/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 55);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = (window._g && _g.$) || window.$CQ || window.$ || window.jQuery;

/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./clientlibs/js/lib/vendor/terrific/config.ts
/**
 * Contains the application base config.
 * The base config can be extended or overwritten either via
 * new Application ($ctx, config) during bootstrapping the application or via
 * overriding the Tc.Config object in your project.
 *
 * @author Remo Brunschwiler
 * @namespace Tc
 * @class Config
 * @static
 */
var config = {
    /**
     * The paths for the different types of dependencies.
     *
     * @property dependencies
     * @type Object
     */
    dependencies: {
        css: '/css/dependencies',
        js: '/js/dependencies',
    },
    debug: false,
};

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(2);

// EXTERNAL MODULE: external "(window._g && _g.$) || window.$CQ || window.$ || window.jQuery"
var external___window__g_____g_$_____window_$CQ____window_$____window_jQuery_ = __webpack_require__(0);
var external___window__g_____g_$_____window_$CQ____window_$____window_jQuery__default = /*#__PURE__*/__webpack_require__.n(external___window__g_____g_$_____window_$CQ____window_$____window_jQuery_);

// EXTERNAL MODULE: ./clientlibs/js/lib/vendor/terrific/Sandbox.ts
var Sandbox = __webpack_require__(99);

// CONCATENATED MODULE: ./clientlibs/js/lib/vendor/terrific/Connector.ts
var Connector = /** @class */ (function () {
    /**
     * Initializes the Connector.
     *
     * @method init
     * @constructor
     * @param {String} connectorId
     *      The unique connector ID
     */
    function Connector(connectorId) {
        this.components = {};
        this.connectorId = connectorId;
    }
    /**
     * Registers a component.
     *
     * @method registerComponent
     * @param {Module} component
     *      The module to register
     */
    Connector.prototype.registerComponent = function (component) {
        this.components[component.id] = { component: component };
    };
    /**
     * Unregisters a component.
     *
     * @method unregisterComponent
     * @param {Module} component
     *      The module to unregister
     */
    Connector.prototype.unregisterComponent = function (component) {
        var components = this.components;
        if (components[component.id]) {
            // tslint:disable-next-line:no-dynamic-delete
            delete components[component.id];
        }
    };
    /**
     * Notifies all registered components about a state change
     * This can be be overriden in the specific connectors.
     *
     * @method notify
     * @param {Module} origin
     *      The module that sends the state change
     * @param {String} state
     *      The component's state
     * @param {Object} data
     *      Contains the state relevant data (if any)
     * @return {boolean}
     *      Indicates whether the default action should be excuted or not
     */
    Connector.prototype.notify = function (origin, state, data) {
        /*
         * Gives the components the ability to prevent the default- and
         * after action from the events by returning false in the
         * on {Event}-Handler.
         */
        var proceed = true;
        var components = this.components;
        for (var id in components) {
            var component = components[id].component;
            if (component === origin) {
                continue;
            }
            var callback = component[state];
            if (!callback) {
                continue;
            }
            var result = !!callback.call(component, data);
            if (!result) {
                proceed = false;
            }
        }
        return proceed;
    };
    return Connector;
}());


// EXTERNAL MODULE: ./clientlibs/js/lib/vendor/terrific/utils/string.ts
var string = __webpack_require__(29);

// EXTERNAL MODULE: ./clientlibs/js/lib/vendor/terrific/Module.ts
var Module = __webpack_require__(3);

// CONCATENATED MODULE: ./clientlibs/js/lib/vendor/terrific/utils/extend.ts


var extend = function (moduleDefinition) {
    var SubModule = /** @class */ (function (_super_1) {
        Object(tslib_es6["c" /* __extends */])(SubModule, _super_1);
        function SubModule($ctx, sandbox, id, modName) {
            var _this = _super_1.call(this, $ctx, sandbox, id, modName) || this;
            // Legacy compatibility:
            // Call `init` (the constructor from “Base”)
            _this.init($ctx, sandbox, id);
            return _this;
        }
        SubModule.prototype._super = function (_$ctx, _sandbox, _id) {
            // Make sure a _super call from an overridden `init` does not call the super constructor again
            this.log.info('call to _super ignored on legacy module');
        };
        // tslint:disable-next-line:prefer-function-over-method
        SubModule.prototype.init = function (_$ctx, _sandbox, _id) {
            // May be overridden
        };
        return SubModule;
    }(Module["a" /* Module */]));
    // Extend the new module with the properties and methods from the definition
    Object.assign(SubModule.prototype, moduleDefinition);
    return SubModule;
};
function mergeRegistries(target) {
    var sources = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        sources[_i - 1] = arguments[_i];
    }
    for (var _a = 0, sources_1 = sources; _a < sources_1.length; _a++) {
        var sourceRegistry = sources_1[_a];
        // Merge two registries
        for (var moduleName in sourceRegistry) {
            var sourceDefinition = sourceRegistry[moduleName];
            if (moduleName in target) {
                var targetDefinition = target[moduleName];
                if (targetDefinition.module &&
                    sourceDefinition.module &&
                    targetDefinition.module !== sourceDefinition.module) {
                    // Module exists in both registries
                    window.debug.error("Tc.Module." + moduleName + " has conflicting implementations. Replacing.", targetDefinition.module, 'with', sourceDefinition.module);
                }
                else if (targetDefinition.module) {
                    // Module is defined only in target, not in source
                    sourceDefinition.module = targetDefinition.module;
                }
                // Merge all skins (ignore duplicates for now)
                // Source has precedence
                sourceDefinition.skins = Object(tslib_es6["a" /* __assign */])(Object(tslib_es6["a" /* __assign */])({}, targetDefinition.skins), sourceDefinition.skins);
            }
            target[moduleName] = sourceDefinition;
        }
    }
    return target;
}

// EXTERNAL MODULE: ./clientlibs/js/lib/util/url.ts + 1 modules
var url = __webpack_require__(6);

// CONCATENATED MODULE: ./clientlibs/js/lib/vendor/terrific/Application.ts








function transformRegistryToFull(registry) {
    var result = {};
    for (var moduleName in registry) {
        var definitionOrModule = registry[moduleName];
        if (typeof definitionOrModule === 'function') {
            result[moduleName] = {
                module: definitionOrModule,
                skins: {},
            };
        }
        else {
            result[moduleName] = {
                module: definitionOrModule.module,
                skins: definitionOrModule.skins || {},
            };
        }
    }
    return result;
}
/**
 * Responsible for application-wide issues such as the creation of modules and establishing connections between them.
 *
 * @author Remo Brunschwiler
 * @namespace Tc
 * @class Application
 */
var Application_Application = /** @class */ (function () {
    /**
     * Initializes the application.
     *
     * @method init
     * @constructor
     * @param {jQuery} $ctx
     *      The jQuery context
     * @param {Object} config
     *      The configuration
     */
    function Application($ctx, cfg, registry, connectorTypes) {
        if (cfg === void 0) { cfg = {}; }
        if (registry === void 0) { registry = {}; }
        if (connectorTypes === void 0) { connectorTypes = {}; }
        /**
         * Contains references to all modules on the page. This can, for
         * example, be useful when there are interactions between Flash
         * objects and Javascript.
         *
         * @property modules
         * @type Array
         */
        this.modules = [];
        /**
         * Associates modules that are hash-capable with their IDs.
         */
        this.hashCapableModules = {};
        /**
         * Contains references to all connectors on the page.
         *
         * @property connectors
         * @type Object
         */
        this.connectors = {};
        this.config = Object(tslib_es6["a" /* __assign */])(Object(tslib_es6["a" /* __assign */])({}, config), cfg);
        this.$ctx = $ctx || external___window__g_____g_$_____window_$CQ____window_$____window_jQuery_('body');
        this.connectors = {};
        this.sandbox = new Sandbox["a" /* Sandbox */](this, this.config);
        this.registry = Object(tslib_es6["a" /* __assign */])({}, transformRegistryToFull(registry));
        this.connectorTypes = Object(tslib_es6["a" /* __assign */])({}, connectorTypes);
    }
    /**
     * Allows to amend the registry of known modules.
     * @param registry The registry to merge into the current one
     */
    // Modified by Swisscom (Raphael Schweikert, taascraa): add ability to register modules after initialization
    Application.prototype.amendRegistry = function (registry) {
        mergeRegistries(this.registry, transformRegistryToFull(registry));
    };
    /**
     * Register modules withing scope
     * Automatically registers all modules within the scope,
     * as long as the modules use the OOCSS naming conventions.
     *
     * @method registerModules
     * @param {jQuery} $ctx
     *      The jQuery context
     * @return {Array}
     *      A list containing the references of the registered modules
     */
    // Modified by Swisscom (Raphael Schweikert, taascraa): add ability to have multiple modules on a single element
    Application.prototype.registerModules = function ($ctx) {
        var _this = this;
        if ($ctx === void 0) { $ctx = this.$ctx; }
        var modules = [];
        // Modified by Swisscom (Dave Talamona, tzhtada2):
        // [1. performance improvement by excluding the NOT from the initial query]
        // [2. descendants of a container with attribute "data-ignore-descendants" are not initialized]
        var $candidates = $ctx.find('.mod')
            .add($ctx.hasClass('mod') ? $ctx : external___window__g_____g_$_____window_$CQ____window_$____window_jQuery_())
            .not('[data-ignore="true"], [data-ignore-descendants="true"] *');
        $candidates.each(function (_, elem) {
            var $elem = external___window__g_____g_$_____window_$CQ____window_$____window_jQuery_(elem);
            // Modified by Swisscom (Dave Talamona, tzhtada2):
            // Modules with newlines or tabs in class attribute were not detected as a modules (classes.length was 1)
            var classes = external___window__g_____g_$_____window_$CQ____window_$____window_jQuery_["trim"]($elem.attr('class') || '').split(/\s+/);
            /*
             * A module can have several different classes and data attributes.
             * See below for possible values.
             */
            /*
             * @config .mod
             *
             * Indicates that it is a base module, this is the default and
             * no JavaScript needs to be involved. It must occur excactly
             * once.
             */
            /*
             * @config .mod{moduleName} || .mod-{module-name}
             *
             * Indicates that it is a module of type basic, which is
             * derived from the base module. It can occur at most
             * once. Example: .modBasic || .mod-basic
             */
            /*
             * @config .skin{moduleName}{skinName} || .skin-{module-name}-{skin-name}
             *
             * Indicates that the module basic has the submarine skin. It
             * will be decorated by the skin JS (if it exists). It can occur
             * arbitrarily. Example: .skinBasicSubmarine || .skin-basic-submarine
             */
            /*
             * @config data-connectors
             *
             * A module can have a comma-separated list of data connectors.
             * The list contains the IDs of the connectors in the following
             * schema: {connectorType}-{connectorId}
             *
             * {connectorType} is optional. If only the {connectorId} is given, the
             * default connector is instantiated.
             *
             * The example MasterSlave-Navigation decodes to: type =
             * MasterSlave, id = Navigation. This instantiates the MasterSlave
             * connector (as mediator) with the connector id Navigation.
             * The connector id is used to chain the appropriate (the ones with the same id)
             * modules together and to improve the reusability of the connector.
             * It can contain multiple connector ids (e.g. 1,2,MasterSlave-Navigation).
             */
            if (classes.length <= 1) {
                return;
            }
            /*
             * This needs to be done via attr() instead of data().
             * As data() cast a single number-only connector to an integer, the split will fail.
             */
            var connectorParts = external___window__g_____g_$_____window_$CQ____window_$____window_jQuery_["trim"]($elem.attr('data-connectors') || '').split(/\s*,\s*/);
            // Do nothing for empty connectors
            var connectors = connectorParts.filter(Boolean);
            var classesNormalized = classes
                .filter(Boolean)
                .map(function (part) {
                if (part.indexOf('-') > -1) {
                    part = Object(string["b" /* toCamel */])(part);
                }
                return part;
            });
            var modNames = classesNormalized
                .filter(function (part) { return part.indexOf('mod') === 0 && part.length > 3; })
                .map(function (part) { return part.substr(3); })
                .filter(function (modName) { return modName in _this.registry; });
            var _loop_1 = function (modName) {
                var definition = _this.registry[modName];
                var skinRegistry = definition.skins;
                // Get skins for module
                var skins = classesNormalized
                    .filter(function (part) {
                    return part.indexOf("skin" + modName) === 0;
                })
                    .map(function (skinClass) { return skinClass.substr('skin'.length + modName.length); })
                    .map(function (skinName) { return skinRegistry[skinName]; })
                    .filter(Boolean);
                var module = _this.registerModule($elem, definition.module, modName, skins, connectors);
                if (module) {
                    modules.push(module);
                }
            };
            for (var _i = 0, modNames_1 = modNames; _i < modNames_1.length; _i++) {
                var modName = modNames_1[_i];
                _loop_1(modName);
            }
        });
        return modules;
    };
    /**
     * Registers a module.
     *
     * @method registerModule
     * @param {jQuery} $node
     *      The module node
     * @param {String} modName
     *      The module name. It must match the class name of the module
     * @param {Array} skins
     *      A list of skin names. Each entry must match a class name of a skin
     * @param {Array} connectors
     *      A list of connectors identifiers (e.g. MasterSlave-Navigation)
     *      Schema: {connectorName}-{connectorId}
     * @return {Module}
     *      The reference to the registered module
     */
    Application.prototype.registerModule = function ($node, module, // Actually typeof T but that would need an extra definition
    modName, skins, connectors) {
        var modules = this.modules;
        skins = skins || [];
        connectors = connectors || [];
        // Generate a unique ID for every module
        var id = modules.length;
        // Modified by Raphael Schweikert (taascraa): add ability to have multiple modules on a single element
        var ids = $node.data('terrific-ids') || {};
        $node.data('terrific-ids', ids);
        // Modified by Dave Talamona (tzhtada2): modules must not be initialized twice
        if (modName in ids) {
            return null;
        }
        ids[modName] = id;
        // Instantiate module
        modules[id] = new module($node, this.sandbox, id, modName);
        // Added by Swisscom (Raphael Schweikert, taascraa)
        modules[id].modName = modName;
        // Decorate it
        for (var _i = 0, skins_1 = skins; _i < skins_1.length; _i++) {
            var skin = skins_1[_i];
            modules[id] = modules[id].getDecoratedModule(skin);
        }
        // Register connections
        for (var i = 0, len = (connectors || []).length; i < len; i++) {
            this.registerConnection(connectors[i], modules[id]);
        }
        return modules[id];
    };
    /**
     * Registers a connection between a module and a connector.
     *
     * @method registerConnection
     * @param {String} connector
     *      The full connector name (e.g. MasterSlave-Navigation)
     * @param {Module} component
     *      The module instance
     */
    Application.prototype.registerConnection = function (connector, component) {
        connector = external___window__g_____g_$_____window_$CQ____window_$____window_jQuery_["trim"](connector);
        var parts = connector.split('-');
        var connectorType;
        var connectorId;
        var identifier;
        if (parts.length === 1) {
            // Default connector
            identifier = connectorId = parts[0];
        }
        else if (parts.length === 2) {
            // A specific connector type is given
            connectorType = parts[0];
            connectorId = parts[1];
            identifier = connectorType + connectorId;
        }
        else {
            return;
        }
        if (!identifier) {
            return;
        }
        var connectors = this.connectors;
        if (!connectors[identifier]) {
            var registry = this.connectorTypes;
            var ctor = Connector;
            if (connectorType && connectorType in registry) {
                ctor = registry[connectorType];
            }
            connectors[identifier] = new ctor(connectorId);
        }
        if (!(identifier in connectors)) {
            return;
        }
        /*
         * The connector observes the component and attaches it as
         * an observer.
         */
        component.attachConnector(connectors[identifier]);
        /*
         * The component wants to be informed over state changes.
         * It registers it as connector member.
         */
        connectors[identifier].registerComponent(component);
    };
    /**
     * Unregisters the modules given by the module instances.
     *
     * @method unregisterModules
     * @param {Array} modules
     *      A list containing the module instances to unregister
     */
    Application.prototype.unregisterModules = function (modules) {
        if (modules === void 0) { modules = this.modules; }
        var connectors = this.connectors;
        // Unregister the given modules
        for (var _i = 0, modules_1 = modules; _i < modules_1.length; _i++) {
            var module = modules_1[_i];
            // Delete the references in the connectors
            for (var connectorId in connectors) {
                if (connectors.hasOwnProperty(connectorId)) {
                    connectors[connectorId].unregisterComponent(module);
                }
            }
            // Delete the module instance itself
            var index = external___window__g_____g_$_____window_$CQ____window_$____window_jQuery_["inArray"](module, this.modules);
            if (index > -1) {
                try {
                    // Modified by Swisscom (Dave Talamona, tzhtada2):
                    // Clear module id when unregistering it so that it can be initialized again
                    var ids = module.$ctx.data('terrific-ids') || {};
                    // tslint:disable-next-line:no-dynamic-delete
                    delete ids[module.modName];
                }
                catch (e) { }
                // tslint:disable-next-line:no-dynamic-delete
                delete this.modules[index];
                if (module.id in this.hashCapableModules) {
                    this.hashCapableModules[module.id] = undefined;
                }
            }
        }
    };
    /**
     * Registers a hook that is called at the end.
     *
     * @method end
     * @param {Function} hook
     * 		The hook function to be executed
     */
    Application.prototype.end = function (hook) {
        this.sandbox.addCallback('end', hook);
    };
    /**
     * Starts (intializes) the registered modules.
     *
     * @method start
     * @param {Array} modules
     *      A list of the modules to start
     */
    Application.prototype.start = function (modules) {
        if (modules === void 0) { modules = this.modules; }
        // Start the modules
        for (var _i = 0, modules_2 = modules; _i < modules_2.length; _i++) {
            var module = modules_2[_i];
            module.start();
            this.initHashHandlingForModule(module);
        }
        this.initHashHandling();
    };
    /**
     * Stops the registered modules.
     *
     * @method stop
     * @param {Array} modules
     *      A list containing the module instances to stop
     */
    Application.prototype.stop = function (modules) {
        if (modules === void 0) { modules = this.modules; }
        // Stop the modules
        for (var _i = 0, modules_3 = modules; _i < modules_3.length; _i++) {
            var module = modules_3[_i];
            module.stop();
        }
    };
    /**
     * Unregisters a module from a connector.
     *
     * @method unregisterConnection
     * @param {String} connectorId
     *      The connector channel id (e.g. 2)
     * @param {Module} component
     *      The module instance
     */
    Application.prototype.unregisterConnection = function (connectorId, component) {
        var connector = this.connectors[connectorId];
        // Delete the references in the connector and the module
        if (connector) {
            connector.unregisterComponent(component);
            component.detachConnector(connector);
        }
    };
    Application.prototype.initHashHandlingForModule = function (module) {
        var _this = this;
        if (!module.moduleStateChanged) {
            return;
        }
        var hashKeyConfigured = module.hashKey;
        // Make hashKey unique
        var hashKey = hashKeyConfigured;
        var index = 0;
        var existing;
        do {
            existing = Object.keys(this.hashCapableModules)
                .map(function (id) { return _this.hashCapableModules[Number(id)]; })
                .filter(Boolean)
                .map(function (mod) { return mod.hashKey; })
                .find(function (key) { return key === hashKey; });
            if (existing) {
                index++;
                hashKey = hashKeyConfigured + index;
            }
        } while (existing);
        module.hashKey = hashKey;
        this.hashCapableModules[module.id] = module;
    };
    Application.prototype.setModuleStatesFromHash = function () {
        for (var moduleId in this.hashCapableModules) {
            var module = this.hashCapableModules[moduleId];
            if (!module) {
                continue;
            }
            var hashKey = module.hashKey;
            var state = Object(url["readStateFromHash"])(hashKey);
            if (state !== undefined) {
                module.moduleStateChanged(state);
            }
        }
    };
    Application.prototype.initHashHandling = function () {
        if (!Object.keys(this.hashCapableModules).length) {
            return;
        }
        external___window__g_____g_$_____window_$CQ____window_$____window_jQuery_(window).on('hashchange', this.setModuleStatesFromHash.bind(this));
        this.setModuleStatesFromHash();
    };
    return Application;
}());


// CONCATENATED MODULE: ./clientlibs/js/lib/vendor/terrific/utils/bootstrap.ts

function bootstrapTerrific($page, modules, debug, connectors) {
    if (debug === void 0) { debug = false; }
    var app = new Application_Application($page, {
        debug: debug,
    }, modules, connectors);
    return app;
}

// EXTERNAL MODULE: ./clientlibs/js/lib/util/helpers.ts
var helpers = __webpack_require__(4);

// CONCATENATED MODULE: ./clientlibs/js/bootstrap/load-terrific.ts
/* harmony export (immutable) */ __webpack_exports__["legacyRegistryToModern"] = legacyRegistryToModern;
/* harmony export (immutable) */ __webpack_exports__["createLegacyRegistry"] = createLegacyRegistry;
/* harmony export (immutable) */ __webpack_exports__["legacyBootstrapDeferred"] = legacyBootstrapDeferred;
/* harmony export (immutable) */ __webpack_exports__["legacyBootstrapDeferredSingleton"] = legacyBootstrapDeferredSingleton;






function legacyRegistryToModern(legacyRegistry) {
    var registry = {};
    for (var moduleName in legacyRegistry) {
        var mod = legacyRegistry[moduleName];
        var regEntry = {
            module: mod,
            skins: {},
        };
        for (var skinName in mod) {
            var skin = mod[skinName];
            // tslint:disable-next-line:strict-type-predicates
            if (typeof skin !== 'function' || !/^[A-Z0-9]$/.test(skinName[0])) {
                continue;
            }
            // We could use `delete mod[skinName]` here but it might remove too much
            // (if some non-skin functions are exported on the Module constructor)
            // Add the skin to the skin registry
            regEntry.skins[skinName] = skin;
        }
        registry[moduleName] = regEntry;
    }
    return registry;
}
function bootstrapWithLegacy($page, modernRegistry, legacyRegistry, debug) {
    if ($page === void 0) { $page = external___window__g_____g_$_____window_$CQ____window_$____window_jQuery_('html'); }
    if (modernRegistry === void 0) { modernRegistry = {}; }
    if (legacyRegistry === void 0) { legacyRegistry = Tc.Module; }
    if (debug === void 0) { debug = !!(window.location.search + window.location.hash).match(/\bdevconsole\b/); }
    // Merge legacy and modern registries
    var registry = mergeRegistries(legacyRegistryToModern(legacyRegistry), transformRegistryToFull(modernRegistry));
    return bootstrapTerrific($page, registry, debug);
}
function createLegacyRegistry() {
    var registry = {
        get extend() {
            return extend;
        },
    };
    Object.defineProperty(registry, 'extend', { enumerable: false });
    return registry;
}
function resetLegacyRegistry(registry) {
    var result = createLegacyRegistry();
    for (var module in registry) {
        result[module] = registry[module];
        // tslint:disable-next-line:no-dynamic-delete
        delete registry[module];
    }
    return result;
}
function amendModulesSinceInit(application, legacyRegistry, initialRegistry) {
    if (application === void 0) { application = window.application; }
    if (legacyRegistry === void 0) { legacyRegistry = Tc.Module; }
    if (initialRegistry === void 0) { initialRegistry = null; }
    application.amendRegistry(legacyRegistryToModern(legacyRegistry));
    if (!initialRegistry) {
        return;
    }
    Object.assign(initialRegistry, resetLegacyRegistry(legacyRegistry));
}
function legacyBootstrapDeferred(modernRegistry, $page, legacyRegistry) {
    if (modernRegistry === void 0) { modernRegistry = {}; }
    if ($page === void 0) { $page = external___window__g_____g_$_____window_$CQ____window_$____window_jQuery_('html'); }
    if (legacyRegistry === void 0) { legacyRegistry = Tc.Module; }
    var application = bootstrapWithLegacy($page, modernRegistry, legacyRegistry);
    // Reset the registry for the next round
    var initialRegistry = resetLegacyRegistry(legacyRegistry);
    // Shim addModules to take modules into account that were added to the registry after initialization
    // Previously, these were added automatically because Tc would not clone the registry it was given.
    // tslint:disable-next-line:no-unbound-method
    var origAddModules = application.sandbox.addModules;
    application.sandbox.addModules = function addModules($ctx) {
        amendModulesSinceInit(application, legacyRegistry, initialRegistry);
        return origAddModules.call(this, $ctx);
    };
    external___window__g_____g_$_____window_$CQ____window_$____window_jQuery_(function () {
        application.sandbox.addModules = origAddModules;
        amendModulesSinceInit(application, legacyRegistry, initialRegistry);
        // Put back all modules onto initial registry (probably Tc.Module)
        Object.assign(legacyRegistry, initialRegistry);
        // Initialize the modules.
        Object(helpers["initNewModules"])($page);
    });
    return [application, initialRegistry];
}
// Variant of legacyBootstrapDeferred that only calls legacyBootstrapDeferred once but still adds modules.
var applicationSingleton = null;
var initialRegistrySingleton;
function legacyBootstrapDeferredSingleton(modernRegistry) {
    var _a;
    if (modernRegistry === void 0) { modernRegistry = {}; }
    if (window.application && window.application.sandbox) {
        applicationSingleton = window.application;
    }
    if (applicationSingleton) {
        // Amend the passed modules
        applicationSingleton.amendRegistry(modernRegistry);
        // Amend the modules that have since been registered on Tc.Module
        amendModulesSinceInit(applicationSingleton, Tc.Module, initialRegistrySingleton);
        return applicationSingleton;
    }
    _a = legacyBootstrapDeferred(modernRegistry, undefined, Tc.Module), applicationSingleton = _a[0], initialRegistrySingleton = _a[1];
    window.application = applicationSingleton;
    return applicationSingleton;
}
// tslint:disable-next-line:variable-name
var Tc = {
    $: external___window__g_____g_$_____window_$CQ____window_$____window_jQuery_,
    Application: Application_Application,
    Config: config,
    Module: createLegacyRegistry(),
};
window.Tc = Tc;
/* harmony default export */ var load_terrific = __webpack_exports__["default"] = (Tc);


/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = __extends;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __assign; });
/* unused harmony export __rest */
/* unused harmony export __decorate */
/* unused harmony export __param */
/* unused harmony export __esDecorate */
/* unused harmony export __runInitializers */
/* unused harmony export __propKey */
/* unused harmony export __setFunctionName */
/* unused harmony export __metadata */
/* harmony export (immutable) */ __webpack_exports__["b"] = __awaiter;
/* harmony export (immutable) */ __webpack_exports__["d"] = __generator;
/* unused harmony export __createBinding */
/* unused harmony export __exportStar */
/* harmony export (immutable) */ __webpack_exports__["f"] = __values;
/* unused harmony export __read */
/* unused harmony export __spread */
/* unused harmony export __spreadArrays */
/* harmony export (immutable) */ __webpack_exports__["e"] = __spreadArray;
/* unused harmony export __await */
/* unused harmony export __asyncGenerator */
/* unused harmony export __asyncDelegator */
/* unused harmony export __asyncValues */
/* unused harmony export __makeTemplateObject */
/* unused harmony export __importStar */
/* unused harmony export __importDefault */
/* unused harmony export __classPrivateFieldGet */
/* unused harmony export __classPrivateFieldSet */
/* unused harmony export __classPrivateFieldIn */
/* unused harmony export __addDisposableResource */
/* unused harmony export __disposeResources */
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __esDecorate(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};

function __runInitializers(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};

function __propKey(x) {
    return typeof x === "symbol" ? x : "".concat(x);
};

function __setFunctionName(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

var __createBinding = Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});

function __exportStar(m, o) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
}

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

/** @deprecated */
function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

/** @deprecated */
function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: false } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

var __setModuleDefault = Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}

function __classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}

function __classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
}

function __classPrivateFieldIn(state, receiver) {
    if (receiver === null || (typeof receiver !== "object" && typeof receiver !== "function")) throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}

function __addDisposableResource(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({ value: value, dispose: dispose, async: async });
    }
    else if (async) {
        env.stack.push({ async: true });
    }
    return value;
}

var _SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

function __disposeResources(env) {
    function fail(e) {
        env.error = env.hasError ? new _SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while (env.stack.length) {
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) { fail(e); return next(); });
            }
            catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}

/* unused harmony default export */ var _unused_webpack_default_export = ({
    __extends: __extends,
    __assign: __assign,
    __rest: __rest,
    __decorate: __decorate,
    __param: __param,
    __metadata: __metadata,
    __awaiter: __awaiter,
    __generator: __generator,
    __createBinding: __createBinding,
    __exportStar: __exportStar,
    __values: __values,
    __read: __read,
    __spread: __spread,
    __spreadArrays: __spreadArrays,
    __spreadArray: __spreadArray,
    __await: __await,
    __asyncGenerator: __asyncGenerator,
    __asyncDelegator: __asyncDelegator,
    __asyncValues: __asyncValues,
    __makeTemplateObject: __makeTemplateObject,
    __importStar: __importStar,
    __importDefault: __importDefault,
    __classPrivateFieldGet: __classPrivateFieldGet,
    __classPrivateFieldSet: __classPrivateFieldSet,
    __classPrivateFieldIn: __classPrivateFieldIn,
    __addDisposableResource: __addDisposableResource,
    __disposeResources: __disposeResources,
});


/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Module; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_string__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lib_util_url__ = __webpack_require__(6);



var Module = /** @class */ (function () {
    function Module($ctx, sandbox, id, modName) {
        var _this = this;
        this.$ctx = $ctx;
        this.sandbox = sandbox;
        this.id = id;
        this.modName = modName;
        this.hashKey = modName;
        this.connectors = {};
        this.debugInternal = !!sandbox.config.debug;
        if (!('debug' in this)) {
            this.debug = this.debugInternal;
        }
        /**
         * Shortcut to debug.log, prepends the module name to the output
         */
        // Added by Swisscom (Raphael Schweikert, taascraa)
        var console = window.debug || window.console;
        var log = function (level) {
            var _a;
            var args = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args[_i - 1] = arguments[_i];
            }
            if (!_this.debugInternal) {
                return;
            }
            (_a = console[level]).call.apply(_a, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __spreadArray */])([console, "Tc.Module." + _this.modName + " >"], args));
        };
        this.logInternal = log.bind(this, 'log');
        var levels = ['error', 'warn', 'info', 'debug', 'log'];
        for (var _i = 0, levels_1 = levels; _i < levels_1.length; _i++) {
            var level = levels_1[_i];
            this.logInternal[level] = log.bind(this, level);
        }
        if (!('log' in this)) {
            this.log = this.logInternal;
        }
    }
    /**
     * Template method to start (i.e. init) the module.
     * This method provides hook functions which can be overridden
     * by the individual instance.
     *
     * @method start
     */
    Module.prototype.start = function () {
        var _this = this;
        // Call the hook method from the individual instance and provide the appropriate callback
        // Modified by Swisscom (Raphael Schweikert, taascraa): Warn if callback not called after 300ms
        if (this.on) {
            var timeout_1 = null;
            if (this.debugInternal) {
                timeout_1 = window.setTimeout(function () {
                    _this.logInternal.error('Module’s `on` hasn’t called its callback after 300ms');
                }, 300);
            }
            var callAfter = function () {
                if (timeout_1) {
                    window.clearTimeout(timeout_1);
                }
                _this.initAfter();
            };
            this.on(callAfter);
        }
        else {
            this.logInternal.error('Module doesn’t implement `on`');
        }
    };
    /**
     * Template method to stop the module.
     *
     * @method stop
     */
    Module.prototype.stop = function () {
        var $ctx = this.$ctx;
        // Remove all bound events and associated jQuery data
        $('*', $ctx).off().removeData();
        $ctx.off().removeData();
    };
    /**
     * Initialization callback.
     *
     * @method initAfter
     * @protected
     */
    Module.prototype.initAfter = function () {
        var _this = this;
        this.sandbox.ready(function () {
            /*
             * Call the 'after' hook method from the individual instance
             */
            if (_this.after) {
                var hashState = {};
                if (_this.moduleStateChanged) {
                    hashState = Object(__WEBPACK_IMPORTED_MODULE_2_lib_util_url__["readStateFromHash"])(_this.hashKey, true);
                }
                _this.after(hashState);
            }
        });
    };
    Module.prototype.fire = function (state, data, channels, defaultAction) {
        var connectors = this.connectors;
        var shouldBeCalled = true; // Indicates whether the default handler should be called
        // Validate params
        if (!channels && !defaultAction) {
            // Max. 2 params
            if (typeof data === 'function') {
                // (state, defaultAction)
                defaultAction = data;
                data = undefined;
            }
            else if (Array.isArray(data)) {
                // (state, channels)
                channels = data;
                data = undefined;
            }
        }
        else if (!defaultAction) {
            // 2-3 params
            if (typeof channels === 'function') {
                // (state, data, defaultAction)
                defaultAction = channels;
                channels = undefined;
            }
            if (Array.isArray(data)) {
                // (state, channels, defaultAction)
                channels = data;
                data = undefined;
            }
        }
        state = Object(__WEBPACK_IMPORTED_MODULE_1__utils_string__["a" /* capitalize */])(state);
        channels = (channels || Object.keys(connectors));
        for (var i = 0, len = channels.length; i < len; i++) {
            var connectorId = channels[i];
            if (connectors.hasOwnProperty(connectorId)) {
                var connector = connectors[connectorId];
                var proceed = connector.notify(this, 'on' + state, data) || false;
                if (!proceed) {
                    shouldBeCalled = false;
                }
            }
            else {
                throw new Error(
                // tslint:disable:trailing-comma
                "The " + this.modName + " module #" + this.id + " is not connected to connector " + connectorId + ".\n\t\t\t\t\tPlease make sure that your data is an object and not an array."
                // tslint:enable:trailing-comma
                );
            }
        }
        // Execute default action unless a veto is provided
        if (shouldBeCalled) {
            if (typeof defaultAction === 'function') {
                defaultAction(data || {});
            }
        }
    };
    /**
     * Attaches a connector (observer).
     *
     * @method attachConnector
     * @param {Connector} connector
     *      The connector to attach
     */
    Module.prototype.attachConnector = function (connector) {
        this.connectors[connector.connectorId] = connector;
    };
    /**
     * Detaches a connector (observer).
     *
     * @method detachConnector
     * @param {Connector} connector The connector to detach
     */
    Module.prototype.detachConnector = function (connector) {
        // tslint:disable-next-line:no-dynamic-delete
        delete this.connectors[connector.connectorId];
    };
    /**
     * Decorates itself with the given skin.
     *
     * @method getDecoratedModule
     * @param {String} module The name of the module
     * @param {String} skin The name of the skin
     * @return {Module} The decorated module
     */
    Module.prototype.getDecoratedModule = function (skin) {
        /*
            * Sets the prototype object to the module.
            * So the "non-decorated" functions will be called on the module
            * without implementing the whole module interface.
            */
        skin.prototype = this;
        skin.prototype.constructor = this.constructor;
        return new skin(this);
    };
    /**
     * Set a new hash state for this module.
     * Updates the url hash.
     *
     * @param hashState The new hash state record.
     */
    Module.prototype.setModuleState = function (hashState) {
        if (!this.moduleStateChanged) {
            this.log.error('Module is not hash-capable');
            return;
        }
        Object(__WEBPACK_IMPORTED_MODULE_2_lib_util_url__["saveStateToHash"])(this.hashKey, hashState);
    };
    return Module;
}());


/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["isMobilePage"] = isMobilePage;
/* harmony export (immutable) */ __webpack_exports__["isEditMode"] = isEditMode;
/* harmony export (immutable) */ __webpack_exports__["zeroFill"] = zeroFill;
/* harmony export (immutable) */ __webpack_exports__["getUniqueIdOfElement"] = getUniqueIdOfElement;
/* harmony export (immutable) */ __webpack_exports__["isNumber"] = isNumber;
/* harmony export (immutable) */ __webpack_exports__["isSwissVisitor"] = isSwissVisitor;
/* harmony export (immutable) */ __webpack_exports__["sanitizePhone"] = sanitizePhone;
/* harmony export (immutable) */ __webpack_exports__["namespace"] = namespace;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "initNewModules", function() { return initNewModules; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ensure", function() { return ensure; });
/* harmony export (immutable) */ __webpack_exports__["imageLoaded"] = imageLoaded;
/* harmony export (immutable) */ __webpack_exports__["fetcher"] = fetcher;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
// tslint:disable:no-reference
/// <reference path="../../bootstrap/load-terrific.ts" />
// tslint:enable:no-reference


// Cache the result for the page (it never changes)
var pageIsMobile;
var MOBILE_SELECTOR = 'div.mobile, body.is-mobile';
function isMobilePage($ctx) {
    if ($ctx && $ctx.length > 0) {
        return $ctx.find(MOBILE_SELECTOR).length > 0;
    }
    if (!document.body) {
        var e_1 = new Error('isMobilePage called too early, no body yet');
        setTimeout(function () {
            throw e_1;
        }, 0);
        return false;
    }
    if (pageIsMobile === undefined) {
        pageIsMobile = __WEBPACK_IMPORTED_MODULE_1_jquery__(MOBILE_SELECTOR).length > 0;
    }
    return pageIsMobile;
}
function isEditMode() {
    return !!((window.CQ
        && window.CQ.WCM
        && window.CQ.WCM.isEditMode
        && window.CQ.WCM.isEditMode(true)) || document.body.dataset.editMode);
}
function zeroFill(num, length) {
    if (length === void 0) { length = 2; }
    length -= Math.round(num).toString().length;
    return new Array((length > 0 ? length + 1 : 0)).join('0') + num;
}
/**
 * Returns a unique id for the given DOM element. This id does not change if it is set once.
 * @method getUniqueIdOfElement
 * @param {HTMLElement|jQuery} element
 * @returns {String}
 */
var counter = 0;
function getUniqueIdOfElement(element) {
    var $el = __WEBPACK_IMPORTED_MODULE_1_jquery__(element);
    var id = $el.data('unique-element-id');
    if (!id) {
        counter++;
        id = counter;
        $el.data('unique-element-id', id);
    }
    return id;
}
/**
 * @method isNumber
 * @param value
 * @returns {boolean}
 */
function isNumber(value) {
    return !isNaN(parseInt(value, 10));
}
function isSwissVisitor() {
    /* Our test enviorments does not have these option, so always return true in
     case there is no window.geolocation object */
    return !window.geolocation || window.geolocation.swissvisitor;
}
function sanitizePhone(to) {
    if (!to) {
        return '';
    }
    to = to.replace(/[\s*\-?\\?\/?\(?\)?]/g, '');
    if (to.indexOf('+') !== 0) {
        if (to.indexOf('00') === 0) {
            to = to.slice(2);
        }
        if (to.indexOf('0') === 0) {
            to = "41" + to.slice(1);
        }
        to = "+" + to;
    }
    return to;
}
function namespace(ns, curr) {
    if (curr === void 0) { curr = window; }
    ns.split('.').forEach(function (item) {
        if (!(item in curr)) {
            curr[item] = {};
        }
        curr = curr[item];
    });
    return curr;
}
/*
 * Implementation for the SCS.ensure method and the “scs-element-add” event
 * The choice for ensure vs the event is entirely up to you.
 * See below for whether to use these or a Tc.Module.
 *
 * SCS.ensure method: alternative to jQuery(document).ready.
 * “scs-element-add” event: event-based API for the same functionality.
 *
 * Called with static content as well as lazily-loaded elements.
 *
 * There are two ways of using ensure (often you’ll use both in the same component):
 *
 * 1. You’re loading content whose components need to be initialized
 *
 * When developing a lazily-loading component (that does not use the overloaded $(…).load()),
 * just call
 * `SCS.utils.initNewModules(element)` (preferred method because it works on bluewin as well whereas ensure doesn’t)
 * or
 * `SCS.ensure(element)`
 * or
 * `$(element).trigger('scs-element-add')`
 * as soon as the loaded element has been updated,
 * with `element` being the updated/newly-loaded element.
 *
 * 2. You’re developing a component that wants to be initialized
 *
 * Instead of
 * $(document).ready(function($){
 *	$('.some_css_class').each(function () {
 *		// some fancy stuff here
 *	});
 * });
 * use
 * SCS.ensure(function($context, $) {
 *	$context.find('.some_css_class').each(function () {
 *		// some fancy stuff here
 *	});
 * });
 * or, using the events
 * $(document).on('scs-element-add', function(event) {
 *	$context = $(event.target || document);
 *	$context.find('.some_css_class').each(function () {
 *		// some fancy stuff here
 *	});
 * })
 *
 * Note: Do NOT use this function if not strictly necessary (eg. to do stuff that only has to be done
 * once, like binding events to a specific element) because all ensired listeners are called
 * each time a load occures. This leads to performance problems if there are lots of
 * listeners that, when called, search the DOM for elements to process each time.
 *
 * For simple event listerns just use the jQuery "delegate" function (or "on" with newer jQuery versions).
 *
 * To prevent performance problems you can additionally pass a DOM-element or a
 * css-selector-string as second parameter along with your callback-function to make
 * sure the function gets only called when a element is loaded which matches the selector.
 * If you don’t pass this additional parameter your callback-function gets called
 * every time ANY load-event is fired (including the DOM-ready event).
 *
 * An example for the selector could be 'body, .ui-tabs-panel, .ui-dialog-content':
 *
 * SCS.ensure(function($context, $) {
 *	$context.find('.some_css_class').each(function () {
 *		// some fancy stuff here
 *	});
 * }, 'body, .ui-tabs-panel, .ui-dialog-content');
 * or, using the events
 * $(document).on('scs-element-add', 'body, .ui-tabs-panel, .ui-dialog-content', function(event) {
 *	$context = $(event.target || document);
 *	$context.find('.some_css_class').each(function () {
 *		// some fancy stuff here
 *	});
 * })
 *
 * This used to be the only method to reliably initialize widgets on lazily-loaded content.
 * However, now there are Tc.Modules and the 'scs-element-add' events,
 * all of which can be used, depending on use cases.
 *
 * Tc.Modules are applicable for encapsulated widgets,
 * ensure or the 'scs-element-add' event can be used
 * for commonly-used light-weight components with few dependencies.
*/
var SCS = namespace('SCS');
var utils = namespace('utils', SCS);
function initNewModulesImpl(container, scope) {
    if (scope === initNewModulesImpl) {
        // `initNewModules` calls going in circles, stopping now
        return [];
    }
    var $ctx = __WEBPACK_IMPORTED_MODULE_1_jquery__(container);
    // Do jQuery Mobile module initialization (if applicable).
    // Should be done before initializing Tc.Modules because they sometimes rely on the correct DOM being already present.
    if ('enhanceWithin' in __WEBPACK_IMPORTED_MODULE_1_jquery__["fn"]) {
        $ctx.enhanceWithin();
    }
    // Remove the flag on the container which tells Terrific to not initialize the descending modules
    if ($ctx.attr('data-ignore-descendants') === 'true') {
        $ctx.removeAttr('data-ignore-descendants').removeData('ignore-descendants');
    }
    var modules = [];
    // Init all Terrific modules in this container
    if (window.application && window.application.sandbox) {
        modules = window.application.sandbox.addModules($ctx);
    }
    // Init all ensured modules in this container
    ensure($ctx, scope || initNewModulesImpl);
    return modules;
}
var initNewModules = initNewModulesImpl;
if (!('initNewModules' in utils)) {
    utils.initNewModules = initNewModulesImpl;
}
else {
    initNewModules = utils.initNewModules;
}

var handlers = [];
function ensureImpl(handler, scope) {
    if (handler && typeof handler === 'function') {
        /*
            Function given, alias for $(document).on('scs-element-add', function() {
                handler($(event.target), $);
            })
        */
        handlers.push([handler, scope]);
        return undefined;
    }
    if (scope === ensureImpl) {
        // Ensure calls going in circles, stopping now
        return undefined;
    }
    var $el = __WEBPACK_IMPORTED_MODULE_1_jquery__(handler);
    // Check if element is inside the document (some functions e.g. size-measuring do not work otherwise)
    var $elBody = $el.closest('body');
    if ($el[0] !== document.body && $el[0] !== document && (!$elBody.length || $elBody[0] !== document.body)) {
        return true;
    }
    var ignoreScope = scope === false;
    if (ignoreScope) {
        scope = undefined;
    }
    // Call handlers
    var errorStack = [];
    for (var _a = 0, handlers_1 = handlers; _a < handlers_1.length; _a++) {
        var _b = handlers_1[_a], myHandler = _b[0], myScope = _b[1];
        // In a try statement because js-errors in these functions
        // Should not be able to stop execution of all other functions in the queue
        try {
            // `scope === false` is a special case, meaning scoping restrictions should be ignored (for overlays and the like)
            // `!myScope` means the handler was registered for all scopes
            // `myScope === $el[0]` means the scope for the handler is an element
            // `(myScope.length && $el.is(myScope))` for the case where the scope is a selector
            if (ignoreScope || !myScope || myScope === $el[0] || (myScope.length && $el.is(myScope))) {
                myHandler($el, __WEBPACK_IMPORTED_MODULE_1_jquery__);
            }
        }
        catch (err) {
            errorStack.push(err);
        }
    }
    /* debug.log('commons.js > ensure > triggered scs-element-add event', $el.prop('tagName'), $el.attr('class')); */
    if (scope !== addHandler) {
        $el.trigger('scs-element-add', scope || ensureImpl);
    }
    __WEBPACK_IMPORTED_MODULE_1_jquery__["each"](errorStack, function (_i, error) {
        // Set a timeout so the calling method is not affected by the error
        window.setTimeout(function () {
            // Throw error because the user should be able to see the error if it occured
            throw error;
        }, 1);
    });
    return $el;
}
var ensure = ensureImpl;
if (!('ensure' in SCS)) {
    SCS.ensure = ensureImpl;
}
else {
    ensure = SCS.ensure;
}

/**
 * Handle 'scs-element-add' events appropriately.
 *
 * Note that this is added only after triggering the first 'scs-element-add' on DOM ready
 * because Terrific already initializes modules on DOM ready and PIE also kicks in immediately.
 * Only ensure had to be triggered manually, which we did above.
 */
var $doc = __WEBPACK_IMPORTED_MODULE_1_jquery__(document);
function addHandler(event, scope) {
    if (scope === addHandler) {
        // `addHandler` calls going in circles, stopping now
        return;
    }
    var $el = __WEBPACK_IMPORTED_MODULE_1_jquery__(event.target || $doc);
    /**
     * Initialize Tc.Modules on 'scs-element-add' (when elements have been added).
     */
    initNewModules($el, scope || addHandler);
}
/*
 * Trigger 'scs-element-add' on DOM ready.
 *
 * The 'scs-element-add' event is completely compatible with ensure, which acts as a more type-safe synonym:
 *
 * • $el.trigger('scs-element-add') is the same as SCS.ensure($el)
 * • $(document).on('scs-element-add', fn) is the same as SCS.ensure(fn) (with the prepended `event` argument to fn).
 * • $(document).on('scs-element-add', '.selector', fn) is the same as SCS.ensure(fn, '.selector')
 *                                                      (with the prepended `event` argument to fn).
 */
$doc.off('.helpers').on('ready.helpers', function () {
    ensure(document.body);
    $doc.trigger('scs-element-add');
    /**
     * Handle 'scs-element-add' events appropriately.
     *
     * Note that this is added only after triggering the first 'scs-element-add' on DOM ready
     * because Terrific already initializes modules on DOM ready and PIE also kicks in immediately.
     * Only ensure had to be triggered manually, which we did above.
     */
    $doc.on('scs-element-add.helpers', addHandler);
});
/**
 * Wait for image to be loaded. Work around issue when image is loaded from cache.
 */
function imageLoaded(image) {
    return new Promise(function (resolve, reject) {
        if (image.complete) {
            resolve(image);
        }
        function unbind() {
            image.removeEventListener('load', loaded);
            image.removeEventListener('error', rejected);
        }
        var loaded = function () { unbind(); resolve(image); };
        var rejected = function (event) { unbind(); reject(event.error); };
        image.addEventListener('load', loaded);
        image.addEventListener('error', rejected);
    });
}
/**
 * Gets the fetch API.
 * On IE 11, waits until the polyfill is available (provided by Shared Header or SDX webcomponents)
 */
function fetcher() {
    return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __awaiter */])(this, void 0, void 0, function () {
        return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
            if (window.fetch) {
                return [2 /*return*/, window.fetch];
            }
            return [2 /*return*/, new Promise(function (resolve) {
                    var interval = window.setInterval(function () {
                        if (window.fetch) {
                            clearInterval(interval);
                            resolve(window.fetch);
                        }
                    }, 50);
                })];
        });
    });
}


/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CFU", function() { return CFU; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "User", function() { return User; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Profile", function() { return Profile; });
/* harmony export (immutable) */ __webpack_exports__["getProfile"] = getProfile;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lib_util_array__ = __webpack_require__(17);



var devMode = !!(window.location.search + window.location.hash).match(/\bdevconsole\b/);
var CFU;
(function (CFU) {
    CFU["RES"] = "res";
    CFU["SME"] = "sme";
    CFU["CBU"] = "cbu";
})(CFU || (CFU = {}));
var User = /** @class */ (function () {
    function User(data) {
        this.data = data;
    }
    User.prototype.getId = function () {
        return this.data.cust_scn;
    };
    User.prototype.getFirstName = function () {
        return decodeURIComponent(this.data.cust_fname || '');
    };
    User.prototype.getLastName = function () {
        return decodeURIComponent(this.data.cust_lname || '');
    };
    User.prototype.getAuthLevel = function () {
        return decodeURIComponent(this.data.session_authlevel || '');
    };
    /**
     * Get full name (first and last)
     */
    User.prototype.getFullName = function () {
        if (this.isSegmentSme() || this.isSegmentCbu()) {
            // We only use the last name in this case, which contains the company name.
            return this.getLastName();
        }
        return [
            this.getFirstName(),
            this.getLastName(),
        ]
            .filter(Boolean)
            .filter(__WEBPACK_IMPORTED_MODULE_2_lib_util_array__["a" /* onlyUnique */])
            .join(' ');
    };
    User.prototype.getSegment = function () {
        return this.data.cust_segment || CFU.RES;
    };
    User.prototype.isSegmentSme = function () {
        return this.getSegment() === CFU.SME;
    };
    User.prototype.isSegmentCbu = function () {
        return this.getSegment() === CFU.CBU;
    };
    User.prototype.isSegmentRes = function () {
        return this.getSegment() === CFU.RES;
    };
    return User;
}());

var Profile = /** @class */ (function () {
    function Profile(user) {
        this.user = user;
    }
    Profile.prototype.getUser = function () {
        return this.user;
    };
    return Profile;
}());

var KEY = 'scsHeader.profile.loginData';
// FIXME: Use OCE MiSe
function fetchProfile() {
    return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __awaiter */])(this, void 0, void 0, function () {
        var contents, e_1;
        return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, new Promise(function (resolve, reject) {
                            __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.get('/etc/profile.json').done(resolve).fail(reject);
                        })];
                case 1:
                    contents = _a.sent();
                    if (KEY in contents) {
                        // KEY existing means this is a logged-in user
                        return [2 /*return*/, new Profile(new User(contents[KEY]))];
                    }
                    return [3 /*break*/, 3];
                case 2:
                    e_1 = _a.sent();
                    if (devMode) {
                        console.error('Profile JSON data not in expected format', e_1);
                    }
                    return [2 /*return*/, new Profile()];
                case 3: 
                // User not logged in
                return [2 /*return*/, new Profile()];
            }
        });
    });
}
var profile;
function getProfile() {
    if (!profile) {
        profile = fetchProfile();
    }
    return profile;
}


/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: external "(window._g && _g.$) || window.$CQ || window.$ || window.jQuery"
var external___window__g_____g_$_____window_$CQ____window_$____window_jQuery_ = __webpack_require__(0);
var external___window__g_____g_$_____window_$CQ____window_$____window_jQuery__default = /*#__PURE__*/__webpack_require__.n(external___window__g_____g_$_____window_$CQ____window_$____window_jQuery_);

// EXTERNAL MODULE: ./clientlibs/js/lib/vendor/jquery-deparam-patched.ts
var jquery_deparam_patched = __webpack_require__(8);

// CONCATENATED MODULE: ./clientlibs/js/lib/util/globals.ts
// This helper is mainly needed because with the switch to sdx there
// is a chance that modules get loaded twice. This is specially true
// for all utility functions relying on global caching/data.
function getGlobal(name, defaults) {
    window.scGlobals = window.scGlobals || {};
    if (!(name in window.scGlobals)) {
        window.scGlobals[name] = defaults;
    }
    return window.scGlobals[name];
}

// CONCATENATED MODULE: ./clientlibs/js/lib/util/url.ts
/* harmony export (immutable) */ __webpack_exports__["removeHashParameterFromUrl"] = removeHashParameterFromUrl;
/* harmony export (immutable) */ __webpack_exports__["removeHashParameter"] = removeHashParameter;
/* harmony export (immutable) */ __webpack_exports__["readStateFromHash"] = readStateFromHash;
/* harmony export (immutable) */ __webpack_exports__["saveStateToHash"] = saveStateToHash;
/* harmony export (immutable) */ __webpack_exports__["setHash"] = setHash;
/* harmony export (immutable) */ __webpack_exports__["isImagePath"] = isImagePath;
/* harmony export (immutable) */ __webpack_exports__["isExternalUrl"] = isExternalUrl;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "hashDeepLink", function() { return hashDeepLink; });



function removeHashParameterFromUrl(url, parameterName) {
    var regexp = new RegExp("(?:(?!#|&)" + parameterName + "(=.+?)?(&|$))", 'g');
    return url.replace(regexp, '').replace(/(#|&)$/, '');
}
function removeHashParameter(parameterName) {
    window.history.replaceState({}, '', removeHashParameterFromUrl(window.location.href, parameterName));
}
var hashStateCache = getGlobal('hashStateCache', {});
function readStateFromHash(key, always) {
    if (always === void 0) { always = false; }
    var hashIndex = window.location.href.lastIndexOf('#');
    var hash = '';
    if (hashIndex > -1) {
        hash = window.location.href.substring(hashIndex + 1);
    }
    if (!hashStateCache.hasOwnProperty(key)) {
        hashStateCache[key] = '';
    }
    hash = hash.split('&').sort().join('&');
    if (hash === hashStateCache[key] && !always) {
        // No changes detected
        return undefined;
    }
    hashStateCache[key] = hash;
    var hashState = Object(jquery_deparam_patched["default"])(hash);
    if (!hashState || !(key in hashState)) {
        return {};
    }
    return hashState[key] || {};
}
function saveStateToHash(key, state) {
    var url = window.location.href;
    var hashIndex = url.lastIndexOf('#');
    var hash = '';
    if (hashIndex > -1) {
        hash = url.substring(hashIndex + 1);
    }
    var hashState = Object(jquery_deparam_patched["default"])(hash) || {};
    hashState[key] = state;
    var serialized = external___window__g_____g_$_____window_$CQ____window_$____window_jQuery_["param"](hashState, false)
        .split('&').sort().join('&');
    setHash(serialized);
    hashStateCache[key] = serialized;
}
function setHash(hash, replaceState) {
    if (replaceState === void 0) { replaceState = true; }
    var deeplink = hash.startsWith('#') ? hash : '#' + hash;
    if (replaceState) {
        if (window.history && window.history.replaceState) {
            window.history.replaceState(undefined, '', deeplink);
        }
        else {
            window.location.replace('#' + deeplink);
        }
    }
    else {
        if (window.history && window.history.pushState) {
            window.history.pushState(undefined, '', deeplink);
        }
        else {
            window.location.hash = deeplink;
        }
    }
}
function isImagePath(path) {
    if (!path) {
        return false;
    }
    return /\.((jpg)|(jpeg)|(gif)|(png)|(bmp))((\?|#).*)?$/i.test(path);
}
/**
 * Checks if a url is external - can be used to check if a url can be loaded via ajax (same domain policy)
 * @method isExternalUrl
 * @param url {string}
 * @returns boolean
 */
var URL_MATCHER = /^([^:\/?#]+:)?(?:\/\/([^\/?#]*))?([^?#]+)?(\?[^#]*)?(#.*)?/;
var CURRENT_PORT = location.protocol === 'http' ? 80 : 443;
function isExternalUrl(url) {
    if (!url) {
        return false;
    }
    var match = url.match(URL_MATCHER);
    if (!match) {
        return false;
    }
    var protocol = (match[1] || '').toLowerCase();
    if (protocol && protocol !== location.protocol) {
        return true;
    }
    var host = (match[2] || '');
    if (host.length > 0 && host.replace(new RegExp(":(" + CURRENT_PORT + ")?$"), '') !== location.host) {
        return true;
    }
    return false;
}
var HashDeepLinkController = /** @class */ (function () {
    function HashDeepLinkController() {
        var _this = this;
        this.deeplinks = [];
        this.callbacks = [];
        this.update();
        window.addEventListener('hashchange', function () { return _this.update(); });
    }
    HashDeepLinkController.prototype.get = function (name) {
        var value;
        for (var _i = 0, _a = this.deeplinks; _i < _a.length; _i++) {
            var link = _a[_i];
            if (link.indexOf(name + '=') === 0) {
                value = decodeURIComponent(link.split('=', 2)[1]);
            }
        }
        return value;
    };
    /**
     * Set a hash parameter or replace it's value.
     *
     * @param name 			The parameter name to set/replace
     * @param value 		The value to set to `name`
     * @param separator 	The separator with which to separate key value pairs
     * @param replaceState 	Set true to omit creating a history entry.
     */
    HashDeepLinkController.prototype.set = function (name, value, separator, replaceState) {
        if (separator === void 0) { separator = ','; }
        if (replaceState === void 0) { replaceState = true; }
        var deeplinkupdated = false;
        var deeplinkValues;
        for (var i = 0; i < this.deeplinks.length; i += 1) {
            if (this.deeplinks[i].indexOf(name + '=') === 0) {
                if (typeof value !== 'undefined') {
                    deeplinkValues = this.deeplinks[i].split('=', 2);
                    deeplinkValues[1] = encodeURIComponent(value);
                    this.deeplinks[i] = deeplinkValues.join('=');
                }
                else {
                    this.deeplinks.splice(i, 1);
                }
                deeplinkupdated = true;
                break;
            }
            if (!this.deeplinks[i]) {
                this.deeplinks.splice(i, 1);
            }
        }
        if (!deeplinkupdated && typeof value !== 'undefined') {
            this.deeplinks.push(name + "=" + encodeURIComponent(value));
        }
        var deeplink = this.deeplinks.join(separator || ',');
        // Add something to avoid jump to top
        if (deeplink === '') {
            deeplink = '!';
        }
        setHash(deeplink, replaceState);
        this.notifySubscribers();
    };
    HashDeepLinkController.prototype.subscribe = function (callback) {
        if (this.callbacks.indexOf(callback) < 0) {
            this.callbacks.push(callback);
        }
    };
    HashDeepLinkController.prototype.update = function () {
        // Use location.href and not hash because window.location.hash returns a urlDecoded value
        var deeplink = window.location.hash
            ? window.location.href.substr(window.location.href.indexOf('#') + 1)
            : '';
        if (deeplink.indexOf(',') > -1) {
            this.deeplinks = deeplink.split(',');
        }
        else {
            this.deeplinks = deeplink.split('&');
        }
        // Remove jump to top preventer
        if (this.deeplinks.length) {
            if (this.deeplinks[0] === '!') {
                this.deeplinks.shift();
            }
        }
    };
    HashDeepLinkController.prototype.notifySubscribers = function () {
        for (var _i = 0, _a = this.callbacks; _i < _a.length; _i++) {
            var callback = _a[_i];
            callback();
        }
    };
    return HashDeepLinkController;
}());
var hashDeepLink = new HashDeepLinkController();


/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_sdx_modal_Modal__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lib_util_pageScrolling__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lib_util_url__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lib_util_helpers__ = __webpack_require__(4);
/*
/*
(c) Copyright Swisscom (Schweiz) AG. All rights reserved.

 This product is the proprietary and sole property of Swisscom (Schweiz) AG
 Use, duplication or dissemination is subject to prior written consent of
 Swisscom (Schweiz) AG.
*/





/** Static instance to enforce singleton pattern */
var instance = null;
/** Cache already loaded urls to avoid re-fetch */
var contentCache = {};
// Hardcode common translations inline due to
// Lack of approved JS translation mechanism
var label = {
    close: {
        de: 'Schliessen',
        en: 'Close',
        fr: 'Fermer',
        it: 'Chiudi',
    },
};
// Santize styles of fake containers
// We don't want any margin/paddings
var cleanCss = {
    margin: '0px',
    padding: '0px',
    width: 'auto',
};
var DISPLAY_MODES = {
    content: 'col-xs-12 col-lg-10 col-xl-8',
    prompt: 'col-xs col-md-10 col-lg-8 col-xl-6',
};
/**
 * Created by Marcel Greter on 21.11.2017.
 *
 * Simple implementation for SDX Modal dialogs. Necessary HTML
 * structure is created once on demand and then re-used. It
 * internally uses/bridges the provided `sdx.Modal` module.
 *
 * @author Marcel Greter (TAAGRMAL)
 * @class SDXModalDialog
 */
var SDXModalDialog = /** @class */ (function () {
    /**
     * Creates empty instance, call `init`
     * to create/initialize DOM structure.
     * @constructor SDXModalDialog
     */
    function SDXModalDialog() {
        /** Stores the sdx.Modal dialog instance */
        this.dialog = null;
        /** Stores spinner timeout */
        this.spinnerTimer = 0;
        // Intentionally left blank
        // Initialized lazy on first use
        var lang = __WEBPACK_IMPORTED_MODULE_1_jquery___default()('HTML').attr('lang');
        switch ((lang || 'de').toLocaleLowerCase()) {
            case 'en':
                this.lang = 'en';
                break;
            case 'fr':
                this.lang = 'fr';
                break;
            case 'it':
                this.lang = 'it';
                break;
            default:
                this.lang = 'de';
                break;
        }
        // Just here to satisfy TypeScript and TSLint
        this.$wrapper = this.$buttons = this.$header = this.$closer =
            this.$title = this.$body = this.$spinner = this.$content =
                this.$text = this.$html = this.$el = __WEBPACK_IMPORTED_MODULE_1_jquery___default()('<div>');
    }
    /**
     * Get singleton instance, which will
     * be created on demand on the first call.
     */
    SDXModalDialog.getInstance = function () {
        return instance !== null ? instance :
            instance = new SDXModalDialog();
    };
    /**
     * Initialize and show modal dialog with given config.
     */
    // tslint:disable:cyclomatic-complexity
    SDXModalDialog.prototype.show = function (config) {
        this.on = config.on;
        this.config = config;
        this.init();
        this.reset(config);
        if (config.notification) {
            // Render as a notification modal (different layout as regular modal.)
            // See https://sdx.swisscom.ch/components_-_notifications_(modal).html
            this.initContentAsNotificationModal(config);
            // Notification modals have predefined dimensions.
            // They can not be overriden by the config.
        }
        else {
            // Render as a regular modal
            // See https://sdx.swisscom.ch/components_-_modals.html
            this.setTitle(config.title);
            if (config.html || config.text) {
                this.setSimpleText(config.text);
                this.setHTML(config.html);
            }
            else if (Object(__WEBPACK_IMPORTED_MODULE_3_lib_util_url__["isImagePath"])(config.url)) {
                // Show scaled image with an image tag
                var img = __WEBPACK_IMPORTED_MODULE_1_jquery___default()('<img/>', { src: config.url, alt: '' });
                img.css({ height: 'auto', width: '100%' });
                // Show html code in modal
                this.setHTML(img);
            }
            else if (config.iframe || Object(__WEBPACK_IMPORTED_MODULE_3_lib_util_url__["isExternalUrl"])(config.url)) {
                this.setIframeContent(config);
            }
            else if (config.url) {
                this.setContentFromInternalUrl(config);
            }
            // Set Dialog Dimensions.
            this.setDimensions(config);
        }
        // Add configured buttons.
        this.addButtons(config);
        if (config.autoOpen !== false) {
            this.open();
        }
        Object(__WEBPACK_IMPORTED_MODULE_4_lib_util_helpers__["ensure"])(this.$body, false);
    };
    /**
     * Open modal dialog with current config.
     * Not very useful, but here for completeness,
     * in case you want to re-open after close.
     * Or if you have set `autoOpen` to `false`
     */
    SDXModalDialog.prototype.open = function () {
        this.init();
        Object(__WEBPACK_IMPORTED_MODULE_2_lib_util_pageScrolling__["a" /* lockPageScroll */])();
        // Invoke sdx method
        this.dialog.open();
        document.body.classList.add('js-modal-open');
        // Dispatch open event (legacy callback)
        // Will be called once url is loaded (async)
        if (this.on && typeof this.on.open === 'function') {
            this.on.open.call(this);
        }
    };
    /**
     * Close currently shown dialog.
     * Will emit sdx dialog events.
     */
    SDXModalDialog.prototype.close = function () {
        this.init();
        Object(__WEBPACK_IMPORTED_MODULE_2_lib_util_pageScrolling__["b" /* unlockPageScroll */])();
        // Invoke sdx method
        this.dialog.close();
        document.body.classList.remove('js-modal-open');
    };
    /**
     * Render the dialog as a notification modal.
     *
     * @param config {SDXModalDialogConfig} - the dialog config to use to render the dialog
     */
    SDXModalDialog.prototype.initContentAsNotificationModal = function (config) {
        if (!config.notification) {
            return;
        }
        this.notification = config.notification;
        this.$header.toggle(false);
        this.$outsideHeaderCloser.toggle(true);
        this.$body.empty();
        var text = config.text || '';
        var icon = '';
        var notificationClass = '';
        switch (config.notification) {
            case 'general': {
                icon = 'icon-051-message';
                break;
            }
            case 'alert': {
                icon = 'icon-026-exclamation-mark-circle';
                notificationClass = 'modal--notification--alert';
                break;
            }
            case 'confirmation': {
                icon = 'icon-012-check-mark-circle';
                notificationClass = 'modal--notification--confirmation';
                break;
            }
            default: break;
        }
        var msg = "<div class=\"notification-message\">\n\t\t\t\t<i class=\"icon " + icon + "\" aria-hidden=\"true\"></i>\n\t\t\t\t" + String(text) + "\n\t\t\t</div>";
        this.setHTML(msg);
        this.$modalWrapper.addClass("modal--notification " + notificationClass);
    };
    /**
     * Initialize SDX dialog DOM structure.
     * @returns sdx.Modal instance
     */
    SDXModalDialog.prototype.initDialogSDX = function () {
        var _this = this;
        var modalId = 'm-' + Date.now().toString();
        var $container = __WEBPACK_IMPORTED_MODULE_1_jquery___default()('<DIV class="container sdx-modal-holder">');
        var $sdxContainer = __WEBPACK_IMPORTED_MODULE_1_jquery___default()('<DIV class="sdx-container">');
        var $modalWrapper = __WEBPACK_IMPORTED_MODULE_1_jquery___default()("<DIV class=\"modal\" role=\"dialog\" aria-labelledby=\"" + modalId + "\" tabindex=\"-1\">");
        var $modalContent = __WEBPACK_IMPORTED_MODULE_1_jquery___default()('<DIV class="modal__content">');
        var $modalHeader = __WEBPACK_IMPORTED_MODULE_1_jquery___default()('<DIV class="modal__header">');
        var $modalBody = __WEBPACK_IMPORTED_MODULE_1_jquery___default()('<DIV class="modal__body">');
        var $closeIcon = __WEBPACK_IMPORTED_MODULE_1_jquery___default()('<I class="icon icon-022-close" aria-hidden="true">');
        var $closer = __WEBPACK_IMPORTED_MODULE_1_jquery___default()('<BUTTON class="modal__close modal-cancel">');
        var $outsideHeaderCloser = __WEBPACK_IMPORTED_MODULE_1_jquery___default()('<BUTTON class="modal__close modal-cancel">');
        var $buttons = __WEBPACK_IMPORTED_MODULE_1_jquery___default()('<DIV class="button-group">');
        var $content = __WEBPACK_IMPORTED_MODULE_1_jquery___default()('<DIV>');
        var $title = __WEBPACK_IMPORTED_MODULE_1_jquery___default()("<P class=\"sc-gray text-h4 dialog-title\" role=\"heading\" aria-level=\"1\" id=\"" + modalId + "\">");
        var $html = __WEBPACK_IMPORTED_MODULE_1_jquery___default()('<DIV>');
        var $text = __WEBPACK_IMPORTED_MODULE_1_jquery___default()('<P>');
        this.$contentHolder = $modalBody;
        // Create sdx html structure
        $modalWrapper.appendTo($sdxContainer);
        $container.appendTo($modalWrapper);
        $modalContent.appendTo($container);
        $modalHeader.appendTo($modalContent);
        $outsideHeaderCloser.appendTo($modalContent);
        $modalBody.appendTo($modalContent);
        $title.appendTo($modalHeader);
        $closer.appendTo($modalHeader);
        $closeIcon.appendTo([$closer[0], $outsideHeaderCloser[0]]);
        // ToDo: make this configurable?
        $buttons.addClass('button-group--responsive');
        $closer.attr('aria-label', label.close[this.lang]);
        // Sanitize a few styles
        $content.css(cleanCss);
        $content.css('float', 'none');
        $buttons.css('clear', 'both');
        this.$modalWrapper = $modalWrapper;
        this.$wrapper = $modalContent;
        this.$buttons = $buttons;
        this.$header = $modalHeader;
        this.$closer = $closer;
        this.$outsideHeaderCloser = $outsideHeaderCloser;
        this.$title = $title;
        this.$body = $modalBody;
        this.$content = $content;
        this.$text = $text;
        this.$html = $html;
        this.$el = $sdxContainer;
        __WEBPACK_IMPORTED_MODULE_1_jquery___default()($modalWrapper[0]).on('cancelled', function (event) {
            Object(__WEBPACK_IMPORTED_MODULE_2_lib_util_pageScrolling__["b" /* unlockPageScroll */])();
            document.body.classList.remove('js-modal-open');
            if (_this.on && typeof _this.on.cancel === 'function') {
                return _this.on.cancel.call(_this, event);
            }
        });
        __WEBPACK_IMPORTED_MODULE_1_jquery___default()($modalWrapper[0]).on('closed', function (event) {
            Object(__WEBPACK_IMPORTED_MODULE_2_lib_util_pageScrolling__["b" /* unlockPageScroll */])();
            document.body.classList.remove('js-modal-open');
            if (_this.on && typeof _this.on.close === 'function') {
                return _this.on.close.call(_this, event);
            }
        });
        // Create loading spinner dom
        this.$spinner = __WEBPACK_IMPORTED_MODULE_1_jquery___default()('<DIV>')
            .css('margin', 'auto')
            .addClass('loader-spinner')
            .addClass('loader-spinner--large')
            .addClass('loader-spinner--plain');
        // Instantiate a new sdx modal dialog
        return new __WEBPACK_IMPORTED_MODULE_0_sdx_modal_Modal__["default"]($modalWrapper[0]);
    };
    /**
     * Ensures SDX modal dialog is initialized.
     * Multiple calls do not have any effect.
     */
    SDXModalDialog.prototype.init = function () {
        // Create HTML singleton
        if (this.dialog === null) {
            // Create sdx dialog structure
            this.dialog = this.initDialogSDX();
            __WEBPACK_IMPORTED_MODULE_1_jquery___default()('BODY').append(this.$el);
            // Add gray-out background to sdx-container
            this.dialog._backdropParent = this.$el[0];
        }
    };
    /**
     * Helper to create and set SDX dialog buttons DOM.
     */
    SDXModalDialog.prototype.addButtons = function (config) {
        if (!config.buttons || !config.buttons.length) {
            return;
        }
        var buttons = config.buttons;
        if (this.notification) {
            this.$buttons.removeClass('button-group button-group--responsive');
        }
        for (var _i = 0, buttons_1 = buttons; _i < buttons_1.length; _i++) {
            var button = buttons_1[_i];
            var $button = __WEBPACK_IMPORTED_MODULE_1_jquery___default()('<BUTTON>')
                .addClass('button')
                .addClass('button--responsive')
                .append(button.title)
                .appendTo(this.$buttons);
            if (button.type) {
                var type = button.type;
                $button.addClass('modal-' + type);
            }
            if (button.primary) {
                $button.addClass('button--primary');
            }
            else {
                $button.addClass('button--secondary');
            }
            if (button.thin) {
                $button.removeClass('button--primary button--secondary');
                $button.addClass('button--thin');
            }
            if (button.click) {
                // Call in the context of modal dialog
                $button.click(button.click.bind(this));
            }
        }
        this.$buttons.appendTo(this.$body);
    };
    /**
     * Resetting the content of the modal.
     * @param config	{SDXModalDialogConfig}	The config to use for resetting the modal.
     */
    SDXModalDialog.prototype.reset = function (config) {
        this.$content.empty().detach();
        this.$html.empty().hide(0).detach();
        this.$text.empty().hide(0).detach();
        this.$title.empty();
        // Hiding buttons is not good enough as we have a list-child
        // Selector on the sdx styles to remove the bottom margin
        this.$buttons.empty().detach();
        this.$modalWrapper.removeClass('modal--notification modal--notification--confirmation modal--notification--alert');
        this.$closer.toggle(!config.hideCloser);
        this.$header.toggle(!config.hideHeader);
        this.$outsideHeaderCloser.toggle(!config.hideCloser);
        if (!config.hideHeader) {
            this.$outsideHeaderCloser.toggle(false);
        }
        this.$wrapper.attr('class', 'modal__content');
        this.$wrapper.addClass(config.class || '');
        // Remove all previously set styles for width and height.
        this.$wrapper.attr('style', null);
    };
    /**
     * Load and cache content from a internal url
     * @param config {SDXModalDialogConfig} - the dialog congfig
     */
    SDXModalDialog.prototype.setContentFromInternalUrl = function (config) {
        var _this = this;
        if (!config.url || Object(__WEBPACK_IMPORTED_MODULE_3_lib_util_url__["isExternalUrl"])(config.url)) {
            return;
        }
        var url = config.url;
        if (Object(__WEBPACK_IMPORTED_MODULE_4_lib_util_helpers__["isMobilePage"])()) {
            // Add mobile page selector if we are embedded in a mobile page
            url = url.replace(/(?:\.mobile)?\.html([#?.]|$)/, '.mobile.html$1');
        }
        if (url in contentCache) {
            var content = contentCache[url];
            this.showContent(config, content);
            return;
        }
        // Abort any request in progress
        if (this.xhr) {
            this.xhr.abort();
        }
        // Fetch url (store pending request)
        this.xhr = __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.get(url, function (content) {
            _this.xhr = undefined;
            contentCache[url] = content;
            _this.showContent(config, content);
        });
        // Clear pending timer
        if (this.spinnerTimer) {
            clearTimeout(this.spinnerTimer);
        }
        // Show spinner if load takes more than 1s
        this.spinnerTimer = setTimeout(function () {
            _this.$content.append(_this.$spinner);
        }, 1000);
    };
    /**
     * Set the dimensions of the dialog.
     * @param config {SDXModalDialogConfig} - the dialog congfig
     */
    SDXModalDialog.prototype.setDimensions = function (config) {
        if (config.minWidth) {
            var minWidth = config.minWidth;
            // .css('min-width', '500') does not work!
            if (!Number.isNaN(Number(minWidth))) {
                minWidth = minWidth + 'px';
            }
            this.$wrapper.css('min-width', minWidth);
        }
        if (config.minHeight) {
            var minHeight = config.minHeight;
            // .css('min-height', '500') does not work!
            if (!Number.isNaN(Number(minHeight))) {
                minHeight = minHeight + 'px';
            }
            this.$wrapper.css('min-height', minHeight);
        }
        if (config.height) {
            this.$wrapper.css('height', String(config.height));
        }
        if (config.displayMode) {
            this.$wrapper.addClass(DISPLAY_MODES[config.displayMode]);
        }
        else if (config.fillWidth) {
            // Do not collapse small content
            this.$wrapper.css('width', '100%');
        }
        else if (config.width) {
            // Use specific width otherwise
            this.$wrapper.css('width', String(config.width));
        }
        else {
            this.$wrapper.addClass(DISPLAY_MODES.content);
        }
    };
    /**
     * Set content as an iFrame
     * @param config {SDXModalDialogConfig} - the dialog congfig
     */
    SDXModalDialog.prototype.setIframeContent = function (config) {
        if (!config.url) {
            return;
        }
        var dims = {
            height: '100%',
            width: '100%',
        };
        this.$content.css(dims);
        var $element = __WEBPACK_IMPORTED_MODULE_1_jquery___default()('<IFRAME>')
            .css('margin', '0px')
            .css('border', 'none')
            .attr('src', config.url).attr(dims);
        this.appendToBody($element);
    };
    /**
     * Set an html string as the new modal content.
     * Maybe used in combination with simple text.
     * @param html {string | JQuery} - The new html content
     */
    SDXModalDialog.prototype.setHTML = function (html) {
        if (!html) {
            return;
        }
        this.$html.appendTo(this.$body);
        this.$html.append(html);
        this.$html.show(0);
    };
    /**
     * Set a new text string as the modal content.
     * Maybe used in combination with html text.
     * @param text {string | JQuery} - The new text content
     */
    SDXModalDialog.prototype.setSimpleText = function (text) {
        if (!text) {
            return;
        }
        this.$text.appendTo(this.$body);
        this.$text.append(text);
        this.$text.show(0);
    };
    /**
     * Set a new modal title.
     * @param title {string} - The new modal title
     */
    SDXModalDialog.prototype.setTitle = function (title) {
        if (!title) {
            return;
        }
        this.$title.text(title);
    };
    /**
     * Helper to create and set SDX dialog content DOM.
     */
    SDXModalDialog.prototype.showContent = function (config, content) {
        this.$content.empty();
        clearTimeout(this.spinnerTimer);
        var parser = new DOMParser();
        var doc = parser.parseFromString(content, 'text/html');
        // Finding a title for the modal.
        var title = config.title;
        if (!title) {
            var titleElement = doc.querySelector('.dialog-title');
            if (!titleElement) {
                title = doc.title.substring(0, doc.title.lastIndexOf('|'));
            }
            else {
                title = titleElement.textContent;
            }
        }
        this.setTitle(title);
        // Finding the content.
        var portalContentPageSelector = Object(__WEBPACK_IMPORTED_MODULE_4_lib_util_helpers__["isMobilePage"])() ? '.stageMobile:first-child > .parsys' : '.content > DIV.parsys';
        var contentSelector = config.contentSelector || portalContentPageSelector;
        var newContent = doc.querySelectorAll(contentSelector);
        if (newContent.length) {
            var $newContent = $(Array.prototype.slice.call(newContent));
            this.appendToBody($newContent, true);
            return;
        }
        // Maybe we loaded a sdx-template based page
        var sdxTemplateSelector = '.main-wrapper > .page';
        newContent = doc.querySelectorAll(sdxTemplateSelector);
        var $pageContent = $(newContent[0]);
        $pageContent.removeClass('container-fluid');
        this.appendToBody($pageContent);
    };
    /**
     * Attach and show the content.
     */
    SDXModalDialog.prototype.appendToBody = function ($content, shouldWrap) {
        if (shouldWrap === void 0) { shouldWrap = false; }
        // Needed for IE11 (DAC-16797)
        for (var i = 0; i < $content.length; i++) {
            // OwnerDocument seems to be the DOMParser!?
            $content[i] = document.adoptNode($content[i]);
        }
        if (shouldWrap) {
            $content = $('<div class="content fake"></div>')
                .css(cleanCss)
                .css('float', 'none')
                .append($content);
            $content = $('<div class="middle fake"></div>')
                .css(cleanCss)
                .append($content);
        }
        this.$content.append($content);
        /*
            * The content has to be the first item in the body.
            * Since the content may have been ajax loaded, the configured buttons
            * may have been attached to the body already.
            * Hence, prepend the content to the body to avoid that the buttons appear
            * before the content.
            */
        this.$content.prependTo(this.$body);
        this.$content.show(0);
        Object(__WEBPACK_IMPORTED_MODULE_4_lib_util_helpers__["ensure"])($content, false);
    };
    return SDXModalDialog;
}());
// Export the singleton instance directly
/* harmony default export */ __webpack_exports__["default"] = (SDXModalDialog.getInstance());

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = deparam;
/// <reference types="jquery" />
var coerceTypes = { true: true, false: false, null: null };
function deparam(params, coerce) {
    if (coerce === void 0) { coerce = false; }
    var obj = {};
    // If params is an empty string or otherwise falsy, return obj.
    if (!params) {
        return obj;
    }
    // Iterate over all name=value pairs.
    params.replace(/\+/g, ' ').split('&').forEach(function (v) {
        var param = v.split('=');
        var key = decodeURIComponent(param[0]);
        var val = null;
        var cur = obj;
        var i = 0;
        // If key is more complex than 'foo', like 'a[]' or 'a[b][c]', split it
        // into its component parts.
        var keys = key.split('][');
        var keysLast = keys.length - 1;
        // If the first keys part contains [ and the last ends with ], then []
        // are correctly balanced.
        if (/\[/.test(keys[0]) && /\]$/.test(keys[keysLast])) {
            // Remove the trailing ] from the last keys part.
            keys[keysLast] = keys[keysLast].replace(/\]$/, '');
            // Split first keys part into two parts on the [ and add them back onto
            // the beginning of the keys array.
            var part = keys.shift();
            if (part !== undefined) {
                keys = part.split('[').concat(keys);
            }
            keysLast = keys.length - 1;
        }
        else {
            // Basic 'foo' style key.
            keysLast = 0;
        }
        // Are we dealing with a name=value pair, or just a name?
        if (param.length === 2) {
            val = decodeURIComponent(param[1]);
            // Coerce values.
            if (coerce) {
                val = val && !isNaN(val) && ((+val + '') === val) ? +val // Isa number
                    : val === 'undefined' ? undefined // Isa undefined
                        : coerceTypes[val] !== undefined ? coerceTypes[val] // Isa true, false, null
                            : val; // Isa string
            }
            if (keysLast) {
                // Complex key, build deep object structure based on a few rules:
                // * The 'cur' pointer starts at the object top-level.
                // * [] = array push (n is set to array length), [n] = array if n is
                //   numeric, otherwise object.
                // * If at the last keys part, set the value.
                // * For each keys part, if the current level is undefined create an
                //   object or array based on the type of the next keys part.
                // * Move the 'cur' pointer to the next level.
                // * Rinse & repeat.
                for (; i <= keysLast; i++) {
                    key = keys[i] === '' ? cur.length : keys[i];
                    if (i < keysLast) {
                        // Patched by taagrmal: must check if property is ours
                        // Otherwise we must not overwrite it by any means!
                        if (Object.prototype.hasOwnProperty.call(cur, key) && cur[key]) {
                            cur = cur[key]; // Re-use existing object
                        }
                        else {
                            cur = cur[key] = keys[i + 1] && isNaN(keys[i + 1]) ? {} : [];
                        }
                    }
                    else {
                        cur[key] = val;
                    }
                }
            }
            else {
                // Simple key, even simpler rules, since only scalars and shallow
                // arrays are allowed.
                if (Object.prototype.toString.call(obj[key]) === '[object Array]') {
                    // Val is already an array, so push on the next value.
                    obj[key].push(val);
                }
                else if (Object.prototype.hasOwnProperty.call(obj, key)) {
                    // Val isn't an array, but since a second value has been specified,
                    // convert val into an array.
                    obj[key] = [obj[key], val];
                }
                else {
                    // Val is a scalar.
                    obj[key] = val;
                }
            }
        }
        else if (key) {
            // No value was defined, so set something meaningful.
            obj[key] = coerce ? undefined : '';
        }
    });
    return obj;
}


/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/snabbdom/es/vnode.js
function vnode_vnode(sel, data, children, text, elm) {
    var key = data === undefined ? undefined : data.key;
    return { sel: sel, data: data, children: children,
        text: text, elm: elm, key: key };
}
/* harmony default export */ var es_vnode = (vnode_vnode);
//# sourceMappingURL=vnode.js.map
// CONCATENATED MODULE: ./node_modules/snabbdom/es/is.js
var array = Array.isArray;
function primitive(s) {
    return typeof s === 'string' || typeof s === 'number';
}
//# sourceMappingURL=is.js.map
// CONCATENATED MODULE: ./node_modules/snabbdom/es/htmldomapi.js
function createElement(tagName) {
    return document.createElement(tagName);
}
function createElementNS(namespaceURI, qualifiedName) {
    return document.createElementNS(namespaceURI, qualifiedName);
}
function createTextNode(text) {
    return document.createTextNode(text);
}
function createComment(text) {
    return document.createComment(text);
}
function insertBefore(parentNode, newNode, referenceNode) {
    parentNode.insertBefore(newNode, referenceNode);
}
function removeChild(node, child) {
    node.removeChild(child);
}
function appendChild(node, child) {
    node.appendChild(child);
}
function parentNode(node) {
    return node.parentNode;
}
function nextSibling(node) {
    return node.nextSibling;
}
function tagName(elm) {
    return elm.tagName;
}
function setTextContent(node, text) {
    node.textContent = text;
}
function getTextContent(node) {
    return node.textContent;
}
function isElement(node) {
    return node.nodeType === 1;
}
function isText(node) {
    return node.nodeType === 3;
}
function isComment(node) {
    return node.nodeType === 8;
}
var htmlDomApi = {
    createElement: createElement,
    createElementNS: createElementNS,
    createTextNode: createTextNode,
    createComment: createComment,
    insertBefore: insertBefore,
    removeChild: removeChild,
    appendChild: appendChild,
    parentNode: parentNode,
    nextSibling: nextSibling,
    tagName: tagName,
    setTextContent: setTextContent,
    getTextContent: getTextContent,
    isElement: isElement,
    isText: isText,
    isComment: isComment,
};
/* harmony default export */ var htmldomapi = (htmlDomApi);
//# sourceMappingURL=htmldomapi.js.map
// CONCATENATED MODULE: ./node_modules/snabbdom/es/h.js


function addNS(data, children, sel) {
    data.ns = 'http://www.w3.org/2000/svg';
    if (sel !== 'foreignObject' && children !== undefined) {
        for (var i = 0; i < children.length; ++i) {
            var childData = children[i].data;
            if (childData !== undefined) {
                addNS(childData, children[i].children, children[i].sel);
            }
        }
    }
}
function h(sel, b, c) {
    var data = {}, children, text, i;
    if (c !== undefined) {
        data = b;
        if (array(c)) {
            children = c;
        }
        else if (primitive(c)) {
            text = c;
        }
        else if (c && c.sel) {
            children = [c];
        }
    }
    else if (b !== undefined) {
        if (array(b)) {
            children = b;
        }
        else if (primitive(b)) {
            text = b;
        }
        else if (b && b.sel) {
            children = [b];
        }
        else {
            data = b;
        }
    }
    if (children !== undefined) {
        for (i = 0; i < children.length; ++i) {
            if (primitive(children[i]))
                children[i] = vnode_vnode(undefined, undefined, undefined, children[i], undefined);
        }
    }
    if (sel[0] === 's' && sel[1] === 'v' && sel[2] === 'g' &&
        (sel.length === 3 || sel[3] === '.' || sel[3] === '#')) {
        addNS(data, children, sel);
    }
    return vnode_vnode(sel, data, children, text, undefined);
}
;
/* harmony default export */ var es_h = (h);
//# sourceMappingURL=h.js.map
// CONCATENATED MODULE: ./node_modules/snabbdom/es/thunk.js

function copyToThunk(vnode, thunk) {
    thunk.elm = vnode.elm;
    vnode.data.fn = thunk.data.fn;
    vnode.data.args = thunk.data.args;
    thunk.data = vnode.data;
    thunk.children = vnode.children;
    thunk.text = vnode.text;
    thunk.elm = vnode.elm;
}
function init(thunk) {
    var cur = thunk.data;
    var vnode = cur.fn.apply(undefined, cur.args);
    copyToThunk(vnode, thunk);
}
function prepatch(oldVnode, thunk) {
    var i, old = oldVnode.data, cur = thunk.data;
    var oldArgs = old.args, args = cur.args;
    if (old.fn !== cur.fn || oldArgs.length !== args.length) {
        copyToThunk(cur.fn.apply(undefined, args), thunk);
        return;
    }
    for (i = 0; i < args.length; ++i) {
        if (oldArgs[i] !== args[i]) {
            copyToThunk(cur.fn.apply(undefined, args), thunk);
            return;
        }
    }
    copyToThunk(oldVnode, thunk);
}
var thunk_thunk = function thunk(sel, key, fn, args) {
    if (args === undefined) {
        args = fn;
        fn = key;
        key = undefined;
    }
    return h(sel, {
        key: key,
        hook: { init: init, prepatch: prepatch },
        fn: fn,
        args: args
    });
};
/* harmony default export */ var es_thunk = (thunk_thunk);
//# sourceMappingURL=thunk.js.map
// CONCATENATED MODULE: ./node_modules/snabbdom/es/snabbdom.js



function isUndef(s) { return s === undefined; }
function isDef(s) { return s !== undefined; }
var emptyNode = es_vnode('', {}, [], undefined, undefined);
function sameVnode(vnode1, vnode2) {
    return vnode1.key === vnode2.key && vnode1.sel === vnode2.sel;
}
function isVnode(vnode) {
    return vnode.sel !== undefined;
}
function createKeyToOldIdx(children, beginIdx, endIdx) {
    var i, map = {}, key, ch;
    for (i = beginIdx; i <= endIdx; ++i) {
        ch = children[i];
        if (ch != null) {
            key = ch.key;
            if (key !== undefined)
                map[key] = i;
        }
    }
    return map;
}
var hooks = ['create', 'update', 'remove', 'destroy', 'pre', 'post'];


function snabbdom_init(modules, domApi) {
    var i, j, cbs = {};
    var api = domApi !== undefined ? domApi : htmldomapi;
    for (i = 0; i < hooks.length; ++i) {
        cbs[hooks[i]] = [];
        for (j = 0; j < modules.length; ++j) {
            var hook = modules[j][hooks[i]];
            if (hook !== undefined) {
                cbs[hooks[i]].push(hook);
            }
        }
    }
    function emptyNodeAt(elm) {
        var id = elm.id ? '#' + elm.id : '';
        var c = elm.className ? '.' + elm.className.split(' ').join('.') : '';
        return es_vnode(api.tagName(elm).toLowerCase() + id + c, {}, [], undefined, elm);
    }
    function createRmCb(childElm, listeners) {
        return function rmCb() {
            if (--listeners === 0) {
                var parent_1 = api.parentNode(childElm);
                api.removeChild(parent_1, childElm);
            }
        };
    }
    function createElm(vnode, insertedVnodeQueue) {
        var i, data = vnode.data;
        if (data !== undefined) {
            if (isDef(i = data.hook) && isDef(i = i.init)) {
                i(vnode);
                data = vnode.data;
            }
        }
        var children = vnode.children, sel = vnode.sel;
        if (sel === '!') {
            if (isUndef(vnode.text)) {
                vnode.text = '';
            }
            vnode.elm = api.createComment(vnode.text);
        }
        else if (sel !== undefined) {
            // Parse selector
            var hashIdx = sel.indexOf('#');
            var dotIdx = sel.indexOf('.', hashIdx);
            var hash = hashIdx > 0 ? hashIdx : sel.length;
            var dot = dotIdx > 0 ? dotIdx : sel.length;
            var tag = hashIdx !== -1 || dotIdx !== -1 ? sel.slice(0, Math.min(hash, dot)) : sel;
            var elm = vnode.elm = isDef(data) && isDef(i = data.ns) ? api.createElementNS(i, tag)
                : api.createElement(tag);
            if (hash < dot)
                elm.setAttribute('id', sel.slice(hash + 1, dot));
            if (dotIdx > 0)
                elm.setAttribute('class', sel.slice(dot + 1).replace(/\./g, ' '));
            for (i = 0; i < cbs.create.length; ++i)
                cbs.create[i](emptyNode, vnode);
            if (array(children)) {
                for (i = 0; i < children.length; ++i) {
                    var ch = children[i];
                    if (ch != null) {
                        api.appendChild(elm, createElm(ch, insertedVnodeQueue));
                    }
                }
            }
            else if (primitive(vnode.text)) {
                api.appendChild(elm, api.createTextNode(vnode.text));
            }
            i = vnode.data.hook; // Reuse variable
            if (isDef(i)) {
                if (i.create)
                    i.create(emptyNode, vnode);
                if (i.insert)
                    insertedVnodeQueue.push(vnode);
            }
        }
        else {
            vnode.elm = api.createTextNode(vnode.text);
        }
        return vnode.elm;
    }
    function addVnodes(parentElm, before, vnodes, startIdx, endIdx, insertedVnodeQueue) {
        for (; startIdx <= endIdx; ++startIdx) {
            var ch = vnodes[startIdx];
            if (ch != null) {
                api.insertBefore(parentElm, createElm(ch, insertedVnodeQueue), before);
            }
        }
    }
    function invokeDestroyHook(vnode) {
        var i, j, data = vnode.data;
        if (data !== undefined) {
            if (isDef(i = data.hook) && isDef(i = i.destroy))
                i(vnode);
            for (i = 0; i < cbs.destroy.length; ++i)
                cbs.destroy[i](vnode);
            if (vnode.children !== undefined) {
                for (j = 0; j < vnode.children.length; ++j) {
                    i = vnode.children[j];
                    if (i != null && typeof i !== "string") {
                        invokeDestroyHook(i);
                    }
                }
            }
        }
    }
    function removeVnodes(parentElm, vnodes, startIdx, endIdx) {
        for (; startIdx <= endIdx; ++startIdx) {
            var i_1 = void 0, listeners = void 0, rm = void 0, ch = vnodes[startIdx];
            if (ch != null) {
                if (isDef(ch.sel)) {
                    invokeDestroyHook(ch);
                    listeners = cbs.remove.length + 1;
                    rm = createRmCb(ch.elm, listeners);
                    for (i_1 = 0; i_1 < cbs.remove.length; ++i_1)
                        cbs.remove[i_1](ch, rm);
                    if (isDef(i_1 = ch.data) && isDef(i_1 = i_1.hook) && isDef(i_1 = i_1.remove)) {
                        i_1(ch, rm);
                    }
                    else {
                        rm();
                    }
                }
                else {
                    api.removeChild(parentElm, ch.elm);
                }
            }
        }
    }
    function updateChildren(parentElm, oldCh, newCh, insertedVnodeQueue) {
        var oldStartIdx = 0, newStartIdx = 0;
        var oldEndIdx = oldCh.length - 1;
        var oldStartVnode = oldCh[0];
        var oldEndVnode = oldCh[oldEndIdx];
        var newEndIdx = newCh.length - 1;
        var newStartVnode = newCh[0];
        var newEndVnode = newCh[newEndIdx];
        var oldKeyToIdx;
        var idxInOld;
        var elmToMove;
        var before;
        while (oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx) {
            if (oldStartVnode == null) {
                oldStartVnode = oldCh[++oldStartIdx]; // Vnode might have been moved left
            }
            else if (oldEndVnode == null) {
                oldEndVnode = oldCh[--oldEndIdx];
            }
            else if (newStartVnode == null) {
                newStartVnode = newCh[++newStartIdx];
            }
            else if (newEndVnode == null) {
                newEndVnode = newCh[--newEndIdx];
            }
            else if (sameVnode(oldStartVnode, newStartVnode)) {
                patchVnode(oldStartVnode, newStartVnode, insertedVnodeQueue);
                oldStartVnode = oldCh[++oldStartIdx];
                newStartVnode = newCh[++newStartIdx];
            }
            else if (sameVnode(oldEndVnode, newEndVnode)) {
                patchVnode(oldEndVnode, newEndVnode, insertedVnodeQueue);
                oldEndVnode = oldCh[--oldEndIdx];
                newEndVnode = newCh[--newEndIdx];
            }
            else if (sameVnode(oldStartVnode, newEndVnode)) {
                patchVnode(oldStartVnode, newEndVnode, insertedVnodeQueue);
                api.insertBefore(parentElm, oldStartVnode.elm, api.nextSibling(oldEndVnode.elm));
                oldStartVnode = oldCh[++oldStartIdx];
                newEndVnode = newCh[--newEndIdx];
            }
            else if (sameVnode(oldEndVnode, newStartVnode)) {
                patchVnode(oldEndVnode, newStartVnode, insertedVnodeQueue);
                api.insertBefore(parentElm, oldEndVnode.elm, oldStartVnode.elm);
                oldEndVnode = oldCh[--oldEndIdx];
                newStartVnode = newCh[++newStartIdx];
            }
            else {
                if (oldKeyToIdx === undefined) {
                    oldKeyToIdx = createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx);
                }
                idxInOld = oldKeyToIdx[newStartVnode.key];
                if (isUndef(idxInOld)) {
                    api.insertBefore(parentElm, createElm(newStartVnode, insertedVnodeQueue), oldStartVnode.elm);
                    newStartVnode = newCh[++newStartIdx];
                }
                else {
                    elmToMove = oldCh[idxInOld];
                    if (elmToMove.sel !== newStartVnode.sel) {
                        api.insertBefore(parentElm, createElm(newStartVnode, insertedVnodeQueue), oldStartVnode.elm);
                    }
                    else {
                        patchVnode(elmToMove, newStartVnode, insertedVnodeQueue);
                        oldCh[idxInOld] = undefined;
                        api.insertBefore(parentElm, elmToMove.elm, oldStartVnode.elm);
                    }
                    newStartVnode = newCh[++newStartIdx];
                }
            }
        }
        if (oldStartIdx <= oldEndIdx || newStartIdx <= newEndIdx) {
            if (oldStartIdx > oldEndIdx) {
                before = newCh[newEndIdx + 1] == null ? null : newCh[newEndIdx + 1].elm;
                addVnodes(parentElm, before, newCh, newStartIdx, newEndIdx, insertedVnodeQueue);
            }
            else {
                removeVnodes(parentElm, oldCh, oldStartIdx, oldEndIdx);
            }
        }
    }
    function patchVnode(oldVnode, vnode, insertedVnodeQueue) {
        var i, hook;
        if (isDef(i = vnode.data) && isDef(hook = i.hook) && isDef(i = hook.prepatch)) {
            i(oldVnode, vnode);
        }
        var elm = vnode.elm = oldVnode.elm;
        var oldCh = oldVnode.children;
        var ch = vnode.children;
        if (oldVnode === vnode)
            return;
        if (vnode.data !== undefined) {
            for (i = 0; i < cbs.update.length; ++i)
                cbs.update[i](oldVnode, vnode);
            i = vnode.data.hook;
            if (isDef(i) && isDef(i = i.update))
                i(oldVnode, vnode);
        }
        if (isUndef(vnode.text)) {
            if (isDef(oldCh) && isDef(ch)) {
                if (oldCh !== ch)
                    updateChildren(elm, oldCh, ch, insertedVnodeQueue);
            }
            else if (isDef(ch)) {
                if (isDef(oldVnode.text))
                    api.setTextContent(elm, '');
                addVnodes(elm, null, ch, 0, ch.length - 1, insertedVnodeQueue);
            }
            else if (isDef(oldCh)) {
                removeVnodes(elm, oldCh, 0, oldCh.length - 1);
            }
            else if (isDef(oldVnode.text)) {
                api.setTextContent(elm, '');
            }
        }
        else if (oldVnode.text !== vnode.text) {
            if (isDef(oldCh)) {
                removeVnodes(elm, oldCh, 0, oldCh.length - 1);
            }
            api.setTextContent(elm, vnode.text);
        }
        if (isDef(hook) && isDef(i = hook.postpatch)) {
            i(oldVnode, vnode);
        }
    }
    return function patch(oldVnode, vnode) {
        var i, elm, parent;
        var insertedVnodeQueue = [];
        for (i = 0; i < cbs.pre.length; ++i)
            cbs.pre[i]();
        if (!isVnode(oldVnode)) {
            oldVnode = emptyNodeAt(oldVnode);
        }
        if (sameVnode(oldVnode, vnode)) {
            patchVnode(oldVnode, vnode, insertedVnodeQueue);
        }
        else {
            elm = oldVnode.elm;
            parent = api.parentNode(elm);
            createElm(vnode, insertedVnodeQueue);
            if (parent !== null) {
                api.insertBefore(parent, vnode.elm, api.nextSibling(elm));
                removeVnodes(parent, [oldVnode], 0, 0);
            }
        }
        for (i = 0; i < insertedVnodeQueue.length; ++i) {
            insertedVnodeQueue[i].data.hook.insert(insertedVnodeQueue[i]);
        }
        for (i = 0; i < cbs.post.length; ++i)
            cbs.post[i]();
        return vnode;
    };
}
//# sourceMappingURL=snabbdom.js.map
// EXTERNAL MODULE: ./node_modules/snabbdom/modules/attributes.js
var attributes = __webpack_require__(208);
var attributes_default = /*#__PURE__*/__webpack_require__.n(attributes);

// EXTERNAL MODULE: ./node_modules/snabbdom/modules/props.js
var props = __webpack_require__(209);
var props_default = /*#__PURE__*/__webpack_require__.n(props);

// EXTERNAL MODULE: ./node_modules/snabbdom/modules/style.js
var style = __webpack_require__(210);
var style_default = /*#__PURE__*/__webpack_require__.n(style);

// EXTERNAL MODULE: ./node_modules/snabbdom/modules/eventlisteners.js
var eventlisteners = __webpack_require__(211);
var eventlisteners_default = /*#__PURE__*/__webpack_require__.n(eventlisteners);

// EXTERNAL MODULE: ./node_modules/snabbdom/modules/class.js
var modules_class = __webpack_require__(212);
var class_default = /*#__PURE__*/__webpack_require__.n(modules_class);

// CONCATENATED MODULE: ./clientlibs/js/bootstrap/load-snabbdom.ts
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return patch; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "a", function() { return h; });







var patch = snabbdom_init([
    attributes_default.a,
    props_default.a,
    style_default.a,
    eventlisteners_default.a,
    class_default.a,
]);
var snabbdom = {
    h: h,
    // Configure the required modules here,
    patch: patch,
};
window.snabbdom = snabbdom;
/* harmony default export */ var load_snabbdom = (snabbdom);


/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createElementWithModules", function() { return createElementWithModules; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createElement", function() { return createElement; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_extend__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_extend___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_extend__);


var undefinedv = function (v) { return v === undefined; };

var number = function (v) { return typeof v === 'number'; };

var string = function (v) { return typeof v === 'string'; };

var text = function (v) { return string(v) || number(v); };

var array = function (v) { return Array.isArray(v); };

var object = function (v) { return typeof v === 'object' && v !== null; };

var fun = function (v) { return typeof v === 'function'; };

var vnode = function (v) { return object(v) && 'sel' in v && 'data' in v && 'children' in v && 'text' in v; };

var svgPropsMap = { svg: 1, circle: 1, ellipse: 1, line: 1, polygon: 1,
  polyline: 1, rect: 1, g: 1, path: 1, text: 1 };

var svg = function (v) { return v.sel in svgPropsMap; };

// TODO: stop using extend here
var extend = function () {
  var objs = [], len = arguments.length;
  while ( len-- ) objs[ len ] = arguments[ len ];

  return __WEBPACK_IMPORTED_MODULE_0_extend___default.a.apply(void 0, [ true ].concat( objs ));
};

var assign = function () {
  var objs = [], len = arguments.length;
  while ( len-- ) objs[ len ] = arguments[ len ];

  return __WEBPACK_IMPORTED_MODULE_0_extend___default.a.apply(void 0, [ false ].concat( objs ));
};

var reduceDeep = function (arr, fn, initial) {
  var result = initial;
  for (var i = 0; i < arr.length; i++) {
    var value = arr[i];
    if (array(value)) {
      result = reduceDeep(value, fn, result);
    } else {
      result = fn(result, value);
    }
  }
  return result
};

var mapObject = function (obj, fn) { return Object.keys(obj).map(
  function (key) { return fn(key, obj[key]); }
).reduce(
  function (acc, curr) { return extend(acc, curr); },
  {}
); };

var deepifyKeys = function (obj, modules) { return mapObject(obj,
  function (key, val) {
    var dashIndex = key.indexOf('-');
    if (dashIndex > -1 && modules[key.slice(0, dashIndex)] !== undefined) {
      var moduleData = {};
      moduleData[key.slice(dashIndex + 1)] = val;
      return ( obj = {}, obj[key.slice(0, dashIndex)] = moduleData, obj )
      var obj;
    }
    return ( obj$1 = {}, obj$1[key] = val, obj$1 )
    var obj$1;
  }
); };



var omit = function (key, obj) { return mapObject(obj,
  function (mod, data) { return mod !== key ? (( obj = {}, obj[mod] = data, obj )) : {}
    var obj; }
); };

// Const fnName = (...params) => guard ? default : ...

var createTextElement = function (text$$1) { return !text(text$$1) ? undefined : {
  text: text$$1,
  sel: undefined,
  data: undefined,
  children: undefined,
  elm: undefined,
  key: undefined
}; };

var considerSvg = function (vnode$$1) { return !svg(vnode$$1) ? vnode$$1 :
  assign(vnode$$1,
    { data: omit('props', extend(vnode$$1.data,
      { ns: 'http://www.w3.org/2000/svg', attrs: omit('className', extend(vnode$$1.data.props,
        { class: vnode$$1.data.props ? vnode$$1.data.props.className : undefined }
      )) }
    )) },
    { children: undefinedv(vnode$$1.children) ? undefined :
      vnode$$1.children.map(function (child) { return considerSvg(child); })
    }
  ); };

var rewrites = {
  for: 'attrs',
  role: 'attrs',
  tabindex: 'attrs',
  'aria-*': 'attrs',
  key: null
};

var rewriteModules = function (data, modules) { return mapObject(data, function (key, val) {
  var inner = {};
  inner[key] = val;
  if (rewrites[key] && modules[rewrites[key]] !== undefined) {
    return ( obj = {}, obj[rewrites[key]] = inner, obj )
    var obj;
  }
  if (rewrites[key] === null) {
    return {}
  }
  var keys = Object.keys(rewrites);
  for (var i = 0; i < keys.length; i++) {
    var k = keys[i];
    if (k.charAt(k.length - 1) === '*' && key.indexOf(k.slice(0, -1)) === 0 && modules[rewrites[k]] !== undefined) {
      return ( obj$1 = {}, obj$1[rewrites[k]] = inner, obj$1 )
      var obj$1;
    }
  }
  if (modules[key] !== undefined) {
    return ( obj$2 = {}, obj$2[modules[key] ? modules[key] : key] = val, obj$2 )
    var obj$2;
  }
  if (modules.props !== undefined) {
    return { props: inner }
  }
  return inner
}); };

var sanitizeData = function (data, modules) { return considerSvg(rewriteModules(deepifyKeys(data, modules), modules)); };

var sanitizeText = function (children) { return children.length > 1 || !text(children[0]) ? undefined : children[0]; };

var sanitizeChildren = function (children) { return reduceDeep(children, function (acc, child) {
  var vnode$$1 = vnode(child) ? child : createTextElement(child);
  acc.push(vnode$$1);
  return acc
}
, []); };

var defaultModules = {
  attrs: '',
  props: '',
  class: '',
  data: 'dataset',
  style: '',
  hook: '',
  on: ''
};

var createElementWithModules = function (modules) {
  return function (sel, data) {
    var children = [], len = arguments.length - 2;
    while ( len-- > 0 ) children[ len ] = arguments[ len + 2 ];

    if (fun(sel)) {
      return sel(data || {}, children)
    }
    var text$$1 = sanitizeText(children, modules);
    return considerSvg({
      sel: sel,
      data: data ? sanitizeData(data, modules) : {},
      children: text$$1 ? undefined : sanitizeChildren(children),
      text: text$$1,
      elm: undefined,
      key: data ? data.key : undefined
    })
  }
};

var createElement = createElementWithModules(defaultModules);

var index = {
  createElement: createElement,
  createElementWithModules: createElementWithModules
};

/* harmony default export */ __webpack_exports__["default"] = (index);


/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export onDocumentReady */
/* harmony export (immutable) */ __webpack_exports__["h"] = searchAndInitialize;
/* harmony export (immutable) */ __webpack_exports__["b"] = clamp;
/* harmony export (immutable) */ __webpack_exports__["e"] = preventDefault;
/* harmony export (immutable) */ __webpack_exports__["f"] = remove;
/* harmony export (immutable) */ __webpack_exports__["c"] = find;
/* harmony export (immutable) */ __webpack_exports__["d"] = internetExplorerOrEdgeVersion;
/* harmony export (immutable) */ __webpack_exports__["g"] = scrollIntoView;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return animation; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);

/**
 * Calls the callback function when the document has been completely parsed.
 * @param {callback} value The callback function to execute.
 */
function onDocumentReady(callback) {
    function completed() {
        document.removeEventListener("DOMContentLoaded", completed, false);
        window.removeEventListener("load", completed, false);
        callback();
    }
    if (document.readyState === "complete") {
        setTimeout(callback);
    }
    else {
        document.addEventListener("DOMContentLoaded", completed, false);
        // A fallback to window.onload, that will always work
        window.addEventListener("load", completed, false);
    }
}
function searchAndInitialize(selector, callback, initSelector) {
    var e_1, _a;
    if (!callback) {
        throw new Error("The callback cannot be undefined");
    }
    var elements = document.querySelectorAll(selector);
    try {
        for (var elements_1 = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __values */])(elements), elements_1_1 = elements_1.next(); !elements_1_1.done; elements_1_1 = elements_1.next()) {
            var e = elements_1_1.value;
            var initElement = e;
            if (initSelector) {
                initElement = initSelector(e);
            }
            if (initElement.getAttribute("data-init") === "auto") {
                callback(e);
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (elements_1_1 && !elements_1_1.done && (_a = elements_1.return)) _a.call(elements_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
}
/**
 * Returns a number whose value is limited to the given range.
 *
 * Example: limit the output of this computation to between 0 and 255
 * Utils.clamp(number, 0, 255)
 *
 * @param {Number} value The number to clamp
 * @param {Number} min The lower boundary of the output range
 * @param {Number} max The upper boundary of the output range
 * @returns A number in the range [min, max]
 * @type Number
 */
function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
}
/**
 * A polyfill for Event.preventDefault().
 * @param {Event} event - The event to prevent the default action.
 */
function preventDefault(event) {
    if (event.preventDefault) {
        event.preventDefault();
    }
    else {
        event.returnValue = false;
    }
}
/**
 * A polyfill for Node.remove().
 * @param {Node} node - The node to remove.
 */
function remove(node) {
    if (!node || !node.parentNode) {
        return;
    }
    node.parentNode.removeChild(node);
}
/**
 * A simple polyfill for the Array.find() method.
 * @param {Array} array - The array to search in.
 * @param {function} expression - The expression to evaluate. Must return true if the element matches.
 */
function find(array, expression) {
    for (var i = 0; i < array.length; i++) {
        var item = array[i];
        if (expression(item) === true) {
            return item;
        }
    }
    return undefined;
}
/**
 * Checks the useragent and returns the Microsoft Internet Explorer / Edge version.
 * If another browser is detected 0 is returned.
 */
function internetExplorerOrEdgeVersion(userAgent) {
    if (userAgent === void 0) { userAgent = navigator.userAgent; }
    // handle IE and Edge
    var ieOrEdge = userAgent.search(/MSIE |Edge[/]/);
    if (ieOrEdge > 0) {
        return parseInt(userAgent.substring(ieOrEdge + 5, userAgent.indexOf(".", ieOrEdge)), 10);
    }
    // handle IE11
    if (userAgent.indexOf("Trident/") > 0) {
        var rv = userAgent.indexOf("rv:");
        return parseInt(userAgent.substring(rv + 3, userAgent.indexOf(".", rv)), 10);
    }
    return 0;
}
/**
 * Tries to move a child element to the top by scrolling the parent element, if it is not already fully visible.
 */
function scrollIntoView(child) {
    var parent = child.parentNode;
    var parentRect = parent.getBoundingClientRect();
    var childRect = child.getBoundingClientRect();
    var isFullyVisible = childRect.top >= parentRect.top &&
        childRect.bottom <= parentRect.top + parent.clientHeight;
    if (!isFullyVisible) {
        parent.scrollTop = childRect.top + parent.scrollTop - parentRect.top;
    }
}
// Note: this is a minified version of the webcomponent-helpers.ts' animation
// object. This exists because the legacy components cannot import modules from
// the Web Components.
var animation = {
    set: function (el, properties) {
        var targetProperties = Array.isArray(properties)
            ? properties[properties.length - 1]
            : properties;
        for (var key in targetProperties) {
            var value = targetProperties[key];
            if (typeof value === "string") {
                el.style[key] = value;
            }
        }
    },
    start: function (el, properties, duration, _a) {
        var _b = _a === void 0 ? {} : _a, _c = _b.delay, delay = _c === void 0 ? 0 : _c, _d = _b.finished, finished = _d === void 0 ? function () { return undefined; } : _d;
        el.getAnimations().forEach(function (animation) {
            animation.commitStyles();
            animation.cancel();
        });
        if (duration === 0) {
            animation.set(el, properties);
            finished();
            return;
        }
        el.animate(properties, {
            duration: duration,
            fill: "forwards",
            easing: "cubic-bezier(0.550, 0.085, 0.320, 1)",
            delay: delay,
        })
            .finished.then(function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            args[0].cancel();
            animation.set(el, properties);
            finished();
        })
            .catch(function () { return undefined; });
    },
};


/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DomFunctions__ = __webpack_require__(15);

var htmlEvents;
/**
 * A wrapper class for DOM Elements.
 */
var DomElement = /** @class */ (function () {
    /**
     * Creates a new instance.
     * @param {Element} - The element to wrap.
     * @param {String} - The DOM element to create.
     */
    function DomElement(element) {
        if (typeof element === "string") {
            this.element = document.createElement(element);
        }
        else {
            this.element = element;
        }
    }
    /**
     * Adds the specified CSS class to the element.
     * @param {String} - The class name to add.
     * @return {DomElement} Returns the current instance for fluent chaining of calls.
     */
    DomElement.prototype.addClass = function (name) {
        __WEBPACK_IMPORTED_MODULE_0__DomFunctions__["a" /* addClass */](this.element, name);
        return this;
    };
    /**
     * Removes the specified CSS class from the element.
     * @param {String} - The class name to remove.
     * @return {DomElement} Returns the current instance for fluent chaining of calls.
     */
    DomElement.prototype.removeClass = function (name) {
        __WEBPACK_IMPORTED_MODULE_0__DomFunctions__["h" /* removeClass */](this.element, name);
        return this;
    };
    DomElement.prototype.hasClass = function (name) {
        return __WEBPACK_IMPORTED_MODULE_0__DomFunctions__["e" /* hasClass */](this.element, name);
    };
    DomElement.prototype.toggleClass = function (name) {
        __WEBPACK_IMPORTED_MODULE_0__DomFunctions__["k" /* toggleClass */](this.element, name);
        return this;
    };
    Object.defineProperty(DomElement.prototype, "classes", {
        get: function () {
            return this.element.classList;
        },
        enumerable: false,
        configurable: true
    });
    DomElement.prototype.setId = function (id) {
        this.element.setAttribute("id", id);
        return this;
    };
    Object.defineProperty(DomElement.prototype, "innerText", {
        get: function () {
            return __WEBPACK_IMPORTED_MODULE_0__DomFunctions__["i" /* text */](this.element);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DomElement.prototype, "innerHtml", {
        get: function () {
            return this.element.innerHTML;
        },
        enumerable: false,
        configurable: true
    });
    DomElement.prototype.setHtml = function (value, allowStrongTag) {
        if (allowStrongTag === void 0) { allowStrongTag = false; }
        function sanitize(dangerousHtmlString) {
            // it's not possible to import _escape from lodash here because the "es2015" preset for babelify is needed
            var map = {
                "&": "&amp;",
                "<": "&lt;",
                ">": "&gt;",
                '"': "&quot;",
                "'": "&#x27;",
                "`": "&grave;",
                "/": "&#x2F;",
            };
            var reg = /[&<>"'`\/]/gi;
            return dangerousHtmlString.replace(reg, function (match) { return map[match]; });
        }
        if (typeof value !== "string") {
            throw new Error("Expected HTML string");
        }
        if (allowStrongTag) {
            var sanitizedValue = sanitize(value);
            sanitizedValue = sanitizedValue.replace("&lt;strong&gt;", "<strong>");
            sanitizedValue = sanitizedValue.replace("&lt;&#x2F;strong&gt;", "</strong>");
            this.element.innerHTML = sanitizedValue;
        }
        else {
            this.element.textContent = value;
        }
        return this;
    };
    DomElement.prototype.getAttribute = function (name) {
        return this.element.getAttribute(name);
    };
    DomElement.prototype.setAttribute = function (name, value) {
        this.element.setAttribute(name, value);
        return this;
    };
    /**
     * Registers an event listener.
     */
    DomElement.prototype.addEventListener = function (type, listener) {
        this.element.addEventListener(type, listener);
    };
    /**
     * Unregisters an event listener on the component.
     */
    DomElement.prototype.removeEventListener = function (type, listener) {
        this.element.removeEventListener(type, listener);
    };
    DomElement.prototype.appendChild = function (newChild) {
        if (!(newChild instanceof DomElement)) {
            throw new Error("Only other DomElements can be added as children");
        }
        this.element.appendChild(newChild.element);
        return this;
    };
    DomElement.prototype.prependChild = function (newChild) {
        if (!(newChild instanceof DomElement)) {
            throw new Error("Only other DomElements can be added as children");
        }
        this.element.insertBefore(newChild.element, this.element.firstChild);
        return this;
    };
    DomElement.prototype.insertBefore = function (newChild) {
        if (!(newChild instanceof DomElement)) {
            throw new Error("Only other DomElements can be added as children");
        }
        if (!this.element.parentNode) {
            throw new Error("Element is not attached");
        }
        this.element.parentNode.insertBefore(newChild.element, this.element);
        return this;
    };
    DomElement.prototype.insertAfter = function (newChild) {
        if (!(newChild instanceof DomElement)) {
            throw new Error("Only other DomElements can be added as children");
        }
        if (!this.element.parentNode) {
            throw new Error("Element is not attached");
        }
        this.element.parentNode.insertBefore(newChild.element, this.element.nextSibling);
        return this;
    };
    DomElement.prototype.removeChild = function (oldChild) {
        if (!(oldChild instanceof DomElement)) {
            throw new Error("Only a DomElements child can be removed");
        }
        this.element.removeChild(oldChild.element);
    };
    DomElement.prototype.find = function (selectors) {
        var e = this.element.querySelector(selectors);
        if (e) {
            return new DomElement(e);
        }
        return undefined;
    };
    DomElement.prototype.wrapWithElement = function (wrapperElement) {
        if (!this.element.parentNode) {
            throw new Error("Element is not attached");
        }
        this.element.parentNode.replaceChild(wrapperElement.element, this.element);
        wrapperElement.element.appendChild(this.element);
        return this;
    };
    DomElement.prototype.dispatchEvent = function (eventName) {
        var event;
        var el = this.element;
        if (document.createEvent) {
            event = document.createEvent("HTMLEvents");
            event.initEvent(eventName, true, true);
        }
        else if (document.createEventObject) {
            // IE < 9
            event = document.createEventObject();
            event.eventType = eventName;
        }
        event.eventName = eventName;
        if (el.dispatchEvent) {
            el.dispatchEvent(event);
        }
        else if (el.fireEvent && htmlEvents["on".concat(eventName)]) {
            // IE < 9
            ;
            el.fireEvent("on".concat(event.eventType), event); // can trigger only real event (e.g. 'click')
        }
        else if (el[eventName]) {
            ;
            el[eventName]();
        }
        else if (el["on".concat(eventName)]) {
            ;
            el["on".concat(eventName)]();
        }
    };
    DomElement.prototype.css = function (property) {
        return __WEBPACK_IMPORTED_MODULE_0__DomFunctions__["b" /* css */](this.element, property);
    };
    /**
     * Removes all child nodes of the current DomElement.
     */
    DomElement.prototype.empty = function () {
        __WEBPACK_IMPORTED_MODULE_0__DomFunctions__["c" /* empty */](this.element);
    };
    return DomElement;
}());
/* harmony default export */ __webpack_exports__["a"] = (DomElement);


/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DEFAULT_PRICE_REPRESENTATION", function() { return DEFAULT_PRICE_REPRESENTATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Price", function() { return Price; });
/* harmony export (immutable) */ __webpack_exports__["default"] = makePrice;
var DEFAULT_PRICE_REPRESENTATION = '—';
var ROUNDING_PRICE_SUFFIX = '–';
var Price = /** @class */ (function () {
    function Price(price) {
        if (price instanceof Price) {
            price = { value: price.value(), currencyIso: price.currency() };
        }
        this.price = price;
    }
    Price.prototype.value = function () {
        var value = this.price;
        if (value && typeof value === 'object') {
            value = value.value;
        }
        if (!value && value !== 0) {
            value = undefined;
        }
        return Number(value);
    };
    Price.prototype.isValid = function () {
        return this.value() > -1 && this.value() < Infinity;
    };
    /**
     * @method formatted
     * @param defaultValue value which will be returned for invalid price
     * @param withStar optional param used to describe format of cent value suffix '–' or '–*'
     * @return string
     */
    Price.prototype.formatted = function (defaultValue, withStar) {
        if (defaultValue === void 0) { defaultValue = DEFAULT_PRICE_REPRESENTATION; }
        if (!this.isValid()) {
            return defaultValue;
        }
        // Calculate in cents (whole integers) so the division by 5 does not cause rounding issues.
        var value = Math.round(this.value() * 100);
        // Round to 0.05, see https://jira.swisscom.com/browse/ECOMX-1502
        value = Math.round(Math.floor(value / 5) * 5);
        // Convert back to whole francs.
        value = value / 100;
        var priceParts = String(value || 0).split('.').slice(0, 2);
        priceParts[1] = (priceParts[1] || '').substr(0, 2);
        if (parseInt(priceParts[1] || '0', 10) === 0) {
            if (withStar) {
                priceParts[1] = ROUNDING_PRICE_SUFFIX + '*';
            }
            else {
                priceParts[1] = ROUNDING_PRICE_SUFFIX;
            }
        }
        else if (priceParts[1].length === 1) {
            priceParts[1] += '0';
        }
        return priceParts.join('.');
    };
    Price.prototype.currency = function () {
        if (this.price && typeof this.price === 'object') {
            return this.price.currencyIso || 'CHF';
        }
        return 'CHF';
    };
    // Allow usage in number contexts (calculations and such)
    Price.prototype.valueOf = function () {
        return this.value();
    };
    // Allow usage in string contexts (replacing, etc.)
    Price.prototype.toString = function () {
        return this.formatted();
    };
    // tslint:disable-next-line:strict-type-predicates
    Price.prototype[typeof Symbol !== 'undefined' && Symbol.toPrimitive || 'toPrimitive'] = function (hint) {
        switch (hint) {
            case 'string':
                return this.formatted();
            default:
            case 'default':
            case 'number':
                return this.value();
        }
    };
    return Price;
}());

function makePrice(price) {
    if (price instanceof Price) {
        return price;
    }
    return new Price(price);
}


/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["parseDate"] = parseDate;
/* harmony export (immutable) */ __webpack_exports__["upper"] = upper;
/* harmony export (immutable) */ __webpack_exports__["compareNumbers"] = compareNumbers;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Segment", function() { return Segment; });
/* harmony export (immutable) */ __webpack_exports__["pageSegment"] = pageSegment;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Language", function() { return Language; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Loadable", function() { return Loadable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Case", function() { return Case; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);


function parseDate(d) {
    return __WEBPACK_IMPORTED_MODULE_0_moment__(d, 'YYYY-MM-DDTHH:mm:ssZ').toDate();
}
function upper(str) {
    return String(str).toUpperCase();
}
/**
 * Compares numbers for sorting arrays ascending
 */
function compareNumbers(a, b) {
    return a - b;
}
var Segment;
(function (Segment) {
    Segment["RES"] = "res";
    Segment["SME"] = "sme";
    Segment["CBU"] = "cbu";
})(Segment || (Segment = {}));
function pageSegment() {
    var segment = String(__WEBPACK_IMPORTED_MODULE_1_jquery__(document.body).data('page-segment')).toLowerCase();
    switch (segment) {
        case Segment.SME:
        case Segment.RES:
            return segment;
        default:
            return undefined;
    }
}
var Language;
(function (Language) {
    Language["German"] = "de";
    Language["French"] = "fr";
    Language["Italian"] = "it";
    Language["English"] = "en";
})(Language || (Language = {}));
/**
 * Adds loaded and load methods for lazily-loaded components
 * @param loadFunction - the method doing the loading, must return a promise (most likely from $.ajax)
 * @param loadCallback - a callback that gets called when the promise has resolved, used to set correct state
 */
var Loadable = /** @class */ (function () {
    function Loadable() {
    }
    Loadable.prototype.loaded = function () {
        return !!this.loader && this.loader.state() === 'resolved';
    };
    Loadable.prototype.load = function () {
        var _this = this;
        if (this.jqPromise && this.jqPromise.state() !== 'rejected') {
            // Currently loading or sucessfully loaded => return promise
            return this.loader.promise();
        }
        // Either not yet loaded or already failed
        var deferred = __WEBPACK_IMPORTED_MODULE_1_jquery__["Deferred"]();
        this.jqPromise = this.loadFunction().done(function (t, u) {
            deferred.resolve(_this.loadCallback(t, u));
        });
        this.loader = deferred.promise();
        return this.loader;
    };
    return Loadable;
}());

var Case;
(function (Case) {
    Case["Retention"] = "RETENTION";
    Case["Activation"] = "ACTIVATION";
    Case["New"] = "NEW";
    Case["Renew"] = "RENEW";
    Case["Takeover"] = "TAKEOVER";
})(Case || (Case = {}));


/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = addClass;
/* harmony export (immutable) */ __webpack_exports__["h"] = removeClass;
/* harmony export (immutable) */ __webpack_exports__["e"] = hasClass;
/* harmony export (immutable) */ __webpack_exports__["k"] = toggleClass;
/* harmony export (immutable) */ __webpack_exports__["f"] = isHidden;
/* harmony export (immutable) */ __webpack_exports__["i"] = text;
/* harmony export (immutable) */ __webpack_exports__["g"] = parentWithClass;
/* harmony export (immutable) */ __webpack_exports__["j"] = textWidth;
/* harmony export (immutable) */ __webpack_exports__["b"] = css;
/* unused harmony export getAttributeReference */
/* harmony export (immutable) */ __webpack_exports__["d"] = getRootElement;
/* harmony export (immutable) */ __webpack_exports__["c"] = empty;
function addClass(element, name) {
    if (typeof name !== "string") {
        throw new Error("Expected string class name");
    }
    element.classList.add(name);
}
function removeClass(element, name) {
    if (typeof name !== "string") {
        throw new Error("Expected string class name");
    }
    element.classList.remove(name);
}
function hasClass(element, name) {
    if (typeof name !== "string") {
        throw new Error("Expected string class name");
    }
    return element.classList.contains(name);
}
function toggleClass(element, name) {
    if (typeof name !== "string") {
        throw new Error("Expected string class name");
    }
    element.classList.toggle(name);
}
/**
 * Determines if the given element is hidden from view.
 * @param {Element} Element The dom element to check.
 * @param {boolean} includeParents If set to `true` searches up the DOM and checks parent visibility as well. Defaults to `false`.
 */
function isHidden(element, includeParents) {
    if (includeParents === void 0) { includeParents = false; }
    if (includeParents === false) {
        var style = window.getComputedStyle(element);
        return style.display === "none" || element.offsetLeft < 0;
    }
    var result;
    while ((result = isHidden(element, false)) === false &&
        element.parentElement) {
        element = element.parentElement;
    }
    return result;
}
/**
 * Gets the text of an element an makes sure this works on all browsers.
 */
function text(element) {
    return element.textContent || element.innerText;
}
function parentWithClass(element, className) {
    var current = element;
    while (!hasClass(current, className) && current.parentElement) {
        current = current.parentElement;
    }
    if (hasClass(current, className)) {
        return current;
    }
    return undefined;
}
function textWidth(text, font) {
    var canvas = document.createElement("canvas");
    var context = canvas.getContext("2d");
    context.font = font;
    var metrics = context.measureText(text);
    return Math.round(metrics.width);
}
function css(element, property) {
    return window.getComputedStyle(element).getPropertyValue(property);
}
/**
 * Gets the single element referenced in an items data-* attribute.
 * @param {DomElement} element - The element containing the reference attribute.
 * @param {string} attribute - The name of the reference attribute.
 * @returns {DomElement} The referenced element; or `undefined` if the reference is invalid
 * or the attribute could not be found.
 */
function getAttributeReference(element, attribute) {
    var attrValue = element.getAttribute(attribute);
    if (!attrValue || attrValue === "") {
        return undefined;
    }
    return document.querySelector(attrValue);
}
/**
 * Gets the document root element (normally the body element)
 * If the document uses a sdx-container wrapper this is returned instead.
 * @returns {Element} The root dom element.
 */
function getRootElement() {
    var element = document.querySelector(".sdx-container");
    if (!element) {
        element = document.body;
    }
    return element;
}
/**
 * Removes all child nodes from the provided element.
 * @param {Element} element The Dom element
 */
function empty(element) {
    while (element.firstChild) {
        element.removeChild(element.firstChild);
    }
}


/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = simpleSubscribe;
/* unused harmony export INITIAL_CHANNEL_NAME */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SUBSCRIPTION_TYPES; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lib_vendor_terrific_Module__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lib_util_array__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lib_util_url__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lib_util_helpers__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Product__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Subscription__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lib_vendor_jquery_deparam_patched__ = __webpack_require__(8);










/**
 * Streamlines the process of subscribing a module to a product data hub.
 *
 * Writes the following properties to the module:
 *  • messageProductDataHub: Method for sending arbitrary messages on the hub’s channel.
 *  • requestProductData: A method that tells the hub to send new data to the callback
 *  • updateProductDataStatus: A method that sets the updated status on the hub
 *  • onInvalidateProductData: Internal handler for channel messages.
 *                             Not to be used directly. Overridden if already existing.
 *
 * @param {(function|string)} cb the callback/method name which is called with the data
 */
function simpleSubscribe(module, callback) {
    var mod = module;
    var cb = __WEBPACK_IMPORTED_MODULE_2_jquery___default.a.proxy(typeof callback === 'string' ?
        mod[callback] :
        // tslint:disable-next-line:no-unbound-method
        (callback || mod.onInvalidateProductData || __WEBPACK_IMPORTED_MODULE_2_jquery___default.a.noop), mod);
    mod.sandbox.subscribe(INITIAL_CHANNEL_NAME, mod);
    // Add proxy requestProductData method
    mod.requestProductData = __WEBPACK_IMPORTED_MODULE_2_jquery___default.a.noop;
    // Add proxy updateProductDataStatus method which sets flag to update status ASAP
    var updateImmediate = false;
    mod.updateProductDataStatus = function updateProductDataStatus() {
        updateImmediate = arguments;
    };
    // Fire the subscribe message on the initial channel.
    mod.fire('subscribeForProductData', {
        element: mod.$ctx,
        subscribe: function (channel, productDataAlreadyLoaded) {
            // The EcommerceProductDataHub that feels itself responsible for the given module…
            // …will answer and send us the name of its channel, to which we will then subscribe.
            mod.sandbox.unsubscribe(INITIAL_CHANNEL_NAME, mod);
            function messageProductDataHub(message, data) {
                mod.fire(message, data, [channel]);
            }
            mod.messageProductDataHub = messageProductDataHub;
            // Main handler for product info (initial and on status changes)
            // tslint:disable-next-line:no-unbound-method
            var existingOnInvalidateProductData = mod.onInvalidateProductData;
            mod.onInvalidateProductData = function onInvalidateProductData(data) {
                cb(data.info, data.origin);
                if (existingOnInvalidateProductData) {
                    existingOnInvalidateProductData.call(this, data);
                }
            };
            if (mod.productDataChannel) {
                mod.sandbox.unsubscribe(mod.productDataChannel, mod);
            }
            mod.productDataChannel = channel;
            // Subscribe to the given channel
            mod.sandbox.subscribe(mod.productDataChannel, mod);
            // Manual refresh trigger
            function requestProductData(status) {
                messageProductDataHub('getInfo', {
                    callback: cb,
                    status: status,
                });
            }
            mod.requestProductData = requestProductData;
            // Status update trigger
            function updateProductDataStatus(status, origin) {
                origin = origin || Object(__WEBPACK_IMPORTED_MODULE_6_lib_util_helpers__["getUniqueIdOfElement"])(mod.$ctx);
                messageProductDataHub('updateStatus', { origin: origin, status: status });
            }
            mod.updateProductDataStatus = updateProductDataStatus;
            // Trigger immediate status update
            if (updateImmediate) {
                mod.updateProductDataStatus.apply(mod, updateImmediate);
            }
            // If component was lazy loaded, request initialization data from data hub.
            if (productDataAlreadyLoaded && !updateImmediate) {
                requestProductData();
            }
        },
    }, [INITIAL_CHANNEL_NAME]);
}
/**
 * Helper function to remove duplicates from key-text object list as used with (dropdown) filters.
 *
 * @method removeDuplicates
 * @param {Object} list
 * @return {Array} an array of {value, …} objects.
 */
function removeDuplicates(list) {
    var map = {};
    return list.map(function (item) {
        map[item.value] = item;
        return item.value;
    }).filter(__WEBPACK_IMPORTED_MODULE_4_lib_util_array__["a" /* onlyUnique */]).map(function (value) {
        return map[value];
    });
}
/**
 * Map and reduce warranties object
 *
 * @method mapVariantsToWarranties
 * @return {Object} warranties
 */
function mapVariantsToWarranties(warrantyInfo) {
    var mapping = warrantyInfo.__mapping || {};
    var result = {};
    Object.keys(mapping).forEach(function (key) {
        var warrantyId = mapping[key];
        if (warrantyId in warrantyInfo) {
            var warranty = warrantyInfo[warrantyId];
            result[key] = { price: warranty.price, guaranteePeriod: warranty.guaranteePeriod };
        }
    });
    return result;
}
// Initial channel where all dependent modules register their subscriptions
var INITIAL_CHANNEL_NAME = 'EcommerceProductDataHub';
var INTERACTIVE_CONTAINER_CHANNEL_NAME = 'BCInteractiveMode';
/**
 * List of possible status properties
 */
var STATUS_PROPERTIES = ['subscriptionId', 'subscriptionDuration', 'subscriptionType', 'color', 'memory'];
/**
 * List of possible subscription types
 */
var SUBSCRIPTION_TYPES;
(function (SUBSCRIPTION_TYPES) {
    SUBSCRIPTION_TYPES["createNew"] = "new";
    SUBSCRIPTION_TYPES["retention"] = "retention";
    SUBSCRIPTION_TYPES["without"] = "without";
})(SUBSCRIPTION_TYPES || (SUBSCRIPTION_TYPES = {}));
var PREFIX_FILTER_NAME = 'filter-';
var w = window;
/**
 * Subscribes to channels: [EcommerceProductDataHub, BCInteractiveMode]
 * Listens to channel events: [SubscribeForProductData, UpdateStatus, GetFilters, GetInfo, InteractiveStateChanged]
 * Triggers channel events:
 *     startProductDataSubscription,
 *     invalidateProductData,
 *     disableMemorySizes,
 *     interactiveStateChanged
 *
 * @namespace Tc.Module
 * @class EcommerceProductDataHub
 * @extends Tc.Module
 */
var EcommerceProductDataHub = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */])(EcommerceProductDataHub, _super);
    function EcommerceProductDataHub() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isEditMode = __WEBPACK_IMPORTED_MODULE_2_jquery___default()(document.body).hasClass('cq_isEditMode');
        _this.isMobile = __WEBPACK_IMPORTED_MODULE_2_jquery___default()(document.body).hasClass('is-mobile');
        _this.isResponsibleForPage = false;
        _this.supportsHistoryApi = false;
        _this.texts = {};
        _this.initialized = false;
        return _this;
    }
    EcommerceProductDataHub.prototype.on = function (callback) {
        var _this = this;
        this.channel = INITIAL_CHANNEL_NAME + Object(__WEBPACK_IMPORTED_MODULE_6_lib_util_helpers__["getUniqueIdOfElement"])(this.$ctx);
        this.segment = (__WEBPACK_IMPORTED_MODULE_2_jquery___default()(document.body).data('page-segment') || '').toLowerCase() === __WEBPACK_IMPORTED_MODULE_3__util__["Segment"].SME
            ? __WEBPACK_IMPORTED_MODULE_3__util__["Segment"].SME : __WEBPACK_IMPORTED_MODULE_3__util__["Segment"].RES;
        this.isResponsibleForPage = this.isResponsibleFor(__WEBPACK_IMPORTED_MODULE_2_jquery___default()(document.body));
        this.supportsHistoryApi = !this.isEditMode && this.isResponsibleForPage && !!w.history && !!w.history.replaceState;
        var subscriptionId = this.$ctx.data('initial-subscription-id') ?
            this.$ctx.data('initial-subscription-id').split('|') : [];
        var subscriptionType = subscriptionId[0] === __WEBPACK_IMPORTED_MODULE_8__Subscription__["b" /* SIMPLE_PAY_DUMMY_SUBSCRIPTION */] ?
            SUBSCRIPTION_TYPES.without : SUBSCRIPTION_TYPES.createNew;
        this.defaults = {
            freetext: '',
            productId: this.$ctx.data('initial-product-id'),
            subscriptionDuration: this.$ctx.data('initial-subscription-duration') || 24,
            subscriptionId: subscriptionId,
            subscriptionType: subscriptionType,
        };
        this.texts = {};
        [].slice.call(this.$ctx[0].attributes)
            .filter(function (attr) { return attr.name.toLowerCase().indexOf('data-txt-') === 0; })
            .forEach(function (attr) {
            _this.texts[attr.name.substring('data-txt-'.length).toLowerCase()] = attr.value;
        });
        this.initProductFamily();
        if (this.productFamily.getConfigError()) {
            this.log.error('Product data is incorrectly configured.', this.productFamily.getConfigError());
        }
        if (this.supportsHistoryApi) {
            this.initRewriteUrl(w.location.href);
        }
        if (this.isResponsibleForPage) {
            this.applyDeepLinking();
        }
        this.initStatus();
        this.sandbox.subscribe(INITIAL_CHANNEL_NAME, this);
        if (this.isResponsibleForPage) {
            this.sandbox.subscribe(INTERACTIVE_CONTAINER_CHANNEL_NAME, this);
        }
        this.sandbox.subscribe(this.channel, this);
        this.fire('startProductDataSubscription', [INITIAL_CHANNEL_NAME]);
        callback();
    };
    EcommerceProductDataHub.prototype.after = function () {
        this.onUpdateStatus({});
        this.initialized = true;
    };
    /**
     * Initializes the product family
     *
     * @method initProductFamily
     * @return void
     */
    EcommerceProductDataHub.prototype.initProductFamily = function () {
        var json = this.$ctx.data('json');
        var variants = this.$ctx.data('variants');
        var overrides = this.$ctx.data('overrides') || {};
        var featureGroups = this.$ctx.data('feature-groups') || {};
        var bestseller = this.$ctx.attr('data-bestsellers') || '';
        var warranties = this.$ctx.data('warranties') || {};
        this.productFamily = new __WEBPACK_IMPORTED_MODULE_7__Product__["a" /* Family */](json, variants, this.segment, featureGroups, bestseller, this.texts, mapVariantsToWarranties(warranties));
        this.productFamily.setOverrides(overrides);
        if (this.debug) {
            this._json = json;
            this._variants = variants;
            this._overrides = overrides;
        }
    };
    /**
     * Initializes the current status
     *
     * @method initStatus
     * @return void
     */
    EcommerceProductDataHub.prototype.initStatus = function () {
        var product = this.productFamily.getProductById(this.defaults.productId);
        if (!product && this.productFamily.getProducts().length > 0) {
            product = this.productFamily.getProducts()[0];
        }
        this.currentStatus = this.currentStatus || {};
        var subscriptionId = null;
        if (!Array.isArray(this.defaults.subscriptionId)) {
            this.defaults.subscriptionId = [this.defaults.subscriptionId];
        }
        var subscriptions = product && product.getSubscriptions();
        if (subscriptions) {
            var subscriptionValid = function (id) { return subscriptions.contains(id); };
            // Find the first of our default subscriptions, if exists
            subscriptionId = this.defaults.subscriptionId.filter(subscriptionValid)[0] || null;
        }
        // Init filters
        this.getFilters();
        var filters = this.filters;
        // Fall back on first configured subscription
        if (!subscriptionId && filters.subscriptionId.length) {
            subscriptionId = filters.subscriptionId[0].value;
        }
        var subscriptionDuration = this.defaults.subscriptionDuration;
        // Subscription exists but not with given duration
        if (subscriptionId && subscriptions && !subscriptions.contains(subscriptionId, subscriptionDuration)) {
            subscriptionDuration = subscriptions.getMaxDuration(subscriptionId) || 0;
        }
        this.currentStatus = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, (this.currentStatus || {})), {
            color: product ? product.getColor() : null,
            dimension: product && product.getDetails().getDimension() ? product.getDetails().getDimension().getValue() : null,
            memory: product ? product.getMemory() : null,
            quantity: 1,
            subscriptionDuration: subscriptionDuration,
            subscriptionId: subscriptionId,
            subscriptionType: this.defaults.subscriptionType || null,
        });
    };
    /**
     * Parse URL for deep linking, overwrite mod.default values
     * Examples: .../<familyAlias>(<freetext>;<aboID>,<aboDuration>,<productID>).html
     * .../<familyAlias>(<productID>).html
     * .../<familyAlias>(<aboID>,<aboDuration>,<productID>).html
     */
    EcommerceProductDataHub.prototype.applyDeepLinking = function () {
        var patt = /\((.*)\)(.*).html/;
        var urlContent;
        var arr;
        var str;
        var filters;
        var url = decodeURIComponent(w.location.href);
        var hashParams = window.location.hash.slice(1);
        var parameters = Object(__WEBPACK_IMPORTED_MODULE_9_lib_vendor_jquery_deparam_patched__["default"])(hashParams);
        this.log('applyDeepLinking > uri', url, patt.test(url), parameters);
        if (!patt.test(url)) {
            return;
        }
        urlContent = patt.exec(url);
        if (!urlContent || urlContent.length < 2) {
            return;
        }
        arr = urlContent[1].split(';');
        str = arr[0];
        if (arr.length > 1) {
            // Found freetext
            this.defaults.freetext = arr[0] + ';';
            str = arr[1];
        }
        var data = str.split(',');
        if (data.length === 1) {
            this.defaults.productId = data[0];
        }
        else if (data.length === 3) {
            filters = this.getFilters();
            // Check if subscription ID is valid
            if (filters.subscriptionId.find(function (id) { return id.value === data[0]; })) {
                this.defaults.subscriptionId = data[0];
            }
            // Check if subscription duration is valid
            if (filters.subscriptionDuration.find(function (duration) { return String(duration.value) === data[1]; })) {
                this.defaults.subscriptionDuration = data[1];
            }
            this.defaults.productId = data[2];
        }
        // If the user gets redirected from login to the #retention case, preset filter accordingly
        if (typeof parameters.retention !== 'undefined') {
            if (!this.isMobile) {
                this.defaults.subscriptionId = SUBSCRIPTION_TYPES.retention;
            }
            this.defaults.subscriptionType = SUBSCRIPTION_TYPES.retention;
            this.defaults.subscriptionDuration = '';
        }
    };
    // See Tc.Module.RetentionDisplay.js and Tc.Module.RetentionResult.ts
    EcommerceProductDataHub.prototype.onRemoveHashParameter = function (param) {
        if (!this.rewriteUrlParser) {
            return;
        }
        var url = this.rewriteUrlParser.href;
        this.rewriteUrlParser.href = Object(__WEBPACK_IMPORTED_MODULE_5_lib_util_url__["removeHashParameterFromUrl"])(url, param);
    };
    /**
     * Initializes data for rewrite url
     * @param {string} url
     */
    EcommerceProductDataHub.prototype.initRewriteUrl = function (url) {
        this.rewriteUrlParser = document.createElement('a');
        var canonicalHref = __WEBPACK_IMPORTED_MODULE_2_jquery___default()('link[rel=canonical]').attr('href');
        if (canonicalHref) {
            this.rewriteUrlParser.href = canonicalHref;
            this.canonicalPathName = this.rewriteUrlParser.pathname.split(/.html\/?/)[0];
        }
        this.rewriteUrlParser.href = url;
        var pathnameArr = this.rewriteUrlParser.pathname.split(/.html\/?/);
        this.rewriteUrlParser.suffix = '';
        if (pathnameArr.length > 1 && pathnameArr[1]) {
            this.rewriteUrlParser.suffix = '/' + pathnameArr[1];
        }
        this.rewriteUrlParser.pathNameOnly = pathnameArr[0].split('(')[0];
        var selectorsArr = pathnameArr[0].replace(/\(.*\)/, '').split('.');
        selectorsArr.shift();
        selectorsArr = __WEBPACK_IMPORTED_MODULE_2_jquery___default.a.grep(selectorsArr, function (a) { return a !== ''; });
        this.rewriteUrlParser.selectors = '';
        if (selectorsArr.length > 0) {
            this.rewriteUrlParser.selectors = '.' + selectorsArr.join('.');
        }
        if (!this.canonicalPathName) {
            this.canonicalPathName = this.rewriteUrlParser.pathNameOnly;
        }
        // Fix for IE 11
        if (this.canonicalPathName.substring(0, 1) !== '/') {
            this.canonicalPathName = '/' + this.canonicalPathName;
        }
        // Prevent jquery mobile from reloading the page on the popstate event
        __WEBPACK_IMPORTED_MODULE_2_jquery___default()(w).on('popstate', function (event) { return event.preventDefault(); });
    };
    /**
     * Create deep link for info.product
     * @param {Object} info
     * @param {Object} info.product
     * @returns {string} the deeplink or ''
     */
    EcommerceProductDataHub.prototype.getDeeplink = function (info) {
        var product = info.product;
        if (!product) {
            return '';
        }
        var hasSubscription = product.canHaveSubscriptions() &&
            !!this.currentStatus.subscriptionId &&
            !!this.currentStatus.subscriptionDuration;
        var subscriptionInfo = '';
        if (hasSubscription) {
            subscriptionInfo = [
                this.currentStatus.subscriptionId,
                this.currentStatus.subscriptionDuration,
            ]
                .filter(Boolean)
                .map(String)
                .map(encodeURIComponent)
                .join(',');
        }
        return "(" + this.defaults.freetext + subscriptionInfo + "," + product.getId() + ")";
    };
    /**
     * Prepare rewrite URL
     * @param {string} deeplink
     * @returns {string} the URL
     */
    EcommerceProductDataHub.prototype.getRewriteUrl = function (deeplink) {
        // tslint:disable-next-line:prefer-template
        return this.canonicalPathName +
            deeplink +
            this.rewriteUrlParser.selectors +
            '.html' +
            this.rewriteUrlParser.suffix +
            this.rewriteUrlParser.search +
            this.rewriteUrlParser.hash;
    };
    /**
     * Rewrite URL in address
     *
     * @param {Object} info
     * @param {Object} info.product
     * @affects {string} mod.currentStatus.deeplink
     * @affects {string} mod.currentStatus.url
     * @affects {string} info.deeplink
     * @affects {string} info.url
     */
    EcommerceProductDataHub.prototype.rewriteUrl = function (info) {
        // Dev mode: disable rewrite if requested
        if ((this.debug && document.location.hash.indexOf('disableUrlRewrite') > -1) ||
            __WEBPACK_IMPORTED_MODULE_2_jquery___default()(document.body).is('.cq-wcm-edit') ||
            location.host === 'localhost:4502') {
            this.log('rewriteUrl > disabled');
            return;
        }
        var product = info.product;
        if (!product) {
            return;
        }
        var deeplink = this.getDeeplink(info);
        var url = this.getRewriteUrl(deeplink);
        this.log('rewriteUrl > uri: ', url);
        w.history.replaceState({}, '', url);
        // Update currentStatus
        this.currentStatus = this.currentStatus || {};
        Object.assign(this.currentStatus, { deeplink: deeplink, url: url });
        // Update info
        Object.assign(info, { deeplink: deeplink, url: url });
    };
    /**
     * Retrieve a product based on the given status. If no status is given, take the currently active one.
     *
     * @method getProduct
     * @param {Object} [status] - The status of the product. May be left undefined.
     * @return {?Object} The found product or null if none is found.
     */
    EcommerceProductDataHub.prototype.getProduct = function (status) {
        status = status || this.currentStatus;
        return this.productFamily.getProductByFilter(status.color || undefined, status.memory || undefined, status.dimension || undefined);
    };
    /**
     * Gets the information about a product based on the combination of the given
     * and currently active status.
     *
     * @method getInfo
     * @param {Object} status - The status for which to get the information for.
     * @return {Object} The information for the given status
     */
    EcommerceProductDataHub.prototype.getInfo = function (requestedStatus) {
        if (requestedStatus === void 0) { requestedStatus = {}; }
        var status = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, this.currentStatus), requestedStatus);
        var product = this.getProduct(status);
        return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, status), { deepLink: status.deepLink || false, family: this.productFamily, product: product || undefined, url: status.url || false });
    };
    /**
     * Checks if the hub component is responsible for the given dom element.
     *
     * @method isResponsibleFor
     * @param {jQuery} element - The element to check
     * @return {Boolean} True if this component is responsible for the element, false otherwise.
     */
    EcommerceProductDataHub.prototype.isResponsibleFor = function ($element) {
        var containerSelector = '.product-data-hub-container, body';
        if ($element) {
            return $element.closest(containerSelector).has(this.$ctx[0]).length > 0 &&
                (this.$ctx.closest(containerSelector).has($element[0]).length > 0 ||
                    this.$ctx.closest(containerSelector).is($element));
        }
        return false;
    };
    /**
     * @callback productDataCallback
     * @param {string} channel - name of the channel
     * @param {Boolean} initialized - product data already loaded?
     */
    /**
     * Channel listener which decides if this hub component is responsible for the calling module and
     * notifies the callers about which channel they should use to communicate with this component.
     *
     * @method onSubscribeForProductData
     * @param {Object} data
     * @param {jQuery} data.element - the calling DOM container
     * @param {productDataCallback} data.subscribe - the callback function
     * @return void
     */
    EcommerceProductDataHub.prototype.onSubscribeForProductData = function (data) {
        if (this.isResponsibleFor(data.element)) {
            data.subscribe(this.channel, this.initialized);
        }
    };
    /**
     * Channel listener which gets called when the status has changed.
     * Notifies other modules which have registered to this component about the data changes.
     *
     * @method onUpdateStatus
     * @param {Object} data
     * @param {string} data.origin - id of the calling module
     * @param {Object} data.status - the new status properties
     * @return {Object} info
     */
    EcommerceProductDataHub.prototype.onUpdateStatus = function (data) {
        __WEBPACK_IMPORTED_MODULE_2_jquery___default.a.extend(this.currentStatus, data.status);
        var origin = data.origin;
        if (!this.isMobile) {
            if (this.currentStatus.subscriptionId && this.currentStatus.subscriptionId !== SUBSCRIPTION_TYPES.retention) {
                if (this.currentStatus.subscriptionType !== SUBSCRIPTION_TYPES.createNew) {
                    this.currentStatus.subscriptionType = SUBSCRIPTION_TYPES.createNew;
                }
            }
            else if (this.currentStatus.subscriptionId === SUBSCRIPTION_TYPES.retention) {
                this.currentStatus.subscriptionType = SUBSCRIPTION_TYPES.retention;
            }
            else if (this.currentStatus.subscriptionType === SUBSCRIPTION_TYPES.createNew) {
                var defaultSubscriptionId = this.defaults.subscriptionId || null;
                if (Array.isArray(defaultSubscriptionId)) {
                    defaultSubscriptionId = defaultSubscriptionId[0];
                }
                this.currentStatus.subscriptionId = defaultSubscriptionId;
            }
        }
        var info = this.getInfo();
        var propertiesForNextProduct = ['memory', 'dimension'];
        while (!info.product && propertiesForNextProduct.length) {
            // Product does not exist, search for the first one available by resetting memory or dimension sizes to the default
            this.selectNextExistingProductBasedOnProperty(propertiesForNextProduct.shift());
            info = this.getInfo();
            origin = Object(__WEBPACK_IMPORTED_MODULE_6_lib_util_helpers__["getUniqueIdOfElement"])(this.$ctx);
        }
        if (!info.product) {
            this.log.error('No variant available to fall back on, got:', info, 'requested:', data, this.productFamily.getId());
            return undefined;
        }
        if (info.subscriptionId &&
            !info.product.getSubscriptions().get(info.subscriptionId, info.subscriptionDuration || undefined)) {
            // If the subscription does not exist in the previously selected duration, default to the max duration
            this.currentStatus.subscriptionDuration = info.product.getSubscriptions().getMaxDuration(info.subscriptionId || undefined);
            info = this.getInfo();
        }
        if (this.supportsHistoryApi) {
            this.rewriteUrl(info);
        }
        this.fire('invalidateProductData', {
            info: info,
            origin: origin,
        }, [this.channel]);
        this.updateInteractiveContainers();
        return info;
    };
    /**
     * Selects the next existing product by changing the given product property.
     *
     * @method selectNextExistingProductBasedOnProperty
     * @param {String} propertyName - Product property name which should be changed
     * @return void
     */
    EcommerceProductDataHub.prototype.selectNextExistingProductBasedOnProperty = function (propertyName) {
        var filter = this.getFilters()[propertyName];
        var startingValue = this.currentStatus[propertyName];
        var lastValidStatus = null;
        for (var _i = 0, filter_1 = filter; _i < filter_1.length; _i++) {
            var f = filter_1[_i];
            var status = {};
            status[propertyName] = f.value;
            var info = this.getInfo(status);
            if (info.product) {
                lastValidStatus = status;
                if (String(startingValue) === f.value) {
                    break;
                }
            }
        }
        if (lastValidStatus) {
            Object.assign(this.currentStatus, lastValidStatus);
        }
    };
    /**
     * Checks if a specific filter should be disabled based on the availability status
     * of the product and notifies the calling module.
     *
     * @method onGetFilterStates
     * @return void
     */
    EcommerceProductDataHub.prototype.onGetFilterStates = function (data) {
        var _this = this;
        if (!this.filters || !this.filters[data.filterName]) {
            return;
        }
        var filters = this.filters[data.filterName];
        var awaited = filters.map(function (filter) { return filter.value; }).map(function (filter) {
            var _a;
            var status = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, _this.currentStatus), (_a = {}, _a[data.filterName] = filter, _a));
            var product = _this.getProduct(status);
            var deferred = __WEBPACK_IMPORTED_MODULE_2_jquery___default.a.Deferred();
            if (product) {
                var availability_1 = product.getAvailability();
                var resolve = function () {
                    // Resolve with data we need once availability info is loaded
                    // If this is in a failure callback, isAvailable will simply be false
                    deferred.resolve({ filter: filter, exists: true, isAvailable: availability_1.isActionable() });
                };
                // Resolve both in success and error case
                // tslint:disable-next-line:no-floating-promises
                availability_1.load().done(resolve).fail(resolve);
            }
            else {
                // Product does not exist for the size requested, resolve immediately
                deferred.resolve({ filter: filter, exists: false });
            }
            return deferred.promise();
        });
        // tslint:disable-next-line:no-floating-promises
        __WEBPACK_IMPORTED_MODULE_2_jquery___default.a.when.apply(__WEBPACK_IMPORTED_MODULE_2_jquery___default.a, awaited).done(function () {
            var infos = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                infos[_i] = arguments[_i];
            }
            // Called when we have existance/availability info for all products
            var result = {
                disableValues: [],
                hideValues: [],
            };
            infos.forEach(function (info) {
                if (!info.exists) {
                    result.hideValues.push(info.filter);
                }
                else if (!info.isAvailable) {
                    result.disableValues.push(info.filter);
                }
            });
            try {
                data.callback(result);
            }
            catch (err) {
                _this.log('Probably issue with ecommerce service, json response is empty object', err);
            }
        });
    };
    /**
     * Returns the subscription durations based on currently selected subscription
     *
     * @method onGetSubscriptionDurations
     * @return void
     */
    EcommerceProductDataHub.prototype.onGetSubscriptionDurations = function (data) {
        var _this = this;
        var filters = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, this.filters);
        var product = this.getProduct();
        var subscriptionDurations = (product && product.getSubscriptions().getDurations(this.currentStatus.subscriptionId || undefined) || [])
            .map(function (duration) {
            return { value: String(duration), text: duration + " " + _this.texts.months };
        });
        if (subscriptionDurations.length) {
            filters.subscriptionDuration = subscriptionDurations;
        }
        data.callback(filters);
    };
    /**
     * @callback filtersCallback
     * @param {Object} filters - the filters
     */
    /**
     * Initializes all filters and notifies calling modules about them.
     *
     * @method onGetFilters
     * @param {Object} data
     * @param {filtersCallback} data.callback - function to be called to notify the calling module
     * @return void
     */
    EcommerceProductDataHub.prototype.onGetFilters = function (data) {
        data.callback(this.getFilters());
    };
    EcommerceProductDataHub.prototype.getFilters = function () {
        var _this = this;
        var products = this.productFamily.getProducts();
        var colors = [];
        var memory = [];
        var subscriptionType = [];
        var dimension = [];
        var subscriptionDuration = [];
        var subscriptionTextValueList = [];
        if (this.filters) {
            return this.filters;
        }
        for (var _i = 0, products_1 = products; _i < products_1.length; _i++) {
            var product = products_1[_i];
            if (product.getColor()) {
                colors.push({ value: product.getColor(), text: product.getColorText() || '' });
            }
            if (product.getMemory()) {
                memory.push({ value: product.getMemory(), text: product.getMemoryText() });
            }
            if (product.getDetails().getDimension()) {
                dimension.push({
                    text: product.getDetails().getDimension().getValueFormatted(),
                    value: product.getDetails().getDimension().getValue(),
                });
            }
            if (!product.getSubscriptions()) {
                continue;
            }
            subscriptionDuration.push.apply(subscriptionDuration, (product.getSubscriptions().getDurations() || [])
                .map(function (duration) {
                return {
                    text: duration + " " + _this.texts.months,
                    value: String(duration),
                };
            }));
            subscriptionTextValueList.push.apply(subscriptionTextValueList, product.getSubscriptions().getTextValueList());
        }
        subscriptionType.push({
            text: this.texts.newsubscription,
            value: SUBSCRIPTION_TYPES.createNew,
        });
        subscriptionType.push({
            text: this.texts.extendsubscription,
            value: SUBSCRIPTION_TYPES.retention,
        });
        subscriptionType.push({
            text: this.texts.nosubscription,
            value: SUBSCRIPTION_TYPES.without,
        });
        this.filters = {
            color: removeDuplicates(colors),
            dimension: removeDuplicates(dimension),
            memory: removeDuplicates(memory),
            subscriptionDuration: removeDuplicates(subscriptionDuration),
            subscriptionId: removeDuplicates(subscriptionTextValueList.sort(__WEBPACK_IMPORTED_MODULE_8__Subscription__["d" /* compareSubscriptions */])),
            subscriptionType: removeDuplicates(subscriptionType),
        };
        this.filters.memory.sort(function (a, b) {
            return Object(__WEBPACK_IMPORTED_MODULE_3__util__["compareNumbers"])(Number(a.value), Number(b.value));
        });
        return this.filters;
    };
    /**
     * Get detail data and notifies calling modules about them.
     *
     * @method onGetDetails
     * @return void
     */
    EcommerceProductDataHub.prototype.onGetDetails = function (data) {
        // FIXME NEC: Loading details is no longer an async call
        data.callback(this.getProduct().getDetails());
    };
    /**
     * @callback infoCallback
     * @param {Object} info - the info
     */
    /**
     * Channel listener to notify calling modules about the requested status.
     *
     * @method onGetInfo
     * @param {Object} data
     * @param {Object} data.status - status for which to get the info
     * @param {infoCallback} data.callback - function to be called to notify the calling module
     * @return void
     */
    EcommerceProductDataHub.prototype.onGetInfo = function (data) {
        if (data.callback) {
            data.callback(this.getInfo(data.status));
        }
    };
    /**
     * Notifies possibly listening interactive containers about the changed status values.
     *
     * @method updateInteractiveContainers
     * @return void
     */
    EcommerceProductDataHub.prototype.updateInteractiveContainers = function () {
        if (this.isResponsibleForPage) {
            for (var name in this.currentStatus) {
                this.fire('updateInteractiveState', {
                    name: PREFIX_FILTER_NAME + name,
                    origin: INTERACTIVE_CONTAINER_CHANNEL_NAME,
                    value: this.currentStatus[name],
                }, [INTERACTIVE_CONTAINER_CHANNEL_NAME]);
            }
        }
    };
    /**
     * Channel listener which gets called when an interactive container gets active.
     * Checks if a valid status value was changed and updates its status based on it.
     *
     * @method onInteractiveStateChanged
     * @param {Object} data
     * @param {string} data.name - name of the changed property
     * @param {string} data.value - value of the changed property
     * @param {string} [data.origin] - undefined if fired by Tc.Module.BackgroundContainer
     * @return void
     */
    EcommerceProductDataHub.prototype.onInteractiveStateChanged = function (data) {
        var _a;
        if (data.origin !== INTERACTIVE_CONTAINER_CHANNEL_NAME &&
            data.name && data.name.indexOf(PREFIX_FILTER_NAME) === 0 &&
            __WEBPACK_IMPORTED_MODULE_2_jquery___default.a.inArray(data.name.substring(PREFIX_FILTER_NAME.length), STATUS_PROPERTIES) >= 0) {
            if (this.currentStatus.subscriptionType === SUBSCRIPTION_TYPES.createNew) {
                var statusKey = data.name.substring(PREFIX_FILTER_NAME.length);
                this.onUpdateStatus({
                    origin: INTERACTIVE_CONTAINER_CHANNEL_NAME,
                    status: (_a = {},
                        _a[statusKey] = data.value,
                        _a),
                });
            }
        }
    };
    EcommerceProductDataHub.simpleSubscribe = simpleSubscribe;
    return EcommerceProductDataHub;
}(__WEBPACK_IMPORTED_MODULE_1_lib_vendor_terrific_Module__["a" /* Module */]));
/* harmony default export */ __webpack_exports__["b"] = (EcommerceProductDataHub);


/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = onlyUnique;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return unique; });
/* unused harmony export flatten */
/**
 * For removing duplicate items from an array
 * Guarantees the original order of all non-duplicated items
 * Usage: [1, 2, 1].filter(onlyUnique)
 */
function onlyUnique(value, index, self) {
    return Array.prototype.indexOf.call(self, value) === index;
}
/**
 * Uniquifies an entire array, with no guarantees as to ordering
 * @param arr the array to make unique
 */
var unique = function (arr) {
    return arr.filter(onlyUnique);
};
// Fast-path version for modern browsers
if ('Set' in window && 'from' in Array && (new Set([1])).size) {
    // IE 11 supports set and Array.from but not initializing a set with a pre-existing array.
    unique = function (arr) {
        return Array.from(new Set(arr));
    };
}

function flatten(arr) {
    var _a;
    return (_a = []).concat.apply(_a, arr);
}


/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["init"] = init;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Utils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DomElement__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Inputs__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__DomFunctions__ = __webpack_require__(15);





var CLASS_PLACEHOLDER = "select__placeholder";
var CLASS_THUMB = "select__thumb";
var CLASS_BUTTON = "select__button";
var CLASS_DROPDOWN = "select__dropdown";
var CLASS_OPEN = "select--open";
var CLASS_CLOSED = "select--closed";
var CLASS_DISABLED = "select--disabled";
var CLASS_FILTERABLE = "select--filterable";
var CLASS_ITEM = "dropdown-item";
var CLASS_ITEM_SELECTED = "dropdown-item--selected";
var CLASS_ITEM_FOCUSED = "dropdown-item--focused";
var CLASS_ITEM_DISABLED = "dropdown-item--disabled";
var CLASS_GROUP_ITEM = "dropdown-group";
var CLASS_GROUP_HEADER = "dropdown-group__item";
var QUERY_MESSAGE = ".message";
var TIMEOUT_CLOSE = 150;
var TIMEOUT_BLUR = 400;
/**
 * The select component API.
 */
var Select = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */])(Select, _super);
    function Select(element) {
        var _this = _super.call(this, element) || this;
        // Minimum filter length
        _this._minFilterLength = 2;
        // The options the Select was initially created upon
        // These will be used as a basis for filtering
        _this._initialOptions = Array.prototype.slice.call(_this.element.children);
        _this._openByFocus = false;
        // Check for multi-selection
        _this._multiselection = _this.element.hasAttribute("multiple") === true;
        // Setup event context
        _this._clickHandler = _this._handleClick.bind(_this);
        _this._handleDropdownClick = _this._handleClick.bind(_this);
        _this._keydownHandler = _this._handleKeydown.bind(_this);
        _this._focusHandler = _this._handleFocus.bind(_this);
        _this._blurHandler = _this._handleBlur.bind(_this);
        _this._windowClickHandler = _this._handleWindowClick.bind(_this);
        _this._filterKeydownHandler = _this._handleFilterKeydown.bind(_this);
        _this._filterKeyupHandler = _this._handleFilterKeyup.bind(_this);
        _this._filterFocusHandler = _this._handleFilterFocus.bind(_this);
        _this._initialize();
        return _this;
    }
    /**
     * Initializes the select component.
     *
     * This method inspects the select definition and its options and
     * generates new stylable DOM elements around the original select-element
     * definitions.
     * @private
     */
    Select.prototype._initialize = function () {
        var e_1, _a;
        var selectedOption = this.element.querySelector("option[selected]");
        var firstOption = this.element.querySelector("option");
        // Per default, set the last selected option to either the option with a "selected" attribute,
        // or, if not found, to the first available option
        this._lastSelectedOption = selectedOption || firstOption;
        this._wrapperElement = new __WEBPACK_IMPORTED_MODULE_2__DomElement__["a" /* default */](this.element.parentElement).addClass(CLASS_CLOSED);
        try {
            for (var _b = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __values */])(this.classes), _c = _b.next(); !_c.done; _c = _b.next()) {
                var cls = _c.value;
                this._wrapperElement.addClass(cls);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        this._dropdownElement = new __WEBPACK_IMPORTED_MODULE_2__DomElement__["a" /* default */]("div").addClass(CLASS_DROPDOWN);
        if (Object(__WEBPACK_IMPORTED_MODULE_1__Utils__["d" /* internetExplorerOrEdgeVersion */])() > 0 &&
            Object(__WEBPACK_IMPORTED_MODULE_1__Utils__["d" /* internetExplorerOrEdgeVersion */])() < 12) {
            // This is a workaround for IE browsers 11 and earlier where focusing
            // a scrollable dropdown list will close the dropdown prematurely.
            this._dropdownElement.element.addEventListener("mousedown", function (event) { return event.preventDefault(); });
        }
        this._setupTarget();
        this._setupPlaceholder();
        this._wrapperElement.appendChild(this._dropdownElement);
        this._createOptions(this.element);
        this._updateSize();
        this._updateMessage();
        if (this.element.disabled) {
            this.disable();
        }
        else {
            this.enable();
        }
    };
    Select.prototype._setupTarget = function () {
        // move the id from the select element to the wrapper
        var id = this.element.getAttribute("id");
        if (id) {
            this.element.removeAttribute("id");
            this._wrapperElement.setAttribute("id", id);
        }
        // Apply the tab index
        var tabIndex = this.element.getAttribute("tabindex");
        if (tabIndex) {
            this._wrapperElement.setAttribute("tabIndex", tabIndex);
        }
    };
    Select.prototype._setupPlaceholder = function () {
        var _this = this;
        if (!this._selectButtonElement) {
            this._selectButtonElement = new __WEBPACK_IMPORTED_MODULE_2__DomElement__["a" /* default */]("div").addClass(CLASS_BUTTON);
            this._wrapperElement.appendChild(this._selectButtonElement);
        }
        if (!this._thumbElement) {
            this._thumbElement = new __WEBPACK_IMPORTED_MODULE_2__DomElement__["a" /* default */]("div").addClass(CLASS_THUMB);
            var thumbIcon = new __WEBPACK_IMPORTED_MODULE_2__DomElement__["a" /* default */]("div").addClass("thumb-icon");
            var loader = new __WEBPACK_IMPORTED_MODULE_2__DomElement__["a" /* default */]("div")
                .addClass("loader-spinner")
                .addClass("loader-spinner--small");
            this._thumbElement.appendChild(loader);
            this._thumbElement.appendChild(thumbIcon);
            this._selectButtonElement.appendChild(this._thumbElement);
        }
        var placeholderText = "";
        this._placeholderOption =
            this.element.querySelector("option[selected][disabled]") || undefined;
        if (this._placeholderOption) {
            placeholderText = __WEBPACK_IMPORTED_MODULE_4__DomFunctions__["i" /* text */](this._placeholderOption);
            if (this._multiselection === true) {
                this._placeholderOption.selected = false;
            }
        }
        var selectedOption = this.element.querySelector("option[selected]:not([disabled])");
        if (selectedOption) {
            placeholderText = __WEBPACK_IMPORTED_MODULE_4__DomFunctions__["i" /* text */](selectedOption);
        }
        if (!this._placeholderElement) {
            // When the Select is filterable, create an "input" as the placeholder element, otherwise a "span"
            if (this._isFilterable()) {
                this._placeholderElement = new __WEBPACK_IMPORTED_MODULE_2__DomElement__["a" /* default */]("input");
                this._placeholderElement.addEventListener("keyup", function (e) {
                    return _this._handleFilterKeyup(e);
                });
                this._placeholderElement.addEventListener("keydown", function (e) {
                    return _this._handleFilterKeydown(e);
                });
                this._placeholderElement.addEventListener("focus", function (e) {
                    return _this._handleFilterFocus(e);
                });
            }
            else {
                this._placeholderElement = new __WEBPACK_IMPORTED_MODULE_2__DomElement__["a" /* default */]("span");
            }
            this._placeholderElement.addClass(CLASS_PLACEHOLDER);
            this._selectButtonElement.appendChild(this._placeholderElement);
        }
        this._setPlaceholder(placeholderText);
        this._placeholderText = placeholderText;
        if (selectedOption && selectedOption !== this._placeholderOption) {
            this._updatePlaceholder(true);
        }
    };
    Select.prototype._updateMessage = function () {
        var messageNode = this._wrapperElement.element.querySelector(QUERY_MESSAGE);
        if (messageNode !== null) {
            this._wrapperElement.appendChild(new __WEBPACK_IMPORTED_MODULE_2__DomElement__["a" /* default */](messageNode));
        }
    };
    Select.prototype._isOptGroup = function (element) {
        return element.tagName.toUpperCase() === "OPTGROUP";
    };
    Select.prototype._isOption = function (element) {
        return element.tagName.toUpperCase() === "OPTION";
    };
    Select.prototype._createOptions = function (element) {
        for (var i = 0; i < element.children.length; i++) {
            var child = element.children[i];
            if (this._isOptGroup(child)) {
                this._appendGroup(child);
            }
            if (this._isOption(child)) {
                var option = this._createOption(child);
                if (option) {
                    this._dropdownElement.appendChild(option);
                }
            }
        }
    };
    Select.prototype._createOption = function (option) {
        var html = option.innerHTML; // code is already parsed at this moment
        if (this._activeFilter) {
            var escapedActiveFilter = this._activeFilter.replace(/[-\\^$*+?.()|[\]{}]/g, "\\$&");
            html = html.replace(new RegExp("(".concat(escapedActiveFilter, ")"), "gi"), "<strong>$1</strong>");
        }
        var opt = new __WEBPACK_IMPORTED_MODULE_2__DomElement__["a" /* default */]("div").addClass(CLASS_ITEM).setHtml(html, true);
        if (option.selected) {
            opt.addClass(CLASS_ITEM_SELECTED);
        }
        if (option.disabled) {
            opt.addClass(CLASS_ITEM_DISABLED);
        }
        if (!this._isPlaceholder(option)) {
            opt.setAttribute("data-value", option.value);
            return opt;
        }
        return undefined;
    };
    Select.prototype._appendGroup = function (optgroup) {
        var e_2, _a;
        var label = optgroup.getAttribute("label");
        var group = new __WEBPACK_IMPORTED_MODULE_2__DomElement__["a" /* default */]("div").addClass(CLASS_GROUP_ITEM);
        var groupHeader = new __WEBPACK_IMPORTED_MODULE_2__DomElement__["a" /* default */]("div")
            .addClass(CLASS_GROUP_HEADER)
            .setHtml(label);
        group.appendChild(groupHeader);
        var options = optgroup.querySelectorAll("option");
        try {
            for (var options_1 = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __values */])(options), options_1_1 = options_1.next(); !options_1_1.done; options_1_1 = options_1.next()) {
                var entry = options_1_1.value;
                var option = this._createOption(entry);
                if (option) {
                    group.appendChild(option);
                }
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (options_1_1 && !options_1_1.done && (_a = options_1.return)) _a.call(options_1);
            }
            finally { if (e_2) throw e_2.error; }
        }
        this._dropdownElement.appendChild(group);
        return group;
    };
    Select.prototype._updateSize = function () {
        var e_3, _a;
        // Note: Mirroring the DOM and measuring the items using their clientWidth was very
        // unreliable, therefore measuring was switched to the new HTML5 measureText method
        // margins and paddings arround the text are copied from the original placeholder items
        // dimension
        var placeholderStyle = window.getComputedStyle(this._placeholderElement.element);
        var paddingRight = parseFloat(placeholderStyle.paddingRight);
        var paddingLeft = parseFloat(placeholderStyle.paddingLeft);
        var font = this._placeholderElement.css("font");
        var textWidth = __WEBPACK_IMPORTED_MODULE_4__DomFunctions__["j" /* textWidth */](this._placeholderText, font);
        var maxWidth = paddingLeft + paddingRight + textWidth;
        var options = this._wrapperElement.element.querySelectorAll(".".concat(CLASS_ITEM));
        try {
            for (var options_2 = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __values */])(options), options_2_1 = options_2.next(); !options_2_1.done; options_2_1 = options_2.next()) {
                var entry = options_2_1.value;
                var width = __WEBPACK_IMPORTED_MODULE_4__DomFunctions__["j" /* textWidth */](__WEBPACK_IMPORTED_MODULE_4__DomFunctions__["i" /* text */](entry), font) + paddingLeft + paddingRight;
                if (width > maxWidth) {
                    maxWidth = width;
                }
            }
        }
        catch (e_3_1) { e_3 = { error: e_3_1 }; }
        finally {
            try {
                if (options_2_1 && !options_2_1.done && (_a = options_2.return)) _a.call(options_2);
            }
            finally { if (e_3) throw e_3.error; }
        }
    };
    Select.prototype._isButtonTarget = function (target) {
        return (target === this._wrapperElement.element ||
            target === this._placeholderElement.element ||
            target === this._selectButtonElement.element ||
            target === this._thumbElement.element);
    };
    Select.prototype._isDropdownTarget = function (target) {
        var current = target;
        while (current !== this._dropdownElement.element && current.parentElement) {
            current = current.parentElement;
        }
        return current === this._dropdownElement.element;
    };
    /**
     * Updates the UI if the selection has changed and makes sure the
     * select control and the generated markup are synchronized.
     * @private
     */
    Select.prototype._selectedItemChanged = function (newItem, autoClose, multiselect) {
        var _this = this;
        if (autoClose === void 0) { autoClose = true; }
        if (multiselect === void 0) { multiselect = false; }
        var oldItems = this._dropdownElement.element.querySelectorAll(".".concat(CLASS_ITEM_SELECTED));
        if (!newItem) {
            setTimeout(function () { return _this.close(); }, TIMEOUT_CLOSE);
            return;
        }
        if (__WEBPACK_IMPORTED_MODULE_4__DomFunctions__["e" /* hasClass */](newItem, CLASS_ITEM_DISABLED)) {
            return;
        }
        if (oldItems.length === 0 && !newItem) {
            throw new Error("Can not select undefined elements");
        }
        var oldItem = oldItems[0];
        if (multiselect === true) {
            oldItem = Object(__WEBPACK_IMPORTED_MODULE_1__Utils__["c" /* find */])(oldItems, function (x) {
                return x.getAttribute("data-value") === newItem.getAttribute("data-value");
            });
        }
        var isDeselect = false;
        if (newItem && oldItem && oldItem === newItem) {
            // Click on a previously selected element -> deselect
            isDeselect = true;
            if (!this._placeholderOption && !multiselect) {
                // If there is no placeholder option, non multiselect options cannot be deselected
                return;
            }
            delete this._lastSelectedOption;
        }
        if (oldItem) {
            // Remove selection on the element
            var oldValue_1 = oldItem.getAttribute("data-value");
            var optElement = Object(__WEBPACK_IMPORTED_MODULE_1__Utils__["c" /* find */])(this.element.options, function (x) { return !x.disabled && x.value === oldValue_1; });
            if (!optElement) {
                throw new Error("The option with value ".concat(oldValue_1, " does not exist"));
            }
            // Unset Select value
            optElement.selected = false;
            __WEBPACK_IMPORTED_MODULE_4__DomFunctions__["h" /* removeClass */](oldItem, CLASS_ITEM_SELECTED);
        }
        if (!isDeselect) {
            // Select an option
            // Select a new item
            var newValue_1 = newItem.getAttribute("data-value");
            var optElement = Object(__WEBPACK_IMPORTED_MODULE_1__Utils__["c" /* find */])(this.element.options, function (x) { return !x.disabled && x.value === newValue_1; });
            if (!optElement) {
                throw new Error("The option with value ".concat(newValue_1, " does not exist"));
            }
            // Set Select value
            optElement.selected = true;
            __WEBPACK_IMPORTED_MODULE_4__DomFunctions__["a" /* addClass */](newItem, CLASS_ITEM_SELECTED);
            // Preserve selection
            this._lastSelectedOption = optElement;
        }
        else {
            // Deselect an option
            // Keep track of falling back to the placeholder (if any)
            if (this._placeholderOption) {
                this._lastSelectedOption = this._placeholderOption;
            }
        }
        var hasSelectedItems = true;
        if (this._multiselection === false && isDeselect) {
            // Handle no selection for non-multiselect states
            this._placeholderOption.selected = true;
            hasSelectedItems = false;
        }
        if (this._multiselection === true &&
            this._getSelectedOptions().length === 0) {
            hasSelectedItems = false;
        }
        // Reset the filter if filterable
        if (this._activeFilter) {
            this._clearFilter();
        }
        this._updatePlaceholder(hasSelectedItems);
        // Dispatch the changed event
        this.dispatchEvent("change");
        if (autoClose && !multiselect) {
            setTimeout(function () {
                _this.close();
            }, TIMEOUT_CLOSE);
        }
    };
    Select.prototype._updatePlaceholder = function (hasSelectedItems) {
        var e_4, _a;
        var text = this._placeholderOption ? __WEBPACK_IMPORTED_MODULE_4__DomFunctions__["i" /* text */](this._placeholderOption) : " ";
        if (hasSelectedItems === true) {
            var selectedItems = this._getSelectedOptions();
            if (selectedItems.length > 0) {
                text = "";
                try {
                    for (var selectedItems_1 = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __values */])(selectedItems), selectedItems_1_1 = selectedItems_1.next(); !selectedItems_1_1.done; selectedItems_1_1 = selectedItems_1.next()) {
                        var item = selectedItems_1_1.value;
                        text += "".concat(__WEBPACK_IMPORTED_MODULE_4__DomFunctions__["i" /* text */](item), ", ");
                    }
                }
                catch (e_4_1) { e_4 = { error: e_4_1 }; }
                finally {
                    try {
                        if (selectedItems_1_1 && !selectedItems_1_1.done && (_a = selectedItems_1.return)) _a.call(selectedItems_1);
                    }
                    finally { if (e_4) throw e_4.error; }
                }
                text = text.substring(0, text.length - 2);
            }
        }
        this._setPlaceholder(text);
    };
    Select.prototype._getSelectedOptions = function () {
        var selectedOptions = [];
        if (this.element.options) {
            ;
            [].forEach.call(this.element.options, function (option) {
                if (option.selected && !option.disabled) {
                    selectedOptions.push(option);
                }
            });
        }
        return selectedOptions;
    };
    /**
     * Clone all of the initially set options (and optgroups) and returns them in a new array.
     * This serves as the basis for filtering. If a filter is present, it will be respected.
     */
    Select.prototype.getInitialOptions = function () {
        var filter = this._activeFilter || "";
        var filtered = [];
        var initialOptions = this._initialOptions;
        for (var i = 0; i < initialOptions.length; i++) {
            var child = initialOptions[i];
            if (this._isOptGroup(child)) {
                // handle <optgroup>
                var optGroupClone = child.cloneNode(false);
                var found = false;
                for (var j = 0; j < child.children.length; j++) {
                    var optionClone = child.children[j].cloneNode(true);
                    // Append on match
                    if (this._containsWord(optionClone.innerHTML, filter)) {
                        optGroupClone.appendChild(optionClone);
                        found = true;
                    }
                }
                // Push if any matches found
                if (found) {
                    filtered.push(optGroupClone);
                }
            }
            else if (this._isOption(child)) {
                // handle <option>
                var optionClone = child.cloneNode(true);
                // Push on match
                if (this._containsWord(optionClone.innerHTML, filter)) {
                    filtered.push(optionClone);
                }
            }
        }
        return filtered;
    };
    /**
     * Returns true if a text contains a given keyword, e.g. in "ca" in "Car"
     */
    Select.prototype._containsWord = function (text, keyword) {
        return text.toLowerCase().indexOf(keyword.toLowerCase()) > -1;
    };
    Select.prototype._handleFocus = function () {
        var _this = this;
        this.open();
        this._openByFocus = true;
        setTimeout(function () {
            _this._openByFocus = false;
        }, TIMEOUT_BLUR);
    };
    Select.prototype._handleBlur = function () {
        this.close();
    };
    Select.prototype._handleClick = function (event) {
        var handled = false;
        if (this._lastHandledEvent === event) {
            this._lastHandledEvent = undefined;
            return;
        }
        if (this._isButtonTarget(event.target) && this._openByFocus === false) {
            // handle header item clicks and toggle dropdown
            this.toggle();
            handled = true;
        }
        var newItem = event.target;
        if (!handled && __WEBPACK_IMPORTED_MODULE_4__DomFunctions__["e" /* hasClass */](newItem, CLASS_ITEM)) {
            // handle clicks on dropdown items
            this._selectedItemChanged(newItem, true, this._multiselection);
            handled = true;
        }
        if (handled) {
            this._lastHandledEvent = event;
            Object(__WEBPACK_IMPORTED_MODULE_1__Utils__["e" /* preventDefault */])(event);
        }
    };
    Select.prototype._handleWindowClick = function (event) {
        if (this._isDropdownTarget(event.target) ||
            this._isButtonTarget(event.target)) {
            return;
        }
        this.close();
    };
    Select.prototype._focusOptionStartingWith = function (keycode, startIndex, options) {
        for (var index = startIndex; index < options.length; index++) {
            var item = new __WEBPACK_IMPORTED_MODULE_2__DomElement__["a" /* default */](options[index]);
            var value = item.innerText.toLowerCase();
            if (index > options.length) {
                index = 0;
            }
            if (value.startsWith(__WEBPACK_IMPORTED_MODULE_3__Inputs__["j" /* getKeyValue */](keycode))) {
                var newOption = new __WEBPACK_IMPORTED_MODULE_2__DomElement__["a" /* default */](options[index]);
                if (!newOption.hasClass(CLASS_ITEM_DISABLED)) {
                    Object(__WEBPACK_IMPORTED_MODULE_1__Utils__["g" /* scrollIntoView */])(options[index]);
                    newOption.addClass(CLASS_ITEM_FOCUSED);
                    return newOption;
                }
            }
        }
        return undefined;
    };
    Select.prototype._handleKeydown = function (event) {
        var keyboardEvent = event;
        var evt = keyboardEvent || window.event;
        var keycode = keyboardEvent.which || keyboardEvent.keyCode;
        if (keycode === __WEBPACK_IMPORTED_MODULE_3__Inputs__["f" /* KEY_ESCAPE */]) {
            // handle Escape key (ESC)
            if (this.isOpen()) {
                this.close();
            }
            evt.preventDefault();
            return;
        }
        if (keycode === __WEBPACK_IMPORTED_MODULE_3__Inputs__["d" /* KEY_ARROW_UP */] || keycode === __WEBPACK_IMPORTED_MODULE_3__Inputs__["a" /* KEY_ARROW_DOWN */]) {
            // Up and down arrows
            var options = this._wrapperElement.element.querySelectorAll(".".concat(CLASS_ITEM));
            if (options.length > 0) {
                var newIndex = 0;
                var oldOption = void 0;
                var focusedElement = this._wrapperElement.find(".".concat(CLASS_ITEM_FOCUSED));
                var searchFor = focusedElement
                    ? CLASS_ITEM_FOCUSED
                    : CLASS_ITEM_SELECTED;
                var newElement = void 0;
                for (var index = 0; index < options.length; index++) {
                    var direction = keycode === __WEBPACK_IMPORTED_MODULE_3__Inputs__["a" /* KEY_ARROW_DOWN */] ? 1 : -1;
                    var item = new __WEBPACK_IMPORTED_MODULE_2__DomElement__["a" /* default */](options[index]);
                    // search for selected or focusedElement elements
                    if (item.hasClass(searchFor)) {
                        oldOption = item;
                        newIndex = index;
                        // get the next not disabled element in the appropriate direction
                        for (var count = 0; count < options.length; count++) {
                            newIndex += direction;
                            newIndex %= options.length;
                            if (newIndex < 0) {
                                newIndex = options.length - 1;
                            }
                            newElement = new __WEBPACK_IMPORTED_MODULE_2__DomElement__["a" /* default */](options[newIndex]);
                            if (!newElement.hasClass(CLASS_ITEM_DISABLED)) {
                                break;
                            }
                        }
                    }
                }
                // set the new element focused
                Object(__WEBPACK_IMPORTED_MODULE_1__Utils__["g" /* scrollIntoView */])(options[newIndex]);
                var newOption = new __WEBPACK_IMPORTED_MODULE_2__DomElement__["a" /* default */](options[newIndex]);
                newOption.addClass(CLASS_ITEM_FOCUSED);
                if (oldOption) {
                    oldOption.removeClass(CLASS_ITEM_FOCUSED);
                }
            }
            evt.preventDefault();
            return;
        }
        if (__WEBPACK_IMPORTED_MODULE_3__Inputs__["j" /* getKeyValue */](keycode) && !this._isFilterable()) {
            // Keyboard keys
            var options = this._wrapperElement.element.querySelectorAll(".".concat(CLASS_ITEM));
            if (options.length > 0) {
                var oldFocusIndex = 0;
                var hasFocusedOption = false;
                for (var index = 0; index < options.length; index++) {
                    var item = new __WEBPACK_IMPORTED_MODULE_2__DomElement__["a" /* default */](options[index]);
                    if (item.hasClass(CLASS_ITEM_FOCUSED)) {
                        item.removeClass(CLASS_ITEM_FOCUSED);
                        var value = item.innerText.toLowerCase();
                        if (value.startsWith(__WEBPACK_IMPORTED_MODULE_3__Inputs__["j" /* getKeyValue */](keycode))) {
                            hasFocusedOption = true;
                            oldFocusIndex = index;
                        }
                    }
                }
                var newOption = this._focusOptionStartingWith(keycode, hasFocusedOption ? oldFocusIndex + 1 : 0, options);
                if (newOption === undefined) {
                    this._focusOptionStartingWith(keycode, 0, options);
                }
            }
            evt.preventDefault();
            return;
        }
        if (keycode === __WEBPACK_IMPORTED_MODULE_3__Inputs__["e" /* KEY_ENTER */] || keycode === __WEBPACK_IMPORTED_MODULE_3__Inputs__["i" /* KEY_TAB */]) {
            // Handle enter and tab key by selecting the currently focused element
            var newItem = this._dropdownElement.element.querySelector(".".concat(CLASS_ITEM_FOCUSED));
            this._selectedItemChanged(newItem, true, this._multiselection);
        }
    };
    /**
     * Fired when the user presses a key in the filter field
     */
    Select.prototype._handleFilterKeydown = function (e) {
        var keyboardEvent = e;
        var keycode = keyboardEvent.which || keyboardEvent.keyCode;
        // If the user hits the enter key while filtering and there's a single match, select it
        if (keycode === __WEBPACK_IMPORTED_MODULE_3__Inputs__["e" /* KEY_ENTER */]) {
            var dropdownElements = this._dropdownElement.element.querySelectorAll(".".concat(CLASS_ITEM));
            if (dropdownElements.length === 1) {
                this._selectedItemChanged(dropdownElements[0], true, this._multiselection);
                e.stopPropagation();
            }
        }
    };
    /**
     * Fired when the user releases a key in the filter field
     */
    Select.prototype._handleFilterKeyup = function (e) {
        var target = e.target;
        // Filter has changed
        if (target.value !== this._activeFilter &&
            target.value !== this._placeholderText &&
            target.value !== this._lastSelectedOption.innerHTML) {
            this._setFilter(target.value);
        }
    };
    /**
     * Fired when the user focusses the filter input field
     */
    Select.prototype._handleFilterFocus = function (e) {
        var target = e.target;
        setTimeout(function () {
            target.select();
        });
    };
    /**
     * Filters the Select by a given filter keyword
     * @param filter Keyword to filter by
     */
    Select.prototype._setFilter = function (filter) {
        if (filter === void 0) { filter = ""; }
        this._activeFilter = filter.length >= this._minFilterLength ? filter : "";
        this.setOptions(this.getInitialOptions());
    };
    /**
     * Resets the filter
     */
    Select.prototype._clearFilter = function () {
        delete this._activeFilter;
        this.setOptions(this.getInitialOptions());
    };
    /**
     * Set new content and reload the Select
     * @param elements Array of new option (or optgroup) elements to display
     */
    Select.prototype.setOptions = function (options) {
        var _this = this;
        this._emptyNode(this.element);
        options.forEach(function (option) {
            _this.element.appendChild(option);
        });
        // Preserve selected value if the selected
        this.element.value = this._lastSelectedOption.value;
        this.reload();
    };
    /**
     * Clear all children of a given node
     * @param node Node
     */
    Select.prototype._emptyNode = function (node) {
        while (node.firstChild) {
            node.removeChild(node.firstChild);
        }
    };
    /**
     * Returns whether an option is a placeholder option
     */
    Select.prototype._isPlaceholder = function (option) {
        return option.hasAttribute("disabled") && option.hasAttribute("selected");
    };
    /**
     * Update placeholder value
     * @param text Content of the placeholder
     */
    Select.prototype._setPlaceholder = function (text) {
        if (this._placeholderElement && text) {
            if (this._isFilterable()) {
                ;
                this._placeholderElement.element.value = text;
            }
            else {
                this._placeholderElement.setHtml(text);
            }
        }
    };
    Object.defineProperty(Select.prototype, "value", {
        /**
         * Gets the value of the currently selected option.
         * If multiple selection is enabled this property returns an array of values.
         */
        get: function () {
            if (this._multiselection) {
                return this._getSelectedOptions().map(function (x) { return x.value; });
            }
            if (this.element.value === "") {
                return null;
            }
            return this.element.value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Select.prototype, "disabled", {
        /**
         * Enables or disables the select component depending on the
         * 'value' parameter.
         * @param {value} If true disables the control; false enables it.
         */
        set: function (value) {
            if (value) {
                this.disable();
            }
            else {
                this.enable();
            }
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Reloads the dropdown's option data definitions from the DOM and updates
     * the generated dropdown display items.
     */
    Select.prototype.reload = function () {
        // Remove all existing child elements
        this._emptyNode(this._dropdownElement.element);
        if (this._activeFilter === undefined) {
            // If the user is filtering, let the placeholder "input" alive
            this._setupPlaceholder();
        }
        this._createOptions(this.element);
        this._updateSize();
        this._updateMessage();
        if (!this._isFilterable()) {
            this._updatePlaceholder(!!this.value);
        }
    };
    /**
     * Sets the select control to the enabled state.
     */
    Select.prototype.enable = function () {
        this.element.removeAttribute("disabled");
        this._wrapperElement.removeClass(CLASS_DISABLED);
        window.addEventListener("click", this._windowClickHandler);
        this._wrapperElement.element.addEventListener("click", this._clickHandler);
        this._wrapperElement.element.addEventListener("keydown", this._keydownHandler);
        this._wrapperElement.element.addEventListener("focus", this._focusHandler);
        this._wrapperElement.element.addEventListener("blur", this._blurHandler);
    };
    /**
     * Sets the select control to the disabled state.
     */
    Select.prototype.disable = function () {
        this.element.setAttribute("disabled", "");
        this._wrapperElement.addClass(CLASS_DISABLED);
        window.removeEventListener("click", this._windowClickHandler);
        this._wrapperElement.element.removeEventListener("click", this._clickHandler);
        this._wrapperElement.element.removeEventListener("keydown", this._keydownHandler);
        this._wrapperElement.element.removeEventListener("focus", this._focusHandler);
        this._wrapperElement.element.removeEventListener("blur", this._blurHandler);
        this.close();
    };
    /**
     * Toggles the open/closed state of the select dropdown.
     */
    Select.prototype.toggle = function () {
        if (this.isOpen()) {
            this.close();
        }
        else {
            this.open();
        }
    };
    /**
     * Gets if the select dropdown is open or closed.
     * @return {boolean} True if open; otherwise false.
     */
    Select.prototype.isOpen = function () {
        return this._wrapperElement.hasClass(CLASS_OPEN);
    };
    /**
     * Opens the select dropdown.
     */
    Select.prototype.open = function () {
        if (!this.isOpen()) {
            this._openByFocus = false;
            this._wrapperElement.removeClass(CLASS_CLOSED);
            this._wrapperElement.addClass(CLASS_OPEN);
            this._dropdownElement.element.addEventListener("click", this._handleDropdownClick);
            this._dropdownElement.element.addEventListener("tap", this._handleDropdownClick);
        }
    };
    /**
     * Closes the select dropdown.
     */
    Select.prototype.close = function () {
        if (this.isOpen()) {
            this._openByFocus = false;
            this._wrapperElement.removeClass(CLASS_OPEN);
            this._wrapperElement.addClass(CLASS_CLOSED);
            // If the Select is filterable and therefore has an input field,
            // reset the value of it to the chosen option
            if (this._isFilterable()) {
                // Unfocus input field
                ;
                this._placeholderElement.element.blur();
                if (!this._activeFilter ||
                    this._activeFilter === this._lastSelectedOption.innerHTML) {
                    this._setPlaceholder(this._lastSelectedOption.textContent || "");
                }
            }
            this._dropdownElement.element.removeEventListener("click", this._handleDropdownClick);
            this._dropdownElement.element.removeEventListener("tap", this._handleDropdownClick);
            var focusedItem = this._wrapperElement.find(".".concat(CLASS_ITEM_FOCUSED));
            if (focusedItem) {
                focusedItem.removeClass(CLASS_ITEM_FOCUSED);
            }
        }
    };
    /**
     * Returns true when the element has the filter modifier class
     */
    Select.prototype._isFilterable = function () {
        return this._wrapperElement.hasClass(CLASS_FILTERABLE);
    };
    /**
     * Destroys the component and clears all references.
     */
    Select.prototype.destroy = function () {
        window.removeEventListener("click", this._windowClickHandler);
        if (this._dropdownElement) {
            this._dropdownElement.element.removeEventListener("click", this._handleDropdownClick);
            this._dropdownElement.element.removeEventListener("tap", this._handleDropdownClick);
            Object(__WEBPACK_IMPORTED_MODULE_1__Utils__["f" /* remove */])(this._dropdownElement.element);
            this._dropdownElement = undefined;
        }
        if (this._placeholderElement) {
            this._placeholderElement.removeEventListener("keydown", this._filterKeydownHandler);
            this._placeholderElement.removeEventListener("keyup", this._filterKeyupHandler);
            this._placeholderElement.removeEventListener("focus", this._filterFocusHandler);
        }
        if (this._wrapperElement) {
            this._wrapperElement.element.removeEventListener("click", this._clickHandler);
            this._wrapperElement.element.removeEventListener("keydown", this._keydownHandler);
            this._wrapperElement.element.removeEventListener("focus", this._focusHandler);
            this._wrapperElement.element.removeEventListener("blur", this._blurHandler);
            this._wrapperElement = undefined;
        }
        if (this._selectButtonElement) {
            Object(__WEBPACK_IMPORTED_MODULE_1__Utils__["f" /* remove */])(this._selectButtonElement.element);
            this._selectButtonElement = undefined;
        }
        this.removeClass(CLASS_CLOSED);
    };
    return Select;
}(__WEBPACK_IMPORTED_MODULE_2__DomElement__["a" /* default */]));
function init() {
    Object(__WEBPACK_IMPORTED_MODULE_1__Utils__["h" /* searchAndInitialize */])("select", function (e) {
        new Select(e);
    });
}
/* harmony default export */ __webpack_exports__["default"] = (Select);


/***/ }),
/* 19 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_dot__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_dot___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_dot__);
/* unused harmony reexport RenderFunction */

window.doT = __WEBPACK_IMPORTED_MODULE_0_dot__;

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_dot__);


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_$) {(function ($, SCS) {
	'use strict';

	SCS.Url = SCS.Url || {};

	/**
	 * Strips protocol from URL
	 * @method stripProtocolFromUrl
	 * @param {String} url
	 * @return {String} url
	 */
	SCS.Url.stripProtocolFromUrl = function(url) {
		if (url && url.length > 0) {
			return(url.replace(/^(https?\:)?\/\//ig, ''));
		}
	};

	/**
	 * Strips content/swisscom path prefixes from URL
	 * @method stripPathPrefixFromUrl
	 * @param {String} url
	 * @return {String} url
	 */
	SCS.Url.stripPathPrefixFromUrl = function(url) {
		if (url && url.length > 0) {
			return(url.replace(/\/content\/swisscom\//ig, '\/'));
		}
	};

	/**
	 * Add or update a query parameter in a URL.
	 *
	 * @method updateQueryStringParameter
	 * @param {String} uri - URL to update
	 * @param {String} key - name of parameter to add/update
	 * @param {String} value - value of parameter to add/update (note: has to be URLencoded!)
	 * @return {String} - URL with added/updated query parameter
	 */
	SCS.Url.updateQueryStringParameter = function (uri, key, value) {
		var re = new RegExp('([?|&])' + key + '=.*?(&|#|$)', 'i'),
			hash = '',
			separator;

		if (!uri) {
			return '';
		}
		else if (uri.match(re)) {
			return uri.replace(re, '$1' + key + '=' + value + '$2');
		}
		else {
			separator = uri.indexOf('?') !== -1 ? uri.indexOf('?') === uri.length - 1 ? '' : '&' : '?';
			if (uri.indexOf('#') !== -1) {
				hash = uri.replace(/.*#/, '#');
				uri = uri.replace(/#.*/, '');
			}
			return uri + separator + key + '=' + value + hash;
		}
	};

	/**
	 * Parse an URL into:
	 *	search:	'?foo=bar' or ''
	 *	hash:	'#foobar' or ''
	 */
	SCS.Url.parse = function (url) {
		var search = '',
			hash = '';

		if (typeof url === 'string') {
			// hash cannot contain #, %, ^, [, ], {, }, \, ", < and >
			var match = url.match(/(\?[^#]+)?(#[^#]+)?$/);
			if (match !== null) {
				search = match[1] || '';
				hash = match[2] || '';
			}
		}

		return {
			search: search,
			hash: hash
		};
	};

	/**
	 * @method parseHash
	 * @param url
	 * @returns {null}
	 */
	SCS.Url.parseHash = function (url) {
		var fragment,
			keyValues = null,
			hashValueFragments,
			hashValue;

		hashValue = SCS.Url.parse(url).hash.substring(1);
		if (hashValue !== '') {
			hashValueFragments = hashValue.split('&');
			keyValues = {};

			for (var i = 0, ii = hashValueFragments.length; i < ii; i += 1) {
				fragment = SCS.Url.parseKeyVal(hashValueFragments[i]);
				keyValues[fragment.key] = fragment.val;
				fragment = null;
			}
		}
		return keyValues;
	};

	/**
	 * queryKeyVal is a string with the following format "key=val" eg. "id=234"
	 *
	 * @method parseKeyVal
	 * @param queryKeyVal
	 */
	SCS.Url.parseKeyVal = function (queryKeyVal) {
		var fragments = queryKeyVal.split('=');

		if (fragments[1] === undefined) {
			fragments[1] = '';
		}

		return {
			'key': fragments[0],
			'val': fragments[1]
		};
	};

	SCS.Url.getValidSelector = function (selector) {
		if (!selector) {
			return '-';
		}

		var selectorCharacterMappings = {
			'ä': 'ae',
			'ö': 'oe',
			'ü': 'ue',
			'ß': 'ss',
			' ': '-',
			'é': 'e',
			'è': 'e',
			'à': 'a',
			'ù': 'u',
			'â': 'a',
			'ê': 'e',
			'î': 'i',
			'ô': 'o',
			'û': 'u',
			'ë': 'e',
			'ï': 'i',
			'ç': 'c',
			'ì': 'i',
			'í': 'i',
			'ò': 'o',
			'ó': 'o',
			'ú': 'u',
			'[^a-z0-9_\\-]': '-'
		};

		for (var expr in selectorCharacterMappings) {
			if (selectorCharacterMappings.hasOwnProperty(expr)) {
				selector = selector.replace(new RegExp(expr, 'gi'), selectorCharacterMappings[expr]);
			}
		}

		return selector;
	};

	// FIXME: It seems this is unused, remove
	SCS.Url.removeHost = function (url) {
		if (!url) {
			return '/';
		}

		url = url.replace(/http\:/, '').replace(/https\:/, '');
		if (url.indexOf('//') !== 0) {
			return url;
		}

		var parts = url.split('/');
		if (parts.length < 4) {
			return '/';
		}
		return '/' + parts.slice(3).join('/');
	};

	SCS.Url.removeHashParameter = __webpack_require__(6).removeHashParameter;

}(__webpack_provided_window_dot_$, window.SCS = window.SCS || {}));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 22 */
/***/ (function(module, exports) {

/*
 * JavaScript Debug - v0.4 - 6/22/2010
 * http://benalman.com/projects/javascript-debug-console-log/
 *
 * Copyright (c) 2010 "Cowboy" Ben Alman
 * Dual licensed under the MIT and GPL licenses.
 * http://benalman.com/about/license/
 *
 * With lots of help from Paul Irish!
 * http://paulirish.com/
 */
window.debug = (function () {
	var i = this, b = Array.prototype.slice, d = i.console, h = {}, f, g, m = 9, c = ["error", "warn", "info", "debug", "log"], l = "assert clear count dir dirxml exception group groupCollapsed groupEnd profile profileEnd table time timeEnd trace".split(" "), j = l.length, a = [], r = Function.prototype.apply;
	while (--j >= 0) {
		(function (n) {
			h[n] = function () {
				m !== 0 && d && d[n] && d[n].apply(d, arguments)
			}
		})(l[j])
	}
	j = c.length;
	while (--j >= 0) {
		(function (n, o) {
			h[o] = function () {
				var q = b.call(arguments), p = [o].concat(q);
				a.push(p);
				e(p);
				if (!d || !k(n)) {
					return
				}
				r.call(d[d[o] ? o : 'log'], d, q)
			}
		})(j, c[j])
	}
	function e(n) {
		if (f && (g || !d || !d.log)) {
			f.apply(i, n)
		}
	}

	h.setLevel = function (n) {
		m = typeof n === "number" ? n : 9
	};
	function k(n) {
		return m > 0 ? m > n : c.length + m <= n
	}

	h.setCallback = function () {
		var o = b.call(arguments), n = a.length, p = n;
		f = o.shift() || null;
		g = typeof o[0] === "boolean" ? o.shift() : false;
		p -= typeof o[0] === "number" ? o.shift() : n;
		while (p < n) {
			e(a[p++])
		}
	};
	return h
})();

/**
 * Add 'devconsole=1' to the url to enable debugging. It's enough if "devconsole" is added to the url.
 * @author tjunghans
 */
(function () {
	"use strict";

	var url = document.location.href,
		queryString = 'devconsole';

	if (url.indexOf(queryString, 'http://'.length) < 0) {
		debug.setLevel(0); // Remove to show logs in console
	}
}());

/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["format"] = format;
/* harmony export (immutable) */ __webpack_exports__["truncate"] = truncate;
/* harmony export (immutable) */ __webpack_exports__["plainTextFromHtml"] = plainTextFromHtml;
/**
 * Replaces format string tokens like "{0} in {1}", which are often used in i18n.
 * @param subject - The string to format
 * @param args - the partial strings to fill into string
 * @returns String
 */
function format(subject) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    return (subject || '').replace(/\{(\d+)\}/g, function (_str, i) {
        var result = args[parseInt(i, 10)];
        return typeof result === 'number' ? result : result || '';
    });
}
/**
 * Truncate a string to "roughly" the given length.
 * Appending an elipsis if sentence is not finished.
 * @param text - The string to truncate
 * @param length - Length of desired string
 * @returns String
 */
function truncate(text, length, elipsis, overshootAllowance) {
    if (elipsis === void 0) { elipsis = '…'; }
    if (overshootAllowance === void 0) { overshootAllowance = 3; }
    if (text && text.length > length + overshootAllowance) {
        // Shorten the lead text and ...
        text = text.substr(0, length)
            // Remove trailing partial word
            .replace(/\s+[^\s\.]+$/, '')
            // Remove trailing interpunction
            .replace(/\s*[(:;,_-]?\s*$/, '');
        // If sentence is not finished
        if (!text.match(/\.$/)) {
            text += elipsis || '';
        }
    }
    return text;
}
function plainTextFromHtml(text) {
    var dummyTag = document.createElement('div');
    dummyTag.innerHTML = text;
    return dummyTag.textContent;
}


/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "anim", function() { return anim; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "stopAnim", function() { return stopAnim; });
/* harmony export (immutable) */ __webpack_exports__["createAnimation"] = createAnimation;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);


// A requestAnimationFrame wrapper/polyfill
// tslint:disable:no-unbound-method
var anim = window.requestAnimationFrame
    || window.webkitRequestAnimationFrame
    || window.mozRequestAnimationFrame;
var stopAnim = window.cancelAnimationFrame
    || window.webkitCancelAnimationFrame
    || window.webkitCancelRequestAnimationFrame
    || window.mozCancelAnimationFrame;
// tslint:enable:no-unbound-method
if (!anim || !stopAnim) {
    anim = function (cb) {
        return window.setTimeout(function () {
            cb(+new Date());
        }, 10);
    };
    stopAnim = window.clearTimeout;
}

function valueIsObject(v) {
    return typeof v === 'object';
}
/**
 * Creates an object with start/stop methods to animate stuff.
 * Uses requestAnimationFrame for performance and falls back to
 * window.setInterval (with an interval of 10 ms).
 *
 * @return a handle from which to control the animation. Contains the following methods:
 *         • start(startOptions) to start the animation with the given options.
 *         • stop() to stop the animation prematurely.
 */
function createAnimation(animationOptions) {
    var handle = null;
    // These are the options given to the last invocation of .start(). For use in .stop().
    var opts = null;
    var result = {
        /**
         * Starts the animation from startValue to endValue using the animator
         * specified. startValue and endValue may be objects in which case all
         * their properties will be animated.
         */
        start: function (startOptions) {
            // Take note of the time
            var startTime;
            // Clear previous animations
            if (handle) {
                result.stop(true);
            }
            // Merge all options
            opts = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ animator: Function.prototype, duration: 500 }, (animationOptions || {})), (startOptions || {}));
            // Normalize options
            if (typeof opts.easing === 'string') {
                opts.easing = __WEBPACK_IMPORTED_MODULE_1_jquery__["easing"][opts.easing];
            }
            if (typeof opts.easing !== 'function') {
                delete opts.easing;
            }
            var easing = opts.easing || null;
            var duration = opts.duration;
            var animator = opts.animator;
            // Handle value tweening
            var startValue = {};
            var endValue = {};
            if (opts.startValue === undefined && opts.startValueCalculator) {
                opts.startValue = opts.startValueCalculator();
            }
            if (opts.startValue === undefined) {
                throw new Error("Animation start value " + opts.startValue + " is invalid");
            }
            if (opts.endValue === undefined) {
                throw new Error("Animation end value " + opts.endValue + " is invalid");
            }
            var objectGiven = valueIsObject(opts.startValue);
            if (!objectGiven) {
                startValue = { _val: opts.startValue };
                endValue = { _val: opts.endValue };
            }
            else {
                startValue = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, opts.startValue);
                endValue = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, opts.endValue);
            }
            // Calculate work to be done
            var valueDiff = {};
            for (var i in startValue) {
                valueDiff[i] = endValue[i] - startValue[i];
            }
            handle = anim(function animate(ts) {
                startTime = startTime || ts;
                var currentTime = ts - startTime;
                var timeProgress = Math.min(1, currentTime / duration);
                var valueProgress = timeProgress;
                if (easing) {
                    // Arguments beyond the first are for legacy jQuery versions
                    valueProgress = easing(timeProgress, currentTime, 0, 1, duration);
                }
                var currentValue = {};
                for (var i in valueDiff) {
                    currentValue[i] = startValue[i] + valueProgress * valueDiff[i];
                }
                if (!objectGiven) {
                    currentValue = currentValue._val;
                }
                animator(valueProgress, currentValue, timeProgress);
                if (timeProgress < 1) {
                    handle = anim(animate);
                }
                else {
                    handle = null;
                    if (opts && opts.finished) {
                        opts.finished();
                    }
                    if (opts && opts.callback) {
                        opts.callback(true);
                    }
                }
            });
        },
        /**
         * Stops a potential current animation from finishing
         */
        stop: function (fromRestart) {
            if (handle) {
                stopAnim(handle);
                if (opts && opts.callback) {
                    opts.callback(fromRestart ? false : null);
                }
                handle = null;
            }
        },
    };
    return result;
}


/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SIMPLE_PAY_DUMMY_SUBSCRIPTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Case; });
/* harmony export (immutable) */ __webpack_exports__["d"] = compareSubscriptions;
/* unused harmony export Subscription */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Subscriptions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lib_util_array__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Price__ = __webpack_require__(13);




var SIMPLE_PAY_DUMMY_SUBSCRIPTION = 'Installment-Subscription';
var Case;
(function (Case) {
    Case["Retention"] = "RETENTION";
    Case["Activation"] = "ACTIVATION";
    Case["New"] = "NEW";
})(Case || (Case = {}));
// Temporary hack to get rid of inappropriate subscriptions
function hackyShouldShowSubscription(subscription) {
    if (/^N_/.test(subscription.getId())) {
        // N_ subscriptions will be deprecated and only the new NG_ subscriptions will be sold in the future (AUG 2017)
        return false;
    }
    var segment = $(document.body).data('page-segment');
    if (segment === 'res' && / Pro /.test(subscription.getId())) {
        // Subscription not in RES according to naming convention
        return false;
    }
    if (segment === 'sme' && /^NG_LEGO/.test(subscription.getId()) && !/ Pro /.test(subscription.getId())) {
        // Subscription not in SME according to naming convention
        return false;
    }
    if (segment === 'res' && /-data-pro-/.test(subscription.getId())) {
        // Data subscription not in RES according to naming convention
        return false;
    }
    if (segment === 'sme' && /^NG_inOne-data-/.test(subscription.getId()) && !/-data-pro-/.test(subscription.getId())) {
        // Data subscription not in SME according to naming convention
        return false;
    }
    return true;
}
function compareSubscriptions(sub1, sub2) {
    // FIXME NEC: Is sortSubscription still to be sorted in descending order (as globalRank was)?
    return Object(__WEBPACK_IMPORTED_MODULE_2__util__["compareNumbers"])(sub2.sortSubscription || 0, sub1.sortSubscription || 0);
}
var Subscription = /** @class */ (function () {
    function Subscription(data) {
        this.data = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, data);
    }
    Subscription.prototype.getName = function () {
        return this.data.subscriptionName || this.getId();
    };
    Subscription.prototype.getId = function () {
        return this.data.subscriptionId;
    };
    Subscription.prototype.getRecurringCharge = function () {
        return Object(__WEBPACK_IMPORTED_MODULE_3__Price__["default"])(this.data.recurringCharge || 0);
    };
    Subscription.prototype.getCase = function () {
        return Object(__WEBPACK_IMPORTED_MODULE_2__util__["upper"])(this.data.useCase || Case.Activation);
    };
    Subscription.prototype.getDuration = function () {
        return Number(this.data.duration);
    };
    Subscription.prototype.getPrice = function () {
        return Object(__WEBPACK_IMPORTED_MODULE_3__Price__["default"])(this.data.price);
    };
    Subscription.prototype.getSimplePayRate = function () {
        return Object(__WEBPACK_IMPORTED_MODULE_3__Price__["default"])(this.data.simplePayRate || 0);
    };
    Subscription.prototype.getSortSubscription = function () {
        return this.data.sortSubscription || -0;
    };
    Subscription.prototype.matches = function (id, duration, kaze) {
        // Special-case id === '' to not match because it’s the default fallback initial ID
        if (id === '' || (id && this.getId() !== id)) {
            // ID does not match
            return false;
        }
        // We always have to get a case, default to Activation
        kaze = Object(__WEBPACK_IMPORTED_MODULE_2__util__["upper"])(kaze || Case.Activation);
        if (this.getCase() !== kaze) {
            // Case does not match
            return false;
        }
        if (duration && this.getDuration() !== Number(duration)) {
            // Duration given and does not match
            return false;
        }
        if (!('QUnit' in window) && !hackyShouldShowSubscription(this)) {
            return false;
        }
        if (this.getId() === SIMPLE_PAY_DUMMY_SUBSCRIPTION) {
            return false;
        }
        return true;
    };
    return Subscription;
}());

/**
 * Wrapper object for the subscriptions list of one product
 */
var Subscriptions = /** @class */ (function () {
    function Subscriptions(subs) {
        if (subs === void 0) { subs = []; }
        this.subscriptions = subs.map(function (sub) {
            return new Subscription(sub);
        });
    }
    Subscriptions.prototype.contains = function (id, duration, kaze) {
        return this.get(id, duration, kaze) !== null;
    };
    Subscriptions.prototype.get = function (id, duration, kaze) {
        return this.getAll(id, duration, kaze)[0] || null;
    };
    Subscriptions.prototype.getByName = function (name, duration, kaze) {
        return this.subscriptions
            .find(function (sub) { return sub.getName() === name && sub.getDuration() === duration && sub.getCase() === Object(__WEBPACK_IMPORTED_MODULE_2__util__["upper"])(kaze); }) || null;
    };
    Subscriptions.prototype.getAll = function (id, duration, kaze) {
        return this.subscriptions.filter(function (subscription) {
            return subscription.matches(id, duration, kaze);
        });
    };
    Subscriptions.prototype.getDurations = function (id, kaze) {
        return this.getAll(id, undefined, kaze)
            .map(function (subscription) {
            return subscription.getDuration();
        })
            .filter(__WEBPACK_IMPORTED_MODULE_1_lib_util_array__["a" /* onlyUnique */])
            .sort(__WEBPACK_IMPORTED_MODULE_2__util__["compareNumbers"]);
    };
    Subscriptions.prototype.getMaxDuration = function (id, kaze) {
        var durations = this.getDurations(id, kaze);
        if (!durations.length) {
            return null;
        }
        return Math.max.apply(Math, durations);
    };
    Subscriptions.prototype.map = function (callback, duration, kaze) {
        return this.getAll(undefined, duration, kaze).map(callback);
    };
    Subscriptions.prototype.getPrice = function (id, duration, kaze) {
        var subscription = this.get(id, duration, kaze);
        if (!subscription) {
            return null;
        }
        return subscription.getPrice();
    };
    Subscriptions.prototype.getName = function (id) {
        var subscription = this.get(id);
        if (!subscription) {
            return null;
        }
        return subscription.getName();
    };
    Subscriptions.prototype.getRecurringCharge = function (id, duration, kaze) {
        var subscription = this.get(id, duration, kaze);
        if (!subscription) {
            return null;
        }
        return subscription.getRecurringCharge();
    };
    Subscriptions.prototype.getSortSubscription = function (id, duration, kaze) {
        return Math.max.apply(Math, this.getAll(id, duration, kaze).map(function (subscription) {
            return subscription.getSortSubscription();
        })) || -0;
    };
    Subscriptions.prototype.getTextValueList = function (kaze) {
        var _this = this;
        return this.getAll(undefined, undefined, kaze)
            .map(function (subscription) {
            return subscription.getId();
        })
            .filter(__WEBPACK_IMPORTED_MODULE_1_lib_util_array__["a" /* onlyUnique */])
            .map(function (subscriptionId) {
            return {
                sortSubscription: _this.getSortSubscription(subscriptionId, undefined, kaze),
                text: _this.getName(subscriptionId),
                value: subscriptionId,
            };
        });
    };
    Subscriptions.prototype.hasValidSimplePay = function (kaze) {
        var subscriptions = this.getAll(undefined, undefined, kaze);
        for (var _i = 0, subscriptions_1 = subscriptions; _i < subscriptions_1.length; _i++) {
            var subscription = subscriptions_1[_i];
            if (subscription.getSimplePayRate().value() > 0) {
                return true;
            }
        }
        var price = this.getSimplePayRateWithoutSubscription();
        return price.value() > 0;
    };
    Subscriptions.prototype.getSimplePayRateWithoutSubscription = function () {
        var dummy = this.subscriptions.find(function (sub) { return sub.getId() === SIMPLE_PAY_DUMMY_SUBSCRIPTION; });
        if (dummy) {
            return dummy.getSimplePayRate();
        }
        return new __WEBPACK_IMPORTED_MODULE_3__Price__["Price"](0);
    };
    return Subscriptions;
}());


/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony export (immutable) */ __webpack_exports__["g"] = trackSelectionChange;
/* harmony export (immutable) */ __webpack_exports__["h"] = validatePhoneNumber;
/* harmony export (immutable) */ __webpack_exports__["c"] = getValidSanitizePhoneNumber;
/* harmony export (immutable) */ __webpack_exports__["a"] = createOpenHoursConfig;
/* unused harmony export getOpenWeekdaysList */
/* harmony export (immutable) */ __webpack_exports__["e"] = isOpen;
/* harmony export (immutable) */ __webpack_exports__["b"] = formatCloseTime;
/* harmony export (immutable) */ __webpack_exports__["d"] = isABCSupported;
/* harmony export (immutable) */ __webpack_exports__["f"] = trackCtx;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lib_util_helpers__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bootstrap_load_dot__ = __webpack_require__(20);


function trackSelectionChange(topic) {
    if (!topic || !(SCS && SCS.portal && SCS.portal.datalayer)) {
        return;
    }
    var label = topic.topicTrackingLabel || topic.topicName || '';
    var topicParent = topic.parent;
    var topicParentTrackingName = '';
    if (topicParent) {
        topicParentTrackingName = topicParent.topicTrackingCategory ?
            topicParent.topicTrackingCategory : topicParent.topicTrackingLabel;
    }
    var category = topic.topicTrackingCategory ||
        topicParentTrackingName ||
        topic.parentTopicName ||
        topic.topicName;
    SCS.portal.datalayer.trackEvent('select', label, 'contactform', category, 'Contact Wizard');
}
function validatePhoneNumber(phonestr) {
    // Regex used from Java validators
    var testRegexp = /^\+41(?!800|840|842|844|848|860|868|869|878|900|901|906|97|98|99)\d{9}$/;
    return testRegexp.test(phonestr);
}
function getValidSanitizePhoneNumber(phone) {
    var sanitazedNumber = Object(__WEBPACK_IMPORTED_MODULE_0_lib_util_helpers__["sanitizePhone"])(phone);
    if (!validatePhoneNumber(sanitazedNumber)) {
        return undefined;
    }
    return sanitazedNumber;
}
function createOpenHoursConfig(str) {
    var retobj = {
        exceptionallyClosed: [],
        exceptionallyOpen: [],
        openhours: [],
    };
    str.split(';').forEach(function (elem) {
        elem = elem.trim();
        if (Object(__WEBPACK_IMPORTED_MODULE_0_lib_util_helpers__["isNumber"])(elem.charAt(0))) {
            if (elem.indexOf('closed') >= 0) {
                retobj.exceptionallyClosed.push(elem);
            }
            else {
                retobj.exceptionallyOpen.push(elem);
            }
        }
        else {
            retobj.openhours.push(elem);
        }
    });
    return retobj;
}
var weekDays = ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'];
function getOpenWeekdaysList(weekDayRange) {
    var startEndDay = weekDayRange.split('-');
    var startDay = weekDays.indexOf(startEndDay[0]);
    var endDay = weekDays.indexOf(startEndDay[1]);
    var openDays = [];
    var i = startDay;
    while (startDay !== -1 || endDay !== -1) {
        if (i === startDay) {
            startDay = -1;
        }
        if (i === endDay) {
            endDay = -1;
        }
        openDays.push(i);
        i = (i + 1) % 7;
    }
    return openDays;
}
function isOpenWeekday(weekDay, weekDayRange) {
    var openWeekDays = getOpenWeekdaysList(weekDayRange);
    return openWeekDays.includes(weekDay);
}
function isOpenToday(today, openingHours) {
    return openingHours.some(function (openConfig) {
        var weekDayRange = openConfig.split(' ')[0];
        var hoursRange = openConfig.split(' ')[1];
        if (isOpenWeekday(today.getDay(), weekDayRange)) {
            return isInsideOpeningHours(today, hoursRange);
        }
        return false;
    });
}
var hourRangePattern = /^(\d{2})\:(\d{2})\-(\d{2})\:(\d{2})$/;
function isInsideOpeningHours(today, hoursRange) {
    var hours = hourRangePattern.exec(hoursRange).map(function (e) { return parseInt(e, 10); });
    var open = new Date(today);
    var close = new Date(today);
    open.setHours(hours[1]);
    open.setMinutes(hours[2]);
    close.setHours(hours[3]);
    close.setMinutes(hours[4]);
    return (today.getTime() >= open.getTime() && today.getTime() < close.getTime());
}
function getFormatedDate(today) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_lib_util_helpers__["zeroFill"])(today.getDate()) + "." + Object(__WEBPACK_IMPORTED_MODULE_0_lib_util_helpers__["zeroFill"])(today.getMonth() + 1) + "." + today.getFullYear();
}
function isExceptionallyClosedToday(today, exceptions) {
    // Exception format: 21.05.2018 closed
    var todayDate = getFormatedDate(today);
    return exceptions.some(function (exception) { return exception.split(' ')[0] === todayDate; });
}
function isTodayExceptionallyConfigured(today, exceptions) {
    // Exception format: 02.01.2019 07:00-19:59
    var todayDate = getFormatedDate(today);
    var exceptionHourRange = '';
    var open = false;
    var hasException = false;
    exceptions.some(function (exception) {
        var exceptionArr = exception.split(' ');
        if (exceptionArr[0] === todayDate) {
            exceptionHourRange = exceptionArr[1];
            return true;
        }
        return false;
    });
    if (exceptionHourRange) {
        open = isInsideOpeningHours(today, exceptionHourRange);
        hasException = true;
    }
    return { open: open, hasException: hasException };
}
// Parameter today is used for testing in every other case it should be ommitted
function isOpen(config, today) {
    if (today === void 0) { today = new Date(); }
    if (isExceptionallyClosedToday(today, config.exceptionallyClosed)) {
        return false;
    }
    var exceptionallyConfigured = isTodayExceptionallyConfigured(today, config.exceptionallyOpen);
    if (exceptionallyConfigured.hasException) {
        return exceptionallyConfigured.open;
    }
    return isOpenToday(today, config.openhours);
}
var weekDaysTranslations = {
    Fr: ['Fr', 'Ve', 'Ve', 'Fr'],
    Mo: ['Mo', 'Lu', 'Lu', 'Mo'],
    Sa: ['Sa', 'Sa', 'Sa', 'Sa'],
    Su: ['So', 'Di', 'Do', 'Su'],
    Th: ['Do', 'Je', 'Gi', 'Th'],
    Tu: ['Di', 'Ma', 'Ma', 'Tu'],
    We: ['Mi', 'Me', 'Me', 'We'],
};
var langs = ['de', 'fr', 'it', 'en'];
function formatCloseTime(openingHours, closeLabel, lang) {
    var config = createOpenHoursConfig(openingHours);
    var template = '<p>{{~it.openhours :value}}{{! value}}<br/>{{~}}{{~it.exceptions :value}}{{! value}}<br/>{{~}}</p>';
    var langPos = langs.indexOf(lang);
    config.openhours = config.openhours.map(function (e) {
        return e.replace(/(Mo|Tu|We|Th|Fr|Sa|Su)/g, function (match) { return weekDaysTranslations[match][langPos]; });
    });
    config.exceptionallyClosed.map(function (e) { return e.replace('closed', closeLabel); });
    var today = new Date();
    var endDay = new Date();
    endDay.setDate(today.getDate() + 10);
    var exceptions = config.exceptionallyClosed.concat(config.exceptionallyOpen)
        .filter(function (el) {
        var excDate = new Date(el.split(' ')[0]);
        return excDate.getTime() >= today.getTime() && excDate.getTime() <= endDay.getTime();
    })
        .sort(function (a, b) { return new Date(a.split(' ')[0]).getTime() - new Date(b.split(' ')[0]).getTime(); });
    var tmpl = __WEBPACK_IMPORTED_MODULE_1_bootstrap_load_dot__["a" /* default */].compile(template);
    return $(tmpl({
        exception: exceptions,
        openhours: config.openhours,
    }));
}
function isABCSupported() {
    var macOSVer = [10, 13, 4];
    var iOSVer = [11, 3];
    // Regex used from apple business chat: https://static.cdn-apple.com/businesschat/start-chat-button/1/index.js
    var regex = /\((Macintosh|iPhone|iPad|(?:iPod(?:\x20touch)?));.*\x20((?:\d[_.]{0,1})+)[^)]*\)\x20/i;
    var testStr = window.navigator && window.navigator.userAgent || '';
    var regexResult = regex.exec(testStr);
    if (!regexResult) {
        return false;
    }
    var supportedVer = regexResult[1].toUpperCase() === 'MACINTOSH' ? macOSVer : iOSVer;
    var currentVer = regexResult[2].split('_').map(function (elem) { return parseInt(elem, 10); });
    for (var i = 0; i < supportedVer.length; i += 1) {
        var version = currentVer[i] || 0;
        if (version === supportedVer[i]) {
            // Check next minor versions
            continue;
        }
        return version > supportedVer[i];
    }
    // If the versions are identical
    return true;
}
function trackCtx(evt) {
    var $ctx = $(evt.currentTarget).closest('.tracking-info-holder');
    if (SCS && SCS.portal && SCS.portal.datalayer) {
        new SCS.portal.datalayer.Interaction()
            .withEvent($ctx.data('track-action'), $ctx.data('track-label'), $ctx.data('track-location'), $ctx.data('track-category'), $ctx.data('track-linkname'))
            .withConversion($ctx.data('conversion-category'), $ctx.data('conversion-detail'), $ctx.data('conversion-class'))
            .track();
    }
}

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["init"] = init;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Utils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DomElement__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DomFunctions__ = __webpack_require__(15);




var QUERY_TOGGLE = ".accordion__toggle";
var QUERY_OPEN_SECTION = ".accordion__item.is-open";
var QUERY_COLLAPSE = ".accordion__collapse";
var CLASS_ITEM = "accordion__item";
var CLASS_OPEN = "is-open";
var CLASS_KEEP_OPEN = "accordion__keep-open";
var REGEX_HIDDEN = /accordion--hidden-.*/;
var ANIMATION_OPEN = 300;
/**
 * The Accordion component
 */
var Accordion = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */])(Accordion, _super);
    /**
     * Creates and initializes the Accordion component.
     * @param {DomElement} - The root element of the Accordion component.
     */
    function Accordion(element) {
        var _this = _super.call(this, element) || this;
        _this._sectionClickHandler = _this._handleSectionClick.bind(_this);
        _this._initialize();
        return _this;
    }
    /**
     * Initializes the Accordion component.
     * @private
     */
    Accordion.prototype._initialize = function () {
        var e_1, _a;
        if (this.element.className.split(" ").some(function (c) { return REGEX_HIDDEN.test(c); })) {
            var indicator = new __WEBPACK_IMPORTED_MODULE_2__DomElement__["a" /* default */]("input")
                .setAttribute("type", "hidden")
                .addClass("js-hidden");
            this.appendChild(indicator);
            this._hiddenIndicator = indicator.element;
        }
        try {
            for (var _b = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __values */])(this.element.querySelectorAll(QUERY_TOGGLE)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var toggle = _c.value;
                toggle.addEventListener("click", this._sectionClickHandler);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
    };
    Accordion.prototype._handleSectionClick = function (event) {
        if (this._hiddenIndicator) {
            var style = window.getComputedStyle(this._hiddenIndicator);
            if (style.visibility !== "visible") {
                return;
            }
        }
        var navSection = event.target.parentElement;
        while (!__WEBPACK_IMPORTED_MODULE_3__DomFunctions__["e" /* hasClass */](navSection, CLASS_ITEM) && navSection.parentElement) {
            navSection = navSection.parentElement;
        }
        var prevSection = this.element.querySelector(QUERY_OPEN_SECTION);
        if (prevSection && prevSection !== navSection) {
            if (!__WEBPACK_IMPORTED_MODULE_3__DomFunctions__["e" /* hasClass */](this.element, CLASS_KEEP_OPEN)) {
                this._toggleSection(prevSection);
            }
        }
        this._toggleSection(navSection);
    };
    Accordion.prototype._toggleSection = function (accSection) {
        var collapseElement = accSection.querySelector(QUERY_COLLAPSE);
        if (__WEBPACK_IMPORTED_MODULE_3__DomFunctions__["e" /* hasClass */](accSection, CLASS_OPEN)) {
            __WEBPACK_IMPORTED_MODULE_3__DomFunctions__["h" /* removeClass */](accSection, CLASS_OPEN);
            this._closeCollapseSection(collapseElement);
        }
        else {
            __WEBPACK_IMPORTED_MODULE_3__DomFunctions__["a" /* addClass */](accSection, CLASS_OPEN);
            if (collapseElement) {
                // to ignore the case when there is no collapsible element (see sdx doku navigation, "all the basics") in a list of accordion
                this._openCollapseSection(collapseElement);
            }
        }
    };
    Accordion.prototype._openCollapseSection = function (el) {
        el.style.display = "block";
        __WEBPACK_IMPORTED_MODULE_1__Utils__["a" /* animation */].start(el, {
            height: "".concat(el.scrollHeight, "px"),
            opacity: "1",
        }, ANIMATION_OPEN, {
            finished: function () {
                el.setAttribute("aria-expanded", "true");
                el.classList.add(CLASS_OPEN);
                el.style.height = "auto"; // allow to grow or shrink with content
                __WEBPACK_IMPORTED_MODULE_1__Utils__["a" /* animation */].set(el, { height: "auto" });
            },
        });
    };
    Accordion.prototype._closeCollapseSection = function (el) {
        // Can't animate "auto", therefore update to current height
        __WEBPACK_IMPORTED_MODULE_1__Utils__["a" /* animation */].set(el, { height: "".concat(el.scrollHeight, "px") });
        __WEBPACK_IMPORTED_MODULE_1__Utils__["a" /* animation */].start(el, {
            height: "0",
            opacity: "0",
        }, ANIMATION_OPEN, {
            finished: function () {
                el.setAttribute("aria-expanded", "false");
                el.style.removeProperty("display"); // removes extra padding in Footer after opening and closing
                el.style.removeProperty("height"); // SDX-691 Missing items in Footer after resizing
                el.style.removeProperty("opacity"); // SDX-691 Missing items in Footer after resizing
                el.classList.remove(CLASS_OPEN);
            },
        });
    };
    /**
     * Removes all event handlers and clears references.
     */
    Accordion.prototype.destroy = function () {
        var e_2, _a;
        try {
            for (var _b = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __values */])(this.element.querySelectorAll(QUERY_TOGGLE)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var toggle = _c.value;
                toggle.removeEventListener("click", this._sectionClickHandler);
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_2) throw e_2.error; }
        }
        ;
        this._sectionClickHandler = null;
        this.element = null;
    };
    return Accordion;
}(__WEBPACK_IMPORTED_MODULE_2__DomElement__["a" /* default */]));
function init() {
    Object(__WEBPACK_IMPORTED_MODULE_1__Utils__["h" /* searchAndInitialize */])(".accordion", function (e) {
        new Accordion(e);
    });
}
/* harmony default export */ __webpack_exports__["default"] = (Accordion);


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;// doT.js
// 2011-2014, Laura Doktorova, https://github.com/olado/doT
// Licensed under the MIT license.

(function () {
	"use strict";

	var doT = {
		name: "doT",
		version: "1.1.1",
		templateSettings: {
			evaluate:    /\{\{([\s\S]+?(\}?)+)\}\}/g,
			interpolate: /\{\{=([\s\S]+?)\}\}/g,
			encode:      /\{\{!([\s\S]+?)\}\}/g,
			use:         /\{\{#([\s\S]+?)\}\}/g,
			useParams:   /(^|[^\w$])def(?:\.|\[[\'\"])([\w$\.]+)(?:[\'\"]\])?\s*\:\s*([\w$\.]+|\"[^\"]+\"|\'[^\']+\'|\{[^\}]+\})/g,
			define:      /\{\{##\s*([\w\.$]+)\s*(\:|=)([\s\S]+?)#\}\}/g,
			defineParams:/^\s*([\w$]+):([\s\S]+)/,
			conditional: /\{\{\?(\?)?\s*([\s\S]*?)\s*\}\}/g,
			iterate:     /\{\{~\s*(?:\}\}|([\s\S]+?)\s*\:\s*([\w$]+)\s*(?:\:\s*([\w$]+))?\s*\}\})/g,
			varname:	"it",
			strip:		true,
			append:		true,
			selfcontained: false,
			doNotSkipEncoded: false
		},
		template: undefined, //fn, compile template
		compile:  undefined, //fn, for express
		log: true
	}, _globals;

	doT.encodeHTMLSource = function(doNotSkipEncoded) {
		var encodeHTMLRules = { "&": "&#38;", "<": "&#60;", ">": "&#62;", '"': "&#34;", "'": "&#39;", "/": "&#47;" },
			matchHTML = doNotSkipEncoded ? /[&<>"'\/]/g : /&(?!#?\w+;)|<|>|"|'|\//g;
		return function(code) {
			return code ? code.toString().replace(matchHTML, function(m) {return encodeHTMLRules[m] || m;}) : "";
		};
	};

	_globals = (function(){ return this || (0,eval)("this"); }());

	/* istanbul ignore else */
	if (typeof module !== "undefined" && module.exports) {
		module.exports = doT;
	} else if (true) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = (function(){return doT;}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		_globals.doT = doT;
	}

	var startend = {
		append: { start: "'+(",      end: ")+'",      startencode: "'+encodeHTML(" },
		split:  { start: "';out+=(", end: ");out+='", startencode: "';out+=encodeHTML(" }
	}, skip = /$^/;

	function resolveDefs(c, block, def) {
		return ((typeof block === "string") ? block : block.toString())
		.replace(c.define || skip, function(m, code, assign, value) {
			if (code.indexOf("def.") === 0) {
				code = code.substring(4);
			}
			if (!(code in def)) {
				if (assign === ":") {
					if (c.defineParams) value.replace(c.defineParams, function(m, param, v) {
						def[code] = {arg: param, text: v};
					});
					if (!(code in def)) def[code]= value;
				} else {
					new Function("def", "def['"+code+"']=" + value)(def);
				}
			}
			return "";
		})
		.replace(c.use || skip, function(m, code) {
			if (c.useParams) code = code.replace(c.useParams, function(m, s, d, param) {
				if (def[d] && def[d].arg && param) {
					var rw = (d+":"+param).replace(/'|\\/g, "_");
					def.__exp = def.__exp || {};
					def.__exp[rw] = def[d].text.replace(new RegExp("(^|[^\\w$])" + def[d].arg + "([^\\w$])", "g"), "$1" + param + "$2");
					return s + "def.__exp['"+rw+"']";
				}
			});
			var v = new Function("def", "return " + code)(def);
			return v ? resolveDefs(c, v, def) : v;
		});
	}

	function unescape(code) {
		return code.replace(/\\('|\\)/g, "$1").replace(/[\r\t\n]/g, " ");
	}

	doT.template = function(tmpl, c, def) {
		c = c || doT.templateSettings;
		var cse = c.append ? startend.append : startend.split, needhtmlencode, sid = 0, indv,
			str  = (c.use || c.define) ? resolveDefs(c, tmpl, def || {}) : tmpl;

		str = ("var out='" + (c.strip ? str.replace(/(^|\r|\n)\t* +| +\t*(\r|\n|$)/g," ")
					.replace(/\r|\n|\t|\/\*[\s\S]*?\*\//g,""): str)
			.replace(/'|\\/g, "\\$&")
			.replace(c.interpolate || skip, function(m, code) {
				return cse.start + unescape(code) + cse.end;
			})
			.replace(c.encode || skip, function(m, code) {
				needhtmlencode = true;
				return cse.startencode + unescape(code) + cse.end;
			})
			.replace(c.conditional || skip, function(m, elsecase, code) {
				return elsecase ?
					(code ? "';}else if(" + unescape(code) + "){out+='" : "';}else{out+='") :
					(code ? "';if(" + unescape(code) + "){out+='" : "';}out+='");
			})
			.replace(c.iterate || skip, function(m, iterate, vname, iname) {
				if (!iterate) return "';} } out+='";
				sid+=1; indv=iname || "i"+sid; iterate=unescape(iterate);
				return "';var arr"+sid+"="+iterate+";if(arr"+sid+"){var "+vname+","+indv+"=-1,l"+sid+"=arr"+sid+".length-1;while("+indv+"<l"+sid+"){"
					+vname+"=arr"+sid+"["+indv+"+=1];out+='";
			})
			.replace(c.evaluate || skip, function(m, code) {
				return "';" + unescape(code) + "out+='";
			})
			+ "';return out;")
			.replace(/\n/g, "\\n").replace(/\t/g, '\\t').replace(/\r/g, "\\r")
			.replace(/(\s|;|\}|^|\{)out\+='';/g, '$1').replace(/\+''/g, "");
			//.replace(/(\s|;|\}|^|\{)out\+=''\+/g,'$1out+=');

		if (needhtmlencode) {
			if (!c.selfcontained && _globals && !_globals._encodeHTML) _globals._encodeHTML = doT.encodeHTMLSource(c.doNotSkipEncoded);
			str = "var encodeHTML = typeof _encodeHTML !== 'undefined' ? _encodeHTML : ("
				+ doT.encodeHTMLSource.toString() + "(" + (c.doNotSkipEncoded || '') + "));"
				+ str;
		}
		try {
			return new Function(c.varname, str);
		} catch (e) {
			/* istanbul ignore else */
			if (typeof console !== "undefined") console.log("Could not create a template function: " + str);
			throw e;
		}
	};

	doT.compile = function(tmpl, def) {
		return doT.template(tmpl, null, def);
	};
}());


/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = toCamel;
/* harmony export (immutable) */ __webpack_exports__["a"] = capitalize;
function toCamel(str) {
    return str.replace(/(\-[^-])/g, function ($1) {
        return $1.toUpperCase().replace('-', '');
    });
}
function capitalize(str) {
    // Capitalize the first letter
    return str.substr(0, 1).toUpperCase().concat(str.substr(1));
}


/***/ }),
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return KEY_TAB; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return KEY_ENTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return KEY_ESCAPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return KEY_ARROW_UP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return KEY_ARROW_DOWN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return KEY_ARROW_LEFT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return KEY_ARROW_RIGHT; });
/* unused harmony export KEY_PAGE_UP */
/* unused harmony export KEY_PAGE_DOWN */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return KEY_NR_0; });
/* unused harmony export KEY_NR_1 */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return KEY_NR_9; });
/* unused harmony export containsKey */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return getKeyValue; });
/* Keyboard input keycode definitions */
var KEY_TAB = 9;
var KEY_ENTER = 13;
var KEY_ESCAPE = 27;
// Arrow keys
var KEY_ARROW_UP = 38;
var KEY_ARROW_DOWN = 40;
var KEY_ARROW_LEFT = 37;
var KEY_ARROW_RIGHT = 39;
// Page keys
var KEY_PAGE_UP = 33;
var KEY_PAGE_DOWN = 34;
// Numbers
var KEY_NR_0 = 48;
var KEY_NR_1 = 49;
var KEY_NR_9 = 57;
// helper functions
var containsKey = function (keycode, inputsKeys) {
    var hasKey = false;
    if (inputsKeys && inputsKeys.length > 0) {
        ;
        [].forEach.call(inputsKeys, function (inputsKey) {
            if (keycode === inputsKey) {
                hasKey = true;
            }
        });
    }
    return hasKey;
};
var getKeyValue = function (keycode) {
    if (keycode < 48 || keycode > 105) {
        return "";
    }
    return String.fromCharCode(96 <= keycode && keycode <= 105 ? keycode - 48 : keycode).toLowerCase();
};


/***/ }),
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony export (immutable) */ __webpack_exports__["replacePlaceholders"] = replacePlaceholders;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lib_vendor_terrific_Module__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Price__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Subscription__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Tc_Module_EcommerceProductDataHub__ = __webpack_require__(16);





var PLACEHOLDERS;
(function (PLACEHOLDERS) {
    PLACEHOLDERS["originalPrice"] = "originalPrice";
    PLACEHOLDERS["discountedPrice"] = "discountedPrice";
    PLACEHOLDERS["minimumPrice"] = "minimumPrice";
    PLACEHOLDERS["currentPrice"] = "currentPrice";
    PLACEHOLDERS["priceInstead"] = "priceInstead";
    PLACEHOLDERS["simplePayMonthlyPrice"] = "simplePayMonthlyPrice";
    PLACEHOLDERS["withSubscription"] = "withSubscription";
})(PLACEHOLDERS || (PLACEHOLDERS = {}));
var PLACEHOLDER_AWARE_ELEMENTS = [
    '.price',
    '.price-label',
];
var PriceBox = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */])(PriceBox, _super);
    function PriceBox() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.previousPlaceholders = {};
        _this.placeholders = {};
        _this.retentionSubscription = '';
        return _this;
    }
    PriceBox.prototype.on = function (callback) {
        var useDynamicPrice = this.$ctx.data('use-dynamic-price');
        this.rebatePriceText = this.$ctx.data('price-rebate-text');
        this.withSubscription = this.$ctx.data('with-subscription');
        this.withYourSubscription = this.$ctx.data('with-your-subscription');
        this.$footnoteStandard = this.$ctx.closest('.gridlayout').find('.footnote-standard');
        this.$footnoteRetention = this.$ctx.closest('.gridlayout').find('.footnote-retention');
        this.$simplePayCheckbox = this.$ctx.find('input[name=simplepay]');
        this.$firstColumn = this.$ctx.find('.first-column');
        this.$secondColumn = this.$ctx.find('.second-column');
        if (useDynamicPrice) {
            // tslint:disable-next-line:no-unbound-method
            Object(__WEBPACK_IMPORTED_MODULE_4__Tc_Module_EcommerceProductDataHub__["c" /* simpleSubscribe */])(this, this.getInfoCallback);
        }
        this.$simplePayCheckbox.change(this.updateSimplePayState.bind(this));
        if (/\bsimplepay=true\b/.test(location.hash)) {
            this.$simplePayCheckbox.prop('checked', true).change();
        }
        callback();
    };
    PriceBox.prototype.getInfoCallback = function (data) {
        if (data && data.product && data.subscriptionType) {
            this.log('getInfoCallback', data.subscriptionType);
            this.product = data.product;
            this.subscriptionId = data.subscriptionId || undefined;
            this.subscriptionDuration = data.subscriptionDuration || undefined;
            this.subscriptionType = data.subscriptionType;
            this.updateSimplePayState();
        }
    };
    /**
     * Listen to and save updates from Tc.Module.RetentionResult
     */
    PriceBox.prototype.onRetentionChange = function (data) {
        if (!data.status || !this.product) {
            return;
        }
        if (data.status === 'possible' && data.existingAboName) {
            this.retentionSubscription = data.existingAboName;
        }
        else {
            if (this.subscriptionType === __WEBPACK_IMPORTED_MODULE_4__Tc_Module_EcommerceProductDataHub__["a" /* SUBSCRIPTION_TYPES */].retention) {
                this.retentionSubscription = '';
            }
        }
        this.updatePrices();
        this.log('onRetentionChange', this.subscriptionType, this.retentionSubscription);
    };
    /**
     * Communicate state change to Tc.Module.PaymentSwitch.
     */
    PriceBox.prototype.updateSimplePayState = function () {
        var simplePayChecked = this.$simplePayCheckbox.prop('checked');
        if (simplePayChecked === undefined) {
            this.log('Simple Pay checkbox not found');
            return;
        }
        var data = {
            simplePayChecked: simplePayChecked,
            simplePayDuration: simplePayChecked && this.subscriptionDuration || '',
        };
        this.log('updateSimplePayState', data);
        this.fire('simplePayChange', data);
        this.updatePrices();
    };
    PriceBox.prototype.updatePrices = function () {
        if (!this.product) {
            this.log('no product');
            return;
        }
        // MinimumPrice, originalPrice and discountedPrice (for phones, tablets, watches, and other devices with subscription)
        // With subscription
        this.placeholders[PLACEHOLDERS.minimumPrice] = this.product.getMinimumPrice().formatted(__WEBPACK_IMPORTED_MODULE_2__Price__["DEFAULT_PRICE_REPRESENTATION"], true);
        var originalPrice = this.product.getOriginalPrice().formatted();
        // Device only, full price
        this.placeholders[PLACEHOLDERS.originalPrice] = originalPrice;
        // Device only, sale price
        this.placeholders[PLACEHOLDERS.discountedPrice] = this.product.getDiscountedPrice().formatted();
        // CurrentPrice (for accessories that cannot be combined with a subscription)
        // Device only, sale price
        this.placeholders[PLACEHOLDERS.currentPrice] = this.product.getMinimumPrice().formatted(__WEBPACK_IMPORTED_MODULE_2__Price__["DEFAULT_PRICE_REPRESENTATION"], false);
        // PriceInstead (a.k.a. as crossed-out price)
        if (this.product.isDiscounted()) {
            this.placeholders[PLACEHOLDERS.priceInstead] = this.rebatePriceText.replace(/\{0}/g, originalPrice);
        }
        else {
            this.placeholders[PLACEHOLDERS.priceInstead] = '';
        }
        // SimplePayMonthlyPrice for watches, tablets, etc
        if (this.$simplePayCheckbox.length) {
            var simplePayMonthlyPrice = this.product.getSimplePayMonthlyPrice(this.subscriptionId, this.subscriptionDuration);
            if (simplePayMonthlyPrice === -1 || !simplePayMonthlyPrice.value()) {
                // SimplePay not possible
                this.placeholders[PLACEHOLDERS.simplePayMonthlyPrice] = __WEBPACK_IMPORTED_MODULE_2__Price__["DEFAULT_PRICE_REPRESENTATION"];
                this.$simplePayCheckbox.prop('disabled', true);
                this.$simplePayCheckbox.prop('checked', false);
                var data = {
                    simplePayChecked: false,
                    simplePayDuration: '',
                };
                this.fire('simplePayChange', data);
            }
            else {
                this.placeholders[PLACEHOLDERS.simplePayMonthlyPrice] = simplePayMonthlyPrice.formatted();
                this.$simplePayCheckbox.prop('disabled', false);
            }
            var disableSimplePay = !this.$simplePayCheckbox.prop('checked') || this.$simplePayCheckbox.prop('disabled');
            this.$firstColumn.toggleClass('disabled', !disableSimplePay);
            this.$secondColumn.toggleClass('disabled', disableSimplePay);
            this.log('disableSimplePay', disableSimplePay);
        }
        // Retention subscription name and price
        this.$footnoteRetention.hide();
        this.$footnoteStandard.show();
        this.placeholders[PLACEHOLDERS.withSubscription] = this.withSubscription;
        if (this.subscriptionType === __WEBPACK_IMPORTED_MODULE_4__Tc_Module_EcommerceProductDataHub__["a" /* SUBSCRIPTION_TYPES */].retention && this.retentionSubscription) {
            var personalizedSub = this.product.getSubscriptions().getByName(this.retentionSubscription, 24, __WEBPACK_IMPORTED_MODULE_3__Subscription__["a" /* Case */].Retention);
            if (personalizedSub) {
                var personalizedPrice = personalizedSub.getPrice().formatted(__WEBPACK_IMPORTED_MODULE_2__Price__["DEFAULT_PRICE_REPRESENTATION"], true);
                if (personalizedPrice) {
                    this.placeholders[PLACEHOLDERS.withSubscription] = this.withYourSubscription + " " + this.retentionSubscription;
                    this.placeholders[PLACEHOLDERS.minimumPrice] = personalizedPrice;
                    this.$footnoteStandard.hide();
                    this.$footnoteRetention.show();
                }
            }
        }
        this.updatePlaceholders(this.placeholders);
    };
    PriceBox.prototype.updatePlaceholders = function (placeholders, replaceAll) {
        if (replaceAll === void 0) { replaceAll = false; }
        if (!replaceAll) {
            placeholders = $.extend({}, this.previousPlaceholders || {}, this.placeholders);
            this.previousPlaceholders = placeholders;
        }
        var $elements = $(PLACEHOLDER_AWARE_ELEMENTS.join(', '), this.$ctx);
        $elements.each(function () {
            var element = $(this);
            var elementText = element.data('placeholder-template');
            if (!elementText) {
                elementText = element.text();
                element.data('placeholder-template', elementText);
            }
            element.text(replacePlaceholders(elementText, placeholders));
        });
        this.$ctx.css('opacity', 1);
    };
    return PriceBox;
}(__WEBPACK_IMPORTED_MODULE_1_lib_vendor_terrific_Module__["a" /* Module */]));
/* harmony default export */ __webpack_exports__["default"] = (PriceBox);
function replacePlaceholders(source, placeholders) {
    return source.replace(/\$\{([a-zA-Z0-9]+)\}/g, function (_, placeholderName) { return placeholders[placeholderName] || ''; });
}

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony export (immutable) */ __webpack_exports__["getGlobalUserBox"] = getGlobalUserBox;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lib_vendor_terrific_Module__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lib_personalization_profile__ = __webpack_require__(5);



var UserBox = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */])(UserBox, _super);
    function UserBox() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.urls = {};
        return _this;
    }
    UserBox.prototype.on = function (callback) {
        this.urls = this.$ctx.data();
        callback();
    };
    UserBox.prototype.getLogoutUrl = function () {
        return this.urls.logoutUrl;
    };
    UserBox.prototype.getLoginUrl = function () {
        return this.urls.loginUrl;
    };
    UserBox.prototype.getResShopUrl = function () {
        return this.urls.resShopUrl;
    };
    UserBox.prototype.getSmeShopUrl = function () {
        return this.urls.logoutUrl;
    };
    UserBox.prototype.getCbuShopUrl = function () {
        return this.urls.smeShopUrl;
    };
    UserBox.prototype.after = function () {
        return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var _a;
            return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!this.$ctx.find('#scs-pageheader-userbox-button span.text').length) return [3 /*break*/, 2];
                        _a = this;
                        return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_2_lib_personalization_profile__["getProfile"])()];
                    case 1:
                        _a.user = (_b.sent()).getUser();
                        if (this.user) {
                            this.initUserBox();
                            this.initUserBoxEvents();
                        }
                        _b.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    UserBox.prototype.initUserBox = function () {
        var $text = this.$ctx.find('#scs-pageheader-userbox-button span.text');
        $text.addClass('ctHidden');
        $text.text(this.user.getFullName());
        this.$ctx.show();
        if (window.scsHeader && window.scsHeader.positionToolbarFiller) {
            window.scsHeader.positionToolbarFiller();
        }
    };
    UserBox.prototype.initUserBoxEvents = function () {
        var _this = this;
        // Show/hide menu
        this.$ctx.find('#scs-pageheader-userbox-button').on('click', function (e) {
            _this.$ctx.toggleClass('isActive');
            e.currentTarget.blur();
        });
        // Close menu if something outside the login-box is clicked
        $(document).on('click', function () {
            _this.$ctx.removeClass('isActive');
        });
        this.$ctx.on('click', function (e) {
            e.stopPropagation();
        });
    };
    return UserBox;
}(__WEBPACK_IMPORTED_MODULE_1_lib_vendor_terrific_Module__["a" /* Module */]));
/* harmony default export */ __webpack_exports__["default"] = (UserBox);
var globalUserBox;
function getGlobalUserBox() {
    if (globalUserBox === undefined) {
        var module = document.getElementById('scs-pageheader-userbox') || document.querySelector('.mod.modUserBox');
        if (!module) {
            globalUserBox = null;
        }
        else {
            globalUserBox = window.application.sandbox.getModuleInstance(module, 'UserBox');
        }
    }
    return globalUserBox;
}

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_imports_loader_define_false_jQuery_jquery_qtip2__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_imports_loader_define_false_jQuery_jquery_qtip2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_imports_loader_define_false_jQuery_jquery_qtip2__);
/// <reference types="qtip2" />



/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_$, __webpack_provided_window_dot_Tc_dot_$) {/* globals JSON, window, document */
/* exported JSON, window, document */
__webpack_require__(4);


(function ($, SCS) {
	'use strict';

	/**
	 * Global utilities for all Swisscom projects
	 *
	 * @author Thomas Junghans
	 * @namespace SCS
	 * @class utils
	 */
	SCS.utils = SCS.utils || {};

	var zeroFill = __webpack_require__(4).zeroFill;

	/**
	 * Override jQuery.fn.load to call SCS.utils.initNewModules on updated elements.
	 */
	var oldLoad = $.fn.load;
	$.fn.load = function (url, data, callback) {
		var element = this;
		callback = callback || data;
		if (!$.isFunction(callback)) {
			callback = $.noop;
		} else if ($.isFunction(data)) {
			data = null;
		}
		return oldLoad.call(element, url, data, function () {
			SCS.utils.initNewModules(element);
			callback.apply(this, arguments);
		});
	};

	/**
	 * Returns LESS variables that were previously stored in the "font-family" property of a hidden element
	 *
	 * You have to define the values in LESS like this:
	 *	// bring less variables to javascript
	 *	myElement > .less-vars {
	 *		// local variables to prevent calculation in the JSON object
	 *		@smallLogoSize: @logoSpace - @logoSmallDifference;
	 *
	 *		// generate JSON out of a object via LESS-Javascript
	 *		font-family: ~`"'" +
	 *			JSON.stringify({
	 *				mobile: {
	 *					breakpoint: '@{ResponsiveMaxMobile}'.replace('px', '')
	 *				},
	 *				desktop: {
	 *					logoTotalWidth: {
	 *						big: '@{logoSpace}'.replace('px', ''),
	 *						small: '@{smallLogoSize}'.replace('px', '')
	 *					}
	 *				}
	 *			})
	 *			+ "'"
	 *		` !important;
	 *
	 *		display: none;
	 *	}
	 *
	 * @method getLessVars
	 * @param {HTMLElement|jQuery} element - must either be the element (with less vars) itself or must contain a child element with class "less-vars"
	 * @returns Object|String
	 */
	SCS.utils.getLessVars = function (element) {
		var $el = $(element),
			$lessVars = $el.is('.less-vars') ? $el : $el.children('.less-vars'),
			fontFamily = $lessVars.css('font-family') || '',
			contentValue = fontFamily.replace(/\\"/g, '"').replace(/(^")|("$)|(^')|('$)/g, '');

		try {
			return JSON.parse(contentValue);
		} catch (e) {
			return contentValue;
		}
	};

	/**
	 * Remove CSS classes that match a substring.
	 *
	 * If cssClassAttriube = "cssClassFoo cssClassBar cssClassBaz cssClassBarBaz" and
	 * cssClassesToRemove = "Bar" then the return value will be "cssClassFoo cssClassBaz"
	 *
	 * @param cssClassAttribute {string}
	 * @param cssClassesToRemove {string}
	 * @returns {string}
	 */
	SCS.utils.removeCssClasses = function (cssClassAttribute, cssClassesToRemove) {
		var classes = cssClassAttribute.split(/\s+/);

		for (var i = 0; i < classes.length;) {

			if (classes[i].indexOf(cssClassesToRemove) > -1) {
				classes.splice(i, 1);
			} else {
				i += 1;
			}
		}
		return classes.join(' ');
	};

	/**
	 * Expects the value of a css class attribute and the prefix of a css class eg. scs-. An array with all prefixed
	 * css classes is returned
	 *
	 * @method getClassNamesWithPrefix
	 * @param {string} classAttribute
	 * @param {string} prefix
	 * @returns {Array<string>}
	 */
	SCS.utils.getClassNamesWithPrefix = function (classAttribute, prefix) {
		var cssClasses = classAttribute.split(/\s+/),
			customClasses = [],
			i = 0,
			ii = cssClasses.length;

		if (typeof(prefix) === 'string') {
			for (; i < ii; i += 1) {
				if (cssClasses[i].indexOf(prefix) >= 0) {
					customClasses.push(cssClasses[i]);
				}
			}
		} else {
			customClasses = cssClasses;
		}

		return customClasses;
	};

	/**
	 * Checks if the path suffix is either jpeg, jpg, png or gif
	 *
	 * @method isImagePath
	 * @namespace SCS.utils
	 * @param path
	 * @returns {boolean} true on success
	 */
	SCS.utils.isImagePath = __webpack_require__(6).isImagePath;

	SCS.utils.isMobilePage = __webpack_require__(4).isMobilePage;

	/**
	 * Returns true if obj is string and not ''.
	 *
	 * @method isNonEmptyString
	 * @param obj
	 * @returns {boolean}
	 */
	SCS.utils.isNonEmptyString = function (obj) {
		return this.isString(obj) && obj.length > 0;
	};

	SCS.utils.isString = function (obj) {
		return typeof obj === 'string' || (obj !== null && typeof obj === 'object' && obj.constructor === String);
	};

	/**
	 * @method parseNumber
	 * @namespace SCS.utils
	 * @param numericValue
	 * @return {Number}
	 */
	SCS.utils.parseNumber = function (numericValue) {
		if (!numericValue) {
			return 0;
		}
		var result = Number($.trim(numericValue.toString()));
		return isNaN(result) ? 0 : result;
	};

	/**
	 * Short cut for getElementId including the conversion into a jQuery object. It is faster than $('#' + id).
	 * @method $id
	 * @param id {string}
	 * @returns {jQuery}
	 */
	SCS.utils.$id = function (id) {
		return $(document.getElementById(id));
	};

	/**
	 * Returns a unique id for the given DOM element. This id does not change if it is set once.
	 * @method getUniqueIdOfElement
	 * @param {HTMLElement|jQuery} element
	 * @returns {String}
	 */
	SCS.utils.getUniqueIdOfElement = __webpack_require__(4).getUniqueIdOfElement;

	/**
	 * Checks if a url is external - can be used to check if a url can be loaded via ajax (same domain policy)
	 * @method isExternalUrl
	 * @param url {string}
	 * @returns boolean
	 */
	SCS.utils.isExternalUrl = __webpack_require__(6).isExternalUrl;

	SCS.utils.isIE11 = __webpack_require__(85).isIE11;

	/**
	 * Converts kbit/s, MBit/s and GBit/s to bits per second (integer)
	 * @method convertToBits
	 * @param {String} s For example '15 MBit/s'
	 * @returns {Integer} Bits per second.
	 */
	SCS.utils.convertToBits = function (s) {
		var i = parseInt(s, 10);
		// kilobit per second (symbol kbit/s or kb/s, often abbreviated "kbps")
		if (s.match(/[kK][bB](it)?[\/p]s/)) {
			return i * 1000;
		}
		// megabit per second (symbol Mbit/s or Mb/s, often abbreviated "Mbps")
		if (s.match(/M[bB](it)?[\/p]s/)) {
			return i * 1000 * 1000;
		}
		// gigabit per second (symbol Gbit/s or Gb/s, often abbreviated "Gbps")
		if (s.match(/G[bB](it)?[\/p]s/)) {
			return i * 1000 * 1000 * 1000;
		}
		return i;
	};

	/**
	 * Formats a given price to a "0.00" format
	 * @method formatPrice
	 * @param {number} price
	 * @returns {string}
	 */
	SCS.utils.formatPrice = function (price) {
		var cents = Math.round(price * 100 || 0) + '';
		while (cents.length < 3) {
			cents = '0' + cents;
		}
		return cents.substr(0, cents.length - 2) + '.' + cents.substr(-2, 2);
	};

	/**
	 * Formats a price/number of format "12.00" or "12" to "12.–", and "12.50" to "12.50"
	 * @param price {(number|string)}
	 * @returns {string}
	 */
	SCS.utils.formatPriceWithDash = function(price) {
		price = String(price);
		if (/[.][0-9]?[1-9]/.test(price)) {
			return SCS.utils.formatPrice(price);
		}
		return price.replace(/^(-?\d+)($|\.0*$|\.00.*$)/, '$1.–');
	};

	/**
	 * Formats time (hours) to "00:00" format
	 * @method formatTime
	 * @param {float} hours
	 * @param {string} delimiter
	 * @returns {string}
	 */
	SCS.utils.formatTime = function (hours, delimiter) {
		return zeroFill(Math.floor(hours), 2) +
			(delimiter ? delimiter : ':') +
			zeroFill(Math.floor((hours % 1) * 60), 2);
	};

	/**
	 * Returns a date object containing the actual server time.
	 * IMPORTANT:
	 * - at the moment this doesn not work until SC ads a "data-server-timestamp" attribute to its body
	 * - if your timezone is different to the servers the minutes can be inaccurate (max as many as the servers caching time - 3 mins at the time)
	 *
	 * @method getServerTime
	 * @returns {Date}
	 */
	SCS.utils.getServerTime = function () {
		var serverTimeStamp = $('body').data('server-timestamp'),
			serverTime,
			browserTime = new Date(),
			acceptableOffset = 1000 * 60 * 10; // 10 minutes

		// fix for swisscom IF there is an element on the page with attribute "data-now"
		if (!serverTimeStamp) {
			serverTimeStamp = $('[data-now]:first').data('now');
		}

		serverTime = new Date(Number(serverTimeStamp));

		/*
		 * The servers timestamp is "old" because of caching. This means we don't have an accurate time and events cannot be started at the exact time.
		 * Therefore if the offset between servertime and browsertime is lower than 10 minutes we assume that both have the same timezone.
		 * Then browsertime is taken. Otherwise the user has a different timezone and then servertime is taken with the above mentioned drawbacks.
		 * The caching time of the server is 3 minutes at the time (mrz. 2015)
		 */
		return (browserTime - serverTime <= acceptableOffset ? browserTime : serverTime);
	};


	SCS.utils.ajaxCache = {

		/**
		 * @private
		 */
		cachedPromises: {},

		/**
		 * Caches ajax calls
		 * @method ajax
		 * @param {object} settings - Settings object required by jQuery.ajax, containing at minimum the url
		 * @param {function} callback
		 * @returns {jQuery.promise}
		 */
		ajax: function (settings, callback) {
			if (!this.cachedPromises[settings.url]) {
				this.cachedPromises[settings.url] = $.Deferred(function (defer) {
					$.ajax(settings).then(defer.resolve, defer.reject);
				}).promise();
			}

			return this.cachedPromises[settings.url].done(callback);
		},

		/**
		 * Caches ajax JSON calls
		 * @method getJSON
		 * @param {string} url
		 * @param {function} callback
		 * @param {number} [timeout] - in milliseconds
		 * @returns {jQuery.promise}
		 */
		getJSON: function (url, callback, timeout) {
			return this.ajax({url: url, dataType: 'json', timeout: timeout}, callback);
		}

	};


	/**
	 * Converts a date string (with or without time) into a native date object
	 * @method fromString
	 * @param {string} dateString - For example '2014-12-31 12:15', '31.12.2014' or '1364560948000+0100'
	 * @returns {Date}
	 */
	function fromString(dateString) {
		var parts,
			date;

		if (!dateString || !dateString.match) {
			return null;
		}

		// dates in english format (2014-12-31 12:15:00) with or without time
		parts = dateString.match(/^(\d+)-(\d+)-(\d+)\s?(\d*):?(\d*):?(\d*)$/);
		if (parts) {
			return new Date(parts[1], parts[2] - 1, parts[3], parts[4] || '0', parts[5] || '0', parts[6] || '0');
		}

		// dates in german format (31.12.2014 12:15:00) with or without time
		parts = dateString.match(/^(\d+)\.(\d+)\.(\d+)\s?(\d*):?(\d*):?(\d*)$/);
		if (parts) {
			return new Date(parts[3], parts[2] - 1, parts[1], parts[4] || '0', parts[5] || '0', parts[6] || '0');
		}

		// dates in eCommerce format (1364560948000+0100)
		parts = dateString.match(/^(\d+)\+\d+$/);
		if (parts) {
			return new Date(parseInt(parts[1], 10));
		}

		// no match found -> try converting it to an integer
		date = new Date(parseInt(dateString, 10));
		if (date && !isNaN(date.getTime())) {
			return date;
		}

		return null;
	}

	/**
	 * Converts a date object into a formatted date (and optional time) string
	 * @method format
	 *
	 * @param {Date} date
	 *
	 * @param {object} [options] - Configure the format
	 * @param {bool} [options.english=false] - Formats the date in english format if TRUE ('2014-12-31' instead of '31.12.2014')
	 * @param {bool} [options.utc=false] - Converts the date to UTC if true
	 * @param {bool} [options.shortYear=false] - Formats the year as two digit value if TRUE ('14' instead of '2014')
	 * @param {bool} [options.time=false] - Includes the time if TRUE - only date is included by default
	 * @param {bool} [options.seconds=false] - Includes the seconds time if TRUE and TIME option is set - only hours and minutes are included by default
	 *
	 * @returns {string} - For example '31.12.2014', '31.12.14' or '2014-12-31 15:13:00'
	 */
	function format(date, options) {
		if (!date || !date.getTime || isNaN(date.getTime())) {
			return null;
		}

		options = $.extend({
			english: false,
			utc: false,
			shortYear: false,
			time: false,
			seconds: false
		}, options);

		var day = zeroFill(options.utc ? date.getUTCDate() : date.getDate()),
			month = zeroFill((options.utc ? date.getUTCMonth() : date.getMonth()) + 1),
			year = (options.utc ? date.getUTCFullYear() : date.getFullYear()).toString().substr(options.shortYear ? 2 : 0),
			hours = zeroFill(options.utc ? date.getUTCHours() : date.getHours()),
			minutes = zeroFill(options.utc ? date.getUTCMinutes() : date.getMinutes()),
			seconds = zeroFill(options.utc ? date.getUTCSeconds() : date.getSeconds()),
			time = (options.time ? (' ' + hours + ':' + minutes + (options.seconds ? (':' + seconds) : '')) : '');

		return (options.english ? (year + '-' + month + '-' + day) : (day + '.' + month + '.' + year)) + time;
	}

	/**
	 * Resets the time of a given date to zero (eg. 31.12.2014 00:00:00)
	 * @method resetTime
	 * @param {Date} date
	 * @returns {Date} - new date instance (original date is left as it is - pass by value)
	 */
	function resetTime(date) {
		var startOfDay = new Date(date);
		startOfDay.setHours(0);
		startOfDay.setMinutes(0);
		startOfDay.setSeconds(0);
		startOfDay.setMilliseconds(0);
		return startOfDay;
	}

	/**
	 * Resets the time of a given date to midnight (eg. 31.12.2014 23:59:59)
	 * @method endOfDay
	 * @param {Date} date
	 * @returns {Date} - new date instance (original date is left as it is - pass by value)
	 */
	function endOfDay(date) {
		var endOfDay = new Date(date);
		endOfDay.setHours(23);
		endOfDay.setMinutes(59);
		endOfDay.setSeconds(59);
		endOfDay.setMilliseconds(999);
		return endOfDay;
	}


	/**
	 * Render opening hours (blocks of work time)
	 *
	 * @method formatDailyHours
	 * @param {int} hours - the time in hours (9.5 => 9:30)
	 * @param {boolean} pad - should numbers be padded (unclear)
	 * @param {Object} locales - hash-map of localization labels
	 * @returns {String} ex. `09.00-11.30 Uhr & 13.00-16.30 Uhr`
	 */
	function formatDailyHours(hours, pad, locales) {
		var pairs = [];
		pad = pad ? 2 : 1;
		locales = locales || {};
		var timeDelim = locales.timeDelim;
		var hourDelim = locales.hourDelim;
		if (typeof timeDelim !== 'string') { timeDelim = '.'; }
		if (typeof hourDelim !== 'string') { hourDelim = ' & '; }
		if (!hours) { return locales.closed; }
		for (var i = 0; i < hours.length; i += 2) {
			var start = hours[i+0], end = hours[i+1];
			if (Math.abs(start - end) > 0) {
				var parts = [ SCS.utils.formatTime(start, timeDelim, pad) ];
				if (start !== end) { parts.push(SCS.utils.formatTime(end, timeDelim, pad)); }
				pairs.push(parts.join(locales.timeSeqDelim || '-') + ' ' + locales.clock);
			}
		}
		if (pairs.length) {
			return pairs.join(hourDelim);
		} else {
			return locales.closed;
		}
	}

	// upgrade alternative config to internaly used config
	// accepts one or multiple input arguments (varargs)
	function parseOpeningHours(openingHours) {

		var i;

		// assert for at least one argument
		if (!openingHours) { return false; }

		// return if input argument is already a valid constraints data object
		if (typeof openingHours === 'object' && openingHours.week) { return openingHours; }

		// create new config
		// closed all day long
		var config = {
			day: {}, // daily exceptions
			week: [
				true, // monday (true = inherit)
				true, // tuesday (true = inherit)
				true, // wednesday (true = inherit)
				true, // thursday (true = inherit)
				true, // friday (true = inherit)
				false,// saturday (false = closed)
				false // sunday (false = closed)
			],
			hours: false,
			time: true
		};

		var rules = [];
		// aggregate input from varargs
		for (i = 0; i < arguments.length; i += 1) {
			if (typeof arguments[i] === 'string') {
				rules.push(arguments[i]);
			} else if (arguments[i].length) {
				rules = rules.concat(arguments[i]);
			}
		}

		// weekdays are needed to create mapping from parsed to index
		var weekdays = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];

		// parse all rules into constraints data
		for (i = 0; i < rules.length; i += 1) {
			// split rule into fragments (hope I got it right)
			var fragments = rules[i].split(/(?:\s*,\s*|\s+)/);
			// assert for minimal parsed fragments
			if (fragments.length < 3) { continue; }
			// get last two items for opening hours block
			var to = fragments.pop(), from = fragments.pop();
			for (var n = 0; n < fragments.length; n += 1) {
				// get fragment to check if it is a weekday
				var fragment = fragments[n].toLowerCase();
				var weekday = weekdays.indexOf(fragment);
				// found a rule that includes a date
				if (fragments[n].match(/^0*(\d+)\.0*(\d+)\.?$/)) {
					var sel = [RegExp.$1, RegExp.$2].join('.');
					config.day[sel] = updateOpeningHours(config.day[sel], toHours(from), toHours(to));
				}
				// found a rule for weekday
				else if (weekday !== -1) {
					config.week[weekday] = updateOpeningHours(config.week[weekday], toHours(from), toHours(to));
				}
			}
		}
		return config;
	}
	// EO parseOpeningHours

	// add opening hours properly to a week config, evne if there are already other opening hours definied previously
	function updateOpeningHours(config, from, to) {
		// when we need to update the values already in that config
		if(!config || !config.length) {
			return [from, to];
		} else {
			var addedToExisting = false;
			var niceConfig = [];
			for(var i = 0; i < config.length; i+=2) {
				niceConfig.push([config[i*2+0], config[i*2+1]]);
			}
			$.each(niceConfig, function(i, span) {
				// new span total before old or
				// new span is total after old
				if(to < span[0] || from > span[1]) {
					return;
				}
				if(from < span[0] && to > span[0] && to < span[1]) {
					// new span starts before and ends within
					niceConfig[i][0] = from;
				} else if(from > span[0] && from < span[1] && to > span[1]) {
					// new span starts within and ends after
					niceConfig[i][1] = to;
				} else if(from < span[0] && to > span[1]) {
					// new span widens the old on both sides
					niceConfig[i][0] = from;
					niceConfig[i][1] = to;
				}
				addedToExisting = true;
			});
			if(!addedToExisting) {
				// if its a span before
				if(to < config[0]) {
					niceConfig.unshift([from, to]);
				// if its a span after
				} else {
					niceConfig.push([from, to]);
				}
			}
			config = [];
			$.each(niceConfig, function(i, span) {
				config.push(span[0]);
				config.push(span[1]);
			});
			return config;
		}
	}
	// EO updateOpeningHours



	/**
	 * Parse a date string into date object
	 * Main support for date-picker, but also suited
	 * for all date inputs from desktop browsers and
	 * inputs from mobile browser with input type date.
	 *
	 * Dektop: 'D.M.YYYY'
	 * Mobile: 'YYYY-M-D'
	 *
	 * @method parseDay
	 * @param {String} daystr - date string in compatible form
	 * @param {Boolean} strict - disable overflow (default true)
	 * @returns {Date} date object (zero time) or null/false
	 */
	function parseDateDay(daystr, strict) {

		var fragments;
		// use object prototype to check if we have already a real date object
		if (Object.prototype.toString.call(daystr) === '[object Date]') { return daystr; }
		// defaults to true if argument is omitted
		if (arguments.length < 2) { strict = true; }
		// base validate assertion
		if (!daystr) { return null; }
		// match default desktop format: `D.M.YYYY`
		else if (daystr.match(/^\d{1,2}\.\d{1,2}\.\d{4}$/)) {
			fragments = daystr.split('.');
		}
		// match default mobile format: `YYYY-M-D`
		else if (daystr.match(/^\d{4}\-\d{1,2}\-\d{1,2}$/)) {
			fragments = daystr.split('-').reverse();
		}
		// incompatible format?
		if (!fragments) { return null; }
		// convert each part to integer
		var day = parseInt(fragments[0], 10),
			month = parseInt(fragments[1], 10),
			year = parseInt(fragments[2], 10);
		// create date object (some parts could overflow)
		var date = new Date(year, month - 1, day);
		// adjust for local timezone (if it was utc)
		// var tzoff = date.getTimezoneOffset() * 60;
		// date.setTime(date.getTime() - tzoff * 1000);

		// is overflow is allowed?
		if (!strict) { return date; }
		// check if no overflow occurred
		return (date.getDate() === day) &&
			(date.getFullYear() === year) &&
			(date.getMonth() + 1 === month) &&
			date; // returns date if all true
	}

	/**
	 * compare two dates if the are on the same day
	 * can be used to sort arrays of date objects
	 *
	 * @method compareDays
	 * @param {Date} a - first date object to compare
	 * @param {Date} b - second date object to compare
	 * @returns {int} 0 for same day, -1 if a < b, 1 if b > a;
	 */
	function compareDays(a, b) {
		// check if date are the same days
		if (a.getFullYear() === b.getFullYear() &&
			a.getMonth() === b.getMonth() &&
			a.getDate() === b.getDate()
		) {
			return 0;
		}
		// or compare dates
		return a < b ? -1 : 1;
	}

	/**
	 * get opening hours for specific day
	 * returns false if the day is closed
	 * but may also return an empty array
	 *
	 * @method getOpeningHours
	 * @param {Date} date - date object (time not used)
	 * @param {Object} config - business hours settings
	 * @returns {Array} list of opening blocks
	 */
	function getOpeningHours(date, config) {
		/* jslint maxdepth: 4 */
		// create on demand
		if (!config.day) {
			config.day = {};
		}
		// dereferenced variable access
		var oDay = config.day,
			oWeek = config.week,
			oHours = config.hours,
			oSpecial = config.special;
		// relevant date parts
		var day = date.getDate(),
			month = date.getMonth(),
			year = date.getFullYear();
		// inflate special days and add to normal day
		// we need to do this once for every year we see
		// use a flag to indicate which years are done
		if (oSpecial && !oSpecial[year]) {
			oSpecial[year] = true;
			for (var sday in oSpecial) {
				if (oSpecial.hasOwnProperty(sday)) {
					if (sday.match(/^easter([\+\-]\d+)?/)) {
						// get the easter date for the given year
						var edate = easterDate(date.getFullYear());
						// add optional offset to easter date (days)
						edate.setDate(edate.getDate() + parseInt(RegExp.$1 || 0, 10));
						// create the key for the working hours day (oDay) settings
						var ekey = [edate.getDate(), edate.getMonth() + 1, year].join('.');
						// attach easter config to day config now
						oDay[ekey] = oSpecial[sday];
					}
				}
			}
		}
		// create keys for day exception
		var mDay = day + '.' + (month + 1);
		var yDay = mDay + '.' + year;
		// check if date is a special year day
		// check if we have settings for day of year
		var yDayHours = oDay ? oDay[ yDay ] : undefined;
		if (yDayHours !== undefined) { return yDayHours; }
		// check if we have settings for day of month
		var mDayHours = oDay ? oDay[ mDay ] : undefined;
		if (mDayHours !== undefined) { return mDayHours; }
		// check if we have settings for day of week
		var wDayHours = oWeek ? oWeek[ date.getDay() ] : undefined;
		// if the value is true we want to let it "bubble" through
		if (wDayHours !== undefined && wDayHours !== true) { return wDayHours; }
		// fallback to the general opening hours
		return oHours || !config.time && [ 8, 17 ];
	}

	/**
	 * Get date of easter the given year
	 * ToDo: need to check for source attribution
	 * ToDo: might be hard to find out real origin
	 * ToDo: seems to be out in the wild for a while
	 * http://www.irt.org/articles/js052/index.htm
	 * http://stackoverflow.com/questions/1284314/easter-date-in-javascript
	 * http://coderzone.org/library/Get-Easter-Date-for-any-year-in-Javascript_1059.htm
	 *
	 * @method easterDate
	 * @param {int} year - full year (ie 2015)
	 * @returns {Date} easter date (with UTC time 12:00)
	 */
	function easterDate(Y) {
		var C = Math.floor(Y/100);
		var N = Y - 19*Math.floor(Y/19);
		var K = Math.floor((C - 17)/25);
		var I = C - Math.floor(C/4) - Math.floor((C - K)/3) + 19*N + 15;
		I = I - 30*Math.floor((I/30));
		I = I - Math.floor(I/28)*(1 - Math.floor(I/28)*Math.floor(29/(I + 1))*Math.floor((21 - N)/11));
		var J = Y + Math.floor(Y/4) + I + 2 - C + Math.floor(C/4);
		J = J - 7*Math.floor(J/7);
		var L = I - J;
		var M = 3 + Math.floor((L + 40)/44);
		var D = L + 28 - 31*Math.floor(M/4);
		return new Date(Date.UTC(Y, M - 1, D, 12));
	}

	/**
	 * Get minimum date given by constraints
	 *
	 * @method getMinDate
	 * @param {Date} date - date object (time is used)
	 * @param {Object} config - date constraint data
	 * @returns {Date} min date for the given constraint
	 */
	function getMinDate(date, config) {
		// relative date from config
		var minDate = config.minDate;
		// normalize invalid passed argument
		// this needs to be fixed in some jsp
		if (minDate === -1) { minDate = null; }
		// we either accept a date object or an offset from current date
		if (Object.prototype.toString.call(minDate) !== '[object Date]') {
			if (minDate !== null && typeof minDate !== 'undefined') {
				minDate = addWorkDays(date, config, minDate || 0);
			}
		}
		// handle waiting period
		if (config.wPeriod) {
			// wait period is applied to either minDate or date
			// we never allow any past dates if the option is set
			minDate = nextAvailableDate(minDate || date, config);
		}
		// return if date is false or time preserved
		if (!minDate || config.time) { return minDate; }
		// reset date to first possible time of day
		return resetTime(minDate);
	}

	/**
	 * Get maximum date given by constraints
	 *
	 * @method getMaxDate
	 * @param {Date} date - date object (time is used)
	 * @param {Object} config - date constraint data
	 * @returns {Date} max date for the given constraint
	 */
	function getMaxDate(date, config) {
		// relative date from config
		var maxDate = config.maxDate;
		// normalize invalid passed argument
		// this needs to be fixed in some jsp
		if (maxDate === -1) { maxDate = null; }
		// we either accept a date object or an offset from current date
		if (Object.prototype.toString.call(maxDate) !== '[object Date]') {
			if (maxDate !== null && typeof maxDate !== 'undefined') {
				maxDate = addWorkDays(date, config, maxDate || 0);
			}
		}
		// return if date is false or time preserved
		if (!maxDate || config.time) { return maxDate; }
		// reset date to last possible time of day
		return endOfDay(maxDate);
	}

	/**
	 * Check if date is in range constraint
	 * Tests for `minDate` and `maxDate`
	 * Both ends are optional, so if nothing
	 * is given on config, always return true.
	 *
	 * @method isInDayRange
	 * @param {Date} date - date object (time not used)
	 * @param {Object} config - uses `minDate` and `maxDate`
	 * @returns {Boolean} true if between minDate and maxDate
	 */
	function isInDayRange(date, config) {

		// optional argument from config
		// mostly used for unit testing
		var now = config.now || new Date();

		// absolute or relative min/max dates
		var minDate = getMinDate(now, config),
			maxDate = getMaxDate(now, config);
		// finally check the min/max constraints
		return (!minDate || date >= minDate) && (!maxDate || date <= maxDate);
	}

	/**
	 * Check if given date is a work day
	 * Meaning we have some opening hours
	 *
	 * @method isWorkDay
	 * @param {Date} date - date object (time not used)
	 * @param {Object} config - constraint data
	 * @returns {Boolean} true if it open that day
	 */
	function isWorkDay(date, config) {
		// get opening hours for day from config
		var hours = getOpeningHours(date, config);
		// compatibility for old option
		if (config.dateNoWeekends) {
			var dayOfWeek = date.getDay();
			if (dayOfWeek === 0) { return false; } // sun
			if (dayOfWeek === 6) { return false; } // sat
		}
		// check if day has opening hours (returns them)
		return hours && hours.length > 0 ? hours : false;
	}

	/**
	 * Check if given day is a valid day
	 * Meaning we have some opening hours
	 * And we can still book appointments
	 * Basically this returns true only if
	 * there is at least one valid date for
	 * that day (determined by isValidDate).
	 *
	 * @method isValidDay
	 * @param {Date} date - date object (time not used)
	 * @param {Object} config - constraint data
	 * @returns {Boolean} true if day has valid times
	 */
	function isValidDay(date, config) {
		// get opening hours via work day check
		var hours = isWorkDay(date, config);
		// return early if no workday
		if (!hours) { return false; }
		// no time checks if option not set
		// if (!config.time) { return hours; }
		// make sure we have a valid time
		var now = config.now || new Date();
		// check further constraints for current day
		// we may have some min date constraints, which
		// means we need to check if minDate can have
		// some time which satisfies the constraints.
		var minDate = getMinDate(now, config),
			maxDate = getMaxDate(now, config);

		// we may not have a min date constraint
		if (!minDate) { minDate = new Date('Jan 1 1900 00:00:00'); }
		if (!maxDate) { maxDate = new Date('Jan 1 2900 23:59:59'); }

		if (config.maxDate >= 0 && !config.time) {
			maxDate = endOfDay(maxDate);
		}
		// compare days of min date and date to test
		var cmpMinDays = compareDays(date, minDate),
			cmpMaxDays = compareDays(date, maxDate);
		// check min date constraint
		if (cmpMinDays === 0) {
			// get time of date to be checked
			var time = toHours(minDate);
			// get last possible valid time (closing)
			var closing = hours[hours.length-1];
			// normaly we exclude closing time
			if (!config.includeClosingTime) {
				if (time === closing) { return false; }
				closing -= config.interval || 0;
			}
			// store may already be closed up
			if (closing < time) { return false; }
		}
		// obey date range conditions
		if (cmpMinDays < 0) {
			return false;
		}
		if (cmpMaxDays > 0) {
			return false;
		}
		// must be upcoming work day
		return hours;
	}

	/**
	 * Check if given date and time are valid
	 * Constraints can be simple min/max or more
	 * complex checkings as for a valid appointment
	 * within opening hours (with a waiting period)
	 *
	 * @method isValidDate
	 * @param {Date} date - date object (time not used)
	 * @param {Object} config - constraint data
	 * @returns {Boolean} true if date is valid
	 */
	function isValidDate(date, config) {
		// run cheapest tests (workday and range check)
		// if (!isWorkDay(date, config)) { return false; }
		if (!isValidDay(date, config)) { return false; }
		if (!isInDayRange(date, config)) { return false; }
		// get opening hours for day from config
		var hours = getOpeningHours(date, config);
		// with disabled time a simple `isWorkDay`check is enough
		if (!config.time) { return hours && hours.length > 0; }
		// then check if the time is insisde opening hours
		var time = toHours(date);
		// check all opening hour blocks
		for (var n = 0; n < hours.length; n += 2) {
			// just to be sure we do good math
			// could be disabled for performance
			var opening = Math.min(hours[n+0], hours[n+1]),
				closing = Math.max(hours[n+1], hours[n+0]);
			// return success if time was found to be open
			// the closing time itself is not valid
			if (opening <= time && time <= closing) {
				// obey special option to include closing time (inline check)
				if (!config.includeClosingTime && time === closing) { return false; }
				// optionally check if time obeys interval
				var interval = (config.interval || 0);
				return !interval || (time - opening) % interval === 0;
			}
		}
		// store closed
		return false;
	}

	/**
	 * Convert date object, string ('11:30', '9.5') or number (9.5)
	 * to floating number representing the time denominated in hours
	 *
	 * @method toHours
	 * @param {Date|string} date - input
	 * @returns {float} time in hours (0-24+)
	 */
	function toHours(date) {
		// use object prototype to reveal sepecific type
		var type = Object.prototype.toString.call(date);
		// convert from date object
		if (type === '[object Date]') {
			return date.getHours() +
				date.getMinutes() / 60 +
				date.getSeconds() / 3600 +
				date.getMilliseconds() / 360000;
		}
		// convert from a string (ie '11:30')
		// all parts optional and can be floats
		else if (type === '[object String]') {
			var part = date.split(':');
			return parseFloat(part[0] || 0, 10) +
				parseFloat(part[1] || 0, 10) / 60 +
				parseFloat(part[2] || 0, 10) / 3600;
		}
		// otherwise try to convert to float
		else { return parseFloat(date || 0, 10); }
	}

	/**
	 * Add days to a date object (return copy)
	 * This also works for negative offsets
	 *
	 * @method addDays
	 * @param {Date} date - input date to be offset
	 * @param {Date} offset - number of days to offset
	 * @returns {Date} date plus offset (might be negative)
	 */
	function addDays(date, offset) {
		var cpy = new Date(date);
		cpy.setDate(cpy.getDate() + offset);
		return cpy;
	}

	/**
	 * Add work days to date object (return copy)
	 * Holidays are not counted when skipped
	 * This also works for negative offsets
	 *
	 * @method addDays
	 * @param {Date} date - input date to be offset
	 * @param {Date} offset - number of days to offset
	 * @returns {Date} date plus offset (might be negative)
	 */
	function addWorkDays(date, config, offset) {
		var cpy = new Date(date);
		var sign = offset < 0 ? -1 : 1;
		var wDays = Math.round(Math.abs(offset));
		// using `-1` is same as `0` but instead
		// of going forward, it goes backwards
		if (sign < 0) {
			wDays -= 1;
		}
		// loop with abort condition
		while (true) {
			// just skip over any holidays
			while (!isWorkDay(cpy, config)) {
				cpy.setDate(cpy.getDate() + sign);
			}
			// have a workday now
			// decrease days to go
				wDays -= 1;
			// check abort condition
			if (wDays <= -0.5) {
				break;
			}
			// move the date iteration object
			cpy.setDate(cpy.getDate() + sign);
		}
		return cpy;
	}

	/**
	 * Calculate next available appointment from date
	 * Employees may need time to prepare appointment
	 * Waiting Period can also be set directly on config
	 *
	 * @method nextAvailableDate
	 * @param {Date} date - date object (time not used)
	 * @param {Object} config - business hours settings
	 * @param {int} wPeriod - waiting period (hours)
	 * @returns {Date} next available appointment
	 */
	function nextAvailableDate(date, config, wPeriod) {

		/* jslint maxdepth: 5 */

		// get a new date object copy
		// also main return object
		var slot = new Date(date);

		// ensure valid number from optional arg or config
		wPeriod = parseFloat(wPeriod || config.wPeriod || 0, 10);

		// need fine grained loop control
		// easier to handle edge cases
		while (true) {
			// get opening hour blocks for the slot day
			var hours = getOpeningHours(slot, config);

			// get hours from date object as float
			var start = toHours(slot);

			// don't need the time part anymore on slot
			// re-calculated from wPeriod and work blocks
			// we just increment the day in the loop below
			slot = resetTime(slot);

			// are there some opening hours?
			if (hours && hours.length > 0) {

				// increment for next available timeslot
				// during the loop we deduct from wPeriod
				for (var n = 0; n < hours.length; n += 2) {

					// just to be sure we do good math
					// could be disabled for performance
					var opening = Math.min(hours[n+0], hours[n+1]),
						closing = Math.max(hours[n+1], hours[n+0]);

					// store is not closed
					if (start <= closing) {
						// start is before opening
						if (start < opening) {
							// move start to opening
							start = opening;
						}
						// deduct time spent in block
						wPeriod -= closing - start;
						// check stop condition
						if (wPeriod <= 0) {
							// calculate final time
							var time = closing + wPeriod;
							// set the time for the slot
							slot.setSeconds(time * 3600 + 0.5);
							// return date object
							return slot;
						}

					}
					// EO if not closed

				}
				// EO for hours loop

			}
			// EO if opening hours

			// move date slot to the next day
			slot.setDate(slot.getDate() + 1);
			start = 0; // reset start time

		}
		// EO while true

		// return date object
		return slot;

	}
	// EO nextAvailableDate

	SCS.utils.date = {
		fromString: fromString,
		format: format,
		resetTime: resetTime,
		endOfDay: endOfDay,
		formatDailyHours: formatDailyHours,
		parseOpeningHours: parseOpeningHours,
		updateOpeningHours: updateOpeningHours,
		parseDateDay: parseDateDay,
		compareDays: compareDays,
		getOpeningHours: getOpeningHours,
		easterDate: easterDate,
		getMinDate: getMinDate,
		getMaxDate: getMaxDate,
		isInDayRange: isInDayRange,
		isWorkDay: isWorkDay,
		isValidDay: isValidDay,
		isValidDate: isValidDate,
		toHours: toHours,
		addDays: addDays,
		addWorkDays: addWorkDays,
		nextAvailableDate: nextAvailableDate
	};
	// EO SCS.utils.date

	/**
	 * Compares two version strings of the format '1.8.3'
	 *
	 * Returns
	 * -1	if the first string is newer/higher
	 *	0	if the strings are equal
	 *	1	if the second string is newer/higher
	 *
	 * @param versionStringOne
	 * @param versionStringTwo
	 * @returns {number}
	 */
	SCS.utils.compareVersions = function(versionStringOne, versionStringTwo) {
		var versionValuesOne = SCS.utils.getVersionNumberArray(versionStringOne),
			versionValuesTwo = SCS.utils.getVersionNumberArray(versionStringTwo),
			maxValuesToCompare = Math.min(versionValuesOne.length, versionValuesTwo.length),
			compareStatus = 0;

		for(var i = 0; i < maxValuesToCompare && compareStatus === 0; i += 1){
			if(versionValuesOne[i] > versionValuesTwo[i]) {
				compareStatus = -1;
			}
			else if(versionValuesOne[i] < versionValuesTwo[i]) {
				compareStatus = 1;
			}
		}

		return compareStatus;
	};

	/**
	 * Turns a version string of format '1.2.3' into an array of int values
	 * @param versionString
	 * @returns {Array}
	 */
	SCS.utils.getVersionNumberArray = function(versionString) {
		var versionValues = versionString && versionString.split('.') || [];
		for(var i = 0; i < versionValues.length; i += 1){
			versionValues[i] = parseInt(versionValues[i], 10);
		}

		return versionValues;
	};

	// FIXME: Remove once unused
	SCS.utils.formatString = __webpack_require__(23).format;

	/**
	 * Frontend caching system functions
	 *
	 * @namespace SCS.utils.cache
	 */
	SCS.utils.cache =  {
		/**
		 * This function caches given data to the browser localstorage and adds the
		 * timestamp that indicates untill the cached data are valid.
		 *
		 * @method cacheData
		 * @memberof SCS.utils.cache
		 * @param {JSON} data Data to be cached
		 * @param {String} dataId localstorage key under which the given data are
		 * stored
		 * @param {Number} validCachePeriod Time in milliseconds that indicates how
		 * long the cached data is considered to be valid.
		 * @returns void
		 */
		cacheData: function (data, dataId, validCachePeriod) {
			var storeData = {
				data: data,
				expireTime: (new Date()).getTime() + (validCachePeriod || 0)
			};
			localStorage.setItem(dataId, JSON.stringify(storeData));
		},
		/**
		 * This function returns cached data for the given key value. If data does
		 * not exists or cache timestamp is expired this function returns null.
		 *
		 * @method getCacheData
		 * @memberof SCS.utils.cache
		 * @param {String} dataId localstorage key under which the given data are
		 * stored
		 * @returns Cached data or null
		 */
		getCacheData: function (dataId) {
			var cachedData = localStorage.getItem(dataId);
			if(cachedData) {
				cachedData = JSON.parse(cachedData);
				if(cachedData.expireTime && (cachedData.expireTime - (new Date()).getTime()) >= 0) {
					return cachedData.data;
				} else {
					localStorage.removeItem(dataId);
				}
			}
			return null;
		}
	};
}(__webpack_provided_window_dot_$ || __webpack_provided_window_dot_Tc_dot_$, window.SCS = window.SCS || {}));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0), __webpack_require__(0)))

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_scsHeaderJQuery, __webpack_provided_window_dot_jQuery, jQuery) {/**
 * WARNING - Two small changes by Swisscom: look for "scsHeaderJQuery"
 *
 * Copyright (c) 2005 - 2010, James Auldridge
 * All rights reserved.
 *
 * Licensed under the BSD, MIT, and GPL (your choice!) Licenses:
 * http://code.google.com/p/cookies/wiki/License
 *
 */
var jaaulde=window.jaaulde||{};jaaulde.utils=jaaulde.utils||{};jaaulde.utils.cookies=(function(){var resolveOptions,assembleOptionsString,parseCookies,constructor,defaultOptions={expiresAt:null,path:'/',domain:null,secure:false};resolveOptions=function(options){var returnValue,expireDate;if(typeof options!=='object'||options===null){returnValue=defaultOptions;}else
{returnValue={expiresAt:defaultOptions.expiresAt,path:defaultOptions.path,domain:defaultOptions.domain,secure:defaultOptions.secure};if(typeof options.expiresAt==='object'&&options.expiresAt instanceof Date){returnValue.expiresAt=options.expiresAt;}else if(typeof options.hoursToLive==='number'&&options.hoursToLive!==0){expireDate=new Date();expireDate.setTime(expireDate.getTime()+(options.hoursToLive*60*60*1000));returnValue.expiresAt=expireDate;}if(typeof options.path==='string'&&options.path!==''){returnValue.path=options.path;}if(typeof options.domain==='string'&&options.domain!==''){returnValue.domain=options.domain;}if(options.secure===true){returnValue.secure=options.secure;}}return returnValue;};assembleOptionsString=function(options){options=resolveOptions(options);return((typeof options.expiresAt==='object'&&options.expiresAt instanceof Date?'; expires='+options.expiresAt.toGMTString():'')+'; path='+options.path+(typeof options.domain==='string'?'; domain='+options.domain:'')+(options.secure===true?'; secure':''));};parseCookies=function(){var cookies={},i,pair,name,value,separated=document.cookie.split(';'),unparsedValue;for(i=0;i<separated.length;i=i+1){pair=separated[i].split('=');name=pair[0].replace(/^\s*/,'').replace(/\s*$/,'');try
{value=decodeURIComponent(pair[1]);}catch(e1){value=pair[1];}if(typeof JSON==='object'&&JSON!==null&&typeof JSON.parse==='function'){try
{unparsedValue=value;value=JSON.parse(value);}catch(e2){value=unparsedValue;}}cookies[name]=value;}return cookies;};constructor=function(){};constructor.prototype.get=function(cookieName){var returnValue,item,cookies=parseCookies();if(typeof cookieName==='string'){returnValue=(typeof cookies[cookieName]!=='undefined')?cookies[cookieName]:null;}else if(typeof cookieName==='object'&&cookieName!==null){returnValue={};for(item in cookieName){if(typeof cookies[cookieName[item]]!=='undefined'){returnValue[cookieName[item]]=cookies[cookieName[item]];}else
{returnValue[cookieName[item]]=null;}}}else
{returnValue=cookies;}return returnValue;};constructor.prototype.filter=function(cookieNameRegExp){var cookieName,returnValue={},cookies=parseCookies();if(typeof cookieNameRegExp==='string'){cookieNameRegExp=new RegExp(cookieNameRegExp);}for(cookieName in cookies){if(cookieName.match(cookieNameRegExp)){returnValue[cookieName]=cookies[cookieName];}}return returnValue;};constructor.prototype.set=function(cookieName,value,options){if(typeof options!=='object'||options===null){options={};}if(typeof value==='undefined'||value===null){value='';options.hoursToLive=-8760;}else if(typeof value!=='string'){if(typeof JSON==='object'&&JSON!==null&&typeof JSON.stringify==='function'){value=JSON.stringify(value);}else
{throw new Error('cookies.set() received non-string value and could not serialize.');}}var optionsString=assembleOptionsString(options);document.cookie=cookieName+'='+encodeURIComponent(value)+optionsString;};constructor.prototype.del=function(cookieName,options){var allCookies={},name;if(typeof options!=='object'||options===null){options={};}if(typeof cookieName==='boolean'&&cookieName===true){allCookies=this.get();}else if(typeof cookieName==='string'){allCookies[cookieName]=true;}for(name in allCookies){if(typeof name==='string'&&name!==''){this.set(name,null,options);}}};constructor.prototype.test=function(){var returnValue=false,testName='cT',testValue='data';this.set(testName,testValue);if(this.get(testName)===testValue){this.del(testName);returnValue=true;}return returnValue;};constructor.prototype.setOptions=function(options){if(typeof options!=='object'){options=null;}defaultOptions=resolveOptions(options);};return new constructor();})();(function(){if(__webpack_provided_window_dot_scsHeaderJQuery || __webpack_provided_window_dot_jQuery){(function($){$.cookies=jaaulde.utils.cookies;var extensions={cookify:function(options){return this.each(function(){var i,nameAttrs=['name','id'],name,$this=$(this),value;for(i in nameAttrs){if(!isNaN(i)){name=$this.attr(nameAttrs[i]);if(typeof name==='string'&&name!==''){if($this.is(':checkbox, :radio')){if($this.attr('checked')){value=$this.val();}}else if($this.is(':input')){value=$this.val();}else
{value=$this.html();}if(typeof value!=='string'||value===''){value=null;}$.cookies.set(name,value,options);break;}}}});},cookieFill:function(){return this.each(function(){var n,getN,nameAttrs=['name','id'],name,$this=$(this),value;getN=function(){n=nameAttrs.pop();return!!n;};while(getN()){name=$this.attr(n);if(typeof name==='string'&&name!==''){value=$.cookies.get(name);if(value!==null){if($this.is(':checkbox, :radio')){if($this.val()===value){$this.attr('checked','checked');}else
{$this.removeAttr('checked');}}else if($this.is(':input')){$this.val(value);}else
{$this.html(value);}}break;}}});},cookieBind:function(options){return this.each(function(){var $this=$(this);$this.cookieFill().change(function(){$this.cookify(options);});});}};$.each(extensions,function(i){$.fn[i]=this;});})(__webpack_provided_window_dot_scsHeaderJQuery || jQuery);}})();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0), __webpack_require__(0), __webpack_require__(0)))

/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["init"] = init;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_body_scroll_lock__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_body_scroll_lock___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_body_scroll_lock__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Utils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Inputs__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__DomElement__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DomFunctions__ = __webpack_require__(15);






var CLASS_BACKDROP = "backdrop";
var CLASS_BACKDROP_OPEN = "backdrop--open";
var CLASS_OPEN = "modal--open";
var CLASS_TRIGGER = "modal-trigger";
var CLASS_BODY = "modal__body";
var CLASS_BUTTONS_OKAY = ".modal-close";
var CLASS_BUTTONS_CLOSE = ".modal-cancel";
/**
 * A component to open and close modal dialogs. It also handles cancellation and makes
 * sure that the modal background is present in the DOM.
 */
var Modal = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */])(Modal, _super);
    function Modal(element) {
        var _this = _super.call(this, element) || this;
        _this._okayHandler = _this.close.bind(_this);
        _this._cancelHandler = _this._handleClick.bind(_this);
        _this._keydownHandler = _this._handleKeydown.bind(_this);
        _this._initialize();
        return _this;
    }
    /**
     * Initializes the range modal component.
     * @private
     */
    Modal.prototype._initialize = function () {
        // Create the backdrop
        this._backdrop = new __WEBPACK_IMPORTED_MODULE_4__DomElement__["a" /* default */]("div").addClass(CLASS_BACKDROP);
        this._backdropParent = Object(__WEBPACK_IMPORTED_MODULE_5__DomFunctions__["d" /* getRootElement */])();
        this._subscribeToTrigger();
    };
    Modal.prototype._subscribeToTrigger = function () {
        var e_1, _a;
        var triggerId = this.element.id;
        if (!triggerId) {
            return;
        }
        this._triggerClickHandler = this.open.bind(this);
        var triggerElements = document.querySelectorAll(".".concat(CLASS_TRIGGER, "[href=").concat(triggerId, "]"));
        try {
            for (var triggerElements_1 = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __values */])(triggerElements), triggerElements_1_1 = triggerElements_1.next(); !triggerElements_1_1.done; triggerElements_1_1 = triggerElements_1.next()) {
                var triggerElement = triggerElements_1_1.value;
                triggerElement.addEventListener("click", this._triggerClickHandler);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (triggerElements_1_1 && !triggerElements_1_1.done && (_a = triggerElements_1.return)) _a.call(triggerElements_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
    };
    Modal.prototype._unsubscribeFromTrigger = function () {
        var e_2, _a;
        var triggerId = this.element.id;
        if (!triggerId) {
            return;
        }
        var triggerElements = document.querySelectorAll(".".concat(CLASS_TRIGGER, "[href=").concat(triggerId, "]"));
        try {
            for (var triggerElements_2 = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __values */])(triggerElements), triggerElements_2_1 = triggerElements_2.next(); !triggerElements_2_1.done; triggerElements_2_1 = triggerElements_2.next()) {
                var triggerElement = triggerElements_2_1.value;
                triggerElement.removeEventListener("click", this._windowClickHandler);
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (triggerElements_2_1 && !triggerElements_2_1.done && (_a = triggerElements_2.return)) _a.call(triggerElements_2);
            }
            finally { if (e_2) throw e_2.error; }
        }
        this._triggerClickHandler = undefined;
    };
    Modal.prototype._handleKeydown = function (event) {
        var keyboardEvent = event;
        var keycode = keyboardEvent.which || keyboardEvent.keyCode;
        if (keycode === __WEBPACK_IMPORTED_MODULE_3__Inputs__["f" /* KEY_ESCAPE */]) {
            // handle Escape key (ESC)
            this.cancel();
            return;
        }
    };
    Modal.prototype._handleClick = function (event) {
        Object(__WEBPACK_IMPORTED_MODULE_2__Utils__["e" /* preventDefault */])(event);
        this.cancel();
    };
    Modal.prototype._close = function () {
        var e_3, _a, e_4, _b;
        var _this = this;
        Object(__WEBPACK_IMPORTED_MODULE_1_body_scroll_lock__["enableBodyScroll"])(this.element);
        document.removeEventListener("keydown", this._keydownHandler);
        this._backdrop.element.removeEventListener("click", this._cancelHandler);
        this._backdrop.removeClass(CLASS_BACKDROP_OPEN);
        this.removeClass(CLASS_OPEN);
        try {
            for (var _c = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __values */])(this.element.querySelectorAll(CLASS_BUTTONS_CLOSE)), _d = _c.next(); !_d.done; _d = _c.next()) {
                var closeButton = _d.value;
                closeButton.removeEventListener("click", this._cancelHandler);
            }
        }
        catch (e_3_1) { e_3 = { error: e_3_1 }; }
        finally {
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            }
            finally { if (e_3) throw e_3.error; }
        }
        try {
            for (var _e = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __values */])(this.element.querySelectorAll(CLASS_BUTTONS_OKAY)), _f = _e.next(); !_f.done; _f = _e.next()) {
                var okayButton = _f.value;
                okayButton.removeEventListener("click", this._okayHandler);
            }
        }
        catch (e_4_1) { e_4 = { error: e_4_1 }; }
        finally {
            try {
                if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
            }
            finally { if (e_4) throw e_4.error; }
        }
        setTimeout(function () {
            // remove the backdrop from the body
            _this._backdropParent.removeChild(_this._backdrop.element);
        }, 300);
    };
    /**
     * Opens the modal dialog.
     * @fires Modal#opened
     */
    Modal.prototype.open = function () {
        var _this = this;
        Object(__WEBPACK_IMPORTED_MODULE_1_body_scroll_lock__["disableBodyScroll"])(this.element, {
            allowTouchMove: function (el) {
                var currentEl = el;
                while (currentEl && currentEl !== document.body) {
                    // Check if the user is scrolling the modal body
                    if (currentEl.classList.contains(CLASS_BODY)) {
                        // Check if the element overflows
                        if (currentEl.scrollHeight > currentEl.clientHeight) {
                            return true;
                        }
                    }
                    currentEl = currentEl.parentNode;
                }
                return false;
            },
        });
        // add the backdrop to the body
        this._backdropParent.appendChild(this._backdrop.element);
        // set the element to flex as it is initially hidden
        this.element.style.display = "flex";
        // remove the style after the animation completes
        setTimeout(function () {
            _this.element.style.display = "";
        }, 800);
        // wait a bit to allow the browser to catch up and show the animation
        setTimeout(function () {
            var e_5, _a, e_6, _b;
            _this.addClass(CLASS_OPEN);
            _this._backdrop.addClass(CLASS_BACKDROP_OPEN);
            document.addEventListener("keydown", _this._keydownHandler);
            _this._backdrop.element.addEventListener("click", _this._cancelHandler);
            try {
                for (var _c = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __values */])(_this.element.querySelectorAll(CLASS_BUTTONS_CLOSE)), _d = _c.next(); !_d.done; _d = _c.next()) {
                    var closeButton = _d.value;
                    closeButton.addEventListener("click", _this._cancelHandler);
                }
            }
            catch (e_5_1) { e_5 = { error: e_5_1 }; }
            finally {
                try {
                    if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                }
                finally { if (e_5) throw e_5.error; }
            }
            try {
                for (var _e = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __values */])(_this.element.querySelectorAll(CLASS_BUTTONS_OKAY)), _f = _e.next(); !_f.done; _f = _e.next()) {
                    var okayButton = _f.value;
                    okayButton.addEventListener("click", _this._okayHandler);
                }
            }
            catch (e_6_1) { e_6 = { error: e_6_1 }; }
            finally {
                try {
                    if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                }
                finally { if (e_6) throw e_6.error; }
            }
            _this.element.addEventListener("click", function (e) { return e.stopPropagation(); });
            _this.dispatchEvent("opened");
        }, 50);
    };
    /**
     * Cancels (and closes) the modal dialog.
     * @fires Modal#cancelled
     * @fires Modal#closed
     */
    Modal.prototype.cancel = function () {
        this.dispatchEvent("cancelled");
        this._close();
    };
    /**
     * Closes the modal dialog.
     * @fires Modal#closed
     */
    Modal.prototype.close = function () {
        this._close();
        this.dispatchEvent("closed");
    };
    /**
     * Destroys the component and frees all references.
     */
    Modal.prototype.destroy = function () {
        this.cancel();
        this._unsubscribeFromTrigger();
    };
    return Modal;
}(__WEBPACK_IMPORTED_MODULE_4__DomElement__["a" /* default */]));
function init() {
    Object(__WEBPACK_IMPORTED_MODULE_2__Utils__["h" /* searchAndInitialize */])(".modal", function (e) {
        new Modal(e);
    });
}
/* harmony default export */ __webpack_exports__["default"] = (Modal);


/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["init"] = init;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DomElement__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DomFunctions__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Utils__ = __webpack_require__(11);




var CLASS_OPEN = "is-open";
var CLASS_MENU = "js-flyout";
var ANIMATION_OPEN = 300;
/**
 * A component for the flyout menu.
 */
var MenuFlyout = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */])(MenuFlyout, _super);
    /**
     * Creates and initializes the flyout component.
     * @param element - The root element of the flyout menu component.
     */
    function MenuFlyout(element) {
        var _this = _super.call(this, element) || this;
        _this._animationDuration = ANIMATION_OPEN;
        _this._clickHandler = _this._handleClick.bind(_this);
        _this._windowClickHandler = _this._handleWindowClick.bind(_this);
        _this._initialize();
        return _this;
    }
    /**
     * Initializes the flyout component.
     * @private
     */
    MenuFlyout.prototype._initialize = function () {
        var dataTarget = this.element.getAttribute("data-target");
        if (dataTarget === null || dataTarget === "") {
            /* eslint-disable no-console */
            console.error("A flyout menu element requires a 'data-target' that specifies the element to collapse");
            console.info(this.element);
            /* eslint-enable no-console */
            return;
        }
        var hiddenTarget = this.element.getAttribute("data-hidden");
        if (hiddenTarget !== null && hiddenTarget !== "") {
            this._hiddenIndicator =
                document.querySelector(hiddenTarget) || undefined;
        }
        this._initFlyoutElement(dataTarget);
        this.element.addEventListener("click", this._clickHandler);
    };
    MenuFlyout.prototype._initFlyoutElement = function (dataTarget) {
        this._flyoutElement = document.querySelector(dataTarget);
        this._flyoutElement.style.opacity = "0";
        this._flyoutElement.style.transform = "translateY(-20px)";
    };
    MenuFlyout.prototype._handleClick = function () {
        this.toggle();
    };
    MenuFlyout.prototype._handleWindowClick = function (event) {
        var target = event.target;
        if (Object(__WEBPACK_IMPORTED_MODULE_2__DomFunctions__["g" /* parentWithClass */])(target, CLASS_MENU) === this._flyoutElement) {
            return false;
        }
        while (target !== this.element && target.parentElement) {
            target = target.parentElement;
        }
        if (target !== this.element) {
            this.close();
            return false;
        }
        return true;
    };
    MenuFlyout.prototype._openMenu = function (el) {
        __WEBPACK_IMPORTED_MODULE_3__Utils__["a" /* animation */].set(el, { display: "block" });
        __WEBPACK_IMPORTED_MODULE_3__Utils__["a" /* animation */].start(el, {
            opacity: "1",
            transform: "translateY(0)",
        }, this._animationDuration, {
            finished: function () {
                Object(__WEBPACK_IMPORTED_MODULE_2__DomFunctions__["a" /* addClass */])(el, CLASS_OPEN);
            },
        });
        // set aria expanded
        el.setAttribute("aria-expanded", "true");
        this.dispatchEvent("opened");
    };
    MenuFlyout.prototype._closeMenu = function (el) {
        __WEBPACK_IMPORTED_MODULE_3__Utils__["a" /* animation */].start(el, {
            opacity: "0",
            transform: "translateY(-20px)",
        }, this._animationDuration, {
            finished: function () {
                __WEBPACK_IMPORTED_MODULE_3__Utils__["a" /* animation */].set(el, { display: "none" });
                Object(__WEBPACK_IMPORTED_MODULE_2__DomFunctions__["h" /* removeClass */])(el, CLASS_OPEN);
            },
        });
        // set aria expanded
        el.setAttribute("aria-expanded", "false");
        this.dispatchEvent("closed");
    };
    Object.defineProperty(MenuFlyout.prototype, "animationDuration", {
        /**
         * Sets the opening animation duration.
         * @param {durationInSeconds} - The animation duration in seconds.
         */
        set: function (durationInSeconds) {
            this._animationDuration = durationInSeconds;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Opens the flyout menu.
     * @fires Modal#opened
     */
    MenuFlyout.prototype.open = function () {
        var _this = this;
        if (this._hiddenIndicator &&
            Object(__WEBPACK_IMPORTED_MODULE_2__DomFunctions__["f" /* isHidden */])(this._hiddenIndicator, false) === true) {
            return;
        }
        if (Object(__WEBPACK_IMPORTED_MODULE_2__DomFunctions__["e" /* hasClass */])(this.element, CLASS_OPEN) === true) {
            return;
        }
        Object(__WEBPACK_IMPORTED_MODULE_2__DomFunctions__["a" /* addClass */])(this.element, CLASS_OPEN);
        this._openMenu(this._flyoutElement);
        setTimeout(function () {
            window.addEventListener("click", _this._windowClickHandler);
            window.addEventListener("touchend", _this._windowClickHandler);
        }, 50);
    };
    /**
     * Closes the flyout menu.
     * @fires Modal#closed
     */
    MenuFlyout.prototype.close = function () {
        if (this._hiddenIndicator &&
            Object(__WEBPACK_IMPORTED_MODULE_2__DomFunctions__["f" /* isHidden */])(this._hiddenIndicator, false) === true) {
            return;
        }
        if (Object(__WEBPACK_IMPORTED_MODULE_2__DomFunctions__["e" /* hasClass */])(this.element, CLASS_OPEN) === false) {
            return;
        }
        Object(__WEBPACK_IMPORTED_MODULE_2__DomFunctions__["h" /* removeClass */])(this.element, CLASS_OPEN);
        window.removeEventListener("click", this._windowClickHandler);
        window.removeEventListener("touchend", this._windowClickHandler);
        this._closeMenu(this._flyoutElement);
    };
    /**
     * Toggles the flyout menu.
     * @fires Modal#opened
     * @fires Modal#closed
     */
    MenuFlyout.prototype.toggle = function () {
        if (Object(__WEBPACK_IMPORTED_MODULE_2__DomFunctions__["e" /* hasClass */])(this.element, CLASS_OPEN) === false) {
            this.open();
        }
        else {
            this.close();
        }
    };
    /**
     * Removes all event handlers and clears references.
     */
    MenuFlyout.prototype.destroy = function () {
        ;
        this._flyoutElement = null;
        window.removeEventListener("click", this._windowClickHandler);
        window.removeEventListener("touchend", this._windowClickHandler);
        if (this._clickHandler) {
            this.element.removeEventListener("click", this._clickHandler);
        }
        ;
        this._clickHandler = null;
        this._windowClickHandler = null;
        this.element = null;
    };
    return MenuFlyout;
}(__WEBPACK_IMPORTED_MODULE_1__DomElement__["a" /* default */]));
function init() {
    var e_1, _a;
    var elements = document.querySelectorAll("[data-toggle='flyout']");
    try {
        for (var elements_1 = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __values */])(elements), elements_1_1 = elements_1.next(); !elements_1_1.done; elements_1_1 = elements_1.next()) {
            var e = elements_1_1.value;
            if (e.getAttribute("data-init") === "auto") {
                new MenuFlyout(e);
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (elements_1_1 && !elements_1_1.done && (_a = elements_1.return)) _a.call(elements_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
}
/* harmony default export */ __webpack_exports__["default"] = (MenuFlyout);


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var require;//! moment.js
//! version : 2.30.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com

;(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    global.moment = factory()
}(this, (function () { 'use strict';

    var hookCallback;

    function hooks() {
        return hookCallback.apply(null, arguments);
    }

    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }

    function isArray(input) {
        return (
            input instanceof Array ||
            Object.prototype.toString.call(input) === '[object Array]'
        );
    }

    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return (
            input != null &&
            Object.prototype.toString.call(input) === '[object Object]'
        );
    }

    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }

    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) {
            return Object.getOwnPropertyNames(obj).length === 0;
        } else {
            var k;
            for (k in obj) {
                if (hasOwnProp(obj, k)) {
                    return false;
                }
            }
            return true;
        }
    }

    function isUndefined(input) {
        return input === void 0;
    }

    function isNumber(input) {
        return (
            typeof input === 'number' ||
            Object.prototype.toString.call(input) === '[object Number]'
        );
    }

    function isDate(input) {
        return (
            input instanceof Date ||
            Object.prototype.toString.call(input) === '[object Date]'
        );
    }

    function map(arr, fn) {
        var res = [],
            i,
            arrLen = arr.length;
        for (i = 0; i < arrLen; ++i) {
            res.push(fn(arr[i], i));
        }
        return res;
    }

    function extend(a, b) {
        for (var i in b) {
            if (hasOwnProp(b, i)) {
                a[i] = b[i];
            }
        }

        if (hasOwnProp(b, 'toString')) {
            a.toString = b.toString;
        }

        if (hasOwnProp(b, 'valueOf')) {
            a.valueOf = b.valueOf;
        }

        return a;
    }

    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }

    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false,
        };
    }

    function getParsingFlags(m) {
        if (m._pf == null) {
            m._pf = defaultParsingFlags();
        }
        return m._pf;
    }

    var some;
    if (Array.prototype.some) {
        some = Array.prototype.some;
    } else {
        some = function (fun) {
            var t = Object(this),
                len = t.length >>> 0,
                i;

            for (i = 0; i < len; i++) {
                if (i in t && fun.call(this, t[i], i, t)) {
                    return true;
                }
            }

            return false;
        };
    }

    function isValid(m) {
        var flags = null,
            parsedParts = false,
            isNowValid = m._d && !isNaN(m._d.getTime());
        if (isNowValid) {
            flags = getParsingFlags(m);
            parsedParts = some.call(flags.parsedDateParts, function (i) {
                return i != null;
            });
            isNowValid =
                flags.overflow < 0 &&
                !flags.empty &&
                !flags.invalidEra &&
                !flags.invalidMonth &&
                !flags.invalidWeekday &&
                !flags.weekdayMismatch &&
                !flags.nullInput &&
                !flags.invalidFormat &&
                !flags.userInvalidated &&
                (!flags.meridiem || (flags.meridiem && parsedParts));
            if (m._strict) {
                isNowValid =
                    isNowValid &&
                    flags.charsLeftOver === 0 &&
                    flags.unusedTokens.length === 0 &&
                    flags.bigHour === undefined;
            }
        }
        if (Object.isFrozen == null || !Object.isFrozen(m)) {
            m._isValid = isNowValid;
        } else {
            return isNowValid;
        }
        return m._isValid;
    }

    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) {
            extend(getParsingFlags(m), flags);
        } else {
            getParsingFlags(m).userInvalidated = true;
        }

        return m;
    }

    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = (hooks.momentProperties = []),
        updateInProgress = false;

    function copyConfig(to, from) {
        var i,
            prop,
            val,
            momentPropertiesLen = momentProperties.length;

        if (!isUndefined(from._isAMomentObject)) {
            to._isAMomentObject = from._isAMomentObject;
        }
        if (!isUndefined(from._i)) {
            to._i = from._i;
        }
        if (!isUndefined(from._f)) {
            to._f = from._f;
        }
        if (!isUndefined(from._l)) {
            to._l = from._l;
        }
        if (!isUndefined(from._strict)) {
            to._strict = from._strict;
        }
        if (!isUndefined(from._tzm)) {
            to._tzm = from._tzm;
        }
        if (!isUndefined(from._isUTC)) {
            to._isUTC = from._isUTC;
        }
        if (!isUndefined(from._offset)) {
            to._offset = from._offset;
        }
        if (!isUndefined(from._pf)) {
            to._pf = getParsingFlags(from);
        }
        if (!isUndefined(from._locale)) {
            to._locale = from._locale;
        }

        if (momentPropertiesLen > 0) {
            for (i = 0; i < momentPropertiesLen; i++) {
                prop = momentProperties[i];
                val = from[prop];
                if (!isUndefined(val)) {
                    to[prop] = val;
                }
            }
        }

        return to;
    }

    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) {
            this._d = new Date(NaN);
        }
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }

    function isMoment(obj) {
        return (
            obj instanceof Moment || (obj != null && obj._isAMomentObject != null)
        );
    }

    function warn(msg) {
        if (
            hooks.suppressDeprecationWarnings === false &&
            typeof console !== 'undefined' &&
            console.warn
        ) {
            console.warn('Deprecation warning: ' + msg);
        }
    }

    function deprecate(msg, fn) {
        var firstTime = true;

        return extend(function () {
            if (hooks.deprecationHandler != null) {
                hooks.deprecationHandler(null, msg);
            }
            if (firstTime) {
                var args = [],
                    arg,
                    i,
                    key,
                    argLen = arguments.length;
                for (i = 0; i < argLen; i++) {
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for (key in arguments[0]) {
                            if (hasOwnProp(arguments[0], key)) {
                                arg += key + ': ' + arguments[0][key] + ', ';
                            }
                        }
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else {
                        arg = arguments[i];
                    }
                    args.push(arg);
                }
                warn(
                    msg +
                        '\nArguments: ' +
                        Array.prototype.slice.call(args).join('') +
                        '\n' +
                        new Error().stack
                );
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }

    var deprecations = {};

    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(name, msg);
        }
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }

    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;

    function isFunction(input) {
        return (
            (typeof Function !== 'undefined' && input instanceof Function) ||
            Object.prototype.toString.call(input) === '[object Function]'
        );
    }

    function set(config) {
        var prop, i;
        for (i in config) {
            if (hasOwnProp(config, i)) {
                prop = config[i];
                if (isFunction(prop)) {
                    this[i] = prop;
                } else {
                    this['_' + i] = prop;
                }
            }
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp(
            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
                '|' +
                /\d{1,2}/.source
        );
    }

    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig),
            prop;
        for (prop in childConfig) {
            if (hasOwnProp(childConfig, prop)) {
                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                    res[prop] = {};
                    extend(res[prop], parentConfig[prop]);
                    extend(res[prop], childConfig[prop]);
                } else if (childConfig[prop] != null) {
                    res[prop] = childConfig[prop];
                } else {
                    delete res[prop];
                }
            }
        }
        for (prop in parentConfig) {
            if (
                hasOwnProp(parentConfig, prop) &&
                !hasOwnProp(childConfig, prop) &&
                isObject(parentConfig[prop])
            ) {
                // make sure changes to properties don't modify parent config
                res[prop] = extend({}, res[prop]);
            }
        }
        return res;
    }

    function Locale(config) {
        if (config != null) {
            this.set(config);
        }
    }

    var keys;

    if (Object.keys) {
        keys = Object.keys;
    } else {
        keys = function (obj) {
            var i,
                res = [];
            for (i in obj) {
                if (hasOwnProp(obj, i)) {
                    res.push(i);
                }
            }
            return res;
        };
    }

    var defaultCalendar = {
        sameDay: '[Today at] LT',
        nextDay: '[Tomorrow at] LT',
        nextWeek: 'dddd [at] LT',
        lastDay: '[Yesterday at] LT',
        lastWeek: '[Last] dddd [at] LT',
        sameElse: 'L',
    };

    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }

    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number),
            zerosToFill = targetLength - absNumber.length,
            sign = number >= 0;
        return (
            (sign ? (forceSign ? '+' : '') : '-') +
            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) +
            absNumber
        );
    }

    var formattingTokens =
            /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
        localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
        formatFunctions = {},
        formatTokenFunctions = {};

    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') {
            func = function () {
                return this[callback]();
            };
        }
        if (token) {
            formatTokenFunctions[token] = func;
        }
        if (padded) {
            formatTokenFunctions[padded[0]] = function () {
                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
            };
        }
        if (ordinal) {
            formatTokenFunctions[ordinal] = function () {
                return this.localeData().ordinal(
                    func.apply(this, arguments),
                    token
                );
            };
        }
    }

    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) {
            return input.replace(/^\[|\]$/g, '');
        }
        return input.replace(/\\/g, '');
    }

    function makeFormatFunction(format) {
        var array = format.match(formattingTokens),
            i,
            length;

        for (i = 0, length = array.length; i < length; i++) {
            if (formatTokenFunctions[array[i]]) {
                array[i] = formatTokenFunctions[array[i]];
            } else {
                array[i] = removeFormattingTokens(array[i]);
            }
        }

        return function (mom) {
            var output = '',
                i;
            for (i = 0; i < length; i++) {
                output += isFunction(array[i])
                    ? array[i].call(mom, format)
                    : array[i];
            }
            return output;
        };
    }

    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) {
            return m.localeData().invalidDate();
        }

        format = expandFormat(format, m.localeData());
        formatFunctions[format] =
            formatFunctions[format] || makeFormatFunction(format);

        return formatFunctions[format](m);
    }

    function expandFormat(format, locale) {
        var i = 5;

        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }

        localFormattingTokens.lastIndex = 0;
        while (i >= 0 && localFormattingTokens.test(format)) {
            format = format.replace(
                localFormattingTokens,
                replaceLongDateFormatTokens
            );
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }

        return format;
    }

    var defaultLongDateFormat = {
        LTS: 'h:mm:ss A',
        LT: 'h:mm A',
        L: 'MM/DD/YYYY',
        LL: 'MMMM D, YYYY',
        LLL: 'MMMM D, YYYY h:mm A',
        LLLL: 'dddd, MMMM D, YYYY h:mm A',
    };

    function longDateFormat(key) {
        var format = this._longDateFormat[key],
            formatUpper = this._longDateFormat[key.toUpperCase()];

        if (format || !formatUpper) {
            return format;
        }

        this._longDateFormat[key] = formatUpper
            .match(formattingTokens)
            .map(function (tok) {
                if (
                    tok === 'MMMM' ||
                    tok === 'MM' ||
                    tok === 'DD' ||
                    tok === 'dddd'
                ) {
                    return tok.slice(1);
                }
                return tok;
            })
            .join('');

        return this._longDateFormat[key];
    }

    var defaultInvalidDate = 'Invalid date';

    function invalidDate() {
        return this._invalidDate;
    }

    var defaultOrdinal = '%d',
        defaultDayOfMonthOrdinalParse = /\d{1,2}/;

    function ordinal(number) {
        return this._ordinal.replace('%d', number);
    }

    var defaultRelativeTime = {
        future: 'in %s',
        past: '%s ago',
        s: 'a few seconds',
        ss: '%d seconds',
        m: 'a minute',
        mm: '%d minutes',
        h: 'an hour',
        hh: '%d hours',
        d: 'a day',
        dd: '%d days',
        w: 'a week',
        ww: '%d weeks',
        M: 'a month',
        MM: '%d months',
        y: 'a year',
        yy: '%d years',
    };

    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output)
            ? output(number, withoutSuffix, string, isFuture)
            : output.replace(/%d/i, number);
    }

    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }

    var aliases = {
        D: 'date',
        dates: 'date',
        date: 'date',
        d: 'day',
        days: 'day',
        day: 'day',
        e: 'weekday',
        weekdays: 'weekday',
        weekday: 'weekday',
        E: 'isoWeekday',
        isoweekdays: 'isoWeekday',
        isoweekday: 'isoWeekday',
        DDD: 'dayOfYear',
        dayofyears: 'dayOfYear',
        dayofyear: 'dayOfYear',
        h: 'hour',
        hours: 'hour',
        hour: 'hour',
        ms: 'millisecond',
        milliseconds: 'millisecond',
        millisecond: 'millisecond',
        m: 'minute',
        minutes: 'minute',
        minute: 'minute',
        M: 'month',
        months: 'month',
        month: 'month',
        Q: 'quarter',
        quarters: 'quarter',
        quarter: 'quarter',
        s: 'second',
        seconds: 'second',
        second: 'second',
        gg: 'weekYear',
        weekyears: 'weekYear',
        weekyear: 'weekYear',
        GG: 'isoWeekYear',
        isoweekyears: 'isoWeekYear',
        isoweekyear: 'isoWeekYear',
        w: 'week',
        weeks: 'week',
        week: 'week',
        W: 'isoWeek',
        isoweeks: 'isoWeek',
        isoweek: 'isoWeek',
        y: 'year',
        years: 'year',
        year: 'year',
    };

    function normalizeUnits(units) {
        return typeof units === 'string'
            ? aliases[units] || aliases[units.toLowerCase()]
            : undefined;
    }

    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {},
            normalizedProp,
            prop;

        for (prop in inputObject) {
            if (hasOwnProp(inputObject, prop)) {
                normalizedProp = normalizeUnits(prop);
                if (normalizedProp) {
                    normalizedInput[normalizedProp] = inputObject[prop];
                }
            }
        }

        return normalizedInput;
    }

    var priorities = {
        date: 9,
        day: 11,
        weekday: 11,
        isoWeekday: 11,
        dayOfYear: 4,
        hour: 13,
        millisecond: 16,
        minute: 14,
        month: 8,
        quarter: 7,
        second: 15,
        weekYear: 1,
        isoWeekYear: 1,
        week: 5,
        isoWeek: 5,
        year: 1,
    };

    function getPrioritizedUnits(unitsObj) {
        var units = [],
            u;
        for (u in unitsObj) {
            if (hasOwnProp(unitsObj, u)) {
                units.push({ unit: u, priority: priorities[u] });
            }
        }
        units.sort(function (a, b) {
            return a.priority - b.priority;
        });
        return units;
    }

    var match1 = /\d/, //       0 - 9
        match2 = /\d\d/, //      00 - 99
        match3 = /\d{3}/, //     000 - 999
        match4 = /\d{4}/, //    0000 - 9999
        match6 = /[+-]?\d{6}/, // -999999 - 999999
        match1to2 = /\d\d?/, //       0 - 99
        match3to4 = /\d\d\d\d?/, //     999 - 9999
        match5to6 = /\d\d\d\d\d\d?/, //   99999 - 999999
        match1to3 = /\d{1,3}/, //       0 - 999
        match1to4 = /\d{1,4}/, //       0 - 9999
        match1to6 = /[+-]?\d{1,6}/, // -999999 - 999999
        matchUnsigned = /\d+/, //       0 - inf
        matchSigned = /[+-]?\d+/, //    -inf - inf
        matchOffset = /Z|[+-]\d\d:?\d\d/gi, // +00:00 -00:00 +0000 -0000 or Z
        matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, // +00 -00 +00:00 -00:00 +0000 -0000 or Z
        matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // 123456789 123456789.123
        // any word (or two) characters or numbers including two/three word month in arabic.
        // includes scottish gaelic two word and hyphenated months
        matchWord =
            /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i,
        match1to2NoLeadingZero = /^[1-9]\d?/, //         1-99
        match1to2HasZero = /^([1-9]\d|\d)/, //           0-99
        regexes;

    regexes = {};

    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex)
            ? regex
            : function (isStrict, localeData) {
                  return isStrict && strictRegex ? strictRegex : regex;
              };
    }

    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) {
            return new RegExp(unescapeFormat(token));
        }

        return regexes[token](config._strict, config._locale);
    }

    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(
            s
                .replace('\\', '')
                .replace(
                    /\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g,
                    function (matched, p1, p2, p3, p4) {
                        return p1 || p2 || p3 || p4;
                    }
                )
        );
    }

    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    function absFloor(number) {
        if (number < 0) {
            // -0 -> 0
            return Math.ceil(number) || 0;
        } else {
            return Math.floor(number);
        }
    }

    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion,
            value = 0;

        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
            value = absFloor(coercedNumber);
        }

        return value;
    }

    var tokens = {};

    function addParseToken(token, callback) {
        var i,
            func = callback,
            tokenLen;
        if (typeof token === 'string') {
            token = [token];
        }
        if (isNumber(callback)) {
            func = function (input, array) {
                array[callback] = toInt(input);
            };
        }
        tokenLen = token.length;
        for (i = 0; i < tokenLen; i++) {
            tokens[token[i]] = func;
        }
    }

    function addWeekParseToken(token, callback) {
        addParseToken(token, function (input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }

    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) {
            tokens[token](input, config._a, config, token);
        }
    }

    function isLeapYear(year) {
        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    }

    var YEAR = 0,
        MONTH = 1,
        DATE = 2,
        HOUR = 3,
        MINUTE = 4,
        SECOND = 5,
        MILLISECOND = 6,
        WEEK = 7,
        WEEKDAY = 8;

    // FORMATTING

    addFormatToken('Y', 0, 0, function () {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
    });

    addFormatToken(0, ['YY', 2], 0, function () {
        return this.year() % 100;
    });

    addFormatToken(0, ['YYYY', 4], 0, 'year');
    addFormatToken(0, ['YYYYY', 5], 0, 'year');
    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

    // PARSING

    addRegexToken('Y', matchSigned);
    addRegexToken('YY', match1to2, match2);
    addRegexToken('YYYY', match1to4, match4);
    addRegexToken('YYYYY', match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);

    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
    addParseToken('YYYY', function (input, array) {
        array[YEAR] =
            input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function (input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function (input, array) {
        array[YEAR] = parseInt(input, 10);
    });

    // HELPERS

    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }

    // HOOKS

    hooks.parseTwoDigitYear = function (input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };

    // MOMENTS

    var getSetYear = makeGetSet('FullYear', true);

    function getIsLeapYear() {
        return isLeapYear(this.year());
    }

    function makeGetSet(unit, keepTime) {
        return function (value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else {
                return get(this, unit);
            }
        };
    }

    function get(mom, unit) {
        if (!mom.isValid()) {
            return NaN;
        }

        var d = mom._d,
            isUTC = mom._isUTC;

        switch (unit) {
            case 'Milliseconds':
                return isUTC ? d.getUTCMilliseconds() : d.getMilliseconds();
            case 'Seconds':
                return isUTC ? d.getUTCSeconds() : d.getSeconds();
            case 'Minutes':
                return isUTC ? d.getUTCMinutes() : d.getMinutes();
            case 'Hours':
                return isUTC ? d.getUTCHours() : d.getHours();
            case 'Date':
                return isUTC ? d.getUTCDate() : d.getDate();
            case 'Day':
                return isUTC ? d.getUTCDay() : d.getDay();
            case 'Month':
                return isUTC ? d.getUTCMonth() : d.getMonth();
            case 'FullYear':
                return isUTC ? d.getUTCFullYear() : d.getFullYear();
            default:
                return NaN; // Just in case
        }
    }

    function set$1(mom, unit, value) {
        var d, isUTC, year, month, date;

        if (!mom.isValid() || isNaN(value)) {
            return;
        }

        d = mom._d;
        isUTC = mom._isUTC;

        switch (unit) {
            case 'Milliseconds':
                return void (isUTC
                    ? d.setUTCMilliseconds(value)
                    : d.setMilliseconds(value));
            case 'Seconds':
                return void (isUTC ? d.setUTCSeconds(value) : d.setSeconds(value));
            case 'Minutes':
                return void (isUTC ? d.setUTCMinutes(value) : d.setMinutes(value));
            case 'Hours':
                return void (isUTC ? d.setUTCHours(value) : d.setHours(value));
            case 'Date':
                return void (isUTC ? d.setUTCDate(value) : d.setDate(value));
            // case 'Day': // Not real
            //    return void (isUTC ? d.setUTCDay(value) : d.setDay(value));
            // case 'Month': // Not used because we need to pass two variables
            //     return void (isUTC ? d.setUTCMonth(value) : d.setMonth(value));
            case 'FullYear':
                break; // See below ...
            default:
                return; // Just in case
        }

        year = value;
        month = mom.month();
        date = mom.date();
        date = date === 29 && month === 1 && !isLeapYear(year) ? 28 : date;
        void (isUTC
            ? d.setUTCFullYear(year, month, date)
            : d.setFullYear(year, month, date));
    }

    // MOMENTS

    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units]();
        }
        return this;
    }

    function stringSet(units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units),
                i,
                prioritizedLen = prioritized.length;
            for (i = 0; i < prioritizedLen; i++) {
                this[prioritized[i].unit](units[prioritized[i].unit]);
            }
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) {
                return this[units](value);
            }
        }
        return this;
    }

    function mod(n, x) {
        return ((n % x) + x) % x;
    }

    var indexOf;

    if (Array.prototype.indexOf) {
        indexOf = Array.prototype.indexOf;
    } else {
        indexOf = function (o) {
            // I know
            var i;
            for (i = 0; i < this.length; ++i) {
                if (this[i] === o) {
                    return i;
                }
            }
            return -1;
        };
    }

    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) {
            return NaN;
        }
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1
            ? isLeapYear(year)
                ? 29
                : 28
            : 31 - ((modMonth % 7) % 2);
    }

    // FORMATTING

    addFormatToken('M', ['MM', 2], 'Mo', function () {
        return this.month() + 1;
    });

    addFormatToken('MMM', 0, 0, function (format) {
        return this.localeData().monthsShort(this, format);
    });

    addFormatToken('MMMM', 0, 0, function (format) {
        return this.localeData().months(this, format);
    });

    // PARSING

    addRegexToken('M', match1to2, match1to2NoLeadingZero);
    addRegexToken('MM', match1to2, match2);
    addRegexToken('MMM', function (isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function (isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });

    addParseToken(['M', 'MM'], function (input, array) {
        array[MONTH] = toInt(input) - 1;
    });

    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) {
            array[MONTH] = month;
        } else {
            getParsingFlags(config).invalidMonth = input;
        }
    });

    // LOCALES

    var defaultLocaleMonths =
            'January_February_March_April_May_June_July_August_September_October_November_December'.split(
                '_'
            ),
        defaultLocaleMonthsShort =
            'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
        defaultMonthsShortRegex = matchWord,
        defaultMonthsRegex = matchWord;

    function localeMonths(m, format) {
        if (!m) {
            return isArray(this._months)
                ? this._months
                : this._months['standalone'];
        }
        return isArray(this._months)
            ? this._months[m.month()]
            : this._months[
                  (this._months.isFormat || MONTHS_IN_FORMAT).test(format)
                      ? 'format'
                      : 'standalone'
              ][m.month()];
    }

    function localeMonthsShort(m, format) {
        if (!m) {
            return isArray(this._monthsShort)
                ? this._monthsShort
                : this._monthsShort['standalone'];
        }
        return isArray(this._monthsShort)
            ? this._monthsShort[m.month()]
            : this._monthsShort[
                  MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'
              ][m.month()];
    }

    function handleStrictParse(monthName, format, strict) {
        var i,
            ii,
            mom,
            llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for (i = 0; i < 12; ++i) {
                mom = createUTC([2000, i]);
                this._shortMonthsParse[i] = this.monthsShort(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;

        if (this._monthsParseExact) {
            return handleStrictParse.call(this, monthName, format, strict);
        }

        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }

        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp(
                    '^' + this.months(mom, '').replace('.', '') + '$',
                    'i'
                );
                this._shortMonthsParse[i] = new RegExp(
                    '^' + this.monthsShort(mom, '').replace('.', '') + '$',
                    'i'
                );
            }
            if (!strict && !this._monthsParse[i]) {
                regex =
                    '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (
                strict &&
                format === 'MMMM' &&
                this._longMonthsParse[i].test(monthName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'MMM' &&
                this._shortMonthsParse[i].test(monthName)
            ) {
                return i;
            } else if (!strict && this._monthsParse[i].test(monthName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function setMonth(mom, value) {
        if (!mom.isValid()) {
            // No op
            return mom;
        }

        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) {
                value = toInt(value);
            } else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) {
                    return mom;
                }
            }
        }

        var month = value,
            date = mom.date();

        date = date < 29 ? date : Math.min(date, daysInMonth(mom.year(), month));
        void (mom._isUTC
            ? mom._d.setUTCMonth(month, date)
            : mom._d.setMonth(month, date));
        return mom;
    }

    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else {
            return get(this, 'Month');
        }
    }

    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }

    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsShortStrictRegex;
            } else {
                return this._monthsShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) {
                this._monthsShortRegex = defaultMonthsShortRegex;
            }
            return this._monthsShortStrictRegex && isStrict
                ? this._monthsShortStrictRegex
                : this._monthsShortRegex;
        }
    }

    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsStrictRegex;
            } else {
                return this._monthsRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) {
                this._monthsRegex = defaultMonthsRegex;
            }
            return this._monthsStrictRegex && isStrict
                ? this._monthsStrictRegex
                : this._monthsRegex;
        }
    }

    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom,
            shortP,
            longP;
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            shortP = regexEscape(this.monthsShort(mom, ''));
            longP = regexEscape(this.months(mom, ''));
            shortPieces.push(shortP);
            longPieces.push(longP);
            mixedPieces.push(longP);
            mixedPieces.push(shortP);
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);

        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp(
            '^(' + longPieces.join('|') + ')',
            'i'
        );
        this._monthsShortStrictRegex = new RegExp(
            '^(' + shortPieces.join('|') + ')',
            'i'
        );
    }

    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) {
                date.setFullYear(y);
            }
        } else {
            date = new Date(y, m, d, h, M, s, ms);
        }

        return date;
    }

    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) {
                date.setUTCFullYear(y);
            }
        } else {
            date = new Date(Date.UTC.apply(null, arguments));
        }

        return date;
    }

    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
            fwd = 7 + dow - doy,
            // first-week day local weekday -- which local weekday is fwd
            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

        return -fwdlw + fwd - 1;
    }

    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7,
            weekOffset = firstWeekOffset(year, dow, doy),
            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
            resYear,
            resDayOfYear;

        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }

        return {
            year: resYear,
            dayOfYear: resDayOfYear,
        };
    }

    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
            resWeek,
            resYear;

        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }

        return {
            week: resWeek,
            year: resYear,
        };
    }

    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy),
            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }

    // FORMATTING

    addFormatToken('w', ['ww', 2], 'wo', 'week');
    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

    // PARSING

    addRegexToken('w', match1to2, match1to2NoLeadingZero);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W', match1to2, match1to2NoLeadingZero);
    addRegexToken('WW', match1to2, match2);

    addWeekParseToken(
        ['w', 'ww', 'W', 'WW'],
        function (input, week, config, token) {
            week[token.substr(0, 1)] = toInt(input);
        }
    );

    // HELPERS

    // LOCALES

    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }

    var defaultLocaleWeek = {
        dow: 0, // Sunday is the first day of the week.
        doy: 6, // The week that contains Jan 6th is the first week of the year.
    };

    function localeFirstDayOfWeek() {
        return this._week.dow;
    }

    function localeFirstDayOfYear() {
        return this._week.doy;
    }

    // MOMENTS

    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    // FORMATTING

    addFormatToken('d', 0, 'do', 'day');

    addFormatToken('dd', 0, 0, function (format) {
        return this.localeData().weekdaysMin(this, format);
    });

    addFormatToken('ddd', 0, 0, function (format) {
        return this.localeData().weekdaysShort(this, format);
    });

    addFormatToken('dddd', 0, 0, function (format) {
        return this.localeData().weekdays(this, format);
    });

    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');

    // PARSING

    addRegexToken('d', match1to2);
    addRegexToken('e', match1to2);
    addRegexToken('E', match1to2);
    addRegexToken('dd', function (isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd', function (isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd', function (isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });

    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) {
            week.d = weekday;
        } else {
            getParsingFlags(config).invalidWeekday = input;
        }
    });

    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
        week[token] = toInt(input);
    });

    // HELPERS

    function parseWeekday(input, locale) {
        if (typeof input !== 'string') {
            return input;
        }

        if (!isNaN(input)) {
            return parseInt(input, 10);
        }

        input = locale.weekdaysParse(input);
        if (typeof input === 'number') {
            return input;
        }

        return null;
    }

    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') {
            return locale.weekdaysParse(input) % 7 || 7;
        }
        return isNaN(input) ? null : input;
    }

    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }

    var defaultLocaleWeekdays =
            'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        defaultWeekdaysRegex = matchWord,
        defaultWeekdaysShortRegex = matchWord,
        defaultWeekdaysMinRegex = matchWord;

    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays)
            ? this._weekdays
            : this._weekdays[
                  m && m !== true && this._weekdays.isFormat.test(format)
                      ? 'format'
                      : 'standalone'
              ];
        return m === true
            ? shiftWeekdays(weekdays, this._week.dow)
            : m
              ? weekdays[m.day()]
              : weekdays;
    }

    function localeWeekdaysShort(m) {
        return m === true
            ? shiftWeekdays(this._weekdaysShort, this._week.dow)
            : m
              ? this._weekdaysShort[m.day()]
              : this._weekdaysShort;
    }

    function localeWeekdaysMin(m) {
        return m === true
            ? shiftWeekdays(this._weekdaysMin, this._week.dow)
            : m
              ? this._weekdaysMin[m.day()]
              : this._weekdaysMin;
    }

    function handleStrictParse$1(weekdayName, format, strict) {
        var i,
            ii,
            mom,
            llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];

            for (i = 0; i < 7; ++i) {
                mom = createUTC([2000, 1]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;

        if (this._weekdaysParseExact) {
            return handleStrictParse$1.call(this, weekdayName, format, strict);
        }

        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }

        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already

            mom = createUTC([2000, 1]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdays(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
                this._shortWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
                this._minWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
            }
            if (!this._weekdaysParse[i]) {
                regex =
                    '^' +
                    this.weekdays(mom, '') +
                    '|^' +
                    this.weekdaysShort(mom, '') +
                    '|^' +
                    this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (
                strict &&
                format === 'dddd' &&
                this._fullWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'ddd' &&
                this._shortWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'dd' &&
                this._minWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function getSetDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        var day = get(this, 'Day');
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else {
            return day;
        }
    }

    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }

    function getSetISODayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.

        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else {
            return this.day() || 7;
        }
    }

    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysStrictRegex;
            } else {
                return this._weekdaysRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                this._weekdaysRegex = defaultWeekdaysRegex;
            }
            return this._weekdaysStrictRegex && isStrict
                ? this._weekdaysStrictRegex
                : this._weekdaysRegex;
        }
    }

    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysShortStrictRegex;
            } else {
                return this._weekdaysShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            }
            return this._weekdaysShortStrictRegex && isStrict
                ? this._weekdaysShortStrictRegex
                : this._weekdaysShortRegex;
        }
    }

    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysMinStrictRegex;
            } else {
                return this._weekdaysMinRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            }
            return this._weekdaysMinStrictRegex && isStrict
                ? this._weekdaysMinStrictRegex
                : this._weekdaysMinRegex;
        }
    }

    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var minPieces = [],
            shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom,
            minp,
            shortp,
            longp;
        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, 1]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ''));
            shortp = regexEscape(this.weekdaysShort(mom, ''));
            longp = regexEscape(this.weekdays(mom, ''));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);

        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;

        this._weekdaysStrictRegex = new RegExp(
            '^(' + longPieces.join('|') + ')',
            'i'
        );
        this._weekdaysShortStrictRegex = new RegExp(
            '^(' + shortPieces.join('|') + ')',
            'i'
        );
        this._weekdaysMinStrictRegex = new RegExp(
            '^(' + minPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    function hFormat() {
        return this.hours() % 12 || 12;
    }

    function kFormat() {
        return this.hours() || 24;
    }

    addFormatToken('H', ['HH', 2], 0, 'hour');
    addFormatToken('h', ['hh', 2], 0, hFormat);
    addFormatToken('k', ['kk', 2], 0, kFormat);

    addFormatToken('hmm', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });

    addFormatToken('hmmss', 0, 0, function () {
        return (
            '' +
            hFormat.apply(this) +
            zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2)
        );
    });

    addFormatToken('Hmm', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });

    addFormatToken('Hmmss', 0, 0, function () {
        return (
            '' +
            this.hours() +
            zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2)
        );
    });

    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function () {
            return this.localeData().meridiem(
                this.hours(),
                this.minutes(),
                lowercase
            );
        });
    }

    meridiem('a', true);
    meridiem('A', false);

    // PARSING

    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }

    addRegexToken('a', matchMeridiem);
    addRegexToken('A', matchMeridiem);
    addRegexToken('H', match1to2, match1to2HasZero);
    addRegexToken('h', match1to2, match1to2NoLeadingZero);
    addRegexToken('k', match1to2, match1to2NoLeadingZero);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);

    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);

    addParseToken(['H', 'HH'], HOUR);
    addParseToken(['k', 'kk'], function (input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken(['a', 'A'], function (input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken(['h', 'hh'], function (input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function (input, array, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function (input, array, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });

    // LOCALES

    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + '').toLowerCase().charAt(0) === 'p';
    }

    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i,
        // Setting the hour should keep the time, because the user explicitly
        // specified which hour they want. So trying to maintain the same hour (in
        // a new timezone) makes sense. Adding/subtracting hours does not follow
        // this rule.
        getSetHour = makeGetSet('Hours', true);

    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'pm' : 'PM';
        } else {
            return isLower ? 'am' : 'AM';
        }
    }

    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,

        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,

        week: defaultLocaleWeek,

        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,

        meridiemParse: defaultLocaleMeridiemParse,
    };

    // internal storage for locale config files
    var locales = {},
        localeFamilies = {},
        globalLocale;

    function commonPrefix(arr1, arr2) {
        var i,
            minl = Math.min(arr1.length, arr2.length);
        for (i = 0; i < minl; i += 1) {
            if (arr1[i] !== arr2[i]) {
                return i;
            }
        }
        return minl;
    }

    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }

    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0,
            j,
            next,
            locale,
            split;

        while (i < names.length) {
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while (j > 0) {
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) {
                    return locale;
                }
                if (
                    next &&
                    next.length >= j &&
                    commonPrefix(split, next) >= j - 1
                ) {
                    //the next array item is better than a shallower substring of this one
                    break;
                }
                j--;
            }
            i++;
        }
        return globalLocale;
    }

    function isLocaleNameSane(name) {
        // Prevent names that look like filesystem paths, i.e contain '/' or '\'
        // Ensure name is available and function returns boolean
        return !!(name && name.match('^[^/\\\\]*$'));
    }

    function loadLocale(name) {
        var oldLocale = null,
            aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (
            locales[name] === undefined &&
            typeof module !== 'undefined' &&
            module &&
            module.exports &&
            isLocaleNameSane(name)
        ) {
            try {
                oldLocale = globalLocale._abbr;
                aliasedRequire = require;
                !(function webpackMissingModule() { var e = new Error("Cannot find module \"./locale\""); e.code = 'MODULE_NOT_FOUND'; throw e; }());
                getSetGlobalLocale(oldLocale);
            } catch (e) {
                // mark as not found to avoid repeating expensive file require call causing high CPU
                // when trying to find en-US, en_US, en-us for every format call
                locales[name] = null; // null means not found
            }
        }
        return locales[name];
    }

    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) {
                data = getLocale(key);
            } else {
                data = defineLocale(key, values);
            }

            if (data) {
                // moment.duration._locale = moment._locale = data;
                globalLocale = data;
            } else {
                if (typeof console !== 'undefined' && console.warn) {
                    //warn user if arguments are passed but the locale could not be set
                    console.warn(
                        'Locale ' + key + ' not found. Did you forget to load it?'
                    );
                }
            }
        }

        return globalLocale._abbr;
    }

    function defineLocale(name, config) {
        if (config !== null) {
            var locale,
                parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple(
                    'defineLocaleOverride',
                    'use moment.updateLocale(localeName, config) to change ' +
                        'an existing locale. moment.defineLocale(localeName, ' +
                        'config) should only be used for creating a new locale ' +
                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.'
                );
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) {
                    parentConfig = locales[config.parentLocale]._config;
                } else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) {
                        parentConfig = locale._config;
                    } else {
                        if (!localeFamilies[config.parentLocale]) {
                            localeFamilies[config.parentLocale] = [];
                        }
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config,
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));

            if (localeFamilies[name]) {
                localeFamilies[name].forEach(function (x) {
                    defineLocale(x.name, x.config);
                });
            }

            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);

            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }

    function updateLocale(name, config) {
        if (config != null) {
            var locale,
                tmpLocale,
                parentConfig = baseConfig;

            if (locales[name] != null && locales[name].parentLocale != null) {
                // Update existing child locale in-place to avoid memory-leaks
                locales[name].set(mergeConfigs(locales[name]._config, config));
            } else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) {
                    parentConfig = tmpLocale._config;
                }
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) {
                    // updateLocale is called for creating a new locale
                    // Set abbr so it will have a name (getters return
                    // undefined otherwise).
                    config.abbr = name;
                }
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }

            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else {
            // pass null for config to unupdate, useful for tests
            if (locales[name] != null) {
                if (locales[name].parentLocale != null) {
                    locales[name] = locales[name].parentLocale;
                    if (name === getSetGlobalLocale()) {
                        getSetGlobalLocale(name);
                    }
                } else if (locales[name] != null) {
                    delete locales[name];
                }
            }
        }
        return locales[name];
    }

    // returns locale data
    function getLocale(key) {
        var locale;

        if (key && key._locale && key._locale._abbr) {
            key = key._locale._abbr;
        }

        if (!key) {
            return globalLocale;
        }

        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) {
                return locale;
            }
            key = [key];
        }

        return chooseLocale(key);
    }

    function listLocales() {
        return keys(locales);
    }

    function checkOverflow(m) {
        var overflow,
            a = m._a;

        if (a && getParsingFlags(m).overflow === -2) {
            overflow =
                a[MONTH] < 0 || a[MONTH] > 11
                    ? MONTH
                    : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH])
                      ? DATE
                      : a[HOUR] < 0 ||
                          a[HOUR] > 24 ||
                          (a[HOUR] === 24 &&
                              (a[MINUTE] !== 0 ||
                                  a[SECOND] !== 0 ||
                                  a[MILLISECOND] !== 0))
                        ? HOUR
                        : a[MINUTE] < 0 || a[MINUTE] > 59
                          ? MINUTE
                          : a[SECOND] < 0 || a[SECOND] > 59
                            ? SECOND
                            : a[MILLISECOND] < 0 || a[MILLISECOND] > 999
                              ? MILLISECOND
                              : -1;

            if (
                getParsingFlags(m)._overflowDayOfYear &&
                (overflow < YEAR || overflow > DATE)
            ) {
                overflow = DATE;
            }
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
                overflow = WEEK;
            }
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
                overflow = WEEKDAY;
            }

            getParsingFlags(m).overflow = overflow;
        }

        return m;
    }

    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex =
            /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        basicIsoRegex =
            /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        tzRegex = /Z|[+-]\d\d(?::?\d\d)?/,
        isoDates = [
            ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
            ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
            ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
            ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
            ['YYYY-DDD', /\d{4}-\d{3}/],
            ['YYYY-MM', /\d{4}-\d\d/, false],
            ['YYYYYYMMDD', /[+-]\d{10}/],
            ['YYYYMMDD', /\d{8}/],
            ['GGGG[W]WWE', /\d{4}W\d{3}/],
            ['GGGG[W]WW', /\d{4}W\d{2}/, false],
            ['YYYYDDD', /\d{7}/],
            ['YYYYMM', /\d{6}/, false],
            ['YYYY', /\d{4}/, false],
        ],
        // iso time formats and regexes
        isoTimes = [
            ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
            ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
            ['HH:mm:ss', /\d\d:\d\d:\d\d/],
            ['HH:mm', /\d\d:\d\d/],
            ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
            ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
            ['HHmmss', /\d\d\d\d\d\d/],
            ['HHmm', /\d\d\d\d/],
            ['HH', /\d\d/],
        ],
        aspNetJsonRegex = /^\/?Date\((-?\d+)/i,
        // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
        rfc2822 =
            /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,
        obsOffsets = {
            UT: 0,
            GMT: 0,
            EDT: -4 * 60,
            EST: -5 * 60,
            CDT: -5 * 60,
            CST: -6 * 60,
            MDT: -6 * 60,
            MST: -7 * 60,
            PDT: -7 * 60,
            PST: -8 * 60,
        };

    // date from iso format
    function configFromISO(config) {
        var i,
            l,
            string = config._i,
            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
            allowTime,
            dateFormat,
            timeFormat,
            tzFormat,
            isoDatesLen = isoDates.length,
            isoTimesLen = isoTimes.length;

        if (match) {
            getParsingFlags(config).iso = true;
            for (i = 0, l = isoDatesLen; i < l; i++) {
                if (isoDates[i][1].exec(match[1])) {
                    dateFormat = isoDates[i][0];
                    allowTime = isoDates[i][2] !== false;
                    break;
                }
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for (i = 0, l = isoTimesLen; i < l; i++) {
                    if (isoTimes[i][1].exec(match[3])) {
                        // match[2] should be 'T' or space
                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
                        break;
                    }
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) {
                    tzFormat = 'Z';
                } else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else {
            config._isValid = false;
        }
    }

    function extractFromRFC2822Strings(
        yearStr,
        monthStr,
        dayStr,
        hourStr,
        minuteStr,
        secondStr
    ) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10),
        ];

        if (secondStr) {
            result.push(parseInt(secondStr, 10));
        }

        return result;
    }

    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) {
            return 2000 + year;
        } else if (year <= 999) {
            return 1900 + year;
        }
        return year;
    }

    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s
            .replace(/\([^()]*\)|[\n\t]/g, ' ')
            .replace(/(\s\s+)/g, ' ')
            .replace(/^\s\s*/, '')
            .replace(/\s\s*$/, '');
    }

    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
                weekdayActual = new Date(
                    parsedInput[0],
                    parsedInput[1],
                    parsedInput[2]
                ).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }

    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) {
            return obsOffsets[obsOffset];
        } else if (militaryOffset) {
            // the only allowed military tz is Z
            return 0;
        } else {
            var hm = parseInt(numOffset, 10),
                m = hm % 100,
                h = (hm - m) / 100;
            return h * 60 + m;
        }
    }

    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)),
            parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(
                match[4],
                match[3],
                match[2],
                match[5],
                match[6],
                match[7]
            );
            if (!checkWeekday(match[1], parsedArray, config)) {
                return;
            }

            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);

            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

            getParsingFlags(config).rfc2822 = true;
        } else {
            config._isValid = false;
        }
    }

    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }

        configFromISO(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        configFromRFC2822(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        if (config._strict) {
            config._isValid = false;
        } else {
            // Final attempt, use Input Fallback
            hooks.createFromInputFallback(config);
        }
    }

    hooks.createFromInputFallback = deprecate(
        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
            'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
            'discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.',
        function (config) {
            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
        }
    );

    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) {
            return a;
        }
        if (b != null) {
            return b;
        }
        return c;
    }

    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) {
            return [
                nowValue.getUTCFullYear(),
                nowValue.getUTCMonth(),
                nowValue.getUTCDate(),
            ];
        }
        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
    }

    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i,
            date,
            input = [],
            currentDate,
            expectedWeekday,
            yearToUse;

        if (config._d) {
            return;
        }

        currentDate = currentDateArray(config);

        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
            dayOfYearFromWeekInfo(config);
        }

        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

            if (
                config._dayOfYear > daysInYear(yearToUse) ||
                config._dayOfYear === 0
            ) {
                getParsingFlags(config)._overflowDayOfYear = true;
            }

            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }

        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for (i = 0; i < 3 && config._a[i] == null; ++i) {
            config._a[i] = input[i] = currentDate[i];
        }

        // Zero out whatever was not defaulted, including time
        for (; i < 7; i++) {
            config._a[i] = input[i] =
                config._a[i] == null ? (i === 2 ? 1 : 0) : config._a[i];
        }

        // Check for 24:00:00.000
        if (
            config._a[HOUR] === 24 &&
            config._a[MINUTE] === 0 &&
            config._a[SECOND] === 0 &&
            config._a[MILLISECOND] === 0
        ) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }

        config._d = (config._useUTC ? createUTCDate : createDate).apply(
            null,
            input
        );
        expectedWeekday = config._useUTC
            ? config._d.getUTCDay()
            : config._d.getDay();

        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) {
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        }

        if (config._nextDay) {
            config._a[HOUR] = 24;
        }

        // check for mismatching day of week
        if (
            config._w &&
            typeof config._w.d !== 'undefined' &&
            config._w.d !== expectedWeekday
        ) {
            getParsingFlags(config).weekdayMismatch = true;
        }
    }

    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;

        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;

            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(
                w.GG,
                config._a[YEAR],
                weekOfYear(createLocal(), 1, 4).year
            );
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) {
                weekdayOverflow = true;
            }
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;

            curWeek = weekOfYear(createLocal(), dow, doy);

            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

            // Default to current week.
            week = defaults(w.w, curWeek.week);

            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) {
                    weekdayOverflow = true;
                }
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) {
                    weekdayOverflow = true;
                }
            } else {
                // default to beginning of week
                weekday = dow;
            }
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
            getParsingFlags(config)._overflowWeeks = true;
        } else if (weekdayOverflow != null) {
            getParsingFlags(config)._overflowWeekday = true;
        } else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }

    // constant that refers to the ISO standard
    hooks.ISO_8601 = function () {};

    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function () {};

    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;

        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i,
            i,
            parsedInput,
            tokens,
            token,
            skipped,
            stringLength = string.length,
            totalParsedInputLength = 0,
            era,
            tokenLen;

        tokens =
            expandFormat(config._f, config._locale).match(formattingTokens) || [];
        tokenLen = tokens.length;
        for (i = 0; i < tokenLen; i++) {
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) ||
                [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) {
                    getParsingFlags(config).unusedInput.push(skipped);
                }
                string = string.slice(
                    string.indexOf(parsedInput) + parsedInput.length
                );
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) {
                    getParsingFlags(config).empty = false;
                } else {
                    getParsingFlags(config).unusedTokens.push(token);
                }
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) {
                getParsingFlags(config).unusedTokens.push(token);
            }
        }

        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver =
            stringLength - totalParsedInputLength;
        if (string.length > 0) {
            getParsingFlags(config).unusedInput.push(string);
        }

        // clear _12h flag if hour is <= 12
        if (
            config._a[HOUR] <= 12 &&
            getParsingFlags(config).bigHour === true &&
            config._a[HOUR] > 0
        ) {
            getParsingFlags(config).bigHour = undefined;
        }

        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(
            config._locale,
            config._a[HOUR],
            config._meridiem
        );

        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) {
            config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        }

        configFromArray(config);
        checkOverflow(config);
    }

    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;

        if (meridiem == null) {
            // nothing to do
            return hour;
        }
        if (locale.meridiemHour != null) {
            return locale.meridiemHour(hour, meridiem);
        } else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) {
                hour += 12;
            }
            if (!isPm && hour === 12) {
                hour = 0;
            }
            return hour;
        } else {
            // this is not supposed to happen
            return hour;
        }
    }

    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig,
            bestMoment,
            scoreToBeat,
            i,
            currentScore,
            validFormatFound,
            bestFormatIsValid = false,
            configfLen = config._f.length;

        if (configfLen === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }

        for (i = 0; i < configfLen; i++) {
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) {
                tempConfig._useUTC = config._useUTC;
            }
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);

            if (isValid(tempConfig)) {
                validFormatFound = true;
            }

            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;

            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

            getParsingFlags(tempConfig).score = currentScore;

            if (!bestFormatIsValid) {
                if (
                    scoreToBeat == null ||
                    currentScore < scoreToBeat ||
                    validFormatFound
                ) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) {
                        bestFormatIsValid = true;
                    }
                }
            } else {
                if (currentScore < scoreToBeat) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                }
            }
        }

        extend(config, bestMoment || tempConfig);
    }

    function configFromObject(config) {
        if (config._d) {
            return;
        }

        var i = normalizeObjectUnits(config._i),
            dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map(
            [i.year, i.month, dayOrDate, i.hour, i.minute, i.second, i.millisecond],
            function (obj) {
                return obj && parseInt(obj, 10);
            }
        );

        configFromArray(config);
    }

    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }

        return res;
    }

    function prepareConfig(config) {
        var input = config._i,
            format = config._f;

        config._locale = config._locale || getLocale(config._l);

        if (input === null || (format === undefined && input === '')) {
            return createInvalid({ nullInput: true });
        }

        if (typeof input === 'string') {
            config._i = input = config._locale.preparse(input);
        }

        if (isMoment(input)) {
            return new Moment(checkOverflow(input));
        } else if (isDate(input)) {
            config._d = input;
        } else if (isArray(format)) {
            configFromStringAndArray(config);
        } else if (format) {
            configFromStringAndFormat(config);
        } else {
            configFromInput(config);
        }

        if (!isValid(config)) {
            config._d = null;
        }

        return config;
    }

    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) {
            config._d = new Date(hooks.now());
        } else if (isDate(input)) {
            config._d = new Date(input.valueOf());
        } else if (typeof input === 'string') {
            configFromString(config);
        } else if (isArray(input)) {
            config._a = map(input.slice(0), function (obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) {
            configFromObject(config);
        } else if (isNumber(input)) {
            // from milliseconds
            config._d = new Date(input);
        } else {
            hooks.createFromInputFallback(config);
        }
    }

    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};

        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }

        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }

        if (
            (isObject(input) && isObjectEmpty(input)) ||
            (isArray(input) && input.length === 0)
        ) {
            input = undefined;
        }
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;

        return createFromConfig(c);
    }

    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }

    var prototypeMin = deprecate(
            'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
            function () {
                var other = createLocal.apply(null, arguments);
                if (this.isValid() && other.isValid()) {
                    return other < this ? this : other;
                } else {
                    return createInvalid();
                }
            }
        ),
        prototypeMax = deprecate(
            'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
            function () {
                var other = createLocal.apply(null, arguments);
                if (this.isValid() && other.isValid()) {
                    return other > this ? this : other;
                } else {
                    return createInvalid();
                }
            }
        );

    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) {
            moments = moments[0];
        }
        if (!moments.length) {
            return createLocal();
        }
        res = moments[0];
        for (i = 1; i < moments.length; ++i) {
            if (!moments[i].isValid() || moments[i][fn](res)) {
                res = moments[i];
            }
        }
        return res;
    }

    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isBefore', args);
    }

    function max() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isAfter', args);
    }

    var now = function () {
        return Date.now ? Date.now() : +new Date();
    };

    var ordering = [
        'year',
        'quarter',
        'month',
        'week',
        'day',
        'hour',
        'minute',
        'second',
        'millisecond',
    ];

    function isDurationValid(m) {
        var key,
            unitHasDecimal = false,
            i,
            orderLen = ordering.length;
        for (key in m) {
            if (
                hasOwnProp(m, key) &&
                !(
                    indexOf.call(ordering, key) !== -1 &&
                    (m[key] == null || !isNaN(m[key]))
                )
            ) {
                return false;
            }
        }

        for (i = 0; i < orderLen; ++i) {
            if (m[ordering[i]]) {
                if (unitHasDecimal) {
                    return false; // only allow non-integers for smallest unit
                }
                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                    unitHasDecimal = true;
                }
            }
        }

        return true;
    }

    function isValid$1() {
        return this._isValid;
    }

    function createInvalid$1() {
        return createDuration(NaN);
    }

    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration),
            years = normalizedInput.year || 0,
            quarters = normalizedInput.quarter || 0,
            months = normalizedInput.month || 0,
            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
            days = normalizedInput.day || 0,
            hours = normalizedInput.hour || 0,
            minutes = normalizedInput.minute || 0,
            seconds = normalizedInput.second || 0,
            milliseconds = normalizedInput.millisecond || 0;

        this._isValid = isDurationValid(normalizedInput);

        // representation for dateAddRemove
        this._milliseconds =
            +milliseconds +
            seconds * 1e3 + // 1000
            minutes * 6e4 + // 1000 * 60
            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;

        this._data = {};

        this._locale = getLocale();

        this._bubble();
    }

    function isDuration(obj) {
        return obj instanceof Duration;
    }

    function absRound(number) {
        if (number < 0) {
            return Math.round(-1 * number) * -1;
        } else {
            return Math.round(number);
        }
    }

    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length),
            lengthDiff = Math.abs(array1.length - array2.length),
            diffs = 0,
            i;
        for (i = 0; i < len; i++) {
            if (
                (dontConvert && array1[i] !== array2[i]) ||
                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))
            ) {
                diffs++;
            }
        }
        return diffs + lengthDiff;
    }

    // FORMATTING

    function offset(token, separator) {
        addFormatToken(token, 0, 0, function () {
            var offset = this.utcOffset(),
                sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return (
                sign +
                zeroFill(~~(offset / 60), 2) +
                separator +
                zeroFill(~~offset % 60, 2)
            );
        });
    }

    offset('Z', ':');
    offset('ZZ', '');

    // PARSING

    addRegexToken('Z', matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken(['Z', 'ZZ'], function (input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });

    // HELPERS

    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;

    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher),
            chunk,
            parts,
            minutes;

        if (matches === null) {
            return null;
        }

        chunk = matches[matches.length - 1] || [];
        parts = (chunk + '').match(chunkOffset) || ['-', 0, 0];
        minutes = +(parts[1] * 60) + toInt(parts[2]);

        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
    }

    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff =
                (isMoment(input) || isDate(input)
                    ? input.valueOf()
                    : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else {
            return createLocal(input).local();
        }
    }

    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }

    // HOOKS

    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function () {};

    // MOMENTS

    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0,
            localAdjust;
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) {
                    return this;
                }
            } else if (Math.abs(input) < 16 && !keepMinutes) {
                input = input * 60;
            }
            if (!this._isUTC && keepLocalTime) {
                localAdjust = getDateOffset(this);
            }
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) {
                this.add(localAdjust, 'm');
            }
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) {
                    addSubtract(
                        this,
                        createDuration(input - offset, 'm'),
                        1,
                        false
                    );
                } else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else {
            return this._isUTC ? offset : getDateOffset(this);
        }
    }

    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') {
                input = -input;
            }

            this.utcOffset(input, keepLocalTime);

            return this;
        } else {
            return -this.utcOffset();
        }
    }

    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }

    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;

            if (keepLocalTime) {
                this.subtract(getDateOffset(this), 'm');
            }
        }
        return this;
    }

    function setOffsetToParsedOffset() {
        if (this._tzm != null) {
            this.utcOffset(this._tzm, false, true);
        } else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) {
                this.utcOffset(tZone);
            } else {
                this.utcOffset(0, true);
            }
        }
        return this;
    }

    function hasAlignedHourOffset(input) {
        if (!this.isValid()) {
            return false;
        }
        input = input ? createLocal(input).utcOffset() : 0;

        return (this.utcOffset() - input) % 60 === 0;
    }

    function isDaylightSavingTime() {
        return (
            this.utcOffset() > this.clone().month(0).utcOffset() ||
            this.utcOffset() > this.clone().month(5).utcOffset()
        );
    }

    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) {
            return this._isDSTShifted;
        }

        var c = {},
            other;

        copyConfig(c, this);
        c = prepareConfig(c);

        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted =
                this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else {
            this._isDSTShifted = false;
        }

        return this._isDSTShifted;
    }

    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }

    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }

    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }

    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,
        // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
        // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
        // and further modified to allow for strings containing both week and day
        isoRegex =
            /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

    function createDuration(input, key) {
        var duration = input,
            // matching against regexp is expensive, do it on demand
            match = null,
            sign,
            ret,
            diffRes;

        if (isDuration(input)) {
            duration = {
                ms: input._milliseconds,
                d: input._days,
                M: input._months,
            };
        } else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) {
                duration[key] = +input;
            } else {
                duration.milliseconds = +input;
            }
        } else if ((match = aspNetRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign, // the millisecond decimal point is included in the match
            };
        } else if ((match = isoRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign),
            };
        } else if (duration == null) {
            // checks for null or undefined
            duration = {};
        } else if (
            typeof duration === 'object' &&
            ('from' in duration || 'to' in duration)
        ) {
            diffRes = momentsDifference(
                createLocal(duration.from),
                createLocal(duration.to)
            );

            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }

        ret = new Duration(duration);

        if (isDuration(input) && hasOwnProp(input, '_locale')) {
            ret._locale = input._locale;
        }

        if (isDuration(input) && hasOwnProp(input, '_isValid')) {
            ret._isValid = input._isValid;
        }

        return ret;
    }

    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;

    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }

    function positiveMomentsDifference(base, other) {
        var res = {};

        res.months =
            other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) {
            --res.months;
        }

        res.milliseconds = +other - +base.clone().add(res.months, 'M');

        return res;
    }

    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) {
            return { milliseconds: 0, months: 0 };
        }

        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) {
            res = positiveMomentsDifference(base, other);
        } else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }

        return res;
    }

    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function (val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(
                    name,
                    'moment().' +
                        name +
                        '(period, number) is deprecated. Please use moment().' +
                        name +
                        '(number, period). ' +
                        'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.'
                );
                tmp = val;
                val = period;
                period = tmp;
            }

            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }

    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds,
            days = absRound(duration._days),
            months = absRound(duration._months);

        if (!mom.isValid()) {
            // No op
            return;
        }

        updateOffset = updateOffset == null ? true : updateOffset;

        if (months) {
            setMonth(mom, get(mom, 'Month') + months * isAdding);
        }
        if (days) {
            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        }
        if (milliseconds) {
            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        }
        if (updateOffset) {
            hooks.updateOffset(mom, days || months);
        }
    }

    var add = createAdder(1, 'add'),
        subtract = createAdder(-1, 'subtract');

    function isString(input) {
        return typeof input === 'string' || input instanceof String;
    }

    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return (
            isMoment(input) ||
            isDate(input) ||
            isString(input) ||
            isNumber(input) ||
            isNumberOrStringArray(input) ||
            isMomentInputObject(input) ||
            input === null ||
            input === undefined
        );
    }

    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = [
                'years',
                'year',
                'y',
                'months',
                'month',
                'M',
                'days',
                'day',
                'd',
                'dates',
                'date',
                'D',
                'hours',
                'hour',
                'h',
                'minutes',
                'minute',
                'm',
                'seconds',
                'second',
                's',
                'milliseconds',
                'millisecond',
                'ms',
            ],
            i,
            property,
            propertyLen = properties.length;

        for (i = 0; i < propertyLen; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input),
            dataTypeTest = false;
        if (arrayTest) {
            dataTypeTest =
                input.filter(function (item) {
                    return !isNumber(item) && isString(input);
                }).length === 0;
        }
        return arrayTest && dataTypeTest;
    }

    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = [
                'sameDay',
                'nextDay',
                'lastDay',
                'nextWeek',
                'lastWeek',
                'sameElse',
            ],
            i,
            property;

        for (i = 0; i < properties.length; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6
            ? 'sameElse'
            : diff < -1
              ? 'lastWeek'
              : diff < 0
                ? 'lastDay'
                : diff < 1
                  ? 'sameDay'
                  : diff < 2
                    ? 'nextDay'
                    : diff < 7
                      ? 'nextWeek'
                      : 'sameElse';
    }

    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(),
            sod = cloneWithOffset(now, this).startOf('day'),
            format = hooks.calendarFormat(this, sod) || 'sameElse',
            output =
                formats &&
                (isFunction(formats[format])
                    ? formats[format].call(this, now)
                    : formats[format]);

        return this.format(
            output || this.localeData().calendar(format, this, createLocal(now))
        );
    }

    function clone() {
        return new Moment(this);
    }

    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() > localInput.valueOf();
        } else {
            return localInput.valueOf() < this.clone().startOf(units).valueOf();
        }
    }

    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() < localInput.valueOf();
        } else {
            return this.clone().endOf(units).valueOf() < localInput.valueOf();
        }
    }

    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from),
            localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
            return false;
        }
        inclusivity = inclusivity || '()';
        return (
            (inclusivity[0] === '('
                ? this.isAfter(localFrom, units)
                : !this.isBefore(localFrom, units)) &&
            (inclusivity[1] === ')'
                ? this.isBefore(localTo, units)
                : !this.isAfter(localTo, units))
        );
    }

    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input),
            inputMs;
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() === localInput.valueOf();
        } else {
            inputMs = localInput.valueOf();
            return (
                this.clone().startOf(units).valueOf() <= inputMs &&
                inputMs <= this.clone().endOf(units).valueOf()
            );
        }
    }

    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }

    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }

    function diff(input, units, asFloat) {
        var that, zoneDelta, output;

        if (!this.isValid()) {
            return NaN;
        }

        that = cloneWithOffset(input, this);

        if (!that.isValid()) {
            return NaN;
        }

        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

        units = normalizeUnits(units);

        switch (units) {
            case 'year':
                output = monthDiff(this, that) / 12;
                break;
            case 'month':
                output = monthDiff(this, that);
                break;
            case 'quarter':
                output = monthDiff(this, that) / 3;
                break;
            case 'second':
                output = (this - that) / 1e3;
                break; // 1000
            case 'minute':
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case 'hour':
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case 'day':
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case 'week':
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }

        return asFloat ? output : absFloor(output);
    }

    function monthDiff(a, b) {
        if (a.date() < b.date()) {
            // end-of-month calculations work correct when the start month has more
            // days than the end month.
            return -monthDiff(b, a);
        }
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()),
            // b is in (anchor - 1 month, anchor + 1 month)
            anchor = a.clone().add(wholeMonthDiff, 'months'),
            anchor2,
            adjust;

        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }

        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }

    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

    function toString() {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }

    function toISOString(keepOffset) {
        if (!this.isValid()) {
            return null;
        }
        var utc = keepOffset !== true,
            m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) {
            return formatMoment(
                m,
                utc
                    ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]'
                    : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ'
            );
        }
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) {
                return this.toDate().toISOString();
            } else {
                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000)
                    .toISOString()
                    .replace('Z', formatMoment(m, 'Z'));
            }
        }
        return formatMoment(
            m,
            utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ'
        );
    }

    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */
    function inspect() {
        if (!this.isValid()) {
            return 'moment.invalid(/* ' + this._i + ' */)';
        }
        var func = 'moment',
            zone = '',
            prefix,
            year,
            datetime,
            suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        prefix = '[' + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
        datetime = '-MM-DD[T]HH:mm:ss.SSS';
        suffix = zone + '[")]';

        return this.format(prefix + year + datetime + suffix);
    }

    function format(inputString) {
        if (!inputString) {
            inputString = this.isUtc()
                ? hooks.defaultFormatUtc
                : hooks.defaultFormat;
        }
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }

    function from(time, withoutSuffix) {
        if (
            this.isValid() &&
            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
        ) {
            return createDuration({ to: this, from: time })
                .locale(this.locale())
                .humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }

    function to(time, withoutSuffix) {
        if (
            this.isValid() &&
            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
        ) {
            return createDuration({ from: this, to: time })
                .locale(this.locale())
                .humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }

    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;

        if (key === undefined) {
            return this._locale._abbr;
        } else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) {
                this._locale = newLocaleData;
            }
            return this;
        }
    }

    var lang = deprecate(
        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
        function (key) {
            if (key === undefined) {
                return this.localeData();
            } else {
                return this.locale(key);
            }
        }
    );

    function localeData() {
        return this._locale;
    }

    var MS_PER_SECOND = 1000,
        MS_PER_MINUTE = 60 * MS_PER_SECOND,
        MS_PER_HOUR = 60 * MS_PER_MINUTE,
        MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;

    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return ((dividend % divisor) + divisor) % divisor;
    }

    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return new Date(y, m, d).valueOf();
        }
    }

    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return Date.UTC(y, m, d);
        }
    }

    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year(), 0, 1);
                break;
            case 'quarter':
                time = startOfDate(
                    this.year(),
                    this.month() - (this.month() % 3),
                    1
                );
                break;
            case 'month':
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case 'week':
                time = startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - this.weekday()
                );
                break;
            case 'isoWeek':
                time = startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - (this.isoWeekday() - 1)
                );
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case 'hour':
                time = this._d.valueOf();
                time -= mod$1(
                    time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                    MS_PER_HOUR
                );
                break;
            case 'minute':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case 'second':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case 'quarter':
                time =
                    startOfDate(
                        this.year(),
                        this.month() - (this.month() % 3) + 3,
                        1
                    ) - 1;
                break;
            case 'month':
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case 'week':
                time =
                    startOfDate(
                        this.year(),
                        this.month(),
                        this.date() - this.weekday() + 7
                    ) - 1;
                break;
            case 'isoWeek':
                time =
                    startOfDate(
                        this.year(),
                        this.month(),
                        this.date() - (this.isoWeekday() - 1) + 7
                    ) - 1;
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case 'hour':
                time = this._d.valueOf();
                time +=
                    MS_PER_HOUR -
                    mod$1(
                        time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                        MS_PER_HOUR
                    ) -
                    1;
                break;
            case 'minute':
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case 'second':
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }

    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }

    function toDate() {
        return new Date(this.valueOf());
    }

    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond(),
        ];
    }

    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds(),
        };
    }

    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }

    function isValid$2() {
        return isValid(this);
    }

    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }

    function invalidAt() {
        return getParsingFlags(this).overflow;
    }

    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict,
        };
    }

    addFormatToken('N', 0, 0, 'eraAbbr');
    addFormatToken('NN', 0, 0, 'eraAbbr');
    addFormatToken('NNN', 0, 0, 'eraAbbr');
    addFormatToken('NNNN', 0, 0, 'eraName');
    addFormatToken('NNNNN', 0, 0, 'eraNarrow');

    addFormatToken('y', ['y', 1], 'yo', 'eraYear');
    addFormatToken('y', ['yy', 2], 0, 'eraYear');
    addFormatToken('y', ['yyy', 3], 0, 'eraYear');
    addFormatToken('y', ['yyyy', 4], 0, 'eraYear');

    addRegexToken('N', matchEraAbbr);
    addRegexToken('NN', matchEraAbbr);
    addRegexToken('NNN', matchEraAbbr);
    addRegexToken('NNNN', matchEraName);
    addRegexToken('NNNNN', matchEraNarrow);

    addParseToken(
        ['N', 'NN', 'NNN', 'NNNN', 'NNNNN'],
        function (input, array, config, token) {
            var era = config._locale.erasParse(input, token, config._strict);
            if (era) {
                getParsingFlags(config).era = era;
            } else {
                getParsingFlags(config).invalidEra = input;
            }
        }
    );

    addRegexToken('y', matchUnsigned);
    addRegexToken('yy', matchUnsigned);
    addRegexToken('yyy', matchUnsigned);
    addRegexToken('yyyy', matchUnsigned);
    addRegexToken('yo', matchEraYearOrdinal);

    addParseToken(['y', 'yy', 'yyy', 'yyyy'], YEAR);
    addParseToken(['yo'], function (input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) {
            match = input.match(config._locale._eraYearOrdinalRegex);
        }

        if (config._locale.eraYearOrdinalParse) {
            array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        } else {
            array[YEAR] = parseInt(input, 10);
        }
    });

    function localeEras(m, format) {
        var i,
            l,
            date,
            eras = this._eras || getLocale('en')._eras;
        for (i = 0, l = eras.length; i < l; ++i) {
            switch (typeof eras[i].since) {
                case 'string':
                    // truncate time
                    date = hooks(eras[i].since).startOf('day');
                    eras[i].since = date.valueOf();
                    break;
            }

            switch (typeof eras[i].until) {
                case 'undefined':
                    eras[i].until = +Infinity;
                    break;
                case 'string':
                    // truncate time
                    date = hooks(eras[i].until).startOf('day').valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }

    function localeErasParse(eraName, format, strict) {
        var i,
            l,
            eras = this.eras(),
            name,
            abbr,
            narrow;
        eraName = eraName.toUpperCase();

        for (i = 0, l = eras.length; i < l; ++i) {
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();

            if (strict) {
                switch (format) {
                    case 'N':
                    case 'NN':
                    case 'NNN':
                        if (abbr === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNN':
                        if (name === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNNN':
                        if (narrow === eraName) {
                            return eras[i];
                        }
                        break;
                }
            } else if ([name, abbr, narrow].indexOf(eraName) >= 0) {
                return eras[i];
            }
        }
    }

    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? +1 : -1;
        if (year === undefined) {
            return hooks(era.since).year();
        } else {
            return hooks(era.since).year() + (year - era.offset) * dir;
        }
    }

    function getEraName() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].name;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].name;
            }
        }

        return '';
    }

    function getEraNarrow() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].narrow;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].narrow;
            }
        }

        return '';
    }

    function getEraAbbr() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].abbr;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].abbr;
            }
        }

        return '';
    }

    function getEraYear() {
        var i,
            l,
            dir,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            dir = eras[i].since <= eras[i].until ? +1 : -1;

            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (
                (eras[i].since <= val && val <= eras[i].until) ||
                (eras[i].until <= val && val <= eras[i].since)
            ) {
                return (
                    (this.year() - hooks(eras[i].since).year()) * dir +
                    eras[i].offset
                );
            }
        }

        return this.year();
    }

    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNameRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }

    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, '_erasAbbrRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }

    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNarrowRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }

    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }

    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }

    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }

    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }

    function computeErasParse() {
        var abbrPieces = [],
            namePieces = [],
            narrowPieces = [],
            mixedPieces = [],
            i,
            l,
            erasName,
            erasAbbr,
            erasNarrow,
            eras = this.eras();

        for (i = 0, l = eras.length; i < l; ++i) {
            erasName = regexEscape(eras[i].name);
            erasAbbr = regexEscape(eras[i].abbr);
            erasNarrow = regexEscape(eras[i].narrow);

            namePieces.push(erasName);
            abbrPieces.push(erasAbbr);
            narrowPieces.push(erasNarrow);
            mixedPieces.push(erasName);
            mixedPieces.push(erasAbbr);
            mixedPieces.push(erasNarrow);
        }

        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
        this._erasNarrowRegex = new RegExp(
            '^(' + narrowPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    addFormatToken(0, ['gg', 2], 0, function () {
        return this.weekYear() % 100;
    });

    addFormatToken(0, ['GG', 2], 0, function () {
        return this.isoWeekYear() % 100;
    });

    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [token, token.length], 0, getter);
    }

    addWeekYearFormatToken('gggg', 'weekYear');
    addWeekYearFormatToken('ggggg', 'weekYear');
    addWeekYearFormatToken('GGGG', 'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');

    // ALIASES

    // PARSING

    addRegexToken('G', matchSigned);
    addRegexToken('g', matchSigned);
    addRegexToken('GG', match1to2, match2);
    addRegexToken('gg', match1to2, match2);
    addRegexToken('GGGG', match1to4, match4);
    addRegexToken('gggg', match1to4, match4);
    addRegexToken('GGGGG', match1to6, match6);
    addRegexToken('ggggg', match1to6, match6);

    addWeekParseToken(
        ['gggg', 'ggggg', 'GGGG', 'GGGGG'],
        function (input, week, config, token) {
            week[token.substr(0, 2)] = toInt(input);
        }
    );

    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });

    // MOMENTS

    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(
            this,
            input,
            this.week(),
            this.weekday() + this.localeData()._week.dow,
            this.localeData()._week.dow,
            this.localeData()._week.doy
        );
    }

    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(
            this,
            input,
            this.isoWeek(),
            this.isoWeekday(),
            1,
            4
        );
    }

    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }

    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }

    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }

    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }

    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) {
            return weekOfYear(this, dow, doy).year;
        } else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) {
                week = weeksTarget;
            }
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }

    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }

    // FORMATTING

    addFormatToken('Q', 0, 'Qo', 'quarter');

    // PARSING

    addRegexToken('Q', match1);
    addParseToken('Q', function (input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });

    // MOMENTS

    function getSetQuarter(input) {
        return input == null
            ? Math.ceil((this.month() + 1) / 3)
            : this.month((input - 1) * 3 + (this.month() % 3));
    }

    // FORMATTING

    addFormatToken('D', ['DD', 2], 'Do', 'date');

    // PARSING

    addRegexToken('D', match1to2, match1to2NoLeadingZero);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function (isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict
            ? locale._dayOfMonthOrdinalParse || locale._ordinalParse
            : locale._dayOfMonthOrdinalParseLenient;
    });

    addParseToken(['D', 'DD'], DATE);
    addParseToken('Do', function (input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });

    // MOMENTS

    var getSetDayOfMonth = makeGetSet('Date', true);

    // FORMATTING

    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

    // PARSING

    addRegexToken('DDD', match1to3);
    addRegexToken('DDDD', match3);
    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
        config._dayOfYear = toInt(input);
    });

    // HELPERS

    // MOMENTS

    function getSetDayOfYear(input) {
        var dayOfYear =
            Math.round(
                (this.clone().startOf('day') - this.clone().startOf('year')) / 864e5
            ) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
    }

    // FORMATTING

    addFormatToken('m', ['mm', 2], 0, 'minute');

    // PARSING

    addRegexToken('m', match1to2, match1to2HasZero);
    addRegexToken('mm', match1to2, match2);
    addParseToken(['m', 'mm'], MINUTE);

    // MOMENTS

    var getSetMinute = makeGetSet('Minutes', false);

    // FORMATTING

    addFormatToken('s', ['ss', 2], 0, 'second');

    // PARSING

    addRegexToken('s', match1to2, match1to2HasZero);
    addRegexToken('ss', match1to2, match2);
    addParseToken(['s', 'ss'], SECOND);

    // MOMENTS

    var getSetSecond = makeGetSet('Seconds', false);

    // FORMATTING

    addFormatToken('S', 0, 0, function () {
        return ~~(this.millisecond() / 100);
    });

    addFormatToken(0, ['SS', 2], 0, function () {
        return ~~(this.millisecond() / 10);
    });

    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
    addFormatToken(0, ['SSSS', 4], 0, function () {
        return this.millisecond() * 10;
    });
    addFormatToken(0, ['SSSSS', 5], 0, function () {
        return this.millisecond() * 100;
    });
    addFormatToken(0, ['SSSSSS', 6], 0, function () {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
        return this.millisecond() * 1000000;
    });

    // PARSING

    addRegexToken('S', match1to3, match1);
    addRegexToken('SS', match1to3, match2);
    addRegexToken('SSS', match1to3, match3);

    var token, getSetMillisecond;
    for (token = 'SSSS'; token.length <= 9; token += 'S') {
        addRegexToken(token, matchUnsigned);
    }

    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }

    for (token = 'S'; token.length <= 9; token += 'S') {
        addParseToken(token, parseMs);
    }

    getSetMillisecond = makeGetSet('Milliseconds', false);

    // FORMATTING

    addFormatToken('z', 0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');

    // MOMENTS

    function getZoneAbbr() {
        return this._isUTC ? 'UTC' : '';
    }

    function getZoneName() {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }

    var proto = Moment.prototype;

    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== 'undefined' && Symbol.for != null) {
        proto[Symbol.for('nodejs.util.inspect.custom')] = function () {
            return 'Moment<' + this.format() + '>';
        };
    }
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate(
        'dates accessor is deprecated. Use date instead.',
        getSetDayOfMonth
    );
    proto.months = deprecate(
        'months accessor is deprecated. Use month instead',
        getSetMonth
    );
    proto.years = deprecate(
        'years accessor is deprecated. Use year instead',
        getSetYear
    );
    proto.zone = deprecate(
        'moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/',
        getSetZone
    );
    proto.isDSTShifted = deprecate(
        'isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information',
        isDaylightSavingTimeShifted
    );

    function createUnix(input) {
        return createLocal(input * 1000);
    }

    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }

    function preParsePostFormat(string) {
        return string;
    }

    var proto$1 = Locale.prototype;

    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;

    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;

    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;

    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;

    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;

    function get$1(format, index, field, setter) {
        var locale = getLocale(),
            utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }

    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';

        if (index != null) {
            return get$1(format, index, field, 'month');
        }

        var i,
            out = [];
        for (i = 0; i < 12; i++) {
            out[i] = get$1(format, i, field, 'month');
        }
        return out;
    }

    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;

            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        }

        var locale = getLocale(),
            shift = localeSorted ? locale._week.dow : 0,
            i,
            out = [];

        if (index != null) {
            return get$1(format, (index + shift) % 7, field, 'day');
        }

        for (i = 0; i < 7; i++) {
            out[i] = get$1(format, (i + shift) % 7, field, 'day');
        }
        return out;
    }

    function listMonths(format, index) {
        return listMonthsImpl(format, index, 'months');
    }

    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }

    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }

    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }

    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }

    getSetGlobalLocale('en', {
        eras: [
            {
                since: '0001-01-01',
                until: +Infinity,
                offset: 1,
                name: 'Anno Domini',
                narrow: 'AD',
                abbr: 'AD',
            },
            {
                since: '0000-12-31',
                until: -Infinity,
                offset: 1,
                name: 'Before Christ',
                narrow: 'BC',
                abbr: 'BC',
            },
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    toInt((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                          ? 'st'
                          : b === 2
                            ? 'nd'
                            : b === 3
                              ? 'rd'
                              : 'th';
            return number + output;
        },
    });

    // Side effect imports

    hooks.lang = deprecate(
        'moment.lang is deprecated. Use moment.locale instead.',
        getSetGlobalLocale
    );
    hooks.langData = deprecate(
        'moment.langData is deprecated. Use moment.localeData instead.',
        getLocale
    );

    var mathAbs = Math.abs;

    function abs() {
        var data = this._data;

        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);

        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);

        return this;
    }

    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);

        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;

        return duration._bubble();
    }

    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }

    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }

    function absCeil(number) {
        if (number < 0) {
            return Math.floor(number);
        } else {
            return Math.ceil(number);
        }
    }

    function bubble() {
        var milliseconds = this._milliseconds,
            days = this._days,
            months = this._months,
            data = this._data,
            seconds,
            minutes,
            hours,
            years,
            monthsFromDays;

        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (
            !(
                (milliseconds >= 0 && days >= 0 && months >= 0) ||
                (milliseconds <= 0 && days <= 0 && months <= 0)
            )
        ) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }

        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;

        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;

        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;

        hours = absFloor(minutes / 60);
        data.hours = hours % 24;

        days += absFloor(hours / 24);

        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        data.days = days;
        data.months = months;
        data.years = years;

        return this;
    }

    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return (days * 4800) / 146097;
    }

    function monthsToDays(months) {
        // the reverse of daysToMonths
        return (months * 146097) / 4800;
    }

    function as(units) {
        if (!this.isValid()) {
            return NaN;
        }
        var days,
            months,
            milliseconds = this._milliseconds;

        units = normalizeUnits(units);

        if (units === 'month' || units === 'quarter' || units === 'year') {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch (units) {
                case 'month':
                    return months;
                case 'quarter':
                    return months / 3;
                case 'year':
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch (units) {
                case 'week':
                    return days / 7 + milliseconds / 6048e5;
                case 'day':
                    return days + milliseconds / 864e5;
                case 'hour':
                    return days * 24 + milliseconds / 36e5;
                case 'minute':
                    return days * 1440 + milliseconds / 6e4;
                case 'second':
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond':
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error('Unknown unit ' + units);
            }
        }
    }

    function makeAs(alias) {
        return function () {
            return this.as(alias);
        };
    }

    var asMilliseconds = makeAs('ms'),
        asSeconds = makeAs('s'),
        asMinutes = makeAs('m'),
        asHours = makeAs('h'),
        asDays = makeAs('d'),
        asWeeks = makeAs('w'),
        asMonths = makeAs('M'),
        asQuarters = makeAs('Q'),
        asYears = makeAs('y'),
        valueOf$1 = asMilliseconds;

    function clone$1() {
        return createDuration(this);
    }

    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }

    function makeGetter(name) {
        return function () {
            return this.isValid() ? this._data[name] : NaN;
        };
    }

    var milliseconds = makeGetter('milliseconds'),
        seconds = makeGetter('seconds'),
        minutes = makeGetter('minutes'),
        hours = makeGetter('hours'),
        days = makeGetter('days'),
        months = makeGetter('months'),
        years = makeGetter('years');

    function weeks() {
        return absFloor(this.days() / 7);
    }

    var round = Math.round,
        thresholds = {
            ss: 44, // a few seconds to seconds
            s: 45, // seconds to minute
            m: 45, // minutes to hour
            h: 22, // hours to day
            d: 26, // days to month/week
            w: null, // weeks to month
            M: 11, // months to year
        };

    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }

    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(),
            seconds = round(duration.as('s')),
            minutes = round(duration.as('m')),
            hours = round(duration.as('h')),
            days = round(duration.as('d')),
            months = round(duration.as('M')),
            weeks = round(duration.as('w')),
            years = round(duration.as('y')),
            a =
                (seconds <= thresholds.ss && ['s', seconds]) ||
                (seconds < thresholds.s && ['ss', seconds]) ||
                (minutes <= 1 && ['m']) ||
                (minutes < thresholds.m && ['mm', minutes]) ||
                (hours <= 1 && ['h']) ||
                (hours < thresholds.h && ['hh', hours]) ||
                (days <= 1 && ['d']) ||
                (days < thresholds.d && ['dd', days]);

        if (thresholds.w != null) {
            a =
                a ||
                (weeks <= 1 && ['w']) ||
                (weeks < thresholds.w && ['ww', weeks]);
        }
        a = a ||
            (months <= 1 && ['M']) ||
            (months < thresholds.M && ['MM', months]) ||
            (years <= 1 && ['y']) || ['yy', years];

        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }

    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) {
            return round;
        }
        if (typeof roundingFunction === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }

    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) {
            return false;
        }
        if (limit === undefined) {
            return thresholds[threshold];
        }
        thresholds[threshold] = limit;
        if (threshold === 's') {
            thresholds.ss = limit - 1;
        }
        return true;
    }

    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var withSuffix = false,
            th = thresholds,
            locale,
            output;

        if (typeof argWithSuffix === 'object') {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === 'boolean') {
            withSuffix = argWithSuffix;
        }
        if (typeof argThresholds === 'object') {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) {
                th.ss = argThresholds.s - 1;
            }
        }

        locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale);

        if (withSuffix) {
            output = locale.pastFuture(+this, output);
        }

        return locale.postformat(output);
    }

    var abs$1 = Math.abs;

    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }

    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var seconds = abs$1(this._milliseconds) / 1000,
            days = abs$1(this._days),
            months = abs$1(this._months),
            minutes,
            hours,
            years,
            s,
            total = this.asSeconds(),
            totalSign,
            ymSign,
            daysSign,
            hmsSign;

        if (!total) {
            // this is the same as C#'s (Noda) and python (isodate)...
            // but not other JS (goog.date)
            return 'P0D';
        }

        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';

        totalSign = total < 0 ? '-' : '';
        ymSign = sign(this._months) !== sign(total) ? '-' : '';
        daysSign = sign(this._days) !== sign(total) ? '-' : '';
        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

        return (
            totalSign +
            'P' +
            (years ? ymSign + years + 'Y' : '') +
            (months ? ymSign + months + 'M' : '') +
            (days ? daysSign + days + 'D' : '') +
            (hours || minutes || seconds ? 'T' : '') +
            (hours ? hmsSign + hours + 'H' : '') +
            (minutes ? hmsSign + minutes + 'M' : '') +
            (seconds ? hmsSign + s + 'S' : '')
        );
    }

    var proto$2 = Duration.prototype;

    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;

    proto$2.toIsoString = deprecate(
        'toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)',
        toISOString$1
    );
    proto$2.lang = lang;

    // FORMATTING

    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');

    // PARSING

    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function (input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken('x', function (input, array, config) {
        config._d = new Date(toInt(input));
    });

    //! moment.js

    hooks.version = '2.30.1';

    setHookCallback(createLocal);

    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;

    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm', // <input type="datetime-local" />
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss', // <input type="datetime-local" step="1" />
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS', // <input type="datetime-local" step="0.001" />
        DATE: 'YYYY-MM-DD', // <input type="date" />
        TIME: 'HH:mm', // <input type="time" />
        TIME_SECONDS: 'HH:mm:ss', // <input type="time" step="1" />
        TIME_MS: 'HH:mm:ss.SSS', // <input type="time" step="0.001" />
        WEEK: 'GGGG-[W]WW', // <input type="week" />
        MONTH: 'YYYY-MM', // <input type="month" />
    };

    return hooks;

})));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(166)(module)))

/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return AvailabilityStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Availability; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(14);


var AVAILABILITY_SERVICE_PATH = '/portal-services/oci/availability/{{productid}}/PortalShop';
/**
 * List of possible availability statuses
 */
var AvailabilityStatus;
(function (AvailabilityStatus) {
    AvailabilityStatus["OnStock"] = "OnStock";
    AvailabilityStatus["OutOfStock"] = "OutOfStock";
    AvailabilityStatus["OutOfStockReservable"] = "OutOfStockReservable";
    AvailabilityStatus["OutOfStockNotifiable"] = "OutOfStockNotifiable";
    AvailabilityStatus["ShortnessOfSupplies"] = "ShortnessOfSupplies";
    AvailabilityStatus["DelayedDelivery"] = "DelayedDelivery";
    AvailabilityStatus["Undefined"] = "Undefined";
})(AvailabilityStatus || (AvailabilityStatus = {}));
var Availability = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */])(Availability, _super);
    function Availability(productId) {
        var _this = _super.call(this) || this;
        _this.availability = AvailabilityStatus.Undefined;
        _this.productId = productId;
        return _this;
    }
    /**
     * Returns String for availability status
     * See {@link AvailabilityStatus} for possible values
     * @returns {string}
     */
    Availability.prototype.getStatus = function () {
        return this.availability || AvailabilityStatus.Undefined;
    };
    /**
     * True if a product is currently on stock
     */
    Availability.prototype.isAvailable = function () {
        return this.getStatus() === AvailabilityStatus.OnStock ||
            this.getStatus() === AvailabilityStatus.ShortnessOfSupplies ||
            this.getStatus() === AvailabilityStatus.DelayedDelivery;
    };
    /**
     * True if an ecommerce order can be placed
     * This holds even if out of stock but reservable.
     * Not however, if it is notifyable because that’s not an order process
     */
    Availability.prototype.isOrderable = function () {
        return this.isAvailable() || this.getStatus() === AvailabilityStatus.OutOfStockReservable;
    };
    /**
     * True if people can opt-in to be notified about when a product becomes available.
     * out-of-stock products have this if they’re not being phased out.
     */
    Availability.prototype.isNotifyable = function () {
        return this.getStatus() === AvailabilityStatus.OutOfStockNotifiable;
    };
    /**
     * True if the item is out-of-stock but some action can still be placed on it or is on-stock.
     */
    Availability.prototype.isActionable = function () {
        return this.isOrderable() || this.isNotifyable() || this.getStatus() === AvailabilityStatus.Undefined;
    };
    /**
     * True if the item is out-of-stock. Does also return true if the item is actionable (notifyable or preorderable).
     */
    Availability.prototype.isOutOfStock = function () {
        return this.getStatus().indexOf(AvailabilityStatus.OutOfStock) > -1;
    };
    // From Loadable
    Availability.prototype.loadFunction = function () {
        return $.ajax({
            accepts: { json: 'application/json' },
            dataType: 'json',
            url: AVAILABILITY_SERVICE_PATH.replace('{{productid}}', this.productId),
        });
    };
    // From Loadable
    Availability.prototype.loadCallback = function (data) {
        if (data && 'state' && data.state) {
            this.availability = data.state;
        }
        return this.availability;
    };
    return Availability;
}(__WEBPACK_IMPORTED_MODULE_1__util__["Loadable"]));


/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(2);

// EXTERNAL MODULE: external "(window._g && _g.$) || window.$CQ || window.$ || window.jQuery"
var external___window__g_____g_$_____window_$CQ____window_$____window_jQuery_ = __webpack_require__(0);
var external___window__g_____g_$_____window_$CQ____window_$____window_jQuery__default = /*#__PURE__*/__webpack_require__.n(external___window__g_____g_$_____window_$CQ____window_$____window_jQuery_);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/base/clientlibs/shared/libraries/SCS.Url.js
var SCS_Url = __webpack_require__(21);
var SCS_Url_default = /*#__PURE__*/__webpack_require__.n(SCS_Url);

// CONCATENATED MODULE: ./clientlibs/js/lib/generic/socialmedia/services/Disqus.ts


var COUNT_URL = 'https://swisscomstorys.disqus.com/count-data.js';
function dispatchRequest() {
    var params = [];
    var handlers = [];
    // Data to be used below
    for (var url in callbacks) {
        params.push('2=' + encodeURI(url));
        handlers.push(callbacks[url]);
    }
    // Do request
    external___window__g_____g_$_____window_$CQ____window_$____window_jQuery_["ajax"]({
        // Reject all handlers
        error: function (err) {
            for (var _i = 0, handlers_1 = handlers; _i < handlers_1.length; _i++) {
                var handler = handlers_1[_i];
                handler[2].call(handler[0], err);
            }
        },
        // Just load a script; hardcoded jsonP call
        dataType: 'script',
        // Create url
        url: [
            COUNT_URL, '?',
            params.join('&'),
        ].join(''),
        // Check if handler was called
        success: function (data) {
            if (dispatched) {
                for (var _i = 0, handlers_2 = handlers; _i < handlers_2.length; _i++) {
                    var handler = handlers_2[_i];
                    handler[2].call(handler[0], data);
                }
            }
        },
    });
}
// Set up disqus jsonp
window.DISQUSWIDGETS = {
    displayCount: function (data) {
        dispatched = false;
        if (typeof data === 'object' && typeof data.text === 'object') {
            var counts = data.counts;
            for (var _i = 0, counts_1 = counts; _i < counts_1.length; _i++) {
                var countObj = counts_1[_i];
                var url = countObj.id, comments = countObj.comments;
                var callback = callbacks[url];
                if (!callback) {
                    continue;
                }
                callback[1].call(callback[0], { count: comments, id: url });
            }
        }
        // Dispatch more requests as long as we’re waiting for them
        if (dispatched) {
            dispatchRequest();
        }
        else {
            // Make sure we have no more pending callbacks
            // Resolve them with zero counts, since this happens
            // …whenever disqus is queried for urls it doesn't know
            for (var url in callbacks) {
                callbacks[url][1].call(callbacks[url][0], { id: url, count: 0 });
            }
        }
    },
};
var callbacks = {};
var dispatched = false;
function shareUrl() {
    throw new Error('Disqus does not support sharing');
}
var Disqus = /** @class */ (function () {
    function Disqus() {
        this.name = 'disqus';
        this.category = ['commentCount'];
        this.shareUrl = shareUrl;
    }
    Disqus.prototype.shareCount = function (url) {
        var _this = this;
        url = SCS.Url.stripPathPrefixFromUrl(url);
        // Create the main promise for this getter
        return new Promise(function (resolve, reject) {
            // Add this request to our queued items
            callbacks[url] = [_this, resolve, reject];
            // Register deferred call once to start the requests
            // We have to dispatch requests in sequence
            if (!dispatched) {
                dispatched = window.setTimeout(dispatchRequest, 0);
            }
        });
    };
    return Disqus;
}());


// CONCATENATED MODULE: ./clientlibs/js/lib/generic/socialmedia/services/SCShareCount.ts


// Base url to share something on swisscom
var SHARE_URL = '/portal-app/roamingtool/public/social-media-statistics';
// Base url to query the swisscom API
var SCShareCount_COUNT_URL = '/portal-app/roamingtool/public/social-media-statistics';
function shareCount(url, name) {
    url = SCS.Url.stripPathPrefixFromUrl(url);
    url = SCS.Url.stripProtocolFromUrl(url);
    return new Promise(function (resolve, reject) {
        external___window__g_____g_$_____window_$CQ____window_$____window_jQuery_["ajax"]({
            // Get parameters to pass
            data: { url: encodeURI(url) },
            // Filled in by jquery
            dataType: 'json',
            // Pass through
            error: reject,
            // Extract count from response
            success: function (res) {
                var response = {
                    count: 0,
                };
                if (res && res[0] && res[0].services) {
                    for (var _i = 0, _a = res[0].services; _i < _a.length; _i++) {
                        var service = _a[_i];
                        if (service.service === name) {
                            response.count = service.count;
                            break;
                        }
                    }
                }
                // Call resolve
                resolve(response);
            },
            // Connection type
            type: 'GET',
            // Count url
            url: SCShareCount_COUNT_URL,
        });
    });
}
function SCShareCount_shareUrl(_url) {
    return SHARE_URL;
}
var SCShareCount = /** @class */ (function () {
    function SCShareCount() {
        this.name = 'SCShareCount';
        this.category = ['shareCount'];
        this.shareUrl = SCShareCount_shareUrl;
        this.shareCount = shareCount;
    }
    return SCShareCount;
}());


// CONCATENATED MODULE: ./clientlibs/js/lib/generic/socialmedia/services/Facebook.ts


var Facebook_Facebook = /** @class */ (function (_super) {
    Object(tslib_es6["c" /* __extends */])(Facebook, _super);
    function Facebook() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = 'facebook';
        return _this;
    }
    return Facebook;
}(SCShareCount));


// CONCATENATED MODULE: ./clientlibs/js/lib/generic/socialmedia/services/LinkedIn.ts


var LinkedIn_LinkedIn = /** @class */ (function (_super) {
    Object(tslib_es6["c" /* __extends */])(LinkedIn, _super);
    function LinkedIn() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = 'linkedin';
        return _this;
    }
    return LinkedIn;
}(SCShareCount));


// CONCATENATED MODULE: ./clientlibs/js/lib/generic/socialmedia/services/Mail.ts


var Mail_Mail = /** @class */ (function (_super) {
    Object(tslib_es6["c" /* __extends */])(Mail, _super);
    function Mail() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = 'mail';
        return _this;
    }
    return Mail;
}(SCShareCount));


// CONCATENATED MODULE: ./clientlibs/js/lib/generic/socialmedia/services/Twitter.ts


var Twitter_Twitter = /** @class */ (function (_super) {
    Object(tslib_es6["c" /* __extends */])(Twitter, _super);
    function Twitter() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = 'twitter';
        return _this;
    }
    return Twitter;
}(SCShareCount));


// CONCATENATED MODULE: ./clientlibs/js/lib/generic/socialmedia/services/WhatsApp.ts


var WhatsApp_WhatsApp = /** @class */ (function (_super) {
    Object(tslib_es6["c" /* __extends */])(WhatsApp, _super);
    function WhatsApp() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = 'whatsapp';
        return _this;
    }
    return WhatsApp;
}(SCShareCount));


// CONCATENATED MODULE: ./clientlibs/js/lib/generic/socialmedia/services/Xing.ts


var Xing_Xing = /** @class */ (function (_super) {
    Object(tslib_es6["c" /* __extends */])(Xing, _super);
    function Xing() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = 'xing';
        return _this;
    }
    return Xing;
}(SCShareCount));


// CONCATENATED MODULE: ./clientlibs/js/lib/generic/socialmedia/SocialMedia.ts
/* harmony export (immutable) */ __webpack_exports__["decodeCount"] = decodeCount;
/* harmony export (immutable) */ __webpack_exports__["encodeCount"] = encodeCount;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SocialMedia", function() { return SocialMedia_SocialMedia; });
/* harmony export (immutable) */ __webpack_exports__["getController"] = getController;










function currentPageUrl() {
    // Dereference object once
    var loc = document.location;
    // Build page url
    var canonical = external___window__g_____g_$_____window_$CQ____window_$____window_jQuery_('link[rel=canonical]').attr('href');
    if (canonical) {
        return canonical;
    }
    return [
        loc.protocol,
        '//', loc.host,
        loc.pathname,
    ].join('');
}
// Conversion factors/units for counts
var FACTOR = 1000;
var UNITS = ['k', 'm'];
var UNIT_PATTERN = /^(\d)([km])$/;
// Resolve `2k` to `2000`
function decodeCount(count) {
    var parsedCount = String(count).toLowerCase();
    if (!UNIT_PATTERN.test(parsedCount)) {
        return parseInt(count, 10);
    }
    var f = UNITS.indexOf(RegExp.$2) + 1;
    return parseInt(RegExp.$1, 10) * Math.pow(FACTOR, f);
}
function encodeCount(count) {
    var f = 0;
    while (count > FACTOR) {
        count /= FACTOR;
        f += 1;
    }
    count = Math.floor(count);
    var parsedCount = String(count);
    if (f) {
        parsedCount += UNITS[f - 1];
    }
    return parsedCount.toUpperCase();
}
var SocialMedia_SocialMedia = /** @class */ (function () {
    function SocialMedia() {
        this.services = {};
    }
    SocialMedia.prototype.registerService = function (service) {
        // Implement assertions to validate data
        // This always indicates a developer error
        if (!service.name) {
            throw (new Error('SocialMediaService has no name'));
        }
        if (!service.category) {
            throw (new Error('SocialMediaService has no category'));
        }
        // Register service on manager instance
        this.services[service.name] = service;
    };
    SocialMedia.prototype.shareUrl = function (name, url) {
        return this.dispatchCall('shareUrl', name, url);
    };
    SocialMedia.prototype.shareCount = function (names, url) {
        var _this = this;
        url = SCS.Url.stripPathPrefixFromUrl(url);
        if (typeof names === 'string') {
            names = [names];
        }
        if (!Array.isArray(names)) {
            names = Object.keys(names);
        }
        var promises = names.map(function (name) {
            if (typeof name !== 'string') {
                name = name.name;
            }
            return _this
                .dispatchCall('shareCount', name, url)
                .then(function (rv) {
                if (!rv.count) {
                    rv.count = 0;
                }
                rv.count = decodeCount(rv.count);
                rv.fcount = encodeCount(rv.count);
                return rv;
            })
                .catch(function (e) {
                console.error(new Error('Error getting share count'), e);
                // Create fake response object with error
                var response = { count: 0, fcount: '0', error: _this };
                // Upgrade to a resolved promise
                return Promise.resolve(response);
            });
        });
        // Wait until all promises are resolved
        return Promise.all(promises).then(function (rv) {
            var aggregateCount = rv.reduce(function (count, item) {
                return count + (item.count || 0);
            }, 0);
            var aggregateFCount = encodeCount(aggregateCount);
            var result = rv;
            Object.assign(result, {
                count: aggregateCount,
                counts: aggregateCount,
                fcount: aggregateFCount,
                fcounts: aggregateFCount,
            });
            return result;
        });
    };
    SocialMedia.prototype.servicesByCategory = function (category) {
        var _this = this;
        return Object
            .keys(this.services)
            .map(function (name) { return _this.services[name]; })
            .filter(function (service) {
            return service.category.includes(category);
        });
    };
    SocialMedia.prototype.getRegisteredServices = function () {
        return Object(tslib_es6["a" /* __assign */])({}, this.services);
    };
    SocialMedia.prototype.dispatchCall = function (action, name, url) {
        // Get service from manager instance
        if (!(name in this.services)) {
            // Throw an error if service is not known
            // This always indicates a developer error
            throw (new Error('unknown social media service: ' + name));
        }
        var service = this.services[name];
        // Maybe use url of current page
        if (!url) {
            url = currentPageUrl();
        }
        var fn = (service[action]);
        // Dispatch to the given action
        return fn.call(this, url, name);
    };
    return SocialMedia;
}());

var singleton;
function getController() {
    if (!singleton) {
        singleton = new SocialMedia_SocialMedia();
        singleton.registerService(new Disqus());
        singleton.registerService(new Facebook_Facebook());
        singleton.registerService(new LinkedIn_LinkedIn());
        singleton.registerService(new Mail_Mail());
        singleton.registerService(new Twitter_Twitter());
        singleton.registerService(new WhatsApp_WhatsApp());
        singleton.registerService(new Xing_Xing());
    }
    return singleton;
}


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var vnode_1 = __webpack_require__(213);
var htmldomapi_1 = __webpack_require__(214);
function toVNode(node, domApi) {
    var api = domApi !== undefined ? domApi : htmldomapi_1.default;
    var text;
    if (api.isElement(node)) {
        var id = node.id ? '#' + node.id : '';
        var cn = node.getAttribute('class');
        var c = cn ? '.' + cn.split(' ').join('.') : '';
        var sel = api.tagName(node).toLowerCase() + id + c;
        var attrs = {};
        var children = [];
        var name_1;
        var i = void 0, n = void 0;
        var elmAttrs = node.attributes;
        var elmChildren = node.childNodes;
        for (i = 0, n = elmAttrs.length; i < n; i++) {
            name_1 = elmAttrs[i].nodeName;
            if (name_1 !== 'id' && name_1 !== 'class') {
                attrs[name_1] = elmAttrs[i].nodeValue;
            }
        }
        for (i = 0, n = elmChildren.length; i < n; i++) {
            children.push(toVNode(elmChildren[i], domApi));
        }
        return vnode_1.default(sel, { attrs: attrs }, children, undefined, node);
    }
    else if (api.isText(node)) {
        text = api.getTextContent(node);
        return vnode_1.default(undefined, undefined, undefined, text, node);
    }
    else if (api.isComment(node)) {
        text = api.getTextContent(node);
        return vnode_1.default('!', {}, [], text, node);
    }
    else {
        return vnode_1.default('', {}, [], undefined, node);
    }
}
exports.toVNode = toVNode;
exports.default = toVNode;
//# sourceMappingURL=tovnode.js.map

/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["flavourSizeFromSiebelId"] = flavourSizeFromSiebelId;
/* harmony export (immutable) */ __webpack_exports__["parseLegoContainerDeeplink"] = parseLegoContainerDeeplink;
function flavourSizeFromSiebelId(siebelId) {
    var idParts = siebelId.split(/\s+/);
    var size = idParts.pop();
    while (size && !size.match(/^([A-Z]+|Public|Private|light|go|premium|basic|flat)$/)) {
        size = idParts.pop();
    }
    if (!size) {
        return 'l';
    }
    var flavourSize = size.toLowerCase();
    return (flavourSize === 'private' || flavourSize === 'lego') ? 'l' : flavourSize;
}
function parseLegoContainerDeeplink(deepLink, calcFlavourPrice) {
    if (!deepLink) {
        return null;
    }
    var _a = deepLink.split('--'), config = _a[0], options = _a[1];
    var deserialized = {
        config: [],
        options: {},
    };
    deserialized.config = config.split('__').map(function (serviceAndProductId) {
        var ids = serviceAndProductId.split('-');
        var serviceId = ids.shift() || '';
        var productId = ids.join('-');
        if (serviceId === '' || productId === '') {
            return undefined;
        }
        return { sliderId: serviceId, slideId: productId, cost: calcFlavourPrice(serviceId, productId) };
    }).filter(Boolean);
    if (options) {
        deserialized.options = options.split('__').reduce(function (acc, option) {
            var _a = option.split('-'), key = _a[0], value = _a[1];
            acc[key] = value;
            return acc;
        }, {});
    }
    return deserialized;
}


/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(SnabbdomPragma) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DOCPCheckout; });
/* harmony export (immutable) */ __webpack_exports__["b"] = loadDOCPProductMapping;
/* harmony export (immutable) */ __webpack_exports__["c"] = mapFlavours;
/* harmony export (immutable) */ __webpack_exports__["d"] = xsrfHeader;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_bootstrap_load_snabbdom__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lib_util_helpers__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lib_personalization_profile__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lib_ecommerce_Tc_Module_ServiceAvailability__ = __webpack_require__(44);






var PAYLOAD_NAMES = {
    internet: 'internetFlavour',
    tv: 'tvFlavour',
    voip: 'voipFlavour',
};
var OrderButtons = /** @class */ (function () {
    function OrderButtons(mod, buttonsModule) {
        this.mod = mod;
        this.withLoginText = buttonsModule.$ctx.find('.orderButtonLinkText').text() || buttonsModule.$ctx.find('.existing-customer .button').text();
        this.withoutLoginText = buttonsModule.$ctx.find('.nologinButtonLinkText').text() || buttonsModule.$ctx.find('.without-login .button').text();
        this.profile = Object(__WEBPACK_IMPORTED_MODULE_4_lib_personalization_profile__["getProfile"])();
        this.root = buttonsModule.$ctx.find('> .button-group')[0];
        this.update();
    }
    OrderButtons.prototype.setAvailability = function (data) {
        this.availabilityData = data;
        this.update();
    };
    OrderButtons.prototype.setWithoutLoginUrl = function (url) {
        this.withoutloginUrl = url;
        this.update();
    };
    OrderButtons.prototype.update = function () {
        this.root = Object(__WEBPACK_IMPORTED_MODULE_2_bootstrap_load_snabbdom__["b" /* patch */])(this.root, this.render());
    };
    OrderButtons.prototype.render = function () {
        if (!this.availabilityData) {
            return SnabbdomPragma.createElement("div", null);
        }
        return SnabbdomPragma.createElement("div", null,
            SnabbdomPragma.createElement("sdx-button-group", null,
                this.withoutloginUrl ? SnabbdomPragma.createElement("sdx-button", { "props-theme": "secondary", "props-href": this.withoutloginUrl, "props-label": this.withoutLoginText }) : undefined,
                SnabbdomPragma.createElement("sdx-button", { "on-click": [this.sendToCheckout.bind(this)], "props-label": this.withLoginText })));
    };
    OrderButtons.prototype.sendToCheckout = function (_event, button) {
        return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var checkoutUrl, e_1;
            return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        button.disabled = true;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        return [4 /*yield*/, this.mod.getCheckoutUrl(this.availabilityData, "" + window.location.pathname + window.location.search + window.location.hash, true)];
                    case 2:
                        checkoutUrl = _a.sent();
                        window.location.href = checkoutUrl;
                        return [3 /*break*/, 5];
                    case 3:
                        e_1 = _a.sent();
                        this.mod.log.error('Error sending to DOCP checkout', e_1);
                        return [3 /*break*/, 5];
                    case 4:
                        button.disabled = false;
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    return OrderButtons;
}());
// tslint:disable-next-line: variable-name
var DOCPCheckout = function DOCPCheckout(parent) {
    this.on = function on(callback) {
        this.docpProductMapping = loadDOCPProductMapping();
        this.replaceOrderButtons();
        this.sandbox.subscribe('serviceavailabilitycheck', this);
        this.sandbox.subscribe('orderoverlaystatus', this);
        parent.on.call(this, callback);
    };
    this.replaceOrderButtons = function replaceOrderButtons() {
        var _this = this;
        this.orderButtons = this.$ctx
            .find('.modOrderOverlayOrderButtons')
            .map(function (_i, button) { return (_this.sandbox.getModuleInstance(button, 'OrderOverlayOrderButtons')); })
            .get()
            .filter(Boolean)
            .map(function (buttonsModule) { return new OrderButtons(_this, buttonsModule); });
    };
    this.onServiceAvailabilityDataUpdate = function onServiceAvailabilityDataUpdate(response) {
        var res = response;
        if (!Object(__WEBPACK_IMPORTED_MODULE_5_lib_ecommerce_Tc_Module_ServiceAvailability__["b" /* isValidResponse */])(response)) {
            this.log.warn('Invalid ServiceAvailabilityDataUpdate', response);
            res = undefined;
        }
        this.log.debug('ServiceAvailabilityDataUpdate', response);
        for (var _a = 0, _b = this.orderButtons; _a < _b.length; _a++) {
            var buttons = _b[_a];
            buttons.setAvailability(res);
        }
    };
    this.onOrderButtonsInit = function onOrderButtonsInit(data) {
        this.log.debug('orderButtonsInit', data);
        for (var _a = 0, _b = this.orderButtons; _a < _b.length; _a++) {
            var buttons = _b[_a];
            buttons.setWithoutLoginUrl(data.noLoginUrl);
        }
    };
    this.getCheckoutUrl = function getCheckoutUrl(availabilityData, returnUrl, forceLogin) {
        return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var currentSelection, mapping, flavours, scn, profile, user;
            return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!availabilityData) {
                            throw new Error('Availability data not present');
                        }
                        currentSelection = this.currentSelection;
                        if (!currentSelection) {
                            throw new Error('Config not present');
                        }
                        return [4 /*yield*/, this.docpProductMapping];
                    case 1:
                        mapping = _a.sent();
                        flavours = mapFlavours(mapping, currentSelection, this);
                        return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_4_lib_personalization_profile__["getProfile"])()];
                    case 2:
                        profile = _a.sent();
                        user = profile.getUser();
                        if (user) {
                            scn = user.getId();
                        }
                        return [2 /*return*/, urlToCheckout(flavours, availabilityData.address, returnUrl, scn, forceLogin)];
                }
            });
        });
    };
    function urlToCheckout(flavours, address, returnUrl, scn, forceLogin) {
        var _a;
        if (forceLogin === void 0) { forceLogin = false; }
        return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var payload, fetch, response, _b, _c, url;
            return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        payload = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ address: {
                                city: address.city,
                                houseName: address.houseName,
                                houseNumber: address.houseNumber,
                                locationId: address.locationId,
                                street: address.street,
                                zip: address.zipCode4,
                            }, bundle: {
                                siebelProductName: 'LEGO Home',
                                skuCode: 'LEGO_Home',
                            }, cancelUrl: returnUrl, returnUrl: returnUrl, scn: scn !== null && scn !== void 0 ? scn : null, sessionChannel: 'selfcare', uiLanguage: document.documentElement.lang }, flavours);
                        return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_3_lib_util_helpers__["fetcher"])()];
                    case 1:
                        fetch = _d.sent();
                        return [4 /*yield*/, fetch('/oce/soe/wbc/common/v1/order', {
                                body: JSON.stringify(payload),
                                headers: Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ consumer: 'OCE', 'content-type': 'application/json' }, xsrfHeader()),
                                method: 'POST',
                            })];
                    case 2:
                        response = _d.sent();
                        if (!!((_a = response.headers.get('content-type')) === null || _a === void 0 ? void 0 : _a.startsWith('text/plain'))) return [3 /*break*/, 4];
                        _b = Error.bind;
                        _c = "Unexpected response ";
                        return [4 /*yield*/, response.text()];
                    case 3: throw new (_b.apply(Error, [void 0, _c + (_d.sent())]))();
                    case 4: return [4 /*yield*/, response.text()];
                    case 5:
                        url = _d.sent();
                        if (forceLogin && !scn) {
                            // Using online instead of guest will force the user to log in
                            url = url.replace(/\/guest\//, '/online/');
                        }
                        return [2 /*return*/, url];
                }
            });
        });
    }
};
var mappingPromise;
function loadDOCPProductMapping() {
    var _this = this;
    if (!mappingPromise) {
        mappingPromise = (function () { return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __awaiter */])(_this, void 0, void 0, function () {
            var fetch, response, data, result, _a, data_1, product;
            return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_3_lib_util_helpers__["fetcher"])()];
                    case 1:
                        fetch = _b.sent();
                        return [4 /*yield*/, fetch('/oce/soe/products/v1/category/wireline/subscriptions?category=WIRELINE')];
                    case 2:
                        response = _b.sent();
                        return [4 /*yield*/, response.json()];
                    case 3:
                        data = _b.sent();
                        result = {};
                        for (_a = 0, data_1 = data; _a < data_1.length; _a++) {
                            product = data_1[_a];
                            result[product.siebelProductName] = product;
                        }
                        return [2 /*return*/, result];
                }
            });
        }); })();
    }
    return mappingPromise;
}
function mapFlavours(mapping, selection, callingMod) {
    var flavours = {};
    for (var service in PAYLOAD_NAMES) {
        var product = selection[service];
        if (!product) {
            // It’s a product DOCP checkout does not support (e.g. mobile)
            continue;
        }
        var siebelId = product.slideId;
        if (!(siebelId in mapping)) {
            callingMod.log.warn('Mapping from Siebel ID', siebelId, 'to SKU code not found in', mapping);
            continue;
        }
        flavours[PAYLOAD_NAMES[service]] = {
            siebelProductName: siebelId,
            skuCode: mapping[siebelId].skuCode,
        };
    }
    return flavours;
}
function xsrfHeader() {
    var xsrfValue = __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.cookie('OCE-XSRF-TOKEN');
    if (!xsrfValue) {
        return {};
    }
    return { 'X-OCE-XSRF-TOKEN': xsrfValue };
}

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(10)))

/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export callService */
/* unused harmony export tvAvailability */
/* harmony export (immutable) */ __webpack_exports__["b"] = isValidResponse;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lib_vendor_terrific_Module__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lib_personalization_profile__ = __webpack_require__(5);




var SITECATALYST_BLOCKLISTED_URL_PARAMS = [
    'locationId',
    'street',
    'houseNumber',
    'houseName',
    'city',
    'zipCode',
    'zip',
    'scn',
];
var FIELDS = {
    city: { session: 'scs_sa_city' },
    houseName: { session: 'scs_sa_housename' },
    houseNumber: { session: 'scs_sa_housenumber' },
    locationId: { session: 'scs_sa_locationid' },
    streetName: { session: 'scs_sa_street', map: 'street' },
    zip: { session: 'scs_sa_zipcode', map: 'zipCode4' },
};
var BADGES = {
    alert: {
        badgeClass: 'badge--notification',
        iconClass: 'icon-alert',
    },
    check: {
        badgeClass: 'badge--confirmation',
        iconClass: 'icon-check',
    },
};
/*
 * This object represents a response of the map service
 * The object is standardized so that small changes in the service do not create the need for a complete refactoring
 * The object is also used by Tc.Module.OrderOverlay => all changes must be reflected there!
 * FIXME: Make response nullable instead of providing dummy data
 */
var EMPTY_RESPONSE = {
    address: {},
    addressValidation: 'invalid',
    broadbandAvailability: 'not_available',
    broadbandIsFiber: false,
    extensionInfo: '',
    maxDown: '',
    maxUp: '',
    productAvailability: [],
    requestType: 'none',
    serverError: true,
    socketNotInLivingArea: false,
    technology: '',
    tvAvailability: 'not_specified',
    tvAvailabilityInfoText: '',
    tvAvailabilityText: '',
};
/**
 * Service Availability, a.k.a. Fiber Checker.
 * Displays the Internet speed and product availability of a specific location,
 * based on a street address.
 * Calls the GAIA service (for address lookup) and the MAP lineinfo service.
 *
 * @author Mad, Michael & Cesar Keller, and many more
 * @namespace Tc.Module
 * @class ServiceAvailability
 * @extends Tc.Module
 */
var ServiceAvailability = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */])(ServiceAvailability, _super);
    function ServiceAvailability() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.checkIsRunning = false;
        _this.filledWithSessionStorageData = false;
        _this.loadingTimeout = 0;
        return _this;
    }
    /**
     * @method on
     * @param {Function} callback function
     * @return void
     */
    ServiceAvailability.prototype.on = function (callback) {
        var _this = this;
        var $ctx = this.$ctx;
        // AdditionalInformation div
        this.$additionalInformation = $ctx.find('.additionalInformation');
        // Input elements of DOM
        this.$form = $ctx.find('div.modScForm');
        this.$street = $ctx.find('div.street-name');
        this.$houseNumber = $ctx.find('div.house-number');
        this.$zip = $ctx.find('div.zip');
        this.$city = $ctx.find('div.city');
        this.$houseName = $ctx.find('div.house-name');
        // Error elements of DOM
        this.$errordiv = $ctx.find('div.error');
        this.generalAddressErrorMsg = $ctx.find('div[data-general-address-error]').data('general-address-error');
        this.serverErrorMsg = $ctx.find('div.error[data-server-error]').data('server-error');
        // Result element of DOM
        this.$internetSpeed = $ctx.find('span.internetspeed');
        this.$availabilityTv = $ctx.find('div.availability-tv');
        this.$availabilityInfo = $ctx.find('div.availability-shortage');
        this.$availabilityInternet = $ctx.find('div.availability-internet');
        this.$availabilityFiber = $ctx.find('div.availability-fiber');
        this.$result = $ctx.find('div.result');
        this.$address = $ctx.find('p.address');
        this.$resultAddress = $ctx.find('div.result p.address span.tested-address');
        this.$extensioninfoholder = $ctx.find('div.extension-info-holder');
        this.$bondingInfoHolder = $ctx.find('div.bonding-info-holder');
        this.openExtensionInfo = '.open-extension-info';
        this.closeExtensionInfo = '.close-extension-info';
        this.$extensionBondingOpener = this.$bondingInfoHolder.find(this.openExtensionInfo);
        this.$extensionBondingCloser = this.$bondingInfoHolder.find(this.closeExtensionInfo);
        this.$extensioninfoopener = this.$extensioninfoholder.find(this.openExtensionInfo);
        this.$extensioninfocloser = this.$extensioninfoholder.find(this.closeExtensionInfo);
        this.$extensioninfo = this.$extensioninfoholder.find('div.extension-info');
        this.$extensioninfounavailable = $ctx.find('div.extension-info.unavailable');
        this.$extensionText = $ctx.find('div.extension-text');
        this.$anotherCheck = $ctx.find('a.change-address');
        this.$fiberInHouseAvailability = $ctx.find('div.availability-house-fiber');
        this.$contentCollapsable = $ctx.parent('.serviceavailability').siblings('.modContactCollapsable');
        this.$extensionCollapsable = this.$contentCollapsable.children('.content');
        this.$bondingInfoText = $ctx.find('.bonding-info-holder .extension-info');
        // Retrieve data from DOM
        this.language = $ctx.data('language');
        this.showFiber = $ctx.data('showfiber');
        this.hideFiberNotAvailable = $ctx.data('hidefibernotavailable');
        this.hideTV = $ctx.data('hidetv');
        this.hideInternet = $ctx.data('hideinternet');
        this.hideExtensionInfo = $ctx.data('hideextensioninfo');
        this.doTracking = $ctx.data('dotracking');
        this.serviceUrl = $ctx.data('serviceurl') || '/map-api/onlinenslg/lineinfo';
        this.productTitlePlaceholder = $ctx.find('h3, h2').data('product-title-placeholder'); // "The product"
        this.productTitle = __WEBPACK_IMPORTED_MODULE_1_jquery___default()('h1:not(.scs-pageheader-accessibility,:empty):first').clone().children().remove().end().text().replace(/(\n|\s+$)/g, '');
        this.productIds = []; // Fill with objects {'name': 'Product Name', 'siebelId': 'SIEBELID'}
        // Clone empty response as initial value
        this.response = __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.extend(true, {}, EMPTY_RESPONSE);
        // Rewrite all IDs (and for-attributes and href="#…") within the module as they could be in the page twice
        // (e.g. once in the orderoverlay and once on the page)
        this.$ctx.find('[id]').each(function (_i, el) {
            var $el = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(el);
            $el.attr('id', $el.attr('id') + "_" + _this.id);
        });
        this.$ctx.find('label[for]').each(function (_i, el) {
            var $el = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(el);
            $el.attr('for', $el.attr('for') + "_" + _this.id);
        });
        this.$ctx.find('a[href]').each(function (_i, el) {
            var _a;
            var $el = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(el);
            var href = (_a = $el.attr('href')) !== null && _a !== void 0 ? _a : '';
            if (href.indexOf('#') === 0 && href.length > 1) {
                $el.attr('href', href + "_" + _this.id);
            }
        });
        // If we have a product to check - use different text
        this.adjustSubmitButtonText();
        // Click on "another address"
        this.$anotherCheck.click(function (event) {
            event.preventDefault();
            _this.$contentCollapsable.addClass('hidden');
            _this.checkIsRunning = false;
            _this.showForm();
            _this.hideAllResultElements();
        });
        this.$ctx.on('click', this.openExtensionInfo, function (event) {
            var $this = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(event.currentTarget);
            var $extensionInfo = $this.siblings('div.extension-info');
            event.preventDefault();
            $extensionInfo.removeClass('hidden');
            $extensionInfo.slideDown(200, _this.centerOverlay.bind(_this));
            setTimeout(_this.centerOverlay.bind(_this), 50);
            setTimeout(_this.centerOverlay.bind(_this), 100);
            setTimeout(_this.centerOverlay.bind(_this), 150);
            __WEBPACK_IMPORTED_MODULE_1_jquery___default()(_this).hide();
            __WEBPACK_IMPORTED_MODULE_1_jquery___default()(_this).siblings('a').show();
        });
        this.$ctx.on('click', this.closeExtensionInfo, function (event) {
            var $this = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(event.target);
            var $extensionInfo = $this.siblings('div.extension-info');
            event.preventDefault();
            $extensionInfo.slideUp(200, _this.centerOverlay.bind(_this));
            setTimeout(_this.centerOverlay.bind(_this), 50);
            setTimeout(_this.centerOverlay.bind(_this), 100);
            setTimeout(_this.centerOverlay.bind(_this), 150);
            $this.hide();
            $this.siblings('a').show();
        });
        // Search Event handler
        this.$form.off('submit');
        this.$ctx.on('submit', 'form', function (event) {
            _this.blockSubmit();
            _this.handleSubmit(event);
        });
        callback();
    };
    ServiceAvailability.prototype.after = function () {
        this.formApi = this.$form.data('form-api');
        this.$ctx.find('form').off('submit');
        // Read values saved in sessionStorage if the module is not a hidden dialog
        if (!(this.$ctx.is('.modOrderOverlay *') && !this.$ctx.is(':visible'))) {
            this.readValuesSavedInSessionStorage();
        }
    };
    ServiceAvailability.prototype.blockSubmit = function () {
        this.$ctx.find('button[type=submit]').prop('disabled', true);
    };
    ServiceAvailability.prototype.unBlockSubmit = function () {
        this.$ctx.find('button[type=submit]').prop('disabled', false);
    };
    ServiceAvailability.prototype.readValuesSavedInSessionStorage = function () {
        if (hasSessionStorageData()) {
            this.formApi.cancelMapDataCall();
            this.fillWithSessionStorageData();
        }
    };
    /**
     * Collects data and sends it to mod.sendData
     */
    ServiceAvailability.prototype.handleSubmit = function (event) {
        var _this = this;
        // No event is set when we call the method manually
        if (event && 'preventDefault' in event) {
            event.preventDefault();
            event.stopPropagation();
            event.stopImmediatePropagation();
        }
        var nrOfErrors = 0;
        // See which form was submitted
        var form = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(event.target);
        var inputs = form.find('input').not('[name="nostreet_label"]');
        var requestType = form.data('requestType');
        this.checkIsRunning = requestType; // Remember for additional calls
        if (inputs.length === 0) {
            this.unBlockSubmit();
            return undefined;
        }
        // Make sure only visible fields are actually required to fill in
        // (the address form has a mode with street and number or with house name)
        inputs.filter(':text, textarea')
            .prop('required', true)
            .filter(':not(:visible)')
            .prop('required', false);
        // Validation => each field is needed before submission happens
        inputs.filter(function (_i, el) {
            return el.required;
        }).each(function (_i, el) {
            if (__WEBPACK_IMPORTED_MODULE_1_jquery___default()(el).val() === '') {
                nrOfErrors += 1;
                __WEBPACK_IMPORTED_MODULE_1_jquery___default()(el).closest('.field > div').addClass('error');
                if (nrOfErrors < 2) {
                    _this.$errordiv.find('span').text(__WEBPACK_IMPORTED_MODULE_1_jquery___default()(el).closest('.field > div').data('errormessage'));
                }
                else {
                    _this.$errordiv.removeClass('hidden').find('span').text(_this.generalAddressErrorMsg);
                }
            }
            else {
                __WEBPACK_IMPORTED_MODULE_1_jquery___default()(el).closest('.field > div').removeClass('error');
            }
        });
        if (nrOfErrors > 0) {
            this.$errordiv.removeClass('hidden');
            this.centerOverlay();
            this.unBlockSubmit();
            return false;
        }
        this.removeAllErrorClass();
        this.centerOverlay();
        var jsonObject = this.prepareRequest(inputs);
        this.sendData(jsonObject);
        return undefined;
    };
    ServiceAvailability.prototype.prepareRequest = function ($inputs) {
        var addressObject = {};
        $inputs = $inputs !== null && $inputs !== void 0 ? $inputs : this.$ctx.find('.addressFields > form input').not('[name="nostreet_label"]');
        var noStreet = false;
        // Collect data and send it to webservice
        $inputs.each(function (_i, el) {
            var _a;
            var $input = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(el);
            var name = $input.attr('name');
            var value = $input.val();
            switch (name) {
                case 'nostreet':
                    noStreet = $input.is(':checked');
                    break;
                default:
                    if (name && FIELDS[name]) {
                        var key = (_a = FIELDS[name].map) !== null && _a !== void 0 ? _a : name;
                        addressObject[key] = value;
                    }
                    break;
            }
        });
        if (noStreet) {
            delete addressObject.street;
            delete addressObject.houseNumber;
        }
        else {
            delete addressObject.houseName;
        }
        var jsonObject = {
            address: addressObject,
            language: this.language,
            productsToCheck: undefined,
        };
        for (var _a = 0, _b = this.productIds; _a < _b.length; _a++) {
            var product = _b[_a];
            jsonObject.productsToCheck = jsonObject.productsToCheck || [];
            jsonObject.productsToCheck.push(product.siebelId);
        }
        return jsonObject;
    };
    /**
     * Sends data to service
     * uses mod.readServiceData to get structured data into mod.response
     */
    ServiceAvailability.prototype.sendData = function (saObject) {
        var _this = this;
        var _a, _b;
        this.startLoading();
        // Write all data in sessionStorage for later use in the same browser session
        if (window.sessionStorage) {
            var addr = saObject.address || {};
            for (var field in FIELDS) {
                // Jshint forin: false
                var key = (_a = FIELDS[field].map) !== null && _a !== void 0 ? _a : field;
                sessionStorage.setItem(FIELDS[field].session, (_b = addr[key]) !== null && _b !== void 0 ? _b : '');
            }
        }
        var success = function (data) {
            _this.unBlockSubmit();
            _this.log('callService > success', arguments);
            _this.endLoading();
            _this.readServiceData(data); // Fills mod.response
            _this.renderResult();
            _this.centerOverlay();
            // Important, that this is done last, as the overlay first hides a lot of things and just redisplays them depending on the data
            _this.sendDataUpdate(data);
            // Hide "more information" link if property in broadbandInfo "displayLink" is false
            _this.displayLinkChecker(data);
            _this.fillShortageInfo(data);
            _this.showBondingInformation(data);
        };
        var customError = function () {
            _this.unBlockSubmit();
            _this.endLoading();
            _this.$errordiv.removeClass('hidden');
            _this.$errordiv.find('span').text(_this.serverErrorMsg);
        };
        this.request = saObject;
        callService(saObject, this.serviceUrl, success, customError);
    };
    ServiceAvailability.prototype.displayLinkChecker = function (data) {
        var $ctx = this.$ctx;
        var $moreInfo = $ctx.find('.extension-info .scs-primary-link');
        if (data && 'broadbandInfo' in data && data.broadbandInfo) {
            if (!data.broadbandInfo.displayLink) {
                $moreInfo.hide();
            }
            else {
                $moreInfo.show();
            }
        }
    };
    ServiceAvailability.prototype.showBondingInformation = function (response) {
        var _a, _b, _c;
        var $ctx = this.$ctx;
        var $bondingInformation = $ctx.find('.bonding-information');
        $bondingInformation.hide();
        if (response.error) {
            return;
        }
        var data = response;
        var $bondingText = $ctx.find('.bonding-text');
        var $extInfo = $bondingInformation.find('.extension-info');
        var hasBondingInfo = data.broadbandInfo && data.broadbandInfo.maxDownSpeedAndBonding !== null && !/FIBER/.test(data.broadbandInfo.technology);
        var maxDownSpeed = ((_a = data.broadbandInfo) === null || _a === void 0 ? void 0 : _a.maxDownSpeed) ? SCS.utils.convertToBits(data.broadbandInfo.maxDownSpeed) : undefined;
        var maxUpSpeed = ((_b = data.broadbandInfo) === null || _b === void 0 ? void 0 : _b.maxUpSpeed) ? SCS.utils.convertToBits(data.broadbandInfo.maxUpSpeed) : undefined;
        var isSmeSegment = __WEBPACK_IMPORTED_MODULE_1_jquery___default()('body').attr('data-page-segment') === 'sme';
        $bondingInformation.hide();
        if (!isSmeSegment) {
            // Backend checking for location bonding information is only available for RES.
            if (hasBondingInfo && (!((_c = data.productAvailabilityInfo) === null || _c === void 0 ? void 0 : _c.length) || data.productAvailabilityInfo[0].bondingEligible)) {
                $bondingInformation.show();
                $bondingText.text(data.broadbandInfo.maxDownSpeedAndBonding);
                $extInfo.hide();
                this.$extensionBondingOpener.show();
                this.$extensionBondingCloser.hide();
            }
        }
        else if ((maxUpSpeed && maxUpSpeed <= 4000000) || (maxDownSpeed && maxDownSpeed <= 10000000)) {
            // Hence poor mans check for SME bonding information.
            $bondingInformation.show();
        }
    };
    /**
     * Takes data from service and fills mod.response with it
     */
    // tslint:disable-next-line: cyclomatic-complexity // Someone elese refactor this…
    ServiceAvailability.prototype.readServiceData = function (response) {
        var _a, _b;
        // Clone empty response as initial value
        this.response = __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.extend(true, {}, EMPTY_RESPONSE);
        // Check for general errors
        if (!response || response.error) {
            this.response.serverError = true;
            this.log('readServiceresponse > error', response);
            return;
        }
        var data = response;
        this.response.serverError = false;
        // Check input validation
        if (data.addressValidationResult) {
            this.response.requestType = 'address';
            this.response.addressValidation = data.addressValidationResult.validationInfo;
            if (data.addressValidationResult.outputAddress) { // If output address is not set, keep the empty object
                this.response.address = data.addressValidationResult.outputAddress;
                this.response.address.zipCode6 = this.response.address.zipCode4;
                if (this.response.address.zipCode4 && this.response.address.zipCode4.length > 4) {
                    this.response.address.zipCode4 = this.response.address.zipCode4.substr(0, 4);
                }
                this.$ctx.toggleClass('noLocationId', data.addressValidationResult.outputAddress.locationId === '');
            }
            else {
                this.$ctx.toggleClass('noLocationId', data.addressValidationResult.inputAddress.locationId === '');
            }
        }
        else {
            this.response.serverError = true;
            return;
        }
        /**
         * siebelId			- String of the products siebelId
         * availabilityStatus - String with the folowing possible values: 'available'|'restricted'|'not_available'
         * availabilityText 	- String with translated text for the different status
         * maxUp				- String max upload speed: '100 Mbit/s'
         * maxDown				- String max download speed: '1 Gbit/s'
         */
        // Fill products first - need this info anyway
        if (this.productIds && this.productIds.length > 0 && ((_b = (_a = data.productAvailabilityInfo) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0) > 0) {
            for (var _c = 0, _d = data.productAvailabilityInfo; _c < _d.length; _c++) {
                var productAvailability = _d[_c];
                this.response.productAvailability.push({
                    availability: productAvailability.availabilityStatus,
                    availabilityText: productAvailability.availabilityText,
                    maxDown: productAvailability.maxProductDownSpeed,
                    maxUp: productAvailability.maxProductUpSpeed,
                    name: this.getProductName(productAvailability.siebelId),
                    siebelId: productAvailability.siebelId,
                });
            }
        }
        // Check tv availability
        if (data.broadbandInfo && data.broadbandInfo.tvAvailabilityInfo) {
            this.response.tvAvailabilityInfoText = data.broadbandInfo.tvAvailabilityInfo.tvStreamsText;
            this.response.tvAvailabilityStatus = data.broadbandInfo.tvAvailabilityInfo.tvAvailabilityStatus;
            this.response.tvAvailability = tvAvailability(data);
            this.response.tvAvailabilityTitle = this.$ctx.data("translation-tvstatus-" + this.response.tvAvailabilityStatus + "-title");
            this.response.tvAvailabilityDescription = this.$ctx.data("translation-tvstatus-" + this.response.tvAvailabilityStatus + "-title");
        }
        else {
            this.response.tvAvailability = 'not_specified';
        }
        // Check fiber in house availability
        if (data.broadbandInfo && data.broadbandInfo.BEPInfoHeader && data.broadbandInfo.BEPInfo) {
            this.response.fiberInHouse = true;
            this.response.fiberInHouseAvailabTitle = data.broadbandInfo.BEPInfoHeader;
            this.response.fiberInHouseAvailabInfo = data.broadbandInfo.BEPInfo;
        }
        else {
            this.response.fiberInHouse = false;
        }
        // Check broadband availability
        if (data.broadbandInfo && data.broadbandInfo.extensionInfo && data.broadbandInfo.extensionInfoHeader) {
            this.response.extensionInfoTitle = data.broadbandInfo.extensionInfoHeader;
            this.response.extensionInfo = data.broadbandInfo.extensionInfo;
        }
        if (!data.broadbandInfo || data.broadbandInfo.available === false) {
            this.response.broadbandAvailability = 'not_available';
            return;
        }
        // Broadband is available
        this.response.broadbandAvailability = 'available'; // Will be overwritten with restricted if product is restricted
        this.response.broadbandIsFiber = /FIBER/.test(data.broadbandInfo.technology);
        this.response.technology = data.broadbandInfo.technology ? data.broadbandInfo.technology.toLowerCase() : '';
        this.response.socketNotInLivingArea = data.broadbandInfo.socketNotInLivingArea && String(data.broadbandInfo.socketNotInLivingArea) === 'true';
        this.response.maxUp = data.broadbandInfo.maxUpSpeed;
        this.response.maxDown = data.broadbandInfo.maxDownSpeed;
        // If there is just one product and it is restricted or not available => broadbandAvailability must also be restricted
        if (this.response.productAvailability && this.response.productAvailability.length === 1 && this.response.productAvailability[0].availability !== 'available') {
            this.response.broadbandAvailability = 'restricted';
        }
    };
    /**
     * Renders the data that is available in mod.response
     */
    ServiceAvailability.prototype.renderResult = function () {
        var response = this.response;
        if (response.serverError) {
            this.invalidServerErrorMessage();
            return;
        }
        if (!isValidResponse(response)) {
            // Invalid input - show form again
            this.removeAllErrorClass();
            this.invalidFormErrorMessage();
        }
        else {
            // Request was valid - write data
            this.hideForm();
            this.showAllResultElements();
            this.fillResultAddressBox();
            this.fillForm();
            this.showFiberAvailability();
            this.showInternetAvailability();
            this.showTvAvailability();
            this.showFiberInHouse();
            this.fillExtensionInfo();
            this.removeAllErrorClass();
            this.addParametersToLinks();
        }
    };
    ServiceAvailability.prototype.isInOverlay = function () {
        return this.$ctx.is('.ui-dialog *') || this.$ctx.is('.is-mobile .modOrderOverlay *');
    };
    // Fill original form with data from JSON
    ServiceAvailability.prototype.fillForm = function () {
        var _a, _b, _c;
        this.$street.find('input').val((_a = this.response.address.street) !== null && _a !== void 0 ? _a : '');
        this.$houseNumber.find('input').val((_b = this.response.address.houseNumber) !== null && _b !== void 0 ? _b : '');
        this.$zip.find('input').val(this.response.address.zipCode4);
        this.$city.find('input').val(this.response.address.city);
        this.$houseName.find('input').val((_c = this.response.address.houseName) !== null && _c !== void 0 ? _c : '');
    };
    // Fills the result Address
    ServiceAvailability.prototype.fillResultAddressBox = function () {
        var street = [];
        var address = [];
        var request = this.request || {};
        var response = this.response || {};
        var requestAddress = request.address || {};
        var responseAddress = response.address || {};
        this.$address.removeClass('hidden');
        // We should only get either street and houseNumber
        // or a houseName, but handle all cases gracefully
        if (responseAddress.street) {
            street.push(responseAddress.street);
        }
        else if (requestAddress.street) {
            street.push(requestAddress.street);
        }
        if (responseAddress.houseName) {
            street.push(responseAddress.houseName);
        }
        else if (requestAddress.houseName) {
            street.push(requestAddress.houseName);
        }
        if (responseAddress.houseNumber) {
            street.push(responseAddress.houseNumber);
        }
        else if (requestAddress.houseNumber) {
            street.push(requestAddress.houseNumber);
        }
        // This should probably never ever happen
        // but the API can act weird sometimes
        // avoids printing "null" to the user
        if (street.length > 0) {
            address.push(street.join(' '));
        }
        // We always need a zip and city
        address.push([
            this.response.address.zipCode4,
            this.response.address.city,
        ].join(' '));
        this.$resultAddress.text(address.join(', '));
    };
    ServiceAvailability.prototype.fillShortageInfo = function (response) {
        var $name = this.$availabilityInfo.find('.name');
        var $desc = this.$availabilityInfo.find('.desc');
        if (!response || response.error) {
            return;
        }
        var data = response;
        if (data && data.broadbandInfo && data.broadbandInfo.shortageInfoHeader && data.broadbandInfo.shortageInfo) {
            this.$availabilityInfo.removeClass('hidden');
            $name.text(data.broadbandInfo.shortageInfoHeader);
            $desc.text(data.broadbandInfo.shortageInfo);
        }
        else {
            this.$availabilityInfo.addClass('hidden');
        }
    };
    // Fills the blue box
    ServiceAvailability.prototype.fillExtensionInfo = function () {
        this.$extensioninfoholder.addClass('hidden');
        if (this.hideExtensionInfo) {
            return;
        }
        if (!this.$extensioninfoholder.hasClass('no-collapse')) {
            this.$extensioninfounavailable.hide().removeClass('hidden');
        }
        // New extension info is just a string
        if (this.response.extensionInfo) {
            this.$extensioninfoholder.removeClass('hidden');
            this.$extensioninfoholder.find('.extension-info-title').text(this.response.extensionInfoTitle);
            this.$extensionText.text(this.response.extensionInfo);
            this.$extensioninfoopener.show();
            this.$extensioninfocloser.hide();
            this.$extensionBondingOpener.show();
            this.$extensionBondingCloser.hide();
            if (!this.$extensioninfoholder.hasClass('no-collapse')) {
                this.$extensioninfo.hide(); // Close
                this.$extensionCollapsable.hide().siblings('.contact').children('a').removeClass('opened'); // Close content collapsable
                this.$bondingInfoText.hide();
            }
            else {
                this.$extensioninfo.show();
                this.$extensioninfounavailable.addClass('hidden');
            }
            // Hide the link if fiber is in front-of the house, but the house is not
            // yet enabled with a fiber outlet.
            this.$extensioninfoholder.find('.extension-info .link').toggleClass('hidden', this.response.fiberInHouse);
        }
        else if (!this.response.broadbandIsFiber) {
            this.$extensioninfounavailable.show();
        }
    };
    /**
     * Display Fiber availability information
     */
    ServiceAvailability.prototype.showFiberAvailability = function () {
        // Fiber
        if (this.showFiber) {
            this.$availabilityFiber.addClass('hidden');
            if (this.response.broadbandIsFiber) {
                this.$availabilityFiber.find('.desc-text').text(this.$ctx.data('translation-fiberstatus-available-description'));
                this.$availabilityFiber.removeClass('hidden');
            }
            else if (!this.hideFiberNotAvailable) {
                this.$availabilityFiber.find('.desc-text').text(this.$ctx.data('translation-fiberstatus-none-description'));
                this.$availabilityFiber.removeClass('hidden');
            }
        }
        else {
            this.$availabilityFiber.addClass('hidden');
        }
    };
    /**
     * Display TV availability information
     */
    ServiceAvailability.prototype.showTvAvailability = function () {
        if (this.hideTV) {
            this.$availabilityTv.addClass('hidden');
            return;
        }
        switch (this.response.tvAvailability) {
            // Both these cases are handled the same way. The text is different, however.
            case 'available':
            case 'restricted':
                this.$availabilityTv.removeClass('hidden');
                this.$availabilityTv.find('.name-text').text(this.response.tvAvailabilityTitle);
                this.$availabilityTv.find('.desc-text').text(this.response.tvAvailabilityDescription);
                this.$availabilityTv.addClass('available-state');
                break;
            case 'not_available':
                this.$availabilityTv.addClass('hidden');
                break;
            default: // 'not_specified'
                this.$availabilityTv.addClass('hidden');
                break;
        }
        var badgeStatus = (this.response.tvAvailability === 'available') ? 'check' : 'alert';
        showAvailabilityBadge(this.$availabilityTv, badgeStatus);
    };
    /**
     * Shows the availabilty information for fiber in the house.
     */
    ServiceAvailability.prototype.showFiberInHouse = function () {
        if (this.response.fiberInHouse) {
            this.$fiberInHouseAvailability.removeClass('hidden');
            this.$fiberInHouseAvailability.find('.name').text(this.response.fiberInHouseAvailabTitle);
            this.$fiberInHouseAvailability.find('.desc').text(this.response.fiberInHouseAvailabInfo);
        }
        else {
            this.$fiberInHouseAvailability.find('.desc span').remove();
            this.$fiberInHouseAvailability.addClass('hidden');
        }
    };
    /**
     * Dispaly intennet availability information
     */
    ServiceAvailability.prototype.showInternetAvailability = function () {
        var $downSpeed = this.$availabilityInternet.find('.downloadspeed');
        var $upSpeed = this.$availabilityInternet.find('.uploadspeed');
        var isServiceRestricted = false;
        // The editor said hide internet info, so hide it for sure.
        if (this.hideInternet) {
            this.$availabilityInternet.addClass('hidden');
            return;
        }
        // Check whether internet is available at all
        if (this.response.broadbandAvailability === 'not_available') {
            this.$availabilityInternet.find('.desc').hide();
            this.$availabilityInternet.find('.desc-not-available').show();
            isServiceRestricted = true;
        }
        else {
            this.$availabilityInternet.find('.desc').show();
            this.$availabilityInternet.find('.desc-not-available').hide();
            $downSpeed.find('.real').text($downSpeed.find('.real').data('text').replace(/%speed%/ig, this.response.maxDown));
            $upSpeed.find('.real').text($upSpeed.find('.real').data('text').replace(/%speed%/ig, this.response.maxUp));
            if (this.response.productAvailability &&
                this.response.productAvailability.length === 1 &&
                this.response.productAvailability[0].availability !== 'available') {
                // Show download information
                var down = this.response.productAvailability[0].maxDown;
                if (SCS.utils.convertToBits(down) > SCS.utils.convertToBits(this.response.maxDown)) {
                    this.writeInternetSpeed($downSpeed, down);
                    isServiceRestricted = true;
                }
                else {
                    $downSpeed.find('.insteadof').hide();
                }
                // Show upload information
                var up = this.response.productAvailability[0].maxUp;
                if (SCS.utils.convertToBits(up) > SCS.utils.convertToBits(this.response.maxUp)) {
                    this.writeInternetSpeed($upSpeed, up);
                    isServiceRestricted = true;
                }
                else {
                    $upSpeed.find('.insteadof').hide();
                }
            }
            else {
                $downSpeed.find('.insteadof').hide();
                $upSpeed.find('.insteadof').hide();
            }
        }
        var badgeStatus = (isServiceRestricted) ? 'alert' : 'check';
        showAvailabilityBadge(this.$availabilityInternet, badgeStatus);
    };
    ServiceAvailability.prototype.writeInternetSpeed = function ($container, speed) {
        $container.find('.insteadof').show().text($container.find('.insteadof').data('text')
            .replace(/%speed%/ig, speed)
            .replace(/%product%/ig, this.response.productAvailability[0].name));
    };
    // Gets Product name - either from the page title or the products-array which can be filled by other modules
    ServiceAvailability.prototype.getProductName = function (productSiebelId) {
        for (var _a = 0, _b = this.productIds; _a < _b.length; _a++) {
            var product = _b[_a];
            if (product.siebelId === productSiebelId && product.name) {
                return product.name;
            }
        }
        return this.productTitle;
    };
    // Show error message, address is invalid (and fill back)
    ServiceAvailability.prototype.invalidFormErrorMessage = function () {
        var errorMessage = this.generalAddressErrorMsg;
        this.hideAllResultElements();
        this.$errordiv.removeClass('hidden');
        this.$errordiv.find('span').text(errorMessage);
    };
    ServiceAvailability.prototype.invalidServerErrorMessage = function () {
        var errorMessage = this.serverErrorMsg;
        this.hideAllResultElements();
        this.$errordiv.removeClass('hidden');
        this.$errordiv.find('span').text(errorMessage);
    };
    ServiceAvailability.prototype.hideAllResultElements = function () {
        this.$result.addClass('hidden');
        this.centerOverlay();
    };
    ServiceAvailability.prototype.hideForm = function () {
        this.sendStatusUpdate('result');
        this.$form.addClass('hidden');
        this.$contentCollapsable.removeClass('hidden');
    };
    ServiceAvailability.prototype.showForm = function () {
        this.sendStatusUpdate('form');
        this.$form.removeClass('hidden');
    };
    ServiceAvailability.prototype.removeAllErrorClass = function () {
        this.$form.find('div.field, div.field > div').removeClass('error');
        this.$errordiv.addClass('hidden');
        this.$errordiv.find('span').text();
        this.$form.find('input[aria-invalid="true"]').removeAttr('aria-invalid');
    };
    ServiceAvailability.prototype.showAllResultElements = function () {
        this.$address.removeClass('hidden');
        this.$internetSpeed.removeClass('hidden');
        this.$availabilityTv.removeClass('hidden');
        this.$availabilityInternet.removeClass('hidden');
        this.$result.removeClass('hidden');
        this.$resultAddress.removeClass('hidden');
        this.$additionalInformation.addClass('hidden');
    };
    ServiceAvailability.prototype.startLoading = function () {
        var _this = this;
        this.loadingTimeout = window.setTimeout(function () {
            if (_this.$ctx.find('.loading').length === 0) {
                _this.$ctx.append('<div class="loading" />');
            }
            _this.$ctx.find('.loading').css('height', _this.$ctx.height() + 'px').fadeTo(200, 1);
            _this.$form.fadeTo(200, 0);
        }, 300);
    };
    ServiceAvailability.prototype.endLoading = function () {
        window.clearTimeout(this.loadingTimeout);
        this.$ctx.find('.loading').hide();
        this.$form.fadeTo(200, 1);
    };
    /**
     * Simple check if fields are ready to submit
     */
    ServiceAvailability.prototype.inputIsValid = function () {
        if (this.checkIsRunning) {
            return this.checkIsRunning;
        }
        var fields = this.$form
            .find('.addressFields input:visible:text')
            .get();
        for (var _a = 0, fields_1 = fields; _a < fields_1.length; _a++) {
            var field = fields_1[_a];
            if (__WEBPACK_IMPORTED_MODULE_1_jquery___default()(field).val() === '') {
                return false;
            }
        }
        return true;
    };
    ServiceAvailability.prototype.fillWithSessionStorageData = function () {
        var preFillData = {};
        // Load data from sessionStorage if available
        this.filledWithSessionStorageData = false;
        if (window.sessionStorage) {
            for (var field in FIELDS) {
                if (sessionStorage.getItem(FIELDS[field].session)) {
                    preFillData[field] = sessionStorage.getItem(FIELDS[field].session);
                    this.filledWithSessionStorageData = true;
                }
            }
            preFillData.nostreet = preFillData.hasOwnProperty('houseName');
            this.fire('fillFormWithStorageData', preFillData);
        }
    };
    ServiceAvailability.prototype.addParametersToLinks = function (update) {
        var _this = this;
        if (update === void 0) { update = false; }
        var $extensionInfoLink = this.$ctx.find('.extension-info a');
        var $overlay = this.$ctx.closest('.modOrderOverlay');
        var $orderLinks = $overlay.find('.modOrderOverlayOrderButtons a[href]');
        var $mobileLinks = $overlay.find('.orderoverlay-mobile-button-holder a:not([href^="tel:"])');
        var $links = $extensionInfoLink.add($orderLinks).add($mobileLinks);
        var mapping = {
            apartment: '',
            cancelUrl: document.location.href,
            city: this.response.address.city,
            floor: '',
            hdPossible: this.response.tvAvailability === 'available' ? 'true' : 'false',
            houseName: this.response.address.houseName,
            houseNumber: this.response.address.houseNumber,
            lang: this.language,
            locationId: this.response.address.locationId,
            returnUrl: document.location.href,
            scn: undefined,
            siebelProductId: '',
            socketNotInLivingArea: this.response.socketNotInLivingArea,
            street: this.response.address.street,
            technology: '',
            tvStreamsText: this.response.tvAvailabilityInfoText,
            uhdPossible: (this.response.tvAvailabilityStatus === 'uhd_box') ? 'true' : 'false',
            zip: this.response.address.zipCode4,
            zipCode: this.response.address.zipCode4,
        };
        this.log('addParametersToLinks', $links, this.productIds, this.response);
        Object(__WEBPACK_IMPORTED_MODULE_3_lib_personalization_profile__["getProfile"])()
            .then(function (profile) {
            var user = profile.getUser();
            if (user) {
                // FIXME: Is this a good idea? We should not put PII in get params anyway…
                mapping.scn = user.getId();
            }
        })
            .catch();
        if (this.productIds.length > 0 && this.productIds[0].siebelId) {
            mapping.siebelProductId = this.productIds[0].siebelId;
        }
        // Set technology to one of these values <VDSL/BX/adsl/gv08>
        if (this.response.broadbandIsFiber) {
            mapping.technology = 'BX';
        }
        else if (this.response.technology === 'adsl') {
            mapping.technology = 'adsl';
        }
        else if (this.response.technology === 'vdsl') {
            mapping.technology = 'VDSL';
        }
        else {
            mapping.technology = 'gv08'; // Grundversorgung
        }
        if (this.doTracking) {
            __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.each(SITECATALYST_BLOCKLISTED_URL_PARAMS, function (_i, name) {
                // tslint:disable-next-line: no-dynamic-delete
                delete mapping[name];
            });
        }
        // Rewrite links
        $links.each(function (_i, el) {
            var $link = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(el);
            var href = $link.attr('href');
            var originalHref = update ? href : $link.data('original-href');
            var iso = $link.closest('div').hasClass('without-login');
            var isLego = /internet-/.test(href) && /tv-/.test(href) && /voip-/.test(href);
            if (isLego) {
                _this.log('not rewriting link with hash parameter for Lego Configurator', href);
                return;
            }
            _this.log('rewrite link', href, $link.attr('class'));
            // Save initial values
            $link.data('original-href', originalHref || href);
            // The no-login order form requires the parameter values to be encoded in ISO-8859-1
            var updatedHref = _this.addParametersToUrl(originalHref, mapping, iso);
            if (updatedHref) {
                $link.attr('href', updatedHref);
            }
        });
    };
    /**
     * Append parameters to URL which are not already present.
     */
    ServiceAvailability.prototype.addParametersToUrl = function (url, mapping, iso) {
        if (iso === void 0) { iso = false; }
        this.log('addParametersToUrl', url, mapping, iso);
        if (!url) {
            return undefined;
        }
        // Handle registrationUrl (SAM) link: append parameters to the RURL parameter
        if (/[?#&]RURL=/.test(url)) {
            this.log('RURL handling', url);
            var rUrl = decodeURIComponent(url.match(/[?#&]RURL=([^&]*)/)[1]);
            var rUrlWithParams = this.addParametersToUrl(rUrl, mapping, iso);
            return SCS.Url.updateQueryStringParameter(url, 'RURL', encodeURIComponent(rUrlWithParams));
        }
        // Handle normal links (MAP)
        for (var key in mapping) {
            if (mapping.hasOwnProperty(key) && mapping[key] !== undefined && url.indexOf(key + '=') < 0) { // Do not overwrite an existing parameter
                this.log('addParameter', key, mapping[key]);
                url += /[?#]/.test(url) ? '&' : '?';
                if (iso) {
                    // ISO-8859-1
                    url += key + "=" + window.escape(mapping[key] || '');
                }
                else {
                    // UTF-8
                    url += key + "=" + encodeURIComponent(mapping[key] || '');
                }
            }
            else {
                this.log.debug('addParametersToUrl > SKIPPED parameter', key, mapping[key]);
            }
        }
        if (iso && /[?#]/.test(url)) {
            url += '&paramEncoding=ISO8859-1';
        }
        return url;
    };
    ServiceAvailability.prototype.adjustSubmitButtonText = function () {
        var $submitButton = this.$ctx.find('button[type=submit]');
        var productName = this.productTitlePlaceholder;
        if (this.productIds.length === 1) {
            // There could be two buttons in $submitButton, but the code works either way because all texts are the same.
            $submitButton.text($submitButton.data('product-check-text'));
            productName = this.productIds[0].name || this.productIds[0].siebelId;
        }
        else {
            $submitButton.text($submitButton.data('check-text'));
        }
        var $texts = this.$ctx.find('.instructions, .description');
        // Set every text individually because the texts might differ and we don’t want to set each one to the same value.
        $texts.each(function (_i, el) {
            var $text = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(el);
            if (!$text.data('original-text')) {
                $text.data('original-text', $text.text());
            }
            $text.text($text.data('original-text').replace(/%product%/ig, productName));
        });
    };
    /**
     * Tell the Order Overlay to reposition itself
     */
    ServiceAvailability.prototype.centerOverlay = function () {
        this.fire('CenterOverlay');
    };
    // Module communication
    /**
     * Sends updated mod.response JSON to listening modules,
     * tracking scripts for Adserver (injected via Tealium Tag Manager),
     * and Test&Target script (injected via mbox) for A/B-Testing.
     */
    ServiceAvailability.prototype.sendDataUpdate = function (rawResponseData) {
        var event = 'ServiceAvailabilityDataUpdate';
        this.fire(event, this.response);
        this.$ctx.trigger(event, [this.response]); // Custom event for Test&Target and friends
        // Tracking with raw data
        var interaction = new SCS.portal.datalayer.Interaction()
            .withEvent('response', 'lineInfo', 'availabilitychecker', 'checker', 'lineInfo')
            .withRawData({
            response: rawResponseData,
        });
        this.log('sendDataUpdate > track', interaction);
        interaction.track();
    };
    /**
     * Result or Form
     */
    ServiceAvailability.prototype.sendStatusUpdate = function (state) {
        this.fire('ServiceAvailabilityStatusUpdate', state);
    };
    /**
     * allows product pages to define, what product(s) should be checked
     */
    ServiceAvailability.prototype.onUpdateProductIds = function (data) {
        this.log('onUpdateProductIds', data);
        if (data && data.productIds && data.productIds.length > 0) {
            this.productIds = data.productIds;
        }
        this.adjustSubmitButtonText();
    };
    /**
     * CheckProductIds (fired by Tc.Module.LegoOrderButton).
     * Allows modules to fetch get service availability info for product ID(s).
     * Note: The address info must already be saved in session storage.
     * The result (mod.response object) is returned via success callback.
     */
    ServiceAvailability.prototype.onCheckProductIds = function (data) {
        var _this = this;
        var _a;
        this.log('onCheckProductIds', data);
        if (data && data.productIds) {
            this.productIds = data.productIds;
        }
        this.readValuesSavedInSessionStorage();
        var jsonObject = this.prepareRequest();
        var success = (_a = data.success) === null || _a === void 0 ? void 0 : _a.bind(data);
        callService(jsonObject, this.serviceUrl, function (response) {
            _this.readServiceData(response); // Fills mod.response
            _this.log('onCheckProductIds response', _this.response);
            if (typeof success === 'function') {
                success(_this.response);
            }
        });
    };
    /**
     * allows product pages to define, what product should be checked
     * works for one single product
     */
    ServiceAvailability.prototype.onUpdateProductId = function (data) {
        this.log('onUpdateProductId', data);
        if (data && data.siebelId) {
            this.productIds = [data];
        }
        this.adjustSubmitButtonText();
        this.addParametersToLinks(true);
    };
    /**
     * Order overlay opened in dialog => if fields are prefilled - submit
     */
    ServiceAvailability.prototype.onDialogOpened = function () {
        if (!this.isInOverlay()) {
            return;
        }
        this.log('onDialogOpened');
        this.checkIsRunning = false;
        this.showForm();
        this.$contentCollapsable.addClass('hidden');
        this.hideAllResultElements();
        this.readValuesSavedInSessionStorage();
        var isValid = this.inputIsValid();
        if (isValid && this.filledWithSessionStorageData) {
            this.handleSubmit({
                target: this.$ctx.find('.addressFields > form'),
            });
        }
    };
    // TODO: Seems unused, can it be removed?
    ServiceAvailability.prototype.onFormError = function (error) {
        if (error && typeof error === 'string') {
            this.$errordiv.removeClass('hidden');
            this.$errordiv.find('span').text(error);
        }
        else {
            this.$errordiv.addClass('hidden');
            this.$errordiv.find('span').text('');
        }
    };
    return ServiceAvailability;
}(__WEBPACK_IMPORTED_MODULE_2_lib_vendor_terrific_Module__["a" /* Module */]));
/* harmony default export */ __webpack_exports__["a"] = (ServiceAvailability);
function callService(saObject, serviceUrl, success, customError) {
    if (customError === void 0) { customError = null; }
    var ajaxOptions = {};
    ajaxOptions.type = 'POST';
    ajaxOptions.data = JSON.stringify(saObject);
    ajaxOptions.contentType = 'application/json; charset=UTF-8';
    ajaxOptions.dataType = 'json';
    ajaxOptions.url = serviceUrl;
    var tries = 1;
    function error() {
        window.debug.log('callService > error', arguments, tries, customError);
        if (tries < 3) {
            tries += 1;
            setTimeout(function () {
                __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.ajax(ajaxOptions);
            }, 1000);
        }
        else {
            if (customError) {
                customError();
            }
        }
    }
    ajaxOptions.success = success;
    ajaxOptions.error = error;
    __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.ajax(ajaxOptions);
}
function tvAvailability(response) {
    if (response === null) {
        return null;
    }
    if (typeof response === 'string') {
        return response;
    }
    var status = ((response.broadbandInfo || {}).tvAvailabilityInfo || {}).tvAvailabilityStatus || null;
    var result = 'not_available';
    if (status === 'sd_box' || status === 'web_only') {
        result = 'restricted';
    }
    else if (status === 'hd_box' || status === 'uhd_box') {
        result = 'available';
    }
    return result;
}
function isValidResponse(response) {
    return response.addressValidation === 'valid' ||
        response.addressValidation === 'partiallyValid' ||
        response.addressValidation === 'adjusted';
}
function clearBadgeStatus($badgeContainer, $badgeIcon) {
    Object.keys(BADGES).forEach(function (key) {
        var badgeStatus = BADGES[key];
        $badgeContainer.removeClass(badgeStatus.badgeClass);
        $badgeIcon.removeClass(badgeStatus.iconClass);
        $badgeIcon.addClass('hidden');
    });
}
/**
 * Sets a badge inside a service container (internet, tv, etc.)
 *
 * @param $serviceContainer - the service container, i.e. availability-internet
 * @param availability - (String) - the availability. Has to match any of the keys in the global badges variable ('check', 'alert')
 */
function showAvailabilityBadge($serviceContainer, availability) {
    var $badgeContainer = $serviceContainer.find('.badge');
    var $badgeIcon = $badgeContainer.find('.badge__content .icon');
    var badgeStatus = BADGES[availability];
    clearBadgeStatus($badgeContainer, $badgeIcon);
    if (badgeStatus) {
        $badgeContainer.addClass(badgeStatus.badgeClass);
        $badgeIcon.addClass(badgeStatus.iconClass);
        $badgeIcon.removeClass('hidden');
    }
    // Trigger loaded event to reposition dialog
    $serviceContainer.trigger('changed.content');
}
function hasSessionStorageData() {
    if (!window.sessionStorage) {
        return false;
    }
    for (var field in FIELDS) {
        if (sessionStorage.getItem(FIELDS[field].session)) {
            return true;
        }
    }
    return false;
}


/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(SnabbdomPragma) {/* harmony export (immutable) */ __webpack_exports__["a"] = Stars;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bootstrap_load_snabbdom__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_bootstrap_load_dot__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_bootstrap_load_moment__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lib_vendor_terrific_Module__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lib_vendor_jquery_deparam_patched__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lib_generic_SDXModalDialog__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lib_util_array__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lib_util_string__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lib_util_helpers__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Tc_Module_EcommerceProductDataHub__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lib_personalization_profile__ = __webpack_require__(5);
/// <reference types="jqueryui" />
/// <reference types="jquerymobile" />
// tslint:disable:no-reference
/// <reference path="../../etc/designs/forms/clientlibs/shared/js/libraries/ScForm.ClientValidation.js.d.ts" />
// tslint:enable:no-reference













function dateCompareRatingDesc(r1, r2) {
    return r2.getDate().valueOf() - r1.getDate().valueOf();
}
// Constants
var STARS_FILTER_HASH = 'rating-list-stars';
var OCC_RATING_ENDPOINT = '/portal-services/occ/rating/{0}/{1}/';
var ADD_COMMENT_URL = OCC_RATING_ENDPOINT + 'comment/add';
var VOTE_RATING_URL = OCC_RATING_ENDPOINT + 'vote';
var VOTE_COMMENT_URL = OCC_RATING_ENDPOINT + 'comment/{2}/vote';
var VOTE_HELPFUL = 'HELPFUL';
var VOTE_USELESS = 'USELESS';
var VOTE_ABUSE = 'ABUSE';
/**
 * Tealium tracking
 */
function trackingTealium(trackingAction) {
    SCS.portal.datalayer.trackEvent(trackingAction, 'r_ratingfilter', 'content', 'Rating');
}
/**
 * Validates comment form.
 * @param $elem jQuery
 */
function validateForm($elem) {
    var $form = $elem.closest('.modScForm');
    var $fields = $form.find('.field');
    var validates = true;
    $fields.each(function (_i, field) {
        var $field = __WEBPACK_IMPORTED_MODULE_2_jquery___default()(field);
        var val = $field.find('input, textarea').val();
        var clientValidation = $field.data('clientvalidation');
        $field.data('invalid', false);
        if (ScForm.createClientValidation(clientValidation).validate(val).isValid) {
            $field.find('input, textarea').removeClass('error-field');
            $field.removeClass('error');
            $field.find('.error').addClass('hidden');
            $field.data('invalid', false);
        }
        else {
            $field.find('.error').html(clientValidation.constraintMessage).removeClass('hidden');
            $field.find('input, textarea').addClass('error-field');
            $field.addClass('error');
            $field.data('invalid', true);
            validates = false;
        }
    });
    return validates;
}
function refreshFilterSelect($filterSelectWrapper) {
    return $filterSelectWrapper.find('select').resetSS();
}
// Snabbdom render functions
// These could be instance methods but out-sourcing them lets the minifier mingle their names.
function IsUseful(_a) {
    var messages = _a.messages, mod = _a.mod, model = _a.model, endpoint = _a.endpoint;
    if (model.hasVoted()) {
        // The user has already up- or downvoted this item
        return SnabbdomPragma.createElement("div", { "attrs-class": "rl-useful" }, model.getVote() ? messages.upvoteMessage : messages.downvoteMessage);
    }
    return SnabbdomPragma.createElement("div", { "attrs-class": "rl-useful" },
        SnabbdomPragma.createElement("a", { "props-href": "#", "on-click": [mod.incrementHelpful.bind(mod), endpoint, true, model] },
            messages.like,
            " (",
            SnabbdomPragma.createElement("span", null, model.getUpvotes()),
            ")"));
}
function ReportAbuse(_a) {
    var messages = _a.messages, mod = _a.mod, model = _a.model, endpoint = _a.endpoint;
    if (model.hasSentAbuseReport()) {
        return messages.reportSuccess;
    }
    return SnabbdomPragma.createElement("a", { href: "#", "on-click": [mod.reportAbuse.bind(mod), endpoint, model] }, messages.reportAbuse);
}
function Star(_a) {
    var val = _a.val, rating = _a.rating;
    return SnabbdomPragma.createElement("span", { "attrs-class": "stars", "class-empty": val > rating });
}
function SDXStar(_a) {
    var val = _a.val, rating = _a.rating;
    return SnabbdomPragma.createElement("i", { className: 'icon ' + (val <= rating ? 'icon-228-star-filled' : 'icon-082-star') });
}
function Stars(_a) {
    var rating = _a.rating, sdx = _a.sdx;
    rating = Math.round(rating);
    return [1, 2, 3, 4, 5].map(function (val) {
        return sdx ? SnabbdomPragma.createElement(SDXStar, { val: val, rating: rating }) : SnabbdomPragma.createElement(Star, { val: val, rating: rating });
    });
}
function Actions(_a) {
    var mod = _a.mod, model = _a.model, endpoint = _a.endpoint;
    var contents = [];
    for (var _b = 1; _b < arguments.length; _b++) {
        contents[_b - 1] = arguments[_b];
    }
    var messages = mod.messages;
    contents.push(SnabbdomPragma.createElement(IsUseful, { messages: messages, mod: mod, model: model, endpoint: endpoint }), SnabbdomPragma.createElement("div", { "attrs-class": "rl-report" },
        SnabbdomPragma.createElement(ReportAbuse, { messages: messages, mod: mod, model: model, endpoint: endpoint })));
    return SnabbdomPragma.createElement("div", { "attrs-class": "rl-actions cf text-b2" }, contents);
}
function RatingStars(_a) {
    var rating = _a.rating;
    return SnabbdomPragma.createElement("div", { "attrs-class": "rl-rating-stars" },
        SnabbdomPragma.createElement(Stars, { rating: rating, sdx: true }));
}
function SubcategoryRatings(_a) {
    var mod = _a.mod, rating = _a.rating;
    var subcategoryRatings = rating.getCategorySubratings();
    if (!subcategoryRatings.hasSubratings()) {
        return undefined;
    }
    if (!mod.areSubcategoryRatingsExpanded(rating)) {
        return SnabbdomPragma.createElement("a", { "attrs-class": "rl-more-link", href: "#", "on-click": [mod.openSubcategoryRatings.bind(mod), rating] });
    }
    return SnabbdomPragma.createElement("div", { "attrs-class": "rl-rating-subratings" },
        SnabbdomPragma.createElement("dl", { "attrs-class": "text-b2" }, subcategoryRatings.map(function (ratingValue, category) { return [
            SnabbdomPragma.createElement("dt", null, category.getName()),
            SnabbdomPragma.createElement("dd", null,
                SnabbdomPragma.createElement(RatingStars, { rating: ratingValue })),
        ]; })));
}
function FormField(_a) {
    var clientValidation = _a.clientValidation, field = _a.field, section = _a.section, id = _a.id, label = _a.label, extraProps = _a.extraProps;
    return Object(__WEBPACK_IMPORTED_MODULE_1_bootstrap_load_snabbdom__["a" /* h */])(section + '.section.cf', [
        SnabbdomPragma.createElement("div", { "attrs-class": "field", attrs: { 'data-clientvalidation': JSON.stringify(clientValidation) } },
            SnabbdomPragma.createElement("label", { "attrs-for": id },
                label,
                "*"),
            SnabbdomPragma.createElement("span", { "attrs-class": "inputField" }, Object(__WEBPACK_IMPORTED_MODULE_1_bootstrap_load_snabbdom__["a" /* h */])(field, {
                attrs: {
                    'aria-required': true,
                },
                props: Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ id: id }, extraProps),
            })),
            SnabbdomPragma.createElement("span", { "attrs-class": "error hidden" })),
    ]);
}
function CommentForm(_a) {
    var mod = _a.mod, rating = _a.rating;
    var messages = mod.messages;
    if (rating.hasCommented()) {
        // The user has already commented on this rating, replace the form with a message
        return [SnabbdomPragma.createElement("br", null), messages.commentMessage];
    }
    return SnabbdomPragma.createElement("form", { "on-submit": mod.postComment.bind(mod, rating) },
        SnabbdomPragma.createElement(FormField, { clientValidation: {
                constraintData: {},
                constraintMessage: messages.formCommentConstraint,
                constraintRegex: null,
                constraintType: null,
                foreignValidationModels: {},
                hasConstraint: false,
                hasLengthValidation: true,
                lengthMessage: messages.formCommentConstraint,
                lengthRegex: '^.{10,2500}$',
                maxLength: 2500,
                minLength: 10,
                required: true,
                requiredMessage: messages.formCommentConstraint,
            }, field: "textarea.textareastandard", section: "div.textarea.comment", id: "rating-comment-" + rating.getId(), label: messages.formCommentLabel, extraProps: {
                cols: 35,
                name: 'Comment',
                sections: 4,
            } }),
        SnabbdomPragma.createElement(FormField, { clientValidation: {
                constraintData: {},
                constraintMessage: '',
                constraintRegex: '',
                constraintType: 'REGEX',
                foreignValidationModels: {},
                hasConstraint: true,
                hasLengthValidation: false,
                lengthMessage: 'Length Error',
                lengthRegex: null,
                maxLength: 50,
                minLength: 2,
                required: true,
                requiredMessage: 'Required ',
            }, field: "input", section: "div.textfield.user-name", id: "rating-user-" + rating.getId(), label: messages.userName, extraProps: {
                name: 'UserName',
                required: true,
                type: 'text',
                value: '',
            } }),
        SnabbdomPragma.createElement("div", { "attrs-class": "comment-form-buttons" },
            SnabbdomPragma.createElement("button", { "attrs-class": "button button--primary", "props-type": "submit" }, messages.formSave)));
}
function RatingComments(_a) {
    var mod = _a.mod, rating = _a.rating, comments = _a.comments, messages = _a.messages;
    return SnabbdomPragma.createElement("div", { "attrs-class": "rl-rating-comments" },
        comments.length ? SnabbdomPragma.createElement("ul", null, comments.map(function (comment) {
            return SnabbdomPragma.createElement("li", { class: { 'admin-comment': comment.isAdminComment() }, key: comment.getId() },
                SnabbdomPragma.createElement("div", { "attrs-class": "rl-rating-author-time text-sm" },
                    SnabbdomPragma.createElement("span", { "attrs-class": "rating-date" }, SCS.utils.date.format(comment.getDate()) || ''),
                    ' ',
                    messages.from,
                    ' ',
                    comment.isAdminComment() ? SnabbdomPragma.createElement("span", { "attrs-class": "admin-user" }, comment.getName()) : comment.getName()),
                SnabbdomPragma.createElement("p", { "attrs-class": "text-b2" }, comment.getComment()),
                SnabbdomPragma.createElement(Actions, { mod: mod, model: comment, endpoint: Object(__WEBPACK_IMPORTED_MODULE_9_lib_util_string__["format"])(VOTE_COMMENT_URL, rating.getProductId(), rating.getId(), comment.getId()) }));
        })) : null,
        SnabbdomPragma.createElement("div", { "attrs-class": "comment-form mod modScForm cf" },
            SnabbdomPragma.createElement(CommentForm, { mod: mod, rating: rating })));
}
/**
 * Rating List
 *
 * @author Zeljko Curcic
 * @namespace Tc.Module
 * @class RatingList
 * @extends Tc.Module
 */
var RatingList = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */])(RatingList, _super);
    function RatingList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // Contains all ids as keys whose subrating categories and ratings are currently expanded (only applicable on mobile)
        _this.subcategoryRatingsVisibleFor = {};
        // A rating object that is currently opened to display its comment list (only one can be open at a time)
        _this.commentsOpenFor = null;
        // How many entries the list is currently limited to
        _this.limit = 10;
        _this.loaded = false;
        return _this;
    }
    RatingList.prototype.on = function (callback) {
        this.prepareData();
        this.prepareTemplates();
        this.prepareDOM();
        this.prepareListeners();
        this.loaded = false;
        // Subscribe to EcommerceProductDataHub product updates
        // tslint:disable-next-line:no-unbound-method
        Object(__WEBPACK_IMPORTED_MODULE_11__Tc_Module_EcommerceProductDataHub__["c" /* simpleSubscribe */])(this, this.getRatingLists);
        callback();
    };
    RatingList.prototype.reportAbuse = function (endpoint, model, event) {
        var _this = this;
        event.preventDefault();
        __WEBPACK_IMPORTED_MODULE_7_lib_generic_SDXModalDialog__["default"].show({
            buttons: [
                {
                    primary: false,
                    title: this.$ctx.data('dialogButtonNo'),
                    type: 'close',
                },
                {
                    click: function () {
                        _this.doPost(endpoint, { vote: VOTE_ABUSE }, function () {
                            model.sendAbuseReport();
                            _this.display();
                        });
                    },
                    primary: true,
                    title: this.$ctx.data('dialogButtonYes'),
                    type: 'close',
                },
            ],
            displayMode: 'prompt',
            html: this.messages.reportDialogText,
            title: this.messages.reportDialogTitle,
        });
    };
    /**
     * Post comment
     * @param $elem jQuery
     */
    RatingList.prototype.postComment = function (rating, event) {
        var _this = this;
        event.preventDefault();
        var $form = __WEBPACK_IMPORTED_MODULE_2_jquery___default()(event.currentTarget);
        if (!validateForm($form)) {
            return;
        }
        var d = Object(__WEBPACK_IMPORTED_MODULE_6_lib_vendor_jquery_deparam_patched__["default"])($form.serialize());
        var data = {
            comment: d.Comment,
            date: Object(__WEBPACK_IMPORTED_MODULE_4_bootstrap_load_moment__["a" /* default */])().format('YYYY-MM-DDTHH:mm:ssZZ'),
            // FIXME NEC: Route this through
            ipAddress: '0.0.0.0',
            reviewerName: d.UserName,
        };
        var url = Object(__WEBPACK_IMPORTED_MODULE_9_lib_util_string__["format"])(ADD_COMMENT_URL, rating.getProductId(), rating.getId());
        this.doPost(url, data, function () {
            rating.comment();
            _this.display();
        });
    };
    RatingList.prototype.areSubcategoryRatingsExpanded = function (rating) {
        return this.isMobile && !(rating.getId() in this.subcategoryRatingsVisibleFor);
    };
    RatingList.prototype.openSubcategoryRatings = function (event, rating) {
        event.preventDefault();
        this.subcategoryRatingsVisibleFor[rating.getId()] = true;
        this.display();
    };
    RatingList.prototype.closeComments = function () {
        this.commentsOpenFor = null;
        this.display();
    };
    /**
     * Upvote/downvote a rating or comment
     * @param $elem jQuery
     */
    RatingList.prototype.incrementHelpful = function (url, isHelpful, model, event) {
        var _this = this;
        event.preventDefault();
        this.doPost(url, { vote: isHelpful ? VOTE_HELPFUL : VOTE_USELESS }, function () {
            model.vote(isHelpful);
            _this.display();
        });
    };
    // Displays the current (filtered) ratings
    RatingList.prototype.display = function () {
        this.$ctx.addClass('hidden loader-wrap');
        this.$filterArea.addClass('hidden');
        var ratings = this.ratings || [];
        var ratingsFiltered = this.filterRatings(ratings);
        var list = this.renderRatingList(ratingsFiltered, this.limit);
        this.rlWrapper = Object(__WEBPACK_IMPORTED_MODULE_1_bootstrap_load_snabbdom__["b" /* patch */])(this.rlWrapper, list);
        this.$loader.remove();
        this.$filterArea.toggleClass('hidden', !ratings.length);
        this.$ctx.toggleClass('hidden', !ratings.length);
        this.$ctx.removeClass('loader-wrap');
    };
    RatingList.prototype.prepareData = function () {
        this.isMobile = Object(__WEBPACK_IMPORTED_MODULE_10_lib_util_helpers__["isMobilePage"])();
        this.messages = this.$ctx.data();
    };
    RatingList.prototype.prepareTemplates = function () {
        this.tmplStarsFilter = __WEBPACK_IMPORTED_MODULE_3_bootstrap_load_dot__["a" /* default */].template(this.$ctx.find('script.tmpl-stars-filter').html());
        this.tmplLanguageFilter = __WEBPACK_IMPORTED_MODULE_3_bootstrap_load_dot__["a" /* default */].template(this.$ctx.find('script.tmpl-language-filter').html());
    };
    RatingList.prototype.prepareDOM = function () {
        var $ctx = this.$ctx;
        this.rlWrapper = $ctx.find('.rl-wrapper')[0];
        this.$loader = $ctx.find('.scs-loadingRotator');
        this.$filterArea = this.$ctx.find('.rl-filter');
        this.$filters = this.$filterArea.find('.filter');
        this.$starsFilter = this.$filters.filter('[data-filter="Rating"]');
        this.$langFilter = this.$filters.filter('[data-filter="Language"]');
    };
    RatingList.prototype.prepareListeners = function () {
        var _this = this;
        __WEBPACK_IMPORTED_MODULE_2_jquery___default()(window).on('hashchange', function () {
            if (_this.loaded) {
                _this.updateFilterFromHash();
                _this.display();
            }
        });
    };
    /**
     * Loads RatingList JSONs for all available product ids and triggers RatingList rendering
     */
    RatingList.prototype.getRatingLists = function (data) {
        if (this.loaded) {
            // We don’t care about updated varians since only the family contains the rating.
            return;
        }
        var family = data.family;
        var ratings = family.getRatings();
        if (!ratings.loaded()) {
            // Register callback for when rating data is loaded
            // tslint:disable-next-line:no-floating-promises
            ratings.load().done(this.getRatingLists.bind(this, data));
            return;
        }
        // Reset state
        this.limit = 10;
        this.commentsOpenFor = null;
        this.subcategoryRatingsVisibleFor = {};
        this.loaded = true;
        this.ratings = ratings.getRatings() || [];
        this.ratings.sort(dateCompareRatingDesc);
        // Maybe the new ratings allow new values in the filters, update those
        this.displayFilters();
        // Display the ratings
        this.display();
    };
    /**
     * Add options to filter dropdowns from values existing in RatingList
     */
    RatingList.prototype.displayFilters = function () {
        // Write down all distinct languages for which there are comments
        var languages = (this.ratings || [])
            .map(function (rating) {
            return rating.getLanguage();
        })
            .filter(__WEBPACK_IMPORTED_MODULE_8_lib_util_array__["a" /* onlyUnique */])
            // Sort by language code
            .sort();
        // Write down all distinct star rating values for which there are comments
        var stars = {};
        (this.ratings || []).map(function (rating) {
            return rating.getRating();
        }).forEach(function (star) {
            stars[star] = true;
        });
        // Use templates to set the HTML
        this.$starsFilter.html(this.tmplStarsFilter({ ratings: stars }));
        this.$langFilter.html(this.tmplLanguageFilter({ languages: languages }));
        // Update/re-create custom selects and attach event listeners
        refreshFilterSelect(this.$starsFilter).change(this.filtersChanged.bind(this));
        refreshFilterSelect(this.$langFilter).change(this.filtersChanged.bind(this));
        this.updateFilterFromHash();
    };
    /**
     * Filter the rating list depending on filter dropdown selections
     * @param ratings The unfiltered list
     */
    RatingList.prototype.filterRatings = function (ratings) {
        // Assemble all filters (field name/value).
        // Currently there are filters for rating (the number of stars) and comment language.
        var filters = this.$filters.get().map(function (elem) {
            // Describe each filter
            return {
                field: elem.dataset.filter,
                value: __WEBPACK_IMPORTED_MODULE_2_jquery___default()(elem).find('select').val(),
            };
        }).filter(function (filter) {
            // Discard filters with unset values
            return !!filter.value;
        });
        // Apply the filters to the ratings collection
        return ratings.filter(function (rating) {
            for (var _a = 0, filters_1 = filters; _a < filters_1.length; _a++) {
                var filter = filters_1[_a];
                var actualValue = rating['get' + filter.field]();
                var filterValue = filter.value;
                if (String(actualValue) !== String(filterValue)) {
                    // This filter didn’t match, exclude the rating
                    return false;
                }
            }
            // All filters matched (or there were none), include the rating
            return true;
        });
    };
    /**
     * Render rating list from mod.data.FilteredRatingList
     * On first rendering initialize filters and more buttons for mobile
     * @param initial Boolean
     */
    RatingList.prototype.renderRatingList = function (ratingsFiltered, limit) {
        var _this = this;
        if (limit === void 0) { limit = Number.MAX_VALUE; }
        var messages = this.messages;
        var ratings = ratingsFiltered.slice(0, limit);
        var hasHidden = ratingsFiltered.length > ratings.length;
        return SnabbdomPragma.createElement("div", { "attrs-class": "rl-wrapper" },
            SnabbdomPragma.createElement("ul", { "attrs-class": "rating-list" },
                !ratings.length ? SnabbdomPragma.createElement("li", { "attrs-class": "empty-list" },
                    SnabbdomPragma.createElement("a", { "props-href": "#", "on-click": this.refreshFilters.bind(this) }, messages.emptyList)) : null,
                ratings.map(function (rating) {
                    var comments = rating.getComments();
                    var subcategoryRatings = SnabbdomPragma.createElement(SubcategoryRatings, { mod: _this, rating: rating });
                    return SnabbdomPragma.createElement("li", { "attrs-class": "rating", key: rating.getId() },
                        SnabbdomPragma.createElement(RatingStars, { rating: rating.getRating() }),
                        SnabbdomPragma.createElement("div", { "attrs-class": "rl-rating-body" },
                            rating.getHeadline() ? SnabbdomPragma.createElement("h3", { "attrs-class": "text-h4 navy" }, rating.getHeadline()) : null,
                            SnabbdomPragma.createElement("div", { "attrs-class": "rl-rating-author-time text-sm" },
                                SnabbdomPragma.createElement("span", { "attrs-class": "rating-date" }, SCS.utils.date.format(rating.getDate()) || ''),
                                ' ',
                                messages.from,
                                ' ',
                                rating.getFirstName()),
                            SnabbdomPragma.createElement("p", null, rating.getComment()),
                            SnabbdomPragma.createElement(Actions, { mod: _this, model: rating, endpoint: Object(__WEBPACK_IMPORTED_MODULE_9_lib_util_string__["format"])(VOTE_RATING_URL, rating.getProductId(), rating.getId()) },
                                SnabbdomPragma.createElement("a", { "attrs-class": "rl-comments-link", "on-click": [_this.handleClickToComment.bind(_this), rating] },
                                    SnabbdomPragma.createElement("i", { "attrs-class": "icon icon-068-reply-message-2 icon--s1" }),
                                    "\u00A0",
                                    comments.length ? [messages.comments, ' (', comments.length, ')'] : messages.writeComment)),
                            _this.commentsOpenFor === rating ? SnabbdomPragma.createElement(RatingComments, { mod: _this, rating: rating, comments: comments, messages: messages }) : null),
                        !_this.isMobile ? subcategoryRatings : null);
                })),
            hasHidden ? SnabbdomPragma.createElement("div", { "attrs-class": "rl-showall" },
                SnabbdomPragma.createElement("a", { "props-href": "#", "attrs-class": "button button--secondary", "on-click": this.displayAll.bind(this) }, Object(__WEBPACK_IMPORTED_MODULE_9_lib_util_string__["format"])(messages.displayAll, ratingsFiltered.length))) : null);
    };
    RatingList.prototype.displayAll = function (event) {
        event.preventDefault();
        this.limit = undefined;
        this.display();
    };
    // tslint:disable-next-line:prefer-function-over-method
    RatingList.prototype.handleClickToComment = function (rating, event) {
        return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var $ctx, loginRequired, isLoggedIn, loginUrl, $tabNavigation, $tabNavigationContent, activeTabIndex;
            return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        event.preventDefault();
                        $ctx = this.$ctx;
                        // Toggle commentsOpenFor === rating
                        this.commentsOpenFor = this.commentsOpenFor === rating ? null : rating;
                        loginRequired = $ctx.data('login-required');
                        isLoggedIn = true;
                        if (!loginRequired) return [3 /*break*/, 2];
                        return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_12_lib_personalization_profile__["getProfile"])()];
                    case 1:
                        isLoggedIn = !!(_a.sent()).getUser();
                        _a.label = 2;
                    case 2:
                        if (this.commentsOpenFor !== null && !isLoggedIn) {
                            loginUrl = $ctx.data('login-url');
                            $tabNavigation = this.$ctx.closest('.modTabNavigation');
                            $tabNavigationContent = $tabNavigation.find('.modTabNavigationContent').has($ctx[0]);
                            activeTabIndex = $tabNavigation.children('.modTabNavigationContent').index($tabNavigationContent) + 1;
                            window.location.href = loginUrl.replace('.tab_index', '.t' + (activeTabIndex || ''));
                            return [2 /*return*/];
                        }
                        // Do nothing, just display
                        this.display();
                        return [2 /*return*/];
                }
            });
        });
    };
    RatingList.prototype.filtersChanged = function (event) {
        var $elem = __WEBPACK_IMPORTED_MODULE_2_jquery___default()(event.currentTarget);
        // Tracking
        trackingTealium($elem.data('tracking-action'));
        // Update display
        this.display();
    };
    RatingList.prototype.updateFilterFromHash = function () {
        var hashParams = Object(__WEBPACK_IMPORTED_MODULE_6_lib_vendor_jquery_deparam_patched__["default"])(window.location.hash.substring(1));
        var hashValue = hashParams[STARS_FILTER_HASH];
        this.$starsFilter.find('select').val(hashValue);
        refreshFilterSelect(this.$starsFilter);
    };
    /**
     * Post data
     * @param url URL
     * @param data Data
     * @param successHandler Success handler
     */
    RatingList.prototype.doPost = function (url, data, successHandler) {
        // tslint:disable-next-line:no-floating-promises
        __WEBPACK_IMPORTED_MODULE_2_jquery___default.a.ajax({
            contentType: 'application/json',
            data: JSON.stringify(data),
            dataType: 'json',
            error: function (_xhr, _status, msg) {
                SCS.portal.showError(msg);
            },
            success: successHandler.bind(this) || null,
            type: 'POST',
            url: url,
        });
    };
    /**
     * Refresh stars and language select filters.
     *
     * @method refreshFilters
     * @return void
     */
    RatingList.prototype.refreshFilters = function () {
        this.$langFilter.find('select').val('');
        this.$starsFilter.find('select').val('');
        refreshFilterSelect(this.$starsFilter);
        refreshFilterSelect(this.$langFilter);
    };
    return RatingList;
}(__WEBPACK_IMPORTED_MODULE_5_lib_vendor_terrific_Module__["a" /* Module */]));
/* harmony default export */ __webpack_exports__["b"] = (RatingList);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(10)))

/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);

window.moment = __WEBPACK_IMPORTED_MODULE_0_moment___default.a;
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_moment___default.a);


/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lib_util_helpers__ = __webpack_require__(4);

var NodeWrapper = /** @class */ (function () {
    function NodeWrapper($ctx) {
        this.$ctx = $ctx;
        this.children = [];
    }
    Object.defineProperty(NodeWrapper.prototype, "parent", {
        get: function () {
            return this._parent;
        },
        set: function (parent) {
            this._parent = parent;
        },
        enumerable: false,
        configurable: true
    });
    NodeWrapper.prototype.getContext = function () {
        return this.$ctx;
    };
    NodeWrapper.prototype.updateState = function (current, active) {
        if (current !== null) {
            this.$ctx.toggleClass('current', current);
            if (Object(__WEBPACK_IMPORTED_MODULE_0_lib_util_helpers__["isMobilePage"])() && this.$ctx.hasClass('topic')) {
                this.$ctx[0].setAttribute('aria-hidden', String(!current));
            }
            if (current) {
                active = true;
            }
        }
        if (active !== null) {
            this.$ctx.toggleClass('active', active);
        }
    };
    NodeWrapper.prototype.addChild = function (child) {
        this.children.push(child);
    };
    NodeWrapper.prototype.getChildren = function () {
        return this.children;
    };
    return NodeWrapper;
}());
/* harmony default export */ __webpack_exports__["a"] = (NodeWrapper);


/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__NodeWrapper__ = __webpack_require__(47);


var BaseItem = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */])(BaseItem, _super);
    function BaseItem($ctx) {
        var _this = _super.call(this, $ctx) || this;
        _this.parentTopicName = _this.$ctx.data('parentTopic');
        return _this;
    }
    Object.defineProperty(BaseItem.prototype, "parentTopicName", {
        get: function () {
            return this._parentTopicName;
        },
        set: function (topicName) {
            this._parentTopicName = topicName;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseItem.prototype, "step", {
        get: function () {
            return this._step;
        },
        set: function (step) {
            this._step = step;
            var pStep = this.step.getPreviousStep;
            if (pStep) {
                var parent = pStep.namedTopic(this.parentTopicName);
                if (parent) {
                    this.setParent(parent);
                }
                else {
                    pStep = this.step.getPreviousStep.getPreviousStep;
                    if (pStep) {
                        parent = pStep.namedTopic(this.parentTopicName);
                        if (parent && parent.isResult) {
                            this.setParent(parent);
                        }
                    }
                }
            }
        },
        enumerable: false,
        configurable: true
    });
    BaseItem.prototype.setParent = function (parent) {
        this.parent = parent;
        this.parent.addChild(this);
    };
    return BaseItem;
}(__WEBPACK_IMPORTED_MODULE_1__NodeWrapper__["a" /* default */]));
/* harmony default export */ __webpack_exports__["a"] = (BaseItem);


/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony export (immutable) */ __webpack_exports__["ibanFieldValidator"] = ibanFieldValidator;
/* harmony export (immutable) */ __webpack_exports__["urlBlacklistValidation"] = urlBlacklistValidation;
function ibanFieldValidator(ibanValue) {
    return function (callback) {
        $.ajax({
            dataType: 'json',
            error: function (err) {
                if (err.status === 404 && err.responseJSON && err.responseJSON.code === 'INVALID_REQUEST_RESOURCE') {
                    callback(false);
                }
                else {
                    callback(false, err);
                }
            },
            success: function (data) {
                callback(Boolean(data && Array.isArray(data) && data.length));
            },
            type: 'GET',
            url: "/portal-services/oce-iban/" + ibanValue,
        });
    };
}
function urlBlacklistValidation(url, inverse) {
    return function (callback) {
        $.ajax({
            data: {
                isInsideForm: true,
                language: document.documentElement.lang || 'de',
                path: window.location.pathname,
                url: url,
            },
            error: function () { return callback(inverse); },
            success: function () { return callback(!inverse); },
            type: 'POST',
            url: '/etc/swisscom/servlets/public/urlchecker.urlchecker.json',
        });
    };
}

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["init"] = init;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Utils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DomElement__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_flatpickr__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_flatpickr_dist_l10n_it_js__ = __webpack_require__(288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_flatpickr_dist_l10n_it_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_flatpickr_dist_l10n_it_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_flatpickr_dist_l10n_fr_js__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_flatpickr_dist_l10n_fr_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_flatpickr_dist_l10n_fr_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_flatpickr_dist_l10n_de_js__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_flatpickr_dist_l10n_de_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_flatpickr_dist_l10n_de_js__);







var INFO_ICON = "icon-026-exclamation-mark-circle";
__WEBPACK_IMPORTED_MODULE_3_flatpickr__["a" /* default */].localize(__WEBPACK_IMPORTED_MODULE_4_flatpickr_dist_l10n_it_js__["Italian"]);
__WEBPACK_IMPORTED_MODULE_3_flatpickr__["a" /* default */].localize(__WEBPACK_IMPORTED_MODULE_5_flatpickr_dist_l10n_fr_js__["French"]);
__WEBPACK_IMPORTED_MODULE_3_flatpickr__["a" /* default */].localize(__WEBPACK_IMPORTED_MODULE_6_flatpickr_dist_l10n_de_js__["German"]);
var DEFAULTS_FLATPICKR = {
    wrap: true,
    allowInput: true,
    locale: "de",
    dateFormat: "d.m.Y",
    time_24hr: true,
};
var CLASS_HAS_VALUE = "is-fixed";
var CLASS_MESSAGE = ".message";
/**
 * Input field component
 */
var InputField = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */])(InputField, _super);
    function InputField(element, datePickerOptions) {
        var _this = _super.call(this, element) || this;
        _this._changedHandler = _this.onValueChanged.bind(_this);
        _this._animationStartHandler = _this._onAnimationStart.bind(_this);
        _this._datePickerOptions = datePickerOptions;
        _this._initialize();
        return _this;
    }
    /**
     * Initializes the input field component.
     * @private
     */
    InputField.prototype._initialize = function () {
        this.element.spellcheck = false;
        this.element.addEventListener("input", this._changedHandler);
        if (this.element.getAttribute("type") === "password") {
            this.element.addEventListener("animationstart", this._animationStartHandler);
        }
        this._initializeDatePicker();
        this.onValueChanged();
    };
    InputField.prototype._initializeDatePicker = function () {
        var picker = this.element.parentElement;
        if (!picker || !picker.classList.contains("flatpickr")) {
            return;
        }
        if (!this._datePickerOptions) {
            try {
                this._datePickerOptions = JSON.parse(picker.dataset.options || "{}");
            }
            catch (e) {
                this._datePickerOptions = {};
                // eslint-disable-next-line no-console
                console.warn("_initializeDatePicker JSON.parse failed", picker.dataset.options, e);
            }
        }
        this._flatpickrInstance = Object(__WEBPACK_IMPORTED_MODULE_3_flatpickr__["a" /* default */])(picker, Object.assign({}, DEFAULTS_FLATPICKR, this._datePickerOptions));
    };
    InputField.prototype._destroyDatePicker = function () {
        if (this._flatpickrInstance) {
            this._flatpickrInstance.destroy();
        }
    };
    InputField.prototype._onAnimationStart = function (e) {
        if (e.animationName === "onAutoFillStart") {
            this.onValueChanged(true);
        }
    };
    /**
     * Notifies the input field component that it's value has been changed.
     */
    InputField.prototype.onValueChanged = function (force) {
        if (force === void 0) { force = false; }
        if ((this.element.value && this.element.value !== "") || force === true) {
            this.addClass(CLASS_HAS_VALUE);
        }
        else {
            this.removeClass(CLASS_HAS_VALUE);
            this.element.value = "";
        }
    };
    /**
     * Destroys the component and frees all references.
     */
    InputField.prototype.destroy = function () {
        this.element.removeEventListener("input", this._changedHandler);
        if (this.element.getAttribute("type") === "password") {
            this.element.removeEventListener("animationstart", this._animationStartHandler);
        }
        ;
        this._changedHandler = undefined;
        this._animationStartHandler = undefined;
        this._destroyDatePicker();
    };
    /**
     * Displays the specified error text underneath the input field.
     * @param {text} text The error text/html to display; or undefined to hide the message.
     */
    InputField.prototype.showError = function (text) {
        var message;
        if (this.element.parentElement) {
            var msg_1 = this.element.parentElement.querySelector(CLASS_MESSAGE);
            if (msg_1) {
                message = new __WEBPACK_IMPORTED_MODULE_2__DomElement__["a" /* default */](msg_1);
            }
        }
        if (!text || text === "") {
            if (message) {
                Object(__WEBPACK_IMPORTED_MODULE_1__Utils__["f" /* remove */])(message.element);
            }
            this.removeClass("invalid");
            return;
        }
        this.addClass("invalid");
        if (!message) {
            message = new __WEBPACK_IMPORTED_MODULE_2__DomElement__["a" /* default */]("div").addClass("message");
            this.element.parentElement.appendChild(message.element);
        }
        else {
            message.empty();
        }
        var icon = new __WEBPACK_IMPORTED_MODULE_2__DomElement__["a" /* default */]("i")
            .addClass("icon")
            .addClass(INFO_ICON)
            .setAttribute("aria-hidden", "true");
        var msg = new __WEBPACK_IMPORTED_MODULE_2__DomElement__["a" /* default */]("span").setHtml(text);
        message.appendChild(icon);
        message.appendChild(msg);
    };
    return InputField;
}(__WEBPACK_IMPORTED_MODULE_2__DomElement__["a" /* default */]));
function init() {
    Object(__WEBPACK_IMPORTED_MODULE_1__Utils__["h" /* searchAndInitialize */])(".input-field input", function (e) {
        new InputField(e);
    }, function (e) { return e.parentElement; });
}
/* harmony default export */ __webpack_exports__["default"] = (InputField);


/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HOOKS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return defaults; });
var HOOKS = [
    "onChange",
    "onClose",
    "onDayCreate",
    "onDestroy",
    "onKeyDown",
    "onMonthChange",
    "onOpen",
    "onParseConfig",
    "onReady",
    "onValueUpdate",
    "onYearChange",
    "onPreCalendarPosition",
];
var defaults = {
    _disable: [],
    allowInput: false,
    allowInvalidPreload: false,
    altFormat: "F j, Y",
    altInput: false,
    altInputClass: "form-control input",
    animate: typeof window === "object" &&
        window.navigator.userAgent.indexOf("MSIE") === -1,
    ariaDateFormat: "F j, Y",
    autoFillDefaultTime: true,
    clickOpens: true,
    closeOnSelect: true,
    conjunction: ", ",
    dateFormat: "Y-m-d",
    defaultHour: 12,
    defaultMinute: 0,
    defaultSeconds: 0,
    disable: [],
    disableMobile: false,
    enableSeconds: false,
    enableTime: false,
    errorHandler: function (err) {
        return typeof console !== "undefined" && console.warn(err);
    },
    getWeek: function (givenDate) {
        var date = new Date(givenDate.getTime());
        date.setHours(0, 0, 0, 0);
        date.setDate(date.getDate() + 3 - ((date.getDay() + 6) % 7));
        var week1 = new Date(date.getFullYear(), 0, 4);
        return (1 +
            Math.round(((date.getTime() - week1.getTime()) / 86400000 -
                3 +
                ((week1.getDay() + 6) % 7)) /
                7));
    },
    hourIncrement: 1,
    ignoredFocusElements: [],
    inline: false,
    locale: "default",
    minuteIncrement: 5,
    mode: "single",
    monthSelectorType: "dropdown",
    nextArrow: "<svg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 17 17'><g></g><path d='M13.207 8.472l-7.854 7.854-0.707-0.707 7.146-7.146-7.146-7.148 0.707-0.707 7.854 7.854z' /></svg>",
    noCalendar: false,
    now: new Date(),
    onChange: [],
    onClose: [],
    onDayCreate: [],
    onDestroy: [],
    onKeyDown: [],
    onMonthChange: [],
    onOpen: [],
    onParseConfig: [],
    onReady: [],
    onValueUpdate: [],
    onYearChange: [],
    onPreCalendarPosition: [],
    plugins: [],
    position: "auto",
    positionElement: undefined,
    prevArrow: "<svg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 17 17'><g></g><path d='M5.207 8.471l7.146 7.147-0.707 0.707-7.853-7.854 7.854-7.853 0.707 0.707-7.147 7.146z' /></svg>",
    shorthandCurrentMonth: false,
    showMonths: 1,
    static: false,
    time_24hr: false,
    weekNumbers: false,
    wrap: false,
};


/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return english; });
var english = {
    weekdays: {
        shorthand: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
        longhand: [
            "Sunday",
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday",
            "Saturday",
        ],
    },
    months: {
        shorthand: [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec",
        ],
        longhand: [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December",
        ],
    },
    daysInMonth: [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],
    firstDayOfWeek: 0,
    ordinal: function (nth) {
        var s = nth % 100;
        if (s > 3 && s < 21)
            return "th";
        switch (s % 10) {
            case 1:
                return "st";
            case 2:
                return "nd";
            case 3:
                return "rd";
            default:
                return "th";
        }
    },
    rangeSeparator: " to ",
    weekAbbreviation: "Wk",
    scrollTitle: "Scroll to increment",
    toggleTitle: "Click to toggle",
    amPM: ["AM", "PM"],
    yearAriaLabel: "Year",
    monthAriaLabel: "Month",
    hourAriaLabel: "Hour",
    minuteAriaLabel: "Minute",
    time_24hr: false,
};
/* harmony default export */ __webpack_exports__["a"] = (english);


/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return pad; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return int; });
/* harmony export (immutable) */ __webpack_exports__["b"] = debounce;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return arrayify; });
var pad = function (number, length) {
    if (length === void 0) { length = 2; }
    return ("000" + number).slice(length * -1);
};
var int = function (bool) { return (bool === true ? 1 : 0); };
function debounce(fn, wait) {
    var t;
    return function () {
        var _this = this;
        var args = arguments;
        clearTimeout(t);
        t = setTimeout(function () { return fn.apply(_this, args); }, wait);
    };
}
var arrayify = function (obj) {
    return obj instanceof Array ? obj : [obj];
};


/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return monthToStr; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return revFormat; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return tokenRegex; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return formats; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(53);

var doNothing = function () { return undefined; };
var monthToStr = function (monthNumber, shorthand, locale) { return locale.months[shorthand ? "shorthand" : "longhand"][monthNumber]; };
var revFormat = {
    D: doNothing,
    F: function (dateObj, monthName, locale) {
        dateObj.setMonth(locale.months.longhand.indexOf(monthName));
    },
    G: function (dateObj, hour) {
        dateObj.setHours((dateObj.getHours() >= 12 ? 12 : 0) + parseFloat(hour));
    },
    H: function (dateObj, hour) {
        dateObj.setHours(parseFloat(hour));
    },
    J: function (dateObj, day) {
        dateObj.setDate(parseFloat(day));
    },
    K: function (dateObj, amPM, locale) {
        dateObj.setHours((dateObj.getHours() % 12) +
            12 * Object(__WEBPACK_IMPORTED_MODULE_0__utils__["c" /* int */])(new RegExp(locale.amPM[1], "i").test(amPM)));
    },
    M: function (dateObj, shortMonth, locale) {
        dateObj.setMonth(locale.months.shorthand.indexOf(shortMonth));
    },
    S: function (dateObj, seconds) {
        dateObj.setSeconds(parseFloat(seconds));
    },
    U: function (_, unixSeconds) { return new Date(parseFloat(unixSeconds) * 1000); },
    W: function (dateObj, weekNum, locale) {
        var weekNumber = parseInt(weekNum);
        var date = new Date(dateObj.getFullYear(), 0, 2 + (weekNumber - 1) * 7, 0, 0, 0, 0);
        date.setDate(date.getDate() - date.getDay() + locale.firstDayOfWeek);
        return date;
    },
    Y: function (dateObj, year) {
        dateObj.setFullYear(parseFloat(year));
    },
    Z: function (_, ISODate) { return new Date(ISODate); },
    d: function (dateObj, day) {
        dateObj.setDate(parseFloat(day));
    },
    h: function (dateObj, hour) {
        dateObj.setHours((dateObj.getHours() >= 12 ? 12 : 0) + parseFloat(hour));
    },
    i: function (dateObj, minutes) {
        dateObj.setMinutes(parseFloat(minutes));
    },
    j: function (dateObj, day) {
        dateObj.setDate(parseFloat(day));
    },
    l: doNothing,
    m: function (dateObj, month) {
        dateObj.setMonth(parseFloat(month) - 1);
    },
    n: function (dateObj, month) {
        dateObj.setMonth(parseFloat(month) - 1);
    },
    s: function (dateObj, seconds) {
        dateObj.setSeconds(parseFloat(seconds));
    },
    u: function (_, unixMillSeconds) {
        return new Date(parseFloat(unixMillSeconds));
    },
    w: doNothing,
    y: function (dateObj, year) {
        dateObj.setFullYear(2000 + parseFloat(year));
    },
};
var tokenRegex = {
    D: "",
    F: "",
    G: "(\\d\\d|\\d)",
    H: "(\\d\\d|\\d)",
    J: "(\\d\\d|\\d)\\w+",
    K: "",
    M: "",
    S: "(\\d\\d|\\d)",
    U: "(.+)",
    W: "(\\d\\d|\\d)",
    Y: "(\\d{4})",
    Z: "(.+)",
    d: "(\\d\\d|\\d)",
    h: "(\\d\\d|\\d)",
    i: "(\\d\\d|\\d)",
    j: "(\\d\\d|\\d)",
    l: "",
    m: "(\\d\\d|\\d)",
    n: "(\\d\\d|\\d)",
    s: "(\\d\\d|\\d)",
    u: "(.+)",
    w: "(\\d\\d|\\d)",
    y: "(\\d{2})",
};
var formats = {
    Z: function (date) { return date.toISOString(); },
    D: function (date, locale, options) {
        return locale.weekdays.shorthand[formats.w(date, locale, options)];
    },
    F: function (date, locale, options) {
        return monthToStr(formats.n(date, locale, options) - 1, false, locale);
    },
    G: function (date, locale, options) {
        return Object(__WEBPACK_IMPORTED_MODULE_0__utils__["d" /* pad */])(formats.h(date, locale, options));
    },
    H: function (date) { return Object(__WEBPACK_IMPORTED_MODULE_0__utils__["d" /* pad */])(date.getHours()); },
    J: function (date, locale) {
        return locale.ordinal !== undefined
            ? date.getDate() + locale.ordinal(date.getDate())
            : date.getDate();
    },
    K: function (date, locale) { return locale.amPM[Object(__WEBPACK_IMPORTED_MODULE_0__utils__["c" /* int */])(date.getHours() > 11)]; },
    M: function (date, locale) {
        return monthToStr(date.getMonth(), true, locale);
    },
    S: function (date) { return Object(__WEBPACK_IMPORTED_MODULE_0__utils__["d" /* pad */])(date.getSeconds()); },
    U: function (date) { return date.getTime() / 1000; },
    W: function (date, _, options) {
        return options.getWeek(date);
    },
    Y: function (date) { return Object(__WEBPACK_IMPORTED_MODULE_0__utils__["d" /* pad */])(date.getFullYear(), 4); },
    d: function (date) { return Object(__WEBPACK_IMPORTED_MODULE_0__utils__["d" /* pad */])(date.getDate()); },
    h: function (date) { return (date.getHours() % 12 ? date.getHours() % 12 : 12); },
    i: function (date) { return Object(__WEBPACK_IMPORTED_MODULE_0__utils__["d" /* pad */])(date.getMinutes()); },
    j: function (date) { return date.getDate(); },
    l: function (date, locale) {
        return locale.weekdays.longhand[date.getDay()];
    },
    m: function (date) { return Object(__WEBPACK_IMPORTED_MODULE_0__utils__["d" /* pad */])(date.getMonth() + 1); },
    n: function (date) { return date.getMonth() + 1; },
    s: function (date) { return date.getSeconds(); },
    u: function (date) { return date.getTime(); },
    w: function (date) { return date.getDay(); },
    y: function (date) { return String(date.getFullYear()).substring(2); },
};


/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var skins_namespaceObject = {};
__webpack_require__.d(skins_namespaceObject, "AdvisorSummary", function() { return AdvisorSummary_AdvisorSummary; });
__webpack_require__.d(skins_namespaceObject, "Configurator", function() { return Configurator_Configurator; });
__webpack_require__.d(skins_namespaceObject, "ConfiguratorEnt", function() { return ConfiguratorEnt_ConfiguratorEnt; });
__webpack_require__.d(skins_namespaceObject, "DetailPage", function() { return DetailPage_DetailPage; });
__webpack_require__.d(skins_namespaceObject, "DetailPagePriceOrder", function() { return DetailPagePriceOrder_DetailPagePriceOrder; });
__webpack_require__.d(skins_namespaceObject, "DOCPCheckout", function() { return DOCPCheckout["a" /* DOCPCheckout */]; });
__webpack_require__.d(skins_namespaceObject, "Invisible", function() { return Invisible_Invisible; });

// EXTERNAL MODULE: ./node_modules/jspolyfill-array.prototype.find/find.js
var find = __webpack_require__(56);
var find_default = /*#__PURE__*/__webpack_require__.n(find);

// EXTERNAL MODULE: ./node_modules/promise-polyfill/src/index.js
var promise_polyfill_src = __webpack_require__(57);

// EXTERNAL MODULE: ./node_modules/url-polyfill/url-polyfill.js
var url_polyfill = __webpack_require__(61);
var url_polyfill_default = /*#__PURE__*/__webpack_require__.n(url_polyfill);

// CONCATENATED MODULE: ./clientlibs/js/bootstrap/polyfills.ts
/**
 * Polyfills for old browsers.
 *
 * Please remove each polyfill whose market share of browsers needing it drops below 1%
 */
// Array.prototype.find

// Math.sign (used in SDX ProgressFull)
if (!('sign' in Math)) {
    Math.sign = function (x) {
        return ((x > 0) - (x < 0)) || +x;
    };
}
// Number.isNaN for IE11 and older
// From  https://developer.mozilla.org/de/docs/Web/JavaScript/Reference/Global_Objects/Number/isNaN#Polyfill
if (!('isNaN' in Number)) {
    Number.isNaN = function (value) {
        // NaN is the only value in javascript which is not equal to itself.
        // tslint:disable-next-line: no-tautology-expression
        return value !== value;
    };
}
// String.startsWith for IE11 and friends
// From https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith#Polyfill
if (!('startsWith' in String.prototype)) {
    Object.defineProperty(String.prototype, 'startsWith', {
        configurable: true,
        value: function (search, pos) {
            search = String(search);
            var startIndex = (!pos || pos < 0) ? 0 : Number(pos);
            var endIndex = startIndex + search.length;
            return this.substring(startIndex, endIndex) === search;
        },
        writable: true,
    });
}
// Promise/A

// To add to window
if (!('Promise' in window)) {
    window.Promise = promise_polyfill_src["a" /* default */];
}
// URL and URLSearchParams

/* Some polyfills are explicitly loaded for certain libraries:
 * etc/designs/portal/clientlibs/shared/js/vendor/smooth-scroll.ts
 * // import 'element-closest';
 * // import 'custom-event-polyfill';
 * // import 'request-animation-frame-polyfill';
*/

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/portal/clientlibs/shared/js/vendor/jquery/jquery-ui.1.12.1.min.js
var jquery_ui_1_12_1_min = __webpack_require__(62);
var jquery_ui_1_12_1_min_default = /*#__PURE__*/__webpack_require__.n(jquery_ui_1_12_1_min);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/portal/clientlibs/shared/js/vendor/jquery/jquery-ui-multiselect-1.13.js
var jquery_ui_multiselect_1_13 = __webpack_require__(63);
var jquery_ui_multiselect_1_13_default = /*#__PURE__*/__webpack_require__.n(jquery_ui_multiselect_1_13);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/portal/clientlibs/shared/js/vendor/jquery/jquery-extensions.js
var jquery_extensions = __webpack_require__(64);
var jquery_extensions_default = /*#__PURE__*/__webpack_require__.n(jquery_extensions);

// EXTERNAL MODULE: ./clientlibs/js/bootstrap/load-qtip.ts
var load_qtip = __webpack_require__(33);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/portal/clientlibs/shared/js/vendor/jquery/jquery.customInput.js
var jquery_customInput = __webpack_require__(66);
var jquery_customInput_default = /*#__PURE__*/__webpack_require__.n(jquery_customInput);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/portal/clientlibs/shared/js/vendor/jquery/jquery.base64.min.js
var jquery_base64_min = __webpack_require__(67);
var jquery_base64_min_default = /*#__PURE__*/__webpack_require__.n(jquery_base64_min);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/portal/clientlibs/shared/js/vendor/jquery/jquery.placeholder.min.js
var jquery_placeholder_min = __webpack_require__(68);
var jquery_placeholder_min_default = /*#__PURE__*/__webpack_require__.n(jquery_placeholder_min);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/portal/clientlibs/shared/js/vendor/jquery.lazy.js
var jquery_lazy = __webpack_require__(69);
var jquery_lazy_default = /*#__PURE__*/__webpack_require__.n(jquery_lazy);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/portal/clientlibs/shared/js/vendor/jquery/jquery.colorbox-min.js
var jquery_colorbox_min = __webpack_require__(70);
var jquery_colorbox_min_default = /*#__PURE__*/__webpack_require__.n(jquery_colorbox_min);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/emagazine/clientlibs/publish/js/libs/jquery.slides.js
var jquery_slides = __webpack_require__(71);
var jquery_slides_default = /*#__PURE__*/__webpack_require__.n(jquery_slides);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/portal/clientlibs/shared/js/utils/font-detect.js
var font_detect = __webpack_require__(72);
var font_detect_default = /*#__PURE__*/__webpack_require__.n(font_detect);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/portal/clientlibs/shared/js/utils/jquery.distinct.js
var jquery_distinct = __webpack_require__(73);
var jquery_distinct_default = /*#__PURE__*/__webpack_require__.n(jquery_distinct);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/portal/clientlibs/shared/js/utils/jquery.showtomeasure.js
var jquery_showtomeasure = __webpack_require__(74);
var jquery_showtomeasure_default = /*#__PURE__*/__webpack_require__.n(jquery_showtomeasure);

// EXTERNAL MODULE: ./clientlibs/js/bootstrap/load-dot.ts
var load_dot = __webpack_require__(20);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/base/clientlibs/shared/js/SCS.Const.js
var SCS_Const = __webpack_require__(75);
var SCS_Const_default = /*#__PURE__*/__webpack_require__.n(SCS_Const);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/base/clientlibs/shared/vendor/ba-debug.min.js
var ba_debug_min = __webpack_require__(22);
var ba_debug_min_default = /*#__PURE__*/__webpack_require__.n(ba_debug_min);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/portal/clientlibs/shared/js/commons.js
var commons = __webpack_require__(76);
var commons_default = /*#__PURE__*/__webpack_require__.n(commons);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/portal/clientlibs/shared/js/carousel.js
var carousel = __webpack_require__(77);
var carousel_default = /*#__PURE__*/__webpack_require__.n(carousel);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/portal/clientlibs/shared/js/components/scene7player.js
var scene7player = __webpack_require__(78);
var scene7player_default = /*#__PURE__*/__webpack_require__.n(scene7player);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/portal/clientlibs/shared/js/dialog.js
var dialog = __webpack_require__(79);
var dialog_default = /*#__PURE__*/__webpack_require__.n(dialog);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/portal/clientlibs/shared/js/forms.js
var js_forms = __webpack_require__(80);
var forms_default = /*#__PURE__*/__webpack_require__.n(js_forms);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/portal/clientlibs/shared/js/sitecatalyst.js
var sitecatalyst = __webpack_require__(81);
var sitecatalyst_default = /*#__PURE__*/__webpack_require__.n(sitecatalyst);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/portal/clientlibs/shared/js/userfeedback.js
var userfeedback = __webpack_require__(82);
var userfeedback_default = /*#__PURE__*/__webpack_require__.n(userfeedback);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/portal/clientlibs/shared/js/forms_scsc.js
var forms_scsc = __webpack_require__(83);
var forms_scsc_default = /*#__PURE__*/__webpack_require__.n(forms_scsc);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/portal/clientlibs/shared/js/libraries/jquery.scs-custom-checkbox.js
var jquery_scs_custom_checkbox = __webpack_require__(84);
var jquery_scs_custom_checkbox_default = /*#__PURE__*/__webpack_require__.n(jquery_scs_custom_checkbox);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/base/clientlibs/shared/libraries/SCS.utils.js
var SCS_utils = __webpack_require__(34);
var SCS_utils_default = /*#__PURE__*/__webpack_require__.n(SCS_utils);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/portal/clientlibs/shared/js/libraries/SCS.PeakProtect.js
var SCS_PeakProtect = __webpack_require__(86);
var SCS_PeakProtect_default = /*#__PURE__*/__webpack_require__.n(SCS_PeakProtect);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/base/clientlibs/shared/libraries/tv/SCS.TV.js
var SCS_TV = __webpack_require__(87);
var SCS_TV_default = /*#__PURE__*/__webpack_require__.n(SCS_TV);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/base/clientlibs/shared/libraries/tv/SCS.TV.Broadcast.js
var SCS_TV_Broadcast = __webpack_require__(88);
var SCS_TV_Broadcast_default = /*#__PURE__*/__webpack_require__.n(SCS_TV_Broadcast);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/base/clientlibs/shared/libraries/tv/SCS.TV.Channel.js
var SCS_TV_Channel = __webpack_require__(89);
var SCS_TV_Channel_default = /*#__PURE__*/__webpack_require__.n(SCS_TV_Channel);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/base/clientlibs/shared/libraries/tv/SCS.TV.Helper.js
var SCS_TV_Helper = __webpack_require__(90);
var SCS_TV_Helper_default = /*#__PURE__*/__webpack_require__.n(SCS_TV_Helper);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/base/clientlibs/shared/libraries/tv/SCS.TV.Movie.js
var SCS_TV_Movie = __webpack_require__(91);
var SCS_TV_Movie_default = /*#__PURE__*/__webpack_require__.n(SCS_TV_Movie);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/base/clientlibs/shared/libraries/tv/SCS.TV.SportEvent.js
var SCS_TV_SportEvent = __webpack_require__(92);
var SCS_TV_SportEvent_default = /*#__PURE__*/__webpack_require__.n(SCS_TV_SportEvent);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/base/clientlibs/shared/libraries/SCS.SportEvents.js
var SCS_SportEvents = __webpack_require__(93);
var SCS_SportEvents_default = /*#__PURE__*/__webpack_require__.n(SCS_SportEvents);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/base/clientlibs/shared/libraries/SCS.SportEvents.Event.js
var SCS_SportEvents_Event = __webpack_require__(94);
var SCS_SportEvents_Event_default = /*#__PURE__*/__webpack_require__.n(SCS_SportEvents_Event);

// CONCATENATED MODULE: ./clientlibs/js/by-category/scs.portal.libs.ts
// # -----------------------------------------------------------------------------
// # LIBS
// # -----------------------------------------------------------------------------
// #
// # Use this client lib to include code to mobile and desktop libs
// # (if they are not used in the header)
// # -----------------------------------------------------------------------------
// #base=/etc/designs/portal/clientlibs
// jQuery UI


// # namespace

// # jQuery Plugins










// # Other

// # Global Constants

// # debug is a wrapper for console (console.log, console.warn, console.dir, etc.)

// # Swisscom Libs











// # TV Libs









// EXTERNAL MODULE: ./clientlibs/js/etc/designs/header/clientlibs/desktop/js/vendor/jquery/jcookie.js
var jcookie = __webpack_require__(95);
var jcookie_default = /*#__PURE__*/__webpack_require__.n(jcookie);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/header/clientlibs/desktop/js/vendor/dateformat.js
var dateformat = __webpack_require__(96);
var dateformat_default = /*#__PURE__*/__webpack_require__.n(dateformat);

// EXTERNAL MODULE: ./clientlibs/js/lib/header/Tc.Module.HeaderLvl2.ts
var Tc_Module_HeaderLvl2 = __webpack_require__(97);

// EXTERNAL MODULE: ./clientlibs/js/lib/header/Tc.Module.MDD.ts
var Tc_Module_MDD = __webpack_require__(98);

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(2);

// EXTERNAL MODULE: ./clientlibs/js/lib/vendor/terrific/Module.ts
var Module = __webpack_require__(3);

// EXTERNAL MODULE: ./clientlibs/js/lib/personalization/profile.ts
var personalization_profile = __webpack_require__(5);

// CONCATENATED MODULE: ./clientlibs/js/lib/header/Tc.Module.SharedHeader.ts



/**
 * Support for shared header on PORTAL.
 *
 * @author Nikola Tica
 * @class SharedHeader
 * @extends Tc.Module
 */
var Tc_Module_SharedHeader_SharedHeader = /** @class */ (function (_super) {
    Object(tslib_es6["c" /* __extends */])(SharedHeader, _super);
    function SharedHeader() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SharedHeader.prototype.on = function (callback) {
        var _this = this;
        this.$scsHeader = this.$ctx.find('scs-header');
        this.$scsHeader.on('languageChanged', function (evt) {
            var url = _this.$ctx.data('language-links')["" + evt.detail];
            location.assign(url);
        });
        callback();
    };
    SharedHeader.prototype.after = function () {
        return Object(tslib_es6["b" /* __awaiter */])(this, void 0, void 0, function () {
            var user;
            return Object(tslib_es6["d" /* __generator */])(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Object(personalization_profile["getProfile"])()];
                    case 1:
                        user = (_a.sent()).getUser();
                        this.initHeaderAttributes(user);
                        return [2 /*return*/];
                }
            });
        });
    };
    SharedHeader.prototype.initHeaderAttributes = function (user) {
        if (user) {
            this.$scsHeader.attr('customer-segment', user.getSegment());
            this.$scsHeader.attr('user-lastname', user.getLastName());
            this.$scsHeader.attr('user-firstname', user.getFirstName());
            this.$scsHeader.attr('scn', user.getId());
        }
        var $lvl1 = this.$scsHeader.find('scs-header-l1');
        // Prevent shared header to display login button until user data are fetch
        $lvl1.attr('show-login', String(!!this.$ctx.data('showLogin')));
        // Allow the shared header to initialize its basket only after we have set the user’s SCN (if any)
        // Avoids querying the basket API twice
        $lvl1.attr('show-basket', String(!!this.$ctx.data('showBasket')));
    };
    return SharedHeader;
}(Module["a" /* Module */]));
/* harmony default export */ var Tc_Module_SharedHeader = (Tc_Module_SharedHeader_SharedHeader);

// EXTERNAL MODULE: ./clientlibs/js/bootstrap/load-terrific.ts + 5 modules
var load_terrific = __webpack_require__(1);

// CONCATENATED MODULE: ./clientlibs/js/by-category/scs.header.shared.ts
// base=/etc/designs/header/clientlibs/desktop/js
// -----------------------------------------------------------------------------
// TERRIFIC MODULES - A-Z PLEASE
// -----------------------------------------------------------------------------
// Modern modules (using imports/exports)



var modernTcModules = {
    HeaderLvl2: Tc_Module_HeaderLvl2["a" /* default */],
    MDD: Tc_Module_MDD["a" /* default */],
    SharedHeader: Tc_Module_SharedHeader,
};
// Tc Bootstrap

Object(load_terrific["legacyBootstrapDeferredSingleton"])(modernTcModules);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/header/clientlibs/desktop/js/general.js
var general = __webpack_require__(100);
var general_default = /*#__PURE__*/__webpack_require__.n(general);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/header/clientlibs/desktop/js/topnav.js
var topnav = __webpack_require__(101);
var topnav_default = /*#__PURE__*/__webpack_require__.n(topnav);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/header/clientlibs/desktop/js/metanav.js
var metanav = __webpack_require__(102);
var metanav_default = /*#__PURE__*/__webpack_require__.n(metanav);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/header/clientlibs/desktop/js/footer.js
var footer = __webpack_require__(103);
var footer_default = /*#__PURE__*/__webpack_require__.n(footer);

// CONCATENATED MODULE: ./clientlibs/js/by-category/scs.header.ts
// base=/etc/designs/header/clientlibs/desktop/js
/**
 * Legacy Header
 *  - will be replaced by the Responsive Header
 */
// -----------------------------------------------------------------------------
// VENDOR CODE
// -----------------------------------------------------------------------------


// -----------------------------------------------------------------------------
// SWISSCOM CODE
// -----------------------------------------------------------------------------





// -----------------------------------------------------------------------------
// TERRIFIC MODULES - A-Z PLEASE
// -----------------------------------------------------------------------------
// Modern modules (using imports/exports)
var scs_header_modernTcModules = {};
// Tc Bootstrap

Object(load_terrific["legacyBootstrapDeferredSingleton"])(scs_header_modernTcModules);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/portal/clientlibs/desktop/js/vendor/jquery/jquery.tmpl.min.js
var jquery_tmpl_min = __webpack_require__(104);
var jquery_tmpl_min_default = /*#__PURE__*/__webpack_require__.n(jquery_tmpl_min);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/base/clientlibs/shared/vendor/jquery.cookies.2.2.0.min.js
var jquery_cookies_2_2_0_min = __webpack_require__(35);
var jquery_cookies_2_2_0_min_default = /*#__PURE__*/__webpack_require__.n(jquery_cookies_2_2_0_min);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/portal/clientlibs/desktop/js/vendor/jquery.tablesorter.js
var jquery_tablesorter = __webpack_require__(105);
var jquery_tablesorter_default = /*#__PURE__*/__webpack_require__.n(jquery_tablesorter);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/portal/clientlibs/desktop/js/vendor/jquery.transit.min.js
var jquery_transit_min = __webpack_require__(106);
var jquery_transit_min_default = /*#__PURE__*/__webpack_require__.n(jquery_transit_min);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/portal/clientlibs/desktop/js/vendor/jwplayer.js
var jwplayer = __webpack_require__(107);
var jwplayer_default = /*#__PURE__*/__webpack_require__.n(jwplayer);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/portal/clientlibs/desktop/js/dialog.js
var js_dialog = __webpack_require__(108);
var js_dialog_default = /*#__PURE__*/__webpack_require__.n(js_dialog);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/portal/clientlibs/desktop/js/mediaplayer.js
var mediaplayer = __webpack_require__(109);
var mediaplayer_default = /*#__PURE__*/__webpack_require__.n(mediaplayer);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/portal/clientlibs/desktop/js/videoteasercomp.js
var videoteasercomp = __webpack_require__(110);
var videoteasercomp_default = /*#__PURE__*/__webpack_require__.n(videoteasercomp);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/portal/clientlibs/desktop/js/tracking.js
var tracking = __webpack_require__(111);
var tracking_default = /*#__PURE__*/__webpack_require__.n(tracking);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/base/clientlibs/shared/libraries/SCS.Url.js
var SCS_Url = __webpack_require__(21);
var SCS_Url_default = /*#__PURE__*/__webpack_require__.n(SCS_Url);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/portal/clientlibs/desktop/js/common.js
var common = __webpack_require__(112);
var common_default = /*#__PURE__*/__webpack_require__.n(common);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/portal/clientlibs/desktop/js/scCarousel.js
var scCarousel = __webpack_require__(113);
var scCarousel_default = /*#__PURE__*/__webpack_require__.n(scCarousel);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/portal/clientlibs/desktop/js/contactwizard.js
var contactwizard = __webpack_require__(114);
var contactwizard_default = /*#__PURE__*/__webpack_require__.n(contactwizard);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/portal/clientlibs/desktop/js/expertchat.js
var expertchat = __webpack_require__(115);
var expertchat_default = /*#__PURE__*/__webpack_require__.n(expertchat);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/portal/clientlibs/desktop/js/lightbox.js
var lightbox = __webpack_require__(116);
var lightbox_default = /*#__PURE__*/__webpack_require__.n(lightbox);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/portal/clientlibs/desktop/js/supportstrip.js
var supportstrip = __webpack_require__(117);
var supportstrip_default = /*#__PURE__*/__webpack_require__.n(supportstrip);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/portal/clientlibs/desktop/js/fullbleed.js
var fullbleed = __webpack_require__(118);
var fullbleed_default = /*#__PURE__*/__webpack_require__.n(fullbleed);

// EXTERNAL MODULE: ./clientlibs/js/bootstrap/sdx-modal.ts
var sdx_modal = __webpack_require__(119);

// EXTERNAL MODULE: external "(window._g && _g.$) || window.$CQ || window.$ || window.jQuery"
var external___window__g_____g_$_____window_$CQ____window_$____window_jQuery_ = __webpack_require__(0);
var external___window__g_____g_$_____window_$CQ____window_$____window_jQuery__default = /*#__PURE__*/__webpack_require__.n(external___window__g_____g_$_____window_$CQ____window_$____window_jQuery_);

// EXTERNAL MODULE: ./node_modules/element-closest/element-closest.js
var element_closest = __webpack_require__(122);
var element_closest_default = /*#__PURE__*/__webpack_require__.n(element_closest);

// EXTERNAL MODULE: ./node_modules/custom-event-polyfill/polyfill.js
var polyfill = __webpack_require__(123);
var polyfill_default = /*#__PURE__*/__webpack_require__.n(polyfill);

// EXTERNAL MODULE: ./node_modules/request-animation-frame-polyfill/index.js
var request_animation_frame_polyfill = __webpack_require__(124);
var request_animation_frame_polyfill_default = /*#__PURE__*/__webpack_require__.n(request_animation_frame_polyfill);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/portal/clientlibs/shared/js/vendor/smooth-scroll.js
var smooth_scroll = __webpack_require__(125);
var smooth_scroll_default = /*#__PURE__*/__webpack_require__.n(smooth_scroll);

// CONCATENATED MODULE: ./clientlibs/js/bootstrap/smooth-scroll.ts

// Element.prototype.closest

// Polyfill global CustomEvent

// Polyfill global requestAnimationFrame

// Import javascript library via AMD loader

external___window__g_____g_$_____window_$CQ____window_$____window_jQuery__default()(function () {
    // Only init if data-flag is set on body tag
    if (external___window__g_____g_$_____window_$CQ____window_$____window_jQuery__default()('BODY').data('is-smooth-anchor-enabled')) {
        /* tslint:disable-next-line:no-unused-expression */
        new smooth_scroll_default.a('a[href*="#"]', {
            crisisHeader: '.crisis',
            emitEvents: false,
            header: '.scsh-dynamic, .modSharedHeader',
        });
    }
});

// EXTERNAL MODULE: ./clientlibs/js/bootstrap/textcutter.ts
var textcutter = __webpack_require__(126);
var textcutter_default = /*#__PURE__*/__webpack_require__.n(textcutter);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/portal/clientlibs/shared/js/modules/Tc.Module.Accordion.js
var Tc_Module_Accordion = __webpack_require__(127);
var Tc_Module_Accordion_default = /*#__PURE__*/__webpack_require__.n(Tc_Module_Accordion);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/portal/clientlibs/shared/js/modules/Tc.Module.Accordion.SingleMode.js
var Tc_Module_Accordion_SingleMode = __webpack_require__(128);
var Tc_Module_Accordion_SingleMode_default = /*#__PURE__*/__webpack_require__.n(Tc_Module_Accordion_SingleMode);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/portal/clientlibs/shared/js/modules/Tc.Module.Accordion.FullBleed.js
var Tc_Module_Accordion_FullBleed = __webpack_require__(129);
var Tc_Module_Accordion_FullBleed_default = /*#__PURE__*/__webpack_require__.n(Tc_Module_Accordion_FullBleed);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/portal/clientlibs/shared/js/modules/Tc.Module.BackgroundContainer.js
var Tc_Module_BackgroundContainer = __webpack_require__(130);
var Tc_Module_BackgroundContainer_default = /*#__PURE__*/__webpack_require__.n(Tc_Module_BackgroundContainer);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/portal/clientlibs/desktop/js/modules/Tc.Module.BrightcoveOverlay.js
var Tc_Module_BrightcoveOverlay = __webpack_require__(131);
var Tc_Module_BrightcoveOverlay_default = /*#__PURE__*/__webpack_require__.n(Tc_Module_BrightcoveOverlay);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/portal/clientlibs/desktop/js/modules/Tc.Module.ContactCollapsable.js
var Tc_Module_ContactCollapsable = __webpack_require__(132);
var Tc_Module_ContactCollapsable_default = /*#__PURE__*/__webpack_require__.n(Tc_Module_ContactCollapsable);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/portal/clientlibs/shared/js/modules/Tc.Module.CallOutSdx.js
var Tc_Module_CallOutSdx = __webpack_require__(133);
var Tc_Module_CallOutSdx_default = /*#__PURE__*/__webpack_require__.n(Tc_Module_CallOutSdx);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/portal/clientlibs/shared/js/modules/Tc.Module.Card.js
var Tc_Module_Card = __webpack_require__(134);
var Tc_Module_Card_default = /*#__PURE__*/__webpack_require__.n(Tc_Module_Card);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/portal/clientlibs/shared/js/modules/Tc.Module.CookieOptOut.js
var Tc_Module_CookieOptOut = __webpack_require__(135);
var Tc_Module_CookieOptOut_default = /*#__PURE__*/__webpack_require__.n(Tc_Module_CookieOptOut);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/base/clientlibs/shared/js/modules/Tc.Module.DeviceSwitch.js
var Tc_Module_DeviceSwitch = __webpack_require__(136);
var Tc_Module_DeviceSwitch_default = /*#__PURE__*/__webpack_require__.n(Tc_Module_DeviceSwitch);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/portal/clientlibs/desktop/js/modules/Tc.Module.DynamicSupport.js
var Tc_Module_DynamicSupport = __webpack_require__(137);
var Tc_Module_DynamicSupport_default = /*#__PURE__*/__webpack_require__.n(Tc_Module_DynamicSupport);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/portal/clientlibs/shared/js/modules/Tc.Module.DmisDlc.js
var Tc_Module_DmisDlc = __webpack_require__(138);
var Tc_Module_DmisDlc_default = /*#__PURE__*/__webpack_require__.n(Tc_Module_DmisDlc);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/portal/clientlibs/shared/js/modules/Tc.Module.EloquaLP.js
var Tc_Module_EloquaLP = __webpack_require__(139);
var Tc_Module_EloquaLP_default = /*#__PURE__*/__webpack_require__.n(Tc_Module_EloquaLP);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/portal/clientlibs/shared/js/modules/Tc.Module.EndlessScrollList.js
var Tc_Module_EndlessScrollList = __webpack_require__(140);
var Tc_Module_EndlessScrollList_default = /*#__PURE__*/__webpack_require__.n(Tc_Module_EndlessScrollList);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/portal/clientlibs/shared/js/modules/Tc.Module.ExpandableContainer.js
var Tc_Module_ExpandableContainer = __webpack_require__(141);
var Tc_Module_ExpandableContainer_default = /*#__PURE__*/__webpack_require__.n(Tc_Module_ExpandableContainer);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/portal/clientlibs/shared/js/modules/Tc.Module.Glossary.js
var Tc_Module_Glossary = __webpack_require__(142);
var Tc_Module_Glossary_default = /*#__PURE__*/__webpack_require__.n(Tc_Module_Glossary);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/portal/clientlibs/desktop/js/modules/Tc.Module.GridLayout.js
var Tc_Module_GridLayout = __webpack_require__(143);
var Tc_Module_GridLayout_default = /*#__PURE__*/__webpack_require__.n(Tc_Module_GridLayout);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/portal/clientlibs/shared/js/modules/Tc.Module.GhqPressReleaseSearch.js
var Tc_Module_GhqPressReleaseSearch = __webpack_require__(144);
var Tc_Module_GhqPressReleaseSearch_default = /*#__PURE__*/__webpack_require__.n(Tc_Module_GhqPressReleaseSearch);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/portal/clientlibs/shared/js/modules/Tc.Module.HoverContainer.js
var Tc_Module_HoverContainer = __webpack_require__(145);
var Tc_Module_HoverContainer_default = /*#__PURE__*/__webpack_require__.n(Tc_Module_HoverContainer);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/portal/clientlibs/desktop/js/modules/Tc.Module.ImageMapContainer.js
var Tc_Module_ImageMapContainer = __webpack_require__(146);
var Tc_Module_ImageMapContainer_default = /*#__PURE__*/__webpack_require__.n(Tc_Module_ImageMapContainer);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/portal/clientlibs/desktop/js/modules/Tc.Module.ImageMapItem.js
var Tc_Module_ImageMapItem = __webpack_require__(147);
var Tc_Module_ImageMapItem_default = /*#__PURE__*/__webpack_require__.n(Tc_Module_ImageMapItem);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/portal/clientlibs/shared/js/modules/Tc.Module.ImagesSlider.js
var Tc_Module_ImagesSlider = __webpack_require__(148);
var Tc_Module_ImagesSlider_default = /*#__PURE__*/__webpack_require__.n(Tc_Module_ImagesSlider);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/portal/clientlibs/desktop/js/modules/Tc.Module.InfoTeaserContainer.js
var Tc_Module_InfoTeaserContainer = __webpack_require__(149);
var Tc_Module_InfoTeaserContainer_default = /*#__PURE__*/__webpack_require__.n(Tc_Module_InfoTeaserContainer);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/portal/clientlibs/shared/js/modules/Tc.Module.LazyContainer.js
var Tc_Module_LazyContainer = __webpack_require__(150);
var Tc_Module_LazyContainer_default = /*#__PURE__*/__webpack_require__.n(Tc_Module_LazyContainer);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/portal/clientlibs/shared/js/modules/Tc.Module.LoadingBar.js
var Tc_Module_LoadingBar = __webpack_require__(151);
var Tc_Module_LoadingBar_default = /*#__PURE__*/__webpack_require__.n(Tc_Module_LoadingBar);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/portal/clientlibs/shared/js/modules/Tc.Module.LoadingIndicator.js
var Tc_Module_LoadingIndicator = __webpack_require__(153);
var Tc_Module_LoadingIndicator_default = /*#__PURE__*/__webpack_require__.n(Tc_Module_LoadingIndicator);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/portal/clientlibs/shared/js/modules/Tc.Module.MultiDropdown.js
var Tc_Module_MultiDropdown = __webpack_require__(154);
var Tc_Module_MultiDropdown_default = /*#__PURE__*/__webpack_require__.n(Tc_Module_MultiDropdown);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/portal/clientlibs/shared/js/modules/Tc.Module.MultiDropdownFilterList.js
var Tc_Module_MultiDropdownFilterList = __webpack_require__(155);
var Tc_Module_MultiDropdownFilterList_default = /*#__PURE__*/__webpack_require__.n(Tc_Module_MultiDropdownFilterList);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/portal/clientlibs/shared/js/modules/Tc.Module.NewsTicker.js
var Tc_Module_NewsTicker = __webpack_require__(156);
var Tc_Module_NewsTicker_default = /*#__PURE__*/__webpack_require__.n(Tc_Module_NewsTicker);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/portal/clientlibs/shared/js/modules/Tc.Module.PageBackground.js
var Tc_Module_PageBackground = __webpack_require__(157);
var Tc_Module_PageBackground_default = /*#__PURE__*/__webpack_require__.n(Tc_Module_PageBackground);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/portal/clientlibs/shared/js/modules/Tc.Module.PersonalizationContainer.js
var Tc_Module_PersonalizationContainer = __webpack_require__(158);
var Tc_Module_PersonalizationContainer_default = /*#__PURE__*/__webpack_require__.n(Tc_Module_PersonalizationContainer);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/portal/clientlibs/shared/js/modules/Tc.Module.PexArticleList.js
var Tc_Module_PexArticleList = __webpack_require__(159);
var Tc_Module_PexArticleList_default = /*#__PURE__*/__webpack_require__.n(Tc_Module_PexArticleList);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/portal/clientlibs/shared/js/modules/Tc.Module.PexCustomerList.js
var Tc_Module_PexCustomerList = __webpack_require__(160);
var Tc_Module_PexCustomerList_default = /*#__PURE__*/__webpack_require__.n(Tc_Module_PexCustomerList);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/portal/clientlibs/shared/js/modules/Tc.Module.PexDocumentList.js
var Tc_Module_PexDocumentList = __webpack_require__(162);
var Tc_Module_PexDocumentList_default = /*#__PURE__*/__webpack_require__.n(Tc_Module_PexDocumentList);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/portal/clientlibs/shared/js/modules/Tc.Module.PexMyStatus.js
var Tc_Module_PexMyStatus = __webpack_require__(163);
var Tc_Module_PexMyStatus_default = /*#__PURE__*/__webpack_require__.n(Tc_Module_PexMyStatus);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/portal/clientlibs/shared/js/modules/Tc.Module.PexFavoriteList.js
var Tc_Module_PexFavoriteList = __webpack_require__(164);
var Tc_Module_PexFavoriteList_default = /*#__PURE__*/__webpack_require__.n(Tc_Module_PexFavoriteList);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/portal/clientlibs/shared/js/modules/Tc.Module.PriceOrderContainer.js
var Tc_Module_PriceOrderContainer = __webpack_require__(165);
var Tc_Module_PriceOrderContainer_default = /*#__PURE__*/__webpack_require__.n(Tc_Module_PriceOrderContainer);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/portal/clientlibs/desktop/js/modules/Tc.Module.ProductOfferPreviews.js
var Tc_Module_ProductOfferPreviews = __webpack_require__(171);
var Tc_Module_ProductOfferPreviews_default = /*#__PURE__*/__webpack_require__.n(Tc_Module_ProductOfferPreviews);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/portal/clientlibs/shared/js/modules/Tc.Module.PromoBadge.js
var Tc_Module_PromoBadge = __webpack_require__(172);
var Tc_Module_PromoBadge_default = /*#__PURE__*/__webpack_require__.n(Tc_Module_PromoBadge);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/portal/clientlibs/desktop/js/modules/Tc.Module.PromoLabel.js
var Tc_Module_PromoLabel = __webpack_require__(173);
var Tc_Module_PromoLabel_default = /*#__PURE__*/__webpack_require__.n(Tc_Module_PromoLabel);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/portal/clientlibs/shared/js/modules/Tc.Module.RatingForm.js
var Tc_Module_RatingForm = __webpack_require__(174);
var Tc_Module_RatingForm_default = /*#__PURE__*/__webpack_require__.n(Tc_Module_RatingForm);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/portal/clientlibs/shared/js/modules/Tc.Module.RatingStars.js
var Tc_Module_RatingStars = __webpack_require__(175);
var Tc_Module_RatingStars_default = /*#__PURE__*/__webpack_require__.n(Tc_Module_RatingStars);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/portal/clientlibs/shared/js/modules/Tc.Module.Richtext.js
var Tc_Module_Richtext = __webpack_require__(176);
var Tc_Module_Richtext_default = /*#__PURE__*/__webpack_require__.n(Tc_Module_Richtext);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/portal/clientlibs/shared/js/modules/Tc.Module.RoamingTariff.js
var Tc_Module_RoamingTariff = __webpack_require__(177);
var Tc_Module_RoamingTariff_default = /*#__PURE__*/__webpack_require__.n(Tc_Module_RoamingTariff);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/portal/clientlibs/desktop/js/modules/Tc.Module.Scene7.js
var Tc_Module_Scene7 = __webpack_require__(178);
var Tc_Module_Scene7_default = /*#__PURE__*/__webpack_require__.n(Tc_Module_Scene7);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/portal/clientlibs/shared/js/modules/Tc.Module.Scene7Stage.js
var Tc_Module_Scene7Stage = __webpack_require__(179);
var Tc_Module_Scene7Stage_default = /*#__PURE__*/__webpack_require__.n(Tc_Module_Scene7Stage);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/portal/clientlibs/shared/js/modules/Tc.Module.ScFormArchive.js
var Tc_Module_ScFormArchive = __webpack_require__(180);
var Tc_Module_ScFormArchive_default = /*#__PURE__*/__webpack_require__.n(Tc_Module_ScFormArchive);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/portal/clientlibs/shared/js/modules/Tc.Module.ScNewsletter.js
var Tc_Module_ScNewsletter = __webpack_require__(181);
var Tc_Module_ScNewsletter_default = /*#__PURE__*/__webpack_require__.n(Tc_Module_ScNewsletter);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/portal/clientlibs/shared/js/modules/Tc.Module.SmoToken.js
var Tc_Module_SmoToken = __webpack_require__(182);
var Tc_Module_SmoToken_default = /*#__PURE__*/__webpack_require__.n(Tc_Module_SmoToken);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/base/clientlibs/shared/js/modules/Tc.Module.SocialShare.js
var Tc_Module_SocialShare = __webpack_require__(183);
var Tc_Module_SocialShare_default = /*#__PURE__*/__webpack_require__.n(Tc_Module_SocialShare);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/portal/clientlibs/desktop/js/modules/Tc.Module.StageCarousel.js
var Tc_Module_StageCarousel = __webpack_require__(184);
var Tc_Module_StageCarousel_default = /*#__PURE__*/__webpack_require__.n(Tc_Module_StageCarousel);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/portal/clientlibs/desktop/js/modules/Tc.Module.SupportAgentStatus.js
var Tc_Module_SupportAgentStatus = __webpack_require__(185);
var Tc_Module_SupportAgentStatus_default = /*#__PURE__*/__webpack_require__.n(Tc_Module_SupportAgentStatus);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/portal/clientlibs/shared/js/modules/Tc.Module.TableSorter.js
var Tc_Module_TableSorter = __webpack_require__(186);
var Tc_Module_TableSorter_default = /*#__PURE__*/__webpack_require__.n(Tc_Module_TableSorter);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/portal/clientlibs/shared/js/modules/Tc.Module.TableSorter.DirectOrderFilter.js
var Tc_Module_TableSorter_DirectOrderFilter = __webpack_require__(187);
var Tc_Module_TableSorter_DirectOrderFilter_default = /*#__PURE__*/__webpack_require__.n(Tc_Module_TableSorter_DirectOrderFilter);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/portal/clientlibs/shared/js/modules/Tc.Module.TabNavigation.js
var Tc_Module_TabNavigation = __webpack_require__(188);
var Tc_Module_TabNavigation_default = /*#__PURE__*/__webpack_require__.n(Tc_Module_TabNavigation);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/portal/clientlibs/shared/js/modules/Tc.Module.TabNavigation.DeprecatedTabs.js
var Tc_Module_TabNavigation_DeprecatedTabs = __webpack_require__(189);
var Tc_Module_TabNavigation_DeprecatedTabs_default = /*#__PURE__*/__webpack_require__.n(Tc_Module_TabNavigation_DeprecatedTabs);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/portal/clientlibs/shared/js/modules/Tc.Module.TabNavigationContent.js
var Tc_Module_TabNavigationContent = __webpack_require__(190);
var Tc_Module_TabNavigationContent_default = /*#__PURE__*/__webpack_require__.n(Tc_Module_TabNavigationContent);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/portal/clientlibs/shared/js/modules/Tc.Module.TabNavigationSharedContent.js
var Tc_Module_TabNavigationSharedContent = __webpack_require__(191);
var Tc_Module_TabNavigationSharedContent_default = /*#__PURE__*/__webpack_require__.n(Tc_Module_TabNavigationSharedContent);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/portal/clientlibs/shared/js/modules/Tc.Module.Tabs.js
var Tc_Module_Tabs = __webpack_require__(192);
var Tc_Module_Tabs_default = /*#__PURE__*/__webpack_require__.n(Tc_Module_Tabs);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/portal/clientlibs/shared/js/modules/Tc.Module.Tabs.StaticallyLinkedTabs.js
var Tc_Module_Tabs_StaticallyLinkedTabs = __webpack_require__(193);
var Tc_Module_Tabs_StaticallyLinkedTabs_default = /*#__PURE__*/__webpack_require__.n(Tc_Module_Tabs_StaticallyLinkedTabs);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/portal/clientlibs/shared/js/modules/Tc.Module.TileOrderStatus.js
var Tc_Module_TileOrderStatus = __webpack_require__(194);
var Tc_Module_TileOrderStatus_default = /*#__PURE__*/__webpack_require__.n(Tc_Module_TileOrderStatus);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/portal/clientlibs/desktop/js/modules/Tc.Module.Timeline.js
var Tc_Module_Timeline = __webpack_require__(195);
var Tc_Module_Timeline_default = /*#__PURE__*/__webpack_require__.n(Tc_Module_Timeline);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/portal/clientlibs/desktop/js/modules/Tc.Module.UserFeedback.js
var Tc_Module_UserFeedback = __webpack_require__(196);
var Tc_Module_UserFeedback_default = /*#__PURE__*/__webpack_require__.n(Tc_Module_UserFeedback);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/portal/clientlibs/shared/js/modules/Tc.Module.Wireline.js
var Tc_Module_Wireline = __webpack_require__(197);
var Tc_Module_Wireline_default = /*#__PURE__*/__webpack_require__.n(Tc_Module_Wireline);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/portal/clientlibs/shared/js/modules/Tc.Module.DownloadPDF.js
var Tc_Module_DownloadPDF = __webpack_require__(198);
var Tc_Module_DownloadPDF_default = /*#__PURE__*/__webpack_require__.n(Tc_Module_DownloadPDF);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/portal/clientlibs/desktop/js/modules/newrepair/Tc.Module.CaseSelection.js
var Tc_Module_CaseSelection = __webpack_require__(199);
var Tc_Module_CaseSelection_default = /*#__PURE__*/__webpack_require__.n(Tc_Module_CaseSelection);

// CONCATENATED MODULE: ./clientlibs/js/lib/sdx/Tc.Module.Button.ts



var CSS_CLASS_IS_HIDDEN = 'is-hidden';
var EVENT_TYPE_CLICK = 'click';
var DATA_ATTR_TRIGGER_VCC = 'trigger-vcc';
var DATA_ATTR_ELEMENT_VALUE = 'element-value';
var DATA_ATTR_ELEMENT_NAME = 'element-name';
var DATA_ATTR_HIDE_BUTTON = 'hide-button';
/**
 * Button module implementation.
 *
 * @author Nikola Tica
 * @class Button
 * @extends Tc.Module
 */
var Tc_Module_Button_Button = /** @class */ (function (_super) {
    Object(tslib_es6["c" /* __extends */])(Button, _super);
    function Button() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Hook function to do all of your module stuff.
     *
     * @method on
     * @param  {Hook} callback Callback function
     * @return void
     */
    Button.prototype.on = function (callback) {
        var _this = this;
        this.$button = this.$ctx.find('.button');
        this.triggerVCC = !!this.$ctx.data(DATA_ATTR_TRIGGER_VCC);
        this.controlElementValue = this.$ctx.data(DATA_ATTR_ELEMENT_VALUE);
        this.hideButtonAfterTrigger = !!this.$ctx.data(DATA_ATTR_HIDE_BUTTON);
        this.controleElementName = this.$ctx.data(DATA_ATTR_ELEMENT_NAME);
        this.$controleElement = external___window__g_____g_$_____window_$CQ____window_$____window_jQuery_("[name=" + this.controleElementName + "]");
        if (this.triggerVCC) {
            this.$button.on(EVENT_TYPE_CLICK, this.triggerVcc.bind(this));
        }
        if (this.$ctx[0].nodeName.toLowerCase() === 'sdx-button') {
            this.$ctx.on('click', function () { return SCS.portal.datalayer.trackEvent(_this.$ctx.data('track-action'), _this.$ctx.data('track-label'), _this.$ctx.data('track-location'), _this.$ctx.data('track-category')); });
        }
        callback();
    };
    Button.prototype.triggerVcc = function () {
        this.$controleElement.val(this.controlElementValue);
        this.$controleElement.trigger('change');
        if (this.hideButtonAfterTrigger) {
            this.hideButton();
        }
    };
    Button.prototype.hideButton = function () {
        this.$button.addClass(CSS_CLASS_IS_HIDDEN);
    };
    return Button;
}(Module["a" /* Module */]));
/* harmony default export */ var Tc_Module_Button = (Tc_Module_Button_Button);

// CONCATENATED MODULE: ./clientlibs/js/lib/cosmos/functions.ts
/**
 * This function sorts topics and subtopics, saves total subtopics number and
 * adds order number to each subtopic.
 *
 * @function prepareDataForRender
 * @param  {ICOSMOSSmartInfo} data
 * @return {ICOSMOSSmartInfo}
 */
function prepareDataForRender(data) {
    data.suggestedTopics.sort(sortTopics);
    data.suggestedTopics.forEach(function (topic) { return topic.solutions.sort(sortSolutions); });
    var total = 0;
    data.suggestedTopics.forEach(function (topic) { return total += topic.solutions ? topic.solutions.length : 0; });
    data.total = total;
    var count = 0;
    data.suggestedTopics.forEach(function (topic) { return topic.solutions.forEach(function (solution) { count++; solution.solutionNo = count; }); });
    return data;
}
/**
 * This function sorts elements based on the `topicId` property.
 *
 * @function sortTopics
 * @param  {ICOSMOSResponseSuggestion} a
 * @param  {ICOSMOSResponseSuggestion} b
 * @return {number} 0 if a.topicId is equal to b.topicId, 1 if a.topicId is
 * greater than b.topicId, otherwise -1
 */
function sortTopics(a, b) {
    return parseInt(a.topicId, 10) - parseInt(b.topicId, 10);
}
/**
 * This function sorts elements based on the `urlId` property.
 *
 * @function sortSolutions
 * @param  {ICOSMOSResponseSolution} a
 * @param  {ICOSMOSResponseSolution} b
 * @return {number} 0 if a.urlId is equal to b.urlId, 1 if a.urlId is
 * greater than b.urlId, otherwise -1
 */
function sortSolutions(a, b) {
    return parseInt(a.urlId, 10) - parseInt(b.urlId, 10);
}

// CONCATENATED MODULE: ./clientlibs/js/lib/util/captcha.ts
var CAPTCHA_RESPONSE_ID = 'g-recaptcha-response';
function isCaptchaRequired(data) {
    return Array.isArray(data) && data.some(function (element) { return element.id === CAPTCHA_RESPONSE_ID; });
}

// CONCATENATED MODULE: ./clientlibs/js/lib/cosmos/Tc.Module.COSMOSResultContainer.ts






var DATA_REDIRECT_URL = 'yes-url-redirect';
var DATA_NEW_INQUIRY_LABEL = 'new-inquiry-label';
var Tc_Module_COSMOSResultContainer_CSS_CLASS_IS_HIDDEN = 'is-hidden';
var CSS_CLASS_HIDDEN = 'hidden';
var AJAX_TYPE_POST = 'POST';
var DATA_TYPE_HTML = 'html';
var DATA_TYPE_JSON = 'json';
var Tc_Module_COSMOSResultContainer_EVENT_TYPE_CLICK = 'click';
var COSMOS_ACTION_SUBMIT = 'submit';
var COSMOS_ACTION_YES = 'yes';
var COSMOS_ACTION_NO = 'no';
var CAPTCHA_NEEDED_EVENT = 'captchaNeededEvent';
/**
 * COSMOSResultContainer module implementation.
 *
 * @author Nikola Tica
 * @class COSMOSResultContainer
 * @extends Tc.Module
 */
var Tc_Module_COSMOSResultContainer_COSMOSResultContainer = /** @class */ (function (_super) {
    Object(tslib_es6["c" /* __extends */])(COSMOSResultContainer, _super);
    function COSMOSResultContainer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Hook function to do all of your module stuff.
     *
     * @method on
     * @param  {Hook} callback Callback function
     * @return void
     */
    COSMOSResultContainer.prototype.on = function (callback) {
        this.template = load_dot["a" /* default */].compile(this.$ctx.find('script.tmpl-cosmos-sotions').html());
        this.$form = this.$ctx.closest('form');
        this.redirectUrl = this.$ctx.data(DATA_REDIRECT_URL);
        this.newInquiryLabel = this.$ctx.data(DATA_NEW_INQUIRY_LABEL);
        this.$submitButton = this.$ctx.find('.submit-button-holder button');
        this.$yesFeedbackButton = this.$ctx.find('.feedback-button-yes');
        this.$noFeedbackButton = this.$ctx.find('.feedback-button-no');
        this.$resultContainer = this.$ctx.find('.result-container');
        this.$answerField = this.$ctx.find('#answer');
        this.$cosmosProcessIdField = this.$ctx.find('#cosmosProcessId');
        this.$cosmosActionField = this.$ctx.find('#cosmosAction');
        this.$showFormFieldsField = this.$ctx.find('#showFormFields');
        this.$formEntryIdField = this.$form.find('[name=":formEntryId"]');
        this.$formErrorHolder = this.$form.find('.headingError');
        this.$formCaptcha = this.$form.find('#captcha');
        this.$ajaxCaptcha = this.$ctx.find('.modAjaxCaptcha');
        // Exclude empty button-groups, button-group in COSMOSResultContainer itself and in personalizationcontainer normal
        // Use to display Captcha.
        this.$buttonGroup = this.$form.find('.button-group:not(.modCOSMOSResultContainer .button-group)'
            + ':not(.personalizationcontainer .normal .button-group):has(button)');
        this.$buttonIndent = this.$form.find('.button-indent');
        // Avoid migration script
        this.$biIntegrationIdField = external___window__g_____g_$_____window_$CQ____window_$____window_jQuery__default()('<input type="hidden" name="biIntegrationId">').appendTo(this.$form);
        this.$piIntegrationIdField = external___window__g_____g_$_____window_$CQ____window_$____window_jQuery__default()('<input type="hidden" name="piIntegrationId">').appendTo(this.$form);
        this.$smartProcessingInfoField = external___window__g_____g_$_____window_$CQ____window_$____window_jQuery__default()('<input type="hidden" name="smartProcessingInfo">').appendTo(this.$form);
        // Detach form captcha, use ajaxcaptcha instead
        if (this.$formCaptcha.length > 0) {
            this.$formCaptcha.detach();
        }
        if (!this.$ajaxCaptcha.find('#g-recaptcha-response').length) {
            /**
             * Workaround for reseting initial ajaxCaptcha issues:
             * When you reach condition that ajax captcha is needed and then reload
             * page, you will trigger regular captcha which is detached and ajax
             * captcha will not be visible but it will have required validation state.
             * This will prevent submiting the form but since ajaxCaptcha will not be
             * visible the user willnot be able to fix it and it will stay in limbo
             * state withouth any visible notification why.
             */
            var captchaCv = this.$ajaxCaptcha.find('[data-clientvalidation]').data('clientvalidation');
            captchaCv.required = false;
            this.$ajaxCaptcha.find('.captcha').data('clientvalidation', captchaCv);
        }
        this.$submitButton.on(Tc_Module_COSMOSResultContainer_EVENT_TYPE_CLICK, this.submitToCosmos.bind(this));
        callback();
    };
    /**
     * This function attaches handlers to component feedback buttons.
     *
     * @method attachFeedbackHandlers
     * @private
     * @return void
     */
    COSMOSResultContainer.prototype.attachFeedbackHandlers = function () {
        this.$yesFeedbackButton.on(Tc_Module_COSMOSResultContainer_EVENT_TYPE_CLICK, this.sendYesFeedback.bind(this));
        this.$noFeedbackButton.on(Tc_Module_COSMOSResultContainer_EVENT_TYPE_CLICK, this.sendNoFeedback.bind(this));
    };
    /**
     * This function renders data retrieved from COSMOS service.
     *
     * @method renderResults
     * @private
     * @param  {ICOSMOSSmartInfo} data COSMOS response data
     * @return void
     */
    COSMOSResultContainer.prototype.renderResults = function (data) {
        var $holder = this.$ctx.find('.solutions-holder');
        prepareDataForRender(data);
        $holder.empty();
        var $html = external___window__g_____g_$_____window_$CQ____window_$____window_jQuery__default()(this.template(data));
        $holder.append($html);
        var $feedbackButtonGroup = this.$ctx.find('.solutions-feedback .button-indent');
        this.$ajaxCaptcha.detach();
        $feedbackButtonGroup.before(this.$ajaxCaptcha);
        return;
    };
    /**
     * This function submits data to COSMOS.
     *
     * @method submitToCosmos
     * @private
     * @return void
     */
    COSMOSResultContainer.prototype.submitToCosmos = function (event) {
        var _this = this;
        var mod = this;
        var formApi = this.$form.parent().data('form-api');
        mod.hideFormFields();
        event.preventDefault();
        setTimeout(function () {
            var invalidateFieldsNum = formApi.validateForm();
            mod.$formErrorHolder.find('.msg').text('');
            mod.$formErrorHolder.addClass(CSS_CLASS_HIDDEN);
            mod.hideResultContainer();
            if (!invalidateFieldsNum) {
                mod.hideSubmitButton();
                mod.setCosmosActionFieldValue(COSMOS_ACTION_SUBMIT);
                external___window__g_____g_$_____window_$CQ____window_$____window_jQuery__default.a.ajax({
                    data: mod.$form.serialize(),
                    dataType: DATA_TYPE_JSON,
                    type: AJAX_TYPE_POST,
                    url: _this.$form.attr('action'),
                    success: function (data) {
                        if ('formEntryId' in data) {
                            mod.$formEntryIdField.val(data.formEntryId);
                        }
                        if (data.success) {
                            mod.changeSubmitButtonLabel(mod.newInquiryLabel);
                            mod.processData(data);
                        }
                        else {
                            mod.handleExceptions(data);
                        }
                    },
                    error: function (data) {
                        mod.handleExceptions(data.responseJSON);
                    },
                });
            }
        }, 250);
    };
    COSMOSResultContainer.prototype.handleExceptions = function (data) {
        if (isCaptchaRequired(data.data || [])) {
            // Show captcha
            this.$ajaxCaptcha.trigger(CAPTCHA_NEEDED_EVENT);
            this.showSubmitButton();
        }
        else {
            this.handleInvalidResponse();
        }
    };
    COSMOSResultContainer.prototype.handleInvalidResponse = function () {
        this.changeSubmitButtonLabel(this.newInquiryLabel);
        this.showSubmitButton();
        // Display fields
        this.showFormFields();
    };
    /**
     * This function process data retrieved from COSMOS service.
     *
     * @method processData
     * @private
     * @param  {ICOSMOSSmartInfo} data
     * @return void
     */
    COSMOSResultContainer.prototype.processData = function (data) {
        if (data.smartInfo && data.smartInfo.info) {
            this.$cosmosProcessIdField.val(data.smartInfo.info.cosmosProcessID);
            this.$biIntegrationIdField.val(data.smartInfo.biIntegrationId);
            this.$piIntegrationIdField.val(data.smartInfo.piIntegrationId);
            this.$smartProcessingInfoField.val(JSON.stringify(data.smartInfo.info));
        }
        if (!data.smartInfo
            || !data.smartInfo.info
            || !data.smartInfo.info.suggestedTopics
            || !data.smartInfo.info.suggestedTopics.length) {
            this.handleInvalidResponse();
            return;
        }
        this.renderResults(data.smartInfo.info);
        this.attachFeedbackHandlers();
        this.showResultContainer();
        this.showSubmitButton();
    };
    /**
     * This function triggers visibility content change
     *
     * @method showFormFields
     * @return void
     */
    COSMOSResultContainer.prototype.showFormFields = function () {
        this.setCosmosActionFieldValue('');
        this.$showFormFieldsField.val('true');
        this.$showFormFieldsField.trigger('change');
        this.$ajaxCaptcha.detach();
        if (this.$buttonGroup.length > 0) {
            this.$buttonGroup.before(this.$ajaxCaptcha);
        }
        else if (this.$buttonIndent) {
            this.$buttonIndent.before(this.$ajaxCaptcha);
        }
    };
    /**
     * This function triggers visibility content change
     *
     * @method hideFormFields
     * @return void
     */
    COSMOSResultContainer.prototype.hideFormFields = function () {
        this.setCosmosActionFieldValue('');
        this.$showFormFieldsField.val('false');
        this.$showFormFieldsField.trigger('change');
        this.$ajaxCaptcha.detach();
        this.$submitButton.before(this.$ajaxCaptcha);
    };
    /**
     * This function sends answer yes feedback to COSMOS and redirect the form to
     * the new url.
     *
     * @method sendYesFeedback
     * @private
     * @return void
     */
    COSMOSResultContainer.prototype.sendYesFeedback = function (event) {
        var mod = this;
        event.preventDefault();
        mod.setAnswerFieldValue('yes');
        mod.setCosmosActionFieldValue(COSMOS_ACTION_YES);
        external___window__g_____g_$_____window_$CQ____window_$____window_jQuery__default.a.ajax({
            data: mod.$form.serialize(),
            dataType: DATA_TYPE_HTML,
            type: AJAX_TYPE_POST,
            url: mod.$form.attr('action'),
            success: function (data) {
                if (!data.success && isCaptchaRequired(data.data || [])) {
                    // Show captcha
                    mod.$ajaxCaptcha.trigger(CAPTCHA_NEEDED_EVENT);
                }
                else {
                    mod.yesRedirect();
                }
            },
            error: function (data) {
                if (isCaptchaRequired(data.responseJSON.data || [])) {
                    // Show captcha
                    mod.$ajaxCaptcha.trigger(CAPTCHA_NEEDED_EVENT);
                }
                else {
                    mod.yesRedirect();
                }
            },
        });
    };
    /**
     * This function redirect to yes page.
     */
    COSMOSResultContainer.prototype.yesRedirect = function () {
        if (this.redirectUrl) {
            window.location.assign(this.redirectUrl);
        }
        this.hideResultContainer();
    };
    /**
     * This function sends answer no feedback to COSMOS.
     *
     * @method sendNoFeedback
     * @private
     * @return void
     */
    COSMOSResultContainer.prototype.sendNoFeedback = function (event) {
        var mod = this;
        event.preventDefault();
        mod.setAnswerFieldValue('no');
        mod.setCosmosActionFieldValue(COSMOS_ACTION_NO);
        mod.hideSubmitButton();
        external___window__g_____g_$_____window_$CQ____window_$____window_jQuery__default.a.ajax({
            data: mod.$form.serialize(),
            dataType: DATA_TYPE_HTML,
            type: AJAX_TYPE_POST,
            url: mod.$form.attr('action'),
            success: function (data) {
                if (!data.success && isCaptchaRequired(data.data || [])) {
                    // Show captcha
                    mod.$ajaxCaptcha.trigger(CAPTCHA_NEEDED_EVENT);
                }
                else {
                    mod.hideResultContainer();
                    mod.showFormFields();
                }
            },
            error: function (data) {
                if (isCaptchaRequired(data.responseJSON.data || [])) {
                    // Show captcha
                    mod.$ajaxCaptcha.trigger(CAPTCHA_NEEDED_EVENT);
                }
                else {
                    mod.hideResultContainer();
                    mod.showFormFields();
                }
            },
        });
    };
    /**
     * This function set hidden answer field value.
     *
     * @method: setAnswerFieldValue
     * @private
     * @param {String} val Expected values are "yes" or "no"
     * @return void
     */
    COSMOSResultContainer.prototype.setAnswerFieldValue = function (val) {
        this.$answerField.val(val);
    };
    /**
     * This function set hidden cosmosAction field value.
     *
     * @method setCosmosActionFieldValue
     * @private
     * @param  {string} value Expected values are: submit, no, yes and empty
     * string ''
     * @return void
     */
    COSMOSResultContainer.prototype.setCosmosActionFieldValue = function (value) {
        this.$cosmosActionField.val(value);
    };
    /**
     * This function hides result container.
     *
     * @method: hideResultContainer
     * @private
     * @return void
     */
    COSMOSResultContainer.prototype.hideResultContainer = function () {
        this.$resultContainer.addClass(Tc_Module_COSMOSResultContainer_CSS_CLASS_IS_HIDDEN);
    };
    /**
     * This function displays result container.
     *
     * @method: showResultContainer
     * @private
     * @return void
     */
    COSMOSResultContainer.prototype.showResultContainer = function () {
        this.$resultContainer.removeClass(Tc_Module_COSMOSResultContainer_CSS_CLASS_IS_HIDDEN);
    };
    /**
     * This function hides submit button.
     *
     * @method hideSubmitButton
     * @private
     * @return void
     */
    COSMOSResultContainer.prototype.hideSubmitButton = function () {
        this.$submitButton.addClass(Tc_Module_COSMOSResultContainer_CSS_CLASS_IS_HIDDEN);
    };
    /**
     * This function shows submit button.
     *
     * @method showSubmitButton
     * @private
     * @return void
     */
    COSMOSResultContainer.prototype.showSubmitButton = function () {
        this.$submitButton.removeClass(Tc_Module_COSMOSResultContainer_CSS_CLASS_IS_HIDDEN);
    };
    COSMOSResultContainer.prototype.changeSubmitButtonLabel = function (newLabel) {
        this.$submitButton.text(newLabel);
    };
    return COSMOSResultContainer;
}(Module["a" /* Module */]));
/* harmony default export */ var Tc_Module_COSMOSResultContainer = (Tc_Module_COSMOSResultContainer_COSMOSResultContainer);

// EXTERNAL MODULE: ./clientlibs/js/lib/contact/Tc.Module.CallFromNet.ts
var Tc_Module_CallFromNet = __webpack_require__(200);

// EXTERNAL MODULE: ./clientlibs/js/lib/sdx/Tc.Module.CallOut.ts
var Tc_Module_CallOut = __webpack_require__(201);

// EXTERNAL MODULE: ./clientlibs/js/lib/form/Tc.Module.DataContainer.ts
var Tc_Module_DataContainer = __webpack_require__(202);

// CONCATENATED MODULE: ./clientlibs/js/lib/newrepair/Tc.Module.DownloadNRepPDF.ts



var DEFAULT_FILE_NAME = 'swisscom.pdf';
function getFileNameFromDisposition(disposition) {
    var fileName = DEFAULT_FILE_NAME;
    if (disposition && disposition.indexOf('attachment') !== -1) {
        var fileNameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
        var matches = fileNameRegex.exec(disposition);
        if (matches !== null && matches[1]) {
            fileName = matches[1].replace(/['"]/g, '');
        }
    }
    return fileName;
}
function createPostRequest(url, data) {
    return new Promise(function (resolve, reject) {
        var request = new XMLHttpRequest();
        request.open('POST', url, true);
        request.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
        request.onreadystatechange = function () {
            /*
             This part is neccessary to solve the error:
             Uncaught InvalidStateError: Failed to read the 'responseText' property
             from 'XMLHttpRequest': The value is only accessible if the object's
             'responseType' is '' or 'text' (was 'blob').
             This is the actual reasone to use XMLHttpRequest instead of $.ajax()
             */
            if (request.readyState === 2) {
                if (request.status === 200) {
                    request.responseType = 'blob';
                }
                else {
                    request.responseType = 'text';
                }
            }
        };
        request.onload = function () { return resolve(request); };
        request.onerror = function () { return reject(request); };
        request.send(data);
    });
}
/**
 * Download pdf button for transfering number. It is used to submit the wizard
 * form to appropriate servlet which will response with a populated pdf file.
 *
 * @author Igor Velickovic
 * @class DownloadNRepPDF
 * @extends Tc.Module
 */
var Tc_Module_DownloadNRepPDF_DownloadNRepPDF = /** @class */ (function (_super) {
    Object(tslib_es6["c" /* __extends */])(DownloadNRepPDF, _super);
    function DownloadNRepPDF() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Hook function to do all of your module stuff.
     *
     * @method on
     * @param  {Hook} callback Callback function
     * @return void
     */
    DownloadNRepPDF.prototype.on = function (callback) {
        var _this = this;
        this.$ctx.find('.download-button').on('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            var $form = _this.$ctx.closest('form.wizard');
            var dataString = external___window__g_____g_$_____window_$CQ____window_$____window_jQuery__default()('input[name!=":formid"],[name!=":formstart"],[name!=":formtype"]', $form)
                .find('input, textarea, select')
                .serialize();
            var ajaxUrl = external___window__g_____g_$_____window_$CQ____window_$____window_jQuery__default()(e.target).data('url');
            createPostRequest(ajaxUrl, dataString)
                .then(function (request) {
                var disposition = request.getResponseHeader('content-disposition');
                var fileName = getFileNameFromDisposition(disposition);
                if (window.navigator && window.navigator.msSaveOrOpenBlob) { // For IE
                    window.navigator.msSaveOrOpenBlob(request.response, fileName);
                }
                else { // For Non-IE (chrome, firefox etc.)
                    var a = document.createElement('a');
                    var url = URL.createObjectURL(request.response);
                    a.href = url;
                    a.download = fileName;
                    document.body.appendChild(a);
                    a.click();
                    a.remove();
                }
            })
                .catch(function (err) { return _this.log(err); });
        });
        callback();
    };
    return DownloadNRepPDF;
}(Module["a" /* Module */]));
/* harmony default export */ var Tc_Module_DownloadNRepPDF = (Tc_Module_DownloadNRepPDF_DownloadNRepPDF);

// EXTERNAL MODULE: ./clientlibs/js/lib/vendor/qrcode/qrcode.js
var qrcode = __webpack_require__(203);
var qrcode_default = /*#__PURE__*/__webpack_require__.n(qrcode);

// CONCATENATED MODULE: ./clientlibs/js/lib/widget/Tc.Module.EasyPointQrCode.ts



/**
 * Generates and displays a QR Code for EasyPoint pickup.
 *
 * https://www.swisscom.ch/easypoint/?9-5-38297179610 redirects to
 * https://www.swisscom.ch/en/residential/easypoint.html#9-5-38297179610
 *
 * - The number before the first dash (e.g. `9-`) selects the prefix
 * - The suffix is the rest of the URL fragment identifier: 5-38297179610
 * - The actual values for the prefixes are configured in the component
 *
 * @author Cesar Keller, Marcel Greter
 * @class EasyPointQrCode
 * @extends Tc.Module
 */
var Tc_Module_EasyPointQrCode_EasyPointQrCode = /** @class */ (function (_super) {
    Object(tslib_es6["c" /* __extends */])(EasyPointQrCode, _super);
    function EasyPointQrCode() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Hook function to do all of your module stuff.
     *
     * @method on
     * @return void
     */
    EasyPointQrCode.prototype.on = function (callback) {
        var hash = location.hash ? location.hash.replace(/^#/, '') : '';
        // Split into two parts at first dash
        var dashPos = hash.indexOf('-');
        var select = hash.substr(0, dashPos);
        var suffix = hash.substr(dashPos + 1);
        // Get configured prefixes from data attribute
        var prefixes = this.$ctx.data('prefixes');
        if (prefixes === undefined) {
            this.log.error('No QR code prefixes found');
        }
        else if (!select || !suffix) {
            this.log.error('Invalid QR code parameter');
        }
        else if (prefixes[select] === undefined || prefixes[select] === '') {
            this.log.error('Unknown QR code prefix');
        }
        else {
            // Concat static prefix and custom suffix
            var code = prefixes[select] + suffix;
            // Draw QrCode into module space
            var qr = new qrcode_default.a(this.$ctx[0], {
                height: 512,
                text: code,
                useSVG: navigator.userAgent.indexOf('SamsungBrowser') === -1,
                width: 512,
            });
            this.log('Rendered QR code ', code, ' into ', qr);
        }
        callback();
    };
    return EasyPointQrCode;
}(Module["a" /* Module */]));
/* harmony default export */ var Tc_Module_EasyPointQrCode = (Tc_Module_EasyPointQrCode_EasyPointQrCode);

// EXTERNAL MODULE: ./clientlibs/js/lib/img/Tc.Module.EnlargeImageView.ts
var Tc_Module_EnlargeImageView = __webpack_require__(204);

// CONCATENATED MODULE: ./clientlibs/js/lib/expandandcollapse/Tc.Module.ExpandAndCollapse.ts


var Tc_Module_ExpandAndCollapse_ExpandAndCollapse = /** @class */ (function (_super) {
    Object(tslib_es6["c" /* __extends */])(ExpandAndCollapse, _super);
    function ExpandAndCollapse() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isOpen = false;
        return _this;
    }
    ExpandAndCollapse.prototype.on = function (callback) {
        this.el = this.$ctx[0];
        this.isOpen = this.el.open;
        callback();
    };
    ExpandAndCollapse.prototype.after = function () {
        this.el.addEventListener('click', this.track.bind(this));
    };
    ExpandAndCollapse.prototype.track = function () {
        if (this.el.open === this.isOpen) {
            return;
        }
        this.isOpen = this.el.open;
        SCS.portal.datalayer.trackEvent(this.isOpen ? 'open' : 'close', this.el.dataset.trackingLabel, this.el.dataset.trackingLocation, this.el.dataset.trackingCategory);
    };
    return ExpandAndCollapse;
}(Module["a" /* Module */]));
/* harmony default export */ var Tc_Module_ExpandAndCollapse = (Tc_Module_ExpandAndCollapse_ExpandAndCollapse);

// EXTERNAL MODULE: ./clientlibs/js/lib/form/Tc.Module.FormDataRestore.ts
var Tc_Module_FormDataRestore = __webpack_require__(205);

// CONCATENATED MODULE: ./clientlibs/js/lib/sdx/gcr-pressrelease/GcrPressReleaseSettings.ts
var dateConfig = {
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    month: 'long',
    year: 'numeric',
};
var headConfig = {
    month: 'long',
    year: 'numeric',
};

// EXTERNAL MODULE: ./clientlibs/js/lib/util/string.ts
var string = __webpack_require__(23);

// EXTERNAL MODULE: ./clientlibs/js/lib/sdx/gcr-pressrelease/ResultCard.tsx
var ResultCard = __webpack_require__(206);

// CONCATENATED MODULE: ./clientlibs/js/lib/sdx/gcr-pressrelease/Tc.Module.GcrNewsArchiveResults.ts






var DATE_CONFIG_SHORT = {
    day: '2-digit',
    month: 'long',
    year: 'numeric',
};
var DATETIME_CONFIG = {
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    month: 'long',
    year: 'numeric',
};
var Tc_Module_GcrNewsArchiveResults_GcrNewsArchiveResults = /** @class */ (function (_super) {
    Object(tslib_es6["c" /* __extends */])(GcrNewsArchiveResults, _super);
    function GcrNewsArchiveResults($ctx, sandbox, id, modName) {
        var _this = _super.call(this, $ctx, sandbox, id, modName) || this;
        _this.loadedResults = 0;
        _this.cardLayout = true;
        _this.items = [];
        _this.lastHeading = '';
        _this.serviceUrl = $ctx.data('service-url');
        _this.resultHolder = new ResultCard["a" /* ResultCard */](_this.$ctx.find('.news-results')[0], _this.$ctx.data('more-translation'));
        return _this;
    }
    GcrNewsArchiveResults.prototype.on = function (finished) {
        var _this = this;
        this.$ctx.find('.toolbar a.grid').on('click', function () { return _this.changeLayout(true); });
        this.$ctx.find('.toolbar a.list').on('click', function () { return _this.changeLayout(false); });
        this.$ctx.find('.news-show-more').on('click', function () { return _this.load(); });
        finished();
    };
    /* Called by Tc.Module.GcrPressReleaseSearch */
    GcrNewsArchiveResults.prototype.onUpdateSearchFilter = function (filter) {
        // Filter object from search form
        this.filter = filter;
        // Limits and offset can be set via data attributes
        this.filter.limit = this.$ctx.data('limit') || 10;
        this.filter.offset = this.$ctx.data('offset') || 0;
        // Reset loaded results state
        this.loadedResults = 0;
        // Clear out the viewport
        this.resultHolder.clear();
        this.items = [];
        // Reset state variable
        this.lastHeading = '';
        this.load();
    };
    GcrNewsArchiveResults.prototype.hideLoadSpinner = function () {
        this.$ctx.find('.loader-spinner').addClass('hidden');
    };
    GcrNewsArchiveResults.prototype.showLoadSpinner = function () {
        this.$ctx.find('.loader-spinner').removeClass('hidden');
    };
    GcrNewsArchiveResults.prototype.hideBtnLoadMore = function () {
        this.$ctx.find('.news-show-more').addClass('hidden');
    };
    GcrNewsArchiveResults.prototype.showBtnLoadMore = function () {
        this.$ctx.find('.news-show-more').removeClass('hidden');
    };
    GcrNewsArchiveResults.prototype.disableBtnLoadMore = function () {
        this.$ctx.find('.news-show-more').addClass('disabled');
    };
    GcrNewsArchiveResults.prototype.enableBtnLoadMore = function () {
        this.$ctx.find('.news-show-more').removeClass('disabled');
    };
    GcrNewsArchiveResults.prototype.hideNoResults = function () {
        this.$ctx.find('.news-no-results').addClass('hidden');
    };
    GcrNewsArchiveResults.prototype.showNoResult = function () {
        this.$ctx.find('.news-no-results').removeClass('hidden');
    };
    GcrNewsArchiveResults.prototype.changeLayout = function (layoutCard) {
        this.cardLayout = layoutCard;
        if (this.cardLayout) {
            this.$ctx.find('.switch-layout').removeClass('show-list').addClass('show-grid');
        }
        else {
            this.$ctx.find('.switch-layout').addClass('show-list').removeClass('show-grid');
        }
        this.renderItems();
    };
    GcrNewsArchiveResults.prototype.load = function () {
        this.showLoadSpinner();
        this.hideNoResults();
        this.hideBtnLoadMore();
        this.disableBtnLoadMore();
        external___window__g_____g_$_____window_$CQ____window_$____window_jQuery_["post"]({
            data: this.filter,
            dataType: 'json',
            url: this.serviceUrl,
        })
            .always(this.hideLoadSpinner.bind(this))
            .always(this.showBtnLoadMore.bind(this))
            .always(this.enableBtnLoadMore.bind(this))
            .done(this.handleSuccess.bind(this))
            .fail(this.handleFailure.bind(this));
    };
    GcrNewsArchiveResults.prototype.handleSuccess = function (data) {
        var _this = this;
        if (data && data.results && data.results.length) {
            var items = data.results
                .map(function (item) { return _this.enrichItem(item); });
            this.items = Object(tslib_es6["e" /* __spreadArray */])(Object(tslib_es6["e" /* __spreadArray */])([], this.items), items);
            this.overrideDefaultCardLayout();
            this.renderItems();
            this.loadedResults += data.results.length;
            this.filter.offset = this.loadedResults;
        }
        // Did we load all results?
        if (data.lastResultSet) {
            this.hideBtnLoadMore();
            // Loaded no items at all?
            if (this.loadedResults === 0) {
                this.showNoResult();
            }
        }
    };
    GcrNewsArchiveResults.prototype.renderItems = function () {
        this.resultHolder.renderItems(this.items, this.cardLayout);
    };
    // Show list-view if ad-hoc tag is one of selected tags
    GcrNewsArchiveResults.prototype.overrideDefaultCardLayout = function () {
        var _a;
        var filterLimit = this.$ctx.data('limit') || 10;
        if (((_a = this.filter.section) === null || _a === void 0 ? void 0 : _a.includes('gcr:pressRoom/section/adhoc')) && this.loadedResults < filterLimit) {
            this.changeLayout(false);
        }
    };
    GcrNewsArchiveResults.prototype.enrichItem = function (data) {
        var lang = this.filter.lang;
        var itemDate = new Date(data.date);
        // Format the date string to locale (not supported by all UAs)
        var readableDate = itemDate.toLocaleDateString(lang, DATE_CONFIG_SHORT);
        var dateAndTime = itemDate.toLocaleDateString(lang, DATETIME_CONFIG);
        var monthHeading = itemDate.toLocaleDateString(lang, headConfig);
        // Make sure to write the month always in uppercase (needed for fr/it)
        monthHeading = monthHeading.charAt(0).toUpperCase() + monthHeading.substr(1);
        var maxLen = data.image || data.imageUrl ? 105 : 165;
        if (data.lead && data.lead.length > maxLen + 4) {
            data.lead = Object(string["truncate"])(data.lead, maxLen + 4);
        }
        var item = {
            categories: data.categories,
            date: readableDate,
            dateAndTime: dateAndTime,
            image: data.image,
            imageMobile: data.imageMobile,
            imageUrl: data.imageUrl,
            lead: data.lead,
            title: data.title,
            topics: data.topics,
            url: data.url,
        };
        // Only set month heading if not used before
        if (this.lastHeading !== monthHeading) {
            this.lastHeading = monthHeading;
            item.heading = monthHeading;
        }
        return item;
    };
    GcrNewsArchiveResults.prototype.handleFailure = function (error) {
        // Is there anything to show?
        this.log('failure', error);
        this.hideBtnLoadMore();
    };
    return GcrNewsArchiveResults;
}(Module["a" /* Module */]));
/* harmony default export */ var Tc_Module_GcrNewsArchiveResults = (Tc_Module_GcrNewsArchiveResults_GcrNewsArchiveResults);

// EXTERNAL MODULE: ./clientlibs/js/lib/sdx/gcr-pressrelease/FilterTag.tsx
var FilterTag = __webpack_require__(215);

// EXTERNAL MODULE: ./clientlibs/js/lib/util/url.ts + 1 modules
var util_url = __webpack_require__(6);

// CONCATENATED MODULE: ./clientlibs/js/lib/sdx/gcr-pressrelease/Tc.Module.GcrNewsArchiveSearch.ts





var autoSubmitTimeout = 500; // In ms
var Tc_Module_GcrNewsArchiveSearch_GcrNewsArchiveSearch = /** @class */ (function (_super) {
    Object(tslib_es6["c" /* __extends */])(GcrNewsArchiveSearch, _super);
    function GcrNewsArchiveSearch($ctx, sandbox, id, modName) {
        var _this = _super.call(this, $ctx, sandbox, id, modName) || this;
        _this.filterOpenState = false;
        /* Read language from page attribute */
        var lang = external___window__g_____g_$_____window_$CQ____window_$____window_jQuery_('HTML').attr('lang');
        switch ((lang || 'de').toLocaleLowerCase()) {
            case 'en':
                _this.lang = 'en';
                break;
            case 'fr':
                _this.lang = 'fr';
                break;
            case 'it':
                _this.lang = 'it';
                break;
            default:
                _this.lang = 'de';
                break;
        }
        _this.scheduledSubmit = 0;
        // Key for the hash state
        _this.hashKey = 'NewsArchive';
        _this.path = _this.$ctx.find('input[name=path]')[0];
        _this.query = _this.$ctx.find('[name=news-query]')[0];
        _this.category = _this.$ctx.find('[name=news-topic]')[0];
        _this.section = _this.$ctx.find('[name=news-section]')[0];
        _this.period = _this.$ctx.find('[name=period]')[0];
        _this.startDate = _this.$ctx.find('[name=start-date]')[0];
        _this.endDate = _this.$ctx.find('[name=end-date]')[0];
        _this.breadcrumbs = _this.$ctx.find('.filter-breadcrumbs')[0];
        _this.filterTag = new FilterTag["a" /* FilterTag */](_this.breadcrumbs, _this.$ctx.data('sections'), _this.$ctx.data('topics'), _this.$ctx.data('periods'));
        return _this;
    }
    GcrNewsArchiveSearch.prototype.on = function (finished) {
        this.$ctx.find('.gcr-archive-collapsible-head').on('click', this.changeFilterState.bind(this));
        finished();
    };
    GcrNewsArchiveSearch.prototype.moduleStateChanged = function (hashState) {
        this.readHashState(hashState);
        this.submitForm(false, this.getFilterConfig());
    };
    GcrNewsArchiveSearch.prototype.after = function (hashState) {
        var updateHashState = true;
        if (external___window__g_____g_$_____window_$CQ____window_$____window_jQuery_["isEmptyObject"](hashState)) {
            if (this.$ctx.data('default-sections')) {
                this.setSections(this.$ctx.data('default-sections').split(','));
            }
            this.period.value = ['1'];
            this.handleDateFields();
        }
        else {
            this.readHashState(hashState);
            updateHashState = false;
        }
        var filter = this.getFilterConfig();
        this.renderBreadcrumbBar(filter);
        this.submitForm(updateHashState, filter);
        this.setupAutoSubmit();
    };
    GcrNewsArchiveSearch.prototype.readHashState = function (hashState) {
        if (hashState.query) {
            this.query.value = hashState.query;
        }
        if (hashState.section) {
            this.section.value = hashState.section;
        }
        if (hashState.category) {
            this.category.value = hashState.category;
        }
        if (hashState.period) {
            this.period.value = hashState.period;
        }
        else {
            this.period.value = ['1'];
        }
        if (hashState.startDate) {
            this.startDate.value = hashState.startDate;
        }
        if (hashState.endDate) {
            this.endDate.value = hashState.endDate;
        }
        if (hashState.filterState && (hashState.filterState === 'true') !== this.filterOpenState) {
            this.changeFilterState();
        }
        this.handleDateFields();
    };
    GcrNewsArchiveSearch.prototype.changeFilterState = function () {
        this.$ctx.find('.gcr-archive-collapsible').toggleClass('gcr-archive-collapsible-closed');
        this.filterOpenState = !this.filterOpenState;
        var state = Object(util_url["readStateFromHash"])(this.hashKey, true) || {};
        this.setModuleState(Object(tslib_es6["a" /* __assign */])(Object(tslib_es6["a" /* __assign */])({}, state), { filterState: this.filterOpenState }));
    };
    GcrNewsArchiveSearch.prototype.setSections = function (data) {
        this.section.value = data;
    };
    GcrNewsArchiveSearch.prototype.submitForm = function (updateHashState, filter) {
        // Dispatch to all listening modules
        this.fire('updateSearchFilter', filter);
        // Update our hash state if needed
        if (updateHashState) {
            this.setModuleState({
                category: filter.category,
                endDate: filter.endDate,
                filterState: this.filterOpenState,
                period: filter.period,
                query: filter.query,
                section: filter.section,
                startDate: filter.startDate,
            });
        }
        // Reset old auto submit
        this.clearAutoSubmit();
    };
    GcrNewsArchiveSearch.prototype.setupAutoSubmit = function () {
        this.query.changeCallback = this.changeCallback.bind(this);
        this.category.changeCallback = this.changeCallback.bind(this);
        this.section.changeCallback = this.changeCallback.bind(this);
        this.period.changeCallback = this.changeCallback.bind(this);
        this.startDate.changeCallback = this.changeCallback.bind(this);
        this.endDate.changeCallback = this.changeCallback.bind(this);
    };
    GcrNewsArchiveSearch.prototype.getFilterConfig = function () {
        var filter = { lang: this.lang, _charset_: 'UTF-8' };
        if (this.query) {
            filter.query = this.query.value;
        }
        if (this.path) {
            filter.path = this.path.value;
        }
        if (this.period) {
            filter.period = this.period.value;
        }
        if (this.startDate) {
            filter.startDate = this.startDate.value;
        }
        if (this.endDate) {
            filter.endDate = this.endDate.value;
        }
        if (this.category) {
            filter.category = this.category.value;
        }
        if (this.section) {
            filter.section = this.section.value;
        }
        return filter;
    };
    GcrNewsArchiveSearch.prototype.changeCallback = function () {
        var _this = this;
        this.clearAutoSubmit();
        this.handleDateFields();
        var filter = this.getFilterConfig();
        this.renderBreadcrumbBar(filter);
        // Schedule auto submit after some timeout
        this.scheduledSubmit = setTimeout(function () {
            _this.submitForm(true, filter);
        }, autoSubmitTimeout);
    };
    GcrNewsArchiveSearch.prototype.clearAutoSubmit = function () {
        // Unscheduled previous auto submit
        clearTimeout(this.scheduledSubmit);
        // Clear status variable
        this.scheduledSubmit = 0;
    };
    GcrNewsArchiveSearch.prototype.handleDateFields = function () {
        var _a;
        if (((_a = this.period) === null || _a === void 0 ? void 0 : _a.value[0]) === '5') {
            this.$ctx.find('.news-date').show();
        }
        else {
            this.$ctx.find('.news-date').hide();
        }
    };
    GcrNewsArchiveSearch.prototype.closeBreadcrumbCallback = function (group, tag) {
        if (group === 'sections') {
            var val = this.section.value.slice();
            val.splice(val.indexOf(tag), 1);
            this.section.value = val;
        }
        if (group === 'topics') {
            var val = this.category.value.slice();
            val.splice(val.indexOf(tag), 1);
            this.category.value = val;
        }
        if (group === 'query') {
            this.query.value = '';
        }
    };
    GcrNewsArchiveSearch.prototype.renderBreadcrumbBar = function (filter) {
        this.filterTag.renderBreadcrumb(filter.section || [], filter.category || [], filter.period || '', filter.query || '', this.closeBreadcrumbCallback.bind(this));
    };
    return GcrNewsArchiveSearch;
}(Module["a" /* Module */]));
/* harmony default export */ var Tc_Module_GcrNewsArchiveSearch = (Tc_Module_GcrNewsArchiveSearch_GcrNewsArchiveSearch);

// CONCATENATED MODULE: ./clientlibs/js/lib/pdf/Tc.Module.GenericPDFFiller.ts



/**
 * GenericPDFFiller module implementation.
 *
 * @author tzhveig1
 * @class GenericPDFFiller
 * @extends Tc.Module
 */
var Tc_Module_GenericPDFFiller_GenericPDFFiller = /** @class */ (function (_super) {
    Object(tslib_es6["c" /* __extends */])(GenericPDFFiller, _super);
    function GenericPDFFiller() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Hook function to do all of your module stuff.
     *
     * @method on
     * @param  {Hook} callback Callback function
     * @return void
     */
    GenericPDFFiller.prototype.on = function (callback) {
        this.$button = this.$ctx.find('.button');
        var url = this.$ctx.data('url');
        this.$parentForm = this.$button.parents('form');
        this.$parentFormContents = this.$parentForm.contents();
        this.$submitForm = external___window__g_____g_$_____window_$CQ____window_$____window_jQuery_('<form />', { method: 'post', action: url, target: '_blank' });
        this.attachHandlers();
        callback();
    };
    GenericPDFFiller.prototype.attachHandlers = function () {
        this.$button.on('click', this.submitForm.bind(this));
    };
    GenericPDFFiller.prototype.submitForm = function (evt) {
        evt.preventDefault();
        if (this.$ctx.data('validate')) {
            var formApi = this.$parentForm.parent().data('form-api');
            formApi.onFormValidate(this.sendResult.bind(this));
        }
        else {
            this.sendResult();
        }
    };
    GenericPDFFiller.prototype.sendResult = function () {
        this.$submitForm.append(this.$parentFormContents.detach());
        // tslint:disable-next-line:max-line-length
        external___window__g_____g_$_____window_$CQ____window_$____window_jQuery_("input[name=':formid'],input[name=':formEntryId'],input[name='_charset_'],input[name=':cq_csrf_token'],[name=':formstart'],[name=':formtype']", this.$submitForm).remove();
        this.$submitForm.appendTo(document.body).trigger('submit').detach();
        this.$parentForm.append(this.$parentFormContents.detach());
    };
    return GenericPDFFiller;
}(Module["a" /* Module */]));
/* harmony default export */ var Tc_Module_GenericPDFFiller = (Tc_Module_GenericPDFFiller_GenericPDFFiller);

// CONCATENATED MODULE: ./clientlibs/js/lib/contact/Tc.Module.GenesysChatForContact.ts


var SECTION_PREFIX = 'portal-contact';
var TIMEOUT = 50;
function getSCSWebchatAPI() {
    var waitTime = 2500;
    var scs = window.SCS;
    if (scs && scs.webchat) {
        return Promise.resolve(scs.webchat);
    }
    return new Promise(function (resolve, reject) {
        var interval = setInterval(function () {
            scs = window.SCS;
            if (scs && scs.webchat) {
                clearInterval(interval);
                resolve(scs.webchat);
            }
            else if (waitTime <= 0) {
                clearInterval(interval);
                reject(new Error('window.SCS.webchat is not available after 2.5s'));
            }
            waitTime -= TIMEOUT;
        }, TIMEOUT);
    });
}
var Tc_Module_GenesysChatForContact_GenesysChatForContact = /** @class */ (function (_super) {
    Object(tslib_es6["c" /* __extends */])(GenesysChatForContact, _super);
    function GenesysChatForContact() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GenesysChatForContact.prototype.on = function (callback) {
        this.topicId = this.$ctx.closest('.result[data-parent-topic]').data('parent-topic');
        callback();
    };
    GenesysChatForContact.prototype.onTopicSelected = function (topic) {
        return Object(tslib_es6["b" /* __awaiter */])(this, void 0, void 0, function () {
            var name, topicName, webChat, e_1;
            return Object(tslib_es6["d" /* __generator */])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (topic.topicName !== this.topicId && topic.name !== this.topicId) {
                            return [2 /*return*/];
                        }
                        name = topic.topicName || topic.name;
                        topicName = name.split('/');
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, getSCSWebchatAPI()];
                    case 2:
                        webChat = _a.sent();
                        // Check if topic is still a currently selected one
                        if (!topic.isCurrent()) {
                            return [2 /*return*/];
                        }
                        if (topicName[0]) {
                            webChat.set(SECTION_PREFIX + ":topic", topicName[0]);
                        }
                        if (topicName[1]) {
                            webChat.set(SECTION_PREFIX + ":subtopic", topicName[1]);
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _a.sent();
                        this.log.error(e_1.message);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    return GenesysChatForContact;
}(Module["a" /* Module */]));
/* harmony default export */ var Tc_Module_GenesysChatForContact = (Tc_Module_GenesysChatForContact_GenesysChatForContact);

// EXTERNAL MODULE: ./clientlibs/js/lib/generic/leadmanagement/Tc.Module.LeadManagement.ts
var Tc_Module_LeadManagement = __webpack_require__(216);

// EXTERNAL MODULE: ./clientlibs/js/lib/generic/SDXModalDialog.ts
var SDXModalDialog = __webpack_require__(7);

// EXTERNAL MODULE: ./clientlibs/js/lib/generic/api/map.ts
var map = __webpack_require__(42);

// EXTERNAL MODULE: ./clientlibs/js/lib/util/helpers.ts
var helpers = __webpack_require__(4);

// CONCATENATED MODULE: ./clientlibs/js/lib/ecommerce/lego/Tc.Module.LegoContainer.ts








var DISABLED_VALUES = {
    'mobile-disable': 'N_LEGO No Mobile',
    'tv-disable': 'LEGO No TV',
    'voip-disable': 'Lego No VoIP',
};
var SKU_DISABLED_VALUES = {
    tv: 'LEGO_no_TV',
    voip: 'Lego_no_VoIP',
};
var SLIDERS_FLAVOR_MAPPING = {
    'Internet Flavour': 'internet',
    'Tv Flavour': 'tv',
    'Voip Flavour': 'voip',
};
var MOBILE_ABO_DEVICE_TOGGLE = 'mobileSubscriptionWithDevice';
/**
 * iterates over an array or object. The only requirement is that the item has a property "slideId".
 */
function getTrackingIdString(data) {
    var arr = Array.isArray(data) ? data : Object.keys(data).map(function (key) { return data[key]; });
    return arr
        .map(function (item) { return item.slideId; })
        .join('_');
}
/**
 * Separate slider and checkbox ui elements and return an object
 * with two arrays, one for each type.
 */
function separateSlidesAndCheckboxes(slideConfigurations) {
    var separated = {
        checkboxes: [],
        slides: [],
    };
    configLoop: for (var _a = 0, slideConfigurations_1 = slideConfigurations; _a < slideConfigurations_1.length; _a++) {
        var slideConfig = slideConfigurations_1[_a];
        for (var key in DISABLED_VALUES) {
            if (DISABLED_VALUES[key].indexOf(slideConfig.slideId) > -1) {
                separated.checkboxes.push(slideConfig.slideId);
                continue configLoop; // Continue on each loop
            }
        }
        separated.slides.push(slideConfig.slideId);
    }
    return separated;
}
function keyForValue(object, value) {
    for (var key in object) {
        if (object.hasOwnProperty(key) && object[key] === value) {
            return key;
        }
    }
    return undefined;
}
function toFloat(value) {
    return parseFloat(value);
}
/**
 * Lego Configurator module implementation.
 *
 * @author Matthias Inauen
 * @namespace Tc.Module
 * @class LegoContainer
 * @extends Tc.Module
 */
var Tc_Module_LegoContainer_LegoContainer = /** @class */ (function (_super) {
    Object(tslib_es6["c" /* __extends */])(LegoContainer, _super);
    function LegoContainer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.initComplete = false;
        _this.dataLoadAttempts = 0;
        _this.legacyCatalogApi = true;
        _this.u26rebate = false;
        _this.options = {};
        _this.currentSelection = {};
        _this.i18n = {};
        _this.isEditMode = false;
        _this.mobileConfigData = null;
        _this.mobileOptional = false;
        _this.configString = null;
        _this.deepLinkConf = null;
        _this.ui = {};
        _this.slidersInitialized = 0;
        _this.disabledSliderState = {};
        return _this;
    }
    LegoContainer.prototype.on = function (callback) {
        this.initComponent();
        this.cacheUi();
        this.initUi();
        this.updateSummaryPosition();
        this.addEventListeners();
        callback();
    };
    LegoContainer.prototype.after = function () {
        // Start module.
        this.loadData();
    };
    LegoContainer.prototype.initComponent = function () {
        this.serviceUrl = this.$ctx.data('serviceurl');
        this.legacyCatalogApi = this.$ctx.data('service-legacy-catalog-api');
        if (!this.legacyCatalogApi) {
            DISABLED_VALUES['tv-disable'] = SKU_DISABLED_VALUES.tv;
            DISABLED_VALUES['voip-disable'] = SKU_DISABLED_VALUES.voip;
        }
        this.segment = this.$ctx.data('segment');
        this.u26rebate = (this.$ctx.data('u26-rebate') && this.segment === 'res');
        this.options[MOBILE_ABO_DEVICE_TOGGLE] = 'false'; // This could be made more flexible, but at the moment this is a fixed default.
        this.i18n.selected = this.$ctx.data('i18n-selected');
        this.i18n.monthShort = this.$ctx.data('i18n-month-abbrev');
        this.isEditMode = this.$ctx.hasClass('isEditMode');
        this.mobileConfigData = this.$ctx.data('mobileConfig') || null;
        this.sandbox.subscribe('LEGO_CONTAINER', this);
        this.mobileOptional = this.$ctx.data('mobile-optional') && !this.isEditMode;
        this.configString = util_url["hashDeepLink"].get('lpIds') || this.readFromStorage();
        this.deepLinkConf = this.deserializeDeeplink(this.configString);
    };
    LegoContainer.prototype.cacheUi = function () {
        this.ui.summaryBar = this.$ctx.find('.summaryBar');
        this.ui.servicesUl = this.ui.summaryBar.find('.services');
        this.ui.services = this.ui.servicesUl.find('li');
        this.ui.costList = this.ui.summaryBar.find('.cost-list');
        this.ui.benefit = this.ui.summaryBar.find('.benefit');
        this.ui.bundlePrice = this.ui.costList.find('.bundle-price .price span');
        this.ui.mobilePrice = this.ui.costList.find('.mobile-price .price span');
        this.ui.mobilePriceDetails = this.ui.costList.find('li:not(.bundle-price)');
        this.ui.actionLink = this.ui.summaryBar.find('.actions .lego-details-link');
        this.ui.orderButton = this.$ctx.find('.modLegoOrderButton .lego-order-button');
        this.ui.total = this.ui.summaryBar.find('.total span');
        this.ui.collapseButton = this.ui.summaryBar.find('.expand-collapse');
        if (!this.mobileConfigData && Object(helpers["isMobilePage"])()) {
            // The prices are hidden in 3P mode and the services list is hidden in mobile view ⇒ there is nothing to toggle
            this.ui.collapseButton.hide();
        }
        this.ui.document = external___window__g_____g_$_____window_$CQ____window_$____window_jQuery__default()(document);
        this.ui.window = external___window__g_____g_$_____window_$CQ____window_$____window_jQuery__default()(window);
        this.ui.footer = external___window__g_____g_$_____window_$CQ____window_$____window_jQuery__default()('.scs-pagefooter');
        this.ui.u26Rebate = this.ui.summaryBar.find('.u26Rebate');
        this.ui.u26benefit = this.ui.summaryBar.find('.u26benefit');
        this.ui.bundleLinks = this.$ctx.find('.legoBundle');
        if (this.mobileOptional) {
            this.ui.orderButtonWithoutMobile = this.$ctx.find('.service-availability-without-mobile');
            this.ui.orderButtonWithMobile = this.$ctx.find('.service-availability-with-mobile');
        }
        var checkBoxSelector = [];
        for (var key in DISABLED_VALUES) {
            checkBoxSelector.push("input[name=\"" + key + "\"]");
        }
        this.ui.checkboxes = this.$ctx.find(checkBoxSelector.join(','));
    };
    LegoContainer.prototype.initUi = function () {
        if (this.mobileConfigData) {
            this.ui.costList.removeClass('hidden');
        }
        else {
            this.ui.u26Rebate.addClass('inOneHome');
            this.ui.benefit.addClass('hidden');
        }
    };
    LegoContainer.prototype.addEventListeners = function () {
        this.ui.actionLink.on('click', this.handleActionLink.bind(this));
        this.ui.collapseButton.on('tap', this.handleToggleCollapse.bind(this));
        this.ui.orderButton.on('click', this.handleOrder.bind(this));
        if (!this.isEditMode) {
            // Call it once initially
            this.handleScroll();
            // Then call it on every scroll.
            this.ui.document.on('scroll', this.handleScroll.bind(this));
        }
    };
    /**
     * Calculate the total price, bundle base price, mobile price, home price
     * @param data - Array
     * @return Object
     */
    LegoContainer.prototype.calculateTotalPrice = function (data) {
        var _this = this;
        var _a, _b, _c, _d;
        if (data === void 0) { data = []; }
        if (this.legacyCatalogApi) {
            return this.calculateTotalPriceLegacy(data);
        }
        external___window__g_____g_$_____window_$CQ____window_$____window_jQuery__default.a.each(data, function (_i, item) {
            _this.currentSelection[item.sliderId] = {
                cost: 0,
                slideId: item.slideId,
                sliderId: item.sliderId,
            };
        });
        var bundleBasePrice = toFloat((_d = (_c = (_b = (_a = this.config) === null || _a === void 0 ? void 0 : _a.pricingBundles) === null || _b === void 0 ? void 0 : _b.find(function (item) {
            return item.configuration.every(function (config) { return config.skuCode === _this.getSkuCodeForFlavour(config); });
        })) === null || _c === void 0 ? void 0 : _c.price) !== null && _d !== void 0 ? _d : NaN);
        var prices = {
            bundleBasePrice: bundleBasePrice,
            homePrice: 0,
            mobilePrice: 0,
            totalPrice: bundleBasePrice,
        };
        return prices;
    };
    LegoContainer.prototype.calculateTotalPriceLegacy = function (data) {
        var _this = this;
        var _a, _b, _c, _d;
        if (data === void 0) { data = []; }
        var bundleBasePrice = toFloat((_b = (_a = this.config) === null || _a === void 0 ? void 0 : _a.bundleBasePrice) !== null && _b !== void 0 ? _b : NaN);
        if (this.u26rebate) {
            bundleBasePrice -= Math.abs(toFloat((_d = (_c = this.config) === null || _c === void 0 ? void 0 : _c.u26PromoPriceDifference) !== null && _d !== void 0 ? _d : NaN));
        }
        var prices = {
            bundleBasePrice: bundleBasePrice,
            homePrice: 0,
            mobilePrice: 0,
            totalPrice: bundleBasePrice,
        };
        external___window__g_____g_$_____window_$CQ____window_$____window_jQuery__default.a.each(data, function (_i, item) {
            _this.currentSelection[item.sliderId] = {
                cost: _this.getFlavourPrice(item.sliderId, item.slideId),
                slideId: item.slideId,
                sliderId: item.sliderId,
            };
        });
        for (var i in this.currentSelection) {
            var slider = this.currentSelection[i];
            if (slider.sliderId === 'mobile') {
                prices.mobilePrice = slider.cost;
            }
            prices.totalPrice += slider.cost;
        }
        prices.homePrice = prices.totalPrice - prices.mobilePrice;
        return prices;
    };
    LegoContainer.prototype.getSkuCodeForFlavour = function (item) {
        var type = SLIDERS_FLAVOR_MAPPING[item.productType];
        var slider = this.currentSelection[type];
        if (slider === undefined) {
            return SKU_DISABLED_VALUES[type];
        }
        return slider.slideId;
    };
    /**
     * - Separate product configuration from options: split('--')
     * - product config and options are separated by __ (double underscore)
     * - key/value pairs are separated by - (minus)
     */
    LegoContainer.prototype.deserializeDeeplink = function (deepLink) {
        return Object(map["parseLegoContainerDeeplink"])(decodeURIComponent(deepLink || ''), this.getFlavourPrice.bind(this));
    };
    LegoContainer.prototype.getFlavourPrice = function (serviceId, flavourId) {
        var _a;
        if (!this.config) {
            // Wait until config data is loaded via ajax
            return 0;
        }
        if (!(serviceId in this.config)) {
            this.log.warn('Unknown LegoContainer Service ID:', serviceId, this.config);
            return 0;
        }
        var service = this.config[serviceId];
        for (var _b = 0, _c = (_a = service === null || service === void 0 ? void 0 : service.flavours) !== null && _a !== void 0 ? _a : []; _b < _c.length; _b++) {
            var flavour = _c[_b];
            if (flavour.siebelId && flavour.siebelId === flavourId) {
                return toFloat(flavour.priceDifference);
            }
        }
        this.log.warn('Unknown LegoContainer Flavour ID:', flavourId, service === null || service === void 0 ? void 0 : service.flavours);
        return 0;
    };
    LegoContainer.prototype.getLocationString = function () {
        var location = 'inone_';
        location += (this.segment === 'res') ? 'home' : 'pro';
        location += '_configurator_';
        location += (this.mobileConfigData) ? 'mobile' : 'no-mobile';
        return location;
    };
    /**
     * Trasnform the current selection into a data set with a different form.
     */
    LegoContainer.prototype.getUpdateDataFromCurrentSelection = function () {
        var _this = this;
        return Object.keys(this.currentSelection)
            .map(function (sliderId) {
            var value = _this.currentSelection[sliderId];
            return { sliderId: sliderId, slideId: value.slideId, cost: value.cost };
        });
    };
    LegoContainer.prototype.loadData = function () {
        var _this = this;
        // If the config object is already set, don't load again.
        if (!external___window__g_____g_$_____window_$CQ____window_$____window_jQuery__default.a.isEmptyObject(this.config)) {
            return;
        }
        // Try to load 3 times if not success
        external___window__g_____g_$_____window_$CQ____window_$____window_jQuery__default.a.ajax({ url: this.serviceUrl, dataType: 'json', headers: { 'X-OCE-CLIENT': 'aem-portal' } })
            .done(function (data) {
            if (data && !external___window__g_____g_$_____window_$CQ____window_$____window_jQuery__default.a.isEmptyObject(data)) {
                if (_this.legacyCatalogApi) {
                    _this.config = _this.segment === 'res' ? data.productCatalogRES : data.productCatalogSME;
                }
                else {
                    _this.config = data;
                }
                // Merge mobile data into config data if exists
                if (_this.mobileConfigData) {
                    _this.config.mobile = {
                        flavours: _this.mobileConfigData,
                    };
                }
                _this.handleDataSuccess();
            }
        })
            .fail(function () {
            if (_this.dataLoadAttempts < 3) {
                _this.dataLoadAttempts += 1;
                setTimeout(_this.loadData.bind(_this), 500);
            }
            else {
                _this.handleDataFail();
            }
        });
    };
    LegoContainer.prototype.handleActionLink = function (event) {
        var $link = external___window__g_____g_$_____window_$CQ____window_$____window_jQuery__default()(event.currentTarget);
        var href = $link.prop('href');
        $link.prop('href', href + "#lpIds=" + this.serializeDeeplink());
    };
    LegoContainer.prototype.handleBundleLink = function (event) {
        event.preventDefault();
        event.stopImmediatePropagation();
        var link = external___window__g_____g_$_____window_$CQ____window_$____window_jQuery__default()(event.currentTarget);
        var deepLinks = this.deserializeDeeplink(link.prop('hash').substr(7));
        if (deepLinks && deepLinks.config.length) {
            this.preselectSliderPositions(deepLinks.config);
            var trackingInfo = {
                action: 'select',
                category: 'preselection',
                label: getTrackingIdString(deepLinks.config),
                location: this.getLocationString(),
                selectedProducts: deepLinks.config,
            };
            this.track(trackingInfo);
        }
        else {
            this.log('handleBundleLink > POSSIBLE CONTENT ISSUE: Url malformed!');
        }
    };
    LegoContainer.prototype.handleDataSuccess = function () {
        if (this.deepLinkConf && this.deepLinkConf.config.length) {
            this.setInitialOptions(this.deepLinkConf.options);
            this.initComplete = true;
            this.updateSummaryUi(this.deepLinkConf.config);
        }
    };
    LegoContainer.prototype.handleDataFail = function () {
        if (this.$ctx.data('map-load-error') && !this.isEditMode) {
            SDXModalDialog["default"].show({
                buttons: [{
                        primary: true,
                        title: 'Ok',
                        type: 'close',
                    }],
                displayMode: 'prompt',
                text: this.$ctx.data('map-load-error'),
                title: 'Error',
            });
        }
    };
    LegoContainer.prototype.handleOrder = function () {
        var trackingInfo = {
            conversionCategory: 'offer',
            conversionClass: 'subscription',
            conversionDetail: 'selected',
            product: getTrackingIdString(this.currentSelection),
            selectedProducts: this.currentSelection,
        };
        this.track(trackingInfo);
    };
    LegoContainer.prototype.handleScroll = function () {
        var footerHeight = this.ui.footer.height();
        var footerVisible = ((this.ui.document.height() - this.ui.document.scrollTop() - this.ui.window.height()) < footerHeight);
        this.ui.summaryBar.toggleClass('sticky', !footerVisible);
        this.ui.summaryBar.css('bottom', (footerVisible) ? footerHeight : 0);
    };
    LegoContainer.prototype.handleToggleCollapse = function (event) {
        var $icon = this.ui.collapseButton.find('.icon');
        event.preventDefault();
        event.stopImmediatePropagation();
        if ($icon.is('.icon-016-chevron-up')) {
            $icon.removeClass('icon-016-chevron-up').addClass('icon-013-chevron-down');
            this.ui.summaryBar.removeClass('collapsed');
            this.ui.servicesUl.removeClass('hidden');
            this.ui.actionLink.removeClass('hidden');
            if (!this.mobileConfigData) {
                return;
            }
            this.ui.costList.removeClass('hidden');
        }
        else {
            $icon.removeClass('icon-013-chevron-down').addClass('icon-016-chevron-up');
            this.ui.summaryBar.addClass('collapsed');
            this.ui.costList.addClass('hidden');
            this.ui.actionLink.addClass('hidden');
            this.ui.servicesUl.addClass('hidden');
        }
        this.updateSummaryPosition();
    };
    LegoContainer.prototype.isBundleConfiguration = function () {
        var _this = this;
        this.ui.bundleLinks.each(function (_index, link) {
            var _a;
            var linkServiceIds = _this.deserializeDeeplink(link.hash.substring(7));
            external___window__g_____g_$_____window_$CQ____window_$____window_jQuery__default()(link)
                .find('.mod.modCard')
                .toggleClass('active', _this.isCurrentConfiguration((_a = linkServiceIds === null || linkServiceIds === void 0 ? void 0 : linkServiceIds.config) !== null && _a !== void 0 ? _a : []));
        });
    };
    /**
     * Comparing the link configuration to the current Configuration
     */
    LegoContainer.prototype.isCurrentConfiguration = function (linkConfiguration) {
        for (var _a = 0, linkConfiguration_1 = linkConfiguration; _a < linkConfiguration_1.length; _a++) {
            var config = linkConfiguration_1[_a];
            var service = this.currentSelection[config.sliderId];
            if (!service || service.slideId !== config.slideId) {
                return false;
            }
        }
        return true;
    };
    /**
     * Preselect a slider element. Better said, send a slide id to sliders and they will
     * activate the element if they encounter a match.
     *
     * @param slideConfigurations - Array of slide Ids
     */
    LegoContainer.prototype.preselectSliderPositions = function (slideConfigurations) {
        var slidesAndCheckboxes = separateSlidesAndCheckboxes(slideConfigurations);
        this.toggleCheckboxes(slidesAndCheckboxes.checkboxes);
        if (slidesAndCheckboxes.slides.length) {
            // Send to all sliders to position themselves in the right configuration.
            this.fire('sliderGotoSlide', { slideId: slidesAndCheckboxes.slides }, ['SLIDER']);
        }
    };
    LegoContainer.prototype.persistToStorage = function (dataString) {
        try {
            window.sessionStorage.setItem('legoSessionConfig', dataString);
        }
        catch (e) {
            this.log('Can not persist data to session storage', e);
        }
    };
    LegoContainer.prototype.readFromStorage = function () {
        try {
            return window.sessionStorage.getItem('legoSessionConfig');
        }
        catch (e) {
            this.log('Can not read from session storage', e);
        }
        return null;
    };
    /**
     * Pattern for serialization:
     * - Each serviceId/siebelId pair is combined by a - (minus)
     * - All pairs are combined by __ (double underscores)
     * - Options are key/value pairs combined with a - (minus)
     * - Multiple options can be added by combining with a __ (double underscore)
     * - Options are appended at the end with a -- (double minus)
     *
     * i.e. serviceId_siebelId__serviceId2_siebelId2--option1key=option1value
     */
    LegoContainer.prototype.serializeDeeplink = function (rawUrl) {
        var _this = this;
        if (rawUrl === void 0) { rawUrl = false; }
        var serialized = Object.keys(this.currentSelection)
            .map(function (key) {
            var value = _this.currentSelection[key];
            return key + "-" + value.slideId;
        });
        var options = [
            // Adding mobile subscription option: with or without device option
            MOBILE_ABO_DEVICE_TOGGLE + "-" + this.options[MOBILE_ABO_DEVICE_TOGGLE],
        ];
        var deeplink = serialized.join('__') + "--" + options.join('__');
        return rawUrl ? deeplink : encodeURIComponent(deeplink);
    };
    /**
     * Setting the initial state of options
     * (i.e. mobile subscription with or without device)
     */
    LegoContainer.prototype.setInitialOptions = function (options) {
        if (MOBILE_ABO_DEVICE_TOGGLE in options) {
            this.updateMobileDeviceOption(options[MOBILE_ABO_DEVICE_TOGGLE]);
        }
    };
    /**
     * Toggling the state of a ui checkbox.
     *
     * @param checkboxIds - Array of checkbox ids to toggle
     */
    LegoContainer.prototype.toggleCheckboxes = function (checkboxIds) {
        var mod = this;
        mod.ui.checkboxes.prop('checked', false).trigger('change');
        // Check if any of the checkboxes are part of the slider configuration:
        for (var _a = 0, checkboxIds_1 = checkboxIds; _a < checkboxIds_1.length; _a++) {
            var checkboxId = checkboxIds_1[_a];
            var checkboxKey = keyForValue(DISABLED_VALUES, checkboxId);
            if (checkboxKey) {
                mod.ui.checkboxes.filter("[name=\"" + checkboxKey + "\"]").prop('checked', true).trigger('change');
            }
        }
    };
    LegoContainer.prototype.updateMobileDeviceOption = function (newValue) {
        this.options[MOBILE_ABO_DEVICE_TOGGLE] = newValue;
        this.toggleMobilePrices(newValue);
    };
    LegoContainer.prototype.toggleMobilePrices = function (usePriceWithDevice) {
        var _a, _b, _c, _d;
        if (!((_b = (_a = this.config) === null || _a === void 0 ? void 0 : _a.mobile) === null || _b === void 0 ? void 0 : _b.flavours)) {
            return;
        }
        for (var _e = 0, _f = this.config.mobile.flavours; _e < _f.length; _e++) {
            var flavour = _f[_e];
            if (usePriceWithDevice === 'true') {
                flavour.priceDifference = toFloat((_c = flavour.priceWithDevice) !== null && _c !== void 0 ? _c : 0);
            }
            else {
                flavour.priceDifference = toFloat((_d = flavour.price) !== null && _d !== void 0 ? _d : 0);
            }
        }
    };
    LegoContainer.prototype.toggleOrderButton = function () {
        var mobileDisabled = (this.currentSelection.mobile && this.currentSelection.mobile.slideId === DISABLED_VALUES['mobile-disable']);
        this.ui.orderButtonWithoutMobile.toggleClass('hidden', mobileDisabled);
        this.ui.orderButtonWithMobile.toggleClass('hidden', !mobileDisabled);
    };
    LegoContainer.prototype.track = function (data) {
        var interaction = new SCS.portal.datalayer.Interaction();
        SCS.portal.datalayer.resetProductList();
        if (data.conversionCategory && data.conversionDetail) {
            interaction.withConversion(data.conversionCategory, data.conversionDetail, data.conversionClass);
        }
        if (data.selectedProducts) {
            SCS.portal.datalayer.addInOneProduct(this.config.bundleSiebelId, this.config.bundleBasePrice, 'bundle');
            external___window__g_____g_$_____window_$CQ____window_$____window_jQuery__default.a.each(data.selectedProducts, function (_index, item) {
                SCS.portal.datalayer.addInOneProduct(item.slideId, item.cost, 'flavour');
            });
        }
        if (data.action) {
            interaction.withEvent(data.action, data.label, data.location, data.category, data.linkName);
        }
        interaction.track();
    };
    /**
     * The summary bar has to be below the content.
     * Hence the lego configurator gets bottom padding in the height of the summaryBar.
     */
    LegoContainer.prototype.updateSummaryPosition = function () {
        this.$ctx.css('padding-bottom', this.ui.summaryBar.outerHeight(true));
    };
    LegoContainer.prototype.updateSummaryUi = function (data) {
        var mod = this;
        var prices = mod.calculateTotalPrice(data);
        mod.ui.mobilePriceDetails.removeClass('disabled');
        mod.ui.u26benefit.removeClass('disabled');
        mod.ui.total.text(SCS.utils.formatPriceWithDash(prices.totalPrice));
        mod.ui.services.addClass('hidden');
        external___window__g_____g_$_____window_$CQ____window_$____window_jQuery__default.a.each(this.currentSelection, function (key, value) {
            if (!value) {
                return;
            }
            var $service = mod.ui.services.filter('.' + String(key));
            var isServiceDisabled = Object.keys(DISABLED_VALUES)
                .map(function (k) { return DISABLED_VALUES[k]; })
                .includes(value.slideId);
            $service.toggleClass('hidden', isServiceDisabled);
            if (!isServiceDisabled) {
                var flavourSize = void 0;
                if (key === 'mobile') {
                    var siebelMapping = external___window__g_____g_$_____window_$CQ____window_$____window_jQuery__default.a.map(mod.mobileConfigData, function (val) {
                        return val.siebelId === value.slideId ? [val.siebelName, val.summaryLabel || 'inOne'] : null;
                    });
                    flavourSize = Object(map["flavourSizeFromSiebelId"])(siebelMapping[0]);
                    mod.ui.costList.find('.mobile-price .abo-type').text(siebelMapping[1]);
                }
                else {
                    flavourSize = Object(map["flavourSizeFromSiebelId"])(value.slideId);
                }
                $service.find('span').not('.serviceName, .swisscomIconFont').removeClass().text(flavourSize).addClass(flavourSize);
            }
            else if (value.slideId === DISABLED_VALUES['mobile-disable']) {
                mod.ui.mobilePriceDetails.addClass('disabled');
                mod.ui.u26benefit.addClass('disabled');
            }
        });
        if (mod.mobileConfigData) {
            mod.ui.mobilePrice.text(SCS.utils.formatPriceWithDash(prices.mobilePrice));
            mod.ui.bundlePrice.text(SCS.utils.formatPriceWithDash(prices.homePrice));
        }
        if (mod.mobileOptional) {
            this.toggleOrderButton();
        }
        mod.updateSummaryPosition();
        // Only after initialization is complete we should rewrite the hash and local storage.
        if (mod.initComplete) {
            // Get the deeplink unencoded as `SCS.HashDeepLink.set()` will encode the url also...
            var deeplink = mod.serializeDeeplink(true);
            // ... but encode it for local storage, because `deserializeDeepLink` will expect an encoded string
            mod.persistToStorage(encodeURIComponent(deeplink));
            util_url["hashDeepLink"].set('lpIds', deeplink, ',', false);
        }
    };
    /**
     * Informs the Lego Order Button about selection changes.
     * Sends the selected products IDs, current prices, and all available Internet flavours.
     */
    LegoContainer.prototype.broadcastConfigurationChanged = function (currentSelection, prices) {
        var _a;
        // Internet should always be set, but it is possible that this
        // method is called before the internet service is initialized.
        if (!((_a = this.config) === null || _a === void 0 ? void 0 : _a.internet)) {
            return;
        }
        var productIds = this.config.internet.flavours;
        var deeplinkHashParameters = this.serializeDeeplink();
        if (this.currentSelection.mobile && this.currentSelection.mobile.slideId) {
            // The only reason for the subscriptionId parameter is for the 4p order form and was implemented as a quickfix
            // the 4p form hosts a hidden field with the name of `subscriptionId` that will pickup this value automatically.
            // this param is NOT needed for the lego container.
            deeplinkHashParameters += '&subscriptionId=' + encodeURIComponent(this.currentSelection.mobile.slideId);
        }
        this.log('broadcastConfigurationChanged', currentSelection, deeplinkHashParameters, prices, productIds);
        this.fire('newLegoConfiguration', {
            currentSelection: currentSelection,
            deeplinkHashParameters: deeplinkHashParameters,
            prices: prices,
            productIds: productIds,
        }, ['LEGO_CONTAINER']);
    };
    return LegoContainer;
}(Module["a" /* Module */]));
/* harmony default export */ var Tc_Module_LegoContainer = (Tc_Module_LegoContainer_LegoContainer);

// CONCATENATED MODULE: ./clientlibs/js/lib/ecommerce/lego/skins/AdvisorSummary.ts





function getFlavour(flavourId, flavours) {
    var _a;
    return (_a = flavours.find(function (flavour) { return flavour.siebelId === flavourId; })) !== null && _a !== void 0 ? _a : null;
}
// tslint:disable-next-line: variable-name
var AdvisorSummary_AdvisorSummary = function AdvisorSummary(parent) {
    /**
     * Initialize the component
     */
    this.initComponent = function () {
        parent.initComponent.call(this);
        this.sandbox.subscribe('LEGO_CONTAINER', this);
        this.conversionCategory = this.$ctx.data('conversionCategory');
        this.conversionDetail = this.$ctx.data('conversionDetail');
        this.conversionClass = this.$ctx.data('conversionClass');
        this.discounts = this.$ctx.data('discount-config') || [];
        this.currentDiscounts = [];
        this.prices = 0;
        this.discountTemplate = load_dot["a" /* default */].template(this.$ctx.find('script.tmpl-discount').html());
        this.u26rebate = this.$ctx.data('u26-rebate');
    };
    /**
     * Cache all ui elements
     */
    this.cacheUi = function () {
        this.ui = {};
        this.ui.form = this.$ctx.closest('.modScForm');
        this.ui.error = this.$ctx.find('.error');
        this.ui.content = this.$ctx.find('.content');
        this.ui.radio = this.ui.form.find('[type="radio"]');
        this.ui.details = this.$ctx.find('.legoDetailContainer');
        this.ui.price = this.$ctx.find('.price');
        this.ui.priceMonthly = this.$ctx.find('.monthly-price');
        this.ui.monthlyAmount = this.$ctx.find('.monthly-price .amount');
        this.ui.totalAmount = this.$ctx.find('.total-price .amount');
        var $actionsMenu = this.$ctx.find('.actions');
        this.$actions = {};
        this.$actions.$normal = $actionsMenu.find('.normal');
        this.$actions.$u26 = $actionsMenu.find('.u26rebate');
        this.$actions.normalLink = this.$actions.$normal.find('.flat-button.secondary');
        this.$actions.normalOrder = this.$actions.$normal.find('.modLegoOrderButton .lego-order-button');
        this.$actions.u26lLink = this.$actions.$u26.find('.flat-button.secondary');
        this.$actions.u26Order = this.$actions.$u26.find('.modLegoOrderButton .lego-order-button');
        if (!this.isEditMode) {
            this.ui.details.addClass('hidden');
        }
    };
    /**
     * Calculate all prices that are needed for the lego order button
     * from the current selection.
     */
    this.getPricesFromCurrentSelection = function () {
        var prices = {
            bundleBasePrice: this.config.bundleBasePrice,
            homePrice: 0,
            mobilePrice: 0,
            totalPrice: this.config.bundleBasePrice,
        };
        // Check for selected discounts
        external___window__g_____g_$_____window_$CQ____window_$____window_jQuery__default.a.each(this.currentDiscounts, function (_i, discount) {
            prices.totalPrice += toFloat(discount.amount);
        });
        external___window__g_____g_$_____window_$CQ____window_$____window_jQuery__default.a.each(this.currentSelection, function (_i, item) {
            if (item.sliderId === 'mobile') {
                prices.mobilePrice = item.cost;
            }
            prices.totalPrice += item.cost;
        });
        prices.homePrice = prices.totalPrice - prices.mobilePrice;
        return prices;
    };
    /**
     * Calculate the total price
     */
    this.calculateTotalPrice = function () {
        var _a;
        var amount = Object(tslib_es6["a" /* __assign */])(Object(tslib_es6["a" /* __assign */])({}, parent.calculateTotalPrice.call(this, (_a = this.deepLinkConf) === null || _a === void 0 ? void 0 : _a.config)), { discount: 0, monthly: this.config.bundleBasePrice, total: 0 });
        external___window__g_____g_$_____window_$CQ____window_$____window_jQuery__default.a.each(this.currentSelection, function (_serviceName, service) {
            amount.monthly += service.cost;
        });
        // Check for selected discounts
        external___window__g_____g_$_____window_$CQ____window_$____window_jQuery__default.a.each(this.currentDiscounts, function (_index, discount) {
            amount.discount += toFloat(discount.amount);
        });
        amount.total = amount.monthly + amount.discount;
        return amount;
    };
    /**
     * Clear any previously set discounts from the price ui
     */
    this.clearDiscounts = function () {
        this.ui.price.find('.discount').remove();
    };
    this.updateActionButtons = function () {
        if (!this.u26rebate) {
            return;
        }
        this.$actions.$normal.toggleClass('hidden', this.isDiscountActive('u26PromoPriceDifference'));
        this.$actions.$u26.toggleClass('hidden', !this.isDiscountActive('u26PromoPriceDifference'));
    };
    this.isDiscountActive = function (discountId) {
        return this.currentDiscounts
            .map(function (discount) { return discount.discountId; })
            .includes(discountId);
    };
    /**
     * Overrides for the methods in base class that would
     * cause trouble here if they weren't silenced.
     */
    this.initUi = external___window__g_____g_$_____window_$CQ____window_$____window_jQuery__default.a.noop;
    this.handleScroll = external___window__g_____g_$_____window_$CQ____window_$____window_jQuery__default.a.noop;
    this.updateSummaryPosition = external___window__g_____g_$_____window_$CQ____window_$____window_jQuery__default.a.noop;
    this.addEventListeners = function () {
        this.$actions.normalLink.on('click', this.handleActionLink.bind(this));
        this.$actions.u26lLink.on('click', this.handleActionLink.bind(this));
        this.ui.form.on('stepchange', this.handleMultiPageStepChanged.bind(this));
        this.$actions.normalOrder.on('click', this.handleOrder.bind(this));
        this.$actions.u26Order.on('click', this.handleOrder.bind(this));
    };
    /**
     * Retrieve a discount amount, either the one found in the data set
     * loaded by a third-party environment or the one provided through the
     * component dialog.
     *
     * Are both set, the third-party data shall precede.
     */
    this.getDiscountAmount = function (discount) {
        var _a, _b;
        var config = (_a = this.config) !== null && _a !== void 0 ? _a : {};
        if (config.hasOwnProperty(discount.discountId)) {
            return (_b = toFloat(config[discount.discountId])) !== null && _b !== void 0 ? _b : 0;
        }
        return discount.amount || 0;
    };
    /**
     * Providing a flavour id, find the services this flavour belongs to.
     */
    this.isService = function (flavourId) {
        for (var _a = 0, _b = this.services; _a < _b.length; _a++) {
            var serviceId = _b[_a];
            var service = this.config[serviceId];
            var flavour = getFlavour(flavourId, service.flavours);
            if (flavour) {
                return { sliderId: serviceId, slideId: flavourId, cost: flavour.priceDifference };
            }
        }
        return null;
    };
    /**
     * Figure out if a provided id is a discount.
     */
    this.isDiscount = function (discountId) {
        for (var _a = 0, _b = this.discounts; _a < _b.length; _a++) {
            var discount = _b[_a];
            if (discount.discountId && discount.discountId === discountId) {
                discount.amount = this.getDiscountAmount(discount);
                return discount;
            }
        }
        return null;
    };
    /**
     * Generates a tracking object
     */
    this.getTrackingConfig = function () {
        var selectedProducts = [];
        external___window__g_____g_$_____window_$CQ____window_$____window_jQuery__default.a.each(this.currentSelection, function (_key, value) {
            selectedProducts.push(value);
        });
        return {
            conversionCategory: this.conversionCategory,
            conversionClass: this.conversionClass,
            conversionDetail: this.conversionDetail,
            selectedProducts: selectedProducts,
        };
    };
    /**
     * Event handler that is called after third-party data was loaded failed.
     */
    this.handleDataFail = function () {
        if (!this.isEditMode) {
            this.ui.error.removeClass('hidden');
        }
    };
    /**
     * Event handler that is called after third-party data was loaded successfully.
     */
    this.handleDataSuccess = function () {
        var _this = this;
        var _a;
        this.ui.content.removeClass('hidden');
        if (!this.isEditMode) {
            // Filter all the services keys from the returned json.
            // use only the ones with a flavours array.
            var config_1 = (_a = this.config) !== null && _a !== void 0 ? _a : {};
            this.services = Object.keys(this.config)
                .filter(function (key) {
                if (!(key in config_1) || !config_1[key]) {
                    return false;
                }
                var service = config_1[key];
                if (typeof service !== 'object') {
                    return false;
                }
                return 'flavours' in service;
            });
            // Go through all selected options and find the service
            this.updateCurrentSelection();
            this.updatePricesUi();
            this.updateSummaryUi();
            this.broadcastConfigurationChanged(this.currentSelection, this.getPricesFromCurrentSelection());
            if (this.conversionCategory && this.conversionDetail) {
                setTimeout(function () {
                    _this.track(_this.getTrackingConfig());
                }, 500);
            }
        }
    };
    /**
     * Update the summery every time a step changes
     */
    this.handleMultiPageStepChanged = function (event) {
        this.log('event', event);
        // If the data load failed before, try to do that again.
        if (!this.services) {
            this.loadData();
        }
        else {
            // Reset the current selection, as it may have changed
            this.currentSelection = {};
            this.updateCurrentSelection();
            this.updatePricesUi();
            this.updateSummaryUi();
            this.broadcastConfigurationChanged(this.currentSelection, this.getPricesFromCurrentSelection());
        }
    };
    this.loadData = function () {
        if (!this.isEditMode) {
            this.ui.error.addClass('hidden');
            this.ui.content.addClass('hidden');
        }
        parent.loadData.call(this);
    };
    /**
     * Check if a container id matches a currently selected flavour.
     */
    this.hideContainer = function (containerId) {
        var hide = true;
        // If the container does not have any id set, we want to always display it.
        if (typeof containerId === 'undefined' || containerId.length === 0) {
            return false;
        }
        external___window__g_____g_$_____window_$CQ____window_$____window_jQuery__default.a.each(this.currentSelection, function (_serviceName, service) {
            if (containerId.indexOf(service.slideId) > -1) {
                hide = false;
                return false; // Break $.each
            }
            return undefined;
        });
        return hide;
    };
    /**
     * Update the current selection model with values from a new service
     * But only if the services flavour has a higher price than the
     * service that is store in the current selection with the same name.
     */
    this.setCurrentSelection = function (service) {
        if (!this.currentSelection[service.sliderId] || this.currentSelection[service.sliderId].cost < service.cost) {
            this.currentSelection[service.sliderId] = service;
        }
    };
    /**
     * Go through all checked radio buttons in the multi-step form.
     * If the value matches a service in the data model set it as a
     * current selection.
     *
     * If it's not a service check if it matches a discount in the discount
     * model and store it in the current discounts if so.
     */
    this.updateCurrentSelection = function () {
        var mod = this;
        this.currentDiscounts = [];
        external___window__g_____g_$_____window_$CQ____window_$____window_jQuery__default.a.each(this.ui.radio.filter(':checked'), function (_i, radio) {
            var service = mod.isService(external___window__g_____g_$_____window_$CQ____window_$____window_jQuery__default()(radio).val());
            // It is a service...
            if (service) {
                // ... store in currentSelection
                mod.setCurrentSelection(service);
                // And continue;
                return;
            }
            // It's not a service. maybe it's a discount
            var discount = mod.isDiscount(external___window__g_____g_$_____window_$CQ____window_$____window_jQuery__default()(radio).val());
            if (discount) {
                mod.currentDiscounts.push(discount);
            }
        });
        this.updateActionButtons();
        // Hard-code no mobile option so the deeplink to the
        // configurator will disable the mobile option.
        // According to Bettina Breiter the advisor will NEVER
        // contain mobile options
        this.currentSelection.mobile = { sliderId: 'mobile', slideId: 'N_LEGO No Mobile', cost: 0 };
    };
    /**
     * Update the price ui with monthly prices, total prices and discounts.
     */
    this.updatePricesUi = function () {
        var amount = this.calculateTotalPrice();
        this.ui.monthlyAmount.text(SCS.utils.formatPriceWithDash(amount.monthly));
        this.ui.totalAmount.text(SCS.utils.formatPriceWithDash(amount.total));
        this.clearDiscounts();
        var mod = this;
        var discounts = '';
        external___window__g_____g_$_____window_$CQ____window_$____window_jQuery__default.a.each(this.currentDiscounts, function (_i, discount) {
            discounts += mod.discountTemplate({
                amount: SCS.utils.formatPriceWithDash(discount.amount),
                disclaimer: discount.disclaimer,
                hasDisclaimer: (discount.disclaimer.length > 0),
                label: discount.label,
            });
        });
        this.ui.priceMonthly.after(discounts);
        Object(helpers["initNewModules"])(this.ui.price);
    };
    /**
     * Update the summary user interface.
     */
    this.updateSummaryUi = function () {
        var mod = this;
        this.ui.details.each(function () {
            var $container = external___window__g_____g_$_____window_$CQ____window_$____window_jQuery__default()(this);
            var id = $container.data('id');
            external___window__g_____g_$_____window_$CQ____window_$____window_jQuery__default()(this).toggleClass('hidden', mod.hideContainer(id));
        });
    };
};

// CONCATENATED MODULE: ./clientlibs/js/lib/ecommerce/lego/skins/Configurator.ts



// tslint:disable-next-line: variable-name
var Configurator_Configurator = function Configurator(parent) {
    this.initComponent = function () {
        parent.initComponent.call(this);
        this.sandbox.subscribe('SLIDER', this);
        this.allSlidesInitialized = false;
        this.dataLoaded = false;
        this.trackUserInteractionWithSlider = false;
    };
    this.addEventListeners = function () {
        parent.addEventListeners.call(this);
        this.ui.bundleLinks.on('click', this.handleBundleLink.bind(this));
        this.ui.checkboxes.on('change', this.handleCheckbox.bind(this));
        this.ui.slider.on('mousedown touchstart', this.handleSliderInteraction.bind(this));
        this.$ctx.find('.bx-controls a').on('mousedown', this.handleSliderInteraction.bind(this));
        this.ui.purchaseMobileDeviceToggle.on('change', this.handlePurchaseMobileDevice.bind(this));
    };
    this.cacheUi = function () {
        parent.cacheUi.call(this);
        this.ui.slider = this.$ctx.find('.mod.modSlider');
        this.ui.slides = this.$ctx.find('.modSlide');
        this.ui.purchaseMobileDeviceToggle = this.$ctx.find("input[name=\"" + MOBILE_ABO_DEVICE_TOGGLE + "\"]");
        this.ui.slides.find('p:contains("${data.priceDifference}")').addClass('priceContainer').toggleClass('invisible', !this.isEditMode);
    };
    this.setInitialDisabledState = function (updateConfig, extendConfig, forceOverride) {
        var _this = this;
        if (forceOverride === void 0) { forceOverride = false; }
        external___window__g_____g_$_____window_$CQ____window_$____window_jQuery__default.a.each(extendConfig, function (extKey, extConf) {
            var extend = true;
            external___window__g_____g_$_____window_$CQ____window_$____window_jQuery__default.a.each(updateConfig, function (index, updateConf) {
                if (extKey === updateConf.sliderId) {
                    if (forceOverride) {
                        _this.disabledSliderState[extKey] = updateConfig[index].slideId;
                        updateConfig[index] = extConf;
                    }
                    extend = false;
                    return false;
                }
                return undefined;
            });
            if (extend) {
                updateConfig.push(extConf);
                if (_this.currentSelection[extKey]) {
                    _this.disabledSliderState[extKey] = _this.currentSelection[extKey].slideId;
                }
            }
        });
        return updateConfig;
    };
    this.getCheckboxDefaultState = function () {
        var _this = this;
        var checkboxConfig = {};
        var mod = this;
        mod.ui.checkboxes.each(function (_i, checkbox) {
            var $checkbox = external___window__g_____g_$_____window_$CQ____window_$____window_jQuery__default()(checkbox);
            if ($checkbox.prop('checked')) {
                var sliderId = $checkbox.val();
                var slideId = DISABLED_VALUES[$checkbox.prop('name')];
                checkboxConfig[sliderId] = {
                    cost: _this.getFlavourPrice(sliderId, slideId),
                    slideId: slideId,
                    sliderId: sliderId,
                };
            }
        });
        return checkboxConfig;
    };
    this.handleCheckbox = function (event) {
        var checkbox = external___window__g_____g_$_____window_$CQ____window_$____window_jQuery__default()(event.currentTarget);
        var sliderId = checkbox.val();
        var checked = checkbox.prop('checked');
        var siebelId = DISABLED_VALUES[checkbox.prop('name')];
        if (checked) {
            this.disabledSliderState[sliderId] = this.currentSelection[sliderId].slideId;
            var data = {
                cost: this.getFlavourPrice(sliderId, siebelId),
                slideId: siebelId,
                sliderId: sliderId,
            };
            this.updateUI([data]);
            this.broadcastConfigurationChanged(this.currentSelection, this.calculateTotalPrice([data]));
            this.fire('sliderToggleEnable', { sliderId: sliderId, enable: false }, ['SLIDER']); // Tc.Module.Slider.RotatingTeaser
            this.trackCheckbox(siebelId, checked);
        }
        else if (!checkbox.prop('checked') && this.disabledSliderState[sliderId]) {
            var data = {
                cost: 0,
                slideId: this.disabledSliderState[sliderId],
                sliderId: sliderId,
            };
            this.updateUI([data]);
            this.broadcastConfigurationChanged(this.currentSelection, this.calculateTotalPrice([data]));
            this.disabledSliderState[sliderId] = '';
            this.fire('sliderToggleEnable', { sliderId: sliderId, enable: true }, ['SLIDER']);
            this.trackCheckbox(siebelId, checked);
        }
        this.isBundleConfiguration();
    };
    this.handleDataSuccess = function () {
        this.dataLoaded = true;
        if (this.allSlidesInitialized) {
            this.setInitialState();
        }
    };
    this.handlePurchaseMobileDevice = function () {
        this.options[MOBILE_ABO_DEVICE_TOGGLE] = this.ui.purchaseMobileDeviceToggle.filter(':checked').val();
        this.toggleMobilePrices(this.options[MOBILE_ABO_DEVICE_TOGGLE]);
        this.updateSummaryUi(this.currentSelection);
        this.broadcastConfigurationChanged(this.currentSelection, this.calculateTotalPrice(this.getUpdateDataFromCurrentSelection()));
        if (this.config && this.config.mobile && this.currentSelection.mobile && this.currentSelection.mobile.slideId) {
            this.updateFlavourPrices(this.config.mobile, this.currentSelection.mobile.slideId);
        }
    };
    this.handleSliderInteraction = function () {
        this.trackUserInteractionWithSlider = true;
    };
    function getSelectedPrice(flavours, slideId) {
        for (var _a = 0, flavours_1 = flavours; _a < flavours_1.length; _a++) {
            var flavour = flavours_1[_a];
            if (flavour.siebelId === slideId) {
                return toFloat(flavour.priceDifference);
            }
        }
        return null;
    }
    this.preparePriceDifferences = function (flavours, slideId) {
        var differences = {};
        var selectedPrice = getSelectedPrice(flavours, slideId);
        for (var _a = 0, flavours_2 = flavours; _a < flavours_2.length; _a++) {
            var flavour = flavours_2[_a];
            if (flavour.siebelId === slideId) {
                differences[flavour.siebelId] = this.i18n.selected;
                continue;
            }
            var price = toFloat(flavour.priceDifference) - (selectedPrice !== null && selectedPrice !== void 0 ? selectedPrice : 0);
            var prefix = (price > 0) ? '+' : '';
            differences[flavour.siebelId] = prefix + SCS.utils.formatPriceWithDash(price) + this.i18n.monthShort;
        }
        return differences;
    };
    this.setInitialState = function () {
        var checkboxStates = this.getCheckboxDefaultState();
        var configString = util_url["hashDeepLink"].get('lpIds') || this.readFromStorage();
        var initConf = this.deserializeDeeplink(configString);
        if (initConf && initConf.config.length) {
            initConf.config = this.setInitialDisabledState(initConf.config, checkboxStates);
            this.preselectSliderPositions(initConf.config);
            this.trackInitialConfiguration(initConf.config);
            if (!Object.keys(initConf.options).length) {
                this.setInitialOptions(this.options);
            }
            else {
                this.setInitialOptions(initConf.options);
            }
            this.initComplete = true;
            this.updateUI(initConf.config);
            this.broadcastConfigurationChanged(this.currentSelection, this.calculateTotalPrice(initConf.config));
        }
        else {
            var updateData = this.getUpdateDataFromCurrentSelection();
            updateData = this.setInitialDisabledState(updateData, checkboxStates, true);
            this.setInitialOptions(this.options);
            this.initComplete = true;
            this.updateUI(updateData);
            this.broadcastConfigurationChanged(this.currentSelection, this.calculateTotalPrice(updateData));
            this.trackInitialConfiguration(updateData);
        }
    };
    this.trackInitialConfiguration = function (deepLinks) {
        var mod = this;
        var trackingInfo = {
            conversionCategory: 'offer',
            conversionClass: this.getLocationString(),
            conversionDetail: 'preselect',
            selectedProducts: deepLinks,
        };
        setTimeout(function () {
            mod.track(trackingInfo);
        }, 500);
    };
    this.trackCheckbox = function (checkboxValue, checked) {
        if (this.allSlidesInitialized && this.dataLoaded) {
            var trackingInfo = {
                action: 'select',
                category: 'optionchange',
                label: checkboxValue + ((checked) ? '_ON' : '_OFF'),
                location: this.getLocationString(),
                selectedProducts: [{ slideId: checkboxValue }],
            };
            this.track(trackingInfo);
        }
    };
    this.updateFlavourPrices = function (data, activeSlideId) {
        if (data && data.flavours) {
            var mod_1 = this;
            var priceText_1 = mod_1.preparePriceDifferences(data.flavours, activeSlideId);
            external___window__g_____g_$_____window_$CQ____window_$____window_jQuery__default.a.each(data.flavours, function (_i, flavour) {
                var slide = mod_1.ui.slides.filter("[data-id=\"" + flavour.siebelId + "\"]");
                slide.find('.priceContainer').text(priceText_1[flavour.siebelId]).removeClass('invisible');
            });
        }
    };
    this.updateMobileDeviceOption = function (newValue) {
        parent.updateMobileDeviceOption.call(this, newValue);
        this.ui.purchaseMobileDeviceToggle.filter("[value=\"" + newValue + "\"]").prop('checked', true);
    };
    this.updateUI = function (data) {
        var _this = this;
        if (!this.allSlidesInitialized || !this.dataLoaded) {
            return;
        }
        external___window__g_____g_$_____window_$CQ____window_$____window_jQuery__default.a.each(data, function (_i, item) {
            _this.updateFlavourPrices(_this.config[item.sliderId], item.slideId);
        });
        this.updateSummaryUi(data);
        this.isBundleConfiguration();
    };
    /**
     * Terrific Handler, fired by Tc.Module.Slider
     */
    this.onSliderSlideInitialized = function (data) {
        this.slidersInitialized += 1;
        this.allSlidesInitialized = this.slidersInitialized === this.ui.slider.length;
        this.onSliderSlideChanged(data);
        // Wait until all sliders on the page have finished initializing.
        if (this.allSlidesInitialized && this.dataLoaded) {
            this.setInitialState();
        }
    };
    /**
     * Terrific Handler, fired by Tc.Module.Slider
     */
    this.onSliderSlideChanged = function (data) {
        var mod = this;
        mod.updateUI([data]);
        mod.broadcastConfigurationChanged(mod.currentSelection, mod.calculateTotalPrice([data]));
        if (mod.trackUserInteractionWithSlider) {
            mod.trackUserInteractionWithSlider = false;
            var trackingInfo = {
                action: 'select',
                category: 'optionchange',
                label: data.slideId,
                location: mod.getLocationString(),
                selectedProducts: [{ slideId: data.slideId }],
            };
            mod.track(trackingInfo);
        }
    };
    /**
     * Terrific Handler, fired by Tc.Module.LegoOrderButton
     */
    this.onFlavourAvailability = function (_data) {
        // This is a hook to enable/disable features in the configurator.
        // So far this was not implemented.
    };
};

// CONCATENATED MODULE: ./clientlibs/js/lib/ecommerce/lego/skins/ConfiguratorEnt.ts



/**
 * The Enterprise Lego Convigurator allows for a custom data model.
 * The data model is provided through the dialog as a json format,
 * that is then used to drive the summary bar.
 *
 * An additional feature is a dependancy model, that allows a selected
 * flavor to exclude flavours in other services from being selected.
 *
 * @author Matthias Inauen
 * @namespace Tc.Module.LegoContainer
 * @class LegoContainer
 * @decorator ConfiguratorEnt
 * @extends Tc.Module
 *
 */
// tslint:disable-next-line: variable-name
var ConfiguratorEnt_ConfiguratorEnt = function ConfiguratorEnt(parent) {
    /**
     * Initialize the component.
     */
    this.initComponent = function () {
        parent.initComponent.call(this);
        this.sandbox.subscribe('SLIDER', this);
        this.allSlidesInitialized = false;
        this.maxPrice = 0;
        this.blocklist = this.$ctx.data('blacklist');
    };
    /**
     * Attache event listeners for this instance
     */
    this.addEventListeners = function () {
        parent.addEventListeners.call(this);
        this.ui.bundleLinks.on('click', this.handleBundleLink.bind(this));
        this.ui.slider.on('mousedown touchstart', this.handleSliderInteraction.bind(this));
        // Only the primary button receives the url parameters when clicked
        this.ui.summaryBar.find('.flat-button').on('click', this.handleButtonAction.bind(this));
    };
    /**
     * Cache the ui elements needed in this configurator
     */
    this.cacheUi = function () {
        parent.cacheUi.call(this);
        this.ui.slider = this.$ctx.find('.mod.modSlider');
        this.ui.slides = this.$ctx.find('.modSlide');
        this.ui.price = this.ui.summaryBar.find('.price');
        this.ui.priceBar = this.ui.price.find('.price-bar');
        this.ui.priceBarIndicator = this.ui.priceBar.find('.bar');
        this.ui.summaryBundleName = this.ui.summaryBar.find('.bundle-name');
        this.ui.buttonOne = this.ui.summaryBar.find('.modFlatButton').eq(0).find('a.flat-button');
        this.ui.buttonTwo = this.ui.summaryBar.find('.modFlatButton').eq(1).find('a.flat-button');
        this.ui.options = this.$ctx.find('[type="checkbox"]');
    };
    /**
     * Calculate the max cost of the highest flavours
     * @returns {number}
     */
    this.calculateMaxCost = function () {
        var _this = this;
        var _a;
        var maxCost = 0;
        external___window__g_____g_$_____window_$CQ____window_$____window_jQuery__default.a.each(((_a = this.customConfig) !== null && _a !== void 0 ? _a : {}), function (_i, service) {
            maxCost += _this.getHighestPrice(service.flavours);
        });
        return maxCost;
    };
    /**
     * calculate the total price
     */
    this.calculateSingleTotalPrice = function (data) {
        var _this = this;
        var totalPrice = 0;
        // Set currentSelection with calculated flavour prices
        external___window__g_____g_$_____window_$CQ____window_$____window_jQuery__default.a.each(data, function (_i, item) {
            _this.currentSelection[item.sliderId] = {
                cost: _this.getFlavourPrice(item.sliderId, item.slideId),
                slideId: item.slideId,
                sliderId: item.sliderId,
            };
        });
        // Now calculate the total price.
        external___window__g_____g_$_____window_$CQ____window_$____window_jQuery__default.a.each(this.currentSelection, function (_i, item) {
            var _a;
            totalPrice += (_a = item === null || item === void 0 ? void 0 : item.cost) !== null && _a !== void 0 ? _a : 0;
        });
        return totalPrice;
    };
    /**
     * Check the blacklist if any of the flavours need to be disabled
     */
    this.checkBlockList = function () {
        var _this = this;
        var blocked = this.getFullBlockList();
        this.ui.slides.each(function (_i, slide) {
            var slideId = external___window__g_____g_$_____window_$CQ____window_$____window_jQuery__default()(slide).data('id');
            _this.fire('setSlideState', {
                disable: (blocked.list.indexOf(slideId) > -1),
                slideId: slideId,
            }, ['SLIDER']); // Tc.Module.Slider.RotatingTeaser
        });
        this.ui.buttonOne.toggleClass('disabled', blocked.disableButtonOne);
        this.ui.buttonTwo.toggleClass('disabled', blocked.disableButtonTwo);
    };
    /**
     * Get a full list of all blocked slides/flavours by all currently selected slides/flavours
     * @returns {{blacklist: Array, disableButtonOne: boolean, disableButtonTwo: boolean}}
     */
    this.getFullBlockList = function () {
        var _this = this;
        var blocklist = [];
        var disableButtonOne = false;
        var disableButtonTwo = false;
        external___window__g_____g_$_____window_$CQ____window_$____window_jQuery__default.a.each(this.currentSelection, function (_i, item) {
            var itemBlackList = _this.findBlocklist(item === null || item === void 0 ? void 0 : item.slideId);
            if (itemBlackList) {
                blocklist = blocklist.concat(itemBlackList.blacklist.split(','));
                if (!disableButtonOne) {
                    disableButtonOne = itemBlackList.disableButtonOne;
                }
                if (!disableButtonTwo) {
                    disableButtonTwo = itemBlackList.disableButtonTwo;
                }
            }
        });
        return { list: blocklist, disableButtonOne: disableButtonOne, disableButtonTwo: disableButtonTwo };
    };
    /**
     * Find a specific blocklist in the blocklist array.
     *
     * @param siebelId - String
     * @returns {*}
     */
    this.findBlocklist = function (siebelId) {
        for (var _a = 0, _b = this.blocklist; _a < _b.length; _a++) {
            var block = _b[_a];
            if (block.siebelId === siebelId) {
                return block;
            }
        }
        return null;
    };
    /**
     * Set the initial UI state.
     */
    this.initUi = external___window__g_____g_$_____window_$CQ____window_$____window_jQuery__default.a.noop;
    /**
     * Find the currently active bundle link
     * @returns {*} - jQuery object with bundle link.
     */
    this.getActiveBundleLink = function () {
        var $bundleLink = null;
        this.ui.bundleLinks.each(function (_i, link) {
            var card = external___window__g_____g_$_____window_$CQ____window_$____window_jQuery__default()(link).find('.mod.modCard');
            if (card.hasClass('active')) {
                $bundleLink = external___window__g_____g_$_____window_$CQ____window_$____window_jQuery__default()(link);
                return false; // Break jquery each loop
            }
            return undefined;
        });
        return $bundleLink;
    };
    /**
     * Override the getFlavourPrice method, and adjust to this data model
     */
    this.getFlavourPrice = function (serviceId, flavourId) {
        if (!this.customConfig) {
            return 0;
        }
        var service = this.customConfig[serviceId];
        if (!service) {
            return 0;
        }
        for (var _a = 0, _b = service.flavours; _a < _b.length; _a++) {
            var flavour = _b[_a];
            if (flavour.siebelId && flavour.siebelId === flavourId) {
                return toFloat(flavour.price);
            }
        }
        return 0;
    };
    /**
     * Iterate over a flavours array and determine the flavour with the
     * highest price. return that price.
     *
     * @param flavours - Array of flavours
     * @returns {number} - the highest flavour price
     */
    this.getHighestPrice = function (flavours) {
        var highestPrice = 0;
        for (var _a = 0, flavours_1 = flavours; _a < flavours_1.length; _a++) {
            var flavour = flavours_1[_a];
            highestPrice = Math.max(highestPrice, flavour.price);
        }
        return highestPrice;
    };
    /**
     * Print the current selections as a parameter string
     */
    this.getUrlParameters = function () {
        var parameters = [];
        external___window__g_____g_$_____window_$CQ____window_$____window_jQuery__default.a.each(this.currentSelection, function (key, item) {
            parameters.push(key + "=" + (item === null || item === void 0 ? void 0 : item.slideId));
        });
        external___window__g_____g_$_____window_$CQ____window_$____window_jQuery__default.a.each(this.ui.options, function (_i, checkbox) {
            var $checkbox = external___window__g_____g_$_____window_$CQ____window_$____window_jQuery__default()(checkbox);
            if ($checkbox.prop('checked')) {
                parameters.push(String($checkbox.val()) + '=yes');
            }
        });
        return parameters.join('&');
    };
    /**
     * Handle the primary button click event.
     * Add the url parameters based on the current selection.
     */
    this.handleButtonAction = function (event) {
        var parameters = this.getUrlParameters();
        var $link = external___window__g_____g_$_____window_$CQ____window_$____window_jQuery__default()(event.currentTarget);
        var originAndSearch = $link.prop('href').split('?', 2);
        var origin = originAndSearch[0];
        var search = originAndSearch[1] || '';
        var hash = '';
        if (!origin) {
            return;
        }
        if (search && search.indexOf('#') > -1) {
            var searchAndHash = search.split('#', 2);
            search = searchAndHash[0];
            hash = '#' + searchAndHash[1];
        }
        search = '?' + [search, parameters].filter(Boolean).join('&');
        var newUrl = origin + search + hash;
        $link.prop('href', newUrl);
    };
    /**
     * Event handler. Handling the users interaction with a slide.
     */
    this.handleSliderInteraction = function () {
        this.trackUserInteractionWithSlider = true;
    };
    /**
     * Event handler. Collapses/Expands the summary bar on mobile devices
     */
    this.handleToggleCollapse = function (event) {
        var $icon = this.ui.collapseButton.find('.icon');
        this.ui.price.toggleClass('hidden', !$icon.is('.icon-016-chevron-up'));
        parent.handleToggleCollapse.call(this, event);
    };
    /**
     * Override the loadData method, but instead of actually loading
     * data, parse the passed in data into a data object the base
     * class can understand. Then start the instance by calling handleDataSuccess.
     */
    this.loadData = function () {
        // If the config object is already set, don't load again.
        if (!external___window__g_____g_$_____window_$CQ____window_$____window_jQuery__default.a.isEmptyObject(this.customConfig)) {
            return;
        }
        this.customConfig = this.parseCustomConfig(this.$ctx.data('custom-config'));
        // Prevent errors in LegoContainer#track, which relies on config info even though the types differ
        // FIXME: Refactor…
        this.config = this.customConfig;
        this.log.debug('loadData', this.customConfig);
        this.maxPrice = this.calculateMaxCost();
    };
    /**
     * Parsing the custom config into the proper form, so the base class automatically
     * understands the data format.
     * @param data
     */
    this.parseCustomConfig = function (data) {
        var config = {};
        for (var _a = 0, data_1 = data; _a < data_1.length; _a++) {
            var item = data_1[_a];
            config[item.serviceId] = {
                flavours: item.flavours,
            };
        }
        return config;
    };
    /**
     * Set the initial state of this configurator
     */
    this.setInitialState = function () {
        var deepLinks = this.deserializeDeeplink(util_url["hashDeepLink"].get('lpIds'));
        if (deepLinks && deepLinks.config.length) {
            this.preselectSliderPositions(deepLinks.config);
            // This.trackInitialConfiguration(deepLinks.config);
            if (!Object.keys(deepLinks.options).length) {
                this.setInitialOptions(this.options);
            }
            else {
                this.setInitialOptions(deepLinks.options);
            }
            this.updateSummaryUi(deepLinks.config);
        }
        else {
            var updateData = this.getUpdateDataFromCurrentSelection();
            this.setInitialOptions(this.options);
            this.updateSummaryUi(updateData);
            // This.trackInitialConfiguration(updateData);
        }
    };
    /**
     * Setting the price bar indicator width to the precentage of the currentPrice/maxPrice
     * @param price	- Number - the current price
     * @param maxPrice - Number - the maximum price that can be reached
     */
    this.updatePriceBar = function (price, maxPrice) {
        var newWidth = this.ui.priceBar.width() * price / maxPrice;
        this.ui.priceBarIndicator.css('width', newWidth);
    };
    /**
     * Update the service list items in the summary bar
     */
    this.updateServiceList = function () {
        var _this = this;
        this.ui.services.addClass('hidden');
        external___window__g_____g_$_____window_$CQ____window_$____window_jQuery__default.a.each(this.currentSelection, function (_i, item) {
            _this.ui.services.filter("[data-depends-on=\"" + item.slideId + "\"]").removeClass('hidden');
        });
    };
    /**
     * Update the bundle name in the summary bar.
     * Receive a list of class names and find a class name that contains 'bundleName-'
     */
    this.updateSummaryBundleName = function () {
        var bundleLink = this.getActiveBundleLink();
        if (!bundleLink) {
            this.ui.summaryBundleName.text(' ');
            return;
        }
        var classList = bundleLink.prop('classList');
        // tslint:disable-next-line: prefer-for-of
        for (var i = 0; i < classList.length; i += 1) {
            if (classList[i].indexOf('bundleName-') > -1) {
                this.ui.summaryBundleName.text(classList[i].replace('bundleName-', ''));
                return;
            }
        }
        this.ui.summaryBundleName.text(' ');
    };
    /**
     * Update the ui of the summary bar.
     *
     * @param data
     */
    this.updateSummaryUi = function (data) {
        var totalPrice = this.calculateSingleTotalPrice(data);
        this.updatePriceBar(totalPrice, this.maxPrice);
        this.isBundleConfiguration();
        this.updateSummaryBundleName();
        this.updateServiceList();
        this.checkBlockList();
    };
    /**
     * Terrific Handler, fired by Tc.Module.Slider
     * @param {Object} data
     */
    this.onSliderSlideInitialized = function (data) {
        this.slidersInitialized += 1;
        this.allSlidesInitialized = this.slidersInitialized === this.ui.slider.length;
        this.onSliderSlideChanged(data);
        // Wait until all sliders on the page have finished initializing.
        if (this.allSlidesInitialized) {
            this.setInitialState();
        }
    };
    /**
     * Terrific Handler, fired by Tc.Module.Slider
     * @param {Object} data
     */
    this.onSliderSlideChanged = function (data) {
        var mod = this;
        mod.updateSummaryUi([data]);
        if (mod.trackUserInteractionWithSlider) {
            mod.trackUserInteractionWithSlider = false;
            var trackingInfo = {
                action: 'select',
                category: 'optionchange',
                label: data.slideId,
                location: mod.getLocationString(),
                selectedProducts: [{ slideId: data.slideId }],
            };
            mod.track(trackingInfo);
        }
    };
};

// CONCATENATED MODULE: ./clientlibs/js/lib/ecommerce/lego/skins/DetailPage.ts

// tslint:disable-next-line: variable-name
var DetailPage_DetailPage = function DetailPage(parent) {
    this.cacheUi = function () {
        parent.cacheUi.call(this);
        this.ui.detailContainers = this.$ctx.find('.legoDetailContainer');
        this.ui.detailContainers.toggleClass('hidden', !this.isEditMode);
        this.$ctx.addClass('initialized');
    };
    this.handleDataSuccess = function () {
        if (this.isEditMode) {
            return;
        }
        var initConf = this.deepLinkConf;
        if (initConf && initConf.config.length) {
            this.setInitialOptions(initConf.options);
            this.initComplete = true;
            this.updateUI(initConf.config);
            this.updateSummaryUi(initConf.config);
            this.broadcastConfigurationChanged(this.currentSelection, this.calculateTotalPrice(initConf.config));
        }
    };
    this.updateUI = function (data) {
        var mod = this;
        this.ui.detailContainers.toggleClass('hidden', true);
        external___window__g_____g_$_____window_$CQ____window_$____window_jQuery__default.a.each(data, function (_i, service) {
            mod.ui.detailContainers.filter("[data-id=\"" + service.slideId + "\"]").toggleClass('hidden', false);
        });
    };
};

// CONCATENATED MODULE: ./clientlibs/js/lib/ecommerce/lego/skins/DetailPagePriceOrder.ts


// tslint:disable-next-line: variable-name
var DetailPagePriceOrder_DetailPagePriceOrder = function DetailPagePriceOrder(parent) {
    this.cacheUi = function () {
        parent.cacheUi.call(this);
        this.ui.detailContainers = this.$ctx.find('.legoDetailContainer');
        this.ui.detailContainers.toggleClass('hidden', !this.isEditMode);
        this.ui.aboSelection = this.$ctx.find('.legoDetailRadio :radio');
    };
    this.addEventListeners = function () {
        parent.addEventListeners.call(this);
        this.ui.aboSelection.on('change', this.updateSelection.bind(this));
    };
    this.handleDataSuccess = function () {
        if (this.isEditMode) {
            return;
        }
        var initConf = this.deepLinkConf;
        if (initConf && initConf.config.length) {
            this.setInitialOptions(initConf.options);
            this.initComplete = true;
            this.updateUI(initConf.config);
            this.updateSummaryUi(initConf.config);
            this.broadcastConfigurationChanged(this.currentSelection, this.calculateTotalPrice(initConf.config));
        }
    };
    this.updateUI = function (data) {
        var _this = this;
        this.ui.detailContainers.toggleClass('hidden', true);
        external___window__g_____g_$_____window_$CQ____window_$____window_jQuery__default.a.each(data.filter(Boolean), function (_i, service) {
            _this.ui.detailContainers.filter("[data-id=\"" + service.slideId + "\"]").toggleClass('hidden', false);
            _this.ui.aboSelection.filter("[value=\"" + service.slideId + "\"]").prop('checked', true);
        });
        var prices = this.calculateTotalPrice(data);
        this.$ctx.find('.detailsTotalPrice span').text(SCS.utils.formatPriceWithDash(prices.totalPrice));
        this.$ctx.find('.detailsTotalPriceTitle, .detailsTotalPrice').removeClass('hidden');
    };
    this.updateSelection = function (event) {
        var mod = this;
        var selectedSiebelId = external___window__g_____g_$_____window_$CQ____window_$____window_jQuery__default()(event.currentTarget).val();
        var selectedName = external___window__g_____g_$_____window_$CQ____window_$____window_jQuery__default()(event.currentTarget).attr('name');
        mod.broadcastConfigurationChanged(mod.currentSelection, mod.calculateTotalPrice([{ slideId: selectedSiebelId, sliderId: selectedName }]));
        var deeplink = mod.serializeDeeplink(true);
        util_url["hashDeepLink"].set('lpIds', deeplink, ',', false);
        var selection = Object.keys(mod.currentSelection)
            .map(function (key) { return mod.currentSelection[key]; })
            .filter(Boolean);
        mod.updateUI(selection);
    };
};

// EXTERNAL MODULE: ./clientlibs/js/lib/ecommerce/lego/skins/DOCPCheckout.tsx
var DOCPCheckout = __webpack_require__(43);

// CONCATENATED MODULE: ./clientlibs/js/lib/ecommerce/lego/skins/Invisible.ts


// tslint:disable-next-line: variable-name
var Invisible_Invisible = function Invisible(parent) {
    this.initComponent = function () {
        parent.initComponent.call(this);
        this.sandbox.subscribe('LEGO_CONTAINER', this);
        this.conversionCategory = this.$ctx.data('conversionCategory');
        this.conversionDetail = this.$ctx.data('conversionDetail');
        this.conversionClass = this.$ctx.data('conversionClass');
    };
    this.cacheUi = external___window__g_____g_$_____window_$CQ____window_$____window_jQuery__default.a.noop;
    this.initUi = external___window__g_____g_$_____window_$CQ____window_$____window_jQuery__default.a.noop;
    this.handleScroll = external___window__g_____g_$_____window_$CQ____window_$____window_jQuery__default.a.noop;
    this.addEventListeners = external___window__g_____g_$_____window_$CQ____window_$____window_jQuery__default.a.noop;
    this.updateSummaryPosition = external___window__g_____g_$_____window_$CQ____window_$____window_jQuery__default.a.noop;
    this.handleDataSuccess = function () {
        var _this = this;
        if (!this.isEditMode) {
            var deepLinks = this.deepLinkConf;
            if (deepLinks && deepLinks.config.length) {
                this.setInitialOptions(deepLinks.options);
                this.prices = this.calculateTotalPrice(deepLinks.config);
                this.onGetBundleTotalPrice();
                var trackingInfo_1 = {
                    selectedProducts: deepLinks.config,
                };
                if (this.conversionCategory && this.conversionDetail) {
                    trackingInfo_1.conversionCategory = this.conversionCategory;
                    trackingInfo_1.conversionDetail = this.conversionDetail;
                    trackingInfo_1.conversionClass = this.conversionClass || '';
                }
                setTimeout(function () {
                    _this.track(trackingInfo_1);
                }, 500);
            }
        }
    };
    this.onGetBundleTotalPrice = function () {
        var totalPrice = this.prices ? this.prices.totalPrice : 0;
        var bundleTotalPrice = {
            disabledValues: DISABLED_VALUES,
            mobileConfig: this.mobileConfigData,
            selectedFlavours: this.currentSelection,
            totalPrice: totalPrice,
        };
        this.fire('bundleTotalPrice', bundleTotalPrice, ['LEGO_CONTAINER']);
    };
};

// CONCATENATED MODULE: ./clientlibs/js/lib/ecommerce/lego/skins/index.ts








// EXTERNAL MODULE: ./clientlibs/js/lib/ecommerce/lego/Tc.Module.LegoOrderButton.ts
var Tc_Module_LegoOrderButton = __webpack_require__(218);

// EXTERNAL MODULE: ./clientlibs/js/lib/contact/Tc.Module.LivePersonChatForContact.ts
var Tc_Module_LivePersonChatForContact = __webpack_require__(219);

// CONCATENATED MODULE: ./clientlibs/js/lib/lottie/Tc.Module.LottieAnimatedSVG.ts


var LOTTIE_CDN = 'https://cdnjs.cloudflare.com/ajax/libs/bodymovin/5.6.3/lottie_svg.min.js';
var LOTTIE_SCI = 'sha256-1LmUDzx23/AXL920x0iaqcWeIzBTGnoJ7XfihOpYd+o=';
function getLottieScript() {
    return Object(tslib_es6["b" /* __awaiter */])(this, void 0, void 0, function () {
        return Object(tslib_es6["d" /* __generator */])(this, function (_a) {
            return [2 /*return*/, new Promise(function (resolve) {
                    var el = document.createElement('script');
                    el.onload = resolve;
                    el.src = LOTTIE_CDN;
                    el.crossOrigin = 'anonymous';
                    el.integrity = LOTTIE_SCI;
                    document.head.appendChild(el);
                })];
        });
    });
}
var scriptLoader = null;
var Tc_Module_LottieAnimatedSVG_LottieAnimatedSVG = /** @class */ (function (_super) {
    Object(tslib_es6["c" /* __extends */])(LottieAnimatedSVG, _super);
    function LottieAnimatedSVG() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LottieAnimatedSVG.prototype.on = function (callback) {
        var _this = this;
        if (scriptLoader === null) {
            scriptLoader = getLottieScript();
        }
        // tslint:disable-next-line:no-floating-promises
        scriptLoader
            .then(this.startLottieAnimation.bind(this))
            .catch(function (err) { return _this.log(err); });
        callback();
    };
    LottieAnimatedSVG.prototype.onActiveDisplay = function ($container) {
        if ($container.find(this.$ctx).length) {
            this.animation.play();
        }
        else {
            this.animation.stop();
        }
    };
    LottieAnimatedSVG.prototype.startLottieAnimation = function () {
        var _this = this;
        if (!window.lottie) {
            return;
        }
        this.animation = window.lottie.loadAnimation({
            autoplay: false,
            container: this.$ctx.find('.animation-holder').get(0),
            loop: false,
            path: this.$ctx.data('json-path'),
            renderer: 'svg',
        });
        var $hoverContainer = this.$ctx.closest('.mod.modHoverContainer');
        if ($hoverContainer.length) {
            $hoverContainer.on('scs-active', function (_, $container) {
                if ($container.find(_this.$ctx).length) {
                    _this.animation.play();
                }
                else {
                    _this.animation.stop();
                }
            });
        }
        else {
            this.$ctx.find('.animation-holder')
                .hover(function (_) { return _this.animation.play(); }, function (_) { return _this.animation.stop(); });
        }
    };
    return LottieAnimatedSVG;
}(Module["a" /* Module */]));
/* harmony default export */ var Tc_Module_LottieAnimatedSVG = (Tc_Module_LottieAnimatedSVG_LottieAnimatedSVG);

// EXTERNAL MODULE: ./clientlibs/js/lib/vendor/jquery-deparam-patched.ts
var jquery_deparam_patched = __webpack_require__(8);

// CONCATENATED MODULE: ./clientlibs/js/lib/ecommerce/Tc.Module.OrderOverlay.ts




/**
 * Order Overlay for MAP Bundle Order or Lego Container pages.
 *
 * @author Michael Keller
 * @namespace Tc.Module
 * @class OrderOverlay
 * @extends Tc.Module
 */
var Tc_Module_OrderOverlay_OrderOverlay = /** @class */ (function (_super) {
    Object(tslib_es6["c" /* __extends */])(OrderOverlay, _super);
    function OrderOverlay() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isMobile = false;
        _this.mobilePageId = 'orderoverlay';
        // Can be set via fire('openOrderOverlay'), and will then override button attributes
        _this.orderLink = null;
        _this.orderLinkNoLogin = null;
        _this.registrationLink = null;
        return _this;
    }
    /**
     * Initializes OrderOverlay
     *
     * @method on
     * @param {Function} callback function
     * @return void
     */
    OrderOverlay.prototype.on = function (callback) {
        var _this = this;
        this.isMobile = external___window__g_____g_$_____window_$CQ____window_$____window_jQuery__default()('body').is('.is-mobile');
        this.$orderButton = external___window__g_____g_$_____window_$CQ____window_$____window_jQuery__default()('.scs-product-orderbutton-buy, .is-mobile .order-button');
        this.$mobileButtonHolder = this.$ctx.find('.orderoverlay-mobile-button-holder');
        // Move error messages of service availability module before button - design differs from serviceavailability when in overlay
        this.$ctx.find('.modScForm > form > .button').before(this.$ctx.find('.modScForm > form > .error'));
        this.$ctx.find('.modScForm > form > .error').css('clear', 'left');
        this.$ctx.find('.limited-offers').hide();
        this.$ctx.find('.no-offers').hide();
        // Mobile initialization (uses jquery-mobile "page")
        if (this.isMobile) {
            this.mobilePageHelper = new SCS.MobilePageHelper('body');
            this.$ctx.find('a.back').text('< ' + this.$ctx.data('buttonBack'));
            // Listen for pagechange event to a page with the id == mod.mobilePageId
            external___window__g_____g_$_____window_$CQ____window_$____window_jQuery__default()(document).on('pagechange', function (event, data) {
                if (data && data.toPage && data.toPage.filter('#' + _this.mobilePageId).length === 1) {
                    _this.fire('dialogOpened');
                }
                _this.log(event, data);
            });
            if (external___window__g_____g_$_____window_$CQ____window_$____window_jQuery__default()('.modPriceOrderContainer, .modLegoOrderButton').length === 0) {
                // Do this only for "old" pages (e.g. BundleVariations);
                // The new ones open the overlay via onOpenOverlay and supply the needed data there - buttons are generated there
                // For mobile, move the existing buttons into orderoverlay-mobile-button-holder (only visible after availability-check)
                // and add a "check availability"-button into the page instead
                this.$ctx.parent().siblings('.order-button, .shop-finder.secondary-button').appendTo('.orderoverlay-mobile-button-holder');
                this.$ctx.parent().before('<a class="button primary-button check-availability-button"></a>');
                // Reset mod.$orderButton to the newly created "Check Availability"-button
                this.$orderButton = this.$ctx.parent().prev('.check-availability-button');
                this.$orderButton.text(this.$ctx.data('translation-check-availability'));
            }
        }
        // Listen for clicks on order-button
        this.$orderButton.click(function (e) {
            if (!_this.$ctx.is('.cq_isEditMode *')) {
                if (_this.isMobile) {
                    _this.openInMobilePage();
                }
                else {
                    _this.openOverlay();
                }
            }
            e.preventDefault();
        });
        // Close overlay, when cancel-button is clicked
        this.$ctx.find('.modServiceAvailability .cancel-button').on('click', function () {
            if (_this.isMobile) {
                // Detach the created mobile page-overlay to prevent issues with navigation flyout and repeated opening of the overlay.
                // timeout prevents a blank screen before switching back to the actual page content.
                setTimeout(function () { external___window__g_____g_$_____window_$CQ____window_$____window_jQuery__default()('#orderoverlay').detach(); }, 500);
                window.history.back(); // Switch back to main page (close "overlay")
            }
            else {
                _this.$ctx.dialog('close');
            }
        });
        callback();
    };
    OrderOverlay.prototype.openOverlay = function () {
        var _this = this;
        this.$ctx.dialog({
            classes: { 'ui-dialog': 'order-overlay-dialog sdx-container' },
            close: function () {
                _this.fire('dialogClosed');
            },
            open: function () {
                var _a, _b;
                var data = {
                    href: (_a = _this.orderLink) !== null && _a !== void 0 ? _a : _this.$orderButton.attr('href'),
                    noLoginUrl: (_b = _this.orderLinkNoLogin) !== null && _b !== void 0 ? _b : _this.$orderButton.data('no-login-url'),
                    registrationUrl: _this.registrationLink,
                };
                _this.fire('orderButtonsInit', data);
                _this.fire('dialogOpened');
            },
            width: 780,
        });
    };
    OrderOverlay.prototype.openInMobilePage = function () {
        SCS.createNewMobilePage({ content: this.$ctx, cssClass: 'ui-body-c content-fw' });
        var data = {
            href: this.orderLink ? this.orderLink : this.$orderButton.attr('href'),
            noLoginUrl: this.orderLinkNoLogin ? this.orderLinkNoLogin : this.$orderButton.data('no-login-url'),
            registrationUrl: this.registrationLink,
        };
        this.fire('orderButtonsInit', data);
        this.$ctx.closest('.ui-content').css('overflow-x', 'visible');
        this.sandbox.addModules(external___window__g_____g_$_____window_$CQ____window_$____window_jQuery__default()('.modHeader'));
    };
    OrderOverlay.prototype.showMobileOrderButtons = function () {
        this.$mobileButtonHolder.removeClass('hidden');
        this.onCenterOverlay();
    };
    OrderOverlay.prototype.hideMobileOrderButtons = function () {
        this.$mobileButtonHolder.addClass('hidden');
        this.onCenterOverlay();
    };
    OrderOverlay.prototype.isActive = function () {
        return this.$ctx.is(':visible') || this.isMobile && this.$ctx.is('#orderoverlay *');
    };
    /**
     * Module communication
     */
    OrderOverlay.prototype.onCenterOverlay = function () {
        var mod = this;
        if (mod.$ctx.is('.ui-dialog-content')) {
            mod.log('Tc.Module.OrderOverlay > centerOverlay');
            mod.$ctx.dialog('reposition');
        }
    };
    OrderOverlay.prototype.onServiceAvailabilityDataUpdate = function (response) {
        var _a, _b, _c, _d;
        var mod = this;
        if (!mod.isActive()) {
            return;
        }
        // FIXME: Why don’t the types match?
        var data = response;
        // React to result of service availability request
        mod.log('Tc.Module.OrderOverlay > received new serviceavailability data', data);
        // Show orderbuttons whenever the product is available or restricted => can be ordered
        // in this case - hide the additional texts
        if (((_b = (_a = data === null || data === void 0 ? void 0 : data.productAvailability) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0) > 0 && data.productAvailability[0].availability !== 'not_available') {
            // Product available or restricted
            mod.fire('orderButtonsShow');
            mod.showMobileOrderButtons();
        }
        else if (((_d = (_c = data === null || data === void 0 ? void 0 : data.productAvailability) === null || _c === void 0 ? void 0 : _c.length) !== null && _d !== void 0 ? _d : 0) > 0 && data.productAvailability[0].availability === 'not_available') {
            // Product not available
            mod.hideMobileOrderButtons();
            if (data.tvAvailability === 'available' || data.tvAvailability === 'restricted') {
                mod.$ctx.find('.limited-offers').show();
            }
            else {
                mod.$ctx.find('.no-offers').show();
            }
        }
        // Hide no-login link for checks based on phone number and show a different button
        // FIXME: Remove since type never changes anymore
        if (!mod.isMobile) {
            mod.fire('checkTypeChange', data.requestType);
        }
        else {
            mod.$ctx.find('.order-link-new-customer-mobile').toggleClass('hidden', data.requestType === 'phone');
        }
        // Update product id
        if (data && data.productAvailability && data.productAvailability.length > 0) {
            mod.fire('UpdateProductId', {
                name: data.productAvailability[0].name,
                siebelId: data.productAvailability[0].siebelId,
            });
        }
        mod.onCenterOverlay();
    };
    OrderOverlay.prototype.onServiceAvailabilityStatusUpdate = function (data) {
        var mod = this;
        if (!mod.isActive()) {
            return;
        }
        // Hide other modules in overlay anyway - will be displayed depending on what is delivered to onServiceAvailabilityDataUpdate
        mod.fire('orderButtonsHide');
        mod.$ctx.find('.limited-offers, .no-offers').hide();
        if (data === 'form') {
            mod.$ctx.find('.form-title').removeClass('hidden');
            mod.hideMobileOrderButtons();
        }
        else {
            mod.$ctx.find('.form-title').addClass('hidden');
        }
        mod.onCenterOverlay();
    };
    /**
     * Listens to modPriceOrderContainer and modLegoOrderButton
     */
    OrderOverlay.prototype.onOpenOverlay = function (data) {
        var samLink = this.$ctx.data('sam-link');
        var orderLinkMatchQueryString = data.orderLink.match(/[?#](.*)/) || [];
        var orderLinkQueryString = orderLinkMatchQueryString[1] || '';
        var orderLinkParams = Object(jquery_deparam_patched["default"])(orderLinkQueryString);
        this.log('onOpenOverlay', data);
        this.orderLink = data.orderLink;
        this.orderLinkNoLogin = data.orderLinkNoLogin;
        this.registrationLink = SCS.Url.updateQueryStringParameter(samLink, 'lang', orderLinkParams.lang);
        this.registrationLink = SCS.Url.updateQueryStringParameter(this.registrationLink, 'serviceName', 'consult');
        this.registrationLink = SCS.Url.updateQueryStringParameter(this.registrationLink, 'RURL', encodeURIComponent(data.orderLink));
        if (data.productIds) {
            this.fire('UpdateProductIds', {
                name: data.productName,
                productIds: data.productIds,
            });
        }
        else {
            this.fire('UpdateProductId', {
                name: data.productName || data.productId,
                siebelId: data.productId,
            });
        }
        if (this.isMobile) {
            this.$mobileButtonHolder.empty();
            external___window__g_____g_$_____window_$CQ____window_$____window_jQuery__default()('#' + data.orderButtonsId).clone().removeClass('hidden').appendTo(this.$mobileButtonHolder);
            this.addSiteCatalystTracking();
            this.openInMobilePage();
        }
        else {
            this.openOverlay();
        }
    };
    /**
     * Track the mobile buttons (which are not handled in OrderOverlayOrderButtons).
     * Handles the buttons provided by the Lego Order Button component.
     */
    OrderOverlay.prototype.addSiteCatalystTracking = function () {
        var win = window;
        this.$mobileButtonHolder.find('.order-link-existing-customer-mobile').click(function (event) {
            var siteCatalyst = win.s || win.s_one;
            if (siteCatalyst && siteCatalyst.tl) {
                siteCatalyst.tl(event.target, 'o', 'OrderOverlay_OrderButton_WithLogin');
            }
        });
        this.$mobileButtonHolder.find('.order-link-new-customer-mobile').click(function (event) {
            var siteCatalyst = win.s || win.s_one;
            if (siteCatalyst && siteCatalyst.tl) {
                siteCatalyst.tl(event.target, 'o', 'OrderOverlay_OrderButton_WithoutLogin');
            }
        });
    };
    return OrderOverlay;
}(Module["a" /* Module */]));
/* harmony default export */ var Tc_Module_OrderOverlay = (Tc_Module_OrderOverlay_OrderOverlay);

// CONCATENATED MODULE: ./clientlibs/js/lib/ecommerce/Tc.Module.OrderOverlayOrderButtons.ts



/**
 * Order Overlay Order Buttons for MAP Bundle Order or Lego Container pages
 *
 * @author Michael Keller
 * @namespace Tc.Module
 * @class OrderOverlayOrderButtons
 * @extends Tc.Module
 */
var Tc_Module_OrderOverlayOrderButtons_OrderOverlayOrderButtons = /** @class */ (function (_super) {
    Object(tslib_es6["c" /* __extends */])(OrderOverlayOrderButtons, _super);
    function OrderOverlayOrderButtons() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    OrderOverlayOrderButtons.prototype.on = function (callback) {
        // Collect button holders and write current texts to data-attributes
        this.$buttonHolders = this.$ctx.find('.existing-customer, .without-login, .phone-contact');
        this.$buttonHolders.find('span, p, a').each(function () {
            external___window__g_____g_$_____window_$CQ____window_$____window_jQuery__default()(this).data('default-text', external___window__g_____g_$_____window_$CQ____window_$____window_jQuery__default()(this).text());
        });
        this.addSiteCatalystTracking();
        // Handle click on button "get in contact" which is displayed after a search for a phonenumber
        this.$ctx.find('.phone-contact a').click(function (e) {
            var _a, _b;
            e.preventDefault();
            if ((_b = (_a = window.SCS) === null || _a === void 0 ? void 0 : _a.HelpWidget) === null || _b === void 0 ? void 0 : _b.open) {
                window.SCS.HelpWidget.open('contact');
            }
        });
        this.readButtonOverrides();
        callback();
    };
    OrderOverlayOrderButtons.prototype.addSiteCatalystTracking = function () {
        var _this = this;
        var win = window;
        this.$ctx.find('.existing-customer a').click(function (e) {
            var $el = external___window__g_____g_$_____window_$CQ____window_$____window_jQuery__default()(e.target);
            var siteCatalyst = win.s || win.s_one;
            if (siteCatalyst && siteCatalyst.tl) {
                if ($el.hasClass('goToLogin')) {
                    siteCatalyst.tl(_this, 'o', 'OrderOverlay_OrderButton_GoToLogin');
                    window.location.href = $el[0].href;
                }
                else {
                    siteCatalyst.tl(_this, 'o', 'OrderOverlay_OrderButton_WithLogin');
                }
            }
        });
        this.$ctx.find('.without-login a').click(function () {
            var siteCatalyst = win.s || win.s_one;
            if (siteCatalyst && siteCatalyst.tl) {
                siteCatalyst.tl(this, 'o', 'OrderOverlay_OrderButton_WithoutLogin');
            }
        });
    };
    /*
     * Reads button override texts if specified by the author
     */
    OrderOverlayOrderButtons.prototype.readButtonOverrides = function () {
        this.buttonOverridesData = this.$ctx
            .find('.button-overrides p')
            .map(function (_i, el) {
            var $el = external___window__g_____g_$_____window_$CQ____window_$____window_jQuery__default()(el);
            return {
                nologinButtonLinkText: $el.find('.nologinButtonLinkText').text(),
                nologinButtonText: $el.find('.nologinButtonText').text(),
                nologinButtonTitle: $el.find('.nologinButtonTitle').text(),
                orderButtonLinkText: $el.find('.orderButtonLinkText').text(),
                orderButtonText: $el.find('.orderButtonText').text(),
                orderButtonTitle: $el.find('.orderButtonTitle').text(),
                phonecontactButtonLinkText: $el.find('.phonecontactButtonLinkText').text(),
                phonecontactButtonText: $el.find('.phonecontactButtonText').text(),
                phonecontactButtonTitle: $el.find('.phonecontactButtonTitle').text(),
                productId: $el.find('.productId').text(),
            };
        })
            .get();
    };
    OrderOverlayOrderButtons.prototype.getButtonOverridesByProductId = function (productId) {
        if (this.buttonOverridesData) {
            for (var _a = 0, _b = this.buttonOverridesData; _a < _b.length; _a++) {
                var buttonOverride = _b[_a];
                if (buttonOverride.productId === productId || buttonOverride.productId === '*') {
                    return buttonOverride;
                }
            }
        }
        return {};
    };
    OrderOverlayOrderButtons.prototype.defaultText = function (selector, override) {
        var $el = this.$ctx.find(selector);
        $el.text(override !== null && override !== void 0 ? override : $el.data('default-text'));
    };
    OrderOverlayOrderButtons.prototype.overrideButtonTexts = function (data) {
        this.defaultText('.existing-customer h4 span', data === null || data === void 0 ? void 0 : data.orderButtonTitle);
        this.defaultText('.existing-customer .description', data === null || data === void 0 ? void 0 : data.orderButtonText);
        this.defaultText('.existing-customer a', data === null || data === void 0 ? void 0 : data.orderButtonLinkText);
        this.defaultText('.without-login h4 span', data === null || data === void 0 ? void 0 : data.nologinButtonTitle);
        this.defaultText('.without-login .description', data === null || data === void 0 ? void 0 : data.nologinButtonText);
        this.defaultText('.without-login a', data === null || data === void 0 ? void 0 : data.nologinButtonLinkText);
        this.defaultText('.phone-contact h4 span', data === null || data === void 0 ? void 0 : data.phonecontactButtonTitle);
        this.defaultText('.phone-contact .description', data === null || data === void 0 ? void 0 : data.phonecontactButtonText);
        this.defaultText('.phone-contact a', data === null || data === void 0 ? void 0 : data.phonecontactButtonLinkText);
    };
    // Fired by Tc.Module.OrderOverlay.js
    OrderOverlayOrderButtons.prototype.onOrderButtonsInit = function (data) {
        var _a, _b;
        var mod = this;
        if (!data) {
            return;
        }
        mod.log('onOrderButtonsInit', data.href, data.noLoginUrl);
        mod.$ctx.find('.existing-customer a').attr('href', (_a = data.href) !== null && _a !== void 0 ? _a : null).removeData();
        mod.$ctx.find('.without-login a').attr('href', data.noLoginUrl).removeData();
        mod.$ctx.find('.new-customer a').attr('href', (_b = data.registrationUrl) !== null && _b !== void 0 ? _b : null).removeData();
        if (data.update) {
            return; // Only update URLs
        }
        if (data.noLoginUrl) {
            mod.$ctx.find('.without-login').removeClass('hidden').removeClass('no-nologin-url');
        }
        else {
            mod.$ctx.find('.without-login').addClass('hidden').addClass('no-nologin-url');
        }
    };
    // Fired by Tc.Module.OrderOverlay.js
    OrderOverlayOrderButtons.prototype.onOrderButtonsHide = function () {
        this.$ctx.hide();
    };
    // Fired by Tc.Module.OrderOverlay.js
    OrderOverlayOrderButtons.prototype.onOrderButtonsShow = function () {
        this.$ctx.show();
    };
    OrderOverlayOrderButtons.prototype.onCheckTypeChange = function (type) {
        var _a;
        this.log('onCheckTypeChange', type);
        var win = window;
        if (type === 'none') {
            if ((_a = win.SCS) === null || _a === void 0 ? void 0 : _a.HelpWidget) {
                // Only needed if a help widget is available
                this.$ctx.find('.phone-contact').removeClass('hidden').addClass('half-width');
                this.$ctx.find('.existing-customer').addClass('half-width');
            }
            this.$ctx.find('.without-login').addClass('hidden');
        }
        else {
            this.$ctx.find('.phone-contact').addClass('hidden').removeClass('half-width');
            this.$ctx.find('.existing-customer').removeClass('half-width');
            if (!this.$ctx.find('.without-login').is('.no-nologin-url')) {
                this.$ctx.find('.without-login').removeClass('hidden');
            }
        }
    };
    OrderOverlayOrderButtons.prototype.onUpdateProductId = function (data) {
        this.log('onUpdateProductId', data);
        if (data && data.siebelId) {
            this.overrideButtonTexts(this.getButtonOverridesByProductId(data.siebelId));
        }
    };
    return OrderOverlayOrderButtons;
}(Module["a" /* Module */]));
/* harmony default export */ var Tc_Module_OrderOverlayOrderButtons = (Tc_Module_OrderOverlayOrderButtons_OrderOverlayOrderButtons);

// EXTERNAL MODULE: ./clientlibs/js/lib/pdf/Tc.Module.PDFQrCode.ts
var Tc_Module_PDFQrCode = __webpack_require__(220);

// EXTERNAL MODULE: ./clientlibs/js/lib/pex/Tc.Module.PexArticleDetail.ts
var Tc_Module_PexArticleDetail = __webpack_require__(221);

// EXTERNAL MODULE: ./clientlibs/js/lib/pex/Tc.Module.PexIncidentInfoDialog.ts
var Tc_Module_PexIncidentInfoDialog = __webpack_require__(222);

// EXTERNAL MODULE: ./clientlibs/js/lib/pex/Tc.Module.AbstractPexList.ts
var Tc_Module_AbstractPexList = __webpack_require__(224);

// EXTERNAL MODULE: ./clientlibs/js/lib/pex/IncidentListRenderer.tsx
var IncidentListRenderer = __webpack_require__(226);

// EXTERNAL MODULE: ./clientlibs/js/lib/pex/TableHeader.tsx
var TableHeader = __webpack_require__(228);

// EXTERNAL MODULE: ./node_modules/json2csv/dist/json2csv.umd.js
var json2csv_umd = __webpack_require__(229);
var json2csv_umd_default = /*#__PURE__*/__webpack_require__.n(json2csv_umd);

// CONCATENATED MODULE: ./clientlibs/js/lib/pex/Tc.Module.PexIncidentList.ts






var Tc_Module_PexIncidentList_PexIncidentList = /** @class */ (function (_super) {
    Object(tslib_es6["c" /* __extends */])(PexIncidentList, _super);
    function PexIncidentList() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PexIncidentList.prototype.on = function (callback) {
        var _this = this;
        this.searchablesProps = new Set();
        ['customerName', 'location', 'title', 'date', 'scn']
            .forEach(function (searchProp) { return _this.searchablesProps.add(searchProp); });
        this.displayedTypes = (this.$ctx.data('incident-types').split(',') || [])
            .map(function (incidentType) { return incidentType.toUpperCase(); });
        this.dataUrl = this.$ctx.data('ajax-url') + ".outages.json";
        _super.prototype.on.call(this, callback);
    };
    PexIncidentList.prototype.init = function () {
        return Object(tslib_es6["b" /* __awaiter */])(this, void 0, void 0, function () {
            return Object(tslib_es6["d" /* __generator */])(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, _super.prototype.init.call(this)];
                    case 1:
                        _a.sent();
                        this.displayIncidentInfo();
                        return [2 /*return*/];
                }
            });
        });
    };
    PexIncidentList.prototype.render = function () {
        var $placeholdeDiv = this.$ctx.find('.table-holder');
        this.incidentListRenderer = new IncidentListRenderer["a" /* IncidentListRenderer */]($placeholdeDiv.find('thead').get(0), this.data, this.labels, this.$ctx.data('ajax-url'), this.displayedTypes);
        var headings = this.createHeadings();
        this.tableHeaders = new TableHeader["a" /* TableHeader */]($placeholdeDiv.find('tbody').get(0), headings, { sortAction: this.onSort.bind(this) }, this.displayedTypes);
        this.tableHeaders.render();
        this.incidentListRenderer.render();
        this.setupFadeoutEffect();
    };
    PexIncidentList.prototype.update = function () {
        this.incidentListRenderer.render();
        this.setupFadeoutEffect();
    };
    PexIncidentList.prototype.fetchData = function () {
        return Object(tslib_es6["b" /* __awaiter */])(this, void 0, void 0, function () {
            var _this = this;
            return Object(tslib_es6["d" /* __generator */])(this, function (_a) {
                return [2 /*return*/, _super.prototype.fetchData.call(this)
                        .then(function (data) {
                        return data.filter(function (elem) { return _this.displayedTypes.includes(elem.type); });
                    })];
            });
        });
    };
    PexIncidentList.prototype.exportToCSV = function () {
        var dataToExport = this.data.filter(function (item) { return item.display; });
        var config = {
            delimiter: ',',
            eol: '\n',
            fields: [
                {
                    label: this.labels.customerListNr,
                    value: 'scn',
                },
                {
                    label: this.labels.customerName,
                    value: 'customerName',
                },
                {
                    label: this.labels.location,
                    value: 'location',
                },
                {
                    label: this.labels.title,
                    value: 'title',
                },
                {
                    label: this.labels.datum,
                    value: 'date',
                },
            ],
            header: true,
            includeEmptyRows: true,
        };
        var csv = Object(json2csv_umd["parse"])(dataToExport, config);
        var blob = new Blob([csv], { type: 'text/csv;encoding:utf-8' });
        var a = document.createElement('a');
        var url = window.URL.createObjectURL(blob);
        a.href = url;
        a.download = 'PexIncidentList.csv';
        document.body.appendChild(a);
        a.click();
        a.remove();
    };
    PexIncidentList.prototype.createHeadings = function () {
        return [
            {
                sort: true,
                sortName: 'title',
                title: this.labels.title,
            },
            {
                sort: true,
                sortName: 'location',
                title: this.labels.location,
            },
            {
                sort: true,
                sortName: 'customerName',
                title: this.labels.customerName,
            },
            {
                sort: true,
                sortName: 'scn',
                title: this.labels.customerListNr,
            },
            {
                sort: true,
                sortName: 'creationDateTamestamp',
                title: this.labels.datum,
            },
            {
                sort: false,
                sortName: '',
                title: '',
            },
        ];
    };
    PexIncidentList.prototype.displayIncidentInfo = function () {
        var queryParams = new URLSearchParams(window.location.search);
        if (queryParams.has('sit')) {
            var sitID_1 = parseInt(queryParams.get('sit'), 10);
            var status_1 = queryParams.has('incidentStatus') ?
                (queryParams.get('incidentStatus').toLowerCase() === 'end' ? 'closed' : 'open') : '';
            var incident = this.data.find(function (item) { return item.id === sitID_1 && (status_1 ? item.status === status_1 : true); });
            if (incident) {
                Object(IncidentListRenderer["b" /* showInfoDialog */])(sitID_1, incident.scn, incident.customerName, this.$ctx.data('ajax-url'), this.labels);
            }
            else {
                SDXModalDialog["default"].show({
                    buttons: [{
                            thin: true,
                            title: this.labels.closeBtnLabel,
                            type: 'close',
                        }],
                    notification: 'alert',
                    text: this.labels.noSearchResultMessage,
                });
            }
        }
    };
    return PexIncidentList;
}(Tc_Module_AbstractPexList["a" /* default */]));
/* harmony default export */ var Tc_Module_PexIncidentList = (Tc_Module_PexIncidentList_PexIncidentList);

// EXTERNAL MODULE: ./clientlibs/js/lib/pex/Tc.Module.PexMustReadModal.ts
var Tc_Module_PexMustReadModal = __webpack_require__(230);

// EXTERNAL MODULE: ./clientlibs/js/lib/stage/Tc.Module.PortalStage.ts
var Tc_Module_PortalStage = __webpack_require__(231);

// EXTERNAL MODULE: ./clientlibs/js/lib/ecommerce/Tc.Module.PriceBox.ts
var Tc_Module_PriceBox = __webpack_require__(31);

// EXTERNAL MODULE: ./clientlibs/js/lib/ecommerce/Tc.Module.PriceDetails.ts
var Tc_Module_PriceDetails = __webpack_require__(232);

// EXTERNAL MODULE: ./clientlibs/js/lib/ecommerce/Tc.Module.RatingList.tsx
var Tc_Module_RatingList = __webpack_require__(45);

// EXTERNAL MODULE: ./clientlibs/js/lib/ecommerce/Tc.Module.RatingOverview.tsx
var Tc_Module_RatingOverview = __webpack_require__(233);

// EXTERNAL MODULE: ./clientlibs/js/lib/ecommerce/Tc.Module.RetentionResult.ts
var Tc_Module_RetentionResult = __webpack_require__(234);

// EXTERNAL MODULE: ./clientlibs/js/lib/scrollElement/Tc.Module.ScrollElement.ts
var Tc_Module_ScrollElement = __webpack_require__(235);

// EXTERNAL MODULE: ./clientlibs/js/lib/contact/Tc.Module.SDXContactWizard.ts
var Tc_Module_SDXContactWizard = __webpack_require__(236);

// EXTERNAL MODULE: ./clientlibs/js/lib/sdx/Tc.Module.SDXDatePicker.ts
var Tc_Module_SDXDatePicker = __webpack_require__(240);

// EXTERNAL MODULE: ./clientlibs/js/lib/contact/helpers.ts
var contact_helpers = __webpack_require__(26);

// EXTERNAL MODULE: ./clientlibs/js/lib/contact/MsgChannel.tsx
var MsgChannel = __webpack_require__(241);

// EXTERNAL MODULE: ./clientlibs/js/lib/contact/Chat.tsx
var Chat = __webpack_require__(242);

// CONCATENATED MODULE: ./clientlibs/js/lib/contact/Tc.Module.SMSAndChat.ts






function isDateWithYear(dateStr) {
    return /^\d{2}\.\d{2}\.\d{4}$/.test(dateStr);
}
function createExceptionallyOpenTimes(data) {
    // Expected array element is '11.11. 12.07. 06:00-18:00' or '12.12.2019 11.02. 06:00-18:00'
    var retArr = [];
    var year = (new Date()).getFullYear();
    var _loop_1 = function (elem) {
        var exceptions = elem.split(' ');
        var exceptionsTime = exceptions.pop();
        exceptions.forEach(function (exception) {
            return retArr.push("" + exception + (isDateWithYear(exception) ? '' : year) + " " + exceptionsTime);
        });
    };
    for (var _i = 0, data_1 = data; _i < data_1.length; _i++) {
        var elem = data_1[_i];
        _loop_1(elem);
    }
    // Exception array element is: 02.01.2019 07:00-19:59
    return retArr;
}
function createExceptionallyClosedTimes(data) {
    // Expected array element is '01.01. 02.01.' or '12.01.2019 12.04.'
    var retArr = [];
    var year = (new Date()).getFullYear();
    for (var _i = 0, data_2 = data; _i < data_2.length; _i++) {
        var elem = data_2[_i];
        elem.split(' ').forEach(function (close) { return retArr.push("" + close + (isDateWithYear(close) ? '' : year) + " closed"); });
    }
    // Exception array element is: 21.05.2018 closed
    return retArr;
}
var MESSAGING_CHANNELS = ['wa', 'sms', 'abc'];
var Tc_Module_SMSAndChat_SMSAndChat = /** @class */ (function (_super) {
    Object(tslib_es6["c" /* __extends */])(SMSAndChat, _super);
    function SMSAndChat() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SMSAndChat.prototype.on = function (callback) {
        this.$contentHolder = this.$ctx.find('.content-holder');
        this.isMobile = this.$ctx.data('is-mobile');
        var displaySettings = Object(contact_helpers["d" /* isABCSupported */])() && this.$ctx.data('use-abc') ?
            this.$ctx.data('a-contact-channels') : this.$ctx.data('contact-channels');
        if (displaySettings[0] === 'chat') {
            Object(Chat["a" /* renderChat */])(this.$contentHolder.get(0), this.$ctx.data('chat-title') || '', this.$ctx.data('chat-intro') || '', this.$ctx.data('chat-type'), this.$ctx.data('chat-genesys-style'), this.$ctx.data('chat-provider'), this.$ctx.data('chat-tracking'));
        }
        else {
            var open = Object(contact_helpers["e" /* isOpen */])({
                exceptionallyClosed: createExceptionallyClosedTimes(this.$ctx.data('exceptions-closed')),
                exceptionallyOpen: createExceptionallyOpenTimes(this.$ctx.data('exceptions-open')),
                openhours: this.$ctx.data('open-time'),
            });
            var swissWisitor = Object(helpers["isSwissVisitor"])();
            var introText = void 0;
            var additionalText = void 0;
            if (!swissWisitor) {
                introText = this.$ctx.data('intro-abroad') || '';
                additionalText = this.$ctx.data('addition-abroad') || '';
            }
            else if (open) {
                introText = this.$ctx.data('intro-open') || '';
                additionalText = this.$ctx.data('addition-open') || '';
            }
            else {
                introText = this.$ctx.data('intro-closed') || '';
                additionalText = this.$ctx.data('addition-closed') || '';
            }
            displaySettings = this.updateDisplayedConfig(displaySettings);
            var msgOptions = this.createMsgConfiguration(displaySettings);
            if (msgOptions.length) {
                Object(MsgChannel["a" /* renderMsgChannel */])(this.$contentHolder.get(0), this.$ctx.data('title') || '', introText, additionalText, msgOptions);
            }
        }
        callback();
    };
    SMSAndChat.prototype.updateDisplayedConfig = function (displaySettings) {
        var _loop_2 = function (msgChannel) {
            if (!displaySettings.includes(msgChannel)) {
                return "continue";
            }
            var msgOpenTime = this_1.$ctx.data(msgChannel + "-open-time");
            var msgExceptionsClosed = this_1.$ctx.data(msgChannel + "-exceptions-closed");
            var msgExceptionsOpen = this_1.$ctx.data(msgChannel + "-exceptions-open");
            if ((msgOpenTime && msgOpenTime.length) ||
                (msgExceptionsClosed && msgExceptionsClosed.length) ||
                (msgExceptionsOpen && msgExceptionsOpen.length)) {
                var isMsgChannelOpen = Object(contact_helpers["e" /* isOpen */])({
                    exceptionallyClosed: createExceptionallyClosedTimes(msgExceptionsClosed),
                    exceptionallyOpen: createExceptionallyOpenTimes(msgExceptionsOpen),
                    openhours: msgOpenTime,
                });
                if (!isMsgChannelOpen) {
                    displaySettings = displaySettings.filter(function (el) { return el !== msgChannel; });
                }
            }
        };
        var this_1 = this;
        for (var _i = 0, MESSAGING_CHANNELS_1 = MESSAGING_CHANNELS; _i < MESSAGING_CHANNELS_1.length; _i++) {
            var msgChannel = MESSAGING_CHANNELS_1[_i];
            _loop_2(msgChannel);
        }
        return displaySettings;
    };
    SMSAndChat.prototype.createMsgConfiguration = function (displaySettings) {
        var _this = this;
        return displaySettings.filter(function (e) { return e !== 'none'; }).map(function (val) {
            var res = {};
            if (val === 'sms') {
                res.channel = val;
                res.type = _this.$ctx.data('sms-type');
                res.tracking = _this.$ctx.data('sms-tracking');
                res.label = _this.$ctx.data('sms-label');
                if (!_this.isMobile) {
                    res.modalTitle = _this.$ctx.data('modal-title');
                    res.modalWidth = _this.$ctx.data('modal-width');
                    res.modalHeight = _this.$ctx.data('modal-height');
                    res.modalPath = _this.$ctx.data('path-to-modal');
                }
                else {
                    res.smsUrl = "sms:" + _this.$ctx.data('sms-number');
                }
            }
            if (val === 'abc') {
                res.channel = val;
                res.abcUrl = _this.$ctx.data('abc-url');
                res.tracking = _this.$ctx.data('abc-tracking');
                res.label = _this.$ctx.data('abc-label');
            }
            if (val === 'wa') {
                res.channel = val;
                res.tracking = _this.$ctx.data('wa-tracking');
                res.label = _this.$ctx.data('wa-label');
                res.waUrl = _this.$ctx.data('wa-url');
                res.type = _this.$ctx.data('wa-btn-type');
            }
            return res;
        });
    };
    return SMSAndChat;
}(Module["a" /* Module */]));
/* harmony default export */ var Tc_Module_SMSAndChat = (Tc_Module_SMSAndChat_SMSAndChat);

// EXTERNAL MODULE: ./clientlibs/js/lib/personalization/Tc.Module.SamAGB.ts
var Tc_Module_SamAGB = __webpack_require__(243);

// EXTERNAL MODULE: ./clientlibs/js/lib/sdx/Tc.Module.ScrollingArrow.ts
var Tc_Module_ScrollingArrow = __webpack_require__(244);

// CONCATENATED MODULE: ./clientlibs/js/lib/search/TC.Module.SearchInput.ts



var TC_Module_SearchInput_SearchInput = /** @class */ (function (_super) {
    Object(tslib_es6["c" /* __extends */])(SearchInput, _super);
    function SearchInput() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    // tslint:disable-next-line: prefer-function-over-method
    SearchInput.prototype.on = function (callback) {
        callback();
    };
    SearchInput.prototype.after = function () {
        return Object(tslib_es6["b" /* __awaiter */])(this, void 0, void 0, function () {
            var user, $searchInput;
            return Object(tslib_es6["d" /* __generator */])(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Object(personalization_profile["getProfile"])()];
                    case 1:
                        user = (_a.sent()).getUser();
                        $searchInput = this.$ctx.find('scs-search-input');
                        if (user && user.getSegment()) {
                            $searchInput.attr('customer-segment', user.getSegment());
                        }
                        $searchInput.attr('is-user-logged-in', "" + !!user);
                        return [2 /*return*/];
                }
            });
        });
    };
    return SearchInput;
}(Module["a" /* Module */]));
/* harmony default export */ var TC_Module_SearchInput = (TC_Module_SearchInput_SearchInput);

// CONCATENATED MODULE: ./clientlibs/js/lib/sdx/Tc.Module.SectionAnchorStage.ts




/**
 * SectionAnchorStage module implementation.
 *
 * @author tzhveig1
 * @class SectionAnchorStage
 * @extends Tc.Module
 */
var Tc_Module_SectionAnchorStage_SectionAnchorStage = /** @class */ (function (_super) {
    Object(tslib_es6["c" /* __extends */])(SectionAnchorStage, _super);
    function SectionAnchorStage() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Hook function to do all of your module stuff.
     *
     * @method on
     * @param  {Hook} callback Callback function
     * @return void
     */
    SectionAnchorStage.prototype.on = function (callback) {
        this.$anchors = this.$ctx.find('a');
        this.$anchors.on('click', smoothScroll);
        callback();
    };
    return SectionAnchorStage;
}(Module["a" /* Module */]));
/* harmony default export */ var Tc_Module_SectionAnchorStage = (Tc_Module_SectionAnchorStage_SectionAnchorStage);
function smoothScroll(event) {
    var $target = external___window__g_____g_$_____window_$CQ____window_$____window_jQuery_(event.target.hash);
    if ($target.length > 0) {
        var offset = $target.offset();
        if (offset !== undefined) {
            event.preventDefault();
            var additionalOffset = (Object(helpers["isMobilePage"])() || $target.is(':target')) ? 0 : 140;
            var crisisHeader = document.querySelector('.crisis');
            if (crisisHeader !== null) {
                additionalOffset += parseInt(window.getComputedStyle(crisisHeader).height, 10);
            }
            external___window__g_____g_$_____window_$CQ____window_$____window_jQuery_('html, body').animate({ scrollTop: offset.top - additionalOffset }, 1000, function () { return window.location.hash = event.target.hash.slice(1); });
        }
    }
}

// EXTERNAL MODULE: ./clientlibs/js/lib/ecommerce/Tc.Module.ServiceAvailability.ts
var Tc_Module_ServiceAvailability = __webpack_require__(44);

// CONCATENATED MODULE: ./clientlibs/js/lib/personalization/templating/providers/fallback.ts

function fallbackProvider(config) {
    return Object(tslib_es6["b" /* __awaiter */])(this, void 0, void 0, function () {
        return Object(tslib_es6["d" /* __generator */])(this, function (_a) {
            return [2 /*return*/, config.value];
        });
    });
}

// EXTERNAL MODULE: ./clientlibs/js/lib/util/array.ts
var array = __webpack_require__(17);

// CONCATENATED MODULE: ./clientlibs/js/lib/personalization/templating/providers/segmentMapping.ts



var RESPONSES = {};
function clearResponseCacheForTesting() {
    for (var url in RESPONSES) {
        // tslint:disable-next-line:no-dynamic-delete
        delete RESPONSES[url];
    }
}
function load(url, segments) {
    var key = segments && segments.length ? url + "/" + segments.join('.') : url;
    if (key in RESPONSES) {
        return RESPONSES[key];
    }
    RESPONSES[key] = external___window__g_____g_$_____window_$CQ____window_$____window_jQuery_["ajax"]({
        data: segments === null ? '' : { tntSegments: segments },
        dataType: 'json',
        type: segments === null ? 'get' : 'post',
        url: url,
        xhrFields: {
            withCredentials: true,
        },
    });
    return RESPONSES[key];
}
function getSegments(url) {
    return Object(tslib_es6["b" /* __awaiter */])(this, void 0, Promise, function () {
        var segmentConfig;
        return Object(tslib_es6["d" /* __generator */])(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if ('EXPERIENCES_PREVIEW_CURRENT_SEGMENTS' in window) {
                        return [2 /*return*/, window.EXPERIENCES_PREVIEW_CURRENT_SEGMENTS];
                    }
                    return [4 /*yield*/, load(url || 'https://swisscom.demdex.net/event?&d_rtbd=json&d_cts=2', null)];
                case 1:
                    segmentConfig = _a.sent();
                    return [2 /*return*/, (segmentConfig || {}).segments || []];
            }
        });
    });
}
function segmentMappingProvider(config) {
    return Object(tslib_es6["b" /* __awaiter */])(this, void 0, void 0, function () {
        var segments, _a, url, mapping, e_1;
        return Object(tslib_es6["d" /* __generator */])(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _a = array["b" /* unique */];
                    return [4 /*yield*/, getSegments(config.segmentUrl || 'https://swisscom.demdex.net/event?&d_rtbd=json&d_cts=2')];
                case 1:
                    segments = _a.apply(void 0, [_b.sent()]).sort();
                    if (!segments.length || !config.fieldName) {
                        return [2 /*return*/, null];
                    }
                    url = config.mappingUrl + "/_jcr_content.segments.json";
                    _b.label = 2;
                case 2:
                    _b.trys.push([2, 4, , 5]);
                    return [4 /*yield*/, load(url, segments)];
                case 3:
                    mapping = _b.sent();
                    return [2 /*return*/, mapping[config.fieldName]];
                case 4:
                    e_1 = _b.sent();
                    console.warn("Error loading segment mapping from " + config.mappingUrl, e_1);
                    return [2 /*return*/, null];
                case 5: return [2 /*return*/];
            }
        });
    });
}

// CONCATENATED MODULE: ./clientlibs/js/lib/personalization/templating/Tc.Module.TemplatingContainer.ts






function configuredProvider(config) {
    switch (config.type) {
        case 'fallback':
            return fallbackProvider.bind(null, config);
        case 'segmentMapping':
            return segmentMappingProvider.bind(null, config);
        default:
            console.warn('Templating provider for config', config, 'not registered');
            return null;
    }
}
function resolve(placeholder, providers) {
    return Object(tslib_es6["b" /* __awaiter */])(this, void 0, Promise, function () {
        var _i, providers_1, providerConfig, provider, result, e_1;
        return Object(tslib_es6["d" /* __generator */])(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _i = 0, providers_1 = providers;
                    _a.label = 1;
                case 1:
                    if (!(_i < providers_1.length)) return [3 /*break*/, 6];
                    providerConfig = providers_1[_i];
                    provider = configuredProvider(providerConfig);
                    if (!provider) {
                        return [3 /*break*/, 5];
                    }
                    _a.label = 2;
                case 2:
                    _a.trys.push([2, 4, , 5]);
                    return [4 /*yield*/, provider()];
                case 3:
                    result = _a.sent();
                    if (typeof result === 'string') {
                        return [2 /*return*/, [placeholder, result]];
                    }
                    return [3 /*break*/, 5];
                case 4:
                    e_1 = _a.sent();
                    console.warn("Error resolving placeholder " + placeholder + " from", providerConfig, e_1);
                    return [3 /*break*/, 5];
                case 5:
                    _i++;
                    return [3 /*break*/, 1];
                case 6: return [2 /*return*/, [placeholder, null]];
            }
        });
    });
}
function resolveAll(variables) {
    return Object(tslib_es6["b" /* __awaiter */])(this, void 0, void 0, function () {
        var replacements, resolved, _i, replacements_1, _a, name, rep;
        return Object(tslib_es6["d" /* __generator */])(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, Promise.all(variables.map(function (c) { return resolve(c.name, c.providers); }))];
                case 1:
                    replacements = _b.sent();
                    resolved = {};
                    for (_i = 0, replacements_1 = replacements; _i < replacements_1.length; _i++) {
                        _a = replacements_1[_i], name = _a[0], rep = _a[1];
                        if (rep) {
                            resolved[name] = rep;
                        }
                    }
                    return [2 /*return*/, resolved];
            }
        });
    });
}
function escapeRegExp(re) {
    return re.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}
function transform(text, prefix, resolvedPlaceholders) {
    return text.replace(new RegExp(escapeRegExp(prefix) + "\\{([^}]+)\\}", 'g'), function (_str, placeholder) {
        if (placeholder in resolvedPlaceholders) {
            return resolvedPlaceholders[placeholder];
        }
        return '';
    });
}
/**
 * Render templating content of all templating components in preview
 */
function refreshAllTemplatingContainers() {
    return Promise.all(external___window__g_____g_$_____window_$CQ____window_$____window_jQuery_('.modTemplatingContainer')
        .get()
        .map(function (el) {
        return window.application.sandbox.getModuleInstance(el, 'TemplatingContainer').refresh();
    }));
}
var templating = Object(helpers["namespace"])('SCS.templating');
function processMBoxContent(mbox) {
    var $mbox = external___window__g_____g_$_____window_$CQ____window_$____window_jQuery_(mbox);
    $mbox.parents('.modTemplatingContainer').each(function (_index, $el) {
        window.application.sandbox.getModuleInstance($el, 'TemplatingContainer')
            .processMBoxContent(mbox);
    });
}
if (!('processMBoxContent' in templating)) {
    templating.processMBoxContent = processMBoxContent;
}
var Tc_Module_TemplatingContainer_TemplatingContainer = /** @class */ (function (_super) {
    Object(tslib_es6["c" /* __extends */])(TemplatingContainer, _super);
    function TemplatingContainer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TemplatingContainer.prototype.on = function (callback) {
        this.template = this.$ctx.find('> template')[0];
        if (Object(helpers["isEditMode"])() || !this.template) {
            callback();
            return;
        }
        if (external___window__g_____g_$_____window_$CQ____window_$____window_jQuery_(document.body).is('.activitypage')) {
            this.templatePrototype = this.template.cloneNode(true);
        }
        if (this.template.content) {
            this.fragment = this.template.content;
        }
        else {
            this.template.style.display = 'none';
        }
        this.config = this.$ctx.data('templatingConfiguration');
        this.process().catch(function (e) {
            console.error('Unable to transform template placeholders', e);
        });
        callback();
    };
    /**
     * Render templating content in preview
     */
    TemplatingContainer.prototype.refresh = function () {
        return Object(tslib_es6["b" /* __awaiter */])(this, void 0, void 0, function () {
            var e_2;
            return Object(tslib_es6["d" /* __generator */])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.template = this.templatePrototype.cloneNode(true);
                        if (this.template.content) {
                            this.fragment = this.template.content;
                            // Remove previous content
                            while (this.$ctx[0].hasChildNodes()) {
                                this.$ctx[0].removeChild(this.$ctx[0].lastChild);
                            }
                        }
                        else {
                            this.template.style.display = 'none';
                            this.$ctx[0].innerHTML = '';
                        }
                        this.resolvedPlaceholders = undefined;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.process()];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        e_2 = _a.sent();
                        console.error('Unable to transform template placeholders', e_2);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    TemplatingContainer.prototype.process = function () {
        return Object(tslib_es6["b" /* __awaiter */])(this, void 0, void 0, function () {
            var templatingReadyEvent, _a;
            return Object(tslib_es6["d" /* __generator */])(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        templatingReadyEvent = 'TEMPLATING_READY';
                        if (!!this.resolvedPlaceholders) return [3 /*break*/, 2];
                        _a = this;
                        return [4 /*yield*/, resolveAll(this.config.placeholders)];
                    case 1:
                        _a.resolvedPlaceholders = _b.sent();
                        _b.label = 2;
                    case 2:
                        this.log('Resolved placeholders', this.resolvedPlaceholders);
                        if (!('XPathResult' in window) || !this.fragment) {
                            // IE Does not support XPath, simply use innerHTML
                            external___window__g_____g_$_____window_$CQ____window_$____window_jQuery_(this.$ctx[0]).html(this.processStringContent(this.template.innerHTML));
                            external___window__g_____g_$_____window_$CQ____window_$____window_jQuery_(document.body).trigger(templatingReadyEvent);
                            return [2 /*return*/];
                        }
                        if (!this.fragment.childNodes[0]) {
                            return [2 /*return*/];
                        }
                        this.fragment = this.processContent(this.fragment);
                        this.$ctx.append(this.fragment);
                        external___window__g_____g_$_____window_$CQ____window_$____window_jQuery_(document.body).trigger(templatingReadyEvent);
                        return [2 /*return*/];
                }
            });
        });
    };
    TemplatingContainer.prototype.processMBoxContent = function (mbox) {
        mbox.innerHTML = this.processStringContent(mbox.innerHTML);
    };
    TemplatingContainer.prototype.processStringContent = function (content) {
        if (!this.resolvedPlaceholders) {
            return content;
        }
        return transform(content, this.config.prefix, this.resolvedPlaceholders);
    };
    TemplatingContainer.prototype.processContent = function (content) {
        if (!this.resolvedPlaceholders) {
            return content;
        }
        // Hack: You can’t use a document fragment as the context of an XPath query.
        //       But you can select it with `..` if you use its child node.
        var target = content.childNodes[0];
        if (!target) {
            return content;
        }
        var attrs = target.ownerDocument.evaluate("..//attribute::*[contains(., '" + this.config.prefix + "')]", target, null, XPathResult.UNORDERED_NODE_SNAPSHOT_TYPE, null);
        for (var i = 0; i < attrs.snapshotLength; i++) {
            var attr = attrs.snapshotItem(i);
            this.log.debug('Replacing placeholders in attribute', attr);
            attr.value = transform(attr.value, this.config.prefix, this.resolvedPlaceholders);
        }
        var texts = target.ownerDocument.evaluate("..//text()[contains(., '" + this.config.prefix + "')]", target, null, XPathResult.UNORDERED_NODE_SNAPSHOT_TYPE, null);
        for (var i = 0; i < texts.snapshotLength; i++) {
            var text = texts.snapshotItem(i);
            var parent = text.parentNode;
            this.log.debug('Replacing placeholders in text node', text);
            parent.replaceChild(document.createTextNode(transform(text.textContent, this.config.prefix, this.resolvedPlaceholders)), text);
        }
        return content;
    };
    return TemplatingContainer;
}(Module["a" /* Module */]));
/* harmony default export */ var Tc_Module_TemplatingContainer = (Tc_Module_TemplatingContainer_TemplatingContainer);

// CONCATENATED MODULE: ./clientlibs/js/lib/cleanpipe/Tc.Module.URLChecker.ts



var Tc_Module_URLChecker_CSS_CLASS_HIDDEN = 'hidden';
var Tc_Module_URLChecker_EVENT_TYPE_CLICK = 'click';
var HTML_TAG_FORM = 'form';
var Tc_Module_URLChecker_AJAX_TYPE_POST = 'POST';
var AJAX_TYPE_GET = 'GET';
var AJAX_DATA_TYPE_JSON = 'json';
var CAPCHA_NEEDED_EVENT = 'captchaNeededEvent';
var DATA_ERR_MSG = 'general-error-message';
/**
 * URLChecker module implementation.
 *
 * @author Nikola Tica
 * @class URLChecker
 * @extends Tc.Module
 */
var Tc_Module_URLChecker_URLChecker = /** @class */ (function (_super) {
    Object(tslib_es6["c" /* __extends */])(URLChecker, _super);
    function URLChecker() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Hook function to do all of your module stuff.
     *
     * @method on
     * @return void
     */
    URLChecker.prototype.on = function (callback) {
        this.$formHolder = this.$ctx.find('.form-holder');
        this.$checkedURLHolder = this.$ctx.find('.checked-url-holder');
        this.$spinnerHolder = this.$ctx.find('.spinner-holder');
        this.$resultSectionHolder = this.$ctx.find('.result-display-holder');
        this.$resetButton = this.$ctx.find('.reset-url-checker');
        this.$form = this.$formHolder.find(HTML_TAG_FORM);
        this.$input = this.$ctx.find('#url');
        this.$submitButton = this.$ctx.find('.check-url-button');
        this.$blacklistedTitle = this.$ctx.find('.blacklisted-title-holder');
        this.$notBlacklistedTitle = this.$ctx.find('.not-blacklisted-title-holder');
        this.$additionalInfoHolder = this.$ctx.find('.blacklisted-reasone-holder');
        this.$additionalInfo = this.$ctx.find('.blacklisted-reasone');
        this.$errorMsgHolder = this.$form.find('.headingError');
        this.$errorMsg = this.$errorMsgHolder.find('.msg');
        this.$ajaxCaptcha = this.$ctx.find('.modAjaxCaptcha');
        this.errorMesage = this.$ctx.data(DATA_ERR_MSG);
        this.reset();
        this.$resetButton.on(Tc_Module_URLChecker_EVENT_TYPE_CLICK, this.reset.bind(this));
        this.$submitButton.on(Tc_Module_URLChecker_EVENT_TYPE_CLICK, this.submitForm.bind(this));
        external___window__g_____g_$_____window_$CQ____window_$____window_jQuery_["ajax"]({
            data: "path=" + encodeURIComponent(window.location.pathname),
            dataType: AJAX_DATA_TYPE_JSON,
            success: this.handleCaptchaResult.bind(this),
            type: AJAX_TYPE_GET,
            url: '/etc/swisscom/servlets/public/urlchecker.urlchecker.json',
        });
        callback();
    };
    /**
     * Handles captcha result
     */
    URLChecker.prototype.handleCaptchaResult = function (data) {
        if (data.captcha) {
            this.$ajaxCaptcha.trigger(CAPCHA_NEEDED_EVENT);
        }
    };
    /**
     * Shows URL checker form part
     */
    URLChecker.prototype.showFormSection = function () {
        this.$formHolder.removeClass(Tc_Module_URLChecker_CSS_CLASS_HIDDEN);
    };
    /**
     * Hides URL checker form part
     */
    URLChecker.prototype.hideFormSection = function () {
        this.$formHolder.addClass(Tc_Module_URLChecker_CSS_CLASS_HIDDEN);
    };
    /**
     * Shows spinner holder
     */
    URLChecker.prototype.showSpinner = function () {
        this.$spinnerHolder.removeClass(Tc_Module_URLChecker_CSS_CLASS_HIDDEN);
    };
    /**
     * Hides spinner holder
     */
    URLChecker.prototype.hideSpinner = function () {
        this.$spinnerHolder.addClass(Tc_Module_URLChecker_CSS_CLASS_HIDDEN);
    };
    /**
     * Shows result section
     */
    URLChecker.prototype.showResultSection = function () {
        this.$resultSectionHolder.removeClass(Tc_Module_URLChecker_CSS_CLASS_HIDDEN);
    };
    /**
     * Hides result section
     */
    URLChecker.prototype.hideResultSection = function () {
        this.$resultSectionHolder.addClass(Tc_Module_URLChecker_CSS_CLASS_HIDDEN);
    };
    /**
     * Shows blacklisted title
     */
    URLChecker.prototype.showBlackListedTitle = function () {
        this.$blacklistedTitle.removeClass(Tc_Module_URLChecker_CSS_CLASS_HIDDEN);
    };
    /**
     * Hides blacklisted title
     */
    URLChecker.prototype.hideBlackListedTitle = function () {
        this.$blacklistedTitle.addClass(Tc_Module_URLChecker_CSS_CLASS_HIDDEN);
    };
    /**
     * Shows not blacklisted title
     */
    URLChecker.prototype.showNotBlackListedTitle = function () {
        this.$notBlacklistedTitle.removeClass(Tc_Module_URLChecker_CSS_CLASS_HIDDEN);
    };
    /**
     * Hides not blacklisted title
     */
    URLChecker.prototype.hideNotBlackListedTitle = function () {
        this.$notBlacklistedTitle.addClass(Tc_Module_URLChecker_CSS_CLASS_HIDDEN);
    };
    /**
     * Shows additional info
     */
    URLChecker.prototype.showAdditionalInfo = function () {
        this.$additionalInfoHolder.removeClass(Tc_Module_URLChecker_CSS_CLASS_HIDDEN);
    };
    /**
     * Hides additional info
     */
    URLChecker.prototype.hideAdditionalInfo = function () {
        this.$additionalInfoHolder.addClass(Tc_Module_URLChecker_CSS_CLASS_HIDDEN);
    };
    /**
     * Shows form error message
     */
    URLChecker.prototype.showFormError = function () {
        this.$errorMsg.text(this.errorMesage);
        this.$errorMsgHolder.removeClass(Tc_Module_URLChecker_CSS_CLASS_HIDDEN);
    };
    /**
     * Hides form error message
     */
    URLChecker.prototype.hideFormError = function () {
        this.$errorMsgHolder.addClass(Tc_Module_URLChecker_CSS_CLASS_HIDDEN);
        this.$errorMsg.text('');
    };
    /**
     * Populates the checked url holder
     */
    URLChecker.prototype.populateCheckedURLHolder = function (url) {
        this.$checkedURLHolder.text(url);
    };
    /**
     * Populates additional info
     */
    URLChecker.prototype.populateadditionalInfo = function (text) {
        if (text === void 0) { text = ''; }
        this.$additionalInfo.empty().html(text);
    };
    /**
     * Resets module
     */
    URLChecker.prototype.reset = function () {
        this.hideFormError();
        this.showFormSection();
        this.hideSpinner();
        this.hideResultSection();
        this.hideAdditionalInfo();
        this.hideBlackListedTitle();
        this.hideNotBlackListedTitle();
        this.$input.val('');
        this.populateCheckedURLHolder('');
        this.populateadditionalInfo('');
    };
    /**
     * Submits form
     */
    URLChecker.prototype.submitForm = function (evt) {
        var formApi = this.$form.parent().data('form-api');
        var invalidateFieldsNum = formApi.validateForm();
        var mod = this;
        evt.preventDefault();
        if (!invalidateFieldsNum) {
            this.hideFormSection();
            this.showSpinner();
            external___window__g_____g_$_____window_$CQ____window_$____window_jQuery_["ajax"]({
                data: this.$form.serialize() + "&path=" + encodeURIComponent(window.location.pathname),
                dataType: AJAX_DATA_TYPE_JSON,
                success: this.handleSubmitResult.bind(this),
                type: Tc_Module_URLChecker_AJAX_TYPE_POST,
                url: '/etc/swisscom/servlets/public/urlchecker.urlchecker.json',
                error: function (data) {
                    mod.handleInvalidResponse(data.responseJSON);
                },
            });
        }
    };
    /**
     * Handles submit result
     */
    URLChecker.prototype.handleSubmitResult = function (data) {
        if (!data.success) {
            this.handleInvalidResponse(data);
        }
        else {
            this.handleSuccessResponse(data.data);
        }
    };
    /**
     * Handles invalid response
     */
    URLChecker.prototype.handleInvalidResponse = function (data) {
        if (data.data.captcha) {
            this.$ajaxCaptcha.trigger(CAPCHA_NEEDED_EVENT);
        }
        this.errorMesage = data.data.description ? data.data.description : this.$ctx.data(DATA_ERR_MSG);
        this.showFormError();
        this.hideSpinner();
        this.showFormSection();
    };
    /**
     * Handles success response
     */
    URLChecker.prototype.handleSuccessResponse = function (data) {
        if (data.captcha) {
            this.$ajaxCaptcha.trigger(CAPCHA_NEEDED_EVENT);
        }
        var inputVal = this.$input.val();
        this.populateCheckedURLHolder(String(inputVal));
        if (data.blocked) {
            this.showBlackListedTitle();
            this.hideNotBlackListedTitle();
            this.populateadditionalInfo(data.additionalInfo);
            if (data.additionalInfo) {
                this.showAdditionalInfo();
            }
            else {
                this.hideAdditionalInfo();
            }
        }
        else {
            this.hideBlackListedTitle();
            this.showNotBlackListedTitle();
            this.hideAdditionalInfo();
        }
        this.hideSpinner();
        this.showResultSection();
    };
    return URLChecker;
}(Module["a" /* Module */]));
/* harmony default export */ var Tc_Module_URLChecker = (Tc_Module_URLChecker_URLChecker);

// EXTERNAL MODULE: ./clientlibs/js/lib/personalization/Tc.Module.UserBox.ts
var Tc_Module_UserBox = __webpack_require__(32);

// CONCATENATED MODULE: ./clientlibs/js/lib/ecommerce/lego/Tc.Module.WBCOrderButton.ts





var Tc_Module_WBCOrderButton_WBCOrderButton = /** @class */ (function (_super) {
    Object(tslib_es6["c" /* __extends */])(WBCOrderButton, _super);
    function WBCOrderButton() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isProcessing = false;
        return _this;
    }
    WBCOrderButton.prototype.on = function (callback) {
        this.log.debug('on');
        this.button = this.$ctx.find('> sdx-button')[0];
        this.button.disabled = true;
        callback();
    };
    WBCOrderButton.prototype.after = function () {
        this.log.debug('after');
        this.mapping = Object(DOCPCheckout["b" /* loadDOCPProductMapping */])();
        this.button.addEventListener('click', this.clicked.bind(this), false);
    };
    WBCOrderButton.prototype.clicked = function (event) {
        return Object(tslib_es6["b" /* __awaiter */])(this, void 0, void 0, function () {
            var products, mapping, flavours, url, e_1;
            return Object(tslib_es6["d" /* __generator */])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        event.preventDefault();
                        products = this.products;
                        if (!products || this.isProcessing) {
                            this.log.warn('No products yet');
                            return [2 /*return*/];
                        }
                        this.log.debug('Clicked WBC Order button with', products);
                        this.button.disabled = true;
                        this.isProcessing = true;
                        return [4 /*yield*/, this.mapping];
                    case 1:
                        mapping = _a.sent();
                        flavours = Object(DOCPCheckout["c" /* mapFlavours */])(mapping, products, this);
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 4, , 5]);
                        return [4 /*yield*/, urlToWbc(flavours, "" + window.location.pathname + window.location.search + window.location.hash)];
                    case 3:
                        url = _a.sent();
                        window.location.href = url;
                        return [3 /*break*/, 5];
                    case 4:
                        e_1 = _a.sent();
                        this.log.error('Couldn’t get URL to WBC', e_1);
                        this.isProcessing = false;
                        this.button.disabled = false;
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Terrific Handler, fired by Tc.Module.LegoContainer.Configurator.
     * Collects all selected product IDs and prepares the parameters needed for the order button URLs.
     */
    WBCOrderButton.prototype.onNewLegoConfiguration = function (_a) {
        var currentSelection = _a.currentSelection;
        this.products = currentSelection;
        if (!this.isProcessing) {
            this.button.disabled = false;
        }
    };
    return WBCOrderButton;
}(Module["a" /* Module */]));
/* harmony default export */ var Tc_Module_WBCOrderButton = (Tc_Module_WBCOrderButton_WBCOrderButton);
var PES_URL = '/oce/soe/wbc/common/v1/input';
function urlToWbc(flavours, returnUrl) {
    var _a, _b, _c, _d, _e, _f;
    return Object(tslib_es6["b" /* __awaiter */])(this, void 0, void 0, function () {
        var payload, fetch, response, body, exchangeId, profile;
        return Object(tslib_es6["d" /* __generator */])(this, function (_g) {
            switch (_g.label) {
                case 0:
                    payload = {
                        bundleSkuCode: 'LEGO_Home',
                        cancelUrl: returnUrl,
                        internetFlavourSkuCode: (_b = (_a = flavours.internetFlavour) === null || _a === void 0 ? void 0 : _a.skuCode) !== null && _b !== void 0 ? _b : null,
                        returnUrl: returnUrl,
                        tvFlavourSkuCode: (_d = (_c = flavours.tvFlavour) === null || _c === void 0 ? void 0 : _c.skuCode) !== null && _d !== void 0 ? _d : null,
                        u26: false,
                        uiLanguage: document.documentElement.lang,
                        voipFlavourSkuCode: (_f = (_e = flavours.voipFlavour) === null || _e === void 0 ? void 0 : _e.skuCode) !== null && _f !== void 0 ? _f : null,
                    };
                    return [4 /*yield*/, Object(helpers["fetcher"])()];
                case 1:
                    fetch = _g.sent();
                    return [4 /*yield*/, fetch(PES_URL, {
                            body: JSON.stringify(payload),
                            headers: Object(tslib_es6["a" /* __assign */])({ consumer: 'OCE', 'content-type': 'application/json' }, Object(DOCPCheckout["d" /* xsrfHeader */])()),
                            method: 'POST',
                        })];
                case 2:
                    response = _g.sent();
                    return [4 /*yield*/, response.json()];
                case 3:
                    body = _g.sent();
                    exchangeId = body.exchangeId;
                    if (!exchangeId && /\bdevconsole\b/.test(window.location.href)) {
                        console.error('Did not get an exchange ID back from', PES_URL, 'instead got', body);
                    }
                    return [4 /*yield*/, Object(personalization_profile["getProfile"])()];
                case 4:
                    profile = _g.sent();
                    return [2 /*return*/, "/bundle-configurator/?" + (profile.getUser() ? '' : 'login&') + (exchangeId ? 'exchangeId=' + exchangeId : '')];
            }
        });
    });
}

// CONCATENATED MODULE: ./clientlibs/js/by-category/scs.portal.desktop.ts
// base=/etc/designs/portal/clientlibs
// -----------------------------------------------------------------------------
// VENDOR CODE
// -----------------------------------------------------------------------------
//
// Don't forget to add vendor libs to wiki page:
//
// See https://wiki.swisscom.com/display/PD/PORTAL+-+3rd+Party+Javascript+and+CSS+Libraries
// -----------------------------------------------------------------------------
// jQuery plugins

// jQuery extensions



// Other

// -----------------------------------------------------------------------------
// SWISSCOM CODE used by both o2012 (res) and old (corporate) pages
// -----------------------------------------------------------------------------
// # Global defaults for dialog

// Seems to be used directly


// Used by forms

// -----------------------------------------------------------------------------
// SWISSCOM CODE / LIBRARIES
// -----------------------------------------------------------------------------


// COMPONENTS






// BOOTSTRAPPERS



// -----------------------------------------------------------------------------
// TERRIFIC MODULES - A-Z PLEASE
// -----------------------------------------------------------------------------

































































// A-Z please

// Modern modules (using imports/exports)














































// Tc Bootstrap

var scs_portal_desktop_modernTcModules = {
    Button: Tc_Module_Button,
    COSMOSResultContainer: Tc_Module_COSMOSResultContainer,
    CallFromNet: Tc_Module_CallFromNet["a" /* default */],
    CallOut: Tc_Module_CallOut["a" /* default */],
    DataContainer: Tc_Module_DataContainer["a" /* default */],
    DownloadNRepPDF: Tc_Module_DownloadNRepPDF,
    EasyPointQrCode: Tc_Module_EasyPointQrCode,
    EnlargeImageView: Tc_Module_EnlargeImageView["a" /* default */],
    ExpandAndCollapse: Tc_Module_ExpandAndCollapse,
    FormDataRestore: Tc_Module_FormDataRestore["a" /* default */],
    GcrNewsArchiveResults: Tc_Module_GcrNewsArchiveResults,
    GcrNewsArchiveSearch: Tc_Module_GcrNewsArchiveSearch,
    GenericPDFFiller: Tc_Module_GenericPDFFiller,
    GenesysChatForContact: Tc_Module_GenesysChatForContact,
    LeadManagement: Tc_Module_LeadManagement["a" /* default */],
    LegoContainer: {
        module: Tc_Module_LegoContainer,
        skins: skins_namespaceObject,
    },
    LegoOrderButton: Tc_Module_LegoOrderButton["a" /* default */],
    LivePersonChatForContact: Tc_Module_LivePersonChatForContact["a" /* default */],
    LottieAnimatedSVG: Tc_Module_LottieAnimatedSVG,
    OrderOverlay: Tc_Module_OrderOverlay,
    OrderOverlayOrderButtons: Tc_Module_OrderOverlayOrderButtons,
    PDFQrCode: Tc_Module_PDFQrCode["a" /* default */],
    PexArticleDetail: Tc_Module_PexArticleDetail["a" /* default */],
    PexIncidentInfoDialog: Tc_Module_PexIncidentInfoDialog["a" /* default */],
    PexIncidentList: Tc_Module_PexIncidentList,
    PexMustReadModal: Tc_Module_PexMustReadModal["a" /* default */],
    PortalStage: Tc_Module_PortalStage["a" /* default */],
    PriceBox: Tc_Module_PriceBox["default"],
    PriceDetails: Tc_Module_PriceDetails["a" /* default */],
    RatingList: Tc_Module_RatingList["b" /* default */],
    RatingOverview: Tc_Module_RatingOverview["a" /* default */],
    RetentionResult: Tc_Module_RetentionResult["a" /* default */],
    SDXContactWizard: Tc_Module_SDXContactWizard["a" /* default */],
    SDXDatePicker: Tc_Module_SDXDatePicker["a" /* default */],
    SMSAndChat: Tc_Module_SMSAndChat,
    SamAGB: Tc_Module_SamAGB["a" /* default */],
    ScrollElement: Tc_Module_ScrollElement["a" /* default */],
    ScrollingArrow: Tc_Module_ScrollingArrow["a" /* default */],
    SearchInput: TC_Module_SearchInput,
    SectionAnchorStage: Tc_Module_SectionAnchorStage,
    ServiceAvailability: Tc_Module_ServiceAvailability["a" /* default */],
    TemplatingContainer: Tc_Module_TemplatingContainer,
    URLChecker: Tc_Module_URLChecker,
    UserBox: Tc_Module_UserBox["default"],
    WBCOrderButton: Tc_Module_WBCOrderButton,
};
Object(load_terrific["legacyBootstrapDeferredSingleton"])(scs_portal_desktop_modernTcModules);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/ecommerce/clientlibs/shared/js/common.js
var js_common = __webpack_require__(245);
var js_common_default = /*#__PURE__*/__webpack_require__.n(js_common);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/ecommerce/clientlibs/desktop/js/abo.js
var abo = __webpack_require__(246);
var abo_default = /*#__PURE__*/__webpack_require__.n(abo);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/ecommerce/clientlibs/shared/js/clipping.js
var clipping = __webpack_require__(247);
var clipping_default = /*#__PURE__*/__webpack_require__.n(clipping);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/ecommerce/clientlibs/shared/js/modules/Tc.Module.EcommerceProductDataHubTracking.js
var Tc_Module_EcommerceProductDataHubTracking = __webpack_require__(248);
var Tc_Module_EcommerceProductDataHubTracking_default = /*#__PURE__*/__webpack_require__.n(Tc_Module_EcommerceProductDataHubTracking);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/ecommerce/clientlibs/shared/js/modules/Tc.Module.EcommerceProductDetail.js
var Tc_Module_EcommerceProductDetail = __webpack_require__(249);
var Tc_Module_EcommerceProductDetail_default = /*#__PURE__*/__webpack_require__.n(Tc_Module_EcommerceProductDetail);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/ecommerce/clientlibs/shared/js/modules/Tc.Module.PricedBundleTitle.js
var Tc_Module_PricedBundleTitle = __webpack_require__(250);
var Tc_Module_PricedBundleTitle_default = /*#__PURE__*/__webpack_require__.n(Tc_Module_PricedBundleTitle);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/ecommerce/clientlibs/shared/js/modules/Tc.Module.ProductAmountPrice.js
var Tc_Module_ProductAmountPrice = __webpack_require__(251);
var Tc_Module_ProductAmountPrice_default = /*#__PURE__*/__webpack_require__.n(Tc_Module_ProductAmountPrice);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/ecommerce/clientlibs/shared/js/modules/Tc.Module.ProductImage.js
var Tc_Module_ProductImage = __webpack_require__(252);
var Tc_Module_ProductImage_default = /*#__PURE__*/__webpack_require__.n(Tc_Module_ProductImage);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/ecommerce/clientlibs/shared/js/modules/Tc.Module.ProductOptionsSummary.js
var Tc_Module_ProductOptionsSummary = __webpack_require__(253);
var Tc_Module_ProductOptionsSummary_default = /*#__PURE__*/__webpack_require__.n(Tc_Module_ProductOptionsSummary);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/ecommerce/clientlibs/shared/js/modules/Tc.Module.ProductItemGroup.js
var Tc_Module_ProductItemGroup = __webpack_require__(254);
var Tc_Module_ProductItemGroup_default = /*#__PURE__*/__webpack_require__.n(Tc_Module_ProductItemGroup);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/ecommerce/clientlibs/shared/js/modules/Tc.Module.ProductTeaser.js
var Tc_Module_ProductTeaser = __webpack_require__(255);
var Tc_Module_ProductTeaser_default = /*#__PURE__*/__webpack_require__.n(Tc_Module_ProductTeaser);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/ecommerce/clientlibs/shared/js/modules/Tc.Module.RetentionButton.js
var Tc_Module_RetentionButton = __webpack_require__(256);
var Tc_Module_RetentionButton_default = /*#__PURE__*/__webpack_require__.n(Tc_Module_RetentionButton);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/ecommerce/clientlibs/shared/js/modules/Tc.Module.RetentionDisplay.js
var Tc_Module_RetentionDisplay = __webpack_require__(257);
var Tc_Module_RetentionDisplay_default = /*#__PURE__*/__webpack_require__.n(Tc_Module_RetentionDisplay);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/ecommerce/clientlibs/shared/js/modules/Tc.Module.Subtotal.js
var Tc_Module_Subtotal = __webpack_require__(258);
var Tc_Module_Subtotal_default = /*#__PURE__*/__webpack_require__.n(Tc_Module_Subtotal);

// EXTERNAL MODULE: ./clientlibs/js/lib/ecommerce/Tc.Module.EcommerceProductDataHub.ts
var Tc_Module_EcommerceProductDataHub = __webpack_require__(16);

// EXTERNAL MODULE: ./clientlibs/js/lib/ecommerce/Tc.Module.OnlineAvailabilityInfo.ts
var Tc_Module_OnlineAvailabilityInfo = __webpack_require__(259);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/ecommerce/clientlibs/shared/js/cbu.js
var cbu = __webpack_require__(260);
var cbu_default = /*#__PURE__*/__webpack_require__.n(cbu);

// CONCATENATED MODULE: ./clientlibs/js/by-category/scs.ecommerce.desktop.ts
// ********************************************************************************
// SWISSCOM CODE
// ********************************************************************************

// Commons

// Components


// Terrific modules













Object(load_terrific["legacyBootstrapDeferredSingleton"])({
    EcommerceProductDataHub: Tc_Module_EcommerceProductDataHub["b" /* default */],
    OnlineAvailabilityInfo: Tc_Module_OnlineAvailabilityInfo["a" /* default */],
});
// Must execute last


// EXTERNAL MODULE: ./clientlibs/js/etc/designs/forms/clientlibs/shared/js/vendor/jquery.stylish-select.js
var jquery_stylish_select = __webpack_require__(261);
var jquery_stylish_select_default = /*#__PURE__*/__webpack_require__.n(jquery_stylish_select);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/forms/clientlibs/shared/js/libraries/SCS.Captcha.js
var SCS_Captcha = __webpack_require__(262);
var SCS_Captcha_default = /*#__PURE__*/__webpack_require__.n(SCS_Captcha);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/forms/clientlibs/shared/js/libraries/ScForm.InvalidField.js
var ScForm_InvalidField = __webpack_require__(263);
var ScForm_InvalidField_default = /*#__PURE__*/__webpack_require__.n(ScForm_InvalidField);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/forms/clientlibs/shared/js/libraries/ScForm.ClientValidation.js
var ScForm_ClientValidation = __webpack_require__(264);
var ScForm_ClientValidation_default = /*#__PURE__*/__webpack_require__.n(ScForm_ClientValidation);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/forms/clientlibs/shared/js/libraries/ScForm.ValidationReturn.js
var ScForm_ValidationReturn = __webpack_require__(265);
var ScForm_ValidationReturn_default = /*#__PURE__*/__webpack_require__.n(ScForm_ValidationReturn);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/forms/clientlibs/shared/js/modules/Tc.Module.AjaxCaptcha.js
var Tc_Module_AjaxCaptcha = __webpack_require__(266);
var Tc_Module_AjaxCaptcha_default = /*#__PURE__*/__webpack_require__.n(Tc_Module_AjaxCaptcha);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/forms/clientlibs/shared/js/modules/Tc.Module.Autocomplete.js
var Tc_Module_Autocomplete = __webpack_require__(267);
var Tc_Module_Autocomplete_default = /*#__PURE__*/__webpack_require__.n(Tc_Module_Autocomplete);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/forms/clientlibs/shared/js/modules/Tc.Module.AutoSuggestAddress.js
var Tc_Module_AutoSuggestAddress = __webpack_require__(268);
var Tc_Module_AutoSuggestAddress_default = /*#__PURE__*/__webpack_require__.n(Tc_Module_AutoSuggestAddress);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/forms/clientlibs/shared/js/modules/Tc.Module.AutoSuggestAddress.ZipAndCity.js
var Tc_Module_AutoSuggestAddress_ZipAndCity = __webpack_require__(269);
var Tc_Module_AutoSuggestAddress_ZipAndCity_default = /*#__PURE__*/__webpack_require__.n(Tc_Module_AutoSuggestAddress_ZipAndCity);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/forms/clientlibs/shared/js/modules/Tc.Module.Captcha.js
var Tc_Module_Captcha = __webpack_require__(270);
var Tc_Module_Captcha_default = /*#__PURE__*/__webpack_require__.n(Tc_Module_Captcha);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/forms/clientlibs/shared/js/modules/Tc.Module.C4PrintButton.js
var Tc_Module_C4PrintButton = __webpack_require__(271);
var Tc_Module_C4PrintButton_default = /*#__PURE__*/__webpack_require__.n(Tc_Module_C4PrintButton);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/forms/clientlibs/shared/js/modules/Tc.Module.DatePicker.js
var Tc_Module_DatePicker = __webpack_require__(272);
var Tc_Module_DatePicker_default = /*#__PURE__*/__webpack_require__.n(Tc_Module_DatePicker);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/forms/clientlibs/desktop/js/modules/Tc.Module.DropDownCascade.js
var Tc_Module_DropDownCascade = __webpack_require__(273);
var Tc_Module_DropDownCascade_default = /*#__PURE__*/__webpack_require__.n(Tc_Module_DropDownCascade);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/forms/clientlibs/shared/js/modules/Tc.Module.DropDownCascadeRest.js
var Tc_Module_DropDownCascadeRest = __webpack_require__(274);
var Tc_Module_DropDownCascadeRest_default = /*#__PURE__*/__webpack_require__.n(Tc_Module_DropDownCascadeRest);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/forms/clientlibs/shared/js/modules/Tc.Module.DropdownPopulation.js
var Tc_Module_DropdownPopulation = __webpack_require__(275);
var Tc_Module_DropdownPopulation_default = /*#__PURE__*/__webpack_require__.n(Tc_Module_DropdownPopulation);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/forms/clientlibs/shared/js/modules/Tc.Module.FileUpload.js
var Tc_Module_FileUpload = __webpack_require__(276);
var Tc_Module_FileUpload_default = /*#__PURE__*/__webpack_require__.n(Tc_Module_FileUpload);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/forms/clientlibs/shared/js/modules/Tc.Module.FormStepIndicator.js
var Tc_Module_FormStepIndicator = __webpack_require__(277);
var Tc_Module_FormStepIndicator_default = /*#__PURE__*/__webpack_require__.n(Tc_Module_FormStepIndicator);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/forms/clientlibs/shared/js/modules/Tc.Module.HiddenGetParameter.js
var Tc_Module_HiddenGetParameter = __webpack_require__(279);
var Tc_Module_HiddenGetParameter_default = /*#__PURE__*/__webpack_require__.n(Tc_Module_HiddenGetParameter);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/forms/clientlibs/shared/js/modules/Tc.Module.MultiField.js
var Tc_Module_MultiField = __webpack_require__(280);
var Tc_Module_MultiField_default = /*#__PURE__*/__webpack_require__.n(Tc_Module_MultiField);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/forms/clientlibs/shared/js/modules/Tc.Module.ScForm.js
var Tc_Module_ScForm = __webpack_require__(281);
var Tc_Module_ScForm_default = /*#__PURE__*/__webpack_require__.n(Tc_Module_ScForm);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/forms/clientlibs/shared/js/modules/Tc.Module.ScForm.MultipageWizard.js
var Tc_Module_ScForm_MultipageWizard = __webpack_require__(282);
var Tc_Module_ScForm_MultipageWizard_default = /*#__PURE__*/__webpack_require__.n(Tc_Module_ScForm_MultipageWizard);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/forms/clientlibs/shared/js/modules/Tc.Module.TextField.js
var Tc_Module_TextField = __webpack_require__(283);
var Tc_Module_TextField_default = /*#__PURE__*/__webpack_require__.n(Tc_Module_TextField);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/forms/clientlibs/shared/js/modules/Tc.Module.VisibilityControlContainer.js
var Tc_Module_VisibilityControlContainer = __webpack_require__(292);
var Tc_Module_VisibilityControlContainer_default = /*#__PURE__*/__webpack_require__.n(Tc_Module_VisibilityControlContainer);

// CONCATENATED MODULE: ./clientlibs/js/by-category/scs.form.desktop.ts
// base=/etc/designs/forms/clientlibs
// Vendor

// Libraries




// Should come before modules:
// BA debug is a wrapper for console (console.log, console.warn, console.dir, etc.)

// Modules



















// EXTERNAL MODULE: ./clientlibs/js/etc/designs/sitesearch/clientlibs/logic/processing/js/SearchProcessor.js
var SearchProcessor = __webpack_require__(293);
var SearchProcessor_default = /*#__PURE__*/__webpack_require__.n(SearchProcessor);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/sitesearch/clientlibs/logic/processing/js/util/backends.js
var backends = __webpack_require__(294);
var backends_default = /*#__PURE__*/__webpack_require__.n(backends);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/sitesearch/clientlibs/logic/processing/js/util/responders.js
var responders = __webpack_require__(295);
var responders_default = /*#__PURE__*/__webpack_require__.n(responders);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/sitesearch/clientlibs/logic/processing/js/util/shims.js
var shims = __webpack_require__(296);
var shims_default = /*#__PURE__*/__webpack_require__.n(shims);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/sitesearch/clientlibs/logic/processing/js/plugins/autosuggest.js
var autosuggest = __webpack_require__(297);
var autosuggest_default = /*#__PURE__*/__webpack_require__.n(autosuggest);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/sitesearch/clientlibs/logic/processing/js/plugins/filtering.js
var filtering = __webpack_require__(298);
var filtering_default = /*#__PURE__*/__webpack_require__.n(filtering);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/sitesearch/clientlibs/logic/processing/js/plugins/gsa-handling.js
var gsa_handling = __webpack_require__(299);
var gsa_handling_default = /*#__PURE__*/__webpack_require__.n(gsa_handling);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/sitesearch/clientlibs/logic/processing/js/plugins/keymatch-handling.js
var keymatch_handling = __webpack_require__(300);
var keymatch_handling_default = /*#__PURE__*/__webpack_require__.n(keymatch_handling);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/sitesearch/clientlibs/logic/processing/js/plugins/session-handling.js
var session_handling = __webpack_require__(301);
var session_handling_default = /*#__PURE__*/__webpack_require__.n(session_handling);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/sitesearch/clientlibs/logic/processing/js/plugins/spellchecking.js
var spellchecking = __webpack_require__(302);
var spellchecking_default = /*#__PURE__*/__webpack_require__.n(spellchecking);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/sitesearch/clientlibs/logic/processing/js/plugins/tracking.js
var plugins_tracking = __webpack_require__(303);
var plugins_tracking_default = /*#__PURE__*/__webpack_require__.n(plugins_tracking);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/sitesearch/clientlibs/logic/processing/js/plugins/url-handling.js
var url_handling = __webpack_require__(304);
var url_handling_default = /*#__PURE__*/__webpack_require__.n(url_handling);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/sitesearch/clientlibs/logic/processing/js/plugins/web.js
var web = __webpack_require__(305);
var web_default = /*#__PURE__*/__webpack_require__.n(web);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/sitesearch/clientlibs/logic/processing/js/trackers/gsa.js
var gsa = __webpack_require__(306);
var gsa_default = /*#__PURE__*/__webpack_require__.n(gsa);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/sitesearch/clientlibs/logic/processing/js/trackers/sc.js
var sc = __webpack_require__(307);
var sc_default = /*#__PURE__*/__webpack_require__.n(sc);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/sitesearch/clientlibs/logic/processing/js/orchestration.js
var orchestration = __webpack_require__(308);
var orchestration_default = /*#__PURE__*/__webpack_require__.n(orchestration);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/sitesearch/clientlibs/logic/gui/js/modules/Tc.Module.HeaderSearchQueryForm.js
var Tc_Module_HeaderSearchQueryForm = __webpack_require__(309);
var Tc_Module_HeaderSearchQueryForm_default = /*#__PURE__*/__webpack_require__.n(Tc_Module_HeaderSearchQueryForm);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/sitesearch/clientlibs/logic/gui/js/modules/Tc.Module.OftenSearchedLinkBox.js
var Tc_Module_OftenSearchedLinkBox = __webpack_require__(310);
var Tc_Module_OftenSearchedLinkBox_default = /*#__PURE__*/__webpack_require__.n(Tc_Module_OftenSearchedLinkBox);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/sitesearch/clientlibs/logic/gui/js/modules/Tc.Module.SearchClusterSuggestions.js
var Tc_Module_SearchClusterSuggestions = __webpack_require__(311);
var Tc_Module_SearchClusterSuggestions_default = /*#__PURE__*/__webpack_require__.n(Tc_Module_SearchClusterSuggestions);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/sitesearch/clientlibs/logic/gui/js/modules/Tc.Module.SearchPreviewLink.js
var Tc_Module_SearchPreviewLink = __webpack_require__(312);
var Tc_Module_SearchPreviewLink_default = /*#__PURE__*/__webpack_require__.n(Tc_Module_SearchPreviewLink);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/sitesearch/clientlibs/logic/gui/js/modules/Tc.Module.SearchPromoBox.js
var Tc_Module_SearchPromoBox = __webpack_require__(313);
var Tc_Module_SearchPromoBox_default = /*#__PURE__*/__webpack_require__.n(Tc_Module_SearchPromoBox);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/sitesearch/clientlibs/logic/gui/js/modules/Tc.Module.SearchPromoContainer.js
var Tc_Module_SearchPromoContainer = __webpack_require__(314);
var Tc_Module_SearchPromoContainer_default = /*#__PURE__*/__webpack_require__.n(Tc_Module_SearchPromoContainer);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/sitesearch/clientlibs/logic/gui/js/modules/Tc.Module.SearchResultContainer.js
var Tc_Module_SearchResultContainer = __webpack_require__(315);
var Tc_Module_SearchResultContainer_default = /*#__PURE__*/__webpack_require__.n(Tc_Module_SearchResultContainer);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/sitesearch/clientlibs/logic/gui/js/modules/Tc.Module.SearchResultDisplay.js
var Tc_Module_SearchResultDisplay = __webpack_require__(316);
var Tc_Module_SearchResultDisplay_default = /*#__PURE__*/__webpack_require__.n(Tc_Module_SearchResultDisplay);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/sitesearch/clientlibs/logic/gui/js/modules/Tc.Module.SearchResultDisplay.Web.js
var Tc_Module_SearchResultDisplay_Web = __webpack_require__(317);
var Tc_Module_SearchResultDisplay_Web_default = /*#__PURE__*/__webpack_require__.n(Tc_Module_SearchResultDisplay_Web);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/sitesearch/clientlibs/logic/gui/js/modules/Tc.Module.SearchResultFilter.js
var Tc_Module_SearchResultFilter = __webpack_require__(318);
var Tc_Module_SearchResultFilter_default = /*#__PURE__*/__webpack_require__.n(Tc_Module_SearchResultFilter);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/sitesearch/clientlibs/logic/gui/js/modules/Tc.Module.SearchResultQueryBox.js
var Tc_Module_SearchResultQueryBox = __webpack_require__(319);
var Tc_Module_SearchResultQueryBox_default = /*#__PURE__*/__webpack_require__.n(Tc_Module_SearchResultQueryBox);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/sitesearch/clientlibs/logic/gui/js/modules/Tc.Module.SearchResultTitle.js
var Tc_Module_SearchResultTitle = __webpack_require__(320);
var Tc_Module_SearchResultTitle_default = /*#__PURE__*/__webpack_require__.n(Tc_Module_SearchResultTitle);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/sitesearch/clientlibs/logic/gui/js/modules/Tc.Module.SearchTopResults.js
var Tc_Module_SearchTopResults = __webpack_require__(321);
var Tc_Module_SearchTopResults_default = /*#__PURE__*/__webpack_require__.n(Tc_Module_SearchTopResults);

// CONCATENATED MODULE: ./clientlibs/js/by-category/scs.sitesearch.ts
// #base=etc/designs/sitesearch/clientlibs/logic/processing/js
















// #base=etc/designs/sitesearch/clientlibs/logic/gui/js/modules














// EXTERNAL MODULE: ./clientlibs/js/bootstrap/load-moment.ts
var load_moment = __webpack_require__(46);

// EXTERNAL MODULE: ./node_modules/@swisscom/bxslider/dist/jquery.bxslider.js
var jquery_bxslider = __webpack_require__(322);
var jquery_bxslider_default = /*#__PURE__*/__webpack_require__.n(jquery_bxslider);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/base/clientlibs/shared/vendor/yepnope.1.5.4-min.js
var yepnope_1_5_4_min = __webpack_require__(323);
var yepnope_1_5_4_min_default = /*#__PURE__*/__webpack_require__.n(yepnope_1_5_4_min);

// EXTERNAL MODULE: ./clientlibs/js/bootstrap/load-snabbdom.ts + 6 modules
var load_snabbdom = __webpack_require__(9);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/base/clientlibs/shared/libraries/scCookie.js
var scCookie = __webpack_require__(324);
var scCookie_default = /*#__PURE__*/__webpack_require__.n(scCookie);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/base/clientlibs/shared/libraries/SCS.hashdeeplink.js
var SCS_hashdeeplink = __webpack_require__(325);
var SCS_hashdeeplink_default = /*#__PURE__*/__webpack_require__.n(SCS_hashdeeplink);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/base/clientlibs/shared/js/modules/Tc.Module.BrightcoveVideo.js
var Tc_Module_BrightcoveVideo = __webpack_require__(326);
var Tc_Module_BrightcoveVideo_default = /*#__PURE__*/__webpack_require__.n(Tc_Module_BrightcoveVideo);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/base/clientlibs/shared/js/modules/Tc.Module.GoogleMaps.js
var Tc_Module_GoogleMaps = __webpack_require__(327);
var Tc_Module_GoogleMaps_default = /*#__PURE__*/__webpack_require__.n(Tc_Module_GoogleMaps);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/base/clientlibs/shared/js/modules/Tc.Module.Slider.js
var Tc_Module_Slider = __webpack_require__(328);
var Tc_Module_Slider_default = /*#__PURE__*/__webpack_require__.n(Tc_Module_Slider);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/base/clientlibs/shared/js/modules/Tc.Module.Slider.RotatingTeaser.js
var Tc_Module_Slider_RotatingTeaser = __webpack_require__(329);
var Tc_Module_Slider_RotatingTeaser_default = /*#__PURE__*/__webpack_require__.n(Tc_Module_Slider_RotatingTeaser);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/base/clientlibs/shared/js/modules/Tc.Module.Twitter.js
var Tc_Module_Twitter = __webpack_require__(330);
var Tc_Module_Twitter_default = /*#__PURE__*/__webpack_require__.n(Tc_Module_Twitter);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/base/clientlibs/shared/js/modules/Tc.Module.LinkForwarder.js
var Tc_Module_LinkForwarder = __webpack_require__(331);
var Tc_Module_LinkForwarder_default = /*#__PURE__*/__webpack_require__.n(Tc_Module_LinkForwarder);

// EXTERNAL MODULE: ./clientlibs/js/lib/generic/seo-utils.tsx
var seo_utils = __webpack_require__(332);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/base/clientlibs/shared/libraries/tracking/SCS.portal.datalayer.js
var SCS_portal_datalayer = __webpack_require__(333);
var SCS_portal_datalayer_default = /*#__PURE__*/__webpack_require__.n(SCS_portal_datalayer);

// CONCATENATED MODULE: ./clientlibs/js/lib/containers/Tc.Module.IFrame.ts




var MESSAGE_HANDLERS = {
    /**
     * Open dialog
     * @param _mod
     * @param dialogOptions
     */
    dialog: function (_mod, dialogOptions) {
        dialogOptions.classes = external___window__g_____g_$_____window_$CQ____window_$____window_jQuery__default.a.extend({}, { 'ui-dialog': dialogOptions.dialogClass || 'wide' }, dialogOptions.classes || {});
        dialogOptions.width = dialogOptions.width || (800 - 30);
        var content = dialogOptions.html;
        delete dialogOptions.html;
        delete dialogOptions.dialogClass;
        external___window__g_____g_$_____window_$CQ____window_$____window_jQuery__default()('<div/>').html(content).dialog(dialogOptions);
    },
    /**
     * Scroll to top
     *
     * @param mod
     * @param top
     */
    top: function (mod, top) {
        if (top.startsWith('iframe')) {
            top = parseInt(top.split('|')[1], 10) || 0;
            top += mod.$iframe.offset().top;
        }
        else {
            top = parseInt(top, 10) || 0;
        }
        window.scrollTo(0, top);
    },
    /**
     * Resize iframe height
     * (only in non-adaptive mode)
     *
     * @param mod
     * @param height
     */
    height: function (mod, height) {
        if (mod.adaptive) {
            return;
        }
        mod.$iframe.attr('height', parseInt(height, 10));
    },
    /**
     * Used for iframes that do not use tracking code but need to track things, so they can post a message
     *
     * @param mod
     * @param trackingData
     */
    trackTealium: function (mod, trackingData) {
        mod.log('trackTealium called with trackingData', trackingData);
        new SCS.portal.datalayer.Interaction()
            .withEvent(trackingData.action, trackingData.label, trackingData.location, trackingData.category, trackingData.friendlyName)
            .withConversion(trackingData.conversionCategory, trackingData.conversionDetail, trackingData.conversionClass)
            .track();
    },
};
// Alias scrollTop to top for www.digitalassessment.ch iframes
MESSAGE_HANDLERS.scrollTop = MESSAGE_HANDLERS.top;
function isVideo(url) {
    return url.indexOf('youtube.com') > -1;
}
// List of allowed domains. Matched against scheme, host and port.
// Be careful when using regular expressions here to not match too little (always anchor at the end!)
var ALLOWED_MESSAGE_SOURCES = [
    /[./](swisscom|bwns)\.ch?$/,
    /\/{2}(www\.)?bluewin\.ch?$/,
    /\/{2}(www\.)?swisscom-learningcenter\.ch$/,
    'https://www.digitalassessment.ch',
    // The current host is always allowed.
    window.location.protocol + "//" + window.location.host,
];
function originAllowed(origin, additionalAllowedSources) {
    if (!origin) {
        return false;
    }
    var checks = ALLOWED_MESSAGE_SOURCES;
    if (additionalAllowedSources) {
        checks = checks.concat(additionalAllowedSources);
    }
    for (var _i = 0, checks_1 = checks; _i < checks_1.length; _i++) {
        var check = checks_1[_i];
        if (check instanceof RegExp) {
            if (check.test(origin)) {
                return true;
            }
        }
        else if (check === origin) {
            return true;
        }
    }
    return false;
}
var Tc_Module_IFrame_IFrame = /** @class */ (function (_super) {
    Object(tslib_es6["c" /* __extends */])(IFrame, _super);
    function IFrame() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Hook function to do all of your module stuff.
     *
     * @method on
     * @param  {Hook} callback Callback function
     * @return void
     */
    IFrame.prototype.on = function (callback) {
        this.readProperties();
        this.$iframe = this.$ctx.find('iframe');
        if (!this.$iframe.length) {
            // Initialize the iframe only if none exists already
            this.initializeIframe();
            this.$iframe = this.$ctx.find('iframe');
        }
        this.addMessageListeners();
        callback();
    };
    /**
     * Initializing properties read from data properties
     * on this context's div tag.
     */
    IFrame.prototype.readProperties = function () {
        this.url = this.$ctx.data('src');
        this.width = this.$ctx.data('width');
        this.height = this.$ctx.data('height');
        this.disallowMessages = this.$ctx.data('disallow-messages');
        this.considerHashParameters = this.$ctx.data('considerhashparameters');
        this.scrollbar = this.$ctx.data('scrollbar');
        this.adaptive = this.$ctx.data('adaptive');
        if (Object(helpers["isMobilePage"])() && isVideo(this.url)) {
            this.adaptive = true;
        }
        var allowedMessageSources = (this.$ctx.attr('data-allowed-message-sources') || '').trim().split(/\s*,\s*/);
        if (allowedMessageSources.length === 1 && !allowedMessageSources[0]) {
            allowedMessageSources = [];
        }
        this.allowedMessageSources = allowedMessageSources;
        this.aspectRatio = parseFloat(this.$ctx.attr('data-aspect-ratio') || '');
        if (isNaN(this.aspectRatio)) {
            this.aspectRatio = 16 / 9;
        }
        this.allowfullscreen = this.$ctx.data('allowfullscreen');
    };
    /**
     * Display Loading Rotator until document ready, then insert iframe
     *
     * @method initializeIframe
     * @return void
     */
    IFrame.prototype.initializeIframe = function () {
        if (this.considerHashParameters) {
            var locationHash = window.location.hash.substr(1);
            var locationParams = new URLSearchParams(locationHash);
            var url_1 = new URL(this.url, window.location.href);
            locationParams.forEach(function (value, key) {
                url_1.searchParams.append(key, value);
            });
            this.url = url_1.href;
        }
        var iframe = external___window__g_____g_$_____window_$CQ____window_$____window_jQuery__default()('<iframe/>').attr({
            frameborder: 0,
            height: this.height,
            scrolling: this.scrollbar,
            src: this.url,
            width: this.width,
        });
        if (this.allowfullscreen) {
            iframe.attr({
                allowfullscreen: '',
            });
        }
        try {
            this.$ctx.empty().append(iframe);
        }
        catch (e) {
            // IE throws an error because of iFrame security but it works anyway
        }
        if (this.adaptive) {
            iframe.wrap(external___window__g_____g_$_____window_$CQ____window_$____window_jQuery__default()('<div/>').addClass('fixedAspectRatio').css({ paddingBottom: (100 / this.aspectRatio) + "%" }));
        }
    };
    /**
     * Attaching event listener to the window, so the
     * iframe containing content can send messages to this module
     */
    IFrame.prototype.addMessageListeners = function () {
        if (this.disallowMessages) {
            return;
        }
        window.addEventListener('message', this.listenMessage.bind(this));
    };
    /**
     * Handle messages sent from iFrame using postMessage
     */
    IFrame.prototype.listenMessage = function (msg) {
        if (this.disallowMessages) {
            return;
        }
        // Ignore non-JSON messages
        if (!msg || !msg.data || !msg.data.match || !msg.data.match(/^\{/)) {
            return;
        }
        // Ignore messages from other iframes
        if (!msg.source || this.$iframe[0].contentWindow !== msg.source) {
            return;
        }
        // Check the origin
        if (!originAllowed(msg.origin, this.allowedMessageSources)) {
            this.log.error('Got message from unknown origin', msg.origin, msg);
            return;
        }
        var msgData = JSON.parse(msg.data);
        for (var type in MESSAGE_HANDLERS) {
            if (type in msgData) {
                this.log("Got " + type + " message", msgData[type]);
                MESSAGE_HANDLERS[type](this, msgData[type], msg, msgData);
            }
        }
    };
    return IFrame;
}(Module["a" /* Module */]));
/* harmony default export */ var Tc_Module_IFrame = (Tc_Module_IFrame_IFrame);

// CONCATENATED MODULE: ./clientlibs/js/by-category/scs.base.desktop.ts
// base=/etc/designs/base/clientlibs
// # scs.base.desktop
// # ========================
// # Be careful when adding files here.
// # These files are included in the desktop clientlibs on portal, and possibly others.
// # TODO: Remove this from base, because it is already included in portal/clientlibs/libs
// (and fix dependencies to this client lib)
















// Tealium library

// Modern modules (using imports/exports)

var scs_base_desktop_modernTcModules = {
    IFrame: Tc_Module_IFrame,
};
// Tc Bootstrap

Object(load_terrific["legacyBootstrapDeferredSingleton"])(scs_base_desktop_modernTcModules);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/help/clientlibs/desktop/js/faq.js
var faq = __webpack_require__(335);
var faq_default = /*#__PURE__*/__webpack_require__.n(faq);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/help/clientlibs/desktop/js/popuplink.js
var popuplink = __webpack_require__(336);
var popuplink_default = /*#__PURE__*/__webpack_require__.n(popuplink);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/help/clientlibs/desktop/js/searchform.js
var searchform = __webpack_require__(337);
var searchform_default = /*#__PURE__*/__webpack_require__.n(searchform);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/help/clientlibs/desktop/js/downloadsearchform.js
var downloadsearchform = __webpack_require__(338);
var downloadsearchform_default = /*#__PURE__*/__webpack_require__.n(downloadsearchform);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/help/clientlibs/desktop/js/clientsidepagination.js
var clientsidepagination = __webpack_require__(339);
var clientsidepagination_default = /*#__PURE__*/__webpack_require__.n(clientsidepagination);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/help/clientlibs/desktop/js/downloadsearchresults.js
var downloadsearchresults = __webpack_require__(340);
var downloadsearchresults_default = /*#__PURE__*/__webpack_require__.n(downloadsearchresults);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/help/clientlibs/desktop/js/downloadbutton.js
var downloadbutton = __webpack_require__(341);
var downloadbutton_default = /*#__PURE__*/__webpack_require__.n(downloadbutton);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/help/clientlibs/desktop/js/searchsuggestion.js
var searchsuggestion = __webpack_require__(342);
var searchsuggestion_default = /*#__PURE__*/__webpack_require__.n(searchsuggestion);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/help/clientlibs/desktop/js/imageload.js
var imageload = __webpack_require__(343);
var imageload_default = /*#__PURE__*/__webpack_require__.n(imageload);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/help/clientlibs/desktop/js/ajaxcalls.js
var ajaxcalls = __webpack_require__(344);
var ajaxcalls_default = /*#__PURE__*/__webpack_require__.n(ajaxcalls);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/help/clientlibs/desktop/js/devicelist.js
var devicelist = __webpack_require__(345);
var devicelist_default = /*#__PURE__*/__webpack_require__.n(devicelist);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/help/clientlibs/shared/js/headerurls.js
var headerurls = __webpack_require__(346);
var headerurls_default = /*#__PURE__*/__webpack_require__.n(headerurls);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/help/clientlibs/desktop/js/quicklinkteaser.js
var quicklinkteaser = __webpack_require__(347);
var quicklinkteaser_default = /*#__PURE__*/__webpack_require__.n(quicklinkteaser);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/help/clientlibs/desktop/js/supportstrip.js
var js_supportstrip = __webpack_require__(348);
var js_supportstrip_default = /*#__PURE__*/__webpack_require__.n(js_supportstrip);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/help/clientlibs/desktop/js/sitecatalyst.js
var js_sitecatalyst = __webpack_require__(349);
var js_sitecatalyst_default = /*#__PURE__*/__webpack_require__.n(js_sitecatalyst);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/help/clientlibs/desktop/js/backButton.js
var backButton = __webpack_require__(350);
var backButton_default = /*#__PURE__*/__webpack_require__.n(backButton);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/help/clientlibs/shared/js/modules/Tc.Module.ContactWizard.js
var Tc_Module_ContactWizard = __webpack_require__(351);
var Tc_Module_ContactWizard_default = /*#__PURE__*/__webpack_require__.n(Tc_Module_ContactWizard);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/help/clientlibs/desktop/js/modules/Tc.Module.HelpSearchResults.js
var Tc_Module_HelpSearchResults = __webpack_require__(352);
var Tc_Module_HelpSearchResults_default = /*#__PURE__*/__webpack_require__.n(Tc_Module_HelpSearchResults);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/help/clientlibs/shared/js/modules/Tc.Module.InteractiveVideo.js
var Tc_Module_InteractiveVideo = __webpack_require__(353);
var Tc_Module_InteractiveVideo_default = /*#__PURE__*/__webpack_require__.n(Tc_Module_InteractiveVideo);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/help/clientlibs/desktop/js/modules/Tc.Module.LastVisitedHelpPages.js
var Tc_Module_LastVisitedHelpPages = __webpack_require__(354);
var Tc_Module_LastVisitedHelpPages_default = /*#__PURE__*/__webpack_require__.n(Tc_Module_LastVisitedHelpPages);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/help/clientlibs/desktop/js/modules/Tc.Module.RecommendationsTeaser.js
var Tc_Module_RecommendationsTeaser = __webpack_require__(355);
var Tc_Module_RecommendationsTeaser_default = /*#__PURE__*/__webpack_require__.n(Tc_Module_RecommendationsTeaser);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/help/clientlibs/shared/js/modules/Tc.Module.SupportCommunityBox.js
var Tc_Module_SupportCommunityBox = __webpack_require__(356);
var Tc_Module_SupportCommunityBox_default = /*#__PURE__*/__webpack_require__.n(Tc_Module_SupportCommunityBox);

// CONCATENATED MODULE: ./clientlibs/js/by-category/scs.help.desktop.ts
// base=/etc/designs/help/clientlibs/desktop/js
// ********************************************************************************
// HELP CODE
// ********************************************************************************
















// ********************************************************************************
// TERRIFIC MODULES (A-Z please)
// ********************************************************************************







// EXTERNAL MODULE: ./clientlibs/js/etc/designs/ecommerce/clientlibs/shared/js/userbox.js
var userbox = __webpack_require__(357);
var userbox_default = /*#__PURE__*/__webpack_require__.n(userbox);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/ecommerce/clientlibs/shared/js/res-sme-cbu-popup.js
var res_sme_cbu_popup = __webpack_require__(358);
var res_sme_cbu_popup_default = /*#__PURE__*/__webpack_require__.n(res_sme_cbu_popup);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/header/clientlibs/responsive/js/modules/Tc.Module.Basket.js
var Tc_Module_Basket = __webpack_require__(359);
var Tc_Module_Basket_default = /*#__PURE__*/__webpack_require__.n(Tc_Module_Basket);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/header/clientlibs/responsive/js/modules/Tc.Module.Flyout.js
var Tc_Module_Flyout = __webpack_require__(360);
var Tc_Module_Flyout_default = /*#__PURE__*/__webpack_require__.n(Tc_Module_Flyout);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/header/clientlibs/responsive/js/modules/Tc.Module.Footer.js
var Tc_Module_Footer = __webpack_require__(361);
var Tc_Module_Footer_default = /*#__PURE__*/__webpack_require__.n(Tc_Module_Footer);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/header/clientlibs/responsive/js/modules/Tc.Module.Header.js
var Tc_Module_Header = __webpack_require__(362);
var Tc_Module_Header_default = /*#__PURE__*/__webpack_require__.n(Tc_Module_Header);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/header/clientlibs/responsive/js/modules/Tc.Module.ProductComparator.js
var Tc_Module_ProductComparator = __webpack_require__(363);
var Tc_Module_ProductComparator_default = /*#__PURE__*/__webpack_require__.n(Tc_Module_ProductComparator);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/header/clientlibs/responsive/js/modules/Tc.Module.SiteSearch.js
var Tc_Module_SiteSearch = __webpack_require__(364);
var Tc_Module_SiteSearch_default = /*#__PURE__*/__webpack_require__.n(Tc_Module_SiteSearch);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/header/clientlibs/responsive/js/modules/Tc.Module.SiteSearch.MobileMenu.js
var Tc_Module_SiteSearch_MobileMenu = __webpack_require__(365);
var Tc_Module_SiteSearch_MobileMenu_default = /*#__PURE__*/__webpack_require__.n(Tc_Module_SiteSearch_MobileMenu);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/header/clientlibs/responsive/js/modules/Tc.Module.Metanav.js
var Tc_Module_Metanav = __webpack_require__(366);
var Tc_Module_Metanav_default = /*#__PURE__*/__webpack_require__.n(Tc_Module_Metanav);

// CONCATENATED MODULE: ./clientlibs/js/lib/search/Tc.Module.FusionSearch.ts


var Tc_Module_FusionSearch_FusionSearch = /** @class */ (function (_super) {
    Object(tslib_es6["c" /* __extends */])(FusionSearch, _super);
    function FusionSearch() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Hook function to do all of your module stuff.
     *
     * @method on
     * @param  {Hook} callback Callback function
     * @return void
     */
    FusionSearch.prototype.on = function (callback) {
        var $ctx = this.$ctx;
        // Fetch jQuery objects once to re-use in submit action
        var $container = $ctx.find('.scsh-fusionsearch-container');
        var $form = $container.find('FORM.scsh-fusionsearch-form');
        var $field = $container.find('INPUT.scsh-fusionsearch-field');
        // Store for re-use in submit action
        var action = $form.attr('action');
        // Handle form submit event
        $form.on('submit', function (event) {
            // Abort if no action is defined
            if (action === undefined) {
                return;
            }
            // Abort if the event is already canceled
            if (event.isDefaultPrevented()) {
                return;
            }
            // Parse the action url (preserve all information)
            var url = new URL(action, document.location.href);
            var pair = url.hash.replace(/^#+/, '').split('?', 2);
            // Decode parameters and update our property
            var params = new URLSearchParams(pair[1]);
            params.set('query', String($field.val()));
            // Update the final action url
            pair[1] = String(params);
            url.hash = '#' + pair.join('?');
            $form.attr('action', url.href);
        });
        // EO on submit
        callback();
    };
    return FusionSearch;
}(Module["a" /* Module */]));
/* harmony default export */ var Tc_Module_FusionSearch = (Tc_Module_FusionSearch_FusionSearch);
// EO class FusionSearch

// EXTERNAL MODULE: ./clientlibs/js/lib/util/createAnimation.ts
var createAnimation = __webpack_require__(24);

// CONCATENATED MODULE: ./clientlibs/js/lib/generic/header/Tc.Module.ImageAnimation.ts




// How much below an integer value the device pixel ratio can fall when still the larger image is loaded.
var RETINA_THRESHOLD = 0.8;
/**
 * ImageAnimation module.
 * Used for animating the Swisscom logo.
 */
var Tc_Module_ImageAnimation_ImageAnimation = /** @class */ (function (_super) {
    Object(tslib_es6["c" /* __extends */])(ImageAnimation, _super);
    function ImageAnimation() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // How many frames the sprite contains
        _this.frames = 100;
        // How long the complete animation should last (in ms)
        _this.duration = 3000;
        // How often to repeat the animation
        _this.repeat = Infinity;
        // When to start loading the sprite. Valid values are 'ready' (on DOMContentReady) or 'load' (on window.load)
        _this.loadPoint = 'load';
        // The document which this animation belongs to
        _this.document = document;
        return _this;
    }
    // Do nothing on “on” so initialization is quick
    ImageAnimation.prototype.on = function (callback) {
        this.document = this.$ctx[0].ownerDocument || document;
        callback();
    };
    // Read options and start loading the sprite image on “after”
    ImageAnimation.prototype.after = function () {
        this.$image = this.$ctx.children('img');
        this.frames = Number(this.$ctx.data('frames')) || this.frames;
        this.duration = Number(this.$ctx.data('duration')) || this.duration;
        this.repeat = Number(this.$ctx.data('repeat')) || this.repeat;
        this.loadPoint = this.$ctx.data('loadPoint') || this.loadPoint;
        this.sprites = {};
        var sprite1x = this.$ctx.data('sprite') || this.$image.prop('src').replace(/\.([^\/]+)$/, '-sprites.$1');
        this.sprites[1] = sprite1x;
        var size = 2;
        while (this.$ctx.data("sprite-" + size + "x")) {
            this.sprites[size] = this.$ctx.data("sprite-" + size + "x");
            size += 1;
        }
        this.easing = this.$ctx.data('easing');
        this.log('Initialized', this);
        this.setUpSpriteLoader();
    };
    ImageAnimation.prototype.setUpSpriteLoader = function () {
        this.log('Attaching sprite loader for ', this.loadPoint);
        if (this.loadPoint === 'load') {
            if (this.document.readyState === 'complete') {
                this.loadSprite();
            }
            else {
                external___window__g_____g_$_____window_$CQ____window_$____window_jQuery_(window).on('load', this.loadSprite.bind(this));
            }
        }
        else {
            if (this.document.readyState === 'complete' || this.document.readyState === 'interactive') {
                this.loadSprite();
            }
            else {
                external___window__g_____g_$_____window_$CQ____window_$____window_jQuery_(this.document).on('ready', this.loadSprite.bind(this));
            }
        }
    };
    ImageAnimation.prototype.spriteSrc = function () {
        var ratio = Math.max(window.devicePixelRatio
            || window.webkitDevicePixelRatio
            || window.mozDevicePixelRatio
            || window.msDevicePixelRatio
            || 1, 1);
        var intRatio = Math.floor(ratio + RETINA_THRESHOLD);
        while (!(intRatio in this.sprites)) {
            intRatio -= 1;
        }
        this.log('Using sprite', this.sprites[intRatio], 'with ratio', intRatio, 'for ratio', ratio, 'from', this.sprites);
        return this.sprites[intRatio];
    };
    ImageAnimation.prototype.loadSprite = function () {
        var src = this.spriteSrc();
        this.log('Loading sprite', src);
        var spriteImage = this.document.createElement('img');
        spriteImage.referrer = 'no-referrer';
        this.$spriteImage = external___window__g_____g_$_____window_$CQ____window_$____window_jQuery_(spriteImage);
        this.$spriteImage.addClass('animated-image');
        this.$spriteImage.addClass(this.$image[0].className);
        this.$spriteImage.removeClass('still-image');
        this.$spriteImage.on('load', this.spriteLoaded.bind(this));
        spriteImage.src = src;
    };
    ImageAnimation.prototype.ensureStillImageLoaded = function (callback) {
        if (this.$image.prop('complete')) {
            callback();
        }
        else {
            this.$image.on('load', callback);
        }
    };
    ImageAnimation.prototype.spriteLoaded = function () {
        this.log('Loaded sprite');
        this.ensureStillImageLoaded(this.animationReady.bind(this));
    };
    ImageAnimation.prototype.animationReady = function () {
        this.log('Begin animating');
        this.animationHandle = Object(createAnimation["createAnimation"])({
            animator: this.animator.bind(this),
            callback: this.animationEnded.bind(this),
            duration: this.duration,
            easing: this.easing,
            endValue: this.frames - 1,
            startValue: 0,
        });
        this.repeatAnimation();
    };
    ImageAnimation.prototype.animator = function (_progress, sprite) {
        // Make sure the index is an integer
        sprite = Math.floor(sprite);
        var offset = sprite * (Number(this.$ctx.data('width')) || this.$image.prop('width'));
        this.$spriteImage.css('marginLeft', "-" + offset + "px");
    };
    ImageAnimation.prototype.repeatAnimation = function () {
        if (!this.animationHandle) {
            return;
        }
        if (this.repeat > 0) {
            this.startAnimation();
            this.repeat -= 1;
        }
    };
    ImageAnimation.prototype.startAnimation = function () {
        if (!this.animationHandle) {
            return;
        }
        this.animationHandle.start();
        this.$ctx[0].replaceChild(this.$spriteImage[0], this.$image[0]);
        this.$ctx.addClass('animating');
    };
    ImageAnimation.prototype.animationEnded = function (successfully) {
        this.$ctx[0].replaceChild(this.$image[0], this.$spriteImage[0]);
        this.$ctx.removeClass('animating');
        if (successfully) {
            this.repeatAnimation();
        }
    };
    return ImageAnimation;
}(Module["a" /* Module */]));
/* harmony default export */ var Tc_Module_ImageAnimation = (Tc_Module_ImageAnimation_ImageAnimation);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/header/clientlibs/responsive/js/sitecatalyst.js
var responsive_js_sitecatalyst = __webpack_require__(367);
var responsive_js_sitecatalyst_default = /*#__PURE__*/__webpack_require__.n(responsive_js_sitecatalyst);

// CONCATENATED MODULE: ./clientlibs/js/by-category/scs.header.responsive.ts
// base=/etc/designs/header/clientlibs/responsive/js
/*
 * Responsive Header
 *  - everything in this clientlib is needed only for the Responsive Header
 *
 * Header Modules used by header/footer:
 *  modBasket
 *  modFlatButton
 *  modFlyout
 *  modHeader
 *  modFooter
 *  modImageAnimation
 *  modMetanav
 *  modSiteSearch
 *  modSiteSearch.skinSiteSearchMobileMenu
 *  modProductComparator
 */


// -----------------------------------------------------------------------------
// TERRIFIC MODULES
// -----------------------------------------------------------------------------








// Modern modules (using imports/exports)


var scs_header_responsive_modernTcModules = {
    FusionSearch: Tc_Module_FusionSearch,
    ImageAnimation: Tc_Module_ImageAnimation,
};
// Tc Bootstrap

Object(load_terrific["legacyBootstrapDeferredSingleton"])(scs_header_responsive_modernTcModules);
// -----------------------------------------------------------------------------
// SWISSCOM CODE
// -----------------------------------------------------------------------------


// EXTERNAL MODULE: ./clientlibs/js/etc/designs/portal/clientlibs/foundation/testandtarget/util/source/init.js
var init = __webpack_require__(368);
var init_default = /*#__PURE__*/__webpack_require__.n(init);

// CONCATENATED MODULE: ./clientlibs/js/by-category/scs.testandtarget.util.ts
// #base=source


// EXTERNAL MODULE: ./clientlibs/js/etc/designs/portal/clientlibs/sdx_expand/js/modules/Tc.Module.SDXAccordion.js
var Tc_Module_SDXAccordion = __webpack_require__(369);
var Tc_Module_SDXAccordion_default = /*#__PURE__*/__webpack_require__.n(Tc_Module_SDXAccordion);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/portal/clientlibs/sdx_expand/js/modules/Tc.Module.SDXTabs.js
var Tc_Module_SDXTabs = __webpack_require__(370);
var Tc_Module_SDXTabs_default = /*#__PURE__*/__webpack_require__.n(Tc_Module_SDXTabs);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/portal/clientlibs/sdx_expand/js/modules/Tc.Module.SDXTabs.Image.js
var Tc_Module_SDXTabs_Image = __webpack_require__(371);
var Tc_Module_SDXTabs_Image_default = /*#__PURE__*/__webpack_require__.n(Tc_Module_SDXTabs_Image);

// EXTERNAL MODULE: ./node_modules/@swisscom/sdx/dist/es6/accordion/Accordion.js
var Accordion = __webpack_require__(27);

// EXTERNAL MODULE: ./node_modules/@swisscom/sdx/dist/es6/form/InputField.js
var InputField = __webpack_require__(50);

// EXTERNAL MODULE: ./node_modules/@swisscom/sdx/dist/es6/form/Select.js
var Select = __webpack_require__(18);

// EXTERNAL MODULE: ./node_modules/@swisscom/sdx/dist/es6/Utils.js
var Utils = __webpack_require__(11);

// EXTERNAL MODULE: ./node_modules/@swisscom/sdx/dist/es6/DomElement.js
var DomElement = __webpack_require__(12);

// EXTERNAL MODULE: ./node_modules/@swisscom/sdx/dist/es6/DomFunctions.js
var DomFunctions = __webpack_require__(15);

// CONCATENATED MODULE: ./node_modules/@swisscom/sdx/dist/es6/table/Table.js




var CLASS_SORTED_ASCENDING = "js-ascending";
var CLASS_SORTED_DESCENDING = "js-descending";
var CLASS_ARROW = "arrow-icon";
/**
 * The Table component. Adds additional capabilities to standard HTML 5 tables.
 */
var Table_Table = /** @class */ (function (_super) {
    Object(tslib_es6["c" /* __extends */])(Table, _super);
    /**
     * Creates a new instance of the table component.
     */
    function Table(element) {
        var _this = _super.call(this, element) || this;
        _this._headerClickHandler = _this._handleHeaderClick.bind(_this);
        _this._body = _this.element.querySelector("tbody");
        _this._header = _this.element.querySelector("thead");
        _this._rows = _this._body.children; // expect only <tr> elements
        _this._initialize();
        return _this;
    }
    Table.prototype._initialize = function () {
        var _this = this;
        var _a;
        (_a = this._header) === null || _a === void 0 ? void 0 : _a.querySelectorAll("th").forEach(function (header) {
            if (header.getAttribute("data-type")) {
                header.addEventListener("click", _this._headerClickHandler);
                var arrowElement = new DomElement["a" /* default */]("div").addClass(CLASS_ARROW).element;
                header.appendChild(arrowElement);
            }
        });
    };
    Table.prototype._handleHeaderClick = function (e) {
        var th = e.target;
        this.sort(th);
    };
    /**
     * Sorts the table according to the specified table header element.
     * The column is sorted ascending by default if no direction is specified and no
     * existing sort order class is found in the markup.
     *
     * If the displayed data is not suitable for sorting `<td/>` elements can define a `data-value` attribute
     * which is then used for the data-source.
     *
     * @param {TableHeader} tableHeader The header element of the row to sort by.
     * @param {Number} direction The direction to sort, `1` for ascending, `-1` for descending order. This parameter is optional.
     * @param {function} equalityComparer The equiality comparer function to compare individual cell values.
     */
    Table.prototype.sort = function (tableHeader, direction, equalityComparer) {
        var e_1, _a;
        if (!tableHeader || tableHeader.tagName !== "TH") {
            throw new Error("The parameter 'tableHeader' must be a valid column header node");
        }
        if (direction !== 1 && direction !== -1 && direction) {
            throw new Error("Parameter out of range, parameter 'direction' with value '".concat(direction, "' must be either -1, 1 or undefined"));
        }
        var columnIndex = tableHeader.cellIndex;
        if (!equalityComparer) {
            var dataType = tableHeader.getAttribute("data-type");
            equalityComparer = this._getComparer(dataType);
        }
        if (columnIndex >= this.element.querySelectorAll("th").length) {
            throw new Error("Column out of range");
        }
        try {
            for (var _b = Object(tslib_es6["f" /* __values */])(this.element.querySelectorAll("th")), _c = _b.next(); !_c.done; _c = _b.next()) {
                var header = _c.value;
                if (header !== tableHeader) {
                    DomFunctions["h" /* removeClass */](header, CLASS_SORTED_ASCENDING);
                    DomFunctions["h" /* removeClass */](header, CLASS_SORTED_DESCENDING);
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        if (DomFunctions["e" /* hasClass */](tableHeader, CLASS_SORTED_ASCENDING)) {
            DomFunctions["h" /* removeClass */](tableHeader, CLASS_SORTED_ASCENDING);
            DomFunctions["a" /* addClass */](tableHeader, CLASS_SORTED_DESCENDING);
            direction = direction || -1;
        }
        else {
            DomFunctions["h" /* removeClass */](tableHeader, CLASS_SORTED_DESCENDING);
            DomFunctions["a" /* addClass */](tableHeader, CLASS_SORTED_ASCENDING);
            direction = direction || 1;
        }
        this._quicksort(columnIndex, 0, this._rows.length - 1, direction, equalityComparer);
    };
    Table.prototype._getCell = function (column, row) {
        var rowEl = this._rows[row];
        return rowEl.cells[column];
    };
    Table.prototype._getRow = function (row) {
        return this._rows[row];
    };
    Table.prototype._getComparer = function (dataType) {
        switch (dataType) {
            case "number": {
                // parse the string as a number
                return function (a, b) {
                    var A = parseFloat(a);
                    var B = parseFloat(b);
                    // move invalid/empty items to the end
                    return ((isNaN(A) ? Number.MAX_VALUE : A) -
                        (isNaN(B) ? Number.MAX_VALUE : B));
                };
            }
            default: {
                // compare strings
                return function (a, b) {
                    if (a < b) {
                        return -1;
                    }
                    if (a > b) {
                        return 1;
                    }
                    return 0;
                };
            }
        }
    };
    Table.prototype._quicksort = function (column, left, right, direction, equalityComparer) {
        if (direction === void 0) { direction = 1; }
        if (right - left > 0) {
            var partition = this._partition(column, left, right, direction, equalityComparer);
            if (left < partition - 1) {
                this._quicksort(column, left, partition - 1, direction, equalityComparer);
            }
            if (partition < right) {
                this._quicksort(column, partition, right, direction, equalityComparer);
            }
        }
    };
    Table.prototype._partition = function (column, left, right, direction, equalityComparer) {
        if (direction === void 0) { direction = 1; }
        var pivot = this._getCell(column, Math.floor((right + left) / 2));
        var i = left;
        var j = right;
        while (i <= j) {
            while (this._equals(this._getCell(column, i), pivot, equalityComparer) *
                direction <
                0) {
                i += 1;
            }
            while (this._equals(this._getCell(column, j), pivot, equalityComparer) *
                direction >
                0) {
                j -= 1;
            }
            if (i <= j) {
                this._swap(i, j);
                i += 1;
                j -= 1;
            }
        }
        return i;
    };
    Table.prototype._equals = function (a, b, equalityComparer) {
        var dataA = a.getAttribute("data-value");
        var dataB = b.getAttribute("data-value");
        dataA = dataA || a.textContent || a.innerText;
        dataB = dataB || b.textContent || b.innerText;
        return equalityComparer(dataA, dataB);
    };
    Table.prototype._swap = function (i, j) {
        var rowI = this._getRow(i);
        var rowJ = this._getRow(j);
        // create marker element and insert it where rowI is
        var temp = document.createElement("div");
        rowI.parentNode.insertBefore(temp, rowI);
        // move rowI to right before rowJ
        rowJ.parentNode.insertBefore(rowI, rowJ);
        // move rowJ to right before where rowI used to be
        temp.parentNode.insertBefore(rowJ, temp);
        // remove temporary marker node
        temp.parentNode.removeChild(temp);
    };
    /**
     * Destroys the component and clears all references.
     */
    Table.prototype.destroy = function () {
        var e_2, _a;
        try {
            for (var _b = Object(tslib_es6["f" /* __values */])(this.element.querySelectorAll("th")), _c = _b.next(); !_c.done; _c = _b.next()) {
                var header = _c.value;
                header.removeEventListener("click", this._headerClickHandler);
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_2) throw e_2.error; }
        }
        ;
        this._headerClickHandler = null;
        this._body = null;
        this._rows = null;
    };
    return Table;
}(DomElement["a" /* default */]));
function Table_init() {
    Object(Utils["h" /* searchAndInitialize */])("table", function (e) {
        new Table_Table(e);
    });
}
/* harmony default export */ var table_Table = (Table_Table);

// CONCATENATED MODULE: ./clientlibs/js/lib/sdx/Tc.Module.SDXAutoInit.ts






/**
 * Initializes SDX components automatically if they’re in the whitelist.
 * Replacement for data-init="auto", which would require the portal
 * to include the whole SDX JS code.
 */
var Tc_Module_SDXAutoInit_SDXAutoInit = /** @class */ (function (_super) {
    Object(tslib_es6["c" /* __extends */])(SDXAutoInit, _super);
    function SDXAutoInit() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SDXAutoInit.prototype.on = function (callback) {
        this.log('doing nothing until after');
        callback();
    };
    SDXAutoInit.prototype.after = function () {
        this.instance = this.init();
    };
    SDXAutoInit.prototype.init = function () {
        for (var _i = 0, _a = SDXAutoInit.INITIALIZERS; _i < _a.length; _i++) {
            var initializer = _a[_i];
            if (initializer.test(this.$ctx)) {
                return initializer.init(this.$ctx[0]);
            }
        }
        return undefined;
    };
    SDXAutoInit.INITIALIZERS = [
        {
            test: function ($el) {
                return $el.is('input');
            },
            init: function (el) {
                return new InputField["default"](el);
            },
        },
        {
            test: function ($el) {
                return $el.is('select');
            },
            init: function (el) {
                var _a;
                var select = new Select["default"](el);
                (_a = select.element.parentElement) === null || _a === void 0 ? void 0 : _a.querySelectorAll('.dropdown-item').forEach(function (e) {
                    e.innerHTML = e.innerHTML.replace(/amp;/gi, '');
                });
                return select;
            },
        },
        {
            test: function ($el) {
                return $el.is('.accordion');
            },
            init: function (el) {
                return new Accordion["default"](el);
            },
        },
        {
            test: function ($el) {
                return $el.is('table');
            },
            init: function (el) {
                return new table_Table(el);
            },
        },
    ];
    return SDXAutoInit;
}(Module["a" /* Module */]));
/* harmony default export */ var Tc_Module_SDXAutoInit = (Tc_Module_SDXAutoInit_SDXAutoInit);

// CONCATENATED MODULE: ./clientlibs/js/by-category/scs.portal.sdx.expand.ts
// base=/etc/designs/portal/clientlibs/sdx_expand/js/modules



// Modern modules (using imports/exports)

var scs_portal_sdx_expand_modernTcModules = {
    SDXAutoInit: Tc_Module_SDXAutoInit,
    SdxAutoInit: Tc_Module_SDXAutoInit,
};
// Tc Bootstrap

Object(load_terrific["legacyBootstrapDeferredSingleton"])(scs_portal_sdx_expand_modernTcModules);

// CONCATENATED MODULE: ./portal/ui/src/main/content/jcr_root/etc/designs/portal/clientlibs/aggregated.ts
// Polyfills

// Embeds













/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Array.prototype.find = Array.prototype.find || function(callback) {
  if (this === null) {
    throw new TypeError('Array.prototype.find called on null or undefined');
  } else if (typeof callback !== 'function') {
    throw new TypeError('callback must be a function');
  }
  var list = Object(this);
  // Makes sures is always has an positive integer as length.
  var length = list.length >>> 0;
  var thisArg = arguments[1];
  for (var i = 0; i < length; i++) {
    var element = list[i];
    if ( callback.call(thisArg, element, i, list) ) {
      return element;
    }
  }
};


/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(setImmediate) {// Store setTimeout reference so promise-polyfill will be unaffected by
// other code modifying setTimeout (like sinon.useFakeTimers())
var setTimeoutFunc = setTimeout;

function noop() {}

// Polyfill for Function.prototype.bind
function bind(fn, thisArg) {
  return function() {
    fn.apply(thisArg, arguments);
  };
}

function handle(self, deferred) {
  while (self._state === 3) {
    self = self._value;
  }
  if (self._state === 0) {
    self._deferreds.push(deferred);
    return;
  }
  self._handled = true;
  Promise._immediateFn(function() {
    var cb = self._state === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      (self._state === 1 ? resolve : reject)(deferred.promise, self._value);
      return;
    }
    var ret;
    try {
      ret = cb(self._value);
    } catch (e) {
      reject(deferred.promise, e);
      return;
    }
    resolve(deferred.promise, ret);
  });
}

function resolve(self, newValue) {
  try {
    // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
    if (newValue === self)
      throw new TypeError('A promise cannot be resolved with itself.');
    if (
      newValue &&
      (typeof newValue === 'object' || typeof newValue === 'function')
    ) {
      var then = newValue.then;
      if (newValue instanceof Promise) {
        self._state = 3;
        self._value = newValue;
        finale(self);
        return;
      } else if (typeof then === 'function') {
        doResolve(bind(then, newValue), self);
        return;
      }
    }
    self._state = 1;
    self._value = newValue;
    finale(self);
  } catch (e) {
    reject(self, e);
  }
}

function reject(self, newValue) {
  self._state = 2;
  self._value = newValue;
  finale(self);
}

function finale(self) {
  if (self._state === 2 && self._deferreds.length === 0) {
    Promise._immediateFn(function() {
      if (!self._handled) {
        Promise._unhandledRejectionFn(self._value);
      }
    });
  }

  for (var i = 0, len = self._deferreds.length; i < len; i++) {
    handle(self, self._deferreds[i]);
  }
  self._deferreds = null;
}

function Handler(onFulfilled, onRejected, promise) {
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, self) {
  var done = false;
  try {
    fn(
      function(value) {
        if (done) return;
        done = true;
        resolve(self, value);
      },
      function(reason) {
        if (done) return;
        done = true;
        reject(self, reason);
      }
    );
  } catch (ex) {
    if (done) return;
    done = true;
    reject(self, ex);
  }
}

function Promise(fn) {
  if (!(this instanceof Promise))
    throw new TypeError('Promises must be constructed via new');
  if (typeof fn !== 'function') throw new TypeError('not a function');
  this._state = 0;
  this._handled = false;
  this._value = undefined;
  this._deferreds = [];

  doResolve(fn, this);
}

var _proto = Promise.prototype;
_proto.catch = function(onRejected) {
  return this.then(null, onRejected);
};

_proto.then = function(onFulfilled, onRejected) {
  var prom = new this.constructor(noop);

  handle(this, new Handler(onFulfilled, onRejected, prom));
  return prom;
};

Promise.all = function(arr) {
  return new Promise(function(resolve, reject) {
    if (!arr || typeof arr.length === 'undefined')
      throw new TypeError('Promise.all accepts an array');
    var args = Array.prototype.slice.call(arr);
    if (args.length === 0) return resolve([]);
    var remaining = args.length;

    function res(i, val) {
      try {
        if (val && (typeof val === 'object' || typeof val === 'function')) {
          var then = val.then;
          if (typeof then === 'function') {
            then.call(
              val,
              function(val) {
                res(i, val);
              },
              reject
            );
            return;
          }
        }
        args[i] = val;
        if (--remaining === 0) {
          resolve(args);
        }
      } catch (ex) {
        reject(ex);
      }
    }

    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.resolve = function(value) {
  if (value && typeof value === 'object' && value.constructor === Promise) {
    return value;
  }

  return new Promise(function(resolve) {
    resolve(value);
  });
};

Promise.reject = function(value) {
  return new Promise(function(resolve, reject) {
    reject(value);
  });
};

Promise.race = function(values) {
  return new Promise(function(resolve, reject) {
    for (var i = 0, len = values.length; i < len; i++) {
      values[i].then(resolve, reject);
    }
  });
};

// Use polyfill for setImmediate for performance gains
Promise._immediateFn =
  (typeof setImmediate === 'function' &&
    function(fn) {
      setImmediate(fn);
    }) ||
  function(fn) {
    setTimeoutFunc(fn, 0);
  };

Promise._unhandledRejectionFn = function _unhandledRejectionFn(err) {
  if (typeof console !== 'undefined' && console) {
    console.warn('Possible Unhandled Promise Rejection:', err); // eslint-disable-line no-console
  }
};

/* harmony default export */ __webpack_exports__["a"] = (Promise);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(58).setImmediate))

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, window, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, window, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(window, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(59);
exports.setImmediate = setImmediate;
exports.clearImmediate = clearImmediate;


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19), __webpack_require__(60)))

/***/ }),
/* 60 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {(function(global) {
  /**
   * Polyfill URLSearchParams
   *
   * Inspired from : https://github.com/WebReflection/url-search-params/blob/master/src/url-search-params.js
   */

  var checkIfIteratorIsSupported = function() {
    try {
      return !!Symbol.iterator;
    } catch (error) {
      return false;
    }
  };


  var iteratorSupported = checkIfIteratorIsSupported();

  var createIterator = function(items) {
    var iterator = {
      next: function() {
        var value = items.shift();
        return { done: value === void 0, value: value };
      }
    };

    if (iteratorSupported) {
      iterator[Symbol.iterator] = function() {
        return iterator;
      };
    }

    return iterator;
  };

  /**
   * Search param name and values should be encoded according to https://url.spec.whatwg.org/#urlencoded-serializing
   * encodeURIComponent() produces the same result except encoding spaces as `%20` instead of `+`.
   */
  var serializeParam = function(value) {
    return encodeURIComponent(value).replace(/%20/g, '+');
  };

  var deserializeParam = function(value) {
    return decodeURIComponent(String(value).replace(/\+/g, ' '));
  };

  var polyfillURLSearchParams = function() {

    var URLSearchParams = function(searchString) {
      Object.defineProperty(this, '_entries', { writable: true, value: {} });
      var typeofSearchString = typeof searchString;

      if (typeofSearchString === 'undefined') {
        // do nothing
      } else if (typeofSearchString === 'string') {
        if (searchString !== '') {
          this._fromString(searchString);
        }
      } else if (searchString instanceof URLSearchParams) {
        var _this = this;
        searchString.forEach(function(value, name) {
          _this.append(name, value);
        });
      } else if ((searchString !== null) && (typeofSearchString === 'object')) {
        if (Object.prototype.toString.call(searchString) === '[object Array]') {
          for (var i = 0; i < searchString.length; i++) {
            var entry = searchString[i];
            if ((Object.prototype.toString.call(entry) === '[object Array]') || (entry.length !== 2)) {
              this.append(entry[0], entry[1]);
            } else {
              throw new TypeError('Expected [string, any] as entry at index ' + i + ' of URLSearchParams\'s input');
            }
          }
        } else {
          for (var key in searchString) {
            if (searchString.hasOwnProperty(key)) {
              this.append(key, searchString[key]);
            }
          }
        }
      } else {
        throw new TypeError('Unsupported input\'s type for URLSearchParams');
      }
    };

    var proto = URLSearchParams.prototype;

    proto.append = function(name, value) {
      if (name in this._entries) {
        this._entries[name].push(String(value));
      } else {
        this._entries[name] = [String(value)];
      }
    };

    proto.delete = function(name) {
      delete this._entries[name];
    };

    proto.get = function(name) {
      return (name in this._entries) ? this._entries[name][0] : null;
    };

    proto.getAll = function(name) {
      return (name in this._entries) ? this._entries[name].slice(0) : [];
    };

    proto.has = function(name) {
      return (name in this._entries);
    };

    proto.set = function(name, value) {
      this._entries[name] = [String(value)];
    };

    proto.forEach = function(callback, thisArg) {
      var entries;
      for (var name in this._entries) {
        if (this._entries.hasOwnProperty(name)) {
          entries = this._entries[name];
          for (var i = 0; i < entries.length; i++) {
            callback.call(thisArg, entries[i], name, this);
          }
        }
      }
    };

    proto.keys = function() {
      var items = [];
      this.forEach(function(value, name) {
        items.push(name);
      });
      return createIterator(items);
    };

    proto.values = function() {
      var items = [];
      this.forEach(function(value) {
        items.push(value);
      });
      return createIterator(items);
    };

    proto.entries = function() {
      var items = [];
      this.forEach(function(value, name) {
        items.push([name, value]);
      });
      return createIterator(items);
    };

    if (iteratorSupported) {
      proto[Symbol.iterator] = proto.entries;
    }

    proto.toString = function() {
      var searchArray = [];
      this.forEach(function(value, name) {
        searchArray.push(serializeParam(name) + '=' + serializeParam(value));
      });
      return searchArray.join('&');
    };


    global.URLSearchParams = URLSearchParams;
  };

  if (!('URLSearchParams' in global) || (new global.URLSearchParams('?a=1').toString() !== 'a=1')) {
    polyfillURLSearchParams();
  }

  var proto = global.URLSearchParams.prototype;

  if (typeof proto.sort !== 'function') {
    proto.sort = function() {
      var _this = this;
      var items = [];
      this.forEach(function(value, name) {
        items.push([name, value]);
        if (!_this._entries) {
          _this.delete(name);
        }
      });
      items.sort(function(a, b) {
        if (a[0] < b[0]) {
          return -1;
        } else if (a[0] > b[0]) {
          return +1;
        } else {
          return 0;
        }
      });
      if (_this._entries) { // force reset because IE keeps keys index
        _this._entries = {};
      }
      for (var i = 0; i < items.length; i++) {
        this.append(items[i][0], items[i][1]);
      }
    };
  }

  if (typeof proto._fromString !== 'function') {
    Object.defineProperty(proto, '_fromString', {
      enumerable: false,
      configurable: false,
      writable: false,
      value: function(searchString) {
        if (this._entries) {
          this._entries = {};
        } else {
          var keys = [];
          this.forEach(function(value, name) {
            keys.push(name);
          });
          for (var i = 0; i < keys.length; i++) {
            this.delete(keys[i]);
          }
        }

        searchString = searchString.replace(/^\?/, '');
        var attributes = searchString.split('&');
        var attribute;
        for (var i = 0; i < attributes.length; i++) {
          attribute = attributes[i].split('=');
          this.append(
            deserializeParam(attribute[0]),
            (attribute.length > 1) ? deserializeParam(attribute[1]) : ''
          );
        }
      }
    });
  }

  // HTMLAnchorElement

})(
  (typeof global !== 'undefined') ? global
    : ((typeof window !== 'undefined') ? window
    : ((typeof self !== 'undefined') ? self : this))
);

(function(global) {
  /**
   * Polyfill URL
   *
   * Inspired from : https://github.com/arv/DOM-URL-Polyfill/blob/master/src/url.js
   */

  var checkIfURLIsSupported = function() {
    try {
      var u = new global.URL('b', 'http://a');
      u.pathname = 'c%20d';
      return (u.href === 'http://a/c%20d') && u.searchParams;
    } catch (e) {
      return false;
    }
  };


  var polyfillURL = function() {
    var _URL = global.URL;

    var URL = function(url, base) {
      if (typeof url !== 'string') url = String(url);

      // Only create another document if the base is different from current location.
      var doc = document, baseElement;
      if (base && (global.location === void 0 || base !== global.location.href)) {
        doc = document.implementation.createHTMLDocument('');
        baseElement = doc.createElement('base');
        baseElement.href = base;
        doc.head.appendChild(baseElement);
        try {
          if (baseElement.href.indexOf(base) !== 0) throw new Error(baseElement.href);
        } catch (err) {
          throw new Error('URL unable to set base ' + base + ' due to ' + err);
        }
      }

      var anchorElement = doc.createElement('a');
      anchorElement.href = url;
      if (baseElement) {
        doc.body.appendChild(anchorElement);
        anchorElement.href = anchorElement.href; // force href to refresh
      }

      if (anchorElement.protocol === ':' || !/:/.test(anchorElement.href)) {
        throw new TypeError('Invalid URL');
      }

      Object.defineProperty(this, '_anchorElement', {
        value: anchorElement
      });


      // create a linked searchParams which reflect its changes on URL
      var searchParams = new global.URLSearchParams(this.search);
      var enableSearchUpdate = true;
      var enableSearchParamsUpdate = true;
      var _this = this;
      ['append', 'delete', 'set'].forEach(function(methodName) {
        var method = searchParams[methodName];
        searchParams[methodName] = function() {
          method.apply(searchParams, arguments);
          if (enableSearchUpdate) {
            enableSearchParamsUpdate = false;
            _this.search = searchParams.toString();
            enableSearchParamsUpdate = true;
          }
        };
      });

      Object.defineProperty(this, 'searchParams', {
        value: searchParams,
        enumerable: true
      });

      var search = void 0;
      Object.defineProperty(this, '_updateSearchParams', {
        enumerable: false,
        configurable: false,
        writable: false,
        value: function() {
          if (this.search !== search) {
            search = this.search;
            if (enableSearchParamsUpdate) {
              enableSearchUpdate = false;
              this.searchParams._fromString(this.search);
              enableSearchUpdate = true;
            }
          }
        }
      });
    };

    var proto = URL.prototype;

    var linkURLWithAnchorAttribute = function(attributeName) {
      Object.defineProperty(proto, attributeName, {
        get: function() {
          return this._anchorElement[attributeName];
        },
        set: function(value) {
          this._anchorElement[attributeName] = value;
        },
        enumerable: true
      });
    };

    ['hash', 'host', 'hostname', 'port', 'protocol']
      .forEach(function(attributeName) {
        linkURLWithAnchorAttribute(attributeName);
      });

    Object.defineProperty(proto, 'search', {
      get: function() {
        return this._anchorElement['search'];
      },
      set: function(value) {
        this._anchorElement['search'] = value;
        this._updateSearchParams();
      },
      enumerable: true
    });

    Object.defineProperties(proto, {

      'toString': {
        get: function() {
          var _this = this;
          return function() {
            return _this.href;
          };
        }
      },

      'href': {
        get: function() {
          return this._anchorElement.href.replace(/\?$/, '');
        },
        set: function(value) {
          this._anchorElement.href = value;
          this._updateSearchParams();
        },
        enumerable: true
      },

      'pathname': {
        get: function() {
          return this._anchorElement.pathname.replace(/(^\/?)/, '/');
        },
        set: function(value) {
          this._anchorElement.pathname = value;
        },
        enumerable: true
      },

      'origin': {
        get: function() {
          // get expected port from protocol
          var expectedPort = { 'http:': 80, 'https:': 443, 'ftp:': 21 }[this._anchorElement.protocol];
          // add port to origin if, expected port is different than actual port
          // and it is not empty f.e http://foo:8080
          // 8080 != 80 && 8080 != ''
          var addPortToOrigin = this._anchorElement.port != expectedPort &&
            this._anchorElement.port !== '';

          return this._anchorElement.protocol +
            '//' +
            this._anchorElement.hostname +
            (addPortToOrigin ? (':' + this._anchorElement.port) : '');
        },
        enumerable: true
      },

      'password': { // TODO
        get: function() {
          return '';
        },
        set: function(value) {
        },
        enumerable: true
      },

      'username': { // TODO
        get: function() {
          return '';
        },
        set: function(value) {
        },
        enumerable: true
      },
    });

    URL.createObjectURL = function(blob) {
      return _URL.createObjectURL.apply(_URL, arguments);
    };

    URL.revokeObjectURL = function(url) {
      return _URL.revokeObjectURL.apply(_URL, arguments);
    };

    global.URL = URL;

  };

  if (!checkIfURLIsSupported()) {
    polyfillURL();
  }

  if ((global.location !== void 0) && !('origin' in global.location)) {
    var getOrigin = function() {
      return global.location.protocol + '//' + global.location.hostname + (global.location.port ? (':' + global.location.port) : '');
    };

    try {
      Object.defineProperty(global.location, 'origin', {
        get: getOrigin,
        enumerable: true
      });
    } catch (e) {
      setInterval(function() {
        global.location.origin = getOrigin();
      }, 100);
    }
  }

})(
  (typeof global !== 'undefined') ? global
    : ((typeof window !== 'undefined') ? window
    : ((typeof self !== 'undefined') ? self : this))
);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19)))

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*! jQuery UI - v1.12.1 - 2017-06-27
* http://jqueryui.com
* Includes: widget.js, position.js, data.js, disable-selection.js, focusable.js, form-reset-mixin.js, keycode.js, labels.js, scroll-parent.js, tabbable.js, unique-id.js, widgets/draggable.js, widgets/resizable.js, widgets/accordion.js, widgets/autocomplete.js, widgets/button.js, widgets/checkboxradio.js, widgets/controlgroup.js, widgets/datepicker.js, widgets/dialog.js, widgets/menu.js, widgets/mouse.js, widgets/tabs.js
* Copyright jQuery Foundation and other contributors; Licensed MIT */

(function(t){ true?!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (t),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):t(jQuery)})(function(t){function e(t){for(var e=t.css("visibility");"inherit"===e;)t=t.parent(),e=t.css("visibility");return"hidden"!==e}function i(t){for(var e,i;t.length&&t[0]!==document;){if(e=t.css("position"),("absolute"===e||"relative"===e||"fixed"===e)&&(i=parseInt(t.css("zIndex"),10),!isNaN(i)&&0!==i))return i;t=t.parent()}return 0}function s(){this._curInst=null,this._keyEvent=!1,this._disabledInputs=[],this._datepickerShowing=!1,this._inDialog=!1,this._mainDivId="ui-datepicker-div",this._inlineClass="ui-datepicker-inline",this._appendClass="ui-datepicker-append",this._triggerClass="ui-datepicker-trigger",this._dialogClass="ui-datepicker-dialog",this._disableClass="ui-datepicker-disabled",this._unselectableClass="ui-datepicker-unselectable",this._currentClass="ui-datepicker-current-day",this._dayOverClass="ui-datepicker-days-cell-over",this.regional=[],this.regional[""]={closeText:"Done",prevText:"Prev",nextText:"Next",currentText:"Today",monthNames:["January","February","March","April","May","June","July","August","September","October","November","December"],monthNamesShort:["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"],dayNames:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"],dayNamesShort:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],dayNamesMin:["Su","Mo","Tu","We","Th","Fr","Sa"],weekHeader:"Wk",dateFormat:"mm/dd/yy",firstDay:0,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""},this._defaults={showOn:"focus",showAnim:"fadeIn",showOptions:{},defaultDate:null,appendText:"",buttonText:"...",buttonImage:"",buttonImageOnly:!1,hideIfNoPrevNext:!1,navigationAsDateFormat:!1,gotoCurrent:!1,changeMonth:!1,changeYear:!1,yearRange:"c-10:c+10",showOtherMonths:!1,selectOtherMonths:!1,showWeek:!1,calculateWeek:this.iso8601Week,shortYearCutoff:"+10",minDate:null,maxDate:null,duration:"fast",beforeShowDay:null,beforeShow:null,onSelect:null,onChangeMonthYear:null,onClose:null,numberOfMonths:1,showCurrentAtPos:0,stepMonths:1,stepBigMonths:12,altField:"",altFormat:"",constrainInput:!0,showButtonPanel:!1,autoSize:!1,disabled:!1},t.extend(this._defaults,this.regional[""]),this.regional.en=t.extend(!0,{},this.regional[""]),this.regional["en-US"]=t.extend(!0,{},this.regional.en),this.dpDiv=n(t("<div id='"+this._mainDivId+"' class='ui-datepicker ui-widget ui-widget-content ui-helper-clearfix ui-corner-all'></div>"))}function n(e){var i="button, .ui-datepicker-prev, .ui-datepicker-next, .ui-datepicker-calendar td a";return e.on("mouseout",i,function(){t(this).removeClass("ui-state-hover"),-1!==this.className.indexOf("ui-datepicker-prev")&&t(this).removeClass("ui-datepicker-prev-hover"),-1!==this.className.indexOf("ui-datepicker-next")&&t(this).removeClass("ui-datepicker-next-hover")}).on("mouseover",i,o)}function o(){t.datepicker._isDisabledDatepicker(u.inline?u.dpDiv.parent()[0]:u.input[0])||(t(this).parents(".ui-datepicker-calendar").find("a").removeClass("ui-state-hover"),t(this).addClass("ui-state-hover"),-1!==this.className.indexOf("ui-datepicker-prev")&&t(this).addClass("ui-datepicker-prev-hover"),-1!==this.className.indexOf("ui-datepicker-next")&&t(this).addClass("ui-datepicker-next-hover"))}function a(e,i){t.extend(e,i);for(var s in i)null==i[s]&&(e[s]=i[s]);return e}t.ui=t.ui||{},t.ui.version="1.12.1";var r=0,l=Array.prototype.slice;t.cleanData=function(e){return function(i){var s,n,o;for(o=0;null!=(n=i[o]);o++)try{s=t._data(n,"events"),s&&s.remove&&t(n).triggerHandler("remove")}catch(a){}e(i)}}(t.cleanData),t.widget=function(e,i,s){var n,o,a,r={},l=e.split(".")[0];e=e.split(".")[1];var h=l+"-"+e;return s||(s=i,i=t.Widget),t.isArray(s)&&(s=t.extend.apply(null,[{}].concat(s))),t.expr[":"][h.toLowerCase()]=function(e){return!!t.data(e,h)},t[l]=t[l]||{},n=t[l][e],o=t[l][e]=function(t,e){return this._createWidget?(arguments.length&&this._createWidget(t,e),void 0):new o(t,e)},t.extend(o,n,{version:s.version,_proto:t.extend({},s),_childConstructors:[]}),a=new i,a.options=t.widget.extend({},a.options),t.each(s,function(e,s){return t.isFunction(s)?(r[e]=function(){function t(){return i.prototype[e].apply(this,arguments)}function n(t){return i.prototype[e].apply(this,t)}return function(){var e,i=this._super,o=this._superApply;return this._super=t,this._superApply=n,e=s.apply(this,arguments),this._super=i,this._superApply=o,e}}(),void 0):(r[e]=s,void 0)}),o.prototype=t.widget.extend(a,{widgetEventPrefix:n?a.widgetEventPrefix||e:e},r,{constructor:o,namespace:l,widgetName:e,widgetFullName:h}),n?(t.each(n._childConstructors,function(e,i){var s=i.prototype;t.widget(s.namespace+"."+s.widgetName,o,i._proto)}),delete n._childConstructors):i._childConstructors.push(o),t.widget.bridge(e,o),o},t.widget.extend=function(e){for(var i,s,n=l.call(arguments,1),o=0,a=n.length;a>o;o++)for(i in n[o])s=n[o][i],n[o].hasOwnProperty(i)&&void 0!==s&&(e[i]=t.isPlainObject(s)?t.isPlainObject(e[i])?t.widget.extend({},e[i],s):t.widget.extend({},s):s);return e},t.widget.bridge=function(e,i){var s=i.prototype.widgetFullName||e;t.fn[e]=function(n){var o="string"==typeof n,a=l.call(arguments,1),r=this;return o?this.length||"instance"!==n?this.each(function(){var i,o=t.data(this,s);return"instance"===n?(r=o,!1):o?t.isFunction(o[n])&&"_"!==n.charAt(0)?(i=o[n].apply(o,a),i!==o&&void 0!==i?(r=i&&i.jquery?r.pushStack(i.get()):i,!1):void 0):t.error("no such method '"+n+"' for "+e+" widget instance"):t.error("cannot call methods on "+e+" prior to initialization; "+"attempted to call method '"+n+"'")}):r=void 0:(a.length&&(n=t.widget.extend.apply(null,[n].concat(a))),this.each(function(){var e=t.data(this,s);e?(e.option(n||{}),e._init&&e._init()):t.data(this,s,new i(n,this))})),r}},t.Widget=function(){},t.Widget._childConstructors=[],t.Widget.prototype={widgetName:"widget",widgetEventPrefix:"",defaultElement:"<div>",options:{classes:{},disabled:!1,create:null},_createWidget:function(e,i){i=t(i||this.defaultElement||this)[0],this.element=t(i),this.uuid=r++,this.eventNamespace="."+this.widgetName+this.uuid,this.bindings=t(),this.hoverable=t(),this.focusable=t(),this.classesElementLookup={},i!==this&&(t.data(i,this.widgetFullName,this),this._on(!0,this.element,{remove:function(t){t.target===i&&this.destroy()}}),this.document=t(i.style?i.ownerDocument:i.document||i),this.window=t(this.document[0].defaultView||this.document[0].parentWindow)),this.options=t.widget.extend({},this.options,this._getCreateOptions(),e),this._create(),this.options.disabled&&this._setOptionDisabled(this.options.disabled),this._trigger("create",null,this._getCreateEventData()),this._init()},_getCreateOptions:function(){return{}},_getCreateEventData:t.noop,_create:t.noop,_init:t.noop,destroy:function(){var e=this;this._destroy(),t.each(this.classesElementLookup,function(t,i){e._removeClass(i,t)}),this.element.off(this.eventNamespace).removeData(this.widgetFullName),this.widget().off(this.eventNamespace).removeAttr("aria-disabled"),this.bindings.off(this.eventNamespace)},_destroy:t.noop,widget:function(){return this.element},option:function(e,i){var s,n,o,a=e;if(0===arguments.length)return t.widget.extend({},this.options);if("string"==typeof e)if(a={},s=e.split("."),e=s.shift(),s.length){for(n=a[e]=t.widget.extend({},this.options[e]),o=0;s.length-1>o;o++)n[s[o]]=n[s[o]]||{},n=n[s[o]];if(e=s.pop(),1===arguments.length)return void 0===n[e]?null:n[e];n[e]=i}else{if(1===arguments.length)return void 0===this.options[e]?null:this.options[e];a[e]=i}return this._setOptions(a),this},_setOptions:function(t){var e;for(e in t)this._setOption(e,t[e]);return this},_setOption:function(t,e){return"classes"===t&&this._setOptionClasses(e),this.options[t]=e,"disabled"===t&&this._setOptionDisabled(e),this},_setOptionClasses:function(e){var i,s,n;for(i in e)n=this.classesElementLookup[i],e[i]!==this.options.classes[i]&&n&&n.length&&(s=t(n.get()),this._removeClass(n,i),s.addClass(this._classes({element:s,keys:i,classes:e,add:!0})))},_setOptionDisabled:function(t){this._toggleClass(this.widget(),this.widgetFullName+"-disabled",null,!!t),t&&(this._removeClass(this.hoverable,null,"ui-state-hover"),this._removeClass(this.focusable,null,"ui-state-focus"))},enable:function(){return this._setOptions({disabled:!1})},disable:function(){return this._setOptions({disabled:!0})},_classes:function(e){function i(i,o){var a,r;for(r=0;i.length>r;r++)a=n.classesElementLookup[i[r]]||t(),a=e.add?t(t.unique(a.get().concat(e.element.get()))):t(a.not(e.element).get()),n.classesElementLookup[i[r]]=a,s.push(i[r]),o&&e.classes[i[r]]&&s.push(e.classes[i[r]])}var s=[],n=this;return e=t.extend({element:this.element,classes:this.options.classes||{}},e),this._on(e.element,{remove:"_untrackClassesElement"}),e.keys&&i(e.keys.match(/\S+/g)||[],!0),e.extra&&i(e.extra.match(/\S+/g)||[]),s.join(" ")},_untrackClassesElement:function(e){var i=this;t.each(i.classesElementLookup,function(s,n){-1!==t.inArray(e.target,n)&&(i.classesElementLookup[s]=t(n.not(e.target).get()))})},_removeClass:function(t,e,i){return this._toggleClass(t,e,i,!1)},_addClass:function(t,e,i){return this._toggleClass(t,e,i,!0)},_toggleClass:function(t,e,i,s){s="boolean"==typeof s?s:i;var n="string"==typeof t||null===t,o={extra:n?e:i,keys:n?t:e,element:n?this.element:t,add:s};return o.element.toggleClass(this._classes(o),s),this},_on:function(e,i,s){var n,o=this;"boolean"!=typeof e&&(s=i,i=e,e=!1),s?(i=n=t(i),this.bindings=this.bindings.add(i)):(s=i,i=this.element,n=this.widget()),t.each(s,function(s,a){function r(){return e||o.options.disabled!==!0&&!t(this).hasClass("ui-state-disabled")?("string"==typeof a?o[a]:a).apply(o,arguments):void 0}"string"!=typeof a&&(r.guid=a.guid=a.guid||r.guid||t.guid++);var l=s.match(/^([\w:-]*)\s*(.*)$/),h=l[1]+o.eventNamespace,c=l[2];c?n.on(h,c,r):i.on(h,r)})},_off:function(e,i){i=(i||"").split(" ").join(this.eventNamespace+" ")+this.eventNamespace,e.off(i).off(i),this.bindings=t(this.bindings.not(e).get()),this.focusable=t(this.focusable.not(e).get()),this.hoverable=t(this.hoverable.not(e).get())},_delay:function(t,e){function i(){return("string"==typeof t?s[t]:t).apply(s,arguments)}var s=this;return setTimeout(i,e||0)},_hoverable:function(e){this.hoverable=this.hoverable.add(e),this._on(e,{mouseenter:function(e){this._addClass(t(e.currentTarget),null,"ui-state-hover")},mouseleave:function(e){this._removeClass(t(e.currentTarget),null,"ui-state-hover")}})},_focusable:function(e){this.focusable=this.focusable.add(e),this._on(e,{focusin:function(e){this._addClass(t(e.currentTarget),null,"ui-state-focus")},focusout:function(e){this._removeClass(t(e.currentTarget),null,"ui-state-focus")}})},_trigger:function(e,i,s){var n,o,a=this.options[e];if(s=s||{},i=t.Event(i),i.type=(e===this.widgetEventPrefix?e:this.widgetEventPrefix+e).toLowerCase(),i.target=this.element[0],o=i.originalEvent)for(n in o)n in i||(i[n]=o[n]);return this.element.trigger(i,s),!(t.isFunction(a)&&a.apply(this.element[0],[i].concat(s))===!1||i.isDefaultPrevented())}},t.each({show:"fadeIn",hide:"fadeOut"},function(e,i){t.Widget.prototype["_"+e]=function(s,n,o){"string"==typeof n&&(n={effect:n});var a,r=n?n===!0||"number"==typeof n?i:n.effect||i:e;n=n||{},"number"==typeof n&&(n={duration:n}),a=!t.isEmptyObject(n),n.complete=o,n.delay&&s.delay(n.delay),a&&t.effects&&t.effects.effect[r]?s[e](n):r!==e&&s[r]?s[r](n.duration,n.easing,o):s.queue(function(i){t(this)[e](),o&&o.call(s[0]),i()})}}),t.widget,function(){function e(t,e,i){return[parseFloat(t[0])*(u.test(t[0])?e/100:1),parseFloat(t[1])*(u.test(t[1])?i/100:1)]}function i(e,i){return parseInt(t.css(e,i),10)||0}function s(e){var i=e[0];return 9===i.nodeType?{width:e.width(),height:e.height(),offset:{top:0,left:0}}:t.isWindow(i)?{width:e.width(),height:e.height(),offset:{top:e.scrollTop(),left:e.scrollLeft()}}:i.preventDefault?{width:0,height:0,offset:{top:i.pageY,left:i.pageX}}:{width:e.outerWidth(),height:e.outerHeight(),offset:e.offset()}}var n,o=Math.max,a=Math.abs,r=/left|center|right/,l=/top|center|bottom/,h=/[\+\-]\d+(\.[\d]+)?%?/,c=/^\w+/,u=/%$/,d=t.fn.position;t.position={scrollbarWidth:function(){if(void 0!==n)return n;var e,i,s=t("<div style='display:block;position:absolute;width:50px;height:50px;overflow:hidden;'><div style='height:100px;width:auto;'></div></div>"),o=s.children()[0];return t("body").append(s),e=o.offsetWidth,s.css("overflow","scroll"),i=o.offsetWidth,e===i&&(i=s[0].clientWidth),s.remove(),n=e-i},getScrollInfo:function(e){var i=e.isWindow||e.isDocument?"":e.element.css("overflow-x"),s=e.isWindow||e.isDocument?"":e.element.css("overflow-y"),n="scroll"===i||"auto"===i&&e.width<e.element[0].scrollWidth,o="scroll"===s||"auto"===s&&e.height<e.element[0].scrollHeight;return{width:o?t.position.scrollbarWidth():0,height:n?t.position.scrollbarWidth():0}},getWithinInfo:function(e){var i=t(e||window),s=t.isWindow(i[0]),n=!!i[0]&&9===i[0].nodeType,o=!s&&!n;return{element:i,isWindow:s,isDocument:n,offset:o?t(e).offset():{left:0,top:0},scrollLeft:i.scrollLeft(),scrollTop:i.scrollTop(),width:i.outerWidth(),height:i.outerHeight()}}},t.fn.position=function(n){if(!n||!n.of)return d.apply(this,arguments);n=t.extend({},n);var u,p,f,g,m,_,v=t(n.of),b=t.position.getWithinInfo(n.within),y=t.position.getScrollInfo(b),w=(n.collision||"flip").split(" "),k={};return _=s(v),v[0].preventDefault&&(n.at="left top"),p=_.width,f=_.height,g=_.offset,m=t.extend({},g),t.each(["my","at"],function(){var t,e,i=(n[this]||"").split(" ");1===i.length&&(i=r.test(i[0])?i.concat(["center"]):l.test(i[0])?["center"].concat(i):["center","center"]),i[0]=r.test(i[0])?i[0]:"center",i[1]=l.test(i[1])?i[1]:"center",t=h.exec(i[0]),e=h.exec(i[1]),k[this]=[t?t[0]:0,e?e[0]:0],n[this]=[c.exec(i[0])[0],c.exec(i[1])[0]]}),1===w.length&&(w[1]=w[0]),"right"===n.at[0]?m.left+=p:"center"===n.at[0]&&(m.left+=p/2),"bottom"===n.at[1]?m.top+=f:"center"===n.at[1]&&(m.top+=f/2),u=e(k.at,p,f),m.left+=u[0],m.top+=u[1],this.each(function(){var s,r,l=t(this),h=l.outerWidth(),c=l.outerHeight(),d=i(this,"marginLeft"),_=i(this,"marginTop"),x=h+d+i(this,"marginRight")+y.width,C=c+_+i(this,"marginBottom")+y.height,D=t.extend({},m),T=e(k.my,l.outerWidth(),l.outerHeight());"right"===n.my[0]?D.left-=h:"center"===n.my[0]&&(D.left-=h/2),"bottom"===n.my[1]?D.top-=c:"center"===n.my[1]&&(D.top-=c/2),D.left+=T[0],D.top+=T[1],s={marginLeft:d,marginTop:_},t.each(["left","top"],function(e,i){t.ui.position[w[e]]&&t.ui.position[w[e]][i](D,{targetWidth:p,targetHeight:f,elemWidth:h,elemHeight:c,collisionPosition:s,collisionWidth:x,collisionHeight:C,offset:[u[0]+T[0],u[1]+T[1]],my:n.my,at:n.at,within:b,elem:l})}),n.using&&(r=function(t){var e=g.left-D.left,i=e+p-h,s=g.top-D.top,r=s+f-c,u={target:{element:v,left:g.left,top:g.top,width:p,height:f},element:{element:l,left:D.left,top:D.top,width:h,height:c},horizontal:0>i?"left":e>0?"right":"center",vertical:0>r?"top":s>0?"bottom":"middle"};h>p&&p>a(e+i)&&(u.horizontal="center"),c>f&&f>a(s+r)&&(u.vertical="middle"),u.important=o(a(e),a(i))>o(a(s),a(r))?"horizontal":"vertical",n.using.call(this,t,u)}),l.offset(t.extend(D,{using:r}))})},t.ui.position={fit:{left:function(t,e){var i,s=e.within,n=s.isWindow?s.scrollLeft:s.offset.left,a=s.width,r=t.left-e.collisionPosition.marginLeft,l=n-r,h=r+e.collisionWidth-a-n;e.collisionWidth>a?l>0&&0>=h?(i=t.left+l+e.collisionWidth-a-n,t.left+=l-i):t.left=h>0&&0>=l?n:l>h?n+a-e.collisionWidth:n:l>0?t.left+=l:h>0?t.left-=h:t.left=o(t.left-r,t.left)},top:function(t,e){var i,s=e.within,n=s.isWindow?s.scrollTop:s.offset.top,a=e.within.height,r=t.top-e.collisionPosition.marginTop,l=n-r,h=r+e.collisionHeight-a-n;e.collisionHeight>a?l>0&&0>=h?(i=t.top+l+e.collisionHeight-a-n,t.top+=l-i):t.top=h>0&&0>=l?n:l>h?n+a-e.collisionHeight:n:l>0?t.top+=l:h>0?t.top-=h:t.top=o(t.top-r,t.top)}},flip:{left:function(t,e){var i,s,n=e.within,o=n.offset.left+n.scrollLeft,r=n.width,l=n.isWindow?n.scrollLeft:n.offset.left,h=t.left-e.collisionPosition.marginLeft,c=h-l,u=h+e.collisionWidth-r-l,d="left"===e.my[0]?-e.elemWidth:"right"===e.my[0]?e.elemWidth:0,p="left"===e.at[0]?e.targetWidth:"right"===e.at[0]?-e.targetWidth:0,f=-2*e.offset[0];0>c?(i=t.left+d+p+f+e.collisionWidth-r-o,(0>i||a(c)>i)&&(t.left+=d+p+f)):u>0&&(s=t.left-e.collisionPosition.marginLeft+d+p+f-l,(s>0||u>a(s))&&(t.left+=d+p+f))},top:function(t,e){var i,s,n=e.within,o=n.offset.top+n.scrollTop,r=n.height,l=n.isWindow?n.scrollTop:n.offset.top,h=t.top-e.collisionPosition.marginTop,c=h-l,u=h+e.collisionHeight-r-l,d="top"===e.my[1],p=d?-e.elemHeight:"bottom"===e.my[1]?e.elemHeight:0,f="top"===e.at[1]?e.targetHeight:"bottom"===e.at[1]?-e.targetHeight:0,g=-2*e.offset[1];0>c?(s=t.top+p+f+g+e.collisionHeight-r-o,(0>s||a(c)>s)&&(t.top+=p+f+g)):u>0&&(i=t.top-e.collisionPosition.marginTop+p+f+g-l,(i>0||u>a(i))&&(t.top+=p+f+g))}},flipfit:{left:function(){t.ui.position.flip.left.apply(this,arguments),t.ui.position.fit.left.apply(this,arguments)},top:function(){t.ui.position.flip.top.apply(this,arguments),t.ui.position.fit.top.apply(this,arguments)}}}}(),t.ui.position,t.extend(t.expr[":"],{data:t.expr.createPseudo?t.expr.createPseudo(function(e){return function(i){return!!t.data(i,e)}}):function(e,i,s){return!!t.data(e,s[3])}}),t.fn.extend({disableSelection:function(){var t="onselectstart"in document.createElement("div")?"selectstart":"mousedown";return function(){return this.on(t+".ui-disableSelection",function(t){t.preventDefault()})}}(),enableSelection:function(){return this.off(".ui-disableSelection")}}),t.ui.focusable=function(i,s){var n,o,a,r,l,h=i.nodeName.toLowerCase();return"area"===h?(n=i.parentNode,o=n.name,i.href&&o&&"map"===n.nodeName.toLowerCase()?(a=t("img[usemap='#"+o+"']"),a.length>0&&a.is(":visible")):!1):(/^(input|select|textarea|button|object)$/.test(h)?(r=!i.disabled,r&&(l=t(i).closest("fieldset")[0],l&&(r=!l.disabled))):r="a"===h?i.href||s:s,r&&t(i).is(":visible")&&e(t(i)))},t.extend(t.expr[":"],{focusable:function(e){return t.ui.focusable(e,null!=t.attr(e,"tabindex"))}}),t.ui.focusable,t.fn.form=function(){return"string"==typeof this[0].form?this.closest("form"):t(this[0].form)},t.ui.formResetMixin={_formResetHandler:function(){var e=t(this);setTimeout(function(){var i=e.data("ui-form-reset-instances");t.each(i,function(){this.refresh()})})},_bindFormResetHandler:function(){if(this.form=this.element.form(),this.form.length){var t=this.form.data("ui-form-reset-instances")||[];t.length||this.form.on("reset.ui-form-reset",this._formResetHandler),t.push(this),this.form.data("ui-form-reset-instances",t)}},_unbindFormResetHandler:function(){if(this.form.length){var e=this.form.data("ui-form-reset-instances");e.splice(t.inArray(this,e),1),e.length?this.form.data("ui-form-reset-instances",e):this.form.removeData("ui-form-reset-instances").off("reset.ui-form-reset")}}},t.ui.keyCode={BACKSPACE:8,COMMA:188,DELETE:46,DOWN:40,END:35,ENTER:13,ESCAPE:27,HOME:36,LEFT:37,PAGE_DOWN:34,PAGE_UP:33,PERIOD:190,RIGHT:39,SPACE:32,TAB:9,UP:38},t.ui.escapeSelector=function(){var t=/([!"#$%&'()*+,./:;<=>?@[\]^`{|}~])/g;return function(e){return e.replace(t,"\\$1")}}(),t.fn.labels=function(){var e,i,s,n,o;return this[0].labels&&this[0].labels.length?this.pushStack(this[0].labels):(n=this.eq(0).parents("label"),s=this.attr("id"),s&&(e=this.eq(0).parents().last(),o=e.add(e.length?e.siblings():this.siblings()),i="label[for='"+t.ui.escapeSelector(s)+"']",n=n.add(o.find(i).addBack(i))),this.pushStack(n))},t.fn.scrollParent=function(e){var i=this.css("position"),s="absolute"===i,n=e?/(auto|scroll|hidden)/:/(auto|scroll)/,o=this.parents().filter(function(){var e=t(this);return s&&"static"===e.css("position")?!1:n.test(e.css("overflow")+e.css("overflow-y")+e.css("overflow-x"))}).eq(0);return"fixed"!==i&&o.length?o:t(this[0].ownerDocument||document)},t.extend(t.expr[":"],{tabbable:function(e){var i=t.attr(e,"tabindex"),s=null!=i;return(!s||i>=0)&&t.ui.focusable(e,s)}}),t.fn.extend({uniqueId:function(){var t=0;return function(){return this.each(function(){this.id||(this.id="ui-id-"+ ++t)})}}(),removeUniqueId:function(){return this.each(function(){/^ui-id-\d+$/.test(this.id)&&t(this).removeAttr("id")})}}),t.ui.ie=!!/msie [\w.]+/.exec(navigator.userAgent.toLowerCase());var h=!1;t(document).on("mouseup",function(){h=!1}),t.widget("ui.mouse",{version:"1.12.1",options:{cancel:"input, textarea, button, select, option",distance:1,delay:0},_mouseInit:function(){var e=this;this.element.on("mousedown."+this.widgetName,function(t){return e._mouseDown(t)}).on("click."+this.widgetName,function(i){return!0===t.data(i.target,e.widgetName+".preventClickEvent")?(t.removeData(i.target,e.widgetName+".preventClickEvent"),i.stopImmediatePropagation(),!1):void 0}),this.started=!1},_mouseDestroy:function(){this.element.off("."+this.widgetName),this._mouseMoveDelegate&&this.document.off("mousemove."+this.widgetName,this._mouseMoveDelegate).off("mouseup."+this.widgetName,this._mouseUpDelegate)},_mouseDown:function(e){if(!h){this._mouseMoved=!1,this._mouseStarted&&this._mouseUp(e),this._mouseDownEvent=e;var i=this,s=1===e.which,n="string"==typeof this.options.cancel&&e.target.nodeName?t(e.target).closest(this.options.cancel).length:!1;return s&&!n&&this._mouseCapture(e)?(this.mouseDelayMet=!this.options.delay,this.mouseDelayMet||(this._mouseDelayTimer=setTimeout(function(){i.mouseDelayMet=!0},this.options.delay)),this._mouseDistanceMet(e)&&this._mouseDelayMet(e)&&(this._mouseStarted=this._mouseStart(e)!==!1,!this._mouseStarted)?(e.preventDefault(),!0):(!0===t.data(e.target,this.widgetName+".preventClickEvent")&&t.removeData(e.target,this.widgetName+".preventClickEvent"),this._mouseMoveDelegate=function(t){return i._mouseMove(t)},this._mouseUpDelegate=function(t){return i._mouseUp(t)},this.document.on("mousemove."+this.widgetName,this._mouseMoveDelegate).on("mouseup."+this.widgetName,this._mouseUpDelegate),e.preventDefault(),h=!0,!0)):!0}},_mouseMove:function(e){if(this._mouseMoved){if(t.ui.ie&&(!document.documentMode||9>document.documentMode)&&!e.button)return this._mouseUp(e);if(!e.which)if(e.originalEvent.altKey||e.originalEvent.ctrlKey||e.originalEvent.metaKey||e.originalEvent.shiftKey)this.ignoreMissingWhich=!0;else if(!this.ignoreMissingWhich)return this._mouseUp(e)}return(e.which||e.button)&&(this._mouseMoved=!0),this._mouseStarted?(this._mouseDrag(e),e.preventDefault()):(this._mouseDistanceMet(e)&&this._mouseDelayMet(e)&&(this._mouseStarted=this._mouseStart(this._mouseDownEvent,e)!==!1,this._mouseStarted?this._mouseDrag(e):this._mouseUp(e)),!this._mouseStarted)},_mouseUp:function(e){this.document.off("mousemove."+this.widgetName,this._mouseMoveDelegate).off("mouseup."+this.widgetName,this._mouseUpDelegate),this._mouseStarted&&(this._mouseStarted=!1,e.target===this._mouseDownEvent.target&&t.data(e.target,this.widgetName+".preventClickEvent",!0),this._mouseStop(e)),this._mouseDelayTimer&&(clearTimeout(this._mouseDelayTimer),delete this._mouseDelayTimer),this.ignoreMissingWhich=!1,h=!1,e.preventDefault()},_mouseDistanceMet:function(t){return Math.max(Math.abs(this._mouseDownEvent.pageX-t.pageX),Math.abs(this._mouseDownEvent.pageY-t.pageY))>=this.options.distance},_mouseDelayMet:function(){return this.mouseDelayMet},_mouseStart:function(){},_mouseDrag:function(){},_mouseStop:function(){},_mouseCapture:function(){return!0}}),t.ui.plugin={add:function(e,i,s){var n,o=t.ui[e].prototype;for(n in s)o.plugins[n]=o.plugins[n]||[],o.plugins[n].push([i,s[n]])},call:function(t,e,i,s){var n,o=t.plugins[e];if(o&&(s||t.element[0].parentNode&&11!==t.element[0].parentNode.nodeType))for(n=0;o.length>n;n++)t.options[o[n][0]]&&o[n][1].apply(t.element,i)}},t.ui.safeActiveElement=function(t){var e;try{e=t.activeElement}catch(i){e=t.body}return e||(e=t.body),e.nodeName||(e=t.body),e},t.ui.safeBlur=function(e){e&&"body"!==e.nodeName.toLowerCase()&&t(e).trigger("blur")},t.widget("ui.draggable",t.ui.mouse,{version:"1.12.1",widgetEventPrefix:"drag",options:{addClasses:!0,appendTo:"parent",axis:!1,connectToSortable:!1,containment:!1,cursor:"auto",cursorAt:!1,grid:!1,handle:!1,helper:"original",iframeFix:!1,opacity:!1,refreshPositions:!1,revert:!1,revertDuration:500,scope:"default",scroll:!0,scrollSensitivity:20,scrollSpeed:20,snap:!1,snapMode:"both",snapTolerance:20,stack:!1,zIndex:!1,drag:null,start:null,stop:null},_create:function(){"original"===this.options.helper&&this._setPositionRelative(),this.options.addClasses&&this._addClass("ui-draggable"),this._setHandleClassName(),this._mouseInit()},_setOption:function(t,e){this._super(t,e),"handle"===t&&(this._removeHandleClassName(),this._setHandleClassName())},_destroy:function(){return(this.helper||this.element).is(".ui-draggable-dragging")?(this.destroyOnClear=!0,void 0):(this._removeHandleClassName(),this._mouseDestroy(),void 0)},_mouseCapture:function(e){var i=this.options;return this.helper||i.disabled||t(e.target).closest(".ui-resizable-handle").length>0?!1:(this.handle=this._getHandle(e),this.handle?(this._blurActiveElement(e),this._blockFrames(i.iframeFix===!0?"iframe":i.iframeFix),!0):!1)},_blockFrames:function(e){this.iframeBlocks=this.document.find(e).map(function(){var e=t(this);return t("<div>").css("position","absolute").appendTo(e.parent()).outerWidth(e.outerWidth()).outerHeight(e.outerHeight()).offset(e.offset())[0]})},_unblockFrames:function(){this.iframeBlocks&&(this.iframeBlocks.remove(),delete this.iframeBlocks)},_blurActiveElement:function(e){var i=t.ui.safeActiveElement(this.document[0]),s=t(e.target);s.closest(i).length||t.ui.safeBlur(i)},_mouseStart:function(e){var i=this.options;return this.helper=this._createHelper(e),this._addClass(this.helper,"ui-draggable-dragging"),this._cacheHelperProportions(),t.ui.ddmanager&&(t.ui.ddmanager.current=this),this._cacheMargins(),this.cssPosition=this.helper.css("position"),this.scrollParent=this.helper.scrollParent(!0),this.offsetParent=this.helper.offsetParent(),this.hasFixedAncestor=this.helper.parents().filter(function(){return"fixed"===t(this).css("position")}).length>0,this.positionAbs=this.element.offset(),this._refreshOffsets(e),this.originalPosition=this.position=this._generatePosition(e,!1),this.originalPageX=e.pageX,this.originalPageY=e.pageY,i.cursorAt&&this._adjustOffsetFromHelper(i.cursorAt),this._setContainment(),this._trigger("start",e)===!1?(this._clear(),!1):(this._cacheHelperProportions(),t.ui.ddmanager&&!i.dropBehaviour&&t.ui.ddmanager.prepareOffsets(this,e),this._mouseDrag(e,!0),t.ui.ddmanager&&t.ui.ddmanager.dragStart(this,e),!0)},_refreshOffsets:function(t){this.offset={top:this.positionAbs.top-this.margins.top,left:this.positionAbs.left-this.margins.left,scroll:!1,parent:this._getParentOffset(),relative:this._getRelativeOffset()},this.offset.click={left:t.pageX-this.offset.left,top:t.pageY-this.offset.top}},_mouseDrag:function(e,i){if(this.hasFixedAncestor&&(this.offset.parent=this._getParentOffset()),this.position=this._generatePosition(e,!0),this.positionAbs=this._convertPositionTo("absolute"),!i){var s=this._uiHash();if(this._trigger("drag",e,s)===!1)return this._mouseUp(new t.Event("mouseup",e)),!1;this.position=s.position}return this.helper[0].style.left=this.position.left+"px",this.helper[0].style.top=this.position.top+"px",t.ui.ddmanager&&t.ui.ddmanager.drag(this,e),!1},_mouseStop:function(e){var i=this,s=!1;return t.ui.ddmanager&&!this.options.dropBehaviour&&(s=t.ui.ddmanager.drop(this,e)),this.dropped&&(s=this.dropped,this.dropped=!1),"invalid"===this.options.revert&&!s||"valid"===this.options.revert&&s||this.options.revert===!0||t.isFunction(this.options.revert)&&this.options.revert.call(this.element,s)?t(this.helper).animate(this.originalPosition,parseInt(this.options.revertDuration,10),function(){i._trigger("stop",e)!==!1&&i._clear()}):this._trigger("stop",e)!==!1&&this._clear(),!1},_mouseUp:function(e){return this._unblockFrames(),t.ui.ddmanager&&t.ui.ddmanager.dragStop(this,e),this.handleElement.is(e.target)&&this.element.trigger("focus"),t.ui.mouse.prototype._mouseUp.call(this,e)},cancel:function(){return this.helper.is(".ui-draggable-dragging")?this._mouseUp(new t.Event("mouseup",{target:this.element[0]})):this._clear(),this},_getHandle:function(e){return this.options.handle?!!t(e.target).closest(this.element.find(this.options.handle)).length:!0},_setHandleClassName:function(){this.handleElement=this.options.handle?this.element.find(this.options.handle):this.element,this._addClass(this.handleElement,"ui-draggable-handle")},_removeHandleClassName:function(){this._removeClass(this.handleElement,"ui-draggable-handle")},_createHelper:function(e){var i=this.options,s=t.isFunction(i.helper),n=s?t(i.helper.apply(this.element[0],[e])):"clone"===i.helper?this.element.clone().removeAttr("id"):this.element;return n.parents("body").length||n.appendTo("parent"===i.appendTo?this.element[0].parentNode:i.appendTo),s&&n[0]===this.element[0]&&this._setPositionRelative(),n[0]===this.element[0]||/(fixed|absolute)/.test(n.css("position"))||n.css("position","absolute"),n},_setPositionRelative:function(){/^(?:r|a|f)/.test(this.element.css("position"))||(this.element[0].style.position="relative")},_adjustOffsetFromHelper:function(e){"string"==typeof e&&(e=e.split(" ")),t.isArray(e)&&(e={left:+e[0],top:+e[1]||0}),"left"in e&&(this.offset.click.left=e.left+this.margins.left),"right"in e&&(this.offset.click.left=this.helperProportions.width-e.right+this.margins.left),"top"in e&&(this.offset.click.top=e.top+this.margins.top),"bottom"in e&&(this.offset.click.top=this.helperProportions.height-e.bottom+this.margins.top)},_isRootNode:function(t){return/(html|body)/i.test(t.tagName)||t===this.document[0]},_getParentOffset:function(){var e=this.offsetParent.offset(),i=this.document[0];return"absolute"===this.cssPosition&&this.scrollParent[0]!==i&&t.contains(this.scrollParent[0],this.offsetParent[0])&&(e.left+=this.scrollParent.scrollLeft(),e.top+=this.scrollParent.scrollTop()),this._isRootNode(this.offsetParent[0])&&(e={top:0,left:0}),{top:e.top+(parseInt(this.offsetParent.css("borderTopWidth"),10)||0),left:e.left+(parseInt(this.offsetParent.css("borderLeftWidth"),10)||0)}},_getRelativeOffset:function(){if("relative"!==this.cssPosition)return{top:0,left:0};var t=this.element.position(),e=this._isRootNode(this.scrollParent[0]);return{top:t.top-(parseInt(this.helper.css("top"),10)||0)+(e?0:this.scrollParent.scrollTop()),left:t.left-(parseInt(this.helper.css("left"),10)||0)+(e?0:this.scrollParent.scrollLeft())}},_cacheMargins:function(){this.margins={left:parseInt(this.element.css("marginLeft"),10)||0,top:parseInt(this.element.css("marginTop"),10)||0,right:parseInt(this.element.css("marginRight"),10)||0,bottom:parseInt(this.element.css("marginBottom"),10)||0}},_cacheHelperProportions:function(){this.helperProportions={width:this.helper.outerWidth(),height:this.helper.outerHeight()}},_setContainment:function(){var e,i,s,n=this.options,o=this.document[0];return this.relativeContainer=null,n.containment?"window"===n.containment?(this.containment=[t(window).scrollLeft()-this.offset.relative.left-this.offset.parent.left,t(window).scrollTop()-this.offset.relative.top-this.offset.parent.top,t(window).scrollLeft()+t(window).width()-this.helperProportions.width-this.margins.left,t(window).scrollTop()+(t(window).height()||o.body.parentNode.scrollHeight)-this.helperProportions.height-this.margins.top],void 0):"document"===n.containment?(this.containment=[0,0,t(o).width()-this.helperProportions.width-this.margins.left,(t(o).height()||o.body.parentNode.scrollHeight)-this.helperProportions.height-this.margins.top],void 0):n.containment.constructor===Array?(this.containment=n.containment,void 0):("parent"===n.containment&&(n.containment=this.helper[0].parentNode),i=t(n.containment),s=i[0],s&&(e=/(scroll|auto)/.test(i.css("overflow")),this.containment=[(parseInt(i.css("borderLeftWidth"),10)||0)+(parseInt(i.css("paddingLeft"),10)||0),(parseInt(i.css("borderTopWidth"),10)||0)+(parseInt(i.css("paddingTop"),10)||0),(e?Math.max(s.scrollWidth,s.offsetWidth):s.offsetWidth)-(parseInt(i.css("borderRightWidth"),10)||0)-(parseInt(i.css("paddingRight"),10)||0)-this.helperProportions.width-this.margins.left-this.margins.right,(e?Math.max(s.scrollHeight,s.offsetHeight):s.offsetHeight)-(parseInt(i.css("borderBottomWidth"),10)||0)-(parseInt(i.css("paddingBottom"),10)||0)-this.helperProportions.height-this.margins.top-this.margins.bottom],this.relativeContainer=i),void 0):(this.containment=null,void 0)
},_convertPositionTo:function(t,e){e||(e=this.position);var i="absolute"===t?1:-1,s=this._isRootNode(this.scrollParent[0]);return{top:e.top+this.offset.relative.top*i+this.offset.parent.top*i-("fixed"===this.cssPosition?-this.offset.scroll.top:s?0:this.offset.scroll.top)*i,left:e.left+this.offset.relative.left*i+this.offset.parent.left*i-("fixed"===this.cssPosition?-this.offset.scroll.left:s?0:this.offset.scroll.left)*i}},_generatePosition:function(t,e){var i,s,n,o,a=this.options,r=this._isRootNode(this.scrollParent[0]),l=t.pageX,h=t.pageY;return r&&this.offset.scroll||(this.offset.scroll={top:this.scrollParent.scrollTop(),left:this.scrollParent.scrollLeft()}),e&&(this.containment&&(this.relativeContainer?(s=this.relativeContainer.offset(),i=[this.containment[0]+s.left,this.containment[1]+s.top,this.containment[2]+s.left,this.containment[3]+s.top]):i=this.containment,t.pageX-this.offset.click.left<i[0]&&(l=i[0]+this.offset.click.left),t.pageY-this.offset.click.top<i[1]&&(h=i[1]+this.offset.click.top),t.pageX-this.offset.click.left>i[2]&&(l=i[2]+this.offset.click.left),t.pageY-this.offset.click.top>i[3]&&(h=i[3]+this.offset.click.top)),a.grid&&(n=a.grid[1]?this.originalPageY+Math.round((h-this.originalPageY)/a.grid[1])*a.grid[1]:this.originalPageY,h=i?n-this.offset.click.top>=i[1]||n-this.offset.click.top>i[3]?n:n-this.offset.click.top>=i[1]?n-a.grid[1]:n+a.grid[1]:n,o=a.grid[0]?this.originalPageX+Math.round((l-this.originalPageX)/a.grid[0])*a.grid[0]:this.originalPageX,l=i?o-this.offset.click.left>=i[0]||o-this.offset.click.left>i[2]?o:o-this.offset.click.left>=i[0]?o-a.grid[0]:o+a.grid[0]:o),"y"===a.axis&&(l=this.originalPageX),"x"===a.axis&&(h=this.originalPageY)),{top:h-this.offset.click.top-this.offset.relative.top-this.offset.parent.top+("fixed"===this.cssPosition?-this.offset.scroll.top:r?0:this.offset.scroll.top),left:l-this.offset.click.left-this.offset.relative.left-this.offset.parent.left+("fixed"===this.cssPosition?-this.offset.scroll.left:r?0:this.offset.scroll.left)}},_clear:function(){this._removeClass(this.helper,"ui-draggable-dragging"),this.helper[0]===this.element[0]||this.cancelHelperRemoval||this.helper.remove(),this.helper=null,this.cancelHelperRemoval=!1,this.destroyOnClear&&this.destroy()},_trigger:function(e,i,s){return s=s||this._uiHash(),t.ui.plugin.call(this,e,[i,s,this],!0),/^(drag|start|stop)/.test(e)&&(this.positionAbs=this._convertPositionTo("absolute"),s.offset=this.positionAbs),t.Widget.prototype._trigger.call(this,e,i,s)},plugins:{},_uiHash:function(){return{helper:this.helper,position:this.position,originalPosition:this.originalPosition,offset:this.positionAbs}}}),t.ui.plugin.add("draggable","connectToSortable",{start:function(e,i,s){var n=t.extend({},i,{item:s.element});s.sortables=[],t(s.options.connectToSortable).each(function(){var i=t(this).sortable("instance");i&&!i.options.disabled&&(s.sortables.push(i),i.refreshPositions(),i._trigger("activate",e,n))})},stop:function(e,i,s){var n=t.extend({},i,{item:s.element});s.cancelHelperRemoval=!1,t.each(s.sortables,function(){var t=this;t.isOver?(t.isOver=0,s.cancelHelperRemoval=!0,t.cancelHelperRemoval=!1,t._storedCSS={position:t.placeholder.css("position"),top:t.placeholder.css("top"),left:t.placeholder.css("left")},t._mouseStop(e),t.options.helper=t.options._helper):(t.cancelHelperRemoval=!0,t._trigger("deactivate",e,n))})},drag:function(e,i,s){t.each(s.sortables,function(){var n=!1,o=this;o.positionAbs=s.positionAbs,o.helperProportions=s.helperProportions,o.offset.click=s.offset.click,o._intersectsWith(o.containerCache)&&(n=!0,t.each(s.sortables,function(){return this.positionAbs=s.positionAbs,this.helperProportions=s.helperProportions,this.offset.click=s.offset.click,this!==o&&this._intersectsWith(this.containerCache)&&t.contains(o.element[0],this.element[0])&&(n=!1),n})),n?(o.isOver||(o.isOver=1,s._parent=i.helper.parent(),o.currentItem=i.helper.appendTo(o.element).data("ui-sortable-item",!0),o.options._helper=o.options.helper,o.options.helper=function(){return i.helper[0]},e.target=o.currentItem[0],o._mouseCapture(e,!0),o._mouseStart(e,!0,!0),o.offset.click.top=s.offset.click.top,o.offset.click.left=s.offset.click.left,o.offset.parent.left-=s.offset.parent.left-o.offset.parent.left,o.offset.parent.top-=s.offset.parent.top-o.offset.parent.top,s._trigger("toSortable",e),s.dropped=o.element,t.each(s.sortables,function(){this.refreshPositions()}),s.currentItem=s.element,o.fromOutside=s),o.currentItem&&(o._mouseDrag(e),i.position=o.position)):o.isOver&&(o.isOver=0,o.cancelHelperRemoval=!0,o.options._revert=o.options.revert,o.options.revert=!1,o._trigger("out",e,o._uiHash(o)),o._mouseStop(e,!0),o.options.revert=o.options._revert,o.options.helper=o.options._helper,o.placeholder&&o.placeholder.remove(),i.helper.appendTo(s._parent),s._refreshOffsets(e),i.position=s._generatePosition(e,!0),s._trigger("fromSortable",e),s.dropped=!1,t.each(s.sortables,function(){this.refreshPositions()}))})}}),t.ui.plugin.add("draggable","cursor",{start:function(e,i,s){var n=t("body"),o=s.options;n.css("cursor")&&(o._cursor=n.css("cursor")),n.css("cursor",o.cursor)},stop:function(e,i,s){var n=s.options;n._cursor&&t("body").css("cursor",n._cursor)}}),t.ui.plugin.add("draggable","opacity",{start:function(e,i,s){var n=t(i.helper),o=s.options;n.css("opacity")&&(o._opacity=n.css("opacity")),n.css("opacity",o.opacity)},stop:function(e,i,s){var n=s.options;n._opacity&&t(i.helper).css("opacity",n._opacity)}}),t.ui.plugin.add("draggable","scroll",{start:function(t,e,i){i.scrollParentNotHidden||(i.scrollParentNotHidden=i.helper.scrollParent(!1)),i.scrollParentNotHidden[0]!==i.document[0]&&"HTML"!==i.scrollParentNotHidden[0].tagName&&(i.overflowOffset=i.scrollParentNotHidden.offset())},drag:function(e,i,s){var n=s.options,o=!1,a=s.scrollParentNotHidden[0],r=s.document[0];a!==r&&"HTML"!==a.tagName?(n.axis&&"x"===n.axis||(s.overflowOffset.top+a.offsetHeight-e.pageY<n.scrollSensitivity?a.scrollTop=o=a.scrollTop+n.scrollSpeed:e.pageY-s.overflowOffset.top<n.scrollSensitivity&&(a.scrollTop=o=a.scrollTop-n.scrollSpeed)),n.axis&&"y"===n.axis||(s.overflowOffset.left+a.offsetWidth-e.pageX<n.scrollSensitivity?a.scrollLeft=o=a.scrollLeft+n.scrollSpeed:e.pageX-s.overflowOffset.left<n.scrollSensitivity&&(a.scrollLeft=o=a.scrollLeft-n.scrollSpeed))):(n.axis&&"x"===n.axis||(e.pageY-t(r).scrollTop()<n.scrollSensitivity?o=t(r).scrollTop(t(r).scrollTop()-n.scrollSpeed):t(window).height()-(e.pageY-t(r).scrollTop())<n.scrollSensitivity&&(o=t(r).scrollTop(t(r).scrollTop()+n.scrollSpeed))),n.axis&&"y"===n.axis||(e.pageX-t(r).scrollLeft()<n.scrollSensitivity?o=t(r).scrollLeft(t(r).scrollLeft()-n.scrollSpeed):t(window).width()-(e.pageX-t(r).scrollLeft())<n.scrollSensitivity&&(o=t(r).scrollLeft(t(r).scrollLeft()+n.scrollSpeed)))),o!==!1&&t.ui.ddmanager&&!n.dropBehaviour&&t.ui.ddmanager.prepareOffsets(s,e)}}),t.ui.plugin.add("draggable","snap",{start:function(e,i,s){var n=s.options;s.snapElements=[],t(n.snap.constructor!==String?n.snap.items||":data(ui-draggable)":n.snap).each(function(){var e=t(this),i=e.offset();this!==s.element[0]&&s.snapElements.push({item:this,width:e.outerWidth(),height:e.outerHeight(),top:i.top,left:i.left})})},drag:function(e,i,s){var n,o,a,r,l,h,c,u,d,p,f=s.options,g=f.snapTolerance,m=i.offset.left,_=m+s.helperProportions.width,v=i.offset.top,b=v+s.helperProportions.height;for(d=s.snapElements.length-1;d>=0;d--)l=s.snapElements[d].left-s.margins.left,h=l+s.snapElements[d].width,c=s.snapElements[d].top-s.margins.top,u=c+s.snapElements[d].height,l-g>_||m>h+g||c-g>b||v>u+g||!t.contains(s.snapElements[d].item.ownerDocument,s.snapElements[d].item)?(s.snapElements[d].snapping&&s.options.snap.release&&s.options.snap.release.call(s.element,e,t.extend(s._uiHash(),{snapItem:s.snapElements[d].item})),s.snapElements[d].snapping=!1):("inner"!==f.snapMode&&(n=g>=Math.abs(c-b),o=g>=Math.abs(u-v),a=g>=Math.abs(l-_),r=g>=Math.abs(h-m),n&&(i.position.top=s._convertPositionTo("relative",{top:c-s.helperProportions.height,left:0}).top),o&&(i.position.top=s._convertPositionTo("relative",{top:u,left:0}).top),a&&(i.position.left=s._convertPositionTo("relative",{top:0,left:l-s.helperProportions.width}).left),r&&(i.position.left=s._convertPositionTo("relative",{top:0,left:h}).left)),p=n||o||a||r,"outer"!==f.snapMode&&(n=g>=Math.abs(c-v),o=g>=Math.abs(u-b),a=g>=Math.abs(l-m),r=g>=Math.abs(h-_),n&&(i.position.top=s._convertPositionTo("relative",{top:c,left:0}).top),o&&(i.position.top=s._convertPositionTo("relative",{top:u-s.helperProportions.height,left:0}).top),a&&(i.position.left=s._convertPositionTo("relative",{top:0,left:l}).left),r&&(i.position.left=s._convertPositionTo("relative",{top:0,left:h-s.helperProportions.width}).left)),!s.snapElements[d].snapping&&(n||o||a||r||p)&&s.options.snap.snap&&s.options.snap.snap.call(s.element,e,t.extend(s._uiHash(),{snapItem:s.snapElements[d].item})),s.snapElements[d].snapping=n||o||a||r||p)}}),t.ui.plugin.add("draggable","stack",{start:function(e,i,s){var n,o=s.options,a=t.makeArray(t(o.stack)).sort(function(e,i){return(parseInt(t(e).css("zIndex"),10)||0)-(parseInt(t(i).css("zIndex"),10)||0)});a.length&&(n=parseInt(t(a[0]).css("zIndex"),10)||0,t(a).each(function(e){t(this).css("zIndex",n+e)}),this.css("zIndex",n+a.length))}}),t.ui.plugin.add("draggable","zIndex",{start:function(e,i,s){var n=t(i.helper),o=s.options;n.css("zIndex")&&(o._zIndex=n.css("zIndex")),n.css("zIndex",o.zIndex)},stop:function(e,i,s){var n=s.options;n._zIndex&&t(i.helper).css("zIndex",n._zIndex)}}),t.ui.draggable,t.widget("ui.resizable",t.ui.mouse,{version:"1.12.1",widgetEventPrefix:"resize",options:{alsoResize:!1,animate:!1,animateDuration:"slow",animateEasing:"swing",aspectRatio:!1,autoHide:!1,classes:{"ui-resizable-se":"ui-icon ui-icon-gripsmall-diagonal-se"},containment:!1,ghost:!1,grid:!1,handles:"e,s,se",helper:!1,maxHeight:null,maxWidth:null,minHeight:10,minWidth:10,zIndex:90,resize:null,start:null,stop:null},_num:function(t){return parseFloat(t)||0},_isNumber:function(t){return!isNaN(parseFloat(t))},_hasScroll:function(e,i){if("hidden"===t(e).css("overflow"))return!1;var s=i&&"left"===i?"scrollLeft":"scrollTop",n=!1;return e[s]>0?!0:(e[s]=1,n=e[s]>0,e[s]=0,n)},_create:function(){var e,i=this.options,s=this;this._addClass("ui-resizable"),t.extend(this,{_aspectRatio:!!i.aspectRatio,aspectRatio:i.aspectRatio,originalElement:this.element,_proportionallyResizeElements:[],_helper:i.helper||i.ghost||i.animate?i.helper||"ui-resizable-helper":null}),this.element[0].nodeName.match(/^(canvas|textarea|input|select|button|img)$/i)&&(this.element.wrap(t("<div class='ui-wrapper' style='overflow: hidden;'></div>").css({position:this.element.css("position"),width:this.element.outerWidth(),height:this.element.outerHeight(),top:this.element.css("top"),left:this.element.css("left")})),this.element=this.element.parent().data("ui-resizable",this.element.resizable("instance")),this.elementIsWrapper=!0,e={marginTop:this.originalElement.css("marginTop"),marginRight:this.originalElement.css("marginRight"),marginBottom:this.originalElement.css("marginBottom"),marginLeft:this.originalElement.css("marginLeft")},this.element.css(e),this.originalElement.css("margin",0),this.originalResizeStyle=this.originalElement.css("resize"),this.originalElement.css("resize","none"),this._proportionallyResizeElements.push(this.originalElement.css({position:"static",zoom:1,display:"block"})),this.originalElement.css(e),this._proportionallyResize()),this._setupHandles(),i.autoHide&&t(this.element).on("mouseenter",function(){i.disabled||(s._removeClass("ui-resizable-autohide"),s._handles.show())}).on("mouseleave",function(){i.disabled||s.resizing||(s._addClass("ui-resizable-autohide"),s._handles.hide())}),this._mouseInit()},_destroy:function(){this._mouseDestroy();var e,i=function(e){t(e).removeData("resizable").removeData("ui-resizable").off(".resizable").find(".ui-resizable-handle").remove()};return this.elementIsWrapper&&(i(this.element),e=this.element,this.originalElement.css({position:e.css("position"),width:e.outerWidth(),height:e.outerHeight(),top:e.css("top"),left:e.css("left")}).insertAfter(e),e.remove()),this.originalElement.css("resize",this.originalResizeStyle),i(this.originalElement),this},_setOption:function(t,e){switch(this._super(t,e),t){case"handles":this._removeHandles(),this._setupHandles();break;default:}},_setupHandles:function(){var e,i,s,n,o,a=this.options,r=this;if(this.handles=a.handles||(t(".ui-resizable-handle",this.element).length?{n:".ui-resizable-n",e:".ui-resizable-e",s:".ui-resizable-s",w:".ui-resizable-w",se:".ui-resizable-se",sw:".ui-resizable-sw",ne:".ui-resizable-ne",nw:".ui-resizable-nw"}:"e,s,se"),this._handles=t(),this.handles.constructor===String)for("all"===this.handles&&(this.handles="n,e,s,w,se,sw,ne,nw"),s=this.handles.split(","),this.handles={},i=0;s.length>i;i++)e=t.trim(s[i]),n="ui-resizable-"+e,o=t("<div>"),this._addClass(o,"ui-resizable-handle "+n),o.css({zIndex:a.zIndex}),this.handles[e]=".ui-resizable-"+e,this.element.append(o);this._renderAxis=function(e){var i,s,n,o;e=e||this.element;for(i in this.handles)this.handles[i].constructor===String?this.handles[i]=this.element.children(this.handles[i]).first().show():(this.handles[i].jquery||this.handles[i].nodeType)&&(this.handles[i]=t(this.handles[i]),this._on(this.handles[i],{mousedown:r._mouseDown})),this.elementIsWrapper&&this.originalElement[0].nodeName.match(/^(textarea|input|select|button)$/i)&&(s=t(this.handles[i],this.element),o=/sw|ne|nw|se|n|s/.test(i)?s.outerHeight():s.outerWidth(),n=["padding",/ne|nw|n/.test(i)?"Top":/se|sw|s/.test(i)?"Bottom":/^e$/.test(i)?"Right":"Left"].join(""),e.css(n,o),this._proportionallyResize()),this._handles=this._handles.add(this.handles[i])},this._renderAxis(this.element),this._handles=this._handles.add(this.element.find(".ui-resizable-handle")),this._handles.disableSelection(),this._handles.on("mouseover",function(){r.resizing||(this.className&&(o=this.className.match(/ui-resizable-(se|sw|ne|nw|n|e|s|w)/i)),r.axis=o&&o[1]?o[1]:"se")}),a.autoHide&&(this._handles.hide(),this._addClass("ui-resizable-autohide"))},_removeHandles:function(){this._handles.remove()},_mouseCapture:function(e){var i,s,n=!1;for(i in this.handles)s=t(this.handles[i])[0],(s===e.target||t.contains(s,e.target))&&(n=!0);return!this.options.disabled&&n},_mouseStart:function(e){var i,s,n,o=this.options,a=this.element;return this.resizing=!0,this._renderProxy(),i=this._num(this.helper.css("left")),s=this._num(this.helper.css("top")),o.containment&&(i+=t(o.containment).scrollLeft()||0,s+=t(o.containment).scrollTop()||0),this.offset=this.helper.offset(),this.position={left:i,top:s},this.size=this._helper?{width:this.helper.width(),height:this.helper.height()}:{width:a.width(),height:a.height()},this.originalSize=this._helper?{width:a.outerWidth(),height:a.outerHeight()}:{width:a.width(),height:a.height()},this.sizeDiff={width:a.outerWidth()-a.width(),height:a.outerHeight()-a.height()},this.originalPosition={left:i,top:s},this.originalMousePosition={left:e.pageX,top:e.pageY},this.aspectRatio="number"==typeof o.aspectRatio?o.aspectRatio:this.originalSize.width/this.originalSize.height||1,n=t(".ui-resizable-"+this.axis).css("cursor"),t("body").css("cursor","auto"===n?this.axis+"-resize":n),this._addClass("ui-resizable-resizing"),this._propagate("start",e),!0},_mouseDrag:function(e){var i,s,n=this.originalMousePosition,o=this.axis,a=e.pageX-n.left||0,r=e.pageY-n.top||0,l=this._change[o];return this._updatePrevProperties(),l?(i=l.apply(this,[e,a,r]),this._updateVirtualBoundaries(e.shiftKey),(this._aspectRatio||e.shiftKey)&&(i=this._updateRatio(i,e)),i=this._respectSize(i,e),this._updateCache(i),this._propagate("resize",e),s=this._applyChanges(),!this._helper&&this._proportionallyResizeElements.length&&this._proportionallyResize(),t.isEmptyObject(s)||(this._updatePrevProperties(),this._trigger("resize",e,this.ui()),this._applyChanges()),!1):!1},_mouseStop:function(e){this.resizing=!1;var i,s,n,o,a,r,l,h=this.options,c=this;return this._helper&&(i=this._proportionallyResizeElements,s=i.length&&/textarea/i.test(i[0].nodeName),n=s&&this._hasScroll(i[0],"left")?0:c.sizeDiff.height,o=s?0:c.sizeDiff.width,a={width:c.helper.width()-o,height:c.helper.height()-n},r=parseFloat(c.element.css("left"))+(c.position.left-c.originalPosition.left)||null,l=parseFloat(c.element.css("top"))+(c.position.top-c.originalPosition.top)||null,h.animate||this.element.css(t.extend(a,{top:l,left:r})),c.helper.height(c.size.height),c.helper.width(c.size.width),this._helper&&!h.animate&&this._proportionallyResize()),t("body").css("cursor","auto"),this._removeClass("ui-resizable-resizing"),this._propagate("stop",e),this._helper&&this.helper.remove(),!1},_updatePrevProperties:function(){this.prevPosition={top:this.position.top,left:this.position.left},this.prevSize={width:this.size.width,height:this.size.height}},_applyChanges:function(){var t={};return this.position.top!==this.prevPosition.top&&(t.top=this.position.top+"px"),this.position.left!==this.prevPosition.left&&(t.left=this.position.left+"px"),this.size.width!==this.prevSize.width&&(t.width=this.size.width+"px"),this.size.height!==this.prevSize.height&&(t.height=this.size.height+"px"),this.helper.css(t),t},_updateVirtualBoundaries:function(t){var e,i,s,n,o,a=this.options;o={minWidth:this._isNumber(a.minWidth)?a.minWidth:0,maxWidth:this._isNumber(a.maxWidth)?a.maxWidth:1/0,minHeight:this._isNumber(a.minHeight)?a.minHeight:0,maxHeight:this._isNumber(a.maxHeight)?a.maxHeight:1/0},(this._aspectRatio||t)&&(e=o.minHeight*this.aspectRatio,s=o.minWidth/this.aspectRatio,i=o.maxHeight*this.aspectRatio,n=o.maxWidth/this.aspectRatio,e>o.minWidth&&(o.minWidth=e),s>o.minHeight&&(o.minHeight=s),o.maxWidth>i&&(o.maxWidth=i),o.maxHeight>n&&(o.maxHeight=n)),this._vBoundaries=o},_updateCache:function(t){this.offset=this.helper.offset(),this._isNumber(t.left)&&(this.position.left=t.left),this._isNumber(t.top)&&(this.position.top=t.top),this._isNumber(t.height)&&(this.size.height=t.height),this._isNumber(t.width)&&(this.size.width=t.width)},_updateRatio:function(t){var e=this.position,i=this.size,s=this.axis;return this._isNumber(t.height)?t.width=t.height*this.aspectRatio:this._isNumber(t.width)&&(t.height=t.width/this.aspectRatio),"sw"===s&&(t.left=e.left+(i.width-t.width),t.top=null),"nw"===s&&(t.top=e.top+(i.height-t.height),t.left=e.left+(i.width-t.width)),t},_respectSize:function(t){var e=this._vBoundaries,i=this.axis,s=this._isNumber(t.width)&&e.maxWidth&&e.maxWidth<t.width,n=this._isNumber(t.height)&&e.maxHeight&&e.maxHeight<t.height,o=this._isNumber(t.width)&&e.minWidth&&e.minWidth>t.width,a=this._isNumber(t.height)&&e.minHeight&&e.minHeight>t.height,r=this.originalPosition.left+this.originalSize.width,l=this.originalPosition.top+this.originalSize.height,h=/sw|nw|w/.test(i),c=/nw|ne|n/.test(i);return o&&(t.width=e.minWidth),a&&(t.height=e.minHeight),s&&(t.width=e.maxWidth),n&&(t.height=e.maxHeight),o&&h&&(t.left=r-e.minWidth),s&&h&&(t.left=r-e.maxWidth),a&&c&&(t.top=l-e.minHeight),n&&c&&(t.top=l-e.maxHeight),t.width||t.height||t.left||!t.top?t.width||t.height||t.top||!t.left||(t.left=null):t.top=null,t},_getPaddingPlusBorderDimensions:function(t){for(var e=0,i=[],s=[t.css("borderTopWidth"),t.css("borderRightWidth"),t.css("borderBottomWidth"),t.css("borderLeftWidth")],n=[t.css("paddingTop"),t.css("paddingRight"),t.css("paddingBottom"),t.css("paddingLeft")];4>e;e++)i[e]=parseFloat(s[e])||0,i[e]+=parseFloat(n[e])||0;return{height:i[0]+i[2],width:i[1]+i[3]}},_proportionallyResize:function(){if(this._proportionallyResizeElements.length)for(var t,e=0,i=this.helper||this.element;this._proportionallyResizeElements.length>e;e++)t=this._proportionallyResizeElements[e],this.outerDimensions||(this.outerDimensions=this._getPaddingPlusBorderDimensions(t)),t.css({height:i.height()-this.outerDimensions.height||0,width:i.width()-this.outerDimensions.width||0})},_renderProxy:function(){var e=this.element,i=this.options;this.elementOffset=e.offset(),this._helper?(this.helper=this.helper||t("<div style='overflow:hidden;'></div>"),this._addClass(this.helper,this._helper),this.helper.css({width:this.element.outerWidth(),height:this.element.outerHeight(),position:"absolute",left:this.elementOffset.left+"px",top:this.elementOffset.top+"px",zIndex:++i.zIndex}),this.helper.appendTo("body").disableSelection()):this.helper=this.element},_change:{e:function(t,e){return{width:this.originalSize.width+e}},w:function(t,e){var i=this.originalSize,s=this.originalPosition;return{left:s.left+e,width:i.width-e}},n:function(t,e,i){var s=this.originalSize,n=this.originalPosition;return{top:n.top+i,height:s.height-i}},s:function(t,e,i){return{height:this.originalSize.height+i}},se:function(e,i,s){return t.extend(this._change.s.apply(this,arguments),this._change.e.apply(this,[e,i,s]))},sw:function(e,i,s){return t.extend(this._change.s.apply(this,arguments),this._change.w.apply(this,[e,i,s]))},ne:function(e,i,s){return t.extend(this._change.n.apply(this,arguments),this._change.e.apply(this,[e,i,s]))},nw:function(e,i,s){return t.extend(this._change.n.apply(this,arguments),this._change.w.apply(this,[e,i,s]))}},_propagate:function(e,i){t.ui.plugin.call(this,e,[i,this.ui()]),"resize"!==e&&this._trigger(e,i,this.ui())},plugins:{},ui:function(){return{originalElement:this.originalElement,element:this.element,helper:this.helper,position:this.position,size:this.size,originalSize:this.originalSize,originalPosition:this.originalPosition}}}),t.ui.plugin.add("resizable","animate",{stop:function(e){var i=t(this).resizable("instance"),s=i.options,n=i._proportionallyResizeElements,o=n.length&&/textarea/i.test(n[0].nodeName),a=o&&i._hasScroll(n[0],"left")?0:i.sizeDiff.height,r=o?0:i.sizeDiff.width,l={width:i.size.width-r,height:i.size.height-a},h=parseFloat(i.element.css("left"))+(i.position.left-i.originalPosition.left)||null,c=parseFloat(i.element.css("top"))+(i.position.top-i.originalPosition.top)||null;i.element.animate(t.extend(l,c&&h?{top:c,left:h}:{}),{duration:s.animateDuration,easing:s.animateEasing,step:function(){var s={width:parseFloat(i.element.css("width")),height:parseFloat(i.element.css("height")),top:parseFloat(i.element.css("top")),left:parseFloat(i.element.css("left"))};n&&n.length&&t(n[0]).css({width:s.width,height:s.height}),i._updateCache(s),i._propagate("resize",e)}})}}),t.ui.plugin.add("resizable","containment",{start:function(){var e,i,s,n,o,a,r,l=t(this).resizable("instance"),h=l.options,c=l.element,u=h.containment,d=u instanceof t?u.get(0):/parent/.test(u)?c.parent().get(0):u;d&&(l.containerElement=t(d),/document/.test(u)||u===document?(l.containerOffset={left:0,top:0},l.containerPosition={left:0,top:0},l.parentData={element:t(document),left:0,top:0,width:t(document).width(),height:t(document).height()||document.body.parentNode.scrollHeight}):(e=t(d),i=[],t(["Top","Right","Left","Bottom"]).each(function(t,s){i[t]=l._num(e.css("padding"+s))}),l.containerOffset=e.offset(),l.containerPosition=e.position(),l.containerSize={height:e.innerHeight()-i[3],width:e.innerWidth()-i[1]},s=l.containerOffset,n=l.containerSize.height,o=l.containerSize.width,a=l._hasScroll(d,"left")?d.scrollWidth:o,r=l._hasScroll(d)?d.scrollHeight:n,l.parentData={element:d,left:s.left,top:s.top,width:a,height:r}))},resize:function(e){var i,s,n,o,a=t(this).resizable("instance"),r=a.options,l=a.containerOffset,h=a.position,c=a._aspectRatio||e.shiftKey,u={top:0,left:0},d=a.containerElement,p=!0;d[0]!==document&&/static/.test(d.css("position"))&&(u=l),h.left<(a._helper?l.left:0)&&(a.size.width=a.size.width+(a._helper?a.position.left-l.left:a.position.left-u.left),c&&(a.size.height=a.size.width/a.aspectRatio,p=!1),a.position.left=r.helper?l.left:0),h.top<(a._helper?l.top:0)&&(a.size.height=a.size.height+(a._helper?a.position.top-l.top:a.position.top),c&&(a.size.width=a.size.height*a.aspectRatio,p=!1),a.position.top=a._helper?l.top:0),n=a.containerElement.get(0)===a.element.parent().get(0),o=/relative|absolute/.test(a.containerElement.css("position")),n&&o?(a.offset.left=a.parentData.left+a.position.left,a.offset.top=a.parentData.top+a.position.top):(a.offset.left=a.element.offset().left,a.offset.top=a.element.offset().top),i=Math.abs(a.sizeDiff.width+(a._helper?a.offset.left-u.left:a.offset.left-l.left)),s=Math.abs(a.sizeDiff.height+(a._helper?a.offset.top-u.top:a.offset.top-l.top)),i+a.size.width>=a.parentData.width&&(a.size.width=a.parentData.width-i,c&&(a.size.height=a.size.width/a.aspectRatio,p=!1)),s+a.size.height>=a.parentData.height&&(a.size.height=a.parentData.height-s,c&&(a.size.width=a.size.height*a.aspectRatio,p=!1)),p||(a.position.left=a.prevPosition.left,a.position.top=a.prevPosition.top,a.size.width=a.prevSize.width,a.size.height=a.prevSize.height)},stop:function(){var e=t(this).resizable("instance"),i=e.options,s=e.containerOffset,n=e.containerPosition,o=e.containerElement,a=t(e.helper),r=a.offset(),l=a.outerWidth()-e.sizeDiff.width,h=a.outerHeight()-e.sizeDiff.height;e._helper&&!i.animate&&/relative/.test(o.css("position"))&&t(this).css({left:r.left-n.left-s.left,width:l,height:h}),e._helper&&!i.animate&&/static/.test(o.css("position"))&&t(this).css({left:r.left-n.left-s.left,width:l,height:h})}}),t.ui.plugin.add("resizable","alsoResize",{start:function(){var e=t(this).resizable("instance"),i=e.options;t(i.alsoResize).each(function(){var e=t(this);e.data("ui-resizable-alsoresize",{width:parseFloat(e.width()),height:parseFloat(e.height()),left:parseFloat(e.css("left")),top:parseFloat(e.css("top"))})})},resize:function(e,i){var s=t(this).resizable("instance"),n=s.options,o=s.originalSize,a=s.originalPosition,r={height:s.size.height-o.height||0,width:s.size.width-o.width||0,top:s.position.top-a.top||0,left:s.position.left-a.left||0};t(n.alsoResize).each(function(){var e=t(this),s=t(this).data("ui-resizable-alsoresize"),n={},o=e.parents(i.originalElement[0]).length?["width","height"]:["width","height","top","left"];t.each(o,function(t,e){var i=(s[e]||0)+(r[e]||0);i&&i>=0&&(n[e]=i||null)}),e.css(n)})},stop:function(){t(this).removeData("ui-resizable-alsoresize")}}),t.ui.plugin.add("resizable","ghost",{start:function(){var e=t(this).resizable("instance"),i=e.size;e.ghost=e.originalElement.clone(),e.ghost.css({opacity:.25,display:"block",position:"relative",height:i.height,width:i.width,margin:0,left:0,top:0}),e._addClass(e.ghost,"ui-resizable-ghost"),t.uiBackCompat!==!1&&"string"==typeof e.options.ghost&&e.ghost.addClass(this.options.ghost),e.ghost.appendTo(e.helper)},resize:function(){var e=t(this).resizable("instance");e.ghost&&e.ghost.css({position:"relative",height:e.size.height,width:e.size.width})},stop:function(){var e=t(this).resizable("instance");e.ghost&&e.helper&&e.helper.get(0).removeChild(e.ghost.get(0))}}),t.ui.plugin.add("resizable","grid",{resize:function(){var e,i=t(this).resizable("instance"),s=i.options,n=i.size,o=i.originalSize,a=i.originalPosition,r=i.axis,l="number"==typeof s.grid?[s.grid,s.grid]:s.grid,h=l[0]||1,c=l[1]||1,u=Math.round((n.width-o.width)/h)*h,d=Math.round((n.height-o.height)/c)*c,p=o.width+u,f=o.height+d,g=s.maxWidth&&p>s.maxWidth,m=s.maxHeight&&f>s.maxHeight,_=s.minWidth&&s.minWidth>p,v=s.minHeight&&s.minHeight>f;s.grid=l,_&&(p+=h),v&&(f+=c),g&&(p-=h),m&&(f-=c),/^(se|s|e)$/.test(r)?(i.size.width=p,i.size.height=f):/^(ne)$/.test(r)?(i.size.width=p,i.size.height=f,i.position.top=a.top-d):/^(sw)$/.test(r)?(i.size.width=p,i.size.height=f,i.position.left=a.left-u):((0>=f-c||0>=p-h)&&(e=i._getPaddingPlusBorderDimensions(this)),f-c>0?(i.size.height=f,i.position.top=a.top-d):(f=c-e.height,i.size.height=f,i.position.top=a.top+o.height-f),p-h>0?(i.size.width=p,i.position.left=a.left-u):(p=h-e.width,i.size.width=p,i.position.left=a.left+o.width-p))}}),t.ui.resizable,t.widget("ui.accordion",{version:"1.12.1",options:{active:0,animate:{},classes:{"ui-accordion-header":"ui-corner-top","ui-accordion-header-collapsed":"ui-corner-all","ui-accordion-content":"ui-corner-bottom"},collapsible:!1,event:"click",header:"> li > :first-child, > :not(li):even",heightStyle:"auto",icons:{activeHeader:"ui-icon-triangle-1-s",header:"ui-icon-triangle-1-e"},activate:null,beforeActivate:null},hideProps:{borderTopWidth:"hide",borderBottomWidth:"hide",paddingTop:"hide",paddingBottom:"hide",height:"hide"},showProps:{borderTopWidth:"show",borderBottomWidth:"show",paddingTop:"show",paddingBottom:"show",height:"show"},_create:function(){var e=this.options;this.prevShow=this.prevHide=t(),this._addClass("ui-accordion","ui-widget ui-helper-reset"),this.element.attr("role","tablist"),e.collapsible||e.active!==!1&&null!=e.active||(e.active=0),this._processPanels(),0>e.active&&(e.active+=this.headers.length),this._refresh()},_getCreateEventData:function(){return{header:this.active,panel:this.active.length?this.active.next():t()}},_createIcons:function(){var e,i,s=this.options.icons;s&&(e=t("<span>"),this._addClass(e,"ui-accordion-header-icon","ui-icon "+s.header),e.prependTo(this.headers),i=this.active.children(".ui-accordion-header-icon"),this._removeClass(i,s.header)._addClass(i,null,s.activeHeader)._addClass(this.headers,"ui-accordion-icons"))},_destroyIcons:function(){this._removeClass(this.headers,"ui-accordion-icons"),this.headers.children(".ui-accordion-header-icon").remove()},_destroy:function(){var t;this.element.removeAttr("role"),this.headers.removeAttr("role aria-expanded aria-selected aria-controls tabIndex").removeUniqueId(),this._destroyIcons(),t=this.headers.next().css("display","").removeAttr("role aria-hidden aria-labelledby").removeUniqueId(),"content"!==this.options.heightStyle&&t.css("height","")},_setOption:function(t,e){return"active"===t?(this._activate(e),void 0):("event"===t&&(this.options.event&&this._off(this.headers,this.options.event),this._setupEvents(e)),this._super(t,e),"collapsible"!==t||e||this.options.active!==!1||this._activate(0),"icons"===t&&(this._destroyIcons(),e&&this._createIcons()),void 0)},_setOptionDisabled:function(t){this._super(t),this.element.attr("aria-disabled",t),this._toggleClass(null,"ui-state-disabled",!!t),this._toggleClass(this.headers.add(this.headers.next()),null,"ui-state-disabled",!!t)},_keydown:function(e){if(!e.altKey&&!e.ctrlKey){var i=t.ui.keyCode,s=this.headers.length,n=this.headers.index(e.target),o=!1;switch(e.keyCode){case i.RIGHT:case i.DOWN:o=this.headers[(n+1)%s];break;case i.LEFT:case i.UP:o=this.headers[(n-1+s)%s];break;case i.SPACE:case i.ENTER:this._eventHandler(e);break;case i.HOME:o=this.headers[0];break;case i.END:o=this.headers[s-1]}o&&(t(e.target).attr("tabIndex",-1),t(o).attr("tabIndex",0),t(o).trigger("focus"),e.preventDefault())}},_panelKeyDown:function(e){e.keyCode===t.ui.keyCode.UP&&e.ctrlKey&&t(e.currentTarget).prev().trigger("focus")},refresh:function(){var e=this.options;this._processPanels(),e.active===!1&&e.collapsible===!0||!this.headers.length?(e.active=!1,this.active=t()):e.active===!1?this._activate(0):this.active.length&&!t.contains(this.element[0],this.active[0])?this.headers.length===this.headers.find(".ui-state-disabled").length?(e.active=!1,this.active=t()):this._activate(Math.max(0,e.active-1)):e.active=this.headers.index(this.active),this._destroyIcons(),this._refresh()},_processPanels:function(){var t=this.headers,e=this.panels;this.headers=this.element.find(this.options.header),this._addClass(this.headers,"ui-accordion-header ui-accordion-header-collapsed","ui-state-default"),this.panels=this.headers.next().filter(":not(.ui-accordion-content-active)").hide(),this._addClass(this.panels,"ui-accordion-content","ui-helper-reset ui-widget-content"),e&&(this._off(t.not(this.headers)),this._off(e.not(this.panels)))},_refresh:function(){var e,i=this.options,s=i.heightStyle,n=this.element.parent();this.active=this._findActive(i.active),this._addClass(this.active,"ui-accordion-header-active","ui-state-active")._removeClass(this.active,"ui-accordion-header-collapsed"),this._addClass(this.active.next(),"ui-accordion-content-active"),this.active.next().show(),this.headers.attr("role","tab").each(function(){var e=t(this),i=e.uniqueId().attr("id"),s=e.next(),n=s.uniqueId().attr("id");
e.attr("aria-controls",n),s.attr("aria-labelledby",i)}).next().attr("role","tabpanel"),this.headers.not(this.active).attr({"aria-selected":"false","aria-expanded":"false",tabIndex:-1}).next().attr({"aria-hidden":"true"}).hide(),this.active.length?this.active.attr({"aria-selected":"true","aria-expanded":"true",tabIndex:0}).next().attr({"aria-hidden":"false"}):this.headers.eq(0).attr("tabIndex",0),this._createIcons(),this._setupEvents(i.event),"fill"===s?(e=n.height(),this.element.siblings(":visible").each(function(){var i=t(this),s=i.css("position");"absolute"!==s&&"fixed"!==s&&(e-=i.outerHeight(!0))}),this.headers.each(function(){e-=t(this).outerHeight(!0)}),this.headers.next().each(function(){t(this).height(Math.max(0,e-t(this).innerHeight()+t(this).height()))}).css("overflow","auto")):"auto"===s&&(e=0,this.headers.next().each(function(){var i=t(this).is(":visible");i||t(this).show(),e=Math.max(e,t(this).css("height","").height()),i||t(this).hide()}).height(e))},_activate:function(e){var i=this._findActive(e)[0];i!==this.active[0]&&(i=i||this.active[0],this._eventHandler({target:i,currentTarget:i,preventDefault:t.noop}))},_findActive:function(e){return"number"==typeof e?this.headers.eq(e):t()},_setupEvents:function(e){var i={keydown:"_keydown"};e&&t.each(e.split(" "),function(t,e){i[e]="_eventHandler"}),this._off(this.headers.add(this.headers.next())),this._on(this.headers,i),this._on(this.headers.next(),{keydown:"_panelKeyDown"}),this._hoverable(this.headers),this._focusable(this.headers)},_eventHandler:function(e){var i,s,n=this.options,o=this.active,a=t(e.currentTarget),r=a[0]===o[0],l=r&&n.collapsible,h=l?t():a.next(),c=o.next(),u={oldHeader:o,oldPanel:c,newHeader:l?t():a,newPanel:h};e.preventDefault(),r&&!n.collapsible||this._trigger("beforeActivate",e,u)===!1||(n.active=l?!1:this.headers.index(a),this.active=r?t():a,this._toggle(u),this._removeClass(o,"ui-accordion-header-active","ui-state-active"),n.icons&&(i=o.children(".ui-accordion-header-icon"),this._removeClass(i,null,n.icons.activeHeader)._addClass(i,null,n.icons.header)),r||(this._removeClass(a,"ui-accordion-header-collapsed")._addClass(a,"ui-accordion-header-active","ui-state-active"),n.icons&&(s=a.children(".ui-accordion-header-icon"),this._removeClass(s,null,n.icons.header)._addClass(s,null,n.icons.activeHeader)),this._addClass(a.next(),"ui-accordion-content-active")))},_toggle:function(e){var i=e.newPanel,s=this.prevShow.length?this.prevShow:e.oldPanel;this.prevShow.add(this.prevHide).stop(!0,!0),this.prevShow=i,this.prevHide=s,this.options.animate?this._animate(i,s,e):(s.hide(),i.show(),this._toggleComplete(e)),s.attr({"aria-hidden":"true"}),s.prev().attr({"aria-selected":"false","aria-expanded":"false"}),i.length&&s.length?s.prev().attr({tabIndex:-1,"aria-expanded":"false"}):i.length&&this.headers.filter(function(){return 0===parseInt(t(this).attr("tabIndex"),10)}).attr("tabIndex",-1),i.attr("aria-hidden","false").prev().attr({"aria-selected":"true","aria-expanded":"true",tabIndex:0})},_animate:function(t,e,i){var s,n,o,a=this,r=0,l=t.css("box-sizing"),h=t.length&&(!e.length||t.index()<e.index()),c=this.options.animate||{},u=h&&c.down||c,d=function(){a._toggleComplete(i)};return"number"==typeof u&&(o=u),"string"==typeof u&&(n=u),n=n||u.easing||c.easing,o=o||u.duration||c.duration,e.length?t.length?(s=t.show().outerHeight(),e.animate(this.hideProps,{duration:o,easing:n,step:function(t,e){e.now=Math.round(t)}}),t.hide().animate(this.showProps,{duration:o,easing:n,complete:d,step:function(t,i){i.now=Math.round(t),"height"!==i.prop?"content-box"===l&&(r+=i.now):"content"!==a.options.heightStyle&&(i.now=Math.round(s-e.outerHeight()-r),r=0)}}),void 0):e.animate(this.hideProps,o,n,d):t.animate(this.showProps,o,n,d)},_toggleComplete:function(t){var e=t.oldPanel,i=e.prev();this._removeClass(e,"ui-accordion-content-active"),this._removeClass(i,"ui-accordion-header-active")._addClass(i,"ui-accordion-header-collapsed"),e.length&&(e.parent()[0].className=e.parent()[0].className),this._trigger("activate",null,t)}}),t.widget("ui.menu",{version:"1.12.1",defaultElement:"<ul>",delay:300,options:{icons:{submenu:"ui-icon-caret-1-e"},items:"> *",menus:"ul",position:{my:"left top",at:"right top"},role:"menu",blur:null,focus:null,select:null},_create:function(){this.activeMenu=this.element,this.mouseHandled=!1,this.element.uniqueId().attr({role:this.options.role,tabIndex:0}),this._addClass("ui-menu","ui-widget ui-widget-content"),this._on({"mousedown .ui-menu-item":function(t){t.preventDefault()},"click .ui-menu-item":function(e){var i=t(e.target),s=t(t.ui.safeActiveElement(this.document[0]));!this.mouseHandled&&i.not(".ui-state-disabled").length&&(this.select(e),e.isPropagationStopped()||(this.mouseHandled=!0),i.has(".ui-menu").length?this.expand(e):!this.element.is(":focus")&&s.closest(".ui-menu").length&&(this.element.trigger("focus",[!0]),this.active&&1===this.active.parents(".ui-menu").length&&clearTimeout(this.timer)))},"mouseenter .ui-menu-item":function(e){if(!this.previousFilter){var i=t(e.target).closest(".ui-menu-item"),s=t(e.currentTarget);i[0]===s[0]&&(this._removeClass(s.siblings().children(".ui-state-active"),null,"ui-state-active"),this.focus(e,s))}},mouseleave:"collapseAll","mouseleave .ui-menu":"collapseAll",focus:function(t,e){var i=this.active||this.element.find(this.options.items).eq(0);e||this.focus(t,i)},blur:function(e){this._delay(function(){var i=!t.contains(this.element[0],t.ui.safeActiveElement(this.document[0]));i&&this.collapseAll(e)})},keydown:"_keydown"}),this.refresh(),this._on(this.document,{click:function(t){this._closeOnDocumentClick(t)&&this.collapseAll(t),this.mouseHandled=!1}})},_destroy:function(){var e=this.element.find(".ui-menu-item").removeAttr("role aria-disabled"),i=e.children(".ui-menu-item-wrapper").removeUniqueId().removeAttr("tabIndex role aria-haspopup");this.element.removeAttr("aria-activedescendant").find(".ui-menu").addBack().removeAttr("role aria-labelledby aria-expanded aria-hidden aria-disabled tabIndex").removeUniqueId().show(),i.children().each(function(){var e=t(this);e.data("ui-menu-submenu-caret")&&e.remove()})},_keydown:function(e){var i,s,n,o,a=!0;switch(e.keyCode){case t.ui.keyCode.PAGE_UP:this.previousPage(e);break;case t.ui.keyCode.PAGE_DOWN:this.nextPage(e);break;case t.ui.keyCode.HOME:this._move("first","first",e);break;case t.ui.keyCode.END:this._move("last","last",e);break;case t.ui.keyCode.UP:this.previous(e);break;case t.ui.keyCode.DOWN:this.next(e);break;case t.ui.keyCode.LEFT:this.collapse(e);break;case t.ui.keyCode.RIGHT:this.active&&!this.active.is(".ui-state-disabled")&&this.expand(e);break;case t.ui.keyCode.ENTER:case t.ui.keyCode.SPACE:this._activate(e);break;case t.ui.keyCode.ESCAPE:this.collapse(e);break;default:a=!1,s=this.previousFilter||"",o=!1,n=e.keyCode>=96&&105>=e.keyCode?""+(e.keyCode-96):String.fromCharCode(e.keyCode),clearTimeout(this.filterTimer),n===s?o=!0:n=s+n,i=this._filterMenuItems(n),i=o&&-1!==i.index(this.active.next())?this.active.nextAll(".ui-menu-item"):i,i.length||(n=String.fromCharCode(e.keyCode),i=this._filterMenuItems(n)),i.length?(this.focus(e,i),this.previousFilter=n,this.filterTimer=this._delay(function(){delete this.previousFilter},1e3)):delete this.previousFilter}a&&e.preventDefault()},_activate:function(t){this.active&&!this.active.is(".ui-state-disabled")&&(this.active.children("[aria-haspopup='true']").length?this.expand(t):this.select(t))},refresh:function(){var e,i,s,n,o,a=this,r=this.options.icons.submenu,l=this.element.find(this.options.menus);this._toggleClass("ui-menu-icons",null,!!this.element.find(".ui-icon").length),s=l.filter(":not(.ui-menu)").hide().attr({role:this.options.role,"aria-hidden":"true","aria-expanded":"false"}).each(function(){var e=t(this),i=e.prev(),s=t("<span>").data("ui-menu-submenu-caret",!0);a._addClass(s,"ui-menu-icon","ui-icon "+r),i.attr("aria-haspopup","true").prepend(s),e.attr("aria-labelledby",i.attr("id"))}),this._addClass(s,"ui-menu","ui-widget ui-widget-content ui-front"),e=l.add(this.element),i=e.find(this.options.items),i.not(".ui-menu-item").each(function(){var e=t(this);a._isDivider(e)&&a._addClass(e,"ui-menu-divider","ui-widget-content")}),n=i.not(".ui-menu-item, .ui-menu-divider"),o=n.children().not(".ui-menu").uniqueId().attr({tabIndex:-1,role:this._itemRole()}),this._addClass(n,"ui-menu-item")._addClass(o,"ui-menu-item-wrapper"),i.filter(".ui-state-disabled").attr("aria-disabled","true"),this.active&&!t.contains(this.element[0],this.active[0])&&this.blur()},_itemRole:function(){return{menu:"menuitem",listbox:"option"}[this.options.role]},_setOption:function(t,e){if("icons"===t){var i=this.element.find(".ui-menu-icon");this._removeClass(i,null,this.options.icons.submenu)._addClass(i,null,e.submenu)}this._super(t,e)},_setOptionDisabled:function(t){this._super(t),this.element.attr("aria-disabled",t+""),this._toggleClass(null,"ui-state-disabled",!!t)},focus:function(t,e){var i,s,n;this.blur(t,t&&"focus"===t.type),this._scrollIntoView(e),this.active=e.first(),s=this.active.children(".ui-menu-item-wrapper"),this._addClass(s,null,"ui-state-active"),this.options.role&&this.element.attr("aria-activedescendant",s.attr("id")),n=this.active.parent().closest(".ui-menu-item").children(".ui-menu-item-wrapper"),this._addClass(n,null,"ui-state-active"),t&&"keydown"===t.type?this._close():this.timer=this._delay(function(){this._close()},this.delay),i=e.children(".ui-menu"),i.length&&t&&/^mouse/.test(t.type)&&this._startOpening(i),this.activeMenu=e.parent(),this._trigger("focus",t,{item:e})},_scrollIntoView:function(e){var i,s,n,o,a,r;this._hasScroll()&&(i=parseFloat(t.css(this.activeMenu[0],"borderTopWidth"))||0,s=parseFloat(t.css(this.activeMenu[0],"paddingTop"))||0,n=e.offset().top-this.activeMenu.offset().top-i-s,o=this.activeMenu.scrollTop(),a=this.activeMenu.height(),r=e.outerHeight(),0>n?this.activeMenu.scrollTop(o+n):n+r>a&&this.activeMenu.scrollTop(o+n-a+r))},blur:function(t,e){e||clearTimeout(this.timer),this.active&&(this._removeClass(this.active.children(".ui-menu-item-wrapper"),null,"ui-state-active"),this._trigger("blur",t,{item:this.active}),this.active=null)},_startOpening:function(t){clearTimeout(this.timer),"true"===t.attr("aria-hidden")&&(this.timer=this._delay(function(){this._close(),this._open(t)},this.delay))},_open:function(e){var i=t.extend({of:this.active},this.options.position);clearTimeout(this.timer),this.element.find(".ui-menu").not(e.parents(".ui-menu")).hide().attr("aria-hidden","true"),e.show().removeAttr("aria-hidden").attr("aria-expanded","true").position(i)},collapseAll:function(e,i){clearTimeout(this.timer),this.timer=this._delay(function(){var s=i?this.element:t(e&&e.target).closest(this.element.find(".ui-menu"));s.length||(s=this.element),this._close(s),this.blur(e),this._removeClass(s.find(".ui-state-active"),null,"ui-state-active"),this.activeMenu=s},this.delay)},_close:function(t){t||(t=this.active?this.active.parent():this.element),t.find(".ui-menu").hide().attr("aria-hidden","true").attr("aria-expanded","false")},_closeOnDocumentClick:function(e){return!t(e.target).closest(".ui-menu").length},_isDivider:function(t){return!/[^\-\u2014\u2013\s]/.test(t.text())},collapse:function(t){var e=this.active&&this.active.parent().closest(".ui-menu-item",this.element);e&&e.length&&(this._close(),this.focus(t,e))},expand:function(t){var e=this.active&&this.active.children(".ui-menu ").find(this.options.items).first();e&&e.length&&(this._open(e.parent()),this._delay(function(){this.focus(t,e)}))},next:function(t){this._move("next","first",t)},previous:function(t){this._move("prev","last",t)},isFirstItem:function(){return this.active&&!this.active.prevAll(".ui-menu-item").length},isLastItem:function(){return this.active&&!this.active.nextAll(".ui-menu-item").length},_move:function(t,e,i){var s;this.active&&(s="first"===t||"last"===t?this.active["first"===t?"prevAll":"nextAll"](".ui-menu-item").eq(-1):this.active[t+"All"](".ui-menu-item").eq(0)),s&&s.length&&this.active||(s=this.activeMenu.find(this.options.items)[e]()),this.focus(i,s)},nextPage:function(e){var i,s,n;return this.active?(this.isLastItem()||(this._hasScroll()?(s=this.active.offset().top,n=this.element.height(),this.active.nextAll(".ui-menu-item").each(function(){return i=t(this),0>i.offset().top-s-n}),this.focus(e,i)):this.focus(e,this.activeMenu.find(this.options.items)[this.active?"last":"first"]())),void 0):(this.next(e),void 0)},previousPage:function(e){var i,s,n;return this.active?(this.isFirstItem()||(this._hasScroll()?(s=this.active.offset().top,n=this.element.height(),this.active.prevAll(".ui-menu-item").each(function(){return i=t(this),i.offset().top-s+n>0}),this.focus(e,i)):this.focus(e,this.activeMenu.find(this.options.items).first())),void 0):(this.next(e),void 0)},_hasScroll:function(){return this.element.outerHeight()<this.element.prop("scrollHeight")},select:function(e){this.active=this.active||t(e.target).closest(".ui-menu-item");var i={item:this.active};this.active.has(".ui-menu").length||this.collapseAll(e,!0),this._trigger("select",e,i)},_filterMenuItems:function(e){var i=e.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g,"\\$&"),s=RegExp("^"+i,"i");return this.activeMenu.find(this.options.items).filter(".ui-menu-item").filter(function(){return s.test(t.trim(t(this).children(".ui-menu-item-wrapper").text()))})}}),t.widget("ui.autocomplete",{version:"1.12.1",defaultElement:"<input>",options:{appendTo:null,autoFocus:!1,delay:300,minLength:1,position:{my:"left top",at:"left bottom",collision:"none"},source:null,change:null,close:null,focus:null,open:null,response:null,search:null,select:null},requestIndex:0,pending:0,_create:function(){var e,i,s,n=this.element[0].nodeName.toLowerCase(),o="textarea"===n,a="input"===n;this.isMultiLine=o||!a&&this._isContentEditable(this.element),this.valueMethod=this.element[o||a?"val":"text"],this.isNewMenu=!0,this._addClass("ui-autocomplete-input"),this.element.attr("autocomplete","off"),this._on(this.element,{keydown:function(n){if(this.element.prop("readOnly"))return e=!0,s=!0,i=!0,void 0;e=!1,s=!1,i=!1;var o=t.ui.keyCode;switch(n.keyCode){case o.PAGE_UP:e=!0,this._move("previousPage",n);break;case o.PAGE_DOWN:e=!0,this._move("nextPage",n);break;case o.UP:e=!0,this._keyEvent("previous",n);break;case o.DOWN:e=!0,this._keyEvent("next",n);break;case o.ENTER:this.menu.active&&(e=!0,n.preventDefault(),this.menu.select(n));break;case o.TAB:this.menu.active&&this.menu.select(n);break;case o.ESCAPE:this.menu.element.is(":visible")&&(this.isMultiLine||this._value(this.term),this.close(n),n.preventDefault());break;default:i=!0,this._searchTimeout(n)}},keypress:function(s){if(e)return e=!1,(!this.isMultiLine||this.menu.element.is(":visible"))&&s.preventDefault(),void 0;if(!i){var n=t.ui.keyCode;switch(s.keyCode){case n.PAGE_UP:this._move("previousPage",s);break;case n.PAGE_DOWN:this._move("nextPage",s);break;case n.UP:this._keyEvent("previous",s);break;case n.DOWN:this._keyEvent("next",s)}}},input:function(t){return s?(s=!1,t.preventDefault(),void 0):(this._searchTimeout(t),void 0)},focus:function(){this.selectedItem=null,this.previous=this._value()},blur:function(t){return this.cancelBlur?(delete this.cancelBlur,void 0):(clearTimeout(this.searching),this.close(t),this._change(t),void 0)}}),this._initSource(),this.menu=t("<ul>").appendTo(this._appendTo()).menu({role:null}).hide().menu("instance"),this._addClass(this.menu.element,"ui-autocomplete","ui-front"),this._on(this.menu.element,{mousedown:function(e){e.preventDefault(),this.cancelBlur=!0,this._delay(function(){delete this.cancelBlur,this.element[0]!==t.ui.safeActiveElement(this.document[0])&&this.element.trigger("focus")})},menufocus:function(e,i){var s,n;return this.isNewMenu&&(this.isNewMenu=!1,e.originalEvent&&/^mouse/.test(e.originalEvent.type))?(this.menu.blur(),this.document.one("mousemove",function(){t(e.target).trigger(e.originalEvent)}),void 0):(n=i.item.data("ui-autocomplete-item"),!1!==this._trigger("focus",e,{item:n})&&e.originalEvent&&/^key/.test(e.originalEvent.type)&&this._value(n.value),s=i.item.attr("aria-label")||n.value,s&&t.trim(s).length&&(this.liveRegion.children().hide(),t("<div>").text(s).appendTo(this.liveRegion)),void 0)},menuselect:function(e,i){var s=i.item.data("ui-autocomplete-item"),n=this.previous;this.element[0]!==t.ui.safeActiveElement(this.document[0])&&(this.element.trigger("focus"),this.previous=n,this._delay(function(){this.previous=n,this.selectedItem=s})),!1!==this._trigger("select",e,{item:s})&&this._value(s.value),this.term=this._value(),this.close(e),this.selectedItem=s}}),this.liveRegion=t("<div>",{role:"status","aria-live":"assertive","aria-relevant":"additions"}).appendTo(this.document[0].body),this._addClass(this.liveRegion,null,"ui-helper-hidden-accessible"),this._on(this.window,{beforeunload:function(){this.element.removeAttr("autocomplete")}})},_destroy:function(){clearTimeout(this.searching),this.element.removeAttr("autocomplete"),this.menu.element.remove(),this.liveRegion.remove()},_setOption:function(t,e){this._super(t,e),"source"===t&&this._initSource(),"appendTo"===t&&this.menu.element.appendTo(this._appendTo()),"disabled"===t&&e&&this.xhr&&this.xhr.abort()},_isEventTargetInWidget:function(e){var i=this.menu.element[0];return e.target===this.element[0]||e.target===i||t.contains(i,e.target)},_closeOnClickOutside:function(t){this._isEventTargetInWidget(t)||this.close()},_appendTo:function(){var e=this.options.appendTo;return e&&(e=e.jquery||e.nodeType?t(e):this.document.find(e).eq(0)),e&&e[0]||(e=this.element.closest(".ui-front, dialog")),e.length||(e=this.document[0].body),e},_initSource:function(){var e,i,s=this;t.isArray(this.options.source)?(e=this.options.source,this.source=function(i,s){s(t.ui.autocomplete.filter(e,i.term))}):"string"==typeof this.options.source?(i=this.options.source,this.source=function(e,n){s.xhr&&s.xhr.abort(),s.xhr=t.ajax({url:i,data:e,dataType:"json",success:function(t){n(t)},error:function(){n([])}})}):this.source=this.options.source},_searchTimeout:function(t){clearTimeout(this.searching),this.searching=this._delay(function(){var e=this.term===this._value(),i=this.menu.element.is(":visible"),s=t.altKey||t.ctrlKey||t.metaKey||t.shiftKey;(!e||e&&!i&&!s)&&(this.selectedItem=null,this.search(null,t))},this.options.delay)},search:function(t,e){return t=null!=t?t:this._value(),this.term=this._value(),t.length<this.options.minLength?this.close(e):this._trigger("search",e)!==!1?this._search(t):void 0},_search:function(t){this.pending++,this._addClass("ui-autocomplete-loading"),this.cancelSearch=!1,this.source({term:t},this._response())},_response:function(){var e=++this.requestIndex;return t.proxy(function(t){e===this.requestIndex&&this.__response(t),this.pending--,this.pending||this._removeClass("ui-autocomplete-loading")},this)},__response:function(t){t&&(t=this._normalize(t)),this._trigger("response",null,{content:t}),!this.options.disabled&&t&&t.length&&!this.cancelSearch?(this._suggest(t),this._trigger("open")):this._close()},close:function(t){this.cancelSearch=!0,this._close(t)},_close:function(t){this._off(this.document,"mousedown"),this.menu.element.is(":visible")&&(this.menu.element.hide(),this.menu.blur(),this.isNewMenu=!0,this._trigger("close",t))},_change:function(t){this.previous!==this._value()&&this._trigger("change",t,{item:this.selectedItem})},_normalize:function(e){return e.length&&e[0].label&&e[0].value?e:t.map(e,function(e){return"string"==typeof e?{label:e,value:e}:t.extend({},e,{label:e.label||e.value,value:e.value||e.label})})},_suggest:function(e){var i=this.menu.element.empty();this._renderMenu(i,e),this.isNewMenu=!0,this.menu.refresh(),i.show(),this._resizeMenu(),i.position(t.extend({of:this.element},this.options.position)),this.options.autoFocus&&this.menu.next(),this._on(this.document,{mousedown:"_closeOnClickOutside"})},_resizeMenu:function(){var t=this.menu.element;t.outerWidth(Math.max(t.width("").outerWidth()+1,this.element.outerWidth()))},_renderMenu:function(e,i){var s=this;t.each(i,function(t,i){s._renderItemData(e,i)})},_renderItemData:function(t,e){return this._renderItem(t,e).data("ui-autocomplete-item",e)},_renderItem:function(e,i){return t("<li>").append(t("<div>").text(i.label)).appendTo(e)},_move:function(t,e){return this.menu.element.is(":visible")?this.menu.isFirstItem()&&/^previous/.test(t)||this.menu.isLastItem()&&/^next/.test(t)?(this.isMultiLine||this._value(this.term),this.menu.blur(),void 0):(this.menu[t](e),void 0):(this.search(null,e),void 0)},widget:function(){return this.menu.element},_value:function(){return this.valueMethod.apply(this.element,arguments)},_keyEvent:function(t,e){(!this.isMultiLine||this.menu.element.is(":visible"))&&(this._move(t,e),e.preventDefault())},_isContentEditable:function(t){if(!t.length)return!1;var e=t.prop("contentEditable");return"inherit"===e?this._isContentEditable(t.parent()):"true"===e}}),t.extend(t.ui.autocomplete,{escapeRegex:function(t){return t.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g,"\\$&")},filter:function(e,i){var s=RegExp(t.ui.autocomplete.escapeRegex(i),"i");return t.grep(e,function(t){return s.test(t.label||t.value||t)})}}),t.widget("ui.autocomplete",t.ui.autocomplete,{options:{messages:{noResults:"No search results.",results:function(t){return t+(t>1?" results are":" result is")+" available, use up and down arrow keys to navigate."}}},__response:function(e){var i;this._superApply(arguments),this.options.disabled||this.cancelSearch||(i=e&&e.length?this.options.messages.results(e.length):this.options.messages.noResults,this.liveRegion.children().hide(),t("<div>").text(i).appendTo(this.liveRegion))}}),t.ui.autocomplete;var c=/ui-corner-([a-z]){2,6}/g;t.widget("ui.controlgroup",{version:"1.12.1",defaultElement:"<div>",options:{direction:"horizontal",disabled:null,onlyVisible:!0,items:{button:"input[type=button], input[type=submit], input[type=reset], button, a",controlgroupLabel:".ui-controlgroup-label",checkboxradio:"input[type='checkbox'], input[type='radio']",selectmenu:"select",spinner:".ui-spinner-input"}},_create:function(){this._enhance()},_enhance:function(){this.element.attr("role","toolbar"),this.refresh()},_destroy:function(){this._callChildMethod("destroy"),this.childWidgets.removeData("ui-controlgroup-data"),this.element.removeAttr("role"),this.options.items.controlgroupLabel&&this.element.find(this.options.items.controlgroupLabel).find(".ui-controlgroup-label-contents").contents().unwrap()},_initWidgets:function(){var e=this,i=[];t.each(this.options.items,function(s,n){var o,a={};return n?"controlgroupLabel"===s?(o=e.element.find(n),o.each(function(){var e=t(this);e.children(".ui-controlgroup-label-contents").length||e.contents().wrapAll("<span class='ui-controlgroup-label-contents'></span>")}),e._addClass(o,null,"ui-widget ui-widget-content ui-state-default"),i=i.concat(o.get()),void 0):(t.fn[s]&&(a=e["_"+s+"Options"]?e["_"+s+"Options"]("middle"):{classes:{}},e.element.find(n).each(function(){var n=t(this),o=n[s]("instance"),r=t.widget.extend({},a);if("button"!==s||!n.parent(".ui-spinner").length){o||(o=n[s]()[s]("instance")),o&&(r.classes=e._resolveClassesValues(r.classes,o)),n[s](r);var l=n[s]("widget");t.data(l[0],"ui-controlgroup-data",o?o:n[s]("instance")),i.push(l[0])}})),void 0):void 0}),this.childWidgets=t(t.unique(i)),this._addClass(this.childWidgets,"ui-controlgroup-item")},_callChildMethod:function(e){this.childWidgets.each(function(){var i=t(this),s=i.data("ui-controlgroup-data");s&&s[e]&&s[e]()})},_updateCornerClass:function(t,e){var i="ui-corner-top ui-corner-bottom ui-corner-left ui-corner-right ui-corner-all",s=this._buildSimpleOptions(e,"label").classes.label;this._removeClass(t,null,i),this._addClass(t,null,s)},_buildSimpleOptions:function(t,e){var i="vertical"===this.options.direction,s={classes:{}};return s.classes[e]={middle:"",first:"ui-corner-"+(i?"top":"left"),last:"ui-corner-"+(i?"bottom":"right"),only:"ui-corner-all"}[t],s},_spinnerOptions:function(t){var e=this._buildSimpleOptions(t,"ui-spinner");return e.classes["ui-spinner-up"]="",e.classes["ui-spinner-down"]="",e},_buttonOptions:function(t){return this._buildSimpleOptions(t,"ui-button")},_checkboxradioOptions:function(t){return this._buildSimpleOptions(t,"ui-checkboxradio-label")},_selectmenuOptions:function(t){var e="vertical"===this.options.direction;return{width:e?"auto":!1,classes:{middle:{"ui-selectmenu-button-open":"","ui-selectmenu-button-closed":""},first:{"ui-selectmenu-button-open":"ui-corner-"+(e?"top":"tl"),"ui-selectmenu-button-closed":"ui-corner-"+(e?"top":"left")},last:{"ui-selectmenu-button-open":e?"":"ui-corner-tr","ui-selectmenu-button-closed":"ui-corner-"+(e?"bottom":"right")},only:{"ui-selectmenu-button-open":"ui-corner-top","ui-selectmenu-button-closed":"ui-corner-all"}}[t]}},_resolveClassesValues:function(e,i){var s={};return t.each(e,function(n){var o=i.options.classes[n]||"";o=t.trim(o.replace(c,"")),s[n]=(o+" "+e[n]).replace(/\s+/g," ")}),s},_setOption:function(t,e){return"direction"===t&&this._removeClass("ui-controlgroup-"+this.options.direction),this._super(t,e),"disabled"===t?(this._callChildMethod(e?"disable":"enable"),void 0):(this.refresh(),void 0)},refresh:function(){var e,i=this;this._addClass("ui-controlgroup ui-controlgroup-"+this.options.direction),"horizontal"===this.options.direction&&this._addClass(null,"ui-helper-clearfix"),this._initWidgets(),e=this.childWidgets,this.options.onlyVisible&&(e=e.filter(":visible")),e.length&&(t.each(["first","last"],function(t,s){var n=e[s]().data("ui-controlgroup-data");if(n&&i["_"+n.widgetName+"Options"]){var o=i["_"+n.widgetName+"Options"](1===e.length?"only":s);o.classes=i._resolveClassesValues(o.classes,n),n.element[n.widgetName](o)}else i._updateCornerClass(e[s](),s)}),this._callChildMethod("refresh"))}}),t.widget("ui.checkboxradio",[t.ui.formResetMixin,{version:"1.12.1",options:{disabled:null,label:null,icon:!0,classes:{"ui-checkboxradio-label":"ui-corner-all","ui-checkboxradio-icon":"ui-corner-all"}},_getCreateOptions:function(){var e,i,s=this,n=this._super()||{};return this._readType(),i=this.element.labels(),this.label=t(i[i.length-1]),this.label.length||t.error("No label found for checkboxradio widget"),this.originalLabel="",this.label.contents().not(this.element[0]).each(function(){s.originalLabel+=3===this.nodeType?t(this).text():this.outerHTML}),this.originalLabel&&(n.label=this.originalLabel),e=this.element[0].disabled,null!=e&&(n.disabled=e),n},_create:function(){var t=this.element[0].checked;this._bindFormResetHandler(),null==this.options.disabled&&(this.options.disabled=this.element[0].disabled),this._setOption("disabled",this.options.disabled),this._addClass("ui-checkboxradio","ui-helper-hidden-accessible"),this._addClass(this.label,"ui-checkboxradio-label","ui-button ui-widget"),"radio"===this.type&&this._addClass(this.label,"ui-checkboxradio-radio-label"),this.options.label&&this.options.label!==this.originalLabel?this._updateLabel():this.originalLabel&&(this.options.label=this.originalLabel),this._enhance(),t&&(this._addClass(this.label,"ui-checkboxradio-checked","ui-state-active"),this.icon&&this._addClass(this.icon,null,"ui-state-hover")),this._on({change:"_toggleClasses",focus:function(){this._addClass(this.label,null,"ui-state-focus ui-visual-focus")},blur:function(){this._removeClass(this.label,null,"ui-state-focus ui-visual-focus")}})},_readType:function(){var e=this.element[0].nodeName.toLowerCase();this.type=this.element[0].type,"input"===e&&/radio|checkbox/.test(this.type)||t.error("Can't create checkboxradio on element.nodeName="+e+" and element.type="+this.type)},_enhance:function(){this._updateIcon(this.element[0].checked)},widget:function(){return this.label},_getRadioGroup:function(){var e,i=this.element[0].name,s="input[name='"+t.ui.escapeSelector(i)+"']";return i?(e=this.form.length?t(this.form[0].elements).filter(s):t(s).filter(function(){return 0===t(this).form().length}),e.not(this.element)):t([])},_toggleClasses:function(){var e=this.element[0].checked;this._toggleClass(this.label,"ui-checkboxradio-checked","ui-state-active",e),this.options.icon&&"checkbox"===this.type&&this._toggleClass(this.icon,null,"ui-icon-check ui-state-checked",e)._toggleClass(this.icon,null,"ui-icon-blank",!e),"radio"===this.type&&this._getRadioGroup().each(function(){var e=t(this).checkboxradio("instance");e&&e._removeClass(e.label,"ui-checkboxradio-checked","ui-state-active")})},_destroy:function(){this._unbindFormResetHandler(),this.icon&&(this.icon.remove(),this.iconSpace.remove())},_setOption:function(t,e){return"label"!==t||e?(this._super(t,e),"disabled"===t?(this._toggleClass(this.label,null,"ui-state-disabled",e),this.element[0].disabled=e,void 0):(this.refresh(),void 0)):void 0},_updateIcon:function(e){var i="ui-icon ui-icon-background ";this.options.icon?(this.icon||(this.icon=t("<span>"),this.iconSpace=t("<span> </span>"),this._addClass(this.iconSpace,"ui-checkboxradio-icon-space")),"checkbox"===this.type?(i+=e?"ui-icon-check ui-state-checked":"ui-icon-blank",this._removeClass(this.icon,null,e?"ui-icon-blank":"ui-icon-check")):i+="ui-icon-blank",this._addClass(this.icon,"ui-checkboxradio-icon",i),e||this._removeClass(this.icon,null,"ui-icon-check ui-state-checked"),this.icon.prependTo(this.label).after(this.iconSpace)):void 0!==this.icon&&(this.icon.remove(),this.iconSpace.remove(),delete this.icon)},_updateLabel:function(){var t=this.label.contents().not(this.element[0]);this.icon&&(t=t.not(this.icon[0])),this.iconSpace&&(t=t.not(this.iconSpace[0])),t.remove(),this.label.append(this.options.label)},refresh:function(){var t=this.element[0].checked,e=this.element[0].disabled;this._updateIcon(t),this._toggleClass(this.label,"ui-checkboxradio-checked","ui-state-active",t),null!==this.options.label&&this._updateLabel(),e!==this.options.disabled&&this._setOptions({disabled:e})}}]),t.ui.checkboxradio,t.widget("ui.button",{version:"1.12.1",defaultElement:"<button>",options:{classes:{"ui-button":"ui-corner-all"},disabled:null,icon:null,iconPosition:"beginning",label:null,showLabel:!0},_getCreateOptions:function(){var t,e=this._super()||{};return this.isInput=this.element.is("input"),t=this.element[0].disabled,null!=t&&(e.disabled=t),this.originalLabel=this.isInput?this.element.val():this.element.html(),this.originalLabel&&(e.label=this.originalLabel),e},_create:function(){!this.option.showLabel&!this.options.icon&&(this.options.showLabel=!0),null==this.options.disabled&&(this.options.disabled=this.element[0].disabled||!1),this.hasTitle=!!this.element.attr("title"),this.options.label&&this.options.label!==this.originalLabel&&(this.isInput?this.element.val(this.options.label):this.element.html(this.options.label)),this._addClass("ui-button","ui-widget"),this._setOption("disabled",this.options.disabled),this._enhance(),this.element.is("a")&&this._on({keyup:function(e){e.keyCode===t.ui.keyCode.SPACE&&(e.preventDefault(),this.element[0].click?this.element[0].click():this.element.trigger("click"))}})},_enhance:function(){this.element.is("button")||this.element.attr("role","button"),this.options.icon&&(this._updateIcon("icon",this.options.icon),this._updateTooltip())},_updateTooltip:function(){this.title=this.element.attr("title"),this.options.showLabel||this.title||this.element.attr("title",this.options.label)},_updateIcon:function(e,i){var s="iconPosition"!==e,n=s?this.options.iconPosition:i,o="top"===n||"bottom"===n;this.icon?s&&this._removeClass(this.icon,null,this.options.icon):(this.icon=t("<span>"),this._addClass(this.icon,"ui-button-icon","ui-icon"),this.options.showLabel||this._addClass("ui-button-icon-only")),s&&this._addClass(this.icon,null,i),this._attachIcon(n),o?(this._addClass(this.icon,null,"ui-widget-icon-block"),this.iconSpace&&this.iconSpace.remove()):(this.iconSpace||(this.iconSpace=t("<span> </span>"),this._addClass(this.iconSpace,"ui-button-icon-space")),this._removeClass(this.icon,null,"ui-wiget-icon-block"),this._attachIconSpace(n))},_destroy:function(){this.element.removeAttr("role"),this.icon&&this.icon.remove(),this.iconSpace&&this.iconSpace.remove(),this.hasTitle||this.element.removeAttr("title")
},_attachIconSpace:function(t){this.icon[/^(?:end|bottom)/.test(t)?"before":"after"](this.iconSpace)},_attachIcon:function(t){this.element[/^(?:end|bottom)/.test(t)?"append":"prepend"](this.icon)},_setOptions:function(t){var e=void 0===t.showLabel?this.options.showLabel:t.showLabel,i=void 0===t.icon?this.options.icon:t.icon;e||i||(t.showLabel=!0),this._super(t)},_setOption:function(t,e){"icon"===t&&(e?this._updateIcon(t,e):this.icon&&(this.icon.remove(),this.iconSpace&&this.iconSpace.remove())),"iconPosition"===t&&this._updateIcon(t,e),"showLabel"===t&&(this._toggleClass("ui-button-icon-only",null,!e),this._updateTooltip()),"label"===t&&(this.isInput?this.element.val(e):(this.element.html(e),this.icon&&(this._attachIcon(this.options.iconPosition),this._attachIconSpace(this.options.iconPosition)))),this._super(t,e),"disabled"===t&&(this._toggleClass(null,"ui-state-disabled",e),this.element[0].disabled=e,e&&this.element.blur())},refresh:function(){var t=this.element.is("input, button")?this.element[0].disabled:this.element.hasClass("ui-button-disabled");t!==this.options.disabled&&this._setOptions({disabled:t}),this._updateTooltip()}}),t.uiBackCompat!==!1&&(t.widget("ui.button",t.ui.button,{options:{text:!0,icons:{primary:null,secondary:null}},_create:function(){this.options.showLabel&&!this.options.text&&(this.options.showLabel=this.options.text),!this.options.showLabel&&this.options.text&&(this.options.text=this.options.showLabel),this.options.icon||!this.options.icons.primary&&!this.options.icons.secondary?this.options.icon&&(this.options.icons.primary=this.options.icon):this.options.icons.primary?this.options.icon=this.options.icons.primary:(this.options.icon=this.options.icons.secondary,this.options.iconPosition="end"),this._super()},_setOption:function(t,e){return"text"===t?(this._super("showLabel",e),void 0):("showLabel"===t&&(this.options.text=e),"icon"===t&&(this.options.icons.primary=e),"icons"===t&&(e.primary?(this._super("icon",e.primary),this._super("iconPosition","beginning")):e.secondary&&(this._super("icon",e.secondary),this._super("iconPosition","end"))),this._superApply(arguments),void 0)}}),t.fn.button=function(e){return function(){return!this.length||this.length&&"INPUT"!==this[0].tagName||this.length&&"INPUT"===this[0].tagName&&"checkbox"!==this.attr("type")&&"radio"!==this.attr("type")?e.apply(this,arguments):(t.ui.checkboxradio||t.error("Checkboxradio widget missing"),0===arguments.length?this.checkboxradio({icon:!1}):this.checkboxradio.apply(this,arguments))}}(t.fn.button),t.fn.buttonset=function(){return t.ui.controlgroup||t.error("Controlgroup widget missing"),"option"===arguments[0]&&"items"===arguments[1]&&arguments[2]?this.controlgroup.apply(this,[arguments[0],"items.button",arguments[2]]):"option"===arguments[0]&&"items"===arguments[1]?this.controlgroup.apply(this,[arguments[0],"items.button"]):("object"==typeof arguments[0]&&arguments[0].items&&(arguments[0].items={button:arguments[0].items}),this.controlgroup.apply(this,arguments))}),t.ui.button,t.extend(t.ui,{datepicker:{version:"1.12.1"}});var u;t.extend(s.prototype,{markerClassName:"hasDatepicker",maxRows:4,_widgetDatepicker:function(){return this.dpDiv},setDefaults:function(t){return a(this._defaults,t||{}),this},_attachDatepicker:function(e,i){var s,n,o;s=e.nodeName.toLowerCase(),n="div"===s||"span"===s,e.id||(this.uuid+=1,e.id="dp"+this.uuid),o=this._newInst(t(e),n),o.settings=t.extend({},i||{}),"input"===s?this._connectDatepicker(e,o):n&&this._inlineDatepicker(e,o)},_newInst:function(e,i){var s=e[0].id.replace(/([^A-Za-z0-9_\-])/g,"\\\\$1");return{id:s,input:e,selectedDay:0,selectedMonth:0,selectedYear:0,drawMonth:0,drawYear:0,inline:i,dpDiv:i?n(t("<div class='"+this._inlineClass+" ui-datepicker ui-widget ui-widget-content ui-helper-clearfix ui-corner-all'></div>")):this.dpDiv}},_connectDatepicker:function(e,i){var s=t(e);i.append=t([]),i.trigger=t([]),s.hasClass(this.markerClassName)||(this._attachments(s,i),s.addClass(this.markerClassName).on("keydown",this._doKeyDown).on("keypress",this._doKeyPress).on("keyup",this._doKeyUp),this._autoSize(i),t.data(e,"datepicker",i),i.settings.disabled&&this._disableDatepicker(e))},_attachments:function(e,i){var s,n,o,a=this._get(i,"appendText"),r=this._get(i,"isRTL");i.append&&i.append.remove(),a&&(i.append=t("<span class='"+this._appendClass+"'>"+a+"</span>"),e[r?"before":"after"](i.append)),e.off("focus",this._showDatepicker),i.trigger&&i.trigger.remove(),s=this._get(i,"showOn"),("focus"===s||"both"===s)&&e.on("focus",this._showDatepicker),("button"===s||"both"===s)&&(n=this._get(i,"buttonText"),o=this._get(i,"buttonImage"),i.trigger=t(this._get(i,"buttonImageOnly")?t("<img/>").addClass(this._triggerClass).attr({src:o,alt:n,title:n}):t("<button type='button'></button>").addClass(this._triggerClass).html(o?t("<img/>").attr({src:o,alt:n,title:n}):n)),e[r?"before":"after"](i.trigger),i.trigger.on("click",function(){return t.datepicker._datepickerShowing&&t.datepicker._lastInput===e[0]?t.datepicker._hideDatepicker():t.datepicker._datepickerShowing&&t.datepicker._lastInput!==e[0]?(t.datepicker._hideDatepicker(),t.datepicker._showDatepicker(e[0])):t.datepicker._showDatepicker(e[0]),!1}))},_autoSize:function(t){if(this._get(t,"autoSize")&&!t.inline){var e,i,s,n,o=new Date(2009,11,20),a=this._get(t,"dateFormat");a.match(/[DM]/)&&(e=function(t){for(i=0,s=0,n=0;t.length>n;n++)t[n].length>i&&(i=t[n].length,s=n);return s},o.setMonth(e(this._get(t,a.match(/MM/)?"monthNames":"monthNamesShort"))),o.setDate(e(this._get(t,a.match(/DD/)?"dayNames":"dayNamesShort"))+20-o.getDay())),t.input.attr("size",this._formatDate(t,o).length)}},_inlineDatepicker:function(e,i){var s=t(e);s.hasClass(this.markerClassName)||(s.addClass(this.markerClassName).append(i.dpDiv),t.data(e,"datepicker",i),this._setDate(i,this._getDefaultDate(i),!0),this._updateDatepicker(i),this._updateAlternate(i),i.settings.disabled&&this._disableDatepicker(e),i.dpDiv.css("display","block"))},_dialogDatepicker:function(e,i,s,n,o){var r,l,h,c,u,d=this._dialogInst;return d||(this.uuid+=1,r="dp"+this.uuid,this._dialogInput=t("<input type='text' id='"+r+"' style='position: absolute; top: -100px; width: 0px;'/>"),this._dialogInput.on("keydown",this._doKeyDown),t("body").append(this._dialogInput),d=this._dialogInst=this._newInst(this._dialogInput,!1),d.settings={},t.data(this._dialogInput[0],"datepicker",d)),a(d.settings,n||{}),i=i&&i.constructor===Date?this._formatDate(d,i):i,this._dialogInput.val(i),this._pos=o?o.length?o:[o.pageX,o.pageY]:null,this._pos||(l=document.documentElement.clientWidth,h=document.documentElement.clientHeight,c=document.documentElement.scrollLeft||document.body.scrollLeft,u=document.documentElement.scrollTop||document.body.scrollTop,this._pos=[l/2-100+c,h/2-150+u]),this._dialogInput.css("left",this._pos[0]+20+"px").css("top",this._pos[1]+"px"),d.settings.onSelect=s,this._inDialog=!0,this.dpDiv.addClass(this._dialogClass),this._showDatepicker(this._dialogInput[0]),t.blockUI&&t.blockUI(this.dpDiv),t.data(this._dialogInput[0],"datepicker",d),this},_destroyDatepicker:function(e){var i,s=t(e),n=t.data(e,"datepicker");s.hasClass(this.markerClassName)&&(i=e.nodeName.toLowerCase(),t.removeData(e,"datepicker"),"input"===i?(n.append.remove(),n.trigger.remove(),s.removeClass(this.markerClassName).off("focus",this._showDatepicker).off("keydown",this._doKeyDown).off("keypress",this._doKeyPress).off("keyup",this._doKeyUp)):("div"===i||"span"===i)&&s.removeClass(this.markerClassName).empty(),u===n&&(u=null))},_enableDatepicker:function(e){var i,s,n=t(e),o=t.data(e,"datepicker");n.hasClass(this.markerClassName)&&(i=e.nodeName.toLowerCase(),"input"===i?(e.disabled=!1,o.trigger.filter("button").each(function(){this.disabled=!1}).end().filter("img").css({opacity:"1.0",cursor:""})):("div"===i||"span"===i)&&(s=n.children("."+this._inlineClass),s.children().removeClass("ui-state-disabled"),s.find("select.ui-datepicker-month, select.ui-datepicker-year").prop("disabled",!1)),this._disabledInputs=t.map(this._disabledInputs,function(t){return t===e?null:t}))},_disableDatepicker:function(e){var i,s,n=t(e),o=t.data(e,"datepicker");n.hasClass(this.markerClassName)&&(i=e.nodeName.toLowerCase(),"input"===i?(e.disabled=!0,o.trigger.filter("button").each(function(){this.disabled=!0}).end().filter("img").css({opacity:"0.5",cursor:"default"})):("div"===i||"span"===i)&&(s=n.children("."+this._inlineClass),s.children().addClass("ui-state-disabled"),s.find("select.ui-datepicker-month, select.ui-datepicker-year").prop("disabled",!0)),this._disabledInputs=t.map(this._disabledInputs,function(t){return t===e?null:t}),this._disabledInputs[this._disabledInputs.length]=e)},_isDisabledDatepicker:function(t){if(!t)return!1;for(var e=0;this._disabledInputs.length>e;e++)if(this._disabledInputs[e]===t)return!0;return!1},_getInst:function(e){try{return t.data(e,"datepicker")}catch(i){throw"Missing instance data for this datepicker"}},_optionDatepicker:function(e,i,s){var n,o,r,l,h=this._getInst(e);return 2===arguments.length&&"string"==typeof i?"defaults"===i?t.extend({},t.datepicker._defaults):h?"all"===i?t.extend({},h.settings):this._get(h,i):null:(n=i||{},"string"==typeof i&&(n={},n[i]=s),h&&(this._curInst===h&&this._hideDatepicker(),o=this._getDateDatepicker(e,!0),r=this._getMinMaxDate(h,"min"),l=this._getMinMaxDate(h,"max"),a(h.settings,n),null!==r&&void 0!==n.dateFormat&&void 0===n.minDate&&(h.settings.minDate=this._formatDate(h,r)),null!==l&&void 0!==n.dateFormat&&void 0===n.maxDate&&(h.settings.maxDate=this._formatDate(h,l)),"disabled"in n&&(n.disabled?this._disableDatepicker(e):this._enableDatepicker(e)),this._attachments(t(e),h),this._autoSize(h),this._setDate(h,o),this._updateAlternate(h),this._updateDatepicker(h)),void 0)},_changeDatepicker:function(t,e,i){this._optionDatepicker(t,e,i)},_refreshDatepicker:function(t){var e=this._getInst(t);e&&this._updateDatepicker(e)},_setDateDatepicker:function(t,e){var i=this._getInst(t);i&&(this._setDate(i,e),this._updateDatepicker(i),this._updateAlternate(i))},_getDateDatepicker:function(t,e){var i=this._getInst(t);return i&&!i.inline&&this._setDateFromField(i,e),i?this._getDate(i):null},_doKeyDown:function(e){var i,s,n,o=t.datepicker._getInst(e.target),a=!0,r=o.dpDiv.is(".ui-datepicker-rtl");if(o._keyEvent=!0,t.datepicker._datepickerShowing)switch(e.keyCode){case 9:t.datepicker._hideDatepicker(),a=!1;break;case 13:return n=t("td."+t.datepicker._dayOverClass+":not(."+t.datepicker._currentClass+")",o.dpDiv),n[0]&&t.datepicker._selectDay(e.target,o.selectedMonth,o.selectedYear,n[0]),i=t.datepicker._get(o,"onSelect"),i?(s=t.datepicker._formatDate(o),i.apply(o.input?o.input[0]:null,[s,o])):t.datepicker._hideDatepicker(),!1;case 27:t.datepicker._hideDatepicker();break;case 33:t.datepicker._adjustDate(e.target,e.ctrlKey?-t.datepicker._get(o,"stepBigMonths"):-t.datepicker._get(o,"stepMonths"),"M");break;case 34:t.datepicker._adjustDate(e.target,e.ctrlKey?+t.datepicker._get(o,"stepBigMonths"):+t.datepicker._get(o,"stepMonths"),"M");break;case 35:(e.ctrlKey||e.metaKey)&&t.datepicker._clearDate(e.target),a=e.ctrlKey||e.metaKey;break;case 36:(e.ctrlKey||e.metaKey)&&t.datepicker._gotoToday(e.target),a=e.ctrlKey||e.metaKey;break;case 37:(e.ctrlKey||e.metaKey)&&t.datepicker._adjustDate(e.target,r?1:-1,"D"),a=e.ctrlKey||e.metaKey,e.originalEvent.altKey&&t.datepicker._adjustDate(e.target,e.ctrlKey?-t.datepicker._get(o,"stepBigMonths"):-t.datepicker._get(o,"stepMonths"),"M");break;case 38:(e.ctrlKey||e.metaKey)&&t.datepicker._adjustDate(e.target,-7,"D"),a=e.ctrlKey||e.metaKey;break;case 39:(e.ctrlKey||e.metaKey)&&t.datepicker._adjustDate(e.target,r?-1:1,"D"),a=e.ctrlKey||e.metaKey,e.originalEvent.altKey&&t.datepicker._adjustDate(e.target,e.ctrlKey?+t.datepicker._get(o,"stepBigMonths"):+t.datepicker._get(o,"stepMonths"),"M");break;case 40:(e.ctrlKey||e.metaKey)&&t.datepicker._adjustDate(e.target,7,"D"),a=e.ctrlKey||e.metaKey;break;default:a=!1}else 36===e.keyCode&&e.ctrlKey?t.datepicker._showDatepicker(this):a=!1;a&&(e.preventDefault(),e.stopPropagation())},_doKeyPress:function(e){var i,s,n=t.datepicker._getInst(e.target);return t.datepicker._get(n,"constrainInput")?(i=t.datepicker._possibleChars(t.datepicker._get(n,"dateFormat")),s=String.fromCharCode(null==e.charCode?e.keyCode:e.charCode),e.ctrlKey||e.metaKey||" ">s||!i||i.indexOf(s)>-1):void 0},_doKeyUp:function(e){var i,s=t.datepicker._getInst(e.target);if(s.input.val()!==s.lastVal)try{i=t.datepicker.parseDate(t.datepicker._get(s,"dateFormat"),s.input?s.input.val():null,t.datepicker._getFormatConfig(s)),i&&(t.datepicker._setDateFromField(s),t.datepicker._updateAlternate(s),t.datepicker._updateDatepicker(s))}catch(n){}return!0},_showDatepicker:function(e){if(e=e.target||e,"input"!==e.nodeName.toLowerCase()&&(e=t("input",e.parentNode)[0]),!t.datepicker._isDisabledDatepicker(e)&&t.datepicker._lastInput!==e){var s,n,o,r,l,h,c;s=t.datepicker._getInst(e),t.datepicker._curInst&&t.datepicker._curInst!==s&&(t.datepicker._curInst.dpDiv.stop(!0,!0),s&&t.datepicker._datepickerShowing&&t.datepicker._hideDatepicker(t.datepicker._curInst.input[0])),n=t.datepicker._get(s,"beforeShow"),o=n?n.apply(e,[e,s]):{},o!==!1&&(a(s.settings,o),s.lastVal=null,t.datepicker._lastInput=e,t.datepicker._setDateFromField(s),t.datepicker._inDialog&&(e.value=""),t.datepicker._pos||(t.datepicker._pos=t.datepicker._findPos(e),t.datepicker._pos[1]+=e.offsetHeight),r=!1,t(e).parents().each(function(){return r|="fixed"===t(this).css("position"),!r}),l={left:t.datepicker._pos[0],top:t.datepicker._pos[1]},t.datepicker._pos=null,s.dpDiv.empty(),s.dpDiv.css({position:"absolute",display:"block",top:"-1000px"}),t.datepicker._updateDatepicker(s),l=t.datepicker._checkOffset(s,l,r),s.dpDiv.css({position:t.datepicker._inDialog&&t.blockUI?"static":r?"fixed":"absolute",display:"none",left:l.left+"px",top:l.top+"px"}),s.inline||(h=t.datepicker._get(s,"showAnim"),c=t.datepicker._get(s,"duration"),s.dpDiv.css("z-index",i(t(e))+1),t.datepicker._datepickerShowing=!0,t.effects&&t.effects.effect[h]?s.dpDiv.show(h,t.datepicker._get(s,"showOptions"),c):s.dpDiv[h||"show"](h?c:null),t.datepicker._shouldFocusInput(s)&&s.input.trigger("focus"),t.datepicker._curInst=s))}},_updateDatepicker:function(e){this.maxRows=4,u=e,e.dpDiv.empty().append(this._generateHTML(e)),this._attachHandlers(e);var i,s=this._getNumberOfMonths(e),n=s[1],a=17,r=e.dpDiv.find("."+this._dayOverClass+" a");r.length>0&&o.apply(r.get(0)),e.dpDiv.removeClass("ui-datepicker-multi-2 ui-datepicker-multi-3 ui-datepicker-multi-4").width(""),n>1&&e.dpDiv.addClass("ui-datepicker-multi-"+n).css("width",a*n+"em"),e.dpDiv[(1!==s[0]||1!==s[1]?"add":"remove")+"Class"]("ui-datepicker-multi"),e.dpDiv[(this._get(e,"isRTL")?"add":"remove")+"Class"]("ui-datepicker-rtl"),e===t.datepicker._curInst&&t.datepicker._datepickerShowing&&t.datepicker._shouldFocusInput(e)&&e.input.trigger("focus"),e.yearshtml&&(i=e.yearshtml,setTimeout(function(){i===e.yearshtml&&e.yearshtml&&e.dpDiv.find("select.ui-datepicker-year:first").replaceWith(e.yearshtml),i=e.yearshtml=null},0))},_shouldFocusInput:function(t){return t.input&&t.input.is(":visible")&&!t.input.is(":disabled")&&!t.input.is(":focus")},_checkOffset:function(e,i,s){var n=e.dpDiv.outerWidth(),o=e.dpDiv.outerHeight(),a=e.input?e.input.outerWidth():0,r=e.input?e.input.outerHeight():0,l=document.documentElement.clientWidth+(s?0:t(document).scrollLeft()),h=document.documentElement.clientHeight+(s?0:t(document).scrollTop());return i.left-=this._get(e,"isRTL")?n-a:0,i.left-=s&&i.left===e.input.offset().left?t(document).scrollLeft():0,i.top-=s&&i.top===e.input.offset().top+r?t(document).scrollTop():0,i.left-=Math.min(i.left,i.left+n>l&&l>n?Math.abs(i.left+n-l):0),i.top-=Math.min(i.top,i.top+o>h&&h>o?Math.abs(o+r):0),i},_findPos:function(e){for(var i,s=this._getInst(e),n=this._get(s,"isRTL");e&&("hidden"===e.type||1!==e.nodeType||t.expr.filters.hidden(e));)e=e[n?"previousSibling":"nextSibling"];return i=t(e).offset(),[i.left,i.top]},_hideDatepicker:function(e){var i,s,n,o,a=this._curInst;!a||e&&a!==t.data(e,"datepicker")||this._datepickerShowing&&(i=this._get(a,"showAnim"),s=this._get(a,"duration"),n=function(){t.datepicker._tidyDialog(a)},t.effects&&(t.effects.effect[i]||t.effects[i])?a.dpDiv.hide(i,t.datepicker._get(a,"showOptions"),s,n):a.dpDiv["slideDown"===i?"slideUp":"fadeIn"===i?"fadeOut":"hide"](i?s:null,n),i||n(),this._datepickerShowing=!1,o=this._get(a,"onClose"),o&&o.apply(a.input?a.input[0]:null,[a.input?a.input.val():"",a]),this._lastInput=null,this._inDialog&&(this._dialogInput.css({position:"absolute",left:"0",top:"-100px"}),t.blockUI&&(t.unblockUI(),t("body").append(this.dpDiv))),this._inDialog=!1)},_tidyDialog:function(t){t.dpDiv.removeClass(this._dialogClass).off(".ui-datepicker-calendar")},_checkExternalClick:function(e){if(t.datepicker._curInst){var i=t(e.target),s=t.datepicker._getInst(i[0]);(i[0].id!==t.datepicker._mainDivId&&0===i.parents("#"+t.datepicker._mainDivId).length&&!i.hasClass(t.datepicker.markerClassName)&&!i.closest("."+t.datepicker._triggerClass).length&&t.datepicker._datepickerShowing&&(!t.datepicker._inDialog||!t.blockUI)||i.hasClass(t.datepicker.markerClassName)&&t.datepicker._curInst!==s)&&t.datepicker._hideDatepicker()}},_adjustDate:function(e,i,s){var n=t(e),o=this._getInst(n[0]);this._isDisabledDatepicker(n[0])||(this._adjustInstDate(o,i+("M"===s?this._get(o,"showCurrentAtPos"):0),s),this._updateDatepicker(o))},_gotoToday:function(e){var i,s=t(e),n=this._getInst(s[0]);this._get(n,"gotoCurrent")&&n.currentDay?(n.selectedDay=n.currentDay,n.drawMonth=n.selectedMonth=n.currentMonth,n.drawYear=n.selectedYear=n.currentYear):(i=new Date,n.selectedDay=i.getDate(),n.drawMonth=n.selectedMonth=i.getMonth(),n.drawYear=n.selectedYear=i.getFullYear()),this._notifyChange(n),this._adjustDate(s)},_selectMonthYear:function(e,i,s){var n=t(e),o=this._getInst(n[0]);o["selected"+("M"===s?"Month":"Year")]=o["draw"+("M"===s?"Month":"Year")]=parseInt(i.options[i.selectedIndex].value,10),this._notifyChange(o),this._adjustDate(n)},_selectDay:function(e,i,s,n){var o,a=t(e);t(n).hasClass(this._unselectableClass)||this._isDisabledDatepicker(a[0])||(o=this._getInst(a[0]),o.selectedDay=o.currentDay=t("a",n).html(),o.selectedMonth=o.currentMonth=i,o.selectedYear=o.currentYear=s,this._selectDate(e,this._formatDate(o,o.currentDay,o.currentMonth,o.currentYear)))},_clearDate:function(e){var i=t(e);this._selectDate(i,"")},_selectDate:function(e,i){var s,n=t(e),o=this._getInst(n[0]);i=null!=i?i:this._formatDate(o),o.input&&o.input.val(i),this._updateAlternate(o),s=this._get(o,"onSelect"),s?s.apply(o.input?o.input[0]:null,[i,o]):o.input&&o.input.trigger("change"),o.inline?this._updateDatepicker(o):(this._hideDatepicker(),this._lastInput=o.input[0],"object"!=typeof o.input[0]&&o.input.trigger("focus"),this._lastInput=null)},_updateAlternate:function(e){var i,s,n,o=this._get(e,"altField");o&&(i=this._get(e,"altFormat")||this._get(e,"dateFormat"),s=this._getDate(e),n=this.formatDate(i,s,this._getFormatConfig(e)),t(o).val(n))},noWeekends:function(t){var e=t.getDay();return[e>0&&6>e,""]},iso8601Week:function(t){var e,i=new Date(t.getTime());return i.setDate(i.getDate()+4-(i.getDay()||7)),e=i.getTime(),i.setMonth(0),i.setDate(1),Math.floor(Math.round((e-i)/864e5)/7)+1},parseDate:function(e,i,s){if(null==e||null==i)throw"Invalid arguments";if(i="object"==typeof i?""+i:i+"",""===i)return null;var n,o,a,r,l=0,h=(s?s.shortYearCutoff:null)||this._defaults.shortYearCutoff,c="string"!=typeof h?h:(new Date).getFullYear()%100+parseInt(h,10),u=(s?s.dayNamesShort:null)||this._defaults.dayNamesShort,d=(s?s.dayNames:null)||this._defaults.dayNames,p=(s?s.monthNamesShort:null)||this._defaults.monthNamesShort,f=(s?s.monthNames:null)||this._defaults.monthNames,g=-1,m=-1,_=-1,v=-1,b=!1,y=function(t){var i=e.length>n+1&&e.charAt(n+1)===t;return i&&n++,i},w=function(t){var e=y(t),s="@"===t?14:"!"===t?20:"y"===t&&e?4:"o"===t?3:2,n="y"===t?s:1,o=RegExp("^\\d{"+n+","+s+"}"),a=i.substring(l).match(o);if(!a)throw"Missing number at position "+l;return l+=a[0].length,parseInt(a[0],10)},k=function(e,s,n){var o=-1,a=t.map(y(e)?n:s,function(t,e){return[[e,t]]}).sort(function(t,e){return-(t[1].length-e[1].length)});if(t.each(a,function(t,e){var s=e[1];return i.substr(l,s.length).toLowerCase()===s.toLowerCase()?(o=e[0],l+=s.length,!1):void 0}),-1!==o)return o+1;throw"Unknown name at position "+l},x=function(){if(i.charAt(l)!==e.charAt(n))throw"Unexpected literal at position "+l;l++};for(n=0;e.length>n;n++)if(b)"'"!==e.charAt(n)||y("'")?x():b=!1;else switch(e.charAt(n)){case"d":_=w("d");break;case"D":k("D",u,d);break;case"o":v=w("o");break;case"m":m=w("m");break;case"M":m=k("M",p,f);break;case"y":g=w("y");break;case"@":r=new Date(w("@")),g=r.getFullYear(),m=r.getMonth()+1,_=r.getDate();break;case"!":r=new Date((w("!")-this._ticksTo1970)/1e4),g=r.getFullYear(),m=r.getMonth()+1,_=r.getDate();break;case"'":y("'")?x():b=!0;break;default:x()}if(i.length>l&&(a=i.substr(l),!/^\s+/.test(a)))throw"Extra/unparsed characters found in date: "+a;if(-1===g?g=(new Date).getFullYear():100>g&&(g+=(new Date).getFullYear()-(new Date).getFullYear()%100+(c>=g?0:-100)),v>-1)for(m=1,_=v;;){if(o=this._getDaysInMonth(g,m-1),o>=_)break;m++,_-=o}if(r=this._daylightSavingAdjust(new Date(g,m-1,_)),r.getFullYear()!==g||r.getMonth()+1!==m||r.getDate()!==_)throw"Invalid date";return r},ATOM:"yy-mm-dd",COOKIE:"D, dd M yy",ISO_8601:"yy-mm-dd",RFC_822:"D, d M y",RFC_850:"DD, dd-M-y",RFC_1036:"D, d M y",RFC_1123:"D, d M yy",RFC_2822:"D, d M yy",RSS:"D, d M y",TICKS:"!",TIMESTAMP:"@",W3C:"yy-mm-dd",_ticksTo1970:1e7*60*60*24*(718685+Math.floor(492.5)-Math.floor(19.7)+Math.floor(4.925)),formatDate:function(t,e,i){if(!e)return"";var s,n=(i?i.dayNamesShort:null)||this._defaults.dayNamesShort,o=(i?i.dayNames:null)||this._defaults.dayNames,a=(i?i.monthNamesShort:null)||this._defaults.monthNamesShort,r=(i?i.monthNames:null)||this._defaults.monthNames,l=function(e){var i=t.length>s+1&&t.charAt(s+1)===e;return i&&s++,i},h=function(t,e,i){var s=""+e;if(l(t))for(;i>s.length;)s="0"+s;return s},c=function(t,e,i,s){return l(t)?s[e]:i[e]},u="",d=!1;if(e)for(s=0;t.length>s;s++)if(d)"'"!==t.charAt(s)||l("'")?u+=t.charAt(s):d=!1;else switch(t.charAt(s)){case"d":u+=h("d",e.getDate(),2);break;case"D":u+=c("D",e.getDay(),n,o);break;case"o":u+=h("o",Math.round((new Date(e.getFullYear(),e.getMonth(),e.getDate()).getTime()-new Date(e.getFullYear(),0,0).getTime())/864e5),3);break;case"m":u+=h("m",e.getMonth()+1,2);break;case"M":u+=c("M",e.getMonth(),a,r);break;case"y":u+=l("y")?e.getFullYear():(10>e.getFullYear()%100?"0":"")+e.getFullYear()%100;break;case"@":u+=e.getTime();break;case"!":u+=1e4*e.getTime()+this._ticksTo1970;break;case"'":l("'")?u+="'":d=!0;break;default:u+=t.charAt(s)}return u},_possibleChars:function(t){var e,i="",s=!1,n=function(i){var s=t.length>e+1&&t.charAt(e+1)===i;return s&&e++,s};for(e=0;t.length>e;e++)if(s)"'"!==t.charAt(e)||n("'")?i+=t.charAt(e):s=!1;else switch(t.charAt(e)){case"d":case"m":case"y":case"@":i+="0123456789";break;case"D":case"M":return null;case"'":n("'")?i+="'":s=!0;break;default:i+=t.charAt(e)}return i},_get:function(t,e){return void 0!==t.settings[e]?t.settings[e]:this._defaults[e]},_setDateFromField:function(t,e){if(t.input.val()!==t.lastVal){var i=this._get(t,"dateFormat"),s=t.lastVal=t.input?t.input.val():null,n=this._getDefaultDate(t),o=n,a=this._getFormatConfig(t);try{o=this.parseDate(i,s,a)||n}catch(r){s=e?"":s}t.selectedDay=o.getDate(),t.drawMonth=t.selectedMonth=o.getMonth(),t.drawYear=t.selectedYear=o.getFullYear(),t.currentDay=s?o.getDate():0,t.currentMonth=s?o.getMonth():0,t.currentYear=s?o.getFullYear():0,this._adjustInstDate(t)}},_getDefaultDate:function(t){return this._restrictMinMax(t,this._determineDate(t,this._get(t,"defaultDate"),new Date))},_determineDate:function(e,i,s){var n=function(t){var e=new Date;return e.setDate(e.getDate()+t),e},o=function(i){try{return t.datepicker.parseDate(t.datepicker._get(e,"dateFormat"),i,t.datepicker._getFormatConfig(e))}catch(s){}for(var n=(i.toLowerCase().match(/^c/)?t.datepicker._getDate(e):null)||new Date,o=n.getFullYear(),a=n.getMonth(),r=n.getDate(),l=/([+\-]?[0-9]+)\s*(d|D|w|W|m|M|y|Y)?/g,h=l.exec(i);h;){switch(h[2]||"d"){case"d":case"D":r+=parseInt(h[1],10);break;case"w":case"W":r+=7*parseInt(h[1],10);break;case"m":case"M":a+=parseInt(h[1],10),r=Math.min(r,t.datepicker._getDaysInMonth(o,a));break;case"y":case"Y":o+=parseInt(h[1],10),r=Math.min(r,t.datepicker._getDaysInMonth(o,a))}h=l.exec(i)}return new Date(o,a,r)},a=null==i||""===i?s:"string"==typeof i?o(i):"number"==typeof i?isNaN(i)?s:n(i):new Date(i.getTime());return a=a&&"Invalid Date"==""+a?s:a,a&&(a.setHours(0),a.setMinutes(0),a.setSeconds(0),a.setMilliseconds(0)),this._daylightSavingAdjust(a)},_daylightSavingAdjust:function(t){return t?(t.setHours(t.getHours()>12?t.getHours()+2:0),t):null},_setDate:function(t,e,i){var s=!e,n=t.selectedMonth,o=t.selectedYear,a=this._restrictMinMax(t,this._determineDate(t,e,new Date));t.selectedDay=t.currentDay=a.getDate(),t.drawMonth=t.selectedMonth=t.currentMonth=a.getMonth(),t.drawYear=t.selectedYear=t.currentYear=a.getFullYear(),n===t.selectedMonth&&o===t.selectedYear||i||this._notifyChange(t),this._adjustInstDate(t),t.input&&t.input.val(s?"":this._formatDate(t))},_getDate:function(t){var e=!t.currentYear||t.input&&""===t.input.val()?null:this._daylightSavingAdjust(new Date(t.currentYear,t.currentMonth,t.currentDay));return e},_attachHandlers:function(e){var i=this._get(e,"stepMonths"),s="#"+e.id.replace(/\\\\/g,"\\");e.dpDiv.find("[data-handler]").map(function(){var e={prev:function(){t.datepicker._adjustDate(s,-i,"M")},next:function(){t.datepicker._adjustDate(s,+i,"M")},hide:function(){t.datepicker._hideDatepicker()},today:function(){t.datepicker._gotoToday(s)},selectDay:function(){return t.datepicker._selectDay(s,+this.getAttribute("data-month"),+this.getAttribute("data-year"),this),!1},selectMonth:function(){return t.datepicker._selectMonthYear(s,this,"M"),!1},selectYear:function(){return t.datepicker._selectMonthYear(s,this,"Y"),!1}};t(this).on(this.getAttribute("data-event"),e[this.getAttribute("data-handler")])})},_generateHTML:function(t){var e,i,s,n,o,a,r,l,h,c,u,d,p,f,g,m,_,v,b,y,w,k,x,C,D,T,I,M,P,S,N,H,A,z,O,E,W,F,L,R=new Date,Y=this._daylightSavingAdjust(new Date(R.getFullYear(),R.getMonth(),R.getDate())),B=this._get(t,"isRTL"),j=this._get(t,"showButtonPanel"),q=this._get(t,"hideIfNoPrevNext"),K=this._get(t,"navigationAsDateFormat"),U=this._getNumberOfMonths(t),V=this._get(t,"showCurrentAtPos"),X=this._get(t,"stepMonths"),$=1!==U[0]||1!==U[1],G=this._daylightSavingAdjust(t.currentDay?new Date(t.currentYear,t.currentMonth,t.currentDay):new Date(9999,9,9)),J=this._getMinMaxDate(t,"min"),Q=this._getMinMaxDate(t,"max"),Z=t.drawMonth-V,te=t.drawYear;if(0>Z&&(Z+=12,te--),Q)for(e=this._daylightSavingAdjust(new Date(Q.getFullYear(),Q.getMonth()-U[0]*U[1]+1,Q.getDate())),e=J&&J>e?J:e;this._daylightSavingAdjust(new Date(te,Z,1))>e;)Z--,0>Z&&(Z=11,te--);for(t.drawMonth=Z,t.drawYear=te,i=this._get(t,"prevText"),i=K?this.formatDate(i,this._daylightSavingAdjust(new Date(te,Z-X,1)),this._getFormatConfig(t)):i,s=this._canAdjustMonth(t,-1,te,Z)?"<a class='ui-datepicker-prev ui-corner-all' data-handler='prev' data-event='click' title='"+i+"'><span class='ui-icon ui-icon-circle-triangle-"+(B?"e":"w")+"'>"+i+"</span></a>":q?"":"<a class='ui-datepicker-prev ui-corner-all ui-state-disabled' title='"+i+"'><span class='ui-icon ui-icon-circle-triangle-"+(B?"e":"w")+"'>"+i+"</span></a>",n=this._get(t,"nextText"),n=K?this.formatDate(n,this._daylightSavingAdjust(new Date(te,Z+X,1)),this._getFormatConfig(t)):n,o=this._canAdjustMonth(t,1,te,Z)?"<a class='ui-datepicker-next ui-corner-all' data-handler='next' data-event='click' title='"+n+"'><span class='ui-icon ui-icon-circle-triangle-"+(B?"w":"e")+"'>"+n+"</span></a>":q?"":"<a class='ui-datepicker-next ui-corner-all ui-state-disabled' title='"+n+"'><span class='ui-icon ui-icon-circle-triangle-"+(B?"w":"e")+"'>"+n+"</span></a>",a=this._get(t,"currentText"),r=this._get(t,"gotoCurrent")&&t.currentDay?G:Y,a=K?this.formatDate(a,r,this._getFormatConfig(t)):a,l=t.inline?"":"<button type='button' class='ui-datepicker-close ui-state-default ui-priority-primary ui-corner-all' data-handler='hide' data-event='click'>"+this._get(t,"closeText")+"</button>",h=j?"<div class='ui-datepicker-buttonpane ui-widget-content'>"+(B?l:"")+(this._isInRange(t,r)?"<button type='button' class='ui-datepicker-current ui-state-default ui-priority-secondary ui-corner-all' data-handler='today' data-event='click'>"+a+"</button>":"")+(B?"":l)+"</div>":"",c=parseInt(this._get(t,"firstDay"),10),c=isNaN(c)?0:c,u=this._get(t,"showWeek"),d=this._get(t,"dayNames"),p=this._get(t,"dayNamesMin"),f=this._get(t,"monthNames"),g=this._get(t,"monthNamesShort"),m=this._get(t,"beforeShowDay"),_=this._get(t,"showOtherMonths"),v=this._get(t,"selectOtherMonths"),b=this._getDefaultDate(t),y="",k=0;U[0]>k;k++){for(x="",this.maxRows=4,C=0;U[1]>C;C++){if(D=this._daylightSavingAdjust(new Date(te,Z,t.selectedDay)),T=" ui-corner-all",I="",$){if(I+="<div class='ui-datepicker-group",U[1]>1)switch(C){case 0:I+=" ui-datepicker-group-first",T=" ui-corner-"+(B?"right":"left");break;case U[1]-1:I+=" ui-datepicker-group-last",T=" ui-corner-"+(B?"left":"right");break;default:I+=" ui-datepicker-group-middle",T=""}I+="'>"}for(I+="<div class='ui-datepicker-header ui-widget-header ui-helper-clearfix"+T+"'>"+(/all|left/.test(T)&&0===k?B?o:s:"")+(/all|right/.test(T)&&0===k?B?s:o:"")+this._generateMonthYearHeader(t,Z,te,J,Q,k>0||C>0,f,g)+"</div><table class='ui-datepicker-calendar'><thead>"+"<tr>",M=u?"<th class='ui-datepicker-week-col'>"+this._get(t,"weekHeader")+"</th>":"",w=0;7>w;w++)P=(w+c)%7,M+="<th scope='col'"+((w+c+6)%7>=5?" class='ui-datepicker-week-end'":"")+">"+"<span title='"+d[P]+"'>"+p[P]+"</span></th>";for(I+=M+"</tr></thead><tbody>",S=this._getDaysInMonth(te,Z),te===t.selectedYear&&Z===t.selectedMonth&&(t.selectedDay=Math.min(t.selectedDay,S)),N=(this._getFirstDayOfMonth(te,Z)-c+7)%7,H=Math.ceil((N+S)/7),A=$?this.maxRows>H?this.maxRows:H:H,this.maxRows=A,z=this._daylightSavingAdjust(new Date(te,Z,1-N)),O=0;A>O;O++){for(I+="<tr>",E=u?"<td class='ui-datepicker-week-col'>"+this._get(t,"calculateWeek")(z)+"</td>":"",w=0;7>w;w++)W=m?m.apply(t.input?t.input[0]:null,[z]):[!0,""],F=z.getMonth()!==Z,L=F&&!v||!W[0]||J&&J>z||Q&&z>Q,E+="<td class='"+((w+c+6)%7>=5?" ui-datepicker-week-end":"")+(F?" ui-datepicker-other-month":"")+(z.getTime()===D.getTime()&&Z===t.selectedMonth&&t._keyEvent||b.getTime()===z.getTime()&&b.getTime()===D.getTime()?" "+this._dayOverClass:"")+(L?" "+this._unselectableClass+" ui-state-disabled":"")+(F&&!_?"":" "+W[1]+(z.getTime()===G.getTime()?" "+this._currentClass:"")+(z.getTime()===Y.getTime()?" ui-datepicker-today":""))+"'"+(F&&!_||!W[2]?"":" title='"+W[2].replace(/'/g,"&#39;")+"'")+(L?"":" data-handler='selectDay' data-event='click' data-month='"+z.getMonth()+"' data-year='"+z.getFullYear()+"'")+">"+(F&&!_?"&#xa0;":L?"<span class='ui-state-default'>"+z.getDate()+"</span>":"<a class='ui-state-default"+(z.getTime()===Y.getTime()?" ui-state-highlight":"")+(z.getTime()===G.getTime()?" ui-state-active":"")+(F?" ui-priority-secondary":"")+"' href='#'>"+z.getDate()+"</a>")+"</td>",z.setDate(z.getDate()+1),z=this._daylightSavingAdjust(z);I+=E+"</tr>"}Z++,Z>11&&(Z=0,te++),I+="</tbody></table>"+($?"</div>"+(U[0]>0&&C===U[1]-1?"<div class='ui-datepicker-row-break'></div>":""):""),x+=I}y+=x}return y+=h,t._keyEvent=!1,y},_generateMonthYearHeader:function(t,e,i,s,n,o,a,r){var l,h,c,u,d,p,f,g,m=this._get(t,"changeMonth"),_=this._get(t,"changeYear"),v=this._get(t,"showMonthAfterYear"),b="<div class='ui-datepicker-title'>",y="";if(o||!m)y+="<span class='ui-datepicker-month'>"+a[e]+"</span>";else{for(l=s&&s.getFullYear()===i,h=n&&n.getFullYear()===i,y+="<select class='ui-datepicker-month' data-handler='selectMonth' data-event='change'>",c=0;12>c;c++)(!l||c>=s.getMonth())&&(!h||n.getMonth()>=c)&&(y+="<option value='"+c+"'"+(c===e?" selected='selected'":"")+">"+r[c]+"</option>");
y+="</select>"}if(v||(b+=y+(!o&&m&&_?"":"&#xa0;")),!t.yearshtml)if(t.yearshtml="",o||!_)b+="<span class='ui-datepicker-year'>"+i+"</span>";else{for(u=this._get(t,"yearRange").split(":"),d=(new Date).getFullYear(),p=function(t){var e=t.match(/c[+\-].*/)?i+parseInt(t.substring(1),10):t.match(/[+\-].*/)?d+parseInt(t,10):parseInt(t,10);return isNaN(e)?d:e},f=p(u[0]),g=Math.max(f,p(u[1]||"")),f=s?Math.max(f,s.getFullYear()):f,g=n?Math.min(g,n.getFullYear()):g,t.yearshtml+="<select class='ui-datepicker-year' data-handler='selectYear' data-event='change'>";g>=f;f++)t.yearshtml+="<option value='"+f+"'"+(f===i?" selected='selected'":"")+">"+f+"</option>";t.yearshtml+="</select>",b+=t.yearshtml,t.yearshtml=null}return b+=this._get(t,"yearSuffix"),v&&(b+=(!o&&m&&_?"":"&#xa0;")+y),b+="</div>"},_adjustInstDate:function(t,e,i){var s=t.selectedYear+("Y"===i?e:0),n=t.selectedMonth+("M"===i?e:0),o=Math.min(t.selectedDay,this._getDaysInMonth(s,n))+("D"===i?e:0),a=this._restrictMinMax(t,this._daylightSavingAdjust(new Date(s,n,o)));t.selectedDay=a.getDate(),t.drawMonth=t.selectedMonth=a.getMonth(),t.drawYear=t.selectedYear=a.getFullYear(),("M"===i||"Y"===i)&&this._notifyChange(t)},_restrictMinMax:function(t,e){var i=this._getMinMaxDate(t,"min"),s=this._getMinMaxDate(t,"max"),n=i&&i>e?i:e;return s&&n>s?s:n},_notifyChange:function(t){var e=this._get(t,"onChangeMonthYear");e&&e.apply(t.input?t.input[0]:null,[t.selectedYear,t.selectedMonth+1,t])},_getNumberOfMonths:function(t){var e=this._get(t,"numberOfMonths");return null==e?[1,1]:"number"==typeof e?[1,e]:e},_getMinMaxDate:function(t,e){return this._determineDate(t,this._get(t,e+"Date"),null)},_getDaysInMonth:function(t,e){return 32-this._daylightSavingAdjust(new Date(t,e,32)).getDate()},_getFirstDayOfMonth:function(t,e){return new Date(t,e,1).getDay()},_canAdjustMonth:function(t,e,i,s){var n=this._getNumberOfMonths(t),o=this._daylightSavingAdjust(new Date(i,s+(0>e?e:n[0]*n[1]),1));return 0>e&&o.setDate(this._getDaysInMonth(o.getFullYear(),o.getMonth())),this._isInRange(t,o)},_isInRange:function(t,e){var i,s,n=this._getMinMaxDate(t,"min"),o=this._getMinMaxDate(t,"max"),a=null,r=null,l=this._get(t,"yearRange");return l&&(i=l.split(":"),s=(new Date).getFullYear(),a=parseInt(i[0],10),r=parseInt(i[1],10),i[0].match(/[+\-].*/)&&(a+=s),i[1].match(/[+\-].*/)&&(r+=s)),(!n||e.getTime()>=n.getTime())&&(!o||e.getTime()<=o.getTime())&&(!a||e.getFullYear()>=a)&&(!r||r>=e.getFullYear())},_getFormatConfig:function(t){var e=this._get(t,"shortYearCutoff");return e="string"!=typeof e?e:(new Date).getFullYear()%100+parseInt(e,10),{shortYearCutoff:e,dayNamesShort:this._get(t,"dayNamesShort"),dayNames:this._get(t,"dayNames"),monthNamesShort:this._get(t,"monthNamesShort"),monthNames:this._get(t,"monthNames")}},_formatDate:function(t,e,i,s){e||(t.currentDay=t.selectedDay,t.currentMonth=t.selectedMonth,t.currentYear=t.selectedYear);var n=e?"object"==typeof e?e:this._daylightSavingAdjust(new Date(s,i,e)):this._daylightSavingAdjust(new Date(t.currentYear,t.currentMonth,t.currentDay));return this.formatDate(this._get(t,"dateFormat"),n,this._getFormatConfig(t))}}),t.fn.datepicker=function(e){if(!this.length)return this;t.datepicker.initialized||(t(document).on("mousedown",t.datepicker._checkExternalClick),t.datepicker.initialized=!0),0===t("#"+t.datepicker._mainDivId).length&&t("body").append(t.datepicker.dpDiv);var i=Array.prototype.slice.call(arguments,1);return"string"!=typeof e||"isDisabled"!==e&&"getDate"!==e&&"widget"!==e?"option"===e&&2===arguments.length&&"string"==typeof arguments[1]?t.datepicker["_"+e+"Datepicker"].apply(t.datepicker,[this[0]].concat(i)):this.each(function(){"string"==typeof e?t.datepicker["_"+e+"Datepicker"].apply(t.datepicker,[this].concat(i)):t.datepicker._attachDatepicker(this,e)}):t.datepicker["_"+e+"Datepicker"].apply(t.datepicker,[this[0]].concat(i))},t.datepicker=new s,t.datepicker.initialized=!1,t.datepicker.uuid=(new Date).getTime(),t.datepicker.version="1.12.1",t.datepicker,t.widget("ui.dialog",{version:"1.12.1",options:{appendTo:"body",autoOpen:!0,buttons:[],classes:{"ui-dialog":"ui-corner-all","ui-dialog-titlebar":"ui-corner-all"},closeOnEscape:!0,closeText:"Close",draggable:!0,hide:null,height:"auto",maxHeight:null,maxWidth:null,minHeight:150,minWidth:150,modal:!1,position:{my:"center",at:"center",of:window,collision:"fit",using:function(e){var i=t(this).css(e).offset().top;0>i&&t(this).css("top",e.top-i)}},resizable:!0,show:null,title:null,width:300,beforeClose:null,close:null,drag:null,dragStart:null,dragStop:null,focus:null,open:null,resize:null,resizeStart:null,resizeStop:null},sizeRelatedOptions:{buttons:!0,height:!0,maxHeight:!0,maxWidth:!0,minHeight:!0,minWidth:!0,width:!0},resizableRelatedOptions:{maxHeight:!0,maxWidth:!0,minHeight:!0,minWidth:!0},_create:function(){this.originalCss={display:this.element[0].style.display,width:this.element[0].style.width,minHeight:this.element[0].style.minHeight,maxHeight:this.element[0].style.maxHeight,height:this.element[0].style.height},this.originalPosition={parent:this.element.parent(),index:this.element.parent().children().index(this.element)},this.originalTitle=this.element.attr("title"),null==this.options.title&&null!=this.originalTitle&&(this.options.title=this.originalTitle),this.options.disabled&&(this.options.disabled=!1),this._createWrapper(),this.element.show().removeAttr("title").appendTo(this.uiDialog),this._addClass("ui-dialog-content","ui-widget-content"),this._createTitlebar(),this._createButtonPane(),this.options.draggable&&t.fn.draggable&&this._makeDraggable(),this.options.resizable&&t.fn.resizable&&this._makeResizable(),this._isOpen=!1,this._trackFocus()},_init:function(){this.options.autoOpen&&this.open()},_appendTo:function(){var e=this.options.appendTo;return e&&(e.jquery||e.nodeType)?t(e):this.document.find(e||"body").eq(0)},_destroy:function(){var t,e=this.originalPosition;this._untrackInstance(),this._destroyOverlay(),this.element.removeUniqueId().css(this.originalCss).detach(),this.uiDialog.remove(),this.originalTitle&&this.element.attr("title",this.originalTitle),t=e.parent.children().eq(e.index),t.length&&t[0]!==this.element[0]?t.before(this.element):e.parent.append(this.element)},widget:function(){return this.uiDialog},disable:t.noop,enable:t.noop,close:function(e){var i=this;this._isOpen&&this._trigger("beforeClose",e)!==!1&&(this._isOpen=!1,this._focusedElement=null,this._destroyOverlay(),this._untrackInstance(),this.opener.filter(":focusable").trigger("focus").length||t.ui.safeBlur(t.ui.safeActiveElement(this.document[0])),this._hide(this.uiDialog,this.options.hide,function(){i._trigger("close",e)}))},isOpen:function(){return this._isOpen},moveToTop:function(){this._moveToTop()},_moveToTop:function(e,i){var s=!1,n=this.uiDialog.siblings(".ui-front:visible").map(function(){return+t(this).css("z-index")}).get(),o=Math.max.apply(null,n);return o>=+this.uiDialog.css("z-index")&&(this.uiDialog.css("z-index",o+1),s=!0),s&&!i&&this._trigger("focus",e),s},open:function(){var e=this;return this._isOpen?(this._moveToTop()&&this._focusTabbable(),void 0):(this._isOpen=!0,this.opener=t(t.ui.safeActiveElement(this.document[0])),this._size(),this._position(),this._createOverlay(),this._moveToTop(null,!0),this.overlay&&this.overlay.css("z-index",this.uiDialog.css("z-index")-1),this._show(this.uiDialog,this.options.show,function(){e._focusTabbable(),e._trigger("focus")}),this._makeFocusTarget(),this._trigger("open"),void 0)},_focusTabbable:function(){var t=this._focusedElement;t||(t=this.element.find("[autofocus]")),t.length||(t=this.element.find(":tabbable")),t.length||(t=this.uiDialogButtonPane.find(":tabbable")),t.length||(t=this.uiDialogTitlebarClose.filter(":tabbable")),t.length||(t=this.uiDialog),t.eq(0).trigger("focus")},_keepFocus:function(e){function i(){var e=t.ui.safeActiveElement(this.document[0]),i=this.uiDialog[0]===e||t.contains(this.uiDialog[0],e);i||this._focusTabbable()}e.preventDefault(),i.call(this),this._delay(i)},_createWrapper:function(){this.uiDialog=t("<div>").hide().attr({tabIndex:-1,role:"dialog"}).appendTo(this._appendTo()),this._addClass(this.uiDialog,"ui-dialog","ui-widget ui-widget-content ui-front"),this._on(this.uiDialog,{keydown:function(e){if(this.options.closeOnEscape&&!e.isDefaultPrevented()&&e.keyCode&&e.keyCode===t.ui.keyCode.ESCAPE)return e.preventDefault(),this.close(e),void 0;if(e.keyCode===t.ui.keyCode.TAB&&!e.isDefaultPrevented()){var i=this.uiDialog.find(":tabbable"),s=i.filter(":first"),n=i.filter(":last");e.target!==n[0]&&e.target!==this.uiDialog[0]||e.shiftKey?e.target!==s[0]&&e.target!==this.uiDialog[0]||!e.shiftKey||(this._delay(function(){n.trigger("focus")}),e.preventDefault()):(this._delay(function(){s.trigger("focus")}),e.preventDefault())}},mousedown:function(t){this._moveToTop(t)&&this._focusTabbable()}}),this.element.find("[aria-describedby]").length||this.uiDialog.attr({"aria-describedby":this.element.uniqueId().attr("id")})},_createTitlebar:function(){var e;this.uiDialogTitlebar=t("<div>"),this._addClass(this.uiDialogTitlebar,"ui-dialog-titlebar","ui-widget-header ui-helper-clearfix"),this._on(this.uiDialogTitlebar,{mousedown:function(e){t(e.target).closest(".ui-dialog-titlebar-close")||this.uiDialog.trigger("focus")}}),this.uiDialogTitlebarClose=t("<button type='button'></button>").button({label:t("<a>").text(this.options.closeText).html(),icon:"ui-icon-closethick",showLabel:!1}).appendTo(this.uiDialogTitlebar),this._addClass(this.uiDialogTitlebarClose,"ui-dialog-titlebar-close"),this._on(this.uiDialogTitlebarClose,{click:function(t){t.preventDefault(),this.close(t)}}),e=t("<span>").uniqueId().prependTo(this.uiDialogTitlebar),this._addClass(e,"ui-dialog-title"),this._title(e),this.uiDialogTitlebar.prependTo(this.uiDialog),this.uiDialog.attr({"aria-labelledby":e.attr("id")})},_title:function(t){this.options.title?t.text(this.options.title):t.html("&#160;")},_createButtonPane:function(){this.uiDialogButtonPane=t("<div>"),this._addClass(this.uiDialogButtonPane,"ui-dialog-buttonpane","ui-widget-content ui-helper-clearfix"),this.uiButtonSet=t("<div>").appendTo(this.uiDialogButtonPane),this._addClass(this.uiButtonSet,"ui-dialog-buttonset"),this._createButtons()},_createButtons:function(){var e=this,i=this.options.buttons;return this.uiDialogButtonPane.remove(),this.uiButtonSet.empty(),t.isEmptyObject(i)||t.isArray(i)&&!i.length?(this._removeClass(this.uiDialog,"ui-dialog-buttons"),void 0):(t.each(i,function(i,s){var n,o;s=t.isFunction(s)?{click:s,text:i}:s,s=t.extend({type:"button"},s),n=s.click,o={icon:s.icon,iconPosition:s.iconPosition,showLabel:s.showLabel,icons:s.icons,text:s.text},delete s.click,delete s.icon,delete s.iconPosition,delete s.showLabel,delete s.icons,"boolean"==typeof s.text&&delete s.text,t("<button></button>",s).button(o).appendTo(e.uiButtonSet).on("click",function(){n.apply(e.element[0],arguments)})}),this._addClass(this.uiDialog,"ui-dialog-buttons"),this.uiDialogButtonPane.appendTo(this.uiDialog),void 0)},_makeDraggable:function(){function e(t){return{position:t.position,offset:t.offset}}var i=this,s=this.options;this.uiDialog.draggable({cancel:".ui-dialog-content, .ui-dialog-titlebar-close",handle:".ui-dialog-titlebar",containment:"document",start:function(s,n){i._addClass(t(this),"ui-dialog-dragging"),i._blockFrames(),i._trigger("dragStart",s,e(n))},drag:function(t,s){i._trigger("drag",t,e(s))},stop:function(n,o){var a=o.offset.left-i.document.scrollLeft(),r=o.offset.top-i.document.scrollTop();s.position={my:"left top",at:"left"+(a>=0?"+":"")+a+" "+"top"+(r>=0?"+":"")+r,of:i.window},i._removeClass(t(this),"ui-dialog-dragging"),i._unblockFrames(),i._trigger("dragStop",n,e(o))}})},_makeResizable:function(){function e(t){return{originalPosition:t.originalPosition,originalSize:t.originalSize,position:t.position,size:t.size}}var i=this,s=this.options,n=s.resizable,o=this.uiDialog.css("position"),a="string"==typeof n?n:"n,e,s,w,se,sw,ne,nw";this.uiDialog.resizable({cancel:".ui-dialog-content",containment:"document",alsoResize:this.element,maxWidth:s.maxWidth,maxHeight:s.maxHeight,minWidth:s.minWidth,minHeight:this._minHeight(),handles:a,start:function(s,n){i._addClass(t(this),"ui-dialog-resizing"),i._blockFrames(),i._trigger("resizeStart",s,e(n))},resize:function(t,s){i._trigger("resize",t,e(s))},stop:function(n,o){var a=i.uiDialog.offset(),r=a.left-i.document.scrollLeft(),l=a.top-i.document.scrollTop();s.height=i.uiDialog.height(),s.width=i.uiDialog.width(),s.position={my:"left top",at:"left"+(r>=0?"+":"")+r+" "+"top"+(l>=0?"+":"")+l,of:i.window},i._removeClass(t(this),"ui-dialog-resizing"),i._unblockFrames(),i._trigger("resizeStop",n,e(o))}}).css("position",o)},_trackFocus:function(){this._on(this.widget(),{focusin:function(e){this._makeFocusTarget(),this._focusedElement=t(e.target)}})},_makeFocusTarget:function(){this._untrackInstance(),this._trackingInstances().unshift(this)},_untrackInstance:function(){var e=this._trackingInstances(),i=t.inArray(this,e);-1!==i&&e.splice(i,1)},_trackingInstances:function(){var t=this.document.data("ui-dialog-instances");return t||(t=[],this.document.data("ui-dialog-instances",t)),t},_minHeight:function(){var t=this.options;return"auto"===t.height?t.minHeight:Math.min(t.minHeight,t.height)},_position:function(){var t=this.uiDialog.is(":visible");t||this.uiDialog.show(),this.uiDialog.position(this.options.position),t||this.uiDialog.hide()},_setOptions:function(e){var i=this,s=!1,n={};t.each(e,function(t,e){i._setOption(t,e),t in i.sizeRelatedOptions&&(s=!0),t in i.resizableRelatedOptions&&(n[t]=e)}),s&&(this._size(),this._position()),this.uiDialog.is(":data(ui-resizable)")&&this.uiDialog.resizable("option",n)},_setOption:function(e,i){var s,n,o=this.uiDialog;"disabled"!==e&&(this._super(e,i),"appendTo"===e&&this.uiDialog.appendTo(this._appendTo()),"buttons"===e&&this._createButtons(),"closeText"===e&&this.uiDialogTitlebarClose.button({label:t("<a>").text(""+this.options.closeText).html()}),"draggable"===e&&(s=o.is(":data(ui-draggable)"),s&&!i&&o.draggable("destroy"),!s&&i&&this._makeDraggable()),"position"===e&&this._position(),"resizable"===e&&(n=o.is(":data(ui-resizable)"),n&&!i&&o.resizable("destroy"),n&&"string"==typeof i&&o.resizable("option","handles",i),n||i===!1||this._makeResizable()),"title"===e&&this._title(this.uiDialogTitlebar.find(".ui-dialog-title")))},_size:function(){var t,e,i,s=this.options;this.element.show().css({width:"auto",minHeight:0,maxHeight:"none",height:0}),s.minWidth>s.width&&(s.width=s.minWidth),t=this.uiDialog.css({height:"auto",width:s.width}).outerHeight(),e=Math.max(0,s.minHeight-t),i="number"==typeof s.maxHeight?Math.max(0,s.maxHeight-t):"none","auto"===s.height?this.element.css({minHeight:e,maxHeight:i,height:"auto"}):this.element.height(Math.max(0,s.height-t)),this.uiDialog.is(":data(ui-resizable)")&&this.uiDialog.resizable("option","minHeight",this._minHeight())},_blockFrames:function(){this.iframeBlocks=this.document.find("iframe").map(function(){var e=t(this);return t("<div>").css({position:"absolute",width:e.outerWidth(),height:e.outerHeight()}).appendTo(e.parent()).offset(e.offset())[0]})},_unblockFrames:function(){this.iframeBlocks&&(this.iframeBlocks.remove(),delete this.iframeBlocks)},_allowInteraction:function(e){return t(e.target).closest(".ui-dialog").length?!0:!!t(e.target).closest(".ui-datepicker").length},_createOverlay:function(){if(this.options.modal){var e=!0;this._delay(function(){e=!1}),this.document.data("ui-dialog-overlays")||this._on(this.document,{focusin:function(t){e||this._allowInteraction(t)||(t.preventDefault(),this._trackingInstances()[0]._focusTabbable())}}),this.overlay=t("<div>").appendTo(this._appendTo()),this._addClass(this.overlay,null,"ui-widget-overlay ui-front"),this._on(this.overlay,{mousedown:"_keepFocus"}),this.document.data("ui-dialog-overlays",(this.document.data("ui-dialog-overlays")||0)+1)}},_destroyOverlay:function(){if(this.options.modal&&this.overlay){var t=this.document.data("ui-dialog-overlays")-1;t?this.document.data("ui-dialog-overlays",t):(this._off(this.document,"focusin"),this.document.removeData("ui-dialog-overlays")),this.overlay.remove(),this.overlay=null}}}),t.uiBackCompat!==!1&&t.widget("ui.dialog",t.ui.dialog,{options:{dialogClass:""},_createWrapper:function(){this._super(),this.uiDialog.addClass(this.options.dialogClass)},_setOption:function(t,e){"dialogClass"===t&&this.uiDialog.removeClass(this.options.dialogClass).addClass(e),this._superApply(arguments)}}),t.ui.dialog,t.widget("ui.tabs",{version:"1.12.1",delay:300,options:{active:null,classes:{"ui-tabs":"ui-corner-all","ui-tabs-nav":"ui-corner-all","ui-tabs-panel":"ui-corner-bottom","ui-tabs-tab":"ui-corner-top"},collapsible:!1,event:"click",heightStyle:"content",hide:null,show:null,activate:null,beforeActivate:null,beforeLoad:null,load:null},_isLocal:function(){var t=/#.*$/;return function(e){var i,s;i=e.href.replace(t,""),s=location.href.replace(t,"");try{i=decodeURIComponent(i)}catch(n){}try{s=decodeURIComponent(s)}catch(n){}return e.hash.length>1&&i===s}}(),_create:function(){var e=this,i=this.options;this.running=!1,this._addClass("ui-tabs","ui-widget ui-widget-content"),this._toggleClass("ui-tabs-collapsible",null,i.collapsible),this._processTabs(),i.active=this._initialActive(),t.isArray(i.disabled)&&(i.disabled=t.unique(i.disabled.concat(t.map(this.tabs.filter(".ui-state-disabled"),function(t){return e.tabs.index(t)}))).sort()),this.active=this.options.active!==!1&&this.anchors.length?this._findActive(i.active):t(),this._refresh(),this.active.length&&this.load(i.active)},_initialActive:function(){var e=this.options.active,i=this.options.collapsible,s=location.hash.substring(1);return null===e&&(s&&this.tabs.each(function(i,n){return t(n).attr("aria-controls")===s?(e=i,!1):void 0}),null===e&&(e=this.tabs.index(this.tabs.filter(".ui-tabs-active"))),(null===e||-1===e)&&(e=this.tabs.length?0:!1)),e!==!1&&(e=this.tabs.index(this.tabs.eq(e)),-1===e&&(e=i?!1:0)),!i&&e===!1&&this.anchors.length&&(e=0),e},_getCreateEventData:function(){return{tab:this.active,panel:this.active.length?this._getPanelForTab(this.active):t()}},_tabKeydown:function(e){var i=t(t.ui.safeActiveElement(this.document[0])).closest("li"),s=this.tabs.index(i),n=!0;if(!this._handlePageNav(e)){switch(e.keyCode){case t.ui.keyCode.RIGHT:case t.ui.keyCode.DOWN:s++;break;case t.ui.keyCode.UP:case t.ui.keyCode.LEFT:n=!1,s--;break;case t.ui.keyCode.END:s=this.anchors.length-1;break;case t.ui.keyCode.HOME:s=0;break;case t.ui.keyCode.SPACE:return e.preventDefault(),clearTimeout(this.activating),this._activate(s),void 0;case t.ui.keyCode.ENTER:return e.preventDefault(),clearTimeout(this.activating),this._activate(s===this.options.active?!1:s),void 0;default:return}e.preventDefault(),clearTimeout(this.activating),s=this._focusNextTab(s,n),e.ctrlKey||e.metaKey||(i.attr("aria-selected","false"),this.tabs.eq(s).attr("aria-selected","true"),this.activating=this._delay(function(){this.option("active",s)},this.delay))}},_panelKeydown:function(e){this._handlePageNav(e)||e.ctrlKey&&e.keyCode===t.ui.keyCode.UP&&(e.preventDefault(),this.active.trigger("focus"))},_handlePageNav:function(e){return e.altKey&&e.keyCode===t.ui.keyCode.PAGE_UP?(this._activate(this._focusNextTab(this.options.active-1,!1)),!0):e.altKey&&e.keyCode===t.ui.keyCode.PAGE_DOWN?(this._activate(this._focusNextTab(this.options.active+1,!0)),!0):void 0},_findNextTab:function(e,i){function s(){return e>n&&(e=0),0>e&&(e=n),e}for(var n=this.tabs.length-1;-1!==t.inArray(s(),this.options.disabled);)e=i?e+1:e-1;return e},_focusNextTab:function(t,e){return t=this._findNextTab(t,e),this.tabs.eq(t).trigger("focus"),t},_setOption:function(t,e){return"active"===t?(this._activate(e),void 0):(this._super(t,e),"collapsible"===t&&(this._toggleClass("ui-tabs-collapsible",null,e),e||this.options.active!==!1||this._activate(0)),"event"===t&&this._setupEvents(e),"heightStyle"===t&&this._setupHeightStyle(e),void 0)},_sanitizeSelector:function(t){return t?t.replace(/[!"$%&'()*+,.\/:;<=>?@\[\]\^`{|}~]/g,"\\$&"):""},refresh:function(){var e=this.options,i=this.tablist.children(":has(a[href])");e.disabled=t.map(i.filter(".ui-state-disabled"),function(t){return i.index(t)}),this._processTabs(),e.active!==!1&&this.anchors.length?this.active.length&&!t.contains(this.tablist[0],this.active[0])?this.tabs.length===e.disabled.length?(e.active=!1,this.active=t()):this._activate(this._findNextTab(Math.max(0,e.active-1),!1)):e.active=this.tabs.index(this.active):(e.active=!1,this.active=t()),this._refresh()},_refresh:function(){this._setOptionDisabled(this.options.disabled),this._setupEvents(this.options.event),this._setupHeightStyle(this.options.heightStyle),this.tabs.not(this.active).attr({"aria-selected":"false","aria-expanded":"false",tabIndex:-1}),this.panels.not(this._getPanelForTab(this.active)).hide().attr({"aria-hidden":"true"}),this.active.length?(this.active.attr({"aria-selected":"true","aria-expanded":"true",tabIndex:0}),this._addClass(this.active,"ui-tabs-active","ui-state-active"),this._getPanelForTab(this.active).show().attr({"aria-hidden":"false"})):this.tabs.eq(0).attr("tabIndex",0)},_processTabs:function(){var e=this,i=this.tabs,s=this.anchors,n=this.panels;this.tablist=this._getList().attr("role","tablist"),this._addClass(this.tablist,"ui-tabs-nav","ui-helper-reset ui-helper-clearfix ui-widget-header"),this.tablist.on("mousedown"+this.eventNamespace,"> li",function(e){t(this).is(".ui-state-disabled")&&e.preventDefault()}).on("focus"+this.eventNamespace,".ui-tabs-anchor",function(){t(this).closest("li").is(".ui-state-disabled")&&this.blur()}),this.tabs=this.tablist.find("> li:has(a[href])").attr({role:"tab",tabIndex:-1}),this._addClass(this.tabs,"ui-tabs-tab","ui-state-default"),this.anchors=this.tabs.map(function(){return t("a",this)[0]}).attr({role:"presentation",tabIndex:-1}),this._addClass(this.anchors,"ui-tabs-anchor"),this.panels=t(),this.anchors.each(function(i,s){var n,o,a,r=t(s).uniqueId().attr("id"),l=t(s).closest("li"),h=l.attr("aria-controls");e._isLocal(s)?(n=s.hash,a=n.substring(1),o=e.element.find(e._sanitizeSelector(n))):(a=l.attr("aria-controls")||t({}).uniqueId()[0].id,n="#"+a,o=e.element.find(n),o.length||(o=e._createPanel(a),o.insertAfter(e.panels[i-1]||e.tablist)),o.attr("aria-live","polite")),o.length&&(e.panels=e.panels.add(o)),h&&l.data("ui-tabs-aria-controls",h),l.attr({"aria-controls":a,"aria-labelledby":r}),o.attr("aria-labelledby",r)}),this.panels.attr("role","tabpanel"),this._addClass(this.panels,"ui-tabs-panel","ui-widget-content"),i&&(this._off(i.not(this.tabs)),this._off(s.not(this.anchors)),this._off(n.not(this.panels)))},_getList:function(){return this.tablist||this.element.find("ol, ul").eq(0)},_createPanel:function(e){return t("<div>").attr("id",e).data("ui-tabs-destroy",!0)},_setOptionDisabled:function(e){var i,s,n;for(t.isArray(e)&&(e.length?e.length===this.anchors.length&&(e=!0):e=!1),n=0;s=this.tabs[n];n++)i=t(s),e===!0||-1!==t.inArray(n,e)?(i.attr("aria-disabled","true"),this._addClass(i,null,"ui-state-disabled")):(i.removeAttr("aria-disabled"),this._removeClass(i,null,"ui-state-disabled"));this.options.disabled=e,this._toggleClass(this.widget(),this.widgetFullName+"-disabled",null,e===!0)},_setupEvents:function(e){var i={};e&&t.each(e.split(" "),function(t,e){i[e]="_eventHandler"}),this._off(this.anchors.add(this.tabs).add(this.panels)),this._on(!0,this.anchors,{click:function(t){t.preventDefault()}}),this._on(this.anchors,i),this._on(this.tabs,{keydown:"_tabKeydown"}),this._on(this.panels,{keydown:"_panelKeydown"}),this._focusable(this.tabs),this._hoverable(this.tabs)},_setupHeightStyle:function(e){var i,s=this.element.parent();"fill"===e?(i=s.height(),i-=this.element.outerHeight()-this.element.height(),this.element.siblings(":visible").each(function(){var e=t(this),s=e.css("position");"absolute"!==s&&"fixed"!==s&&(i-=e.outerHeight(!0))}),this.element.children().not(this.panels).each(function(){i-=t(this).outerHeight(!0)}),this.panels.each(function(){t(this).height(Math.max(0,i-t(this).innerHeight()+t(this).height()))}).css("overflow","auto")):"auto"===e&&(i=0,this.panels.each(function(){i=Math.max(i,t(this).height("").height())}).height(i))},_eventHandler:function(e){var i=this.options,s=this.active,n=t(e.currentTarget),o=n.closest("li"),a=o[0]===s[0],r=a&&i.collapsible,l=r?t():this._getPanelForTab(o),h=s.length?this._getPanelForTab(s):t(),c={oldTab:s,oldPanel:h,newTab:r?t():o,newPanel:l};e.preventDefault(),o.hasClass("ui-state-disabled")||o.hasClass("ui-tabs-loading")||this.running||a&&!i.collapsible||this._trigger("beforeActivate",e,c)===!1||(i.active=r?!1:this.tabs.index(o),this.active=a?t():o,this.xhr&&this.xhr.abort(),h.length||l.length||t.error("jQuery UI Tabs: Mismatching fragment identifier."),l.length&&this.load(this.tabs.index(o),e),this._toggle(e,c))},_toggle:function(e,i){function s(){o.running=!1,o._trigger("activate",e,i)}function n(){o._addClass(i.newTab.closest("li"),"ui-tabs-active","ui-state-active"),a.length&&o.options.show?o._show(a,o.options.show,s):(a.show(),s())}var o=this,a=i.newPanel,r=i.oldPanel;this.running=!0,r.length&&this.options.hide?this._hide(r,this.options.hide,function(){o._removeClass(i.oldTab.closest("li"),"ui-tabs-active","ui-state-active"),n()}):(this._removeClass(i.oldTab.closest("li"),"ui-tabs-active","ui-state-active"),r.hide(),n()),r.attr("aria-hidden","true"),i.oldTab.attr({"aria-selected":"false","aria-expanded":"false"}),a.length&&r.length?i.oldTab.attr("tabIndex",-1):a.length&&this.tabs.filter(function(){return 0===t(this).attr("tabIndex")}).attr("tabIndex",-1),a.attr("aria-hidden","false"),i.newTab.attr({"aria-selected":"true","aria-expanded":"true",tabIndex:0})},_activate:function(e){var i,s=this._findActive(e);s[0]!==this.active[0]&&(s.length||(s=this.active),i=s.find(".ui-tabs-anchor")[0],this._eventHandler({target:i,currentTarget:i,preventDefault:t.noop}))},_findActive:function(e){return e===!1?t():this.tabs.eq(e)},_getIndex:function(e){return"string"==typeof e&&(e=this.anchors.index(this.anchors.filter("[href$='"+t.ui.escapeSelector(e)+"']"))),e},_destroy:function(){this.xhr&&this.xhr.abort(),this.tablist.removeAttr("role").off(this.eventNamespace),this.anchors.removeAttr("role tabIndex").removeUniqueId(),this.tabs.add(this.panels).each(function(){t.data(this,"ui-tabs-destroy")?t(this).remove():t(this).removeAttr("role tabIndex aria-live aria-busy aria-selected aria-labelledby aria-hidden aria-expanded")}),this.tabs.each(function(){var e=t(this),i=e.data("ui-tabs-aria-controls");i?e.attr("aria-controls",i).removeData("ui-tabs-aria-controls"):e.removeAttr("aria-controls")}),this.panels.show(),"content"!==this.options.heightStyle&&this.panels.css("height","")},enable:function(e){var i=this.options.disabled;i!==!1&&(void 0===e?i=!1:(e=this._getIndex(e),i=t.isArray(i)?t.map(i,function(t){return t!==e?t:null}):t.map(this.tabs,function(t,i){return i!==e?i:null})),this._setOptionDisabled(i))},disable:function(e){var i=this.options.disabled;if(i!==!0){if(void 0===e)i=!0;else{if(e=this._getIndex(e),-1!==t.inArray(e,i))return;i=t.isArray(i)?t.merge([e],i).sort():[e]}this._setOptionDisabled(i)}},load:function(e,i){e=this._getIndex(e);var s=this,n=this.tabs.eq(e),o=n.find(".ui-tabs-anchor"),a=this._getPanelForTab(n),r={tab:n,panel:a},l=function(t,e){"abort"===e&&s.panels.stop(!1,!0),s._removeClass(n,"ui-tabs-loading"),a.removeAttr("aria-busy"),t===s.xhr&&delete s.xhr};this._isLocal(o[0])||(this.xhr=t.ajax(this._ajaxSettings(o,i,r)),this.xhr&&"canceled"!==this.xhr.statusText&&(this._addClass(n,"ui-tabs-loading"),a.attr("aria-busy","true"),this.xhr.done(function(t,e,n){setTimeout(function(){a.html(t),s._trigger("load",i,r),l(n,e)},1)}).fail(function(t,e){setTimeout(function(){l(t,e)},1)})))},_ajaxSettings:function(e,i,s){var n=this;return{url:e.attr("href").replace(/#.*$/,""),beforeSend:function(e,o){return n._trigger("beforeLoad",i,t.extend({jqXHR:e,ajaxSettings:o},s))}}},_getPanelForTab:function(e){var i=t(e).attr("aria-controls");return this.element.find(this._sanitizeSelector("#"+i))}}),t.uiBackCompat!==!1&&t.widget("ui.tabs",t.ui.tabs,{_processTabs:function(){this._superApply(arguments),this._addClass(this.tabs,"ui-tab")}}),t.ui.tabs});

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery) {/**
 * IMPORTANT: Strongly modified for use in Tc.Module.MultipleSelectFilter - so do NOT replace with updated version
 */

/* jshint forin:true, noarg:true, noempty:true, eqeqeq:true, boss:true, undef:true, curly:true, browser:true, jquery:true */
/*
 * jQuery MultiSelect UI Widget 1.13
 * Copyright (c) 2012 Eric Hynds
 *
 * http://www.erichynds.com/jquery/jquery-ui-multiselect-widget/
 *
 * Depends:
 *   - jQuery 1.4.2+
 *   - jQuery UI 1.8 widget factory
 *
 * Optional:
 *   - jQuery UI effects
 *   - jQuery UI position utility
 *
 * Dual licensed under the MIT and GPL licenses:
 *   http://www.opensource.org/licenses/mit-license.php
 *   http://www.gnu.org/licenses/gpl.html
 *
*/
(function($, undefined){

var multiselectID = 0;

$.widget("ech.multiselect", {

	// default options
	options: {
		header: true,
		height: 175,
		minWidth: 225,
		classes: '',
		checkAllText: 'Check all',
		uncheckAllText: 'Uncheck all',
		noneSelectedText: 'Select options',
		selectedText: '# selected',
		selectedList: 0,
		show: null,
		hide: null,
		autoOpen: false,
		multiple: true,
		position: {}
	},

	_create: function(){
		var el = this.element.hide(),
			o = this.options;

		this.speed = $.fx.speeds._default; // default speed for effects
		this._isOpen = false; // assume no

		var
			button = (this.button = $('<button type="button"><span class="ui-icon ui-icon-triangle-2-n-s"></span></button>'))
				.addClass('ui-multiselect ui-widget ui-state-default ui-corner-all')
				.addClass( o.classes )
				.attr({ 'title':el.attr('title'), 'aria-haspopup':true, 'tabIndex':el.attr('tabIndex') })
				.insertAfter( el ),

			buttonlabel = (this.buttonlabel = $('<span />'))
				.html( o.noneSelectedText )
				.appendTo( button ),

			menu = (this.menu = $('<div />'))
				.addClass('ui-multiselect-menu ui-widget ui-widget-content ui-corner-all')
				.addClass( o.classes )
				.appendTo( document.body ),

			header = (this.header = $('<div />'))
				.addClass('ui-widget-header ui-corner-all ui-multiselect-header ui-helper-clearfix')
				.appendTo( menu ),

			headerLinkContainer = (this.headerLinkContainer = $('<ul />'))
				.addClass('ui-helper-reset')
				.html(function(){
					if( o.header === true ){
						return '<li><a class="ui-multiselect-all" href="#"><span class="ui-icon ui-icon-check"></span><span>' + o.checkAllText + '</span></a></li><li><a class="ui-multiselect-none" href="#"><span class="ui-icon ui-icon-closethick"></span><span>' + o.uncheckAllText + '</span></a></li>';
					} else if(typeof o.header === "string"){
						return '<li>' + o.header + '</li>';
					} else {
						return '';
					}
				})
				.append('<li class="ui-multiselect-close"><a href="#" class="ui-multiselect-close"><span class="ui-icon ui-icon-circle-close"></span></a></li>')
				.appendTo( header ),

			checkboxContainer = (this.checkboxContainer = $('<ul />'))
				.addClass('ui-multiselect-checkboxes ui-helper-reset')
				.appendTo( menu );

		// perform event bindings
		this._bindEvents();

		// build menu
		this.refresh( true );

		// some addl. logic for single selects
		if( !o.multiple ){
			menu.addClass('ui-multiselect-single');
		}
	},

	_init: function(){
		if( this.options.header === false ){
			this.header.hide();
		}
		if( !this.options.multiple ){
			this.headerLinkContainer.find('.ui-multiselect-all, .ui-multiselect-none').hide();
		}
		if( this.options.autoOpen ){
			this.open();
		}
		if( this.element.is(':disabled') ){
			this.disable();
		}
	},

	refresh: function( init ){
		var el = this.element,
			o = this.options,
			menu = this.menu,
			checkboxContainer = this.checkboxContainer,
			optgroups = [],
			html = "",
			id = el.attr('id') || multiselectID++; // unique ID for the label & option tags

		// build items
		el.find('option').each(function( i ){
			var $this = $(this),
				parent = this.parentNode,
				title = this.innerHTML,
				description = this.title,
				value = this.value,
				inputID = 'ui-multiselect-' + (this.id || id + '-option-' + i),
				isDisabled = this.disabled,
				isSelected = this.selected,
				labelClasses = [ 'ui-corner-all' ],
				liClasses = (isDisabled ? 'ui-multiselect-disabled ' : ' ') + this.className,
				optLabel;

			// is this an optgroup?
			if( parent.tagName === 'OPTGROUP' ){
				optLabel = parent.getAttribute( 'label' );

				// has this optgroup been added already?
				if( $.inArray(optLabel, optgroups) === -1 ){
					html += '<li class="ui-multiselect-optgroup-label ' + parent.className + '"><a href="#">' + optLabel + '</a></li>';
					optgroups.push( optLabel );
				}
			}

			if( isDisabled ){
				labelClasses.push( 'ui-state-disabled' );
			}

			// browsers automatically select the first option
			// by default with single selects
			if( isSelected && !o.multiple ){
				labelClasses.push( 'ui-state-active' );
			}

			html += '<li class="' + liClasses + '">';

			// create the label
			html += '<label for="' + inputID + '" title="' + description + '" class="' + labelClasses.join(' ') + '">';
			html += '<input class="noCustomInput" id="' + inputID + '" name="multiselect_' + id + '" type="' + (o.multiple ? "checkbox" : "radio") + '" value="' + value + '" title="' + title + '"';

			// pre-selected?
			if( isSelected ){
				html += ' checked="checked"';
				html += ' aria-selected="true"';
			}

			// disabled?
			if( isDisabled ){
				html += ' disabled="disabled"';
				html += ' aria-disabled="true"';
			}

			// add the title and close everything off
			html += ' /><span>' + title + '</span></label></li>';
		});

		// insert into the DOM
		checkboxContainer.html( html );

		// cache some moar useful elements
		this.labels = menu.find('label');
		this.inputs = this.labels.children('input');

		// set widths
		this._setButtonWidth();
		this._setMenuWidth();

		// remember default value
		this.button[0].defaultValue = this.update();

		// broadcast refresh event; useful for widgets
		if( !init ){
			this._trigger('refresh');
		}
	},

	// updates the button text. call refresh() to rebuild
	update: function(){
		var o = this.options,
			$inputs = this.inputs,
			$checked = $inputs.filter(':checked'),
			numChecked = $checked.length,
			value;

		$inputs.closest("label").removeClass("selected");
		$checked.closest("label").addClass("selected");

		if( numChecked === 0 ){
			value = o.noneSelectedText;
		} else {
			if($.isFunction( o.selectedText )){
				value = o.selectedText.call(this, numChecked, $inputs.length, $checked.get());
			} else if( /\d/.test(o.selectedList) && o.selectedList > 0 && numChecked <= o.selectedList){
				value = $checked.map(function(){ return $(this).next().html(); }).get().join(', ');
			} else {
				value = o.selectedText.replace('#', numChecked).replace('#', $inputs.length);
			}
		}

		this.buttonlabel.html( value );
		return value;
	},

	// binds events
	_bindEvents: function(){
		var self = this, button = this.button;

		function clickHandler(){
			self[ self._isOpen ? 'close' : 'open' ]();
			return false;
		}

		// webkit doesn't like it when you click on the span :(
		button
			.find('span')
			.on('click.multiselect', clickHandler);

		// button events
		button
		.hover(function() {
				jQuery(this).addClass("buttonhover");
			},
			function() {
				jQuery(this).removeClass("buttonhover");
			})
		.on({
			keypress: function( e ){
				switch(e.which){
					case 27: // esc
					case 38: // up
					case 37: // left
						self.close();
						break;
					case 39: // right
					case 40: // down
						self.open();
						break;
				}
			},
			mouseenter: function(){

				self.open();
			},
			mouseleave: function(){
				window.setTimeout(function() {
					if (!jQuery(self.menu).is(".menuhover")) {
						self.close();
					}
				}, 100);
			},
			focus: function(){
				if( !button.hasClass('ui-state-disabled') ){
					$(this).addClass('ui-state-focus');
				}
			},
			blur: function(){
				$(this).removeClass('ui-state-focus');
			}
		});

		this.menu
			.hover(function() {
				jQuery(this).addClass("menuhover");
			},
			function() {
				jQuery(this).removeClass("menuhover");
			})
			.on("mouseleave", function() {
				if (!jQuery(self.button).is(".buttonhover")) {
					self.close();
				}
			});

		// header links
		this.header
			.on('click.multiselect', 'a', function( e ){
				// close link
				if( $(this).hasClass('ui-multiselect-close') ){
					self.close();

				// check all / uncheck all
				} else {
					self[ $(this).hasClass('ui-multiselect-all') ? 'checkAll' : 'uncheckAll' ]();
				}

				e.preventDefault();
			});

		// optgroup label toggle support
		this.menu
			.on('click.multiselect', 'li.ui-multiselect-optgroup-label a', function( e ){
				e.preventDefault();

				var $this = $(this),
					$inputs = $this.parent().nextUntil('li.ui-multiselect-optgroup-label').find('input:visible:not(:disabled)'),
					nodes = $inputs.get(),
					label = $this.parent().text();

				// trigger event and bail if the return is false
				if( self._trigger('beforeoptgrouptoggle', e, { inputs:nodes, label:label }) === false ){
					return;
				}

				// toggle inputs
				self._toggleChecked(
					$inputs.filter(':checked').length !== $inputs.length,
					$inputs
				);

				self._trigger('optgrouptoggle', e, {
					inputs: nodes,
					label: label,
					checked: nodes[0].checked
				});
			})
			.on('mouseenter.multiselect', 'label', function(){
				if( !$(this).hasClass('ui-state-disabled') ){
					self.labels.removeClass('ui-state-hover');
					$(this).addClass('ui-state-hover');  //.find('input').focus();
					//PORTAL-4098: Focusing on the input field on mouseover was causing some weird scrolling in the list, so it is removed
				}
			})
			.on('keydown.multiselect', 'label', function( e ){
				e.preventDefault();

				switch(e.which){
					case 9: // tab
					case 27: // esc
						self.close();
						break;
					case 38: // up
					case 40: // down
					case 37: // left
					case 39: // right
						self._traverse(e.which, this);
						break;
					case 13: // enter
						$(this).find('input')[0].click();
						break;
				}
			})
			.on('click.multiselect', 'input[type="checkbox"], input[type="radio"]', function( e ){
				var $this = $(this),
					val = this.value,
					checked = this.checked,
					tags = self.element.find('option');

				if ($this.is('[type="radio"]')) {
					checked = true;
				}

				// bail if this input is disabled or the event is cancelled
				if( this.disabled || self._trigger('click', e, { value: val, text: this.title, checked: checked }) === false ){
					e.preventDefault();
					return;
				}

				// make sure the input has focus. otherwise, the esc key
				// won't close the menu after clicking an item.
				$this.focus();

				// toggle aria state
				$this.attr('aria-selected', checked);

				// change state on the original option tags
				tags.each(function(){
					if( this.value === val ){
						this.selected = checked;
					} else if( !self.options.multiple ){
						this.selected = false;
					}
				});

				// some additional single select-specific logic
				if( !self.options.multiple ){
					self.labels.removeClass('ui-state-active');
					$this.closest('label').toggleClass('ui-state-active', checked );

					// close menu
					self.close();
				}

				// fire change on the select box
				self.element.trigger("change");

				// setTimeout is to fix multiselect issue #14 and #47. caused by jQuery issue #3827
				// http://bugs.jquery.com/ticket/3827
				setTimeout($.proxy(self.update, self), 10);
			});

		// close each widget when clicking on any other element/anywhere else on the page
		$(document).on('mousedown.multiselect', function( e ){
			if(self._isOpen && !$.contains(self.menu[0], e.target) && !$.contains(self.button[0], e.target) && e.target !== self.button[0]){
				self.close();
			}
		});

		// deal with form resets.  the problem here is that buttons aren't
		// restored to their defaultValue prop on form reset, and the reset
		// handler fires before the form is actually reset.  delaying it a bit
		// gives the form inputs time to clear.
		$(this.element[0].form).on('reset.multiselect', function(){
			setTimeout($.proxy(self.refresh, self), 10);
		});
	},

	// set button width
	_setButtonWidth: function(){

		// don't set width => automatic width
		return;

		var width = this.element.outerWidth(),
			o = this.options;

		if( /\d/.test(o.minWidth) && width < o.minWidth){
			width = o.minWidth;
		}

		// set widths
		this.button.width( width );
	},

	// set menu width
	_setMenuWidth: function(){
		var m = this.menu,
			width = this.button.outerWidth()-
				parseInt(m.css('padding-left'),10)-
				parseInt(m.css('padding-right'),10)-
				parseInt(m.css('border-right-width'),10)-
				parseInt(m.css('border-left-width'),10);

		m.width( width || this.button.outerWidth() );
	},

	// move up or down within the menu
	_traverse: function( which, start ){
		var $start = $(start),
			moveToLast = which === 38 || which === 37,

			// select the first li that isn't an optgroup label / disabled
			$next = $start.parent()[moveToLast ? 'prevAll' : 'nextAll']('li:not(.ui-multiselect-disabled, .ui-multiselect-optgroup-label)')[ moveToLast ? 'last' : 'first']();

		// if at the first/last element
		if( !$next.length ){
			var $container = this.menu.find('ul').last();

			// move to the first/last
			this.menu.find('label')[ moveToLast ? 'last' : 'first' ]().trigger('mouseover');

			// set scroll position
			$container.scrollTop( moveToLast ? $container.height() : 0 );

		} else {
			$next.find('label').trigger('mouseover');
		}
	},

	// This is an internal function to toggle the checked property and
	// other related attributes of a checkbox.
	//
	// The context of this function should be a checkbox; do not proxy it.
	_toggleState: function( prop, flag ){
		return function(){
			if( !this.disabled ) {
				this[ prop ] = flag;
			}

			if( flag ){
				this.setAttribute('aria-selected', true);
			} else {
				this.removeAttribute('aria-selected');
			}
		};
	},

	_toggleChecked: function( flag, group ){
		var $inputs = (group && group.length) ?  group : this.inputs,
			self = this;

		// toggle state on inputs
		$inputs.each(this._toggleState('checked', flag));

		// give the first input focus
		$inputs.eq(0).focus();

		// update button text
		this.update();

		// gather an array of the values that actually changed
		var values = $inputs.map(function(){
			return this.value;
		}).get();

		// toggle state on original option tags
		this.element
			.find('option')
			.each(function(){
				if( !this.disabled && $.inArray(this.value, values) > -1 ){
					self._toggleState('selected', flag).call( this );
				}
			});

		// trigger the change event on the select
		if( $inputs.length ) {
			this.element.trigger("change");
		}
	},

	_toggleDisabled: function( flag ){
		this.button
			.attr({ 'disabled':flag, 'aria-disabled':flag })[ flag ? 'addClass' : 'removeClass' ]('ui-state-disabled');

		var inputs = this.menu.find('input');
		var key = "ech-multiselect-disabled";

		if(flag) {
			// remember which elements this widget disabled (not pre-disabled)
			// elements, so that they can be restored if the widget is re-enabled.
			inputs = inputs.filter(':enabled')
				.data(key, true)
		} else {
			inputs = inputs.filter(function() {
				return $.data(this, key) === true;
			}).removeData(key);
		}

		inputs
			.attr({ 'disabled':flag, 'arial-disabled':flag })
			.parent()[ flag ? 'addClass' : 'removeClass' ]('ui-state-disabled');

		this.element
			.attr({ 'disabled':flag, 'aria-disabled':flag });
	},

	// open the menu
	open: function( e ){
		var self = this,
			button = this.button,
			menu = this.menu,
			speed = this.speed,
			o = this.options,
			args = [];

		// bail if the multiselectopen event returns false, this widget is disabled, or is already open
		if( this._trigger('beforeopen') === false || button.hasClass('ui-state-disabled') || this._isOpen ){
			return;
		}



		if( !this.button.hasClass('ui-state-disabled') ){
			$(this.button).addClass('ui-state-hover');
		}

		var $container = menu.find('ul').last(),
			effect = o.show,
			pos = button.offset();

		// figure out opening effects/speeds
		if( $.isArray(o.show) ){
			effect = o.show[0];
			speed = o.show[1] || self.speed;
		}

		// if there's an effect, assume jQuery UI is in use
		// build the arguments to pass to show()
		if( effect ) {
	  args = [ effect, speed ];
		}

		// set the scroll of the checkbox container
		$container.scrollTop(0).height(o.height);

		// position and show menu
		if( $.ui.position && !$.isEmptyObject(o.position) ){
			o.position.of = o.position.of || button;

			menu
				.show()
				.position( o.position )
				.hide();

		// if position utility is not available...
		} else {
			menu.css({
				top: pos.top + button.outerHeight(),
				left: pos.left
			});
		}

		// show the menu, maybe with a speed/effect combo
		$.fn.show.apply(menu, args);

		// select the first option
		// triggering both mouseover and mouseover because 1.4.2+ has a bug where triggering mouseover
		// will actually trigger mouseenter.  the mouseenter trigger is there for when it's eventually fixed
		//this.labels.eq(0).trigger('mouseover').trigger('mouseenter').find('input').trigger('focus');

		button.addClass('ui-state-active');
		this._isOpen = true;
		this._trigger('open');
	},

	// close the menu
	close: function(){
		if(this._trigger('beforeclose') === false){
			return;
		}


		$(this.button).removeClass('ui-state-hover');

		var o = this.options,
			effect = o.hide,
			speed = this.speed,
			args = [];

		// figure out opening effects/speeds
		if( $.isArray(o.hide) ){
			effect = o.hide[0];
			speed = o.hide[1] || this.speed;
		}

	if( effect ) {
	  args = [ effect, speed ];
	}

	$.fn.hide.apply(this.menu, args);
		this.button.removeClass('ui-state-active').trigger('blur');//.trigger('mouseleave');
		this._isOpen = false;
		this._trigger('close');
	},

	enable: function(){
		this._toggleDisabled(false);
	},

	disable: function(){
		this._toggleDisabled(true);
	},

	checkAll: function( e ){
		this._toggleChecked(true);
		this._trigger('checkAll');
	},

	uncheckAll: function(){
		this._toggleChecked(false);
		this._trigger('uncheckAll');
	},

	getChecked: function(){
		return this.menu.find('input').filter(':checked');
	},

	destroy: function(){
		// remove classes + data
		$.Widget.prototype.destroy.call( this );

		this.button.remove();
		this.menu.remove();
		this.element.show();

		return this;
	},

	isOpen: function(){
		return this._isOpen;
	},

	widget: function(){
		return this.menu;
	},

	getButton: function(){
	  return this.button;
  },

	// react to option changes after initialization
	_setOption: function( key, value ){
		var menu = this.menu;

		switch(key){
			case 'header':
				menu.find('div.ui-multiselect-header')[ value ? 'show' : 'hide' ]();
				break;
			case 'checkAllText':
				menu.find('a.ui-multiselect-all span').eq(-1).text(value);
				break;
			case 'uncheckAllText':
				menu.find('a.ui-multiselect-none span').eq(-1).text(value);
				break;
			case 'height':
				menu.find('ul').last().height( parseInt(value,10) );
				break;
			case 'minWidth':
				this.options[ key ] = parseInt(value,10);
				this._setButtonWidth();
				this._setMenuWidth();
				break;
			case 'selectedText':
			case 'selectedList':
			case 'noneSelectedText':
				this.options[key] = value; // these all needs to update immediately for the update() call
				this.update();
				break;
			case 'classes':
				menu.add(this.button).removeClass(this.options.classes).addClass(value);
				break;
			case 'multiple':
				menu.toggleClass('ui-multiselect-single', !value);
				this.options.multiple = value;
				this.element[0].multiple = value;
				this.refresh();
		}

		$.Widget.prototype._setOption.apply( this, arguments );
	}
});

})(jQuery);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {/**
 * Namespacing
 */
$.namespace = __webpack_require__(4).namespace;

var SCS = $.namespace("SCS");
SCS.ajaxTimeout = 300000; // 5min

$.ajaxSetup({
	error : function(jqXHR, textStatus, errorThrown) {
		if (SCS.portal.errorHandling) {
			SCS.portal.errorHandling(jqXHR.responseText);
		}
	},
	timeout : SCS.ajaxTimeout
});

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var define = false;
var jQuery = __webpack_require__(0);

/*
 * qTip2 - Pretty powerful tooltips - v3.0.3
 * http://qtip2.com
 *
 * Copyright (c) 2016 
 * Released under the MIT licenses
 * http://jquery.org/license
 *
 * Date: Wed May 11 2016 10:31 GMT+0100+0100
 * Plugins: tips modal viewport svg imagemap ie6
 * Styles: core basic css3
 */
/*global window: false, jQuery: false, console: false, define: false */

/* Cache window, document, undefined */
(function( window, document, undefined ) {

// Uses AMD or browser globals to create a jQuery plugin.
(function( factory ) {
	"use strict";
	if(typeof define === 'function' && define.amd) {
		define(['jquery'], factory);
	}
	else if(jQuery && !jQuery.fn.qtip) {
		factory(jQuery);
	}
}
(function($) {
	"use strict"; // Enable ECMAScript "strict" operation for this function. See more: http://ejohn.org/blog/ecmascript-5-strict-mode-json-and-more/
;// Munge the primitives - Paul Irish tip
var TRUE = true,
FALSE = false,
NULL = null,

// Common variables
X = 'x', Y = 'y',
WIDTH = 'width',
HEIGHT = 'height',

// Positioning sides
TOP = 'top',
LEFT = 'left',
BOTTOM = 'bottom',
RIGHT = 'right',
CENTER = 'center',

// Position adjustment types
FLIP = 'flip',
FLIPINVERT = 'flipinvert',
SHIFT = 'shift',

// Shortcut vars
QTIP, PROTOTYPE, CORNER, CHECKS,
PLUGINS = {},
NAMESPACE = 'qtip',
ATTR_HAS = 'data-hasqtip',
ATTR_ID = 'data-qtip-id',
WIDGET = ['ui-widget', 'ui-tooltip'],
SELECTOR = '.'+NAMESPACE,
INACTIVE_EVENTS = 'click dblclick mousedown mouseup mousemove mouseleave mouseenter'.split(' '),

CLASS_FIXED = NAMESPACE+'-fixed',
CLASS_DEFAULT = NAMESPACE + '-default',
CLASS_FOCUS = NAMESPACE + '-focus',
CLASS_HOVER = NAMESPACE + '-hover',
CLASS_DISABLED = NAMESPACE+'-disabled',

replaceSuffix = '_replacedByqTip',
oldtitle = 'oldtitle',
trackingBound,

// Browser detection
BROWSER = {
	/*
	 * IE version detection
	 *
	 * Adapted from: http://ajaxian.com/archives/attack-of-the-ie-conditional-comment
	 * Credit to James Padolsey for the original implemntation!
	 */
	ie: (function() {
		/* eslint-disable no-empty */
		var v, i;
		for (
			v = 4, i = document.createElement('div');
			(i.innerHTML = '<!--[if gt IE ' + v + ']><i></i><![endif]-->') && i.getElementsByTagName('i')[0];
			v+=1
		) {}
		return v > 4 ? v : NaN;
		/* eslint-enable no-empty */
	})(),

	/*
	 * iOS version detection
	 */
	iOS: parseFloat(
		('' + (/CPU.*OS ([0-9_]{1,5})|(CPU like).*AppleWebKit.*Mobile/i.exec(navigator.userAgent) || [0,''])[1])
		.replace('undefined', '3_2').replace('_', '.').replace('_', '')
	) || FALSE
};
;function QTip(target, options, id, attr) {
	// Elements and ID
	this.id = id;
	this.target = target;
	this.tooltip = NULL;
	this.elements = { target: target };

	// Internal constructs
	this._id = NAMESPACE + '-' + id;
	this.timers = { img: {} };
	this.options = options;
	this.plugins = {};

	// Cache object
	this.cache = {
		event: {},
		target: $(),
		disabled: FALSE,
		attr: attr,
		onTooltip: FALSE,
		lastClass: ''
	};

	// Set the initial flags
	this.rendered = this.destroyed = this.disabled = this.waiting =
		this.hiddenDuringWait = this.positioning = this.triggering = FALSE;
}
PROTOTYPE = QTip.prototype;

PROTOTYPE._when = function(deferreds) {
	return $.when.apply($, deferreds);
};

PROTOTYPE.render = function(show) {
	if(this.rendered || this.destroyed) { return this; } // If tooltip has already been rendered, exit

	var self = this,
		options = this.options,
		cache = this.cache,
		elements = this.elements,
		text = options.content.text,
		title = options.content.title,
		button = options.content.button,
		posOptions = options.position,
		deferreds = [];

	// Add ARIA attributes to target
	$.attr(this.target[0], 'aria-describedby', this._id);

	// Create public position object that tracks current position corners
	cache.posClass = this._createPosClass(
		(this.position = { my: posOptions.my, at: posOptions.at }).my
	);

	// Create tooltip element
	this.tooltip = elements.tooltip = $('<div/>', {
		'id': this._id,
		'class': [ NAMESPACE, CLASS_DEFAULT, options.style.classes, cache.posClass ].join(' '),
		'width': options.style.width || '',
		'height': options.style.height || '',
		'tracking': posOptions.target === 'mouse' && posOptions.adjust.mouse,

		/* ARIA specific attributes */
		'role': 'alert',
		'aria-live': 'polite',
		'aria-atomic': FALSE,
		'aria-describedby': this._id + '-content',
		'aria-hidden': TRUE
	})
	.toggleClass(CLASS_DISABLED, this.disabled)
	.attr(ATTR_ID, this.id)
	.data(NAMESPACE, this)
	.appendTo(posOptions.container)
	.append(
		// Create content element
		elements.content = $('<div />', {
			'class': NAMESPACE + '-content',
			'id': this._id + '-content',
			'aria-atomic': TRUE
		})
	);

	// Set rendered flag and prevent redundant reposition calls for now
	this.rendered = -1;
	this.positioning = TRUE;

	// Create title...
	if(title) {
		this._createTitle();

		// Update title only if its not a callback (called in toggle if so)
		if(!$.isFunction(title)) {
			deferreds.push( this._updateTitle(title, FALSE) );
		}
	}

	// Create button
	if(button) { this._createButton(); }

	// Set proper rendered flag and update content if not a callback function (called in toggle)
	if(!$.isFunction(text)) {
		deferreds.push( this._updateContent(text, FALSE) );
	}
	this.rendered = TRUE;

	// Setup widget classes
	this._setWidget();

	// Initialize 'render' plugins
	$.each(PLUGINS, function(name) {
		var instance;
		if(this.initialize === 'render' && (instance = this(self))) {
			self.plugins[name] = instance;
		}
	});

	// Unassign initial events and assign proper events
	this._unassignEvents();
	this._assignEvents();

	// When deferreds have completed
	this._when(deferreds).then(function() {
		// tooltiprender event
		self._trigger('render');

		// Reset flags
		self.positioning = FALSE;

		// Show tooltip if not hidden during wait period
		if(!self.hiddenDuringWait && (options.show.ready || show)) {
			self.toggle(TRUE, cache.event, FALSE);
		}
		self.hiddenDuringWait = FALSE;
	});

	// Expose API
	QTIP.api[this.id] = this;

	return this;
};

PROTOTYPE.destroy = function(immediate) {
	// Set flag the signify destroy is taking place to plugins
	// and ensure it only gets destroyed once!
	if(this.destroyed) { return this.target; }

	function process() {
		if(this.destroyed) { return; }
		this.destroyed = TRUE;

		var target = this.target,
			title = target.attr(oldtitle),
			timer;

		// Destroy tooltip if rendered
		if(this.rendered) {
			this.tooltip.stop(1,0).find('*').remove().end().remove();
		}

		// Destroy all plugins
		$.each(this.plugins, function() {
			this.destroy && this.destroy();
		});

		// Clear timers
		for (timer in this.timers) {
			if (this.timers.hasOwnProperty(timer)) {
				clearTimeout(this.timers[timer]);
			}
		}

		// Remove api object and ARIA attributes
		target.removeData(NAMESPACE)
			.removeAttr(ATTR_ID)
			.removeAttr(ATTR_HAS)
			.removeAttr('aria-describedby');

		// Reset old title attribute if removed
		if(this.options.suppress && title) {
			target.attr('title', title).removeAttr(oldtitle);
		}

		// Remove qTip events associated with this API
		this._unassignEvents();

		// Remove ID from used id objects, and delete object references
		// for better garbage collection and leak protection
		this.options = this.elements = this.cache = this.timers =
			this.plugins = this.mouse = NULL;

		// Delete epoxsed API object
		delete QTIP.api[this.id];
	}

	// If an immediate destroy is needed
	if((immediate !== TRUE || this.triggering === 'hide') && this.rendered) {
		this.tooltip.one('tooltiphidden', $.proxy(process, this));
		!this.triggering && this.hide();
	}

	// If we're not in the process of hiding... process
	else { process.call(this); }

	return this.target;
};
;function invalidOpt(a) {
	return a === NULL || $.type(a) !== 'object';
}

function invalidContent(c) {
	return !($.isFunction(c) || 
            c && c.attr || 
            c.length || 
            $.type(c) === 'object' && (c.jquery || c.then));
}

// Option object sanitizer
function sanitizeOptions(opts) {
	var content, text, ajax, once;

	if(invalidOpt(opts)) { return FALSE; }

	if(invalidOpt(opts.metadata)) {
		opts.metadata = { type: opts.metadata };
	}

	if('content' in opts) {
		content = opts.content;

		if(invalidOpt(content) || content.jquery || content.done) {
			text = invalidContent(content) ? FALSE : content;
			content = opts.content = {
				text: text
			};
		}
		else { text = content.text; }

		// DEPRECATED - Old content.ajax plugin functionality
		// Converts it into the proper Deferred syntax
		if('ajax' in content) {
			ajax = content.ajax;
			once = ajax && ajax.once !== FALSE;
			delete content.ajax;

			content.text = function(event, api) {
				var loading = text || $(this).attr(api.options.content.attr) || 'Loading...',

				deferred = $.ajax(
					$.extend({}, ajax, { context: api })
				)
				.then(ajax.success, NULL, ajax.error)
				.then(function(newContent) {
					if(newContent && once) { api.set('content.text', newContent); }
					return newContent;
				},
				function(xhr, status, error) {
					if(api.destroyed || xhr.status === 0) { return; }
					api.set('content.text', status + ': ' + error);
				});

				return !once ? (api.set('content.text', loading), deferred) : loading;
			};
		}

		if('title' in content) {
			if($.isPlainObject(content.title)) {
				content.button = content.title.button;
				content.title = content.title.text;
			}

			if(invalidContent(content.title || FALSE)) {
				content.title = FALSE;
			}
		}
	}

	if('position' in opts && invalidOpt(opts.position)) {
		opts.position = { my: opts.position, at: opts.position };
	}

	if('show' in opts && invalidOpt(opts.show)) {
		opts.show = opts.show.jquery ? { target: opts.show } :
			opts.show === TRUE ? { ready: TRUE } : { event: opts.show };
	}

	if('hide' in opts && invalidOpt(opts.hide)) {
		opts.hide = opts.hide.jquery ? { target: opts.hide } : { event: opts.hide };
	}

	if('style' in opts && invalidOpt(opts.style)) {
		opts.style = { classes: opts.style };
	}

	// Sanitize plugin options
	$.each(PLUGINS, function() {
		this.sanitize && this.sanitize(opts);
	});

	return opts;
}

// Setup builtin .set() option checks
CHECKS = PROTOTYPE.checks = {
	builtin: {
		// Core checks
		'^id$': function(obj, o, v, prev) {
			var id = v === TRUE ? QTIP.nextid : v,
				newId = NAMESPACE + '-' + id;

			if(id !== FALSE && id.length > 0 && !$('#'+newId).length) {
				this._id = newId;

				if(this.rendered) {
					this.tooltip[0].id = this._id;
					this.elements.content[0].id = this._id + '-content';
					this.elements.title[0].id = this._id + '-title';
				}
			}
			else { obj[o] = prev; }
		},
		'^prerender': function(obj, o, v) {
			v && !this.rendered && this.render(this.options.show.ready);
		},

		// Content checks
		'^content.text$': function(obj, o, v) {
			this._updateContent(v);
		},
		'^content.attr$': function(obj, o, v, prev) {
			if(this.options.content.text === this.target.attr(prev)) {
				this._updateContent( this.target.attr(v) );
			}
		},
		'^content.title$': function(obj, o, v) {
			// Remove title if content is null
			if(!v) { return this._removeTitle(); }

			// If title isn't already created, create it now and update
			v && !this.elements.title && this._createTitle();
			this._updateTitle(v);
		},
		'^content.button$': function(obj, o, v) {
			this._updateButton(v);
		},
		'^content.title.(text|button)$': function(obj, o, v) {
			this.set('content.'+o, v); // Backwards title.text/button compat
		},

		// Position checks
		'^position.(my|at)$': function(obj, o, v){
			if('string' === typeof v) {
				this.position[o] = obj[o] = new CORNER(v, o === 'at');
			}
		},
		'^position.container$': function(obj, o, v){
			this.rendered && this.tooltip.appendTo(v);
		},

		// Show checks
		'^show.ready$': function(obj, o, v) {
			v && (!this.rendered && this.render(TRUE) || this.toggle(TRUE));
		},

		// Style checks
		'^style.classes$': function(obj, o, v, p) {
			this.rendered && this.tooltip.removeClass(p).addClass(v);
		},
		'^style.(width|height)': function(obj, o, v) {
			this.rendered && this.tooltip.css(o, v);
		},
		'^style.widget|content.title': function() {
			this.rendered && this._setWidget();
		},
		'^style.def': function(obj, o, v) {
			this.rendered && this.tooltip.toggleClass(CLASS_DEFAULT, !!v);
		},

		// Events check
		'^events.(render|show|move|hide|focus|blur)$': function(obj, o, v) {
			this.rendered && this.tooltip[($.isFunction(v) ? '' : 'un') + 'bind']('tooltip'+o, v);
		},

		// Properties which require event reassignment
		'^(show|hide|position).(event|target|fixed|inactive|leave|distance|viewport|adjust)': function() {
			if(!this.rendered) { return; }

			// Set tracking flag
			var posOptions = this.options.position;
			this.tooltip.attr('tracking', posOptions.target === 'mouse' && posOptions.adjust.mouse);

			// Reassign events
			this._unassignEvents();
			this._assignEvents();
		}
	}
};

// Dot notation converter
function convertNotation(options, notation) {
	var i = 0, obj, option = options,

	// Split notation into array
	levels = notation.split('.');

	// Loop through
	while(option = option[ levels[i++] ]) {
		if(i < levels.length) { obj = option; }
	}

	return [obj || options, levels.pop()];
}

PROTOTYPE.get = function(notation) {
	if(this.destroyed) { return this; }

	var o = convertNotation(this.options, notation.toLowerCase()),
		result = o[0][ o[1] ];

	return result.precedance ? result.string() : result;
};

function setCallback(notation, args) {
	var category, rule, match;

	for(category in this.checks) {
		if (!this.checks.hasOwnProperty(category)) { continue; }

		for(rule in this.checks[category]) {
			if (!this.checks[category].hasOwnProperty(rule)) { continue; }

			if(match = (new RegExp(rule, 'i')).exec(notation)) {
				args.push(match);

				if(category === 'builtin' || this.plugins[category]) {
					this.checks[category][rule].apply(
						this.plugins[category] || this, args
					);
				}
			}
		}
	}
}

var rmove = /^position\.(my|at|adjust|target|container|viewport)|style|content|show\.ready/i,
	rrender = /^prerender|show\.ready/i;

PROTOTYPE.set = function(option, value) {
	if(this.destroyed) { return this; }

	var rendered = this.rendered,
		reposition = FALSE,
		options = this.options,
		name;

	// Convert singular option/value pair into object form
	if('string' === typeof option) {
		name = option; option = {}; option[name] = value;
	}
	else { option = $.extend({}, option); }

	// Set all of the defined options to their new values
	$.each(option, function(notation, val) {
		if(rendered && rrender.test(notation)) {
			delete option[notation]; return;
		}

		// Set new obj value
		var obj = convertNotation(options, notation.toLowerCase()), previous;
		previous = obj[0][ obj[1] ];
		obj[0][ obj[1] ] = val && val.nodeType ? $(val) : val;

		// Also check if we need to reposition
		reposition = rmove.test(notation) || reposition;

		// Set the new params for the callback
		option[notation] = [obj[0], obj[1], val, previous];
	});

	// Re-sanitize options
	sanitizeOptions(options);

	/*
	 * Execute any valid callbacks for the set options
	 * Also set positioning flag so we don't get loads of redundant repositioning calls.
	 */
	this.positioning = TRUE;
	$.each(option, $.proxy(setCallback, this));
	this.positioning = FALSE;

	// Update position if needed
	if(this.rendered && this.tooltip[0].offsetWidth > 0 && reposition) {
		this.reposition( options.position.target === 'mouse' ? NULL : this.cache.event );
	}

	return this;
};
;PROTOTYPE._update = function(content, element) {
	var self = this,
		cache = this.cache;

	// Make sure tooltip is rendered and content is defined. If not return
	if(!this.rendered || !content) { return FALSE; }

	// Use function to parse content
	if($.isFunction(content)) {
		content = content.call(this.elements.target, cache.event, this) || '';
	}

	// Handle deferred content
	if($.isFunction(content.then)) {
		cache.waiting = TRUE;
		return content.then(function(c) {
			cache.waiting = FALSE;
			return self._update(c, element);
		}, NULL, function(e) {
			return self._update(e, element);
		});
	}

	// If content is null... return false
	if(content === FALSE || !content && content !== '') { return FALSE; }

	// Append new content if its a DOM array and show it if hidden
	if(content.jquery && content.length > 0) {
		element.empty().append(
			content.css({ display: 'block', visibility: 'visible' })
		);
	}

	// Content is a regular string, insert the new content
	else { element.html(content); }

	// Wait for content to be loaded, and reposition
	return this._waitForContent(element).then(function(images) {
		if(self.rendered && self.tooltip[0].offsetWidth > 0) {
			self.reposition(cache.event, !images.length);
		}
	});
};

PROTOTYPE._waitForContent = function(element) {
	var cache = this.cache;

	// Set flag
	cache.waiting = TRUE;

	// If imagesLoaded is included, ensure images have loaded and return promise
	return ( $.fn.imagesLoaded ? element.imagesLoaded() : new $.Deferred().resolve([]) )
		.done(function() { cache.waiting = FALSE; })
		.promise();
};

PROTOTYPE._updateContent = function(content, reposition) {
	this._update(content, this.elements.content, reposition);
};

PROTOTYPE._updateTitle = function(content, reposition) {
	if(this._update(content, this.elements.title, reposition) === FALSE) {
		this._removeTitle(FALSE);
	}
};

PROTOTYPE._createTitle = function()
{
	var elements = this.elements,
		id = this._id+'-title';

	// Destroy previous title element, if present
	if(elements.titlebar) { this._removeTitle(); }

	// Create title bar and title elements
	elements.titlebar = $('<div />', {
		'class': NAMESPACE + '-titlebar ' + (this.options.style.widget ? createWidgetClass('header') : '')
	})
	.append(
		elements.title = $('<div />', {
			'id': id,
			'class': NAMESPACE + '-title',
			'aria-atomic': TRUE
		})
	)
	.insertBefore(elements.content)

	// Button-specific events
	.delegate('.qtip-close', 'mousedown keydown mouseup keyup mouseout', function(event) {
		$(this).toggleClass('ui-state-active ui-state-focus', event.type.substr(-4) === 'down');
	})
	.delegate('.qtip-close', 'mouseover mouseout', function(event){
		$(this).toggleClass('ui-state-hover', event.type === 'mouseover');
	});

	// Create button if enabled
	if(this.options.content.button) { this._createButton(); }
};

PROTOTYPE._removeTitle = function(reposition)
{
	var elements = this.elements;

	if(elements.title) {
		elements.titlebar.remove();
		elements.titlebar = elements.title = elements.button = NULL;

		// Reposition if enabled
		if(reposition !== FALSE) { this.reposition(); }
	}
};
;PROTOTYPE._createPosClass = function(my) {
	return NAMESPACE + '-pos-' + (my || this.options.position.my).abbrev();
};

PROTOTYPE.reposition = function(event, effect) {
	if(!this.rendered || this.positioning || this.destroyed) { return this; }

	// Set positioning flag
	this.positioning = TRUE;

	var cache = this.cache,
		tooltip = this.tooltip,
		posOptions = this.options.position,
		target = posOptions.target,
		my = posOptions.my,
		at = posOptions.at,
		viewport = posOptions.viewport,
		container = posOptions.container,
		adjust = posOptions.adjust,
		method = adjust.method.split(' '),
		tooltipWidth = tooltip.outerWidth(FALSE),
		tooltipHeight = tooltip.outerHeight(FALSE),
		targetWidth = 0,
		targetHeight = 0,
		type = tooltip.css('position'),
		position = { left: 0, top: 0 },
		visible = tooltip[0].offsetWidth > 0,
		isScroll = event && event.type === 'scroll',
		win = $(window),
		doc = container[0].ownerDocument,
		mouse = this.mouse,
		pluginCalculations, offset, adjusted, newClass;

	// Check if absolute position was passed
	if($.isArray(target) && target.length === 2) {
		// Force left top and set position
		at = { x: LEFT, y: TOP };
		position = { left: target[0], top: target[1] };
	}

	// Check if mouse was the target
	else if(target === 'mouse') {
		// Force left top to allow flipping
		at = { x: LEFT, y: TOP };

		// Use the mouse origin that caused the show event, if distance hiding is enabled
		if((!adjust.mouse || this.options.hide.distance) && cache.origin && cache.origin.pageX) {
			event =  cache.origin;
		}

		// Use cached event for resize/scroll events
		else if(!event || event && (event.type === 'resize' || event.type === 'scroll')) {
			event = cache.event;
		}

		// Otherwise, use the cached mouse coordinates if available
		else if(mouse && mouse.pageX) {
			event = mouse;
		}

		// Calculate body and container offset and take them into account below
		if(type !== 'static') { position = container.offset(); }
		if(doc.body.offsetWidth !== (window.innerWidth || doc.documentElement.clientWidth)) {
			offset = $(document.body).offset();
		}

		// Use event coordinates for position
		position = {
			left: event.pageX - position.left + (offset && offset.left || 0),
			top: event.pageY - position.top + (offset && offset.top || 0)
		};

		// Scroll events are a pain, some browsers
		if(adjust.mouse && isScroll && mouse) {
			position.left -= (mouse.scrollX || 0) - win.scrollLeft();
			position.top -= (mouse.scrollY || 0) - win.scrollTop();
		}
	}

	// Target wasn't mouse or absolute...
	else {
		// Check if event targetting is being used
		if(target === 'event') {
			if(event && event.target && event.type !== 'scroll' && event.type !== 'resize') {
				cache.target = $(event.target);
			}
			else if(!event.target) {
				cache.target = this.elements.target;
			}
		}
		else if(target !== 'event'){
			cache.target = $(target.jquery ? target : this.elements.target);
		}
		target = cache.target;

		// Parse the target into a jQuery object and make sure there's an element present
		target = $(target).eq(0);
		if(target.length === 0) { return this; }

		// Check if window or document is the target
		else if(target[0] === document || target[0] === window) {
			targetWidth = BROWSER.iOS ? window.innerWidth : target.width();
			targetHeight = BROWSER.iOS ? window.innerHeight : target.height();

			if(target[0] === window) {
				position = {
					top: (viewport || target).scrollTop(),
					left: (viewport || target).scrollLeft()
				};
			}
		}

		// Check if the target is an <AREA> element
		else if(PLUGINS.imagemap && target.is('area')) {
			pluginCalculations = PLUGINS.imagemap(this, target, at, PLUGINS.viewport ? method : FALSE);
		}

		// Check if the target is an SVG element
		else if(PLUGINS.svg && target && target[0].ownerSVGElement) {
			pluginCalculations = PLUGINS.svg(this, target, at, PLUGINS.viewport ? method : FALSE);
		}

		// Otherwise use regular jQuery methods
		else {
			targetWidth = target.outerWidth(FALSE);
			targetHeight = target.outerHeight(FALSE);
			position = target.offset();
		}

		// Parse returned plugin values into proper variables
		if(pluginCalculations) {
			targetWidth = pluginCalculations.width;
			targetHeight = pluginCalculations.height;
			offset = pluginCalculations.offset;
			position = pluginCalculations.position;
		}

		// Adjust position to take into account offset parents
		position = this.reposition.offset(target, position, container);

		// Adjust for position.fixed tooltips (and also iOS scroll bug in v3.2-4.0 & v4.3-4.3.2)
		if(BROWSER.iOS > 3.1 && BROWSER.iOS < 4.1 ||
			BROWSER.iOS >= 4.3 && BROWSER.iOS < 4.33 ||
			!BROWSER.iOS && type === 'fixed'
		){
			position.left -= win.scrollLeft();
			position.top -= win.scrollTop();
		}

		// Adjust position relative to target
		if(!pluginCalculations || pluginCalculations && pluginCalculations.adjustable !== FALSE) {
			position.left += at.x === RIGHT ? targetWidth : at.x === CENTER ? targetWidth / 2 : 0;
			position.top += at.y === BOTTOM ? targetHeight : at.y === CENTER ? targetHeight / 2 : 0;
		}
	}

	// Adjust position relative to tooltip
	position.left += adjust.x + (my.x === RIGHT ? -tooltipWidth : my.x === CENTER ? -tooltipWidth / 2 : 0);
	position.top += adjust.y + (my.y === BOTTOM ? -tooltipHeight : my.y === CENTER ? -tooltipHeight / 2 : 0);

	// Use viewport adjustment plugin if enabled
	if(PLUGINS.viewport) {
		adjusted = position.adjusted = PLUGINS.viewport(
			this, position, posOptions, targetWidth, targetHeight, tooltipWidth, tooltipHeight
		);

		// Apply offsets supplied by positioning plugin (if used)
		if(offset && adjusted.left) { position.left += offset.left; }
		if(offset && adjusted.top) {  position.top += offset.top; }

		// Apply any new 'my' position
		if(adjusted.my) { this.position.my = adjusted.my; }
	}

	// Viewport adjustment is disabled, set values to zero
	else { position.adjusted = { left: 0, top: 0 }; }

	// Set tooltip position class if it's changed
	if(cache.posClass !== (newClass = this._createPosClass(this.position.my))) {
		cache.posClass = newClass;
		tooltip.removeClass(cache.posClass).addClass(newClass);
	}

	// tooltipmove event
	if(!this._trigger('move', [position, viewport.elem || viewport], event)) { return this; }
	delete position.adjusted;

	// If effect is disabled, target it mouse, no animation is defined or positioning gives NaN out, set CSS directly
	if(effect === FALSE || !visible || isNaN(position.left) || isNaN(position.top) || target === 'mouse' || !$.isFunction(posOptions.effect)) {
		tooltip.css(position);
	}

	// Use custom function if provided
	else if($.isFunction(posOptions.effect)) {
		posOptions.effect.call(tooltip, this, $.extend({}, position));
		tooltip.queue(function(next) {
			// Reset attributes to avoid cross-browser rendering bugs
			$(this).css({ opacity: '', height: '' });
			if(BROWSER.ie) { this.style.removeAttribute('filter'); }

			next();
		});
	}

	// Set positioning flag
	this.positioning = FALSE;

	return this;
};

// Custom (more correct for qTip!) offset calculator
PROTOTYPE.reposition.offset = function(elem, pos, container) {
	if(!container[0]) { return pos; }

	var ownerDocument = $(elem[0].ownerDocument),
		quirks = !!BROWSER.ie && document.compatMode !== 'CSS1Compat',
		parent = container[0],
		scrolled, position, parentOffset, overflow;

	function scroll(e, i) {
		pos.left += i * e.scrollLeft();
		pos.top += i * e.scrollTop();
	}

	// Compensate for non-static containers offset
	do {
		if((position = $.css(parent, 'position')) !== 'static') {
			if(position === 'fixed') {
				parentOffset = parent.getBoundingClientRect();
				scroll(ownerDocument, -1);
			}
			else {
				parentOffset = $(parent).position();
				parentOffset.left += parseFloat($.css(parent, 'borderLeftWidth')) || 0;
				parentOffset.top += parseFloat($.css(parent, 'borderTopWidth')) || 0;
			}

			pos.left -= parentOffset.left + (parseFloat($.css(parent, 'marginLeft')) || 0);
			pos.top -= parentOffset.top + (parseFloat($.css(parent, 'marginTop')) || 0);

			// If this is the first parent element with an overflow of "scroll" or "auto", store it
			if(!scrolled && (overflow = $.css(parent, 'overflow')) !== 'hidden' && overflow !== 'visible') { scrolled = $(parent); }
		}
	}
	while(parent = parent.offsetParent);

	// Compensate for containers scroll if it also has an offsetParent (or in IE quirks mode)
	if(scrolled && (scrolled[0] !== ownerDocument[0] || quirks)) {
		scroll(scrolled, 1);
	}

	return pos;
};

// Corner class
var C = (CORNER = PROTOTYPE.reposition.Corner = function(corner, forceY) {
	corner = ('' + corner).replace(/([A-Z])/, ' $1').replace(/middle/gi, CENTER).toLowerCase();
	this.x = (corner.match(/left|right/i) || corner.match(/center/) || ['inherit'])[0].toLowerCase();
	this.y = (corner.match(/top|bottom|center/i) || ['inherit'])[0].toLowerCase();
	this.forceY = !!forceY;

	var f = corner.charAt(0);
	this.precedance = f === 't' || f === 'b' ? Y : X;
}).prototype;

C.invert = function(z, center) {
	this[z] = this[z] === LEFT ? RIGHT : this[z] === RIGHT ? LEFT : center || this[z];
};

C.string = function(join) {
	var x = this.x, y = this.y;

	var result = x !== y ?
		x === 'center' || y !== 'center' && (this.precedance === Y || this.forceY) ? 
			[y,x] : 
			[x,y] :
		[x];

	return join !== false ? result.join(' ') : result;
};

C.abbrev = function() {
	var result = this.string(false);
	return result[0].charAt(0) + (result[1] && result[1].charAt(0) || '');
};

C.clone = function() {
	return new CORNER( this.string(), this.forceY );
};

;
PROTOTYPE.toggle = function(state, event) {
	var cache = this.cache,
		options = this.options,
		tooltip = this.tooltip;

	// Try to prevent flickering when tooltip overlaps show element
	if(event) {
		if((/over|enter/).test(event.type) && cache.event && (/out|leave/).test(cache.event.type) &&
			options.show.target.add(event.target).length === options.show.target.length &&
			tooltip.has(event.relatedTarget).length) {
			return this;
		}

		// Cache event
		cache.event = $.event.fix(event);
	}

	// If we're currently waiting and we've just hidden... stop it
	this.waiting && !state && (this.hiddenDuringWait = TRUE);

	// Render the tooltip if showing and it isn't already
	if(!this.rendered) { return state ? this.render(1) : this; }
	else if(this.destroyed || this.disabled) { return this; }

	var type = state ? 'show' : 'hide',
		opts = this.options[type],
		posOptions = this.options.position,
		contentOptions = this.options.content,
		width = this.tooltip.css('width'),
		visible = this.tooltip.is(':visible'),
		animate = state || opts.target.length === 1,
		sameTarget = !event || opts.target.length < 2 || cache.target[0] === event.target,
		identicalState, allow, after;

	// Detect state if valid one isn't provided
	if((typeof state).search('boolean|number')) { state = !visible; }

	// Check if the tooltip is in an identical state to the new would-be state
	identicalState = !tooltip.is(':animated') && visible === state && sameTarget;

	// Fire tooltip(show/hide) event and check if destroyed
	allow = !identicalState ? !!this._trigger(type, [90]) : NULL;

	// Check to make sure the tooltip wasn't destroyed in the callback
	if(this.destroyed) { return this; }

	// If the user didn't stop the method prematurely and we're showing the tooltip, focus it
	if(allow !== FALSE && state) { this.focus(event); }

	// If the state hasn't changed or the user stopped it, return early
	if(!allow || identicalState) { return this; }

	// Set ARIA hidden attribute
	$.attr(tooltip[0], 'aria-hidden', !!!state);

	// Execute state specific properties
	if(state) {
		// Store show origin coordinates
		this.mouse && (cache.origin = $.event.fix(this.mouse));

		// Update tooltip content & title if it's a dynamic function
		if($.isFunction(contentOptions.text)) { this._updateContent(contentOptions.text, FALSE); }
		if($.isFunction(contentOptions.title)) { this._updateTitle(contentOptions.title, FALSE); }

		// Cache mousemove events for positioning purposes (if not already tracking)
		if(!trackingBound && posOptions.target === 'mouse' && posOptions.adjust.mouse) {
			$(document).bind('mousemove.'+NAMESPACE, this._storeMouse);
			trackingBound = TRUE;
		}

		// Update the tooltip position (set width first to prevent viewport/max-width issues)
		if(!width) { tooltip.css('width', tooltip.outerWidth(FALSE)); }
		this.reposition(event, arguments[2]);
		if(!width) { tooltip.css('width', ''); }

		// Hide other tooltips if tooltip is solo
		if(!!opts.solo) {
			(typeof opts.solo === 'string' ? $(opts.solo) : $(SELECTOR, opts.solo))
				.not(tooltip).not(opts.target).qtip('hide', new $.Event('tooltipsolo'));
		}
	}
	else {
		// Clear show timer if we're hiding
		clearTimeout(this.timers.show);

		// Remove cached origin on hide
		delete cache.origin;

		// Remove mouse tracking event if not needed (all tracking qTips are hidden)
		if(trackingBound && !$(SELECTOR+'[tracking="true"]:visible', opts.solo).not(tooltip).length) {
			$(document).unbind('mousemove.'+NAMESPACE);
			trackingBound = FALSE;
		}

		// Blur the tooltip
		this.blur(event);
	}

	// Define post-animation, state specific properties
	after = $.proxy(function() {
		if(state) {
			// Prevent antialias from disappearing in IE by removing filter
			if(BROWSER.ie) { tooltip[0].style.removeAttribute('filter'); }

			// Remove overflow setting to prevent tip bugs
			tooltip.css('overflow', '');

			// Autofocus elements if enabled
			if('string' === typeof opts.autofocus) {
				$(this.options.show.autofocus, tooltip).focus();
			}

			// If set, hide tooltip when inactive for delay period
			this.options.show.target.trigger('qtip-'+this.id+'-inactive');
		}
		else {
			// Reset CSS states
			tooltip.css({
				display: '',
				visibility: '',
				opacity: '',
				left: '',
				top: ''
			});
		}

		// tooltipvisible/tooltiphidden events
		this._trigger(state ? 'visible' : 'hidden');
	}, this);

	// If no effect type is supplied, use a simple toggle
	if(opts.effect === FALSE || animate === FALSE) {
		tooltip[ type ]();
		after();
	}

	// Use custom function if provided
	else if($.isFunction(opts.effect)) {
		tooltip.stop(1, 1);
		opts.effect.call(tooltip, this);
		tooltip.queue('fx', function(n) {
			after(); n();
		});
	}

	// Use basic fade function by default
	else { tooltip.fadeTo(90, state ? 1 : 0, after); }

	// If inactive hide method is set, active it
	if(state) { opts.target.trigger('qtip-'+this.id+'-inactive'); }

	return this;
};

PROTOTYPE.show = function(event) { return this.toggle(TRUE, event); };

PROTOTYPE.hide = function(event) { return this.toggle(FALSE, event); };
;PROTOTYPE.focus = function(event) {
	if(!this.rendered || this.destroyed) { return this; }

	var qtips = $(SELECTOR),
		tooltip = this.tooltip,
		curIndex = parseInt(tooltip[0].style.zIndex, 10),
		newIndex = QTIP.zindex + qtips.length;

	// Only update the z-index if it has changed and tooltip is not already focused
	if(!tooltip.hasClass(CLASS_FOCUS)) {
		// tooltipfocus event
		if(this._trigger('focus', [newIndex], event)) {
			// Only update z-index's if they've changed
			if(curIndex !== newIndex) {
				// Reduce our z-index's and keep them properly ordered
				qtips.each(function() {
					if(this.style.zIndex > curIndex) {
						this.style.zIndex = this.style.zIndex - 1;
					}
				});

				// Fire blur event for focused tooltip
				qtips.filter('.' + CLASS_FOCUS).qtip('blur', event);
			}

			// Set the new z-index
			tooltip.addClass(CLASS_FOCUS)[0].style.zIndex = newIndex;
		}
	}

	return this;
};

PROTOTYPE.blur = function(event) {
	if(!this.rendered || this.destroyed) { return this; }

	// Set focused status to FALSE
	this.tooltip.removeClass(CLASS_FOCUS);

	// tooltipblur event
	this._trigger('blur', [ this.tooltip.css('zIndex') ], event);

	return this;
};
;PROTOTYPE.disable = function(state) {
	if(this.destroyed) { return this; }

	// If 'toggle' is passed, toggle the current state
	if(state === 'toggle') {
		state = !(this.rendered ? this.tooltip.hasClass(CLASS_DISABLED) : this.disabled);
	}

	// Disable if no state passed
	else if('boolean' !== typeof state) {
		state = TRUE;
	}

	if(this.rendered) {
		this.tooltip.toggleClass(CLASS_DISABLED, state)
			.attr('aria-disabled', state);
	}

	this.disabled = !!state;

	return this;
};

PROTOTYPE.enable = function() { return this.disable(FALSE); };
;PROTOTYPE._createButton = function()
{
	var self = this,
		elements = this.elements,
		tooltip = elements.tooltip,
		button = this.options.content.button,
		isString = typeof button === 'string',
		close = isString ? button : 'Close tooltip';

	if(elements.button) { elements.button.remove(); }

	// Use custom button if one was supplied by user, else use default
	if(button.jquery) {
		elements.button = button;
	}
	else {
		elements.button = $('<a />', {
			'class': 'qtip-close ' + (this.options.style.widget ? '' : NAMESPACE+'-icon'),
			'title': close,
			'aria-label': close
		})
		.prepend(
			$('<span />', {
				'class': 'ui-icon ui-icon-close',
				'html': '&times;'
			})
		);
	}

	// Create button and setup attributes
	elements.button.appendTo(elements.titlebar || tooltip)
		.attr('role', 'button')
		.click(function(event) {
			if(!tooltip.hasClass(CLASS_DISABLED)) { self.hide(event); }
			return FALSE;
		});
};

PROTOTYPE._updateButton = function(button)
{
	// Make sure tooltip is rendered and if not, return
	if(!this.rendered) { return FALSE; }

	var elem = this.elements.button;
	if(button) { this._createButton(); }
	else { elem.remove(); }
};
;// Widget class creator
function createWidgetClass(cls) {
	return WIDGET.concat('').join(cls ? '-'+cls+' ' : ' ');
}

// Widget class setter method
PROTOTYPE._setWidget = function()
{
	var on = this.options.style.widget,
		elements = this.elements,
		tooltip = elements.tooltip,
		disabled = tooltip.hasClass(CLASS_DISABLED);

	tooltip.removeClass(CLASS_DISABLED);
	CLASS_DISABLED = on ? 'ui-state-disabled' : 'qtip-disabled';
	tooltip.toggleClass(CLASS_DISABLED, disabled);

	tooltip.toggleClass('ui-helper-reset '+createWidgetClass(), on).toggleClass(CLASS_DEFAULT, this.options.style.def && !on);

	if(elements.content) {
		elements.content.toggleClass( createWidgetClass('content'), on);
	}
	if(elements.titlebar) {
		elements.titlebar.toggleClass( createWidgetClass('header'), on);
	}
	if(elements.button) {
		elements.button.toggleClass(NAMESPACE+'-icon', !on);
	}
};
;function delay(callback, duration) {
	// If tooltip has displayed, start hide timer
	if(duration > 0) {
		return setTimeout(
			$.proxy(callback, this), duration
		);
	}
	else{ callback.call(this); }
}

function showMethod(event) {
	if(this.tooltip.hasClass(CLASS_DISABLED)) { return; }

	// Clear hide timers
	clearTimeout(this.timers.show);
	clearTimeout(this.timers.hide);

	// Start show timer
	this.timers.show = delay.call(this,
		function() { this.toggle(TRUE, event); },
		this.options.show.delay
	);
}

function hideMethod(event) {
	if(this.tooltip.hasClass(CLASS_DISABLED) || this.destroyed) { return; }

	// Check if new target was actually the tooltip element
	var relatedTarget = $(event.relatedTarget),
		ontoTooltip = relatedTarget.closest(SELECTOR)[0] === this.tooltip[0],
		ontoTarget = relatedTarget[0] === this.options.show.target[0];

	// Clear timers and stop animation queue
	clearTimeout(this.timers.show);
	clearTimeout(this.timers.hide);

	// Prevent hiding if tooltip is fixed and event target is the tooltip.
	// Or if mouse positioning is enabled and cursor momentarily overlaps
	if(this !== relatedTarget[0] &&
		(this.options.position.target === 'mouse' && ontoTooltip) ||
		this.options.hide.fixed && (
			(/mouse(out|leave|move)/).test(event.type) && (ontoTooltip || ontoTarget))
		)
	{
		/* eslint-disable no-empty */
		try {
			event.preventDefault();
			event.stopImmediatePropagation();
		} catch(e) {}
		/* eslint-enable no-empty */

		return;
	}

	// If tooltip has displayed, start hide timer
	this.timers.hide = delay.call(this,
		function() { this.toggle(FALSE, event); },
		this.options.hide.delay,
		this
	);
}

function inactiveMethod(event) {
	if(this.tooltip.hasClass(CLASS_DISABLED) || !this.options.hide.inactive) { return; }

	// Clear timer
	clearTimeout(this.timers.inactive);

	this.timers.inactive = delay.call(this,
		function(){ this.hide(event); },
		this.options.hide.inactive
	);
}

function repositionMethod(event) {
	if(this.rendered && this.tooltip[0].offsetWidth > 0) { this.reposition(event); }
}

// Store mouse coordinates
PROTOTYPE._storeMouse = function(event) {
	(this.mouse = $.event.fix(event)).type = 'mousemove';
	return this;
};

// Bind events
PROTOTYPE._bind = function(targets, events, method, suffix, context) {
	if(!targets || !method || !events.length) { return; }
	var ns = '.' + this._id + (suffix ? '-'+suffix : '');
	$(targets).bind(
		(events.split ? events : events.join(ns + ' ')) + ns,
		$.proxy(method, context || this)
	);
	return this;
};
PROTOTYPE._unbind = function(targets, suffix) {
	targets && $(targets).unbind('.' + this._id + (suffix ? '-'+suffix : ''));
	return this;
};

// Global delegation helper
function delegate(selector, events, method) {
	$(document.body).delegate(selector,
		(events.split ? events : events.join('.'+NAMESPACE + ' ')) + '.'+NAMESPACE,
		function() {
			var api = QTIP.api[ $.attr(this, ATTR_ID) ];
			api && !api.disabled && method.apply(api, arguments);
		}
	);
}
// Event trigger
PROTOTYPE._trigger = function(type, args, event) {
	var callback = new $.Event('tooltip'+type);
	callback.originalEvent = event && $.extend({}, event) || this.cache.event || NULL;

	this.triggering = type;
	this.tooltip.trigger(callback, [this].concat(args || []));
	this.triggering = FALSE;

	return !callback.isDefaultPrevented();
};

PROTOTYPE._bindEvents = function(showEvents, hideEvents, showTargets, hideTargets, showCallback, hideCallback) {
	// Get tasrgets that lye within both
	var similarTargets = showTargets.filter( hideTargets ).add( hideTargets.filter(showTargets) ),
		toggleEvents = [];

	// If hide and show targets are the same...
	if(similarTargets.length) {

		// Filter identical show/hide events
		$.each(hideEvents, function(i, type) {
			var showIndex = $.inArray(type, showEvents);

			// Both events are identical, remove from both hide and show events
			// and append to toggleEvents
			showIndex > -1 && toggleEvents.push( showEvents.splice( showIndex, 1 )[0] );
		});

		// Toggle events are special case of identical show/hide events, which happen in sequence
		if(toggleEvents.length) {
			// Bind toggle events to the similar targets
			this._bind(similarTargets, toggleEvents, function(event) {
				var state = this.rendered ? this.tooltip[0].offsetWidth > 0 : false;
				(state ? hideCallback : showCallback).call(this, event);
			});

			// Remove the similar targets from the regular show/hide bindings
			showTargets = showTargets.not(similarTargets);
			hideTargets = hideTargets.not(similarTargets);
		}
	}

	// Apply show/hide/toggle events
	this._bind(showTargets, showEvents, showCallback);
	this._bind(hideTargets, hideEvents, hideCallback);
};

PROTOTYPE._assignInitialEvents = function(event) {
	var options = this.options,
		showTarget = options.show.target,
		hideTarget = options.hide.target,
		showEvents = options.show.event ? $.trim('' + options.show.event).split(' ') : [],
		hideEvents = options.hide.event ? $.trim('' + options.hide.event).split(' ') : [];

	// Catch remove/removeqtip events on target element to destroy redundant tooltips
	this._bind(this.elements.target, ['remove', 'removeqtip'], function() {
		this.destroy(true);
	}, 'destroy');

	/*
	 * Make sure hoverIntent functions properly by using mouseleave as a hide event if
	 * mouseenter/mouseout is used for show.event, even if it isn't in the users options.
	 */
	if(/mouse(over|enter)/i.test(options.show.event) && !/mouse(out|leave)/i.test(options.hide.event)) {
		hideEvents.push('mouseleave');
	}

	/*
	 * Also make sure initial mouse targetting works correctly by caching mousemove coords
	 * on show targets before the tooltip has rendered. Also set onTarget when triggered to
	 * keep mouse tracking working.
	 */
	this._bind(showTarget, 'mousemove', function(moveEvent) {
		this._storeMouse(moveEvent);
		this.cache.onTarget = TRUE;
	});

	// Define hoverIntent function
	function hoverIntent(hoverEvent) {
		// Only continue if tooltip isn't disabled
		if(this.disabled || this.destroyed) { return FALSE; }

		// Cache the event data
		this.cache.event = hoverEvent && $.event.fix(hoverEvent);
		this.cache.target = hoverEvent && $(hoverEvent.target);

		// Start the event sequence
		clearTimeout(this.timers.show);
		this.timers.show = delay.call(this,
			function() { this.render(typeof hoverEvent === 'object' || options.show.ready); },
			options.prerender ? 0 : options.show.delay
		);
	}

	// Filter and bind events
	this._bindEvents(showEvents, hideEvents, showTarget, hideTarget, hoverIntent, function() {
		if(!this.timers) { return FALSE; }
		clearTimeout(this.timers.show);
	});

	// Prerendering is enabled, create tooltip now
	if(options.show.ready || options.prerender) { hoverIntent.call(this, event); }
};

// Event assignment method
PROTOTYPE._assignEvents = function() {
	var self = this,
		options = this.options,
		posOptions = options.position,

		tooltip = this.tooltip,
		showTarget = options.show.target,
		hideTarget = options.hide.target,
		containerTarget = posOptions.container,
		viewportTarget = posOptions.viewport,
		documentTarget = $(document),
		windowTarget = $(window),

		showEvents = options.show.event ? $.trim('' + options.show.event).split(' ') : [],
		hideEvents = options.hide.event ? $.trim('' + options.hide.event).split(' ') : [];


	// Assign passed event callbacks
	$.each(options.events, function(name, callback) {
		self._bind(tooltip, name === 'toggle' ? ['tooltipshow','tooltiphide'] : ['tooltip'+name], callback, null, tooltip);
	});

	// Hide tooltips when leaving current window/frame (but not select/option elements)
	if(/mouse(out|leave)/i.test(options.hide.event) && options.hide.leave === 'window') {
		this._bind(documentTarget, ['mouseout', 'blur'], function(event) {
			if(!/select|option/.test(event.target.nodeName) && !event.relatedTarget) {
				this.hide(event);
			}
		});
	}

	// Enable hide.fixed by adding appropriate class
	if(options.hide.fixed) {
		hideTarget = hideTarget.add( tooltip.addClass(CLASS_FIXED) );
	}

	/*
	 * Make sure hoverIntent functions properly by using mouseleave to clear show timer if
	 * mouseenter/mouseout is used for show.event, even if it isn't in the users options.
	 */
	else if(/mouse(over|enter)/i.test(options.show.event)) {
		this._bind(hideTarget, 'mouseleave', function() {
			clearTimeout(this.timers.show);
		});
	}

	// Hide tooltip on document mousedown if unfocus events are enabled
	if(('' + options.hide.event).indexOf('unfocus') > -1) {
		this._bind(containerTarget.closest('html'), ['mousedown', 'touchstart'], function(event) {
			var elem = $(event.target),
				enabled = this.rendered && !this.tooltip.hasClass(CLASS_DISABLED) && this.tooltip[0].offsetWidth > 0,
				isAncestor = elem.parents(SELECTOR).filter(this.tooltip[0]).length > 0;

			if(elem[0] !== this.target[0] && elem[0] !== this.tooltip[0] && !isAncestor &&
				!this.target.has(elem[0]).length && enabled
			) {
				this.hide(event);
			}
		});
	}

	// Check if the tooltip hides when inactive
	if('number' === typeof options.hide.inactive) {
		// Bind inactive method to show target(s) as a custom event
		this._bind(showTarget, 'qtip-'+this.id+'-inactive', inactiveMethod, 'inactive');

		// Define events which reset the 'inactive' event handler
		this._bind(hideTarget.add(tooltip), QTIP.inactiveEvents, inactiveMethod);
	}

	// Filter and bind events
	this._bindEvents(showEvents, hideEvents, showTarget, hideTarget, showMethod, hideMethod);

	// Mouse movement bindings
	this._bind(showTarget.add(tooltip), 'mousemove', function(event) {
		// Check if the tooltip hides when mouse is moved a certain distance
		if('number' === typeof options.hide.distance) {
			var origin = this.cache.origin || {},
				limit = this.options.hide.distance,
				abs = Math.abs;

			// Check if the movement has gone beyond the limit, and hide it if so
			if(abs(event.pageX - origin.pageX) >= limit || abs(event.pageY - origin.pageY) >= limit) {
				this.hide(event);
			}
		}

		// Cache mousemove coords on show targets
		this._storeMouse(event);
	});

	// Mouse positioning events
	if(posOptions.target === 'mouse') {
		// If mouse adjustment is on...
		if(posOptions.adjust.mouse) {
			// Apply a mouseleave event so we don't get problems with overlapping
			if(options.hide.event) {
				// Track if we're on the target or not
				this._bind(showTarget, ['mouseenter', 'mouseleave'], function(event) {
					if(!this.cache) {return FALSE; }
					this.cache.onTarget = event.type === 'mouseenter';
				});
			}

			// Update tooltip position on mousemove
			this._bind(documentTarget, 'mousemove', function(event) {
				// Update the tooltip position only if the tooltip is visible and adjustment is enabled
				if(this.rendered && this.cache.onTarget && !this.tooltip.hasClass(CLASS_DISABLED) && this.tooltip[0].offsetWidth > 0) {
					this.reposition(event);
				}
			});
		}
	}

	// Adjust positions of the tooltip on window resize if enabled
	if(posOptions.adjust.resize || viewportTarget.length) {
		this._bind( $.event.special.resize ? viewportTarget : windowTarget, 'resize', repositionMethod );
	}

	// Adjust tooltip position on scroll of the window or viewport element if present
	if(posOptions.adjust.scroll) {
		this._bind( windowTarget.add(posOptions.container), 'scroll', repositionMethod );
	}
};

// Un-assignment method
PROTOTYPE._unassignEvents = function() {
	var options = this.options,
		showTargets = options.show.target,
		hideTargets = options.hide.target,
		targets = $.grep([
			this.elements.target[0],
			this.rendered && this.tooltip[0],
			options.position.container[0],
			options.position.viewport[0],
			options.position.container.closest('html')[0], // unfocus
			window,
			document
		], function(i) {
			return typeof i === 'object';
		});

	// Add show and hide targets if they're valid
	if(showTargets && showTargets.toArray) {
		targets = targets.concat(showTargets.toArray());
	}
	if(hideTargets && hideTargets.toArray) {
		targets = targets.concat(hideTargets.toArray());
	}

	// Unbind the events
	this._unbind(targets)
		._unbind(targets, 'destroy')
		._unbind(targets, 'inactive');
};

// Apply common event handlers using delegate (avoids excessive .bind calls!)
$(function() {
	delegate(SELECTOR, ['mouseenter', 'mouseleave'], function(event) {
		var state = event.type === 'mouseenter',
			tooltip = $(event.currentTarget),
			target = $(event.relatedTarget || event.target),
			options = this.options;

		// On mouseenter...
		if(state) {
			// Focus the tooltip on mouseenter (z-index stacking)
			this.focus(event);

			// Clear hide timer on tooltip hover to prevent it from closing
			tooltip.hasClass(CLASS_FIXED) && !tooltip.hasClass(CLASS_DISABLED) && clearTimeout(this.timers.hide);
		}

		// On mouseleave...
		else {
			// When mouse tracking is enabled, hide when we leave the tooltip and not onto the show target (if a hide event is set)
			if(options.position.target === 'mouse' && options.position.adjust.mouse &&
				options.hide.event && options.show.target && !target.closest(options.show.target[0]).length) {
				this.hide(event);
			}
		}

		// Add hover class
		tooltip.toggleClass(CLASS_HOVER, state);
	});

	// Define events which reset the 'inactive' event handler
	delegate('['+ATTR_ID+']', INACTIVE_EVENTS, inactiveMethod);
});
;// Initialization method
function init(elem, id, opts) {
	var obj, posOptions, attr, config, title,

	// Setup element references
	docBody = $(document.body),

	// Use document body instead of document element if needed
	newTarget = elem[0] === document ? docBody : elem,

	// Grab metadata from element if plugin is present
	metadata = elem.metadata ? elem.metadata(opts.metadata) : NULL,

	// If metadata type if HTML5, grab 'name' from the object instead, or use the regular data object otherwise
	metadata5 = opts.metadata.type === 'html5' && metadata ? metadata[opts.metadata.name] : NULL,

	// Grab data from metadata.name (or data-qtipopts as fallback) using .data() method,
	html5 = elem.data(opts.metadata.name || 'qtipopts');

	// If we don't get an object returned attempt to parse it manualyl without parseJSON
	/* eslint-disable no-empty */
	try { html5 = typeof html5 === 'string' ? $.parseJSON(html5) : html5; }
	catch(e) {}
	/* eslint-enable no-empty */

	// Merge in and sanitize metadata
	config = $.extend(TRUE, {}, QTIP.defaults, opts,
		typeof html5 === 'object' ? sanitizeOptions(html5) : NULL,
		sanitizeOptions(metadata5 || metadata));

	// Re-grab our positioning options now we've merged our metadata and set id to passed value
	posOptions = config.position;
	config.id = id;

	// Setup missing content if none is detected
	if('boolean' === typeof config.content.text) {
		attr = elem.attr(config.content.attr);

		// Grab from supplied attribute if available
		if(config.content.attr !== FALSE && attr) { config.content.text = attr; }

		// No valid content was found, abort render
		else { return FALSE; }
	}

	// Setup target options
	if(!posOptions.container.length) { posOptions.container = docBody; }
	if(posOptions.target === FALSE) { posOptions.target = newTarget; }
	if(config.show.target === FALSE) { config.show.target = newTarget; }
	if(config.show.solo === TRUE) { config.show.solo = posOptions.container.closest('body'); }
	if(config.hide.target === FALSE) { config.hide.target = newTarget; }
	if(config.position.viewport === TRUE) { config.position.viewport = posOptions.container; }

	// Ensure we only use a single container
	posOptions.container = posOptions.container.eq(0);

	// Convert position corner values into x and y strings
	posOptions.at = new CORNER(posOptions.at, TRUE);
	posOptions.my = new CORNER(posOptions.my);

	// Destroy previous tooltip if overwrite is enabled, or skip element if not
	if(elem.data(NAMESPACE)) {
		if(config.overwrite) {
			elem.qtip('destroy', true);
		}
		else if(config.overwrite === FALSE) {
			return FALSE;
		}
	}

	// Add has-qtip attribute
	elem.attr(ATTR_HAS, id);

	// Remove title attribute and store it if present
	if(config.suppress && (title = elem.attr('title'))) {
		// Final attr call fixes event delegatiom and IE default tooltip showing problem
		elem.removeAttr('title').attr(oldtitle, title).attr('title', '');
	}

	// Initialize the tooltip and add API reference
	obj = new QTip(elem, config, id, !!attr);
	elem.data(NAMESPACE, obj);

	return obj;
}

// jQuery $.fn extension method
QTIP = $.fn.qtip = function(options, notation, newValue)
{
	var command = ('' + options).toLowerCase(), // Parse command
		returned = NULL,
		args = $.makeArray(arguments).slice(1),
		event = args[args.length - 1],
		opts = this[0] ? $.data(this[0], NAMESPACE) : NULL;

	// Check for API request
	if(!arguments.length && opts || command === 'api') {
		return opts;
	}

	// Execute API command if present
	else if('string' === typeof options) {
		this.each(function() {
			var api = $.data(this, NAMESPACE);
			if(!api) { return TRUE; }

			// Cache the event if possible
			if(event && event.timeStamp) { api.cache.event = event; }

			// Check for specific API commands
			if(notation && (command === 'option' || command === 'options')) {
				if(newValue !== undefined || $.isPlainObject(notation)) {
					api.set(notation, newValue);
				}
				else {
					returned = api.get(notation);
					return FALSE;
				}
			}

			// Execute API command
			else if(api[command]) {
				api[command].apply(api, args);
			}
		});

		return returned !== NULL ? returned : this;
	}

	// No API commands. validate provided options and setup qTips
	else if('object' === typeof options || !arguments.length) {
		// Sanitize options first
		opts = sanitizeOptions($.extend(TRUE, {}, options));

		return this.each(function(i) {
			var api, id;

			// Find next available ID, or use custom ID if provided
			id = $.isArray(opts.id) ? opts.id[i] : opts.id;
			id = !id || id === FALSE || id.length < 1 || QTIP.api[id] ? QTIP.nextid++ : id;

			// Initialize the qTip and re-grab newly sanitized options
			api = init($(this), id, opts);
			if(api === FALSE) { return TRUE; }
			else { QTIP.api[id] = api; }

			// Initialize plugins
			$.each(PLUGINS, function() {
				if(this.initialize === 'initialize') { this(api); }
			});

			// Assign initial pre-render events
			api._assignInitialEvents(event);
		});
	}
};

// Expose class
$.qtip = QTip;

// Populated in render method
QTIP.api = {};
;$.each({
	/* Allow other plugins to successfully retrieve the title of an element with a qTip applied */
	attr: function(attr, val) {
		if(this.length) {
			var self = this[0],
				title = 'title',
				api = $.data(self, 'qtip');

			if(attr === title && api && api.options && 'object' === typeof api && 'object' === typeof api.options && api.options.suppress) {
				if(arguments.length < 2) {
					return $.attr(self, oldtitle);
				}

				// If qTip is rendered and title was originally used as content, update it
				if(api && api.options.content.attr === title && api.cache.attr) {
					api.set('content.text', val);
				}

				// Use the regular attr method to set, then cache the result
				return this.attr(oldtitle, val);
			}
		}

		return $.fn['attr'+replaceSuffix].apply(this, arguments);
	},

	/* Allow clone to correctly retrieve cached title attributes */
	clone: function(keepData) {
		// Clone our element using the real clone method
		var elems = $.fn['clone'+replaceSuffix].apply(this, arguments);

		// Grab all elements with an oldtitle set, and change it to regular title attribute, if keepData is false
		if(!keepData) {
			elems.filter('['+oldtitle+']').attr('title', function() {
				return $.attr(this, oldtitle);
			})
			.removeAttr(oldtitle);
		}

		return elems;
	}
}, function(name, func) {
	if(!func || $.fn[name+replaceSuffix]) { return TRUE; }

	var old = $.fn[name+replaceSuffix] = $.fn[name];
	$.fn[name] = function() {
		return func.apply(this, arguments) || old.apply(this, arguments);
	};
});

/* Fire off 'removeqtip' handler in $.cleanData if jQuery UI not present (it already does similar).
 * This snippet is taken directly from jQuery UI source code found here:
 *     http://code.jquery.com/ui/jquery-ui-git.js
 */
if(!$.ui) {
	$['cleanData'+replaceSuffix] = $.cleanData;
	$.cleanData = function( elems ) {
		for(var i = 0, elem; (elem = $( elems[i] )).length; i++) {
			if(elem.attr(ATTR_HAS)) {
				/* eslint-disable no-empty */
				try { elem.triggerHandler('removeqtip'); }
				catch( e ) {}
				/* eslint-enable no-empty */
			}
		}
		$['cleanData'+replaceSuffix].apply(this, arguments);
	};
}
;// qTip version
QTIP.version = '3.0.3';

// Base ID for all qTips
QTIP.nextid = 0;

// Inactive events array
QTIP.inactiveEvents = INACTIVE_EVENTS;

// Base z-index for all qTips
QTIP.zindex = 15000;

// Define configuration defaults
QTIP.defaults = {
	prerender: FALSE,
	id: FALSE,
	overwrite: TRUE,
	suppress: TRUE,
	content: {
		text: TRUE,
		attr: 'title',
		title: FALSE,
		button: FALSE
	},
	position: {
		my: 'top left',
		at: 'bottom right',
		target: FALSE,
		container: FALSE,
		viewport: FALSE,
		adjust: {
			x: 0, y: 0,
			mouse: TRUE,
			scroll: TRUE,
			resize: TRUE,
			method: 'flipinvert flipinvert'
		},
		effect: function(api, pos) {
			$(this).animate(pos, {
				duration: 200,
				queue: FALSE
			});
		}
	},
	show: {
		target: FALSE,
		event: 'mouseenter',
		effect: TRUE,
		delay: 90,
		solo: FALSE,
		ready: FALSE,
		autofocus: FALSE
	},
	hide: {
		target: FALSE,
		event: 'mouseleave',
		effect: TRUE,
		delay: 0,
		fixed: FALSE,
		inactive: FALSE,
		leave: 'window',
		distance: FALSE
	},
	style: {
		classes: '',
		widget: FALSE,
		width: FALSE,
		height: FALSE,
		def: TRUE
	},
	events: {
		render: NULL,
		move: NULL,
		show: NULL,
		hide: NULL,
		toggle: NULL,
		visible: NULL,
		hidden: NULL,
		focus: NULL,
		blur: NULL
	}
};
;var TIP,
createVML,
SCALE,
PIXEL_RATIO,
BACKING_STORE_RATIO,

// Common CSS strings
MARGIN = 'margin',
BORDER = 'border',
COLOR = 'color',
BG_COLOR = 'background-color',
TRANSPARENT = 'transparent',
IMPORTANT = ' !important',

// Check if the browser supports <canvas/> elements
HASCANVAS = !!document.createElement('canvas').getContext,

// Invalid colour values used in parseColours()
INVALID = /rgba?\(0, 0, 0(, 0)?\)|transparent|#123456/i;

// Camel-case method, taken from jQuery source
// http://code.jquery.com/jquery-1.8.0.js
function camel(s) { return s.charAt(0).toUpperCase() + s.slice(1); }

/*
 * Modified from Modernizr's testPropsAll()
 * http://modernizr.com/downloads/modernizr-latest.js
 */
var cssProps = {}, cssPrefixes = ['Webkit', 'O', 'Moz', 'ms'];
function vendorCss(elem, prop) {
	var ucProp = prop.charAt(0).toUpperCase() + prop.slice(1),
		props = (prop + ' ' + cssPrefixes.join(ucProp + ' ') + ucProp).split(' '),
		cur, val, i = 0;

	// If the property has already been mapped...
	if(cssProps[prop]) { return elem.css(cssProps[prop]); }

	while(cur = props[i++]) {
		if((val = elem.css(cur)) !== undefined) {
			cssProps[prop] = cur;
			return val;
		}
	}
}

// Parse a given elements CSS property into an int
function intCss(elem, prop) {
	return Math.ceil(parseFloat(vendorCss(elem, prop)));
}


// VML creation (for IE only)
if(!HASCANVAS) {
	createVML = function(tag, props, style) {
		return '<qtipvml:'+tag+' xmlns="urn:schemas-microsoft.com:vml" class="qtip-vml" '+(props||'')+
			' style="behavior: url(#default#VML); '+(style||'')+ '" />';
	};
}

// Canvas only definitions
else {
	PIXEL_RATIO = window.devicePixelRatio || 1;
	BACKING_STORE_RATIO = (function() {
		var context = document.createElement('canvas').getContext('2d');
		return context.backingStorePixelRatio || context.webkitBackingStorePixelRatio || context.mozBackingStorePixelRatio ||
				context.msBackingStorePixelRatio || context.oBackingStorePixelRatio || 1;
	})();
	SCALE = PIXEL_RATIO / BACKING_STORE_RATIO;
}


function Tip(qtip, options) {
	this._ns = 'tip';
	this.options = options;
	this.offset = options.offset;
	this.size = [ options.width, options.height ];

	// Initialize
	this.qtip = qtip;
	this.init(qtip);
}

$.extend(Tip.prototype, {
	init: function(qtip) {
		var context, tip;

		// Create tip element and prepend to the tooltip
		tip = this.element = qtip.elements.tip = $('<div />', { 'class': NAMESPACE+'-tip' }).prependTo(qtip.tooltip);

		// Create tip drawing element(s)
		if(HASCANVAS) {
			// save() as soon as we create the canvas element so FF2 doesn't bork on our first restore()!
			context = $('<canvas />').appendTo(this.element)[0].getContext('2d');

			// Setup constant parameters
			context.lineJoin = 'miter';
			context.miterLimit = 100000;
			context.save();
		}
		else {
			context = createVML('shape', 'coordorigin="0,0"', 'position:absolute;');
			this.element.html(context + context);

			// Prevent mousing down on the tip since it causes problems with .live() handling in IE due to VML
			qtip._bind( $('*', tip).add(tip), ['click', 'mousedown'], function(event) { event.stopPropagation(); }, this._ns);
		}

		// Bind update events
		qtip._bind(qtip.tooltip, 'tooltipmove', this.reposition, this._ns, this);

		// Create it
		this.create();
	},

	_swapDimensions: function() {
		this.size[0] = this.options.height;
		this.size[1] = this.options.width;
	},
	_resetDimensions: function() {
		this.size[0] = this.options.width;
		this.size[1] = this.options.height;
	},

	_useTitle: function(corner) {
		var titlebar = this.qtip.elements.titlebar;
		return titlebar && (
			corner.y === TOP || corner.y === CENTER && this.element.position().top + this.size[1] / 2 + this.options.offset < titlebar.outerHeight(TRUE)
		);
	},

	_parseCorner: function(corner) {
		var my = this.qtip.options.position.my;

		// Detect corner and mimic properties
		if(corner === FALSE || my === FALSE) {
			corner = FALSE;
		}
		else if(corner === TRUE) {
			corner = new CORNER( my.string() );
		}
		else if(!corner.string) {
			corner = new CORNER(corner);
			corner.fixed = TRUE;
		}

		return corner;
	},

	_parseWidth: function(corner, side, use) {
		var elements = this.qtip.elements,
			prop = BORDER + camel(side) + 'Width';

		return (use ? intCss(use, prop) : 
			intCss(elements.content, prop) ||
			intCss(this._useTitle(corner) && elements.titlebar || elements.content, prop) ||
			intCss(elements.tooltip, prop)
		) || 0;
	},

	_parseRadius: function(corner) {
		var elements = this.qtip.elements,
			prop = BORDER + camel(corner.y) + camel(corner.x) + 'Radius';

		return BROWSER.ie < 9 ? 0 :
			intCss(this._useTitle(corner) && elements.titlebar || elements.content, prop) ||
			intCss(elements.tooltip, prop) || 0;
	},

	_invalidColour: function(elem, prop, compare) {
		var val = elem.css(prop);
		return !val || compare && val === elem.css(compare) || INVALID.test(val) ? FALSE : val;
	},

	_parseColours: function(corner) {
		var elements = this.qtip.elements,
			tip = this.element.css('cssText', ''),
			borderSide = BORDER + camel(corner[ corner.precedance ]) + camel(COLOR),
			colorElem = this._useTitle(corner) && elements.titlebar || elements.content,
			css = this._invalidColour, color = [];

		// Attempt to detect the background colour from various elements, left-to-right precedance
		color[0] = css(tip, BG_COLOR) || css(colorElem, BG_COLOR) || css(elements.content, BG_COLOR) ||
			css(elements.tooltip, BG_COLOR) || tip.css(BG_COLOR);

		// Attempt to detect the correct border side colour from various elements, left-to-right precedance
		color[1] = css(tip, borderSide, COLOR) || css(colorElem, borderSide, COLOR) ||
			css(elements.content, borderSide, COLOR) || css(elements.tooltip, borderSide, COLOR) || elements.tooltip.css(borderSide);

		// Reset background and border colours
		$('*', tip).add(tip).css('cssText', BG_COLOR+':'+TRANSPARENT+IMPORTANT+';'+BORDER+':0'+IMPORTANT+';');

		return color;
	},

	_calculateSize: function(corner) {
		var y = corner.precedance === Y,
			width = this.options.width,
			height = this.options.height,
			isCenter = corner.abbrev() === 'c',
			base = (y ? width: height) * (isCenter ? 0.5 : 1),
			pow = Math.pow,
			round = Math.round,
			bigHyp, ratio, result,

		smallHyp = Math.sqrt( pow(base, 2) + pow(height, 2) ),
		hyp = [
			this.border / base * smallHyp,
			this.border / height * smallHyp
		];

		hyp[2] = Math.sqrt( pow(hyp[0], 2) - pow(this.border, 2) );
		hyp[3] = Math.sqrt( pow(hyp[1], 2) - pow(this.border, 2) );

		bigHyp = smallHyp + hyp[2] + hyp[3] + (isCenter ? 0 : hyp[0]);
		ratio = bigHyp / smallHyp;

		result = [ round(ratio * width), round(ratio * height) ];
		return y ? result : result.reverse();
	},

	// Tip coordinates calculator
	_calculateTip: function(corner, size, scale) {
		scale = scale || 1;
		size = size || this.size;

		var width = size[0] * scale,
			height = size[1] * scale,
			width2 = Math.ceil(width / 2), height2 = Math.ceil(height / 2),

		// Define tip coordinates in terms of height and width values
		tips = {
			br:	[0,0,		width,height,	width,0],
			bl:	[0,0,		width,0,		0,height],
			tr:	[0,height,	width,0,		width,height],
			tl:	[0,0,		0,height,		width,height],
			tc:	[0,height,	width2,0,		width,height],
			bc:	[0,0,		width,0,		width2,height],
			rc:	[0,0,		width,height2,	0,height],
			lc:	[width,0,	width,height,	0,height2]
		};

		// Set common side shapes
		tips.lt = tips.br; tips.rt = tips.bl;
		tips.lb = tips.tr; tips.rb = tips.tl;

		return tips[ corner.abbrev() ];
	},

	// Tip coordinates drawer (canvas)
	_drawCoords: function(context, coords) {
		context.beginPath();
		context.moveTo(coords[0], coords[1]);
		context.lineTo(coords[2], coords[3]);
		context.lineTo(coords[4], coords[5]);
		context.closePath();
	},

	create: function() {
		// Determine tip corner
		var c = this.corner = (HASCANVAS || BROWSER.ie) && this._parseCorner(this.options.corner);

		// If we have a tip corner...
		this.enabled = !!this.corner && this.corner.abbrev() !== 'c';
		if(this.enabled) {
			// Cache it
			this.qtip.cache.corner = c.clone();

			// Create it
			this.update();
		}

		// Toggle tip element
		this.element.toggle(this.enabled);

		return this.corner;
	},

	update: function(corner, position) {
		if(!this.enabled) { return this; }

		var elements = this.qtip.elements,
			tip = this.element,
			inner = tip.children(),
			options = this.options,
			curSize = this.size,
			mimic = options.mimic,
			round = Math.round,
			color, precedance, context,
			coords, bigCoords, translate, newSize, border;

		// Re-determine tip if not already set
		if(!corner) { corner = this.qtip.cache.corner || this.corner; }

		// Use corner property if we detect an invalid mimic value
		if(mimic === FALSE) { mimic = corner; }

		// Otherwise inherit mimic properties from the corner object as necessary
		else {
			mimic = new CORNER(mimic);
			mimic.precedance = corner.precedance;

			if(mimic.x === 'inherit') { mimic.x = corner.x; }
			else if(mimic.y === 'inherit') { mimic.y = corner.y; }
			else if(mimic.x === mimic.y) {
				mimic[ corner.precedance ] = corner[ corner.precedance ];
			}
		}
		precedance = mimic.precedance;

		// Ensure the tip width.height are relative to the tip position
		if(corner.precedance === X) { this._swapDimensions(); }
		else { this._resetDimensions(); }

		// Update our colours
		color = this.color = this._parseColours(corner);

		// Detect border width, taking into account colours
		if(color[1] !== TRANSPARENT) {
			// Grab border width
			border = this.border = this._parseWidth(corner, corner[corner.precedance]);

			// If border width isn't zero, use border color as fill if it's not invalid (1.0 style tips)
			if(options.border && border < 1 && !INVALID.test(color[1])) { color[0] = color[1]; }

			// Set border width (use detected border width if options.border is true)
			this.border = border = options.border !== TRUE ? options.border : border;
		}

		// Border colour was invalid, set border to zero
		else { this.border = border = 0; }

		// Determine tip size
		newSize = this.size = this._calculateSize(corner);
		tip.css({
			width: newSize[0],
			height: newSize[1],
			lineHeight: newSize[1]+'px'
		});

		// Calculate tip translation
		if(corner.precedance === Y) {
			translate = [
				round(mimic.x === LEFT ? border : mimic.x === RIGHT ? newSize[0] - curSize[0] - border : (newSize[0] - curSize[0]) / 2),
				round(mimic.y === TOP ? newSize[1] - curSize[1] : 0)
			];
		}
		else {
			translate = [
				round(mimic.x === LEFT ? newSize[0] - curSize[0] : 0),
				round(mimic.y === TOP ? border : mimic.y === BOTTOM ? newSize[1] - curSize[1] - border : (newSize[1] - curSize[1]) / 2)
			];
		}

		// Canvas drawing implementation
		if(HASCANVAS) {
			// Grab canvas context and clear/save it
			context = inner[0].getContext('2d');
			context.restore(); context.save();
			context.clearRect(0,0,6000,6000);

			// Calculate coordinates
			coords = this._calculateTip(mimic, curSize, SCALE);
			bigCoords = this._calculateTip(mimic, this.size, SCALE);

			// Set the canvas size using calculated size
			inner.attr(WIDTH, newSize[0] * SCALE).attr(HEIGHT, newSize[1] * SCALE);
			inner.css(WIDTH, newSize[0]).css(HEIGHT, newSize[1]);

			// Draw the outer-stroke tip
			this._drawCoords(context, bigCoords);
			context.fillStyle = color[1];
			context.fill();

			// Draw the actual tip
			context.translate(translate[0] * SCALE, translate[1] * SCALE);
			this._drawCoords(context, coords);
			context.fillStyle = color[0];
			context.fill();
		}

		// VML (IE Proprietary implementation)
		else {
			// Calculate coordinates
			coords = this._calculateTip(mimic);

			// Setup coordinates string
			coords = 'm' + coords[0] + ',' + coords[1] + ' l' + coords[2] +
				',' + coords[3] + ' ' + coords[4] + ',' + coords[5] + ' xe';

			// Setup VML-specific offset for pixel-perfection
			translate[2] = border && /^(r|b)/i.test(corner.string()) ?
				BROWSER.ie === 8 ? 2 : 1 : 0;

			// Set initial CSS
			inner.css({
				coordsize: newSize[0]+border + ' ' + newSize[1]+border,
				antialias: ''+(mimic.string().indexOf(CENTER) > -1),
				left: translate[0] - translate[2] * Number(precedance === X),
				top: translate[1] - translate[2] * Number(precedance === Y),
				width: newSize[0] + border,
				height: newSize[1] + border
			})
			.each(function(i) {
				var $this = $(this);

				// Set shape specific attributes
				$this[ $this.prop ? 'prop' : 'attr' ]({
					coordsize: newSize[0]+border + ' ' + newSize[1]+border,
					path: coords,
					fillcolor: color[0],
					filled: !!i,
					stroked: !i
				})
				.toggle(!!(border || i));

				// Check if border is enabled and add stroke element
				!i && $this.html( createVML(
					'stroke', 'weight="'+border*2+'px" color="'+color[1]+'" miterlimit="1000" joinstyle="miter"'
				) );
			});
		}

		// Opera bug #357 - Incorrect tip position
		// https://github.com/Craga89/qTip2/issues/367
		window.opera && setTimeout(function() {
			elements.tip.css({
				display: 'inline-block',
				visibility: 'visible'
			});
		}, 1);

		// Position if needed
		if(position !== FALSE) { this.calculate(corner, newSize); }
	},

	calculate: function(corner, size) {
		if(!this.enabled) { return FALSE; }

		var self = this,
			elements = this.qtip.elements,
			tip = this.element,
			userOffset = this.options.offset,
			position = {},
			precedance, corners;

		// Inherit corner if not provided
		corner = corner || this.corner;
		precedance = corner.precedance;

		// Determine which tip dimension to use for adjustment
		size = size || this._calculateSize(corner);

		// Setup corners and offset array
		corners = [ corner.x, corner.y ];
		if(precedance === X) { corners.reverse(); }

		// Calculate tip position
		$.each(corners, function(i, side) {
			var b, bc, br;

			if(side === CENTER) {
				b = precedance === Y ? LEFT : TOP;
				position[ b ] = '50%';
				position[MARGIN+'-' + b] = -Math.round(size[ precedance === Y ? 0 : 1 ] / 2) + userOffset;
			}
			else {
				b = self._parseWidth(corner, side, elements.tooltip);
				bc = self._parseWidth(corner, side, elements.content);
				br = self._parseRadius(corner);

				position[ side ] = Math.max(-self.border, i ? bc : userOffset + (br > b ? br : -b));
			}
		});

		// Adjust for tip size
		position[ corner[precedance] ] -= size[ precedance === X ? 0 : 1 ];

		// Set and return new position
		tip.css({ margin: '', top: '', bottom: '', left: '', right: '' }).css(position);
		return position;
	},

	reposition: function(event, api, pos) {
		if(!this.enabled) { return; }

		var cache = api.cache,
			newCorner = this.corner.clone(),
			adjust = pos.adjusted,
			method = api.options.position.adjust.method.split(' '),
			horizontal = method[0],
			vertical = method[1] || method[0],
			shift = { left: FALSE, top: FALSE, x: 0, y: 0 },
			offset, css = {}, props;

		function shiftflip(direction, precedance, popposite, side, opposite) {
			// Horizontal - Shift or flip method
			if(direction === SHIFT && newCorner.precedance === precedance && adjust[side] && newCorner[popposite] !== CENTER) {
				newCorner.precedance = newCorner.precedance === X ? Y : X;
			}
			else if(direction !== SHIFT && adjust[side]){
				newCorner[precedance] = newCorner[precedance] === CENTER ?
					adjust[side] > 0 ? side : opposite :
					newCorner[precedance] === side ? opposite : side;
			}
		}

		function shiftonly(xy, side, opposite) {
			if(newCorner[xy] === CENTER) {
				css[MARGIN+'-'+side] = shift[xy] = offset[MARGIN+'-'+side] - adjust[side];
			}
			else {
				props = offset[opposite] !== undefined ?
					[ adjust[side], -offset[side] ] : [ -adjust[side], offset[side] ];

				if( (shift[xy] = Math.max(props[0], props[1])) > props[0] ) {
					pos[side] -= adjust[side];
					shift[side] = FALSE;
				}

				css[ offset[opposite] !== undefined ? opposite : side ] = shift[xy];
			}
		}

		// If our tip position isn't fixed e.g. doesn't adjust with viewport...
		if(this.corner.fixed !== TRUE) {
			// Perform shift/flip adjustments
			shiftflip(horizontal, X, Y, LEFT, RIGHT);
			shiftflip(vertical, Y, X, TOP, BOTTOM);

			// Update and redraw the tip if needed (check cached details of last drawn tip)
			if(newCorner.string() !== cache.corner.string() || cache.cornerTop !== adjust.top || cache.cornerLeft !== adjust.left) {
				this.update(newCorner, FALSE);
			}
		}

		// Setup tip offset properties
		offset = this.calculate(newCorner);

		// Readjust offset object to make it left/top
		if(offset.right !== undefined) { offset.left = -offset.right; }
		if(offset.bottom !== undefined) { offset.top = -offset.bottom; }
		offset.user = this.offset;

		// Perform shift adjustments
		shift.left = horizontal === SHIFT && !!adjust.left;
		if(shift.left) {
			shiftonly(X, LEFT, RIGHT);
		}
		shift.top = vertical === SHIFT && !!adjust.top;
		if(shift.top) {
			shiftonly(Y, TOP, BOTTOM);
		}

		/*
		* If the tip is adjusted in both dimensions, or in a
		* direction that would cause it to be anywhere but the
		* outer border, hide it!
		*/
		this.element.css(css).toggle(
			!(shift.x && shift.y || newCorner.x === CENTER && shift.y || newCorner.y === CENTER && shift.x)
		);

		// Adjust position to accomodate tip dimensions
		pos.left -= offset.left.charAt ? offset.user :
			horizontal !== SHIFT || shift.top || !shift.left && !shift.top ? offset.left + this.border : 0;
		pos.top -= offset.top.charAt ? offset.user :
			vertical !== SHIFT || shift.left || !shift.left && !shift.top ? offset.top + this.border : 0;

		// Cache details
		cache.cornerLeft = adjust.left; cache.cornerTop = adjust.top;
		cache.corner = newCorner.clone();
	},

	destroy: function() {
		// Unbind events
		this.qtip._unbind(this.qtip.tooltip, this._ns);

		// Remove the tip element(s)
		if(this.qtip.elements.tip) {
			this.qtip.elements.tip.find('*')
				.remove().end().remove();
		}
	}
});

TIP = PLUGINS.tip = function(api) {
	return new Tip(api, api.options.style.tip);
};

// Initialize tip on render
TIP.initialize = 'render';

// Setup plugin sanitization options
TIP.sanitize = function(options) {
	if(options.style && 'tip' in options.style) {
		var opts = options.style.tip;
		if(typeof opts !== 'object') { opts = options.style.tip = { corner: opts }; }
		if(!(/string|boolean/i).test(typeof opts.corner)) { opts.corner = TRUE; }
	}
};

// Add new option checks for the plugin
CHECKS.tip = {
	'^position.my|style.tip.(corner|mimic|border)$': function() {
		// Make sure a tip can be drawn
		this.create();

		// Reposition the tooltip
		this.qtip.reposition();
	},
	'^style.tip.(height|width)$': function(obj) {
		// Re-set dimensions and redraw the tip
		this.size = [ obj.width, obj.height ];
		this.update();

		// Reposition the tooltip
		this.qtip.reposition();
	},
	'^content.title|style.(classes|widget)$': function() {
		this.update();
	}
};

// Extend original qTip defaults
$.extend(TRUE, QTIP.defaults, {
	style: {
		tip: {
			corner: TRUE,
			mimic: FALSE,
			width: 6,
			height: 6,
			border: TRUE,
			offset: 0
		}
	}
});
;var MODAL, OVERLAY,
	MODALCLASS = 'qtip-modal',
	MODALSELECTOR = '.'+MODALCLASS;

OVERLAY = function()
{
	var self = this,
		focusableElems = {},
		current,
		prevState,
		elem;

	// Modified code from jQuery UI 1.10.0 source
	// http://code.jquery.com/ui/1.10.0/jquery-ui.js
	function focusable(element) {
		// Use the defined focusable checker when possible
		if($.expr[':'].focusable) { return $.expr[':'].focusable; }

		var isTabIndexNotNaN = !isNaN($.attr(element, 'tabindex')),
			nodeName = element.nodeName && element.nodeName.toLowerCase(),
			map, mapName, img;

		if('area' === nodeName) {
			map = element.parentNode;
			mapName = map.name;
			if(!element.href || !mapName || map.nodeName.toLowerCase() !== 'map') {
				return false;
			}
			img = $('img[usemap=#' + mapName + ']')[0];
			return !!img && img.is(':visible');
		}

		return /input|select|textarea|button|object/.test( nodeName ) ?
			!element.disabled :
			'a' === nodeName ?
				element.href || isTabIndexNotNaN :
				isTabIndexNotNaN
		;
	}

	// Focus inputs using cached focusable elements (see update())
	function focusInputs(blurElems) {
		// Blurring body element in IE causes window.open windows to unfocus!
		if(focusableElems.length < 1 && blurElems.length) { blurElems.not('body').blur(); }

		// Focus the inputs
		else { focusableElems.first().focus(); }
	}

	// Steal focus from elements outside tooltip
	function stealFocus(event) {
		if(!elem.is(':visible')) { return; }

		var target = $(event.target),
			tooltip = current.tooltip,
			container = target.closest(SELECTOR),
			targetOnTop;

		// Determine if input container target is above this
		targetOnTop = container.length < 1 ? FALSE :
			parseInt(container[0].style.zIndex, 10) > parseInt(tooltip[0].style.zIndex, 10);

		// If we're showing a modal, but focus has landed on an input below
		// this modal, divert focus to the first visible input in this modal
		// or if we can't find one... the tooltip itself
		if(!targetOnTop && target.closest(SELECTOR)[0] !== tooltip[0]) {
			focusInputs(target);
		}
	}

	$.extend(self, {
		init: function() {
			// Create document overlay
			elem = self.elem = $('<div />', {
				id: 'qtip-overlay',
				html: '<div></div>',
				mousedown: function() { return FALSE; }
			})
			.hide();

			// Make sure we can't focus anything outside the tooltip
			$(document.body).bind('focusin'+MODALSELECTOR, stealFocus);

			// Apply keyboard "Escape key" close handler
			$(document).bind('keydown'+MODALSELECTOR, function(event) {
				if(current && current.options.show.modal.escape && event.keyCode === 27) {
					current.hide(event);
				}
			});

			// Apply click handler for blur option
			elem.bind('click'+MODALSELECTOR, function(event) {
				if(current && current.options.show.modal.blur) {
					current.hide(event);
				}
			});

			return self;
		},

		update: function(api) {
			// Update current API reference
			current = api;

			// Update focusable elements if enabled
			if(api.options.show.modal.stealfocus !== FALSE) {
				focusableElems = api.tooltip.find('*').filter(function() {
					return focusable(this);
				});
			}
			else { focusableElems = []; }
		},

		toggle: function(api, state, duration) {
			var tooltip = api.tooltip,
				options = api.options.show.modal,
				effect = options.effect,
				type = state ? 'show': 'hide',
				visible = elem.is(':visible'),
				visibleModals = $(MODALSELECTOR).filter(':visible:not(:animated)').not(tooltip);

			// Set active tooltip API reference
			self.update(api);

			// If the modal can steal the focus...
			// Blur the current item and focus anything in the modal we an
			if(state && options.stealfocus !== FALSE) {
				focusInputs( $(':focus') );
			}

			// Toggle backdrop cursor style on show
			elem.toggleClass('blurs', options.blur);

			// Append to body on show
			if(state) {
				elem.appendTo(document.body);
			}

			// Prevent modal from conflicting with show.solo, and don't hide backdrop is other modals are visible
			if(elem.is(':animated') && visible === state && prevState !== FALSE || !state && visibleModals.length) {
				return self;
			}

			// Stop all animations
			elem.stop(TRUE, FALSE);

			// Use custom function if provided
			if($.isFunction(effect)) {
				effect.call(elem, state);
			}

			// If no effect type is supplied, use a simple toggle
			else if(effect === FALSE) {
				elem[ type ]();
			}

			// Use basic fade function
			else {
				elem.fadeTo( parseInt(duration, 10) || 90, state ? 1 : 0, function() {
					if(!state) { elem.hide(); }
				});
			}

			// Reset position and detach from body on hide
			if(!state) {
				elem.queue(function(next) {
					elem.css({ left: '', top: '' });
					if(!$(MODALSELECTOR).length) { elem.detach(); }
					next();
				});
			}

			// Cache the state
			prevState = state;

			// If the tooltip is destroyed, set reference to null
			if(current.destroyed) { current = NULL; }

			return self;
		}
	});

	self.init();
};
OVERLAY = new OVERLAY();

function Modal(api, options) {
	this.options = options;
	this._ns = '-modal';

	this.qtip = api;
	this.init(api);
}

$.extend(Modal.prototype, {
	init: function(qtip) {
		var tooltip = qtip.tooltip;

		// If modal is disabled... return
		if(!this.options.on) { return this; }

		// Set overlay reference
		qtip.elements.overlay = OVERLAY.elem;

		// Add unique attribute so we can grab modal tooltips easily via a SELECTOR, and set z-index
		tooltip.addClass(MODALCLASS).css('z-index', QTIP.modal_zindex + $(MODALSELECTOR).length);

		// Apply our show/hide/focus modal events
		qtip._bind(tooltip, ['tooltipshow', 'tooltiphide'], function(event, api, duration) {
			var oEvent = event.originalEvent;

			// Make sure mouseout doesn't trigger a hide when showing the modal and mousing onto backdrop
			if(event.target === tooltip[0]) {
				if(oEvent && event.type === 'tooltiphide' && /mouse(leave|enter)/.test(oEvent.type) && $(oEvent.relatedTarget).closest(OVERLAY.elem[0]).length) {
					/* eslint-disable no-empty */
					try { event.preventDefault(); }
					catch(e) {}
					/* eslint-enable no-empty */
				}
				else if(!oEvent || oEvent && oEvent.type !== 'tooltipsolo') {
					this.toggle(event, event.type === 'tooltipshow', duration);
				}
			}
		}, this._ns, this);

		// Adjust modal z-index on tooltip focus
		qtip._bind(tooltip, 'tooltipfocus', function(event, api) {
			// If focus was cancelled before it reached us, don't do anything
			if(event.isDefaultPrevented() || event.target !== tooltip[0]) { return; }

			var qtips = $(MODALSELECTOR),

			// Keep the modal's lower than other, regular qtips
			newIndex = QTIP.modal_zindex + qtips.length,
			curIndex = parseInt(tooltip[0].style.zIndex, 10);

			// Set overlay z-index
			OVERLAY.elem[0].style.zIndex = newIndex - 1;

			// Reduce modal z-index's and keep them properly ordered
			qtips.each(function() {
				if(this.style.zIndex > curIndex) {
					this.style.zIndex -= 1;
				}
			});

			// Fire blur event for focused tooltip
			qtips.filter('.' + CLASS_FOCUS).qtip('blur', event.originalEvent);

			// Set the new z-index
			tooltip.addClass(CLASS_FOCUS)[0].style.zIndex = newIndex;

			// Set current
			OVERLAY.update(api);

			// Prevent default handling
			/* eslint-disable no-empty */
			try { event.preventDefault(); }
			catch(e) {}
			/* eslint-enable no-empty */
		}, this._ns, this);

		// Focus any other visible modals when this one hides
		qtip._bind(tooltip, 'tooltiphide', function(event) {
			if(event.target === tooltip[0]) {
				$(MODALSELECTOR).filter(':visible').not(tooltip).last().qtip('focus', event);
			}
		}, this._ns, this);
	},

	toggle: function(event, state, duration) {
		// Make sure default event hasn't been prevented
		if(event && event.isDefaultPrevented()) { return this; }

		// Toggle it
		OVERLAY.toggle(this.qtip, !!state, duration);
	},

	destroy: function() {
		// Remove modal class
		this.qtip.tooltip.removeClass(MODALCLASS);

		// Remove bound events
		this.qtip._unbind(this.qtip.tooltip, this._ns);

		// Delete element reference
		OVERLAY.toggle(this.qtip, FALSE);
		delete this.qtip.elements.overlay;
	}
});


MODAL = PLUGINS.modal = function(api) {
	return new Modal(api, api.options.show.modal);
};

// Setup sanitiztion rules
MODAL.sanitize = function(opts) {
	if(opts.show) {
		if(typeof opts.show.modal !== 'object') { opts.show.modal = { on: !!opts.show.modal }; }
		else if(typeof opts.show.modal.on === 'undefined') { opts.show.modal.on = TRUE; }
	}
};

// Base z-index for all modal tooltips (use qTip core z-index as a base)
/* eslint-disable camelcase */
QTIP.modal_zindex = QTIP.zindex - 200;
/* eslint-enable camelcase */

// Plugin needs to be initialized on render
MODAL.initialize = 'render';

// Setup option set checks
CHECKS.modal = {
	'^show.modal.(on|blur)$': function() {
		// Initialise
		this.destroy();
		this.init();

		// Show the modal if not visible already and tooltip is visible
		this.qtip.elems.overlay.toggle(
			this.qtip.tooltip[0].offsetWidth > 0
		);
	}
};

// Extend original api defaults
$.extend(TRUE, QTIP.defaults, {
	show: {
		modal: {
			on: FALSE,
			effect: TRUE,
			blur: TRUE,
			stealfocus: TRUE,
			escape: TRUE
		}
	}
});
;PLUGINS.viewport = function(api, position, posOptions, targetWidth, targetHeight, elemWidth, elemHeight)
{
	var target = posOptions.target,
		tooltip = api.elements.tooltip,
		my = posOptions.my,
		at = posOptions.at,
		adjust = posOptions.adjust,
		method = adjust.method.split(' '),
		methodX = method[0],
		methodY = method[1] || method[0],
		viewport = posOptions.viewport,
		container = posOptions.container,
		adjusted = { left: 0, top: 0 },
		fixed, newMy, containerOffset, containerStatic,
		viewportWidth, viewportHeight, viewportScroll, viewportOffset;

	// If viewport is not a jQuery element, or it's the window/document, or no adjustment method is used... return
	if(!viewport.jquery || target[0] === window || target[0] === document.body || adjust.method === 'none') {
		return adjusted;
	}

	// Cach container details
	containerOffset = container.offset() || adjusted;
	containerStatic = container.css('position') === 'static';

	// Cache our viewport details
	fixed = tooltip.css('position') === 'fixed';
	viewportWidth = viewport[0] === window ? viewport.width() : viewport.outerWidth(FALSE);
	viewportHeight = viewport[0] === window ? viewport.height() : viewport.outerHeight(FALSE);
	viewportScroll = { left: fixed ? 0 : viewport.scrollLeft(), top: fixed ? 0 : viewport.scrollTop() };
	viewportOffset = viewport.offset() || adjusted;

	// Generic calculation method
	function calculate(side, otherSide, type, adjustment, side1, side2, lengthName, targetLength, elemLength) {
		var initialPos = position[side1],
			mySide = my[side],
			atSide = at[side],
			isShift = type === SHIFT,
			myLength = mySide === side1 ? elemLength : mySide === side2 ? -elemLength : -elemLength / 2,
			atLength = atSide === side1 ? targetLength : atSide === side2 ? -targetLength : -targetLength / 2,
			sideOffset = viewportScroll[side1] + viewportOffset[side1] - (containerStatic ? 0 : containerOffset[side1]),
			overflow1 = sideOffset - initialPos,
			overflow2 = initialPos + elemLength - (lengthName === WIDTH ? viewportWidth : viewportHeight) - sideOffset,
			offset = myLength - (my.precedance === side || mySide === my[otherSide] ? atLength : 0) - (atSide === CENTER ? targetLength / 2 : 0);

		// shift
		if(isShift) {
			offset = (mySide === side1 ? 1 : -1) * myLength;

			// Adjust position but keep it within viewport dimensions
			position[side1] += overflow1 > 0 ? overflow1 : overflow2 > 0 ? -overflow2 : 0;
			position[side1] = Math.max(
				-containerOffset[side1] + viewportOffset[side1],
				initialPos - offset,
				Math.min(
					Math.max(
						-containerOffset[side1] + viewportOffset[side1] + (lengthName === WIDTH ? viewportWidth : viewportHeight),
						initialPos + offset
					),
					position[side1],

					// Make sure we don't adjust complete off the element when using 'center'
					mySide === 'center' ? initialPos - myLength : 1E9
				)
			);

		}

		// flip/flipinvert
		else {
			// Update adjustment amount depending on if using flipinvert or flip
			adjustment *= type === FLIPINVERT ? 2 : 0;

			// Check for overflow on the left/top
			if(overflow1 > 0 && (mySide !== side1 || overflow2 > 0)) {
				position[side1] -= offset + adjustment;
				newMy.invert(side, side1);
			}

			// Check for overflow on the bottom/right
			else if(overflow2 > 0 && (mySide !== side2 || overflow1 > 0)  ) {
				position[side1] -= (mySide === CENTER ? -offset : offset) + adjustment;
				newMy.invert(side, side2);
			}

			// Make sure we haven't made things worse with the adjustment and reset if so
			if(position[side1] < viewportScroll[side1] && -position[side1] > overflow2) {
				position[side1] = initialPos; newMy = my.clone();
			}
		}

		return position[side1] - initialPos;
	}

	// Set newMy if using flip or flipinvert methods
	if(methodX !== 'shift' || methodY !== 'shift') { newMy = my.clone(); }

	// Adjust position based onviewport and adjustment options
	adjusted = {
		left: methodX !== 'none' ? calculate( X, Y, methodX, adjust.x, LEFT, RIGHT, WIDTH, targetWidth, elemWidth ) : 0,
		top: methodY !== 'none' ? calculate( Y, X, methodY, adjust.y, TOP, BOTTOM, HEIGHT, targetHeight, elemHeight ) : 0,
		my: newMy
	};

	return adjusted;
};
;PLUGINS.polys = {
	// POLY area coordinate calculator
	//	Special thanks to Ed Cradock for helping out with this.
	//	Uses a binary search algorithm to find suitable coordinates.
	polygon: function(baseCoords, corner) {
		var result = {
			width: 0, height: 0,
			position: {
				top: 1e10, right: 0,
				bottom: 0, left: 1e10
			},
			adjustable: FALSE
		},
		i = 0, next,
		coords = [],
		compareX = 1, compareY = 1,
		realX = 0, realY = 0,
		newWidth, newHeight;

		// First pass, sanitize coords and determine outer edges
		i = baseCoords.length; 
		while(i--) {
			next = [ parseInt(baseCoords[--i], 10), parseInt(baseCoords[i+1], 10) ];

			if(next[0] > result.position.right){ result.position.right = next[0]; }
			if(next[0] < result.position.left){ result.position.left = next[0]; }
			if(next[1] > result.position.bottom){ result.position.bottom = next[1]; }
			if(next[1] < result.position.top){ result.position.top = next[1]; }

			coords.push(next);
		}

		// Calculate height and width from outer edges
		newWidth = result.width = Math.abs(result.position.right - result.position.left);
		newHeight = result.height = Math.abs(result.position.bottom - result.position.top);

		// If it's the center corner...
		if(corner.abbrev() === 'c') {
			result.position = {
				left: result.position.left + result.width / 2,
				top: result.position.top + result.height / 2
			};
		}
		else {
			// Second pass, use a binary search algorithm to locate most suitable coordinate
			while(newWidth > 0 && newHeight > 0 && compareX > 0 && compareY > 0)
			{
				newWidth = Math.floor(newWidth / 2);
				newHeight = Math.floor(newHeight / 2);

				if(corner.x === LEFT){ compareX = newWidth; }
				else if(corner.x === RIGHT){ compareX = result.width - newWidth; }
				else{ compareX += Math.floor(newWidth / 2); }

				if(corner.y === TOP){ compareY = newHeight; }
				else if(corner.y === BOTTOM){ compareY = result.height - newHeight; }
				else{ compareY += Math.floor(newHeight / 2); }

				i = coords.length;
				while(i--)
				{
					if(coords.length < 2){ break; }

					realX = coords[i][0] - result.position.left;
					realY = coords[i][1] - result.position.top;

					if(
						corner.x === LEFT && realX >= compareX ||
						corner.x === RIGHT && realX <= compareX ||
						corner.x === CENTER && (realX < compareX || realX > result.width - compareX) ||
						corner.y === TOP && realY >= compareY ||
						corner.y === BOTTOM && realY <= compareY ||
						corner.y === CENTER && (realY < compareY || realY > result.height - compareY)) {
						coords.splice(i, 1);
					}
				}
			}
			result.position = { left: coords[0][0], top: coords[0][1] };
		}

		return result;
	},

	rect: function(ax, ay, bx, by) {
		return {
			width: Math.abs(bx - ax),
			height: Math.abs(by - ay),
			position: {
				left: Math.min(ax, bx),
				top: Math.min(ay, by)
			}
		};
	},

	_angles: {
		tc: 3 / 2, tr: 7 / 4, tl: 5 / 4,
		bc: 1 / 2, br: 1 / 4, bl: 3 / 4,
		rc: 2, lc: 1, c: 0
	},
	ellipse: function(cx, cy, rx, ry, corner) {
		var c = PLUGINS.polys._angles[ corner.abbrev() ],
			rxc = c === 0 ? 0 : rx * Math.cos( c * Math.PI ),
			rys = ry * Math.sin( c * Math.PI );

		return {
			width: rx * 2 - Math.abs(rxc),
			height: ry * 2 - Math.abs(rys),
			position: {
				left: cx + rxc,
				top: cy + rys
			},
			adjustable: FALSE
		};
	},
	circle: function(cx, cy, r, corner) {
		return PLUGINS.polys.ellipse(cx, cy, r, r, corner);
	}
};
;PLUGINS.svg = function(api, svg, corner)
{
	var elem = svg[0],
		root = $(elem.ownerSVGElement),
		ownerDocument = elem.ownerDocument,
		strokeWidth2 = (parseInt(svg.css('stroke-width'), 10) || 0) / 2,
		frameOffset, mtx, transformed,
		len, next, i, points,
		result, position;

	// Ascend the parentNode chain until we find an element with getBBox()
	while(!elem.getBBox) { elem = elem.parentNode; }
	if(!elem.getBBox || !elem.parentNode) { return FALSE; }

	// Determine which shape calculation to use
	switch(elem.nodeName) {
		case 'ellipse':
		case 'circle':
			result = PLUGINS.polys.ellipse(
				elem.cx.baseVal.value,
				elem.cy.baseVal.value,
				(elem.rx || elem.r).baseVal.value + strokeWidth2,
				(elem.ry || elem.r).baseVal.value + strokeWidth2,
				corner
			);
		break;

		case 'line':
		case 'polygon':
		case 'polyline':
			// Determine points object (line has none, so mimic using array)
			points = elem.points || [
				{ x: elem.x1.baseVal.value, y: elem.y1.baseVal.value },
				{ x: elem.x2.baseVal.value, y: elem.y2.baseVal.value }
			];

			for(result = [], i = -1, len = points.numberOfItems || points.length; ++i < len;) {
				next = points.getItem ? points.getItem(i) : points[i];
				result.push.apply(result, [next.x, next.y]);
			}

			result = PLUGINS.polys.polygon(result, corner);
		break;

		// Unknown shape or rectangle? Use bounding box
		default:
			result = elem.getBBox();
			result = {
				width: result.width,
				height: result.height,
				position: {
					left: result.x,
					top: result.y
				}
			};
		break;
	}

	// Shortcut assignments
	position = result.position;
	root = root[0];

	// Convert position into a pixel value
	if(root.createSVGPoint) {
		mtx = elem.getScreenCTM();
		points = root.createSVGPoint();

		points.x = position.left;
		points.y = position.top;
		transformed = points.matrixTransform( mtx );
		position.left = transformed.x;
		position.top = transformed.y;
	}

	// Check the element is not in a child document, and if so, adjust for frame elements offset
	if(ownerDocument !== document && api.position.target !== 'mouse') {
		frameOffset = $((ownerDocument.defaultView || ownerDocument.parentWindow).frameElement).offset();
		if(frameOffset) {
			position.left += frameOffset.left;
			position.top += frameOffset.top;
		}
	}

	// Adjust by scroll offset of owner document
	ownerDocument = $(ownerDocument);
	position.left += ownerDocument.scrollLeft();
	position.top += ownerDocument.scrollTop();

	return result;
};
;PLUGINS.imagemap = function(api, area, corner)
{
	if(!area.jquery) { area = $(area); }

	var shape = (area.attr('shape') || 'rect').toLowerCase().replace('poly', 'polygon'),
		image = $('img[usemap="#'+area.parent('map').attr('name')+'"]'),
		coordsString = $.trim(area.attr('coords')),
		coordsArray = coordsString.replace(/,$/, '').split(','),
		imageOffset, coords, i, result, len;

	// If we can't find the image using the map...
	if(!image.length) { return FALSE; }

	// Pass coordinates string if polygon
	if(shape === 'polygon') {
		result = PLUGINS.polys.polygon(coordsArray, corner);
	}

	// Otherwise parse the coordinates and pass them as arguments
	else if(PLUGINS.polys[shape]) {
		for(i = -1, len = coordsArray.length, coords = []; ++i < len;) {
			coords.push( parseInt(coordsArray[i], 10) );
		}

		result = PLUGINS.polys[shape].apply(
			this, coords.concat(corner)
		);
	}

	// If no shapre calculation method was found, return false
	else { return FALSE; }

	// Make sure we account for padding and borders on the image
	imageOffset = image.offset();
	imageOffset.left += Math.ceil((image.outerWidth(FALSE) - image.width()) / 2);
	imageOffset.top += Math.ceil((image.outerHeight(FALSE) - image.height()) / 2);

	// Add image position to offset coordinates
	result.position.left += imageOffset.left;
	result.position.top += imageOffset.top;

	return result;
};
;var IE6,

/*
 * BGIFrame adaption (http://plugins.jquery.com/project/bgiframe)
 * Special thanks to Brandon Aaron
 */
BGIFRAME = '<iframe class="qtip-bgiframe" frameborder="0" tabindex="-1" src="javascript:\'\';" ' +
	' style="display:block; position:absolute; z-index:-1; filter:alpha(opacity=0); ' +
		'-ms-filter:"progid:DXImageTransform.Microsoft.Alpha(Opacity=0)";"></iframe>';

function Ie6(api) {
	this._ns = 'ie6';

	this.qtip = api;
	this.init(api);
}

$.extend(Ie6.prototype, {
	_scroll : function() {
		var overlay = this.qtip.elements.overlay;
		overlay && (overlay[0].style.top = $(window).scrollTop() + 'px');
	},

	init: function(qtip) {
		var tooltip = qtip.tooltip;

		// Create the BGIFrame element if needed
		if($('select, object').length < 1) {
			this.bgiframe = qtip.elements.bgiframe = $(BGIFRAME).appendTo(tooltip);

			// Update BGIFrame on tooltip move
			qtip._bind(tooltip, 'tooltipmove', this.adjustBGIFrame, this._ns, this);
		}

		// redraw() container for width/height calculations
		this.redrawContainer = $('<div/>', { id: NAMESPACE+'-rcontainer' })
			.appendTo(document.body);

		// Fixup modal plugin if present too
		if( qtip.elements.overlay && qtip.elements.overlay.addClass('qtipmodal-ie6fix') ) {
			qtip._bind(window, ['scroll', 'resize'], this._scroll, this._ns, this);
			qtip._bind(tooltip, ['tooltipshow'], this._scroll, this._ns, this);
		}

		// Set dimensions
		this.redraw();
	},

	adjustBGIFrame: function() {
		var tooltip = this.qtip.tooltip,
			dimensions = {
				height: tooltip.outerHeight(FALSE),
				width: tooltip.outerWidth(FALSE)
			},
			plugin = this.qtip.plugins.tip,
			tip = this.qtip.elements.tip,
			tipAdjust, offset;

		// Adjust border offset
		offset = parseInt(tooltip.css('borderLeftWidth'), 10) || 0;
		offset = { left: -offset, top: -offset };

		// Adjust for tips plugin
		if(plugin && tip) {
			tipAdjust = plugin.corner.precedance === 'x' ? [WIDTH, LEFT] : [HEIGHT, TOP];
			offset[ tipAdjust[1] ] -= tip[ tipAdjust[0] ]();
		}

		// Update bgiframe
		this.bgiframe.css(offset).css(dimensions);
	},

	// Max/min width simulator function
	redraw: function() {
		if(this.qtip.rendered < 1 || this.drawing) { return this; }

		var tooltip = this.qtip.tooltip,
			style = this.qtip.options.style,
			container = this.qtip.options.position.container,
			perc, width, max, min;

		// Set drawing flag
		this.qtip.drawing = 1;

		// If tooltip has a set height/width, just set it... like a boss!
		if(style.height) { tooltip.css(HEIGHT, style.height); }
		if(style.width) { tooltip.css(WIDTH, style.width); }

		// Simulate max/min width if not set width present...
		else {
			// Reset width and add fluid class
			tooltip.css(WIDTH, '').appendTo(this.redrawContainer);

			// Grab our tooltip width (add 1 if odd so we don't get wrapping problems.. huzzah!)
			width = tooltip.width();
			if(width % 2 < 1) { width += 1; }

			// Grab our max/min properties
			max = tooltip.css('maxWidth') || '';
			min = tooltip.css('minWidth') || '';

			// Parse into proper pixel values
			perc = (max + min).indexOf('%') > -1 ? container.width() / 100 : 0;
			max = (max.indexOf('%') > -1 ? perc : 1 * parseInt(max, 10)) || width;
			min = (min.indexOf('%') > -1 ? perc : 1 * parseInt(min, 10)) || 0;

			// Determine new dimension size based on max/min/current values
			width = max + min ? Math.min(Math.max(width, min), max) : width;

			// Set the newly calculated width and remvoe fluid class
			tooltip.css(WIDTH, Math.round(width)).appendTo(container);
		}

		// Set drawing flag
		this.drawing = 0;

		return this;
	},

	destroy: function() {
		// Remove iframe
		this.bgiframe && this.bgiframe.remove();

		// Remove bound events
		this.qtip._unbind([window, this.qtip.tooltip], this._ns);
	}
});

IE6 = PLUGINS.ie6 = function(api) {
	// Proceed only if the browser is IE6
	return BROWSER.ie === 6 ? new Ie6(api) : FALSE;
};

IE6.initialize = 'render';

CHECKS.ie6 = {
	'^content|style$': function() {
		this.redraw();
	}
};
;}));
}( window, document ));



/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($, jQuery) {/*--------------------------------------------------------------------
 * jQuery plugin: customInput()
 * by Maggie Wachs and Scott Jehl, http://www.filamentgroup.com
 * Copyright (c) 2009 Filament Group
 * Dual licensed under the MIT (filamentgroup.com/examples/mit-license.txt) and GPL (filamentgroup.com/examples/gpl-license.txt) licenses.
 * Article: http://www.filamentgroup.com/lab/accessible_custom_designed_checkbox_radio_button_inputs_styled_css_jquery/
 * Usage example below (see comment "Run the script...").
 * ==================================================================
 * Refactored by Swisscom: We sometimes have pre-rendered the custom styles with jsp,
 * so the event `updateState` was not bound. This lead to not beeing able to update
 * the visible state programatically without re-implementing this logic. To has pretty
 * much changed the whole structure of the script, so it will not be easily upgradable.
 --------------------------------------------------------------------*/

jQuery.fn.customInput = function() {
	$(this).each(function(i) {

		var input = $(this),
		    inputId = this.id,
		    inputName = this.name,
		    inputTag = this.tagName.toUpperCase(),
		    inputType = this.type.toLowerCase();

		// can only process input fields with valid id
		if (inputTag != 'INPUT' || !inputId) { return; }
		// check flag to disable any custom input at all
		if (input.hasClass('noCustomInput')) { return; }
		// only works on radio and checkbox input types
		if (inputType != 'radio' && inputType != 'checkbox') { return; }
		// customize each input node only once (singleton check)
		if (input.data('customInput-initialized')) { return; }
		// set the singleton status for this node
		input.data('customInput-initialized', true);

		var parentDivClass = 'custom-' + inputType;

		// get the associated label using the input's id
		// ToDo: will not work if input is inside the label
		var label = $('label[for="' + inputId + '"]');

		// wrap the input and label inside a div
		// it may already be present this way in the html
		if (input.closest("." + parentDivClass).length == 0) {
			$('<div class="custom-'+ inputType +'"></div>')
				.insertBefore(input).append(input, label);
		}

		// bind event to sync the custom UI to the actual state
		input.on('updateState', function() {
			if (!input[0].form) return;
			var isHovered = label.hasClass('hover'),
				isFocused = label.hasClass('focus');
			if (input.is(':checked')) {
				// clear all states for associated input labels
				if (input.is(':radio')) {
					// find all inputs in this set by input's name
					$(input[0].form[inputName]).each(function () {
						if ($(this).attr('id')) {
							$('label[for="' + $(this).attr('id') + '"]')
								.removeClass('checked checkedHover checkedFocus');
						}
					});
				}
				// add `checked` status class
				label.addClass('checked');
				if (isHovered) { label.addClass('checkedHover'); }
				if (isFocused) { label.addClass('checkedFocus'); }
			}
		})
		// trigger the event once
		.trigger('updateState')
		// do updateState on change event
		.change(function() {
			input.trigger('updateState');
		});

		// disable tabbing for readonly items
		if (input.attr('readonly')) {
			input.attr('tabindex', -1);
		}

		// bind hover and focus on input and label
		label.add(input)
		// prevent events on read-only labels from propagating
		// readonly must not be set programatically after init
		.on('click keydown keypress keyup', function(evt) {
			input.trigger('updateState');
			if (input.attr('readonly')) {
				// always allow tab and enter keycodes
				if (!evt.keyCode || evt.keyCode > 13) {
					evt.preventDefault(true);
					evt.stopPropagation(true);
					return false;
				}
			}
		})
		// add `focus` class
		.focus(function() {
			label.addClass('focus');
			input.trigger('updateState');
		})
		// remove `focus` class
		.blur(function() {
			label.removeClass('focus');
			input.trigger('updateState');
		})
		// necessary for browsers that only support :hover
		// pseudo class on link (A) tags (Internet Explorer)
		.hover(
			function() {
				label.addClass('hover');
				input.trigger('updateState');
			},
			function() {
				label.removeClass('hover');
				input.trigger('updateState');
			}
		);

	});
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0), __webpack_require__(0)))

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(jQuery) {// Swisscom 13-03-2014: changed to URL safe version of Base64 (- and _ instead of + and /)
jQuery.base64=(function($){var _PADCHAR="=",_ALPHA="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_",_VERSION="1.0fixed";function _getbyte64(s,i){var idx=_ALPHA.indexOf(s.charAt(i));if(idx===-1){throw"Cannot decode base64"}return idx}function _decode(s){var pads=0,i,b10,imax=s.length,x=[];s=String(s);if(imax===0){return s}if(imax%4!==0){throw"Cannot decode base64"}if(s.charAt(imax-1)===_PADCHAR){pads=1;if(s.charAt(imax-2)===_PADCHAR){pads=2}imax-=4}for(i=0;i<imax;i+=4){b10=(_getbyte64(s,i)<<18)|(_getbyte64(s,i+1)<<12)|(_getbyte64(s,i+2)<<6)|_getbyte64(s,i+3);x.push(String.fromCharCode(b10>>16,(b10>>8)&255,b10&255))}switch(pads){case 1:b10=(_getbyte64(s,i)<<18)|(_getbyte64(s,i+1)<<12)|(_getbyte64(s,i+2)<<6);x.push(String.fromCharCode(b10>>16,(b10>>8)&255));break;case 2:b10=(_getbyte64(s,i)<<18)|(_getbyte64(s,i+1)<<12);x.push(String.fromCharCode(b10>>16));break}return x.join("")}function _getbyte(s,i){var x=s.charCodeAt(i);if(x>255){throw"INVALID_CHARACTER_ERR: DOM Exception 5"}return x}function _encode(s){if(arguments.length!==1){throw"SyntaxError: exactly one argument required"}s=String(s);var i,b10,x=[],imax=s.length-s.length%3;if(s.length===0){return s}for(i=0;i<imax;i+=3){b10=(_getbyte(s,i)<<16)|(_getbyte(s,i+1)<<8)|_getbyte(s,i+2);x.push(_ALPHA.charAt(b10>>18));x.push(_ALPHA.charAt((b10>>12)&63));x.push(_ALPHA.charAt((b10>>6)&63));x.push(_ALPHA.charAt(b10&63))}switch(s.length-imax){case 1:b10=_getbyte(s,i)<<16;x.push(_ALPHA.charAt(b10>>18)+_ALPHA.charAt((b10>>12)&63)+_PADCHAR+_PADCHAR);break;case 2:b10=(_getbyte(s,i)<<16)|(_getbyte(s,i+1)<<8);x.push(_ALPHA.charAt(b10>>18)+_ALPHA.charAt((b10>>12)&63)+_ALPHA.charAt((b10>>6)&63)+_PADCHAR);break}return x.join("")}return{decode:_decode,encode:_encode,VERSION:_VERSION}}(jQuery));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery) {/*! http://mths.be/placeholder v2.0.7 by @mathias */
;(function(f,h,$){var a='placeholder' in h.createElement('input'),d='placeholder' in h.createElement('textarea'),i=$.fn,c=$.valHooks,k,j;if(a&&d){j=i.placeholder=function(){return this};j.input=j.textarea=true}else{j=i.placeholder=function(){var l=this;l.filter((a?'textarea':':input')+'[placeholder]').not('.placeholder').on({'focus.placeholder':b,'blur.placeholder':e}).data('placeholder-enabled',true).trigger('blur.placeholder');return l};j.input=a;j.textarea=d;k={get:function(m){var l=$(m);return l.data('placeholder-enabled')&&l.hasClass('placeholder')?'':m.value},set:function(m,n){var l=$(m);if(!l.data('placeholder-enabled')){return m.value=n}if(n==''){m.value=n;if(m!=h.activeElement){e.call(m)}}else{if(l.hasClass('placeholder')){b.call(m,true,n)||(m.value=n)}else{m.value=n}}return l}};a||(c.input=k);d||(c.textarea=k);$(function(){$(h).on('submit.placeholder','form',function(){var l=$('.placeholder',this).each(b);setTimeout(function(){l.each(e)},10)})});$(f).on('beforeunload.placeholder',function(){$('.placeholder').each(function(){this.value=''})})}function g(m){var l={},n=/^jQuery\d+$/;$.each(m.attributes,function(p,o){if(o.specified&&!n.test(o.name)){l[o.name]=o.value}});return l}function b(m,n){var l=this,o=$(l);if(l.value==o.attr('placeholder')&&o.hasClass('placeholder')){if(o.data('placeholder-password')){o=o.hide().next().show().attr('id',o.removeAttr('id').data('placeholder-id'));if(m===true){return o[0].value=n}o.focus()}else{l.value='';o.removeClass('placeholder');l==h.activeElement&&l.select()}}}function e(){var q,l=this,p=$(l),m=p,o=this.id;if(l.value==''){if(l.type=='password'){if(!p.data('placeholder-textinput')){try{q=p.clone().attr({type:'text'})}catch(n){q=$('<input>').attr($.extend(g(this),{type:'text'}))}q.removeAttr('name').data({'placeholder-password':true,'placeholder-id':o}).on('focus.placeholder',b);p.data({'placeholder-textinput':q,'placeholder-id':o}).before(q)}p=p.removeAttr('id').hide().prev().attr('id',o).show()}p.addClass('placeholder');p[0].value=p.attr('placeholder')}else{p.removeClass('placeholder')}}}(this,document,jQuery));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery) {/*!
 * jQuery Lazy - v0.1.11
 * http://jquery.eisbehr.de/lazy/
 *
 * Copyright 2013, Daniel 'Eisbehr' Kern
 *
 * Dual licensed under the MIT and GPL v2 licenses:
 * http://www.opensource.org/licenses/mit-license.php
 * http://www.gnu.org/licenses/gpl-2.0.html
 *
 * jQuery("img.lazy").lazy();
 */

(function($, window, document, undefined)
{
    $.fn.lazy = function(settings)
    {
        /**
         * settings and configuration data
         * @type {}
         */
        var configuration =
        {
            // general
            bind            : "load",
            threshold       : 500,
            fallbackHeight  : 2000,
            visibleOnly     : true,

            // delay
            delay           : -1,
            combined        : false,

            // attribute
            attribute       : "data-src",
            removeAttribute : true,

            // effect
            effect          : "show",
            effectTime      : 0,

            // throttle
            enableThrottle  : false,
            throttle        : 250,

            // callback
            beforeLoad      : null,
            onLoad          : null,
            afterLoad       : null,
            onError         : null
        };

        // overwrite configuration with custom user settings
        if( settings ) $.extend(configuration, settings);

        // all given items by jQuery selector
        var items = this;

        // on first page load get initial images
        if( configuration.bind == "load" ) $(window).on('load', _init);

        // if event driven don't wait for page loading
        else if( configuration.bind == "event" ) _init();

        // bind error callback to images if wanted
        if( configuration.onError ) items.on("error", function() { configuration.onError($(this)); });

        /**
         * lazyLoadImages(allImages)
         *
         * the 'lazy magic'
         * check and load all needed images
         *
         * @param allImages boolean
         * @return void
         */
        function lazyLoadImages(allImages)
        {
            if( typeof allImages != "boolean" ) allImages = false;

            items.each(function()
            {
                var element = $(this);
                var tag = this.tagName.toLowerCase();

                if( _isInLoadableArea(element) || allImages )
                {
                    // the lazy magic
                    if( // image source attribute is available
                        element.attr(configuration.attribute) &&
                        // and is image tag where attribute is not equal source 
                        ((tag == "img" && element.attr(configuration.attribute) != element.attr("src")) ||
                        // or is non image tag where attribute is not equal background
                        ((tag != "img" && element.attr(configuration.attribute) != element.css("background-image"))) ) &&
                        // and is not actually loaded just before
                        !element.data("loaded") &&
                        // and is visible or visibility doesn't matter
                        (element.is(":visible") || !configuration.visibleOnly) )
                    {
                        // create image object
                        var imageObj = $(new Image());

                        // copy element information to pseudo image because we return this element in "onLoad" and "onError"
                        $.each(this.attributes, function(index, attr)
                        {
                            if( attr.name != "src" )
                            {
                                // i know, there is a shorter way to do the following
                                // but this is the best workaround for ie6/7
                                var value = element.attr(attr.name);
                                imageObj.attr(attr.name, value);
                            }
                        });

                        // bind error event if wanted
                        if( configuration.onError ) imageObj.on('error', function() { configuration.onError(imageObj); });

                        // bind after load callback to image
                        var onLoad = true;
                        imageObj.one("load", function()
                        {
                            var callable = function()
                            {
                                if( onLoad )
                                {
                                    window.setTimeout(callable, 100);
                                    return;
                                }

                                // remove element from view
                                element.hide();

                                // set image back to element
                                if( tag == "img" ) element.attr("src", imageObj.attr("src"));
                                else element.css("background-image", "url(" + imageObj.attr("src") + ")");

                                // bring it back with some effect!
                                element[configuration.effect](configuration.effectTime);

                                // remove attribute from element
                                if( configuration.removeAttribute ) element.removeAttr(configuration.attribute);

                                // call after load event
                                if( configuration.afterLoad ) configuration.afterLoad(element);

                                // unbind event and remove image object
                                imageObj.off("load");
                                imageObj.remove();
                            };

                            callable();
                        });

                        // trigger function before loading image
                        if( configuration.beforeLoad ) configuration.beforeLoad(element);

                        // set source
                        imageObj.attr("src", element.attr(configuration.attribute));

                        // trigger function before loading image
                        if( configuration.onLoad ) configuration.onLoad(imageObj);
                        onLoad = false;

                        // call after load even on cached image
                        if( imageObj.complete ) imageObj.load();

                        // mark element always as loaded
                        element.data("loaded", true);
                    }
                }
            });

            // cleanup all items which are already loaded
            items = $(items).filter(function()
            {
                return !$(this).data("loaded");
            });
        }

        /**
         * _init()
         *
         * initialize lazy plugin
         * bind loading to events or set delay time to load all images at once
         *
         * @return void
         */
        function _init()
        {
            // if delay time is set load all images at once after delay time
            if( configuration.delay >= 0 ) setTimeout(function() { lazyLoadImages(true); }, configuration.delay);

            // if no delay is set or combine usage is active bind events
            if( configuration.delay < 0 || configuration.combined )
            {
                // load initial images
                lazyLoadImages(false);

                // bind lazy load functions to scroll and resize event
                $(window).on("scroll", _throttle(configuration.throttle, lazyLoadImages));
                $(window).on("resize", _throttle(configuration.throttle, lazyLoadImages));
            }
        }

        /**
         * _isInLoadableArea(element)
         *
         * check if the given element is inside the current viewport or threshold
         *
         * @param element jQuery
         * @return boolean
         */
        function _isInLoadableArea(element)
        {
            var top = document.documentElement.scrollTop ? document.documentElement.scrollTop : document.body.scrollTop;
            return (top + _getActualHeight() + configuration.threshold) > (element.offset().top); //removed + element.height()
        }

        /**
         * _getActualHeight()
         *
         * try to allocate current viewport height of the browser
         * uses fallback option when no height is found
         *
         * @return number
         */
        function _getActualHeight()
        {
            if( window.innerHeight ) return window.innerHeight;
            if( document.documentElement && document.documentElement.clientHeight ) return document.documentElement.clientHeight;
            if( document.body && document.body.clientHeight ) return document.body.clientHeight;
            if( document.body && document.body.offsetHeight ) return document.body.offsetHeight;

            return configuration.fallbackHeight;
        }

        /**
         * _throttle(delay, call)
         *
         * helper function to throttle down event triggering
         *
         * @param delay integer
         * @param call function object
         * @return function object
         */
        function _throttle(delay, call)
        {
            var _timeout;
            var _exec = 0;

            function callable()
            {
                var elapsed = +new Date() - _exec;

                function run()
                {
                    _exec = +new Date();
                    call.apply();
                }

                _timeout && clearTimeout(_timeout);

                if( elapsed > delay || !configuration.enableThrottle ) run();
                else _timeout = setTimeout(run, delay - elapsed);
            }

            return callable;
        }

        return this;
    };

    // make lazy a bit more case-insensitive :)
    $.fn.Lazy = $.fn.lazy;

})(jQuery, window, document);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery) {/*!
	Colorbox v1.4.26 - 2013-06-30
	jQuery lightbox and modal window plugin
	(c) 2013 Jack Moore - http://www.jacklmoore.com/colorbox
	license: http://www.opensource.org/licenses/mit-license.php
*/
(function(e,t,i){function o(i,o,n){var r=t.createElement(i);return o&&(r.id=et+o),n&&(r.style.cssText=n),e(r)}function n(){return i.innerHeight?i.innerHeight:e(i).height()}function r(e){var t=E.length,i=(j+e)%t;return 0>i?t+i:i}function l(e,t){return Math.round((/%/.test(e)?("x"===t?H.width():n())/100:1)*parseInt(e,10))}function a(e,t){return e.photo||e.photoRegex.test(t)}function h(e,t){return e.retinaUrl&&i.devicePixelRatio>1?t.replace(e.photoRegex,e.retinaSuffix):t}function s(e){"contains"in v[0]&&!v[0].contains(e.target)&&(e.stopPropagation(),v.focus())}function d(){var t,i=e.data(A,Z);null==i?(O=e.extend({},Y),console&&console.log&&console.log("Error: cboxElement missing settings object")):O=e.extend({},i);for(t in O)e.isFunction(O[t])&&"on"!==t.slice(0,2)&&(O[t]=O[t].call(A));O.rel=O.rel||A.rel||e(A).data("rel")||"nofollow",O.href=O.href||e(A).attr("href"),O.title=O.title||A.title,"string"==typeof O.href&&(O.href=e.trim(O.href))}function c(i,o){e(t).trigger(i),ht.trigger(i),e.isFunction(o)&&o.call(A)}function u(){var e,t,i,o,n,r=et+"Slideshow_",l="click."+et;O.slideshow&&E[1]?(t=function(){clearTimeout(e)},i=function(){(O.loop||E[j+1])&&(e=setTimeout(J.next,O.slideshowSpeed))},o=function(){R.html(O.slideshowStop).off(l).one(l,n),ht.on(nt,i).on(ot,t).on(rt,n),v.removeClass(r+"off").addClass(r+"on")},n=function(){t(),ht.off(nt,i).off(ot,t).off(rt,n),R.html(O.slideshowStart).off(l).one(l,function(){J.next(),o()}),v.removeClass(r+"on").addClass(r+"off")},O.slideshowAuto?o():n()):v.removeClass(r+"off "+r+"on")}function p(i){G||(A=i,d(),E=e(A),j=0,"nofollow"!==O.rel&&(E=e("."+tt).filter(function(){var t,i=e.data(this,Z);return i&&(t=e(this).data("rel")||i.rel||this.rel),t===O.rel}),j=E.index(A),-1===j&&(E=E.add(A),j=E.length-1)),g.css({opacity:parseFloat(O.opacity),cursor:O.overlayClose?"pointer":"auto",visibility:"visible"}).show(),V&&v.add(g).removeClass(V),O.className&&v.add(g).addClass(O.className),V=O.className,O.closeButton?P.html(O.close).appendTo(x):P.appendTo("<div/>"),$||($=q=!0,v.css({visibility:"hidden",display:"block"}),W=o(st,"LoadedContent","width:0; height:0; overflow:hidden").appendTo(x),_=b.height()+k.height()+x.outerHeight(!0)-x.height(),D=T.width()+C.width()+x.outerWidth(!0)-x.width(),N=W.outerHeight(!0),z=W.outerWidth(!0),O.w=l(O.initialWidth,"x"),O.h=l(O.initialHeight,"y"),J.position(),u(),c(it,O.onOpen),B.add(S).hide(),v.focus(),O.trapFocus&&t.addEventListener&&(t.addEventListener("focus",s,!0),ht.one(lt,function(){t.removeEventListener("focus",s,!0)})),O.returnFocus&&ht.one(lt,function(){e(A).focus()})),w())}function f(){!v&&t.body&&(X=!1,H=e(i),v=o(st).attr({id:Z,"class":e.support.opacity===!1?et+"IE":"",role:"dialog",tabindex:"-1"}).hide(),g=o(st,"Overlay").hide(),L=e([o(st,"LoadingOverlay")[0],o(st,"LoadingGraphic")[0]]),y=o(st,"Wrapper"),x=o(st,"Content").append(S=o(st,"Title"),M=o(st,"Current"),K=e('<button type="button"/>').attr({id:et+"Previous"}),I=e('<button type="button"/>').attr({id:et+"Next"}),R=o("button","Slideshow"),L),P=e('<button type="button"/>').attr({id:et+"Close"}),y.append(o(st).append(o(st,"TopLeft"),b=o(st,"TopCenter"),o(st,"TopRight")),o(st,!1,"clear:left").append(T=o(st,"MiddleLeft"),x,C=o(st,"MiddleRight")),o(st,!1,"clear:left").append(o(st,"BottomLeft"),k=o(st,"BottomCenter"),o(st,"BottomRight"))).find("div div").css({"float":"left"}),F=o(st,!1,"position:absolute; width:9999px; visibility:hidden; display:none"),B=I.add(K).add(M).add(R),e(t.body).append(g,v.append(y,F)))}function m(){function i(e){e.which>1||e.shiftKey||e.altKey||e.metaKey||e.ctrlKey||(e.preventDefault(),p(this))}return v?(X||(X=!0,I.click(function(){J.next()}),K.click(function(){J.prev()}),P.click(function(){J.close()}),g.click(function(){O.overlayClose&&J.close()}),e(t).on("keydown."+et,function(e){var t=e.keyCode;$&&O.escKey&&27===t&&(e.preventDefault(),J.close()),$&&O.arrowKey&&E[1]&&!e.altKey&&(37===t?(e.preventDefault(),K.click()):39===t&&(e.preventDefault(),I.click()))}),e.isFunction(e.fn.on)?e(t).on("click."+et,"."+tt,i):e("."+tt).live("click."+et,i)),!0):!1}function w(){var n,r,s,u=J.prep,p=++dt;q=!0,U=!1,A=E[j],d(),c(at),c(ot,O.onLoad),O.h=O.height?l(O.height,"y")-N-_:O.innerHeight&&l(O.innerHeight,"y"),O.w=O.width?l(O.width,"x")-z-D:O.innerWidth&&l(O.innerWidth,"x"),O.mw=O.w,O.mh=O.h,O.maxWidth&&(O.mw=l(O.maxWidth,"x")-z-D,O.mw=O.w&&O.w<O.mw?O.w:O.mw),O.maxHeight&&(O.mh=l(O.maxHeight,"y")-N-_,O.mh=O.h&&O.h<O.mh?O.h:O.mh),n=O.href,Q=setTimeout(function(){L.show()},100),O.inline?(s=o(st).hide().insertBefore(e(n)[0]),ht.one(at,function(){s.replaceWith(W.children())}),u(e(n))):O.iframe?u(" "):O.html?u(O.html):a(O,n)?(n=h(O,n),U=t.createElement("img"),e(U).addClass(et+"Photo").on("error",function(){O.title=!1,u(o(st,"Error").html(O.imgError))}).one("load",function(){var t;p===dt&&(U.alt=e(A).attr("alt")||e(A).attr("data-alt")||"",O.retinaImage&&i.devicePixelRatio>1&&(U.height=U.height/i.devicePixelRatio,U.width=U.width/i.devicePixelRatio),O.scalePhotos&&(r=function(){U.height-=U.height*t,U.width-=U.width*t},O.mw&&U.width>O.mw&&(t=(U.width-O.mw)/U.width,r()),O.mh&&U.height>O.mh&&(t=(U.height-O.mh)/U.height,r())),O.h&&(U.style.marginTop=Math.max(O.mh-U.height,0)/2+"px"),E[1]&&(O.loop||E[j+1])&&(U.style.cursor="pointer",U.onclick=function(){J.next()}),U.style.width=U.width+"px",U.style.height=U.height+"px",setTimeout(function(){u(U)},1))}),setTimeout(function(){U.src=n},1)):n&&F.load(n,O.data,function(t,i){p===dt&&u("error"===i?o(st,"Error").html(O.xhrError):e(this).contents())})}var g,v,y,x,b,T,C,k,E,H,W,F,L,S,M,R,I,K,P,B,O,_,D,N,z,A,j,U,$,q,G,Q,J,V,X,Y={transition:"elastic",speed:300,fadeOut:300,width:!1,initialWidth:"600",innerWidth:!1,maxWidth:!1,height:!1,initialHeight:"450",innerHeight:!1,maxHeight:!1,scalePhotos:!0,scrolling:!0,inline:!1,html:!1,iframe:!1,fastIframe:!0,photo:!1,href:!1,title:!1,rel:!1,opacity:.9,preloading:!0,className:!1,retinaImage:!1,retinaUrl:!1,retinaSuffix:"@2x.$1",current:"image {current} of {total}",previous:"previous",next:"next",close:"close",xhrError:"This content failed to load.",imgError:"This image failed to load.",open:!1,returnFocus:!0,trapFocus:!0,reposition:!0,loop:!0,slideshow:!1,slideshowAuto:!0,slideshowSpeed:2500,slideshowStart:"start slideshow",slideshowStop:"stop slideshow",photoRegex:/\.(gif|png|jp(e|g|eg)|bmp|ico|webp)((#|\?).*)?$/i,onOpen:!1,onLoad:!1,onComplete:!1,onCleanup:!1,onClosed:!1,overlayClose:!0,escKey:!0,arrowKey:!0,top:!1,bottom:!1,left:!1,right:!1,fixed:!1,data:void 0,closeButton:!0},Z="colorbox",et="cbox",tt=et+"Element",it=et+"_open",ot=et+"_load",nt=et+"_complete",rt=et+"_cleanup",lt=et+"_closed",at=et+"_purge",ht=e("<a/>"),st="div",dt=0,ct={};e.colorbox||(e(f),J=e.fn[Z]=e[Z]=function(t,i){var o=this;if(t=t||{},f(),m()){if(e.isFunction(o))o=e("<a/>"),t.open=!0;else if(!o[0])return o;i&&(t.onComplete=i),o.each(function(){e.data(this,Z,e.extend({},e.data(this,Z)||Y,t))}).addClass(tt),(e.isFunction(t.open)&&t.open.call(o)||t.open)&&p(o[0])}return o},J.position=function(t,i){function o(){b[0].style.width=k[0].style.width=x[0].style.width=parseInt(v[0].style.width,10)-D+"px",x[0].style.height=T[0].style.height=C[0].style.height=parseInt(v[0].style.height,10)-_+"px"}var r,a,h,s=0,d=0,c=v.offset();if(H.off("resize."+et),v.css({top:-9e4,left:-9e4}),a=H.scrollTop(),h=H.scrollLeft(),O.fixed?(c.top-=a,c.left-=h,v.css({position:"fixed"})):(s=a,d=h,v.css({position:"absolute"})),d+=O.right!==!1?Math.max(H.width()-O.w-z-D-l(O.right,"x"),0):O.left!==!1?l(O.left,"x"):Math.round(Math.max(H.width()-O.w-z-D,0)/2),s+=O.bottom!==!1?Math.max(n()-O.h-N-_-l(O.bottom,"y"),0):O.top!==!1?l(O.top,"y"):Math.round(Math.max(n()-O.h-N-_,0)/2),v.css({top:c.top,left:c.left,visibility:"visible"}),y[0].style.width=y[0].style.height="9999px",r={width:O.w+z+D,height:O.h+N+_,top:s,left:d},t){var u=0;e.each(r,function(e){return r[e]!==ct[e]?(u=t,void 0):void 0}),t=u}ct=r,t||v.css(r),v.dequeue().animate(r,{duration:t||0,complete:function(){o(),q=!1,y[0].style.width=O.w+z+D+"px",y[0].style.height=O.h+N+_+"px",O.reposition&&setTimeout(function(){H.on("resize."+et,J.position)},1),i&&i()},step:o})},J.resize=function(e){var t;$&&(e=e||{},e.width&&(O.w=l(e.width,"x")-z-D),e.innerWidth&&(O.w=l(e.innerWidth,"x")),W.css({width:O.w}),e.height&&(O.h=l(e.height,"y")-N-_),e.innerHeight&&(O.h=l(e.innerHeight,"y")),e.innerHeight||e.height||(t=W.scrollTop(),W.css({height:"auto"}),O.h=W.height()),W.css({height:O.h}),t&&W.scrollTop(t),J.position("none"===O.transition?0:O.speed))},J.prep=function(i){function n(){return O.w=O.w||W.width(),O.w=O.mw&&O.mw<O.w?O.mw:O.w,O.w}function l(){return O.h=O.h||W.height(),O.h=O.mh&&O.mh<O.h?O.mh:O.h,O.h}if($){var s,d="none"===O.transition?0:O.speed;W.empty().remove(),W=o(st,"LoadedContent").append(i),W.hide().appendTo(F.show()).css({width:n(),overflow:O.scrolling?"auto":"hidden"}).css({height:l()}).prependTo(x),F.hide(),e(U).css({"float":"none"}),s=function(){function i(){e.support.opacity===!1&&v[0].style.removeAttribute("filter")}var n,l,s=E.length,u="frameBorder",p="allowTransparency";$&&(l=function(){clearTimeout(Q),L.hide(),c(nt,O.onComplete)},S.html(O.title).add(W).show(),s>1?("string"==typeof O.current&&M.html(O.current.replace("{current}",j+1).replace("{total}",s)).show(),I[O.loop||s-1>j?"show":"hide"]().html(O.next),K[O.loop||j?"show":"hide"]().html(O.previous),O.slideshow&&R.show(),O.preloading&&e.each([r(-1),r(1)],function(){var i,o,n=E[this],r=e.data(n,Z);r&&r.href?(i=r.href,e.isFunction(i)&&(i=i.call(n))):i=e(n).attr("href"),i&&a(r,i)&&(i=h(r,i),o=t.createElement("img"),o.src=i)})):B.hide(),O.iframe?(n=o("iframe")[0],u in n&&(n[u]=0),p in n&&(n[p]="true"),O.scrolling||(n.scrolling="no"),e(n).attr({src:O.href,name:(new Date).getTime(),"class":et+"Iframe",allowFullScreen:!0,webkitAllowFullScreen:!0,mozallowfullscreen:!0}).one("load",l).appendTo(W),ht.one(at,function(){n.src="//about:blank"}),O.fastIframe&&e(n).trigger("load")):l(),"fade"===O.transition?v.fadeTo(d,1,i):i())},"fade"===O.transition?v.fadeTo(d,0,function(){J.position(0,s)}):J.position(d,s)}},J.next=function(){!q&&E[1]&&(O.loop||E[j+1])&&(j=r(1),p(E[j]))},J.prev=function(){!q&&E[1]&&(O.loop||j)&&(j=r(-1),p(E[j]))},J.close=function(){$&&!G&&(G=!0,$=!1,c(rt,O.onCleanup),H.off("."+et),g.fadeTo(O.fadeOut||0,0),v.stop().fadeTo(O.fadeOut||0,0,function(){v.add(g).css({opacity:1,cursor:"auto"}).hide(),c(at),W.empty().remove(),setTimeout(function(){G=!1,c(lt,O.onClosed)},1)}))},J.remove=function(){v&&(v.stop(),e.colorbox.close(),v.stop().remove(),g.remove(),G=!1,v=null,e("."+tt).removeData(Z).removeClass(tt),e(t).off("click."+et))},J.element=function(){return e(A)},J.settings=Y)})(jQuery,document,window);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery) {// Generated by CoffeeScript 1.6.1
// Modified by Swisscom (2017)
(function() {

    (function($, window, document) {
        var Plugin, defaults, pluginName;
        pluginName = "slidesjs";
        defaults = {
            width: 940,
            height: 528,
            start: 1,
            navigation: {
                active: true,
                effect: "slide"
            },
            pagination: {
                active: true,
                effect: "slide"
            },
            play: {
                active: false,
                effect: "slide",
                interval: 5000,
                auto: false,
                swap: true,
                pauseOnHover: false,
                restartDelay: 2500
            },
            effect: {
                slide: {
                    speed: 1000
                },
                fade: {
                    speed: 300,
                    crossfade: true
                }
            },
            callback: {
                loaded: function() {},
                start: function() {},
                complete: function() {}
            }
        };
        Plugin = (function() {

            function Plugin(element, options) {
                this.element = element;
                this.options = $.extend(true, {}, defaults, options);
                this._defaults = defaults;
                this._name = pluginName;
                this.init();
            }

            return Plugin;

        })();
        Plugin.prototype.init = function() {
            var $element, nextButton, pagination, playButton, prevButton, stopButton,
                _this = this;
            $element = $(this.element);
            this.data = $.data(this);
            $.data(this, "animating", false);
            $.data(this, "total", $element.children().not(".slidesjs-navigation", $element).length);
            $.data(this, "current", this.options.start - 1);
            $.data(this, "vendorPrefix", this._getVendorPrefix());
            if (typeof TouchEvent !== "undefined") {
                $.data(this, "touch", true);
                this.options.effect.slide.speed = this.options.effect.slide.speed / 2;
            }
            $element.css({
                overflow: "hidden"
            });
            $element.slidesContainer = $element.children().not(".slidesjs-navigation", $element).wrapAll("<div class='slidesjs-container'>", $element).parent().css({
                overflow: "hidden",
                position: "relative"
            });
            $(".slidesjs-container", $element).wrapInner("<div class='slidesjs-control'>", $element).children();
            $(".slidesjs-control", $element).css({
                position: "relative",
                left: 0
            });
            $(".slidesjs-control", $element).children().addClass("slidesjs-slide").css({
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                zIndex: 0,
                display: "block",
                webkitBackfaceVisibility: "hidden"
            });
            $.each($(".slidesjs-control", $element).children(), function(i) {
                var $slide;
                $slide = $(this);
                return $slide.attr("slidesjs-index", i);
            });
            if (this.data.touch) {
                $($element).delegate(".slidesjs-control", "touchstart", function(e) {
                    return _this._touchstart(e);
                });
                $($element).delegate(".slidesjs-control", "touchmove", function(e) {
                    return _this._touchmove(e);
                });
                $($element).delegate(".slidesjs-control", "touchend", function(e) {
                    return _this._touchend(e);
                });
            }
            $element.fadeIn(0);
            this.update();
            if (this.data.touch) {
                this._setuptouch();
            }
            $(".slidesjs-control", $element).children(":eq(" + this.data.current + ")").eq(0).fadeIn(0, function() {
                return $(this).css({
                    zIndex: 10
                });
            });
            if (this.options.navigation.active) {
                prevButton = $("<a>", {
                    "class": "slidesjs-previous slidesjs-navigation",
                    href: "#",
                    title: "Previous",
                    text: "Previous"
                }).appendTo($element);
                nextButton = $("<a>", {
                    "class": "slidesjs-next slidesjs-navigation",
                    href: "#",
                    title: "Next",
                    text: "Next"
                }).appendTo($element);
            }
            $(".slidesjs-next", $element).click(function(e) {
                e.preventDefault();
                _this.stop(true);
                return _this.next(_this.options.navigation.effect);
            });
            $(".slidesjs-previous", $element).click(function(e) {
                e.preventDefault();
                _this.stop(true);
                return _this.previous(_this.options.navigation.effect);
            });
            if (this.options.play.active) {
                playButton = $("<a>", {
                    "class": "slidesjs-play slidesjs-navigation",
                    href: "#",
                    title: "Play",
                    text: "Play"
                }).appendTo($element);
                stopButton = $("<a>", {
                    "class": "slidesjs-stop slidesjs-navigation",
                    href: "#",
                    title: "Stop",
                    text: "Stop"
                }).appendTo($element);
                playButton.click(function(e) {
                    e.preventDefault();
                    return _this.play(true);
                });
                stopButton.click(function(e) {
                    e.preventDefault();
                    return _this.stop(true);
                });
                if (this.options.play.swap) {
                    stopButton.css({
                        display: "none"
                    });
                }
            }
            if (this.options.pagination.active) {
                pagination = $("<ul>", {
                    "class": "slidesjs-pagination"
                }).appendTo($element);
                $.each(new Array(this.data.total), function(i) {
                    var paginationItem, paginationLink;
                    paginationItem = $("<li>", {
                        "class": "slidesjs-pagination-item"
                    }).appendTo(pagination);
                    paginationLink = $("<a>", {
                        href: "#",
                        "data-slidesjs-item": i,
                        html: i + 1
                    }).appendTo(paginationItem);
                    return paginationLink.click(function(e) {
                        e.preventDefault();
                        _this.stop(true);
                        return _this.gotoCustom(($(e.currentTarget).attr("data-slidesjs-item") * 1) + 1);
                    });
                });
            }
            $(window).bind("resize", function() {
                return _this.update();
            });
            this._setActive();
            if (this.options.play.auto) {
                this.play();
            }
            return this.options.callback.loaded(this.options.start);
        };
        Plugin.prototype._setActive = function(number) {
            var $element, current;
            $element = $(this.element);
            this.data = $.data(this);
            current = number > -1 ? number : this.data.current;
            $(".active", $element).removeClass("active");
            return $(".slidesjs-pagination li:eq(" + current + ") a", $element).addClass("active");
        };
        Plugin.prototype.update = function() {
            var $element, height, width;
            $element = $(this.element);
            this.data = $.data(this);
            $(".slidesjs-control", $element).children(":not(:eq(" + this.data.current + "))").css({
                display: "block",
                left: 0,
                zIndex: 0
            });
            width = $element.width();
            height = (this.options.height / this.options.width) * width;
            this.options.width = width;
            this.options.height = height;
            return $(".slidesjs-control, .slidesjs-container", $element).css({
                width: width,
                height: height
            });
        };
        Plugin.prototype.next = function(effect) {
            var $element;
            $element = $(this.element);
            this.data = $.data(this);
            $.data(this, "direction", "next");
            if (effect === 0) {
                effect = this.options.navigation.effect;
            }
            if (effect === "fade") {
                return this._fade();
            } else {
                return this._slide();
            }
        };
        Plugin.prototype.previous = function(effect) {
            var $element;
            $element = $(this.element);
            this.data = $.data(this);
            $.data(this, "direction", "previous");
            if (effect === 0) {
                effect = this.options.navigation.effect;
            }
            if (effect === "fade") {
                return this._fade();
            } else {
                return this._slide();
            }
        };
        Plugin.prototype.gotoCustom = function(number) {
            var $element, effect;
            $element = $(this.element);
            this.data = $.data(this);
            if (effect === 0) {
                effect = this.options.pagination.effect;
            }
            if (number > this.data.total) {
                number = this.data.total;
            } else if (number < 1) {
                number = 1;
            }
            if (typeof number === "number") {
                if (effect === "fade") {
                    return this._fade(number);
                } else {
                    return this._slide(number);
                }
            } else if (typeof number === "string") {
                if (number === "first") {
                    if (effect === "fade") {
                        return this._fade(0);
                    } else {
                        return this._slide(0);
                    }
                } else if (number === "last") {
                    if (effect === "fade") {
                        return this._fade(this.data.total);
                    } else {
                        return this._slide(this.data.total);
                    }
                }
            }
        };
        Plugin.prototype._setuptouch = function() {
            var $element, next, previous, slidesControl;
            $element = $(this.element);
            this.data = $.data(this);
            slidesControl = $(".slidesjs-control", $element);
            next = this.data.current + 1;
            previous = this.data.current - 1;
            if (previous < 0) {
                previous = this.data.total - 1;
            }
            if (next > this.data.total - 1) {
                next = 0;
            }
            slidesControl.children(":eq(" + next + ")").css({
                display: "block",
                left: this.options.width
            });
            return slidesControl.children(":eq(" + previous + ")").css({
                display: "block",
                left: -this.options.width
            });
        };
        Plugin.prototype._touchstart = function(e) {
            var $element, touches;
            $element = $(this.element);
            this.data = $.data(this);
            touches = e.originalEvent.touches[0];
            this._setuptouch();
            $.data(this, "touchtimer", Number(new Date()));
            $.data(this, "touchstartx", touches.pageX);
            $.data(this, "touchstarty", touches.pageY);
            return e.stopPropagation();
        };
        Plugin.prototype._touchend = function(e) {
            var $element, duration, prefix, slidesControl, timing, touches, transform,
                _this = this;
            $element = $(this.element);
            this.data = $.data(this);
            touches = e.originalEvent.touches[0];
            slidesControl = $(".slidesjs-control", $element);
            if (slidesControl.position().left > this.options.width * 0.5 || slidesControl.position().left > this.options.width * 0.1 && (Number(new Date()) - this.data.touchtimer < 250)) {
                $.data(this, "direction", "previous");
                this._slide();
            } else if (slidesControl.position().left < -(this.options.width * 0.5) || slidesControl.position().left < -(this.options.width * 0.1) && (Number(new Date()) - this.data.touchtimer < 250)) {
                $.data(this, "direction", "next");
                this._slide();
            } else {
                prefix = this.data.vendorPrefix;
                transform = prefix + "Transform";
                duration = prefix + "TransitionDuration";
                timing = prefix + "TransitionTimingFunction";
                slidesControl[0].style[transform] = "translateX(0px)";
                slidesControl[0].style[duration] = this.options.effect.slide.speed * 0.85 + "ms";
            }
            $element.delegate(".slidesjs-control", "transitionend webkitTransitionEnd oTransitionEnd otransitionend MSTransitionEnd", function() {
                prefix = _this.data.vendorPrefix;
                transform = prefix + "Transform";
                duration = prefix + "TransitionDuration";
                timing = prefix + "TransitionTimingFunction";
                slidesControl[0].style[transform] = "";
                slidesControl[0].style[duration] = "";
                return slidesControl[0].style[timing] = "";
            });
            return e.stopPropagation();
        };
        Plugin.prototype._touchmove = function(e) {
            var $element, prefix, slidesControl, touches, transform;
            $element = $(this.element);
            this.data = $.data(this);
            touches = e.originalEvent.touches[0];
            prefix = this.data.vendorPrefix;
            slidesControl = $(".slidesjs-control", $element);
            transform = prefix + "Transform";
            $.data(this, "scrolling", Math.abs(touches.pageX - this.data.touchstartx) < Math.abs(touches.pageY - this.data.touchstarty));
            if (!this.data.animating && !this.data.scrolling) {
                e.preventDefault();
                this._setuptouch();
                slidesControl[0].style[transform] = "translateX(" + (touches.pageX - this.data.touchstartx) + "px)";
            }
            return e.stopPropagation();
        };
        Plugin.prototype.play = function(next) {
            var $element, currentSlide, slidesContainer,
                _this = this;
            $element = $(this.element);
            this.data = $.data(this);
            if (!this.data.playInterval) {
                if (next) {
                    currentSlide = this.data.current;
                    this.data.direction = "next";
                    if (this.options.play.effect === "fade") {
                        this._fade();
                    } else {
                        this._slide();
                    }
                }
                $.data(this, "playInterval", setInterval((function() {
                    currentSlide = _this.data.current;
                    _this.data.direction = "next";
                    if (_this.options.play.effect === "fade") {
                        return _this._fade();
                    } else {
                        return _this._slide();
                    }
                }), this.options.play.interval));
                slidesContainer = $(".slidesjs-container", $element);
                if (this.options.play.pauseOnHover) {
                    slidesContainer.unbind();
                    slidesContainer.bind("mouseenter", function() {
                        return _this.stop();
                    });
                    slidesContainer.bind("mouseleave", function() {
                        if (_this.options.play.restartDelay) {
                            return $.data(_this, "restartDelay", setTimeout((function() {
                                return _this.play(true);
                            }), _this.options.play.restartDelay));
                        } else {
                            return _this.play();
                        }
                    });
                }
                $.data(this, "playing", true);
                $(".slidesjs-play", $element).addClass("slidesjs-playing");
                if (this.options.play.swap) {
                    $(".slidesjs-play", $element).hide();
                    return $(".slidesjs-stop", $element).show();
                }
            }
        };
        Plugin.prototype.stop = function(clicked) {
            var $element;
            $element = $(this.element);
            this.data = $.data(this);
            clearInterval(this.data.playInterval);
            if (this.options.play.pauseOnHover && clicked) {
                $(".slidesjs-container", $element).unbind();
            }
            $.data(this, "playInterval", null);
            $.data(this, "playing", false);
            $(".slidesjs-play", $element).removeClass("slidesjs-playing");
            if (this.options.play.swap) {
                $(".slidesjs-stop", $element).hide();
                return $(".slidesjs-play", $element).show();
            }
        };
        Plugin.prototype._slide = function(number) {
            var $element, currentSlide, direction, duration, next, prefix, slidesControl, timing, transform, value,
                _this = this;
            $element = $(this.element);
            this.data = $.data(this);
            if (!this.data.animating && number !== this.data.current + 1) {
                $.data(this, "animating", true);
                currentSlide = this.data.current;
                if (number > -1) {
                    number = number - 1;
                    value = number > currentSlide ? 1 : -1;
                    direction = number > currentSlide ? -this.options.width : this.options.width;
                    next = number;
                } else {
                    value = this.data.direction === "next" ? 1 : -1;
                    direction = this.data.direction === "next" ? -this.options.width : this.options.width;
                    next = currentSlide + value;
                }
                if (next === -1) {
                    next = this.data.total - 1;
                }
                if (next === this.data.total) {
                    next = 0;
                }
                this._setActive(next);
                slidesControl = $(".slidesjs-control", $element);
                if (number > -1) {
                    slidesControl.children(":not(:eq(" + currentSlide + "))").css({
                        display: "block",
                        left: 0,
                        zIndex: 0
                    });
                }
                slidesControl.children(":eq(" + next + ")").css({
                    display: "block",
                    left: value * this.options.width,
                    zIndex: 10
                });
                this.options.callback.start(currentSlide + 1);
                if (this.data.vendorPrefix) {
                    prefix = this.data.vendorPrefix;
                    transform = prefix + "Transform";
                    duration = prefix + "TransitionDuration";
                    timing = prefix + "TransitionTimingFunction";
                    slidesControl[0].style[transform] = "translateX(" + direction + "px)";
                    slidesControl[0].style[duration] = this.options.effect.slide.speed + "ms";
                    return $element.delegate(".slidesjs-control", "transitionend webkitTransitionEnd oTransitionEnd otransitionend MSTransitionEnd", function() {
                       slidesControl[0].style[transform] = "";
                       slidesControl[0].style[duration] = "";
                       slidesControl.children(":eq(" + next + ")").css({
                           left: 0,
                           zIndex: 10
                       });
                       slidesControl.children(":eq(" + currentSlide + ")").css({
                           display: "block",
                           left: 0,
                           zIndex: 0
                       });
                       $.data(_this, "current", next);
                       $.data(_this, "animating", false);
                       slidesControl.unbind("transitionend webkitTransitionEnd oTransitionEnd otransitionend MSTransitionEnd");
                       slidesControl.children(":not(:eq(" + next + "))").css({
                           display: "block",
                           left: 0,
                           zIndex: 0
                       });
                       if (_this.data.touch) {
                           _this._setuptouch();
                       }
                       return _this.options.callback.complete(next + 1);
                    });
                    } else {
                    return slidesControl.stop().animate({
                       left: direction
                    }, this.options.effect.slide.speed, (function() {
                       slidesControl.css({
                           left: 0
                       });
                       slidesControl.children(":eq(" + next + ")").css({
                           left: 0
                       });
                       return slidesControl.children(":eq(" + currentSlide + ")").css({
                           display: "block",
                           left: 0,
                           zIndex: 0
                       }, $.data(_this, "current", next), $.data(_this, "animating", false), _this.options.callback.complete(next + 1));
                    }));
                }
            }
        };
        Plugin.prototype._fade = function(number) {
            var $element, currentSlide, next, slidesControl, value,
                _this = this;
            $element = $(this.element);
            this.data = $.data(this);
            if (!this.data.animating && number !== this.data.current + 1) {
                $.data(this, "animating", true);
                currentSlide = this.data.current;
                if (number) {
                    number = number - 1;
                    value = number > currentSlide ? 1 : -1;
                    next = number;
                } else {
                    value = this.data.direction === "next" ? 1 : -1;
                    next = currentSlide + value;
                }
                if (next === -1) {
                    next = this.data.total - 1;
                }
                if (next === this.data.total) {
                    next = 0;
                }
                this._setActive(next);
                slidesControl = $(".slidesjs-control", $element);
                slidesControl.children(":eq(" + next + ")").css({
                    display: "block",
                    left: 0,
                    zIndex: 10
                });
                this.options.callback.start(currentSlide + 1);
                if (this.options.effect.fade.crossfade) {
                    slidesControl.children(":eq(" + this.data.current + ")").stop().fadeOut(this.options.effect.fade.speed);
                    return slidesControl.children(":eq(" + next + ")").stop().fadeIn(this.options.effect.fade.speed, (function() {
                        slidesControl.children(":eq(" + next + ")").css({
                            zIndex: 0
                        });
                        $.data(_this, "animating", false);
                        $.data(_this, "current", next);
                        return _this.options.callback.complete(next + 1);
                    }));
                } else {
                    return slidesControl.children(":eq(" + currentSlide + ")").stop().fadeOut(this.options.effect.fade.speed, (function() {
                        slidesControl.children(":eq(" + next + ")").stop().fadeIn(_this.options.effect.fade.speed, (function() {
                            return slidesControl.children(":eq(" + next + ")").css({
                                zIndex: 10
                            });
                        }));
                        $.data(_this, "animating", false);
                        $.data(_this, "current", next);
                        return _this.options.callback.complete(next + 1);
                    }));
                }
            }
        };
        Plugin.prototype._getVendorPrefix = function() {
            var body, i, style, transition, vendor;
            body = document.body || document.documentElement;
            style = body.style;
            transition = "transition";
            vendor = ["Moz", "Webkit", "Khtml", "O", "ms"];
            transition = transition.charAt(0).toUpperCase() + transition.substr(1);
            i = 0;
            while (i < vendor.length) {
                if (typeof style[vendor[i] + transition] === "string") {
                    return vendor[i];
                }
                i++;
            }
            return false;
        };
        return $.fn[pluginName] = function(options) {
            return this.each(function() {
                if (!$.data(this, "plugin_" + pluginName)) {
                    return $.data(this, "plugin_" + pluginName, new Plugin(this, options));
                }
            });
        };
    })(jQuery, window, document);

}).call(this);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 72 */
/***/ (function(module, exports) {

/**

 * Detect when webfonts are properly loaded and available!

 */

/* globals window, document */
/* exported window, document */
(function (window, document) {

	'use strict';

	/* jslint curly: false */
	/* jslint plusplus: true */
	/* jslint camelcase: false */
	/* jslint validthis: true */

	// by font key
	var resolved = {},
	    detecting = {},
	    containers = {};

	// maybe implement a more advance detection
	// use smart setup to trigger a scroll event
	// function fontDetectScroll(fontkey, font) {}

	// detect if a font is loaded by using
	// some divs to detect dimension change
	function fontDetectDom(fontkey, font)
	{

		// create the elements to be measured
		var webfont_div = document.createElement('div');
		var fallback_div = document.createElement('div');

		// setup the font family for the reference div
		fallback_div.style.fontFamily = font.fallback;
		// then setup the webfont div with same fallback as the reference div
		webfont_div.style.fontFamily = [font.family, font.fallback].join(', ');
		// store created divs so we can later remove them from document
		var divs = containers[fontkey] = [fallback_div, webfont_div];

		// apply common styles to all created divs
		for (var i = 0, L = divs.length; i < L; ++ i)
		{
			divs[i].style.fontWeight = font.weight;
			divs[i].style.fontStyle = font.style;
			divs[i].style.fontSize = '42px';
			divs[i].style.whiteSpace = 'nowrap';
			divs[i].style.position = 'absolute';
			divs[i].style.visibility = 'hidden';
			divs[i].style.left = '-9999px';
			divs[i].innerHTML = font.paragraph;
		}

		// now append the tests to the document
		// this could trigger the font download
		document.body.appendChild(fallback_div);
		document.body.appendChild(webfont_div);

		// create an array for further promises
		// we don't wait for them, we resolve them
		var promises = detecting[fontkey] = [];

		// return promise to resolve once font is loaded
		return new Promise(function (resolve, reject) {

			// closures
			var iv, tm;

			// store callbacks in internal array
			promises.push([resolve, reject]);

			// setup the timeout abort timer
			tm = window.setTimeout(function () {

				// clear the check interval
				if (iv) window.clearInterval(iv);
				// reject all waiting promises
				var i = promises.length; while (i--)
					promises[i][1]('timeout');
				// remove the created containers
				var n = divs.length; while (n--)
					document.body.removeChild(divs[n]);
				// remember the result
				resolved[fontkey] = false;
				// reset the array
				promises.length = 0;

			}, font.timeout || 4000);

			// closure function
			function check()
			{
				// check any dimensions have changed (success)
				if (webfont_div.offsetWidth != fallback_div.offsetWidth ||
				    webfont_div.offsetHeight != fallback_div.offsetHeight) {

					// load is complete, abort timers
					if (iv) window.clearInterval(iv);
					if (tm) window.clearTimeout(tm);
					// mark font ready (also via config object)
					// can be accessed before resolve is called
					font.ready = font.config.ready = true;
					// resolve all waiting promises
					var i = promises.length; while (i--)
						promises[i][0].call(this, font);
					// remove the created containers
					var n = divs.length; while (n--)
						document.body.removeChild(divs[n]);
					// remember the result
					resolved[fontkey] = font;
					// reset the array
					promises.length = 0;
				}
			}

			// this is the main testing interval
			iv = window.setInterval(check, font.interval || 40);

			// call once to trigger
			// one syncronized event
			// avoid fouc if possible
			check();

		});
		// EO Promise


	}
	// EO fontDetectDom

	var id = 0;

	// detect if a font is loaded by using
	// some divs to detect dimension change
	function fontDetect(family, config)
	{

		// ensure config object
		config = config || {};

		// split font families for fallbacks
		// avoid to get events from fallbacks
		var families = family.split(/\s*,\s*/);

		// poor man's extend
		var font = {
			id: ++id,
			ready: false,
			// mandatory
			config: config,
			family: families[0],
			families: families,
			// optional style settings
			style: config.style || 'normal',
			weight: config.weight || 'normal',
			effect: config.effect || 'normal',
			stretch: config.stretch || 'normal',
			variant: config.variant || 'normal',
			// timings for the tests
			timeout: config.timeout || 4000,
			interval: config.interval || 40,
			// properties for the tests
			paragraph: config.paragraph,
			fallback: config.fallback
		};

		// unique key for font
		// use to access hashmap
		var fontkey = [
			family,
			font.style,
			font.weight,
			font.effect,
			font.stretch,
			font.variant
		].join(':');

		// check if we already have a result
		if (typeof resolved[fontkey] != 'undefined')
		{
			return new Promise(function (resolve, reject) {
				var font = resolved[fontkey];
				if (resolved[fontkey]) resolve(font);
				else reject('timeout');
			});
		}

		// check if we already have a result
		if (typeof detecting[fontkey] != 'undefined')
		{
			return new Promise(function (resolve, reject) {
				// store callbacks in internal array
				detecting[fontkey].push([resolve, reject]);
			});
		}

		// try to be a little on the safe side
		// otherwise pass us a valid test font
		if (!font.fallback)
		{
			font.fallback = font.style == 'monospace' ?
			                'oblique' : 'monospace';
		}

		// initialize the test text
		if (!font.paragraph)
		{
			font.paragraph = [
				'0123456789',
				'!?\"\'\\#$(){}[]_',
				':;<>@~+-*%&^`|,=./',
				'ABCDEFGHIJKLMNOPQRSTUVWXYZ',
				'abcdefghijklmnopqrstuvwxyz'
			].join(' ');
		}

		// now dispatch to implementors
		return fontDetectDom(fontkey, font);

	}

	// export into the window namespace
	window.fontDetect = fontDetect;

})(window, document);

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_jQuery) {/**
 * https://github.com/tjunghans/jquery.distinct
 */
(function ($) {
	'use strict';

	$.extend({
		distinct: function (anArray) {
			var result = [];
			$.each(anArray, function (i, v) {
				if ($.inArray(v, result) === -1) {
					result.push(v);
				}
			});
			return result;
		}
	});
}(__webpack_provided_window_dot_jQuery));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery) {/**

 * Helper to measure stuff on possibly hidden nodes
 * This only works with block elements, since there
 * a) is no way to reset a style to a browser default
 * b) we don't know if a tag should be inline or block
 * c) doesn't make much sense on non block nodes anyway

 */

/* jslint plusplus: true */
/* globals jQuery, window, document */
/* exported jQuery, window, document */
(function (jQuery, window, document) {

	'use strict';

	// show the given nodes to do some measuring
	// the function will be called when node is showed
	// afterwards we will revert changed view states
	// fn is mandatory and must be synchronous
	jQuery.fn.showToMeasure = function (fn) {

		// closure variables
		var treenodes = [],
		    viewstate = [];

		// closure to reset states
		function revert () {
			for (var i = 0, L = viewstate.length; i < L; i++) {
				viewstate[i][0].css('display', viewstate[i][1]);
			}
		}

		// now show all nodes
		this.each(function(n, node) {
			// show temporarily
			// if (jQuery(node).is(':hidden')) {
			if (node.offsetParent === null) {
				// move up to the body tag
				while (node.tagName != 'BODY') {
					// collect view states
					treenodes.push(jQuery(node));
					// move up in the tree
					node = node.parentNode;
				}
				// process the array from behind
				// basically starting at the tree top
				// so we only change actual hidden nodes
				var i = treenodes.length; while (i--) {
					// this is a jQuery node
					var $treenode = treenodes[i];
					// check if the current node is hidden
					if ($treenode.is(':hidden')) {
						// store the old state for node to be changed
						viewstate.push([$treenode, $treenode[0].style.display]);
						// forcefully display this node now
						$treenode.css('display', 'block');
					}
				}
			}
		});

		// call function
		fn.call(this);
		// revert visibility
		revert.call(this);
		// keep chainable
		return this;

	};

})(jQuery, window, document);


/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_jQuery) {(function ($, SCS) {
	'use strict';

	var staticResourcesHost = ((($('script[src*=".scsstatic.ch"]:first').attr('src') || '').match(/(\/\/.*scsstatic\.ch)\//) || [])[1] || ''); // find the HOST of the first SCRIPT element with a static resource server OR empty string as fallback

	SCS.Const = {

		SNOOPY_SHARING_URL: 'http://tvonline.swisscom.ch/r/link?', // also used for TV2.0
		SNOOPY_LOADED_EVENT: 'snoopyLoaded',

		SNOOPY_CHANNEL_MAPPING : {
			'sf-1'			: '574b6a53-58bd-488a-a5fe-0d1299854fdd',
			'sf-2'			: 'ee734305-74e6-4bc9-ab1f-c6be80469d5e',
			'sf-info'		: '52404018-4781-4464-8d4c-a4e2f1c9deee',
			'ard'			: 'f2799299-fd05-4b6a-bbfd-719c9db583e2',
			'zdf'			: 'b1435924-aa17-41e6-bb72-e8d95a37a3b9',
			'rtl'			: '364d23b8-2512-4c1c-b268-f9ab56ec3f38',
			'rtl-2'			: 'f89a8a73-4337-4586-bb22-417e88c5ff0d',
			'prosieben'		: 'd1cd8b9b-5572-4686-bc5c-72ed5d9c39be', // no HD available yet
			'sat1'			: 'ae66c5a2-83fe-41e6-9f14-e3ac09218dc1', // no HD available yet
			'kabel-eins'	: '47057ee0-cc86-4dee-8c21-16ef9e693df0', // no HD available yet
			'orf-1'			: '364d23b8-2512-4c1c-b268-f9ab56ec3f38',
			'orf-2'			: 'f89a8a73-4337-4586-bb22-417e88c5ff0d',
			'eurosport'		: 'cc61d18e-348e-4b48-bdbb-c9a95d63193f', // no HD available yet ... and NOT available for web TV!
			'tsr1'			: '8a3a1025-e4f8-47e4-a6e7-22ed6c7942e9',
			'tsr2'			: '83bbb445-ded4-436f-9725-372077fba0a6',
			'tf1'			: '1075f22b-622f-42f8-8721-521a6d4d87fa',
			'm6-suisse'		: '55dd0909-beca-4291-b36d-0790f5ddc128',
			'france-2'		: 'a4875ae5-69ee-462f-9057-5be229947de9',
			'france-3'		: 'c10a3cb6-7e3e-4556-9889-83a1abb10176',
			'france-4'		: '56eaeea5-a2a0-471a-b99f-95567e07430a',
			'rsi-la1'		: '482d5b67-51db-4d2b-900e-8bcd5b73fd29',
			'rsi-la2'		: '3c209535-74c0-40df-b07f-08b5c27470c5',
			'canale-5'		: '1e5f5485-44a8-4c75-8062-051d344d3284', // no HD available yet
			'rai-uno'		: 'bbaa60fd-8200-48f7-8465-d45d3a223082',
			'rai-due'		: 'caf245e5-3111-4a51-9f4b-c0064c2f913a'  // no HD available yet
		},
		SPORT_CHANNELS: {
			'chtv': {
				name: 'CH TV',
				id: 'e623b137-002a-4ac5-b6d2-5b1eefc1cff8'
			},
			'mdr-sachsen': {
				name: 'MDR',
				id: '1a567f8f-3222-43a2-a69b-3f92335134cd'
			},
			'sport1schweiz': {
				name: 'Sport 1',
				id: '4b59eb3a-2aca-4939-809f-74d4d5a8da1a'
			},
			'tv24': {
				name: 'TV 24',
				id: '26b2482f-3b5c-404e-bb68-a38a64174709'
			},
			'more4': {
				name: 'More 4',
				id: 'a58b5205-b1f8-45a4-b23c-cadf431a28cb'
			},
			'canale-5': {
				name: 'Canale 5',
				id: '2681a93a-7344-43d4-b232-b829577134ab'
			},
			'tele1': {
				name: 'tele 1',
				id: 'f1ff8927-4213-47f7-a370-c3e9037ec2fb'
			},
			'servus_tv': {
				name: 'Servus TV',
				id: '1b5a8730-506d-41be-abdc-09124b28ca20'
			},
			'rete-4': {
				name: 'Rete 4',
				id: 'ea1d7cfc-d03f-40bf-96f5-b248445d8baf'
			},
			'm6-suisse': {
				name: 'M6',
				id: '55dd0909-beca-4291-b36d-0790f5ddc128'
			},
			'bbc-one': {
				name: 'BBC 1',
				id: 'dc5bd62c-c1d5-4952-94aa-0b40b3632493'
			},
			'bbc2': {
				name: 'BBC 2',
				id: '9d1820ab-a1a8-4d3d-8ab4-2aa2145eb820'
			},
			'rtlnitro': {
				name: 'RTL Nitro',
				id: '502abd22-ac9a-4bf7-8809-3570c3a96b92'
			},
			'wdr-koeln': {
				name: 'WDR',
				id: 'b1d56065-3cf5-414d-a4c9-4862c4a0cbf6'
			},
			'ndr-niedersachsen': {
				name: 'NDR',
				id: 'a9e3bf20-63c0-4f5b-88e7-a93a907dfcae'
			},
			'br': {
				name: 'BR',
				id: '741f304d-bd8f-42a1-8ac8-fbc08103ad16'
			},
			'swr-fernsehen-bw': {
				name: 'SWR',
				id: 'c8d6571d-15f3-480b-a4ef-c09d70d0427e'
			},
			'rbb': {
				name: 'RBB',
				id: '932aea63-1e98-400c-b87e-e69a77f1c819'
			},
			'3sat': {
				name: '3sat',
				id: '87622996-a63e-4120-9f40-bd16c68707af'
			},
			'sat1gold': {
				name: 'SAT.1 Gold',
				id: 'ba80795b-99d6-4086-b1f2-a041fffc7558'
			},
			'sat1': {
				name: 'SAT.1',
				id: '5e31f6b8-b2fb-499b-87a0-010a4e6d6d14'
			},
			'italia-1': {
				name: 'Italia 1',
				id: 'abe0651e-284a-4e3f-8893-4d9463f241f7'
			},
			'raisports2': {
				name: 'Rai Sport 2',
				id: '6c332a06-dcb0-42f2-abf5-71fc11ca99eb'
			},
			'raisports1': {
				name: 'Rai Sport 1',
				id: 'f884c11d-ab2f-4a29-9520-b0118b66dcd9'
			},
			'rai-tre': {
				name: 'Rai 3',
				id: 'acaf5818-f98e-429e-8490-3a6e281541b8'
			},
			'sf-1': {
				name: 'SRF 1',
				id: '574b6a53-58bd-488a-a5fe-0d1299854fdd'
			},
			'sf-2': {
				name: 'SRF zwei',
				id: 'ee734305-74e6-4bc9-ab1f-c6be80469d5e'
			},
			'ard': {
				name: 'ARD',
				id: 'f2799299-fd05-4b6a-bbfd-719c9db583e2'
			},
			'zdf': {
				name: 'ZDF',
				id: 'b1435924-aa17-41e6-bb72-e8d95a37a3b9'
			},
			'rtl': {
				name: 'RTL',
				id: '9cd31fcd-fe3f-49b8-aa27-ae99231a5c08'
			},
			'rtl-2': {
				name: 'RTL 2',
				id: '6877bf47-2160-461b-b8b9-8767214ad2b3'
			},
			'prosieben': {
				name: 'Pro7',
				id: 'aaa37308-b629-4291-a0eb-1bb61ed17cd0'
			},
			'kabel-eins': {
				name: 'Kabel eins',
				id: 'eada50f7-b603-444b-b5bb-24e25b25a543'
			},
			'startv': {
				name: 'Star TV',
				id: '99cd5709-44d4-4d83-ad75-d066f08aa9fb'
			},
			'orf-1': {
				name: 'ORF 1',
				id: '364d23b8-2512-4c1c-b268-f9ab56ec3f38'
			},
			'orf-2': {
				name: 'ORF 2',
				id: 'f89a8a73-4337-4586-bb22-417e88c5ff0d'
			},
			'dsf': {
				name: 'Sport1',
				id: '6daa7c44-bc40-4502-8923-ead0f0b7d68e'
			},
			'eurosport': {
				name: 'Eurosport',
				id: 'cc61d18e-348e-4b48-bdbb-c9a95d63193f'
			},
			'hr': {
				name: 'HR1',
				id: '9bde57bc-a37d-45fb-9036-6d60416e44cc'
			},
			'itv-1-london': {
				name: 'ITV1',
				id: 'fe3a74b6-77b0-4a9d-8a81-2b810b109d8a'
			},
			'itv-4': {
				name: 'ITV4',
				id: 'f43acfb7-9d7c-4910-b3cf-fc0e9d4bd702'
			},
			'channel-4': {
				name: 'Channel 4',
				id: 'fd18552b-ec44-42d0-a991-d8de6d9dadaa'
			},
			'five': {
				name: 'Five',
				id: 'b7bd1a2b-2e91-413e-904b-1b271b4e72cf'
			},
			'tsr1': {
				name: 'RTS un',
				id: '8a3a1025-e4f8-47e4-a6e7-22ed6c7942e9'
			},
			'tsr2': {
				name: 'RTS deux',
				id: '83bbb445-ded4-436f-9725-372077fba0a6'
			},
			'tf1': {
				name: 'TF1',
				id: '1075f22b-622f-42f8-8721-521a6d4d87fa'
			},
			'france-2': {
				name: 'France 2',
				id: 'a4875ae5-69ee-462f-9057-5be229947de9'
			},
			'france-3': {
				name: 'France 3',
				id: 'a853a4f2-ff63-5200-7048-d8d59d805f7b'
			},
			'france-4': {
				name: 'France 4',
				id: '9553a4f2-ff63-5200-7048-d8d59d805f7e'
			},
			'france-5': {
				name: 'France 5',
				id: '3153a4f2-ff63-5200-7048-d8d59d805f81'
			},
			'rsi-la1': {
				name: 'RSI la 1',
				id: '482d5b67-51db-4d2b-900e-8bcd5b73fd29'
			},
			'rsi-la2': {
				name: 'RSI la 2',
				id: '3c209535-74c0-40df-b07f-08b5c27470c5'
			},
			'rai-uno': {
				name: 'Rai 1',
				id: '65a4d083-50e4-4916-954a-ecd32e48da98'
			},
			'rai-due': {
				name: 'Rai 2',
				id: 'caf245e5-3111-4a51-9f4b-c0064c2f913a'
			},
			'sf-info': {
				name: 'SRF info',
				id: '52404018-4781-4464-8d4c-a4e2f1c9deee'
			}
		},
		SNOOPY_CHANNEL_IMAGE_BASE : '/tvairpub/online/content/images/tv/channel/',
		SNOOPY_CHANNEL_IMAGE_PREFIX_WIDH_SMALL : '_image_W90.png',
		/*
			possible sizes are:
			W45, W90, W116, W145, W176, W290, W484, W928, W1920
			H480, H720, H1080,
		*/

		SNOOPY_SERVICE_PROXY_URL: '/tvairpub/online/',
		SNOOPY_LANGUAGE: $('html').attr('lang') || 'de',
		SNOOPY_IMAGE_WIDTHS: [45, 90, 116, 145, 176, 290, 484, 928, 1920],
		SNOOPY_WEB_RENT_SURCHARGE: 0,
		SNOOPY_VOD_STORES: {'de': 'SwisscomDeutsch', 'fr': 'SwisscomFrançais', 'it': 'SwisscomItaliano', 'en': 'SwisscomDeutsch'},
		SNOOPY_TV_HIGHLIGHTS_CATEGORIES: {'de': 'DeHighlightsTip', 'fr': 'FrHighlightsTip', 'it': 'ItHighlightsTip', 'en': 'EnHighlightsTip'},
		SNOOPY_IS_OLD_IE: (Number((navigator.userAgent.toLowerCase().split('msie')[1] || '').split('.', 1)[0] || 9) < 9), // check if is IE and version is < 9

		STATIC_RESOURCES_HOST: staticResourcesHost,
		SNOOPY_IMAGE_BASE: staticResourcesHost + '/tvairpubimage/',

		SNOOPY_REPLAY_MAX_HOURS: 30
	};

}(__webpack_provided_window_dot_jQuery, window.SCS = window.SCS || {}));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_jQuery) {__webpack_require__(4);

/**
 * (c) Copyright Swisscom (Schweiz) AG. All rights reserved.
 *
 * This product is the proprietary and sole property of Swisscom (Schweiz) AG
 * Use, duplication or dissemination is subject to prior written consent of
 * Swisscom (Schweiz) AG.
 *
 * $Id: commons.js (portal)
 */

(function ($, SCS, w, undefined) {
	'use strict';
	var jQuery = $; // wrapped in closure to protect from other jQuery versions - tjunghans

	$.namespace('SCS');
	$.namespace('SCS.portal');

	/**
	 * Replace all function
	 * WARNING: dangerous function - if find-text is contained in replacement-text,
	 * it will re-replace within
	 * @param text Text
	 * @param find String to find
	 * @param repl Replacement string
	 */
	SCS.portal.replaceAll = function(text, find, repl) {
		var newText = text;
		if (newText) {
			var i = 0;
			while (newText.indexOf(find) !== -1 && i < 20) {
				newText = newText.replace(find, repl);
				i += 1;
			}
		}
		return newText;
	};

	/**
	 * Convert new-lines to breaks
	 * @param text Text
	 */
	SCS.portal.nl2br = function(text) {
		if (text) {
			return text.replace(/\n/g, '<br/>\n');
		}
		return text;
	};

	/**
	 * I18n (TODO: remove from static js files).
	 * used internally.
	 */
	SCS.portal.errorMessage = {
		de : 'Technische Störung.<br> Bitte versuchen Sie es später noch einmal.',
		en : 'Due to technical difficulties<br> please try again later.',
		fr : 'En raison de problèmes techniques<br> nous vous prions d\'essayer à nouveau plus tard.',
		it : 'Problema tecnico.<br> Vi preghiamo di riprovare più tardi.'
	};

	/**
	 * Ajax error handling
	 * @param message Error message
	 */
	SCS.portal.errorHandling = function(message) {
		if (message === undefined) {
			message = this.errorMessage[SCS.portal.lang];
		}
		var updatedMessage = ' <div id="scs-pageheader-crisis"> <div class="pageCenter"> <div id="scs-pageheader-crisis-warning">Warning:</div><div id="scs-pageheader-crisis-text">' +
			message +
			'</div><a href="#" id="scs-pageheader-crisis-link">More information</a><div class="clear">&nbsp;</div></div></div></div>';

		$('#commonsErrorContainer').show();
		$('#commonsErrorContainer').html(updatedMessage);
	};

	SCS.portal.isValidDate = function (day,month,year){
		if (month < 1 || month > 12) {
			return false;
		}
		if (day < 1 || day > 31){
			return false;
		}
		if ((month === 4 || month === 6 || month === 9 || month === 11) && day === 31){
			return false;
		}
		if (month === 2){
			var isleap = (year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0));
			if (day > 29 || (day === 29 && !isleap)){
				return false;
			}
		}
		return true;
	};

	/**
	 * Add parameter to query string of given url
	 * @param {string} url - URL
	 * @param {...string} name_or_value - Unlimited number of parameters with name and value example: addParamToUrl(url, 'param1', 'value1', 'param2', 'value2')
	 */
	SCS.portal.addParamToUrl = function(url) {
		if (!url) {
			return '';
		}

		var query = [];
		if (arguments.length > 1) {
			for (var i=1; arguments.length >= i+1; i+=2) {
				if (arguments[i + 1] === null) {
					query.push(arguments[i]);
				}
				else {
					query.push(arguments[i] + '=' + arguments[i + 1]);
				}
			}
		}

		var hashPos = url.indexOf('#'),
			queryStarter = (url.indexOf('?') === -1 ? '?' : '&');
		if (hashPos !== -1) {
			return url.substr(0, hashPos) + queryStarter + query.join('&') + url.substr(hashPos);
		} else {
			return url + queryStarter + query.join('&');
		}
	};

	/**
	 * Unused function, kept for legacy compatibility.
	 */
	SCS.portal.rePIE = jQuery.noop;

	jQuery(function($) {
		// Set wcmmode to disabled for HTML calls on all author instances when either in preview or publish-simulation modes.
		var body = $(document.body);
		if(body.is('.cq_isAuthorInstance') && (body.is('.cq_isPreviewMode') || body.is('.cq_isPublishMode'))) {
			$.ajaxPrefilter(function(options) {
				var url = options.url;
				url += (url.indexOf('?') > -1 ? '&' : '?') + 'wcmmode=disabled';
				options.url = url;
			});
		}
		// allow deeplinks to a specific lightbox (placed after "wcmmode=disabled" feature because otherwise
		// url selectors in preview mode don't work) --- ##jumpMarker-lightboxDeeplinkOpen## (do not remove)
		var lightboxHash = __webpack_require__(6).hashDeepLink.get('lightbox');
		if (lightboxHash && lightboxHash.length && lightboxHash.indexOf('sel:') === 0) {
			$(lightboxHash.substr(4)).click();
		}
	});

	/**
	 * Hide error message
	 */
	SCS.portal.hideErrorMessage = function() {
		if ($('#commonsErrorContainer').show()) {
			$('#commonsErrorContainer').hide();
		}
	};

}(__webpack_provided_window_dot_jQuery, window.SCS, window));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {/**
 * (c) Copyright Swisscom (Schweiz) AG. All rights reserved.
 *
 * This product is the proprietary and sole property of Swisscom (Schweiz) AG
 * Use, duplication or dissemination is subject to prior written consent of
 * Swisscom (Schweiz) AG.
 *
 * $Id: carousel.js
 */
$.namespace("SCS.carousel");

/**
 * Initialize all carousels found within a specific context or the body if no context is specified
 */
SCS.carousel.initCarousels = function(context) {
	context = context && context.closest && context.closest('body').length ? context : null;
	if(context){
		context.find('.carouselContainer').each(SCS.carousel.initializeCarousel);
	}
};

/**
 * Initialize a single carousel
 * @param carousel Carousel object
 */
SCS.carousel.initializeCarousel = function() {
	var carouselContainer = $(this);

	if(carouselContainer.is('.manual-init')) {
		return;
	}

	if (carouselContainer.data('carousel-initialized')) {
		return;
	}
	carouselContainer.data('carousel-initialized', true);

	var buttons = carouselContainer.find('.carousel-prev, .carousel-next'),
		labels = carouselContainer.find('.label-next, .label-prev'),
        controls = carouselContainer.find('.carousel-control'),
		initCallback = null;

    if($('.carouselContainer').data('controls')) {
        controls.hide();
    } else {
        controls.show();
    }

	if (carouselContainer.hasClass('thumbnailsCarouselContainer')) {
		SCS.carousel.activateVideo(carouselContainer.find('.items .item:first').show());
		initCallback = SCS.carousel.initThumbnailsCarouselCallback;
	} else {
		carouselContainer.find('ul.carousel-list > li').show().width(carouselContainer.closest('.carouselContainer').width());
		initCallback = SCS.carousel.initCarouselCallback;
	}

	carouselContainer.scCarousel({
		onAfterInit: function (instance) {
			// restore deeplink to this carousel-index from URL hash
			var deeplinkPosition = window.SCS.HashDeepLink.get('carousel');
			if (deeplinkPosition && carouselContainer.attr('data-deeplinks-enabled') === 'true') {
				instance.slideTo(parseFloat(deeplinkPosition, 10));
			}

            // sliding
      		var self = instance,
                $slideLink = $('.carousel a.carousel-slide-to-link');

            $slideLink.click(function() {
        	   	self.slideTo($(this).data('slideto'));
            });


			initCallback.apply(this, arguments);
		},
		onBeforeAnimation: function (instance, outElement, inElement) {
			buttons.hide();
			SCS.carousel.deactivateVideos(carouselContainer);
		},
		onAfterAnimation: function (instance, outElement, inElement) {
			buttons.show();
			SCS.carousel.activateVideo($(inElement));

			// set deeplink to this carousel-index in URL hash
			if (carouselContainer.attr('data-deeplinks-enabled') === 'true') {
				window.SCS.HashDeepLink.set('carousel', instance.position);
			}
		}
	});
	var mouseenter = false;
	labels.show();

	carouselContainer
		.mouseenter(function () {
			buttons.show();
			mouseenter = true;
		})
		.mouseleave(function () {
			mouseenter = false;
			setTimeout(function() {
				if(!mouseenter) {
					buttons.hide();
					labels.show();
				}
			}, 300);
		});
};

/**
 * Initializations after the CATALOGUE-carousel is ready
 * @param carousel Carousel object
 */
var imageLoaded = __webpack_require__(4).imageLoaded;
SCS.carousel.initCarouselCallback = function(carousel) {

	var images = [];
	carousel.listItems.each(function () {
		$(this).find('img').each(function(i, img) {
			images.push(imageLoaded(img));
		});
	});
	Promise.all(images).then(function() {
		SCS.carousel.adjustArrowNavigationPosition(carousel);
	});

	SCS.carousel.adjustArrowNavigationPosition(carousel);

	var duration = carousel.container.find('.carousel-clip').data('duration');
	if (duration) {
		var updateTimerCallback = function (timer) {
				if (!timer) {
					clearTimeout(carousel.container.data('autoSlideTimeout'));
				}
				carousel.container.data('autoSlideTimeout', timer);
			},
			start = function () {
				SCS.carousel.autoSlide(carousel, duration, updateTimerCallback);
			},
			stop = function () {
				updateTimerCallback(null);
			},
			$hoverElem = carousel.container.find('.carousel-clip').one("mousemove", function() {
				// handle case when mouse is already over the stage after page load
				if ($hoverElem.is(":hover")) {
					stop();
				}
			})
				.mouseenter(stop)
				.mouseover(stop)
				.mouseleave(start);
		start();
	}

	SCS.carousel.circleNavigationInit(carousel);
};

/**
 * @param carousel the carousel to be rotated
 * @param duration rotation-duration in sec
 * @param updateTimerCallback Callback to update timer. This is required to allow to place stage auto rotate carousel and one additional in the content.
 */
SCS.carousel.autoSlide = function(carousel, duration, updateTimerCallback) {
	updateTimerCallback(null);
	var timer = setTimeout(function() {
		var active = carousel.pagingItems.filter('.selected').index();
		if (carousel.stepSize) {
			carousel.showNext(true);
		} else {
			var next = (active + 1 === carousel.pagingItems.length) ? 0 : active + 1;
			carousel.pagingItems.blur().eq(next).click();
		}
		SCS.carousel.autoSlide(carousel, duration, updateTimerCallback);
	}, duration * 1000);
	updateTimerCallback(timer);
};

/**
 * Initializations after the THUMBNAIL-carousel is ready
 * @param carousel Carousel object
 */
SCS.carousel.initThumbnailsCarouselCallback = function(carousel) {
	carousel.container.find('.carousel-item').width(carousel.container.width());
	SCS.carousel.overlayThumbnailNavigationInit(carousel);
	SCS.carousel.thumbnailNavigationInit(carousel);
};

/**
 * Paging / Circle-navigation
 * @param carousel Carousel object
 */
SCS.carousel.circleNavigationInit = function(carousel) {
	/* todo: why is this done with JS instead of CSS? */
	var pagingContainer = carousel.container.find('.carousel-control');
	if (pagingContainer.is('.stage .normalCarouselContainer .carousel-control')) {
		pagingContainer.css('margin-left', '-' + Math.round(pagingContainer.width() / 2) + 'px');
	}
};

/**
 * Show / hide overlayed thumbnails
 * @param carousel Carousel object
 */
SCS.carousel.overlayThumbnailNavigationInit = function(carousel) {
	if (carousel.container.closest('.stage').length === 0) {
		// abort: we don't have the overlay navigation setting
		return;
	}
	var thumbnails = carousel.container.find('.thumbnailsCarousel');
	var timeoutId;
	carousel.container
		.mouseenter(function() {
			window.clearTimeout(timeoutId);
			thumbnails.slideDown();
		})
		.mouseleave(function() {
			timeoutId = window.setTimeout(function() {
				thumbnails.slideUp();
			}, 200);
		});
	// initially display thumbnails and hide them after 5 seconds
	thumbnails.slideDown();
	timeoutId = window.setTimeout(function() {
		thumbnails.slideUp();
	}, 5000);
};

/**
 * Thumbnail-navigation
 * @param carousel Carousel object
 */
SCS.carousel.thumbnailNavigationInit = function(carousel) {
	var container = carousel.container,
		$carouselYouTube = container.html().indexOf('youtube'),
		linkItems = container.find('a.carousel-link');

	linkItems
		.each(function (i) {
			$(this).data('index', i);
		})
		.on('click', function(e) {
			e.preventDefault();
			var $this = $(this);

			// do nothing if the clicked item is a placeholder (placeholders are needed for correct styling)
			if ($this.is('.placeholder')) {
				return;
			}

			// hide all items and stop all videos
			var allItems = container.find('.items .item');
			SCS.carousel.deactivateVideos(allItems);

			// Check for YouTube video
			if ($carouselYouTube != '-1') {
				allItems.addClass('useVisibility', 1000);
			} else {
				allItems.hide();
			}

			// display the new item, show text and start video if text or video is present in the current item
			var newItem = allItems.eq($this.data('index')).removeClass('useVisibility').show();
			if (container.closest('.videoWithText').length) {
				var text = newItem.find('.videoText').html();
				newItem.closest('.col_two').find('.two').html(text);
			}

			SCS.carousel.activateVideo(newItem, $carouselYouTube);

			// mark clicked item as active
			$this.closest('ul').find('a.selected').removeClass('selected');
			$this.addClass('selected');

			// set deeplink to this item-index in URL hash
			if (container.attr('data-deeplinks-enabled') === 'true') {
				window.SCS.HashDeepLink.set('carousel-thumbnail', linkItems.index($this));
			}
		});

	// initially show the first item OR restore deeplink to item from URL hash
	var deeplinkPosition = window.SCS.HashDeepLink.get('carousel-thumbnail'),
		initialActiveItem = linkItems.eq((deeplinkPosition && container.attr('data-deeplinks-enabled') === 'true') ? deeplinkPosition : 0);
	initialActiveItem.trigger('click');
};

SCS.carousel.deepLinks = function() {
    // initially show the first item OR restore deeplink to item from URL hash
    var deeplinkPosition = window.SCS.HashDeepLink.get('carousel-thumbnail');
        //initialActiveItem = linkItems.eq((deeplinkPosition && container.attr('data-deeplinks-enabled') === 'true') ? deeplinkPosition : 0);
        console.log("Informations about deepLinks");
        console.log(deeplinkPosition);
    //initialActiveItem.trigger('click');
}

/**
 * Stop playing all videos
 * @param item jQuery-object container to search for videos (in any depth, not just children)
 */
SCS.carousel.deactivateVideos = function(item) {
	item.find('.scs-media-player').each(function() {
		var itm = $(this);
		var player = itm.mediaPlayer();
		if(itm.data('wasPlaying') === null) {
			itm.data('wasPlaying', player.info.state.playing);
		}
		player.callbacks.playPause(false);
	});

	item.find('.modBrightcoveVideo').each(function() {
		var itm = $(this);
		var player = itm.data("brightcove-api");
		if(!player)
			return;
		if(itm.data('wasPlaying') === null) {
			itm.data('wasPlaying', player.isPlaying());
		}
		player.pause();
	});

	return item;
};

/**
 * Start playing a single video
 * @param item jQuery-object container to search for videos (in any depth, not just children)
 */
SCS.carousel.activateVideo = function(item, youtube) {
	var itm = item.find('.scs-media-player:first');
	var player;
	if(itm.mediaPlayer && (player = itm.mediaPlayer())) {
		if (player.controller) {
			player.controller.recalc();
		}

		if (youtube == '-1') {
			player.callbacks.playPause(itm.data('wasPlaying') === true);
			itm.data('wasPlaying', null);
		}
	}

	itm = item.find('.modBrightcoveVideo:first');
	if(player = itm.data("brightcove-api")) {
		if(!player)
			return;
		if (itm.data('wasPlaying') === true) {
			player.play();
		}
		itm.data('wasPlaying', null);
	}


	return item;
};

/**
 * Adjust position of left / right navigation buttons
 * @param carousel Carousel object
 */
SCS.carousel.adjustArrowNavigationPosition = function(carousel) {
	var container = carousel.container;
	var listTop = carousel.clip.position().top;
	var maxHeight = 0;
	carousel.listItems.each(function () {
		maxHeight = Math.max(maxHeight, $(this).outerHeight());
	});

	// if content is not yet loaded, please redo it again, because height < 20 is wrong for sure.
	if(maxHeight < 20 && carousel.listItems.length > 0) {
		setTimeout(function() { SCS.carousel.adjustArrowNavigationPosition(carousel); }, 200);
	} else if(maxHeight > 0) {
		if (carousel.container.hasClass('smart-arrows')) {
			var $window = $(window);
			$window.scroll(function () {
				scrollTop = $window.scrollTop();
				var vpHeight = $window.height(),
				    listTop = carousel.clip.position().top,
				    contHeight = carousel.clip.height(),
				    listOffTop = carousel.clip.offset().top,
				    buttonHeight = carousel.prevButton.height();
				var position = Math.round(listTop) + Math.round((maxHeight - buttonHeight) / 2);
				position = Math.max(position, scrollTop - listOffTop + buttonHeight);
				position = Math.min(position, contHeight - buttonHeight);
				// position is outside (below) the viewport
				if (listOffTop + position > scrollTop + vpHeight - buttonHeight) {
					position = scrollTop + vpHeight - buttonHeight - listOffTop;
					if (position < buttonHeight) position = buttonHeight;
				}
				carousel.prevButton.add(carousel.nextButton).css({
					'top': position + 'px'
				});
			});
		} else {
			carousel.prevButton.add(carousel.nextButton).css({
				'top': Math.round(listTop) + Math.round((maxHeight - carousel.prevButton.height()) / 2) + 'px'
			});
		}
	}
};

// Initialize carousels on dom-ready and/or jquery-load
SCS.ensure(SCS.carousel.initCarousels, 'body, .ui-tabs-panel, .modTabNavigationContent, .modLazyContainer');

// Update carousels when elements have been shown
$(document).on('element-shown', function(event, el) {
	el.find(':data(scCarousel)').each(function() {
		var $carouselContainer = $(this),
			carousel = $carouselContainer.data('scCarousel');

		if(carousel.updateNavigationWidth) {
			carousel.updateNavigationWidth();
		}

		if ($carouselContainer.hasClass('normalCarouselContainer')) {
			carousel.listItems.width(carousel.listItemWidth);
		}

		SCS.carousel.adjustArrowNavigationPosition(carousel);

		if ($carouselContainer.hasClass('catalogueCarouselContainer')) {
			carousel.listItems.width(carousel.listItemWidth);
			$catalogueCarouselImages = $('.scs-boxmovingproductteaser-image img', $carouselContainer);
			catalogueCarouselImagesNo = $catalogueCarouselImages.length;
			$catalogueCarouselImages.each(function(index) {
				$productTeaserImage = $(this);
				if (this.complete || /*for IE 10-*/ $productTeaserImage.height() > 0) {
					++index;
				} else {
					$productTeaserImage.on('load', function() {
						++index;
					});
				}

				if (catalogueCarouselImagesNo === index) {
					SCS.portal.synchronizeTeaserHeights('.carouselContainer', '.scs-boxmovingproductteaser', el);
				}
			});
		}
		// Check if it was opened before
		if ($carouselContainer.css('opacity') === '0') {
			$carouselContainer.css('opacity', 1);
		}
	});
});

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_$) {/**
 * Scene 7 Player Integration for ecommerce product detail pages.
 *
 * @author Marc Althoff, Yves DeBrune
 * @namespace SCS.scene7
 */
(function ($, SCS) {
	'use strict';
	// read only:
	/* globals container, Set1, Set2, s7width, s7height, s7params, s7sdk, s7flyoutzoomview, s7zoomview, s7spinview */
	// read-write:
	/* globals s7swatches:true, s7ZoomMode:true */
	/* jshint camelcase: false */

	SCS.scene7 = SCS.scene7 || {};
	$(function () {

		/**
		 * Get a spinset from the server, calls getMediaSets_spinset
		 *
		 * @method SCS.scene7.getMediaSet_1
		 */
		SCS.scene7.getMediaSet_1 = function () {
			if (Set1.length) {
				s7params.params.asset = Set1;
				SCS.scene7.Set1 = new s7sdk.MediaSet(null, s7params, null);
				SCS.scene7.Set1.addEventListener(s7sdk.AssetEvent.NOTF_SET_PARSED, SCS.scene7.getMediaSet_2, false);
			} else {
				SCS.scene7.getMediaSet_2();
			}
		};

		/**
		 * Get a spinset from the server, calls onSetsParsed
		 *
		 * @method SCS.scene7.getMediaSet_2
		 */
		SCS.scene7.getMediaSet_2 = function () {
			if (Set2.length) {
				s7params.params.asset = Set2;
				SCS.scene7.Set2 = new s7sdk.MediaSet(null, s7params, null);
				SCS.scene7.Set2.addEventListener(s7sdk.AssetEvent.NOTF_SET_PARSED, SCS.scene7.onSetsParsed, false);
			} else {
				SCS.scene7.onSetsParsed();
			}
		};

		/**
		 * Event Handler called after the Scene 7 Sets are parsed
		 *
		 * @method SCS.scene7.onSetsParsed
		 * @param {Object} e event
		 */
		SCS.scene7.onSetsParsed = function () {
			var	compAsset = new s7sdk.MediaSetDesc(0, 0, s7sdk.ItemDescType.MEDIA_SET, '', '');

			SCS.scene7.addSetToComposite(compAsset, SCS.scene7.Set1);
			SCS.scene7.addSetToComposite(compAsset, SCS.scene7.Set2);

			// set media set for Swatches to display
			s7swatches = new s7sdk.Swatches('s7container', s7params, 'swatches');
			s7swatches.addEventListener(s7sdk.AssetEvent.SWATCH_SELECTED_EVENT, SCS.scene7.swatchSelected, false);
			s7swatches.setMediaSet(compAsset);
			SCS.scene7.alignSwatches(s7swatches, compAsset, s7params);

			// select the first swatch
			s7swatches.selectSwatch(0, true);

			container.addEventListener(s7sdk.ResizeEvent.COMPONENT_RESIZE, SCS.scene7.onResize, false);
			container.addEventListener(s7sdk.ResizeEvent.WINDOW_RESIZE, SCS.scene7.onResize, false);

			SCS.scene7.styleSwatches();
		};

		/**
		 * Adds styling (indicators for spinview and – later – video) to the swatches
		 *
		 * @method SCS.scene7.styleSwatches
		 */
		SCS.scene7.styleSwatches = function () {
			// Parse the swatches element and check for videos / 360 spinsets
			var spinSnippet = '<div class="spinner"></div>',
				mySwatches = s7swatches.filteredSet_;

			for (var key in mySwatches) {
				if (mySwatches.hasOwnProperty(key)) {
					if (+mySwatches[key].type === 8) {
						$('#s7container #swatches div div').eq(0).addClass('container');
						$('#s7container #swatches .container > div').eq(key).css({
							'position': 'absolute'
						}).append(spinSnippet);
					}
				}
			}
		};

		/**
		 * Adds a mediaset (e.g. an imageset and a spinset) to a Scene7 "Composite"
		 *
		 * @method SCS.scene7.addSetToComposite
		 * @param {Object} composite
		 * @param {Object} set
		 */
		SCS.scene7.addSetToComposite = function (composite, set) {
			if (set) {
				var	mset = set.mediaSetDesc_;

				if (mset.type === s7sdk.ItemDescType.IMAGE_SET) {
					for (var i = 0; i < mset.items.length; i+=1) {
						composite.items.push(mset.items[i]);
					}
				} else {
					composite.items.push(mset);
				}
			}
		};

		/**
		 * change the image displayed in the main view every time the swatch selection changes
		 *
		 * @method SCS.scene7.swatchSelected
		 * @param {Object} e event
		 */
		SCS.scene7.swatchSelected = function (e) {
			var asset = e.s7event.asset,
				type = asset.type;

			// Hide all
			$('#flyoutzoomview').hide();
			$('#zoomview').hide();
			$('#spinview').hide();
			$('.spinsetSpinner').hide();

			if (+type === 1) { // ImageSet

				// always set asset in both viewers
				s7flyoutzoomview.setItem(asset);
				s7zoomview.setItem(asset);

				if (s7ZoomMode === 'ZoomView') {
					$('#zoomview').show();
				}

				if (s7ZoomMode === 'FlyoutZoomView') {
					$('#flyoutzoomview').show();
				}

				return;
			}

			if (+type === 8) { // SpinView
				s7params.params.asset = asset.name;
				s7spinview.setMediaSet(asset);


				$('.spinsetSpinner').show();
				$('.spinsetSpinner').slider('destroy').slider({
					animate: 'fast',
					max: s7spinview.getFramesLength() - 1,
					slide: SCS.scene7.sliderToSpinnerSync,
					start: SCS.scene7.sliderStartDrag,
					stop: SCS.scene7.sliderStopDrag
				}).data('s7spinview', s7spinview);

				$('#spinview').show();

				setTimeout(
					function () {
						// jump to "first" (technically last) frame
						$('.spinsetSpinner').data('s7spinview').setCurrentFrameIndex(s7spinview.getFramesLength() - 1);
					}, 100
				);

				return;
			}
		};

		/**
		 * Slider helper function on drag
		 *
		 * @method SCS.scene7.sliderStartDrag
		 * @param {Object} event
		 */
		SCS.scene7.sliderStartDrag = function () {
			$(this).data('isDragging', true);
		};

		/**
		 * Slider helper function on drag
		 *
		 * @method SCS.scene7.sliderStopDrag
		 * @param {Object} event
		 * @param {Object} ui
		 */
		SCS.scene7.sliderStopDrag = function () {
			$(this).data('isDragging', false);
		};

		/**
		 * syncs slider movement to the spinner
		 *
		 * Spinsets should adhere to the following logic:
		 * - 36 frames
		 * - start with frame 0 = Front
		 * - end with frame 35 (10° left to front)
		 * - rotation is counterclockwise around the z axis (you "push" on the right side of the device to get to frame n + 1)
		 *
		 * @method SCS.scene7.sliderToSpinnerSync
		 * @param {Object} event
		 */
		SCS.scene7.sliderToSpinnerSync = function (event, ui) {
			var $ctx = $(this),
				gotoFrame = (s7spinview.getFramesLength() - 1) - ui.value;

			if (gotoFrame >= 0) {
				$ctx.data('s7spinview').setCurrentFrameIndex(gotoFrame);
			}
		};

		/**
		 * syncs spinner movement to the slider
		 *
		 * @method SCS.scene7.spinnerToSliderSync
		 * @param {Object} e event
		 */
		SCS.scene7.spinnerToSliderSync = function (e) {
			var frame = e.s7event.frame,
				gotoFrame = (s7spinview.getFramesLength() - 1) - frame,
				slider = $('.spinsetSpinner');

			if (gotoFrame >= 0) {
				if (!slider.data('isDragging')) {
					slider.slider('option', 'value', gotoFrame);
				}
			}
		};

		/**
		 * Aligns the swatches after the set is parsed
		 *
		 * @method SCS.scene7.alignSwatches
		 * @param {Object} inSwatches
		 * @param {Object} inMediaSetDesc
		 * @param {Object} inParams
		 */
		SCS.scene7.alignSwatches = function (inSwatches, inMediaSetDesc) {
			var tw = parseInt(s7sdk.Util.css.getCss('s7thumb', 'width', inSwatches.id, 's7swatches'), 10),
				dw = Number(inSwatches.cellSpacing.horizontalSpacing),
				width = inMediaSetDesc.items.length * (tw + dw) + dw,
				swWidth = width,
				swHeight = inSwatches.obj.getHeight(),
				contr = document.getElementById('s7container');
			if ((width > contr.offsetWidth)) {
				swWidth = contr.offsetWidth;
			} else if ((width <= contr.offsetWidth)) {
				swWidth = width;
			}

			if (contr.offsetHeight < inSwatches.obj.getHeight()) {
				swHeight = contr.offsetHeight;
			}
			inSwatches.resize(swWidth, swHeight);
			inSwatches.obj.style.left = (contr.offsetWidth - inSwatches.obj.getWidth()) / 2 + 'px';
		};

		/**
		 * Toggles between the fullscreen ZoomView and the standard view
		 * by enabling various DOM elements
		 *
		 * @method SCS.scene7.toggleZoomView
		 */
		SCS.scene7.toggleZoomView = function () {
			$('#s7containerContainer').toggleClass('zoomView');

			if (s7ZoomMode === 'FlyoutZoomView') {
				// default -> wechsel in ZoomView
				$('#scs-pageheader-logo a').css({
					'zIndex': 9999,
					'position': 'absolute',
					'left': '50px'
				});
				$('body').css({
					'overflow': 'hidden'
				});
				$('#flyoutzoomview').hide();

				// ... and enter 'full window' overlay mode
				var size = SCS.scene7.getWindowSize();
				container.resize(size.w, size.h);
				s7swatches.resize(size.w - 2, 90); // s7swatches.size.height

				s7zoomview.resize(size.w, size.h);
				s7spinview.resize(size.w, size.h);

				if ($('#spinview').css('display') === 'block') {
					$('#zoomview').hide();
				} else {
					$('#spinview').hide();
					$('#zoomview').show();
				}

				// switch zo Zoomview ...
				s7ZoomMode = 'ZoomView';

			} else {
				$('#scs-pageheader-logo a').css({
					'zIndex': 9999,
					'position': 'relative',
					'left': 'auto'
				});
				$('body').css({
					'overflow': 'visible'
				});

				// switch zo FlyoutZoomView ...
				s7ZoomMode = 'FlyoutZoomView';
				container.resize(s7width, s7height);
				s7flyoutzoomview.resize(s7width, s7height); // ?
				s7swatches.resize(s7width - 2, 360);
				s7spinview.resize(s7width, s7height);

				$('#zoomview').hide();

				if ($('#spinview').css('display') !== 'block') {
					$('#spinview').hide();
					$('#flyoutzoomview').show();
				}
			}

			SCS.scene7.styleSwatches();
		};

		/**
		 * Event Handler function for toggleZoomView
		 *
		 * @method SCS.scene7.onResize
		 * @param {Object} event
		 */
		SCS.scene7.onResize = function (event) {
			if ((s7ZoomMode === 'ZoomView' && event.type === 'windowResize') || (event.type === 'componentResize')) {
				// only when changing viewmodes
				if (s7ZoomMode === 'ZoomView') {
					if (container) {
						container.resize(event.s7event.w, event.s7event.h);
					}
				}
				if (s7swatches) {
					s7swatches.resize(event.s7event.w - 2, s7swatches.size.height); // Exclude the border width (2px)
				}
				if (s7spinview) {
					s7spinview.resize(event.s7event.w, event.s7event.h);
				}
				if (s7zoomview) {
					s7zoomview.resize(event.s7event.w, event.s7event.h);
				}
			}
		};

		/**
		 * Helper function for toggleZoomView - getWindowSize
		 *
		 * @method SCS.scene7.getWindowSize
		 * @param {Object} event
		 */
		SCS.scene7.getWindowSize = function () {
			var	size = new s7sdk.Point2D(),
				winW = 630,
				winH = 460;

			if (document.body && document.body.offsetWidth) {
				winW = document.body.offsetWidth;
				winH = document.body.offsetHeight;
			}
			if (document.compatMode === 'CSS1Compat' &&
				document.documentElement &&
				document.documentElement.offsetWidth) {
				winW = document.documentElement.offsetWidth;
				winH = document.documentElement.offsetHeight;
			}
			if (window.innerWidth && window.innerHeight) {
				winW = window.innerWidth;
				winH = window.innerHeight;
			}

			size.w = winW;
			size.h = winH;
			return size;
		};

	});

})(__webpack_provided_window_dot_$, window.SCS = window.SCS || {});

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_$, __webpack_provided_window_dot_jQuery, __webpack_provided_window_dot_scsHeaderJQuery) {(function($, SCS) {
	'use strict';

	// definitions
	var padding = 50; // total padding (left + right) -> will be subtracted when setting the width of the dialog
	var notificationWidth = 310;
	var dialogWidth = 470;

	var dialogStack = [];
	var currentDialog;

	function calculateWidth(options, element) {
		if(options.width && options.width !== 'auto') {
			return options.width;
		}
		if(element.is('.small')) {
			return notificationWidth - padding;
		}
		var isWideDialog = element.is('.wide') || element.find('img').length > 0;
		if(!isWideDialog) {
			for(var i in options.buttons) {
				if (i !== 'length') {
					// TODO: Describe why having a button named “length” matters…
					isWideDialog = true;
					break;
				}
			}
		}
		return (isWideDialog ? dialogWidth : notificationWidth) - padding;
	}

	// default settings
	$.ui.dialog.prototype.options.modal = true;
	$.ui.dialog.prototype.options.draggable = false;
	$.ui.dialog.prototype.options.resizable = false;
	$.ui.dialog.prototype.options.width = 'auto';
	$.ui.dialog.prototype.options.minHeight = false;
	$.ui.dialog.prototype.options.closeText = '';

	// recalculate position and apply -> provide a function that can be called like this: $(dom-element).dialog('reposition');
	$.ui.dialog.prototype.reposition = $.ui.dialog.prototype._position;

	// embed internal dialog-creation function to detect dom-element states before the dialog is created
	var originalDialogCreateFunction = $.ui.dialog.prototype._create;
	$.ui.dialog.prototype._create = function() {
		// set width of the dialog according to its type (design says
		// notifications (no buttons, no content-images) should have a with
		// of 300 pixels and dialogs (has buttons and/or images in content)
		// 460 pixels) -> this default-setting is overridable by setting a
		// width as option when creating the dialog
		// detect if the content element for the dialog is virtual or part of the dom (will be removed from dom after closing the dialog if it is virtual)
		this.options.width = calculateWidth(this.options, this.element);
		if (this.element.parent().length) {
			this.element.data('dialogOriginalClass', this.element.attr('class'));
			this.element.data('dialogOriginalStyle', this.element.attr('style'));
		} else {
			this.element.data('dialogRemoveFromDomAfterClose', true);
		}
		originalDialogCreateFunction.apply(this, arguments);
	};


	// embed internal dialog-opener function to connect the background-overlay to its corresponding dialog
	var originalDialogOpenFunction = $.ui.dialog.prototype.open;
	$.ui.dialog.prototype.open = function() {
		originalDialogOpenFunction.apply(this, arguments);
		this.overlay.data('myCorrespondingDialog', this.element);
		var $dialog = $(this.element);
		if (!$dialog.data('openedOnce')) {
			this.option('position', {my: 'center', at: 'center', of: window});
			SCS.utils.initNewModules(this.element);
			$dialog.on('changed.content', function() {
				$dialog.dialog('reposition');
			});
			$dialog.data('openedOnce', true);
		}
		// fix for jquery 1.11 incompatibility
		this.element.parent().find('button').each(function(){
			var button = $(this),
				labelText = button.attr('text');
			if(labelText){
				button.text(labelText);
			}
		});
		if (currentDialog) {
			dialogStack.push(currentDialog);
			currentDialog.uiDialog.hide();
			currentDialog.overlay.hide();
		}
		currentDialog = this;
	};

	$(function($) {
		// Add listeners to keep dialog centered on window resize and scroll
		$(document).on('dialogopen', function(event) {
			var $el = $(event.target);
			var $dialogContent = $('.ui-dialog-content', $el);
			// Add .no-center-on-scroll class to your .ui-dialog-content to prevent the dialog centering on window scroll.
			// Useful for longer dialog forms on iPad and similar cases.
			var events = ['resize', !$dialogContent.is('.no-center-on-scroll') && 'scroll'].filter(Boolean).join(' ');
			function reposition() {
				// center the dialog on the screen on scroll or window-resize
				$el.dialog('reposition');
			}
			$(window).on(events, reposition);
			$el.one('dialogclose', function() {
				$(window).off(events, reposition);
				currentDialog = undefined;
				if (dialogStack.length > 0) {
					currentDialog = dialogStack.pop();
					currentDialog.uiDialog.show();
					currentDialog.overlay.show();
					currentDialog.element.dialog('reposition');
				}
			});
		});


		$(document).on('dialogclose', function(event) {
			var el = $(event.target);
			if ((window.SCS && window.SCS.ecommerce) || !el.closest('.ui-dialog').is('.scs-pageheader-ui-dialog')) {
				// Prevent the rest of the close handler (which destroys the dialog) from runing
				return;
			}

			// destroy the dialog by default (normally the dialog is just hidden, but removed from the dom)
			el.dialog('destroy');
			// if the content element for the dialog was virtual (remove it from the dom) or part of the dom (restore its original classes and styles) before creating the dilaog
			if (el.data('dialogRemoveFromDomAfterClose')) {
				el.remove();
			} else {
				if (el.data('dialogOriginalClass') && el.data('dialogOriginalClass').length) {
					el.attr('class', el.data('dialogOriginalClass'));
				}
				if (el.data('dialogOriginalStyle') && el.data('dialogOriginalStyle').length) {
					el.attr('style', el.data('dialogOriginalStyle'));
				} else {
					el.removeAttr('style');
				}
			}

			el.trigger('dialogAfterClose');
		});

		// close the dialog if the corresponding background-overlay is clicked
		$(document).on('click', '.scs-pageheader-ui-dialog + .ui-widget-overlay', function() {
			if (!$(this).data('myCorrespondingDialog')) {
				return true;
			}
			$(this).data('myCorrespondingDialog').dialog('close');
		});

	});

})(__webpack_provided_window_dot_$ || __webpack_provided_window_dot_jQuery || __webpack_provided_window_dot_scsHeaderJQuery, window.SCS);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0), __webpack_require__(0), __webpack_require__(0)))

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($, jQuery) {/**
 * (c) Copyright Swisscom (Schweiz) AG. All rights reserved.
 *
 * This product is the proprietary and sole property of Swisscom (Schweiz) AG
 * Use, duplication or dissemination is subject to prior written consent of
 * Swisscom (Schweiz) AG.
 *
 * $Id: forms.js
 */
$.namespace("SCS.portal.forms");

/**
 * Clear errors
 */
// used by Tc.Module.SmsEService
SCS.portal.forms.clearErrors = function() {
	$(".scs-form")
		.find(".field.error")
			.find(".error, .fullLengthError")
				.hide()
				.end()
			.removeClass("error")
			.end()
		.find(".headingError").closest(".field").hide();
};

/**
 * Make field and button fit into the full width of the form
 */
jQuery(function() {
	jQuery('.teaserform form.scs-form, .supportstrip form.scs-form').each(function() {
		var form = jQuery(this);
		var input = form.find(':input:not(:button, :submit)');
		var submit = form.find(':button, :submit');
		if(submit.parent()[0] !== form[0]) {
			submit = submit.parent();
		}
		var full = form.width();
		var space =
			parseInt(input.css('marginLeft'), 10) +
			parseInt(input.css('marginRight'), 10) +
			parseInt(input.css('paddingLeft'), 10) +
			parseInt(input.css('paddingRight'), 10) +
			parseInt(input.css('borderLeftWidth'), 10) +
			parseInt(input.css('borderRightWidth'), 10) +
			parseInt(submit.css('marginLeft'), 10) +
			parseInt(submit.css('marginRight'), 10) +
			parseInt(submit.css('paddingLeft'), 10) +
			parseInt(submit.css('paddingRight'), 10) +
			parseInt(submit.css('borderLeftWidth'), 10) +
			parseInt(submit.css('borderRightWidth'), 10);
		var submitWidth = submit.width();
		var tolerance = 6;
		input.css('width', (full - submitWidth - space - tolerance)+'px');
	});
});

/**
 * Handle DropDown Fields
 */
(function () {
	$(document).on('beforeInit.sSelect', function (e) {
		$(e.target).data('autoPosition', false);
	});
	$(document).on('afterInit.sSelect', function (e) {
		var list = $(e.target).parent().find('ul.newList');
		list.css({ 'position':'', 'top':'', 'left':'' }).wrap('<div class="newListWrapper" />');
		list.css('min-width', (list.closest('.newListSelected').outerWidth() - (list.outerWidth() - list.width())) + 'px');
	});
})();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0), __webpack_require__(0)))

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {/**
 * (c) Copyright Swisscom (Schweiz) AG. All rights reserved.
 *
 * This product is the proprietary and sole property of Swisscom (Schweiz) AG
 * Use, duplication or dissemination is subject to prior written consent of
 * Swisscom (Schweiz) AG.
 *
 * $Id: sitecatalyst.js
 */
$.namespace("SCS.siteCatalyst");

/**
 * NOTE: This file is hosted for web-clipped ECommerce pages
 */

SCS.siteCatalyst.track = function(data) {
	if ($('body').hasClass('cq_isEditMode') || !window.s) {
		return;
	}

	var siteCatalyst = window.s || window.s_one;
	if(data && data.siteCatalystEvent && siteCatalyst && siteCatalyst.t) {
		var pageName = siteCatalyst.pageName;
		var channel = siteCatalyst.channel;
		siteCatalyst.pageName = siteCatalyst.pageName + data.siteCatalystEvent.additionalPageNameExtension;
		siteCatalyst.channel = siteCatalyst.channel + data.siteCatalystEvent.additionalPageNameExtension;
		siteCatalyst.events = data.siteCatalystEvent.events;
		siteCatalyst.products = data.siteCatalystEvent.products;
		for (property in data.siteCatalystEvent.properties) {
			siteCatalyst[property] = data.siteCatalystEvent.properties[property];
		}
		siteCatalyst.t();
		siteCatalyst.pageName = pageName;
		siteCatalyst.channel = channel;
	}
};

//Track link clicks to SiteCatalyst
SCS.siteCatalyst.trackLink = function(data) {
	var siteCatalyst = window.s || window.s_one;

	if(data && data.siteCatalystLink && siteCatalyst && siteCatalyst.tl) {
		siteCatalyst.linkTrackVars = data.siteCatalystLink.linkTrackVars;
		
		// iterate through site catalyst properties and 
		// set them in the s array
		for(property in data.siteCatalystLink.properties) {
			siteCatalyst[property] = data.siteCatalystLink.properties[property];
		}

		// iterate through site catalyst evars and 
		// set them in the s array
		for(eVar in data.siteCatalystLink.eVars) {
			siteCatalyst[eVar] = data.siteCatalystLink[eVar];
		}
	
		// site catalyst link tracking call
		siteCatalyst.tl(this, data.siteCatalystLink.linkType, data.siteCatalystLink.link);
	}
};

SCS.siteCatalyst.addProduct = function(productString) {
	var siteCatalyst = window.s || window.s_one;

	if ($('body').hasClass('cq_isEditMode') || !siteCatalyst) {
		return;
	}	
	if (!SCS.siteCatalyst.isEmpty(siteCatalyst.products)) {
		siteCatalyst.products += ','+productString;
	} else {
		siteCatalyst.products = productString;
	}
};

SCS.siteCatalyst.isEmpty = function(str) {
	return (!str || 0 === str.length);
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {/**
 * (c) Copyright Swisscom (Schweiz) AG. All rights reserved.
 * 
 * This product is the proprietary and sole property of Swisscom (Schweiz) AG
 * Use, duplication or dissemination is subject to prior written consent of
 * Swisscom (Schweiz) AG.
 * 
 * $Id: userfeedback.js
 */

$.namespace("SCS.userfeedback");

var pageCookie = "pageCookie";
var yesFirstQuestionValue = "yesFirstQuestion";
var noFirstQuestionValue = "noFirstQuestion";
var yesSecondQuestionValue = "yesSecondQuestion";
var noSecondQuestionValue = "noSecondQuestion";

SCS.userfeedback.init = function(resourceId) {
	$(document).ready(function() {
		var cookieValue = $.cookie(pageCookie);
		if (cookieValue == null) {
			$("#scs-help-userfeedback-first-question-" + resourceId).show();
			$("#scs-help-userfeedback-second-question-" + resourceId).hide();
			$("#message-" + resourceId).hide();
			$("#chat-" + resourceId).hide();
		} else if (cookieValue == yesFirstQuestionValue) {
			$("#scs-help-userfeedback-first-question-" + resourceId).hide();
			$("#scs-help-userfeedback-second-question-" + resourceId).show();
			$("#message-" + resourceId).hide();
			$("#chat-" + resourceId).hide();
		} else {
			$("#scs-help-userfeedback-first-question-" + resourceId).hide();
			$("#scs-help-userfeedback-second-question-" + resourceId).hide();
			$("#message-" + resourceId).show();
		}
	});
};

function yesFirstQuestion(firstQuestion, resourceId) {
	var siteCatalyst = window.s || window.s_one;
	if (siteCatalyst && siteCatalyst.tl) {
		siteCatalyst.eVar52 = siteCatalyst.pageName;
		siteCatalyst.linkTrackVars = 'eVar52,events';
		siteCatalyst.linkTrackEvents = 'event56';
		siteCatalyst.events = 'event56';
		siteCatalyst.tl(this, 'o', firstQuestion);
	}
	$("#scs-help-userfeedback-first-question-" + resourceId).hide();
	$("#scs-help-userfeedback-second-question-" + resourceId).show();
	$.cookie(pageCookie, yesFirstQuestionValue, {
		expires : 2,
		path : window.location.pathname
	});
}

function noFirstQuestion(firstQuestion, resourceId) {
	var siteCatalyst = window.s || window.s_one;
	if (siteCatalyst && siteCatalyst.tl) {
		siteCatalyst.eVar52 = siteCatalyst.pageName;
		siteCatalyst.linkTrackVars = 'eVar52,events';
		siteCatalyst.linkTrackEvents = 'event57';
		siteCatalyst.events = 'event57';
		siteCatalyst.tl(this, 'o', firstQuestion);
	}

	$("#scs-help-userfeedback-first-question-" + resourceId).hide();
	$("#message-" + resourceId).hide();
	$("#chat-" + resourceId).show();
	$.cookie(pageCookie, noFirstQuestionValue, {
		expires : 2,
		path : window.location.pathname
	});
}

function yesSecondQuestion(secondQuestion, resourceId) {
	var siteCatalyst = window.s || window.s_one;
	if (siteCatalyst && siteCatalyst.tl) {
		siteCatalyst.eVar52 = siteCatalyst.pageName;
		siteCatalyst.linkTrackVars = 'eVar52,events';
		siteCatalyst.linkTrackEvents = 'event58';
		siteCatalyst.events = 'event58';
		siteCatalyst.tl(this, 'o', secondQuestion);
	}

	$("#scs-help-userfeedback-second-question-" + resourceId).hide();
	$("#message-" + resourceId).show();
	$.cookie(pageCookie, yesSecondQuestionValue, {
		expires : 2,
		path : window.location.pathname
	});
}

function noSecondQuestion(secondQuestion, resourceId) {
	var siteCatalyst = window.s || window.s_one;
	if (siteCatalyst && siteCatalyst.tl) {
		siteCatalyst.eVar52 = siteCatalyst.pageName;
		siteCatalyst.linkTrackVars = 'eVar52,events';
		siteCatalyst.linkTrackEvents = 'event59';
		siteCatalyst.events = 'event59';
		siteCatalyst.tl(this, 'o', secondQuestion);
	}

	$("#scs-help-userfeedback-second-question-" + resourceId).hide();
	$("#message-" + resourceId).show();
	$("#chat-" + resourceId).hide();
	$.cookie(pageCookie, noSecondQuestionValue, {
		expires : 2,
		path : window.location.pathname
	});
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {/**
 * (c) Copyright Swisscom (Schweiz) AG. All rights reserved.
 *
 * This product is the proprietary and sole property of Swisscom (Schweiz) AG
 * Use, duplication or dissemination is subject to prior written consent of
 * Swisscom (Schweiz) AG.
 *
 * $Id: forms.js
 */

// legacy
$.namespace('SCSC');
$.namespace('SCSC.forms');

SCSC.forms.isPlaceholderSupported = function() {
	var input = document.createElement("input");
	return ('placeholder' in input);
};

SCSC.forms.placeholderSupported = SCSC.forms.isPlaceholderSupported();

/**
 * Placeholder for form fields
 */
// used by SCS.supportstrip.init
SCSC.forms.placeholder = function() {
	var placeholderFieldFocussed = function () {
		var $this = $(this);
		if ($this.hasClass('placeholder')) {
			$this.removeClass('placeholder');
			if (!SCSC.forms.placeholderSupported && $this.val() == $this.attr('placeholder')) {
				$this.val('');
			}
		}
	};
	var placeholderFieldBlurred = function () {
		var $this = $(this);
		if ($this.val() == '') {
			if (!SCSC.forms.placeholderSupported) {
				$this.val($this.attr('placeholder'));
			}
			$this.addClass('placeholder');
		}
	};
	var getUninitialized = function () {
		return !$(this).data('placeholderInitialized');
	};
	$('.scs-form').find('input[placeholder][placeholder!=""], textarea[placeholder][placeholder!=""]').filter(getUninitialized)
		.focus(placeholderFieldFocussed)
		.blur(placeholderFieldBlurred).trigger('blur')
		.change(function () { // is called by UI when field is not focussed (eg. datefield)
			var $this = $(this);
			if (!$this.data('isChanging')) {
				$this.data('isChanging', true);
				placeholderFieldFocussed.call(this);
				placeholderFieldBlurred.call(this);
				$this.data('isChanging', false);
			}
		})
		.data('placeholderInitialized', true);

	$('form').filter(getUninitialized)

		// Adserver 21,22 - Order-Tracking - Form-Tracking - Item #3374
		// quick and dirty for old forms
		.each(function() {
			// write success URL to data attribute
			var $form = $(this),
				$scsForm = $form.find('.scs-form'),
				redirectUrl = $form.find('input[type="hidden"][name=":redirect"]').val() || '';

			if ($scsForm.length) {
				if (redirectUrl.length) {
					$scsForm.data('success-url', redirectUrl);
					debug.log('Form-Tracking: using form :redirect', $scsForm.data('success-url'));
				} else {
					$scsForm.data('success-url', $form.attr('action'));
					debug.log('Form-Tracking: using form action', $scsForm.data('success-url'));
				}
			}
		})
		.submit(function() {
			var $form = $(this);
			$form.find('.placeholder').each(function() {
				placeholderFieldFocussed.call(this);
			});

			// Adserver 21,22 - Order-Tracking - Form-Tracking - Item #3374
			// quick and dirty for old forms
			// raise success event
			$form.find('.scs-form').trigger('formsuccess');

		})
		.data('placeholderInitialized', true);
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery) {/**
 * For custom checkboxes with the following html structure:
 *
 * <div class="custom-checkbox">
 *		<label><input type="checkbox" data-role="none" />Click me</label>
 * </div>

 span.checkbox-control holds the custom checkbox image. The image is used from the sprite in
 forms/ui/src/main/content/jcr_root/etc/designs/forms/clientlibs/desktop/css/base/form-sprites-generated.less

 .custom-checkbox label .checkbox-control {
	 background-image: url('@{imgPath}sprites/sprites-lores-1375968538552.png');
	 background-position: left -18px;
	 height: 13px;
	 width: 13px;
 }

 .custom-checkbox label.checked .checkbox-control {
	  background-image: url('@{imgPath}sprites/sprites-lores-1375968538552.png');
	 background-position: left -31px;
	 height: 13px;
	 width: 13px;
 }

 * Usage: $('input:checkbox').scsCustomCheckbox();
 * @author Thomas Junghans
 */
;(function ($, window, undefined ) {
	"use strict";

	var setCheckbox = function ($el) {
		var isChecked = $el.prop('checked'),
			$label = $el.parent('label');

		if ($el.is(':checkbox')) {
			if ($label.find('span.checkbox-control').length === 0) {
				$el.after('<span class="checkbox-control" role="checkbox" data-role="none"></span>');
			}

			$label.toggleClass('checked', isChecked).find('span.checkbox-control').attr('aria-checked', isChecked);
		}
	};

	$.fn.scsCustomCheckbox = function() {

		// Prevent text selection.
		// See also http://stackoverflow.com/questions/880512/prevent-text-selection-after-double-click
		this.each(function () {

			var $el = $(this);

			$el.parent('label').mousedown(function(){ return false; });

			setCheckbox($el);

		});

		this.change(function () {
			setCheckbox($(this));
		});

		return this;
	};
}(jQuery, window));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["isIE11"] = isIE11;
/**
 * Detect Internet Explorer 11
 */
function isIE11() {
    return !!window.MSInputMethodContext && !!document.documentMode;
}


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_jQuery) {/**
 * Created by Dimitri Sebeschuk on 10.07.15.
 */
/* globals SCS, debug, peakProtectObj */
(function ($) {
	'use strict';

	var deparam = __webpack_require__(8).default;

	/**
	 *
	 * @constructor
	 */
	var SCSPeakProtection = function () {
		var mod = this;
		mod.init();
	};

	function triggerProtectionLifted() {
		var event;
		try {
			event = new Event('peak-protection-lifted');
		} catch(e) {
			// Fallback for IE
			event = document.createEvent('Event');
			event.initEvent('peak-protection-lifted', false, false);
		}
		document.documentElement.dispatchEvent(event);
		$('.modOCEAngularApp').removeAttr('data-protected');
	}

	SCSPeakProtection.prototype = {

		EXCEPTION_REDIRECT_PAGE: 'http://www.swisscom.ch',

		COOKIE_PREFIX: 'AcpAT-v3-',

		COOKIE_TARGET_URL: 'SCS-pp-tu41',

		MESSAGE_KEY: 'peakmsg',

		AJAX_IGNORE_URL_EXTENSIONS: ['js'],

		//Swisscom cookie
		//120 Seconds
		DEFAULT_COOKIE_TIMEOUT: 120,
		COOKIE_NAME: 'x-pkprtct',
		COOKIE_VALUE: 'scs',

		/**
		 * Call in constructor
		 */
		init: function () {
			$.ajaxSetup({
				//Case ECommerce AJAX call
				timeout: SCS.ajaxTimeout,
				global: true
			});
		},

		/**
		 * Call on document ready
		 */
		/* jslint maxstatements: 40 */
		on: function () {
			var mod = this;

			mod.ctx = $('body');

			mod.ajaxRequestQueue = [];

			mod.enabled = mod.ctx.data('peakprotect-enabled');
			mod.isMobile = SCS.utils.isMobilePage();

			//Peak Protect page 
			mod.peakprotectPage = mod.ctx.data('peakprotect-page');

			mod.ajaxUrls = mod.ctx.data('peakprotect-ajax-url-prefixes') || [];
			mod.showExceptionMessage = mod.ctx.data('peakprotect-show-exception-message');
			mod.exceptionMessage = mod.ctx.data('peakprotect-exception-message');
			mod.exceptionPageUrl = mod.ctx.data('peakprotect-exception-page-url');
			if (!mod.exceptionPageUrl || !mod.exceptionPageUrl.length) {
				mod.exceptionPageUrl = mod.EXCEPTION_REDIRECT_PAGE;
			}
			mod.ajaxRepeatMsg = mod.ctx.data('peakprotect-repeat-message');
			if (!mod.ajaxRepeatMsg || !mod.ajaxRepeatMsg.length) {
				mod.ajaxRepeatMsg = 'Please try your action again.';
			}

			//mod.jsDownloadUrl = '/mockpeakprotect/filter.js';
			mod.jsDownloadUrl = mod.ctx.data('peakprotect-js-download-url');
			if (!mod.jsDownloadUrl || !mod.jsDownloadUrl.length) {
				mod.enabled = false;
			}

			mod.isEditMode = $('body').hasClass('cq_isEditMode');

			if (mod.isEditMode || location.host === 'internal.swissptt.ch') {
				mod.enabled = false;
			}

			mod.ajaxPrefilterActive = false;
			mod.ctx.on('clipping', $.proxy(mod.reInitClipping, mod));

			mod.clippings = $('.scs-clipping-peakprotect');

			if(!mod.enabled) {
				//display clipping, break script
				mod.enableClipping();
				return;
			}
			
			if (mod.peakprotectPage) {
				//Peakprotect page, we need always to redirect
				mod.processProtectPage();
				return;
			}

			mod.showMessage();

			if(mod.clippings.length){
				mod.loadScript(mod.processCallback, $.proxy(mod.enableClipping, mod));
			} else {
				mod.loadScript(triggerProtectionLifted);
			}

			if (!mod.clippings.length && !mod.isProtectAjaxUrl(window.location.href)) {
				//clipping not found
				mod.ajaxPrefilterActive = true;
				$.ajaxPrefilter($.proxy(mod.onAjaxPrefilter, mod));
				return;
			}
		},

		//Fix for Lazy loading by tabs & ... components
		reInitClipping: function () {
			debug.log('SCS.PeakProtect > reInitClipping');
			var mod = this;
			mod.clippings = $('.scs-clipping-peakprotect');

			if (mod.clippings.length) {
				mod.ajaxPrefilterActive = false;
				if (!mod.enabled) {
					//display clipping, break script
					mod.enableClipping();
					return;
				}
				mod.loadScript(mod.processCallback, $.proxy(mod.enableClipping, mod));
			}
		},

		/**
		 * Use only by peakprotect.html, get target url from # and save in cookie
		 * if url is empty, get target url from cookie
		 * @returns {string}
		 */
		getTargetUrl: function () {
			var mod = this,
				url = window.location.hash.slice(1),
				temp;

			if (url && url.length) {
				temp = window.location.href.match(/^(?:[a-z]+:)?\/\/[^\/]+/) || ['https://www.swisscom.ch'];
				url = temp[0] + url;
				$.cookie(mod.COOKIE_TARGET_URL, url);
				return url;
			}
			url = $.cookie(mod.COOKIE_TARGET_URL);
			if (!url || !url.length) {
				//Exception url should set
				mod.exceptionHandler('Target url not found!');
				return;
			}
			return url;
		},

		getHashParameter: function (parameterName) {
			var hashParams = window.location.hash.slice(1),
				parameters = deparam(hashParams);
			if (parameters && parameters[parameterName]) {
				return decodeURIComponent(parameters[parameterName]);
			}
			return false;
		},

		removeHashParameter: function (parameterName) {
			var url = window.location.href,
				regexp = new RegExp('(?:(?!#|&)' + parameterName + '=.+?(&|$))', 'g');
			url = url.replace(regexp, '').replace(/(#|&)$/, '');
			window.history.replaceState({}, '', url);
		},
		
		processCallback: function (cb) {
			var mod = this;
			debug.log('SCS.PeakProtect > processClippingPageCallback');
			try {
				if (peakProtectObj && peakProtectObj.protect) {
					peakProtectObj.protect(window.location.href, $.proxy(mod.exceptionHandler, mod), cb);
				} else {
					mod.exceptionHandler('peakProtectionObj is not exists!');
					return;
				}
			} catch (err) {
				mod.exceptionHandler(err);
				return;
			}
		},

		enableClipping: function () {
			debug.log('SCS.PeakProtect > enableClipping');
			var mod = this;
			//enable clipping

			triggerProtectionLifted();

			if (mod.clippings.length) {
				mod.clippings.addClass('scs-clipping');
				if (SCS.fn) {
					if (SCS.fn.clipping) {
						SCS.fn.clipping($('body'), $);
					}
					if (SCS.fn.clippingProductConfig) {
						SCS.fn.clippingProductConfig();
					}
					if (SCS.fn.clippingCart) {
						SCS.fn.clippingCart();
					}
				}
			}
		},

		/**
		 * Redirect to exception page
		 */
		exceptionHandler: function (exception, msg) {
			var mod = this;
			debug.log('SCS.PeakProtect > Exception: ' + exception);

			var imgUrl = '/dam/error/1.png?exception=' + encodeURIComponent('SCS.PeakProtect > Exception: ' + exception);
			$('<img />', {'src': imgUrl});
			if (!msg || !msg.length) {
				if (!mod.showExceptionMessage) {
					window.location.href = mod.exceptionPageUrl;
					return;
				}
				msg = mod.exceptionMessage;
			}
			window.location.href = mod.addMsgToUrl(mod.exceptionPageUrl, msg);
		},

		addMsgToUrl: function (url, msg) {
			var mod = this,
				ch = '#';
			if (url.indexOf('#') > -1) {
				ch = '&';
			}
			return url + ch + mod.MESSAGE_KEY + '=' + encodeURIComponent(msg);
		},

		showMessage: function () {
			var mod = this,
				msg = mod.getHashParameter(mod.MESSAGE_KEY);
			debug.log('SCS.PeakProtect > showMessage');

			if (msg && msg.length) {
				mod.removeHashParameter(mod.MESSAGE_KEY);
				if (mod.isMobile) {
					var p = $( '<p />' );
					p.text( msg );
					var $popupMessage = $('<div id="ajaxErrorPopup" data-role="popup"></div>').append(p);
					$popupMessage.appendTo('body');
					$popupMessage.popup().popup('open');
					$popupMessage.on('popupafterclose', function () {
						$popupMessage.popup('destroy');
						$popupMessage.remove();
					});
				} else {
					var div = $( '<div />' );
					div.text( msg );
					$(div).dialog();
				}
			}
		},

		loadScript: function (cb, cb1) {
			var mod = this;
			try {
				$.ajax({
					url: mod.jsDownloadUrl,
					dataType: 'script',
					cache: true
				}).done(function () {$.proxy(cb, mod).call(mod, cb1);})
					.fail(function (jqxhr, settings, exception) {
						debug.log('SCS.PeakProtect > Failed to download PeakProtect JS with ajax response: ' + jqxhr.responseText);
						mod.exceptionHandler(exception);
					});
			} catch (err) {
				mod.exceptionHandler(err);
				return;
			}
		},

		/**
		 * process protect page
		 */
		processProtectPage: function () {
			debug.log('SCS.PeakProtect > processProtectPage');
			var mod = this;
			mod.loadScript(mod.processProtectPageCallback);
		},

		processProtectPageCallback: function () {
			debug.log('SCS.PeakProtect > processProtectPageCallback');

			var mod = this;
			try {
				if (peakProtectObj && peakProtectObj.protect) {
					debug.log('SCS.PeakProtect > processProtectPageCallback getOriginUrl=', mod.getTargetUrl());
					mod.setSwisscomCookie();
					peakProtectObj.protect(mod.getTargetUrl(),
						$.proxy(mod.exceptionHandler, mod), $.proxy(mod.processProtectPageRedirect, mod));
					return true;
				}
				mod.exceptionHandler('peakProtectionObj is not exists!');
			} catch (err) {
				mod.exceptionHandler(err);
			}
		},

		setSwisscomCookie: function(){
			var mod = this,
				options,
				expDate = new Date();
			if(!mod.cookieTimeout) {
				mod.cookieTimeout = (isNaN(parseInt(mod.ctx.data('peakprotect-cookie-timeout'), 10))) ? mod.DEFAULT_COOKIE_TIMEOUT : parseInt(mod.ctx.data('peakprotect-cookie-timeout'), 10);
			}

			debug.log('SCS.PeakProtect > setSwisscomCookie mod.cookieTimeout=', mod.cookieTimeout);

			expDate.setTime(expDate.getTime() + (mod.cookieTimeout * 1000));

			options = {
				path : '/',
				expires : expDate
			};
			$.cookie(mod.COOKIE_NAME, mod.COOKIE_VALUE, options);
		},

		/**
		 * Redirect to target url
		 */
		processProtectPageRedirect: function () {
			var mod = this;
			window.location.href = mod.getTargetUrl();
		},

		isCookie: function () {
			return document.cookie && document.cookie.indexOf(this.COOKIE_PREFIX) > -1;
		},

		isProtectAjaxUrl: function (url) {
			debug.log('SCS.PeakProtect > isProtectAjaxUrl url=' + url);
			var mod = this,
				extention;

			if (!mod.ajaxUrls || !mod.ajaxUrls.length) {
				return false;
			}

			if (!url || !url.length) {
				return false;
			}

			extention = url.split('.').pop().split(/\#|\?/)[0];
			if (mod.AJAX_IGNORE_URL_EXTENSIONS.indexOf(extention) > -1) {
				return false;
			}


			for (var i = 0, L = mod.ajaxUrls.length; i < L; i += 1) {
				if (url.indexOf(mod.ajaxUrls[i]) > -1) {
					debug.log('SCS.PeakProtect > isProtectAjaxUrl protected AJAX url=' + url);
					return true;
				}
			}
			return false;
		},

		/**
		 * Global event handler before AJAX send
		 */
		onAjaxPrefilter: function (options, originalOptions, jqXHR) {
			var mod = this;

			if (!mod.enabled || !mod.ajaxPrefilterActive) {
				return;
			}

			if (!originalOptions.pass) {

				if (!mod.isProtectAjaxUrl(options.url)) {
					return;
				}

				debug.log('SCS.PeakProtect > onAjaxPrefilter protected AJAX url=', options.url);

				//try to start ajax again
				originalOptions.pass = true; // pragma: allowlist-secret

				jqXHR.abort();
				debug.log('SCS.PeakProtect > abort AJAX Call for url: ' + options.url + ' call peak protection');

				mod.ajaxRequestQueue.push({opt: originalOptions, req: jqXHR});

				mod.loadScript(mod.ajaxPrefilterCallback);
			}
		},

		ajaxPrefilterCallback: function () {
			debug.log('SCS.PeakProtect > ajaxPrefilterCallback');
			var mod = this;
			try {
				if (peakProtectObj && peakProtectObj.protect) {
					mod.removeHashParameter(mod.MESSAGE_KEY);
					peakProtectObj.protect(mod.addMsgToUrl(window.location.href, mod.ajaxRepeatMsg),
						$.proxy(mod.exceptionHandler, mod), $.proxy(mod.callbackAjaxPeakProtect, mod));
					return true;
				}
				mod.exceptionHandler('peakProtectionObj is not exists!');
			} catch (err) {
				mod.exceptionHandler(err);
			}
		},

		callbackAjaxPeakProtect: function () {
			var mod = this,
				aj;

			mod.removeHashParameter(mod.MESSAGE_KEY);

			//Start AJAX calls
			//done, fail, always don't work, case may not initialize, please refactor ajax call to success, error & complete
			while (mod.ajaxRequestQueue.length) {
				aj = mod.ajaxRequestQueue.pop();
				$.ajax(aj.opt)
					.done(aj.req.done)
					.fail(aj.req.fail)
					.always(aj.req.always);
			}
		}
	};

	var obj = new SCSPeakProtection();
	$(document).ready($.proxy(obj.on, obj));

})(__webpack_provided_window_dot_jQuery);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_jQuery) {(function ($, SCS, debug) {
	'use strict';

	var zeroFill = __webpack_require__(4).zeroFill;
	/**
	 * Create namespace
	 */
	SCS.TV = SCS.TV || {};


	/********************
	 * Public API
	 *
	 * All methods that need to request data via ajax offer a callback function and also
	 * return a jQuery-Deferred object (read more here: http://api.jquery.com/category/deferred-object/)
	 ********************/

	/**
	 * load one broadcast by id
	 */
	SCS.TV.getBroadcastById = function (id, callback) {
		var def = $.Deferred();
		new SCS.TV.Broadcast(id, function(broadcast) {
			def.resolve(broadcast);
			if (typeof callback === 'function') {
				callback(broadcast);
			}
		});
		return def;
	};

	/**
	 * load multiple broadcasts at once
	 * use this instead of multiple times getBroadcastById, as this method only needs one ajax call for all the give broadcastids
	 */
	SCS.TV.getMultipleBroadcastsById = function (broadcastIds, callback) {
		var def = $.Deferred();
		if (broadcastIds && broadcastIds.length > 0) {

			$.getJSON(SCS.Const.SNOOPY_SERVICE_PROXY_URL + 'catalog/tv/broadcasts/list/(datalevel=normal;ids=' + broadcastIds.join(',') + ');', function (data) {
				var broadcasts = [];

				if (data && data.Nodes && data.Nodes.Items && data.Nodes.Items.length > 0) {
					for (var i = 0; i < data.Nodes.Items.length; i++) {
						if (data.Nodes.Items[i] && data.Nodes.Items[i].Kind === 'Broadcast') {
							var tempBroadcast = new SCS.TV.Broadcast();
							tempBroadcast._readData(data.Nodes.Items[i]);

							broadcasts.push(tempBroadcast);
						}
					}
				}

				// service does not return content in the same order as requested.. so sort it again
				broadcasts = SCS.TV.Helper.orderByArrayOrder(broadcastIds, broadcasts, 'broadcastId');

				def.resolve(broadcasts);
				if (typeof callback === 'function') {
					callback(broadcasts);
				}
			});
		}
		else {
			def.resolve([]); // we do not use def.reject(); as otherwise we would need to handle the exception in every usage
		}
		return def;
	};

	/**
	 * load multiple channels at once
	 */
	SCS.TV.getMultipleChannelsById = function (channelIds, callback) {
		var def = $.Deferred();
		if (channelIds && channelIds.length > 0) {

			var ids = channelIds.join(',');
			if(ids.length > 0){
				$.getJSON(SCS.Const.SNOOPY_SERVICE_PROXY_URL + 'catalog/tv/channels/list/(ids=' + ids + ');', function (data) {
					var channels = [];

					if (data && data.Nodes && data.Nodes.Items && data.Nodes.Items.length > 0) {
						for (var i = 0; i < data.Nodes.Items.length; i++) {
							if (data.Nodes.Items[i] && data.Nodes.Items[i].Kind === 'Channel') {
								debug.log('SCS.TV.getMultipleChannelsById', data.Nodes.Items[i]);
								var tempChannel = new SCS.TV.Channel();
								tempChannel._readData(data.Nodes.Items[i]);
								channels.push(tempChannel);
							}
						}
					}

					// service does not return content in the same order as requested.. so sort it again
					channels = SCS.TV.Helper.orderByArrayOrder(channelIds, channels, 'channelId');

					def.resolve(channels);
					if (typeof callback === 'function') {
						callback(channels);
					}
				});
			}
		}
		else {
			def.resolve([]); // we do not use def.reject(); as otherwise we would need to handle the exception in every usage
		}
		return def;
	};

	/**
	 * load multiple movies at once
	 */
	SCS.TV.getMultipleMoviesById = function(movieIds, callback) {
		debug.log('SCS.TV.getMultipleMoviesById > movieIds', movieIds);
		var def = $.Deferred();

		if (movieIds && movieIds.length > 0) {

			$.getJSON(SCS.Const.SNOOPY_SERVICE_PROXY_URL + 'catalog/vod/' + SCS.Const.SNOOPY_VOD_STORES[SCS.Const.SNOOPY_LANGUAGE] + '/movies/list/(datalevel=normal;ids=' + movieIds + ');', function (data) {
				var movies = [];
				debug.log('SCS.TV.getMultipleMoviesById > data', data);
				if (data && data.Nodes && data.Nodes.Items && data.Nodes.Items.length > 0) {
					for (var i = 0; i < data.Nodes.Items.length; i++) {

						var tempMovie = new SCS.TV.Movie();
						tempMovie._readData(data.Nodes.Items[i]);
						movies.push(tempMovie);

					}
				}

				// service does not return content in the same order as requested.. so sort it again
				movies = SCS.TV.Helper.orderByArrayOrder(movieIds, movies, 'movieId');

				def.resolve(movies);
				if (typeof callback === 'function') {
					callback(movies);
				}
			});
		}
		else {
			def.resolve([]); // we do not use def.reject(); as otherwise we would need to handle the exception in every usage
		}
		return def;
	};

	/**
	 * Loads movie highlights - first selects "RecentlyAdded"-Category and then selects element of this category
	 **/
	SCS.TV.getMovieHighlights = function (callback, limit) {
		var def = $.Deferred(),
			limitStr = limit ? ';limit=' + limit : '';

		// first load all categories
		$.getJSON(SCS.Const.SNOOPY_SERVICE_PROXY_URL + 'catalog/vod/' + SCS.Const.SNOOPY_VOD_STORES[SCS.Const.SNOOPY_LANGUAGE] + '/categories/list/(ids=all;level=minimal);', function (data) {
			if (!(data && data.Nodes && data.Nodes.Items && data.Nodes.Items.length > 0)) {
				def.resolve([]);
				if (typeof callback === 'function') {
					callback([]);
				}
				return [];
			}

			var categoryData = SCS.TV.Helper.getFirstElementOfKindAndRoleAndShape(data.Nodes.Items, 'Container', 'RecentlyAdded');
			if (!categoryData) {
				def.resolve([]);
				if (typeof callback === 'function') {
					callback([]);
				}
				return [];
			}

			// if a "RecenlyAdded" category has been found - request content of this category
			var categoryId = categoryData.Identifier;
			$.getJSON(SCS.Const.SNOOPY_SERVICE_PROXY_URL + 'catalog/vod/' + SCS.Const.SNOOPY_VOD_STORES[SCS.Const.SNOOPY_LANGUAGE] + '/categories/detail/(ids=' + categoryId + ';level=normal' + limitStr + ');', function (vodData) {

				var movies = [];

				if (vodData && vodData.Nodes && vodData.Nodes.Items && vodData.Nodes.Items.length === 1 && vodData.Nodes.Items[0].Content && vodData.Nodes.Items[0].Content.Nodes && vodData.Nodes.Items[0].Content.Nodes.Items && vodData.Nodes.Items[0].Content.Nodes.Items.length > 0) { // item = selected category
					var categoryContent = vodData.Nodes.Items[0].Content.Nodes.Items;
					for (var i = 0; i < categoryContent.length; i++) {

						// for each VOD - check if there is a web-version and a poster image, then add to list
						if (categoryContent[i].Content && categoryContent[i].Content.Nodes && categoryContent[i].Content.Nodes.Items && categoryContent[i].Content.Nodes.Items.length > 0) {

							var webVersion = SCS.TV.Helper.getFirstElementOfKindAndRoleAndShape(categoryContent[i].Content.Nodes.Items, 'Asset', undefined, 'WEB');
							if (webVersion) { // web version exists
								var posterImage = SCS.TV.Helper.getFirstElementOfKindAndRoleAndShape(categoryContent[i].Content.Nodes.Items, 'Image', 'Poster');
								if (posterImage) { // poster image available
									var tempMovie = new SCS.TV.Movie();
									tempMovie._readData(categoryContent[i]);
									movies.push(tempMovie);
								}
							}
						}
					}
				}
				def.resolve(movies);
				if (typeof callback === 'function') {
					callback(movies);
				}
			});
		});
		return def;
	};

	/**
	 * Loads most rented movies
	 **/
	SCS.TV.getMostRentedMovies = function (callback, limit) {
		$.getJSON(SCS.Const.SNOOPY_SERVICE_PROXY_URL + 'discovery/generallist/vod/mostrented/?language=' + SCS.Const.SNOOPY_LANGUAGE, function (vodData) {
			var movies = [];

			if (vodData && vodData.Nodes && vodData.Nodes.Items && vodData.Nodes.Items.length === 1 && vodData.Nodes.Items[0].Content && vodData.Nodes.Items[0].Content.Nodes && vodData.Nodes.Items[0].Content.Nodes.Items && vodData.Nodes.Items[0].Content.Nodes.Items.length > 0) { // item = selected category
				var vodContent = vodData.Nodes.Items[0].Content.Nodes.Items;

				for (var i = 0; i < vodContent.length && (!limit || i < limit); i++) {
					// for each VOD - check if there is a web-version and a poster image, then add to list
					if (vodContent[i].Content && vodContent[i].Content.Nodes && vodContent[i].Content.Nodes.Items && vodContent[i].Content.Nodes.Items.length > 0) {
						var posterImage = SCS.TV.Helper.getFirstElementOfKindAndRoleAndShape(vodContent[i].Content.Nodes.Items, 'Image', 'Poster');

						if (posterImage) { // poster image available
							var tempMovie = new SCS.TV.Movie();

							tempMovie._readData(vodContent[i]);
							movies.push(tempMovie);
						}
					}
				}
			}

			if (typeof callback === 'function') {
				callback(movies);
			}
		});
	}

	/**
	 * load one sport-event by id
	 */
	SCS.TV.getSportEventById = function (id, callback) {
		var def = $.Deferred();
		new SCS.TV.SportEvent(id, function(sportEvent) {
			def.resolve(sportEvent);
			if (typeof callback === 'function') {
				callback(sportEvent);
			}
		});
		return def;
	};

	/**
	 * load multiple sportevents at once
	 * use this instead of multiple times getSportEventById, as this method only needs one ajax call for all the give broadcastids
	 */
	SCS.TV.getMultipleSportEventsById = function (sportEventIds, callback) {
		var def = $.Deferred();
		if (sportEventIds && sportEventIds.length > 0) {

			$.getJSON(SCS.Const.SNOOPY_SERVICE_PROXY_URL + 'catalog/sport/' + SCS.Const.SNOOPY_LANGUAGE + '/events/list/(ids=' + sportEventIds.join(',') + ');', function (data) {
				var sportEvents = [];

				if (data && data.Nodes && data.Nodes.Items && data.Nodes.Items.length > 0) {
					for (var i = 0; i < data.Nodes.Items.length; i++) {
						if (data.Nodes.Items[i]) {
							var tempSportEvent = new SCS.TV.SportEvent();
							tempSportEvent._readData(data.Nodes.Items[i]);

							sportEvents.push(tempSportEvent);
						}
					}
				}

				// service does not return content in the same order as requested.. so sort it again
				sportEvents = SCS.TV.Helper.orderByArrayOrder(sportEventIds, sportEvents, 'sportEventId');

				def.resolve(sportEvents);
				if (typeof callback === 'function') {
					callback(sportEvents);
				}
			});
		}
		else {
			def.resolve([]); // we do not use def.reject(); as otherwise we would need to handle the exception in every usage
		}
		return def;
	};


	/**
	 * Selects movie highlights from categories saved in tvHighlightsCategories
	 * ISSUE: Does not return channel-name (and also channel-id is not returned with datalevel=minimal) therefore channelname cannot be used as alt-text of logo
	 */
	SCS.TV.getTvHighlights = function (callback, dateFrom, dateTo, limit) {
		var def = $.Deferred(),
			limitStr = limit ? ';limit=' + (limit*2) : ''; // load two times as many items as needed as often there are dublicates that get filtered out
		if (!dateFrom) {
			dateFrom = new Date();
		}
		if (!dateTo) {
			dateTo = new Date(dateFrom.getTime() + 24 * 60 * 60 * 1000);
		}

		dateFrom.setMinutes(Math.floor(dateFrom.getMinutes()/10)*10); // round to 10min - better caching
		dateTo.setMinutes(Math.floor(dateTo.getMinutes()/10)*10);

		var dateFromFilter = dateFrom.getFullYear().toString() + zeroFill(dateFrom.getMonth() + 1) + zeroFill(dateFrom.getDate()) + zeroFill(dateFrom.getHours()) + zeroFill(dateFrom.getMinutes());
		var dateToFilter = dateTo.getFullYear().toString() + zeroFill(dateTo.getMonth() + 1) + zeroFill(dateTo.getDate()) + zeroFill(dateTo.getHours()) + zeroFill(dateTo.getMinutes());

		$.getJSON(SCS.Const.SNOOPY_SERVICE_PROXY_URL + 'catalog/tv/' + SCS.Const.SNOOPY_LANGUAGE + '/categories/detail/(datalevel=reduced;end=' + dateToFilter + ';ids=' + SCS.Const.SNOOPY_TV_HIGHLIGHTS_CATEGORIES[SCS.Const.SNOOPY_LANGUAGE] + ';start=' + dateFromFilter + limitStr + ')', function (data) {
			var broadcasts = [];

			if (data && data.Nodes && data.Nodes.Items && data.Nodes.Items.length === 1 && data.Nodes.Items[0].Content && data.Nodes.Items[0].Content.Nodes && data.Nodes.Items[0].Content.Nodes.Items && data.Nodes.Items[0].Content.Nodes.Items.length > 0) { // item = selected category
				var categoryContent = data.Nodes.Items[0].Content.Nodes.Items;
				for (var i = 0; i < categoryContent.length; i++) {

					// for each VOD - check if there is a web-version and a poster image, then add to list
					if (categoryContent[i].Content && categoryContent[i].Content.Nodes && categoryContent[i].Content.Nodes.Items && categoryContent[i].Content.Nodes.Items.length > 0) {

						var posterImage = SCS.TV.Helper.getFirstElementOfKindAndRoleAndShape(categoryContent[i].Content.Nodes.Items, 'Image', 'Poster');
						if (posterImage) { // poster image available
							var tempBroadcast = new SCS.TV.Broadcast();
							tempBroadcast._readData(categoryContent[i]);
							broadcasts.push(tempBroadcast);
						}
					}
				}
			}

			// filter double entries
			broadcasts = SCS.TV.Helper.removeDuplicateTitles(broadcasts);
			if (limit) {
				broadcasts = broadcasts.slice(0, limit);
			}

			def.resolve(broadcasts);
			if (typeof callback === 'function') {
				callback(broadcasts);
			}
		});
		return def;
	};

}(__webpack_provided_window_dot_jQuery, window.SCS = window.SCS || {}, window.debug));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_jQuery) {(function ($, SCS, debug) {
	'use strict';

	/**
	 * Create namespaces
	 */
	SCS.TV = SCS.TV || {};

	/**
	 * Broadcast Class
	 */
	function Broadcast(broadcastId, callback) {
		this._init(broadcastId, callback);
	}

	// poster url - using resizing servlet and the closest image size available from the service
	Broadcast.posterUrl = (SCS.Const.SNOOPY_IMAGE_BASE ? SCS.Const.SNOOPY_IMAGE_BASE + '/{width}x0/' : SCS.Const.SNOOPY_SERVICE_PROXY_URL) + 'content/images/tv/broadcast/{broadcastid}_poster_{size}.jpg';

	// static functions
	Broadcast.getPosterUrlByBroadcastId = function (broadcastId, width) {
		var availableWidth = SCS.TV.Helper.getBestImageWidth(width);
		return Broadcast.posterUrl.replace('{broadcastid}', broadcastId).replace('{size}', 'W' + availableWidth).replace('{width}', width);
	};

	Broadcast.getPlayerUrl = function(broadcastId) {
		return SCS.Const.SNOOPY_SHARING_URL + 'L=' + SCS.Const.SNOOPY_LANGUAGE + '&T=Watch&I=' + broadcastId;
	};

	Broadcast.getDetailsUrl = function(broadcastId) {
		return SCS.Const.SNOOPY_SHARING_URL + 'L=' + SCS.Const.SNOOPY_LANGUAGE + '&T=Program&I=' + broadcastId;
	};


	Broadcast.prototype = {
		constructor: Broadcast,
		_init: function (broadcastId, callback) {
			this.broadcastId = broadcastId;
			this.title = '';
			this.summary = '';
			this.duration = '';
			this.language = '';
			this.start = new Date(2000,1,1);
			this.end = new Date(2000,1,1);
			this.price = 0;
			this.currency = 'CHF';
			this.channelId = '';
			if (broadcastId) { // do not initialize if no id is given
				this._loadData(callback);
			}
		},

		_loadData: function (callback) {
			var broadcast = this;
			$.getJSON(SCS.Const.SNOOPY_SERVICE_PROXY_URL + 'catalog/tv/broadcasts/list/(datalevel=normal;ids=' + this.broadcastId + ');', function (data) {
				debug.log('SCS.TV > Broadcast > read free tv data', data);

				if (data && data.Nodes && data.Nodes.Items && data.Nodes.Items.length > 0) {
					var broadcastInfo = SCS.TV.Helper.getFirstElementOfKindAndRoleAndShape(data.Nodes.Items, 'Broadcast');

					broadcast._readData(broadcastInfo);
				}

				if (typeof callback === 'function') {
					callback(broadcast);
				}
			});
		},

		/**
		 * Public API
		 */
		getPosterUrl: function (width) {
			var availableWidth = SCS.TV.Helper.getBestImageWidth(width);
			return this.posterUrl.replace('{size}', 'W' + availableWidth).replace('{width}', width);
		},

		/**
		 * Public API
		 */
		getChannel: function (callback) {
			if (this.channelId !== '') {
				return new SCS.TV.Channel(this.channelId, callback);
			}
			return null;
		},

		getPlayerUrl: function () {
			return SCS.TV.Broadcast.getPlayerUrl(this.broadcastId);
		},

		getDetailsUrl: function() {
			return SCS.TV.Broadcast.getDetailsUrl(this.broadcastId);
		},

		getFormattedPrice: function () {
			return SCS.utils.formatPrice(this.price);
		},

		isToday: function () {
			return SCS.TV.Helper.isToday(this.start);
		},

		isTomorrow: function () {
			return SCS.TV.Helper.isTomorrow(this.start);
		},

		_readData: function (broadcastInfo) {
			if (broadcastInfo) {
				if (broadcastInfo.Content && broadcastInfo.Content.Description) {
					this.title = broadcastInfo.Content.Description.Title;
					var durationString = broadcastInfo.Content.Description.Duration;
					if (durationString) {
						var durationParts = durationString.split(':');
						if (durationParts.length === 3) {
							this.duration = 60*parseInt(durationParts[0], 10) + parseInt(durationParts[1], 10);
						}
					}
					this.summary = broadcastInfo.Content.Description.Summary ? broadcastInfo.Content.Description.Summary : '';
					this.language = broadcastInfo.Content.Description.Language;
				}
				if (broadcastInfo.Availabilities && broadcastInfo.Availabilities.length > 0) {
					if (SCS.Const.SNOOPY_IS_OLD_IE) {
						this.start = SCS.TV.Helper.readDateIE8(broadcastInfo.Availabilities[0].AvailabilityStart);
						this.end = SCS.TV.Helper.readDateIE8(broadcastInfo.Availabilities[0].AvailabilityEnd);
					}
					else {
						this.start = new Date(broadcastInfo.Availabilities[0].AvailabilityStart);
						this.end = new Date(broadcastInfo.Availabilities[0].AvailabilityEnd);
					}

					if (!this.duration) {
						var diffMs = (this.end - this.start); // milliseconds between start and end
						this.duration = Math.round(diffMs / 60000);
					}

					this.price = broadcastInfo.Availabilities[0].Price ? parseFloat(broadcastInfo.Availabilities[0].Price) : 0;
					if (this.price > 0) { // web users pay 2.- more to rent the stream
						this.price += SCS.Const.SNOOPY_WEB_RENT_SURCHARGE;
					}
					this.currency = broadcastInfo.Availabilities[0].Currency;
				}
				if (broadcastInfo.Relations) {
					var tempChannel = SCS.TV.Helper.getFirstElementOfKindAndRoleAndShape(broadcastInfo.Relations, 'Reference', 'ChannelIdentifier');
					this.channelId = tempChannel ? tempChannel.TargetIdentifier : '';
				}

				// write id-specific data here in case the object was created without ID and loaded by reading already loaded data using _readData
				this.broadcastId = broadcastInfo.Identifier;
				this.posterUrl = Broadcast.posterUrl.replace('{broadcastid}', this.broadcastId);
			}
		}
	};

	SCS.TV.Broadcast = Broadcast;

}(__webpack_provided_window_dot_jQuery, window.SCS = window.SCS || {}, window.debug));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_jQuery) {(function ($, SCS, debug) {
	'use strict';

	/**
	 * Create namespaces
	 */
	SCS.TV = SCS.TV || {};

	
	/**
	 * Channel Class
	 */
	function Channel(channelId, callback) {
		debug.log('SCS.TV > Channel > new', channelId, callback);
		this._init(channelId, callback);
	}

	// channel logos are not resized further as the quality would be too bad
	Channel.logoUrl = SCS.Const.SNOOPY_SERVICE_PROXY_URL + 'content/images/tv/channel/{channelid}_image_{size}.png';

	// static functions
	Channel.getLogoUrlByChannelId = function (channelId, width) {
		var availableWidth = SCS.TV.Helper.getBestImageWidth(width);
		return SCS.TV.Channel.logoUrl.replace('{channelid}', channelId).replace('{size}', 'W' + availableWidth);
	};

	// class functions
	Channel.prototype = {
		constructor: Channel,
		

		_init: function (channelId, callback) {
			this.channelId = channelId;
			this.logoUrl = SCS.TV.Channel.logoUrl.replace('{channelid}', channelId);
			this.name = '';

			if (channelId) {
				this._loadData(callback);
			}
		},

		_loadData: function (callback) {
			var channel = this;
			$.getJSON(SCS.Const.SNOOPY_SERVICE_PROXY_URL + 'catalog/tv/channels/list/(ids=' + this.channelId + ');', function (data) {
				debug.log('SCS.TV > Channel > loadData', data);
				if (data && data.Nodes && data.Nodes.Items && data.Nodes.Items.length > 0) {
					var channelInfo = SCS.TV.Helper.getFirstElementOfKindAndRoleAndShape(data.Nodes.Items, 'Channel');
					if (channelInfo) {
						channel._readData(channelInfo);
					}
				}
				if (typeof callback === 'function') {
					callback(channel);
				}
			});
		},

		_readData: function (channelInfo) {
			if (channelInfo.Content && channelInfo.Content.Description && channelInfo.Content.Description.Title) {
				this.name = channelInfo.Content.Description.Title;
				this.channelId = channelInfo.Identifier;
				this.logoUrl = SCS.TV.Channel.logoUrl.replace('{channelid}', this.channelId);
			}
		},

		/**
		 * Public API
		 */
		getLogoUrl: function (width) {
			var availableWidth = SCS.TV.Helper.getBestImageWidth(width);
			return this.logoUrl.replace('{size}', 'W' + availableWidth);
		}
	};

	
	SCS.TV.Channel = Channel;

}(__webpack_provided_window_dot_jQuery, window.SCS = window.SCS || {}, window.debug));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_jQuery) {(function ($, SCS, debug) {
	'use strict';

	var zeroFill = __webpack_require__(4).zeroFill;
	/**
	 * Create namespaces
	 */
	SCS.TV = SCS.TV || {};

	/**
	 * Static helper
	 */
	SCS.TV.Helper = SCS.TV.Helper || {};

	// returns first object in an array that has field "Kind" with the value of parameter kind
	SCS.TV.Helper.getFirstElementOfKindAndRoleAndShape = function (array, kind, role, shape, count) {
		if (!count) {
			count = 1;
		}
		if (!array || array.length < 1) {
			return null;
		}
		var collected = [];
		for (var i = 0; i < array.length; i++) {
			if ((!shape && !role && array[i].Kind === kind) ||
				(!shape && array[i].Kind === kind && array[i].Role === role) ||
				(array[i].Kind === kind && array[i].Role === role && array[i].Shape === shape)) {
				collected.push(array[i]);
				if (collected.length >= count) {
					break;
				}
			}
		}
		if (collected.length === 0) {
			return null;
		}
		else if (count > 1) {
			return collected;
		}
		else {
			return collected[0];
		}

	};

	// returns minimum available image width that is larger than given width (if possible)
	SCS.TV.Helper.getBestImageWidth = function (neededWidth) {
		neededWidth = neededWidth || 0;
		var availableWidth = SCS.Const.SNOOPY_IMAGE_WIDTHS.slice(-1)[0]; // max width
		for (var i = 0; i < SCS.Const.SNOOPY_IMAGE_WIDTHS.length; i++) {
			if (SCS.Const.SNOOPY_IMAGE_WIDTHS[i] >= neededWidth) {
				availableWidth = SCS.Const.SNOOPY_IMAGE_WIDTHS[i];
				break;
			}
		}
		return availableWidth;
	};

	// returns array without entries that had the same title as another entry
	SCS.TV.Helper.removeDuplicateTitles = function (broadcasts) {
		var filteredBroadcasts = [],
			found = false;

		for (var i = 0; i < broadcasts.length; i++) {
			found = false;
			for (var j = 0; j < filteredBroadcasts.length; j++) {
				if (filteredBroadcasts[j].title === broadcasts[i].title) {
					found = true;
					break;
				}
			}
			if (!found) {
				filteredBroadcasts.push(broadcasts[i]);
			}
		}
		return filteredBroadcasts;
	};

	// preformats date so IE8 can convert it to date object
	SCS.TV.Helper.readDateIE8 = function (dateStr) {
		if (dateStr && typeof dateStr.getMonth === 'function') {
			return dateStr; // is already a date
		}
		dateStr = dateStr.replace(/-/g, '/').replace(/T/, ' ');
		return new Date(dateStr);
	};

	// checks if @str might be a broadcast-id
	SCS.TV.Helper.isPossibleBroadcastId = function(str) {
		return (str && str.length === 16);
	};

	// checks if @str might be a sportevent-id
	SCS.TV.Helper.isPossibleSportEventId = function(str) {
		return (str && str.length === 36);
	};

	// takes availabilities and selects the cheapest currently available one
	SCS.TV.Helper.selectCheapestCurrentAvailability = function(availabilities) {
		if (!availabilities || availabilities.length < 1) {
			return null;
		}

		var currentlySelected = null,
			currentStart = null,
			currentEnd = null,
			currentPrice = null,
			now = new Date();

		for (var i = 0; i < availabilities.length; i++) {
			if (availabilities[i].AvailabilityStart && availabilities[i].AvailabilityEnd && availabilities[i].Price) {
				currentStart = SCS.Const.SNOOPY_IS_OLD_IE ? SCS.TV.Helper.readDateIE8(availabilities[i].AvailabilityStart) : new Date(availabilities[i].AvailabilityStart);
				currentEnd = SCS.Const.SNOOPY_IS_OLD_IE ? SCS.TV.Helper.readDateIE8(availabilities[i].AvailabilityEnd) : new Date(availabilities[i].AvailabilityEnd);
				currentPrice = parseFloat(availabilities[i].Price);
				if (currentStart.valueOf() < now.valueOf() && currentEnd.valueOf() > now.valueOf() && (currentlySelected === null || currentlySelected.Price > currentPrice)) {
					currentlySelected = availabilities[i];
				}
			}
		}

		return currentlySelected;
	};

	// parses a duration string in the form hh:mm and return a number of minutes
	SCS.TV.Helper.getMinutesFromDurationString = function(durationStr) {
		var parts = durationStr.split('.'),
			minutes = 0,
			timeParts = null;

        if (parts.length > 1) {
            minutes += 24*60*parseInt(parts[0]);
            timeParts = parts[1].split(':');
        }
        else {
            timeParts = parts[0].split(':');
        }

        minutes += 60*parseInt(timeParts[0]);
        minutes += parseInt(timeParts[1]);

        return minutes;
	};

	// checks if a date is today
	SCS.TV.Helper.isToday = function(date) {
		return date && date.toDateString() === (new Date()).toDateString();
	};

	// checks if a date is tomorrow
	SCS.TV.Helper.isTomorrow = function(date) {
		return date && date.toDateString() === new Date((new Date()).getTime() + 24 * 60 * 60 * 1000).toDateString();
	};

	// returns formatted date to be used for the creation of ICS files - also calculates the time to UTC
	SCS.TV.Helper.getICSDate = function(date) {
		var dateStr = '',
			d = date || new Date();

		dateStr += d.getUTCFullYear();
		dateStr += zeroFill(d.getUTCMonth() + 1);
		dateStr += zeroFill(d.getUTCDate());
		dateStr += 'T';
		dateStr += zeroFill(d.getUTCHours());
		dateStr += zeroFill(d.getUTCMinutes());
		dateStr += zeroFill(d.getUTCSeconds());
		dateStr += 'Z';

		return dateStr;
	};

	/**
	 * Sorts objects in array @toOrder in the same order as the object-value @key is ordered in rightOrder
	 */
	SCS.TV.Helper.orderByArrayOrder = function(rightOrder, toOrder, key) {
		var newOrder = [];
		for (var i = 0; i < rightOrder.length; i++) {
			for (var j = 0; j < toOrder.length; j++) {
				if (rightOrder[i] === toOrder[j][key]) {
					newOrder.push(toOrder[j]);
					break;
				}
			}
		}
		return newOrder;
	};



}(__webpack_provided_window_dot_jQuery, window.SCS = window.SCS || {}, window.debug));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_jQuery) {(function ($, SCS, debug) {
	'use strict';

	/**
	 * Movie Class
	 */
	function Movie(movieId, callback) {
		debug.log('SCS.TV > Movie > new', movieId, callback);
		this._init(movieId, callback);
	}

	Movie.getPlayerUrl = function(movieId) {
		return SCS.Const.SNOOPY_SHARING_URL + 'L=' + SCS.Const.SNOOPY_LANGUAGE + '&T=VOD&I=' + movieId;
	};

	// class functions
	Movie.prototype = {
		constructor: Movie,


		_init: function (movieId, callback) {
			this.movieId = movieId;
			this.title = '';
			this.price = '';
			this.currency = '';
			this.webavailable = false;
			this.posterUrl = '';
			this.director = '';
			this.country = '';
			this.genre = '';
			this.releaseDate = '';
			this.duration = '';
			this.language = '';

			if (movieId) {
				this._loadData(callback);
			}
		},

		_loadData: function (callback) {
			var movie = this;

			$.getJSON(SCS.Const.SNOOPY_SERVICE_PROXY_URL + 'catalog/vod/' + SCS.Const.SNOOPY_VOD_STORES[SCS.Const.SNOOPY_LANGUAGE] + '/movies/detail/(datalevel=normal;ids=' + this.movieId + ');', function (data) {

				if (data && data.Nodes && data.Nodes.Items && data.Nodes.Items.length === 1) {
					movie._readData(data.Nodes.Items[0]);
				}

				if (typeof callback === 'function') {
					callback(movie);
				}
			});
		},

		_readData: function (movieInfo) {
			this.movieId = movieInfo.Identifier;

			// the poster can be defined by id
			this.posterUrl = (SCS.Const.SNOOPY_IMAGE_BASE ? SCS.Const.SNOOPY_IMAGE_BASE + '/{width}x0' : '/tvairpub/online') + '/content/images/vod/asset/' + this.movieId + '_poster_{size}.jpg';

			// read content data
			if (!movieInfo.Content) {
				return;
			}

			if (movieInfo.Content.Description) {
				this.title = movieInfo.Content.Description.Title;
				this.country = movieInfo.Content.Description.Country;
				this.releaseDate = movieInfo.Content.Description.ReleaseDate ? movieInfo.Content.Description.ReleaseDate.substr(0,4) : '';
			}

			// price has to be read from web availability
			if (!movieInfo.Content.Nodes || !movieInfo.Content.Nodes.Items) {
				return;
			}
			var webVersion = SCS.TV.Helper.getFirstElementOfKindAndRoleAndShape(movieInfo.Content.Nodes.Items, 'Asset', undefined, 'WEB');
			if (webVersion && webVersion.Availabilities && webVersion.Availabilities.length > 0) {
				var bestAvailability = SCS.TV.Helper.selectCheapestCurrentAvailability(webVersion.Availabilities);
				if (bestAvailability !== null) {
					this.price = bestAvailability.Price;
					this.currency = bestAvailability.Currency;
					this.webavailable = true;
				}
				// get duration from assets in webversion - duration has the following format => PT1H30M3S
				if (webVersion.Content && webVersion.Content.Nodes && webVersion.Content.Nodes.Items) {
					var featuredMovie = SCS.TV.Helper.getFirstElementOfKindAndRoleAndShape(webVersion.Content.Nodes.Items, 'Video', 'Feature', 'WEB');
					if (featuredMovie && featuredMovie.Content && featuredMovie.Content.Description && featuredMovie.Content.Description.Duration && featuredMovie.Content.Description.Duration.length > 0) {
						this.duration = SCS.TV.Helper.getMinutesFromDurationString(featuredMovie.Content.Description.Duration);
					}
				}
			}

			// get director and gerne from relations
			if (movieInfo.Relations) {
				var genreNode = SCS.TV.Helper.getFirstElementOfKindAndRoleAndShape(movieInfo.Relations, 'Genre', 'Genre');
				if (genreNode) {
					this.genre = genreNode.TargetIdentifier;
				}

				var directorNode = SCS.TV.Helper.getFirstElementOfKindAndRoleAndShape(movieInfo.Relations, 'Participant', 'Director');
				if (directorNode && directorNode.TargetNode && directorNode.TargetNode.Content && directorNode.TargetNode.Content.Description) {
					this.director = directorNode.TargetNode.Content.Description.FirstName + ' ' + directorNode.TargetNode.Content.Description.LastName;
				}
			}
		},

		/**
		 * Public API
		 */
		getPosterUrl: function (width) {
			var availableWidth = SCS.TV.Helper.getBestImageWidth(width);
			return this.posterUrl.replace('{size}', 'W' + availableWidth).replace('{width}', width);
		},

		/**
		 * Public API
		 */
		getFormattedPrice: function () {
			if (this.price > 0) {
				var cents = ((this.price - Math.floor(this.price)) * 100);
				if (cents === 0) {
					cents = '00';
				}
				return Math.floor(this.price) + '.' + cents;
			}
			return '0.00';
		},

		/**
		 * Public API
		 */
		getPlayerUrl: function () {
			return SCS.TV.Movie.getPlayerUrl(this.movieId);
		}
	};

	SCS.TV.Movie = Movie;

}(__webpack_provided_window_dot_jQuery, window.SCS = window.SCS || {}, window.debug));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_jQuery) {(function ($, SCS, debug) {
	'use strict';

	/**
	 * Create namespaces
	 */
	SCS.TV = SCS.TV || {};

	

	/**
	 * SportEvent Class
	 * Represents a Sport-Event (which contains multiple broadcasts)
	 */
	function SportEvent(sportEventId, callback) {
		debug.log('SCS.TV > SportEvent > new', sportEventId, callback);
		this._init(sportEventId, callback);
	}

	SportEvent.getDetailsUrl = function(sportEventId) {
		return SCS.Const.SNOOPY_SHARING_URL + 'L=' + SCS.Const.SNOOPY_LANGUAGE + '&T=Sport&I=' + sportEventId;
	};

	// class functions
	SportEvent.prototype = {
		constructor: SportEvent,
		
		_init: function(sportEventId, callback) {
			this.sportEventId = sportEventId;
			this.title = '';
			this.broadcasts = [];
			this.firstParticipant = null; // {'name':'', 'logo': ''}
			this.secondParticipant = null;

			if (sportEventId) {
				this._loadData(callback);
			}
		},

		_loadData: function(callback) {
			var sportEvent = this;
			$.getJSON(SCS.Const.SNOOPY_SERVICE_PROXY_URL + 'catalog/sport/' + SCS.Const.SNOOPY_LANGUAGE + '/events/list/(ids=' + this.sportEventId + ');', function (data) {
				debug.log('SCS.TV > sportEventId > loadData', data);
				if (data && data.Nodes && data.Nodes.Items && data.Nodes.Items.length > 0) {
					var eventInfo = SCS.TV.Helper.getFirstElementOfKindAndRoleAndShape(data.Nodes.Items, 'Container', 'EventGroup');
					if (eventInfo) {
						sportEvent._readData(eventInfo);
					}
				}
				if (typeof callback === 'function') {
					callback(sportEvent);
				}
			});
		},

		_readData: function(eventInfo) {
			var tempBroadcasts,
				tempBroadcast,
				tempChannel;

			this.sportEventId = eventInfo.Identifier;

			// important: title language is dependant on event-id specified (there's a event-id for each language)
			// as sportal delivers only one language - always use their title or the broadcast-title of the automatically-selected broadcast
			if (eventInfo && eventInfo.Content && eventInfo.Content.Description) {
				this.title = eventInfo.Content.Description.Title;
			}

			// find participants (1 or 2 depending on the type of sport)
			if (eventInfo.Relations) {
				var partitipants = SCS.TV.Helper.getFirstElementOfKindAndRoleAndShape(eventInfo.Relations, 'Participant', null, null, 2);
				if (partitipants && partitipants.length > 0) {
					this.firstParticipant = this._readParticipantData(partitipants[0]);
					if (partitipants.length > 1) {
						this.secondParticipant = this._readParticipantData(partitipants[1]);
					}
				}
			}

			// read all broadcasts of this sportevent
			if (eventInfo && eventInfo.Content && eventInfo.Content.Nodes && eventInfo.Content.Nodes.Items) {
				tempBroadcasts = eventInfo.Content.Nodes.Items;
				for (var i = 0; i < tempBroadcasts.length; i++) {
					if (tempBroadcasts[i].Kind === 'Broadcast' && tempBroadcasts[i].Content && tempBroadcasts[i].Content.Description && tempBroadcasts[i].Availabilities && tempBroadcasts[i].Availabilities.length > 0) {
						
						if (tempBroadcasts[i].Relations) {
							tempChannel = SCS.TV.Helper.getFirstElementOfKindAndRoleAndShape(tempBroadcasts[i].Relations, 'Reference', 'ChannelIdentifier');
						}
						
						tempBroadcast = new SCS.TV.Broadcast();
						tempBroadcast.broadcastId = tempBroadcasts[i].Identifier;
						tempBroadcast.title = this.title;
						tempBroadcast.summary = '';
						tempBroadcast.language = tempBroadcasts[i].Content.Description.Language;
						tempBroadcast.start = SCS.Const.SNOOPY_IS_OLD_IE ? SCS.TV.Helper.readDateIE8(tempBroadcasts[i].Availabilities[0].AvailabilityStart) : new Date(tempBroadcasts[i].Availabilities[0].AvailabilityStart);
						tempBroadcast.end = SCS.Const.SNOOPY_IS_OLD_IE ? SCS.TV.Helper.readDateIE8(tempBroadcasts[i].Availabilities[0].AvailabilityEnd) : new Date(tempBroadcasts[i].Availabilities[0].AvailabilityEnd);
						tempBroadcast.duration = Math.round((tempBroadcast.end - tempBroadcast.start) / 60000);
						tempBroadcast.price = tempBroadcasts[i].Availabilities[0].Price;
						if (tempBroadcast.price > 0) { // web users pay 2.- more to rent the stream
							tempBroadcast.price += SCS.Const.SNOOPY_WEB_RENT_SURCHARGE;
						}
						tempBroadcast.currency = tempBroadcasts[i].Availabilities[0].Currency;
						tempBroadcast.channelId = tempChannel ? tempChannel.TargetIdentifier : '';
						tempBroadcast.posterUrl = SCS.TV.Broadcast.posterUrl.replace('{broadcastid}', tempBroadcast.broadcastId);

						this.broadcasts.push(tempBroadcast);
					}
				}

			}

		},

		/**
		 * reads paritipant node and returns object with name and logo-url
		 */
		_readParticipantData: function(participantNode) {
			var participant = {},
				logoNode;
			if (participantNode.TargetNode.Content && participantNode.TargetNode.Content.Description) {
				participant.name = participantNode.TargetNode.Content.Description.Title;
			}
			if (participantNode.TargetNode.Content && participantNode.TargetNode.Content.Nodes && participantNode.TargetNode.Content.Nodes) {
				logoNode = SCS.TV.Helper.getFirstElementOfKindAndRoleAndShape(participantNode.TargetNode.Content.Nodes.Items, 'Image', 'Logo');
				if (logoNode) {
					participant.logo = SCS.Const.SNOOPY_SERVICE_PROXY_URL + 'content/images/sport/participant/' + logoNode.Identifier + '_W90.png';
				}
			}
			return participant;

		},

		/**
		 * Tries to automatically select the correct broadcast for a sportevent
		 * Strangely - there are TV channels with no price - but these cannot be used here, as they are the channels
		 * that are integrated into a subscription. Therefore all broadcasts that have no price, are excluded
		 * @lang can be used to override default language
		 */
		getAutomaticSelectedBroadcast: function(lang) {
			var broadcastsWithBestLanguage = [],
				broadcastsWithPrice = [],
				cheapest = null;

			if (!lang) {
				lang = SCS.Const.SNOOPY_LANGUAGE;
			}

			for (var i = 0; i < this.broadcasts.length; i++) {
				if (this.broadcasts[i].language && this.broadcasts[i].language.indexOf(lang) === 0) {
					broadcastsWithBestLanguage.push(this.broadcasts[i]);
				}
			}
			if (broadcastsWithBestLanguage.length === 0) {
				broadcastsWithBestLanguage = this.broadcasts;
			}

			if (broadcastsWithBestLanguage.length === 0) {
				return null;
			}

			for (i = 0; i < broadcastsWithBestLanguage.length; i++) {
				if (broadcastsWithBestLanguage[i].price) {
					broadcastsWithPrice.push(broadcastsWithBestLanguage[i]);
				}
			}

			cheapest = broadcastsWithPrice[0];
			for (i = 0; i < broadcastsWithPrice.length; i++) {
				if (cheapest.price > broadcastsWithPrice[i].price) {
					cheapest = broadcastsWithPrice[i];
				}
			}
			return cheapest;
		},

		/**
		 * returns details url which should show sportevent in tv-app - if not logged in, the use should at least be redirected to the sports-page
		 */
		getDetailsUrl: function() {
			return SCS.TV.SportEvent.getDetailsUrl(this.sportEventId);
		}
	};


	SCS.TV.SportEvent = SportEvent;

}(__webpack_provided_window_dot_jQuery, window.SCS = window.SCS || {}, window.debug));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery) {//noinspection JSUnusedLocalSymbols
(function($) {
	'use strict';

	/**
	 * Loader and handler for SportEvents (based on the "sportal" data)
	 *
	 * @author Dave Talamona
	 * @class SCS.SportEvents
	 */

	// init namespace
	window.SCS = window.SCS || {};

	// private variables with library scope
	var events = [],
		isLoading = false,
		isLoaded = false,
		loadWasSuccessful = false,
		loadListeners = [],
		tvBackendDataStore = [];

	window.SCS.SportEvents = {
		/**
		 * This callback function is called after events are loaded
		 * @callback eventsLoadedCallback
		 * @param {bool} loadWasSuccessful
		 * @param {SCS.SportEvents.Event[]} events
		 */
		/**
		 * @param {String} url - Sportal data url
		 * @param {eventsLoadedCallback} callback - Callback is called after events are loaded
		 * @return void
		 */
		load: function (url, callback) {
			var jsonData;

			if (!isLoading && !isLoaded) {
				isLoading = true;

				// create callback for jsonP
				window.SCS.sportal = window.SCS.sportal || {};
				window.SCS.sportal.ticker = function (data) {
					jsonData = data;
				};

				// load jsonP (via "type=script" and not "jsonp" because of problems with the callback name config in jQuery)
				$.getScript(url)
					.done(function () {
						var singleEvent;

						loadWasSuccessful = true;

						// process and save data
						for (var i = 0; jsonData && jsonData.length && i < jsonData.length; i++) {
							singleEvent = new SCS.SportEvents.Event(jsonData[i]);

							// check if event is valid
							if (singleEvent.id && singleEvent.title && (singleEvent.hasStream || singleEvent.hasTicker)) {
								events.push(singleEvent);
							}
						}
					})
					.fail(function () {
						loadWasSuccessful = false;
					})
					.always(function () {
						debug.log("SCS.SportEvents > loaded", events);

						// call every registered load-listener
						for (var i = 0; i < loadListeners.length; i++) {
							loadListeners[i](loadWasSuccessful, [].concat(events));
						}

						isLoaded = true;
						isLoading = false;
					});
			}

			// handle callback
			if (typeof callback == 'function') {
				if (isLoaded) {
					callback(loadWasSuccessful, [].concat(events));
				} else {
					loadListeners.push(callback);
				}
			}
		},

		/**
		 * Filters all events by given options
		 * @param {Object} [options] - Configure the event-subset
		 * @param {Date} [options.maxDate] - All events further in the future then this date
		 * @param {bool} [options.includingFinished=false] - Include finished events (from the past)
		 * @param {bool} [options.ppvOnly=false] - Exclude Free-TV events
		 * @param {String} [options.sportid] - Only events with this sport-id
		 * @return {SCS.SportEvents.Event[]}
		 */
		getEvents: function (options) {
			var eventSubset = [].concat(events), // create a copy of the events array
				i;

			options = options || {};

			for (i = 0; i < eventSubset.length; i++) {
				if (
					// remove events outside of a given timeframe (only if option "maxDate" is set)
					(
						options.maxDate &&
						options.maxDate < eventSubset[i].date
					) ||
					// remove finished events normally but NOT if option "includingFinished" is set to TRUE
					(
						options.includingFinished !== true &&
						eventSubset[i].finished
					) ||
					// remove Free-TV events
					(
						options.ppvOnly &&
						!eventSubset[i].ppvData
					) ||
					// remove events when other criteria does not match
					(
						options.sportid &&
						eventSubset[i].sportid != options.sportid
					)
				) {
					eventSubset.splice(i, 1);
					i--;
				}
			}

			debug.log("SCS.SportEvents > getEventSubset", options, eventSubset);

			return eventSubset;
		},

		/**
		 * @param {String} id
		 * @return {SCS.SportEvents.Event}
		 */
		findById: function (id) {
			for (var i = 0; i < events.length; i++) {
				if (events[i].id == id) {
					return events[i];
				}
			}

			return null;
		},

		/**
		 * @param {SCS.SportEvents.Event[]} [eventSubset] - events eg. gotten from SCS.SportEvents.getEvents
		 * @param {Object} [options]
		 * @param {String} [options.todayLabel]
		 * @param {String} [options.tomorrowLabel]
		 * @return {Object[]} - Array of Objects containing the title and an array of events
		 */
		groupEventsByDate: function (eventSubset, options) {
			var datesObj = {},
				datesArr = [],
				datesTimestamps = [],
				timestamp,
				firstEvent,
				i;

			eventSubset = eventSubset || events;
			options = options || {};

			for (i = 0; i < eventSubset.length; i++) {
				timestamp = window.SCS.utils.date.resetTime(eventSubset[i].startTime).getTime();

				if (!datesObj[timestamp]) {
					datesObj[timestamp] = [];
					datesTimestamps.push(timestamp);
				}

				datesObj[timestamp].push(eventSubset[i]);
			}

			datesTimestamps.sort();

			for (i = 0; i < datesTimestamps.length; i++) {
				timestamp = datesTimestamps[i];
				firstEvent = datesObj[timestamp][0];

				datesArr.push({
					title: (firstEvent.today && options.todayLabel ? options.todayLabel : (firstEvent.tomorrow && options.tomorrowLabel ? options.tomorrowLabel : window.SCS.utils.date.format(firstEvent.startTime))),
					events: datesObj[timestamp]
				});
			}

			return datesArr;
		},

		/**
		 * Create a list of all sport types found in the given events (ordered alphabetically by sport names)
		 * @param {SCS.SportEvents.Event[]} [eventSubset] - Events eg. gotten from SCS.SportEvents.getEvents
		 * @param {Object} [options]
		 * @param {String} [options.idPropertyName] - The name of the property for the sportTypes ID in the returned objects (defaults to 'id')
		 * @param {String} [options.namePropertyName] - The name of the property for the sportTypes NAME in the returned objects (defaults to 'name')
		 * @return {Object} - an Object containing
		 */
		getSportTypes: function (eventSubset, options) {
			var sportTypes = [],
				sportIds = {},
				sportNames = [],
				i, event, obj;

			eventSubset = eventSubset || [].concat(events); // create a copy of the events array if no subset parameter is passed
			options = options || {};

			for (i = 0; i < eventSubset.length; i++) {
				event = eventSubset[i];

				if (!sportIds[event.sport]) {
					sportIds[event.sport] = event.sportid;
					sportNames.push(event.sport);
				}
			}

			sportNames.sort();

			for (i = 0; i < sportNames.length; i++) {
				obj = {};
				obj[options.idPropertyName || 'id'] = sportIds[sportNames[i]];
				obj[options.namePropertyName || 'name'] = sportNames[i];
				sportTypes.push(obj);
			}

			debug.log("SCS.SportEvents > getSportTypes", eventSubset, sportTypes);

			return sportTypes;
		},

		/**
		 * This callback function is called after events are loaded
		 * @callback eventsEnrichedCallback
		 * @param {SCS.SportEvents.Event[]} events
		 */
		/**
		 * Enrich event data with data loaded from the the TV backend
		 * @param {SCS.SportEvents.Event[]} [eventSubset] - Events eg. gotten from SCS.SportEvents.getEvents
		 * @param {Object} [options]
		 * @param {bool} [options.checkRentalStatus] - The name of the property for the sportTypes ID in the returned objects (defaults to 'id')
		 * @param {eventsEnrichedCallback} callback - Callback is called after events are altered/enriched
		 * @return void - Function directly alters the passed eventSubset
		 */
		enrichPpvEventsWithTvBackendData: function (eventSubset, options, callback) {
			$.when(

				// load event specific data from TV backend
				(function () {
					var defer = jQuery.Deferred(),
						idsToLoad = [],
						loadedData = [];

					// check for already loaded/cached values
					$(eventSubset).each(function () {
						var id = (this.ppvData || {}).identifier;

						// only proceed if it's a PPV event
						if (id) {
							if (tvBackendDataStore[id]) {
								loadedData.push(tvBackendDataStore[id]);
							} else {
								idsToLoad.push(id);
							}
						}
					});

					if (!idsToLoad.length) {
						defer.resolve(loadedData);
					} else {
						SCS.TV.getMultipleSportEventsById(idsToLoad, function (sportEvents) {
							$(sportEvents).each(function () {
								tvBackendDataStore[this.sportEventId] = this;
								loadedData.push(this);
							});

							defer.resolve(loadedData);
						});
					}

					return defer.promise();
				})(),

				// load purchases via snoopy from TV backend
				(function () {
					var defer = jQuery.Deferred(),
						broadcastIds = [];

					if (options.checkRentalStatus && SCS.snoopyInit) { // SCS.snoopyInit is available in Bluewin environment only
						SCS.snoopyInit(function () {
							if (!tvSessionService.currentSession.isActive) {
								defer.resolve(broadcastIds);
							} else {
								tvPurchasingService.Refresh(function () {
									if (tvPurchasingService.purchasingsListPPV && tvPurchasingService.purchasingsListPPV.length) {
										for (var i=0; tvPurchasingService.purchasingsListPPV[i]; i++) {
											broadcastIds.push(tvPurchasingService.purchasingsListPPV[i].subject);
										}
									}
									defer.resolve(broadcastIds);
								}, false);
							}
						});
					} else {
						defer.resolve(broadcastIds);
					}

					return defer.promise();
				})()

			).done(function (sportEvents, rentedBroadcastIds) {
				// iterate through each ppv event
				$(eventSubset).each(function () {
					var event = this,
						sportEvent = null, // instance of SCS.TV.SportEvent
						i = 0;

					// only proceed if it's a PPV event
					if (!event.ppvData) {
						return;
					}

					// find matching sport event
					for (i=0; sportEvents[i]; i++) {
						if (sportEvents[i].sportEventId == event.ppvData.identifier) {
							sportEvent = sportEvents[i];
						}
					}
					if (!sportEvent || !sportEvent.broadcasts.length) {
						event.hasError = true;
						return;
					}

					// get broadcast id and check rental status
					{
						var rentedBroadcast = null,
							setEventNotRented = function () {
								event.broadcast = sportEvent.getAutomaticSelectedBroadcast(event.language) || {};
								event.broadcastId = event.broadcast.broadcastId;
								event.isRented = false;

								if (!event.broadcastId) {
									event.hasError = true;
								}
							};

						if (options.checkRentalStatus) {
							// find rented broadcast
							for (i=0; sportEvent.broadcasts[i]; i++) {
								var broadcastIndex = jQuery.inArray(sportEvent.broadcasts[i].broadcastId, rentedBroadcastIds);

								if (broadcastIndex !== -1) {
									rentedBroadcast = sportEvent.broadcasts[i];
								}
							}

							// broadcast is rented -> apply found rented broadcast id to event
							if (rentedBroadcast) {
								event.broadcast = rentedBroadcast;
								event.broadcastId = rentedBroadcast.broadcastId;
								event.isRented = true;
							}

							// broadcast is not rented -> apply best guessed broadcast to event (matching language and cheapest price)
							else {
								setEventNotRented();
							}
						} else {
							// assume broadcast is not rented -> apply best guessed broadcast to event (matching language and cheapest price)
							setEventNotRented();
						}
					}
				});

				callback();
			});
		}
	};

})(jQuery);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery) {//noinspection JSUnusedLocalSymbols
(function($) {
	'use strict';

	/**
	 * SportEvent (based on the "sportal" data)
	 *
	 * @author Dave Talamona
	 * @class SCS.SportEvents.Event
	 */

	// init namespace
	window.SCS = window.SCS || {};
	window.SCS.SportEvents = window.SCS.SportEvents || {};


	var zeroFill = __webpack_require__(4).zeroFill;

	// private variables with class scope
	var privatesInitialized = false,
		now, language, // definition in helper function "initPrivates"
		oneHourMilliseconds = 60 * 60 * 1000,
		oneDayMilliseconds = 24 * oneHourMilliseconds,
		endNotDefinedOffset = 4 * oneHourMilliseconds, // [ms] If an event has no end defined in the stream info then the start is taken and this offset is added (advice and definition of duration by Alain Vergères, 09.03.2015)
		languageFallbackChane = ['browser', 'en', 'de', 'first']; // 'browser' is the browsers language, 'first' is the first language that is found

	// constructor
	window.SCS.SportEvents.Event = function (json) {
		var i, j, counter, start, end, tvDataStore;

		// class init
		if (!privatesInitialized) {
			privateHelpers.initPrivates();
		}

		// save json data for later use in other scripts
		this.json = json;

		this.id = json.MATCHID;

		this.date = new Date(Number(json.DATE) * 1000);
		this.time = json.TIME;

		this.title = json.HEADLINE;
		this.sport = json.SPORT;
		this.sportid = (json.SPORTID != '' ? json.SPORTID : json.SPORT.toLowerCase());
		this.competition = json.COMPETITION;
		this.descr = this.sport + (this.sport && this.competition ? ', ' : '') + this.competition;

		this.result = (json.RESULT ? json.RESULT.replace(/,\s*/g, ', ') : ''); // json.RESULT can be null

		this.reference = json.REFERENCE;

		this.language = '';

		// check for FreeTv schedule
		{
			this.freeTvData = null;
			tvDataStore = [];

			start = SCS.utils.date.fromString(json['TVSTARTFREE']);
			end = SCS.utils.date.fromString(json['TVENDFREE']);

			// find all valid broadcasts
			for (i = 0, counter = ''; i <= 8; i++, counter = i) { // According to the specification there are 9 senders 0 to 8. 0 is no number in the name => SENDER, SENDER1, SENDER2, ...SENDER8.
				if (json['SENDER' + counter] && json['SENDER' + counter + 'LANGUAGE']) {
					tvDataStore.push({
						sender: json['SENDER' + counter],
						start: start,
						end: end,
						language: json['SENDER' + counter + 'LANGUAGE'].toLowerCase()
					});
				}
			}

			// find the the broadcasts with best matching language (according to setting in "languageFallbackChane" variable)
			for (i = 0; !this.freeTvData && i < languageFallbackChane.length; i++) {
				for (j = 0; !this.freeTvData && j < tvDataStore.length; j++) {
					if (
						tvDataStore[j].language == languageFallbackChane[i] ||
						(languageFallbackChane[i] == 'browser' && tvDataStore[j].language == language) ||
						languageFallbackChane[i] == 'first'
					) {
						this.freeTvData = tvDataStore[j];
						this.language = this.freeTvData.language;
					}
				}
			}
		}

		// check for PPV schedule
		{
			this.ppvData = null;
			tvDataStore = [];

			if (json.PPVCH == 'ja' && !this.freeTvData) {
				// find all valid broadcasts
				for (i = 1, counter = ''; i <= 3; i++, counter = i) { // According to the specification there can be up to 3 pay per view identifiers, start and end times
					if (json['PROGRAMIDENTIFIER' + counter] && json['PROGRAMLANGUAGE' + counter]) {
						tvDataStore.push({
							identifier: json['PROGRAMIDENTIFIER' + counter],
							start: SCS.utils.date.fromString(json['TVSTART' + counter]),
							end: SCS.utils.date.fromString(json['TVEND' + counter]),
							language: json['PROGRAMLANGUAGE' + counter].toLowerCase()
						});
					}
				}

				// find the the broadcasts with best matching language (according to setting in "languageFallbackChane" variable)
				for (i = 0; !this.ppvData && i < languageFallbackChane.length; i++) {
					for (j = 0; !this.ppvData && j < tvDataStore.length; j++) {
						if (
							tvDataStore[j].language == languageFallbackChane[i] ||
							(languageFallbackChane[i] == 'browser' && tvDataStore[j].language == language) ||
							languageFallbackChane[i] == 'first'
						) {
							this.ppvData = tvDataStore[j];
							this.language = this.ppvData.language;
						}
					}
				}
			}
		}

		// set start and end time directly on the event
		if (this.freeTvData && this.freeTvData.start) {
			this.startTime = this.freeTvData.start;
			this.endTime = (this.freeTvData.end ? this.freeTvData.end : new Date(this.startTime.getTime() + endNotDefinedOffset));
		} else if (this.ppvData && this.ppvData.start) {
			this.startTime = this.ppvData.start;
			this.endTime = (this.ppvData.end ? this.ppvData.end : new Date(this.startTime.getTime() + endNotDefinedOffset));
		} else {
			this.startTime = this.date;
			this.endTime = new Date(this.date.getTime() + endNotDefinedOffset);
		}

		// correct differences in stream start time and given JSON date/time -> take stream time (advice and definition of duration by Alain Vergères, 09.03.2015)
		if (this.date.getTime() != this.startTime.getTime()) {
			this.date = this.startTime;
			this.time = zeroFill(this.date.getHours()) + ':' + zeroFill(this.date.getMinutes());
		}

		// set flags
		this.hasTicker = (json.TICKER == 'ja');
		this.hasStream = !!(this.freeTvData || this.ppvData);

		// set stream/timing status flags
		this.finished = (json.STATUS == 'fin' || now > this.endTime); // check for date because sometimes sportal does not set the status to "fin"
		this.today = ((now.getDate() == this.startTime.getDate() || now.getDate() == this.endTime.getDate()) || (now > this.startTime && !this.finished));
		this.tomorrow = ((new Date(now.getTime() + oneDayMilliseconds)).getDate() == this.startTime.getDate() && now > this.startTime - (2 * oneDayMilliseconds));
		this.live = (this.today && (json.STATUS == 'live' || (now >= this.startTime && now < this.endTime))); // check for today because sometimes sportal delivers LIVE markers for events in the future

		// set status css class (used by different modules)
		//noinspection JSUnusedGlobalSymbols
		this.cssClasses = (this.finished ? 'finished' : (this.live ? 'live' : 'scheduled'));

		// set details url
		this.url =
			location.href.match(/https?:\/\/.+?\/[a-z]{2}\//)[0] + // find the actual url starting with the protocol and including the language
			'sport/' + this.sportid +
			'/live-ticker.html#' + this.id;
	};

	// class
	window.SCS.SportEvents.Event.prototype = {
		constructor : window.SCS.SportEvents.Event
	};

	// helpers
	var privateHelpers = {
		initPrivates: function () {
			// get language of the actual page
			language = ($('html').attr('lang') || 'de').toLowerCase();

			// get servers time
			now = SCS.utils.getServerTime(); // can be a little off for browsers with different timezone (see JsDOc for detailed description)
		}
	};

})(jQuery);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery) {/**
 * Cookie plugin
 *
 * Copyright (c) 2006 Klaus Hartl (stilbuero.de)
 * Dual licensed under the MIT and GPL licenses:
 * http://www.opensource.org/licenses/mit-license.php
 * http://www.gnu.org/licenses/gpl.html
 *
 */

/**
 * Create a cookie with the given name and value and other optional parameters.
 *
 * @example $.cookie('the_cookie', 'the_value');
 * @desc Set the value of a cookie.
 * @example $.cookie('the_cookie', 'the_value', { expires: 7, path: '/', domain: 'jquery.com', secure: true });
 * @desc Create a cookie with all available options.
 * @example $.cookie('the_cookie', 'the_value');
 * @desc Create a session cookie.
 * @example $.cookie('the_cookie', null);
 * @desc Delete a cookie by passing null as value. Keep in mind that you have to use the same path and domain
 *	   used when the cookie was set.
 *
 * @param String name The name of the cookie.
 * @param String value The value of the cookie.
 * @param Object options An object literal containing key/value pairs to provide optional cookie attributes.
 * @option Number|Date expires Either an integer specifying the expiration date from now on in days or a Date object.
 *							 If a negative value is specified (e.g. a date in the past), the cookie will be deleted.
 *							 If set to null or omitted, the cookie will be a session cookie and will not be retained
 *							 when the the browser exits.
 * @option String path The value of the path atribute of the cookie (default: path of page that created the cookie).
 * @option String domain The value of the domain attribute of the cookie (default: domain of page that created the cookie).
 * @option Boolean secure If true, the secure attribute of the cookie will be set and the cookie transmission will
 *						require a secure protocol (like HTTPS).
 * @type undefined
 *
 * @name $.cookie
 * @cat Plugins/Cookie
 * @author Klaus Hartl/klaus.hartl@stilbuero.de
 */

/**
 * Get the value of a cookie with the given name.
 * 
 * @example $.cookie('the_cookie');
 * @desc Get the value of a cookie.
 * 
 * @param String
 *			name The name of the cookie.
 * @return The value of the cookie.
 * @type String
 * 
 * @name $.cookie
 * @cat Plugins/Cookie
 * @author Klaus Hartl/klaus.hartl@stilbuero.de
 */
jQuery.cookie = function(name, value, options) {
	if (typeof value != 'undefined') { // name and value given, set cookie
		options = options || {};
		if (value === null) {
			value = '';
			options.expires = -1;
		}
		var expires = '';
		if (options.expires
				&& (typeof options.expires == 'number' || options.expires.toUTCString)) {
			var date;
			if (typeof options.expires == 'number') {
				date = new Date();
				date.setTime(date.getTime()
						+ (options.expires * 24 * 60 * 60 * 1000));
			} else {
				date = options.expires;
			}
			expires = '; expires=' + date.toUTCString(); // use expires
															// attribute,
															// max-age is
															// not supported
															// by IE
		}
		// CAUTION: Needed to parenthesize options.path and options.domain
		// in the following expressions, otherwise they evaluate to
		// undefined
		// in the packed version for some reason...
		var path = options.path ? '; path=' + (options.path) : '';
		var domain = options.domain ? '; domain=' + (options.domain) : '';
		var secure = options.secure ? '; secure' : '';
		document.cookie = [ name, '=', encodeURIComponent(value), expires,
				path, domain, secure ].join('');
	} else { // only name given, get cookie
		var cookieValue = null;
		if (document.cookie && document.cookie != '') {
			var cookies = document.cookie.split(';');
			for ( var i = 0; i < cookies.length; i++) {
				var cookie = jQuery.trim(cookies[i]);
				// Does this cookie string begin with the name we want?
				if (cookie.substring(0, name.length + 1) == (name + '=')) {
					try {
						cookieValue = decodeURIComponent(cookie
								.substring(name.length + 1));
					} catch (e) {
						// added by swisscom: 05.12.2013 Cesar Keller
						// handle legacy cookies encoded with ISO-8859-1
						cookieValue = unescape(cookie
								.substring(name.length + 1));
					}
					break;
				}
			}
		}
		return cookieValue;
	}
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 96 */
/***/ (function(module, exports) {

/*
 * Date Format 1.2.3
 * (c) 2007-2009 Steven Levithan <stevenlevithan.com>
 * MIT license
 *
 * Includes enhancements by Scott Trenda <scott.trenda.net>
 * and Kris Kowal <cixar.com/~kris.kowal/>
 *
 * Accepts a date, a mask, or a date and a mask.
 * Returns a formatted version of the given date.
 * The date defaults to the current date/time.
 * The mask defaults to dateFormat.masks.default.
 */

var scsHeaderDateFormat = (function() {
	var token = /d{1,4}|m{1,4}|yy(?:yy)?|([HhMsTt])\1?|[LloSZ]|"[^"]*"|'[^']*'/g,
		timezone = /\b(?:[PMCEA][SDP]T|(?:Pacific|Mountain|Central|Eastern|Atlantic) (?:Standard|Daylight|Prevailing) Time|(?:GMT|UTC)(?:[-+]\d{4})?)\b/g,
		timezoneClip = /[^-+\dA-Z]/g,
		pad = function(val, len) {
			val = String(val);
			len = len || 2;
			while (val.length < len) {
				val = "0" + val;
			}
			return val;
		};

	// Regexes and supporting functions are cached through closure
	return function dF(date, mask, utc) {
		// You can't provide utc if you skip other args (use the "UTC:" mask prefix)
		if (arguments.length == 1 && Object.prototype.toString.call(date) == "[object String]" && !/\d/.test(date)) {
			mask = date;
			date = undefined;
		}

		// Passing date through Date applies Date.parse, if necessary
		date = date ? new Date(date) : new Date;
		if (isNaN(date)) {
			throw SyntaxError("invalid date");
		}

		mask = String(dF.masks[mask] || mask || dF.masks["default"]);

		// Allow setting the utc argument via the mask
		if (mask.slice(0, 4) == "UTC:") {
			mask = mask.slice(4);
			utc = true;
		}

		var _ = utc ? "getUTC" : "get",
			d = date[_ + "Date"](),
			D = date[_ + "Day"](),
			m = date[_ + "Month"](),
			y = date[_ + "FullYear"](),
			H = date[_ + "Hours"](),
			M = date[_ + "Minutes"](),
			s = date[_ + "Seconds"](),
			L = date[_ + "Milliseconds"](),
			o = utc ? 0 : date.getTimezoneOffset(),
			flags = {
				d: d,
				dd: pad(d),
				ddd: dF.i18n.dayNames[D],
				dddd: dF.i18n.dayNames[D + 7],
				m: m + 1,
				mm: pad(m + 1),
				mmm: dF.i18n.monthNames[m],
				mmmm: dF.i18n.monthNames[m + 12],
				yy: String(y).slice(2),
				yyyy: y,
				h: H % 12 || 12,
				hh: pad(H % 12 || 12),
				H: H,
				HH: pad(H),
				M: M,
				MM: pad(M),
				s: s,
				ss: pad(s),
				l: pad(L, 3),
				L: pad(L > 99 ? Math.round(L / 10) : L),
				t: H < 12 ? "a" : "p",
				tt: H < 12 ? "am" : "pm",
				T: H < 12 ? "A" : "P",
				TT: H < 12 ? "AM" : "PM",
				Z: utc ? "UTC" : (String(date).match(timezone) || [""]).pop().replace(timezoneClip, ""),
				o: (o > 0 ? "-" : "+") + pad(Math.floor(Math.abs(o) / 60) * 100 + Math.abs(o) % 60, 4),
				S: ["th", "st", "nd", "rd"][d % 10 > 3 ? 0 : (d % 100 - d % 10 != 10) * d % 10]
			};

		return mask.replace(token, function($0) {
			return $0 in flags ? flags[$0] : $0.slice(1, $0.length - 1);
		});
	};
})();

// Some common format strings
scsHeaderDateFormat.masks = {
	"default": "ddd mmm dd yyyy HH:MM:ss",
	shortDate: "m/d/yy",
	mediumDate: "mmm d, yyyy",
	longDate: "mmmm d, yyyy",
	fullDate: "dddd, mmmm d, yyyy",
	shortTime: "h:MM TT",
	mediumTime: "h:MM:ss TT",
	longTime: "h:MM:ss TT Z",
	isoDate: "yyyy-mm-dd",
	isoTime: "HH:MM:ss",
	isoDateTime: "yyyy-mm-dd'T'HH:MM:ss",
	isoUtcDateTime: "UTC:yyyy-mm-dd'T'HH:MM:ss'Z'"
};

// Internationalization strings
scsHeaderDateFormat.i18n = {
	dayNames: [
		"Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat",
		"Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"
	],
	monthNames: [
		"Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec",
		"January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"
	]
};

window.scsHeaderDateFormat = scsHeaderDateFormat;

/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lib_vendor_terrific_Module__ = __webpack_require__(3);


var BREAKPOINT_MOBILE = 768;
function setDataWidth($list) {
    // Store each items outer-with inclusive margin
    $list.each(function (_idx, element) {
        var $li = $(element);
        $li.data('width', $(element).outerWidth(true) || 0);
    });
}
/**
 * Level 2 of header support
 *
 * @author Nikola Tica
 * @class HeaderLvl2
 * @extends Tc.Module
 */
var HeaderLvl2 = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */])(HeaderLvl2, _super);
    function HeaderLvl2() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    HeaderLvl2.prototype.on = function (callback) {
        var _this = this;
        this.mediaQueryList = window.matchMedia("(max-width: " + BREAKPOINT_MOBILE + "px)");
        if (this.$ctx.find('.scsh-lvl2-navi > li').length) {
            this.initBreakDown();
            this.$ctx.find('.scsh-lvl2-container.scsh-has-child-pages h1').on('click', function (evt) {
                if (_this.mediaQueryList.matches) {
                    $(evt.target).toggleClass('active').closest('.scsh-lvl2-container').find('.scsh-lvl2-navi').toggleClass('active');
                }
            });
            // Listener for click on overflow-nav dropdown
            this.$ctx.find('.scsh-lvl2-overflow-container > a').on('click', function () {
                var overflowContainer = _this.$ctx.find('.scsh-lvl2-overflow-container');
                overflowContainer.trigger('scsh-flyout-open', [function () { return overflowContainer.removeClass('scsh-active'); }]);
                overflowContainer.addClass('scsh-active');
            });
        }
        this.initiTracking();
        callback();
    };
    /**
     * Setup functionality for putting level 2 navigations links on dropdown in
     * `more` button depending on screen size
     */
    HeaderLvl2.prototype.initBreakDown = function () {
        var _this = this;
        var $nav = this.$ctx.find('.scsh-lvl2-navi');
        var $overflowNav = this.$ctx.find('.scsh-lvl2-overflow-navi');
        var $overflowContainer = this.$ctx.find('.scsh-lvl2-overflow-container');
        var $maxXPosElement = $nav.closest('.scsh-lvl2-container');
        var $firstNavItem = $nav.children().first();
        var firstNavItemSpacingToTitle = ($firstNavItem.css('margin-left') || '0').replace('px', '');
        var lastHeaderWidth = 0;
        var overflowNavVisible = false;
        var $mobilizedItems = $();
        var widthCalculated = false;
        if (!this.mediaQueryList.matches) {
            setDataWidth($nav.children());
            widthCalculated = true;
        }
        var resizeTimeout;
        $(window).on('resize', function () {
            // Use timeout to throttle
            window.clearTimeout(resizeTimeout);
            resizeTimeout = window.setTimeout(function () {
                var headerWidth = _this.$ctx.width() || 0;
                var $navItems = $nav.children();
                // Do not do anything if (complete) mobile view is active
                if (_this.mediaQueryList.matches) {
                    if (!$mobilizedItems.length) {
                        $mobilizedItems = $overflowNav.children().appendTo($nav);
                    }
                    return;
                }
                if ($mobilizedItems.length) {
                    if (!widthCalculated) {
                        widthCalculated = true;
                        setDataWidth($nav.children());
                    }
                    $mobilizedItems.appendTo($overflowNav);
                    $mobilizedItems = $();
                }
                if ((headerWidth < lastHeaderWidth || !lastHeaderWidth) && $navItems.length > 1) {
                    // Screen got smaller -> check for moving items to overflow nav
                    var maxXPos = Math.round($maxXPosElement.offset().left + $maxXPosElement.width());
                    var $lastElement = (overflowNavVisible ? $overflowContainer : $navItems.last());
                    // Move all but the first item into overflow navi (ignore frst one to prevent just having the overflow navi there)
                    while ($navItems.length > 1 && Math.floor($lastElement.offset().left + $lastElement.outerWidth()) > maxXPos) {
                        var $lastNavItem = $navItems.last();
                        // Move to overflow-list
                        $lastNavItem.prependTo($overflowNav);
                        // Remove the last item from the set
                        $navItems = $navItems.not($lastNavItem);
                        if (!overflowNavVisible) {
                            $overflowContainer.addClass('is-visible');
                            overflowNavVisible = true;
                            $lastElement = $overflowContainer;
                        }
                    }
                }
                else if (headerWidth > lastHeaderWidth && overflowNavVisible) {
                    // Screen got bigger -> check for moving items back to normal nav
                    var availableSpace = Math.floor($firstNavItem.offset().left -
                        parseInt(firstNavItemSpacingToTitle, 10) - $nav.offset().left);
                    var $overflowItems = $overflowNav.children();
                    var $firstOverflowElement = $overflowItems.first();
                    while ($overflowItems.length && availableSpace >= $firstOverflowElement.data('width')) {
                        // Move back to normal-list
                        $firstOverflowElement.appendTo($nav);
                        // Reduce available space by the moved elements width
                        availableSpace -= $firstOverflowElement.data('width');
                        // Get new first item in overflow-nav
                        $overflowItems = $overflowItems.not($firstOverflowElement); // Remove the first item from the set
                        $firstOverflowElement = $overflowItems.first(); // Get the new first item
                        if (!$overflowItems.length) {
                            $overflowContainer.removeClass('is-visible');
                            overflowNavVisible = false;
                        }
                    }
                }
                lastHeaderWidth = headerWidth;
            }, 10);
        });
        $(window).trigger('resize');
    };
    HeaderLvl2.prototype.initiTracking = function () {
        // Back button
        this.$ctx.find('.scsh-dynamic scsh-lvl2-area .scsh-back').on('click', function (e) {
            scsHeader.siteCatalyst.trackClick(e.currentTarget, e, 'back', 'l2-navigation');
        });
        // Level 2 links
        this.$ctx.find('.scsh-dynamic .scsh-lvl2-area .scsh-lvl2-navi li a').on('click', function (e) {
            scsHeader.siteCatalyst.trackClick(e.currentTarget, e, $(e.currentTarget).data('tracking-link-name') || $(e.currentTarget).find('h3').text(), 'l2-navigation');
        });
    };
    return HeaderLvl2;
}(__WEBPACK_IMPORTED_MODULE_1_lib_vendor_terrific_Module__["a" /* Module */]));
/* harmony default export */ __webpack_exports__["a"] = (HeaderLvl2);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lib_vendor_terrific_Module__ = __webpack_require__(3);


function handleClick(evt) {
    var $item = $(evt.currentTarget).closest('.scsh-has-subnav');
    // Deactivate other active items
    {
        // Other LIs on the same level
        $item.siblings('.active').removeClass('active');
    }
    $item.toggleClass('active');
    // This makes the MDD animate promptly and makes click tracking asynchronous.
    evt.preventDefault();
    var $a = $($item.find('a').get(0));
    var trackingLinkName = $a.data('tracking-link-name') || $a.text();
    scsHeader.siteCatalyst
        .trackClick($a.get(0), evt, trackingLinkName, 'l1-mdd');
}
/**
 * Mega Drop Down support
 *
 * @author Nikola Tica
 * @class MDD
 * @extends Tc.Module
 */
var MDD = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */])(MDD, _super);
    function MDD() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MDD.prototype.on = function (callback) {
        var _this = this;
        // Close MDD on outsied click
        if (this.$ctx.data('attach-global-listeners')) {
            $(document).on('click', function (e) {
                if (!$(e.target).closest('.menu-items').length) {
                    _this.$ctx.find('.scsh-icon-menu > li.active, .menu-items > li.scsh-has-subnav.active')
                        .not(':has(> .modFlyout)').find('> a, .lvl1-item a')
                        .trigger('click');
                }
            });
        }
        this.initMDD();
        this.initMDDTracking();
        callback();
    };
    MDD.prototype.initMDD = function () {
        var items = this.$ctx.find('.menu-items > .scsh-has-subnav');
        items.children('.lvl1-item').on('click', function (evt) {
            if (evt.originalEvent) {
                setTimeout(function () { return handleClick(evt); });
            }
            else {
                handleClick(evt);
            }
        });
    };
    MDD.prototype.initMDDTracking = function () {
        this.$ctx.find('.secondary-navigation .link .aTag').on('click', function (evt) {
            var $this = $(evt.currentTarget);
            var $mddLvl1Link = $this.closest('.scsh-has-subnav').find('h2 a');
            var mddLvl1 = $mddLvl1Link.data('tracking-link-name') ||
                $mddLvl1Link.text() ||
                'mddLvl1';
            var mddLvl2 = $.trim(mddLvl1) + "_" + ($this.data('track-linkname') || $.trim($this.find('h4').text()));
            scsHeader.siteCatalyst.trackClick(evt.currentTarget, evt, mddLvl2, 'l1-mdd');
        });
        this.$ctx.find('.secondary-navigation li a.linklist').on('click', function (evt) {
            var $this = $(evt.currentTarget);
            var $mddLvl1Link = $this.closest('.scsh-has-subnav').find('h2 a');
            var mddLvl1 = $mddLvl1Link.data('tracking-link-name') ||
                $mddLvl1Link.text() ||
                'mddLvl1';
            var mddLvl2 = $this.parents('.column').find('a').data('track-linkname') ||
                $this.parents('.column').find('h4:first, .modPromoBadge').text() ||
                'mddLvl2';
            var mddLvl3 = $.trim(mddLvl1) + "_" + $.trim(mddLvl2) + "_" + ($this.data('tracking-link-name') || $this.text());
            scsHeader.siteCatalyst.trackClick(evt.currentTarget, evt, mddLvl3, 'l1-mdd');
        });
    };
    return MDD;
}(__WEBPACK_IMPORTED_MODULE_1_lib_vendor_terrific_Module__["a" /* Module */]));
/* harmony default export */ __webpack_exports__["a"] = (MDD);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Sandbox; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Module__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_string__ = __webpack_require__(29);


var Sandbox = /** @class */ (function () {
    /**
     * Initializes the Sandbox.
     *
     * @method init
     * @constructor
     * @param {Applicaton} application
     *      The application reference
     * @param {Object} config
     *      The configuration
     */
    function Sandbox(application, config) {
        this.hooks = {
            after: [],
            end: [],
        };
        this.doneAfterHooks = 0;
        this.application = application;
        this.config = config;
    }
    /**
     * Adds (register and start) all modules in the given context scope.
     *
     * @method addModules
     * @param {jQuery} $ctx
     *      The jQuery context
     * @return {Array}
     *      A list containing the references of the registered modules
     */
    Sandbox.prototype.addModules = function ($ctx) {
        var modules = [];
        var application = this.application;
        if ($ctx) {
            // Register modules
            modules = application.registerModules($ctx);
            // Start modules
            application.start(modules);
        }
        return modules;
    };
    /**
     * Removes a module by module instances.
     * This stops and unregisters a module through a module instance.
     *
     * @method removeModules
     * @param {mixed} modules
     *      A list containing the module instances to remove or the jQuery context to look for registered modules in.
     */
    Sandbox.prototype.removeModules = function (modules) {
        var _this = this;
        var application = this.application;
        if (!$.isArray(modules)) {
            var $ctx = modules;
            // Get modules
            var tmpModules_1 = [];
            var $candidates = $ctx.find('.mod').add($ctx.hasClass('mod') ? $ctx : $());
            $candidates.each(function (_, elem) {
                // Check for instance
                // Modified by Raphael Schweikert (taascraa): add ability to have multiple modules on a single element
                var ids = $(elem).data('terrific-ids') || {};
                for (var modName in ids) {
                    var module = _this.getModuleById(ids[modName]);
                    if (module) {
                        tmpModules_1.push(module);
                    }
                }
            });
            modules = tmpModules_1;
        }
        if (modules) {
            // Stop modules
            application.stop(modules);
            // Unregister modules
            application.unregisterModules(modules);
        }
    };
    /**
     * Subscribes a module to a connector.
     *
     * @method subscribe
     * @param {String} connector The full connector name (e.g. MasterSlave-Navigation)
     * @param {Module} module The module instance
     */
    Sandbox.prototype.subscribe = function (connector, module) {
        // Explicitly cast connector to string (e.g. to handle 0 case)
        connector = String(connector);
        // Guards
        if (!module || !connector) {
            throw new Error('subscribe is expecting 2 parameters (connector, module)');
        }
        if (!(module instanceof __WEBPACK_IMPORTED_MODULE_0__Module__["a" /* Module */])) {
            throw new Error('the module param must be an instance of Tc.Module');
        }
        this.application.registerConnection(connector, module);
    };
    /**
     * Unsubscribes a module from a connector.
     *
     * @method unsubscribe
     * @param {String} connectorId The connector channel id (e.g. 2 or Navigation)
     * @param {Module} module The module instance
     */
    Sandbox.prototype.unsubscribe = function (connectorId, module) {
        if (module instanceof __WEBPACK_IMPORTED_MODULE_0__Module__["a" /* Module */] && connectorId) {
            // Explicitly cast connector id to string
            this.application.unregisterConnection(String(connectorId), module);
        }
    };
    /**
     * Gets the appropriate module for the given ID.
     *
     * @method getModuleById
     * @param {int} id
     *      The module ID
     * @return {Module}
     *      The appropriate module
     */
    Sandbox.prototype.getModuleById = function (id) {
        var application = this.application;
        if (application.modules[id]) {
            return application.modules[id];
        }
        throw new Error("the module with the id " + id + " does not exist");
    };
    /**
     * Gets the appropriate module for the given DOM element
     *
     * @method getModuleInstance
     * @param {HTMLElement} element
     *      The module DOM element
     * @param {String} [modName]
     *      The module name (relevant if multiple Modules are defined on the same DOM element)
     *      Schema: Classname without "Tc.Module." - eg. "BrightcoveVideo"
     * @return {Module}
     *      The appropriate module
     */
    // Added by Swisscom (Dave Talamona, tzhtada2):
    // Prevent modules from using other modules internal "terrific-ids" for getting their module instance
    Sandbox.prototype.getModuleInstance = function (element, moduleName) {
        var application = this.application;
        var ids = $(element).data('terrific-ids') || {};
        var id;
        if (moduleName) {
            var modName = moduleName;
            if (modName.indexOf('-') > -1) {
                modName = Object(__WEBPACK_IMPORTED_MODULE_1__utils_string__["b" /* toCamel */])(modName);
            }
            modName = modName.substr(0, 1).toUpperCase() + modName.substr(1);
            if (!(modName in ids)) {
                return null;
            }
            id = ids[modName];
        }
        else {
            // If no modName is given, return the first module found
            for (var name in ids) {
                id = ids[name];
                break;
            }
        }
        if (id === undefined) {
            return null;
        }
        return application.modules[id] || null;
    };
    /**
     * Gets all modules for the given DOM element
     *
     * @method getModuleInstances
     * @param {HTMLElement} element
     *      The module DOM element
     * @return {Module}[]
     *      The appropriate modules
     */
    // Added by Swisscom (Raphael Schweikert, taascraa)
    Sandbox.prototype.getModuleInstances = function (element) {
        var ids = $(element).data('terrific-ids') || {};
        var results = [];
        for (var modName in ids) {
            var module = this.getModuleInstance(element, modName);
            if (module) {
                results.push(module);
            }
        }
        return results;
    };
    /**
     * Gets the application config.
     *
     * @method getConfig
     * @return {Object}
     *      The configuration object
     */
    Sandbox.prototype.getConfig = function () {
        return this.config;
    };
    /**
     * Gets an application config param.
     *
     * @method getConfigParam
     * @param {String} name
     *      The param name
     * @return {mixed}
     *      The appropriate configuration param
     */
    Sandbox.prototype.getConfigParam = function (name) {
        var config = this.config;
        if (config[name] !== undefined) {
            return config[name];
        }
        throw new Error("the config param " + name + " does not exist");
    };
    Sandbox.prototype.addCallback = function (phase, callback) {
        if (typeof phase === 'function') {
            // Only 1 param
            callback = phase;
            phase = 'end';
        }
        if (!callback) {
            return;
        }
        var callbacks = this.hooks[phase];
        callbacks.push(callback);
    };
    /**
     * Collects the module status messages and handles the callbacks.
     * This means that it is ready for the 'after' hook.
     *
     * @method ready
     * @param {Function} callback
     *      The 'after' hook module callback
     */
    Sandbox.prototype.ready = function (callback) {
        var afterHooks = this.hooks.after;
        // Add the callback to the stack
        afterHooks.push(callback);
        // Check whether all modules are ready for the 'after' hook
        if (this.application.modules.length !== (afterHooks.length + this.doneAfterHooks)) {
            return;
        }
        for (var i = 0; i < afterHooks.length; i++) {
            // Make sure the callback is only executed once (and is not called during addModules)
            var afterCallback = afterHooks.splice(i, 1)[0];
            i--;
            afterCallback();
            this.doneAfterHooks++;
        }
        // Execute the end hooks
        var endHooks = this.hooks.end;
        for (var _i = 0, endHooks_1 = endHooks; _i < endHooks_1.length; _i++) {
            var hook = endHooks_1[_i];
            hook();
        }
    };
    return Sandbox;
}());


/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_scsHeaderJQuery) {/**
 * (c) Copyright Swisscom (Schweiz) AG. All rights reserved.
 *
 * This product is the proprietary and sole property of Swisscom (Schweiz) AG
 * Use, duplication or dissemination is subject to prior written consent of
 * Swisscom (Schweiz) AG.
 *
 * $Id: general.js
 */

(function ($, scsHeader) {
	'use strict';

	/**
	 * Initialize IE compatibility stuff
	 */
	if (navigator.userAgent.indexOf(' Trident/') > -1) {
		$('html').addClass('msIe');
	}

	scsHeader.positionToolbarFiller = function() {
		var $filler = $('.scs-pageheader').find('.filler'),
			$container = $filler.parent();

		if (!$filler.length) {
			return;
		}

		if (document.fonts) {
			var font = [
				$container.css('font-style'),
				$container.css('font-weight'),
				$container.css('font-size'),
				$container.css('font-family').split(',')[0]
			].join(' ');

			document.fonts
				.load(font)
				.then(updateLeftAndWidth, updateLeftAndWidth);

		} else {
			updateLeftAndWidth();
			setTimeout(updateLeftAndWidth, 1000);
			setTimeout(updateLeftAndWidth, 5000);
		}

		function updateLeftAndWidth() {
			var $branchNav = $container.find('#scs-pageheader-branchnav'),
				$toolsNav = $container.find('#scs-pageheader-toolsnav'),
				$userBox = $container.find('#scs-pageheader-userbox'),
				left = $filler.position().left,
				fillerWidth = $filler.width(),
				toolbarWidth = $filler.parent().width();

			if ($branchNav.length){
				left = $branchNav.position().left + $branchNav.outerWidth(false) - 1;
			}

			fillerWidth = toolbarWidth - left;

			if ($userBox.is(':visible').length) {
				fillerWidth = $userBox.position().left - left;
			}

			if ($toolsNav.length){
				fillerWidth = $toolsNav.position().left - left;
			}

			$filler.css({left: left + 'px', width: fillerWidth + 'px'});
		}
	};

	$(document).ready(function(){
		scsHeader.positionToolbarFiller();
	});

	$(window).on('load', function(){
		scsHeader.positionToolbarFiller();
	});

})(__webpack_provided_window_dot_scsHeaderJQuery, window.scsHeader = window.scsHeader || {});

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_scsHeaderJQuery) {/**
 * (c) Copyright Swisscom (Schweiz) AG. All rights reserved.
 *
 * This product is the proprietary and sole property of Swisscom (Schweiz) AG
 * Use, duplication or dissemination is subject to prior written consent of
 * Swisscom (Schweiz) AG.
 *
 * $Id: topnav.js
 */

/**
 * Initialize top navigation (1st level)
 */
__webpack_provided_window_dot_scsHeaderJQuery(function($) {
	'use strict';

	// level 1 navigation: allow items to have different dividers on mouseDown (focused by mouse)
	var me = $('#scs-pageheader-topnav li.active');
	if (me.is(':last-child')) {
		me.after('<li class="dummy">&nbsp;</li>');
	}
	me.addClass('bigDivider').next().addClass('bigDivider');

	// megaDropDown
	// config
	var megaAnimInWait = 250;
	var megaAnimOutWait = 250;
	var megaAnimDurationPer100Px = 100;
	// definitions and declarations
	var megaAnimInTimeout;
	var megaAnimOutTimeout;
	var megaIsOpen = false;
	var megaDropDown = $('#scs-pageheader-megadropdown');
	var megaDropDownWrapper = megaDropDown.parent();
	var menuList = $('ul#scs-pageheader-topnav');
	var overItem;
	var hideInProgress = false;
	var activeItem = menuList.children('.active:first');
	var megaContentLoaded = [];
	var megaContentLoader = $('#scs-pageheader-megadropdown-loader');

	var listenToEscKey = function(e) {
		if (e.which === 27) {
			hideMega();
		}
	};

	// functions providing the possibility to show and hide the megaDropDown
	var showMega = function() {
		var mddIndex = overItem.data('mdd');
		var contentEl = $('#scs-pageheader-megadropdown-content-' + mddIndex);

		if (contentEl.length <= 0) return;

		// remove classes from active item if the active one is a neighbour of
		// the over item
		// reset active item -> necessary if the mega is already open
		activeItem.addClass('active bigDivider').next().addClass('bigDivider');
		if (overItem.prev().is('.active')) {
			overItem.removeClass('bigDivider');
		} else if (overItem.is('.active')) {
			overItem.removeClass('active').add(overItem.next()).removeClass('bigDivider');
		} else if (overItem.next().is('.active')) {
			overItem.next().removeClass('bigDivider');
		}
		// mark menu item as "over" item for megaDropDown
		menuList.find('.open').removeClass('open'); // reset open items
		overItem.addClass('open').find('a:first').addClass('open');
		menuList.addClass('megaDdVisible');
		// slide effect
		var isLoaded = megaContentLoaded[mddIndex];
		if (!megaIsOpen) {
			megaDropDown.css('height', 0).show();
		}
		megaDropDown.children().hide().attr('aria-hidden', 'true');
		var targetHeight = (isLoaded ? contentEl.show() : megaContentLoader.show()).height();
		var animTime = Math.abs(targetHeight - megaDropDown.height()) / 100 * megaAnimDurationPer100Px;
		megaDropDownWrapper.show();
		megaDropDown.animate({
			height : targetHeight
		}, animTime, function() {
			// show content if it is loaded now
			if (!isLoaded && megaContentLoaded[mddIndex] && mddIndex === overItem.data('mdd')) {
				var targetHeight = contentEl.height();
				var animTime = Math.abs(-megaDropDown.height()) / 100 * megaAnimDurationPer100Px;
				megaDropDown.animate({
					height : targetHeight
				}, animTime);
				megaContentLoader.hide();
				contentEl.show();
			}
		});
		contentEl.attr('aria-hidden', 'false');
		$(document).on('keydown', listenToEscKey);
		megaIsOpen = true;
	};

	var hideMega = function() {
		var mddIndex = overItem.data('mdd');
		var contentEl = $('#scs-pageheader-megadropdown-content-' + mddIndex);
		megaIsOpen = false;
		$(document).off('keydown', listenToEscKey);
		contentEl.attr('aria-hidden', 'true');
		menuList.find('.open').removeClass('open'); // reset open items
		activeItem.addClass('active bigDivider').next().addClass('bigDivider'); // reset
																				// active
																				// item
		megaDropDown.slideUp(megaDropDown.height() / 100 * megaAnimDurationPer100Px, function() {
			menuList.removeClass('megaDdVisible');
			megaDropDownWrapper.hide();
			hideInProgress = false;
		});
	};

	var requestShowMega = function() {
		var $this = $(this);
		overItem = $this.closest('li');
		window.clearTimeout(megaAnimInTimeout);
		window.clearTimeout(megaAnimOutTimeout);
		if (megaIsOpen) {
			showMega();
		} else {
			megaAnimInTimeout = window.setTimeout(showMega, megaAnimInWait);
		}
	};

	var requestHideMega = function() {
		hideInProgress = true;
		window.clearTimeout(megaAnimInTimeout);
		window.clearTimeout(megaAnimOutTimeout);
		if (megaIsOpen) {
			megaAnimOutTimeout = window.setTimeout(hideMega, megaAnimOutWait);
		}
	};

	// mouse events on menu items and the mega itself
	menuList.find('li').on('mouseenter', function() {
		requestShowMega.call($(this).find('a').get(0));
	}).on('mouseleave', function() {
		requestHideMega();
	});

	menuList.find('a').on('focus', function() {
		requestShowMega.call(this);
	}).on('blur', function() {
		requestHideMega();
	});

	megaDropDown.on('mouseenter focus', function() {
		window.clearTimeout(megaAnimOutTimeout);
	}).on('mouseleave blur', function() {
		requestHideMega();
	});

	// display the MDD on touchdevices without loading the target page on tap. If
	// the appropriate MDD is already opened and link is tapped again, load the
	// target page.
	if (('ontouchstart' in window) || window.DocumentTouch && document instanceof window.DocumentTouch) {
		menuList.find('a').each(function() {
			var $this = $(this),
				mddindex = $this.parent().data('mdd'),
				mddContent = $('#scs-pageheader-megadropdown-content-' + mddindex),
				url = $this.attr('href');

			if (mddContent.length) {
				$this.attr('href', 'javascript:;');
				$this.on('click', function() {
					if (mddContent.is(':visible')) {
						window.location.href = url;
					}
				});
			}
		});
	}

	// preload megaDropDown contents
	var processMddContentAfterLoad = function($this, i) {
		megaContentLoaded[i] = true;
		if (overItem && overItem.data('mdd') === i && !hideInProgress) {
			showMega();
		}
		$this.find('a').on('click', function(e) {
			window.scsHeader.siteCatalyst.trackClick(this, e, $(this).data('trackingTitle'), 'MDD');
		});
	};
	$('#scs-pageheader-megadropdown .mdd-content').each(function(i) {
		var $this = $(this);
		var url = $this.data('url');
		if (url) {
			megaContentLoaded[i] = false;
			$(window).on('load', function(e) {
				if (!$(e.target).is('iframe')) {
					$this.load(url, function() {
						$this.append('<div class="clear">&nbsp;</div>');
						processMddContentAfterLoad($this, i);
					});
				}
			});
		} else {
			processMddContentAfterLoad($this, i);
		}
	});

	var isPlaceholderSupported = function() {
		var input = document.createElement('input');
		return ('placeholder' in input);
	};
	var placeholderSupported = isPlaceholderSupported();

	var placeholderFieldFocussed = function() {
		var $this = $(this);
		if ($this.hasClass('placeholder')) {
			$this.removeClass('placeholder');
			if (!placeholderSupported && $this.val() === $this.attr('placeholder')) {
				$this.val('');
			}
		}
	};
	var placeholderFieldBlurred = function() {
		var $this = $(this);
		if ($this.val() === '') {
			if (!placeholderSupported) {
				$this.val($this.attr('placeholder'));
			}
			$this.addClass('placeholder');
		}
	};

	$('#scs-pageheader-search-field').focus(placeholderFieldFocussed).blur(placeholderFieldBlurred)
		.trigger('blur');

	$('input[name=qReferer]').val(document.location.href);
});

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_scsHeaderJQuery) {/**
 * (c) Copyright Swisscom (Schweiz) AG. All rights reserved.
 *
 * This product is the proprietary and sole property of Swisscom (Schweiz) AG
 * Use, duplication or dissemination is subject to prior written consent of
 * Swisscom (Schweiz) AG.
 *
 * $Id: metanav.js
 */

(function(scsHeader, $, SCS) {
	'use strict';

	$.namespace('scsHeader.metanav');

	function updateLegacyHeader() {
		// Read number of cart items from cookie and add it to shopping cart link
		var cartItems = window.Tc && window.Tc.Module.Basket && window.Tc.Module.Basket.getNumberOfItemsInBasket();
		if (cartItems > 0) {
			if (!$('#shoppingCartLink .cart-itemcount').length) {
				$('#shoppingCartLink').prepend('<span class="cart-itemcount">' + cartItems + '</span>');
			} else {
				$('#shoppingCartLink .cart-itemcount').text(cartItems);
			}
		} else {
			$('#shoppingCartLink .cart-itemcount').remove();
		}
	}
	function updateResponsiveHeader($modBasket) {
		var basket = window.application.sandbox.getModuleInstance($modBasket, 'Basket');
		if(basket) {
			basket.updateBasketNumberIndicator();
		}
	}

	scsHeader.metanav.updateShoppingCartItemsIcon = function() {
		var $modBasket = $('.modHeader .modBasket');
		if($modBasket.length) {
			updateResponsiveHeader($modBasket);
		} else {
			updateLegacyHeader();
		}
	};

	scsHeader.metanav.initShoppingCartMini = function() {
		if (!$('#cartmini').length || !$('#shoppingCartLink-wrap').length) {
			return;
		}
		var shoppingCartMiniIsOpen = false;
		$('#shoppingCartLink-wrap').append('<div id="cartmini-top"></div><span></span>')
			.append($('#cartmini'));
		$('#shoppingCartLink').addClass('active');
		var shoppingCartHref = $('#shoppingCartLink').attr('href');
		$('#shoppingCartLink').attr('href', 'javascript:void(0)');
		$('#cartmini-cartlink').attr('href', shoppingCartHref);
		var url = $('#cartmini').data('url');

		$('body').on('click', function(e) {
			if (!shoppingCartMiniIsOpen || $(e.target).parents('#shoppingCartLink-wrap').length
				|| $(e.target).is('#shoppingCartLink-wrap')) {
				return;
			}
			$('#shoppingCartLink').trigger('click');
		});

		$('#shoppingCartLink').click(function() {
			scsHeader.metanav.updateShoppingCartItemsIcon();

			var $this = $(this);
			var parent = $this.parents('#shoppingCartLink-wrap');
			shoppingCartMiniIsOpen = !parent.is('.open');
			parent[shoppingCartMiniIsOpen ? 'addClass' : 'removeClass']('open');
			if (!shoppingCartMiniIsOpen) {
				return;
			}
			$.ajax({
				type : 'GET',
				url : url,
				dataType : 'json',
				success : function(json) {
					var i, j;
					var $cartMiniWrapper = $('#cartmini .scs-cartmini-inner');
					$('#cartmini .scs-loadingRotator, .scs-cartmini-error, .scs-cartmini-empty')
						.hide();
					$('.scs-cartmini-inner tbody').remove();

					// error text
					var errorText = '';
					if (json && json.ErrorMessages && json.ErrorMessages.length) {
						for (i = 0; i < json.ErrorMessages.length; i+=1) {
							errorText += '<p>' + json.ErrorMessages[i] + '</p>';
						}
						$('.scs-cartmini-error').html(errorText).show();
					}

					if (json && json.BasketItems && json.BasketItems.length) {
						$('.basket-total td.onetimecharge')
							.html(json.OneTimeChargeFormatted);
						$('.basket-total td.recurringcharge')
							.html(json.RecurringChargeFormatted);

						// cart items
						for (i = 0; i < json.BasketItems.length; i+=1) {
							var groupItems = (json.BasketItems[i].ChildrenItems) ? json.BasketItems[i].ChildrenItems.length + 1
								: 1;
							var groupClass = (i == json.BasketItems.length - 1) ? 'basket-item-group basket-item-group-last'
								: 'basket-item-group';
							var itemHtml = '<tbody class="' + groupClass + '">';
							for (j = 0; j < groupItems; j+=1) {
								var basketItem = (j == 0) ? json.BasketItems[i]
									: json.BasketItems[i].ChildrenItems[j - 1];
								var itemClass = (j == groupItems - 1) ? 'basket-item basket-item-last'
									: 'basket-item';
								if (j == 0) {
									itemClass += ' basket-item-first';
								}
								if (basketItem.IsPromo) {
									itemClass += ' basket-item-promo';
									basketItem.ProductName = '<span class="promo-bullet">+ </span><span class="promo-bullet-text">'
										+ basketItem.ProductName + '</span>';
								}
								// if (basketItem.ErrorMessages &&
								// basketItem.ErrorMessages.length)
								// itemClass += "
								// basket-item-error";

								itemHtml += '<tr class="' + itemClass + '">';

								itemHtml += '<input type="hidden" name="ProductId" value="'
									+ basketItem.ProductId
									+ '" class="basket-item-hiddenid">';
								if (j == 0) {
									itemHtml += '<td rowspan="' + groupItems
										+ '" class="basket-item-image">' + '<img alt="'
										+ basketItem.ProductName + '" src="'
										+ basketItem.ImagePathMini + '">' + '</td>';
								}
								var basketItemQuantity = (basketItem.Quantity > 1) ? basketItem.Quantity
									+ 'x '
									: '';
								if (basketItem.OneTimeCharge == 0) {
									basketItem.OneTimeChargeFormatted = '';
								}
								itemHtml += '<td class="basket-item-text">'
									+ basketItemQuantity
									+ basketItem.ProductName
									+ '</td>'
									+ '<td class="basket-item-separatorrow"></td>'
									+ '<td class="recurringcharge">'
									+ ((basketItem.RecurringCharge) ? basketItem.RecurringChargeFormatted
										: '')
									+ '</td>'
									+ '<td class="onetimecharge">'
									+ ((basketItem.IsPromo && basketItem.OneTimeCharge == 0) ? SCS.portal.i18n.freeOfCharge
										: basketItem.OneTimeChargeFormatted) + '</td>';
								itemHtml += '</tr>';
							}
							itemHtml += '</tbody>';
							$('.scs-cartmini-inner table tfoot.basket-total')
								.before(itemHtml);
							$cartMiniWrapper.show();
						}
					} else {
						// empty cart
						$('.scs-cartmini-empty').show();
						$('.scs-cartmini-inner, .scs-cartmini-error, .scs-cartmini .scs-loadingRotator')
							.hide();
						$('#shoppingCartLink .cart-itemcount').remove();
					}
				}
			});
		});
	};

	/**
	 * Initialize meta navigation
	 */
	$(function() {
		// language selector
		var langIsOpen = false;
		// move active language outside the ul/li construct
		$('#scs-pageheader-language-switch li.active, #scs-pageheader-language-switch li a.active, #scs-pageheader-language-switch li.scsh-active, #scs-pageheader-language-switch li a.scsh-active')
			.each(function() {
				var $this = $(this);
				var activeLang = $this.text();
				var ul = $this.closest('ul');
				var languages = $('#scs-pageheader-language-switch li').length;
				if (languages > 1) {
					ul.before('<a href="javascript:void(0)" class="active scsh-active">' + activeLang + '</a>');
				} else {
					// single language pages do not need a language selector
					ul.before(activeLang);
				}
				if (this.tagName.toLowerCase() == 'a') {
					$this = $this.closest('li');
				}
				$this.remove();
			});
		// click event for active language
		$('#scs-pageheader-language-switch a.active, #scs-pageheader-language-switch a.scsh-active').on('click', function(e) {
			var parent = $('#scs-pageheader-language-switch');
			langIsOpen = !parent.is('.open');
			parent.toggleClass('open', langIsOpen);
			e.preventDefault();
		});
		// close languageSelector if something outside is clicked
		$('body').on('click', function(e) {
			if (!langIsOpen || $(e.target).parents('#scs-pageheader-language-switch').length
				|| $(e.target).is('#scs-pageheader-language-switch')) {
				return;
			}
			$('#scs-pageheader-language-switch a.active, #scs-pageheader-language-switch a.scsh-active').trigger('click');
		});

		// replace date placeholder with current date
		$('.scs-pageheader-metanav-date').html(window.scsHeaderDateFormat(new Date(), 'dd.mm.yyyy'));

		// init JUNCTION SWITCH, for example BUSINESS AREA SELECTOR
		var junctionSwitchIsOpen = false;
		$('#scs-pageheader-junction-switch-selector a.active').on('click', function(e) {
			var dropdown = $('#scs-pageheader-junction-switch-dropdown');
			var selector = $('#scs-pageheader-junction-switch-selector');
			junctionSwitchIsOpen = !dropdown.is('.open');
			dropdown.toggleClass('open', junctionSwitchIsOpen);
			selector.toggleClass('open', junctionSwitchIsOpen);
			e.preventDefault();
		});
		$('body').on('click', function(e) {
			if (!junctionSwitchIsOpen
				|| $(e.target).parents('#scs-pageheader-junction-switch-selector').length
				|| $(e.target).is('#scs-pageheader-junction-switch-selector')) {
				return;
			}
			$('#scs-pageheader-junction-switch-selector a.active').trigger('click');
		});
		$('#scs-pageheader-junction-switch-dropdown').on('click', function(e) {
			e.stopPropagation(); // do not propagate this click event to parents
									// -> prevents closing
		});

		scsHeader.metanav.updateShoppingCartItemsIcon();
		scsHeader.metanav.initShoppingCartMini();

		// Write the resume shopping link cookie on Shopping cart link click (FR
		// 14608)
		$('#shoppingCartLink').click(function() {
			$.cookie('SCSResumeShoppingLink', window.location.href, {
				'path' : '/'
			});
		});

	});

})(window.scsHeader, __webpack_provided_window_dot_scsHeaderJQuery, window.SCS);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(scsHeaderJQuery) {// footer.js

scsHeaderJQuery(function($) {
	// toggle high contrast mode
	$(".scs-pagefooter .scs-accessibility-mode").on("click", function(event) {
		if (scsHeaderJQuery.cookie("scs-accessibility-mode") === "true") {
			SCS.ecommerce.setCookieForAllLanguages("scs-accessibility-mode", "false");
			$("body").removeClass("scs-accessibility-mode");
		} else {
			SCS.ecommerce.setCookieForAllLanguages("scs-accessibility-mode", "true");
			$("body").addClass("scs-accessibility-mode");
		}
		event.preventDefault();
	});
	// enable or disable high contrast mode, based on cookie state
	if (scsHeaderJQuery.cookie("scs-accessibility-mode") === "true") {
		$("body").addClass("scs-accessibility-mode");
	} else {
		$("body").removeClass("scs-accessibility-mode");
	}
	// load footer via AJAX
	// TODO: Remove after all pages are migrated to NPE header/footer
	var footer = $("#scs-pageheader-pagefooter-content .mdd-content");
	if(footer && footer.data('url')){
		footer.load( footer.data('url'), function(){
			// since footer is asynchronously loaded, stage need to be adjusted here
			// to allow proper aligning of bottom aligned background images.
			var stageBackground = $('.scs-stage-flat');
			if( stageBackground.hasClass('full-height-background') ) {
				stageBackground.css( 'bottom', $("#scs-pageheader-pagefooter-content").height() );
			}
		});
	}
});

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery) {(function (a) {
	var r = a.fn.domManip, d = "_tmplitem", q = /^[^<]*(<[\w\W]+>)[^>]*$|\{\{\! /, b = {}, f = {}, e, p = {key: 0, data: {}}, h = 0, c = 0, l = [];

	function g(e, d, g, i) {
		var c = {data: i || (d ? d.data : {}), _wrap: d ? d._wrap : null, tmpl: null, parent: d || null, nodes: [], calls: u, nest: w, wrap: x, html: v, update: t};
		e && a.extend(c, e, {nodes: [], parent: d});
		if (g) {
			c.tmpl = g;
			c._ctnt = c._ctnt || c.tmpl(a, c);
			c.key = ++h;
			(l.length ? f : b)[h] = c
		}
		return c
	}

	a.each({appendTo: "append", prependTo: "prepend", insertBefore: "before", insertAfter: "after", replaceAll: "replaceWith"}, function (f, d) {
		a.fn[f] = function (n) {
			var g = [], i = a(n), k, h, m, l, j = this.length === 1 && this[0].parentNode;
			e = b || {};
			if (j && j.nodeType === 11 && j.childNodes.length === 1 && i.length === 1) {
				i[d](this[0]);
				g = this
			} else {
				for (h = 0, m = i.length; h < m; h++) {
					c = h;
					k = (h > 0 ? this.clone(true) : this).get();
					a.fn[d].apply(a(i[h]), k);
					g = g.concat(k)
				}
				c = 0;
				g = this.pushStack(g, f, i.selector)
			}
			l = e;
			e = null;
			a.tmpl.complete(l);
			return g
		}
	});
	a.fn.extend({
		tmpl: function (d, c, b) {
			return a.tmpl(this[0], d, c, b)
		}, tmplItem: function () {
			return a.tmplItem(this[0])
		}, template: function (b) {
			return a.template(b, this[0])
		}, domManip: function (d, l, j) {
			if (d[0] && d[0].nodeType) {
				var f = a.makeArray(arguments), g = d.length, i = 0, h;
				while (i < g && !(h = a.data(d[i++], "tmplItem")));
				if (g > 1)f[0] = [a.makeArray(d)];
				if (h && c)f[2] = function (b) {
					a.tmpl.afterManip(this, b, j)
				};
				r.apply(this, f)
			} else r.apply(this, arguments);
			c = 0;
			!e && a.tmpl.complete(b);
			return this
		}
	});
	a.extend({
		tmpl: function (d, h, e, c) {
			var j, k = !c;
			if (k) {
				c = p;
				d = a.template[d] || a.template(null, d);
				f = {}
			} else if (!d) {
				d = c.tmpl;
				b[c.key] = c;
				c.nodes = [];
				c.wrapped && n(c, c.wrapped);
				return a(i(c, null, c.tmpl(a, c)))
			}
			if (!d)return [];
			if (typeof h === "function")h = h.call(c || {});
			e && e.wrapped && n(e, e.wrapped);
			j = a.isArray(h) ? a.map(h, function (a) {
				return a ? g(e, c, d, a) : null
			}) : [g(e, c, d, h)];
			return k ? a(i(c, null, j)) : j
		}, tmplItem: function (b) {
			var c;
			if (b instanceof a)b = b[0];
			while (b && b.nodeType === 1 && !(c = a.data(b, "tmplItem")) && (b = b.parentNode));
			return c || p
		}, template: function (c, b) {
			if (b) {
				if (typeof b === "string")b = o(b); else if (b instanceof a)b = b[0] || {};
				if (b.nodeType)b = a.data(b, "tmpl") || a.data(b, "tmpl", o(b.innerHTML));
				return typeof c === "string" ? (a.template[c] = b) : b
			}
			return c ? typeof c !== "string" ? a.template(null, c) : a.template[c] || a.template(null, q.test(c) ? c : a(c)) : null
		}, encode: function (a) {
			return ("" + a).split("<").join("&lt;").split(">").join("&gt;").split('"').join("&#34;").split("'").join("&#39;")
		}
	});
	a.extend(a.tmpl, {
		tag: {
			tmpl: {_default: {$2: "null"}, open: "if($notnull_1){_=_.concat($item.nest($1,$2));}"},
			wrap: {_default: {$2: "null"}, open: "$item.calls(_,$1,$2);_=[];", close: "call=$item.calls();_=call._.concat($item.wrap(call,_));"},
			each: {_default: {$2: "$index, $value"}, open: "if($notnull_1){$.each($1a,function($2){with(this){", close: "}});}"},
			"if": {open: "if(($notnull_1) && $1a){", close: "}"},
			"else": {_default: {$1: "true"}, open: "}else if(($notnull_1) && $1a){"},
			html: {open: "if($notnull_1){_.push($1a);}"},
			"=": {_default: {$1: "$data"}, open: "if($notnull_1){_.push($.encode($1a));}"},
			"!": {open: ""}
		}, complete: function () {
			b = {}
		}, afterManip: function (f, b, d) {
			var e = b.nodeType === 11 ? a.makeArray(b.childNodes) : b.nodeType === 1 ? [b] : [];
			d.call(f, b);
			m(e);
			c++
		}
	});
	function i(e, g, f) {
		var b, c = f ? a.map(f, function (a) {
			return typeof a === "string" ? e.key ? a.replace(/(<\w+)(?=[\s>])(?![^>]*_tmplitem)([^>]*)/g, "$1 " + d + '="' + e.key + '" $2') : a : i(a, e, a._ctnt)
		}) : e;
		if (g)return c;
		c = c.join("");
		c.replace(/^\s*([^<\s][^<]*)?(<[\w\W]+>)([^>]*[^>\s])?\s*$/, function (f, c, e, d) {
			b = a(e).get();
			m(b);
			if (c)b = j(c).concat(b);
			if (d)b = b.concat(j(d))
		});
		return b ? b : j(c)
	}

	function j(c) {
		var b = document.createElement("div");
		b.innerHTML = c;
		return a.makeArray(b.childNodes)
	}

	function o(b) {
		return new Function("jQuery", "$item", "var $=jQuery,call,_=[],$data=$item.data;with($data){_.push('" + a.trim(b).replace(/([\\'])/g, "\\$1").replace(/[\r\t\n]/g, " ").replace(/\$\{([^\}]*)\}/g, "{{= $1}}").replace(/\{\{(\/?)(\w+|.)(?:\(((?:[^\}]|\}(?!\}))*?)?\))?(?:\s+(.*?)?)?(\(((?:[^\}]|\}(?!\}))*?)\))?\s*\}\}/g, function (m, l, j, d, b, c, e) {
				var i = a.tmpl.tag[j], h, f, g;
				if (!i)throw"Template command not found: " + j;
				h = i._default || [];
				if (c && !/\w$/.test(b)) {
					b += c;
					c = ""
				}
				if (b) {
					b = k(b);
					e = e ? "," + k(e) + ")" : c ? ")" : "";
					f = c ? b.indexOf(".") > -1 ? b + c : "(" + b + ").call($item" + e : b;
					g = c ? f : "(typeof(" + b + ")==='function'?(" + b + ").call($item):(" + b + "))"
				} else g = f = h.$1 || "null";
				d = k(d);
				return "');" + i[l ? "close" : "open"].split("$notnull_1").join(b ? "typeof(" + b + ")!=='undefined' && (" + b + ")!=null" : "true").split("$1a").join(g).split("$1").join(f).split("$2").join(d ? d.replace(/\s*([^\(]+)\s*(\((.*?)\))?/g, function (d, c, b, a) {
						a = a ? "," + a + ")" : b ? ")" : "";
						return a ? "(" + c + ").call($item" + a : d
					}) : h.$2 || "") + "_.push('"
			}) + "');}return _;")
	}

	function n(c, b) {
		c._wrap = i(c, true, a.isArray(b) ? b : [q.test(b) ? b : a(b).html()]).join("")
	}

	function k(a) {
		return a ? a.replace(/\\'/g, "'").replace(/\\\\/g, "\\") : null
	}

	function s(b) {
		var a = document.createElement("div");
		a.appendChild(b.cloneNode(true));
		return a.innerHTML
	}

	function m(o) {
		var n = "_" + c, k, j, l = {}, e, p, i;
		for (e = 0, p = o.length; e < p; e++) {
			if ((k = o[e]).nodeType !== 1)continue;
			j = k.getElementsByTagName("*");
			for (i = j.length - 1; i >= 0; i--)m(j[i]);
			m(k)
		}
		function m(j) {
			var p, i = j, k, e, m;
			if (m = j.getAttribute(d)) {
				while (i.parentNode && (i = i.parentNode).nodeType === 1 && !(p = i.getAttribute(d)));
				if (p !== m) {
					i = i.parentNode ? i.nodeType === 11 ? 0 : i.getAttribute(d) || 0 : 0;
					if (!(e = b[m])) {
						e = f[m];
						e = g(e, b[i] || f[i], null, true);
						e.key = ++h;
						b[h] = e
					}
					c && o(m)
				}
				j.removeAttribute(d)
			} else if (c && (e = a.data(j, "tmplItem"))) {
				o(e.key);
				b[e.key] = e;
				i = a.data(j.parentNode, "tmplItem");
				i = i ? i.key : 0
			}
			if (e) {
				k = e;
				while (k && k.key != i) {
					k.nodes.push(j);
					k = k.parent
				}
				delete e._ctnt;
				delete e._wrap;
				a.data(j, "tmplItem", e)
			}
			function o(a) {
				a = a + n;
				e = l[a] = l[a] || g(e, b[e.parent.key + n] || e.parent, null, true)
			}
		}
	}

	function u(a, d, c, b) {
		if (!a)return l.pop();
		l.push({_: a, tmpl: d, item: this, data: c, options: b})
	}

	function w(d, c, b) {
		return a.tmpl(a.template(d), c, b, this)
	}

	function x(b, d) {
		var c = b.options || {};
		c.wrapped = d;
		return a.tmpl(a.template(b.tmpl), b.data, c, b.item)
	}

	function v(d, c) {
		var b = this._wrap;
		return a.map(a(a.isArray(b) ? b.join("") : b).filter(d || "*"), function (a) {
			return c ? a.innerText || a.textContent : a.outerHTML || s(a)
		})
	}

	function t() {
		var b = this.nodes;
		a.tmpl(null, null, null, this).insertBefore(b[0]);
		a(b).remove()
	}
})(jQuery);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery) {/*!
* TableSorter 2.4.5 - Client-side table sorting with ease!
* @requires jQuery v1.2.6+
*
* Copyright (c) 2007 Christian Bach
* Examples and docs at: http://tablesorter.com
* Dual licensed under the MIT and GPL licenses:
* http://www.opensource.org/licenses/mit-license.php
* http://www.gnu.org/licenses/gpl.html
*
* @type jQuery
* @name tablesorter
* @cat Plugins/Tablesorter
* @author Christian Bach/christian.bach@polyester.se
* @contributor Rob Garrison/https://github.com/Mottie/tablesorter
*/
/*jshint evil:true, browser:true, jquery:true, unused:false */
/*global console:false, alert:false */
!(function($) {
	"use strict";
	$.extend({
		tablesorter: new function() {

			var ts = this;

			ts.version = "2.4.5";

			ts.parsers = [];
			ts.widgets = [];
			ts.defaults = {

				// appearance
				theme				: 'default', // adds tablesorter-{theme} to the table for styling
				widthFixed			: false, // adds colgroup to fix widths of columns
				showProcessing		: false, // show an indeterminate timer icon in the header when the table is sorted or filtered.

				// functionality
				cancelSelection		: true, // prevent text selection in the header
				dateFormat			: 'mmddyyyy', // other options: "ddmmyyy" or "yyyymmdd"
				sortMultiSortKey 	: 'shiftKey', // key used to select additional columns
				usNumberFormat		: true, // false for German "1.234.567,89" or French "1 234 567,89"
				delayInit			: false, // if false, the parsed table contents will not update until the first sort

				// sort options
				headers				: {}, // set sorter, string, empty, locked order, sortInitialOrder, filter, etc.
				ignoreCase			: true, // ignore case while sorting
				sortForce			: null, // column(s) first sorted; always applied
				sortList			: [], // Initial sort order; applied initially; updated when manually sorted
				sortAppend			: null, // column(s) sorted last; always applied

				sortInitialOrder 	: 'asc', // sort direction on first click
				sortLocaleCompare	: false, // replace equivalent character (accented characters)
				sortReset			: false, // third click on the header will reset column to default - unsorted
				sortRestart			: false, // restart sort to "sortInitialOrder" when clicking on previously unsorted columns

				emptyTo				: 'bottom', // sort empty cell to bottom, top, none, zero
				stringTo			: 'max', // sort strings in numerical column as max, min, top, bottom, zero
				textExtraction		: 'simple', // text extraction method/function - function(node, table, cellIndex){}
				textSorter			: null, // use custom text sorter - function(a,b){ return a.sort(b); } // basic sort

				// widget options
				widgets: [], // method to add widgets, e.g. widgets: ['zebra']
				widgetOptions	: {
					zebra : [ 'even', 'odd' ]	// zebra widget alternating row class names
				},
				initWidgets		: true, // apply widgets on tablesorter initialization

				// callbacks
				initialized		: null, // function(table){},
				onRenderHeader	: null, // function(index){},

				// css class names
				tableClass		: 'tablesorter',
				cssAsc			: 'tablesorter-headerSortUp',
				cssChildRow		: 'tablesorter-childRow', // previously "expand-child"
				cssDesc			: 'tablesorter-headerSortDown',
				cssHeader		: 'tablesorter-header',
				cssHeaderRow	: 'tablesorter-headerRow',
				cssIcon			: 'tablesorter-icon', // if this class exists, a <i> will be added to the header automatically
				cssInfoBlock	: 'tablesorter-infoOnly', // don't sort tbody with this class name
				cssProcessing	: 'tablesorter-processing', // processing icon applied to header during sort/filter

				// selectors
				selectorHeaders	: '> thead th, > thead td',
				selectorSort	: 'th, td', // jQuery selector of content within selectorHeaders that is clickable to trigger a sort
				selectorRemove	: '.remove-me',

				// advanced
				debug			: false,

				// Internal variables
				headerList: [],
				empties: {},
				strings: {},
				parsers: []

				// deprecated; but retained for backwards compatibility
				// widgetZebra: { css: ["even", "odd"] }

			};

			/* debuging utils */
			function log(s) {
				if (typeof console !== "undefined" && typeof console.log !== "undefined") {
					console.log(s);
				} else {
					alert(s);
				}
			}

			function benchmark(s, d) {
				log(s + " (" + (new Date().getTime() - d.getTime()) + "ms)");
			}

			ts.benchmark = benchmark;

			function getElementText(table, node, cellIndex) {
				if (!node) { return ""; }
				var c = table.config,
					t = c.textExtraction, text = "";
				if (t === "simple") {
					if (c.supportsTextContent) {
						text = node.textContent; // newer browsers support this
					} else {
						text = $(node).text();
					}
				} else {
					if (typeof(t) === "function") {
						text = t(node, table, cellIndex);
					} else if (typeof(t) === "object" && t.hasOwnProperty(cellIndex)) {
						text = t[cellIndex](node, table, cellIndex);
					} else {
						text = c.supportsTextContent ? node.textContent : $(node).text();
					}
				}
				return $.trim(text);
			}

			function detectParserForColumn(table, rows, rowIndex, cellIndex) {
				var i, l = ts.parsers.length,
				node = false,
				nodeValue = '',
				keepLooking = true;
				while (nodeValue === '' && keepLooking) {
					rowIndex++;
					if (rows[rowIndex]) {
						node = rows[rowIndex].cells[cellIndex];
						nodeValue = getElementText(table, node, cellIndex);
						if (table.config.debug) {
							log('Checking if value was empty on row ' + rowIndex + ', column: ' + cellIndex + ': ' + nodeValue);
						}
					} else {
						keepLooking = false;
					}
				}
				for (i = 1; i < l; i++) {
					if (ts.parsers[i].is(nodeValue, table, node)) {
						return ts.parsers[i];
					}
				}
				// 0 is always the generic parser (text)
				return ts.parsers[0];
			}

			function buildParserCache(table, $headers) {
				var c = table.config,
					tb = $(table.tBodies).filter(':not(.' + c.cssInfoBlock + ')'),
					rows, list, l, i, h, ch, p, parsersDebug = "";
				if ( tb.length === 0) { return; } // In the case of empty tables
				rows = tb[0].rows;
				if (rows[0]) {
					list = [];
					l = rows[0].cells.length;
					for (i = 0; i < l; i++) {
						// tons of thanks to AnthonyM1229 for working out the following selector (issue #74) to make this work in IE8!
						h = $headers.filter(':not([colspan])[data-column="' + i + '"]:last,[colspan="1"][data-column="' + i + '"]:last');
						ch = c.headers[i];
						// get column parser
						p = ts.getParserById( ts.getData(h, ch, 'sorter') );
						// empty cells behaviour - keeping emptyToBottom for backwards compatibility
						c.empties[i] = ts.getData(h, ch, 'empty') || c.emptyTo || (c.emptyToBottom ? 'bottom' : 'top' );
						// text strings behaviour in numerical sorts
						c.strings[i] = ts.getData(h, ch, 'string') || c.stringTo || 'max';
						if (!p) {
							p = detectParserForColumn(table, rows, -1, i);
						}
						if (c.debug) {
							parsersDebug += "column:" + i + "; parser:" + p.id + "; string:" + c.strings[i] + '; empty: ' + c.empties[i] + "\n";
						}
						list.push(p);
					}
				}
				if (c.debug) {
					log(parsersDebug);
				}
				return list;
			}

			/* utils */
			function buildCache(table) {
				var b = table.tBodies,
				tc = table.config,
				totalRows,
				totalCells,
				parsers = tc.parsers,
				t, i, j, k, c, cols, cacheTime;
				tc.cache = {};
				if (tc.debug) {
					cacheTime = new Date();
				}
				// processing icon
				if (tc.showProcessing) {
					ts.isProcessing(table, true);
				}
				for (k = 0; k < b.length; k++) {
					tc.cache[k] = { row: [], normalized: [] };
					// ignore tbodies with class name from css.cssInfoBlock
					if (!$(b[k]).hasClass(tc.cssInfoBlock)) {
						totalRows = (b[k] && b[k].rows.length) || 0;
						totalCells = (b[k].rows[0] && b[k].rows[0].cells.length) || 0;
						for (i = 0; i < totalRows; ++i) {
							/** Add the table data to main data array */
							c = $(b[k].rows[i]);
							cols = [];
							// if this is a child row, add it to the last row's children and continue to the next row
							if (c.hasClass(tc.cssChildRow)) {
								tc.cache[k].row[tc.cache[k].row.length - 1] = tc.cache[k].row[tc.cache[k].row.length - 1].add(c);
								// go to the next for loop
								continue;
							}
							tc.cache[k].row.push(c);
							for (j = 0; j < totalCells; ++j) {
								t = getElementText(table, c[0].cells[j], j);
								// allow parsing if the string is empty, previously parsing would change it to zero,
								// in case the parser needs to extract data from the table cell attributes
								cols.push( parsers[j].format(t, table, c[0].cells[j], j) );
							}
							cols.push(tc.cache[k].normalized.length); // add position for rowCache
							tc.cache[k].normalized.push(cols);
						}
					}
				}
				if (tc.showProcessing) {
					ts.isProcessing(table); // remove processing icon
				}
				if (tc.debug) {
					benchmark("Building cache for " + totalRows + " rows", cacheTime);
				}
			}

			// init flag (true) used by pager plugin to prevent widget application
			function appendToTable(table, init) {
				var c = table.config,
				b = table.tBodies,
				rows = [],
				c2 = c.cache,
				r, n, totalRows, checkCell, $bk, $tb,
				i, j, k, l, pos, appendTime;
				if (c.debug) {
					appendTime = new Date();
				}
				for (k = 0; k < b.length; k++) {
					$bk = $(b[k]);
					if (!$bk.hasClass(c.cssInfoBlock)) {
						// get tbody
						$tb = ts.processTbody(table, $bk, true);
						r = c2[k].row;
						n = c2[k].normalized;
						totalRows = n.length;
						checkCell = totalRows ? (n[0].length - 1) : 0;
						for (i = 0; i < totalRows; i++) {
							pos = n[i][checkCell];
							rows.push(r[pos]);
							// removeRows used by the pager plugin
							if (!c.appender || !c.removeRows) {
								l = r[pos].length;
								for (j = 0; j < l; j++) {
									$tb.append(r[pos][j]);
								}
							}
						}
						// restore tbody
						ts.processTbody(table, $tb, false);
					}
				}
				if (c.appender) {
					c.appender(table, rows);
				}
				if (c.debug) {
					benchmark("Rebuilt table", appendTime);
				}
				// apply table widgets
				if (!init) { ts.applyWidget(table); }
				// trigger sortend
				$(table).trigger("sortEnd", table);
			}

			// computeTableHeaderCellIndexes from:
			// http://www.javascripttoolbox.com/lib/table/examples.php
			// http://www.javascripttoolbox.com/temp/table_cellindex.html
			function computeThIndexes(t) {
				var matrix = [],
				lookup = {},
				trs = $(t).find('thead:eq(0) tr, tfoot tr'),
				i, j, k, l, c, cells, rowIndex, cellId, rowSpan, colSpan, firstAvailCol, matrixrow;
				for (i = 0; i < trs.length; i++) {
					cells = trs[i].cells;
					for (j = 0; j < cells.length; j++) {
						c = cells[j];
						rowIndex = c.parentNode.rowIndex;
						cellId = rowIndex + "-" + c.cellIndex;
						rowSpan = c.rowSpan || 1;
						colSpan = c.colSpan || 1;
						if (typeof(matrix[rowIndex]) === "undefined") {
							matrix[rowIndex] = [];
						}
						// Find first available column in the first row
						for (k = 0; k < matrix[rowIndex].length + 1; k++) {
							if (typeof(matrix[rowIndex][k]) === "undefined") {
								firstAvailCol = k;
								break;
							}
						}
						lookup[cellId] = firstAvailCol;
						// add data-column
						$(c).attr({ 'data-column' : firstAvailCol }); // 'data-row' : rowIndex
						for (k = rowIndex; k < rowIndex + rowSpan; k++) {
							if (typeof(matrix[k]) === "undefined") {
								matrix[k] = [];
							}
							matrixrow = matrix[k];
							for (l = firstAvailCol; l < firstAvailCol + colSpan; l++) {
								matrixrow[l] = "x";
							}
						}
					}
				}
				return lookup;
			}

			function formatSortingOrder(v) {
				// look for "d" in "desc" order; return true
				return (/^d/i.test(v) || v === 1);
			}

			function buildHeaders(table) {
				var header_index = computeThIndexes(table), ch, $t,
					t, lock, time, $tableHeaders, c = table.config;
					c.headerList = [];
				if (c.debug) {
					time = new Date();
				}
				$tableHeaders = $(table).find(c.selectorHeaders).each(function(index) {
					$t = $(this);
					ch = c.headers[index];
					t = c.cssIcon ? '<i class="' + c.cssIcon + '"></i>' : ''; // add icon if cssIcon option exists
					this.innerHTML = '<div class="tablesorter-header-inner">' + this.innerHTML + t + '</div>'; // faster than wrapInner
					if (c.onRenderHeader) { c.onRenderHeader.apply($t, [index]); }
					this.column = header_index[this.parentNode.rowIndex + "-" + this.cellIndex];
					this.order = formatSortingOrder( ts.getData($t, ch, 'sortInitialOrder') || c.sortInitialOrder ) ? [1,0,2] : [0,1,2];
					this.count = -1; // set to -1 because clicking on the header automatically adds one
					if (ts.getData($t, ch, 'sorter') === 'false') {
						this.sortDisabled = true;
						$t.addClass('sorter-false');
					} else {
						$t.removeClass('sorter-false');
					}
					this.lockedOrder = false;
					lock = ts.getData($t, ch, 'lockedOrder') || false;
					if (typeof(lock) !== 'undefined' && lock !== false) {
						this.order = this.lockedOrder = formatSortingOrder(lock) ? [1,1,1] : [0,0,0];
					}
					$t.addClass( this.sortDisabled ? 'sorter-false' : c.cssHeader );
					// add cell to headerList
					c.headerList[index] = this;
					// add to parent in case there are multiple rows
					$t.parent().addClass(c.cssHeaderRow);
				});
				if (table.config.debug) {
					benchmark("Built headers:", time);
					log($tableHeaders);
				}
				return $tableHeaders;
			}

			function setHeadersCss(table, $headers) {
				var f, i, j, l,
					c = table.config,
					list = c.sortList,
					css = [c.cssDesc, c.cssAsc],
					// find the footer
					$t = $(table).find('tfoot tr').children().removeClass(css.join(' '));
				// remove all header information
				$headers.removeClass(css.join(' '));
				l = list.length;
				for (i = 0; i < l; i++) {
					// direction = 2 means reset!
					if (list[i][1] !== 2) {
						// multicolumn sorting updating - choose the :last in case there are nested columns
						f = $headers.not('.sorter-false').filter('[data-column="' + list[i][0] + '"]' + (l === 1 ? ':last' : '') );
						if (f.length) {
							for (j = 0; j < f.length; j++) {
								if (!f[j].sortDisabled) {
									f.eq(j).addClass(css[list[i][1]]);
									// add sorted class to footer, if it exists
									if ($t.length) {
										$t.filter('[data-column="' + list[i][0] + '"]').eq(j).addClass(css[list[i][1]]);
									}
								}
							}
						}
					}
				}
			}

			function fixColumnWidth(table) {
				if (table.config.widthFixed && $(table).find('colgroup').length === 0) {
					var colgroup = $('<colgroup>'),
						overallWidth = $(table).width();
					$("tr:first td", table.tBodies[0]).each(function() {
						colgroup.append($('<col>').css('width', parseInt(($(this).width()/overallWidth)*1000, 10)/10 + '%'));
					});
					$(table).prepend(colgroup);
				}
			}

			function updateHeaderSortCount(table, list) {
				var s, o, c = table.config,
					l = c.headerList.length,
					sl = list || c.sortList;
				c.sortList = [];
				$.each(sl, function(i,v){
					// ensure all sortList values are numeric - fixes #127
					s = [ parseInt(v[0], 10), parseInt(v[1], 10) ];
					// make sure header exists
					o = c.headerList[s[0]];
					if (o) { // prevents error if sorton array is wrong
						c.sortList.push(s);
						o.count = s[1] % (c.sortReset ? 3 : 2);
					}
				});
			}

			function getCachedSortType(parsers, i) {
				return (parsers && parsers[i]) ? parsers[i].type || '' : '';
			}

			// sort multiple columns
			function multisort(table) {
				var dynamicExp, sortWrapper, col, mx = 0, dir = 0, tc = table.config,
				sortList = tc.sortList, l = sortList.length, bl = table.tBodies.length,
				sortTime, i, j, k, c, cache, lc, s, e, order, orgOrderCol;
				if (tc.debug) { sortTime = new Date(); }
				for (k = 0; k < bl; k++) {
					dynamicExp = "sortWrapper = function(a,b) {";
					cache = tc.cache[k];
					lc = cache.normalized.length;
					for (i = 0; i < l; i++) {
						c = sortList[i][0];
						order = sortList[i][1];
						// fallback to natural sort since it is more robust
						s = /n/i.test(getCachedSortType(tc.parsers, c)) ? "Numeric" : "Text";
						s += order === 0 ? "" : "Desc";
						e = "e" + i;
						// get max column value (ignore sign)
						if (/Numeric/.test(s) && tc.strings[c]) {
							for (j = 0; j < lc; j++) {
								col = Math.abs(parseFloat(cache.normalized[j][c]));
								mx = Math.max( mx, isNaN(col) ? 0 : col );
							}
							// sort strings in numerical columns
							if (typeof(tc.string[tc.strings[c]]) === 'boolean') {
								dir = (order === 0 ? 1 : -1) * (tc.string[tc.strings[c]] ? -1 : 1);
							} else {
								dir = (tc.strings[c]) ? tc.string[tc.strings[c]] || 0 : 0;
							}
						}
						dynamicExp += "var " + e + " = $.tablesorter.sort" + s + "(table,a[" + c + "],b[" + c + "]," + c + "," + mx + "," + dir + "); ";
						dynamicExp += "if (" + e + ") { return " + e + "; } ";
						dynamicExp += "else { ";
					}
					// if value is the same keep orignal order
					orgOrderCol = (cache.normalized && cache.normalized[0]) ? cache.normalized[0].length - 1 : 0;
					dynamicExp += "return a[" + orgOrderCol + "]-b[" + orgOrderCol + "];";
					for (i=0; i < l; i++) {
						dynamicExp += "}; ";
					}
					dynamicExp += "return 0; ";
					dynamicExp += "}; ";
					cache.normalized.sort(eval(dynamicExp)); // sort using eval expression
				}
				if (tc.debug) { benchmark("Sorting on " + sortList.toString() + " and dir " + order + " time", sortTime); }
			}

			function resortComplete($table, callback){
				var t = $table[0];
				$table.trigger('updateComplete');
				if (typeof callback === "function") {
					callback(t);
				}
			}

			function checkResort($table, flag, callback) {
				if (flag !== false) {
					$table.trigger("sorton", [$table[0].config.sortList, function(){
						resortComplete($table, callback);
					}]);
				} else {
					resortComplete($table, callback);
				}
			}

			/* public methods */
			ts.construct = function(settings) {
				return this.each(function() {
					// if no thead or tbody, or tablesorter is already present, quit
					if (!this.tHead || this.tBodies.length === 0 || this.hasInitialized === true) { return; }
					// declare
					var $headers, $cell, $this = $(this),
						c, i, j, k = '', a, s, o, downTime,
						m = $.metadata;
					// initialization flag
					this.hasInitialized = false;
					// new blank config object
					this.config = {};
					// merge and extend
					c = $.extend(true, this.config, ts.defaults, settings);
					// save the settings where they read
					$.data(this, "tablesorter", c);
					if (c.debug) { $.data( this, 'startoveralltimer', new Date()); }
					// constants
					c.supportsTextContent = $('<span>x</span>')[0].textContent === 'x';
					c.supportsDataObject = parseFloat($.fn.jquery) >= 1.4;
					// digit sort text location; keeping max+/- for backwards compatibility
					c.string = { 'max': 1, 'min': -1, 'max+': 1, 'max-': -1, 'zero': 0, 'none': 0, 'null': 0, 'top': true, 'bottom': false };
					// add table theme class only if there isn't already one there
					if (!/tablesorter\-/.test($this.attr('class'))) {
						k = (c.theme !== '' ? ' tablesorter-' + c.theme : '');
					}
					$this.addClass(c.tableClass + k);
					// build headers
					$headers = buildHeaders(this);
					// try to auto detect column type, and store in tables config
					c.parsers = buildParserCache(this, $headers);
					// build the cache for the tbody cells
					// delayInit will delay building the cache until the user starts a sort
					if (!c.delayInit) { buildCache(this); }
					// apply event handling to headers
					// this is to big, perhaps break it out?
					$headers
					// http://stackoverflow.com/questions/5312849/jquery-find-self
					.find('*').addBack().filter(c.selectorSort)
					.off('mousedown.tablesorter mouseup.tablesorter')
					.on('mousedown.tablesorter mouseup.tablesorter', function(e, external) {
						// jQuery v1.2.6 doesn't have closest()
						var $cell = this.tagName.match('TH|TD') ? $(this) : $(this).parents('th, td').filter(':last'), cell = $cell[0];
						// only recognize left clicks
						if ((e.which || e.button) !== 1) { return false; }
						// set timer on mousedown
						if (e.type === 'mousedown') {
							downTime = new Date().getTime();
							return e.target.tagName === "INPUT" ? '' : !c.cancelSelection;
						}
						// ignore long clicks (prevents resizable widget from initializing a sort)
						if (external !== true && (new Date().getTime() - downTime > 250)) { return false; }
						if (c.delayInit && !c.cache) { buildCache($this[0]); }
						if (!cell.sortDisabled) {
							// Only call sortStart if sorting is enabled
							$this.trigger("sortStart", $this[0]);
							// store exp, for speed
							// $cell = $(this);
							k = !e[c.sortMultiSortKey];
							// get current column sort order
							cell.count = (cell.count + 1) % (c.sortReset ? 3 : 2);
							// reset all sorts on non-current column - issue #30
							if (c.sortRestart) {
								i = cell;
								$headers.each(function() {
									// only reset counts on columns that weren't just clicked on and if not included in a multisort
									if (this !== i && (k || !$(this).is('.' + c.cssDesc + ',.' + c.cssAsc))) {
										this.count = -1;
									}
								});
							}
							// get current column index
							i = cell.column;
							// user only wants to sort on one column
							if (k) {
								// flush the sort list
								c.sortList = [];
								if (c.sortForce !== null) {
									a = c.sortForce;
									for (j = 0; j < a.length; j++) {
										if (a[j][0] !== i) {
											c.sortList.push(a[j]);
										}
									}
								}
								// add column to sort list
								o = cell.order[cell.count];
								if (o < 2) {
									c.sortList.push([i, o]);
									// add other columns if header spans across multiple
									if (cell.colSpan > 1) {
										for (j = 1; j < cell.colSpan; j++) {
											c.sortList.push([i + j, o]);
										}
									}
								}
								// multi column sorting
							} else {
								// get rid of the sortAppend before adding more - fixes issue #115
								if (c.sortAppend && c.sortList.length > 1) {
									if (ts.isValueInArray(c.sortAppend[0][0], c.sortList)) {
										c.sortList.pop();
									}
								}
								// the user has clicked on an already sorted column
								if (ts.isValueInArray(i, c.sortList)) {
									// reverse the sorting direction for all tables
									for (j = 0; j < c.sortList.length; j++) {
										s = c.sortList[j];
										o = c.headerList[s[0]];
										if (s[0] === i) {
											s[1] = o.order[o.count];
											if (s[1] === 2) {
												c.sortList.splice(j,1);
												o.count = -1;
											}
										}
									}
								} else {
									// add column to sort list array
									o = cell.order[cell.count];
									if (o < 2) {
										c.sortList.push([i, o]);
										// add other columns if header spans across multiple
										if (cell.colSpan > 1) {
											for (j = 1; j < cell.colSpan; j++) {
												c.sortList.push([i + j, o]);
											}
										}
									}
								}
							}
							if (c.sortAppend !== null) {
								a = c.sortAppend;
								for (j = 0; j < a.length; j++) {
									if (a[j][0] !== i) {
										c.sortList.push(a[j]);
									}
								}
							}
							// sortBegin event triggered immediately before the sort
							$this.trigger("sortBegin", $this[0]);
							// setTimeout needed so the processing icon shows up
							setTimeout(function(){
								// set css for headers
								setHeadersCss($this[0], $headers);
								multisort($this[0]);
								appendToTable($this[0]);
							}, 1);
						}
					});
					if (c.cancelSelection) {
						// cancel selection
						$headers.each(function() {
							this.onselectstart = function() {
								return false;
							};
						});
					}
					// apply easy methods that trigger binded events
					$this
					.off('update updateCell addRows sorton appendCache applyWidgetId applyWidgets refreshWidgets destroy mouseup mouseleave')
					.on("update", function(e, resort, callback) {
						// remove rows/elements before update
						$(c.selectorRemove, this).remove();
						// rebuild parsers
						c.parsers = buildParserCache(this, $headers);
						// rebuild the cache map
						buildCache(this);
						checkResort($this, resort, callback);
					})
					.on("updateCell", function(e, cell, resort, callback) {
						// get position from the dom
						var l, row, icell,
						t = this, $tb = $(this).find('tbody'),
						// update cache - format: function(s, table, cell, cellIndex)
						// no closest in jQuery v1.2.6 - tbdy = $tb.index( $(cell).closest('tbody') ),$row = $(cell).closest('tr');
						tbdy = $tb.index( $(cell).parents('tbody').filter(':last') ),
						$row = $(cell).parents('tr').filter(':last');
						// tbody may not exist if update is initialized while tbody is removed for processing
						if ($tb.length && tbdy >= 0) {
							row = $tb.eq(tbdy).find('tr').index( $row );
							icell = cell.cellIndex;
							l = t.config.cache[tbdy].normalized[row].length - 1;
							t.config.cache[tbdy].row[t.config.cache[tbdy].normalized[row][l]] = $row;
							t.config.cache[tbdy].normalized[row][icell] = c.parsers[icell].format( getElementText(t, cell, icell), t, cell, icell );
							checkResort($this, resort, callback);
						}
					})
					.on("addRows", function(e, $row, resort, callback) {
						var i, rows = $row.filter('tr').length,
						dat = [], l = $row[0].cells.length, t = this,
						tbdy = $(this).find('tbody').index( $row.closest('tbody') );
						// add each row
						for (i = 0; i < rows; i++) {
							// add each cell
							for (j = 0; j < l; j++) {
								dat[j] = c.parsers[j].format( getElementText(t, $row[i].cells[j], j), t, $row[i].cells[j], j );
							}
							// add the row index to the end
							dat.push(c.cache[tbdy].row.length);
							// update cache
							c.cache[tbdy].row.push([$row[i]]);
							c.cache[tbdy].normalized.push(dat);
							dat = [];
						}
						// resort using current settings
						checkResort($this, resort, callback);
					})
					.on("sorton", function(e, list, callback, init) {
						$(this).trigger("sortStart", this);
						// update header count index
						updateHeaderSortCount(this, list);
						// set css for headers
						setHeadersCss(this, $headers);
						// sort the table and append it to the dom
						multisort(this);
						appendToTable(this, init);
						if (typeof callback === "function") {
							callback(this);
						}
					})
					.on("appendCache", function(e, callback, init) {
						appendToTable(this, init);
						if (typeof callback === "function") {
							callback(this);
						}
					})
					.on("applyWidgetId", function(e, id) {
						ts.getWidgetById(id).format(this, c, c.widgetOptions);
					})
					.on("applyWidgets", function(e, init) {
						// apply widgets
						ts.applyWidget(this, init);
					})
					.on("refreshWidgets", function(e, all, dontapply){
						ts.refreshWidgets(this, all, dontapply);
					})
					.on("destroy", function(e, c, cb){
						ts.destroy(this, c, cb);
					});

					// get sort list from jQuery data or metadata
					// in jQuery < 1.4, an error occurs when calling $this.data()
					if (c.supportsDataObject && typeof $this.data().sortlist !== 'undefined') {
						c.sortList = $this.data().sortlist;
					} else if (m && ($this.metadata() && $this.metadata().sortlist)) {
						c.sortList = $this.metadata().sortlist;
					}
					// apply widget init code
					ts.applyWidget(this, true);
					// if user has supplied a sort list to constructor
					if (c.sortList.length > 0) {
						$this.trigger("sorton", [c.sortList, {}, !c.initWidgets]);
					} else if (c.initWidgets) {
						// apply widget format
						ts.applyWidget(this);
					}

					// fixate columns if the users supplies the fixedWidth option
					// do this after theme has been applied
					fixColumnWidth(this);

					// show processesing icon
					if (c.showProcessing) {
						$this
						.off('sortBegin sortEnd')
						.on('sortBegin sortEnd', function(e) {
							ts.isProcessing($this[0], e.type === 'sortBegin');
						});
					}

					// initialized
					this.hasInitialized = true;
					if (c.debug) {
						ts.benchmark("Overall initialization time", $.data( this, 'startoveralltimer'));
					}
					$this.trigger('tablesorter-initialized', this);
					if (typeof c.initialized === 'function') { c.initialized(this); }
				});
			};

			// *** Process table ***
			// add processing indicator
			ts.isProcessing = function(table, toggle, $ths) {
				var c = table.config,
					// default to all headers
					$h = $ths || $(table).find('.' + c.cssHeader);
				if (toggle) {
					if (c.sortList.length > 0) {
						// get headers from the sortList
						$h = $h.filter(function(){
							// get data-column from attr to keep compatibility with jQuery 1.2.6
							return this.sortDisabled ? false : ts.isValueInArray( parseFloat($(this).attr('data-column')), c.sortList);
						});
					}
					$h.addClass(c.cssProcessing);
				} else {
					$h.removeClass(c.cssProcessing);
				}
			};

			// detach tbody but save the position
			// don't use tbody because there are portions that look for a tbody index (updateCell)
			ts.processTbody = function(table, $tb, getIt){
				var t, holdr;
				if (getIt) {
					$tb.before('<span class="tablesorter-savemyplace"/>');
					holdr = ($.fn.detach) ? $tb.detach() : $tb.remove();
					return holdr;
				}
				holdr = $(table).find('span.tablesorter-savemyplace');
				$tb.insertAfter( holdr );
				holdr.remove();
			};

			ts.clearTableBody = function(table) {
				$(table.tBodies).filter(':not(.' + table.config.cssInfoBlock + ')').empty();
			};

			ts.destroy = function(table, removeClasses, callback){
				var $t = $(table), c = table.config,
				$h = $t.find('thead:first');
				// clear flag in case the plugin is initialized again
				table.hasInitialized = false;
				// remove widget added rows
				$h.find('tr:not(.' + c.cssHeaderRow + ')').remove();
				// remove resizer widget stuff
				$h.find('.tablesorter-resizer').remove();
				// remove all widgets
				ts.refreshWidgets(table, true, true);
				// disable tablesorter
				$t
					.removeData('tablesorter')
					.off('update updateCell addRows sorton appendCache applyWidgetId applyWidgets refreshWidgets destroy mouseup mouseleave')
					.find('.' + c.cssHeader)
					.off('click mousedown mousemove mouseup')
					.removeClass(c.cssHeader + ' ' + c.cssAsc + ' ' + c.cssDesc)
					.find('.tablesorter-header-inner').each(function(){
						if (c.cssIcon !== '') { $(this).find('.' + c.cssIcon).remove(); }
						$(this).replaceWith( $(this).contents() );
					});
				if (removeClasses !== false) {
					$t.removeClass(c.tableClass);
				}
				if (typeof callback === 'function') {
					callback(table);
				}
			};

			// *** sort functions ***
			// regex used in natural sort
			ts.regex = [
				/(^-?[0-9]+(\.?[0-9]*)[df]?e?[0-9]?$|^0x[0-9a-f]+$|[0-9]+)/gi, // chunk/tokenize numbers & letters
				/(^([\w ]+,?[\w ]+)?[\w ]+,?[\w ]+\d+:\d+(:\d+)?[\w ]?|^\d{1,4}[\/\-]\d{1,4}[\/\-]\d{1,4}|^\w+, \w+ \d+, \d{4})/, //date
				/^0x[0-9a-f]+$/i // hex
			];

			// Natural sort - https://github.com/overset/javascript-natural-sort
			ts.sortText = function(table, a, b, col) {
				if (a === b) { return 0; }
				var c = table.config, e = c.string[ (c.empties[col] || c.emptyTo ) ],
					r = ts.regex, xN, xD, yN, yD, xF, yF, i, mx;
				if (a === '' && e !== 0) { return (typeof(e) === 'boolean') ? (e ? -1 : 1) : -e || -1; }
				if (b === '' && e !== 0) { return (typeof(e) === 'boolean') ? (e ? 1 : -1) : e || 1; }
				if (typeof c.textSorter === 'function') { return c.textSorter(a, b, table, col); }
				// chunk/tokenize
				xN = a.replace(r[0], '\\0$1\\0').replace(/\\0$/, '').replace(/^\\0/, '').split('\\0');
				yN = b.replace(r[0], '\\0$1\\0').replace(/\\0$/, '').replace(/^\\0/, '').split('\\0');
				// numeric, hex or date detection
				xD = parseInt(a.match(r[2]),16) || (xN.length !== 1 && a.match(r[1]) && Date.parse(a));
				yD = parseInt(b.match(r[2]),16) || (xD && b.match(r[1]) && Date.parse(b)) || null;
				// first try and sort Hex codes or Dates
				if (yD) {
					if ( xD < yD ) { return -1; }
					if ( xD > yD ) { return 1; }
				}
				mx = Math.max(xN.length, yN.length);
				// natural sorting through split numeric strings and default strings
				for (i = 0; i < mx; i++) {
					// find floats not starting with '0', string or 0 if not defined
					xF = isNaN(xN[i]) ? xN[i] || 0 : parseFloat(xN[i]) || 0;
					yF = isNaN(yN[i]) ? yN[i] || 0 : parseFloat(yN[i]) || 0;
					// handle numeric vs string comparison - number < string - (Kyle Adams)
					if (isNaN(xF) !== isNaN(yF)) { return (isNaN(xF)) ? 1 : -1; }
					// rely on string comparison if different types - i.e. '02' < 2 != '02' < '2'
					if (typeof xF !== typeof yF) {
						xF += '';
						yF += '';
					}
					if (xF < yF) { return -1; }
					if (xF > yF) { return 1; }
				}
				return 0;
			};

			ts.sortTextDesc = function(table, a, b, col) {
				if (a === b) { return 0; }
				var c = table.config, e = c.string[ (c.empties[col] || c.emptyTo ) ];
				if (a === '' && e !== 0) { return (typeof(e) === 'boolean') ? (e ? -1 : 1) : e || 1; }
				if (b === '' && e !== 0) { return (typeof(e) === 'boolean') ? (e ? 1 : -1) : -e || -1; }
				if (typeof c.textSorter === 'function') { return c.textSorter(b, a, table, col); }
				return ts.sortText(table, b, a);
			};

			// return text string value by adding up ascii value
			// so the text is somewhat sorted when using a digital sort
			// this is NOT an alphanumeric sort
			ts.getTextValue = function(a, mx, d) {
				if (mx) {
					// make sure the text value is greater than the max numerical value (mx)
					var i, l = a.length, n = mx + d;
					for (i = 0; i < l; i++) {
						n += a.charCodeAt(i);
					}
					return d * n;
				}
				return 0;
			};

			ts.sortNumeric = function(table, a, b, col, mx, d) {
				if (a === b) { return 0; }
				var c = table.config, e = c.string[ (c.empties[col] || c.emptyTo ) ];
				if (a === '' && e !== 0) { return (typeof(e) === 'boolean') ? (e ? -1 : 1) : -e || -1; }
				if (b === '' && e !== 0) { return (typeof(e) === 'boolean') ? (e ? 1 : -1) : e || 1; }
				if (isNaN(a)) { a = ts.getTextValue(a, mx, d); }
				if (isNaN(b)) { b = ts.getTextValue(b, mx, d); }
				return a - b;
			};

			ts.sortNumericDesc = function(table, a, b, col, mx, d) {
				if (a === b) { return 0; }
				var c = table.config, e = c.string[ (c.empties[col] || c.emptyTo ) ];
				if (a === '' && e !== 0) { return (typeof(e) === 'boolean') ? (e ? -1 : 1) : e || 1; }
				if (b === '' && e !== 0) { return (typeof(e) === 'boolean') ? (e ? 1 : -1) : -e || -1; }
				if (isNaN(a)) { a = ts.getTextValue(a, mx, d); }
				if (isNaN(b)) { b = ts.getTextValue(b, mx, d); }
				return b - a;
			};

			// used when replacing accented characters during sorting
			ts.characterEquivalents = {
				"a" : "\u00e1\u00e0\u00e2\u00e3\u00e4", // áàâãä
				"A" : "\u00c1\u00c0\u00c2\u00c3\u00c4", // ÁÀÂÃÄ
				"c" : "\u00e7", // ç
				"C" : "\u00c7", // Ç
				"e" : "\u00e9\u00e8\u00ea\u00eb", // éèêë
				"E" : "\u00c9\u00c8\u00ca\u00cb", // ÉÈÊË
				"i" : "\u00ed\u00ec\u0130\u00ee\u00ef", // íìİîï
				"I" : "\u00cd\u00cc\u0130\u00ce\u00cf", // ÍÌİÎÏ
				"o" : "\u00f3\u00f2\u00f4\u00f5\u00f6", // óòôõö
				"O" : "\u00d3\u00d2\u00d4\u00d5\u00d6", // ÓÒÔÕÖ
				"S" : "\u00df", // ß
				"u" : "\u00fa\u00f9\u00fb\u00fc", // úùûü
				"U" : "\u00da\u00d9\u00db\u00dc" // ÚÙÛÜ
			};
			ts.replaceAccents = function(s) {
				var a, acc = '[', eq = ts.characterEquivalents;
				if (!ts.characterRegex) {
					ts.characterRegexArray = {};
					for (a in eq) {
						if (typeof a === 'string') {
							acc += eq[a];
							ts.characterRegexArray[a] = new RegExp('[' + eq[a] + ']', 'g');
						}
					}
					ts.characterRegex = new RegExp(acc + ']');
				}
				if (ts.characterRegex.test(s)) {
					for (a in eq) {
						if (typeof a === 'string') {
							s = s.replace( ts.characterRegexArray[a], a );
						}
					}
				}
				return s;
			};

			// *** utilities ***
			ts.isValueInArray = function(v, a) {
				var i, l = a.length;
				for (i = 0; i < l; i++) {
					if (a[i][0] === v) {
						return true;
					}
				}
				return false;
			};

			ts.addParser = function(parser) {
				var i, l = ts.parsers.length, a = true;
				for (i = 0; i < l; i++) {
					if (ts.parsers[i].id.toLowerCase() === parser.id.toLowerCase()) {
						a = false;
					}
				}
				if (a) {
					ts.parsers.push(parser);
				}
			};

			ts.getParserById = function(name) {
				var i, l = ts.parsers.length;
				for (i = 0; i < l; i++) {
					if (ts.parsers[i].id.toLowerCase() === (name.toString()).toLowerCase()) {
						return ts.parsers[i];
					}
				}
				return false;
			};

			ts.addWidget = function(widget) {
				ts.widgets.push(widget);
			};

			ts.getWidgetById = function(name) {
				var i, w, l = ts.widgets.length;
				for (i = 0; i < l; i++) {
					w = ts.widgets[i];
					if (w && w.hasOwnProperty('id') && w.id.toLowerCase() === name.toLowerCase()) {
						return w;
					}
				}
			};

			ts.applyWidget = function(table, init) {
				var c = table.config,
					wo = c.widgetOptions,
					ws = c.widgets.sort().reverse(), // ensure that widgets are always applied in a certain order
					time, i, w, l = ws.length;
				// make zebra last
				i = $.inArray('zebra', c.widgets);
				if (i >= 0) {
					c.widgets.splice(i,1);
					c.widgets.push('zebra');
				}
				if (c.debug) {
					time = new Date();
				}
				// add selected widgets
				for (i = 0; i < l; i++) {
					w = ts.getWidgetById(ws[i]);
					if ( w ) {
						if (init === true && w.hasOwnProperty('init')) {
							w.init(table, w, c, wo);
						} else if (!init && w.hasOwnProperty('format')) {
							w.format(table, c, wo);
						}
					}
				}
				if (c.debug) {
					benchmark("Completed " + (init === true ? "initializing" : "applying") + " widgets", time);
				}
			};

			ts.refreshWidgets = function(table, doAll, dontapply) {
				var i, c = table.config,
					cw = c.widgets,
					w = ts.widgets, l = w.length;
				// remove previous widgets
				for (i = 0; i < l; i++){
					if ( w[i] && w[i].id && (doAll || $.inArray( w[i].id, cw ) < 0) ) {
						if (c.debug) { log( 'removing ' + w[i].id ); }
						if (w[i].hasOwnProperty('remove')) { w[i].remove(table, c, c.widgetOptions); }
					}
				}
				if (dontapply !== true) {
					ts.applyWidget(table, doAll);
				}
			};

			// get sorter, string, empty, etc options for each column from
			// jQuery data, metadata, header option or header class name ("sorter-false")
			// priority = jQuery data > meta > headers option > header class name
			ts.getData = function(h, ch, key) {
				var val = '', $h = $(h), m, cl;
				if (!$h.length) { return ''; }
				m = $.metadata ? $h.metadata() : false;
				cl = ' ' + ($h.attr('class') || '');
				if (typeof $h.data(key) !== 'undefined' || typeof $h.data(key.toLowerCase()) !== 'undefined'){
					// "data-lockedOrder" is assigned to "lockedorder"; but "data-locked-order" is assigned to "lockedOrder"
					// "data-sort-initial-order" is assigned to "sortInitialOrder"
					val += $h.data(key) || $h.data(key.toLowerCase());
				} else if (m && typeof m[key] !== 'undefined') {
					val += m[key];
				} else if (ch && typeof ch[key] !== 'undefined') {
					val += ch[key];
				} else if (cl !== ' ' && cl.match(' ' + key + '-')) {
					// include sorter class name "sorter-text", etc
					val = cl.match( new RegExp(' ' + key + '-(\\w+)') )[1] || '';
				}
				return $.trim(val);
			};

			ts.formatFloat = function(s, table) {
				if (typeof(s) !== 'string' || s === '') { return s; }
				if (table.config.usNumberFormat !== false) {
					// US Format - 1,234,567.89 -> 1234567.89
					s = s.replace(/,/g,'');
				} else {
					// German Format = 1.234.567,89 -> 1234567.89
					// French Format = 1 234 567,89 -> 1234567.89
					s = s.replace(/[\s|\.]/g,'').replace(/,/g,'.');
				}
				if(/^\s*\([.\d]+\)/.test(s)) {
					// make (#) into a negative number -> (10) = -10
					s = s.replace(/^\s*\(/,'-').replace(/\)/,'');
				}
				var i = parseFloat(s);
				// return the text instead of zero
				return isNaN(i) ? $.trim(s) : i;
			};

			ts.isDigit = function(s) {
				// replace all unwanted chars and match
				return isNaN(s) ? (/^[\-+(]?\d+[)]?$/).test(s.toString().replace(/[,.'\s]/g, '')) : true;
			};

		}()
	});

	// make shortcut
	var ts = $.tablesorter;

	// extend plugin scope
	$.fn.extend({
		tablesorter: ts.construct
	});

	// add default parsers
	ts.addParser({
		id: "text",
		is: function(s, table, node) {
			return true;
		},
		format: function(s, table, cell, cellIndex) {
			var c = table.config;
			s = $.trim( c.ignoreCase ? s.toLocaleLowerCase() : s );
			return c.sortLocaleCompare ? ts.replaceAccents(s) : s;
		},
		type: "text"
	});

	ts.addParser({
		id: "currency",
		is: function(s) {
			return (/^\(?[\u00a3$\u20ac\u00a4\u00a5\u00a2?.]\d+/).test(s); // £$€¤¥¢
		},
		format: function(s, table) {
			return ts.formatFloat(s.replace(/[^\w,. \-()]/g, ""), table);
		},
		type: "numeric"
	});

	ts.addParser({
		id: "ipAddress",
		is: function(s) {
			return (/^\d{1,3}[\.]\d{1,3}[\.]\d{1,3}[\.]\d{1,3}$/).test(s);
		},
		format: function(s, table) {
			var i, a = s.split("."),
			r = "",
			l = a.length;
			for (i = 0; i < l; i++) {
				r += ("00" + a[i]).slice(-3);
			}
			return ts.formatFloat(r, table);
		},
		type: "numeric"
	});

	ts.addParser({
		id: "url",
		is: function(s) {
			return (/^(https?|ftp|file):\/\//).test(s);
		},
		format: function(s) {
			return $.trim(s.replace(/(https?|ftp|file):\/\//, ''));
		},
		type: "text"
	});

	ts.addParser({
		id: "isoDate",
		is: function(s) {
			return (/^\d{4}[\/\-]\d{1,2}[\/\-]\d{1,2}$/).test(s);
		},
		format: function(s, table) {
			return ts.formatFloat((s !== "") ? (new Date(s.replace(/-/g, "/")).getTime() || "") : "", table);
		},
		type: "numeric"
	});

	ts.addParser({
		id: "percent",
		is: function(s) {
			return (/\d%\)?$/).test(s);
		},
		format: function(s, table) {
			return ts.formatFloat(s.replace(/%/g, ""), table);
		},
		type: "numeric"
	});

	ts.addParser({
		id: "usLongDate",
		is: function(s) {
			return (/^[A-Z]{3,10}\.?\s+\d{1,2},?\s+(\d{4}|'?\d{2})\s+(([0-2]?\d:[0-5]\d)|([0-1]?\d:[0-5]\d\s?([AP]M)))$/i).test(s);
		},
		format: function(s, table) {
			return ts.formatFloat( (new Date(s.replace(/(\S)([AP]M)$/i, "$1 $2")).getTime() || ''), table);
		},
		type: "numeric"
	});

	ts.addParser({
		id: "shortDate", // "mmddyyyy", "ddmmyyyy" or "yyyymmdd"
		is: function(s) {
			// testing for ####-##-#### - so it's not perfect
			return (/^(\d{2}|\d{4})[\/\-\,\.\s+]\d{2}[\/\-\.\,\s+](\d{2}|\d{4})$/).test(s);
		},
		format: function(s, table, cell, cellIndex) {
			var c = table.config, ci = c.headerList[cellIndex],
			format = ci.shortDateFormat;
			if (typeof format === 'undefined') {
				// cache header formatting so it doesn't getData for every cell in the column
				format = ci.shortDateFormat = ts.getData( ci, c.headers[cellIndex], 'dateFormat') || c.dateFormat;
			}
			s = s.replace(/\s+/g," ").replace(/[\-|\.|\,]/g, "/");
			if (format === "mmddyyyy") {
				s = s.replace(/(\d{1,2})[\/\s](\d{1,2})[\/\s](\d{4})/, "$3/$1/$2");
			} else if (format === "ddmmyyyy") {
				s = s.replace(/(\d{1,2})[\/\s](\d{1,2})[\/\s](\d{4})/, "$3/$2/$1");
			} else if (format === "yyyymmdd") {
				s = s.replace(/(\d{4})[\/\s](\d{1,2})[\/\s](\d{1,2})/, "$1/$2/$3");
			}
			return ts.formatFloat( (new Date(s).getTime() || ''), table);
		},
		type: "numeric"
	});

	ts.addParser({
		id: "time",
		is: function(s) {
			return (/^(([0-2]?\d:[0-5]\d)|([0-1]?\d:[0-5]\d\s?([AP]M)))$/i).test(s);
		},
		format: function(s, table) {
			return ts.formatFloat( (new Date("2000/01/01 " + s.replace(/(\S)([AP]M)$/i, "$1 $2")).getTime() || ""), table);
		},
		type: "numeric"
	});

	ts.addParser({
		id: "digit",
		is: function(s) {
			return ts.isDigit(s);
		},
		format: function(s, table) {
			return ts.formatFloat(s.replace(/[^\w,. \-()]/g, ""), table);
		},
		type: "numeric"
	});

	ts.addParser({
		id: "metadata",
		is: function(s) {
			return false;
		},
		format: function(s, table, cell) {
			var c = table.config,
			p = (!c.parserMetadataName) ? 'sortValue' : c.parserMetadataName;
			return $(cell).metadata()[p];
		},
		type: "numeric"
	});

	// add default widgets
	ts.addWidget({
		id: "zebra",
		format: function(table, c, wo) {
			var $tb, $tv, $tr, row, even, time, k, l,
			child = new RegExp(c.cssChildRow, 'i'),
			b = $(table).children('tbody:not(.' + c.cssInfoBlock + ')');
			if (c.debug) {
				time = new Date();
			}
			for (k = 0; k < b.length; k++ ) {
				// loop through the visible rows
				$tb = $(b[k]);
				l = $tb.children('tr').length;
				if (l > 1) {
					row = 0;
					$tv = $tb.children('tr:visible');
					// revered back to using jQuery each - strangely it's the fastest method
					$tv.each(function(){
						$tr = $(this);
						// style children rows the same way the parent row was styled
						if (!child.test(this.className)) { row++; }
						even = (row % 2 === 0);
						$tr.removeClass(wo.zebra[even ? 1 : 0]).addClass(wo.zebra[even ? 0 : 1]);
					});
				}
			}
			if (c.debug) {
				ts.benchmark("Applying Zebra widget", time);
			}
		},
		remove: function(table, c, wo){
			var k, $tb,
				b = $(table).children('tbody:not(.' + c.cssInfoBlock + ')'),
				rmv = (c.widgetOptions.zebra || [ "even", "odd" ]).join(' ');
			for (k = 0; k < b.length; k++ ){
				$tb = $.tablesorter.processTbody(table, $(b[k]), true); // remove tbody
				$tb.children().removeClass(rmv);
				$.tablesorter.processTbody(table, $tb, false); // restore tbody
			}
		}
	});

})(jQuery);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery) {/*!
 * jQuery Transit - CSS3 transitions and transformations
 * (c) 2011-2012 Rico Sta. Cruz <rico@ricostacruz.com>
 * MIT Licensed.
 *
 * http://ricostacruz.com/jquery.transit
 * http://github.com/rstacruz/jquery.transit
 */
(function(k){k.transit={version:"0.9.9",propertyMap:{marginLeft:"margin",marginRight:"margin",marginBottom:"margin",marginTop:"margin",paddingLeft:"padding",paddingRight:"padding",paddingBottom:"padding",paddingTop:"padding"},enabled:true,useTransitionEnd:false};var d=document.createElement("div");var q={};function b(v){if(v in d.style){return v}var u=["Moz","Webkit","O","ms"];var r=v.charAt(0).toUpperCase()+v.substr(1);if(v in d.style){return v}for(var t=0;t<u.length;++t){var s=u[t]+r;if(s in d.style){return s}}}function e(){d.style[q.transform]="";d.style[q.transform]="rotateY(90deg)";return d.style[q.transform]!==""}var a=navigator.userAgent.toLowerCase().indexOf("chrome")>-1;q.transition=b("transition");q.transitionDelay=b("transitionDelay");q.transform=b("transform");q.transformOrigin=b("transformOrigin");q.transform3d=e();var i={transition:"transitionEnd",MozTransition:"transitionend",OTransition:"oTransitionEnd",WebkitTransition:"webkitTransitionEnd",msTransition:"MSTransitionEnd"};var f=q.transitionEnd=i[q.transition]||null;for(var p in q){if(q.hasOwnProperty(p)&&typeof k.support[p]==="undefined"){k.support[p]=q[p]}}d=null;k.cssEase={_default:"ease","in":"ease-in",out:"ease-out","in-out":"ease-in-out",snap:"cubic-bezier(0,1,.5,1)",easeOutCubic:"cubic-bezier(.215,.61,.355,1)",easeInOutCubic:"cubic-bezier(.645,.045,.355,1)",easeInCirc:"cubic-bezier(.6,.04,.98,.335)",easeOutCirc:"cubic-bezier(.075,.82,.165,1)",easeInOutCirc:"cubic-bezier(.785,.135,.15,.86)",easeInExpo:"cubic-bezier(.95,.05,.795,.035)",easeOutExpo:"cubic-bezier(.19,1,.22,1)",easeInOutExpo:"cubic-bezier(1,0,0,1)",easeInQuad:"cubic-bezier(.55,.085,.68,.53)",easeOutQuad:"cubic-bezier(.25,.46,.45,.94)",easeInOutQuad:"cubic-bezier(.455,.03,.515,.955)",easeInQuart:"cubic-bezier(.895,.03,.685,.22)",easeOutQuart:"cubic-bezier(.165,.84,.44,1)",easeInOutQuart:"cubic-bezier(.77,0,.175,1)",easeInQuint:"cubic-bezier(.755,.05,.855,.06)",easeOutQuint:"cubic-bezier(.23,1,.32,1)",easeInOutQuint:"cubic-bezier(.86,0,.07,1)",easeInSine:"cubic-bezier(.47,0,.745,.715)",easeOutSine:"cubic-bezier(.39,.575,.565,1)",easeInOutSine:"cubic-bezier(.445,.05,.55,.95)",easeInBack:"cubic-bezier(.6,-.28,.735,.045)",easeOutBack:"cubic-bezier(.175, .885,.32,1.275)",easeInOutBack:"cubic-bezier(.68,-.55,.265,1.55)"};k.cssHooks["transit:transform"]={get:function(r){return k(r).data("transform")||new j()},set:function(s,r){var t=r;if(!(t instanceof j)){t=new j(t)}if(q.transform==="WebkitTransform"&&!a){s.style[q.transform]=t.toString(true)}else{s.style[q.transform]=t.toString()}k(s).data("transform",t)}};k.cssHooks.transform={set:k.cssHooks["transit:transform"].set};if(k.fn.jquery<"1.8"){k.cssHooks.transformOrigin={get:function(r){return r.style[q.transformOrigin]},set:function(r,s){r.style[q.transformOrigin]=s}};k.cssHooks.transition={get:function(r){return r.style[q.transition]},set:function(r,s){r.style[q.transition]=s}}}n("scale");n("translate");n("rotate");n("rotateX");n("rotateY");n("rotate3d");n("perspective");n("skewX");n("skewY");n("x",true);n("y",true);function j(r){if(typeof r==="string"){this.parse(r)}return this}j.prototype={setFromString:function(t,s){var r=(typeof s==="string")?s.split(","):(s.constructor===Array)?s:[s];r.unshift(t);j.prototype.set.apply(this,r)},set:function(s){var r=Array.prototype.slice.apply(arguments,[1]);if(this.setter[s]){this.setter[s].apply(this,r)}else{this[s]=r.join(",")}},get:function(r){if(this.getter[r]){return this.getter[r].apply(this)}else{return this[r]||0}},setter:{rotate:function(r){this.rotate=o(r,"deg")},rotateX:function(r){this.rotateX=o(r,"deg")},rotateY:function(r){this.rotateY=o(r,"deg")},scale:function(r,s){if(s===undefined){s=r}this.scale=r+","+s},skewX:function(r){this.skewX=o(r,"deg")},skewY:function(r){this.skewY=o(r,"deg")},perspective:function(r){this.perspective=o(r,"px")},x:function(r){this.set("translate",r,null)},y:function(r){this.set("translate",null,r)},translate:function(r,s){if(this._translateX===undefined){this._translateX=0}if(this._translateY===undefined){this._translateY=0}if(r!==null&&r!==undefined){this._translateX=o(r,"px")}if(s!==null&&s!==undefined){this._translateY=o(s,"px")}this.translate=this._translateX+","+this._translateY}},getter:{x:function(){return this._translateX||0},y:function(){return this._translateY||0},scale:function(){var r=(this.scale||"1,1").split(",");if(r[0]){r[0]=parseFloat(r[0])}if(r[1]){r[1]=parseFloat(r[1])}return(r[0]===r[1])?r[0]:r},rotate3d:function(){var t=(this.rotate3d||"0,0,0,0deg").split(",");for(var r=0;r<=3;++r){if(t[r]){t[r]=parseFloat(t[r])}}if(t[3]){t[3]=o(t[3],"deg")}return t}},parse:function(s){var r=this;s.replace(/([a-zA-Z0-9]+)\((.*?)\)/g,function(t,v,u){r.setFromString(v,u)})},toString:function(t){var s=[];for(var r in this){if(this.hasOwnProperty(r)){if((!q.transform3d)&&((r==="rotateX")||(r==="rotateY")||(r==="perspective")||(r==="transformOrigin"))){continue}if(r[0]!=="_"){if(t&&(r==="scale")){s.push(r+"3d("+this[r]+",1)")}else{if(t&&(r==="translate")){s.push(r+"3d("+this[r]+",0)")}else{s.push(r+"("+this[r]+")")}}}}}return s.join(" ")}};function m(s,r,t){if(r===true){s.queue(t)}else{if(r){s.queue(r,t)}else{t()}}}function h(s){var r=[];k.each(s,function(t){t=k.camelCase(t);t=k.transit.propertyMap[t]||k.cssProps[t]||t;t=c(t);if(k.inArray(t,r)===-1){r.push(t)}});return r}function g(s,v,x,r){var t=h(s);if(k.cssEase[x]){x=k.cssEase[x]}var w=""+l(v)+" "+x;if(parseInt(r,10)>0){w+=" "+l(r)}var u=[];k.each(t,function(z,y){u.push(y+" "+w)});return u.join(", ")}k.fn.transition=k.fn.transit=function(z,s,y,C){var D=this;var u=0;var w=true;if(typeof s==="function"){C=s;s=undefined}if(typeof y==="function"){C=y;y=undefined}if(typeof z.easing!=="undefined"){y=z.easing;delete z.easing}if(typeof z.duration!=="undefined"){s=z.duration;delete z.duration}if(typeof z.complete!=="undefined"){C=z.complete;delete z.complete}if(typeof z.queue!=="undefined"){w=z.queue;delete z.queue}if(typeof z.delay!=="undefined"){u=z.delay;delete z.delay}if(typeof s==="undefined"){s=k.fx.speeds._default}if(typeof y==="undefined"){y=k.cssEase._default}s=l(s);var E=g(z,s,y,u);var B=k.transit.enabled&&q.transition;var t=B?(parseInt(s,10)+parseInt(u,10)):0;if(t===0){var A=function(F){D.css(z);if(C){C.apply(D)}if(F){F()}};m(D,w,A);return D}var x={};var r=function(H){var G=false;var F=function(){if(G){D.off(f,F)}if(t>0){D.each(function(){this.style[q.transition]=(x[this]||null)})}if(typeof C==="function"){C.apply(D)}if(typeof H==="function"){H()}};if((t>0)&&(f)&&(k.transit.useTransitionEnd)){G=true;D.on(f,F)}else{window.setTimeout(F,t)}D.each(function(){if(t>0){this.style[q.transition]=E}k(this).css(z)})};var v=function(F){this.offsetWidth;r(F)};m(D,w,v);return this};function n(s,r){if(!r){k.cssNumber[s]=true}k.transit.propertyMap[s]=q.transform;k.cssHooks[s]={get:function(v){var u=k(v).css("transit:transform");return u.get(s)},set:function(v,w){var u=k(v).css("transit:transform");u.setFromString(s,w);k(v).css({"transit:transform":u})}}}function c(r){return r.replace(/([A-Z])/g,function(s){return"-"+s.toLowerCase()})}function o(s,r){if((typeof s==="string")&&(!s.match(/^[\-0-9\.]+$/))){return s}else{return""+s+r}}function l(s){var r=s;if(k.fx.speeds[r]){r=k.fx.speeds[r]}return o(r,"ms")}k.transit.getTransitionValue=g})(jQuery);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 107 */
/***/ (function(module, exports) {

if(typeof jwplayer=="undefined"){var jwplayer=function(a){if(jwplayer.api){return jwplayer.api.selectPlayer(a)}};var $jw=jwplayer;jwplayer.version="5.9.2156 (Licensed version)";jwplayer.vid=document.createElement("video");jwplayer.audio=document.createElement("audio");jwplayer.source=document.createElement("source");(function(b){b.utils=function(){};b.utils.typeOf=function(d){var c=typeof d;if(c==="object"){if(d){if(d instanceof Array){c="array"}}else{c="null"}}return c};b.utils.extend=function(){var c=b.utils.extend["arguments"];if(c.length>1){for(var e=1;e<c.length;e++){for(var d in c[e]){c[0][d]=c[e][d]}}return c[0]}return null};b.utils.clone=function(f){var c;var d=b.utils.clone["arguments"];if(d.length==1){switch(b.utils.typeOf(d[0])){case"object":c={};for(var e in d[0]){c[e]=b.utils.clone(d[0][e])}break;case"array":c=[];for(var e in d[0]){c[e]=b.utils.clone(d[0][e])}break;default:return d[0];break}}return c};b.utils.extension=function(c){if(!c){return""}c=c.substring(c.lastIndexOf("/")+1,c.length);c=c.split("?")[0];if(c.lastIndexOf(".")>-1){return c.substr(c.lastIndexOf(".")+1,c.length).toLowerCase()}return};b.utils.html=function(c,d){c.innerHTML=d};b.utils.wrap=function(c,d){if(c.parentNode){c.parentNode.replaceChild(d,c)}d.appendChild(c)};b.utils.ajax=function(g,f,c){var e;if(window.XMLHttpRequest){e=new XMLHttpRequest()}else{e=new ActiveXObject("Microsoft.XMLHTTP")}e.onreadystatechange=function(){if(e.readyState===4){if(e.status===200){if(f){if(!b.utils.exists(e.responseXML)){try{if(window.DOMParser){var h=(new DOMParser()).parseFromString(e.responseText,"text/xml");if(h){e=b.utils.extend({},e,{responseXML:h})}}else{h=new ActiveXObject("Microsoft.XMLDOM");h.async="false";h.loadXML(e.responseText);e=b.utils.extend({},e,{responseXML:h})}}catch(j){if(c){c(g)}}}f(e)}}else{if(c){c(g)}}}};try{e.open("GET",g,true);e.send(null)}catch(d){if(c){c(g)}}return e};b.utils.load=function(d,e,c){d.onreadystatechange=function(){if(d.readyState===4){if(d.status===200){if(e){e()}}else{if(c){c()}}}}};b.utils.find=function(d,c){return d.getElementsByTagName(c)};b.utils.append=function(c,d){c.appendChild(d)};b.utils.isIE=function(){return((!+"\v1")||(typeof window.ActiveXObject!="undefined"))};b.utils.userAgentMatch=function(d){var c=navigator.userAgent.toLowerCase();return(c.match(d)!==null)};b.utils.isIOS=function(){return b.utils.userAgentMatch(/iP(hone|ad|od)/i)};b.utils.isIPad=function(){return b.utils.userAgentMatch(/iPad/i)};b.utils.isIPod=function(){return b.utils.userAgentMatch(/iP(hone|od)/i)};b.utils.isAndroid=function(){return b.utils.userAgentMatch(/android/i)};b.utils.isLegacyAndroid=function(){return b.utils.userAgentMatch(/android 2.[012]/i)};b.utils.isBlackberry=function(){return b.utils.userAgentMatch(/blackberry/i)};b.utils.isMobile=function(){return b.utils.userAgentMatch(/(iP(hone|ad|od))|android/i)};b.utils.getFirstPlaylistItemFromConfig=function(c){var d={};var e;if(c.playlist&&c.playlist.length){e=c.playlist[0]}else{e=c}d.file=e.file;d.levels=e.levels;d.streamer=e.streamer;d.playlistfile=e.playlistfile;d.provider=e.provider;if(!d.provider){if(d.file&&(d.file.toLowerCase().indexOf("youtube.com")>-1||d.file.toLowerCase().indexOf("youtu.be")>-1)){d.provider="youtube"}if(d.streamer&&d.streamer.toLowerCase().indexOf("rtmp://")==0){d.provider="rtmp"}if(e.type){d.provider=e.type.toLowerCase()}}if(d.provider=="audio"){d.provider="sound"}return d};b.utils.getOuterHTML=function(c){if(c.outerHTML){return c.outerHTML}else{try{return new XMLSerializer().serializeToString(c)}catch(d){return""}}};b.utils.setOuterHTML=function(f,e){if(f.outerHTML){f.outerHTML=e}else{var g=document.createElement("div");g.innerHTML=e;var c=document.createRange();c.selectNodeContents(g);var d=c.extractContents();f.parentNode.insertBefore(d,f);f.parentNode.removeChild(f)}};b.utils.hasFlash=function(){if(typeof navigator.plugins!="undefined"&&typeof navigator.plugins["Shockwave Flash"]!="undefined"){return true}if(typeof window.ActiveXObject!="undefined"){try{new ActiveXObject("ShockwaveFlash.ShockwaveFlash");return true}catch(c){}}return false};b.utils.getPluginName=function(c){if(c.lastIndexOf("/")>=0){c=c.substring(c.lastIndexOf("/")+1,c.length)}if(c.lastIndexOf("-")>=0){c=c.substring(0,c.lastIndexOf("-"))}if(c.lastIndexOf(".swf")>=0){c=c.substring(0,c.lastIndexOf(".swf"))}if(c.lastIndexOf(".js")>=0){c=c.substring(0,c.lastIndexOf(".js"))}return c};b.utils.getPluginVersion=function(c){if(c.lastIndexOf("-")>=0){if(c.lastIndexOf(".js")>=0){return c.substring(c.lastIndexOf("-")+1,c.lastIndexOf(".js"))}else{if(c.lastIndexOf(".swf")>=0){return c.substring(c.lastIndexOf("-")+1,c.lastIndexOf(".swf"))}else{return c.substring(c.lastIndexOf("-")+1)}}}return""};b.utils.getAbsolutePath=function(j,h){if(!b.utils.exists(h)){h=document.location.href}if(!b.utils.exists(j)){return undefined}if(a(j)){return j}var k=h.substring(0,h.indexOf("://")+3);var g=h.substring(k.length,h.indexOf("/",k.length+1));var d;if(j.indexOf("/")===0){d=j.split("/")}else{var e=h.split("?")[0];e=e.substring(k.length+g.length+1,e.lastIndexOf("/"));d=e.split("/").concat(j.split("/"))}var c=[];for(var f=0;f<d.length;f++){if(!d[f]||!b.utils.exists(d[f])||d[f]=="."){continue}else{if(d[f]==".."){c.pop()}else{c.push(d[f])}}}return k+g+"/"+c.join("/")};function a(d){if(!b.utils.exists(d)){return}var e=d.indexOf("://");var c=d.indexOf("?");return(e>0&&(c<0||(c>e)))}b.utils.pluginPathType={ABSOLUTE:"ABSOLUTE",RELATIVE:"RELATIVE",CDN:"CDN"};b.utils.getPluginPathType=function(d){if(typeof d!="string"){return}d=d.split("?")[0];var e=d.indexOf("://");if(e>0){return b.utils.pluginPathType.ABSOLUTE}var c=d.indexOf("/");var f=b.utils.extension(d);if(e<0&&c<0&&(!f||!isNaN(f))){return b.utils.pluginPathType.CDN}return b.utils.pluginPathType.RELATIVE};b.utils.mapEmpty=function(c){for(var d in c){return false}return true};b.utils.mapLength=function(d){var c=0;for(var e in d){c++}return c};b.utils.log=function(d,c){if(typeof console!="undefined"&&typeof console.log!="undefined"){if(c){console.log(d,c)}else{console.log(d)}}};b.utils.css=function(d,g,c){if(b.utils.exists(d)){for(var e in g){try{if(typeof g[e]==="undefined"){continue}else{if(typeof g[e]=="number"&&!(e=="zIndex"||e=="opacity")){if(isNaN(g[e])){continue}if(e.match(/color/i)){g[e]="#"+b.utils.strings.pad(g[e].toString(16),6)}else{g[e]=Math.ceil(g[e])+"px"}}}d.style[e]=g[e]}catch(f){}}}};b.utils.isYouTube=function(c){return(c.indexOf("youtube.com")>-1||c.indexOf("youtu.be")>-1)};b.utils.transform=function(e,d,c,g,h){if(!b.utils.exists(d)){d=1}if(!b.utils.exists(c)){c=1}if(!b.utils.exists(g)){g=0}if(!b.utils.exists(h)){h=0}if(d==1&&c==1&&g==0&&h==0){e.style.webkitTransform="";e.style.MozTransform="";e.style.OTransform=""}else{var f="scale("+d+","+c+") translate("+g+"px,"+h+"px)";e.style.webkitTransform=f;e.style.MozTransform=f;e.style.OTransform=f}};b.utils.stretch=function(k,q,p,g,n,h){if(typeof p=="undefined"||typeof g=="undefined"||typeof n=="undefined"||typeof h=="undefined"){return}var d=p/n;var f=g/h;var m=0;var l=0;var e=false;var c={};if(q.parentElement){q.parentElement.style.overflow="hidden"}b.utils.transform(q);switch(k.toUpperCase()){case b.utils.stretching.NONE:c.width=n;c.height=h;c.top=(g-c.height)/2;c.left=(p-c.width)/2;break;case b.utils.stretching.UNIFORM:if(d>f){c.width=n*f;c.height=h*f;if(c.width/p>0.95){e=true;d=Math.ceil(100*p/c.width)/100;f=1;c.width=p}}else{c.width=n*d;c.height=h*d;if(c.height/g>0.95){e=true;d=1;f=Math.ceil(100*g/c.height)/100;c.height=g}}c.top=(g-c.height)/2;c.left=(p-c.width)/2;break;case b.utils.stretching.FILL:if(d>f){c.width=n*d;c.height=h*d}else{c.width=n*f;c.height=h*f}c.top=(g-c.height)/2;c.left=(p-c.width)/2;break;case b.utils.stretching.EXACTFIT:c.width=n;c.height=h;var o=Math.round((n/2)*(1-1/d));var j=Math.round((h/2)*(1-1/f));e=true;c.top=c.left=0;break;default:break}if(e){b.utils.transform(q,d,f,o,j)}b.utils.css(q,c)};b.utils.stretching={NONE:"NONE",FILL:"FILL",UNIFORM:"UNIFORM",EXACTFIT:"EXACTFIT"};b.utils.deepReplaceKeyName=function(k,e,c){switch(b.utils.typeOf(k)){case"array":for(var g=0;g<k.length;g++){k[g]=b.utils.deepReplaceKeyName(k[g],e,c)}break;case"object":for(var f in k){var j,h;if(e instanceof Array&&c instanceof Array){if(e.length!=c.length){continue}else{j=e;h=c}}else{j=[e];h=[c]}var d=f;for(var g=0;g<j.length;g++){d=d.replace(new RegExp(e[g],"g"),c[g])}k[d]=b.utils.deepReplaceKeyName(k[f],e,c);if(f!=d){delete k[f]}}break}return k};b.utils.isInArray=function(e,d){if(!(e)||!(e instanceof Array)){return false}for(var c=0;c<e.length;c++){if(d===e[c]){return true}}return false};b.utils.exists=function(c){switch(typeof(c)){case"string":return(c.length>0);break;case"object":return(c!==null);case"undefined":return false}return true};b.utils.empty=function(c){if(typeof c.hasChildNodes=="function"){while(c.hasChildNodes()){c.removeChild(c.firstChild)}}};b.utils.parseDimension=function(c){if(typeof c=="string"){if(c===""){return 0}else{if(c.lastIndexOf("%")>-1){return c}else{return parseInt(c.replace("px",""),10)}}}return c};b.utils.getDimensions=function(c){if(c&&c.style){return{x:b.utils.parseDimension(c.style.left),y:b.utils.parseDimension(c.style.top),width:b.utils.parseDimension(c.style.width),height:b.utils.parseDimension(c.style.height)}}else{return{}}};b.utils.getElementWidth=function(c){if(!c){return null}else{if(c==document.body){return b.utils.parentNode(c).clientWidth}else{if(c.clientWidth>0){return c.clientWidth}else{if(c.style){return b.utils.parseDimension(c.style.width)}else{return null}}}}};b.utils.getElementHeight=function(c){if(!c){return null}else{if(c==document.body){return b.utils.parentNode(c).clientHeight}else{if(c.clientHeight>0){return c.clientHeight}else{if(c.style){return b.utils.parseDimension(c.style.height)}else{return null}}}}};b.utils.timeFormat=function(c){str="00:00";if(c>0){str=Math.floor(c/60)<10?"0"+Math.floor(c/60)+":":Math.floor(c/60)+":";str+=Math.floor(c%60)<10?"0"+Math.floor(c%60):Math.floor(c%60)}return str};b.utils.useNativeFullscreen=function(){return(navigator&&navigator.vendor&&navigator.vendor.indexOf("Apple")==0)};b.utils.parentNode=function(c){if(!c){return docuemnt.body}else{if(c.parentNode){return c.parentNode}else{if(c.parentElement){return c.parentElement}else{return c}}}};b.utils.getBoundingClientRect=function(c){if(typeof c.getBoundingClientRect=="function"){return c.getBoundingClientRect()}else{return{left:c.offsetLeft+document.body.scrollLeft,top:c.offsetTop+document.body.scrollTop,width:c.offsetWidth,height:c.offsetHeight}}};b.utils.translateEventResponse=function(e,c){var g=b.utils.extend({},c);if(e==b.api.events.JWPLAYER_FULLSCREEN&&!g.fullscreen){g.fullscreen=g.message=="true"?true:false;delete g.message}else{if(typeof g.data=="object"){g=b.utils.extend(g,g.data);delete g.data}else{if(typeof g.metadata=="object"){b.utils.deepReplaceKeyName(g.metadata,["__dot__","__spc__","__dsh__"],["."," ","-"])}}}var d=["position","duration","offset"];for(var f in d){if(g[d[f]]){g[d[f]]=Math.round(g[d[f]]*1000)/1000}}return g};b.utils.saveCookie=function(c,d){document.cookie="jwplayer."+c+"="+d+"; path=/"};b.utils.getCookies=function(){var f={};var e=document.cookie.split("; ");for(var d=0;d<e.length;d++){var c=e[d].split("=");if(c[0].indexOf("jwplayer.")==0){f[c[0].substring(9,c[0].length)]=c[1]}}return f};b.utils.readCookie=function(c){return b.utils.getCookies()[c]}})(jwplayer);(function(a){a.events=function(){};a.events.COMPLETE="COMPLETE";a.events.ERROR="ERROR"})(jwplayer);(function(jwplayer){jwplayer.events.eventdispatcher=function(debug){var _debug=debug;var _listeners;var _globallisteners;this.resetEventListeners=function(){_listeners={};_globallisteners=[]};this.resetEventListeners();this.addEventListener=function(type,listener,count){try{if(!jwplayer.utils.exists(_listeners[type])){_listeners[type]=[]}if(typeof(listener)=="string"){eval("listener = "+listener)}_listeners[type].push({listener:listener,count:count})}catch(err){jwplayer.utils.log("error",err)}return false};this.removeEventListener=function(type,listener){if(!_listeners[type]){return}try{for(var listenerIndex=0;listenerIndex<_listeners[type].length;listenerIndex++){if(_listeners[type][listenerIndex].listener.toString()==listener.toString()){_listeners[type].splice(listenerIndex,1);break}}}catch(err){jwplayer.utils.log("error",err)}return false};this.addGlobalListener=function(listener,count){try{if(typeof(listener)=="string"){eval("listener = "+listener)}_globallisteners.push({listener:listener,count:count})}catch(err){jwplayer.utils.log("error",err)}return false};this.removeGlobalListener=function(listener){if(!listener){return}try{for(var globalListenerIndex=0;globalListenerIndex<_globallisteners.length;globalListenerIndex++){if(_globallisteners[globalListenerIndex].listener.toString()==listener.toString()){_globallisteners.splice(globalListenerIndex,1);break}}}catch(err){jwplayer.utils.log("error",err)}return false};this.sendEvent=function(type,data){if(!jwplayer.utils.exists(data)){data={}}if(_debug){jwplayer.utils.log(type,data)}if(typeof _listeners[type]!="undefined"){for(var listenerIndex=0;listenerIndex<_listeners[type].length;listenerIndex++){try{_listeners[type][listenerIndex].listener(data)}catch(err){jwplayer.utils.log("There was an error while handling a listener: "+err.toString(),_listeners[type][listenerIndex].listener)}if(_listeners[type][listenerIndex]){if(_listeners[type][listenerIndex].count===1){delete _listeners[type][listenerIndex]}else{if(_listeners[type][listenerIndex].count>0){_listeners[type][listenerIndex].count=_listeners[type][listenerIndex].count-1}}}}}for(var globalListenerIndex=0;globalListenerIndex<_globallisteners.length;globalListenerIndex++){try{_globallisteners[globalListenerIndex].listener(data)}catch(err){jwplayer.utils.log("There was an error while handling a listener: "+err.toString(),_globallisteners[globalListenerIndex].listener)}if(_globallisteners[globalListenerIndex]){if(_globallisteners[globalListenerIndex].count===1){delete _globallisteners[globalListenerIndex]}else{if(_globallisteners[globalListenerIndex].count>0){_globallisteners[globalListenerIndex].count=_globallisteners[globalListenerIndex].count-1}}}}}}})(jwplayer);(function(a){var b={};a.utils.animations=function(){};a.utils.animations.transform=function(c,d){c.style.webkitTransform=d;c.style.MozTransform=d;c.style.OTransform=d;c.style.msTransform=d};a.utils.animations.transformOrigin=function(c,d){c.style.webkitTransformOrigin=d;c.style.MozTransformOrigin=d;c.style.OTransformOrigin=d;c.style.msTransformOrigin=d};a.utils.animations.rotate=function(c,d){a.utils.animations.transform(c,["rotate(",d,"deg)"].join(""))};a.utils.cancelAnimation=function(c){delete b[c.id]};a.utils.fadeTo=function(m,f,e,j,h,d){if(b[m.id]!=d&&a.utils.exists(d)){return}if(m.style.opacity==f){return}var c=new Date().getTime();if(d>c){setTimeout(function(){a.utils.fadeTo(m,f,e,j,0,d)},d-c)}if(m.style.display=="none"){m.style.display="block"}if(!a.utils.exists(j)){j=m.style.opacity===""?1:m.style.opacity}if(m.style.opacity==f&&m.style.opacity!==""&&a.utils.exists(d)){if(f===0){m.style.display="none"}return}if(!a.utils.exists(d)){d=c;b[m.id]=d}if(!a.utils.exists(h)){h=0}var k=(e>0)?((c-d)/(e*1000)):0;k=k>1?1:k;var l=f-j;var g=j+(k*l);if(g>1){g=1}else{if(g<0){g=0}}m.style.opacity=g;if(h>0){b[m.id]=d+h*1000;a.utils.fadeTo(m,f,e,j,0,b[m.id]);return}setTimeout(function(){a.utils.fadeTo(m,f,e,j,0,d)},10)}})(jwplayer);(function(a){a.utils.arrays=function(){};a.utils.arrays.indexOf=function(c,d){for(var b=0;b<c.length;b++){if(c[b]==d){return b}}return -1};a.utils.arrays.remove=function(c,d){var b=a.utils.arrays.indexOf(c,d);if(b>-1){c.splice(b,1)}}})(jwplayer);(function(a){a.utils.extensionmap={"3gp":{html5:"video/3gpp",flash:"video"},"3gpp":{html5:"video/3gpp"},"3g2":{html5:"video/3gpp2",flash:"video"},"3gpp2":{html5:"video/3gpp2"},flv:{flash:"video"},f4a:{html5:"audio/mp4"},f4b:{html5:"audio/mp4",flash:"video"},f4v:{html5:"video/mp4",flash:"video"},mov:{html5:"video/quicktime",flash:"video"},m4a:{html5:"audio/mp4",flash:"video"},m4b:{html5:"audio/mp4"},m4p:{html5:"audio/mp4"},m4v:{html5:"video/mp4",flash:"video"},mp4:{html5:"video/mp4",flash:"video"},rbs:{flash:"sound"},aac:{html5:"audio/aac",flash:"video"},mp3:{html5:"audio/mp3",flash:"sound"},ogg:{html5:"audio/ogg"},oga:{html5:"audio/ogg"},ogv:{html5:"video/ogg"},webm:{html5:"video/webm"},m3u8:{html5:"audio/x-mpegurl"},gif:{flash:"image"},jpeg:{flash:"image"},jpg:{flash:"image"},swf:{flash:"image"},png:{flash:"image"},wav:{html5:"audio/x-wav"}}})(jwplayer);(function(e){e.utils.mediaparser=function(){};var g={element:{width:"width",height:"height",id:"id","class":"className",name:"name"},media:{src:"file",preload:"preload",autoplay:"autostart",loop:"repeat",controls:"controls"},source:{src:"file",type:"type",media:"media","data-jw-width":"width","data-jw-bitrate":"bitrate"},video:{poster:"image"}};var f={};e.utils.mediaparser.parseMedia=function(j){return d(j)};function c(k,j){if(!e.utils.exists(j)){j=g[k]}else{e.utils.extend(j,g[k])}return j}function d(n,j){if(f[n.tagName.toLowerCase()]&&!e.utils.exists(j)){return f[n.tagName.toLowerCase()](n)}else{j=c("element",j);var o={};for(var k in j){if(k!="length"){var m=n.getAttribute(k);if(e.utils.exists(m)){o[j[k]]=m}}}var l=n.style["#background-color"];if(l&&!(l=="transparent"||l=="rgba(0, 0, 0, 0)")){o.screencolor=l}return o}}function h(n,k){k=c("media",k);var l=[];var j=e.utils.selectors("source",n);for(var m in j){if(!isNaN(m)){l.push(a(j[m]))}}var o=d(n,k);if(e.utils.exists(o.file)){l[0]={file:o.file}}o.levels=l;return o}function a(l,k){k=c("source",k);var j=d(l,k);j.width=j.width?j.width:0;j.bitrate=j.bitrate?j.bitrate:0;return j}function b(l,k){k=c("video",k);var j=h(l,k);return j}f.media=h;f.audio=h;f.source=a;f.video=b})(jwplayer);(function(a){a.utils.loaderstatus={NEW:"NEW",LOADING:"LOADING",ERROR:"ERROR",COMPLETE:"COMPLETE"};a.utils.scriptloader=function(c){var d=a.utils.loaderstatus.NEW;var b=new a.events.eventdispatcher();a.utils.extend(this,b);this.load=function(){if(d==a.utils.loaderstatus.NEW){d=a.utils.loaderstatus.LOADING;var e=document.createElement("script");e.onload=function(f){d=a.utils.loaderstatus.COMPLETE;b.sendEvent(a.events.COMPLETE)};e.onerror=function(f){d=a.utils.loaderstatus.ERROR;b.sendEvent(a.events.ERROR)};e.onreadystatechange=function(){if(e.readyState=="loaded"||e.readyState=="complete"){d=a.utils.loaderstatus.COMPLETE;b.sendEvent(a.events.COMPLETE)}};document.getElementsByTagName("head")[0].appendChild(e);e.src=c}};this.getStatus=function(){return d}}})(jwplayer);(function(a){a.utils.selectors=function(b,e){if(!a.utils.exists(e)){e=document}b=a.utils.strings.trim(b);var c=b.charAt(0);if(c=="#"){return e.getElementById(b.substr(1))}else{if(c=="."){if(e.getElementsByClassName){return e.getElementsByClassName(b.substr(1))}else{return a.utils.selectors.getElementsByTagAndClass("*",b.substr(1))}}else{if(b.indexOf(".")>0){var d=b.split(".");return a.utils.selectors.getElementsByTagAndClass(d[0],d[1])}else{return e.getElementsByTagName(b)}}}return null};a.utils.selectors.getElementsByTagAndClass=function(e,h,g){var j=[];if(!a.utils.exists(g)){g=document}var f=g.getElementsByTagName(e);for(var d=0;d<f.length;d++){if(a.utils.exists(f[d].className)){var c=f[d].className.split(" ");for(var b=0;b<c.length;b++){if(c[b]==h){j.push(f[d])}}}}return j}})(jwplayer);(function(a){a.utils.strings=function(){};a.utils.strings.trim=function(b){return b.replace(/^\s*/,"").replace(/\s*$/,"")};a.utils.strings.pad=function(c,d,b){if(!b){b="0"}while(c.length<d){c=b+c}return c};a.utils.strings.serialize=function(b){if(b==null){return null}else{if(b=="true"){return true}else{if(b=="false"){return false}else{if(isNaN(Number(b))||b.length>5||b.length==0){return b}else{return Number(b)}}}}};a.utils.strings.seconds=function(d){d=d.replace(",",".");var b=d.split(":");var c=0;if(d.substr(-1)=="s"){c=Number(d.substr(0,d.length-1))}else{if(d.substr(-1)=="m"){c=Number(d.substr(0,d.length-1))*60}else{if(d.substr(-1)=="h"){c=Number(d.substr(0,d.length-1))*3600}else{if(b.length>1){c=Number(b[b.length-1]);c+=Number(b[b.length-2])*60;if(b.length==3){c+=Number(b[b.length-3])*3600}}else{c=Number(d)}}}}return c};a.utils.strings.xmlAttribute=function(b,c){for(var d=0;d<b.attributes.length;d++){if(b.attributes[d].name&&b.attributes[d].name.toLowerCase()==c.toLowerCase()){return b.attributes[d].value.toString()}}return""};a.utils.strings.jsonToString=function(f){var h=h||{};if(h&&h.stringify){return h.stringify(f)}var c=typeof(f);if(c!="object"||f===null){if(c=="string"){f='"'+f.replace(/"/g,'\\"')+'"'}else{return String(f)}}else{var g=[],b=(f&&f.constructor==Array);for(var d in f){var e=f[d];switch(typeof(e)){case"string":e='"'+e.replace(/"/g,'\\"')+'"';break;case"object":if(a.utils.exists(e)){e=a.utils.strings.jsonToString(e)}break}if(b){if(typeof(e)!="function"){g.push(String(e))}}else{if(typeof(e)!="function"){g.push('"'+d+'":'+String(e))}}}if(b){return"["+String(g)+"]"}else{return"{"+String(g)+"}"}}}})(jwplayer);(function(c){var d=new RegExp(/^(#|0x)[0-9a-fA-F]{3,6}/);c.utils.typechecker=function(g,f){f=!c.utils.exists(f)?b(g):f;return e(g,f)};function b(f){var g=["true","false","t","f"];if(g.toString().indexOf(f.toLowerCase().replace(" ",""))>=0){return"boolean"}else{if(d.test(f)){return"color"}else{if(!isNaN(parseInt(f,10))&&parseInt(f,10).toString().length==f.length){return"integer"}else{if(!isNaN(parseFloat(f))&&parseFloat(f).toString().length==f.length){return"float"}}}}return"string"}function e(g,f){if(!c.utils.exists(f)){return g}switch(f){case"color":if(g.length>0){return a(g)}return null;case"integer":return parseInt(g,10);case"float":return parseFloat(g);case"boolean":if(g.toLowerCase()=="true"){return true}else{if(g=="1"){return true}}return false}return g}function a(f){switch(f.toLowerCase()){case"blue":return parseInt("0000FF",16);case"green":return parseInt("00FF00",16);case"red":return parseInt("FF0000",16);case"cyan":return parseInt("00FFFF",16);case"magenta":return parseInt("FF00FF",16);case"yellow":return parseInt("FFFF00",16);case"black":return parseInt("000000",16);case"white":return parseInt("FFFFFF",16);default:f=f.replace(/(#|0x)?([0-9A-F]{3,6})$/gi,"$2");if(f.length==3){f=f.charAt(0)+f.charAt(0)+f.charAt(1)+f.charAt(1)+f.charAt(2)+f.charAt(2)}return parseInt(f,16)}return parseInt("000000",16)}})(jwplayer);(function(a){a.utils.parsers=function(){};a.utils.parsers.localName=function(b){if(!b){return""}else{if(b.localName){return b.localName}else{if(b.baseName){return b.baseName}else{return""}}}};a.utils.parsers.textContent=function(b){if(!b){return""}else{if(b.textContent){return b.textContent}else{if(b.text){return b.text}else{return""}}}}})(jwplayer);(function(a){a.utils.parsers.jwparser=function(){};a.utils.parsers.jwparser.PREFIX="jwplayer";a.utils.parsers.jwparser.parseEntry=function(c,d){for(var b=0;b<c.childNodes.length;b++){if(c.childNodes[b].prefix==a.utils.parsers.jwparser.PREFIX){d[a.utils.parsers.localName(c.childNodes[b])]=a.utils.strings.serialize(a.utils.parsers.textContent(c.childNodes[b]));if(a.utils.parsers.localName(c.childNodes[b])=="file"&&d.levels){delete d.levels}}if(!d.file&&String(d.link).toLowerCase().indexOf("youtube")>-1){d.file=d.link}}return d};a.utils.parsers.jwparser.getProvider=function(c){if(c.type){return c.type}else{if(c.file.indexOf("youtube.com/w")>-1||c.file.indexOf("youtube.com/v")>-1||c.file.indexOf("youtu.be/")>-1){return"youtube"}else{if(c.streamer&&c.streamer.indexOf("rtmp")==0){return"rtmp"}else{if(c.streamer&&c.streamer.indexOf("http")==0){return"http"}else{var b=a.utils.strings.extension(c.file);if(extensions.hasOwnProperty(b)){return extensions[b]}}}}}return""}})(jwplayer);(function(a){a.utils.parsers.mediaparser=function(){};a.utils.parsers.mediaparser.PREFIX="media";a.utils.parsers.mediaparser.parseGroup=function(d,f){var e=false;for(var c=0;c<d.childNodes.length;c++){if(d.childNodes[c].prefix==a.utils.parsers.mediaparser.PREFIX){if(!a.utils.parsers.localName(d.childNodes[c])){continue}switch(a.utils.parsers.localName(d.childNodes[c]).toLowerCase()){case"content":if(!e){f.file=a.utils.strings.xmlAttribute(d.childNodes[c],"url")}if(a.utils.strings.xmlAttribute(d.childNodes[c],"duration")){f.duration=a.utils.strings.seconds(a.utils.strings.xmlAttribute(d.childNodes[c],"duration"))}if(a.utils.strings.xmlAttribute(d.childNodes[c],"start")){f.start=a.utils.strings.seconds(a.utils.strings.xmlAttribute(d.childNodes[c],"start"))}if(d.childNodes[c].childNodes&&d.childNodes[c].childNodes.length>0){f=a.utils.parsers.mediaparser.parseGroup(d.childNodes[c],f)}if(a.utils.strings.xmlAttribute(d.childNodes[c],"width")||a.utils.strings.xmlAttribute(d.childNodes[c],"bitrate")||a.utils.strings.xmlAttribute(d.childNodes[c],"url")){if(!f.levels){f.levels=[]}f.levels.push({width:a.utils.strings.xmlAttribute(d.childNodes[c],"width"),bitrate:a.utils.strings.xmlAttribute(d.childNodes[c],"bitrate"),file:a.utils.strings.xmlAttribute(d.childNodes[c],"url")})}break;case"title":f.title=a.utils.parsers.textContent(d.childNodes[c]);break;case"description":f.description=a.utils.parsers.textContent(d.childNodes[c]);break;case"keywords":f.tags=a.utils.parsers.textContent(d.childNodes[c]);break;case"thumbnail":f.image=a.utils.strings.xmlAttribute(d.childNodes[c],"url");break;case"credit":f.author=a.utils.parsers.textContent(d.childNodes[c]);break;case"player":var b=d.childNodes[c].url;if(b.indexOf("youtube.com")>=0||b.indexOf("youtu.be")>=0){e=true;f.file=a.utils.strings.xmlAttribute(d.childNodes[c],"url")}break;case"group":a.utils.parsers.mediaparser.parseGroup(d.childNodes[c],f);break}}}return f}})(jwplayer);(function(b){b.utils.parsers.rssparser=function(){};b.utils.parsers.rssparser.parse=function(f){var c=[];for(var e=0;e<f.childNodes.length;e++){if(b.utils.parsers.localName(f.childNodes[e]).toLowerCase()=="channel"){for(var d=0;d<f.childNodes[e].childNodes.length;d++){if(b.utils.parsers.localName(f.childNodes[e].childNodes[d]).toLowerCase()=="item"){c.push(a(f.childNodes[e].childNodes[d]))}}}}return c};function a(d){var e={};for(var c=0;c<d.childNodes.length;c++){if(!b.utils.parsers.localName(d.childNodes[c])){continue}switch(b.utils.parsers.localName(d.childNodes[c]).toLowerCase()){case"enclosure":e.file=b.utils.strings.xmlAttribute(d.childNodes[c],"url");break;case"title":e.title=b.utils.parsers.textContent(d.childNodes[c]);break;case"pubdate":e.date=b.utils.parsers.textContent(d.childNodes[c]);break;case"description":e.description=b.utils.parsers.textContent(d.childNodes[c]);break;case"link":e.link=b.utils.parsers.textContent(d.childNodes[c]);break;case"category":if(e.tags){e.tags+=b.utils.parsers.textContent(d.childNodes[c])}else{e.tags=b.utils.parsers.textContent(d.childNodes[c])}break}}e=b.utils.parsers.mediaparser.parseGroup(d,e);e=b.utils.parsers.jwparser.parseEntry(d,e);return new b.html5.playlistitem(e)}})(jwplayer);(function(a){var c={};var b={};a.plugins=function(){};a.plugins.loadPlugins=function(e,d){b[e]=new a.plugins.pluginloader(new a.plugins.model(c),d);return b[e]};a.plugins.registerPlugin=function(h,f,e){var d=a.utils.getPluginName(h);if(c[d]){c[d].registerPlugin(h,f,e)}else{a.utils.log("A plugin ("+h+") was registered with the player that was not loaded. Please check your configuration.");for(var g in b){b[g].pluginFailed()}}}})(jwplayer);(function(a){a.plugins.model=function(b){this.addPlugin=function(c){var d=a.utils.getPluginName(c);if(!b[d]){b[d]=new a.plugins.plugin(c)}return b[d]}}})(jwplayer);(function(a){a.plugins.pluginmodes={FLASH:"FLASH",JAVASCRIPT:"JAVASCRIPT",HYBRID:"HYBRID"};a.plugins.plugin=function(b){var d="http://lp.longtailvideo.com";var j=a.utils.loaderstatus.NEW;var k;var h;var l;var c=new a.events.eventdispatcher();a.utils.extend(this,c);function e(){switch(a.utils.getPluginPathType(b)){case a.utils.pluginPathType.ABSOLUTE:return b;case a.utils.pluginPathType.RELATIVE:return a.utils.getAbsolutePath(b,window.location.href);case a.utils.pluginPathType.CDN:var o=a.utils.getPluginName(b);var n=a.utils.getPluginVersion(b);var m=(window.location.href.indexOf("https://")==0)?d.replace("http://","https://secure"):d;return m+"/"+a.version.split(".")[0]+"/"+o+"/"+o+(n!==""?("-"+n):"")+".js"}}function g(m){l=setTimeout(function(){j=a.utils.loaderstatus.COMPLETE;c.sendEvent(a.events.COMPLETE)},1000)}function f(m){j=a.utils.loaderstatus.ERROR;c.sendEvent(a.events.ERROR)}this.load=function(){if(j==a.utils.loaderstatus.NEW){if(b.lastIndexOf(".swf")>0){k=b;j=a.utils.loaderstatus.COMPLETE;c.sendEvent(a.events.COMPLETE);return}j=a.utils.loaderstatus.LOADING;var m=new a.utils.scriptloader(e());m.addEventListener(a.events.COMPLETE,g);m.addEventListener(a.events.ERROR,f);m.load()}};this.registerPlugin=function(o,n,m){if(l){clearTimeout(l);l=undefined}if(n&&m){k=m;h=n}else{if(typeof n=="string"){k=n}else{if(typeof n=="function"){h=n}else{if(!n&&!m){k=o}}}}j=a.utils.loaderstatus.COMPLETE;c.sendEvent(a.events.COMPLETE)};this.getStatus=function(){return j};this.getPluginName=function(){return a.utils.getPluginName(b)};this.getFlashPath=function(){if(k){switch(a.utils.getPluginPathType(k)){case a.utils.pluginPathType.ABSOLUTE:return k;case a.utils.pluginPathType.RELATIVE:if(b.lastIndexOf(".swf")>0){return a.utils.getAbsolutePath(k,window.location.href)}return a.utils.getAbsolutePath(k,e());case a.utils.pluginPathType.CDN:if(k.indexOf("-")>-1){return k+"h"}return k+"-h"}}return null};this.getJS=function(){return h};this.getPluginmode=function(){if(typeof k!="undefined"&&typeof h!="undefined"){return a.plugins.pluginmodes.HYBRID}else{if(typeof k!="undefined"){return a.plugins.pluginmodes.FLASH}else{if(typeof h!="undefined"){return a.plugins.pluginmodes.JAVASCRIPT}}}};this.getNewInstance=function(n,m,o){return new h(n,m,o)};this.getURL=function(){return b}}})(jwplayer);(function(a){a.plugins.pluginloader=function(h,e){var g={};var k=a.utils.loaderstatus.NEW;var d=false;var b=false;var c=new a.events.eventdispatcher();a.utils.extend(this,c);function f(){if(!b){b=true;k=a.utils.loaderstatus.COMPLETE;c.sendEvent(a.events.COMPLETE)}}function j(){if(!b){var m=0;for(plugin in g){var l=g[plugin].getStatus();if(l==a.utils.loaderstatus.LOADING||l==a.utils.loaderstatus.NEW){m++}}if(m==0){f()}}}this.setupPlugins=function(n,l,s){var m={length:0,plugins:{}};var p={length:0,plugins:{}};for(var o in g){var q=g[o].getPluginName();if(g[o].getFlashPath()){m.plugins[g[o].getFlashPath()]=l.plugins[o];m.plugins[g[o].getFlashPath()].pluginmode=g[o].getPluginmode();m.length++}if(g[o].getJS()){var r=document.createElement("div");r.id=n.id+"_"+q;r.style.position="absolute";r.style.zIndex=p.length+10;p.plugins[q]=g[o].getNewInstance(n,l.plugins[o],r);p.length++;if(typeof p.plugins[q].resize!="undefined"){n.onReady(s(p.plugins[q],r,true));n.onResize(s(p.plugins[q],r))}}}n.plugins=p.plugins;return m};this.load=function(){k=a.utils.loaderstatus.LOADING;d=true;for(var l in e){if(a.utils.exists(l)){g[l]=h.addPlugin(l);g[l].addEventListener(a.events.COMPLETE,j);g[l].addEventListener(a.events.ERROR,j)}}for(l in g){g[l].load()}d=false;j()};this.pluginFailed=function(){f()};this.getStatus=function(){return k}}})(jwplayer);(function(b){var a=[];b.api=function(d){this.container=d;this.id=d.id;var m={};var t={};var p={};var c=[];var g=undefined;var k=false;var h=[];var r=undefined;var o=b.utils.getOuterHTML(d);var s={};var j={};this.getBuffer=function(){return this.callInternal("jwGetBuffer")};this.getContainer=function(){return this.container};function e(v,u){return function(A,w,x,y){if(v.renderingMode=="flash"||v.renderingMode=="html5"){var z;if(w){j[A]=w;z="jwplayer('"+v.id+"').callback('"+A+"')"}else{if(!w&&j[A]){delete j[A]}}g.jwDockSetButton(A,z,x,y)}return u}}this.getPlugin=function(u){var w=this;var v={};if(u=="dock"){return b.utils.extend(v,{setButton:e(w,v),show:function(){w.callInternal("jwDockShow");return v},hide:function(){w.callInternal("jwDockHide");return v},onShow:function(x){w.componentListener("dock",b.api.events.JWPLAYER_COMPONENT_SHOW,x);return v},onHide:function(x){w.componentListener("dock",b.api.events.JWPLAYER_COMPONENT_HIDE,x);return v}})}else{if(u=="controlbar"){return b.utils.extend(v,{show:function(){w.callInternal("jwControlbarShow");return v},hide:function(){w.callInternal("jwControlbarHide");return v},onShow:function(x){w.componentListener("controlbar",b.api.events.JWPLAYER_COMPONENT_SHOW,x);return v},onHide:function(x){w.componentListener("controlbar",b.api.events.JWPLAYER_COMPONENT_HIDE,x);return v}})}else{if(u=="display"){return b.utils.extend(v,{show:function(){w.callInternal("jwDisplayShow");return v},hide:function(){w.callInternal("jwDisplayHide");return v},onShow:function(x){w.componentListener("display",b.api.events.JWPLAYER_COMPONENT_SHOW,x);return v},onHide:function(x){w.componentListener("display",b.api.events.JWPLAYER_COMPONENT_HIDE,x);return v}})}else{return this.plugins[u]}}}};this.callback=function(u){if(j[u]){return j[u]()}};this.getDuration=function(){return this.callInternal("jwGetDuration")};this.getFullscreen=function(){return this.callInternal("jwGetFullscreen")};this.getHeight=function(){return this.callInternal("jwGetHeight")};this.getLockState=function(){return this.callInternal("jwGetLockState")};this.getMeta=function(){return this.getItemMeta()};this.getMute=function(){return this.callInternal("jwGetMute")};this.getPlaylist=function(){var v=this.callInternal("jwGetPlaylist");if(this.renderingMode=="flash"){b.utils.deepReplaceKeyName(v,["__dot__","__spc__","__dsh__"],["."," ","-"])}for(var u=0;u<v.length;u++){if(!b.utils.exists(v[u].index)){v[u].index=u}}return v};this.getPlaylistItem=function(u){if(!b.utils.exists(u)){u=this.getCurrentItem()}return this.getPlaylist()[u]};this.getPosition=function(){return this.callInternal("jwGetPosition")};this.getRenderingMode=function(){return this.renderingMode};this.getState=function(){return this.callInternal("jwGetState")};this.getVolume=function(){return this.callInternal("jwGetVolume")};this.getWidth=function(){return this.callInternal("jwGetWidth")};this.setFullscreen=function(u){if(!b.utils.exists(u)){this.callInternal("jwSetFullscreen",!this.callInternal("jwGetFullscreen"))}else{this.callInternal("jwSetFullscreen",u)}return this};this.setMute=function(u){if(!b.utils.exists(u)){this.callInternal("jwSetMute",!this.callInternal("jwGetMute"))}else{this.callInternal("jwSetMute",u)}return this};this.lock=function(){return this};this.unlock=function(){return this};this.load=function(u){this.callInternal("jwLoad",u);return this};this.playlistItem=function(u){this.callInternal("jwPlaylistItem",u);return this};this.playlistPrev=function(){this.callInternal("jwPlaylistPrev");return this};this.playlistNext=function(){this.callInternal("jwPlaylistNext");return this};this.resize=function(v,u){if(this.renderingMode=="html5"){g.jwResize(v,u)}else{this.container.width=v;this.container.height=u;var w=document.getElementById(this.id+"_wrapper");if(w){w.style.width=v+"px";w.style.height=u+"px"}}return this};this.play=function(u){if(typeof u=="undefined"){u=this.getState();if(u==b.api.events.state.PLAYING||u==b.api.events.state.BUFFERING){this.callInternal("jwPause")}else{this.callInternal("jwPlay")}}else{this.callInternal("jwPlay",u)}return this};this.pause=function(u){if(typeof u=="undefined"){u=this.getState();if(u==b.api.events.state.PLAYING||u==b.api.events.state.BUFFERING){this.callInternal("jwPause")}else{this.callInternal("jwPlay")}}else{this.callInternal("jwPause",u)}return this};this.stop=function(){this.callInternal("jwStop");return this};this.seek=function(u){this.callInternal("jwSeek",u);return this};this.setVolume=function(u){this.callInternal("jwSetVolume",u);return this};this.loadInstream=function(v,u){r=new b.api.instream(this,g,v,u);return r};this.onBufferChange=function(u){return this.eventListener(b.api.events.JWPLAYER_MEDIA_BUFFER,u)};this.onBufferFull=function(u){return this.eventListener(b.api.events.JWPLAYER_MEDIA_BUFFER_FULL,u)};this.onError=function(u){return this.eventListener(b.api.events.JWPLAYER_ERROR,u)};this.onFullscreen=function(u){return this.eventListener(b.api.events.JWPLAYER_FULLSCREEN,u)};this.onMeta=function(u){return this.eventListener(b.api.events.JWPLAYER_MEDIA_META,u)};this.onMute=function(u){return this.eventListener(b.api.events.JWPLAYER_MEDIA_MUTE,u)};this.onPlaylist=function(u){return this.eventListener(b.api.events.JWPLAYER_PLAYLIST_LOADED,u)};this.onPlaylistItem=function(u){return this.eventListener(b.api.events.JWPLAYER_PLAYLIST_ITEM,u)};this.onReady=function(u){return this.eventListener(b.api.events.API_READY,u)};this.onResize=function(u){return this.eventListener(b.api.events.JWPLAYER_RESIZE,u)};this.onComplete=function(u){return this.eventListener(b.api.events.JWPLAYER_MEDIA_COMPLETE,u)};this.onSeek=function(u){return this.eventListener(b.api.events.JWPLAYER_MEDIA_SEEK,u)};this.onTime=function(u){return this.eventListener(b.api.events.JWPLAYER_MEDIA_TIME,u)};this.onVolume=function(u){return this.eventListener(b.api.events.JWPLAYER_MEDIA_VOLUME,u)};this.onBeforePlay=function(u){return this.eventListener(b.api.events.JWPLAYER_MEDIA_BEFOREPLAY,u)};this.onBeforeComplete=function(u){return this.eventListener(b.api.events.JWPLAYER_MEDIA_BEFORECOMPLETE,u)};this.onBuffer=function(u){return this.stateListener(b.api.events.state.BUFFERING,u)};this.onPause=function(u){return this.stateListener(b.api.events.state.PAUSED,u)};this.onPlay=function(u){return this.stateListener(b.api.events.state.PLAYING,u)};this.onIdle=function(u){return this.stateListener(b.api.events.state.IDLE,u)};this.remove=function(){if(!k){throw"Cannot call remove() before player is ready";return}q(this)};function q(u){h=[];if(b.utils.getOuterHTML(u.container)!=o){b.api.destroyPlayer(u.id,o)}}this.setup=function(v){if(b.embed){var u=this.id;q(this);var w=b(u);w.config=v;return new b.embed(w)}return this};this.registerPlugin=function(w,v,u){b.plugins.registerPlugin(w,v,u)};this.setPlayer=function(u,v){g=u;this.renderingMode=v};this.stateListener=function(u,v){if(!t[u]){t[u]=[];this.eventListener(b.api.events.JWPLAYER_PLAYER_STATE,f(u))}t[u].push(v);return this};this.detachMedia=function(){if(this.renderingMode=="html5"){return this.callInternal("jwDetachMedia")}};this.attachMedia=function(){if(this.renderingMode=="html5"){return this.callInternal("jwAttachMedia")}};function f(u){return function(w){var v=w.newstate,y=w.oldstate;if(v==u){var x=t[v];if(x){for(var z=0;z<x.length;z++){if(typeof x[z]=="function"){x[z].call(this,{oldstate:y,newstate:v})}}}}}}this.componentListener=function(u,v,w){if(!p[u]){p[u]={}}if(!p[u][v]){p[u][v]=[];this.eventListener(v,l(u,v))}p[u][v].push(w);return this};function l(u,v){return function(x){if(u==x.component){var w=p[u][v];if(w){for(var y=0;y<w.length;y++){if(typeof w[y]=="function"){w[y].call(this,x)}}}}}}this.addInternalListener=function(u,v){try{u.jwAddEventListener(v,'function(dat) { jwplayer("'+this.id+'").dispatchEvent("'+v+'", dat); }')}catch(w){b.utils.log("Could not add internal listener")}};this.eventListener=function(u,v){if(!m[u]){m[u]=[];if(g&&k){this.addInternalListener(g,u)}}m[u].push(v);return this};this.dispatchEvent=function(w){if(m[w]){var v=_utils.translateEventResponse(w,arguments[1]);for(var u=0;u<m[w].length;u++){if(typeof m[w][u]=="function"){m[w][u].call(this,v)}}}};this.dispatchInstreamEvent=function(u){if(r){r.dispatchEvent(u,arguments)}};this.callInternal=function(){if(k){var w=arguments[0],u=[];for(var v=1;v<arguments.length;v++){u.push(arguments[v])}if(typeof g!="undefined"&&typeof g[w]=="function"){if(u.length==2){return(g[w])(u[0],u[1])}else{if(u.length==1){return(g[w])(u[0])}else{return(g[w])()}}}return null}else{h.push(arguments)}};this.playerReady=function(v){k=true;if(!g){this.setPlayer(document.getElementById(v.id))}this.container=document.getElementById(this.id);for(var u in m){this.addInternalListener(g,u)}this.eventListener(b.api.events.JWPLAYER_PLAYLIST_ITEM,function(w){s={}});this.eventListener(b.api.events.JWPLAYER_MEDIA_META,function(w){b.utils.extend(s,w.metadata)});this.dispatchEvent(b.api.events.API_READY);while(h.length>0){this.callInternal.apply(this,h.shift())}};this.getItemMeta=function(){return s};this.getCurrentItem=function(){return this.callInternal("jwGetPlaylistIndex")};function n(w,y,x){var u=[];if(!y){y=0}if(!x){x=w.length-1}for(var v=y;v<=x;v++){u.push(w[v])}return u}return this};b.api.selectPlayer=function(d){var c;if(!b.utils.exists(d)){d=0}if(d.nodeType){c=d}else{if(typeof d=="string"){c=document.getElementById(d)}}if(c){var e=b.api.playerById(c.id);if(e){return e}else{return b.api.addPlayer(new b.api(c))}}else{if(typeof d=="number"){return b.getPlayers()[d]}}return null};b.api.events={API_READY:"jwplayerAPIReady",JWPLAYER_READY:"jwplayerReady",JWPLAYER_FULLSCREEN:"jwplayerFullscreen",JWPLAYER_RESIZE:"jwplayerResize",JWPLAYER_ERROR:"jwplayerError",JWPLAYER_MEDIA_BEFOREPLAY:"jwplayerMediaBeforePlay",JWPLAYER_MEDIA_BEFORECOMPLETE:"jwplayerMediaBeforeComplete",JWPLAYER_COMPONENT_SHOW:"jwplayerComponentShow",JWPLAYER_COMPONENT_HIDE:"jwplayerComponentHide",JWPLAYER_MEDIA_BUFFER:"jwplayerMediaBuffer",JWPLAYER_MEDIA_BUFFER_FULL:"jwplayerMediaBufferFull",JWPLAYER_MEDIA_ERROR:"jwplayerMediaError",JWPLAYER_MEDIA_LOADED:"jwplayerMediaLoaded",JWPLAYER_MEDIA_COMPLETE:"jwplayerMediaComplete",JWPLAYER_MEDIA_SEEK:"jwplayerMediaSeek",JWPLAYER_MEDIA_TIME:"jwplayerMediaTime",JWPLAYER_MEDIA_VOLUME:"jwplayerMediaVolume",JWPLAYER_MEDIA_META:"jwplayerMediaMeta",JWPLAYER_MEDIA_MUTE:"jwplayerMediaMute",JWPLAYER_PLAYER_STATE:"jwplayerPlayerState",JWPLAYER_PLAYLIST_LOADED:"jwplayerPlaylistLoaded",JWPLAYER_PLAYLIST_ITEM:"jwplayerPlaylistItem",JWPLAYER_INSTREAM_CLICK:"jwplayerInstreamClicked",JWPLAYER_INSTREAM_DESTROYED:"jwplayerInstreamDestroyed"};b.api.events.state={BUFFERING:"BUFFERING",IDLE:"IDLE",PAUSED:"PAUSED",PLAYING:"PLAYING"};b.api.playerById=function(d){for(var c=0;c<a.length;c++){if(a[c].id==d){return a[c]}}return null};b.api.addPlayer=function(c){for(var d=0;d<a.length;d++){if(a[d]==c){return c}}a.push(c);return c};b.api.destroyPlayer=function(g,d){var f=-1;for(var j=0;j<a.length;j++){if(a[j].id==g){f=j;continue}}if(f>=0){var c=document.getElementById(a[f].id);if(document.getElementById(a[f].id+"_wrapper")){c=document.getElementById(a[f].id+"_wrapper")}if(c){if(d){b.utils.setOuterHTML(c,d)}else{var h=document.createElement("div");var e=c.id;if(c.id.indexOf("_wrapper")==c.id.length-8){newID=c.id.substring(0,c.id.length-8)}h.setAttribute("id",e);c.parentNode.replaceChild(h,c)}}a.splice(f,1)}return null};b.getPlayers=function(){return a.slice(0)}})(jwplayer);var _userPlayerReady=(typeof playerReady=="function")?playerReady:undefined;playerReady=function(b){var a=jwplayer.api.playerById(b.id);if(a){a.playerReady(b)}else{jwplayer.api.selectPlayer(b.id).playerReady(b)}if(_userPlayerReady){_userPlayerReady.call(this,b)}};(function(a){a.api.instream=function(c,j,n,q){var h=c;var b=j;var g=n;var k=q;var e={};var p={};function f(){h.callInternal("jwLoadInstream",n,q)}function m(r,s){b.jwInstreamAddEventListener(s,'function(dat) { jwplayer("'+h.id+'").dispatchInstreamEvent("'+s+'", dat); }')}function d(r,s){if(!e[r]){e[r]=[];m(b,r)}e[r].push(s);return this}function o(r,s){if(!p[r]){p[r]=[];d(a.api.events.JWPLAYER_PLAYER_STATE,l(r))}p[r].push(s);return this}function l(r){return function(t){var s=t.newstate,v=t.oldstate;if(s==r){var u=p[s];if(u){for(var w=0;w<u.length;w++){if(typeof u[w]=="function"){u[w].call(this,{oldstate:v,newstate:s,type:t.type})}}}}}}this.dispatchEvent=function(u,t){if(e[u]){var s=_utils.translateEventResponse(u,t[1]);for(var r=0;r<e[u].length;r++){if(typeof e[u][r]=="function"){e[u][r].call(this,s)}}}};this.onError=function(r){return d(a.api.events.JWPLAYER_ERROR,r)};this.onFullscreen=function(r){return d(a.api.events.JWPLAYER_FULLSCREEN,r)};this.onMeta=function(r){return d(a.api.events.JWPLAYER_MEDIA_META,r)};this.onMute=function(r){return d(a.api.events.JWPLAYER_MEDIA_MUTE,r)};this.onComplete=function(r){return d(a.api.events.JWPLAYER_MEDIA_COMPLETE,r)};this.onSeek=function(r){return d(a.api.events.JWPLAYER_MEDIA_SEEK,r)};this.onTime=function(r){return d(a.api.events.JWPLAYER_MEDIA_TIME,r)};this.onVolume=function(r){return d(a.api.events.JWPLAYER_MEDIA_VOLUME,r)};this.onBuffer=function(r){return o(a.api.events.state.BUFFERING,r)};this.onPause=function(r){return o(a.api.events.state.PAUSED,r)};this.onPlay=function(r){return o(a.api.events.state.PLAYING,r)};this.onIdle=function(r){return o(a.api.events.state.IDLE,r)};this.onInstreamClick=function(r){return d(a.api.events.JWPLAYER_INSTREAM_CLICK,r)};this.onInstreamDestroyed=function(r){return d(a.api.events.JWPLAYER_INSTREAM_DESTROYED,r)};this.play=function(r){b.jwInstreamPlay(r)};this.pause=function(r){b.jwInstreamPause(r)};this.seek=function(r){b.jwInstreamSeek(r)};this.destroy=function(){b.jwInstreamDestroy()};this.getState=function(){return b.jwInstreamGetState()};this.getDuration=function(){return b.jwInstreamGetDuration()};this.getPosition=function(){return b.jwInstreamGetPosition()};f()}})(jwplayer);(function(a){var c=a.utils;a.embed=function(h){var k={width:400,height:300,components:{controlbar:{position:"over"}}};var g=c.mediaparser.parseMedia(h.container);var f=new a.embed.config(c.extend(k,g,h.config),this);var j=a.plugins.loadPlugins(h.id,f.plugins);function d(n,m){for(var l in m){if(typeof n[l]=="function"){(n[l]).call(n,m[l])}}}function e(){if(j.getStatus()==c.loaderstatus.COMPLETE){for(var n=0;n<f.modes.length;n++){if(f.modes[n].type&&a.embed[f.modes[n].type]){var p=f.modes[n].config;var t=f;if(p){t=c.extend(c.clone(f),p);var s=["file","levels","playlist"];for(var m=0;m<s.length;m++){var q=s[m];if(c.exists(p[q])){for(var l=0;l<s.length;l++){if(l!=m){var o=s[l];if(c.exists(t[o])&&!c.exists(p[o])){delete t[o]}}}}}}var r=new a.embed[f.modes[n].type](document.getElementById(h.id),f.modes[n],t,j,h);if(r.supportsConfig()){r.embed();d(h,f.events);return h}}}c.log("No suitable players found");new a.embed.logo(c.extend({hide:true},f.components.logo),"none",h.id)}}j.addEventListener(a.events.COMPLETE,e);j.addEventListener(a.events.ERROR,e);j.load();return h};function b(){if(!document.body){return setTimeout(b,15)}var d=c.selectors.getElementsByTagAndClass("video","jwplayer");for(var e=0;e<d.length;e++){var f=d[e];if(f.id==""){f.id="jwplayer_"+Math.round(Math.random()*100000)}a(f.id).setup({})}}b()})(jwplayer);(function(e){var k=e.utils;function h(m){var l=[{type:"flash",src:m?m:"/jwplayer/player.swf"},{type:"html5"},{type:"download"}];if(k.isAndroid()){l[0]=l.splice(1,1,l[0])[0]}return l}var a={players:"modes",autoplay:"autostart"};function b(o){var n=o.toLowerCase();var m=["left","right","top","bottom"];for(var l=0;l<m.length;l++){if(n==m[l]){return true}}return false}function c(m){var l=false;l=(m instanceof Array)||(typeof m=="object"&&!m.position&&!m.size);return l}function j(l){if(typeof l=="string"){if(parseInt(l).toString()==l||l.toLowerCase().indexOf("px")>-1){return parseInt(l)}}return l}var g=["playlist","dock","controlbar","logo","display"];function f(l){var o={};switch(k.typeOf(l.plugins)){case"object":for(var n in l.plugins){o[k.getPluginName(n)]=n}break;case"string":var p=l.plugins.split(",");for(var m=0;m<p.length;m++){o[k.getPluginName(p[m])]=p[m]}break}return o}function d(p,o,n,l){if(k.typeOf(p[o])!="object"){p[o]={}}var m=p[o][n];if(k.typeOf(m)!="object"){p[o][n]=m={}}if(l){if(o=="plugins"){var q=k.getPluginName(n);m[l]=p[q+"."+l];delete p[q+"."+l]}else{m[l]=p[n+"."+l];delete p[n+"."+l]}}}e.embed.deserialize=function(m){var n=f(m);for(var l in n){d(m,"plugins",n[l])}for(var q in m){if(q.indexOf(".")>-1){var p=q.split(".");var o=p[0];var q=p[1];if(k.isInArray(g,o)){d(m,"components",o,q)}else{if(n[o]){d(m,"plugins",n[o],q)}}}}return m};e.embed.config=function(l,v){var u=k.extend({},l);var s;if(c(u.playlist)){s=u.playlist;delete u.playlist}u=e.embed.deserialize(u);u.height=j(u.height);u.width=j(u.width);if(typeof u.plugins=="string"){var m=u.plugins.split(",");if(typeof u.plugins!="object"){u.plugins={}}for(var q=0;q<m.length;q++){var r=k.getPluginName(m[q]);if(typeof u[r]=="object"){u.plugins[m[q]]=u[r];delete u[r]}else{u.plugins[m[q]]={}}}}for(var t=0;t<g.length;t++){var p=g[t];if(k.exists(u[p])){if(typeof u[p]!="object"){if(!u.components[p]){u.components[p]={}}if(p=="logo"){u.components[p].file=u[p]}else{u.components[p].position=u[p]}delete u[p]}else{if(!u.components[p]){u.components[p]={}}k.extend(u.components[p],u[p]);delete u[p]}}if(typeof u[p+"size"]!="undefined"){if(!u.components[p]){u.components[p]={}}u.components[p].size=u[p+"size"];delete u[p+"size"]}}if(typeof u.icons!="undefined"){if(!u.components.display){u.components.display={}}u.components.display.icons=u.icons;delete u.icons}for(var o in a){if(u[o]){if(!u[a[o]]){u[a[o]]=u[o]}delete u[o]}}var n;if(u.flashplayer&&!u.modes){n=h(u.flashplayer);delete u.flashplayer}else{if(u.modes){if(typeof u.modes=="string"){n=h(u.modes)}else{if(u.modes instanceof Array){n=u.modes}else{if(typeof u.modes=="object"&&u.modes.type){n=[u.modes]}}}delete u.modes}else{n=h()}}u.modes=n;if(s){u.playlist=s}return u}})(jwplayer);(function(a){a.embed.download=function(c,g,b,d,f){this.embed=function(){var k=a.utils.extend({},b);var q={};var j=b.width?b.width:480;if(typeof j!="number"){j=parseInt(j,10)}var m=b.height?b.height:320;if(typeof m!="number"){m=parseInt(m,10)}var u,o,n;var s={};if(b.playlist&&b.playlist.length){s.file=b.playlist[0].file;o=b.playlist[0].image;s.levels=b.playlist[0].levels}else{s.file=b.file;o=b.image;s.levels=b.levels}if(s.file){u=s.file}else{if(s.levels&&s.levels.length){u=s.levels[0].file}}n=u?"pointer":"auto";var l={display:{style:{cursor:n,width:j,height:m,backgroundColor:"#000",position:"relative",textDecoration:"none",border:"none",display:"block"}},display_icon:{style:{cursor:n,position:"absolute",display:u?"block":"none",top:0,left:0,border:0,margin:0,padding:0,zIndex:3,width:50,height:50,backgroundImage:"url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAALdJREFUeNrs18ENgjAYhmFouDOCcQJGcARHgE10BDcgTOIosAGwQOuPwaQeuFRi2p/3Sb6EC5L3QCxZBgAAAOCorLW1zMn65TrlkH4NcV7QNcUQt7Gn7KIhxA+qNIR81spOGkL8oFJDyLJRdosqKDDkK+iX5+d7huzwM40xptMQMkjIOeRGo+VkEVvIPfTGIpKASfYIfT9iCHkHrBEzf4gcUQ56aEzuGK/mw0rHpy4AAACAf3kJMACBxjAQNRckhwAAAABJRU5ErkJggg==)"}},display_iconBackground:{style:{cursor:n,position:"absolute",display:u?"block":"none",top:((m-50)/2),left:((j-50)/2),border:0,width:50,height:50,margin:0,padding:0,zIndex:2,backgroundImage:"url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAEpJREFUeNrszwENADAIA7DhX8ENoBMZ5KR10EryckCJiIiIiIiIiIiIiIiIiIiIiIh8GmkRERERERERERERERERERERERGRHSPAAPlXH1phYpYaAAAAAElFTkSuQmCC)"}},display_image:{style:{width:j,height:m,display:o?"block":"none",position:"absolute",cursor:n,left:0,top:0,margin:0,padding:0,textDecoration:"none",zIndex:1,border:"none"}}};var h=function(v,x,y){var w=document.createElement(v);if(y){w.id=y}else{w.id=c.id+"_jwplayer_"+x}a.utils.css(w,l[x].style);return w};q.display=h("a","display",c.id);if(u){q.display.setAttribute("href",a.utils.getAbsolutePath(u))}q.display_image=h("img","display_image");q.display_image.setAttribute("alt","Click to download...");if(o){q.display_image.setAttribute("src",a.utils.getAbsolutePath(o))}if(true){q.display_icon=h("div","display_icon");q.display_iconBackground=h("div","display_iconBackground");q.display.appendChild(q.display_image);q.display_iconBackground.appendChild(q.display_icon);q.display.appendChild(q.display_iconBackground)}_css=a.utils.css;_hide=function(v){_css(v,{display:"none"})};function r(v){_imageWidth=q.display_image.naturalWidth;_imageHeight=q.display_image.naturalHeight;t()}function t(){a.utils.stretch(a.utils.stretching.UNIFORM,q.display_image,j,m,_imageWidth,_imageHeight)}q.display_image.onerror=function(v){_hide(q.display_image)};q.display_image.onload=r;c.parentNode.replaceChild(q.display,c);var p=(b.plugins&&b.plugins.logo)?b.plugins.logo:{};q.display.appendChild(new a.embed.logo(b.components.logo,"download",c.id));f.container=document.getElementById(f.id);f.setPlayer(q.display,"download")};this.supportsConfig=function(){if(b){var j=a.utils.getFirstPlaylistItemFromConfig(b);if(typeof j.file=="undefined"&&typeof j.levels=="undefined"){return true}else{if(j.file){return e(j.file,j.provider,j.playlistfile)}else{if(j.levels&&j.levels.length){for(var h=0;h<j.levels.length;h++){if(j.levels[h].file&&e(j.levels[h].file,j.provider,j.playlistfile)){return true}}}}}}else{return true}};function e(j,l,h){if(h){return false}var k=["image","sound","youtube","http"];if(l&&(k.toString().indexOf(l)>-1)){return true}if(!l||(l&&l=="video")){var m=a.utils.extension(j);if(m&&a.utils.extensionmap[m]){return true}}return false}}})(jwplayer);(function(a){a.embed.flash=function(f,g,l,e,j){function m(o,n,p){var q=document.createElement("param");q.setAttribute("name",n);q.setAttribute("value",p);o.appendChild(q)}function k(o,p,n){return function(q){if(n){document.getElementById(j.id+"_wrapper").appendChild(p)}var s=document.getElementById(j.id).getPluginConfig("display");o.resize(s.width,s.height);var r={left:s.x,top:s.y};a.utils.css(p,r)}}function d(p){if(!p){return{}}var r={};for(var o in p){var n=p[o];for(var q in n){r[o+"."+q]=n[q]}}return r}function h(q,p){if(q[p]){var s=q[p];for(var o in s){var n=s[o];if(typeof n=="string"){if(!q[o]){q[o]=n}}else{for(var r in n){if(!q[o+"."+r]){q[o+"."+r]=n[r]}}}}delete q[p]}}function b(q){if(!q){return{}}var t={},s=[];for(var n in q){var p=a.utils.getPluginName(n);var o=q[n];s.push(n);for(var r in o){t[p+"."+r]=o[r]}}t.plugins=s.join(",");return t}function c(p){var n=p.netstreambasepath?"":"netstreambasepath="+encodeURIComponent(window.location.href.split("#")[0])+"&";for(var o in p){if(typeof(p[o])=="object"){n+=o+"="+encodeURIComponent("[[JSON]]"+a.utils.strings.jsonToString(p[o]))+"&"}else{n+=o+"="+encodeURIComponent(p[o])+"&"}}return n.substring(0,n.length-1)}this.embed=function(){l.id=j.id;var A;var r=a.utils.extend({},l);var o=r.width;var y=r.height;if(f.id+"_wrapper"==f.parentNode.id){A=document.getElementById(f.id+"_wrapper")}else{A=document.createElement("div");A.id=f.id+"_wrapper";a.utils.wrap(f,A);a.utils.css(A,{position:"relative",width:o,height:y})}var p=e.setupPlugins(j,r,k);if(p.length>0){a.utils.extend(r,b(p.plugins))}else{delete r.plugins}var s=["height","width","modes","events"];for(var v=0;v<s.length;v++){delete r[s[v]]}var q="opaque";if(r.wmode){q=r.wmode}h(r,"components");h(r,"providers");if(typeof r["dock.position"]!="undefined"){if(r["dock.position"].toString().toLowerCase()=="false"){r.dock=r["dock.position"];delete r["dock.position"]}}var x=a.utils.getCookies();for(var n in x){if(typeof(r[n])=="undefined"){r[n]=x[n]}}var z="#000000";var u;if(a.utils.isIE()){var w='<object classid="clsid:D27CDB6E-AE6D-11cf-96B8-444553540000" bgcolor="'+z+'" width="100%" height="100%" id="'+f.id+'" name="'+f.id+'" tabindex=0"">';w+='<param name="movie" value="'+g.src+'">';w+='<param name="allowfullscreen" value="true">';w+='<param name="allowscriptaccess" value="always">';w+='<param name="seamlesstabbing" value="true">';w+='<param name="wmode" value="'+q+'">';w+='<param name="flashvars" value="'+c(r)+'">';w+="</object>";a.utils.setOuterHTML(f,w);u=document.getElementById(f.id)}else{var t=document.createElement("object");t.setAttribute("type","application/x-shockwave-flash");t.setAttribute("data",g.src);t.setAttribute("width","100%");t.setAttribute("height","100%");t.setAttribute("bgcolor","#000000");t.setAttribute("id",f.id);t.setAttribute("name",f.id);t.setAttribute("tabindex",0);m(t,"allowfullscreen","true");m(t,"allowscriptaccess","always");m(t,"seamlesstabbing","true");m(t,"wmode",q);m(t,"flashvars",c(r));f.parentNode.replaceChild(t,f);u=t}j.container=u;j.setPlayer(u,"flash")};this.supportsConfig=function(){if(a.utils.hasFlash()){if(l){var o=a.utils.getFirstPlaylistItemFromConfig(l);if(typeof o.file=="undefined"&&typeof o.levels=="undefined"){return true}else{if(o.file){return flashCanPlay(o.file,o.provider)}else{if(o.levels&&o.levels.length){for(var n=0;n<o.levels.length;n++){if(o.levels[n].file&&flashCanPlay(o.levels[n].file,o.provider)){return true}}}}}}else{return true}}return false};flashCanPlay=function(n,p){var o=["video","http","sound","image"];if(p&&(o.toString().indexOf(p)<0)){return true}var q=a.utils.extension(n);if(!q){return true}if(a.utils.exists(a.utils.extensionmap[q])&&!a.utils.exists(a.utils.extensionmap[q].flash)){return false}return true}}})(jwplayer);(function(a){a.embed.html5=function(c,g,b,d,f){function e(j,k,h){return function(l){var m=document.getElementById(c.id+"_displayarea");if(h){m.appendChild(k)}j.resize(m.clientWidth,m.clientHeight);k.left=m.style.left;k.top=m.style.top}}this.embed=function(){if(a.html5){d.setupPlugins(f,b,e);c.innerHTML="";var j=a.utils.extend({screencolor:"0x000000"},b);var h=["plugins","modes","events"];for(var k=0;k<h.length;k++){delete j[h[k]]}if(j.levels&&!j.sources){j.sources=b.levels}if(j.skin&&j.skin.toLowerCase().indexOf(".zip")>0){j.skin=j.skin.replace(/\.zip/i,".xml")}var l=new (a.html5(c)).setup(j);f.container=document.getElementById(f.id);f.setPlayer(l,"html5")}else{return null}};this.supportsConfig=function(){if(!!a.vid.canPlayType){if(b){var j=a.utils.getFirstPlaylistItemFromConfig(b);if(typeof j.file=="undefined"&&typeof j.levels=="undefined"){return true}else{if(j.file){return html5CanPlay(a.vid,j.file,j.provider,j.playlistfile)}else{if(j.levels&&j.levels.length){for(var h=0;h<j.levels.length;h++){if(j.levels[h].file&&html5CanPlay(a.vid,j.levels[h].file,j.provider,j.playlistfile)){return true}}}}}}else{return true}}return false};html5CanPlay=function(k,j,l,h){if(h){return false}if(l&&l=="youtube"){return true}if(l&&l!="video"&&l!="http"&&l!="sound"){return false}if(navigator.userAgent.match(/BlackBerry/i)!==null){return false}var m=a.utils.extension(j);if(!a.utils.exists(m)||!a.utils.exists(a.utils.extensionmap[m])){return true}if(!a.utils.exists(a.utils.extensionmap[m].html5)){return false}if(a.utils.isLegacyAndroid()&&m.match(/m4v|mp4/)){return true}return browserCanPlay(k,a.utils.extensionmap[m].html5)};browserCanPlay=function(j,h){if(!h){return true}if(j.canPlayType(h)){return true}else{if(h=="audio/mp3"&&navigator.userAgent.match(/safari/i)){return j.canPlayType("audio/mpeg")}else{return false}}}}})(jwplayer);(function(a){a.embed.logo=function(m,l,d){var j={prefix:"http://l.longtailvideo.com/"+l+"/",file:"",link:"",linktarget:"_top",margin:8,out:0.5,over:1,timeout:5,hide:false,position:"bottom-left"};_css=a.utils.css;var b;var h;k();function k(){o();c();f()}function o(){if(j.prefix){var q=a.version.split(/\W/).splice(0,2).join("/");if(j.prefix.indexOf(q)<0){j.prefix+=q+"/"}}h=a.utils.extend({},j,m)}function p(){var s={border:"none",textDecoration:"none",position:"absolute",cursor:"pointer",zIndex:10};s.display=h.hide?"none":"block";var r=h.position.toLowerCase().split("-");for(var q in r){s[r[q]]=h.margin}return s}function c(){b=document.createElement("img");b.id=d+"_jwplayer_logo";b.style.display="none";b.onload=function(q){_css(b,p());e()};if(!h.file){return}if(h.file.indexOf("http://")===0){b.src=h.file}else{b.src=h.prefix+h.file}}if(!h.file){return}function f(){if(h.link){b.onmouseover=g;b.onmouseout=e;b.onclick=n}else{this.mouseEnabled=false}}function n(q){if(typeof q!="undefined"){q.preventDefault();q.stopPropagation()}if(h.link){window.open(h.link,h.linktarget)}return}function e(q){if(h.link){b.style.opacity=h.out}return}function g(q){if(h.hide){b.style.opacity=h.over}return}return b}})(jwplayer);(function(a){a.html5=function(b){var c=b;this.setup=function(d){a.utils.extend(this,new a.html5.api(c,d));return this};return this}})(jwplayer);(function(a){var c=a.utils;var b=c.css;a.html5.view=function(l,D,g){var k=l;var v=D;var h=g;var M;var f;var q;var m;var B;var L;var K;var A=false;var u=false;var x,J;var e,N,r;function H(){M=document.createElement("div");M.id=v.id;M.className=v.className;_videowrapper=document.createElement("div");_videowrapper.id=M.id+"_video_wrapper";v.id=M.id+"_video";b(M,{position:"relative",height:h.height,width:h.width,padding:0,backgroundColor:P(),zIndex:0});function P(){if(k.skin.getComponentSettings("display")&&k.skin.getComponentSettings("display").backgroundcolor){return k.skin.getComponentSettings("display").backgroundcolor}return parseInt("000000",16)}b(v,{width:"100%",height:"100%",top:0,left:0,zIndex:1,margin:"auto",display:"block"});b(_videowrapper,{overflow:"hidden",position:"absolute",top:0,left:0,bottom:0,right:0});c.wrap(v,M);c.wrap(v,_videowrapper);m=document.createElement("div");m.id=M.id+"_displayarea";M.appendChild(m);_instreamArea=document.createElement("div");_instreamArea.id=M.id+"_instreamarea";b(_instreamArea,{overflow:"hidden",position:"absolute",top:0,left:0,bottom:0,right:0,zIndex:100,background:"000000",display:"none"});M.appendChild(_instreamArea)}function G(){for(var P=0;P<h.plugins.order.length;P++){var Q=h.plugins.order[P];if(c.exists(h.plugins.object[Q].getDisplayElement)){h.plugins.object[Q].height=c.parseDimension(h.plugins.object[Q].getDisplayElement().style.height);h.plugins.object[Q].width=c.parseDimension(h.plugins.object[Q].getDisplayElement().style.width);h.plugins.config[Q].currentPosition=h.plugins.config[Q].position}}s()}function p(P){u=h.fullscreen}function n(P){if(N){return}if(h.getMedia()&&h.getMedia().hasChrome()){m.style.display="none"}else{switch(P.newstate){case P.newstate==a.api.events.state.PLAYING:m.style.display="none";break;default:m.style.display="block";break}}j()}function s(Q){var S=h.getMedia()?h.getMedia().getDisplayElement():null;if(c.exists(S)){if(K!=S){if(K&&K.parentNode){K.parentNode.replaceChild(S,K)}K=S}for(var P=0;P<h.plugins.order.length;P++){var R=h.plugins.order[P];if(c.exists(h.plugins.object[R].getDisplayElement)){h.plugins.config[R].currentPosition=h.plugins.config[R].position}}}C(h.width,h.height)}this.setup=function(){if(h&&h.getMedia()){v=h.getMedia().getDisplayElement()}H();G();k.jwAddEventListener(a.api.events.JWPLAYER_PLAYER_STATE,n);k.jwAddEventListener(a.api.events.JWPLAYER_MEDIA_LOADED,s);k.jwAddEventListener(a.api.events.JWPLAYER_MEDIA_BEFOREPLAY,p);k.jwAddEventListener(a.api.events.JWPLAYER_MEDIA_META,function(Q){j()});var P;if(c.exists(window.onresize)){P=window.onresize}window.onresize=function(Q){if(c.exists(P)){try{P(Q)}catch(S){}}if(k.jwGetFullscreen()){if(!y()){var R=c.getBoundingClientRect(document.body);h.width=Math.abs(R.left)+Math.abs(R.right);h.height=window.innerHeight;C(h.width,h.height)}}else{C(h.width,h.height)}}};function I(P){switch(P.keyCode){case 27:if(k.jwGetFullscreen()){k.jwSetFullscreen(false)}break;case 32:if(k.jwGetState()!=a.api.events.state.IDLE&&k.jwGetState()!=a.api.events.state.PAUSED){k.jwPause()}else{k.jwPlay()}break}}function C(P,Y){if(M.style.display=="none"){return}var S=[].concat(h.plugins.order);S.reverse();B=S.length+2;if(u&&y()){try{if(h.fullscreen&&!h.getMedia().getDisplayElement().webkitDisplayingFullscreen){h.fullscreen=false}}catch(V){}}if(!h.fullscreen){f=P;q=Y;if(typeof P=="string"&&P.indexOf("%")>0){f=c.getElementWidth(c.parentNode(M))*parseInt(P.replace("%"),"")/100}else{f=P}if(typeof Y=="string"&&Y.indexOf("%")>0){q=c.getElementHeight(c.parentNode(M))*parseInt(Y.replace("%"),"")/100}else{q=Y}var T={top:0,bottom:0,left:0,right:0,width:f,height:q,position:"absolute"};b(m,T);var Z={};var W;try{W=h.plugins.object.display.getDisplayElement()}catch(V){}if(W){Z.width=c.parseDimension(W.style.width);Z.height=c.parseDimension(W.style.height)}var X=c.extend({},T,Z,{zIndex:_instreamArea.style.zIndex,display:_instreamArea.style.display});b(_instreamArea,X);b(M,{height:q,width:f});var U=t(E,S);if(U.length>0){B+=U.length;var R=U.indexOf("playlist"),Q=U.indexOf("controlbar");if(R>=0&&Q>=0){U[R]=U.splice(Q,1,U[R])[0]}t(o,U,true)}x=c.getElementWidth(m);J=c.getElementHeight(m)}else{if(!y()){t(d,S,true)}}j()}function t(W,S,T){var U=[];for(var R=0;R<S.length;R++){var V=S[R];if(c.exists(h.plugins.object[V].getDisplayElement)){if(h.plugins.config[V].currentPosition!=a.html5.view.positions.NONE){var P=W(V,B--);if(!P){U.push(V)}else{var Q=P.width;var X=P.height;if(T){delete P.width;delete P.height}b(h.plugins.object[V].getDisplayElement(),P);h.plugins.object[V].resize(Q,X)}}else{b(h.plugins.object[V].getDisplayElement(),{display:"none"})}}}return U}function E(Q,R){if(c.exists(h.plugins.object[Q].getDisplayElement)){if(h.plugins.config[Q].position&&O(h.plugins.config[Q].position)){if(!c.exists(h.plugins.object[Q].getDisplayElement().parentNode)){M.appendChild(h.plugins.object[Q].getDisplayElement())}var P=w(Q);P.zIndex=R;return P}}return false}function o(P,Q){if(!c.exists(h.plugins.object[P].getDisplayElement().parentNode)){m.appendChild(h.plugins.object[P].getDisplayElement())}return{position:"absolute",width:(c.getElementWidth(m)-c.parseDimension(m.style.right)),height:(c.getElementHeight(m)-c.parseDimension(m.style.bottom)),zIndex:Q}}function d(P,Q){return{position:"fixed",width:h.width,height:h.height,zIndex:Q}}var j=this.resizeMedia=function(){m.style.position="absolute";var R=h.getMedia()?h.getMedia().getDisplayElement():r;if(!R){return}if(R&&R.tagName.toLowerCase()=="video"){if(!R.videoWidth||!R.videoHeight){R.style.width=m.style.width;R.style.height=m.style.height;return}R.style.position="absolute";c.fadeTo(R,1,0.25);if(R.parentNode){R.parentNode.style.left=m.style.left;R.parentNode.style.top=m.style.top}if(h.fullscreen&&k.jwGetStretching()==a.utils.stretching.EXACTFIT&&!c.isMobile()){var P=document.createElement("div");c.stretch(a.utils.stretching.UNIFORM,P,c.getElementWidth(m),c.getElementHeight(m),x,J);c.stretch(a.utils.stretching.EXACTFIT,R,c.parseDimension(P.style.width),c.parseDimension(P.style.height),R.videoWidth?R.videoWidth:400,R.videoHeight?R.videoHeight:300);b(R,{left:P.style.left,top:P.style.top})}else{c.stretch(k.jwGetStretching(),R,c.getElementWidth(m),c.getElementHeight(m),R.videoWidth?R.videoWidth:400,R.videoHeight?R.videoHeight:300)}}else{var Q=h.plugins.object.display.getDisplayElement();if(Q){h.getMedia().resize(c.parseDimension(Q.style.width),c.parseDimension(Q.style.height))}else{h.getMedia().resize(c.parseDimension(m.style.width),c.parseDimension(m.style.height))}}};var w=this.getComponentPosition=function(Q){var R={position:"absolute",margin:0,padding:0,top:null};var P=h.plugins.config[Q].currentPosition.toLowerCase();switch(P.toUpperCase()){case a.html5.view.positions.TOP:R.top=c.parseDimension(m.style.top);R.left=c.parseDimension(m.style.left);R.width=c.getElementWidth(m)-c.parseDimension(m.style.left)-c.parseDimension(m.style.right);R.height=h.plugins.object[Q].height;m.style[P]=c.parseDimension(m.style[P])+h.plugins.object[Q].height+"px";m.style.height=c.getElementHeight(m)-R.height+"px";break;case a.html5.view.positions.RIGHT:R.top=c.parseDimension(m.style.top);R.right=c.parseDimension(m.style.right);R.width=h.plugins.object[Q].width;R.height=c.getElementHeight(m)-c.parseDimension(m.style.top)-c.parseDimension(m.style.bottom);m.style.width=c.getElementWidth(m)-R.width+"px";break;case a.html5.view.positions.BOTTOM:R.bottom=c.parseDimension(m.style.bottom);R.left=c.parseDimension(m.style.left);R.width=c.getElementWidth(m)-c.parseDimension(m.style.left)-c.parseDimension(m.style.right);R.height=h.plugins.object[Q].height;m.style.height=c.getElementHeight(m)-R.height+"px";break;case a.html5.view.positions.LEFT:R.top=c.parseDimension(m.style.top);R.left=c.parseDimension(m.style.left);R.width=h.plugins.object[Q].width;R.height=c.getElementHeight(m)-c.parseDimension(m.style.top)-c.parseDimension(m.style.bottom);m.style[P]=c.parseDimension(m.style[P])+h.plugins.object[Q].width+"px";m.style.width=c.getElementWidth(m)-R.width+"px";break;default:break}return R};this.resize=C;var F;this.fullscreen=function(S){var U;try{U=h.getMedia().getDisplayElement()}catch(T){}if(y()&&U&&U.webkitSupportsFullscreen){if(S&&!U.webkitDisplayingFullscreen){try{c.transform(U);F=m.style.display;m.style.display="none";U.webkitEnterFullscreen()}catch(R){}}else{if(!S){j();if(U.webkitDisplayingFullscreen){try{U.webkitExitFullscreen()}catch(R){}}m.style.display=F}}A=false}else{if(S){document.onkeydown=I;clearInterval(L);var Q=c.getBoundingClientRect(document.body);h.width=Math.abs(Q.left)+Math.abs(Q.right);h.height=window.innerHeight;var P={position:"fixed",width:"100%",height:"100%",top:0,left:0,zIndex:2147483000};b(M,P);P.zIndex=1;if(h.getMedia()&&h.getMedia().getDisplayElement()){b(h.getMedia().getDisplayElement(),P)}P.zIndex=2;b(m,P);A=true}else{document.onkeydown="";h.width=f;h.height=q;b(M,{position:"relative",height:h.height,width:h.width,zIndex:0});A=false}C(h.width,h.height)}};function O(P){return([a.html5.view.positions.TOP,a.html5.view.positions.RIGHT,a.html5.view.positions.BOTTOM,a.html5.view.positions.LEFT].toString().indexOf(P.toUpperCase())>-1)}function y(){if(k.jwGetState()!=a.api.events.state.IDLE&&!A&&(h.getMedia()&&h.getMedia().getDisplayElement()&&h.getMedia().getDisplayElement().webkitSupportsFullscreen)&&c.useNativeFullscreen()){return true}return false}this.setupInstream=function(P,Q){c.css(_instreamArea,{display:"block",position:"absolute"});m.style.display="none";_instreamArea.appendChild(P);r=Q;N=true};var z=this.destroyInstream=function(){_instreamArea.style.display="none";_instreamArea.innerHTML="";m.style.display="block";r=null;N=false;C(h.width,h.height)}};a.html5.view.positions={TOP:"TOP",RIGHT:"RIGHT",BOTTOM:"BOTTOM",LEFT:"LEFT",OVER:"OVER",NONE:"NONE"}})(jwplayer);(function(a){var b={backgroundcolor:"",margin:10,font:"Arial,sans-serif",fontsize:10,fontcolor:parseInt("000000",16),fontstyle:"normal",fontweight:"bold",buttoncolor:parseInt("ffffff",16),position:a.html5.view.positions.BOTTOM,idlehide:false,hideplaylistcontrols:false,forcenextprev:false,layout:{left:{position:"left",elements:[{name:"play",type:"button"},{name:"divider",type:"divider"},{name:"prev",type:"button"},{name:"divider",type:"divider"},{name:"next",type:"button"},{name:"divider",type:"divider"},{name:"elapsed",type:"text"}]},center:{position:"center",elements:[{name:"time",type:"slider"}]},right:{position:"right",elements:[{name:"duration",type:"text"},{name:"blank",type:"button"},{name:"divider",type:"divider"},{name:"mute",type:"button"},{name:"volume",type:"slider"},{name:"divider",type:"divider"},{name:"fullscreen",type:"button"}]}}};_utils=a.utils;_css=_utils.css;_hide=function(c){_css(c,{display:"none"})};_show=function(c){_css(c,{display:"block"})};a.html5.controlbar=function(m,X){window.controlbar=this;var l=m;var D=_utils.extend({},b,l.skin.getComponentSettings("controlbar"),X);if(D.position==a.html5.view.positions.NONE||typeof a.html5.view.positions[D.position]=="undefined"){return}if(_utils.mapLength(l.skin.getComponentLayout("controlbar"))>0){D.layout=l.skin.getComponentLayout("controlbar")}var af;var Q;var ae;var E;var w="none";var h;var k;var ag;var g;var f;var z;var R={};var q=false;var c={};var ab;var j=false;var p;var d;var U=false;var G=false;var H;var Z=new a.html5.eventdispatcher();_utils.extend(this,Z);function K(){if(!ab){ab=l.skin.getSkinElement("controlbar","background");if(!ab){ab={width:0,height:0,src:null}}}return ab}function O(){ae=0;E=0;Q=0;if(!q){var ao={height:K().height,backgroundColor:D.backgroundcolor};af=document.createElement("div");af.id=l.id+"_jwplayer_controlbar";_css(af,ao)}var an=(l.skin.getSkinElement("controlbar","capLeft"));var am=(l.skin.getSkinElement("controlbar","capRight"));if(an){y("capLeft","left",false,af)}ac("background",af,{position:"absolute",height:K().height,left:(an?an.width:0),zIndex:0},"img");if(K().src){R.background.src=K().src}ac("elements",af,{position:"relative",height:K().height,zIndex:1});if(am){y("capRight","right",false,af)}}this.getDisplayElement=function(){return af};this.resize=function(ao,am){S();_utils.cancelAnimation(af);f=ao;z=am;if(G!=l.jwGetFullscreen()){G=l.jwGetFullscreen();if(!G){Y()}d=undefined}var an=x();J({id:l.id,duration:ag,position:k});v({id:l.id,bufferPercent:g});return an};this.show=function(){if(j){j=false;_show(af);V()}};this.hide=function(){if(!j){j=true;_hide(af);ad()}};function r(){var an=["timeSlider","volumeSlider","timeSliderRail","volumeSliderRail"];for(var ao in an){var am=an[ao];if(typeof R[am]!="undefined"){c[am]=_utils.getBoundingClientRect(R[am])}}}var e;function Y(am){if(j){return}clearTimeout(p);if(D.position==a.html5.view.positions.OVER||l.jwGetFullscreen()){switch(l.jwGetState()){case a.api.events.state.PAUSED:case a.api.events.state.IDLE:if(af&&af.style.opacity<1&&(!D.idlehide||_utils.exists(am))){e=false;setTimeout(function(){if(!e){W()}},100)}if(D.idlehide){p=setTimeout(function(){A()},2000)}break;default:e=true;if(am){W()}p=setTimeout(function(){A()},2000);break}}else{W()}}function A(){if(!j){ad();if(af.style.opacity==1){_utils.cancelAnimation(af);_utils.fadeTo(af,0,0.1,1,0)}}}function W(){if(!j){V();if(af.style.opacity==0){_utils.cancelAnimation(af);_utils.fadeTo(af,1,0.1,0,0)}}}function I(am){return function(){if(U&&d!=am){d=am;Z.sendEvent(am,{component:"controlbar",boundingRect:P()})}}}var V=I(a.api.events.JWPLAYER_COMPONENT_SHOW);var ad=I(a.api.events.JWPLAYER_COMPONENT_HIDE);function P(){if(D.position==a.html5.view.positions.OVER||l.jwGetFullscreen()){return _utils.getDimensions(af)}else{return{x:0,y:0,width:0,height:0}}}function ac(aq,ap,ao,am){var an;if(!q){if(!am){am="div"}an=document.createElement(am);R[aq]=an;an.id=af.id+"_"+aq;ap.appendChild(an)}else{an=document.getElementById(af.id+"_"+aq)}if(_utils.exists(ao)){_css(an,ao)}return an}function N(){if(l.jwGetHeight()<=40){D.layout=_utils.clone(D.layout);for(var am=0;am<D.layout.left.elements.length;am++){if(D.layout.left.elements[am].name=="fullscreen"){D.layout.left.elements.splice(am,1)}}for(am=0;am<D.layout.right.elements.length;am++){if(D.layout.right.elements[am].name=="fullscreen"){D.layout.right.elements.splice(am,1)}}o()}al(D.layout.left);al(D.layout.center);al(D.layout.right)}function al(ap,am){var aq=ap.position=="right"?"right":"left";var ao=_utils.extend([],ap.elements);if(_utils.exists(am)){ao.reverse()}var ap=ac(ap.position+"Group",R.elements,{"float":"left",styleFloat:"left",cssFloat:"left",height:"100%"});for(var an=0;an<ao.length;an++){C(ao[an],aq,ap)}}function L(){return Q++}function C(aq,at,av){var ap,an,ao,am,aw;if(!av){av=R.elements}if(aq.type=="divider"){y("divider"+L(),at,true,av,undefined,aq.width,aq.element);return}switch(aq.name){case"play":y("playButton",at,false,av);y("pauseButton",at,true,av);T("playButton","jwPlay");T("pauseButton","jwPause");break;case"prev":y("prevButton",at,true,av);T("prevButton","jwPlaylistPrev");break;case"stop":y("stopButton",at,true,av);T("stopButton","jwStop");break;case"next":y("nextButton",at,true,av);T("nextButton","jwPlaylistNext");break;case"elapsed":y("elapsedText",at,true,av,null,null,l.skin.getSkinElement("controlbar","elapsedBackground"));break;case"time":an=!_utils.exists(l.skin.getSkinElement("controlbar","timeSliderCapLeft"))?0:l.skin.getSkinElement("controlbar","timeSliderCapLeft").width;ao=!_utils.exists(l.skin.getSkinElement("controlbar","timeSliderCapRight"))?0:l.skin.getSkinElement("controlbar","timeSliderCapRight").width;ap=at=="left"?an:ao;aw={height:K().height,position:"relative","float":"left",styleFloat:"left",cssFloat:"left"};var ar=ac("timeSlider",av,aw);y("timeSliderCapLeft",at,true,ar,"relative");y("timeSliderRail",at,false,ar,"relative");y("timeSliderBuffer",at,false,ar,"absolute");y("timeSliderProgress",at,false,ar,"absolute");y("timeSliderThumb",at,false,ar,"absolute");y("timeSliderCapRight",at,true,ar,"relative");aa("time");break;case"fullscreen":y("fullscreenButton",at,false,av);y("normalscreenButton",at,true,av);T("fullscreenButton","jwSetFullscreen",true);T("normalscreenButton","jwSetFullscreen",false);break;case"volume":an=!_utils.exists(l.skin.getSkinElement("controlbar","volumeSliderCapLeft"))?0:l.skin.getSkinElement("controlbar","volumeSliderCapLeft").width;ao=!_utils.exists(l.skin.getSkinElement("controlbar","volumeSliderCapRight"))?0:l.skin.getSkinElement("controlbar","volumeSliderCapRight").width;ap=at=="left"?an:ao;am=l.skin.getSkinElement("controlbar","volumeSliderRail").width+an+ao;aw={height:K().height,position:"relative",width:am,"float":"left",styleFloat:"left",cssFloat:"left"};var au=ac("volumeSlider",av,aw);y("volumeSliderCapLeft",at,false,au,"relative");y("volumeSliderRail",at,false,au,"relative");y("volumeSliderProgress",at,false,au,"absolute");y("volumeSliderThumb",at,false,au,"absolute");y("volumeSliderCapRight",at,false,au,"relative");aa("volume");break;case"mute":y("muteButton",at,false,av);y("unmuteButton",at,true,av);T("muteButton","jwSetMute",true);T("unmuteButton","jwSetMute",false);break;case"duration":y("durationText",at,true,av,null,null,l.skin.getSkinElement("controlbar","durationBackground"));break}}function y(ap,at,an,aw,aq,am,ao){if(_utils.exists(l.skin.getSkinElement("controlbar",ap))||ap.indexOf("Text")>0||ap.indexOf("divider")===0){var ar={height:"100%",position:aq?aq:"relative",display:"block","float":"left",styleFloat:"left",cssFloat:"left"};if((ap.indexOf("next")===0||ap.indexOf("prev")===0)&&(l.jwGetPlaylist().length<2||D.hideplaylistcontrols.toString()=="true")){if(D.forcenextprev.toString()!="true"){an=false;ar.display="none"}}var ax;if(ap.indexOf("Text")>0){ap.innerhtml="00:00";ar.font=D.fontsize+"px/"+(K().height+1)+"px "+D.font;ar.color=D.fontcolor;ar.textAlign="center";ar.fontWeight=D.fontweight;ar.fontStyle=D.fontstyle;ar.cursor="default";if(ao){ar.background="url("+ao.src+") no-repeat center";ar.backgroundSize="100% "+K().height+"px"}ar.padding="0 5px"}else{if(ap.indexOf("divider")===0){if(am){if(!isNaN(parseInt(am))){ax=parseInt(am)}}else{if(ao){var au=l.skin.getSkinElement("controlbar",ao);if(au){ar.background="url("+au.src+") repeat-x center left";ax=au.width}}else{ar.background="url("+l.skin.getSkinElement("controlbar","divider").src+") repeat-x center left";ax=l.skin.getSkinElement("controlbar","divider").width}}}else{ar.background="url("+l.skin.getSkinElement("controlbar",ap).src+") repeat-x center left";ax=l.skin.getSkinElement("controlbar",ap).width}}if(at=="left"){if(an){ae+=ax}}else{if(at=="right"){if(an){E+=ax}}}if(_utils.typeOf(aw)=="undefined"){aw=R.elements}ar.width=ax;if(q){_css(R[ap],ar)}else{var av=ac(ap,aw,ar);if(_utils.exists(l.skin.getSkinElement("controlbar",ap+"Over"))){av.onmouseover=function(ay){av.style.backgroundImage=["url(",l.skin.getSkinElement("controlbar",ap+"Over").src,")"].join("")};av.onmouseout=function(ay){av.style.backgroundImage=["url(",l.skin.getSkinElement("controlbar",ap).src,")"].join("")}}if(ap.indexOf("divider")==0){av.setAttribute("class","divider")}av.innerHTML="&nbsp;"}}}function F(){l.jwAddEventListener(a.api.events.JWPLAYER_PLAYLIST_LOADED,B);l.jwAddEventListener(a.api.events.JWPLAYER_PLAYLIST_ITEM,t);l.jwAddEventListener(a.api.events.JWPLAYER_MEDIA_BUFFER,v);l.jwAddEventListener(a.api.events.JWPLAYER_PLAYER_STATE,s);l.jwAddEventListener(a.api.events.JWPLAYER_MEDIA_TIME,J);l.jwAddEventListener(a.api.events.JWPLAYER_MEDIA_MUTE,ak);l.jwAddEventListener(a.api.events.JWPLAYER_MEDIA_VOLUME,n);l.jwAddEventListener(a.api.events.JWPLAYER_MEDIA_COMPLETE,M)}function B(){if(!D.hideplaylistcontrols){if(l.jwGetPlaylist().length>1||D.forcenextprev.toString()=="true"){_show(R.nextButton);_show(R.prevButton)}else{_hide(R.nextButton);_hide(R.prevButton)}x();ah()}}function t(am){ag=l.jwGetPlaylist()[am.index].duration;J({id:l.id,duration:ag,position:0});v({id:l.id,bufferProgress:0})}function ah(){J({id:l.id,duration:l.jwGetDuration(),position:0});v({id:l.id,bufferProgress:0});ak({id:l.id,mute:l.jwGetMute()});s({id:l.id,newstate:a.api.events.state.IDLE});n({id:l.id,volume:l.jwGetVolume()})}function T(ao,ap,an){if(q){return}if(_utils.exists(l.skin.getSkinElement("controlbar",ao))){var am=R[ao];if(_utils.exists(am)){_css(am,{cursor:"pointer"});if(ap=="fullscreen"){am.onmouseup=function(aq){aq.stopPropagation();l.jwSetFullscreen(!l.jwGetFullscreen())}}else{am.onmouseup=function(aq){aq.stopPropagation();if(_utils.exists(an)){l[ap](an)}else{l[ap]()}}}}}}function aa(am){if(q){return}var an=R[am+"Slider"];_css(R.elements,{cursor:"pointer"});_css(an,{cursor:"pointer"});an.onmousedown=function(ao){w=am};an.onmouseup=function(ao){ao.stopPropagation();aj(ao.pageX)};an.onmousemove=function(ao){if(w=="time"){h=true;var ap=ao.pageX-c[am+"Slider"].left-window.pageXOffset;_css(R[w+"SliderThumb"],{left:ap})}}}function aj(an){h=false;var am;if(w=="time"){am=an-c.timeSliderRail.left+window.pageXOffset;var ap=am/c.timeSliderRail.width*ag;if(ap<0){ap=0}else{if(ap>ag){ap=ag-3}}if(l.jwGetState()==a.api.events.state.PAUSED||l.jwGetState()==a.api.events.state.IDLE){l.jwPlay()}l.jwSeek(ap)}else{if(w=="volume"){am=an-c.volumeSliderRail.left-window.pageXOffset;var ao=Math.round(am/c.volumeSliderRail.width*100);if(ao<10){ao=0}else{if(ao>100){ao=100}}if(l.jwGetMute()){l.jwSetMute(false)}l.jwSetVolume(ao)}}w="none"}function v(an){if(_utils.exists(an.bufferPercent)){g=an.bufferPercent}if(c.timeSliderRail){var ap=l.skin.getSkinElement("controlbar","timeSliderCapLeft");var ao=c.timeSliderRail.width;var am=isNaN(Math.round(ao*g/100))?0:Math.round(ao*g/100);_css(R.timeSliderBuffer,{width:am,left:ap?ap.width:0})}}function ak(am){if(am.mute){_hide(R.muteButton);_show(R.unmuteButton);_hide(R.volumeSliderProgress)}else{_show(R.muteButton);_hide(R.unmuteButton);_show(R.volumeSliderProgress)}}function s(am){if(am.newstate==a.api.events.state.BUFFERING||am.newstate==a.api.events.state.PLAYING){_show(R.pauseButton);_hide(R.playButton)}else{_hide(R.pauseButton);_show(R.playButton)}Y();if(am.newstate==a.api.events.state.IDLE){_hide(R.timeSliderBuffer);_hide(R.timeSliderProgress);_hide(R.timeSliderThumb);J({id:l.id,duration:l.jwGetDuration(),position:0})}else{_show(R.timeSliderBuffer);if(am.newstate!=a.api.events.state.BUFFERING){_show(R.timeSliderProgress);_show(R.timeSliderThumb)}}}function M(am){v({bufferPercent:0});J(_utils.extend(am,{position:0,duration:ag}))}function J(aq){if(_utils.exists(aq.position)){k=aq.position}var am=false;if(_utils.exists(aq.duration)&&aq.duration!=ag){ag=aq.duration;am=true}var ao=(k===ag===0)?0:k/ag;var at=c.timeSliderRail;if(at){var an=isNaN(Math.round(at.width*ao))?0:Math.round(at.width*ao);var ar=l.skin.getSkinElement("controlbar","timeSliderCapLeft");var ap=an+(ar?ar.width:0);if(R.timeSliderProgress){_css(R.timeSliderProgress,{width:an,left:ar?ar.width:0});if(!h){if(R.timeSliderThumb){R.timeSliderThumb.style.left=ap+"px"}}}}if(R.durationText){R.durationText.innerHTML=_utils.timeFormat(ag)}if(R.elapsedText){R.elapsedText.innerHTML=_utils.timeFormat(k)}if(am){x()}}function o(){var am=R.elements.childNodes;var ar,ap;for(var ao=0;ao<am.length;ao++){var aq=am[ao].childNodes;for(var an in aq){if(isNaN(parseInt(an,10))){continue}if(aq[an].id.indexOf(af.id+"_divider")===0&&ap&&ap.id.indexOf(af.id+"_divider")===0&&aq[an].style.backgroundImage==ap.style.backgroundImage){aq[an].style.display="none"}else{if(aq[an].id.indexOf(af.id+"_divider")===0&&ar&&ar.style.display!="none"){aq[an].style.display="block"}}if(aq[an].style.display!="none"){ap=aq[an]}ar=aq[an]}}}function ai(){if(l.jwGetFullscreen()){_show(R.normalscreenButton);_hide(R.fullscreenButton)}else{_hide(R.normalscreenButton);_show(R.fullscreenButton)}if(l.jwGetState()==a.api.events.state.BUFFERING||l.jwGetState()==a.api.events.state.PLAYING){_show(R.pauseButton);_hide(R.playButton)}else{_hide(R.pauseButton);_show(R.playButton)}if(l.jwGetMute()==true){_hide(R.muteButton);_show(R.unmuteButton);_hide(R.volumeSliderProgress)}else{_show(R.muteButton);_hide(R.unmuteButton);_show(R.volumeSliderProgress)}}function x(){o();ai();var ao={width:f};var aw={"float":"left",styleFloat:"left",cssFloat:"left"};if(D.position==a.html5.view.positions.OVER||l.jwGetFullscreen()){ao.left=D.margin;ao.width-=2*D.margin;ao.top=z-K().height-D.margin;ao.height=K().height}var aq=l.skin.getSkinElement("controlbar","capLeft");var au=l.skin.getSkinElement("controlbar","capRight");aw.width=ao.width-(aq?aq.width:0)-(au?au.width:0);var ap=_utils.getBoundingClientRect(R.leftGroup).width;var at=_utils.getBoundingClientRect(R.rightGroup).width;var ar=aw.width-ap-at-1;var an=ar;var am=l.skin.getSkinElement("controlbar","timeSliderCapLeft");var av=l.skin.getSkinElement("controlbar","timeSliderCapRight");if(_utils.exists(am)){an-=am.width}if(_utils.exists(av)){an-=av.width}R.timeSlider.style.width=ar+"px";R.timeSliderRail.style.width=an+"px";_css(af,ao);_css(R.elements,aw);_css(R.background,aw);r();return ao}function n(ar){if(_utils.exists(R.volumeSliderRail)){var ao=isNaN(ar.volume/100)?1:ar.volume/100;var ap=_utils.parseDimension(R.volumeSliderRail.style.width);var am=isNaN(Math.round(ap*ao))?0:Math.round(ap*ao);var at=_utils.parseDimension(R.volumeSliderRail.style.right);var an=(!_utils.exists(l.skin.getSkinElement("controlbar","volumeSliderCapLeft")))?0:l.skin.getSkinElement("controlbar","volumeSliderCapLeft").width;_css(R.volumeSliderProgress,{width:am,left:an});if(R.volumeSliderThumb){var aq=(am-Math.round(_utils.parseDimension(R.volumeSliderThumb.style.width)/2));aq=Math.min(Math.max(aq,0),ap-_utils.parseDimension(R.volumeSliderThumb.style.width));_css(R.volumeSliderThumb,{left:aq})}if(_utils.exists(R.volumeSliderCapLeft)){_css(R.volumeSliderCapLeft,{left:0})}}}function S(){try{var an=(l.id.indexOf("_instream")>0?l.id.replace("_instream",""):l.id);H=document.getElementById(an);H.addEventListener("mousemove",Y)}catch(am){_utils.log("Could not add mouse listeners to controlbar: "+am)}}function u(){O();N();r();q=true;F();D.idlehide=(D.idlehide.toString().toLowerCase()=="true");if(D.position==a.html5.view.positions.OVER&&D.idlehide){af.style.opacity=0;U=true}else{af.style.opacity=1;setTimeout((function(){U=true;V()}),1)}S();ah()}u();return this}})(jwplayer);(function(b){var a=["width","height","state","playlist","item","position","buffer","duration","volume","mute","fullscreen"];var c=b.utils;b.html5.controller=function(o,K,f,h){var n=o,m=f,j=h,y=K,M=true,G=-1,A=false,d=false,P,C=[],q=false;var D=(c.exists(m.config.debug)&&(m.config.debug.toString().toLowerCase()=="console")),N=new b.html5.eventdispatcher(y.id,D);c.extend(this,N);function L(T){if(q){N.sendEvent(T.type,T)}else{C.push(T)}}function s(T){if(!q){q=true;N.sendEvent(b.api.events.JWPLAYER_READY,T);if(b.utils.exists(window.playerReady)){playerReady(T)}if(b.utils.exists(window[f.config.playerReady])){window[f.config.playerReady](T)}while(C.length>0){var V=C.shift();N.sendEvent(V.type,V)}if(f.config.autostart&&!b.utils.isIOS()){O()}while(x.length>0){var U=x.shift();B(U.method,U.arguments)}}}m.addGlobalListener(L);m.addEventListener(b.api.events.JWPLAYER_MEDIA_BUFFER_FULL,function(){m.getMedia().play()});m.addEventListener(b.api.events.JWPLAYER_MEDIA_TIME,function(T){if(T.position>=m.playlist[m.item].start&&G>=0){m.playlist[m.item].start=G;G=-1}});m.addEventListener(b.api.events.JWPLAYER_MEDIA_COMPLETE,function(T){setTimeout(E,25)});m.addEventListener(b.api.events.JWPLAYER_PLAYLIST_LOADED,O);m.addEventListener(b.api.events.JWPLAYER_FULLSCREEN,p);function F(){try{P=F;if(!A){A=true;N.sendEvent(b.api.events.JWPLAYER_MEDIA_BEFOREPLAY);A=false;if(d){d=false;P=null;return}}v(m.item);if(m.playlist[m.item].levels[0].file.length>0){if(M||m.state==b.api.events.state.IDLE){m.getMedia().load(m.playlist[m.item]);M=false}else{if(m.state==b.api.events.state.PAUSED){m.getMedia().play()}}}return true}catch(T){N.sendEvent(b.api.events.JWPLAYER_ERROR,T);P=null}return false}function e(){try{if(m.playlist[m.item].levels[0].file.length>0){switch(m.state){case b.api.events.state.PLAYING:case b.api.events.state.BUFFERING:if(m.getMedia()){m.getMedia().pause()}break;default:if(A){d=true}}}return true}catch(T){N.sendEvent(b.api.events.JWPLAYER_ERROR,T)}return false}function z(T){try{if(m.playlist[m.item].levels[0].file.length>0){if(typeof T!="number"){T=parseFloat(T)}switch(m.state){case b.api.events.state.IDLE:if(G<0){G=m.playlist[m.item].start;m.playlist[m.item].start=T}if(!A){F()}break;case b.api.events.state.PLAYING:case b.api.events.state.PAUSED:case b.api.events.state.BUFFERING:m.seek(T);break}}return true}catch(U){N.sendEvent(b.api.events.JWPLAYER_ERROR,U)}return false}function w(T){P=null;if(!c.exists(T)){T=true}try{if((m.state!=b.api.events.state.IDLE||T)&&m.getMedia()){m.getMedia().stop(T)}if(A){d=true}return true}catch(U){N.sendEvent(b.api.events.JWPLAYER_ERROR,U)}return false}function k(){try{if(m.playlist[m.item].levels[0].file.length>0){if(m.config.shuffle){v(S())}else{if(m.item+1==m.playlist.length){v(0)}else{v(m.item+1)}}}if(m.state!=b.api.events.state.IDLE){var U=m.state;m.state=b.api.events.state.IDLE;N.sendEvent(b.api.events.JWPLAYER_PLAYER_STATE,{oldstate:U,newstate:b.api.events.state.IDLE})}F();return true}catch(T){N.sendEvent(b.api.events.JWPLAYER_ERROR,T)}return false}function I(){try{if(m.playlist[m.item].levels[0].file.length>0){if(m.config.shuffle){v(S())}else{if(m.item===0){v(m.playlist.length-1)}else{v(m.item-1)}}}if(m.state!=b.api.events.state.IDLE){var U=m.state;m.state=b.api.events.state.IDLE;N.sendEvent(b.api.events.JWPLAYER_PLAYER_STATE,{oldstate:U,newstate:b.api.events.state.IDLE})}F();return true}catch(T){N.sendEvent(b.api.events.JWPLAYER_ERROR,T)}return false}function S(){var T=null;if(m.playlist.length>1){while(!c.exists(T)){T=Math.floor(Math.random()*m.playlist.length);if(T==m.item){T=null}}}else{T=0}return T}function H(U){if(!m.playlist||!m.playlist[U]){return false}try{if(m.playlist[U].levels[0].file.length>0){var V=m.state;if(V!==b.api.events.state.IDLE){if(m.playlist[m.item]&&m.playlist[m.item].provider==m.playlist[U].provider){w(false)}else{w()}}v(U);F()}return true}catch(T){N.sendEvent(b.api.events.JWPLAYER_ERROR,T)}return false}function v(T){if(!m.playlist[T]){return}m.setActiveMediaProvider(m.playlist[T]);if(m.item!=T){m.item=T;M=true;N.sendEvent(b.api.events.JWPLAYER_PLAYLIST_ITEM,{index:T})}}function g(U){try{v(m.item);var V=m.getMedia();switch(typeof(U)){case"number":V.volume(U);break;case"string":V.volume(parseInt(U,10));break}m.setVolume(U);return true}catch(T){N.sendEvent(b.api.events.JWPLAYER_ERROR,T)}return false}function r(U){try{v(m.item);var V=m.getMedia();if(typeof U=="undefined"){V.mute(!m.mute);m.setMute(!m.mute)}else{if(U.toString().toLowerCase()=="true"){V.mute(true);m.setMute(true)}else{V.mute(false);m.setMute(false)}}return true}catch(T){N.sendEvent(b.api.events.JWPLAYER_ERROR,T)}return false}function J(U,T){try{m.width=U;m.height=T;j.resize(U,T);N.sendEvent(b.api.events.JWPLAYER_RESIZE,{width:m.width,height:m.height});return true}catch(V){N.sendEvent(b.api.events.JWPLAYER_ERROR,V)}return false}function u(U,V){try{if(typeof U=="undefined"){U=!m.fullscreen}if(typeof V=="undefined"){V=true}if(U!=m.fullscreen){m.fullscreen=(U.toString().toLowerCase()=="true");j.fullscreen(m.fullscreen);if(V){N.sendEvent(b.api.events.JWPLAYER_FULLSCREEN,{fullscreen:m.fullscreen})}N.sendEvent(b.api.events.JWPLAYER_RESIZE,{width:m.width,height:m.height})}return true}catch(T){N.sendEvent(b.api.events.JWPLAYER_ERROR,T)}return false}function R(T){try{w();if(A){d=false}m.loadPlaylist(T);if(m.playlist[m.item].provider){v(m.item);if(m.config.autostart.toString().toLowerCase()=="true"&&!c.isIOS()&&!A){F()}return true}else{return false}}catch(U){N.sendEvent(b.api.events.JWPLAYER_ERROR,U)}return false}function O(T){if(!c.isIOS()){v(m.item);if(m.config.autostart.toString().toLowerCase()=="true"&&!c.isIOS()){F()}}}function p(T){u(T.fullscreen,false)}function t(){try{return m.getMedia().detachMedia()}catch(T){return null}}function l(){try{var T=m.getMedia().attachMedia();if(typeof P=="function"){P()}}catch(U){return null}}b.html5.controller.repeatoptions={LIST:"LIST",ALWAYS:"ALWAYS",SINGLE:"SINGLE",NONE:"NONE"};function E(){if(m.state!=b.api.events.state.IDLE){return}P=E;switch(m.config.repeat.toUpperCase()){case b.html5.controller.repeatoptions.SINGLE:F();break;case b.html5.controller.repeatoptions.ALWAYS:if(m.item==m.playlist.length-1&&!m.config.shuffle){H(0)}else{k()}break;case b.html5.controller.repeatoptions.LIST:if(m.item==m.playlist.length-1&&!m.config.shuffle){w();v(0)}else{k()}break;default:w();break}}var x=[];function Q(T){return function(){if(q){B(T,arguments)}else{x.push({method:T,arguments:arguments})}}}function B(V,U){var T=[];for(i=0;i<U.length;i++){T.push(U[i])}V.apply(this,T)}this.play=Q(F);this.pause=Q(e);this.seek=Q(z);this.stop=Q(w);this.next=Q(k);this.prev=Q(I);this.item=Q(H);this.setVolume=Q(g);this.setMute=Q(r);this.resize=Q(J);this.setFullscreen=Q(u);this.load=Q(R);this.playerReady=s;this.detachMedia=t;this.attachMedia=l;this.beforePlay=function(){return A}}})(jwplayer);(function(a){a.html5.defaultSkin=function(){this.text='<?xml version="1.0" ?><skin author="LongTail Video" name="Five" version="1.1"><components><component name="controlbar"><settings><setting name="margin" value="20"/><setting name="fontsize" value="11"/><setting name="fontcolor" value="0x000000"/></settings><layout><group position="left"><button name="play"/><divider name="divider"/><button name="prev"/><divider name="divider"/><button name="next"/><divider name="divider"/><text name="elapsed"/></group><group position="center"><slider name="time"/></group><group position="right"><text name="duration"/><divider name="divider"/><button name="blank"/><divider name="divider"/><button name="mute"/><slider name="volume"/><divider name="divider"/><button name="fullscreen"/></group></layout><elements><element name="background" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAIAAABvFaqvAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAElJREFUOI3t1LERACAMQlFgGvcfxNIhHMK4gsUvUviOmgtNsiAZkBSEKxKEnCYkkQrJn/YwbUNiSDDYRZaQRDaShv+oX9GBZEIuK+8hXVLs+/YAAAAASUVORK5CYII="/><element name="blankButton" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAYCAYAAAAyJzegAAAAFElEQVQYV2P8//8/AzpgHBUc7oIAGZdH0RjKN8EAAAAASUVORK5CYII="/><element name="capLeft" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAAYCAYAAAA7zJfaAAAAQElEQVQIWz3LsRGAMADDQJ0XB5bMINABZ9GENGrszxhjT2WLSqxEJG2JQrTMdV2q5LpOAvyRaVmsi7WdeZ/7+AAaOTq7BVrfOQAAAABJRU5ErkJggg=="/><element name="capRight" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAAYCAYAAAA7zJfaAAAAQElEQVQIWz3LsRGAMADDQJ0XB5bMINABZ9GENGrszxhjT2WLSqxEJG2JQrTMdV2q5LpOAvyRaVmsi7WdeZ/7+AAaOTq7BVrfOQAAAABJRU5ErkJggg=="/><element name="divider" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAAYCAIAAAC0rgCNAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAADhJREFUCB0FwcENgEAAw7Aq+893g8APUILNOQcbFRktVGqUVFRkWNz3xTa2sUaLNUosKlRUvvf5AdbWOTtzmzyWAAAAAElFTkSuQmCC"/><element name="playButton" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAYCAYAAAAVibZIAAAANUlEQVR42u2RsQkAAAjD/NTTPaW6dXLrINJA1kBpGPMAjDWmOgp1HFQXx+b1KOefO4oxY57R73YnVYCQUCQAAAAASUVORK5CYII="/><element name="pauseButton" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAYCAYAAAAVibZIAAAAIUlEQVQ4jWNgGAWjYOiD/0gYG3/U0FFDB4Oho2AUDAYAAEwiL9HrpdMVAAAAAElFTkSuQmCC"/><element name="prevButton" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAYCAYAAAAVibZIAAAAQklEQVQ4y2NgGAWjYOiD/1AMA/JAfB5NjCJD/YH4PRaLyDa0H4lNNUP/DxlD59PCUBCIp3ZEwYA+NZLUKBgFgwEAAN+HLX9sB8u8AAAAAElFTkSuQmCC"/><element name="nextButton" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAYCAYAAAAVibZIAAAAQElEQVQ4y2NgGAWjYOiD/0B8Hojl0cT+U2ooCL8HYn9qGwrD/bQw9P+QMXQ+tSMqnpoRBUpS+tRMUqNgFAwGAADxZy1/mHvFnAAAAABJRU5ErkJggg=="/><element name="timeSliderRail" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAOElEQVRIDe3BwQkAIRADwAhhw/nU/kWwUK+KPITMABFh19Y+F0acY8CJvX9wYpXgRElwolSIiMf9ZWEDhtwurFsAAAAASUVORK5CYII="/><element name="timeSliderBuffer" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAN0lEQVRIDe3BwQkAMQwDMBcc55mRe9zi7RR+FCwBEWG39vcfGHFm4MTuhhMlwYlVBSdKhYh43AW/LQMKm1spzwAAAABJRU5ErkJggg=="/><element name="timeSliderProgress" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAIElEQVRIiWNgGAWjYBTQBfynMR61YCRYMApGwSigMQAAiVWPcbq6UkIAAAAASUVORK5CYII="/><element name="timeSliderThumb" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAAAYCAYAAAA/OUfnAAAAO0lEQVQYlWP4//8/Awwz0JgDBP/BeN6Cxf/hnI2btiI4u/fsQ3AOHjqK4Jw4eQbBOX/hEoKDYjSd/AMA4cS4mfLsorgAAAAASUVORK5CYII="/><element name="muteButton" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAYCAYAAADKx8xXAAAAJklEQVQ4y2NgGAUjDcwH4v/kaPxPikZkxcNVI9mBQ5XoGAWDFwAAsKAXKQQmfbUAAAAASUVORK5CYII="/><element name="unmuteButton" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAYCAYAAADKx8xXAAAAMklEQVQ4y2NgGAWDHPyntub5xBr6Hwv/Pzk2/yfVG/8psRFE25Oq8T+tQnsIaB4FVAcAi2YVysVY52AAAAAASUVORK5CYII="/><element name="volumeSliderRail" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYAgMAAACdGdVrAAAACVBMVEUAAACmpqampqbBXAu8AAAAAnRSTlMAgJsrThgAAAArSURBVAhbY2AgErBAyA4I2QEhOyBkB4TsYOhAoaCCUCUwDTDtMMNgRuMHAFB5FoGH5T0UAAAAAElFTkSuQmCC"/><element name="volumeSliderProgress" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYAgMAAACdGdVrAAAACVBMVEUAAAAAAAAAAACDY+nAAAAAAnRSTlMAgJsrThgAAAArSURBVAhbY2AgErBAyA4I2QEhOyBkB4TsYOhAoaCCUCUwDTDtMMNgRuMHAFB5FoGH5T0UAAAAAElFTkSuQmCC"/><element name="volumeSliderCapRight" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAYCAYAAAAyJzegAAAAFElEQVQYV2P8//8/AzpgHBUc7oIAGZdH0RjKN8EAAAAASUVORK5CYII="/><element name="fullscreenButton" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAQklEQVRIiWNgGAWjYMiD/0iYFDmSLbDHImdPLQtgBpEiR7Zl2NijAA5oEkT/0Whi5UiyAJ8BVMsHNMtoo2AUDAIAAGdcIN3IDNXoAAAAAElFTkSuQmCC"/><element name="normalscreenButton" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAP0lEQVRIx2NgGAWjYMiD/1RSQ5QB/wmIUWzJfzx8qhj+n4DYCAY0DyJ7PBbYU8sHMEvwiZFtODXUjIJRMJgBACpWIN2ZxdPTAAAAAElFTkSuQmCC"/></elements></component><component name="display"><elements><element name="background" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyAQMAAAAk8RryAAAABlBMVEUAAAAAAAClZ7nPAAAAAnRSTlOZpuml+rYAAAASSURBVBhXY2AYJuA/GBwY6jQAyDyoK8QcL4QAAAAASUVORK5CYII="/><element name="playIcon" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAAiUlEQVR42u3XSw2AMBREURwgAQlIQAISKgUpSEFKJeCg5b0E0kWBTVcD9ySTsL0Jn9IBAAAA+K2UUrBlW/Rr5ZDoIeeuoFkxJD9ss03aIXXQqB9SttoG7ZA6qNcOKdttiwcJh9RB+iFl4SshkRBuLR72+9cvH0SOKI2HRo7x/Fi1/uoCAAAAwLsD8ki99IlO2dQAAAAASUVORK5CYII="/><element name="muteIcon" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAAVUlEQVR42u3WMQrAIAxAUW/g/SdvGmvpoOBeSHgPsjj5QTANAACARCJilIhYM0tEvJM+Ik3Id9E957kQIb+F3OdCPC0hPkQriqWx9hp/x/QGAABQyAPLB22VGrpLDgAAAABJRU5ErkJggg=="/><element name="errorIcon" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAA/0lEQVR42u2U0QmEMBAF7cASLMESUoIlpARLSCkpwRJSgiWkhOvAXD4WsgRkyaG5DbyB+Yvg8KITAAAAAAAYk+u61mwk15EjPtlEfihmqIiZR1Qx80ghjgdUuiHXGHSVsoag0x6x8DUoyjD5KovmEJ9NTDMRPIT0mtdIUkjlonuNohO+Ha99DTmkuGgKCTcvebAzx82ZoCWC3/3aIMWSRucaxcjORSFY4xpFdjYJGp1rFGcyCYZ/RVh6AUnfcNZ2zih3/mGj1jVCdiNDwyrq1rA/xMdeEXvDVdnYc1vDc3uPkDObXrlaxbNHSOohQhr/WOeLEWfWTgAAAAAAADzNF9sHJ7PJ57MlAAAAAElFTkSuQmCC"/><element name="bufferIcon" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAACBklEQVR42u3Zv0sCYRzH8USTzOsHHEWGkC1HgaDgkktGDjUYtDQ01RDSljQ1BLU02+rk1NTm2NLq4Nx/0L/h9fnCd3j4cnZe1/U8xiO8h3uurufF0/3COd/3/0UWYiEWYiEWYiGJQ+J8xuPxKhXjEMZANinjIZhkGuVRNioE4wVURo4JkHm0xKWmhRAc1bh1EyCUw5BcBIjHiApKa4CErko6DEJwuRo6IRKzyJD8FJAyI3Zp2zRImiBcRhlfo5RtlxCcE3CcDNpGrhYIT2IhAJKilO0VRmzJ32fAMTpBTS0QMfGwlcuKMRftE0DJ0wCJdcOsCkBdXP3Mh9CEFUBTPS9mDZJBG6io4aqVzMdCokCw9H3kT6j/C/9iDdSeUMNC7DkyyxAs/Rk6Qss8FPWRZgdVtUH4DjxEn1zxh+/zj1wHlf4MQhNGrwqA6sY40U8JonRJwEQh+AO3AvCG6gHv4U7IY4krxkroWoAOkoQMGfCBrgIm+YBGqPENpIJ66CJg3x66Y0gnSUidAEEnNr9jjLiWMn5DiWP0OC/oAsCgkq43xBdGDMQr7YASP/vEkHvdl1+JOCcEV5sC4hGEOzTlPuKgd0b0xD4JkRcOgnRRTjdErkYhAsQVq6IdUuPJtmk7BCL3t/h88cx91pKQkI/pkDx6pmYTIjEoxiHsN1YWYiEWYiEWknhflZ5IErA5nr8AAAAASUVORK5CYII="/></elements></component><component name="dock"><settings><setting name="fontcolor" value="0xffffff"/></settings><elements><element name="button" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyAQMAAAAk8RryAAAABlBMVEUAAAAAAAClZ7nPAAAAAnRSTlOZpuml+rYAAAASSURBVBhXY2AYJuA/GBwY6jQAyDyoK8QcL4QAAAAASUVORK5CYII="/></elements></component><component name="playlist"><settings><setting name="backgroundcolor" value="0xe8e8e8"/></settings><elements><element name="item" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAA8CAIAAAC1nk4lAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAHBJREFUaN7t2MENwCAMBEEe9N8wSKYC/D8YV7CyJoRkVtVImxkZPQInMxoP0XiIxkM0HsGbjjSNBx544IEHHnjggUe/6UQeey0PIh7XTftGxKPj4eXCtLsHHh+ZxkO0Iw8PR55Ni8ZD9Hu/EAoP0dc5RRg9qeRjVF8AAAAASUVORK5CYII="/><element name="sliderCapTop" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAHCAYAAADnCQYGAAAAFUlEQVQokWP8//8/A7UB46ihI9hQAKt6FPPXhVGHAAAAAElFTkSuQmCC"/><element name="sliderRail" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAUCAYAAABiS3YzAAAAKElEQVQ4y2P4//8/Az68bNmy/+iYkB6GUUNHDR01dNTQUUNHDaXcUABUDOKhcxnsSwAAAABJRU5ErkJggg=="/><element name="sliderThumb" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAUCAYAAABiS3YzAAAAJUlEQVQ4T2P4//8/Ay4MBP9xYbz6Rg0dNXTU0FFDRw0dNZRyQwHH4NBa7GJsXAAAAABJRU5ErkJggg=="/><element name="sliderCapBottom" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAHCAYAAADnCQYGAAAAFUlEQVQokWP8//8/A7UB46ihI9hQAKt6FPPXhVGHAAAAAElFTkSuQmCC"/></elements></component></components></skin>';this.xml=null;if(window.DOMParser){parser=new DOMParser();this.xml=parser.parseFromString(this.text,"text/xml")}else{this.xml=new ActiveXObject("Microsoft.XMLDOM");this.xml.async="false";this.xml.loadXML(this.text)}return this}})(jwplayer);(function(a){_utils=a.utils;_css=_utils.css;_hide=function(b){_css(b,{display:"none"})};_show=function(b){_css(b,{display:"block"})};a.html5.display=function(k,K){var j={icons:true,showmute:false};var X=_utils.extend({},j,K);var h=k;var W={};var e;var w;var z;var T;var u;var M;var E;var N=!_utils.exists(h.skin.getComponentSettings("display").bufferrotation)?15:parseInt(h.skin.getComponentSettings("display").bufferrotation,10);var s=!_utils.exists(h.skin.getComponentSettings("display").bufferinterval)?100:parseInt(h.skin.getComponentSettings("display").bufferinterval,10);var D=-1;var v=a.api.events.state.IDLE;var O=true;var d;var C=false,V=true;var p="";var g=false;var o=false;var m;var y,R;var L=new a.html5.eventdispatcher();_utils.extend(this,L);var H={display:{style:{cursor:"pointer",top:0,left:0,overflow:"hidden"},click:n},display_icon:{style:{cursor:"pointer",position:"absolute",top:((h.skin.getSkinElement("display","background").height-h.skin.getSkinElement("display","playIcon").height)/2),left:((h.skin.getSkinElement("display","background").width-h.skin.getSkinElement("display","playIcon").width)/2),border:0,margin:0,padding:0,zIndex:3,display:"none"}},display_iconBackground:{style:{cursor:"pointer",position:"absolute",top:((w-h.skin.getSkinElement("display","background").height)/2),left:((e-h.skin.getSkinElement("display","background").width)/2),border:0,backgroundImage:(["url(",h.skin.getSkinElement("display","background").src,")"]).join(""),width:h.skin.getSkinElement("display","background").width,height:h.skin.getSkinElement("display","background").height,margin:0,padding:0,zIndex:2,display:"none"}},display_image:{style:{display:"none",width:e,height:w,position:"absolute",cursor:"pointer",left:0,top:0,margin:0,padding:0,textDecoration:"none",zIndex:1}},display_text:{style:{zIndex:4,position:"relative",opacity:0.8,backgroundColor:parseInt("000000",16),color:parseInt("ffffff",16),textAlign:"center",fontFamily:"Arial,sans-serif",padding:"0 5px",fontSize:14}}};h.jwAddEventListener(a.api.events.JWPLAYER_PLAYER_STATE,q);h.jwAddEventListener(a.api.events.JWPLAYER_MEDIA_MUTE,q);h.jwAddEventListener(a.api.events.JWPLAYER_PLAYLIST_LOADED,P);h.jwAddEventListener(a.api.events.JWPLAYER_PLAYLIST_ITEM,q);h.jwAddEventListener(a.api.events.JWPLAYER_ERROR,r);Q();function Q(){W.display=G("div","display");W.display_text=G("div","display_text");W.display.appendChild(W.display_text);W.display_image=G("img","display_image");W.display_image.onerror=function(Y){_hide(W.display_image)};W.display_image.onload=B;W.display_icon=G("div","display_icon");W.display_iconBackground=G("div","display_iconBackground");W.display.appendChild(W.display_image);W.display_iconBackground.appendChild(W.display_icon);W.display.appendChild(W.display_iconBackground);f();setTimeout((function(){o=true;if(X.icons.toString()=="true"){J()}}),1)}this.getDisplayElement=function(){return W.display};this.resize=function(Z,Y){if(h.jwGetFullscreen()&&_utils.isMobile()){return}_css(W.display,{width:Z,height:Y});_css(W.display_text,{width:(Z-10),top:((Y-_utils.getBoundingClientRect(W.display_text).height)/2)});_css(W.display_iconBackground,{top:((Y-h.skin.getSkinElement("display","background").height)/2),left:((Z-h.skin.getSkinElement("display","background").width)/2)});if(e!=Z||w!=Y){e=Z;w=Y;d=undefined;J()}if(!h.jwGetFullscreen()){y=Z;R=Y}c();q({})};this.show=function(){if(g){g=false;t(h.jwGetState())}};this.hide=function(){if(!g){F();g=true}};function B(Y){z=W.display_image.naturalWidth;T=W.display_image.naturalHeight;c();if(h.jwGetState()==a.api.events.state.IDLE){_css(W.display_image,{display:"block",opacity:0});_utils.fadeTo(W.display_image,1,0.1)}C=false}function c(){if(h.jwGetFullscreen()&&h.jwGetStretching()==a.utils.stretching.EXACTFIT){var Y=document.createElement("div");_utils.stretch(a.utils.stretching.UNIFORM,Y,e,w,y,R);_utils.stretch(a.utils.stretching.EXACTFIT,W.display_image,_utils.parseDimension(Y.style.width),_utils.parseDimension(Y.style.height),z,T);_css(W.display_image,{left:Y.style.left,top:Y.style.top})}else{_utils.stretch(h.jwGetStretching(),W.display_image,e,w,z,T)}}function G(Y,aa){var Z=document.createElement(Y);Z.id=h.id+"_jwplayer_"+aa;_css(Z,H[aa].style);return Z}function f(){for(var Y in W){if(_utils.exists(H[Y].click)){W[Y].onclick=H[Y].click}}}function n(Y){if(typeof Y.preventDefault!="undefined"){Y.preventDefault()}else{Y.returnValue=false}if(typeof m=="function"){m(Y);return}else{if(h.jwGetState()!=a.api.events.state.PLAYING){h.jwPlay()}else{h.jwPause()}}}function U(Y){if(E){F();return}W.display_icon.style.backgroundImage=(["url(",h.skin.getSkinElement("display",Y).src,")"]).join("");_css(W.display_icon,{width:h.skin.getSkinElement("display",Y).width,height:h.skin.getSkinElement("display",Y).height,top:(h.skin.getSkinElement("display","background").height-h.skin.getSkinElement("display",Y).height)/2,left:(h.skin.getSkinElement("display","background").width-h.skin.getSkinElement("display",Y).width)/2});b();if(_utils.exists(h.skin.getSkinElement("display",Y+"Over"))){W.display_icon.onmouseover=function(Z){W.display_icon.style.backgroundImage=["url(",h.skin.getSkinElement("display",Y+"Over").src,")"].join("")};W.display_icon.onmouseout=function(Z){W.display_icon.style.backgroundImage=["url(",h.skin.getSkinElement("display",Y).src,")"].join("")}}else{W.display_icon.onmouseover=null;W.display_icon.onmouseout=null}}function F(){if(X.icons.toString()=="true"){_hide(W.display_icon);_hide(W.display_iconBackground);S()}}function b(){if(!g&&X.icons.toString()=="true"){_show(W.display_icon);_show(W.display_iconBackground);J()}}function r(Y){E=true;F();W.display_text.innerHTML=Y.message;_show(W.display_text);W.display_text.style.top=((w-_utils.getBoundingClientRect(W.display_text).height)/2)+"px"}function I(){V=false;W.display_image.style.display="none"}function P(){v=""}function q(Y){if((Y.type==a.api.events.JWPLAYER_PLAYER_STATE||Y.type==a.api.events.JWPLAYER_PLAYLIST_ITEM)&&E){E=false;_hide(W.display_text)}var Z=h.jwGetState();if(Z==v){return}v=Z;if(D>=0){clearTimeout(D)}if(O||h.jwGetState()==a.api.events.state.PLAYING||h.jwGetState()==a.api.events.state.PAUSED){t(h.jwGetState())}else{D=setTimeout(l(h.jwGetState()),500)}}function l(Y){return(function(){t(Y)})}function t(Y){if(_utils.exists(M)){clearInterval(M);M=null;_utils.animations.rotate(W.display_icon,0)}switch(Y){case a.api.events.state.BUFFERING:if(_utils.isIPod()){I();F()}else{if(h.jwGetPlaylist()[h.jwGetPlaylistIndex()].provider=="sound"){x()}u=0;M=setInterval(function(){u+=N;_utils.animations.rotate(W.display_icon,u%360)},s);U("bufferIcon");O=true}break;case a.api.events.state.PAUSED:if(!_utils.isIPod()){if(h.jwGetPlaylist()[h.jwGetPlaylistIndex()].provider!="sound"){_css(W.display_image,{background:"transparent no-repeat center center"})}U("playIcon");O=true}break;case a.api.events.state.IDLE:if(h.jwGetPlaylist()[h.jwGetPlaylistIndex()]&&h.jwGetPlaylist()[h.jwGetPlaylistIndex()].image){x()}else{I()}U("playIcon");O=true;break;default:if(h.jwGetPlaylist()[h.jwGetPlaylistIndex()]&&h.jwGetPlaylist()[h.jwGetPlaylistIndex()].provider=="sound"){if(_utils.isIPod()){I();O=false}else{x()}}else{I();O=false}if(h.jwGetMute()&&X.showmute){U("muteIcon")}else{F()}break}D=-1}function x(){if(h.jwGetPlaylist()[h.jwGetPlaylistIndex()]){var Y=h.jwGetPlaylist()[h.jwGetPlaylistIndex()].image;if(Y){if(Y!=p){p=Y;C=true;W.display_image.src=_utils.getAbsolutePath(Y)}else{if(!(C||V)){V=true;W.display_image.style.opacity=0;W.display_image.style.display="block";_utils.fadeTo(W.display_image,1,0.1)}}}}}function A(Y){return function(){if(!o){return}if(!g&&d!=Y){d=Y;L.sendEvent(Y,{component:"display",boundingRect:_utils.getDimensions(W.display_iconBackground)})}}}var J=A(a.api.events.JWPLAYER_COMPONENT_SHOW);var S=A(a.api.events.JWPLAYER_COMPONENT_HIDE);this.setAlternateClickHandler=function(Y){m=Y};this.revertAlternateClickHandler=function(){m=undefined};return this}})(jwplayer);(function(a){var c=a.utils;var b=c.css;a.html5.dock=function(w,D){function x(){return{align:a.html5.view.positions.RIGHT}}var n=c.extend({},x(),D);if(n.align=="FALSE"){return}var j={};var A=[];var k;var F;var f=false;var C=false;var g={x:0,y:0,width:0,height:0};var z;var o;var y;var m=new a.html5.eventdispatcher();c.extend(this,m);var r=document.createElement("div");r.id=w.id+"_jwplayer_dock";r.style.opacity=1;p();w.jwAddEventListener(a.api.events.JWPLAYER_PLAYER_STATE,q);this.getDisplayElement=function(){return r};this.setButton=function(K,H,I,J){if(!H&&j[K]){c.arrays.remove(A,K);r.removeChild(j[K].div);delete j[K]}else{if(H){if(!j[K]){j[K]={}}j[K].handler=H;j[K].outGraphic=I;j[K].overGraphic=J;if(!j[K].div){A.push(K);j[K].div=document.createElement("div");j[K].div.style.position="absolute";r.appendChild(j[K].div);j[K].div.appendChild(document.createElement("div"));j[K].div.childNodes[0].style.position="relative";j[K].div.childNodes[0].style.width="100%";j[K].div.childNodes[0].style.height="100%";j[K].div.childNodes[0].style.zIndex=10;j[K].div.childNodes[0].style.cursor="pointer";j[K].div.appendChild(document.createElement("img"));j[K].div.childNodes[1].style.position="absolute";j[K].div.childNodes[1].style.left=0;j[K].div.childNodes[1].style.top=0;if(w.skin.getSkinElement("dock","button")){j[K].div.childNodes[1].src=w.skin.getSkinElement("dock","button").src}j[K].div.childNodes[1].style.zIndex=9;j[K].div.childNodes[1].style.cursor="pointer";j[K].div.onmouseover=function(){if(j[K].overGraphic){j[K].div.childNodes[0].style.background=h(j[K].overGraphic)}if(w.skin.getSkinElement("dock","buttonOver")){j[K].div.childNodes[1].src=w.skin.getSkinElement("dock","buttonOver").src}};j[K].div.onmouseout=function(){if(j[K].outGraphic){j[K].div.childNodes[0].style.background=h(j[K].outGraphic)}if(w.skin.getSkinElement("dock","button")){j[K].div.childNodes[1].src=w.skin.getSkinElement("dock","button").src}};if(w.skin.getSkinElement("dock","button")){j[K].div.childNodes[1].src=w.skin.getSkinElement("dock","button").src}}if(j[K].outGraphic){j[K].div.childNodes[0].style.background=h(j[K].outGraphic)}else{if(j[K].overGraphic){j[K].div.childNodes[0].style.background=h(j[K].overGraphic)}}if(H){j[K].div.onclick=function(L){L.preventDefault();a(w.id).callback(K);if(j[K].overGraphic){j[K].div.childNodes[0].style.background=h(j[K].overGraphic)}if(w.skin.getSkinElement("dock","button")){j[K].div.childNodes[1].src=w.skin.getSkinElement("dock","button").src}}}}}l(k,F)};function h(H){return"url("+H+") no-repeat center center"}function t(H){}function l(H,T){p();if(A.length>0){var I=10;var S=I;var P=-1;var Q=w.skin.getSkinElement("dock","button").height;var O=w.skin.getSkinElement("dock","button").width;var M=H-O-I;var R,L;if(n.align==a.html5.view.positions.LEFT){P=1;M=I}for(var J=0;J<A.length;J++){var U=Math.floor(S/T);if((S+Q+I)>((U+1)*T)){S=((U+1)*T)+I;U=Math.floor(S/T)}var K=j[A[J]].div;K.style.top=(S%T)+"px";K.style.left=(M+(w.skin.getSkinElement("dock","button").width+I)*U*P)+"px";var N={x:c.parseDimension(K.style.left),y:c.parseDimension(K.style.top),width:O,height:Q};if(!R||(N.x<=R.x&&N.y<=R.y)){R=N}if(!L||(N.x>=L.x&&N.y>=L.y)){L=N}K.style.width=O+"px";K.style.height=Q+"px";S+=w.skin.getSkinElement("dock","button").height+I}g={x:R.x,y:R.y,width:L.x-R.x+L.width,height:R.y-L.y+L.height}}if(C!=w.jwGetFullscreen()||k!=H||F!=T){k=H;F=T;C=w.jwGetFullscreen();z=undefined;setTimeout(s,1)}}function d(H){return function(){if(!f&&z!=H&&A.length>0){z=H;m.sendEvent(H,{component:"dock",boundingRect:g})}}}function q(H){if(c.isMobile()){if(H.newstate==a.api.events.state.IDLE){v()}else{e()}}else{B()}}function B(H){if(f){return}clearTimeout(y);if(D.position==a.html5.view.positions.OVER||w.jwGetFullscreen()){switch(w.jwGetState()){case a.api.events.state.PAUSED:case a.api.events.state.IDLE:if(r&&r.style.opacity<1&&(!D.idlehide||c.exists(H))){E()}if(D.idlehide){y=setTimeout(function(){u()},2000)}break;default:if(c.exists(H)){E()}y=setTimeout(function(){u()},2000);break}}else{E()}}var s=d(a.api.events.JWPLAYER_COMPONENT_SHOW);var G=d(a.api.events.JWPLAYER_COMPONENT_HIDE);this.resize=l;var v=function(){b(r,{display:"block"});if(f){f=false;s()}};var e=function(){b(r,{display:"none"});if(!f){G();f=true}};function u(){if(!f){G();if(r.style.opacity==1){c.cancelAnimation(r);c.fadeTo(r,0,0.1,1,0)}}}function E(){if(!f){s();if(r.style.opacity==0){c.cancelAnimation(r);c.fadeTo(r,1,0.1,0,0)}}}function p(){try{o=document.getElementById(w.id);o.addEventListener("mousemove",B)}catch(H){c.log("Could not add mouse listeners to dock: "+H)}}this.hide=e;this.show=v;return this}})(jwplayer);(function(a){a.html5.eventdispatcher=function(d,b){var c=new a.events.eventdispatcher(b);a.utils.extend(this,c);this.sendEvent=function(e,f){if(!a.utils.exists(f)){f={}}a.utils.extend(f,{id:d,version:a.version,type:e});c.sendEvent(e,f)}}})(jwplayer);(function(a){var b=a.utils;a.html5.instream=function(y,m,x,z){var t={controlbarseekable:"always",controlbarpausable:true,controlbarstoppable:true,playlistclickable:true};var v,A,C=y,E=m,j=x,w=z,r,H,o,G,e,f,g,l,q,h=false,k,d,n=this;this.load=function(M,K){c();h=true;A=b.extend(t,K);v=a.html5.playlistitem(M);F();d=document.createElement("div");d.id=n.id+"_instream_container";w.detachMedia();r=g.getDisplayElement();f=E.playlist[E.item];e=C.jwGetState();if(e==a.api.events.state.BUFFERING||e==a.api.events.state.PLAYING){r.pause()}H=r.src?r.src:r.currentSrc;o=r.innerHTML;G=r.currentTime;q=new a.html5.display(n,b.extend({},E.plugins.config.display));q.setAlternateClickHandler(function(N){if(_fakemodel.state==a.api.events.state.PAUSED){n.jwInstreamPlay()}else{D(a.api.events.JWPLAYER_INSTREAM_CLICK,N)}});d.appendChild(q.getDisplayElement());if(!b.isMobile()){l=new a.html5.controlbar(n,b.extend({},E.plugins.config.controlbar,{}));if(E.plugins.config.controlbar.position==a.html5.view.positions.OVER){d.appendChild(l.getDisplayElement())}else{var L=E.plugins.object.controlbar.getDisplayElement().parentNode;L.appendChild(l.getDisplayElement())}}j.setupInstream(d,r);p();g.load(v)};this.jwInstreamDestroy=function(K){if(!h){return}h=false;if(e!=a.api.events.state.IDLE){g.load(f,false);g.stop(false)}else{g.stop(true)}g.detachMedia();j.destroyInstream();if(l){try{l.getDisplayElement().parentNode.removeChild(l.getDisplayElement())}catch(L){}}D(a.api.events.JWPLAYER_INSTREAM_DESTROYED,{reason:(K?"complete":"destroyed")},true);w.attachMedia();if(e==a.api.events.state.BUFFERING||e==a.api.events.state.PLAYING){r.play();if(E.playlist[E.item]==f){E.getMedia().seek(G)}}return};this.jwInstreamAddEventListener=function(K,L){k.addEventListener(K,L)};this.jwInstreamRemoveEventListener=function(K,L){k.removeEventListener(K,L)};this.jwInstreamPlay=function(){if(!h){return}g.play(true)};this.jwInstreamPause=function(){if(!h){return}g.pause(true)};this.jwInstreamSeek=function(K){if(!h){return}g.seek(K)};this.jwInstreamGetState=function(){if(!h){return undefined}return _fakemodel.state};this.jwInstreamGetPosition=function(){if(!h){return undefined}return _fakemodel.position};this.jwInstreamGetDuration=function(){if(!h){return undefined}return _fakemodel.duration};this.playlistClickable=function(){return(!h||A.playlistclickable.toString().toLowerCase()=="true")};function s(){_fakemodel=new a.html5.model(this,E.getMedia()?E.getMedia().getDisplayElement():E.container,E);k=new a.html5.eventdispatcher();C.jwAddEventListener(a.api.events.JWPLAYER_RESIZE,p);C.jwAddEventListener(a.api.events.JWPLAYER_FULLSCREEN,p)}function c(){_fakemodel.setMute(E.mute);_fakemodel.setVolume(E.volume)}function F(){if(!g){g=new a.html5.mediavideo(_fakemodel,E.getMedia()?E.getMedia().getDisplayElement():E.container);g.addGlobalListener(I);g.addEventListener(a.api.events.JWPLAYER_MEDIA_META,J);g.addEventListener(a.api.events.JWPLAYER_MEDIA_COMPLETE,u);g.addEventListener(a.api.events.JWPLAYER_MEDIA_BUFFER_FULL,B)}g.attachMedia()}function I(K){if(h){D(K.type,K)}}function B(K){if(h){g.play()}}function u(K){if(h){setTimeout(function(){n.jwInstreamDestroy(true)},10)}}function J(K){if(K.metadata.width&&K.metadata.height){j.resizeMedia()}}function D(K,L,M){if(h||M){k.sendEvent(K,L)}}function p(){var K=E.plugins.object.display.getDisplayElement().style;if(l){var L=E.plugins.object.controlbar.getDisplayElement().style;l.resize(b.parseDimension(K.width),b.parseDimension(L.height));_css(l.getDisplayElement(),b.extend({},L,{zIndex:1001,opacity:1}))}if(q){q.resize(b.parseDimension(K.width),b.parseDimension(K.height));_css(q.getDisplayElement(),b.extend({},K,{zIndex:1000}))}if(j){j.resizeMedia()}}this.jwPlay=function(K){if(A.controlbarpausable.toString().toLowerCase()=="true"){this.jwInstreamPlay()}};this.jwPause=function(K){if(A.controlbarpausable.toString().toLowerCase()=="true"){this.jwInstreamPause()}};this.jwStop=function(){if(A.controlbarstoppable.toString().toLowerCase()=="true"){this.jwInstreamDestroy();C.jwStop()}};this.jwSeek=function(K){switch(A.controlbarseekable.toLowerCase()){case"always":this.jwInstreamSeek(K);break;case"backwards":if(_fakemodel.position>K){this.jwInstreamSeek(K)}break}};this.jwGetPosition=function(){};this.jwGetDuration=function(){};this.jwGetWidth=C.jwGetWidth;this.jwGetHeight=C.jwGetHeight;this.jwGetFullscreen=C.jwGetFullscreen;this.jwSetFullscreen=C.jwSetFullscreen;this.jwGetVolume=function(){return E.volume};this.jwSetVolume=function(K){g.volume(K);C.jwSetVolume(K)};this.jwGetMute=function(){return E.mute};this.jwSetMute=function(K){g.mute(K);C.jwSetMute(K)};this.jwGetState=function(){return _fakemodel.state};this.jwGetPlaylist=function(){return[v]};this.jwGetPlaylistIndex=function(){return 0};this.jwGetStretching=function(){return E.config.stretching};this.jwAddEventListener=function(L,K){k.addEventListener(L,K)};this.jwRemoveEventListener=function(L,K){k.removeEventListener(L,K)};this.skin=C.skin;this.id=C.id+"_instream";s();return this}})(jwplayer);(function(a){var b={prefix:"",file:"",link:"",linktarget:"_top",margin:8,out:0.5,over:1,timeout:5,hide:true,position:"bottom-left"};_css=a.utils.css;a.html5.logo=function(n,r){var q=n;var u;var d;var t;var h=false;g();function g(){o();q.jwAddEventListener(a.api.events.JWPLAYER_PLAYER_STATE,j);c();l()}function o(){if(b.prefix){var v=n.version.split(/\W/).splice(0,2).join("/");if(b.prefix.indexOf(v)<0){b.prefix+=v+"/"}}if(r.position==a.html5.view.positions.OVER){r.position=b.position}try{if(window.location.href.indexOf("https")==0){b.prefix=b.prefix.replace("http://l.longtailvideo.com","https://securel.longtailvideo.com")}}catch(w){}d=a.utils.extend({},b,r)}function c(){t=document.createElement("img");t.id=q.id+"_jwplayer_logo";t.style.display="none";t.onload=function(v){_css(t,k());p()};if(!d.file){return}if(d.file.indexOf("/")>=0){t.src=d.file}else{t.src=d.prefix+d.file}}if(!d.file){return}this.resize=function(w,v){};this.getDisplayElement=function(){return t};function l(){if(d.link){t.onmouseover=f;t.onmouseout=p;t.onclick=s}else{this.mouseEnabled=false}}function s(v){if(typeof v!="undefined"){v.stopPropagation()}if(!h){return}q.jwPause();q.jwSetFullscreen(false);if(d.link){window.open(d.link,d.linktarget)}return}function p(v){if(d.link&&h){t.style.opacity=d.out}return}function f(v){if(h){t.style.opacity=d.over}return}function k(){var x={textDecoration:"none",position:"absolute",cursor:"pointer"};x.display=(d.hide.toString()=="true"&&!h)?"none":"block";var w=d.position.toLowerCase().split("-");for(var v in w){x[w[v]]=parseInt(d.margin)}return x}function m(){if(d.hide.toString()=="true"){t.style.display="block";t.style.opacity=0;a.utils.fadeTo(t,d.out,0.1,parseFloat(t.style.opacity));u=setTimeout(function(){e()},d.timeout*1000)}h=true}function e(){h=false;if(d.hide.toString()=="true"){a.utils.fadeTo(t,0,0.1,parseFloat(t.style.opacity))}}function j(v){if(v.newstate==a.api.events.state.BUFFERING){clearTimeout(u);m()}}return this}})(jwplayer);(function(b){var d={ended:b.api.events.state.IDLE,playing:b.api.events.state.PLAYING,pause:b.api.events.state.PAUSED,buffering:b.api.events.state.BUFFERING};var e=b.utils;var a=e.isMobile();var c={};b.html5.mediavideo=function(h,F){var J={abort:y,canplay:p,canplaythrough:p,durationchange:u,emptied:y,ended:p,error:o,loadeddata:u,loadedmetadata:u,loadstart:p,pause:p,play:y,playing:p,progress:D,ratechange:y,seeked:p,seeking:p,stalled:p,suspend:p,timeupdate:N,volumechange:l,waiting:p,canshowcurrentframe:y,dataunavailable:y,empty:y,load:g,loadedfirstframe:y,webkitfullscreenchange:k};var K=new b.html5.eventdispatcher();e.extend(this,K);var j=h,B=F,m,f,C,T,E,M,L=false,t=false,x=false,I,G,Q;R();this.load=function(V,W){if(typeof W=="undefined"){W=true}if(!t){return}T=V;x=(T.duration>0);j.duration=T.duration;e.empty(m);Q=0;q(V.levels);if(V.levels&&V.levels.length>0){if(V.levels.length==1||e.isIOS()){m.src=V.levels[0].file}else{if(m.src){m.removeAttribute("src")}for(var U=0;U<V.levels.length;U++){var X=m.ownerDocument.createElement("source");X.src=V.levels[U].file;m.appendChild(X);Q++}}}else{m.src=V.file}m.style.display="block";m.style.opacity=1;m.volume=j.volume/100;m.muted=j.mute;if(a){P()}I=G=C=false;j.buffer=0;if(!e.exists(V.start)){V.start=0}M=(V.start>0)?V.start:-1;s(b.api.events.JWPLAYER_MEDIA_LOADED);if((!a&&V.levels.length==1)||!L){m.load()}L=false;if(W){w(b.api.events.state.BUFFERING);s(b.api.events.JWPLAYER_MEDIA_BUFFER,{bufferPercent:0});A()}if(m.videoWidth>0&&m.videoHeight>0){u()}};this.play=function(){if(!t){return}A();if(G){w(b.api.events.state.PLAYING)}else{w(b.api.events.state.BUFFERING)}m.play()};this.pause=function(){if(!t){return}m.pause();w(b.api.events.state.PAUSED)};this.seek=function(U){if(!t){return}if(!C&&m.readyState>0){if(!(j.duration<=0||isNaN(j.duration))&&!(j.position<=0||isNaN(j.position))){m.currentTime=U;m.play()}}else{M=U}};var z=this.stop=function(U){if(!t){return}if(!e.exists(U)){U=true}r();if(U){G=false;var V=navigator.userAgent;if(m.webkitSupportsFullscreen){try{m.webkitExitFullscreen()}catch(W){}}m.style.opacity=0;v();if(e.isIE()){m.src=""}else{m.removeAttribute("src")}e.empty(m);m.load();L=true}w(b.api.events.state.IDLE)};this.fullscreen=function(U){if(U===true){this.resize("100%","100%")}else{this.resize(j.config.width,j.config.height)}};this.resize=function(V,U){};this.volume=function(U){if(!a){m.volume=U/100;s(b.api.events.JWPLAYER_MEDIA_VOLUME,{volume:(U/100)})}};this.mute=function(U){if(!a){m.muted=U;s(b.api.events.JWPLAYER_MEDIA_MUTE,{mute:U})}};this.getDisplayElement=function(){return m};this.hasChrome=function(){return a&&(f==b.api.events.state.PLAYING)};this.detachMedia=function(){t=false;return this.getDisplayElement()};this.attachMedia=function(){t=true};function H(V,U){return function(W){if(e.exists(W.target.parentNode)){U(W)}}}function R(){f=b.api.events.state.IDLE;t=true;m=n();m.setAttribute("x-webkit-airplay","allow");if(B.parentNode){m.id=B.id;B.parentNode.replaceChild(m,B)}}function n(){var U=c[j.id];if(!U){if(B.tagName.toLowerCase()=="video"){U=B}else{U=document.createElement("video")}c[j.id]=U;if(!U.id){U.id=B.id}}for(var V in J){U.addEventListener(V,H(V,J[V]),true)}return U}function w(U){if(U==b.api.events.state.PAUSED&&f==b.api.events.state.IDLE){return}if(a){switch(U){case b.api.events.state.PLAYING:P();break;case b.api.events.state.BUFFERING:case b.api.events.state.PAUSED:v();break}}if(f!=U){var V=f;j.state=f=U;s(b.api.events.JWPLAYER_PLAYER_STATE,{oldstate:V,newstate:U})}}function y(U){}function l(U){var V=Math.round(m.volume*100);s(b.api.events.JWPLAYER_MEDIA_VOLUME,{volume:V},true);s(b.api.events.JWPLAYER_MEDIA_MUTE,{mute:m.muted},true)}function D(W){if(!t){return}var V;if(e.exists(W)&&W.lengthComputable&&W.total){V=W.loaded/W.total*100}else{if(e.exists(m.buffered)&&(m.buffered.length>0)){var U=m.buffered.length-1;if(U>=0){V=m.buffered.end(U)/m.duration*100}}}if(e.useNativeFullscreen()&&e.exists(m.webkitDisplayingFullscreen)){if(j.fullscreen!=m.webkitDisplayingFullscreen){s(b.api.events.JWPLAYER_FULLSCREEN,{fullscreen:m.webkitDisplayingFullscreen},true)}}if(G===false&&f==b.api.events.state.BUFFERING){s(b.api.events.JWPLAYER_MEDIA_BUFFER_FULL);G=true}if(!I){if(V==100){I=true}if(e.exists(V)&&(V>j.buffer)){j.buffer=Math.round(V);s(b.api.events.JWPLAYER_MEDIA_BUFFER,{bufferPercent:Math.round(V)})}}}function N(V){if(!t){return}if(e.exists(V)&&e.exists(V.target)){if(x>0){if(!isNaN(V.target.duration)&&(isNaN(j.duration)||j.duration<1)){if(V.target.duration==Infinity){j.duration=0}else{j.duration=Math.round(V.target.duration*10)/10}}}if(!C&&m.readyState>0){w(b.api.events.state.PLAYING)}if(f==b.api.events.state.PLAYING){if(m.readyState>0&&(M>-1||!C)){C=true;try{if(m.currentTime!=M&&M>-1){m.currentTime=M;M=-1}}catch(U){}m.volume=j.volume/100;m.muted=j.mute}j.position=j.duration>0?(Math.round(V.target.currentTime*10)/10):0;s(b.api.events.JWPLAYER_MEDIA_TIME,{position:j.position,duration:j.duration});if(j.position>=j.duration&&(j.position>0||j.duration>0)){O();return}}}D(V)}function g(U){}function p(U){if(!t){return}if(d[U.type]){if(U.type=="ended"){O()}else{w(d[U.type])}}}function u(V){if(!t){return}var U=Math.round(m.duration*10)/10;var W={height:m.videoHeight,width:m.videoWidth,duration:U};if(!x){if((j.duration<U||isNaN(j.duration))&&m.duration!=Infinity){j.duration=U}}s(b.api.events.JWPLAYER_MEDIA_META,{metadata:W})}function o(W){if(!t){return}if(f==b.api.events.state.IDLE){return}var V="There was an error: ";if((W.target.error&&W.target.tagName.toLowerCase()=="video")||W.target.parentNode.error&&W.target.parentNode.tagName.toLowerCase()=="video"){var U=!e.exists(W.target.error)?W.target.parentNode.error:W.target.error;switch(U.code){case U.MEDIA_ERR_ABORTED:e.log("User aborted the video playback.");return;case U.MEDIA_ERR_NETWORK:V="A network error caused the video download to fail part-way: ";break;case U.MEDIA_ERR_DECODE:V="The video playback was aborted due to a corruption problem or because the video used features your browser did not support: ";break;case U.MEDIA_ERR_SRC_NOT_SUPPORTED:V="The video could not be loaded, either because the server or network failed or because the format is not supported: ";break;default:V="An unknown error occurred: ";break}}else{if(W.target.tagName.toLowerCase()=="source"){Q--;if(Q>0){return}if(e.userAgentMatch(/firefox/i)){e.log("The video could not be loaded, either because the server or network failed or because the format is not supported.");z(false);return}else{V="The video could not be loaded, either because the server or network failed or because the format is not supported: "}}else{e.log("An unknown error occurred.  Continuing...");return}}z(false);V+=S();_error=true;s(b.api.events.JWPLAYER_ERROR,{message:V});return}function S(){var W="";for(var V in T.levels){var U=T.levels[V];var X=B.ownerDocument.createElement("source");W+=b.utils.getAbsolutePath(U.file);if(V<(T.levels.length-1)){W+=", "}}return W}function A(){if(!e.exists(E)){E=setInterval(function(){D()},100)}}function r(){clearInterval(E);E=null}function O(){if(f==b.api.events.state.PLAYING){z(false);s(b.api.events.JWPLAYER_MEDIA_BEFORECOMPLETE);s(b.api.events.JWPLAYER_MEDIA_COMPLETE)}}function k(U){if(e.exists(m.webkitDisplayingFullscreen)){if(j.fullscreen&&!m.webkitDisplayingFullscreen){s(b.api.events.JWPLAYER_FULLSCREEN,{fullscreen:false},true)}}}function q(W){if(W.length>0&&e.userAgentMatch(/Safari/i)&&!e.userAgentMatch(/Chrome/i)){var U=-1;for(var V=0;V<W.length;V++){switch(e.extension(W[V].file)){case"mp4":if(U<0){U=V}break;case"webm":W.splice(V,1);break}}if(U>0){var X=W.splice(U,1)[0];W.unshift(X)}}}function P(){setTimeout(function(){m.setAttribute("controls","controls")},100)}function v(){setTimeout(function(){m.removeAttribute("controls")},250)}function s(U,W,V){if(t||V){if(W){K.sendEvent(U,W)}else{K.sendEvent(U)}}}}})(jwplayer);(function(a){var c={ended:a.api.events.state.IDLE,playing:a.api.events.state.PLAYING,pause:a.api.events.state.PAUSED,buffering:a.api.events.state.BUFFERING};var b=a.utils.css;a.html5.mediayoutube=function(j,e){var f=new a.html5.eventdispatcher();a.utils.extend(this,f);var l=j;var h=document.getElementById(e.id);var g=a.api.events.state.IDLE;var n,m;function k(p){if(g!=p){var q=g;l.state=p;g=p;f.sendEvent(a.api.events.JWPLAYER_PLAYER_STATE,{oldstate:q,newstate:p})}}this.getDisplayElement=this.detachMedia=function(){return h};this.attachMedia=function(){};this.play=function(){if(g==a.api.events.state.IDLE){f.sendEvent(a.api.events.JWPLAYER_MEDIA_BUFFER,{bufferPercent:100});f.sendEvent(a.api.events.JWPLAYER_MEDIA_BUFFER_FULL);k(a.api.events.state.PLAYING)}else{if(g==a.api.events.state.PAUSED){k(a.api.events.state.PLAYING)}}};this.pause=function(){k(a.api.events.state.PAUSED)};this.seek=function(p){};this.stop=function(p){if(!_utils.exists(p)){p=true}l.position=0;k(a.api.events.state.IDLE);if(p){b(h,{display:"none"})}};this.volume=function(p){l.setVolume(p);f.sendEvent(a.api.events.JWPLAYER_MEDIA_VOLUME,{volume:Math.round(p)})};this.mute=function(p){h.muted=p;f.sendEvent(a.api.events.JWPLAYER_MEDIA_MUTE,{mute:p})};this.resize=function(q,p){if(q*p>0&&n){n.width=m.width=q;n.height=m.height=p}};this.fullscreen=function(p){if(p===true){this.resize("100%","100%")}else{this.resize(l.config.width,l.config.height)}};this.load=function(p){o(p);b(n,{display:"block"});k(a.api.events.state.BUFFERING);f.sendEvent(a.api.events.JWPLAYER_MEDIA_BUFFER,{bufferPercent:0});f.sendEvent(a.api.events.JWPLAYER_MEDIA_LOADED);this.play()};this.hasChrome=function(){return(g!=a.api.events.state.IDLE)};function o(v){var s=v.levels[0].file;s=["http://www.youtube.com/v/",d(s),"&amp;hl=en_US&amp;fs=1&autoplay=1"].join("");n=document.createElement("object");n.id=h.id;n.style.position="absolute";var u={movie:s,allowfullscreen:"true",allowscriptaccess:"always"};for(var p in u){var t=document.createElement("param");t.name=p;t.value=u[p];n.appendChild(t)}m=document.createElement("embed");n.appendChild(m);var q={src:s,type:"application/x-shockwave-flash",allowfullscreen:"true",allowscriptaccess:"always",width:n.width,height:n.height};for(var r in q){m.setAttribute(r,q[r])}n.appendChild(m);n.style.zIndex=2147483000;if(h!=n&&h.parentNode){h.parentNode.replaceChild(n,h)}h=n}function d(q){var p=q.split(/\?|\#\!/);var s="";for(var r=0;r<p.length;r++){if(p[r].substr(0,2)=="v="){s=p[r].substr(2)}}if(s==""){if(q.indexOf("/v/")>=0){s=q.substr(q.indexOf("/v/")+3)}else{if(q.indexOf("youtu.be")>=0){s=q.substr(q.indexOf("youtu.be/")+9)}else{s=q}}}if(s.indexOf("?")>-1){s=s.substr(0,s.indexOf("?"))}if(s.indexOf("&")>-1){s=s.substr(0,s.indexOf("&"))}return s}this.embed=m;return this}})(jwplayer);(function(jwplayer){var _configurableStateVariables=["width","height","start","duration","volume","mute","fullscreen","item","plugins","stretching"];var _utils=jwplayer.utils;jwplayer.html5.model=function(api,container,options){var _api=api;var _container=container;var _cookies=_utils.getCookies();var _model={id:_container.id,playlist:[],state:jwplayer.api.events.state.IDLE,position:0,buffer:0,container:_container,config:{width:480,height:320,item:-1,skin:undefined,file:undefined,image:undefined,start:0,duration:0,bufferlength:5,volume:_cookies.volume?_cookies.volume:90,mute:_cookies.mute&&_cookies.mute.toString().toLowerCase()=="true"?true:false,fullscreen:false,repeat:"",stretching:jwplayer.utils.stretching.UNIFORM,autostart:false,debug:undefined,screencolor:undefined}};var _media;var _eventDispatcher=new jwplayer.html5.eventdispatcher();var _components=["display","logo","controlbar","playlist","dock"];jwplayer.utils.extend(_model,_eventDispatcher);for(var option in options){if(typeof options[option]=="string"){var type=/color$/.test(option)?"color":null;options[option]=jwplayer.utils.typechecker(options[option],type)}var config=_model.config;var path=option.split(".");for(var edge in path){if(edge==path.length-1){config[path[edge]]=options[option]}else{if(!jwplayer.utils.exists(config[path[edge]])){config[path[edge]]={}}config=config[path[edge]]}}}for(var index in _configurableStateVariables){var configurableStateVariable=_configurableStateVariables[index];_model[configurableStateVariable]=_model.config[configurableStateVariable]}var pluginorder=_components.concat([]);if(jwplayer.utils.exists(_model.plugins)){if(typeof _model.plugins=="string"){var userplugins=_model.plugins.split(",");for(var userplugin in userplugins){if(typeof userplugins[userplugin]=="string"){pluginorder.push(userplugins[userplugin].replace(/^\s+|\s+$/g,""))}}}}if(jwplayer.utils.isMobile()){pluginorder=["display","logo","dock","playlist"];if(!jwplayer.utils.exists(_model.config.repeat)){_model.config.repeat="list"}}else{if(_model.config.chromeless){pluginorder=["logo","dock","playlist"];if(!jwplayer.utils.exists(_model.config.repeat)){_model.config.repeat="list"}}}_model.plugins={order:pluginorder,config:{},object:{}};if(typeof _model.config.components!="undefined"){for(var component in _model.config.components){_model.plugins.config[component]=_model.config.components[component]}}var playlistVisible=false;for(var pluginIndex in _model.plugins.order){var pluginName=_model.plugins.order[pluginIndex];var pluginConfig=!jwplayer.utils.exists(_model.plugins.config[pluginName])?{}:_model.plugins.config[pluginName];_model.plugins.config[pluginName]=!jwplayer.utils.exists(_model.plugins.config[pluginName])?pluginConfig:jwplayer.utils.extend(_model.plugins.config[pluginName],pluginConfig);if(!jwplayer.utils.exists(_model.plugins.config[pluginName].position)){if(pluginName=="playlist"){_model.plugins.config[pluginName].position=jwplayer.html5.view.positions.NONE}else{_model.plugins.config[pluginName].position=jwplayer.html5.view.positions.OVER}}else{if(pluginName=="playlist"){playlistVisible=true}_model.plugins.config[pluginName].position=_model.plugins.config[pluginName].position.toString().toUpperCase()}}if(_model.plugins.config.controlbar&&playlistVisible){_model.plugins.config.controlbar.hideplaylistcontrols=true}if(typeof _model.plugins.config.dock!="undefined"){if(typeof _model.plugins.config.dock!="object"){var position=_model.plugins.config.dock.toString().toUpperCase();_model.plugins.config.dock={position:position}}if(typeof _model.plugins.config.dock.position!="undefined"){_model.plugins.config.dock.align=_model.plugins.config.dock.position;_model.plugins.config.dock.position=jwplayer.html5.view.positions.OVER}if(typeof _model.plugins.config.dock.idlehide=="undefined"){try{_model.plugins.config.dock.idlehide=_model.plugins.config.controlbar.idlehide}catch(e){}}}function _loadExternal(playlistfile){var loader=new jwplayer.html5.playlistloader();loader.addEventListener(jwplayer.api.events.JWPLAYER_PLAYLIST_LOADED,function(evt){_model.playlist=new jwplayer.html5.playlist(evt);_loadComplete(true)});loader.addEventListener(jwplayer.api.events.JWPLAYER_ERROR,function(evt){_model.playlist=new jwplayer.html5.playlist({playlist:[]});_loadComplete(false)});loader.load(playlistfile)}function _loadComplete(){if(_model.config.shuffle){_model.item=_getShuffleItem()}else{if(_model.config.item>=_model.playlist.length){_model.config.item=_model.playlist.length-1}else{if(_model.config.item<0){_model.config.item=0}}_model.item=_model.config.item}_model.position=0;_model.duration=_model.playlist.length>0?_model.playlist[_model.item].duration:0;_eventDispatcher.sendEvent(jwplayer.api.events.JWPLAYER_PLAYLIST_LOADED,{playlist:_model.playlist});_eventDispatcher.sendEvent(jwplayer.api.events.JWPLAYER_PLAYLIST_ITEM,{index:_model.item})}_model.loadPlaylist=function(arg){var input;if(typeof arg=="string"){if(arg.indexOf("[")==0||arg.indexOf("{")=="0"){try{input=eval(arg)}catch(err){input=arg}}else{input=arg}}else{input=arg}var config;switch(jwplayer.utils.typeOf(input)){case"object":config=input;break;case"array":config={playlist:input};break;default:config={file:input};break}_model.playlist=new jwplayer.html5.playlist(config);_model.item=_model.config.item>=0?_model.config.item:0;if(!_model.playlist[0].provider&&_model.playlist[0].file){_loadExternal(_model.playlist[0].file)}else{_loadComplete()}};function _getShuffleItem(){var result=null;if(_model.playlist.length>1){while(!jwplayer.utils.exists(result)){result=Math.floor(Math.random()*_model.playlist.length);if(result==_model.item){result=null}}}else{result=0}return result}function forward(evt){switch(evt.type){case jwplayer.api.events.JWPLAYER_MEDIA_LOADED:_container=_media.getDisplayElement();break;case jwplayer.api.events.JWPLAYER_MEDIA_MUTE:this.mute=evt.mute;break;case jwplayer.api.events.JWPLAYER_MEDIA_VOLUME:this.volume=evt.volume;break}_eventDispatcher.sendEvent(evt.type,evt)}var _mediaProviders={};_model.setActiveMediaProvider=function(playlistItem){if(playlistItem.provider=="audio"){playlistItem.provider="sound"}var provider=playlistItem.provider;var current=_media?_media.getDisplayElement():null;if(provider=="sound"||provider=="http"||provider==""){provider="video"}if(!jwplayer.utils.exists(_mediaProviders[provider])){switch(provider){case"video":_media=new jwplayer.html5.mediavideo(_model,current?current:_container);break;case"youtube":_media=new jwplayer.html5.mediayoutube(_model,current?current:_container);break}if(!jwplayer.utils.exists(_media)){return false}_media.addGlobalListener(forward);_mediaProviders[provider]=_media}else{if(_media!=_mediaProviders[provider]){if(_media){_media.stop()}_media=_mediaProviders[provider]}}return true};_model.getMedia=function(){return _media};_model.seek=function(pos){_eventDispatcher.sendEvent(jwplayer.api.events.JWPLAYER_MEDIA_SEEK,{position:_model.position,offset:pos});return _media.seek(pos)};_model.setVolume=function(newVol){_utils.saveCookie("volume",newVol);_model.volume=newVol};_model.setMute=function(state){_utils.saveCookie("mute",state);_model.mute=state};_model.setupPlugins=function(){if(!jwplayer.utils.exists(_model.plugins)||!jwplayer.utils.exists(_model.plugins.order)||_model.plugins.order.length==0){jwplayer.utils.log("No plugins to set up");return _model}for(var i=0;i<_model.plugins.order.length;i++){try{var pluginName=_model.plugins.order[i];if(jwplayer.utils.exists(jwplayer.html5[pluginName])){if(pluginName=="playlist"){_model.plugins.object[pluginName]=new jwplayer.html5.playlistcomponent(_api,_model.plugins.config[pluginName])}else{_model.plugins.object[pluginName]=new jwplayer.html5[pluginName](_api,_model.plugins.config[pluginName])}}else{_model.plugins.order.splice(plugin,plugin+1)}if(typeof _model.plugins.object[pluginName].addGlobalListener=="function"){_model.plugins.object[pluginName].addGlobalListener(forward)}}catch(err){jwplayer.utils.log("Could not setup "+pluginName)}}};return _model}})(jwplayer);(function(a){a.html5.playlist=function(b){var d=[];if(b.playlist&&b.playlist instanceof Array&&b.playlist.length>0){for(var c in b.playlist){if(!isNaN(parseInt(c))){d.push(new a.html5.playlistitem(b.playlist[c]))}}}else{d.push(new a.html5.playlistitem(b))}return d}})(jwplayer);(function(a){var c={size:180,position:a.html5.view.positions.NONE,itemheight:60,thumbs:true,fontcolor:"#000000",overcolor:"",activecolor:"",backgroundcolor:"#f8f8f8",font:"_sans",fontsize:"",fontstyle:"",fontweight:""};var b={_sans:"Arial, Helvetica, sans-serif",_serif:"Times, Times New Roman, serif",_typewriter:"Courier New, Courier, monospace"};_utils=a.utils;_css=_utils.css;_hide=function(d){_css(d,{display:"none"})};_show=function(d){_css(d,{display:"block"})};a.html5.playlistcomponent=function(r,C){var x=r;var e=a.utils.extend({},c,x.skin.getComponentSettings("playlist"),C);if(e.position==a.html5.view.positions.NONE||typeof a.html5.view.positions[e.position]=="undefined"){return}var y;var l;var D;var d;var g;var f;var k=-1;var h={background:undefined,item:undefined,itemOver:undefined,itemImage:undefined,itemActive:undefined};this.getDisplayElement=function(){return y};this.resize=function(G,E){l=G;D=E;if(x.jwGetFullscreen()){_hide(y)}else{var F={display:"block",width:l,height:D};_css(y,F)}};this.show=function(){_show(y)};this.hide=function(){_hide(y)};function j(){y=document.createElement("div");y.id=x.id+"_jwplayer_playlistcomponent";y.style.overflow="hidden";switch(e.position){case a.html5.view.positions.RIGHT:case a.html5.view.positions.LEFT:y.style.width=e.size+"px";break;case a.html5.view.positions.TOP:case a.html5.view.positions.BOTTOM:y.style.height=e.size+"px";break}B();if(h.item){e.itemheight=h.item.height}y.style.backgroundColor="#C6C6C6";x.jwAddEventListener(a.api.events.JWPLAYER_PLAYLIST_LOADED,s);x.jwAddEventListener(a.api.events.JWPLAYER_PLAYLIST_ITEM,v);x.jwAddEventListener(a.api.events.JWPLAYER_PLAYER_STATE,m)}function p(){var E=document.createElement("ul");_css(E,{width:y.style.width,minWidth:y.style.width,height:y.style.height,backgroundColor:e.backgroundcolor,backgroundImage:h.background?"url("+h.background.src+")":"",color:e.fontcolor,listStyle:"none",margin:0,padding:0,fontFamily:b[e.font]?b[e.font]:b._sans,fontSize:(e.fontsize?e.fontsize:11)+"px",fontStyle:e.fontstyle,fontWeight:e.fontweight,overflowY:"auto"});return E}function z(E){return function(){var F=f.getElementsByClassName("item")[E];var G=e.fontcolor;var H=h.item?"url("+h.item.src+")":"";if(E==x.jwGetPlaylistIndex()){if(e.activecolor!==""){G=e.activecolor}if(h.itemActive){H="url("+h.itemActive.src+")"}}_css(F,{color:e.overcolor!==""?e.overcolor:G,backgroundImage:h.itemOver?"url("+h.itemOver.src+")":H})}}function o(E){return function(){var F=f.getElementsByClassName("item")[E];var G=e.fontcolor;var H=h.item?"url("+h.item.src+")":"";if(E==x.jwGetPlaylistIndex()){if(e.activecolor!==""){G=e.activecolor}if(h.itemActive){H="url("+h.itemActive.src+")"}}_css(F,{color:G,backgroundImage:H})}}function q(J){var Q=d[J];var P=document.createElement("li");P.className="item";_css(P,{height:e.itemheight,display:"block",cursor:"pointer",backgroundImage:h.item?"url("+h.item.src+")":"",backgroundSize:"100% "+e.itemheight+"px"});P.onmouseover=z(J);P.onmouseout=o(J);var K=document.createElement("div");var G=new Image();var L=0;var M=0;var N=0;if(w()&&(Q.image||Q["playlist.image"]||h.itemImage)){G.className="image";if(h.itemImage){L=(e.itemheight-h.itemImage.height)/2;M=h.itemImage.width;N=h.itemImage.height}else{M=e.itemheight*4/3;N=e.itemheight}_css(K,{height:N,width:M,"float":"left",styleFloat:"left",cssFloat:"left",margin:"0 5px 0 0",background:"black",overflow:"hidden",margin:L+"px",position:"relative"});_css(G,{position:"relative"});K.appendChild(G);G.onload=function(){a.utils.stretch(a.utils.stretching.FILL,G,M,N,this.naturalWidth,this.naturalHeight)};if(Q["playlist.image"]){G.src=Q["playlist.image"]}else{if(Q.image){G.src=Q.image}else{if(h.itemImage){G.src=h.itemImage.src}}}P.appendChild(K)}var F=l-M-L*2;if(D<e.itemheight*d.length){F-=15}var E=document.createElement("div");_css(E,{position:"relative",height:"100%",overflow:"hidden"});var H=document.createElement("span");if(Q.duration>0){H.className="duration";_css(H,{fontSize:(e.fontsize?e.fontsize:11)+"px",fontWeight:(e.fontweight?e.fontweight:"bold"),width:"40px",height:e.fontsize?e.fontsize+10:20,lineHeight:24,"float":"right",styleFloat:"right",cssFloat:"right"});H.innerHTML=_utils.timeFormat(Q.duration);E.appendChild(H)}var O=document.createElement("span");O.className="title";_css(O,{padding:"5px 5px 0 "+(L?0:"5px"),height:e.fontsize?e.fontsize+10:20,lineHeight:e.fontsize?e.fontsize+10:20,overflow:"hidden","float":"left",styleFloat:"left",cssFloat:"left",width:((Q.duration>0)?F-50:F)-10+"px",fontSize:(e.fontsize?e.fontsize:13)+"px",fontWeight:(e.fontweight?e.fontweight:"bold")});O.innerHTML=Q?Q.title:"";E.appendChild(O);if(Q.description){var I=document.createElement("span");I.className="description";_css(I,{display:"block","float":"left",styleFloat:"left",cssFloat:"left",margin:0,paddingLeft:O.style.paddingLeft,paddingRight:O.style.paddingRight,lineHeight:(e.fontsize?e.fontsize+4:16)+"px",overflow:"hidden",position:"relative"});I.innerHTML=Q.description;E.appendChild(I)}P.appendChild(E);return P}function s(F){y.innerHTML="";d=t();if(!d){return}items=[];f=p();for(var G=0;G<d.length;G++){var E=q(G);E.onclick=A(G);f.appendChild(E);items.push(E)}k=x.jwGetPlaylistIndex();o(k)();y.appendChild(f);if(_utils.isIOS()&&window.iScroll){f.style.height=e.itemheight*d.length+"px";var H=new iScroll(y.id)}}function t(){var F=x.jwGetPlaylist();var G=[];for(var E=0;E<F.length;E++){if(!F[E]["ova.hidden"]){G.push(F[E])}}return G}function A(E){return function(){x.jwPlaylistItem(E);x.jwPlay(true)}}function n(){f.scrollTop=x.jwGetPlaylistIndex()*e.itemheight}function w(){return e.thumbs.toString().toLowerCase()=="true"}function v(E){if(k>=0){o(k)();k=E.index}o(E.index)();n()}function m(){if(e.position==a.html5.view.positions.OVER){switch(x.jwGetState()){case a.api.events.state.IDLE:_show(y);break;default:_hide(y);break}}}function B(){for(var E in h){h[E]=u(E)}}function u(E){return x.skin.getSkinElement("playlist",E)}j();return this}})(jwplayer);(function(b){b.html5.playlistitem=function(d){var e={author:"",date:"",description:"",image:"",link:"",mediaid:"",tags:"",title:"",provider:"",file:"",streamer:"",duration:-1,start:0,currentLevel:-1,levels:[]};var c=b.utils.extend({},e,d);if(c.type){c.provider=c.type;delete c.type}if(c.levels.length===0){c.levels[0]=new b.html5.playlistitemlevel(c)}if(!c.provider){c.provider=a(c.levels[0])}else{c.provider=c.provider.toLowerCase()}return c};function a(e){if(b.utils.isYouTube(e.file)){return"youtube"}else{var f=b.utils.extension(e.file);var c;if(f&&b.utils.extensionmap[f]){if(f=="m3u8"){return"video"}c=b.utils.extensionmap[f].html5}else{if(e.type){c=e.type}}if(c){var d=c.split("/")[0];if(d=="audio"){return"sound"}else{if(d=="video"){return d}}}}return""}})(jwplayer);(function(a){a.html5.playlistitemlevel=function(b){var d={file:"",streamer:"",bitrate:0,width:0};for(var c in d){if(a.utils.exists(b[c])){d[c]=b[c]}}return d}})(jwplayer);(function(a){a.html5.playlistloader=function(){var c=new a.html5.eventdispatcher();a.utils.extend(this,c);this.load=function(e){a.utils.ajax(e,d,b)};function d(g){var f=[];try{var f=a.utils.parsers.rssparser.parse(g.responseXML.firstChild);c.sendEvent(a.api.events.JWPLAYER_PLAYLIST_LOADED,{playlist:new a.html5.playlist({playlist:f})})}catch(h){b("Could not parse the playlist")}}function b(e){c.sendEvent(a.api.events.JWPLAYER_ERROR,{message:e?e:"Could not load playlist an unknown reason."})}}})(jwplayer);(function(a){a.html5.skin=function(){var b={};var c=false;this.load=function(d,e){new a.html5.skinloader(d,function(f){c=true;b=f;e()},function(){new a.html5.skinloader("",function(f){c=true;b=f;e()})})};this.getSkinElement=function(d,e){if(c){try{return b[d].elements[e]}catch(f){a.utils.log("No such skin component / element: ",[d,e])}}return null};this.getComponentSettings=function(d){if(c&&b&&b[d]){return b[d].settings}return null};this.getComponentLayout=function(d){if(c){return b[d].layout}return null}}})(jwplayer);(function(a){a.html5.skinloader=function(f,p,k){var o={};var c=p;var l=k;var e=true;var j;var n=f;var s=false;function m(){if(typeof n!="string"||n===""){d(a.html5.defaultSkin().xml)}else{a.utils.ajax(a.utils.getAbsolutePath(n),function(t){try{if(a.utils.exists(t.responseXML)){d(t.responseXML);return}}catch(u){h()}d(a.html5.defaultSkin().xml)},function(t){d(a.html5.defaultSkin().xml)})}}function d(y){var E=y.getElementsByTagName("component");if(E.length===0){return}for(var H=0;H<E.length;H++){var C=E[H].getAttribute("name");var B={settings:{},elements:{},layout:{}};o[C]=B;var G=E[H].getElementsByTagName("elements")[0].getElementsByTagName("element");for(var F=0;F<G.length;F++){b(G[F],C)}var z=E[H].getElementsByTagName("settings")[0];if(z&&z.childNodes.length>0){var K=z.getElementsByTagName("setting");for(var P=0;P<K.length;P++){var Q=K[P].getAttribute("name");var I=K[P].getAttribute("value");var x=/color$/.test(Q)?"color":null;o[C].settings[Q]=a.utils.typechecker(I,x)}}var L=E[H].getElementsByTagName("layout")[0];if(L&&L.childNodes.length>0){var M=L.getElementsByTagName("group");for(var w=0;w<M.length;w++){var A=M[w];o[C].layout[A.getAttribute("position")]={elements:[]};for(var O=0;O<A.attributes.length;O++){var D=A.attributes[O];o[C].layout[A.getAttribute("position")][D.name]=D.value}var N=A.getElementsByTagName("*");for(var v=0;v<N.length;v++){var t=N[v];o[C].layout[A.getAttribute("position")].elements.push({type:t.tagName});for(var u=0;u<t.attributes.length;u++){var J=t.attributes[u];o[C].layout[A.getAttribute("position")].elements[v][J.name]=J.value}if(!a.utils.exists(o[C].layout[A.getAttribute("position")].elements[v].name)){o[C].layout[A.getAttribute("position")].elements[v].name=t.tagName}}}}e=false;r()}}function r(){clearInterval(j);if(!s){j=setInterval(function(){q()},100)}}function b(y,x){var w=new Image();var t=y.getAttribute("name");var v=y.getAttribute("src");var A;if(v.indexOf("data:image/png;base64,")===0){A=v}else{var u=a.utils.getAbsolutePath(n);var z=u.substr(0,u.lastIndexOf("/"));A=[z,x,v].join("/")}o[x].elements[t]={height:0,width:0,src:"",ready:false,image:w};w.onload=function(B){g(w,t,x)};w.onerror=function(B){s=true;r();l()};w.src=A}function h(){for(var u in o){var w=o[u];for(var t in w.elements){var x=w.elements[t];var v=x.image;v.onload=null;v.onerror=null;delete x.image;delete w.elements[t]}delete o[u]}}function q(){for(var t in o){if(t!="properties"){for(var u in o[t].elements){if(!o[t].elements[u].ready){return}}}}if(e===false){clearInterval(j);c(o)}}function g(t,v,u){if(o[u]&&o[u].elements[v]){o[u].elements[v].height=t.height;o[u].elements[v].width=t.width;o[u].elements[v].src=t.src;o[u].elements[v].ready=true;r()}else{a.utils.log("Loaded an image for a missing element: "+u+"."+v)}}m()}})(jwplayer);(function(a){a.html5.api=function(c,p){var n={};var g=document.createElement("div");c.parentNode.replaceChild(g,c);g.id=c.id;n.version=a.version;n.id=g.id;var m=new a.html5.model(n,g,p);var k=new a.html5.view(n,g,m);var l=new a.html5.controller(n,g,m,k);n.skin=new a.html5.skin();n.jwPlay=function(q){if(typeof q=="undefined"){f()}else{if(q.toString().toLowerCase()=="true"){l.play()}else{l.pause()}}};n.jwPause=function(q){if(typeof q=="undefined"){f()}else{if(q.toString().toLowerCase()=="true"){l.pause()}else{l.play()}}};function f(){if(m.state==a.api.events.state.PLAYING||m.state==a.api.events.state.BUFFERING){l.pause()}else{l.play()}}n.jwStop=l.stop;n.jwSeek=l.seek;n.jwPlaylistItem=function(q){if(d){if(d.playlistClickable()){d.jwInstreamDestroy();return l.item(q)}}else{return l.item(q)}};n.jwPlaylistNext=l.next;n.jwPlaylistPrev=l.prev;n.jwResize=l.resize;n.jwLoad=l.load;n.jwDetachMedia=l.detachMedia;n.jwAttachMedia=l.attachMedia;function j(q){return function(){return m[q]}}function e(q,s,r){return function(){var t=m.plugins.object[q];if(t&&t[s]&&typeof t[s]=="function"){t[s].apply(t,r)}}}n.jwGetPlaylistIndex=j("item");n.jwGetPosition=j("position");n.jwGetDuration=j("duration");n.jwGetBuffer=j("buffer");n.jwGetWidth=j("width");n.jwGetHeight=j("height");n.jwGetFullscreen=j("fullscreen");n.jwSetFullscreen=l.setFullscreen;n.jwGetVolume=j("volume");n.jwSetVolume=l.setVolume;n.jwGetMute=j("mute");n.jwSetMute=l.setMute;n.jwGetStretching=function(){return m.stretching.toUpperCase()};n.jwGetState=j("state");n.jwGetVersion=function(){return n.version};n.jwGetPlaylist=function(){return m.playlist};n.jwAddEventListener=l.addEventListener;n.jwRemoveEventListener=l.removeEventListener;n.jwSendEvent=l.sendEvent;n.jwDockSetButton=function(t,q,r,s){if(m.plugins.object.dock&&m.plugins.object.dock.setButton){m.plugins.object.dock.setButton(t,q,r,s)}};n.jwControlbarShow=e("controlbar","show");n.jwControlbarHide=e("controlbar","hide");n.jwDockShow=e("dock","show");n.jwDockHide=e("dock","hide");n.jwDisplayShow=e("display","show");n.jwDisplayHide=e("display","hide");var d;n.jwLoadInstream=function(r,q){if(!d){d=new a.html5.instream(n,m,k,l)}setTimeout(function(){d.load(r,q)},10)};n.jwInstreamDestroy=function(){if(d){d.jwInstreamDestroy()}};n.jwInstreamAddEventListener=o("jwInstreamAddEventListener");n.jwInstreamRemoveEventListener=o("jwInstreamRemoveEventListener");n.jwInstreamGetState=o("jwInstreamGetState");n.jwInstreamGetDuration=o("jwInstreamGetDuration");n.jwInstreamGetPosition=o("jwInstreamGetPosition");n.jwInstreamPlay=o("jwInstreamPlay");n.jwInstreamPause=o("jwInstreamPause");n.jwInstreamSeek=o("jwInstreamSeek");function o(q){return function(){if(d&&typeof d[q]=="function"){return d[q].apply(this,arguments)}else{_utils.log("Could not call instream method - instream API not initialized")}}}n.jwGetLevel=function(){};n.jwGetBandwidth=function(){};n.jwGetLockState=function(){};n.jwLock=function(){};n.jwUnlock=function(){};function b(){if(m.config.playlistfile){m.addEventListener(a.api.events.JWPLAYER_PLAYLIST_LOADED,h);m.loadPlaylist(m.config.playlistfile)}else{if(typeof m.config.playlist=="string"){m.addEventListener(a.api.events.JWPLAYER_PLAYLIST_LOADED,h);m.loadPlaylist(m.config.playlist)}else{m.loadPlaylist(m.config);setTimeout(h,25)}}}function h(q){m.removeEventListener(a.api.events.JWPLAYER_PLAYLIST_LOADED,h);m.setupPlugins();k.setup();var q={id:n.id,version:n.version};l.playerReady(q)}if(m.config.chromeless&&!a.utils.isIOS()){b()}else{n.skin.load(m.config.skin,b)}return n}})(jwplayer)};

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {// Only override what shared/js/dialog.js didn’t already set

// default settings
$.ui.dialog.prototype.options.classes = {'ui-dialog': 'scs-pageheader-ui-dialog'};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery) {/**
 * (c) Copyright Swisscom (Schweiz) AG. All rights reserved.
 *
 * This product is the proprietary and sole property of Swisscom (Schweiz) AG
 * Use, duplication or dissemination is subject to prior written consent of
 * Swisscom (Schweiz) AG.
 *
 * $Id: mediaplayer.js
 */
(function($, w) {
	// We aren't using strict mode because of arguments.callee 
	// in external script load for YouTube player
	//'use strict'
	
	/*
	 * Put a flag and declare our space on portal
	 */
	$.namespace('SCS.mediaplayer');
	
	// Flag for classes
	SCS.mediaplayer.MASTER_CLASS = 'scs-media-player-';
	SCS.mediaplayer.CONTROL_CLASS = '.' + SCS.mediaplayer.MASTER_CLASS + 'control-';
	SCS.mediaplayer.MUTE_CLASS = SCS.mediaplayer.MASTER_CLASS + 'control-volume-mute';
	SCS.mediaplayer.IMAGES = '/etc/designs/portal/resources/mediaplayer/';
	
	
	/**
	 * Check if we are in IOS devices
	 * We need to check this because IOS doesn't allow mechanical click
	 * 
	 * @return $platform {integer} 1 for IOS devices or 0 for not
	 */
	SCS.mediaplayer.isIOS = function() {
		var $platform = navigator.platform.match(/(iPad|iPhone|iPod)/);
		return $platform && $platform != 'null' ? 1 : 0;
	};
	
	
	/**
	 * Helper function for play overlay on IOS devices
	 * 
	 * @param element {object} Player element
	 * 
	 * @return $play_button_element {object} Overlay play button element
	 */
	SCS.mediaplayer.playOverlay = function(element) {
		var $play_button_element = '';
		
		// Do we have a element
		if (typeof element === 'undefined') {
			return false;
		}
		
		// Check now for IOS devices and support for poinyter-events in css3 (all IOS devices have support, but we check just in case) 
		if(SCS.mediaplayer.isIOS() && ('pointerEvents' in document.body.style)) {
			
			// If everything is ok, finally create overlay image element
			$play_button_element = $('<img/>', {
				'class':SCS.mediaplayer.MASTER_CLASS+'ios-play',
				src: SCS.mediaplayer.IMAGES+'center-play.png',
				alt:'Play'
			}).appendTo(element);
		}

		return $play_button_element;
	};
	
	/**
	 * Animate event for controls
	 * 
	 * @param player_element {object} Player element
	 * param clear {Boolean} If true the animate event will be stop
	 */
	SCS.mediaplayer.ieToggleControls  = function(player_element, clear) {

		// Reset animated padding if cursor were hover over video
		if (clear) {
			player_element.animate({'padding-bottom': 0}, 'slow');
		} else {
			player_element.animate({'padding-bottom': 37}, 'slow');
		}
	};
	
	
	/**
	 * Everything that is relevant to full screen is processed here
	 * 
	 * @param document_body {object} Body document object
	 * @param player_element {object} Player element
	 * @param static_image {object} Image parent element
	 * @param static_image_parent {object} Video intro image
	 * @param fullscreen_button {object} Full screen button
	 * @param info {object} Info object with properties and state object and with clear, set and update function
	 * @param controller {object} Control object for player controls 
	 */
	SCS.mediaplayer.fullScreen = function(document_body, player_element, static_image, static_image_parent, fullscreen_button, info, controller) {
		var $player_width = 0, $player_height = 0;
				
		// Do we have a full screen button
		if (typeof fullscreen_button === 'undefined') {
			fullscreen_button = $(SCS.mediaplayer.CONTROL_CLASS + 'fullscreen', player_element);
		}
		
		// Check if we are in full screen mode
		if(info.properties.fullScreen) {
			info.clear('fullScreen');
			fullscreen_button.toggleClass(SCS.mediaplayer.MASTER_CLASS + 'control-smallscreen');
			document_body.toggleClass(SCS.mediaplayer.MASTER_CLASS + 'document-body');
			
			// Reset video image style
			if (info.image.presence) {
				
				// Check if we are working with JW player
				if (player_element.hasClass('playerType-jw')) {
					static_image = info.image.jw_intro;
					static_image_parent = info.image.jw_intro_parent;
					static_image.removeAttr('style');
					static_image_parent.removeAttr('style');
				}
				
				static_image.css({
					'width': '',
					'height': ''
				}).removeClass(SCS.mediaplayer.MASTER_CLASS + 'intro-image-width ' + SCS.mediaplayer.MASTER_CLASS + 'intro-image-height');
				
				// Reset image parent line-height
				static_image_parent.css('line-height', info.image.parent_height);
			}
			
			// Recalculate controls position
			controller.recalc();
			
		} else if(!info.properties.fullScreen && !info.state.videoLoading) {
			info.set('fullScreen');
			fullscreen_button.toggleClass(SCS.mediaplayer.MASTER_CLASS + 'control-smallscreen');
			document_body.toggleClass(SCS.mediaplayer.MASTER_CLASS + 'document-body');
			
			// Calculate the image position as opposed to video player
			if (info.image.presence) {
				
				// Recalculate image size and position
				SCS.mediaplayer.resizeFullScreenImage(player_element, static_image, static_image_parent, info);
			}
			
			// Recalculate controls position
			controller.recalc();
		}
	};
	
	
	/**
	 * Resize and reposition video intro image
	 * 
	 * @param player_element {object} Player element
	 * @param static_image {object} Video intro image
	 * @param static_image_parent {object} Video intro image
	 * @param info {object} Info object with properties and state object and with clear, set and update function
	 */
	SCS.mediaplayer.resizeFullScreenImage = function(player_element, static_image, static_image_parent, info) {
		var player_element_height = player_element.height();
		
		// Check if we are working with JW player
		if (player_element.hasClass('playerType-jw')) {
			static_image = info.image.jw_intro;
			static_image_parent = info.image.jw_intro_parent;
			static_image.removeAttr('style');
			static_image_parent.removeAttr('style');
		}
		
		// Reset image height, width and remove previous full screen classes
		static_image.css({
			'width': '',
			'height': ''
		}).removeClass(SCS.mediaplayer.MASTER_CLASS + 'intro-image-width ' + SCS.mediaplayer.MASTER_CLASS + 'intro-image-height');
		
		// Check which side of image to resize
		if ((player_element.width() / static_image.width()) < (player_element_height / static_image.height())) {
			static_image.addClass(SCS.mediaplayer.MASTER_CLASS + 'intro-image-width');
		} else {
			static_image.addClass(SCS.mediaplayer.MASTER_CLASS + 'intro-image-height');
		}
		
		// Set new image parent line-height
		static_image_parent.css('line-height', (player_element_height - 2) + 'px');
	};
	
	
	/**
	 * Listen for screen resize event in full screen mode
	 * 
	 * @param player_element {object} Player element
	 * @param info {object} Info object with properties and state object and with clear, set and update function
	 * @param static_image {object} Video intro image
	 * @param static_image_parent {object} Video intro image
	 * @param controller {object} Control object for player controls
	 */
	SCS.mediaplayer.fullScreenResize = function(player_element, info, static_image, static_image_parent, controller) {
		$(w).resize(function() {
			SCS.mediaplayer.fullScreenResizeChain(player_element, info, static_image, static_image_parent, controller);
		});
	};
	
	
	/**
	 * Chain function for full screen resize event
	 * 
	 * @param player_element {object} Player element
	 * @param info {object} Info object with properties and state object and with clear, set and update function
	 * @param static_image {object} Video intro image
	 * @param static_image_parent {object} Video intro image
	 * @param controller {object} Control object for player controls
	 */
	SCS.mediaplayer.fullScreenResizeChain = function(player_element, info, static_image, static_image_parent, controller) {
		
		// Check if are in full screen mode
		if (player_element.hasClass('fullScreen')) {
			
			// Recalculate image size and position
			if (info.image.presence) {
				SCS.mediaplayer.resizeFullScreenImage(player_element, static_image, static_image_parent, info);
			}
			
			// Recalculate controls position
			if (!info.properties.noToolbar) {
				controller.recalc();
			}
		}
	};
	
	
	/**
	 * Checks if flash is installed/enabled on the browser
	 * 
	 * @return hasFlash {boolean} True or false for flash player
	 */
	SCS.mediaplayer.isFlashEnabled = function() {
		var hasFlash = false;

		try {
			var fo = new ActiveXObject('ShockwaveFlash.ShockwaveFlash');
			if(fo) {
				hasFlash = true;
			}
		}

		catch(e) {
			if(navigator.mimeTypes["application/x-shockwave-flash"] !== undefined) {
				hasFlash = true;
			}
		}

		return hasFlash;
	};
	
	
	/**
	 * Main video controller
	 *
	 * @param controls {object} Children of scs-media-player-controls class
	 * @param callbacks {function} Player function in media player API
	 * @param info {object} Info object with properties and state object and with clear, set and update function
	 */
	SCS.mediaplayer.controller = function(controls, callbacks, info) {
		callbacks = callbacks || {};
		var $_this = this,
			$volume = controls.find(SCS.mediaplayer.CONTROL_CLASS + 'volume-control'),
			$progress = controls.find(SCS.mediaplayer.CONTROL_CLASS + 'progress'),
			$bar = controls.find(SCS.mediaplayer.CONTROL_CLASS + 'bar-body'),
			$buttons = {},
			$quiet = controls.find(SCS.mediaplayer.CONTROL_CLASS + 'volume-quiet'),
			$loud = controls.find(SCS.mediaplayer.CONTROL_CLASS + 'volume-loud'),
			
			// Get button element
			$button = function(name) {
				
				if(!$buttons[name]) {
					$buttons[name] = $bar.find(SCS.mediaplayer.CONTROL_CLASS + ''+name);
				}
				
				return {
					click: function(callback) {
						$buttons[name].click(callback);
					}
				};
			};
			
		// Hidden overlay for IE browsers, they put flash always on top in any mode
		if (w.ActiveXObject !== undefined && info.properties.playerType === 'youTube') {
			$('<div/>', {
				'class': SCS.mediaplayer.MASTER_CLASS + 'ie-overlay'
			}).insertBefore(controls);
		}
		
		this.timeIndex = (function(){
			var progressMeter = $progress.find(SCS.mediaplayer.CONTROL_CLASS + 'progress-meter'),
				timeMeter = controls.find(SCS.mediaplayer.CONTROL_CLASS + 'time'),
				total,
				percentage = 0,
				time = 0,
				previousTime;
	
			return {
				update: function(uiOnly, drag) {
					if(previousTime !== Math.floor(time)) {
						previousTime = Math.floor(time);
						var minutes = ''+Math.floor(time/60),
							seconds = ''+Math.floor(time%60);
							
						if(seconds.length < 2) {
							seconds = '0'+seconds;
						}
						
						timeMeter.text(''+minutes+':'+seconds);
						progressMeter.css('width', ''+percentage*100+'%');
						$_this.recalc(); //Recalc the bar’s dimensions because the time display might be larger
					}
					if(!uiOnly && callbacks.timeIndex) {
						callbacks.timeIndex(time);
					}
					return this;
				},
				
				setPercentage: function(percent) {
					if(total === undefined) {
						return this;
					}
					percentage = Math.min(Math.max(percent, 0), 100);
					time = Math.floor(total * percentage);
					return this;
				},
				
				setTime: function(timeIndex) {
					if(total === undefined) {
						return this;
					}
					time = timeIndex;
					percentage = time/total;
					return this;
				},
				
				setTotal: function(tot) {
					total = tot;
					return this;
				}
			};
		})();
				
		this.volume = (function() {
			var volumeMeter = $volume.find(SCS.mediaplayer.CONTROL_CLASS + 'volume-control-meter'),
				percentage = 1;
				
			return {
				update: function(drag) {
					volumeMeter.css('width', ''+(percentage*100)+'%');
					if(callbacks.volume) {
						callbacks.volume(percentage*100);
					}
					return this;
				},
				
				setPercentage: function(percent) {
					percentage = Math.min(Math.max(percent, 0), 100);
					return this.update();
				}
			};
		})();
	
		$progress.click(function(event) {
			var $x = event.pageX - $progress.offset().left + 2,
				$percentage = $x/$progress.width();
			$_this.timeIndex.setPercentage($percentage).update();
		});
		
		$volume.click(function(event) {
			var x = event.pageX - $volume.offset().left + 2,
				percentage = x/$volume.width();
			$_this.volume.setPercentage(percentage);
		});
		
		$button('volume-quiet').click(function() {
			$_this.volume.setPercentage(0);
			$(this).toggleClass(SCS.mediaplayer.MUTE_CLASS);
		});
		
		$button('volume-loud').click(function() {
			$_this.volume.setPercentage(1);
			if ($quiet.hasClass(SCS.mediaplayer.MUTE_CLASS)) {
				$quiet.removeClass(SCS.mediaplayer.MUTE_CLASS);
			}
		});
		
		$button('playpause').click(function() {
			if(callbacks.playPause) {
				callbacks.playPause();
			}
		});
		
		$button('fullscreen').click(function() {
			if(callbacks.fillScreen) {
				callbacks.fillScreen();
			}
		});
		
		var center_controls = controls.find(SCS.mediaplayer.CONTROL_CLASS + 'center').click(function() {
			if(info.state.finished) {
				return callbacks.restart && callbacks.restart();
			} else if(!info.state.videoLoading && callbacks.playPause) {
				callbacks.playPause();
			}
		});
		
		var $bar_holder = $bar.parent();
		
		this.recalc = function(barOnly) {
			controls.css('display', 'block');
			$bar_holder.css('display', 'block');
			
			if(!barOnly) {
				var playerHeight = (controls.parent().height() < parseInt(controls.parent().css('height'), 10)) ? parseInt(controls.parent().css('height'), 10) : controls.parent().height();
				controls.find(SCS.mediaplayer.CONTROL_CLASS + 'center').css('top', ''+(playerHeight/2)+'px');
			}
			
			var $bar_width = $bar.width(),
				$other_items = 0;
			
			$bar.children().each(function() {
				var element = $(this);
				if(this !== $progress[0]) {
					$other_items += element.outerWidth(true);
				} else {
					$other_items += parseInt(element.css('margin-left'), 10) + parseInt(element.css('margin-right'), 10) + parseInt(element.css('padding-left'), 10) + parseInt(element.css('padding-right'), 10);
				}
			});
			
			$bar_holder.css('display', '');
			controls.css('display', '');
			$progress.width($bar_width - $other_items - 5);
		};
		
		this.timeIndex.update(true);
		this.volume.update();
		
		/* Lets make things a little bit more interesting for the visitors
		 * If the UI is present in the document, they will be able to scroll video and change volume using mouse drag
		 * TO DO - This can be achieve also with pure jQuery 
		 */
		if (typeof $.ui.draggable == 'function') {
			var percentageUpdate = 0;
			
			// Video control
			$(SCS.mediaplayer.CONTROL_CLASS + 'progress-indicator', controls).draggable({
				axis: 'x',
				containment: $progress,
				drag: function() {
					percentageUpdate = $(this).position().left / $progress.width();
					if (percentageUpdate <= 0) {
						percentageUpdate = -0.014;
					}
					
					$_this.timeIndex.setPercentage(percentageUpdate + 0.015).update();
				},
				stop: function() {
					$(this).css('left', '');
				}
			});
			
			// Volume control
			$('.progress-indicator', $volume).draggable({
				axis: 'x',
				containment: $volume,
				drag: function() {
					percentageUpdate = $(this).position().left / $volume.width();
					if (percentageUpdate <= 0) {
						percentageUpdate = -0.16;
						$quiet.addClass(SCS.mediaplayer.MUTE_CLASS);
					} else {
						$quiet.removeClass(SCS.mediaplayer.MUTE_CLASS);
					}
					
					$_this.volume.setPercentage(percentageUpdate + 0.17).update();
				},
				stop: function() {
					$(this).css('left', '');
				}
			});
		}
	};
	
	
	/**
	 * Youtube player
	 *
	 * @param element {object} Player video container with intro image
	 * @param info {object} Info object with properties and state object and with clear, set and update function
	 * @param id {string} YouTube video ID
	 * @param static_image {object} Video intro image
	 * 
	 * @return $callbacks {object} Control player object with playPause, volume, timeIndex and restart functions
	 */
	SCS.mediaplayer.youTube = function(element, info, id, static_image) {
		
		var $player_element = element.parent(),
			$youtubePlaceholder = $('.scs-youtubePlaceholder', element),
			$staticImage_parent = static_image.parent(),
			$staticImageIframe = '',
			$play_button = SCS.mediaplayer.playOverlay($player_element),
			fun;
			
		// We manage the static image ourselves since there is no option for it
		if(!$staticImage_parent.length) {
			$staticImage = null;
			element.addClass('yt-no-staticImage');
		}
		
		// Time update functions
		var $player,
			$updater = (function() {
			var $timeIndexInterval = null,
				$updater = function() {
				info.updateTime($player.getCurrentTime(), $player.getDuration());
			};
			return {
				set: function() {
					this.clear();
					$timeIndexInterval = w.setInterval($updater, 1000);
					$updater();
				},
				clear: function() {
					if ($timeIndexInterval) {
						w.clearInterval($timeIndexInterval);
						$timeIndexInterval = null;
					}
				}
			};
		})();
		
		var $load = function() {
			
			$player = new YT.Player($youtubePlaceholder[0], {
				
				// Player vars
				height: '100%',
				width: '100%',
				videoId: id,

				playerVars: {
					autoplay: 0,
					controls: SCS.mediaplayer.isIOS(),
					enablejsapi: 1,
					modestbranding: 1,
					showinfo: 0,
					rel: 0,
					iv_load_policy: 3,
					wmode: 'transparent',
					origin: encodeURIComponent(w.location.protocol + '//' + w.location.host)
				},
				
				// Events
				events: {
					onReady: function() {
						w.player = $player;
						info.set('pausing');
						if(info.properties.autoPlay) {
							$player.playVideo();
						}
					},
					
					// State of video
					onStateChange: function(state) {
						
						switch(state.data) {
							
							// Paused
							case YT.PlayerState.PAUSED:
								$updater.clear();
								info.set('pausing');
								break;
							
							// Playing
							case YT.PlayerState.PLAYING:
								$updater.set();
								info.set('playing');
								
								$staticImage_parent.hide();

								if ($play_button) {
									$staticImage_parent.hide();
								}
								
								break;
								
							// Ended
							case YT.PlayerState.ENDED:
								$updater.clear();
								info.set('finished');
								
								if ($staticImage_parent) {
									if (!$player_element.hasClass('fullScreen')) {
										static_image.css('margin-top', info.image_top_margin);
									}
									
									$staticImage_parent.show();
								}
								
								if ($play_button) {
									$play_button.attr('src', SCS.mediaplayer.IMAGES + 'center-restart.png').show();
								}
								
								break;
							
							// Buffering
							case YT.PlayerState.BUFFERING:
								$updater.clear();
								info.set('videoLoading');
								
								if ($play_button) {
									$play_button.attr('src', SCS.mediaplayer.IMAGES + 'center-loading.gif').show();
								}
								
								break;
								
						} // Switch
					} // Status change
				} // Events
			}); // YT player
			
			// Since we are replacing placeholder we need to get new iframe element of player
			$youtubePlaceholder = $('.scs-youtubePlaceholder', element);
		}; // Load

		// Check for YouTube script and player function
		if(w.YT && YT.Player) {
			$load();
		} else {
			if(typeof w.onYouTubePlayerAPIReady != 'function') {
			
				w.onYouTubePlayerAPIReady = function() {
					$.each(arguments.callee.loaders, function(index, loader) { loader(); });
				};
				
				w.onYouTubePlayerAPIReady.loaders = [];
				var tag = document.createElement('script');
				tag.src = '//www.youtube.com/player_api';
				var firstScriptTag = document.getElementsByTagName('script')[0];
				firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
				
			}
			w.onYouTubePlayerAPIReady.loaders.push($load);
		}

		// Player functions callbacks
		var $callbacks = {
			playPause: function(mode) {
				if(mode === undefined) {
					mode = $player.getPlayerState();
					mode = (mode === undefined || mode === YT.PlayerState.PAUSED || mode === YT.PlayerState.ENDED || mode === -1 || mode === YT.PlayerState.CUED);
				}
				if(mode) {
					$player.playVideo();
				} else {
					$player.pauseVideo();
				}
				return this;
			},
			volume: function(volume) {
				$player.setVolume(volume);
				return this;
			},
			timeIndex: function(index) {
				$player.seekTo(index, true);
				return this;
			},
			restart: function() {
				$player.seekTo(0, true);
				$player.playVideo();
				return this;
			}
		};
		
		var $fun_callback_function = function(orig, fun) {
			$callbacks[fun] = function() {
					
				// Discard calls made before the player was ready
				if(!$player || !$player.playVideo) {
					return this;
				}
				return orig.apply(this, [].slice.call(arguments));
			};
		};
		
		for(fun in $callbacks) {
			if($callbacks.hasOwnProperty(fun)) {
				$fun_callback_function($callbacks[fun], fun);
			}
		}
		
		return $callbacks;
	};

	
	/**
	 * JW player
	 *
	 * @param element {object} Player video container with intro image
	 * @param info {object} Info object with properties and state object and with clear, set and update function
	 * @param url {string} Video URL
	 * @param static_image {object} Video intro image
	 * @param url {string} Video format
	 * 
	 * @return {object} Control player object with playPause, volume, timeIndex and restart functions
	 */
	SCS.mediaplayer.jw = function(element, info, url, static_image, format) {
		
		var levels = [],
			$playerId = element.attr('id'),
			$player = jwplayer($playerId), // This is stupid: why not be able to just pass the element? I guess LongTail have their reasons!
			$player_parent_element = element.parent(),
			$play_button = SCS.mediaplayer.playOverlay(element.parent()),
			$player_render_mode, $html5_video_element;
		
		// Lets create array for player
		levels.push({file: url, type: SCS.mediaplayer.mimeType(format)});
		
		// Because JW player limit child elements to parent size we need to over ride that (only for non IOS devices)
		if ($play_button) {
			$player_parent_element.addClass('jw-ios');
		} else {
			$player_parent_element.addClass('jw-fullscreen');
		}
		
		// Start JW player
		$player.setup({
			'id': $playerId,
			'controlbar.position': 'none',
			icons: false,
			image: static_image.attr('src'),
			'tracker.movie_id': $player_parent_element.data('tracker-movie-id'),
			'tracker.report_suite': $player_parent_element.data('tracker-reportsuite'),
			'tracker.catalogue': $player_parent_element.data('tracker-catalogue'),
			'tracker.category': $player_parent_element.data('tracker-category'),
			levels: levels,
			'plugins': '/etc/designs/portal/resources/player/plugins/Tracker.swf',
			
			modes: [
				{ type: 'html5' }
			],
			
			events: {
				onReady: function() {
					info.set('pausing');
					$html5_video_element = $('video', $player.container);
					$player_render_mode = $player.getRenderingMode();
					
					if(info.properties.autoPlay) {
						$player.play(true);
					}
					
					if (info.image.presence) {
						info.image.jw_intro_parent = $('div[id^=scs-media-player-scs-video][id$=_jwplayer_display]', $player.container);
						info.image.jw_intro = $('> img', info.image.jw_intro_parent);
						info.image.jw_intro_parent.removeAttr('style');
						info.image.jw_intro.removeAttr('style');
						info.image.jw_intro_parent.css('line-height', info.image.parent_height);
					} else if ($player_render_mode === 'html5' && !$html5_video_element.attr('src')) {
						
						// We are manually inserting video url in video element, 
						// because JW player remove it at the start and end of video?
						$html5_video_element.attr('src', url);
					}
					
					if ($play_button) {
						$player.playButtonSrc = $play_button.attr('src');
						$player.jwElementParent = $('#' + $playerId).parent();
					}
				},
				
				onPlay: function() {
					info.set('playing');
					if ($play_button) {
						$play_button.hide();
						$player.jwElementParent.removeClass('jw-ios');
					}
					
					if (info.image.presence) {
						info.image.jw_intro.attr('style', 'display: none !important;');
					}
				},
				
				onPause: function() {
					info.set('pausing');
					if ($play_button && $player.playButtonSrc) {
						$play_button.attr('src', $player.playButtonSrc).show();
					}
					
					if (info.image.presence) {
						info.image.jw_intro.attr('style', 'display: none !important;');
					}
				},
				
				onBuffer: function() {
					info.set('videoLoading');
					if ($play_button) {
						$play_button.attr('src', SCS.mediaplayer.IMAGES + 'center-loading.gif').show();
						$player.jwElementParent.removeClass('jw-ios');
					}
					
					if (info.image.presence) {
						info.image.jw_intro.attr('style', 'display: none !important;');
					}
				},
				
				onComplete: function() {
					info.set('finished');
					if ($play_button) {
						$play_button.attr('src', SCS.mediaplayer.IMAGES + 'center-restart.png').show();
					}
					
					if (info.image.presence) {
						info.image.jw_intro.removeAttr('style');
					}
					
					if ($player_render_mode === 'html5') {
					
						// Stupid, stupid, stupid, the JW remove source attribute 
						// from video after all events, hence show empty black screen!
						setTimeout(function() {
							if (!$html5_video_element.attr('src')) {
								$html5_video_element.attr('src', url);
							}
						}, 50);
					}
				},
				
				onTime: function(e) {
					info.updateTime(e.position, e.duration);
				}
			},
			
			width: '100%',
			height: '100%',
			volume: 100
		});
		
		return {
			playPause: function(mode) {
				$player.play(mode);
				return this;
			},
			volume: function(volume) {
				$player.setVolume(volume);
				return this;
			},
			timeIndex: function(index) {
				$player.seek(index);
				return this;
			},
			restart: function() {
				$player.seek(0);
				$player.play(true);
				return this;
			}
		};
	};
	
	
	/**
	 * Check input format and return corresponding mime type
	 *
	 * @param format {string} Video format
	 * 
	 * @return {string} Mime type of input string
	 */
	SCS.mediaplayer.mimeType = function(format) {
		var $mime_type;
		
		switch (format) {
			case 'mp4':
				$mime_type = 'video/mp4';
				break;
			case 'webm': 
				$mime_type = 'video/webm';
				break;
			case 'ogg':
			case 'ogv':
				$mime_type = 'video/ogg';
				break;
			case 'flv':
				$mime_type = 'video/x-flv';
				break;
			default: 
				$mime_type = false;
				break;
		}
		
		return $mime_type;
	};
	
	
	/**
	 * Media player API
	 * Extend jQuery in form of a plugin
	 * 
	 * @return player_element.data {object} Main media player object
	 */
	$.fn.mediaPlayer = function() {
		if(!this.length) {
			return null;
		}
		
		// Set vars for player
		var $document_body = $('body'),
			$player_element = this.eq(0),
			$autoPlay = $player_element.data('autoplay') === 'true',
			$static_image = $('img:first', $player_element),
			$static_image_parent,
			$staticImage_src = $static_image.attr('src'),
			$overlay = $player_element.children('.scs-media-player-controls'),
			$noFlashOverlay = $player_element.children('.' + SCS.mediaplayer.MASTER_CLASS + 'no-flash'),
			$noFlashSwfContainer = $noFlashOverlay.children('.' + SCS.mediaplayer.MASTER_CLASS + 'no-flash-swf-container'),
			$format = $player_element.attr('data-video-type'),
			$playerType = ($format === 'youtube' ? 'youTube' : 'jw'),
			$player = SCS.mediaplayer[$playerType],
			$controller, $callbacks;
		
		if($player_element.data('mediaPlayer')) {
			return $player_element.data('mediaPlayer');
		}
		
		var info = (function() {
			var properties = {fullScreen: false, noToolbar: false, autoPlay: $autoPlay, playerType: $playerType},
				state = {playing: false, videoLoading: false, finished: false, pausing: false},
				image = {presence: false},
				
				controls = {
					set: function(stateName, value) {
						value = value || true;
						var name;
						if(state[stateName] === undefined) {
							properties[stateName] = value;
						} else {
							for(name in state) {
								if(state.hasOwnProperty(name)) {
									state[name] = false;
									$player_element.removeClass(name);
								}
							}
							state[stateName] = value;
						}
						$player_element.addClass(stateName);
						return this;
					},
					
					clear: function(stateName) {
						if(state[stateName] === undefined) {
							properties[stateName] = false;
						} else {
							state[stateName] = false;
						}
						$player_element.removeClass(stateName);
						return this;
					},
					
					properties: properties,
					state: state,
					image: image
				};
			
			controls.set('videoLoading');
			return controls;
		})();
		
		// Set static images
		if ($static_image.length) {
			$static_image_parent = $static_image.parent();
			$static_image_parent_height = ($player_element.height() - 2) + 'px';
			
			// We are adding line-height in order to position image vertically middle
			$static_image_parent.css({
				'line-height': $static_image_parent_height
			});
			
			// Set image properties
			info.image.presence = true;
			info.image.parent_height = $static_image_parent_height;
		}

		// Initialize the player
		$player_element.addClass('playerType-' + $playerType);
		$callbacks = $player($player_element.children('.scs-media-player-content'), info, $player_element.data('video-url'), $static_image, $format);

		// Controller
		if (!SCS.mediaplayer.isFlashEnabled() && navigator.userAgent.toLowerCase().indexOf('firefox') != -1) {
			$overlay.remove();
			$noFlashOverlay.show();
			$noFlashSwfContainer.html('<object height="0" width="0"><embed src="/etc/designs/portal/resources/player/so_redirect.swf" type="application/x-shockwave-flash" height="0" width="0"/></object>');
			info.set('noToolbar');
		} else if('ontouchstart' in w) {
			$overlay.remove();
			info.set('noToolbar');
		} else {
			$controller = new SCS.mediaplayer.controller($overlay, $callbacks, info);
		}
				
		// Check for window resize in full screen mode
		SCS.mediaplayer.fullScreenResize($player_element, info, $static_image, $static_image_parent, $controller);
		
		// Update play time
		info.updateTime = function(current, total) {
			if (!info.properties.noToolbar) {
				$controller.timeIndex.setTotal(total).setTime(current).update(true);
			}
		};
		
		// Full screen
		$callbacks.fillScreen = function(fullscreen_button) {
			
			// Process full screen event
			if (!info.properties.noToolbar) {
				SCS.mediaplayer.fullScreen($document_body, $player_element, $static_image, $static_image_parent, fullscreen_button, info, $controller);
			}
			
			return this;
		};
		
		// Bind some key events for current document
		$(document).on('keydown', function(event) {
			if(info.properties.fullScreen) {
				if(event.keyCode === 32) {
					$callbacks.playPause();
					return false;
				} else if (event.keyCode === 27) {
					$callbacks.fillScreen();
					return false;
				}
			}
		});

		// Set player data
		$player_element.data('mediaPlayer', {callbacks: $callbacks, controller: $controller, info: info});
		return $player_element.data('mediaPlayer');
	};
})(jQuery, window);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery) {jQuery(function() {
	jQuery('[data-video-box]').each(function() {
		var wind = jQuery(window);
		var element = jQuery(this);
		var container = element.parent();
		var box = jQuery('#'+element.attr('data-video-box')).appendTo(document.body).hide();
		var lightbox = container.parent().find('.lightbox');
		var player_element = box.find('.scs-media-player');
		var player = player_element.mediaPlayer();
		element.find('a.VideoLink, a.roundarrow').on('click', function() {
			lightbox.show();
			var width = parseInt(player_element.css('width'), 10) || 400;
			var height = parseInt(player_element.css('height'), 10) || (width*3/4);
			var padding = 2 * 44;
			box.css({left: (wind.width() - width - padding)/2 + "px", top: (wind.height() - height - padding)/2 + wind.scrollTop() + "px"}).show();
			player_element.css({width: width+'px', height: height+'px'});
			container.addClass("openvideo");
			player.callbacks.playPause(true);
			player.controller.recalc();
			return false;
		});
		lightbox.add(box.find('.closeme')).on('click', function() {
			player.callbacks.playPause(false);
			lightbox.hide();box.hide();
			container.removeClass("openvideo");
			return false;
		});
	});
});

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {/**
 * (c) Copyright Swisscom (Schweiz) AG. All rights reserved.
 *
 * This product is the proprietary and sole property of Swisscom (Schweiz) AG
 * Use, duplication or dissemination is subject to prior written consent of
 * Swisscom (Schweiz) AG.
 *
 * $Id: tracking.js
 */
$.namespace('SCS.tracking');

/**
 * Track page views when some of the content is changing,
 * e.g. when replacing content with AJAX responses
 */
SCS.tracking.trackPartialPageView = function (tabname) {
	SCS.portal.datalayer.pushPagePath(tabname, true);
	SCS.portal.datalayer.trackPageView();
	SCS.portal.datalayer.popPagePath();
};

/**
 * Setting pageName suffixed with tabname for landing tab
 */
SCS.tracking.setLandingTabName = function (tabname) {
	SCS.portal.datalayer.pushPagePath(tabname, true);
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_Tc_dot_$) {/**
 * (c) Copyright Swisscom (Schweiz) AG. All rights reserved.
 *
 * This product is the proprietary and sole property of Swisscom (Schweiz) AG
 * Use, duplication or dissemination is subject to prior written consent of
 * Swisscom (Schweiz) AG.
 *
 * $Id: common.js
 */
(function ($, SCS) {
	'use strict';

	SCS.portal = SCS.portal || {};

	SCS.portal.emailRegExp = /^[^@]+([@]{1})[0-9a-zA-Z\\._-]+([\\.]{1})[0-9a-zA-Z\\._-]+$/;

	SCS.portal.lang = $('html').attr('lang'); // deprecated
	SCS.portal.i18n = {}; // deprecated

	/**
	 * APPLY AFTER EFFECTS:
	 * This method applies all after-effects.
	 * It styles drop-downs, checkboxes and radio buttons.
	 * It adds arrows to links.
	 * IMPORTANT: For each after-effect function it's important to remove the CSS class after the effect
	 * has been applied - this way, you can execute this function multiple times and don't break already
	 * created effects (necessary for authoring).
	 */
	SCS.portal.applyAfterEffects = function (componentName) {
		if (!window.CQ) {
			return;
		}
		var js = $('.authorstyling');
		var component = js.closest('.' + componentName);
		if (!component.length) {
			component = js.parent();
		}
		js.remove();
		js = null;
		SCS.ensure(component);
	};

	/**
	 * Prefill old forms from hash tags
	 * @deprecated
	 */
	SCS.portal.prefillFormFromHash = function () {
		var queryStringArray = location.hash.substr(1).split('&');
		var paramValueArray = {};
		if (queryStringArray) {
			for (var i = 0; i < queryStringArray.length; i += 1) {
				var paramValue = queryStringArray[i].split('=');
				paramValueArray[paramValue[0]] = paramValue[1];
			}
		}
		return paramValueArray;
	};

	/**
	 * Validate simple old form
	 * @param form Form
	 * @deprecated
	 */
	SCS.portal.validateSimpleForm = function (form) {
		var hasError = false;
		form.find('.headingError').hide();
		form.find('input:not([type=button]):not([type=submit]), textarea, select').each(function () {
			var row = $(this).closest('.field');
			row.removeClass('error');
			row.find('span.error').hide();
			row.find('input').removeClass('invalid invalid--inline').addClass('valid').removeAttr('style'); // SDX input field
		});
		form.find('input:not([type=button]):not([type=submit]), textarea, select').each(function () {
			var $this = $(this);
			var row = $this.closest('.field');
			var value = $this.val();
			var regexp = $this.data('regexp');
			if (value === '') {
				hasError = true;
				SCS.portal.showSimpleError(row);
			} else if (regexp && regexp !== '') {
				var valid = false;

				value = value.replace(/(\r\n|\n|\r)/gm, ' ');

				var t = (new RegExp(regexp, 'm')).exec(value);
				if (t) {
					var len = value.length;
					var pattlen = t[0].length;
					valid = (pattlen === len);
				}
				if (!valid) {
					hasError = true;
					SCS.portal.showSimpleError(row);
				}
			}
		});
		if (hasError) {
			form.find('.headingError').show();
		}
		return hasError;
	};

	SCS.portal.showSimpleError = function (row) {
		row.addClass('error');
		row.find('span.error').show();
		row.find('input').addClass('invalid invalid--inline'); // SDX input field
		if (window.debug) {
			window.debug.log('SCS.portal.showSimpleError', row.find('input').attr('name'));
		}
	};

	/**
	 * This function displays error messages in a dialog. If no parameter is passed to it, a general message is displayed.
	 */
	SCS.portal.showError = function (msg, title) {
		var debugMode = $('body').hasClass('cq_isPreviewMode') || $('body').hasClass('cq_isAuthorMode');
		if (!msg || !debugMode) {
			var generalErrorMessageData = $(document.body).data('generalErrorMessage');
				msg = generalErrorMessageData.length ? generalErrorMessageData : 'An unknown error occured.';
		}
		if (!title) {
			var generalErrorTitleData = $(document.body).data('generalErrorTitle');
			title = generalErrorTitleData.length ? generalErrorTitleData : 'Error';
		}
		$('<div>' + msg + '</div>').dialog({
			title: title,
			classes: {'ui-dialog': 'error'}
		});
	};

	/**
	 * Find teasers in different containers and synchronize their heights (based on sub-containers)
	 * (by default all predefined teasers are synched BUT one can define two parameters to only sync specific teasers)
	 */
	SCS.portal.synchronizeTeaserHeights = function (containerSelector, teaserSelector, scope) {
		// jshint loopfunc: true
		scope = scope ? scope : $('body');
		teaserSelector = containerSelector && teaserSelector && containerSelector.length && teaserSelector.length ?
			[[containerSelector, teaserSelector]] :
			[
				['.columncontainer', '.priceteaser'],
				['.columncontainer', '.alignedTeaser']
			];

		for (var n = 0; n < teaserSelector.length; n += 1) {
			scope.find(teaserSelector[n][0]).each(function () {
				var $ul = $(this);
				var $teaser = $ul.find(teaserSelector[n][1]);
				// find the teaser which has the most child elements
				var $refTeaser = $teaser.filter(':first');
				$teaser.each(function () {
					var $this = $(this);
					if ($this.children().length > $refTeaser.children().length) {
						$refTeaser = $this;
					}
				});
				var hiddenTeasers = $teaser.filter('.scs-accordion-tab-panel:hidden');
				var hiddenParents = $teaser.parents('.scs-accordion-tab-panel:hidden');
				hiddenTeasers.show();
				hiddenParents.show();
				$refTeaser.children().each(function (i) {
					i += 1;
					var $this = $(this);
					if (!$this.is('.clear')) {
						var height = 0;
						var nThChildren = $teaser.children(':nth-child(' + i + ')');
						if ($this.css('display') === 'inline') {
							nThChildren.css('display', 'block');
						}
						nThChildren.each(function () {
							var $this = $(this);
							// taagrma7: changed from height to min-height, since using height directly
							// would not allow us to decrease the size after the initial run, if we
							// remove some content dynamically. But we also want to respect any intialy
							// set height via inline styles, so we need to use another property.
							height = Math.max(height, $this.css('min-height', '').height());
						});
						nThChildren.css('min-height', height);
					}
				});
				hiddenParents.hide();
				hiddenTeasers.hide();
			});
		}
	};

	/**
	 * Synchronize heights of given node collection with the same logic as synchronizeTeaserHeights
	 * (means we synch the height of each and every child inside the nodes found in the collection)
	 */
	SCS.portal.synchronizeHeights = function ($teaser) {
		var nodes = [],
			$hiddens = $(),
			maxNodes = 0;

		var i, L, n;

		// do nothing with only one item
		if ($teaser.length < 2) { return; }

		for (i = 0, L = $teaser.length; i < L; i+=1) {
			var $children = $teaser.eq(i).children();
			if ($children.length) {
				nodes.push($children);
			}
			if (maxNodes < $children.length) {
				maxNodes = $children.length;
			}
		}

		// process all parents (including ourself)
		var $parents = $teaser.add($teaser.parents());
		// find and show all hiddent parent nodes
		// needed to measure the actual node height
		for (i = 0, L = $parents.length; i < L; i+=1) {
			// get the parent jquery node
			var $parent = $parents.eq(i);
			// only process items with hide declaration
			if ($parent.css('display') === 'none') {
				// store old style attribute to restore it later
				$parent.data('old-display', $parent.attr('display') || '');
				$parent.data('old-style', $parent.attr('style') || '');
				// show the child and add to array for later
				$hiddens = $hiddens.add($parent.css('display', 'block'));
			}
		}

		for (i = 0; i < maxNodes; i+=1) {
			var maxHeight = 0;
			for (n = 0; n < nodes.length; n+=1) {
				if (nodes[n].length < i) {
					continue;
				}
				var $node = nodes[n].eq(i);
				$node.css('min-height', '');
				var height = $node.height();
				if (height > maxHeight) {
					maxHeight = height;
				}
			}
			if (!maxHeight) {
				continue;
			}
			for (n = 0; n < nodes.length; n+=1) {
				if (nodes[n].length >= i) {
					nodes[n].eq(i).css('min-height', maxHeight);
				}
			}
		}

		// hide everything again (use previous display value)
		for (i = 0, L = $hiddens.length; i < L; i+=1) {
			var $hidden = $hiddens.eq(i);
			// may has only been hidden by class and not inline styles
			$hidden.css('display', $hidden.data('old-display'))
				.attr('style', $hidden.data('old-style'));
		}
	};

	/**
	 * Initialize paging
	 * @param nextButton Next button
	 * @param items Items
	 */
	SCS.portal.initPaging = function (nextButton, items) {
		if (nextButton.length > 0 && items.length > 0) {
			var itemsPerPage = parseInt(nextButton.data('items-per-page'), 10);
			if (itemsPerPage === -1 || items.length === itemsPerPage) {
				return; // break if all items should be displayed
			}

			// if the next page already shows all items
			if (itemsPerPage + itemsPerPage >= items.length) {
				nextButton.val(nextButton.data('button-text-all'));
			}

			nextButton.click(function () {
				var $this = $(this);
				items.filter(':hidden').filter(':lt(' + itemsPerPage + ')').show();
				if (items.filter(':hidden').length <= 0) {
					nextButton.parent().hide();
				}
				else if (items.filter(':visible').length + itemsPerPage >= items.length) {
					$this.val($this.data('button-text-all'));
				}
			});
		}
	};

	/**
	 * Initialize image maps tool tips (call outs)
	 */
	SCS.portal.initImageMapCallouts = function () {
		$('.imageContainer img, area').qtip();
	};

	SCS.portal.tplToString = function (tplEl) {
		return $(tplEl).wrap('<span />').parent().html();
	};

	/**
	 * Initialize common stuff
	 */

	/* Repeated inits (using ensure) */

	// Apply custom input (radio buttons and checkboxes) styling
	SCS.ensure(function (context) {
		// the customInput function is already safe to execute multiple times
		context.find('input[type=checkbox]:not(.sdx), input[type=radio]:not(.sdx)').customInput();
	});

	// Apply drop down after effects
	SCS.ensure(function (context) {
		context.find('.customDropDown').sSelect();
	});

	// FIXME: still used?
	// Apply media player stuff
	SCS.ensure(function (context, $) {
		context.find('.scs-media-player').each(function () {
			var staticImage = $(this).find('.scs-media-player-content img');
			var staticImageSrc = staticImage.attr('src');
			if (staticImageSrc && staticImageSrc.match(/^[/][/]/)) {
				// add the current pages protocol, as workaround for a jwplayer bug
				var protocol = location.href.match(/^https?/);
				staticImage.attr('src', protocol + ':' + staticImageSrc);
			}
			$(this).mediaPlayer();
		});
	});

	// Apply arrows on links
	SCS.ensure(function (context) {
		// wrap links with div
		var links = context.find('a.arrow')
			.add(context.find('a').has('span.alternative-action-link', 'span.alternative-action-link-large', 'span.arrowLink'))
			.add(context.find('span.alternative-action-link a', 'span.alternative-action-link-large a', 'span.arrowLink a'));

		links.removeClass('arrow').wrap('<div class="scs-primary-link" />');
		context.find('span.alternative-action-link').removeClass('alternative-action-link');
		context.find('span.alternative-action-link-large').removeClass('alternative-action-link-large').addClass('action-link-large');
		context.find('span.arrowLink').removeClass('arrowLink');
	});

	// FIXME: still used? replace with modern CSS
	// Initialize definition lists
	SCS.ensure(function (context) {
		// set a class on the first dt and dd pair in the list
		context.find('dl').find('dt:first, dd:first').addClass('first-child');
	}, 'body, .ui-tabs-panel, .ui-dialog-content');

	// @deprecated
	// Prefill old forms from cookies or hash
	SCS.ensure(function (context, $) {
		$('form', context).has('input[name=":formid"]').each(function () {
			var $form = $(this),
				formName = $form.find('input[name=":formid"]').val(),
				prefillCookie = $.parseJSON($.cookie('SCSPrefillForm_' + formName) || 'null'),
				prefillFields = prefillCookie;

			if (!prefillFields && !$form.parent().hasClass('modScForm')) {
				// try to read from the request (with hash tag)
				prefillFields = SCS.portal.prefillFormFromHash();
			}

			if (prefillFields) {
				$.each(prefillFields, function (idx, val) {
					$('[name="' + idx + '"]', $form).val(val).trigger('change');
				});
			}

			if (prefillCookie) {
				// Clear the cookie
				$.cookie('SCSPrefillForm_' + formName, null, {path: '/', domain: '.swisscom.ch'});
			}
		});
	}, 'body, .ui-tabs-panel, .ui-dialog-content');


	// Initialize "Link target: Lightbox" links with HTML page inside
	var openLightbox = function (event) {
		event.preventDefault();
		var $this = $(this),
			url = $this.attr('href'),
			// default: 600x400 ; minimal: 300x100
			lightboxWidth = Math.max($this.data('lightbox-width') || 600, 300),
			lightboxHeight = Math.max($this.data('lightbox-height') || 400, 100),
			classname = '',
			lightboxClosed = function () {
				window.SCS.HashDeepLink.set('lightbox');
				$this.focus(); // restore focus after closing the lightbox
			},
			isExternalUrl = SCS.utils.isExternalUrl && SCS.utils.isExternalUrl(url);

		// allow deeplinking to this lightbox (for opening the deeplinks search for "##jumpMarker-lightboxDeeplinkOpen##" in the code)
		window.SCS.HashDeepLink.set('lightbox', 'sel:[target="lightbox"][href="' + url + '"]');

		//only the content without header and footer, also skip stage by showing first parsys only
		// in case the link has a print selector the link is shown in an iframe
		if (!isExternalUrl && !url.match(/\.print\./)) {
			$.get(url, function (data) {
				var $html = $(data);
				var titleSelectors = ['.content h1', '.modTitle', '#scs-pagetitle'];
				// Detach the content first so that we only search for the title in parts of the DOM that are not included
				var $content = $html.find('.content > div.parsys').detach();
				var $title;
				for(var i = 0; i < titleSelectors.length; i += 1) {
					var sel = titleSelectors[i]+':first';
					$title = $html.filter(sel).add($html.find(sel)).first();
					if($title.length) {
						break;
					}
				}
				var title = $.trim($title.text());

				// reconstruct page structure because a lot of css is based on that
				$content = $content.wrap('<div class="middle fake"><div class="content fake" /></div>');

				// create and open dialog
				$content.addClass('ui-dialog-lightbox-content').dialog({
					classes: {'ui-dialog': 'ui-dialog-lightbox' + (title === '' ? ' no-title' : '')},
					width: lightboxWidth,
					height: lightboxHeight,
					title: title,
					open: function () {
						// initialize newly added content, override selector-specific ensure listeners
						SCS.ensure($content, false);
						// adjust carousel arrows when brightcove players are initialized
						$content.on('brightcove.playerloaded', function () {
							$content.find('.carouselContainer').each(function () {
								SCS.carousel.adjustArrowNavigationPosition($(this).scCarousel());
							});
						});

						// jshint camelcase: false
						// OSO-464 automatic overlay tracking
						if (SCS.portal && SCS.portal.datalayer && SCS.portal.datalayer.pushPagePath) {
							var href = $this.attr('href'),
								name = href.substr(href.lastIndexOf('/')),
								overlayName = name.split('/').pop().replace('.html', '');
							SCS.portal.datalayer.pushPagePath(overlayName);
							SCS.portal.datalayer.trackPageView();
							SCS.portal.datalayer.popPagePath();
						}
					},
					close: function () {
						$('.ui-dialog-lightbox-content').remove();
						lightboxClosed();
					}
				});
			});
		} else {
			$.colorbox({
				href: url,
				iframe: true,
				width: lightboxWidth,
				height: lightboxHeight,
				className: classname,
				onClosed: lightboxClosed
			});
		}
	};
	SCS.ensure(function (context) {
		context.find('a[target="lightbox"]:not([data-handler-attached])').on('click', openLightbox).attr('data-handler-attached', 'true');
	}, 'body, .ui-tabs-panel, .ui-dialog-content, .modTabNavigationContent');


	// empty all hrefs on a page when using the .nolinks selector or #nolinks hash
	(function () {
		var
			path = document.location.pathname.split('/'),
			pageName = path[path.length - 1];

		if((window.location.hash.search('nolinks') !== -1) || (pageName.search('.nolinks') !== -1)) {
			SCS.ensure(function($ctx) {
				// jshint scripturl: true
				$ctx.find('*[href]').attr('href', 'javascript:;');
			});
		}
	})();

	/* One-time inits (on load) */

	$(window).on('load', function() {
		// synch teaser heights when the window is loaded because images without fix height could make a resizeing of the teasers necessary
		SCS.portal.synchronizeTeaserHeights();
		$('body').trigger('sync-heights');
	});

	/* One-time inits (on ready) */

	$(document).ready(function () {
		SCS.portal.initImageMapCallouts();

		// developmental feature: add “&wcmmode=disabled&endless” to your URL will make navigation on the website easier in author-mode
		var $body = $(document.body), hasEndless, isMobile;
		function addEndlessToLinks(context, $) {
			context.find('a[href]:not([href^="http"]):not([href^="javascript:"]):not([href^="#"]):not([href^="mailto:"])').each(function () {
				var $a = $(this);
				if(hasEndless && $a.attr('href').indexOf('&endless') === -1) {
					$a.attr('href', SCS.portal.addParamToUrl($a.attr('href'), 'wcmmode', 'disabled', 'endless', null));
				}
				if(isMobile && $a.attr('href').indexOf('.mobile.html') === -1) {
					$a.attr('href', $a.attr('href').replace('.html', '.mobile.html'));
				}
			});
		}
		if($body.is('.cq_isAuthorInstance') && ($body.is('.cq_isPreviewMode') || $body.is('.cq_isPublishMode'))) {
			hasEndless = window.location.href.indexOf('&endless') > 0;
			isMobile = $('body').is('.is-mobile');
			if(hasEndless || isMobile) {
				SCS.ensure(addEndlessToLinks);
				addEndlessToLinks($body, $);
			}
		}
	});

	/* Overwrite stuff */

	// Overwrite zIndex() function of jQuery to work around crappy implementation of the jQuery.UI.Dialog
	(function () {
		var originalFunction = $.fn.zIndex;

		$.fn.zIndex = function () {
			var value = originalFunction.apply(this, arguments),
				dialogContent = this.closest('.ui-dialog-content'),
				dialogContentZindex = (dialogContent.length ? originalFunction.call(dialogContent) : 0);

			if (dialogContent.length && !isNaN(value) && value < dialogContentZindex) {
				value += dialogContentZindex;
			}

			return value;
		};
	})();
})(__webpack_provided_window_dot_Tc_dot_$, window.SCS = window.SCS || {});

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery) {(function ($) {

	'use strict';
	/* globals jQuery */

	var defaults = {
		selectors: {
			gridLayout: '>.gridlayout',
			gridPanels: '>.modGridLayout>.column',
			prevButton: '.carousel-prev',
			nextButton: '.carousel-next',
			pagerItems: '.carousel-control > a',
			clip: '.carousel-clip',
			list: 'ul.carousel-list',
			listItems: ''								// optional, by default the direct children of the list are taken
		},
		pagerItemsActiveCls: 'selected',
		noItemsCls: 'noScrolling',
		disabledButtonCls: 'disabled',
		slideGridRows: true,
		animation: {
			duration: 'normal',
			easing: 'swing'
		}
	};

	/**
	 * Dynamic opacity gradient against background
	 *
	 * draw an opacity gradient to the foreground that will
	 * look like the actual content gets faded out against
	 * the actual background. Currently only images and solid
	 * colors are implemented (solid color can alternatively
	 * be handled in pure css, if you never have bg images).
	 *
	 * @author Marcel Greter
	 * @namespace local
	 * @class OpacityGradient
	 */
	function OpacityGradient(el, ct, conf) {

		/* jshint maxstatements: 40 */
		this.canvas = $('<canvas>');
		this.context = this.canvas[0].getContext('2d');

		// canvas not supported?
		if (!this.context) { return; }

		this.el = $(el);

		this.config = $.extend({}, {
			// selectors return in document order and we use the last one!
			pageBgSelector: '.full-height-background, .scs-stage-flat, BODY',
			gridColSelector: '>ul.carousel-list>:first>.gridlayout>.modGridLayout>.column'
		}, conf);

		this.el.css({
			position: 'relative'
		});

		// get parent node for outer content area
		this.ct = ct;
		var width = this.ct.width() - this.el.width();
		var height = this.el.outerHeight() * 5;

		this.canvas[0].width = width;
		this.canvas[0].height = height;

		// currently the fade-out is always right aligned and size tells us how wide it will be
		// query cols of the first grid layout to determine the size (if not explicitly given)
		this.size = this.config.size || (1 / $(this.config.gridColSelector, this.el).length);

		// get one element that has a background defined
		var bgEl = $(this.config.pageBgSelector),
		    bgUrl = $(bgEl.last()).css('background-image'),
		    bgCol = $(bgEl.last()).css('background-color');
		this.bgImg = $(bgEl.last()).find('>IMG');
		// we do not support stage areas areas with streched background
		if ($('>.scs-stage-flat-inner>IMG', bgEl.last()).length) { return; }

		// try to extract the src url for the background-image
		var urlMatch = /^\s*url\(([\'\"]?)(.*?)\1\)/.exec(bgUrl);
		if (urlMatch && urlMatch.length > 1) { bgUrl = urlMatch[2]; }
		// handle findings and attach to object
		if (bgUrl == 'none') { bgUrl = null; }
		if (bgCol) { this.color = bgCol; }
		if (bgUrl || this.bgImg.length) { this.image = new Image(); }
		if (this.image) { this.image.src = bgUrl || this.bgImg.attr('src'); }

		// add canvas element to the dom
		this.wrapper = $('<div>');
		this.wrapper.css({
			top: 0,
			bottom: 0,
			right: 0,
			width: width,
			overflow: 'hidden',
			position: 'absolute',
			'pointer-events': 'none'
		});
		this.wrapper.append(this.canvas);

		// will wait for image to be loaded
		var renderer = $.proxy(this.render, this);

		if (this.image) {
			// wait for bg-image to be loaded
			if (this.image.complete) { renderer(); }
			else { this.image.onload = renderer; }
		} else if (this.color) {
			// render color right away
			renderer();
		}

		// hook into window resize event
		$(window).resize(renderer);

		this.el.append(this.wrapper);

	}

	// declare class methods
	(function (proto) {

		// main render function
		// image must already be loaded
		proto.render = function render() {

			var width = this.ct.width() - this.el.width();
			var height = this.el.outerHeight() * 5;

			var canvas = this.canvas[0];
			var context = this.context;
			var offPos = this.el.offset();
			if (this.bgImg.length) {
				var imgOff = this.bgImg.offset();
				offPos.top -= imgOff.top;
				offPos.left -= imgOff.left;
			}
			offPos.top = Math.round(offPos.top);
			offPos.left = Math.round(offPos.left);

			context.clearRect (0, 0, canvas.width, canvas.height);

			this.canvas[0].width = width;
			this.canvas[0].height = height;
			this.wrapper.css({ 'width': width });
			offPos.left += this.ct.width() - this.canvas[0].width;

			/*
			// implementation for partial bg height
			var bg_height = $('.scs-stage-flat').height();
			if (bg_height) {
				var w = canvas.width;
				var h = canvas.height;
				h = Math.min(h, bg_height - offPos.top);
				context.beginPath();
				context.moveTo(0,0);
				context.lineTo(w, 0);
				context.lineTo(w, h);
				context.lineTo(0, h);
				context.clip();
			}
			*/

			context.translate(- offPos.left, - offPos.top);

			if (this.image) {
				context.fillStyle = context.createPattern(this.image, 'repeat');
			} else {
				context.fillStyle = this.color;
			}

			context.globalCompositeOperation = 'source-over';
			context.fillRect(0, 0, canvas.width + offPos.left, canvas.height + offPos.top);
			context.translate(offPos.left, offPos.top);

			var gradient = context.createLinearGradient(0, 0, canvas.width, 0);
			gradient.addColorStop(0.0, 'rgba(255, 255, 255, 0.0)');
			gradient.addColorStop(1.0, 'rgba(255, 255, 255, 1.0)');
			context.fillStyle = gradient;
			context.globalCompositeOperation = 'destination-in';
			context.fillRect(0, 0, canvas.width, canvas.height);

		};

	})(OpacityGradient.prototype);

	$.scCarousel = function (e, o) {

		/* jshint maxstatements: 70 */
		var me = this; // local scope inside cascaded functions


		this.options = $.extend({}, defaults, o || {});
		this.container = $(e);

		this.clip = this.container.find(this.options.selectors.clip);
		this.list = this.clip.find(this.options.selectors.list);
		this.listItems = (this.options.selectors.listItems && this.options.selectors.listItems.length) ? this.list.find(this.options.selectors.listItems) : this.list.children();

		this.carouselOverflow = false;
		this.options.firstSlide = this.container.data('first-slide');
		this.options.infiniteLoop = this.container.data('infinite-loop');
		this.options.slideGridRows = this.container.hasClass('slide-grid-panels');
		this.options.fadeOutGridPanel = this.container.hasClass('shadow-last-grid-panel');

		// first slide start from one
		if (isNaN(this.options.firstSlide)) {
			this.options.firstSlide = 1;
		}

		// options are mutually exclusive
		if (this.options.slideGridRows) {
			this.options.infiniteLoop = false;
			// Fix only needed as long as css styles forces fixed widths
			jQuery('.contentWide .carouselContainer').css({ width: 'auto' });
			jQuery('.contentWide .carouselContainer LI.large').css({ width: 'auto' });
		}

		this.gridMargin = 0;
		if (this.options.slideGridRows) {
			// adjust overflow for possible shadows
			this.clip.css({ 'margin': -8, 'padding': 8 });
			this.listItems.css({ 'margin': -8, 'padding': 8 });
			// var rows = $('>.gridlayout>.single-row', this.listItems);
			var rows = $('>.gridlayout>.modGridLayout', this.listItems);
			this.gridMargin = parseInt(rows.css('margin-left'), 10) * -1;
			this.listItems.not(':last').css('margin-right', this.gridMargin - 8);
			// add class to mark the 'row' for synced heights
			this.container.addClass('row');
		}

		// get navigation-buttons and paging-navigation
		this.prevButton = this.container.find(this.options.selectors.prevButton);
		this.nextButton = this.container.find(this.options.selectors.nextButton);
		this.pagingItems = this.container.find(this.options.selectors.pagerItems);

		// definitions
		this.position = 0;
		this.isAnimating = false;

		var gridFirstLayout = $(this.options.selectors.gridLayout, this.listItems[0]);
		var gridFirstPanels = $(this.options.selectors.gridPanels, gridFirstLayout);
		var gridLastLayout = $(this.options.selectors.gridLayout, this.listItems[this.listItems.length - 1]);
		var gridLastPanels = $(this.options.selectors.gridPanels, gridLastLayout);

		var overflow = 1;
		this.stepSize = 1;
		this.lastPanelMissing = 0;
		if (this.options.slideGridRows) {
			this.gridSize = gridFirstPanels.length;
			if (gridFirstPanels.length > 0) {
				this.stepSize /= this.gridSize;
				overflow += this.stepSize;
			}
			this.lastPanelMissing = 1 - this.stepSize * gridLastPanels.length;
			this.gridLayouts = $(this.options.selectors.gridLayout, this.listItems);
			this.gridPanels = $(this.options.selectors.gridPanels, this.gridLayouts);
		} else {
			this.gridSize = 1;
		}
		if (this.options.fadeOutGridPanel) {
			this.ct = this.clip.closest('.content, .gridlayout');
			this.overflowWidth = this.ct.width() - this.clip.width();
			this.container.find('>.carousel-clip').css({
				'padding-right': this.overflowWidth,
				'margin-right': - this.overflowWidth

			});
		}

		this.updateNavigationWidth();
		if (!isNaN(this.options.firstSlide)) {
			this.setPosition((this.options.firstSlide - 1) * this.gridSize);
		}
		this.updateNavigationStates();

		// bind events to the navigation buttons
		this.prevButton.on('click', function (e) {
			me.slideTo(me.position * me.gridSize - 1);
			e.preventDefault();
		});
		this.nextButton.on('click', function (e) {
			me.slideTo(me.position * me.gridSize + 1);
			e.preventDefault();
		});

		// bind events to the pagination
		this.pagingItems.each(function (i) {
			$(this).data('carousel-paging-index', i);
		});
		this.pagingItems.on('click', function (e) {
			me.slideTo($(this).data('carousel-paging-index'));
			e.preventDefault();
		});

		// bind keyboard events
		this.container.on('keyup', function (e) {
			if (e.which == 37) { // left
				e.preventDefault();
				me.slideTo(me.position * me.gridSize - 1);
			} else if (e.which == 39) { // right
				e.preventDefault();
				me.slideTo(me.position * me.gridSize + 1);
			}
		});

		// enable touch-events if availlable
		if (!!('ontouchend' in document)) { this.enableTouch(); }

		if (this.options.fadeOutGridPanel) {
			var self = this;
			this.clip.each(function (i, el) {
				var grad = new OpacityGradient(el, self.ct);
				if (self.container.hasClass('clickable-gradient')) {
					grad.wrapper.css({
						'cursor': 'pointer',
						'pointer-events': ''
					});
					grad.canvas.on('click', function (/* e */) {
						self.nextButton.click();
					});
				}
			});
		}

		if (this.options.slideGridRows) {
			this.listItems.addClass('active-item');
			for (var i = 0, L = i + this.gridSize; i < L; i += 1) {
				$(this.gridPanels[i]).addClass('active-item');
			}
		} else {
			this.listItems.first().addClass('active-item');
		}

		this.fireEvent('onAfterInit');
	};

	$.extend($.scCarousel.prototype, {

		fireEvent: function () {
			// convert arguments-object (is not a real array) into an array
			var params = [];
			for (var i=0; i < arguments.length; i+=1) {
				params.push(arguments[i]);
			}

			var event = params.shift();
			if (typeof this.options[event] == 'function') {
				params.unshift(this);
				this.options[event].apply(this.container[0], params);
			}
		},

		updateNavigationWidth: function(){
			// initial DOM manipulations
			this.list.css('width', ''); // When in accordion and not visible, the list width is truncated
			this.listItemWidth = Math.max(this.clip.width(), this.listItems.eq(0).outerWidth(true));
			this.list.width((this.listItemWidth + 10) * this.listItems.length); // 10 px addition for tolerance
			if (this.listItems.length <= 1) {
				this.container.addClass(this.options.noItemsCls);
			}
		},

		updateNavigationStates: function () {
			if (!this.options.infiniteLoop) {
				this.prevButton[this.position > 0 ? 'removeClass' : 'addClass'](this.options.disabledButtonCls);
				this.nextButton[this.position >= this.listItems.length-1 - this.lastPanelMissing ? 'addClass' : 'removeClass'](this.options.disabledButtonCls);
			}
			var position = this.position;
			// this should only be needed for endless carousel mode
			if (position == -1) { position = this.listItems.length - 1; }

			this.pagingItems.filter('.' + this.options.pagerItemsActiveCls).blur();
			this.pagingItems
				.removeClass(this.options.pagerItemsActiveCls)
				.filter(':eq(' + position + ')').addClass(this.options.pagerItemsActiveCls);
		},

		normalizePosition: function (pos) {
			if (this.options.infiniteLoop) {
				var L = this.listItems.length - 1;
				while (pos > L) { pos -= L + 1; }
				while (pos < 0) { pos += L + 1; }
			}
			return pos;
		},

		slideTo: function (newPos) {
			/* jshint maxstatements: 40 */
			if (this.isAnimating) {
				return;
			}
			if (!this.options.infiniteLoop) {
				newPos /= this.gridSize;
				newPos = newPos < 0 ? 0 : (newPos >= this.listItems.length-1 - this.lastPanelMissing ? this.listItems.length-1 - this.lastPanelMissing : newPos);
			}
			// moving carousel outside on the left
			// ensure to add last panel before first
			else if (newPos < 0) {
				var panels = this.listItems,
				    rPanel = $(panels[panels.length-1]);
				rPanel.insertBefore(panels[0]);
				rPanel.css('margin-left', - this.listItemWidth);
			}
			var me = this; // local scope inside cascaded functions
			this.isAnimating = true;
			var oldPos = this.position;
			var futurePos = newPos;
			var activePos = this.position;
			if (!this.options.infiniteLoop) {
				if (parseInt(newPos, 10) != newPos) {
					if (newPos > oldPos) {
						futurePos = Math.ceil(futurePos);
						activePos = Math.floor(activePos);
					} else {
						futurePos = Math.floor(futurePos);
						activePos = Math.ceil(activePos);
					}
				}
			}

			var futureItem = this.listItems.eq(me.normalizePosition(futurePos));
			var activeItem = this.listItems.eq(me.normalizePosition(activePos));

			this.fireEvent('onBeforeAnimation', activeItem[0], futureItem[0], newPos, this.position, this.listItems.length);
			me.prepareAnimation(newPos);

			if (this.options.slideGridRows) {
				this.gridPanels.removeClass('active-item');
				var gridPanelFirstIndex = this.position * this.gridSize;
				for (var i = gridPanelFirstIndex, L = i + this.gridSize; i < L; i += 1) {
					$(this.gridPanels[i]).addClass('active-item');
				}
			} else {
				this.listItems.removeClass('active-item');
				futureItem.addClass('active-item');
			}
			this.updateNavigationStates();
			if (typeof futureItem.position() !== 'undefined') {
				var futureRight = this.position * this.listItemWidth;

				this.list.animate({'right': futureRight + 'px'}, this.options.animation.duration, this.options.animation.easing, function () {
					me.isAnimating = false;
					me.position *= me.gridSize;
					me.fireEvent('onAfterAnimation', activeItem[0], futureItem[0], me.position, oldPos, me.listItems.length);
					me.position /= me.gridSize;
					me.setPosition(me.position);
				});
			}
		},

		prepareSlideCarousel: function (pos) {
			var delta = pos - this.position;
			if (!this.options.infiniteLoop) {
				pos = Math.max(0, Math.min(this.listItems.length - 1, pos));
			} else {
				// bring into valid range
				var L = this.listItems.length;
				while (pos < -1) { pos += L; }
				while (pos > L - 1) { pos -= L; }
				var panels, rPanel;
				// position is moving into left abiss?
				if (pos < 0 || (pos === 0 && delta > 0)) {
					if (!this.carouselOverflow) {
						panels = this.listItems;
						rPanel = $(panels[panels.length-1]);
						rPanel.insertBefore(panels[0]);
						rPanel.css('margin-left', - this.listItemWidth);
						this.carouselOverflow = true;
					}
				} else {
					if (this.carouselOverflow) {
						panels = this.listItems;
						rPanel = $(panels[panels.length-1]);
						rPanel.insertAfter(panels[panels.length-2]);
						rPanel.css('margin-left', '');
						this.carouselOverflow = false;
					}
				}
			}
			return pos;
		},

		prepareAnimation: function (pos) {
			var delta = pos - this.position;
			pos = this.prepareSlideCarousel(pos);
			var off = (pos - delta) * this.listItemWidth;
			this.list.css('right', off + 'px');
			this.position = pos;
		},

		setPosition: function (pos) {
			pos = this.prepareSlideCarousel(pos);
			var off = pos * this.listItemWidth;
			this.list.css('right', off + 'px');
			this.position = pos;
		},

		enableTouch: function () {
			var me = this,
				dragEl = this.list,
				dragStarted = false,
				dragStartFingerPos, dragStartElementPos, dragMaxPos, dragMinPos, lastFingerPos, lastDirection;
			dragEl.on('touchstart', function (e) {
				if (dragStarted) { return true; }
				me.list.stop(true);
				me.isAnimating = false;
				dragStartFingerPos = event.touches && event.touches.length ? event.touches[0].pageX : e.originalEvent.pageX;
				var rightPos = dragEl.css('right').replace('px', '');
				if (isNaN(rightPos)) { rightPos = 0; } // maybe it's not yet set
				dragStartElementPos = isNaN(rightPos-0) ? 0 : rightPos;
				dragMinPos = 0;
				dragMaxPos = me.listItemWidth * (me.listItems.length - 1);
				dragStarted = true;
			}).on('touchmove', function (e) {
				if (!dragStarted) { return true; }
				//e.preventDefault(); // prevent scrolling
				var fingerPos = event.touches && event.touches.length ? event.touches[0].pageX : e.originalEvent.pageX;
				var delta = fingerPos - dragStartFingerPos;
				lastDirection = fingerPos > lastFingerPos ? 'right' : 'left';
				lastFingerPos = fingerPos;
				var off = dragStartElementPos - delta;
				me.setPosition(off / me.listItemWidth);
			}).on('touchend', function (/* e */) {
				if (!dragStarted) { return true; }
				var pos = dragEl.css('right').replace('px', '');
				if (isNaN(pos)) { pos = 0; } // maybe it's not yet set
				var visibleItem = me.listItems.length - (((me.listItemWidth * (me.listItems.length - 1)) - pos) / me.listItemWidth) - 1;
				var proximity = visibleItem % 1;
				var nextItem;
				if (proximity <= 0.2 || proximity >= 0.8) { nextItem = Math.round(visibleItem); }
				else { nextItem = parseInt(visibleItem, 10) + (lastDirection == 'right' ? 0 : 1); }
				me.slideTo(nextItem);
				dragStarted = false;
			});
		},

		showNext: function (wrapAround) {
			var newPos = this.position + this.stepSize;
			if (wrapAround) {
				if (newPos > this.listItems.length -1 ) { newPos = 0; }
			}
			this.slideTo(newPos);
		}

	});

	$.fn.scCarousel = function (o) {
		var $this = $(this);
		if ($this.length == 1 && $this.data('scCarousel')) {
			return $this.data('scCarousel');
		} else {
			return this.each(function () {
				var $this = $(this);
				if (!$this.data('scCarousel')) {
					$this.data('scCarousel', new $.scCarousel(this, o));
				}
			});
		}
	};

})(jQuery);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {$(function () {
	$('body').on('click', '.topiclist input[type=radio]', function(){
		document.location.href = $(this).data('url');
	});
});

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery) {jQuery(document).ready(function() {
	jQuery('.expertchat .textContainer, .expertchat .imageContainer').click(function(evt) {
		$this = jQuery(this);
		jQuery('.expertChatJsInclude a img', $this.closest('.expertchat')).click();
	});
});

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {/**
 * (c) Copyright Swisscom (Schweiz) AG. All rights reserved.
 *
 * This product is the proprietary and sole property of Swisscom (Schweiz) AG
 * Use, duplication or dissemination is subject to prior written consent of
 * Swisscom (Schweiz) AG.
 *
 * $Id: lightbox.js
 */

$.namespace('SCS.portal.lightbox');


/**
 * configuration
 */
SCS.portal.lightbox.maxWidth = 75; // percentage of the viewport-width
SCS.portal.lightbox.maxHeight = 75; // percentage of the viewport-height
SCS.portal.lightbox.loaderImage = '/etc/designs/base/resources/rotating-loader.gif';


/**
 * Show lightbox with Image inside
 */
SCS.portal.lightbox.show = function (e) {
	var $this = $(this);
	// show dialog with loader
	var lightbox = $('<div style="text-align:center;"><img src="' + SCS.portal.lightbox.loaderImage + '" alt="" /></div>');
	lightbox.dialog();
	var dialog = lightbox.closest('.ui-dialog');
	dialog.css({
		'min-width': '40px', // necessary to overwrite the dialogs minimal width
		'width': '40px' // necessary to overwrite the two possible swisscom default widths
	});
	lightbox.dialog('reposition');
	// attach image (is executed on load of the image)
	var attachImage = function () {
		// calculate and set maximum width
		if (img.width() > $(window).width() / 100 * SCS.portal.lightbox.maxWidth) {
			img.width(Math.round($(window).width() / 100 * SCS.portal.lightbox.maxWidth));
		}
		// calculate and set maximum height
		if (img.height() > $(window).height() / 100 * SCS.portal.lightbox.maxHeight) {
			img.css('width', ''); // reset width to keep aspect ratio
			img.height($(window).height() / 100 * SCS.portal.lightbox.maxHeight);
		}
		dialog.css({
			'max-width': img.width() + 'px', // necessary to overwrite the dialogs maximal width
			'width': img.width() + 'px' // necessary to overwrite the two possible swisscom default widths
		});
		lightbox.html('').append(img); // replace loader with image
		preLoader.remove(); // preloader is no longer needed - remove it from the dom
		lightbox.dialog('reposition');
	};
	// preload image
	var img = $('<img src="' + $this.attr('href') + '" alt="" />').on('load', attachImage);
	var preLoader = $('<div style="position: absolute; top: -9999px; left: -9999px; width: 1px; height: 1px; overflow: hidden;"></div>').append(img).prependTo('body'); // create preloader to measure the imagesize before sizing the dialog
	e.preventDefault(); // cancel mouse click on the link to NOT open the image in a new window
};


/**
 * Initialize lightbox-links
 */
SCS.ensure(function (context, $) {
	$('.lightbox', context).each(function () { // find lightbox-links inside a context (separate context for body AND AJAX-areas)
		var $this = $(this);
		var link = $this.is('a') ? $this : ($this.parent().is('a') ? $this.parent() : ($this.find('a').length == 1 ? $this.find('a') : {
			length: 0
		})); // find the link - necessary because spans with class "lightbox" could be wrapped around or inside the link itself
		if (link.length == 1) { // only one link should be found/processed for each "lightbox"-class
			link.click(SCS.portal.lightbox.show);
		}
	});
}, 'body, .ui-tabs-panel, .ui-dialog-content');

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {/**
 * (c) Copyright Swisscom (Schweiz) AG. All rights reserved.
 *
 * This product is the proprietary and sole property of Swisscom (Schweiz) AG
 * Use, duplication or dissemination is subject to prior written consent of
 * Swisscom (Schweiz) AG.
 *
 * $Id: supportstrip.js
 */

/**
 * Load support strip link lists
 */

$.namespace("SCS.supportstrip");

SCS.supportstrip.placeholder = '_keyword_';
SCS.supportstrip.NA = 'NA'; //base64 url safe encoded

// still used on PROD (19 instances)
SCS.supportstrip.init = function (id) {

	$("#" + id + " .links").each(function () {
		var $this = $(this);
		var url = $this.data("url");
		if (url) {
			url = url.replace(SCS.supportstrip.placeholder, $.base64.encode(SCS.supportstrip.NA).replace('=', '')); // URL Safe version of Base64

			$this.load(url, function (response, status, xhr) {
				if (status != "success" && status != "notmodified") {
					$this.hide();
				}
			});
		}
	});

	$("#" + id + " form").on("submit", function (e) {
		var actionUrl = $(this).attr("action");
		var term = escape($("#searchTerm").val());
		var url = actionUrl + "#.$[TERM].$".replace("[TERM]", term);
		window.location.href = url;

		e.preventDefault();
	});

	SCSC.forms.placeholder(); // TODO try to get rid of this call to legacy code
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {// fullbleed.js

$.namespace("SCS.fullbleedCarousel");
SCS.fullbleedCarousel.timer = null;
SCS.fullbleedCarousel.holder = null;

$(function() {
	var stage = $('#scs-stage'),
		stageFlat = stage.find('.scs-stage-flat'),
		$slides = $('.scs-fullbleed-carousel-slide'),
		carouselContainer = $('.fullbleed'),
		stageFlatInner;

	if ($slides.length) {
		$('.fullbleed:not(.modBackgroundContainer)').addClass('carouselContainer normalCarouselContainer');

		if( stageFlat.length === 0 ) {
			stageFlat = $('<div class="scs-stage-flat"></div>');
			stage.append( stageFlat );

			if( stage.data("full-height") ){
				stageFlat.addClass( 'full-height-background' );
			}

			if( stage.data("bottom-align") ){
				stageFlat.addClass( 'bottom-align-background' );
			}

			if( stage.data("background-color").length > 0 ) {
				stageFlat.css('background-color', "#"+stage.data("background-color") );
			}
		}

		if( stage.data("stretch-image") ) {
			stageFlatInner = stageFlat.find('.scs-stage-flat-inner');

			if( stageFlatInner.length === 0 ) {
				stageFlatInner = $('<div class="scs-stage-flat-inner"></div>');
				stageFlat.append( stageFlatInner );
			}

			SCS.fullbleedCarousel.holder = stageFlatInner;
		}
		else {
			SCS.fullbleedCarousel.holder = stageFlat;
		}

		SCS.fullbleedCarousel.holder.find('.scs-stage-backgroundimage:not(.scs-fbslide-backgroundimage)').remove();

		var $slide = $slides.eq(0).fadeIn(800);
		$slide.attr({
			'id' : 'fbSlide0',
			'data-bg' : 'fbSlideBg0'
		});
		$slide.find('.scs-stage-backgroundimage').attr('id', 'fbSlideBg0').show();
		var theme = $slide.find('.scs-stage-backgroundimage').data('theme');
		SCS.fullbleedCarousel.setTheme(theme);
		SCS.fullbleedCarousel.appendBackground($slide);
	}

	if ($slides.length > 1) {
		$(window).on('load', function() {
			SCS.fullbleedCarousel.loadSlide(1);
		});
	}
	else {
		// still set the width of a single container only in Fullbleed Stage carousel.
		carouselContainer.find('ul.carousel-list > li.scs-fullbleed-carousel-slide').show().width(carouselContainer.closest('.carouselContainer').width());
	}
});

SCS.fullbleedCarousel.setTheme = function(theme) {
	var $middle = $('div.middle');
	var $backgroundCreator = $middle.is('.creates-background') ? $middle : $middle.find('#scs-stage.creates-background');
	var $header = $('.scs-pageheader > div');

	if (theme === "themeWhite") {
		$header.removeClass('scs-pageheader-themeDark background-contrast-is-dark').addClass('scs-pageheader-themeWhite background-contrast-is-light');
		$middle.removeClass("scs-body-themeDark").addClass("scs-body-themeWhite");
		$backgroundCreator.removeClass('background-contrast-is-dark').addClass('background-contrast-is-light');
	} else {
		$header.removeClass('scs-pageheader-themeWhite background-contrast-is-light').addClass('scs-pageheader-themeDark background-contrast-is-dark');
		$middle.removeClass("scs-body-themeWhite").addClass("scs-body-themeDark");
		$backgroundCreator.removeClass('background-contrast-is-light').addClass('background-contrast-is-dark');
	}
};

SCS.fullbleedCarousel.loadSlide = function(num) {
	var count = (!num) ? 1 : num;
	var $slides = $('.scs-fullbleed-carousel-slide');
	$slide = $slides.eq(count);
	$.get($slide.data("url"), function(data) {
		$slide.attr({
			'id' : 'fbSlide' + count,
			'data-bg' : 'fbSlideBg' + count
		}).html(data);
		$slide.find('.scs-stage-backgroundimage').attr('id', 'fbSlideBg' + count);
		SCS.fullbleedCarousel.appendBackground($slide);
		if (count + 1 < $slides.length) {
			SCS.fullbleedCarousel.loadSlide(count + 1);
		} else {
			SCS.fullbleedCarousel.init();

			SCS.lazyLoadImages($('#scs-stage'));
			// fix for slides with images not backgrounds
			$('#fbSlideBg0').show();
		}
	});
};

SCS.fullbleedCarousel.appendBackground = function(elem) {
	SCS.fullbleedCarousel.holder.append(elem.find('.scs-stage-backgroundimage'));
};

SCS.fullbleedCarousel.animateBackground = function(outElementId, inElementId) {
	var FADE_TIME = 800; // ms
	$("#" + outElementId).fadeOut(FADE_TIME);
	$("#" + inElementId).fadeIn(FADE_TIME);
	setTimeout(function() {
		var theme = $("#" + inElementId).data("theme");
		SCS.fullbleedCarousel.setTheme(theme);
	}, FADE_TIME / 2);
};

SCS.fullbleedCarousel.init = function() {
	var carouselContainer = $('.fullbleed');
	var carouselControls = $('.fullbleed-controls').fadeIn(1000);
	var buttons = carouselControls.find('.carousel-prev, .carousel-next').fadeIn(1000);

	if (carouselContainer.data('carousel-initialized')) {
		return;
	}
	carouselContainer.data('carousel-initialized', true);

	carouselContainer.find('ul.carousel-list > li').show().width(carouselContainer
		.closest('.carouselContainer').width());

	carouselContainer.scCarousel({
		onAfterInit : SCS.fullbleedCarousel.initCarouselCallback,
		onBeforeAnimation : function(instance, outElement, inElement) {
			buttons.hide();
			SCS.fullbleedCarousel.animateBackground($(outElement).data('bg'), $(inElement)
				.data('bg'));
			SCS.carousel.deactivateVideos(carouselContainer);
		},
		onAfterAnimation : function(instance, outElement, inElement) {
			buttons.show();
			SCS.carousel.activateVideo($(inElement));
		}
	});
};

SCS.fullbleedCarousel.initCarouselCallback = function(carousel) {

	var duration = carousel.container.find('.carousel-clip').data('duration');
	if (duration) {
		function updateTimerCallback(timer) {
			if (!timer) {
				clearTimeout(SCS.fullbleedCarousel.timer);
			}
			SCS.fullbleedCarousel.timer = timer;
		}
		function start() {
			SCS.carousel.autoSlide(carousel, duration, updateTimerCallback);
		}
		function stop() {
			updateTimerCallback(null);
		}
		var $stage = $(".stage").one("mousemove", function() {
			// handle case when mouse is already over the stage after page load
			if ($stage.is(":hover")) {
				stop();
			}
		}).mouseenter(stop)
			.mouseover(stop)
			.mouseleave(start);
		start();
	}

	SCS.carousel.circleNavigationInit(carousel);
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(jQuery) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lib_generic_SDXModalDialog__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lib_util_url__ = __webpack_require__(6);


// Selector of SDX Lightbox triggers
var selector = '[target="sdxlightbox"]';
/* SDX Lightbox has been closed */
function closedSdxLightbox() {
    // Remove deeplinking to this lightbox
    __WEBPACK_IMPORTED_MODULE_1_lib_util_url__["hashDeepLink"].set('lightbox', undefined, '&');
    // Stop brightcove player
    __WEBPACK_IMPORTED_MODULE_0_lib_generic_SDXModalDialog__["default"].$contentHolder.find('.mod.modBrightcoveVideo').each(function (_, elem) {
        elem.brightcoveapi.pause();
    });
}
/* SDX Lightbox has been opened */
function openedSdxLightbox() {
    var _a;
    // Get url from passed config
    // Modal is a singleton class
    var url = (_a = __WEBPACK_IMPORTED_MODULE_0_lib_generic_SDXModalDialog__["default"].config) === null || _a === void 0 ? void 0 : _a.url;
    if (!url) {
        return;
    }
    // Allow deeplinking to this lightbox (opens lightbox directly on page load)
    __WEBPACK_IMPORTED_MODULE_1_lib_util_url__["hashDeepLink"].set('lightbox', "sel:" + selector + "[href=\"" + url + "\"]", '&');
}
/**
 * Global Handler for SDX Modal Dialogs
 * Triggered by A[target=sdxlightbox] tags
 * They must have a valid href url to load
 * We will use img tags for image urls
 * External urls will be loaded in iframe
 *
 * @author Marcel Greter (TAAGRMAL)
 */
function openSdxLightbox(event) {
    event.preventDefault();
    // Target should be an anchor tag with href
    var $anchor = jQuery(event.currentTarget);
    // Get target href from anchor tag
    var href = $anchor.attr('href');
    // Assertion for valid anchor href
    if (href === undefined || href === '') {
        throw Error(selector + " href needed");
    }
    // Add the hash of the linked URL to the current page (for visibility control containers to work).
    var hashIndex = href.indexOf('#');
    if (hashIndex > -1) {
        window.location.hash = href.substring(hashIndex);
        __WEBPACK_IMPORTED_MODULE_1_lib_util_url__["hashDeepLink"].update();
        href = href.substring(0, hashIndex);
    }
    // Init shared options from anchor data
    // tslint:disable:object-literal-sort-keys
    var options = {
        title: $anchor.data('sdxLightboxTitle'),
        width: $anchor.data('sdxLightboxWidth'),
        height: $anchor.data('sdxLightboxHeight'),
        class: $anchor.data('sdxLightboxClass'),
        url: href,
        on: {
            open: openedSdxLightbox,
            close: closedSdxLightbox,
            cancel: closedSdxLightbox,
        },
    };
    // Show the modal dialog
    __WEBPACK_IMPORTED_MODULE_0_lib_generic_SDXModalDialog__["default"].show(options);
}
// EO openSdxLightbox
// Use jQuery "live" to lazy handle all clicks on lighbox links
// More "initial load" efficient since testing is done on click
jQuery(document).on('click', "A[href]" + selector, openSdxLightbox);
/* Remove this once it is proven that we don't get any issues
 * with jQuery.on (it might be that some parent eats our events)
 * SCS.ensure(function(context) {
 * 	context.find('a[target="sdxlightbox"]:not([data-handler-attached])')
 * 		.on('click', openSdxLightbox).attr('data-handler-attached', 'true');
 * }, 'body, .ui-tabs-panel, .ui-dialog-content, .modTabNavigationContent');
 */

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!function(e,t){if(true)!(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (t),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));else if("undefined"!=typeof exports)t(exports);else{var o={};t(o),e.bodyScrollLock=o}}(this,function(exports){"use strict";function r(e){if(Array.isArray(e)){for(var t=0,o=Array(e.length);t<e.length;t++)o[t]=e[t];return o}return Array.from(e)}Object.defineProperty(exports,"__esModule",{value:!0});var l=!1;if("undefined"!=typeof window){var e={get passive(){l=!0}};window.addEventListener("testPassive",null,e),window.removeEventListener("testPassive",null,e)}var d="undefined"!=typeof window&&window.navigator&&window.navigator.platform&&/iP(ad|hone|od)/.test(window.navigator.platform),c=[],u=!1,a=-1,s=void 0,v=void 0,f=function(t){return c.some(function(e){return!(!e.options.allowTouchMove||!e.options.allowTouchMove(t))})},m=function(e){var t=e||window.event;return!!f(t.target)||(1<t.touches.length||(t.preventDefault&&t.preventDefault(),!1))},o=function(){setTimeout(function(){void 0!==v&&(document.body.style.paddingRight=v,v=void 0),void 0!==s&&(document.body.style.overflow=s,s=void 0)})};exports.disableBodyScroll=function(i,e){if(d){if(!i)return void console.error("disableBodyScroll unsuccessful - targetElement must be provided when calling disableBodyScroll on IOS devices.");if(i&&!c.some(function(e){return e.targetElement===i})){var t={targetElement:i,options:e||{}};c=[].concat(r(c),[t]),i.ontouchstart=function(e){1===e.targetTouches.length&&(a=e.targetTouches[0].clientY)},i.ontouchmove=function(e){var t,o,n,r;1===e.targetTouches.length&&(o=i,r=(t=e).targetTouches[0].clientY-a,!f(t.target)&&(o&&0===o.scrollTop&&0<r?m(t):(n=o)&&n.scrollHeight-n.scrollTop<=n.clientHeight&&r<0?m(t):t.stopPropagation()))},u||(document.addEventListener("touchmove",m,l?{passive:!1}:void 0),u=!0)}}else{n=e,setTimeout(function(){if(void 0===v){var e=!!n&&!0===n.reserveScrollBarGap,t=window.innerWidth-document.documentElement.clientWidth;e&&0<t&&(v=document.body.style.paddingRight,document.body.style.paddingRight=t+"px")}void 0===s&&(s=document.body.style.overflow,document.body.style.overflow="hidden")});var o={targetElement:i,options:e||{}};c=[].concat(r(c),[o])}var n},exports.clearAllBodyScrollLocks=function(){d?(c.forEach(function(e){e.targetElement.ontouchstart=null,e.targetElement.ontouchmove=null}),u&&(document.removeEventListener("touchmove",m,l?{passive:!1}:void 0),u=!1),c=[],a=-1):(o(),c=[])},exports.enableBodyScroll=function(t){if(d){if(!t)return void console.error("enableBodyScroll unsuccessful - targetElement must be provided when calling enableBodyScroll on IOS devices.");t.ontouchstart=null,t.ontouchmove=null,c=c.filter(function(e){return e.targetElement!==t}),u&&0===c.length&&(document.removeEventListener("touchmove",m,l?{passive:!1}:void 0),u=!1)}else(c=c.filter(function(e){return e.targetElement!==t})).length||o()}});


/***/ }),
/* 121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = lockPageScroll;
/* harmony export (immutable) */ __webpack_exports__["b"] = unlockPageScroll;
/* unused harmony export smoothScrollIntoView */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createAnimation__ = __webpack_require__(24);

var scrollLockTop = 0;
var scrollLockLeft = 0;
var scrollLocked = false;
// Make scroll event void
function revertScroll() {
    // Can't use preventDefault, as it doesn't work
    // Just lock scrolling to initial position
    scrollTo(scrollLockLeft, scrollLockTop);
}
/* Lock main page scrolling */
function lockPageScroll() {
    // Remember current scroll position
    scrollLockTop = window.scrollY;
    scrollLockLeft = window.scrollX;
    // Only bind the event listener once
    if (scrollLocked) {
        return;
    }
    // Add event handler to catch all scroll events
    document.addEventListener('scroll', revertScroll);
    // Set status flag
    scrollLocked = true;
}
/* Unlock main page scrolling */
function unlockPageScroll() {
    // Only unbind the event listener once
    if (!scrollLocked) {
        return;
    }
    // Remove event handler to catch all scroll events
    document.removeEventListener('scroll', revertScroll);
    // Set status flag
    scrollLocked = false;
}
var smoothScrollingSupported;
function supportsSmoothScrolling() {
    if (smoothScrollingSupported !== undefined) {
        return smoothScrollingSupported;
    }
    smoothScrollingSupported = false;
    try {
        var div = document.createElement('div');
        div.scrollTo({
            get behavior() {
                smoothScrollingSupported = true;
                return 'smooth';
            },
            top: 0,
        });
    }
    catch (err) { } // Edge throws an error
    return smoothScrollingSupported;
}
/**
 * Smoothely scroll a desired Element on the page into view.
 * @param node the HTMLElement to scroll to.
 * @param forcePolyfill Force polyfill for testing purpose only.
 */
function smoothScrollIntoView(nodeOrSelector, forcePolyfill) {
    if (forcePolyfill === void 0) { forcePolyfill = false; }
    var node = (typeof nodeOrSelector === 'string') ? document.querySelector(nodeOrSelector) : nodeOrSelector;
    if (node === null) {
        return;
    }
    if (supportsSmoothScrolling() && !forcePolyfill) {
        node.scrollIntoView({
            behavior: 'smooth',
        });
        return;
    }
    var animation = Object(__WEBPACK_IMPORTED_MODULE_0__createAnimation__["createAnimation"])({
        animator: function (_t, val) {
            node.ownerDocument.documentElement.scrollTop = val;
        },
        easing: 'swing',
        endValue: node.getBoundingClientRect().top,
        startValue: node.ownerDocument.documentElement.scrollTop,
    });
    function cancel() {
        animation.stop(false);
    }
    animation.start({
        callback: function () {
            node.removeEventListener('wheel', cancel);
            node.removeEventListener('touchstart', cancel);
        },
    });
    node.addEventListener('wheel', cancel, { passive: true });
    node.addEventListener('touchstart', cancel, { passive: true });
}


/***/ }),
/* 122 */
/***/ (function(module, exports) {

// element-closest | CC0-1.0 | github.com/jonathantneal/closest

(function (ElementProto) {
	if (typeof ElementProto.matches !== 'function') {
		ElementProto.matches = ElementProto.msMatchesSelector || ElementProto.mozMatchesSelector || ElementProto.webkitMatchesSelector || function matches(selector) {
			var element = this;
			var elements = (element.document || element.ownerDocument).querySelectorAll(selector);
			var index = 0;

			while (elements[index] && elements[index] !== element) {
				++index;
			}

			return Boolean(elements[index]);
		};
	}

	if (typeof ElementProto.closest !== 'function') {
		ElementProto.closest = function closest(selector) {
			var element = this;

			while (element && element.nodeType === 1) {
				if (element.matches(selector)) {
					return element;
				}

				element = element.parentNode;
			}

			return null;
		};
	}
})(window.Element.prototype);


/***/ }),
/* 123 */
/***/ (function(module, exports) {

// Polyfill for creating CustomEvents on IE9/10/11

// code pulled from:
// https://github.com/d4tocchini/customevent-polyfill
// https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent#Polyfill

(function() {
  if (typeof window === 'undefined') {
    return;
  }

  try {
    var ce = new window.CustomEvent('test', { cancelable: true });
    ce.preventDefault();
    if (ce.defaultPrevented !== true) {
      // IE has problems with .preventDefault() on custom events
      // http://stackoverflow.com/questions/23349191
      throw new Error('Could not prevent default');
    }
  } catch (e) {
    var CustomEvent = function(event, params) {
      var evt, origPrevent;
      params = params || {};
      params.bubbles = !!params.bubbles;
      params.cancelable = !!params.cancelable;

      evt = document.createEvent('CustomEvent');
      evt.initCustomEvent(
        event,
        params.bubbles,
        params.cancelable,
        params.detail
      );
      origPrevent = evt.preventDefault;
      evt.preventDefault = function() {
        origPrevent.call(this);
        try {
          Object.defineProperty(this, 'defaultPrevented', {
            get: function() {
              return true;
            }
          });
        } catch (e) {
          this.defaultPrevented = true;
        }
      };
      return evt;
    };

    CustomEvent.prototype = window.Event.prototype;
    window.CustomEvent = CustomEvent; // expose definition to window
  }
})();


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * Thanks for following 
 * requestAnimationFrame polyfill by Erik Möller & Paul Irish et. al.
 * https://gist.github.com/1866474
 * http://paulirish.com/2011/requestanimationframe-for-smart-animating/
 * http://my.opera.com/emoller/blog/2011/12/20/requestanimationframe-for-smart-er-animating
**/

/**
 *	(c) 2015 Alfred UC
 *	raf-uc may be freely distributed under the MIT license.
 *	For all details and documentation:
 *	https://github.com/b6pzeusbc54tvhw5jgpyw8pwz2x6gs/raf-uc
**/

/*jshint asi: false, browser: true, curly: true, eqeqeq: true, forin: false, newcap: true, noempty: true, strict: true, undef: true */

(function( factory ) {

	'use strict';

	// We use `self` instead of `window` for `WebWorker` support.
	var root = (typeof self == 'object' && self.self == self && self) ||
			(typeof global == 'object' && global.global == global && global);

	// Set up raf-uc appropriately for the environment. Start with AMD.
	if (true) {

		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_RESULT__ = (function(exports) {
			// Export global even in AMD case in case this script is loaded with
			// others that may still expect a global rafUC.
			root.rafUC = factory( root, exports );
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

	// Next for CommonJS.
	} else if (typeof exports !== 'undefined') {
		factory( root, exports );

	// Finally, as a browser global.
	} else {
		root.rafUC = factory( root, {} );
	}

}( function( root, exports ) {

	'use strict';
	
	var previousRafUC = root.rafUC;
	exports.noConflict = function() {
		root.rafUC = previousRafUC;
		return this;
	};

	var lastTime = 0;
	var prefixList = 'webkit moz ms o'.split(' ');
	// get unprefixed rAF and cAF, if present
	var requestAnimationFrame = root.requestAnimationFrame;
	var cancelAnimationFrame = root.cancelAnimationFrame;
	// loop through vendor prefixList and get prefixed rAF and cAF
	var prefix;
	for( var i = 0; i < prefixList.length; i++ ) {
		if ( requestAnimationFrame && cancelAnimationFrame ) {
			break;
		}
		prefix = prefixList[i];
		requestAnimationFrame = requestAnimationFrame || root[ prefix + 'RequestAnimationFrame' ];
		cancelAnimationFrame  = cancelAnimationFrame  || root[ prefix + 'CancelAnimationFrame' ] ||
		root[ prefix + 'CancelRequestAnimationFrame' ];
	}

	// fallback to setTimeout and clearTimeout if either request/cancel is not supported
	if ( !requestAnimationFrame || !cancelAnimationFrame ) {

		requestAnimationFrame = function( callback ) {
			var currTime = new Date().getTime();
			var timeToCall = Math.max( 0, 16 - ( currTime - lastTime ) );
			var id = root.setTimeout( function() {
				callback( currTime + timeToCall );
			}, timeToCall );
			lastTime = currTime + timeToCall;
			return id;
		};

		cancelAnimationFrame = function( id ) {
			root.clearTimeout( id );
		};
	}

	// put in global namespace
	root.requestAnimationFrame = requestAnimationFrame;
	root.cancelAnimationFrame = cancelAnimationFrame;

	exports.raf = requestAnimationFrame;
	exports.caf = cancelAnimationFrame;

	return exports;
}));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19)))

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * 
 * SWISSCOM NOTE: Changed by TAAGRMAL - PR opened on upstream
 * See https://github.com/cferdinandi/smooth-scroll/pull/462
 * 
 * smooth-scroll v14.2.1: Animate scrolling to anchor links
 * (c) 2018 Chris Ferdinandi
 * MIT License
 * http://github.com/cferdinandi/smooth-scroll
 */

(function (root, factory) {
	if (true) {
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return factory(root);
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (typeof exports === 'object') {
		module.exports = factory(root);
	} else {
		root.SmoothScroll = factory(root);
	}
})(typeof global !== 'undefined' ? global : typeof window !== 'undefined' ? window : this, (function (window) {

	'use strict';

	//
	// Default settings
	//

	var defaults = {
		// Selectors
		ignore: '[data-scroll-ignore]',
		header: null,
		topOnEmptyHash: true,

		// Speed & Easing
		speed: 500,
		clip: true,
		offset: 0,
		easing: 'easeInOutCubic',
		customEasing: null,

		// History
		updateURL: true,
		popstate: true,

		// Custom Events
		emitEvents: true
	};


	//
	// Utility Methods
	//

	/**
	 * Check if browser supports required methods
	 * @return {Boolean} Returns true if all required methods are supported
	 */
	var supports = function () {
		return (
			'querySelector' in document &&
			'addEventListener' in window &&
			'requestAnimationFrame' in window &&
			'closest' in window.Element.prototype
		);
	};

	/**
	 * Merge two or more objects. Returns a new object.
	 * @param {Object}   objects  The objects to merge together
	 * @returns {Object}          Merged values of defaults and options
	 */
	var extend = function () {

		// Variables
		var extended = {};

		// Merge the object into the extended object
		var merge = function (obj) {
			for (var prop in obj) {
				if (obj.hasOwnProperty(prop)) {
					extended[prop] = obj[prop];
				}
			}
		};

		// Loop through each object and conduct a merge
		for (var i = 0; i < arguments.length; i++) {
			merge(arguments[i]);
		}

		return extended;

	};

	/**
	 * Check to see if user prefers reduced motion
	 * @param  {Object} settings Script settings
	 */
	var reduceMotion = function (settings) {
		if ('matchMedia' in window && window.matchMedia('(prefers-reduced-motion)').matches) {
			return true;
		}
		return false;
	};

	/**
	 * Get the height of an element.
	 * @param  {Node} elem The element to get the height of
	 * @return {Number}    The element's height in pixels
	 */
	var getHeight = function (elem) {
		return parseInt(window.getComputedStyle(elem).height, 10);
	};

	/**
	 * Decode a URI, with error check
	 * @param  {String} hash The URI to decode
	 * @return {String}      A decoded URI (or the original string if an error is thrown)
	 */
	var decode = function (hash) {
		var decoded;
		try {
			decoded = decodeURIComponent(hash);
		} catch(e) {
			decoded = hash;
		}
		return decoded;
	};

	/**
	 * Escape special characters for use with querySelector
	 * @author Mathias Bynens
	 * @link https://github.com/mathiasbynens/CSS.escape
	 * @param {String} id The anchor ID to escape
	 */
	var escapeCharacters = function (id) {

		// Remove leading hash
		if (id.charAt(0) === '#') {
			id = id.substr(1);
		}

		var string = String(id);
		var length = string.length;
		var index = -1;
		var codeUnit;
		var result = '';
		var firstCodeUnit = string.charCodeAt(0);
		while (++index < length) {
			codeUnit = string.charCodeAt(index);
			// Note: there’s no need to special-case astral symbols, surrogate
			// pairs, or lone surrogates.

			// If the character is NULL (U+0000), then throw an
			// `InvalidCharacterError` exception and terminate these steps.
			if (codeUnit === 0x0000) {
				throw new InvalidCharacterError(
					'Invalid character: the input contains U+0000.'
				);
			}

			if (
				// If the character is in the range [\1-\1F] (U+0001 to U+001F) or is
				// U+007F, […]
				(codeUnit >= 0x0001 && codeUnit <= 0x001F) || codeUnit == 0x007F ||
				// If the character is the first character and is in the range [0-9]
				// (U+0030 to U+0039), […]
				(index === 0 && codeUnit >= 0x0030 && codeUnit <= 0x0039) ||
				// If the character is the second character and is in the range [0-9]
				// (U+0030 to U+0039) and the first character is a `-` (U+002D), […]
				(
					index === 1 &&
					codeUnit >= 0x0030 && codeUnit <= 0x0039 &&
					firstCodeUnit === 0x002D
				)
			) {
				// http://dev.w3.org/csswg/cssom/#escape-a-character-as-code-point
				result += '\\' + codeUnit.toString(16) + ' ';
				continue;
			}

			// If the character is not handled by one of the above rules and is
			// greater than or equal to U+0080, is `-` (U+002D) or `_` (U+005F), or
			// is in one of the ranges [0-9] (U+0030 to U+0039), [A-Z] (U+0041 to
			// U+005A), or [a-z] (U+0061 to U+007A), […]
			if (
				codeUnit >= 0x0080 ||
				codeUnit === 0x002D ||
				codeUnit === 0x005F ||
				codeUnit >= 0x0030 && codeUnit <= 0x0039 ||
				codeUnit >= 0x0041 && codeUnit <= 0x005A ||
				codeUnit >= 0x0061 && codeUnit <= 0x007A
			) {
				// the character itself
				result += string.charAt(index);
				continue;
			}

			// Otherwise, the escaped character.
			// http://dev.w3.org/csswg/cssom/#escape-a-character
			result += '\\' + string.charAt(index);

		}

		// Return sanitized hash
		var hash;
		try {
			hash = decodeURIComponent('#' + result);
		} catch(e) {
			hash = '#' + result;
		}
		return hash;

	};

	/**
	 * Calculate the easing pattern
	 * @link https://gist.github.com/gre/1650294
	 * @param {String} type Easing pattern
	 * @param {Number} time Time animation should take to complete
	 * @returns {Number}
	 */
	var easingPattern = function (settings, time) {
		var pattern;

		// Default Easing Patterns
		if (settings.easing === 'easeInQuad') pattern = time * time; // accelerating from zero velocity
		if (settings.easing === 'easeOutQuad') pattern = time * (2 - time); // decelerating to zero velocity
		if (settings.easing === 'easeInOutQuad') pattern = time < 0.5 ? 2 * time * time : -1 + (4 - 2 * time) * time; // acceleration until halfway, then deceleration
		if (settings.easing === 'easeInCubic') pattern = time * time * time; // accelerating from zero velocity
		if (settings.easing === 'easeOutCubic') pattern = (--time) * time * time + 1; // decelerating to zero velocity
		if (settings.easing === 'easeInOutCubic') pattern = time < 0.5 ? 4 * time * time * time : (time - 1) * (2 * time - 2) * (2 * time - 2) + 1; // acceleration until halfway, then deceleration
		if (settings.easing === 'easeInQuart') pattern = time * time * time * time; // accelerating from zero velocity
		if (settings.easing === 'easeOutQuart') pattern = 1 - (--time) * time * time * time; // decelerating to zero velocity
		if (settings.easing === 'easeInOutQuart') pattern = time < 0.5 ? 8 * time * time * time * time : 1 - 8 * (--time) * time * time * time; // acceleration until halfway, then deceleration
		if (settings.easing === 'easeInQuint') pattern = time * time * time * time * time; // accelerating from zero velocity
		if (settings.easing === 'easeOutQuint') pattern = 1 + (--time) * time * time * time * time; // decelerating to zero velocity
		if (settings.easing === 'easeInOutQuint') pattern = time < 0.5 ? 16 * time * time * time * time * time : 1 + 16 * (--time) * time * time * time * time; // acceleration until halfway, then deceleration

		// Custom Easing Patterns
		if (!!settings.customEasing) pattern = settings.customEasing(time);

		return pattern || time; // no easing, no acceleration
	};

	/**
	 * Determine the document's height
	 * @returns {Number}
	 */
	var getDocumentHeight = function () {
		return Math.max(
			document.body.scrollHeight, document.documentElement.scrollHeight,
			document.body.offsetHeight, document.documentElement.offsetHeight,
			document.body.clientHeight, document.documentElement.clientHeight
		);
	};

	/**
	 * Calculate how far to scroll
	 * Clip support added by robjtede - https://github.com/cferdinandi/smooth-scroll/issues/405
	 * @param {Element} anchor       The anchor element to scroll to
	 * @param {Number}  headerHeight Height of a fixed header, if any
	 * @param {Number}  offset       Number of pixels by which to offset scroll
	 * @param {Boolean} clip         If true, adjust scroll distance to prevent abrupt stops near the bottom of the page
	 * @returns {Number}
	 */
	var getEndLocation = function (anchor, headerHeight, offset, clip) {
		var location = 0;
		if (anchor.offsetParent) {
			do {
				location += anchor.offsetTop;
				anchor = anchor.offsetParent;
			} while (anchor);
		}
		location = Math.max(location - headerHeight - offset, 0);
		if (clip) {
			location = Math.min(location, getDocumentHeight() - window.innerHeight);
		}
 		return location;
	};

	/**
	 * Get the height of the fixed header
	 * @param  {Node}   header The header
	 * @return {Number}        The height of the header
	 */
	var getHeaderHeight = function (header) {
		return !header ? 0 : (getHeight(header) + header.offsetTop);
	};

	/**
	 * Update the URL
	 * @param  {Node}    anchor  The anchor that was scrolled to
	 * @param  {Boolean} isNum   If true, anchor is a number
	 * @param  {Object}  options Settings for Smooth Scroll
	 */
	var updateURL = function (anchor, isNum, options) {

		// Bail if the anchor is a number
		if (isNum) return;

		// Verify that pushState is supported and the updateURL option is enabled
		if (!history.pushState || !options.updateURL) return;

		// Update URL
		history.pushState(
			{
				smoothScroll: JSON.stringify(options),
				anchor: anchor.id
			},
			document.title,
			anchor === document.documentElement ? '#top' : '#' + anchor.id
		);

	};

	/**
	 * Bring the anchored element into focus
	 * @param {Node}     anchor      The anchor element
	 * @param {Number}   endLocation The end location to scroll to
	 * @param {Boolean}  isNum       If true, scroll is to a position rather than an element
	 */
	var adjustFocus = function (anchor, endLocation, isNum) {

		// Is scrolling to top of page, blur
		if (anchor === 0) {
			document.body.focus();
		}

		// Don't run if scrolling to a number on the page
		if (isNum) return;

		// Otherwise, bring anchor element into focus
		anchor.focus();
		if (document.activeElement !== anchor) {
			anchor.setAttribute('tabindex', '-1');
			anchor.focus();
			anchor.style.outline = 'none';
		}
		window.scrollTo(0 , endLocation);

	};

	/**
	 * Emit a custom event
	 * @param  {String} type    The event type
	 * @param  {Object} options The settings object
	 * @param  {Node}   anchor  The anchor element
	 * @param  {Node}   toggle  The toggle element
	 */
	var emitEvent = function (type, options, anchor, toggle) {
		if (!options.emitEvents || typeof window.CustomEvent !== 'function') return;
		var event = new CustomEvent(type, {
			bubbles: true,
			detail: {
				anchor: anchor,
				toggle: toggle
			}
		});
		document.dispatchEvent(event);
	};


	//
	// SmoothScroll Constructor
	//

	var SmoothScroll = function (selector, options) {

		//
		// Variables
		//

		var smoothScroll = {}; // Object for public APIs
		var settings, anchor, toggle, fixedHeader, headerHeight, eventTimeout, animationInterval;


		//
		// Methods
		//

		/**
		 * Cancel a scroll-in-progress
		 */
		smoothScroll.cancelScroll = function (noEvent) {
			cancelAnimationFrame(animationInterval);
			animationInterval = null;
			if (noEvent) return;
			emitEvent('scrollCancel', settings);
		};

		/**
		 * Start/stop the scrolling animation
		 * @param {Node|Number} anchor  The element or position to scroll to
		 * @param {Element}     toggle  The element that toggled the scroll event
		 * @param {Object}      options
		 */
		smoothScroll.animateScroll = function (anchor, toggle, options) {

			// Local settings
			var animateSettings = extend(settings || defaults, options || {}); // Merge user options with defaults

			// Selectors and variables
			var isNum = Object.prototype.toString.call(anchor) === '[object Number]' ? true : false;
			var anchorElem = isNum || !anchor.tagName ? null : anchor;
			if (!isNum && !anchorElem) return;
			var startLocation = window.pageYOffset; // Current location on the page
			var finallHeaderHeight;
			if (animateSettings.header && !fixedHeader) {
				// Get the fixed header if not already set
				fixedHeader = document.querySelector(animateSettings.header);
			}
			if (!headerHeight) {
				// Get the height of a fixed header if one exists and not already set
				headerHeight = getHeaderHeight(fixedHeader);
			}
			finallHeaderHeight = headerHeight;
			//Always check for the crisisHeader as it maybe removed once caluclated and the scrolling will be off
			if (animateSettings.crisisHeader) {
				finallHeaderHeight += getHeaderHeight(document.querySelector(animateSettings.crisisHeader))
			}
			var endLocation = isNum ? anchor : getEndLocation(anchorElem, finallHeaderHeight, parseInt((typeof animateSettings.offset === 'function' ? animateSettings.offset(anchor, toggle) : animateSettings.offset), 10), animateSettings.clip); // Location to scroll to
			var distance = endLocation - startLocation; // distance to travel
			var documentHeight = getDocumentHeight();
			var timeLapsed = 0;
			var start, percentage, position;

			/**
			 * Stop the scroll animation when it reaches its target (or the bottom/top of page)
			 * @param {Number} position Current position on the page
			 * @param {Number} endLocation Scroll to location
			 * @param {Number} animationInterval How much to scroll on this loop
			 */
			var stopAnimateScroll = function (position, endLocation) {

				// Get the current location
				var currentLocation = window.pageYOffset;

				// Check if the end location has been reached yet (or we've hit the end of the document)
				if (position == endLocation || currentLocation == endLocation || ((startLocation < endLocation && window.innerHeight + currentLocation) >= documentHeight)) {

					// Clear the animation timer
					smoothScroll.cancelScroll(true);

					// Bring the anchored element into focus
					adjustFocus(anchor, endLocation, isNum);

					// Emit a custom event
					emitEvent('scrollStop', animateSettings, anchor, toggle);

					// Reset start
					start = null;
					animationInterval = null;

					return true;

				}
			};

			/**
			 * Loop scrolling animation
			 */
			var loopAnimateScroll = function (timestamp) {
				if (!start) { start = timestamp; }
				timeLapsed += timestamp - start;
				percentage = (timeLapsed / parseInt(animateSettings.speed, 10));
				percentage = (percentage > 1) ? 1 : percentage;
				position = startLocation + (distance * easingPattern(animateSettings, percentage));
				window.scrollTo(0, Math.floor(position));
				if (!stopAnimateScroll(position, endLocation)) {
					animationInterval = window.requestAnimationFrame(loopAnimateScroll);
					start = timestamp;
				}
			};

			/**
			 * Reset position to fix weird iOS bug
			 * @link https://github.com/cferdinandi/smooth-scroll/issues/45
			 */
			if (window.pageYOffset === 0) {
				window.scrollTo(0, 0);
			}

			// Update the URL
			updateURL(anchor, isNum, animateSettings);

			// Emit a custom event
			emitEvent('scrollStart', animateSettings, anchor, toggle);

			// Start scrolling animation
			smoothScroll.cancelScroll(true);
			window.requestAnimationFrame(loopAnimateScroll);

		};

		/**
		 * If smooth scroll element clicked, animate scroll
		 */
		var clickHandler = function (event) {

			// Don't run if the user prefers reduced motion
			if (reduceMotion(settings)) return;

			// Don't run if event was canceled but still bubbled up
			// Added by TAAGRMAL - Pull request opened on upstream
			// See https://github.com/cferdinandi/smooth-scroll/pull/462
			if (event.defaultPrevented) return;

			// Don't run if right-click or command/control + click
			if (event.button !== 0 || event.metaKey || event.ctrlKey) return;

			// Check if event.target has closest() method
			// By @totegi - https://github.com/cferdinandi/smooth-scroll/pull/401/
			if(!('closest' in event.target))return;

			// Check if a smooth scroll link was clicked
			toggle = event.target.closest(selector);
			if (!toggle || toggle.tagName.toLowerCase() !== 'a' || event.target.closest(settings.ignore)) return;

			// Only run if link is an anchor and points to the current page
			if (toggle.hostname !== window.location.hostname || toggle.pathname !== window.location.pathname || !/#/.test(toggle.href)) return;

			// Get an escaped version of the hash
			var hash = escapeCharacters(decode(toggle.hash));

			// Get the anchored element
			var anchor = settings.topOnEmptyHash && hash === '#' ? document.documentElement : document.querySelector(hash);
			anchor = !anchor && hash === '#top' ? document.documentElement : anchor;

			// If anchored element exists, scroll to it
			if (!anchor) return;
			event.preventDefault();
			smoothScroll.animateScroll(anchor, toggle);

		};

		/**
		 * Animate scroll on popstate events
		 */
		var popstateHandler = function (event) {
			// Stop if history.state doesn't exist (ex. if clicking on a broken anchor link).
			// fixes `Cannot read property 'smoothScroll' of null` error getting thrown.
			if (history.state === null || history.state === undefined) return; 

			// Only run if state is a popstate record for this instantiation
			if (!history.state.smoothScroll || history.state.smoothScroll !== JSON.stringify(settings)) return;

			// Only run if state includes an anchor
			if (!history.state.anchor) return;

			// Get the anchor
			var anchor = document.querySelector(escapeCharacters(decode(history.state.anchor)));
			if (!anchor) return;

			// Animate scroll to anchor link
			smoothScroll.animateScroll(anchor, null, {updateURL: false});

		};

		/**
		 * On window scroll and resize, only run events at a rate of 15fps for better performance
		 */
		var resizeThrottler = function (event) {
			if (!eventTimeout) {
				eventTimeout = setTimeout((function() {
					eventTimeout = null; // Reset timeout
					headerHeight = getHeaderHeight(fixedHeader); // Get the height of a fixed header if one exists
				}), 66);
			}
		};

		/**
		 * Destroy the current initialization.
		 */
		smoothScroll.destroy = function () {

			// If plugin isn't already initialized, stop
			if (!settings) return;

			// Remove event listeners
			document.removeEventListener('click', clickHandler, false);
			window.removeEventListener('resize', resizeThrottler, false);
			window.removeEventListener('popstate', popstateHandler, false);

			// Cancel any scrolls-in-progress
			smoothScroll.cancelScroll();

			// Reset variables
			settings = null;
			anchor = null;
			toggle = null;
			fixedHeader = null;
			headerHeight = null;
			eventTimeout = null;
			animationInterval = null;

		};

		/**
		 * Initialize Smooth Scroll
		 * @param {Object} options User settings
		 */
		smoothScroll.init = function (options) {

			// feature test
			if (!supports()) throw 'Smooth Scroll: This browser does not support the required JavaScript methods and browser APIs.';

			// Destroy any existing initializations
			smoothScroll.destroy();

			// Selectors and variables
			settings = extend(defaults, options || {}); // Merge user options with defaults
			fixedHeader = settings.header ? document.querySelector(settings.header) : null; // Get the fixed header
			headerHeight = getHeaderHeight(fixedHeader);

			// When a toggle is clicked, run the click handler
			document.addEventListener('click', clickHandler, false);

			// If window is resized and there's a fixed header, recalculate its size
			if (fixedHeader) {
				window.addEventListener('resize', resizeThrottler, false);
			}

			// If updateURL and popState are enabled, listen for pop events
			if (settings.updateURL && settings.popstate) {
				window.addEventListener('popstate', popstateHandler, false);
			}

		};


		//
		// Initialize plugin
		//

		smoothScroll.init(options);


		//
		// Public APIs
		//

		return smoothScroll;

	};

	return SmoothScroll;

}));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19)))

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function applyClampValue() {
    document.body.querySelectorAll('[data-text-line-cut]').forEach(function (element) {
        element.style.webkitLineClamp = element.dataset.textLineCut;
    });
}
(function () {
    if (document.readyState !== 'loading') {
        applyClampValue();
    }
    else {
        document.addEventListener('DOMContentLoaded', applyClampValue);
    }
})();


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_Tc_dot_$) {/*** IMPORTS FROM imports-loader ***/
var loadTerrific = __webpack_require__(1);
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function (Module, $, SCS) {
	'use strict';
	/*jslint plusplus: true */

	/**
	 * Accordion.
	 *
	 * @author TAASCRAA
	 * @namespace Tc.Module
	 * @class Accordion
	 * @extends Tc.Module
	 */

	var groupCount = 0;
	var groupCache = {};

	Module.Accordion = Module.extend({
		// True if one of the tabs has been clicked upon
		hasBeenClicked: false,
		// All the tabs, all the tabs, all the tabs you should have given.
		// All the tabs, all the tabs, all the tabs we could have given.
		tabs: null,
		syncedInitCounter: {},

		/**
		 * Does all the work.
		 *
		 * @method on
		 * @param {Function} callback function
		 * @return void
		 */
		on: function (callback) {
			var $ctx = this.$ctx;
			this.tabs = $ctx.find('.scs-accordion-tab');
			this.isSynchronizedAccordion = $ctx.is('.synchronizedaccordion');
			this.groupId = $ctx.data('group-id') || '';
			this.groupSelector = '.modAccordion.synchronizedaccordion.' + this.groupId;
			// make sure we do not sync accross different tabs
			var parent = $ctx.closest('.modTabNavigationContent');
			if (parent.length) {
				if (!parent.data('sync-root-id')) {
					groupCount += 1;
					parent.attr('data-sync-root-id', groupCount);
				}
				var syncId = parent.data('sync-root-id');
				this.groupSelector = '[data-sync-root-id=' + syncId + '] ' + this.groupSelector;
			}
			this.setupAccordion($ctx);
			callback();
		},

		/**
		 * Called when all modules have been set up
		 */
		after: function () {
			var mod = this,
				$row,
				_groupCache = groupCache[this.groupSelector];

			if(!mod.isSynchronizedAccordion) {
				return;
			}

			// only cache the nodes once per group
			if (!_groupCache) {
				_groupCache = {};
				_groupCache.$group = $(this.groupSelector);
				_groupCache.$sections = mod.$ctx.find('>DIV>.synchronizedaccordion.section');
				_groupCache.tabs = [];
				_groupCache.groupRowSegments = [];

				// Aggregate and cache all row segments within a single group.
				for (var i = 0, sectionLength = _groupCache.$sections.length; i < sectionLength; i += 1) {
					$row = _groupCache.$group.find('.synchronizedaccordion.section:nth-child(' + (i + 1) + ')');
					_groupCache.tabs.push($row.find('.scs-accordion-tab'));
					_groupCache.groupRowSegments.push([
						$row.find('.scs-accordion-tab-heading'),
						$row.find('.scs-accordion-tab-panel'),
						$row.find('.scs-accordion-tab-footer')
					]);
				}
			}

			// only register once for each group
			if (!_groupCache.hasListener) {
				// don't sync group with only one item
				// need at least two to sync something
				if (_groupCache.$group.length > 1) {
					// register sync height event handler
					// try to sync only items in the same "row"
					$(mod.$ctx).parents('BODY, .single-row, .row')
						.on('sync-heights', function (event) {
							event.stopPropagation();
							mod.synchronizeRowHeights();
						});

					// remember that we have bound a handler
					_groupCache.hasListener = true;
					// store the group cache accessibly to all instances.
					groupCache[this.groupSelector] = _groupCache;

					// synchronize here once, because the first 'sync-heights' event will be triggered by the window.load event.
					// But the wait for window.load may be long, when there are multiple larger images or other resources on the page.
					// Hence, we want to present a nice layout quickly, but 'sync-heights' will synchronize again with all loaded images.
					mod.synchronizeRowHeights();
					mod.initOpenedTabs();
					mod.disableEmptyTabs();
				}
			}
		},

		/**
		 * Loop through the row contents and synchronize their heights.
		 */
		synchronizeRowHeights: function() {
			var _groupCache = groupCache[this.groupSelector];
			for (var i = 0, iL = _groupCache.groupRowSegments.length; i < iL; ++i) {
				for (var n = 0, nL = _groupCache.groupRowSegments[i].length; n < nL; ++n) {
					SCS.portal.synchronizeHeights(_groupCache.groupRowSegments[i][n]);
				}
			}
		},

		/**
		 * If one accordion tab in a group row was configured to be opened on load,
		 * make sure all others in the row have the same configuration
		 */
		initOpenedTabs:function(){
			var _groupCache = groupCache[this.groupSelector];
			for( var i = 0, tabsLength = _groupCache.tabs.length; i < tabsLength; i += 1) {
				if (_groupCache.tabs[i].is('.scs-accordion-tab-opened')) {
					_groupCache.tabs[i].addClass('scs-accordion-tab-opened');
				}

				_groupCache.tabs[i].each($.proxy(this.finalizeTab, this));
			}
		},

		/**
		 * Check for content in each accordion tab row.
		 * if a row does not define content, disable the whole row.
		 */
		disableEmptyTabs: function() {
			var _groupCache = groupCache[this.groupSelector],
				$tabRow,
				$tabHeadings;
			for( var i = 0, tabsLength = _groupCache.tabs.length; i < tabsLength; i += 1) {
				$tabRow = _groupCache.tabs[i];
				if(!$tabRow.find('.parsysSynchronizedAccordionContent').children().length) {
					$tabHeadings = $tabRow.find('.scs-accordion-tab-heading');
					$tabHeadings.addClass('disabled');
					$tabRow.off('scs-accordion-tab-opening');
					$tabRow.off('scs-accordion-tab-closing');
					$tabHeadings.off('click');
					$tabHeadings.off('synchronizedTabClick');
					$tabHeadings.off('focus');
				}
			}
		},

		/**
		 * Set up tab that should be initially open
		 */
		setupAccordion: function ($ctx) {
			if (!this.tabs.length) {
				return; //Do nothing if no tabs are present
			}
			this.tabs.each($.proxy(this.setupTab, this));

			this.setupOpenTabs();

			if ($ctx.data(Module.Accordion.DATA.ACCORDION.TRACKING)) {
				var trackedName = $ctx.find('.scs-accordion-tab-opened .scs-accordion-tab-heading a').data('tracking-name');
				SCS.tracking.setLandingTabName(trackedName);
			}
		},

		/**
		 * Takes care to set open states of tabs whose indexes appear in the URL as part of a sling selector
		 */
		setupOpenTabs: function () {
			var openTabs = this.openTabsByHash(); // Hash has higher precedence than all other methods
			if (!openTabs.length) {
				openTabs = this.openTabsByDefault();
			}
			this.tabs.removeClass('scs-accordion-tab-opened');
			openTabs.addClass('scs-accordion-tab-opened');
			openTabs.each($.proxy(this.finalizeTab, this));
		},

		/**
		 * Returns all tabs of which the controller tells us they’re open.
		 * This includes tabs opened by the selector (tab-«normalized-tab-name», or legacy: a«no«, «no») or configured to be initially open.
		 */
		openTabsByDefault: function () {
			return this.tabs.filter('[data-is-selected="true"]');
		},

		/**
		 * Returns the tab whose index appear in the URL as part of the hash.
		 */
		openTabsByHash: function () {
			var tab = this.tabs.filter(function () {
				return $(this).data(Module.Accordion.DATA.TAB.OPENER).find('a').attr('href') === window.location.hash;
			}).first();
			return tab;
		},

		/**
		 * Set up individual tab
		 */
		setupTab: function (index, tab) {
			tab = $(tab);

			// Elements
			var opener = tab.children('.scs-accordion-tab-heading');
			var openerEl = $('A, .title', opener);
			if (!openerEl.length) {
				openerEl = opener;
			}
			var panel = tab.children('.scs-accordion-tab-panel');

			// Tab data
			tab.data(Module.Accordion.DATA.TAB.OPENER, opener);
			tab.data(Module.Accordion.DATA.TAB.PANEL, panel);
			tab.data(Module.Accordion.DATA.TAB.LOADED, !panel.attr('data-url')); //Ajax tabs will be loaded when first opened

			// Tab event handlers
			tab.on('scs-accordion-tab-opening', $.proxy(this.handleOpenTab, this, tab));
			tab.on('scs-accordion-tab-closing', $.proxy(this.handleCloseTab, this, tab));
			openerEl.on('click', $.proxy(this.handleClickOpener, this, tab, opener));
			opener.on('synchronizedTabClick', $.proxy(this.handleClickOpener, this, tab, opener));
			opener.on('focus', $.proxy(this.handleFocusOpener, this, tab, opener));

			// Additional setup
			openerEl.prop('tabindex', -1); //Make the opener focusable
			openerEl.css('cursor', 'pointer'); //Is a clickable element

		},

		/**
		 * Updates the tab data properties to sync with the state represented by the actual class names
		 */
		finalizeTab: function (index, tab) {
			tab = $(tab);

			tab.data(Module.Accordion.DATA.TAB.IS_OPEN, tab.is('.scs-accordion-tab-opened'));

			if (tab.data(Module.Accordion.DATA.TAB.IS_OPEN)) {
				this.openTab(tab);
			}
		},

		/**
		 * Makes sure newly opened tabs are correctly configured (with loaded content)
		 */
		handleOpenTab: function (tab) {
			tab.data(Module.Accordion.DATA.TAB.IS_OPEN, 'opening');
			this.loadTab(tab, function (panel) {
				panel.slideDown($.proxy(this.tabOpened, this, tab));
			});
		},

		/**
		 * Called when the open animation has finished. This is mostly to update classes and to focus the opener.
		 * If there is a carousel inside the panel, it may have to be re-rendered.
		 */
		tabOpened: function (tab) {
			var opener = tab.data(Module.Accordion.DATA.TAB.OPENER);
			var panel = tab.data(Module.Accordion.DATA.TAB.PANEL);

			tab.data(Module.Accordion.DATA.TAB.IS_OPEN, true);
			tab.addClass('scs-accordion-tab-opened').trigger('scs-accordion-tab-opened');
			opener.trigger('focus');
			panel.attr('aria-hidden', 'false');

			$(document).trigger('element-shown', [panel]);
		},

		/**
		 * Makes sure newly closed tabs are correctly disposed of
		 */
		handleCloseTab: function (tab, event) {
			//Prevent closing Parent tab
			event.stopPropagation();
			var panel = tab.data(Module.Accordion.DATA.TAB.PANEL);
			tab.data(Module.Accordion.DATA.TAB.IS_OPEN, null);
			panel.slideUp(function () {
				tab.data(Module.Accordion.DATA.TAB.IS_OPEN, false);
				tab.removeClass('scs-accordion-tab-opened').trigger('scs-accordion-tab-closed');
				panel.attr('aria-hidden', 'true');
				tab.find($('a').each(function(){this.onmouseup = this.blur();}));
			});
		},

		/**
		 * Handles tab heading clicks
		 */
		handleClickOpener: function (tab, opener, event) {
			event.preventDefault();
			event.stopPropagation();

			// not needed to set to false after this line, openBySelector event has already happened
			this.hasBeenClicked = true;

			//Disallow clicks while loading, and during opening and closing
			if (tab.data(Module.Accordion.DATA.TAB.IS_OPEN) === 'opening' || tab.data(Module.Accordion.DATA.TAB.IS_OPEN) === null) {
				return;
			}
			if (tab.data(Module.Accordion.DATA.TAB.IS_OPEN)) {
				this.closeTab(tab);
			}
			else {
				this.openTab(tab);
			}

			if (this.$ctx.data(Module.Accordion.DATA.ACCORDION.TRACKING) && event.type === 'click') {
				var trackedName = opener.find('a').data('tracking-name');
				SCS.tracking.trackPartialPageView(trackedName);
			}

			if (groupCache[this.groupSelector] && groupCache[this.groupSelector].$group.length > 1 && event.type !== 'synchronizedTabClick') {
				var index = opener.closest('.synchronizedaccordion.section').index();
				groupCache[this.groupSelector].$group.find('.synchronizedaccordion.section:eq(' + index + ')')
					.find('.scs-accordion-tab-heading')
					.trigger('synchronizedTabClick');
			}
		},

		/**
		 * When the opener gets focus, make sure to scroll so the content is visible
		 */
		handleFocusOpener: function (tab, op, event) {
			event.preventDefault();

			var opener = tab.data(Module.Accordion.DATA.TAB.OPENER);
			var panel = tab.data(Module.Accordion.DATA.TAB.PANEL);
			var offset = opener.offset();

			if (this.hasBeenClicked && panel.height() && ( $(window).scrollTop() + $(window).height() < offset.top + panel.outerHeight(true) + opener.outerHeight(true) )) {
				window.scrollTo(0, offset.top);
			}
		},

		/**
		 * Makes sure the tab content is loaded
		 */
		loadTab: function (tab, callback) {
			var mod = this;
			var panel = tab.data(Module.Accordion.DATA.TAB.PANEL);

			if (tab.data(Module.Accordion.DATA.TAB.LOADED) === 'loading') {
				return; //Drop the callback because the one that’s gonna be executed on finish is probably the same
			} else if (tab.data(Module.Accordion.DATA.TAB.LOADED)) {
				return callback.call(mod, panel);
			} else {
				tab.data(Module.Accordion.DATA.TAB.LOADED, 'loading'); // "loading" is the intermediate status
				panel.load(panel.attr('data-url'), function () {
					tab.data(Module.Accordion.DATA.TAB.LOADED, true);
					callback.call(mod, panel);
				});
			}
		},

		/**
		 * Opens an individual tab
		 *
		 * @argument tab Either the tab element or a (0-indexed) tab number
		 */
		openTab: function (tab) {
			if (typeof tab === 'number') {
				tab = this.tabs.eq(tab);
			}
			tab.trigger('scs-accordion-tab-opening');
		},

		/**
		 * Closes an individual tab
		 *
		 * @argument tab Either the tab element or a (0-indexed) tab number
		 */
		closeTab: function (tab) {
			if (typeof tab === 'number') {
				tab = this.tabs.eq(tab);
			}
			tab.trigger('scs-accordion-tab-closing');
		}
	});

	Module.Accordion.DATA = {
		ACCORDION: {
			TRACKING: 'tracking-enabled'
		},
		TAB: {
			IS_OPEN: 'modAccordion-isOpen', //Possible values: true, 'opening', false, null (closing)
			OPENER: 'modAccordion-opener',
			PANEL: 'modAccordion-panel',
			LOADED: 'modAccordion-hasBeenLoaded'
		}
	};
}(window.Tc.Module, __webpack_provided_window_dot_Tc_dot_$, window.SCS, window.debug || window.console));

}.call(window));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_Tc_dot_$) {/*** IMPORTS FROM imports-loader ***/
var loadTerrific = __webpack_require__(1);
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function(Accordion, $) {
	'use strict';

	/**
	 * Accordion single mode skin
	 * Allows only one tab to be open at a time
	 *
	 * @author TAASCRAA
	 * @namespace Tc.Module.Accordion
	 * @class SingleMode
	 * @extends Tc.Module.Accordion
	 */
	Accordion.SingleMode = function(parent) {
		this.setupAccordion = function($ctx) {
			parent.setupAccordion.apply(this, arguments);
			var first = this.tabs.filter('.scs-accordion-tab-opened').eq(0);
			if(!first.length) {
				// If no tab was open initially, we’ll use the first tab
				first = this.tabs.eq(0).addClass('scs-accordion-tab-opened');
			}
			this.tabs.not(first).removeClass('scs-accordion-tab-opened');
		};

		this.handleOpenTab = function(tab) {
			var mod = this;
			parent.handleOpenTab.apply(this, arguments);
			// Close all other tabs
			this.tabs.not(tab).each(function() {
				mod.closeTab($(this));
			});
		};

		this.handleCloseTab = function(tab) {
			if(this.tabs.not(tab).filter(function() {
				// Filter open or opening tabs
				return !!$(this).data(Accordion.DATA.TAB.IS_OPEN);
			}).length === 0) {
				// Don’t allow the last tab to close
				return;
			} else {
				parent.handleCloseTab.apply(this, arguments);
			}
		};
	};

}(window.Tc.Module.Accordion, __webpack_provided_window_dot_Tc_dot_$));
}.call(window));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_Tc_dot_$) {/*** IMPORTS FROM imports-loader ***/
var loadTerrific = __webpack_require__(1);
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function(Accordion, $) {
	'use strict';

	function findPositioningParent($element) {
		var parent = $element.parent();
		while(parent.length && parent.css('overflow') !== 'hidden') {
			parent = parent.parent();
		}
		return parent;
	}

	// Searches the positioningParent’s height in accordance with some conventions
	function findHeight(heightParent) {
		var height = heightParent.find('[data-height]').data('height');
		if(!height) {
			height = heightParent.outerHeight();
		}
		return height;
	}

	/**
	 * Accordion full bleed skin
	 * Tries to take up as much vertical space as possible
	 *
	 * @author TAASCRAA
	 * @namespace Tc.Module.Accordion
	 * @class FullBleed
	 * @extends Tc.Module.Accordion
	 */
	Accordion.FullBleed = function(parent) {
		this.availableContentHeight = null;

		this.setupAccordion = function() {
			var heightParent = findPositioningParent(this.$ctx);
			if(heightParent.length) {
				this.availableContentHeight = findHeight(heightParent);
			}
			parent.setupAccordion.apply(this, arguments);
		};

		this.after = function() {
			parent.after.apply(this, arguments);
			if(!this.availableContentHeight) {
				return;
			}
			this.$ctx.css({
				position: 'absolute',
				top: 0,
				left: 0,
				bottom: 0,
				right: 0
			});
		};

		this.setupTab = function(index, tab) {
			parent.setupTab.apply(this, arguments);
			if(!this.availableContentHeight) {
				return;
			}
			tab = $(tab);
			var opener = tab.data(Accordion.DATA.TAB.OPENER);
			this.availableContentHeight -= opener.outerHeight();
		};

		this.tabOpened = function(tab) {
			parent.tabOpened.apply(this, arguments);
			if(!this.availableContentHeight) {
				return;
			}
			var panel = tab.data(Accordion.DATA.TAB.PANEL);
			var box = panel.outerHeight() - panel.height();
			panel.css({
				overflowY: 'auto',
				overflowX: 'hidden',
				height: ''+(this.availableContentHeight-box)+'px'
			});
		};

		// Diable scrolling the view on focus
		this.handleFocusOpener = $.noop;
	};

}(window.Tc.Module.Accordion, __webpack_provided_window_dot_Tc_dot_$));
}.call(window));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_Tc_dot_$) {/*** IMPORTS FROM imports-loader ***/
var loadTerrific = __webpack_require__(1);
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function (Module, $) {
	'use strict';

	/**
	 * Background Container
	 *
	 * @author Matthias Inauen
	 * @namespace Tc.Module
	 * @class BackgroundContainer
	 * @extends Tc.Module
	 */
	Module.BackgroundContainer = Module.extend({

		CHANNEL_INTERACTIVE_MODE: 'BCInteractiveMode',
		isEditMode: false,

		/**
		 * @method on
		 * @param {Function} callback function
		 * @return void
		 */
		on: function (callback) {
			this.isEditMode = window.CQ && window.CQ.WCM && window.CQ.WCM.isEditMode(true);
			this.interactiveMode = this.$ctx.hasClass('interactivemode');
			this.noDeactivate = this.$ctx.hasClass('no-deactivate');
			this.mobileGallery = this.$ctx.closest('.modMobileGallery');
			this.tabNavigationContent = this.$ctx.closest('.modTabNavigationContent');
			this.slideChangeHandlerFunction = this.handleCarouselSlideChanged.bind(this);

			if(this.interactiveMode) {
				this.sandbox.subscribe(this.CHANNEL_INTERACTIVE_MODE, this);
				this.interactiveElementName = this.$ctx.data('interactive-name');
				this.interactiveElementValue = this.$ctx.data('interactive-value');
			}

			this.tailBackgroundColor();

			callback();
		},

		after: function() {
			if(this.interactiveMode) {
				this.addEvents();
			}
		},

		/**
		 * Add Event Listeners
		 * @param skipNextSlideChangedEvent
		 */
		addEvents: function(skipNextSlideChangedEvent){
			this.$ctx.on('click', $.proxy(this.handleBackgroundClicked, this));
			// scCarouselSlideChanged triggers after an animation time passed. Sometimes you need to skip one event
			// but listen to the following events. (i.e. when onUpdateInteractiveState is called)
			if(skipNextSlideChangedEvent){
				this.mobileGallery.one('scCarouselSlideChanged', this.handleSkipNextEvent.bind(this));
			}
			else {
				this.handleSkipNextEvent();
			}
		},

		removeEvents: function() {
			this.$ctx.off('click');
			this.mobileGallery.off('scCarouselSlideChanged', this.slideChangeHandlerFunction);
		},

		handleSkipNextEvent: function() {
			this.mobileGallery.on('scCarouselSlideChanged', this.slideChangeHandlerFunction);
		},

		handleCarouselSlideChanged: function(event, carouselListItem) {
			if($.contains(carouselListItem[0], this.$ctx[0])) {
				this.interactiveStateActivate();
				this.broadcastInteractiveState();
			}
			else {
				this.interactiveStateDeactivate();
			}
		},

		handleBackgroundClicked: function(event){
			var currentTime = new Date().getTime();
			var $eventTarget = $(event.currentTarget);

			if (!$eventTarget.is(this.$ctx)) {
				return;
			}
			// prevent double-clicks
			if(this.lastClickTime && (currentTime - this.lastClickTime) < 100) {
				return;
			}

			this.lastClickTime = currentTime;

			if (this.isActive) {
				this.interactiveStateDeactivate(true);
			} else {
				this.interactiveStateActivate();
				this.broadcastInteractiveState();
			}
		},

		interactiveStateActivate: function () {
			if (this.isActive) {
				return;
			}

			this.isActive = true;
			this.$ctx.addClass('active');
		},

		updateTabNavigation: function() {
			this.tabNavigationContent.triggerHandler('activate');
		},

		updateMobileCarousel: function(){
			this.mobileGallery.trigger('scCarouselSlideToElement', [this.$ctx]);
		},

		broadcastInteractiveState: function() {
			this.fire('interactiveStateChanged', {
				name: this.interactiveElementName,
				value: this.interactiveElementValue
			}, [this.CHANNEL_INTERACTIVE_MODE]);
		},

		interactiveStateDeactivate: function (userInteraction) {
			if(userInteraction && this.noDeactivate) {
				return;
			}

			this.isActive = false;
			this.$ctx.removeClass('active');
		},

		onUpdateInteractiveState: function (data) {
			if(data.name !== this.interactiveElementName) {
				return;
			}

			if(data.value === this.interactiveElementValue) {
				this.removeEvents();
				this.interactiveStateActivate();
				this.updateTabNavigation();
				this.updateMobileCarousel();
				this.addEvents(true);
			} else {
				this.interactiveStateDeactivate();
			}
		},

		tailBackgroundColor: function() {
			var $backgroundColor = this.$ctx.css('backgroundColor');
			var $tail = this.$ctx.find('.tail');

			$tail.css('borderColor', $backgroundColor);
		}
	});
}(window.Tc.Module, __webpack_provided_window_dot_Tc_dot_$));

}.call(window));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var loadTerrific = __webpack_require__(1);
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function($) {
	"use strict";
	/*globals Tc */

	/**
	 * Brightcove Overlay
	 *
	 * @author Zeljko Curcic
	 * @namespace Tc.Module
	 * @class BrightcoveOverlay
	 * @extends Tc.Module
	 */
	Tc.Module.BrightcoveOverlay = Tc.Module.extend({

		on: function(callback) {
			var mod = this,
				$ctx = mod.$ctx,
				$video = $ctx.children('.brightcove-video-container');


			$ctx.on('click', '.overlay-link', function(e){
				e.preventDefault();
				mod.createOverlay($video);
			});

			callback();
		},
		createOverlay : function($video){
			var mod = this,
				$ctx = mod.$ctx,
				$link = $ctx.children('.overlay-link'),
				videoWidth = $link.data('lightbox-width'),
				videoHeight = $link.data('lightbox-height');

			if (!$video.is(':data(ui-dialog)')){
				$video.dialog({
					classes: {'ui-dialog': 'ui-brightcove-overlay'},
					title : '',
					autoOpen : false,
					width : videoWidth,
					minHeight : videoHeight,
					appendTo : $ctx
				});
			}
			$video.dialog('open');
		}
	});
}(Tc.$));

}.call(window));

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var loadTerrific = __webpack_require__(1);
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function($) {
    /**
     * @author Nikola Lakovic
     * @namespace Tc.Module.ContactCollapsable
     * @class ContactCollapsable
     * @extends Tc.Module
     */
    Tc.Module.ContactCollapsable = Tc.Module.extend({

        /**
         * @method on
         * @param {Function} callback function
         * @return void
         */

        on: function(callback) {
            var mod = this,
                $ctx = mod.$ctx,
                $contact = $ctx.find('.contact'),
                $content = $ctx.find('.content').hide(),
                $link = $contact.find('a');
                $path = $ctx.closest('.modOrderOverlay').data('path');

            if (!$path) {
                $ctx.hide();
            } else {
                $ctx.siblings('.modOrderOverlayOrderButtons').addClass('irrelevant'); 

                // load content form help pages
                $content.load($path + ' .helpWidgetCF', function(response, status, xhr) {
                    if (status == "error") {
                        debug.log('Tc.Module.ContentCollapsable > no valid path entered', $path);
                        return;
                    } else {
                        $(this).addClass('loaded');
                    } 
                });
            }

            $contact.click(function() {
                if(!$content.hasClass('loaded')) {
                    $content.slideDown(200, $.proxy(mod.centerOverlay, mod));
                    setTimeout($.proxy(mod.centerOverlay, mod), 50);
                    setTimeout($.proxy(mod.centerOverlay, mod), 100);
                    setTimeout($.proxy(mod.centerOverlay, mod), 150);
                    $link.toggleClass('opened');
                } else {
                    $link.toggleClass('opened');
                    $content.slideToggle(200, $.proxy(mod.centerOverlay, mod));
                    setTimeout($.proxy(mod.centerOverlay, mod), 50);
                    setTimeout($.proxy(mod.centerOverlay, mod), 100);
                    setTimeout($.proxy(mod.centerOverlay, mod), 150);
                }
            });

            callback();
        },
        
        centerOverlay: function () {
            var mod = this;
            mod.fire('CenterOverlay');
        },
    });
})(Tc.$);

}.call(window));

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_Tc_dot_$) {/*** IMPORTS FROM imports-loader ***/
var loadTerrific = __webpack_require__(1);
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function (Module, $, debug) {
	'use strict';

	/**
	 * Initialize all SDX Information Call Out.
	 *
	 * Used for Desktop and Mobile
	 *
	 * @author Rami Attallah
	 */
	Module.CallOutSdx = Module.extend({


		on: function (callback) {
			var mod = this,
				$ctx = mod.$ctx;

			mod.isMobileOnly = $ctx.hasClass('isMobileOnly');
			mod.isMobile = SCS.utils.isMobilePage();

			// Configuration
			mod.content = $ctx.text();
			if (mod.isMobileOnly && !mod.isMobile) {
				// render as text on desktop
				$ctx.removeClass('mod modCallOut isMobileOnly').attr('style', '');
				return;
			}

			$ctx.hide();

			callback();
		},

		after: function () {
			var mod = this,
				$callout = $('<button/>'),
				$icon = $('<i/>');

			$icon.addClass('icon icon-046-information-circle');
			$callout.attr('aria-label', mod.content)
				.addClass('toolbar__item item--show tooltip')
				.append($icon);
			if(mod.$ctx.hasClass('right')) {
				$callout.addClass('tooltip--right');
			}
			mod.$ctx.replaceWith($callout);
		}
	});
}(window.Tc.Module, __webpack_provided_window_dot_Tc_dot_$, window.debug));
}.call(window));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_Tc_dot_$) {/*** IMPORTS FROM imports-loader ***/
var loadTerrific = __webpack_require__(1);
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function (Module, $) {
	'use strict';

	/**
	 * Card.
	 *
	 * @author TAAATRA1
	 * @namespace Tc.Module
	 * @class Card
	 * @extends Tc.Module
	 */
	Module.Card = Module.extend({

		on: function (callback) {
			var $ctx = this.$ctx;

			if($ctx.hasClass('cardClickable')) {
				$ctx.on('click', $.proxy(this.handleClick, this));
			}
			if($ctx.hasClass('selected')) {
				this.handleClick();
			}

			$ctx.closest('.link > a').css('text-decoration', 'none');

			callback();
		},

		handleClick: function () {
			var $ctx = this.$ctx;
			if($ctx.hasClass('active')) {
				return;
			}
			var $parentGrid = $ctx.closest('.modGridLayout, .gridlayout');
			var onetimeCharge = $ctx.data('onetime-charge'),
				monthlyPriceCharge = $ctx.data('price'),
				$input = $ctx.find('input');

			$parentGrid.find('.modCard.cardClickable').removeClass('active selected').removeAttr('style');
			$parentGrid.find('.modCard.cardClickable input').val('').removeAttr('data-onetime-charge data-price');
			$ctx.addClass('active');
			$input.val($ctx.data('active-value'));
			if(onetimeCharge) {
				$input.attr('data-onetime-charge', onetimeCharge);
			}
			else if (monthlyPriceCharge){
				$input.attr('data-price', monthlyPriceCharge);
			}
			this.fire('PriceAdded', {}, ['formpriceupdate']);
		}
	});

}(window.Tc.Module, __webpack_provided_window_dot_Tc_dot_$));

}.call(window));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_Tc_dot_$) {/*** IMPORTS FROM imports-loader ***/
var loadTerrific = __webpack_require__(1);
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function($, Tc, SCS, debug) {
	'use strict';

	/**
	 * Cookie Opt-out
	 *
	 * @author Zeljko Curcic
	 * @namespace Tc.Module
	 * @class CookieOptOut
	 * @extends Tc.Module
	 */

	Tc.Module.CookieOptOut = Tc.Module.extend({

		cookieName: 'optout',

		/**
		 * Initializes CookieOptOut and attaches events
		 *
		 * @method on
		 * @param {Function} callback function
		 * @return void
		 */
		on: function(callback) {
			var mod = this,
				$ctx = mod.$ctx;

			mod.isMobile = SCS.utils.isMobilePage();
			mod.cbox = $ctx.find('#cookieOptOut');
			mod.overlay = $ctx.closest('.ui-dialog-lightbox-content');

			// TODO: Investigate how to make the checkbox work on mobile without adding this line to the module
			if (mod.isMobile) {
				mod.cbox.customInput();
			}

			if ($.getCookie(mod.cookieName) === 1) {
				mod.cbox.prop('checked', true);
			}

			$ctx.on('click', '.secondary-button', function () {
				if (mod.overlay.length) {
					mod.overlay.dialog('close');
				} else if (window.history.length) {
					window.history.back();
				}
			});

			$ctx.on('click', '.primary-button', $.proxy(mod.handleCookie, mod));

			callback();
		},

		handleCookie: function () {
			var mod = this,
				cookieValue = mod.cbox.filter(':checked').length,
				domain = location.hostname.indexOf('.swisscom.ch') >= 0 ? '.swisscom.ch' : null;

			$.setCookie(mod.cookieName, cookieValue, 365, null, domain);
			debug.log('Tc.Module.CookieOptOut >', mod.cookieName, cookieValue, 365, null, domain);

			if (mod.overlay.length) {
				mod.overlay.dialog('close');
			}
		}
	});
}(__webpack_provided_window_dot_Tc_dot_$, window.Tc, window.SCS = window.SCS || {}, window.debug));

}.call(window));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_Tc_dot_$) {/*** IMPORTS FROM imports-loader ***/
var loadTerrific = __webpack_require__(1);
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function ($, Tc, debug) {
	'use strict';

	/**
	 * Device Switch
	 *
	 * @author Zeljko Curcic
	 * @namespace Tc.Module
	 * @class DeviceSwitch
	 * @extends Tc.Module
	 */
	Tc.Module.DeviceSwitch = Tc.Module.extend({

		config : {
			cookieName : 'pps',
			cookieValueMobile : 'mobile',
			cookieValueDesktop : 'desktop',
			days : 1
		},

		on: function(callback) {
			var mod = this,
				cookieName = mod.config.cookieName,
				days = mod.config.days,
				selectMobile = false;

			mod.$ctx.on('click', 'a', function (e) {
				e.preventDefault();

				selectMobile = $(this).hasClass('scs-dsm');

				var options = {
					path : '/',
					expiresAt : mod.setCookieExpiresInDays(days)
				};

				// Set cookie for 24 hrs
				if (selectMobile) {
					$.cookies.set(cookieName, mod.config.cookieValueMobile, options);
				} else {
					$.cookies.set(cookieName, mod.config.cookieValueDesktop, options);
				}
				debug.log('Tc.Module.DeviceSwitch > Switch to' + (selectMobile ? 'Mobile' : 'Desktop'));
				window.location.reload();
			});

			callback();
		},

		/**
		 * Creates new date object adding "days" to the current date and time
		 *
		 * @method setCookieExpiresInDays
		 * @param days
		 * @return {Date}
		 */
		setCookieExpiresInDays: function (days) {
			var date = new Date();
			date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
			return date;
		}

	});
}(__webpack_provided_window_dot_Tc_dot_$, window.Tc, window.debug));

}.call(window));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var loadTerrific = __webpack_require__(1);
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function($) {
	
	'use strict';

	/**
	 * Dynamic Support module
	 * @author Nikola Lakovic
	 * @namespace Tc.Module.DynamicSupport.js
	 * @class DynamicSupport
	 * @extends Tc.Module
	 *
	 **/

	Tc.Module.DynamicSupport = Tc.Module.extend({

		on: function(callback) {

			var mod = this,
				$ctx = this.$ctx,
				$dynamicsupportpar = $ctx.find('.dynamicsupportpar'),
				$dynamicSupportHolder = $ctx.find('.dynamicSupportHolder'),
				$language = $('html').attr('lang'),
				$content = '';

			$.ajax({
				url: '/management/rest/v1/support_information/selected',
				type: 'GET',
				dataType: 'json',
				processData: false,
				contentType: 'application/json; charset=UTF-8',
				success: function (data) {
					mod.tmplItem = doT.template($('#support', $ctx).html());
					$.each(data, function(index, value) {
						if(index === $language) {
							$content = $(mod.tmplItem(data[$language]));
							return false;
						} else {
							$content = $(mod.tmplItem(data['en']));
						}
					});
					
					$dynamicSupportHolder.append($content);
					if($dynamicSupportHolder.children().length > 1) {
						$dynamicsupportpar.hide();
					} 
				},
				error: function () {
					debug.log("Tc.Module.DynamicSupport.js module > Ajax call went wrong");
				}
			});

			callback();
		}
	});

})(Tc.$);
}.call(window));

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var loadTerrific = __webpack_require__(1);
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function($) {
	"use strict";
	/*globals Tc */

	/**
	 * DMIS DLC
	 *
	 * @author Thomas Amsler
	 * @namespace Tc.Module
	 * @class DmisDlc
	 * @extends Tc.Module
	 */

	Tc.Module.DmisDlc = Tc.Module.extend({

		/**
		 * Initializes DmisDlc and attaches events
		 *
		 * @method on
		 * @param {Function} callback function
		 * @return void
		 */
		on: function(callback) {

			var mod = this,
				$ctx = mod.$ctx;
			
			mod.results = [];
			mod.allresults = [];
			mod.container = $('.dlc-container', $ctx);
			mod.resultsPerPage = parseInt(mod.container.data('results-per-page'));
			mod.end = mod.resultsPerPage;
			mod.button = $('button.more-results', $ctx);
			mod.tmplRow = doT.template($('.tmpl-dlc-row', $ctx).html());
			
			var hashs = (location.hash.substring(1)).split('&');
			if (hashs.length && hashs[0] != '') {
				for (var i=0; i<hashs.length; i++) {
					var parts = hashs[i].split('=');
					var select = $('select[name="dlc-' + parts[0] + '"]');
					select.find('option').filter(function(index) { return $(this).text() === parts[1]; }).prop('selected', true);
					select.change();
				}
			}
			mod.getResults(0);

			$('select', $ctx).on('change', function() {
				mod.displayData();
			});
			
			$ctx.find('.reset a').on('click', function () {
				var form = $(this).closest('form');
				
				form[0].reset();
				//alert("ok2" + form.find('select').trigger);
//				form.find('select').eq(0).trigger('change');
				
				form.find('select').eq(0).find('option').eq(0).attr('selected',true);
				form.find('select').eq(1).find('option').eq(0).attr('selected',true);
				form.find('select').eq(2).find('option').eq(0).attr('selected',true);
				form.find('select').eq(0).trigger('change')
				form.find('select').eq(1).trigger('change')
				form.find('select').eq(2).trigger('change')
				
			});

			callback();
		},
		
		doPaging: function(start) {
			var mod = this;
			if (mod.results.length > (start + mod.resultsPerPage)) {
				mod.end = start + mod.resultsPerPage;
				mod.button.off('click').click(function() {
					mod.doPaging(mod.end);
				}).removeClass('is-hidden');
			}
			else {
				mod.end = mod.results.length;
				mod.button.addClass('is-hidden');
			}
			mod.showResults();
		},
		
		showResults: function() {
			var mod = this;
			var rows = mod.container.find('.row');
			for (var i=0; i<mod.end; i++) {
				$(rows[i]).removeClass('is-hidden');
			}
		},
	
		filterResults: function()
		{
			var mod = this,
			$ctx = mod.$ctx;
			
			var yearFilter = $('select[name="dlc-year"]', $ctx).val();
			var areaFilter = $('select[name="dlc-area"]', $ctx).val();
			var topicFilter = $('select[name="dlc-topic"]', $ctx).val();

			mod.results=mod.allresults;
			
			mod.filterResultsByCriteria(yearFilter);
			mod.filterResultsByCriteria(areaFilter);
			mod.filterResultsByCriteria(topicFilter);
			mod.results.sort(mod.sortByDate);
		},
		
		filterResultsByCriteria: function(filterCriteria)
		{
			var mod = this,
			$ctx = mod.$ctx;
			
			if (filterCriteria!=undefined && filterCriteria.length>0)
			{
			var tmpResults = [];
			var splittedFilter=filterCriteria.split("/");
			var filterKey = splittedFilter[0];
			var filterVal = splittedFilter[1];
			
			for (var i=0; i<mod.results.length; i++) {
				if (mod.results[i].hasOwnProperty(filterKey) && mod.results[i][filterKey]==filterVal)
					{
					tmpResults.push(mod.results[i]);
					}
				}
			mod.results=tmpResults;
			}
			
			
		},
		
		sortByDate: function(a, b)
		{
			var aName = a['sortDate'];
			var bName = b['sortDate']; 
			if (aName==bName)
				{
				return a['title'].localeCompare(b['title']);
				}

			  return ((aName > bName) ? -1 : ((aName < bName) ? 1 : 0));	

		},
		
		displayData: function() {
			var mod = this,
			$ctx = mod.$ctx;			
			mod.container.empty();
			mod.button.addClass('is-hidden');
			mod.filterResults();
			if (mod.results.length > 0) {
				if (mod.end > mod.results.length) {
					mod.end = mod.results.length;
				}
				$('.dlc-no-results', $ctx).addClass('is-hidden');
				$('.dlc-results', $ctx).removeClass('is-hidden'); 
				for (var i=0; i<mod.results.length; i++) {
					mod.results[i].cls = 'row is-hidden';
					$(mod.tmplRow(mod.results[i])).appendTo(mod.container);
				}
				mod.doPaging(0);
			}
			else {
				$('.dlc-no-results', $ctx).removeClass('is-hidden');
				$('.dlc-results', $ctx).addClass('is-hidden');
			}
					
		},
		getResults: function() {
			var mod = this,
				$ctx = mod.$ctx;
			
			mod.container.empty();
			$('.scs-loadingRotator', $ctx).removeClass('is-hidden');
			$.ajax({
				url: mod.container.data('url'),
				dataType: 'json',
				type: 'GET',
				data: {
					},
				success: function (data) {
					$('.scs-loadingRotator', $ctx).addClass('is-hidden');
					mod.allresults = data.results || [];
					mod.filterResults();
					if (data.error) {
						$('.dlc-error', $ctx).removeClass('is-hidden');
					}
					else
						{
						mod.displayData();
						}
					
				},
				error: function (data) {
					mod.allresults = [];
					$('.scs-loadingRotator', $ctx).addClass('is-hidden');
					$('.dlc-error', $ctx).removeClass('is-hidden');
				}
			});
		}
	});
}(Tc.$));
}.call(window));

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_Tc_dot_$, jQuery) {/*** IMPORTS FROM imports-loader ***/
var loadTerrific = __webpack_require__(1);
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function (Module, $, window) {
	'use strict';

	Module.EloquaLP = Module.extend({

		on: function (callback) {
			this.loadData();
			callback();
		},

		// case subscription center, email provide a link with param elq=<eloqua-id>
		getUrlParam: function(name) {
			var queryParams = new URLSearchParams(window.location.search);
			var results = queryParams.get(name);
			return (results !== null) ? results || 0 : false;
		},

		// handles for unique fields
		handleWebinarUnique: function(form) {
			var testField = $('[name="WebinarUnique"]')[0];
			if(testField === undefined) {
				return;
			}

			form.addEventListener("submit", function (event) {
				var webinarUnique = document.getElementsByName("WebinarUnique")[0];
				var webinarId = document.getElementsByName("WebinarId")[0];
				var email = document.getElementsByName("C_EmailAddress")[0];
				webinarUnique.value = webinarId.value + "(" + email.value + ")";
				// to set the Lead topic
				var unique = document.getElementsByName("Unique")[0];
				var topic = document.getElementsByName("Topic")[0];
				unique.value = topic.value + "_" + email.value;
			});
		},

		handleEventUnique: function(form) {
			var testField = $('[name="EventUnique"]')[0];
			if(testField === undefined) {
				return;
			}

			form.addEventListener("submit", function (event) {
				var eventUnique = document.getElementsByName("EventUnique")[0];
				var eventname = document.getElementsByName("Eventname")[0];
				var email = document.getElementsByName("C_EmailAddress")[0];
				eventUnique.value = eventname.value + "_" + email.value;
				// step to make the Lead unique value
				var unique = document.getElementsByName("Unique")[0];
				var topic = document.getElementsByName("Topic")[0];
				unique.value = topic.value + "_" + email.value;
			});
		},

		handleOrderUnique: function(form) {
			var testField = $('[name="Date"]')[0];
			if(testField === undefined) {
				return;
			}

			form.addEventListener("submit", function (event) {
				var email = document.querySelector("[name=C_EmailAddress]:not(meta)");
				var unique = document.querySelector("[name=Unique]:not(meta)");
				var topic = document.querySelector("[name=Topic]:not(#Topic)");
				unique.value = topic.value + "_" + email.value;
				var date = document.querySelector("[name=Date]:not(meta)");
				date.value = (new Date()).toLocaleString("en-GB");
			});
		},

		handleOfferUnique: function(form) {
			var productHolder = undefined;
			var testField = $('[name="ProductOwner"]')[0];
			if(testField === undefined) {
				return;
			}

			form.addEventListener("submit", function (event) {
				var email = document.querySelector("[name=C_EmailAddress]:not(meta)");
				var unique = document.querySelector("[name=Unique]:not(meta)");
				var topic = document.querySelector("[name=Topic]:not(#Topic)")
				unique.value = topic.value + "_" + email.value;
				var product = document.querySelector("[name=Product]:not(#Product)");
				var productOwner = document.querySelector('[name=ProductOwner]:not(#ProductOwner)');
				var eDate = (new Date()).toLocaleString("en-GB");

				productHolder = productHolder || product.value;
				product.value = eDate + " -ProductName: " + productHolder + " -ProductOwner: " + productOwner.value;
			});
		},

		handleExpertUnique: function(form) {
			var productHolder = undefined;
			var testField = $('[name="ExpertEmail"]')[0];
			if(testField === undefined) {
				return;
			}

			form.addEventListener("submit", function (event) {
				var email = document.querySelector("[name=C_EmailAddress]:not(meta)");
				var unique = document.querySelector("[name=Unique]:not(meta)");
				var topic = document.querySelector("[name=Topic]:not(#Topic)");
				unique.value = topic.value + "_" + email.value;

				var eDate = (new Date()).toLocaleString("en-GB");
				var product = document.querySelector("[name=Product]:not(#Product)");

				productHolder = productHolder || product.value;
				product.value = eDate + " -Product: " + productHolder;

			});
		},

		initSubmitListener: function(form) {
			var fieldValidities = new Map();
			function initLiveValidationListeners() {
				if (!('LiveValidationForm' in window)) {
					setTimeout(initLiveValidationListeners, 100);
					return;
				}
				var lv = LiveValidationForm.getInstance(form);
				for (var i = 0; i < lv.fields.length; i++) {
					const lvField = lv.fields[i];
					fieldValidities.set(lvField, false);
					// eslint-disable-next-line @typescript-eslint/unbound-method
					var oldOnValid = lvField.onValid;
					lvField.onValid = function () {
						fieldValidities.set(lvField, true);
						return oldOnValid.apply(this, arguments);
					};
					// eslint-disable-next-line @typescript-eslint/unbound-method
					var oldOnInvalid = lvField.onInvalid;
					lvField.onInvalid = function () {
						fieldValidities.set(lvField, false);
						return oldOnInvalid.apply(this, arguments);
					};
				}
			}
			initLiveValidationListeners();

			var elqAdobeID = form.querySelector('input[name=Eloqua-Adobe-ID]');
			form.addEventListener("submit", function () {
				LiveValidation.massValidate(LiveValidationForm.getInstance(form).fields);

				if (Array.from(fieldValidities.values()).every(Boolean)) {
					doTracking(elqAdobeID);
					replaceWithLoadingButton(form);
				}
			});

		},


		handleUnique: function(form) {
			this.handleWebinarUnique(form);
			this.handleEventUnique(form);
			this.handleOrderUnique(form);
			this.handleOfferUnique(form);
			this.handleExpertUnique(form);
		},

		getScript: function (scriptsWithSource, scripts, i) {
			i = i || 0;
			var mod = this;
			$.getScript($(scriptsWithSource[i]).attr("src"), function () {
				i++;
				if (scriptsWithSource.length === i) {
					scripts.forEach(function (script) {
						$("head").append(script);
					});
				}
				;
				scriptsWithSource.length > i && mod.getScript(scriptsWithSource, scripts, i);
			});
		},

		prepareForm: function(data) {

			// Remove the html tag tracking pixel
			data = data.slice(0, data.lastIndexOf('</html>') + 7);
			var responseDOM = $.parseHTML(data, true);
			// The main div in the body of the landing page
			var mainDivElement;
			// array that will contain script tags with a source
			var scriptsWithSource = [];
			// array that will contain script tags without a source
			var scripts = [];

			// Iterate over node list. Meta and script tags should be appended in the head, while the main div of the body should be saved for later
			responseDOM.forEach(function (node) {
				if (node.tagName == undefined) return;
				if (node.tagName.toLowerCase() == "meta" || node.tagName.toLowerCase() == "script") $("head").append(node);
				if (node.tagName.toLowerCase() == "div") mainDivElement = node;
			})

			// Iterate over main div elements to find script inserted in the body, append them in the correct list and remove them from the div
			$(mainDivElement).find("*").each(function (index) {
				if (this.tagName == undefined) return;
				if (this.tagName.toLowerCase() == "script") {
					if ($(this).attr("src") != null) {
						scriptsWithSource.push(this);
					} else {
						scripts.push(this);
					}
					this.remove();
				}
			});

			// Replace the content div with the main div (now stripped of the script tags)
			this.$ctx.append(mainDivElement);
			//$("#content").replaceWith(mainDivElement);

			// Scripts with a source should be appended to head and then loaded
			this.getScript(scriptsWithSource, scripts);

			// Insert meta values in html body fields
			$('.hiddenFieldParsys :input').each(function () {
				$('.modEloquaLP form :input[name=' + this.name + ']').val($(this).attr("value"));
			});

			$('.field-control-wrapper .list-order.one-column').parent().css('display', 'block');

			const twoCol = $('.layout-col.col-sm-6');
			twoCol.css('flex', '0 0 100%').css('max-width', '100%');
			twoCol.parent().css('flex', '0 0 50%').css('max-width', '50%');

			// Insert success/error url values in html body fields
			$('form :input[name=' + this.$ctx.data('lp-error-key') + ']').val(this.$ctx.data('lp-error-url'));
			$('form :input[name=' + this.$ctx.data('lp-success-key') + ']').val(this.$ctx.data('lp-success-url'));

			var form = document.getElementsByClassName("elq-form")[0];
			if(form === null) {
				return;
			}
			this.handleUnique(form);
			this.initSubmitListener(form);
			// Modify the default onSubmit, to handle additional logic of the form
			/**
			 * NOTE: here I suppose there is only a form tag in the html page.
			 *
			 * **/
			$('form').removeAttr('onsubmit')
				.submit(function (event) {
					// On submit, populate the hidden field Unique
					$("form :input[name=Unique]").val($("form :input[name=Topic]").val() + "_" + $("form :input[name=C_EmailAddress]").val());
				});


		},

		loadData: function () {

			var mod = this;
			var $ctx = this.$ctx;
			var subdirectory = 'b2bmarketing-nocookie';
			if (window.SCS && window.SCS.datalayer && window.SCS.datalayer.getConsent('visitorRecognition')) {
				subdirectory = 'b2bmarketing';
			}
			var ajaxUrl = '/portal-services/' + subdirectory +'/LP=' + encodeURIComponent($ctx.data('lp-id'));
			var elq = encodeURIComponent(this.getUrlParam("elq"));

			jQuery.ajax({
				type: 'GET',
				async: true,
				dataType: 'html',
				data: {
					elq_ck: 0,
					elq: elq
				},
				url: ajaxUrl
			})
				.done(function(data) { mod.prepareForm.call(mod, data);})
				.error(function (xhr, state, err) {
					// xhr === req
					console.log('error', this, xhr, state, err);
				});

		},

	});

	function doTracking(elqAdobeID) {
		if (!elqAdobeID) {
			return;
		}
		var uuid = crypto.randomUUID();
		elqAdobeID.value = uuid;

		if (!window.SCS || !window.SCS.datalayer) {
			return;
		}

		const data = window.SCS.datalayer.cloneMandatoryData();
		data.event = {
			action: "button",
			label: "aaeloquaid",
			location: "leadforms",
			category: "eloqua"
		};
		data.apps = {
			analytics: {
				aaeloquaid: uuid
			}
		};
		window.SCS.datalayer.track(data);
	}


	function replaceWithLoadingButton(form) {
		const button = form.querySelector('input[type="submit"]');
		button.setAttribute('style', 'display: none;');
		const sdxButton = document.createElement('sdx-button');
		sdxButton.loading = true;
		button.parentElement.prepend(sdxButton);
	}

}(window.Tc.Module, __webpack_provided_window_dot_Tc_dot_$, window));

}.call(window));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0), __webpack_require__(0)))

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var loadTerrific = __webpack_require__(1);
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function ($) {
	/*
	 * Dependencies:
	 * TerrificJs 2.0.1,
	 * jQuery 1.7 or greater,
	 * jquery.placeholder.min.js,
	 *
	 */

	'use strict';
	/*globals Tc */
	/*jshint smarttabs:true */

	Tc.Module.EndlessScrollList = Tc.Module.extend({

		on: function (callback) {
			var mod = this;
			mod.url = mod.$ctx.data('url') || '';
			mod.page = mod.$ctx.data('start') || 0;
			mod.container = mod.$ctx.find('.scroll-list-container');
			mod.loadingIndicator = mod.$ctx.find('.modLoadingIndicator');
			mod.loadingIndicator.on('visible', $.proxy(mod.loadContent, mod));
			callback();
		},

		getUrl: function () {
			var mod = this,
				url = mod.url;
			url = url.replace('${page}', mod.page);
			return url;
		},

		loadContent: function () {
			var mod = this, newContent;
			if (!mod.finished && !mod.loading) {
				mod.loading = true;
				$.ajax({
					url: mod.getUrl(),
					success: function (response) {
						mod.page++;
						mod.loading = false;
						response = (response || '').trim();
						if (response) {
							newContent = $('<div>').addClass('scroll-list-page').html(response);
							mod.container.append(newContent);
							SCS.utils.initNewModules(newContent);
						} else {
							mod.finished = true;
							mod.loadingIndicator.addClass('hidden');
							mod.loadingIndicator.trigger('stop');
						}
					},
					error: function () {
						mod.loading = false;
					}
				});
			}
		}
	});

}(Tc.$));
}.call(window));

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_Tc_dot_$, jQuery) {/*** IMPORTS FROM imports-loader ***/
var loadTerrific = __webpack_require__(1);
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function (Tc, $) {
	'use strict';

	/*
	 * Dependencies:
	 * TerrificJs 2.0.1,
	 * jQuery 1.6.4 or greater
	 */

	/**
	 * Expandable Container
	 *
	 * @author Dimitri Sebeschuk, Marc Althoff
	 * @namespace Tc.Module
	 * @class ExpandableContainer
	 * @extends Tc.Module
	 */
	Tc.Module.ExpandableContainer = Tc.Module.extend({

		on: function (callback) {
			var mod = this;
			this.hashKey = 'expandableContainer-' + this.$ctx.data('id');

			mod.isEditMode = window.CQ && window.CQ.WCM && window.CQ.WCM.isEditMode(true);
			mod.$expandable = mod.$ctx.find('.expandable').eq(0);
			mod.$button = mod.$ctx.find('.expandableButton').eq(0);

			// Make sure the background container does not show a scroll bar when we’re expanding
			mod.$ctx.closest('.modBackgroundContainer').css('overflow', 'hidden');

			if (!mod.isEditMode) {
				mod.$ctx.on('click', '.expandableButton, .sdxClose', $.proxy(mod.handleExpand, mod));
			}
			callback();
		},

		after: function (hashState) {
			if(!jQuery.isEmptyObject(hashState)) {
				this.moduleStateChanged(hashState);
			} else if (this.$ctx.data('start-open')) {
				this.setState();
			}
		},

		handleExpand: function (e) {
			var mod = this;
			e.stopPropagation();
			mod.$ctx.toggleClass('expanded');
			this.setState();
			if (mod.$ctx.hasClass('sdxtheme')) {
				var containerID = mod.$ctx.data('id') || 'expandable-container',
					status = '';
				if (mod.$ctx.hasClass('expanded')) {
					status = 'open';
					$('html, body').animate({
						scrollTop: mod.$ctx.find('.expandable').offset().top - 100
					}, 1000);
				}
				else {
					status = 'close';
				}
				SCS.portal.datalayer.trackEvent(status, containerID, utag_data.page_cfu + '/' + utag_data.page_language + '/' + utag_data.page_path, 'expandable-container');
			}
		},

		moduleStateChanged: function (hashState) {
			var mod = this;
			this.$ctx.toggleClass('expanded', !!hashState[this.hashKey]);
		},

		setState: function() {
			var state = {};
			state[this.hashKey] = this.$ctx.hasClass('expanded') ? 'expanded' : '';
			this.setModuleState(state);
		}
	});
}(window.Tc, __webpack_provided_window_dot_Tc_dot_$));

}.call(window));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0), __webpack_require__(0)))

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var loadTerrific = __webpack_require__(1);
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function($) {
	/*
	 * Dependencies:
	 * TerrificJs 2.0.1,
	 * jQuery 1.7 or greater,
	 * jquery.placeholder.min.js,
	 *
	 */

	'use strict';
	/*globals Tc */
	/*jshint smarttabs:true */

	Tc.Module.Glossary = Tc.Module.extend({

		PAGESIZE: 20,

		init: function($ctx, sandbox, modId) {
			this.$ctx = $ctx;
			this.loadingIndicator = $('.modLoadingIndicator', this.$ctx);
			this.lastLetter = '';
			this.hasMoreResults = true;
			this.itemsLoaded = 0;
			this.groupByFirstLetter = this.$ctx.data('group-by-first-letter');
			this.items = $('.data-provider-item', this.$ctx);
			this.itemsContainer = this.items.parent();
			this.isMobile = $('body').hasClass('is-mobile');
			this._super($ctx, sandbox, modId);
		},

		on: function(callback) {
			this.items.detach();
			this.loadingIndicator.on('visible', $.proxy(this.eventEndOfListReached, this));
			this.$ctx.addClass('initialized');
			callback();
		},

		eventEndOfListReached: function() {
			if (!this.isLoading && this.hasMoreResults) {
				this.isLoading = true;
				this.loadMoreResults();
			}
		},

		loadMoreResults: function() {
			var mod = this,
				item, i, letter;
			for (i = 0; i < mod.PAGESIZE && mod.itemsLoaded < mod.items.length; i++, mod.itemsLoaded++) {
				item = $(mod.items.get(mod.itemsLoaded));
				letter = mod.getLetter(item);
				// if there is no letter, the meta data title is not set on the referred page.
				// hence skip this item.
				if(!letter) {
					continue;
				}

				if (letter !== mod.lastLetter && mod.groupByFirstLetter) {
					mod.lastLetter = letter;
					mod.itemsContainer.append($('<h2>').addClass('letter').text(mod.lastLetter));
				}
				if (mod.isMobile) {
					mod.bindMobileClickHandler(item);
				}
				mod.itemsContainer.append(item);
			}
			if (mod.itemsLoaded === mod.items.length) {
				this.hasMoreResults = false;
				this.loadingIndicator.trigger('stop');
				this.$ctx.addClass('loaded');
			}
			this.isLoading = false;
		},

		getLetter: function(item) {
			var title = item.find('h2, h3').text();
			if (title.length > 0) {
				return title[0].toUpperCase();
			}
			return null;
		},

		bindMobileClickHandler: function(item) {
			var mod = this,
				links = item.find('h2 a, h3 a');
			links = links.length > 0 ? links : item.find('a');
			if (links.length > 0) {
				item.on('click', function(event){
					if (!$(event.target).is('a')) {
						links[0].click();
					}
				});
			} else {
				item.addClass('no-link');
			}
		}
	});
	
}(Tc.$));
}.call(window));

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_Tc_dot_$) {/*** IMPORTS FROM imports-loader ***/
var loadTerrific = __webpack_require__(1);
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function ($, Module, SCS) {
	'use strict';
	/*jshint smarttabs:true */

	/**
	 * GridLayout module implementation.
	 *
	 * @author Rami Attallah
	 * @namespace Tc.Module
	 * @class GridLayout
	 * @extends Tc.Module
	 */
	Module.GridLayout = Module.extend({
		syncHeights: false,
		/**
		 * Hook function to do all of your module stuff.
		 *
		 * @method on
		 * @param {Function} callback function
		 * @return void
		 */
		on: function(callback) {
			var mod = this;
			mod.syncHeights = mod.$ctx.hasClass('scs-html-sync-height');

			callback();
		},

		after: function() {
			var mod = this;
			if(mod.syncHeights) {
				mod.$ctx.parents('body').on('sync-heights', function() {
					var teasers = mod.$ctx.find('.sync-wrapper');
					SCS.portal.synchronizeHeights(teasers);
				});
			}
		}
	});
}(__webpack_provided_window_dot_Tc_dot_$, window.Tc.Module, window.SCS = window.SCS || {}));

}.call(window));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_Tc_dot_$) {/*** IMPORTS FROM imports-loader ***/
var loadTerrific = __webpack_require__(1);
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function($, Tc) {
	'use strict';

	/**
	 * GhqPressReleaseSearch
	 *
	 * @author Michael Keller
	 * @namespace Tc.Module
	 * @class GhqPressReleaseSearch
	 * @extends Tc.Module
	 */
	Tc.Module.GhqPressReleaseSearch = Tc.Module.extend({

		on: function(callback) {
			var mod = this,
				$ctx = mod.$ctx;

			$ctx.find('.standardSubmitBtn').on('click', '', function() {
				mod.startSearch();
			});

			$ctx.on('keyup', '.keyword', function(e) {
				if (e.keyCode === 13) {
					mod.startSearch();
				}
			});

			callback();
		},

		startSearch: function() {
			var mod = this,
				$ctx = mod.$ctx;
			mod.fire('search', {fulltext: $ctx.find('.keyword').val()});
		}
	});
}(__webpack_provided_window_dot_Tc_dot_$, window.Tc));

}.call(window));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_Tc_dot_$) {/*** IMPORTS FROM imports-loader ***/
var loadTerrific = __webpack_require__(1);
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

var imageLoaded = __webpack_require__(4).imageLoaded;

(function(Module, $) {
	'use strict';

	/**
	 * Hover Container
	 *
	 * @author Yves De Bruyne
	 * @namespace Tc.Module
	 * @class HoverContainer
	 * @extends Tc.Module
	 */

	Module.HoverContainer = Module.extend({
		// The normal content element
		$normalDisplay: null,
		// The hover content element
		$hoverDisplay: null,
		// The transition’s name
		transitionName: null,
		// The transition
		transition: null,
		// The height of the hover component. false means: no fixed height, true means: height will be calculated from content
		height: true,
		// Whether there is an animation currently running
		isAnimating: false,
		// All pending animations
		animationQueue: null,

		/**
		 * Init, attach Events
		 *
		 * @method on
		 * @param {Function} callback function
		 * @return void
		 */
		on: function (callback) {
			var mod = this,
				$ctx = mod.$ctx;

			this.animationQueue = [];

			this.$normalDisplay = $ctx.find('> .normalDisplay').show();
			this.$hoverDisplay = $ctx.find('> .hoverDisplay').hide();
			this.transitionName = $ctx.data('transition');

			function finished() {
				Promise.all(mod.$normalDisplay.find('img').get().map(imageLoaded)).then(mod.initHover.bind(mod));
				callback();
			}

			if(document.readyState === 'complete') {
				finished();
			} else {
				$(window).on('load', finished);
			}
		},

		after: function () {
		},

		initHover: function() {
			this.initHeight();
			this.initTransition();

			this.$ctx.hover(
				$.proxy(this, 'run', this.$normalDisplay, this.$hoverDisplay, true),
				$.proxy(this, 'run', this.$hoverDisplay, this.$normalDisplay, false)
			);
		},

		initHeight: function() {
			var height = false;
			if(this.height === true) {
				// “Display” the hover element so we can calculate its size
				this.$hoverDisplay.css({
					display: '',
					visibility: 'hidden'
				});
				var heightInfo = {
					normal: this.$normalDisplay[0].clientHeight,
					hover: this.$hoverDisplay[0].clientHeight
				};
				height = Math.max(heightInfo.normal, heightInfo.hover);
				// Hide the hover element again
				this.$hoverDisplay.css({
					opacity: 0,
					visibility: ''
				});
			} else if(this.height) {
				height = this.height;
			}
			if(height) {
				this.$ctx.height(height);
			}
		},

		initTransition: function() {
			if(this.transitionName in Module.HoverContainer.Transitions) {
				this.transition = Module.HoverContainer.Transitions[this.transitionName];
			} else {
				this.transition = Module.HoverContainer.Transitions.swap;
			}
			if('init' in this.transition) {
				this.transition.init(this.$normalDisplay, this.$hoverDisplay, this.$ctx);
			}
		},

		run: function($from, $to, isToBackside) {
			var isAnimated = !(this.transition instanceof Function);
			var props = (isAnimated ? this.transition.properties : this.transition)(this.$ctx, isToBackside);
			if(isAnimated) {
				this.runAnimated($from, $to, props, isToBackside);
			} else {
				this.runStatic($from, $to, props, isToBackside);
			}
		},

		runStatic: function($from, $to, props) {
			$from.css(props.from);
			$to.css(props.to);
			this.$ctx.trigger('scs-active', [$to]);
		},

		runAnimated: function($from, $to, props, isToBackside) {
			if(this.isAnimating) {
				var args = [].slice.call(arguments);
				this.animationQueue.push(args);
				return;
			}
			this.isAnimating = true;
			if('prepare' in this.transition) {
				this.transition.prepare($from, $to, this.$ctx, isToBackside);
			}
			var completed = 2;
			var complete = $.proxy(function() {
				if((completed -= 1) !== 0) {
					// Wait for second animation to finish.
					return;
				}
				if('finish' in this.transition) {
					this.transition.finish($from, $to, this.$ctx, isToBackside);
				}
				this.isAnimating = false;
				this.animationQueueStep();
				this.$ctx.trigger('scs-active', [$to]);
			}, this);
			$from.animate(props.from, Module.HoverContainer.ANIMATION_OPTIONS.extend({
				complete: complete
			}));
			$to.animate(props.to, Module.HoverContainer.ANIMATION_OPTIONS.extend({
				complete: complete
			}));
		},

		animationQueueStep: function() {
			while(this.animationQueue.length > 1) {
				if(this.animationQueue[0][3] === this.animationQueue[1][3]) {
					// The two queue items point to the same endpoint… coalesce them
					this.animationQueue.splice(0, 1);
				} else {
					// The two queue items complement one another… delete both
					this.animationQueue.splice(0, 2);
				}
			}
			if(this.animationQueue.length) {
				var step = this.animationQueue.shift();
				this.runAnimated.apply(this, step);
			}
		}
	});

	Module.HoverContainer.ANIMATION_OPTIONS = {
		queue: false,
		duration: 600,
		extend: function(opts) {
			return $.extend({}, this, opts, {extend: undefined});
		}
	};

	Module.HoverContainer.Transitions = {
		dissolve: {
			init: function($normalDisplay, $hoverDisplay, $ctx) {
				$ctx.css({
					position: 'relative'
				});
				$normalDisplay.add($hoverDisplay).css({
					position: 'absolute',
					top: 0,
					bottom: 0,
					width: '100%'
				});
			},
			prepare: function($from, $to) {
				$from.css({
					zIndex: 1
				});
				$to.css({
					zIndex: 2,
					display: '',
					opacity: 0
				});
			},
			properties: function() {
				return {
					from: {
						opacity: 0
					},
					to: {
						opacity: 1
					}
				};
			},
			finish: function($from) {
				$from.hide();
			}
		},
		push: {
			init: function($normalDisplay, $hoverDisplay, $ctx) {
				$ctx.css({
					position: 'relative',
					overflow: 'hidden'
				});
				$normalDisplay.add($hoverDisplay).css({
					position: 'absolute',
					top: 0,
					bottom: 0,
					width: '100%'
				});
			},
			prepare: function($from, $to, $ctx, isToBackside) {
				var direction = isToBackside ? 1 : -1;
				$from.css({
					left: 0
				});
				$to.css({
					display: '',
					left: direction * $ctx.width()
				});
			},
			properties: function($ctx, isToBackside) {
				var direction = isToBackside ? -1 : 1;
				return {
					from: {
						left: direction * $ctx.width()
					},
					to: {
						left: 0
					}
				};
			},
			finish: function($from) {
				$from.hide();
			}
		},
		swap: function() {
			return {
				from: {
					opacity: '0',
					position: 'absolute'
				},
				to: {
					opacity: '1',
					position: 'relative',
					display: ''
				}
			};
		},
		fadein: function() {
			return {
				from: {
					opacity: '0',
					transition: 'opacity .4s ease-in-out',
					position: 'absolute'
				},
				to: {
					opacity: '1',
					position: 'relative',
					transition: 'opacity .4s ease-in-out',
					display: ''
				}
			};
		},
		// Only works with background containers
		fade: {
			init: function($normalDisplay, $hoverDisplay, $ctx) {
				$ctx.css({
					position: 'relative'
				});
				var $text = $hoverDisplay.find('.modBackgroundContainer > * > .parsys').eq(0).find('*');
				$text.css({
					color: '#1af' //Swisscom blue
				});
				var $overlay = $('<div/>');
				$overlay.css({
					zIndex: 3,
					backgroundColor: '#85d5ff', //Swisscom light blue
					display: 'none'
				});
				$ctx.append($overlay);
				$ctx.data('hover-overlay', $overlay);
				$normalDisplay.css({zIndex: 1});
				$hoverDisplay.css({zIndex: 0, display: ''});
				$normalDisplay.add($hoverDisplay).add($overlay).css({
					position: 'absolute',
					top: 0,
					bottom: 0,
					width: '100%'
				});
				$.easing.swingAndBack = function(time, b, c, d) {
					time = 1 - Math.abs(time * 2 - 1); //Should go from 0 to 1 to 0
					return $.easing.swing(time, b, c, d);
				};
			},
			prepare: function($from, $to, $ctx) {
				$to.show();
				$ctx.data('hover-overlay').css({
					opacity: 0,
					display: ''
				}).animate({
					opacity: 0.5
				}, Module.HoverContainer.ANIMATION_OPTIONS.extend({
					easing: 'swingAndBack'
				}));
			},
			properties: function($ctx, isToBackside) {
				return {
					from: {
						opacity: isToBackside ? 0 : 1
					},
					to: {
						opacity: 1
					}
				};
			},
			finish: function($from, $to, $ctx, isToBackside) {
				if(isToBackside) {
					$from.hide();
				}
				$ctx.data('hover-overlay').hide();
			}
		}
	};

})(window.Tc.Module, __webpack_provided_window_dot_Tc_dot_$);

}.call(window));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var loadTerrific = __webpack_require__(1);
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function($) {
    'use strict';
    /*globals Tc */

    /**
     * ImageMapContainer
     *
     * @author Zeljko Curcic
     * @namespace Tc.Module
     * @class ImageMapContainer
     * @extends Tc.Module
     */

    Tc.Module.ImageMapContainer = Tc.Module.extend({

        on: function(callback) {
            this.$items = this.$ctx.find('.modImageMapItem');
            this.$defaultItem = this.$ctx.find('.item-default').length ? this.$ctx.find('.item-default').eq(0) : this.$items.eq(0).addClass('item-default');
            this.$areaContainer = this.$ctx.find('.area-container');

            this.$ctx.find('.item-default').removeClass('hidden');
            this.setupImageMap();

            this.$areaContainer.find('.image-map-area:first').addClass('first');

            this.$ctx.on('click', '.area-container > .image-map-area', $.proxy(this.mouseEnterHandler, this));

            this.$ctx.on('click', '.area-container > .image-map-area', this.imageMap);

            callback();
        },

        mouseEnterHandler: function(e) {
            var $activeArea = $(e.currentTarget),
                idx = $activeArea.index();

            if (!(this.$items.eq(idx).hasClass('hidden'))) {
                this.$items.addClass('hidden');
                this.$defaultItem.removeClass('hidden');
            } else {
                this.$items.addClass('hidden');
                this.$items.eq(idx).removeClass('hidden');
            }

            this.fire('toggleVisibility', {}, ['brightcovecontrol']);
        },

        setupImageMap: function() {
            var i, $item, $area,
                ii = this.$items.length;
            if (ii > 1) {
                for (i = 0; i < ii; i += 1) {
                    $item = this.$items.eq(i);
                    $area = $('<div class="image-map-area"><div class="button"></div></div>').css({
                        'left': $item.data('left'),
                        'top': $item.data('top'),
                        'width': $item.data('width'),
                        'height': $item.data('height')
                    });
                    $area.appendTo(this.$areaContainer);
                }
            } else {
                this.$items.removeClass('hidden');
            }
            var $button = this.$ctx.find('.button');

            if (this.$ctx.data('disable')) {
                $button.css('opacity', '0');
            } else {
                $button.css('opacity', '1');
            }
        },

        imageMap: function() {
            var $button = $(this).find(".button");
            if ($button.hasClass('clicked')) {
                $button.removeClass('clicked');
            } else {
                $button.addClass('clicked').parent().siblings().find('.button').removeClass('clicked');
            }
        }

    });
}(Tc.$));
}.call(window));

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var loadTerrific = __webpack_require__(1);
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function($) {
    'use strict';
    /*globals Tc */

    /**
     * ImageMapItem
     *
     * @author Nikola Lakovic
     * @namespace Tc.Module
     * @class ImageMapItem
     * @extends Tc.Module
     */

    Tc.Module.ImageMapItem = Tc.Module.extend({
        on: function(callback) {
            var $ctx = this.$ctx;
            this.$container = this.$ctx.find('.text-area');
            var $positionEl = this.$container.data('pos');

            if($positionEl) {
                this.$container.css({
                    'position': 'absolute',
                    'left': this.$container.data('left'),
                    'top': this.$container.data('top'),
                    'width': this.$container.data('width'),
                    'height': this.$container.data('height')
                });
            } else {
                this.$container.css('position', 'static');
            }
            callback();
        }
    });
}(Tc.$));
}.call(window));

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_Tc_dot_$) {/*** IMPORTS FROM imports-loader ***/
var loadTerrific = __webpack_require__(1);
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

var imageLoaded = __webpack_require__(4).imageLoaded;

/**
 * User: konstantin
 * Date: 4/8/14
 */
(function(Tc, $, SCS) {
	'use strict';
	// /*globals Tc, doT, SCS, debug */
	/*jshint smarttabs:false */

	Tc.Module.ImagesSlider = Tc.Module.extend({
		config: {
			fullWidthWrapperClass: '.fullwidthwrapper',
			normalWidthWrapperClass: '.normalwidthwrapper',
			imagefullwidthClass: '.imagefullwidth',
			slider: '.slider',
			slide: '.slidesjs-slide',
			image: '.slider .slidesjs-slide img',
			prevLinkClass: '.sjs-prev',
			nextLinkClass: '.sjs-next',
			bildlegendeSpan: '.bildlegende > span',
			bildlegendeClass: '.bildlegende',
			facebookShare: 'a.facebook',
			twitterShare: 'a.twitter',
			mail: 'a.mail'
		},

		on: function (callback) {
			var mod = this,
				$ctx = mod.$ctx,
				config = mod.config;

			setTimeout(function() {
				mod.checkWidth(0);
				mod.initSlider();
				mod.sliderButtons();
				mod.initCaptionText();
				mod.centerCaptionText();
				mod.captionHovering();
				mod.centerImages();
			}, 200);

			$(window).resize(function () {
				setTimeout(function() {
					mod.checkWidth(0);
					mod.initCaptionText();
					mod.centerCaptionText();
					mod.centerImages();
				}, 200);
			});

			mod.shareImages();

			Promise.all(mod.$ctx.find('img').get().map(imageLoaded)).then(function() {
				setTimeout(function () {
					mod.checkWidth(0);
					mod.initCaptionText();
					mod.centerCaptionText();
					mod.centerImages();
				}, 200);
			});

			callback();
		},

		centerImages: function () {
			var mod = this,
				$ctx = mod.$ctx,
				config = mod.config;

			var maxHeight = mod.getSlideMaxHeight();
			if(SCS.utils.isMobilePage()) {
				maxHeight = maxHeight + mod.getCaptionMaxHeight();
			}

			$(config.normalWidthWrapperClass, $ctx).css({height: maxHeight});
			$('.normalwidthwrapper .imagefullwidth', $ctx).height($(config.normalWidthWrapperClass, $ctx).height());

			$(config.fullWidthWrapperClass, $ctx).css({height: maxHeight});
			$(config.imagefullwidthClass, $ctx).css({height: maxHeight});
			$('.slidesjs-container', $ctx).css({height: maxHeight});
			$('.slidesjs-control', $ctx).css({height: maxHeight});

			$(config.fullWidthWrapperClass + ' ' + config.slider, $ctx).height($(config.fullWidthWrapperClass, $ctx).height());

			$(config.slide, $ctx).css({height: maxHeight});

			$(config.image, $ctx).each(function () {
				var $this = $(this);

				if($this.width() > $this.parent().width()){
					$this.css({'float': 'left', 'width': '100%'});
				}

				var height = $this.height();
				if(SCS.utils.isMobilePage()) {
					height = height + mod.getCaptionMaxHeight();
				}
				var heightHalf = -1 * Math.round(height / 2);
				$this.css({'margin-top': heightHalf + 'px'});
			});
		},

		shareImages: function () {
			var mod = this,
				$ctx = mod.$ctx,
				config = mod.config;

				/*
			$ctx.on('click', config.facebookShare, function () {
				var $this = $(this);
				mod.shareImage('http://www.facebook.com/share.php?u=' + $this.closest(config.slide).find('img').attr('src') + '&amp;title=' + $this.parent().data('share-text'));
				return false;
			});
			$ctx.on('click', config.twitterShare, function () {
				var $this = $(this);
				mod.shareImage('http://twitter.com/home?status=' + $this.parent().data('share-text') + '+' + $this.closest(config.slide).find('img').attr('src'));
				return false;
			});
			$ctx.on('click', config.mail, function () {
				var $this = $(this);
				document.location.href = 'mailto:?body=' + $this.closest(config.slide).find('img').attr('src') + '&subject=' + $this.data('share-text').replace(/&/g, '%26');
				return false;
			});
			*/
		},

		shareImage: function (url) {
			var w = 500;
			var h = 500;
			var left = (screen.width/2)-(w/2);
			var top = (screen.height/2)-(h/2);

			window.open(url,"_blank", "toolbar=no, location=no, status=no, menubar=no, scrollbars=yes, resizable=yes, width=" + w + ", height=" + h + ", top=" + top + ", left=" + left);
		},

		initSlider: function () {
			var mod = this;
			var $ctx = mod.$ctx;
			var config = mod.config;

			// do not init slidesjs if only one image because of a known bug in the plugin
			// see https://groups.google.com/forum/#!msg/slidesjs/Q61KaOBzV4w/J_moJx0TxnMJ

			if (!mod.oneImage()) {

				if(SCS.utils.isMobilePage()) {
					$('.fullwidthwrapper', $ctx).height(($(config.fullWidthWrapperClass + ' .imagefullwidth img', $ctx).height() + mod.getCaptionMaxHeight()));

					$(config.fullWidthWrapperClass + ' ' + config.slider, $ctx).slidesjs({
						width: $(window).width(),
						height: ($(config.fullWidthWrapperClass + ' .imagefullwidth img', $ctx).height() + mod.getCaptionMaxHeight()),
						navigation: {
							active: false,
							effect: "slide"
						},
						pagination: {
							active: false
						}
					});
				} else {
					$(config.fullWidthWrapperClass + ' ' + config.slider, $ctx).slidesjs({
						width: $(window).width(),
						height: ($(config.fullWidthWrapperClass, $ctx).height() + mod.getCaptionMaxHeight()),
						navigation: {
							active: false,
							effect: "slide"
						},
						pagination: {
							active: false
						}
					});
				}

				$(config.normalWidthWrapperClass + ' ' + config.slider, $ctx).slidesjs({
					width: 100,
					height: $(config.normalWidthWrapperClass, $ctx).height(),
					navigation: {
						active: false,
						effect: "slide"
					},
					pagination: {
						active: false
					}
				});

			}

			$('.normalwidthwrapper .imagefullwidth', $ctx).height($(config.normalWidthWrapperClass, $ctx).height());

		},

		sliderButtons: function () {
			var mod = this;
			var $ctx = mod.$ctx;
			var config = mod.config;

			if (!mod.oneImage()) {
				var sjs = $(config.slider, $ctx).data('plugin_slidesjs');
				$(config.nextLinkClass, $ctx).click(function (clickevent) {
					clickevent.preventDefault();
					sjs.next();
				});
				$(config.prevLinkClass, $ctx).click(function (clickevent) {
					clickevent.preventDefault();
					sjs.previous();
				});
			} else {
				$(config.nextLinkClass, $ctx).hide();
				$(config.prevLinkClass, $ctx).hide();
				$(config.bildlegendeSpan, $ctx).css('padding','10px');
				$(config.fullWidthWrapperClass + ' ' + config.bildlegendeSpan, $ctx).css('width','515px');
			}
		},

		initCaptionText: function () {
			var mod = this;
			var $ctx = mod.$ctx;
			var config = mod.config;

			$(config.slider + ' p.bildlegende', $ctx).each(function () {
				$(this).height(mod.getCaptionMaxHeight());
			});

		},

		captionHovering: function () {
			var mod = this;
			var $ctx = mod.$ctx;
			var config = mod.config;

			$(config.slider, $ctx).hover(
				function () {
					if (!SCS.utils.isMobilePage()) {
						$ctx.find('p.bildlegende').animate({
							height: mod.getCaptionMaxHeight()
						}, 500);
					}
				},
				function () {
					if (!SCS.utils.isMobilePage()) {
						$ctx.find('p.bildlegende').animate({
							height: 0
						}, 500);
					}
				}
			);
		},

		centerCaptionText: function () {
			var mod = this;
			var $ctx = mod.$ctx;
			var config = mod.config;

			$(config.slider + ' p.bildlegende', $ctx).each(function () {
				$(this).height(mod.getCaptionMaxHeight());
			});
		},

		checkWidth: function (index) {
			var mod = this;
			var $ctx = this.$ctx;
			var config = this.config;

			if (SCS.utils.isMobilePage()) {
				$(config.bildlegendeClass, $ctx).removeAttr('style');

				var heightNormal = $('.normalwidthwrapper > .imagefullwidth div[slidesjs-index='+index+'] img', $ctx).height();
				if(heightNormal == null){
					heightNormal = $('.normalwidthwrapper > .imagefullwidth img', $ctx).height();
				}

				if(heightNormal != null){
					$(config.normalWidthWrapperClass, $ctx).css({height: (heightNormal + $('.normalwidthwrapper > .imagefullwidth div[slidesjs-index='+index+'] p.bildlegende', $ctx).height())});
					$('.normalwidthwrapper .imagefullwidth', $ctx).height($(config.normalWidthWrapperClass, $ctx).height());
					$('.slidesjs-container', $ctx).css({height: $(config.normalWidthWrapperClass, $ctx).height()});
					$('.slidesjs-control', $ctx).css({height: $(config.normalWidthWrapperClass, $ctx).height()});
				}

				var heightFull = $('.fullwidthwrapper > .imagefullwidth div[slidesjs-index='+index+'] img', $ctx).height();
				if(heightFull == null){
					heightFull = $('.fullwidthwrapper > .imagefullwidth img', $ctx).height();
				}

				if(heightFull != null){
					$(config.fullWidthWrapperClass, $ctx).css({height: heightFull + $('.fullwidthwrapper > .imagefullwidth div[slidesjs-index='+index+'] p.bildlegende', $ctx).height()});

					$(config.fullWidthWrapperClass + ' ' + config.slider, $ctx).height($(config.fullWidthWrapperClass, $ctx).height());
					$(config.fullWidthWrapperClass + ' .slidesjs-container', $ctx).height($(config.fullWidthWrapperClass, $ctx).height());
					$(config.fullWidthWrapperClass + ' .slidesjs-control', $ctx).height($(config.fullWidthWrapperClass, $ctx).height());
				}

			} else {
				var heightNormal = $('.normalwidthwrapper > .imagefullwidth div[slidesjs-index='+index+'] img', $ctx).height();
				if(heightNormal == null){
					heightNormal = $('.normalwidthwrapper > .imagefullwidth img', $ctx).height();
				}

				if(heightNormal != null){
					$(config.normalWidthWrapperClass, $ctx).css({height: heightNormal});
					$('.normalwidthwrapper .imagefullwidth', $ctx).height($(config.normalWidthWrapperClass, $ctx).height());
				}

				var heightFull = $('.fullwidthwrapper > .imagefullwidth div[slidesjs-index='+index+'] img', $ctx).height();
				if(heightFull == null){
					heightFull = $('.fullwidthwrapper > .imagefullwidth img', $ctx).height();
				}

				if(heightFull != null){
					$(config.fullWidthWrapperClass, $ctx).css({height: heightFull});
					$(config.imagefullwidthClass, $ctx).css({height: heightFull});
					$('.slidesjs-container', $ctx).css({height: heightFull});
					$('.slidesjs-control', $ctx).css({height: heightFull});
				}

				$(config.fullWidthWrapperClass + ' ' + config.slider, $ctx).height($(config.fullWidthWrapperClass, $ctx).height());
			}
		},

		getCaptionMaxHeight: function () {
			var mod = this;
			var $ctx = mod.$ctx;
			var config = mod.config;

			var maxheight = 55;

			$(config.slider + ' p.bildlegende span', $ctx).each(function () {
				var height = $(this).outerHeight();
				if (height > maxheight) {
					maxheight = height;
				}
			});
			if($ctx.data('share-enabled')){
				if(SCS.utils.isMobilePage()) {
					maxheight = maxheight + 43;
				} else {
					maxheight = maxheight + 20;
				}
			}

			return maxheight;
		},

		getSlideMaxHeight: function() {
			var mod = this;
			var $ctx = mod.$ctx;
			var config = mod.config;

			var maxheight = -1;

			$(config.image, $ctx).each(function () {
				var $this = $(this);

				var heightReal = $this.height();
				$this.css({'width': '100%'});
				var height100 = $this.height();

				var height = height100;
				if(height100 > heightReal){
					height = heightReal;
				}

				if (height > maxheight) {
					maxheight = height;
				}
				$this.css({'width': 'auto'});
			});

			return maxheight;
		},

		oneImage: function () {
			return $(this.config.slider + " img", this.$ctx).length < 2;
		}

	});
}(window.Tc, __webpack_provided_window_dot_Tc_dot_$, window.SCS));

}.call(window));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var loadTerrific = __webpack_require__(1);
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function($) {
	'use strict';
	/*globals Tc, debug */

	/**
	 * InfoTeaserContainer
	 *
	 * @author tzhveig1
	 * @namespace Tc.Module
	 * @class InfoTeaserContainer
	 * @extends Tc.Module
	 */

	Tc.Module.InfoTeaserContainer = Tc.Module.extend({

		on: function(callback) {
			var mod = this,
			$ctx = mod.$ctx

			if ($ctx.hasClass('zigzag')){
				mod.zigzagDataProviderItems();
			}

			callback();
		},

		after: function() {
			var mod = this,
			$ctx = mod.$ctx,
			height = 0;

			$ctx.find('.modDataProvider .data-provider-item').each(function() {
				height = ($(this).height() > height) ? $(this).height() : height;
			});

			debug.log('Tc.Module.InfoTeaserContainer > maxheight', height);
			$ctx.find('.modDataProvider .data-provider-item').height(height).addClass('float');

		},

		zigzagDataProviderItems: function(){
			var mod = this,
				$items = mod.$ctx.find('.data-provider-item');

			for (var i = 0; i < $items.length; i ++){
				$items.eq(i).addClass((i & 1) ? 'zag' : 'zig');
			}
		}

	});
}(Tc.$));
}.call(window));

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_Tc_dot_$) {/*** IMPORTS FROM imports-loader ***/
var loadTerrific = __webpack_require__(1);
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

/**
 * Created by Dimitri Sebeschuk on 09.06.15.
 */
(function (Tc, $, SCS) {
	'use strict';

	/*
	 * Dependencies:
	 * TerrificJs 2.0.1,
	 * jQuery 1.6.4 or greater
	 */
	Tc.Module.LazyContainer = Tc.Module.extend({

		//Timeout for scroll stop event 250ms
		SCROLL_STOP_TIMEOUT: 250,
		THRESHOLD: 60,

		on: function (callback) {
			var mod = this;
			mod.isEditMode = window.CQ && window.CQ.WCM && window.CQ.WCM.isEditMode(true);
			mod.url = mod.$ctx.data('url');
			if (window.location.href.indexOf('wcmmode=disabled') > 0 || mod.isEditMode) {
				mod.url = SCS.portal.addParamToUrl(mod.url, 'wcmmode', 'disabled');
			}

			mod.loadingIndicator = $('<div>').addClass('loading-indicator');
			mod.errorMessage = mod.$ctx.find('.content-error').first();

			callback();
		},

		after: function () {
			var mod = this;
			if (mod.$ctx.data('preload-content')) {
				return;
			}
			//init lazy loading
			if (mod.$ctx.data('scroll-lazy')) {
				if (!mod.isScrolledIntoView()) {
					//scroll-lazy is true and content not into view
					mod.onScrollProxy = $.proxy(mod.onScroll, mod);
					$(window).on('scroll', mod.onScrollProxy);
					return;
				}
			}

			if (typeof mod.$ctx.data('delay') === 'number') {
				setTimeout($.proxy(mod.loadContent, mod), mod.$ctx.data('delay'));
			} else {
				mod.loadContent();
			}

		},

		loadContent: function () {
			var mod = this;
			if (mod.$ctx.hasClass('loading') || mod.$ctx.hasClass('js-lazycontainer-loaded')) {
				return;
			}
			mod.$ctx.addClass('loading');
			if (mod.url) {
				mod.errorMessage.addClass('hidden');
				mod.$ctx.prepend(mod.loadingIndicator);
				$.ajax({
					url: mod.url
				}).done(function (response) {
					mod.$ctx.removeClass('loading');
					mod.$ctx.addClass('js-lazycontainer-loaded');
					mod.loadingIndicator.detach();
					mod.$ctx.html(response);
					SCS.utils.initNewModules(mod.$ctx);
				}).fail(function () {
					mod.loadingIndicator.detach();
					mod.$ctx.removeClass('loading');
					mod.errorMessage.removeClass('hidden');
				});
			} else {
				mod.$ctx.removeClass('loading');
			}
		},

		isScrolledIntoView: function () {
			var mod = this,
				fold = (window.innerHeight ? window.innerHeight : $(window).height()) + $(window).scrollTop();
			//Content below will be loaded
			return fold > mod.$ctx.offset().top - mod.THRESHOLD;
		},

		onScroll: function () {
			var mod = this;

			if (mod.scrollStopTimeoutHandler) {
				clearTimeout(mod.scrollStopTimeoutHandler);
				mod.scrollStopTimeoutHandler = null;
			}
			mod.scrollStopTimeoutHandler = setTimeout($.proxy(mod.onScrollStop, mod), mod.SCROLL_STOP_TIMEOUT);
		},

		onScrollStop: function () {
			var mod = this;
			if (mod.isScrolledIntoView()) {
				mod.loadContent();
				if (mod.onScrollProxy) {
					$(window).off('scroll', mod.onScrollProxy);
				}
			}
		}

	});
}(window.Tc, __webpack_provided_window_dot_Tc_dot_$, window.SCS));

}.call(window));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_Tc_dot_$) {/*** IMPORTS FROM imports-loader ***/
var loadTerrific = __webpack_require__(1);
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

var SdxLoaderBar = __webpack_require__(152).default;

(function (Module, $) {
	'use strict';

	var INTERVAL_STEP = 50;

	/**
	 * Wrapper object for a Bar
	 */
	function Bar($bar) {
		var bar = new SdxLoaderBar($bar[0]);
		var fileSize = parseInt($bar.data('filesize'), 10) || 0;
		var internetSpeed = parseInt($bar.data('internetspeed'), 10) || 0;
		var $seconds = $bar.find('.seconds');
		var $name = $bar.find('.name');
		var title = $name.text();
		var fileSizeTranslationMb = $bar.data('file-size-translation-mb');
		var fileSizeTranslationGb = $bar.data('file-size-translation-gb');

		/**
		 * Calculates the duration in seconds, that are required to download fileSize with internetSpeed.
		 *
		 * @param fileSize - in Mega Bytes
		 * @param internetSpeed - in Mega Bits
		 * @returns {number} - float - seconds
		 */
		var getSeconds = function (fileSize, internetSpeed) {
			if(typeof fileSize === 'undefined' || typeof internetSpeed === 'undefined' || internetSpeed === 0) {
				return 0;
			}
			return fileSize / (internetSpeed / 8);
		};

		/**
		 * Format the time in format "X Min. X Sek."
		 *
		 * @param time
		 * @returns {string}
		 */
		var formatTime = function (time) {
			var min = Math.floor((time % 3600) / 60),
				seconds = time % 60;

			return (min > 0) ? min + ' ' + $bar.data('minutes') + ' ' + Math.round(seconds) + ' ' + $bar.data('seconds') : (Math.round(seconds * 10) / 10) + ' ' + $bar.data('seconds');
		};

		/**
		 * Format the file size in either MB or GB
		 *
		 * @param fileSize
		 * @returns {string}
		 */
		var formatFileSize = function(fileSize) {
			return (fileSize > 1000) ? '(' + String( fileSize / 1000 ) + ' ' + fileSizeTranslationGb + ')' : '(' + String( fileSize ) + ' ' + fileSizeTranslationMb + ')';
		};

		$.extend(this, {
			/**
			 * Update the user interface with the new file size and internet speed
			 *
			 * @param size
			 * @param speed
			 */
			updateUI: function (size, speed) {
				if (!size || !speed) {
					return;
				}

				var time = getSeconds(size, speed);
				$seconds.text(formatTime(time));
				$name.text(title + ' ' + formatFileSize(size));
			},

			/**
			 * Set a new file size
			 *
			 * @param newSize - Int
			 */
			setFileSize: function (newSize) {
				fileSize = newSize;
				this.updateUI(fileSize, internetSpeed);
			},
			/**
			 * Set a new Internet Speed
			 *
			 * @param newSpeed - Int
			 */
			setInternetSpeed: function (newSpeed) {
				internetSpeed = newSpeed;
				this.updateUI(fileSize, internetSpeed);
			},

			/**
			 * Reset the loading bar and start the animation after a delay time
			 * so it's more visible to the user what is happening.
			 */
			startAnimation: function () {
				this.resetBar();

				this.animationStartDelay = setTimeout(this.animate.bind(this), 250);
			},

			/**
			 * Do the animation
			 */
			animate: function() {
				var duration = getSeconds(fileSize, internetSpeed) * 1000;
				var iterations = Math.ceil(duration / INTERVAL_STEP);
				var count = 0;
				var _this = this;

				if(iterations === 0) {
					return;
				}

				this.animationTimer = setInterval(function () {
					count += 1;

					bar.progress = count / iterations;

					if (iterations === count) {
						_this.stopAnimation();
					}
				}, INTERVAL_STEP);
			},

			/**
			 * Stop the animation
			 */
			stopAnimation: function () {
				if (typeof this.animationStartDelay !== 'undefined') {
					clearTimeout(this.animationStartDelay);
				}

				if (typeof this.animationTimer !== 'undefined') {
					clearInterval(this.animationTimer);
				}
			},

			/**
			 * Reset the loading bar to 0;
			 */
			resetBar: function () {
				this.stopAnimation();
				bar.progress = 0;
			}
		});

		//init with default values
		this.updateUI(fileSize, internetSpeed);
		this.startAnimation();
	}

	/**
	 * Loading Bar
	 *
	 * @author TAAATRA1
	 * @namespace Tc.Module
	 * @class LoadingBar
	 * @extends Tc.Module
	 */
	Module.LoadingBar = Module.extend({

		on: function (callback) {
			var mod = this;

			mod.bars = [];

			mod.$ctx.find('.loader-bar').each(function () {
				mod.bars.push(new Bar($(this)));
			});

			this.storeData();
			this.cacheUi();
			this.addEventListeners();

			this.sandbox.subscribe('LOADING_BAR', this);

			callback();
		},

		addEventListeners: function(){
			if(this.ui.$observable) {
				this.ui.$observable.on('change', this.handleObservableChange.bind(this));
			}
		},

		storeData: function() {
			this.observableId = this.$ctx.data('observable');
			this.observableConfig = this.$ctx.data('observable-config');
		},

		cacheUi: function(){
			this.ui = {};

			if(this.observableId) {
				this.ui.$observable = $(document.body).find('input[name="'+this.observableId+'"]');
			}
		},

		getObservableConfig: function(observableValue) {
			for(var i = 0; i < this.observableConfig.length; i += 1) {
				if(this.observableConfig[i].value === observableValue) {
					return this.observableConfig[i];
				}
			}
		},

		handleObservableChange: function(event) {
			var $field = $(event.currentTarget);
			var config = this.getObservableConfig($field.val());

			if(!config) {
				return;
			}

			if(config.fileSize) {
				this.setFileSize(parseInt(config.fileSize));
			}

			if(config.internetSpeed) {
				this.setInternetSpeed(parseInt(config.internetSpeed));
			}
		},

		/**
		 * Updates all bars to a new internet speed.
		 *
		 * @param internetSpeed - the new internet speed in Mbit/Sec
		 */
		setInternetSpeed: function(internetSpeed) {
			this.bars.forEach(function (bar) {
				bar.setInternetSpeed(internetSpeed);
				bar.startAnimation();
			});
		},

		/**
		 * Updates the files size on all bars to the supplied filesize.
		 *
		 * @param fileSize - the new filesize in MB
		 */
		setFileSize: function(fileSize) {
			this.bars.forEach(function (bar) {
				bar.setFileSize(fileSize);
				bar.startAnimation();
			});
		},

		/**
		 * Terrific message handler method.
		 * Updates the internet speed on all progress bars in this component
		 *
		 * @param data
		 */
		onUpdateInternetSpeed: function (data) {
			if (!data || !data.internetSpeed) {
				return;
			}

			this.setInternetSpeed(data.internetSpeed);
		},

		/**
		 * Terrific message handler method.
		 * Updates the file size on all progress bars in this component
		 *
		 * @param data
		 */
		onUpdateFileSize: function (data) {
			if (!data || !data.fileSize) {
				return;
			}

			this.setFileSize(data.fileSize);
		}
	});
}(window.Tc.Module, __webpack_provided_window_dot_Tc_dot_$));

}.call(window));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["init"] = init;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Utils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DomElement__ = __webpack_require__(12);



/**
 * Loader bar component
 */
var LoaderBar = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */])(LoaderBar, _super);
    /**
     * Creates and initializes the LoaderBar component.
     * @param {Element} - The root element of the LoaderBar component.
     */
    function LoaderBar(element) {
        var _this = _super.call(this, element) || this;
        _this._initialize();
        return _this;
    }
    /**
     * Initializes the loader bar component.
     * @private
     */
    LoaderBar.prototype._initialize = function () {
        this.progressElement = this.find(".indicator") || this;
        this.fileNameElement = this.find(".detail > .name");
        this.progressLabelElement = this.find(".progress");
        this.totalProgressElement = this.find(".file-size");
    };
    Object.defineProperty(LoaderBar.prototype, "progress", {
        /**
         * Gets the current progress value in the range of 0..1.
         */
        get: function () {
            return this.value;
        },
        /**
         * Sets the current progress.
         * @param {number} - The progress in the range of 0..1.
         */
        set: function (val) {
            // val = clamp(val, 0, 1)
            var percentage = (val * 100).toFixed(0);
            this.value = val;
            this.element.value = String(val);
            this.progressElement.setAttribute("style", "width: ".concat(val * 100, "%"));
            if (this.progressLabelElement) {
                this.progressLabelElement.element.textContent = "".concat(percentage, "%");
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LoaderBar.prototype, "filename", {
        /**
         * Gets the filename.
         * @returns {string} - The filename.
         */
        get: function () {
            if (!this.fileNameElement) {
                return undefined;
            }
            return this.fileNameElement.element.textContent || undefined;
        },
        /**
         * Sets the filename.
         */
        set: function (val) {
            if (!this.fileNameElement) {
                throw new Error("Cannot set the filename, missing detail element");
            }
            this.fileNameElement.setHtml(val || "");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LoaderBar.prototype, "fileSize", {
        /**
         * Sets the file size label.
         */
        set: function (val) {
            if (!this.totalProgressElement) {
                throw new Error("Cannot set the fileSize, missing detail element");
            }
            this.totalProgressElement.setHtml(val);
        },
        enumerable: false,
        configurable: true
    });
    return LoaderBar;
}(__WEBPACK_IMPORTED_MODULE_2__DomElement__["a" /* default */]));
function init() {
    Object(__WEBPACK_IMPORTED_MODULE_1__Utils__["h" /* searchAndInitialize */])(".loader-bar", function (e) {
        new LoaderBar(e);
    });
}
/* harmony default export */ __webpack_exports__["default"] = (LoaderBar);


/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var loadTerrific = __webpack_require__(1);
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function($) {
	/*
	 * Dependencies:
	 * TerrificJs 2.0.1,
	 * jQuery 1.7 or greater,
	 * jquery.placeholder.min.js,
	 *
	 */

	'use strict';
	/*globals Tc */
	/*jshint smarttabs:true */

	Tc.Module.LoadingIndicator = Tc.Module.extend({

		init: function($ctx, sandbox, modId) {
			var mod = this;
			mod.$ctx = $ctx;
			mod.properties = {
				interval: mod.$ctx.data('interval') || 500,
				checkVisibility: mod.$ctx.data('check-visibility')
			};
			this._super($ctx, sandbox, modId);
		},

		on: function(callback) {
			var mod = this;
			mod.$ctx.on('stop', function(){
				mod.properties.checkVisibility = false;
			});
			callback();
		},

		after: function() {
			this.checkVisibility();
		},

		checkVisibility: function() {
			if (this.properties.checkVisibility) {
				if (this.isVisible()) {
					this.$ctx.trigger('visible');
				}
				setTimeout($.proxy(this.checkVisibility, this), this.properties.interval);
			}
		},

		isVisible: function() {
			var mod = this,
				scrollOffset = mod.$ctx.offset().top,
				windowScrollOffset = $(window).scrollTop(),
				windowHeight = $(window).height();
			if (scrollOffset > 0 && scrollOffset < windowScrollOffset + windowHeight && mod.$ctx.is(':visible')) {
				return true;
			}
			return false;
		}
	});
	
}(Tc.$));
}.call(window));

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_Tc_dot_$) {/*** IMPORTS FROM imports-loader ***/
var loadTerrific = __webpack_require__(1);
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function($, Tc) {
	'use strict';

	/**
	 * MultiDropdown
	 *
	 * @author Michael Keller
	 * @namespace Tc.Module
	 * @class MultiDropdown
	 * @extends Tc.Module
	 */
	Tc.Module.MultiDropdown = Tc.Module.extend({

		on: function(callback) {
			var mod = this,
				$ctx = mod.$ctx;

			mod.$select = $ctx.find('select');
			mod.isMulti = mod.$select.is('[multiple]');
			mod.name = mod.$select.attr('name');
			mod.label = $ctx.find('label').text();
			// only for desktop - when multiselect is restyled
			if (mod.$select.is('.multiselect')) {
				$ctx.find('label').hide();
			}

			// on change read value and broadcast it to all listening modules
			mod.$select.on('change', function() {
				mod.values = mod.readValue();
				mod.broadcastValue();
				mod.checkIfEmpty();

				//Used in PEX Form Archive. On mobile view, title(label) of the dropdown should always stay the same, selected values need to be visible only in modMultiDropdownFilter
				if (mod.$ctx.hasClass('static-title')){
					mod.$ctx.find('.ui-btn > span:first').text(mod.label);
				}

				mod.$ctx.trigger('multidropdown-changed', mod.values, mod.getValue());
			});

			if (!mod.isMulti) {
				mod.$select.addClass('singleselect');
				var showAllText = $ctx.data('show-all');
				if(showAllText) {
					mod.$select.append('<option class="novalue" value="">' + showAllText + '</option>');
				}

				if (mod.$select.find('option.preselected').length === 0) {
					mod.$select.find('option.novalue').prop('selected', true);
				}

				// for single selects - ie8 does not get the clicks on the inputs as custom-inputs does not redirect the click
				$(document).on('click', '.ui-multiselect-single li > label', function(e) {
					if (!$(e.target).is('input')) {
						$(this).find('input[type="radio"]').click();

					}
				});
			}

			mod.values = mod.readValue();

			// only for desktop
			if (mod.$select.is('.multiselect')) {
				mod.$select.multiselect({
					selectedText: mod.label,
					noneSelectedText: mod.label,
					header: false,
					minWidth: 50,
					height: 275,
					multiple: mod.isMulti,
					open: function(){
						var $this = $(this),
							$list = $this.multiselect('widget'),
							listHeight = $this.multiselect('option','height');

						$list.find('ul').css('max-height', listHeight + 'px');

						if ($list.height() < listHeight){
							$list.find('ul').css('overflow-y','auto');
						}
					}
				});
			}
			// only for mobile
			else {
				mod.$ctx.find('.ui-btn > span:first').text(mod.label);
				mod.fixMultiSelects();
			}

			mod.initAPI();

			callback();
		},

		after: function() {
			var mod = this;
			mod.broadcastValue();
		},

		initAPI: function() {
			var mod = this;
			mod.$ctx[0].multidropdown = {
				isMulti: function() {
					return mod.isMulti;
				},
				getModule: function() {
					return mod;
				},
				readValue: function() {
					return mod.value;
				},
				getValue: mod.getValue.bind(mod),
				setValue: mod.setValue.bind(mod),
				addValue: mod.addValue.bind(mod),
				allValues: mod.allValues.bind(mod),
				removeValue: mod.removeValue.bind(mod),
				valueLabel: mod.valueLabel.bind(mod)
			};
			mod.$ctx.data('multidropdown-api', mod.$ctx[0].multidropdown);
		},

		// boardcast value together with name and label
		broadcastValue: function() {
			var mod = this;
			mod.fire('updateValue', { name : mod.name, label : mod.label, valueObj : mod.values });
		},

		// reads value and returns it as array
		readValue: function() {
			var mod = this,
				rawValues = mod.$select.val(),
				valueObj = null,
				i = 0;

			if (rawValues === null) {
				rawValues = [];
			}
			valueObj = { labels: [], values: rawValues };

			for (i = 0; valueObj && valueObj.values && i < valueObj.values.length; i+=1) {
				valueObj.labels[i] = mod.valueLabel(valueObj.values[i]);
			}

			return valueObj;
		},

		valueLabel: function(value) {
			return this.$select.find('option[value="'+value+'"]').text();
		},

		// remove filter when filter was removed in other module
		onRemoveFilter: function(data) {
			var mod = this;

			if (!mod.$select.is('[name="'+data.name+'"]')) {
				return;
			}

			mod.removeValue(data.value);
		},

		onSetFilters: function(data) {
			var mod = this,
				i = 0;
			if (data.newValues) {
				data = data.newValues;
				if (data && data.length > 0) {
					for (i = 0; i < data.length; i++) {
						if (data[i].name === mod.name) {
							mod.$select.filter('[name="'+data[i].name+'"]').find('option[value="'+data[i].value+'"]').attr('selected', 'selected');
						}
					}
				}
				// MultiSelect module only on desktop
				if (mod.$select.is('.multiselect')) {
					// Inform the multiselect of the change
					mod.$select.multiselect('refresh');
				}
				mod.$select.change();
			}
		},

		getValue: function() {
			var mod = this;
			var value = mod.values.values;
			if(mod.isMulti) {
				// Make a copy to not allow internal state to be changed from the outside
				return  $.isArray(value) ? value.slice() : [value];
			} else {
				return $.isArray(value) ? value[0] : value;
			}
		},

		setValue: function(val) {
			var mod = this;
			if(mod.isMulti) {
				if(!$.isArray(val)) {
					val = val === null ? [] : [val];
				}
			} else {
				if($.isArray(val)) {
					val = val[0];
				}
			}
			if(!mod.isMulti && val === null) {
				// Special-case no-value case in multiselect
				mod.$select.find('option').prop('selected', false).filter('.novalue').prop('selected', true);
			} else if(mod.isMulti && !val.length) {
				// fix for chrome on android issue => https://code.google.com/p/chromium/issues/detail?id=331737
				mod.$select.prepend('<option class="toremove" />');
				mod.$select.val(val);
				mod.$select.find('.toremove').remove();
			} else {
				// Usual case
				mod.$select.val(val);
			}
			// MultiSelect module only on desktop
			if (mod.$select.is('.multiselect')) {
				// Inform the multiselect of the change
				mod.$select.multiselect('refresh');
			}
			// Trigger the change handler (will update mod.values)
			mod.$select.change();
		},

		addValue: function(val) {
			var mod = this;
			if(mod.isMulti) {
				var currentValue = mod.getValue();
				if(currentValue.indexOf(val) >-1) {
					// Already set
					return;
				}
				currentValue.push(val);
				val = currentValue;
			}
			mod.setValue(val);
		},

		allValues: function() {
			var mod = this;
			return mod.$select.find('option').map(function() {
				return this.value;
			}).get();
		},

		removeValue: function(val) {
			var mod = this;
			var currentValue = mod.getValue();
			var newValue = null;
			if(mod.isMulti) {
				var index;
				if((index = currentValue.indexOf(val)) === -1) {
					// Alredy not set
					return;
				}

				// Remove the value
				currentValue.splice(index, 1);
				newValue = currentValue;
			} else {
				if(currentValue !== val) {
					return;
				}
			}

			mod.setValue(newValue);
		},

		onClearAll: function() {
			var mod = this;

			if (mod.checkIfEmpty()) {
				return;
			}
			if (mod.isMulti) {
				mod.setValue([]);
			} else {
				mod.setValue(null);
			}
		},

		checkIfEmpty: function() {
			var mod = this;
			if (mod.$select.find('option:selected:not(.novalue)').length === 0) {
				if (!mod.$select.is('.multiselect')) {
					mod.$ctx.find('.ui-btn > span').text(mod.label);
				}
				return true;
			}
			return false;
		},

		// hack for iPhone 7.0.3 multiselects bug
		// https://discussions.apple.com/message/24694954#24694954
		fixMultiSelects: function () {
			var mod = this;
			if (navigator.userAgent.match(/iphone os 7.0/i)) {
				mod.$ctx.find('select[multiple]').each(function () {
					var select = $(this).on({
						focusout: function () {
							var values = select.val() || [];
							setTimeout(function () {
								select.val(values.length ? values : ['']).change();
							}, 1000);
						}
					});
					var firstOption = '<option value="" disabled="disabled"';
					firstOption += (select.val() || []).length ? '' : ' selected="selected"';
					firstOption += '>' + mod.label + '';
					firstOption += '</option>';
					select.prepend(firstOption);
				});
			}
		}

	});
}(__webpack_provided_window_dot_Tc_dot_$, window.Tc));

}.call(window));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery) {/*** IMPORTS FROM imports-loader ***/
var loadTerrific = __webpack_require__(1);
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function($) {
	'use strict';
	/*globals Tc */

	/**
	 * MultiDropdownFilterList
	 *
	 * @author Michael Keller
	 * @namespace Tc.Module
	 * @class MultiDropdownFilterList
	 * @extends Tc.Module
	 */
	Tc.Module.MultiDropdownFilterList = Tc.Module.extend({

		on: function(callback) {
			var mod = this,
				$ctx = mod.$ctx;

			mod.currentValues = {};

			$ctx.on('click', '.filterParamRemove', function() {
				mod.fire('removeFilter', { name : jQuery(this).closest('li').find('.breadcrumb-label').data('filterType'), value : jQuery(this).closest('li').find('.breadcrumb-label').data('value')});
				$(this).closest('li').remove();
			});

			$ctx.on('click', '.removeAllFilterButton + .icon-close', function() {
				mod.fire('clearAll');
			});

			callback();
		},


		onUpdateValue: function(data) {
			var mod = this;
			mod.currentValues[data.name] = data;
			mod.renderValues();
		},

		renderValues: function() {
			var mod = this,
				$ctx = mod.$ctx;

			$ctx.find('.filter-breadcrumb li').remove();

			$('.multiselect, .is-mobile select[multiple]').each(function() {
				if (mod.currentValues[jQuery(this).attr('name')]) {
					var data = mod.currentValues[jQuery(this).attr('name')],
						i = 0,
						$li = null,
						$label = null,
						$close = null;
					for (i = 0; data.valueObj && i < data.valueObj.values.length; i++) {
						$li = jQuery('<li />').appendTo(mod.$ctx.find('.filter-breadcrumb'));
						$label = jQuery('<span />').appendTo($li).addClass('breadcrumb-label').data('filterType', data.name).data('value', data.valueObj.values[i]).text(data.valueObj.labels[i]);
						$close = jQuery('<span />').appendTo($li).addClass('filterParamRemove').addClass('icon-close close-icon');
					}
				}
			});

			if ($ctx.find('li').length === 0) {
				$ctx.find('.removeAllFilterButton, .removeAllFilterButton + .icon-close').hide();
			}
			else {
				$ctx.find('.removeAllFilterButton, .removeAllFilterButton + .icon-close').show();
			}

		}

	});
}(Tc.$));

}.call(window));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var loadTerrific = __webpack_require__(1);
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function($) {
	'use strict';
	/*globals Tc */

	/**
	 * NewsTicker
	 *
	 * @author Michael Keller
	 * @namespace Tc.Module
	 * @class NewsTicker
	 * @extends Tc.Module
	 */
	Tc.Module.NewsTicker = Tc.Module.extend({

		on: function(callback) {
			var mod = this;
			
			mod.initnewsticker();

			callback();
		},

		/**
		 * get data from json file
		 */
		initnewsticker: function() {
			var mod = this,
				$ctx = mod.$ctx,
				cleanUrl = mod.stripParametersFromUrl(document.location.href),
				queryParams = null,
				newValues = [],
				i = null;


			mod.url = cleanUrl.substr(0, cleanUrl.lastIndexOf('.')) + '.pressreleaseservlet.json';
			mod.entriesPerPage = $ctx.data('num');
			mod.currentValues = {};
			mod.currentValues.num = {name:'num', valueObj: {labels:['none'], values: [$ctx.data('num')]}};
			// add one more result to the request to check if the "more"-button should be displayed
			mod.currentValues.num.valueObj.values[0]++; 

			mod.currentValues.offset = {name:'offset', valueObj: {labels:['none'], values: [$ctx.data('offset')]}};
			mod.currentValues.lang = {name:'lang', valueObj: {labels:['none'], values: [$ctx.data('lang')]}};
			mod.currentValues.categories = {name:'categories', valueObj: {labels:$ctx.data('categories').split(','), values: $ctx.data('categories').split(',')}};

			mod.currentData = [];

			queryParams = mod.getParametersFromUrl(document.location.href);
			if (queryParams && queryParams.categories) {
				mod.currentValues.categories = {name:'categories', valueObj: {labels:queryParams.categories.replace(/_8725_/g, '/').split(','), values: queryParams.categories.replace(/_8725_/g, '/').split(',')}};
			}

			if (mod.currentValues.categories && mod.currentValues.categories.valueObj && mod.currentValues.categories.valueObj.values && mod.currentValues.categories.valueObj.values.length > 0) {
				for (i = 0; i < mod.currentValues.categories.valueObj.values.length; i++) {
					newValues.push({ name : mod.currentValues.categories.name, label : mod.currentValues.categories.valueObj.labels[i], value : mod.currentValues.categories.valueObj.values[i] });
				}
				mod.fire('setFilters', {newValues: newValues});
			}


			$ctx.find('.more-results').on('click', '', function() {
				mod.loadData(true);
				return false;
			});

			mod.loadData(null);
		},

		onUpdateValue: function(data) {
			var mod = this;

			mod.currentValues[data.name] = data;

			// make sure that for multiple updates that are very shortly after each other are handled together (less ajax requests on clear all)
			if (mod.updateTimeout) {
				window.clearTimeout(mod.updateTimeout);
			}
			mod.updateTimeout = window.setTimeout(function() {
				mod.loadData();
			}, 50);
		},

		onLoadData: function() {
			this.loadData();
		},

		loadData: function(more) {
			var mod = this,
				$ctx = mod.$ctx,
				url = mod.url,
				request = null,
				clearCurrentView = false,
				extension = '',
				key = null;

			if (more) {
				mod.currentValues.offset.valueObj.values[0] += mod.entriesPerPage;
			}
			else {
				// no offset given - start search from 0
				clearCurrentView = true;
				mod.currentValues.offset.valueObj.values[0] = 0;
				mod.currentValues.num.valueObj.values[0] = mod.entriesPerPage + 1; // +1 to see if there are more results => display more button
			}

			extension = url.substr(url.lastIndexOf('.') + 1);
			url = url.substr(0, url.lastIndexOf('.'));

			if (mod.currentValues) {
				for (key in mod.currentValues) {
					if (mod.currentValues[key].valueObj === undefined) {
						continue;
					}
					else {
						url += '.' + mod.currentValues[key].name + '=' + mod.currentValues[key].valueObj.values.join(',').replace(/\//g, '_8725_');
					}
				}
			}

			url += '.' + extension;
			
			if (request !== null && request.readystate !== 4 && request.abort !== undefined) {
				request.abort();
			}

			$.ajax({
				type: 'GET',
				url: url,
				dataType: 'json',
				success: function(data) {
					
					var showMoreLink = false,
						dataToDisplay = data,
						$html = null,
						tempYear,
						tempMonth;

					// requested are always mod.entriesPerPage + 1 to see if there are still more items available => display more button
					if (dataToDisplay.length > mod.entriesPerPage) {
						showMoreLink = true;
						dataToDisplay = dataToDisplay.slice(0, mod.entriesPerPage);
					}


					// add quarter to data
					for (var i = 0; i < dataToDisplay.length; i++) {
						
						if (dataToDisplay[i].date && dataToDisplay[i].date.length === 10) {
							tempYear = dataToDisplay[i].date.substr(6);
							tempMonth = parseInt(dataToDisplay[i].date.substr(3, 2), 10) - 1;
							dataToDisplay[i].quarter = tempYear + " Q" + (Math.floor(tempMonth / 3) + 1);
						}
						else {
							dataToDisplay[i].quarter = '-';
						}
					}

					if (clearCurrentView) {
						mod.currentData = [];
					}
					mod.currentData = mod.currentData.concat(dataToDisplay);

					mod.tmplItem = doT.template($('script.tmpl-newsticker', $ctx).html());
					$html = $(mod.tmplItem(mod.currentData));


					mod.$ctx.find('div.news-list-holder').html($html);

					if (showMoreLink) {
						$ctx.find('.more-results').show();
					}
					else {
						$ctx.find('.more-results').hide();
					}

				},

				error: function () {
					debug.log('Tc.Module.NewsTicker > data ajax error');
				}
			});
			
		},

		onSearch: function(data) {
			
			var mod = this;
			mod.currentValues.fulltext = {name:'fulltext', valueObj: {labels:['none'], values: [data.fulltext]}};
			mod.loadData();
		},

		stripParametersFromUrl: function(url) {
			var folderPath = url.substr(0, url.lastIndexOf('/')+1),
				filePath = url.substr(url.lastIndexOf('/')+1),
				query = '',
				newFilePath = '';
			if (url.indexOf('?') !== -1) {
				query = url.substr(url.indexOf('?'));
				filePath = filePath.substr(0, filePath.indexOf('?'));
			}
			newFilePath = filePath.substr(0, filePath.indexOf('.')) + filePath.substr(filePath.lastIndexOf('.'));
			return folderPath + newFilePath + query;

		},

		getParametersFromUrl: function(url) {
			var filePath = url.substr(url.lastIndexOf('/')+1),
				parameterPart = filePath.substr(filePath.indexOf('.') + 1),
				paramArray = '',
				data = {},
				i = 0,
				tempArr = null;

			parameterPart = parameterPart.substr(0, parameterPart.lastIndexOf('.'));
			paramArray = parameterPart.split('.');

	 		for (i; i < paramArray.length; i++) {
				tempArr = paramArray[i].split('=');
				if (tempArr.length === 2) {
					data[tempArr[0]] = tempArr[1];
				}
			}

			return data;
		}
	});
}(Tc.$));
}.call(window));

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var loadTerrific = __webpack_require__(1);
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function($) {
	/*
	 * Dependencies:
	 * TerrificJs 2.0.1,
	 * jQuery 1.7 or greater,
	 * jquery.placeholder.min.js,
	 *
	 */

	'use strict';
	/*globals Tc */
	/*jshint smarttabs:true */

	Tc.Module.PageBackground = Tc.Module.extend({

		on: function(callback) {
			var mod = this;
			mod.settingsContainer = $('.scs-stage-flat', mod.$ctx);
			if (mod.settingsContainer.length === 0) {
				mod.settingsContainer = $('<div>').addClass('scs-stage-flat');
				mod.$ctx.prepend(mod.settingsContainer);
			}

			mod.defaultCss = {};
			mod.defaultCss['background-repeat'] = mod.settingsContainer.css('background-repeat');
			mod.defaultCss['background-color'] = mod.settingsContainer.css('background-color');
			mod.defaultCss['background-image'] = mod.settingsContainer.css('background-image');
			mod.defaultFullHeightBackground = mod.settingsContainer.hasClass('full-height-background');

			mod.imageTag = $('.scs-stage-backgroundimage', mod.settingsContainer);
			if (mod.imageTag.length === 0) {
				mod.imageTag = $('<img>').attr('src', '').attr('alt', '').addClass('scs-stage-backgroundimage').addClass('hidden');
				mod.settingsContainer.append(mod.imageTag);
			}
			mod.imageTag.data('default', mod.imageTag.attr('src'));

			mod.$ctx.on('setBackground', $.proxy(mod.setBackground, mod));
			callback();
		},

		setBackground: function(event, image, color, repeatX, repeatY) {
			var mod = this,
				css = {},
				usesRepeat = false;

			if (repeatX && repeatY) {
				css['background-repeat'] = 'repeat';
			} else if (repeatX) {
				css['background-repeat'] = 'repeat-x';
			} else if (repeatY) {
				css['background-repeat'] = 'repeat-y';
			} else if (repeatX === false && repeatY === false) {
				css['background-repeat'] = 'no-repeat';
			} else {
				css['background-repeat'] = mod.defaultCss['background-repeat'];
			}

			if (color) {
				css['background-color'] = color;
			} else {
				css['background-color'] = mod.defaultCss['background-color'];
			}

			if (image) {
				if (css['background-repeat'] === 'no-repeat') {
					mod.imageTag.attr('src', image).removeClass('hidden');
					css['background-image'] = 'none';
				} else {
					css['background-image'] = 'url(' + image + ')';
					mod.imageTag.addClass('hidden');
				}
			} else {
				if (css['background-repeat'] === 'no-repeat' && mod.imageTag.data('default')) {
					mod.imageTag.removeClass('hidden');
				} else {
					mod.imageTag.addClass('hidden');
				}
				mod.imageTag.attr('src', mod.imageTag.data('default'));
				css['background-image'] = mod.defaultCss['background-image'];
			}
			if (!color && !image && !mod.defaultFullHeightBackground) {
				mod.settingsContainer.removeClass('full-height-background');
			} else {
				mod.settingsContainer.addClass('full-height-background');
			}
			mod.settingsContainer.css(css);
		}
	});
	
}(Tc.$));
}.call(window));

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var loadTerrific = __webpack_require__(1);
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function (Module, $) {
	'use strict';
	/*globals Tc, SCS, scsHeader */

	/**
	 * Personalization Container
	 *
	 * @author Dave Talamona (tzhtada2)
	 * @namespace Tc.Module
	 * @class PersonalizationContainer
	 * @extends Tc.Module
	 */

	Module.PersonalizationContainer = Module.extend({

		conditions: [], // array of strings with keys for personalization-checks
		conditionIndex: -1,

		/**
		 * Init (called onDomReady)
		 *
		 * @method on
		 * @param {Function} callback function
		 * @return void
		 */
		on: function (callback) {
			var mod = this;

			// break in author / edit mode
			if ($('body').hasClass('cq_isEditMode')) {
				callback();
				return;
			}

			mod.conditions = mod.$ctx.data('conditions').substr(1, mod.$ctx.data('conditions').length - 2).split(',');
			mod.checkNextCondition();

			callback();
		},

		checkNextCondition: function (result) {
			var mod = this;

			mod.conditionIndex++;

			// condition failed? -> show normal content, not personalized one
			if (result === false) {
				mod.$ctx.addClass('normal');
				SCS.utils.initNewModules(mod.$ctx.children('.normal'));
			}

			// all conditions checked and none failed? -> show personalized content, not normal one
			else if (mod.conditionIndex >= mod.conditions.length) {
				mod.$ctx.addClass('personalized');
				SCS.utils.initNewModules(mod.$ctx.children('.personalized'));
			}

			// check next condition
			else {
				mod['condition_' + $.trim(mod.conditions[mod.conditionIndex])]($.proxy(mod.checkNextCondition, mod));
			}
		},


		/**
		 * -------------------------------------------------------------------------------------------------------------
		 * INSERT CONDITION-CHECKING FUNCTIONS HERE
		 * follow the naming-convention "condition_XXX" where "XXX" ist the name of the condition in the data attribute
		 * -------------------------------------------------------------------------------------------------------------
		 */

		// is user logged in or not?
		condition_loggedIn: function (callback) {
			__webpack_require__(5).getProfile().then(function(profile) {
				callback(!!profile.getUser());
			});
		},

		// user has items in quickbasket?
		condition_quickbasketHasItems: function (callback) {
			SCS.utils.ajaxCache.getJSON(this.$ctx.data('quickbasket-list-url') + '?session_lang=' + $('html').attr('lang'), function (json) {
				var hasItems = !!(json && json.quickBaskets && json.quickBaskets.length);

				// tracking
				if (hasItems) {
					var siteCatalyst = window.s || window.s_one;
					if(siteCatalyst) {
						SCS.portal.datalayer.trackEvent('view', 'quickbasket', siteCatalyst.pageName, 'quickbasket', 'Quickbasket View');
					}
				}

				callback(hasItems);
			});
		}
	});

})(Tc.Module, Tc.$);

}.call(window));

/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var loadTerrific = __webpack_require__(1);
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function ($, SCS) {
	"use strict";
	/*globals Tc */
	/*jshint smarttabs:true */

	/**
	 * PexArticleList module implementation.
	 *
	 * @author Dave Talamona
	 * @namespace Tc.Module
	 * @class PexArticleList
	 * @extends Tc.Module
	 */
	Tc.Module.PexArticleList = Tc.Module.extend({

		/**
		 * Hook function to do all of your module stuff.
		 *
		 * @method on
		 * @param {Function} callback function
		 * @return void
		 */
		on: function(callback) {
			var mod = this,
				$ctx = mod.$ctx, 
				$articleList = $ctx.find("ul.article-list");

			// Check for mobile news list
			if (SCS.utils.isMobilePage() && 
				!$articleList.hasClass("isPromotions") && 
				!$articleList.hasClass('article-list-new-business')) {
					mod.setMobileNewsList($articleList);
			}
			
			// Load more atricles
			mod.numOfVisibleArticles = $articleList.find('.article-list-item:not(.hidden)').length;
			$ctx.find('.loadMore').on('click', function () {
				$articleList.find('.article-list-item.hidden').filter(':lt(' + mod.numOfVisibleArticles + ')').removeClass('hidden');
				mod.checkLoadMore();
			});
			
			mod.checkLoadMore();

			callback();
		},

		checkLoadMore: function () {
			var mod = this,
				$ctx = mod.$ctx;

			if (!$ctx.find('.article-list-item.hidden').length) {
				$ctx.find('.loadMore').hide();
			}
		},
		
		
		/**
		 * Set mobile view for news list
		 * 
		 * @param $articleList {Object} List element 
		 */
		setMobileNewsList: function($articleList) {
			var mod = this,
				$element,
				$link;
			
			$articleList.find('> li').each(function(){
				$element = $(this);
				$link = $element.find('.link');
				
				$link.css('display','none');
				$element.append("<div class='chevron'></div>");
				$element.wrapInner('<a href="' + $link.attr('href') + '" style="navigation-simple scs-linklist-simple ui-link"></a>');
			});
		}
	});
}(Tc.$, window.SCS));
}.call(window));

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var loadTerrific = __webpack_require__(1);
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function ($) {
	"use strict";
	/*globals Tc, doT, SCS, debug */
	/*jshint smarttabs:true */

	var SdxFlyoutMenu = __webpack_require__(37).default;
	var SdxModal = __webpack_require__(7).default;
	var deparam = __webpack_require__(8).default;

	/**
	 * Page module implementation.
	 *
	 * @author Rami Attallah
	 * @namespace Tc.Module
	 * @class PexCustomerList
	 * @extends Tc.Module
	 */
	Tc.Module.PexCustomerList = Tc.Module.extend({

		// config
		lazyLoadRowNumber: 10, // number of rows to display at once on scroll
		lazyLoadRowsOffset: 40, // [px] space between bottom of the list and bottom of the window before next set of rows is displayed

		// vars with module scope
		rows: [], // contains all rows except the ones filtered out by the search function
		allRows: [], // contains all rows, even the ones filtered out by the search function
		displayedRowCount: 0, // rows loaded by the lazy loader
		searchForm: $(),
		headerColumns: $(),
		tableBody: $(),
		sortInfo: {prop: '', asc: true}, // stores latest sorting info for restoring after search
		columnSourceNames: {}, // contains names of properties in the JSON to search for (search must not process all available data)
		lazyLoaderInitialized: false,
		isAgent: false,
		lastSearchTerm: '',
		isMobile: $(),
		editRowIndex: null,
		incidentAvailableStatuses: {
			ongoingIncidents: ['Start', 'Update'],
			solvedIncidents: ['End']
		},
		incidentInitStatuses: {ongoingIncidents: true, solvedIncidents: true},
		incidentCurrentStatuses: {},
		statusFromHash: '',

		/**
		 * Hook function to do all of your module stuff.
		 *
		 * @method on
		 * @param {Function} callback function
		 */
		on: function (callback) {
			var mod = this;

			// init vars with module scope
			mod.itemCounter = mod.$ctx.find('.search-results span');
			mod.searchForm = mod.$ctx.find('form.search');
			mod.formCheckboxes = mod.$ctx.find('input:checkbox');
			mod.searchField = mod.$ctx.find('#search_field_pexcustomerlist');
			mod.headerColumns = mod.$ctx.find('th[data-source-name]');
			mod.tableWrapper = mod.$ctx.find('.table__wrapper');
			mod.tableBody = mod.$ctx.find('tbody');
			mod.isAgent = mod.$ctx.data('is-agent'); // boolean string is converted to boolean by jQuery
			mod.isMobile = $('body').hasClass('is-mobile'); // boolean string is converted to boolean by jQuery
			mod.isTrainingList = mod.$ctx.data('list-type') === 'training';
			mod.listUrl = mod.$ctx.data('list-url');
			mod.dialogButtonCloseText = mod.$ctx.data('dialog-button-close');
			mod.dialogButtonSaveText = mod.$ctx.data('dialog-button-save');
			mod.exportLink = mod.$ctx.find('.partner-links a[download]');
			mod.titles = mod.$ctx.data('traininglist-titles-mapping');

			// get source names of all visible table columns
			mod.headerColumns.each(function () {
				var columnSourceNamesStr = $(this).data('source-name'),
					columnSourceNamesArr = columnSourceNamesStr ? columnSourceNamesStr.split('/') : [];
				for (var i = 0; i < columnSourceNamesArr.length; i++) {
					mod.columnSourceNames[columnSourceNamesArr[i]] = true; // don't cue it in an array but set object property to true because it's faster while reading later on
				}
			});

			// reset search value when browser does auto-prefill
			mod.searchForm.find('input:text').val('');

			mod.initEventListeners();

			// load JSON when user is not an agent otherwise he has to search first
			if (!mod.isAgent) {
				if (mod.formCheckboxes.length) {
					mod.incidentCurrentStatuses = mod.incidentInitStatuses;
				}
				mod.loadJson('', function () {
					mod.readIncidentFilter();
				});
				mod.updateCsvLinkParameters();
			} else {
				// display empty message
				mod.checkEmpty();
			}

			callback();
		},

		updateCsvLinkParameters: function () {
			var $link = this.$ctx.find('.partner-links a').eq(0);
			var searchParams = $link.prop('search');
			searchParams = (searchParams ? searchParams + '&' : '?') + $.param(this.incidentCurrentStatuses);
			$link.prop('search', searchParams);
		},

		setupFadeoutEffect: function () {
			var mod = this;

			var el = mod.tableWrapper[0],
				threshold = 5,
				offset = el.scrollWidth - el.offsetWidth;

			if (el.scrollLeft > threshold && offset > threshold) {
				mod.tableWrapper.addClass('left-scroll');
			} else {
				mod.tableWrapper.removeClass('left-scroll');
			}

			if ((offset - el.scrollLeft) > threshold && offset > threshold) {
				mod.tableWrapper.addClass('right-scroll');
			} else {
				mod.tableWrapper.removeClass('right-scroll');
			}
		},

		initEventListeners: function () {
			var mod = this;

			// init sorting
			mod.headerColumns.on('click', function () {
				var $this = $(this),
					asc = $this.hasClass('sort-up');

				$this.toggleClass('sort-up', !asc);
				$this.toggleClass('sort-down', asc);
				$this.siblings().removeClass('sort-up');
				$this.siblings().removeClass('sort-down');
				mod.sort(($this.data('sort-name') ? $this.data('sort-name') : $this.data('source-name')), asc);
			});

			// init search
			mod.searchForm.on('submit', function (e) {
				e.preventDefault();
				e.stopImmediatePropagation();
				mod.search($(this).find('input:text').val());
			});

			mod.tableWrapper.on('scroll', function () {
				mod.setupFadeoutEffect();
			});

			// start search if hash value is set
			if (mod.isAgent) {
				mod.readIncidentFilter();
			}

			mod.formCheckboxes.on('change', function (e) {
				mod.formCheckboxes.each(function () {
					mod.incidentCurrentStatuses[$(this).attr('name')] = this.checked;
				});

				var searchTerm = mod.searchField.val() || '';
				mod.search(searchTerm);
				mod.updateCsvLinkParameters();
			});

			mod.exportLink.on('click', function () {
				if (mod.isTrainingList) {
					var pageTitle = $('meta[name="twitter:title"]').attr('content') || window.title;

					var keys = Object.keys(mod.titles);
					var index = keys.indexOf('title');
					// Move title to front if exists
					if(index > 0) {
						keys.splice(0, 0, keys[index]);
						keys.splice(index+1, 1);
					}
					var headers = keys.map(function(key) {return String(mod.titles[key]);})

					var rows = mod.rows
						.map(function(row) {
							return keys.map(function(title) {
								return String(row[title]);
							});
						});
					var actualDate = new Date();
					var blob = __webpack_require__(161).getXlsxBlob(
						headers,
						rows,
						pageTitle,
						{
							Company: 'Swisscom',
							Title: pageTitle,
							CreatedDate: actualDate
						}
					);
					var fileTitle = pageTitle + '-' + moment().format('YYYYMMDD_HHmmss');
					mod.exportLink.prop('download', fileTitle.replace(/\s+/, '-') + '.xlsx');
					mod.exportLink.prop('href', URL.createObjectURL(blob));
				}
			});

			// listeners for desktop only
			if (!mod.isMobile) {
				// show/hide action-dropdown
				mod.$ctx.on('mouseenter', '.people-icon', function () {
					var elem = $(this);
					if (!elem.data('qtip')) {
						elem.qtip({
							content: mod.$ctx.data('tip-text'),
							style: {
								classes: 'scs-callout',
								width: "140"
							}
						}).data('qtip').show();
					}
				});

				mod.$ctx.on('click', '.show-details', function () {
					mod.openDetailsDialog({title: event.target.textContent, buttonClose: mod.dialogButtonCloseText});
				});

				mod.$ctx.on('click', '.edit-record', function () {
					mod.openEditDialog({title: event.target.textContent, buttonClose: mod.dialogButtonCloseText, buttonSave: mod.dialogButtonSaveText});
				});

				mod.$ctx.on('click', '.add-record', function () {
					mod.editRowIndex = null;
					mod.openEditDialog({title: event.target.textContent, buttonClose: mod.dialogButtonCloseText, buttonSave: mod.dialogButtonSaveText});
				});

				mod.tableBody.on('mouseenter', 'tr', function (event) {
					var $menuButton = $(event.currentTarget).find('[data-action="dropdown-menu"]');
					mod.editRowIndex = $(this).index();

					mod.flyoutMenuInstance = $menuButton.length ? new SdxFlyoutMenu($menuButton[0]) : undefined;

					if (mod.flyoutMenuInstance) {
						mod.setMenuOpeningDirection();
						mod.flyoutMenuInstance._dynamicPlacement = false;
					}
				});

				mod.tableBody.on('mouseleave', 'tr', function () {
					if (mod.flyoutMenuInstance) {
						mod.flyoutMenuInstance.close();
					}
				});

				mod.tableBody.on('click', '.action-button', function () {
					var action = $(this).data('action'),
						$row = $(this).closest("tr");

					if (action === 'dropdown-menu' && mod.flyoutMenuInstance) {
						mod.flyoutMenuInstance.open();
					}

					if (action === 'delete') {
						mod.openConfirmationFlyout($row);
					}
				});
			}

			// listeners for mobile only
			else {
				// edit record - show form
				$(document).on('click', '.edit-record[target="newPage"]', function (event, newStage) {
					mod.editRowIndex = $(this).data('row-index');

					SCS.createNewMobilePage({
						content: mod.getFormHtml(mod.rows[mod.editRowIndex]),
						destroyOnClose: true
					});
				});

				// edit record - show form
				$(document).on('click', '.show-incident[target="newPage"]', function (event, newStage) {
					mod.editRowIndex = $(this).data('row-index');

					SCS.createNewMobilePage({
						content: mod.getDetailsHtml(mod.rows[mod.editRowIndex]),
						destroyOnClose: true
					});
				});
			}
		},

		loadJson: function (searchTerm, loadedCallback) {
			var mod = this;

			//empty table getting json might be slow
			mod.tableBody.empty();
			mod.$ctx.removeClass('is-empty');
			mod.$ctx.removeClass('max-Limit');
			mod.rows = [];
			mod.allRows = [];

			var term = searchTerm ? {term: searchTerm, '_charset_': 'UTF-8'} : {};
			var searchData = Object.assign({}, mod.incidentCurrentStatuses, term);

			$.getJSON(mod.listUrl, searchData, function (json) {
				var jsonRowArray = [],
					jsonArray = (mod.isTrainingList) ? json.trainings : json.customers;

				if (json && mod.isAgent && json.maxLimit === true) {
					mod.$ctx.removeClass('loading');
					mod.$ctx.addClass('max-Limit');
					return;
				}

				// read data from json into the "rows" array
				if (json && typeof jsonArray === "object" && jsonArray.length > 0) {
					mod.$ctx.removeClass('loading');

					jsonRowArray = $.makeArray(jsonArray); // convert json-array-object into a real array

					// process values in each row
					for (var i = 0; i < jsonRowArray.length; i++) { // not done via $.each because of memory problems with jQuery when the list contains thousands of records
						mod.processData(jsonRowArray[i], i);
					}

					mod.allRows = jsonRowArray;
					mod.rows = [].concat(mod.allRows); // create a copy of "allRows" ("mod.rows = mod.allRows" would create a reference)
					for (var key in mod.rows) {
						if (mod.rows.hasOwnProperty(key)) {
							// Trim empty values
							for (var j in mod.rows[key]) {
								if (mod.rows[key].hasOwnProperty(j)) {
									if (typeof mod.rows[key][j] === 'string') {
										mod.rows[key][j] = mod.rows[key][j].trim();
									}
								}
							}
						}
					}
				}

				// init list if data is there
				if (!mod.checkEmpty()) {
					// remove existing rows (in case of multiple searches as agent)
					mod.displayedRowCount = 0;
					mod.tableBody.empty();

					// render rows
					mod.appendRows(true);
					mod.setupFadeoutEffect();

					// restore sort if searches as agent
					if (searchTerm && mod.sortInfo.prop.length) {
						mod.sort(mod.sortInfo.prop, mod.sortInfo.asc);
					}

					if (!mod.lazyLoaderInitialized) {
						mod.lazyLoaderInitialized = true;

						// init lazy loading of rows
						$(window).on('scroll resize orientationchange', function () {
							mod.appendRows();
						});
					}
				}

				if (typeof loadedCallback === "function") {
					loadedCallback.apply(mod);
				}

			}).fail(function () {
				mod.$ctx.addClass('error-json');
			});
		},

		appendRows: function (showAnyWay) {
			var mod = this,
				win = $(window),
				bottomScrollOffset = win.height() - (mod.tableBody.height() + mod.tableBody.offset().top - win.scrollTop());

			if (mod.displayedRowCount < mod.rows.length && (showAnyWay || bottomScrollOffset > mod.lazyLoadRowsOffset)) {
				mod.tableBody.append(mod.getRowHtml(mod.rows.slice(mod.displayedRowCount, (mod.displayedRowCount += mod.lazyLoadRowNumber))));
				mod.appendRows(); // fill the viewport with rows
			}
		},

		setMenuOpeningDirection: function () {
			var mod = this;

			var $menu = $(mod.flyoutMenuInstance._flyoutElement),
				$list = $menu.find('ul');

			$list.find('a, button').removeClass('flyout__indicator');

			var bottomOffset = window.innerHeight - Math.round(mod.flyoutMenuInstance.element.getBoundingClientRect().bottom);

			if ($menu.height() > bottomOffset) {
				$list.find('li').last().find('a, button').addClass('flyout__indicator');
				$menu.addClass('flyout--top');
				$menu.closest('.dropdown').addClass('top');
			} else {
				$list.find('li').first().find('a, button').addClass('flyout__indicator');
				$menu.removeClass('flyout--top');
				$menu.closest('.dropdown').removeClass('top');
			}
		},

		getRowHtml: function (data) {
			var mod = this,
				template = mod.$ctx.find('script.tmpl-pexcustomerlistview').html(),
				templateParsed = template.replace(/\{lang}/g, $('html').attr('lang')).replace(/\{scn}/g, '{{! item.scsCustomerId}}'),
				tmplItem = doT.template(templateParsed);

			return $(tmplItem(data));
		},

		getEditFormHtml: function (data) {
			var mod = this,
				tmplItemForm = doT.template(mod.$ctx.find('script.tmpl-pexcustomerlistview-form').html());

			return tmplItemForm(data);
		},
		getDetailsHtml: function (data) {
			var mod = this,
				tmplItemForm = doT.template(mod.$ctx.find('script.tmpl-pexcustomerlistview-details').html());

			return tmplItemForm(data);
		},

		sort: function (prop, asc) {
			var mod = this;

			mod.sortInfo = {prop: prop, asc: asc};

			mod.rows.sort(function (a, b) {
				var valA = a[prop],
					valB = b[prop];

				// make dates sortable
				/* disabled because the source-data does now contain timestamps instead of date strings
				var dateA, dateB;
				if (typeof valA == "string" && valA.match(/^[0-9]{1,2}\.[0-9]{1,2}\.[0-9]{2,4}$/)) {
					dateA = valA.split('.');
					valA = (new Date(dateA[2], dateA[1] - 1, dateA[0])).getTime();
					dateB = valB.split('.');
					valB = (new Date(dateB[2], dateB[1] - 1, dateB[0])).getTime();
				}
				*/

				if (valA === null || valA === '' || valA === undefined) {
					return (asc ? 1 : -1) * (valA === valB ? 0 : -1);
				} else if (valB === null || valB === '' || valB === undefined) {
					return (asc ? 1 : -1) * (valA === valB ? 0 : 1);
				}

				if (typeof valA === 'string' && typeof valB === 'string') {
					if (Number(valA) === valA && Number(valB) === valB) {
						valA = Number(valA);
						valB = Number(valB);
					} else {
						valA = valA.toLowerCase();
						valB = valB.toLowerCase();

						// do utf8 umlaut compatible string comparison if supported by the browser
						if (typeof valA.localeCompare === 'function') {
							return (asc ? 1 : -1) * valA.localeCompare(valB);
						}
					}
				}

				// do the sorting (JS is able to compare numbers AND string with the "<", ">" operators
				return (asc ? 1 : -1) * (valA > valB ? 1 : (valA < valB ? -1 : 0));
			});

			mod.tableBody.html(mod.getRowHtml(mod.rows.slice(0, mod.displayedRowCount)));
		},

		search: function (searchString) {
			var mod = this,
				renderLater = false,
				allSearchTerms = [];

			searchString = $.trim(searchString.toLowerCase());

			mod.rows = [].concat(mod.allRows); // create a copy of "allRows" ("mod.rows = mod.allRows" would create a reference)
			mod.lastSearchTerm = searchString;

			// filter rows
			if (!mod.isAgent) {
				allSearchTerms = searchString.replace(/-\s+/g, '-').replace(/-+/g, '-').split(/\s+/g);
				allSearchTerms.sort().reverse(); // process positive terms first, then negative ones (starting with "-")
				for (var i = 0; i < allSearchTerms.length; i++) {
					mod._searchHelper(allSearchTerms[i]);
				}
			} else {
				// load filtered rows from backend
				renderLater = true;
				mod.$ctx.addClass('loading is-agent');
				mod.loadJson(searchString);
			}

			// display filtered rows
			if (!renderLater) {
				if (mod.checkEmpty()) {
					mod.tableBody.empty();
				} else {
					if (mod.sortInfo.prop.length) {
						// restore sort (rendering happens in sort function)
						mod.sort(mod.sortInfo.prop, mod.sortInfo.asc);
					} else {
						// render list
						mod.tableBody.html(mod.getRowHtml(mod.rows.slice(0, mod.displayedRowCount)));
					}
				}
			}
		},

		_searchHelper: function (searchTerm) {
			var mod = this,
				filteredRows = [],
				isIgnoringTerm = (searchTerm.substr(0, 1) === '-'),
				termFound = false,
				addRow = false,
				ignoreRow = false,
				statusExists = false;

			// remove the "-" at the beginning of the term
			if (isIgnoringTerm) {
				searchTerm = searchTerm.substr(1);
			}

			// find rows that math the given search string
			for (var i = 0; i < mod.rows.length; i++) { // not done via $.each because of memory problems with jQuery when the list contains thousands of records
				addRow = isIgnoringTerm; // always add when isIgnoringTerm
				ignoreRow = false;

				if (Object.keys(mod.incidentCurrentStatuses).length) {
					for (var currentStatus in mod.incidentCurrentStatuses) {
						var activeStatus = mod.incidentCurrentStatuses[currentStatus] ? currentStatus : '';

						if (mod.incidentAvailableStatuses[activeStatus]) {
							statusExists = mod.incidentAvailableStatuses[activeStatus].some(function (availableStatus) {
								if (mod.statusFromHash) {
									return ((mod.rows[i]['sitStatus'] === availableStatus) && (mod.rows[i]['sitStatus'] === mod.statusFromHash));
								} else {
									return mod.rows[i]['sitStatus'] === availableStatus;
								}
							});

							if (statusExists) {
								break;
							}
						}
					}

					if (!statusExists) {
						continue;
					}
				}

				for (var key in mod.rows[i]) {
					if (mod.columnSourceNames[key] && mod.rows[i][key]) {
						termFound = mod.rows[i][key] && mod.rows[i][key].toString().toLowerCase().indexOf(searchTerm) >= 0; // if you want only results that start with the given value use "=== 0" instead of ">= 0"
						if (!isIgnoringTerm && termFound) {
							addRow = true;
							break;
						} else if (isIgnoringTerm && termFound) {
							ignoreRow = true;
							break;
						}
					}
				}

				if (addRow && !ignoreRow) {
					filteredRows.push(mod.rows[i]);
				}
			}

			mod.rows = filteredRows;
		},

		checkEmpty: function () {
			var mod = this,
				isEmpty = !mod.rows.length,
				isSearchString = (location.search && location.search.length
					&& location.search.indexOf('sit=' + this.searchForm.find('input:text').val()) > -1);

			// mark/unmark list as empty
			mod.$ctx.toggleClass('is-empty', isEmpty);
			mod.$ctx.toggleClass('is-search-string', isSearchString);
			mod.$ctx.removeClass('loading');
			// show number of results
			mod.itemCounter.html(mod.rows.length);

			return isEmpty;
		},

		openDetailsDialog: function (config) {
			var mod = this,
				content = (mod.editRowIndex !== null) ? mod.rows[mod.editRowIndex] : {},
				$dialog = $(mod.getDetailsHtml(content));

			SdxModal.show({
				buttons: [
					{
						primary: false,
						title: config.buttonClose,
						type: 'close'
					}
				],
				class: 'pex-customer-list-detail',
				title: content.title ? content.title.concat(' - ' + config.title) : config.title,
				fillWidth: true,
				html: $dialog
			});
		},

		openEditDialog: function (config) {
			var mod = this,
				content = mod.editRowIndex !== null ? mod.rows[mod.editRowIndex] : {},
				$dialog = $(mod.getEditFormHtml(content));

			SdxModal.show({
				buttons: [
					{
						primary: true,
						title: config.buttonSave,
						click: $.proxy(mod.handleEditData, mod, $dialog)
					},
					{
						primary: false,
						title: config.buttonClose,
						type: 'close'
					}
				],
				class: 'pex-customer-list-detail',
				title: content.title ? content.title.concat(' - ' + config.title) : config.title,
				fillWidth: true,
				html: $dialog
			});
		},

		prepareFormData: function (form) {
			var mod = this,
				rawFormData = {},
				isFormValid = true;

			form.find('input:not([disabled])').each(function () {
				var $validationRules = $(this).data('clientvalidation');

				if ($validationRules) {
					var $validatorInstance = ScForm.createClientValidation($validationRules),
						isFieldValid = mod.validateFormField(this, $validatorInstance);

					rawFormData[this.name] = $(this).val();

					if (rawFormData.eventDate) {
						rawFormData.eventTimeStamp = SCS.utils.date.fromString(rawFormData.eventDate).getTime();

					}

					if (mod.editRowIndex !== null) {
						rawFormData.pexCustomerId = mod.rows[mod.editRowIndex].pexCustomerId;
					}

					if (!isFieldValid) {
						isFormValid = false;
					}
				}
			});

			return isFormValid ? rawFormData : {};
		},

		validateFormField: function (field, $validatorInstance) {
			var $field = $(field),
				$validatedField = $validatorInstance.validate($field.val()),
				$message = $field.siblings('.message');

			if ($validatedField.isValid) {
				$field.closest('.input-field').removeClass('error');
				$message.find('span').empty();
			} else {
				$field.closest('.input-field').addClass('error');

				if ($validatorInstance.hasLengthValidation) {
					var lengthRange = [$validatorInstance.minLength.toString(), $validatorInstance.maxLength.toString()];

					$validatedField.message = lengthRange.length ? $validatedField.message.replace(/\{([a-zA-Z0-9]+)\}/g, function (_, placeholderName) {
						return lengthRange[placeholderName];
					}) : '';
				}

				$message.find('span').text($validatedField.message);
			}

			return $validatedField.isValid;
		},

		openConfirmationFlyout: function ($row) {
			var mod = this;

			var $confirmationFlyout = $row.find('.confirm-flyout');

			if ($confirmationFlyout) {
				$confirmationFlyout.addClass('open');

				$confirmationFlyout.find('.confirm-button').on('click', function () {
					var $button = $(this);

					var confirmAction = $button.data('confirm');

					if (confirmAction === 'cancel') {
						$confirmationFlyout.removeClass('open');
					}

					if (confirmAction === 'delete-record') {
						mod.handleDeleteRecord();
					}
				});
			}
		},

		handleDeleteRecord: function () {
			var mod = this;

			$.post({
				url: mod.listUrl,
				data: {
					operation: 'delete',
					customer: {pexCustomerId: mod.rows[mod.editRowIndex].pexCustomerId}
				},
				dataType: 'json',
				traditional: false
			}).done(function (json) {
				for (var j = 0; j < mod.allRows.length; j++) {
					if (json.pexCustomerId === mod.allRows[j].pexCustomerId) {
						mod.allRows.splice(j, 1);
						break;
					}
				}
				mod.rows.splice(mod.editRowIndex, 1);
				// re-render list
				if (mod.isMobile) {
					$(document).find('.stageMobile .back').trigger('click');
				}

				if (mod.sortInfo.prop.length) {
					// restore sort (rendering happens in sort function)
					mod.sort(mod.sortInfo.prop, mod.sortInfo.asc);
				} else {
					// render list
					mod.tableBody.html(mod.getRowHtml(mod.rows.slice(0, mod.displayedRowCount)));
				}

				mod.itemCounter.html(mod.allRows.length);
			});
		},

		handleEditData: function (form) {
			var mod = this,
				formRawData = mod.prepareFormData(form),
				$formErrorMessage = SdxModal.$html.find('.headingError');

			$formErrorMessage.addClass('hidden');

			if (Object.keys(formRawData).length) {
				SdxModal.$buttons.find('.button--primary').addClass('disabled');

				$.post({
					url: mod.listUrl,
					data: {
						operation: (mod.editRowIndex !== null ? 'update' : 'create'),
						customer: formRawData,
						'_charset_': 'UTF-8'
					},
					dataType: 'json',
					traditional: false
				}).done(function (json) {
					if (mod.isMobile) {
						$(document).find('.stageMobile .back').trigger('click');
					} else {
						SdxModal.close();
					}

					if (mod.editRowIndex !== null) {
						mod.processData(json, null);
						// update
						for (var i = 0; i < mod.allRows.length; i++) {
							if (json.pexCustomerId === mod.allRows[i].pexCustomerId) {
								mod.allRows[i] = json;
								break;
							}
						}
						mod.rows[mod.editRowIndex] = json;
					} else {
						mod.processData(json, mod.getNextTableIndex());
						// create
						mod.allRows.push(json);
						mod.rows.push(json);

						mod.itemCounter.html(mod.rows.length);
					}
					// re-render list
					if (mod.sortInfo.prop.length) {
						// restore sort (rendering happens in sort function)
						mod.sort(mod.sortInfo.prop, mod.sortInfo.asc);
					} else {
						// render list
						mod.tableBody.html(mod.getRowHtml(mod.rows.slice(0, mod.displayedRowCount)));
					}
				})
					.fail(function () {
						$formErrorMessage.removeClass('hidden');
						SdxModal.$buttons.find('.button--primary').removeClass('disabled');
					});
			}
		},

		getNextTableIndex: function () {
			var mod = this,
				highestIndex = 0;

			for (var j = 0; j < mod.allRows.length; j++) {
				if (mod.allRows[j].index !== null) {
					highestIndex = Math.max(mod.allRows[j].index, highestIndex);
				}
			}

			return highestIndex + 1;
		},

		getStatusKeyByValue: function (value) {
			var mod = this;

			return Object.keys(mod.incidentAvailableStatuses).find(function (key) {
				if (mod.incidentAvailableStatuses[key].includes(value)) {
					return key;
				}
			});
		},

		loadIncidentFilter: function (params) {
			var mod = this;

			if (('incidentStatus' in params)) {
				mod.statusFromHash = params.incidentStatus;
				var statusType = mod.getStatusKeyByValue(mod.statusFromHash);

				if (statusType) {
					mod.formCheckboxes.each(function () {
						var status = ($(this).attr('name') === statusType);
						$(this).prop("checked", status).trigger('change');
					})
				}

				mod.searchForm.trigger('submit');
			}

			if (('sit' in params)) {
				mod.searchForm
					.find('input:text')
					.val(params.sit);

				mod.searchForm.trigger('submit');
			}
		},

		readIncidentFilter: function () {
			if (location.search && !!location.search.length) {
				var params = deparam(location.search.substr(1));
				if (params) {
					this.loadIncidentFilter(params);
				}
			}
		},

		processData: function (row, index) {
			var rowDate;
			// process date -> not done via "moment" library because of performance when the list contains thousands of records (at 710 records the lib takes 30ms and the native way only 2ms)
			if (row.eventTimeStamp !== null) {
				rowDate = new Date(Number(row['eventTimeStamp'])); // number conversion because otherwise Firefox prints "invalid date"
				row.eventDate = (rowDate.getDate() < 10 ? '0' : '') + rowDate.getDate() + '.' + (rowDate.getMonth() < 9 ? '0' : '') + (rowDate.getMonth() + 1) + '.' + (rowDate.getFullYear());
			}
			if (row.sitStartTime !== null) {
				rowDate = new Date(Number(row['sitStartTime'])); // number conversion because otherwise Firefox prints "invalid date"
				row.sitStartDate = (rowDate.getDate() < 10 ? '0' : '') + rowDate.getDate() + '.' + (rowDate.getMonth() < 9 ? '0' : '') + (rowDate.getMonth() + 1) + '.' + (rowDate.getFullYear());
			}

			if (row.sitLastUpdate !== null) {
				rowDate = new Date(Number(row['sitLastUpdate'])); // number conversion because otherwise Firefox prints "invalid date"
				row.sitLastUpdateDate = (rowDate.getDate() < 10 ? '0' : '') + rowDate.getDate() + '.' + (rowDate.getMonth() < 9 ? '0' : '') + (rowDate.getMonth() + 1) + '.' + (rowDate.getFullYear());
			}

			// move users reference from "data" property one level up for easier search and sort
			if (row.data) {
				row.linkName = row.data.linkName;
				row.linkUrl = row.data.linkUrl;
			}

			if (row.linkUrl && row.linkUrl.substr(0, 4).toLowerCase() !== 'http') {
				row.linkUrl = 'http://' + row.linkUrl;
			}

			if (row.customerPhoneNumber) {
				row.phoneNumber = row.customerPhoneNumber.replace(/\s+/g, '');
			}

			if (index !== null && !row.hasOwnProperty('index')) {
				row['index'] = index;
			}

			// protect user from destructive html/script injection (XSS)
			for (var key in row) {
				//noinspection JSUnfilteredForInLoop
				if (typeof row[key] === 'string' && row[key].indexOf('<') >= 0) {
					//noinspection JSUnfilteredForInLoop
					row[key] = row[key].replace(/</g, '&lt;');
				}
			}
		}

	});
}(Tc.$));

}.call(window));

/***/ }),
/* 161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["getXlsxBlob"] = getXlsxBlob;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);

function s2ab(s) {
    var buf = new ArrayBuffer(s.length); // Convert s to arrayBuffer
    var view = new Uint8Array(buf); // Create uint8array as viewer
    for (var i = 0; i < s.length; i++) {
        view[i] = s.charCodeAt(i) & 0xFF; // Convert to octet
    }
    return buf;
}
function getXlsxBlob(headers, rows, sheetName, props) {
    var wb = XLSX.utils.book_new();
    wb.Props = props;
    var ws = XLSX.utils.aoa_to_sheet(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __spreadArray */])([headers], rows));
    wb.SheetNames.push(sheetName);
    wb.Sheets[sheetName] = ws;
    var result = XLSX.write(wb, { bookType: 'xlsx', type: 'binary' });
    return new Blob([s2ab(result)], { type: 'application/vnd.ms-excel' });
}


/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var loadTerrific = __webpack_require__(1);
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function ($) {
	"use strict";
	/*globals Tc */
	/*jshint smarttabs:true */

	/**
	 * PexDocumentList module implementation.
	 *
	 * @author Walid Ghazzo
	 * @namespace Tc.Module
	 * @class PexDocumentList
	 * @extends Tc.Module
	 */
	Tc.Module.PexDocumentList = Tc.Module.extend({

		/**
		 * Hook function to do all of your module stuff.
		 *
		 * @method on
		 * @param {Function} callback function
		 * @return void
		 */
		on: function(callback) {
			var mod = this,
				$ctx = mod.$ctx;

			mod.initModel();
			callback();
		},

		/**
		 * Initializes the model
		 * @method initModel
		 * @return {Tc.Module.PexDocumentList} Module
		 */
		initModel: function () {
			var mod = this,
				$ctx = mod.$ctx,
				url = $ctx.data("action");

			var data = $.getJSON(url, function (response) {
				$ctx.find('.scs-loadingRotator').addClass('hidden');
				
				// Success: fetch json and apply bindings
				var templateScript = mod.$ctx.find('script.tmpl-pexdocumentlistview'),
					template = doT.template(templateScript.html());

				templateScript.after(template(response));
				
			}).fail(function() {
				
				// Fail: hide table and show error
				$ctx.find('.scs-loadingRotator').addClass('hidden');
				$ctx.find('table').hide();
				$ctx.find('.error').removeClass('hidden').show();
			});

			return mod;
		}
	});
}(Tc.$));

}.call(window));

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var loadTerrific = __webpack_require__(1);
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function($, w, SCS) {
	"use strict";
	/*globals Tc */

	/**
	 * MyStatus
	 *
	 * @author Sebastian Bartels
	 * @namespace Tc.Module
	 * @class MyStatus
	 * @extends Tc.Module
	 */
	Tc.Module.MyStatus = Tc.Module.extend({

		on: function(callback) {
			var mod = this;
			
			// Declare vars
			mod.declareVars();
						
			// If we are on mobile page process HTML and fire up window resize event
			if (SCS.utils.isMobilePage()) {
				mod.prepareMobileContent();
				mod.updateStatusBarsOnResize();
			}

			// get user data
			mod.userData = mod.$ctx.find('.userdata:first').data();
			if (mod.userData.level === "undefined" || mod.userData.level === "nodisplay") {
				mod.userHasNoLevel = true;
			}

			// get available levels
			mod.getAvailableLevels();

			// mark the target-step(s) as active
			mod.$ctx.find('.step' +
                (mod.userData.level ? '.' + mod.userData.level : '') +
                ', .marker-line' +
                (mod.userData.level ? '.' + mod.userData.level : '')).addClass('active');

			// update the status bars
			mod.updateStatusBar('sales');
			mod.updateStatusBar('training');
			
			callback();
		},

		getAvailableLevels: function () {
			var mod = this,
				levelMarkers = mod.$ctx.find('.progressbar:first .marker-line');

			mod.$ctx.find('.levels:first > span[data-name]').each(function (i) {
				var data = $(this).data();

				data.index = i;
				data.markerPosition = levelMarkers.filter('.' + data.name).position().left;

				mod.levels.push(data);

				// get users target level
				if (mod.userData.level === data.name) {
					mod.userTargetLevelIndex = data.index;
				}

				// get users current index
				if (mod.userData.salesValue >= data.salesValue) {
					mod.userCurrentLevelIndex.sales = data.index;
				}
				
				if (mod.userData.trainingValue >= data.trainingValue) {
					mod.userCurrentLevelIndex.training = data.index;
				}
			});
		},

		updateStatusBar: function (sectionName) {
			var mod = this,
				section = mod.$ctx.find('.section.' + sectionName),
				currentBar = section.find('.bar.current'),
				targetBar = section.find('.bar.target'),
				currentBarWidth = 1,
				targetBarWidth = mod.levels[mod.userTargetLevelIndex].markerPosition + 1,
				currentValue = mod.userData[sectionName + 'Value'],
				level = mod.levels[mod.userCurrentLevelIndex[sectionName]],
				levelValue = level[sectionName + 'Value'],
				nextLevel = mod.levels[level.index + 1],
				nextLevelValue = (nextLevel ? nextLevel[sectionName + 'Value'] : 0);

			// current progressbar
			if (!mod.userHasNoLevel && (currentValue > 0 || currentValue === levelValue)) {
				// users value is higher then the highest level
				if (!nextLevel && currentValue > levelValue) {
					currentBarWidth = currentBar.parent().width();
				} else if (level.index === 0 && currentValue < levelValue) { // users value is lower then the first level
					currentBarWidth = Math.max(level.markerPosition / levelValue * currentValue, currentBarWidth);
				} else if (currentValue === levelValue || !nextLevel) { // users value is exactly at one levels value
					currentBarWidth = level.markerPosition + 1;
				} else {
					currentBarWidth = level.markerPosition + ((nextLevel.markerPosition - level.markerPosition) / (nextLevelValue - levelValue) * (currentValue - levelValue));
				}
			}
			
			currentBar.width(currentBarWidth);

			/* Adjust position of current callout
			 Because callout on mobile is located below progress bars, 
			 we don't need to calculate it position */  
			if (!SCS.utils.isMobilePage()) {
				mod.adjustCurrentCallout(currentBar, currentBarWidth);
			}

			// target progressbar
			if (currentBarWidth < targetBarWidth) {
				targetBar.css({
					width: ((targetBarWidth - currentBarWidth) + 1) + "px",
					left: (currentBarWidth - 1) + "px"
				});
				
				// Update separator line color
				mod.updateSeparatorLineColor(section, currentBarWidth);
			} else {
				section.find('.info-status').hide();
				targetBar.hide();
			}
		},

		adjustCurrentCallout: function (currentBar, currentBarWidth) {
			var mod = this,
				currentCalloutPosition,
				currentCallout,
				currentCalloutWidth,
				currentCalloutAvaillableWidth;

			if (currentBarWidth > mod.currentCalloutOffset) {
				currentCallout = currentBar.find('.current-callout');
				currentCalloutPosition = currentBarWidth - mod.currentCalloutOffset;
				currentCalloutWidth = currentCallout.outerWidth();
				currentCalloutAvaillableWidth = currentCallout.closest('.progressbar').width();
				if (currentCalloutPosition + currentCalloutWidth > currentCalloutAvaillableWidth) {
					currentCalloutPosition = currentCalloutAvaillableWidth - currentCalloutWidth;
				}
				currentCallout.css('left', currentCalloutPosition + 'px');
			}
		},
		
		/**
		 *  Prepare content for mobile platforms
		 */
		prepareMobileContent: function() {
			var $element;
				
			// Remove call-out classes
			this.$ctx.find('.call-out').each(function() {
				$element = $(this);
				$element.removeClass('call-out').addClass('info-status').insertAfter($element.closest('.progressbar'));
			});
		},
		
		/**
		 * Update separator border color line based on bar progress
		 * 
		 * @param section {Object} Wrapper element of progress bar
		 * @param currentBarWidth {Float} Current progress width 
		 */
		updateSeparatorLineColor: function(section, currentBarWidth) {
			var $element;
				
			section.find('.marker-line').each(function (index, element) {
				$element = $(element);
				if ($element.position().left > currentBarWidth) {
					$element.addClass('overlay-color');
				}
			});
		},
		
		/**
		 * Update both status bars if user view-port resize
		 */
		updateStatusBarsOnResize: function() {
			var mod = this;
			
			$(w).resize(function() {

                // Declare vars
                mod.declareVars();

                // get user data
                mod.userData = mod.$ctx.find('.userdata:first').data();
                if (mod.userData.level === "undefined" || mod.userData.level === "nodisplay") {
                    mod.userHasNoLevel = true;
                }

                // get available levels
                mod.getAvailableLevels();

                // update the status bars
                mod.updateStatusBar('sales');
                mod.updateStatusBar('training');
			});
		},
		
		/**
		 * Declare module vars
		 */
		declareVars: function() {
			var mod = this;
			
			// Config
			mod.currentCalloutOffset = 20;
	
			// vars
			mod.levels = [];
			mod.userData = {};
			mod.userHasNoLevel = false;
			mod.userTargetLevelIndex = 0;
			mod.userCurrentLevelIndex = {
				sales: 0,
				training: 0
			};
		}
	});
}(Tc.$, window, window.SCS));
}.call(window));

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_Tc_dot_$) {/*** IMPORTS FROM imports-loader ***/
var loadTerrific = __webpack_require__(1);
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function (Tc, $, w, d, SCS) {
	'use strict';

	/**
	 * PexFavoriteList
	 *
	 * @author ewessolek, Rami A, David T
	 * @namespace Tc.Module
	 * @class PexFavoriteList
	 * @extends Tc.Module
	 */
	Tc.Module.PexFavoriteList = Tc.Module.extend({

		on: function (callback) {
			var mod = this,
				$ctx = mod.$ctx,
				$listContainer = $ctx.find('.scs-favorites-list-container'),
				$showfavoriteList = $ctx.find('.show-favorite-list'),
				$showfavoriteListArrow = $showfavoriteList.find('span'),
				mobileSearch;

			// Module vars
			mod.listData = null;
			mod.normalTemplate = null;
			mod.editTemplate = null;
			mod.baseurl = null;
			mod.list = null;
			mod.isMobile = SCS.utils.isMobilePage();

			// open/close list
			$showfavoriteList.click(function () {

				// Check if search bar is visible
				if (mod.isMobile) {
					mobileSearch = $ctx.parent().prev();
					if (mobileSearch.hasClass('scs-sitesearch-active-icon')) {
						mobileSearch.removeClass('scs-sitesearch-active-icon');
						$('#scs-pageheader-search-form').slideUp('fast');
					}
				} else {
					$showfavoriteListArrow.toggleClass('arrow-up').toggleClass('arrow-down');
				}

				$ctx.toggleClass('open');

				if (!mod.listData) {
					mod.readJson();

					// Sizing of the list-container
					if (!mod.isMobile) {
						var $win = $(w),
							topPos = $listContainer.offset().top,
							bottomSpacing = 100,
							$listContent = $listContainer.find('.scs-favorites-list-content'),
							otherHeight = $listContent.height() - $listContent.height();

						$win.resize(function () {
							$listContent.css('max-height', ($win.height() - topPos - bottomSpacing - otherHeight) + 'px');
						});
					}
				}
			});

			$ctx.click(function (e) {
				e.stopPropagation();
			});

			$(d).click(function () {
				if ($listContainer.is(':visible')) {
					if (!mod.isMobile) {
						$showfavoriteListArrow.removeClass('arrow-up').addClass('arrow-down');
					}

					$ctx.removeClass('open');
				}
			});

			// toggle normal/edit modes
			$ctx.find('a.favorite-list-edit-link').click(function () {
				var link = $(this);

				// call function "normalMode" or "editMode" according to button state
				mod[(link.hasClass('active') ? 'normal' : 'edit') + 'Mode']();
				$ctx[(link.hasClass('active') ? 'remove' : 'add') + 'Class']('edit');

				link.toggleClass('active');
			});

			$ctx.on('click', '.link-actions a.edit', function () {
				$(this).closest('.normal').next('.edit').removeClass('is-hidden').css('display', 'table-row').find('input').focus();
				$(this).closest('.normal').addClass('is-hidden');
			});

			// event listeners
			$ctx.on('click', 'div.normal a.edit', function () {
				$(this).closest('li').addClass('edit');
			});
			$ctx.on('click', 'div.normal a.delete', function () {
				mod.deletePage($(this).closest('li').data('id'));
			});
			$ctx.on('click', 'div.edit a.save', function () {
				mod.editPage(
					$(this).closest('li').data('id'),
					$(this).closest('div.edit').find('input').val()
				);
				$(this).closest('li').find('> .edit').addClass('is-hidden');
				$(this).closest('li').find('> .normal').removeClass('is-hidden');
			});
			$ctx.find('.add-current-url').click(function () {
				if (!$(this).hasClass('disabled')) {
					var start = w.location.href.indexOf(w.location.pathname);
					mod.addPage(w.location.href.substr(start, w.location.href.length), $('head > title').html());
				}
			});

			$ctx.find('.add-url').click(function () {
				var favListExternalUrl = mod.$ctx.find('#favlist-external-url'),
					favListExternalUrlValue = $.trim(favListExternalUrl.val()),
					favListExternalUrlTitle = favListExternalUrlValue;
				if (!$(this).hasClass('disabled') && favListExternalUrlValue) {

					//if link from location.origin & pex ([www|partner(-[sirius|orion|vega])].swisscom.ch/{lang}/pex/), save it relative
					var reg = new RegExp('^' + location.origin + '/(de|fr|it|en)/pex/.*')
					if (reg.test(favListExternalUrlValue)) {
						favListExternalUrlValue = favListExternalUrlValue.replace(w.location.origin, '');
					} else if (!/http[s]?:\/\//.test(favListExternalUrlValue.substr(0, 8))) {
						favListExternalUrlValue = 'http://' + favListExternalUrlValue;
						favListExternalUrlTitle = favListExternalUrlValue;
					}

					mod.addPage(favListExternalUrlValue, favListExternalUrlTitle);
					favListExternalUrl.val('');
				}
			});

			$(d).on('click', '.modPexDocumentList a.save', function () {
				var docLink = $(this),
					addDocument = function () {
						if (mod.checkListLength()) {
							mod.addPage(
								docLink.data('link'),
								docLink.data('title')
							);
							docLink.css('visibility', 'hidden');
						} else {
							$ctx.find('.show-favorite-list').trigger('click');
							$(w).scrollTop(0);
						}
					};

				if (!mod.listData) {
					mod.readJson(addDocument);
				} else {
					addDocument();
				}
			});

			// get templates
			mod.normalTemplate = window.doT.template(mod.$ctx.find('script.tmpl-pexfavoritelistview').html());
			mod.editTemplate = window.doT.template(mod.$ctx.find('script.tmpl-pexfavoritelistedit').html());

			// set module-globals
			mod.baseurl = $ctx.data('baseurl');
			mod.list = mod.$ctx.find('.scs-favorites-list-content ul');

			callback();
		},

		readJson: function (callback) {
			var mod = this;
			var favouriteItem, favouriteJsonData;
			$.getJSON(mod.baseurl + 'favoriteslist.get.json', {noCache: (new Date()).getTime()}, function (json) {
				if (json.success) {
					json = json.favoriteItems;
					favouriteJsonData = [];
					// check for internal/external url
					for (var i = 0; json[i]; i += 1) {
						favouriteItem = json[i];

						if (!favouriteItem.href || favouriteItem.href === null || favouriteItem.href === undefined || favouriteItem.href === '') {
							continue;
						}
						favouriteItem.external = !mod.isInternalUrl(favouriteItem.href);
						favouriteJsonData.push(favouriteItem);
					}
					// save json for later use
					mod.listData = favouriteJsonData;
					// draw link list
					mod.normalMode();
					mod.checkListLength();

					if (typeof callback === 'function') {
						callback();
					}
				} else {
					mod.$ctx.addClass('error-json');
				}
			})
				.fail(function () {
					mod.$ctx.addClass('error-json');
				});
		},

		isInternalUrl: function (url) {
			return (url.indexOf('localhost') > -1 || url.indexOf('swisscom.ch/') > -1 || url.indexOf('swisscom.com/') > -1 || url.indexOf('/') === 0) && url.indexOf('.html') > -1;
		},

		normalMode: function () {
			var mod = this;

			mod.list.html(mod.normalTemplate(mod.listData));
		},

		editMode: function () {
			var mod = this;

			mod.list.html(mod.editTemplate(mod.listData));
		},

		addPage: function (href, title) {
			var mod = this,
				data = {
					href: href,
					title: title || '',
					external: !mod.isInternalUrl(href),
					'_charset_': 'UTF-8'
				};

			$.post(mod.baseurl + 'favoriteslist.add.json', data, function (json) {
				if (json.success) {
					data.id = json.favoriteItems[0].id;
					// append new item to the initial json list data (e.g. reused if the user switches to edit mode)
					mod.listData.unshift(data);
					// append new item to the list
					if (mod.$ctx.hasClass('edit')) {
						mod.list.prepend(mod.editTemplate([data]));
					} else {
						mod.list.prepend(mod.normalTemplate([data]));
					}

					mod.checkListLength();
				} else {
					mod.$ctx.addClass('error-json');
				}
			})
				.fail(function () {
					mod.$ctx.addClass('error-json');
				});
		},

		editPage: function (id, title) {
			var mod = this;

			$.post(mod.baseurl + 'favoriteslist.update.json', {id: id, title: title, '_charset_': 'UTF-8'}, function (json) {
				if (json.success) {
					// change item within the initial json list data (because it is reused if the user switches to edit mode)
					for (var i = 0; mod.listData[i]; i += 1) {
						//compare value of type string with value of type int
						if (String(mod.listData[i].id) === String(id)) {
							mod.listData[i].title = title;
							break;
						}
					}
					// remove item from the list
					mod.list.find('li[data-id="' + id + '"] .link-title > span > span').text(title);
					// toggle edit-view of the active line/link
					mod.$ctx.find('li.edit').removeClass('edit');
				} else {
					mod.$ctx.addClass('error-json');
				}
			})
				.fail(function () {
					mod.$ctx.addClass('error-json');
				});
		},

		deletePage: function (id) {
			var mod = this;

			$.post(mod.baseurl + 'favoriteslist.delete.json', {id: id}, function (json) {
				if (json.success) {
					// remove item from the initial json list data (because it is reused if the user switches to edit mode)
					for (var i = 0; mod.listData[i]; i += 1) {
						//compare value of type string with value of type int
						if (String(mod.listData[i].id) === String(id)) {
							mod.listData.splice(i, 1);
							break;
						}
					}
					// remove item from the list
					mod.list.find('li[data-id="' + id + '"]').remove();

					// restore even/odd classes
					mod.list.find('li').removeClass('odd').removeClass('even');
					mod.list.find('li:nth-child(odd)').addClass('even');
					mod.list.find('li:nth-child(even)').addClass('odd');

					mod.checkListLength();
				} else {
					mod.$ctx.addClass('error-json');
				}
			})
				.fail(function () {
					mod.$ctx.addClass('error-json');
				});
		},

		checkListLength: function () {
			var mod = this,
				$ctx = mod.$ctx,
				$favlistExternalUrl = $ctx.find('#favlist-external-url'),
				$addUrlButtons = $ctx.find('.add-current-url, .add-url');

			if (mod.listData.length >= 200) {
				$ctx.addClass('error-length-max');
				$favlistExternalUrl.attr('disabled', 'disabled').addClass('disabled');
				$addUrlButtons.addClass('disabled');
				return false;
			} else if ($ctx.hasClass('error-length-max')) {
				$ctx.removeClass('error-length-max');
				$favlistExternalUrl.removeAttr('disabled').removeClass('disabled');
				$addUrlButtons.removeClass('disabled');
			}
			return true;
		}

	});
}(window.Tc, __webpack_provided_window_dot_Tc_dot_$, window, document, window.SCS = window.SCS || {}));

}.call(window));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_Tc_dot_$) {/*** IMPORTS FROM imports-loader ***/
var loadTerrific = __webpack_require__(1);
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function ($, Tc, SCS) {
	'use strict';
	var sdxModal = __webpack_require__(7).default;
	var deparam = __webpack_require__(8).default;
	var replacePlaceholders = __webpack_require__(31).replacePlaceholders;

	var SIMPLE_PAY_URL_KEY = 'simplepay';
	var SIMPLE_PAY_DURATION_URL_INITIAL_VALUE = 24;
	var WARRANTY_URL_INITIAL_VALUE = 'true';

	/**
	 * Initialize Order Overlay from Price & Orderlink
	 *
	 * Subscribes to channels: [EcommerceProductDataHub, serviceavailabilitycheck]
	 * Listens to channel events: [startProductDataSubscription, invalidateProductData, dialogClosed]
	 * Triggers channel events: [subscribeForProductData, getInfo, OpenOverlay, updateStatus]
	 *
	 * @author Marc Althoff, Renaldas Szentiks, Matthias Inauen
	 * @namespace Tc.Module
	 * @class OrderOverlay
	 * @extends Tc.Module
	 */
	Tc.Module.PriceOrderContainer = Tc.Module.extend({

		/**
		 * List of available placeholders in the component
		 */
		PLACEHOLDERS: {
			productId: 'productId',
			minimumPrice: 'minimumPrice',
			originalPrice: 'originalPrice',
			currentPrice: 'currentPrice',
			subscriptionPrice: 'subscriptionPrice',
			subscriptionId: 'subscriptionId',
			subscriptionDuration: 'subscriptionDuration',
			subscriptionType: 'subscriptionType',
			detailPagePath: 'detailPagePath',
			quantity: 'quantity',
			subscriptionName: 'subscriptionName',
			familyName: 'familyName',
			familyId: 'familyId',
			simplePayMonthlyPrice: 'simplePayMonthlyPrice',
			simplePayInitialPrice: 'simplePayInitialPrice',
			simplePayChecked: 'simplePayChecked',
			simplePayDuration: 'simplePayDuration',
			warrantyChecked: 'warranty',
			priceInstead: 'priceInstead',
			xtraDiscount: 'xtraDiscount'
		},

		CHECKOUT_URL_TYPES: {
			automatic: 'automatic',
			configurableProduct: 'configurableProduct',
			accessory: 'accessory',
			eorders: 'eorders',
			manual: 'manual',
			notify: 'notify'
		},

		// How long to wait for tracking call to complete before ordering
		TRACKING_TIMEOUT: 5000,
		/**
		 * Selectors of placeholder aware elements which can contain placeholders
		 */
		PLACEHOLDER_AWARE_ELEMENTS: [
			'.price',
			'.secondary-button',
			'.details-link',
			'.price-subtitle',
			'.footnote',
			'.tracking',
			'.price-instead',
			'.orderButton',
			'.xtraDiscount'
		],

		/**
		 * Attributes of placeholder aware elements, which can contain placeholders
		 */
		PLACEHOLDER_AWARE_ATTRIBUTES: [
			'href',
			'data-tracking-friendlyname',
			'data-tracking-location',
			'data-tracking-action',
			'data-tracking-label',
			'data-tracking-category',
			'data-tracking-conversioncategory',
			'data-tracking-conversiondetail',
			'data-tracking-conversionclass',
			'data-rebate-price',
			'data-xtra-price'
		],

		// The setTimeout handle that waits for tracking to complete (see TRACKING_TIMEOUT)
		trackingTimeout: null,

		on: function (callback) {
			var mod = this,
				placeholder = {};

			mod.actionLink = mod.$ctx.find('.action-link');
			// Remember the link label (if not responding to availabilityStatus)
			mod.actionLink.data('default-label', mod.actionLink.text());
			mod.detailsLink = mod.$ctx.find('.details-link');
			mod.hasOverlay = mod.$ctx.data('order-link') ? true : false;
			mod.useDynamicPrice = mod.$ctx.data('use-dynamic-price');
			mod.subscriptionId = mod.$ctx.data('subscription-id');
			mod.showSubscriptionDuration = mod.$ctx.data('show-subscription-duration');
			mod.msgExtendSubscription = mod.$ctx.data('msg-extend-subscription');

			mod.productId = mod.$ctx.data('product-id');
			mod.familyId = mod.$ctx.data('family-id');

			mod.useAutomaticProductId = this.$ctx.data('checkout-url-type') === this.CHECKOUT_URL_TYPES.automatic || mod.productId === '${productId}';
			mod.useAutomaticFamilyId = this.$ctx.data('checkout-url-type') === this.CHECKOUT_URL_TYPES.automatic || mod.productId === '${familyId}';

			mod.linkParams = mod.$ctx.data('order-link-params');
			mod.isMobilePage = $('body').hasClass('is-mobile');
			mod.hasSimplePay = mod.$ctx.data('simple-pay-active');
			mod.hasWarranty = mod.$ctx.data('warranty-show-checkbox');
			mod.aboDiscountOverrides = mod.$ctx.data('abo-discount-overrides') || {};

			if (mod.hasSimplePay) {
				mod.simplePayCheckbox = mod.$ctx.find('input[name=simplepay]');
				mod.title1 = mod.$ctx.find('.title');
				mod.title2 = mod.$ctx.find('.title2');
				mod.priceSecond = mod.$ctx.find('.price-second');
				mod.simplePayPrices = mod.$ctx.find('.simple-pay-prices');
				mod.priceFirst = mod.$ctx.find('.price-first');
				mod.simplePayInitialPrice = mod.$ctx.find('.simple-pay-initial-price');
				// In simplified simple price mode, the second price is assumed to be configured
				// to display all relevant simple pay information.
				// No custom layout/styling is applied.
				mod.simplifiedSimplePrice = mod.priceSecond.find('span.price').text() === '${simplePayMonthlyPrice}';

				// set simple pay to disabled initially and wait for the ecommerce data hub
				// to enable/disable it based on the data of the product
				mod.handleSimplePay();
			}

			if (mod.hasWarranty) {
				mod.warrantyCheckbox = mod.$ctx.find('input[name=warranty]');
				mod.warrantyCheckbox.on('change', mod.handleWarranty.bind(mod));
				mod.warrantyCheckbox.trigger('change');
			}

			if ((typeof (mod.$ctx.data('checkout-url-type')) === 'undefined' || !mod.$ctx.data('checkout-url-type').length)) {
				mod.$ctx.data('checkout-url-type', mod.CHECKOUT_URL_TYPES.automatic);
			}

			mod.CHECKOUT_URL_TYPE = mod.$ctx.data('checkout-url-type');
			mod.BUY_BUTTON_LABEL = mod.actionLink.text();

			mod.actionLink.on('click', $.proxy(mod.handleActionLinkClick, mod));
			mod.$ctx.on('ctaClick', function () {
				if (!mod.actionLinkDisabled) {
					if (mod.actionLink.length) {
						mod.ctaClickTriggered = true;
						mod.actionLink.trigger('click');
					} else if (mod.detailsLink.length) {
						mod.detailsLink[0].click();
					}
				}
			});
			mod.$ctx.on('detailsClick', function () {
				if (mod.detailsLink.length) {
					mod.detailsLink[0].click();
				}
			});
			if (mod.showSubscriptionDuration) {
				mod.initDurations();
			}
			mod.prepareVariantOrderLinks();
			mod.updateCTAUrl(mod.getCheckoutUrlType());
			placeholder[mod.PLACEHOLDERS.productId] = mod.productId;
			placeholder[mod.PLACEHOLDERS.familyId] = mod.familyId;
			mod.updatePlaceholders(placeholder);

			if (mod.useDynamicPrice) {
				mod.updatePlaceholders({}, true);
				mod.onStartProductDataSubscription();
			}

			mod.$ctx.closest('.modVisibilityControlContainer').on('visibilityControl-show', function (event) {
				// jshint unused: false
				mod.onShow();
			});

			mod.$ctx.closest('.modVisibilityControlContainer').on('visibilityControl-hide', function (event) {
				// jshint unused: false
				mod.onHide();
			});

			if (!$.cookie('SCSMiniShoppingCart')) {
				$.cookie('SCSMiniShoppingCart', '', { path: '/' });
			}

			callback();
		},

		after: function () {
			var mod = this;

			if (SCS.utils.isMobilePage()) {
				mod.fire('AdjustGalleryHeight', {});
			}

			if (mod.useDynamicPrice) {
				mod.onInvalidateProductData({});
			}
		},

		/**
		 * Channel listener to register for EcommerceProductDataHub events.
		 *
		 * @method onStartProductDataSubscription
		 * @return void
		 */
		onStartProductDataSubscription: function () {
			var mod = this,
				initialChannel = 'EcommerceProductDataHub';
			mod.sandbox.subscribe(initialChannel, mod);
			mod.fire('subscribeForProductData', {
				element: mod.$ctx,
				subscribe: function (channel, fetchDataOnSubscribe) {
					if (mod.productDataChannel) {
						mod.sandbox.unsubscribe(mod.productDataChannel, mod);
					}
					mod.productDataChannel = channel;
					mod.sandbox.unsubscribe(initialChannel, mod);
					mod.sandbox.subscribe(channel, mod);
					mod.$ctx.removeClass('initializing');

					// If component was lazy loaded, request initialization data
					// from data hub.
					if (fetchDataOnSubscribe) {
						mod.fire('getInfo', {
							callback: function (data) {
								mod.onInvalidateProductData({ info: data });
							}
						}, [mod.productDataChannel]);
					}
				}
			}, [initialChannel]);
		},

		/**
		 * Channel listener which gets called by EcommerceProductDataHub to notify about data changes.
		 *
		 * @method onInvalidateProductData
		 * @param {Object} data See EcommerceProductDataHub for details about the structure
		 * @return void
		 */
		onInvalidateProductData: function (data) {
			// jshint unused: false
			var mod = this, status = {};
			if (mod.productDataChannel) {
				if (mod.subscriptionId) {
					status.subscriptionId = mod.subscriptionId;
				}
				// request the new data based on the settings in this component
				mod.fire('getInfo', {
					status: status,
					callback: $.proxy(mod.getInfoCallback, mod)
				}, [mod.productDataChannel]);
			}
		},

		/**
		 * Callback function which gets passed as a parameter to the [GetInfo] channel event.
		 *
		 * Creates all required placeholders and initiates the placeholder replacement in the component.
		 *
		 * @method getInfoCallback
		 * @param {Object} data See EcommerceProductDataHub for details about the structure
		 * @return void
		 */
		getInfoCallback: function (data) {
			var mod = this,
				placeholders = {},
				zeroDotEmDash = '0.—',
				emDash = '—',
				isSimplePayAllowed = false,
				simplePayMonthlyPrice;

			mod.actionLink.data('placeholder-template', mod.BUY_BUTTON_LABEL);

			// Set product family related placeholders
			if (data.family) {
				mod.updateFamilyId(data.family.getId());
				placeholders[mod.PLACEHOLDERS.detailPagePath] = data.family.getDetailPagePath();
				placeholders[mod.PLACEHOLDERS.familyName] = data.family.getFamilyName();
				placeholders[mod.PLACEHOLDERS.familyId] = (mod.CHECKOUT_URL_TYPE !== mod.CHECKOUT_URL_TYPES.automatic) ? mod.familyId : data.family.getId();
				// Turn simple pay on or off for the whole family
				if (mod.hasSimplePay) {
					if (data.family.isSimplePayAllowed() === true) {
						isSimplePayAllowed = true;
						mod.simplePayCheckbox.closest('.field').removeClass('hidden');
					}
					else {
						// un-check the checkbox before hiding
						mod.simplePayCheckbox.prop('checked', false).trigger('change').closest('.field').addClass('hidden');
					}
				}
			}
			// Set product variant related placeholders
			var makePrice = __webpack_require__(13).default;
			if (data.product) {
				var id = data.product.getId();
				mod.updateProductId(id);
				mod.checkPromotions(data);
				placeholders[mod.PLACEHOLDERS.productId] = (mod.CHECKOUT_URL_TYPE !== mod.CHECKOUT_URL_TYPES.automatic) ? mod.productId : data.product.getId();
				placeholders[mod.PLACEHOLDERS.minimumPrice] = data.product.getMinimumPrice().formatted();
				placeholders[mod.PLACEHOLDERS.originalPrice] = data.product.getOriginalPrice().formatted();

				if (data.subscriptionType === 'without' && !data.subscriptionId) {
					placeholders[mod.PLACEHOLDERS.currentPrice] = data.product.getDiscountedPrice().formatted(); // device only, sale price
					if (data.product.isDiscounted()) {
						placeholders[mod.PLACEHOLDERS.priceInstead] = data.product.getOriginalPrice().formatted();
					} else {
						placeholders[mod.PLACEHOLDERS.priceInstead] = '';
					}
					placeholders[mod.PLACEHOLDERS.subscriptionPrice] = zeroDotEmDash;
				}
				else {
					var subscriptions = data.product.getSubscriptions();
					placeholders[mod.PLACEHOLDERS.currentPrice] = data.product.getPrice(data.subscriptionId, data.subscriptionDuration).formatted();
					var recurringCharge = subscriptions.getRecurringCharge(data.subscriptionId, data.subscriptionDuration) || makePrice();
					placeholders[mod.PLACEHOLDERS.subscriptionPrice] = recurringCharge.formatted();

					if (data.subscriptionId in mod.aboDiscountOverrides) {
						var discount = mod.aboDiscountOverrides[data.subscriptionId];
						var charge = subscriptions.getRecurringCharge(data.subscriptionId, data.subscriptionDuration) - discount;
						placeholders[mod.PLACEHOLDERS.subscriptionPrice] = makePrice(charge).formatted();
						placeholders[mod.PLACEHOLDERS.xtraDiscount] = makePrice(discount).formatted();
					}
					else {
						placeholders[mod.PLACEHOLDERS.xtraDiscount] = '';
					}

					var subscriptionPricing = data.product.getSubscriptionPrice(data.subscriptionId, data.subscriptionDuration);
					if (!subscriptionPricing && data.product.isDiscounted()) {
						// placeholders[mod.PLACEHOLDERS.currentPrice] will already contain the discounted price since that’s what
						// getPrice() does if no subscription matches (and this holds because getSubscriptionPrice returned null)
						placeholders[mod.PLACEHOLDERS.priceInstead] = data.product.getOriginalPrice().formatted();
					}
					else {
						placeholders[mod.PLACEHOLDERS.priceInstead] = '';
					}
				}

				placeholders[mod.PLACEHOLDERS.subscriptionName] = data.product.getSubscriptions().getName(data.subscriptionId);

				var availability = data.product.getAvailability();
				availability.load().always(function () {
					if (id !== mod.currentProductId) {
						// User has changed the product since the availability info started loading
						return;
					}

					// FIXME NEC: Refactor: getCheckoutUrlType relies on availability to be loaded but does not declare so
					mod.updateCTAUrl(mod.getCheckoutUrlType(data.product), data);

					if (!mod.actionLink.attr('href')) {
						// No link ⇒ no need for availability info to load…
						mod.updateActionLinkStatus(false);
					} else {
						mod.updateActionLinkStatus(availability.isActionable(), availability.getStatus());
					}

					mod.updatePlaceholders(placeholders);
				});

				if (isSimplePayAllowed) {
					simplePayMonthlyPrice = data.product.getSimplePayMonthlyPrice(data.subscriptionId, data.subscriptionDuration);
					placeholders[mod.PLACEHOLDERS.simplePayMonthlyPrice] = simplePayMonthlyPrice;
					placeholders[mod.PLACEHOLDERS.simplePayInitialPrice] = data.product.getSimplePayInitialPrice(data.subscriptionId, data.subscriptionDuration);

					if (parseFloat(simplePayMonthlyPrice) > 0) {
						mod.enableSimplePay();
					}
					else {
						mod.disableSimplePay();
					}

					// if the simplepay option was checked before, add it back to the call to action url.
					if (!this.simplePayCheckbox.prop('readonly') && this.simplePayChecked) {
						this.addUrlParam(SIMPLE_PAY_URL_KEY, true);
					}
				}

				if (mod.hasWarranty && !data.product.hasGuaranteeExtension()) {
					mod.warrantyCheckbox.closest('.field').addClass('hidden');
				} else if (mod.hasWarranty) {
					mod.warrantyCheckbox.prop('checked', WARRANTY_URL_INITIAL_VALUE).trigger('change');
					mod.updateWarrantyLabel(mod.warrantyCheckbox, data.product);
					mod.warrantyCheckbox.closest('.field').removeClass('hidden');
				}
			}
			else {
				mod.updateActionLinkStatus(false);
				mod.updateProductId('');
				placeholders[mod.PLACEHOLDERS.minimumPrice] = emDash;
				placeholders[mod.PLACEHOLDERS.originalPrice] = emDash;
				placeholders[mod.PLACEHOLDERS.currentPrice] = emDash;
				placeholders[mod.PLACEHOLDERS.subscriptionPrice] = emDash;
				// disable simple pay - there's no product
				if (isSimplePayAllowed) {
					mod.disableSimplePay();
				}
			}

			if (data.subscriptionId === 'retention') {
				placeholders[mod.PLACEHOLDERS.subscriptionPrice] = emDash;
			}
			else if (data.subscriptionId === 'without') {
				placeholders[mod.PLACEHOLDERS.subscriptionPrice] = emDash;
			}
			else {
				placeholders[mod.PLACEHOLDERS.subscriptionId] = data.subscriptionId;
				placeholders[mod.PLACEHOLDERS.subscriptionDuration] = data.subscriptionDuration;
			}

			if (data.subscriptionType === 'retention') {
				mod.showMessage(mod.msgExtendSubscription);
			}
			else {
				mod.showMessage(null);
			}

			placeholders[mod.PLACEHOLDERS.subscriptionType] = data.subscriptionType;
			placeholders[mod.PLACEHOLDERS.quantity] = data.quantity;
			mod.quantity = (typeof (data.quantity) === 'undefined') ? 1 : data.quantity;

			if (mod.showSubscriptionDuration) {
				mod.setDuration(data.subscriptionDuration);
			}
			mod.updatePlaceholders(placeholders);
		},

		enableSimplePay: function () {
			this.simplePayCheckbox.prop('readonly', false).closest('.custom-checkbox').attr('readonly', false);
			this.simplePayCheckbox.on('change.PriceOrderContainer', this.handleSimplePay.bind(this));
		},

		disableSimplePay: function () {
			this.simplePayCheckbox.prop('checked', false).prop('readonly', true).closest('.custom-checkbox').attr('readonly', true);
			this.handleSimplePay();
			this.simplePayCheckbox.off('change.PriceOrderContainer');
		},

		showMessage: function (text) {
			var mod = this;
			if (!mod.priceContainer) {
				mod.priceContainer = $('.pricetag .price-first, .pricetag .price-second', mod.$ctx);
			}
			if (!mod.simplePayChecked) {
				if (!mod.messageContainer) {
					mod.messageContainer = $('<div>').addClass('message-container').addClass('hidden');
					mod.messageContainer = $('<div>').addClass('message-container').addClass('hidden');
					mod.messageContainer.html('&nbsp;').prepend($('<div>').addClass('text'));
					$('.pricetag', mod.$ctx).prepend(mod.messageContainer);
				}
				if (text) {
					mod.messageContainer.removeClass('hidden').find('.text').text(text);
					mod.priceContainer.addClass('hidden');
				} else {
					mod.priceContainer.removeClass('hidden');
					mod.messageContainer.addClass('hidden').find('.text').text('');
				}
			}
		},

		/**
		 * Check if promotions are available and display text.
		 *
		 * @method checkPromotions
		 * @param {object} data returned from ecommerce product data hub
		 * @return void
		 */
		checkPromotions: function (data) {
			var mod = this,
				$promotionWrapper = mod.$ctx.find('.product-promotion');

			// Do a little bit of magic to check whether there is already a ProductDetail component configured to display promotions
			var $container = this.$ctx.closest('.modEcommerceProductDataHub, .modTabNavigationSharedContent, .modLayoutcontainer.actionboxProducts');
			var $productDetailPromoDisplay = $container.find('.modEcommerceProductDetail[data-type="promotionName"]');

			if (!data.subscriptionId || $promotionWrapper.hasClass('hidden') || $productDetailPromoDisplay.length) {
				$promotionWrapper.hide();
				return;
			}

			var promotions = data.product.getApplicablePromotions(
				data.subscriptionId,
				data.subscriptionDuration,
				data.subscriptionType
			).filter(function (promotion) {
				return !promotion.isCallout();
			}).map(function (promotion) {
				// Create an element for each promo
				return $('<div/>', { text: promotion.getName() });
			});

			if (!promotions.length) {
				$promotionWrapper.hide();
				return;
			}

			$promotionWrapper.html(promotions).show();
		},

		/**
		 * Updates the status of the action link.
		 *
		 * @method updateActionLinkStatus
		 * @param {Boolean} isEnabled Status of the action link
		 * @return void
		 */
		updateActionLinkStatus: function (isEnabled, productAvailability) {
			var mod = this;

			if (isEnabled || mod.variantOrderLink) {
				mod.actionLinkDisabled = false;
				mod.actionLink.removeClass('disabled');
			} else {
				mod.actionLinkDisabled = true;
				mod.actionLink.addClass('disabled');
			}

			var label = mod.actionLink.data('default-label');
			if (productAvailability) {
				label = mod.$ctx.data(productAvailability.toLowerCase());
				//Replace the value inside the place-holder template as well. Otherwise it gets reverted after changing.
				mod.actionLink.data('placeholder-template', label);
				mod.actionLink.text(label);
			}
		},

		/**
		 * Updates the call to action url based on the product type.
		 *
		 * @param checkoutUrlType
		 * @param data
		 */
		updateCTAUrl: function (checkoutUrlType, data) {
			var url = '';

			if (this.productId && this.productId in this.variantOrderLinks) {
				// Use variant order link and ignore type
				url = this.variantOrderLinks[this.productId];
				this.variantOrderLink = true;
			} else {
				// Use default behaviour
				switch (checkoutUrlType) {
					case this.CHECKOUT_URL_TYPES.accessory:
						url = this.$ctx.data('url-addtobasket');
						break;
					case this.CHECKOUT_URL_TYPES.configurableProduct:
						if (data.product.isAddProductAndShowBasket(data.subscriptionType)) {
							url = this.getAddProductAndShowBasketUrl();
						} else {
							url = this.$ctx.data('url-productconfig');
						}
						break;
					case this.CHECKOUT_URL_TYPES.eorders:
						url = this.$ctx.data('url-maporder');
						break;
					case this.CHECKOUT_URL_TYPES.manual:
						url = this.$ctx.data('url-manual');
						break;
					case this.CHECKOUT_URL_TYPES.notify:
						if (data && data.product && data.product.getNotifyUrl()) {
							url = data.product.getNotifyUrl();
						}
						break;
					default:
						url = this.$ctx.data('url-maporder');
				}

				url = this.appendUrlParameters(url, data);
			}
			this.actionLink.data('placeholder-template-href', url);
			this.actionLink.attr('href', url);
		},

		/**
		 * Returns the checkout URL of a product where the eCommerce Configuration page can be skipped.
		 */
		getAddProductAndShowBasketUrl: function () {
			if (this.isMobilePage) {
				return '/portalshop/' + $('html').attr('lang') + '/' + $('body').data('page-segment') +
					'/Basket/AddWatch?deviceId=${productId}&simplePay=${simplePayChecked}&duration=${simplePayDuration}&warranty=${warrantyChecked}';
			} else {
				return '/content/swisscom/' + $('html').attr('lang') + '/' + $('body').data('page-segment') +
					'/addproduct#deviceId=${productId}&simplepay=${simplePayChecked}&duration=${simplePayDuration}&warranty=${warrantyChecked}';
			}
		},

		/**
		 * Appending parameters to the checkout url
		 *
		 * @param url
		 * @param data
		 * @returns url string
		 */
		appendUrlParameters: function (url, data) {
			var urlBase,
				urlParams,
				urlHash,
				tmpUrl,
				returnUrl = url;

			if (!url) {
				return returnUrl;
			}

			urlHash = url.split('#')[1];
			urlParams = url.split('#')[0].split('?')[1];
			urlBase = url.split('#')[0].split('?')[0];


			if (this.CHECKOUT_URL_TYPE === this.CHECKOUT_URL_TYPES.manual && this.linkParams) {
				if (this.linkParams.indexOf('?') > -1) {
					urlParams = (urlParams && urlParams.length) ? (urlParams + '&' + this.linkParams.substring(1)) : this.linkParams.substring(1);
				}
				else if (this.linkParams.indexOf('#') > -1) {
					urlHash = (urlHash && urlHash.length) ? (urlHash + '&' + this.linkParams.substring(1)) : this.linkParams.substring(1);
				}
				else {
					urlParams = (urlParams && urlParams.length) ? (urlParams + '&' + this.linkParams) : this.linkParams;
				}
			}

			if (this.ctaType === this.CHECKOUT_URL_TYPES.configurableProduct && data && data.product && data.product.canHaveSubscriptions()) {
				if (data.subscriptionId) {
					tmpUrl = 'aboId=' + encodeURIComponent(data.subscriptionId);
					if (data.subscriptionDuration) {
						tmpUrl = tmpUrl + '&duration=' + encodeURIComponent(data.subscriptionDuration);
					}
				}

				if (data.subscriptionType) {
					tmpUrl = (tmpUrl) ? (tmpUrl + '&subscriptioncasetype=' + encodeURIComponent(data.subscriptionType)) : 'subscriptioncasetype=' + encodeURIComponent(data.subscriptionType);
				}

				if (this.isMobilePage) {
					urlParams = (urlParams && urlParams.length) ? (urlParams + '&' + tmpUrl) : tmpUrl;
				} else {
					urlHash = (urlHash && urlHash.length) ? (urlHash + '&' + tmpUrl) : tmpUrl;
				}
			}

			returnUrl = urlBase;

			if (urlParams && urlParams.length) {
				returnUrl = returnUrl + '?' + urlParams;
			}
			if (urlHash && urlHash.length) {
				returnUrl = returnUrl + '#' + urlHash;
			}

			return returnUrl;
		},

		/**
		 * Adding the URL parameters to the actionlink url
		 * Manipulates the actionlink href attribute directly
		 * TODO: Why? Can’t this be done with a placeholder inside the URL?
		 */

		addUrlParam: function (paramName, paramValue) {
			var urlBase,
				urlBaseHash,
				returnUrl,
				newUrlString,
				urlParameters,
				url = this.actionLink.attr('href');

			if (url) {
				urlBaseHash = url.split('#')[0];
				urlBase = url.split('?')[0];

				urlParameters = this.mapQueryStringParameters(url);

				if (urlParameters[paramName]) {
					return;
				}

				urlParameters[paramName] = paramValue;
				newUrlString = $.param(urlParameters);

				returnUrl = this.isMobilePage ? urlBase + '?' + newUrlString : urlBaseHash + '#' + newUrlString;

				if (newUrlString !== undefined) {
					// FIXME: Test on non-watch device with simple pay.
					// Should the simple pay URL param be configured or do we need to fix it in code?

					// this.actionLink.data('placeholder-template-href', returnUrl);
					this.actionLink.attr('href', returnUrl);
				}
			}
		},

		/**
		 * Return URL query string object with parameters based on device
		 * @method mapQueryStringParameters
		 * @param {String} url
		 * @return {Object} parameters
		 */
		mapQueryStringParameters: function (url) {
			var urlParameters = {};

			if (this.isMobilePage) {
				var queryString = SCS.Url.parse(url).search.slice(1);

				if (queryString) {
					urlParameters = deparam(queryString);
				}
			} else {
				var fragmentString = SCS.Url.parse(url).hash.slice(1);

				if (fragmentString) {
					urlParameters = deparam(fragmentString);
				}
			}

			return urlParameters;
		},

		/**
		 * modifies the action link url directly and remove URL parameters
		 */

		removeUrlParam: function (paramName) {
			var urlBase,
				urlBaseHash,
				urlParameters = {},
				newUrlString,
				url = this.actionLink.attr('href');

			if (!url) {
				return;
			}

			urlBaseHash = url.split('#')[0];
			urlBase = url.split('?')[0];
			urlParameters = this.mapQueryStringParameters(url);

			if (urlParameters[paramName]) {
				delete urlParameters[paramName];
				newUrlString = $.param(urlParameters);
			}
		},

		/**
		 * Handler for the action link click event
		 * There are multiple cases to consider
		 * 1. The component specifies an overlay (e.g. Service Availability Overlay) -> open the overlay
		 * 2. Notify mode is enabled -> open the notification overlay
		 * 3. The product is an accessory and it's not a mobile page -> open the add accessory to basket overlay
		 * 4. In all other cases simply follow the href of the anchor.
		 *
		 * @method handleActionLinkClick
		 * @param {Object} event
		 * @return void
		 */
		handleActionLinkClick: function (event) {
			var mod = this,
				$button = $(event.currentTarget);

			$.cookie('SCSResumeShoppingLink', window.location.href, { 'path': '/' });

			if (!mod.overlayIsOpen && !mod.actionLinkDisabled) {

				mod.trackButtonClick();

				if (mod.hasOverlay) {
					mod.overlayIsOpen = true;
					if (!mod.$ctx.is('.cq_isEditMode *')) {
						mod.log('OpenOverlay',
							mod.$ctx.data('order-link'),
							mod.$ctx.data('order-link-no-login'),
							mod.$ctx.data('button-id'),
							mod.$ctx.data('product-id'),
							mod.$ctx.data('product-name')
						);
						mod.fire('OpenOverlay', {
							'orderLink': mod.$ctx.data('order-link'),
							'orderLinkNoLogin': mod.$ctx.data('order-link-no-login'),
							'orderButtonsId': mod.$ctx.data('button-id'),
							'productId': mod.$ctx.data('product-id'),
							'productName': mod.$ctx.data('product-name')
						});
					}
				}
				else if (mod.ctaType === mod.CHECKOUT_URL_TYPES.notify) {
					if (!SCS.utils.isMobilePage()) {
						var form = $('<form class="sdx-container"/>');
						form.data('title', mod.actionLink.text());
						mod.$ctx.append(form);
						form.load(mod.actionLink.attr('href'), function (response, status /* ,xhr */) {
							if (status !== 'error') {
								mod.initNotifyForm(form);
							}
						});
					} else {
						mod.sandbox.subscribe('initNotifyForm', mod);
						mod.fire('initMobileNotify', {
							formUrl: mod.actionLink.attr('href'),
							title: mod.actionLink.text()
						}, ['initNotifyForm']);
					}
				}
				else if (mod.ctaType === mod.CHECKOUT_URL_TYPES.accessory) {
					mod.quantity = (typeof (mod.quantity) === 'undefined') ? 1 : mod.quantity;

					if (mod.isMobilePage) {
						$.ajax({
							url: this.actionLink.attr('href'),
							type: 'post',
							data: {
								'quantity': mod.quantity
							},
							success: function (data) {
								if (data.Error && data.Error.Code && (data.Error.Code === 'INTERNAL_ERROR')) {
									sdxModal.show({
										title: data.Error.Messages[0],
										text: data.Error.Messages[1] || '',
										displayMode: 'prompt',
										buttons: [{
											title: mod.$ctx.data('close-button-msg'),
											type: 'close',
											primary: false
										}]
									});
								} else {
									location.href = mod.$ctx.data('url-basket');
								}
							}
						});
					}
					else {
						SCS.ecommerceApi.addProductToBasket( // swisscom.ecommerceApi.js
							mod.productId,
							mod.quantity,
							$('html').attr('lang'),
							$('body').attr('data-page-segment'),
							function (data) {
								if (data && SCS.ecommerceApi && SCS.ecommerceApi.showOverlayAfterProductAddedToBasket) {
									SCS.ecommerceApi.showOverlayAfterProductAddedToBasket(data.resultView, data.message, data.status);
								}
								window.scsHeader.metanav.updateShoppingCartItemsIcon();
							},
							function (jqXHR) {
								mod.log(jqXHR);
								$button.qtip({
									content: '<div class="sc-richtext-failure">' +
										(jqXHR.responseText || mod.$ctx.data('orderButtonError')) +
										'</div>',
									style: {
										classes: 'ui-tooltip-ecommerce',
										width: 240
									},
									show: {
										event: 'click',
										effect: function () {
											$(this).fadeIn(1000);
										}
									},
									hide: {
										event: false,
										inactive: 3500,
										effect: function () {
											$(this).fadeOut(1000);
										}
									},
									events: {
										hidden: function (event, api) {
											api.destroy();
										}
									}
								});
								window.scsHeader.metanav.updateShoppingCartItemsIcon();
								$button.qtip('show');
							}
						);
					}
				}
				else {
					if (mod.ctaClickTriggered) {
						event.currentTarget.click();
						mod.ctaClickTriggered = false;
					}
				}
			}
			if (this.hasOverlay || mod.actionLinkDisabled || mod.ctaType === mod.CHECKOUT_URL_TYPES.accessory || mod.ctaType === mod.CHECKOUT_URL_TYPES.notify) {
				event.preventDefault();
			}
		},

		initNotifyForm: function ($form) {
			var mod = this,
				$formContent = $form.find('#notificationForm');

			$form.dialog({
				title: $form.data('title'),
				width: 820,
				classes: { 'ui-dialog': 'scs-notification-dialog' },
				buttons: [{
					text: $formContent.data('button1-text'),
					'class': 'secondary-button',
					click: function () {
						$form.dialog('close');
					}
				}, {
					text: $formContent.data('button2-text'),
					'class': 'primary-button',
					'data-track-action': 'button',
					'data-track-label': 'notify',
					'data-track-location': 'content',
					'data-track-category': $formContent.data('track-family-name'),
					click: function () {
						if (!SCS.portal.validateSimpleForm($form)) {

							$.ajax({
								url: $formContent.data('url'),
								type: 'POST',
								data: $form.serialize(),
								success: function (data) {
									if (data && data.Error && data.Error.Code === 'OK') {
										var title = $form.data('title'),
											$successContent = $form.find('#notificationSuccess').clone().show();

										// Send form data for Adserver
										mod.overlaySuccessTracking($form.serializeArray());

										$form.dialog('close');
										$successContent.dialog({
											title: title,
											buttons: [{
												text: $successContent.data('button1-text'),
												'class': 'primary-button',
												click: function () {
													$successContent.dialog('close');
												}
											}]
										});
									} else {
										$form.dialog('close');
										SCS.portal.showError(data.Error && data.Error.Messages);
									}
								},
								error: function (jqXHR, textStatus, errorThrown) {
									SCS.portal.showError(errorThrown);
								}
							});

						}
					}
				}],
				close: function () {
					$form.detach();
				}
			});
		},

		overlaySuccessTracking: function (formData) {
			var mod = this;

			// Check form data
			if (Object.prototype.toString.call(formData) !== '[object Array]') {
				return false;
			}

			// Vars
			var language = $('html').attr('lang'),
				segment = $('body').data('page-segment'),
				jsonFormData = {},
				marketingCheckbox = false;

			// Create form data in JSON format
			$.each(formData, function () {

				// Ready data for Adserver
				switch (this.name) {
					case 'productId':
						jsonFormData.ProductId = this.value || '';
						break;
					case 'salutation':
						jsonFormData.Salutation = this.value || '';
						break;
					case 'firstName':
						jsonFormData.Firstname = this.value || '';
						break;
					case 'lastName':
						jsonFormData.Lastname = this.value || '';
						break;
					case 'email':
						jsonFormData.Email = this.value || '';
						break;
					case 'confirmMarketing':
						marketingCheckbox = this.value;
						break;
				}
			});

			// Special case for AllowMarketing field
			jsonFormData.AllowMarketing = marketingCheckbox;

			// Send data to ecommerce for parsing
			if (SCS.ecommerceApi) {
				SCS.ecommerceApi.addProductNotification(
					jsonFormData,
					language,
					segment,
					function (data) {
						mod.log('overlaySuccessTracking', data);
					},
					function (jqXHR) {
						mod.log('overlaySuccessTracking', jqXHR);
					}
				);
			}
		},

		/**
		 * Warranty Checkbox Event handler.
		 */
		handleWarranty: function () {
			var mod = this;

			mod.warrantyChecked = mod.warrantyCheckbox.prop('checked');

			mod.updatePlaceholders({
				warrantyChecked: mod.warrantyChecked
			});
		},

		/**
		 * Warranty Checkbox label updater.
		 */
		updateWarrantyLabel: function (element, product) {
			var $label = $(element).siblings('label'),
				$warrantyLabel = $label.find('.warrantyLabel'),
				$warrantyPrice = $label.find('.warrantyPrice');

			if ($warrantyLabel && $warrantyPrice) {
				var labelText = $warrantyLabel.text().replace(/[\{\}0-9]+/, product.getWarrantyPeriod());
				$warrantyLabel.text(labelText);
				$warrantyPrice.text('(' + product.getWarrantyPriceFormatted() + ')');
			}
		},

		/**
		 * Simple Pay Checkbox Event handler.
		 */
		handleSimplePay: function () {
			var mod = this;

			mod.simplePayChecked = mod.simplePayCheckbox.prop('checked');

			if (mod.simplifiedSimplePrice) {
				mod.toggleSimplifiedSimplePrice(mod.simplePayChecked);
			} else {
				mod.toggleSimplePrice(mod.simplePayChecked);
			}

			mod.updatePlaceholders({
				simplePayChecked: mod.simplePayChecked,
				simplePayDuration: (mod.simplePayChecked && SIMPLE_PAY_DURATION_URL_INITIAL_VALUE) || ''
			});

			if (mod.simplePayChecked) {
				mod.addUrlParam(SIMPLE_PAY_URL_KEY, true);
			} else {
				mod.removeUrlParam(SIMPLE_PAY_URL_KEY);
			}
		},

		toggleSimplifiedSimplePrice: function (show) {
			var mod = this;

			mod.title1.toggleClass('is-invisible', show);
			mod.title2.toggleClass('is-invisible', !show);

			mod.priceFirst.toggleClass('is-invisible', show);
			mod.priceSecond.toggleClass('is-invisible', !show);
		},

		toggleSimplePrice: function (show) {
			var mod = this;
			var titleKey = (show ? 'simplepay' : '') + 'title';
			if (mod.title1) {
				mod.title1.text(mod.title1.data(titleKey + '1'));
			}
			if (mod.title2) {
				mod.title2.text(mod.title2.data(titleKey + '2'));
			}
			mod.priceSecond.toggleClass('hidden', show);
			mod.priceFirst.toggleClass('hidden', show);
			mod.simplePayPrices.toggleClass('hidden', !show);
			mod.simplePayInitialPrice.toggleClass('hidden', !show);
		},

		/**
		 * Perform the Tealium tracking when the component became visible
		 */
		trackOnShow: function () {
			var mod = this,
				$tracking = mod.$ctx.find('.tracking');

			if (mod.trackingEnabled($tracking)) {
				mod.log('trackOnShow');
				SCS.portal.datalayer.trackEvent(
					$tracking.data('tracking-action'),
					$tracking.data('tracking-label'),
					$tracking.data('tracking-location'),
					$tracking.data('tracking-category'),
					$tracking.data('tracking-friendlyname')
				);

				SCS.portal.datalayer.trackConversion(
					$tracking.data('tracking-conversioncategory'),
					$tracking.data('tracking-conversiondetail'),
					$tracking.data('tracking-conversionclass')
				);
			}
		},

		/**
		 * Perform the Tealium tracking when the component became visible
		 */
		trackButtonClick: function () {
			var mod = this,
				$tracking = mod.$ctx.find('.tracking');

			if (mod.trackingEnabled($tracking)) {
				mod.log('trackButtonClick');
				// action, label, location, category, linkName, conversionCategory, conversionDetail, conversionClass
				SCS.portal.datalayer.trackEvent(
					$tracking.data('tracking-action') || 'button',
					$tracking.data('tracking-label') || 'order',
					$tracking.data('tracking-location'),
					$tracking.data('tracking-category'),
					$tracking.data('tracking-friendlyname')
				);

				SCS.portal.datalayer.trackConversion(
					$tracking.data('tracking-conversioncategory'),
					$tracking.data('tracking-conversiondetail'),
					$tracking.data('tracking-conversionclass')
				);
			}
		},

		trackingEnabled: function (tracking) {
			return $(tracking).data('tracking-enabled');
		},

		onDialogClosed: function () {
			var mod = this;
			mod.overlayIsOpen = false;
		},

		updateProductId: function (productId) {
			this.currentProductId = productId;
			if (productId) {
				this.$ctx.data('product-id', productId);
				this.$ctx.attr('data-product-id', productId);
				if (this.useAutomaticProductId) {
					this.productId = productId;
				}
			}
		},

		updateFamilyId: function (familyId) {
			if (familyId) {
				this.$ctx.data('family-id', familyId);
				this.$ctx.attr('data-family-id', familyId);
				if (this.useAutomaticFamilyId) {
					this.familyId = familyId;
				}
			}
		},

		/**
		 * Updates the placeholders in the component.
		 *
		 * @method updatePlaceholders
		 * @param {Map/Object} placeholders A map of key value pairs
		 * @return void
		 */
		updatePlaceholders: function (placeholders, replaceAll) {
			var mod = this;

			// Merge with previous placeholders
			if (!replaceAll) {
				placeholders = $.extend({}, mod.previousPlaceholders || {}, placeholders);
				mod.previousPlaceholders = placeholders;
			}

			var element, elementText, attrValue,
				elements = $(mod.PLACEHOLDER_AWARE_ELEMENTS.join(', '), mod.$ctx),
				attributes = mod.PLACEHOLDER_AWARE_ATTRIBUTES;

			elements.each(function () {
				element = $(this);

				// replace in text nodes
				elementText = element.data('placeholder-template');
				if (!elementText) {
					elementText = element.text();
					element.data('placeholder-template', elementText);
				}
				element.text(replacePlaceholders(elementText, placeholders));

				// replace in attributes
				for (var j = 0; j < attributes.length; j += 1) {
					attrValue = element.data('placeholder-template-' + attributes[j]);
					if (!attrValue) {
						attrValue = element.attr(attributes[j]);
						element.data('placeholder-template-' + attributes[j], attrValue);
					}
					if (attrValue) {
						attrValue = replacePlaceholders(attrValue, placeholders);
						element.attr(attributes[j], attrValue);
						if (attributes[j].indexOf('data-') === 0) {
							element.data(attributes[j].substring(5), attrValue);
						}
					}
				}
			});
		},

		/**
		 * Initializes duration radio buttons inside the component.
		 *
		 * Normally radio buttons rely on ScForm module JS, which is not used here,
		 * therefore the handling is re-implemented and adjusted to the specific
		 * needs of this component.
		 *
		 * @method initDurations
		 * @return void
		 */
		initDurations: function () {
			var mod = this,
				radioInputs = $('.custom-radio input:radio', mod.$ctx);
			radioInputs.on('change', function () {
				$(this).parent().find('input:radio').each(function () {
					var label = $(this).parent().find('[for="' + this.id + '"]');
					if (this.checked) {
						label.addClass('checked');
					} else {
						label.removeClass('checked');
					}
				});
			});
			$('.custom-radio label', mod.$ctx).on('click', function () {
				var label = $(this),
					radioInput = label.parent().find('[id="' + label.attr('for') + '"]');
				radioInput.prop('checked', true);
				radioInputs.trigger('change');
				if (mod.productDataChannel) {
					mod.fire('updateStatus', {
						status: {
							subscriptionDuration: radioInput.val() - 0
						},
						origin: SCS.utils.getUniqueIdOfElement(mod.$ctx)
					}, [mod.productDataChannel]);
				}
			});
		},

		getCheckoutUrlType: function (product) {
			var checkoutUrlType = '';

			if (product && product.showNotificationButton()) {
				checkoutUrlType = this.CHECKOUT_URL_TYPES.notify;
			}
			else if (this.CHECKOUT_URL_TYPE !== this.CHECKOUT_URL_TYPES.automatic) {
				checkoutUrlType = this.CHECKOUT_URL_TYPE;
			}
			else if (!!product) {
				if (product.isConfigurationNeeded()) {
					checkoutUrlType = this.CHECKOUT_URL_TYPES.configurableProduct;
				}
				else if (product.isEordersProduct()) {
					checkoutUrlType = this.CHECKOUT_URL_TYPES.eorders;
				}
				else {
					checkoutUrlType = this.CHECKOUT_URL_TYPES.accessory;
				}
			}

			this.ctaType = checkoutUrlType;
			return checkoutUrlType;
		},

		setDuration: function (value) {
			var mod = this;
			$('.custom-radio input:radio[name^="price-order-subscription-duration-"]', mod.$ctx).each(function () {
				var radioButton = $(this);
				if (radioButton.val() === String(value)) {
					radioButton.prop('checked', true);
				}
				radioButton.trigger('change');
			});
		},

		/**
		 * Event handler when the component is shown. Applies only if the component is not used in combination with a
		 * product data hub.
		 *
		 * @method onShow
		 * @return void
		 */
		onShow: function () {
			var mod = this;

			if (!mod.useDynamicPrice) {
				if (mod.trackingTimeout) {
					clearTimeout(mod.trackingTimeout);
					mod.trackingTimeout = null;
				}
				mod.trackingTimeout = setTimeout($.proxy(mod.trackOnShow, mod), mod.TRACKING_TIMEOUT);
			}
		},

		/**
		 * Event handler when the component is hidden. Applies only if the component is not used in combination with a
		 * product data hub.
		 *
		 * @method onHide
		 * @return void
		 */
		onHide: function () {
			var mod = this;

			if (mod.trackingTimeout) {
				clearTimeout(mod.trackingTimeout);
				mod.trackingTimeout = null;
			}
		},

		onGetCheckoutUrl: function (data) {
			// Only send the url if no fixed subscription Id is set.
			// Otherwise it's not the main price order component.
			if (!this.subscriptionId) {
				data.callback({ url: this.actionLink.attr('href') });
			}
		},

		prepareVariantOrderLinks: function () {
			var mod = this;
			var $links = mod.$ctx.find('> .variant-order-links a[href]');
			var links = mod.variantOrderLinks = {};
			$links.each(function () {
				links[this.getAttribute('data-product-detail-id')] = this.href;
			});
		},

		onLoadContractDetails: function () {
			$('[name="filter-subscriptionId"], [name="filter-subscriptionType"]').change();
		}
	});
}(__webpack_provided_window_dot_Tc_dot_$, window.Tc, window.SCS = window.SCS || {}));

}.call(window));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 166 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* unused harmony export Product */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Family; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Subscription__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Availability__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Promotion__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Rating__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Details__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_etc_designs_base_clientlibs_shared_vendor_ba_debug_min_js__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_etc_designs_base_clientlibs_shared_vendor_ba_debug_min_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_etc_designs_base_clientlibs_shared_vendor_ba_debug_min_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lib_ecommerce_Price__ = __webpack_require__(13);









var NEC_IMAGE_SIZES = {
    product: 344,
    superZoom: 450,
    thumbnail: 180,
    zoom: 450,
};
/**
 * Wrapper object for one family product
 */
var Product = /** @class */ (function () {
    function Product(product, family, featureGroups, bestseller, texts) {
        this.product = product;
        this.overrides = {};
        this.family = family;
        this.texts = texts;
        this.subscriptions = new __WEBPACK_IMPORTED_MODULE_1__Subscription__["c" /* Subscriptions */](product.subscriptionBundles);
        this.availability = new __WEBPACK_IMPORTED_MODULE_2__Availability__["a" /* Availability */](product.code);
        var discountPrices = (product.discountSpecialOffers || [])
            .map(function (discount) { return new __WEBPACK_IMPORTED_MODULE_3__Promotion__["a" /* Discount */](discount); })
            .filter(function (discount) { return discount.isValid(); });
        if (discountPrices.length > 1) {
            window.debug.error('Found more than one applicable discount for product', product.code);
        }
        // Add dummy discount of 0 so the API is more unified.
        this.discountPrice = discountPrices[0] || new __WEBPACK_IMPORTED_MODULE_3__Promotion__["a" /* Discount */]({ active: false });
        var promotionDatas = Object(__WEBPACK_IMPORTED_MODULE_3__Promotion__["e" /* normalizePromotions */])(product.bundleSpecialOffers);
        var callouts = Object(__WEBPACK_IMPORTED_MODULE_3__Promotion__["f" /* synthesizeCallouts */])(product, bestseller, texts, promotionDatas, this.discountPrice);
        this.promotions = promotionDatas.concat(callouts)
            .map(function (promotion) { return new __WEBPACK_IMPORTED_MODULE_3__Promotion__["c" /* Promotion */](promotion); })
            .sort(function (ref, candidate) {
            return Object(__WEBPACK_IMPORTED_MODULE_7__util__["compareNumbers"])(__WEBPACK_IMPORTED_MODULE_3__Promotion__["b" /* PROMOTION_PRIORITY */].indexOf(ref.getType()), __WEBPACK_IMPORTED_MODULE_3__Promotion__["b" /* PROMOTION_PRIORITY */].indexOf(candidate.getType()));
        });
        // FIXME NEC: Possibly move to ProductFamily
        this.images = {};
        for (var _i = 0, _a = product.images || []; _i < _a.length; _i++) {
            var imageData = _a[_i];
            var size = typeof (imageData.format) === 'string' ? NEC_IMAGE_SIZES[imageData.format] : imageData.format;
            this.images[size] = imageData;
        }
        this.details = new __WEBPACK_IMPORTED_MODULE_5__Details__["a" /* default */](product.classifications || [], product, family.productFamily, featureGroups);
        // Pre-emptive loading of product availability info
        // tslint:disable-next-line:no-floating-promises
        this.availability.load();
    }
    Product.prototype.setOverrides = function (ovr) {
        this.overrides = ovr;
    };
    Product.prototype.getDetails = function () {
        return this.details;
    };
    Product.prototype.matches = function (color, memory, dimension) {
        if (color && String(this.getColor()).toLowerCase() !== String(color).toLowerCase()) {
            return false;
        }
        if (memory && String(this.getMemory()).toLowerCase() !== String(memory).toLowerCase()) {
            return false;
        }
        var productDimension = String(this.getDetails().getDimension() && this.getDetails().getDimension().getValue()).toLowerCase();
        if (dimension && productDimension !== String(dimension).toLowerCase()) {
            return false;
        }
        return true;
    };
    // Like getDetails().getColor().getValue() but includes overrides
    Product.prototype.getColor = function () {
        return this.overrides.color || this.details.getColor().getValue();
    };
    // Like getDetails().getColorText().getValue() but includes overrides
    Product.prototype.getColorText = function () {
        return this.overrides.colorText || this.details.getColorText().getValue();
    };
    // Like getDetails().getMemory().getValue() but includes overrides
    Product.prototype.getMemory = function () {
        return this.overrides.memory || this.details.getMemory().getValue();
    };
    // Like getDetails().getMemory().getValueFormatted() but includes overrides
    Product.prototype.getMemoryText = function () {
        var mem = this.details.getMemory();
        if (this.overrides.memory) {
            var unit = mem.getUnitSymbol();
            unit = unit ? ' ' + unit : '';
            // FIXME NEC: What if unit is part of memory already?
            return this.overrides.memory + unit;
        }
        return mem.getValueFormatted();
    };
    // FIXME NEC: Move to base class with ProductFamily?
    Product.prototype.getBrand = function () {
        return this.product.brand && this.product.brand.code;
    };
    Product.prototype.getName = function () {
        return this.overrides.productName || this.product.name;
    };
    Product.prototype.getFamilyName = function () {
        return this.overrides.familyName || this.family.getFamilyName() || this.getName();
    };
    // FIXME NEC: Move to base class with ProductFamily?
    Product.prototype.getCategory = function () {
        return this.product.productCategoryMaster;
    };
    Product.prototype.getProductCategory2 = function () {
        return this.product.productCategory2;
    };
    Product.prototype.showsRebate = function () {
        return $.inArray(this.getCategory(), __WEBPACK_IMPORTED_MODULE_3__Promotion__["d" /* REBATE_EXEMPT_CATEGORIES */]) === -1;
    };
    Product.prototype.hasGuaranteeExtension = function () {
        return (this.product.guaranteeExtension &&
            this.product.guaranteeExtension.guaranteePeriod &&
            this.product.guaranteeExtension.price);
    };
    Product.prototype.getWarrantyPriceFormatted = function () {
        if (this.hasGuaranteeExtension()) {
            var price = Object(__WEBPACK_IMPORTED_MODULE_8_lib_ecommerce_Price__["default"])(this.product.guaranteeExtension.price);
            if (price.isValid()) {
                return "+ " + price.currency() + " " + price.formatted();
            }
        }
        return '';
    };
    Product.prototype.getWarrantyPeriod = function () {
        return (this.product.guaranteeExtension && this.product.guaranteeExtension.guaranteePeriod) || 0;
    };
    /**
     * Gets the price info for how much the product costs without subscriptions (but including discounts)
     * @returns Price
     */
    Product.prototype.getDiscountedPrice = function () {
        if (!this.showsRebate()) {
            return this.getOriginalPrice();
        }
        return this.discountPrice.getPrice(this.getOriginalPrice());
    };
    /**
     * Gets the price info for how much the product costs without subscriptions and without discounts
     * @returns Price
     */
    Product.prototype.getOriginalPrice = function () {
        return Object(__WEBPACK_IMPORTED_MODULE_8_lib_ecommerce_Price__["default"])(this.product.price);
    };
    Product.prototype.isDiscounted = function () {
        return this.getDiscountedPrice() < this.getOriginalPrice();
    };
    // Gets the lowest price this product can be had for, taking any possible subscriptions into account
    Product.prototype.getMinimumPrice = function () {
        var prices = this.subscriptions.map(function (subscription) {
            // Math.min will call its valueOf automatically from the Price instance returned by getPrice()
            return subscription.getPrice();
        });
        // Add device price
        prices.push(this.getDiscountedPrice());
        return Object(__WEBPACK_IMPORTED_MODULE_8_lib_ecommerce_Price__["default"])(Math.min.apply(Math, prices));
    };
    /**
     * Returns the price for a subscription or, as a fallback, the price of the
     * Product if no subscription can be found
     *
     * @param subscriptionId
     * @param subscriptionDuration
     *
     * @returns Price
     */
    Product.prototype.getPrice = function (subscriptionId, subscriptionDuration) {
        var price = this.getSubscriptionPrice(subscriptionId, subscriptionDuration);
        if (!price) {
            return this.getDiscountedPrice();
        }
        return price;
    };
    Product.prototype.getSubscriptionPrice = function (subscriptionId, subscriptionDuration) {
        if (this.subscriptions.contains(subscriptionId, subscriptionDuration)) {
            return this.subscriptions.getPrice(subscriptionId, subscriptionDuration);
        }
        return null;
    };
    /**
     * Retrieves the simple pay monthly pay from the provided subscriptionId and subscriptionDuration.
     * Default value is -1 (if no plan found) or a Price with value of 0 (if the plan does not have simple pay)
     * both of which mean simple pay should not be active.
     *
     * @param subscriptionId - The subscription Id to check
     * @param subscriptionDuration - The subscription duration to check
     * @returns {(string|Number)}
     */
    Product.prototype.getSimplePayMonthlyPrice = function (subscriptionId, subscriptionDuration) {
        if (!subscriptionId || !this.subscriptions.getAll().length) {
            var price = this.subscriptions.getSimplePayRateWithoutSubscription();
            if (price.value() === 0) {
                return -1;
            }
            return price;
        }
        var plan = this.subscriptions.get(subscriptionId, subscriptionDuration);
        if (!plan) {
            return -1;
        }
        return plan.getSimplePayRate();
    };
    /**
     * Returns true if the eCommerce Configuration page can be skipped.
     * This is the case for configurable products without a subscription but with simple pay possible.
     */
    Product.prototype.isAddProductAndShowBasket = function (subscriptionType) {
        return this.isConfigurationNeeded() && subscriptionType === 'without' && this.getSimplePayMonthlyPrice() !== -1;
    };
    /**
     * Retrieves the simple pay initial price (“Anzahlung”) from the provided subscriptionId and subscriptionDuration.
     * Ecommerce as of February release 2016 does not deliver this property and it will always return 0.-
     *
     * @param subscriptionId - The subscription Id to check
     * @param subscriptionDuration - The subscription duration to check
     * @returns {string}
     */
    // tslint:disable-next-line:prefer-function-over-method
    Product.prototype.getSimplePayInitialPrice = function () {
        return Object(__WEBPACK_IMPORTED_MODULE_8_lib_ecommerce_Price__["default"])(0);
    };
    Product.prototype.getSubscriptions = function () {
        return this.subscriptions;
    };
    Product.prototype.getId = function () {
        return String(this.overrides.productId || this.product.code);
    };
    /**
     * Returns the image URL for the given size
     *
     * @deprecated use @link{getImageData} to also get alt text and similar attributes
     */
    Product.prototype.getImage = function (size) {
        var data = this.getImageData(size);
        return data.sapUrl || data.url;
    };
    /**
     * Returns the image data objectfor the given size
     *
     * @see https://wiki.swisscom.com/display/ECMX/SCOM+OCC+ImageWsDTO
     */
    Product.prototype.getImageData = function (size) {
        if (typeof size === 'string') {
            // FIXME NEC: Is thumbnail 180 or 64?
            switch (size) {
                case 'large':
                    size = 450;
                    break;
                case 'big':
                    size = 344;
                    break;
                case 'small':
                    size = 180;
                    break;
                case 'mini':
                    size = 104;
                    break;
                default:
                case 'thumbnail':
                    size = 64;
                    break;
            }
        }
        return (this.images[size] || this.images[450] || {});
    };
    Product.prototype.getImageBig = function () {
        return this.overrides.imagePath || this.getImage('big');
    };
    Product.prototype.getImageSmall = function () {
        return this.overrides.imagePath || this.getImage('small');
    };
    Product.prototype.getImageMini = function () {
        return this.overrides.imagePath || this.getImage('mini');
    };
    Product.prototype.getRedFlagText = function () {
        return this.product.redFlagText;
    };
    Product.prototype.getSlogan = function () {
        return this.product.slogan;
    };
    Product.prototype.getFeatures = function () {
        return this.product.description;
    };
    Product.prototype.getTopFeatures = function () {
        // FIXME NEC: Can we get an array?
        return (this.product.topFeatures || '').split(/[\r\n]+/g);
    };
    Product.prototype.getDelayedDeliveryReason = function () {
        return this.product.deliveryInfo || '';
    };
    Product.prototype.getAvailability = function () {
        return this.availability;
    };
    Product.prototype.allowOnStockNotification = function () {
        return this.product.onStockNotifications;
    };
    Product.prototype.showNotificationButton = function () {
        return this.availability.getStatus() === __WEBPACK_IMPORTED_MODULE_2__Availability__["b" /* AvailabilityStatus */].OutOfStockNotifiable;
    };
    Product.prototype.isEordersProduct = function () {
        return this.product.isEordersProduct;
    };
    Product.prototype.isConfigurationNeeded = function () {
        return this.product.configurationNeeded;
    };
    Product.prototype.canHaveSubscriptions = function () {
        return this.product.variantType === 'MobileDeviceProduct';
    };
    Product.prototype.isReservationInStoreAllowed = function () {
        return this.product.reservationInStoreAllowed;
    };
    Product.prototype.isReservationAllowed = function () {
        return !!this.product.reservationAllowed;
    };
    Product.prototype.getNotifyUrl = function () {
        return this.texts.notifyurl + "/" + this.getId();
    };
    Product.prototype.isSddAllowed = function () {
        return this.product.sddAllowed || false;
    };
    Product.prototype.getSddMinimumPurchaseAmount = function () {
        return this.family.getSddMinimumPurchaseAmount();
    };
    Product.prototype.getSddShippingFee = function () {
        return this.family.getSddShippingFee();
    };
    Product.prototype.hasValidSimplePay = function () {
        return this.subscriptions.hasValidSimplePay();
    };
    Product.prototype.getApplicablePromotions = function (subscriptionId, duration, kaze) {
        // Filter promotions that don’t match
        return this.promotions.filter(function (promotion) {
            return promotion.matches(subscriptionId, duration, kaze);
        });
    };
    /**
     * Legacy mode: only returns promotions that don’t depend on the chosen subscription or its duration or the case
     */
    Product.prototype.getPromotions = function () {
        return this.getApplicablePromotions();
    };
    return Product;
}());

/**
 * Wrapper object for product family
 */
var Family = /** @class */ (function () {
    function Family(productFamily, variants, segment, featureGroups, bestseller, texts, warranties) {
        var _this = this;
        if (variants === void 0) { variants = null; }
        if (segment === void 0) { segment = __WEBPACK_IMPORTED_MODULE_7__util__["Segment"].RES; }
        this.productFamily = productFamily;
        this.overrides = {};
        this.details = new __WEBPACK_IMPORTED_MODULE_5__Details__["a" /* default */](undefined, undefined, productFamily);
        this.segment = segment;
        this.texts = texts;
        var createProduct = function (data) { return new Product(data, _this, featureGroups, bestseller, texts); };
        variants = variants || { __ordering: [] };
        this.products = variants.__ordering
            .filter(function (variantCode) { return variantCode in variants; })
            .map(function (variantCode) {
            return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, productFamily), variants[variantCode]), { guaranteeExtension: warranties[variantCode] });
        })
            .map(createProduct);
        this.ratings = new __WEBPACK_IMPORTED_MODULE_4__Rating__["a" /* Ratings */](productFamily.code);
        // Pre-emptive loading of product ratings
        // tslint:disable-next-line:no-floating-promises
        this.ratings.load();
    }
    Family.prototype.getConfigError = function () {
        if (!this.products.length) {
            return 'No variants available.';
        }
        return null;
    };
    Family.prototype.setOverrides = function (ovr) {
        if (ovr === void 0) { ovr = {}; }
        this.overrides = ovr;
        for (var productId in (this.overrides.products || {})) {
            var product = this.getProductById(productId);
            if (!product) {
                window.debug.error("Override given for id " + productId + ", but product does not exist");
                continue;
            }
            // Inherit properties (family name) form parent but make sure to delete products
            var productOverrides = $.extend({}, this.overrides, this.overrides.products[productId], { products: null });
            product.setOverrides(productOverrides);
        }
    };
    Family.prototype.getProducts = function () {
        return this.products;
    };
    Family.prototype.getProductById = function (id) {
        for (var _i = 0, _a = this.products; _i < _a.length; _i++) {
            var product = _a[_i];
            if (product.getId() === String(id)) {
                return product;
            }
        }
        return null;
    };
    Family.prototype.getProductByFilter = function (color, memory, dimension) {
        for (var _i = 0, _a = this.products; _i < _a.length; _i++) {
            var product = _a[_i];
            if (product.matches(color, memory, dimension)) {
                return product;
            }
        }
        return null;
    };
    Family.prototype.getId = function () {
        return String(this.productFamily.code);
    };
    Family.prototype.getFamilyName = function () {
        return this.overrides.familyName || this.productFamily.name;
    };
    Family.prototype.getBrand = function () {
        return this.productFamily.brand.code;
    };
    Family.prototype.getSeoName = function () {
        return this.texts.seoname || this.getFamilyName();
    };
    Family.prototype.getCategory = function () {
        // FIXME NEC: Does this need to be a human-readable category name?
        return this.productFamily.productCategoryMaster;
    };
    // tslint:disable-next-line:prefer-function-over-method
    Family.prototype.isFamilyProduct = function () {
        return true;
    };
    Family.prototype.isEordersProduct = function () {
        return this.productFamily.isEordersProduct;
    };
    Family.prototype.isConfigurationNeeded = function () {
        return this.productFamily.configurationNeeded;
    };
    Family.prototype.canHaveSubscriptions = function () {
        // FIXME NEC: Check that this is correct
        // See https://wiki.swisscom.com/display/ECMX/SCOM+OCC+ProductWsDTO
        // Changed from check if itemType === 'MobileDeviceProduct'…
        // …because that didn’t work; mobiles had 'Product' there instead.
        return this.productFamily.variantType === 'MobileDeviceProduct';
    };
    Family.prototype.getSlogan = function () {
        return this.productFamily.slogan || '';
    };
    Family.prototype.getFeatures = function () {
        return this.productFamily.description;
    };
    Family.prototype.getTopFeatures = function () {
        return (this.productFamily.topFeatures || '').split(/[\r\n]+/g);
    };
    Family.prototype.getDetailPagePath = function () {
        return this.texts.detailpagepath;
    };
    Family.prototype.getNotifyUrl = function () {
        return this.texts.notifyurl;
    };
    Family.prototype.getSegment = function () {
        return this.segment;
    };
    Family.prototype.getDetails = function () {
        return this.details;
    };
    Family.prototype.getRatings = function () {
        return this.ratings;
    };
    Family.prototype.getRedFlagText = function () {
        // FIXME NEC: Remove if unused (on family)
        return this.productFamily.redFlagText;
    };
    Family.prototype.getSddMinimumPurchaseAmount = function () {
        if (!this.productFamily.sddMinimumPurchaseAmount) {
            return '';
        }
        return this.productFamily.sddMinimumPurchaseAmount.toFixed(2) || '';
    };
    Family.prototype.getSddShippingFee = function () {
        if (!this.productFamily.sddShippingFee) {
            return '';
        }
        return this.productFamily.sddShippingFee.toFixed(2) || '';
    };
    Family.prototype.isSimplePayAllowed = function () {
        for (var _i = 0, _a = this.products; _i < _a.length; _i++) {
            var product = _a[_i];
            if (product.hasValidSimplePay()) {
                return true;
            }
        }
        return false;
    };
    return Family;
}());


/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),
/* 168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PROMOTION_PRIORITY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Promotion; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Discount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return REBATE_EXEMPT_CATEGORIES; });
/* harmony export (immutable) */ __webpack_exports__["e"] = normalizePromotions;
/* harmony export (immutable) */ __webpack_exports__["f"] = synthesizeCallouts;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Price__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);




var Activatable = /** @class */ (function () {
    function Activatable() {
    }
    Activatable.prototype.isOn = function (date) {
        if (date === void 0) { date = new Date(); }
        var from = this.getStartDate();
        if (from && from > date) {
            return false;
        }
        var to = this.getEndDate();
        if (to && to < date) {
            return false;
        }
        return true;
    };
    Activatable.prototype.isValid = function (date) {
        if (date === void 0) { date = new Date(); }
        if (!this.isActive()) {
            return false;
        }
        return this.isOn(date);
    };
    Activatable.prototype.isActive = function () {
        // FIXME NEC: Check again when this flag is deployed if we actually need to check for presence.
        return !('active' in this.getModel()) || this.getModel().active;
    };
    Activatable.prototype.getStartDate = function () {
        if (!this.getModel().validFrom) {
            return null;
        }
        return Object(__WEBPACK_IMPORTED_MODULE_1__util__["parseDate"])(this.getModel().validFrom);
    };
    Activatable.prototype.getEndDate = function () {
        if (!this.getModel().validTo) {
            return null;
        }
        return Object(__WEBPACK_IMPORTED_MODULE_1__util__["parseDate"])(this.getModel().validTo);
    };
    return Activatable;
}());
var PROMOTION_PRIORITY = ['DISCOUNT', 'BESTSELLER', 'PROMOTION', 'FREETEXT', 'NEW'];
var Promotion = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */])(Promotion, _super);
    function Promotion(promotion) {
        var _this = _super.call(this) || this;
        _this.promotion = promotion;
        return _this;
    }
    Promotion.prototype.getId = function () {
        return this.promotion.promotionCode || this.promotion.code;
    };
    Promotion.prototype.getBundleId = function () {
        return this.promotion.code;
    };
    Promotion.prototype.getName = function () {
        return this.promotion.name;
    };
    Promotion.prototype.getDescription = function () {
        return this.promotion.description;
    };
    Promotion.prototype.getSlogan = function () {
        return this.promotion.slogan;
    };
    Promotion.prototype.getCases = function () {
        return (this.promotion.cases || []).map(__WEBPACK_IMPORTED_MODULE_1__util__["upper"]);
    };
    Promotion.prototype.getSubscriptionId = function () {
        return this.promotion.subscriptionId;
    };
    Promotion.prototype.getDurations = function () {
        return (this.promotion.durations || []).map(Number);
    };
    Promotion.prototype.isCallout = function () {
        return this.promotion.callout;
    };
    Promotion.prototype.getType = function () {
        return Object(__WEBPACK_IMPORTED_MODULE_1__util__["upper"])(this.promotion.type);
    };
    /**
     * Checks if the promotion is applicable for a certain configuration
     * If an argument is omitted, return only true if the promotion is unconditional on that argument.
     */
    Promotion.prototype.matches = function (subscriptionId, duration, kaze) {
        if (!this.isValid()) {
            // Never apply promotions whose dates don’t match
            return false;
        }
        if (this.getSubscriptionId() && subscriptionId !== this.getSubscriptionId()) {
            // Subscription needs to match but didn’t
            return false;
        }
        if (this.getDurations().length && __WEBPACK_IMPORTED_MODULE_3_jquery__["inArray"](Number(duration), this.getDurations()) === -1) {
            // Duration needs to be set but was not found in conditions
            return false;
        }
        if (this.getCases().length && __WEBPACK_IMPORTED_MODULE_3_jquery__["inArray"](Object(__WEBPACK_IMPORTED_MODULE_1__util__["upper"])(kaze || ''), this.getCases()) === -1) {
            // Case was expected but did not match
            return false;
        }
        return true;
    };
    // From Activatable
    Promotion.prototype.getModel = function () {
        return this.promotion;
    };
    return Promotion;
}(Activatable));

var Discount = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */])(Discount, _super);
    function Discount(discountSpecialOffer) {
        var _this = _super.call(this) || this;
        _this.discountSpecialOffer = discountSpecialOffer;
        return _this;
    }
    Discount.prototype.getPrice = function (fullPrice) {
        if (this.discountSpecialOffer.oneTimePrice) {
            return Object(__WEBPACK_IMPORTED_MODULE_2__Price__["default"])(this.discountSpecialOffer.oneTimePrice);
        }
        // Absolute price
        var price = Object(__WEBPACK_IMPORTED_MODULE_2__Price__["default"])(fullPrice);
        if (this.discountSpecialOffer.oneTimePricePercentage) {
            // FIXME NEC: Assuming oneTimePricePercentage is an int betwen 0…100 signifiyin the discount.
            return Object(__WEBPACK_IMPORTED_MODULE_2__Price__["default"])(price.value() * (1 - (this.discountSpecialOffer.oneTimePricePercentage / 100)));
        }
        return price;
    };
    // From Activatable
    Discount.prototype.getModel = function () {
        return this.discountSpecialOffer;
    };
    return Discount;
}(Activatable));

var REBATE_EXEMPT_CATEGORIES = ['MobileLike.Handy.Smartphone', 'MobileLike.Handy', 'MobileLike.Tablets'];
function normalizePromotions(promotions) {
    // Flatten promotions ⇒ promotionBundles
    var _a;
    if (promotions === void 0) { promotions = []; }
    var result = (promotions || []).map(function (promotion) {
        return (promotion.promoBundles || []).map(function (promoBundle) {
            return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, promotion), promoBundle), { promotionCode: promotion.code });
        });
    });
    // Flatten arrays in array
    return (_a = []).concat.apply(_a, result);
}
function synthesizeCallouts(product, bestseller, texts, existingPromotions, discountPrice) {
    if (discountPrice === void 0) { discountPrice = null; }
    var result = [];
    // Handle bestseller flag
    var isBestseller = (bestseller || '').indexOf("," + product.code + ",") > -1;
    if (isBestseller) {
        // Artificially add the bestseller promotion to the list of promotions
        result.push({
            callout: true,
            code: 'bestseller',
            name: texts.bestseller,
            type: 'bestseller',
        });
    }
    // Handle callout property
    if (product.callout && product.callout.code && product.callout.code !== 'NONE') {
        // Artificially add the callout promotion (if any) to the list of promotions
        result.push({
            callout: true,
            code: product.callout.code,
            name: product.callout.name || product.callout.code,
            type: product.callout.code,
        });
    }
    // Handle discount
    if (discountPrice && discountPrice.isValid()) {
        result.push({ code: 'discount', name: texts.discountflagtext, callout: true, type: 'discount' });
    }
    // Consider all promotions in existingPromotions to be non-badge.
    for (var _i = 0, existingPromotions_1 = existingPromotions; _i < existingPromotions_1.length; _i++) {
        var promo = existingPromotions_1[_i];
        // Use cases, durations and subscriptionId from original promo (if available)
        result.push(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, promo), {
            callout: true,
            name: texts.promotionflagtext,
            type: 'promotion',
        }));
    }
    return result;
}


/***/ }),
/* 169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* unused harmony export SubRatingCategory */
/* unused harmony export CategorySubratings */
/* unused harmony export Votable */
/* unused harmony export RatingComment */
/* unused harmony export Rating */
/* unused harmony export SubRatingCategories */
/* unused harmony export RatingSummary */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Ratings; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(14);


var SubRatingCategory = /** @class */ (function () {
    function SubRatingCategory(category) {
        this.id = category.id;
        this.name = category.name;
    }
    SubRatingCategory.prototype.getId = function () {
        return this.id;
    };
    SubRatingCategory.prototype.getName = function () {
        return this.name;
    };
    return SubRatingCategory;
}());

var CategorySubratings = /** @class */ (function () {
    function CategorySubratings(ratings) {
        this.ratings = ratings || [];
        this.subRatings = {};
        for (var _i = 0, _a = this.ratings; _i < _a.length; _i++) {
            var rating = _a[_i];
            // FIXME NEC: Is there a spec for this? Rating seems to be an integer [10..50]
            rating.ratingValue = rating.rating / 10;
            this.subRatings[rating.category.id] = rating;
        }
    }
    CategorySubratings.prototype.hasSubratings = function () {
        return !!this.ratings.length;
    };
    CategorySubratings.prototype.forCategoryWithId = function (categoryId) {
        var subrating = this.subRatings[categoryId];
        if (!subrating) {
            return -0;
        }
        return subrating.ratingValue || -0;
    };
    CategorySubratings.prototype.map = function (mapper) {
        return this.ratings.map(function (rating) { return mapper(rating.ratingValue, new SubRatingCategory(rating.category)); });
    };
    return CategorySubratings;
}());

var Votable = /** @class */ (function () {
    function Votable() {
        this.type = '';
        this._hasVoted = null;
        this._hasSentAbuseReport = false;
    }
    Votable.prototype.getUpvotes = function () {
        return this.getModel().numHelpful + (this._hasVoted === true ? 1 : 0);
    };
    Votable.prototype.getDownvotes = function () {
        return this.getModel().numUseless + (this._hasVoted === false ? 1 : 0);
    };
    Votable.prototype.hasVoted = function () {
        return this._hasVoted !== null;
    };
    Votable.prototype.getVote = function () {
        return this._hasVoted;
    };
    Votable.prototype.hasSentAbuseReport = function () {
        return this._hasSentAbuseReport;
    };
    // Attention: updates state
    Votable.prototype.vote = function (isUpvote) {
        this._hasVoted = isUpvote;
    };
    Votable.prototype.sendAbuseReport = function () {
        this._hasSentAbuseReport = true;
    };
    return Votable;
}());

var RatingComment = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */])(RatingComment, _super);
    function RatingComment(comment) {
        var _this = _super.call(this) || this;
        _this.type = 'comment';
        _this.comment = comment;
        return _this;
    }
    RatingComment.prototype.getId = function () {
        return this.comment.id;
    };
    RatingComment.prototype.getName = function () {
        return this.comment.reviewerName || '';
    };
    RatingComment.prototype.getComment = function () {
        return this.comment.comment || '';
    };
    RatingComment.prototype.getDate = function () {
        return Object(__WEBPACK_IMPORTED_MODULE_1__util__["parseDate"])(this.comment.date);
    };
    RatingComment.prototype.isAdminComment = function () {
        return this.comment.isAdminComment;
    };
    // From Votable
    RatingComment.prototype.getModel = function () {
        return this.comment;
    };
    return RatingComment;
}(Votable));

var Rating = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */])(Rating, _super);
    function Rating(rating) {
        var _this = _super.call(this) || this;
        _this.type = 'rating';
        _this.rating = rating;
        _this._hasCommented = false;
        _this.comments = (rating.comments || []).map(function (comment) {
            return new RatingComment(comment);
        });
        return _this;
    }
    Rating.prototype.getId = function () {
        return this.rating.id;
    };
    Rating.prototype.getProductId = function () {
        return this.rating.productId;
    };
    Rating.prototype.getRating = function () {
        // FIXME NEC: Is there a spec for this? Rating seems to be an integer [10..50]
        return this.rating.rating / 10;
    };
    Rating.prototype.getFirstName = function () {
        return this.rating.firstName;
    };
    Rating.prototype.getLastName = function () {
        return this.rating.lastName;
    };
    Rating.prototype.getComment = function () {
        return this.rating.comment || '';
    };
    Rating.prototype.getDate = function () {
        return Object(__WEBPACK_IMPORTED_MODULE_1__util__["parseDate"])(this.rating.date);
    };
    Rating.prototype.isRecommended = function () {
        return String(this.rating.recommended).toUpperCase() === 'YES';
    };
    Rating.prototype.isDiscommended = function () {
        return String(this.rating.recommended).toUpperCase() === 'NO';
    };
    Rating.prototype.isRecommendationNeutral = function () {
        return !this.isRecommended() && !this.isDiscommended();
    };
    Rating.prototype.getLanguage = function () {
        return this.rating.language || 'de';
    };
    Rating.prototype.getHeadline = function () {
        return this.rating.headline;
    };
    Rating.prototype.getCategorySubratings = function () {
        return new CategorySubratings(this.rating.subratings);
    };
    Rating.prototype.getComments = function () {
        return this.comments;
    };
    Rating.prototype.hasCommented = function () {
        return this._hasCommented;
    };
    // Attention: updates state
    Rating.prototype.comment = function () {
        this._hasCommented = true;
    };
    // From Votable
    Rating.prototype.getModel = function () {
        return this.rating;
    };
    return Rating;
}(Votable));

/**
 * Wrapper object for Ratings
 */
var SubRatingCategories = /** @class */ (function () {
    function SubRatingCategories(subratingCategories) {
        this.subratingCategories = subratingCategories;
    }
    SubRatingCategories.prototype.getCategories = function () {
        return (this.subratingCategories || []).map(function (category) {
            return new SubRatingCategory(category);
        });
    };
    return SubRatingCategories;
}());

function num(num, rounded) {
    if (rounded) {
        return Math.round(num || 0);
    }
    return num || 0;
}
var RatingSummary = /** @class */ (function () {
    function RatingSummary(ratings) {
        this.aggregate = {
            1: 0,
            2: 0,
            3: 0,
            4: 0,
            5: 0,
            count: 0,
            countRecommended: 0,
            sum: 0,
        };
        for (var _i = 0, ratings_1 = ratings; _i < ratings_1.length; _i++) {
            var rating = ratings_1[_i];
            var value = rating.getRating();
            this.aggregate.count += 1;
            this.aggregate.sum += value;
            this.aggregate.countRecommended += rating.isRecommended() ? 1 : 0;
            this.aggregate[String(value)] += 1;
        }
    }
    RatingSummary.prototype.getAverage = function (rounded) {
        return num(this.aggregate.sum / this.aggregate.count, rounded);
    };
    RatingSummary.prototype.count = function (forStar) {
        var num = this.aggregate.count;
        if (forStar && forStar in this.aggregate) {
            num = this.aggregate[forStar];
        }
        return num || -0;
    };
    RatingSummary.prototype.getRecommendationPercentage = function (rounded) {
        return num(this.aggregate.countRecommended / this.aggregate.count * 100, rounded);
    };
    return RatingSummary;
}());

var lang = $('html').attr('lang');
var OCC_ENDPOINT = '/portal-services/occ/';
var RATING_ENDPOINT = OCC_ENDPOINT + 'ratings/{languageId}/{productId}';
var SUBRATING_CATEGORIES_ENDPOINT = OCC_ENDPOINT + 'subratingCategories/{languageId}/{productId}';
/**
 * Load ratings from endpoint
 */
function loadRatings(url, productId) {
    if (!productId) {
        // Wrongly-configured product data hub
        // Return a promise that never resolves.
        return $.Deferred().promise();
    }
    return $.ajax(url.replace('{productId}', productId).replace('{languageId}', lang), {
        dataType: 'json',
    });
}
/**
 * Wraps all ratign-related properties
 */
var Ratings = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */])(Ratings, _super);
    function Ratings(productFamilyId) {
        var _this = _super.call(this) || this;
        _this.productFamilyId = productFamilyId;
        return _this;
    }
    Ratings.prototype.getRatings = function () {
        return this.ratings;
    };
    Ratings.prototype.getSummary = function () {
        return new RatingSummary(this.ratings || []);
    };
    Ratings.prototype.getSubRatingCategories = function () {
        return this.subRatingCategories;
    };
    // From Loadable
    Ratings.prototype.loadFunction = function () {
        return $.when(
        // Load both infos in parallel
        loadRatings(RATING_ENDPOINT, this.productFamilyId), loadRatings(SUBRATING_CATEGORIES_ENDPOINT, this.productFamilyId));
    };
    // From Loadable
    Ratings.prototype.loadCallback = function (productRatings, subRatingCategories) {
        this.ratings = (productRatings[0].productRatings || []).map(function (rating) {
            return new Rating(rating);
        });
        this.subRatingCategories = new SubRatingCategories(subRatingCategories[0].categories);
        return [this.ratings, this.subRatingCategories];
    };
    return Ratings;
}(__WEBPACK_IMPORTED_MODULE_1__util__["Loadable"]));


/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),
/* 170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Feature */
/* unused harmony export FeatureGroup */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);

var COLOR_TEXT_FEATURE_ID = 'HardwareVariantBasics/PimClassification/1.0/HardwareVariantBasics.colourtext';
var COLOR_FEATURE_ID = 'HardwareVariantBasics/PimClassification/1.0/HardwareVariantBasics.colourhexvalue';
var STORAGE_FEATURE_ID = 'HardwareVariantBasics/PimClassification/1.0/HardwareVariantBasics.internalstoragesize';
var DIMENSION_FEATURE_ID = 'HardwareBasics/PimClassification/1.0/HardwareBasics.dimension';
// TODO: Remove fallbacks
var FALLBACK_COLOR_TEXT_FEATURE_ID = 'Hardware/PimClassification/1.0/Hardware.colourtext';
var FALLBACK_COLOR_FEATURE_ID = 'Hardware/PimClassification/1.0/Hardware.colourhexvalue';
var FALLBACK_STORAGE_FEATURE_ID = 'Hardware/PimClassification/1.0/Hardware.internalstoragesize';
var FALLBACK_DIMENSION_FEATURE_ID = 'Hardware/PimClassification/1.0/Hardware.dimension';
// Features that are internal-only and should not be listed
var BLACKLISTED_FEATURE_IDS = [
    COLOR_TEXT_FEATURE_ID,
    FALLBACK_COLOR_TEXT_FEATURE_ID,
    COLOR_FEATURE_ID,
    FALLBACK_COLOR_FEATURE_ID,
    'HardwareBasics/PimClassification/1.0/HardwareBasics.pixel',
    'Hardware/PimClassification/1.0/Hardware.pixel',
];
/**
 * Wrapper object for Features/Details
 */
var Details = /** @class */ (function () {
    function Details(classifications, product, family, featureGroups) {
        var _this = this;
        if (classifications === void 0) { classifications = []; }
        if (product === void 0) { product = {}; }
        if (featureGroups === void 0) { featureGroups = {}; }
        this.product = product;
        this.family = family;
        var restGroup = null;
        var groupMapping = {};
        this.features = {};
        // Put groups first
        this.featureOrder = Object.keys(featureGroups)
            .map(function (name) {
            var containedFeatureIDs = featureGroups[name];
            var group = new FeatureGroup(name);
            _this.features[group.getFeatureId()] = group;
            if (containedFeatureIDs) {
                containedFeatureIDs.forEach(function (id) {
                    groupMapping[id] = group;
                });
            }
            else {
                restGroup = group;
            }
            return group.getFeatureId();
        });
        classifications.forEach(function (classificationCategory) {
            var categoryCode = classificationCategory.code;
            (classificationCategory.features || []).forEach(function (featureData) {
                var feature = new Feature(categoryCode, featureData);
                var id = feature.getFeatureId();
                _this.featureOrder.push(id);
                _this.features[id] = feature;
                // Put feature in group if applicable
                if (feature.belongsInGroup()) {
                    var group = restGroup;
                    if (id in groupMapping) {
                        group = groupMapping[id];
                    }
                    if (group) {
                        group.addFeature(feature);
                    }
                }
            });
        });
    }
    Details.prototype.getFeatures = function () {
        var _this = this;
        return this.featureOrder.map(function (featureId) { return _this.features[featureId]; });
    };
    Details.prototype.getColor = function () {
        return this.features[COLOR_FEATURE_ID] ||
            this.features[FALLBACK_COLOR_FEATURE_ID] ||
            new Feature(COLOR_FEATURE_ID, {});
    };
    Details.prototype.getColorText = function () {
        return this.features[COLOR_TEXT_FEATURE_ID] ||
            this.features[FALLBACK_COLOR_TEXT_FEATURE_ID] ||
            new Feature(COLOR_TEXT_FEATURE_ID, {});
    };
    Details.prototype.getMemory = function () {
        return this.features[STORAGE_FEATURE_ID] ||
            this.features[FALLBACK_STORAGE_FEATURE_ID] ||
            new Feature(STORAGE_FEATURE_ID, {});
    };
    Details.prototype.getDimension = function () {
        return this.features[DIMENSION_FEATURE_ID] || this.features[FALLBACK_DIMENSION_FEATURE_ID];
    };
    Details.prototype.getDeliveryFeatures = function () {
        return this.product.deliveryFeatures;
    };
    Details.prototype.getGeneralTermsAndConditions = function () {
        // FIXME NEC: Where to get these?
        return this.product.generalTermsAndConditions || this.family.generalTermsAndConditions || [];
    };
    Details.prototype.getGuaranteePeriod = function () {
        return this.product.guaranteePeriod || this.family.guaranteePeriod;
    };
    Details.prototype.getConditions = function () {
        // FIXME NEC: Where to get these?
        return this.product.productConditions || this.family.productConditions;
    };
    Details.prototype.getEcoPoints = function () {
        // FIXME NEC: Where to get these?
        return this.product.ecoPoints || this.family.ecoPoints;
    };
    Details.prototype.getPowerConsumption = function () {
        // TODO: Remove fallback
        return this.features['HardwareBasics/PimClassification/1.0/HardwareBasics.powerConsumption'] ||
            this.features['Hardware/PimClassification/1.0/Hardware.powerCosumption'];
    };
    Details.prototype.getProductionEnergy = function () {
        // TODO: Remove fallback
        return this.features['HardwareBasics/PimClassification/1.0/HardwareBasics.productionEnergy'] ||
            this.features['Hardware/PimClassification/1.0/Hardware.productionEnergy'];
    };
    Details.prototype.getRawMaterialSelection = function () {
        // FIXME NEC: Where to get these?
        return this.product.rawMaterialSelection || this.family.rawMaterialSelection;
    };
    return Details;
}());
/* harmony default export */ __webpack_exports__["a"] = (Details);
var Feature = /** @class */ (function () {
    function Feature(category, feature) {
        this.category = category;
        this.feature = feature;
    }
    Feature.prototype.getId = function () {
        return this.feature.code;
    };
    Feature.prototype.getCategory = function () {
        return this.category;
    };
    Feature.prototype.getFeatureId = function () {
        return [this.getCategory(), this.getId()].filter(Boolean).join('/');
    };
    Feature.prototype.getName = function () {
        return this.feature.name || '';
    };
    Feature.prototype.isComparable = function () {
        return !!this.feature.comparable;
    };
    Feature.prototype.getUnitName = function () {
        return (this.feature.featureUnit || {}).name;
    };
    Feature.prototype.getUnitSymbol = function () {
        return (this.feature.featureUnit || {}).symbol;
    };
    Feature.prototype.belongsInGroup = function () {
        return ['true', 'false', true, false].indexOf(this.getValue()) > -1;
    };
    Feature.prototype.getValueFormatted = function () {
        var unit = this.getUnitSymbol();
        unit = unit ? ' ' + unit : '';
        return this.getValue() + unit;
    };
    Feature.prototype.getUnitType = function () {
        return (this.feature.featureUnit || {}).unitType;
    };
    Feature.prototype.getValue = function () {
        return this.getValues()[0];
    };
    Feature.prototype.getValues = function () {
        return (this.feature.featureValues || [])
            .map(function (featureValue) { return featureValue.value; });
    };
    Feature.prototype.hasValueRange = function () {
        return !!this.feature.range;
    };
    Feature.prototype.isBlacklisted = function () {
        return this.belongsInGroup() || BLACKLISTED_FEATURE_IDS.indexOf(this.getFeatureId()) > -1;
    };
    return Feature;
}());

var FeatureGroup = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */])(FeatureGroup, _super);
    function FeatureGroup(name) {
        var _this = _super.call(this, 'FeatureGroup', {}) || this;
        _this.name = name;
        _this.features = [];
        return _this;
    }
    FeatureGroup.prototype.getId = function () {
        return this.getName();
    };
    FeatureGroup.prototype.getName = function () {
        return this.name;
    };
    // tslint:disable-next-line:prefer-function-over-method
    FeatureGroup.prototype.belongsInGroup = function () {
        return false;
    };
    FeatureGroup.prototype.getValue = function () {
        return this.getValues().join(', ');
    };
    FeatureGroup.prototype.getValues = function () {
        return this.features
            .filter(function (feature) { return feature.getValue() === 'true'; })
            .map(function (feature) { return feature.getName(); });
    };
    FeatureGroup.prototype.isBlacklisted = function () {
        return !this.getValues().length;
    };
    FeatureGroup.prototype.addFeature = function (feature) {
        this.features.push(feature);
    };
    return FeatureGroup;
}(Feature));



/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var loadTerrific = __webpack_require__(1);
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function ($) {
	'use strict';
	/*globals Tc */

	/**
	 * ProductOfferPreviews
	 *
	 * @author Matthias Inauen
	 * @namespace Tc.Module
	 * @class ProductOfferPreviews
	 * @extends Tc.Module
	 */
	Tc.Module.ProductOfferPreviews = Tc.Module.extend({

		ANIMATION_DURATION: 400,
		THUMBNAIL_IMG_OPACITY: 0.6,
		THUMBNAIL_LABEL_OPACITY: 0.8,
		DEEPLINK_MARKER: 't',
		TRACKING_PHRASE: 'tab',

		stageBackgroundImages: null,
		productOfferSlides: null,
		thumbnails: null,
		slides: null,
		slideshowIntervalDuration: null,
		slideshowInterval: null,
		slideshowCanceled: true,
		promoLabelContainers: null,
		adServerSlides: [],
		isMobile: false,

		/**
		 * Terrific On method
		 * @param callback Function
		 */
		on: function (callback) {

			var mod = this,
				$ctx = mod.$ctx,
				stage = $('#scs-stage'),
				backgroundImages = "",
				stageBackgroundContainer = stage.find('.scs-stage-flat');

			$(document).on('adServerContentComplete', $.proxy(mod.handleAdserverContentComplete, mod));
			$(document).on('adServerContentLoaded', $.proxy(mod.handleAdserverContentLoaded, mod));
			$(document).on('adServerContentFailed', $.proxy(mod.handleAdserverContentFailed, mod));

			mod.productOfferSlides = $ctx.find('.product-offer-preview-slide');
			mod.thumbnails = $ctx.find('.thumbnail-links').find('li');
			mod.slides = $ctx.find('.slides > li');
			mod.promoLabelContainers = mod.slides.find('.modPromoLabel');
			mod.slideshowIntervalDuration = parseInt($ctx.data('duration')) * 1000;
			mod.isMobile = SCS.utils.isMobilePage();
			// quickfix because on tablets background videos tend to not work properly
			// so we just turn off background videos for tablets and treat everything as it would be mobile
			if(!mod.isMobile) {
				mod.isMobile = mod.mobileAndTabletcheck();
			}

			mod.isOldIE = $('html').is('.msIe9, .msIe8, .msIe7, .msIe6');
			mod.volumeButtons = $('.video-volume', $ctx);

			if (mod.productOfferSlides.length > 0) {
				if (stageBackgroundContainer.length > 0) {
					stageBackgroundContainer.remove();
				}

				stageBackgroundContainer = mod.makeStageBackgroundContainer(stage);

				mod.productOfferSlides.each(function (index) {
					var slide = $(this);

					if (slide.data('videourl') && !mod.isMobile && !mod.isOldIE) {
						backgroundImages += '<div class="scs-stage-backgroundcontainer"><div class="replacementVideoTag" data-is-video="true" data-src="' + slide.data("videourl") + '"><img src="" data-imagesource="' + slide.data('backgroundimage') + '"></div></div>'
					}
					else {
						backgroundImages += '<div class="scs-stage-backgroundcontainer"><img src="" data-imagesource="' + slide.data('backgroundimage') + '"></div>';
					}

					// cache the slides that will try to load content from an ad-server
					if (slide.data('wp-id')) {
						mod.adServerSlides.push({slide: slide, wpId: slide.data('wp-id'), index: index, wpplaceholderid: slide.data('wpplaceholderid')});
						mod.hideSlide(index);
					}
				});

				stageBackgroundContainer.append(backgroundImages);
				mod.stageBackgroundImages = stageBackgroundContainer.find('.scs-stage-backgroundcontainer');
				mod.stageBackgroundImages.fadeTo(0, 0);
			}

			mod.volumeButtons.on('click', $.proxy(mod.handleVideoVolume, mod));

			mod.$ctx.on('click', '.productofferslide a, .productofferslide button, .productofferslide input', function(){
				mod.cancelSlideshowInterval();
			});

			callback();
		},

		after: function () {
			var mod = this,
				deeplink = parseInt(SCS.HashDeepLink.get(mod.DEEPLINK_MARKER));

			// try the reach the deeplink, if that slide is not waiting for an adserver response.
			if (typeof(deeplink) !== 'undefined' && deeplink < mod.thumbnails.length) {
				mod.startWithSlide(deeplink, false);
			}
			// Only initialize if the first slide is not waiting for an ad-server response
			else if (!mod.adServerSlides.length || mod.adServerSlides[0].index !== 0) {
				mod.startWithSlide(0, true);
			}
		},

		/**
		 * Checks if the client is a mobile device or a tablet
		 */
		mobileAndTabletcheck : function() {
			var check = false;
			(function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4)))check = true})(navigator.userAgent||navigator.vendor||window.opera);
			return check;
		},


		/**
		 * Entry point to initialize the User Interface for the component
		 * @param index
		 */
		startWithSlide: function (index, enableAutoPlay) {
			var mod = this;
			index = (index === undefined || index === '') ? 0 : parseInt(index);

			if (mod.productOfferSlides.length > 1) {
				mod.thumbnails.off('click').on('click', $.proxy(mod.handleThumbnailClick, mod));

				if (mod.slideshowIntervalDuration > 0 && typeof(enableAutoPlay) !== 'undefined' && enableAutoPlay === true) {
					mod.setNextInterval();
					mod.slideshowCanceled = false;
				}
			}
			mod.activateSlideWithIndex(index);
		},


		/**
		 * A Make UI function. Generates the background container in the background of the stage using
		 * the regular stage mechanisms and styles. Appends the background images DOM with them actually loading images.
		 * @param stage jqueryObject of the stage
		 * @returns jqueryObject of the container containing the background images.
		 */
		makeStageBackgroundContainer: function (stage) {
			var backgroundOuterContainer = $('<div class="scs-stage-flat product-offer-previews-stage"></div>');
			var backgroundInnerContainer = $('<div class="scs-stage-flat-inner"></div>');

			if (stage.data("full-height")) {
				backgroundOuterContainer.addClass('full-height-background');
			}

			if (stage.data("bottom-align")) {
				backgroundOuterContainer.addClass('bottom-align-background');
			}

			if (stage.data("background-color").length > 0) {
				backgroundOuterContainer.css('background-color', "#" + stage.data("background-color"));
			}

			stage.append(backgroundOuterContainer);

			if (stage.data("stretch-image")) {
				backgroundOuterContainer.append(backgroundInnerContainer);
				return backgroundInnerContainer;
			}

			return backgroundOuterContainer;
		},

		/**
		 * Thumbnail click event handler
		 * @param event Object
		 */
		handleThumbnailClick: function (event) {
			var mod = this,
				target = $(event.currentTarget);

			if (!target.hasClass('active')) {
				mod.slideshowCanceled = true;
				mod.activateSlideWithIndex(target.index());
				mod.trackInteraction(target.index());
			}
		},

		/**
		 * Entry to point to switch to a new slide. Checks if the background of the new slide
		 * is already loaded, if not load the background first. The success handler of the loadBackgroundImage will then
		 * continue the flow.
		 * Otherwise call animateToSlide with the next valid slide index.
		 * @param slideIndex
		 */
		activateSlideWithIndex: function (slideIndex) {
			var mod = this,
				index = mod.getNextLoadedSlideIndex(slideIndex);
			if (index !== null) {
				var nextBackgroundImage = mod.stageBackgroundImages.eq(index);

				mod.cancelSlideshowInterval();

				var tmpTag = nextBackgroundImage.find(".replacementVideoTag");
				if(tmpTag.length > 0) {
					mod.makeRealVideoTag(tmpTag);
				}

				if (nextBackgroundImage.find('img').attr('src') === '') {
					mod.loadBackgroundImage(index)
				}
				else {
					mod.animateToSlide(index);
				}



			}
		},


		/*
		*	Creates a real video tag from a dummy div tag to speed up loading if a lot of videos are used
		*/
		makeRealVideoTag : function(replaceTag) {
			var videoUrl = replaceTag.data("src");
            var newTag = '<video muted="muted" src="' + videoUrl + '" poster="' + replaceTag.find("img").data("imagesource") + '">' + replaceTag.html() + '</video>';
            newTag = $(newTag);
            newTag.on('ended', function () {
              this.load();
              this.play();
            });
			replaceTag.replaceWith(newTag);
		},


		/**
		 * Loads the new background image and calls the animate to slide method on success.
		 * @param index
		 */
		loadBackgroundImage: function (index) {
			var mod = this,
				nextBackground = mod.stageBackgroundImages.eq(index),
				backgroundImage = nextBackground.find('img');

			backgroundImage.on('load', function () {
				var backgroundIndex = index;
				mod.animateToSlide(backgroundIndex);
			}).attr('src', (backgroundImage.data('imagesource')));

			if (backgroundImage[0].complete) {
				backgroundImage.off('load');
				mod.animateToSlide(index);
			}
		},

		/**
		 * Animates to the slide at the provided index. Should not be called directly.
		 * To switch to a slide always call activateSlideWithIndex(the-index);
		 * @param nextSlideIndex int
		 */
		animateToSlide: function (nextSlideIndex) {
			var mod = this,
				currentBackground = mod.stageBackgroundImages.filter(function () {
					return $(this).css('opacity') == 1;
				}),
				thumbnailLink = mod.thumbnails.eq(nextSlideIndex),
				nextBackground = mod.stageBackgroundImages.eq(nextSlideIndex),
				slide = mod.slides.eq(nextSlideIndex),
				slideContent = slide.find('.product-offer-preview-slide');

			mod.thumbnails.filter('.active').removeClass('active');
			thumbnailLink.addClass('active');

			mod.stageBackgroundImages.css('z-index', 0);
			currentBackground.delay(mod.ANIMATION_DURATION).fadeTo(mod.ANIMATION_DURATION, 0);
			nextBackground.css('z-index', 1).fadeTo(mod.ANIMATION_DURATION, 1);

			if (!mod.isOldIE) {
				if (currentBackground.children().eq(0).is('video')) {
					currentBackground.children()[0].pause();
				}

				if (nextBackground.children().eq(0).is('video')) {
					nextBackground.children()[0].play();
				}
			}

			mod.slides.stop().hide();
			slide.show().fadeTo(0, 0).delay(mod.ANIMATION_DURATION * 1.3).fadeTo((mod.ANIMATION_DURATION * 1.3), 1);

			if (slideContent.hasClass('themeWhite')) {
				$('.scs-pageheader > div').removeClass('scs-pageheader-themeDark').addClass('scs-pageheader-themeWhite');
			}
			else {
				$('.scs-pageheader > div').addClass('scs-pageheader-themeDark').removeClass('scs-pageheader-themeWhite');
			}
			mod.fire('productOfferPreviewAnimation', {activePromoLabel: mod.promoLabelContainers.eq(nextSlideIndex), duration: mod.ANIMATION_DURATION});

			if (!mod.slideshowCanceled) {
				mod.setNextInterval();
			}

			// set the deeplink of the active tab.
			SCS.HashDeepLink.set(mod.DEEPLINK_MARKER, nextSlideIndex);
		},

		/**
		 * Event handler for the slideshow interval
		 */
		handleSlideShowInterval: function () {
			var mod = this,
				activeThumbnailIndex = mod.thumbnails.filter('.active').index(),
				nextBackgroundIndex = mod.getNextSlideIndex(activeThumbnailIndex);
			mod.activateSlideWithIndex(nextBackgroundIndex);
		},

		/**
		 * Sets a new Timeout with call back
		 */
		setNextInterval: function () {
			var mod = this;
			mod.cancelSlideshowInterval();
			mod.slideshowInterval = setTimeout($.proxy(mod.handleSlideShowInterval, mod), mod.slideshowIntervalDuration);
		},

		/**
		 * Cancel the slide show interval
		 */
		cancelSlideshowInterval: function () {
			var mod = this;
			clearTimeout(mod.slideshowInterval);
		},

		/**
		 * Event handler for the adServerContentLoaded event sent by adserver.js
		 * Expects that the ad-server call was successful, the new DOM is loaded but not yet injected into the document
		 * @param event Object
		 * @param data Object
		 */
		handleAdserverContentLoaded: function (event, data) {
			var mod = this,
				productOfferSlideData = mod.getQueuedAdserverSlideData(data.wpplaceholderid),
				loadedSlideDOM = data.content.find('.product-offer-preview-slide'),
				contentLoadedAtIndex = (productOfferSlideData) ? productOfferSlideData.index : loadedSlideDOM.closest('li').index(),
				backgroundImage = mod.stageBackgroundImages.eq(contentLoadedAtIndex),
				thumbnail = mod.thumbnails.eq(contentLoadedAtIndex);

			// replace the background image
			backgroundImage.find('img').attr('src', loadedSlideDOM.data('backgroundimage')).data('imagesource', loadedSlideDOM.data('backgroundimage'));

			// if the new slide has a video url
			if (loadedSlideDOM.data('videourl') && !mod.isMobile && !mod.isOldIE) {
				// and is alreay a video slide
				if (backgroundImage.find('video').length) {
					// just replace the video
					backgroundImage.find('video').attr('src', loadedSlideDOM.data('videourl'));
				}
				else {
					// otherwise inject the video dom
					backgroundImage.find('img').wrap('<video muted="muted" loop="loop" src="' + loadedSlideDOM.data("videourl") + '"></video>');
				}
			}

			thumbnail.find('img').attr('src', loadedSlideDOM.data('thumbnailimage'));
			thumbnail.find('span').text(loadedSlideDOM.data('thumbnaillabel'));
		},

		/**
		 * Event handler for the adServerContentComplete event sent by adserver.js
		 * Expects that the ad-server call was successful, and the new content is already injected into the dom
		 * @param event Object
		 * @param data Object
		 */
		handleAdserverContentComplete: function (event, data) {
			var mod = this,
				$ctx = mod.$ctx,
				productOfferSlideData = mod.getQueuedAdserverSlideData(data.wpplaceholderid),
				contentLoadedAtIndex = (productOfferSlideData) ? productOfferSlideData.index : data.content.closest('li').index(),
				thumbnail = mod.thumbnails.eq(contentLoadedAtIndex);

			mod.productOfferSlides = $ctx.find('.product-offer-preview-slide');
			mod.slides = $ctx.find('.slides > li');
			mod.promoLabelContainers = mod.slides.find('.modPromoLabel');

			// initialize all modules
			SCS.utils.initNewModules(mod.productOfferSlides.eq(contentLoadedAtIndex));

			// re-enable volume buttons
			mod.volumeButtons.off('click');
			mod.volumeButtons = $('.video-volume', mod.$ctx);
			mod.volumeButtons.on('click', $.proxy(mod.handleVideoVolume, mod));

			mod.dequeueAdserverSlide(data.wpplaceholderid);

			thumbnail.find('img').stop().fadeTo(mod.ANIMATION_DURATION, mod.THUMBNAIL_IMG_OPACITY, function () {
				$(this).removeAttr('style');
			});
			thumbnail.find('span').stop().fadeTo(mod.ANIMATION_DURATION, mod.THUMBNAIL_LABEL_OPACITY, function () {
				$(this).removeAttr('style');
				if (contentLoadedAtIndex === 0) {
					mod.startWithSlide(0, true);
				}
			});
		},

		/**
		 * Event handler for the adServerContentFailed event sent by adserver.js
		 * Expects that the ad-server call did not work, hence we display the fall back contents
		 * @param event Object
		 * @param data Object
		 */
		handleAdserverContentFailed: function (event, data) {
			var mod = this,
				fallBackSlideData = null;

			// only proceed if the original DOM that made the ad-server call is still attached to the document
			if (data.origin.parent().length > 0) {
				fallBackSlideData = mod.getQueuedAdserverSlideData(data.wpplaceholderid);

				if (fallBackSlideData) {
					mod.dequeueAdserverSlide(data.wpplaceholderid);

					mod.thumbnails.eq(fallBackSlideData.index).find('img').fadeTo(mod.ANIMATION_DURATION, mod.THUMBNAIL_IMG_OPACITY, function () {
						$(this).removeAttr('style')
					});
					mod.thumbnails.eq(fallBackSlideData.index).find('span').fadeTo(mod.ANIMATION_DURATION, mod.THUMBNAIL_LABEL_OPACITY, function () {
						$(this).removeAttr('style')
					});
					mod.productOfferSlides.eq(fallBackSlideData.index).fadeTo(mod.ANIMATION_DURATION, 1, function () {
						if (fallBackSlideData.index === 0) {
							mod.startWithSlide(0, true);
						}
					});
				}
			}
		},

		/**
		 * Video Volume event handler
		 * Turns volume on corresponding video on and turns the volume for all other videos off
		 * Updates all volume indicators on the page.
		 */
		handleVideoVolume: function (event) {
			var mod = this,
				volumeButton = $(event.currentTarget),
				volumeOn = volumeButton.find('.video-volume-on'),
				volumeOff = volumeButton.find('.video-volume-off'),
				slideIndex = volumeButton.closest('li').index();

			if (volumeOn.hasClass('hidden')) {
				mod.stageBackgroundImages.eq(slideIndex).find('video')[0].muted = true;
				volumeOn.removeClass('hidden');
				volumeOff.addClass('hidden');
			}
			else {
				mod.stageBackgroundImages.eq(slideIndex).find('video')[0].muted = false;
				volumeOff.removeClass('hidden');
				volumeOn.addClass('hidden');
			}
		},

		/**
		 * Hides the contents of a slide for the purpose of waiting for its alternate contents from the adserver
		 * @param index int
		 */
		hideSlide: function (index) {
			var mod = this;

			mod.thumbnails.eq(index).find('img, span').fadeTo(0, 0);
			mod.productOfferSlides.eq(index).fadeTo(0, 0);

			if (mod.stageBackgroundImages) {
				mod.stageBackgroundImages.eq(index).fadeTo(0, 0);
			}
		},

		/**
		 * Retrieves the information about the product offer slide that is in the
		 * adserver queue that has the provided
		 * @param wpplaceholderid String
		 * @returns {*}
		 */
		getQueuedAdserverSlideData: function (wpplaceholderid) {
			var mod = this,
				productOfferSlide = null;

			for (var i = 0, length = mod.adServerSlides.length; i < length; i++) {
				if (mod.adServerSlides[i].wpplaceholderid.toString() === wpplaceholderid.toString()) {
					productOfferSlide = mod.adServerSlides[i];
					break;
				}
			}

			return productOfferSlide;
		},

		/**
		 * Removes one item out of the Adserver Queue
		 * @param wpplaceholderid String
		 */
		dequeueAdserverSlide: function (wpplaceholderid) {
			var mod = this;

			for (var i = 0, length = mod.adServerSlides.length; i < length; i++) {
				if (mod.adServerSlides[i].wpplaceholderid.toString() === wpplaceholderid.toString()) {
					mod.adServerSlides.splice(i, 1);
					break;
				}
			}
		},

		/**
		 * Returns the index of the next completely loaded slide of the current slide.
		 * @param slideIndex int
		 * @returns int
		 */
		getNextLoadedSlideIndex: function (slideIndex) {
			var mod = this,
				loopCount = 0,
				i = 0,
				adServerLength = mod.adServerSlides.length,
				thumbnailLength = mod.thumbnails.length,
				indexValid = false;

			// in case no slides have loaded yet, abort
			if (adServerLength === thumbnailLength) return null;

			if (mod.adServerSlides.length) {
				while (!indexValid && loopCount < thumbnailLength) {
					indexValid = true;
					for (i = 0; i < adServerLength; i++) {
						if (slideIndex === mod.adServerSlides[i].index) {
							indexValid = false;
							slideIndex = mod.getNextSlideIndex(slideIndex);
							break;
						}
					}

					loopCount++;
				}
			}
			return slideIndex;
		},

		/**
		 * Get the next valid slide index.
		 * @param currentIndex int
		 * @returns int
		 */
		getNextSlideIndex: function (currentIndex) {
			var mod = this;
			return ((currentIndex + 1) < mod.thumbnails.length ) ? (currentIndex + 1) : 0;
		},

		trackInteraction: function (index) {
			var siteCatalyst = window.s || window.s_one;
			if (siteCatalyst && siteCatalyst.pageName && siteCatalyst.channel && siteCatalyst.prop21 && siteCatalyst.t) {
				siteCatalyst.linkTrackVars = 'pageName,channel,prop18,prop19,prop20,prop21,prop39,evar14';
				siteCatalyst.pageName = siteCatalyst.pageName + "/" + this.TRACKING_PHRASE + index;
				siteCatalyst.channel = siteCatalyst.channel + "/" + this.TRACKING_PHRASE + index;
				siteCatalyst.prop21 = siteCatalyst.prop21 + ":" + this.TRACKING_PHRASE + index;
				siteCatalyst.t('virtual pageview');
			}
		}
	});
}(Tc.$));
}.call(window));

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_Tc_dot_$) {/*** IMPORTS FROM imports-loader ***/
var loadTerrific = __webpack_require__(1);
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function($, Module) {
	'use strict';

	/**
	 *
	 * Subscribes to channels: [EcommerceProductDataHub]
	 * Listens to channel events: [startProductDataSubscription, invalidateProductData]
	 * Triggers channel events: [subscribeForProductData]
	 *
	 * @namespace Tc.Module
	 * @class PromoBadge
	 * @extends Tc.Module
	 */
	Module.PromoBadge = Module.extend({

		on: function(callback) {
			/*
			  ATTENTION
			  This module is auto-initialized only, if the component configured to use a E-Commerce Data Hub
			  to retrieve its data. Otherwise this component does not require JS to function properly.
			 */
			var	mod = this;

			mod.$textfield = mod.$ctx.find('.textfield');
			mod.defaultText = mod.$textfield.text();

			callback();
		},

		after: function() {
			this.sandbox.application.registry.EcommerceProductDataHub.module.simpleSubscribe(this, this.gotDataFromHub);
		},

		/**
		 * Channel listener which gets called by EcommerceProductDataHub to notify about data changes.
		 *
		 * @method onInvalidateProductData
		 * @param {Object} data See EcommerceProductDataHub for details about the structure
		 * @return void
		 */
		gotDataFromHub: function(info) {
			var mod = this;
			var promotion = null;
			if(info && info.product) {
				var promos = info.product.getApplicablePromotions(
					info.subscriptionId,
					info.subscriptionDuration,
					info.subscriptionType
				).filter(function(promo) {
					return promo.isCallout();
				});
				promotion = promos[0];
			}

			if(!promotion) {
				if (!$('body').hasClass('cq_isEditMode')) {
					mod.$ctx.addClass('hidden');
				} else {
					mod.$textfield.text(mod.defaultText);
				}
				return;
			}

			mod.$textfield.text(promotion.getName());
			mod.$ctx.removeClass('hidden');
		}
	});

}(__webpack_provided_window_dot_Tc_dot_$, window.Tc.Module));
}.call(window));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var loadTerrific = __webpack_require__(1);
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function ($) {
	'use strict';
	/*globals Tc */

	/**
	 * PromoLabel
	 *
	 * @author Matthias Inauen
	 * @namespace Tc.Module
	 * @class PromoLabel
	 * @extends Tc.Module
	 */
	Tc.Module.PromoLabel = Tc.Module.extend({

		on: function (callback) {
			var mod = this,
				$ctx = mod.$ctx;
			// initialize if its a product offer preview promo label.
			if ($ctx.hasClass('productofferpreview')) {
				// resize the h2 if they are too long
				$ctx.find('h2').each(function () {
					if (!$(this).hasClass('smallheader') && $(this).text().length > 5) {
						$(this).addClass('smallheader');
					}
				});
			}

			callback();
		},

		onProductOfferPreviewAnimation: function (data) {
			var $ctx = this.$ctx;

			if (data.activePromoLabel.is($ctx) && !$ctx.data('animation-disabled')) {

				$ctx.addClass('notransition').slideUp(0).delay(data.duration * 1.8).slideDown(data.duration * 0.8, $.proxy(this.enableCssTransitions, this));
			}
		},

		enableCssTransitions: function () {
			this.$ctx.removeClass('notransition');
		}
	});
}(Tc.$));
}.call(window));

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_Tc_dot_$) {/*** IMPORTS FROM imports-loader ***/
var loadTerrific = __webpack_require__(1);
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function ($, Module, w, SCS, scsHeader) {
	'use strict';

	var deparam = __webpack_require__(8).default;

	/**
	 * Rating form component
	 *
	 * @author Branislav Maksin
	 * @namespace Tc.Module
	 * @class RatingsForm
	 * @extends Tc.Module
	 */
	Module.RatingForm = Module.extend({
		// Shortcut. True if the view mode is mobile.
		isMobile: false,

		// The product family model instance
		family: null,

		/**
		 * Module vars
		 */

		/**
		 * Does all the work.
		 *
		 * @method on
		 * @param {Function} callback function
		 * @return void
		 */
		on: function (callback) {
			var mod = this;

			mod.isMobile = SCS.utils.isMobilePage();

			// Rating select
			mod.ratingStarSelect();

			// Subscribe to products private channel and get data
			mod.sandbox.subscribe('dynamicProducts', mod);
			mod.sandbox.subscribe('rarev', mod);

			mod.$subRatingsWrapper = mod.$ctx.find('.sub-ratings-wrapper');

			mod.createEventHandler();

			this.sandbox.application.registry.EcommerceProductDataHub.module.simpleSubscribe(mod, mod.updateFamily);

			callback();
		},

		createEventHandler: function () {
			var mod = this;
			mod.$form = mod.$ctx.find('.modScForm > form');
			// Submit rating
			mod.$form.on('submit', $.proxy(mod.onSubmit, mod));

			// Cancel rating
			mod.$form.on('reset', $.proxy(mod.onCancel, mod));
		},

		// Submit rating
		onSubmit: function (e) {
			var mod = this;
			e.preventDefault();
			e.stopImmediatePropagation();

			if (mod.validateForm()) {
				mod.$form.find('.button-indent').addClass('scs-loadingRotator');
				mod.postReview();
			}
		},

		// Cancel rating
		onCancel: function (e) {
			var mod = this;
			e.preventDefault();

			if (mod.isMobile) {
				if (mod.mobileDialog) {
					mod.mobileDialog.close();
				}
			} else {
				mod.$ctx.dialog('close');
			}

			mod.onAddTracking('cancel');
		},

		/**
		 * Callback function from hub
		 * @param subRatingCategories
		 */
		updateFamily: function updateFamily(data) {
			var mod = this;

			var family = mod.family = data.family;
			var id = family.getId();
			var ratings = family.getRatings();
			if(!ratings.loaded()) {
				// Register callback for when rating data is loaded
				ratings.load().done($.proxy(updateFamily, mod, data));
				return;
			}

			// Add first product ID
			if(!id) {
				mod.log('Data from overview module doesn’t have product ID');
				return false;
			}

			mod.setTitle(family.getFamilyName());

			// Update subrating categories
			var categories = ratings.getSubRatingCategories().getCategories();
			mod.updateSubratingCategories(categories);

			// Show form button
			mod.fire('showFormButton', {show: !mod.checkPreviousRatings(id)}, ['dynamicProducts']);
		},

		updateSubratingCategories: function(categories) {
			var $ctx = this.$ctx;

			$ctx.find('.sub-ratings-wrapper > a').remove();
			$ctx.find('.sub-ratings-wrapper').addClass('hidden');

			if(!categories.length) {
				return;
			}

			var $subRatings = $(document.createDocumentFragment());
			var $star = $('<span/>', {'class': 'empty'});

			$.each(categories, function(i, category) {
				var $stars = $([1, 2, 3, 4, 5].map(function() {
					return $star.clone()[0];
				}));
				var $category = $('<a/>', {
					prop: {
						href: '#'
					},
					'class': 'rating-stars sub-ratings',
					data: {
						subratingId: category.getId()
					}
				});
				$category.append($stars).append($('<span/>').text(category.getName()||''));
				if(this.isMobile) {
					$category = $category.wrap('<span/>');
				}
				$subRatings.append($category[0]);
			});

			$ctx.find('.sub-ratings-wrapper').removeClass('hidden').append($subRatings);
		},

		/**
		 * Get data from overview module and prepare form
		 *
		 * @param formData {Object} Object data from overview module
		 */
		onGetDataFromParent: function(data) {
			this.setTitle(data.title);
		},

		setTitle: function(title) {
			var $title = this.$ctx.find('h2 > span');
			if(!title) {
				$title.text('');
			} else {
				$title.text(' '+title);
			}
		},

		/**
		 * Happens when opening the form
		 *
		 * @param @button {Object} Open form button
		 */
		onOpenRatingForm: function () {
			var mod = this,
				dialogTitle = mod.$ctx.data('dialog-title');

			if (mod.isMobile) {

				mod.mobileDialog = SCS.createNewMobilePage({
					content: mod.$ctx.removeClass('hidden'),
					cssClass: 'rating-form',
					noContentInit: true,
					destroyOnClose: true,
					reuseContent: true
				});

				mod.resetFormValidation();

			} else {
				mod.resetFormValidation();
				mod.$ctx.dialog({
					width: 470,
					maxWidth: 470,
					classes: {'ui-dialog': 'rating-form'},
					title: dialogTitle
				});
			}
		},

		/**
		 * Rating stars selection method
		 */
		ratingStarSelect: function () {
			var mod = this,
				$ctx = mod.$ctx;


			if (mod.isMobile) {
				$ctx.on('click', '.rating-stars > .empty', function (e) {
					e.stopPropagation();
					e.preventDefault();
					var $star = $(this),
						$starParent = $star.parent();

					$starParent.children().removeClass('click');

					// Add star number to parent data
					$starParent.data('product-rating', $star.index() + 1);

					// Finally add click class
					$star.addClass('click');

					$star.prevAll().addClass('selected');
					$star.addClass('selected');
					$star.nextAll().removeClass('selected');

				});
			} else {
				$ctx.on('mouseenter', '.rating-stars > .empty', function (e) {
					e.stopPropagation();
					var $star = $(this),
						$previousStars = $star.prevAll(),
						$nextStars = $star.nextAll();

					$previousStars.addClass('selected');
					$nextStars.removeClass('selected');

				});

				$ctx.on('mouseleave', '.rating-stars > .empty', function (e) {
					e.stopPropagation();
					var $star = $(this),
						$parent = $star.parent(),
						$selected = $parent.find('.click');

					$parent.children().removeClass('selected');


					if ($selected && $selected.length) {
						$selected.prevAll().addClass('selected');
						$selected.addClass('selected');
						$selected.nextAll().removeClass('selected');
					}

				});

				$ctx.on('click', '.rating-stars > .empty', function (e) {
					e.stopPropagation();
					e.preventDefault();
					var $star = $(this),
						$starParent = $star.parent();

					$starParent.children().removeClass('click');

					// Add star number to parent data
					$starParent.data('product-rating', $star.index() + 1);

					// Finally add click class
					$star.addClass('click');
				});
			}


		},

		/**
		 * Validates comment form
		 *
		 * @param $submitButton {Object} Form submit button
		 */
		validateForm: function () {
			var $ctx = this.$ctx,
				$ratingSelect = $ctx.find('.rating-select > a'),
				$fields = $ctx.find('.modScForm form > .field'),
				validates = true,
				clientValidation,
				clientValidationInstance;

			// Check rating selection
			if (isNaN(parseInt($ratingSelect.data('product-rating'), 10))) {
				$ratingSelect.addClass('error');
				validates = false;
			} else if ($ratingSelect.hasClass('error')) {
				$ratingSelect.removeClass('error');
			}

			// Check for form input fields
			for (var i = 0, ii = $fields.length; i < ii; i += 1) {
				var $field = $fields.eq(i),
					$inputs = $field.find('input[data-validate!="false"], textarea[data-validate!="false"]'),
					val = $inputs.val(),
					type = $inputs.attr('type');

				clientValidation = w.ScForm.createClientValidation($field.data('clientvalidation'));
				$field.data('invalid', false);

				if (type === 'radio') {
					clientValidationInstance = clientValidation.
						validateRadioGroup($field.find('input:radio:checked').length);
				} else {
					clientValidationInstance = clientValidation.validate(val);
				}

				if (clientValidationInstance.isValid) {
					$field.find('input, textarea').removeClass('error-field');
					$field.removeClass('error');
					$field.find('.error').addClass('hidden');
					$field.data('invalid', false);
				} else {
					$field.find('.error').html(clientValidation.constraintMessage).removeClass('hidden');
					$field.find('input, textarea').addClass('error-field');
					$field.addClass('error');
					$field.data('invalid', true);
					validates = false;
				}
			}

			return validates;
		},


		resetFormValidation: function () {
			var $ctx = this.$ctx;
			$ctx.find('.modScForm > .field').removeClass('error');
			$ctx.find('input, textarea').removeClass('error-field');
			$ctx.find('.rating-select > a').removeClass('error');
			$ctx.find('.error').addClass('hidden');

		},

		/**
		 * Prepare data fro eCommerce
		 */
		// FIXME NEC: Adapt to new endpoint
		postReview: function () {
			var mod = this,
				$ctx = mod.$ctx,
				$ratingSelect = $ctx.find('.rating-select > a');

			var data = deparam(mod.$form.serialize());

			var postData = {
				// FIXME NEC: Is there a spec for this? Rating seems to be an integer [10..50]
				rating: parseInt($ratingSelect.data('product-rating'), 10) * 10,
				productId: mod.family.getId(),
				firstName: data.FirstName,
				lastName: data.LastName,
				email: data.Email,
				comment: data.Comment,
				date: w.moment().format('YYYY-MM-DDTHH:mm:ssZZ'),
				// FIXME NEC: Route this through
				ipAddress: '0.0.0.0',
				language: $('html').attr('lang'),
				headline: data.Title,
				// FIXME NEC: Use correct enum values
				recommended: data.Recommendation,
				subratings: $ctx.find('.sub-ratings-wrapper > a').map(function() {
					var $subRatings = $(this);
					return {
						category: {
							id: $subRatings.data('subrating-id')
						},
						// FIXME NEC: Is there a spec for this? Rating seems to be an integer [10..50]
						rating: parseInt($subRatings.data('product-rating'), 10) * 10
					};
				}).get().filter(function(subrating) {
					return !!subrating.rating;
				})
			};

			// Finally send the data to eCommerce
			mod.sendData(postData);
		},

		/**
		 * Post rating & review to eCommerce
		 *
		 * @param data {Object}
		 */
		sendData: function (data) {
			var mod = this,
				$ctx = mod.$ctx;

			var endpoint = SCS.utils.formatString(mod.$form.attr('action'), mod.family.getId());

			var $error = $ctx.find('.headingError');
			var $errorMsg = $error.find('> .msg');

			// Send the data
			$.ajax({
				url: endpoint,
				type: 'POST',
				dataType: 'json',
				contentType: 'application/json',
				data: w.JSON.stringify(data),
				success: function() {
					mod.checkPreviousRatings(data.productId, true);
					mod.onAddTracking('save');
					mod.resetForm();
					mod.fire('formSuccessSubmit', {}, ['dynamicProducts']);
					mod.fire('showFormButton', {
						show: false,
						success: true
					}, ['dynamicProducts']);

					// Hide form
					if (mod.isMobile) {
						if (mod.mobileDialog) {
							mod.mobileDialog.close();
						}
					} else {
						$ctx.dialog('close');
					}
				},
				error: function (jqXHR) {
					var response;
					mod.log('Got error response', arguments);
					$error.removeClass('hidden');
					try {
						response = $.parseJSON(jqXHR.responseText).Error;
					} catch(e) {}
					if (response) {
						$errorMsg.html('<ul><li>' + response.Messages.join('</li><li>') + '</li></ul>');
					} else {
						$errorMsg.text($ctx.find('.modScForm').data('error-message'));
					}
				},
				statusCode: {
					409: function conflict() {
						mod.log('Got conflict response', arguments);
						// Conflict means the user has already submitted a review
						$errorMsg.text($ctx.data('error-message-duplicate-submit'));
					}
				},
				complete: function () {
					$ctx.find('.button-indent').removeClass('scs-loadingRotator');
				}
			});
		},

		/**
		 * Get updated product data from PMF
		 *
		 * @param productID {Integer} Product ID that visitor want to leave a r&r
		 * @param set {Boolean} Do we need to set product flag into storage
		 *
		 * @return {Boolean] Have visitor rated this product before
		 */
		checkPreviousRatings: function (productID, set) {
			if (!w.localStorage) {
				// Check does browser support local storage
				return false;
			}

			var productRatings = localStorage.getItem('scs-productRatings') || '{}';
			productRatings = w.JSON.parse(productRatings) || {};

			// Check do we need to set product flag
			if(set) {
				productRatings[productID] = true;
				// Sat data into storage
				localStorage.setItem('scs-productRatings', w.JSON.stringify(productRatings));
			}

			return productID in productRatings;
		},

		/**
		 * Reset form on successful rating submit
		 */
		resetForm: function () {
			var mod = this,
				$ctx = mod.$ctx;

			// Reset rating selection
			$ctx.find('.rating-stars > span').removeClass('selected click');

			// Reset title, comment and recommendation
			$ctx.find('input[name=Title], textarea[name=Comment]').val('');
			$ctx.find('input[name=Recommendation]').prop('checked', false);
			$ctx.find('label[for^=Recommendation]').removeClass('checked');
		},

		/**
		 * Track events in form
		 *
		 * @param action {String} Action to track
		 */
		onAddTracking: function (action) {
			// jshint camelcase: false
			var mod = this;


			mod.trackingTealium(action);
		},

		/**
		 * Tealium tracking
		 *
		 * @param action {String} Action to track
		 */
		trackingTealium: function (action) {
			// jshint camelcase: false
			SCS.portal.datalayer.trackEvent(action, 'r_ratingstars', 'content', 'Rating');
		}
	});


})(__webpack_provided_window_dot_Tc_dot_$, window.Tc.Module, window, window.SCS = window.SCS || {}, window.scsHeader = window.scsHeader || {});

}.call(window));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_Tc_dot_$) {/*** IMPORTS FROM imports-loader ***/
var loadTerrific = __webpack_require__(1);
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function($, Module, w, SCS) {
	'use strict';
	/**
	 * Rating stars component
	 *
	 * @author Branislav Maksin
	 * @namespace Tc.Module
	 * @class RatingsStars
	 * @extends Tc.Module
	 */
	Module.RatingStars = Module.extend({

		/**
		 * Does all the work.
		 *
		 * @method on
		 * @param {Function} callback function
		 * @return void
		 */
		on: function(callback) {
			var mod = this;
			var $ctx = mod.$ctx;

			mod.$ratingStarsWrapper = $ctx.find('.rating-stars');
			mod.$flyOut = $ctx.find('> .flyOut');

			// Product JSON data
			mod.summaryData = null;

			this.sandbox.application.registry.EcommerceProductDataHub.module.simpleSubscribe(mod, mod.processData);

			callback();
		},

		after: function() {},

		/**
		 * Process products IDs and get products JSONs data
		 *
		 */
		processData: function processData(data) {
			var mod = this;

			if(mod.initialized){
				return;
			}

			var family = data.family;
			var ratings = family.getRatings();
			if(!ratings.loaded()) {
				// Register callback for when rating data is loaded
				ratings.load().done($.proxy(processData, mod, data));
				return;
			}

			mod.initialized = true;

			mod.family = family;

			if(!family) {
				mod.log('Module doesn’t have any IDs');
				mod.$ctx.removeClass('scs-loadingRotator').addClass('error');
				return;
			}

			if(mod.$ctx.hasClass('error')){
				mod.$ctx.removeClass('error').addClass('scs-loadingRotator');
			}

			var summary = ratings.getSummary();

			mod.showRatingSummary(summary);

			mod.$ctx.removeClass('scs-loadingRotator');

		},

		/**
		 * Insert the summary data into DOM elements
		 *
		 * @param summaryData {Object} Final summary data
		 */
		showRatingSummary: function(summaryData) {
			var mod = this,
				$ctx = mod.$ctx;

			var $flyOut = mod.$flyOut;

			var count = summaryData.count();
			var rating = summaryData.getAverage(true);

			// Set the rating star summary
			var $ratingStars = mod.$ratingStarsWrapper.find('> span');
			$ratingStars.addClass('empty').filter(':lt(' + rating + ')').removeClass('empty');
			$ratingStars.filter(':last-child').text('(' + (count || 0) + ')');

			if(!count) {
				mod.log('no ratings yet!');
				return;
			}

			// Check if we are on product detail page
			if ($ctx.hasClass('rating-details')) {
				mod.addClickEvent();

				if ($flyOut.length) {
					// Set fly out ratings
					$flyOut.find('> ul').each(function() {
						var $flyOutRatings = $(this).find('> li');
						var $link = $flyOutRatings.find('a');
						var stars = $link.data('stars');
						var starCount = summaryData.count(stars);
						$flyOutRatings.find('> span').width(((starCount / count) * 100) + '%');
						$flyOutRatings.filter(':last-child').text('(' + starCount + ')');
						if(!starCount){
							$link.addClass('disabled');
						}
					});

					mod.addFlyOut(mod.$ratingStarsWrapper, $flyOut);
				}
			}
		},

		/**
		 * Add fly out tooltip on mouse over event
		 *
		 * @param $ratingStars {Object} Rating star element
		 * @param $flyOut {Object} Fly out element
		 */
		addFlyOut: function ($ratingStars, $flyOut) {
			var mod = this,
				flyOutPosition = {};

			// Select proper position
			switch (mod.$ctx.data('flyout-position')) {
				case 'top':
					flyOutPosition.my = 'bottom center';
					flyOutPosition.at = 'top center';
					flyOutPosition.adjustY = 16;
					flyOutPosition.adjustX = 0;
					break;

				case 'right':
					flyOutPosition.my = 'left center';
					flyOutPosition.at = 'right center';
					flyOutPosition.adjustY = 0;
					flyOutPosition.adjustX = 5;
					break;

				case 'left':
					flyOutPosition.my = 'right center';
					flyOutPosition.at = 'left center';
					flyOutPosition.adjustY = 0;
					flyOutPosition.adjustX = -5;
					break;

				default:
					flyOutPosition.my = 'top center';
					flyOutPosition.at = 'bottom center';
					flyOutPosition.adjustY = -18;
					flyOutPosition.adjustX = 0;
			}

			// Start qtip2 plugin
			$ratingStars.qtip({
				position: {
					my: flyOutPosition.my,
					at: flyOutPosition.at,
					viewport: $(window),
					target: $ratingStars,
					adjust: {
						scroll: false,
						y: flyOutPosition.adjustY,
						x: flyOutPosition.adjustX,
						method: 'none flipinvert'
					},
					effect: function(api, pos) {
						$(this).animate(pos, {
							duration: 250,
							easing: 'linear',
							queue: false
						});
					}
				},
				content: {
					text: $flyOut
				},
				hide: {
					fixed: true,
					delay: 400
				},
				style: {
					classes: 'modRatingStars',
					tip: {
						width: 16,
						border: 2
					}
				}
			});
		},

		/**
		 * Add click event to open rating and review tab
		 *
		 * @param $ratingStars {Object} Rating summary element
		 */
		addClickEvent: function () {
			var mod = this,
				$ctx = mod.$ctx,
				tabNavigationName = $ctx.data('navigation-name'),
				$tabNavigation = $('.modTabNavigation[data-name="' + tabNavigationName + '"], .modSDXTabs'),
				tabNavigationOrder = parseInt($ctx.data('rating-tab')),
				$tabNavigationContent,
				$tabNavigationTab;

			// Check if tab bar exists
			if(!$tabNavigation.length) {
				return;
			}

			$tabNavigationTab = $tabNavigation.find('.tab-navigation-tab:nth-child(' + tabNavigationOrder + '), [data-panel="ratings"]');
			$tabNavigationContent = $tabNavigation.find('.modTabNavigationContent:nth-child(' + tabNavigationOrder + ')');
			if ($tabNavigationContent.length === 0) {
				$tabNavigationContent = $('.section .ratings');
			}

			// Add click event to open and scroll to review tab content
			if(!$tabNavigationTab.length) {
				return;
			}

			mod.$ratingStarsWrapper.addClass('click');
			mod.$ratingStarsWrapper.on('click', function(e) {
				e.preventDefault();

				var currentScrollTop = $('body').scrollTop();

				$('.content-reset-button:visible:eq(0)').trigger('click');
				$tabNavigationTab.trigger('click');

				if (!SCS.utils.isMobilePage()){
					// Scroll to ratings tab content
					$('html, body').animate({
						scrollTop: $tabNavigationContent.offset().top
					}, 800);
				} else {
					$('html, body').scrollTop(currentScrollTop);
				}

				// Tracking
				mod.addTracking();
			});
			mod.$flyOut.on('click', '.label a', function(event) {
				event.preventDefault();

				var $link = $(this);
				if($link.is('.disabled')) {
					// Do nothing
					return;
				}
				var stars = $link.data('stars');

				mod.$ratingStarsWrapper.qtip('toggle', false);
				mod.$ratingStarsWrapper.trigger('click');

				SCS.HashDeepLink.set('rating-list-stars', stars, '&');
				mod.fire('setRatingListFilter', {}, ['rarev']);
			});
		},
		/**
		 * Track the fly out opening event
		 */
		addTracking: function () {

			// jshint camelcase: false
			var mod = this;
			mod.trackingTealium();
		},

		/**
		 * Tealium tracking
		 */
		trackingTealium: function () {
			// jshint camelcase: false
			SCS.portal.datalayer.trackEvent('click', 'r_ratingstars', 'content', 'Rating');
		}
	});
})(__webpack_provided_window_dot_Tc_dot_$, window.Tc.Module, window, window.SCS);

}.call(window));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_Tc_dot_$) {/*** IMPORTS FROM imports-loader ***/
var loadTerrific = __webpack_require__(1);
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function (Tc, $, debug) {
	'use strict';

	/**
	 * Richtext
	 *	- Copy class to headlines that contain a spitzmarke, so that the margins can be removed
	 *
	 * Used for Desktop and Mobile
	 *
	 * @author Cesar Keller
	 */
	Tc.Module.RichText = Tc.Module.extend({

		on: function (callback) {
			var $ctx = this.$ctx;

			var $spitzmarke = $ctx.find('.scs-spitzmarke-dachzeile');
			if ($spitzmarke.length) {
				$spitzmarke.closest('h2, h3, h4, h5').addClass('scs-spitzmarke-dachzeile');
				debug.log('Tc.Module.Richtext > found scs-spitzmarke-dachzeile', $spitzmarke.length);
			}
			callback();
		},

		after: function() {
			var hasSensitiveData = this.$ctx.data('has-sensitive-data');

			if (hasSensitiveData) {
				this.hideSensitiveData();
			}
		},

		hideSensitiveData: function() {
			this.$ctx.find('*').addClass('ctHidden');
		}
	});
}(window.Tc, __webpack_provided_window_dot_Tc_dot_$, window.debug));

}.call(window));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_Tc_dot_$) {/*** IMPORTS FROM imports-loader ***/
var loadTerrific = __webpack_require__(1);
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function ($, Tc, SCS, debug, doT) {
	'use strict';

	/**
	 * RoamingTariff module implementation.
	 *
	 * @author Danijel Basic
	 * @namespace Tc.Module
	 * @class RoamingTariff
	 * @extends Tc.Module
	 */
	Tc.Module.RoamingTariff = Tc.Module.extend({

		cache : {
			countryListUrl : '/country/list',
			subscriptionsUrl : '/subscription/list/subscription/scat',
			pricesUrl : '/prices/search',
			operatorsUrl : '/operator/list',
			renderAsList : 'DATA',
			SERVICE_CAMEL : 'CAMEL',
			SERVICE_LTE : 'LTE (4G)',
			SERVICE_FIVE : 'FIVE (5G)',
			SERVICE_GPRS : 'GPRS (2G)',
			SERVICE_GSM : 'GSM',
			SERVICE_UMTS : 'UMTS (3G)',
			SERVICE_SMS : 'SMS',
			SERVICE_MMS : 'MMS',
			SERVICE_SMS_IW : 'SMS IW',
			SERVICE_VOICE : 'VOICE',
			SERVICE_DATA : 'DATA',
			SERVICE_INCOMING : 'incoming',
			SERVICE_OUTGOING : 'outgoing',
			SERVICE_OUTGOING_NO_PREPAID : 'outgoingNoPrepaid',
			FREQ_GSM_UMTS : 'GSM_UMTS',
			FREQ_GPRS : 'GPRS',
			FREQ_LTE : 'LTE',
			FREQ_FIVE : 'FIVE',
			FREQ_UMTS : 'UMTS'
		},

		/**
		 * Hook function to do all of your module stuff.
		 *
		 * @method on
		 * @param {Function} callback function
		 * @return void
		 */
		on: function (callback) {
			var mod = this;
			debug.log('Tc.Module.RoamingTariff > on');

			mod.$countryField = mod.$ctx.find('#roatCountry');
			mod.$subscriptionField = mod.$ctx.find('#roatSubscription');
			mod.$singleSubscriptionField = mod.$ctx.find('.singleSubscription');
			mod.lang = mod.$countryField.data('language');
			mod.isMobile = SCS.utils.isMobilePage();
			mod.$baseUrl = mod.$ctx.data('appurl');
			mod.hideRoamingPartner = mod.$ctx.data('hideroatpartner');
			mod.$pars = mod.$ctx.find('.rt-par-container');
			mod.initFilter();
			callback();
		},

		initFilter: function () {
			this.loadCountries();
			this.loadSubscriptions();

			// attach onClick handler
			var mod = this;
			var $ctx = mod.$ctx;
			$('.primary-button', $ctx).click(function (evt) {
				evt.preventDefault();
				mod.getRoamingTariffs();
			});
		},

		loadCountries: function () {
			var mod = this;

			$.ajax({
				url: mod.$baseUrl + mod.cache.countryListUrl + '/' + mod.lang,
				type: 'post'
			}).done(function (data) {
				mod.renderTemplate(data, 'script.tmpl-roat-country', mod.$countryField, true);
				if (!mod.isMobile) {

					var $allAboInfoIdsContainer = mod.$ctx.find('#allAboInfoIdsContainer');
					if ($allAboInfoIdsContainer.length > 0) {
						var hiddenId = 'hidden_field_id';

						var $hiddenField = mod.$ctx.find('input[type="hidden"]');
						if ($hiddenField.length > 0) {
							hiddenId = $hiddenField.attr('id');
						}
						var expressionsHtml = '';
						for (var i=0; i < data.allAboInfoIds.length; i+=1) {
							expressionsHtml += 'containsWord(&#36;&#123;' + hiddenId + '&#125;, &#39;' + data.allAboInfoIds[i] + '&#39;) <br>';
						}
						$allAboInfoIdsContainer.html(expressionsHtml);
					}

					mod.$countryField.resetSS();
				}
			}).fail(function (jqXHR) {
				debug.log('Tc.Module.RoamingTariff country AJAX error: ' + jqXHR.responseText);
			});
		},

		loadSubscriptions: function () {
			var mod = this,
				subscriptionCategories = mod.$subscriptionField.data('subscription-categories');

			$.ajax({
				url: mod.$baseUrl + mod.cache.subscriptionsUrl + '?' + mod.convertToQueryParam(subscriptionCategories) + '&lang=' + mod.lang,
				type: 'post'
			}).done(function (data) {
				if (data !== null && data.length === 1) {
					mod.$singleSubscriptionField.text(data[0].name);
					mod.$singleSubscriptionField.attr('value', data[0].id);
					mod.$subscriptionField.addClass('hidden');
					mod.$ctx.find('.dropdown-sub .newListSelected').addClass('hidden');
					mod.$singleSubscriptionField.removeClass('hidden');
				} else {
					mod.renderTemplate(data, 'script.tmpl-roat-subscription', mod.$subscriptionField, true);
					mod.$singleSubscriptionField.addClass('hidden');
					mod.$subscriptionField.removeClass('hidden');
					mod.$ctx.find('.dropdown-sub .newListSelected').removeClass('hidden');
					if (!mod.isMobile) {
						mod.$subscriptionField.resetSS();
					}
				}
			}).fail(function (jqXHR) {
				debug.log('Tc.Module.RoamingTariff subscriptions AJAX error: ' + jqXHR.responseText);
			});
		},

		convertToQueryParam: function(sCat) {

			var sCatArr = sCat.split(',');
			var sCatQuery = '';

			if (sCatArr !== null && sCatArr.length > 0) {
				for (var i = 0; i < sCatArr.length; i+=1) {
					var sCat1 = sCatArr[i];
					if (i > 0) {
						sCatQuery += '&';
					}
					sCatQuery += 'subscriptionCategories=';
					sCatQuery += sCat1;
				}
			}
			return sCatQuery;
		},

		getRoamingTariffs: function () {
			var mod = this,
				$ctx = mod.$ctx;

			var countryId = mod.$countryField.val();
			var subscriptionId = mod.$subscriptionField.hasClass('hidden')? mod.$singleSubscriptionField.attr('value'): mod.$subscriptionField.val();
			var language = mod.lang;

			mod.clearData();
			$.ajax({
				url: mod.$baseUrl + mod.cache.pricesUrl + '/' + countryId + '/' + subscriptionId + '/' + language,
				type: 'post'
			}).done(function (data) {
				if(data){
					mod.showAboInfo(data.aboInfoIds);
				}

				if (data && data.countryInfoList && data.countryInfoList.messages) {
					mod.renderTemplate(data, 'script.tmpl-roat-info-messages', '.info-results', false);
				}

				if (!data || !data.serviceTypes || !data.serviceTypes.length) {
					debug.log('Tc.Module.RoamingTariff > getRoamingTariffs', data);
					$ctx.find('.roat-no-prices').removeClass('hidden');
					return false;
				}

				data.services = mod.getAvailableServices(data.serviceTypes);
				data.renderAsList = mod.cache.renderAsList;
				data.country = mod.$countryField.find('option:selected').html();

				debug.log('Tc.Module.RoamingTariff prices:', data);

				mod.renderTemplate(data, 'script.tmpl-roat-results-list', '.roat-prices-list', false);
				mod.renderTemplate(data, 'script.tmpl-roat-results-table', '.roat-prices', false);

				for (var i=0, ii = mod.$pars.length; i < ii; i+=1){
					if (mod.$pars.eq(i).prev().text().length){
						mod.$pars.eq(i).removeClass('hidden');
					}
				}

				SCS.utils.initNewModules($ctx.find('.roat-prices, .info-results'));
				if (!mod.isMobile && !mod.$subscriptionField.hasClass('hidden')) {
					mod.$subscriptionField.resetSS();
				}

				mod.getRoamingOperators();
			}).fail(function (jqXHR) {
				debug.log('Tc.Module.RoamingTariff prices AJAX error: ' + jqXHR.responseText);
			});
		},

		getAvailableServices: function(serviceTypes) {
			var mod = this;

			mod.services = {
				'data' : false,
				'voce' : false,
				'messaging' : false
			};

			for (var i = 0, ii = serviceTypes.length; i < ii; i+=1){
				if (serviceTypes[i].type === mod.cache.SERVICE_DATA){
					mod.services.data = true;
				}
				if (serviceTypes[i].type === mod.cache.SERVICE_VOICE){
					mod.services.voice = true;
				}
				if (serviceTypes[i].type === mod.cache.SERVICE_SMS || serviceTypes[i].type === mod.cache.SERVICE_MMS ){
					mod.services.messaging = true;
				}
			}

			return mod.services;
		},

		clearData: function () {
			var mod = this,
				$ctx = mod.$ctx;

			$ctx.find('.roat-prices, .roat-operators, #messagesContainer').empty();
			$ctx.find('#aboInfoContainer, #noPricesMessage, #noOperatorsMessage, .rt-par-container').addClass('hidden');
		},

		showAboInfo: function (aboInfoIds) {
			var mod = this;

			var $aboInfoContainer = mod.$ctx.find('#aboInfoContainer');
			if ($aboInfoContainer) {
				if (aboInfoIds.length > 0) {
					mod.$ctx.find('input[type="hidden"]').val(aboInfoIds).trigger('change');
					$aboInfoContainer.removeClass('hidden');
				} else {
					$aboInfoContainer.addClass('hidden');
				}
			}
		},

		getRoamingOperators: function () {
			var mod = this,
				$ctx = mod.$ctx;

			var countryId = mod.$countryField.val();

			$.ajax({
				url: mod.$baseUrl + mod.cache.operatorsUrl + '/' +  countryId,
				type: 'post'
			}).done(function (data) {

				data.services = mod.services;

				if (!data || !data.operators || !data.operators.length) {
					debug.log('Tc.Module.RoamingTariff > getRoamingOperators', data);
					$ctx.find('.roat-no-operators').removeClass('hidden');
					return false;
				}
				var hideAsterisk = true;
				for (var i=0, ii = data.operators.length; i < ii; i += 1) {
					if (data.operators[i].services) {
						data.operators[i].rules = mod.setRoamingOperatorRules(data.operators[i].services);
						data.operators[i].frequencies = mod.collectFrequencies(data.operators[i].services);
					}
					hideAsterisk = hideAsterisk && data.operators[i].rules[mod.cache.SERVICE_CAMEL];
				}

				if(!mod.hideRoamingPartner) {
					mod.renderTemplate(data, 'script.tmpl-roat-operators-list', '.roat-operators', false);

					if ($ctx.find('.roat-operators').text().length){
						$ctx.find('.roat-operators').next().removeClass('hidden');
					}

					SCS.utils.initNewModules(mod.$ctx.find('.roat-operators'));
				}

				var $asteriskContainer = mod.$ctx.find('.roaming-partners-footnote');
				if ($asteriskContainer) {
					if (!hideAsterisk) {
						$asteriskContainer.removeClass('hidden');
					} else {
						$asteriskContainer.addClass('hidden');
					}
				}
			}).fail(function (jqXHR) {
				debug.log('Tc.Module.RoamingTariff operators AJAX error: ' + jqXHR.responseText);
			});
		},

		renderTemplate: function (data, tplSelector, containerElem, append) {
			var mod = this,
				$ctx = mod.$ctx;

			if (data) {
				mod.tmplItem = doT.template($ctx.find(tplSelector).html());
				var $html = $(mod.tmplItem(data));
				if (!append) {
					$ctx.find(containerElem).empty();
				}
				$ctx.find(containerElem).append($html);
			}
		},

		setRoamingOperatorRules: function (services) {
			var mod = this,
				rules = [];

			rules[mod.cache.SERVICE_CAMEL] = false;
			rules[mod.cache.SERVICE_LTE] = false;
			rules[mod.cache.SERVICE_FIVE] = false;
			rules[mod.cache.SERVICE_GPRS] = false;
			rules[mod.cache.SERVICE_GSM] = false;
			rules[mod.cache.SERVICE_UMTS] = false;
			rules[mod.cache.SERVICE_SMS] = false;
			rules[mod.cache.SERVICE_MMS] = false;
			rules[mod.cache.SERVICE_SMS_IW] = false;
			rules[mod.cache.SERVICE_INCOMING] = false;
			rules[mod.cache.SERVICE_OUTGOING] = false;
			rules[mod.cache.SERVICE_OUTGOING_NO_PREPAID] = false;

			for (var i = services.length - 1; i >= 0; i -= 1) {
				rules[services[i].name] = services[i].commerciallyOpen;
				if(services[i].name === mod.cache.SERVICE_SMS_IW){
					rules[services[i].name] = services[i].showSmsIw;
				}
			}

			rules[mod.cache.SERVICE_SMS] = rules[mod.cache.SERVICE_INCOMING] = rules[mod.cache.SERVICE_GSM] || rules[mod.cache.SERVICE_UMTS];
			rules[mod.cache.SERVICE_OUTGOING] = rules[mod.cache.SERVICE_INCOMING] && rules[mod.cache.SERVICE_CAMEL];
			rules[mod.cache.SERVICE_OUTGOING_NO_PREPAID] = rules[mod.cache.SERVICE_INCOMING] && !rules[mod.cache.SERVICE_CAMEL];
			rules[mod.cache.SERVICE_MMS] = rules[mod.cache.SERVICE_GPRS] || rules[mod.cache.SERVICE_UMTS] || rules[mod.cache.SERVICE_LTE]|| rules[mod.cache.SERVICE_FIVE];

			return rules;
		},

		collectFrequencies: function (services) {
			var mod = this,
				frequencies = [],
				collectedFrequencies = [];

			for (var i = services.length - 1; i >= 0; i-=1) {
				frequencies[services[i].name] = services[i].frequency;
			}

			var gsm = frequencies[mod.cache.SERVICE_GSM];
			gsm = mod.mergeFrequenciesRemoveDuplicates(gsm);
			gsm = mod.sortFrequencies(gsm);

			// taken from GSM (PORTAL-6298)
			var gprs = frequencies[mod.cache.SERVICE_GSM];
			gprs = mod.mergeFrequenciesRemoveDuplicates(gprs);
			gprs = mod.sortFrequencies(gprs);

			var umts = frequencies[mod.cache.SERVICE_UMTS];
			umts = mod.mergeFrequenciesRemoveDuplicates(umts);
			umts = mod.sortFrequencies(umts);

			var gsmUmts = '';
			if (gsm) {
				gsmUmts += gsm;
				if (umts) {
					gsmUmts += '/';
					gsmUmts += umts;
				}
			}
			gsmUmts = mod.mergeFrequenciesRemoveDuplicates(gsmUmts);
			gsmUmts = mod.sortFrequencies(gsmUmts);

			var lte = frequencies[mod.cache.SERVICE_LTE];
			lte = mod.mergeFrequenciesRemoveDuplicates(lte);
			lte = mod.sortFrequencies(lte);

			var five = frequencies[mod.cache.SERVICE_FIVE];
			five = mod.mergeFrequenciesRemoveDuplicates(five);
			five = mod.sortFrequencies(five);

			collectedFrequencies[mod.cache.FREQ_GSM_UMTS] = gsmUmts;
			collectedFrequencies[mod.cache.FREQ_GPRS] = gprs;
			collectedFrequencies[mod.cache.FREQ_LTE] = lte;
			collectedFrequencies[mod.cache.FREQ_FIVE] = five;
			collectedFrequencies[mod.cache.FREQ_UMTS] = umts;

			return collectedFrequencies;
		},

		mergeFrequenciesRemoveDuplicates: function (freqStr) {
			var newStr = '';
			if (!freqStr) {
				return newStr;
			}
			if (freqStr.indexOf('/') > -1) {
				var parts = freqStr.split('/');
				var newStrArr = [];
				for(var i = 0; i < parts.length; i += 1) {
					var part = parts[i];
					if ($.inArray(part, newStrArr) === -1) {
						newStrArr.push(part);
					}
				}
				newStr = newStrArr.join('/');
			} else {
				newStr = freqStr;
			}
			return newStr;
		},

		sortFrequencies: function (freqStr) {
			var newStr = '';
			if (!freqStr) {
				return newStr;
			}
			if (freqStr.indexOf('/') > -1) {
				var parts = freqStr.split('/');
				var newStrArr = [];
				for(var i = 0; i < parts.length; i += 1) {
					var part = parts[i];
					if (part !== null && part !== '' && !isNaN(part)) {
						newStrArr.push(parseInt(part, 10));
					}
				}
				var sortedFreqArr = newStrArr.sort(function (a,b) { return a - b; });
				newStr = sortedFreqArr.join('/');
			} else {
				newStr = freqStr;
			}
			return newStr;
		}
	});
}(__webpack_provided_window_dot_Tc_dot_$, window.Tc, window.SCS = window.SCS || {}, window.debug, window.doT));

}.call(window));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_Tc_dot_$) {/*** IMPORTS FROM imports-loader ***/
var loadTerrific = __webpack_require__(1);
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function (Tc, $, SCS, w) {
	'use strict';
	/*
	 * Dependencies:
	 * TerrificJs 2.0.1,
	 * jQuery 1.6.4 or greater,
	 * jquery.placeholder.min.js,
	 */

	var INVISIBLE_CLASS = 'invisible';

	Tc.Module.Scene7 = Tc.Module.extend({

		/*
		 * Global properties for all scene7 components
		 */
		GLOBAL: {
			initialized: false,
			initializing: false
		},

		STYLE: {
			'default': 'default',
			type1: 'type1'
		},

		init: function ($ctx, sandbox, modId) {
			var mod = this;

			mod.$ctx = $ctx;
			mod.$ctx.addClass('normalView');
			mod.mediaSetConfiguration = mod.$ctx.data('references').split(',');
			mod.templateParameters = mod.$ctx.data('template-params');
			mod.elements = {
				zoomButton: $('.zoomButton', mod.$ctx),
				spinsetSpinner: $('.spinsetSpinner', mod.$ctx),
				containerScene7: $('.container-scene7', mod.$ctx),
				videoButton: $('.videoButton', mod.$ctx)
			};
			mod.videoThumbnail = mod.$ctx.data('video-thumbnail');

			mod.isEditMode = window.CQ && window.CQ.WCM && window.CQ.WCM.isEditMode(true);

			mod.videoButtonOffset = 0;
			mod.videoButtonOffsetType1 = 0;

			// init video button & player
			if (mod.elements.videoButton.length > 0) {
				mod.videoButtonOffset = 55;
				mod.videoButtonOffsetType1 = 65;
				mod.elements.brightcoveVideo = mod.$ctx.find('.modBrightcoveVideo');

				if(mod.videoThumbnail){
					mod.elements.videoButton.css('background-image', 'url(' + mod.videoThumbnail + ')');
				}
			} else {
				mod.elements.videoButton = false;
			}

			mod.size = {
				width: mod.$ctx.data('width'),
				height: mod.$ctx.data('height')
			};
			mod.properties = {
				id: $('.container-scene7', mod.$ctx).attr('id'),
				zoomMode: 'FlyoutZoomView',
				style: mod.$ctx.hasClass('style-' + mod.STYLE.type1) ? mod.STYLE.type1 : mod.STYLE['default']
			};
			mod.s7 = {
				params: {},
				container: {},
				spinview: {},
				zoomview: {},
				flyoutzoomview: {},
				trackingManager: {}
			};
			mod.mediaSets = [];
			mod.spinviewFrameIndex = 0;
			mod.animationSpinviewSpeed = 50;
			mod.spinsetSpinnerExt = 24;
			mod.swatchesHeight = 90;

			// use to start/stop animation 360 view
			mod.visible = true;

			this._super($ctx, sandbox, modId);
		},

		on: function (callback) {
			var mod = this;

			mod.styleElements();

			mod.$ctx.closest('.modVisibilityControlContainer').on('visibilityControl-hide', function () {
				mod.onHide();
			});

			mod.$ctx.closest('.modVisibilityControlContainer').on('visibilityControl-show', function () {
				mod.onShow();
			});

			mod.$ctx.removeClass(INVISIBLE_CLASS);
			mod.$ctx.removeClass('hidden');
			mod.initializeBase($.proxy(mod.initParameterManager, mod));

			// if no File References are configured, get config via Product Data Hub
			if (!mod.mediaSetConfiguration || !mod.mediaSetConfiguration.join('')) {
				if (mod.sandbox.application.registry.EcommerceProductDataHub) {
					mod.sandbox.application.registry.EcommerceProductDataHub.module.simpleSubscribe(mod, mod.productDataChanged);
				}
			}

			callback();
		},

		after: function () {
			if (navigator.userAgent.indexOf('Safari') !== -1 && navigator.userAgent.indexOf('Chrome') === -1) {
				$('body').addClass('safari-browser');
			}
		},

		productDataChanged: function(data) {
			var mod = this;

			mod.log('productDataChanged', data);
			if (!this.GLOBAL.ready) {
				mod.log('productDataChanged - scene7 not yet ready');
				setTimeout(function () {
					mod.productDataChanged(data);
				}, 200);
				return;
			}
			if (!data || !data.product || !data.family) {
				mod.log('productDataChanged - invalid data');
				return;
			}

			var displayedProduct = data.product;

			// find the product with the same color and the smallest memory size
			for (var i = 0; i < data.family.products.length; i += 1) {
				var product = data.family.products[i];
				if (product.getColor() === displayedProduct.getColor() &&
					+product.getMemory() < +displayedProduct.getMemory()) {

					displayedProduct = product;
				}
			}

			var id = displayedProduct.product.code.replace(/^0+/, '');
			if (mod.currentId !== id) {
				mod.currentId = id;
				// Note: "de" must be used for all languages
				mod.updateConfiguration(['Swisscom/scs-' + id + '-de-is']);
			}
		},

		updateConfiguration: function(config) {
			var mod = this;
			mod.log('updateConfiguration', config);
			mod.mediaSetConfiguration = config;
			mod.$ctx.find('.s7swatches').empty();
			mod.mediaSets = [];
			mod.getMediaSet();
		},

		initializeBase: function (callback) {
			if (typeof w.s7sdk !== 'undefined') {
				if (!this.GLOBAL.initialized && !this.GLOBAL.initializing) {
					this.GLOBAL.initializing = true;

					w.s7sdk.Util.lib.include('s7sdk.common.Container');
					w.s7sdk.Util.lib.include('s7sdk.common.Button');
					w.s7sdk.Util.lib.include('s7sdk.set.MediaSet');
					w.s7sdk.Util.lib.include('s7sdk.set.SpinView');
					w.s7sdk.Util.lib.include('s7sdk.set.Swatches');
					w.s7sdk.Util.lib.include('s7sdk.image.ZoomView');
					w.s7sdk.Util.lib.include('s7sdk.image.FlyoutZoomView');
					w.s7sdk.Util.init();

					var params = new w.s7sdk.ParameterManager();
					params.addEventListener(w.s7sdk.Event.SDK_READY, $.proxy(this.overrideS7GetObjRect, this), false);
					params.init();

					this.GLOBAL.initialized = true;
					this.GLOBAL.initializing = false;
					callback();
				} else if (this.GLOBAL.initializing) {
					setTimeout($.proxy(this.initializeBase, this, callback), 500);
				} else {
					callback();
				}
			}
		},

		// Override broken s7sdk.set.Swatches.prototype.getObjRect with an implementation that ignores transforms
		overrideS7GetObjRect: function() {
			var orig = w.s7sdk.set.Swatches.prototype.getObjRect;

			w.s7sdk.set.Swatches.prototype.getObjRect = function getObjRectIgnoringTransforms(el) {
				var $parents = $(el).parents();

				$parents.each(function() {
					var $this = $(this);
					var transform = $this.css('transform') || $this.css('webkit-transform');
					if(transform) {
						this.style.transform = this.style.WebkitTransform = 'none';
					}
				});
				var result = orig.apply(this, arguments);
				$parents.each(function() {
					this.style.transform = this.style.WebkitTransform = '';
				});

				return result;
			};
		},

		initParameterManager: function () {
			var mod = this;
			mod.s7.params = new w.s7sdk.ParameterManager();
			mod.s7.params.setViewer('504,4.7.1');
			mod.s7.params.addEventListener(w.s7sdk.Event.SDK_READY, $.proxy(mod.initViewer, mod), false);
			mod.s7.params.init();
		},

		initViewer: function () {
			var mod = this;
			mod.log('initViewer SDK_READY');
			this.GLOBAL.ready = true;

			// settings for container
			mod.s7.params.push('serverUrl', '//swisscomvbc.scene7.com/is/image/');
			mod.s7.params.push('iscommand', '&resMode=sharp2&op_usm=0.2,0.1,0,0&' + mod.templateParameters);
			mod.s7.params.push('size', mod.size.width + ',' + mod.size.height);
			mod.s7.params.push('zoomfactor', '1');

			// optional Swatches settings
			mod.s7.params.push(mod.properties.id + '-swatches.iscommand', '$thumb$&' + mod.templateParameters);
			mod.s7.params.push(mod.properties.id + '-swatches.tmblayout', '0,1');
			mod.s7.params.push(mod.properties.id + '-swatches.resizable', '0');
			mod.s7.params.push(mod.properties.id + '-swatches.orientation', '0');
			mod.s7.params.push(mod.properties.id + '-swatches.buttonsnapmode', 'snapin');
			mod.s7.params.push(mod.properties.id + '-swatches.tmbsize', '55,55'); // duplicate in $thumb$ preset, does not seem to work if it is only called there ...
			mod.s7.params.push(mod.properties.id + '-swatches.fmt', 'png-alpha'); // duplicate in $thumb$ preset, does not seem to work if it is only called there ...
			if (mod.properties.style === mod.STYLE.type1) {
				mod.s7.params.push(mod.properties.id + '-swatches.cellspacing', '10,10');
			} else {
				mod.s7.params.push(mod.properties.id + '-swatches.cellspacing', '3,3');
			}
			mod.s7.params.push(mod.properties.id + '-swatches.textpos', 'none');
			mod.s7.params.push(mod.properties.id + '-swatches.align', 'center,bottom');
			if (w.s7sdk.browser.device.name !== 'desktop') {
				mod.s7.params.push(mod.properties.id + '-swatches.enablescrollbuttons', '0');
			}

			// optional Spinview settings
			mod.s7.params.push(mod.properties.id + '-spinview.fmt', 'png-alpha');
			mod.s7.params.push(mod.properties.id + '-spinview.doubleclick', 'none'); //disable zoom in spinview

			// optional Zoomview settings
			mod.s7.params.push(mod.properties.id + '-zoomview.zoomfactor', '3,-1');
			mod.s7.params.push(mod.properties.id + '-zoomview.fmt', 'png-alpha');

			// optional Flyout-Zoomview settings
			mod.s7.params.push(mod.properties.id + '-flyoutzoomview.zoomfactor', '3,-1');
			mod.s7.params.push(mod.properties.id + '-flyoutzoomview.fmt', 'png-alpha');

			mod.s7.container = new w.s7sdk.Container(mod.properties.id, mod.s7.params, mod.properties.id + '-s7container');
			mod.s7.spinview = new w.s7sdk.SpinView(mod.properties.id + '-s7container', mod.s7.params, mod.properties.id + '-spinview');
			mod.s7.zoomview = new w.s7sdk.image.ZoomView(mod.properties.id + '-s7container', mod.s7.params, mod.properties.id + '-zoomview');
			mod.s7.flyoutzoomview = new w.s7sdk.image.FlyoutZoomView(mod.properties.id + '-s7container', mod.s7.params, mod.properties.id + '-flyoutzoomview');
			mod.s7.flyoutzoomview.resize();
			mod.s7.flyoutzoomview.addEventListener('click', $.proxy(mod.toggleZoomView, mod));

			mod.s7.trackingManager = new w.s7sdk.TrackingManager();

			mod.s7.spinview.setDragToSpin(true);
			mod.s7.spinview.addEventListener(w.s7sdk.event.AssetEvent.ASSET_CHANGED, $.proxy(mod.spinnerToSliderSync, mod), true);

			mod.elements.zoomButton.on('click', $.proxy(mod.toggleZoomView, mod));
			if (mod.elements.videoButton) {
				mod.elements.videoButton.on('click', $.proxy(mod.onClickVideoButton, mod));
			}

			$(document).keyup(function (e) {
				if (mod.properties.zoomMode === 'ZoomView') {
					if (e.keyCode === 27) { // Esc
						mod.toggleZoomView();
					}
				}
			});

			mod.s7.container.addEventListener(w.s7sdk.ResizeEvent.COMPONENT_RESIZE, $.proxy(mod.onContainerResizeEvent, mod), false);
			mod.s7.container.addEventListener(w.s7sdk.ResizeEvent.WINDOW_RESIZE, $.proxy(mod.onWindowResizeEvent, mod), false);

			mod.getMediaSet();
		},

		getMediaSet: function (i) {
			var mod = this,
				mediaSet;

			i = typeof i === 'undefined' ? 0 : i;
			if (mod.mediaSetConfiguration.length > i) {
				if (mod.mediaSetConfiguration[i] && mod.mediaSetConfiguration[i].length) {
					mod.log('getMediaSet', mod.mediaSetConfiguration[i]);
					mod.s7.params.params.asset = mod.mediaSetConfiguration[i];
					mediaSet = new w.s7sdk.MediaSet(null, mod.s7.params, null);
					mediaSet.addEventListener(w.s7sdk.AssetEvent.NOTF_SET_PARSED, $.proxy(mod.getMediaSet, mod, i += 1), false);
					mod.mediaSets.push(mediaSet);
				} else {
					mod.getMediaSet(i += 1);
				}
			} else {
				mod.onMediaSetsParsed();
			}
		},

		onMediaSetsParsed: function () {
			var mod = this,
				i, j,
				compAsset = new w.s7sdk.MediaSetDesc(0, 0, w.s7sdk.ItemDescType.MEDIA_SET, '', ''),
				mset;

			mod.log('onMediaSetsParsed');
			for (i = 0; i < mod.mediaSets.length; i += 1) {
				if (mod.mediaSets[i]) {
					mset = mod.mediaSets[i].mediaSetDesc_;
					if (mset && mset.type === w.s7sdk.ItemDescType.IMAGE_SET) {
						for (j = 0; j < mset.items.length; j += 1) {
							compAsset.items.push(mset.items[j]);
						}
					} else {
						compAsset.items.unshift(mset);
					}
				}
			}

			// set media set for Swatches to display
			mod.s7.swatches = new w.s7sdk.Swatches(mod.properties.id + '-s7container', mod.s7.params, mod.properties.id + '-swatches');
			mod.s7.swatches.addEventListener(w.s7sdk.AssetEvent.SWATCH_SELECTED_EVENT, $.proxy(mod.swatchSelectedEvent, mod), false);
			mod.s7.swatches.setMediaSet(compAsset);
			if (mod.properties.style === mod.STYLE['default']) {
				mod.s7.swatches.resize(mod.size.width - mod.videoButtonOffset, mod.swatchesHeight);
			} else {
				mod.s7.swatches.resize(mod.size.height - mod.videoButtonOffsetType1, mod.swatchesHeight);
			}

			// select the first swatch or if the #s7 has is set the value instead (starting index is 0)
			if (compAsset.items.length > 0) {
				var hash = SCS.HashDeepLink.get('s7');
				var index = !isNaN(hash) ? hash : 0;
				mod.s7.swatches.selectSwatch(Math.min(Math.abs(index), compAsset.items.length - 1), true);
			}

			/* jshint camelcase: false */
			window.viewer_ASSET_CHANGED = function (e) {
				if ((mod.s7.swatches) && (mod.s7.swatches.frame !== e.s7event.frame)) {
					mod.s7.swatches.selectSwatch(e.s7event.frame, true);
				}
			};

			mod.styleSwatches();

			if (mod.elements.videoButton) {
				mod.elements.videoButton.show();
			}
		},

		// Event from VisibilityControlContainer
		onShow: function () {
			this.visible = true;
		},

		// Event from VisibilityControlContainer
		onHide: function () {
			this.visible = false;
		},

		onClickVideoButton: function () {
			var mod = this;

			if(mod.elements.videoButton.hasClass('selected')) {
				return;
			}

			mod.hideAll();

			mod.$ctx.find('.' + INVISIBLE_CLASS).removeClass(INVISIBLE_CLASS);

			if (mod.s7.swatches) {
				mod.s7.swatches.selectSwatch(-1, false);
			}
			mod.elements.videoButton.addClass('selected');
		},

		hideAll: function () {
			var mod = this;
			// Hide all
			$(mod.s7.flyoutzoomview.obj).hide();
			$(mod.s7.zoomview.obj).hide();
			mod.elements.zoomButton.hide();
			$(mod.s7.spinview.obj).hide();
			mod.elements.spinsetSpinner.hide();

			if (mod.elements.videoButton) {
				mod.elements.videoButton.removeClass('selected');
				mod.elements.brightcoveVideo.addClass(INVISIBLE_CLASS);
			}

		},

		swatchSelectedEvent: function (e) {
			var mod = this,
				asset = e.s7event.asset,
				type = asset.type;

			if (mod.elements.brightcoveVideo) {
				mod.elements.brightcoveVideo.trigger('onPause');
			}

			mod.hideAll();
			mod.elements.zoomButton.show();

			if (+type === 1) { // ImageSet
				// always set asset in both viewers
				mod.s7.flyoutzoomview.setItem(asset);
				mod.s7.zoomview.setItem(asset);

				if (mod.properties.zoomMode === 'ZoomView') {
					$(mod.s7.zoomview.obj).show();
				}

				if (mod.properties.zoomMode === 'FlyoutZoomView') {
					$(mod.s7.flyoutzoomview.obj).show();
				}
				return;
			}

			if (+type === 8) { // SpinView
				mod.s7.params.params.asset = asset.name;
				mod.s7.spinview.setMediaSet(asset);
				mod.s7.spinview.setCurrentFrameIndex(mod.spinviewFrameIndex);
				mod.elements.spinsetSpinner.show();
				mod.elements.spinsetSpinner.slider('destroy').slider({
					animate: 'fast',
					max: mod.s7.spinview.getFramesLength() - 1,
					slide: $.proxy(mod.sliderToSpinnerSync, mod),
					start: $.proxy(mod.sliderStartDrag, mod),
					stop: $.proxy(mod.sliderStopDrag, mod),
					value: mod.spinviewFrameIndex
				});
				$(mod.s7.spinview.obj).show();
				setTimeout($.proxy(mod.setInitialSpinsetSpinviewFrame, mod), 100);
				return;
			}
		},

		setInitialSpinsetSpinviewFrame: function () {
			var mod = this;
			mod.s7.spinview.setCurrentFrameIndex(mod.spinviewFrameIndex);
			if (mod.properties.spinview) {
				mod.s7.spinview.resize(mod.properties.spinview.width, mod.properties.spinview.height);
				delete mod.properties.spinview;
			}

			// animation
			if (mod.visible) {
				setTimeout($.proxy(mod.animationSpinview, mod), 500);
			}
		},

		animationSpinview: function () {
			var mod = this;
			if (!mod.visible) {
				return;
			}
			if (mod.spinviewFrameIndex < mod.s7.spinview.getFramesLength()) {
				mod.s7.spinview.setCurrentFrameIndex(mod.spinviewFrameIndex);
				mod.spinviewFrameIndex += 1;
				setTimeout($.proxy(mod.animationSpinview, mod), mod.animationSpinviewSpeed);
			} else {
				mod.spinviewFrameIndex = 0;
				mod.s7.spinview.setCurrentFrameIndex(mod.spinviewFrameIndex);
			}
		},

		onContainerResizeEvent: function (event) {
			var mod = this,
				width = event.s7event.w,
				height = event.s7event.h;

			if (mod.properties.zoomMode === 'ZoomView') {
				height = height - 0 - mod.swatchesHeight;
			}

			if (event.target === mod.s7.container.obj) { // acts only on container resize events
				if (mod.properties.zoomMode === 'ZoomView') {
					mod.s7.swatches.resize(width, mod.swatchesHeight);
				} else {
					if (mod.properties.style === mod.STYLE['default']) {
						mod.s7.swatches.resize(width - mod.videoButtonOffset, mod.swatchesHeight);
					} else {
						mod.s7.swatches.resize(height - mod.videoButtonOffsetType1, mod.swatchesHeight);
					}
				}
				mod.s7.zoomview.resize(width, height);
				if (mod.s7.spinview.getCurrentView()) {
					mod.s7.spinview.resize(width, height);
				} else {
					mod.properties.spinview = {
						width: width,
						height: height
					};
				}
			}
		},

		onWindowResizeEvent: function (event) {
			var mod = this;
			if (mod.properties.zoomMode === 'ZoomView') {
				mod.s7.container.resize(event.s7event.w, event.s7event.h);
			}
		},

		styleSwatches: function () {
			// Parse the swatches element and check for videos / 360 spinsets
			var mod = this,
				spinSnippet = '<div class="spinner"></div>',
				mySwatches = mod.s7.swatches.filteredSet_;

			for (var key in mySwatches) {
				if (mySwatches.hasOwnProperty(key)) {
					if (+mySwatches[key].type === 8) {
						$('#' + mod.s7.swatches.id + ' div div').eq(0).addClass('container');
						$('#' + mod.s7.swatches.id + ' .container > div').eq(key).css({
							'position': 'absolute'
						}).append(spinSnippet);
					}
				}
			}

			mod.styleZoom();
		},

		sliderToSpinnerSync: function (event, ui) {
			var mod = this,
				goToFrame = ui.value;

			if (goToFrame >= 0 && goToFrame < mod.s7.spinview.getFramesLength()) {
				mod.s7.spinview.setCurrentFrameIndex(goToFrame);
				mod.spinviewFrameIndex = goToFrame;
			}
		},

		sliderStartDrag: function () {
			var mod = this;
			mod.elements.spinsetSpinner.data('isDragging', true);
		},

		sliderStopDrag: function () {
			var mod = this;
			mod.elements.spinsetSpinner.data('isDragging', false);
		},

		spinnerToSliderSync: function (e) {
			var mod = this,
				goToFrame = e.s7event.frame;

			if (goToFrame >= 0 && goToFrame < mod.s7.spinview.getFramesLength() && !mod.elements.spinsetSpinner.data('isDragging')) {
				mod.elements.spinsetSpinner.slider('option', 'value', goToFrame);
				mod.spinviewFrameIndex = goToFrame;
			}
		},

		toggleZoomView: function () {
			var mod = this;

			mod.$ctx.toggleClass('zoomView');
			mod.$ctx.toggleClass('normalView');

			if (mod.properties.zoomMode === 'FlyoutZoomView') {

				mod.properties.zoomMode = 'ZoomView';
				var size = mod.getWindowSize();
				mod.s7.container.resize(size.w, size.h);

				$('#scs-pageheader-logo a').css({
					'zIndex': 16200,
					'position': 'absolute',
					'left': '50px'
				});
				$('body').css({
					'overflow': 'hidden'
				});
				$(mod.s7.flyoutzoomview.obj).hide();
				if ($(mod.s7.spinview.obj).css('display') === 'block') {
					$(mod.s7.zoomview.obj).hide();
				} else {
					$(mod.s7.spinview.obj).hide();
					$(mod.s7.zoomview.obj).show();
				}
				if (mod.elements.videoButton) {
					$(mod.elements.videoButton).hide();
					mod.elements.brightcoveVideo.trigger('onPause');
					mod.elements.brightcoveVideo.hide();
				}

				$(mod.elements.containerScene7).addClass('hideBackground');

			} else {

				mod.properties.zoomMode = 'FlyoutZoomView';
				mod.s7.container.resize(mod.size.width, mod.size.height);

				$('#scs-pageheader-logo a').css({
					'zIndex': 16200,
					'position': 'relative',
					'left': 'auto'
				});
				$('body').css({
					'overflow': 'visible'
				});
				$(mod.s7.zoomview.obj).hide();
				if ($(mod.s7.spinview.obj).css('display') !== 'block') {
					$(mod.s7.spinview.obj).hide();
					$(mod.s7.flyoutzoomview.obj).show();
				}
				if (mod.elements.videoButton) {
					$(mod.elements.videoButton).show();
					mod.elements.brightcoveVideo.show();
				}

				$(mod.elements.containerScene7).removeClass('hideBackground');
			}
			mod.styleSwatches();
		},

		getWindowSize: function () {
			var size = new w.s7sdk.Point2D(),
				winW = 630,
				winH = 460;

			if (document.body && document.body.offsetWidth) {
				winW = document.body.offsetWidth;
				winH = document.body.offsetHeight;
			}
			if (document.compatMode === 'CSS1Compat' &&
				document.documentElement &&
				document.documentElement.offsetWidth) {
				winW = document.documentElement.offsetWidth;
				winH = document.documentElement.offsetHeight;
			}
			if (window.innerWidth && window.innerHeight) {
				winW = window.innerWidth;
				winH = window.innerHeight;
			}

			size.w = winW;
			size.h = winH;
			return size;
		},

		styleElements: function () {
			var mod = this;

			if (mod.properties.style === mod.STYLE['default']) {
				mod.elements.spinsetSpinner.css({
					top: (mod.size.height - 0 + 8) + 'px',
					width: (mod.size.width - mod.swatchesHeight) + 'px'
				});
				mod.elements.zoomButton.css({
					top: mod.size.height + 'px',
					'margin-left': (mod.size.width - 23) + 'px'
				});

				mod.elements.containerScene7.css({
					height: (mod.size.height - 0 + mod.swatchesHeight + mod.spinsetSpinnerExt) + 'px',
					width: mod.size.width + 'px'
				});
				if (mod.elements.videoButton) {
					mod.elements.videoButton.css({
						top: (
							mod.size.height +
							(mod.properties.style === mod.STYLE['default'] ? 58 : 38)
						) + 'px',
						'margin-left': (mod.size.width - 60) + 'px'
					});
				}

			} else {
				mod.elements.spinsetSpinner.css({
					top: (mod.size.height - 0 + 8) + 'px',
					width: (mod.size.width - mod.swatchesHeight) + 'px'
				});
				mod.elements.zoomButton.css({
					top: ''
				});

				if (mod.elements.videoButton) {
					mod.elements.videoButton.css({
						top: (mod.size.height - mod.elements.videoButton.width() - 2) + 'px'
					});
				}

				mod.elements.containerScene7.css({
					height: (mod.size.height - 0 + mod.spinsetSpinnerExt) + 'px',
					width: (mod.size.width - 0 + 110) + 'px'
				});
			}
		},

		styleZoom: function () {
			var mod = this,
				switcherContainer,
				arrowObj;

			$(mod.s7.swatches.obj).removeClass('zoomviewbackground');
			if (mod.properties.zoomMode === 'ZoomView') {
				mod.elements.zoomButton.css({
					top: ''
				});
				mod.elements.spinsetSpinner.css({
					top: '',
					width: ''
				});
				mod.elements.containerScene7.css({
					height: ''
				});
				if (mod.properties.style === mod.STYLE['default']) {
					$(mod.s7.swatches.obj).addClass('zoomviewbackground');
				}
			} else {
				mod.styleElements();
			}

			if (mod.properties.style === mod.STYLE.type1 && mod.s7.swatches) {
				switcherContainer = $(mod.s7.swatches.obj).children().first();

				arrowObj = $(mod.s7.swatches.obj).children('.s7scrollrightbutton');
				if (mod.properties.zoomMode === 'FlyoutZoomView') {
					if (arrowObj.length > 0) {
						var top = parseInt(switcherContainer.css('left'), 10) - 1;
						$(mod.s7.swatches.obj).css({
							top: '-' + top + 'px'
						});
						arrowObj = $(mod.s7.swatches.obj).children('.s7scrollrightbutton');
						mod.elements.zoomButton.css({
							top: (arrowObj.position().top - 11 - top) + 'px'
						});
						$(switcherContainer).css({
							'margin-left': '-8px'
						});
					} else {
						if (mod.elements.videoButton) {
							mod.elements.videoButton.css({
								top: (switcherContainer.position().top + switcherContainer.width() + 25 -
										(mod.$ctx.hasClass('sdxStyle') ? 29 : 0)
								) + 'px'
							});
						}
						mod.elements.zoomButton.css({
							top: (switcherContainer.position().top + switcherContainer.width() - 4) + 'px'
						});
					}
				} else {
					$(mod.s7.swatches.obj).css({
						top: ''
					});
					$(switcherContainer).css({
						'margin-left': ''
					});
				}

			}
			mod.elements.zoomButton.show();
		}
	});
}(window.Tc, __webpack_provided_window_dot_Tc_dot_$, window.SCS, window));

}.call(window));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var loadTerrific = __webpack_require__(1);
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function($) {

	/**
	 * @author Thomas Amsler
	 * @namespace Tc.Module.Scene7Stage
	 * @class Scene7Stage
	 * @extends Tc.Module
	 */

	Tc.Module.Scene7Stage = Tc.Module.extend({

		/**
		 * @method on
		 * @param {Function}
		 *            callback function
		 * @return void
		 */
		on : function(callback) {
			var mod = this, $ctx = mod.$ctx;

			// load and parse dataObject json
			mod.dataObject = $ctx.data('json');

			// set defaults
			mod.image = $ctx.data('desktop-image');
			if (SCS.utils.isMobilePage()) {
				mod.image = $ctx.data('mobile-image');
			}
			mod.s7Url = mod.image + '?$Original%20Size$';

			setTimeout(mod.loadDefaultImage.bind(mod), 3000);
			callback();
		},

		/**
		 * @method loadDefaultImage
		 * @return void
		 */
		loadDefaultImage : function() {
			var mod = this, $ctx = mod.$ctx;
			var img = $ctx.find('img')[0];
			if (img.naturalWidth == 1) {
				if (SCS.utils.isMobilePage()) {
					img.src = $ctx.data('mobile-src');
				} else {
					img.src = $ctx.data('desktop-src');
				}
			}
		},

		/**
		 * @method updateImageSrc
		 * @param {String}
		 *            zalCode to load
		 * @param {String}
		 *            condId to load
		 * @param {String}
		 *            segment to load
		 * @return void
		 */
		updateImageSrc : function(zalCode, condId, segment) {
			var mod = this;
			var img = mod.$ctx.find('img');
			var data = mod.getDataObject(zalCode, condId, segment);
			
			mod.s7Url = mod.image + '?$Original%20Size$&';
			mod.s7Url += $.param(data||{}).replace(/(^|&)/g, '$1$')
			img.attr('src', mod.s7Url);
		},

		/**
		 * @method updateLink
		 * @param {String}
		 *            zalCode to load
		 * @param {String}
		 *            condId to load
		 * @param {String}
		 *            segment to load
		 * @param {String}
		 *            linkProperty property name of the link
		 * @param {String}
		 *            addParameter query string with additional
		 *            parameter
		 * @return void
		 */
		updateLink : function(zalCode, condId, segment, linkProperty,
				addParameter) {
			var mod = this, $ctx = mod.$ctx;

			var data = mod.getDataObject(zalCode, condId, segment);
			if (data) {
				var link = data[linkProperty];
				if (link) {
					var href = unescape(link)
					if (href.indexOf('?') > -1) {
						href += '&'
					} else {
						href += '?'
					}
					href += addParameter;
					$ctx.attr('href', href);
				}
			}
		},

		/**
		 * @method getDataObject
		 * @param {String}
		 *            zalCode to load
		 * @param {String}
		 *            condId to load
		 * @param {String}
		 *            segment to load
		 * @return {Object} the data object with all defined PSD layers
		 */
		getDataObject : function(zalCode, condId, segment) {
			var mod = this;
			var zalObj = mod.dataObject[zalCode];
			if (!zalObj) {
				return;
			}

			var condIdObj = zalObj[condId];
			if (!condIdObj) {
				return;
			}

			var segmentObj = condIdObj[segment.toUpperCase()];
			if (!segmentObj) {
				return;
			}

			return segmentObj;
		}
	});
})(Tc.$);
}.call(window));

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var loadTerrific = __webpack_require__(1);
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function($, SCS) {
	/*
	 * Dependencies:
	 * TerrificJs 2.0.1,
	 * jQuery 1.7 or greater,
	 * jquery.placeholder.min.js,
	 * SCS.utils
	 *
	 */

	'use strict';
	/*globals Tc */
	/*jshint smarttabs:true */

	/**
	 * ScFormArchive module implementation.
	 *
	 * @author
	 * @namespace Tc.Module
	 * @class ScFormArchive
	 * @extends Tc.Module
	 */
	Tc.Module.ScFormArchive = Tc.Module.extend({

		cookieName: 'FormArchiveFilter',

		Events: {
			loadingClicked: 'loadingClicked', // no data when firing
			loadingStart: 'loadingStart', // no data when firing
			loadingStop: 'loadingEnd', // no data when firing
			noResults: 'noResults', // no data when firing
			resetResults: 'resetResults', // no data when firing
			resultsUpdated: 'resultsUpdated', // fired with data: { size: (overall size of the results), count (currently displayed entries) }
			itemAdded: 'itemAdded', // fired with data: { item (all data for this entry from backend), row (jquery element of the added table row) }
			update: 'update' // fired by modules whose data has changed, passing the new values, listened to by modules which need the updated data
		},

		/**
		 * Hook function to do all of your module stuff.
		 *
		 * @method on
		 * @param {Function} callback function
		 * @return void
		 */
		on: function(callback) {
			this.isMobile = SCS.utils.isMobilePage();

			this.LoadingIndicator.init($('.js-loading-indicator', this.$ctx), this);
			this.LoadButton.init($('.js-load-button', this.$ctx), this);
			this.SizeIndicator.init($('.showcount', this.$ctx), this);
			this.ResultTable.init($('table', this.$ctx), this);
			this.ActionsHandler.init($('table', this.$ctx), this);
			this.SortHandler.init($('table thead', this.$ctx), this);
			//this.Search.init($('form', this.$ctx), this);
			callback();
		},

		showDialog: function(title, text) {
			if(!this.isMobile){
				$('<div/>').attr('title', title).append(text).dialog();
			} else {
				var $popup = $('<div/>').attr('title', title).append(text);
				$popup.popup({
					afterclose: function( event, ui ) {
						$popup.popup('destroy');
					}
				}).popup('open');
			}
		},

		setCookieValue: function(name, value) {
			try {
				var data = $.cookies.get(this.cookieName) || {};
				data[name] = value;

				$.cookies.set(this.cookieName, data, {
					hoursToLive: 1
				});
			} catch(e) {}
		},

		getCookieValue: function(name) {
			try {
				var data = $.cookies.get(this.cookieName) || {};
				if (typeof data !== 'object') {
					data = $.parseJSON(data);
				}
				if (data && data.hasOwnProperty(name)) {
					return data[name];
				}
			} catch(e) {}
			return null;
		},

		/**
		 * Hook function to trigger your events.
		 *
		 * @method after
		 * @return void
		 */
		after: function() {
			this.Search.init($('form', this.$ctx), this);

			this.Search.start();
			this.SortHandler.start();
			this.ResultTable.start();
		},

		LoadingIndicator: {
			init: function(element, parent) {
				this.element = element;
				parent.$ctx.on(parent.Events.loadingStart, $.proxy(this.start, this));
				parent.$ctx.on(parent.Events.loadingStop, $.proxy(this.stop, this));
				this.stop();
			},

			start: function() {
				this.element.show();
			},

			stop: function() {
				this.element.hide();
			}
		},

		LoadButton: {
			init: function(element, parent) {
				this.element = element;
				this.parent = parent;

				this.parent.$ctx.on(this.parent.Events.loadingStart, $.proxy(this.disable, this));
				this.parent.$ctx.on(this.parent.Events.loadingStop, $.proxy(this.enable, this));
				this.parent.$ctx.on(this.parent.Events.noResults, $.proxy(this.stop, this));
				this.parent.$ctx.on(this.parent.Events.resetResults, $.proxy(this.reset, this));
				this.element.on('click', $.proxy(this.clickHandler, this));
			},

			clickHandler: function(event) {
				event.preventDefault();
				this.parent.$ctx.trigger(this.parent.Events.loadingClicked);
			},

			enable: function() {
				if (!this.stopped) {
					this.element.removeClass('disabled');
					this.element.show();
				}
			},

			disable: function() {
				if (!this.stopped) {
					this.element.addClass('disabled');
					this.element.hide();
				}
			},

			stop: function() {
				this.disable();
				this.stopped = true;

			},

			reset: function() {
				this.stopped = false;
				this.enable();
			}
		},

		SizeIndicator: {
			init: function(element, parent) {
				this.element = element;
				parent.$ctx.on(parent.Events.resultsUpdated, $.proxy(this.update, this));
			},

			update: function(event, data) {
				var size = (data ? data.size : 0) || 0,
					count = (data ? data.count : 0) || 0;
				if (!this.text) {
					this.text = this.element.text();
				}
				this.element.text((this.text || '').replace('(count)', count).replace('(size)', size)).show();
			}
		},

		ResultTable: {
			Data: {
				url: 'page-path',
				errorMsg: 'error-msg',
				statusDraftText: 'txt-status-draft',
				statusSentText: 'txt-status-sent'
			},

			init: function(element, parent) {
				this.element = element;
				this.parent = parent;
				this.count = 0;
				this.finalSize = 0;
				this.Filter = {};
				this.parent.$ctx.on(this.parent.Events.resetResults, $.proxy(this.reset, this));
				this.parent.$ctx.on(this.parent.Events.loadingClicked, $.proxy(this.loadData, this));
				this.parent.$ctx.on(this.parent.Events.update, $.proxy(this.updateHandler, this));
			},

			start: function() {
				this.parent.$ctx.trigger(this.parent.Events.resetResults);
			},

			getPagePath: function() {
				if (!this.pagePath) {
					this.pagePath = this.getProperty(this.Data.url);
				}
				return this.pagePath;
			},

			loadData: function() {
				if (!this.currentlyLoading) {
					this.currentlyLoading = true;
					this.abortingAjax = false;
					this.parent.$ctx.trigger(this.parent.Events.loadingStart);
					var $this = this;
					this.Filter.offset = this.count;
					if (!this.Filter['_charset_']) {
						this.Filter['_charset_'] = "utf-8";
					}
					this.ajaxCall = $.ajax({
						type: 'GET',
						url: $this.getPagePath() + '.formarchive.list.json',
						cache: false,
						dataType: 'json',
						data: $this.Filter,
						traditional: true,
						success: $.proxy($this.loadDataSuccess, $this),
						error: $.proxy($this.loadDataError, $this)
					});
				} else {
					if (this.ajaxCall) {
						this.abortingAjax = true;
						this.ajaxCall.abort();
					}
					this.loadData();
				}
			},

			loadDataSuccess: function(data) {
				if( data && data.items && data.items.length > 0 ) {
					this.finalSize = data.size;
					this.append(data.items);
					if (data.size && this.count >= data.size) {
						this.parent.$ctx.trigger(this.parent.Events.noResults);
					}
				} else {
					this.parent.$ctx.trigger(this.parent.Events.noResults);
				}
				this.notifyNewSize();
				this.currentlyLoading = false;
				this.parent.$ctx.trigger(this.parent.Events.loadingStop);
			},

			loadDataError: function() {
				this.currentlyLoading = false;
				if (!this.abortingAjax) {
					this.parent.showDialog('Error', this.getProperty(this.Data.errorMsg));
				}
				this.notifyNewSize();
				this.parent.$ctx.trigger(this.parent.Events.loadingStop);
			},

			updateHandler: function(event, data) {
				var filterChanged = false,
					key;
				if (data) {
					for (key in data) {
						if (data.hasOwnProperty(key)) {
							if (data[key] === '' || data[key] === undefined || data[key] === null) {
								if (this.Filter.hasOwnProperty(key)) {
									delete this.Filter[key];
									filterChanged = true;
								}
							} else {
								if (this.Filter[key] !== data[key]) {
									this.Filter[key] = data[key];
									filterChanged = true;
								}
							}
						}
					}
				}
				if (filterChanged) {
					this.parent.$ctx.trigger(this.parent.Events.resetResults);
				}
			},

			reset: function() {
				this.count = 0;
				this.finalSize = 0;
				this.getContent().empty();
				this.loadData();
			},

			append: function(data) {
				if (data) {
					for (var i = 0; i < data.length; i++) {
						this.addRow(data[i]);
					}
					this.notifyNewSize();
				}
			},

			notifyNewSize: function() {
				var $this = this;
				this.parent.$ctx.trigger(this.parent.Events.resultsUpdated, { size: $this.finalSize || $this.count, count: $this.count });
			},

			addRow: function (item) {
				var content = $('<tr/>'),
					shortSummary = item.shortSummary !== null && item.shortSummary !== '' ? item.shortSummary.trim() : ' ';
				shortSummary = $('<div/>').html(shortSummary).text();
				content.append(this.getCell(item.formId, 'cell-form-type'));
				content.append(this.getCell(item.lastUpdated, 'cell-last-updated'));
				if (item.draft === true) {
					content.append(this.getCell(this.getProperty(this.Data.statusDraftText), 'cell-status'));
				} else {
					content.append(this.getCell(this.getProperty(this.Data.statusSentText), 'cell-status'));
				}
				content.append(this.getCell($('<span class="content"/>').html(shortSummary), 'cell-summary'));

				//add header texts to table cells
				if(this.parent.isMobile){
					content.find('.cell-last-updated').prepend(this.element.find('th.cell-last-updated > span').clone());
					content.find('.cell-status').prepend(this.element.find('th.cell-status > span').clone());
					if ($.trim(content.find('.cell-summary .content').text()).length){
						content.find('.cell-summary .content').prepend(this.element.find('th.cell-summary > span').clone());
					}
				}

				this.getContent().append(content);
				this.count++;
				this.parent.$ctx.trigger(this.parent.Events.itemAdded, { item: item, row: content });
			},

			getCell: function(content, cssClass) {
				var cell = $('<td/>');
				if (cssClass) cell.addClass(cssClass);
				if (content !== undefined) {
					if (typeof content === 'string') {
						cell.text(content);
					} else {
						cell.append(content);
					}
				}
				return cell;
			},

			getProperty: function(name, defaultValue) {
				return this.element.data(name) || defaultValue;
			},

			getContent: function() {
				if (!this.content) {
					this.content = $('tbody', this.element);
				}
				return this.content;
			}
		},

		SortHandler: {
			SortDirections: {
				ascending: 'asc',
				descending: 'desc'
			},

			SortCellClass: {
				ascending: 'sort-asc',
				descending: 'sort-desc'
			},

			Data: {
				defaultSortBy: 'default-sort-by',
				defaultSortDirection: 'default-sort-direction'
			},

			init: function(element, parent) {
				this.element = element;
				this.parent = parent;
				this.sortName = this.getProperty(this.Data.defaultSortBy, '');
				this.sortDirection = this.getProperty(this.Data.defaultSortDirection, '');
				this.element.on('click', 'th', $.proxy(this.handler, this));
				this.updateHeader();
			},

			start: function() {
				var $this = this;
				this.parent.$ctx.trigger(this.parent.Events.update, { sort: $this.sortName, sortDirection: $this.sortDirection });
			},

			getProperty: function(name, defaultValue) {
				return this.element.data(name) || defaultValue;
			},

			handler: function(event) {
				var el = $(event.currentTarget),
					name = el.data('name'),
					$this = this;
				if (name) {
					if (name === this.sortName) {
						if (this.sortDirection === this.SortDirections.descending) {
							this.sortDirection = this.SortDirections.ascending;
						} else {
							this.sortDirection = this.SortDirections.descending;
						}
					} else {
						this.sortName = name;
						this.sortDirection = this.SortDirections.descending;
					}
					this.updateHeader();
					this.parent.$ctx.trigger(this.parent.Events.update, { sort: $this.sortName, sortDirection: $this.sortDirection });
				}
			},

			updateHeader: function() {
				var $this = this;
				$('th', this.element).each(function() {
					var el = $(this),
						name = el.data('name');
					if (name) {
						if (name === $this.sortName) {
							if ($this.sortDirection === $this.SortDirections.ascending) {
								el.removeClass($this.SortCellClass.descending);
								el.addClass($this.SortCellClass.ascending);
							} else {
								el.removeClass($this.SortCellClass.ascending);
								el.addClass($this.SortCellClass.descending);
							}
						} else {
							el.removeClass($this.SortCellClass.ascending);
							el.removeClass($this.SortCellClass.descending);
						}
					}
				});
			}
		},

		ActionsHandler: {
			Type: {
				edit: 'edit',
				copy: 'copy',
				view: 'view',
				remove: 'remove'
			},

			Data: {
				url: 'page-path',
				layerWidth: 'view-width',
				sentOnText: 'txt-sent-on',
				layerCopyButtonText: 'txt-layer-button-copy',
				errorMsg: 'error-msg',
				editText: 'txt-edit',
				copyText: 'txt-copy',
				viewText: 'txt-view',
				removeText: 'txt-remove',
				removeQuestionText: 'txt-remove-question',
				yesText: 'txt-yes',
				noText: 'txt-no'
			},

			init: function(element, parent) {
				this.element = element;
				this.parent = parent;
				this.parent.$ctx.on(this.parent.Events.itemAdded, $.proxy(this.setActionsHandler, this));
			},

			getProperty: function(name, defaultValue) {
				return this.element.data(name) || defaultValue;
			},

			getPagePath: function() {
				if (!this.pagePath) {
					this.pagePath = this.getProperty(this.Data.url);
				}
				return this.pagePath;
			},

			setActionsHandler: function(event, data) {
				if (data) {
					var actionsContainer = (!this.parent.isMobile) ? $('<span class="button-list"/>') : $('<ul class="link-list button-list"/>'),
						actions = this.getAvailableActions(data.item),
						i, $li;
					for (i = 0; i < actions.length; i++) {
						if(this.parent.isMobile){
							$li = $('<li></li>').appendTo(actionsContainer);
							$li.append(this.getElement(actions[i], data.item));
						} else {
							actionsContainer.append(this.getElement(actions[i], data.item));
						}
					}
					$('td:last-child', data.row).append(actionsContainer);
				}
			},

			getAvailableActions: function(item) {
				var actions = [];
				if (item.draft !== true) {
					actions.push(this.Type.view);
				}
				if (item.draft === true) {
					actions.push(this.Type.remove);
				}
				if (item.formPageExists === true && item.migratedData !== true) {
					if (item.draft === true) {
						actions.push(this.Type.edit);
					} else {
						actions.push(this.Type.copy);
					}
				}

				return actions;
			},

			getElement: function(actionType, item) {
				var action = $('<a/>').attr('href', this.getUrl(actionType, item));
				if (actionType === this.Type.view) {
					action.text(this.getProperty(this.Data.viewText));
					action.data('item', item);
					action.on('click', $.proxy(this.viewClickHandler, this));
				} else if (actionType === this.Type.edit) {
					action.text(this.getProperty(this.Data.editText));
				} else if (actionType === this.Type.copy) {
					action.text(this.getProperty(this.Data.copyText));
				} else if (actionType === this.Type.remove) {
					action.text(this.getProperty(this.Data.removeText));
					action.data('item', item);
					action.on('click', $.proxy(this.removeClickHandler, this));
				}
				return action;
			},

			getUrl: function(actionType, item) {
				if (actionType === this.Type.edit) {
					return item.formPath + '.html?action=edit&entryId=' + item.id;
				} else if (actionType === this.Type.copy) {
					return item.formPath + '.html?action=copy&entryId=' + item.id;
				} else {
					return item.formPath + '.html';
				}
			},

			viewClickHandler: function(event) {
				event.preventDefault();
				if (!this.viewLayer) {
					var $this = this,
						item = $(event.currentTarget).data('item');

					this.viewLayer = $('<div/>')
						.addClass('ui-dialog-lightbox-content modScFormArchive archive-preview')
						.append($('<div/>').addClass('js-loading-indicator')); // loading indicator

					if(!this.parent.isMobile){
							this.viewLayer.dialog({
								classes: {'ui-dialog': 'ui-dialog-lightbox pex-ui-dialog-lightbox'},
								width: $this.getProperty($this.Data.layerWidth) || 600,
								height: 'auto',
								position: { 'my': 'center', 'at': 'center' },
								close: function() {
									$this.viewLayer.remove();
									$this.viewLayerOpen = false;
									$this.viewLayer = null;
								}
						});
					} else {
						this.viewLayer.addClass('form-archive-panel').appendTo('.ui-page');
					}

					$.ajax({
						type: 'GET',
						url: $this.getPagePath() + '.formarchive.item.json',
						cache: false,
						dataType: 'json',
						data: {
							entryId: item.id
						},
						success: $.proxy($this.displayViewLayer, $this),
						error: function () {
							$this.parent.showDialog('Error', $this.element.data($this.Data.errorMsg));
							$this.viewLayer = null;
						}
					});
				}
			},

			displayViewLayer: function(data) {
				if (this.viewLayer) {
					this.viewLayer.empty();
					var summary = $('<div/>').html(data.summary).text(), // decode html
						copyLink = $('<a class="primary-button"/>').attr('href', this.getUrl(this.Type.copy, data)).text(this.getProperty(this.Data.layerCopyButtonText)),
						hr = ($('<hr/>')),
						$this = this;


					this.viewLayer.append($('<h2/>').text(data.pageTitle)); // title
					this.viewLayer.append($('<p/>').addClass('senttime').text(this.getProperty(this.Data.sentOnText) + ' ' + data.lastUpdated)); // submitting date
					this.viewLayer.append($('<div/>').addClass('content').html(summary)); // summary
					if (data.formPageExists === true && data.migratedData !== true) {
						this.viewLayer.append($('<hr/>'));
						this.viewLayer.append($('<div/>').append(copyLink));
					}
					if (this.viewLayer.height() > $(window).height()) {
						window.scrollTo(0, 0);
					}
					if(!this.parent.isMobile){
						this.viewLayer.dialog('reposition');
					} else {
						$('html').addClass('has-form-archive-dialog');
						this.viewLayer.prepend(hr);
						this.viewLayer.prepend(this.parent.$ctx.find('.form-remove-panel-back').clone());
						this.viewLayer.find('.form-remove-panel-back').click(function(){
							$('html').removeClass('has-form-archive-dialog');
							$this.viewLayer.remove();
							$this.viewLayerOpen = false;
							$this.viewLayer = null;
						});
					}
				}
			},

			removeClickHandler: function(event) {
				event.preventDefault();
				if (!this.removeLayer) {
					this.removeTarget = $(event.currentTarget);
					var $this = this,
						item = $(event.currentTarget).data('item'),
						question = $('<h3/>').text((this.getProperty(this.Data.removeText|| ''))),
						copytext = $('<p/>').text((this.getProperty(this.Data.removeQuestionText) || '').replace('(form)', item.formId)),
						buttonYes = $('<a class="archiv-button primary-button" href="#"/>').text((this.getProperty(this.Data.yesText) || '')).on('click', { item: item }, $.proxy(this.removeClickConfirmedHandler, this)),
						buttonNo = $('<a class="archiv-button  secondary-button" href="#"/>').text((this.getProperty(this.Data.noText) || '')).on('click', $.proxy(this.removeClickDiscardedHandler, this)),
						hr = ($('<hr/>'));
					this.removeLayer = $('<div/>').append(question).append(copytext).append(hr).append(buttonYes).append(buttonNo);

					if(!this.parent.isMobile){
						this.removeLayer.addClass('ui-dialog-lightbox-content modScFormArchive archive-preview').dialog({
							classes: {'ui-dialog': 'ui-dialog-lightbox'},
							width: 400,
							height: 'auto',
							close: function() {
								$this.removeLayer.remove();
								$this.removeLayer = null;
							}
						});
					} else {
						this.removeLayer.prepend(hr);
						this.removeLayer.prepend(this.parent.$ctx.find('.form-remove-panel-back').clone());
						this.removeLayer.find('.form-remove-panel-back').on('click', $.proxy(this.removeClickDiscardedHandler, this));
						this.removeLayer.addClass('form-archive-panel').appendTo('.ui-page');

					}
				}
			},

			removeClickConfirmedHandler: function(event) {
				event.preventDefault();
				if (event.data.item) {
					var $this = this;
					if (this.removeLayer) {
						this.removeLayer.empty().append($('<div/>').addClass('js-loading-indicator'));
					}
					$.ajax({
						type: 'POST',
						url: $this.getPagePath() + '.formarchive.delete.json',
						cache: false,
						dataType: 'json',
						data: {
							entryId: event.data.item.id
						},
						success: $.proxy($this.removeSuccess, $this),
						error: function () {
							if ($this.removeLayer) {
								if(!this.parent.isMobile){
										$this.removeLayer.dialog('close');
								} else {
									$this.removeLayer.remove();
								}
							}
							$this.parent.showDialog('Error', $this.element.data($this.Data.errorMsg));
						}
					});
				}
			},

			removeClickDiscardedHandler: function(event) {
				event.preventDefault();
				if (this.removeLayer) {
					if(!this.parent.isMobile){
							this.removeLayer.dialog('close');
					} else {
						this.removeLayer.remove();
						this.removeLayer = null;
					}
				}
				this.removeTarget = null;
			},

			removeSuccess: function(data) {
				if (this.removeLayer) {
					if(!this.parent.isMobile){
							this.removeLayer.dialog('close');
					} else {
						this.removeLayer.remove();
					}
				}
				if (data && (data.success === true || data.success === 'true')) {
					if (this.removeTarget) {
						this.removeTarget.closest('tr').remove();
					}
				} else {
					this.parent.showDialog('Error', this.element.data(this.Data.errorMsg));
				}
				this.removeTarget = null;
			}
		},

		Search: {
			init: function(element, parent) {
				var $this = this;
				this.element = element;
				this.parent = parent;
				this.Filter = {};
				this.searchButton = $('.js-search-button', this.element).on('click', $.proxy(this.fireUpdate, this));
				$('[data-filter-name]', this.element).each(function() {
					$this.addFilter($(this));
				});
			},

			start: function() {
				this.fireUpdate();
			},

			addFilter: function(el) {
				var inputField = $(':input', el),
					datePicker = $('.modDatePicker', el),
					name = el.data('filter-name'),
                    searchRef = this,
					value = this.parent.getCookieValue(name);
				if (value) {
					this.setInputValue(inputField, value);
					this.Filter[name] = value;
				}
				inputField.on('change', { element: el }, $.proxy(this.changeEventHandler, this));
				if(datePicker.length > 0) {
				    $("#ui-datepicker-div").hide();
					inputField.datepicker("option", "onSelect", function() {
						value = searchRef.getInputValue(inputField);
						searchRef.Filter[name] = value;
						searchRef.parent.setCookieValue(name, value);
					});

				}
				inputField.on('keyup', $.proxy(this.enterPressedHandler, this));
			},

			enterPressedHandler: function(event) {
				if(event.keyCode === 13){
					$(event.currentTarget).trigger('change', { forceUpdate: true });
				}
			},

			fireUpdate: function(event) {
				if (event) {
					event.preventDefault();
				}
				this.parent.$ctx.trigger(this.parent.Events.update, this.Filter);
			},

			changeEventHandler: function(event, data) {
                var el = event.data.element,
					name, value;
				if (el) {
					value = this.getInputValue($(event.currentTarget));
					name = el.data('filter-name');
					this.Filter[name] = value;
					this.parent.setCookieValue(name, value);
					if ((el.data('filter-autoupdate') !== 'false' && el.data('filter-autoupdate') !== false) ||
						(data && data.forceUpdate === true)) {
						this.fireUpdate();
					}
				}
			},

			getInputType: function(input) {
				if (input && input.length > 0) {
					return input[0].type || input[0].tagName.toLowerCase();
				}
				return null;
			},

			getInputValue: function(input) {
				var type = this.getInputType(input),
					value = null;
				if (type === 'radio' || type === 'checkbox') {
					value = [];
					$(':input[name="' + input.attr('name') + '"]', this.element).each(function() {
						if ($(this).is(':checked')) {
							value.push(this.value);
						}
					});
				} else {
					value = input.val();
				}
				return value;
			},

			setInputValue: function(input, value) {
				var type = this.getInputType(input);
				if (type === 'radio' || type === 'checkbox') {
					$(':input[name="' + input.attr('name') + '"]', this.element).each(function() {
						if (this.value === value || (value instanceof Array && $.inArray(this.value, value) >= 0)) {
							var $this = $(this);
							$this.prop('checked', true);
							$this.trigger('change');
						}
					});
				} else if (type) {
					input.val(value);
					input.trigger('change');
				}
			}
		}
	});

}(Tc.$, window.SCS = window.SCS || {}));

}.call(window));

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_Tc_dot_$) {/*** IMPORTS FROM imports-loader ***/
var loadTerrific = __webpack_require__(1);
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function ($, Tc, SCS, undefined) {
	'use strict';

	/**
	 * Newsletter Module
	 *
	 * @author Reto Zigerlig
	 * @namespace Tc.Module
	 * @class ScNewsletter
	 * @extends Tc.Module
	 */
	Tc.Module.ScNewsletter = Tc.Module.extend({

		/**
		 * Initializes ScNewsletter and attaches events
		 *
		 * @method on
		 * @param {Function} callback function
		 * @return void
		 */
		on: function (callback) {
			var mod = this,
				$ctx = mod.$ctx,
				$form = $ctx.find('form');

			// Remove the formstart for compatibility reasons with legacy newsletter
			$form.find('[name=":formstart"]').remove();

			// Attach the newsletter specific selector for the legacy newsletter submit servlet
			var defaultAction = $form.attr('action');
			if (defaultAction) {
				// the newsletter selector has to be first, we just remove all other selectors
				var updatedAction = defaultAction.replace(/\/([^/.]+)(\.[^/]+)?\.html/, '/$1.newsletter.html');
				// action for info page (update)
				if (updatedAction.indexOf('type=info') > -1) {
					updatedAction = SCS.Url.updateQueryStringParameter(updatedAction, "type", "update");
				}
				$form.attr('action', updatedAction);
				debug.log('Tc.Module.ScNewsletter', updatedAction);
			}

			// prefill values
			var json = $ctx.data('subscription');
			$ctx.find('input[type="checkbox"][value="' + (json.tags || []).join('"], input[type="checkbox"][value="') + '"]').prop('checked', true).trigger('change');
			$ctx.find('input[type="text"][data-bind="value:email"]').val(json.email || '');
			$ctx.find('input[type="radio"][value="' + (json.language || '') + '"]').prop('checked', true).trigger('change');
			debug.log('Tc.Module.ScNewsletter', json.tags, json.email, json.language);

			callback(); // this MUST be called!
		}
	});
}(__webpack_provided_window_dot_Tc_dot_$, window.Tc, window.SCS));
}.call(window));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var loadTerrific = __webpack_require__(1);
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function($, SCS) {
	/*
	 * Dependencies:
	 * TerrificJs 2.0.1,
	 * jQuery 1.7 or greater,
	 * jquery.placeholder.min.js,
	 * SCS.utils
	 *
	 */

	'use strict';
	/*globals Tc */

	/**
	 * SmoToken Implementation
	 *
	 * @author Matthias Inauen
	 * @namespace Tc.Module
	 * @class SmoToken
	 * @extends Tc.Module
	 */
	Tc.Module.SmoToken = Tc.Module.extend({
		/**
		 * Hook function to do all of your module stuff.
		 *
		 * @method on
		 * @param {Function} callback function
		 * @return void
		 */
		on: function(callback) {
			this.originalSubmitButton = this.$ctx.find('.button-indent');
			this.secondSubmitButton = this.originalSubmitButton.clone();
			this.phoneField = this.$ctx.find('input[type=tel]');
			this.emailField = this.$ctx.find('input[type=email]');
			this.phoneParentField = this.phoneField.closest('.field');
			this.emailParentField = this.emailField.closest('.field');
			this.smotokenform = this.$ctx.find('form');

			this.phoneParentField.closest('.textfield.section').append(this.originalSubmitButton);
			this.emailParentField.closest('.textfield.section').append(this.secondSubmitButton);

			this.originalSubmitButton.on('click', $.proxy(this.handleSubmitButtonClick, this));
			this.secondSubmitButton.on('click', $.proxy(this.handleSubmitButtonClick, this));

			this.phoneField.on('keypress', $.proxy(this.handleKeyPressPhone, this));
			this.emailField.on('keypress', $.proxy(this.handleKeyPressEmail, this));

			callback();
		},

		handleSubmitButtonClick: function (event){
			if($(event.currentTarget).is(this.originalSubmitButton)) {
				this.handleInputFieldFocusInPhone();
			}
			else {
				this.handleInputFieldFocusInEmail();
			}
		},

		handleInputFieldFocusInPhone: function (){
			this.emailField.val('');
			this.setRequiredOfField(this.phoneParentField, true);
			this.setRequiredOfField(this.emailParentField, false);
		},

		handleInputFieldFocusInEmail: function (){
			this.phoneField.val('');
			this.setRequiredOfField(this.emailParentField, true);
			this.setRequiredOfField(this.phoneParentField, false);
		},

		handleKeyPressPhone: function (event){
			if(event.which == 13) {
				event.preventDefault();
				this.handleInputFieldFocusInPhone();
				this.smotokenform.trigger('submit');
			}
		},

		handleKeyPressEmail: function (event){
			if(event.which == 13) {
				event.preventDefault();
				this.handleInputFieldFocusInEmail();
				this.smotokenform.trigger('submit');
			}
		},

		setRequiredOfField: function(field, value) {
			var clientValidation = field.data('clientvalidation');
			if (clientValidation) {
				clientValidation.required = value;
				field.data('clientvalidation', clientValidation);
				field.attr('data-clientvalidation', clientValidation);
			}
		}
	});

}(Tc.$, window.SCS = window.SCS || {}));
}.call(window));

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var loadTerrific = __webpack_require__(1);
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function ($) {
	var socialMedia = __webpack_require__(40).getController();
	var encodeCount = __webpack_require__(40).encodeCount;


	'use strict';
	/*globals Tc, debug */

	/**
	 * Social Share Button Implementation
	 *
	 * @author Matthias Inauen, Marc Althoff
	 * @namespace Tc.Module
	 * @class SocialShare
	 * @extends Tc.Module
	 */
	Tc.Module.SocialShare = Tc.Module.extend({
		/**
		 * Hook function to do all of your module stuff.
		 *
		 * @method on
		 * @param {Function} callback function
		 * @return void
		 */
		on: function (callback) {
			var mod = this;
			mod.displayAggregatedShareCount = mod.$ctx.hasClass('skinSocialShareTeaser') ? true : false;
			mod.displayShareCount = mod.$ctx.hasClass('showShareCount');
			mod.attachEvents();

			// init share count if enabled on the module
			if (mod.displayShareCount) {
				if (mod.displayAggregatedShareCount) {
					// init aggregated share count on the teaser
					mod.initAggregatedShareCountBadges();
				} else {
					// init individual button share count on a series of buttons
					mod.initButtonShareCountBadges();
				}
			}

			callback();
		},

		/**
		 * Returns a list of active social media services in this module
		 *
		 * @method getActiveServices
		 * @returns {Array}
		 */
		getActiveServices: function () {
			var mod = this,
				services = [],
				service;
			// run through all share-buttons. Stored on the <a> descendant
			// is a data property called service, which contains the name of the
			// service this button represents.
			mod.$ctx.find('.share-button').each(function () {
				service = $(this).find('> a').data('service');
				if (service) {
					services.push(service);
				}
			});

			return services;
		},

		/**
		 * Attach click events to buttons:
		 * Show popups instead of direct links
		 *
		 * @method attachEvents
		 * @return void
		 */
		attachEvents: function () {
			var mod = this;

			// Print triggers a simple window.print
			mod.$ctx.find('.share-button.print > a').on('click', $.proxy(mod.printPage, mod));

			// Anything else gets sent to track & trigger
			mod.$ctx.find('.share-button:not(".print") > a').on('click', $.proxy(mod.shareThisPage, mod));
		},

		/**
		 * Print the page
		 *
		 * @method printPage
		 */
		printPage: function () {
			window.print();
		},

		shareThisPage: function(event) {
			var mod = this,
				urlToTrackInRoamingTool,
				clickedShareButton = $(event.target).closest('.share-button'), // get the share button in which the <a> was clicked
				serviceName = clickedShareButton.find('a').data('service');

			// for some services we can not read the share count back from the external service
			// hence, we track it in a swisscom internal database
			if((serviceName === 'mail' ||
				serviceName === 'xing' ||
				serviceName === 'linkedin' ||
				serviceName === 'facebook' ||
				serviceName === 'whatsapp' ||
				serviceName === 'twitter') &&
				!clickedShareButton.data('alreadySharedOnce')) {
				urlToTrackInRoamingTool = SCS.Url.stripProtocolFromUrl($('link[rel=canonical]').attr('href')) || window.SCS.Url.stripPathPrefixFromUrl(document.location.hostname + document.location.pathname);
				mod.trackClickCountInternally(urlToTrackInRoamingTool, serviceName);
			}

			// open the share dialog to allow the user to post the url to their stream on
			// the according profile
			if( serviceName !== 'mail' ){
				event.preventDefault();
				mod.displayShareDialog(event.currentTarget.href);
			}

			// add the click count to the button
			mod.addClickCount(clickedShareButton);
		},


		/**
		 * trackClickCountInternally - write the click count to a swisscom database
		 *
		 * @method trackClickCountInternally
		 * @param url - the url to track
		 * @param serviceName - the name of the service
		 */
		trackClickCountInternally: function (url, serviceName) {
			$.ajax({
				method: 'POST',
				type: 'POST',
				url: '/portal-app/roamingtool/public/social-media-statistics',
				data: JSON.stringify({url: encodeURI(url), service: serviceName}),
				contentType: 'application/json; charset=utf-8',
				dataType: 'json'
			});
		},

		displayShareDialog: function(dialogUrl) {
			var w = 500,
				h = 500,
				left = (screen.width / 2) - (w / 2),
				top = (screen.height / 2) - (h / 2);

			window.open(dialogUrl, 'socialShareWindow', 'toolbar§=no, location=no, status=no, menubar=no, scrollbars=yes, resizable=yes, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left);
		},

		/**
		 * Fakes the share count increase on the client side, without provoking a page reload.
		 * @param shareButton
		 */
		addClickCount: function (shareButton) {
			if (!shareButton.data('alreadySharedOnce')) {
				// update the badge
				this.addShareCountToShareButton(shareButton, 1, shareButton.find('.shareWithCount'));
				// Lock the element from adding further share counts
				shareButton.data('alreadySharedOnce', 'true');
			}
		},

		/**
		 * Update the share count on the button, if displaying of button is configured
		 * If there is already a button with a share count, the new share count will be added.
		 *
		 * @param button - jquery object. Expected to be of type '.share-button'
		 * @param newShareCount - Number - the new share count to add to the button
		 * @param shareCountParent - jquery object - The parent where to append the share Count Badge to.
		 */
		addShareCountToShareButton: function (button, newShareCount, shareCountParent) {
			if (this.displayShareCount) {
				var badge, shareCount;

				if (newShareCount > 0) {
					// get the current badge or create a new one.
					badge = (button.find('.badge').length) ? button.find('.badge') : $('<span class="badge"/>');
					shareCount = (badge.data('actualShareCount')) ? badge.data('actualShareCount') : 0;
					shareCount += newShareCount;
					badge.text(encodeCount(shareCount));
					// store the actual share count so 2999 + 1 will result in the display of 3K
					badge.data('actualShareCount', shareCount);
					// if it's a new badge. append it to the right place
					if (!badge.parent().length && shareCountParent) {
						shareCountParent.append(badge);
					}
				}
			}
		},

		/**
		 * Initialize Share Count Badges on the share buttons
		 */
		initButtonShareCountBadges: function () {
			var mod = this, button;
			$.each(mod.getActiveServices(), function (index, service) {
				socialMedia.shareCount(service)
					.then(function (rv) {
						button = mod.$ctx.find('.share-button').has('a[data-service=' + service + ']');
						mod.addShareCountToShareButton(button, rv.count, button.find('.shareWithCount'));
					}, function () {
						debug.log('Tc.Module.SocialShare.js >> promise rejected >> service: ', service);
					});
			});
		},

		initAggregatedShareCountBadges: function () {
			var mod = this,
				shareCount = mod.$ctx.find('.shareCount'),
				commentCount = mod.$ctx.find('.commentCount');
			// separate call for all social media
			socialMedia.shareCount(socialMedia.servicesByCategory('shareCount'), shareCount.data('fullurl'))
				.then(function (rv) {
					if (rv.counts) {
						shareCount.removeClass('hidden');
					}
					mod.addShareCountToShareButton(shareCount, rv.counts, shareCount);
				}, function () {
					mod.log('aggregate share count rejected. Services aggregated ', socialMedia.servicesByCategory('shareCount'));
				});

			// separate call for disqus
			socialMedia.shareCount('disqus', commentCount.data('disqusUrl'))
				.then(function (rv) {
					if (rv.count) {
						commentCount.removeClass('hidden');
					}
					mod.addShareCountToShareButton(commentCount, rv.count, commentCount);
				}, function () {
					mod.log('Tc.Module.SocialShare.js >> disques count rejected.');
				});
		}
	});
}(Tc.$, window, window.SCS));
}.call(window));

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var loadTerrific = __webpack_require__(1);
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function($,w,SCS) {
	'use strict';
	/*globals Tc,doT,debug,tvDialogs */

	/**
	 * Stage Carousel.
	 *
	 * @author Dave Talamona
	 * @namespace Tc.Module
	 * @class StageCarousel
	 * @extends Tc.Module
	 */

	Tc.Module.StageCarousel = Tc.Module.extend({

		/**
		 * Does all the work.
		 *
		 * @method on
		 * @param {Function} callback function
		 * @return void
		 */
		on: function(callback) {
			var mod = this;

			mod.initialize();

			callback();
		},

		initialize: function() {
			var mod = this,
				initialPosition = 1,
				initialized = false,
				carousel,
				wrapper = this.$ctx.parents('.stageCarousel-wrapper'),
				slideList = this.$ctx.find('ul.carousel-list > li');
			if (slideList.length <= 2) {
				initialPosition = 0;
			}

			carousel = mod.$ctx.stageCarousel_scCarousel({
				position: initialPosition,
				onBeforeAnimation: function (carousel, activeItem, futureItem, newPos, oldPos, totalListItems) {
					if (initialized) {
						$(activeItem)
							.removeClass('active')
							.transition({ opacity: 0.34 }, carousel.options.animation.duration, carousel.options.animation.easing);
						$(futureItem)
							.addClass('active')
							.transition({ opacity: 1 }, carousel.options.animation.duration, carousel.options.animation.easing);
						wrapper.find('.slide-background-image').each(function(){
							var img = $(this);
							if (img.hasClass('index-' + newPos)) {
								img.addClass('active');
							} else {
								img.removeClass('active');
							}
						});

					}
				},
				onAfterInit: function() {
					slideList.each(function(index) {
						$(this).find('.slide-background-image').each(function() {
							var img = $(this);
							img.addClass('index-' + index);
							if (index == initialPosition) {
								img.addClass('active');
							}
							wrapper.prepend(img.detach());
						});
					});
					wrapper.siblings('.stageCarousel-place-holder').height(wrapper.height());
				}
			});

			// activate item at the initial position
			mod.$ctx.find('.carousel-list > li:eq(' + initialPosition + ')').addClass('active').css('opacity', 1);

			// prevent klicks on "inactive" items
			// open links in snoopy-overlays
			mod.$ctx.on('click', '.carousel-list a', function (e) {
				if (!$(this).hasClass('allow-default-event') && !$(this).hasClass('action-link')) {
					e.preventDefault();
				}
			});

			initialized = true;
		}
	});
})(Tc.$, window, window.SCS = window.SCS || {});





/*
* !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
* The following carousel is a copy of the old scCarousel (before swipe-refactoring) and is only used for the
* Tc.Module.StageCarousel because the principle this carousel is not possible to realize with the new one.
* !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
* */

(function ($) {
	/**
	 * Swisscom Carousel
	 *
	 * @author David Talamona
	 * @namespace SCS
	 * @class stageCarousel_scCarousel
	 */
	"use strict";

	var defaults = {
		selectors: {
			prevButton: '.carousel-prev',
			nextButton: '.carousel-next',
			disabledButton: '.disabled',
			pagerItems: '.carousel-control > a',
			clip: '.carousel-clip',
			list: 'ul.carousel-list',
			listItems: '',								// optional, by default the direct children of the list are taken
			otherFocusGrabbers: []
		},
		setItemWidth: false,
		pagerItemsActiveCls: 'selected',
		position: 0,
		noItemsCls: 'noScrolling',
		disabledButtonCls: 'disabled',
		animation: {
			duration: 500,
			easing: ''
		}
	};

	var carousel = function (e, o) {
		var me = this; // local scope inside cascaded functions

		this.options = $.extend({}, defaults, o || {});
		this.container = $(e);
		this.clip = this.container.find(this.options.selectors.clip);
		this.list = this.clip.find(this.options.selectors.list);
		this.listItems = this.options.selectors.listItems && this.options.selectors.listItems.length ? this.list.find(this.options.selectors.listItems) : this.list.children();

		// get navigation-buttons and paging-navigation
		this.prevButton = this.container.find(this.options.selectors.prevButton);
		this.nextButton = this.container.find(this.options.selectors.nextButton);
		this.pagingItems = this.container.find(this.options.selectors.pagerItems);

		// find and store all link items
		this.linkItems = this.listItems.find('A');

		// disable tabbing to all links
		this.linkItems.attr('tabindex', -1);

		// definitions
		this.position = this.options.position;
		this.isAnimating = false;

		// initial DOM manipulations
		this.listItemWidth = Math.max(this.clip.width(), this.options.setItemWidth ? 0 : this.listItems.filter(':eq(0)').outerWidth(true));
		this.list.width((this.listItemWidth + 10) * this.listItems.length); // 10 px addition for tolerance
		if (this.options.setItemWidth) {
			// recalculate itemWidth because scrollbar might have been gone after setting the list-width to "infinity"
			this.listItemWidth = this.clip.width();
			this.list.width((this.listItemWidth + 10) * this.listItems.length); // 10 px addition for tolerance
			// set width of the list-items
			this.listItems.width(this.listItemWidth);
		}
		if (this.listItems.length <= 1) {
			this.container.addClass(this.options.noItemsCls);
		}
		this.updateNavigationStates();

		// bind events to the navigation buttons
		this.prevButton.on('click', function (e) {
			e.preventDefault();
			if (!me.prevButton.hasClass(me.options.selectors.disabledButton)) {
				me.slideTo(me.position - 1);
			}
		});
		this.nextButton.on('click', function (e) {
			e.preventDefault();
			if (!me.nextButton.hasClass(me.options.selectors.disabledButton)) {
				me.slideTo(me.position + 1);
			}
		});

		// bind events to the pagination
		this.pagingItems.each(function (i) {
			$(this).data('carousel-paging-index', i);
		});
		this.pagingItems.on('click', function (e) {
			me.slideTo($(this).data('carousel-paging-index'));
			e.preventDefault();
		});

		// bind keyboard events
		if (!this.options.selectors.otherFocusGrabbers) {
			this.options.selectors.otherFocusGrabbers = [];
		}
		this.container.add(this.options.selectors.otherFocusGrabbers.join(', ')).on('keyup', function (e) {
			if (e.which === 37) { // LEFT
				me.slideTo(me.position - 1);
			} else if (e.which === 39) { // RIGHT
				me.slideTo(me.position + 1);
			}
		});

		if (this.position > -1) {
			$.fx.off = true;
			me.slideTo(me.position);
			$.fx.off = false;
			me.isAnimating = false;
		}

		this.fireEvent('onAfterInit');
	};

	$.extend(carousel.prototype, {

		fireEvent: function () {
			// convert arguments-object (is not a real array) into an array
			var params = [];
			for (var i=0; i < arguments.length; i++) {
				params.push(arguments[i]);
			}

			var event = params.shift();

			if (typeof this.options[event] === 'function') {
				params.unshift(this);
				this.options[event].apply(this.container[0], params);
			}
		},

		updateNavigationStates: function () {
			this.prevButton[this.position > 0 ? 'removeClass' : 'addClass'](this.options.disabledButtonCls);
			this.nextButton[this.position+1 < this.listItems.length ? 'removeClass' : 'addClass'](this.options.disabledButtonCls);
			this.pagingItems
				.removeClass(this.options.pagerItemsActiveCls)
				.filter(':eq(' + this.position + ')').addClass(this.options.pagerItemsActiveCls);
		},

		slideTo: function (newPos) {
			newPos = newPos < 0 ? 0 : (newPos > this.listItems.length-1 ? this.listItems.length-1 : newPos);
			if (this.isAnimating) {
				return;
			}
			var me = this; // local scope inside cascaded functions
			var activeItem = this.listItems.filter(':eq(' + this.position + ')');
			var futureItem = this.listItems.filter(':eq(' + newPos + ')');
			this.fireEvent('onBeforeAnimation', activeItem[0], futureItem[0], newPos, this.position, this.listItems.length);
			var oldPos = this.position;
			this.position = newPos;
			this.updateNavigationStates();
			if (typeof futureItem.position() !== 'undefined') {
				this.list.transition({'right': futureItem.position().left + 'px'}, this.options.animation.duration, this.options.animation.easing, function () {
					me.isAnimating = false;
					me.fireEvent('onAfterAnimation', activeItem[0], futureItem[0], me.position, oldPos, me.listItems.length);
				});
				this.isAnimating = true;
			}
		},

		updateWidth: function (newItemWidth) {
			this.listItemWidth = newItemWidth ? newItemWidth : this.clip.width();
			if (this.options.setItemWidth) {
				this.listItems.width(this.listItemWidth);
			}
			this.list.width((this.listItemWidth + 10) * this.listItems.length); // 10 px addition for tolerance
			// stop currently running animation
			this.list.stop(true);
			this.isAnimating = false;
			// set list-position to the new position regarding the new item-sizes
			var activeItem = this.listItems.filter(':eq(' + this.position + ')');
			this.list.css({'right': activeItem.position().left + 'px'});
		}

	});

	$.fn.stageCarousel_scCarousel = function (o) {
		var $this = $(this);
		if ($this.length === 1 && $this.data('stageCarousel_scCarousel')) {
			return $this.data('stageCarousel_scCarousel');
		} else {
			return this.each(function () {
				var $this = $(this);
				if (!$this.data('stageCarousel_scCarousel')) {
					$this.data('stageCarousel_scCarousel', new carousel(this, o));
				}
			});
		}
	};

})(Tc.$);
}.call(window));

/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var loadTerrific = __webpack_require__(1);
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function($) {
	'use strict';
	/*globals Tc */

	/**
	 * SupportAgentStatus
	 *
	 * @author Walid Ghazzo
	 * @namespace Tc.Module
	 * @class SupportAgentStatus
	 * @extends Tc.Module
	 */

	Tc.Module.SupportAgentStatus = Tc.Module.extend({

		on: function(callback) {

			$('html').addClass('hasAdditionalTopBar');
			callback();

		}

	});
}(Tc.$));
}.call(window));

/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var loadTerrific = __webpack_require__(1);
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function($, SCS) {
	"use strict";
	/*globals Tc */

	/**
	 * Tablesorter
	 *
	 * @author Roland Rüger
	 * @namespace Tc.Module
	 * @class TableSorter
	 * @extends Tc.Module
	 */

	Tc.Module.TableSorter = Tc.Module.extend({

		/**
		 * Inititialize
		 *
		 * @method on
		 * @param {Function} callback function
		 * @return void
		 */
		on: function(callback) {
			var mod = this,
				$ctx = mod.$ctx;

			if (!SCS.utils.isMobilePage()){

				$ctx.find('table').tablesorter({
					headers: {
						2: {sorter: false},
						3: {sorter: false}
					},
					sortList: [[0,0]]
				});

				$ctx.find('.sorter-false').empty();
			}

			callback();
		}
	});
}(Tc.$, window.SCS));
}.call(window));

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var loadTerrific = __webpack_require__(1);
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function($, SCS, doc) {
	'use strict';
	/**
	 * Basic Skin implementation for the Default module.
	 *
	 * @author Rami Attallah
	 * @namespace Tc.Module.TableSorter
	 * @class DirectOrderFilter
	 * @extends Tc.Module
	 */

	Tc.Module.TableSorter.DirectOrderFilter = function(parent) {
		/**
		 * override the appropriate methods from the decorated module (ie. this.get = function()).
		 * the former/original method may be called via parent.<method>()
		 */
		this.on = function(callback) {
			var mod = this,
				$ctx = mod.$ctx,
				output = '',
				productGroups = [];

			mod.isMobile = SCS.utils.isMobilePage();

			if (mod.isMobile){
				mod.wrapLinks();
				mod.makeFilterCollapsible();
			}

			mod.$productGroup = $ctx.find('.product-group');

			mod.$productGroup.each(function() {
				productGroups.push($.trim($(this).text()));
			});

			if (productGroups.length > 1) {
				var len = $.distinct(productGroups).length;
				output += (mod.isMobile) ? '<ul class="direct-order-filter-list modScForm">' : '<ul class="direct-order-filter-list">';
				$.each($.distinct(productGroups), function( index, value ) {
					output += '<li' + ((len === index + 1) ? ' class="last"' : '') + '>';
					output += '<div class="custom-checkbox">';
					output += '<label><input type="checkbox" data-role="none" name="' + value + '" id="directOrderfilterCheckbox' + index + '" value="' + value + '"/>';
					output += '<span class="checkbox-control" role="checkbox" aria-checked="false" data-role="none"></span>' + value + '</label>';
					output += '</div>';
					output += '</li>';
				});

				output += '</ul>';
				$ctx.find('div.direct-order-container').append(output);
				$ctx.find('div.direct-order-container input:checkbox').scsCustomCheckbox();
			}

			$ctx.on('change', 'div.direct-order-container input:checkbox', function() {
				mod.filterTable(mod.getFilterValues());
				if (mod.isMobile) mod.toggleFilterInList(this);
			});

			mod.$ctx.on('click', '.filterParamRemove', function(){
				var id = $(this).closest('li').attr('data-id');
				$(doc.getElementById(id)).trigger('click');
			});

			// calling parent method
			parent.on(callback);
		};

		/**
		 *
		 * @returns {Array<String>}
		 */
		this.getFilterValues = function() {
			var mod = this,
				filterValues = [],
				$activeFilters = mod.$ctx.find('div.direct-order-container input:checkbox:checked');

			$activeFilters.each(function() {
				filterValues.push($(this).val());
			});

			return filterValues;
		};

		this.filterTable = function(filterValues) {

			var mod = this;

			if ($.isArray(filterValues) === false) {
				return false;
			}

			if (filterValues.length === 0) {
				mod.$productGroup.closest('tr').removeClass('is-hidden');
			} else {
				mod.$productGroup.each(function() {
					var productGroupValue = $.trim($(this).text());

					$(this).closest('tr').toggleClass('is-hidden', ($.inArray(productGroupValue, filterValues) === -1));

				});
			}

			return true;

		};

		/* Add necessary linklist markup for mobile version */
		this.wrapLinks = function() {
			var mod = this,
				$ctx = mod.$ctx;

			$('.product-detail-link', $ctx).each(function(){
				var $this = $(this),
					$toRemove = $this.parent();

				$this.appendTo($this.parent().prev('td'));
				$toRemove.remove();
			});

			$('.product-links', $ctx).append('<ul class="link-list"></ul>');

			$('.product-links > a, .product-links > span', $ctx).each(function(){
				var $this = $(this);
				$this.parent().find('br').remove();
				$this.appendTo($this.closest('.product-links').find('ul.link-list')).wrap('<li></li>');
			});

            /*  hide empty detail links for mobile */
            $('.product-detail-link', $ctx).each(function() {
                var $this = $(this);
                if ($this.attr('href') == '' || $this.text() == '' ) {
                    $this.parent().hide();
                } else {
                    $this.parent().show();
}
            });

		};

		this.makeFilterCollapsible = function() {
			var mod = this,
				$ctx = mod.$ctx;

			$ctx.find('.filter-title').append('<span class="arrow-down"></span>').wrapInner('<a href="#"></a>');

			$ctx.on('click', '.filter-title a', function(e){
				e.preventDefault();
				var $this = $(this),
					$arrow = $this.children('span');

				if ($arrow.hasClass('arrow-down')){
					$arrow.removeClass('arrow-down').addClass('arrow-up');
					$ctx.find('.direct-order-filter-list').slideDown(300);
				} else {
					$arrow.removeClass('arrow-up').addClass('arrow-down');
					$ctx.find('.direct-order-filter-list').slideUp(300);
				}

			});
		};

		this.toggleFilterInList = function(elem){
			var mod = this,
				$ctx = mod.$ctx,
				$elem = $(elem),
				id = $(elem).attr('id'),
				value = $(elem).val(),
				$filterList = ($ctx.find('.filter-breadcrumb').length) ? $ctx.find('.filter-breadcrumb') : $('<ul class="filter-breadcrumb"></ul>').insertAfter('.direct-order-filter-list', $ctx);

			if ($filterList.find('li[data-id="' + id + '"]').length){
				$filterList.find('li[data-id="' + id + '"]').remove();
				if (!$filterList.find('li').length) $filterList.remove();
			} else {
				$filterList.append('<li data-id="' + id + '">' + value + ' <span class="filterParamRemove close-icon"></span></li>');
			}
		};

	};
})(Tc.$, window.SCS, document);
}.call(window));

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_Tc_dot_$) {/*** IMPORTS FROM imports-loader ***/
var loadTerrific = __webpack_require__(1);
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function (Module, SCS, $) {
	/*
	 * Dependencies:
	 * TerrificJs 2.0.1,
	 * jQuery 1.7 or greater,
	 * jquery.placeholder.min.js,
	 *
	 */

	'use strict';
	/*jshint smarttabs:true */

	var deparam = __webpack_require__(8).default;

	Module.TabNavigation = Module.extend({
		CHANNEL_GENERIC: 'TabNavigation',

		INDICATOR_HALF_WIDTH: 10,

		currentTabIndex: null,
		lastTracked: '',

		// @Overridable by skins
		on: function (callback) {
			var mod = this;
			mod.channel = mod.CHANNEL_GENERIC + SCS.utils.getUniqueIdOfElement(mod.$ctx);
			mod.name = mod.$ctx.data('name') || mod.channel;
			// FIXME: Is there a reason why we don’t use mod.$ctx.find('> .navigation-bar .tab-navigation-tab') and drop the filter?
			mod.tabs = mod.$ctx.find('.tab-navigation-tab').filter(function () {
				return mod.isResponsibleFor($(this)) && $(this).closest('.bottom-tab-links').length === 0;
			});
			mod.trackingEnabled = mod.$ctx.data('tracking-enabled') || false;
			// mod.track(mod.tabs.filter('.active'), true);
			mod.pageBackgroundContainer = $('.modPageBackground');
			mod.defaultTitle = $('.navigation-bar h1', mod.$ctx).eq(0).text();
			mod.activeIndicator = $('.indicator', mod.$ctx);
			mod.bottomBorderLeftItem = $('.border-bottom:eq(0) > div', mod.$ctx).eq(0);
			mod.initHandlers();
			mod.sandbox.subscribe(mod.CHANNEL_GENERIC, mod);
			mod.sandbox.subscribe(mod.channel, mod);
			mod.fire('startSubscription', [mod.CHANNEL_GENERIC]);
			$(window).resize(function () {
				mod.updateIndicatorWidth();
			});
			mod.hasMobileQtip = mod.$ctx.find('.modCallOut').length && SCS.utils.isMobilePage();

			callback();
		},

		// @Overridable by skins
		initHandlers: function () {
			var mod = this;
			mod.tabs.on('click', $.proxy(mod.tabClickedHandler, mod));
		},

		onSubscribe: function (data) {
			var mod = this,
				index = data.index;
			if (mod.isResponsibleFor(data.element, data.name, data.type === 'content')) {
				if (data.type === 'content') {
					data.subscribe(mod.channel, mod.name, index);
				} else {
					data.subscribe(mod.channel, mod.name);
				}
			}
		},

		isResponsibleFor: function (content, name, isTabContent) {
			var mod = this,
				isResponsible = mod.name === name || mod.$ctx.is(content.closest('.modTabNavigation'));
			if (isTabContent && isResponsible && content.closest('.modTabNavigation').is(content.parent().closest('.modTabNavigationContent').closest('.modTabNavigation'))) {
				return false;
			}
			return isResponsible;
		},

		// @Overridable by skins
		after: function () {
			var mod = this,
				hashValueStr = location.hash.substr(1),
				hashValues,
				activeTab = mod.tabs.filter('.active');

			if (hashValueStr) {
				hashValues = deparam(hashValueStr);
				var activatedByHash = false;
				mod.tabs.each(function () {
					var tab = $(this);
					var selector = tab.data('hash-selector');
					if (selector in hashValues) {
						activeTab = tab;
						activatedByHash = true;
						return false;
					}
				});
				if (!activatedByHash) {
					// Legacy handling
					mod.tabs.each(function () {
						var tab = $(this);
						if (tab.attr('data-index') === hashValueStr) {
							activeTab = tab;
							activatedByHash = true;
							return false;
						}
					});
				}
			}
			if (activeTab.length) {
				mod.moveActiveIndicator();
				mod.activateTab(activeTab);
			}
		},

		onActivateContent: function (data) {
			var mod = this;
			if (data.index) {
				mod.activateTab(mod.tabs.eq(data.index - 1));
			}
		},

		// @Overridable by skins
		tabClickedHandler: function (event) {
			var mod = this;
			event.preventDefault();
			var tab = $(event.currentTarget);
			if (tab.is('.active')) {
				return;
			}

			mod.activateTab(tab);
			mod.track(tab);
		},

		// @Overridable by skins
		activateTab: function (activatedTab) {
			var mod = this;
			var backgroundSettings = null;
			var index = activatedTab.data('index');
			var previouslyActiveTab = mod.tabs.filter('.active');

			if (previouslyActiveTab.data('use-custom-background')) {
				backgroundSettings = [];
			}
			previouslyActiveTab.removeClass('active');

			mod.currentTabIndex = index;
			mod.animateIndicator(activatedTab);
			activatedTab.addClass('active');

			$('.navigation-bar h1', mod.$ctx).eq(0).text(activatedTab.data('dynamic-title') ? activatedTab.data('dynamic-title') : mod.defaultTitle);

			if (activatedTab.data('use-custom-background')) {
				backgroundSettings = [
					activatedTab.data('background-image'),
					activatedTab.data('background-color'),
					activatedTab.data('background-repeat-x'),
					activatedTab.data('background-repeat-y')
				];
			}

			if (backgroundSettings !== null) {
				mod.pageBackgroundContainer.trigger('setBackground', backgroundSettings);
			}

			if(mod.hasMobileQtip) {
				$('.qtip-close').trigger('click');
			}

			mod.fire('activateTab', {
				index: index
			}, [mod.channel]);
		},

		track: function (element) {

			var mod = this;

			if (!mod.trackingEnabled || !element || element.length <= 0) {
				return;
			}

			var trackingName = element.data('tracking-name') || element.text();

			element.parents('.modTabNavigation').each(function (index) {
				element = $(this).find('a.tab-navigation-tab.active');
				var trackingText = element.data('tracking-name') || element.text();
				if (index === 0) {
					trackingName = trackingText;
				} else {
					trackingName = trackingText + '/' + trackingName;
				}
			});

			if (mod.lastTracked === trackingName) {
				return;
			} else {
				mod.lastTracked = trackingName;
				SCS.tracking.trackPartialPageView(trackingName);
			}

			// SCS.portal.datalayer.appendPagePath(trackingName);
			//if (!isInitialTracking) {
			// SCS.tracking.trackPartialPageView(trackingName);
			//}
		},

		animateIndicator: function () {
			if (!this.$ctx.hasClass('single-tab')) {
				this.makeAnimation(0, 12, $.proxy(this.moveActiveIndicator, this));
			}
		},

		makeAnimation: function (endValue, step, callback) {
			var mod = this,
				isIE = (mod.activeIndicator.css('backgroundPosition') === undefined),
				backgroundPosition = ( isIE ) ? mod.activeIndicator.css('background-position-y') : mod.activeIndicator.css('backgroundPosition').split(' ')[1],
				currentValue = parseInt(backgroundPosition, 10);

			var interval = setInterval(function () {
				if (typeof(currentValue) !== 'undefined' && (step > 0 && currentValue < endValue) || (step < 0 && currentValue > endValue)) {
					currentValue += step;
					if (isIE) {
						mod.activeIndicator.css('background-position-y', currentValue);
					}
					else {
						mod.activeIndicator.css('backgroundPosition', '0px ' + currentValue + 'px');
					}
				}
				else {
					clearInterval(interval);
					if (typeof(callback) === 'function') {
						callback();
					}
				}

			}, 10);
		},

		updateIndicatorWidth: function () {
			var mod = this,
				activeTab = this.tabs.filter('.active');

			if(!activeTab.length) {
				return;
			}

			var leftItemWidth = Math.floor(activeTab.position().left) + Math.floor((activeTab.width() / 2)) - this.INDICATOR_HALF_WIDTH;

			mod.bottomBorderLeftItem.width(leftItemWidth);
		},

		moveActiveIndicator: function () {
			var mod = this;
			if (!mod.$ctx.hasClass('single-tab')) {
				mod.updateIndicatorWidth();
				mod.makeAnimation(-120, -12);
			}
		}
	});

}(window.Tc.Module, window.SCS, __webpack_provided_window_dot_Tc_dot_$));
}.call(window));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_Tc_dot_$) {/*** IMPORTS FROM imports-loader ***/
var loadTerrific = __webpack_require__(1);
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function (Module, $, SCS) {
	'use strict';

	Module.TabNavigation.DeprecatedTabs = function (parent) {
		// @Override
		this.on = function (callback) {
			this.tabContentsParents = this.$ctx.find('> .tabs > .tab');
			this.errorMessage = this.$ctx.nextAll('.tab-content-error').eq(0);
			var mod = this;

			mod.tabs = mod.$ctx.find('> .navigation-bar .tab-navigation-tab');

			// Mark first tab active if none is active
			if(!this.tabs.filter('.active').length) {
				this.tabs.eq(0).addClass('active');
			}

			// If two or more Tabs are active. Only the first will be active
			if(this.tabs.filter('.active').length > 1 ){
				this.tabs.filter('.active').not(this.tabs.filter('.active').first()).removeClass('active');
			}

			parent.on.call(this, callback);

		};

		// @Override
		this.after = function () {
			parent.after.call(this);
		};

		// @Override
		this.activateTab = function(activatedTab) {
			var mod = this;
			var tabInList = activatedTab.parent();
			var tabContentParent = mod.tabContentsParents.eq(tabInList.index());
			var panel = tabContentParent.children().eq(0);

			mod.tabContentsParents.find('> div').hide();
			mod.tabContentsParents.find('> div').attr('aria-hidden','true');

			//check if tab is lazyload and if tab already exists
			if (activatedTab.data('islazyloaded') && !panel.length) {
				//create the tabcontentParent div
				panel = $('<div role="tabpanel" class="ui-tabs-panel ui-widget-content ui-corner-bottom" aria-hidden="false"><div class="loading-indicator"></div></div>');
				tabContentParent.empty().append(panel);
				mod.loadDeprecatedTabContent(activatedTab.attr('data-url'), panel);
			} else {
				panel.show();
				panel.attr('aria-hidden','false');
				SCS.utils.initNewModules(panel);
				$(window).trigger('resize'); //only for TabNavigation
			}

			parent.activateTab.apply(this, arguments);
		};

		this.loadDeprecatedTabContent = function (url, panel) {
			var mod = this;

			$.ajax({
				url: url
			}).done(function (data) {
				mod.onLoadDeprecatedTabContentSuccess(data, panel);
			}).fail(function (jqXHR, errortype, exceptionobject) {
				mod.onLoadDeprecatedTabContentFail(jqXHR, errortype, exceptionobject, panel);
			});
		};

		this.onLoadDeprecatedTabContentSuccess = function (htmlContent, panel) {
			var mod = this;

			panel.html(htmlContent);
			mod.$ctx.trigger('create');
			SCS.utils.initNewModules(panel);
			$(window).trigger('resize'); //only for TabNavigation

		};

		this.onLoadDeprecatedTabContentFail = function (jqXHR, errortype, exceptionobject, panel) {
			var mod = this;

			panel.html(mod.errorMessage);
			panel.find('.tab-content-error').first().removeClass('hidden');
		};
	};
}(window.Tc.Module, __webpack_provided_window_dot_Tc_dot_$, window.SCS));

}.call(window));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var loadTerrific = __webpack_require__(1);
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function($, SCS) {
	/*
	 * Dependencies:
	 * TerrificJs 2.0.1,
	 * jQuery 1.7 or greater,
	 * jquery.placeholder.min.js,
	 *
	 */


	'use strict';
	/*globals Tc */
	/*jshint smarttabs:true */

	Tc.Module.TabNavigationContent = Tc.Module.extend({

		on: function(callback) {
			var mod = this;
			mod.url = mod.$ctx.data('url');
			if (window.location.href.indexOf('wcmmode=disabled') > 0) {
				mod.url = SCS.portal.addParamToUrl(mod.url, 'wcmmode', 'disabled');
			}
			if (!mod.$ctx.data('lazy-loading-enabled')) {
				mod.$ctx.addClass('loaded');
			}
			mod.loadingIndicator = $('<div>').addClass('loading-indicator');
			mod.errorMessage = mod.$ctx.find('.tab-content-error').first();
			mod.onStartSubscription();
			callback();
		},

		onStartSubscription: function() {
			var mod = this,
				initialChannel = 'TabNavigation',
				productDataHubChannel = 'EcommerceProductDataHub';
			mod.sandbox.subscribe(initialChannel, mod);
			mod.fire('subscribe', {
				element: mod.$ctx,
				type: 'content',
				name: mod.$ctx.data('name'),
				index: mod.$ctx.data('index'),
				isActive: mod.$ctx.hasClass('active'),
				subscribe: function(channel, name, index) {
					mod.navigationChannel = channel;
					mod.name = name;
					mod.index = index;
					mod.sandbox.unsubscribe(initialChannel, mod);
					mod.sandbox.subscribe(channel, mod);
					mod.$ctx.on('activate', function(event){
						if (!mod.$ctx.hasClass('active')) {
							mod.fire('activateContent', {
								index: index,
								name: name
							}, [channel]);
							event.stopPropagation();
							event.stopImmediatePropagation();
						}
					});
				}
			}, [initialChannel]);
		},

		onActivateTab: function(data) {
			var mod = this;
			if(!mod.$ctx.parent().is(":visible"))
				return;
			if (data.index === mod.index) {
				mod.showContent();
			} else {
				mod.hideContent();
			}
		},

		showContent: function() {
			var mod = this;
			this.loadingIndicator.detach();
			this.$ctx.addClass('active');
			this.$ctx.closest('.tabcontent').addClass('active');
			if (!this.$ctx.hasClass('loaded')) {
				this.loadContent();
				this.$ctx.trigger('show');
				SCS.utils.initNewModules(this.$ctx);
			} else {
				SCS.utils.initNewModules(this.$ctx);
				mod.fireContentDisplayedEvent();
				this.$ctx.trigger('show');
			}
			$(document).trigger('element-shown', [this.$ctx]);
		},

		hideContent: function() {
			var mod = this;
			if (mod.navigationChannel) {
				mod.$ctx.removeClass('active');
				mod.$ctx.closest('.tabcontent').removeClass('active');
				mod.$ctx.addClass('hideEditbar').trigger('hide');
			}
		},

		loadContent: function() {
			var mod = this;
			if (!this.$ctx.hasClass('loading')) {
				this.$ctx.addClass('loading');
				if (this.url) {
					this.errorMessage.addClass('hidden');
					this.$ctx.prepend(mod.loadingIndicator);
					$.ajax({
						type: 'GET',
						url: mod.url,
						success: $.proxy(mod.onLoadContentSuccess, mod),
						error: $.proxy(mod.onLoadContentError, mod)
					});
				} else {
					this.$ctx.removeClass('loading');
					this.$ctx.addClass('loaded');
				}
			}
		},

		onLoadContentError: function() {
			this.loadingIndicator.detach();
			this.$ctx.removeClass('loading');
			this.errorMessage.removeClass('hidden');
		},

		onLoadContentSuccess: function(htmlContent) {
			this.$ctx.removeClass('loading');
			this.$ctx.addClass('loaded');
			this.loadingIndicator.detach();
			this.$ctx.html(htmlContent);
			if (this.tabTitle) {
				this.$ctx.prepend(this.tabTitle);
			}
			SCS.utils.initNewModules(this.$ctx);
			this.$ctx.trigger('create');
			this.fireContentDisplayedEvent();
		},

		fireContentDisplayedEvent: function() {
			var mod = this;
			if (mod.navigationChannel) {
				this.fire('visibleContentChanged', {
					content: mod.$ctx
				}, [mod.navigationChannel]);
			}
		}
	});

}(Tc.$, window.SCS));
}.call(window));

/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var loadTerrific = __webpack_require__(1);
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function($) {
	/*
	 * Dependencies:
	 * TerrificJs 2.0.1,
	 * jQuery 1.7 or greater,
	 * jquery.placeholder.min.js,
	 *
	 */

	'use strict';
	/*globals Tc */
	/*jshint smarttabs:true */

	Tc.Module.TabNavigationSharedContent = Tc.Module.extend({

		on: function(callback) {
			var mod = this;
			mod.tabContent = mod.$ctx.closest('.modTabNavigationContent');
			mod.onStartSubscription();
			callback();
		},

		onStartSubscription: function() {
			var mod = this,
				initialChannel = 'TabNavigation';
			mod.sandbox.subscribe(initialChannel, mod);
			mod.fire('subscribe', {
				element: mod.$ctx,
				subscribe: function(channel, name) {
					mod.navigationChannel = channel;
					mod.name = name;
					mod.sandbox.unsubscribe(initialChannel, mod);
					mod.sandbox.subscribe(channel, mod);
					mod.Registry.add(name, mod.$ctx.children('.shared-content'));
				}
			}, [initialChannel]);
		},

		onVisibleContentChanged: function(data) {
			var mod = this;
			if (mod.tabContent.is(data.content)) {
				// only move shared tab content if we received
				// the event from an active or visible component
				if (mod.$ctx.is('.active') || mod.$ctx.is(':visible')) {
					// do not move the content in edit mode
					// breaks if inside a reference component
					if (!$('body').hasClass('cq_isEditMode')) {
						mod.insertContent();
					}
				}
			}
		},

		insertContent: function() {
			var mod = this, i,
				sharedContents = mod.Registry.get(mod.name);
			if (!mod.$ctx.hasClass('disabled')) {
				for (i = 0; i < sharedContents.length; i++) {
					mod.$ctx.append(sharedContents[i].detach());
				}
			}
		},

		// Singleton object that is shared with all the shared tab content modules on the page
		Registry: {
			contents: [],

			add: function(name, content) {
				if (!this.contents[name]) {
					this.contents[name] = [];
				}
				this.contents[name].push(content);
			},

			get: function(name) {
				if (this.contents[name]) {
					return this.contents[name];
				}
				return [];
			}
		}
	});

}(Tc.$));
}.call(window));

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_Tc_dot_$) {/*** IMPORTS FROM imports-loader ***/
var loadTerrific = __webpack_require__(1);
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function (Module, $, SCS) {
	'use strict';

	/**
	 * Tabs.
	 *
	 * @author TAASCRAA
	 * @namespace Tc.Module
	 * @class Tabs
	 * @extends Tc.Module
	 */
	Module.Tabs = Module.extend({
		// True if tracking is enabled
		enableTracking: false,
		// True if lazy tab contents should be cached
		enableCaching: true,
		// True if tabs should be loaded lazily (in general – individual tabs can still be static (for example if they’re loaded initially))
		// Currently unused as the jQuery UI tabs detect the type of link for this
		enableLazyLoading: false,
		// All the LIs that make up the tab headings
		tabHeadings: null,
		// The tab currently selected: {tab, panel}
		selectedTab: null,
		// Whether we generate the mobile helper links at the bottom
		createBottomLinks: false,

		/**
		 * Does all the work.
		 *
		 * @method on
		 * @param {Function} callback function
		 * @return void
		 */
		on: function (callback) {
			var $ctx = this.$ctx;

			this.createBottomLinks = $ctx.data('create-mobile-links') && $('body').hasClass('is-mobile');

			this.setupAnimations();

			this.enableTracking = $ctx.data('enableTracking');
			this.enableCaching = $ctx.data('enableCaching');
			this.enableLazyLoading = $ctx.data('enableLazyLoading');
			this.scroller = $ctx.find('> .scroll-wrapper > .scroller')[0];
			var $headingParent = this.scroller ? $(this.scroller) : $ctx;
			this.tabHeadings = $headingParent.find('> ul > li');
			this.setupTabs($ctx);
			this.setupAPI($ctx);

			this.tabs = this.$ctx.find('.tab-list .ui-tabs-anchor');

			if (this.createBottomLinks) {
				Module.Tabs.initBottomTabLinks(this, '.tab-title');
				this.hideActiveBottomTabLink($(this.selectedTab.tab).find('.ui-tabs-anchor'));
			}
			callback();
		},

		/**
		 * Called when all modules have been set up
		 */
		after: function () {
		},

		/**
		 * Do nothing in default implementation
		 * Left for overrides
		 */
		setupAnimations: function () {

		},

		setupTabs: function ($ctx) {
			var mod = this;

			var selectedTabs = mod.tabHeadings.filter('[data-is-selected="true"]').eq(0);
			if (selectedTabs.length === 0) {
				selectedTabs = mod.tabHeadings.eq(0);
			}

			var tabOptions = mod.getTabOptions(selectedTabs);

			$ctx.tabs(tabOptions);

			mod.initialTabSelection();

			var tabSelected = $ctx.tabs('option', 'active');
			var trackingTab = $ctx.find('ul li:nth-child(' + (tabSelected + 1) + ') a');
			var trackingVal = trackingTab.data('tracking-name');
			if (!trackingVal) {
				trackingVal = trackingTab.text();
			}
			SCS.tracking.setLandingTabName(trackingVal);
		},

		// Overridable
		getTabOptions: function(selectedTabs) {
			var mod = this;
			return {
				load: function (event, ui) {
					var panel = $(ui.panel);
					// fix for mobile => Move out of scroller
					if (mod.scroller && panel.parents().is(mod.scroller)) {
						$(mod.scroller).parent().parent().append(panel);
					}
					SCS.utils.initNewModules(panel);
				},
				// For jQuery UI 1.11
				active: mod.tabHeadings.index(selectedTabs),
				classes: {'ui-tabs-active': 'ui-tabs-selected'},
				beforeActivate: $.proxy(mod.tabSelecting, mod),
				beforeLoad: $.proxy(mod.beforeLoad, mod),
				activate: $.proxy(mod.tabSelected, mod),
				create: function (event, ui) {
					if (ui.tab && ui.panel) {
						mod.selectedTab = ui;
					}
				}
			};
		},

		/**
		 * Called when we know the initial tab and tabs have been set up
		 * Do nothing in default implementation
		 * Left for overrides
		 */
		initialTabSelection: function (tab) {
			// jshint unused: false
		},

		setupAPI: function ($ctx) {
			$ctx.data('tab-switch-to-prev', $.proxy(this.switchToPrev, this));
			$ctx.data('tab-switch-to-next', $.proxy(this.switchToNext, this));
			$ctx.data('tab-switch-to-tab', $.proxy(this.switchToSpecific, this));
			$ctx.data('tab-current-tab', $.proxy(this.currentTab, this));
			$ctx.data('tab-count', $.proxy(this.count, this));
			$ctx.data('tab-headings', $.proxy(this.allTabHeadings, this));
		},

		handleBottomTabClick: function (event, tab) {
			event.preventDefault();
			// Act as if the top tab was clicked
			tab.click();
			return false;
		},

		hideActiveBottomTabLink: function (tab) {
			if (!this.createBottomLinks || !this.bottomTabLinks) {
				return;
			}
			this.bottomTabLinks.children().show();
			var link = tab.data('bottom-tab-link');
			if (link) {
				link.hide();
			}
		},

		/**
		 * jQuery UI event listener.
		 *
		 * Normalizes arguments across jQuery UI versions (desktop/mobile)
		 * and delegates to `selectingTab`.
		 */
		tabSelecting: function (event, ui) {
			var tab = $(ui.tab || (ui.newTab && ui.newTab.find('a')));

			this.selectingTab(tab);
		},

		// Overridable
		selectingTab: function (tab) {
			if (this.enableTracking) {
				var trackingVal = tab.data('tracking-name');
				if (!trackingVal) {
					trackingVal = tab.html();
				}

				var parentTab = tab.parents('.modTabs').parents('.modTabs:last').find('li.ui-state-active a');
				if (typeof parentTab !== 'undefined') {
					var parentTrackingVal = parentTab.data('tracking-name');
					if (!parentTrackingVal) {
						parentTrackingVal = parentTab.html();
					}
					if (parentTrackingVal && parentTrackingVal !== '') {
						trackingVal = parentTrackingVal + '/' + trackingVal;
					}
				}
				this.log('selectingTab > trackingVal', trackingVal);
				SCS.tracking.trackPartialPageView(trackingVal);
			}
		},

		// Overridable
		beforeLoad: function (event, ui) {
			if(!this.enableCaching) {
				return;
			}
			if(ui.tab.data('loaded') ) {
				event.preventDefault();
				return;
			}
			ui.jqXHR.success(function() {
				ui.tab.data('loaded', true );
			});
		},

		tabSelected: function (event, ui) {
			var mod = this;

			this.selectedTab = {
				tab: ui.newTab,
				panel: ui.newPanel
			};

			mod.hideActiveBottomTabLink($(this.selectedTab.tab).find('.ui-tabs-anchor'));

			var panel = $(this.selectedTab.panel);


			$(document).trigger('element-shown', [panel]);
			$(window).trigger('resize'); // only for TabNavigations to initialize
			mod.$ctx.trigger('tabSelected', this.selectedTab.tab, panel);
		},

		switchToPrev: function () {
			this.tabHeadings.filter('.ui-tabs-selected').prev('li').find('a').click();
		},

		switchToNext: function () {
			this.tabHeadings.filter('.ui-tabs-selected').next('li').find('a').click();
		},

		switchToSpecific: function (tab) {
			if (!isNaN(parseInt(tab, 10))) {
				tab = this.tabHeadings.eq(tab);
			}
			if (this.tabHeadings.is(tab)) {
				tab = this.tabHeadings.filter(tab).eq(0);
				tab.find('a').click();
			}
		},

		currentTab: function () {
			return this.selectedTab;
		},

		allTabHeadings: function () {
			return this.tabHeadings;
		},

		count: function () {
			return this.tabHeadings.length;
		}
	});

	Module.Tabs.TAB_MODULE_SELECTOR = '.mod.modTabs';

	/**
	 * Searches the one tab control (if any) that should be affected by a keypress.
	 * @param selectMode either "prev" or "next"
	 */
	Module.Tabs.findAffectedTabControl = function (selectMode) {
		var validTabControls = $(Module.Tabs.TAB_MODULE_SELECTOR);
		// Reduce to elements whose selected panel is not yet the first (or last)
		validTabControls = validTabControls.filter(function () {
			var tabControl = $(this);
			var tab = tabControl.data('tab-current-tab')();
			var index = tab.index;
			if (selectMode === 'next') {
				var count = tabControl.data('tab-count')();
				return index !== (count - 1);
			} else {
				return index !== 0;
			}
		});
		// Exclude tab control contained in closed tab panels
		validTabControls = validTabControls.filter(':visible');
		// Reduce to that don’t contain other valid tabs
		validTabControls = validTabControls.filter(function () {
			var tabControl = $(this);
			var tab = tabControl.data('tab-current-tab')();
			var doesContainValidTabControls = false;
			validTabControls.each(function () {
				if ($(this).parents().is(tab.panel)) {
					doesContainValidTabControls = true;
					return false;
				}
			});
			return !doesContainValidTabControls;
		});
		if (!validTabControls.length) {
			return null;
		}
		return selectMode === 'next' ? validTabControls.first() : validTabControls.last();
	};

	Module.Tabs.switchTo = function (selectMode) {
		var tabControl = Module.Tabs.findAffectedTabControl(selectMode);
		if (!tabControl) {
			return false;
		}
		if (selectMode === 'next') {
			tabControl.data('tab-switch-to-next')();
		} else {
			tabControl.data('tab-switch-to-prev')();
		}
		return true;
	};

	Module.Tabs.setupKeyBindings = function () {
		$(document).keydown(function (e) {
			var target = $(e.target);
			if (target.is('input') || target.closest('form').length) {
				// we are inside an input field - don’t switch tabs!
				// we are somewhere inside a form - don’t switch tabs!
				return;
			}
			var hasMatched = false;
			if (e.which === 37) {
				hasMatched = Module.Tabs.switchTo('prev');
			} else if (e.which === 39) {
				hasMatched = Module.Tabs.switchTo('next');
			}
			if (!hasMatched) {
				return;
			}
			e.stopPropagation();
			$(document).one('keypress', function (e) {
				e.preventDefault();
			});
		});
	};

	Module.Tabs.initBottomTabLinks = function (mod, titleQuery) {
		mod.bottomTabLinks = mod.$ctx.nextAll('.bottom-tab-links').eq(0);

		if (!mod.bottomTabLinks.length) {
			return;
		}
		var fragment = document.createDocumentFragment();

		mod.tabs.each(function () {
			var tab = $(this);
			var li = document.createElement('li');
			var a = tab.clone(false).appendTo(li);
			if (titleQuery) {
				a.html(a.find(titleQuery).html());
			}
			a.addClass('tab-navigation-tab-mobile-link').removeClass('active');
			tab.data('bottom-tab-link', $(li));
			a.on('click tap', function (event) {
				return mod.handleBottomTabClick(event, tab);
			});
			fragment.appendChild(li);
		});
		mod.bottomTabLinks.append(fragment);
	};


	Module.Tabs.setupKeyBindings();
}(window.Tc.Module, __webpack_provided_window_dot_Tc_dot_$, window.SCS));

}.call(window));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var loadTerrific = __webpack_require__(1);
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function (Module) {
	'use strict';

	Module.Tabs.StaticallyLinkedTabs = function(parent) {
		this.on = function() {
			parent.on.apply(this, arguments);
		};
		this.after = function() {
			parent.after.apply(this, arguments);
		};

		this.selectingTab = function(tab) {
			// Trigger the animation
			parent.selectingTab.apply(this, arguments);
			var href = tab.attr('data-href');
			tab.prop('href', href);
			// Trigger loading the URL with the selector.
			window.location.href = href;
		};

		// Overridden
		this.beforeLoad = function (event, ui) {
			// Cleanly stop the Ajax request (for >= 1.9 versions of jQuery UI)
			ui.jqXHR.abort();
			event.preventDefault();
			return false;
		};

	};
}(window.Tc.Module));

}.call(window));

/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_Tc_dot_$) {/*** IMPORTS FROM imports-loader ***/
var loadTerrific = __webpack_require__(1);
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function($, Tc, SCS, doT, scsHeader) {
	'use strict';

	var RESPONSE_TIMEOUT = 5000;
	var DEFAULT_LANG = 'de';
	var CACHING_TIME = 60000;

	/**
	 * TileOrderStatus module implementation.
	 *
	 * @author Nikola Tica
	 * @namespace Tc.Module
	 * @class TileOrderStatus
	 * @extends Tc.Module
	 */
	Tc.Module.TileOrderStatus = Tc.Module.extend({
		/**
		 * Hook function to do all of your module stuff.
		 *
		 * @method on
		 * @memberof TileOrderStatus
		 * @param {Function} callback function
		 * @returns void
		 */
		on: function (callback) {
			var mod = this,
				lang = (SCS && SCS.portal && SCS.portal.lang) ? SCS.portal.lang : DEFAULT_LANG;

			mod.showLoadingScreen();
			mod.hideErrorScreen();
			mod.hideNoOrderMsg();
			mod.hideOrders();

			mod.url = SCS.Url.updateQueryStringParameter(mod.$ctx.data('mod-url'), 'lang', lang);

			__webpack_require__(5).getProfile().then(function(profile) {
				var user = profile.getUser();
				var cachedItemId = (user ? user.getId() : 'anonymous') + '-cached-orders';

				var data = SCS.utils.cache.getCacheData(cachedItemId);
				if (data) {
					mod.processData(data);
				} else {
					$.ajax({
						timeout: RESPONSE_TIMEOUT,
						url : mod.url,
						dataType: 'json',
						success : function (data) {
							SCS.utils.cache.cacheData(data, cachedItemId, CACHING_TIME);
							mod.processData(data);
						},
						error : function () {
							mod.hideLoadingScreen();
							mod.showErrorScreen();
						}
					});
				}
			});

			callback();
		},
		/**
		 * This function shows loading display.
		 *
		 * @method showLoadingScreen
		 * @memberof TileOrderStatus
		 * @returns void
		 */
		showLoadingScreen: function () {
			var mod = this;
			mod.$ctx.find('.loading-message-section').removeClass('is-hidden');
		},
		/**
		 * This function hides loading display.
		 *
		 * @method hideLoadingScreen
		 * @memberof TileOrderStatus
		 * @returns void
		 */
		hideLoadingScreen: function () {
			var mod = this;
			mod.$ctx.find('.loading-message-section').addClass('is-hidden');
		},
		/**
		 * This function shows error screen.
		 *
		 * @method showErrorScreen
		 * @memberof TileOrderStatus
		 * @returns void
		 */
		showErrorScreen: function () {
			var mod = this;
			mod.$ctx.find('.error-message-section').removeClass('is-hidden');
		},
		/**
		 * This function hides error screen.
		 *
		 * @method hideErrorScreen
		 * @memberof TileOrderStatus
		 * @returns void
		 */
		hideErrorScreen: function () {
			var mod = this;
			mod.$ctx.find('.error-message-section').addClass('is-hidden');
		},
		/**
		 * This function shows no order message.
		 *
		 * @method showNoOrderMsg
		 * @memberof TileOrderStatus
		 * @returns void
		 */
		showNoOrderMsg: function () {
			var mod = this;
			mod.$ctx.find('.no-order-section').removeClass('is-hidden');
		},
		/**
		 * This function hides no order message.
		 *
		 * @method hideNoOrderMsg
		 * @memberof TileOrderStatus
		 * @returns void
		 */
		hideNoOrderMsg: function () {
			var mod = this;
			mod.$ctx.find('.no-order-section').addClass('is-hidden');
		},
		/**
		 * This function shows the order section.
		 *
		 * @method showOrders
		 * @memberof TileOrderStatus
		 * @returns void
		 */
		showOrders: function () {
			var mod = this;
			mod.$ctx.find('.results-section').removeClass('is-hidden');
		},
		/**
		 * This function hides the order section.
		 *
		 * @method hideOrders
		 * @memberof TileOrderStatus
		 * @returns void
		 */
		hideOrders: function () {
			var mod = this;
			mod.$ctx.find('.results-section').addClass('is-hidden');
			mod.$ctx.find('.result-container').empty();
		},
		/**
		 * This function creates HTML fron data retrieved from the MUST.
		 *
		 * @method renderData
		 * @memberof TileOrderStatus
		 * @param {Array} data Array of objects that contains orders information.
		 * @returns void
		 */
		renderData: function (data) {
			var mod = this;
			var $ordersTemplate = mod.$ctx.find('script.tmpl-order-status'),
				tmplItem = doT.template($ordersTemplate.html());
			var renderData = data.map(function (item) {
				return {
					statusIconColorClass: mod.getStatusColorClass(item.status),
					statusIcon: mod.getStatusIcon(item.status),
					title: item.title || '',
					dateCreated: SCS.utils.date.format(SCS.utils.date.fromString(item.dateCreated)) || '',
					referenceId: item.referenceId || '',
					orderFor: item.orderFor || '',
					detailLink: item.detailLink || 'javascript' + String.fromCharCode(58) + 'void(0);'
				};
			});
			var $html = $(tmplItem({orders: renderData}));
			mod.$ctx.find('.result-container').append($html);
		},
		/**
		 * This function returns SDX icon used to represent given status.
		 *
		 * @method getStatusIcon
		 * @memberof TileOrderStatus
		 * @param {String} status Order status. Expected values: NONE, CLOSED,
		 * WAITING, IN_PROGRESS, OPEN_REVISABLE, NEEDS_ATTENTION
		 * @returns {String} Status icon
		 */
		getStatusIcon: function (status) {
			var icon;
			switch (status) {
				case 'CLOSED':
					icon = 'icon-012-check-mark-circle';
					break;
				case 'OPEN_REVISABLE':
					icon = 'icon-026-exclamation-mark-circle';
					break;
				case 'NEEDS_ATTENTION':
					icon = 'icon-026-exclamation-mark-circle';
					break;
				default:
					icon = 'icon-021-clock';
			}
			return icon;
		},
		/**
		 * This function returns SDX icon collor class used to represent given
		 * status.
		 *
		 * @method getStatusColorClass
		 * @memberof TileOrderStatus
		 * @param {String} status Order status. Expected values: NONE, CLOSED,
		 * WAITING, IN_PROGRESS, OPEN_REVISABLE, NEEDS_ATTENTION
		 * @returns {String} Status icon color class
		 */
		getStatusColorClass: function (status) {
			var colorClass;
			switch (status) {
				case 'CLOSED':
					colorClass = 'int-green';
					break;
				case 'OPEN_REVISABLE':
					colorClass = 'int-red';
					break;
				case 'NEEDS_ATTENTION':
					colorClass = 'int-red';
					break;
				default:
					colorClass = 'gray-mid';
			}
			return colorClass;
		},
		/**
		 * This function displays data or no orders message.
		 *
		 * @method processData
		 * @memberof TileOrderStatus
		 * @param {Array} data Array of objects that contains orders information.
		 * @returns void
		 */
		processData: function (data) {
			var mod = this;
			if(!data.length) {
				mod.hideLoadingScreen();
				mod.showNoOrderMsg();
			} else {
				mod.renderData(data);
				mod.hideLoadingScreen();
				mod.showOrders();
			}
		}

	});
})(__webpack_provided_window_dot_Tc_dot_$, window.Tc, window.SCS, window.doT, window.scsHeader);

}.call(window));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var loadTerrific = __webpack_require__(1);
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function($) {
	'use strict'
	/**
	 * Timeline
	 * @author Nikola Lakovic
	 * @namespace Tc.Module.Timeline.js
	 * @class Timeline
	 * @extends Tc.Module
	 *
	 **/

	Tc.Module.Timeline = Tc.Module.extend({

		on: function(callback) {

			var mod = this,
				$ctx = this.$ctx,
				$panelContainer = $ctx.find('.pannel_container'),
				$panel = $ctx.find('.container'),
				$nav = $ctx.find('nav'),
				totalPanels = $panel.length;
				mod.height = $ctx.data('height');
				mod.width = $ctx.data('width');
				mod.top = $ctx.data('top');
				mod.left = $ctx.data('left');

			mod.setTimelineDimensions($ctx, $panel, $panelContainer);
			mod.setTimelinePosition();

			if (totalPanels < 2) {
				$nav.remove();
				callback();
				return false;
			}

			mod.adjustLayout();

			callback();
		},

		adjustLayout: function() {
			var mod = this,
				$ctx = mod.$ctx;

			var $panel = $ctx.find('.container'),
				$nav = $ctx.find('nav'),
				panelWidth = $panel.width(),
				totalPanels = $panel.length,
				leftPos = parseInt(panelWidth / (totalPanels - 1));

			$panel.each(function(index) {
				var newX = panelWidth * index,
					$this = $(this);

				$this.css({
					'left': newX + 'px'
				});

				var newLabel = $this.find('.modImageMapContainer').data('year');
				$nav.append('<a href="#" style="left:' + leftPos * index + 'px"><span>' + newLabel + '</span></a>');
			});

			$nav.find('a:first-child').addClass('selected');
			var currentPanel = $nav.find('a:last-child').index();

			mod.activateNavigation();
		},

		activateNavigation: function() {
			var mod = this,
				$ctx = mod.$ctx,
				$nav = $ctx.find('nav'),
				$link = $nav.find('a'),
				panelWidth = $ctx.width(),
				$panelSlider = $ctx.find('.panel_slider'),
				$activePanel = $ctx.find('.container');

			if ($ctx.data('slide') !== true) {
				$activePanel.css('left', 0).hide().first().show();
			}

			$link.on('click', function(event) {
				event.preventDefault();
				/* Act on the event */
				var $this = $(this),
					currentPanel = $this.index();

				$link.removeClass('selected');
				$this.addClass('selected');

				if ($ctx.data('slide')) {

					var newPosition = ((currentPanel * panelWidth) * -1);

					$panelSlider.animate({
						left: newPosition + 'px'
					}, 700);

				} else {

					$activePanel.eq($this.index()).fadeIn(500).siblings().fadeOut(500);
				}

			});
		},

		setTimelineDimensions: function() {
			var mod = this,
				$ctx = mod.$ctx;

			for (var i = 0; i < arguments.length; i++) {
				arguments[i].css({
					width: mod.width + 'px',
					height: mod.height + 'px'
				});
			}
		},

		setTimelinePosition: function() {
			var mod = this,
				$ctx = mod.$ctx;

			$ctx.css({
				top: mod.top,
				left: mod.left
			});
		}

	});
})(Tc.$);
}.call(window));

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var loadTerrific = __webpack_require__(1);
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function($, w) {
	"use strict";
	/*globals Tc, window */

	/**
	 * UserFeedback for tracking user actions
	 *
	 * @author Rami Attallah, Elena Wessolek, Cesar Keller
	 * @namespace Tc.Module
	 * @class UserFeedback
	 * @extends Tc.Module
	 */
	Tc.Module.UserFeedback = Tc.Module.extend({

		on: function(callback) {
			var mod = this,
				$ctx = mod.$ctx;

			$ctx.find("[baynote_fbhelpful]").click(function() {
				var $button = $(this),
					feedbackVal = $button.attr('baynote_fbhelpful');

				// LivePerson JavaScript was already loaded by the LivePerson Chat component
				if (feedbackVal && w.lpSendData) {
					// send to LivePerson
					w.lpMTagConfig = w.lpMTagConfig || {};
					w.lpMTagConfig.vars = w.lpMTagConfig.vars || [];
					w.lpMTagConfig.vars.push(['page', 'PageContentUserFeedbackHelpful', feedbackVal]);
					w.lpSendData();
					w.debug.log("Tc.Module.UserFeedback", feedbackVal, w.lpMTagConfig);
				} else {
					w.debug.warn("Tc.Module.UserFeedback cannot send", feedbackVal, w.lpSendData);
				}

			});

			callback();
		}
	});
}(Tc.$, window));

}.call(window));

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_Tc_dot_$) {/*** IMPORTS FROM imports-loader ***/
var loadTerrific = __webpack_require__(1);
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function($, Tc) {
	/*
	 * Dependencies:
	 * TerrificJs 2.0.1,
	 * jQuery 1.7 or greater,
	 * jquery.placeholder.min.js,
	 */

	'use strict';

	/**
	 * Wireline module implementation.
	 *
	 * @author
	 * @namespace Tc.Module
	 * @class Wireline
	 * @extends Tc.Module
	 */
	Tc.Module.Wireline = Tc.Module.extend({

		Elements: {
			Fallback: '.fallback',
			LoadingIndicator: '.loading-indicator',
			ResultContainer: '.result-container'
		},

		/**
		 * Initializes the module.
		 *
		 * @method init
		 * @constructor
		 * @param {jQuery} $ctx the jquery context
		 * @param {Sandbox} sandbox the sandbox to get the resources from
		 * @param {String} modId the unique module id
		 */
		init: function($ctx, sandbox, modId) {
			this.$ctx = $ctx;
			this.config = {
				url: $ctx.data('url'),
				zipFieldName: $ctx.data('zip-field'),
				cityFieldName: $ctx.data('city-field'),
				updateOnChange: $ctx.data('update-on-change'),
				displayOnlySingleContact: $ctx.data('display-single-contact')
			};

			// call base constructor
			this._super($ctx, sandbox, modId);
		},

		/**
		 * Hook function to do all of your module stuff.
		 *
		 * @method on
		 * @param {Function} callback function
		 * @return void
		 */
		on: function(callback) {
			this.zipField = this.getField(this.config.zipFieldName);
			this.cityField = this.getField(this.config.cityFieldName);
			$('.update-results', this.$ctx).on('click', $.proxy(this.onSearchClick, this));
			this.getResultContainer().on('click', '.on-list-item-click', $.proxy(this.onListItemClick, this));
			callback();
		},

		/**
		 * Hook function to trigger your events.
		 *
		 * @method after
		 * @return void
		 */
		after: function() {
			if (this.config.updateOnChange && this.config.displayOnlySingleContact) {
				this.refresh();
			}
		},

		getField: function(name) {
			var $this = this,
				field = {
					name: name,
					field: $this.getFieldByName(name),
					init: function() {
						if (this.field) {
							this.field.on('change', $.proxy($this.onFieldValueChanged, $this));
							this.field.on('keypress', $.proxy($this.onKeyPress, $this));
						}
					},
					getValue: function() {
						if (this.field) {
							return this.field.val();
						}
						return null;
					}
				};
			field.init();
			return field;
		},

		getFieldByName: function(name) {
			if (name) {
				return $('input[name="' + name + '"]');
			}
			return null;
		},

		getResultContainer: function() {
			if (!this.resultContainer) {
				this.resultContainer = $(this.Elements.ResultContainer, this.$ctx);
			}
			return this.resultContainer;
		},

		onFieldValueChanged: function() {
			if (this.config.updateOnChange) {
				this.refresh();
			}
		},

		onKeyPress: function(event) {
			if(event.keyCode === 13) {
				this.refresh();
			}
		},

		onSearchClick: function() {
			this.refresh();
		},

		onListItemClick: function(event) {
			var item = this.getSavedItem($(event.currentTarget).data('index'));
			if (item) {
				this.refresh({
					'postcode': item.postcode,
					'city': item.city
				});
			}
		},

		onLoadDataSuccess: function(data) {
			this.showElement(this.Elements.LoadingIndicator, false);
			if (data.success === true) {
				this.saveItems(data.items);
				if (data.type === 'contacts') {
					this.displayContacts(data.items);
				} else {
					this.displayCities(data.items);
				}
			} else {
				this.onLoadDataError();
			}
		},

		onLoadDataError: function() {
			this.showElement(this.Elements.LoadingIndicator, false);
			this.showElement(this.Elements.Fallback, true);
		},

		refresh: function(customData) {
			var $this = this,
				data = $this.getRequestData();
			if (customData) {
				$.extend(data, customData);
			}
			this.showElement(this.Elements.Fallback, false);
			this.showElement(this.Elements.LoadingIndicator, true);
			this.showElement(this.Elements.ResultContainer, false);
			if($this.$ctx.find('.city span.error').is(':visible') && $this.$ctx.find('.zipCountry input').val().length === 0) {
				$this.$ctx.find('.city span.error').addClass('hidden');
			}
			this.getResultContainer().empty();
			this.ajaxCall = $.ajax({
				type: 'GET',
				url: $this.config.url,
				cache: false,
				dataType: 'json',
				data: data,
				success: $.proxy($this.onLoadDataSuccess, $this),
				error: $.proxy($this.onLoadDataError, $this)
			});
		},

		getRequestData: function() {
			var $this = this,
				requestData = {
					'_charset_': 'utf-8',
					'postcode': $this.zipField.getValue(),
					'city': $this.cityField.getValue()
				};
			return requestData;
		},

		showElement: function(type, show) {
			if (!this.elements) {
				this.elements = {};
			}
			if (!this.elements[type]) {
				this.elements[type] = $(type, this.$ctx);
			}
			if (show) {
				if (type === this.Elements.LoadingIndicator && this.elements[this.Elements.ResultContainer]) {
					this.elements[type].height(Math.max(35, this.elements[this.Elements.ResultContainer].height()));
				}
				this.elements[type].removeClass('hidden');
			} else {
				this.elements[type].addClass('hidden');
			}
		},

		saveItems: function(items) {
			this.savedItems = items;
		},

		getSavedItem: function(index) {
			if (this.savedItems && typeof index === 'number' && this.savedItems.length > index) {
				return this.savedItems[index];
			}
			return null;
		},

		getCitiesTemplate: function() {
			if (!this.listTemplate) {
				var templateScript = this.$ctx.find('script.tmpl-cities');
				this.listTemplate = window.doT.template(templateScript.html());
			}
			return this.listTemplate;
		},

		getContactsTemplate: function() {
			if (!this.itemTemplate) {
				var templateScript = this.$ctx.find('script.tmpl-contacts');
				this.itemTemplate = window.doT.template(templateScript.html());
			}
			return this.itemTemplate;
		},

		displayCities: function(list) {
			if (list.length > 0 && !this.config.displayOnlySingleContact) {
				this.showElement(this.Elements.Fallback, false);
				this.showElement(this.Elements.ResultContainer, true);
				this.getResultContainer().html(this.getCitiesTemplate()(list));
			} else {
				this.showElement(this.Elements.Fallback, true);
			}
		},

		displayContacts: function(items) {
			if (items.length > 0 && (!this.config.displayOnlySingleContact || (this.config.displayOnlySingleContact && items.length === 1))) {
				this.showElement(this.Elements.Fallback, false);
				this.showElement(this.Elements.ResultContainer, true);
				this.prepareContacts(items);
				this.getResultContainer().html(this.getContactsTemplate()(items));
			} else {
				this.showElement(this.Elements.Fallback, true);
			}
		},

		prepareContacts: function(contacts) {
			for (var i = 0; i < contacts.length; i += 1) {
				if (contacts[i].officeTime) {
					contacts[i].officeTime = contacts[i].officeTime.replace('(', '').replace(')', '');
				}
			}
		}
	});

}(__webpack_provided_window_dot_Tc_dot_$, window.Tc));

}.call(window));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var loadTerrific = __webpack_require__(1);
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function ($) {
	"use strict";
	/*globals Tc, doT, SCS */
	/*jshint smarttabs:true */
	/**
	 * JS Logic for PDF Downdload Component
	 *
	 * @author Matthias Inauen
	 * @namespace Tc.Module
	 * @class DownloadPDF
	 * @extends Tc.Module
	 */
	Tc.Module.DownloadPDF = Tc.Module.extend({
		/**
		 * Hook function to do all of your module stuff.
		 *
		 * @method on
		 * @param {Function} callback function
		 * @return void
		 */
		on: function (callback) {
			var mod = this;

			mod.downloadLink = $('a.download', mod.$ctx );
			mod.actionURL = mod.downloadLink.attr('data-url');
			mod.parentForm = mod.downloadLink.parents('form');

			$("input[name=':formid'],[name=':formstart'],[name=':formtype']", mod.parentForm ).remove();

			mod.parentFormContents = mod.parentForm.contents();
			mod.submitForm = $('<form />', { method: 'post', action: this.actionURL, target: '_blank' });

			mod.downloadLink.click( function( event ){
				event.preventDefault();

				mod.submitForm.append( mod.parentFormContents.detach() ).appendTo( 'body').submit().detach();
				mod.parentForm.append( mod.parentFormContents.detach() );
			});

			callback();
		}
	});
})(Tc.$);
}.call(window));

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var loadTerrific = __webpack_require__(1);
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function($) {
	"use strict";
	/*globals Tc, doT, SCS */
	/*jshint smarttabs:true */
	/**
	 * CaseSelection module implementation.
	 *
	 * @author Zeljko Curcic
	 * @namespace Tc.Module
	 * @class CaseSelection
	 * @extends Tc.Module
	 */
	Tc.Module.CaseSelection = Tc.Module.extend({

		caseSelected: false,
		lastSelectedRadio: null,
		nextStepButton: null,

		/**
		 * Hook function to do all of your module stuff.
		 *
		 * @method on
		 * @param {Function} callback function
		 * @return void
		 */
		on: function(callback) {
			var mod = this,
				$radios = mod.$ctx.find('input[type=radio]');

			mod.nextStepButton = $('.multipage-wizard-step .multipage-forward-button');
			mod.nextStepButton.attr('href', mod.$ctx.data("default-url"));


			// save the initially checked radio
			mod.lastSelectedRadio = $radios.filter(':checked');

			$radios.on('change', function () {
				mod.changeCase($(this));
			});

			mod.nextStepButton.on('click', function () {
				mod.caseSelected = true;
			});

			callback();
		},

		changeCase: function (selectedRadio) {
			var mod = this,
				changeAllowed = true;

			// check if case has already been selected by the user before
			if (mod.caseSelected) {
				changeAllowed = confirm('If you change this, all the form data will be erased!');
			}

			if (changeAllowed) {
				mod.lastSelectedRadio = selectedRadio;

				// set the URL of the "next step"-button of the wizard to the target-URL of the selected case
				mod.nextStepButton.attr('href', selectedRadio.val());

				// trigger the wizard to delete all following steps
				mod.fire('clearWizardSteps', { stepContainer: mod.$ctx }, ['wizard']);

				// prevent further questions until the user clicked the "next"-button again
				mod.caseSelected = false;
			} else {
				// reset the radio to its last selection
				mod.lastSelectedRadio.focus().prop('checked', true);
			}
		}

	});
})(Tc.$);

}.call(window));

/***/ }),
/* 200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lib_vendor_terrific_Module__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lib_generic_SDXModalDialog__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lib_util_helpers__ = __webpack_require__(4);





var CSS_CLASS_HIDDEN = 'hidden';
var CSS_CLASS_ERROR = 'error';
var AJAX_TIMEOUT = 10000;
var DISPLAY_OPTION_HOTLINE = 'hotline';
var DISPLAY_OPTION_BUTTON = 'button';
function hideLoader($ctx) {
    $ctx.find('.loader-holder').addClass(CSS_CLASS_HIDDEN);
}
function showLoader($ctx) {
    $ctx.find('.loader-holder').removeClass(CSS_CLASS_HIDDEN);
}
function showCFN($ctx) {
    $ctx.find('.cfn-open').removeClass(CSS_CLASS_HIDDEN);
}
function hideCFN($ctx) {
    $ctx.find('.cfn-open').addClass(CSS_CLASS_HIDDEN);
}
function isAvailable(openingHours) {
    var config = Object(__WEBPACK_IMPORTED_MODULE_3__helpers__["a" /* createOpenHoursConfig */])(openingHours);
    return Object(__WEBPACK_IMPORTED_MODULE_3__helpers__["e" /* isOpen */])(config);
}
function showHotlineOpen($ctx, publicNumber) {
    var formattedNumber = publicNumber.replace(/^(\+410?)([\d]{3})([\d]{3})([\d]{3})$/, '0$2 $3 $4');
    $ctx.find('div:not(.abroad-display, .check-available-error) > .hotline-info .hotline-number').text(formattedNumber);
    $ctx.find('.hotline-open').removeClass(CSS_CLASS_HIDDEN);
}
function hideHotlineOpen($ctx) {
    $ctx.find('div:not(.abroad-display, .check-available-error) > .hotline-info .hotline-number').text('');
    $ctx.find('.hotline-open').addClass(CSS_CLASS_HIDDEN);
}
function hideHotlineClosed($ctx) {
    $ctx.find('.hotline-close').addClass(CSS_CLASS_HIDDEN);
}
function displayError($ctx, considerDisplayOptions, displayOption, $buttonLink) {
    if (considerDisplayOptions === void 0) { considerDisplayOptions = false; }
    $ctx.removeClass('left right center');
    if (considerDisplayOptions) {
        if (displayOption === DISPLAY_OPTION_BUTTON) {
            $buttonLink.removeClass(CSS_CLASS_HIDDEN);
        }
        else if (displayOption === DISPLAY_OPTION_HOTLINE) {
            $ctx.find('.check-available-error').removeClass(CSS_CLASS_HIDDEN);
        }
    }
    else {
        $ctx.find('.check-available-error').removeClass(CSS_CLASS_HIDDEN);
    }
}
function hideError($ctx) {
    $ctx.find('.check-available-error').addClass(CSS_CLASS_HIDDEN);
}
var CallFromNet = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */])(CallFromNet, _super);
    function CallFromNet() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CallFromNet.prototype.on = function (callback) {
        this.configuration = this.$ctx.data('configuration');
        if (!this.configuration) {
            this.$ctx.hide();
            this.log('Do not initialize component if configuration is missing');
            callback();
            return;
        }
        this.$dialog = this.$ctx.find('.callfromnet-dialog');
        this.$successDialog = this.$ctx.find('.callfromnet-dialog-success');
        this.hasMultipleTopics = this.configuration.length > 1;
        this.ajaxUrlPrefix = this.$ctx.data('ajax-url');
        this.displayCFNCloseOption = this.$ctx.data('display-options');
        this.displayOpeningHours = this.$ctx.data('display-oh');
        this.displayOpeningHoursAsTooltip = this.$ctx.data('display-oh-as-tooltip');
        this.trackAction = this.$ctx.data('track-action');
        this.trackLabel = this.$ctx.data('track-label');
        this.trackLocation = this.$ctx.data('track-location');
        this.trackCategory = this.$ctx.data('track-category');
        this.trackLinkName = this.$ctx.data('track-linkname');
        this.conversionCategory = this.$ctx.data('conversion-category');
        this.conversionDetail = this.$ctx.data('conversion-detail');
        this.conversionClass = this.$ctx.data('conversion-class');
        this.$buttonLink = this.$ctx.find('.button-link');
        if (!this.hasMultipleTopics) {
            this.$button = this.$ctx.find('.display-cfn .cfn-open .button, .display-cfn .cfn-open .link');
        }
        else {
            this.$button = this.$ctx.find('.cfn-multiple-configs .cfn-open .button, .cfn-multiple-configs .cfn-open .link');
        }
        hideLoader(this.$ctx);
        hideCFN(this.$ctx);
        hideHotlineOpen(this.$ctx);
        hideHotlineClosed(this.$ctx);
        hideError(this.$ctx);
        var $abroad = this.$ctx.find('.abroad-display');
        $abroad.addClass(CSS_CLASS_HIDDEN);
        this.$ctx.find('.button-link').addClass(CSS_CLASS_HIDDEN);
        if (this.$ctx.data('consider-abroad') && !Object(__WEBPACK_IMPORTED_MODULE_4_lib_util_helpers__["isSwissVisitor"])()) {
            if (this.displayCFNCloseOption === DISPLAY_OPTION_BUTTON) {
                this.$buttonLink.removeClass(CSS_CLASS_HIDDEN);
            }
            else if (this.displayCFNCloseOption === DISPLAY_OPTION_HOTLINE) {
                $abroad.removeClass(CSS_CLASS_HIDDEN);
            }
        }
        else if (this.hasMultipleTopics) {
            showCFN(this.$ctx.find('.cfn-multiple-configs'));
            this.$dialog.find('.subtopics-holder').removeClass(CSS_CLASS_HIDDEN);
        }
        else {
            this.$dialog.find('.subtopics-holder').addClass(CSS_CLASS_HIDDEN);
            this.activeTopicConfig = this.configuration[0];
            this.chackAvailability(this.$ctx.find('.display-cfn'), true);
        }
        this.attachEvents();
        callback();
    };
    CallFromNet.prototype.attachEvents = function () {
        this.$button.on('click', this.startDialog.bind(this));
        this.$button.on('click', this.trackOpen.bind(this));
    };
    CallFromNet.prototype.startDialog = function () {
        var _this = this;
        __WEBPACK_IMPORTED_MODULE_2_lib_generic_SDXModalDialog__["default"].show({
            html: this.$dialog,
            title: this.$ctx.data('dialog-title'),
            width: this.hasMultipleTopics ? 680 : 490,
        });
        this.$dialog.removeClass(CSS_CLASS_HIDDEN);
        if (!this.hasMultipleTopics) {
            showCFN(this.$dialog);
        }
        /* When dialog is closed all handlers attached to its elements are
        removed so we need to attach events on every dialog show */
        this.$dialog.find('.button--secondary').click(function () { return __WEBPACK_IMPORTED_MODULE_2_lib_generic_SDXModalDialog__["default"].close(); });
        this.$dialog.find('form').submit(function (evt) {
            evt.preventDefault();
            _this.submitForm();
        });
        var $subtopics = this.$dialog.find('.subtopics');
        $subtopics.find('li').each(function (i, li) { return _this.attachClickHandlerForSubtopic(i, $(li), $subtopics); });
    };
    CallFromNet.prototype.attachClickHandlerForSubtopic = function (i, $li, $subtopics) {
        var _this = this;
        $li.find('label').on('click', function (evt) {
            $subtopics.find('li').each(function (_idx, elem) { $(elem).removeClass('active'); });
            $li.addClass('active');
            _this.activeTopicConfig = _this.configuration[i];
            hideCFN(_this.$dialog);
            hideHotlineOpen(_this.$dialog);
            hideHotlineClosed(_this.$dialog);
            _this.trackSubtopics(_this.activeTopicConfig.subtopicName || '');
            _this.chackAvailability(_this.$dialog);
            evt.stopPropagation();
        });
    };
    CallFromNet.prototype.chackAvailability = function ($ctx, considerDisplayOptions) {
        var _this = this;
        if (considerDisplayOptions === void 0) { considerDisplayOptions = false; }
        var data = {
            segment: this.activeTopicConfig.segment,
        };
        if (this.activeTopicConfig.routingTarget) {
            data.routingTarget = this.activeTopicConfig.routingTarget;
        }
        else {
            data.subtopic = this.activeTopicConfig.subtopicKey;
            data.topic = this.activeTopicConfig.topicKey;
        }
        var postData = {
            data: data,
            timeout: AJAX_TIMEOUT,
            url: this.ajaxUrlPrefix + ".contactavailable" + (this.activeTopicConfig.routingTarget ? '.v2' : '') + ".json",
        };
        var promise = $.post(postData);
        hideError($ctx);
        showLoader($ctx);
        return promise
            .then(function (res) {
            if (!res) {
                hideLoader($ctx);
                displayError($ctx, considerDisplayOptions, _this.displayCFNCloseOption, _this.$buttonLink);
                return 0;
            }
            var isCfnOpen = isAvailable(res.openhours);
            var isHotlineOpen = isAvailable(res.transferhours);
            hideLoader($ctx);
            if (isCfnOpen) {
                showCFN($ctx);
            }
            else {
                if (considerDisplayOptions) {
                    if (_this.displayCFNCloseOption === DISPLAY_OPTION_BUTTON) {
                        _this.$buttonLink.removeClass(CSS_CLASS_HIDDEN);
                    }
                    else if (_this.displayCFNCloseOption === DISPLAY_OPTION_HOTLINE) {
                        if (isHotlineOpen) {
                            showHotlineOpen($ctx, res.publicnumber);
                        }
                        else {
                            _this.showHotlineClosed($ctx, res.transferhours);
                        }
                    }
                }
                else {
                    if (isHotlineOpen) {
                        showHotlineOpen($ctx, res.publicnumber);
                    }
                    else {
                        _this.showHotlineClosed($ctx, res.transferhours);
                    }
                }
            }
            return 0;
        }, function (err) {
            hideLoader($ctx);
            displayError($ctx, considerDisplayOptions, _this.displayCFNCloseOption, $ctx.find('.button-link'));
            _this.log(err.responseText);
        });
    };
    CallFromNet.prototype.track = function () {
        if (!(SCS && SCS.portal && SCS.portal.datalayer)) {
            return;
        }
        var location = this.trackLocation;
        if (this.hasMultipleTopics) {
            location += "_" + (this.activeTopicConfig.subtopicName || '');
        }
        new SCS.portal.datalayer.Interaction()
            .withEvent(this.trackAction, this.trackLabel, location, this.trackCategory, this.trackLinkName)
            .withConversion(this.conversionCategory, this.conversionDetail, this.conversionClass)
            .track();
    };
    CallFromNet.prototype.trackOpen = function () {
        if (!(SCS && SCS.portal && SCS.portal.datalayer)) {
            return;
        }
        SCS.portal.datalayer.trackEvent(this.trackAction + "_open", this.trackLabel, this.trackLocation, this.trackCategory, this.trackLinkName);
    };
    CallFromNet.prototype.trackSubtopics = function (subtopicLabel) {
        if (!(SCS && SCS.portal && SCS.portal.datalayer)) {
            return;
        }
        SCS.portal.datalayer.trackEvent(this.trackAction + "_" + subtopicLabel, this.trackLabel, this.trackLocation, this.trackCategory, this.trackLinkName);
    };
    CallFromNet.prototype.submitForm = function () {
        var _this = this;
        this.$dialog.find('.phone-numbers input').each(function (_idx, elem) {
            var $elem = $(elem);
            var $field = $elem.closest('.field');
            var $fieldError = $field.find('.field-validation-error');
            var elemVal = $elem.val();
            var isValid = Object(__WEBPACK_IMPORTED_MODULE_3__helpers__["h" /* validatePhoneNumber */])(Object(__WEBPACK_IMPORTED_MODULE_4_lib_util_helpers__["sanitizePhone"])(elemVal));
            if ($elem.attr('aria-required') === 'true') {
                $field.addClass(CSS_CLASS_ERROR);
                $fieldError.removeClass(CSS_CLASS_HIDDEN);
                if (isValid && elemVal) {
                    $field.removeClass(CSS_CLASS_ERROR);
                    $fieldError.addClass(CSS_CLASS_HIDDEN);
                }
            }
            else {
                if (!isValid && elemVal) {
                    $field.addClass(CSS_CLASS_ERROR);
                    $fieldError.removeClass(CSS_CLASS_HIDDEN);
                }
                else {
                    $field.removeClass(CSS_CLASS_ERROR);
                    $fieldError.addClass(CSS_CLASS_HIDDEN);
                }
            }
        });
        var $form = this.$dialog.find('form');
        var phoneNo = $form.find('input#numberToCall').val().replace(/\s+/g, '');
        if (!$form.find('.field.error').length) {
            var postData = {
                data: this.getDataForSubmit(),
                timeout: AJAX_TIMEOUT,
                url: this.ajaxUrlPrefix + ".contactrequest" + (this.activeTopicConfig.routingTarget ? '.v2' : '') + ".json",
            };
            this.track();
            var promise = $.post(postData);
            promise
                .then(function () {
                _this.$successDialog.removeClass(CSS_CLASS_HIDDEN);
                _this.$successDialog
                    .find('.success-message')
                    .text(_this.$ctx.data('success-message').replace('${numberToCall}', phoneNo));
                __WEBPACK_IMPORTED_MODULE_2_lib_generic_SDXModalDialog__["default"].show({
                    buttons: [{
                            primary: true,
                            title: _this.$ctx.data('close-dialog-button-label'),
                            type: 'close',
                        }],
                    html: _this.$successDialog,
                    title: _this.$ctx.data('success-dialog-title'),
                    width: _this.hasMultipleTopics ? 680 : 490,
                });
            }, function () {
                __WEBPACK_IMPORTED_MODULE_2_lib_generic_SDXModalDialog__["default"].show({
                    buttons: [{
                            click: _this.startDialog.bind(_this),
                            thin: true,
                            title: _this.$ctx.data('reset-dialog-button-label'),
                        }],
                    notification: 'alert',
                    text: _this.$ctx.data('error-message'),
                });
            });
        }
    };
    CallFromNet.prototype.getDataForSubmit = function () {
        var $form = this.$dialog.find('form');
        var customerLineNumber = $form.find('input[name="customerLine"]').val();
        var numberToCallVal = Object(__WEBPACK_IMPORTED_MODULE_3__helpers__["c" /* getValidSanitizePhoneNumber */])($form.find('input[name="numberToCall"]').val()) || '';
        var customerLineVal = Object(__WEBPACK_IMPORTED_MODULE_3__helpers__["c" /* getValidSanitizePhoneNumber */])(customerLineNumber) || '';
        var data = {
            conversionclass: this.$ctx.data('conversion-class'),
            eventcategory: this.$ctx.data('track-category'),
            numbertocall: numberToCallVal,
            phonenumber: customerLineVal,
            segment: this.activeTopicConfig.segment,
            source: window.location.href.slice(0, 255),
        };
        if (this.activeTopicConfig.routingTarget) {
            data.routingTarget = this.activeTopicConfig.routingTarget;
        }
        else {
            data.subtopic = this.activeTopicConfig.subtopicKey;
            data.topic = this.activeTopicConfig.topicKey;
        }
        return data;
    };
    CallFromNet.prototype.showHotlineClosed = function ($ctx, openingHours) {
        if (this.displayOpeningHours) {
            var label = this.$ctx.data('closed-label');
            var lang = $('html').attr('lang') || 'de';
            if (!this.displayOpeningHoursAsTooltip) {
                $ctx.find('.hotline-closed .open-hours')
                    .empty()
                    .append(Object(__WEBPACK_IMPORTED_MODULE_3__helpers__["b" /* formatCloseTime */])(openingHours, label, lang));
            }
            else {
                var formatedTime = Object(__WEBPACK_IMPORTED_MODULE_3__helpers__["b" /* formatCloseTime */])(openingHours, label, lang).html();
                var str = "<div>" + this.$ctx.data('open-time') + " <span class=\"mod modCallOut sdx\">" + formatedTime + "</span></div>";
                $ctx.find('.hotline-closed')
                    .empty()
                    .append($(str));
                Object(__WEBPACK_IMPORTED_MODULE_4_lib_util_helpers__["initNewModules"])($ctx.find('.hotline-closed'));
            }
        }
        $ctx.find('.hotline-close').removeClass(CSS_CLASS_HIDDEN);
    };
    return CallFromNet;
}(__WEBPACK_IMPORTED_MODULE_1_lib_vendor_terrific_Module__["a" /* Module */]));
/* harmony default export */ __webpack_exports__["a"] = (CallFromNet);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),
/* 201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lib_vendor_terrific_Module__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_bootstrap_load_qtip__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lib_util_helpers__ = __webpack_require__(4);




var CallOut = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */])(CallOut, _super);
    function CallOut() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.content = '';
        _this.overwriteClass = '';
        _this.overwriteIconClass = '';
        _this.offsetOverrideX = 0;
        _this.offsetOverrideY = 2;
        _this.isMobile = false;
        _this.isMobileOnly = false;
        _this.isSDX = true;
        _this.$tip = null;
        return _this;
    }
    CallOut.prototype.on = function (callback) {
        var $ctx = this.$ctx;
        // Configuration
        this.content = $ctx.html();
        // <div data-class-overwrite="myPEXSpecialStyleInGrau"…
        this.overwriteClass = $ctx.data('class-overwrite') || '';
        this.overwriteIconClass = $ctx.data('icon-class-overwrite') || '';
        this.offsetOverrideX = $ctx.data('offset-override-x') || 0;
        this.offsetOverrideY = $ctx.data('offset-override-y') || 2;
        this.isMobileOnly = $ctx.is('.isMobileOnly');
        this.isMobile = Object(__WEBPACK_IMPORTED_MODULE_3_lib_util_helpers__["isMobilePage"])();
        this.isSDX = $ctx.is('.sdx');
        this.log.debug('content', this.content);
        $ctx.hide();
        callback();
    };
    CallOut.prototype.after = function () {
        var $ctx = this.$ctx;
        if (this.isMobileOnly && !this.isMobile) {
            // Render as text on desktop
            $ctx.removeClass('mod modCallOut isMobileOnly').attr('style', '');
            return;
        }
        if (this.isMobile) {
            var $tabNav = this.$ctx.closest('.modTabNavigation');
            var tabNav = this.sandbox.getModuleInstance($tabNav, 'TabNavigation');
            if (tabNav) {
                this.sandbox.subscribe(tabNav.channel, this);
            }
        }
        if (!this.isSDX) {
            this.$tip = $('<span/>');
            this.$tip.addClass('scs-icon info-callout');
        }
        else {
            this.$tip = $('<i/>');
            this.$tip.addClass('sdx icon icon-046-information-circle');
        }
        this.$tip
            .attr('title', this.content)
            .addClass(this.overwriteClass)
            .addClass(this.overwriteIconClass)
            .insertBefore(this.$ctx)
            .before(' ')
            .after(' ');
        var configuration = this.isMobile ? this.mobileConfiguration() : this.desktopConfiguration();
        this.$tip.qtip(configuration);
    };
    CallOut.prototype.stop = function () {
        if (this.$tip) {
            this.$tip.qtip('destroy', true);
            this.$tip.remove();
            this.$tip = null;
        }
        Object.getPrototypeOf(Object.getPrototypeOf(this)).stop.apply(this, arguments);
    };
    /**
     * This function returns configuration object for jQuery tooltip plug-in
     * qTip. This configuration object is used on mobile.
     *
     * @method mobileConfiguration
     * @return Configuration object for jQuery tooltip plug-in qTip.
     */
    CallOut.prototype.mobileConfiguration = function () {
        var _this = this;
        var config = {
            content: {
                button: 'close',
                title: {
                    text: ' ',
                },
            },
            events: {
                hide: function () {
                    _this.$tip.removeClass('mobile-active');
                },
                show: function () {
                    _this.$tip.addClass('mobile-active');
                },
            },
            hide: {
                event: 'click',
            },
            show: {
                event: 'click',
                solo: true,
            },
            style: {
                classes: 'ui-tooltip-mobile',
            },
        };
        var $modalParent = this.$ctx.closest('.modal');
        if ($modalParent.length) {
            config.position = {
                container: $modalParent.find('.modal__content'),
            };
            config.content.title.button = $('<i class="icon icon-022-close icon--s2 font--semi-bold sc-navy" aria-hidden="true"></i>');
        }
        return config;
    };
    /**
     * This function returns configuration object for jQuery tooltip plug-in
     * qTip. This configuration object is used on desktop.
     *
     * @method desktopConfiguration
     * @return Configuration object for jQuery tooltip plug-in qTip.
     */
    CallOut.prototype.desktopConfiguration = function () {
        var config = {
            position: {
                adjust: {
                    x: this.offsetOverrideX,
                    y: this.offsetOverrideY,
                },
                at: 'top center',
                my: 'bottom center',
                viewport: $(document.documentElement),
            },
            style: {
                classes: this.overwriteClass + " scs-callout " + (this.isSDX ? ' sdx' : ''),
                tip: {
                    corner: true,
                    height: 6,
                    width: 8,
                },
            },
        };
        var $modalParent = this.$ctx.closest('.modal');
        if ($modalParent.length) {
            config.position.container = $modalParent;
        }
        return config;
    };
    /**
     * This function hides callout when tab is changed.
     *
     * @method onActivateTab
     * @return void
     */
    CallOut.prototype.onActivateTab = function () {
        this.$tip.qtip('hide');
    };
    return CallOut;
}(__WEBPACK_IMPORTED_MODULE_1_lib_vendor_terrific_Module__["a" /* Module */]));
/* harmony default export */ __webpack_exports__["a"] = (CallOut);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),
/* 202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($, jQuery) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lib_util_helpers__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lib_vendor_terrific_Module__ = __webpack_require__(3);



// Compile regex pattern only once
var regExp = /\$\{\s*([^}\s]+)\s*\}/g;
/**
 * Data Container Terrific Module
 */
var DataContainer = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */])(DataContainer, _super);
    function DataContainer($ctx, sandbox, id, modName) {
        var _this = _super.call(this, $ctx, sandbox, id, modName) || this;
        _this.prefix = $ctx.data('provider-prefix');
        _this.serviceUrl = $ctx.data('ajax-url');
        _this.paramName = $ctx.data('hash-parameter-uri');
        _this.paramValue = $ctx.data('hash-parameter-default');
        _this.$form = $ctx.find('form');
        _this.$inputs = _this.$form.find(':input[data-default-value]')
            .add(_this.$form.find('.custom-checkbox, .custom-radio'));
        return _this;
    }
    /**
     * Hook function to do all of your module stuff.
     *
     * @method on
     * @param  {Hook} callback Callback function
     * @return void
     */
    DataContainer.prototype.on = function (callback) {
        // Don't replace for author
        if (Object(__WEBPACK_IMPORTED_MODULE_1_lib_util_helpers__["isEditMode"])()) {
            return;
        }
        var formAction = this.$form.attr('action') || location.href;
        var locationHash = location.hash.substr(1); // Cut '#'
        var locationParams = new URLSearchParams(locationHash);
        // Check that expected hash parameter is present
        if (locationParams.has(this.paramName)) {
            this.paramValue = locationParams.get(this.paramName);
            var postData = { hashParameterURI: this.paramValue };
            // Request data for "templating"
            $.post({
                /* Needs to be synced, otherwise ScForm will replace them first */
                async: false,
                data: postData,
                dataType: 'json',
                success: this.onResult.bind(this),
                url: this.serviceUrl,
            });
            // Preserve consumed hashes in form action
            var actionUrl = new URL(formAction, location.href);
            var actionHash = actionUrl.hash.substr(1); // Cut '#'
            var actionParams = new URLSearchParams(actionHash);
            actionParams.set(this.paramName, this.paramValue);
            actionUrl.hash = '#' + actionParams.toString();
            this.$form.attr('action', actionUrl.toString());
        }
        else {
            // Log warning, since we always expect the hash parameter to be present
            this.log.warn("Expected hash parameter (" + this.paramName + ") for DataContainer not provided!");
        }
        // Append hidden field on the form
        this.$form.append(jQuery('<input>', {
            name: this.prefix + "_hidden_for_fedp",
            type: 'hidden', value: this.paramValue,
        }));
        callback();
    };
    DataContainer.prototype.onResult = function (data) {
        if (Array.isArray(data) && data.length > 0) {
            // Replace placeholders with data
            this.replacePlaceholders(data[0]);
        }
        else {
            // Log error, since we always expect some data to be filled in
            this.log.error("No results for DataContainer (" + this.paramValue + ")");
        }
    };
    // Replace placeholders in `text` with `data`.
    // Returns the `string` with placeholders replaced.
    // If nothing is replaced, it returns `null` instead.
    DataContainer.prototype.replacePlaceholder = function (data, text) {
        var _this = this;
        var hasPlaceholder = false;
        var replaced = text.replace(regExp, function (matched, placeholder) {
            hasPlaceholder = true;
            var matches = placeholder.split('.', 2);
            return matches[0] === _this.prefix &&
                data[matches[1]] !== undefined ?
                String(data[matches[1]]) : matched;
        });
        if (hasPlaceholder) {
            return replaced;
        }
        return null;
    };
    // Replace placeholders in all text nodes recursively.
    DataContainer.prototype.replaceInTextNodes = function (data) {
        // Return early if option is not enabled
        if (!this.$ctx.data('replace-in-texts')) {
            return;
        }
        // Start at the root of the container
        var nodeQueue = [this.$ctx[0]];
        // Process until nothing more to do
        while (nodeQueue.length > 0) {
            // Remove the first item of the queue and process it
            var current = nodeQueue.shift();
            // Clean up all the text nodes under this
            // Element (merge adjacent, remove empty).
            current.normalize();
            // Check all child nodes of the current HTML Element
            for (var child = current.firstChild; child !== null; child = child.nextSibling) {
                // Using a switch for optimal performance
                switch (child.nodeType) {
                    case 3: // Node.TEXT_NODE:
                        if (child.textContent !== null) {
                            var replaced = this.replacePlaceholder(data, child.textContent);
                            if (replaced !== null) {
                                child.textContent = replaced;
                            }
                        }
                        break;
                    case 1: // Node.ELEMENT_NODE:
                        // Add to queue to be processed later
                        nodeQueue.push(child);
                        break;
                    default:
                        // Nothing to do
                        break;
                }
            }
        }
    };
    // Replace placeholders for input elements.
    // Also for defaults stored in data attributes.
    DataContainer.prototype.replaceForInputFields = function (data) {
        // Functions differ by element types
        var getter;
        var setter;
        // Process all fields in the form
        for (var _i = 0, _a = this.$inputs; _i < _a.length; _i++) {
            var input = _a[_i];
            var $input = $(input);
            if ($input.is('input')) {
                getter = function ($el) { return String($el.val()); };
                setter = function ($el, val) { return $el.val(val); };
            }
            else if ($input.is('div')) {
                getter = function ($el) { return String($el.data('default-value')); };
                setter = function ($el, val) { return $el.data('default-value', val); };
            }
            else {
                getter = function ($el) { return String($el.text()); };
                setter = function ($el, val) { return $el.text(val); };
            }
            var replaced = this.replacePlaceholder(data, getter($input));
            if (replaced !== null) {
                setter($input, replaced);
            }
        }
    };
    DataContainer.prototype.replacePlaceholders = function (data) {
        this.replaceInTextNodes(data);
        this.replaceForInputFields(data);
    };
    return DataContainer;
}(__WEBPACK_IMPORTED_MODULE_2_lib_vendor_terrific_Module__["a" /* Module */]));
/* harmony default export */ __webpack_exports__["a"] = (DataContainer);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0), __webpack_require__(0)))

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * @fileoverview
 * - Using the 'QRCode for Javascript library'
 * - Fixed dataset of 'QRCode for Javascript library' for support full-spec.
 * - this library has no dependencies.
 * 
 * @author davidshimjs
 * @see <a href="http://www.d-project.com/" target="_blank">http://www.d-project.com/</a>
 * @see <a href="http://jeromeetienne.github.com/jquery-qrcode/" target="_blank">http://jeromeetienne.github.com/jquery-qrcode/</a>
 */
var QRCode;

(function () {
	//---------------------------------------------------------------------
	// QRCode for JavaScript
	//
	// Copyright (c) 2009 Kazuhiko Arase
	//
	// URL: http://www.d-project.com/
	//
	// Licensed under the MIT license:
	//   http://www.opensource.org/licenses/mit-license.php
	//
	// The word "QR Code" is registered trademark of 
	// DENSO WAVE INCORPORATED
	//   http://www.denso-wave.com/qrcode/faqpatent-e.html
	//
	//---------------------------------------------------------------------
	function QR8bitByte(data) {
		this.mode = QRMode.MODE_8BIT_BYTE;
		this.data = data;
		this.parsedData = [];

		// Added to support UTF-8 Characters
		for (var i = 0, l = this.data.length; i < l; i++) {
			var byteArray = [];
			var code = this.data.charCodeAt(i);

			if (code > 0x10000) {
				byteArray[0] = 0xF0 | ((code & 0x1C0000) >>> 18);
				byteArray[1] = 0x80 | ((code & 0x3F000) >>> 12);
				byteArray[2] = 0x80 | ((code & 0xFC0) >>> 6);
				byteArray[3] = 0x80 | (code & 0x3F);
			} else if (code > 0x800) {
				byteArray[0] = 0xE0 | ((code & 0xF000) >>> 12);
				byteArray[1] = 0x80 | ((code & 0xFC0) >>> 6);
				byteArray[2] = 0x80 | (code & 0x3F);
			} else if (code > 0x80) {
				byteArray[0] = 0xC0 | ((code & 0x7C0) >>> 6);
				byteArray[1] = 0x80 | (code & 0x3F);
			} else {
				byteArray[0] = code;
			}

			this.parsedData.push(byteArray);
		}

		this.parsedData = Array.prototype.concat.apply([], this.parsedData);

		if (this.parsedData.length != this.data.length) {
			this.parsedData.unshift(191);
			this.parsedData.unshift(187);
			this.parsedData.unshift(239);
		}
	}

	QR8bitByte.prototype = {
		getLength: function (buffer) {
			return this.parsedData.length;
		},
		write: function (buffer) {
			for (var i = 0, l = this.parsedData.length; i < l; i++) {
				buffer.put(this.parsedData[i], 8);
			}
		}
	};

	function QRCodeModel(typeNumber, errorCorrectLevel) {
		this.typeNumber = typeNumber;
		this.errorCorrectLevel = errorCorrectLevel;
		this.modules = null;
		this.moduleCount = 0;
		this.dataCache = null;
		this.dataList = [];
	}

	QRCodeModel.prototype={addData:function(data){var newData=new QR8bitByte(data);this.dataList.push(newData);this.dataCache=null;},isDark:function(row,col){if(row<0||this.moduleCount<=row||col<0||this.moduleCount<=col){throw new Error(row+","+col);}
	return this.modules[row][col];},getModuleCount:function(){return this.moduleCount;},make:function(){this.makeImpl(false,this.getBestMaskPattern());},makeImpl:function(test,maskPattern){this.moduleCount=this.typeNumber*4+17;this.modules=new Array(this.moduleCount);for(var row=0;row<this.moduleCount;row++){this.modules[row]=new Array(this.moduleCount);for(var col=0;col<this.moduleCount;col++){this.modules[row][col]=null;}}
	this.setupPositionProbePattern(0,0);this.setupPositionProbePattern(this.moduleCount-7,0);this.setupPositionProbePattern(0,this.moduleCount-7);this.setupPositionAdjustPattern();this.setupTimingPattern();this.setupTypeInfo(test,maskPattern);if(this.typeNumber>=7){this.setupTypeNumber(test);}
	if(this.dataCache==null){this.dataCache=QRCodeModel.createData(this.typeNumber,this.errorCorrectLevel,this.dataList);}
	this.mapData(this.dataCache,maskPattern);},setupPositionProbePattern:function(row,col){for(var r=-1;r<=7;r++){if(row+r<=-1||this.moduleCount<=row+r)continue;for(var c=-1;c<=7;c++){if(col+c<=-1||this.moduleCount<=col+c)continue;if((0<=r&&r<=6&&(c==0||c==6))||(0<=c&&c<=6&&(r==0||r==6))||(2<=r&&r<=4&&2<=c&&c<=4)){this.modules[row+r][col+c]=true;}else{this.modules[row+r][col+c]=false;}}}},getBestMaskPattern:function(){var minLostPoint=0;var pattern=0;for(var i=0;i<8;i++){this.makeImpl(true,i);var lostPoint=QRUtil.getLostPoint(this);if(i==0||minLostPoint>lostPoint){minLostPoint=lostPoint;pattern=i;}}
	return pattern;},createMovieClip:function(target_mc,instance_name,depth){var qr_mc=target_mc.createEmptyMovieClip(instance_name,depth);var cs=1;this.make();for(var row=0;row<this.modules.length;row++){var y=row*cs;for(var col=0;col<this.modules[row].length;col++){var x=col*cs;var dark=this.modules[row][col];if(dark){qr_mc.beginFill(0,100);qr_mc.moveTo(x,y);qr_mc.lineTo(x+cs,y);qr_mc.lineTo(x+cs,y+cs);qr_mc.lineTo(x,y+cs);qr_mc.endFill();}}}
	return qr_mc;},setupTimingPattern:function(){for(var r=8;r<this.moduleCount-8;r++){if(this.modules[r][6]!=null){continue;}
	this.modules[r][6]=(r%2==0);}
	for(var c=8;c<this.moduleCount-8;c++){if(this.modules[6][c]!=null){continue;}
	this.modules[6][c]=(c%2==0);}},setupPositionAdjustPattern:function(){var pos=QRUtil.getPatternPosition(this.typeNumber);for(var i=0;i<pos.length;i++){for(var j=0;j<pos.length;j++){var row=pos[i];var col=pos[j];if(this.modules[row][col]!=null){continue;}
	for(var r=-2;r<=2;r++){for(var c=-2;c<=2;c++){if(r==-2||r==2||c==-2||c==2||(r==0&&c==0)){this.modules[row+r][col+c]=true;}else{this.modules[row+r][col+c]=false;}}}}}},setupTypeNumber:function(test){var bits=QRUtil.getBCHTypeNumber(this.typeNumber);for(var i=0;i<18;i++){var mod=(!test&&((bits>>i)&1)==1);this.modules[Math.floor(i/3)][i%3+this.moduleCount-8-3]=mod;}
	for(var i=0;i<18;i++){var mod=(!test&&((bits>>i)&1)==1);this.modules[i%3+this.moduleCount-8-3][Math.floor(i/3)]=mod;}},setupTypeInfo:function(test,maskPattern){var data=(this.errorCorrectLevel<<3)|maskPattern;var bits=QRUtil.getBCHTypeInfo(data);for(var i=0;i<15;i++){var mod=(!test&&((bits>>i)&1)==1);if(i<6){this.modules[i][8]=mod;}else if(i<8){this.modules[i+1][8]=mod;}else{this.modules[this.moduleCount-15+i][8]=mod;}}
	for(var i=0;i<15;i++){var mod=(!test&&((bits>>i)&1)==1);if(i<8){this.modules[8][this.moduleCount-i-1]=mod;}else if(i<9){this.modules[8][15-i-1+1]=mod;}else{this.modules[8][15-i-1]=mod;}}
	this.modules[this.moduleCount-8][8]=(!test);},mapData:function(data,maskPattern){var inc=-1;var row=this.moduleCount-1;var bitIndex=7;var byteIndex=0;for(var col=this.moduleCount-1;col>0;col-=2){if(col==6)col--;while(true){for(var c=0;c<2;c++){if(this.modules[row][col-c]==null){var dark=false;if(byteIndex<data.length){dark=(((data[byteIndex]>>>bitIndex)&1)==1);}
	var mask=QRUtil.getMask(maskPattern,row,col-c);if(mask){dark=!dark;}
	this.modules[row][col-c]=dark;bitIndex--;if(bitIndex==-1){byteIndex++;bitIndex=7;}}}
	row+=inc;if(row<0||this.moduleCount<=row){row-=inc;inc=-inc;break;}}}}};QRCodeModel.PAD0=0xEC;QRCodeModel.PAD1=0x11;QRCodeModel.createData=function(typeNumber,errorCorrectLevel,dataList){var rsBlocks=QRRSBlock.getRSBlocks(typeNumber,errorCorrectLevel);var buffer=new QRBitBuffer();for(var i=0;i<dataList.length;i++){var data=dataList[i];buffer.put(data.mode,4);buffer.put(data.getLength(),QRUtil.getLengthInBits(data.mode,typeNumber));data.write(buffer);}
	var totalDataCount=0;for(var i=0;i<rsBlocks.length;i++){totalDataCount+=rsBlocks[i].dataCount;}
	if(buffer.getLengthInBits()>totalDataCount*8){throw new Error("code length overflow. ("
	+buffer.getLengthInBits()
	+">"
	+totalDataCount*8
	+")");}
	if(buffer.getLengthInBits()+4<=totalDataCount*8){buffer.put(0,4);}
	while(buffer.getLengthInBits()%8!=0){buffer.putBit(false);}
	while(true){if(buffer.getLengthInBits()>=totalDataCount*8){break;}
	buffer.put(QRCodeModel.PAD0,8);if(buffer.getLengthInBits()>=totalDataCount*8){break;}
	buffer.put(QRCodeModel.PAD1,8);}
	return QRCodeModel.createBytes(buffer,rsBlocks);};QRCodeModel.createBytes=function(buffer,rsBlocks){var offset=0;var maxDcCount=0;var maxEcCount=0;var dcdata=new Array(rsBlocks.length);var ecdata=new Array(rsBlocks.length);for(var r=0;r<rsBlocks.length;r++){var dcCount=rsBlocks[r].dataCount;var ecCount=rsBlocks[r].totalCount-dcCount;maxDcCount=Math.max(maxDcCount,dcCount);maxEcCount=Math.max(maxEcCount,ecCount);dcdata[r]=new Array(dcCount);for(var i=0;i<dcdata[r].length;i++){dcdata[r][i]=0xff&buffer.buffer[i+offset];}
	offset+=dcCount;var rsPoly=QRUtil.getErrorCorrectPolynomial(ecCount);var rawPoly=new QRPolynomial(dcdata[r],rsPoly.getLength()-1);var modPoly=rawPoly.mod(rsPoly);ecdata[r]=new Array(rsPoly.getLength()-1);for(var i=0;i<ecdata[r].length;i++){var modIndex=i+modPoly.getLength()-ecdata[r].length;ecdata[r][i]=(modIndex>=0)?modPoly.get(modIndex):0;}}
	var totalCodeCount=0;for(var i=0;i<rsBlocks.length;i++){totalCodeCount+=rsBlocks[i].totalCount;}
	var data=new Array(totalCodeCount);var index=0;for(var i=0;i<maxDcCount;i++){for(var r=0;r<rsBlocks.length;r++){if(i<dcdata[r].length){data[index++]=dcdata[r][i];}}}
	for(var i=0;i<maxEcCount;i++){for(var r=0;r<rsBlocks.length;r++){if(i<ecdata[r].length){data[index++]=ecdata[r][i];}}}
	return data;};var QRMode={MODE_NUMBER:1<<0,MODE_ALPHA_NUM:1<<1,MODE_8BIT_BYTE:1<<2,MODE_KANJI:1<<3};var QRErrorCorrectLevel={L:1,M:0,Q:3,H:2};var QRMaskPattern={PATTERN000:0,PATTERN001:1,PATTERN010:2,PATTERN011:3,PATTERN100:4,PATTERN101:5,PATTERN110:6,PATTERN111:7};var QRUtil={PATTERN_POSITION_TABLE:[[],[6,18],[6,22],[6,26],[6,30],[6,34],[6,22,38],[6,24,42],[6,26,46],[6,28,50],[6,30,54],[6,32,58],[6,34,62],[6,26,46,66],[6,26,48,70],[6,26,50,74],[6,30,54,78],[6,30,56,82],[6,30,58,86],[6,34,62,90],[6,28,50,72,94],[6,26,50,74,98],[6,30,54,78,102],[6,28,54,80,106],[6,32,58,84,110],[6,30,58,86,114],[6,34,62,90,118],[6,26,50,74,98,122],[6,30,54,78,102,126],[6,26,52,78,104,130],[6,30,56,82,108,134],[6,34,60,86,112,138],[6,30,58,86,114,142],[6,34,62,90,118,146],[6,30,54,78,102,126,150],[6,24,50,76,102,128,154],[6,28,54,80,106,132,158],[6,32,58,84,110,136,162],[6,26,54,82,110,138,166],[6,30,58,86,114,142,170]],G15:(1<<10)|(1<<8)|(1<<5)|(1<<4)|(1<<2)|(1<<1)|(1<<0),G18:(1<<12)|(1<<11)|(1<<10)|(1<<9)|(1<<8)|(1<<5)|(1<<2)|(1<<0),G15_MASK:(1<<14)|(1<<12)|(1<<10)|(1<<4)|(1<<1),getBCHTypeInfo:function(data){var d=data<<10;while(QRUtil.getBCHDigit(d)-QRUtil.getBCHDigit(QRUtil.G15)>=0){d^=(QRUtil.G15<<(QRUtil.getBCHDigit(d)-QRUtil.getBCHDigit(QRUtil.G15)));}
	return((data<<10)|d)^QRUtil.G15_MASK;},getBCHTypeNumber:function(data){var d=data<<12;while(QRUtil.getBCHDigit(d)-QRUtil.getBCHDigit(QRUtil.G18)>=0){d^=(QRUtil.G18<<(QRUtil.getBCHDigit(d)-QRUtil.getBCHDigit(QRUtil.G18)));}
	return(data<<12)|d;},getBCHDigit:function(data){var digit=0;while(data!=0){digit++;data>>>=1;}
	return digit;},getPatternPosition:function(typeNumber){return QRUtil.PATTERN_POSITION_TABLE[typeNumber-1];},getMask:function(maskPattern,i,j){switch(maskPattern){case QRMaskPattern.PATTERN000:return(i+j)%2==0;case QRMaskPattern.PATTERN001:return i%2==0;case QRMaskPattern.PATTERN010:return j%3==0;case QRMaskPattern.PATTERN011:return(i+j)%3==0;case QRMaskPattern.PATTERN100:return(Math.floor(i/2)+Math.floor(j/3))%2==0;case QRMaskPattern.PATTERN101:return(i*j)%2+(i*j)%3==0;case QRMaskPattern.PATTERN110:return((i*j)%2+(i*j)%3)%2==0;case QRMaskPattern.PATTERN111:return((i*j)%3+(i+j)%2)%2==0;default:throw new Error("bad maskPattern:"+maskPattern);}},getErrorCorrectPolynomial:function(errorCorrectLength){var a=new QRPolynomial([1],0);for(var i=0;i<errorCorrectLength;i++){a=a.multiply(new QRPolynomial([1,QRMath.gexp(i)],0));}
	return a;},getLengthInBits:function(mode,type){if(1<=type&&type<10){switch(mode){case QRMode.MODE_NUMBER:return 10;case QRMode.MODE_ALPHA_NUM:return 9;case QRMode.MODE_8BIT_BYTE:return 8;case QRMode.MODE_KANJI:return 8;default:throw new Error("mode:"+mode);}}else if(type<27){switch(mode){case QRMode.MODE_NUMBER:return 12;case QRMode.MODE_ALPHA_NUM:return 11;case QRMode.MODE_8BIT_BYTE:return 16;case QRMode.MODE_KANJI:return 10;default:throw new Error("mode:"+mode);}}else if(type<41){switch(mode){case QRMode.MODE_NUMBER:return 14;case QRMode.MODE_ALPHA_NUM:return 13;case QRMode.MODE_8BIT_BYTE:return 16;case QRMode.MODE_KANJI:return 12;default:throw new Error("mode:"+mode);}}else{throw new Error("type:"+type);}},getLostPoint:function(qrCode){var moduleCount=qrCode.getModuleCount();var lostPoint=0;for(var row=0;row<moduleCount;row++){for(var col=0;col<moduleCount;col++){var sameCount=0;var dark=qrCode.isDark(row,col);for(var r=-1;r<=1;r++){if(row+r<0||moduleCount<=row+r){continue;}
	for(var c=-1;c<=1;c++){if(col+c<0||moduleCount<=col+c){continue;}
	if(r==0&&c==0){continue;}
	if(dark==qrCode.isDark(row+r,col+c)){sameCount++;}}}
	if(sameCount>5){lostPoint+=(3+sameCount-5);}}}
	for(var row=0;row<moduleCount-1;row++){for(var col=0;col<moduleCount-1;col++){var count=0;if(qrCode.isDark(row,col))count++;if(qrCode.isDark(row+1,col))count++;if(qrCode.isDark(row,col+1))count++;if(qrCode.isDark(row+1,col+1))count++;if(count==0||count==4){lostPoint+=3;}}}
	for(var row=0;row<moduleCount;row++){for(var col=0;col<moduleCount-6;col++){if(qrCode.isDark(row,col)&&!qrCode.isDark(row,col+1)&&qrCode.isDark(row,col+2)&&qrCode.isDark(row,col+3)&&qrCode.isDark(row,col+4)&&!qrCode.isDark(row,col+5)&&qrCode.isDark(row,col+6)){lostPoint+=40;}}}
	for(var col=0;col<moduleCount;col++){for(var row=0;row<moduleCount-6;row++){if(qrCode.isDark(row,col)&&!qrCode.isDark(row+1,col)&&qrCode.isDark(row+2,col)&&qrCode.isDark(row+3,col)&&qrCode.isDark(row+4,col)&&!qrCode.isDark(row+5,col)&&qrCode.isDark(row+6,col)){lostPoint+=40;}}}
	var darkCount=0;for(var col=0;col<moduleCount;col++){for(var row=0;row<moduleCount;row++){if(qrCode.isDark(row,col)){darkCount++;}}}
	var ratio=Math.abs(100*darkCount/moduleCount/moduleCount-50)/5;lostPoint+=ratio*10;return lostPoint;}};var QRMath={glog:function(n){if(n<1){throw new Error("glog("+n+")");}
	return QRMath.LOG_TABLE[n];},gexp:function(n){while(n<0){n+=255;}
	while(n>=256){n-=255;}
	return QRMath.EXP_TABLE[n];},EXP_TABLE:new Array(256),LOG_TABLE:new Array(256)};for(var i=0;i<8;i++){QRMath.EXP_TABLE[i]=1<<i;}
	for(var i=8;i<256;i++){QRMath.EXP_TABLE[i]=QRMath.EXP_TABLE[i-4]^QRMath.EXP_TABLE[i-5]^QRMath.EXP_TABLE[i-6]^QRMath.EXP_TABLE[i-8];}
	for(var i=0;i<255;i++){QRMath.LOG_TABLE[QRMath.EXP_TABLE[i]]=i;}
	function QRPolynomial(num,shift){if(num.length==undefined){throw new Error(num.length+"/"+shift);}
	var offset=0;while(offset<num.length&&num[offset]==0){offset++;}
	this.num=new Array(num.length-offset+shift);for(var i=0;i<num.length-offset;i++){this.num[i]=num[i+offset];}}
	QRPolynomial.prototype={get:function(index){return this.num[index];},getLength:function(){return this.num.length;},multiply:function(e){var num=new Array(this.getLength()+e.getLength()-1);for(var i=0;i<this.getLength();i++){for(var j=0;j<e.getLength();j++){num[i+j]^=QRMath.gexp(QRMath.glog(this.get(i))+QRMath.glog(e.get(j)));}}
	return new QRPolynomial(num,0);},mod:function(e){if(this.getLength()-e.getLength()<0){return this;}
	var ratio=QRMath.glog(this.get(0))-QRMath.glog(e.get(0));var num=new Array(this.getLength());for(var i=0;i<this.getLength();i++){num[i]=this.get(i);}
	for(var i=0;i<e.getLength();i++){num[i]^=QRMath.gexp(QRMath.glog(e.get(i))+ratio);}
	return new QRPolynomial(num,0).mod(e);}};function QRRSBlock(totalCount,dataCount){this.totalCount=totalCount;this.dataCount=dataCount;}
	QRRSBlock.RS_BLOCK_TABLE=[[1,26,19],[1,26,16],[1,26,13],[1,26,9],[1,44,34],[1,44,28],[1,44,22],[1,44,16],[1,70,55],[1,70,44],[2,35,17],[2,35,13],[1,100,80],[2,50,32],[2,50,24],[4,25,9],[1,134,108],[2,67,43],[2,33,15,2,34,16],[2,33,11,2,34,12],[2,86,68],[4,43,27],[4,43,19],[4,43,15],[2,98,78],[4,49,31],[2,32,14,4,33,15],[4,39,13,1,40,14],[2,121,97],[2,60,38,2,61,39],[4,40,18,2,41,19],[4,40,14,2,41,15],[2,146,116],[3,58,36,2,59,37],[4,36,16,4,37,17],[4,36,12,4,37,13],[2,86,68,2,87,69],[4,69,43,1,70,44],[6,43,19,2,44,20],[6,43,15,2,44,16],[4,101,81],[1,80,50,4,81,51],[4,50,22,4,51,23],[3,36,12,8,37,13],[2,116,92,2,117,93],[6,58,36,2,59,37],[4,46,20,6,47,21],[7,42,14,4,43,15],[4,133,107],[8,59,37,1,60,38],[8,44,20,4,45,21],[12,33,11,4,34,12],[3,145,115,1,146,116],[4,64,40,5,65,41],[11,36,16,5,37,17],[11,36,12,5,37,13],[5,109,87,1,110,88],[5,65,41,5,66,42],[5,54,24,7,55,25],[11,36,12,7,37,13],[5,122,98,1,123,99],[7,73,45,3,74,46],[15,43,19,2,44,20],[3,45,15,13,46,16],[1,135,107,5,136,108],[10,74,46,1,75,47],[1,50,22,15,51,23],[2,42,14,17,43,15],[5,150,120,1,151,121],[9,69,43,4,70,44],[17,50,22,1,51,23],[2,42,14,19,43,15],[3,141,113,4,142,114],[3,70,44,11,71,45],[17,47,21,4,48,22],[9,39,13,16,40,14],[3,135,107,5,136,108],[3,67,41,13,68,42],[15,54,24,5,55,25],[15,43,15,10,44,16],[4,144,116,4,145,117],[17,68,42],[17,50,22,6,51,23],[19,46,16,6,47,17],[2,139,111,7,140,112],[17,74,46],[7,54,24,16,55,25],[34,37,13],[4,151,121,5,152,122],[4,75,47,14,76,48],[11,54,24,14,55,25],[16,45,15,14,46,16],[6,147,117,4,148,118],[6,73,45,14,74,46],[11,54,24,16,55,25],[30,46,16,2,47,17],[8,132,106,4,133,107],[8,75,47,13,76,48],[7,54,24,22,55,25],[22,45,15,13,46,16],[10,142,114,2,143,115],[19,74,46,4,75,47],[28,50,22,6,51,23],[33,46,16,4,47,17],[8,152,122,4,153,123],[22,73,45,3,74,46],[8,53,23,26,54,24],[12,45,15,28,46,16],[3,147,117,10,148,118],[3,73,45,23,74,46],[4,54,24,31,55,25],[11,45,15,31,46,16],[7,146,116,7,147,117],[21,73,45,7,74,46],[1,53,23,37,54,24],[19,45,15,26,46,16],[5,145,115,10,146,116],[19,75,47,10,76,48],[15,54,24,25,55,25],[23,45,15,25,46,16],[13,145,115,3,146,116],[2,74,46,29,75,47],[42,54,24,1,55,25],[23,45,15,28,46,16],[17,145,115],[10,74,46,23,75,47],[10,54,24,35,55,25],[19,45,15,35,46,16],[17,145,115,1,146,116],[14,74,46,21,75,47],[29,54,24,19,55,25],[11,45,15,46,46,16],[13,145,115,6,146,116],[14,74,46,23,75,47],[44,54,24,7,55,25],[59,46,16,1,47,17],[12,151,121,7,152,122],[12,75,47,26,76,48],[39,54,24,14,55,25],[22,45,15,41,46,16],[6,151,121,14,152,122],[6,75,47,34,76,48],[46,54,24,10,55,25],[2,45,15,64,46,16],[17,152,122,4,153,123],[29,74,46,14,75,47],[49,54,24,10,55,25],[24,45,15,46,46,16],[4,152,122,18,153,123],[13,74,46,32,75,47],[48,54,24,14,55,25],[42,45,15,32,46,16],[20,147,117,4,148,118],[40,75,47,7,76,48],[43,54,24,22,55,25],[10,45,15,67,46,16],[19,148,118,6,149,119],[18,75,47,31,76,48],[34,54,24,34,55,25],[20,45,15,61,46,16]];QRRSBlock.getRSBlocks=function(typeNumber,errorCorrectLevel){var rsBlock=QRRSBlock.getRsBlockTable(typeNumber,errorCorrectLevel);if(rsBlock==undefined){throw new Error("bad rs block @ typeNumber:"+typeNumber+"/errorCorrectLevel:"+errorCorrectLevel);}
	var length=rsBlock.length/3;var list=[];for(var i=0;i<length;i++){var count=rsBlock[i*3+0];var totalCount=rsBlock[i*3+1];var dataCount=rsBlock[i*3+2];for(var j=0;j<count;j++){list.push(new QRRSBlock(totalCount,dataCount));}}
	return list;};QRRSBlock.getRsBlockTable=function(typeNumber,errorCorrectLevel){switch(errorCorrectLevel){case QRErrorCorrectLevel.L:return QRRSBlock.RS_BLOCK_TABLE[(typeNumber-1)*4+0];case QRErrorCorrectLevel.M:return QRRSBlock.RS_BLOCK_TABLE[(typeNumber-1)*4+1];case QRErrorCorrectLevel.Q:return QRRSBlock.RS_BLOCK_TABLE[(typeNumber-1)*4+2];case QRErrorCorrectLevel.H:return QRRSBlock.RS_BLOCK_TABLE[(typeNumber-1)*4+3];default:return undefined;}};function QRBitBuffer(){this.buffer=[];this.length=0;}
	QRBitBuffer.prototype={get:function(index){var bufIndex=Math.floor(index/8);return((this.buffer[bufIndex]>>>(7-index%8))&1)==1;},put:function(num,length){for(var i=0;i<length;i++){this.putBit(((num>>>(length-i-1))&1)==1);}},getLengthInBits:function(){return this.length;},putBit:function(bit){var bufIndex=Math.floor(this.length/8);if(this.buffer.length<=bufIndex){this.buffer.push(0);}
	if(bit){this.buffer[bufIndex]|=(0x80>>>(this.length%8));}
	this.length++;}};var QRCodeLimitLength=[[17,14,11,7],[32,26,20,14],[53,42,32,24],[78,62,46,34],[106,84,60,44],[134,106,74,58],[154,122,86,64],[192,152,108,84],[230,180,130,98],[271,213,151,119],[321,251,177,137],[367,287,203,155],[425,331,241,177],[458,362,258,194],[520,412,292,220],[586,450,322,250],[644,504,364,280],[718,560,394,310],[792,624,442,338],[858,666,482,382],[929,711,509,403],[1003,779,565,439],[1091,857,611,461],[1171,911,661,511],[1273,997,715,535],[1367,1059,751,593],[1465,1125,805,625],[1528,1190,868,658],[1628,1264,908,698],[1732,1370,982,742],[1840,1452,1030,790],[1952,1538,1112,842],[2068,1628,1168,898],[2188,1722,1228,958],[2303,1809,1283,983],[2431,1911,1351,1051],[2563,1989,1423,1093],[2699,2099,1499,1139],[2809,2213,1579,1219],[2953,2331,1663,1273]];
	
	function _isSupportCanvas() {
		return typeof CanvasRenderingContext2D != "undefined";
	}
	
	// android 2.x doesn't support Data-URI spec
	function _getAndroid() {
		var android = false;
		var sAgent = navigator.userAgent;
		
		if (/android/i.test(sAgent)) { // android
			android = true;
			var aMat = sAgent.toString().match(/android ([0-9]\.[0-9])/i);
			
			if (aMat && aMat[1]) {
				android = parseFloat(aMat[1]);
			}
		}
		
		return android;
	}
	
	var svgDrawer = (function() {

		var Drawing = function (el, htOption) {
			this._el = el;
			this._htOption = htOption;
		};

		Drawing.prototype.draw = function (oQRCode) {
			var _htOption = this._htOption;
			var _el = this._el;
			var nCount = oQRCode.getModuleCount();
			var nWidth = Math.floor(_htOption.width / nCount);
			var nHeight = Math.floor(_htOption.height / nCount);

			this.clear();

			function makeSVG(tag, attrs) {
				var el = document.createElementNS('http://www.w3.org/2000/svg', tag);
				for (var k in attrs)
					if (attrs.hasOwnProperty(k)) el.setAttribute(k, attrs[k]);
				return el;
			}

			var svg = makeSVG("svg" , {'viewBox': '0 0 ' + String(nCount) + " " + String(nCount), 'width': '100%', 'height': '100%', 'fill': _htOption.colorLight});
			svg.setAttributeNS("http://www.w3.org/2000/xmlns/", "xmlns:xlink", "http://www.w3.org/1999/xlink");
			_el.appendChild(svg);

			svg.appendChild(makeSVG("rect", {"fill": _htOption.colorLight, "width": "100%", "height": "100%"}));
			svg.appendChild(makeSVG("rect", {"fill": _htOption.colorDark, "width": "1", "height": "1", "id": "template"}));

			for (var row = 0; row < nCount; row++) {
				for (var col = 0; col < nCount; col++) {
					if (oQRCode.isDark(row, col)) {
						var child = makeSVG("use", {"x": String(col), "y": String(row)});
						child.setAttributeNS("http://www.w3.org/1999/xlink", "href", "#template")
						svg.appendChild(child);
					}
				}
			}
		};
		Drawing.prototype.clear = function () {
			while (this._el.hasChildNodes())
				this._el.removeChild(this._el.lastChild);
		};
		return Drawing;
	})();

	var useSVG = document.documentElement.tagName.toLowerCase() === "svg";

	// Drawing in DOM by using Table tag
	var Drawing = useSVG ? svgDrawer : !_isSupportCanvas() ? (function () {
		var Drawing = function (el, htOption) {
			this._el = el;
			this._htOption = htOption;
		};
			
		/**
		 * Draw the QRCode
		 * 
		 * @param {QRCode} oQRCode
		 */
		Drawing.prototype.draw = function (oQRCode) {
            var _htOption = this._htOption;
            var _el = this._el;
			var nCount = oQRCode.getModuleCount();
			var nWidth = Math.floor(_htOption.width / nCount);
			var nHeight = Math.floor(_htOption.height / nCount);
			var aHTML = ['<table style="border:0;border-collapse:collapse;">'];
			
			for (var row = 0; row < nCount; row++) {
				aHTML.push('<tr>');
				
				for (var col = 0; col < nCount; col++) {
					aHTML.push('<td style="border:0;border-collapse:collapse;padding:0;margin:0;width:' + nWidth + 'px;height:' + nHeight + 'px;background-color:' + (oQRCode.isDark(row, col) ? _htOption.colorDark : _htOption.colorLight) + ';"></td>');
				}
				
				aHTML.push('</tr>');
			}
			
			aHTML.push('</table>');
			_el.innerHTML = aHTML.join('');
			
			// Fix the margin values as real size.
			var elTable = _el.childNodes[0];
			var nLeftMarginTable = (_htOption.width - elTable.offsetWidth) / 2;
			var nTopMarginTable = (_htOption.height - elTable.offsetHeight) / 2;
			
			if (nLeftMarginTable > 0 && nTopMarginTable > 0) {
				elTable.style.margin = nTopMarginTable + "px " + nLeftMarginTable + "px";	
			}
		};
		
		/**
		 * Clear the QRCode
		 */
		Drawing.prototype.clear = function () {
			this._el.innerHTML = '';
		};
		
		return Drawing;
	})() : (function () { // Drawing in Canvas
		function _onMakeImage() {
			this._elImage.src = this._elCanvas.toDataURL("image/png");
			this._elImage.style.display = "block";
			this._elCanvas.style.display = "none";			
		}
		
		// Android 2.1 bug workaround
		// http://code.google.com/p/android/issues/detail?id=5141
		if (this._android && this._android <= 2.1) {
	    	var factor = 1 / window.devicePixelRatio;
	        var drawImage = CanvasRenderingContext2D.prototype.drawImage; 
	    	CanvasRenderingContext2D.prototype.drawImage = function (image, sx, sy, sw, sh, dx, dy, dw, dh) {
	    		if (("nodeName" in image) && /img/i.test(image.nodeName)) {
		        	for (var i = arguments.length - 1; i >= 1; i--) {
		            	arguments[i] = arguments[i] * factor;
		        	}
	    		} else if (typeof dw == "undefined") {
	    			arguments[1] *= factor;
	    			arguments[2] *= factor;
	    			arguments[3] *= factor;
	    			arguments[4] *= factor;
	    		}
	    		
	        	drawImage.apply(this, arguments); 
	    	};
		}
		
		/**
		 * Check whether the user's browser supports Data URI or not
		 * 
		 * @private
		 * @param {Function} fSuccess Occurs if it supports Data URI
		 * @param {Function} fFail Occurs if it doesn't support Data URI
		 */
		function _safeSetDataURI(fSuccess, fFail) {
            var self = this;
            self._fFail = fFail;
            self._fSuccess = fSuccess;

            // Check it just once
            if (self._bSupportDataURI === null) {
                var el = document.createElement("img");
                var fOnError = function() {
                    self._bSupportDataURI = false;

                    if (self._fFail) {
                        self._fFail.call(self);
                    }
                };
                var fOnSuccess = function() {
                    self._bSupportDataURI = true;

                    if (self._fSuccess) {
                        self._fSuccess.call(self);
                    }
                };

                el.onabort = fOnError;
                el.onerror = fOnError;
                el.onload = fOnSuccess;
                el.src = "data:image/gif;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAFCAYAAACNbyblAAAAHElEQVQI12P4//8/w38GIAXDIBKE0DHxgljNBAAO9TXL0Y4OHwAAAABJRU5ErkJggg=="; // the Image contains 1px data.
                return;
            } else if (self._bSupportDataURI === true && self._fSuccess) {
                self._fSuccess.call(self);
            } else if (self._bSupportDataURI === false && self._fFail) {
                self._fFail.call(self);
            }
		};
		
		/**
		 * Drawing QRCode by using canvas
		 * 
		 * @constructor
		 * @param {HTMLElement} el
		 * @param {Object} htOption QRCode Options 
		 */
		var Drawing = function (el, htOption) {
    		this._bIsPainted = false;
    		this._android = _getAndroid();
		
			this._htOption = htOption;
			this._elCanvas = document.createElement("canvas");
			this._elCanvas.width = htOption.width;
			this._elCanvas.height = htOption.height;
			el.appendChild(this._elCanvas);
			this._el = el;
			this._oContext = this._elCanvas.getContext("2d");
			this._bIsPainted = false;
			this._elImage = document.createElement("img");
			this._elImage.alt = "Scan me!";
			this._elImage.style.display = "none";
			this._el.appendChild(this._elImage);
			this._bSupportDataURI = null;
		};
			
		/**
		 * Draw the QRCode
		 * 
		 * @param {QRCode} oQRCode 
		 */
		Drawing.prototype.draw = function (oQRCode) {
            var _elImage = this._elImage;
            var _oContext = this._oContext;
            var _htOption = this._htOption;
            
			var nCount = oQRCode.getModuleCount();
			var nWidth = _htOption.width / nCount;
			var nHeight = _htOption.height / nCount;
			var nRoundedWidth = Math.round(nWidth);
			var nRoundedHeight = Math.round(nHeight);

			_elImage.style.display = "none";
			this.clear();
			
			for (var row = 0; row < nCount; row++) {
				for (var col = 0; col < nCount; col++) {
					var bIsDark = oQRCode.isDark(row, col);
					var nLeft = col * nWidth;
					var nTop = row * nHeight;
					_oContext.strokeStyle = bIsDark ? _htOption.colorDark : _htOption.colorLight;
					_oContext.lineWidth = 1;
					_oContext.fillStyle = bIsDark ? _htOption.colorDark : _htOption.colorLight;					
					_oContext.fillRect(nLeft, nTop, nWidth, nHeight);
					
					// 안티 앨리어싱 방지 처리
					_oContext.strokeRect(
						Math.floor(nLeft) + 0.5,
						Math.floor(nTop) + 0.5,
						nRoundedWidth,
						nRoundedHeight
					);
					
					_oContext.strokeRect(
						Math.ceil(nLeft) - 0.5,
						Math.ceil(nTop) - 0.5,
						nRoundedWidth,
						nRoundedHeight
					);
				}
			}
			
			this._bIsPainted = true;
		};
			
		/**
		 * Make the image from Canvas if the browser supports Data URI.
		 */
		Drawing.prototype.makeImage = function () {
			if (this._bIsPainted) {
				_safeSetDataURI.call(this, _onMakeImage);
			}
		};
			
		/**
		 * Return whether the QRCode is painted or not
		 * 
		 * @return {Boolean}
		 */
		Drawing.prototype.isPainted = function () {
			return this._bIsPainted;
		};
		
		/**
		 * Clear the QRCode
		 */
		Drawing.prototype.clear = function () {
			this._oContext.clearRect(0, 0, this._elCanvas.width, this._elCanvas.height);
			this._bIsPainted = false;
		};
		
		/**
		 * @private
		 * @param {Number} nNumber
		 */
		Drawing.prototype.round = function (nNumber) {
			if (!nNumber) {
				return nNumber;
			}
			
			return Math.floor(nNumber * 1000) / 1000;
		};
		
		return Drawing;
	})();
	
	/**
	 * Get the type by string length
	 * 
	 * @private
	 * @param {String} sText
	 * @param {Number} nCorrectLevel
	 * @return {Number} type
	 */
	function _getTypeNumber(sText, nCorrectLevel) {			
		var nType = 1;
		var length = _getUTF8Length(sText);
		
		for (var i = 0, len = QRCodeLimitLength.length; i <= len; i++) {
			var nLimit = 0;
			
			switch (nCorrectLevel) {
				case QRErrorCorrectLevel.L :
					nLimit = QRCodeLimitLength[i][0];
					break;
				case QRErrorCorrectLevel.M :
					nLimit = QRCodeLimitLength[i][1];
					break;
				case QRErrorCorrectLevel.Q :
					nLimit = QRCodeLimitLength[i][2];
					break;
				case QRErrorCorrectLevel.H :
					nLimit = QRCodeLimitLength[i][3];
					break;
			}
			
			if (length <= nLimit) {
				break;
			} else {
				nType++;
			}
		}
		
		if (nType > QRCodeLimitLength.length) {
			throw new Error("Too long data");
		}
		
		return nType;
	}

	function _getUTF8Length(sText) {
		var replacedText = encodeURI(sText).toString().replace(/\%[0-9a-fA-F]{2}/g, 'a');
		return replacedText.length + (replacedText.length != sText ? 3 : 0);
	}
	
	/**
	 * @class QRCode
	 * @constructor
	 * @example 
	 * new QRCode(document.getElementById("test"), "http://jindo.dev.naver.com/collie");
	 *
	 * @example
	 * var oQRCode = new QRCode("test", {
	 *    text : "http://naver.com",
	 *    width : 128,
	 *    height : 128
	 * });
	 * 
	 * oQRCode.clear(); // Clear the QRCode.
	 * oQRCode.makeCode("http://map.naver.com"); // Re-create the QRCode.
	 *
	 * @param {HTMLElement|String} el target element or 'id' attribute of element.
	 * @param {Object|String} vOption
	 * @param {String} vOption.text QRCode link data
	 * @param {Number} [vOption.width=256]
	 * @param {Number} [vOption.height=256]
	 * @param {String} [vOption.colorDark="#000000"]
	 * @param {String} [vOption.colorLight="#ffffff"]
	 * @param {QRCode.CorrectLevel} [vOption.correctLevel=QRCode.CorrectLevel.H] [L|M|Q|H] 
	 */
	QRCode = function (el, vOption) {
		this._htOption = {
			width : 256, 
			height : 256,
			typeNumber : 4,
			colorDark : "#000000",
			colorLight : "#ffffff",
			correctLevel : QRErrorCorrectLevel.H
		};
		
		if (typeof vOption === 'string') {
			vOption	= {
				text : vOption
			};
		}
		
		// Overwrites options
		if (vOption) {
			for (var i in vOption) {
				this._htOption[i] = vOption[i];
			}
		}
		
		if (typeof el == "string") {
			el = document.getElementById(el);
		}

		if (this._htOption.useSVG) {
			Drawing = svgDrawer;
		}
		
		this._android = _getAndroid();
		this._el = el;
		this._oQRCode = null;
		this._oDrawing = new Drawing(this._el, this._htOption);
		
		if (this._htOption.text) {
			this.makeCode(this._htOption.text);	
		}
	};
	
	/**
	 * Make the QRCode
	 * 
	 * @param {String} sText link data
	 */
	QRCode.prototype.makeCode = function (sText) {
		this._oQRCode = new QRCodeModel(_getTypeNumber(sText, this._htOption.correctLevel), this._htOption.correctLevel);
		this._oQRCode.addData(sText);
		this._oQRCode.make();
		this._el.title = sText;
		this._oDrawing.draw(this._oQRCode);			
		this.makeImage();
	};
	
	/**
	 * Make the Image from Canvas element
	 * - It occurs automatically
	 * - Android below 3 doesn't support Data-URI spec.
	 * 
	 * @private
	 */
	QRCode.prototype.makeImage = function () {
		if (typeof this._oDrawing.makeImage == "function" && (!this._android || this._android >= 3)) {
			this._oDrawing.makeImage();
		}
	};
	
	/**
	 * Clear the QRCode
	 */
	QRCode.prototype.clear = function () {
		this._oDrawing.clear();
	};
	
	/**
	 * @name QRCode.CorrectLevel
	 */
	QRCode.CorrectLevel = QRErrorCorrectLevel;
})();

if (true) {
	module.exports = QRCode;
}


/***/ }),
/* 204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lib_vendor_terrific_Module__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lib_generic_SDXModalDialog__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_dot__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_dot___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_dot__);




var TAG_IMG = 'img';
var DIALOG_CLASS = 'enlarge-image-dialog';
var DIALOG_PADDING = 32;
/**
 * Big image view implemntation.
 *
 * @author Nikola Tica
 * @class Button
 * @extends Tc.Module
 */
var EnlargeImageView = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */])(EnlargeImageView, _super);
    function EnlargeImageView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Hook function to do all of your module stuff.
     *
     * @method on
     * @param  {Hook} callback Callback function
     * @return void
     */
    EnlargeImageView.prototype.on = function (callback) {
        var mod = this;
        this.title = this.$ctx.data('lightbox-title');
        this.description = this.$ctx.data('lightbox-description');
        this.dialogWidth = this.$ctx.data('lightbox-width');
        this.dialogHeight = this.$ctx.data('lightbox-height');
        this.template = __WEBPACK_IMPORTED_MODULE_3_dot__["compile"](this.$ctx.find('script.tmpl-big-image-preview').html());
        this.imgWidth = this.$ctx.data('img-width');
        var $img = this.$ctx.find(TAG_IMG);
        this.imgSrc = $img.data('lazy-src') || $img.attr('src') || '';
        var data = {
            description: this.description,
            src: this.imgSrc,
        };
        this.$modalContent = $(this.template(data));
        this.$ctx.find('.preview-link').on('click', function () {
            __WEBPACK_IMPORTED_MODULE_2_lib_generic_SDXModalDialog__["default"].show({
                class: DIALOG_CLASS,
                height: mod.dialogHeight,
                html: mod.$modalContent,
                title: mod.title,
                width: mod.dialogWidth || (mod.imgWidth + (DIALOG_PADDING * 2)),
            });
        });
        callback();
    };
    return EnlargeImageView;
}(__WEBPACK_IMPORTED_MODULE_1_lib_vendor_terrific_Module__["a" /* Module */]));
/* harmony default export */ __webpack_exports__["a"] = (EnlargeImageView);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),
/* 205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lib_vendor_terrific_Module__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lib_vendor_jquery_deparam_patched__ = __webpack_require__(8);



var KEY_FORM = 'FORM_DATA_RESTORE';
var TYPE_RESTORE = 'restore';
var TYPE_STORE = 'store';
var TYPE_STORE_RESTORE = 'storeRestore';
/**
 * Form Data Restore Module
 */
var FormDataRestore = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */])(FormDataRestore, _super);
    function FormDataRestore($ctx, sandbox, id, modName) {
        var _this = _super.call(this, $ctx, sandbox, id, modName) || this;
        _this.storeType = $ctx.data('store-type') || '';
        var formData = $ctx.data('form-data-includes') || '';
        _this.dataIncludes = formData.split(',');
        return _this;
    }
    /**
     * Hook function to do all of your module stuff.
     *
     * @method on
     * @param  {Hook} callback Callback function
     * @return void
     */
    FormDataRestore.prototype.on = function (callback) {
        var _this = this;
        var form = this.$ctx.find('form');
        if (form.length === 0) {
            callback();
            return;
        }
        var formElement = form.get(0);
        var elements = formElement.elements;
        if (this.storeType === TYPE_RESTORE || this.storeType === TYPE_STORE_RESTORE) {
            var formData = sessionStorage.getItem(KEY_FORM);
            if (formData) {
                var data = Object(__WEBPACK_IMPORTED_MODULE_2_lib_vendor_jquery_deparam_patched__["default"])(formData);
                for (var key in data) {
                    if (this.dataIncludes.includes(key)) {
                        var element = elements[key];
                        if (element) {
                            element.value = data[key];
                        }
                    }
                }
            }
        }
        if (this.storeType === TYPE_STORE || this.storeType === TYPE_STORE_RESTORE) {
            form.on('submit', function () {
                var filteredData = {};
                _this.dataIncludes.map(function (key) { return filteredData[key] = elements[key].value; });
                if (_this.storeType === TYPE_STORE_RESTORE) {
                    var formData = sessionStorage.getItem(KEY_FORM);
                    if (formData) {
                        var data = Object(__WEBPACK_IMPORTED_MODULE_2_lib_vendor_jquery_deparam_patched__["default"])(formData);
                        for (var key in data) {
                            if (!filteredData[key]) {
                                filteredData[key] = data[key];
                            }
                        }
                    }
                }
                sessionStorage.setItem(KEY_FORM, $.param(filteredData));
            });
        }
        callback();
    };
    return FormDataRestore;
}(__WEBPACK_IMPORTED_MODULE_1_lib_vendor_terrific_Module__["a" /* Module */]));
/* harmony default export */ __webpack_exports__["a"] = (FormDataRestore);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),
/* 206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(SnabbdomPragma) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ResultCard; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bootstrap_load_snabbdom__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_snabbdom_tovnode__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_snabbdom_tovnode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_snabbdom_tovnode__);


function CardItem(_a) {
    var title = _a.title, category = _a.category, date = _a.date, dateAndTime = _a.dateAndTime, image = _a.image, imageUrl = _a.imageUrl, url = _a.url, lead = _a.lead, heading = _a.heading, moreLabel = _a.moreLabel, cardsLayout = _a.cardsLayout;
    if (cardsLayout) {
        return SnabbdomPragma.createElement("div", { className: 'col-xs-12 col-md-4 margin-bottom-2' },
            SnabbdomPragma.createElement("a", { href: url, role: "none", className: 'card card--image-top card--clickable card--border padding-bottom-2 ' + ((image && image.url) || imageUrl ? 'card--no-color' : 'card--dark') },
                (image && image.url) || imageUrl ? SnabbdomPragma.createElement("div", { className: "card__image", style: { backgroundImage: "url(" + (imageUrl || image.url) + ")" } }) : '',
                SnabbdomPragma.createElement("div", { className: "card__body" },
                    SnabbdomPragma.createElement("div", { className: "card__header" },
                        SnabbdomPragma.createElement("div", { className: "row" },
                            SnabbdomPragma.createElement("div", { className: "col-xs-6 sc-navy" }, category && (SnabbdomPragma.createElement("span", { className: "small-text" }, category))),
                            SnabbdomPragma.createElement("div", { className: "col-xs-6 text-align-right sc-gray" }, date && (SnabbdomPragma.createElement("span", { className: "small-text" }, date)))),
                        title && (SnabbdomPragma.createElement("h4", { className: "sc-navy font--semi-bold" }, title)))),
                SnabbdomPragma.createElement("div", { className: "card__footer padding-2" },
                    SnabbdomPragma.createElement("span", { className: "int-blue" }, moreLabel))));
    }
    return SnabbdomPragma.createElement("div", { className: 'news-item clearfix ' + ((image && image.url) || imageUrl ? 'news-with-image' : '') },
        SnabbdomPragma.createElement("h4", null, heading),
        SnabbdomPragma.createElement("a", { href: url, className: "clearfix", role: "none" },
            image && image.url ? SnabbdomPragma.createElement("img", { src: image.url, alt: image.altText, width: image.width, height: image.height }) : '',
            imageUrl && SnabbdomPragma.createElement("img", { src: imageUrl, alt: "teaser image", width: "360", height: "184" }),
            SnabbdomPragma.createElement("div", { className: "news-text margin-top-0" },
                SnabbdomPragma.createElement("div", { className: "metadata" },
                    SnabbdomPragma.createElement("span", { className: "tags text-sm font font--semi-bold" }, category),
                    SnabbdomPragma.createElement("span", { className: "date text-sm sc-gray-light" }, dateAndTime)),
                title && (SnabbdomPragma.createElement("h4", { className: "sc-navy font--semi-bold margin-bottom-0" }, title)),
                lead && (SnabbdomPragma.createElement("p", { className: "news-text-lead text-b1" }, lead)))));
}
var ResultCard = /** @class */ (function () {
    function ResultCard(element, more) {
        this.container = __WEBPACK_IMPORTED_MODULE_1_snabbdom_tovnode___default()(element);
        this.more = more;
    }
    ResultCard.prototype.renderItems = function (items, cardsLayout) {
        var _this = this;
        this.container = Object(__WEBPACK_IMPORTED_MODULE_0_bootstrap_load_snabbdom__["b" /* patch */])(this.container, SnabbdomPragma.createElement("div", { className: "news-results row" }, items.map(function (c) { return SnabbdomPragma.createElement(CardItem, { title: c.title, category: c.categories.join(', '), date: c.date, dateAndTime: c.dateAndTime || '', image: c.imageMobile, imageUrl: c.imageUrl || '', url: c.url, lead: c.lead, heading: c.heading || '', moreLabel: _this.more, cardsLayout: cardsLayout }); })));
    };
    ResultCard.prototype.clear = function () {
        this.container = Object(__WEBPACK_IMPORTED_MODULE_0_bootstrap_load_snabbdom__["b" /* patch */])(this.container, SnabbdomPragma.createElement("div", { className: "news-results" }));
    };
    return ResultCard;
}());


/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(10)))

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var hasOwn = Object.prototype.hasOwnProperty;
var toStr = Object.prototype.toString;
var defineProperty = Object.defineProperty;
var gOPD = Object.getOwnPropertyDescriptor;

var isArray = function isArray(arr) {
	if (typeof Array.isArray === 'function') {
		return Array.isArray(arr);
	}

	return toStr.call(arr) === '[object Array]';
};

var isPlainObject = function isPlainObject(obj) {
	if (!obj || toStr.call(obj) !== '[object Object]') {
		return false;
	}

	var hasOwnConstructor = hasOwn.call(obj, 'constructor');
	var hasIsPrototypeOf = obj.constructor && obj.constructor.prototype && hasOwn.call(obj.constructor.prototype, 'isPrototypeOf');
	// Not own constructor property must be Object
	if (obj.constructor && !hasOwnConstructor && !hasIsPrototypeOf) {
		return false;
	}

	// Own properties are enumerated firstly, so to speed up,
	// if last one is own, then all properties are own.
	var key;
	for (key in obj) { /**/ }

	return typeof key === 'undefined' || hasOwn.call(obj, key);
};

// If name is '__proto__', and Object.defineProperty is available, define __proto__ as an own property on target
var setProperty = function setProperty(target, options) {
	if (defineProperty && options.name === '__proto__') {
		defineProperty(target, options.name, {
			enumerable: true,
			configurable: true,
			value: options.newValue,
			writable: true
		});
	} else {
		target[options.name] = options.newValue;
	}
};

// Return undefined instead of __proto__ if '__proto__' is not an own property
var getProperty = function getProperty(obj, name) {
	if (name === '__proto__') {
		if (!hasOwn.call(obj, name)) {
			return void 0;
		} else if (gOPD) {
			// In early versions of node, obj['__proto__'] is buggy when obj has
			// __proto__ as an own property. Object.getOwnPropertyDescriptor() works.
			return gOPD(obj, name).value;
		}
	}

	return obj[name];
};

module.exports = function extend() {
	var options, name, src, copy, copyIsArray, clone;
	var target = arguments[0];
	var i = 1;
	var length = arguments.length;
	var deep = false;

	// Handle a deep copy situation
	if (typeof target === 'boolean') {
		deep = target;
		target = arguments[1] || {};
		// skip the boolean and the target
		i = 2;
	}
	if (target == null || (typeof target !== 'object' && typeof target !== 'function')) {
		target = {};
	}

	for (; i < length; ++i) {
		options = arguments[i];
		// Only deal with non-null/undefined values
		if (options != null) {
			// Extend the base object
			for (name in options) {
				src = getProperty(target, name);
				copy = getProperty(options, name);

				// Prevent never-ending loop
				if (target !== copy) {
					// Recurse if we're merging plain objects or arrays
					if (deep && copy && (isPlainObject(copy) || (copyIsArray = isArray(copy)))) {
						if (copyIsArray) {
							copyIsArray = false;
							clone = src && isArray(src) ? src : [];
						} else {
							clone = src && isPlainObject(src) ? src : {};
						}

						// Never move original objects, clone them
						setProperty(target, { name: name, newValue: extend(deep, clone, copy) });

					// Don't bring in undefined values
					} else if (typeof copy !== 'undefined') {
						setProperty(target, { name: name, newValue: copy });
					}
				}
			}
		}
	}

	// Return the modified object
	return target;
};


/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var xlinkNS = 'http://www.w3.org/1999/xlink';
var xmlNS = 'http://www.w3.org/XML/1998/namespace';
var colonChar = 58;
var xChar = 120;
function updateAttrs(oldVnode, vnode) {
    var key, elm = vnode.elm, oldAttrs = oldVnode.data.attrs, attrs = vnode.data.attrs;
    if (!oldAttrs && !attrs)
        return;
    if (oldAttrs === attrs)
        return;
    oldAttrs = oldAttrs || {};
    attrs = attrs || {};
    // update modified attributes, add new attributes
    for (key in attrs) {
        var cur = attrs[key];
        var old = oldAttrs[key];
        if (old !== cur) {
            if (cur === true) {
                elm.setAttribute(key, "");
            }
            else if (cur === false) {
                elm.removeAttribute(key);
            }
            else {
                if (key.charCodeAt(0) !== xChar) {
                    elm.setAttribute(key, cur);
                }
                else if (key.charCodeAt(3) === colonChar) {
                    // Assume xml namespace
                    elm.setAttributeNS(xmlNS, key, cur);
                }
                else if (key.charCodeAt(5) === colonChar) {
                    // Assume xlink namespace
                    elm.setAttributeNS(xlinkNS, key, cur);
                }
                else {
                    elm.setAttribute(key, cur);
                }
            }
        }
    }
    // remove removed attributes
    // use `in` operator since the previous `for` iteration uses it (.i.e. add even attributes with undefined value)
    // the other option is to remove all attributes with value == undefined
    for (key in oldAttrs) {
        if (!(key in attrs)) {
            elm.removeAttribute(key);
        }
    }
}
exports.attributesModule = { create: updateAttrs, update: updateAttrs };
exports.default = exports.attributesModule;
//# sourceMappingURL=attributes.js.map

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function updateProps(oldVnode, vnode) {
    var key, cur, old, elm = vnode.elm, oldProps = oldVnode.data.props, props = vnode.data.props;
    if (!oldProps && !props)
        return;
    if (oldProps === props)
        return;
    oldProps = oldProps || {};
    props = props || {};
    for (key in oldProps) {
        if (!props[key]) {
            delete elm[key];
        }
    }
    for (key in props) {
        cur = props[key];
        old = oldProps[key];
        if (old !== cur && (key !== 'value' || elm[key] !== cur)) {
            elm[key] = cur;
        }
    }
}
exports.propsModule = { create: updateProps, update: updateProps };
exports.default = exports.propsModule;
//# sourceMappingURL=props.js.map

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
// Bindig `requestAnimationFrame` like this fixes a bug in IE/Edge. See #360 and #409.
var raf = (typeof window !== 'undefined' && (window.requestAnimationFrame).bind(window)) || setTimeout;
var nextFrame = function (fn) { raf(function () { raf(fn); }); };
var reflowForced = false;
function setNextFrame(obj, prop, val) {
    nextFrame(function () { obj[prop] = val; });
}
function updateStyle(oldVnode, vnode) {
    var cur, name, elm = vnode.elm, oldStyle = oldVnode.data.style, style = vnode.data.style;
    if (!oldStyle && !style)
        return;
    if (oldStyle === style)
        return;
    oldStyle = oldStyle || {};
    style = style || {};
    var oldHasDel = 'delayed' in oldStyle;
    for (name in oldStyle) {
        if (!style[name]) {
            if (name[0] === '-' && name[1] === '-') {
                elm.style.removeProperty(name);
            }
            else {
                elm.style[name] = '';
            }
        }
    }
    for (name in style) {
        cur = style[name];
        if (name === 'delayed' && style.delayed) {
            for (var name2 in style.delayed) {
                cur = style.delayed[name2];
                if (!oldHasDel || cur !== oldStyle.delayed[name2]) {
                    setNextFrame(elm.style, name2, cur);
                }
            }
        }
        else if (name !== 'remove' && cur !== oldStyle[name]) {
            if (name[0] === '-' && name[1] === '-') {
                elm.style.setProperty(name, cur);
            }
            else {
                elm.style[name] = cur;
            }
        }
    }
}
function applyDestroyStyle(vnode) {
    var style, name, elm = vnode.elm, s = vnode.data.style;
    if (!s || !(style = s.destroy))
        return;
    for (name in style) {
        elm.style[name] = style[name];
    }
}
function applyRemoveStyle(vnode, rm) {
    var s = vnode.data.style;
    if (!s || !s.remove) {
        rm();
        return;
    }
    if (!reflowForced) {
        getComputedStyle(document.body).transform;
        reflowForced = true;
    }
    var name, elm = vnode.elm, i = 0, compStyle, style = s.remove, amount = 0, applied = [];
    for (name in style) {
        applied.push(name);
        elm.style[name] = style[name];
    }
    compStyle = getComputedStyle(elm);
    var props = compStyle['transition-property'].split(', ');
    for (; i < props.length; ++i) {
        if (applied.indexOf(props[i]) !== -1)
            amount++;
    }
    elm.addEventListener('transitionend', function (ev) {
        if (ev.target === elm)
            --amount;
        if (amount === 0)
            rm();
    });
}
function forceReflow() {
    reflowForced = false;
}
exports.styleModule = {
    pre: forceReflow,
    create: updateStyle,
    update: updateStyle,
    destroy: applyDestroyStyle,
    remove: applyRemoveStyle
};
exports.default = exports.styleModule;
//# sourceMappingURL=style.js.map

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function invokeHandler(handler, vnode, event) {
    if (typeof handler === "function") {
        // call function handler
        handler.call(vnode, event, vnode);
    }
    else if (typeof handler === "object") {
        // call handler with arguments
        if (typeof handler[0] === "function") {
            // special case for single argument for performance
            if (handler.length === 2) {
                handler[0].call(vnode, handler[1], event, vnode);
            }
            else {
                var args = handler.slice(1);
                args.push(event);
                args.push(vnode);
                handler[0].apply(vnode, args);
            }
        }
        else {
            // call multiple handlers
            for (var i = 0; i < handler.length; i++) {
                invokeHandler(handler[i], vnode, event);
            }
        }
    }
}
function handleEvent(event, vnode) {
    var name = event.type, on = vnode.data.on;
    // call event handler(s) if exists
    if (on && on[name]) {
        invokeHandler(on[name], vnode, event);
    }
}
function createListener() {
    return function handler(event) {
        handleEvent(event, handler.vnode);
    };
}
function updateEventListeners(oldVnode, vnode) {
    var oldOn = oldVnode.data.on, oldListener = oldVnode.listener, oldElm = oldVnode.elm, on = vnode && vnode.data.on, elm = (vnode && vnode.elm), name;
    // optimization for reused immutable handlers
    if (oldOn === on) {
        return;
    }
    // remove existing listeners which no longer used
    if (oldOn && oldListener) {
        // if element changed or deleted we remove all existing listeners unconditionally
        if (!on) {
            for (name in oldOn) {
                // remove listener if element was changed or existing listeners removed
                oldElm.removeEventListener(name, oldListener, false);
            }
        }
        else {
            for (name in oldOn) {
                // remove listener if existing listener removed
                if (!on[name]) {
                    oldElm.removeEventListener(name, oldListener, false);
                }
            }
        }
    }
    // add new listeners which has not already attached
    if (on) {
        // reuse existing listener or create new
        var listener = vnode.listener = oldVnode.listener || createListener();
        // update vnode for listener
        listener.vnode = vnode;
        // if element changed or added we add all needed listeners unconditionally
        if (!oldOn) {
            for (name in on) {
                // add listener if element was changed or new listeners added
                elm.addEventListener(name, listener, false);
            }
        }
        else {
            for (name in on) {
                // add listener if new listener added
                if (!oldOn[name]) {
                    elm.addEventListener(name, listener, false);
                }
            }
        }
    }
}
exports.eventListenersModule = {
    create: updateEventListeners,
    update: updateEventListeners,
    destroy: updateEventListeners
};
exports.default = exports.eventListenersModule;
//# sourceMappingURL=eventlisteners.js.map

/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function updateClass(oldVnode, vnode) {
    var cur, name, elm = vnode.elm, oldClass = oldVnode.data.class, klass = vnode.data.class;
    if (!oldClass && !klass)
        return;
    if (oldClass === klass)
        return;
    oldClass = oldClass || {};
    klass = klass || {};
    for (name in oldClass) {
        if (!klass[name]) {
            elm.classList.remove(name);
        }
    }
    for (name in klass) {
        cur = klass[name];
        if (cur !== oldClass[name]) {
            elm.classList[cur ? 'add' : 'remove'](name);
        }
    }
}
exports.classModule = { create: updateClass, update: updateClass };
exports.default = exports.classModule;
//# sourceMappingURL=class.js.map

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function vnode(sel, data, children, text, elm) {
    var key = data === undefined ? undefined : data.key;
    return { sel: sel, data: data, children: children,
        text: text, elm: elm, key: key };
}
exports.vnode = vnode;
exports.default = vnode;
//# sourceMappingURL=vnode.js.map

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function createElement(tagName) {
    return document.createElement(tagName);
}
function createElementNS(namespaceURI, qualifiedName) {
    return document.createElementNS(namespaceURI, qualifiedName);
}
function createTextNode(text) {
    return document.createTextNode(text);
}
function createComment(text) {
    return document.createComment(text);
}
function insertBefore(parentNode, newNode, referenceNode) {
    parentNode.insertBefore(newNode, referenceNode);
}
function removeChild(node, child) {
    node.removeChild(child);
}
function appendChild(node, child) {
    node.appendChild(child);
}
function parentNode(node) {
    return node.parentNode;
}
function nextSibling(node) {
    return node.nextSibling;
}
function tagName(elm) {
    return elm.tagName;
}
function setTextContent(node, text) {
    node.textContent = text;
}
function getTextContent(node) {
    return node.textContent;
}
function isElement(node) {
    return node.nodeType === 1;
}
function isText(node) {
    return node.nodeType === 3;
}
function isComment(node) {
    return node.nodeType === 8;
}
exports.htmlDomApi = {
    createElement: createElement,
    createElementNS: createElementNS,
    createTextNode: createTextNode,
    createComment: createComment,
    insertBefore: insertBefore,
    removeChild: removeChild,
    appendChild: appendChild,
    parentNode: parentNode,
    nextSibling: nextSibling,
    tagName: tagName,
    setTextContent: setTextContent,
    getTextContent: getTextContent,
    isElement: isElement,
    isText: isText,
    isComment: isComment,
};
exports.default = exports.htmlDomApi;
//# sourceMappingURL=htmldomapi.js.map

/***/ }),
/* 215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(SnabbdomPragma) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FilterTag; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bootstrap_load_snabbdom__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_snabbdom_tovnode__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_snabbdom_tovnode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_snabbdom_tovnode__);


function FilterTagItem(_a) {
    var name = _a.name, tag = _a.tag, fixed = _a.fixed, onClick = _a.onClick;
    if (fixed) {
        return SnabbdomPragma.createElement("div", { key: "" + tag, className: 'breadcrumb checkbox-filter-breadcrumb filter-breadcrumb breadcrumb-fixed' },
            SnabbdomPragma.createElement("span", { className: "text" }, name));
    }
    return SnabbdomPragma.createElement("div", { key: "" + tag, "on-click": onClick, className: 'breadcrumb checkbox-filter-breadcrumb filter-breadcrumb' },
        SnabbdomPragma.createElement("span", { className: "text" }, name),
        SnabbdomPragma.createElement("i", { className: "icon icon-202-clear-circle" }));
}
var FilterTag = /** @class */ (function () {
    function FilterTag(element, sectionsData, topicsData, periodData) {
        this.container = __WEBPACK_IMPORTED_MODULE_1_snabbdom_tovnode___default()(element);
        this.sectionsData = sectionsData;
        this.topcisData = topicsData;
        this.periodData = periodData;
    }
    FilterTag.prototype.renderBreadcrumb = function (sections, topics, period, query, onClick) {
        var _this = this;
        this.container = Object(__WEBPACK_IMPORTED_MODULE_0_bootstrap_load_snabbdom__["b" /* patch */])(this.container, SnabbdomPragma.createElement("div", null));
        this.container = Object(__WEBPACK_IMPORTED_MODULE_0_bootstrap_load_snabbdom__["b" /* patch */])(this.container, SnabbdomPragma.createElement("div", null,
            sections.map(function (t) { return SnabbdomPragma.createElement(FilterTagItem, { name: _this.sectionsData[t], tag: t, fixed: false, onClick: function () { return onClick('sections', t); } }); }),
            topics.map(function (t) { return SnabbdomPragma.createElement(FilterTagItem, { name: _this.topcisData[t], tag: t, fixed: false, onClick: function () { return onClick('topics', t); } }); }),
            query &&
                SnabbdomPragma.createElement(FilterTagItem, { name: query, tag: 'query', fixed: false, onClick: function () { return onClick('query', period); } }),
            SnabbdomPragma.createElement(FilterTagItem, { name: this.periodData[period], tag: period, fixed: true, onClick: function () { return onClick('period', period); } })));
    };
    return FilterTag;
}());


/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(10)))

/***/ }),
/* 216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lib_vendor_terrific_Module__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lib_generic_SDXModalDialog__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lib_ecommerce_util__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers__ = __webpack_require__(217);





var AJAX_TYPE_GET = 'GET';
var AJAX_DATA_TYPE_JSON = 'json';
var LeadManagement = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */])(LeadManagement, _super);
    function LeadManagement() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.baseUrl = [
            window.location.protocol,
            '//',
            window.location.host,
        ].join('');
        _this.segment = (Object(__WEBPACK_IMPORTED_MODULE_3_lib_ecommerce_util__["pageSegment"])() || __WEBPACK_IMPORTED_MODULE_3_lib_ecommerce_util__["Segment"].RES).toUpperCase();
        return _this;
    }
    LeadManagement.prototype.on = function (callback) {
        var _this = this;
        this.$link = this.$ctx.find('a');
        /*
         * Because there is an open parsys where editors can add
         * typography component that themselves may contain anchor tags,
         * we must only wrapp the parsys content when we can not find any anchor tag already.
        */
        if (!this.$link.length) {
            var anchor = $('<a></a>', { href: '' });
            anchor.append(this.$ctx.children());
            this.$ctx.append(anchor);
            this.$link = anchor;
        }
        this.$link.on('click', function (event) {
            event.preventDefault();
            event.stopImmediatePropagation();
            if (!_this.$ctx.is('.disabled')) {
                _this.$ctx.addClass('disabled');
                _this.validateDeeplink();
            }
        });
        callback();
    };
    LeadManagement.prototype.updateLink = function (params) {
        var url = Object(__WEBPACK_IMPORTED_MODULE_4__helpers__["d" /* stringifyParams */])(params, this.baseUrl);
        this.$ctx.toggleClass('disabled', !url);
        this.$link.prop('href', url || '#');
    };
    LeadManagement.prototype.validateDeeplink = function () {
        var _this = this;
        var url = this.$link.attr('href');
        var serviceApi = "/lmneo/guest/services/anon/validate/deeplink?url=" + encodeURIComponent(url);
        $.ajax({
            dataType: AJAX_DATA_TYPE_JSON,
            type: AJAX_TYPE_GET,
            url: serviceApi,
        }).then(function (data) {
            if (data.valid) {
                window.location.href = _this.$link.attr('href');
            }
            else {
                _this.onValidationError(data.failureMessages[0]);
            }
        }, function (error) {
            _this.onValidationError(error.responseText);
        });
    };
    LeadManagement.prototype.onValidationError = function (message) {
        __WEBPACK_IMPORTED_MODULE_2_lib_generic_SDXModalDialog__["default"].show({
            buttons: [{
                    thin: true,
                    title: this.$ctx.data('close-label'),
                    type: 'close',
                }],
            notification: 'alert',
            text: message,
        });
    };
    return LeadManagement;
}(__WEBPACK_IMPORTED_MODULE_1_lib_vendor_terrific_Module__["a" /* Module */]));
// tslint:disable-next-line:variable-name
var LegoContainer = function () {
    this.after = function () {
        this.sandbox.subscribe('LEGO_CONTAINER', this);
    };
    this.onNewLegoConfiguration = function (data) {
        var nestedParams = null;
        if (data.currentSelection.mobile &&
            data.currentSelection.mobile.slideId &&
            data.currentSelection.mobile.slideId !== 'N_LEGO No Mobile') {
            // We need a nested lead url inside return url
            nestedParams = {
                cancelUrl: window.location.href,
                leadProductGroup: 'WIRELESS',
                mode: '4P_Wireless',
                productInfo: [
                    { type: __WEBPACK_IMPORTED_MODULE_4__helpers__["a" /* ProductType */].Bundle, value: data.currentSelection.mobile.slideId },
                    { type: __WEBPACK_IMPORTED_MODULE_4__helpers__["a" /* ProductType */].AboLength, value: '12' },
                ],
                productSegment: this.segment,
                returnUrl: Object(__WEBPACK_IMPORTED_MODULE_4__helpers__["b" /* getDefaultReturnUrl */])(this.baseUrl),
            };
        }
        var inOneHomeProducts = [
            { type: __WEBPACK_IMPORTED_MODULE_4__helpers__["a" /* ProductType */].Bundle, value: (this.segment === __WEBPACK_IMPORTED_MODULE_3_lib_ecommerce_util__["Segment"].RES.toUpperCase()) ? 'LEGO Home' : 'LEGO Pro' },
        ];
        inOneHomeProducts = inOneHomeProducts.concat(Object(__WEBPACK_IMPORTED_MODULE_4__helpers__["c" /* getInOneHomeProducts */])(data.currentSelection));
        var params = {
            cancelUrl: window.location.href,
            leadProductGroup: 'WIRELINE',
            mode: nestedParams ? '4P_Wireline' : undefined,
            productInfo: inOneHomeProducts,
            productSegment: this.$ctx.data('productSegment') || this.segment,
            returnUrl: nestedParams || Object(__WEBPACK_IMPORTED_MODULE_4__helpers__["b" /* getDefaultReturnUrl */])(this.baseUrl),
        };
        this.updateLink(params);
    };
};
// tslint:disable-next-line:variable-name
var Manual = function () {
    this.after = function () {
        var cancelUrl = new URL(this.$ctx.data('cancelUrl') || window.location.href, this.baseUrl);
        var returnUrl = new URL(this.$ctx.data('returnUrl') || Object(__WEBPACK_IMPORTED_MODULE_4__helpers__["b" /* getDefaultReturnUrl */])(this.baseUrl), this.baseUrl);
        var params = {
            cancelUrl: cancelUrl.href,
            leadProductGroup: this.$ctx.data('leadProductGroup') || 'WIRELINE',
            productInfo: this.$ctx.data('productInfo'),
            productSegment: this.$ctx.data('productSegment') || this.segment.toUpperCase(),
            returnUrl: returnUrl.href,
        };
        this.updateLink(params);
    };
};
var registryEntry = {
    module: LeadManagement,
    skins: {
        LegoContainer: LegoContainer,
        Manual: Manual,
    },
};
/* harmony default export */ __webpack_exports__["a"] = (registryEntry);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),
/* 217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ProductType; });
/* harmony export (immutable) */ __webpack_exports__["b"] = getDefaultReturnUrl;
/* harmony export (immutable) */ __webpack_exports__["d"] = stringifyParams;
/* harmony export (immutable) */ __webpack_exports__["c"] = getInOneHomeProducts;
/**
 * The available product types
 */
var ProductType;
(function (ProductType) {
    ProductType["Bundle"] = "BUNDLE";
    ProductType["Tv"] = "TV";
    ProductType["Voip"] = "VOIP";
    ProductType["Internet"] = "INTERNET";
    ProductType["Service"] = "SERVICE";
    ProductType["Device"] = "DEVICE";
    ProductType["AboLength"] = "ABOLENGTH";
    ProductType["RatePlan"] = "RATEPLAN";
})(ProductType || (ProductType = {}));
/**
 *
 * @param baseUrl 	The `baseUrl`
 * @returns			The default return url on top of `baseUrl`
 */
function getDefaultReturnUrl(baseUrl) {
    return baseUrl + '/homescreen/online/homeScreen.html';
}
/**
 * @param products	The array of products.
 * @returns 		A serialize string as such: type,name|type,name|etc...
 */
function getProductInfo(products) {
    return products.map(function (product) { return product.type + "," + product.value; }).join('|');
}
/**
 * @param params		The `params` object to serialize into a url search string
 * @param baseUrl		The base for the resutling url onto which to append the params string
 * @returns				A valid URL including the `params` as GET parameters
 */
function stringifyParams(params, baseUrl) {
    if (baseUrl === void 0) { baseUrl = ''; }
    if (!params || !params.productInfo || params.productInfo.length === 0) {
        return null;
    }
    var resultPath = '/lmneo/online/?leadType=PRODUCT&system=PORTAL&';
    var paramString = Object.keys(params).sort().map(function (key) {
        var value = params[key];
        if (!value) {
            return undefined;
        }
        if (typeof value !== 'string') {
            if (Array.isArray(value)) {
                value = getProductInfo(params.productInfo);
            }
            else {
                value = stringifyParams(value, baseUrl) || '';
            }
        }
        return key + "=" + encodeURIComponent(value);
    }).filter(Boolean).join('&');
    return baseUrl + resultPath + paramString;
}
/**
 * Returns an array of inOne Home products based off the users current inOne Home configuration.
 * inOne Home does not include mobile or a mobile device.
 *
 * @param currentSelection	The users current selection
 * @returns					An array of products
 */
function getInOneHomeProducts(currentSelection) {
    var products = [];
    Object.keys(currentSelection).sort().forEach(function (key) {
        var val = currentSelection[key];
        if (!val || !val.slideId) {
            return;
        }
        switch (key.toUpperCase()) {
            case ProductType.Internet:
                products.push({ type: ProductType.Internet, value: val.slideId });
                break;
            case ProductType.Voip:
                products.push({ type: ProductType.Voip, value: val.slideId });
                break;
            case ProductType.Tv:
                products.push({ type: ProductType.Tv, value: val.slideId });
                break;
            case ProductType.Service:
                products.push({ type: ProductType.Service, value: val.slideId });
                break;
            default:
                return;
        }
    });
    return products;
}


/***/ }),
/* 218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lib_vendor_terrific_Module__ = __webpack_require__(3);


var MAP_SLIDER_ID_TO_ORDER_LINK_PARAM = {
    internet: 'Internet',
    service: 'Service',
    tv: 'TV',
    voip: 'Voip',
};
function formattedPrice(amount, perMonth) {
    return "CHF&nbsp;" + SCS.utils.formatPriceWithDash(amount) + perMonth;
}
/**
 * Lego Order Button.
 *
 * @see {@link https://wiki.swisscom.com/pages/viewpage.action?pageId=169925848} for order link parameter details.
 * @example
 *        https://<host>:<port>/map/online/qualifyOrder.html
 *        ?flavourSelection=Internet%3AInternet+Flavour+LEGO+Home+L%3BTV%3ALEGO+No+TV%3BVoip%3ALego+No+VoIP
 *        &siebelProductId=LEGO+Home
 *        &lang=de
 *        &returnUrl=http%3A%2F%2Fwww.swisscom.com%2F
 *        &cancelUrl=http%3A%2F%2Fwww.swisscom.com%2F
 *
 * @author Cesar Keller
 * @namespace Tc.Module
 * @class LegoOrderButton
 * @extends Tc.Module
 */
var LegoOrderButton = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */])(LegoOrderButton, _super);
    function LegoOrderButton() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LegoOrderButton.prototype.on = function (callback) {
        var $ctx = this.$ctx;
        this.orderLinkExistingCustomer = $ctx.data('order-link-existing-customer');
        this.orderLinkNewCustomer = $ctx.data('order-link-new-customer');
        this.orderLinkExistingCustomerMobile = $ctx.data('order-link-existing-customer-mobile');
        this.orderLinkNewCustomerMobile = $ctx.data('order-link-new-customer-mobile');
        this.$existingCustomerButton = $('.modOrderOverlay').eq(0).find('.existing-customer');
        this.siebelProductId = $ctx.data('siebel-product-id');
        this.sandbox.subscribe('LEGO_CONTAINER', this);
        this.$ctx.find('.lego-order-button').on('click', this.openOverlay.bind(this));
        this.additionalParams = this.$ctx.data('additionalParams') || {};
        callback();
    };
    /**
     * Open the order overlay.
     * Update the mobile buttons
     *
     * @fires	'openOverlay'
     */
    LegoOrderButton.prototype.openOverlay = function (event) {
        // If this button is in a form or multi-step form, prevent
        // the default submit action
        event.preventDefault();
        var data = {
            orderButtonsId: 'lego-order-buttons-mobile',
            orderLink: this.addParamsExistingCustomer(this.orderLinkExistingCustomer),
            orderLinkNoLogin: this.addParamsNewCustomer(this.orderLinkNewCustomer),
            productIds: this.selectedProductId,
            productName: '',
        };
        this.fire('openOverlay', data, ['orderoverlaystatus']);
        this.updateMobileButtons();
        this.$existingCustomerButton.on('click', this.handleExistingCustomer.bind(this));
    };
    /**
     * Show 'order steps' dialog before linking to MAP if order step is configured.
     */
    LegoOrderButton.prototype.handleExistingCustomer = function (event) {
        var _this = this;
        var $ctx = this.$ctx;
        var orderStepsContent = $ctx.data('order-steps-content');
        // No order step configured
        // or the button is a button in the order step dialog. In this case just
        // go to the url in the href of the anchor tag.
        if (!orderStepsContent || $(event.target).hasClass('goToLogin')) {
            return true;
        }
        // Order step configured, we need to load and display first.
        $.ajax({
            success: function (data) {
                var _a, _b, _c, _d, _e, _f, _g, _h;
                var $services = $ctx.closest('.modLegoContainer').find('.summary .services');
                var perMonth = $ctx.data('per-month');
                var orderButtonText = $ctx.data('order-button-text');
                var $home = $services.clone().css('display', 'table-cell');
                $home.find('.mobile').addClass('hidden');
                $home.find('.internet').css('margin-left', '0');
                $home = $('<div/>').addClass('modLegoContainer').append($home);
                var $mobile = $services.clone().css('display', 'table-cell');
                $mobile.find('.internet, .service, .tv, .voip').addClass('hidden');
                $mobile.find('.mobile').css('margin-left', '0');
                $mobile = $('<div/>').addClass('modLegoContainer').append($mobile);
                // Replace placeholders for prices, and selected flavours
                data = data
                    .replace(/\$\{bundleBasePrice\}/g, formattedPrice((_b = (_a = _this.prices) === null || _a === void 0 ? void 0 : _a.bundleBasePrice) !== null && _b !== void 0 ? _b : 0, perMonth))
                    .replace(/\$\{homePrice\}/g, formattedPrice((_d = (_c = _this.prices) === null || _c === void 0 ? void 0 : _c.homePrice) !== null && _d !== void 0 ? _d : 0, perMonth))
                    .replace(/\$\{mobilePrice\}/g, formattedPrice((_f = (_e = _this.prices) === null || _e === void 0 ? void 0 : _e.mobilePrice) !== null && _f !== void 0 ? _f : 0, perMonth))
                    .replace(/\$\{totalPrice\}/g, formattedPrice((_h = (_g = _this.prices) === null || _g === void 0 ? void 0 : _g.totalPrice) !== null && _h !== void 0 ? _h : 0, perMonth))
                    .replace(/\$\{home\}/g, $home[0].outerHTML)
                    .replace(/\$\{mobile\}/g, $mobile[0].outerHTML);
                var $orderButton = $('<div/>')
                    .addClass('button-group button-group--right button-group--responsive')
                    .append(_this.$existingCustomerButton.clone(true));
                $orderButton.find('.button').text(orderButtonText).addClass('goToLogin');
                $('<div/>').append(data).append($orderButton).dialog({
                    classes: { 'ui-dialog': 'order-overlay-dialog sdx-container' },
                    width: 780,
                });
            },
            url: orderStepsContent + '/_jcr_content/par.html',
        });
        return false;
    };
    // Update mobile buttons in this module and the clone in the order overlay
    LegoOrderButton.prototype.updateMobileButtons = function () {
        var existingCustomerUrl = this.orderLinkExistingCustomerMobile;
        var newCustomerUrl = this.addParamsNewCustomer(this.orderLinkNewCustomerMobile);
        var $createLoginButton = $('.modOrderOverlay .new-customer .button[href]');
        if (!existingCustomerUrl) {
            existingCustomerUrl = this.addParamsExistingCustomer(this.orderLinkExistingCustomer);
        }
        else if (existingCustomerUrl && !String(existingCustomerUrl).trim().startsWith('tel:')) {
            existingCustomerUrl = this.addParamsExistingCustomer(existingCustomerUrl);
        }
        // Handle BBI: if swisscomLoginRequired is enabled in Order Overlay, use that button's href and label
        if ($createLoginButton.length) {
            newCustomerUrl = $createLoginButton.prop('href');
            var newCustomerUrlLabel = $createLoginButton.text();
            this.$ctx.find('.order-link-new-customer-mobile .button').text(newCustomerUrlLabel);
            $('#orderoverlay').find('.order-link-new-customer-mobile .button').text(newCustomerUrlLabel);
        }
        this.$ctx.find('.order-link-existing-customer-mobile').attr('href', existingCustomerUrl);
        $('#orderoverlay').find('.order-link-existing-customer-mobile').attr('href', existingCustomerUrl);
        this.$ctx.find('.order-link-new-customer-mobile').attr('href', newCustomerUrl);
        $('#orderoverlay').find('.order-link-new-customer-mobile').attr('href', newCustomerUrl);
    };
    LegoOrderButton.prototype.onDialogClosed = function () {
        this.$existingCustomerButton.off('click');
    };
    // Fired by Tc.Module.ServiceAvailability
    LegoOrderButton.prototype.onServiceAvailabilityDataUpdate = function () {
        var _this = this;
        var mod = this;
        // The user has already entered his phone number or address,
        // so this is a good time to check all the flavours at once
        mod.fire('checkProductIds', {
            productIds: this.productIds,
            success: function (data) {
                // Send results to Lego Configurator
                _this.fire('flavourAvailability', data, ['LEGO_CONTAINER']);
            },
        });
    };
    /**
     * Terrific Handler, fired by Tc.Module.LegoContainer.Configurator.
     * Collects all selected product IDs and prepares the parameters needed for the order button URLs.
     */
    LegoOrderButton.prototype.onNewLegoConfiguration = function (data) {
        // I18n
        var yourSelection = this.$ctx.data('your-selection');
        var currentSelection = data && data.currentSelection;
        var deeplinkHashParameters = data && data.deeplinkHashParameters;
        var prices = data && data.prices;
        // All flavours
        var productIds = data && data.productIds;
        var flavourSelection = Object.keys(currentSelection)
            .filter(function (key) { return key in MAP_SLIDER_ID_TO_ORDER_LINK_PARAM; })
            .map(function (key) { return MAP_SLIDER_ID_TO_ORDER_LINK_PARAM[key] + ":" + currentSelection[key].slideId; })
            .join(';');
        if (currentSelection.internet) {
            this.selectedProductId = { name: yourSelection, siebelId: currentSelection.internet.slideId };
        }
        // Save for later
        this.flavourSelection = flavourSelection;
        this.deeplinkHashParameters = deeplinkHashParameters;
        this.productIds = productIds;
        this.prices = prices;
        this.log('onNewLegoConfiguration', flavourSelection, this.selectedProductId, productIds, prices);
        // Update buttons for desktop and mobile (in case the overlay is already open)
        var orderButtonsInitData = {
            href: this.addParamsExistingCustomer(this.orderLinkExistingCustomer),
            noLoginUrl: String(this.orderLinkNewCustomer) + "#lpIds=" + this.deeplinkHashParameters,
            update: true, // Do not init/reset the button state, only update the URLs
        };
        this.fire('orderButtonsInit', orderButtonsInitData, ['orderoverlaystatus']);
        this.updateMobileButtons();
        this.fire('updateProductId', this.selectedProductId, ['serviceavailabilitycheck']);
    };
    LegoOrderButton.prototype.addParamsNewCustomer = function (url) {
        var result = String(url) + "#lpIds=" + String(this.deeplinkHashParameters);
        for (var additionalParam in this.additionalParams) {
            result += "&" + additionalParam + "=" + encodeURIComponent(this.additionalParams[additionalParam]);
        }
        return result;
    };
    LegoOrderButton.prototype.addParamsExistingCustomer = function (url) {
        var language = this.$ctx.data('language');
        var params = [
            'flavourSelection',
            this.flavourSelection,
            'siebelProductId', this.siebelProductId,
            'lang', language,
            'returnUrl', location.href,
            'cancelUrl', location.href,
        ];
        for (var additionalParam in this.additionalParams) {
            params.push(additionalParam, this.additionalParams[additionalParam]);
        }
        var result = url + '?';
        for (var i = 0; i < params.length; i += 2) {
            result += "" + (i === 0 ? '' : '&') + params[i] + "=" + encodeURIComponent(params[i + 1]);
        }
        return result;
    };
    return LegoOrderButton;
}(__WEBPACK_IMPORTED_MODULE_1_lib_vendor_terrific_Module__["a" /* Module */]));
/* harmony default export */ __webpack_exports__["a"] = (LegoOrderButton);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),
/* 219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lib_vendor_terrific_Module__ = __webpack_require__(3);


var SECTION_PREFIX = 'portal-contact';
var HIDDEN_DIV_TEMPLATE = '<div class="hidden"></div>';
var LIVEPERSONCHAT_DIV_TEMPLATE = '<div class="modLivePersonChat" id="lpChatContactButton"></div>';
var LivePersonChatForContact = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */])(LivePersonChatForContact, _super);
    function LivePersonChatForContact() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LivePersonChatForContact.prototype.on = function (callback) {
        this.topicId = this.$ctx.closest('.result[data-parent-topic]').attr('data-parent-topic');
        this.$chatButton = $(document.body).find('#lpChatContactButton');
        if (!this.$chatButton.length) {
            var $hiddenDiv = $(HIDDEN_DIV_TEMPLATE);
            this.$chatButton = $(LIVEPERSONCHAT_DIV_TEMPLATE);
            this.$chatButton.appendTo($hiddenDiv);
            $hiddenDiv.appendTo(document.body);
        }
        callback();
    };
    LivePersonChatForContact.prototype.onTopicSelected = function (topic) {
        if (topic.topicName !== this.topicId && topic.name !== this.topicId) {
            return;
        }
        var name = topic.topicName || topic.name;
        var topicName = name.split('/');
        var topicSection = SECTION_PREFIX + ":topic:" + topicName[0];
        var subtopicSection = SECTION_PREFIX + ":subtopic:" + topicName[1];
        if (window.lpTag) {
            var sections = window.lpTag.section || [];
            sections = sections.filter(function (section) {
                if (typeof section !== 'string') {
                    return true;
                }
                section = section.split(':');
                return section[0] !== SECTION_PREFIX;
            });
            sections.push(topicSection, subtopicSection);
            if (window.lpTag.newPage) {
                window.lpTag.newPage(window.location.href, { section: sections });
            }
            else {
                window.lpTag.section = sections;
            }
        }
        else {
            window.lpTag = { section: [topicSection, subtopicSection] };
        }
        this.$chatButton.attr('data-track-linkname', this.$ctx.data('track-linkname'));
        this.$chatButton.attr('data-track-action', this.$ctx.data('track-action'));
        this.$chatButton.attr('data-track-label', this.$ctx.data('track-label'));
        this.$chatButton.attr('data-track-location', this.$ctx.data('track-location'));
        this.$chatButton.attr('data-track-category', this.$ctx.data('track-category'));
        this.$chatButton.attr('data-conversion-category', this.$ctx.data('conversion-category'));
        this.$chatButton.attr('data-conversion-detail', this.$ctx.data('conversion-detail'));
        this.$chatButton.attr('data-conversion-class', this.$ctx.data('conversion-class'));
        this.$chatButton.appendTo(this.$ctx);
    };
    return LivePersonChatForContact;
}(__WEBPACK_IMPORTED_MODULE_1_lib_vendor_terrific_Module__["a" /* Module */]));
/* harmony default export */ __webpack_exports__["a"] = (LivePersonChatForContact);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),
/* 220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lib_vendor_terrific_Module__ = __webpack_require__(3);


var SEP = '|';
/**
 * PDFQrCode module implementation.
 *
 * @author taatini1
 * @class PDFQrCode
 * @extends Tc.Module
 */
var PDFQrCode = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */])(PDFQrCode, _super);
    function PDFQrCode() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.inputs = [];
        return _this;
    }
    /**
     * Hook function to do all of your module stuff.
     *
     * @method on
     * @param  {Hook} callback Callback function
     * @return void
     */
    PDFQrCode.prototype.on = function (callback) {
        this.placeholderName = this.$ctx.data('placeholder-name');
        this.$inputElement = this.$ctx.find('input');
        var nameList = this.$ctx.data('input-names') || [];
        for (var _i = 0, nameList_1 = nameList; _i < nameList_1.length; _i++) {
            var name = nameList_1[_i];
            var $elem = $("input[name=\"" + name + "\"]");
            this.inputs.push($elem);
            $elem.on('change', this.updateValue.bind(this));
        }
        this.updateValue();
        callback();
    };
    PDFQrCode.prototype.updateValue = function () {
        var value = this.inputs
            .map(function ($el) { return $el.val(); })
            .join(SEP);
        var res = {
            name: this.placeholderName,
            text: "" + value + SEP,
        };
        this.$inputElement.val(JSON.stringify(res));
    };
    return PDFQrCode;
}(__WEBPACK_IMPORTED_MODULE_1_lib_vendor_terrific_Module__["a" /* Module */]));
/* harmony default export */ __webpack_exports__["a"] = (PDFQrCode);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),
/* 221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lib_vendor_terrific_Module__ = __webpack_require__(3);


/**
 * Tc.Module.PexArticleDetail
 */
var PexArticleDetail = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */])(PexArticleDetail, _super);
    function PexArticleDetail($ctx, sandbox, id, modName) {
        var _this = _super.call(this, $ctx, sandbox, id, modName) || this;
        _this.$button = $ctx.find('.agreeButton');
        _this.serviceUrl = _this.$button.data('ajax-url');
        return _this;
    }
    /**
     * Hook function to do all of your module stuff.
     *
     * @method on
     * @param  {Hook} callback Callback function
     * @return void
     */
    PexArticleDetail.prototype.on = function (callback) {
        this.log.debug('starting');
        this.$button.on('click', this.sendResult.bind(this));
        callback();
    };
    PexArticleDetail.prototype.sendResult = function () {
        this.$button.addClass('disabled');
        $.post({
            async: false,
            data: {},
            dataType: 'json',
            success: this.onResult.bind(this),
            url: this.serviceUrl,
        });
    };
    PexArticleDetail.prototype.onResult = function () {
        this.$button.addClass('button--confirm');
        this.$button.removeClass('button--primary');
        var text = this.$button.text();
        this.$button.html("<i class=\"icon-011-check-mark icon\"></i> " + text);
        this.log.debug('Response success');
    };
    return PexArticleDetail;
}(__WEBPACK_IMPORTED_MODULE_1_lib_vendor_terrific_Module__["a" /* Module */]));
/* harmony default export */ __webpack_exports__["a"] = (PexArticleDetail);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),
/* 222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lib_vendor_terrific_Module__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__IncidentInfo__ = __webpack_require__(223);



/**
 * Tc.Module.IncidentInfoDialog
 */
var IncidentInfoDialog = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */])(IncidentInfoDialog, _super);
    function IncidentInfoDialog() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Hook function to do all of your module stuff.
     *
     * @method on
     * @param  {Hook} callback Callback function
     * @return void
     */
    IncidentInfoDialog.prototype.on = function (callback) {
        var _this = this;
        this.scn = parseInt(this.$ctx.data('incident-scn'), 10);
        this.userName = this.$ctx.data('user-name');
        this.incidentId = parseInt(this.$ctx.data('incident-id'), 10);
        this.ajaxUrlPrefix = this.$ctx.data('ajax-url');
        this.messages = this.$ctx.data('labels');
        this.fetchData()
            .then(function (data) {
            _this.data = data;
            (new __WEBPACK_IMPORTED_MODULE_2__IncidentInfo__["a" /* IncidentInfo */](_this.$ctx.find('>div').get(0), _this.data, _this.userName, _this.scn, _this.messages)).render();
        })
            .catch(function (err) { return _this.log(err.responseText); });
        callback();
    };
    IncidentInfoDialog.prototype.fetchData = function () {
        return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var data, postData;
            return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
                data = {
                    outageId: this.incidentId,
                    scn: this.scn,
                };
                postData = {
                    data: data,
                    url: this.ajaxUrlPrefix + ".details.json",
                };
                return [2 /*return*/, $.post(postData)];
            });
        });
    };
    return IncidentInfoDialog;
}(__WEBPACK_IMPORTED_MODULE_1_lib_vendor_terrific_Module__["a" /* Module */]));
/* harmony default export */ __webpack_exports__["a"] = (IncidentInfoDialog);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),
/* 223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(SnabbdomPragma) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return IncidentInfo; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bootstrap_load_snabbdom__ = __webpack_require__(9);

function InfoLayout(_a) {
    var data = _a.data, userName = _a.userName, scn = _a.scn, messages = _a.messages;
    return SnabbdomPragma.createElement("div", { className: "customer-list-dialog row show-grid" },
        SnabbdomPragma.createElement("div", { className: "col-sm-12 col-md-6" },
            SnabbdomPragma.createElement("div", { className: "margin-bottom-2 text-align-left" },
                SnabbdomPragma.createElement("span", { className: "label" }, "ID"),
                SnabbdomPragma.createElement("p", null, data.id)),
            SnabbdomPragma.createElement("div", { className: "margin-bottom-2 text-align-left" },
                SnabbdomPragma.createElement("span", { className: "label" }, messages.datum),
                SnabbdomPragma.createElement("p", null, (new Date(data.creationDate)).toLocaleDateString(document.documentElement.lang))),
            SnabbdomPragma.createElement("div", { className: "margin-bottom-2 text-align-left" },
                SnabbdomPragma.createElement("span", { className: "label" }, messages.customerListNr),
                SnabbdomPragma.createElement("p", null, scn ? scn : '-')),
            SnabbdomPragma.createElement("div", { className: "margin-bottom-2 text-align-left" },
                SnabbdomPragma.createElement("span", { className: "label" }, messages.customerName),
                SnabbdomPragma.createElement("p", null, userName ? userName : '-')),
            SnabbdomPragma.createElement("div", { className: "margin-bottom-2 text-align-left" },
                SnabbdomPragma.createElement("span", { className: "label" }, messages.incidentType),
                SnabbdomPragma.createElement("p", null, data.type.charAt(0).toUpperCase() + data.type.substring(1).toLowerCase())),
            SnabbdomPragma.createElement("div", { className: "margin-bottom-2 text-align-left" },
                SnabbdomPragma.createElement("span", { className: "label" }, messages.title),
                SnabbdomPragma.createElement("p", null, data.title)),
            SnabbdomPragma.createElement("div", { className: "text-align-left" },
                SnabbdomPragma.createElement("span", { className: "label" }, messages.internalDescription),
                SnabbdomPragma.createElement("p", null, data.internalDescription ? data.internalDescription : '-')),
            SnabbdomPragma.createElement("div", { className: "text-align-left" },
                SnabbdomPragma.createElement("span", { className: "label" }, messages.location),
                SnabbdomPragma.createElement("p", null, data.location))),
        SnabbdomPragma.createElement("div", { className: "col-sm-12 col-md-6" },
            SnabbdomPragma.createElement("div", { className: "margin-bottom-2 text-align-left" },
                SnabbdomPragma.createElement("span", { className: "label" }, messages.description),
                SnabbdomPragma.createElement("p", null, data.description)),
            SnabbdomPragma.createElement("div", { className: "margin-bottom-2 text-align-left" },
                SnabbdomPragma.createElement("span", { className: "label" }, messages.workaround),
                SnabbdomPragma.createElement("p", null, data.partnerWorkaround ? data.partnerWorkaround : '-')),
            data.attributes.map(function (elem) {
                return SnabbdomPragma.createElement("div", { className: "margin-bottom-2 text-align-left" },
                    SnabbdomPragma.createElement("span", { className: "label" }, elem.label),
                    SnabbdomPragma.createElement("p", null, elem.value));
            })));
}
var IncidentInfo = /** @class */ (function () {
    function IncidentInfo(target, data, userName, scn, messages) {
        this.target = target;
        this.data = data;
        this.userName = userName;
        this.scn = scn;
        this.messages = messages;
    }
    IncidentInfo.prototype.render = function () {
        this.target = Object(__WEBPACK_IMPORTED_MODULE_0_bootstrap_load_snabbdom__["b" /* patch */])(this.target, SnabbdomPragma.createElement(InfoLayout, { data: this.data, userName: this.userName, scn: this.scn, messages: this.messages }));
    };
    return IncidentInfo;
}());


/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(10)))

/***/ }),
/* 224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lib_vendor_terrific_Module__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lib_util_compare__ = __webpack_require__(225);



/**
 * Tc.Module.AbstractPexList
 */
var AbstractPexList = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */])(AbstractPexList, _super);
    function AbstractPexList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.dataUrl = '';
        _this.lastSearchTerm = '';
        return _this;
    }
    /**
     * Hook function to do all of your module stuff.
     *
     * @method on
     * @param  {Hook} callback Callback function
     * @return void
     */
    AbstractPexList.prototype.on = function (callback) {
        var _this = this;
        this.$searchButton = this.$ctx.find('.search-button');
        this.$searchField = this.$ctx.find('.search-field');
        this.$openIncidentsCheckbox = this.$ctx.find('#userdecidesOpenIncidents');
        this.$closeIncidentsCheckbox = this.$ctx.find('#userdecidesCloseIncidents');
        this.displayStatus = this.$ctx.data('show-incident-status');
        this.$resultNumberHolder = this.$ctx.find('.result-number');
        this.$exportToCSVButton = this.$ctx.find('.export-to-csv');
        this.labels = this.$ctx.data('labels');
        this.$tableWrapper = this.$ctx.find('.table__wrapper');
        this.addEventHandlers();
        this.init()
            .catch(function (err) { return _this.log("ERROR fetch data: " + err); });
        callback();
    };
    AbstractPexList.prototype.init = function () {
        return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var data, err_1;
            var _this = this;
            return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.fetchData()];
                    case 1:
                        data = _a.sent();
                        data.forEach(function (item) {
                            var date = new Date(item.creationDate);
                            item.date = date.toLocaleDateString(document.documentElement.lang);
                            item.creationDateTamestamp = date.getTime();
                            item.searchValue = Object.keys(item)
                                .filter(function (k) { return _this.searchablesProps.has(k); })
                                .map(function (k) { return item[k]; })
                                .filter(Boolean)
                                .map(String)
                                .map(function (prop) { return prop.toLowerCase(); })
                                .join(' ');
                        });
                        this.data = data;
                        this.filterData();
                        this.render();
                        this.updateResultNumber();
                        return [3 /*break*/, 3];
                    case 2:
                        err_1 = _a.sent();
                        this.log("ERROR fetch data: " + err_1.responseText);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    AbstractPexList.prototype.onSort = function (evt) {
        var $target = $(evt.target);
        var propName = $target.data('sort-name');
        var asc = $target.hasClass('sort-up');
        $target.toggleClass('sort-up', !asc);
        $target.toggleClass('sort-down', asc);
        $target.siblings().removeClass('sort-up');
        $target.siblings().removeClass('sort-down');
        if (this.sortPropName === propName && this.sortAsc === asc) {
            return;
        }
        this.sortPropName = propName;
        this.sortAsc = asc;
        this.sort();
        this.update();
    };
    AbstractPexList.prototype.search = function () {
        var searchString = $.trim((this.$searchField.val() || '').toLowerCase());
        var allSearchTerms;
        // If search string is same as prevous one search is already done.
        if (searchString === this.lastSearchTerm) {
            return;
        }
        this.lastSearchTerm = searchString;
        this.filterData();
        if (!this.lastSearchTerm) {
            return;
        }
        // Remove spaces after - and posible multiple accurance of - sign
        allSearchTerms = searchString.replace(/-+\s*/g, '-').split(/\s+/g);
        this.searchHelper(allSearchTerms);
    };
    AbstractPexList.prototype.filterData = function () {
        var _this = this;
        this.data.forEach(function (elem) {
            switch (_this.displayStatus) {
                case 'open':
                    elem.display = elem.status === 'open';
                    break;
                case 'close':
                    elem.display = elem.status === 'closed';
                    break;
                case 'user-defined':
                    elem.display = (elem.status === 'open' && _this.$openIncidentsCheckbox.prop('checked')) ||
                        (elem.status === 'closed' && _this.$closeIncidentsCheckbox.prop('checked'));
                    break;
                default:
                    elem.display = true;
                    break;
            }
        });
    };
    AbstractPexList.prototype.fetchData = function () {
        return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __awaiter */])(this, void 0, void 0, function () {
            return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
                return [2 /*return*/, $.post({
                        data: {},
                        url: this.dataUrl,
                    })];
            });
        });
    };
    AbstractPexList.prototype.setupFadeoutEffect = function () {
        var el = this.$tableWrapper.get(0);
        var threshold = 5;
        var offset = el.scrollWidth - el.offsetWidth;
        if (el.scrollLeft > threshold && offset > threshold) {
            this.$tableWrapper.addClass('left-scroll');
        }
        else {
            this.$tableWrapper.removeClass('left-scroll');
        }
        if ((offset - el.scrollLeft) > threshold && offset > threshold) {
            this.$tableWrapper.addClass('right-scroll');
        }
        else {
            this.$tableWrapper.removeClass('right-scroll');
        }
    };
    AbstractPexList.prototype.addEventHandlers = function () {
        var _this = this;
        this.$searchButton.on('click', function (evt) { return _this.onSearch(evt); });
        this.$openIncidentsCheckbox.on('click', function () { return _this.onFilterChange(); });
        this.$closeIncidentsCheckbox.on('click', function () { return _this.onFilterChange(); });
        this.$exportToCSVButton.on('click', function () { return _this.exportToCSV(); });
        this.$tableWrapper.on('scroll', function () { return _this.setupFadeoutEffect(); });
    };
    AbstractPexList.prototype.onFilterChange = function () {
        this.filterData();
        this.lastSearchTerm = '';
        this.search();
        this.updateResultNumber();
        this.update();
    };
    AbstractPexList.prototype.onSearch = function (evt) {
        evt.preventDefault();
        this.search();
        this.updateResultNumber();
        this.update();
    };
    AbstractPexList.prototype.sort = function () {
        var cmp = Object(__WEBPACK_IMPORTED_MODULE_2_lib_util_compare__["b" /* comparingBy */])(this.data[0], __WEBPACK_IMPORTED_MODULE_2_lib_util_compare__["a" /* compare */], this.sortPropName);
        this.data.sort(this.sortAsc ? cmp : Object(__WEBPACK_IMPORTED_MODULE_2_lib_util_compare__["c" /* inverted */])(cmp));
    };
    AbstractPexList.prototype.searchHelper = function (searchTerms) {
        var includeSearchTerms = searchTerms.filter(function (searchTerm) { return !searchTerm.startsWith('-'); });
        var excludeSearchTerms = searchTerms.filter(function (searchTerm) { return searchTerm.startsWith('-'); })
            .map(function (searchTerm) { return searchTerm.substring(1); });
        var _loop_1 = function (item) {
            if (item.display) {
                item.display = !excludeSearchTerms.some(function (searchTerm) { return item.searchValue.includes(searchTerm); }) &&
                    includeSearchTerms.every(function (searchTerm) { return item.searchValue.includes(searchTerm); });
            }
        };
        for (var _i = 0, _a = this.data; _i < _a.length; _i++) {
            var item = _a[_i];
            _loop_1(item);
        }
    };
    AbstractPexList.prototype.updateResultNumber = function () {
        this.$resultNumberHolder.text(this.data.filter(function (item) { return item.display; }).length);
    };
    return AbstractPexList;
}(__WEBPACK_IMPORTED_MODULE_1_lib_vendor_terrific_Module__["a" /* Module */]));
/* harmony default export */ __webpack_exports__["a"] = (AbstractPexList);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),
/* 225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = compare;
/* harmony export (immutable) */ __webpack_exports__["b"] = comparingBy;
/* harmony export (immutable) */ __webpack_exports__["c"] = inverted;
function compare(valA, valB) {
    if (valA === null || valA === '' || valA === undefined) {
        return valA === valB ? 0 : -1;
    }
    if (valB === null || valB === '' || valB === undefined) {
        return valA === valB ? 0 : 1;
    }
    var cmpA = valA;
    var cmpB = valB;
    if (typeof valA === 'string' && typeof valB === 'string') {
        if (!Number.isNaN(parseInt(valA, 10)) && !Number.isNaN(parseInt(valB, 10))) {
            cmpA = parseInt(valA, 10);
            cmpB = parseInt(valB, 10);
        }
        else {
            cmpA = valA.toLowerCase();
            cmpB = valB.toLowerCase();
            // Do utf8 umlaut compatible string comparison if supported by the browser
            if (typeof cmpA.localeCompare === 'function') {
                return cmpA.localeCompare(cmpB);
            }
        }
    }
    // Do the sorting (JS is able to compare numbers AND string with the "<", ">" operators
    return cmpA > cmpB ? 1 : (cmpA < cmpB ? -1 : 0);
}
function comparingBy(_data, comparator, key) {
    return function (a, b) { return comparator(a[key], b[key]); };
}
function inverted(compare) {
    return function (a, b) { return compare(b, a); };
}


/***/ }),
/* 226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(SnabbdomPragma) {/* harmony export (immutable) */ __webpack_exports__["b"] = showInfoDialog;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return IncidentListRenderer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bootstrap_load_snabbdom__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__model__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sdx_menu_MenuFlyout__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lib_generic_SDXModalDialog__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_jquery__);





function showInfoDialog(id, scn, customerName, url, labels) {
    var htmlString = "\n<div class=\"mod modPexIncidentInfoDialog\"\n\tdata-user-name=\"" + customerName + "\"\n\tdata-incident-id=\"" + id + "\"\n\tdata-incident-scn=\"" + scn + "\"\n\tdata-ajax-url=\"" + url + "\"\n>\n\t<div></div>\n</div>";
    var $html = __WEBPACK_IMPORTED_MODULE_4_jquery___default()(htmlString);
    $html.attr('data-labels', JSON.stringify(labels));
    __WEBPACK_IMPORTED_MODULE_3_lib_generic_SDXModalDialog__["default"].show({
        buttons: [
            {
                primary: false,
                title: labels.closeBtnLabel,
                type: 'close',
            },
        ],
        class: 'pex-customer-list-detail',
        fillWidth: true,
        html: $html,
        title: labels.details,
    });
}
function IncidentList(_a) {
    var data = _a.data, labels = _a.labels, ctx = _a.ctx, displayedTypes = _a.displayedTypes;
    var isIncidentList = displayedTypes.includes(__WEBPACK_IMPORTED_MODULE_1__model__["a" /* IncidentTypes */].INCIDENT);
    return SnabbdomPragma.createElement("tbody", null, data.filter(function (elem) { return elem.display; })
        .map(function (elem) {
        return SnabbdomPragma.createElement("tr", { "on-mouseleave": [ctx.destroyDropdownMenu.bind(ctx)] },
            SnabbdomPragma.createElement("td", null,
                " ",
                elem.title,
                " "),
            SnabbdomPragma.createElement("td", null,
                " ",
                elem.location,
                " "),
            isIncidentList && (SnabbdomPragma.createElement("td", null,
                " ",
                elem.customerName ? elem.customerName : '-',
                " ")),
            isIncidentList && (SnabbdomPragma.createElement("td", null,
                " ",
                elem.scn ? elem.scn : '-',
                " ")),
            SnabbdomPragma.createElement("td", null,
                " ",
                elem.date,
                " "),
            SnabbdomPragma.createElement("td", { className: "action-buttons" },
                SnabbdomPragma.createElement("div", { className: "action-menu button-group" },
                    SnabbdomPragma.createElement("button", { className: "action-button", "attrs-data-action": "dropdown-menu", "attrs-data-toggle": "flyout", "attrs-data-target": '#customer-flyout-menu_' + elem.id, "on-click": [ctx.initDropdownMenu.bind(ctx)] },
                        SnabbdomPragma.createElement("i", { className: "icon icon-053-more" }))),
                SnabbdomPragma.createElement("div", { className: "dropdown" },
                    SnabbdomPragma.createElement("div", { "attrs-id": 'customer-flyout-menu_' + elem.id, className: "flyout flyout--list flyout--right js-flyout" },
                        SnabbdomPragma.createElement("ul", { className: "abstractlist" },
                            SnabbdomPragma.createElement("li", { className: "abstractlist-item margin-0" },
                                SnabbdomPragma.createElement("button", { className: "show-details link list-link", "on-click": [showInfoDialog, elem.id, elem.scn, elem.customerName, ctx.ajaxUrlPrefix, labels] }, labels.details)))))));
    }));
}
var IncidentListRenderer = /** @class */ (function () {
    function IncidentListRenderer(target, data, labels, ajaxUrlPrefix, displayedTypes) {
        this.target = target;
        this.data = data;
        this.flyoutInstance = null;
        this.labels = labels;
        this.ajaxUrlPrefix = ajaxUrlPrefix;
        this.displayedTypes = displayedTypes;
    }
    IncidentListRenderer.prototype.render = function () {
        this.target = Object(__WEBPACK_IMPORTED_MODULE_0_bootstrap_load_snabbdom__["b" /* patch */])(this.target, SnabbdomPragma.createElement(IncidentList, { data: this.data, labels: this.labels, ctx: this, displayedTypes: this.displayedTypes }));
    };
    IncidentListRenderer.prototype.clear = function () {
        this.target = Object(__WEBPACK_IMPORTED_MODULE_0_bootstrap_load_snabbdom__["b" /* patch */])(this.target, SnabbdomPragma.createElement("tbody", null));
    };
    IncidentListRenderer.prototype.initDropdownMenu = function (_evt, target) {
        if (this.flyoutInstance) {
            return;
        }
        this.flyoutInstance = new __WEBPACK_IMPORTED_MODULE_2_sdx_menu_MenuFlyout__["default"](target.elm);
        var targetId = target.elm.dataset.target;
        var $menu = __WEBPACK_IMPORTED_MODULE_4_jquery___default()(target.elm).closest('.action-buttons').find(targetId);
        var $list = $menu.find('ul');
        $list.find('a, button').removeClass('flyout__indicator');
        var bottomOffset = window.innerHeight - Math.round(this.flyoutInstance.element.getBoundingClientRect().bottom);
        if ($menu.height() > bottomOffset) {
            $list.find('li').last().find('a, button').addClass('flyout__indicator');
            $menu.addClass('flyout--top');
            $menu.closest('.dropdown').addClass('top');
        }
        else {
            $list.find('li').first().find('a, button').addClass('flyout__indicator');
            $menu.removeClass('flyout--top');
            $menu.closest('.dropdown').removeClass('top');
        }
        // FIXME: This should be fixed on SDX side
        this.flyoutInstance._dynamicPlacement = false;
        this.flyoutInstance.open();
    };
    IncidentListRenderer.prototype.destroyDropdownMenu = function () {
        if (this.flyoutInstance) {
            this.flyoutInstance.close();
            this.flyoutInstance.destroy();
            this.flyoutInstance = null;
        }
    };
    return IncidentListRenderer;
}());


/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(10)))

/***/ }),
/* 227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return IncidentTypes; });
var IncidentTypes;
(function (IncidentTypes) {
    IncidentTypes["INCIDENT"] = "INCIDENT";
    IncidentTypes["PROBLEM"] = "PROBLEM";
    IncidentTypes["CHANGE"] = "CHANGE";
})(IncidentTypes || (IncidentTypes = {}));


/***/ }),
/* 228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(SnabbdomPragma) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TableHeader; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bootstrap_load_snabbdom__ = __webpack_require__(9);

function Header(_a) {
    var displayedTypes = _a.displayedTypes, headings = _a.headings, sortAction = _a.sortAction;
    var isIncidentList = displayedTypes.includes('INCIDENT');
    var hiddenFields = ['scn', 'customerName'];
    return SnabbdomPragma.createElement("thead", null,
        SnabbdomPragma.createElement("tr", null, headings
            .filter(function (item) { return isIncidentList || !hiddenFields.includes(item.sortName); })
            .map(function (item) {
            return SnabbdomPragma.createElement("th", { "attrs-data-sort-name": item.sortName, className: "font--semi-bold", "on-click": item.sort ? [sortAction] : undefined },
                item.title,
                " ",
                item.sort && SnabbdomPragma.createElement("i", { className: "tablesorter-icon" }));
        })));
}
var TableHeader = /** @class */ (function () {
    function TableHeader(target, headings, sortOptions, displayedTypes) {
        this.target = target;
        this.headings = headings;
        this.sortOptions = sortOptions;
        this.displayedTypes = displayedTypes;
    }
    TableHeader.prototype.render = function () {
        this.target = Object(__WEBPACK_IMPORTED_MODULE_0_bootstrap_load_snabbdom__["b" /* patch */])(this.target, SnabbdomPragma.createElement(Header, { headings: this.headings, 
            // tslint:disable-next-line:no-unbound-method
            sortAction: this.sortOptions.sortAction, displayedTypes: this.displayedTypes }));
    };
    TableHeader.prototype.clear = function () {
        this.target = Object(__WEBPACK_IMPORTED_MODULE_0_bootstrap_load_snabbdom__["b" /* patch */])(this.target, SnabbdomPragma.createElement("thead", null));
    };
    return TableHeader;
}());


/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(10)))

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {(function (global, factory) {
   true ? factory(exports) :
  typeof define === 'function' && define.amd ? define(['exports'], factory) :
  (global = global || self, factory(global.json2csv = {}));
}(this, function (exports) { 'use strict';

  var domain;

  // This constructor is used to store event handlers. Instantiating this is
  // faster than explicitly calling `Object.create(null)` to get a "clean" empty
  // object (tested with v8 v4.9).
  function EventHandlers() {}
  EventHandlers.prototype = Object.create(null);

  function EventEmitter() {
    EventEmitter.init.call(this);
  }

  // nodejs oddity
  // require('events') === require('events').EventEmitter
  EventEmitter.EventEmitter = EventEmitter;

  EventEmitter.usingDomains = false;

  EventEmitter.prototype.domain = undefined;
  EventEmitter.prototype._events = undefined;
  EventEmitter.prototype._maxListeners = undefined;

  // By default EventEmitters will print a warning if more than 10 listeners are
  // added to it. This is a useful default which helps finding memory leaks.
  EventEmitter.defaultMaxListeners = 10;

  EventEmitter.init = function() {
    this.domain = null;
    if (EventEmitter.usingDomains) {
      // if there is an active domain, then attach to it.
      if (domain.active && !(this instanceof domain.Domain)) ;
    }

    if (!this._events || this._events === Object.getPrototypeOf(this)._events) {
      this._events = new EventHandlers();
      this._eventsCount = 0;
    }

    this._maxListeners = this._maxListeners || undefined;
  };

  // Obviously not all Emitters should be limited to 10. This function allows
  // that to be increased. Set to zero for unlimited.
  EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
    if (typeof n !== 'number' || n < 0 || isNaN(n))
      throw new TypeError('"n" argument must be a positive number');
    this._maxListeners = n;
    return this;
  };

  function $getMaxListeners(that) {
    if (that._maxListeners === undefined)
      return EventEmitter.defaultMaxListeners;
    return that._maxListeners;
  }

  EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
    return $getMaxListeners(this);
  };

  // These standalone emit* functions are used to optimize calling of event
  // handlers for fast cases because emit() itself often has a variable number of
  // arguments and can be deoptimized because of that. These functions always have
  // the same number of arguments and thus do not get deoptimized, so the code
  // inside them can execute faster.
  function emitNone(handler, isFn, self) {
    if (isFn)
      handler.call(self);
    else {
      var len = handler.length;
      var listeners = arrayClone(handler, len);
      for (var i = 0; i < len; ++i)
        listeners[i].call(self);
    }
  }
  function emitOne(handler, isFn, self, arg1) {
    if (isFn)
      handler.call(self, arg1);
    else {
      var len = handler.length;
      var listeners = arrayClone(handler, len);
      for (var i = 0; i < len; ++i)
        listeners[i].call(self, arg1);
    }
  }
  function emitTwo(handler, isFn, self, arg1, arg2) {
    if (isFn)
      handler.call(self, arg1, arg2);
    else {
      var len = handler.length;
      var listeners = arrayClone(handler, len);
      for (var i = 0; i < len; ++i)
        listeners[i].call(self, arg1, arg2);
    }
  }
  function emitThree(handler, isFn, self, arg1, arg2, arg3) {
    if (isFn)
      handler.call(self, arg1, arg2, arg3);
    else {
      var len = handler.length;
      var listeners = arrayClone(handler, len);
      for (var i = 0; i < len; ++i)
        listeners[i].call(self, arg1, arg2, arg3);
    }
  }

  function emitMany(handler, isFn, self, args) {
    if (isFn)
      handler.apply(self, args);
    else {
      var len = handler.length;
      var listeners = arrayClone(handler, len);
      for (var i = 0; i < len; ++i)
        listeners[i].apply(self, args);
    }
  }

  EventEmitter.prototype.emit = function emit(type) {
    var er, handler, len, args, i, events, domain;
    var doError = (type === 'error');

    events = this._events;
    if (events)
      doError = (doError && events.error == null);
    else if (!doError)
      return false;

    domain = this.domain;

    // If there is no 'error' event listener then throw.
    if (doError) {
      er = arguments[1];
      if (domain) {
        if (!er)
          er = new Error('Uncaught, unspecified "error" event');
        er.domainEmitter = this;
        er.domain = domain;
        er.domainThrown = false;
        domain.emit('error', er);
      } else if (er instanceof Error) {
        throw er; // Unhandled 'error' event
      } else {
        // At least give some kind of context to the user
        var err = new Error('Uncaught, unspecified "error" event. (' + er + ')');
        err.context = er;
        throw err;
      }
      return false;
    }

    handler = events[type];

    if (!handler)
      return false;

    var isFn = typeof handler === 'function';
    len = arguments.length;
    switch (len) {
      // fast cases
      case 1:
        emitNone(handler, isFn, this);
        break;
      case 2:
        emitOne(handler, isFn, this, arguments[1]);
        break;
      case 3:
        emitTwo(handler, isFn, this, arguments[1], arguments[2]);
        break;
      case 4:
        emitThree(handler, isFn, this, arguments[1], arguments[2], arguments[3]);
        break;
      // slower
      default:
        args = new Array(len - 1);
        for (i = 1; i < len; i++)
          args[i - 1] = arguments[i];
        emitMany(handler, isFn, this, args);
    }

    return true;
  };

  function _addListener(target, type, listener, prepend) {
    var m;
    var events;
    var existing;

    if (typeof listener !== 'function')
      throw new TypeError('"listener" argument must be a function');

    events = target._events;
    if (!events) {
      events = target._events = new EventHandlers();
      target._eventsCount = 0;
    } else {
      // To avoid recursion in the case that type === "newListener"! Before
      // adding it to the listeners, first emit "newListener".
      if (events.newListener) {
        target.emit('newListener', type,
                    listener.listener ? listener.listener : listener);

        // Re-assign `events` because a newListener handler could have caused the
        // this._events to be assigned to a new object
        events = target._events;
      }
      existing = events[type];
    }

    if (!existing) {
      // Optimize the case of one listener. Don't need the extra array object.
      existing = events[type] = listener;
      ++target._eventsCount;
    } else {
      if (typeof existing === 'function') {
        // Adding the second element, need to change to array.
        existing = events[type] = prepend ? [listener, existing] :
                                            [existing, listener];
      } else {
        // If we've already got an array, just append.
        if (prepend) {
          existing.unshift(listener);
        } else {
          existing.push(listener);
        }
      }

      // Check for listener leak
      if (!existing.warned) {
        m = $getMaxListeners(target);
        if (m && m > 0 && existing.length > m) {
          existing.warned = true;
          var w = new Error('Possible EventEmitter memory leak detected. ' +
                              existing.length + ' ' + type + ' listeners added. ' +
                              'Use emitter.setMaxListeners() to increase limit');
          w.name = 'MaxListenersExceededWarning';
          w.emitter = target;
          w.type = type;
          w.count = existing.length;
          emitWarning(w);
        }
      }
    }

    return target;
  }
  function emitWarning(e) {
    typeof console.warn === 'function' ? console.warn(e) : console.log(e);
  }
  EventEmitter.prototype.addListener = function addListener(type, listener) {
    return _addListener(this, type, listener, false);
  };

  EventEmitter.prototype.on = EventEmitter.prototype.addListener;

  EventEmitter.prototype.prependListener =
      function prependListener(type, listener) {
        return _addListener(this, type, listener, true);
      };

  function _onceWrap(target, type, listener) {
    var fired = false;
    function g() {
      target.removeListener(type, g);
      if (!fired) {
        fired = true;
        listener.apply(target, arguments);
      }
    }
    g.listener = listener;
    return g;
  }

  EventEmitter.prototype.once = function once(type, listener) {
    if (typeof listener !== 'function')
      throw new TypeError('"listener" argument must be a function');
    this.on(type, _onceWrap(this, type, listener));
    return this;
  };

  EventEmitter.prototype.prependOnceListener =
      function prependOnceListener(type, listener) {
        if (typeof listener !== 'function')
          throw new TypeError('"listener" argument must be a function');
        this.prependListener(type, _onceWrap(this, type, listener));
        return this;
      };

  // emits a 'removeListener' event iff the listener was removed
  EventEmitter.prototype.removeListener =
      function removeListener(type, listener) {
        var list, events, position, i, originalListener;

        if (typeof listener !== 'function')
          throw new TypeError('"listener" argument must be a function');

        events = this._events;
        if (!events)
          return this;

        list = events[type];
        if (!list)
          return this;

        if (list === listener || (list.listener && list.listener === listener)) {
          if (--this._eventsCount === 0)
            this._events = new EventHandlers();
          else {
            delete events[type];
            if (events.removeListener)
              this.emit('removeListener', type, list.listener || listener);
          }
        } else if (typeof list !== 'function') {
          position = -1;

          for (i = list.length; i-- > 0;) {
            if (list[i] === listener ||
                (list[i].listener && list[i].listener === listener)) {
              originalListener = list[i].listener;
              position = i;
              break;
            }
          }

          if (position < 0)
            return this;

          if (list.length === 1) {
            list[0] = undefined;
            if (--this._eventsCount === 0) {
              this._events = new EventHandlers();
              return this;
            } else {
              delete events[type];
            }
          } else {
            spliceOne(list, position);
          }

          if (events.removeListener)
            this.emit('removeListener', type, originalListener || listener);
        }

        return this;
      };

  EventEmitter.prototype.removeAllListeners =
      function removeAllListeners(type) {
        var listeners, events;

        events = this._events;
        if (!events)
          return this;

        // not listening for removeListener, no need to emit
        if (!events.removeListener) {
          if (arguments.length === 0) {
            this._events = new EventHandlers();
            this._eventsCount = 0;
          } else if (events[type]) {
            if (--this._eventsCount === 0)
              this._events = new EventHandlers();
            else
              delete events[type];
          }
          return this;
        }

        // emit removeListener for all listeners on all events
        if (arguments.length === 0) {
          var keys = Object.keys(events);
          for (var i = 0, key; i < keys.length; ++i) {
            key = keys[i];
            if (key === 'removeListener') continue;
            this.removeAllListeners(key);
          }
          this.removeAllListeners('removeListener');
          this._events = new EventHandlers();
          this._eventsCount = 0;
          return this;
        }

        listeners = events[type];

        if (typeof listeners === 'function') {
          this.removeListener(type, listeners);
        } else if (listeners) {
          // LIFO order
          do {
            this.removeListener(type, listeners[listeners.length - 1]);
          } while (listeners[0]);
        }

        return this;
      };

  EventEmitter.prototype.listeners = function listeners(type) {
    var evlistener;
    var ret;
    var events = this._events;

    if (!events)
      ret = [];
    else {
      evlistener = events[type];
      if (!evlistener)
        ret = [];
      else if (typeof evlistener === 'function')
        ret = [evlistener.listener || evlistener];
      else
        ret = unwrapListeners(evlistener);
    }

    return ret;
  };

  EventEmitter.listenerCount = function(emitter, type) {
    if (typeof emitter.listenerCount === 'function') {
      return emitter.listenerCount(type);
    } else {
      return listenerCount.call(emitter, type);
    }
  };

  EventEmitter.prototype.listenerCount = listenerCount;
  function listenerCount(type) {
    var events = this._events;

    if (events) {
      var evlistener = events[type];

      if (typeof evlistener === 'function') {
        return 1;
      } else if (evlistener) {
        return evlistener.length;
      }
    }

    return 0;
  }

  EventEmitter.prototype.eventNames = function eventNames() {
    return this._eventsCount > 0 ? Reflect.ownKeys(this._events) : [];
  };

  // About 1.5x faster than the two-arg version of Array#splice().
  function spliceOne(list, index) {
    for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1)
      list[i] = list[k];
    list.pop();
  }

  function arrayClone(arr, i) {
    var copy = new Array(i);
    while (i--)
      copy[i] = arr[i];
    return copy;
  }

  function unwrapListeners(arr) {
    var ret = new Array(arr.length);
    for (var i = 0; i < ret.length; ++i) {
      ret[i] = arr[i].listener || arr[i];
    }
    return ret;
  }

  var global$1 = (typeof global !== "undefined" ? global :
              typeof self !== "undefined" ? self :
              typeof window !== "undefined" ? window : {});

  var lookup = [];
  var revLookup = [];
  var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
  var inited = false;
  function init () {
    inited = true;
    var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    for (var i = 0, len = code.length; i < len; ++i) {
      lookup[i] = code[i];
      revLookup[code.charCodeAt(i)] = i;
    }

    revLookup['-'.charCodeAt(0)] = 62;
    revLookup['_'.charCodeAt(0)] = 63;
  }

  function toByteArray (b64) {
    if (!inited) {
      init();
    }
    var i, j, l, tmp, placeHolders, arr;
    var len = b64.length;

    if (len % 4 > 0) {
      throw new Error('Invalid string. Length must be a multiple of 4')
    }

    // the number of equal signs (place holders)
    // if there are two placeholders, than the two characters before it
    // represent one byte
    // if there is only one, then the three characters before it represent 2 bytes
    // this is just a cheap hack to not do indexOf twice
    placeHolders = b64[len - 2] === '=' ? 2 : b64[len - 1] === '=' ? 1 : 0;

    // base64 is 4/3 + up to two characters of the original data
    arr = new Arr(len * 3 / 4 - placeHolders);

    // if there are placeholders, only get up to the last complete 4 chars
    l = placeHolders > 0 ? len - 4 : len;

    var L = 0;

    for (i = 0, j = 0; i < l; i += 4, j += 3) {
      tmp = (revLookup[b64.charCodeAt(i)] << 18) | (revLookup[b64.charCodeAt(i + 1)] << 12) | (revLookup[b64.charCodeAt(i + 2)] << 6) | revLookup[b64.charCodeAt(i + 3)];
      arr[L++] = (tmp >> 16) & 0xFF;
      arr[L++] = (tmp >> 8) & 0xFF;
      arr[L++] = tmp & 0xFF;
    }

    if (placeHolders === 2) {
      tmp = (revLookup[b64.charCodeAt(i)] << 2) | (revLookup[b64.charCodeAt(i + 1)] >> 4);
      arr[L++] = tmp & 0xFF;
    } else if (placeHolders === 1) {
      tmp = (revLookup[b64.charCodeAt(i)] << 10) | (revLookup[b64.charCodeAt(i + 1)] << 4) | (revLookup[b64.charCodeAt(i + 2)] >> 2);
      arr[L++] = (tmp >> 8) & 0xFF;
      arr[L++] = tmp & 0xFF;
    }

    return arr
  }

  function tripletToBase64 (num) {
    return lookup[num >> 18 & 0x3F] + lookup[num >> 12 & 0x3F] + lookup[num >> 6 & 0x3F] + lookup[num & 0x3F]
  }

  function encodeChunk (uint8, start, end) {
    var tmp;
    var output = [];
    for (var i = start; i < end; i += 3) {
      tmp = (uint8[i] << 16) + (uint8[i + 1] << 8) + (uint8[i + 2]);
      output.push(tripletToBase64(tmp));
    }
    return output.join('')
  }

  function fromByteArray (uint8) {
    if (!inited) {
      init();
    }
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3; // if we have 1 byte left, pad 2 bytes
    var output = '';
    var parts = [];
    var maxChunkLength = 16383; // must be multiple of 3

    // go through the array every three bytes, we'll deal with trailing stuff later
    for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
      parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)));
    }

    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
      tmp = uint8[len - 1];
      output += lookup[tmp >> 2];
      output += lookup[(tmp << 4) & 0x3F];
      output += '==';
    } else if (extraBytes === 2) {
      tmp = (uint8[len - 2] << 8) + (uint8[len - 1]);
      output += lookup[tmp >> 10];
      output += lookup[(tmp >> 4) & 0x3F];
      output += lookup[(tmp << 2) & 0x3F];
      output += '=';
    }

    parts.push(output);

    return parts.join('')
  }

  function read (buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? (nBytes - 1) : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];

    i += d;

    e = s & ((1 << (-nBits)) - 1);
    s >>= (-nBits);
    nBits += eLen;
    for (; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8) {}

    m = e & ((1 << (-nBits)) - 1);
    e >>= (-nBits);
    nBits += mLen;
    for (; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8) {}

    if (e === 0) {
      e = 1 - eBias;
    } else if (e === eMax) {
      return m ? NaN : ((s ? -1 : 1) * Infinity)
    } else {
      m = m + Math.pow(2, mLen);
      e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
  }

  function write (buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0);
    var i = isLE ? 0 : (nBytes - 1);
    var d = isLE ? 1 : -1;
    var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0;

    value = Math.abs(value);

    if (isNaN(value) || value === Infinity) {
      m = isNaN(value) ? 1 : 0;
      e = eMax;
    } else {
      e = Math.floor(Math.log(value) / Math.LN2);
      if (value * (c = Math.pow(2, -e)) < 1) {
        e--;
        c *= 2;
      }
      if (e + eBias >= 1) {
        value += rt / c;
      } else {
        value += rt * Math.pow(2, 1 - eBias);
      }
      if (value * c >= 2) {
        e++;
        c /= 2;
      }

      if (e + eBias >= eMax) {
        m = 0;
        e = eMax;
      } else if (e + eBias >= 1) {
        m = (value * c - 1) * Math.pow(2, mLen);
        e = e + eBias;
      } else {
        m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
        e = 0;
      }
    }

    for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

    e = (e << mLen) | m;
    eLen += mLen;
    for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

    buffer[offset + i - d] |= s * 128;
  }

  var toString = {}.toString;

  var isArray = Array.isArray || function (arr) {
    return toString.call(arr) == '[object Array]';
  };

  var INSPECT_MAX_BYTES = 50;

  /**
   * If `Buffer.TYPED_ARRAY_SUPPORT`:
   *   === true    Use Uint8Array implementation (fastest)
   *   === false   Use Object implementation (most compatible, even IE6)
   *
   * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
   * Opera 11.6+, iOS 4.2+.
   *
   * Due to various browser bugs, sometimes the Object implementation will be used even
   * when the browser supports typed arrays.
   *
   * Note:
   *
   *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
   *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
   *
   *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
   *
   *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
   *     incorrect length in some situations.

   * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
   * get the Object implementation, which is slower but behaves correctly.
   */
  Buffer.TYPED_ARRAY_SUPPORT = global$1.TYPED_ARRAY_SUPPORT !== undefined
    ? global$1.TYPED_ARRAY_SUPPORT
    : true;

  function kMaxLength () {
    return Buffer.TYPED_ARRAY_SUPPORT
      ? 0x7fffffff
      : 0x3fffffff
  }

  function createBuffer (that, length) {
    if (kMaxLength() < length) {
      throw new RangeError('Invalid typed array length')
    }
    if (Buffer.TYPED_ARRAY_SUPPORT) {
      // Return an augmented `Uint8Array` instance, for best performance
      that = new Uint8Array(length);
      that.__proto__ = Buffer.prototype;
    } else {
      // Fallback: Return an object instance of the Buffer class
      if (that === null) {
        that = new Buffer(length);
      }
      that.length = length;
    }

    return that
  }

  /**
   * The Buffer constructor returns instances of `Uint8Array` that have their
   * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
   * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
   * and the `Uint8Array` methods. Square bracket notation works as expected -- it
   * returns a single octet.
   *
   * The `Uint8Array` prototype remains unmodified.
   */

  function Buffer (arg, encodingOrOffset, length) {
    if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
      return new Buffer(arg, encodingOrOffset, length)
    }

    // Common case.
    if (typeof arg === 'number') {
      if (typeof encodingOrOffset === 'string') {
        throw new Error(
          'If encoding is specified then the first argument must be a string'
        )
      }
      return allocUnsafe(this, arg)
    }
    return from(this, arg, encodingOrOffset, length)
  }

  Buffer.poolSize = 8192; // not used by this implementation

  // TODO: Legacy, not needed anymore. Remove in next major version.
  Buffer._augment = function (arr) {
    arr.__proto__ = Buffer.prototype;
    return arr
  };

  function from (that, value, encodingOrOffset, length) {
    if (typeof value === 'number') {
      throw new TypeError('"value" argument must not be a number')
    }

    if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
      return fromArrayBuffer(that, value, encodingOrOffset, length)
    }

    if (typeof value === 'string') {
      return fromString(that, value, encodingOrOffset)
    }

    return fromObject(that, value)
  }

  /**
   * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
   * if value is a number.
   * Buffer.from(str[, encoding])
   * Buffer.from(array)
   * Buffer.from(buffer)
   * Buffer.from(arrayBuffer[, byteOffset[, length]])
   **/
  Buffer.from = function (value, encodingOrOffset, length) {
    return from(null, value, encodingOrOffset, length)
  };

  if (Buffer.TYPED_ARRAY_SUPPORT) {
    Buffer.prototype.__proto__ = Uint8Array.prototype;
    Buffer.__proto__ = Uint8Array;
  }

  function assertSize (size) {
    if (typeof size !== 'number') {
      throw new TypeError('"size" argument must be a number')
    } else if (size < 0) {
      throw new RangeError('"size" argument must not be negative')
    }
  }

  function alloc (that, size, fill, encoding) {
    assertSize(size);
    if (size <= 0) {
      return createBuffer(that, size)
    }
    if (fill !== undefined) {
      // Only pay attention to encoding if it's a string. This
      // prevents accidentally sending in a number that would
      // be interpretted as a start offset.
      return typeof encoding === 'string'
        ? createBuffer(that, size).fill(fill, encoding)
        : createBuffer(that, size).fill(fill)
    }
    return createBuffer(that, size)
  }

  /**
   * Creates a new filled Buffer instance.
   * alloc(size[, fill[, encoding]])
   **/
  Buffer.alloc = function (size, fill, encoding) {
    return alloc(null, size, fill, encoding)
  };

  function allocUnsafe (that, size) {
    assertSize(size);
    that = createBuffer(that, size < 0 ? 0 : checked(size) | 0);
    if (!Buffer.TYPED_ARRAY_SUPPORT) {
      for (var i = 0; i < size; ++i) {
        that[i] = 0;
      }
    }
    return that
  }

  /**
   * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
   * */
  Buffer.allocUnsafe = function (size) {
    return allocUnsafe(null, size)
  };
  /**
   * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
   */
  Buffer.allocUnsafeSlow = function (size) {
    return allocUnsafe(null, size)
  };

  function fromString (that, string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') {
      encoding = 'utf8';
    }

    if (!Buffer.isEncoding(encoding)) {
      throw new TypeError('"encoding" must be a valid string encoding')
    }

    var length = byteLength(string, encoding) | 0;
    that = createBuffer(that, length);

    var actual = that.write(string, encoding);

    if (actual !== length) {
      // Writing a hex string, for example, that contains invalid characters will
      // cause everything after the first invalid character to be ignored. (e.g.
      // 'abxxcd' will be treated as 'ab')
      that = that.slice(0, actual);
    }

    return that
  }

  function fromArrayLike (that, array) {
    var length = array.length < 0 ? 0 : checked(array.length) | 0;
    that = createBuffer(that, length);
    for (var i = 0; i < length; i += 1) {
      that[i] = array[i] & 255;
    }
    return that
  }

  function fromArrayBuffer (that, array, byteOffset, length) {
    array.byteLength; // this throws if `array` is not a valid ArrayBuffer

    if (byteOffset < 0 || array.byteLength < byteOffset) {
      throw new RangeError('\'offset\' is out of bounds')
    }

    if (array.byteLength < byteOffset + (length || 0)) {
      throw new RangeError('\'length\' is out of bounds')
    }

    if (byteOffset === undefined && length === undefined) {
      array = new Uint8Array(array);
    } else if (length === undefined) {
      array = new Uint8Array(array, byteOffset);
    } else {
      array = new Uint8Array(array, byteOffset, length);
    }

    if (Buffer.TYPED_ARRAY_SUPPORT) {
      // Return an augmented `Uint8Array` instance, for best performance
      that = array;
      that.__proto__ = Buffer.prototype;
    } else {
      // Fallback: Return an object instance of the Buffer class
      that = fromArrayLike(that, array);
    }
    return that
  }

  function fromObject (that, obj) {
    if (internalIsBuffer(obj)) {
      var len = checked(obj.length) | 0;
      that = createBuffer(that, len);

      if (that.length === 0) {
        return that
      }

      obj.copy(that, 0, 0, len);
      return that
    }

    if (obj) {
      if ((typeof ArrayBuffer !== 'undefined' &&
          obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
        if (typeof obj.length !== 'number' || isnan(obj.length)) {
          return createBuffer(that, 0)
        }
        return fromArrayLike(that, obj)
      }

      if (obj.type === 'Buffer' && isArray(obj.data)) {
        return fromArrayLike(that, obj.data)
      }
    }

    throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
  }

  function checked (length) {
    // Note: cannot use `length < kMaxLength()` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= kMaxLength()) {
      throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                           'size: 0x' + kMaxLength().toString(16) + ' bytes')
    }
    return length | 0
  }
  Buffer.isBuffer = isBuffer;
  function internalIsBuffer (b) {
    return !!(b != null && b._isBuffer)
  }

  Buffer.compare = function compare (a, b) {
    if (!internalIsBuffer(a) || !internalIsBuffer(b)) {
      throw new TypeError('Arguments must be Buffers')
    }

    if (a === b) return 0

    var x = a.length;
    var y = b.length;

    for (var i = 0, len = Math.min(x, y); i < len; ++i) {
      if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break
      }
    }

    if (x < y) return -1
    if (y < x) return 1
    return 0
  };

  Buffer.isEncoding = function isEncoding (encoding) {
    switch (String(encoding).toLowerCase()) {
      case 'hex':
      case 'utf8':
      case 'utf-8':
      case 'ascii':
      case 'latin1':
      case 'binary':
      case 'base64':
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return true
      default:
        return false
    }
  };

  Buffer.concat = function concat (list, length) {
    if (!isArray(list)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    }

    if (list.length === 0) {
      return Buffer.alloc(0)
    }

    var i;
    if (length === undefined) {
      length = 0;
      for (i = 0; i < list.length; ++i) {
        length += list[i].length;
      }
    }

    var buffer = Buffer.allocUnsafe(length);
    var pos = 0;
    for (i = 0; i < list.length; ++i) {
      var buf = list[i];
      if (!internalIsBuffer(buf)) {
        throw new TypeError('"list" argument must be an Array of Buffers')
      }
      buf.copy(buffer, pos);
      pos += buf.length;
    }
    return buffer
  };

  function byteLength (string, encoding) {
    if (internalIsBuffer(string)) {
      return string.length
    }
    if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
        (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
      return string.byteLength
    }
    if (typeof string !== 'string') {
      string = '' + string;
    }

    var len = string.length;
    if (len === 0) return 0

    // Use a for loop to avoid recursion
    var loweredCase = false;
    for (;;) {
      switch (encoding) {
        case 'ascii':
        case 'latin1':
        case 'binary':
          return len
        case 'utf8':
        case 'utf-8':
        case undefined:
          return utf8ToBytes(string).length
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
          return len * 2
        case 'hex':
          return len >>> 1
        case 'base64':
          return base64ToBytes(string).length
        default:
          if (loweredCase) return utf8ToBytes(string).length // assume utf8
          encoding = ('' + encoding).toLowerCase();
          loweredCase = true;
      }
    }
  }
  Buffer.byteLength = byteLength;

  function slowToString (encoding, start, end) {
    var loweredCase = false;

    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.

    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) {
      start = 0;
    }
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) {
      return ''
    }

    if (end === undefined || end > this.length) {
      end = this.length;
    }

    if (end <= 0) {
      return ''
    }

    // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;

    if (end <= start) {
      return ''
    }

    if (!encoding) encoding = 'utf8';

    while (true) {
      switch (encoding) {
        case 'hex':
          return hexSlice(this, start, end)

        case 'utf8':
        case 'utf-8':
          return utf8Slice(this, start, end)

        case 'ascii':
          return asciiSlice(this, start, end)

        case 'latin1':
        case 'binary':
          return latin1Slice(this, start, end)

        case 'base64':
          return base64Slice(this, start, end)

        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
          return utf16leSlice(this, start, end)

        default:
          if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
          encoding = (encoding + '').toLowerCase();
          loweredCase = true;
      }
    }
  }

  // The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
  // Buffer instances.
  Buffer.prototype._isBuffer = true;

  function swap (b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
  }

  Buffer.prototype.swap16 = function swap16 () {
    var len = this.length;
    if (len % 2 !== 0) {
      throw new RangeError('Buffer size must be a multiple of 16-bits')
    }
    for (var i = 0; i < len; i += 2) {
      swap(this, i, i + 1);
    }
    return this
  };

  Buffer.prototype.swap32 = function swap32 () {
    var len = this.length;
    if (len % 4 !== 0) {
      throw new RangeError('Buffer size must be a multiple of 32-bits')
    }
    for (var i = 0; i < len; i += 4) {
      swap(this, i, i + 3);
      swap(this, i + 1, i + 2);
    }
    return this
  };

  Buffer.prototype.swap64 = function swap64 () {
    var len = this.length;
    if (len % 8 !== 0) {
      throw new RangeError('Buffer size must be a multiple of 64-bits')
    }
    for (var i = 0; i < len; i += 8) {
      swap(this, i, i + 7);
      swap(this, i + 1, i + 6);
      swap(this, i + 2, i + 5);
      swap(this, i + 3, i + 4);
    }
    return this
  };

  Buffer.prototype.toString = function toString () {
    var length = this.length | 0;
    if (length === 0) return ''
    if (arguments.length === 0) return utf8Slice(this, 0, length)
    return slowToString.apply(this, arguments)
  };

  Buffer.prototype.equals = function equals (b) {
    if (!internalIsBuffer(b)) throw new TypeError('Argument must be a Buffer')
    if (this === b) return true
    return Buffer.compare(this, b) === 0
  };

  Buffer.prototype.inspect = function inspect () {
    var str = '';
    var max = INSPECT_MAX_BYTES;
    if (this.length > 0) {
      str = this.toString('hex', 0, max).match(/.{2}/g).join(' ');
      if (this.length > max) str += ' ... ';
    }
    return '<Buffer ' + str + '>'
  };

  Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
    if (!internalIsBuffer(target)) {
      throw new TypeError('Argument must be a Buffer')
    }

    if (start === undefined) {
      start = 0;
    }
    if (end === undefined) {
      end = target ? target.length : 0;
    }
    if (thisStart === undefined) {
      thisStart = 0;
    }
    if (thisEnd === undefined) {
      thisEnd = this.length;
    }

    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
      throw new RangeError('out of range index')
    }

    if (thisStart >= thisEnd && start >= end) {
      return 0
    }
    if (thisStart >= thisEnd) {
      return -1
    }
    if (start >= end) {
      return 1
    }

    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;

    if (this === target) return 0

    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);

    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);

    for (var i = 0; i < len; ++i) {
      if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break
      }
    }

    if (x < y) return -1
    if (y < x) return 1
    return 0
  };

  // Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
  // OR the last index of `val` in `buffer` at offset <= `byteOffset`.
  //
  // Arguments:
  // - buffer - a Buffer to search
  // - val - a string, Buffer, or number
  // - byteOffset - an index into `buffer`; will be clamped to an int32
  // - encoding - an optional encoding, relevant is val is a string
  // - dir - true for indexOf, false for lastIndexOf
  function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1

    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
      encoding = byteOffset;
      byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) {
      byteOffset = 0x7fffffff;
    } else if (byteOffset < -0x80000000) {
      byteOffset = -0x80000000;
    }
    byteOffset = +byteOffset;  // Coerce to Number.
    if (isNaN(byteOffset)) {
      // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
      byteOffset = dir ? 0 : (buffer.length - 1);
    }

    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
      if (dir) return -1
      else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
      if (dir) byteOffset = 0;
      else return -1
    }

    // Normalize val
    if (typeof val === 'string') {
      val = Buffer.from(val, encoding);
    }

    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if (internalIsBuffer(val)) {
      // Special case: looking for empty string/buffer always fails
      if (val.length === 0) {
        return -1
      }
      return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
    } else if (typeof val === 'number') {
      val = val & 0xFF; // Search for a byte value [0-255]
      if (Buffer.TYPED_ARRAY_SUPPORT &&
          typeof Uint8Array.prototype.indexOf === 'function') {
        if (dir) {
          return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
        } else {
          return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
        }
      }
      return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
    }

    throw new TypeError('val must be string, number or Buffer')
  }

  function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;

    if (encoding !== undefined) {
      encoding = String(encoding).toLowerCase();
      if (encoding === 'ucs2' || encoding === 'ucs-2' ||
          encoding === 'utf16le' || encoding === 'utf-16le') {
        if (arr.length < 2 || val.length < 2) {
          return -1
        }
        indexSize = 2;
        arrLength /= 2;
        valLength /= 2;
        byteOffset /= 2;
      }
    }

    function read (buf, i) {
      if (indexSize === 1) {
        return buf[i]
      } else {
        return buf.readUInt16BE(i * indexSize)
      }
    }

    var i;
    if (dir) {
      var foundIndex = -1;
      for (i = byteOffset; i < arrLength; i++) {
        if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
          if (foundIndex === -1) foundIndex = i;
          if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
        } else {
          if (foundIndex !== -1) i -= i - foundIndex;
          foundIndex = -1;
        }
      }
    } else {
      if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
      for (i = byteOffset; i >= 0; i--) {
        var found = true;
        for (var j = 0; j < valLength; j++) {
          if (read(arr, i + j) !== read(val, j)) {
            found = false;
            break
          }
        }
        if (found) return i
      }
    }

    return -1
  }

  Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1
  };

  Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
    return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
  };

  Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
    return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
  };

  function hexWrite (buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) {
      length = remaining;
    } else {
      length = Number(length);
      if (length > remaining) {
        length = remaining;
      }
    }

    // must be an even number of digits
    var strLen = string.length;
    if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')

    if (length > strLen / 2) {
      length = strLen / 2;
    }
    for (var i = 0; i < length; ++i) {
      var parsed = parseInt(string.substr(i * 2, 2), 16);
      if (isNaN(parsed)) return i
      buf[offset + i] = parsed;
    }
    return i
  }

  function utf8Write (buf, string, offset, length) {
    return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
  }

  function asciiWrite (buf, string, offset, length) {
    return blitBuffer(asciiToBytes(string), buf, offset, length)
  }

  function latin1Write (buf, string, offset, length) {
    return asciiWrite(buf, string, offset, length)
  }

  function base64Write (buf, string, offset, length) {
    return blitBuffer(base64ToBytes(string), buf, offset, length)
  }

  function ucs2Write (buf, string, offset, length) {
    return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
  }

  Buffer.prototype.write = function write (string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
      encoding = 'utf8';
      length = this.length;
      offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
      encoding = offset;
      length = this.length;
      offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
      offset = offset | 0;
      if (isFinite(length)) {
        length = length | 0;
        if (encoding === undefined) encoding = 'utf8';
      } else {
        encoding = length;
        length = undefined;
      }
    // legacy write(string, encoding, offset, length) - remove in v0.13
    } else {
      throw new Error(
        'Buffer.write(string, encoding, offset[, length]) is no longer supported'
      )
    }

    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;

    if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
      throw new RangeError('Attempt to write outside buffer bounds')
    }

    if (!encoding) encoding = 'utf8';

    var loweredCase = false;
    for (;;) {
      switch (encoding) {
        case 'hex':
          return hexWrite(this, string, offset, length)

        case 'utf8':
        case 'utf-8':
          return utf8Write(this, string, offset, length)

        case 'ascii':
          return asciiWrite(this, string, offset, length)

        case 'latin1':
        case 'binary':
          return latin1Write(this, string, offset, length)

        case 'base64':
          // Warning: maxLength not taken into account in base64Write
          return base64Write(this, string, offset, length)

        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
          return ucs2Write(this, string, offset, length)

        default:
          if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
          encoding = ('' + encoding).toLowerCase();
          loweredCase = true;
      }
    }
  };

  Buffer.prototype.toJSON = function toJSON () {
    return {
      type: 'Buffer',
      data: Array.prototype.slice.call(this._arr || this, 0)
    }
  };

  function base64Slice (buf, start, end) {
    if (start === 0 && end === buf.length) {
      return fromByteArray(buf)
    } else {
      return fromByteArray(buf.slice(start, end))
    }
  }

  function utf8Slice (buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];

    var i = start;
    while (i < end) {
      var firstByte = buf[i];
      var codePoint = null;
      var bytesPerSequence = (firstByte > 0xEF) ? 4
        : (firstByte > 0xDF) ? 3
        : (firstByte > 0xBF) ? 2
        : 1;

      if (i + bytesPerSequence <= end) {
        var secondByte, thirdByte, fourthByte, tempCodePoint;

        switch (bytesPerSequence) {
          case 1:
            if (firstByte < 0x80) {
              codePoint = firstByte;
            }
            break
          case 2:
            secondByte = buf[i + 1];
            if ((secondByte & 0xC0) === 0x80) {
              tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F);
              if (tempCodePoint > 0x7F) {
                codePoint = tempCodePoint;
              }
            }
            break
          case 3:
            secondByte = buf[i + 1];
            thirdByte = buf[i + 2];
            if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
              tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F);
              if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
                codePoint = tempCodePoint;
              }
            }
            break
          case 4:
            secondByte = buf[i + 1];
            thirdByte = buf[i + 2];
            fourthByte = buf[i + 3];
            if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
              tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F);
              if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
                codePoint = tempCodePoint;
              }
            }
        }
      }

      if (codePoint === null) {
        // we did not generate a valid codePoint so insert a
        // replacement char (U+FFFD) and advance only 1 byte
        codePoint = 0xFFFD;
        bytesPerSequence = 1;
      } else if (codePoint > 0xFFFF) {
        // encode to utf16 (surrogate pair dance)
        codePoint -= 0x10000;
        res.push(codePoint >>> 10 & 0x3FF | 0xD800);
        codePoint = 0xDC00 | codePoint & 0x3FF;
      }

      res.push(codePoint);
      i += bytesPerSequence;
    }

    return decodeCodePointsArray(res)
  }

  // Based on http://stackoverflow.com/a/22747272/680742, the browser with
  // the lowest limit is Chrome, with 0x10000 args.
  // We go 1 magnitude less, for safety
  var MAX_ARGUMENTS_LENGTH = 0x1000;

  function decodeCodePointsArray (codePoints) {
    var len = codePoints.length;
    if (len <= MAX_ARGUMENTS_LENGTH) {
      return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    }

    // Decode in chunks to avoid "call stack size exceeded".
    var res = '';
    var i = 0;
    while (i < len) {
      res += String.fromCharCode.apply(
        String,
        codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
      );
    }
    return res
  }

  function asciiSlice (buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);

    for (var i = start; i < end; ++i) {
      ret += String.fromCharCode(buf[i] & 0x7F);
    }
    return ret
  }

  function latin1Slice (buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);

    for (var i = start; i < end; ++i) {
      ret += String.fromCharCode(buf[i]);
    }
    return ret
  }

  function hexSlice (buf, start, end) {
    var len = buf.length;

    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;

    var out = '';
    for (var i = start; i < end; ++i) {
      out += toHex(buf[i]);
    }
    return out
  }

  function utf16leSlice (buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = '';
    for (var i = 0; i < bytes.length; i += 2) {
      res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    }
    return res
  }

  Buffer.prototype.slice = function slice (start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;

    if (start < 0) {
      start += len;
      if (start < 0) start = 0;
    } else if (start > len) {
      start = len;
    }

    if (end < 0) {
      end += len;
      if (end < 0) end = 0;
    } else if (end > len) {
      end = len;
    }

    if (end < start) end = start;

    var newBuf;
    if (Buffer.TYPED_ARRAY_SUPPORT) {
      newBuf = this.subarray(start, end);
      newBuf.__proto__ = Buffer.prototype;
    } else {
      var sliceLen = end - start;
      newBuf = new Buffer(sliceLen, undefined);
      for (var i = 0; i < sliceLen; ++i) {
        newBuf[i] = this[i + start];
      }
    }

    return newBuf
  };

  /*
   * Need to make sure that buffer isn't trying to write out of bounds.
   */
  function checkOffset (offset, ext, length) {
    if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
  }

  Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);

    var val = this[offset];
    var mul = 1;
    var i = 0;
    while (++i < byteLength && (mul *= 0x100)) {
      val += this[offset + i] * mul;
    }

    return val
  };

  Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) {
      checkOffset(offset, byteLength, this.length);
    }

    var val = this[offset + --byteLength];
    var mul = 1;
    while (byteLength > 0 && (mul *= 0x100)) {
      val += this[offset + --byteLength] * mul;
    }

    return val
  };

  Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
    if (!noAssert) checkOffset(offset, 1, this.length);
    return this[offset]
  };

  Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
    if (!noAssert) checkOffset(offset, 2, this.length);
    return this[offset] | (this[offset + 1] << 8)
  };

  Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
    if (!noAssert) checkOffset(offset, 2, this.length);
    return (this[offset] << 8) | this[offset + 1]
  };

  Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
    if (!noAssert) checkOffset(offset, 4, this.length);

    return ((this[offset]) |
        (this[offset + 1] << 8) |
        (this[offset + 2] << 16)) +
        (this[offset + 3] * 0x1000000)
  };

  Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
    if (!noAssert) checkOffset(offset, 4, this.length);

    return (this[offset] * 0x1000000) +
      ((this[offset + 1] << 16) |
      (this[offset + 2] << 8) |
      this[offset + 3])
  };

  Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);

    var val = this[offset];
    var mul = 1;
    var i = 0;
    while (++i < byteLength && (mul *= 0x100)) {
      val += this[offset + i] * mul;
    }
    mul *= 0x80;

    if (val >= mul) val -= Math.pow(2, 8 * byteLength);

    return val
  };

  Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);

    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while (i > 0 && (mul *= 0x100)) {
      val += this[offset + --i] * mul;
    }
    mul *= 0x80;

    if (val >= mul) val -= Math.pow(2, 8 * byteLength);

    return val
  };

  Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
    if (!noAssert) checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return (this[offset])
    return ((0xff - this[offset] + 1) * -1)
  };

  Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
    if (!noAssert) checkOffset(offset, 2, this.length);
    var val = this[offset] | (this[offset + 1] << 8);
    return (val & 0x8000) ? val | 0xFFFF0000 : val
  };

  Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
    if (!noAssert) checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | (this[offset] << 8);
    return (val & 0x8000) ? val | 0xFFFF0000 : val
  };

  Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
    if (!noAssert) checkOffset(offset, 4, this.length);

    return (this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16) |
      (this[offset + 3] << 24)
  };

  Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
    if (!noAssert) checkOffset(offset, 4, this.length);

    return (this[offset] << 24) |
      (this[offset + 1] << 16) |
      (this[offset + 2] << 8) |
      (this[offset + 3])
  };

  Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
    if (!noAssert) checkOffset(offset, 4, this.length);
    return read(this, offset, true, 23, 4)
  };

  Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
    if (!noAssert) checkOffset(offset, 4, this.length);
    return read(this, offset, false, 23, 4)
  };

  Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
    if (!noAssert) checkOffset(offset, 8, this.length);
    return read(this, offset, true, 52, 8)
  };

  Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
    if (!noAssert) checkOffset(offset, 8, this.length);
    return read(this, offset, false, 52, 8)
  };

  function checkInt (buf, value, offset, ext, max, min) {
    if (!internalIsBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
    if (offset + ext > buf.length) throw new RangeError('Index out of range')
  }

  Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) {
      var maxBytes = Math.pow(2, 8 * byteLength) - 1;
      checkInt(this, value, offset, byteLength, maxBytes, 0);
    }

    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while (++i < byteLength && (mul *= 0x100)) {
      this[offset + i] = (value / mul) & 0xFF;
    }

    return offset + byteLength
  };

  Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) {
      var maxBytes = Math.pow(2, 8 * byteLength) - 1;
      checkInt(this, value, offset, byteLength, maxBytes, 0);
    }

    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while (--i >= 0 && (mul *= 0x100)) {
      this[offset + i] = (value / mul) & 0xFF;
    }

    return offset + byteLength
  };

  Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0);
    if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value);
    this[offset] = (value & 0xff);
    return offset + 1
  };

  function objectWriteUInt16 (buf, value, offset, littleEndian) {
    if (value < 0) value = 0xffff + value + 1;
    for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
      buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
        (littleEndian ? i : 1 - i) * 8;
    }
  }

  Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
    if (Buffer.TYPED_ARRAY_SUPPORT) {
      this[offset] = (value & 0xff);
      this[offset + 1] = (value >>> 8);
    } else {
      objectWriteUInt16(this, value, offset, true);
    }
    return offset + 2
  };

  Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
    if (Buffer.TYPED_ARRAY_SUPPORT) {
      this[offset] = (value >>> 8);
      this[offset + 1] = (value & 0xff);
    } else {
      objectWriteUInt16(this, value, offset, false);
    }
    return offset + 2
  };

  function objectWriteUInt32 (buf, value, offset, littleEndian) {
    if (value < 0) value = 0xffffffff + value + 1;
    for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
      buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff;
    }
  }

  Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
    if (Buffer.TYPED_ARRAY_SUPPORT) {
      this[offset + 3] = (value >>> 24);
      this[offset + 2] = (value >>> 16);
      this[offset + 1] = (value >>> 8);
      this[offset] = (value & 0xff);
    } else {
      objectWriteUInt32(this, value, offset, true);
    }
    return offset + 4
  };

  Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
    if (Buffer.TYPED_ARRAY_SUPPORT) {
      this[offset] = (value >>> 24);
      this[offset + 1] = (value >>> 16);
      this[offset + 2] = (value >>> 8);
      this[offset + 3] = (value & 0xff);
    } else {
      objectWriteUInt32(this, value, offset, false);
    }
    return offset + 4
  };

  Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) {
      var limit = Math.pow(2, 8 * byteLength - 1);

      checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }

    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while (++i < byteLength && (mul *= 0x100)) {
      if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
        sub = 1;
      }
      this[offset + i] = ((value / mul) >> 0) - sub & 0xFF;
    }

    return offset + byteLength
  };

  Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) {
      var limit = Math.pow(2, 8 * byteLength - 1);

      checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }

    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while (--i >= 0 && (mul *= 0x100)) {
      if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
        sub = 1;
      }
      this[offset + i] = ((value / mul) >> 0) - sub & 0xFF;
    }

    return offset + byteLength
  };

  Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80);
    if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = (value & 0xff);
    return offset + 1
  };

  Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000);
    if (Buffer.TYPED_ARRAY_SUPPORT) {
      this[offset] = (value & 0xff);
      this[offset + 1] = (value >>> 8);
    } else {
      objectWriteUInt16(this, value, offset, true);
    }
    return offset + 2
  };

  Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000);
    if (Buffer.TYPED_ARRAY_SUPPORT) {
      this[offset] = (value >>> 8);
      this[offset + 1] = (value & 0xff);
    } else {
      objectWriteUInt16(this, value, offset, false);
    }
    return offset + 2
  };

  Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000);
    if (Buffer.TYPED_ARRAY_SUPPORT) {
      this[offset] = (value & 0xff);
      this[offset + 1] = (value >>> 8);
      this[offset + 2] = (value >>> 16);
      this[offset + 3] = (value >>> 24);
    } else {
      objectWriteUInt32(this, value, offset, true);
    }
    return offset + 4
  };

  Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000);
    if (value < 0) value = 0xffffffff + value + 1;
    if (Buffer.TYPED_ARRAY_SUPPORT) {
      this[offset] = (value >>> 24);
      this[offset + 1] = (value >>> 16);
      this[offset + 2] = (value >>> 8);
      this[offset + 3] = (value & 0xff);
    } else {
      objectWriteUInt32(this, value, offset, false);
    }
    return offset + 4
  };

  function checkIEEE754 (buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range')
    if (offset < 0) throw new RangeError('Index out of range')
  }

  function writeFloat (buf, value, offset, littleEndian, noAssert) {
    if (!noAssert) {
      checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38);
    }
    write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4
  }

  Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
    return writeFloat(this, value, offset, true, noAssert)
  };

  Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
    return writeFloat(this, value, offset, false, noAssert)
  };

  function writeDouble (buf, value, offset, littleEndian, noAssert) {
    if (!noAssert) {
      checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308);
    }
    write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8
  }

  Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
    return writeDouble(this, value, offset, true, noAssert)
  };

  Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
    return writeDouble(this, value, offset, false, noAssert)
  };

  // copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
  Buffer.prototype.copy = function copy (target, targetStart, start, end) {
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;

    // Copy 0 bytes; we're done
    if (end === start) return 0
    if (target.length === 0 || this.length === 0) return 0

    // Fatal error conditions
    if (targetStart < 0) {
      throw new RangeError('targetStart out of bounds')
    }
    if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
    if (end < 0) throw new RangeError('sourceEnd out of bounds')

    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) {
      end = target.length - targetStart + start;
    }

    var len = end - start;
    var i;

    if (this === target && start < targetStart && targetStart < end) {
      // descending copy from end
      for (i = len - 1; i >= 0; --i) {
        target[i + targetStart] = this[i + start];
      }
    } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
      // ascending copy from start
      for (i = 0; i < len; ++i) {
        target[i + targetStart] = this[i + start];
      }
    } else {
      Uint8Array.prototype.set.call(
        target,
        this.subarray(start, start + len),
        targetStart
      );
    }

    return len
  };

  // Usage:
  //    buffer.fill(number[, offset[, end]])
  //    buffer.fill(buffer[, offset[, end]])
  //    buffer.fill(string[, offset[, end]][, encoding])
  Buffer.prototype.fill = function fill (val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
      if (typeof start === 'string') {
        encoding = start;
        start = 0;
        end = this.length;
      } else if (typeof end === 'string') {
        encoding = end;
        end = this.length;
      }
      if (val.length === 1) {
        var code = val.charCodeAt(0);
        if (code < 256) {
          val = code;
        }
      }
      if (encoding !== undefined && typeof encoding !== 'string') {
        throw new TypeError('encoding must be a string')
      }
      if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
        throw new TypeError('Unknown encoding: ' + encoding)
      }
    } else if (typeof val === 'number') {
      val = val & 255;
    }

    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) {
      throw new RangeError('Out of range index')
    }

    if (end <= start) {
      return this
    }

    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;

    if (!val) val = 0;

    var i;
    if (typeof val === 'number') {
      for (i = start; i < end; ++i) {
        this[i] = val;
      }
    } else {
      var bytes = internalIsBuffer(val)
        ? val
        : utf8ToBytes(new Buffer(val, encoding).toString());
      var len = bytes.length;
      for (i = 0; i < end - start; ++i) {
        this[i + start] = bytes[i % len];
      }
    }

    return this
  };

  // HELPER FUNCTIONS
  // ================

  var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g;

  function base64clean (str) {
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = stringtrim(str).replace(INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return ''
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while (str.length % 4 !== 0) {
      str = str + '=';
    }
    return str
  }

  function stringtrim (str) {
    if (str.trim) return str.trim()
    return str.replace(/^\s+|\s+$/g, '')
  }

  function toHex (n) {
    if (n < 16) return '0' + n.toString(16)
    return n.toString(16)
  }

  function utf8ToBytes (string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];

    for (var i = 0; i < length; ++i) {
      codePoint = string.charCodeAt(i);

      // is surrogate component
      if (codePoint > 0xD7FF && codePoint < 0xE000) {
        // last char was a lead
        if (!leadSurrogate) {
          // no lead yet
          if (codePoint > 0xDBFF) {
            // unexpected trail
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
            continue
          } else if (i + 1 === length) {
            // unpaired lead
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
            continue
          }

          // valid lead
          leadSurrogate = codePoint;

          continue
        }

        // 2 leads in a row
        if (codePoint < 0xDC00) {
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
          leadSurrogate = codePoint;
          continue
        }

        // valid surrogate pair
        codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
      } else if (leadSurrogate) {
        // valid bmp char, but last char was a lead
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
      }

      leadSurrogate = null;

      // encode utf8
      if (codePoint < 0x80) {
        if ((units -= 1) < 0) break
        bytes.push(codePoint);
      } else if (codePoint < 0x800) {
        if ((units -= 2) < 0) break
        bytes.push(
          codePoint >> 0x6 | 0xC0,
          codePoint & 0x3F | 0x80
        );
      } else if (codePoint < 0x10000) {
        if ((units -= 3) < 0) break
        bytes.push(
          codePoint >> 0xC | 0xE0,
          codePoint >> 0x6 & 0x3F | 0x80,
          codePoint & 0x3F | 0x80
        );
      } else if (codePoint < 0x110000) {
        if ((units -= 4) < 0) break
        bytes.push(
          codePoint >> 0x12 | 0xF0,
          codePoint >> 0xC & 0x3F | 0x80,
          codePoint >> 0x6 & 0x3F | 0x80,
          codePoint & 0x3F | 0x80
        );
      } else {
        throw new Error('Invalid code point')
      }
    }

    return bytes
  }

  function asciiToBytes (str) {
    var byteArray = [];
    for (var i = 0; i < str.length; ++i) {
      // Node's code seems to be doing this and not & 0x7F..
      byteArray.push(str.charCodeAt(i) & 0xFF);
    }
    return byteArray
  }

  function utf16leToBytes (str, units) {
    var c, hi, lo;
    var byteArray = [];
    for (var i = 0; i < str.length; ++i) {
      if ((units -= 2) < 0) break

      c = str.charCodeAt(i);
      hi = c >> 8;
      lo = c % 256;
      byteArray.push(lo);
      byteArray.push(hi);
    }

    return byteArray
  }


  function base64ToBytes (str) {
    return toByteArray(base64clean(str))
  }

  function blitBuffer (src, dst, offset, length) {
    for (var i = 0; i < length; ++i) {
      if ((i + offset >= dst.length) || (i >= src.length)) break
      dst[i + offset] = src[i];
    }
    return i
  }

  function isnan (val) {
    return val !== val // eslint-disable-line no-self-compare
  }


  // the following is from is-buffer, also by Feross Aboukhadijeh and with same lisence
  // The _isBuffer check is for Safari 5-7 support, because it's missing
  // Object.prototype.constructor. Remove this eventually
  function isBuffer(obj) {
    return obj != null && (!!obj._isBuffer || isFastBuffer(obj) || isSlowBuffer(obj))
  }

  function isFastBuffer (obj) {
    return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
  }

  // For Node v0.10 support. Remove this eventually.
  function isSlowBuffer (obj) {
    return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isFastBuffer(obj.slice(0, 0))
  }

  // shim for using process in browser
  // based off https://github.com/defunctzombie/node-process/blob/master/browser.js

  function defaultSetTimout() {
      throw new Error('setTimeout has not been defined');
  }
  function defaultClearTimeout () {
      throw new Error('clearTimeout has not been defined');
  }
  var cachedSetTimeout = defaultSetTimout;
  var cachedClearTimeout = defaultClearTimeout;
  if (typeof global$1.setTimeout === 'function') {
      cachedSetTimeout = setTimeout;
  }
  if (typeof global$1.clearTimeout === 'function') {
      cachedClearTimeout = clearTimeout;
  }

  function runTimeout(fun) {
      if (cachedSetTimeout === setTimeout) {
          //normal enviroments in sane situations
          return setTimeout(fun, 0);
      }
      // if setTimeout wasn't available but was latter defined
      if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
          cachedSetTimeout = setTimeout;
          return setTimeout(fun, 0);
      }
      try {
          // when when somebody has screwed with setTimeout but no I.E. maddness
          return cachedSetTimeout(fun, 0);
      } catch(e){
          try {
              // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
              return cachedSetTimeout.call(null, fun, 0);
          } catch(e){
              // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
              return cachedSetTimeout.call(this, fun, 0);
          }
      }


  }
  function runClearTimeout(marker) {
      if (cachedClearTimeout === clearTimeout) {
          //normal enviroments in sane situations
          return clearTimeout(marker);
      }
      // if clearTimeout wasn't available but was latter defined
      if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
          cachedClearTimeout = clearTimeout;
          return clearTimeout(marker);
      }
      try {
          // when when somebody has screwed with setTimeout but no I.E. maddness
          return cachedClearTimeout(marker);
      } catch (e){
          try {
              // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
              return cachedClearTimeout.call(null, marker);
          } catch (e){
              // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
              // Some versions of I.E. have different rules for clearTimeout vs setTimeout
              return cachedClearTimeout.call(this, marker);
          }
      }



  }
  var queue = [];
  var draining = false;
  var currentQueue;
  var queueIndex = -1;

  function cleanUpNextTick() {
      if (!draining || !currentQueue) {
          return;
      }
      draining = false;
      if (currentQueue.length) {
          queue = currentQueue.concat(queue);
      } else {
          queueIndex = -1;
      }
      if (queue.length) {
          drainQueue();
      }
  }

  function drainQueue() {
      if (draining) {
          return;
      }
      var timeout = runTimeout(cleanUpNextTick);
      draining = true;

      var len = queue.length;
      while(len) {
          currentQueue = queue;
          queue = [];
          while (++queueIndex < len) {
              if (currentQueue) {
                  currentQueue[queueIndex].run();
              }
          }
          queueIndex = -1;
          len = queue.length;
      }
      currentQueue = null;
      draining = false;
      runClearTimeout(timeout);
  }
  function nextTick(fun) {
      var args = new Array(arguments.length - 1);
      if (arguments.length > 1) {
          for (var i = 1; i < arguments.length; i++) {
              args[i - 1] = arguments[i];
          }
      }
      queue.push(new Item(fun, args));
      if (queue.length === 1 && !draining) {
          runTimeout(drainQueue);
      }
  }
  // v8 likes predictible objects
  function Item(fun, array) {
      this.fun = fun;
      this.array = array;
  }
  Item.prototype.run = function () {
      this.fun.apply(null, this.array);
  };
  var title = 'browser';
  var platform = 'browser';
  var browser = true;
  var env = {};
  var argv = [];
  var version = ''; // empty string to avoid regexp issues
  var versions = {};
  var release = {};
  var config = {};

  function noop() {}

  var on = noop;
  var addListener = noop;
  var once = noop;
  var off = noop;
  var removeListener = noop;
  var removeAllListeners = noop;
  var emit = noop;

  function binding(name) {
      throw new Error('process.binding is not supported');
  }

  function cwd () { return '/' }
  function chdir (dir) {
      throw new Error('process.chdir is not supported');
  }function umask() { return 0; }

  // from https://github.com/kumavis/browser-process-hrtime/blob/master/index.js
  var performance = global$1.performance || {};
  var performanceNow =
    performance.now        ||
    performance.mozNow     ||
    performance.msNow      ||
    performance.oNow       ||
    performance.webkitNow  ||
    function(){ return (new Date()).getTime() };

  // generate timestamp or delta
  // see http://nodejs.org/api/process.html#process_process_hrtime
  function hrtime(previousTimestamp){
    var clocktime = performanceNow.call(performance)*1e-3;
    var seconds = Math.floor(clocktime);
    var nanoseconds = Math.floor((clocktime%1)*1e9);
    if (previousTimestamp) {
      seconds = seconds - previousTimestamp[0];
      nanoseconds = nanoseconds - previousTimestamp[1];
      if (nanoseconds<0) {
        seconds--;
        nanoseconds += 1e9;
      }
    }
    return [seconds,nanoseconds]
  }

  var startTime = new Date();
  function uptime() {
    var currentTime = new Date();
    var dif = currentTime - startTime;
    return dif / 1000;
  }

  var process = {
    nextTick: nextTick,
    title: title,
    browser: browser,
    env: env,
    argv: argv,
    version: version,
    versions: versions,
    on: on,
    addListener: addListener,
    once: once,
    off: off,
    removeListener: removeListener,
    removeAllListeners: removeAllListeners,
    emit: emit,
    binding: binding,
    cwd: cwd,
    chdir: chdir,
    umask: umask,
    hrtime: hrtime,
    platform: platform,
    release: release,
    config: config,
    uptime: uptime
  };

  var inherits;
  if (typeof Object.create === 'function'){
    inherits = function inherits(ctor, superCtor) {
      // implementation from standard node.js 'util' module
      ctor.super_ = superCtor;
      ctor.prototype = Object.create(superCtor.prototype, {
        constructor: {
          value: ctor,
          enumerable: false,
          writable: true,
          configurable: true
        }
      });
    };
  } else {
    inherits = function inherits(ctor, superCtor) {
      ctor.super_ = superCtor;
      var TempCtor = function () {};
      TempCtor.prototype = superCtor.prototype;
      ctor.prototype = new TempCtor();
      ctor.prototype.constructor = ctor;
    };
  }
  var inherits$1 = inherits;

  var formatRegExp = /%[sdj%]/g;
  function format(f) {
    if (!isString(f)) {
      var objects = [];
      for (var i = 0; i < arguments.length; i++) {
        objects.push(inspect(arguments[i]));
      }
      return objects.join(' ');
    }

    var i = 1;
    var args = arguments;
    var len = args.length;
    var str = String(f).replace(formatRegExp, function(x) {
      if (x === '%%') return '%';
      if (i >= len) return x;
      switch (x) {
        case '%s': return String(args[i++]);
        case '%d': return Number(args[i++]);
        case '%j':
          try {
            return JSON.stringify(args[i++]);
          } catch (_) {
            return '[Circular]';
          }
        default:
          return x;
      }
    });
    for (var x = args[i]; i < len; x = args[++i]) {
      if (isNull(x) || !isObject(x)) {
        str += ' ' + x;
      } else {
        str += ' ' + inspect(x);
      }
    }
    return str;
  }

  // Mark that a method should not be used.
  // Returns a modified function which warns once by default.
  // If --no-deprecation is set, then it is a no-op.
  function deprecate(fn, msg) {
    // Allow for deprecating things in the process of starting up.
    if (isUndefined(global$1.process)) {
      return function() {
        return deprecate(fn, msg).apply(this, arguments);
      };
    }

    var warned = false;
    function deprecated() {
      if (!warned) {
        {
          console.error(msg);
        }
        warned = true;
      }
      return fn.apply(this, arguments);
    }

    return deprecated;
  }

  var debugs = {};
  var debugEnviron;
  function debuglog(set) {
    if (isUndefined(debugEnviron))
      debugEnviron = process.env.NODE_DEBUG || '';
    set = set.toUpperCase();
    if (!debugs[set]) {
      if (new RegExp('\\b' + set + '\\b', 'i').test(debugEnviron)) {
        var pid = 0;
        debugs[set] = function() {
          var msg = format.apply(null, arguments);
          console.error('%s %d: %s', set, pid, msg);
        };
      } else {
        debugs[set] = function() {};
      }
    }
    return debugs[set];
  }

  /**
   * Echos the value of a value. Trys to print the value out
   * in the best way possible given the different types.
   *
   * @param {Object} obj The object to print out.
   * @param {Object} opts Optional options object that alters the output.
   */
  /* legacy: obj, showHidden, depth, colors*/
  function inspect(obj, opts) {
    // default options
    var ctx = {
      seen: [],
      stylize: stylizeNoColor
    };
    // legacy...
    if (arguments.length >= 3) ctx.depth = arguments[2];
    if (arguments.length >= 4) ctx.colors = arguments[3];
    if (isBoolean(opts)) {
      // legacy...
      ctx.showHidden = opts;
    } else if (opts) {
      // got an "options" object
      _extend(ctx, opts);
    }
    // set default options
    if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
    if (isUndefined(ctx.depth)) ctx.depth = 2;
    if (isUndefined(ctx.colors)) ctx.colors = false;
    if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
    if (ctx.colors) ctx.stylize = stylizeWithColor;
    return formatValue(ctx, obj, ctx.depth);
  }

  // http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
  inspect.colors = {
    'bold' : [1, 22],
    'italic' : [3, 23],
    'underline' : [4, 24],
    'inverse' : [7, 27],
    'white' : [37, 39],
    'grey' : [90, 39],
    'black' : [30, 39],
    'blue' : [34, 39],
    'cyan' : [36, 39],
    'green' : [32, 39],
    'magenta' : [35, 39],
    'red' : [31, 39],
    'yellow' : [33, 39]
  };

  // Don't use 'blue' not visible on cmd.exe
  inspect.styles = {
    'special': 'cyan',
    'number': 'yellow',
    'boolean': 'yellow',
    'undefined': 'grey',
    'null': 'bold',
    'string': 'green',
    'date': 'magenta',
    // "name": intentionally not styling
    'regexp': 'red'
  };


  function stylizeWithColor(str, styleType) {
    var style = inspect.styles[styleType];

    if (style) {
      return '\u001b[' + inspect.colors[style][0] + 'm' + str +
             '\u001b[' + inspect.colors[style][1] + 'm';
    } else {
      return str;
    }
  }


  function stylizeNoColor(str, styleType) {
    return str;
  }


  function arrayToHash(array) {
    var hash = {};

    array.forEach(function(val, idx) {
      hash[val] = true;
    });

    return hash;
  }


  function formatValue(ctx, value, recurseTimes) {
    // Provide a hook for user-specified inspect functions.
    // Check that value is an object with an inspect function on it
    if (ctx.customInspect &&
        value &&
        isFunction(value.inspect) &&
        // Filter out the util module, it's inspect function is special
        value.inspect !== inspect &&
        // Also filter out any prototype objects using the circular check.
        !(value.constructor && value.constructor.prototype === value)) {
      var ret = value.inspect(recurseTimes, ctx);
      if (!isString(ret)) {
        ret = formatValue(ctx, ret, recurseTimes);
      }
      return ret;
    }

    // Primitive types cannot have properties
    var primitive = formatPrimitive(ctx, value);
    if (primitive) {
      return primitive;
    }

    // Look up the keys of the object.
    var keys = Object.keys(value);
    var visibleKeys = arrayToHash(keys);

    if (ctx.showHidden) {
      keys = Object.getOwnPropertyNames(value);
    }

    // IE doesn't make error fields non-enumerable
    // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
    if (isError(value)
        && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
      return formatError(value);
    }

    // Some type of object without properties can be shortcutted.
    if (keys.length === 0) {
      if (isFunction(value)) {
        var name = value.name ? ': ' + value.name : '';
        return ctx.stylize('[Function' + name + ']', 'special');
      }
      if (isRegExp(value)) {
        return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
      }
      if (isDate(value)) {
        return ctx.stylize(Date.prototype.toString.call(value), 'date');
      }
      if (isError(value)) {
        return formatError(value);
      }
    }

    var base = '', array = false, braces = ['{', '}'];

    // Make Array say that they are Array
    if (isArray$1(value)) {
      array = true;
      braces = ['[', ']'];
    }

    // Make functions say that they are functions
    if (isFunction(value)) {
      var n = value.name ? ': ' + value.name : '';
      base = ' [Function' + n + ']';
    }

    // Make RegExps say that they are RegExps
    if (isRegExp(value)) {
      base = ' ' + RegExp.prototype.toString.call(value);
    }

    // Make dates with properties first say the date
    if (isDate(value)) {
      base = ' ' + Date.prototype.toUTCString.call(value);
    }

    // Make error with message first say the error
    if (isError(value)) {
      base = ' ' + formatError(value);
    }

    if (keys.length === 0 && (!array || value.length == 0)) {
      return braces[0] + base + braces[1];
    }

    if (recurseTimes < 0) {
      if (isRegExp(value)) {
        return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
      } else {
        return ctx.stylize('[Object]', 'special');
      }
    }

    ctx.seen.push(value);

    var output;
    if (array) {
      output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
    } else {
      output = keys.map(function(key) {
        return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
      });
    }

    ctx.seen.pop();

    return reduceToSingleString(output, base, braces);
  }


  function formatPrimitive(ctx, value) {
    if (isUndefined(value))
      return ctx.stylize('undefined', 'undefined');
    if (isString(value)) {
      var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '')
                                               .replace(/'/g, "\\'")
                                               .replace(/\\"/g, '"') + '\'';
      return ctx.stylize(simple, 'string');
    }
    if (isNumber(value))
      return ctx.stylize('' + value, 'number');
    if (isBoolean(value))
      return ctx.stylize('' + value, 'boolean');
    // For some reason typeof null is "object", so special case here.
    if (isNull(value))
      return ctx.stylize('null', 'null');
  }


  function formatError(value) {
    return '[' + Error.prototype.toString.call(value) + ']';
  }


  function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
    var output = [];
    for (var i = 0, l = value.length; i < l; ++i) {
      if (hasOwnProperty(value, String(i))) {
        output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
            String(i), true));
      } else {
        output.push('');
      }
    }
    keys.forEach(function(key) {
      if (!key.match(/^\d+$/)) {
        output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
            key, true));
      }
    });
    return output;
  }


  function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
    var name, str, desc;
    desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
    if (desc.get) {
      if (desc.set) {
        str = ctx.stylize('[Getter/Setter]', 'special');
      } else {
        str = ctx.stylize('[Getter]', 'special');
      }
    } else {
      if (desc.set) {
        str = ctx.stylize('[Setter]', 'special');
      }
    }
    if (!hasOwnProperty(visibleKeys, key)) {
      name = '[' + key + ']';
    }
    if (!str) {
      if (ctx.seen.indexOf(desc.value) < 0) {
        if (isNull(recurseTimes)) {
          str = formatValue(ctx, desc.value, null);
        } else {
          str = formatValue(ctx, desc.value, recurseTimes - 1);
        }
        if (str.indexOf('\n') > -1) {
          if (array) {
            str = str.split('\n').map(function(line) {
              return '  ' + line;
            }).join('\n').substr(2);
          } else {
            str = '\n' + str.split('\n').map(function(line) {
              return '   ' + line;
            }).join('\n');
          }
        }
      } else {
        str = ctx.stylize('[Circular]', 'special');
      }
    }
    if (isUndefined(name)) {
      if (array && key.match(/^\d+$/)) {
        return str;
      }
      name = JSON.stringify('' + key);
      if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
        name = name.substr(1, name.length - 2);
        name = ctx.stylize(name, 'name');
      } else {
        name = name.replace(/'/g, "\\'")
                   .replace(/\\"/g, '"')
                   .replace(/(^"|"$)/g, "'");
        name = ctx.stylize(name, 'string');
      }
    }

    return name + ': ' + str;
  }


  function reduceToSingleString(output, base, braces) {
    var length = output.reduce(function(prev, cur) {
      if (cur.indexOf('\n') >= 0) ;
      return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
    }, 0);

    if (length > 60) {
      return braces[0] +
             (base === '' ? '' : base + '\n ') +
             ' ' +
             output.join(',\n  ') +
             ' ' +
             braces[1];
    }

    return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
  }


  // NOTE: These type checking functions intentionally don't use `instanceof`
  // because it is fragile and can be easily faked with `Object.create()`.
  function isArray$1(ar) {
    return Array.isArray(ar);
  }

  function isBoolean(arg) {
    return typeof arg === 'boolean';
  }

  function isNull(arg) {
    return arg === null;
  }

  function isNumber(arg) {
    return typeof arg === 'number';
  }

  function isString(arg) {
    return typeof arg === 'string';
  }

  function isUndefined(arg) {
    return arg === void 0;
  }

  function isRegExp(re) {
    return isObject(re) && objectToString(re) === '[object RegExp]';
  }

  function isObject(arg) {
    return typeof arg === 'object' && arg !== null;
  }

  function isDate(d) {
    return isObject(d) && objectToString(d) === '[object Date]';
  }

  function isError(e) {
    return isObject(e) &&
        (objectToString(e) === '[object Error]' || e instanceof Error);
  }

  function isFunction(arg) {
    return typeof arg === 'function';
  }

  function objectToString(o) {
    return Object.prototype.toString.call(o);
  }

  function _extend(origin, add) {
    // Don't do anything if add isn't an object
    if (!add || !isObject(add)) return origin;

    var keys = Object.keys(add);
    var i = keys.length;
    while (i--) {
      origin[keys[i]] = add[keys[i]];
    }
    return origin;
  }
  function hasOwnProperty(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
  }

  function BufferList() {
    this.head = null;
    this.tail = null;
    this.length = 0;
  }

  BufferList.prototype.push = function (v) {
    var entry = { data: v, next: null };
    if (this.length > 0) this.tail.next = entry;else this.head = entry;
    this.tail = entry;
    ++this.length;
  };

  BufferList.prototype.unshift = function (v) {
    var entry = { data: v, next: this.head };
    if (this.length === 0) this.tail = entry;
    this.head = entry;
    ++this.length;
  };

  BufferList.prototype.shift = function () {
    if (this.length === 0) return;
    var ret = this.head.data;
    if (this.length === 1) this.head = this.tail = null;else this.head = this.head.next;
    --this.length;
    return ret;
  };

  BufferList.prototype.clear = function () {
    this.head = this.tail = null;
    this.length = 0;
  };

  BufferList.prototype.join = function (s) {
    if (this.length === 0) return '';
    var p = this.head;
    var ret = '' + p.data;
    while (p = p.next) {
      ret += s + p.data;
    }return ret;
  };

  BufferList.prototype.concat = function (n) {
    if (this.length === 0) return Buffer.alloc(0);
    if (this.length === 1) return this.head.data;
    var ret = Buffer.allocUnsafe(n >>> 0);
    var p = this.head;
    var i = 0;
    while (p) {
      p.data.copy(ret, i);
      i += p.data.length;
      p = p.next;
    }
    return ret;
  };

  // Copyright Joyent, Inc. and other Node contributors.
  var isBufferEncoding = Buffer.isEncoding
    || function(encoding) {
         switch (encoding && encoding.toLowerCase()) {
           case 'hex': case 'utf8': case 'utf-8': case 'ascii': case 'binary': case 'base64': case 'ucs2': case 'ucs-2': case 'utf16le': case 'utf-16le': case 'raw': return true;
           default: return false;
         }
       };


  function assertEncoding(encoding) {
    if (encoding && !isBufferEncoding(encoding)) {
      throw new Error('Unknown encoding: ' + encoding);
    }
  }

  // StringDecoder provides an interface for efficiently splitting a series of
  // buffers into a series of JS strings without breaking apart multi-byte
  // characters. CESU-8 is handled as part of the UTF-8 encoding.
  //
  // @TODO Handling all encodings inside a single object makes it very difficult
  // to reason about this code, so it should be split up in the future.
  // @TODO There should be a utf8-strict encoding that rejects invalid UTF-8 code
  // points as used by CESU-8.
  function StringDecoder(encoding) {
    this.encoding = (encoding || 'utf8').toLowerCase().replace(/[-_]/, '');
    assertEncoding(encoding);
    switch (this.encoding) {
      case 'utf8':
        // CESU-8 represents each of Surrogate Pair by 3-bytes
        this.surrogateSize = 3;
        break;
      case 'ucs2':
      case 'utf16le':
        // UTF-16 represents each of Surrogate Pair by 2-bytes
        this.surrogateSize = 2;
        this.detectIncompleteChar = utf16DetectIncompleteChar;
        break;
      case 'base64':
        // Base-64 stores 3 bytes in 4 chars, and pads the remainder.
        this.surrogateSize = 3;
        this.detectIncompleteChar = base64DetectIncompleteChar;
        break;
      default:
        this.write = passThroughWrite;
        return;
    }

    // Enough space to store all bytes of a single character. UTF-8 needs 4
    // bytes, but CESU-8 may require up to 6 (3 bytes per surrogate).
    this.charBuffer = new Buffer(6);
    // Number of bytes received for the current incomplete multi-byte character.
    this.charReceived = 0;
    // Number of bytes expected for the current incomplete multi-byte character.
    this.charLength = 0;
  }

  // write decodes the given buffer and returns it as JS string that is
  // guaranteed to not contain any partial multi-byte characters. Any partial
  // character found at the end of the buffer is buffered up, and will be
  // returned when calling write again with the remaining bytes.
  //
  // Note: Converting a Buffer containing an orphan surrogate to a String
  // currently works, but converting a String to a Buffer (via `new Buffer`, or
  // Buffer#write) will replace incomplete surrogates with the unicode
  // replacement character. See https://codereview.chromium.org/121173009/ .
  StringDecoder.prototype.write = function(buffer) {
    var charStr = '';
    // if our last write ended with an incomplete multibyte character
    while (this.charLength) {
      // determine how many remaining bytes this buffer has to offer for this char
      var available = (buffer.length >= this.charLength - this.charReceived) ?
          this.charLength - this.charReceived :
          buffer.length;

      // add the new bytes to the char buffer
      buffer.copy(this.charBuffer, this.charReceived, 0, available);
      this.charReceived += available;

      if (this.charReceived < this.charLength) {
        // still not enough chars in this buffer? wait for more ...
        return '';
      }

      // remove bytes belonging to the current character from the buffer
      buffer = buffer.slice(available, buffer.length);

      // get the character that was split
      charStr = this.charBuffer.slice(0, this.charLength).toString(this.encoding);

      // CESU-8: lead surrogate (D800-DBFF) is also the incomplete character
      var charCode = charStr.charCodeAt(charStr.length - 1);
      if (charCode >= 0xD800 && charCode <= 0xDBFF) {
        this.charLength += this.surrogateSize;
        charStr = '';
        continue;
      }
      this.charReceived = this.charLength = 0;

      // if there are no more bytes in this buffer, just emit our char
      if (buffer.length === 0) {
        return charStr;
      }
      break;
    }

    // determine and set charLength / charReceived
    this.detectIncompleteChar(buffer);

    var end = buffer.length;
    if (this.charLength) {
      // buffer the incomplete character bytes we got
      buffer.copy(this.charBuffer, 0, buffer.length - this.charReceived, end);
      end -= this.charReceived;
    }

    charStr += buffer.toString(this.encoding, 0, end);

    var end = charStr.length - 1;
    var charCode = charStr.charCodeAt(end);
    // CESU-8: lead surrogate (D800-DBFF) is also the incomplete character
    if (charCode >= 0xD800 && charCode <= 0xDBFF) {
      var size = this.surrogateSize;
      this.charLength += size;
      this.charReceived += size;
      this.charBuffer.copy(this.charBuffer, size, 0, size);
      buffer.copy(this.charBuffer, 0, 0, size);
      return charStr.substring(0, end);
    }

    // or just emit the charStr
    return charStr;
  };

  // detectIncompleteChar determines if there is an incomplete UTF-8 character at
  // the end of the given buffer. If so, it sets this.charLength to the byte
  // length that character, and sets this.charReceived to the number of bytes
  // that are available for this character.
  StringDecoder.prototype.detectIncompleteChar = function(buffer) {
    // determine how many bytes we have to check at the end of this buffer
    var i = (buffer.length >= 3) ? 3 : buffer.length;

    // Figure out if one of the last i bytes of our buffer announces an
    // incomplete char.
    for (; i > 0; i--) {
      var c = buffer[buffer.length - i];

      // See http://en.wikipedia.org/wiki/UTF-8#Description

      // 110XXXXX
      if (i == 1 && c >> 5 == 0x06) {
        this.charLength = 2;
        break;
      }

      // 1110XXXX
      if (i <= 2 && c >> 4 == 0x0E) {
        this.charLength = 3;
        break;
      }

      // 11110XXX
      if (i <= 3 && c >> 3 == 0x1E) {
        this.charLength = 4;
        break;
      }
    }
    this.charReceived = i;
  };

  StringDecoder.prototype.end = function(buffer) {
    var res = '';
    if (buffer && buffer.length)
      res = this.write(buffer);

    if (this.charReceived) {
      var cr = this.charReceived;
      var buf = this.charBuffer;
      var enc = this.encoding;
      res += buf.slice(0, cr).toString(enc);
    }

    return res;
  };

  function passThroughWrite(buffer) {
    return buffer.toString(this.encoding);
  }

  function utf16DetectIncompleteChar(buffer) {
    this.charReceived = buffer.length % 2;
    this.charLength = this.charReceived ? 2 : 0;
  }

  function base64DetectIncompleteChar(buffer) {
    this.charReceived = buffer.length % 3;
    this.charLength = this.charReceived ? 3 : 0;
  }

  Readable.ReadableState = ReadableState;

  var debug = debuglog('stream');
  inherits$1(Readable, EventEmitter);

  function prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === 'function') {
      return emitter.prependListener(event, fn);
    } else {
      // This is a hack to make sure that our error handler is attached before any
      // userland ones.  NEVER DO THIS. This is here only because this code needs
      // to continue to work with older versions of Node.js that do not include
      // the prependListener() method. The goal is to eventually remove this hack.
      if (!emitter._events || !emitter._events[event])
        emitter.on(event, fn);
      else if (Array.isArray(emitter._events[event]))
        emitter._events[event].unshift(fn);
      else
        emitter._events[event] = [fn, emitter._events[event]];
    }
  }
  function listenerCount$1 (emitter, type) {
    return emitter.listeners(type).length;
  }
  function ReadableState(options, stream) {

    options = options || {};

    // object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away
    this.objectMode = !!options.objectMode;

    if (stream instanceof Duplex) this.objectMode = this.objectMode || !!options.readableObjectMode;

    // the point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    var hwm = options.highWaterMark;
    var defaultHwm = this.objectMode ? 16 : 16 * 1024;
    this.highWaterMark = hwm || hwm === 0 ? hwm : defaultHwm;

    // cast to ints.
    this.highWaterMark = ~ ~this.highWaterMark;

    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift()
    this.buffer = new BufferList();
    this.length = 0;
    this.pipes = null;
    this.pipesCount = 0;
    this.flowing = null;
    this.ended = false;
    this.endEmitted = false;
    this.reading = false;

    // a flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;

    // whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    this.needReadable = false;
    this.emittedReadable = false;
    this.readableListening = false;
    this.resumeScheduled = false;

    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || 'utf8';

    // when piping, we only care about 'readable' events that happen
    // after read()ing all the bytes and not getting any pushback.
    this.ranOut = false;

    // the number of writers that are awaiting a drain event in .pipe()s
    this.awaitDrain = 0;

    // if true, a maybeReadMore has been scheduled
    this.readingMore = false;

    this.decoder = null;
    this.encoding = null;
    if (options.encoding) {
      this.decoder = new StringDecoder(options.encoding);
      this.encoding = options.encoding;
    }
  }
  function Readable(options) {

    if (!(this instanceof Readable)) return new Readable(options);

    this._readableState = new ReadableState(options, this);

    // legacy
    this.readable = true;

    if (options && typeof options.read === 'function') this._read = options.read;

    EventEmitter.call(this);
  }

  // Manually shove something into the read() buffer.
  // This returns true if the highWaterMark has not been hit yet,
  // similar to how Writable.write() returns true if you should
  // write() some more.
  Readable.prototype.push = function (chunk, encoding) {
    var state = this._readableState;

    if (!state.objectMode && typeof chunk === 'string') {
      encoding = encoding || state.defaultEncoding;
      if (encoding !== state.encoding) {
        chunk = Buffer.from(chunk, encoding);
        encoding = '';
      }
    }

    return readableAddChunk(this, state, chunk, encoding, false);
  };

  // Unshift should *always* be something directly out of read()
  Readable.prototype.unshift = function (chunk) {
    var state = this._readableState;
    return readableAddChunk(this, state, chunk, '', true);
  };

  Readable.prototype.isPaused = function () {
    return this._readableState.flowing === false;
  };

  function readableAddChunk(stream, state, chunk, encoding, addToFront) {
    var er = chunkInvalid(state, chunk);
    if (er) {
      stream.emit('error', er);
    } else if (chunk === null) {
      state.reading = false;
      onEofChunk(stream, state);
    } else if (state.objectMode || chunk && chunk.length > 0) {
      if (state.ended && !addToFront) {
        var e = new Error('stream.push() after EOF');
        stream.emit('error', e);
      } else if (state.endEmitted && addToFront) {
        var _e = new Error('stream.unshift() after end event');
        stream.emit('error', _e);
      } else {
        var skipAdd;
        if (state.decoder && !addToFront && !encoding) {
          chunk = state.decoder.write(chunk);
          skipAdd = !state.objectMode && chunk.length === 0;
        }

        if (!addToFront) state.reading = false;

        // Don't add to the buffer if we've decoded to an empty string chunk and
        // we're not in object mode
        if (!skipAdd) {
          // if we want the data now, just emit it.
          if (state.flowing && state.length === 0 && !state.sync) {
            stream.emit('data', chunk);
            stream.read(0);
          } else {
            // update the buffer info.
            state.length += state.objectMode ? 1 : chunk.length;
            if (addToFront) state.buffer.unshift(chunk);else state.buffer.push(chunk);

            if (state.needReadable) emitReadable(stream);
          }
        }

        maybeReadMore(stream, state);
      }
    } else if (!addToFront) {
      state.reading = false;
    }

    return needMoreData(state);
  }

  // if it's past the high water mark, we can push in some more.
  // Also, if we have no data yet, we can stand some
  // more bytes.  This is to work around cases where hwm=0,
  // such as the repl.  Also, if the push() triggered a
  // readable event, and the user called read(largeNumber) such that
  // needReadable was set, then we ought to push more, so that another
  // 'readable' event will be triggered.
  function needMoreData(state) {
    return !state.ended && (state.needReadable || state.length < state.highWaterMark || state.length === 0);
  }

  // backwards compatibility.
  Readable.prototype.setEncoding = function (enc) {
    this._readableState.decoder = new StringDecoder(enc);
    this._readableState.encoding = enc;
    return this;
  };

  // Don't raise the hwm > 8MB
  var MAX_HWM = 0x800000;
  function computeNewHighWaterMark(n) {
    if (n >= MAX_HWM) {
      n = MAX_HWM;
    } else {
      // Get the next highest power of 2 to prevent increasing hwm excessively in
      // tiny amounts
      n--;
      n |= n >>> 1;
      n |= n >>> 2;
      n |= n >>> 4;
      n |= n >>> 8;
      n |= n >>> 16;
      n++;
    }
    return n;
  }

  // This function is designed to be inlinable, so please take care when making
  // changes to the function body.
  function howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if (state.objectMode) return 1;
    if (n !== n) {
      // Only flow one buffer at a time
      if (state.flowing && state.length) return state.buffer.head.data.length;else return state.length;
    }
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = computeNewHighWaterMark(n);
    if (n <= state.length) return n;
    // Don't have enough
    if (!state.ended) {
      state.needReadable = true;
      return 0;
    }
    return state.length;
  }

  // you can override either this method, or the async _read(n) below.
  Readable.prototype.read = function (n) {
    debug('read', n);
    n = parseInt(n, 10);
    var state = this._readableState;
    var nOrig = n;

    if (n !== 0) state.emittedReadable = false;

    // if we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && (state.length >= state.highWaterMark || state.ended)) {
      debug('read: emitReadable', state.length, state.ended);
      if (state.length === 0 && state.ended) endReadable(this);else emitReadable(this);
      return null;
    }

    n = howMuchToRead(n, state);

    // if we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
      if (state.length === 0) endReadable(this);
      return null;
    }

    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.

    // if we need a readable event, then we need to do some reading.
    var doRead = state.needReadable;
    debug('need readable', doRead);

    // if we currently have less than the highWaterMark, then also read some
    if (state.length === 0 || state.length - n < state.highWaterMark) {
      doRead = true;
      debug('length less than watermark', doRead);
    }

    // however, if we've ended, then there's no point, and if we're already
    // reading, then it's unnecessary.
    if (state.ended || state.reading) {
      doRead = false;
      debug('reading or ended', doRead);
    } else if (doRead) {
      debug('do read');
      state.reading = true;
      state.sync = true;
      // if the length is currently zero, then we *need* a readable event.
      if (state.length === 0) state.needReadable = true;
      // call internal read method
      this._read(state.highWaterMark);
      state.sync = false;
      // If _read pushed data synchronously, then `reading` will be false,
      // and we need to re-evaluate how much data we can return to the user.
      if (!state.reading) n = howMuchToRead(nOrig, state);
    }

    var ret;
    if (n > 0) ret = fromList(n, state);else ret = null;

    if (ret === null) {
      state.needReadable = true;
      n = 0;
    } else {
      state.length -= n;
    }

    if (state.length === 0) {
      // If we have nothing in the buffer, then we want to know
      // as soon as we *do* get something into the buffer.
      if (!state.ended) state.needReadable = true;

      // If we tried to read() past the EOF, then emit end on the next tick.
      if (nOrig !== n && state.ended) endReadable(this);
    }

    if (ret !== null) this.emit('data', ret);

    return ret;
  };

  function chunkInvalid(state, chunk) {
    var er = null;
    if (!isBuffer(chunk) && typeof chunk !== 'string' && chunk !== null && chunk !== undefined && !state.objectMode) {
      er = new TypeError('Invalid non-string/buffer chunk');
    }
    return er;
  }

  function onEofChunk(stream, state) {
    if (state.ended) return;
    if (state.decoder) {
      var chunk = state.decoder.end();
      if (chunk && chunk.length) {
        state.buffer.push(chunk);
        state.length += state.objectMode ? 1 : chunk.length;
      }
    }
    state.ended = true;

    // emit 'readable' now to make sure it gets picked up.
    emitReadable(stream);
  }

  // Don't emit readable right away in sync mode, because this can trigger
  // another read() call => stack overflow.  This way, it might trigger
  // a nextTick recursion warning, but that's not so bad.
  function emitReadable(stream) {
    var state = stream._readableState;
    state.needReadable = false;
    if (!state.emittedReadable) {
      debug('emitReadable', state.flowing);
      state.emittedReadable = true;
      if (state.sync) nextTick(emitReadable_, stream);else emitReadable_(stream);
    }
  }

  function emitReadable_(stream) {
    debug('emit readable');
    stream.emit('readable');
    flow(stream);
  }

  // at this point, the user has presumably seen the 'readable' event,
  // and called read() to consume some data.  that may have triggered
  // in turn another _read(n) call, in which case reading = true if
  // it's in progress.
  // However, if we're not ended, or reading, and the length < hwm,
  // then go ahead and try to read some more preemptively.
  function maybeReadMore(stream, state) {
    if (!state.readingMore) {
      state.readingMore = true;
      nextTick(maybeReadMore_, stream, state);
    }
  }

  function maybeReadMore_(stream, state) {
    var len = state.length;
    while (!state.reading && !state.flowing && !state.ended && state.length < state.highWaterMark) {
      debug('maybeReadMore read 0');
      stream.read(0);
      if (len === state.length)
        // didn't get any data, stop spinning.
        break;else len = state.length;
    }
    state.readingMore = false;
  }

  // abstract method.  to be overridden in specific implementation classes.
  // call cb(er, data) where data is <= n in length.
  // for virtual (non-string, non-buffer) streams, "length" is somewhat
  // arbitrary, and perhaps not very meaningful.
  Readable.prototype._read = function (n) {
    this.emit('error', new Error('not implemented'));
  };

  Readable.prototype.pipe = function (dest, pipeOpts) {
    var src = this;
    var state = this._readableState;

    switch (state.pipesCount) {
      case 0:
        state.pipes = dest;
        break;
      case 1:
        state.pipes = [state.pipes, dest];
        break;
      default:
        state.pipes.push(dest);
        break;
    }
    state.pipesCount += 1;
    debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);

    var doEnd = (!pipeOpts || pipeOpts.end !== false);

    var endFn = doEnd ? onend : cleanup;
    if (state.endEmitted) nextTick(endFn);else src.once('end', endFn);

    dest.on('unpipe', onunpipe);
    function onunpipe(readable) {
      debug('onunpipe');
      if (readable === src) {
        cleanup();
      }
    }

    function onend() {
      debug('onend');
      dest.end();
    }

    // when the dest drains, it reduces the awaitDrain counter
    // on the source.  This would be more elegant with a .once()
    // handler in flow(), but adding and removing repeatedly is
    // too slow.
    var ondrain = pipeOnDrain(src);
    dest.on('drain', ondrain);

    var cleanedUp = false;
    function cleanup() {
      debug('cleanup');
      // cleanup event handlers once the pipe is broken
      dest.removeListener('close', onclose);
      dest.removeListener('finish', onfinish);
      dest.removeListener('drain', ondrain);
      dest.removeListener('error', onerror);
      dest.removeListener('unpipe', onunpipe);
      src.removeListener('end', onend);
      src.removeListener('end', cleanup);
      src.removeListener('data', ondata);

      cleanedUp = true;

      // if the reader is waiting for a drain event from this
      // specific writer, then it would cause it to never start
      // flowing again.
      // So, if this is awaiting a drain, then we just call it now.
      // If we don't know, then assume that we are waiting for one.
      if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }

    // If the user pushes more data while we're writing to dest then we'll end up
    // in ondata again. However, we only want to increase awaitDrain once because
    // dest will only emit one 'drain' event for the multiple writes.
    // => Introduce a guard on increasing awaitDrain.
    var increasedAwaitDrain = false;
    src.on('data', ondata);
    function ondata(chunk) {
      debug('ondata');
      increasedAwaitDrain = false;
      var ret = dest.write(chunk);
      if (false === ret && !increasedAwaitDrain) {
        // If the user unpiped during `dest.write()`, it is possible
        // to get stuck in a permanently paused state if that write
        // also returned false.
        // => Check whether `dest` is still a piping destination.
        if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
          debug('false write response, pause', src._readableState.awaitDrain);
          src._readableState.awaitDrain++;
          increasedAwaitDrain = true;
        }
        src.pause();
      }
    }

    // if the dest has an error, then stop piping into it.
    // however, don't suppress the throwing behavior for this.
    function onerror(er) {
      debug('onerror', er);
      unpipe();
      dest.removeListener('error', onerror);
      if (listenerCount$1(dest, 'error') === 0) dest.emit('error', er);
    }

    // Make sure our error handler is attached before userland ones.
    prependListener(dest, 'error', onerror);

    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
      dest.removeListener('finish', onfinish);
      unpipe();
    }
    dest.once('close', onclose);
    function onfinish() {
      debug('onfinish');
      dest.removeListener('close', onclose);
      unpipe();
    }
    dest.once('finish', onfinish);

    function unpipe() {
      debug('unpipe');
      src.unpipe(dest);
    }

    // tell the dest that it's being piped to
    dest.emit('pipe', src);

    // start the flow if it hasn't been started already.
    if (!state.flowing) {
      debug('pipe resume');
      src.resume();
    }

    return dest;
  };

  function pipeOnDrain(src) {
    return function () {
      var state = src._readableState;
      debug('pipeOnDrain', state.awaitDrain);
      if (state.awaitDrain) state.awaitDrain--;
      if (state.awaitDrain === 0 && src.listeners('data').length) {
        state.flowing = true;
        flow(src);
      }
    };
  }

  Readable.prototype.unpipe = function (dest) {
    var state = this._readableState;

    // if we're not piping anywhere, then do nothing.
    if (state.pipesCount === 0) return this;

    // just one destination.  most common case.
    if (state.pipesCount === 1) {
      // passed in one, but it's not the right one.
      if (dest && dest !== state.pipes) return this;

      if (!dest) dest = state.pipes;

      // got a match.
      state.pipes = null;
      state.pipesCount = 0;
      state.flowing = false;
      if (dest) dest.emit('unpipe', this);
      return this;
    }

    // slow case. multiple pipe destinations.

    if (!dest) {
      // remove all.
      var dests = state.pipes;
      var len = state.pipesCount;
      state.pipes = null;
      state.pipesCount = 0;
      state.flowing = false;

      for (var _i = 0; _i < len; _i++) {
        dests[_i].emit('unpipe', this);
      }return this;
    }

    // try to find the right one.
    var i = indexOf(state.pipes, dest);
    if (i === -1) return this;

    state.pipes.splice(i, 1);
    state.pipesCount -= 1;
    if (state.pipesCount === 1) state.pipes = state.pipes[0];

    dest.emit('unpipe', this);

    return this;
  };

  // set up data events if they are asked for
  // Ensure readable listeners eventually get something
  Readable.prototype.on = function (ev, fn) {
    var res = EventEmitter.prototype.on.call(this, ev, fn);

    if (ev === 'data') {
      // Start flowing on next tick if stream isn't explicitly paused
      if (this._readableState.flowing !== false) this.resume();
    } else if (ev === 'readable') {
      var state = this._readableState;
      if (!state.endEmitted && !state.readableListening) {
        state.readableListening = state.needReadable = true;
        state.emittedReadable = false;
        if (!state.reading) {
          nextTick(nReadingNextTick, this);
        } else if (state.length) {
          emitReadable(this, state);
        }
      }
    }

    return res;
  };
  Readable.prototype.addListener = Readable.prototype.on;

  function nReadingNextTick(self) {
    debug('readable nexttick read 0');
    self.read(0);
  }

  // pause() and resume() are remnants of the legacy readable stream API
  // If the user uses them, then switch into old mode.
  Readable.prototype.resume = function () {
    var state = this._readableState;
    if (!state.flowing) {
      debug('resume');
      state.flowing = true;
      resume(this, state);
    }
    return this;
  };

  function resume(stream, state) {
    if (!state.resumeScheduled) {
      state.resumeScheduled = true;
      nextTick(resume_, stream, state);
    }
  }

  function resume_(stream, state) {
    if (!state.reading) {
      debug('resume read 0');
      stream.read(0);
    }

    state.resumeScheduled = false;
    state.awaitDrain = 0;
    stream.emit('resume');
    flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
  }

  Readable.prototype.pause = function () {
    debug('call pause flowing=%j', this._readableState.flowing);
    if (false !== this._readableState.flowing) {
      debug('pause');
      this._readableState.flowing = false;
      this.emit('pause');
    }
    return this;
  };

  function flow(stream) {
    var state = stream._readableState;
    debug('flow', state.flowing);
    while (state.flowing && stream.read() !== null) {}
  }

  // wrap an old-style stream as the async data source.
  // This is *not* part of the readable stream interface.
  // It is an ugly unfortunate mess of history.
  Readable.prototype.wrap = function (stream) {
    var state = this._readableState;
    var paused = false;

    var self = this;
    stream.on('end', function () {
      debug('wrapped end');
      if (state.decoder && !state.ended) {
        var chunk = state.decoder.end();
        if (chunk && chunk.length) self.push(chunk);
      }

      self.push(null);
    });

    stream.on('data', function (chunk) {
      debug('wrapped data');
      if (state.decoder) chunk = state.decoder.write(chunk);

      // don't skip over falsy values in objectMode
      if (state.objectMode && (chunk === null || chunk === undefined)) return;else if (!state.objectMode && (!chunk || !chunk.length)) return;

      var ret = self.push(chunk);
      if (!ret) {
        paused = true;
        stream.pause();
      }
    });

    // proxy all the other methods.
    // important when wrapping filters and duplexes.
    for (var i in stream) {
      if (this[i] === undefined && typeof stream[i] === 'function') {
        this[i] = function (method) {
          return function () {
            return stream[method].apply(stream, arguments);
          };
        }(i);
      }
    }

    // proxy certain important events.
    var events = ['error', 'close', 'destroy', 'pause', 'resume'];
    forEach(events, function (ev) {
      stream.on(ev, self.emit.bind(self, ev));
    });

    // when we try to consume some more bytes, simply unpause the
    // underlying stream.
    self._read = function (n) {
      debug('wrapped _read', n);
      if (paused) {
        paused = false;
        stream.resume();
      }
    };

    return self;
  };

  // exposed for testing purposes only.
  Readable._fromList = fromList;

  // Pluck off n bytes from an array of buffers.
  // Length is the combined lengths of all the buffers in the list.
  // This function is designed to be inlinable, so please take care when making
  // changes to the function body.
  function fromList(n, state) {
    // nothing buffered
    if (state.length === 0) return null;

    var ret;
    if (state.objectMode) ret = state.buffer.shift();else if (!n || n >= state.length) {
      // read it all, truncate the list
      if (state.decoder) ret = state.buffer.join('');else if (state.buffer.length === 1) ret = state.buffer.head.data;else ret = state.buffer.concat(state.length);
      state.buffer.clear();
    } else {
      // read part of list
      ret = fromListPartial(n, state.buffer, state.decoder);
    }

    return ret;
  }

  // Extracts only enough buffered data to satisfy the amount requested.
  // This function is designed to be inlinable, so please take care when making
  // changes to the function body.
  function fromListPartial(n, list, hasStrings) {
    var ret;
    if (n < list.head.data.length) {
      // slice is the same for buffers and strings
      ret = list.head.data.slice(0, n);
      list.head.data = list.head.data.slice(n);
    } else if (n === list.head.data.length) {
      // first chunk is a perfect match
      ret = list.shift();
    } else {
      // result spans more than one buffer
      ret = hasStrings ? copyFromBufferString(n, list) : copyFromBuffer(n, list);
    }
    return ret;
  }

  // Copies a specified amount of characters from the list of buffered data
  // chunks.
  // This function is designed to be inlinable, so please take care when making
  // changes to the function body.
  function copyFromBufferString(n, list) {
    var p = list.head;
    var c = 1;
    var ret = p.data;
    n -= ret.length;
    while (p = p.next) {
      var str = p.data;
      var nb = n > str.length ? str.length : n;
      if (nb === str.length) ret += str;else ret += str.slice(0, n);
      n -= nb;
      if (n === 0) {
        if (nb === str.length) {
          ++c;
          if (p.next) list.head = p.next;else list.head = list.tail = null;
        } else {
          list.head = p;
          p.data = str.slice(nb);
        }
        break;
      }
      ++c;
    }
    list.length -= c;
    return ret;
  }

  // Copies a specified amount of bytes from the list of buffered data chunks.
  // This function is designed to be inlinable, so please take care when making
  // changes to the function body.
  function copyFromBuffer(n, list) {
    var ret = Buffer.allocUnsafe(n);
    var p = list.head;
    var c = 1;
    p.data.copy(ret);
    n -= p.data.length;
    while (p = p.next) {
      var buf = p.data;
      var nb = n > buf.length ? buf.length : n;
      buf.copy(ret, ret.length - n, 0, nb);
      n -= nb;
      if (n === 0) {
        if (nb === buf.length) {
          ++c;
          if (p.next) list.head = p.next;else list.head = list.tail = null;
        } else {
          list.head = p;
          p.data = buf.slice(nb);
        }
        break;
      }
      ++c;
    }
    list.length -= c;
    return ret;
  }

  function endReadable(stream) {
    var state = stream._readableState;

    // If we get here before consuming all the bytes, then that is a
    // bug in node.  Should never happen.
    if (state.length > 0) throw new Error('"endReadable()" called on non-empty stream');

    if (!state.endEmitted) {
      state.ended = true;
      nextTick(endReadableNT, state, stream);
    }
  }

  function endReadableNT(state, stream) {
    // Check that we didn't get one last unshift.
    if (!state.endEmitted && state.length === 0) {
      state.endEmitted = true;
      stream.readable = false;
      stream.emit('end');
    }
  }

  function forEach(xs, f) {
    for (var i = 0, l = xs.length; i < l; i++) {
      f(xs[i], i);
    }
  }

  function indexOf(xs, x) {
    for (var i = 0, l = xs.length; i < l; i++) {
      if (xs[i] === x) return i;
    }
    return -1;
  }

  // A bit simpler than readable streams.
  Writable.WritableState = WritableState;
  inherits$1(Writable, EventEmitter);

  function nop() {}

  function WriteReq(chunk, encoding, cb) {
    this.chunk = chunk;
    this.encoding = encoding;
    this.callback = cb;
    this.next = null;
  }

  function WritableState(options, stream) {
    Object.defineProperty(this, 'buffer', {
      get: deprecate(function () {
        return this.getBuffer();
      }, '_writableState.buffer is deprecated. Use _writableState.getBuffer ' + 'instead.')
    });
    options = options || {};

    // object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!options.objectMode;

    if (stream instanceof Duplex) this.objectMode = this.objectMode || !!options.writableObjectMode;

    // the point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write()
    var hwm = options.highWaterMark;
    var defaultHwm = this.objectMode ? 16 : 16 * 1024;
    this.highWaterMark = hwm || hwm === 0 ? hwm : defaultHwm;

    // cast to ints.
    this.highWaterMark = ~ ~this.highWaterMark;

    this.needDrain = false;
    // at the start of calling end()
    this.ending = false;
    // when end() has been called, and returned
    this.ended = false;
    // when 'finish' is emitted
    this.finished = false;

    // should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    var noDecode = options.decodeStrings === false;
    this.decodeStrings = !noDecode;

    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || 'utf8';

    // not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;

    // a flag to see when we're in the middle of a write.
    this.writing = false;

    // when true all writes will be buffered until .uncork() call
    this.corked = 0;

    // a flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;

    // a flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;

    // the callback that's passed to _write(chunk,cb)
    this.onwrite = function (er) {
      onwrite(stream, er);
    };

    // the callback that the user supplies to write(chunk,encoding,cb)
    this.writecb = null;

    // the amount that is being written when _write is called.
    this.writelen = 0;

    this.bufferedRequest = null;
    this.lastBufferedRequest = null;

    // number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted
    this.pendingcb = 0;

    // emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams
    this.prefinished = false;

    // True if the error was already emitted and should not be thrown again
    this.errorEmitted = false;

    // count buffered requests
    this.bufferedRequestCount = 0;

    // allocate the first CorkedRequest, there is always
    // one allocated and free to use, and we maintain at most two
    this.corkedRequestsFree = new CorkedRequest(this);
  }

  WritableState.prototype.getBuffer = function writableStateGetBuffer() {
    var current = this.bufferedRequest;
    var out = [];
    while (current) {
      out.push(current);
      current = current.next;
    }
    return out;
  };
  function Writable(options) {

    // Writable ctor is applied to Duplexes, though they're not
    // instanceof Writable, they're instanceof Readable.
    if (!(this instanceof Writable) && !(this instanceof Duplex)) return new Writable(options);

    this._writableState = new WritableState(options, this);

    // legacy.
    this.writable = true;

    if (options) {
      if (typeof options.write === 'function') this._write = options.write;

      if (typeof options.writev === 'function') this._writev = options.writev;
    }

    EventEmitter.call(this);
  }

  // Otherwise people can pipe Writable streams, which is just wrong.
  Writable.prototype.pipe = function () {
    this.emit('error', new Error('Cannot pipe, not readable'));
  };

  function writeAfterEnd(stream, cb) {
    var er = new Error('write after end');
    // TODO: defer error events consistently everywhere, not just the cb
    stream.emit('error', er);
    nextTick(cb, er);
  }

  // If we get something that is not a buffer, string, null, or undefined,
  // and we're not in objectMode, then that's an error.
  // Otherwise stream chunks are all considered to be of length=1, and the
  // watermarks determine how many objects to keep in the buffer, rather than
  // how many bytes or characters.
  function validChunk(stream, state, chunk, cb) {
    var valid = true;
    var er = false;
    // Always throw error if a null is written
    // if we are not in object mode then throw
    // if it is not a buffer, string, or undefined.
    if (chunk === null) {
      er = new TypeError('May not write null values to stream');
    } else if (!Buffer.isBuffer(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
      er = new TypeError('Invalid non-string/buffer chunk');
    }
    if (er) {
      stream.emit('error', er);
      nextTick(cb, er);
      valid = false;
    }
    return valid;
  }

  Writable.prototype.write = function (chunk, encoding, cb) {
    var state = this._writableState;
    var ret = false;

    if (typeof encoding === 'function') {
      cb = encoding;
      encoding = null;
    }

    if (Buffer.isBuffer(chunk)) encoding = 'buffer';else if (!encoding) encoding = state.defaultEncoding;

    if (typeof cb !== 'function') cb = nop;

    if (state.ended) writeAfterEnd(this, cb);else if (validChunk(this, state, chunk, cb)) {
      state.pendingcb++;
      ret = writeOrBuffer(this, state, chunk, encoding, cb);
    }

    return ret;
  };

  Writable.prototype.cork = function () {
    var state = this._writableState;

    state.corked++;
  };

  Writable.prototype.uncork = function () {
    var state = this._writableState;

    if (state.corked) {
      state.corked--;

      if (!state.writing && !state.corked && !state.finished && !state.bufferProcessing && state.bufferedRequest) clearBuffer(this, state);
    }
  };

  Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === 'string') encoding = encoding.toLowerCase();
    if (!(['hex', 'utf8', 'utf-8', 'ascii', 'binary', 'base64', 'ucs2', 'ucs-2', 'utf16le', 'utf-16le', 'raw'].indexOf((encoding + '').toLowerCase()) > -1)) throw new TypeError('Unknown encoding: ' + encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
  };

  function decodeChunk(state, chunk, encoding) {
    if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') {
      chunk = Buffer.from(chunk, encoding);
    }
    return chunk;
  }

  // if we're already writing something, then just put this
  // in the queue, and wait our turn.  Otherwise, call _write
  // If we return false, then we need a drain event, so set that flag.
  function writeOrBuffer(stream, state, chunk, encoding, cb) {
    chunk = decodeChunk(state, chunk, encoding);

    if (Buffer.isBuffer(chunk)) encoding = 'buffer';
    var len = state.objectMode ? 1 : chunk.length;

    state.length += len;

    var ret = state.length < state.highWaterMark;
    // we must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;

    if (state.writing || state.corked) {
      var last = state.lastBufferedRequest;
      state.lastBufferedRequest = new WriteReq(chunk, encoding, cb);
      if (last) {
        last.next = state.lastBufferedRequest;
      } else {
        state.bufferedRequest = state.lastBufferedRequest;
      }
      state.bufferedRequestCount += 1;
    } else {
      doWrite(stream, state, false, len, chunk, encoding, cb);
    }

    return ret;
  }

  function doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (writev) stream._writev(chunk, state.onwrite);else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
  }

  function onwriteError(stream, state, sync, er, cb) {
    --state.pendingcb;
    if (sync) nextTick(cb, er);else cb(er);

    stream._writableState.errorEmitted = true;
    stream.emit('error', er);
  }

  function onwriteStateUpdate(state) {
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
  }

  function onwrite(stream, er) {
    var state = stream._writableState;
    var sync = state.sync;
    var cb = state.writecb;

    onwriteStateUpdate(state);

    if (er) onwriteError(stream, state, sync, er, cb);else {
      // Check if we're actually ready to finish, but don't emit yet
      var finished = needFinish(state);

      if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) {
        clearBuffer(stream, state);
      }

      if (sync) {
        /*<replacement>*/
          nextTick(afterWrite, stream, state, finished, cb);
        /*</replacement>*/
      } else {
          afterWrite(stream, state, finished, cb);
        }
    }
  }

  function afterWrite(stream, state, finished, cb) {
    if (!finished) onwriteDrain(stream, state);
    state.pendingcb--;
    cb();
    finishMaybe(stream, state);
  }

  // Must force callback to be called on nextTick, so that we don't
  // emit 'drain' before the write() consumer gets the 'false' return
  // value, and has a chance to attach a 'drain' listener.
  function onwriteDrain(stream, state) {
    if (state.length === 0 && state.needDrain) {
      state.needDrain = false;
      stream.emit('drain');
    }
  }

  // if there's something in the buffer waiting, then process it
  function clearBuffer(stream, state) {
    state.bufferProcessing = true;
    var entry = state.bufferedRequest;

    if (stream._writev && entry && entry.next) {
      // Fast case, write everything using _writev()
      var l = state.bufferedRequestCount;
      var buffer = new Array(l);
      var holder = state.corkedRequestsFree;
      holder.entry = entry;

      var count = 0;
      while (entry) {
        buffer[count] = entry;
        entry = entry.next;
        count += 1;
      }

      doWrite(stream, state, true, state.length, buffer, '', holder.finish);

      // doWrite is almost always async, defer these to save a bit of time
      // as the hot path ends with doWrite
      state.pendingcb++;
      state.lastBufferedRequest = null;
      if (holder.next) {
        state.corkedRequestsFree = holder.next;
        holder.next = null;
      } else {
        state.corkedRequestsFree = new CorkedRequest(state);
      }
    } else {
      // Slow case, write chunks one-by-one
      while (entry) {
        var chunk = entry.chunk;
        var encoding = entry.encoding;
        var cb = entry.callback;
        var len = state.objectMode ? 1 : chunk.length;

        doWrite(stream, state, false, len, chunk, encoding, cb);
        entry = entry.next;
        // if we didn't call the onwrite immediately, then
        // it means that we need to wait until it does.
        // also, that means that the chunk and cb are currently
        // being processed, so move the buffer counter past them.
        if (state.writing) {
          break;
        }
      }

      if (entry === null) state.lastBufferedRequest = null;
    }

    state.bufferedRequestCount = 0;
    state.bufferedRequest = entry;
    state.bufferProcessing = false;
  }

  Writable.prototype._write = function (chunk, encoding, cb) {
    cb(new Error('not implemented'));
  };

  Writable.prototype._writev = null;

  Writable.prototype.end = function (chunk, encoding, cb) {
    var state = this._writableState;

    if (typeof chunk === 'function') {
      cb = chunk;
      chunk = null;
      encoding = null;
    } else if (typeof encoding === 'function') {
      cb = encoding;
      encoding = null;
    }

    if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);

    // .end() fully uncorks
    if (state.corked) {
      state.corked = 1;
      this.uncork();
    }

    // ignore unnecessary end() calls.
    if (!state.ending && !state.finished) endWritable(this, state, cb);
  };

  function needFinish(state) {
    return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
  }

  function prefinish(stream, state) {
    if (!state.prefinished) {
      state.prefinished = true;
      stream.emit('prefinish');
    }
  }

  function finishMaybe(stream, state) {
    var need = needFinish(state);
    if (need) {
      if (state.pendingcb === 0) {
        prefinish(stream, state);
        state.finished = true;
        stream.emit('finish');
      } else {
        prefinish(stream, state);
      }
    }
    return need;
  }

  function endWritable(stream, state, cb) {
    state.ending = true;
    finishMaybe(stream, state);
    if (cb) {
      if (state.finished) nextTick(cb);else stream.once('finish', cb);
    }
    state.ended = true;
    stream.writable = false;
  }

  // It seems a linked list but it is not
  // there will be only 2 of these for each stream
  function CorkedRequest(state) {
    var _this = this;

    this.next = null;
    this.entry = null;

    this.finish = function (err) {
      var entry = _this.entry;
      _this.entry = null;
      while (entry) {
        var cb = entry.callback;
        state.pendingcb--;
        cb(err);
        entry = entry.next;
      }
      if (state.corkedRequestsFree) {
        state.corkedRequestsFree.next = _this;
      } else {
        state.corkedRequestsFree = _this;
      }
    };
  }

  inherits$1(Duplex, Readable);

  var keys = Object.keys(Writable.prototype);
  for (var v = 0; v < keys.length; v++) {
    var method = keys[v];
    if (!Duplex.prototype[method]) Duplex.prototype[method] = Writable.prototype[method];
  }
  function Duplex(options) {
    if (!(this instanceof Duplex)) return new Duplex(options);

    Readable.call(this, options);
    Writable.call(this, options);

    if (options && options.readable === false) this.readable = false;

    if (options && options.writable === false) this.writable = false;

    this.allowHalfOpen = true;
    if (options && options.allowHalfOpen === false) this.allowHalfOpen = false;

    this.once('end', onend);
  }

  // the no-half-open enforcer
  function onend() {
    // if we allow half-open state, or if the writable side ended,
    // then we're ok.
    if (this.allowHalfOpen || this._writableState.ended) return;

    // no more data can be written.
    // But allow more writes to happen in this tick.
    nextTick(onEndNT, this);
  }

  function onEndNT(self) {
    self.end();
  }

  // a transform stream is a readable/writable stream where you do
  inherits$1(Transform, Duplex);

  function TransformState(stream) {
    this.afterTransform = function (er, data) {
      return afterTransform(stream, er, data);
    };

    this.needTransform = false;
    this.transforming = false;
    this.writecb = null;
    this.writechunk = null;
    this.writeencoding = null;
  }

  function afterTransform(stream, er, data) {
    var ts = stream._transformState;
    ts.transforming = false;

    var cb = ts.writecb;

    if (!cb) return stream.emit('error', new Error('no writecb in Transform class'));

    ts.writechunk = null;
    ts.writecb = null;

    if (data !== null && data !== undefined) stream.push(data);

    cb(er);

    var rs = stream._readableState;
    rs.reading = false;
    if (rs.needReadable || rs.length < rs.highWaterMark) {
      stream._read(rs.highWaterMark);
    }
  }
  function Transform(options) {
    if (!(this instanceof Transform)) return new Transform(options);

    Duplex.call(this, options);

    this._transformState = new TransformState(this);

    // when the writable side finishes, then flush out anything remaining.
    var stream = this;

    // start out asking for a readable event once data is transformed.
    this._readableState.needReadable = true;

    // we have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;

    if (options) {
      if (typeof options.transform === 'function') this._transform = options.transform;

      if (typeof options.flush === 'function') this._flush = options.flush;
    }

    this.once('prefinish', function () {
      if (typeof this._flush === 'function') this._flush(function (er) {
        done(stream, er);
      });else done(stream);
    });
  }

  Transform.prototype.push = function (chunk, encoding) {
    this._transformState.needTransform = false;
    return Duplex.prototype.push.call(this, chunk, encoding);
  };

  // This is the part where you do stuff!
  // override this function in implementation classes.
  // 'chunk' is an input chunk.
  //
  // Call `push(newChunk)` to pass along transformed output
  // to the readable side.  You may call 'push' zero or more times.
  //
  // Call `cb(err)` when you are done with this chunk.  If you pass
  // an error, then that'll put the hurt on the whole operation.  If you
  // never call cb(), then you'll never get another chunk.
  Transform.prototype._transform = function (chunk, encoding, cb) {
    throw new Error('Not implemented');
  };

  Transform.prototype._write = function (chunk, encoding, cb) {
    var ts = this._transformState;
    ts.writecb = cb;
    ts.writechunk = chunk;
    ts.writeencoding = encoding;
    if (!ts.transforming) {
      var rs = this._readableState;
      if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
    }
  };

  // Doesn't matter what the args are here.
  // _transform does all the work.
  // That we got here means that the readable side wants more data.
  Transform.prototype._read = function (n) {
    var ts = this._transformState;

    if (ts.writechunk !== null && ts.writecb && !ts.transforming) {
      ts.transforming = true;
      this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
    } else {
      // mark that we need a transform, so that any data that comes in
      // will get processed, now that we've asked for it.
      ts.needTransform = true;
    }
  };

  function done(stream, er) {
    if (er) return stream.emit('error', er);

    // if there's nothing in the write buffer, then that means
    // that nothing more will ever be provided
    var ws = stream._writableState;
    var ts = stream._transformState;

    if (ws.length) throw new Error('Calling transform done when ws.length != 0');

    if (ts.transforming) throw new Error('Calling transform done when still transforming');

    return stream.push(null);
  }

  inherits$1(PassThrough, Transform);
  function PassThrough(options) {
    if (!(this instanceof PassThrough)) return new PassThrough(options);

    Transform.call(this, options);
  }

  PassThrough.prototype._transform = function (chunk, encoding, cb) {
    cb(null, chunk);
  };

  inherits$1(Stream, EventEmitter);
  Stream.Readable = Readable;
  Stream.Writable = Writable;
  Stream.Duplex = Duplex;
  Stream.Transform = Transform;
  Stream.PassThrough = PassThrough;

  // Backwards-compat with node 0.4.x
  Stream.Stream = Stream;

  // old-style streams.  Note that the pipe method (the only relevant
  // part of this class) is overridden in the Readable class.

  function Stream() {
    EventEmitter.call(this);
  }

  Stream.prototype.pipe = function(dest, options) {
    var source = this;

    function ondata(chunk) {
      if (dest.writable) {
        if (false === dest.write(chunk) && source.pause) {
          source.pause();
        }
      }
    }

    source.on('data', ondata);

    function ondrain() {
      if (source.readable && source.resume) {
        source.resume();
      }
    }

    dest.on('drain', ondrain);

    // If the 'end' option is not supplied, dest.end() will be called when
    // source gets the 'end' or 'close' events.  Only dest.end() once.
    if (!dest._isStdio && (!options || options.end !== false)) {
      source.on('end', onend);
      source.on('close', onclose);
    }

    var didOnEnd = false;
    function onend() {
      if (didOnEnd) return;
      didOnEnd = true;

      dest.end();
    }


    function onclose() {
      if (didOnEnd) return;
      didOnEnd = true;

      if (typeof dest.destroy === 'function') dest.destroy();
    }

    // don't leave dangling pipes when there are errors.
    function onerror(er) {
      cleanup();
      if (EventEmitter.listenerCount(this, 'error') === 0) {
        throw er; // Unhandled stream error in pipe.
      }
    }

    source.on('error', onerror);
    dest.on('error', onerror);

    // remove all the event listeners that were added.
    function cleanup() {
      source.removeListener('data', ondata);
      dest.removeListener('drain', ondrain);

      source.removeListener('end', onend);
      source.removeListener('close', onclose);

      source.removeListener('error', onerror);
      dest.removeListener('error', onerror);

      source.removeListener('end', cleanup);
      source.removeListener('close', cleanup);

      dest.removeListener('close', cleanup);
    }

    source.on('end', cleanup);
    source.on('close', cleanup);

    dest.on('close', cleanup);

    dest.emit('pipe', source);

    // Allow for unix-like usage: A.pipe(B).pipe(C)
    return dest;
  };

  function _typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
      _typeof = function (obj) {
        return typeof obj;
      };
    } else {
      _typeof = function (obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };
    }

    return _typeof(obj);
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
  }

  function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
      return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
  }

  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };

    return _setPrototypeOf(o, p);
  }

  function _assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return self;
  }

  function _possibleConstructorReturn(self, call) {
    if (call && (typeof call === "object" || typeof call === "function")) {
      return call;
    }

    return _assertThisInitialized(self);
  }

  function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
  }

  function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) {
      for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

      return arr2;
    }
  }

  function _iterableToArray(iter) {
    if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
  }

  function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance");
  }

  /*
  The MIT License (MIT)

  Copyright (c) 2016 CoderPuppy

  Permission is hereby granted, free of charge, to any person obtaining a copy
  of this software and associated documentation files (the "Software"), to deal
  in the Software without restriction, including without limitation the rights
  to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
  copies of the Software, and to permit persons to whom the Software is
  furnished to do so, subject to the following conditions:

  The above copyright notice and this permission notice shall be included in all
  copies or substantial portions of the Software.

  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
  IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
  FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
  AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
  LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
  OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
  SOFTWARE.

  */
  var _endianness;
  function endianness() {
    if (typeof _endianness === 'undefined') {
      var a = new ArrayBuffer(2);
      var b = new Uint8Array(a);
      var c = new Uint16Array(a);
      b[0] = 1;
      b[1] = 2;
      if (c[0] === 258) {
        _endianness = 'BE';
      } else if (c[0] === 513){
        _endianness = 'LE';
      } else {
        throw new Error('unable to figure out endianess');
      }
    }
    return _endianness;
  }

  function hostname() {
    if (typeof global$1.location !== 'undefined') {
      return global$1.location.hostname
    } else return '';
  }

  function loadavg() {
    return [];
  }

  function uptime$1() {
    return 0;
  }

  function freemem() {
    return Number.MAX_VALUE;
  }

  function totalmem() {
    return Number.MAX_VALUE;
  }

  function cpus() {
    return [];
  }

  function type() {
    return 'Browser';
  }

  function release$1 () {
    if (typeof global$1.navigator !== 'undefined') {
      return global$1.navigator.appVersion;
    }
    return '';
  }

  function networkInterfaces(){}
  function getNetworkInterfaces(){}

  function tmpDir() {
    return '/tmp';
  }
  var tmpdir = tmpDir;

  var EOL = '\n';
  var os = {
    EOL: EOL,
    tmpdir: tmpdir,
    tmpDir: tmpDir,
    networkInterfaces:networkInterfaces,
    getNetworkInterfaces: getNetworkInterfaces,
    release: release$1,
    type: type,
    cpus: cpus,
    totalmem: totalmem,
    freemem: freemem,
    uptime: uptime$1,
    loadavg: loadavg,
    hostname: hostname,
    endianness: endianness,
  };

  var commonjsGlobal = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

  /**
   * lodash (Custom Build) <https://lodash.com/>
   * Build: `lodash modularize exports="npm" -o ./`
   * Copyright jQuery Foundation and other contributors <https://jquery.org/>
   * Released under MIT license <https://lodash.com/license>
   * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
   * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
   */

  /** Used as the `TypeError` message for "Functions" methods. */
  var FUNC_ERROR_TEXT = 'Expected a function';

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED = '__lodash_hash_undefined__';

  /** Used as references for various `Number` constants. */
  var INFINITY = 1 / 0;

  /** `Object#toString` result references. */
  var funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      symbolTag = '[object Symbol]';

  /** Used to match property names within property paths. */
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/,
      reLeadingDot = /^\./,
      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

  /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

  /** Used to match backslashes in property paths. */
  var reEscapeChar = /\\(\\)?/g;

  /** Used to detect host constructors (Safari). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

  /** Detect free variable `self`. */
  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

  /** Used as a reference to the global object. */
  var root = freeGlobal || freeSelf || Function('return this')();

  /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function getValue(object, key) {
    return object == null ? undefined : object[key];
  }

  /**
   * Checks if `value` is a host object in IE < 9.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
   */
  function isHostObject(value) {
    // Many host objects are `Object` objects that can coerce to strings
    // despite having improperly defined `toString` methods.
    var result = false;
    if (value != null && typeof value.toString != 'function') {
      try {
        result = !!(value + '');
      } catch (e) {}
    }
    return result;
  }

  /** Used for built-in method references. */
  var arrayProto = Array.prototype,
      funcProto = Function.prototype,
      objectProto = Object.prototype;

  /** Used to detect overreaching core-js shims. */
  var coreJsData = root['__core-js_shared__'];

  /** Used to detect methods masquerading as native. */
  var maskSrcKey = (function() {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
    return uid ? ('Symbol(src)_1.' + uid) : '';
  }());

  /** Used to resolve the decompiled source of functions. */
  var funcToString = funcProto.toString;

  /** Used to check objects for own properties. */
  var hasOwnProperty$1 = objectProto.hasOwnProperty;

  /**
   * Used to resolve the
   * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
   * of values.
   */
  var objectToString$1 = objectProto.toString;

  /** Used to detect if a method is native. */
  var reIsNative = RegExp('^' +
    funcToString.call(hasOwnProperty$1).replace(reRegExpChar, '\\$&')
    .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
  );

  /** Built-in value references. */
  var Symbol$1 = root.Symbol,
      splice = arrayProto.splice;

  /* Built-in method references that are verified to be native. */
  var Map = getNative(root, 'Map'),
      nativeCreate = getNative(Object, 'create');

  /** Used to convert symbols to primitives and strings. */
  var symbolProto = Symbol$1 ? Symbol$1.prototype : undefined,
      symbolToString = symbolProto ? symbolProto.toString : undefined;

  /**
   * Creates a hash object.
   *
   * @private
   * @constructor
   * @param {Array} [entries] The key-value pairs to cache.
   */
  function Hash(entries) {
    var index = -1,
        length = entries ? entries.length : 0;

    this.clear();
    while (++index < length) {
      var entry = entries[index];
      this.set(entry[0], entry[1]);
    }
  }

  /**
   * Removes all key-value entries from the hash.
   *
   * @private
   * @name clear
   * @memberOf Hash
   */
  function hashClear() {
    this.__data__ = nativeCreate ? nativeCreate(null) : {};
  }

  /**
   * Removes `key` and its value from the hash.
   *
   * @private
   * @name delete
   * @memberOf Hash
   * @param {Object} hash The hash to modify.
   * @param {string} key The key of the value to remove.
   * @returns {boolean} Returns `true` if the entry was removed, else `false`.
   */
  function hashDelete(key) {
    return this.has(key) && delete this.__data__[key];
  }

  /**
   * Gets the hash value for `key`.
   *
   * @private
   * @name get
   * @memberOf Hash
   * @param {string} key The key of the value to get.
   * @returns {*} Returns the entry value.
   */
  function hashGet(key) {
    var data = this.__data__;
    if (nativeCreate) {
      var result = data[key];
      return result === HASH_UNDEFINED ? undefined : result;
    }
    return hasOwnProperty$1.call(data, key) ? data[key] : undefined;
  }

  /**
   * Checks if a hash value for `key` exists.
   *
   * @private
   * @name has
   * @memberOf Hash
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function hashHas(key) {
    var data = this.__data__;
    return nativeCreate ? data[key] !== undefined : hasOwnProperty$1.call(data, key);
  }

  /**
   * Sets the hash `key` to `value`.
   *
   * @private
   * @name set
   * @memberOf Hash
   * @param {string} key The key of the value to set.
   * @param {*} value The value to set.
   * @returns {Object} Returns the hash instance.
   */
  function hashSet(key, value) {
    var data = this.__data__;
    data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
    return this;
  }

  // Add methods to `Hash`.
  Hash.prototype.clear = hashClear;
  Hash.prototype['delete'] = hashDelete;
  Hash.prototype.get = hashGet;
  Hash.prototype.has = hashHas;
  Hash.prototype.set = hashSet;

  /**
   * Creates an list cache object.
   *
   * @private
   * @constructor
   * @param {Array} [entries] The key-value pairs to cache.
   */
  function ListCache(entries) {
    var index = -1,
        length = entries ? entries.length : 0;

    this.clear();
    while (++index < length) {
      var entry = entries[index];
      this.set(entry[0], entry[1]);
    }
  }

  /**
   * Removes all key-value entries from the list cache.
   *
   * @private
   * @name clear
   * @memberOf ListCache
   */
  function listCacheClear() {
    this.__data__ = [];
  }

  /**
   * Removes `key` and its value from the list cache.
   *
   * @private
   * @name delete
   * @memberOf ListCache
   * @param {string} key The key of the value to remove.
   * @returns {boolean} Returns `true` if the entry was removed, else `false`.
   */
  function listCacheDelete(key) {
    var data = this.__data__,
        index = assocIndexOf(data, key);

    if (index < 0) {
      return false;
    }
    var lastIndex = data.length - 1;
    if (index == lastIndex) {
      data.pop();
    } else {
      splice.call(data, index, 1);
    }
    return true;
  }

  /**
   * Gets the list cache value for `key`.
   *
   * @private
   * @name get
   * @memberOf ListCache
   * @param {string} key The key of the value to get.
   * @returns {*} Returns the entry value.
   */
  function listCacheGet(key) {
    var data = this.__data__,
        index = assocIndexOf(data, key);

    return index < 0 ? undefined : data[index][1];
  }

  /**
   * Checks if a list cache value for `key` exists.
   *
   * @private
   * @name has
   * @memberOf ListCache
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function listCacheHas(key) {
    return assocIndexOf(this.__data__, key) > -1;
  }

  /**
   * Sets the list cache `key` to `value`.
   *
   * @private
   * @name set
   * @memberOf ListCache
   * @param {string} key The key of the value to set.
   * @param {*} value The value to set.
   * @returns {Object} Returns the list cache instance.
   */
  function listCacheSet(key, value) {
    var data = this.__data__,
        index = assocIndexOf(data, key);

    if (index < 0) {
      data.push([key, value]);
    } else {
      data[index][1] = value;
    }
    return this;
  }

  // Add methods to `ListCache`.
  ListCache.prototype.clear = listCacheClear;
  ListCache.prototype['delete'] = listCacheDelete;
  ListCache.prototype.get = listCacheGet;
  ListCache.prototype.has = listCacheHas;
  ListCache.prototype.set = listCacheSet;

  /**
   * Creates a map cache object to store key-value pairs.
   *
   * @private
   * @constructor
   * @param {Array} [entries] The key-value pairs to cache.
   */
  function MapCache(entries) {
    var index = -1,
        length = entries ? entries.length : 0;

    this.clear();
    while (++index < length) {
      var entry = entries[index];
      this.set(entry[0], entry[1]);
    }
  }

  /**
   * Removes all key-value entries from the map.
   *
   * @private
   * @name clear
   * @memberOf MapCache
   */
  function mapCacheClear() {
    this.__data__ = {
      'hash': new Hash,
      'map': new (Map || ListCache),
      'string': new Hash
    };
  }

  /**
   * Removes `key` and its value from the map.
   *
   * @private
   * @name delete
   * @memberOf MapCache
   * @param {string} key The key of the value to remove.
   * @returns {boolean} Returns `true` if the entry was removed, else `false`.
   */
  function mapCacheDelete(key) {
    return getMapData(this, key)['delete'](key);
  }

  /**
   * Gets the map value for `key`.
   *
   * @private
   * @name get
   * @memberOf MapCache
   * @param {string} key The key of the value to get.
   * @returns {*} Returns the entry value.
   */
  function mapCacheGet(key) {
    return getMapData(this, key).get(key);
  }

  /**
   * Checks if a map value for `key` exists.
   *
   * @private
   * @name has
   * @memberOf MapCache
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function mapCacheHas(key) {
    return getMapData(this, key).has(key);
  }

  /**
   * Sets the map `key` to `value`.
   *
   * @private
   * @name set
   * @memberOf MapCache
   * @param {string} key The key of the value to set.
   * @param {*} value The value to set.
   * @returns {Object} Returns the map cache instance.
   */
  function mapCacheSet(key, value) {
    getMapData(this, key).set(key, value);
    return this;
  }

  // Add methods to `MapCache`.
  MapCache.prototype.clear = mapCacheClear;
  MapCache.prototype['delete'] = mapCacheDelete;
  MapCache.prototype.get = mapCacheGet;
  MapCache.prototype.has = mapCacheHas;
  MapCache.prototype.set = mapCacheSet;

  /**
   * Gets the index at which the `key` is found in `array` of key-value pairs.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} key The key to search for.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function assocIndexOf(array, key) {
    var length = array.length;
    while (length--) {
      if (eq(array[length][0], key)) {
        return length;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.get` without support for default values.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array|string} path The path of the property to get.
   * @returns {*} Returns the resolved value.
   */
  function baseGet(object, path) {
    path = isKey(path, object) ? [path] : castPath(path);

    var index = 0,
        length = path.length;

    while (object != null && index < length) {
      object = object[toKey(path[index++])];
    }
    return (index && index == length) ? object : undefined;
  }

  /**
   * The base implementation of `_.isNative` without bad shim checks.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a native function,
   *  else `false`.
   */
  function baseIsNative(value) {
    if (!isObject$1(value) || isMasked(value)) {
      return false;
    }
    var pattern = (isFunction$1(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
  }

  /**
   * The base implementation of `_.toString` which doesn't convert nullish
   * values to empty strings.
   *
   * @private
   * @param {*} value The value to process.
   * @returns {string} Returns the string.
   */
  function baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') {
      return value;
    }
    if (isSymbol(value)) {
      return symbolToString ? symbolToString.call(value) : '';
    }
    var result = (value + '');
    return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
  }

  /**
   * Casts `value` to a path array if it's not one.
   *
   * @private
   * @param {*} value The value to inspect.
   * @returns {Array} Returns the cast property path array.
   */
  function castPath(value) {
    return isArray$2(value) ? value : stringToPath(value);
  }

  /**
   * Gets the data for `map`.
   *
   * @private
   * @param {Object} map The map to query.
   * @param {string} key The reference key.
   * @returns {*} Returns the map data.
   */
  function getMapData(map, key) {
    var data = map.__data__;
    return isKeyable(key)
      ? data[typeof key == 'string' ? 'string' : 'hash']
      : data.map;
  }

  /**
   * Gets the native function at `key` of `object`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {string} key The key of the method to get.
   * @returns {*} Returns the function if it's native, else `undefined`.
   */
  function getNative(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : undefined;
  }

  /**
   * Checks if `value` is a property name and not a property path.
   *
   * @private
   * @param {*} value The value to check.
   * @param {Object} [object] The object to query keys on.
   * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
   */
  function isKey(value, object) {
    if (isArray$2(value)) {
      return false;
    }
    var type = typeof value;
    if (type == 'number' || type == 'symbol' || type == 'boolean' ||
        value == null || isSymbol(value)) {
      return true;
    }
    return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
      (object != null && value in Object(object));
  }

  /**
   * Checks if `value` is suitable for use as unique object key.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
   */
  function isKeyable(value) {
    var type = typeof value;
    return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
      ? (value !== '__proto__')
      : (value === null);
  }

  /**
   * Checks if `func` has its source masked.
   *
   * @private
   * @param {Function} func The function to check.
   * @returns {boolean} Returns `true` if `func` is masked, else `false`.
   */
  function isMasked(func) {
    return !!maskSrcKey && (maskSrcKey in func);
  }

  /**
   * Converts `string` to a property path array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the property path array.
   */
  var stringToPath = memoize(function(string) {
    string = toString$1(string);

    var result = [];
    if (reLeadingDot.test(string)) {
      result.push('');
    }
    string.replace(rePropName, function(match, number, quote, string) {
      result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
    });
    return result;
  });

  /**
   * Converts `value` to a string key if it's not a string or symbol.
   *
   * @private
   * @param {*} value The value to inspect.
   * @returns {string|symbol} Returns the key.
   */
  function toKey(value) {
    if (typeof value == 'string' || isSymbol(value)) {
      return value;
    }
    var result = (value + '');
    return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
  }

  /**
   * Converts `func` to its source code.
   *
   * @private
   * @param {Function} func The function to process.
   * @returns {string} Returns the source code.
   */
  function toSource(func) {
    if (func != null) {
      try {
        return funcToString.call(func);
      } catch (e) {}
      try {
        return (func + '');
      } catch (e) {}
    }
    return '';
  }

  /**
   * Creates a function that memoizes the result of `func`. If `resolver` is
   * provided, it determines the cache key for storing the result based on the
   * arguments provided to the memoized function. By default, the first argument
   * provided to the memoized function is used as the map cache key. The `func`
   * is invoked with the `this` binding of the memoized function.
   *
   * **Note:** The cache is exposed as the `cache` property on the memoized
   * function. Its creation may be customized by replacing the `_.memoize.Cache`
   * constructor with one whose instances implement the
   * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
   * method interface of `delete`, `get`, `has`, and `set`.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Function
   * @param {Function} func The function to have its output memoized.
   * @param {Function} [resolver] The function to resolve the cache key.
   * @returns {Function} Returns the new memoized function.
   * @example
   *
   * var object = { 'a': 1, 'b': 2 };
   * var other = { 'c': 3, 'd': 4 };
   *
   * var values = _.memoize(_.values);
   * values(object);
   * // => [1, 2]
   *
   * values(other);
   * // => [3, 4]
   *
   * object.a = 2;
   * values(object);
   * // => [1, 2]
   *
   * // Modify the result cache.
   * values.cache.set(object, ['a', 'b']);
   * values(object);
   * // => ['a', 'b']
   *
   * // Replace `_.memoize.Cache`.
   * _.memoize.Cache = WeakMap;
   */
  function memoize(func, resolver) {
    if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
      throw new TypeError(FUNC_ERROR_TEXT);
    }
    var memoized = function() {
      var args = arguments,
          key = resolver ? resolver.apply(this, args) : args[0],
          cache = memoized.cache;

      if (cache.has(key)) {
        return cache.get(key);
      }
      var result = func.apply(this, args);
      memoized.cache = cache.set(key, result);
      return result;
    };
    memoized.cache = new (memoize.Cache || MapCache);
    return memoized;
  }

  // Assign cache to `_.memoize`.
  memoize.Cache = MapCache;

  /**
   * Performs a
   * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
   * comparison between two values to determine if they are equivalent.
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to compare.
   * @param {*} other The other value to compare.
   * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
   * @example
   *
   * var object = { 'a': 1 };
   * var other = { 'a': 1 };
   *
   * _.eq(object, object);
   * // => true
   *
   * _.eq(object, other);
   * // => false
   *
   * _.eq('a', 'a');
   * // => true
   *
   * _.eq('a', Object('a'));
   * // => false
   *
   * _.eq(NaN, NaN);
   * // => true
   */
  function eq(value, other) {
    return value === other || (value !== value && other !== other);
  }

  /**
   * Checks if `value` is classified as an `Array` object.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is an array, else `false`.
   * @example
   *
   * _.isArray([1, 2, 3]);
   * // => true
   *
   * _.isArray(document.body.children);
   * // => false
   *
   * _.isArray('abc');
   * // => false
   *
   * _.isArray(_.noop);
   * // => false
   */
  var isArray$2 = Array.isArray;

  /**
   * Checks if `value` is classified as a `Function` object.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a function, else `false`.
   * @example
   *
   * _.isFunction(_);
   * // => true
   *
   * _.isFunction(/abc/);
   * // => false
   */
  function isFunction$1(value) {
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 8-9 which returns 'object' for typed array and other constructors.
    var tag = isObject$1(value) ? objectToString$1.call(value) : '';
    return tag == funcTag || tag == genTag;
  }

  /**
   * Checks if `value` is the
   * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
   * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is an object, else `false`.
   * @example
   *
   * _.isObject({});
   * // => true
   *
   * _.isObject([1, 2, 3]);
   * // => true
   *
   * _.isObject(_.noop);
   * // => true
   *
   * _.isObject(null);
   * // => false
   */
  function isObject$1(value) {
    var type = typeof value;
    return !!value && (type == 'object' || type == 'function');
  }

  /**
   * Checks if `value` is object-like. A value is object-like if it's not `null`
   * and has a `typeof` result of "object".
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
   * @example
   *
   * _.isObjectLike({});
   * // => true
   *
   * _.isObjectLike([1, 2, 3]);
   * // => true
   *
   * _.isObjectLike(_.noop);
   * // => false
   *
   * _.isObjectLike(null);
   * // => false
   */
  function isObjectLike(value) {
    return !!value && typeof value == 'object';
  }

  /**
   * Checks if `value` is classified as a `Symbol` primitive or object.
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
   * @example
   *
   * _.isSymbol(Symbol.iterator);
   * // => true
   *
   * _.isSymbol('abc');
   * // => false
   */
  function isSymbol(value) {
    return typeof value == 'symbol' ||
      (isObjectLike(value) && objectToString$1.call(value) == symbolTag);
  }

  /**
   * Converts `value` to a string. An empty string is returned for `null`
   * and `undefined` values. The sign of `-0` is preserved.
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to process.
   * @returns {string} Returns the string.
   * @example
   *
   * _.toString(null);
   * // => ''
   *
   * _.toString(-0);
   * // => '-0'
   *
   * _.toString([1, 2, 3]);
   * // => '1,2,3'
   */
  function toString$1(value) {
    return value == null ? '' : baseToString(value);
  }

  /**
   * Gets the value at `path` of `object`. If the resolved value is
   * `undefined`, the `defaultValue` is returned in its place.
   *
   * @static
   * @memberOf _
   * @since 3.7.0
   * @category Object
   * @param {Object} object The object to query.
   * @param {Array|string} path The path of the property to get.
   * @param {*} [defaultValue] The value returned for `undefined` resolved values.
   * @returns {*} Returns the resolved value.
   * @example
   *
   * var object = { 'a': [{ 'b': { 'c': 3 } }] };
   *
   * _.get(object, 'a[0].b.c');
   * // => 3
   *
   * _.get(object, ['a', '0', 'b', 'c']);
   * // => 3
   *
   * _.get(object, 'a.b.c', 'default');
   * // => 'default'
   */
  function get(object, path, defaultValue) {
    var result = object == null ? undefined : baseGet(object, path);
    return result === undefined ? defaultValue : result;
  }

  var lodash_get = get;

  function getProp(obj, path, defaultValue) {
    return obj[path] === undefined ? defaultValue : obj[path];
  }

  function setProp(obj, path, value) {
    var pathArray = Array.isArray(path) ? path : path.split('.');
    var key = pathArray[0];
    var newValue = pathArray.length > 1 ? setProp(obj[key] || {}, pathArray.slice(1), value) : value;
    return Object.assign({}, obj, _defineProperty({}, key, newValue));
  }

  function flattenReducer(acc, arr) {
    try {
      // This is faster but susceptible to `RangeError: Maximum call stack size exceeded`
      acc.push.apply(acc, _toConsumableArray(arr));
      return acc;
    } catch (err) {
      // Fallback to a slower but safer option
      return acc.concat(arr);
    }
  }

  function fastJoin(arr, separator) {
    var isFirst = true;
    return arr.reduce(function (acc, elem) {
      if (elem === null || elem === undefined) {
        elem = '';
      }

      if (isFirst) {
        isFirst = false;
        return "".concat(elem);
      }

      return "".concat(acc).concat(separator).concat(elem);
    }, '');
  }

  var utils = {
    getProp: getProp,
    setProp: setProp,
    fastJoin: fastJoin,
    flattenReducer: flattenReducer
  };

  var getProp$1 = utils.getProp,
      setProp$1 = utils.setProp,
      fastJoin$1 = utils.fastJoin,
      flattenReducer$1 = utils.flattenReducer;

  var JSON2CSVBase =
  /*#__PURE__*/
  function () {
    function JSON2CSVBase(opts) {
      _classCallCheck(this, JSON2CSVBase);

      this.opts = this.preprocessOpts(opts);
      this.preprocessRow = this.memoizePreprocessRow();
    }
    /**
     * Check passing opts and set defaults.
     *
     * @param {Json2CsvOptions} opts Options object containing fields,
     * delimiter, default value, quote mark, header, etc.
     */


    _createClass(JSON2CSVBase, [{
      key: "preprocessOpts",
      value: function preprocessOpts(opts) {
        var processedOpts = Object.assign({}, opts);
        processedOpts.unwind = !Array.isArray(processedOpts.unwind) ? processedOpts.unwind ? [processedOpts.unwind] : [] : processedOpts.unwind;
        processedOpts.delimiter = processedOpts.delimiter || ',';
        processedOpts.flattenSeparator = processedOpts.flattenSeparator || '.';
        processedOpts.eol = processedOpts.eol || os.EOL;
        processedOpts.quote = typeof processedOpts.quote === 'string' ? opts.quote : '"';
        processedOpts.doubleQuote = typeof processedOpts.doubleQuote === 'string' ? processedOpts.doubleQuote : processedOpts.quote + processedOpts.quote;
        processedOpts.header = processedOpts.header !== false;
        processedOpts.includeEmptyRows = processedOpts.includeEmptyRows || false;
        processedOpts.withBOM = processedOpts.withBOM || false;
        return processedOpts;
      }
      /**
       * Check and normalize the fields configuration.
       *
       * @param {(string|object)[]} fields Fields configuration provided by the user
       * or inferred from the data
       * @returns {object[]} preprocessed FieldsInfo array
       */

    }, {
      key: "preprocessFieldsInfo",
      value: function preprocessFieldsInfo(fields) {
        var _this = this;

        return fields.map(function (fieldInfo) {
          if (typeof fieldInfo === 'string') {
            return {
              label: fieldInfo,
              value: fieldInfo.includes('.') || fieldInfo.includes('[') ? function (row) {
                return lodash_get(row, fieldInfo, _this.opts.defaultValue);
              } : function (row) {
                return getProp$1(row, fieldInfo, _this.opts.defaultValue);
              },
              stringify: true
            };
          }

          if (_typeof(fieldInfo) === 'object') {
            var defaultValue = 'default' in fieldInfo ? fieldInfo.default : _this.opts.defaultValue;

            if (typeof fieldInfo.value === 'string') {
              return {
                label: fieldInfo.label || fieldInfo.value,
                value: fieldInfo.value.includes('.') || fieldInfo.value.includes('[') ? function (row) {
                  return lodash_get(row, fieldInfo.value, defaultValue);
                } : function (row) {
                  return getProp$1(row, fieldInfo.value, defaultValue);
                },
                stringify: fieldInfo.stringify !== undefined ? fieldInfo.stringify : true
              };
            }

            if (typeof fieldInfo.value === 'function') {
              var label = fieldInfo.label || fieldInfo.value;
              var field = {
                label: label,
                default: defaultValue
              };
              return {
                label: label,
                value: function value(row) {
                  var value = fieldInfo.value(row, field);
                  return value === null || value === undefined ? defaultValue : value;
                },
                stringify: fieldInfo.stringify !== undefined ? fieldInfo.stringify : true
              };
            }
          }

          throw new Error('Invalid field info option. ' + JSON.stringify(fieldInfo));
        });
      }
      /**
       * Create the title row with all the provided fields as column headings
       *
       * @returns {String} titles as a string
       */

    }, {
      key: "getHeader",
      value: function getHeader() {
        var _this2 = this;

        return fastJoin$1(this.opts.fields.map(function (fieldInfo) {
          return _this2.processValue(fieldInfo.label, true);
        }), this.opts.delimiter);
      }
    }, {
      key: "memoizePreprocessRow",
      value: function memoizePreprocessRow() {
        if (this.opts.unwind && this.opts.unwind.length) {
          if (this.opts.flatten) {
            return function (row) {
              var _this3 = this;

              return this.unwindData(row, this.opts.unwind).map(function (row) {
                return _this3.flatten(row, _this3.opts.flattenSeparator);
              });
            };
          }

          return function (row) {
            return this.unwindData(row, this.opts.unwind);
          };
        }

        if (this.opts.flatten) {
          return function (row) {
            return [this.flatten(row, this.opts.flattenSeparator)];
          };
        }

        return function (row) {
          return [row];
        };
      }
      /**
       * Preprocess each object according to the give opts (unwind, flatten, etc.).
       * The actual body of the function is dynamically set on the constructor by the
       *  `memoizePreprocessRow` method after parsing the options.
       *
       * @param {Object} row JSON object to be converted in a CSV row
       */

    }, {
      key: "preprocessRow",
      value: function preprocessRow() {}
      /**
       * Create the content of a specific CSV row
       *
       * @param {Object} row JSON object to be converted in a CSV row
       * @returns {String} CSV string (row)
       */

    }, {
      key: "processRow",
      value: function processRow(row) {
        var _this4 = this;

        if (!row) {
          return undefined;
        }

        var processedRow = this.opts.fields.map(function (fieldInfo) {
          return _this4.processCell(row, fieldInfo);
        });

        if (!this.opts.includeEmptyRows && processedRow.every(function (field) {
          return field === undefined;
        })) {
          return undefined;
        }

        return fastJoin$1(processedRow, this.opts.delimiter);
      }
      /**
       * Create the content of a specfic CSV row cell
       *
       * @param {Object} row JSON object representing the  CSV row that the cell belongs to
       * @param {FieldInfo} fieldInfo Details of the field to process to be a CSV cell
       * @returns {String} CSV string (cell)
       */

    }, {
      key: "processCell",
      value: function processCell(row, fieldInfo) {
        return this.processValue(fieldInfo.value(row), fieldInfo.stringify);
      }
      /**
       * Create the content of a specfic CSV row cell
       *
       * @param {Any} value Value to be included in a CSV cell
       * @param {Boolean} stringify Details of the field to process to be a CSV cell
       * @returns {String} Value stringified and processed
       */

    }, {
      key: "processValue",
      value: function processValue(value, stringify) {
        if (value === null || value === undefined) {
          return undefined;
        }

        var valueType = _typeof(value);

        if (valueType !== 'boolean' && valueType !== 'number' && valueType !== 'string') {
          value = JSON.stringify(value);

          if (value === undefined) {
            return undefined;
          }

          if (value[0] === '"') {
            value = value.replace(/^"(.+)"$/, '$1');
          }
        }

        if (typeof value === 'string') {
          if (value.includes(this.opts.quote)) {
            value = value.replace(new RegExp(this.opts.quote, 'g'), this.opts.doubleQuote);
          } // This should probably be remove together with the whole strignify option


          if (stringify) {
            value = "".concat(this.opts.quote).concat(value).concat(this.opts.quote);
          } else {
            value = value.replace(new RegExp("^".concat(this.opts.doubleQuote)), this.opts.quote).replace(new RegExp("".concat(this.opts.doubleQuote, "$")), this.opts.quote);
          }

          if (this.opts.excelStrings) {
            value = "\"=\"".concat(value, "\"\"");
          }
        }

        return value;
      }
      /**
       * Performs the flattening of a data row recursively
       *
       * @param {Object} dataRow Original JSON object
       * @param {String} separator Separator to be used as the flattened field name
       * @returns {Object} Flattened object
       */

    }, {
      key: "flatten",
      value: function flatten(dataRow, separator) {
        function step(obj, flatDataRow, currentPath) {
          Object.keys(obj).forEach(function (key) {
            var value = obj[key];
            var newPath = currentPath ? "".concat(currentPath).concat(separator).concat(key) : key;

            if (_typeof(value) !== 'object' || value === null || Array.isArray(value) || Object.prototype.toString.call(value.toJSON) === '[object Function]' || !Object.keys(value).length) {
              flatDataRow[newPath] = value;
              return;
            }

            step(value, flatDataRow, newPath);
          });
          return flatDataRow;
        }

        return step(dataRow, {});
      }
      /**
       * Performs the unwind recursively in specified sequence
       *
       * @param {Object} dataRow Original JSON object
       * @param {String[]} unwindPaths The paths as strings to be used to deconstruct the array
       * @returns {Array} Array of objects containing all rows after unwind of chosen paths
      */

    }, {
      key: "unwindData",
      value: function unwindData(dataRow, unwindPaths) {
        var _this5 = this;

        var unwind = function unwind(rows, unwindPath) {
          return rows.map(function (row) {
            var unwindArray = lodash_get(row, unwindPath);

            if (!Array.isArray(unwindArray)) {
              return row;
            }

            if (!unwindArray.length) {
              return setProp$1(row, unwindPath, undefined);
            }

            return unwindArray.map(function (unwindRow, index) {
              var clonedRow = _this5.opts.unwindBlank && index > 0 ? {} : row;
              return setProp$1(clonedRow, unwindPath, unwindRow);
            });
          }).reduce(flattenReducer$1, []);
        };

        return unwindPaths.reduce(unwind, [dataRow]);
      }
    }]);

    return JSON2CSVBase;
  }();

  var JSON2CSVBase_1 = JSON2CSVBase;

  var fastJoin$2 = utils.fastJoin,
      flattenReducer$2 = utils.flattenReducer;

  var JSON2CSVParser =
  /*#__PURE__*/
  function (_JSON2CSVBase) {
    _inherits(JSON2CSVParser, _JSON2CSVBase);

    function JSON2CSVParser(opts) {
      var _this;

      _classCallCheck(this, JSON2CSVParser);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(JSON2CSVParser).call(this, opts));

      if (_this.opts.fields) {
        _this.opts.fields = _this.preprocessFieldsInfo(_this.opts.fields);
      }

      return _this;
    }
    /**
     * Main function that converts json to csv.
     *
     * @param {Array|Object} data Array of JSON objects to be converted to CSV
     * @returns {String} The CSV formated data as a string
     */


    _createClass(JSON2CSVParser, [{
      key: "parse",
      value: function parse(data) {
        var processedData = this.preprocessData(data);

        if (!this.opts.fields) {
          this.opts.fields = processedData.reduce(function (fields, item) {
            Object.keys(item).forEach(function (field) {
              if (!fields.includes(field)) {
                fields.push(field);
              }
            });
            return fields;
          }, []);
          this.opts.fields = this.preprocessFieldsInfo(this.opts.fields);
        }

        var header = this.opts.header ? this.getHeader() : '';
        var rows = this.processData(processedData);
        var csv = (this.opts.withBOM ? "\uFEFF" : '') + header + (header && rows ? this.opts.eol : '') + rows;
        return csv;
      }
      /**
       * Preprocess the data according to the give opts (unwind, flatten, etc.)
        and calculate the fields and field names if they are not provided.
       *
       * @param {Array|Object} data Array or object to be converted to CSV
       */

    }, {
      key: "preprocessData",
      value: function preprocessData(data) {
        var _this2 = this;

        var processedData = Array.isArray(data) ? data : [data];

        if (!this.opts.fields && (processedData.length === 0 || _typeof(processedData[0]) !== 'object')) {
          throw new Error('Data should not be empty or the "fields" option should be included');
        }

        if ((!this.opts.unwind || !this.opts.unwind.length) && !this.opts.flatten) {
          return processedData;
        }

        return processedData.map(function (row) {
          return _this2.preprocessRow(row);
        }).reduce(flattenReducer$2, []);
      }
      /**
       * Create the content row by row below the header
       *
       * @param {Array} data Array of JSON objects to be converted to CSV
       * @returns {String} CSV string (body)
       */

    }, {
      key: "processData",
      value: function processData(data) {
        var _this3 = this;

        return fastJoin$2(data.map(function (row) {
          return _this3.processRow(row);
        }).filter(function (row) {
          return row;
        }), // Filter empty rows
        this.opts.eol);
      }
    }]);

    return JSON2CSVParser;
  }(JSON2CSVBase_1);

  var JSON2CSVParser_1 = JSON2CSVParser;

  /*global Buffer*/
  // Named constants with unique integer values
  var C = {};
  // Tokens
  var LEFT_BRACE    = C.LEFT_BRACE    = 0x1;
  var RIGHT_BRACE   = C.RIGHT_BRACE   = 0x2;
  var LEFT_BRACKET  = C.LEFT_BRACKET  = 0x3;
  var RIGHT_BRACKET = C.RIGHT_BRACKET = 0x4;
  var COLON         = C.COLON         = 0x5;
  var COMMA         = C.COMMA         = 0x6;
  var TRUE          = C.TRUE          = 0x7;
  var FALSE         = C.FALSE         = 0x8;
  var NULL          = C.NULL          = 0x9;
  var STRING        = C.STRING        = 0xa;
  var NUMBER        = C.NUMBER        = 0xb;
  // Tokenizer States
  var START   = C.START   = 0x11;
  var STOP    = C.STOP    = 0x12;
  var TRUE1   = C.TRUE1   = 0x21;
  var TRUE2   = C.TRUE2   = 0x22;
  var TRUE3   = C.TRUE3   = 0x23;
  var FALSE1  = C.FALSE1  = 0x31;
  var FALSE2  = C.FALSE2  = 0x32;
  var FALSE3  = C.FALSE3  = 0x33;
  var FALSE4  = C.FALSE4  = 0x34;
  var NULL1   = C.NULL1   = 0x41;
  var NULL2   = C.NULL2   = 0x42;
  var NULL3   = C.NULL3   = 0x43;
  var NUMBER1 = C.NUMBER1 = 0x51;
  var NUMBER3 = C.NUMBER3 = 0x53;
  var STRING1 = C.STRING1 = 0x61;
  var STRING2 = C.STRING2 = 0x62;
  var STRING3 = C.STRING3 = 0x63;
  var STRING4 = C.STRING4 = 0x64;
  var STRING5 = C.STRING5 = 0x65;
  var STRING6 = C.STRING6 = 0x66;
  // Parser States
  var VALUE   = C.VALUE   = 0x71;
  var KEY     = C.KEY     = 0x72;
  // Parser Modes
  var OBJECT  = C.OBJECT  = 0x81;
  var ARRAY   = C.ARRAY   = 0x82;
  // Character constants
  var BACK_SLASH =      "\\".charCodeAt(0);
  var FORWARD_SLASH =   "\/".charCodeAt(0);
  var BACKSPACE =       "\b".charCodeAt(0);
  var FORM_FEED =       "\f".charCodeAt(0);
  var NEWLINE =         "\n".charCodeAt(0);
  var CARRIAGE_RETURN = "\r".charCodeAt(0);
  var TAB =             "\t".charCodeAt(0);

  var STRING_BUFFER_SIZE = 64 * 1024;

  function Parser() {
    this.tState = START;
    this.value = undefined;

    this.string = undefined; // string data
    this.stringBuffer = Buffer.alloc ? Buffer.alloc(STRING_BUFFER_SIZE) : new Buffer(STRING_BUFFER_SIZE);
    this.stringBufferOffset = 0;
    this.unicode = undefined; // unicode escapes
    this.highSurrogate = undefined;

    this.key = undefined;
    this.mode = undefined;
    this.stack = [];
    this.state = VALUE;
    this.bytes_remaining = 0; // number of bytes remaining in multi byte utf8 char to read after split boundary
    this.bytes_in_sequence = 0; // bytes in multi byte utf8 char to read
    this.temp_buffs = { "2": new Buffer(2), "3": new Buffer(3), "4": new Buffer(4) }; // for rebuilding chars split before boundary is reached

    // Stream offset
    this.offset = -1;
  }

  // Slow code to string converter (only used when throwing syntax errors)
  Parser.toknam = function (code) {
    var keys = Object.keys(C);
    for (var i = 0, l = keys.length; i < l; i++) {
      var key = keys[i];
      if (C[key] === code) { return key; }
    }
    return code && ("0x" + code.toString(16));
  };

  var proto = Parser.prototype;
  proto.onError = function (err) { throw err; };
  proto.charError = function (buffer, i) {
    this.tState = STOP;
    this.onError(new Error("Unexpected " + JSON.stringify(String.fromCharCode(buffer[i])) + " at position " + i + " in state " + Parser.toknam(this.tState)));
  };
  proto.appendStringChar = function (char) {
    if (this.stringBufferOffset >= STRING_BUFFER_SIZE) {
      this.string += this.stringBuffer.toString('utf8');
      this.stringBufferOffset = 0;
    }

    this.stringBuffer[this.stringBufferOffset++] = char;
  };
  proto.appendStringBuf = function (buf, start, end) {
    var size = buf.length;
    if (typeof start === 'number') {
      if (typeof end === 'number') {
        if (end < 0) {
          // adding a negative end decreeses the size
          size = buf.length - start + end;
        } else {
          size = end - start;
        }
      } else {
        size = buf.length - start;
      }
    }

    if (size < 0) {
      size = 0;
    }

    if (this.stringBufferOffset + size > STRING_BUFFER_SIZE) {
      this.string += this.stringBuffer.toString('utf8', 0, this.stringBufferOffset);
      this.stringBufferOffset = 0;
    }

    buf.copy(this.stringBuffer, this.stringBufferOffset, start, end);
    this.stringBufferOffset += size;
  };
  proto.write = function (buffer) {
    if (typeof buffer === "string") buffer = new Buffer(buffer);
    var n;
    for (var i = 0, l = buffer.length; i < l; i++) {
      if (this.tState === START){
        n = buffer[i];
        this.offset++;
        if(n === 0x7b){ this.onToken(LEFT_BRACE, "{"); // {
        }else if(n === 0x7d){ this.onToken(RIGHT_BRACE, "}"); // }
        }else if(n === 0x5b){ this.onToken(LEFT_BRACKET, "["); // [
        }else if(n === 0x5d){ this.onToken(RIGHT_BRACKET, "]"); // ]
        }else if(n === 0x3a){ this.onToken(COLON, ":");  // :
        }else if(n === 0x2c){ this.onToken(COMMA, ","); // ,
        }else if(n === 0x74){ this.tState = TRUE1;  // t
        }else if(n === 0x66){ this.tState = FALSE1;  // f
        }else if(n === 0x6e){ this.tState = NULL1; // n
        }else if(n === 0x22){ // "
          this.string = "";
          this.stringBufferOffset = 0;
          this.tState = STRING1;
        }else if(n === 0x2d){ this.string = "-"; this.tState = NUMBER1; // -
        }else{
          if (n >= 0x30 && n < 0x40) { // 1-9
            this.string = String.fromCharCode(n); this.tState = NUMBER3;
          } else if (n === 0x20 || n === 0x09 || n === 0x0a || n === 0x0d) ; else {
            return this.charError(buffer, i);
          }
        }
      }else if (this.tState === STRING1){ // After open quote
        n = buffer[i]; // get current byte from buffer
        // check for carry over of a multi byte char split between data chunks
        // & fill temp buffer it with start of this data chunk up to the boundary limit set in the last iteration
        if (this.bytes_remaining > 0) {
          for (var j = 0; j < this.bytes_remaining; j++) {
            this.temp_buffs[this.bytes_in_sequence][this.bytes_in_sequence - this.bytes_remaining + j] = buffer[j];
          }

          this.appendStringBuf(this.temp_buffs[this.bytes_in_sequence]);
          this.bytes_in_sequence = this.bytes_remaining = 0;
          i = i + j - 1;
        } else if (this.bytes_remaining === 0 && n >= 128) { // else if no remainder bytes carried over, parse multi byte (>=128) chars one at a time
          if (n <= 193 || n > 244) {
            return this.onError(new Error("Invalid UTF-8 character at position " + i + " in state " + Parser.toknam(this.tState)));
          }
          if ((n >= 194) && (n <= 223)) this.bytes_in_sequence = 2;
          if ((n >= 224) && (n <= 239)) this.bytes_in_sequence = 3;
          if ((n >= 240) && (n <= 244)) this.bytes_in_sequence = 4;
          if ((this.bytes_in_sequence + i) > buffer.length) { // if bytes needed to complete char fall outside buffer length, we have a boundary split
            for (var k = 0; k <= (buffer.length - 1 - i); k++) {
              this.temp_buffs[this.bytes_in_sequence][k] = buffer[i + k]; // fill temp buffer of correct size with bytes available in this chunk
            }
            this.bytes_remaining = (i + this.bytes_in_sequence) - buffer.length;
            i = buffer.length - 1;
          } else {
            this.appendStringBuf(buffer, i, i + this.bytes_in_sequence);
            i = i + this.bytes_in_sequence - 1;
          }
        } else if (n === 0x22) {
          this.tState = START;
          this.string += this.stringBuffer.toString('utf8', 0, this.stringBufferOffset);
          this.stringBufferOffset = 0;
          this.onToken(STRING, this.string);
          this.offset += Buffer.byteLength(this.string, 'utf8') + 1;
          this.string = undefined;
        }
        else if (n === 0x5c) {
          this.tState = STRING2;
        }
        else if (n >= 0x20) { this.appendStringChar(n); }
        else {
            return this.charError(buffer, i);
        }
      }else if (this.tState === STRING2){ // After backslash
        n = buffer[i];
        if(n === 0x22){ this.appendStringChar(n); this.tState = STRING1;
        }else if(n === 0x5c){ this.appendStringChar(BACK_SLASH); this.tState = STRING1;
        }else if(n === 0x2f){ this.appendStringChar(FORWARD_SLASH); this.tState = STRING1;
        }else if(n === 0x62){ this.appendStringChar(BACKSPACE); this.tState = STRING1;
        }else if(n === 0x66){ this.appendStringChar(FORM_FEED); this.tState = STRING1;
        }else if(n === 0x6e){ this.appendStringChar(NEWLINE); this.tState = STRING1;
        }else if(n === 0x72){ this.appendStringChar(CARRIAGE_RETURN); this.tState = STRING1;
        }else if(n === 0x74){ this.appendStringChar(TAB); this.tState = STRING1;
        }else if(n === 0x75){ this.unicode = ""; this.tState = STRING3;
        }else{
          return this.charError(buffer, i);
        }
      }else if (this.tState === STRING3 || this.tState === STRING4 || this.tState === STRING5 || this.tState === STRING6){ // unicode hex codes
        n = buffer[i];
        // 0-9 A-F a-f
        if ((n >= 0x30 && n < 0x40) || (n > 0x40 && n <= 0x46) || (n > 0x60 && n <= 0x66)) {
          this.unicode += String.fromCharCode(n);
          if (this.tState++ === STRING6) {
            var intVal = parseInt(this.unicode, 16);
            this.unicode = undefined;
            if (this.highSurrogate !== undefined && intVal >= 0xDC00 && intVal < (0xDFFF + 1)) { //<56320,57343> - lowSurrogate
              this.appendStringBuf(new Buffer(String.fromCharCode(this.highSurrogate, intVal)));
              this.highSurrogate = undefined;
            } else if (this.highSurrogate === undefined && intVal >= 0xD800 && intVal < (0xDBFF + 1)) { //<55296,56319> - highSurrogate
              this.highSurrogate = intVal;
            } else {
              if (this.highSurrogate !== undefined) {
                this.appendStringBuf(new Buffer(String.fromCharCode(this.highSurrogate)));
                this.highSurrogate = undefined;
              }
              this.appendStringBuf(new Buffer(String.fromCharCode(intVal)));
            }
            this.tState = STRING1;
          }
        } else {
          return this.charError(buffer, i);
        }
      } else if (this.tState === NUMBER1 || this.tState === NUMBER3) {
          n = buffer[i];

          switch (n) {
            case 0x30: // 0
            case 0x31: // 1
            case 0x32: // 2
            case 0x33: // 3
            case 0x34: // 4
            case 0x35: // 5
            case 0x36: // 6
            case 0x37: // 7
            case 0x38: // 8
            case 0x39: // 9
            case 0x2e: // .
            case 0x65: // e
            case 0x45: // E
            case 0x2b: // +
            case 0x2d: // -
              this.string += String.fromCharCode(n);
              this.tState = NUMBER3;
              break;
            default:
              this.tState = START;
              var result = Number(this.string);

              if (isNaN(result)){
                return this.charError(buffer, i);
              }

              if ((this.string.match(/[0-9]+/) == this.string) && (result.toString() != this.string)) {
                // Long string of digits which is an ID string and not valid and/or safe JavaScript integer Number
                this.onToken(STRING, this.string);
              } else {
                this.onToken(NUMBER, result);
              }

              this.offset += this.string.length - 1;
              this.string = undefined;
              i--;
              break;
          }
      }else if (this.tState === TRUE1){ // r
        if (buffer[i] === 0x72) { this.tState = TRUE2; }
        else { return this.charError(buffer, i); }
      }else if (this.tState === TRUE2){ // u
        if (buffer[i] === 0x75) { this.tState = TRUE3; }
        else { return this.charError(buffer, i); }
      }else if (this.tState === TRUE3){ // e
        if (buffer[i] === 0x65) { this.tState = START; this.onToken(TRUE, true); this.offset+= 3; }
        else { return this.charError(buffer, i); }
      }else if (this.tState === FALSE1){ // a
        if (buffer[i] === 0x61) { this.tState = FALSE2; }
        else { return this.charError(buffer, i); }
      }else if (this.tState === FALSE2){ // l
        if (buffer[i] === 0x6c) { this.tState = FALSE3; }
        else { return this.charError(buffer, i); }
      }else if (this.tState === FALSE3){ // s
        if (buffer[i] === 0x73) { this.tState = FALSE4; }
        else { return this.charError(buffer, i); }
      }else if (this.tState === FALSE4){ // e
        if (buffer[i] === 0x65) { this.tState = START; this.onToken(FALSE, false); this.offset+= 4; }
        else { return this.charError(buffer, i); }
      }else if (this.tState === NULL1){ // u
        if (buffer[i] === 0x75) { this.tState = NULL2; }
        else { return this.charError(buffer, i); }
      }else if (this.tState === NULL2){ // l
        if (buffer[i] === 0x6c) { this.tState = NULL3; }
        else { return this.charError(buffer, i); }
      }else if (this.tState === NULL3){ // l
        if (buffer[i] === 0x6c) { this.tState = START; this.onToken(NULL, null); this.offset += 3; }
        else { return this.charError(buffer, i); }
      }
    }
  };
  proto.onToken = function (token, value) {
    // Override this to get events
  };

  proto.parseError = function (token, value) {
    this.tState = STOP;
    this.onError(new Error("Unexpected " + Parser.toknam(token) + (value ? ("(" + JSON.stringify(value) + ")") : "") + " in state " + Parser.toknam(this.state)));
  };
  proto.push = function () {
    this.stack.push({value: this.value, key: this.key, mode: this.mode});
  };
  proto.pop = function () {
    var value = this.value;
    var parent = this.stack.pop();
    this.value = parent.value;
    this.key = parent.key;
    this.mode = parent.mode;
    this.emit(value);
    if (!this.mode) { this.state = VALUE; }
  };
  proto.emit = function (value) {
    if (this.mode) { this.state = COMMA; }
    this.onValue(value);
  };
  proto.onValue = function (value) {
    // Override me
  };
  proto.onToken = function (token, value) {
    if(this.state === VALUE){
      if(token === STRING || token === NUMBER || token === TRUE || token === FALSE || token === NULL){
        if (this.value) {
          this.value[this.key] = value;
        }
        this.emit(value);
      }else if(token === LEFT_BRACE){
        this.push();
        if (this.value) {
          this.value = this.value[this.key] = {};
        } else {
          this.value = {};
        }
        this.key = undefined;
        this.state = KEY;
        this.mode = OBJECT;
      }else if(token === LEFT_BRACKET){
        this.push();
        if (this.value) {
          this.value = this.value[this.key] = [];
        } else {
          this.value = [];
        }
        this.key = 0;
        this.mode = ARRAY;
        this.state = VALUE;
      }else if(token === RIGHT_BRACE){
        if (this.mode === OBJECT) {
          this.pop();
        } else {
          return this.parseError(token, value);
        }
      }else if(token === RIGHT_BRACKET){
        if (this.mode === ARRAY) {
          this.pop();
        } else {
          return this.parseError(token, value);
        }
      }else{
        return this.parseError(token, value);
      }
    }else if(this.state === KEY){
      if (token === STRING) {
        this.key = value;
        this.state = COLON;
      } else if (token === RIGHT_BRACE) {
        this.pop();
      } else {
        return this.parseError(token, value);
      }
    }else if(this.state === COLON){
      if (token === COLON) { this.state = VALUE; }
      else { return this.parseError(token, value); }
    }else if(this.state === COMMA){
      if (token === COMMA) {
        if (this.mode === ARRAY) { this.key++; this.state = VALUE; }
        else if (this.mode === OBJECT) { this.state = KEY; }

      } else if (token === RIGHT_BRACKET && this.mode === ARRAY || token === RIGHT_BRACE && this.mode === OBJECT) {
        this.pop();
      } else {
        return this.parseError(token, value);
      }
    }else{
      return this.parseError(token, value);
    }
  };

  Parser.C = C;

  var jsonparse = Parser;

  var Transform$1 = Stream.Transform;

  var JSON2CSVTransform =
  /*#__PURE__*/
  function (_Transform) {
    _inherits(JSON2CSVTransform, _Transform);

    function JSON2CSVTransform(opts, transformOpts) {
      var _this;

      _classCallCheck(this, JSON2CSVTransform);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(JSON2CSVTransform).call(this, transformOpts)); // Inherit methods from JSON2CSVBase since extends doesn't
      // allow multiple inheritance and manually preprocess opts

      Object.getOwnPropertyNames(JSON2CSVBase_1.prototype).forEach(function (key) {
        return _this[key] = JSON2CSVBase_1.prototype[key];
      });
      _this.opts = _this.preprocessOpts(opts);
      _this.preprocessRow = _this.memoizePreprocessRow();
      _this._data = '';
      _this._hasWritten = false;

      if (_this._readableState.objectMode) {
        _this.initObjectModeParse();
      } else if (_this.opts.ndjson) {
        _this.initNDJSONParse();
      } else {
        _this.initJSONParser();
      }

      if (_this.opts.withBOM) {
        _this.push("\uFEFF");
      }

      if (_this.opts.fields) {
        _this.opts.fields = _this.preprocessFieldsInfo(_this.opts.fields);

        _this.pushHeader();
      }

      return _this;
    }
    /**
     * Init the transform with a parser to process data in object mode.
     * It receives JSON objects one by one and send them to `pushLine for processing.
     */


    _createClass(JSON2CSVTransform, [{
      key: "initObjectModeParse",
      value: function initObjectModeParse() {
        var transform = this;
        this.parser = {
          write: function write(line) {
            transform.pushLine(line);
          },
          getPendingData: function getPendingData() {
            return undefined;
          }
        };
      }
      /**
       * Init the transform with a parser to process NDJSON data.
       * It maintains a buffer of received data, parses each line
       * as JSON and send it to `pushLine for processing.
       */

    }, {
      key: "initNDJSONParse",
      value: function initNDJSONParse() {
        var transform = this;
        this.parser = {
          _data: '',
          write: function write(chunk) {
            this._data += chunk.toString();

            var lines = this._data.split('\n').map(function (line) {
              return line.trim();
            }).filter(function (line) {
              return line !== '';
            });

            var pendingData = false;
            lines.forEach(function (line, i) {
              try {
                transform.pushLine(JSON.parse(line));
              } catch (e) {
                if (i === lines.length - 1) {
                  pendingData = true;
                } else {
                  e.message = 'Invalid JSON (' + line + ')';
                  transform.emit('error', e);
                }
              }
            });
            this._data = pendingData ? this._data.slice(this._data.lastIndexOf('\n')) : '';
          },
          getPendingData: function getPendingData() {
            return this._data;
          }
        };
      }
      /**
       * Init the transform with a parser to process JSON data.
       * It maintains a buffer of received data, parses each as JSON 
       * item if the data is an array or the data itself otherwise
       * and send it to `pushLine` for processing.
       */

    }, {
      key: "initJSONParser",
      value: function initJSONParser() {
        var transform = this;
        this.parser = new jsonparse();

        this.parser.onValue = function (value) {
          if (this.stack.length !== this.depthToEmit) return;
          transform.pushLine(value);
        };

        this.parser._onToken = this.parser.onToken;

        this.parser.onToken = function (token, value) {
          transform.parser._onToken(token, value);

          if (this.stack.length === 0 && !transform.opts.fields && this.mode !== jsonparse.C.ARRAY && this.mode !== jsonparse.C.OBJECT) {
            this.onError(new Error('Data should not be empty or the "fields" option should be included'));
          }

          if (this.stack.length === 1) {
            if (this.depthToEmit === undefined) {
              // If Array emit its content, else emit itself
              this.depthToEmit = this.mode === jsonparse.C.ARRAY ? 1 : 0;
            }

            if (this.depthToEmit !== 0 && this.stack.length === 1) {
              // No need to store the whole root array in memory
              this.value = undefined;
            }
          }
        };

        this.parser.getPendingData = function () {
          return this.value;
        };

        this.parser.onError = function (err) {
          if (err.message.includes('Unexpected')) {
            err.message = 'Invalid JSON (' + err.message + ')';
          }

          transform.emit('error', err);
        };
      }
      /**
       * Main function that send data to the parse to be processed.
       *
       * @param {Buffer} chunk Incoming data
       * @param {String} encoding Encoding of the incoming data. Defaults to 'utf8'
       * @param {Function} done Called when the proceesing of the supplied chunk is done
       */

    }, {
      key: "_transform",
      value: function _transform(chunk, encoding, done) {
        this.parser.write(chunk);
        done();
      }
    }, {
      key: "_flush",
      value: function _flush(done) {
        if (this.parser.getPendingData()) {
          done(new Error('Invalid data received from stdin', this.parser.getPendingData()));
        }

        done();
      }
      /**
       * Generate the csv header and pushes it downstream.
       */

    }, {
      key: "pushHeader",
      value: function pushHeader() {
        if (this.opts.header) {
          var header = this.getHeader();
          this.emit('header', header);
          this.push(header);
          this._hasWritten = true;
        }
      }
      /**
       * Transforms an incoming json data to csv and pushes it downstream.
       *
       * @param {Object} data JSON object to be converted in a CSV row
       */

    }, {
      key: "pushLine",
      value: function pushLine(data) {
        var _this2 = this;

        var processedData = this.preprocessRow(data);

        if (!this._hasWritten) {
          this.opts.fields = this.opts.fields || this.preprocessFieldsInfo(Object.keys(processedData[0]));
          this.pushHeader();
        }

        processedData.forEach(function (row) {
          var line = _this2.processRow(row, _this2.opts);

          if (line === undefined) return;

          _this2.emit('line', line);

          _this2.push(_this2._hasWritten ? _this2.opts.eol + line : line);

          _this2._hasWritten = true;
        });
      }
    }]);

    return JSON2CSVTransform;
  }(Transform$1);

  var JSON2CSVTransform_1 = JSON2CSVTransform;

  var Transform$2 = Stream.Transform;
  var fastJoin$3 = utils.fastJoin;

  var JSON2CSVAsyncParser =
  /*#__PURE__*/
  function () {
    function JSON2CSVAsyncParser(opts, transformOpts) {
      _classCallCheck(this, JSON2CSVAsyncParser);

      this.input = new Transform$2(transformOpts);

      this.input._read = function () {};

      this.transform = new JSON2CSVTransform_1(opts, transformOpts);
      this.processor = this.input.pipe(this.transform);
    }

    _createClass(JSON2CSVAsyncParser, [{
      key: "fromInput",
      value: function fromInput(input) {
        if (this._input) {
          throw new Error('Async parser already has an input.');
        }

        this._input = input;
        this.input = this._input.pipe(this.processor);
        return this;
      }
    }, {
      key: "throughTransform",
      value: function throughTransform(transform) {
        if (this._output) {
          throw new Error('Can\'t add transforms once an output has been added.');
        }

        this.processor = this.processor.pipe(transform);
        return this;
      }
    }, {
      key: "toOutput",
      value: function toOutput(output) {
        if (this._output) {
          throw new Error('Async parser already has an output.');
        }

        this._output = output;
        this.processor = this.processor.pipe(output);
        return this;
      }
    }, {
      key: "promise",
      value: function promise() {
        var _this = this;

        return new Promise(function (resolve, reject) {
          var csvBuffer = [];

          _this.processor.on('data', function (chunk) {
            return csvBuffer.push(chunk.toString());
          }).on('finish', function () {
            return resolve(fastJoin$3(csvBuffer, ''));
          }).on('error', function (err) {
            return reject(err);
          });
        });
      }
    }]);

    return JSON2CSVAsyncParser;
  }();

  var JSON2CSVAsyncParser_1 = JSON2CSVAsyncParser;

  var Readable$1 = Stream.Readable;
  var Parser$1 = JSON2CSVParser_1;
  var AsyncParser = JSON2CSVAsyncParser_1;
  var Transform$3 = JSON2CSVTransform_1; // Convenience method to keep the API similar to version 3.X

  var parse = function parse(data, opts) {
    return new JSON2CSVParser_1(opts).parse(data);
  };

  var parseAsync = function parseAsync(data, opts, transformOpts) {
    if (!(data instanceof Readable$1)) {
      transformOpts = Object.assign({}, transformOpts, {
        objectMode: true
      });
    }

    var asyncParser = new JSON2CSVAsyncParser_1(opts, transformOpts);
    var promise = asyncParser.promise();

    if (Array.isArray(data)) {
      data.forEach(function (item) {
        return asyncParser.input.push(item);
      });
      asyncParser.input.push(null);
    } else if (data instanceof Readable$1) {
      asyncParser.fromInput(data);
    } else {
      asyncParser.input.push(data);
      asyncParser.input.push(null);
    }

    return promise;
  };

  var json2csv = {
    Parser: Parser$1,
    AsyncParser: AsyncParser,
    Transform: Transform$3,
    parse: parse,
    parseAsync: parseAsync
  };

  exports.default = json2csv;
  exports.Parser = Parser$1;
  exports.AsyncParser = AsyncParser;
  exports.Transform = Transform$3;
  exports.parse = parse;
  exports.parseAsync = parseAsync;

  Object.defineProperty(exports, '__esModule', { value: true });

}));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19)))

/***/ }),
/* 230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lib_vendor_terrific_Module__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lib_generic_SDXModalDialog__ = __webpack_require__(7);
// Declare types
/// <reference types="jquery.cookie" />



/**
 * Tc.Module.PexMustReadModal
 */
var PexMustReadModal = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */])(PexMustReadModal, _super);
    function PexMustReadModal() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Hook function to do all of your module stuff.
     *
     * @method on
     * @param  {Hook} callback Callback function
     * @return void
     */
    PexMustReadModal.prototype.on = function (callback) {
        this.log.debug('starting');
        this.$html = this.$ctx.find('.sdx-container');
        var showModal = this.$html.find('ul').length > 0;
        var $button = this.$html.find('sdx-button');
        this.ajaxUrl = $button.data('ajaxUrl');
        $button.on('click', this.buttonClick.bind(this));
        this.title = this.$ctx.data('title');
        this.log.debug('Should show modal: ', showModal);
        if (showModal) {
            __WEBPACK_IMPORTED_MODULE_2_lib_generic_SDXModalDialog__["default"].show({
                class: 'text-align-left',
                html: this.$html,
                title: this.title,
            });
        }
        callback();
    };
    PexMustReadModal.prototype.buttonClick = function () {
        this.log('click event');
        var checked = this.$html.find('sdx-input-item')[0].checked;
        if (checked) {
            this.log('call servlet', this.ajaxUrl);
            $.post({
                data: {},
                url: this.ajaxUrl,
            }).then(function () {
                __WEBPACK_IMPORTED_MODULE_2_lib_generic_SDXModalDialog__["default"].close();
            });
        }
        else {
            __WEBPACK_IMPORTED_MODULE_2_lib_generic_SDXModalDialog__["default"].close();
        }
    };
    return PexMustReadModal;
}(__WEBPACK_IMPORTED_MODULE_1_lib_vendor_terrific_Module__["a" /* Module */]));
/* harmony default export */ __webpack_exports__["a"] = (PexMustReadModal);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),
/* 231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lib_vendor_terrific_Module__ = __webpack_require__(3);


var RES_HOME_ANIMATION = 'res-home-animation';
function waitForVideoToBeRady(video) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __awaiter */])(this, void 0, Promise, function () {
        return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (video.readyState === video.HAVE_ENOUGH_DATA || video.networkState === video.NETWORK_NO_SOURCE) {
                        return [2 /*return*/, Promise.resolve()];
                    }
                    // Firefox sometimes does not actually loads the data if video is disabled for
                    // the page, which is by default. This will prevent the blocking code
                    // execution in that rare cases
                    if (video.readyState === video.HAVE_FUTURE_DATA && video.networkState === video.NETWORK_IDLE) {
                        return [2 /*return*/, Promise.resolve()];
                    }
                    return [4 /*yield*/, new Promise(function (resolve) {
                            video.addEventListener('error', resolve, { once: true });
                            video.addEventListener('loadeddata', resolve, { once: true });
                        })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
var PortalStage = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */])(PortalStage, _super);
    function PortalStage() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Hook function to do all of your module stuff.
     *
     * @method on
     * @param  {Hook} callback Callback function
     * @return void
     */
    PortalStage.prototype.on = function (callback) {
        var _this = this;
        this.animationType = this.$ctx.data('animation');
        if (this.animationType === RES_HOME_ANIMATION) {
            setTimeout(function () { return _this.startAnimation(); });
        }
        callback();
    };
    PortalStage.prototype.startAnimation = function () {
        return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var $videos, waitForVideos;
            return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        $videos = this.$ctx.find('video');
                        waitForVideos = $videos.get()
                            .map(function (video) { return waitForVideoToBeRady(video); });
                        return [4 /*yield*/, Promise.all(waitForVideos)];
                    case 1:
                        _a.sent();
                        this.$ctx.addClass('start-animation');
                        this.$ctx.on('animationend', function (evt) { return $(evt.target).addClass('animation-ended'); });
                        return [2 /*return*/];
                }
            });
        });
    };
    return PortalStage;
}(__WEBPACK_IMPORTED_MODULE_1_lib_vendor_terrific_Module__["a" /* Module */]));
/* harmony default export */ __webpack_exports__["a"] = (PortalStage);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),
/* 232 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(jQuery) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lib_vendor_terrific_Module__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sdx_accordion_Accordion__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sdx_form_Select__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lib_util_helpers__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lib_personalization_profile__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Price__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Subscription__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Tc_Module_EcommerceProductDataHub__ = __webpack_require__(16);
/**
 * This component has a subset of features of both PriceOrderContainer and ProductModelFilter
 *
 * * From PriceOrderContainer, getInfoCallback (called on changes on the selected variant or subscription)
 * * From ProductModelFilter, handleGetFilters (called on page load)
 */









var PriceDetails = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */])(PriceDetails, _super);
    function PriceDetails() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.retentionAllowed = false;
        _this.aboDiscountOverrides = {};
        _this.monthText = '';
        _this.retentionSubscription = '';
        _this.subscriptionId = '';
        return _this;
    }
    PriceDetails.prototype.on = function (callback) {
        this.retentionAllowed = this.$ctx.data('retention-allowed');
        this.aboDiscountOverrides = this.$ctx.data('abo-discount-overrides') || {};
        this.monthText = this.$ctx.data('month-text');
        var accordion = new __WEBPACK_IMPORTED_MODULE_2_sdx_accordion_Accordion__["default"](this.$ctx.find('.accordion')[0]);
        this.log('SDX Accordion initialized', accordion);
        this.subscriptionsSelect = new __WEBPACK_IMPORTED_MODULE_3_sdx_form_Select__["default"](this.$ctx.find('select')[0]);
        this.log('SDX Select initalized', this.subscriptionsSelect);
        Object(__WEBPACK_IMPORTED_MODULE_8__Tc_Module_EcommerceProductDataHub__["c" /* simpleSubscribe */])(this, this.getInfoCallback.bind(this));
        callback();
    };
    PriceDetails.prototype.after = function () {
        return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __awaiter */])(this, void 0, void 0, function () {
            return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_5_lib_personalization_profile__["getProfile"])()];
                    case 1:
                        if (!(_a.sent()).getUser()) {
                            this.$ctx.find('.not-logged-in').removeClass('hidden');
                        }
                        this.fire('getFilters', {
                            callback: this.handleGetFilters.bind(this),
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Listen to and save updates from Tc.Module.RetentionResult
     */
    PriceDetails.prototype.onRetentionChange = function (data) {
        if (!data.existingAboName) {
            return;
        }
        this.retentionSubscription = data.existingAboName;
        this.updateSelectedSubscription();
        this.updatePrices();
        this.log('onRetentionChange', data.existingAboName);
    };
    /**
     * Copied and adapted from ProductModelFilter::handleGetFilters
     *
     * Callback handler for the getFilters terrific message.
     * Triggered on page load.
     * @param filters - Object with all filters for all product model filter types.
     */
    PriceDetails.prototype.handleGetFilters = function (filters) {
        var _this = this;
        this.log('handleGetFilters');
        var mod = this;
        var $select = jQuery(this.subscriptionsSelect.element);
        for (var _i = 0, _a = filters.subscriptionType; _i < _a.length; _i++) {
            var filter = _a[_i];
            var value = filter.value;
            if (value === __WEBPACK_IMPORTED_MODULE_8__Tc_Module_EcommerceProductDataHub__["a" /* SUBSCRIPTION_TYPES */].retention) {
                filters.subscriptionId.push(filter);
            }
            if (value === __WEBPACK_IMPORTED_MODULE_8__Tc_Module_EcommerceProductDataHub__["a" /* SUBSCRIPTION_TYPES */].without) {
                filters.subscriptionId.push(filter);
            }
        }
        // Populate
        var options = '';
        filters.subscriptionId.forEach(function (item) {
            // 6- The visual design implies a single subscription price is used for 12 and 24 months duration
            var subscriptionPrice = _this.product.getSubscriptions().getRecurringCharge(item.value, 12) || Object(__WEBPACK_IMPORTED_MODULE_6__Price__["default"])();
            if (item.value in mod.aboDiscountOverrides) {
                // 7-
                subscriptionPrice = Object(__WEBPACK_IMPORTED_MODULE_6__Price__["default"])(subscriptionPrice.value() - mod.aboDiscountOverrides[item.value]);
            }
            options += "<option value=\"" + item.value + "\">" + item.text;
            if (item.value !== 'retention' && item.value !== 'without') {
                options += " (" + subscriptionPrice.formatted() + " / " + _this.monthText + ")";
            }
            options += '</option>';
        });
        $select.append(options);
        this.subscriptionsSelect.reload();
        // Bind handlers
        $select.on('change', this.handleChanged.bind(this));
    };
    /**
     * Triggered on each variant change
     */
    PriceDetails.prototype.getInfoCallback = function (data) {
        if (data && data.product && data.subscriptionType) {
            this.product = data.product;
            this.subscriptionId = data.subscriptionId;
            this.subscriptionType = data.subscriptionType;
            this.log('getInfoCallback', data.subscriptionType);
            this.updatePrices();
        }
        else {
            // 16-
            this.$ctx.find('.device-12months').text(__WEBPACK_IMPORTED_MODULE_6__Price__["DEFAULT_PRICE_REPRESENTATION"]);
            this.$ctx.find('.device-24months').text(__WEBPACK_IMPORTED_MODULE_6__Price__["DEFAULT_PRICE_REPRESENTATION"]);
        }
    };
    /*
    
    Price reads on existing PriceOrderContainer::getInfoCallback
    
    USED AND DONE:
        placeholders[mod.PLACEHOLDERS.currentPrice] =
                '5- ' + data.product.getPrice(data.subscriptionId, data.subscriptionDuration).formatted();
        placeholders[mod.PLACEHOLDERS.simplePayMonthlyPrice] = '12- ' + simplePayMonthlyPrice;
        placeholders[mod.PLACEHOLDERS.currentPrice] = '16- ' + emDash;
        placeholders[mod.PLACEHOLDERS.subscriptionPrice] = '6- ' + recurringCharge.formatted();
        placeholders[mod.PLACEHOLDERS.subscriptionPrice] = '7- ' + makePrice(charge).formatted();
    
    USED AND TODO:
        placeholders[mod.PLACEHOLDERS.subscriptionPrice] = '17- ' + emDash;
        placeholders[mod.PLACEHOLDERS.subscriptionPrice] = '18- ' + emDash;
        placeholders[mod.PLACEHOLDERS.subscriptionPrice] = '19- ' + emDash;
    
    UNUSED:
        placeholders[mod.PLACEHOLDERS.minimumPrice] = '1- ' + data.product.getMinimumPrice().formatted();
        placeholders[mod.PLACEHOLDERS.minimumPrice] = '14- ' + emDash;
        placeholders[mod.PLACEHOLDERS.originalPrice] = '2- ' + data.product.getOriginalPrice().formatted();
        placeholders[mod.PLACEHOLDERS.currentPrice] =
                '3- ' + placeholders[mod.PLACEHOLDERS.originalPrice];
                (seems unused because there is not visual design for 'ohne abo' option)
        placeholders[mod.PLACEHOLDERS.subscriptionPrice] = '4- ' + zeroDotEmDash;
        placeholders[mod.PLACEHOLDERS.xtraDiscount] = '8- ' + makePrice(discount).formatted();
        placeholders[mod.PLACEHOLDERS.xtraDiscount] = '9- ';
        placeholders[mod.PLACEHOLDERS.priceInstead] = '10- ' + data.product.getOriginalPrice().formatted();
        placeholders[mod.PLACEHOLDERS.priceInstead] = '11- ';
        placeholders[mod.PLACEHOLDERS.simplePayInitialPrice] =
                '13- ' + data.product.getSimplePayInitialPrice(data.subscriptionId, data.subscriptionDuration);
        placeholders[mod.PLACEHOLDERS.originalPrice] = '15- ' + emDash;
    
    TODO:
    
    */
    PriceDetails.prototype.updatePrices = function () {
        var mod = this;
        mod.toggleNote('activation-fee', this.subscriptionType === __WEBPACK_IMPORTED_MODULE_8__Tc_Module_EcommerceProductDataHub__["a" /* SUBSCRIPTION_TYPES */].createNew ||
            (this.subscriptionType === __WEBPACK_IMPORTED_MODULE_8__Tc_Module_EcommerceProductDataHub__["a" /* SUBSCRIPTION_TYPES */].retention && !mod.retentionAllowed));
        mod.toggleNote('instalments-possible', this.subscriptionType === __WEBPACK_IMPORTED_MODULE_8__Tc_Module_EcommerceProductDataHub__["a" /* SUBSCRIPTION_TYPES */].without);
        if (this.subscriptionType === __WEBPACK_IMPORTED_MODULE_8__Tc_Module_EcommerceProductDataHub__["a" /* SUBSCRIPTION_TYPES */].without) {
            mod.selectOhneAbo();
            mod.toggleWithSubscription(false);
        }
        else {
            // 5-
            for (var _i = 0, _a = [12, 24]; _i < _a.length; _i++) {
                var duration = _a[_i];
                var subscription = void 0;
                if (this.subscriptionType === __WEBPACK_IMPORTED_MODULE_8__Tc_Module_EcommerceProductDataHub__["a" /* SUBSCRIPTION_TYPES */].retention && this.retentionSubscription) {
                    subscription = this.product.getSubscriptions().getByName(this.retentionSubscription, duration, __WEBPACK_IMPORTED_MODULE_7__Subscription__["a" /* Case */].Retention);
                }
                else if (this.subscriptionId) {
                    subscription = this.product.getSubscriptions().get(this.subscriptionId, duration, __WEBPACK_IMPORTED_MODULE_7__Subscription__["a" /* Case */].Activation);
                }
                var price = void 0;
                if (subscription) {
                    price = subscription.getPrice().formatted();
                }
                this.$ctx.find(".device-" + duration + "months").text(price || __WEBPACK_IMPORTED_MODULE_6__Price__["DEFAULT_PRICE_REPRESENTATION"]);
            }
            mod.toggleWithSubscription(true);
            // The visual design is displaying different monthly info depending on the duration
            // Therefore we calculate the visibility separately. if (isSimplePayAllowed) {
            var monthlyprice12months = this.product.getSimplePayMonthlyPrice(this.subscriptionId, 12);
            if ((monthlyprice12months !== -1) && (monthlyprice12months.value() > 0)) {
                mod.showMonthlyPrice(monthlyprice12months.formatted(), 12);
            }
            else {
                mod.hideMonthlyPrice(12);
            }
            var monthlyprice24months = this.product.getSimplePayMonthlyPrice(this.subscriptionId, 24);
            if ((monthlyprice24months !== -1) && (monthlyprice24months.value() > 0)) {
                mod.showMonthlyPrice(monthlyprice24months.formatted(), 24);
            }
            else {
                mod.hideMonthlyPrice(24);
            }
        }
        this.updateSelectedSubscription(this.subscriptionId || this.subscriptionType);
    };
    PriceDetails.prototype.updateSelectedSubscription = function (id) {
        if (!this.subscriptionsSelect || !this.subscriptionsSelect.element.length) {
            return;
        }
        if (this.subscriptionType === __WEBPACK_IMPORTED_MODULE_8__Tc_Module_EcommerceProductDataHub__["a" /* SUBSCRIPTION_TYPES */].retention && this.retentionSubscription) {
            // Does the personalized subscription exist in the dropdown?
            var foundId = void 0;
            var options = Array.prototype.slice.call(this.subscriptionsSelect.element.childNodes);
            for (var _i = 0, options_1 = options; _i < options_1.length; _i++) {
                var option = options_1[_i];
                if (option.innerText && option.innerText.indexOf(this.retentionSubscription) === 0) {
                    // Yes
                    foundId = option.value;
                }
            }
            if (!foundId) {
                // No, so add it to dropdown
                var personalizedSub = this.product.getSubscriptions().getByName(this.retentionSubscription, 24, __WEBPACK_IMPORTED_MODULE_7__Subscription__["a" /* Case */].Retention);
                if (personalizedSub) {
                    foundId = personalizedSub.getId();
                    this.subscriptionsSelect.element.add(new Option(this.retentionSubscription, foundId));
                }
            }
            id = foundId;
        }
        if (id) {
            this.subscriptionId = id;
            this.subscriptionsSelect.element.value = id;
            this.subscriptionsSelect.reload();
        }
    };
    PriceDetails.prototype.toggleNote = function (noteClass, display) {
        this.$ctx.find('.note-' + noteClass).toggle(display);
    };
    PriceDetails.prototype.selectOhneAbo = function () {
        this.subscriptionsSelect.element.value = __WEBPACK_IMPORTED_MODULE_8__Tc_Module_EcommerceProductDataHub__["a" /* SUBSCRIPTION_TYPES */].without;
        this.subscriptionsSelect.reload();
    };
    PriceDetails.prototype.toggleWithSubscription = function (display) {
        this.$ctx.find('.with-subscription').toggle(display);
    };
    PriceDetails.prototype.handleChanged = function () {
        this.fire('updateStatus', {
            origin: Object(__WEBPACK_IMPORTED_MODULE_4_lib_util_helpers__["getUniqueIdOfElement"])(this.$ctx),
            status: this.getStatus(),
        });
    };
    /**
     * FIXME: This is a 'get' function that also sets stuff; should be renamed and/or refactored.
     */
    PriceDetails.prototype.getStatus = function () {
        var status = {};
        var value = this.subscriptionsSelect.value || null;
        if (value === __WEBPACK_IMPORTED_MODULE_8__Tc_Module_EcommerceProductDataHub__["a" /* SUBSCRIPTION_TYPES */].retention) {
            status.subscriptionType = __WEBPACK_IMPORTED_MODULE_8__Tc_Module_EcommerceProductDataHub__["a" /* SUBSCRIPTION_TYPES */].retention;
            value = null;
        }
        else if (value === __WEBPACK_IMPORTED_MODULE_8__Tc_Module_EcommerceProductDataHub__["a" /* SUBSCRIPTION_TYPES */].without) {
            status.subscriptionType = __WEBPACK_IMPORTED_MODULE_8__Tc_Module_EcommerceProductDataHub__["a" /* SUBSCRIPTION_TYPES */].without;
            value = null;
        }
        else {
            status.subscriptionType = __WEBPACK_IMPORTED_MODULE_8__Tc_Module_EcommerceProductDataHub__["a" /* SUBSCRIPTION_TYPES */].createNew;
        }
        status.subscriptionId = value;
        return status;
    };
    PriceDetails.prototype.showMonthlyPrice = function (price, subscriptionDuration) {
        var $ctx = this.$ctx;
        $ctx.find(".monthlyprice-" + subscriptionDuration + "months").text(price);
        $ctx.find(".monthlypricecontainer-" + subscriptionDuration + "months .not-possible").hide();
        $ctx.find(".monthlypricecontainer-" + subscriptionDuration + "months .possible").show();
    };
    PriceDetails.prototype.hideMonthlyPrice = function (subscriptionDuration) {
        var $ctx = this.$ctx;
        $ctx.find(".monthlypricecontainer-" + subscriptionDuration + "months .possible").hide();
        $ctx.find(".monthlypricecontainer-" + subscriptionDuration + "months .not-possible").show();
    };
    return PriceDetails;
}(__WEBPACK_IMPORTED_MODULE_1_lib_vendor_terrific_Module__["a" /* Module */]));
/* harmony default export */ __webpack_exports__["a"] = (PriceDetails);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),
/* 233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(SnabbdomPragma, $) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bootstrap_load_snabbdom__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lib_vendor_terrific_Module__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lib_util_helpers__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lib_personalization_profile__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Tc_Module_RatingList__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Tc_Module_EcommerceProductDataHub__ = __webpack_require__(16);
// tslint:disable:no-reference
/// <reference path="../../etc/designs/base/clientlibs/shared/libraries/SCS.utils.js.d.ts" />
// tslint:enable:no-reference







function SubcategoryRatings(_a) {
    var summarySubData = _a.summarySubData;
    return summarySubData.map(function (summaryInfo) {
        return SnabbdomPragma.createElement("a", { "attrs-class": "rating-stars sub-ratings" },
            SnabbdomPragma.createElement(__WEBPACK_IMPORTED_MODULE_5__Tc_Module_RatingList__["a" /* Stars */], { rating: summaryInfo.avg, sdx: true }),
            SnabbdomPragma.createElement("span", null,
                summaryInfo.category.getName(),
                " (",
                summaryInfo.count,
                ")"));
    });
}
/**
 * Prepare summary sub rating data for insertion
 *
 * @param ratingSubSummary {Object} Returned JSON object from ajax call with summary sub ratings
 */
function aggregateSubRatingSummaryData(subratingCategories, ratingList) {
    // FIXME: Maybe iterating the ratings first and the categories inside is less overhead. But it also needs more state…
    return subratingCategories.getCategories().map(function (category) {
        var ratingValues = ratingList.map(function (rating) {
            // Find the rating for the given category
            return rating.getCategorySubratings().forCategoryWithId(category.getId());
        }).filter(function (ratingValue) {
            // Only include the rating if > 0
            return ratingValue > 0;
        });
        // Sum up all the ratingValues
        var sum = ratingValues.reduce(function (a, b) {
            return a + b;
        }, 0);
        // Count the ratingValues
        var count = ratingValues.length;
        // Return aggregate summary data for each category
        return {
            avg: sum / count,
            category: category, count: count, sum: sum,
        };
    }).filter(function (summaryInfo) {
        // Remove categories with ratings <= 0
        return summaryInfo.avg > 0;
    });
}
/**
 * Rating overview component
 *
 * @author Branislav Maksin
 * @namespace Tc.Module
 * @class RatingsOverview
 * @extends Tc.Module
 */
var RatingOverview = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */])(RatingOverview, _super);
    function RatingOverview() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Does all the work.
     *
     * @method on
     * @param {Function} callback function
     * @return void
     */
    RatingOverview.prototype.on = function (callback) {
        var _this = this;
        var $ctx = this.$ctx;
        var loginRequired = $ctx.data('login-required');
        var loginUrl = $ctx.data('login-url');
        this.subRatingsPlaceholder = $ctx.find('.sub-ratings-wrapper')[0];
        // Subscribe to products private channel and get data
        this.sandbox.subscribe('dynamicProducts', this);
        this.sandbox.subscribe('rarev', this);
        // Add click event for open form button
        this.$ctx.on('click', '.open-overlay', function (e) { return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __awaiter */])(_this, void 0, void 0, function () {
            var _a, $tabNavigationContent, activeTabIndex;
            return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        e.preventDefault();
                        _a = !loginRequired;
                        if (_a) return [3 /*break*/, 2];
                        return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_4_lib_personalization_profile__["getProfile"])()];
                    case 1:
                        _a = (_b.sent()).getUser();
                        _b.label = 2;
                    case 2:
                        if (_a) {
                            this.fire('openRatingForm', $(e.currentTarget), ['dynamicProducts']);
                            this.fire('addTracking', 'rate', ['dynamicProducts']);
                        }
                        else {
                            $tabNavigationContent = $('.modTabNavigationContent').has($ctx[0]);
                            activeTabIndex = this.$ctx
                                .closest('.modTabNavigation')
                                .children('.modTabNavigationContent')
                                .index($tabNavigationContent) + 1;
                            if (activeTabIndex === 0) {
                                window.location.href = loginUrl.replace('.tab_index.', '.');
                            }
                            else {
                                window.location.href = loginUrl.replace('tab_index', 't' + activeTabIndex);
                            }
                        }
                        return [2 /*return*/];
                }
            });
        }); });
        this.initialized = false;
        // tslint:disable-next-line:no-unbound-method
        Object(__WEBPACK_IMPORTED_MODULE_6__Tc_Module_EcommerceProductDataHub__["c" /* simpleSubscribe */])(this, this.processProductsIDs);
        callback();
    };
    /**
     * Process products IDs and get products JSONs data
     *
     */
    RatingOverview.prototype.processProductsIDs = function (data) {
        var $ctx = this.$ctx;
        if (this.initialized) {
            return;
        }
        var family = data.family;
        // Get product data
        if (!family.getId()) {
            this.log('Family doesn’t have any IDs');
            $ctx.removeClass('scs-loadingRotator').addClass('error');
            return;
        }
        if ($ctx.hasClass('error')) {
            $ctx.removeClass('error').addClass('scs-loadingRotator');
        }
        var ratings = family.getRatings();
        if (!ratings.loaded()) {
            // Register callback for when rating data is loaded
            // tslint:disable-next-line:no-floating-promises
            ratings.load().done(this.processProductsIDs.bind(this, data));
            return;
        }
        this.initialized = true;
        var summary = ratings.getSummary();
        this.showRatingSummary(summary);
        var summarySubData = aggregateSubRatingSummaryData(ratings.getSubRatingCategories(), ratings.getRatings());
        this.showSubRatingSummary(summarySubData);
        this.sendDataToForm(family);
        $ctx.removeClass('scs-loadingRotator');
    };
    /**
     * Show form button when everything is ready
     *
     * @param {Object} data With
     * • {Boolean} show: Should we show button?
     * • {Boolean} success: Should we show success message?
     */
    RatingOverview.prototype.onShowFormButton = function (data) {
        var $ctx = this.$ctx;
        // Show/hide open form button
        $ctx.find('.open-form').toggleClass('hidden', data.show === false);
        $ctx.find('.statusSuccessful').toggleClass('hidden', data.success !== true);
    };
    /**
     * Insert the summary data into DOM elements
     *
     * @param summaryData {Object} Final summary data
     */
    RatingOverview.prototype.showRatingSummary = function (summaryData) {
        var $ctx = this.$ctx;
        var $ratingStarHolder = $ctx.find('.rating-stars:first');
        // Get needed info
        var rating = summaryData.getAverage(true);
        var recommendationPercentage = summaryData.getRecommendationPercentage(true);
        var count = summaryData.count();
        // Set the rating star summary
        var $ratingStars = $ratingStarHolder.find('> i');
        var $ratingStarsCount = $ratingStarHolder.find('> span');
        $ratingStars.addClass('icon-082-star').filter(":lt(" + rating + ")")
            .removeClass('icon-082-star')
            .addClass('icon-228-star-filled');
        $ratingStarsCount.text("(" + count + ")");
        // Show recommendation percentage
        $ctx.find('.recommendation')
            .toggleClass('hidden', recommendationPercentage < 1)
            .find('> p .recommendation-percentage')
            .text(recommendationPercentage + "%");
    };
    /**
     * Insert the summary data into DOM elements
     *
     * @param summarySubData {Object} Final sub summary data
     */
    RatingOverview.prototype.showSubRatingSummary = function (summarySubData) {
        this.subRatingsPlaceholder = Object(__WEBPACK_IMPORTED_MODULE_1_bootstrap_load_snabbdom__["b" /* patch */])(this.subRatingsPlaceholder, SnabbdomPragma.createElement("div", { "attrs-class": "sub-ratings-wrapper", "class-hidden": !summarySubData.length },
            SnabbdomPragma.createElement(SubcategoryRatings, { summarySubData: summarySubData })));
    };
    /**
     * Send the data to review form
     */
    RatingOverview.prototype.sendDataToForm = function (family) {
        var title = family.getFamilyName();
        // Get product title
        if (Object(__WEBPACK_IMPORTED_MODULE_3_lib_util_helpers__["isMobilePage"])()) {
            title = this.$ctx.closest('.stageMobile').find('h1').text() || title;
        }
        else {
            title = this.$ctx.closest('.content').find('h1').text() || title;
        }
        // Send the data
        this.fire('getDataFromParent', { family: family, title: title }, ['rarev']);
    };
    return RatingOverview;
}(__WEBPACK_IMPORTED_MODULE_2_lib_vendor_terrific_Module__["a" /* Module */]));
/* harmony default export */ __webpack_exports__["a"] = (RatingOverview);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(10), __webpack_require__(0)))

/***/ }),
/* 234 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lib_vendor_terrific_Module__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lib_util_array__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lib_util_string__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lib_personalization_profile__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_sdx_form_Select__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Tc_Module_EcommerceProductDataHub__ = __webpack_require__(16);







// The e-commerce backend can take a very long time to respond
var AJAX_TIMEOUT = 300000;
var STATE;
(function (STATE) {
    STATE["entInSmeOrRes"] = "entinsmeorres";
    STATE["error"] = "error";
    STATE["green"] = "green";
    STATE["loading"] = "loading";
    STATE["loggedOut"] = "loggedOut";
    STATE["noRetentionPossible"] = "noretentionpossible";
    STATE["retentionResult"] = "retentionResult";
})(STATE || (STATE = {}));
var ERROR = {
    DATA: 'data',
    TIMEOUT: 'timeout',
};
var HASH_SUFFIX = 'retention';
/**
 * Check if a contract's end date is in the future
 */
function isStillRunning(contract) {
    var today = new Date().getTime();
    var endDate = getTime(contract.ContractEndDate);
    return endDate > today;
}
/**
 * Returns the time in miliseconds
 */
function getTime(timeString) {
    return Number(timeString.slice(6, -7));
}
/**
 * Format a phone number. Example: +41791231234 -> 079 123 12 34
 */
function formattedPhoneNumber(phoneNumber) {
    return phoneNumber.replace(/^[+]41/, '0').replace(/^(...)(...)(..)(..)$/, '$1 $2 $3 $4');
}
/**
 * Wrapper for localStorage with expiration time support.
 */
var STORAGE = {
    load: function (key) {
        if (!window.localStorage) {
            return false;
        }
        var record = JSON.parse(localStorage.getItem(key) || '{}');
        if (!record || !record.timestamp || new Date().getTime() > record.timestamp) {
            return false;
        }
        return JSON.parse(record.value);
    },
    save: function (key, jsonData, expirationHours) {
        if (!window.localStorage) {
            return false;
        }
        var expirationMS = expirationHours * 60 * 60 * 1000;
        var record = {
            timestamp: new Date().getTime() + expirationMS,
            value: JSON.stringify(jsonData),
        };
        localStorage.setItem(key, JSON.stringify(record));
        return jsonData;
    },
};
var RetentionResult = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */])(RetentionResult, _super);
    function RetentionResult() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.data = {};
        _this.noCache = false;
        _this.hasProductDataHub = false;
        _this.hideActionButton = false;
        _this.ajaxError = '';
        _this.contracts = [];
        return _this;
    }
    RetentionResult.prototype.on = function (callback) {
        var _this = this;
        Object(__WEBPACK_IMPORTED_MODULE_6__Tc_Module_EcommerceProductDataHub__["c" /* simpleSubscribe */])(this, function (data) {
            _this.log('simpleSubscribe', data.subscriptionType);
            if (data.subscriptionType === __WEBPACK_IMPORTED_MODULE_6__Tc_Module_EcommerceProductDataHub__["a" /* SUBSCRIPTION_TYPES */].retention) {
                // Prevent dropdown getting cut off by removing "overflow: hidden" after the animation
                _this.$ctx.slideDown(200, function () { return _this.$ctx.removeAttr('style'); });
            }
            else {
                _this.$ctx.slideUp(100);
            }
        });
        this.$ctx.hide();
        this.init();
        this.handleLoginStatus().catch(function (e) { return _this.log.error('Error handling login status', e); });
        callback();
    };
    RetentionResult.prototype.handleLoginStatus = function () {
        return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var user;
            return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_4_lib_personalization_profile__["getProfile"])()];
                    case 1:
                        user = (_a.sent()).getUser();
                        this.log('handleLoginChange', user);
                        if (user) {
                            if (user.getSegment() === __WEBPACK_IMPORTED_MODULE_4_lib_personalization_profile__["CFU"].CBU) {
                                // ENT customers cannot use this feature. Hence, they are asked to go to the ENT shop.
                                this.showUiState(STATE.entInSmeOrRes);
                            }
                            else {
                                this.loadContractsOverview(user);
                            }
                        }
                        else {
                            this.showUiState(STATE.loggedOut);
                        }
                        if (this.productDataChannel) {
                            this.fire('removeHashParameter', HASH_SUFFIX, [this.productDataChannel]);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    RetentionResult.prototype.init = function () {
        var mod = this;
        mod.data = mod.$ctx.data();
        mod.noCache = mod.debug && window.location.hash.indexOf('nocache') > 0;
        mod.hasProductDataHub = !!$('.modEcommerceProductDataHub').length;
        mod.$loaderSpinner = mod.$ctx.find('.loader-spinner');
        mod.$dropdown = mod.$ctx.find('.select');
        mod.$message = mod.$ctx.find('.retention-message');
        mod.$dropdown.on('change', mod.handleDropdownChange.bind(mod));
    };
    RetentionResult.prototype.handleDropdownChange = function (event) {
        var phoneNumber = $(event.target).val();
        this.showUiState(STATE.retentionResult, this.getContractByPhoneNumber(String(phoneNumber)));
        this.log('handleDropdownChange', phoneNumber);
    };
    /**
     * Loads available contracts for a retention upgrade from the server.
     * Response (Array of Strings containing ALL phone numbers listed under this account:
     * ['+41791039311', '+41791039315']
     */
    RetentionResult.prototype.loadContractsOverview = function (user) {
        var mod = this;
        var SCS = window.SCS;
        mod.contracts = STORAGE.load("contracts" + user.getId() + "_" + $('html').attr('lang'));
        if (mod.contracts && !mod.noCache) {
            mod.log('loaded from storage', mod.contracts);
            mod.updateDropdown(mod.getContracts());
            mod.showRetentionResults();
            return;
        }
        mod.showUiState(STATE.loading);
        mod.contracts = [];
        $.ajax({
            timeout: AJAX_TIMEOUT,
            url: SCS.portal.addParamToUrl(mod.data.urlLoadContracts, 'id', user.getId()),
            success: function (contracts) {
                if ($.isArray(contracts)) {
                    if (contracts.length) {
                        mod.updateDropdown(contracts);
                        mod.loadContractDetails(user, contracts, 0);
                    }
                    else {
                        mod.showUiState(STATE.noRetentionPossible);
                    }
                }
                else {
                    mod.showError();
                }
            },
            error: function (xhr, _textStatus, errorThrown) {
                mod.showError(errorThrown, xhr);
            },
        });
    };
    RetentionResult.prototype.getContracts = function () {
        return this.contracts.map(function (contract) { return contract.SubscriptionNumber; });
    };
    RetentionResult.prototype.getContractByPhoneNumber = function (phoneNumber) {
        return this.contracts.find(function (contract) { return contract.SubscriptionNumber === phoneNumber; });
    };
    RetentionResult.prototype.updateDropdown = function (contracts) {
        if (contracts === void 0) { contracts = []; }
        if (!this.sdxSelect) {
            var selectElement = this.$ctx[0].querySelector('select');
            if (!selectElement) {
                return;
            }
            this.sdxSelect = new __WEBPACK_IMPORTED_MODULE_5_sdx_form_Select__["default"](selectElement);
        }
        var uniqueContracts = contracts.filter(__WEBPACK_IMPORTED_MODULE_2_lib_util_array__["a" /* onlyUnique */]);
        this.sdxSelect.empty();
        for (var _i = 0, uniqueContracts_1 = uniqueContracts; _i < uniqueContracts_1.length; _i++) {
            var phoneNumber = uniqueContracts_1[_i];
            this.sdxSelect.element.appendChild(new Option(formattedPhoneNumber(phoneNumber), phoneNumber));
        }
        this.sdxSelect.reload();
    };
    /**
     * Load the details of a single contract from
     * /portalshop/de/res/Retention/GetRetentionContractDetails?subscriptionNumber={{NUMBER}}
     * Response: RetentionContractDetailsModel
     *
     * @param contracts - Array with cell phone numbers registered under the current user
     */
    RetentionResult.prototype.loadContractDetails = function (user, contracts, index) {
        var mod = this;
        var SCS = window.SCS;
        var url = SCS.portal.addParamToUrl(mod.data.urlLoadContractDetails, 'subscriptionNumber', contracts[index]);
        $.ajax({
            error: function (xhr, _textStatus, errorThrown) {
                if ((index + 1) < (contracts.length)) {
                    mod.loadContractDetails(user, contracts, (index + 1));
                }
                else {
                    mod.showError(errorThrown, xhr);
                }
            },
            success: function (details) {
                var contractDetails = details.RetentionContractDetailsModel;
                if (contractDetails && contractDetails.Status.indexOf('error') === -1) {
                    mod.contracts.push(contractDetails);
                }
                if ((index + 1) < (contracts.length)) {
                    mod.loadContractDetails(user, contracts, (index + 1));
                }
                else {
                    if (contractDetails && contractDetails.Status.indexOf('error') > -1) {
                        mod.ajaxError = ERROR.TIMEOUT;
                    }
                    mod.contractsLoadingHandler();
                    STORAGE.save("contracts" + user.getId() + "_" + $('html').attr('lang'), mod.contracts, 1);
                }
            },
            timeout: AJAX_TIMEOUT,
            url: url,
        });
    };
    RetentionResult.prototype.contractsLoadingHandler = function () {
        var mod = this;
        if (mod.ajaxError) {
            if (mod.ajaxError === ERROR.TIMEOUT) {
                mod.showError(ERROR.TIMEOUT);
            }
            else {
                mod.showError();
            }
        }
        else {
            mod.showRetentionResults();
        }
    };
    /**
     * Show the results of the load contract details call(s).
     * Loaded via AJAX or from local storage.
     */
    RetentionResult.prototype.showRetentionResults = function () {
        var retentionPossible = this.getFirstWithRetentionPossible();
        if (retentionPossible) {
            this.showUiState(STATE.retentionResult, retentionPossible);
            this.fireTrackingCall('retentionPossible');
            return;
        }
        var futureRetentionPossible = this.getContractWithNearestEndDate();
        if (futureRetentionPossible) {
            this.showUiState(STATE.retentionResult, futureRetentionPossible);
            this.fireTrackingCall('futureRetentionPossible');
            return;
        }
        this.showUiState(STATE.noRetentionPossible);
        this.fireTrackingCall('noRetentionPossible');
    };
    RetentionResult.prototype.getFirstWithRetentionPossible = function () {
        for (var _i = 0, _a = this.contracts; _i < _a.length; _i++) {
            var contract = _a[_i];
            if (contract.Status.toLowerCase() === STATE.green) {
                return contract;
            }
        }
        return undefined;
    };
    RetentionResult.prototype.fireTrackingCall = function (retentionStatus) {
        var interaction = new SCS.portal.datalayer.Interaction()
            .withEvent('response', retentionStatus, 'productDetailPage', 'checker');
        interaction.track();
        this.log('fireTrackingCall', interaction);
    };
    /**
     * Communicate state change to Tc.Module.PaymentSwitch and Tc.Module.PriceBox.
     */
    RetentionResult.prototype.updateState = function (status, subscriptionNumberMD5Hash, existingAboName) {
        this.log('updateState', status);
        var data = {
            existingAboName: existingAboName,
            status: status,
            subscriptionNumberMD5Hash: subscriptionNumberMD5Hash,
        };
        this.fire('retentionChange', data);
    };
    /**
     * Switch between different UI states.
     */
    RetentionResult.prototype.showUiState = function (uiState, contract) {
        var mod = this;
        mod.$loaderSpinner.addClass('hidden');
        mod.$dropdown.removeClass('hidden');
        mod.showMessage();
        mod.$ctx.removeClass('hidden');
        switch (uiState) {
            case STATE.loggedOut:
                mod.$ctx.addClass('hidden');
                mod.updateState('loggedOut');
                break;
            case STATE.loading:
                mod.$loaderSpinner.removeClass('hidden');
                mod.$dropdown.addClass('hidden');
                mod.showMessage(mod.data.messageLoading);
                mod.scrollToComponent();
                mod.updateState('loading');
                break;
            case STATE.noRetentionPossible:
                mod.$dropdown.addClass('hidden');
                mod.showMessage(contract && contract.ReasonText || mod.data.messageNoRetentionPossible);
                this.updateState('notPossible');
                break;
            case STATE.retentionResult:
                if (!contract) {
                    mod.showMessage(mod.data.messageNoRetentionPossible);
                    this.updateState('notPossible');
                    break;
                }
                this.$dropdown.find('select').val(contract.SubscriptionNumber);
                this.sdxSelect.reload();
                if (contract.Status.toLowerCase() === STATE.green) {
                    mod.showMessage(contract.ReasonText || mod.data.messageRetentionPossible);
                    mod.updateState('possible', contract.SubscriptionNumberMD5Hash, contract.ExistingAboName);
                }
                else if (isStillRunning(contract)) {
                    var date = new Date(getTime(contract.ContractEndDate));
                    var dateString = date.getDate() + ". " + (date.getMonth() + 1) + ". " + date.getFullYear();
                    mod.showMessage(Object(__WEBPACK_IMPORTED_MODULE_3_lib_util_string__["format"])(mod.data.messageFutureRetentionPossible, dateString));
                    mod.updateState('futurePossible');
                }
                else {
                    mod.showMessage(contract.ReasonText || mod.data.messageNoRetentionPossible);
                    mod.updateState('notPossible');
                }
                break;
            case STATE.entInSmeOrRes:
                mod.showMessage(mod.data.messageCbuInResOrSme);
                mod.updateState('notPossible');
                break;
            default:
            case STATE.error:
                mod.showMessage(mod.data.messageError);
                mod.updateState('notPossible');
                break;
        }
        mod.log('showUiState', uiState, contract);
    };
    RetentionResult.prototype.showMessage = function (message) {
        if (!message || !message.length) {
            this.$message.text('').addClass('hidden');
            return;
        }
        this.$message.text(message).removeClass('hidden');
    };
    RetentionResult.prototype.scrollToComponent = function () {
        var scrollTop = 0;
        var offset = this.$ctx.offset();
        if (offset && offset.top) {
            scrollTop = offset.top - 100;
            $('html, body').animate({ scrollTop: scrollTop }, 1000);
        }
    };
    /**
     * Find the contract with the nearest contract end date from today.
     */
    RetentionResult.prototype.getContractWithNearestEndDate = function () {
        var contract;
        var nearestContract;
        var endDate;
        var nearestEndDate;
        for (var i = 0, length = this.contracts.length; i < length; i += 1) {
            contract = this.contracts[i];
            endDate = getTime(contract.ContractEndDate);
            if ((!nearestEndDate || endDate < nearestEndDate) && isStillRunning(contract)) {
                nearestContract = contract;
                nearestEndDate = endDate;
            }
        }
        return nearestContract;
    };
    /**
     * Display an error Message.
     */
    RetentionResult.prototype.showError = function (errorThrown, xhr) {
        var SCS = window.SCS;
        this.log(errorThrown, xhr);
        if (xhr && xhr.status === SCS.ecommerce.ECOMMERCE_SERVICE_UNAVAILABLE_EXCEPTION) {
            SCS.ecommerce.showEcommerceErrorMessage();
        }
        else {
            this.showUiState(STATE.error);
        }
    };
    return RetentionResult;
}(__WEBPACK_IMPORTED_MODULE_1_lib_vendor_terrific_Module__["a" /* Module */]));
/* harmony default export */ __webpack_exports__["a"] = (RetentionResult);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),
/* 235 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lib_vendor_terrific_Module__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lib_util_helpers__ = __webpack_require__(4);



/**
 * Scroll Element implemntation.
 *
 * @author Kiril Delovski
 * @extends Tc.Module
 */
var ScrollElement = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */])(ScrollElement, _super);
    function ScrollElement() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Hook function to do all of your module stuff.
     *
     * @method on
     * @param  {Hook} callback Callback function
     * @return void
     * @author Kiril Delovski
     */
    ScrollElement.prototype.on = function (callback) {
        var $ctx = this.$ctx;
        var $slideElements = $ctx.find('.slide');
        var slideElementsLength = $slideElements.length;
        var $firstSlideImage = $ctx.find('.slide-1 .image-presenter');
        if (slideElementsLength > 1) {
            var slide1TopPosition_1 = $firstSlideImage.position().top;
            var elHeight_1 = $firstSlideImage.height() || 0;
            var elWidth_1 = $firstSlideImage.width() || 0;
            var $slideImages_1 = $slideElements.find('.image-presenter');
            var $lastSlideElem_1 = $($slideElements[slideElementsLength - 1]);
            var $lastSlideImage_1 = $lastSlideElem_1.find('.image-presenter');
            $firstSlideImage.css('opacity', 1);
            $slideImages_1.css('height', elHeight_1);
            $slideImages_1.css('width', elWidth_1);
            window.addEventListener('scroll', eventScrolling, { passive: true });
            window.addEventListener('resize', function () {
                slide1TopPosition_1 = $ctx.find('.slide-1 .image').position().top;
                elHeight_1 = $firstSlideImage.height() || 0;
                elWidth_1 = $firstSlideImage.width() || 0;
            }, { passive: true });
            function eventScrolling() {
                var $window = $(window);
                var mobileLandscape = window.innerHeight < window.innerWidth;
                var topMargin;
                var windowHeight = $window.height() || 1;
                var scrollPosition = $window.scrollTop() || 0;
                var scroll = scrollPosition + (windowHeight / 3);
                if (Object(__WEBPACK_IMPORTED_MODULE_2_lib_util_helpers__["isMobilePage"])()) {
                    if (window.innerWidth <= 768) {
                        topMargin = 0;
                    }
                    else {
                        topMargin = 160;
                        if (mobileLandscape) {
                            topMargin = 100;
                        }
                    }
                }
                else {
                    topMargin = 160;
                }
                if (scrollPosition + topMargin > slide1TopPosition_1) {
                    $firstSlideImage.css('opacity', '');
                    $slideImages_1.addClass('fixed');
                }
                if ($lastSlideElem_1.position().top < scrollPosition + topMargin) {
                    $slideImages_1.removeClass('fixed');
                    if (!$lastSlideElem_1.hasClass('active') && !$lastSlideImage_1.hasClass('fixed')) {
                        $lastSlideImage_1.css('opacity', 1);
                    }
                    else {
                        $lastSlideImage_1.css('opacity', '');
                    }
                }
                if (scrollPosition + topMargin < slide1TopPosition_1) {
                    $firstSlideImage.css('opacity', 1);
                    $slideImages_1.removeClass('fixed');
                }
                $slideElements.removeClass('active');
                $slideElements.each(function () {
                    var $this = $(this);
                    if ($this.position().top <= scroll && $this.position().top + ($this.height() || 1) > scroll) {
                        $this.addClass('active');
                    }
                });
            }
        }
        callback();
    };
    return ScrollElement;
}(__WEBPACK_IMPORTED_MODULE_1_lib_vendor_terrific_Module__["a" /* Module */]));
/* harmony default export */ __webpack_exports__["a"] = (ScrollElement);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),
/* 236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lib_vendor_terrific_Module__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ContactStep__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ContactTopic__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ContactResult__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lib_util_createAnimation__ = __webpack_require__(24);







var defaultHashManipulator = {
    hashSetter: function (hash) { window.location.hash = hash; },
    hashGetter: function () { return window.location.hash; },
};
var defaultTitleManipulator = {
    titleSetter: function (title) { document.title = title; },
    titleGetter: function () { return document.title; },
};
var SDXContactWizard = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */])(SDXContactWizard, _super);
    function SDXContactWizard() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SDXContactWizard.prototype.on = function (callback) {
        this.setHashManipulator(defaultHashManipulator);
        this.setTitleManipulator(defaultTitleManipulator);
        this.steps = [];
        callback();
    };
    SDXContactWizard.prototype.after = function () {
        // Find steps and topics
        this.initializeSteps();
        this.initializeDom();
        this.loadStateFromHash();
        this.hashChanged();
        this.updateTopicClasses();
    };
    SDXContactWizard.prototype.topicSelected = function (topic) {
        var hash = (topic && topic.topicName) || undefined;
        Object(__WEBPACK_IMPORTED_MODULE_5__helpers__["g" /* trackSelectionChange */])(topic);
        this.updateTitle(topic);
        this.setHash(hash);
        this.scrollToTopic(topic);
        this.fire('topicSelected', topic);
    };
    SDXContactWizard.prototype.setHashManipulator = function (hashManipulator) {
        this.hashManipulator = hashManipulator;
    };
    SDXContactWizard.prototype.setTitleManipulator = function (titleManipulator) {
        this.titleManipulator = titleManipulator;
    };
    SDXContactWizard.prototype.initializeSteps = function () {
        var _this = this;
        var $steps = this.$ctx.find('.steps > .step');
        var previousStep;
        $steps.each(function (_id, step) {
            var $step = $(step);
            var contactStep = new __WEBPACK_IMPORTED_MODULE_2__ContactStep__["a" /* default */]($step, _this, previousStep);
            _this.steps.push(contactStep);
            // Handle topics
            var $topics = $step.find('.topics > .topic');
            $topics.each(function (_idx, topic) {
                var $topic = $(topic);
                var contactTopic = new __WEBPACK_IMPORTED_MODULE_3__ContactTopic__["a" /* default */]($topic);
                contactStep.addTopic(contactTopic);
            });
            var $results = $step.find('.results > .result');
            $results.each(function (_idx, result) {
                var $result = $(result);
                var contactResult = new __WEBPACK_IMPORTED_MODULE_4__ContactResult__["a" /* default */]($result);
                contactStep.addResult(contactResult);
            });
            previousStep = contactStep;
        });
    };
    SDXContactWizard.prototype.initializeDom = function () {
        var $window = $(window);
        // Bind hash change handlers
        $window.on('hashchange', this.hashChanged.bind(this));
        // Store initial document title
        this.defaultTitle = this.titleManipulator.titleGetter();
        // Create animator
        this.scrollAnimation = Object(__WEBPACK_IMPORTED_MODULE_6_lib_util_createAnimation__["createAnimation"])({
            startValueCalculator: function () {
                return document.documentElement.scrollTop;
            },
            animator: function (_time, scrollTop) {
                window.scroll(undefined, scrollTop);
            },
            easing: 'swing',
        });
    };
    SDXContactWizard.prototype.scrollToTopic = function (topic) {
        if (!topic) {
            return;
        }
        var step = topic.step;
        if (!step) {
            return;
        }
        var pos = step.getContext().offset();
        if (!pos) {
            return;
        }
        var $correctionElement = $(document.body).find('.modHeader .scsh-lvl2-container');
        var correction = $correctionElement.length > 0 ? $correctionElement.height() - 30 : 0;
        this.scrollAnimation.start({
            endValue: pos.top - correction,
        });
    };
    SDXContactWizard.prototype.setHash = function (hash) {
        if (this.currentHash === hash) {
            return;
        }
        this.currentHash = hash;
        this.hashManipulator.hashSetter(hash || '');
    };
    SDXContactWizard.prototype.getHash = function () {
        var hash = this.hashManipulator.hashGetter() || '';
        if (hash.charAt(0) === '#') {
            hash = hash.substring(1);
        }
        if (hash === this.currentHash) {
            return undefined;
        }
        return hash;
    };
    SDXContactWizard.prototype.loadStateFromHash = function (hash) {
        if (!hash || !this.steps || !this.steps.length) {
            return;
        }
        var topic = null;
        // Find topic by name
        for (var _i = 0, _a = this.steps; _i < _a.length; _i++) {
            var step = _a[_i];
            topic = step.namedTopic(hash);
            if (topic) {
                break;
            }
        }
        if (topic) {
            this.currentHash = hash;
            this.steps[0].selectTopic(topic);
        }
        else if (!hash) {
            this.steps[0].deselect();
        }
    };
    SDXContactWizard.prototype.hashChanged = function () {
        var hash = this.getHash();
        this.loadStateFromHash(hash);
    };
    SDXContactWizard.prototype.updateTitle = function (topic) {
        var titles = [];
        while (topic) {
            titles.unshift(topic.getTitle());
            topic = topic.parent;
        }
        var newTitle = this.defaultTitle;
        if (titles.length) {
            newTitle = titles.join(': ') + " \u2013 " + newTitle;
        }
        this.titleManipulator.titleSetter(newTitle);
    };
    SDXContactWizard.prototype.updateTopicClasses = function () {
        this.steps.forEach(function (step) {
            step.getTopics().forEach(function (topic) {
                if (!topic.parent) {
                    var children = topic.getChildren();
                    children.forEach(function (child, idx) {
                        if (!(idx % 3 - 1)) {
                            child.getContext().addClass('margin-side');
                        }
                    });
                }
            });
        });
    };
    return SDXContactWizard;
}(__WEBPACK_IMPORTED_MODULE_1_lib_vendor_terrific_Module__["a" /* Module */]));
/* harmony default export */ __webpack_exports__["a"] = (SDXContactWizard);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),
/* 237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__NodeWrapper__ = __webpack_require__(47);


var ContactStep = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */])(ContactStep, _super);
    function ContactStep($ctx, module, previousStep) {
        var _this = _super.call(this, $ctx) || this;
        _this.module = module;
        _this.topicsByName = new Map();
        _this.topics = [];
        _this.results = [];
        if (previousStep) {
            _this.previousStep = previousStep;
            previousStep.nextStep = _this;
        }
        _this.$ctx.find('.step-back > button').on('click', _this.deselect.bind(_this));
        return _this;
    }
    ContactStep.prototype.namedTopic = function (topicName) {
        return this.topicsByName.get(topicName);
    };
    Object.defineProperty(ContactStep.prototype, "getPreviousStep", {
        get: function () {
            return this.previousStep;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ContactStep.prototype, "getNextStep", {
        get: function () {
            return this.nextStep;
        },
        enumerable: false,
        configurable: true
    });
    ContactStep.prototype.addTopic = function (topic) {
        this.topics.push(topic);
        this.topicsByName.set(topic.topicName, topic);
        topic.step = this;
    };
    ContactStep.prototype.addResult = function (result) {
        this.results.push(result);
        result.step = this;
    };
    ContactStep.prototype.updateItems = function (current, active) {
        this.topics.forEach(function (topic) { return topic.updateState(current, active); });
        this.results.forEach(function (result) { return result.updateState(current, active); });
    };
    ContactStep.prototype.getTopics = function () {
        return this.topics;
    };
    ContactStep.prototype.deselect = function () {
        if (!this.selectedTopic) {
            return;
        }
        var newTopic = (this.previousStep && this.previousStep.selectedTopic) || null;
        this.selectTopic(newTopic);
    };
    ContactStep.prototype.markActive = function (parentTopic) {
        var activeItems = [];
        if (parentTopic) {
            // Mark which subset of topics/results are active (the ones whose parent are from the previous step)
            activeItems = parentTopic.getChildren();
        }
        // Deactivate all items
        this.updateItems(false, false);
        // Activate active items
        activeItems.forEach(function (topic) { return topic.updateState(null, true); });
        // Set step active if we have topics to show in this step
        this.updateState(null, !!activeItems.length);
    };
    ContactStep.prototype.selectTopic = function (topic) {
        // Search parents of the newly-selected topic until we found one in our step (like jQuery.fn.closest)
        var stepTopic = topic;
        while (stepTopic && stepTopic.step !== this) {
            stepTopic = stepTopic.parent;
        }
        // Mark the step topic as selected
        this.selectedTopic = stepTopic;
        this.setAdditionalClasses();
        if (this.selectedTopic) {
            var children = this.selectedTopic.getChildren();
            var $par = children.length ? children[0].getContext().parent() : $();
            if (this.selectedTopic.isResult) {
                $par.siblings('.additional-info').addClass('hidden');
            }
            else {
                $par.siblings('.additional-info').removeClass('hidden');
            }
        }
        // Set current if we have a “current” topic for this step
        this.updateState(!!stepTopic, null);
        // Remove “current” from all items
        this.updateItems(false, null);
        // Mark current item active (if any)
        if (stepTopic) {
            stepTopic.updateState(true, null);
        }
        // Propagate to the next step (if any)
        if (this.nextStep) {
            if (this.selectedTopic && this.selectedTopic.isResult && this.nextStep.nextStep) {
                this.nextStep.updateState(null, false);
                this.nextStep.nextStep.markActive(stepTopic);
                this.nextStep.nextStep.selectTopic(topic);
            }
            else {
                this.nextStep.markActive(stepTopic);
                this.nextStep.selectTopic(topic);
            }
        }
        else {
            // Mark topic as selected in the module (for hash handling, scrolling and stuff)
            this.module.topicSelected(topic);
        }
    };
    ContactStep.prototype.setAdditionalClasses = function () {
        this.$ctx.toggleClass('link-selected', !!(this.selectedTopic && this.selectedTopic.isLink()));
        if (this.selectedTopic &&
            this.nextStep &&
            this.nextStep.nextStep &&
            this.selectedTopic.isResult) {
            // Explicitely call set additional classes since in this case this step will be skipped by selectTopic()
            this.nextStep.setAdditionalClasses();
        }
        if (!this.selectedTopic &&
            this.previousStep &&
            this.previousStep.selectedTopic &&
            this.previousStep.selectedTopic.isResult) {
            this.$ctx.addClass('skipped');
        }
        else {
            this.$ctx.removeClass('skipped');
        }
    };
    return ContactStep;
}(__WEBPACK_IMPORTED_MODULE_1__NodeWrapper__["a" /* default */]));
/* harmony default export */ __webpack_exports__["a"] = (ContactStep);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),
/* 238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BaseItem__ = __webpack_require__(48);


var ContactTopic = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */])(ContactTopic, _super);
    function ContactTopic($ctx) {
        var _this = _super.call(this, $ctx) || this;
        _this.name = _this.$ctx.data('name');
        _this.link = _this.$ctx.data('result-link');
        _this.trackingLabel = _this.$ctx.data('tracking-label');
        _this.trackingCategory = _this.$ctx.data('tracking-category');
        _this._isResult = !!_this.$ctx.data('is-result-container');
        _this.init();
        return _this;
    }
    Object.defineProperty(ContactTopic.prototype, "topicName", {
        get: function () {
            return this.name;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ContactTopic.prototype, "topicTrackingLabel", {
        get: function () {
            return this.trackingLabel;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ContactTopic.prototype, "topicTrackingCategory", {
        get: function () {
            return this.trackingCategory;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ContactTopic.prototype, "isResult", {
        get: function () {
            return this._isResult;
        },
        enumerable: false,
        configurable: true
    });
    ContactTopic.prototype.isLink = function () {
        return !!this.link;
    };
    ContactTopic.prototype.getTitle = function () {
        return this.$ctx.find('.title').text();
    };
    ContactTopic.prototype.isCurrent = function () {
        return this.$ctx.hasClass('current');
    };
    ContactTopic.prototype.init = function () {
        if (!this.$ctx.hasClass('is-result')) {
            this.$ctx.on('click', this.select.bind(this));
        }
    };
    ContactTopic.prototype.select = function () {
        this.step.selectTopic(this);
    };
    return ContactTopic;
}(__WEBPACK_IMPORTED_MODULE_1__BaseItem__["a" /* default */]));
/* harmony default export */ __webpack_exports__["a"] = (ContactTopic);


/***/ }),
/* 239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BaseItem__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lib_util_helpers__ = __webpack_require__(4);



var ContactResult = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */])(ContactResult, _super);
    function ContactResult($ctx) {
        return _super.call(this, $ctx) || this;
    }
    ContactResult.prototype.updateState = function (current, active) {
        _super.prototype.updateState.call(this, current, active);
        if (active) {
            Object(__WEBPACK_IMPORTED_MODULE_2_lib_util_helpers__["initNewModules"])(this.$ctx);
        }
    };
    return ContactResult;
}(__WEBPACK_IMPORTED_MODULE_1__BaseItem__["a" /* default */]));
/* harmony default export */ __webpack_exports__["a"] = (ContactResult);


/***/ }),
/* 240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($, jQuery) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sdx_form_Select__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lib_vendor_terrific_Module__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lib_util_helpers__ = __webpack_require__(4);
/// <reference types="@swisscom/sdx/dist/js/webcomponents/types/components" />




var scDate = window.SCS.utils.date;
function clear(el) {
    if (!el) {
        return undefined;
    }
    while (el.firstChild) {
        el.removeChild(el.firstChild);
    }
    return el;
}
/**
 * SDX Date Picker.
 *
 * @author Kiril Delovski
 * @class SDXDatePicker
 * @extends Tc.Module
 */
var SDXDatePicker = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */])(SDXDatePicker, _super);
    function SDXDatePicker() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SDXDatePicker.prototype.on = function (callback) {
        var _a, _b;
        var now = new Date();
        var $field = $('>.date-field', this.$ctx);
        var $input = $('sdx-input[type="date"]', this.$ctx);
        this.$hiddenInput = this.$ctx.find("input[data-name=\"" + $input.attr('name') + "\"]");
        // Container for time field options
        var timeSelect = this.$ctx.find('.time-container select')[0];
        if (timeSelect) {
            this.sdxTimePicker = new __WEBPACK_IMPORTED_MODULE_1_sdx_form_Select__["default"](timeSelect);
        }
        // Snap appointment dates to this value (in minutes, defaults to 30)
        this.timeInterval = parseInt(this.$ctx.data('time-interval') || 30, 10);
        // Option to show time field values as from-to ranges in drop-down
        this.showTimeInterval = this.$ctx.data('show-time-interval') || false;
        // Config for SCS.utils.date
        this.constraints = {
            // Business hours
            day: {},
            hours: [
                scDate.toHours(this.$ctx.data('time-from') || 8),
                scDate.toHours(this.$ctx.data('time-to') || 17),
            ],
            includeClosingTime: !this.showTimeInterval,
            interval: this.timeInterval / 60,
            // Date constraints
            maxDate: $input.data('enable-until'),
            minDate: $input.data('enable-from'),
            // Time constraints
            refTimeField: (_a = this.sdxTimePicker) === null || _a === void 0 ? void 0 : _a.element,
            time: !!this.sdxTimePicker,
            week: [
                true,
                true,
                true,
                true,
                true,
                true,
                true, // Sat
            ],
        };
        // Upgrade for utils.date compatible config
        // Create exclude days configuration (D.M[.Y])
        var exclDateDays = $input.data('exclude-days') || [];
        for (var _i = 0, exclDateDays_1 = exclDateDays; _i < exclDateDays_1.length; _i++) {
            var exclDateDay = exclDateDays_1[_i];
            // Normalize DD.MM.YYYY to D.M.Y (remove leading zeros)
            var dayDate = exclDateDay.replace(/(^|\.)0+/g, '$1');
            this.constraints.day[dayDate] = false;
        }
        // Create weekday configuration (weekday in java form)
        // Get a list of weekdays to skip (start from 1 = sun)
        var exclWeekDays = $input.data('no-weekdays') || [];
        for (var _c = 0, exclWeekDays_1 = exclWeekDays; _c < exclWeekDays_1.length; _c++) {
            var exclWeekDay = exclWeekDays_1[_c];
            this.constraints.week[exclWeekDay - 1] = false;
        }
        // Working block hours in old representation
        this.timeFrom = this.$ctx.data('time-from') || 8;
        this.timeTo = this.$ctx.data('time-to') || 17;
        // Calculate the length of a working day
        this.constraints.workDuration = scDate.toHours(this.timeTo) -
            scDate.toHours(this.timeFrom);
        // Options to skip time in work blocks
        this.constraints.wPeriod = scDate.toHours(this.sdxTimePicker ? this.$ctx.data('time-available-from') : 0);
        // Create a new client validation instance
        this.cv = ScForm.createClientValidation({
            constraintData: this.constraints,
        });
        // Get options for client validation (twice in source?)
        var clientvalidation = $field.data('clientvalidation') || {};
        // Upgrade client validation constraints config
        // Be used by client validation `validateDate`
        clientvalidation.constraintData = this.constraints;
        this.isReadOnly = $input.prop('readonly');
        this.showCurrentDate = $input.data('show-current-date');
        this.$timeContainer = this.$ctx.find('.time-container');
        if (!this.isReadOnly) {
            setFlatpickrConstraints($input);
        }
        if (this.showCurrentDate && !$input.val()) {
            // Sets date in format `DD.MM.YYYY`
            $input[0].setAttribute('value', scDate.format(now));
        }
        if (this.sdxTimePicker) {
            if ($input.val()) {
                this.onSelectListener($input.val());
            }
            else {
                (_b = this.sdxTimePicker) === null || _b === void 0 ? void 0 : _b.disable();
            }
        }
        else {
            this.createTimes();
        }
        $input[0].changeCallback = this.inputCallback.bind(this);
        callback();
    };
    SDXDatePicker.prototype.inputCallback = function (value) {
        var $input = $('sdx-input[type="date"]', this.$ctx);
        $input[0].setAttribute('value', value);
        this.$hiddenInput.val(value);
        this.onSelectListener(value);
    };
    /**
     * Create an array of appointments for the given date/day
     * Optionally you may pass a minimal starting date/time
     */
    SDXDatePicker.prototype.getAppointmentTimes = function (date, config) {
        // Get list of open/close pairs for the specific day
        var workBlocks = scDate.getOpeningHours(date, this.cv.constraintData);
        // Maybe we have some holiday?
        if (!workBlocks || workBlocks === true) {
            return [];
        }
        // Do calculations after easy checks
        var now = config.now || new Date();
        var interval = config.interval || 0.5;
        var inclusive = !!config.includeClosingTime;
        var min = scDate.getMinDate(now, config);
        // Compare the day parts of the date objects
        var cmpDays = scDate.compareDays(date, min);
        // No appointments in the past
        if (cmpDays < 0) {
            return [];
        }
        // Set time to zero now to make all times available
        // Only needed if min and date are on the same day
        var startTime = cmpDays ?
            0 : Math.max(scDate.toHours(min), scDate.toHours(date));
        // Create result array
        var appointments = [];
        for (var i = 0; i < workBlocks.length; i += 2) {
            // Note: values should already be in that form
            var blockStart = scDate.toHours(workBlocks[i + 0]);
            var blockStop = scDate.toHours(workBlocks[i + 1]);
            // Check if we should include the closing time
            if (!inclusive) {
                blockStop -= interval;
            }
            // Now loop through this workblock by given interval
            // The last block time was deliberately left out here
            for (var t = blockStart; t <= blockStop; t += interval) {
                // Add everything after the startTime
                if (t >= startTime) {
                    appointments.push(t * 60);
                }
            }
        }
        // Return array now
        return appointments;
    };
    // Create
    SDXDatePicker.prototype.createTimes = function (dateString) {
        var _a, _b, _c, _d, _e, _f, _g;
        // Invalid input
        if (!dateString) {
            (_a = this.sdxTimePicker) === null || _a === void 0 ? void 0 : _a.disable();
            return;
        }
        this.constraints.refTimeField = (_b = this.sdxTimePicker) === null || _b === void 0 ? void 0 : _b.element;
        // Allow to pass a day date string
        // We are mostly called on input values
        var date = scDate.parseDateDay(dateString);
        // Helper function to create a drop-down option
        function createOption(name, value, selected) {
            if (selected === void 0) { selected = false; }
            // Create an option and set mandatory options
            var option = jQuery('<OPTION>').val(value).html(name);
            // Optionally set the selected attribute
            if (selected) {
                option.attr('selected', 'selected');
            }
            // Return dom node
            return option[0];
        }
        // Helper to convert minutes to strings
        function minutesToString(minutes) {
            return [
                Object(__WEBPACK_IMPORTED_MODULE_3_lib_util_helpers__["zeroFill"])(Math.floor(minutes / 60), 2),
                Object(__WEBPACK_IMPORTED_MODULE_3_lib_util_helpers__["zeroFill"])(Math.floor(minutes) % 60, 2),
            ].join(':');
        }
        var interval = this.timeInterval;
        var config = this.cv.constraintData;
        // Get array of all available appointments that day
        var times = this.getAppointmentTimes(date, config);
        // Dom node store
        var options = [];
        // Create a select dropdown
        if (times && times.length && this.sdxTimePicker) {
            // Get the text to put on top of the drop-down
            var slctTxt = this.sdxTimePicker.element.dataset.pleaseSelect;
            var defaultVal = this.sdxTimePicker.element.dataset.defaultValue;
            // Create a first option to enable de-selecting
            if (slctTxt) {
                options.push(createOption(slctTxt, ''));
            }
            // Create options for all available times
            for (var _i = 0, times_1 = times; _i < times_1.length; _i++) {
                var time = times_1[_i];
                // Create main label for start time
                var txt = minutesToString(time);
                // Maybe show a `from - to` interval
                if (this.showTimeInterval) {
                    // Append the stop time to show full range with label
                    txt = [txt, minutesToString(time + interval)].join(' - ');
                }
                // Check if entry should be selected
                var val = minutesToString(time);
                var selected = (val === defaultVal);
                // Append the final option to our array
                options.push(createOption(txt, val, selected));
            }
        }
        // Clear and append the new options
        (_d = clear((_c = this.sdxTimePicker) === null || _c === void 0 ? void 0 : _c.element)) === null || _d === void 0 ? void 0 : _d.append.apply(_d, options);
        (_e = this.sdxTimePicker) === null || _e === void 0 ? void 0 : _e.reload();
        // Enable/disable time field
        if (times && times.length) {
            (_f = this.sdxTimePicker) === null || _f === void 0 ? void 0 : _f.enable();
        }
        else {
            (_g = this.sdxTimePicker) === null || _g === void 0 ? void 0 : _g.disable();
        }
    };
    SDXDatePicker.prototype.onSelectListener = function (date) {
        var _a;
        if (!this.sdxTimePicker) {
            return;
        }
        if (!this.cv.validate(date)) {
            (_a = this.sdxTimePicker) === null || _a === void 0 ? void 0 : _a.disable();
            return;
        }
        // Update drop-down
        this.createTimes(date);
    };
    return SDXDatePicker;
}(__WEBPACK_IMPORTED_MODULE_2_lib_vendor_terrific_Module__["a" /* Module */]));
/* harmony default export */ __webpack_exports__["a"] = (SDXDatePicker);
function setFlatpickrConstraints($el) {
    var yearFrom = $el.data('year-from') || '';
    var yearTo = $el.data('year-to') || '';
    var noWeekDays = $el.data('no-weekdays') || [];
    var excludeDays = $el.data('exclude-days') || [];
    var enableFrom = $el.data('enable-from');
    var enableUntil = $el.data('enable-until');
    var availableDaysInWeek = [];
    var daysConstraint = [];
    if (yearTo && yearFrom) {
        $el[0].flatpickrOptions = {
            disable: excludeDays,
            maxDate: '31.12.' + yearTo,
            minDate: '01.01.' + yearFrom,
        };
    }
    if (enableFrom !== -1 && enableUntil !== -1) {
        $el[0].flatpickrOptions = {
            disable: excludeDays,
            maxDate: new Date().fp_incr(enableUntil),
            minDate: new Date().fp_incr(enableFrom),
        };
    }
    if (noWeekDays.length > 0) {
        for (var _i = 0, noWeekDays_1 = noWeekDays; _i < noWeekDays_1.length; _i++) {
            var noWeekDay = noWeekDays_1[_i];
            availableDaysInWeek.push(noWeekDay - 1);
        }
        daysConstraint = excludeDays.concat([
            function (date) {
                return availableDaysInWeek.indexOf(date.getDay()) >= 0;
            },
        ]);
        $el[0].flatpickrOptions = {
            disable: daysConstraint,
        };
    }
}

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0), __webpack_require__(0)))

/***/ }),
/* 241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($, SnabbdomPragma) {/* harmony export (immutable) */ __webpack_exports__["a"] = renderMsgChannel;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bootstrap_load_snabbdom__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lib_generic_SDXModalDialog__ = __webpack_require__(7);



function openModal(evt) {
    Object(__WEBPACK_IMPORTED_MODULE_1__helpers__["f" /* trackCtx */])(evt);
    var $target = $(evt.currentTarget);
    var config = {
        title: $target.data('modal-title'),
        url: $target.data('modal-url'),
    };
    if ($target.data('modal-width')) {
        config.width = $target.data('modal-width');
    }
    if ($target.data('modal-height')) {
        config.height = $target.data('modal-height');
    }
    __WEBPACK_IMPORTED_MODULE_2_lib_generic_SDXModalDialog__["default"].show(config);
}
function RenderMsgOption(_a) {
    var config = _a.config;
    return SnabbdomPragma.createElement("div", { className: "col-xs-12 col-md-6 tracking-info-holder margin-bottom-1", "attrs-data-conversion-category": config.tracking['data-conversion-category'], "attrs-data-conversion-detail": config.tracking['data-conversion-detail'], "attrs-data-conversion-class": config.tracking['data-conversion-class'], "attrs-data-track-action": config.tracking['data-track-action'], "attrs-data-track-category": config.tracking['data-track-category'], "attrs-data-track-label": config.tracking['data-track-label'], "attrs-data-track-linkname": config.tracking['data-track-linkname'], "attrs-data-track-location": config.tracking['data-track-location'] },
        config.channel === 'sms' && SnabbdomPragma.createElement(RenderSMS, { config: config }),
        config.channel === 'wa' && SnabbdomPragma.createElement(RenderWa, { config: config }),
        config.channel === 'abc' && SnabbdomPragma.createElement(RenderAbc, { config: config }));
}
function RenderAbc(_a) {
    var config = _a.config;
    return SnabbdomPragma.createElement("a", { "attrs-href": config.abcUrl, className: "abc-chat-link", "on-click": __WEBPACK_IMPORTED_MODULE_1__helpers__["f" /* trackCtx */], "attrs-target": "_blank", "attrs-data-role": "none" },
        SnabbdomPragma.createElement("img", { className: "wa-logo", "attrs-src": "/etc/designs/base/resources/images/apple_business_chat.png", "attrs-width": "50", "attrs-height": "50" }),
        config.label);
}
function RenderWa(_a) {
    var config = _a.config;
    return SnabbdomPragma.createElement("a", { "attrs-href": config.waUrl, className: "wa-chat-link", "on-click": __WEBPACK_IMPORTED_MODULE_1__helpers__["f" /* trackCtx */], "attrs-target": "_blank", "attrs-data-role": "none" },
        config.type !== 'link' &&
            SnabbdomPragma.createElement("img", { className: "wa-logo", "attrs-src": "/etc/designs/base/resources/images/whatsapp.svg", "attrs-width": "50", "attrs-height": "50" }),
        config.label);
}
function RenderSMS(_a) {
    var config = _a.config;
    if (config.modalPath) {
        return SnabbdomPragma.createElement(RenderSMSDesktop, { config: config });
    }
    return SnabbdomPragma.createElement(RenderSMSMobile, { config: config });
}
function RenderSMSMobile(_a) {
    var config = _a.config;
    return SnabbdomPragma.createElement("a", { className: "sms-chat-link", "attrs-href": config.smsUrl, "on-click": __WEBPACK_IMPORTED_MODULE_1__helpers__["f" /* trackCtx */], "attrs-data-role": "none" },
        config.type !== 'link' &&
            SnabbdomPragma.createElement("span", { className: "sms-logo" },
                SnabbdomPragma.createElement("i", { className: "icon icon--s3 icon-163-sms sc-white" })),
        config.label);
}
function RenderSMSDesktop(_a) {
    var config = _a.config;
    return SnabbdomPragma.createElement("button", { type: "button", className: "link sms-chat-link", "attrs-data-modal-url": config.modalPath, "attrs-data-modal-title": config.modalTitle, "attrs-data-modal-width": config.modalWidth, "attrs-data-modal-height": config.modalHeight, "on-click": openModal },
        config.type !== 'link' &&
            SnabbdomPragma.createElement("span", { className: "sms-logo" },
                SnabbdomPragma.createElement("i", { className: "icon icon--s3 icon-163-sms sc-white" })),
        config.label);
}
function RenderMsgChannel(_a) {
    var title = _a.title, introductionText = _a.introductionText, additionalText = _a.additionalText, msg = _a.msg;
    return SnabbdomPragma.createElement("div", { className: "contact-holder" },
        title &&
            SnabbdomPragma.createElement("h4", { className: "sc-navy margin-bottom-3" }, title),
        introductionText &&
            SnabbdomPragma.createElement("div", { className: "introduction-text margin-bottom-2", innerHTML: introductionText }),
        SnabbdomPragma.createElement("div", { className: "row show-grid" }, msg.map(function (cfg) {
            return SnabbdomPragma.createElement(RenderMsgOption, { config: cfg });
        })),
        additionalText &&
            SnabbdomPragma.createElement("div", { className: "additional-text margin-top-2", innerHTML: additionalText }));
}
function renderMsgChannel(target, title, introductionText, additionalText, channels) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_bootstrap_load_snabbdom__["b" /* patch */])(target, SnabbdomPragma.createElement(RenderMsgChannel, { title: title, introductionText: introductionText, additionalText: additionalText, msg: channels }));
}

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0), __webpack_require__(10)))

/***/ }),
/* 242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(SnabbdomPragma) {/* harmony export (immutable) */ __webpack_exports__["a"] = renderChat;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bootstrap_load_snabbdom__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_bootstrap_load_terrific__ = __webpack_require__(1);



var hooks = {
    insert: function (vnode) {
        window.application.sandbox.addModules(__WEBPACK_IMPORTED_MODULE_1_jquery___default()(vnode.elm));
    },
};
function LivepersonChat(_a) {
    var chatType = _a.chatType, trackingConfig = _a.trackingConfig;
    var cssClasses = chatType === 'general' ? 'modLivePersonChat' : 'mod modLivePersonChatForContact';
    return SnabbdomPragma.createElement("div", { className: cssClasses, id: chatType === 'general' ? 'lpChatGeneralButton' : '', "attrs-data-connectors": chatType === 'contact' ? 'sdxContactWizard,contactWizard' : '', "attrs-data-conversion-category": trackingConfig['data-conversion-category'], "attrs-data-conversion-detail": trackingConfig['data-conversion-detail'], "attrs-data-conversion-class": trackingConfig['data-conversion-class'], "attrs-data-track-action": trackingConfig['data-track-action'], "attrs-data-track-category": trackingConfig['data-track-category'], "attrs-data-track-label": trackingConfig['data-track-label'], "attrs-data-track-linkname": trackingConfig['data-track-linkname'], "attrs-data-track-location": trackingConfig['data-track-location'] });
}
function GenesysChat(_a) {
    var chatId = _a.chatId, chatType = _a.chatType, trackingConfig = _a.trackingConfig;
    var cssClasses = chatType === 'general' ? '' : 'mod modGenesysChatForContact';
    return SnabbdomPragma.createElement("div", { className: cssClasses, id: chatId, "attrs-data-connectors": chatType === 'contact' ? 'sdxContactWizard' : '', "attrs-data-conversion-category": trackingConfig['data-conversion-category'], "attrs-data-conversion-detail": trackingConfig['data-conversion-detail'], "attrs-data-conversion-class": trackingConfig['data-conversion-class'], "attrs-data-track-action": trackingConfig['data-track-action'], "attrs-data-track-category": trackingConfig['data-track-category'], "attrs-data-track-label": trackingConfig['data-track-label'], "attrs-data-track-linkname": trackingConfig['data-track-linkname'], "attrs-data-track-location": trackingConfig['data-track-location'] });
}
function Chat(_a) {
    var title = _a.title, introductionText = _a.introductionText, chatType = _a.chatType, chatId = _a.chatId, chatProvider = _a.chatProvider, trackingConfig = _a.trackingConfig;
    return SnabbdomPragma.createElement("div", { hook: hooks },
        title &&
            SnabbdomPragma.createElement("h4", { className: "sc-navy margin-bottom-3" }, title),
        introductionText &&
            SnabbdomPragma.createElement("div", { className: "introduction-text margin-bottom-2", innerHTML: introductionText }),
        chatProvider === 'liveperson' &&
            SnabbdomPragma.createElement(LivepersonChat, { chatType: chatType, trackingConfig: trackingConfig }),
        chatProvider === 'genesys' &&
            SnabbdomPragma.createElement(GenesysChat, { chatId: chatId, chatType: chatType, trackingConfig: trackingConfig }));
}
function renderChat(target, title, introductionText, chatType, chatId, chatProvider, trackingConfig) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_bootstrap_load_snabbdom__["b" /* patch */])(target, SnabbdomPragma.createElement(Chat, { title: title, introductionText: introductionText, chatType: chatType, chatId: chatId, chatProvider: chatProvider, trackingConfig: trackingConfig }));
}

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(10)))

/***/ }),
/* 243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lib_vendor_terrific_Module__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__profile__ = __webpack_require__(5);



var SamAGB = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */])(SamAGB, _super);
    function SamAGB() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SamAGB.prototype.on = function (callback) {
        this.scriptSrc = this.$ctx.data('scriptSrc');
        callback();
    };
    SamAGB.prototype.after = function () {
        return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var user;
            return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (window.suppressDatausageOverlay) {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_2__profile__["getProfile"])()];
                    case 1:
                        user = (_a.sent()).getUser();
                        if (!user) {
                            return [2 /*return*/];
                        }
                        $.ajax({
                            cache: true,
                            dataType: 'script',
                            url: this.scriptSrc,
                            success: function () {
                                PopupJs.init('PORTAL', document.documentElement.lang, 'POPUP_Portal');
                            },
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    return SamAGB;
}(__WEBPACK_IMPORTED_MODULE_1_lib_vendor_terrific_Module__["a" /* Module */]));
/* harmony default export */ __webpack_exports__["a"] = (SamAGB);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),
/* 244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lib_vendor_terrific_Module__ = __webpack_require__(3);


var ScrollingArrow = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */])(ScrollingArrow, _super);
    function ScrollingArrow() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ScrollingArrow.prototype.on = function (callback) {
        var _this = this;
        var screenHeight = screen.height - 250;
        this.$ctx.on('click', function () {
            $('html, body').animate({ scrollTop: window.pageYOffset + screenHeight }, 1000);
        });
        $(document).on('scroll', function () {
            _this.$ctx.toggleClass('hidden', window.innerHeight + window.scrollY + 400 > document.body.clientHeight);
        });
        callback();
    };
    return ScrollingArrow;
}(__WEBPACK_IMPORTED_MODULE_1_lib_vendor_terrific_Module__["a" /* Module */]));
/* harmony default export */ __webpack_exports__["a"] = (ScrollingArrow);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_$, __webpack_provided_window_dot_scsHeaderJQuery) {(function ($, scsHeaderJQuery, scsHeader, SCS) {
	'use strict';

	SCS.ecommerce = SCS.ecommerce || {};

	SCS.ecommerce.ECOMMERCE_SERVICE_UNAVAILABLE_EXCEPTION = 503;

	SCS.ecommerce.MESSAGE_TYPE_UNAVAILABLE = 'UNAVAILABLE';

	/**
	 * Call to eCommerce with success/error callbacks.
	 *
	 * The config object is similar to the jQuery.ajax config object.
	 * You can define type (GET or POST), url, data (name/value pairs), success and error callback functions
	 * (or omit any of them, except url).
	 * The callbackObj is for executing the callback functions on (for "this").
	 * @param config Configuration (type, url, data, success, error)
	 * @param callbackObj Callback object ("this" in the callback function)
	 */
	SCS.ecommerce.eCommerceCall = function (config, callbackObj) {
		if (callbackObj === undefined) {
			callbackObj = this;
		}
		config = $.extend({type: 'GET', data: null}, config);
		$.ajax({
			type: config.type,
			url: config.url,
			data: config.data,
			success: function (data) {
				if (data && data.Error) {
					if (data.Error.Code === 'OK') {
						callbackObj._success = config.success;
						callbackObj._success();
					}
					else {
						callbackObj._error = config.error;
						callbackObj._error(data.Error.Messages);
					}
				}
				else {
					callbackObj._error = config.error;
					callbackObj._error(null);
				}
			},
			error: function (xhr, textStatus, errorThrown) {
				if (config.error) {
					callbackObj._error = config.error;
					callbackObj._error(errorThrown);
				}
				else {
					if (xhr.status === SCS.ecommerce.ECOMMERCE_SERVICE_UNAVAILABLE_EXCEPTION) {
						SCS.ecommerce.showEcommerceErrorMessage();
					} else {
						SCS.portal.showError();
					}
				}
			}
		});
	};

	/**
	 * Set cookie for all language paths.
	 * Reason: For some strange reason, you can set a cookie on '/' but then later not read it in JavaScript.
	 * At least not on INT1. With deeper paths it works.
	 * @param name Name
	 * @param value Value
	 */
	SCS.ecommerce.setCookieForAllLanguages = function (name, value, expires) {
		var paths = ['/', '/de', '/en', '/fr', '/it'];
		for (var i = 0; i < paths.length; i += 1) {
			scsHeaderJQuery.cookie(name, value, {expires: expires, path: paths[i]});
		}
	};

	/**
	 * Set redirect cookie
	 */
	SCS.ecommerce.setRedirectCookie = function (url) {
		this.setCookieForAllLanguages('SCS_REDIRECT', url);
	};

	/**
	 * Initialize redirect. If the redirect-cookie is present,
	 * this will auto-redirect there (and delete the cookie before that).
	 */
	SCS.ecommerce.initRedirect = function () {
		var url = scsHeaderJQuery.cookie('SCS_REDIRECT');
		if (url) {
			this.setCookieForAllLanguages('SCS_REDIRECT', null);
		}
	};

	/**
	 * find teasers in different containers an synchronize their heights (based on sub-containers)
	 * (by default all predefined teasers are synched BUT one can define two parameters to only synch specific teasers)
	 */
	SCS.ecommerce.synchronizeTeaserHeights = function (containerSelector, teaserSelector, scope) {
		if (!SCS.portal.synchronizeTeaserHeights) {
			return; // no syncing for mobile version
		}

		if (containerSelector && teaserSelector && containerSelector.length && teaserSelector.length) {
			SCS.portal.synchronizeTeaserHeights(containerSelector, teaserSelector, scope);
		}
	};

	/**
	 * Initialize common stuff
	 */
	$(document).ready(function () {
		SCS.ecommerce.initRedirect();
		$(window).on('load', SCS.ecommerce.synchronizeTeaserHeights);
		$(window).on('load', SCS.ecommerce.synchronizePricePaddings);
	});

	SCS.ecommerce.synchronizePricePaddings = function () {
		var height = 0,
			teasers = $('.abos .scs-abo-teaser .custom-radio'),
			hidePanel = false;

		if (teasers.parents('.ui-tabs-panel:hidden').length) {
			hidePanel = true;
			teasers.parents('.ui-tabs-panel').removeClass('ui-tabs-hide');
		}

		teasers.each(function () {
			var $this = $(this);
			height = Math.max(height, $this.height(), $this.css('height', '').height());
		});

		teasers.each(function () {
			var $this = $(this),
				compareHeight = Math.max($this.height(), $this.css('height', '').height());
			if (compareHeight < height) {
				var currentPadding = $this.css('paddingTop').replace('px', '');
				var paddingTop = height - compareHeight + parseInt(currentPadding, 10);
				$this.css('paddingTop', paddingTop + 'px');
			}
		});

		if (hidePanel) {
			teasers.parents('.ui-tabs-panel').addClass('ui-tabs-hide');
		}
	};

	SCS.ecommerce.MESSAGES_CONFIG_RES_URL = '/bin/scs/services/ecommercemessages.keyvalues';
	SCS.ecommerce.MESSAGE_ECOMMERCE_SERVICE_UNAVAILABLE_TITLE = 'ecommerce.service.unavailable.title';
	SCS.ecommerce.MESSAGE_ECOMMERCE_SERVICE_UNAVAILABLE_MESSAGE = 'ecommerce.service.unavailable.message';

	SCS.ecommerce.showEcommerceErrorMessage = function () {
		function findEcommerceMessageValue(msgConfig, configKey) {
			for (var child in msgConfig) {
				if (msgConfig[child].configKey === configKey) {
					return msgConfig[child].configValue;
				}
			}
		}
		$.ajax({
			url: SCS.ecommerce.MESSAGES_CONFIG_RES_URL + '.' + SCS.portal.lang + '.json',
			success: function (configJson) {
				var ecommerceTitle = findEcommerceMessageValue(configJson, SCS.ecommerce.MESSAGE_ECOMMERCE_SERVICE_UNAVAILABLE_TITLE),
					ecommerceMessage = findEcommerceMessageValue(configJson, SCS.ecommerce.MESSAGE_ECOMMERCE_SERVICE_UNAVAILABLE_MESSAGE);

				$('<div/>').html(ecommerceMessage).dialog({
					title: ecommerceTitle,
					classes: {'ui-dialog': 'warn'},
					close: function () {
						history.back();
					}
				});
			}
		});
	};

})(__webpack_provided_window_dot_$, __webpack_provided_window_dot_scsHeaderJQuery, window.scsHeader, window.SCS = window.SCS || {});

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0), __webpack_require__(0)))

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {/**
 * (c) Copyright Swisscom (Schweiz) AG. All rights reserved.
 *
 * This product is the proprietary and sole property of Swisscom (Schweiz) AG
 * Use, duplication or dissemination is subject to prior written consent of
 * Swisscom (Schweiz) AG.
 *
 * $Id: abo.js
 */
$.namespace("SCS.abo");

/**
 * Initialize abo (plan)
 */
SCS.abo.init = function() {
	$('.products').find('.shopping').each(function() {
		$(this).find('input:radio').each(function() {
			var $this = $(this);
			if (this.checked) {
				SCS.abo.getPrice($this);
			}
			$this.change(function() {
				if (this.checked) {
					SCS.abo.getPrice($(this));
				}
			});
		});
	});
};

/**
 * Get price
 * @param radio Radio button
 */
SCS.abo.getPrice = function(radio) {
	var priceDisplay = radio.closest('.shopping').find('.modPriceTag .price');
	priceDisplay.text(radio.data('price'));
};

/**
 * Initialize next button
 */
SCS.abo.initNextButton = function() {
	var nextButton = $('.products').find('.nextresults');
	var items = $('.products').find('.device');
	SCS.portal.initPaging(nextButton, items);
};

/**
 * Initialize
 */
SCS.ensure(function(context, $) {
	SCS.abo.init();
	SCS.abo.initNextButton();
}, 'body, .ui-tabs-panel');

/* Update form action and initialize tooltips in abo teasers */
SCS.ensure(function(context, $) {
	if (context.find('.scs-abo-teaser').length){
		if (SCS.product && typeof SCS.product.updateFormAction !== 'undefined') SCS.product.updateFormAction(context.find('.scs-abo-teaser form.scs-form'));

		$('.scs-abo-teaser .promo-tip').qtip();
	}
}, 'body, .ui-tabs-panel');

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * (c) Copyright Swisscom (Schweiz) AG. All rights reserved.
 *
 * This product is the proprietary and sole property of Swisscom (Schweiz) AG
 * Use, duplication or dissemination is subject to prior written consent of
 * Swisscom (Schweiz) AG.
 *
 * $Id: clipping.js
 */

SCS.fn = SCS.fn || {};

SCS.fn.clipping = function (context, $) {
	$clippingElements = $('.scs-clipping', context);
	if(!$clippingElements.length) {
		return;
	}

	// Export sdx.Accordion, sdx.Select, and sdx.Modal as global as they are used in the eCommerce checkout process.
	var sdx = window.sdx || {};
	sdx.Accordion = __webpack_require__(27).default;
	sdx.Select = __webpack_require__(18).default;
	sdx.Modal = __webpack_require__(36).default;
	window.sdx = sdx;

	$clippingElements.each(function () {
		var $this = $(this),
			hashParams = window.location.hash.slice(1),
			getParams = window.location.search.slice(1),
			url = $this.data('url'),
			parameters,
			params;

		if (typeof url === "undefined") {
			return;
		}

		params = getParams;

		// Bail on already-initialized clippings
		if ($this.data('scs-clipping-has-been-processed')) {
			debug.log('SCS.fn.clipping > Clipping already initialized', url);
			return;
		}
		$this.data('scs-clipping-has-been-processed', true);

		if (hashParams.length > 0) {
			params = params + '&' + hashParams;
		}

		// trim ampersand at beginning of string
		while (params.charAt(0) === '&') {
			params = params.slice(1);
		}

		if (params.length > 0) {

			// encode for firefox which automatically decodes the Link / URL
			if (params.indexOf(' ') != -1) {
				params = encodeURI(params);
			}

			if (url.indexOf('?') === -1) {
				url = url + '?' + params;
			}
			else {
				// if url-data have params and since they are cached they are wrong.
				url = url.slice(0, url.indexOf('?')).concat('?').concat(params);
			}
		}

		$this.attr('data-url', url);
		$this.load(url, function (response, status, xhr) {
			if (xhr.status === SCS.ecommerce.ECOMMERCE_SERVICE_UNAVAILABLE_EXCEPTION) {
				SCS.ecommerce.showEcommerceErrorMessage();
			} else if (status == 'error') {
				SCS.portal.showError(xhr.statusText + ' (' + xhr.status + ')');
			} else {
				// Mark successful load
				$this.data('scs-clipping-has-been-processed', 1);
			}
		});

		if (url.toLowerCase().indexOf('productid') !== -1) {
			//update other wrong links

			//head link[rel='alternate']
			$('head link[rel="alternate"]').each(function () {
				fixLanguageLinks(this, params);
			});

			// lang links
			$('body ul .scs-pie a').each(function () {
				fixLanguageLinks(this, params);
			});

			var logoutUrl = $('body #scs-pageheader-userbox').data('logout-url');
			if (logoutUrl.indexOf('konfiguration.html') != -1 && logoutUrl.indexOf('productid') != -1) {
				fixLoginAndLogoutButtons($('body #scs-pageheader-userbox'), params, 'data-logout-url', logoutUrl);
			}

			logoutUrl = $('body #scs-pageheader-userbox-logout-button').attr('href');
			if (logoutUrl.indexOf('konfiguration.html') != -1 && logoutUrl.indexOf('productid') != -1) {
				fixLoginAndLogoutButtons($('body #scs-pageheader-userbox-logout-button'), params, 'href', logoutUrl);
			}

			var loginUrl = $('body #scs-pageheader-userbox').data('login-url');
			if (loginUrl.indexOf('konfiguration.html') != -1 && loginUrl.indexOf('productid') != -1) {
				fixLoginAndLogoutButtons($('body #scs-pageheader-userbox'), params, 'data-login-url', loginUrl);
			}
		}


	});

	function fixLanguageLinks(element, params) {
		var localeUrl = $(element).attr('href');
		if (localeUrl.indexOf('?') === -1) {
			localeUrl = localeUrl + '?' + params;
		}
		else {
			// if url-data have params and since they are cached they are wrong.
			localeUrl = localeUrl.slice(0, localeUrl.indexOf('?')).concat('?').concat(params);
		}
		$(element).attr('href', localeUrl);
	}

	function fixLoginAndLogoutButtons(element, params, attributeName, url) {
		var rurl = decodeURIComponent(url.slice(url.indexOf('RURL') + 5)),
			base = rurl.slice(0, rurl.indexOf('?')),
			rurlBase = url.slice(0, url.indexOf('RURL') + 5);

		element.attr(attributeName, rurlBase + encodeURIComponent(base.concat('?').concat(params)));
	}

};

SCS.ensure(SCS.fn.clipping, 'body, .ui-tabs-panel');




/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var loadTerrific = __webpack_require__(1);
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function ($) {
	'use strict';
	/*globals Tc */
	/*jshint smarttabs:true */
	/**
	 *
	 * Subscribes to channels: [EcommerceProductDataHub]
	 * Listens to channel events: [startProductDataSubscription, invalidateProductData]
	 * Triggers channel events: []
	 *
	 * @namespace Tc.Module
	 * @class EcommerceProductDataHubTracking
	 * @extends Tc.Module
	 */
	Tc.Module.EcommerceProductDataHubTracking = Tc.Module.extend({

		isInitialTracking: true,
		trackingTimeout: null,
		productChanged: false,
		subscriptionChanged: false,

		lastTracked: null,
		toTrack: null,

		TRACKING_TIMEOUT: 5000,
		// Tealium tag id for metalyzer product retargeting
		TAG_ID_METALYZER_PRODUCT_RETARGETING: 15566,
		PROD_VIEW: 'prodView',
		FAMILY_PAGE: 'familypage',
		EVENT_ACTION_CHANGE: 'change',
		EVENT_LABEL_SUBSCRIPTION_CHANGE: 'subscription selection',
		EVENT_LABEL_PRODUCT_CHANGE: 'product selection',

		on: function (callback) {
			this.onStartProductDataSubscription();
			callback();
		},

		/**
		 * Channel listener to register for EcommerceProductDataHub events.
		 *
		 * @method onStartProductDataSubscription
		 * @return void
		 */
		onStartProductDataSubscription: function () {
			var mod = this,
				initialChannel = 'EcommerceProductDataHub';
			mod.sandbox.subscribe(initialChannel, mod);
			mod.fire('subscribeForProductData', {
				element: mod.$ctx,
				subscribe: function (channel, fetchDataOnSubscribe) {
					if (mod.productDataChannel) {
						mod.sandbox.unsubscribe(mod.productDataChannel, mod);
					}
					mod.productDataChannel = channel;
					mod.sandbox.unsubscribe(initialChannel, mod);
					mod.sandbox.subscribe(channel, mod);

					// If component was lazy loaded, request initialization data
					// from data hub.
					if (fetchDataOnSubscribe) {
						mod.fire('getInfo', {
							callback: function (data) {
								mod.onInvalidateProductData({info: data});
							}
						}, [mod.productDataChannel]);
					}
				}
			}, [initialChannel]);
		},

		after: function () {
		},

		/**
		 * Channel listener which gets called by EcommerceProductDataHub to notify about data changes.
		 *
		 * @method onInvalidateProductData
		 * @param {Object} data See EcommerceProductDataHub for details about the structure
		 * @return void
		 */
		onInvalidateProductData: function (data) {
			var mod = this;

			if (mod.isProductTeaser()) {
				return;
			}

			if (mod.hasChanged(data)) {

				// abort existing timeout handler
				if (mod.trackingTimeout) {
					clearTimeout(mod.trackingTimeout);
					mod.trackingTimeout = null;
				}

				if (mod.subscriptionChanged) {
					// subscription changed: abort possible product changed flag in addition to the aborted timeout
					mod.productChanged = false;
					mod.track(data);
				} else {

					if (mod.isInitialTracking) {
						// fire initial tracking immediately
						mod.track(data);
					} else {
						// fire subsequent tracking calls with a delay
						mod.trackingTimeout = setTimeout($.proxy(mod.track, mod, data), mod.TRACKING_TIMEOUT);
					}
				}
			}
		},

		/**
		 * Check whether the component is port of a product teaser. In that case the tracking functionality is disabled
		 * @returns {boolean}
		 */
		isProductTeaser: function () {
			var mod = this;
			return mod.$ctx.parents("div.productteaser").length > 0;
		},

		/**
		 * Update data and check whether something has changed
		 */
		hasChanged: function (data) {
			var mod = this;
			mod.productChanged = false;
			mod.subscriptionChanged = false;

			if (mod.isProductTeaser()) {
				return false;
			}

			//if (data.info && data.info.product && data.info.subscriptionId) {
			if (data.info && data.info.product) {
				mod.toTrack = data.info;
				SCS.portal.datalayer.setProduct(
					mod.toTrack.product.getId(),
					mod.toTrack.product.getName(),
					mod.toTrack.product.getName(),
					mod.toTrack.family.getCategory(),
					mod.toTrack.product.getProductCategory2(),
					mod.toTrack.product.getBrand()
				);

				if (mod.isInitialTracking) {
					return true;
				} else {
					mod.productChanged = mod.lastTracked.product.getId() != mod.toTrack.product.getId();
					mod.subscriptionChanged = mod.lastTracked.subscriptionId != mod.toTrack.subscriptionId;
					return mod.productChanged || mod.subscriptionChanged;
				}
			}
			return false;

		},

		track: function (data) {
			var mod = this;

			// due to redundantly fire change events during the initialization need a special case to force the initial tracking
			mod.productChanged = mod.isInitialTracking || mod.productChanged;

			// only track product views if tracking is enabled and when not inside of a product tease
			if (mod.trackingEnabled()) {
				mod.datalayerTracking();
				mod.recommendationsTracking();
				mod.isInitialTracking = false;
				mod.lastTracked = mod.toTrack;
				mod.productChanged = mod.subscriptionChanged = false;
			}
		},

		/**
		 * Tealium tracking
		 */
		datalayerTracking: function () {
			var mod = this;

			if (!SCS.datalayer || !SCS.portal.datalayer) {
				debug.log('Tc.Module.EcommerceProductDataHubTracking.datalayerTracking > SCS.datalayer or SCS.portal.datalayer is not defined. Aborting tealium tracking');
			}

			// handling for first time page load
			if (mod.isInitialTracking) {
				// set currently viewed product
				// debug.log('Tc.Module.EcommerceProductDataHubTracking.datalayerTracking > initial page view tracking');

				SCS.portal.datalayer.trackPageView();
			} else {

				// changed product
				if (mod.productChanged) {

					// in this case we need more than the standard set of information in the event,
					// hence we have to create it manually and cannot use SCS.portal.datalayer.trackEvent() directly
					var interaction = new SCS.portal.datalayer.Interaction()
						.withEvent(
							mod.EVENT_ACTION_CHANGE,
							mod.EVENT_LABEL_PRODUCT_CHANGE,
							mod.FAMILY_PAGE + '-configuration',
							mod.FAMILY_PAGE + '-' + mod.toTrack.family.getFamilyName(),
							mod.EVENT_LABEL_PRODUCT_CHANGE
						).withProduct(SCS.portal.datalayer.getProduct());

					debug.log('Tc.Module.EcommerceProductDataHubTracking.datalayerTracking > product has changed', interaction);
					interaction.track();

					// TAGMAN-515 fire metalyzer tag on product change. Note that tag this only fires
					// on utag.view whereas we normally only fire utag.link on product change
					utag.view(window.utag_data, null, [mod.TAG_ID_METALYZER_PRODUCT_RETARGETING]);

					// changed subscription
				} else if (mod.subscriptionChanged) {
					debug.log('Tc.Module.EcommerceProductDataHubTracking.datalayerTracking > subscription has changed');
					SCS.portal.datalayer.trackEvent(
						mod.EVENT_ACTION_CHANGE,
						mod.EVENT_LABEL_SUBSCRIPTION_CHANGE,
						mod.FAMILY_PAGE + '-' + mod.getSubscriptionName(),
						mod.FAMILY_PAGE + '-' + mod.toTrack.family.getFamilyName()
					);
				} else {
					// case not implemented. either product or subscription should have changed
				}
			}
		},

		getSubscriptionName: function () {
			var mod = this;
			return mod.toTrack.product.getSubscriptions().getName(mod.toTrack.subscriptionId);
		},

		/**
		 * Only allow tracking within the context of the Ecommerce xxx Family Pages
		 */
		trackingEnabled: function () {
			return SCS.portal.datalayer.initialized && /Family Page|Product Detail/i.test(SCS.portal.datalayer.getTemplate());
		},

		/**
		 * Adobe Recommendations tracking
		 */
		recommendationsTracking: function () {
			if (window.mboxDefine && window.mboxUpdate) {
				var mod = this,
					el = $('#productPageMbox'),
					lang = $('html').attr('lang') || 'de',
					product = mod.toTrack.product,
					description = $('meta[name="description"]') ? $('meta[name="description"]').attr('content') : '',
					cleanTitle = mod.$ctx.data('page-title') || '';


				if (el.length > 0) {
					if (mod.isInitialTracking) {
						mboxDefine('productPageMbox', 'global_ProductDetailPage');
					}

					var availability = product.getAvailability();

					availability.load().then(function() {
						adobe.target.getOffer({
							mbox: "global_ProductDetailPage",
							params: {
								id: product.getId() + lang + (mod.toTrack.family.getSegment() ? mod.toTrack.family.getSegment().toUpperCase() : ''),  // (Id + Lang)
								idNoLanguage: product.getId(), // (Id)
								title: cleanTitle,
								name: product.getName(), // (Product Name)
								description: description,
								pageURL: window.location.pathname, // (Page URL)
								thumbnailURL: product.getImageMini(), // (Product Image Mini)
								categoryId: product.getCategory(), //product_categories',  // (Category1, Category2, etc.)
								value: product.getOriginalPrice().value(), //( Original Price)
								valueWithAbo: product.getPrice(mod.toTrack.subscriptionId, mod.toTrack.subscriptionDuration).value(), // (Price with Subscription)
								brand: product.getBrand(), // (Product Brand)
								availability: product.getAvailability().getStatus(), // ( Availability)
								ratings: mod.toTrack.family.getRatings().getSummary().getAverage(), // (Rating)
								language: lang, // (Language)
								cfu: mod.toTrack.family.getSegment(), // (CFU: res or sme)
								ProductImageSmall: product.getImageSmall(), // (Product Image Small)
								ProductImageBig: product.getImageBig(), // (Product Image Big)
								pageType: product_page //page_pagetype' // (Content Type of Page)
							},
							success: function(offer) {
								adobe.target.applyOffer({
									mbox: "global_ProductDetailPage",
									selector: el,
									offer: offer
								});
							},
							error: function(error) {
								console.error(error);
								el.style.visibility = "visible";
							}
						});

					});
				}
			}
		}
	});

})(Tc.$);

}.call(window));

/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var loadTerrific = __webpack_require__(1);
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function ($, SCS, doT) {
	'use strict';
	/*globals Tc */

	/**
	 *
	 * Subscribes to channels: ['EcommerceProductDataHub']
	 * Listens to channel events: ['EcommerceProductDataHub']
	 * Triggers channel events: ['subscribeForProductData']
	 *
	 * @namespace Tc.Module
	 * @class EcommerceProductDetail
	 * @extends Tc.Module
	 */
	Tc.Module.EcommerceProductDetail = Tc.Module.extend({

		Type: {
			description: 'description',
			features: 'features',
			contracts: 'contracts',
			deliveryScope: 'deliveryscope',
			ecoPoints: 'ecopoints',
			topFeatures: 'topfeatures',
			promotionName: 'promotionName',
			redflagText: 'redflagText',
			sameDayDelivery: 'sameDayDelivery'
		},

		// used to convert dialog style placeholders to dotJs placeholders
		PLACEHOLDERS: [
			[/\$\{sddMinimumPurchaseAmount\}/g, '{{=it.sddMinimumPurchaseAmount}}'],
			[/\$\{sddShippingFee\}/g, '{{=it.sddShippingFee}}']
		],

		on: function (callback) {
			var mod = this;
			mod.type = mod.$ctx.data('type');
			mod.templateHtml = mod.replacePlaceholders(mod.$ctx.find('script.tmpl').detach().html() || '');
			mod.template = doT.template(mod.templateHtml);
			this.sandbox.application.registry.EcommerceProductDataHub.module.simpleSubscribe(mod, mod.dataChanged);
			callback();
		},

		/**
		 * Channel listener which gets called by EcommerceProductDataHub to notify about data changes.
		 *
		 * @method onInvalidateProductData
		 * @param {Object} data See EcommerceProductDataHub for details about the structure
		 * @return void
		 */
		dataChanged: function(info) {
			var mod = this;
			switch (mod.type) {
				case mod.Type.topFeatures:
					if (info.product) {
						mod.createTopFeatures(info.product);
					}
					break;
				case mod.Type.description:
					if (info.product) {
						mod.createDescriptions(info.product);
					}
					break;
				case mod.Type.promotionName:
					if (info.product) {
						mod.createPromotionName(info);
					}
					break;
				case mod.Type.redflagText:
					if (info.product) {
						mod.createRedFlagText(info.product);
					}
					break;
				case mod.Type.sameDayDelivery:
					if (info.product) {
						mod.createSameDayDelivery(info.product);
					}
					break;
				default:
					if (info.product) {
						mod.requestDetailsCallback(info.product.getDetails());
					}
					break;
			}
		},

		populateTemplate: function (data) {
			var mod = this;
			if (data) {
				mod.$ctx.html(mod.template(data));
				mod.$ctx.removeClass('hidden');
				SCS.utils.initNewModules(mod.$ctx);
			} else {
				mod.$ctx.html('');
				mod.$ctx.addClass('hidden');
			}
		},

		requestDetails: function () {
			var mod = this;
			if (mod.productDataChannel) {
				mod.fire('getDetails', {
					callback: $.proxy(mod.requestDetailsCallback, mod)
				}, [mod.productDataChannel]);
			}
		},

		requestDetailsCallback: function (details) {
			var mod = this;
			if (details) {
				switch (mod.type) {
					case mod.Type.features:
						mod.createFeatures(details);
						break;
					case mod.Type.contracts:
						mod.createContracts(details);
						break;
					case mod.Type.deliveryScope:
						mod.createDeliveryScope(details);
						break;
					case mod.Type.ecoPoints:
						mod.createEcoPoints(details);
						break;
				}
			} else {
				mod.populateTemplate();
			}
		},

		createFeatures: function (details) {
			var mod = this;
			var features = mod.cleanupFeatures(details.getFeatures());
			mod.populateTemplate(features);
		},

		createDescriptions: function (product) {
			var mod = this;
			var features = mod.cleanupFeatures(product.getFeatures());

			if (typeof features === 'string') {
				features = features.replace(/<ul>/g, '<ul class="list">')
			}

			mod.populateTemplate(features);
		},

		createPromotionName: function (info) {
			var promos = info.product.getApplicablePromotions(
				info.subscriptionId,
				info.subscriptionDuration,
				info.subscriptionType
			).filter(function(promo) {
				return !promo.isCallout();
			});

			this.populateTemplate(promos);
		},

		createRedFlagText: function (product) {
			var mod = this,
				data = null;

			if (product.getRedFlagText() && product.getRedFlagText().length) {
				data = {text: product.getRedFlagText()};
			}
			mod.populateTemplate(data);
		},

		createSameDayDelivery: function (product) {
			var mod = this,
				data = null;
			if(product.isSddAllowed()) {
				data = {};
				data.sddMinimumPurchaseAmount = product.getSddMinimumPurchaseAmount();
				data.sddShippingFee = product.getSddShippingFee();
			}

			mod.populateTemplate(data);
		},

		createContracts: function (details) {
			var mod = this, i,
				conditions = details.getGeneralTermsAndConditions(),
				data = {
					items: []
				};
			data.guaranteePeriod = details.getGuaranteePeriod();
			for (i = 0; i < conditions.length; i+=1) {
				data.items.push({
					title: conditions[i].Title,
					url: conditions[i].Url
				});
			}
			mod.populateTemplate(data);
		},

		createDeliveryScope: function (details) {
			var mod = this;
			mod.populateTemplate(details.getDeliveryFeatures());
		},

		createEcoPoints: function (details) {
			var mod = this, data;
			if (details.getEcoPoints() > 0 && details.getPowerConsumption() > 0 && details.getProductionEnergy() > 0 && details.getRawMaterialSelection() > 0) {
				data = {
					ecoPoints: details.getEcoPoints(),
					powerConsumption: details.getPowerConsumption(),
					productionEnergy: details.getProductionEnergy(),
					rawMaterialSelection: details.getRawMaterialSelection()
				};
			}
			mod.populateTemplate(data);
		},

		createTopFeatures: function (product) {
			var mod = this, i,
				features = product.getTopFeatures(),
				data = {
					items: []
				};
			data.slogan = product.getSlogan();
			for (i = 0; i < features.length; i+=1) {
				data.items.push(features[i]);
			}
			mod.populateTemplate(data);
		},

		replacePlaceholders: function (templateHtml) {
			for( var i = 0, length = this.PLACEHOLDERS.length; i < length; i+=1) {
				templateHtml = templateHtml.replace(this.PLACEHOLDERS[i][0], this.PLACEHOLDERS[i][1]);
			}

			return templateHtml;
		},

		cleanupFeatures: function(features) {
			if (!features || !features.filter) {
				return features;
			}
			var found = {};
			return features.filter(function(feature) {
				if (feature.feature && feature.getName() && !found[feature.getName()] && !feature.isBlacklisted() ) {
					found[feature.getName()] = true;

					return true;
				}
			});
		}
	});

})(Tc.$, window.SCS, window.doT);
}.call(window));

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var loadTerrific = __webpack_require__(1);
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function ($) {
	'use strict';
	/*globals Tc, doT, SCS, require */
	/*jshint smarttabs:true */
	var RES_SORT = ['internet', 'tv', 'voip', 'mobile'];
	var SME_SORT = ['internet', 'service', 'voip', 'tv', 'mobile'];
	var flavourSizeFromSiebelId = __webpack_require__(42).flavourSizeFromSiebelId;
	var makePrice = __webpack_require__(13).default;
	/**
	 * PricedBundleTitle module implementation.
	 *
	 * @author Stefan Maurer
	 * @namespace Tc.Module
	 * @class PricedBundleTitle
	 * @extends Tc.Module
	 */
	Tc.Module.PricedBundleTitle = Tc.Module.extend({

		/**
		 * Hook function to do all of your module stuff.
		 *
		 * @method on
		 * @param {Function} callback function
		 * @return void
		 */
		on: function (callback) {
			this.isLegoMode = this.$ctx.data('is-lego-mode');
			if(this.isLegoMode) {
				var pageSegment = $('body').data('page-segment');
				var $ctx = this.$ctx;
				this.sort = (pageSegment === 'res' ? RES_SORT : SME_SORT).map(function(offer) {
					return {
						key: offer,
						i18n: $ctx.data(offer)
					};
				});
				this.sandbox.subscribe('LEGO_CONTAINER', this);
				this.fire('getBundleTotalPrice', ['LEGO_CONTAINER']);
			}


			callback();
		},

		/**
		 * Hook function to do all of your module stuff.
		 *
		 * @method after
		 * @param {Function} callback function
		 * @return void
		 */
		after: function () {
			if(!this.isLegoMode) {
				this.fire('PriceAdded', {}, ['formpriceupdate']);
			}
		},

		onBundleTotalPrice: function (data) {
			var titles = [];

			if(Object.keys(data.selectedFlavours).length > 1) {
				$.each(this.sort,function (index, item) {
					var key = item.key;
					if(data.selectedFlavours[key]) {
						var siebelId = data.selectedFlavours[key].slideId;
						var isServiceDisabled = (siebelId === data.disabledValues['tv-disable'] || siebelId === data.disabledValues['voip-disable'] || siebelId === data.disabledValues['mobile-disable']);
						if(!isServiceDisabled) {
							if(key === 'mobile' && data.mobileConfig) {
								siebelId = $.map(data.mobileConfig, function(val) {
									return val.siebelId === siebelId ? val.siebelName : null;
								})[0] || siebelId;
							}
							var flavourSize = flavourSizeFromSiebelId(siebelId);
							titles.push(item.i18n + ' ' + (key === 'mobile' ? flavourSize : flavourSize.toUpperCase()));
						}
					}
				});
				var inputLabel = this.$ctx.find('.prices input').attr('data-label') + '\n' + titles.join(', ');
				this.$ctx.find('.prices input').val(data.totalPrice).data('price', data.totalPrice).attr('data-price', data.totalPrice).attr('data-label', inputLabel).data('label', inputLabel);
				this.$ctx.find('.price').text(makePrice(data.totalPrice).formatted());
				this.fire('PriceAdded', {}, ['formpriceupdate']);
			}
		}

	});
})(Tc.$);

}.call(window));

/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var loadTerrific = __webpack_require__(1);
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function ($) {
	"use strict";
	/*globals Tc */
	/*jshint smarttabs:true */

	/**
	 * ProductAmountPrice module implementation.
	 *
	 * @author Stefan Maurer, Cesar Keller, Sebastian Bartels
	 * @namespace Tc.Module
	 * @class ProductAmountPrice
	 * @extends Tc.Module
	 */
	Tc.Module.ProductAmountPrice = Tc.Module.extend({

		on: function (callback) {

			callback(); // do not remove!
			this.validMaxNumber();
			// move this here, so the change handler is executed before the change handler Tc.Module.ProductItemGroup.js
			// Tc.Module.ProductItemGroup.js is accessing data that is set in the valueChangeHandler, directly on the object
			$(':input', this.$ctx).on('change', $.proxy(this.valueChangedHandler, this));
		},

		/**
		 * Validates the field content on blur() (min/max and >=0)
		 *
		 * @method after
		 * @return void
		 */

		validMaxNumber: function () {
			var mod = this,
				$ctx = mod.$ctx,
				$inputnumber = $ctx.find("[type=text]"),
				maxnumber = $ctx.find("[type=text]").attr("data-max"),
				errornummeric = $ctx.find(".error-numeric"),

				errormaxed = $ctx.find(".error-maxed");

			debug.log($inputnumber, maxnumber, 'Input Number');
			$inputnumber.keypress(function () {
				var e = window.event||e; // Handle browser compatibility
				var keyID = e.keyCode;

				//space pressed
				if ((keyID == 45) || (keyID == 46) || (keyID == 44)) {
					e.preventDefault(); // Prevent the default action
				}


			});
			$inputnumber.blur(function (e) {

				var inputVal = $(this).val(),
					numericReg = /^\d*[0-9](|.\d*[0-9]|,\d*[0-9])?$/;

				if (inputVal) {
					if(!numericReg.test(inputVal)) {
						errornummeric.show();
					} else {
						errornummeric.hide();
					}

					if (parseInt(inputVal) > parseInt(maxnumber)){
						errormaxed.show();
						$(this).val(0);
						$(this).trigger("change");
					} else {
						errormaxed.hide();
					}
				}

			});
		},

		after: function () {
			var mod = this;
			mod.valueChangedHandler();
			mod.fire("PriceAdded", {}, ["formpriceupdate"]);
		},

		valueChangedHandler: function(event) {
			var mod = this,
				field = event ? $(event.currentTarget) : $(':input', mod.$ctx),
				count = parseInt(field.val()) || 0;
			field.attr('data-hascost', count);
			field.data('hascost', count);
			if (mod.$ctx.data('show-calculated-price')) {
				var priceOnce = field.data('onetime-charge'),
					priceMonthly = field.data('price');

				if (priceOnce) {
					$('.onetime-price .price', mod.$ctx).text(parseFloat(Math.round(count * priceOnce * 100) / 100).toFixed(2));
				}
				if (priceMonthly) {
					$('.monthly-price .price', mod.$ctx).text(parseFloat(Math.round(count * priceMonthly * 100) / 100).toFixed(2));
				}
			}
		}
	});
})(Tc.$);

}.call(window));

/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_Tc_dot_$) {/*** IMPORTS FROM imports-loader ***/
var loadTerrific = __webpack_require__(1);
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function ($, Tc, debug, SCS) {
	'use strict';

	/**
	 *
	 * Subscribes to channels: [EcommerceProductDataHub]
	 * Listens to channel events: [startProductDataSubscription, invalidateProductData]
	 * Triggers channel events: [subscribeForProductData]
	 *
	 * @namespace Tc.Module
	 * @class ProductImage
	 * @extends Tc.Module
	 */
	Tc.Module.ProductImage = Tc.Module.extend({

		on: function (callback) {
			var mod = this;
			mod.image = $('img', mod.$ctx);
			mod.image.data('default-src', mod.image.attr('src'));
			mod.image.data('default-alt', mod.image.attr('alt'));
			mod.size = mod.$ctx.data('size');
			mod.onStartProductDataSubscription();
			callback();
		},

		/**
		 * Channel listener to register for EcommerceProductDataHub events.
		 *
		 * @method onStartProductDataSubscription
		 * @return void
		 */
		onStartProductDataSubscription: function () {
			var mod = this,
				initialChannel = 'EcommerceProductDataHub';
			mod.sandbox.subscribe(initialChannel, mod);
			mod.fire('subscribeForProductData', {
				element: mod.$ctx,
				subscribe: function (channel, fetchDataOnSubscribe) {
					mod.productDataChannel = channel;
					mod.sandbox.unsubscribe(initialChannel, mod);
					mod.sandbox.subscribe(channel, mod);

					if (fetchDataOnSubscribe) {
						mod.fire('getInfo', {
							callback: function (data) {
								mod.onInvalidateProductData({info: data});
							}
						}, [mod.productDataChannel]);
					}
				}
			}, [initialChannel]);
		},

		/**
		 * Channel listener which gets called by EcommerceProductDataHub to notify about data changes.
		 *
		 * @method onInvalidateProductData
		 * @param {Object} data See EcommerceProductDataHub for details about the structure
		 * @return void
		 */
		onInvalidateProductData: function (data) {
			var mod = this, alt, src;
			if (mod.productDataChannel && data.info && data.info.product) {
				alt = data.info.family.getSeoName();
				if (mod.size === 'small') {
					src = data.info.product.getImageSmall();
				} else if (mod.size === 'mini') {
					src = data.info.product.getImageMini();
				} else {
					src = data.info.product.getImageBig();
				}
			}
			src = src || mod.image.data('default-src');
			alt = alt || mod.image.data('default-alt');
			mod.image.attr('src', src);
			mod.image.attr('alt', alt);
		}
	});

}(__webpack_provided_window_dot_Tc_dot_$, window.Tc, window.debug, window.SCS));

}.call(window));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var loadTerrific = __webpack_require__(1);
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function ($) {
	"use strict";
	/*globals Tc, doT, SCS */
	/*jshint smarttabs:true */

	var makePrice = __webpack_require__(13).default;

	/**
	 * ProductOptionsSummary module implementation.
	 *
	 * @author Stefan Maurer
	 * @namespace Tc.Module
	 * @class ProductOptionsSummary
	 * @extends Tc.Module
	 */
	Tc.Module.ProductOptionsSummary = Tc.Module.extend({
		/**
		 * Hook function to do all of your module stuff.
		 *
		 * @method on
		 * @param {Function} callback function
		 * @return void
		 */
		on: function (callback) {
			var mod = this;

			mod.updateSubtotal();
			mod.updateAddress();

			// ensure this event is only bound once
			$(":input[data-price],:input[data-onetime-charge],:input[data-type=item],sdx-input-item[data-price],sdx-input-item[data-onetime-charge],sdx-input-item[data-type=item]").off("change.ProductOptionsSummary");
			$(":input[data-price],:input[data-onetime-charge],:input[data-type=item],sdx-input-item[data-price],sdx-input-item[data-onetime-charge],sdx-input-item[data-type=item]").on("change.ProductOptionsSummary", $.proxy(mod.updateSubtotal, mod));

			callback();
		},

		onBeforeShowStep: function (data) {
			var mod = this;

			if (mod.$ctx.parents('#' + data.stepId).length > 0) {
				debug.log("Tc.Module.ProductOptionsSummary.js > BeforeShowStep " + data.stepId);
				mod.updateAddress();
			}
		},

		onPriceAdded: function (data) {
			var mod = this;

			mod.updateSubtotal();
			// ensure this event is only bound once
			$(":input[data-price],:input[data-onetime-charge],:input[data-type=item],sdx-input-item[data-price],sdx-input-item[data-onetime-charge],sdx-input-item[data-type=item]").off("change.ProductOptionsSummary", $.proxy(mod.updateSubtotal, mod));
			$(":input[data-price],:input[data-onetime-charge],:input[data-type=item],sdx-input-item[data-price],sdx-input-item[data-onetime-charge],sdx-input-item[data-type=item]").on("change.ProductOptionsSummary", $.proxy(mod.updateSubtotal, mod));

		},

		updateAddress: function () {
			var mod = this,
				deliveryAddress = $('.deliveryAddress', mod.$ctx),
				deliverySame = $(":input[name='" + deliveryAddress.attr('data-fieldDeliveryAddressSwitch') + "']").is(':checked'),
				deliverySuffix = (deliverySame) ? "" : "Delivery",
				company = $(":input[name='" + deliveryAddress.attr('data-fieldCompany' + deliverySuffix) + "']").val(),
				salutation = $(":input[name='" + deliveryAddress.attr('data-fieldSalutation' + deliverySuffix) + "']:checked").val(),
				prename = $(":input[name='" + deliveryAddress.attr('data-fieldPrename' + deliverySuffix) + "']").val(),
				surname = $(":input[name='" + deliveryAddress.attr('data-fieldSurname' + deliverySuffix) + "']").val(),
				street = $(":input[name='" + deliveryAddress.attr('data-fieldStreet' + deliverySuffix) + "']").val(),
				zip = $(":input[name='" + deliveryAddress.attr('data-fieldZip' + deliverySuffix) + "']").val(),
				city = $(":input[name='" + deliveryAddress.attr('data-fieldCity' + deliverySuffix) + "']").val(),
				html = '';

			if (company) {
				html += company + '<br />';
			}
			if (salutation) {
				html += salutation + '<br />';
			}
			if (prename || surname) {
				html += prename + ' ' + surname + '<br />';
			}
			if (street) {
				html += street + '<br />';
			}
			if (zip || city) {
				html += zip + ' ' + city;
			}

			deliveryAddress.html(html);
		},

		isHidden: function($element) {
			// checking if parent of element is hidden
			var $visibilityContainer = $element.closest(".modVisibilityControlContainer");

			if($visibilityContainer.children(':input[type=select]').length) {
				return $visibilityContainer.is(":hidden");
			}
			else {
				return true;
			}
			return false;
		},

		updateSubtotal: function () {
			var mod = this,
				prices = {
					items: [],
					monthlyPrices: [],
					onetimePrices: [],
					subTotalOnetime: 0,
					subTotalMonthly: 0
				},
				$form = $(".modScForm form"); // not a parent or child of this mod


			debug.log("Tc.Module.ProductOptionsSummary.js > updateSubtotal");

			// remove current content
			mod.$ctx.find(".priceOverview").remove();
			mod.$ctx.find("#totalOneTimeCost").remove();
			mod.$ctx.find("#totalMonthlyCost").remove();

			// add items price info
			$form.find(':input[data-price],.modBaseBundleOption :input[data-hascost],sdx-input-item[data-price],.modBaseBundleOption sdx-input-item[data-hascost]').each(function () {
				var	$this = $(this),
					itemCountRaw = ($this.filter('[data-hascost]').length && $this.data('hascost') != '') ? $this.data('hascost') : $this.val(),
					itemCount = itemCountRaw == '' ? 0 : itemCountRaw,
					itemPrice = '',
					itemPriceFormatted = '',
					isCheckboxOrRadio = ['checkbox', 'radio'].indexOf(this.type) > -1,
					summary = $this.data('summary') || "",
					itemLabel = $this.data('label'),
					prio = $this.data('prio') || 0;

				if($this.data('price') === '0.00') {
					itemPrice = 1;
					itemPriceFormatted = '0.00';
				}
				else {
					itemPrice = itemCount * $this.data('price');
					itemPriceFormatted = makePrice(itemPrice).formatted();
				}

				var isCheckedRadioOrCheckbox = isCheckboxOrRadio && $this.prop('checked');
				if($this.is('sdx-input-item:not(.hydrated)')) {
					isCheckedRadioOrCheckbox = $this.attr('checked');
				}

				if (itemCount && (!isCheckboxOrRadio || isCheckedRadioOrCheckbox) && itemPrice && mod.isHidden($this)) {
					prices.items[itemLabel] = {
						label: itemLabel,
						itemCount: (itemCount > 0 ? itemCount : ''),
						description: summary,
						onetimePrice: '',
						monthlyPrice: itemPriceFormatted
					};
					prices.monthlyPrices[itemLabel] = {
						description: summary,
						label: itemLabel,
						itemCount: (itemCount > 0 ? itemCount : ''),
						price: itemPriceFormatted,
						prio: prio
					};
					// Making sure we are not adding +1 to the total price
					if ($this.data('price') !== '0.00') {
						prices.subTotalMonthly += itemPrice;
					}
				}

			});

			$('.one-time-summary', mod.$ctx).addClass('ui-helper-hidden');
			prices.subTotalMonthly = parseFloat(Math.round(prices.subTotalMonthly * 100) / 100).toFixed(2);

			// add items price info
			$form.find(":input[data-onetime-charge],.modBaseBundleOption :input[data-hascost],sdx-input-item[data-onetime-charge],.modBaseBundleOption sdx-input-item[data-hascost]").each(function () {
				var $this = $(this),
					itemCountRaw = ($this.filter('[data-hascost]').length && $this.data('hascost') != '') ? $this.data('hascost') : $this.val(),
					itemCount = itemCountRaw == '' ? 0 : itemCountRaw,
					isCheckboxOrRadio = ['checkbox', 'radio'].indexOf(this.type) > -1,
					summary = $this.data('summary') || '',
					itemLabel = $this.data('label'),
					itemPrice = '',
					itemPriceFormatted;
				if($this.data('onetime-charge') === '0.00') {
					itemPrice = 1;
					itemPriceFormatted = '0.00';
				}
				else {
					itemPrice = itemCount * $this.data('onetime-charge');
					itemPriceFormatted = makePrice(itemPrice).formatted();
				}

				var isCheckedRadioOrCheckbox = isCheckboxOrRadio && $this.prop('checked');
				if($this.is('sdx-input-item:not(.hydrated)')) {
					isCheckedRadioOrCheckbox = $this.attr('checked');
				}

				if (itemCount && (!isCheckboxOrRadio || isCheckedRadioOrCheckbox) && itemPrice) {
					if (prices.items[itemLabel]) {
						prices.items[itemLabel].onetimePrice = itemPriceFormatted;
					} else {
						prices.items[itemLabel] = {
							label: itemLabel,
							itemCount: (itemCount > 0 ? itemCount : ''),
							description: summary,
							onetimePrice: itemPriceFormatted,
							monthlyPrice: ''
						};
					}
					prices.onetimePrices[itemLabel] = {
						label: itemLabel,
						description: summary,
						itemCount: (itemCount > 0 ? itemCount : ''),
						price: itemPriceFormatted
					};
					// Making sure we are not adding +1 to the total price
					if ($this.data('onetime-charge') !== '0.00') {
						prices.subTotalOnetime += itemPrice;
					}
				}

			});

			if (prices.subTotalOnetime > 0) {
				$('.one-time-summary', mod.$ctx).removeClass('ui-helper-hidden');
			}

			prices.subTotalOnetime = parseFloat(Math.round(prices.subTotalOnetime * 100) / 100).toFixed(2);

			// Add class summary-page for multipage-summary-step
			mod.$ctx.addClass("summary-page");

			// remove keys from prices.items (dot template wants numeric array keys)
			function assocToArray(obj) {
				return Object.keys(obj).map(function(key) {
					return obj[key];
				});
			}

			prices.items = assocToArray(prices.items);
			prices.monthlyPrices = assocToArray(prices.monthlyPrices);
			prices.onetimePrices = assocToArray(prices.onetimePrices);
			prices.monthlyPrices.sort(function(a, b) {
				return b.prio - a.prio;
			});
			prices.onetimePrices.reverse();

			var templateScript = mod.$ctx.find('script.tmpl-productOptionsSummary'),
				template = doT.template(templateScript.html());

			templateScript.after(template(prices));
		}
	});
})(Tc.$);

}.call(window));

/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var loadTerrific = __webpack_require__(1);
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function ($) {
	"use strict";
	/*globals Tc */
	/*jshint smarttabs:true */
	/**
	 * @namespace Tc.Module
	 * @class ProductItemGroup
	 * @extends Tc.Module
	 */
	Tc.Module.ProductItemGroup = Tc.Module.extend({

		on: function (callback) {
			var mod = this;
			mod.titleBox = $('.title-box', mod.$ctx);
			mod.contentBox = $('.content-box', mod.$ctx);

			mod.titleBox.on('click', function(){
				mod.contentBox.slideToggle(200, function(){
					mod.$ctx.toggleClass('active');
				});
			});
			callback();
		},

		after: function () {
			var mod = this;
			mod.$ctx.find(":input[data-price],:input[data-onetime-charge],:input[data-type=item]").on("change", $.proxy(mod.updatePrice, mod));
			mod.updatePrice();
		},

		updatePrice: function() {
			var mod = this,
				total = 0;
			mod.$ctx.find(':input[data-price],.modBaseBundleOption :input[data-hascost]').each(function () {
				var $this = $(this),
					amount = ($this.filter('[data-hascost]').length && $this.data('hascost') != "") ? $this.data('hascost') : $this.val(),
					price = amount * $this.data('price'),
					isCheckboxOrRadio = $this.is(':checkbox') || $this.is(':radio');

				if (amount > 0) {
					if (isNaN(price)) {
						return;
					}
					if (isCheckboxOrRadio && !$this.is(':checked')) {
						return;
					}
					total += price;
				}
			});
			if (total == 0) {
				mod.$ctx.find('.title-box .price-monthly').addClass('empty').html('&nbsp;');
			} else {
				mod.$ctx.find('.title-box .price-monthly').removeClass('empty').text(parseFloat(Math.round(total * 100) / 100).toFixed(2));
			}

			total = 0;
			mod.$ctx.find(':input[data-onetime-charge]').each(function () {
				var $this = $(this),
					amount = $this.data('hascost'),
					price = amount * $this.data('onetime-charge'),
					isCheckboxOrRadio = $this.is(':checkbox') || $this.is(':radio');

				if (amount > 0) {
					if (isNaN(price)) {
						return;
					}
					if (isCheckboxOrRadio && !$this.is(':checked')) {
						return;
					}
					total += price;
				}
			});
			if (total == 0) {
				mod.$ctx.find('.title-box .price-once').addClass('empty').html('&nbsp;');
			} else {
				mod.$ctx.find('.title-box .price-once').removeClass('empty').text(parseFloat(Math.round(total * 100) / 100).toFixed(2));
			}
		}
	});
})(Tc.$);
}.call(window));

/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_Tc_dot_$) {/*** IMPORTS FROM imports-loader ***/
var loadTerrific = __webpack_require__(1);
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function ($, Module) {
	'use strict';
	/*globals Tc */

	/**
	 * Subscribes to channels: [EcommerceProductDataHub]
	 * Listens to channel events: [startProductDataSubscription, invalidateProductData]
	 * Triggers channel events: [subscribeForProductData]
	 *
	 * @namespace Tc.Module
	 * @class ProductTeaser
	 * @extends Tc.Module
	 */

	Module.ProductTeaser = Tc.Module.extend({

		on: function (callback) {
			var mod = this;
			mod.$formPart = $('<div/>', {'class': 'productTeaserInvisibleFormPart'});
			mod.isMobile = $('body').hasClass('is-mobile');
			mod.priceOrder = $('.modPriceOrderContainer', mod.$ctx);
			mod.useInForm = (mod.$ctx.hasClass('form-teaser') && mod.$ctx.is('form *')) || false;
			mod.translationDuration = mod.$ctx.data('translation-duration');
			mod.translationMonths = mod.$ctx.data('months-translation');

			if ($('.modPromoBadge .ribbon', mod.$ctx).text()) {
				mod.$ctx.addClass('with-badge');
			}
			if ($('.promo-image img', mod.$ctx).length > 0) {
				mod.$ctx.addClass('with-promo-image');
			}
			if (!$('body').hasClass('cq_isEditMode') && !mod.useInForm) {
				mod.bindClickEvent();
			}

			if(mod.useInForm) {
				mod.bindFormClickEvent();
			}

			if(!mod.isMobile && !mod.useInForm) {
				mod.$ctx.find('.modProductImage img, .modTitle h3').wrap('<a class="product-link">');
			}

			mod.onStartProductDataSubscription();
			callback();
		},

		after: function() {
			var mod = this;
			if (mod.$ctx.closest('.modProductOfferPreviews').length > 0) {
				mod.adjustForStage();
			}
		},

		/**
		 * Channel listener to register for EcommerceProductDataHub events.
		 *
		 * @method onStartProductDataSubscription
		 * @return void
		 */
		onStartProductDataSubscription: function() {
			var mod = this,
				initialChannel = 'EcommerceProductDataHub';
			mod.sandbox.subscribe(initialChannel, mod);
			mod.fire('subscribeForProductData', {
				element: mod.$ctx,
				subscribe: function(channel, fetchDataOnSubscribe) {
					mod.productDataChannel = channel;
					mod.sandbox.unsubscribe(initialChannel, mod);
					mod.sandbox.subscribe(channel, mod);

					// If component was lazy loaded, request initialization data
					// from data hub.
					if (fetchDataOnSubscribe) {
						mod.fire('getInfo', {
							callback: function (data) {
								mod.onInvalidateProductData({info: data});
							}
						}, [mod.productDataChannel]);
					}
				}
			}, [initialChannel]);
		},

		/**
		 * Channel listener which gets called by EcommerceProductDataHub to notify about data changes.
		 *
		 * @method onInvalidateProductData
		 * @param {Object} data See EcommerceProductDataHub for details about the structure
		 * @return void
		 */
		onInvalidateProductData: function(data) {
			var mod = this;
			if(data.info.family.getDetailPagePath() && !mod.useInForm) {
				mod.$ctx.find('.product-link').attr('href', data.info.family.getDetailPagePath());
			}

			if (mod.productDataChannel) {
				mod.setTitle(data.info.family.getSeoName());
			} else {
				mod.setTitle();
			}
			if(mod.useInForm) {
				mod.gotDataFromHub(data);
				mod.fire('PriceAdded', {}, ['formpriceupdate']);
			}
		},


		bindClickEvent: function() {
			var mod = this;
			if(mod.isMobile) {
				// bind detail link click to whole teaser only if the price order detail link is in a specific style
				if (mod.priceOrder.find('.details-link.scs-primary-link').length > 0 && mod.$ctx.closest('.carouselContainer').length === 0) {
					mod.$ctx.css('cursor', 'pointer');
					mod.$ctx.addClass('linked-teaser');
					mod.$ctx.on('click', function(){
						mod.priceOrder.trigger('detailsClick');
					});
				}
			} else {
				if (mod.$ctx.closest('.carouselContainer').length === 0 && !mod.$ctx.hasClass('type-product') && !mod.$ctx.hasClass('type-product-wide')) {
					mod.$ctx.css('cursor', 'pointer');
					mod.$ctx.on('click', function (event) {
						if (!$(event.target).is('select')
							&& !$(event.target).is('.secondary-button')
							&& !$(event.target).is('.primary-button')
							&& !$(event.target).is('[data-name] a')
							&& !$(event.target).is('.scs-primary-link')
							&& !$(event.target).is('.ignore-click-forward')) {
							mod.priceOrder.trigger('ctaClick');
						}
					});
				}
			}
		},

		bindFormClickEvent: function () {
			var mod = this;
			mod.$ctx.on('click', function(event) {
				var $grid = mod.$ctx.closest('.modGridLayout');
				var mobileOrDesktopClasses = mod.isMobile ? '.modMobileGallery' : '.modGridLayout .column >';

				mod.$ctx.closest('.modBackgroundContainer').addClass('selected');
				$grid.find('.productTeaserInvisibleFormPart').remove();
				mod.$ctx.append(mod.$formPart);
				mod.fire('PriceAdded', {}, ['formpriceupdate']);
			});
		},

		gotDataFromHub: function(info) {
			info = info.info;
			var mod = this;
			var productInfo = {};
			mod.$formPart.empty();
			if(info && info.product) {
				productInfo = {
					'Name': info.product.getSubscriptions().getName(info.subscriptionId),
					'Duration': info.subscriptionDuration,
					'Id':  info.subscriptionId,
					'SAPId' : info.product.getId(),
					'Title': info.product.getName(),
					'Color' : info.color,
					'MemorySize' : info.memory,
					'Price' : info.product.getPrice(info.subscriptionId, info.subscriptionDuration).value()
				};
				$.each(productInfo, function( k, v ) {
					$('<input>').attr({
						type: 'hidden',
						'class' : 'mobileInfo mobileSubscription' + k,
						name: 'mobileSubscription' + k,
						value: v
					}).appendTo(mod.$formPart);
				});
				mod.$formPart.children('.mobileSubscriptionPrice')
					.attr('data-label', info.product.getName() + ', ' + mod.translationDuration + ' ' + info.subscriptionDuration + ' ' + mod.translationMonths)
					.attr('data-onetime-charge', info.product.getPrice(info.subscriptionId, info.subscriptionDuration).value())
					.attr('data-hascost', '1')
					.attr('data-type', 'base');
			}
		},

		setTitle: function(title) {
			var mod = this;
			if (!mod.title) {
				mod.title = $('.modTitle h2, .modTitle h3, .title h2, .title h3', mod.$ctx);
			}
			mod.title.each(function(){
				var elem = $(this);
				if (!elem.data('text')) {
					elem.data('text', elem.text());
				}
				if (title) {
					elem.text(title);
				} else {
					elem.text(elem.data('text'));
				}
			});
		},

		adjustForStage: function() {
			var mod = this, i, detachedPreviewImage,
				priceContainer = $('.modPriceOrderContainer', mod.$ctx).first(),
				slideContainer = mod.$ctx.closest('.product-offer-preview-slide');
			if (!$('body').hasClass('cq_isEditMode')) {
				if (priceContainer.length > 0) {
					$('.productmodelfilter', mod.$ctx).detach().insertBefore(priceContainer);
				}
				if (slideContainer.length > 0) {
					detachedPreviewImage = $('<div class="modProductTeaser productimage-container">').append($('.productimage', mod.$ctx).detach());
					slideContainer.prepend(detachedPreviewImage);
				}
			}
		}
	});
})(__webpack_provided_window_dot_Tc_dot_$, window.Tc.Module);

}.call(window));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {/*** IMPORTS FROM imports-loader ***/
var loadTerrific = __webpack_require__(1);
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

/*globals Tc */

/**
 * List of available placeholders in the component
 */
var PLACEHOLDERS = {
	familyName: 'familyName'
};

/**
 * Selectors of placeholder aware elements which can contain placeholders
 */
var PLACEHOLDER_AWARE_ELEMENTS = [
	'.tracking'
];

/**
 * Attributes of placeholder aware elements, which can contain placeholders
 */
var PLACEHOLDER_AWARE_ATTRIBUTES = [
	'data-tracking-friendlyname',
	'data-tracking-location',
	'data-tracking-action',
	'data-tracking-label',
	'data-tracking-category',
	'data-tracking-conversionid',
	'data-tracking-conversionsubject'
];

var ORIGIN_URL_TEMPLATE = '##ORIGIN_URL##';

var HASH_SUFFIX = 'retention';

/**
 * @namespace Tc.Module
 * @class RetentionButton
 * @extends Tc.Module
 */
Tc.Module.RetentionButton = Tc.Module.extend({

	on: function (callback) {
		var mod = this;
		mod.loginUrl = mod.$ctx.data('login-url');
		// HOTFIX: Minimal impact change to replace former server side url, with encoded clientside url.
		mod.originUrl = encodeURIComponent(window.location.href.replace(/\(.*\)/,"").replace(/\.html.+/,".html"));

		callback();
	},

	after: function () {
		var mod = this;

		__webpack_require__(5).getProfile().then(function(profile) {
			mod.profile = profile;
			mod.button = mod.$ctx.find('a');
			mod.button.on('click', $.proxy(mod.handleClick, mod));
			mod.updatePlaceholders({});
			mod.onStartProductDataSubscription();
			mod.updateLoginUrl();

			if(profile.getUser()) {
				// if we return from a login, make sure the retention display is shown.
				mod.selectRetentionModelFilter();
			}
		});

	},

	updateLoginUrl: function (info) {
		var mod = this,
			url,
			ch = '#',
			pageUrl = mod.originUrl;

		if (!mod.loginUrl || !pageUrl) {
			return;
		}

		//get origin url from info
		if (info && info.deeplink && info.deeplink.length > 0) {
			mod.deeplink = info.deeplink;
		}

		if (mod.deeplink) {
			pageUrl = pageUrl.replace('.html', mod.deeplink + '.html');
		}

		if (pageUrl.indexOf('#') > -1) {
			ch = '&';
		}

		url = mod.loginUrl.replace(ORIGIN_URL_TEMPLATE, encodeURIComponent(pageUrl + ch + HASH_SUFFIX));

		mod.button.attr('href', url);
		mod.button.data('placeholder-template-href', url);
	},

	/**
	 * Channel listener to register for EcommerceProductDataHub events.
	 *
	 * @method onStartProductDataSubscription
	 * @return void
	 */
	onStartProductDataSubscription: function () {
		var mod = this,
			initialChannel = 'EcommerceProductDataHub';

		mod.sandbox.subscribe(initialChannel, mod);
		mod.fire('subscribeForProductData', {
			element: mod.$ctx,
			subscribe: function (channel, fetchDataOnSubscribe) {
				mod.productDataChannel = channel;
				mod.sandbox.unsubscribe(initialChannel, mod);
				mod.sandbox.subscribe(channel, mod);
				mod.$ctx.removeClass('initializing');

				// If component was lazy loaded, request initialization data
				// from data hub.
				if (fetchDataOnSubscribe) {
					mod.fire('getInfo', {
						callback: function (data) {
							mod.onInvalidateProductData({info: data});
						}
					}, [mod.productDataChannel]);
				}
			}
		}, [initialChannel]);
	},

	/**
	 * Channel listener which gets called by EcommerceProductDataHub to notify about data changes.
	 *
	 * @method onInvalidateProductData
	 * @param {Object} data See EcommerceProductDataHub for details about the structure
	 * @return void
	 */
	onInvalidateProductData: function (data) {
		var mod = this, status = {};
		if (mod.productDataChannel) {
			if (mod.subscriptionId) {
				status.subscriptionId = mod.subscriptionId;
			}

			//don't wait getInfo
			mod.updateLoginUrl(data.info);

			// request the new data based on the settings in this component
			mod.fire('getInfo', {
				status: status,
				callback: $.proxy(mod.getInfoCallback, mod)
			}, [mod.productDataChannel]);
		}
	},

	/**
	 * Callback function which gets passed as a parameter to the [GetInfo] channel event.
	 *
	 * Creates all required placeholders and initiates the placeholder replacement in the component.
	 *
	 * @method getInfoCallback
	 * @param {Object} data See EcommerceProductDataHub for details about the structure
	 * @return void
	 */
	getInfoCallback: function (data) {
		var mod = this, placeholders = {};
		if (data.family) {
			placeholders[PLACEHOLDERS.familyName] = data.family.getFamilyName();
		}
		mod.updatePlaceholders(placeholders);
	},

	/**
	 * Updates the placeholders in the component.
	 *
	 * @method updatePlaceholders
	 * @param {Map/Object} placeholders A map of key value pairs
	 * @return void
	 */
	updatePlaceholders: function (placeholders) {
		var mod = this, element, elementText, attrValue,
			elements = $(PLACEHOLDER_AWARE_ELEMENTS.join(', '), mod.$ctx),
			attributes = PLACEHOLDER_AWARE_ATTRIBUTES;
		elements.each(function () {
			element = $(this);

			// replace in text nodes
			elementText = element.data('placeholder-template');
			if (!elementText) {
				elementText = element.text();
				element.data('placeholder-template', elementText);
			}
			element.text(mod.replacePlaceholders(elementText, placeholders));

			// replace in attributes
			for (var j = 0; j < attributes.length; j++) {
				attrValue = element.data('placeholder-template-' + attributes[j]);
				if (!attrValue) {
					attrValue = element.attr(attributes[j]);
					element.data('placeholder-template-' + attributes[j], attrValue);
				}
				if (attrValue) {
					attrValue = mod.replacePlaceholders(attrValue, placeholders);
					element.attr(attributes[j], attrValue);
					if (attributes[j].indexOf('data-') === 0) {
						element.data(attributes[j].substring(5), attrValue);
					}
				}
			}
		});
	},

	/**
	 * Replaces all placeholders in the given source string.
	 * Not existing placeholders are replaced by empty strings.
	 *
	 * @method replacePlaceholders
	 * @param {String} source The source string
	 * @param {Map/Object} placeholders A map of key value pairs
	 * @return {String} the given source string with replaced placeholders.
	 */
	replacePlaceholders: function (source, placeholders) {
		var foundPlaceholders, i, placeholderName;
		if (source) {
			foundPlaceholders = source.match(/\$\{[a-zA-Z0-9]+\}/g);
			for (i = 0; foundPlaceholders && i < foundPlaceholders.length; i++) {
				placeholderName = foundPlaceholders[i].substring(0, foundPlaceholders[i].length - 1).substring(2);
				source = source.replace(new RegExp('\\$\\{' + placeholderName + '\\}', 'g'), placeholders[placeholderName] || '');
			}
		}
		return source;
	},

	trackingEnabled: function (tracking) {
		return $(tracking).data('tracking-enabled');
	},

	/**
	 * Perform the tracking when the component became visible
	 */
	trackButtonClick: function () {
		var mod = this,
			$tracking = mod.$ctx.find('.tracking');

		if (mod.trackingEnabled($tracking)) {
			mod.log('Tc.Module.RetentionButton > trackButtonClick');
			SCS.portal.datalayer.trackEvent(
				$tracking.data('tracking-action'),
				$tracking.data('tracking-label'),
				$tracking.data('tracking-location'),
				$tracking.data('tracking-category'),
				$tracking.data('tracking-friendlyname'));

			SCS.portal.datalayer.trackConversion(
				$tracking.data('tracking-conversionid'),
				$tracking.data('tracking-conversionsubject')
			);
		}
	},

	selectRetentionModelFilter: function(){
		// just set the product model filter subscriptionId (desktop) oder subscriptionType (mobile) to the value retention
		if ($('select[name=filter-subscriptionId]').length) {
			$('select[name=filter-subscriptionId]').val('retention').trigger('change');
		}
		else {
			$('li[data-name=filter-subscriptionType][data-value=retention]').find('a').click();
		}
	},

	handleClick: function (event) {
		var mod = this;
		mod.trackButtonClick();

		if (!mod.profile.getUser()) {
			// just go to login. so do nothing here.
			return;
		}

		event.stopImmediatePropagation();
		event.preventDefault();
		mod.selectRetentionModelFilter();
		mod.fire('retentionButtonClick');
	}
});


}.call(window));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {/*** IMPORTS FROM imports-loader ***/
var loadTerrific = __webpack_require__(1);
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

/*globals Tc */

/*
	Tc.Module.RetentionDisplay.js is deprecated.
	See Tc.Module.RetentionResult.ts
	*/

// Use a 10x longer timeout than what is globally set (30000).
// because the e-commerce backend can take a very long time to respond
var AJAX_TIMEOUT = 300000;
var STATE = {
	green: 'green',
	loggedOut: 'loggedOut',
	noRetentionPossible: 'noretentionpossible',
	futureRetentionPossible: 'futureretentionpossible',
	retentionPossible: 'retentionpossible',
	loading: 'loading',
	cbuInSmeOrRes: 'cbuinsmeorres',
	error: 'error'
};
var ERROR = {
	DATA: 'data',
	TIMEOUT: 'timeout'
};
var HASH_SUFFIX = 'retention';

/**
 * @namespace Tc.Module
 * @class RetentionDisplay
 * @extends Tc.Module
 */
Tc.Module.RetentionDisplay = Tc.Module.extend({

	on: function (callback) {
		var mod = this;

		mod.pageSegment = $('body').data('page-segment');
		// cache data object, because data access is slow. jquery removes dashes in this process and stores
		// properties in camel case: some-attribute-name becomes someAttributeName
		mod.data = mod.$ctx.data();
		mod.productId = mod.data.productId;
		mod.hasProductDataHub = !!$('.modEcommerceProductDataHub').length;
		mod.hideActionButton = mod.data.hideActionButton;

		mod.$message = mod.$ctx.find('.retention-message');
		mod.$buyButton = mod.$ctx.find('.retention-action-button');
		mod.$buyButtonLink = mod.$buyButton.find('a');
		mod.$buyButtonLink.on('click', $.proxy(mod.handleBuyButton, mod));
		mod.$loginButton = mod.$ctx.find('.retention-login-button');

		mod.contractsWithRetention = [];
		mod.contractsWithoutRetention = [];
		mod.currentUiState = {};

		// restyle the secondary button on the login button
		mod.$loginButton.find('a').addClass('primary-button').removeClass('secondary-button');

		// establish connection to Product Data Hub
		if (mod.hasProductDataHub) {
			mod.onStartProductDataSubscription();
		}

		callback();
	},

	after: function () {
		var mod = this;

		__webpack_require__(5).getProfile().then(function(profile) {
			mod.user = profile.getUser();
			if(mod.user) {
				// cbu customers can not use this feature. Hence, they are asked to redirect to go to the cbu shop.
				if (mod.user.getSegment() === 'cbu') {
					mod.showUiState(STATE.cbuInSmeOrRes);
				}
				else {
					if (window.location.hash.indexOf(HASH_SUFFIX) > -1) {
						if(!(mod.debug && document.location.hash.indexOf('disableUrlRewrite') > -1)) {
							SCS.Url.removeHashParameter(HASH_SUFFIX);
						}
						mod.loadContractsOverview();
					}
					else {
						mod.showUiState(STATE.loggedOut);
					}
				}
			} else {
				mod.showUiState(STATE.loggedOut);
			}

			if (mod.productDataChannel) {
				mod.fire('getInfo', {
					callback: function (data) {
						mod.updateOnProductData(data);
					}
				}, [mod.productDataChannel]);
				mod.fire('removeHashParameter', HASH_SUFFIX, [mod.productDataChannel]);
			}
		});
	},

	onRetentionButtonClick: function () {
		this.loadContractsOverview();
	},

	/**
	 * loadContractsOverview
	 * loads available contracts for a retention upgrade from the server
	 * Response (Array of Strings containing ALL phone numbers listed under this account, not only the :
	 * [
	 *        '+41791039311',
	 *        '+41791039315'
	 *    ]
	 */
	loadContractsOverview: function () {
		var mod = this;
		mod.showUiState(STATE.loading);
		mod.contractsWithRetention = [];
		mod.contractsWithoutRetention = [];

		// use debug data if debug mode is on.
		$.ajax({
			timeout: AJAX_TIMEOUT,
			url: SCS.portal.addParamToUrl(mod.data.urlLoadContracts, 'id', mod.user.getId()),
			success: function (contracts) {
				if ($.isArray(contracts)) {
					if (contracts.length) {
						mod.loadContractDetails(contracts, 0);
					}
					else {
						mod.showUiState(STATE.noRetentionPossible);
					}
				}
				else {
					mod.showError();
				}
			},
			error: function (xhr, textStatus, errorThrown) {
				mod.showError(errorThrown, xhr);
			}
		});
	},


	/**
	 * Loading the details of a single contract
	 * url: /portalshop/de/res/Retention/GetRetentionContractDetails?subscriptionNumber={{NUMBER}}
	 *
	 * response:
	 * {
			 *      RetentionContractDetailsModel: {
			 *          ContractEndDate: '/Date(1423263600000+0100)/',
			 *          ContractType: 1,
			 *          DaysUntilOffer: 0,
			 *          ExistingAboName: 'NATEL® infinity L',
			 *          MaximumAllowedDiscount: '100',
			 *          Options: null,
			 *          PremiumDiscount: '',
			 *          ReasonCode: 'R1.0',
			 *          ReasonText: 'Sie können jetzt von unserem Treueangebot profitieren und erhalten die aktuellsten Mobiltelefone zu Sonderkonditionen.',
			 *          Status: 'green',
			 *          SubscriptionNumber: '+41791231234',
			 *          SubscriptionNumberMD5Hash: 'CC77768E6D8756878898B18838A0B132'
			 *      }
			 * }
	 *
	 * Worth mentioning:
	 * ContractEndDate: The end date of the contract, can be used to display a Date, when a retention is possible.
	 * Status:    Red        = contract is not entitled for a retention offer
	 *            Green        = contract is entitled for a retention offer
	 *
	 * @param contracts        - Array with cell phone numbers registered under the current user
	 */
	loadContractDetails: function (contracts, index) {
		var mod = this,
			url = SCS.portal.addParamToUrl(mod.data.urlLoadContractDetails, 'subscriptionNumber', contracts[index]);

		mod.fire('loadContractDetails');

		$.ajax({
			timeout: AJAX_TIMEOUT,
			url: url,
			success: function (details) {
				var contractDetails;
				if (details && details.RetentionContractDetailsModel) {
					contractDetails = details.RetentionContractDetailsModel;
				}
				if (contractDetails && contractDetails.Status.indexOf('error') === -1) {
					if (contractDetails.Status.toLowerCase() === STATE.green) {
						mod.contractsWithRetention.push(contractDetails);
						mod.contractsLoadingHandler();
						return;
					}
					else {
						mod.contractsWithoutRetention.push(contractDetails);
					}
				}

				if ((index + 1) < (contracts.length)) {
					mod.loadContractDetails(contracts, (index + 1));
				}
				else {
					if (contractDetails && contractDetails.Status.indexOf('error') > -1) {
						mod.ajaxError = ERROR.TIMEOUT;
					}
					mod.contractsLoadingHandler();
				}
			},
			error: function (xhr, textStatus, errorThrown) {
				if ((index + 1) < (contracts.length)) {
					mod.loadContractDetails(contracts, (index + 1));
				}
				else {
					mod.showError(errorThrown, xhr);
				}
			}
		});
	},

	contractsLoadingHandler: function () {
		var mod = this;

		if (mod.ajaxError) {
			if (mod.ajaxError === ERROR.TIMEOUT) {
				mod.showError(ERROR.TIMEOUT);
			}
			else {
				mod.showError();
			}
		}
		else {
			mod.showRetentionResults();
		}
	},

	/**
	 * Prepare or show the results of the load contract details call(s).
	 */
	showRetentionResults: function () {
		var mod = this,
			doTrack = true,
			buyUrl,
			retentionStatus;

		if (mod.contractsWithRetention.length === 0) {
			if (mod.contractsWithoutRetention.length === 0) {
				$('.retention-message', mod.$ctx).addClass('noRetentionPossible');
				mod.showUiState(STATE.noRetentionPossible);
				retentionStatus = 'noRetentionPossible';
			}
			else {
				var nearestContract = mod.getContractWithNearestEndDate();
				if (nearestContract) {
					$('.retention-message', mod.$ctx).addClass('futureRetentionPossible');
					mod.showUiState(STATE.futureRetentionPossible, nearestContract);
					retentionStatus = 'futureRetentionPossible';
				}
				else {
					$('.retention-message', mod.$ctx).addClass('noRetentionPossible');
					mod.showUiState(STATE.noRetentionPossible);
					retentionStatus = 'noRetentionPossible';
				}
			}
		}
		else {
			$('.retention-message', mod.$ctx).addClass('retentionPossible');
			buyUrl = mod.getBuyUrl(mod.contractsWithRetention[0]); // just use the first possible contract for the deeplink
			if (buyUrl) {
				mod.showUiState(STATE.retentionPossible, mod.contractsWithRetention[0]);
				mod.setBuyButtonLink(buyUrl, mod.data.labelLinkOrder);
				retentionStatus = 'retentionPossible';
			}
			else {
				mod.currentUiState.state = STATE.error;
				mod.showError();
				doTrack = false;
				$('.retention-message', mod.$ctx).removeClass('retentionPossible');
				mod.log('no product configuration page set');
			}
		}
		if (doTrack) {
			// Fire tracking call
			var interaction = new SCS.portal.datalayer.Interaction()
				.withEvent('response', retentionStatus, 'productDetailPage', 'checker');
			mod.log('fire tracking call: ', interaction);
			interaction.track();
		}
	},

	/**
	 * Switch between different ui states.
	 *
	 * @param status Name of the state
	 */
	showUiState: function (uiState, contractData) {
		var mod = this;

		mod.currentUiState.state = uiState;
		mod.currentUiState.contractData = contractData;

		mod.$ctx.removeClass('loading-indicator');
		mod.$loginButton.addClass('hidden');
		mod.setBuyButtonLink();
		mod.showMessage();

		switch (uiState) {
			case STATE.loggedOut:
				mod.$loginButton.removeClass('hidden');
				break;
			case STATE.loading:
				mod.$ctx.addClass('loading-indicator');
				mod.showMessage(mod.data.messageLoading);
				break;
			case STATE.noRetentionPossible:
				mod.showMessage(mod.data.messageNoRetentionPossible);
				break;
			case STATE.futureRetentionPossible:
				var date = new Date(parseInt(mod.getTimeString(contractData.ContractEndDate), 10)),
					dateString = date.getDate() + '. ' + (date.getMonth() + 1) + '. ' + date.getFullYear();
				mod.showMessage(SCS.utils.formatString(mod.data.messageFutureRetentionPossible, dateString));
				break;
			case STATE.retentionPossible:
				mod.showMessage(mod.data.messageRetentionPossible);
				if(!mod.hideActionButton) {
					mod.$buyButton.removeClass('hidden');
				}
				break;
			case STATE.cbuInSmeOrRes:
				mod.showMessage(mod.data.messageCbuInResOrSme);
				mod.setBuyButtonLink(mod.data.urlCbu, mod.data.labelLinkToCbuShop);
				break;
			case STATE.error:
				mod.showMessage(mod.data.messageError);
				break;
			default:
				// simply do nothing
				break;
		}
	},

	showMessage: function (message) {
		if (message && message.length) {
			this.$message.html(message);
			this.$message.removeClass('hidden');
			$('html, body').animate({scrollTop: this.$message.offset().top - 100}, 'fast');
		}
		else {
			this.$message.html('');
			this.$message.addClass('hidden');
		}
	},

	setBuyButtonLink: function (link, label) {
		if (link && link.length && label && label.length && !this.hideActionButton) {
			this.$buyButtonLink.attr('href', link).text(label);
			this.$buyButton.removeClass('hidden');
		}
		else {
			this.$buyButton.addClass('hidden');
		}
	},

	/**
	 * Buy button event handler
	 * @param event
	 */
	handleBuyButton: function (event) {
		if ($(event.target).hasClass('disabled')) {
			event.stopImmediatePropagation();
			event.preventDefault();
		}
	},

	/**
	 * TODO: remove because not used
	 * 
	 * Select list event handler
	 * @param event
	 */
	handleContractChanged: function (event) {
		var value = $(event.target).val();
		if (value) {
			this.showUiState(STATE.multipleContractsWithSelection, this.getContractDateByNumber(value));
		}
		else {
			this.showUiState(STATE.multipleContractsNoSelection);
		}
	},

	/**
	 * TODO: remove because not used
	 * 
	 * Retrieve contract Data from phone number.
	 * @param number
	 * @returns {*}
	 */
	getContractDateByNumber: function (number) {
		var data;
		for (var i = 0, length = this.contractsWithRetention.length; i < length; i+=1) {
			if (this.contractsWithRetention[i].SubscriptionNumber === number) {
				data = this.contractsWithRetention[i];
				break;
			}
		}

		return data;
	},

	/**
	 * Returns the time string
	 */
	getTimeString: function (timeString) {
		return timeString.slice(6, -7);
	},

	/**
	 * Create the buy url, if there is a product ID.
	 *
	 * @param contract
	 * @returns {undefined}
	 */
	getBuyUrl: function (contract) {
		var url;
		if (this.productId && this.productId.length) {
			url = SCS.portal.addParamToUrl(this.data.urlCheckout, 'productId', this.productId);
			url = SCS.portal.addParamToUrl(url, 'refNo', contract.SubscriptionNumberMD5Hash);
		}

		return url;
	},

	/**
	 * Find the contract with the nearest contract end date from today.
	 */
	getContractWithNearestEndDate: function () {
		var nearestContract,
			nearestTimeString,
			contract,
			today = new Date().getTime(),
			timeString;

		for (var i = 0, length = this.contractsWithoutRetention.length; i < length; i+=1) {
			contract = this.contractsWithoutRetention[i];
			timeString = this.getTimeString(contract.ContractEndDate);

			if ((!nearestTimeString || timeString < nearestTimeString) && timeString > today) {
				nearestContract = contract;
				nearestTimeString = timeString;
			}
		}
		return nearestContract;
	},

	/**
	 * Display an error Message.
	 * @param errorThrown
	 * @param xhr
	 */
	showError: function (errorThrown, xhr) {
		if (typeof(xhr) !== 'undefined' && xhr.status === SCS.ecommerce.ECOMMERCE_SERVICE_UNAVAILABLE_EXCEPTION) {
			SCS.ecommerce.showEcommerceErrorMessage();
		} else {
			this.showUiState(STATE.error);
		}
	},

	/**
	 * Methods to subscribe and communicate with the Product Data hub
	 */
	onStartProductDataSubscription: function () {
		var mod = this,
			initialChannel = 'EcommerceProductDataHub';
		mod.sandbox.subscribe(initialChannel, mod);
		mod.fire('subscribeForProductData', {
			element: mod.$ctx,
			subscribe: function (channel) {
				mod.productDataChannel = channel;
				mod.sandbox.unsubscribe(initialChannel, mod);
				mod.sandbox.subscribe(channel, mod);
			}
		}, [initialChannel]);
	},

	/**
	 * Methods to subscribe and communicate with the Product Data hub
	 */
	onInvalidateProductData: function (data) {
		this.updateOnProductData(data.info);
	},

	updateOnProductData: function (data) {
		var mod = this;
		if (data && data.product) {
			var id = data.product.getId();
			mod.productId = id;
			var availability = data.product.getAvailability();
			availability.load().then(function() {
				if(id !== mod.productId) {
					mod.log.warn('product changed from', id, 'to', mod.productId);
					// User has changed the product since the availability info started loading
					return;
				}
				mod.log('got availability info for product', availability.isOrderable(), availability.getStatus());
				mod.$buyButtonLink.toggleClass('disabled', !availability.isOrderable());
			});
		}
		else {
			mod.productId = undefined;
		}
	}
});

}.call(window));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var loadTerrific = __webpack_require__(1);
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function ($, SCS) {
	'use strict';
	/*globals Tc */
	/*jshint smarttabs:true */
	/**
	 * Subtotal module implementation.
	 *
	 * @author Stefan Maurer, Cesar Keller
	 * @namespace Tc.Module
	 * @class Subtotal
	 * @extends Tc.Module
	 */
	Tc.Module.Subtotal = Tc.Module.extend({

		EVT_STEP_LOADED: 'steploaded',
		EVT_BEFORE_NEXT_STEP: 'beforenextstep',
		EVT_BEFORE_PREVIOUS_STEP: 'beforepreviousstep',
		step: [], // step[id] = stepUrl

		/**
		 * Main hook.
		 *
		 * @method on
		 * @param {Function} callback function
		 * @return void
		 */
		on: function (callback) {
			var mod = this,
				scrollTop = 0,
				$window = $(window),
				scrollThreshold = mod.$ctx.offset().top;

			// fixed subtotal box if it scrolls out of the viewport
			$window.scroll(function () {

				// only fix box if it at least fits the window
				if (mod.$ctx.height() <= window.innerHeight && !$(document.body).hasClass('cq_isEditMode')) {
					scrollTop = $window.scrollTop();
					if (mod.$ctx.hasClass('sdxStyle') && scrollTop <= 0) {
						mod.$ctx.removeClass('is-fixed');
						return;
					}
					else if (scrollTop >= scrollThreshold) {
						mod.$ctx.addClass('is-fixed');
					} else if (scrollTop < scrollThreshold) {
						mod.$ctx.removeClass('is-fixed');
					}
				} else {
					mod.$ctx.removeClass('is-fixed');
				}
			});

			if(mod.$ctx.hasClass('sdxStyle')) {
				$('.modSharedHeader, .modHeader, .scs-pageheader').addClass('spacer');
				if(SCS.utils.isMobilePage()) {
					$('.stageMobile').css('position', 'initial');
				}
				mod.$ctx.find('i.icon, button.close').on('click', function() {
					mod.$ctx.toggleClass('showDetails');
				});
			}

			mod.updateSubtotalSum();
			mod.bindEvents();
			mod.showOrHideDetails();
			callback();
		},

		after: function () {
			var mod = this;

			mod.bindEvents();
		},

		onPriceAdded: function () {
			var mod = this;

			mod.updateSubtotalSum();
			mod.bindEvents();
		},

		bindEvents: function () {
			var mod = this,
				$form = $('.modScForm'); // not a parent or child of this mod

			// ensure events are only bound once
			var changeHandler = function () {
				mod.updateSubtotalSum(mod);
			};

			$form.find(':input[data-price],:input[data-onetime-charge],:input[data-type=item]')
				.off('change', changeHandler)
				.on('change', changeHandler);

			// Find sdx input elements and register click
			$form
				.find('sdx-input-item')
				.each(function(_index, el) {
					el.changeCallback = mod.updateSubtotalSum.bind(mod, mod);
				});

			var nextHandler = function (e, stepUrl, stepId) {
				mod.showOrHide(stepUrl, stepId);
			};

			var previousHandler = function (e, stepId) {
				mod.showOrHide(null, stepId);
			};

			$form
				.off(mod.EVT_STEP_LOADED, nextHandler)
				.on(mod.EVT_STEP_LOADED, nextHandler)
				.off(mod.EVT_BEFORE_NEXT_STEP, nextHandler)
				.on(mod.EVT_BEFORE_NEXT_STEP, nextHandler)
				.off(mod.EVT_BEFORE_PREVIOUS_STEP, previousHandler)
				.on(mod.EVT_BEFORE_PREVIOUS_STEP, previousHandler);
		},

		showOrHide: function (stepUrl, stepId) {
			var mod = this,
				$ctx = mod.$ctx,
				hideOnPages = $ctx.data('hide-on-pages'),
				separators = '(,|])';

			if (stepUrl) {
				mod.step[stepId] = stepUrl;
			} else {
				stepUrl = mod.step[stepId];
			}

			if (typeof hideOnPages === 'string' && hideOnPages.match(stepUrl + separators)) {
				$ctx.hide();
			} else {
				$ctx.show();
			}
		},

		showOrHideDetails: function () {
			var mod = this,
				$ctx = mod.$ctx,
				togglers = $ctx.find('div.toggle-on-details, div.toggle-off-details');

			togglers.on('click', 'span, .arrow-down, .arrow-up', function (e) {
				e.preventDefault();

				togglers.toggle();
				$ctx.find('div.section-details').slideToggle(200);
			});
		},

		updateSubtotalSum: function (module) {
			var mod = module || this,
				$ctx = mod.$ctx,
				$form = $('.modScForm form'), // not a parent or child of this mod
				subtotal = 0,
				subtotalElement = $ctx.find('.subtotal'),
				priceElement = subtotalElement.find('.price'),
				priceOTCElement = subtotalElement.find('.priceOTC'),
				itemPriceElement = $ctx.find('span.items-total-monthly-price'),
				itemPriceOTCElement = $ctx.find('span.items-total-onetime-price'),
				subtotalOTC = 0;

			// remove current content
			$ctx.find('ul.items li').remove();

			// add base and items
			$form.find(':input[data-price],.modBaseBundleOption :input[data-hascost], sdx-input-item[data-price],.modBaseBundleOption sdx-input-item[data-hascost]').each(function () {
				var $this = $(this),
					amount = ($this.filter('[data-hascost]').length && $this.data('hascost') !== '') ? $this.data('hascost') : $this.val(),
					itemPrice = amount * $this.data('price'),
					itemPriceFormatted = parseFloat(Math.round(itemPrice * 100) / 100).toFixed(2),
					itemMarkup = '<li><dl><dt>',
					isCheckboxOrRadio = ['checkbox', 'radio'].indexOf(this.type) > -1,
					itemLabel = $this.data('label'),
					summary = $this.data('summary') || '';

				if (amount > 0) {
					var isUncheckedRadioOrCheckbox = isCheckboxOrRadio && !$this.prop('checked');
					if($this.is('sdx-input-item:not(.hydrated)')) {
						isUncheckedRadioOrCheckbox = !$this.attr('checked');
					}
					if (isUncheckedRadioOrCheckbox) {
						return;
					}

					if ($this.data('price').length === 0) {
						return;
					}

					if (amount > 1) {
						itemMarkup += amount + ' x ';
					}

					itemMarkup += itemLabel;

					if (summary.length > 0 && !$ctx.hasClass('sdxStyle')) {
						itemMarkup += '<br />' + summary;
					}
					else {
						itemMarkup += ' ' + summary;
					}

					itemMarkup += '</dt><dd>';

					if (isNaN(itemPrice)) {
						itemPrice = 0;
					} else {
						if (itemPrice !== 0) {
							itemMarkup += itemPriceFormatted;
						}
					}

					itemMarkup += '</dd></dl></li>';

					$ctx.find('.monthly-items').children('.items').append(itemMarkup);
					subtotal += itemPrice;
				}
			});

			// remove current content
			$ctx.find('ul.one-time-items li').remove();
			$ctx.find('.one-time-items').addClass('ui-helper-hidden');

			// add base and items
			$form.find(':input[data-onetime-charge], sdx-input-item[data-onetime-charge]').each(function () {
				var $this = $(this),
					amount = ($this.filter('[data-hascost]').length && $this.data('hascost') !== '') ? $this.data('hascost') : $this.val(),
					itemPriceOTC = amount * $this.data('onetime-charge'),
					itemPriceOTCFormatted = parseFloat(Math.round(itemPriceOTC * 100) / 100).toFixed(2),
					itemMarkup = '<li><dl><dt>',
					isCheckboxOrRadio = ['checkbox', 'radio'].indexOf(this.type) > -1,
					itemLabel = $this.data('label'),
					summary = $this.data('summary') || '';

				if (amount > 0) {
					var isUncheckedRadioOrCheckbox = isCheckboxOrRadio && !$this.prop('checked');
					if($this.is('sdx-input-item:not(.hydrated)')) {
						isUncheckedRadioOrCheckbox = !$this.attr('checked');
					}
					if (isUncheckedRadioOrCheckbox) {
						return;
					}

					if ($this.data('onetime-charge').length === 0) {
						return;
					}

					if (amount > 1) {
						itemMarkup += amount + ' x ';
					}

					itemMarkup += itemLabel;

					if (summary.length > 0) {
						itemMarkup += '<br />' + summary;
					}

					itemMarkup += '</dt><dd>';

					if (isNaN(itemPriceOTC)) {
						itemPriceOTC = 0;
					} else {
						if (itemPriceOTC !== 0) {
							itemMarkup += itemPriceOTCFormatted;
						}
						else if (itemPriceOTC === 0 && mod.$ctx.hasClass('sdxStyle')) {
							itemMarkup += '0.00';
						}
					}

					itemMarkup += '</dd></dl></li>';

					$ctx.children('.itemsOTC').append(itemMarkup);
					subtotalOTC += itemPriceOTC;
					$ctx.find('.one-time-items').removeClass('ui-helper-hidden');
					$ctx.find('.one-time-items > .items').append(itemMarkup);
				}
			});

			// calculate and display subtotal
			subtotal = parseFloat(Math.round(subtotal * 100) / 100).toFixed(2);
			subtotalOTC = parseFloat(Math.round(subtotalOTC * 100) / 100).toFixed(2);
			priceElement.html(subtotal);
			itemPriceElement.html(subtotal);
			priceOTCElement.html(subtotalOTC);
			itemPriceOTCElement.html(subtotalOTC);

			// change font size of prices, depending on the width
			if (priceElement.text().length > 5 || priceOTCElement.text().length > 5) {
				subtotalElement.addClass('medium');
			} else {
				subtotalElement.removeClass('medium');
			}
		}
	});
})(Tc.$, window.SCS = window.SCS || {});

}.call(window));

/***/ }),
/* 259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lib_vendor_terrific_Module__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lib_util_helpers__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Availability__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lib_ecommerce_Tc_Module_EcommerceProductDataHub__ = __webpack_require__(16);





var CONTAINER_CLASS = 'availabilityInfo';
/**
 * Online Availability Info
 *
 * @author Matthias Inauen
 * @namespace Tc.Module
 * @class Online Availability Info
 * @extends Tc.Module
 */
var OnlineAvailabilityInfo = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */])(OnlineAvailabilityInfo, _super);
    function OnlineAvailabilityInfo() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    OnlineAvailabilityInfo.prototype.on = function (callback) {
        this.container = $('.' + CONTAINER_CLASS, this.$ctx);
        var classes = this.container.attr('class');
        this.containerStyle = classes || '';
        this.subcontainer = $('.availabilityInfoDelayedDeliveryInfoLink', this.$ctx);
        this.productId = this.$ctx.data('productid');
        this.status = this.$ctx.data('status');
        if (this.productId) {
            this.productAvailabilityInfo = new __WEBPACK_IMPORTED_MODULE_3__Availability__["a" /* Availability */](this.productId);
        }
        else {
            // tslint:disable-next-line:no-unbound-method
            Object(__WEBPACK_IMPORTED_MODULE_4_lib_ecommerce_Tc_Module_EcommerceProductDataHub__["c" /* simpleSubscribe */])(this, this.gotDataFromHub);
        }
        callback();
    };
    OnlineAvailabilityInfo.prototype.after = function () {
        if (this.productId) {
            this.update();
        }
    };
    OnlineAvailabilityInfo.prototype.gotDataFromHub = function (info) {
        if (info && info.product) {
            this.productData = info.product;
            this.productAvailabilityInfo = info.product.getAvailability();
            this.update();
        }
    };
    OnlineAvailabilityInfo.prototype.update = function () {
        if (!this.productAvailabilityInfo) {
            this.log.error('No product data in OnlineAvailabilityInfo module');
            return;
        }
        if (!this.productAvailabilityInfo.loaded()) {
            // Availability info not yet available, wait until loaded.
            // tslint:disable-next-line:no-floating-promises
            this.productAvailabilityInfo.load().done(this.update.bind(this));
            return;
        }
        var data = this.getUpdateData(this.productData, this.productAvailabilityInfo);
        // Desktop has mod.status='always'
        if (data.infoText &&
            (!this.status ||
                this.status === 'always' ||
                this.status.toLowerCase() === data.availability.toLowerCase())) {
            if (this.$ctx.hasClass('Classic')) {
                this.container
                    .removeClass()
                    .addClass(CONTAINER_CLASS)
                    .addClass('stock-availability-' + data.availability)
                    .text(data.infoText)
                    .css('display', 'block');
                return;
            }
            var iconClass = '';
            var iconPrefix = 'icon ';
            var colorClass = '';
            switch (data.availability) {
                case 'OnStock':
                    iconClass = iconPrefix + 'icon-012-check-mark-circle';
                    colorClass = 'int-green';
                    break;
                case 'ShortnessOfSupplies':
                    iconClass = iconPrefix + 'icon-026-exclamation-mark-circle';
                    colorClass = 'int-orange';
                    break;
                case 'OutOfStockReservable':
                    iconClass = iconPrefix + 'icon-021-clock';
                    break;
                case 'OutOfStockNotifiable':
                case 'OutOfStock':
                    iconClass = iconPrefix + 'icon-026-exclamation-mark-circle';
                    colorClass = 'int-red';
                    break;
                default:
                    break;
            }
            if (data.availability) {
                this.container
                    .removeClass()
                    .addClass(this.containerStyle)
                    .removeClass('hidden')
                    .addClass(colorClass)
                    .children('.infoText')
                    .text(data.infoText);
                this.container.children('i').removeClass().addClass(iconClass);
            }
            if (this.subcontainer.length) {
                this.subcontainer.toggleClass('hidden', data.availability !== __WEBPACK_IMPORTED_MODULE_3__Availability__["b" /* AvailabilityStatus */].DelayedDelivery);
                if (Object(__WEBPACK_IMPORTED_MODULE_2_lib_util_helpers__["isMobilePage"])()) {
                    this.container.eq(0).toggleClass('hidden', data.availability === __WEBPACK_IMPORTED_MODULE_3__Availability__["b" /* AvailabilityStatus */].DelayedDelivery);
                }
            }
        }
        else {
            // Clear availability info
            this.subcontainer.addClass('hidden');
            this.container.eq(0).addClass('hidden');
        }
    };
    OnlineAvailabilityInfo.prototype.getUpdateData = function (productData, productAvailabilityInfo) {
        var updateData = {
            availability: productAvailabilityInfo.getStatus(),
            infoText: this.$ctx.data(productAvailabilityInfo.getStatus().toLowerCase()),
        };
        if (productData) {
            // Product info came from data hub
            var isReservationAllowed = productData.isReservationAllowed();
            var delayedDeliveryReason = productData.getDelayedDeliveryReason();
            if (isReservationAllowed && delayedDeliveryReason) {
                updateData.availability = __WEBPACK_IMPORTED_MODULE_3__Availability__["b" /* AvailabilityStatus */].DelayedDelivery;
                updateData.infoText = delayedDeliveryReason;
            }
            this.$ctx.toggleClass('two-columns', productData.isReservationInStoreAllowed());
        }
        return updateData;
    };
    return OnlineAvailabilityInfo;
}(__WEBPACK_IMPORTED_MODULE_1_lib_vendor_terrific_Module__["a" /* Module */]));
/* harmony default export */ __webpack_exports__["a"] = (OnlineAvailabilityInfo);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {/**
 * (c) Copyright Swisscom (Schweiz) AG. All rights reserved.
 *
 * This product is the proprietary and sole property of Swisscom (Schweiz) AG
 * Use, duplication or dissemination is subject to prior written consent of
 * Swisscom (Schweiz) AG.
 *
 * $Id: cbu.js
 */
$.namespace('SCS.cbu');

/**
 * Initialize CBU customer callout on login
 */
var user = undefined;
var userBox = undefined;
__webpack_require__(5).getProfile().then(function(profile) {
	// Wait for DOMContentLoaded
	$(function ready() {
		userBox = __webpack_require__(32).getGlobalUserBox();
		user = profile.getUser();
		if(!user) {
			return;
		}
		if (user.isSegmentCbu()) {
			SCS.cbu.initOrderButtons();
		}
	});
});


/**
 * Initialize order buttons for CBU customers.
 * I.e. don't allow ordering products and show a dialog.
 */
SCS.cbu.initOrderButtons = function() {
	$('.scs-product-orderbutton-buy, .scs-product-orderbutton-notify').each(function() {
		// override click events with this handler
		$(this).off('click').click(function(e) {
			e.preventDefault();
			SCS.cbu.PRODUCT_ID = SCS.cbu.getProductId($(this));
			SCS.cbu.createOrderBarrierDialog();
			return false;
		});
	});
};

/**
 * Get product id from corresponding order button
 * @param orderButton Order button
 */
SCS.cbu.getProductId = function(orderButton) {
	return orderButton.closest('form').find('input[name=productId]').val();
};

/**
 * Create CBU order dialog ('do not order ...')
 */
SCS.cbu.createOrderBarrierDialog = function() {
	var cbuEl = $('#cbuTemplate').tmpl();
	var msg = SCS.portal.tplToString(cbuEl);
	SCS.cbu.orderDialog = $('<div>' + msg + '</div>').dialog({
		title: cbuEl.data('dialog-title'),
		classes: {'ui-dialog': 'cbu'},
		width: 500,
		buttons: [
			{
				text: cbuEl.data('btn-cancel'),
				'class': 'secondary-button',
				click: function() {
					SCS.cbu.orderDialog.dialog('close');
				}
			},
			{
				text: cbuEl.data('btn-continue'),
				'class': 'primary-button',
				click: SCS.cbu.continueHandler
			}
		]
	});
	SCS.portal.applyAfterEffects();
};

/**
 * Click on the 'continue' button in the CBU options dialog
 */
SCS.cbu.continueHandler = function() {
	var values = $('#scs-cbu-order-form').serializeArray();
	if (values && values[0] && values[0]['value']) {
		var option = values[0]['value'];
		if (option == 'tocbushop') {
			location.href = userBox.getCbuShopUrl();
		}
		else if (option == 'loginascbu') {
			SCS.ecommerce.setRedirectCookie(userBox.getLoginUrl());
			location.href = userBox.getLogoutUrl();
		}
		else if (option == 'shopasguest') {
			location.href = userBox.getLogoutUrl();
		}
	}
	return false;
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_jQuery) {/**
 * Updated by Thomas Junghans 19.8.2013. Added text container span.txtValue
 * Updated by Cesar Keller 16.12.2014. Added support for disabled="disabled"
 * 		Usage: $('select').prop('disabled', true).closest('.field').addClass('disabled')
 */
(function($){
	/* jshint quotmark: false */
	/* jslint plusplus: true */
	/* jslint eqeq: true */
	/* jshint indent: false */
	/* jshint curly: false */
	/* jshint latedef: false */
	/* jshint maxstatements: false */

	"use strict";

	//add class to html tag
	$('html').addClass('stylish-select');
	//create cross-browser indexOf
	$('.field').on('load', function(){
		if (!Array.prototype.indexOf) {
			Array.prototype.indexOf = function (obj, start) {
				for (var i = (start || 0); i < this.length; i++) {
					if (this[i] === obj) {
						return i;
					}
				}
			};
		}
	});

	//utility methods
	$.fn.extend({
		getSetSSValue: function(value){
			if (value){
				//set value and trigger change event
				$(this).val(value).change();
				return this;
			} else {
				return $(this).find(':selected').val();
			}
		},
		/**
		 * Usage: $('select').resetSS() after the select has been updated. Resets and ReInitialises.
		 *
		 * @author Justin Beasley, updated by Thomas Junghans 19.8.2013
		 */

		resetSS: function(){

			return this.each(function(){

				var $this = $(this),
					oldOpts = $this.data('ssOpts');

				$this
					.next()
					.remove();

				$this
					.addClass('customDropDown')
					.css({
						'position' : null,
						'left': ''
					})

					//unbind all events and redraw
					.off('.sSelect').sSelect(oldOpts);
			});
		}
	});

	$.fn.sSelect = function(options) {

		return this.each(function(){

			var $input = $(this);

					$input.trigger('beforeInit.sSelect'); // added by David Talamona

			if (!$input.is('.customDropDown')) {
				return;
			}

			$input.removeClass('customDropDown');

			var defaults = {
				defaultText: 'Please select',
				animationSpeed: 0, //set speed of dropdown
				ddMaxHeight: '', //set css max-height value of dropdown
				containerClass: '' //additional classes for container div
			};

			//initial variables
			var opts = $.extend(defaults, options),
				$containerDivArrow = $('<div class="arrow"></div>'),
				$containerDivText = $('<div class="selectedTxt"><span class="txtValue"></span></div>'),
				$containerDiv = $('<div class="newListSelected ' + opts.containerClass + '"></div>'),
				$newUl = $('<ul class="newList" style="visibility:hidden;"></ul>'),
				itemIndex = -1,
				currentIndex = -1,
				keys = [],
				seekTerm = "",
				seekTimeout = false,
				prevKey = false,
				prevented = false,
				$newLi;


			//added by Justin Beasley
			$input.data('ssOpts',options);

			//build new list
			$containerDiv.insertAfter($input);

			if($input.attr('disabled')){
				$containerDiv.addClass("disabled");
			}

			var tabIndex = $input.attr("tabindex");
			if (tabIndex == -1) {
				$containerDiv.attr("tabindex", "0");
			} else {
				$containerDiv.attr("tabindex", tabIndex || "0");
			}
			$containerDivText.prependTo($containerDivArrow);
			$containerDivArrow.prependTo($containerDiv);
			$newUl.appendTo($containerDiv);

			$input.css({"position" : "absolute", "left" : "-99999px"});

			//added by Justin Beasley (used for lists initialized while hidden)
			$containerDivText.data('ssReRender',!$containerDivText.is(':visible'));

			//test for optgroup
			if ($input.children('optgroup').length === 0){
				$input.children().each(function(i){
					var option = $(this).html();
					var key = $(this).val();

					//add first letter of each word to array
					keys.push(option.charAt(0).toLowerCase());
					if ($(this).attr('selected') || this.selected){ // added " || this.selected" by Thomas Amsler
						opts.defaultText = option;
						currentIndex = i;
					}
					$newUl.append($('<li><a href="javascript:void(0);">'+option+'</a></li>').data('key', key));

				});
				//cache list items object
				$newLi = $newUl.children().children();

			} else { //optgroup
				$input.children('optgroup').each(function(){

					var optionTitle = $(this).attr('label'),
					$optGroup = $('<li class="newListOptionTitle">'+optionTitle+'</li>');

					$optGroup.appendTo($newUl);

					var $optGroupList = $('<ul></ul>');

					$optGroupList.appendTo($optGroup);

					$(this).children().each(function(){
						++itemIndex;
						var option = $(this).html();
						var key = $(this).val();
						//add first letter of each word to array
						keys.push(option.charAt(0).toLowerCase());
						if ($(this).attr('selected') || this.selected) { // added " || this.selected" by Thomas Amsler
							opts.defaultText = option;
							currentIndex = itemIndex;

						}
						$optGroupList.append($('<li><a href="javascript:void(0);">'+option+'</a></li>').data('key',key));
					});
				});
				//cache list items object
				$newLi = $newUl.find('ul li a');
			}

			//get heights of new elements for use later
			var newUlHeight = $newUl.height(),
			containerHeight = $containerDiv.height(),
			newLiLength = $newLi.length;

			//check if a value is selected
			if (currentIndex != -1){
				navigateList(currentIndex, true);

			} else {
				//set placeholder text
				$containerDivText.find('.txtValue').html(opts.defaultText);

			}

			//decide if to place the new list above or below the drop-down
			function newUlPos(){
								if ($input.data('autoPosition') === false) return; // added by David Talamona
				var containerPosY = $containerDiv.offset().top,
				docHeight = __webpack_provided_window_dot_jQuery(window).height(),
				scrollTop = __webpack_provided_window_dot_jQuery(window).scrollTop();

				//if height of list is greater then max height, set list height to max height value
				if (newUlHeight > parseInt(opts.ddMaxHeight, 10)) {
					newUlHeight = parseInt(opts.ddMaxHeight, 10);
				}

				containerPosY = containerPosY-scrollTop;
				if (containerPosY+newUlHeight >= docHeight){
					$newUl.css({
						top: '18px',
						height: newUlHeight
					});
					$input.onTop = true;
				} else {
					$newUl.css({
						top: '18px',
						height: newUlHeight
					});
					$input.onTop = false;
				}
			}

			//run function on page load
			newUlPos();

			//run function on browser window resize
			$(window).on('resize.sSelect scroll.sSelect', newUlPos);

			//positioning
			function positionFix(){
				$containerDiv.css('position','relative');
			}

			function positionHideFix(){
				$containerDiv.css('position','static');
			}

			$containerDivArrow.on('click.sSelect',function(event){
				event.stopPropagation();

				// added by Cesar Keller
				if ($input.is(':disabled')) {
					return;
				}

				//added by Justin Beasley
				if($(this).data('ssReRender')) {
					newUlHeight = $newUl.height('').height();
					containerHeight = $containerDiv.height();
					$(this).data('ssReRender',false);
					newUlPos();
				}

				//hide all menus apart from this one
				$('.newList').not($newUl).hide() // changed by Raphael Schweikert
					.parent()
						.css('position', 'static')
						.removeClass('newListSelFocus');

				//show/hide this menu
				$newUl.toggle();
								$containerDiv[($newUl.is(':visible')?'add':'remove') + 'Class']('newListSelOpen'); // added by David Talamona
				positionFix();
				//scroll list to selected item
				$newLi.eq(currentIndex).focus();

								$input.trigger('list' + ($newUl.is(':visible')?'Open':'Close') + '.sSelect'); // added by David Talamona

			});

			// select item
			$newLi.on('click.sSelect',function(e){
				var $clickedLi = $(e.target);

				//update counter
				currentIndex = $newLi.index($clickedLi);
				// Made Selecte box selected
				$(this).parent().parent().parent().prev().children().attr('selected', false);
				$(this).parent().parent().parent().prev().children().eq(currentIndex).attr('selected', true);

				//remove all hilites, then add hilite to selected item
				prevented = true;
				navigateList(currentIndex);
				$containerDiv.removeClass('newListSelOpen'); // added by David Talamona
				$newUl.hide();
				positionHideFix();//ie // modified by David Talamona
								$input.trigger('listClose.sSelect'); // added by David Talamona
			});

			$newLi.on('mouseenter.sSelect',
				function(e) {
					var $hoveredLi = $(e.target);
					$hoveredLi.addClass('newListHover');
				}
			).on('mouseleave.sSelect',
				function(e) {
					var $hoveredLi = $(e.target);
					$hoveredLi.removeClass('newListHover');
				}
			);

			function navigateList(currentIndex, init){
				$newLi.removeClass('hiLite')
				.eq(currentIndex)
				.addClass('hiLite');

				$newLi.parent().removeClass('hiLite').end().eq(currentIndex).parent().addClass('hiLite'); // added by David Talamona

				if ($newUl.find('li').eq(currentIndex+1).length){
					$newUl.scrollTop($newUl.scrollTop() + $newUl.find('li').eq(currentIndex+1).position().top);
				}

				if ($newUl.is(':visible')){
					$newLi.eq(currentIndex).focus();
				}

				var text = $newLi.eq(currentIndex).html();
				var val = $newLi.eq(currentIndex).parent().data('key');

				//page load
				if (init){
					$input.val(val);
					$containerDivText.find('.txtValue').html(text);
					return false;
				}

				try {
					$input.val(val);
				} catch(ex) {
					// handle ie6 exception
					$input[0].selectedIndex = currentIndex;
				}

				$input.change();
				$input.trigger('change');
				$containerDivText.find('.txtValue').html(text);
			}

			$input.on('change.sSelect',function(event){
				var $targetInput = $(event.target);
				//stop change function from firing
				if (prevented){
					prevented = false;
					return false;
				}
				var $currentOpt = $targetInput.find(':selected');

				//currentIndex = $targetInput.find('option').index($currentOpt);
				currentIndex = $targetInput.find('option').index($currentOpt);

				navigateList(currentIndex, true);
			});

			//handle up and down keys
			function keyPress(element) {
				//when keys are pressed
				$(element).off('keydown.sSelect').on('keydown.sSelect',function(e){
					var keycode = e.which;

					// added by Cesar Keller
					if ($input.is(':disabled')) {
						return;
					}

					//prevent change function from firing
					prevented = true;

					switch(keycode) {
						case 40: //down
						case 39: //right
							incrementList();
							return false;
						case 38: //up
						case 37: //left
							decrementList();
							return false;
						case 33: //page up
						case 36: //home
							gotoFirst();
							return false;
						case 34: //page down
						case 35: //end
							gotoLast();
							return false;
						case 13:
						case 27:
							$containerDiv.removeClass('newListSelOpen'); // added by David Talamona
							$newUl.hide();
							positionHideFix();
							$input.trigger('listClose.sSelect'); // added by David Talamona
							return false;
						case 9: // tab -> leafe field // added by David Talamona
							return true;
						case 16: // Ignore 'SHIFT'// added by Nikola Tica
							return true;
					}

					//check for keyboard shortcuts
					var keyPressed = String.fromCharCode(keycode).toLowerCase();

					seekTerm+=keyPressed;

					if (seekTimeout && typeof seekTimeout.clearTimeout === 'function') seekTimeout.clearTimeout();

					if(findDropdownItem(seekTerm) >= 0){
						currentIndex = findDropdownItem(seekTerm);
					} else if(findDropdownItem(keyPressed) >= 0){
						seekTerm = keyPressed;
						currentIndex = findDropdownItem(seekTerm);
					} else {
						seekTerm = "";
						currentIndex = 0;
					}

					if (seekTerm){
						seekTimeout = setTimeout(function(){
							seekTerm = "";
						}, 1000);
					}
					navigateList(currentIndex);
					//store last key pressed
					prevKey = keyPressed;
					return false;
				});
			}

			function findDropdownItem(term){
				var $options = $input.find('option[value!=""]');
				for(var i=0,ii=$options.length; i < ii; i++){
					var option = $options.eq(i).html();
					if (option.substr(0, term.length).toLowerCase() === term.toLowerCase()){
						return $options.eq(i).index();
					}
				}
				return false;
			}

			function incrementList(){
				if (currentIndex < (newLiLength-1)) {
					++currentIndex;
					navigateList(currentIndex);
				}
			}

			function decrementList(){
				if (currentIndex > 0) {
					--currentIndex;
					navigateList(currentIndex);
				}
			}

			function gotoFirst(){
				currentIndex = 0;
				navigateList(currentIndex);

			}

			function gotoLast(){
				currentIndex = newLiLength-1;
				navigateList(currentIndex);
			}

			$containerDiv.on('click.sSelect',function(e){
				e.stopPropagation();
				keyPress(this);
			});

			$containerDiv.on('focus.sSelect',function(){
				// added by Cesar Keller
				if ($input.is(':disabled')) {
					$(this).removeClass('newListSelFocus');
					return;
				}

				$(this).addClass('newListSelFocus');
				keyPress(this);
			});

			$containerDiv.on('blur.sSelect',function(){
				$(this).removeClass('newListSelFocus');
				// added by Matthias Inauen -> so the select menu closes properly if the user clicks on another select menu
				if(!$containerDiv.is('.newListSelHover') && $containerDiv.is('.newListSelOpen')) {
					$(document).trigger('click.sSelect');
				}
			});

			//hide list on blur
			$(document).on('click.sSelect',function(){
				$containerDiv.removeClass('newListSelFocus');
				if (!$containerDiv.is('.newListSelOpen')) return; // added by David Talamona -> do not close the dopdown every time the page is clicked ANYWHERE
				$containerDiv.removeClass('newListSelOpen'); // added by David Talamona
				$newUl.hide();
				positionHideFix();
				$input.trigger('listClose.sSelect'); // added by David Talamona
			});

			//add classes on hover
			$containerDivText.on('mouseenter.sSelect',
				function(e) {
					var $hoveredTxt = $(e.target);
					$hoveredTxt.parent().addClass('newListSelHover');
				}
			).on('mouseleave.sSelect',
				function(e) {
					var $hoveredTxt = $(e.target);
					$hoveredTxt.parent().removeClass('newListSelHover');
				}
			);

			// added by David Talamona (following listener-block)
			$containerDiv.on('mouseenter.sSelect',
				function() {
					$(this).addClass('newListSelHover');
				}
			).on('mouseleave.sSelect',
				function() {
					$(this).removeClass('newListSelHover');
				}
			);

			//reset left property and hide
			$newUl.css({
				left: '8px',
				display: 'none',
				visibility: 'visible',
				position: 'absolute'
			});

			$input.trigger('afterInit.sSelect'); // added by David Talamona

			if (!!navigator.userAgent.match(/Trident.*rv\:11\./) && currentIndex >= 0) { // added by Nikola Tica
				$containerDiv.find('ul > li').eq(currentIndex).trigger('click');
			}
		});

	};

})(__webpack_provided_window_dot_jQuery);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_$) {(function ($, SCS) {
	'use strict';

	/**
	 *  use by forms/components/form/capthca
	 *  defined Callback function for https://www.google.com/recaptcha/api.js
	 *  Synchronize call createCaptcha from Tc.Module.Captcha and google API
	 */
	SCS.captcha = SCS.captcha || {};

	$.extend(SCS.captcha, {

		onloadCaptchaCallback: function () {

			/*
			 * apply wrapper
			 *
			 * @param array parameterArray An array comprising either:
			 *      [ ctx, functionObject, optional_parameters ]
			 */
			function apply () {
				var parameterArray, f, ctx, form, ajaxCaptcha;

				if(arguments.length>0){
					parameterArray = arguments[0];
					ctx = parameterArray.shift();
					f = parameterArray.shift();
					f.apply(ctx, parameterArray);

					//detach ajaxCaptcha if exists, only one Captcha field is allow.
					form = ctx.$ctx.closest('form');
					if(form && form.length > 0){
						ajaxCaptcha = form.find('.modAjaxCaptcha');
						if(ajaxCaptcha && ajaxCaptcha.length >0){
							ajaxCaptcha.detach();
						}
					}

				}

			}

			if (SCS.captcha.captchaHandler && $.isArray(SCS.captcha.captchaHandler) && $('#captcha').length) {
				//SCS.captchaHandler with handlers

				for (var iterator = 0; iterator < SCS.captcha.captchaHandler.length; iterator++) {
					if (SCS.captcha.captchaHandler[iterator]) {
						apply(SCS.captcha.captchaHandler[iterator]);
					}
				}

			}

			function CaptchaHandlerProxy () {
				return {
					push: apply
				};
			}

			// replace initialization array with proxy object
			SCS.captcha.captchaHandler = new CaptchaHandlerProxy();

		}
	});

	// asynchronous (or proxy)
	if (!SCS.captcha.captchaHandler || typeof SCS.captcha.captchaHandler !== 'object') {
		SCS.captcha.captchaHandler = [];
	}

}(__webpack_provided_window_dot_$, window.SCS = window.SCS || {}));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 263 */
/***/ (function(module, exports) {

(function (w) {
	"use strict";

	/**
	 * The class InvalidField is a helper for invalid field information
	 *
	 * @author Thomas Junghans
	 * @namespace ScForm
	 * @class InvalidField
	 * @param {Number} index
	 * @param {ValidationReturn} validationReturn
	 * @constructor
	 */

	function InvalidField(index,validationReturn) {
		this.init(index, validationReturn);
	}

	InvalidField.prototype = {
		constructor : InvalidField,
		init : function (index, validationReturn) {
			this.index = index;
			this.validationReturn = validationReturn;
		},

		/**
		 * @method getIndex
		 * @returns {Number}
		 */
		getIndex : function () {
			return this.index;
		},

		/**
		 *
		 * @method getVr
		 * @returns {ValidationReturn}
		 */
		getVr : function () {
			return this.validationReturn;
		},

		setField: function(field) {
			this.field = field;
			return this;
		},

		getField: function() {
			return this.field;
		}

	};

	w.ScForm = w.ScForm || {};
	w.ScForm.createInvalidField = function (isValid, message) {
		return new InvalidField(isValid, message);
	};

}(window));

/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_$) {var ibanFieldValidator = __webpack_require__(49).ibanFieldValidator;
var urlBlacklistValidation = __webpack_require__(49).urlBlacklistValidation;
(function (w, $, SCS) {

	/* Dependencies:
	 * ScForm.ValidationReturn.js
	 */

	'use strict';

	/**
	 * The class ClientValidation is a helper for form clientside validation and takes the validation object as a parameter.
	 *
	 * ex. 1 {
	 *		"required":true,
	 *		"minLength":0,
	 *		"constraintMessage":"Bitte geben Sie einen korrekten Wert als Name ein",
	 *		"maxLength":0,
	 *		"requiredMessage":"Bitte füllen Sie das Feld Name aus",
	 *		"lengthMessage":null,
	 *		"hasLengthValidation":false,
	 *		"hasConstraint":false,
	 *		"constraintRegex":"^[\\w\\.,\\s\\u0080-\\u00ff\\u008C\\u0153\\-\\/]+$",
	 *		'constraintType':null
	 * }
	 * ex. 2 {
	 *		'required':true,
	 *		'requiredMessage':'field is required',
	 *		'minLength':4,
	 *		'maxLength':10,
	 *		'lengthMessage':'length must be between x and y',
	 *		'constraintMessage':'email is not valid',
	 *		'hasConstraint':true,
	 *		'hasLengthValidation':false,
	 *		'lengthRegex':null,
	 *		'constraintRegex':'xyz',
	 *		'constraintType':'REGEX'
	 * }
	 *
	 * @author Thomas Junghans
	 * @namespace ScForm
	 * @class ClientValidation
	 * @param {Object} clientValidationJson
	 * @constructor
	 */

	function ClientValidation(clientValidationJson, $form) {
		this.init(clientValidationJson, $form);
	}

	ClientValidation.prototype = {
		constructor: ClientValidation,

		isUndef: function (value) {
			return typeof(value) === 'undefined';
		},

		init: function (clientValidationJson, $form) {

			// Alias
			var cvj = clientValidationJson;

			/**
			 * @property required
			 * @type {boolean}
			 */
			this.required = this.isUndef(cvj.required) ? false : cvj.required;

			/**
			 * @property requiredMessage
			 * @type {string}
			 */
			this.requiredMessage = this.isUndef(cvj.requiredMessage) ? '' : cvj.requiredMessage;

			/**
			 * @property minLength
			 * @type {Number}
			 */
			this.minLength = this.isUndef(cvj.minLength) ? 0 : cvj.minLength;

			/**
			 * A number between 0 cvj.maxLength or 255
			 * @property maxLength
			 * @type {Number}
			 */
			this.maxLength = this.isUndef(cvj.maxLength) || cvj.maxLength === 0 ? 255 : cvj.maxLength;

			/**
			 * @property lengthMessage
			 * @type {string}
			 */
			this.lengthMessage = this.isUndef(cvj.lengthMessage) ? '' : cvj.lengthMessage;

			/**
			 * @property constraintMessage
			 * @type {string}
			 */
			this.constraintMessage = this.isUndef(cvj.constraintMessage) ? '' : cvj.constraintMessage;

			/**
			 * @property constraintType
			 * @type {string}
			 */
			this.constraintType = this.isUndef(cvj.constraintType) ? '' : cvj.constraintType;

			/**
			 * @property hasLengthValidation
			 * @type {boolean}
			 */
			this.hasLengthValidation = this.isUndef(cvj.hasLengthValidation) ? false : cvj.hasLengthValidation;

			/**
			 * @property hasConstraint
			 * @type {boolean}
			 */
			this.hasConstraint = this.isUndef(cvj.hasConstraint) ? false : cvj.hasConstraint;

			/**
			 * @property constraintRegex
			 * @type {null|RegExp}
			 */
			this.constraintRegex = this.isUndef(cvj.constraintRegex) ? null : new RegExp(cvj.constraintRegex);

			/**
			 * @property constraintData
			 * @type {null|obj}
			 */
			this.constraintData = this.isUndef(cvj.constraintData) ? null : cvj.constraintData;

			/**
			 * @property foreignValidationModels
			 * @type {null|obj}
			 */
			this.foreignValidationModels = this.isUndef(cvj.foreignValidationModels) ? null : cvj.foreignValidationModels;

			/**
			 * @property lengthRegex
			 * @type {null|RegExp}
			 */
			this.lengthRegex = this.isUndef(cvj.lengthRegex) ? null : new RegExp(cvj.lengthRegex);

			/**
			 * @property $form The form element used
			 * @type {jQuery|null}
			 */
			this.$form = $form;

			/**
			 * @property formAPI The form module API (if any)
			 * @type {Object}
			 */
			this.formAPI = null;
			if (this.$form) {
				this.formAPI = this.$form.data('form-api');
			}
		},

		/**
		 * @method getConstraintMessage
		 * @returns {string}
		 */
		getConstraintMessage: function () {
			return this.constraintMessage;
		},

		/**
		 * @method getRequiredMessage
		 * @returns {string}
		 */
		getRequiredMessage: function () {
			return this.requiredMessage;
		},

		/**
		 * @method getLengthMessage
		 * @returns {string}
		 */
		getLengthMessage: function () {
			return this.lengthMessage;
		},

		/**
		 * @method isRequired
		 * @returns {boolean}
		 */
		isRequired: function () {
			return this.required;
		},

		hasCorrectLength: function (value) {
			if (this.hasLengthValidation === false) {
				return true;
			}

			// Replace all carriage returns with a space, otherwise the regex will fail
			value = value.replace(/\n/g, ' ');

			return this.lengthRegex instanceof RegExp && this.lengthRegex.test(value) === true;
		},

		/**
		 * Expects either the number of checked checkboxes (0...n) or true for checked, false for not checked
		 *
		 * @method validateCheckboxGroup
		 * @param {boolean|number} selected
		 * @returns {ValidationReturn}
		 */
		validateCheckboxGroup: function (selected) {
			var cv = this,
				vr = w.ScForm.createValidationReturn(true, '');

			if (cv.isRequired() === false) {
				return vr;
			} else if (selected === false || selected === 0) {
				vr.set(false, cv.getRequiredMessage());
				return vr;
			}

			return vr;
		},

		/**
		 * Expects either the number of checked radios (0 or not 0) or true for checked, false for not checked
		 * selected must be either true or exactly 1 to validate (only 1 radio can be selected in a group)
		 *
		 * @method validateRadioGroup
		 * @param {boolean|number} selected
		 * @returns {ValidationReturn}
		 */
		validateRadioGroup: function (selected) {
			var cv = this,
				vr = w.ScForm.createValidationReturn(true, '');

			if (cv.isRequired() === false) {
				return vr;
			} else if (selected === false || selected < 1 || selected > 1) {
				vr.set(false, cv.getRequiredMessage());
				return vr;
			}

			return vr;
		},

		validateSDXInputGroup: function (values) {
			var cv = this,
				vr = w.ScForm.createValidationReturn(true, '');

			if (cv.isRequired() === false) {
				return vr;
			} else if (!values || !values.length) {
				vr.set(false, cv.getRequiredMessage());
				return vr;
			}

			return vr;
		},

		/**
		 *
		 * @param value
		 * @returns {ValidationReturn}
		 */
		validate: function (value, context) {
			var cv = this,
				vr = w.ScForm.createValidationReturn(true, '');

			if (cv.constraintType === 'FOREIGN_FIELD') {
				return cv.validateByForeignField(value);
			}

			// 1. Required
			if (cv.isRequired() && value === '') {
				vr.set(false, cv.getRequiredMessage());
				return vr;
			}

			// 2. Check length
			if (value !== '' && cv.hasLengthValidation === true && cv.hasCorrectLength(value) === false) {
				vr.set(false, cv.getLengthMessage());
				return vr;
			}

			// 3. Check constraint
			if (cv.hasConstraint === false || value === '') {
				return vr;
			} else if (cv.constraintType === 'REGEX' && cv.constraintRegex instanceof RegExp && cv.constraintRegex.test(value) === false) {
				vr.set(false, cv.getConstraintMessage());
			} else if (cv.constraintType === 'DATE' && cv.validateDate(value) === false) {
				vr.set(false, cv.getConstraintMessage());
			} else if (cv.constraintType === 'DATE_IN_FUTURE' && cv.validateDate(value, true) === false) {
				vr.set(false, cv.getConstraintMessage());
			} else if (cv.constraintType === 'DATE_IN_PAST' && cv.validateDate(value, false) === false) {
				vr.set(false, cv.getConstraintMessage());
			} else if (cv.constraintType === 'URL_EXISTS' && cv.validateUrlExists(value, cv.constraintData, context) === false) {
				vr.set(false, cv.getConstraintMessage());
			} else if (cv.constraintType === 'SIM_NUMBER' && cv.validateSimCardNumber(value, cv.constraintData, context) === false) {
				vr.set(false, cv.getConstraintMessage());
			} else if (cv.constraintType === 'AJAX' && cv.validateByAjax(value, cv.constraintData, context) === false) {
				vr.set(false, cv.getConstraintMessage());
			} else if (cv.constraintType === 'IBAN' && cv.validateIBAN(value, context) === false) {
				vr.set(false, cv.getConstraintMessage());
			} else if (cv.constraintType === 'URL_NOT_BLACKLISTED' && cv.validateBlacklistedURL(value, context, false) === false) {
				vr.set(false, cv.getConstraintMessage());
			} else if (cv.constraintType === 'URL_BLACKLISTED' && cv.validateBlacklistedURL(value, context, true) === false) {
				vr.set(false, cv.getConstraintMessage());
			}

			// Finally, if all is good
			return vr;
		},

		/**
		 * Validates a date in the format of d.m.yyyy or dd.mm.yyyy. The second parameter is optional. If true, the given date
		 * must be in the future starting with the current date. If it is false, it must be in the past starting the with the current date.
		 *
		 * @method validateDate
		 * @param inputDate
		 * @returns {boolean}
		 */
		validateDate: function (date, constraint) {

			// delegate to parse function if not a date object already
			if (Object.prototype.toString.call(date) !== '[object Date]') {
				date = SCS.utils.date.parseDateDay(date);
			}
			// assert for valid object
			if (!date) {
				return false;
			}

			// get validation constraints
			var config = this.constraintData;

			// support old options for compatibility reasons (used by validate)
			if (constraint === true && date < new Date()) {
				return false; // DATE_IN_FUTURE
			}
			if (constraint === false && date > new Date()) {
				return false; // DATE_IN_PAST
			}

			// Get the time from the referenced field.
			// On validation we only get passed the value
			// of the main field. With date we potentially
			// have two input elements (date & time).
			var time = 0;
			if (config.refTimeField) {
				if(config.refTimeField.value) {
					time = config.refTimeField.value;
				} else if(typeof config.refTimeField.val === 'function') {
					time = config.refTimeField.val();
				}
			}

			// put time on date object (supports optional hour format)
			if (time) {
				time = SCS.utils.date.toHours(time);
				date.setMinutes(time * 60);
			}

			// dispatch the actual check to the library function
			return SCS.utils.date.isValidDate(date, this.constraintData);

		},
		// EO validateDate

		/**
		 * Validates a date in the format of d.m.yyyy or dd.mm.yyyy. The second parameter is optional. If true, the given date
		 * must be in the future starting with the current date. If it is false, it must be in the past starting the with the current date.
		 *
		 * @method validateDate
		 * @param inputDate
		 * @returns {boolean}
		 */
		validateDay: function (date) {

			// delegate to parse function if not a date object already
			if (Object.prototype.toString.call(date) !== '[object Date]') {
				date = SCS.utils.date.parseDateDay(date, this.constraintData);
			}
			// assert for valid object
			if (!date) {
				return false;
			}

			// day is valid if it is a work day (by business hours)
			return SCS.utils.date.isValidDay(date, this.constraintData);

		},
		// EO validateDate

		validateByForeignField: function (value) {
			var field = this.constraintData.foreignFieldName;
			if (field) {
				var selector = 'select[name="' + field + '"],input:checked[type=radio][name="' + field + '"],input:checked[type=checkbox][name="' + field + '"],input[type=text][name="' + field + '"]';
				var foreignFieldValue = $(selector).val();
				for (var key in this.foreignValidationModels) {
					if (this.foreignValidationModels.hasOwnProperty(key)) {
						if (key === foreignFieldValue) {
							var cv = new ClientValidation(this.foreignValidationModels[key]);
							return cv.validate(value);
						}
					}
				}
			}
			this.constraintType = 'NONE';
			return this.validate(value);
		},

		// FIXME: Real asynchronous validation would be a cool feature
		// but rewriting all consumers of this API is too much work compared to the benefits.
		// This just returns false (marks the field invalid), resets the validation markup afterwards,
		// does the validation asynchronously and caches the result and then re-triggers the validation,
		// for which it can return the cached result.
		// If the validation was triggered as part of a submit, this will submit the form when
		// the validation call has completed.
		validateAsynchronously: function validateAsynchronously(key, validator, context) {
			var cv = this;
			// Init cache of asynchronous validation results
			if (!validateAsynchronously.cache) {
				validateAsynchronously.cache = {};
			}
			if (!cv.formAPI) {
				throw new Error('Asynchronous validation hack/workaround is only available for full forms.');
			}
			// Result already available or validation currently running.
			if (key in validateAsynchronously.cache) {
				return validateAsynchronously.cache[key] === undefined ? false : validateAsynchronously.cache[key];
			}
			// Mark validation as running.
			validateAsynchronously.cache[key] = undefined;
			// Disable scrolling temporarily
			cv.formAPI.setEnableValidationScrolling(false);

			validator(function (result, error) {
				if (error) {
					// The validation could not be performed at this time. Abort.
					if (error.status && error.responseText) {
						try {
							error = $.parseJSON(error.responseText);
							cv.formAPI.renderPopupMessage(error.message);
						}
						catch (e) {
							cv.formAPI.renderPopupMessage(error.responseText);
						}
					} else {
						cv.formAPI.renderPopupMessage('Unspecified Error');
					}
					delete validateAsynchronously.cache[key];
					return;
				}
				validateAsynchronously.cache[key] = !!result;
				cv.formAPI.setEnableValidationScrolling(true);
				// Re-trigger form validation
				if (context === 'submit') {
					cv.formAPI.submit();
				} else if (context === 'advanceStep') {
					cv.formAPI.advanceStep();
				} else if (context === 'stepAction') {
					cv.formAPI.stepAction();
				} else if (typeof context === 'function') {
					cv.formAPI.onFormValidate(context);
				} else {
					cv.formAPI.validateForm();
				}
			});

			window.setTimeout(function () {
				// Check if validation is still running.
				// If so, reset the fields so they don’t appear invalid while the validation is running
				if (validateAsynchronously.cache[key] === undefined && key in validateAsynchronously.cache) {
					cv.formAPI.resetValidation();
				}
			}, 0);

			// Mark as invalid until validation has finished (if validation was synchronous, this already contains the correct result).
			return validateAsynchronously.cache[key] === undefined ? false : validateAsynchronously.cache[key];
		},

		validateUrlExists: function (value, options, context) {
			if (/[^a-zA-Z0-9_\-öäüÖÄÜ]/.test(value)) {
				// PORTAL-5702: No special characters except - and _ are allowed.
				return false;
			}

			var url = options.urlPattern.replace(/\*/g, value);

			var urlPatternCheckIsNegative = options.urlPatternCheckIsNegative === 'true';
			var key = 'validateUrlExists-' + (urlPatternCheckIsNegative ? 'negative' : 'positive') + '-' + url;
			var validator;
			// Use the JS route if .js appears in the URL.
			// Might be in a selector, as the extension
			// or even as a param (so we can force URLs to be recognized as JS)
			if (url.indexOf('.js') > -1) {
				var global = /[&?]global=([^&]+)(&|$)/.exec(url);
				if (global && (global = global[1])) {
					// Safeguard against accidental overrides by not allowing globals that already exist
					if (window[global]) {
						global = null;
					}
				}
				validator = function jsValidator(cb) {
					$.ajax(url, {
						complete: function (xhr, error) {
							// A timeout is the only way to detect whether there was valid javascript at the given location
							var isValid = error === 'success';
							// We can also check for a global that was created by the script
							if (global && isValid) {
								isValid = !!window[global];
								window[global] = undefined;
							}
							cb(urlPatternCheckIsNegative ? !isValid : isValid);
						},
						dataType: 'script',
						timeout: 2000
					});
				};
			} else {
				validator = function xhrValidator(cb) {
					$.ajax(url, {
						complete: function (xhr) {
							var isValid = xhr.status >= 200 && xhr.status < 400;
							cb(urlPatternCheckIsNegative ? !isValid : isValid);
						},
						dataType: 'text'
					});
				};
			}
			return this.validateAsynchronously(key, validator, context);
		},

		/**
		 * Use the Luhn algorithm to validate that a sim card number is valid.
		 * @param value
		 */
		validateSimCardNumber: function validateSimCardNumber(value) {

			//Valid sim numbers have 20 digits (only new ones are considered).
			if (!value || !/^\d{20}/.test(value)) {
				return false;
			}

			/**
			 * Luhn algorithm in JavaScript: validate credit card number supplied as string of numbers
			 * @author ShirtlessKirk. Copyright (c) 2012.
			 * @license WTFPL (http://www.wtfpl.net/txt/copying)
			 */
			var luhnChk = (function (arr) {
				return function (ccNum) {
					var
						len = ccNum.length,
						bit = 1,
						sum = 0,
						val;

					while (len) {
						len -= 1;
						val = parseInt(ccNum.charAt(len), 10);
						/* jshint bitwise: false */
						sum += (bit ^= 1) ? arr[val] : val;
					}

					return sum && sum % 10 === 0;
				};
			}([0, 2, 4, 6, 8, 1, 3, 5, 7, 9]));

			return luhnChk(value);
		},

		/**
		 * use ajax to validate field
		 * @param value
		 */
		validateByAjax: function validateByAjax(value, constraintData, context) {
			var ajaxUrl = constraintData.ajaxUrl,
				formFieldName = constraintData.formFieldName,
				key = 'validateByAjax-' + formFieldName + '-' + value,
				data = $.extend({
					value: value,
					formId: this.$form.find('*[name=\':formid\']').val(),
					formPath: this.$form.find('*[name=\':formstart\']').val()
				}, constraintData),
				validator = function ajaxValidator(callback) {
					$.ajax({
						url: ajaxUrl,
						type: 'POST',
						cache: false,
						data: data,
						dataType: 'json',
						success: function (data) {
							var isValid = data.isValid;
							callback(isValid);
						},
						error: function (jqXHR) {
							callback(null, jqXHR);
						}
					});
				};

			return this.validateAsynchronously(key, validator, context);
		},

		validateIBAN: function (value, context) {
			var res = /^[A-Z]{2}[0-9]{2}([0-9]{5})[0-9A-Z]{12}$/.exec(value);
			var bcNumber = res && res[1];
			if(!bcNumber) {
				return false;
			}
			var sanitizedValue = bcNumber.replace(/^0*/, '');
			if(sanitizedValue.length < 3) {
				return false;
			}
			var validator = ibanFieldValidator(sanitizedValue);
			var key = 'validateIBAN-' + sanitizedValue;

			return this.validateAsynchronously(key, validator, context);
		},

		validateBlacklistedURL: function (value, context, inverted) {
			var validator = urlBlacklistValidation(value, inverted);
			var key1 = 'validateIURLBlacklisted-' + encodeURIComponent(value);
			var key2 = 'validateIURLNotBlacklisted-' + encodeURIComponent(value);
			var key = inverted ? key1 : key2;

			return this.validateAsynchronously(key, validator, context);
		}

	};

	w.ScForm = w.ScForm || {};
	w.ScForm.createClientValidation = function (clientValidationJson, $form) {
		return new ClientValidation(clientValidationJson, $form);
	};

}(window, __webpack_provided_window_dot_$, window.SCS = window.SCS || {}));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 265 */
/***/ (function(module, exports) {

(function (w) {
	"use strict";

	/**
	 * The class ValidationReturn is a wrapper for the ClientValidation return
	 *
	 *
	 * @author Thomas Junghans
	 * @namespace ScForm
	 * @class ValidationReturn
	 * @param {Boolean} isValid
	 * @param {String} message
	 * @constructor
	 */
	function ValidationReturn(isValid, message) {
		this.init(isValid, message);
	}

	ValidationReturn.prototype = {
		constructor : ValidationReturn,
		init : function (isValid, message) {
			this.set(isValid, message);
		},

		set : function (isValid, message) {
			this.isValid = isValid;
			this.message = message;
		},

		get : function () {
			var self = this;
			return {
				isValid : self.isValid,
				message : self.message
			};
		},
		getMessage : function () {
			return this.message;
		}
	};

	w.ScForm = w.ScForm || {};
	w.ScForm.createValidationReturn = function (isValid, message) {
		return new ValidationReturn(isValid, message);
	};

}(window));

/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var loadTerrific = __webpack_require__(1);
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function ($, w) {
	/*
	 * Dependencies:
	 * TerrificJs 2.0.1,
	 * jQuery 1.7 or greater,
	 */

	'use strict';
	/*globals Tc */

	/**
	 * AjaxCaptcha module implementation.
	 *
	 * @author Dimitri Sebeschuk
	 * @namespace Tc.Module
	 * @class AjaxCaptcha
	 * @extends Tc.Module
	 */
	Tc.Module.AjaxCaptcha = Tc.Module.extend({

		/**
		 * Triggered when the status message in the detail page should be reset
		 *
		 * @event resetstatus
		 */
		EVENT_CALLBACK_CAPTCHA: 'callbackCaptchaEvent',

		/**
		 * Initializes the Default module.
		 *
		 * @method init
		 * @constructor
		 * @param {jQuery|Zepto} $ctx the jquery context
		 * @param {Sandbox} sandbox the sandbox to get the resources from
		 * @param {String} modId the unique module id
		 */
		init: function ($ctx, sandbox, modId) {

			$ctx.insertBefore($ctx.closest('.buttongroup'));

			// call base constructor
			this._super($ctx, sandbox, modId);

		},


		/**
		 * Hook function to do all of your module stuff.
		 *
		 * @method on
		 * @param {Function} callback function
		 * @return void
		 */
		on: function (callback) {
			var mod = this;

			mod.path = mod.getPath();
			mod.$ctx.on('captchaNeededEvent', $.proxy(mod.onCaptchaNeeded, mod));
			mod.$ctx.on('clearCaptchaEvent', $.proxy(mod.onClearCaptcha, mod));

			if(!mod.$ctx.data('disable-on-load')){
			mod.onCaptchaNeeded();
			}

			callback();
		},

		onCaptchaNeeded: function () {
			var mod = this;
			$.ajax({
				type: 'POST',
				url: "/etc/swisscom/servlets/public/forms/captcha.json",
				cache: false,
				data: {
					path: mod.path
				},
				success: function (data) {
					var clientValidation = mod.$ctx.find('.field').data('clientvalidation');
					if (data == 'true' || data === true || mod.$ctx.data('required') === true) {
						if (clientValidation) {
							clientValidation.required = true;
							mod.$ctx.find('.field').data('clientvalidation', clientValidation);
						}
						mod.createCaptcha();
					} else {
						if (clientValidation) {
							clientValidation.required = false;
							mod.$ctx.find('.field').data('clientvalidation', clientValidation);
						}
					}
				}
				//TODO Show exception
			});
		},

		getPath: function () {
			var mod = this,
				href,
				urlParser,
				form = mod.$ctx.closest('form'),
				path = form.find('input[name=":formstart"]').val(),
				formId = form.find('input[name=":formid"]').val();

			if (!path || !path.length) {
				//try to take path from canonical url
				urlParser = document.createElement('a');
				href = $('link[rel=canonical]').attr('href');
				if (href) {
					urlParser.href = href;
					path = urlParser.pathname;
				}
			}
			if (!path || !path.length) {
				//take path from location
				urlParser.href = w.location.href;
				//remove all selectors
				path = urlParser.pathname.replace(/(\.[^\/.]+)*\.html$/, '.html');
			}

			if (path && path.length > 0) {
				if(path.charAt(0) != '/'){
				path = '/' + path;
				}
				path = path.indexOf('/jcr:content') > 0 ? path.substring(0, path.indexOf('/jcr:content')) : path;
				//see ch.swisscom.forms.business.api.impl.FormDatabaseServiceImpl.logFormSubmit()
				path = formId && formId.length > 0 ? path+'?:formid='+formId : path;
			}

			return path;
		},

		callbackCaptchaHandler: function () {
			var mod = this;
			mod.$ctx.trigger(mod.EVENT_CALLBACK_CAPTCHA);
		},

		createCaptcha: function () {
			this.createCaptchaCount = this.createCaptchaCount || 0;
			if (typeof grecaptcha !== 'undefined') {
				var mod = this,
					publicKey = mod.$ctx.data('public-key'),
					theme = mod.$ctx.data('theme'),
					lang = mod.$ctx.data('lang'),
					id = 'captchaAjaxContainer_' + mod.$ctx.data('uid');

				if (mod.widgetId > -1) {
					debug.log('Tc.Module.AjaxCaptcha -> createCaptcha: captcha exists return!');
					grecaptcha.reset(mod.widgetId);
					mod.$ctx.show();
					return;
				}


				mod.widgetId = grecaptcha.render(id, {
					'sitekey': publicKey,
					'theme': theme,
					'callback': $.proxy(mod.callbackCaptchaHandler, mod)
				});
				mod.$ctx.show();
			} else {
				if (this.createCaptchaCount < 10) {
					this.createCaptchaCount++;
					setTimeout($.proxy(this.createCaptcha, this), 500);
				}
			}

		},

		onClearCaptcha: function () {
			var mod = this,
				id = 'captchaAjaxContainer_' + mod.$ctx.data('uid'),
				clientValidation = mod.$ctx.find('.field').data('clientvalidation');

			mod.widgetId = -1;
			$('#' + id, mod.$ctx).empty();
			mod.$ctx.hide();
			if (clientValidation) {
				clientValidation.required = false;
				mod.$ctx.find('.field').data('clientvalidation', clientValidation);
			}
		}

	});

}(Tc.$, window));

}.call(window));

/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_Tc_dot_$, jQuery) {/*** IMPORTS FROM imports-loader ***/
var loadTerrific = __webpack_require__(1);
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function ($, Tc, SCS, debug) {
	'use strict';

	// allocate one container at the body level
	// avoids beeing inside any overflow hidden node
	var bodyContainer;

	/**
	 * JQuery Autocomplete Wrapper
	 * http://api.jqueryui.com/autocomplete/
	 *
	 * @author Marc Althoff
	 * @namespace Tc.Module
	 * @class Autocomplete
	 * @extends Tc.Module
	 */
	Tc.Module.Autocomplete = Tc.Module.extend({

		// cached directly via varnish
		url: '/portalshop-api/res/product/getexportproductsbycategorynew/RES_MO_PHONES',
		data: [],

		/**
		 * @method on
		 * @param {Function} callback function
		 * @return void
		 */
		on: function (callback) {
			var
				mod = this;

			mod.getData();

			callback();
		},

		getData: function () {
			var
				mod = this;

			$.ajax({
				url: mod.url,
				dataType: "json",
				success: function (json) {
					mod.parseData(json);
				},
				error: function () {
					debug.log('Tc.Module.Autocomplete.js / error: ajax call to ' + mod.url + 'failed');
				},
				statusCode: {
					404: function () {
						debug.log('Tc.Module.Autocomplete.js / statusCode.404: URL not found');
					},
					500: function () {
						debug.log('Tc.Module.Autocomplete.js / statusCode.500: Service not available');
					},
					503: function () {
						debug.log('Tc.Module.Autocomplete.js / statusCode.503: Service Temporarily Unavailable');
					}
				}
			});
		},

		parseData: function (data) {

			var
				mod = this,
				type = mod.$ctx.attr("data-autocomplete");

			function unique(array) {
				return $.grep(array, function (el, index) {
					return index == $.inArray(el, array);
				});
			}

			function parseManufacturers(data) {
				var brands = Array();
				data['ExportProductList'].forEach(function (product) {
					brands.push(product['ProductBrand']);
				});
				return unique(brands);
			}

			function parseDevices(data, language) {
				var products = Array();
				data['ExportProductList'].forEach(function (product) {
					product['Names'].forEach(function (name) {
						if (name['Language'].substr(0, 2) == language) {
							products.push(name['Name']);
						}
					});
				});
				var productList = unique(products);
				return productList.sort();
			}

			if (type === 'manufacturer') {
				mod.data = parseManufacturers(data);
			} else if (type === 'device') {
				mod.data = $.unique(parseDevices(data, ($('html').attr('lang') || "de")));
			}
			mod.populateFields();

		},

		populateFields: function () {
			var
				mod = this;

			// create body container only once
			if (!bodyContainer) {
				bodyContainer = jQuery('<DIV>')
					.addClass('autocompleteMenuTarget')
					.appendTo('BODY');
			}

			$('.autocomplete', mod.$ctx).autocomplete({
				source: mod.data,
				minLength: (mod.$ctx.attr('data-minlength') || 2),
				appendTo: bodyContainer
			});
		}
	});

}(__webpack_provided_window_dot_Tc_dot_$, window.Tc, window.SCS = window.SCS || {}, window.debug));




}.call(window));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0), __webpack_require__(0)))

/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_Tc_dot_$) {/*** IMPORTS FROM imports-loader ***/
var loadTerrific = __webpack_require__(1);
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function (Module, $, doT) {
	'use strict';
	/*jshint smarttabs:false */
	/**
	 * Address with Type-Ahead uses the GAIA Webservice to
	 * render list of suggestions to the user using the address
	 * fields in this set.
	 *
	 * As the M@p Service will be removed from portal as of November 2016, pre-fill from
	 * M@p values has been removed from this component.
	 *
	 * @author Matthias Inauen
	 * @namespace Tc.Module.AutoSuggestAddress
	 * @class AutoSuggestAddress
	 * @extends Tc.Module
	 *
	 * @terrificjs-channels    autosuggestaddress
	 * @fires zipCityLoaded, zipCityStart
	 * @handles onZipCityLoaded
	 */

	var GAIA = {
			SERVICE: {
				BASE_PATH: '/portal-services/portal-integration/ws/gaia/',
			},
		},
		// P = postal addresses
		// S = Official addresses
		// T = Technical addresses
		ADDRESS_TYPE = {
			"P": "&addressUsage=P",
			"S": "&addressUsage=S",
			"T": "&addressUsage=T",
			"PS": "&addressUsage=PS",
			"ST": "&addressUsage=ST",
			"PST": "&addressUsage=PST",
		},
		ERROR_MESSAGES = {
			400: 'bad request, mandatory input parameters missing',
			401: 'unauthorized - authorization informations missing',
			404: 'not found',
			500: 'internal server error'
		},
		LIST_MAX_LENGTH = 10,
		dataCache = {
			zipCity: [],
			streetName: [],
			houseNumber: [],
			houseName: []
		},
		KEYS = {
			ESCAPE: 27,
			DOWN: 40,
			UP: 38,
			ENTER: 13,
			TAB: 9
		},
		FIELD_MAPPINGS = {
			zip: {datakey: 'zipCity', valuekey: 'zipCity', matchStart: true},
			city: {datakey: 'zipCity', valuekey: 'zipCity', matchStart: false},
			streetName: {datakey: 'streetName', valuekey: 'streetName', matchStart: false},
			houseNumber: {datakey: 'houseNumber', valuekey: 'houseNumber', matchStart: true},
			houseName: {datakey: 'houseName', valuekey: 'houseName', matchStart: false}
		};

	function escapeRegExp(string) {
		// copied from Tc.Module.ScForm.js
		return string.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, "\\$1");
	}

	Module.AutoSuggestAddress = Module.extend({
		on: function (callback) {
			this.templateCache = {};

			this.initComponent();
			this.cacheTemplates();

			this.typeAheadList = this.$ctx.find('.type-ahead-list');
			this.typeAheadListUl = this.typeAheadList.find('ul');
			this.isMobile = this.$ctx.is('isMobile');
			this.addressType = this.$ctx.data('address-type');
			if (!(this.addressType in ADDRESS_TYPE)) {
				this.addressType = 'PS'; // default
			}

			this.addEventListeners();
			this.setFieldAccess();
			callback();
		},

		/**
		 * Initialize Component, and make sure it can be easily overridden by
		 * a skin.
		 */
		initComponent: function () {
			this.$checkboxNoStreet = this.$ctx.find('.nostreet input:checkbox');
			this.$zipAndCity = this.$ctx.find('.zip-and-city');
			this.$zipInput = this.$zipAndCity.find('.zip input');
			this.$cityInput = this.$zipAndCity.find('.city input');
			this.$streetNrAndHouseName = this.$ctx.find('input').not('.zip-and-city input, .nostreet input');
			this.$allAddressInputFields = this.$ctx.find('input').not('.nostreet input, [type="hidden"]');
			this.$streetAndNumber = this.$ctx.find('.street-and-nr');
			this.$streetNameInput = this.$streetAndNumber.find('.street-name input');
			this.$houseNumberInput = this.$streetAndNumber.find('.house-number input');
			this.$locationIdInput = this.$ctx.find('[name="locationId"]');
			this.$building = this.$ctx.find('.building');
			this.$houseNameInput = this.$building.find('.house-name input');
			this.formIsRequired = this.$ctx.data('formInputRequired');
			// Used in Custom Forms
			this.gaiaAdress = this.$ctx.hasClass('gaiaAddressCheck');

			if (this.gaiaAdress) {
				this.initAdditionalFields();
			}

		},

		initAdditionalFields: function () {
			var street, houseNumber, houseName, zipFieldName, cityFieldName;

			street = this.$streetNameInput.attr('name');
			houseNumber = this.$houseNumberInput.attr('name');
			houseName = this.$houseNameInput.attr('name');
			zipFieldName = this.$zipInput.attr('name');
			cityFieldName = this.$cityInput.attr('name');
			FIELD_MAPPINGS[street] = {datakey: 'streetName', valuekey: 'streetName', matchStart: false};
			FIELD_MAPPINGS[houseNumber] = {datakey: 'houseNumber', valuekey: 'houseNumber', matchStart: false};
			FIELD_MAPPINGS[houseName] = {datakey: 'houseName', valuekey: 'houseName', matchStart: false};
			FIELD_MAPPINGS[zipFieldName] = {datakey: 'zipCity', valuekey: 'zipCity', matchStart: true};
			FIELD_MAPPINGS[cityFieldName] = {datakey: 'zipCity', valuekey: 'zipCity', matchStart: false};
			this.$locationIdInput = this.$ctx.find('.gaiaId');
		},
		/**
		 * Cache the templates for each list item
		 */
		cacheTemplates: function () {
			this.templateCache[FIELD_MAPPINGS.zip.datakey] = doT.template(this.$ctx.find('script.tmpl-zipcity').html());
			this.templateCache[FIELD_MAPPINGS.streetName.datakey] = doT.template(this.$ctx.find('script.tmpl-streetname').html());
			this.templateCache[FIELD_MAPPINGS.houseNumber.datakey] = doT.template(this.$ctx.find('script.tmpl-housenumber').html());
			this.templateCache[FIELD_MAPPINGS.houseName.datakey] = doT.template(this.$ctx.find('script.tmpl-housename').html());
		},

		/**
		 * Adding all event listeners for this component
		 */
		addEventListeners: function () {
			this.$checkboxNoStreet.on('change', $.proxy(this.handleNoStreet, this));
			this.$ctx.on('mouseenter', $.proxy(this.handleFirstInteraction, this));
			this.typeAheadListUl.on('click', 'li:not(.nomatch)', $.proxy(this.handleListItemSelected, this));
			this.typeAheadList.on('mouseenter', $.proxy(this.handleListFocus, this));
			this.typeAheadList.on('mouseleave', $.proxy(this.handleListFocus, this));
			this.$allAddressInputFields.on('focusin.AutoSuggestAddress', $.proxy(this.handleFirstInteraction, this));
			this.$allAddressInputFields.on('focusin', $.proxy(this.handleInputFocusIn, this));
			this.$allAddressInputFields.on('blur', $.proxy(this.handleInputFocusOut, this));
			this.$houseNumberInput.on('input change', $.proxy(this.handleAddressComplete, this));
			this.$houseNameInput.on('input change', $.proxy(this.handleAddressComplete, this));
		},
		/**
		 * Adds key listeners to a form field.
		 * @param $input
		 */
		addKeyListeners: function ($input) {
			$input.on('input.AutoSuggestAddress', $.proxy(this.handleInput, this));
			$input.on('keydown.AutoSuggestAddress', $.proxy(this.handleKeyDown, this));
		},
		/**
		 * Cache the current input field value for later comparison to the new value,
		 * to figure out if the value changed.
		 * @param $input
		 */
		cacheInputFieldValue: function ($input) {
			var zipCityValue;

			if (this.isZipOrCity($input)) {
				zipCityValue = this.$zipInput.val() + ' ' + this.$cityInput.val();
				this.$zipInput.data('currentValue', zipCityValue);
				this.$cityInput.data('currentValue', zipCityValue);
			}
			else {
				$input.data('currentValue', $input.val());
			}
		},
		/**
		 * Clears the values of all subsequent input fields starting at the
		 * provided input field.
		 * @param fieldName
		 */
		clearSubsequentFields: function (fieldName) {
			var $input = this['$' + fieldName + 'Input'];
			if ($input) {
				var inputIndex = this.$allAddressInputFields.index($input);
				for (var i = (inputIndex + 1); i < this.$allAddressInputFields.length; i += 1) {
					this.$allAddressInputFields.eq(i).val('');
				}

				this.setFieldAccess();
			}
		},
		/**
		 * Remove the unique address id from the form
		 */
		clearUniqueAddressId: function () {
			this.$locationIdInput.val('');
		},
		/**
		 * checks if a (series) of fields already have values set an initiates loading of
		 * the according data for the next fields.
		 * @param fieldName
		 */
		checkForPreFilledValues: function (fieldName) {
			var $input, filterValue, filteredValues, links, dataLink;

			if (fieldName === 'zipCity') {
				filterValue = (this.$zipInput.val().length && this.$cityInput.val().length) ? this.$zipInput.val() + ' ' + this.$cityInput.val() : '';
			}
			else {
				$input = this['$' + fieldName + 'Input'] || $();
				filterValue = $input.val();
			}

			if (!filterValue || !filterValue.length) {
				if (fieldName !== 'zipCity') {
					$input.focus();
				}
				return;
			}

			filteredValues = this.getFilteredList(dataCache[fieldName], fieldName, filterValue, true, true);
			if (filteredValues.length) {
				links = filteredValues[0].links;
				if (fieldName === 'zipCity') {
					// cache the values in case the user switches from street name to house name
					this.zipCityValueCache = {
						zip: this.$zipInput.val(),
						city: this.$cityInput.val(),
						linkStreetName: this.getFilteredList(links, 'rel', 'streets', true, true)[0].href,
						linkHouseName: this.getFilteredList(links, 'rel', 'houseNames', true, true)[0].href
					};

					dataLink = (this.useHouseName) ? this.zipCityValueCache.linkHouseName : this.zipCityValueCache.linkStreetName;
				}
				else {
					dataLink = links[0].href;
				}

				if (dataLink) {
					this.getData(dataLink);
				}
			}
		},
		/**
		 * Checks if all fields have a value
		 */
		formIsComplete: function () {
			if (this.useHouseName) {
				return (this.$zipInput.val().length && this.$cityInput.val().length && this.$houseNameInput.val().length);
			}

			return (this.$zipInput.val().length && this.$cityInput.val().length && this.$streetNameInput.val().length && this.$houseNumberInput.val().length);
		},
		/**
		 * Handles all ajax calls to the backend.
		 *
		 * @param url
		 * @param successCallback
		 * @param params
		 */
		getData: function (url) {
			var requestUrl = GAIA.SERVICE.BASE_PATH + url;
			this.dataLoadingInProgress = true;
			$.ajax({
				url: requestUrl,
				success: $.proxy(this.handleDataSuccess, this),
				context: this,
				error: function (jqXHR, textStatus, errorThrown) {
					// jshint unused: false
					this.log('getData :: ajax error callback :: arguments', arguments);
					this.showErrorMessage(parseInt(jqXHR.status, 10));
				}
			});
		},
		/**
		 * Filters an array of objects.
		 * Selects all objects that have key and key contains value(s)
		 *
		 * @param list - (array)
		 * @param key - (string)
		 * @param value - (string|array). Values that a key must contain. In case of array, if any of the values are part of key, the element is returned
		 * @param matchStart - (boolean) indicate if the value to filter for should match the beginning of the string
		 * @param matchEnd - (boolean) indicate if the value to filter for should match the beginning of the string
		 * @param maxLength - (int) the max length of the array. can be undefined.
		 * @returns Array
		 */
		getFilteredList: function (list, key, value, matchStart, matchEnd, maxLength) {
			var i,
				valueRegexPrefix = (matchStart) ? '^' : '',
				valueRegexPostfix = (matchEnd) ? '$' : '';

			if ($.isArray(list)) {
				return $.grep(list, function (element) {
					if (!element.hasOwnProperty(key)) {
						return false;
					}

					if ($.isArray(value)) {
						for (i = 0; i < value.length; i += 1) {
							if (new RegExp(valueRegexPrefix + escapeRegExp(value[i]) + valueRegexPostfix, 'i').test(element[key].toString())) {
								return true;
							}
						}

						return false;
					}
					else {
						return new RegExp(valueRegexPrefix + escapeRegExp(value) + valueRegexPostfix, 'i').test(element[key].toString());
					}
				}).slice(0, maxLength); // slice to max length. if maxlength is undefined the whole array will be returned
			}

			return [];
		},
		/**
		 * Retrieve the next field in the row
		 * @param field
		 * @return jquery object - next input field
		 */
		getNextField: function (field) {
			if (!field) {
				return null;
			}
			var fieldName = field.attr('name');
			switch (fieldName) {
				case 'zip':
				case 'city':
					if (this.useHouseName) {
						return this.$houseNameInput;
					}
					return this.$streetNameInput;
				case 'streetName':
					return this.$houseNumberInput;
				default:
					return null;
			}
		},
		/**
		 * Handles when the last fields are filled/changed
		 */
		handleAddressComplete: function () {
			this.setUniqueAddressId();
		},

		/**
		 * Handles success for all data calls
		 * @param data
		 * @param status
		 * @param jqXHR
		 */
		handleDataSuccess: function (data) {
			var nextField;
			this.dataLoadingInProgress = false;
			if (data.length) {
				if (data[0].hasOwnProperty('zipCity') && !data[0].hasOwnProperty('houseNumber')) {
					// now store the zip and city data for this instance,
					// but filter out P.O. Box and company addresses first (zipTypes 30 and 40 must go out)
					dataCache.zipCity = this.getFilteredList(data, 'zipType', ['10', '20'])
					// filter entries that are not prefixed with an actual zip number
					// eg. {zipCity: "Wilen b. Wollerau", zipType: 20, altName: "n", zipCode6Pos: "883202"}
					// vs. {zipCity: "8832 Wilen b. Wollerau", zipType: 20, altName: "n", zipCode6Pos: "883202"}
						.filter(function (zipCity) {
							return zipCity.zipCity.match(/^\d+\s/);
						});

					// Send this big junk of data off to all other instances on the page
					// so they don't have to load it themselves.
					this.fire('zipCityLoaded', {zipCity: dataCache.zipCity});
					this.checkForPreFilledValues('zipCity');
					this.clearSubsequentFields('city');
					if (this.activeField) {
						this.updateList(this.activeField);
					}
				}
				else if (data[0].hasOwnProperty('streetName')) {
					dataCache.streetName = data;
					this.checkForPreFilledValues('streetName');
					this.clearSubsequentFields('streetName');
				}
				else if (data[0].hasOwnProperty('houseName')) {
					dataCache.houseName = data;
					this.checkForPreFilledValues('houseName');
				}
				else if (data[0].hasOwnProperty('houseNumber')) {
					dataCache.houseNumber = data;
					this.checkForPreFilledValues('houseNumber');
				}
			}
			else {
				// set focus to the next field.
				nextField = this.getNextField(this.activeField);
				if (nextField) {
					nextField.focus();
				}
				else if (this.activeField) {
					this.activeField.focusout();
				}
			}
		},
		/**
		 * Loading the zip/city json data on first interaction and sending it
		 * off to any other instance of this component on the page.
		 * @param event
		 */
		handleFirstInteraction: function () {
			// prepare initial url
			var url = 'zip-cities/domicile';
			// immediately remove the event handlers that triggered this method, so it won't be called twice
			this.removeFirstInteractionHandlers();
			// let other instances know they can remove the event listeners as well, to avoid loading the data twice
			this.fire('zipCityStart');
			// load the data
			this.getData(url);
		},
		/**
		 * Handles when an input field gains focus
		 * @param event
		 */
		handleInputFocusIn: function (event) {
			var $input = $(event.target);
			// simply cache the current value to verify if the value changed, when focus is lost
			this.cacheInputFieldValue($input);
			this.activeField = $input;
			this.moveListToField($input);
			this.addKeyListeners($input);
			this.updateList($input);
		},
		/**
		 * Handles when an input field loses focus
		 * @param event
		 */
		handleInputFocusOut: function (event) {
			var $input = $(event.target);
			this.removeKeyListeners($input);

			if (this.inputValueChanged($input) && !this.dataLoadingInProgress && !this.valueSetFromListSelect) {
				// input values changed, clear the fields behind this one.
				this.clearSubsequentFields($input.attr('name'));
			}
			this.valueSetFromListSelect = false;
			this.hideTypeAheadList();
		},

		/**
		 * Key events need to be handled on key down to be able to
		 * intercept the event before the browser acts on it.
		 * @param event
		 */
		handleKeyDown: function (event) {
			var $listItems = this.typeAheadListItems;
			var $focus = $listItems.filter('.focus');
			var $input = $(event.target);
			switch (event.which) {
				case KEYS.TAB:
					if (this.listHasFocus) {
						if ($focus.length) {
							event.preventDefault();
							$focus.click();
						}
					}
					break;
				case KEYS.ENTER:
					if (this.listHasFocus) {
						if ($focus.length) {
							event.preventDefault();
							$focus.click();
						}
					}
					break;
				case KEYS.DOWN:
					event.preventDefault();
					this.showTypeAheadList();
					this.selectListItem(true);
					break;
				case KEYS.UP:
					event.preventDefault();
					this.showTypeAheadList();
					this.selectListItem(false);
					break;
				case KEYS.ESCAPE:
					if (!this.typeAheadList.hasClass('hidden')) {
						event.preventDefault();
						$listItems.removeClass('focus');
						this.typeAheadList.addClass('hidden');
						this.typeAheadList.focus();
						this.listHasFocus = false;
					}
					break;
				default:
					this.updateList($input);
					this.setFieldAccess();
			}
		},

		/**
		 * Input event is fired on e.g. paste
		 * @param event
		 */
		handleInput: function (event) {
			var $input = $(event.target);
			this.updateList($input);
			this.setFieldAccess();
		},

		/**
		 * Handles list focus. Sets a flag (listHasFocus) to keep track of the list focus.
		 * @param event
		 */
		handleListFocus: function (event) {
			this.listHasFocus = (event.type === 'mouseenter');
		},
		/**
		 * Handles a selected list item
		 * @param event
		 */
		handleListItemSelected: function (event) {
			var listItem = $(event.target),
				value = listItem.text(), values, dataLink;

			if (this.isZipOrCity(this.activeField)) {
				values = value.split(' ');
				this.$zipInput.val(values.shift()); // first value is the zip
				this.$cityInput.val(values.join(' ')); // all others the city
				dataLink = (this.useHouseName) ? listItem.data('linkHouseName') : listItem.data('linkStreetName');

				var changed = (!this.zipCityValueCache)
					|| (this.zipCityValueCache.zip !== values[0])
					|| (this.zipCityValueCache.city !== values[1]);

				// cache the values in case the user switches from street name to house name
				this.zipCityValueCache = {
					zip: values[0],
					city: values[1],
					linkStreetName: listItem.data('linkStreetName'),
					linkHouseName: listItem.data('linkHouseName')
				};

				if (changed) {
					if (this.$houseNameInput) {
						this.$houseNameInput.val('').trigger('change');
					}
					if (this.$houseNumberInput) {
						this.$houseNumberInput.val('').trigger('change');
					}
					if (this.$streetNrAndHouseName) {
						this.$streetNrAndHouseName.val('').trigger('change');
					}
				}

			}
			else {
				this.activeField.val(value).trigger('change');
				dataLink = listItem.data('link');
			}

			if (dataLink) {
				this.getData(dataLink);
			}

			this.setFieldAccess();
			this.listHasFocus = false;
			this.valueSetFromListSelect = true;
			this.hideTypeAheadList();
		},
		/**
		 * Toggling the UI between Street/Nr. and House Name entry fields.
		 * @param event
		 */
		handleNoStreet: function (event) {
			var isChecked = $(event.target).is(':checked'),
				showField = (isChecked) ? this.$building : this.$streetAndNumber,
				hideField = (isChecked) ? this.$streetAndNumber : this.$building;

			showField.removeClass('hidden');
			hideField.addClass('hidden');

			if (this.formIsRequired) {
				showField.find('input').prop('required', true).prop('aria-required', true);
				hideField.find('input').prop('required', false).prop('aria-required', false);
			}

			// store the option for later use, when evaluating the data
			this.useHouseName = isChecked;

			// clear the input values in the field to hide, so they won't be submitted with the form.
			hideField.find('input').val('').trigger('change');

			// if any of the data sets are empty, load the appropriate data set from the GAIA service for the type ahead list:
			if (this.zipCityValueCache) {
				if (this.useHouseName && dataCache.houseName.length === 0) {
					this.getData(this.zipCityValueCache.linkHouseName);
				}
				else if (!this.useHouseName && dataCache.streetName.length === 0) {
					this.getData(this.zipCityValueCache.linkStreetName);
				}
			}
		},
		/**
		 * Hides the type ahead list
		 */
		hideTypeAheadList: function () {
			if (!this.listHasFocus) {
				this.typeAheadList.addClass('hidden');
				this.typeAheadListUl.empty();
				this.listHasFocus = false;
			}
		},
		/**
		 * Figure out if the value has changed.
		 * @param $input
		 * @returns {boolean}
		 */
		inputValueChanged: function ($input) {
			var newFieldValue;

			if (this.isZipOrCity($input)) {
				newFieldValue = this.$zipInput.val() + ' ' + this.$cityInput.val();
			}
			else {
				newFieldValue = $input.val();
			}

			return $input.data('currentValue') !== newFieldValue;
		},
		/**
		 * Is the provided input field the zip or city field
		 * @param $input
		 * @returns {boolean}
		 */
		isZipOrCity: function ($input) {
			var fieldName = $input.attr('name');
			if (this.gaiaAdress) {
				return $input.attr('name') === this.$zipInput.attr('name') ||
					$input.attr('name') === this.$cityInput.attr('name');
			} else {
				return (fieldName === 'zip' || fieldName === 'city');
			}

		},
		/**
		 * moving the list to a input field
		 * @param input - the input field to move the list to
		 */
		moveListToField: function (input) {
			var field = input.closest('.field'),
				$sdxMessagePart = field.find('.sdx.message'),
				position = field.position(),
				positionTop = position.top + parseInt(field.innerHeight(), 10) - parseInt(input.css('margin-bottom'), 10) -
					parseInt($sdxMessagePart.length ? $sdxMessagePart.innerHeight() : 0, 10);

			this.typeAheadList.css({left: position.left, top: positionTop, minWidth: input.outerWidth()});

			// we only want to add scrollbar if the fields are in the order overlay
			if ($('.modOrderOverlay').length) {
				if (field.parent().hasClass('zip-and-city')) {
					this.typeAheadList.addClass('city-position').removeClass('street-position');
				}
				else if (field.parent().hasClass('street-and-nr')) {
					this.typeAheadList.addClass('street-position').removeClass('city-position');
				}
			}
		},
		/**
		 * Terrific event handler for the fillFormWithStorageData message.
		 * Prefills the form with data provided from storage data.
		 * @param data
		 */
		onFillFormWithStorageData: function (data) {
			if (!this.formAutoFilled) {
				if (data.nostreet && data.nostreet !== false) {
					this.$checkboxNoStreet.prop('checked', true).trigger('change');
				}

				for (var field in data) {
					if (field === 'nostreet') {
						continue;
					}
					var input = this['$' + field + 'Input'];
					if (input) {
						input.val(data[field]).trigger('change');
					}
				}

				this.setFieldAccess();
				this.formAutoFilled = true;
			}
		},
		/**
		 * Terrific event handler for the zipCityLoaded message
		 * Stores the zip and city data locally and removes the
		 * hover focus handler for this instance.
		 */
		onZipCityLoaded: function (data) {
			dataCache.zipCity = data.zipCity;
		},
		/**
		 * Terrific event handler for the zipCityStart message.
		 */
		onZipCityStart: function () {
			// another instance of this module already started loading the zip and city data
			// so we can remove the event listeners that would trigger the loading.
			this.removeFirstInteractionHandlers();
		},
		/**
		 * Removes the mouseenter and focus handlers
		 */
		removeFirstInteractionHandlers: function () {
			this.$ctx.off('mouseenter');
			this.$allAddressInputFields.off('focusin.AutoSuggestAddress');
		},
		/**
		 * Removes key listeners from a form field.
		 * @param $input
		 */
		removeKeyListeners: function ($input) {
			$input.off('input.AutoSuggestAddress');
			$input.off('keydown.AutoSuggestAddress');
		},
		/**
		 * Selecting the next or previous item in the currently open list
		 * @param selectNextItem - (boolean) - whether the go down or up in the list
		 */
		selectListItem: function (selectNextItem) {
			var selectedItem = this.typeAheadListItems.filter('.focus'),
				listLength = this.typeAheadListItems.length,
				step = (selectNextItem) ? 1 : -1,
				nextIndex;

			if (selectedItem.length) {
				nextIndex = (selectedItem.index() + step) % listLength;
			}
			else {
				nextIndex = (selectNextItem) ? 0 : -1;
			}

			this.typeAheadListItems.removeClass('focus');
			this.typeAheadListItems.eq(nextIndex).addClass('focus');

			if (!this.listHasFocus) {
				this.listHasFocus = true;
			}
		},
		/**
		 * Sets the access to the appropriate fields.
		 * if the zip or city doesn't have a value, it will disable the other fields.
		 */
		setFieldAccess: function () {
			if (this.$zipInput.val().length && this.$cityInput.val().length) {
				this.$houseNameInput.prop('disabled', false);
				this.$streetNameInput.prop('disabled', false);

				if (this.$streetNameInput.val().length) {
					this.$houseNumberInput.prop('disabled', false);
				} else {
					this.$houseNumberInput.prop('disabled', true);
					this.$houseNumberInput.val('').trigger('change');
				}
			}
			else {
				this.$streetNrAndHouseName.prop('disabled', true);
				this.$houseNameInput.prop('disabled', true);
				this.$streetNrAndHouseName.val('').trigger('change');
				this.$houseNameInput.val('').trigger('change');
			}
		},
		/**
		 * Add the unique address id to the form
		 * @param uniqueAddressId - unique address id as provided by GAIA
		 */
		setUniqueAddressId: function () {
			var field = (this.useHouseName) ? this.$houseNameInput : this.$houseNumberInput,
				filteredValues;
			// add unique address id to the form
			if (field.val()) {
				if (this.gaiaAdress) {
					if (this.useHouseName) {
						filteredValues = this.getFilteredList(dataCache.houseName, 'houseName', field.val(), true, true);
					} else {
						filteredValues = this.getFilteredList(dataCache.houseNumber, 'houseNumber', field.val(), true, true);
					}
				}
				else {
					filteredValues = this.getFilteredList(dataCache[field.attr('name')], field.attr('name'), field.val(), true, true);
				}

				if (filteredValues.length && filteredValues[0].hasOwnProperty('uniqueAddressId')) {
					this.$locationIdInput.val(filteredValues[0].uniqueAddressId);
					if(this.gaiaAdress) {
						this.$locationIdInput.prop('disabled', false);
					}
				}
				else {
					this.clearUniqueAddressId();
				}
			}
		},

		/**
		 * Shows a customized error Code based on the error status code
		 * Currently no UI is present to display the message to the user.
		 * @param statusCode
		 */
		showErrorMessage: function (statusCode) {
			var message = ERROR_MESSAGES[statusCode] || 'None';
			this.log('showErrorMessage :: Status Code: ' + statusCode + ' | Message: ' + message);
		},

		/**
		 * Displays the type ahead list
		 */
		showTypeAheadList: function () {
			if (this.activeField) {
				if ((!this.activeField.val() && this.typeAheadListItems.length >= 1) || (this.activeField.val() && this.typeAheadListItems.length)) {
					this.typeAheadList.removeClass('hidden');
				}
			}
		},

		/**
		 * Update the type-ahead list with new values
		 * @param $input
		 */
		updateList: function ($input) {
			var value = $input.val(),
				fieldName = $input.attr('name'),
				fieldMap = FIELD_MAPPINGS[fieldName],
				dataSet = dataCache[fieldMap.datakey],
				filteredSet = this.getFilteredList(dataSet, fieldMap.valuekey, value, fieldMap.matchStart, false, LIST_MAX_LENGTH),
				listHtml = this.templateCache[fieldMap.datakey](filteredSet);

			this.typeAheadListUl.html(listHtml);
			// cache list items
			this.typeAheadListItems = this.typeAheadListUl.find('li');
			if (fieldName === 'houseNumber' && filteredSet.length < 1) {
				this.valueSetFromListSelect = false;
				this.hideTypeAheadList();
			} else {
				this.showTypeAheadList();
			}
		}
	});

	// Guards execution of the named accessors against the specified guardProperty
	// (property must be falsy for the methods to be executed)
	function guardable(module, accessors, guardProperty) {
		module = module.prototype;
		module[guardProperty] = false;
		$.each(accessors, function (i, accessorName) {
			var orig = module[accessorName];
			var guard = function () {
				if (this[guardProperty]) {
					return;
				}
				return orig.apply(this, arguments);
			};
			guard.displayName = 'guard-' + (orig.displayName || orig.name);
			module[accessorName] = guard;
		});
	}

	guardable(
		Module.AutoSuggestAddress,
		[
			'handleNoStreet',
			'handleListItemSelected',
			'handleListFocus',
			'handleFirstInteraction',
			'handleInputFocusIn',
			'handleInputFocusOut',
			'handleAddressComplete',
			'handleKeyDown',
			'handleInput'
		],
		'disableAutosuggest'
	);


	Module.AutoSuggestAddress.FIELD_MAPPINGS = FIELD_MAPPINGS;
	if (false) {
		Module.AutoSuggestAddress.reset = function () {
			dataCache = {
				zipCity: [],
				streetName: [],
				houseNumber: [],
				houseName: []
			};
		};
	}

}(window.Tc.Module, __webpack_provided_window_dot_Tc_dot_$, window.doT));

}.call(window));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_Tc_dot_$) {/*** IMPORTS FROM imports-loader ***/
var loadTerrific = __webpack_require__(1);
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function (Module, $, doT) {
	'use strict';
	/*jshint smarttabs:false */
	/**
	 * Address with Type-Ahead uses the GAIA Webservice to
	 * render list of suggestions to the user using the address
	 * fields in this set.
	 *
	 * As the M@p Service will be removed from portal as of November 2016, pre-fill from
	 * M@p values has been removed from this component.
	 *
	 * @author Matthias Inauen
	 * @namespace Tc.Module.AutoSuggestAddress
	 * @class AutoSuggestAddress
	 * @decorator ZipAndCity
	 * @extends Tc.Module
	 *
	 * @terrificjs-channels    autosuggestaddress
	 * @fires zipCityLoaded, zipCityStart
	 * @handles onZipCityLoaded
	 */
	var FIELD_MAPPINGS = Module.AutoSuggestAddress.FIELD_MAPPINGS;
	var SWITZERLAND_COUNTRY_VALUES = ['ch', 'schweiz', 'switzerland', 'suisse', 'svizzera'];
	var LIECHTENSTEIN_COUNTRY_VALUES = ['li', 'liechtenstein'];

	Module.AutoSuggestAddress.ZipAndCity = function () {

		this.initComponent = function () {
			this.$zipInput = this.$ctx.find('.zip input');
			this.$cityInput = this.$ctx.find('.city input');

			this.$countryDropdown = this.$ctx.is('.withCountry') ? this.$ctx.find('.zipCountry > .country select') : $([]);
			if (this.$countryDropdown.length) {
				this.countryChanged();
			}

			this.$allAddressInputFields = this.$ctx.find('input').not('[type="hidden"]').not('input[readonly]');
		};

		this.cacheTemplates = function () {
			var zipFieldName, cityFieldName;

			zipFieldName = this.$zipInput.attr('name');
			cityFieldName = this.$cityInput.attr('name');

			FIELD_MAPPINGS[zipFieldName] = {datakey: 'zipCity', valuekey: 'zipCity', matchStart: true};
			FIELD_MAPPINGS[cityFieldName] = {datakey: 'zipCity', valuekey: 'zipCity', matchStart: false};

			this.templateCache[FIELD_MAPPINGS[zipFieldName].datakey] = doT.template(this.$ctx.find('script.tmpl-zipcity').html());
		};

		this.addEventListeners = function () {
			this.$ctx.on('mouseenter', $.proxy(this.handleFirstInteraction, this));
			this.typeAheadListUl.on('click', 'li:not(.nomatch)', $.proxy(this.handleListItemSelected, this));
			this.typeAheadList.on('mouseenter', $.proxy(this.handleListFocus, this));
			this.typeAheadList.on('mouseleave', $.proxy(this.handleListFocus, this));
			this.$allAddressInputFields.on('focusin', $.proxy(this.handleFirstInteraction, this));
			this.$allAddressInputFields.on('focusin', $.proxy(this.handleInputFocusIn, this));
			this.$allAddressInputFields.on('blur', $.proxy(this.handleInputFocusOut, this));

			this.$countryDropdown.on('change', $.proxy(this.countryChanged, this));
		};

		this.countryChanged = function (event) {
			var prevDisableAutosuggest = this.disableAutosuggest;
			var val = String(this.$countryDropdown.val()).toLowerCase();
			var isSwitzerland = $.inArray(val, SWITZERLAND_COUNTRY_VALUES) > -1;
			var isLiechtenstein = $.inArray(val, LIECHTENSTEIN_COUNTRY_VALUES) > -1;
			this.disableAutosuggest = !isSwitzerland && !isLiechtenstein;
			if (this.disableAutosuggest !== prevDisableAutosuggest) {
				// State change, remove previous values
				this.$zipInput.val('');
				this.$cityInput.val('');
			}
			if (isLiechtenstein && this.$zipInput.val() === '') {
				this.$zipInput.val('94');
			}
			if (event) {
				// Do not focus for the initial selection
				this.$zipInput.focus();
			}
		};

		// override, cause nothing has to be done here.
		this.setFieldAccess = $.noop;

		// there is only zip or city here.
		this.isZipOrCity = function () {
			return true;
		};

		this.formIsComplete = function () {
			return (this.$zipInput.val().length && this.$cityInput.val().length);
		};
	};
})(window.Tc.Module, __webpack_provided_window_dot_Tc_dot_$, window.doT);

}.call(window));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var loadTerrific = __webpack_require__(1);
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function ($, SCS) {
	/*
	 * Dependencies:
	 * TerrificJs 2.0.1,
	 * jQuery 1.7 or greater,
	 */

	'use strict';
	/*globals Tc */

	/**
	 * Captcha module implementation.
	 *
	 * @author Dimitri Sebeschuk
	 * @namespace Tc.Module
	 * @class Captcha
	 * @extends Tc.Module
	 */
	Tc.Module.Captcha = Tc.Module.extend({


		/**
		 * Hook function to do all of your module stuff.
		 *
		 * @method on
		 * @param {Function} callback function
		 * @return void
		 */
		on: function (callback) {
			SCS.captcha = SCS.captcha || {};

			if (!SCS.captcha.captchaHandler || typeof SCS.captcha.captchaHandler !== 'object') {
				SCS.captcha.captchaHandler = [];
			}

			SCS.captcha.captchaHandler.push([this, this.createCaptcha]);

			callback();
		},


		createCaptcha: function () {
			var mod = this,
				sitekey = mod.$ctx.data('sitekey'),
				theme = mod.$ctx.data('theme'),
				id = 'captchaContainer_' + mod.$ctx.data('uid');

			if (typeof grecaptcha === 'undefined') {
				//Show Exception
				debug.log('Tc.Module.Captcha -> createCaptcha: grecaptcha is not exists!');
				return;
			}

			grecaptcha.render(id, {
				'sitekey': sitekey,
				'theme': theme
			});

		}


	});

}(Tc.$, window.SCS));

}.call(window));

/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var loadTerrific = __webpack_require__(1);
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function ($, w) {
	/*
	 * Dependencies:
	 * TerrificJs 2.0.1,
	 * jQuery 1.7 or greater,
	 */

	'use strict';
	/*globals Tc */

	/**
	 * @Deprecated
	 *
	 * @author Yves De Bruyne
	 * @namespace Tc.Module
	 * @class C4PrintButton
	 * @extends Tc.Module
	 */
	Tc.Module.C4PrintButton = Tc.Module.extend({

		SERVLET_PATH: "/etc/swisscom/servlets/public/c4export.json",
		$link: null,
		$form: null,
		$randomToken: null,
		mappings: null,


		/**
		 * Hook function to do all of your module stuff.
		 *
		 * @method on
		 * @param {Function} callback function
		 * @return void
		 */
		on: function (callback) {
			var mod = this;

			mod.$link = mod.$ctx.find('a');
			mod.$form = mod.$ctx.closest('form');
			mod.mappings = mod.$link.data('mappings');
			
			mod.$randomToken = mod.$form.find('input[name="randomGeneratedToken"]');
			mod.$randomToken.val(Math.round(Math.random() * 1000000) + '' + new Date().getTime());
			
			if (!$('body').hasClass('cq_isEditMode')) {
				mod.$form.find('.modDownloadNRepPDF').css('visibility', 'hidden');
			}

			mod.$link.click(function () {
				mod.clickAction();
			});

			callback();
		},

		clickAction: function () {
			var mod = this,
				serializedData = mod.$form.serialize(),
				renamedSerializedData = Tc.Module.C4PrintButton.renameKeys(serializedData, mod.mappings);

			if(mod.$ctx.find('input[name="c4ExportType"]').val() == 'number_transfer'){
			
				$.ajax(mod.$form.attr('action'), {							
					type: 'POST',
					data: serializedData,
					dataType: 'json',
					success: $.proxy(mod.formSubmittedSuccess, mod),
					error: $.proxy(mod.formSubmittedError, mod)
				});
				
			} else {
				
				/* send data to C4 */
				$.ajax(mod.SERVLET_PATH, {
					success: $.proxy(mod.openC4Popup, mod),
					error: $.proxy(mod.printPage, mod),
					type: 'POST',
					data: renamedSerializedData
				});
				
			}

		},
		
		formSubmittedSuccess: function (data, textStatus, jqXHR) {
			var mod = this, 
				$ctx = mod.$ctx;
			
			if(data.hasOwnProperty('message') && data.message != null){
				mod.fireAjaxError(data.message);
			} else if(data.hasOwnProperty('data') && $.isArray(data.data) && data.data.length > 0) {
				mod.fireHandleError(data);
			} else {
			
				var serializedData = mod.$form.serialize();
				var renamedSerializedData = Tc.Module.C4PrintButton.renameKeys(serializedData, mod.mappings);
			
				/* send data to C4 */
				$.ajax(mod.SERVLET_PATH, {
					success: $.proxy(mod.openC4Popup, mod),
					error: $.proxy(mod.printPage, mod),
					type: 'POST',
					data: renamedSerializedData
				});			
			}
		},
		
		formSubmittedError: function (jqXHR, textStatus, errorThrown) {
			var mod = this, 
				$ctx = mod.$ctx;
				
			mod.fireAjaxError(JSON.parse(jqXHR.responseText).message);
		},
		
		fireAjaxError: function (msg) {
			var mod = this, 
				$ctx = mod.$ctx;

			mod.fire('ajaxError', {message: msg, title: mod.$ctx.data('generalErrorTitle')}, ['wizard']);
		},
		
		fireHandleError: function (data) {
			var mod = this, 
				$ctx = mod.$ctx;

			mod.fire('handleError', data, ['wizard']);
		},		

		openC4Popup: function (data, textStatus, jqXHR) {
			var mod = this, 
				$ctx = mod.$ctx;
				
			console.log('openC4Popup data=', data)
			if(data && data.url){
				var win = window.open(data.url, '_blank');
//				win.focus();
			}else{
				window.print();
			}
			
			if(mod.$ctx.find('input[name="c4ExportType"]').val() == 'number_transfer'){
				if(data && data.url){
					var $currentStep = mod.$ctx.closest('.multipage-wizard-step');
					mod.fire('preloadNextStepAndDisplay',{ stepUrl: mod.$ctx.data('success-page-url'), prevStep: $currentStep.prop('id')}, ['wizard']);
				} else {
					var $currentStep = mod.$ctx.closest('.multipage-wizard-step');
					mod.fire('preloadNextStepAndDisplay',{ stepUrl: mod.$ctx.data('error-page-url'), prevStep: $currentStep.prop('id')}, ['wizard']);
				}
			}
		},

		printPage: function (jqXHR, textStatus, errorThrown) {
			var mod = this, 
				$ctx = mod.$ctx;
			
			if(mod.$ctx.find('input[name="c4ExportType"]').val() == 'number_transfer'){
				var $currentStep = mod.$ctx.closest('.multipage-wizard-step');
				mod.fire('preloadNextStepAndDisplay',{ stepUrl: mod.$ctx.data('error-page-url'), prevStep: $currentStep.prop('id')}, ['wizard']);
			} else {
				window.print();
			}
		}
	});

	Tc.Module.C4PrintButton.renameKeys = function (serializedData, mappings) {

		for (var i = 0; i < mappings.length; i++) {
			var formKey = mappings[i].key,
				servletKey = mappings[i].value;

			var keyRegExp = new RegExp('(\\b|&)' + formKey + '=', 'g');

			serializedData = serializedData.replace(keyRegExp, '$1' + servletKey + '=');
		}

		//neutralize formstart
		serializedData = serializedData.replace(/(\b|&)%3Aformid=/g, '$1_formid=');
		serializedData = serializedData.replace(/(\b|&)%3Aformstart=/g, '$1_formstart=');
		serializedData = serializedData.replace(/(\b|&)%3Aformtype=/g, '$1_formtype=');

		return serializedData;
	}

}(Tc.$, window));
}.call(window));

/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_Tc_dot_$, jQuery) {/*** IMPORTS FROM imports-loader ***/
var loadTerrific = __webpack_require__(1);
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

/* globals jQuery, window, document */
/* exported jQuery, window, document */

var SdxSelect = __webpack_require__(18).default;
var zeroFill = __webpack_require__(4).zeroFill;

(function ($, Tc, debug, SCS, ScForm, scDate) {
	'use strict';

	/**
	 * Datepicker module implementation.
	 *
	 * @author Sebastian Bartels
	 * @namespace Tc.Module
	 * @class DatePicker
	 * @extends Tc.Module
	 */
	Tc.Module.DatePicker = Tc.Module.extend({

		on: function (callback) {
			/* jslint maxstatements: 40 */
			var i, mod = this,
				now = new Date(),
				$field = $('>.date-field', mod.$ctx),
				$input = $('input[type=text]', mod.$ctx);

			// container for time field options
			mod.$select = mod.$ctx.find('select');

			// option to enable time field (drop-down)
			mod.timeEnable = mod.$ctx.data('time-enable');
			// snap appointment dates to this value (in minutes, defaults to 30)
			mod.timeInterval = parseInt(mod.$ctx.data('time-interval') || 30, 10);
			// option to show time field values as from-to ranges in drop-down
			mod.showTimeInterval = mod.$ctx.data('show-time-interval') || false;
			mod.sdx = mod.$ctx.data('sdx') || false;
			if (mod.sdx && mod.$ctx.find('.time-container select').length) {
				mod.sdxSelect = new SdxSelect(mod.$ctx.find('.time-container select')[0]);
			}
			// config for SCS.utils.date
			mod.constraints = {
				// business hours
				day: {},
				week: [
					true, // sun
					true, // mon
					true, // tue
					true, // wed
					true, // thu
					true, // fri
					true  // sat
				],
				hours: [
					scDate.toHours(mod.$ctx.data('time-from') || 8),
					scDate.toHours(mod.$ctx.data('time-to') || 17)
				],
				// date constraints
				minDate: $input.data('enable-from'),
				maxDate: $input.data('enable-until'),
				// time constraints
				time: mod.timeEnable,
				refTimeField: mod.$select,
				interval: mod.timeInterval / 60,
				includeClosingTime: !mod.showTimeInterval
			};

			// upgrade for utils.date compatible config
			// create exclude days configuration (D.M[.Y])
			var exclDateDays = $input.data('exclude-days') || [];
			for (i = 0; i < exclDateDays.length; i += 1) {
				// normalize DD.MM.YYYY to D.M.Y (remove leading zeros)
				var dayDate = exclDateDays[i].replace(/(^|\.)0+/g, '$1');
				mod.constraints.day[dayDate] = false;
			}
			// create weekday configuration (weekday in java form)
			// get a list of weekdays to skip (start from 1 = sun)
			var exclWeekDays = $input.data('no-weekdays') || [];
			for (i = 0; i < exclWeekDays.length; i += 1) {
				mod.constraints.week[exclWeekDays[i] - 1] = false;
			}

			// Working block hours in old representation
			mod.timeFrom = mod.$ctx.data('time-from') || 8;
			mod.timeTo = mod.$ctx.data('time-to') || 17;

			// calculate the length of a working day
			mod.constraints.workDuration = scDate.toHours(mod.timeTo) -
				scDate.toHours(mod.timeFrom);

			// options to skip time in work blocks
			mod.constraints.wPeriod = scDate.toHours(
				mod.timeEnable ? mod.$ctx.data('time-available-from') : 0
			);

			// create a new client validation instance
			mod.cv = ScForm.createClientValidation({
				'constraintData': mod.constraints
			});

			// get options for client validation (twice in source?)
			var clientvalidation = $field.data('clientvalidation') || {};
			// upgrade client validation constraints config
			// be used by client validation `validateDate`
			clientvalidation.constraintData = mod.constraints;

			mod.isMobile = SCS.utils.isMobilePage();
			mod.isReadOnly = $input.attr('readonly');

			mod.showCurrentDate = $input.data('show-current-date');
			mod.$timeContainer = mod.$ctx.find('.time-container');

			// not used but seem valid - keep'em around for now
			// mod.defaultTime = mod.$select.data('default-value');

			if (!mod.isReadOnly) {
				this.addDatePicker();
			}

			// overwrite old value with current date
			// but preserve browser prefilled values
			if (mod.showCurrentDate && !$input.val()) {
				// sets date in format `DD.MM.YYYY`
				$input.val(scDate.format(now));
			}

			if (mod.timeEnable) {
				// attach change handler to update time drop-down
				var proxy = $.proxy(mod.onChangeHandler, mod);
				$input.on('change', proxy).trigger('change');
				// event trigger sometimes not working?
				// mod.onSelectListener($input.val());
			}
			else {
				mod.createTimes(null);
			}

			if (mod.sdx) {
				mod.$ctx.find('.date-icon.icon').on('click focus', function () {
					$input.datepicker('show');
				});
			}

			// $input.trigger('change');
			callback();
		},

		/**
		 * Create an array of appointments for the given date/day
		 * Optionally you may pass a minimal starting date/time
		 *
		 * @method initNewModules
		 * @param {Date} date - date to create appointments for
		 * @param {Array} workBlocks - list of start/end pairs
		 * @param {Minutes|int} interval - time delta next slot
		 * @param {Date} min - minimal start date (default: now)
		 * @returns {Array} list of possible appointments
		 */
		getAppointmentTimes: function (date, config) {

			// get list of open/close pairs for the specific day
			var workBlocks = scDate.getOpeningHours(date, this.cv.constraintData);

			// maybe we have some holiday?
			if (!workBlocks) { return []; }

			// do calculations after easy checks
			var now = config.now || new Date(),
				interval = config.interval || 0.5,
				inclusive = config.includeClosingTime,
				min = scDate.getMinDate(now, config);

			// compare the day parts of the date objects
			var cmpDays = scDate.compareDays(date, min);

			// no appointments in the past
			if (cmpDays < 0) { return []; }

			// set time to zero now to make all times available
			// only needed if min and date are on the same day
			var startTime = cmpDays ?
				0 : Math.max(
					scDate.toHours(min),
					scDate.toHours(date)
				);

			// create result array
			var appointments = [];

			for (var i = 0; i < workBlocks.length; i += 2) {
				// Note: values should already be in that form
				var blockStart = scDate.toHours(workBlocks[i + 0]),
					blockStop = scDate.toHours(workBlocks[i + 1]);
				// check if we should include the closing time
				if (!inclusive) { blockStop -= interval; }
				// Now loop through this workblock by given interval
				// The last block time was deliberately left out here
				for (var t = blockStart; t <= blockStop; t += interval) {
					// add everything after the startTime
					if (t >= startTime) { appointments.push(t * 60); }
				}
			}

			// return array now
			return appointments;

		},

		// create
		createTimes: function (date) {
			var mod = this;

			// Invalid input
			if (!date) {
				mod.disableTimeField();
				return;
			}
			if (mod.sdx) {
				mod.$select = mod.$ctx.find('.time-container select');
				mod.constraints.refTimeField = mod.$select;
			}


			// allow to pass a day date string
			// we are mostly called on input values
			date = scDate.parseDateDay(date);

			// helper function to create a drop-down option
			function createOption(name, value, selected) {
				// create an option and set mandatory options
				var option = jQuery('<OPTION>').val(value).html(name);
				// optionally set the selected attribute
				if (selected) { option.attr('selected', 'selected'); }
				// return dom node
				return option[0];
			}

			// helper to convert minutes to strings
			function minutesToString(minutes) {
				return [
					zeroFill(Math.floor(minutes / 60), 2),
					zeroFill(Math.floor(minutes) % 60, 2)
				].join(':');
			}

			var interval = mod.timeInterval;
			var config = mod.cv.constraintData;

			// get array of all available appointments that day
			var times = mod.getAppointmentTimes(date, config);

			// dom node store
			var options = [];

			// create a select dropdown
			if (times && times.length) {

				// get the text to put on top of the drop-down
				var slctTxt = mod.$select.data('please-select');
				var defaultVal = mod.$select.data('default-value');

				// create a first option to enable de-selecting
				if (slctTxt) { options.push(createOption(slctTxt, '')); }

				// create options for all available times
				for (var i = 0; i < times.length; i += 1) {
					// create main label for start time
					var txt = minutesToString(times[i]);
					// maybe show a `from - to` interval
					if (mod.showTimeInterval) {
						// append the stop time to show full range with label
						txt = [txt, minutesToString(times[i] + interval)].join(' - ');
					}
					// check if entry should be selected
					var val = minutesToString(times[i]),
						selected = (val == defaultVal);
					// append the final option to our array
					options.push(createOption(txt, val, selected));
				}
			}

			// clear and append the new options
			mod.$select.empty().append(options);

			if (mod.sdx && mod.sdxSelect) {
				mod.sdxSelect.reload();
			}

			// do some magic
			if (!mod.isMobile && !mod.sdx) {
				mod.$select.resetSS();
			}

			// enable/disable time field
			if (times && times.length) {
				mod.enableTimeField();
			} else {
				mod.disableTimeField();
			}

		},

		/**
		 * Disable the time drop-down
		 *
		 * @method disableTimeField
		 * @return void
		 */
		disableTimeField: function () {
			// add disabled class from container
			this.$timeContainer.addClass('disabled');
			// add disabled property from select
			this.$select.prop('disabled', true)
				// change selection to first entry
				.prop('selectedIndex', 0)
				// trigger a change event
				// informs enhanced select
				.trigger('change');
			if (this.sdx && this.sdxSelect) {
				this.sdxSelect.disabled = true;
			}
		},

		/**
		 * Enable the time drop-down
		 *
		 * @method enableTimeField
		 * @return void
		 */
		enableTimeField: function () {
			var mod = this;
			// remove disabled property from select
			this.$select.prop('disabled', false);
			// remove disabled class from container
			this.$timeContainer.removeClass('disabled');
			if (mod.sdx && mod.sdxSelect) {
				mod.sdxSelect.reload();
				mod.sdxSelect.disabled = false;
			} else if (!mod.isMobile && !mod.sdx) {
				mod.$select.resetSS();
			}
		},

		/**
		 * Initializes the jQuery UI DatePicker with default values from module.
		 *
		 * @method addDatePicker
		 * @return void
		 */
		addDatePicker: function () {
			var mod = this,
				$ctx = mod.$ctx,
				$input = $ctx.find('input'),
				yearTo = $input.data('year-to'),
				yearFrom = $input.data('year-from');

			yearTo = new Date(yearTo, 11, 31);
			yearFrom = new Date(yearFrom, 0, 1);
			debug.log('Tc.Module.DatePicker > addDatePicker', yearFrom, yearTo);

			// datapicker jquery plugin options
			var options = {
				firstDay: 1,
				maxDate: yearTo, // "+1m +7d",
				minDate: yearFrom, // "-1m -7d",
				yearRange: [
					yearFrom.getFullYear(),
					yearTo.getFullYear()
				].join(':'),
				dateFormat: 'dd.mm.yy',
				changeYear: $input.data('change-year'),
				changeMonth: $input.data('change-month'),
				beforeShowDay: function (date) {
					return [mod.cv.validateDay(date)];
				},
				onSelect: $.proxy(mod.onSelectListener, mod),
				buttonImage: $ctx.data('img-src'),
				buttonImageOnly: true
			};

			// mobile config
			if (mod.isMobile) {
				options.showOn = 'both';
				options.beforeShow = function (textbox, instance) {
					instance.dpDiv.css({
						marginTop: 10 + 'px'
					});
				};
				// Note: why only mobile?
				$input.data('role', 'date');
			}
			// desktop config
			else {
				options.showOn = 'button';
				options.beforeShow = function (textbox, instance) {
					instance.dpDiv.css({
						marginTop: 10 + 'px',
						marginLeft: textbox.offsetWidth - 155 + 'px'
					});
					if ($('.modSubtotal.sdxStyle').length) {
						instance.dpDiv.addClass('subTotalSpacer');
					}
				};
			}
			// instantiate jquery plugin
			$input.datepicker(options);
			if (mod.sdx) {
				mod.$ctx.find('.ui-datepicker-trigger').remove();
			}
		},

		onChangeHandler: function (event) {
			var element = $(event.currentTarget);
			this.onSelectListener(element.val());
		},

		onSelectListener: function (date) {
			var mod = this;
			if (!mod.timeEnable) {
				return;
			}
			if (!mod.cv.validate(date)) {
				mod.disableTimeField();
				return;
			}
			// update drop-down
			mod.createTimes(date);
		}

	});
})(__webpack_provided_window_dot_Tc_dot_$, window.Tc, window.debug, window.SCS = window.SCS || {}, window.ScForm = window.ScForm || {}, window.SCS.utils.date);

}.call(window));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0), __webpack_require__(0)))

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var loadTerrific = __webpack_require__(1);
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function($) {
	"use strict";
	/*globals Tc, doT, SCS */
	/*jshint smarttabs:true */
	/**
	 * Default module implementation.
	 *
	 * @author Rami Attallah
	 * @namespace Tc.Module.DropDownCascade
	 * @class DropDownCascade
	 * @extends Tc.Module
	 */
	Tc.Module.DropDownCascade = Tc.Module.extend({
		
		NO_CLIENT_VALIDATION: "{&quot;required&quot;:false,&quot;requiredMessage&quot;:&quot;&quot;,&quot;hasLengthValidation&quot;:false,&quot;minLength&quot;:0,&quot;maxLength&quot;:10000,&quot;lengthRegex&quot;:null,&quot;lengthMessage&quot;:&quot;&quot;,&quot;constraintRegex&quot;:null,&quot;constraintType&quot;:null,&quot;constraintMessage&quot;:&quot;&quot;,&quot;constraintData&quot;:{},&quot;foreignValidationModels&quot;:{},&quot;hasConstraint&quot;:false}",
		
		/**
		 * Initializes the Default module.
		 *
		 * @method init
		 * @constructor
		 * @param {jQuery} $ctx the jquery context
		 * @param {Sandbox} sandbox the sandbox to get the resources from
		 * @param {String} modId the unique module id
		 */
		init: function($ctx, sandbox, modId) {
			// call base constructor
			this._super($ctx, sandbox, modId);
		},

		/**
		 * Hook function to do all of your module stuff.
		 *
		 * @method on
		 * @param {Function} callback function
		 * @return void
		 */
		on: function(callback) {
            var mod = this;

            mod.changeDropDownHtml();
			callback();
		},
		
		changeDropDownHtml : function() {
			var mod = this;
			$.getJSON(mod.$ctx.data('json-url'), function(json) {
				var selects = mod.$ctx.find('select');
				var selectText = mod.$ctx.data('select-text');
			    var fillSelect = function ($this, parentJson) {
			        var i;
			        
			        $this.empty();
			        $this.append('<option value="">'+ selectText +'</option>');
			        for (i=0; i<parentJson.length; i++) {
			            var option = $('<option value="' + parentJson[i].name + '">' + parentJson[i].name + '</option>');
			            
			            option.data('json', parentJson[i].items);
			            $this.append(option);
			            $this.parent().show();
			        }
			        $this.resetSS();
			    };

			selects.parent().hide();
			selects.each(function() {
				var option = $(this).children('option:first');
				if(option.attr("value") == -1) {
					option.attr("value", "");
				}
			});
			selects.on('change', function () {
				var $this = $(this),
		        nextSelect = selects.eq(selects.index($this) + 1),
		        nextJson = $this.find("option:selected").data('json');

				if (nextSelect.length) {
					var selectBox = nextSelect.closest('.modSelectbox');
					if (nextJson && nextJson.length) {
						fillSelect(nextSelect, nextJson);
						
						if (selectBox && selectBox.data('clientvalidation-origin')) {
							selectBox.data('clientvalidation', selectBox.data('clientvalidation-origin'));
							selectBox.removeData('clientvalidation-origin');
						}
					} else {
						if(selectBox && !selectBox.data('clientvalidation-origin')){
							selectBox.data('clientvalidation-origin', selectBox.data('clientvalidation'));
							selectBox.data('clientvalidation', mod.NO_CLIENT_VALIDATION);
						}
						
						nextSelect.parent().hide();
						nextSelect.empty().trigger('change');
					}
				}
			});
			fillSelect(selects.first(), json);
			selects.resetSS();
			
			});
			
		}
		
	});
})(Tc.$);

}.call(window));

/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var loadTerrific = __webpack_require__(1);
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function($) {
	"use strict";
	/*globals Tc, doT, SCS */
	/*jshint smarttabs:true */
	/**
	 * Default module implementation.
	 *
	 * @author Igor Velickovic
	 * @namespace Tc.Module.DropDownCascadeRest
	 * @class DropDownCascadeRest
	 * @extends Tc.Module
	 */
	Tc.Module.DropDownCascadeRest = Tc.Module.extend({

		/**
		* Use dummy file
		*/
		testMode: false,
		testUrl: '/etc/designs/forms/resources/getProductList.json',

		url: null,
		json: null,

		categoryDropdown: null,
		subcategoryDropdown: null,
		productDropdown: null,

		/**
		 * Hook function to do all of your module stuff.
		 *
		 * @method on
		 * @param {Function} callback function
		 * @return void
		 */
		on: function(callback) {
            var mod = this;

            mod.url = mod.testMode ? mod.testUrl : mod.$ctx.data('json-url');
			debug.log('Tc.Module.DropDownCascadeRest > url', mod.url);

			var selects = mod.$ctx.find('select');
			mod.categoryDropdown = $(selects[0]);
			mod.subcategoryDropdown = $(selects[1]);
			mod.productDropdown = $(selects[2]);

			mod.subcategoryDropdown.parent().hide();
			mod.productDropdown.parent().hide();

			mod.categoryDropdown.on('change', function() {
				mod.populateSubcategory();
				mod.initBox(mod.productDropdown);
				mod.productDropdown.parent().hide();
				mod.populateFieldTranslation(mod.categoryDropdown);
				mod.populateFieldTranslation(mod.subcategoryDropdown);
                mod.populateFieldTranslation(mod.productDropdown);
			});

			mod.subcategoryDropdown.on('change', function() {
				mod.populateProduct();
				mod.populateFieldTranslation(mod.subcategoryDropdown);
				mod.populateFieldTranslation(mod.productDropdown);
			});

			mod.productDropdown.on('change', function() {
				mod.populateFieldTranslation(mod.productDropdown);
			});

			$.getJSON(mod.url, function(json) {
				debug.log('Tc.Module.DropDownCascadeRest > json', json);
				mod.json = json;
				mod.populateCategory();
			});

            //mod.changeDropDownHtml();
			callback();
		},

		initBox: function($elem) {
			var mod = this;
			$elem.empty();
			$elem.append('<option value="">'+ mod.$ctx.data('empty') +'</option>');
			$elem.resetSS();
		},

		populateCategory: function() {
			var mod = this;

			if (mod.json) {
				mod.initBox(mod.categoryDropdown);
				for (var i in mod.json) {
					var item = mod.json[i];
					debug.log('Tc.Module.DropDownCascadeRest > item', item);
					var name = mod.translationName(item.translations);
					var id = item.id;
					debug.log('Tc.Module.DropDownCascadeRest > categoryDropdown > id , name', id, name);
					var option = $('<option value="'+ id +'">'+ name +'</option>');
                    option.data('json', item.subCategoryItems);

					mod.categoryDropdown.append(option);
				}
				mod.categoryDropdown.resetSS();
			}
		},

		populateSubcategory: function() {
			var mod = this;

			var selected = mod.categoryDropdown.find("option:selected");
			debug.log('Tc.Module.DropDownCascadeRest > selected',selected.val());
			var json = selected.data('json');
			if (json){
				mod.initBox(mod.subcategoryDropdown);
				for (var j in json) {
					var item = json[j];
					var id = item.id;
					var name = mod.translationName(item.translations);
					debug.log('Tc.Module.DropDownCascadeRest > subcategoryDropdown > id , name', id, name);
					var option = $('<option value="'+ id +'">'+ name +'</option>');
					option.data('json', item.products);
					mod.subcategoryDropdown.append(option);
				}
				mod.subcategoryDropdown.resetSS();
			}

			mod.subcategoryDropdown.parent().show();
		},

		populateProduct: function() {
			var mod = this;

			var selected = mod.subcategoryDropdown.find("option:selected");
			debug.log('Tc.Module.DropDownCascadeRest > selected',selected.val());
			var json = selected.data('json');
			if (json){
				mod.initBox(mod.productDropdown);
				for (var j in json) {
					var item = json[j];
					var id = item.name;
					var name = mod.translationName(item.translations);
					debug.log('Tc.Module.DropDownCascadeRest > productDropdown > id , name', id, name);
					var option = $('<option value="'+ id +'">'+ name +'</option>');
					option.data('json', item.products);
					mod.productDropdown.append(option);
				}
				mod.productDropdown.resetSS();
			}
			mod.productDropdown.parent().show();
		},

		populateFieldTranslation: function(field) {
			var mod = this;
			var selected = field.find("option:selected");
			var hidden_name =  field.attr('name') + '_translation';
			var val = (selected.val() == '' || !field.parent().is(':visible')) ? '' : selected.text();
			mod.$ctx.find('[name='+ hidden_name +']').val(val);
		},

		translationName: function(translationArray) {
			var mod = this,
				name = '';
			for (var i in translationArray) {
				if (translationArray[i].language == mod.$ctx.data('lang')) {
					name = translationArray[i].translatedName;
				}
			}
			return name;
		}

		
	});
})(Tc.$);

}.call(window));

/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var loadTerrific = __webpack_require__(1);
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;


(function ($) {
    "use strict";
    /*globals Tc, doT, SCS, debug */
    /*jshint smarttabs:false */

    Tc.Module.DropdownPopulation = Tc.Module.extend({

        on: function (callback) {
            var $ctx = this.$ctx,
            	hashParams = window.location.hash.slice(1),
            	getParams = window.location.search.slice(1),
            	requestUrl = $ctx.data("ws-url").toLowerCase(),
            	useWebService = $ctx.data("use-ws"),
            	valueField = $ctx.data("ws-value-field"),
            	labelField = $ctx.data("ws-label-field"),
            	id = $ctx.data("ws-id");


            if( useWebService ) {
                debug.log("Tc.Module.DropdownPopulation > Use web service to populate dropdown");
                debug.log("Tc.Module.DropdownPopulation > Web service URL:", requestUrl);
                debug.log("Tc.Module.DropdownPopulation > Value field ", valueField);
                debug.log("Tc.Module.DropdownPopulation > Label field ", labelField);

				var paramMap = this.getParamMap(getParams, hashParams);

				$.each(paramMap, function(key, value) {
					debug.log("Tc.Module.DropdownPopulation > key, value ", key, value);
					requestUrl = requestUrl.replace("$"+key.toLowerCase(), value);
				});
                this.callWebService(requestUrl, valueField, labelField, id);
            }

            callback();
        },

		getParamMap: function(getParams, hashParams) {
			var params = getParams.split('&'),
			    hParam = hashParams.split('&'),
                paramMap = {};
                $.each(params, function(index, item) {
                    var parts = item.split('=');
                    if( parts.length == 2 ) {
                        paramMap[parts[0]] = parts[1];
                    }
                });
                $.each(hParam, function(index, item) {
                    var parts = item.split('=');
                    if( parts.length == 2 ) {
                        paramMap[parts[0]] = parts[1];
                    }
                });
            return paramMap;
		},

        callWebService: function(requestUrl, valueField, labelField, id) {

			$.ajax({
				dataType:"json",
			    url: requestUrl,
				success: function (data, status) {
	                debug.log('Tc.Module.DropdownPopulation > callWebService ', status);

	                if (status === 'success') {
	                    debug.log('Tc.Module.DropdownPopulation > initDropdown - receved data', data);
                        var selectDom = $("#" + id),
                                optionsValues = "";

                        if( Object.prototype.toString.call(data) === '[object Array]' ) {
	                        $.each(data, function(index,item) {
	                            if( item.hasOwnProperty(valueField) && item[valueField].length > 0 && item.hasOwnProperty(labelField) && item[labelField].length > 0 ) {
	                                optionsValues += '<option value="' + item[valueField] + '">' + item[labelField] + '</option>';
	                            }
	                        })
	                        debug.log('Tc.Module.DropdownPopulation > initDropdown', optionsValues);
	                        selectDom.html(optionsValues);
	                        selectDom.resetSS();
                        };
	                } else {
	                    debug.log('Tc.Module.DropdownPopulation > could not update', data);
	                }
	            }
			});
        }
    });
}(Tc.$, window));
}.call(window));

/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var loadTerrific = __webpack_require__(1);
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function ($, doT) {
	/*
	 * Dependencies:
	 * TerrificJs 2.0.1,
	 * jQuery 1.7 or greater,
	 */

	'use strict';
	/*globals Tc */
	var extReg = /^.*(\.[a-zA-Z0-9]*)$/;

	/**
	 * FileUpload module implementation.
	 *
	 * @author Renaldas Szentiks
	 * @namespace Tc.Module
	 * @class FileUpload
	 * @extends Tc.Module
	 */
	Tc.Module.FileUpload = Tc.Module.extend({
		/**
		 * Initializes the module.
		 *
		 * @method init
		 * @constructor
		 * @param {jQuery} $ctx the jquery context
		 * @param {Sandbox} sandbox the sandbox to get the resources from
		 * @param {String} modId the unique module id
		 */
		init: function ($ctx, sandbox, modId) {
			this._super($ctx, sandbox, modId);
			this.fileList = $('.fileList', this.$ctx);
			this.name = this.getUploadField().data('name');
			this.url = this.$ctx.data('url');
			this.SizeCalculator.init(this.$ctx.data('size-limit'), this.$ctx.data('file-size-limit'));
			this.generateLinks = this.$ctx.data('generate-links') === true || this.$ctx.data('generate-links') === 'true';
			this.actionProvider = this.$ctx.data('action-provider');
			this.maxUploadFiles = this.$ctx.data('max-uploads');
			this.noOfUploadedFiles = 0;
			var dataExt = this.$ctx.data('allowed-extensions');
			this.allowedExtensions = dataExt ? dataExt.split(', ') : [];
			this.sdxStyle = this.$ctx.data('sdx-style');
		},

		/**
		 * Hook function to do all of your module stuff.
		 *
		 * @method on
		 * @param {Function} callback function
		 * @return void
		 */
		on: function (callback) {
			this.getUploadField().on('change', $.proxy(this.changeHandler, this));
			this.getUploadField().on('prefill', $.proxy(this.prefillHandler, this));
			this.getUploadField().on('resetFiles', $.proxy(this.removeAllFilesHandler, this));
			this.getUploadField().on('click', this.checkMaxUploads.bind(this));
			this.$ctx.find('.upload-button').on('click', this.triggerUploadFieldClick.bind(this));

			if(this.sdxStyle) {
				this.$errorMessageHolder = this.$ctx.find('.error-message');
				this.getUploadField().on('click', this.hideErrorMessage.bind(this));

				this.preventErrorMessageHide = false;
				this.hideErrorMessage();
			}
			var $itemTmplContent = this.$ctx.find('script.tmpl-uploaded-element');
			this.itemTmpl = doT.template($itemTmplContent.html());
			this.uploadedFiles = [];
			callback();
		},

		after: function () {
			this.$ctx.trigger('randomFormToken', {action: 'generate', cb: $.proxy(this.onRandomFormToken, this)});
		},

		onRandomFormToken: function (data) {
			if (data && data.action === 'set') {
				this.randomFormToken = data.token;
			}
		},

		/**
		 * This function checks if the allowed number of uploads is reached. If
		 * maximum number of uploads is reach it prevents uploading new file.
		 *
		 * @method checkMaxUploads
		 * @return {Boolean}
		 */
		checkMaxUploads: function () {
			if (this.maxUploadFiles && this.noOfUploadedFiles >= this.maxUploadFiles) {
				this.showDialog('Error', this.$ctx.data('error-upload-limit').replace('{0}', this.maxUploadFiles));
				this.preventErrorMessageHide = true;
				return false;
			}
			return true;
		},

		/**
		 * This function adds information of uploaded files.
		 * These information are stored in `uploadedFiles` property which is array
		 * of objects that contains uploaded file path and uuid.
		 *
		 * @method addItemToUploadedFileList
		 * @param fileName {String} File name that is uploaded
		 * @param uuid {String} Uploaded file uuid
		 * @return void
		 */
		addItemToUploadedFileList: function (fileName, uuid) {
			this.uploadedFiles.push({
				fileName: fileName.toLowerCase(),
				uuid: uuid
			});
		},

		/**
		 * This function removes information of uploaded files.
		 * These information are stored in `uploadedFiles` property which is array
		 * of objects that contains uploaded file path and uuid.
		 *
		 * @method removeItemFromUploadedFileList
		 * @param uuid {String} Uploaded file uuid
		 * @return void
		 */
		removeItemFromUploadedFileList: function (uuid) {
			var mod = this;
			this.uploadedFiles.some(function (item, i) {
				if (item.uuid === uuid) {
					mod.uploadedFiles.splice(i, 1);
					return true;
				}
				return false;
			});
		},

		/**
		 * Check if file with given name is already loaded.
		 *
		 * @method checkIfFileIsUploaded
		 * @param fileName {String} File name that is uploaded
		 * @return {Boolean}
		 */
		checkIfFileIsUploaded: function (fileName) {
			return this.uploadedFiles.some(function (item) {
				return (item.fileName === fileName);
			});
		},

		/**
		 *
		 *
		 * @method getUploadFileName
		 * @param filepath {String} Path to the file that is uploaded
		 * @return {String} Upload file name with extension
		 */
		getUploadFileName: function (filepath) {
			return filepath.split('\\').pop().split('/').pop();
		},

		/**
		 * This function triggers click event on upload field.
		 *
		 * @method triggerUploadFieldClick
		 * @param {Event} evt Click event
		 * @return void
		 */
		triggerUploadFieldClick: function (evt) {
			if(evt) {
				evt.preventDefault();
				evt.stopPropagation();
			}
			this.getUploadField().click();
		},

		/**
		 * This function sets value of upload field to empty string.
		 *
		 * @method resetUploadField
		 * @return void
		 */
		resetUploadField: function () {
			this.getUploadField().val('');
		},

		/**
		 * This function displays error message.
		 *
		 * @method showErrorMessage
		 * @param {String} message Error mesage to be displayed
		 * @return void
		 */
		showErrorMessage: function (message) {
			this.$errorMessageHolder.removeClass('is-hidden');
			this.$errorMessageHolder.text(message);
		},

		/**
		 * This function hides error message.
		 *
		 * @method hideErrorMessage
		 * @return void
		 */
		hideErrorMessage: function () {
			if (!this.preventErrorMessageHide) {
				this.$errorMessageHolder.addClass('is-hidden');
				this.$errorMessageHolder.empty();
			} else {
				this.preventErrorMessageHide = false;
			}
		},

		getName: function () {
			return this.name;
		},

		getUrl: function () {
			return this.url;
		},

		getUploadField: function () {
			return $('input[type="file"]', this.$ctx);
		},

		showDialog: function (title, text) {
			if(this.sdxStyle) {
				this.showErrorMessage(text);
			} else {
				$('<div/>').attr('title', title).append(text).dialog();
			}
		},

		changeHandler: function (event) {
			if (event) {
				event.preventDefault();
			}
			var filePath = this.getUploadField().val();
			this.uploadFileName = this.getUploadFileName(filePath);
			if (filePath) {
				var fileExt = extReg.exec(this.uploadFileName);
				if(!fileExt || !fileExt[1]) {
					this.showDialog('Error', this.$ctx.data('error-missing-extension'));
					this.resetUploadField();
					return;
				}
				if(this.allowedExtensions.length && !this.allowedExtensions.some(function (ext) { return ext === fileExt[1].toLowerCase();})) {
					this.showDialog('Error', this.$ctx.data('error-wrong-extension').replace('{0}', fileExt[1]).replace('{1}', this.allowedExtensions.join(', ')));
					this.resetUploadField();
					return;
				}
				if(this.checkIfFileIsUploaded(this.uploadFileName.toLowerCase())) {
					this.showDialog('Error', this.$ctx.data('error-already-uploaded').replace('{0}', this.uploadFileName));
					this.resetUploadField();
					return;
				}
				this.uploadFile(this.getUploadField());
			}
		},

		prefillHandler: function (event, data) {
			if (data) {
				if (Array.isArray(data.items)) { // array of attachments
					this.noOfUploadedFiles = data.items.length;
					for (var i = 0; i < data.items.length; i += 1) {
						this.appendFileEntry(data.items[i]);
					}
				} else { // single attachment
					this.noOfUploadedFiles = 1;
					this.appendFileEntry(data);
				}
			}
		},

		uploadResponseHandler: function (response) {
			this.resetUploadField();
			if (response.success === true || response.success === 'true') {
				this.noOfUploadedFiles += 1;
				this.appendFileEntry(response.item);
				this.addItemToUploadedFileList(this.uploadFileName, response.item.uuid);
			} else {
				if (response.errorMessage) { // unknown error
					this.showDialog('Error', response.errorMessage);
				} else if (response.errorCode === '1' || response.errorCode === 1) { // file size too big
					this.showDialog('Error', this.$ctx.data('error-file-size-limit').replace('{0}', this.formatSize(this.SizeCalculator.getFileSizeLimit())));
				} else if (response.errorCode === '2' || response.errorCode === 2) { // empty file
					this.showDialog('Error', this.$ctx.data('error-file-empty'));
				}
			}
			this.uploadFileName = '';
		},

		appendFileEntry: function (data) {
			if (data && typeof data.uuid !== 'undefined') {
				var sizeStatus = this.SizeCalculator.add(data.size);
				if (sizeStatus.ok && sizeStatus.fileOk) {
					var name = data.fileName ? data.fileName : data.uuid,
						url = this.generateLinks ? this.getUrl() + '?uuid=' + data.uuid : '';
					var $uploadItem = $(this.itemTmpl({
						url: url,
						name: name,
						generateLinks: this.generateLinks,
						size: this.formatSize(data.size),
						uploadFieldName: this.getName(),
						uuid: data.uuid
					}));
					this.fileList.append($uploadItem);

					var removeIcon = $uploadItem.find('.remove-icon');
					removeIcon.on('click', {uuid: data.uuid, entry: $uploadItem}, this.removeFileHandler.bind(this));
				} else {
					this.SizeCalculator.remove(data.size);
					if (!sizeStatus.ok) {
						this.showDialog('Error', this.$ctx.data('error-size-limit').replace('{0}', this.formatSize(this.SizeCalculator.getSizeLimit())));
					} else {
						this.showDialog('Error', this.$ctx.data('error-file-size-limit').replace('{0}', this.formatSize(this.SizeCalculator.getFileSizeLimit())));
					}
				}
			}
		},

		formatSize: function (size) {
			if (size) {
				size = parseInt(size, 10);
				if (!isNaN(size) && size > 1024) {
					var suffix = 'kB';
					size = size / 1024;
					if (size >= 1024) {
						size = size / 1024;
						suffix = 'MB';
					}
					size = Math.round(size * 10) / 10;
					return size + suffix;
				} else {
					return '1kB';
				}
			}
			return '0kB';
		},

		removeAllFilesHandler: function () {
			this.noOfUploadedFiles = 0;
			this.uploadFileName = '';
			this.uploadedFiles = [];
			this.fileList.empty();
			if (this.sdxStyle) {
				this.hideErrorMessage();
			}
		},

		removeFileHandler: function (event) {
			if (event) {
				event.preventDefault();
			}
			var $this = this,
				uuid = event.data.uuid,
				listEntry = event.data.entry;

			listEntry.remove();
			this.noOfUploadedFiles -= 1;

			this.removeItemFromUploadedFileList(uuid);
			if (this.sdxStyle) {
				this.hideErrorMessage();
			}

			// response does not matter, since the hidden parameter is already
			// removed ant the attachment won't be connected to the form anymore
			$.ajax({
				type: 'POST',
				url: $this.getUrl(),
				cache: false,
				data: {
					uuid: uuid,
					randomToken: $this.randomFormToken
				}
			});
		},

		getFrameName: function () {
			return 'UploadFrame' + this.getName();
		},

		uploadFile: function (field) {
			this.prepareField(field);

			if (!this.frame) {
            	this.frame = $('#'+this.getFrameName());
            }

			// create iframe:
			if (this.frame) {
				this.frame.remove();
				this.frame = null;
			}
			this.frame = $('<iframe id="' + this.getFrameName() + '" name="' + this.getFrameName() + '" style="display: none">');
			$(document.body).append(this.frame);
			this.frame.on('load', $.proxy(this.loadHandler, this));

			var inputFieldName = $('<input>').attr('type', 'hidden').attr('name', 'fieldName').val(this.getName()),
				formTokenField = $('<input>').attr('type', 'hidden').attr('name', 'randomToken').val(this.randomFormToken),
				actionProviderField = $('<input>').attr('type', 'hidden').attr('name', 'actionProvider').val(this.actionProvider),
				charsetField = $('<input>').attr('type', 'hidden').attr('name', '_charset_').val('UTF-8'),
				formPathField = $('<input>').attr('type', 'hidden').attr('name', 'formPath').val(this.getFormParameter(':formstart'));

			// create form:
			if (this.form) {
				this.form.remove();
				this.form = null;
			}
			this.form = $('<form method="post" action="' + this.getUrl() + '" enctype="multipart/form-data" target="' + this.getFrameName() + '" style="display: none">');
			this.form.append(field);
			if (!this.form.html()) { // for IE8 and lower
				this.form = $('<form>').attr('method', 'post').attr('action', this.getUrl()).attr('enctype', 'multipart/form-data').attr('target', this.getFrameName()).attr('style', 'display: none');
				this.form.append(field);
			}
			this.form.append(inputFieldName).append(formTokenField).append(actionProviderField).append(formPathField).append(charsetField);

			$(document.body).append(this.form);

			this.form.submit();
		},

		getFormParameter: function (parameterName) {
			if (!this.currentForm) {
				this.currentForm = this.$ctx.parents('form');
			}
			return $('input[name="' + parameterName + '"]', this.currentForm).val();
		},

		prepareField: function (field) {
			this.originalFieldName = field.attr('name');
			if (!this.originalFieldPlaceholder) {
				this.originalFieldPlaceholder = $('<span style="display: none"/>');
				this.originalFieldPlaceholder.insertBefore(field);
			}
			this.originalField = field.attr('name', 'file').detach();
			this.showLoadingIndicator();
		},

		resetField: function () {
			this.originalField.attr('name', this.originalFieldName);
			this.showLoadingIndicator(false);
			this.originalField.clone(true).insertAfter(this.originalFieldPlaceholder);
		},

		showLoadingIndicator: function (show) {
			if (!this.loadingIndicator) {
				this.loadingIndicator = $('.js-loading-indicator', this.$ctx);
			}
			if (show === false) {
				this.loadingIndicator.hide();
			} else {
				this.loadingIndicator.show();
			}
		},

		loadHandler: function () {
			var content = this.frame.contents().find('#content');
			if (content.length > 0) {
				this.resetField();
				this.uploadResponseHandler(content.data('response'));
			}
		},

		/**
		 * Singleton for size limit for attachments in the whole form/page
		 */
		SizeCalculator: {
			init: function (limit, fileLimit) {
				if (!this.initialized) {
					this.initialized = true;
					this.sizeLimit = limit;
					if (!this.sizeLimit) {
						this.sizeLimit = -1;
					}
					this.fileSizeLimit = fileLimit;
					if (!this.fileSizeLimit) {
						this.fileSizeLimit = -1;
					}
					this.size = 0;
				}
			},

			getSizeLimit: function () {
				return this.sizeLimit;
			},

			getFileSizeLimit: function () {
				return this.fileSizeLimit;
			},

			add: function (size) {
				this.size += size;
				if (this.fileSizeLimit >= 0 && this.fileSizeLimit < size) {
					return this.getStatus(false, size - this.fileSizeLimit);
				}
				return this.getStatus();
			},

			remove: function (size) {
				this.size -= size;
				return this.getStatus();
			},

			getStatus: function (fileSizeStatusOk, fileOverhead) {
				var overhead = this.size - this.sizeLimit;
				fileOverhead = typeof fileOverhead === 'undefined' ? 0 : fileOverhead;
				fileSizeStatusOk = fileSizeStatusOk !== false ? true : false;
				if (this.sizeLimit >= 0 && overhead > 0) {
					return {
						ok: false,
						fileOk: fileSizeStatusOk,
						overhead: overhead,
						fileOverhead: fileOverhead
					};
				}
				return {
					ok: true,
					fileOk: fileSizeStatusOk,
					overhead: 0,
					fileOverhead: fileOverhead
				};
			}
		}
	});
}(Tc.$, window.doT));

}.call(window));

/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var loadTerrific = __webpack_require__(1);
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

var SdxProgressFull = __webpack_require__(278).default;

(function ($) {
	"use strict";
	/*globals Tc */

	/**
	 * FormStepIndicator module implementation.
	 *
	 * @author Thomas Junghans
	 * @namespace Tc.Module
	 * @class FormStepIndicator
	 * @extends Tc.Module
	 */
	Tc.Module.FormStepIndicator = Tc.Module.extend({

		/**
		 * Initializes the FormStepIndicator module.
		 *
		 * @method init
		 * @constructor
		 * @param {jQuery} $ctx the jquery context
		 * @param {Sandbox} sandbox the sandbox to get the resources from
		 * @param {String} modId the unique module id
		 */
		init: function ($ctx, sandbox, modId) {
			// call base constructor
			this._super($ctx, sandbox, modId);
		},

		MAXIMUM_MARKERS: 5,

		/**
		 * Hook function to do all of your module stuff.
		 *
		 * @method on
		 * @param {Function} callback function
		 * @return void
		 */
		on: function (callback) {
			var mod = this,
				$ctx = mod.$ctx,
				markerCount,
				containerWidth,
				connectorWidth,
				currentPosition,
				markerWidth,
				leftOffset,
				extendedConnectorWidth;

			mod.$marker = $ctx.find('div.marker');
			mod.$markerConnector = $ctx.find('div.marker-connector');

			markerCount = mod.$marker.length;
			containerWidth = $ctx.width();
			connectorWidth = mod.$markerConnector.filter(':first').width();
			currentPosition = $ctx.find('div.marker-active').filter(':last').index();

			markerWidth = mod.$marker.filter(':first').width();

			// Ignore 1 and maximum
			if (markerCount < mod.MAXIMUM_MARKERS && markerCount > 1) {
				leftOffset = (containerWidth - (markerCount * markerWidth)) / (markerCount - 1);
				extendedConnectorWidth = connectorWidth + leftOffset;

				mod.$markerConnector.width(extendedConnectorWidth);
				mod.$marker.not(':first').css('margin-left', leftOffset);
			}

			mod.setStepByIndex(currentPosition);

			// The link default action is not needed. Theoretically, if JavaScript would be deactivated, the step would be opened
			$ctx.on('click', 'a.marker-label', function (event) {
				event.preventDefault();
			});

			if (mod.$ctx.hasClass('progress-full')) {
				mod.progressFull = new SdxProgressFull(mod.$ctx[0]);
				mod.$ctx.find('button.indicator').attr('disabled', true);
			}

			callback();
		},

		setStepByIndex: function (index) {

			var mod = this,
				counter = index;

			mod.$marker.removeClass('marker-active finish finish-all');

			while (counter >= 0) {
				mod.$marker.eq(counter).addClass('marker-active').removeClass('finish');
				counter -= 1;
			}

			mod.setFinishStep(index);

			if (mod.progressFull) {
				mod.progressFull.value = index + 1;
			}

		},

		setFinishStep: function (index) {

			var mod = this,
				activeCount = mod.$ctx.find('.marker-active').length,
				totalCount = mod.$ctx.find('.marker-container').children().length;

			// If the same step with container (div)
			if (totalCount === activeCount) {
				mod.$ctx.find('.marker').last().addClass('finish-all').removeClass('.marker-active finish');
			}

			mod.$ctx.find('.marker-active').addClass('finish');
			mod.$ctx.find('.marker-active').last().removeClass('finish');
		},

		onStepChange: function (data) {
			if (isNaN(data.stepIndex)) {
				this.setStepByIndex(0);

			} else {
				this.setStepByIndex(data.stepIndex);
			}
		}
	});
}(Tc.$));
}.call(window));

/***/ }),
/* 278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["init"] = init;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Utils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Inputs__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DomElement__ = __webpack_require__(12);




var CLASS_HEADER = ".progress-full__bar";
var CLASS_SECTIONS = ".progress-full__sections > span";
var CLASS_SECTION_ACTIVE = "section--active";
var CLASS_INDICATOR = "indicator";
var CLASS_INDICATOR_CURRENT = "indicator--current";
var CLASS_INDICATOR_COMPLETED = "indicator--completed";
/**
 * Full progress bar component
 */
var ProgressFull = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */])(ProgressFull, _super);
    /**
     * Creates and initializes the ProgressFull component.
     * @param {DomElement} - The root element of the ProgressFull component.
     */
    function ProgressFull(element) {
        var _this = _super.call(this, element) || this;
        _this._initialize();
        return _this;
    }
    /**
     * Initializes the loader bar component.
     * @private
     */
    ProgressFull.prototype._initialize = function () {
        this._buttonClickHandler = this._handleButtonClick.bind(this);
        this._keydownHandler = this._handleKeydown.bind(this);
        this._headerElement = this.find(CLASS_HEADER);
        this._pages = this.element.querySelectorAll(CLASS_SECTIONS);
        this._minValue = 1;
        this._value = 1;
        this._total = this._pages.length;
        for (var index = 0; index < this._pages.length; index++) {
            if (this._pages[index].classList.contains(CLASS_SECTION_ACTIVE)) {
                this._value = index + 1;
            }
        }
        this._addIncicators();
        this._update(-1, this._value, false);
        // Apply the tab index
        var tabIndex = this.getAttribute("tabindex");
        if (tabIndex) {
            this.setAttribute("tabindex", "");
            this._headerElement.setAttribute("tabindex", tabIndex);
        }
        this._headerElement.element.addEventListener("click", this._buttonClickHandler);
        this._headerElement.element.addEventListener("keydown", this._keydownHandler);
    };
    ProgressFull.prototype._addIncicators = function () {
        for (var i = this._pages.length - 1; i >= 0; i--) {
            var indicatorElement = new __WEBPACK_IMPORTED_MODULE_3__DomElement__["a" /* default */]("button")
                .addClass(CLASS_INDICATOR)
                .setAttribute("data-value", "".concat(i + 1))
                .setHtml((i + 1).toString());
            this._headerElement.prependChild(indicatorElement);
        }
    };
    ProgressFull.prototype._update = function (oldValue, newValue, animate) {
        if (animate === void 0) { animate = true; }
        var indicators = this._headerElement.element.childNodes;
        for (var index = 0; index < indicators.length; index++) {
            var indicatorElement = new __WEBPACK_IMPORTED_MODULE_3__DomElement__["a" /* default */](indicators[index]);
            if (index + 1 < this._value) {
                indicatorElement
                    .removeClass(CLASS_INDICATOR_CURRENT)
                    .addClass(CLASS_INDICATOR_COMPLETED);
            }
            if (index + 1 === this._value) {
                indicatorElement
                    .removeClass(CLASS_INDICATOR_COMPLETED)
                    .addClass(CLASS_INDICATOR_CURRENT);
            }
            if (index + 1 > this._value) {
                indicatorElement
                    .removeClass(CLASS_INDICATOR_COMPLETED)
                    .removeClass(CLASS_INDICATOR_CURRENT);
            }
        }
        if (oldValue !== newValue) {
            var direction = Math.sign(oldValue - newValue);
            if (oldValue > 0 && oldValue !== newValue) {
                var oldSection_1 = new __WEBPACK_IMPORTED_MODULE_3__DomElement__["a" /* default */](this._pages[oldValue - 1]);
                if (animate) {
                    __WEBPACK_IMPORTED_MODULE_1__Utils__["a" /* animation */].start(oldSection_1.element, { left: "".concat(100 * direction, "px"), opacity: "0" }, 300, {
                        finished: function () {
                            oldSection_1.removeClass(CLASS_SECTION_ACTIVE);
                            oldSection_1.setAttribute("style", "");
                        },
                    });
                }
                else {
                    oldSection_1.removeClass(CLASS_SECTION_ACTIVE);
                    oldSection_1.setAttribute("style", "");
                }
            }
            var newSection_1 = new __WEBPACK_IMPORTED_MODULE_3__DomElement__["a" /* default */](this._pages[newValue - 1]);
            if (animate) {
                __WEBPACK_IMPORTED_MODULE_1__Utils__["a" /* animation */].set(newSection_1.element, {
                    left: "".concat(-100 * direction, "px"),
                    opacity: "0",
                });
                newSection_1.addClass(CLASS_SECTION_ACTIVE);
                __WEBPACK_IMPORTED_MODULE_1__Utils__["a" /* animation */].start(newSection_1.element, {
                    left: "0",
                    opacity: "1",
                }, 300, {
                    finished: function () {
                        newSection_1.setAttribute("style", "");
                    },
                });
            }
            else {
                newSection_1.addClass(CLASS_SECTION_ACTIVE);
                newSection_1.setAttribute("style", "");
            }
        }
    };
    ProgressFull.prototype._handleButtonClick = function (event) {
        var element = new __WEBPACK_IMPORTED_MODULE_3__DomElement__["a" /* default */](event.target);
        if (!element.hasClass(CLASS_INDICATOR)) {
            return;
        }
        var value = element.getAttribute("data-value");
        this.value = parseFloat(value);
    };
    ProgressFull.prototype._handleKeydown = function (event) {
        var keyboardEvent = event;
        var keycode = keyboardEvent.which || keyboardEvent.keyCode;
        if (keycode === __WEBPACK_IMPORTED_MODULE_2__Inputs__["c" /* KEY_ARROW_RIGHT */]) {
            this.value += 1;
            Object(__WEBPACK_IMPORTED_MODULE_1__Utils__["e" /* preventDefault */])(keyboardEvent);
            return;
        }
        if (keycode === __WEBPACK_IMPORTED_MODULE_2__Inputs__["b" /* KEY_ARROW_LEFT */]) {
            this.value -= 1;
            Object(__WEBPACK_IMPORTED_MODULE_1__Utils__["e" /* preventDefault */])(keyboardEvent);
            return;
        }
        if (keycode >= __WEBPACK_IMPORTED_MODULE_2__Inputs__["g" /* KEY_NR_0 */] && keycode <= __WEBPACK_IMPORTED_MODULE_2__Inputs__["h" /* KEY_NR_9 */]) {
            this.value = keycode - __WEBPACK_IMPORTED_MODULE_2__Inputs__["g" /* KEY_NR_0 */];
            Object(__WEBPACK_IMPORTED_MODULE_1__Utils__["e" /* preventDefault */])(keyboardEvent);
            return;
        }
    };
    Object.defineProperty(ProgressFull.prototype, "value", {
        /**
         * Gets the current progress value in the range of 1..total.
         */
        get: function () {
            return this._value;
        },
        /**
         * Sets the current progress.
         * @param {number} - The progress in the range of 1..total.
         */
        set: function (val) {
            var oldValue = this._value;
            this._value = Object(__WEBPACK_IMPORTED_MODULE_1__Utils__["b" /* clamp */])(val, this._minValue, this._total);
            this._update(oldValue, this._value, true);
            this.dispatchEvent("changed");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProgressFull.prototype, "total", {
        /**
         * Gets the total progress value.
         */
        get: function () {
            return this._total;
        },
        enumerable: false,
        configurable: true
    });
    return ProgressFull;
}(__WEBPACK_IMPORTED_MODULE_3__DomElement__["a" /* default */]));
function init() {
    Object(__WEBPACK_IMPORTED_MODULE_1__Utils__["h" /* searchAndInitialize */])(".progress-full", function (e) {
        new ProgressFull(e);
    });
}
/* harmony default export */ __webpack_exports__["default"] = (ProgressFull);


/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var loadTerrific = __webpack_require__(1);
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

// TODO: This needs reviewing - TJ, 11.9.2013
(function($) {
	"use strict";
	/*globals Tc, debug */
	/**
	 * Hidden component which values gets initialized by a GET query parameter.
	 *
	 * @author Stefan Maurer
	 * @namespace Tc.Module
	 * @class HiddenGetParameter
	 * @extends Tc.Module
	 */
	Tc.Module.HiddenGetParameter = Tc.Module.extend({

		/**
		 * Main hook.
		 *
		 * @method on
		 * @param {Function} callback function
		 * @return void
		 */
		on: function(callback) {
			var mod = this,
				$ctx = mod.$ctx,
				$input = $ctx.find('input'),
				paramName = $input.data('param');

			if (paramName !== undefined && paramName.length) {
				var regex = new RegExp(paramName + '=([^&]+)');
				var m = location.search.match(regex),
					getParamValue = m && m[1] && decodeURIComponent(m[1]);

				if (getParamValue !== null && getParamValue.length) {
					$input.val(getParamValue);
				}

				debug.log("Tc.Module.HiddenGetParameter > on", paramName, getParamValue);
			}

			callback();
		}

	});
})(Tc.$);

}.call(window));

/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_Tc_dot_$) {/*** IMPORTS FROM imports-loader ***/
var loadTerrific = __webpack_require__(1);
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function ($, Tc) {
	'use strict';

	/**
	 * MultiField module implementation.
	 *
	 * @author Renaldas Szentiks
	 * @namespace Tc.Module
	 * @class MultiField
	 * @extends Tc.Module
	 */
	Tc.Module.MultiField = Tc.Module.extend({

		on: function (callback) {
			this.$ctx.on('click', '.icon-close', $.proxy(this.onRemoveAction, this));
			$('.add-action', this.$ctx).on('click', $.proxy(this.onAddAction, this));
			this.$ctx.on('setValue', 'input', $.proxy(this.onSetValue, this));
			this.fieldCount = $('.multifield-container', this.$ctx).children('.inputField').length;
			this.container = $('.multifield-container', this.$ctx);
			this.fieldTemplate = this.getFieldTemplate();
			callback();
		},

		onRemoveAction: function(event) {
			var button = $(event.currentTarget),
				fieldContainer = button.parents('.inputField'),
				siblings = fieldContainer.siblings('.inputField');

			// if event was fired on the input field, delete the value
			if (button.attr('type') === 'text') {
				button.val('');
			}
			// does not allow to remove the last element
			if (siblings.length > 0) {
				fieldContainer.remove();
				if (siblings.length === 1) {
					siblings.find('.icon-close').addClass('hidden');
				}
			}
		},

		onAddAction: function() {
			var newField = this.fieldTemplate.clone(),
				inputField = newField.find('input');

			inputField.attr('id', inputField.attr('name') + '_' + this.fieldCount);
			this.fieldCount += 1;
			inputField.data('multifield', true);
			inputField.on('resetField', $.proxy(this.onRemoveAction, this));
			this.container.find('.add-action').before(newField);
			this.container.find('.icon-close').removeClass('hidden');
		},

		getFieldTemplate: function() {
			var newField = this.container.children('.inputField').first().clone(),
				inputField = newField.find('input');

			inputField.attr('id', inputField.attr('name'));
			inputField.val('');
			return newField;
		},

		onSetValue: function(event, data) {
			if (data) {
				if (data.value instanceof Array) {
					this.setRequiredNumberOfFields(data.value.length);
					$('input', this.$ctx).each(function(index){
						if (data.value.length > index) {
							$(this).val(data.value[index]);
						}
					});
				} else if (data.value) {
					this.setRequiredNumberOfFields(1);
					$('input', this.$ctx).val(data.value);
				}
			}
		},

		setRequiredNumberOfFields: function(num) {
			var difference,
				i;

			if (this.fieldCount > num && num > 1) {
				difference = this.fieldCount - num;
				for (i = 0; i < difference; i += 1) {
					$('.icon-close', this.$ctx).first().trigger('click');
				}
			} else if (this.fieldCount < num) {
				difference = num - this.fieldCount;
				for (i = 0; i < difference; i += 1) {
					this.onAddAction();
				}
			}
		}
	});
}(__webpack_provided_window_dot_Tc_dot_$, window.Tc));

}.call(window));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_Tc_dot_$) {/*** IMPORTS FROM imports-loader ***/
var loadTerrific = __webpack_require__(1);
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function ($, Tc, ScForm, debug, SCS) {
	/*
	 * Dependencies:
	 * TerrificJs 2.0.1,
	 * jQuery 1.7 or greater,
	 * jquery.placeholder.min.js,
	 *
	 * ScForm.ValidationReturn.js,
	 * ScForm.ClientValidation.js,
	 * ScForm.InvalidField.js
	 */

	'use strict';

	/* globals require, visitor */
	/* jshint maxdepth: 7 */
	/* jshint maxstatements: 39 */

	/* shared by all instances */
	var synchronizedForms = null,
		synchronizedGroups = {};

	var replacePlaceholders = __webpack_require__(31).replacePlaceholders;

	function escapeRegExp(string) {
		return string.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, "\\$1");
	}

	/**
	 * ScForm module implementation.
	 *
	 * @author Thomas Junghans
	 * @namespace Tc.Module
	 * @class ScForm
	 * @extends Tc.Module
	 */
	Tc.Module.ScForm = Tc.Module.extend({

		//CONSTS
		TPL_PREFIX: '${',
		TPL_SUFFIX: '}',
		TPL_ESCAPED_PREFIX: '$%7B',
		TPL_ESCAPED_SUFFIX: '%7D',
		TEMPLATE_TYPE_HELP_WIDGET: 'Portal Contact-Widget Page',
		TPL_MAP_CUSTOMER_DETAILS_PREFIX: 'customerDetails_',

		//FIELDS
		enableValidationScrolling: true,

		/**
		 * Initializes the module.
		 *
		 * @method init
		 * @constructor
		 * @param {jQuery} $ctx the jquery context
		 * @param {Sandbox} sandbox the sandbox to get the resources from
		 * @param {String} modId the unique module id
		 */
		init: function ($ctx, sandbox, modId) {

			this.$form = null;

			this.checkboxGroupSelector = '.field[role="group"]';
			this.checkboxSelector = '.custom-checkbox input:checkbox';
			this.selectSelector = '.field select';
			this.radioGroupSelector = '.field[role="radiogroup"]';
			this.radioSelector = '.custom-radio input:radio';
			this.summarySelector = '.scs-form-summary';
			this.saveButtonSelector = '.multipage-save-button';
			this.cancelButtonSelector = '.multipage-cancel-button';
			this.forwardButtonSelector = '.multipage-forward-button';
			this.allInputFieldsSelector = 'input,textarea,select';
			this.formIdSelector = 'input[name=":formid"]';
			this.formStartSelector = 'input[name=":formstart"]';

			// Because FF is auto decoding location.hash string, we are splitting the location.href to achieve same effect
			// https://bugzilla.mozilla.org/show_bug.cgi?id=483304
			this.locationHash = location.href.split('#')[1];


			/**
			 * Holds array of InvalidField
			 *
			 * @property invalidFields
			 * @type {Array<InvalidField>}
			 */
			this.invalidFields = [];
			this.placeholdersData = {};

			//Data from M@P service
			this.mapJson = null;

			/**
			 * Holds qtip options. See http://craigsworks.com/projects/qtip2/docs/
			 *
			 * @property qtipConfig
			 * @type {{position: {my: string, at: string, viewport: (*|HTMLElement), adjust: {x: number, y: number}},
			 *		hide: {fixed: boolean}, content: {title: boolean, text: Function}, show: {event: string}, style: {classes: string}}}
			 */
			this.qtipConfig = QTIP_CONFIG; // Moved this out of init, to the bottom of this file. Not 100% about this convention, but at least it now only gets processed once.

			// call base constructor
			this._super($ctx, sandbox, modId);
		},

		/**
		 * Hook function to do all of your module stuff.
		 *
		 * @method on
		 * @param {Function} callback function
		 * @return void
		 */
		on: function (callback) {
			var mod = this;
			mod.$ctx.on('randomFormToken', $.proxy(this.onRandomFormToken, this));
			mod.isMobile = SCS.utils.isMobilePage();

			this.formTag = this.$ctx[0].tagName === 'FORM' ? this.$ctx : $('form', this.$ctx);

			mod.initApi();

			// Only execute custom styles on desktop because jquery ui runs on mobile
			if (!SCS.utils.isMobilePage()) {
				mod.$ctx.find('select.customDropDown').sSelect();
			}

			mod.placeholdersData = {
				'ecVisitorId': typeof visitor === 'object' ? visitor.getMarketingCloudVisitorID() : ''
			};

			// 1. Set global properties
			mod.$form = mod.$ctx.find('form:first');
			mod.$stageMobile = mod.$ctx.closest('div.stageMobile');
			mod.formIdEl = mod.$ctx.find(mod.formIdSelector);
			mod.formId = (typeof mod.formIdEl != 'undefined' && mod.formIdEl.length) ? mod.formIdEl.val() : '';
			mod.formStartEl = mod.$ctx.find(mod.formStartSelector);
			mod.formStart = (typeof mod.formStartEl != 'undefined' && mod.formStartEl.length) ? mod.formStartEl.val() : '';

			// 2. Bind events
			mod.$form.on('submit', $.proxy(mod.formSubmitHandler, mod));

			mod.$ctx.on('formerror', $.proxy(mod.formErrorHandler, mod));

			mod.$ctx.one('formFieldsChanged', $.proxy(mod.prefillFormData, mod));

			mod.$ctx.on('change', mod.radioSelector, $.proxy(mod.radioSelectHandler, mod));

			// Need this for validation of radio groups
			mod.$ctx.on('valuechange', mod.radioGroupSelector, function (event, el) {
				var $group = $(el).closest(mod.radioGroupSelector),
					selected = $group.find('input:radio:checked').length;

				$group.data('selected', selected);
			});

			// Does not work on click in webkit
			mod.$ctx.on('focus', mod.radioSelector, function () {
				var $chkbox = $(this);

				$chkbox.parent().find('label[for="' + $chkbox.attr('id') + '"]').addClass('focus');
			});

			// Does not work when clicking away in webkit
			mod.$ctx.on('blur', mod.radioSelector, function () {
				var $chkbox = $(this);

				$chkbox.parent().find('label[for="' + $chkbox.attr('id') + '"]').removeClass('focus');
			});

			// Does not work on click in webkit
			mod.$ctx.on('focus', mod.checkboxSelector, function () {
				var $chkbox = $(this);

				$chkbox.parent().find('label[for="' + $chkbox.attr('id') + '"]').addClass('focus');
			});

			// Does not work when clicking away in webkit
			mod.$ctx.on('blur', mod.checkboxSelector, function () {
				var $chkbox = $(this);

				$chkbox.parent().find('label[for="' + $chkbox.attr('id') + '"]').removeClass('focus');
			});

			mod.$ctx.on('change', mod.selectSelector, $.proxy(mod.selectChangeHandler, mod));

			mod.$ctx.on('change', mod.checkboxSelector, $.proxy(mod.checkboxClickHandler, mod));

			// Need this for validation of checkbox groups
			mod.$ctx.on('valuechange', mod.checkboxGroupSelector, function (event, el) {
				var $group = $(el).closest(mod.checkboxGroupSelector),
					selected = $group.find('input:checkbox:checked').length;
				$group.data('selected', selected);
			});

			mod.$ctx.on('click', mod.saveButtonSelector, $.proxy(mod.clickSaveHandler, mod));
			mod.$ctx.on('click', mod.cancelButtonSelector, $.proxy(mod.clickCancelHandler, mod));
			mod.$ctx.on('click', mod.forwardButtonSelector, $.proxy(mod.clickForwardHandler, mod));

			$('.scs-form-summary a[href*="${"]', mod.$ctx).each(function () {
				var href = $(this).attr('href');
				href = href.replace(/\${/g, '__FIELDNAME__');
				href = href.replace(/}/g, '__');
				$(this).attr('data-url-with-placeholder', href);
			});

			mod.$ctx.on('click', 'a[data-url-with-placeholder]', $.proxy(mod.clickLinkWithPlaceholder, mod));

			// 3. Preparation
			mod.initForm();

			// 4. Get data from M@P for logged-in user (if any)
			if (mod.formApi.loadsMapData()) {
				mod.getDataFromMap(mod.$ctx.data('map-url'));
			}

			var numberOfPixelsToMoveFocus = mod.$ctx.data('number-of-pixels-to-move-focus');
			if (numberOfPixelsToMoveFocus) {
				mod.scrollToForm(numberOfPixelsToMoveFocus, 2000);
				// Due to lazy loading of images on publish instances, we need second call to recalculate positions
				setTimeout(function () {
					mod.scrollToForm(numberOfPixelsToMoveFocus, 500);
				}, 2500);
			}

			callback();
		},

		scrollToForm: function (numberOfPixelsToMoveFocus, scrollTime) {
			var mod = this;
			if (mod.$ctx.find('.headingError.server-side').length) {
				$('html, body').stop(true, true).animate({
					scrollTop: mod.$ctx.find('.headingError.server-side').offset().top + numberOfPixelsToMoveFocus
				}, scrollTime);
			} else if (!mod.$ctx.children('form').length) {
				$('html, body').stop(true, true).animate({
					scrollTop: mod.$ctx.offset().top + numberOfPixelsToMoveFocus
				}, scrollTime);
			}
		},

		//Fill mapJson and call callback function
		getDataFromMap: function (mapUrl) {
			var mod = this;
			__webpack_require__(5)
				.getProfile()
				.then(function (profile) {
					if (!!profile.getUser()) {
						mod.mapDataCall = $.ajax({
							url: mapUrl,
							type: 'get',
							dataType: 'json'
						});
						return mod.mapDataCall;
					} else {
						return Promise.reject();
					}
				})
				.then(function (json) {
					mod.mapDataCall = null;
					if (json) {
						mod.mapJson = {};
						for (var key in json) {
							if (json.hasOwnProperty(key)) {
								mod.mapJson[mod.TPL_MAP_CUSTOMER_DETAILS_PREFIX + key] = json[key];
							}
						}
						mod.setPrefillFormDataFromMap();
					}
				})
				.catch(function (err) {
					if (err) {
						mod.mapDataCall = null;
						debug.log('get M@P data failed', err.responseText);
					}
					mod.$ctx.trigger('MapDataPrefilFailed');
				});
		},

		onRandomFormToken: function (event, data) {
			var mod = this;
			if (data && data.action === 'generate' && !this.randomFormTokenInProgress) {
				this.randomFormTokenInProgress = true;
				if (!this.randomFormToken) {
					this.randomFormToken = Math.round(Math.random() * 100000) + '' + new Date().getTime();
					this.setFieldValue('randomToken', this.randomFormToken, true);
				}
				data.cb({action: 'set', token: mod.randomFormToken});
				this.randomFormTokenInProgress = false;
			}
		},

		initApi: function () {
			var mod = this;

			mod.formApi = {

				/**
				 * Use for reinitializing the form. Elements that have already been initialized will be ignored.
				 */
				reInit: function () {
					mod.initForm();
					mod.prefillFormData();
				},

				/**
				 * Returns true the number of invalid fields is greater than 0, without showing the errors on the form
				 * @returns {boolean}
				 */
				isFormValid: function () {
					mod.resetInvalidFields();
					return mod.checkFieldValidation() === 0;
				},

				/**
				 * Sets everything back to 0 and removes all errors
				 */
				resetValidation: function () {
					mod.resetFormValidation();
				},

				resetValidationContext: function () {
					delete mod.$validationContext;
				},

				/**
				 * Set a context to only validate a part of a form
				 * @param $validationContext
				 */
				setValidationContext: function ($validationContext) {
					mod.$validationContext = $validationContext;
				},

				/**
				 * Checks form validation, marks errors and returns the number of invalid fields
				 * @returns {Number}
				 */
				validateForm: function (context) {
					mod.resetFormValidation();

					var invalidFields = mod.checkFieldValidation(context);

					if (invalidFields > 0) {
						mod.$ctx.trigger('formerror');
					}

					this.resetValidationContext();


					return invalidFields;
				},

				updateSummaries: function () {
					mod.updateSummaries();
				},

				executeSpecialButtonHandlers: function (execute) {
					mod.executeSpecialButtonHandlers = execute;
				},

				getReferrerButton: function () {
					return mod.getReferrerButton();
				},

				submit: function () {
					mod.$form.submit();
				},

				setEnableValidationScrolling: function (enableValidationScrolling) {
					mod.enableValidationScrolling = enableValidationScrolling;
				},

				renderPopupMessage: function (errorMessage, errorTitle) {
					if (!SCS.utils.isMobilePage()) {
						$('<div/>').attr('title', errorTitle || "").text(errorMessage).dialog();
					} else {
						var $popupMessage = $('<div id="ajaxErrorPopup" data-role="popup"></div>').append((errorTitle ? ('<h3>' + errorTitle + '</h3>') : '') + '<p>' + errorMessage + '</p>');
						$popupMessage.appendTo('body');
						$popupMessage.popup().popup('open');
						$popupMessage.on('popupafterclose', function () {
							$popupMessage.popup('destroy');
							$popupMessage.remove();
						});
					}
				},

				loadsMapData: function () {
					return mod.$ctx.data('enable-map') &&
						mod.$ctx.data('map-url') &&
						mod.mapDataCall !== 'cancelled';
				},

				cancelMapDataCall: function () {
					if (mod.mapDataCall && mod.mapDataCall.abort) {
						mod.mapDataCall.abort();
					}
					mod.mapDataCall = 'cancelled';
				},

				onFormValidate: function (callback) {
					mod.resetFormValidation();

					var invalidFields = mod.checkFieldValidation(callback);

					if (invalidFields > 0) {
						mod.$ctx.trigger('formerror');
					} else {
						callback();
					}
				}
			};

			// Module API
			mod.$ctx.data('form-api', mod.formApi);
			// Alias as plain 'api' for backwards-compatibility
			mod.$ctx.data('api', mod.formApi);
		},

		initForm: function () {
			var mod = this;
			mod.prefillData = undefined;
			mod.setupInputs();
			mod.setUpCheckboxes();
			mod.setupCheckboxGroups();
			mod.setUpRadios();
			mod.setupRadioGroups();
			mod.setUpSelects();
			mod.setupToolTip();
			mod.initSummary();
			mod.initPlaceholderFields();

			mod.setUpRadiosInitIE();
		},

		initPlaceholderFields: function () {
			var mod = this,
				$ctx = mod.$ctx;

			$('[type="hidden"]', $ctx).each(function () {
				var $input = $(this),
					placeholderValue = $input.data('placeholder-value') || '';

				if (placeholderValue) {
					var value = replacePlaceholders(placeholderValue, mod.placeholdersData);
					if (value) {
						$input.val(value);
					}
				}
			});
		},

		autoSubmit: function () {
			var mod = this,
				$ctx = mod.$ctx;

			if ($ctx.data('auto-submit')) {
				// Check field validation requirements
				var numberOfInvalidFields = mod.checkFieldValidation('submit');
				if (numberOfInvalidFields > 0) {
					mod.$ctx.trigger('formerror');
					mod.$form.removeClass('hidden');
					$ctx.find('.loader').addClass('hidden');
				} else {
					// Submit form
					$.ajax({
						type: "POST",
						url: $ctx.find('form').attr('action'),
						data: $ctx.find('form').serialize() + '&auto-submit=true',
						dataType: 'html',
						success: function (response) {
							if (response && response.length) {
								$ctx.replaceWith(response);
							}
						},
						error: function () {
							debug.log("Tc.Module.ScForm > auto submit action failed, POST request error");
							mod.$form.removeClass('hidden');
							$ctx.find('.loader').addClass('hidden');
						}
					});
				}
			}
		},

		after: function () {
			var mod = this,
				$ctx = mod.$ctx,
				prefillUrl = $ctx.data('prefill-url');

			this.prefillFormData();

			if (mod.$ctx.data('formSynchronization')) {
				var groupId = mod.$ctx.data('formSynchronizationId');
				// get a list of all synchronized forms and cache the result (only query once)
				if (typeof synchronizedForms === 'undefined' || !synchronizedForms) {
					synchronizedForms = $('.modScForm[data-form-synchronization="true"]');
				}
				// collect the group members of this synchronized forms group (only query once)
				if (typeof synchronizedGroups[groupId] === 'undefined' || !synchronizedGroups[groupId]) {
					var groupFilter = function () {
						return $(this).data('formSynchronizationId') === groupId;
					};
					synchronizedGroups[groupId] = synchronizedForms.filter(groupFilter);
				}
				// change event still needed here for ie. radio buttons and other "unaware" components
				mod.$ctx.on('change', mod.allInputFieldsSelector, $.proxy(mod.synchValueChangedHandler, mod));
			}

			if (!prefillUrl) {
				mod.autoSubmit();
			}
		},

		doExecuteSpecialButtonHandlers: function () {
			return this.executeSpecialButtonHandlers === undefined || this.executeSpecialButtonHandlers;
		},

		/**
		 * Returns collection of input field with html attribute "data-clientvalidation"
		 *
		 * @returns {*|HTMLElement}
		 */
		getFieldsWithValidation: function () {
			var mod = this,
				$ctx = this.$ctx;

			if (mod.$validationContext && mod.$validationContext.length > 0) {
				$ctx = mod.$validationContext;
			}

			return $ctx.find('.field[data-clientvalidation]').filter(function () {
				return !$(this).data('do-not-validate');
			});

		},

		setUpCheckboxes: function () {
			var mod = this;
			mod.$ctx.find('.custom-checkbox input:checkbox').each($.proxy(mod.setCustomInputCheckbox, mod));
		},

		setupInputs: function () {
			this.$ctx.find('input, textarea').placeholder();
		},

		setUpRadios: function () {
			var mod = this;
			mod.$ctx.find('.custom-radio input:radio').each($.proxy(mod.setCustomInputRadio, mod));
		},
		setUpRadiosInitIE: function () {
			// check if ie
			if (window.navigator.userAgent.indexOf('MSIE ') > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {
				var mod = this;
				mod.$ctx.find('.custom-radio input:radio').each($.proxy(mod.setCustomInputRadioInitIE, mod));
			}
		},

		setUpSelects: function () {
			var mod = this;
			mod.$ctx.find('.modSelectbox select').each($.proxy(mod.setCustomSelect, mod));
		},

		setUpFieldsWithValidation: function () {
			var mod = this;

			mod.getFieldsWithValidation().each(function () {
				var $this = $(this);

				// Create new instance of ClientValidation for easier handling and store as data on element
				$this.data('clientvalidationInstance', ScForm.createClientValidation($this.data('clientvalidation'), mod.$ctx));
			});
		},

		/**
		 * Takes the name of an input:radio group and sets their custom styles according to the input select state.
		 *
		 * @method setInputRadioByName
		 * @param {String} name
		 */
		setInputRadioByName: function (name) {
			var mod = this;

			mod.$ctx.find('input:radio[name="' + name + '"]').each($.proxy(mod.setCustomInputRadio, mod));

			return mod;
		},

		/**
		 * This function is called on init and every time a radio is selected
		 *
		 * @method setCustomInputRadio
		 * @param {Number} index (optional)
		 * @param {Node} domElem
		 * @returns {Tc.Module.ScForm}
		 */
		setCustomInputRadio: function (index, domElem) {
			var mod = this,
				$radio = $(domElem);

			if ($radio.is(':radio')) {
				$radio.parent()
					.find('label[for="' + $radio.attr('id') + '"]')
					.toggleClass('checked', $radio[0].checked);
				this.setCustomInputSelectionHiddenLabel($radio);
			}
			return mod;
		},

		/**
		 * This function is called on init
		 *
		 * @method setCustomInputRadio
		 * @param {Number} index (optional)
		 * @param {Node} domElem
		 * @returns {Tc.Module.ScForm}
		 */
		setCustomInputRadioInitIE: function (index, domElem) {
			var mod = this,
				$radio = $(domElem);

			if ($radio.is(':radio')) {
				var labelTag = $radio.parent().find('label[for="' + $radio.attr('id') + '"]');

				// Quickfix for IE that messes up clickable elements/the render tree when loaded..
				// touching DOM elements helps..
				setTimeout(function () {
					labelTag.css("display", "inline");
					setTimeout(function () {
						labelTag.css("display", "");
					}, 1);
				}, 2);

			}
			return mod;
		},


		/**
		 * This function is called on init and every time a select is selected
		 *
		 * @method setCustomInputSelect
		 * @param {Number} index (optional)
		 * @param {Node} domElem
		 * @returns {Tc.Module.ScForm}
		 */
		setCustomSelect: function (index, domElem) {
			var mod = this,
				$select = $(domElem);

			if ($select[0].tagName === 'SELECT') {
				this.setCustomInputSelectionHiddenLabel($select);
			}
			return mod;
		},

		/**
		 * @method setCustomInputCheckbox
		 * @param {Number} index
		 * @param {Node} domElem
		 * @returns {Tc.Module.ScForm}
		 */
		setCustomInputCheckbox: function (index, domElem) {
			var mod = this,
				$chkbox = $(domElem),
				isChecked = domElem.checked;

			if ($chkbox.is(':checkbox')) {
				$chkbox.parent()
					.find('label[for="' + $chkbox.attr('id') + '"]')
					.toggleClass('checked', isChecked)
					.find('span.checkbox-control')
					.attr('aria-checked', isChecked);
				this.setCustomInputSelectionHiddenLabel($chkbox);
			}

			return mod;
		},

		setCustomInputSelectionHiddenLabel: function (field) {
			var hiddenLabel = field.data('hiddenLabel'),
				hiddenLabelName = field.attr('name') + '_label',
				hiddenLabelId = field.attr('id') + '_label';
			if (!hiddenLabel) {
				hiddenLabel = $('input[name="' + hiddenLabelName + '"][data-id="' + hiddenLabelId + '"]', field.parent());
				if (hiddenLabel.length === 0) {
					hiddenLabel = $('<input type="hidden" name="' + hiddenLabelName + '" data-id="' + hiddenLabelId + '" data-validate="false" />');
					field.parent().append(hiddenLabel);
				}
				field.data('hiddenLabel', hiddenLabel);
			}

			if (field.is(':radio') || field.is(':checkbox')) {
				if (field[0].checked) {
					var labelTag = field.parent().find('label[for="' + field.attr('id') + '"]');
					var labelTagItemTitle = labelTag.find('.item-title');
					if (labelTagItemTitle.length > 0) {
						labelTag = labelTagItemTitle;
					}
					hiddenLabel.prop('disabled', false).val($.trim(labelTag.text())).trigger('change');
				} else {
					hiddenLabel.prop('disabled', true).val('').trigger('change');
				}
			}

			if (field[0].tagName === 'SELECT') {
				hiddenLabel.val($.trim(field.find('option:selected').text())).trigger('change');
			}
		},

		/**
		 * Event handler
		 * @method selectChangeHandler
		 * @param event
		 */
		selectChangeHandler: function (event) {
			var mod = this,
				el = event.currentTarget;

			mod.setCustomSelect(0, el);

			//set hasChanged for M@P prefill
			$(el).data('hasChanged', true);


			if (mod.isMobile) {
				$(el).trigger('valuechange', [el]);
			}

			return mod;
		},

		/**
		 * Event handler
		 * @method checkboxClickHandler
		 * @param event
		 */
		checkboxClickHandler: function (event) {
			var mod = this,
				el = event.currentTarget;
			if ($(el).is('[readonly]')) return mod;

			mod.setCustomInputCheckbox(0, el);

			if (mod.isMobile) {
				$(el).closest(mod.checkboxGroupSelector).trigger('valuechange', [el]);
			}

			return mod;
		},

		formErrorHandler: function () {
			var mod = this, i, ii;

			// 1. Marks all fields that are invalid
			for (i = 0, ii = mod.invalidFields.length; i < ii; i += 1) {
				mod.markFieldAsInvalid(mod.invalidFields[i]);
			}

			// 2. Display error messages
			mod.updateClientErrorView(mod.invalidFields);

			return mod;
		},

		formSubmitHandler: function (event) {
			var mod = this,
				numberOfInvalidFields,
				$formButton = mod.$ctx.find('button[type=submit]');

			var successTracking = mod.$ctx.data('successtracking-enabled');
			var warehouseTracking = mod.$ctx.data('datawarehouse-tracking-enabled');

			// previous form submit was delayed for tracking
			// after a short delay we trigger a submit again
			// checks have been done before, just do the submit
			if (mod.formSubmitDelayed) return true;

			try {
				$formButton.addClass('is-hidden');
				// Reset previous validation
				mod.resetFormValidation();

				// Check field validation requirements
				numberOfInvalidFields = mod.checkFieldValidation('submit');

				if (numberOfInvalidFields > 0) {
					mod.$ctx.trigger('formerror');

				} else {
					var allSummariesConfirmed = true,
						summaries = mod.getSummaries();

					for (var i = 0; i < summaries.length; i += 1) {
						var summary = summaries[i];
						if (!summary.el.data('confirmed')) {
							if (event) {
								event.preventDefault();
							}
							if (summary.el.find('.scs-form-navigation').length > 0) {
								mod.$stageMobile.addClass('navigation-back');
							}
							mod.showSummary(summary, true);
							window.scrollTo(0, 0);
							allSummariesConfirmed = false;
						}
					}

					if (allSummariesConfirmed) {
						if (successTracking || warehouseTracking) {
							mod.formSuccessTracking();
							mod.dataWarehouseTracking();
							// delay submit to allow tracking
							event.preventDefault();
							mod.formSubmitDelayed = true;
							// trigger real submit a bit later
							setTimeout(function () {
								mod.$form.trigger('submit');
								mod.formSubmitDelayed = false;
							}, 50);

							// Prevent premature submission
							return false;
						}
						// Return early to submit the form
						return true;
					}
				}
			} catch (e) {
				$formButton.removeClass('is-hidden');

				debug.log('Tc.Module.ScForm: JS exception when trying to submit form', e);
				if (event) {
					// The form must not submit data before validation in case there is a javascript exception
					event.preventDefault();
					throw e;
				}
			}

			$formButton.removeClass('is-hidden');
			return false;
		},

		/**
		 * Triggers the Swisscom form submit tracking for tealium
		 */
		formSuccessTracking: function () {
			var mod = this,
				$ctx = mod.$ctx,
				conversionCategory = $ctx.data('conversion-category'),
				conversionDetail = $ctx.data('conversion-detail'),
				conversionClass = $ctx.data('conversion-class'),
				eventAction = $ctx.data('track-action'),
				eventLocation = $ctx.data('track-location'),
				eventLabel = $ctx.data('track-label'),
				eventCategory = $ctx.data('track-category');

			debug.log('Tc.Module.ScForm > formSuccessTracking > triggering conversion:', conversionCategory, conversionDetail, conversionClass);

			new SCS.portal.datalayer.Interaction()
				.withEvent(eventAction, eventLabel, eventLocation, eventCategory, "")
				.withConversion(conversionCategory, conversionDetail, conversionClass)
				.track();
		},

		/**
		 * Triggers the Swisscom datawarehouse tracking
		 */
		dataWarehouseTracking: function () {
			var mod = this,
				$ctx = mod.$ctx,
				/* jshint camelcase: false */
				location = window.utag_data && window.utag_data.page_template && window.utag_data.page_template !== mod.TEMPLATE_TYPE_HELP_WIDGET ? 'Content' : 'Help-Widget',
				interaction = new SCS.portal.datalayer.Interaction()
					.withEvent('submit', '', location, 'form');

			if ($ctx.data('datawarehouse-tracking-enabled')) {
				debug.log("Tc.Module.ScForm.js > dataWarehouseTracking > enabled");
				interaction.event.rawdata = {};

				$ctx.find('[data-sdw-mapping]').each(function () {
					// skip unselected radio buttons and checkboxes
					if (($(this).is('input:radio') || $(this).is('input:checkbox')) && !$(this).is(':checked')) {
						return true;
					}
					interaction.event.rawdata[$(this).data('sdw-mapping')] = $(this).val();
					debug.log('Tc.Module.ScForm > ' + $(this).data('sdw-mapping') + ' > ' + $(this).val());
				});

				interaction.track();
			}
		},

		radioSelectHandler: function (event) {
			var mod = this,
				el = event.currentTarget,
				$radio = $(el);

			if ($radio.is('[readonly]')) return mod;

			mod.setInputRadioByName($radio.attr('name'));

			if (mod.isMobile) {
				$(el).closest(mod.radioGroupSelector).trigger('valuechange', [el]);
			}
			return mod;
		},

		/**
		 * @method checkFieldValidation
		 * @returns {Number}
		 */
		checkFieldValidation: function (context) {
			var mod = this;
			// setup the validation object when the form fields are evaluated
			mod.setUpFieldsWithValidation();
			mod.getFieldsWithValidation().each(function (index) {
				var $this = $(this),
					$inputs = $this.find('input[data-validate!="false"],textarea[data-validate!="false"],select[data-validate!="false"],sdx-input-group[data-validate!="false"]').filter(function () {
						return ($(this).attr('name') !== 'recaptcha_challenge_field');
					}),
					cv, vr,
					inputType = [$inputs.attr('type')],
					inputValue = [$.trim($inputs.val())],
					i, x;

				cv = $this.data('clientvalidationInstance');
				if ($this.data('is-multifield') === true) {
					inputValue = [];
					inputType = [];
					for (i = 0; i < $inputs.length; i += 1) {
						var field = $($inputs[i]);
						inputValue.push(field.val());
						inputType.push(field.attr('type'));
					}
				}

				for (x = 0; x < inputValue.length; x += 1) {
					if((inputType[x] === 'radio' || inputType[x] === 'checkbox') && $inputs[x].tagName.toLowerCase() === 'sdx-input-group') {
						vr = cv.validateSDXInputGroup($inputs[x].value);
					} else if (inputType[x] === 'radio') {
						vr = cv.validateRadioGroup($this.find('input:radio:checked').length, context);
					} else if (inputType[x] === 'checkbox') {
						vr = cv.validateCheckboxGroup($this.find('input:checkbox:checked').length, context);
					} else {
						vr = cv.validate(inputValue[x], context);
					}

					if (vr.isValid === false) {
						if (mod.invalidFields.length === 0) {
							if (mod.enableValidationScrolling) {
								mod.scrollToElement($this);
							}
						}
						mod.invalidFields.push(ScForm.createInvalidField(index, vr).setField($($inputs[x])));
					}
				}
			});

			return mod.invalidFields.length;
		},

		scrollToElement: function (element) {
			var scrollOffset = element.offset().top,
				windowScrollOffset = $(window).scrollTop(),
				windowHeight = $(window).height();
			if (scrollOffset < windowScrollOffset || scrollOffset + 40 > windowScrollOffset + windowHeight) {
				$('html, body').animate({scrollTop: (scrollOffset - 20)}, 1000);
			}
		},

		/**
		 * Marks the invalid fields with a css class
		 *
		 * @method markFieldAsInvalid
		 * @param {InvalidField} invalidField
		 * @returns {Tc.Module.ScForm}
		 */
		markFieldAsInvalid: function (invalidField) {
			var mod = this,
				$field = mod.getFieldsWithValidation().eq(invalidField.getIndex()),
				$errorField = $field.find('span.error');
			if ($field.closest('.sdx-container').length) {
				$field.find('.sdx.message').removeClass('hidden');
			}

			$field.addClass('error');
			$errorField.html($errorField.html() + ($errorField.html() === '' ? '' : '<br/>') + $('<div>').text(invalidField.getVr().getMessage() || '').html());
			$errorField.removeClass('hidden');
			invalidField.getField().addClass('error-field');
			return mod;
		},

		/**
		 * Removes all error markings from form
		 *
		 * @method resetFormValidation
		 * @returns {Tc.Module.ScForm}
		 */
		resetFormValidation: function () {
			var mod = this,
				$ctx = mod.$ctx;

			mod.resetInvalidFields();
			$('div.headingError', $ctx).addClass('hidden');
			if (mod.$validationContext && mod.$validationContext.length > 0) {
				$ctx = mod.$validationContext;
			}
			$('.sdx.message', $ctx).addClass('hidden');
			$('div.error, fieldset.error', $ctx).removeClass('error');
			$('.error-field', $ctx).removeClass('error-field');
			$('span.error', $ctx).addClass('hidden').text('');

			return mod;
		},

		/**
		 * Resets array containing list of all fields that are marked as invalid
		 *
		 * @method resetInvalidFields
		 * @returns void
		 */
		resetInvalidFields: function () {
			this.invalidFields = [];
		},

		/**
		 * Inserts error messages into dom and shows them
		 *
		 * @method updateClientErrorView
		 * @param invalidFields {Array<InvalidField>}
		 * @returns {Tc.Module.ScForm}
		 */
		updateClientErrorView: function (invalidFields) {
			var mod = this,
				// $clientErrorView = $('div.headingError', mod.$ctx);
				$clientErrorView = $('div.headingError:not(.server-side)', mod.$ctx);

			// Only show message if there are errors and a message text is specified
			if (invalidFields.length > 0 && $.trim($clientErrorView.find('span.msg').text()) !== '') {
				$clientErrorView.removeClass('hidden');
			}

			return mod;
		},

		/**
		 * Creates instance of qtip for hints. Checks if qtip instance is available.
		 *
		 * @method setupToolTip
		 * @return {Tc.Module.ScForm}
		 */
		setupToolTip: function () {
			var mod = this,
				$buttonFieldHints = mod.$ctx.find('button.field-hint'),
				i = 0,
				ii = $buttonFieldHints.length;

			for (; i < ii; i += 1) {
				mod.createQtipInstance($buttonFieldHints.eq(i), mod.qtipConfig);
			}

			return mod;
		},

		/**
		 * Create qTip instance on element such as <button class="field-hint" data-hint="Foo"></button>
		 *
		 * @param $buttonFieldHint
		 * @param qTipConfig
		 */
		createQtipInstance: function ($buttonFieldHint, qTipConfig) {
			if ($buttonFieldHint.length !== 1 || typeof ($buttonFieldHint.data('hint')) === 'undefined') {
				throw ('Trying to create qtip instance on element without hint');
			}

			if (typeof ($buttonFieldHint.data('qtip')) === 'undefined') {
				debug.log('Tc.Module.ScForm > initialized Tooltip');
				$buttonFieldHint.qtip(qTipConfig);
			}
		},

		/**
		 * Initializes checkbox groups. Every checkbox group has a minimum of one checkbox, hence every checkbox is a group. Checkbox groups have a wrapper with the role="group"
		 *
		 * @method setupCheckboxGroups
		 * @return {number}
		 */
		setupCheckboxGroups: function () {
			var mod = this,
				initCounter = 0;

			mod.$ctx.find(mod.checkboxGroupSelector).each(function () {
				var $group = $(this);

				if ($group.data('init') !== true) {
					$group.data('selected', $group.find('input:checkbox:checked').length);
					$group.attr('data-init', true);
					initCounter += 1;
				}
			});

			debug.log('Tc.Module.ScForm > initialized Checkbox Groups: ' + initCounter);
			return initCounter;
		},

		/**
		 * Initializes radio groups
		 *
		 * @method setupRadioGroups
		 * @returns {number}
		 */
		setupRadioGroups: function () {
			var mod = this,
				initCounter = 0;

			mod.$ctx.find(mod.radioGroupSelector).each(function () {
				var $group = $(this);

				if ($group.data('init') !== true) {
					$group.data('selected', $group.find('input:radio:checked').length);
					$group.attr('data-init', true);
					initCounter += 1;
				}
			});

			debug.log('Tc.Module.ScForm > initialized Radio Groups: ' + initCounter);
			return initCounter;
		},

		/**
		 * Returns a map of fields and their visible values, meaning
		 * that for select boxes, radio buttons and checkboxes it will
		 * take the labels, for all other fields their actual values.
		 * If the field has more than one value, the value for this field
		 * will be an array of values.
		 */
		getFieldsAsMapForSummary: function () {
			var fieldMap = {},
				mod = this;
			//we ignore the _label fields as they do not contain user inputs
			mod.$form.find(':input:not([name$=_label])').each(function () {
				var elem = $(this),
					value = $(this).val(),
					type = 'text',
					data = value,
					found = true,
					label;
				if (this.type === 'checkbox') {
					type = this.type;
					found = false;
					value = [];
					mod.$form.find('input[name="' + this.name + '"]').each(function () {
						var checkbox = $(this);
						if (checkbox.is(':checked')) {
							label = checkbox.next('label[for="' + checkbox.attr('id') + '"]');
							if (label) {
								value.push($.trim(label.text()));
							}
						}
					});
					if (value.length > 0) {
						found = true;
						data = value;
					}
				} else if (this.type === 'radio') {
					type = this.type;
					found = false;
					if (elem.is(':checked')) {
						label = elem.next('label[for="' + elem.attr('id') + '"]');
						if (label) {
							value = $.trim(label.text());
							data = value;
							found = true;
						}
					}
				} else if (elem.is('SELECT')) {
					type = 'select';
					found = false;
					elem.children().each(function () {
						var option = $(this);
						if (option.attr('value') === elem.val()) {
							if (value === '' || value === -1) {
								value = '';
							} else {
								value = option.text();
							}
							data = value;
							found = true;
						}
					});
				} else if (elem.data('type') === 'file') {
					type = 'file';
					found = false;
					value = [];
					data = [];
					mod.$form.find('input[name="' + this.name + '"]').each(function () {
						var $this = $(this),
							link = $this.siblings('.fileDescription').clone();
						value.push($('<div>').append(link).html());
						data.push({
							text: link.find('.text').text(),
							size: link.find('.size').text(),
							uuid: $this.val()
						});
					});
					if (value.length > 0) {
						found = true;
						value = '<span class="fileList">' + value.join('') + '</span>';
					}
				} else if (this.type === 'text') {
					value = [];
					mod.$form.find('input[name="' + this.name + '"]').each(function () {
						var fieldValue = $(this).val();
						if (fieldValue) {
							value.push(fieldValue);
						}
					});
					if (value.length > 0) {
						data = value;
					}
				}

				if (found && fieldMap[this.name] === undefined) {
					fieldMap[this.name] = {
						type: type,
						data: data,
						value: value
					};
				}
			});
			return fieldMap;
		},

		clickSaveHandler: function (event) {
			event.preventDefault();
			this.updateSummaries();
			var mod = this,
				formStartParameterName = ':formstart',
				frm = mod.formTag,
				formStartParameter = $('input[name="' + formStartParameterName + '"]', frm),
				serializedData;
			formStartParameter.attr('name', 'formstart');
			try {
				serializedData = frm.serialize();
			} finally {
				formStartParameter.attr('name', formStartParameterName);
			}
			$.ajax({
				type: 'POST',
				url: frm.attr('action').replace('.html', '.formarchive.save.json'),
				dataType: 'json',
				data: serializedData,
				success: function (data) {
					if (data.success === 'true' || data.success === true) {
						if (data.entryId) {
							mod.setFieldValue(':archiveId', data.entryId, true);
						}
						if (data.lastUpdated) {
							mod.setLastSavedDate(data.lastUpdated);
						}
					}
					// TODO: display 'could not save' message otherwise?
				},
				error: function () {
					mod.showDialog('Error', mod.$ctx.data('error-msg'));
				}
			});
		},

		setLastSavedDate: function (date) {
			if (!this.lastSavedDateContainer) {
				this.lastSavedDateContainer = $('<p/>').addClass('sentdate');
				this.formTag.prepend(this.lastSavedDateContainer);
			}
			this.lastSavedDateContainer.text(this.$ctx.data('txt-last-saved') + ' ' + date);
			this.lastSavedDateContainer.show();
		},

		showDialog: function (title, text) {
			$('<div/>').attr('title', title).append(text).dialog();
		},

		clickCancelHandler: function (event) {
			var $el = $(event.currentTarget);
			window.location.href = $el.attr('href');
			event.preventDefault();
		},

		clickForwardHandler: function (event) {
			var mod = this;
			if ($('body').hasClass('cq_isEditMode')) {
				event.preventDefault();
				mod.showDialog('Forms in multi-page steps cannot be submitted individually.', mod.$ctx.data('error-msg'));
			} else if (this.doExecuteSpecialButtonHandlers()) {
				this.clickSummaryActionHandler(event);
			}
		},

		clickLinkWithPlaceholder: function (event) {
			event.preventDefault();
			var mod = this,
				key,
				$el = $(event.currentTarget),
				href = $el.attr('data-url-with-placeholder'),
				target = $el.attr('target') ? $el.attr('target') : '_self';

			// Reset previous validation
			mod.resetFormValidation();

			// Check field validation requirements
			var numberOfInvalidFields = mod.checkFieldValidation();

			if (numberOfInvalidFields > 0) {
				mod.$ctx.trigger('formerror');
			} else {
				var fieldMap = mod.getFieldsAsMapForSummary();
				for (key in fieldMap) {
					if (fieldMap.hasOwnProperty(key)) {
						var value = encodeURIComponent(fieldMap[key].value);
						href = SCS.portal.replaceAll(href, '__FIELDNAME__' + key + '__', value);
					}
				}

				if (target === '_self') {
					location.href = href;
				} else {
					window.open(href, target);
				}
			}
		},

		// triggered on change for all fields in form
		synchValueChangedHandler: function (event) {
			var mod = this,
				index = this.$ctx.find(this.allInputFieldsSelector).index(event.target),
				originalField = $(event.target),
				field = null,
				value = originalField.val(),
				checked = originalField.prop('checked');

			// only sync on real user events
			// avoids endless sync loop
			if (event.originalEvent) {
				var groupId = mod.$ctx.data('formSynchronizationId') || '';
				$(synchronizedGroups[groupId]).not(mod.$ctx).each(function () {
					field = $(this).find(mod.allInputFieldsSelector).eq(index);
					if (field.length > 0) {
						var label = field.closest('.field').find('label');
						switch (event.target.type) {
							case 'radio':
								field.prop('checked', checked);
								$(field[0].form.elements[field[0].name]).each(function () {
									var el = $(this).closest('.field').find('LABEL')
										.filter('[for="' + $(this).prop('id') + '"]');
									el.toggleClass('checked', this.checked);
								});
								break;
							case 'checkbox':
								field.prop('checked', checked);
								label.toggleClass('checked', checked);
								break;
							default:
								field.val(value);
						}
						// for visibility containers
						field.trigger('sync-ui');
					}
				});

				// call sync-heights for accordions
				$(event.target).trigger('sync-heights');

			}
		},

		getReferrerButton: function (init) {
			if (!this.referrerButton && init) {
				this.referrerButton = $('<a/>').addClass('secondary-button').attr('href', document.referrer).text(this.$ctx.data('txt-back'));
			}
			return this.referrerButton;
		},

		initReferrerButton: function () {
			var button = this.getReferrerButton(true),
				submitButton = this.$ctx.find('button[type="submit"]');
			if (submitButton && submitButton.length > 0) {
				submitButton.parent().prepend(button);
			}
		},

		initSummary: function () {
			var summaries = this.getSummaries();
			for (var i = 0; i < summaries.length; i += 1) {
				summaries[i].el.on('click', '.multipage-back-button', $.proxy(this.clickSummaryBackwardHandler, this));
				summaries[i].el.on('click', '.multipage-action-button', $.proxy(this.clickSummaryActionHandler, this));
			}

			this.updateSummaries();
		},

		clickSummaryActionHandler: function (event) {
			var mod = this,
				i,
				summariesInForm;

			if (mod.doExecuteSpecialButtonHandlers()) {
				event.preventDefault();
				//check if its a single page form
				var $multipageStep = $(event.target).closest('.multipage-wizard-step');
				if ($multipageStep.length === 0) {
					summariesInForm = mod.getSummaries();
					for (i = 0; i < summariesInForm.length; i += 1) {
						summariesInForm[i].el.data('confirmed', true);
					}
				} else {
					//otherwise check that all summaries in this multipage step have been confirmed
					var $summariesOnStep = $multipageStep.find('.scs-form-summary');
					summariesInForm = mod.getSummaries();
					for (i = 0; i < summariesInForm.length; i += 1) {
						for (var j = 0; j < $summariesOnStep.length; j += 1) {
							var $summaryOnStep = $($summariesOnStep[j]);
							if (summariesInForm[i].el.is($summaryOnStep)) {
								summariesInForm[i].el.data('confirmed', true);
							}
						}
					}
				}
				this.$form.submit();
			}
		},

		clickSummaryBackwardHandler: function () {
			var mod = this;

			if (mod.doExecuteSpecialButtonHandlers()) {
				var summaries = this.getSummaries();
				for (var i = 0; i < summaries.length; i += 1) {
					mod.showSummary(summaries[i], false);
				}
				mod.$stageMobile.removeClass('navigation-back');
				if (mod.isMobile) {
					window.scrollTo(0, 0);
				}
			}
		},

		/**
		 * This functions returns the summary object for a form.
		 * Only one summary in a form is supported.
		 *
		 * @method getSummaries
		 */
		getSummaries: function () {
			return this.getSummariesForSelector(this.summarySelector);
		},

		getShortSummary: function () {
			if (!this.shortSummary) {
				this.shortSummary = this.getSummariesForSelector('.scs-form-short-summary');
			}
			return this.shortSummary;
		},

		getSummariesForSelector: function (selector) {
			var mod = this,
				$ctx = mod.$ctx,
				$summaries = $ctx.find(selector),
				$template,
				$content,
				response = [];

			var saveValue = function (name, value, parameter) {
				if (!this.savedValuesContainer) {
					this.savedValuesContainer = this.el.find('.savedValues');
					if (this.savedValuesContainer.length === 0) {
						this.savedValuesContainer = $('<div/>').addClass('savedValues').hide();
						this.el.append(this.savedValuesContainer);
					}
				}
				if (!parameter) {
					parameter = this.el.data('values-name');
				}

				// remove entry with same name from any summary
				$ctx.find('input[type=hidden]').filter(function () {
					return this.name === parameter && this.value.match('^' + name + '::');
				}).remove();

				// add entry
				var field = $('<input/>').attr('type', 'hidden').attr('name', parameter).val(name + '::' + value);
				this.savedValuesContainer.append(field);

				debug.log('Tc.Module.ScForm > saveValue', name + '::' + value);
			};

			if ($summaries.length > 0) {
				for (var i = 0; i < $summaries.length; i += 1) {
					var $summary = $($summaries[i]);
					$template = $('.scs-summary-template', $summary);
					$content = $('.scs-summary-content', $summary);
					response.push({
						el: $summary,
						content: $content,
						template: $template.html(),
						confirmed: false,
						saveValues: $summary.data('values-save') ? true : false, // seems to be always true
						saveValue: saveValue,
						saveAttachment: function (name, value) {
							this.saveValue(name, value, this.el.data('attachments-name'));
						},
						resetSavedValues: function () {
							if (this.savedValuesContainer && this.savedValuesContainer.length > 0) {
								this.savedValuesContainer.empty();
							}
						}
					});
				}
			}
			return response;
		},

		/**
		 * Updates one given summary with the newest form field
		 * values and sets the hidden summary parameter.
		 */
		updateSummaryHandler: function (summary, fieldMap) {
			if (summary && summary.template) {
				var mod = this,
					template = summary.template,
					key,
					value,
					container,
					$scssummary = [];

				if (summary.saveValues) {
					summary.resetSavedValues();
				}
				for (key in fieldMap) {
					if (fieldMap.hasOwnProperty(key)) {
						value = fieldMap[key].value;
						if ($.isArray(value)) {
							value = value.join(', ');
						}
						if (
							summary.saveValues &&
							(
								template.indexOf(mod.TPL_PREFIX + key + mod.TPL_SUFFIX) >= 0 ||
								template.indexOf(mod.TPL_ESCAPED_PREFIX + key + mod.TPL_ESCAPED_SUFFIX) >= 0
							)
						) {
							if (fieldMap[key].type === 'file') {
								if (fieldMap[key].data && fieldMap[key].data.length > 0) {
									var saveValue = [], i, dataEntry;
									for (i = 0; i < fieldMap[key].data.length; i += 1) {
										dataEntry = fieldMap[key].data[i];
										saveValue.push(dataEntry.uuid + ':' + dataEntry.text + ':' + dataEntry.size);
									}
									summary.saveAttachment(key, saveValue.join('|'));
								}
							} else {
								summary.saveValue(key, value);
							}
						}
						if (fieldMap[key].type !== 'file') {
							value = value.replace(/</g, '&lt;').replace(/>/g, '&gt;');
						}
						// do replace only for textarea
						if (value && value.replace && fieldMap[key].type === 'textarea') {
							value = value.replace(/\r\n/g, '<br/>').replace(/\n/g, '<br/>');
						}

						template = SCS.portal.replaceAll(template, mod.TPL_PREFIX + key + mod.TPL_SUFFIX, value);
						//the parameters that are used e.g. in URLS are escaped, hiding the ${...} placeholders
						template = SCS.portal.replaceAll(template, mod.TPL_ESCAPED_PREFIX + key + mod.TPL_ESCAPED_SUFFIX, value);
						//the summary displays the same information for ${field} and ${field_label}
						template = SCS.portal.replaceAll(template, mod.TPL_PREFIX + key + '_label' + mod.TPL_SUFFIX, value);
						template = SCS.portal.replaceAll(template, mod.TPL_ESCAPED_PREFIX + key + '_label' + mod.TPL_ESCAPED_SUFFIX, value);
					}
				}

				container = mod.$ctx.closest('.columncontainer');
				if (container.find('.mod').hasClass('modScForm')) {
					$scssummary = container.find('.scs-summary-field');
				} else {
					$scssummary = mod.$ctx.find('.scs-summary-field');
				}

				$scssummary.each(function () {
					var $this = $(this),
						name = $this.data('name');

					if (summary.saveValues && template.indexOf(mod.TPL_PREFIX + key + mod.TPL_SUFFIX) >= 0) {
						summary.saveValue(key, $this.text());
					}
					template = SCS.portal.replaceAll(template,
						mod.TPL_PREFIX + key + mod.TPL_SUFFIX, value.replace(/</g, '&lt;').replace(/>/g, '&gt;'));
					template = SCS.portal.replaceAll(template,
						mod.TPL_PREFIX + name + mod.TPL_SUFFIX, $this.text());
				});

				// remove left over placeholders
				template = template.replace(/\${[a-zA-Z0-9_\/:\-]*}/g, '');

				template = $('<div>').append(template);
				template.find('*').addClass('ctHidden');

				// write back to the DOM
				summary.content[0].innerHTML = template[0].innerHTML; // does not execute scripts in content
			}
		},

		updateSummaries: function () {
			var fieldMap = this.getFieldsAsMapForSummary(),
				summaries = this.getSummaries();
			for (var i = 0; i < summaries.length; i += 1) {
				this.updateSummaryHandler(summaries[i], fieldMap);
			}

			this.updateSummaryHandler(this.getShortSummary(), fieldMap);

		},

		/**
		 * Depending on the given "show" parameter, either hides all
		 * form fields and shows the summary, or vice versa.
		 */
		showSummary: function (summary, show) {
			var mod = this,
				$ctx = mod.$ctx,
				$summary = summary.el,
				$container = $summary.closest('.parsys'),
				$colcontainer = $summary.closest('.columncontainer').find('.modSubtotal'),
				$submitButton = $ctx.find('button[type="submit"]'),
				$buttonGroup;

			// Form fields visibility
			$container.children().each(function () {
				var $this = $(this);
				if ($this[0] !== $summary.parent()[0]) {
					if (show) {
						$this.hide();
					} else {
						$this.show();
					}
				}
			});

			if ($colcontainer.length) {
				if (show) {
					$colcontainer.hide();
				} else {
					$colcontainer.show();
				}
			}

			// Submit button visibility
			if ($submitButton.length) {
				if (show) {
					$submitButton.parent().hide();
				} else {
					$submitButton.parent().show();
				}
			}

			// summary visibility
			if (show) {
				mod.updateSummaries();
				$summary.show();
			} else {
				$summary.hide();
			}

			// PEX summary form require different buttons styles
			if (mod.isMobile && $('body').hasClass('pex')) {
				$buttonGroup = $summary.find('.buttonGroup');

				// Remove empty paragraphs and line breaks
				$summary.find('.scs-summary-content p').each(function (index, element) {
					var $element = $(element),
						elementHtml = $element.html();

					if (!elementHtml || elementHtml === '&nbsp;') {
						$element.hide();
					}
				});

				// Cancel
				$buttonGroup.find('.cancel .primary-button').removeClass('primary-button').addClass('secondary-button');

				// Back
				$buttonGroup.find('.back .scs-form-navigation').removeClass('scs-form-navigation').addClass('secondary-button multipage-back-button');
			}
		},

		setFieldValue: function (name, value, createIfNotExistingInForm) {
			//revert 4bf502c6e79029154e2eb993e61cbbd854407dba PORTAL-7022 URAON: Fixed prefilling of form fields that are hidden in multi.wiz.
			//Fix for PORTAL-8265 Attachment don't save
			return this.setFieldValueInContainer(this.formTag, name, value, createIfNotExistingInForm);
		},

		getDataSourceParamsRegExp: function (container) {
			var mod = this;
			if (!mod.dataSourceParamsRegExp) {
				mod.dataSourceParamsRegExp = {};
				$('[data-source-param*="*"]', container.parent()).each(function () {
					var sourceParamName = $(this).data('source-param');
					mod.dataSourceParamsRegExp[sourceParamName] = new RegExp('^' + sourceParamName.replace(/\*/g, '(.*)') + '$', 'i');
				});
			}
			return mod.dataSourceParamsRegExp;
		},

		/**
		 * Search fields data-source-params names with wildcard and match with parameter field name
		 *
		 * Use wildcard '*' for Interaction mail forms: data-source=*group
		 * Values from parameters like x_group, y_group ..., will be set into group field
		 * @param container - form container
		 * @param name - field name
		 */
		getDataSourceParamName: function (container, name) {
			var mod = this,
				dataSourceParamsRegExp = mod.getDataSourceParamsRegExp(container);
			for (var sourceParamName in dataSourceParamsRegExp) {
				if (dataSourceParamsRegExp.hasOwnProperty(sourceParamName)) {
					if (dataSourceParamsRegExp[sourceParamName].test(name)) {
						return sourceParamName;
					}
				}
			}
			return name;
		},

		/**
		 * Sets a value for a field. Can optionally create
		 * a hidden field and append it to the end of the form
		 * if it doesn't exists. HTML decodes the value before
		 * setting it.
		 */
		setFieldValueInContainer: function (container, name, value, createIfNotExistingInForm) {
			//Fix for PORTAL-7022 URAON: Fixed prefilling of form fields that are hidden in multi.wiz. & PORTAL-6604
			//search in parent container for elements in hidden Visibility Control Container

			var el = $('[name="' + name + '"], [name="' + name + '-field"], [data-source-param="' + this.getDataSourceParamName(container, name) + '"]', container.parent()),
				elInContainer = $('[name="' + name + '"], [name="' + name + '-field"], [data-source-param="' + name + '"]', container),
				mod = this,
				valueChanged = false,
				clientvalidation,
				maxLength = Infinity,
				i;

			//hidden element have to insert in form !!!
			if (elInContainer.length === 0 && createIfNotExistingInForm) {
				elInContainer = $('<input type="hidden" name="' + name + '" />');
				container.append(elInContainer);
				el = elInContainer.add(el);
			}

			if (el.length === 0) {
				//nothing found
				return valueChanged;
			}

			if (el.data('is-prefilled') && el.data('prefilled-with') === value) {
				// do not overwrite potential changes made by the user
				debug.log('Tc.Module.ScForm > setFieldValueInContainer > was already prefilled', name, value);
			} else {
				el.data('is-prefilled', true).data('prefilled-with', value);

				if (value instanceof Array || typeof value === 'string') {
					clientvalidation = el.closest('.field').data('clientvalidation');
					if (clientvalidation) {
						maxLength = clientvalidation.maxLength || Infinity;
					}
					debug.log('Tc.Module.ScForm > setFieldValueInContainer', name, value, maxLength);
					if (value instanceof Array) {
						for (i = 0; i < value.length; i += 1) {
							if (typeof value[i] === 'string') {
								try {
									value[i] = decodeURIComponent(value[i]);
								} catch (e) {
								}
								value[i] = value[i].substr(0, maxLength);
							}
						}
					} else if (typeof value === 'string') {
						value = $('<div/>').html(value.replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;')).text();
						try {
							value = decodeURIComponent(value);
						} catch (e) {
						}
						value = value.substr(0, maxLength);
					}
				}
				if ((el.attr('type') === 'checkbox' || el.attr('type') === 'radio') && value !== null) {
					el.each(function () {
						// some values that come from the backend have
						// the character ':' replaced by an empty space,
						// therefore this case has to be checked too
						var $this = $(this),
							valueArray = value instanceof Array ? value : value.split(',');
						if ($this.val() === value ||
							$this.val().replace(':', ' ') === value ||
							$.inArray($this.val(), valueArray) >= 0 ||
							$.inArray($this.val().replace(':', ' '), valueArray) >= 0) {
							$this.prop('checked', true).trigger('updateState');
							// timeout is needed to prevent "stop running script" message in IE8
							setTimeout($.proxy(mod.triggerFieldValueChangedEvent, mod, $this), 0);
							valueChanged = true;
						}
					});
				} else if (el.attr('type') === 'file' && value !== null) {
					if (this.getRequestParameter('action') !== 'copy') { // no prefilling of attachments when copying
						el.trigger('prefill', {items: value.items});
					}
					valueChanged = true;
				} else {
					el.val(value);
					// timeout is needed to prevent "stop running script" message in IE8
					setTimeout($.proxy(mod.triggerFieldValueChangedEvent, mod, el, value), 0);
					valueChanged = true;
				}
			}
			return valueChanged;
		},

		triggerFieldValueChangedEvent: function (element, value) {
			element.trigger('setValue', {value: value}).trigger('change');
		},

		getRequestParameter: function (name) {
			var regex = new RegExp('[?&]' + escapeRegExp(name) + '=([^&]+)'),
				tmpValue = window.location.search.match(regex);
			return tmpValue && tmpValue[1] && decodeURIComponent(tmpValue[1]);
		},

		getPrefillData: function () {
			var mod = this;
			if (!mod.prefillData) {
				// get prefill data embedded in newsletterservice.jsp
				var prefillJson = $('#form-prefill-json').data('prefill-json');
				// init object to hold all merged data keys
				mod.prefillData = $.extend({}, prefillJson);

				// parse query
				mod.setPrefillFormDataFromQuery();

				// parse params after hash sign in url
				mod.setPrefillFormDataFromHash();
				// setup data from this.mapJson
				if (mod.mapJson) {
					mod.setPrefillFormDataFromMap();
				}
				// there is a race condition here, since we do not know
				// which ajax call returns first. If we have same key
				// in both results, only the first will be considered
				// they should return a promise that resolves to data
				if (!prefillJson) {
					mod.lazyPrefillFormData();
				}
				mod.lazyPrefillFormArchiveData();
			}
			return mod.prefillData;
		},

		/* add new keys to prefillData */
		/* skips already known keys */
		addPrefillData: function (data) {
			var mod = this;
			if (!mod.prefillData) {
				mod.prefillData = {};
			}
			if (data) {
				for (var key in data) {
					if (data.hasOwnProperty(key)) {
						// skip it if we already have data for this key
						if (mod.prefillData.hasOwnProperty(key)) {
							continue;
						}
						// add this key to our data store
						mod.prefillData[key] = data[key];
					}
				}
				// prefill data now as far as possible
				// called again for newly added data
				mod.prefillFormData();
			}
		},

		prefillFormData: function () {
			this.replaceDefaultValuePlaceholders();

			if (!this.prefillingInProgress) {
				this.prefillingInProgress = true;
				var key,
					data = this.getPrefillData();

				if (data) {
					for (key in data) {
						if (data.hasOwnProperty(key)) {
							if (key === 'randomToken') {
								this.randomFormToken = data[key];
								this.setFieldValue(key, data[key], true);
								this.fire('randomFormToken', {action: 'set', token: data[key]});
								delete data[key];
							} else if (this.setFieldValue(key, data[key])) {
								delete data[key];
							}
						}
					}
				} else {
					// why is this called twice?
					// why do we throw away return?
					this.getPrefillData();
				}
				this.prefillingInProgress = false;
				if (this.restartPrefilling) {
					this.restartPrefilling = false;
					this.prefillFormData();
				}
			} else {
				this.restartPrefilling = true;
			}
		},

		lazyPrefillFormArchiveData: function () {
			var mod = this,
				form = mod.formTag,
				entryId = this.getRequestParameter('entryId'),
				action = this.getRequestParameter('action');
			if (!entryId) {
				entryId = $('input[name=":archiveId"]', mod.$ctx).val();
			}
			if (entryId) {
				this.initReferrerButton();
				if (action === 'edit') {
					this.setFieldValue(':archiveId', entryId, true);
				}
				$.ajax({
					type: 'GET',
					url: form.attr('action').replace('.html', '.formarchive.item.json'),
					cache: false,
					dataType: 'json',
					data: {entryId: entryId},
					success: function (data) {
						if (data.jsonSummary) {
							if (data.attachments && data.attachments.length > 0) {
								for (var i = 0; i < data.attachments.length; i += 1) {
									var attachment = data.attachments[i];
									if (!data.jsonSummary.randomToken) {
										data.jsonSummary.randomToken = attachment.token;
									}
									if (!data.jsonSummary[attachment.fieldName] || typeof data.jsonSummary[attachment.fieldName] === 'string') {
										data.jsonSummary[attachment.fieldName] = {
											items: []
										};
									}
									data.jsonSummary[attachment.fieldName].items.push(attachment);
								}
							}
							mod.addPrefillData(data.jsonSummary);
						}
						if (action === 'edit' && data.lastUpdated) {
							mod.setLastSavedDate(data.lastUpdated);
						}
					}
				}).done(function () {
					mod.autoSubmit();
				});
			}
		},

		lazyPrefillFormData: function () {
			var mod = this,
				prefillUrl = this.$ctx.data('prefill-url'),
				charset = this.$ctx.find('input[name="_charset_"]').val();
			if (prefillUrl) {
				$.ajax({
					url: prefillUrl,
					type: 'get',
					dataType: 'json',
					data: {'_charset_': charset, ':formid': mod.formId, ':formstart': mod.formStart}
				}).done(function (json) {
					mod.addPrefillData(json);
					mod.autoSubmit();
				}).fail(function (jqXHR) {
					debug.log('prefill failed: ' + jqXHR.responseText);
				});
			}
		},

		/**
		 * Prefill form fields with hash parameter values like:
		 * .../myform.html#key=value&foo=bar&zip=1234
		 */
		setPrefillFormDataFromHash: function () {
			if (!this.locationHash) {
				if (!location.hash.length) {
					return;
				}
				this.locationHash = location.href.split('#')[1];
			}
			this.addPrefillData(this.parseQueryString(this.locationHash));
		},

		/**
		 * Prefill form fields with query parameter values like:
		 * .../myform.html?key=value&foo=bar&zip=1234
		 *
		 * Used if query parameter should be remapped to another field
		 */
		setPrefillFormDataFromQuery: function () {
			if (this.$ctx.data('enable-parse-query-parameters') === true && location.search.length) {
				this.addPrefillData(this.parseQueryString(location.search.substring(1)));
			}
		},

		/**
		 * Prefill form fields with values from M@P
		 */
		setPrefillFormDataFromMap: function () {
			var mod = this,
				pattern = new RegExp(escapeRegExp(mod.TPL_PREFIX) + '(' + escapeRegExp(mod.TPL_MAP_CUSTOMER_DETAILS_PREFIX) + '(\\S+)' + ')' + escapeRegExp(mod.TPL_SUFFIX)), // ${customerDetails_mapFieldName}
				data = {};

			// prefilled text inputs, selects
			mod.$ctx.find('[type="text"], [type="email"], textarea, select').each(function () {
				var $input = $(this),
					defaultValue = $input.data('orig-default-value'),
					currentValue = $input.val() || '',
					value,
					key;

				if (!defaultValue || $input.is('select')) {
					defaultValue = $input.data('default-value') || '';
					$input.data('orig-default-value', defaultValue);
				}

				if ((!$input.is('select')
					&& currentValue.length > 0 && defaultValue.length > 0 && currentValue !== defaultValue)
					|| $input.data('hasChanged')) {
					return;
				}

				var match, replacementCount = 0;
				while ((match = pattern.exec(defaultValue)) !== null) {
					key = match[1];
					value = mod.mapJson[key] || '';
					defaultValue = defaultValue.substr(0, match.index) + value + defaultValue.substr(match.index + match[0].length);
					replacementCount += 1;
				}

				if (!replacementCount) {
					return;
				}

				$input.data('default-value', defaultValue);
				$input.val(defaultValue);

				data[$input.attr('name')] = defaultValue;
			});

			// prefilled checkboxes, radios
			mod.$ctx.find(':checkbox, :radio').each(function () {
				var $input = $(this),
					$field = $input.closest('.field'),
					val = $field.data('orig-default-value'),
					orig = $field.find('input:checked').val() || '',
					replacementCount = 0,
					value, key, keyWithoutPrefix, matchingTitleField, match;

				if (!val) {
					val = $field.data('default-value');
					$field.data('orig-default-value', val);
				}

				val = (orig.length > 0 && orig !== $input.data('default-value')) ? orig : val;

				while ((match = pattern.exec(val)) !== null) {
					key = match[1];
					keyWithoutPrefix = match[2];
					value = mod.mapJson[key] || '';

					if (keyWithoutPrefix === 'title') {
						// special selection method for generder / title field
						matchingTitleField = $field.find(':radio[data-type="title_' + value.toLowerCase() + '"]');
						if (matchingTitleField.length) {
							val = matchingTitleField.val();
						} else {
							break;
						}
					} else {
						val = val.substr(0, match.index) + value + val.substr(match.index + match[0].length);
					}

					replacementCount += 1;
				}

				if (!replacementCount) {
					return;
				}

				$field.data('default-value', val);

				if (val && val.length > 0) {
					data[$input.attr('name')] = val;
					$input.data('default-checked', val === $input.val());
				}

			});

			if ($.isEmptyObject(data)) {
				return;
			}

			mod.addPrefillData(data);
			mod.$ctx.trigger('MapDataPrefilled');
		},

		replaceDefaultValuePlaceholders: function () {
			var mod = this,
				$ctx = mod.$ctx,
				pattern = new RegExp(escapeRegExp(mod.TPL_PREFIX) + '(\\S+)' + mod.TPL_SUFFIX); // ${fieldname}

			debug.log('Tc.Module.ScForm > replaceDefaultValuePlaceholders', $ctx.find(':input').length);

			// prefilled text inputs
			$('[type="text"], [type="email"], [type="hidden"]', $ctx).each(function () {
				var $input = $(this),
					val = $input.val(),
					match = val && val.match(pattern),
					getValues = function () {
						return this.value;
					},
					fieldname = match && match[1] || '';

				while (match) {
					var placeholderVal =
						$(':input:not(:radio,:checkbox)[name="' + fieldname + '"]').val() ||
						$(':input:radio:checked[name="' + fieldname + '"]').val() ||
						$(':input:checkbox:checked[name="' + fieldname + '"]').map(getValues).get().join(', ') ||
						'';

					debug.log('Tc.Module.ScForm > replaceDefaultValuePlaceholders > textfield', $input.attr('name'), fieldname, placeholderVal);
					val = val.replace(pattern, placeholderVal);

					if (val.length && val === placeholderVal) {
						break;
					}
					match = val.match(pattern);
					fieldname = match && match[1] || '';
				}

				if (fieldname.indexOf(mod.TPL_MAP_CUSTOMER_DETAILS_PREFIX) === -1) {
					$input.val(val);
				}

			});

			// prefilled radio buttons, check boxes
			$ctx.find(':checkbox, :radio').each(function () {
				var $input = $(this),
					val = $input.val(),
					$field = $input.closest('.field'),
					defaultValue = $field.data('default-value'),
					match = typeof defaultValue === 'string' && defaultValue.match(pattern);

				if (match) {
					var fieldname = match[1],
						placeholderVal =
							$(':input:radio:checked[name="' + fieldname + '"][value="' + val + '"]').val() ||
							$(':input:checkbox:checked[name="' + fieldname + '"][value="' + val + '"]').val() ||
							$(':input:not(:radio,:checkbox)[name="' + fieldname + '"]').val() ||
							'';

					if (fieldname.indexOf(mod.TPL_MAP_CUSTOMER_DETAILS_PREFIX) === -1) {
						debug.log('Tc.Module.ScForm > replaceDefaultValuePlaceholders > radio/checkbox', $input.attr('name'), fieldname, placeholderVal);
						$input.val([placeholderVal]).change();
					}
				}
			});

			// prefilled select drop downs
			$ctx.find('select').each(function () {
				var $input = $(this),
					defaultValue = $input.data('default-value'),
					match = typeof defaultValue === 'string' && defaultValue.match(pattern);

				if (match) {
					var fieldname = match[1],
						placeholderVal =
							$(':input:radio:checked[name="' + fieldname + '"]').val() ||
							$(':input:checkbox:checked[name="' + fieldname + '"]').val() ||
							$(':input:not(:radio,:checkbox)[name="' + fieldname + '"]').val() ||
							'';

					if (fieldname.indexOf(mod.TPL_MAP_CUSTOMER_DETAILS_PREFIX) === -1) {
						debug.log('Tc.Module.ScForm > replaceDefaultValuePlaceholders > select dropdown', $input.attr('name'), fieldname, placeholderVal);
						$input.val(placeholderVal).change();
					}
				}
			});
		},

		parseQueryString: function (query) {
			var queryParts, i, queryParam, params = [];
			if (query) {
				queryParts = query.split('&');
				for (i = 0; i < queryParts.length; i += 1) {
					queryParam = queryParts[i].split('=');
					if (queryParam.length === 2) {
						var value = decodeURIComponent((queryParam[1] || '').replace(/\+/g, ' '));
						if (params.hasOwnProperty(queryParam[0])) {
							if (params[queryParam[0]] instanceof Array) {
								params[queryParam[0]].push(value);
							} else {
								params[queryParam[0]] = [params[queryParam[0]], value];
							}
						} else {
							params[queryParam[0]] = value;
						}
					}
				}
			}

			return params;
		}
	}); // end of Tc.Module.extend

	// module vars
	var QTIP_CONFIG = {
		position: {
			my: 'bottom center',
			at: 'top center',
			viewport: $(window), // Keep it on-screen at all times if possible
			adjust: {
				x: 0,
				y: -2
			}
		},
		hide: {
			fixed: true // Helps to prevent the tooltip from hiding occasionally when tracking!
			//,event : 'click' // Uncomment for styling and debugging
		},
		content: {
			title: false,
			text: function () {
				return $(this).data('hint');
			}
		},
		show: {
			event: 'click mouseenter'
		},
		style: {
			classes: ($.fn.qtip.defaults.style.classes || '') + ' scs-callout qtip-shadow qtip-rounded scs-form-qtip'
		}
	};

}(__webpack_provided_window_dot_Tc_dot_$, window.Tc, window.ScForm, window.debug, window.SCS = window.SCS || {}));

}.call(window));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {/*** IMPORTS FROM imports-loader ***/
var loadTerrific = __webpack_require__(1);
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

function readTrackingData($el) {
	var data = {conversion: undefined, cart: undefined};

	var conversion = {
		category: $el.data('conversion-category'),
		detail: $el.data('conversion-detail'),
		'class': $el.data('conversion-class') || '',
	};

	if(conversion.category && conversion.detail) {
		data.conversion = conversion;
	}

	var ordercase = $el.data('tracking-ordercase');
	if(ordercase) {
		data.cart = {ordercase: ordercase};
	}

	return data;
}

/**
 * MultipageWizard Skin implementation for the ScForm module.
 *
 * @author Zeljko Curcic, Thomas Junghans
 * @namespace Tc.Module.ScForm
 * @class MultipageWizard
 * @extends Tc.Module
 * @constructor
 */
Tc.Module.ScForm.MultipageWizard = function (parent) {
	/* jshint maxstatements: false */

	/**
	 * @type {string}
	 */
	this.STEP_PREFIX = 'multipageStep-';

	/**
	 * @type {string}
	 */
	this.EVT_STEP_LOADED = 'steploaded';

	/**
	 * @type {string}
	 */
	this.EVT_BEFORE_ACTION = 'beforeaction';

	/**
	 * @type {string}
	 */
	this.EVT_BEFORE_NEXT_STEP = 'beforenextstep';

	/**
	 * @type {string}
	 */
	this.EVT_BEFORE_PREVIOUS_STEP = 'beforepreviousstep';

	/**
	 * Event fired after the step is changed
	 * @type {string}
	 */
	this.EVT_STEP_CHANGE = 'stepchange';

	/**
	 * Page template name used by Help Widget pages
	 */
	this.TEMPLATE_TYPE_HELP_WIDGET = 'Portal Contact-Widget Page';

	/**
	 * Required for page ajax request
	 * @type {string}
	 */
	this.STEP_LINK_SUFFIX = '/_jcr_content/parsys/form/formpar.html';

	// developmental feature: add mobile selector in preview mode on author
	if (window.location.href.indexOf('wcmmode=disabled') > 0) {
		if (location.href.match(/\.mobile\.html/)) {
			this.STEP_LINK_SUFFIX = this.STEP_LINK_SUFFIX.replace('.html', '.mobile.html');
		}
	}

	this.HASH_PREFIX = 'ms-';

	/**
	 * The pages get appended to this container
	 * @type {jQuery|null}
	 */
	this.$stepContainer = null;

	this.clsHidden = 'hidden';

	this.lastTrackedStep = '';
	this.trackingData = {};

	/**
	 * This is fired just before the next step is loaded or displayed. This is when you want to validate.
	 * @event steploaded
	 * @param nextStepUrl
	 * @param nextStepId
	 * @param currentStepId
	 */
	this.fireBeforeNextStep = function (nextStepUrl, nextStepId, currentStepId) {
		this.$ctx.trigger(this.EVT_BEFORE_NEXT_STEP, [nextStepUrl, nextStepId, currentStepId]);
	};

	this.fireBeforePreviousStep = function (prevStepId) {
		this.$ctx.trigger(this.EVT_BEFORE_PREVIOUS_STEP, [prevStepId]);
	};

	this.fireBeforeAction = function (nextStepUrl, nextStepId, currentStepId, dataWarehouseTrackingEnabled) {
		this.$ctx.trigger(this.EVT_BEFORE_ACTION, [nextStepUrl, nextStepId, currentStepId, dataWarehouseTrackingEnabled]);
	};

	this.fireStepChange = function () {
		this.$ctx.trigger(this.EVT_STEP_CHANGE);
	};

	/**
	 * Fired after step is loaded and displayed. This is when new form fields need to be initialized
	 * @param stepUrl
	 * @param stepId
	 */
	this.fireStepLoaded = function (stepUrl, stepId) {
		this.$ctx.trigger(this.EVT_STEP_LOADED, [stepUrl, stepId]);
	};

	/**
	 * Wrapper for user.getFullName()
	 * @returns {string}
	 */
	this.getUserFullName = function () {
		if(this.user) {
			return this.user.getFullName();
		}
		return '';
	};

	/**
	 * Wrapper for user.getFirstName()
	 * @returns {string}
	 */
	this.getUserFirstName = function () {
		if(this.user) {
			return this.user.getFirstName();
		}
		return '';
	};

	/**
	 * Wrapper for user.getLastName()
	 * @returns {string}
	 */
	this.getUserLastName = function () {
		if(this.user) {
			return this.user.getLastName();
		}
		return '';
	};

	this.goToNextStep = function (nextStepUrl, nextStepId, currentStepId) {
		var mod = this;

		if (document.getElementById(nextStepId) !== null) {
			mod.showStep(nextStepId);
		} else {
			mod.loadStep(nextStepUrl, currentStepId);
		}

	};

	this.handleError = function (data) {
		var mod = this,
			showDefaultMsgBox = true;

		mod.disableFormSubmissions = false;

		//handle response object
		if (data.status && data.responseText) {
			try {
				data = $.parseJSON(data.responseText);
			}
			catch (e) {
				this.showAjaxError(data.status);
				return;
			}
		}

		if (data.data && $.isArray(data.data) && data.data.length > 0) {
			mod.$ctx.find('.modCaptcha').trigger('reloadCaptcha');
			var showValidationMsg = true,
				ok;
			$.each(data.data, function (index, invalidField) {
				ok = mod.markFieldAsInvalid(invalidField);
				showValidationMsg = showValidationMsg && !ok ? false : true;
			});

			if (!showValidationMsg) {
				//reset message
				data.message = '';
			}

			showDefaultMsgBox = false;
		}

		if (data.message && data.message.length > 0) {
			var elContainer = mod.$ctx.find('div.headingError.client-side');
			var el = elContainer.find('.msg');
			el.text(data.message);
			elContainer.removeClass('hidden');
			showDefaultMsgBox = false;
		}

		//show default msg box
		if (showDefaultMsgBox) {
			this.showAjaxError();
		}
	};

	this.resetServersideInvalidFields = function () {
		var mod = this;
		$('div.error', mod.$ctx).removeClass('error');
		$('.error-field', mod.$ctx).removeClass('error-field');
		$('span.error', mod.$ctx).addClass('hidden').text('');
		$('div.headingError', mod.$ctx).addClass('hidden');
	};

	this.showAjaxError = function (errorCode) {
		var mod = this,
			errorTitle = errorCode === 403 ? mod.error403Title : mod.errorTitle,
			errorMessage = errorCode === 403 ? mod.error403Message : mod.errorMessage;

		mod.formApi.renderPopupMessage(errorMessage, errorTitle);
	};

	this.onAjaxError = function (data) {
		this.errorTitle = data.title;
		this.errorMessage = data.message;
		this.showAjaxError();
	};

	this.onHandleError = function (data) {
		this.resetServersideInvalidFields();
		this.handleError(data);
	};

	this.executeAction = function (nextStepUrl, nextStepId, currentStepId, promise) {
		var mod = this,
			frm = $('form.wizard');
		promise = promise || $.Deferred().resolve();
		promise.then(function () {
			$.ajax({
				type: frm.attr('method'),
				url: frm.attr('action'),
				dataType: 'json',
				data: frm.serialize().replace(new RegExp('\'', 'g'), '%27').replace(/\(/g, '%28').replace(/\)/g, '%29'),
				success: function (data) {
					mod.resetServersideInvalidFields();
					if (data.success === 'true' || data.success === true) {
						if (data.href) {
							if (data.target) {
								window.open(data.href, data.target);
							} else {
								window.open(data.href);
							}
						}
						if (nextStepUrl && nextStepUrl.length > 0) {
							mod.goToNextStep(nextStepUrl, nextStepId, currentStepId);
						}
					} else {
						mod.handleError(data);
					}
				},
				error: function (jqXHR) {
					mod.resetServersideInvalidFields();
					mod.handleError(jqXHR);
				}
			});
		});
	};

	this.dataWarehouseTracking = function () {
		var mod = this,
			location = window.utag_data && window.utag_data.page_template && window.utag_data.page_template !== mod.TEMPLATE_TYPE_HELP_WIDGET
				? "Content"
				: "Help-Widget",
			interaction = new SCS.portal.datalayer.Interaction()
				.withEvent('submit', '', location, 'multistepform');

		interaction.event.rawdata = {};

		mod.log('datawarehouse tracking enabled');
		mod.$ctx.find('[data-sdw-mapping]').each(function () {

			// skip unselected radio buttons and checkboxes
			if (($(this).is('input:radio') || $(this).is('input:checkbox')) && !$(this).is(':checked')) {
				return true;
			}
			interaction.event.rawdata[$(this).data('sdw-mapping')] = $(this).val();
			mod.log($(this).data('sdw-mapping'), ' > ', $(this).val());
		});
		interaction.track();
	};

	/**
	 * Marks the invalid fields with a css class
	 *
	 * @method markFieldAsInvalid
	 * @param invalidField
	 * @returns {Tc.Module.ScForm}
	 */
	this.markFieldAsInvalid = function (invalidField) {
		var mod = this,
			$field = mod.$ctx.find('#' + invalidField.id),
			$fieldContainer = $field.closest('.field'),
			$errorField = $fieldContainer.find('span.error'),
			$msgDiv = $fieldContainer.find('div.sdx.message');

		$fieldContainer.addClass('error');
		$errorField.html($errorField.html() + ($errorField.html() === '' ? '' : '<br/>') + '<div>' + invalidField.messages + '</div>');
		$errorField.removeClass('hidden');
		if($msgDiv){
			$msgDiv.removeClass('hidden');
		}
		$field.addClass('error-field');
		return $field || $field.length > 0;
	};

	/**
	 * Wrapper for profile.getUser() !== null
	 * Returns true if the user is logged in, false if anonymous or login state is unknown
	 * @returns {boolean}
	 */
	this.isUserLoggedIn = function () {
		return !!this.user;
	};

	/**
	 * Expects "url" to be a string such as
	 * /de/component-gallery/swisscom/components/wimbledon-sme/business-internetstandardform/installation
	 *
	 * In case of the above string, the return would be "multipageStep-installation"
	 *
	 * @method makeStepId
	 * @param url {string}
	 * @returns {string}
	 */
	this.makeStepId = function (url) {
		if (url && url.length > 0) {
			var res = url.match(/\/([^\/?#]+)(\?|#|$)/);
			return this.STEP_PREFIX + (res.length > 1 ? res[1] : 'empty');
		}

		return this.STEP_PREFIX + 'empty';
	};

	/**
	 * Expects the path of the page to be loaded and uses the part after the last "/"
	 *
	 * @method makeTrackingStepName
	 * @param stepUrl {string}
	 * @returns {string}
	 */
	this.makeTrackingStepName = function (stepUrl) {
		return stepUrl.substring(stepUrl.lastIndexOf('/') + 1, stepUrl.length);
	};

	/**
	 * Executed when the "back" button is clicked
	 *
	 * @method multiPageBackwardHandler
	 * @param event
	 */
	this.multiPageBackwardHandler = function (event) {
		event.preventDefault();

		var mod = this,
			$el = $(event.currentTarget),
			prevStepId = $el.parents('.multipage-wizard-step').data('prev');

		mod.fireBeforePreviousStep(prevStepId);

		mod.trackingData = readTrackingData($el);

		mod.showStep(prevStepId);

		mod.fireStepChange();
	};

	/**
	 * Executed when the "next" button is clicked
	 *
	 * @method multiPageForwardHandler
	 * @param event
	 */
	this.multiPageForwardHandler = function (event) {
		event.preventDefault();

		var mod = this,
			$el = $(event.currentTarget),
			$currentStep = $el.closest('.multipage-wizard-step'),
			currentStepId = $currentStep.prop('id'),
			nextStepUrl = $el.attr('href'),
			nextStepId = mod.makeStepId(nextStepUrl);

		if ($el.hasClass('disabled')) {
			return;
		}

		mod.trackingData = readTrackingData($el);

		// Validation of current step and loading of next are done in the event handler
		mod.fireBeforeNextStep(nextStepUrl, nextStepId, currentStepId);
	};

	this.onStepChange = function (data) {
		if (data.step === 'next') {
			this.multiPageForwardHandler(data.event);
		} else if (data.step === 'previous') {
			this.multiPageBackwardHandler(data.event);
		}
	};

	this.multiPageActionHandler = function (e) {
		e.preventDefault();
		var mod = this,
			$el = $(e.currentTarget),
			$currentStep = $el.closest('.multipage-wizard-step'),
			currentStepId = $currentStep.prop('id'),
			nextStepUrl = $el.attr('href'),
			nextStepId = mod.makeStepId(nextStepUrl),
			dataWarehouseTrackingEnabled = $el.data('datawarehouse-tracking-enabled') || false;

		mod.trackingData = readTrackingData($el);

		// Validation of current step and loading of next are done in the event handler
		mod.fireBeforeAction(nextStepUrl, nextStepId, currentStepId, dataWarehouseTrackingEnabled);
	};

	this.on = function (callback) {
		var mod = this,
			$ctx = mod.$ctx,
			startpageUrl = $ctx.data('startpage');

		__webpack_require__(5).getProfile().then(function(profile) {
			mod.user = profile.getUser();
		});

		// Run parent first before anything else!
		parent.on(callback);

		mod.formApi = parent.$ctx.data('form-api');
		mod.$stepContainer = mod.$ctx.find('form');

		mod.$stageMobile = $ctx.closest('div.stageMobile');
		mod.errorTitle = mod.$ctx.data('error-title');
		mod.errorMessage = mod.$ctx.data('error-msg');
		mod.error403Title = mod.$ctx.data('error-403-title');
		mod.error403Message = mod.$ctx.data('error-403-msg');

		mod.disableFormSubmissions = false;

		$ctx.on(mod.EVT_STEP_LOADED, function () {

			// 1. Reinit form
			mod.formApi.reInit();

			if (mod.formApi.getReferrerButton() && !mod.referrerButtonMoved) {
				mod.referrerButtonMoved = true;
				var button = mod.formApi.getReferrerButton().clone();
				mod.formApi.getReferrerButton().remove();
				$('.buttonGroup .clear', mod.$ctx).before($('<div/>').addClass('back').append(button));
			}

			// 2. Get user login and check for fields
			if (mod.isUserLoggedIn()) {

				// The following three input fields are pre-filled if a user is logged in.
				// The pre-filling only happens once in case the user changes the values
				var $inputName = $ctx.find('input[name="name"]'),
					$inputFirstName = $ctx.find('input[name="firstname"]'),
					$inputLastName = $ctx.find('input[name="lastname"]');

				if ($inputName.length === 1 && typeof($inputName.data('prefilled')) === 'undefined') {
					$inputName.val(mod.getUserFullName());
					$inputName.data('prefilled', true);
				}

				if ($inputFirstName.length === 1 && typeof($inputFirstName.data('prefilled')) === 'undefined') {
					$inputFirstName.val(mod.getUserFirstName());
					$inputFirstName.data('prefilled', true);
				}

				if ($inputLastName.length === 1 && typeof($inputLastName.data('prefilled')) === 'undefined') {
					$inputLastName.val(mod.getUserLastName());
					$inputLastName.data('prefilled', true);
				}

			}

			if (SCS.utils.isMobilePage()) {
				// Add additional form padding
				mod.addFormStepTopPadding();
			}
		});

		$ctx.on(mod.EVT_BEFORE_NEXT_STEP, function (e, nextStepUrl, nextStepId, currentStepId) {

			// A validation context needs to be provided to validate only the current step
			mod.formApi.setValidationContext($(document.getElementById(currentStepId))); // The context is automatically reset after validation

			var numberOfInvalidElements = mod.formApi.validateForm('advanceStep');

			mod.log('There are', numberOfInvalidElements, 'invalid elements', mod.disableFormSubmissions);

			if (numberOfInvalidElements === 0 && !mod.disableFormSubmissions) {
				mod.disableFormSubmissions = true;
				mod.goToNextStep(nextStepUrl, nextStepId, currentStepId);
				mod.fireStepChange();
			}
		});

		/**
		 * Fired before the submit action
		 */
		$ctx.on(mod.EVT_BEFORE_ACTION, function (e, nextStepUrl, nextStepId, currentStepId, dataWarehouseTrackingEnabled) {

			var numberOfInvalidElements = mod.formApi.validateForm('stepAction');

			// A validation context needs to be provided to validate only the current step
			mod.formApi.setValidationContext($(document.getElementById(currentStepId))); // The context is automatically reset after validation
			mod.log('There are', numberOfInvalidElements, 'invalid elements', mod.disableFormSubmissions);

			if (numberOfInvalidElements === 0 && !mod.disableFormSubmissions) {

				var promise = $.Deferred().resolve();

				var tvProductId = mod.$ctx.find('#tv_uhd').val();
				if (tvProductId && tvProductId.length) {
					promise = mod.processPayment(tvProductId);
				}

				if (dataWarehouseTrackingEnabled) {
					mod.dataWarehouseTracking();
				}

				mod.disableFormSubmissions = true;
				if (tvProductId && tvProductId.length) {
					mod.executeAction('', nextStepId, currentStepId, promise);
					mod.disableFormSubmissions = false;
				} else {
					mod.executeAction(nextStepUrl, nextStepId, currentStepId, promise);
				}

			}
		});

		$ctx.on(mod.EVT_STEP_CHANGE, function () {
			window.scrollTo(0, 0);
		});

		mod.formApi.executeSpecialButtonHandlers(false);
		$ctx.on('click', '.multipage-forward-button', $.proxy(mod.multiPageForwardHandler, mod));
		$ctx.on('click', '.multipage-back-button', $.proxy(mod.multiPageBackwardHandler, mod));
		$ctx.on('click', '.multipage-action-button', $.proxy(mod.multiPageActionHandler, mod));

		$(window).on('hashchange', function () {
			var prevStepId = mod.getStepHash();

			mod.showStep(prevStepId);
		});


		$ctx.on('keyup keydown keypress', 'input', function (event) {
			if (event.which === 13) {
				event.stopImmediatePropagation();
				event.preventDefault();
				if (!mod.advanceStep()) {
					mod.stepAction();
				}
				return false;
			}
		});

		$ctx.data('api').advanceStep = $.proxy(mod, 'advanceStep');
		$ctx.data('api').stepAction = $.proxy(mod, 'stepAction');

		mod.loadStep(startpageUrl);
	};

	/**
	 * TODO: Add Description
	 * @param data
	 */
	this.onPreloadNextStep = function (data) {
		var mod = this;
		mod.loadStep(data.stepUrl, data.prevStep, true);
	};

	this.onPreloadNextStepAndDisplay = function (data) {
		var mod = this;
		mod.loadStep(data.stepUrl, data.prevStep, false);
	};

	this.getUrlParameters = function () {
		var startIndex = window.location.href.indexOf('?'),
			endIndex = window.location.href.indexOf('#');
		if (startIndex > 0) {
			if (endIndex > 0 && endIndex > startIndex) {
				return window.location.href.substring(startIndex, endIndex);
			} else {
				return window.location.href.substring(startIndex);
			}
		}
		return '';
	};

	/**
	 * Trigger step change tracking
	 */
	this.trackStep = function (stepId) {
		var mod = this,
			// remove prefix and query parameters
			originalTrackingName = stepId.substr(mod.STEP_PREFIX.length).split("?")[0].split("#")[0],
			trackingName = originalTrackingName;

		// update metalyzer conversion value for the current step
		if (window.metalyzerTrackerList && originalTrackingName in metalyzerTrackerList && metalyzerTrackerList[originalTrackingName] !== "") {
			SCS.portal.datalayer.addUdoProperty("metalyzer_conv_tracker", metalyzerTrackerList[originalTrackingName]);
		}

		// update mxcIntelliAdTrackerId for the current step
		if (window.mxcIntelliAdTrackerList && originalTrackingName in mxcIntelliAdTrackerList && mxcIntelliAdTrackerList[originalTrackingName] !== "") {
			SCS.portal.datalayer.addUdoProperty("mxc_ia_tracker", mxcIntelliAdTrackerList[originalTrackingName]);
		}

		// update mxcDcIntelliAdTrackerId for the current step
		if (window.mxcDcIntelliAdTrackerList && originalTrackingName in mxcDcIntelliAdTrackerList && mxcDcIntelliAdTrackerList[originalTrackingName] !== "") {
			SCS.portal.datalayer.addUdoProperty("mxc_dc_tracker", mxcDcIntelliAdTrackerList[originalTrackingName]);
		}

		// update productId for the current step
		if (window.productMap && originalTrackingName in productMap && productMap[originalTrackingName] !== "") {
			SCS.portal.datalayer.setProduct(productMap[originalTrackingName]["id"], productMap[originalTrackingName]["key"], productMap[originalTrackingName]["name"]);
		}

		// update page type for the current step
		if (window.trackingPageTypeMap && originalTrackingName in trackingPageTypeMap && trackingPageTypeMap[originalTrackingName] !== "") {
			SCS.portal.datalayer.setPageType(trackingPageTypeMap[originalTrackingName]);
		}

		// page view tracking, afterwards revert alias to actual page name for language independent tracking
		if (window.aliasList && trackingName in aliasList) {
			trackingName = aliasList[trackingName];
		}
		if (SCS.portal.datalayer && trackingName !== mod.lastTrackedStep) {
			if (SCS.portal.datalayer.pushPagePath(trackingName, true)) {
				mod.log("trackStep > trackingName: ", trackingName);

				// add conversion information in tracking object
				mod.log("trackStep > form submit with tracking data:", mod.trackingData);
				Object.assign(SCS.portal.datalayer.trackObj, mod.trackingData);

				SCS.portal.datalayer.trackPageView();

				// reset conversion info
				mod.trackingData = {};
			}
			mod.lastTrackedStep = trackingName;
		}
	};

	/**
	 * Loads the step using ajax and shows it once loaded, if preLoad is false or not given that is.
	 *
	 * @param stepUrl
	 * @param prevStep
	 * @param preLoad {boolean}, optional
	 */
	this.loadStep = function (stepUrl, prevStep, preLoad) {

		var mod = this,
			stepId = mod.makeStepId(stepUrl),
			$wrapper = $('<div class="multipage-wizard-step hidden"></div>').attr({'id': stepId, 'data-prev': prevStep});

		// make sure we don't create steps that already exists (for multiple events fired in ie8)
		if (mod.$ctx.find('#' + stepId).length) {
			mod.log('Attempted creation of multiple form steps with the same id');
			return;
		}

		// Trigger Create for Jquery Mobile, pages via Ajax are otherwise not covered by jquery mobile
		$wrapper.appendTo(mod.$stepContainer);

		if (mod.getIndexOfStepById(stepId) === 0) {
			$wrapper.addClass('first');
		}

		if (!preLoad) {
			mod.toggleLoadingIndicator(true);
		}

		if (stepUrl) {
			stepUrl = stepUrl.replace(/(\?|#).*/, "");
		}

		$wrapper.load(stepUrl + mod.STEP_LINK_SUFFIX + mod.getUrlParameters(), function () {
			if (!preLoad) {
				mod.toggleLoadingIndicator(false);
				mod.showStep(stepId);
			}
			SCS.utils.initNewModules(mod.$stepContainer);

			mod.fireStepLoaded(stepUrl, stepId);
		});
	};

	this.toggleLoadingIndicator = function (toggle) {
		var mod = this,
			$loadingIndicator = mod.$ctx.find('.loader-wrap'),
			$steps = $('div.multipage-wizard-step', mod.$ctx);

		if (toggle) {
			$steps.addClass(mod.clsHidden);
			$loadingIndicator.removeClass(mod.clsHidden);
		} else {
			$loadingIndicator.addClass(mod.clsHidden);
		}
	};

	/**
	 * showStep and loadStep are not the same thing
	 *
	 * Shows a step that has already been loaded into the dom
	 *
	 * @method showStep
	 * @param stepId
	 */
	this.showStep = function (stepId) {
		this.disableFormSubmissions = false;

		var mod = this,
			$step,
			$steps = $('div.multipage-wizard-step', mod.$ctx),
			stepIndex;

		if (SCS.utils.isMobilePage()) {
			$steps.trigger('create');
		}

		mod.fire('BeforeShowStep', {'stepId': stepId}, ['wizard']);

		mod.updateSummary(stepId);
		mod.formApi.updateSummaries();

		$steps.addClass(mod.clsHidden);
		$step = $(document.getElementById(stepId));
		$step.removeClass(mod.clsHidden);

		if (!SCS.utils.isMobilePage()) {
			mod.recalculateDropdownWidths($step);
		}

		stepIndex = mod.getIndexOfStepById(stepId);

		if (stepIndex !== -1) {
			mod.fire('stepChange', {stepIndex: stepIndex});

			// Only update hash if the step id and hash differ, otherwise showStep is called too often
			if (mod.getStepHash() !== stepId) {
				mod.setStepHash(stepId);
			}

			// Adding class to non module
			mod.$stageMobile.toggleClass('navigation-back', $step.find('.scs-form-navigation').length > 0);
		} else {
			window.history.go(-1);
		}
		mod.trackStep(stepId);
	};

	/**
	 * stepId is the value of the id-attribute in
	 * <div class="multipage-wizard-step" id="multipageStep-konfiguration">
	 *
	 * @method getIndexOfStepById
	 * @param stepId {string}
	 */
	this.getIndexOfStepById = function (stepId) {
		var mod = this,
			$steps = $('div.multipage-wizard-step', mod.$ctx),
			$step = $(document.getElementById(stepId));

		return $steps.index($step);
	};

	/**
	 * Converts the hash from the url to the step html id attribute.
	 *
	 * if the id value is "multipageStep-konfiguration" then the location.hash will be ms-multipageStep-konfiguration
	 *
	 * location.hash = 'ms-'
	 */
	this.getStepHash = function () {
		var mod = this;

		return location.hash.split('#' + mod.HASH_PREFIX)[1];
	};

	/**
	 *
	 * @method setStepHash
	 * @param newHash
	 */
	this.setStepHash = function (newHash) {
		var mod = this;

		location.hash = mod.HASH_PREFIX + newHash;
	};

	/**
	 * This function updates form summary pages after.
	 * TODO(ces): rename this function to be more generic
	 *
	 * Summary pages must use following naming convention to fetch data from other form steps:
	 *
	 * Display text set in form element with name 'company'
	 * <span data-bind="text: company"></span>
	 *
	 * Show text "Show" only, if form element with name 'advice' has value 'sms'
	 * <span data-bind="conditional: advice: sms">Show</span>
	 *
	 * @method updateSummary
	 * @param {String} stepId only summary fields of the given step get updated
	 * @return void
	 */
	this.updateSummary = function (stepId) {
		var mod = this,
			$ctx = mod.$ctx;

		$(document.getElementById(stepId)).find('[data-bind]').each(function () {
			var $this = $(this),
				bindings = $(this).attr('data-bind').split(':'),
				type = $.trim(bindings[0]),
				name = $.trim(bindings[1]),
				value = '',
				condition;

			$this.addClass('ctHidden');

			if (type === 'text') {
				$this.html($(':input[name="' + name + '"]', $ctx).val());

			} else if (type === 'radio') {
				$this.html($(':input[name="' + name + '"]:checked', $ctx).val());

			} else if (type === 'conditional') {
				value = $(':input[name="' + name + '"]', $ctx).val();
				condition = $.trim(bindings[2]);

				if (condition === value) {
					$this.show();
				} else {
					$this.hide();
				}
			}
		});

		//hide empty elements
		mod.$ctx.find('dd:empty').each(function () {
			$(this).prev('dt').addClass('hidden');
		});
	};

	/**
	 * This function is a listener for all wizard-step-modules that want to delete other steps ahead of them because of changed data (occures if a user navigates back through wizard-steps)
	 *
	 * @method onClearWizardSteps
	 * @param {object} data containing "stepContainer" which can be a wizard-step or any module within
	 * @return void
	 */
	this.onClearWizardSteps = function (data) {
		var stepContainer = data.stepContainer.is('.multipage-wizard-step') ? data.stepContainer : data.stepContainer.closest('.multipage-wizard-step');

		stepContainer.nextAll().remove();
	};

	/**
	 * After displaying a form wizard step, calculates the width of custom dropdowns, to display them correctly
	 *
	 * @method recalculateDropdownWidths
	 * @param $step
	 */
	this.recalculateDropdownWidths = function ($step) {
		$step.find('.newList').each(function () {
			var list = $(this);
			list.css('min-width', (list.closest('.newListSelected').outerWidth() - (list.outerWidth() - list.width())) + 'px');
		});
	};

	/**
	 * Add top padding to each step of the form if back button has sub label text
	 * @return void
	 */
	this.addFormStepTopPadding = function () {
		var $currentFormStep = this.currentFormStep();

		if ($.trim($('.scs-navigation-button-sub-label:visible', $currentFormStep).html()) && $currentFormStep.css('padding-top') !== '22px') {
			$currentFormStep.css('padding-top', '22px');
		}
	};

	this.currentFormStep = function () {
		return $('form > div:visible', this.$ctx);
	};

	// Advances to the next form step if possible (but validates first)
	this.advanceStep = function advanceStep() {
		var $currentFormStep = this.currentFormStep();
		var $actionButton = $currentFormStep.find('.forward .multipage-forward-button');
		if ($actionButton.length > 0) {
			$actionButton[0].click();
			return true;
		}
	};

	// Advances to the next form step if possible (but validates first)
	this.stepAction = function stepAction() {
		var $currentFormStep = this.currentFormStep();
		var $actionButton = $currentFormStep.find('.action .multipage-action-button');
		if ($actionButton.length > 0) {
			$actionButton[0].click();
			return true;
		}
	};

	this.processPayment = function (tvProductId) {
		var mod = this;

		var ajaxUrl = $('input[name=":formstart"]').val() + '.payment.json',
			firstName = $('input[name="lead_contact_person_first_name"]').val(),
			lastName = $('input[name="lead_contact_person_last_name"]').val(),
			email = $('input[name="lead_contact_email_address"]').val(),
			etage = false,
			postData;

		if ($('input[name="lead_etagenlieferung"]:checked').length) {
			postData = [tvProductId, 'etage'];
			etage = true;
		}
		else {
			postData = tvProductId;
			etage = false;
		}

		return $.post(ajaxUrl, {productId: postData}, function (data) {
			if (data && data.success) {
				mod.$ctx.find('#user_ref').val(data.refno);

				$.getScript(data.datatransJavaScriptUrl).done(function () {
					var params = {
						merchantId: data.merchantId,
						amount: data.amount,
						currency: data.currency,
						refno: data.refno,
						sign: data.sign,
						successUrl: data.successUrl,
						cancelUrl: data.cancelUrl,
						errorUrl: data.errorUrl,
						uppWebResponseMethod: 'GET',
						uppStartTarget: '_top',
						fName: firstName,
						lName: lastName,
						email: email,
						pID: tvProductId,
						etage: etage
					};
					window.Datatrans.startPayment({params: params});
				}).fail(function () {
					this.showAjaxError();
				});
			} else {
				this.showAjaxError();
			}
		});


	};
};

}.call(window));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_Tc_dot_$) {/*** IMPORTS FROM imports-loader ***/
var loadTerrific = __webpack_require__(1);
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

var SdxInputField = __webpack_require__(50).default;
var SdxTextarea = __webpack_require__(291).default;

(function($, Tc) {
	/*
	 * Dependencies:
	 * TerrificJs 2.0.1,
	 * jQuery 1.7 or greater,
	 */

	'use strict';

	/**
	 * TextField module implementation.
	 *
	 * @author Nikola Tica
	 * @namespace Tc.Module
	 * @class TextField
	 * @extends Tc.Module
	 */
	Tc.Module.TextField = Tc.Module.extend({

		/**
		 * Hook function to do all of your module stuff.
		 *
		 * @method on
		 * @param {Function} callback function
		 * @return void
		 */
		on: function (callback) {
			var mod = this,
				$ctx = this.$ctx;

			mod.$field = $('.field-input', $ctx);

			if ($ctx.is('.input-field--multiline')) {
				mod.sdxTextarea = new SdxTextarea($ctx[0]);
				mod.log('init textarea');
			} else {
				mod.sdxInputField = new SdxInputField(mod.$field[0]);
			}

			if (mod.$field.data('remember-last-entry')) {
				mod.localStorageItemId = mod.$field.data('remember-last-entry');
				mod.updateFieldValueFromLS();
				mod.$field.on('input', mod.saveEnteredValue.bind(mod));
			}

			if ($ctx.is('.mobile_number')) {
				mod.allowedNumberFieldInputs = /[\d+]/;
				mod.$field.on('keydown', mod.restrictNumberFieldInputs.bind(mod));
			} else if (mod.$field.data('number-field-to-restrict')) {
				mod.allowedNumberFieldInputs = /[\d-.]/;
				mod.$field.on('keydown', mod.restrictNumberFieldInputs.bind(mod));
			}

			if (mod.$field.data('display-length-constraint')) {
				mod.$textHolder = mod.$ctx.find('.input-text-length');
				mod.$field.on('input', mod.updateEnteredTextLengthHolder.bind(mod));
				mod.updateEnteredTextLengthHolder();
			}
			callback();
		},

		/**
		 * This function saves current field value to the localStorage.
		 *
		 * @method saveEnteredValue
		 * @return void
		 */
		saveEnteredValue: function() {
			var mod = this;

			var currentFieldVal = mod.$field.val();
			if (currentFieldVal !== '') {
				localStorage.setItem(mod.localStorageItemId, currentFieldVal);
				mod.log('saved ' + mod.localStorageItemId, currentFieldVal);
			}
		},

		/**
		 * This function sets the value from the local storage to the input element.
		 *
		 * @method updateFieldValueFromLS
		 * @return void
		 */
		updateFieldValueFromLS: function () {
			var mod = this;

			if(mod.$field) {
				var recordedValue = localStorage.getItem(mod.localStorageItemId);
				if (recordedValue) {
					mod.$field.val(recordedValue);
					if (mod.sdxTextarea && mod.sdxTextarea._updateHeight) {
						mod.sdxTextarea._updateHeight();
					}
					mod.log('recovered ' + mod.localStorageItemId, recordedValue);
				}
			}
		},

		/**
		 * This function is used to prevent entering values other than Numbers,
		 * '-' or '.' into number type input field.
		 *
		 * @method restrictNumberFieldInputs
		 * @param {Event} evt
		 * @return Boolean
		 */
		restrictNumberFieldInputs : function (evt) {
			var mod = this,
				enteredValue = evt.key;
			//IE11/ MSEdge workaround for NumPad '+', '*', '/', and Space Bar
			if(['add', 'divide', 'multiply', 'spacebar'].indexOf(enteredValue.toLowerCase()) !== -1) {
				return false;
			}
			return !(enteredValue.length === 1 && !mod.allowedNumberFieldInputs.test(enteredValue));
		},

		/**
		 * This functions displays input field text length number.
		 *
		 * @method updateEnteredTextLengthHolder
		 * @return Boolean
		 */
		updateEnteredTextLengthHolder : function () {
			var mod = this;
			var textLength = mod.$field.val().length;

			mod.$textHolder.text(textLength);
		}
	});
}(__webpack_provided_window_dot_Tc_dot_$, window.Tc));

}.call(window));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(jQuery) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__types_options__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__l10n_default__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_dom__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_dates__ = __webpack_require__(286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_formatting__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_polyfills__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_polyfills___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__utils_polyfills__);
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};







var DEBOUNCED_CHANGE_MS = 300;
function FlatpickrInstance(element, instanceConfig) {
    var self = {
        config: __assign(__assign({}, __WEBPACK_IMPORTED_MODULE_0__types_options__["b" /* defaults */]), flatpickr.defaultConfig),
        l10n: __WEBPACK_IMPORTED_MODULE_1__l10n_default__["a" /* default */],
    };
    self.parseDate = Object(__WEBPACK_IMPORTED_MODULE_4__utils_dates__["d" /* createDateParser */])({ config: self.config, l10n: self.l10n });
    self._handlers = [];
    self.pluginElements = [];
    self.loadedPlugins = [];
    self._bind = bind;
    self._setHoursFromDate = setHoursFromDate;
    self._positionCalendar = positionCalendar;
    self.changeMonth = changeMonth;
    self.changeYear = changeYear;
    self.clear = clear;
    self.close = close;
    self.onMouseOver = onMouseOver;
    self._createElement = __WEBPACK_IMPORTED_MODULE_3__utils_dom__["b" /* createElement */];
    self.createDay = createDay;
    self.destroy = destroy;
    self.isEnabled = isEnabled;
    self.jumpToDate = jumpToDate;
    self.updateValue = updateValue;
    self.open = open;
    self.redraw = redraw;
    self.set = set;
    self.setDate = setDate;
    self.toggle = toggle;
    function setupHelperFunctions() {
        self.utils = {
            getDaysInMonth: function (month, yr) {
                if (month === void 0) { month = self.currentMonth; }
                if (yr === void 0) { yr = self.currentYear; }
                if (month === 1 && ((yr % 4 === 0 && yr % 100 !== 0) || yr % 400 === 0))
                    return 29;
                return self.l10n.daysInMonth[month];
            },
        };
    }
    function init() {
        self.element = self.input = element;
        self.isOpen = false;
        parseConfig();
        setupLocale();
        setupInputs();
        setupDates();
        setupHelperFunctions();
        if (!self.isMobile)
            build();
        bindEvents();
        if (self.selectedDates.length || self.config.noCalendar) {
            if (self.config.enableTime) {
                setHoursFromDate(self.config.noCalendar ? self.latestSelectedDateObj : undefined);
            }
            updateValue(false);
        }
        setCalendarWidth();
        var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
        if (!self.isMobile && isSafari) {
            positionCalendar();
        }
        triggerEvent("onReady");
    }
    function getClosestActiveElement() {
        var _a;
        return (((_a = self.calendarContainer) === null || _a === void 0 ? void 0 : _a.getRootNode())
            .activeElement || document.activeElement);
    }
    function bindToInstance(fn) {
        return fn.bind(self);
    }
    function setCalendarWidth() {
        var config = self.config;
        if (config.weekNumbers === false && config.showMonths === 1) {
            return;
        }
        else if (config.noCalendar !== true) {
            window.requestAnimationFrame(function () {
                if (self.calendarContainer !== undefined) {
                    self.calendarContainer.style.visibility = "hidden";
                    self.calendarContainer.style.display = "block";
                }
                if (self.daysContainer !== undefined) {
                    var daysWidth = (self.days.offsetWidth + 1) * config.showMonths;
                    self.daysContainer.style.width = daysWidth + "px";
                    self.calendarContainer.style.width =
                        daysWidth +
                            (self.weekWrapper !== undefined
                                ? self.weekWrapper.offsetWidth
                                : 0) +
                            "px";
                    self.calendarContainer.style.removeProperty("visibility");
                    self.calendarContainer.style.removeProperty("display");
                }
            });
        }
    }
    function updateTime(e) {
        if (self.selectedDates.length === 0) {
            var defaultDate = self.config.minDate === undefined ||
                Object(__WEBPACK_IMPORTED_MODULE_4__utils_dates__["b" /* compareDates */])(new Date(), self.config.minDate) >= 0
                ? new Date()
                : new Date(self.config.minDate.getTime());
            var defaults = Object(__WEBPACK_IMPORTED_MODULE_4__utils_dates__["f" /* getDefaultHours */])(self.config);
            defaultDate.setHours(defaults.hours, defaults.minutes, defaults.seconds, defaultDate.getMilliseconds());
            self.selectedDates = [defaultDate];
            self.latestSelectedDateObj = defaultDate;
        }
        if (e !== undefined && e.type !== "blur") {
            timeWrapper(e);
        }
        var prevValue = self._input.value;
        setHoursFromInputs();
        updateValue();
        if (self._input.value !== prevValue) {
            self._debouncedChange();
        }
    }
    function ampm2military(hour, amPM) {
        return (hour % 12) + 12 * Object(__WEBPACK_IMPORTED_MODULE_2__utils__["c" /* int */])(amPM === self.l10n.amPM[1]);
    }
    function military2ampm(hour) {
        switch (hour % 24) {
            case 0:
            case 12:
                return 12;
            default:
                return hour % 12;
        }
    }
    function setHoursFromInputs() {
        if (self.hourElement === undefined || self.minuteElement === undefined)
            return;
        var hours = (parseInt(self.hourElement.value.slice(-2), 10) || 0) % 24, minutes = (parseInt(self.minuteElement.value, 10) || 0) % 60, seconds = self.secondElement !== undefined
            ? (parseInt(self.secondElement.value, 10) || 0) % 60
            : 0;
        if (self.amPM !== undefined) {
            hours = ampm2military(hours, self.amPM.textContent);
        }
        var limitMinHours = self.config.minTime !== undefined ||
            (self.config.minDate &&
                self.minDateHasTime &&
                self.latestSelectedDateObj &&
                Object(__WEBPACK_IMPORTED_MODULE_4__utils_dates__["b" /* compareDates */])(self.latestSelectedDateObj, self.config.minDate, true) ===
                    0);
        var limitMaxHours = self.config.maxTime !== undefined ||
            (self.config.maxDate &&
                self.maxDateHasTime &&
                self.latestSelectedDateObj &&
                Object(__WEBPACK_IMPORTED_MODULE_4__utils_dates__["b" /* compareDates */])(self.latestSelectedDateObj, self.config.maxDate, true) ===
                    0);
        if (self.config.maxTime !== undefined &&
            self.config.minTime !== undefined &&
            self.config.minTime > self.config.maxTime) {
            var minBound = Object(__WEBPACK_IMPORTED_MODULE_4__utils_dates__["a" /* calculateSecondsSinceMidnight */])(self.config.minTime.getHours(), self.config.minTime.getMinutes(), self.config.minTime.getSeconds());
            var maxBound = Object(__WEBPACK_IMPORTED_MODULE_4__utils_dates__["a" /* calculateSecondsSinceMidnight */])(self.config.maxTime.getHours(), self.config.maxTime.getMinutes(), self.config.maxTime.getSeconds());
            var currentTime = Object(__WEBPACK_IMPORTED_MODULE_4__utils_dates__["a" /* calculateSecondsSinceMidnight */])(hours, minutes, seconds);
            if (currentTime > maxBound && currentTime < minBound) {
                var result = Object(__WEBPACK_IMPORTED_MODULE_4__utils_dates__["h" /* parseSeconds */])(minBound);
                hours = result[0];
                minutes = result[1];
                seconds = result[2];
            }
        }
        else {
            if (limitMaxHours) {
                var maxTime = self.config.maxTime !== undefined
                    ? self.config.maxTime
                    : self.config.maxDate;
                hours = Math.min(hours, maxTime.getHours());
                if (hours === maxTime.getHours())
                    minutes = Math.min(minutes, maxTime.getMinutes());
                if (minutes === maxTime.getMinutes())
                    seconds = Math.min(seconds, maxTime.getSeconds());
            }
            if (limitMinHours) {
                var minTime = self.config.minTime !== undefined
                    ? self.config.minTime
                    : self.config.minDate;
                hours = Math.max(hours, minTime.getHours());
                if (hours === minTime.getHours() && minutes < minTime.getMinutes())
                    minutes = minTime.getMinutes();
                if (minutes === minTime.getMinutes())
                    seconds = Math.max(seconds, minTime.getSeconds());
            }
        }
        setHours(hours, minutes, seconds);
    }
    function setHoursFromDate(dateObj) {
        var date = dateObj || self.latestSelectedDateObj;
        if (date && date instanceof Date) {
            setHours(date.getHours(), date.getMinutes(), date.getSeconds());
        }
    }
    function setHours(hours, minutes, seconds) {
        if (self.latestSelectedDateObj !== undefined) {
            self.latestSelectedDateObj.setHours(hours % 24, minutes, seconds || 0, 0);
        }
        if (!self.hourElement || !self.minuteElement || self.isMobile)
            return;
        self.hourElement.value = Object(__WEBPACK_IMPORTED_MODULE_2__utils__["d" /* pad */])(!self.config.time_24hr
            ? ((12 + hours) % 12) + 12 * Object(__WEBPACK_IMPORTED_MODULE_2__utils__["c" /* int */])(hours % 12 === 0)
            : hours);
        self.minuteElement.value = Object(__WEBPACK_IMPORTED_MODULE_2__utils__["d" /* pad */])(minutes);
        if (self.amPM !== undefined)
            self.amPM.textContent = self.l10n.amPM[Object(__WEBPACK_IMPORTED_MODULE_2__utils__["c" /* int */])(hours >= 12)];
        if (self.secondElement !== undefined)
            self.secondElement.value = Object(__WEBPACK_IMPORTED_MODULE_2__utils__["d" /* pad */])(seconds);
    }
    function onYearInput(event) {
        var eventTarget = Object(__WEBPACK_IMPORTED_MODULE_3__utils_dom__["e" /* getEventTarget */])(event);
        var year = parseInt(eventTarget.value) + (event.delta || 0);
        if (year / 1000 > 1 ||
            (event.key === "Enter" && !/[^\d]/.test(year.toString()))) {
            changeYear(year);
        }
    }
    function bind(element, event, handler, options) {
        if (event instanceof Array)
            return event.forEach(function (ev) { return bind(element, ev, handler, options); });
        if (element instanceof Array)
            return element.forEach(function (el) { return bind(el, event, handler, options); });
        element.addEventListener(event, handler, options);
        self._handlers.push({
            remove: function () { return element.removeEventListener(event, handler, options); },
        });
    }
    function triggerChange() {
        triggerEvent("onChange");
    }
    function bindEvents() {
        if (self.config.wrap) {
            ["open", "close", "toggle", "clear"].forEach(function (evt) {
                Array.prototype.forEach.call(self.element.querySelectorAll("[data-" + evt + "]"), function (el) {
                    return bind(el, "click", self[evt]);
                });
            });
        }
        if (self.isMobile) {
            setupMobile();
            return;
        }
        var debouncedResize = Object(__WEBPACK_IMPORTED_MODULE_2__utils__["b" /* debounce */])(onResize, 50);
        self._debouncedChange = Object(__WEBPACK_IMPORTED_MODULE_2__utils__["b" /* debounce */])(triggerChange, DEBOUNCED_CHANGE_MS);
        if (self.daysContainer && !/iPhone|iPad|iPod/i.test(navigator.userAgent))
            bind(self.daysContainer, "mouseover", function (e) {
                if (self.config.mode === "range")
                    onMouseOver(Object(__WEBPACK_IMPORTED_MODULE_3__utils_dom__["e" /* getEventTarget */])(e));
            });
        bind(self._input, "keydown", onKeyDown);
        if (self.calendarContainer !== undefined) {
            bind(self.calendarContainer, "keydown", onKeyDown);
        }
        if (!self.config.inline && !self.config.static)
            bind(window, "resize", debouncedResize);
        if (window.ontouchstart !== undefined)
            bind(window.document, "touchstart", documentClick);
        else
            bind(window.document, "mousedown", documentClick);
        bind(window.document, "focus", documentClick, { capture: true });
        if (self.config.clickOpens === true) {
            bind(self._input, "focus", self.open);
            bind(self._input, "click", self.open);
        }
        if (self.daysContainer !== undefined) {
            bind(self.monthNav, "click", onMonthNavClick);
            bind(self.monthNav, ["keyup", "increment"], onYearInput);
            bind(self.daysContainer, "click", selectDate);
        }
        if (self.timeContainer !== undefined &&
            self.minuteElement !== undefined &&
            self.hourElement !== undefined) {
            var selText = function (e) {
                return Object(__WEBPACK_IMPORTED_MODULE_3__utils_dom__["e" /* getEventTarget */])(e).select();
            };
            bind(self.timeContainer, ["increment"], updateTime);
            bind(self.timeContainer, "blur", updateTime, { capture: true });
            bind(self.timeContainer, "click", timeIncrement);
            bind([self.hourElement, self.minuteElement], ["focus", "click"], selText);
            if (self.secondElement !== undefined)
                bind(self.secondElement, "focus", function () { return self.secondElement && self.secondElement.select(); });
            if (self.amPM !== undefined) {
                bind(self.amPM, "click", function (e) {
                    updateTime(e);
                });
            }
        }
        if (self.config.allowInput) {
            bind(self._input, "blur", onBlur);
        }
    }
    function jumpToDate(jumpDate, triggerChange) {
        var jumpTo = jumpDate !== undefined
            ? self.parseDate(jumpDate)
            : self.latestSelectedDateObj ||
                (self.config.minDate && self.config.minDate > self.now
                    ? self.config.minDate
                    : self.config.maxDate && self.config.maxDate < self.now
                        ? self.config.maxDate
                        : self.now);
        var oldYear = self.currentYear;
        var oldMonth = self.currentMonth;
        try {
            if (jumpTo !== undefined) {
                self.currentYear = jumpTo.getFullYear();
                self.currentMonth = jumpTo.getMonth();
            }
        }
        catch (e) {
            e.message = "Invalid date supplied: " + jumpTo;
            self.config.errorHandler(e);
        }
        if (triggerChange && self.currentYear !== oldYear) {
            triggerEvent("onYearChange");
            buildMonthSwitch();
        }
        if (triggerChange &&
            (self.currentYear !== oldYear || self.currentMonth !== oldMonth)) {
            triggerEvent("onMonthChange");
        }
        self.redraw();
    }
    function timeIncrement(e) {
        var eventTarget = Object(__WEBPACK_IMPORTED_MODULE_3__utils_dom__["e" /* getEventTarget */])(e);
        if (~eventTarget.className.indexOf("arrow"))
            incrementNumInput(e, eventTarget.classList.contains("arrowUp") ? 1 : -1);
    }
    function incrementNumInput(e, delta, inputElem) {
        var target = e && Object(__WEBPACK_IMPORTED_MODULE_3__utils_dom__["e" /* getEventTarget */])(e);
        var input = inputElem ||
            (target && target.parentNode && target.parentNode.firstChild);
        var event = createEvent("increment");
        event.delta = delta;
        input && input.dispatchEvent(event);
    }
    function build() {
        var fragment = window.document.createDocumentFragment();
        self.calendarContainer = Object(__WEBPACK_IMPORTED_MODULE_3__utils_dom__["b" /* createElement */])("div", "flatpickr-calendar");
        self.calendarContainer.tabIndex = -1;
        if (!self.config.noCalendar) {
            fragment.appendChild(buildMonthNav());
            self.innerContainer = Object(__WEBPACK_IMPORTED_MODULE_3__utils_dom__["b" /* createElement */])("div", "flatpickr-innerContainer");
            if (self.config.weekNumbers) {
                var _a = buildWeeks(), weekWrapper = _a.weekWrapper, weekNumbers = _a.weekNumbers;
                self.innerContainer.appendChild(weekWrapper);
                self.weekNumbers = weekNumbers;
                self.weekWrapper = weekWrapper;
            }
            self.rContainer = Object(__WEBPACK_IMPORTED_MODULE_3__utils_dom__["b" /* createElement */])("div", "flatpickr-rContainer");
            self.rContainer.appendChild(buildWeekdays());
            if (!self.daysContainer) {
                self.daysContainer = Object(__WEBPACK_IMPORTED_MODULE_3__utils_dom__["b" /* createElement */])("div", "flatpickr-days");
                self.daysContainer.tabIndex = -1;
            }
            buildDays();
            self.rContainer.appendChild(self.daysContainer);
            self.innerContainer.appendChild(self.rContainer);
            fragment.appendChild(self.innerContainer);
        }
        if (self.config.enableTime) {
            fragment.appendChild(buildTime());
        }
        Object(__WEBPACK_IMPORTED_MODULE_3__utils_dom__["f" /* toggleClass */])(self.calendarContainer, "rangeMode", self.config.mode === "range");
        Object(__WEBPACK_IMPORTED_MODULE_3__utils_dom__["f" /* toggleClass */])(self.calendarContainer, "animate", self.config.animate === true);
        Object(__WEBPACK_IMPORTED_MODULE_3__utils_dom__["f" /* toggleClass */])(self.calendarContainer, "multiMonth", self.config.showMonths > 1);
        self.calendarContainer.appendChild(fragment);
        var customAppend = self.config.appendTo !== undefined &&
            self.config.appendTo.nodeType !== undefined;
        if (self.config.inline || self.config.static) {
            self.calendarContainer.classList.add(self.config.inline ? "inline" : "static");
            if (self.config.inline) {
                if (!customAppend && self.element.parentNode)
                    self.element.parentNode.insertBefore(self.calendarContainer, self._input.nextSibling);
                else if (self.config.appendTo !== undefined)
                    self.config.appendTo.appendChild(self.calendarContainer);
            }
            if (self.config.static) {
                var wrapper = Object(__WEBPACK_IMPORTED_MODULE_3__utils_dom__["b" /* createElement */])("div", "flatpickr-wrapper");
                if (self.element.parentNode)
                    self.element.parentNode.insertBefore(wrapper, self.element);
                wrapper.appendChild(self.element);
                if (self.altInput)
                    wrapper.appendChild(self.altInput);
                wrapper.appendChild(self.calendarContainer);
            }
        }
        if (!self.config.static && !self.config.inline)
            (self.config.appendTo !== undefined
                ? self.config.appendTo
                : window.document.body).appendChild(self.calendarContainer);
    }
    function createDay(className, date, _dayNumber, i) {
        var dateIsEnabled = isEnabled(date, true), dayElement = Object(__WEBPACK_IMPORTED_MODULE_3__utils_dom__["b" /* createElement */])("span", className, date.getDate().toString());
        dayElement.dateObj = date;
        dayElement.$i = i;
        dayElement.setAttribute("aria-label", self.formatDate(date, self.config.ariaDateFormat));
        if (className.indexOf("hidden") === -1 &&
            Object(__WEBPACK_IMPORTED_MODULE_4__utils_dates__["b" /* compareDates */])(date, self.now) === 0) {
            self.todayDateElem = dayElement;
            dayElement.classList.add("today");
            dayElement.setAttribute("aria-current", "date");
        }
        if (dateIsEnabled) {
            dayElement.tabIndex = -1;
            if (isDateSelected(date)) {
                dayElement.classList.add("selected");
                self.selectedDateElem = dayElement;
                if (self.config.mode === "range") {
                    Object(__WEBPACK_IMPORTED_MODULE_3__utils_dom__["f" /* toggleClass */])(dayElement, "startRange", self.selectedDates[0] &&
                        Object(__WEBPACK_IMPORTED_MODULE_4__utils_dates__["b" /* compareDates */])(date, self.selectedDates[0], true) === 0);
                    Object(__WEBPACK_IMPORTED_MODULE_3__utils_dom__["f" /* toggleClass */])(dayElement, "endRange", self.selectedDates[1] &&
                        Object(__WEBPACK_IMPORTED_MODULE_4__utils_dates__["b" /* compareDates */])(date, self.selectedDates[1], true) === 0);
                    if (className === "nextMonthDay")
                        dayElement.classList.add("inRange");
                }
            }
        }
        else {
            dayElement.classList.add("flatpickr-disabled");
        }
        if (self.config.mode === "range") {
            if (isDateInRange(date) && !isDateSelected(date))
                dayElement.classList.add("inRange");
        }
        if (self.weekNumbers &&
            self.config.showMonths === 1 &&
            className !== "prevMonthDay" &&
            i % 7 === 6) {
            self.weekNumbers.insertAdjacentHTML("beforeend", "<span class='flatpickr-day'>" + self.config.getWeek(date) + "</span>");
        }
        triggerEvent("onDayCreate", dayElement);
        return dayElement;
    }
    function focusOnDayElem(targetNode) {
        targetNode.focus();
        if (self.config.mode === "range")
            onMouseOver(targetNode);
    }
    function getFirstAvailableDay(delta) {
        var startMonth = delta > 0 ? 0 : self.config.showMonths - 1;
        var endMonth = delta > 0 ? self.config.showMonths : -1;
        for (var m = startMonth; m != endMonth; m += delta) {
            var month = self.daysContainer.children[m];
            var startIndex = delta > 0 ? 0 : month.children.length - 1;
            var endIndex = delta > 0 ? month.children.length : -1;
            for (var i = startIndex; i != endIndex; i += delta) {
                var c = month.children[i];
                if (c.className.indexOf("hidden") === -1 && isEnabled(c.dateObj))
                    return c;
            }
        }
        return undefined;
    }
    function getNextAvailableDay(current, delta) {
        var givenMonth = current.className.indexOf("Month") === -1
            ? current.dateObj.getMonth()
            : self.currentMonth;
        var endMonth = delta > 0 ? self.config.showMonths : -1;
        var loopDelta = delta > 0 ? 1 : -1;
        for (var m = givenMonth - self.currentMonth; m != endMonth; m += loopDelta) {
            var month = self.daysContainer.children[m];
            var startIndex = givenMonth - self.currentMonth === m
                ? current.$i + delta
                : delta < 0
                    ? month.children.length - 1
                    : 0;
            var numMonthDays = month.children.length;
            for (var i = startIndex; i >= 0 && i < numMonthDays && i != (delta > 0 ? numMonthDays : -1); i += loopDelta) {
                var c = month.children[i];
                if (c.className.indexOf("hidden") === -1 &&
                    isEnabled(c.dateObj) &&
                    Math.abs(current.$i - i) >= Math.abs(delta))
                    return focusOnDayElem(c);
            }
        }
        self.changeMonth(loopDelta);
        focusOnDay(getFirstAvailableDay(loopDelta), 0);
        return undefined;
    }
    function focusOnDay(current, offset) {
        var activeElement = getClosestActiveElement();
        var dayFocused = isInView(activeElement || document.body);
        var startElem = current !== undefined
            ? current
            : dayFocused
                ? activeElement
                : self.selectedDateElem !== undefined && isInView(self.selectedDateElem)
                    ? self.selectedDateElem
                    : self.todayDateElem !== undefined && isInView(self.todayDateElem)
                        ? self.todayDateElem
                        : getFirstAvailableDay(offset > 0 ? 1 : -1);
        if (startElem === undefined) {
            self._input.focus();
        }
        else if (!dayFocused) {
            focusOnDayElem(startElem);
        }
        else {
            getNextAvailableDay(startElem, offset);
        }
    }
    function buildMonthDays(year, month) {
        var firstOfMonth = (new Date(year, month, 1).getDay() - self.l10n.firstDayOfWeek + 7) % 7;
        var prevMonthDays = self.utils.getDaysInMonth((month - 1 + 12) % 12, year);
        var daysInMonth = self.utils.getDaysInMonth(month, year), days = window.document.createDocumentFragment(), isMultiMonth = self.config.showMonths > 1, prevMonthDayClass = isMultiMonth ? "prevMonthDay hidden" : "prevMonthDay", nextMonthDayClass = isMultiMonth ? "nextMonthDay hidden" : "nextMonthDay";
        var dayNumber = prevMonthDays + 1 - firstOfMonth, dayIndex = 0;
        for (; dayNumber <= prevMonthDays; dayNumber++, dayIndex++) {
            days.appendChild(createDay("flatpickr-day " + prevMonthDayClass, new Date(year, month - 1, dayNumber), dayNumber, dayIndex));
        }
        for (dayNumber = 1; dayNumber <= daysInMonth; dayNumber++, dayIndex++) {
            days.appendChild(createDay("flatpickr-day", new Date(year, month, dayNumber), dayNumber, dayIndex));
        }
        for (var dayNum = daysInMonth + 1; dayNum <= 42 - firstOfMonth &&
            (self.config.showMonths === 1 || dayIndex % 7 !== 0); dayNum++, dayIndex++) {
            days.appendChild(createDay("flatpickr-day " + nextMonthDayClass, new Date(year, month + 1, dayNum % daysInMonth), dayNum, dayIndex));
        }
        var dayContainer = Object(__WEBPACK_IMPORTED_MODULE_3__utils_dom__["b" /* createElement */])("div", "dayContainer");
        dayContainer.appendChild(days);
        return dayContainer;
    }
    function buildDays() {
        if (self.daysContainer === undefined) {
            return;
        }
        Object(__WEBPACK_IMPORTED_MODULE_3__utils_dom__["a" /* clearNode */])(self.daysContainer);
        if (self.weekNumbers)
            Object(__WEBPACK_IMPORTED_MODULE_3__utils_dom__["a" /* clearNode */])(self.weekNumbers);
        var frag = document.createDocumentFragment();
        for (var i = 0; i < self.config.showMonths; i++) {
            var d = new Date(self.currentYear, self.currentMonth, 1);
            d.setMonth(self.currentMonth + i);
            frag.appendChild(buildMonthDays(d.getFullYear(), d.getMonth()));
        }
        self.daysContainer.appendChild(frag);
        self.days = self.daysContainer.firstChild;
        if (self.config.mode === "range" && self.selectedDates.length === 1) {
            onMouseOver();
        }
    }
    function buildMonthSwitch() {
        if (self.config.showMonths > 1 ||
            self.config.monthSelectorType !== "dropdown")
            return;
        var shouldBuildMonth = function (month) {
            if (self.config.minDate !== undefined &&
                self.currentYear === self.config.minDate.getFullYear() &&
                month < self.config.minDate.getMonth()) {
                return false;
            }
            return !(self.config.maxDate !== undefined &&
                self.currentYear === self.config.maxDate.getFullYear() &&
                month > self.config.maxDate.getMonth());
        };
        self.monthsDropdownContainer.tabIndex = -1;
        self.monthsDropdownContainer.innerHTML = "";
        for (var i = 0; i < 12; i++) {
            if (!shouldBuildMonth(i))
                continue;
            var month = Object(__WEBPACK_IMPORTED_MODULE_3__utils_dom__["b" /* createElement */])("option", "flatpickr-monthDropdown-month");
            month.value = new Date(self.currentYear, i).getMonth().toString();
            month.textContent = Object(__WEBPACK_IMPORTED_MODULE_5__utils_formatting__["b" /* monthToStr */])(i, self.config.shorthandCurrentMonth, self.l10n);
            month.tabIndex = -1;
            if (self.currentMonth === i) {
                month.selected = true;
            }
            self.monthsDropdownContainer.appendChild(month);
        }
    }
    function buildMonth() {
        var container = Object(__WEBPACK_IMPORTED_MODULE_3__utils_dom__["b" /* createElement */])("div", "flatpickr-month");
        var monthNavFragment = window.document.createDocumentFragment();
        var monthElement;
        if (self.config.showMonths > 1 ||
            self.config.monthSelectorType === "static") {
            monthElement = Object(__WEBPACK_IMPORTED_MODULE_3__utils_dom__["b" /* createElement */])("span", "cur-month");
        }
        else {
            self.monthsDropdownContainer = Object(__WEBPACK_IMPORTED_MODULE_3__utils_dom__["b" /* createElement */])("select", "flatpickr-monthDropdown-months");
            self.monthsDropdownContainer.setAttribute("aria-label", self.l10n.monthAriaLabel);
            bind(self.monthsDropdownContainer, "change", function (e) {
                var target = Object(__WEBPACK_IMPORTED_MODULE_3__utils_dom__["e" /* getEventTarget */])(e);
                var selectedMonth = parseInt(target.value, 10);
                self.changeMonth(selectedMonth - self.currentMonth);
                triggerEvent("onMonthChange");
            });
            buildMonthSwitch();
            monthElement = self.monthsDropdownContainer;
        }
        var yearInput = Object(__WEBPACK_IMPORTED_MODULE_3__utils_dom__["c" /* createNumberInput */])("cur-year", { tabindex: "-1" });
        var yearElement = yearInput.getElementsByTagName("input")[0];
        yearElement.setAttribute("aria-label", self.l10n.yearAriaLabel);
        if (self.config.minDate) {
            yearElement.setAttribute("min", self.config.minDate.getFullYear().toString());
        }
        if (self.config.maxDate) {
            yearElement.setAttribute("max", self.config.maxDate.getFullYear().toString());
            yearElement.disabled =
                !!self.config.minDate &&
                    self.config.minDate.getFullYear() === self.config.maxDate.getFullYear();
        }
        var currentMonth = Object(__WEBPACK_IMPORTED_MODULE_3__utils_dom__["b" /* createElement */])("div", "flatpickr-current-month");
        currentMonth.appendChild(monthElement);
        currentMonth.appendChild(yearInput);
        monthNavFragment.appendChild(currentMonth);
        container.appendChild(monthNavFragment);
        return {
            container: container,
            yearElement: yearElement,
            monthElement: monthElement,
        };
    }
    function buildMonths() {
        Object(__WEBPACK_IMPORTED_MODULE_3__utils_dom__["a" /* clearNode */])(self.monthNav);
        self.monthNav.appendChild(self.prevMonthNav);
        if (self.config.showMonths) {
            self.yearElements = [];
            self.monthElements = [];
        }
        for (var m = self.config.showMonths; m--;) {
            var month = buildMonth();
            self.yearElements.push(month.yearElement);
            self.monthElements.push(month.monthElement);
            self.monthNav.appendChild(month.container);
        }
        self.monthNav.appendChild(self.nextMonthNav);
    }
    function buildMonthNav() {
        self.monthNav = Object(__WEBPACK_IMPORTED_MODULE_3__utils_dom__["b" /* createElement */])("div", "flatpickr-months");
        self.yearElements = [];
        self.monthElements = [];
        self.prevMonthNav = Object(__WEBPACK_IMPORTED_MODULE_3__utils_dom__["b" /* createElement */])("span", "flatpickr-prev-month");
        self.prevMonthNav.innerHTML = self.config.prevArrow;
        self.nextMonthNav = Object(__WEBPACK_IMPORTED_MODULE_3__utils_dom__["b" /* createElement */])("span", "flatpickr-next-month");
        self.nextMonthNav.innerHTML = self.config.nextArrow;
        buildMonths();
        Object.defineProperty(self, "_hidePrevMonthArrow", {
            get: function () { return self.__hidePrevMonthArrow; },
            set: function (bool) {
                if (self.__hidePrevMonthArrow !== bool) {
                    Object(__WEBPACK_IMPORTED_MODULE_3__utils_dom__["f" /* toggleClass */])(self.prevMonthNav, "flatpickr-disabled", bool);
                    self.__hidePrevMonthArrow = bool;
                }
            },
        });
        Object.defineProperty(self, "_hideNextMonthArrow", {
            get: function () { return self.__hideNextMonthArrow; },
            set: function (bool) {
                if (self.__hideNextMonthArrow !== bool) {
                    Object(__WEBPACK_IMPORTED_MODULE_3__utils_dom__["f" /* toggleClass */])(self.nextMonthNav, "flatpickr-disabled", bool);
                    self.__hideNextMonthArrow = bool;
                }
            },
        });
        self.currentYearElement = self.yearElements[0];
        updateNavigationCurrentMonth();
        return self.monthNav;
    }
    function buildTime() {
        self.calendarContainer.classList.add("hasTime");
        if (self.config.noCalendar)
            self.calendarContainer.classList.add("noCalendar");
        var defaults = Object(__WEBPACK_IMPORTED_MODULE_4__utils_dates__["f" /* getDefaultHours */])(self.config);
        self.timeContainer = Object(__WEBPACK_IMPORTED_MODULE_3__utils_dom__["b" /* createElement */])("div", "flatpickr-time");
        self.timeContainer.tabIndex = -1;
        var separator = Object(__WEBPACK_IMPORTED_MODULE_3__utils_dom__["b" /* createElement */])("span", "flatpickr-time-separator", ":");
        var hourInput = Object(__WEBPACK_IMPORTED_MODULE_3__utils_dom__["c" /* createNumberInput */])("flatpickr-hour", {
            "aria-label": self.l10n.hourAriaLabel,
        });
        self.hourElement = hourInput.getElementsByTagName("input")[0];
        var minuteInput = Object(__WEBPACK_IMPORTED_MODULE_3__utils_dom__["c" /* createNumberInput */])("flatpickr-minute", {
            "aria-label": self.l10n.minuteAriaLabel,
        });
        self.minuteElement = minuteInput.getElementsByTagName("input")[0];
        self.hourElement.tabIndex = self.minuteElement.tabIndex = -1;
        self.hourElement.value = Object(__WEBPACK_IMPORTED_MODULE_2__utils__["d" /* pad */])(self.latestSelectedDateObj
            ? self.latestSelectedDateObj.getHours()
            : self.config.time_24hr
                ? defaults.hours
                : military2ampm(defaults.hours));
        self.minuteElement.value = Object(__WEBPACK_IMPORTED_MODULE_2__utils__["d" /* pad */])(self.latestSelectedDateObj
            ? self.latestSelectedDateObj.getMinutes()
            : defaults.minutes);
        self.hourElement.setAttribute("step", self.config.hourIncrement.toString());
        self.minuteElement.setAttribute("step", self.config.minuteIncrement.toString());
        self.hourElement.setAttribute("min", self.config.time_24hr ? "0" : "1");
        self.hourElement.setAttribute("max", self.config.time_24hr ? "23" : "12");
        self.hourElement.setAttribute("maxlength", "2");
        self.minuteElement.setAttribute("min", "0");
        self.minuteElement.setAttribute("max", "59");
        self.minuteElement.setAttribute("maxlength", "2");
        self.timeContainer.appendChild(hourInput);
        self.timeContainer.appendChild(separator);
        self.timeContainer.appendChild(minuteInput);
        if (self.config.time_24hr)
            self.timeContainer.classList.add("time24hr");
        if (self.config.enableSeconds) {
            self.timeContainer.classList.add("hasSeconds");
            var secondInput = Object(__WEBPACK_IMPORTED_MODULE_3__utils_dom__["c" /* createNumberInput */])("flatpickr-second");
            self.secondElement = secondInput.getElementsByTagName("input")[0];
            self.secondElement.value = Object(__WEBPACK_IMPORTED_MODULE_2__utils__["d" /* pad */])(self.latestSelectedDateObj
                ? self.latestSelectedDateObj.getSeconds()
                : defaults.seconds);
            self.secondElement.setAttribute("step", self.minuteElement.getAttribute("step"));
            self.secondElement.setAttribute("min", "0");
            self.secondElement.setAttribute("max", "59");
            self.secondElement.setAttribute("maxlength", "2");
            self.timeContainer.appendChild(Object(__WEBPACK_IMPORTED_MODULE_3__utils_dom__["b" /* createElement */])("span", "flatpickr-time-separator", ":"));
            self.timeContainer.appendChild(secondInput);
        }
        if (!self.config.time_24hr) {
            self.amPM = Object(__WEBPACK_IMPORTED_MODULE_3__utils_dom__["b" /* createElement */])("span", "flatpickr-am-pm", self.l10n.amPM[Object(__WEBPACK_IMPORTED_MODULE_2__utils__["c" /* int */])((self.latestSelectedDateObj
                ? self.hourElement.value
                : self.config.defaultHour) > 11)]);
            self.amPM.title = self.l10n.toggleTitle;
            self.amPM.tabIndex = -1;
            self.timeContainer.appendChild(self.amPM);
        }
        return self.timeContainer;
    }
    function buildWeekdays() {
        if (!self.weekdayContainer)
            self.weekdayContainer = Object(__WEBPACK_IMPORTED_MODULE_3__utils_dom__["b" /* createElement */])("div", "flatpickr-weekdays");
        else
            Object(__WEBPACK_IMPORTED_MODULE_3__utils_dom__["a" /* clearNode */])(self.weekdayContainer);
        for (var i = self.config.showMonths; i--;) {
            var container = Object(__WEBPACK_IMPORTED_MODULE_3__utils_dom__["b" /* createElement */])("div", "flatpickr-weekdaycontainer");
            self.weekdayContainer.appendChild(container);
        }
        updateWeekdays();
        return self.weekdayContainer;
    }
    function updateWeekdays() {
        if (!self.weekdayContainer) {
            return;
        }
        var firstDayOfWeek = self.l10n.firstDayOfWeek;
        var weekdays = __spreadArrays(self.l10n.weekdays.shorthand);
        if (firstDayOfWeek > 0 && firstDayOfWeek < weekdays.length) {
            weekdays = __spreadArrays(weekdays.splice(firstDayOfWeek, weekdays.length), weekdays.splice(0, firstDayOfWeek));
        }
        for (var i = self.config.showMonths; i--;) {
            self.weekdayContainer.children[i].innerHTML = "\n      <span class='flatpickr-weekday'>\n        " + weekdays.join("</span><span class='flatpickr-weekday'>") + "\n      </span>\n      ";
        }
    }
    function buildWeeks() {
        self.calendarContainer.classList.add("hasWeeks");
        var weekWrapper = Object(__WEBPACK_IMPORTED_MODULE_3__utils_dom__["b" /* createElement */])("div", "flatpickr-weekwrapper");
        weekWrapper.appendChild(Object(__WEBPACK_IMPORTED_MODULE_3__utils_dom__["b" /* createElement */])("span", "flatpickr-weekday", self.l10n.weekAbbreviation));
        var weekNumbers = Object(__WEBPACK_IMPORTED_MODULE_3__utils_dom__["b" /* createElement */])("div", "flatpickr-weeks");
        weekWrapper.appendChild(weekNumbers);
        return {
            weekWrapper: weekWrapper,
            weekNumbers: weekNumbers,
        };
    }
    function changeMonth(value, isOffset) {
        if (isOffset === void 0) { isOffset = true; }
        var delta = isOffset ? value : value - self.currentMonth;
        if ((delta < 0 && self._hidePrevMonthArrow === true) ||
            (delta > 0 && self._hideNextMonthArrow === true))
            return;
        self.currentMonth += delta;
        if (self.currentMonth < 0 || self.currentMonth > 11) {
            self.currentYear += self.currentMonth > 11 ? 1 : -1;
            self.currentMonth = (self.currentMonth + 12) % 12;
            triggerEvent("onYearChange");
            buildMonthSwitch();
        }
        buildDays();
        triggerEvent("onMonthChange");
        updateNavigationCurrentMonth();
    }
    function clear(triggerChangeEvent, toInitial) {
        if (triggerChangeEvent === void 0) { triggerChangeEvent = true; }
        if (toInitial === void 0) { toInitial = true; }
        self.input.value = "";
        if (self.altInput !== undefined)
            self.altInput.value = "";
        if (self.mobileInput !== undefined)
            self.mobileInput.value = "";
        self.selectedDates = [];
        self.latestSelectedDateObj = undefined;
        if (toInitial === true) {
            self.currentYear = self._initialDate.getFullYear();
            self.currentMonth = self._initialDate.getMonth();
        }
        if (self.config.enableTime === true) {
            var _a = Object(__WEBPACK_IMPORTED_MODULE_4__utils_dates__["f" /* getDefaultHours */])(self.config), hours = _a.hours, minutes = _a.minutes, seconds = _a.seconds;
            setHours(hours, minutes, seconds);
        }
        self.redraw();
        if (triggerChangeEvent)
            triggerEvent("onChange");
    }
    function close() {
        self.isOpen = false;
        if (!self.isMobile) {
            if (self.calendarContainer !== undefined) {
                self.calendarContainer.classList.remove("open");
            }
            if (self._input !== undefined) {
                self._input.classList.remove("active");
            }
        }
        triggerEvent("onClose");
    }
    function destroy() {
        if (self.config !== undefined)
            triggerEvent("onDestroy");
        for (var i = self._handlers.length; i--;) {
            self._handlers[i].remove();
        }
        self._handlers = [];
        if (self.mobileInput) {
            if (self.mobileInput.parentNode)
                self.mobileInput.parentNode.removeChild(self.mobileInput);
            self.mobileInput = undefined;
        }
        else if (self.calendarContainer && self.calendarContainer.parentNode) {
            if (self.config.static && self.calendarContainer.parentNode) {
                var wrapper = self.calendarContainer.parentNode;
                wrapper.lastChild && wrapper.removeChild(wrapper.lastChild);
                if (wrapper.parentNode) {
                    while (wrapper.firstChild)
                        wrapper.parentNode.insertBefore(wrapper.firstChild, wrapper);
                    wrapper.parentNode.removeChild(wrapper);
                }
            }
            else
                self.calendarContainer.parentNode.removeChild(self.calendarContainer);
        }
        if (self.altInput) {
            self.input.type = "text";
            if (self.altInput.parentNode)
                self.altInput.parentNode.removeChild(self.altInput);
            delete self.altInput;
        }
        if (self.input) {
            self.input.type = self.input._type;
            self.input.classList.remove("flatpickr-input");
            self.input.removeAttribute("readonly");
        }
        [
            "_showTimeInput",
            "latestSelectedDateObj",
            "_hideNextMonthArrow",
            "_hidePrevMonthArrow",
            "__hideNextMonthArrow",
            "__hidePrevMonthArrow",
            "isMobile",
            "isOpen",
            "selectedDateElem",
            "minDateHasTime",
            "maxDateHasTime",
            "days",
            "daysContainer",
            "_input",
            "_positionElement",
            "innerContainer",
            "rContainer",
            "monthNav",
            "todayDateElem",
            "calendarContainer",
            "weekdayContainer",
            "prevMonthNav",
            "nextMonthNav",
            "monthsDropdownContainer",
            "currentMonthElement",
            "currentYearElement",
            "navigationCurrentMonth",
            "selectedDateElem",
            "config",
        ].forEach(function (k) {
            try {
                delete self[k];
            }
            catch (_) { }
        });
    }
    function isCalendarElem(elem) {
        return self.calendarContainer.contains(elem);
    }
    function documentClick(e) {
        if (self.isOpen && !self.config.inline) {
            var eventTarget_1 = Object(__WEBPACK_IMPORTED_MODULE_3__utils_dom__["e" /* getEventTarget */])(e);
            var isCalendarElement = isCalendarElem(eventTarget_1);
            var isInput = eventTarget_1 === self.input ||
                eventTarget_1 === self.altInput ||
                self.element.contains(eventTarget_1) ||
                (e.path &&
                    e.path.indexOf &&
                    (~e.path.indexOf(self.input) ||
                        ~e.path.indexOf(self.altInput)));
            var lostFocus = !isInput &&
                !isCalendarElement &&
                !isCalendarElem(e.relatedTarget);
            var isIgnored = !self.config.ignoredFocusElements.some(function (elem) {
                return elem.contains(eventTarget_1);
            });
            if (lostFocus && isIgnored) {
                if (self.config.allowInput) {
                    self.setDate(self._input.value, false, self.config.altInput
                        ? self.config.altFormat
                        : self.config.dateFormat);
                }
                if (self.timeContainer !== undefined &&
                    self.minuteElement !== undefined &&
                    self.hourElement !== undefined &&
                    self.input.value !== "" &&
                    self.input.value !== undefined) {
                    updateTime();
                }
                self.close();
                if (self.config &&
                    self.config.mode === "range" &&
                    self.selectedDates.length === 1)
                    self.clear(false);
            }
        }
    }
    function changeYear(newYear) {
        if (!newYear ||
            (self.config.minDate && newYear < self.config.minDate.getFullYear()) ||
            (self.config.maxDate && newYear > self.config.maxDate.getFullYear()))
            return;
        var newYearNum = newYear, isNewYear = self.currentYear !== newYearNum;
        self.currentYear = newYearNum || self.currentYear;
        if (self.config.maxDate &&
            self.currentYear === self.config.maxDate.getFullYear()) {
            self.currentMonth = Math.min(self.config.maxDate.getMonth(), self.currentMonth);
        }
        else if (self.config.minDate &&
            self.currentYear === self.config.minDate.getFullYear()) {
            self.currentMonth = Math.max(self.config.minDate.getMonth(), self.currentMonth);
        }
        if (isNewYear) {
            self.redraw();
            triggerEvent("onYearChange");
            buildMonthSwitch();
        }
    }
    function isEnabled(date, timeless) {
        var _a;
        if (timeless === void 0) { timeless = true; }
        var dateToCheck = self.parseDate(date, undefined, timeless);
        if ((self.config.minDate &&
            dateToCheck &&
            Object(__WEBPACK_IMPORTED_MODULE_4__utils_dates__["b" /* compareDates */])(dateToCheck, self.config.minDate, timeless !== undefined ? timeless : !self.minDateHasTime) < 0) ||
            (self.config.maxDate &&
                dateToCheck &&
                Object(__WEBPACK_IMPORTED_MODULE_4__utils_dates__["b" /* compareDates */])(dateToCheck, self.config.maxDate, timeless !== undefined ? timeless : !self.maxDateHasTime) > 0))
            return false;
        if (!self.config.enable && self.config.disable.length === 0)
            return true;
        if (dateToCheck === undefined)
            return false;
        var bool = !!self.config.enable, array = (_a = self.config.enable) !== null && _a !== void 0 ? _a : self.config.disable;
        for (var i = 0, d = void 0; i < array.length; i++) {
            d = array[i];
            if (typeof d === "function" &&
                d(dateToCheck))
                return bool;
            else if (d instanceof Date &&
                dateToCheck !== undefined &&
                d.getTime() === dateToCheck.getTime())
                return bool;
            else if (typeof d === "string") {
                var parsed = self.parseDate(d, undefined, true);
                return parsed && parsed.getTime() === dateToCheck.getTime()
                    ? bool
                    : !bool;
            }
            else if (typeof d === "object" &&
                dateToCheck !== undefined &&
                d.from &&
                d.to &&
                dateToCheck.getTime() >= d.from.getTime() &&
                dateToCheck.getTime() <= d.to.getTime())
                return bool;
        }
        return !bool;
    }
    function isInView(elem) {
        if (self.daysContainer !== undefined)
            return (elem.className.indexOf("hidden") === -1 &&
                elem.className.indexOf("flatpickr-disabled") === -1 &&
                self.daysContainer.contains(elem));
        return false;
    }
    function onBlur(e) {
        var isInput = e.target === self._input;
        var valueChanged = self._input.value.trimEnd() !== getDateStr();
        if (isInput &&
            valueChanged &&
            !(e.relatedTarget && isCalendarElem(e.relatedTarget))) {
            self.setDate(self._input.value, true, e.target === self.altInput
                ? self.config.altFormat
                : self.config.dateFormat);
        }
    }
    function onKeyDown(e) {
        var eventTarget = Object(__WEBPACK_IMPORTED_MODULE_3__utils_dom__["e" /* getEventTarget */])(e);
        var isInput = self.config.wrap
            ? element.contains(eventTarget)
            : eventTarget === self._input;
        var allowInput = self.config.allowInput;
        var allowKeydown = self.isOpen && (!allowInput || !isInput);
        var allowInlineKeydown = self.config.inline && isInput && !allowInput;
        if (e.keyCode === 13 && isInput) {
            if (allowInput) {
                self.setDate(self._input.value, true, eventTarget === self.altInput
                    ? self.config.altFormat
                    : self.config.dateFormat);
                self.close();
                return eventTarget.blur();
            }
            else {
                self.open();
            }
        }
        else if (isCalendarElem(eventTarget) ||
            allowKeydown ||
            allowInlineKeydown) {
            var isTimeObj = !!self.timeContainer &&
                self.timeContainer.contains(eventTarget);
            switch (e.keyCode) {
                case 13:
                    if (isTimeObj) {
                        e.preventDefault();
                        updateTime();
                        focusAndClose();
                    }
                    else
                        selectDate(e);
                    break;
                case 27:
                    e.preventDefault();
                    focusAndClose();
                    break;
                case 8:
                case 46:
                    if (isInput && !self.config.allowInput) {
                        e.preventDefault();
                        self.clear();
                    }
                    break;
                case 37:
                case 39:
                    if (!isTimeObj && !isInput) {
                        e.preventDefault();
                        var activeElement = getClosestActiveElement();
                        if (self.daysContainer !== undefined &&
                            (allowInput === false ||
                                (activeElement && isInView(activeElement)))) {
                            var delta_1 = e.keyCode === 39 ? 1 : -1;
                            if (!e.ctrlKey)
                                focusOnDay(undefined, delta_1);
                            else {
                                e.stopPropagation();
                                changeMonth(delta_1);
                                focusOnDay(getFirstAvailableDay(1), 0);
                            }
                        }
                    }
                    else if (self.hourElement)
                        self.hourElement.focus();
                    break;
                case 38:
                case 40:
                    e.preventDefault();
                    var delta = e.keyCode === 40 ? 1 : -1;
                    if ((self.daysContainer &&
                        eventTarget.$i !== undefined) ||
                        eventTarget === self.input ||
                        eventTarget === self.altInput) {
                        if (e.ctrlKey) {
                            e.stopPropagation();
                            changeYear(self.currentYear - delta);
                            focusOnDay(getFirstAvailableDay(1), 0);
                        }
                        else if (!isTimeObj)
                            focusOnDay(undefined, delta * 7);
                    }
                    else if (eventTarget === self.currentYearElement) {
                        changeYear(self.currentYear - delta);
                    }
                    else if (self.config.enableTime) {
                        if (!isTimeObj && self.hourElement)
                            self.hourElement.focus();
                        updateTime(e);
                        self._debouncedChange();
                    }
                    break;
                case 9:
                    if (isTimeObj) {
                        var elems = [
                            self.hourElement,
                            self.minuteElement,
                            self.secondElement,
                            self.amPM,
                        ]
                            .concat(self.pluginElements)
                            .filter(function (x) { return x; });
                        var i = elems.indexOf(eventTarget);
                        if (i !== -1) {
                            var target = elems[i + (e.shiftKey ? -1 : 1)];
                            e.preventDefault();
                            (target || self._input).focus();
                        }
                    }
                    else if (!self.config.noCalendar &&
                        self.daysContainer &&
                        self.daysContainer.contains(eventTarget) &&
                        e.shiftKey) {
                        e.preventDefault();
                        self._input.focus();
                    }
                    break;
                default:
                    break;
            }
        }
        if (self.amPM !== undefined && eventTarget === self.amPM) {
            switch (e.key) {
                case self.l10n.amPM[0].charAt(0):
                case self.l10n.amPM[0].charAt(0).toLowerCase():
                    self.amPM.textContent = self.l10n.amPM[0];
                    setHoursFromInputs();
                    updateValue();
                    break;
                case self.l10n.amPM[1].charAt(0):
                case self.l10n.amPM[1].charAt(0).toLowerCase():
                    self.amPM.textContent = self.l10n.amPM[1];
                    setHoursFromInputs();
                    updateValue();
                    break;
            }
        }
        if (isInput || isCalendarElem(eventTarget)) {
            triggerEvent("onKeyDown", e);
        }
    }
    function onMouseOver(elem, cellClass) {
        if (cellClass === void 0) { cellClass = "flatpickr-day"; }
        if (self.selectedDates.length !== 1 ||
            (elem &&
                (!elem.classList.contains(cellClass) ||
                    elem.classList.contains("flatpickr-disabled"))))
            return;
        var hoverDate = elem
            ? elem.dateObj.getTime()
            : self.days.firstElementChild.dateObj.getTime(), initialDate = self.parseDate(self.selectedDates[0], undefined, true).getTime(), rangeStartDate = Math.min(hoverDate, self.selectedDates[0].getTime()), rangeEndDate = Math.max(hoverDate, self.selectedDates[0].getTime());
        var containsDisabled = false;
        var minRange = 0, maxRange = 0;
        for (var t = rangeStartDate; t < rangeEndDate; t += __WEBPACK_IMPORTED_MODULE_4__utils_dates__["e" /* duration */].DAY) {
            if (!isEnabled(new Date(t), true)) {
                containsDisabled =
                    containsDisabled || (t > rangeStartDate && t < rangeEndDate);
                if (t < initialDate && (!minRange || t > minRange))
                    minRange = t;
                else if (t > initialDate && (!maxRange || t < maxRange))
                    maxRange = t;
            }
        }
        var hoverableCells = Array.from(self.rContainer.querySelectorAll("*:nth-child(-n+" + self.config.showMonths + ") > ." + cellClass));
        hoverableCells.forEach(function (dayElem) {
            var date = dayElem.dateObj;
            var timestamp = date.getTime();
            var outOfRange = (minRange > 0 && timestamp < minRange) ||
                (maxRange > 0 && timestamp > maxRange);
            if (outOfRange) {
                dayElem.classList.add("notAllowed");
                ["inRange", "startRange", "endRange"].forEach(function (c) {
                    dayElem.classList.remove(c);
                });
                return;
            }
            else if (containsDisabled && !outOfRange)
                return;
            ["startRange", "inRange", "endRange", "notAllowed"].forEach(function (c) {
                dayElem.classList.remove(c);
            });
            if (elem !== undefined) {
                elem.classList.add(hoverDate <= self.selectedDates[0].getTime()
                    ? "startRange"
                    : "endRange");
                if (initialDate < hoverDate && timestamp === initialDate)
                    dayElem.classList.add("startRange");
                else if (initialDate > hoverDate && timestamp === initialDate)
                    dayElem.classList.add("endRange");
                if (timestamp >= minRange &&
                    (maxRange === 0 || timestamp <= maxRange) &&
                    Object(__WEBPACK_IMPORTED_MODULE_4__utils_dates__["g" /* isBetween */])(timestamp, initialDate, hoverDate))
                    dayElem.classList.add("inRange");
            }
        });
    }
    function onResize() {
        if (self.isOpen && !self.config.static && !self.config.inline)
            positionCalendar();
    }
    function open(e, positionElement) {
        if (positionElement === void 0) { positionElement = self._positionElement; }
        if (self.isMobile === true) {
            if (e) {
                e.preventDefault();
                var eventTarget = Object(__WEBPACK_IMPORTED_MODULE_3__utils_dom__["e" /* getEventTarget */])(e);
                if (eventTarget) {
                    eventTarget.blur();
                }
            }
            if (self.mobileInput !== undefined) {
                self.mobileInput.focus();
                self.mobileInput.click();
            }
            triggerEvent("onOpen");
            return;
        }
        else if (self._input.disabled || self.config.inline) {
            return;
        }
        var wasOpen = self.isOpen;
        self.isOpen = true;
        if (!wasOpen) {
            self.calendarContainer.classList.add("open");
            self._input.classList.add("active");
            triggerEvent("onOpen");
            positionCalendar(positionElement);
        }
        if (self.config.enableTime === true && self.config.noCalendar === true) {
            if (self.config.allowInput === false &&
                (e === undefined ||
                    !self.timeContainer.contains(e.relatedTarget))) {
                setTimeout(function () { return self.hourElement.select(); }, 50);
            }
        }
    }
    function minMaxDateSetter(type) {
        return function (date) {
            var dateObj = (self.config["_" + type + "Date"] = self.parseDate(date, self.config.dateFormat));
            var inverseDateObj = self.config["_" + (type === "min" ? "max" : "min") + "Date"];
            if (dateObj !== undefined) {
                self[type === "min" ? "minDateHasTime" : "maxDateHasTime"] =
                    dateObj.getHours() > 0 ||
                        dateObj.getMinutes() > 0 ||
                        dateObj.getSeconds() > 0;
            }
            if (self.selectedDates) {
                self.selectedDates = self.selectedDates.filter(function (d) { return isEnabled(d); });
                if (!self.selectedDates.length && type === "min")
                    setHoursFromDate(dateObj);
                updateValue();
            }
            if (self.daysContainer) {
                redraw();
                if (dateObj !== undefined)
                    self.currentYearElement[type] = dateObj.getFullYear().toString();
                else
                    self.currentYearElement.removeAttribute(type);
                self.currentYearElement.disabled =
                    !!inverseDateObj &&
                        dateObj !== undefined &&
                        inverseDateObj.getFullYear() === dateObj.getFullYear();
            }
        };
    }
    function parseConfig() {
        var boolOpts = [
            "wrap",
            "weekNumbers",
            "allowInput",
            "allowInvalidPreload",
            "clickOpens",
            "time_24hr",
            "enableTime",
            "noCalendar",
            "altInput",
            "shorthandCurrentMonth",
            "inline",
            "static",
            "enableSeconds",
            "disableMobile",
        ];
        var userConfig = __assign(__assign({}, JSON.parse(JSON.stringify(element.dataset || {}))), instanceConfig);
        var formats = {};
        self.config.parseDate = userConfig.parseDate;
        self.config.formatDate = userConfig.formatDate;
        Object.defineProperty(self.config, "enable", {
            get: function () { return self.config._enable; },
            set: function (dates) {
                self.config._enable = parseDateRules(dates);
            },
        });
        Object.defineProperty(self.config, "disable", {
            get: function () { return self.config._disable; },
            set: function (dates) {
                self.config._disable = parseDateRules(dates);
            },
        });
        var timeMode = userConfig.mode === "time";
        if (!userConfig.dateFormat && (userConfig.enableTime || timeMode)) {
            var defaultDateFormat = flatpickr.defaultConfig.dateFormat || __WEBPACK_IMPORTED_MODULE_0__types_options__["b" /* defaults */].dateFormat;
            formats.dateFormat =
                userConfig.noCalendar || timeMode
                    ? "H:i" + (userConfig.enableSeconds ? ":S" : "")
                    : defaultDateFormat + " H:i" + (userConfig.enableSeconds ? ":S" : "");
        }
        if (userConfig.altInput &&
            (userConfig.enableTime || timeMode) &&
            !userConfig.altFormat) {
            var defaultAltFormat = flatpickr.defaultConfig.altFormat || __WEBPACK_IMPORTED_MODULE_0__types_options__["b" /* defaults */].altFormat;
            formats.altFormat =
                userConfig.noCalendar || timeMode
                    ? "h:i" + (userConfig.enableSeconds ? ":S K" : " K")
                    : defaultAltFormat + (" h:i" + (userConfig.enableSeconds ? ":S" : "") + " K");
        }
        Object.defineProperty(self.config, "minDate", {
            get: function () { return self.config._minDate; },
            set: minMaxDateSetter("min"),
        });
        Object.defineProperty(self.config, "maxDate", {
            get: function () { return self.config._maxDate; },
            set: minMaxDateSetter("max"),
        });
        var minMaxTimeSetter = function (type) { return function (val) {
            self.config[type === "min" ? "_minTime" : "_maxTime"] = self.parseDate(val, "H:i:S");
        }; };
        Object.defineProperty(self.config, "minTime", {
            get: function () { return self.config._minTime; },
            set: minMaxTimeSetter("min"),
        });
        Object.defineProperty(self.config, "maxTime", {
            get: function () { return self.config._maxTime; },
            set: minMaxTimeSetter("max"),
        });
        if (userConfig.mode === "time") {
            self.config.noCalendar = true;
            self.config.enableTime = true;
        }
        Object.assign(self.config, formats, userConfig);
        for (var i = 0; i < boolOpts.length; i++)
            self.config[boolOpts[i]] =
                self.config[boolOpts[i]] === true ||
                    self.config[boolOpts[i]] === "true";
        __WEBPACK_IMPORTED_MODULE_0__types_options__["a" /* HOOKS */].filter(function (hook) { return self.config[hook] !== undefined; }).forEach(function (hook) {
            self.config[hook] = Object(__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* arrayify */])(self.config[hook] || []).map(bindToInstance);
        });
        self.isMobile =
            !self.config.disableMobile &&
                !self.config.inline &&
                self.config.mode === "single" &&
                !self.config.disable.length &&
                !self.config.enable &&
                !self.config.weekNumbers &&
                /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
        for (var i = 0; i < self.config.plugins.length; i++) {
            var pluginConf = self.config.plugins[i](self) || {};
            for (var key in pluginConf) {
                if (__WEBPACK_IMPORTED_MODULE_0__types_options__["a" /* HOOKS */].indexOf(key) > -1) {
                    self.config[key] = Object(__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* arrayify */])(pluginConf[key])
                        .map(bindToInstance)
                        .concat(self.config[key]);
                }
                else if (typeof userConfig[key] === "undefined")
                    self.config[key] = pluginConf[key];
            }
        }
        if (!userConfig.altInputClass) {
            self.config.altInputClass =
                getInputElem().className + " " + self.config.altInputClass;
        }
        triggerEvent("onParseConfig");
    }
    function getInputElem() {
        return self.config.wrap
            ? element.querySelector("[data-input]")
            : element;
    }
    function setupLocale() {
        if (typeof self.config.locale !== "object" &&
            typeof flatpickr.l10ns[self.config.locale] === "undefined")
            self.config.errorHandler(new Error("flatpickr: invalid locale " + self.config.locale));
        self.l10n = __assign(__assign({}, flatpickr.l10ns.default), (typeof self.config.locale === "object"
            ? self.config.locale
            : self.config.locale !== "default"
                ? flatpickr.l10ns[self.config.locale]
                : undefined));
        __WEBPACK_IMPORTED_MODULE_5__utils_formatting__["d" /* tokenRegex */].D = "(" + self.l10n.weekdays.shorthand.join("|") + ")";
        __WEBPACK_IMPORTED_MODULE_5__utils_formatting__["d" /* tokenRegex */].l = "(" + self.l10n.weekdays.longhand.join("|") + ")";
        __WEBPACK_IMPORTED_MODULE_5__utils_formatting__["d" /* tokenRegex */].M = "(" + self.l10n.months.shorthand.join("|") + ")";
        __WEBPACK_IMPORTED_MODULE_5__utils_formatting__["d" /* tokenRegex */].F = "(" + self.l10n.months.longhand.join("|") + ")";
        __WEBPACK_IMPORTED_MODULE_5__utils_formatting__["d" /* tokenRegex */].K = "(" + self.l10n.amPM[0] + "|" + self.l10n.amPM[1] + "|" + self.l10n.amPM[0].toLowerCase() + "|" + self.l10n.amPM[1].toLowerCase() + ")";
        var userConfig = __assign(__assign({}, instanceConfig), JSON.parse(JSON.stringify(element.dataset || {})));
        if (userConfig.time_24hr === undefined &&
            flatpickr.defaultConfig.time_24hr === undefined) {
            self.config.time_24hr = self.l10n.time_24hr;
        }
        self.formatDate = Object(__WEBPACK_IMPORTED_MODULE_4__utils_dates__["c" /* createDateFormatter */])(self);
        self.parseDate = Object(__WEBPACK_IMPORTED_MODULE_4__utils_dates__["d" /* createDateParser */])({ config: self.config, l10n: self.l10n });
    }
    function positionCalendar(customPositionElement) {
        if (typeof self.config.position === "function") {
            return void self.config.position(self, customPositionElement);
        }
        if (self.calendarContainer === undefined)
            return;
        triggerEvent("onPreCalendarPosition");
        var positionElement = customPositionElement || self._positionElement;
        var calendarHeight = Array.prototype.reduce.call(self.calendarContainer.children, (function (acc, child) { return acc + child.offsetHeight; }), 0), calendarWidth = self.calendarContainer.offsetWidth, configPos = self.config.position.split(" "), configPosVertical = configPos[0], configPosHorizontal = configPos.length > 1 ? configPos[1] : null, inputBounds = positionElement.getBoundingClientRect(), distanceFromBottom = window.innerHeight - inputBounds.bottom, showOnTop = configPosVertical === "above" ||
            (configPosVertical !== "below" &&
                distanceFromBottom < calendarHeight &&
                inputBounds.top > calendarHeight);
        var top = window.pageYOffset +
            inputBounds.top +
            (!showOnTop ? positionElement.offsetHeight + 2 : -calendarHeight - 2);
        Object(__WEBPACK_IMPORTED_MODULE_3__utils_dom__["f" /* toggleClass */])(self.calendarContainer, "arrowTop", !showOnTop);
        Object(__WEBPACK_IMPORTED_MODULE_3__utils_dom__["f" /* toggleClass */])(self.calendarContainer, "arrowBottom", showOnTop);
        if (self.config.inline)
            return;
        var left = window.pageXOffset + inputBounds.left;
        var isCenter = false;
        var isRight = false;
        if (configPosHorizontal === "center") {
            left -= (calendarWidth - inputBounds.width) / 2;
            isCenter = true;
        }
        else if (configPosHorizontal === "right") {
            left -= calendarWidth - inputBounds.width;
            isRight = true;
        }
        Object(__WEBPACK_IMPORTED_MODULE_3__utils_dom__["f" /* toggleClass */])(self.calendarContainer, "arrowLeft", !isCenter && !isRight);
        Object(__WEBPACK_IMPORTED_MODULE_3__utils_dom__["f" /* toggleClass */])(self.calendarContainer, "arrowCenter", isCenter);
        Object(__WEBPACK_IMPORTED_MODULE_3__utils_dom__["f" /* toggleClass */])(self.calendarContainer, "arrowRight", isRight);
        var right = window.document.body.offsetWidth -
            (window.pageXOffset + inputBounds.right);
        var rightMost = left + calendarWidth > window.document.body.offsetWidth;
        var centerMost = right + calendarWidth > window.document.body.offsetWidth;
        Object(__WEBPACK_IMPORTED_MODULE_3__utils_dom__["f" /* toggleClass */])(self.calendarContainer, "rightMost", rightMost);
        if (self.config.static)
            return;
        self.calendarContainer.style.top = top + "px";
        if (!rightMost) {
            self.calendarContainer.style.left = left + "px";
            self.calendarContainer.style.right = "auto";
        }
        else if (!centerMost) {
            self.calendarContainer.style.left = "auto";
            self.calendarContainer.style.right = right + "px";
        }
        else {
            var doc = getDocumentStyleSheet();
            if (doc === undefined)
                return;
            var bodyWidth = window.document.body.offsetWidth;
            var centerLeft = Math.max(0, bodyWidth / 2 - calendarWidth / 2);
            var centerBefore = ".flatpickr-calendar.centerMost:before";
            var centerAfter = ".flatpickr-calendar.centerMost:after";
            var centerIndex = doc.cssRules.length;
            var centerStyle = "{left:" + inputBounds.left + "px;right:auto;}";
            Object(__WEBPACK_IMPORTED_MODULE_3__utils_dom__["f" /* toggleClass */])(self.calendarContainer, "rightMost", false);
            Object(__WEBPACK_IMPORTED_MODULE_3__utils_dom__["f" /* toggleClass */])(self.calendarContainer, "centerMost", true);
            doc.insertRule(centerBefore + "," + centerAfter + centerStyle, centerIndex);
            self.calendarContainer.style.left = centerLeft + "px";
            self.calendarContainer.style.right = "auto";
        }
    }
    function getDocumentStyleSheet() {
        var editableSheet = null;
        for (var i = 0; i < document.styleSheets.length; i++) {
            var sheet = document.styleSheets[i];
            if (!sheet.cssRules)
                continue;
            try {
                sheet.cssRules;
            }
            catch (err) {
                continue;
            }
            editableSheet = sheet;
            break;
        }
        return editableSheet != null ? editableSheet : createStyleSheet();
    }
    function createStyleSheet() {
        var style = document.createElement("style");
        document.head.appendChild(style);
        return style.sheet;
    }
    function redraw() {
        if (self.config.noCalendar || self.isMobile)
            return;
        buildMonthSwitch();
        updateNavigationCurrentMonth();
        buildDays();
    }
    function focusAndClose() {
        self._input.focus();
        if (window.navigator.userAgent.indexOf("MSIE") !== -1 ||
            navigator.msMaxTouchPoints !== undefined) {
            setTimeout(self.close, 0);
        }
        else {
            self.close();
        }
    }
    function selectDate(e) {
        e.preventDefault();
        e.stopPropagation();
        var isSelectable = function (day) {
            return day.classList &&
                day.classList.contains("flatpickr-day") &&
                !day.classList.contains("flatpickr-disabled") &&
                !day.classList.contains("notAllowed");
        };
        var t = Object(__WEBPACK_IMPORTED_MODULE_3__utils_dom__["d" /* findParent */])(Object(__WEBPACK_IMPORTED_MODULE_3__utils_dom__["e" /* getEventTarget */])(e), isSelectable);
        if (t === undefined)
            return;
        var target = t;
        var selectedDate = (self.latestSelectedDateObj = new Date(target.dateObj.getTime()));
        var shouldChangeMonth = (selectedDate.getMonth() < self.currentMonth ||
            selectedDate.getMonth() >
                self.currentMonth + self.config.showMonths - 1) &&
            self.config.mode !== "range";
        self.selectedDateElem = target;
        if (self.config.mode === "single")
            self.selectedDates = [selectedDate];
        else if (self.config.mode === "multiple") {
            var selectedIndex = isDateSelected(selectedDate);
            if (selectedIndex)
                self.selectedDates.splice(parseInt(selectedIndex), 1);
            else
                self.selectedDates.push(selectedDate);
        }
        else if (self.config.mode === "range") {
            if (self.selectedDates.length === 2) {
                self.clear(false, false);
            }
            self.latestSelectedDateObj = selectedDate;
            self.selectedDates.push(selectedDate);
            if (Object(__WEBPACK_IMPORTED_MODULE_4__utils_dates__["b" /* compareDates */])(selectedDate, self.selectedDates[0], true) !== 0)
                self.selectedDates.sort(function (a, b) { return a.getTime() - b.getTime(); });
        }
        setHoursFromInputs();
        if (shouldChangeMonth) {
            var isNewYear = self.currentYear !== selectedDate.getFullYear();
            self.currentYear = selectedDate.getFullYear();
            self.currentMonth = selectedDate.getMonth();
            if (isNewYear) {
                triggerEvent("onYearChange");
                buildMonthSwitch();
            }
            triggerEvent("onMonthChange");
        }
        updateNavigationCurrentMonth();
        buildDays();
        updateValue();
        if (!shouldChangeMonth &&
            self.config.mode !== "range" &&
            self.config.showMonths === 1)
            focusOnDayElem(target);
        else if (self.selectedDateElem !== undefined &&
            self.hourElement === undefined) {
            self.selectedDateElem && self.selectedDateElem.focus();
        }
        if (self.hourElement !== undefined)
            self.hourElement !== undefined && self.hourElement.focus();
        if (self.config.closeOnSelect) {
            var single = self.config.mode === "single" && !self.config.enableTime;
            var range = self.config.mode === "range" &&
                self.selectedDates.length === 2 &&
                !self.config.enableTime;
            if (single || range) {
                focusAndClose();
            }
        }
        triggerChange();
    }
    var CALLBACKS = {
        locale: [setupLocale, updateWeekdays],
        showMonths: [buildMonths, setCalendarWidth, buildWeekdays],
        minDate: [jumpToDate],
        maxDate: [jumpToDate],
        positionElement: [updatePositionElement],
        clickOpens: [
            function () {
                if (self.config.clickOpens === true) {
                    bind(self._input, "focus", self.open);
                    bind(self._input, "click", self.open);
                }
                else {
                    self._input.removeEventListener("focus", self.open);
                    self._input.removeEventListener("click", self.open);
                }
            },
        ],
    };
    function set(option, value) {
        if (option !== null && typeof option === "object") {
            Object.assign(self.config, option);
            for (var key in option) {
                if (CALLBACKS[key] !== undefined)
                    CALLBACKS[key].forEach(function (x) { return x(); });
            }
        }
        else {
            self.config[option] = value;
            if (CALLBACKS[option] !== undefined)
                CALLBACKS[option].forEach(function (x) { return x(); });
            else if (__WEBPACK_IMPORTED_MODULE_0__types_options__["a" /* HOOKS */].indexOf(option) > -1)
                self.config[option] = Object(__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* arrayify */])(value);
        }
        self.redraw();
        updateValue(true);
    }
    function setSelectedDate(inputDate, format) {
        var dates = [];
        if (inputDate instanceof Array)
            dates = inputDate.map(function (d) { return self.parseDate(d, format); });
        else if (inputDate instanceof Date || typeof inputDate === "number")
            dates = [self.parseDate(inputDate, format)];
        else if (typeof inputDate === "string") {
            switch (self.config.mode) {
                case "single":
                case "time":
                    dates = [self.parseDate(inputDate, format)];
                    break;
                case "multiple":
                    dates = inputDate
                        .split(self.config.conjunction)
                        .map(function (date) { return self.parseDate(date, format); });
                    break;
                case "range":
                    dates = inputDate
                        .split(self.l10n.rangeSeparator)
                        .map(function (date) { return self.parseDate(date, format); });
                    break;
                default:
                    break;
            }
        }
        else
            self.config.errorHandler(new Error("Invalid date supplied: " + JSON.stringify(inputDate)));
        self.selectedDates = (self.config.allowInvalidPreload
            ? dates
            : dates.filter(function (d) { return d instanceof Date && isEnabled(d, false); }));
        if (self.config.mode === "range")
            self.selectedDates.sort(function (a, b) { return a.getTime() - b.getTime(); });
    }
    function setDate(date, triggerChange, format) {
        if (triggerChange === void 0) { triggerChange = false; }
        if (format === void 0) { format = self.config.dateFormat; }
        if ((date !== 0 && !date) || (date instanceof Array && date.length === 0))
            return self.clear(triggerChange);
        setSelectedDate(date, format);
        self.latestSelectedDateObj =
            self.selectedDates[self.selectedDates.length - 1];
        self.redraw();
        jumpToDate(undefined, triggerChange);
        setHoursFromDate();
        if (self.selectedDates.length === 0) {
            self.clear(false);
        }
        updateValue(triggerChange);
        if (triggerChange)
            triggerEvent("onChange");
    }
    function parseDateRules(arr) {
        return arr
            .slice()
            .map(function (rule) {
            if (typeof rule === "string" ||
                typeof rule === "number" ||
                rule instanceof Date) {
                return self.parseDate(rule, undefined, true);
            }
            else if (rule &&
                typeof rule === "object" &&
                rule.from &&
                rule.to)
                return {
                    from: self.parseDate(rule.from, undefined),
                    to: self.parseDate(rule.to, undefined),
                };
            return rule;
        })
            .filter(function (x) { return x; });
    }
    function setupDates() {
        self.selectedDates = [];
        self.now = self.parseDate(self.config.now) || new Date();
        var preloadedDate = self.config.defaultDate ||
            ((self.input.nodeName === "INPUT" ||
                self.input.nodeName === "TEXTAREA") &&
                self.input.placeholder &&
                self.input.value === self.input.placeholder
                ? null
                : self.input.value);
        if (preloadedDate)
            setSelectedDate(preloadedDate, self.config.dateFormat);
        self._initialDate =
            self.selectedDates.length > 0
                ? self.selectedDates[0]
                : self.config.minDate &&
                    self.config.minDate.getTime() > self.now.getTime()
                    ? self.config.minDate
                    : self.config.maxDate &&
                        self.config.maxDate.getTime() < self.now.getTime()
                        ? self.config.maxDate
                        : self.now;
        self.currentYear = self._initialDate.getFullYear();
        self.currentMonth = self._initialDate.getMonth();
        if (self.selectedDates.length > 0)
            self.latestSelectedDateObj = self.selectedDates[0];
        if (self.config.minTime !== undefined)
            self.config.minTime = self.parseDate(self.config.minTime, "H:i");
        if (self.config.maxTime !== undefined)
            self.config.maxTime = self.parseDate(self.config.maxTime, "H:i");
        self.minDateHasTime =
            !!self.config.minDate &&
                (self.config.minDate.getHours() > 0 ||
                    self.config.minDate.getMinutes() > 0 ||
                    self.config.minDate.getSeconds() > 0);
        self.maxDateHasTime =
            !!self.config.maxDate &&
                (self.config.maxDate.getHours() > 0 ||
                    self.config.maxDate.getMinutes() > 0 ||
                    self.config.maxDate.getSeconds() > 0);
    }
    function setupInputs() {
        self.input = getInputElem();
        if (!self.input) {
            self.config.errorHandler(new Error("Invalid input element specified"));
            return;
        }
        self.input._type = self.input.type;
        self.input.type = "text";
        self.input.classList.add("flatpickr-input");
        self._input = self.input;
        if (self.config.altInput) {
            self.altInput = Object(__WEBPACK_IMPORTED_MODULE_3__utils_dom__["b" /* createElement */])(self.input.nodeName, self.config.altInputClass);
            self._input = self.altInput;
            self.altInput.placeholder = self.input.placeholder;
            self.altInput.disabled = self.input.disabled;
            self.altInput.required = self.input.required;
            self.altInput.tabIndex = self.input.tabIndex;
            self.altInput.type = "text";
            self.input.setAttribute("type", "hidden");
            if (!self.config.static && self.input.parentNode)
                self.input.parentNode.insertBefore(self.altInput, self.input.nextSibling);
        }
        if (!self.config.allowInput)
            self._input.setAttribute("readonly", "readonly");
        updatePositionElement();
    }
    function updatePositionElement() {
        self._positionElement = self.config.positionElement || self._input;
    }
    function setupMobile() {
        var inputType = self.config.enableTime
            ? self.config.noCalendar
                ? "time"
                : "datetime-local"
            : "date";
        self.mobileInput = Object(__WEBPACK_IMPORTED_MODULE_3__utils_dom__["b" /* createElement */])("input", self.input.className + " flatpickr-mobile");
        self.mobileInput.tabIndex = 1;
        self.mobileInput.type = inputType;
        self.mobileInput.disabled = self.input.disabled;
        self.mobileInput.required = self.input.required;
        self.mobileInput.placeholder = self.input.placeholder;
        self.mobileFormatStr =
            inputType === "datetime-local"
                ? "Y-m-d\\TH:i:S"
                : inputType === "date"
                    ? "Y-m-d"
                    : "H:i:S";
        if (self.selectedDates.length > 0) {
            self.mobileInput.defaultValue = self.mobileInput.value = self.formatDate(self.selectedDates[0], self.mobileFormatStr);
        }
        if (self.config.minDate)
            self.mobileInput.min = self.formatDate(self.config.minDate, "Y-m-d");
        if (self.config.maxDate)
            self.mobileInput.max = self.formatDate(self.config.maxDate, "Y-m-d");
        if (self.input.getAttribute("step"))
            self.mobileInput.step = String(self.input.getAttribute("step"));
        self.input.type = "hidden";
        if (self.altInput !== undefined)
            self.altInput.type = "hidden";
        try {
            if (self.input.parentNode)
                self.input.parentNode.insertBefore(self.mobileInput, self.input.nextSibling);
        }
        catch (_a) { }
        bind(self.mobileInput, "change", function (e) {
            self.setDate(Object(__WEBPACK_IMPORTED_MODULE_3__utils_dom__["e" /* getEventTarget */])(e).value, false, self.mobileFormatStr);
            triggerEvent("onChange");
            triggerEvent("onClose");
        });
    }
    function toggle(e) {
        if (self.isOpen === true)
            return self.close();
        self.open(e);
    }
    function triggerEvent(event, data) {
        if (self.config === undefined)
            return;
        var hooks = self.config[event];
        if (hooks !== undefined && hooks.length > 0) {
            for (var i = 0; hooks[i] && i < hooks.length; i++)
                hooks[i](self.selectedDates, self.input.value, self, data);
        }
        if (event === "onChange") {
            self.input.dispatchEvent(createEvent("change"));
            self.input.dispatchEvent(createEvent("input"));
        }
    }
    function createEvent(name) {
        var e = document.createEvent("Event");
        e.initEvent(name, true, true);
        return e;
    }
    function isDateSelected(date) {
        for (var i = 0; i < self.selectedDates.length; i++) {
            var selectedDate = self.selectedDates[i];
            if (selectedDate instanceof Date &&
                Object(__WEBPACK_IMPORTED_MODULE_4__utils_dates__["b" /* compareDates */])(selectedDate, date) === 0)
                return "" + i;
        }
        return false;
    }
    function isDateInRange(date) {
        if (self.config.mode !== "range" || self.selectedDates.length < 2)
            return false;
        return (Object(__WEBPACK_IMPORTED_MODULE_4__utils_dates__["b" /* compareDates */])(date, self.selectedDates[0]) >= 0 &&
            Object(__WEBPACK_IMPORTED_MODULE_4__utils_dates__["b" /* compareDates */])(date, self.selectedDates[1]) <= 0);
    }
    function updateNavigationCurrentMonth() {
        if (self.config.noCalendar || self.isMobile || !self.monthNav)
            return;
        self.yearElements.forEach(function (yearElement, i) {
            var d = new Date(self.currentYear, self.currentMonth, 1);
            d.setMonth(self.currentMonth + i);
            if (self.config.showMonths > 1 ||
                self.config.monthSelectorType === "static") {
                self.monthElements[i].textContent =
                    Object(__WEBPACK_IMPORTED_MODULE_5__utils_formatting__["b" /* monthToStr */])(d.getMonth(), self.config.shorthandCurrentMonth, self.l10n) + " ";
            }
            else {
                self.monthsDropdownContainer.value = d.getMonth().toString();
            }
            yearElement.value = d.getFullYear().toString();
        });
        self._hidePrevMonthArrow =
            self.config.minDate !== undefined &&
                (self.currentYear === self.config.minDate.getFullYear()
                    ? self.currentMonth <= self.config.minDate.getMonth()
                    : self.currentYear < self.config.minDate.getFullYear());
        self._hideNextMonthArrow =
            self.config.maxDate !== undefined &&
                (self.currentYear === self.config.maxDate.getFullYear()
                    ? self.currentMonth + 1 > self.config.maxDate.getMonth()
                    : self.currentYear > self.config.maxDate.getFullYear());
    }
    function getDateStr(specificFormat) {
        var format = specificFormat ||
            (self.config.altInput ? self.config.altFormat : self.config.dateFormat);
        return self.selectedDates
            .map(function (dObj) { return self.formatDate(dObj, format); })
            .filter(function (d, i, arr) {
            return self.config.mode !== "range" ||
                self.config.enableTime ||
                arr.indexOf(d) === i;
        })
            .join(self.config.mode !== "range"
            ? self.config.conjunction
            : self.l10n.rangeSeparator);
    }
    function updateValue(triggerChange) {
        if (triggerChange === void 0) { triggerChange = true; }
        if (self.mobileInput !== undefined && self.mobileFormatStr) {
            self.mobileInput.value =
                self.latestSelectedDateObj !== undefined
                    ? self.formatDate(self.latestSelectedDateObj, self.mobileFormatStr)
                    : "";
        }
        self.input.value = getDateStr(self.config.dateFormat);
        if (self.altInput !== undefined) {
            self.altInput.value = getDateStr(self.config.altFormat);
        }
        if (triggerChange !== false)
            triggerEvent("onValueUpdate");
    }
    function onMonthNavClick(e) {
        var eventTarget = Object(__WEBPACK_IMPORTED_MODULE_3__utils_dom__["e" /* getEventTarget */])(e);
        var isPrevMonth = self.prevMonthNav.contains(eventTarget);
        var isNextMonth = self.nextMonthNav.contains(eventTarget);
        if (isPrevMonth || isNextMonth) {
            changeMonth(isPrevMonth ? -1 : 1);
        }
        else if (self.yearElements.indexOf(eventTarget) >= 0) {
            eventTarget.select();
        }
        else if (eventTarget.classList.contains("arrowUp")) {
            self.changeYear(self.currentYear + 1);
        }
        else if (eventTarget.classList.contains("arrowDown")) {
            self.changeYear(self.currentYear - 1);
        }
    }
    function timeWrapper(e) {
        e.preventDefault();
        var isKeyDown = e.type === "keydown", eventTarget = Object(__WEBPACK_IMPORTED_MODULE_3__utils_dom__["e" /* getEventTarget */])(e), input = eventTarget;
        if (self.amPM !== undefined && eventTarget === self.amPM) {
            self.amPM.textContent =
                self.l10n.amPM[Object(__WEBPACK_IMPORTED_MODULE_2__utils__["c" /* int */])(self.amPM.textContent === self.l10n.amPM[0])];
        }
        var min = parseFloat(input.getAttribute("min")), max = parseFloat(input.getAttribute("max")), step = parseFloat(input.getAttribute("step")), curValue = parseInt(input.value, 10), delta = e.delta ||
            (isKeyDown ? (e.which === 38 ? 1 : -1) : 0);
        var newValue = curValue + step * delta;
        if (typeof input.value !== "undefined" && input.value.length === 2) {
            var isHourElem = input === self.hourElement, isMinuteElem = input === self.minuteElement;
            if (newValue < min) {
                newValue =
                    max +
                        newValue +
                        Object(__WEBPACK_IMPORTED_MODULE_2__utils__["c" /* int */])(!isHourElem) +
                        (Object(__WEBPACK_IMPORTED_MODULE_2__utils__["c" /* int */])(isHourElem) && Object(__WEBPACK_IMPORTED_MODULE_2__utils__["c" /* int */])(!self.amPM));
                if (isMinuteElem)
                    incrementNumInput(undefined, -1, self.hourElement);
            }
            else if (newValue > max) {
                newValue =
                    input === self.hourElement ? newValue - max - Object(__WEBPACK_IMPORTED_MODULE_2__utils__["c" /* int */])(!self.amPM) : min;
                if (isMinuteElem)
                    incrementNumInput(undefined, 1, self.hourElement);
            }
            if (self.amPM &&
                isHourElem &&
                (step === 1
                    ? newValue + curValue === 23
                    : Math.abs(newValue - curValue) > step)) {
                self.amPM.textContent =
                    self.l10n.amPM[Object(__WEBPACK_IMPORTED_MODULE_2__utils__["c" /* int */])(self.amPM.textContent === self.l10n.amPM[0])];
            }
            input.value = Object(__WEBPACK_IMPORTED_MODULE_2__utils__["d" /* pad */])(newValue);
        }
    }
    init();
    return self;
}
function _flatpickr(nodeList, config) {
    var nodes = Array.prototype.slice
        .call(nodeList)
        .filter(function (x) { return x instanceof HTMLElement; });
    var instances = [];
    for (var i = 0; i < nodes.length; i++) {
        var node = nodes[i];
        try {
            if (node.getAttribute("data-fp-omit") !== null)
                continue;
            if (node._flatpickr !== undefined) {
                node._flatpickr.destroy();
                node._flatpickr = undefined;
            }
            node._flatpickr = FlatpickrInstance(node, config || {});
            instances.push(node._flatpickr);
        }
        catch (e) {
            console.error(e);
        }
    }
    return instances.length === 1 ? instances[0] : instances;
}
if (typeof HTMLElement !== "undefined" &&
    typeof HTMLCollection !== "undefined" &&
    typeof NodeList !== "undefined") {
    HTMLCollection.prototype.flatpickr = NodeList.prototype.flatpickr = function (config) {
        return _flatpickr(this, config);
    };
    HTMLElement.prototype.flatpickr = function (config) {
        return _flatpickr([this], config);
    };
}
var flatpickr = function (selector, config) {
    if (typeof selector === "string") {
        return _flatpickr(window.document.querySelectorAll(selector), config);
    }
    else if (selector instanceof Node) {
        return _flatpickr([selector], config);
    }
    else {
        return _flatpickr(selector, config);
    }
};
flatpickr.defaultConfig = {};
flatpickr.l10ns = {
    en: __assign({}, __WEBPACK_IMPORTED_MODULE_1__l10n_default__["a" /* default */]),
    default: __assign({}, __WEBPACK_IMPORTED_MODULE_1__l10n_default__["a" /* default */]),
};
flatpickr.localize = function (l10n) {
    flatpickr.l10ns.default = __assign(__assign({}, flatpickr.l10ns.default), l10n);
};
flatpickr.setDefaults = function (config) {
    flatpickr.defaultConfig = __assign(__assign({}, flatpickr.defaultConfig), config);
};
flatpickr.parseDate = Object(__WEBPACK_IMPORTED_MODULE_4__utils_dates__["d" /* createDateParser */])({});
flatpickr.formatDate = Object(__WEBPACK_IMPORTED_MODULE_4__utils_dates__["c" /* createDateFormatter */])({});
flatpickr.compareDates = __WEBPACK_IMPORTED_MODULE_4__utils_dates__["b" /* compareDates */];
if (typeof jQuery !== "undefined" && typeof jQuery.fn !== "undefined") {
    jQuery.fn.flatpickr = function (config) {
        return _flatpickr(this, config);
    };
}
Date.prototype.fp_incr = function (days) {
    return new Date(this.getFullYear(), this.getMonth(), this.getDate() + (typeof days === "string" ? parseInt(days, 10) : days));
};
if (typeof window !== "undefined") {
    window.flatpickr = flatpickr;
}
/* harmony default export */ __webpack_exports__["a"] = (flatpickr);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),
/* 285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["f"] = toggleClass;
/* harmony export (immutable) */ __webpack_exports__["b"] = createElement;
/* harmony export (immutable) */ __webpack_exports__["a"] = clearNode;
/* harmony export (immutable) */ __webpack_exports__["d"] = findParent;
/* harmony export (immutable) */ __webpack_exports__["c"] = createNumberInput;
/* harmony export (immutable) */ __webpack_exports__["e"] = getEventTarget;
function toggleClass(elem, className, bool) {
    if (bool === true)
        return elem.classList.add(className);
    elem.classList.remove(className);
}
function createElement(tag, className, content) {
    var e = window.document.createElement(tag);
    className = className || "";
    content = content || "";
    e.className = className;
    if (content !== undefined)
        e.textContent = content;
    return e;
}
function clearNode(node) {
    while (node.firstChild)
        node.removeChild(node.firstChild);
}
function findParent(node, condition) {
    if (condition(node))
        return node;
    else if (node.parentNode)
        return findParent(node.parentNode, condition);
    return undefined;
}
function createNumberInput(inputClassName, opts) {
    var wrapper = createElement("div", "numInputWrapper"), numInput = createElement("input", "numInput " + inputClassName), arrowUp = createElement("span", "arrowUp"), arrowDown = createElement("span", "arrowDown");
    if (navigator.userAgent.indexOf("MSIE 9.0") === -1) {
        numInput.type = "number";
    }
    else {
        numInput.type = "text";
        numInput.pattern = "\\d*";
    }
    if (opts !== undefined)
        for (var key in opts)
            numInput.setAttribute(key, opts[key]);
    wrapper.appendChild(numInput);
    wrapper.appendChild(arrowUp);
    wrapper.appendChild(arrowDown);
    return wrapper;
}
function getEventTarget(event) {
    try {
        if (typeof event.composedPath === "function") {
            var path = event.composedPath();
            return path[0];
        }
        return event.target;
    }
    catch (error) {
        return event.target;
    }
}


/***/ }),
/* 286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return createDateFormatter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return createDateParser; });
/* harmony export (immutable) */ __webpack_exports__["b"] = compareDates;
/* unused harmony export compareTimes */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return isBetween; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return calculateSecondsSinceMidnight; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return parseSeconds; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return duration; });
/* harmony export (immutable) */ __webpack_exports__["f"] = getDefaultHours;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__formatting__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types_options__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__l10n_default__ = __webpack_require__(52);



var createDateFormatter = function (_a) {
    var _b = _a.config, config = _b === void 0 ? __WEBPACK_IMPORTED_MODULE_1__types_options__["b" /* defaults */] : _b, _c = _a.l10n, l10n = _c === void 0 ? __WEBPACK_IMPORTED_MODULE_2__l10n_default__["b" /* english */] : _c, _d = _a.isMobile, isMobile = _d === void 0 ? false : _d;
    return function (dateObj, frmt, overrideLocale) {
        var locale = overrideLocale || l10n;
        if (config.formatDate !== undefined && !isMobile) {
            return config.formatDate(dateObj, frmt, locale);
        }
        return frmt
            .split("")
            .map(function (c, i, arr) {
            return __WEBPACK_IMPORTED_MODULE_0__formatting__["a" /* formats */][c] && arr[i - 1] !== "\\"
                ? __WEBPACK_IMPORTED_MODULE_0__formatting__["a" /* formats */][c](dateObj, locale, config)
                : c !== "\\"
                    ? c
                    : "";
        })
            .join("");
    };
};
var createDateParser = function (_a) {
    var _b = _a.config, config = _b === void 0 ? __WEBPACK_IMPORTED_MODULE_1__types_options__["b" /* defaults */] : _b, _c = _a.l10n, l10n = _c === void 0 ? __WEBPACK_IMPORTED_MODULE_2__l10n_default__["b" /* english */] : _c;
    return function (date, givenFormat, timeless, customLocale) {
        if (date !== 0 && !date)
            return undefined;
        var locale = customLocale || l10n;
        var parsedDate;
        var dateOrig = date;
        if (date instanceof Date)
            parsedDate = new Date(date.getTime());
        else if (typeof date !== "string" &&
            date.toFixed !== undefined)
            parsedDate = new Date(date);
        else if (typeof date === "string") {
            var format = givenFormat || (config || __WEBPACK_IMPORTED_MODULE_1__types_options__["b" /* defaults */]).dateFormat;
            var datestr = String(date).trim();
            if (datestr === "today") {
                parsedDate = new Date();
                timeless = true;
            }
            else if (config && config.parseDate) {
                parsedDate = config.parseDate(date, format);
            }
            else if (/Z$/.test(datestr) ||
                /GMT$/.test(datestr)) {
                parsedDate = new Date(date);
            }
            else {
                var matched = void 0, ops = [];
                for (var i = 0, matchIndex = 0, regexStr = ""; i < format.length; i++) {
                    var token = format[i];
                    var isBackSlash = token === "\\";
                    var escaped = format[i - 1] === "\\" || isBackSlash;
                    if (__WEBPACK_IMPORTED_MODULE_0__formatting__["d" /* tokenRegex */][token] && !escaped) {
                        regexStr += __WEBPACK_IMPORTED_MODULE_0__formatting__["d" /* tokenRegex */][token];
                        var match = new RegExp(regexStr).exec(date);
                        if (match && (matched = true)) {
                            ops[token !== "Y" ? "push" : "unshift"]({
                                fn: __WEBPACK_IMPORTED_MODULE_0__formatting__["c" /* revFormat */][token],
                                val: match[++matchIndex],
                            });
                        }
                    }
                    else if (!isBackSlash)
                        regexStr += ".";
                }
                parsedDate =
                    !config || !config.noCalendar
                        ? new Date(new Date().getFullYear(), 0, 1, 0, 0, 0, 0)
                        : new Date(new Date().setHours(0, 0, 0, 0));
                ops.forEach(function (_a) {
                    var fn = _a.fn, val = _a.val;
                    return (parsedDate = fn(parsedDate, val, locale) || parsedDate);
                });
                parsedDate = matched ? parsedDate : undefined;
            }
        }
        if (!(parsedDate instanceof Date && !isNaN(parsedDate.getTime()))) {
            config.errorHandler(new Error("Invalid date provided: " + dateOrig));
            return undefined;
        }
        if (timeless === true)
            parsedDate.setHours(0, 0, 0, 0);
        return parsedDate;
    };
};
function compareDates(date1, date2, timeless) {
    if (timeless === void 0) { timeless = true; }
    if (timeless !== false) {
        return (new Date(date1.getTime()).setHours(0, 0, 0, 0) -
            new Date(date2.getTime()).setHours(0, 0, 0, 0));
    }
    return date1.getTime() - date2.getTime();
}
function compareTimes(date1, date2) {
    return (3600 * (date1.getHours() - date2.getHours()) +
        60 * (date1.getMinutes() - date2.getMinutes()) +
        date1.getSeconds() -
        date2.getSeconds());
}
var isBetween = function (ts, ts1, ts2) {
    return ts > Math.min(ts1, ts2) && ts < Math.max(ts1, ts2);
};
var calculateSecondsSinceMidnight = function (hours, minutes, seconds) {
    return hours * 3600 + minutes * 60 + seconds;
};
var parseSeconds = function (secondsSinceMidnight) {
    var hours = Math.floor(secondsSinceMidnight / 3600), minutes = (secondsSinceMidnight - hours * 3600) / 60;
    return [hours, minutes, secondsSinceMidnight - hours * 3600 - minutes * 60];
};
var duration = {
    DAY: 86400000,
};
function getDefaultHours(config) {
    var hours = config.defaultHour;
    var minutes = config.defaultMinute;
    var seconds = config.defaultSeconds;
    if (config.minDate !== undefined) {
        var minHour = config.minDate.getHours();
        var minMinutes = config.minDate.getMinutes();
        var minSeconds = config.minDate.getSeconds();
        if (hours < minHour) {
            hours = minHour;
        }
        if (hours === minHour && minutes < minMinutes) {
            minutes = minMinutes;
        }
        if (hours === minHour && minutes === minMinutes && seconds < minSeconds)
            seconds = config.minDate.getSeconds();
    }
    if (config.maxDate !== undefined) {
        var maxHr = config.maxDate.getHours();
        var maxMinutes = config.maxDate.getMinutes();
        hours = Math.min(hours, maxHr);
        if (hours === maxHr)
            minutes = Math.min(maxMinutes, minutes);
        if (hours === maxHr && minutes === maxMinutes)
            seconds = config.maxDate.getSeconds();
    }
    return { hours: hours, minutes: minutes, seconds: seconds };
}


/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

if (typeof Object.assign !== "function") {
    Object.assign = function (target) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        if (!target) {
            throw TypeError("Cannot convert undefined or null to object");
        }
        var _loop_1 = function (source) {
            if (source) {
                Object.keys(source).forEach(function (key) { return (target[key] = source[key]); });
            }
        };
        for (var _a = 0, args_1 = args; _a < args_1.length; _a++) {
            var source = args_1[_a];
            _loop_1(source);
        }
        return target;
    };
}


/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

(function (global, factory) {
   true ? factory(exports) :
  typeof define === 'function' && define.amd ? define(['exports'], factory) :
  (global = typeof globalThis !== 'undefined' ? globalThis : global || self, factory(global.it = {}));
}(this, (function (exports) { 'use strict';

  var fp = typeof window !== "undefined" && window.flatpickr !== undefined
      ? window.flatpickr
      : {
          l10ns: {},
      };
  var Italian = {
      weekdays: {
          shorthand: ["Dom", "Lun", "Mar", "Mer", "Gio", "Ven", "Sab"],
          longhand: [
              "Domenica",
              "Lunedì",
              "Martedì",
              "Mercoledì",
              "Giovedì",
              "Venerdì",
              "Sabato",
          ],
      },
      months: {
          shorthand: [
              "Gen",
              "Feb",
              "Mar",
              "Apr",
              "Mag",
              "Giu",
              "Lug",
              "Ago",
              "Set",
              "Ott",
              "Nov",
              "Dic",
          ],
          longhand: [
              "Gennaio",
              "Febbraio",
              "Marzo",
              "Aprile",
              "Maggio",
              "Giugno",
              "Luglio",
              "Agosto",
              "Settembre",
              "Ottobre",
              "Novembre",
              "Dicembre",
          ],
      },
      firstDayOfWeek: 1,
      ordinal: function () { return "°"; },
      rangeSeparator: " al ",
      weekAbbreviation: "Se",
      scrollTitle: "Scrolla per aumentare",
      toggleTitle: "Clicca per cambiare",
      time_24hr: true,
  };
  fp.l10ns.it = Italian;
  var it = fp.l10ns;

  exports.Italian = Italian;
  exports.default = it;

  Object.defineProperty(exports, '__esModule', { value: true });

})));


/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

(function (global, factory) {
   true ? factory(exports) :
  typeof define === 'function' && define.amd ? define(['exports'], factory) :
  (global = typeof globalThis !== 'undefined' ? globalThis : global || self, factory(global.fr = {}));
}(this, (function (exports) { 'use strict';

  var fp = typeof window !== "undefined" && window.flatpickr !== undefined
      ? window.flatpickr
      : {
          l10ns: {},
      };
  var French = {
      firstDayOfWeek: 1,
      weekdays: {
          shorthand: ["dim", "lun", "mar", "mer", "jeu", "ven", "sam"],
          longhand: [
              "dimanche",
              "lundi",
              "mardi",
              "mercredi",
              "jeudi",
              "vendredi",
              "samedi",
          ],
      },
      months: {
          shorthand: [
              "janv",
              "févr",
              "mars",
              "avr",
              "mai",
              "juin",
              "juil",
              "août",
              "sept",
              "oct",
              "nov",
              "déc",
          ],
          longhand: [
              "janvier",
              "février",
              "mars",
              "avril",
              "mai",
              "juin",
              "juillet",
              "août",
              "septembre",
              "octobre",
              "novembre",
              "décembre",
          ],
      },
      ordinal: function (nth) {
          if (nth > 1)
              return "";
          return "er";
      },
      rangeSeparator: " au ",
      weekAbbreviation: "Sem",
      scrollTitle: "Défiler pour augmenter la valeur",
      toggleTitle: "Cliquer pour basculer",
      time_24hr: true,
  };
  fp.l10ns.fr = French;
  var fr = fp.l10ns;

  exports.French = French;
  exports.default = fr;

  Object.defineProperty(exports, '__esModule', { value: true });

})));


/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

(function (global, factory) {
   true ? factory(exports) :
  typeof define === 'function' && define.amd ? define(['exports'], factory) :
  (global = typeof globalThis !== 'undefined' ? globalThis : global || self, factory(global.de = {}));
}(this, (function (exports) { 'use strict';

  var fp = typeof window !== "undefined" && window.flatpickr !== undefined
      ? window.flatpickr
      : {
          l10ns: {},
      };
  var German = {
      weekdays: {
          shorthand: ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
          longhand: [
              "Sonntag",
              "Montag",
              "Dienstag",
              "Mittwoch",
              "Donnerstag",
              "Freitag",
              "Samstag",
          ],
      },
      months: {
          shorthand: [
              "Jan",
              "Feb",
              "Mär",
              "Apr",
              "Mai",
              "Jun",
              "Jul",
              "Aug",
              "Sep",
              "Okt",
              "Nov",
              "Dez",
          ],
          longhand: [
              "Januar",
              "Februar",
              "März",
              "April",
              "Mai",
              "Juni",
              "Juli",
              "August",
              "September",
              "Oktober",
              "November",
              "Dezember",
          ],
      },
      firstDayOfWeek: 1,
      weekAbbreviation: "KW",
      rangeSeparator: " bis ",
      scrollTitle: "Zum Ändern scrollen",
      toggleTitle: "Zum Umschalten klicken",
      time_24hr: true,
  };
  fp.l10ns.de = German;
  var de = fp.l10ns;

  exports.German = German;
  exports.default = de;

  Object.defineProperty(exports, '__esModule', { value: true });

})));


/***/ }),
/* 291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["init"] = init;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Utils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DomElement__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DomFunctions__ = __webpack_require__(15);




var QUERY_TEXTAREA = "textarea";
var CLASS_HAS_VALUE = "is-fixed";
/**
 * Textarea component
 */
var Textarea = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */])(Textarea, _super);
    function Textarea(element) {
        var _this = _super.call(this, element) || this;
        _this._area = _this.element.querySelector(QUERY_TEXTAREA);
        _this._focusChangedHandler = _this._focusChanged.bind(_this);
        _this._valueChangedHandler = _this._onValueChanged.bind(_this);
        _this._resizeHandler = _this._updateHeight.bind(_this);
        _this._initialize();
        return _this;
    }
    /**
     * Initializes the textarea component.
     * @private
     */
    Textarea.prototype._initialize = function () {
        this._area.spellcheck = false;
        this._minRows = parseInt(this._area.getAttribute("data-min-rows") || "4", 10);
        this._maxRows = parseInt(this._area.getAttribute("data-max-rows") || "10", 10);
        // Make sure min an max are property specified
        this._minRows = Math.min(this._minRows, this._maxRows);
        this._maxRows = Math.max(this._minRows, this._maxRows);
        this._lineHeight = parseInt(__WEBPACK_IMPORTED_MODULE_3__DomFunctions__["b" /* css */](this._area, "line-height"), 10);
        this._updateBaseHeight = __WEBPACK_IMPORTED_MODULE_3__DomFunctions__["f" /* isHidden */](this._area, true);
        this._calculateBaseHeight();
        // add event listeners
        this._area.addEventListener("focus", this._focusChangedHandler);
        this._area.addEventListener("blur", this._focusChangedHandler);
        this._area.addEventListener("input", this._valueChangedHandler);
        window.addEventListener("resize", this._resizeHandler);
        window.addEventListener("orientationchange", this._resizeHandler);
        this._onValueChanged();
    };
    Textarea.prototype._calculateBaseHeight = function () {
        // temporary clear the content to take measurements
        var value = this._area.value;
        this._area.value = "";
        this._baseHeight = this._area.offsetHeight - this._lineHeight;
        this._baseScrollHeight = this._area.scrollHeight - this._lineHeight;
        // restore initial content
        this._area.value = value;
    };
    Textarea.prototype._focusChanged = function () {
        this._updateHeight();
    };
    Textarea.prototype._updateHeight = function () {
        var hasFocus = this._area === document.activeElement;
        var maxRows, rows = 0;
        if (this._updateBaseHeight === true &&
            __WEBPACK_IMPORTED_MODULE_3__DomFunctions__["f" /* isHidden */](this._area, true) === false) {
            this._calculateBaseHeight();
            this._updateBaseHeight = false;
        }
        // Calculate the apropriate size for the control
        if (!this._hasValue()) {
            // Handle empty states
            rows = hasFocus === true ? this._minRows : 1;
            maxRows = rows;
        }
        else {
            // Reset the height for calculation of the row count
            this._area.style.height = "auto";
            // Get the new height
            rows =
                Math.ceil((this._area.scrollHeight - this._baseScrollHeight) / this._lineHeight) + 1;
            maxRows = Math.max(Math.min(this._maxRows, rows), this._minRows);
        }
        if (rows > this._maxRows) {
            this._area.style.overflow = "auto";
        }
        else {
            this._area.style.overflow = "hidden";
        }
        var height = (maxRows - 1) * this._lineHeight + this._baseHeight;
        this._area.style.height = "".concat(height, "px");
    };
    Textarea.prototype._hasValue = function () {
        return this._area.value && this._area.value.length > 0;
    };
    Textarea.prototype._onValueChanged = function () {
        if (this._hasValue()) {
            __WEBPACK_IMPORTED_MODULE_3__DomFunctions__["a" /* addClass */](this._area, CLASS_HAS_VALUE);
        }
        else {
            __WEBPACK_IMPORTED_MODULE_3__DomFunctions__["h" /* removeClass */](this._area, CLASS_HAS_VALUE);
            this._area.value = "";
        }
        this._updateHeight();
    };
    /**
     * Destroys the component and clears all references.
     */
    Textarea.prototype.destroy = function () {
        window.removeEventListener("resize", this._resizeHandler);
        window.removeEventListener("orientationchange", this._resizeHandler);
        this._area.removeEventListener("focus", this._focusChangedHandler);
        this._area.removeEventListener("blur", this._focusChangedHandler);
        this._area.removeEventListener("input", this._valueChangedHandler);
        this._focusChangedHandler = null;
        this._valueChangedHander = null;
        this._area = null;
        this._minRows = null;
        this._maxRows = null;
        this._lineHeight = null;
        this._baseHeight = null;
        this._baseScrollHeight = null;
        this.element = null;
    };
    return Textarea;
}(__WEBPACK_IMPORTED_MODULE_2__DomElement__["a" /* default */]));
function init() {
    Object(__WEBPACK_IMPORTED_MODULE_1__Utils__["h" /* searchAndInitialize */])(".input-multiline, .input-field--multiline", function (e) {
        new Textarea(e);
    });
}
/* harmony default export */ __webpack_exports__["default"] = (Textarea);


/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_Tc_dot_$) {/*** IMPORTS FROM imports-loader ***/
var loadTerrific = __webpack_require__(1);
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function ($, Tc) {
	'use strict';
	/*globals SCS */

	// we register change event handlers for various input fields. Often we have
	// mutliple visibility containers depending on the same input field (we often
	// have one container visible while another is hidden). In this case we do not
	// want to be called multiple times for the change event handler. Therefore we
	// need a static value to keep track of which input fields we already listen for.
	var delegated = {};

	/**
	 * Hidden component which handles showing/hiding of contained form elements
	 * based on the state of a configured (name & value) form element.
	 *
	 * For example: If the check box with name=foo and value=bar is checked, this
	 * module is displayed, otherwise it is hidden.
	 *
	 * @author Stefan Koch and Cesar Keller, update: Renaldas Szentiks, Matthias Inauen
	 * @namespace Tc.Module
	 * @class VisibilityControlContainer
	 * @extends Tc.Module
	 */
	Tc.Module.VisibilityControlContainer = Tc.Module.extend({

		EVT_STEP_LOADED: 'steploaded',
		EVT_INIT: 'init',
		ANIMATION_DURATION: 250,

		FUNCTIONS: {
			dateDifferenceFromNow: 'moment(%1, "DD.MM.YYYY").diff(moment().startOf("day"),%2, true)',
			dateDifference: 'moment(%1, "DD.MM.YYYY").diff(moment(%2, "DD.MM.YYYY"),%3, true)',
			containsValue: '(%1+"").split(",").indexOf(%2) >= 0',
			containsWord: '(%1+"").indexOf(%2) >= 0'
		},

		animationType: '',
		authorMode: false,
		show: function () {
		},
		hide: function () {
		},

		contentMustStayAtPlaceInDom: true,
		content: $(),

		/**
		 * Main hook.
		 *
		 * @method on
		 * @param {Function} callback function
		 * @return void
		 */
		on: function (callback) {
			var mod = this,
				$ctx = mod.$ctx;

			// read config
			mod.name = $ctx.data('name');
			mod.dataAttr = $ctx.data('attr');
			mod.value = $ctx.attr('data-value');
			mod.action = $ctx.data('action');
			mod.expression = mod.prepareExpression($ctx.data('expression'));
			// the target field may reside in any form module on the page.
			mod.formModule = $('.modScForm');
			// fetch and cache form dom nodes
			mod.forms = $('>FORM', mod.formModule);
			mod.authorMode = $ctx.hasClass('author-mode');
			mod.animationType = $ctx.data('animationtype');

			mod.selectors = $ctx.data('selectors');

			mod.show = (mod.authorMode) ? mod.showAuthor : mod.showPublisher;
			mod.hide = (mod.authorMode) ? mod.hideAuthor : mod.hidePublisher;

			mod.contentMustStayAtPlaceInDom = !$ctx.closest('form').length;
			if (!mod.contentMustStayAtPlaceInDom) {
				mod.content = $('<div class="move-off-screen" />').appendTo($ctx.closest('.modScForm'));
			}

			mod.sandbox.subscribe('formpriceupdate', mod);

			callback();
		},

		isSimpleCheck: function () {
			return this.expression ? false : true;
		},

		showOrHide: function (caller) {
			var mod = this,
				isSuccess = false;

			if (this.isSimpleCheck()) {
				isSuccess = this.checkField();
			} else {
				isSuccess = this.checkExpression();
			}
			//see backend implementation
			isSuccess = isSuccess || (mod.selectors && mod.selectors.length > 0);
			if (isSuccess) {
				if (this.action === 'show') {
					this.show(caller);
				} else {
					this.hide(caller);
				}
			} else {
				if (this.action === 'show') {
					this.hide(caller);
				} else {
					this.show(caller);
				}
			}
		},

		prepareExpression: function (expression) {
			var $this = this,
				functionName;
			expression = expression.replace(new RegExp(' and ', 'g'), ' && ').replace(new RegExp(' or ', 'g'), ' || ');
			for (functionName in this.FUNCTIONS) {
				if (this.FUNCTIONS.hasOwnProperty(functionName)) {
					expression = this.prepareFunction({name: functionName, template: $this.FUNCTIONS[functionName]}, expression);
				}
			}
			return expression;
		},

		prepareFunction: function (functionDefinition, expression) {
			var functions = expression.match(new RegExp(functionDefinition.name + '[\\s]?\\([^\\)]+\\)', 'g')),
				i = 0,
				j = 0,
				data = [],
				template;

			for (; functions && i < functions.length; i += 1) {
				data = functions[i].substring(0, functions[i].length - 1).replace(new RegExp(functionDefinition.name + '[\\s]?\\('), '').split(',');
				if (data.length > 0) {
					template = functionDefinition.template;
					for (j = 0; j < data.length; j += 1) {
						template = template.replace(new RegExp('%' + (j + 1), 'g'), data[j]);
					}
					expression = expression.replace(functions[i], template);
				} else {
					expression = expression.replace(functions[i], '');
				}
			}
			return expression;
		},

		checkExpression: function () {
			var placeholders = this.getExpressionPlaceholders(),
				processedExpression = this.expression,
				i = 0,
				value = '';
			for (i = 0; placeholders && i < placeholders.length; i += 1) {
				value = this.getFieldValue(placeholders[i]);
				value = value.replace(new RegExp('\'', 'g'), '').replace(new RegExp('\\\\', 'g'), '');
				if (!value.match(/^[0-9]+$/)) {
					value = '\'' + value + '\'';
				}
				processedExpression = processedExpression.replace(new RegExp('\\$\\{' + placeholders[i] + '\\}', 'g'), value);
			}
			try {
				return eval(processedExpression); // TODO don't use eval. Refactor to use regular functions instead.
			} catch (e) {
				return false;
			}
		},

		getFieldValue: function (name) {
			var field = this.formModule.find('[name="' + name + '"],.active[data-name="' + name + '"]'),
				values = [],
				i = 0;
			//field is hidden in VCC
			if(field.closest('.move-off-screen').length > 0){
				return '';
			}
			if (field.attr('type') === 'radio') {
				field = this.formModule.find('[name="' + name + '"]:checked');
				return field.val() || '';
			} else if (field.attr('type') === 'checkbox') {
				field = this.formModule.find('[name="' + name + '"]:checked');
				for (i = 0; i < field.length; i += 1) {
					values.push($(field[i]).val());
				}
				return values.join(',');
			} else if (field.data('name')) {
				return field.data('value') || '';
			} else if (field.length > 0) {
				for (i = 0; i < field.length; i += 1) {
					values.push($(field[i]).val());
				}
				return values.join(',');
			}
			return field.val() || '';
		},

		getExpressionPlaceholders: function () {
			var mod = this,
				placeholders = [],
				i = 0,
				name;

			/* jshint maxdepth: 5 */
			if (!mod.expressionPlaceholders) {
				mod.expressionPlaceholders = [];
				if (mod.expression) {
					placeholders = mod.expression.match(/\$\{[a-zA-Z0-9_\\/:\\-]+\}/g);
					if (placeholders) {
						for (i = 0; i < placeholders.length; i += 1) {
							name = placeholders[i].replace('${', '').replace('}', '');
							if (mod.expressionPlaceholders.indexOf(name) < 0) {
								mod.expressionPlaceholders.push(name);
							}
						}
					}
				}
			}
			return mod.expressionPlaceholders;
		},

		checkField: function () {
			// input element name
			var mod = this,
				name = mod.name,
				value = mod.value;

			// forms have been prefetched on initialization
			for (var i = 0, L = mod.forms.length; i < L; i += 1) {
				// get element via form node
				var form = mod.forms[i],
					el = form.elements[name];
				// may not exist in this form
				if (!el) {
					continue;
				}
				// if Data Attribute is empty, check value
				if (!mod.dataAttr){
					// special test for checkbox
					if ($(el).attr('type') === 'checkbox') {
						// value is static and doesn't change with checked status
						if ($(el).is(':checked') &&
							$(el).filter(':checked')
								.map(function() { return this.value; })
								.get()
								.some(function (val) { return val === value; })) {
							return true;
						}
					} else if ($(el).attr('type') === 'radio') {
						if ($(el).filter(':checked').val() === mod.value) {
							return true;
						}
					}
					// generic form element handling
					else {
						// a HTMLFormElementsCollection returns a RadioNodeList if
						// multiple elements share the same name. The RadioNodeList
						// has special value semantics where it returns the value of
						// the first checked radio list in the nodelist. All other
						// standard types (textarea, text, hidden) have it anyway!
						if (el.value === mod.value) {
							return true;
						}
					}
				// check if Data Attribute has the desired value
				} else {
					// special test for checkbox
					if ($(el).attr('type') === 'checkbox') {
						// value is static and doesn't change with checked status
						if ($(el).is(':checked') && '' + $(el).filter(':checked').data(mod.dataAttr) === mod.value) {
							return true;
						}
					} else if ($(el).attr('type') === 'radio') {
						if ('' + $(el).filter(':checked').data(mod.dataAttr) === mod.value) {
							return true;
						}
					} else if ($(el).prop('tagName').toLowerCase() === 'select') {
						if ('' + $(el).find('option:selected').data(mod.dataAttr) === mod.value) {
							return true;
						}
					}
					// generic form element handling
					else {
						// a HTMLFormElementsCollection returns a RadioNodeList if
						// multiple elements share the same name. The RadioNodeList
						// has special value semantics where it returns the value of
						// the first checked radio list in the nodelist. All other
						// standard types (textarea, text, hidden) have it anyway!
						if (el.data(mod.dataAttr) === mod.value) {
							return true;
						}
					}
				}
			}

			return (mod.formModule.find('.active[data-name="' + mod.name + '"]').attr('data-value') === mod.value) ||
				// test below is for checkbox groups (each checkbox has same name; custom and strange logic)
				mod.formModule.find('INPUT[type="hidden"][name="' + mod.name + '_label"]:not([disabled])')
					.filter(function () {
						return this.value === value;
					}).length > 0;
		},

		showPublisher: function (caller) {
			var mod = this;

			if(mod.status === 'showing' || mod.status === 'shown') {
				return;
			}

			mod.$ctx.trigger('visibilityControl-show');
			mod.$ctx.removeClass('visibilityControl-hidden');

			if (!mod.inProgress) {
				mod.inProgress = true;
				mod.status = 'showing';

				if (mod.contentMustStayAtPlaceInDom) {
					mod.$ctx.removeClass('move-off-screen');
				} else {
					mod.$ctx.append(mod.content.children());
				}
				$('input, textarea', mod.$ctx).placeholder();

				if (this.formModule) {
					this.formModule.trigger('formFieldsChanged');
				}

				mod.showAnimation(function () {
					mod.inProgress = false;
					mod.status = 'shown';
					if (mod.queriedAction && mod.queriedAction === 'hide') {
						mod.queriedAction = null;
						mod.hide();
					} else {
						mod.queriedAction = null;
						// Only consider init events because stepload may be called between init and the time out
						if(caller === mod.EVT_INIT) {
							var oflow = mod.$ctx.css('overflow');
							if(!mod.$ctx.find('.modDropdownPopulation').length) {
								mod.$ctx.css('overflow', 'hidden');
							}

							window.setTimeout(function () {
								mod.$ctx.css('overflow', oflow);
							}, 0);
						}
					}
				});

				mod.$ctx.find('[data-clientvalidation]').removeData('do-not-validate');

			} else {
				if (caller !== mod.EVT_STEP_LOADED && caller !== mod.EVT_INIT) {
					mod.queriedAction = 'show';
				}
			}
			mod.$ctx.trigger('visibilityControl-afterShow', this);
			this.updateSubtotal();
			if(!mod.initializedChildren){
				mod.initializedChildren = true;
				SCS.utils.initNewModules(this.$ctx);
				if(mod.$ctx.find('.carouselContainer').length && !SCS.utils.isMobilePage()) {
					SCS.carousel.initializeCarousel.apply(mod.$ctx.find('.carouselContainer'));
					SCS.portal.synchronizeHeights($('.carouselContainer .sync-wrapper'));
				}
			}

			$(document).trigger('element-shown', [this.$ctx]);
		},

		updateSubtotal: function(){
			var $priceFields = this.$ctx.find(':input[data-price],:input[data-onetime-charge],:input[data-type=item]');
			if ($priceFields.length){
				this.fire('PriceAdded', {}, ['formpriceupdate']);
			}
		},

		hidePublisher: function (caller) {
			var mod = this;

			if(mod.status === 'hiding' || mod.status === 'hidden') {
				return;
			}

			mod.$ctx.trigger('visibilityControl-hide');
			mod.$ctx.addClass('visibilityControl-hidden');

			if (!mod.inProgress) {
				mod.status = 'hiding';
				mod.inProgress = true;
				mod.hideAnimation(function () {
					mod.status = 'hidden';
					if (mod.animationType !== 'greyout') {
						if (mod.contentMustStayAtPlaceInDom) {
							mod.$ctx.addClass('move-off-screen').show();
						} else {
							mod.content.append(mod.$ctx.children());
						}
					}
					else {
						if(!mod.initializedChildren){
							mod.initializedChildren = true;
							SCS.utils.initNewModules(mod.$ctx);
						}
					}
					mod.inProgress = false;
					if (mod.queriedAction && mod.queriedAction === 'show') {
						mod.queriedAction = null;
						mod.show();
					} else {
						mod.queriedAction = null;
					}

					if(mod.contentMustStayAtPlaceInDom) {
						mod.$ctx.find('[data-clientvalidation]').data('do-not-validate', 'true');
					} else {
						mod.content.find('[data-clientvalidation]').data('do-not-validate', 'true');
					}

					// calling a method from Tc.Module.ProductOptionsSummaery.js to recalculate a price
					mod.fire('PriceAdded', {}, ['formpriceupdate']);

				});

			} else {
				if (caller !== mod.EVT_STEP_LOADED && caller !== mod.EVT_INIT) {
					mod.queriedAction = 'hide';
				}
			}
			mod.$ctx.trigger('visibilityControl-afterHide', this);
		},

		showAuthor: function () {
			this.$ctx.trigger('visibilityControl-show');
			this.$ctx.find('.section, .cq-editbar-placeholder').removeClass('move-off-screen');
			this.$ctx.trigger('visibilityControl-afterShow', this);
			this.updateSubtotal();
			//Commented at 11.03.2016, we need to investigate how to fix the lazy loading on Author
			//SCS.utils.initNewModules(this.$ctx);
		},

		hideAuthor: function () {
			this.$ctx.trigger('visibilityControl-hide');
			this.$ctx.find('.section, .cq-editbar-placeholder').addClass('move-off-screen');
			this.$ctx.trigger('visibilityControl-afterHide', this);
		},

		showAnimation: function (callback) {
			var mod = this;
			switch (mod.animationType) {
				case 'noanimation':
					mod.$ctx.css('display', 'block');
					callback();
					break;
				case 'greyout':
					mod.$ctx.fadeTo(mod.ANIMATION_DURATION, 1, callback);
					break;
				default:
					mod.$ctx.slideDown(mod.ANIMATION_DURATION, callback);
			}
		},

		hideAnimation: function (callback) {
			var mod = this;

			switch (mod.animationType) {
				case 'noanimation':
					mod.$ctx.css('display', 'none');
					callback();
					break;
				case 'greyout':
					mod.$ctx.fadeTo(mod.ANIMATION_DURATION, 0.4, callback);
					break;
				default:
					mod.$ctx.slideUp(mod.ANIMATION_DURATION, callback);
			}
		},

		getHiddenContentHandler: function (event, callback) {
			var mod = this;

			if (mod.$ctx.hasClass('move-off-screen') && mod.$ctx.children().length) {
				callback(mod.$ctx.children());
			} else if (mod.content.children().length) {
				callback(mod.content.children());
			}
		},

		attachEvents: function(fieldName) {
			var mod = this;
			delegated[fieldName] = [mod];

			// sync-ui event is triggered when a synced form field was updated
			// data-name comes from custom fields, that are not form fields but still trigger change events.
			// These type of fields occure in the Tc.Module.ProductModelFilter
			//
			// the visibility control container in simple mode has a attribute called data-name. The value will
			// correspond with the fieldName as this is the value it is supposed to observe for change.
			// make sure the visibility control containers do not trigger this event if a descendant child triggers
			// a change event.
			$(document).on('sync-ui change keyup', '[name="' + fieldName + '"]:not(.modVisibilityControlContainer), [data-name="' + fieldName + '"]:not(.modVisibilityControlContainer)', function (event) {

				for (var i = 0, L = delegated[fieldName].length; i < L; i += 1) {
					delegated[fieldName][i].showOrHide('change', event);
				}
				if (event.originalEvent && event.type !== 'sync-ui') {
					$(this).trigger('sync-heights');
				}
			});
			mod.forms.each(function(idx, frm) {
				var sdxInputGroups = frm.querySelectorAll('sdx-input-group');
				sdxInputGroups.forEach(function(item) {
					var originalClbck = item.changeCallback;
					item.getSelection().then(function() {
						$(item).find('input[name="' + fieldName + '"]').change();
					});
					item.changeCallback = function() {
						setTimeout(function () {
							$(item).find('input[name="' + fieldName + '"]').change();
							originalClbck && originalClbck();
						}, 10);
					};
				});
			});
		},

		getFieldNames: function() {
			if (this.isSimpleCheck()) {
				return [this.name];
			} else {
				return this.getExpressionPlaceholders();
			}
		},

		/**
		 * Initialize the component
		 */
		initModule: function(){
			var mod = this;
			var fieldNames = this.getFieldNames();

			this.showOrHide(this.EVT_INIT);

			for (var i = 0; i < fieldNames.length; i += 1) {
				if (delegated[fieldNames[i]]) {
					delegated[fieldNames[i]].push(mod);
				} else {
					mod.attachEvents(fieldNames[i]);
				}
			}
			// these two need to be optimized as well, they are being called multiple times, if there are more than one form element on the page.
			this.formModule.on(this.EVT_STEP_LOADED, $.proxy(this.showOrHide, this, this.EVT_STEP_LOADED)); // triggered by Tc.Module.ScForm.MultipageWizard
			this.$ctx.on('getHiddenContent', $.proxy(this.getHiddenContentHandler, this));
		},

		/**
		 * Hook which is triggered after all modules have executed "on".
		 *
		 * @method after
		 * @return void
		 */
		after: function () {
			if(this.$ctx.hasClass('disabled')) {
				return;
			}

			// only init the module after all other components have finished initializing.
			setTimeout(this.initModule.bind(this), 0);
		}
	});
})(__webpack_provided_window_dot_Tc_dot_$, window.Tc);

}.call(window));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

(function(SCS) {
	'use strict';

	var slice = Array.prototype.slice;
	var search = SCS.search = SCS.search || {};
	var util = search.util = search.util || {};

	/**
	 * Creates an instance that processes search requests.
	 * @argument backend The backend function.
	 *           Gets passed the config URL and a callback which it calls with the response data.
	 *           Also gets passed the config object and the processor.
	 *           These should only be used for debugging as the backend may be used to service several requests from different processors and using different configs (as long as the URL stays the same) when behind a deduplicatedBackend or cachingBackend wrapper (or both).
	 *           To respond to config options, use pre- or post-plugins instead.
	 * @argument logger A logger. Should conform to the console interface (methods that may be used are: log, debug, info, error).
	 */
	function SearchProcessor(backend, logger) {
		this.backend = backend || search.backend.defaultBackend();
		this.responders = [];
		this.preFilters = [];
		this.postFilters = [];
		this.logger = logger || window.debug || window.console || null;
		this.running = null;
	}

	var proto = SearchProcessor.prototype;

	proto.responder = function(responder) {
		this.responders.push(responder);
		return responder;
	};

	proto.removeResponder = function(responder) {
		var res = this.responders;
		var index = util.inArray(responder, res);
		if(index > -1) {
			return res.splice(index, 1)[0];
		}
		return null;
	};

	function addToFilterList(filter, list, weight) {
		for(var i=0;i<list.length;i+=1) {
			if(list[i].weight > weight) {
				break;
			}
		}
		list.splice(i, 0, {filter: filter, weight: weight});
	}
	proto.use = function(preFilter, postFilter, weight) {
		weight = weight || 0;
		if(preFilter) {
			addToFilterList(preFilter, this.preFilters, weight);
		}
		if(postFilter) {
			addToFilterList(postFilter, this.postFilters, weight);
		}
	};

	// Syntactic sugar aliases
	proto.usePre = function(filter, weight) { this.use(filter, null, weight); };
	proto.usePost = function(filter, weight) { this.use(null, filter, weight); };

	/**
	* Calls each of the filters in the given filter chain.
	* Expects to be passed the same amount of additional arguments (after context) that:
	* 	1. The filter takes (excluding the callback)
	*		2. The filter passes its callback
	*		3. The done method takes
	* Guarantees the done function be called asynchronously even if none of the filters are asynchronous
	* Each callback (and done) is run in context of the filter chain API, which allows the filter chain to be prematurely aborted.
	*/
	function processAsyncFilterChain(filterChain, done, processor) {
		var args = slice.call(arguments, processAsyncFilterChain.length);
		filterChain = filterChain.slice();

		var running = true;
		var currentFilterAPI = null;

		// Stops the filter chain and ignores the current value (does not call any methods)
		// Called from the outside (the search processor instance)
		function abort() {
			running = false;
			if(currentFilterAPI) {
				currentFilterAPI.abort();
			}
		}
		// Public API for controlling this chain.
		var result = {
			abort: abort,
			processor: processor,
			isRunning: function() {
				return running;
			},
			args: args
		};
		
		// API for controlling this chain from within (calls the processor instance to abort)
		var context = util.extend({}, result, {
			abort: function(silent) {
				abort();
				processor.aborted.apply(processor, [result].concat(args, [silent]));
			}
		});

		var allFiltersSync = true;
		// Called by the filters when they are done processing.
		// Can be synchronously or asynchronously called.
		function nextFilter() {
			// Use the arguments from the last invocation if the filter didn’t pass them.
			for(var i=0;i<args.length;i+=1) {
				args[i] = arguments[i] || args[i];
			}

			if(!running) {
				// Do nothing if already responded or aborted
				// If filters up till now were asynchronous, don’t return a valid controller result;
				result = null;
				return;
			}

			var filter = filterChain.shift();
			if(filter) {
				filter = filter.filter;
			}

			if(!filter && allFiltersSync) {
				// Add a special “async” filter that delays the execution to make filter chains always predictably asynchronous
				filter = function async() {
					var handle = window.setTimeout(function() {
						nextFilter();
					}, 0);
					return {
						abort: function() {
							window.clearTimeout(handle);
						}
					};
				};
			}

			// Filters finished
			if(!filter) {
				// Mark the filter chain as finished (no more callbacks allowed)
				running = false;
				// Clear the API of the current filter
				currentFilterAPI = null;
				// Call the done callback after all filters are done
				done.apply(context, args);

				return;
			}
			// We still have filters to work on, call the next one
			var isSync = false;
			var callback = function() {
				isSync = true;
				return nextFilter.apply(this, arguments);
			};
			// Add the callback as last argument
			currentFilterAPI = filter.apply(context, args.concat([callback]));
			if(!isSync && !running) {
				// Filter aborted before calling a callback
				result = null;
				return;
			}
			if(!isSync && (!currentFilterAPI || !('abort' in currentFilterAPI))) {
				throw new Error('Filter ' + filter.name + ' did not return an API and isn’t synchronous');
			}
		}
		nextFilter();
		// If we got here, something in nextFilter was asynchronous.
		allFiltersSync = false;

		return result;
	}

	proto.process = function(configuration) {
		var _this = this;
		// Called when all filters are done
		function callBackend(configuration) {
			var isSync = false;
			var running = _this.backend.call(_this, configuration.url, function(data) {
				isSync = true;
				_this.running = null;
				_this.processingDone(data, configuration);
			}, _this, configuration);
			 _this.running = _this.running || running; // _this.running may be set in _this.processingDone (for sync backends). Don’t overwrite it!
			if(!isSync && (!_this.running || !('abort' in _this.running))) {
				throw new Error('Backend ' + _this.backend.name + ' did not return an API and isn’t synchronous');
			}
		}

		this.abort();

		this.running = processAsyncFilterChain(this.preFilters, callBackend, this, configuration);
	};

	proto.processingDone = function(data, configuration) {
		var _this = this;
		if(data instanceof Error) {
			return _this.send('error', data, configuration);
		}
		function callResponder(data, configuration) {
			_this.running = null;
			_this.data(data, configuration);
		}
		_this.running = processAsyncFilterChain(this.postFilters, callResponder, this, data, configuration);
	};

	// Aborts the currently active filter queue/backend request
	proto.abort = function() {
		var running = this.running;
		if(running) {
			this.running = null;
			// Abort currently running
			running.abort();
			// Emit the “abort” event
			var args = running.args || [];
			this.aborted(running, args[0], args[1]);
		}
	};
	
	// If this is called, the filter chain was already aborted, either from the outside or the inside
	// Use the “silent” argument when you immediately follow the abort with a new processing phase
	proto.aborted = function aborted(filterChain, data, configuration, silent) {
		if(arguments.length < aborted.length) {
			// No data given (abort was in pre-filter chain)
			silent = configuration;
			configuration = data;
			data = undefined;
		}
		if(filterChain === this.running) {
			this.running = null;
		}
		var eventName = silent ? 'silent-abort' : 'abort';
		this.send(eventName, filterChain, data, configuration);
	};

	// Sends the `data` event with the given data and configuration to all responders
	proto.data = function(data, configuration) {
		this.send('data', data, configuration);
	};

	// Sends an event to all responders
	proto.send = function(event, data) {
		// jshint unused: false
		var args = slice.call(arguments);
		args.splice(1, 0, this);
		// Copy responders so concurrent mutations do not affect the iteration
		var responders = this.responders.slice();
		for(var i=0;i<responders.length;i+=1) {
			// Don’t let an exception in one responder cancel the execution of others
			try {
				this.log('debug', 'sending event', event, 'with data', args);
				responders[i].apply(null, args);
			} catch(e) {
				this.log('error', 'responder', responders[i].displayName || responders[i].name, 'threw', e);
			}
		}
	};

	// Track various events.
	// See https://wiki.swisscom.com/display/PD/Tracking+interface
	proto.track = function(event, data) {
		// jshint unused: false
		var args = slice.call(arguments, 1);

		var trackedBy = [];

		var nav = window.navigator;
		if(util.inArray((nav.mockDoNotTrack || nav.doNotTrack || nav.msDoNotTrack), ['1', 'yes']) > -1) {
			return trackedBy;
		}

		// Find eligible trackers and call them
		var trackers = search.trackers || {};
		for(var name in trackers) {
			// jshint forin: false
			var tracker = trackers[name];
			if(!tracker || !tracker[event] || !tracker.hasOwnProperty(event)) {
				// Event not tracked
				continue;
			}
			try {
				tracker[event].apply(null, args);
				trackedBy.push(name);
			} catch(e) {
				this.log('error', 'Tracker', name, 'threw', e);
			}
		}
		return trackedBy;
	};

	proto.log = function log(level) {
		if(!this.logger) {
			return;
		}
		var messages = slice.call(arguments);
		messages.splice(0, log.length, 'SearchProcessor >');
		level = level || 'log';
		if(!(level in this.logger)) {
			// Prepend level if default, otherwise use real level
			messages.splice(0, 0, level.toUpperCase());
			level = 'log';
		}
		this.logger[level].apply(this.logger, messages);
	};

	search.Processor = SearchProcessor;
	if(false) {
		// Visible for testing
		search.internals = search.internals || {};
		search.internals.processAsyncFilterChain = processAsyncFilterChain;
	}

})(window.SCS = window.SCS || {});

/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_Tc_dot_$, __webpack_provided_window_dot_$) {(function(SCS, $) {
	'use strict';

	var search = SCS.search = SCS.search || {};

	function deduplicatedBackend(backend) {
		var pending = {};
		function backendDeduplicator(url, callback, processor, config) {
			// jshint validthis: true
			var duplicate = url in pending;

			var current = pending[url] = pending[url] || {callbacks: [], result: null};
			current.callbacks.push(callback);

			var handle = {
				abort: function() {
					var index = search.util.inArray(callback, current.callbacks);
					if(index !== -1) {
						current.callbacks.splice(index, 1);
					}
					if(!current.callbacks.length) {
						current.result.abort();
					}
				}
			};

			if(duplicate) {
				return handle;
			}

			current.result = backend.call(this, url, function() {
				delete pending[url];
				for(var i=0;i<current.callbacks.length;i+=1) {
					current.callbacks[i].apply(this, arguments);
				}
			}, processor, config);

			return handle;
		}
		backendDeduplicator.displayName = deduplicatedBackend.name + ': ' + (backend.displayName || backend.name);
		return backendDeduplicator;
	}

	var DEFAULT_CACHE_SIZE = 20;
	var DEFAULT_CACHE_TOLERANCE = 0.5;
	function cachedBackend(backend, cacheSize, tolerance) {
		cacheSize = cacheSize || DEFAULT_CACHE_SIZE;
		tolerance = tolerance || DEFAULT_CACHE_TOLERANCE;

		var maxSize = Math.ceil(cacheSize * (1 + tolerance));

		var cache = {};
		var currentSize = 0;

		function cleanCache() {
			// Clean up stale cache entries
			if(currentSize <= maxSize) {
				return;
			}
			var toRemove = Math.max(currentSize - cacheSize, 0);
			var ordered = [];
			for(var k in cache) {
				// jshint forin: false
				ordered.push(k);
			}
			ordered.sort(function(a, b) {
				return cache[a].ts - cache[b].ts;
			});
			for(var i=0;i<toRemove;i+=1) {
				delete cache[ordered[i]];
				currentSize -= 1;
			}
		}

		function purgeCache() {
			cache = {};
		}

		function backendCacher(url, callback, processor, config) {
			// jshint validthis: true
			if(url in cache) {
				cache[url].ts = +new Date();
				// Cannot abort cached requests because they are synchronous
				return callback.apply(this, cache[url].data);
			}
			return backend.call(this, url, function() {
				if(!(arguments[0] instanceof Error)) {
					cache[url] = {data: arguments, ts: +new Date()};
					currentSize += 1;
					cleanCache();
				}
				callback.apply(this, arguments);
			}, processor, config);
		}

		backendCacher.purgeCache = purgeCache;
		backendCacher.displayName = cachedBackend.name + ': ' + (backend.displayName || backend.name);

		return backendCacher;
	}

	function ajaxBackend(ajaxOptions) {
		// A backend function that does a real XMLHttpRequest using a jQuery.ajax GET request
		ajaxOptions = ajaxOptions || {};
		return function jQueryBackend(url, callback) {
			var match = url.match(/^\[(\w+)\](.*)$/) || [];
			url = match[2] || url;
			var method = match[1] || 'GET';
			var opts = search.util.extend({}, ajaxOptions, {
				url: url,
				type: method
			});
			var request = $.ajax(opts).done(callback).fail(function(xhr, textStatus, errorThrown) {
				if(!errorThrown || !(errorThrown instanceof Error)) {
					errorThrown = new Error(errorThrown || textStatus);
				}
				callback(errorThrown);
			});
			return {
				abort: function() {
					request.abort();
				}
			};
		};
	}

	var backend = search.backend = search.backend || {};
	backend.deduplicatedBackend = deduplicatedBackend;
	backend.cachedBackend = cachedBackend;
	backend.ajaxBackend = ajaxBackend;

	backend.defaultBackend = function defaultBackend() {
		if(!defaultBackend.instance) {
			var defaultAjaxBackend = ajaxBackend({
				dataType: 'json',
				timeout: 1800
			});
			// Caching must be done after deduplication to not cache concurrent requests
			defaultBackend.instance = deduplicatedBackend(cachedBackend(defaultAjaxBackend));
		}
		return defaultBackend.instance;
	};

})(window.SCS = window.SCS || {}, 'Tc' in window ? __webpack_provided_window_dot_Tc_dot_$ : __webpack_provided_window_dot_$);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0), __webpack_require__(0)))

/***/ }),
/* 295 */
/***/ (function(module, exports) {

(function(SCS) {
	'use strict';

	SCS.search = SCS.search || {};
	SCS.search.util = SCS.search.util || {};

	var util = SCS.search.util;

	var slice = Array.prototype.slice;

	function respondOnce(targetEvents, callback, context) {
		if(!util.isArray(targetEvents)) {
			targetEvents = [targetEvents];
		}
		var result = function onceResponder(event, processor) {
			if(util.inArray(event, targetEvents) === -1) {
				return;
			}
			processor.removeResponder(onceResponder);
			callback.apply(context||this, arguments);
		};
		result.displayName = result.name + ' (' + targetEvents + '): ' + callback.name;
		return result;
	}

	function respondTo(events, context) {
		var result = function toResponder(event) {
			if(event in events) {
				var args = slice.call(arguments, toResponder.length);
				events[event].apply(context||this, args);
			}
		};
		result.displayName = result.name + ': ' + (Object.keys ? Object.keys(events) : 'events');
		return result;
	}

	util.respondOnce = respondOnce;
	util.respondTo = respondTo;

})(window.SCS = window.SCS || {});

/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_Tc_dot_$, __webpack_provided_window_dot_$) {(function(SCS, $) {
	'use strict';

	var arrayProto = Array.prototype;
	
	var isArray = Array.isArray || function(object) {
		return Object.prototype.toString.call(object) === '[object Array]';
	};

	var inArray = ('indexOf' in arrayProto && function inArray(item, array) {
		return arrayProto.indexOf.call(array, item);
	}) || $.inArray;

	var extend = ($ && $.extend) || function extend(base) {
		var extendWith = arrayProto.slice.call(arguments, extend.length);
		for(var i=0;i<extendWith.length;i+=1) {
			for(var name in extendWith[i]) {
				// jshint forin: false
				base[name] = extendWith[i][name];
			}
		}
		return base;
	};

	/**
	 * Flattens an object/array in to a single array where the nth item is the key path and the n+1th item is the value
	 */
	function flatten(object, result, prefix) {
		result = result || [];
		prefix = prefix || '';
		if(isArray(object)) {
			for(var i=0;i<object.length;i+=1) {
				flatten(object[i], result, prefix+'[]');
			}
		} else if(typeof(object) === 'object' && object !== null) {
			for(var k in object) {
				// jshint forin: false
				var p = prefix ? prefix+'['+k+']' : k;
				flatten(object[k], result, p);
			}
		} else {
			result.push(prefix, String(object));
		}
		return result;
	}

	function urlEncode(string) {
		return window.encodeURIComponent(string).replace(/%20/g, '+');
	}

	function param(object) {
		var items = flatten(object);
		var result = [];
		for(var i=0;i<items.length;i+=2) {
			result.push(urlEncode(items[i])+'='+urlEncode(items[i+1]));
		}
		return result.sort().join('&');
	}

	function parallel(operations, callback) {
		if(!operations.length) {
			return callback();
		}
		var pending = operations.length;
		function done() {
			pending -= 1;
			if(pending === 0) {
				callback();
			}
		}
		var apis = [];
		for(var i=0;i<operations.length;i+=1) {
			apis.push(operations[i](done));
		}
		return {
			abort: function() {
				for(var i=0;i<apis.length;i+=1) {
					if(apis[i]) {
						apis[i].abort();
					}
				}
			}
		};
	}

	var search = SCS.search = SCS.search || {};
	var util = search.util = search.util || {};

	if(false) {
		// Visible for testing
		util.internals = util.internals || {};
		util.internals = {
			urlEncode: urlEncode
		};
	}


	util.isArray = isArray;
	util.inArray = inArray;
	util.extend = extend;
	util.param = param;
	util.parallel = parallel;

})(window.SCS = window.SCS || {}, 'Tc' in window ? __webpack_provided_window_dot_Tc_dot_$ : __webpack_provided_window_dot_$);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0), __webpack_require__(0)))

/***/ }),
/* 297 */
/***/ (function(module, exports) {

(function(SCS) {
	'use strict';

	var search = SCS.search = SCS.search || {};
	var util = search.util = search.util || {};

	function retrieveKeymatchesFromSuggestions(keymatchProcessor) {
		var running;
		function abortRunning() {
			if(running) {
				running.abort();
			}
		}
		return function keymatchRetriever(data, configuration, callback) {
			abortRunning();

			// Build search string for keymatch from the suggestions we got
			var results = data.results || [];
			var query = '';
			for(var i=0;i<results.length;i+=1) {
				query += results[i].name + ' ';
			}
			if(query) {
				query = query.slice(0, -1);
			} else {
				// No autosuggest results, use the original query for keymatches
				query = configuration.query;
			}

			var autosuggestProcessor = this.processor;

			// Unregister after the first result form the autosuggest processor and abort
			// the current loading of keymatches if the autosuggest was aborted
			autosuggestProcessor.responder(util.respondOnce(['abort', 'data'], util.respondTo({
				abort: abortRunning
			})));

			function keymatchQueryDone(event, keymatchProcessor, data, config) {
				running = null;
				if(event === 'data') {
					autosuggestProcessor.send('keymatch-data', data, config);
				}
			}

			keymatchProcessor.responder(util.respondOnce(['data', 'error', 'abort'], keymatchQueryDone));
			keymatchProcessor.process({query: query, userQuery: configuration.query});
			running = keymatchProcessor;

			// FIXME: Should we wait with processing suggestions until keymatches are loaded?
			callback();
		};
	}

	function abortShortQueries(limit) {
		limit = limit || 3;
		return function shortQueriesAborter(configuration, callback) {
			if(String(configuration.query).length >= limit) {
				// All OK
				return callback();
			}
			this.abort();
			callback();
		};
	}

	function setUp(processor, keymatchRetriever, shortQueriesAborter) {
		if(keymatchRetriever) {
			processor.usePost(keymatchRetriever, 200);
		}
		processor.usePre(shortQueriesAborter||abortShortQueries(), -10000);
	}

	var plugins = search.plugins = search.plugins || {};
	var autosuggest = plugins.autosuggest = plugins.autosuggest || {};

	autosuggest.retrieveKeymatchesFromSuggestions = retrieveKeymatchesFromSuggestions;
	autosuggest.setUp = setUp;

})(window.SCS = window.SCS || {});

/***/ }),
/* 298 */
/***/ (function(module, exports) {

(function(SCS) {
	'use strict';

	var search = SCS.search = SCS.search || {};

	function handleAutounfilter() {
		// Stops the query if no results were found and creates a new query where the filters are removed.
		// Should be added after spellchecking (because autocorrections should be applied first).
		return function autounfilterHandler(data, configuration, callback) {
			// Only unfilter automatically if no results
			if(data.resultCount) {
				return callback();
			}

			// No filters set to begin with. Abort.
			if(!configuration.requiredfields) {
				return callback();
			}

			var processor = this.processor;
			// Clear filters and re-trigger search
			var update = {
				filter: {},
				subsearch: true,
				previousFilter: configuration.filter
			};
			var config = search.util.extend({}, configuration.inputConfig, update);
			processor.track('automaticFilterRemoval', search.util.extend({}, configuration, update));

			this.abort(true);
			processor.process(config);
		};
	}

	function setUp(processor, autounfilterHandler, weight) {
		weight = weight || 110;
		processor.usePost(autounfilterHandler||handleAutounfilter(), weight);
	}

	var plugins = search.plugins = search.plugins || {};
	var filtering = plugins.filtering = plugins.filtering || {};

	filtering.handleAutounfilter = handleAutounfilter;
	filtering.setUp = setUp;

})(window.SCS = window.SCS || {});

/***/ }),
/* 299 */
/***/ (function(module, exports) {

(function(SCS) {
	'use strict';

	var search = SCS.search = SCS.search || {};

	var GSA_AND_DELIMITER = '.';
	var GSA_EQUAL_DELIMITER = ':';
	var GSA_FACET_PREFIX = 'gsaentity_GSA_';

	function addFilterParams(defaultFilter) {
		// A pre-filter that transforms the filter config property into a “requiredfields” facet filtering string readable by the GSA.
		// Must be added before paramsTransposer from url-handling.js
		defaultFilter = defaultFilter || {};
		return function filterParamsAdder(config, callback) {
			if(!('filter' in config)) {
				// Create a copy of the default filter
				config.filter = search.util.extend({}, defaultFilter);
			}
			var filterString = '';
			for(var name in config.filter) {
				// jshint forin: false
				filterString += GSA_FACET_PREFIX+name + GSA_EQUAL_DELIMITER + config.filter[name] + GSA_AND_DELIMITER;
			}
			if(filterString) {
				// Cut off the last GSA_AND_DELIMITER
				config.requiredfields = filterString.slice(0, -1);
				config.gsaFilter = 'duplicateSnippet';
			}
			callback();
		};
	}

	function split(sites) {
		if(typeof sites === 'string') {
			return sites.split(/\|+/);
		}
		return sites || [];
	}

	function addSiteParams(defaultSites) {
		defaultSites = split(defaultSites);
		// Makes it easy to pass sites as an array and converts it into a pipe-separated string as necessary
		return function siteParamsAdder(config, callback) {
			if('site' in config) {
				config.sites = split(config.site);
				return callback();
			}
			if('sites' in config) {
				config.sites = split(config.sites);
			} else {
				config.sites = defaultSites;
			}
			if(config.sites && config.sites.length) {
				config.site = config.sites.join('|');
			}
			
			callback();
		};
	}

	function handlePaging() {
		// Adjusts the offset to the current page number (if given)
		return function pagingHandler(config, callback) {
			if(!config.inputConfig || 'offset' in config.inputConfig || !('offset' in config) || !('page' in config)) {
				// Explicit offset given, ignore
				// Or no page given, ignore
				return callback();
			}
			config.offset = config.page * config.resultLimit;
			callback();
		};
	}

	function aggregateMetaTags() {
		// Converts the metaTags attribute of each result to an object format
		return function metaTagsAggregator(data, config, callback) {
			var results = data.results || [];

			for(var i=0;i<results.length;i+=1) {
				var result = results[i];
				var metaTags = result.metaTags || [];
				var meta = result.meta = {};
				for(var j=0;j<metaTags.length;j+=1) {
					var metaTag = metaTags[j];
					meta[metaTag.name] = metaTag.value;
				}
			}

			callback();
		};
	}

	function aggregateDynNavFacets() {
		// Converts the dynNav facets attribute of the data to an object format
		return function dynNavFacetsAggregator(data, config, callback) {
			var facets = (data.dynNav && data.dynNav.facets) || [];
			config.facets = {};
			for(var i=0;i<facets.length;i+=1) {
				var facet = facets[i];
				var name = facet.name;
				if(name.indexOf(GSA_FACET_PREFIX) === 0) {
					name = name.substring(GSA_FACET_PREFIX.length);
				}
				facet = config.facets[name] = search.util.extend({}, facet);
				var values = facet.values || [];
				facet.values = {};
				for(var j=0;j<values.length;j+=1) {
					var value = values[j];
					facet.values[value.value] = value;
				}
			}
			callback();
		};
	}

	function setUp(processor, filterParamsAdder, siteParamsAdder, pagingHandler, metaTagsAggregator, dynNavFacetsAggregator) {
		processor.usePre(filterParamsAdder||addFilterParams());
		processor.usePre(siteParamsAdder||addSiteParams());
		processor.usePre(pagingHandler||handlePaging(), 50000);
		processor.usePost(metaTagsAggregator||aggregateMetaTags(), 500);
		processor.usePost(dynNavFacetsAggregator||aggregateDynNavFacets(), 510);
	}

	var plugins = search.plugins = search.plugins || {};
	var gsa = plugins.gsa = plugins.gsa || {};

	gsa.addFilterParams = addFilterParams;
	gsa.addSiteParams = addSiteParams;
	gsa.handlePaging = handlePaging;
	gsa.aggregateMetaTags = aggregateMetaTags;
	gsa.aggregateDynNavFacets = aggregateDynNavFacets;
	gsa.setUp = setUp;

})(window.SCS = window.SCS || {});

/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

(function(SCS) {
	'use strict';

	var search = SCS.search = SCS.search || {};

	function getEcommerceURL(ecommerceBaseURL, language, segment, productId) {
		var eCommerceURL = ecommerceBaseURL;
		eCommerceURL = eCommerceURL.replace('%LANG%', language);
		eCommerceURL = eCommerceURL.replace('%SEGMENT%', segment);
		eCommerceURL = eCommerceURL + productId;
		return eCommerceURL;
	}
	var DATA_EXTRACTORS = {
		ecommerceproduct: function(keymatch, data, ecommerceBaseURL) {
			keymatch.segment = data[2];
			keymatch.language = data[3];
			keymatch.productId = data[4];
			keymatch.eCommerceURL = getEcommerceURL(ecommerceBaseURL, keymatch.language, keymatch.segment, keymatch.productId);
			keymatch.display = 'product';
			// Fill in title and subtitle generically
			this.generic(keymatch, data);
		},
		product: function(keymatch, data) {
			keymatch.brand = data[0];
			keymatch.product = data[1];
			keymatch.image = data[2];
			keymatch.rating = data[3];
			keymatch.ratingCount = data[4];
			// Fill in title and subtitle generically
			this.generic(keymatch, data);
		},
		webcode: function(keymatch) {
			keymatch.redirectTo = keymatch.url;
		},
		generic: function(keymatch, data) {
			keymatch.title = data[0];
			keymatch.subtitle = data[1];
		},
		selfcare: function(keymatch, data) {
			keymatch.isSelfcare = true;
			this.generic(keymatch, data);
		}
	};
	function splitKeymatchData(dataExtractors, ecommerceBaseURL) {
		ecommerceBaseURL = ecommerceBaseURL || '/portalshop-api/%LANG%/%SEGMENT%/Product/GetFamilyData/';
		dataExtractors = dataExtractors || DATA_EXTRACTORS;

		return function keymatchDataSplitter(data, config, callback) {
			var keymatches = data.keymatches;
			if(!keymatches || !keymatches.length) {
				return callback();
			}
			config.keymatches = [];
			for(var i=0;i<keymatches.length;i+=1) {
				var keymatch = search.util.extend({}, keymatches[i]);
				keymatch.data = keymatch.data.split(/\|/);
				keymatch.type = keymatch.data.pop().toLowerCase();
				keymatch.display = keymatch.type;
				if(keymatch.type in dataExtractors) {
					dataExtractors[keymatch.type](keymatch, keymatch.data, ecommerceBaseURL);
				}
				config.keymatches.push(keymatch);
			}
			callback();
		};
	}

	function redirectToKeymatch(redirector) {
		redirector = redirector || function(url) {
			window.location = url;
		};

		return function keymatchRedirector(data, config, callback) {
			var keymatches = config.keymatches;
			if(!keymatches || !keymatches.length) {
				return callback();
			}

			for(var i=0;i<keymatches.length;i+=1) {
				var keymatch = keymatches[i];
				if(keymatch.redirectTo) {
					redirector(keymatch.redirectTo);
					this.abort();
					return callback();
				}
			}
			callback();
		};
	}

	var DATA_AGGREGATORS = {
		ecommerceproduct: function(keymatch, backend, callback) {
			return backend(keymatch.eCommerceURL, function(response) {
				keymatch.error = response instanceof Error ? response : null;
				if (!response || !response.ProductDataFamily || response instanceof Error) {
					return callback();
				}

				var family = response.ProductDataFamily;
				keymatch.brand = family.ProductBrand;
				keymatch.product = family.ProductName;
				keymatch.tagline = family.ProductSlogan;

				keymatch.title = (keymatch.brand || keymatch.title) + ' ' + (keymatch.product || keymatch.subtitle);
				keymatch.subtitle = keymatch.tagline || '';

				var familyRating = family.AggregatedFamilyRatingSummary;
				if(familyRating) {
					keymatch.ratingCount = familyRating.NumberOfRatings;
					keymatch.rating = familyRating.Rating;
				}

				var familyProductData = family.FamilyProductData;
				if (familyProductData && familyProductData.length > 0) {
					keymatch.image = familyProductData[0].ProductImageSmall;
				}

				callback();
			});
		}
	};
	var DEFAULT_AGGREGATOR = function(keymatch, backend, callback) {
		callback({});
	};
	function aggregateKeymatchContents(backend, dataAggregators) {
		dataAggregators = dataAggregators || DATA_AGGREGATORS;

		return function keymatchContentsAggregator(data, config, callback) {
			var keymatches = config.keymatches;
			if(!keymatches || !keymatches.length) {
				return callback();
			}
			// Use the current backend to request data from ecommerce
			var aggregateBackend = backend || this.processor.backend;
			var aggregators = [];
			function aggregator(keymatch) {
				return function(callback) {
					var aggregator = keymatch.type in dataAggregators ? dataAggregators[keymatch.type] : DEFAULT_AGGREGATOR;
					aggregator(keymatch, aggregateBackend, callback);
				};
			}
			for(var i=0;i<keymatches.length;i+=1) {
				aggregators.push(aggregator(keymatches[i]));
			}
			// Delay results until keymatches are loaded from ecommerce.
			// FIXME: Is this a good idea?
			return search.util.parallel(aggregators, callback);
		};
	}

	function setUp(processor, keymatchDataSplitter, keymatchContentsAggregator, keymatchRedirector, weight) {
		weight = weight || 300;
		processor.usePost(keymatchDataSplitter||splitKeymatchData(), weight);
		processor.usePost(keymatchContentsAggregator||aggregateKeymatchContents(), weight+20);
		if(keymatchRedirector) {
			// Only use if explicitly passed
			processor.usePost(keymatchRedirector, weight+10);
		}
	}

	var plugins = search.plugins = search.plugins || {};
	var keymatch = plugins.keymatch = plugins.keymatch || {};

	keymatch.splitKeymatchData = splitKeymatchData;
	keymatch.aggregateKeymatchContents = aggregateKeymatchContents;
	keymatch.redirectToKeymatch = redirectToKeymatch;
	keymatch.setUp = setUp;

	if(false) {
		// Visible for testing
		search.internals = search.internals || {};
		search.internals.keymatch = {
			getEcommerceURL: getEcommerceURL
		};
	}

})(window.SCS = window.SCS || {});

/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_Tc_dot_$, __webpack_provided_window_dot_$) {/* Search Sessions - v0.1.0 - 2016-01-04
 * Copyright (c) 2016 Contexity AG; Licensed
 * exported SearchSessions
 *
 # Search Sessions

 Support for search sessions as a JS "module".

 ## Getting Started

 General form:
 ```javascript
 var session = window.scsSiteSearch.SearchSessions([options]).getSession(query[,action]);
 ```
 where the parameters are as follows:
 - **options**: an optional configuration object, which supports the following parameters
 -	*timeout*: the numbers of milliseconds after which a search session expires
 - *min_shared_terms*: the minimum number of terms two subsequent queries must have in common in order to be considered to belong to the same search session
 -	*max_distance*: the maximum edit distance two subsequent queries must have in common in order to be considered to belong to the same search session
 - **query**: the query text entered by the user (**Note!** Not satinized internally!)
 - **action**: an optional forced session-update action with the following possible values:
 -	*"new"*: causes a new session to be created, reseting sequences if necessary
 -	*"next"*: forces an update of the session, even if the session continuation criteria are met
 -	*"same"*: forces the session to remain the same, even if the session continuation criteria are not met

 The default options if none are specified are as follows:
 ```javascript
 {
 timeout: 180000,
 min_shared_terms: 1,
 max_distance: 3,
 }
 ```

 The session objects returned have the following attributes:
 -  **created**: timestamp of the time at which the session was created
 -  **accessed**: timestamp of the time at which the session was last retrieved
 -  **ssid**: the session's ID
 -  **query**: the query text entered by the user (**Note!** Not sanitized internally!)

 */
(function(SCS, JSON, $) {
	'use strict';

	var search = SCS.search = SCS.search || {};
	var noop = function() {};

	var currentTS = Date.now || function() { return +new Date(); };

	// original Levenshtein distance code: Copyright (c) 2011 Andrei Mackenzie (https://gist.github.com/andrei-m/982927)
	// transposition ammendment by Contexity
	function editDistance(a, b) {
		if (a.length === 0) {
			return b.length;
		}
		if (b.length === 0) {
			return a.length;
		}

		var matrix = [];

		// increment along the first column of each row
		var i;
		for (i = 0; i <= b.length; i+=1) {
			matrix[i] = [i];
		}

		// increment each column in the first row
		var j;
		for (j = 0; j <= a.length; j+=1) {
			matrix[0][j] = j;
		}

		// Fill in the rest of the matrix
		for (i = 1; i <= b.length; i+=1) {
			for (j = 1; j <= a.length; j+=1) {
				if (b.charAt(i - 1) === a.charAt(j - 1)) {
					matrix[i][j] = matrix[i - 1][j - 1];
					continue;
				}
				matrix[i][j] = Math.min(matrix[i - 1][j - 1] + 1,   // substitution
					Math.min(matrix[i][j - 1] + 1,                  // insertion
						matrix[i - 1][j] + 1));                     // deletion
				if (i > 1 && j > 1 && a.charAt(i - 1) === b.charAt(j - 2) &&
					a.charAt(i - 2) === b.charAt(j - 1)) {
					matrix[i][j] = Math.min(matrix[i][j],
						matrix[i - 2][j - 2] + 1);                  // transposition
				}
			}
		}

		return matrix[b.length][a.length];
	}

	// compares the terms in two query strings and returns the number of terms that occur in both
	var TERM_SEPARATOR = /\s+/;
	function commonTerms(q1, q2) {

		if (!q1 || !q2) {
			return 0;
		}
		var t1 = q1.split(TERM_SEPARATOR), t2 = q2.split(TERM_SEPARATOR), d = {}, count = 0;
		for (var i = 0; i < t1.length; i+=1) {
			d[t1[i]] = true;
		}
		for (var j = 0; j < t2.length; j+=1) {
			if (d[t2[j]]) {
				count+=1;
			}
		}
		return count;
	}

	// RFC4122 v.4 compatible UUIDs
	// (http://stackoverflow.com/questions/105034/create-guid-uuid-in-javascript/2117523#2117523)
	function uuid() {
		// jshint bitwise: false
		var uuid =
			'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
				// var r = crypto.getRandomValues(new Uint8Array(1))[0] % 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
				var r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
				return v.toString(16);
			});
		return uuid;
	}

	// Loads/sets session data
	var sessionStorage = null;
	try {
		sessionStorage = window.sessionStorage;
	} catch(e) {}
	var writer = (sessionStorage && function(name, value) {
		sessionStorage.setItem(name, value);
	}) || ($ && $.cookie && function(name, value) {
		__webpack_provided_window_dot_$.cookie(name).set(value);
	}) || noop;
	var loader = (sessionStorage && function(name) {
		return sessionStorage.getItem(name);
	}) || ($ && $.cookie && function(name) {
		return $.cookie(name).get();
	}) || noop;

	// Encapsulates session data load/storage
	var defaultStorageHandler = {
		get: loader,
		set: writer
	};

	function defaultIDSequence(previous) {
		if (typeof(previous) === 'number') {
			return previous + 1;
		} else {
			return 1;
		}
	}
	
	var SESSION_SESSION_KEY = 'sc-search-session';

	function createSessionFactory(options, logger, idSequence, idGenerator, storageHandler) {
		logger = logger || window.debug;
		idSequence = idSequence || defaultIDSequence;
		idGenerator = idGenerator || uuid;
		storageHandler = storageHandler || defaultStorageHandler;

		// conditional console logging, may be replaced with pre-existing logging infrastructure
		function _log() {
			if(logger) {
				logger.log.apply(logger, arguments);
			}
		}

		// defaults...
		var _defaults = {
			timeout: 180000,
			min_shared_terms: 1,
			max_distance: 3,
			session_key: SESSION_SESSION_KEY
		};
		// ... extended by any options passed in
		var _options = search.util.extend({}, _defaults, options || {});

		// create a new search session with the given query text
		function _newSession(query, prevSession) {
			var now = currentTS();
			var sequence = idSequence(prevSession ? prevSession.sequence : null);
			var id = idGenerator();
			return {created: now, accessed: now, ssid: id, sequence: sequence, query: query};
		}

		// create a "successor" session to the one passed in as parameter
		function _nextSession(session, query) {
			if(!session) {
				_log('Invalid session passed to _nextSession:', session);
			}
			return _newSession(query, session);
		}

		// "touch" a session, updating its last accessed time, but leaving the ssid the same
		function _touchSession(session, query) {
			if(!session) {
				_log('Invalid session passed to _touchSession:', session);
			}
			session.accessed = currentTS();
			session.query = query || session.query || '';
			return session;
		}

		function queryDemandsNewSession(currentSession, query) {
			// we have the same session if:
			// 1. the queries have the minimum of common terms
			return (commonTerms(currentSession.query, query) < _options.min_shared_terms) &&
					// 2. have the maximum allowed edit distance
				(editDistance(currentSession.query, query) > _options.max_distance);
		}

		function timeDistanceDemandsNewSession(currentSession) {
			return (currentTS() - currentSession.accessed) >= _options.timeout;
		}

		function _needNextSession(currentSession, query) {
			return timeDistanceDemandsNewSession(currentSession) && queryDemandsNewSession(currentSession, query);
		}

		var currentSession = null;
		return function getSession(query, force) {
			if(currentSession === null) {
				// retrieve the current session if any
				currentSession = storageHandler.get(_options.session_key);
				if(currentSession) {
					currentSession = JSON.parse(currentSession);
				}
			}
			if (!currentSession) {
				currentSession = false;
				force = 'new';
			}

			if (!query) {
				// return previous session from cache
				return currentSession;
			}

			if(!force) {
				force = _needNextSession(currentSession, query) ? 'next' : 'current';
			}

			// force session behaviour
			if (force === 'new') {
				// always return a new session
				currentSession = _newSession(query);
			} else if (force === 'next') {
				// always return the next session
				currentSession = _nextSession(currentSession, query);
			} else if (force === 'current') {
				// always return the existing version, if there is one
				currentSession = _touchSession(currentSession, query);
			}

			// store the new session
			storageHandler.set(_options.session_key, JSON.stringify(currentSession));
			return currentSession;
		};

	}

	function defaultSessionFactory() {
		if(!defaultSessionFactory.instance) {
			defaultSessionFactory.instance = createSessionFactory();
		}
		return defaultSessionFactory.instance;
	}

	function addSession(sessionGetter) {
		sessionGetter = sessionGetter || defaultSessionFactory();
		// Generates a session for the query.
		// Can be added as soon as the query is known.
		function sessionAdder(config, callback) {
			var sessionOptions = config.sessionOptions || {};
			var force = sessionOptions.forceOnce || sessionOptions.force || null;
			config.forceSession = force;
			// Next request, even if derived, should not force the session again
			delete sessionOptions.forceOnce;
			var session = sessionGetter(config.query, force);
			config.session = session;
			config.ssid = session.ssid;
			config.sessionSequence = session.sequence;
			callback();
		}

		sessionAdder.sessionGetter = sessionGetter;

		return sessionAdder;
	}

	function setUp(processor, sessionAdder) {
		processor.usePre(sessionAdder||addSession(), -10000);
	}

	var plugins = search.plugins = search.plugins || {};
	var session = plugins.session = plugins.session || {};

	if(false) {
		// Visible for testing
		var internals = session.internals = session.internals || {};
		internals.defaultStorageHandler = defaultStorageHandler;
		internals.defaultSessionFactory = defaultSessionFactory;
		internals.defaultIDSequence = defaultIDSequence;
		internals.uuid = uuid;
		internals.editDistance = editDistance;
		internals.commonTerms = commonTerms;
		internals.resetDefaultSession = function() {
			defaultSessionFactory.instance = null;
			defaultStorageHandler.set(SESSION_SESSION_KEY, '');
		};
	}

	session.createSessionFactory = createSessionFactory;
	session.addSession = addSession;
	session.setUp = setUp;

})(window.SCS = window.SCS || {}, window.JSON, 'Tc' in window ? __webpack_provided_window_dot_Tc_dot_$ : __webpack_provided_window_dot_$);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0), __webpack_require__(0)))

/***/ }),
/* 302 */
/***/ (function(module, exports) {

(function(SCS) {
	'use strict';

	var search = SCS.search = SCS.search || {};

	function handleAutocorrect() {
		// Handles the cases where we automatically cancel the current search and do a new search because we had no results
		// See flow-chart at https://wiki.swisscom.com/display/PD/Workflow
		return function autocorrectHandler(data, configuration, callback) {
			// Only correct automatically if no results
			if(data.resultCount) {
				return callback();
			}

			// Don’t do automatic corrections after first iteration
			if('autoCorrectedFrom' in configuration) {
				return callback();
			}

			var suggestions = data.spellingSuggestions || [];

			// Don’t do anything if no suggestions found
			if(!suggestions || !suggestions.length) {
				return callback();
			}

			var processor = this.processor;
			var firstSuggestion = suggestions[0];
			// Send a new query with the same config but the autocorrected query
			var config = search.util.extend({}, configuration.inputConfig, {
				autoCorrectedFrom: configuration.query,
				nextSuggestion: suggestions.length > 1 ? suggestions[1].plain : null,
				subsearch: true,
				query: firstSuggestion.plain
			});
			processor.track('automaticSpellingCorrection', search.util.extend({}, configuration, {
				query: firstSuggestion.plain,
				previousQuery: configuration.query
			}));

			this.abort(true);
			processor.process(config);
		};
	}

	function addManualCorrection() {
		// Adds a property manualCorrectionSuggestion to the returned configuration.
		// Should be added after the handleAutocorrect filter.
		return function manualCorrectionAdder(data, configuration, callback) {
			var suggestions = data.spellingSuggestions || [];

			// Don’t do anything if no suggestions found
			if(!suggestions.length && !configuration.nextSuggestion) {
				return callback();
			}

			// Take the nextSuggestion (2nd place before) from a previous, auto-corrected search
			// or, alternatively, the current top suggestion
			var suggestionText = configuration.nextSuggestion;
			if(!suggestionText) {
				suggestionText = suggestions[0].plain;
			}
			configuration.manualCorrectionSuggestion = suggestionText;

			callback();
		};
	}

	function setUp(processor, autocorrectHandler, manualCorrectionAdder, weight) {
		weight = weight || 100;
		processor.usePost(autocorrectHandler||handleAutocorrect(), weight);
		processor.usePost(manualCorrectionAdder||addManualCorrection(), weight+20);
	}

	var plugins = search.plugins = search.plugins || {};
	var spellchecking = plugins.spellchecking = plugins.spellchecking || {};

	spellchecking.handleAutocorrect = handleAutocorrect;
	spellchecking.addManualCorrection = addManualCorrection;
	spellchecking.setUp = setUp;

})(window.SCS = window.SCS || {});

/***/ }),
/* 303 */
/***/ (function(module, exports) {

(function(SCS) {
	'use strict';

	var search = SCS.search = SCS.search || {};

	function trackQueries() {
		return function queriesTracker(data, config, callback) {
			var params = search.util.extend({}, config, {resultCount: data.resultCount});
			config.queryTrackedBy = this.processor.track('searchQuery', params);
			callback();
		};
	}

	function trackNoResults() {
		// Tracks a query that returned no results
		// Add before spellchecking handling so we only get the no-results cases that are displayed to the user
		return function noResultsTracker(data, config, callback) {
			// Do nothing if results were found
			if(data.resultCount) {
				return callback();
			}

			var params = search.util.extend({}, config, {resultCount: 0});
			config.noResultsTrackedBy = this.processor.track('noResults', params);
			callback();
		};
	}

	function setUp(processor) {
		processor.usePost(trackQueries(), 1000);
		processor.usePost(trackNoResults(), 1000);
	}

	var plugins = search.plugins = search.plugins || {};
	var tracking = plugins.tracking = plugins.tracking || {};

	tracking.trackQueries = trackQueries;
	tracking.trackNoResults = trackNoResults;
	tracking.setUp = setUp;

})(window.SCS = window.SCS || {});

/***/ }),
/* 304 */
/***/ (function(module, exports) {

(function(SCS) {
	'use strict';

	var search = SCS.search || {};
	var extend = search.util.extend;

	function saveInputConfig(blacklist) {
		blacklist = blacklist || {};
		// Saves the config that was input initially (rather than what all the later plugins modified)
		// so that when re-sending or modifying old queries we don’t have to set all the auto-generated config attributes
		// (we can use this to de-duplicate running queries from a responder instead of stopping and re-starting them)
		return function inputConfigSaver(config, callback) {
			config.inputConfig = extend({}, config);
			for(var k in blacklist) {
				// jshint forin: false
				delete config.inputConfig[k];
			}
			callback();
		};
	}

	function setBaseURL(baseURL, suffix, backendType) {
		backendType = backendType || 'gsa';
		// Sets the given baseURL as the URL to use for a request.
		// Should be added very early (low weight) in the pre-filter chain.
		return function baseURLSetter(config, callback) {
			config.url = baseURL + (config.url || suffix || '');
			config.endpointURL = config.url;
			config.baseURL = baseURL;
			config.backendType = backendType;
			callback();
		};
	}

	var DEFAULT_CONFIG = {requester: 'user', origin: null};
	function addDefaultConfig(defaultConfig, customConfig) {
		defaultConfig = extend({}, defaultConfig || DEFAULT_CONFIG, customConfig || {});
		// If a param exists in defaultConfig but not in config, it is taken from there.
		// Should be added just before transposeParams.
		return function defaultConfigAdder(config, callback) {
			config = extend({}, defaultConfig, config);
			callback(config);
		};
	}
	addDefaultConfig.DEFAULT_QUERY = extend({}, DEFAULT_CONFIG, {
		page: 0,
		offset: 0
	});
	
	// FIXME: Move to orchestration or gsa-handling
	var GSA_BASE = {
		client: '', // e.g. sc_v2_f_res_de
		query: '',
		site: '',
		getfields: '*'
	};
	var GSA_QUERY = extend({}, GSA_BASE, {
		proxystylesheet: 'sc_v2b_p_json_default',
		language: 'de' // e.g. lang_de
	});
	addDefaultConfig.GSA_SEARCH_CONFIG = extend({}, addDefaultConfig.DEFAULT_QUERY, GSA_QUERY, {
		resultLimit: 10,
		keyMatchLimit: 0,
		gsaFilter: 'both'
	});
	addDefaultConfig.GSA_SUGGEST_CONFIG = extend({}, DEFAULT_CONFIG, GSA_BASE, {
		format: 'rich',
		suggestionLimit: 5,
		gsaFilter: 'duplicateSnippet'
	});
	addDefaultConfig.GSA_CLUSTER_CONFIG = extend({}, DEFAULT_CONFIG, GSA_QUERY, {
		gsaFilter: 'duplicateSnippet'
	});


	function transposeParams(map) {
		map = map || {};
		// Transposes config.params according to the given map (from => to)
		// Used so we can have unified names of params that work for all backends (e.g. “query”)
		// And then have them transposed into backend-specific names (e.g. “q” for GSA)
		// Should be added before flattenParams but after all the param mingling is done (including addDefaultConfig).
		return function paramsTransposer(config, callback) {
			config.params = config.params || {};
			config.untransposedParams = extend({}, config.params);
			for(var name in map) {
				// jshint forin: false
				if(name in config) {
					config.untransposedParams[name] = config[name];
					if(map[name].constructor === Function) {
						map[name](config[name], config.params);
					} else {
						var newName = map[name] === true ? name : map[name];
						config.params[newName] = config[name];
					}
				}
			}
			callback();
		};
	}
	
	// FIXME: Move to orchestration
	transposeParams.GSA_MAP = {
		query: 'q',
		language: function transposeLanguage(language, params) {
			params.lr = 'lang_' + language;
		},
		client: true,
		site: true, // e.g. sc_v2_c_res_de_live
		getfields: true,
		gsaFilter: function transposeGsaFilter(gsaFilter, params) {
			if(gsaFilter === 'duplicateSnippet') {
				gsaFilter = 'p';
			} else if(gsaFilter === 'duplicateDirectory') {
				gsaFilter = 's';
			} else if(gsaFilter === 'none') {
				gsaFilter = '0';
			} else if(gsaFilter === 'both' || !gsaFilter) {
				// This is the default, don’t add the param
				// gsaFilter = '1'
				return;
			}
			params.filter = gsaFilter;
		},
		proxystylesheet: true,
		requiredfields: true, // gsaentity_GSA_Area:2_business
		format: true, // rich
		resultLimit: 'num',
		keyMatchLimit: 'numgm',
		suggestionLimit: 'max',
		offset: 'start'
	};
	transposeParams.GSA_TITLE_MAP = extend({}, {
		query: 't'
	}, transposeParams.GSA_MAP);

	function flattenParams(paramizeFunction) {
		paramizeFunction = paramizeFunction || search.util.param;
		// Generates the final URL by addind config.params as GET params to the URL.
		// Should be added very late (high weight) in the pre-filter chain of a SearchProcessor.
		return function paramsFlattener(config, callback) {
			config.params = config.params || {};
			config.url = typeof(config.url) === 'string' ? config.url : '/';
			config.baseURL = config.baseURL || config.url;
			config.rootURL = config.url;
			config.urlParams = paramizeFunction(config.params);
			var separator = config.url.indexOf('?') > -1 ? '&' : '?';
			config.url = config.url + separator + config.urlParams;
			callback();
		};
	}

	function prependRequestMethod(defaultMethod) {
		defaultMethod = defaultMethod || 'GET';
		// Prepend the request method to the URL for the ajax backend (but to still have nice cache keys)
		return function requestMethodPrepender(config, callback) {
			config.method = String(config.method || defaultMethod).toUpperCase();
			config.requestUrl = config.url;
			config.url = '['+config.method+']'+config.requestUrl;
			callback();
		};
	}

	function setUp(processor, inputConfigSaver, baseURLSetter, defaultConfigAdder, paramsTransposer, paramsFlattener, requestMethodPrepender) {
		processor.usePre(inputConfigSaver||saveInputConfig(), -2000000);
		processor.usePre(baseURLSetter, -1000000);
		if(defaultConfigAdder) {
			processor.usePre(defaultConfigAdder, 1000);
		}
		processor.usePre(paramsTransposer||transposeParams(), 1000000);
		processor.usePre(paramsFlattener||flattenParams(), 2000000);
		processor.usePre(requestMethodPrepender||prependRequestMethod(), 3000000);
	}

	var plugins = search.plugins = search.plugins || {};
	var url = plugins.url = plugins.url || {};

	url.saveInputConfig = saveInputConfig;
	url.setBaseURL = setBaseURL;
	url.addDefaultConfig = addDefaultConfig;
	url.transposeParams = transposeParams;
	url.flattenParams = flattenParams;
	url.prependRequestMethod = prependRequestMethod;
	url.setUp = setUp;

})(window.SCS = window.SCS || {});

/***/ }),
/* 305 */
/***/ (function(module, exports) {

(function(SCS) {
	'use strict';

	var search = SCS.search = SCS.search || {};

	function fixupStartValue() {
		// Fix up start value offset for Web vs. GSA (Web starts at 1, GSA at 0)
		return function startValueFixerUpper(config, callback) {
			if('start' in config.params) {
				config.params.start = config.params.start + 1;
			}
			callback();
		};
	}

	function fixupResult() {
		// Unify the data structure to be mostly compatible with what we get from the GSA
		return function resultFixerUpper(data, config, callback) {
			data = search.util.extend({}, data);
			var results = data.results = data.items || data.results || [];
			data.resultCount = (data.searchInformation && parseInt(data.searchInformation.totalResults, 10)) || data.resultCount || results.length || 0;
			callback(data);
		};
	}

	function setUp(processor, startValueFixerUpper, resultFixerUpper) {
		processor.usePre(startValueFixerUpper||fixupStartValue(), 1000500);
		processor.usePost(resultFixerUpper||fixupResult());
	}

	var plugins = search.plugins = search.plugins || {};
	var web = plugins.web = plugins.web || {};

	web.fixupStartValue = fixupStartValue;
	web.fixupResult = fixupResult;
	web.setUp = setUp;

})(window.SCS = window.SCS || {});

/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

(function(SCS) {
	'use strict';
	var search = SCS.search = SCS.search || {};
	search.trackers = search.trackers || {};
	// Define track logic as functions that can be called from the listeners

	var PARAM_MAPPING = {
		// mapping from internal => gsa param names
		href: 'url',
		query: 'q',
		start: 's',
		ctype: 'ct',
		cdata: 'cd',
		score: 'r'
	};

	function getTrackURL(props) {
		// jshint forin: false
		var name;
		var parameters = {
			ctype: 'OTHER',
			query: '',
			site: '',
			cdata: '{}',
			href: '',
			cq_ck: +new Date(),
			start: 0,
			score: 0
		};
		// Calculate cdata
		var cdata = {ssid: props.ssid, score: props.score};
		cdata.filters = [];
		for(name in (props.filter||{})) {
			cdata.filters.push(name+':'+props.filter[name]);
		}
		props.cdata = window.JSON.stringify(cdata);
		// Use params from props (if in whitelist)
		for(name in parameters) {
			if(name in props && props[name]) {
				parameters[name] = props[name];
			}
		}
		// Map parameters to GSA names
		for(name in PARAM_MAPPING) {
			if(name in parameters) {
				parameters[PARAM_MAPPING[name]] = parameters[name];
			}
			delete parameters[name];
		}
		// Convert params to query string
		parameters = search.util.param(parameters);
		return props.baseURL + '/click?' + parameters;
	}

	if(false) {
		// Visible for testing
		search.internals = search.internals || {};
		search.internals.gsa = {
			getTrackURL: getTrackURL
		};
	}

	var listeners = {
		// Listeners here
		generalClick: function(props) {
			if(props.backendType && props.backendType !== 'gsa') {
				return;
			}
			if(!props.baseURL) {
				// No URL, no tracking
				return;
			}

			var img = document.createElement('img');
			img.src = getTrackURL(props);
		}
	};
	search.trackers.gsa = listeners;
})(window.SCS = window.SCS || {});


/***/ }),
/* 307 */
/***/ (function(module, exports) {

// Add SCs_one.search.trackers_one.* tracking code here…
(function(SCS, debug) {
    'use strict';

    // jshint camelcase: false
    /* GetValOnce */
    function scGetValOnce(value, fieldname) {
        if (window.sessionStorage.getItem(fieldname) && String(value) === window.sessionStorage.getItem(fieldname)) return '';
        else {
            window.sessionStorage.setItem(fieldname, value);
            return value;
        }
    }

    // hotplugs for s_one functions
    var hotplug = {
        // apply item to list of not exists
        apl: function(array, item) {
            var narray = array;
            if (array.indexOf(item) < 0) narray.push(item); // push item if not in array
            return narray;
        },
        // cookie read
        c_r: function(a) {
            var b = document.cookie.match('(^|;)\\s*' + a + '\\s*=\\s*([^;]+)');
            return b ? b.pop() : 'undefined';
        }
    };

    var search = SCS.search = SCS.search || {};
    search.trackers = search.trackers || {};
    // Define track logic as functions that can be called from the listeners

    function querySearch(object) {
        window.SCS.tiq.trackingReadyCallbacks.push((function(object) {
            if (object.requester !== 'user' || object.origin !== 'serp' || object.page > 0 || object.fromFilterChange) return;

            var trackObj = SCS.datalayer.cloneMandatoryData();
            trackObj.apps = trackObj.apps || {};
            trackObj.apps.search = {};
            trackObj.apps.search.context = {};
            trackObj.apps.search.events = [];

            trackObj.apps.search.context['SERP'] = 'SERP_resultpage'; // this eVar should be present in all SERP pages, total seconds spent / instances = average
            trackObj.apps.search.events = ['searchQuery'];
            if (object.query) {
                trackObj.apps.search.context['SERP.query'] = object.query;
                if (scGetValOnce(object.query, 'SERP_query') !== '') trackObj.apps.search.events = hotplug.apl(trackObj.apps.search.events, 'newQueryTerm'); // every new query fires event
            }
            if (object.baseURL) trackObj.apps.search.context['SERP.baseURL'] = object.baseURL;
            if (object.endpointURL) trackObj.apps.search.context['SERP.endpointURL'] = object.endpointURL;
            if (object.backendType) trackObj.apps.search.context['SERP.backendType'] = object.backendType;
            if (object.resultCount) trackObj.apps.search.context['SERP.resultCount'] = object.resultCount;
            if (object.site) trackObj.apps.search.context['SERP.site'] = object.site;
            if (object.client) trackObj.apps.search.context['SERP.client'] = object.client;
            if (object.language) trackObj.apps.search.context['SERP.language'] = object.language;
            if (object.filter.Area) trackObj.apps.search.context['SERP.filter.Area'] = object.filter.Area;
            if (object.filter.Category) trackObj.apps.search.context['SERP.filter.Category'] = object.filter.Category;

            var sViCookie = hotplug.c_r('s_vi');
            if (sViCookie !== 'undefined') trackObj.apps.search.context['SERP.s_vi'] = sViCookie.replace('[CS]v1|', '').replace('[CE]', '');

            if (object.ssid && object.site) {
                trackObj.apps.search.context['SERP.ssid'] = object.ssid;
                var tmp3 = scGetValOnce(object.ssid, 'SERP_ssid');
                debug.log('value cookievalues:' + tmp3);
                debug.log(object);
                if (tmp3 !== '') trackObj.apps.search.events = hotplug.apl(trackObj.apps.search.events, 'firstQueryInSession'); // only the first search is been counted
            }

            SCS.datalayer.track(trackObj);
        })(object));
    }

    function resultlinktracking(object) {
        window.SCS.tiq.trackingReadyCallbacks.push((function(object) {
            var trackObj = SCS.datalayer.cloneMandatoryData();
            trackObj.apps = trackObj.apps || {};
            trackObj.apps.search = {};
            trackObj.apps.search.context = {};
            trackObj.apps.search.events = [];

            trackObj.apps.search.events = ['resultPageClick'];
            trackObj.apps.search.context['SERP'] = 'SERP_resultclick';

            if (object.ssid) trackObj.apps.search.context['SERP.ssid'] = object.ssid;
            if (object.sessionSequence) trackObj.apps.search.context['SERP.sessionSequence'] = object.sessionSequence;
            if (object.origin) trackObj.apps.search.context['SERP.origin'] = object.origin;
            if (object.ctype) {
                trackObj.apps.search.context['SERP.ctype'] = object.ctype;
                if (object.ctype === 'c' || object.ctype === 'ac' || object.ctype === 'keymatch') {
                    trackObj.apps.search.events = hotplug.apl(trackObj.apps.search.events, 'searchResultEntryClick'); // every click on a result in the middle (ctype c) is counted
                }
            }
            if (object.endpointURL) trackObj.apps.search.context['SERP.endpointURL'] = object.endpointURL;

            var sViCookie = hotplug.c_r('s_vi');
            if (sViCookie !== 'undefined') trackObj.apps.search.context['SERP.s_vi'] = sViCookie.replace('[CS]v1|', '').replace('[CE]', '');

            var tmp4;
            debug.log('object.site:' + object.site + ' object.ssid:' + object.ssid);
            if (object.ssid && object.site) {
                if (object.ctype === 'c' || object.ctype === 'ac' || object.ctype === 'keymatch') {
                    if (scGetValOnce(object.query, 'SERP_query_result') !== '') trackObj.apps.search.events = hotplug.apl(trackObj.apps.search.events, 'firstClickOnNewQueryTerm'); // only the first click for the query is been counted
                    tmp4 = scGetValOnce(object.ssid, 'SERP_ssid_result');
                    if (object.query && scGetValOnce(object.query, 'SERP_query') !== '') trackObj.apps.search.events = hotplug.apl(trackObj.apps.search.events, 'newQueryTerm'); // every new query fires event
                    debug.log('value cookievalues: ' + tmp4);
                    if (tmp4 !== '') trackObj.apps.search.events = hotplug.apl(trackObj.apps.search.events, 'firstClickOnSearchResult'); // only the first click on a result (ctype c or ac) is counted
                }
                if (object.ctype === 'ac' || object.ctype === 'keymatch') {
                    trackObj.apps.search.events = hotplug.apl(trackObj.apps.search.events, 'searchQuery'); //every query is tracked
                    trackObj.apps.search.context['SERP'] = 'SERP_query_resultpage'; // this eVar should be present in all SERP pages, total seconds spent / instances = average; override original value because of autocomplete detection
                    if (object.query) trackObj.apps.search.context['SERP.query'] = bject.query;
                    if (object.userQuery) trackObj.apps.search.context['SERP.userQuery'] = object.userQuery;
                    if (object.baseURL) trackObj.apps.search.context['SERP.baseURL'] = object.baseURL;
                    if (object.endpointURL) trackObj.apps.search.context['SERP.endpointURL'] = object.endpointURL;
                    if (object.backendType) trackObj.apps.search.context['SERP.backendType'] = object.backendType;
                    if (object.resultCount) trackObj.apps.search.context['SERP.resultCount'] = object.resultCount;
                    if (object.site) trackObj.apps.search.context['SERP.site'] = object.site;
                    if (object.client) trackObj.apps.search.context['SERP.client'] = object.client;
                    if (object.language) trackObj.apps.search.context['SERP.language'] = object.language;
                    if (object.filter.Area) trackObj.apps.search.context['SERP.filter.Area'] = object.filter.Area;
                    if (object.filter.Category) trackObj.apps.search.context['SERP.filter.Category'] = object.filter.Category;

                    tmp4 = scGetValOnce(object.ssid, 'SERP_ssid');
                    debug.log('value cookievalues:' + tmp4);
                    debug.log(object);
                    if (tmp4 !== '') trackObj.apps.search.events = hotplug.apl(trackObj.apps.search.events, 'firstQueryInSession'); // only the first search is been counted
                }
            }
            SCS.datalayer.track(trackObj);
            debug.log(object);
        })(object));
    }

    function noResultsFound(object) {
        window.SCS.tiq.trackingReadyCallbacks.push((function(object) {
            if (object.requester !== 'user' || object.origin === 'header') return;

            var trackObj = SCS.datalayer.cloneMandatoryData();
            trackObj.apps = trackObj.apps || {};
            trackObj.apps.search = {};
            trackObj.apps.search.context = {};
            trackObj.apps.search.events = [];

            trackObj.apps.search.events = ['noResults'];
            trackObj.apps.search.context['SERP'] = 'SERP_noresult';

            if (object.ssid) trackObj.apps.search.context['SERP.ssid'] = object.ssid;
            if (object.sessionSequence) trackObj.apps.search.context['SERP.sessionSequence'] = object.sessionSequence;
            if (object.origin) trackObj.apps.search.context['SERP.origin'] = object.origin;
            if (object.query) trackObj.apps.search.context['SERP.query'] = object.query;
            if (object.endpointURL) trackObj.apps.search.context['SERP.endpointURL'] = object.endpointURL;

            SCS.datalayer.track(trackObj);
            debug.log(object);
        })(object));
    }

    function automaticSpellingCor(object) {
        window.SCS.tiq.trackingReadyCallbacks.push((function(object) {
            var trackObj = SCS.datalayer.cloneMandatoryData();
            trackObj.apps = trackObj.apps || {};
            trackObj.apps.search = {};
            trackObj.apps.search.context = {};
            trackObj.apps.search.events = [];

            trackObj.apps.search.context['SERP'] = 'SERP_autoSpellingCorrection';
            if (object.ssid) trackObj.apps.search.context['SERP.ssid'] = object.ssid;
            if (object.sessionSequence) trackObj.apps.search.context['SERP.sessionSequence'] = object.sessionSequence;
            if (object.origin) trackObj.apps.search.context['SERP.origin'] = object.origin;
            if (object.endpointURL) trackObj.apps.search.context['SERP.endpointURL'] = object.endpointURL;
            if (object.previousQuery) trackObj.apps.search.context['SERP.autoCorrection.previousQuery'] = object.previousQuery;
            if (object.query) trackObj.apps.search.context['SERP.autoCorrection.newQuery'] = object.query;

            SCS.datalayer.track(trackObj);
            debug.log(object);
        })(object));
    }

    search.trackers.sc = {
        generalClick: resultlinktracking,
        searchQuery: querySearch,
        noResults: noResultsFound,
        automaticSpellingCorrection: automaticSpellingCor
    };
})
(window.SCS = window.SCS || {}, window.debug);

/***/ }),
/* 308 */
/***/ (function(module, exports) {

(function(SCS) {
	'use strict';

	// jshint maxparams: 10

	var search = SCS.search = SCS.search || {};
	var plugins = search.plugins = search.plugins || {};

	function baseSetup(urlPrefix, suffix, backendType, defaultConfig, customConfig) {
		urlPrefix = urlPrefix || '';
		// Create processor (use global backend)
		var processor = new search.Processor();

		var url = plugins.url;
		// Add URL handling
		url.setUp(
			processor,
			null,
			url.setBaseURL(urlPrefix, '/' + suffix, backendType),
			url.addDefaultConfig(
				defaultConfig,
				customConfig
			),
			url.transposeParams(url.transposeParams.GSA_MAP)
		);

		return processor;
	}

	function gsaSetup(urlPrefix, type, customConfig, sites) {
		var url = plugins.url;
		var gsa = plugins.gsa;

		var defaultConfig = url.addDefaultConfig['GSA_' + type.toUpperCase() + '_CONFIG'] || {};
		var processor = baseSetup(urlPrefix, type, 'gsa', defaultConfig,  customConfig);

		// Add GSA handling (use global session)
		gsa.setUp(processor, gsa.addFilterParams(), gsa.addSiteParams(sites));
		// Add Session handling (use global session)
		plugins.session.setUp(processor);

		return processor;
	}

	function webSetup(urlPrefix, customConfig) {
		var url = plugins.url;
		var gsa = plugins.gsa;
		var web = plugins.web;

		var processor = baseSetup(urlPrefix, 'web/', 'google', url.addDefaultConfig.DEFAULT_QUERY,  customConfig);

		// We use the paging from gsa plugin but not the whole set-up
		processor.usePre(gsa.handlePaging(), 50000);

		web.setUp(processor);

		return processor;
	}

	function forSerp(urlPrefix, site, client, language, customConfig) {
		customConfig = search.util.extend({}, {
			language: language,
			client: client,
			origin: 'serp'
		}, customConfig||{});
		var processor = gsaSetup(urlPrefix, 'search', customConfig, site);

		// Add spell-checking
		plugins.spellchecking.setUp(processor);
		// Add filtering
		plugins.filtering.setUp(processor);
		// Add tracking
		plugins.tracking.setUp(processor);

		return processor;
	}

	function forWebSearch(urlPrefix, language, customConfig) {
		customConfig = search.util.extend({}, {
			language: language,
			origin: 'serp'
		}, customConfig||{});
		var processor = webSetup(urlPrefix, customConfig);

		return processor;
	}

	function split(sites) {
		if(typeof sites === 'string') {
			return sites.split(/\|+/);
		}
		return sites || [];
	}

	function keymatchSetup(urlPrefix, site, client, keyMatchLimit, language, instantCollectionSuffix, customConfig) {
		site = split(site);
		instantCollectionSuffix = instantCollectionSuffix || '';
		for(var i=0;i<site.length;i+=1) {
			site[i] = site[i] + instantCollectionSuffix;
		}
		var config = search.util.extend({
			client: client,
			keyMatchLimit: keyMatchLimit||2,
			language: language,
			resultLimit: 0
		}, customConfig||{});

		return gsaSetup(urlPrefix, 'search', config, site);
	}

	function forKeymatches(urlPrefix, site, client, keyMatchLimit, language, instantCollectionSuffix, customConfig) {
		var processor = keymatchSetup(urlPrefix, site, client, keyMatchLimit, language, instantCollectionSuffix, customConfig);
		// On SERP, do redirect to webcodes
		plugins.keymatch.setUp(processor, null, null, plugins.keymatch.redirectToKeymatch());
		return processor;
	}

	function forAutosuggest(urlPrefix, site, client, suggestionLimit, keyMatchLimit, language, instantCollectionSuffix) {
		language = language || 'de';
		keyMatchLimit = parseInt(keyMatchLimit, 10);

		var processor = gsaSetup(urlPrefix, 'suggest', {
			language: language,
			suggestionLimit: suggestionLimit,
			origin: 'header',
			client: client,
			site: site
		});

		var keymatchProcessor;
		// Only load keymatches if explicitly configured with limit > 0
		if(keyMatchLimit) {
			keymatchProcessor = keymatchSetup(urlPrefix, site, client, keyMatchLimit, language, instantCollectionSuffix, {
				origin: 'header'
			});

			// Don’t redirect to webcodes
			plugins.keymatch.setUp(keymatchProcessor);
		}
		var keymatchRetriever = keymatchProcessor ? plugins.autosuggest.retrieveKeymatchesFromSuggestions(keymatchProcessor) : null;
		plugins.autosuggest.setUp(processor, keymatchRetriever);

		return processor;
	}

	function forClusterSuggestions(urlPrefix, site, client, language) {
		urlPrefix = urlPrefix || '';
		var processor = gsaSetup(urlPrefix, 'cluster', {
			language: language,
			method: 'POST',
			client: client
		}, site);
		return processor;
	}

	function forResultCount(urlPrefix, site, client, language) {
		var processor = gsaSetup(urlPrefix, 'search', {
			language: language,
			client: client,
			proxystylesheet: 'sc_v2_p_json_count',
			gsaFilter: 'duplicateSnippet'
		}, site);

		return processor;
	}

	var orchestration = search.orchestration = search.orchestration || {};

	orchestration.forSerp = forSerp;
	orchestration.forWebSearch = forWebSearch;
	orchestration.forKeymatches = forKeymatches;
	orchestration.forAutosuggest = forAutosuggest;
	orchestration.forClusterSuggestions = forClusterSuggestions;
	orchestration.forResultCount = forResultCount;

})(window.SCS = window.SCS || {});

/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_Tc_dot_$) {/*** IMPORTS FROM imports-loader ***/
var loadTerrific = __webpack_require__(1);
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function(Module, $, SCS) {
	'use strict';

	var KEYS = {
		ESCAPE: 27,
		DOWN: 40,
		UP: 38,
		ENTER: 13
	};
	var PROCESS_WAIT_TIMEOUT = 200;

	function stop(event) {
		event.preventDefault();
	}

	function getSelectedSuggestion(mod) {
		if(mod.selectedIndex in mod.suggestions) {
			return mod.suggestions[mod.selectedIndex];
		}
		return null;
	}

	// Click handler for a suggest item
	function activateSuggestion(mod, suggestion) {
		// Tracking
		Module.SearchResultContainer.trackClick('suggestion', mod.suggestConfig, suggestion, mod.searchProcessor);
		// Set the form value and let the submit handle the rest
		mod.$field.val(suggestion.name);
		mod.$form.submit();
	}

	function updateSelectedIndex(mod, index) {
		mod.selectedIndex = index;
		updateDom(mod);
	}

	function selectionChanged(mod, delta) {
		var newSelectedIndex = mod.selectedIndex + delta;
		if(newSelectedIndex < -1) {
			// On arrow-up, if nothing is selected, select the last item available
			newSelectedIndex = mod.suggestions.length + newSelectedIndex + 1;
		}
		if(newSelectedIndex >= mod.suggestions.length) {
			// On arrow-down at the last item, begin again with being unselected
			newSelectedIndex = -1;
		}
		updateSelectedIndex(mod, newSelectedIndex);
	}

	function updateDom(mod) {
		var selectedSuggestion = getSelectedSuggestion(mod);
		var results = mod.suggestions;
		var snabbdom = window.snabbdom;
		var h = snabbdom.h;
		var contents = [];
		for(var i=0;i<results.length;i+=1) {
			var result = results[i];
			contents.push(h(
				'li.scs-sitesearch-autosuggest-li',
				{
					'class': {
						'scs-sitesearch-searchfield-hoveractive': result === selectedSuggestion
					},
					on: {
						click: [activateSuggestion, mod, result],
						// Don’t let the mousedown trigger a blur of the input field (otherwise we don’t get a click)
						mousedown: stop
					}
				},
				result.name
			));
		}

		var suggestions = h('ul.suggestions', contents);
		mod.suggestResultContent = snabbdom.patch(mod.suggestResultContent, suggestions);
		mod.$instantResultContainer.toggleClass('has-results', !!results.length);

		if(selectedSuggestion) {
			mod.$field.val(selectedSuggestion.name);
		} else {
			mod.$field.val(mod.prevFieldVal);
		}
	}

	function suggestData(processor, data, config) {
		// jshint validthis: true
		this.selectedIndex = -1;
		this.suggestions = data.results || [];
		this.suggestConfig = config;
		updateDom(this);
	}

	function suggestError() {
		// jshint validthis: true
		this.selectedIndex = -1;
		this.suggestions = [];
		updateDom(this);
	}

	function setupSuggestions(mod, $field, $form) {
		var numberOfSuggestions = parseInt($field.attr('data-sitesearch-gsanumberofresults'), 10);
		if(!numberOfSuggestions) {
			return;
		}
		mod.$instantResultContainer = mod.$ctx.find('.scs-sitesearch-searchfield-autosuggest');
		if(!mod.$instantResultContainer.length) {
			return;
		}

		$field.attr('autocomplete', 'off');
		mod.$field = $field;
		mod.$form = $form;

		mod.searchProcessor = SCS.search.orchestration.forAutosuggest(
			$field.attr('data-sitesearch-gsahostname'),
			$field.attr('data-sitesearch-sites'),
			$field.attr('data-sitesearch-client'),
			$field.attr('gsanumberofresults'),
			0, // No keymatches
			$('html').attr('lang') || 'de'
		);
		mod.searchProcessor.responder(SCS.search.util.respondTo({
			'data': $.proxy(suggestData, mod),
			'error': $.proxy(suggestError, mod)
		}, mod));


		$field.on('keydown', function(event) {
			if(event.keyCode === KEYS.UP) {
				selectionChanged(mod, -1);
			} else if(event.keyCode === KEYS.DOWN) {
				selectionChanged(mod, +1);
			} else {
				return;
			}
			// Do not further process the key press:
			// * Do not trigger a new search
			// * Do not move the cursor the beginning or end when navigating suggestions or keymatches
			event.stopImmediatePropagation();
			return false;
		});
		var processKeyPressTimeout = null;

		$field.on('input keypress', function(event) {
			if(event.which === KEYS.ENTER) {
				// Selected suggestions already updated the field value with the suggestion
				// and normal searches can just trigger the regular form submit
				return;
			}
			var value = $field.val();
			if(value === mod.prevFieldVal) {
				return;
			}

			mod.prevFieldVal = value;

			clearTimeout(processKeyPressTimeout);
			processKeyPressTimeout = setTimeout(function() {
				processKeyPressTimeout = null;
				mod.searchProcessor.process({query: value});
			}, PROCESS_WAIT_TIMEOUT);
		});

		$field.on('focus', function() {
			mod.$instantResultContainer.addClass('focused');
		}).on('blur', function() {
			mod.$instantResultContainer.removeClass('focused');
		});

		mod.suggestResultContent = $('<ul/>').appendTo(mod.$instantResultContainer)[0];
	}

	// For the legacy header
	var HeaderSearchQueryForm = Module.extend({
		// The currently-selected suggestion
		selectedIndex: -1,
		// The list of suggestions
		suggestions: [],
		// The configuration for the suggest request
		suggestConfig: {},
		// The previous search value (before overwriting the search field with the text from the selected suggestion)
		prevFieldVal: '',

		on: function(callback) {
			callback();
		},

		after: function() {
			this.attachListeners();
		},

		attachListeners: function() {
			var $form = this.$ctx;
			var $field = $form.find('input[name="q"]');
			$form.on('submit', function(event) {
				event.preventDefault();
				var target = $form.attr('action');
				var pivot = '#'; // RESOLVE: Do we need to use query params at one point or is the hash always ok?
				var separator = target.indexOf(pivot) > -1 ? '&' : pivot;
				var query = {query: $field.val()};
				target = target + separator + SCS.search.util.param(query);
				window.location.href = target;
			});

			var $toggleIcon = $form.closest('.modMobileHeader').find('.scs-sitesearch-icon');
			$toggleIcon.click(function() {
				$toggleIcon.toggleClass('scs-sitesearch-active-icon');
				if($toggleIcon.hasClass('scs-sitesearch-active-icon')) {
					$form.slideDown('fast');
				} else {
					$form.slideUp('fast');
				}
			});

			// custom event fired by scsSiteSearch.Serp.init()
			$(document).on('scsSiteSearch-serp-query', function (event, q) {
				// we are on a search result page (SERP)

				$toggleIcon.removeClass('scs-sitesearch-active-icon').click();
				$field.val(q);
			});

			setupSuggestions(this, $field, $form);
		}
	});

	Module.HeaderSearchQueryForm = HeaderSearchQueryForm;

})(window.Tc.Module, __webpack_provided_window_dot_Tc_dot_$, window.SCS = window.SCS || {});

}.call(window));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_Tc_dot_$) {/*** IMPORTS FROM imports-loader ***/
var loadTerrific = __webpack_require__(1);
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function(Module, $, SCS) {
	'use strict';

	var OftenSearchedLinkBox = Module.extend({
		// The container module instance (for setting config changes and the like)
		searchContainer: null,

		on: function(callback) {
			callback();
		},

		after: function() {
			this.findElements();
		},

		initSearch: function(searchContainer) {
			this.searchContainer = searchContainer;
		},

		findElements: function() {
			var mod = this;
			mod.$links = this.$ctx.find('.scs-sitesearch-oftensearchedbox-list-item > a');
			mod.$links.each(function() {
				var $link = $(this);
				$link.click(function() {
					// Force the session to increase for the next request
					mod.searchContainer.sessionOptions.forceOnce = 'next';
					// Track clicks.
					Module.SearchResultContainer.trackClick(
						'often',
						{},
						{
							url: $link.prop('href'),
							query: $link.attr('data-sitesearch-query')
						},
						// We don’t have a search processor instance so just use the prototype as it has the same methods.
						SCS.search.Processor.prototype
					);
				});
			});
		}

	});

	Module.OftenSearchedLinkBox = OftenSearchedLinkBox;

})(window.Tc.Module, __webpack_provided_window_dot_Tc_dot_$, window.SCS = window.SCS || {});

}.call(window));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_Tc_dot_$) {/*** IMPORTS FROM imports-loader ***/
var loadTerrific = __webpack_require__(1);
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function(Module, $, SCS) {
	'use strict';

	var SearchClusterSuggestions = Module.extend({
		// The container module instance (for setting config changes and the like)
		searchContainer: null,
		// The search processor instance for getting the cluster suggestions
		searchProcessor: null,

		on: function(callback) {
			callback();
		},

		after: function() {
			this.findElements();
			this.attachListeners();
		},

		initSearch: function(searchContainer) {
			var mod = this;

			mod.searchContainer = searchContainer;

			var $config = mod.$ctx.closest('.search-configuration');
			if(!$config.length) {
				// Configuration on search field could also be outside
				$config = searchContainer.$config;
			}

			mod.searchProcessor = SCS.search.orchestration.forClusterSuggestions(
				$config.attr('data-sitesearch-gsahostname'),
				$config.attr('data-sitesearch-sites'),
				$config.attr('data-sitesearch-client'),
				$('html').attr('lang') || 'de'
			);
			mod.searchProcessor.responder(SCS.search.util.respondTo({
				data: mod.clusterData
			}, mod));
			mod.searchProcessor.responder(SCS.search.util.respondTo({
				data: searchContainer.stopLoading,
				error: searchContainer.stopLoading,
				abort: searchContainer.stopLoading
			}, searchContainer));
		},

		searchConfigChanged: function(searchConfig) {
			this.searchContainer.startLoading();
			this.searchProcessor.process(searchConfig);
		},

		clusterData: function(processor, data, config) {
			var clusters = data.clusters || [];
			clusters = clusters[0] || {};
			clusters = clusters.clusters || [];
			if(clusters.length < this.minSearchResults) {
				clusters = [];
			}
			clusters = clusters.slice(0, this.maxSearchResults);

			this.$ctx.toggleClass('active', !!clusters.length);
			this.$title.text(SCS.utils.formatString(
				this.titleFormat,
				config.query
			));

			var snabbdom = window.snabbdom;
			var h = snabbdom.h;

			var listSize = Math.ceil(this.maxSearchResults/2);
			var lists = [];
			while(clusters.length) {
				lists.push(this.renderList(clusters.splice(0, listSize), processor, config, h));
			}

			this.resultContainer = snabbdom.patch(this.resultContainer, h('div.scs-sitesearch-cluster-suggestions-results', lists));
		},

		renderList: function(clusters, processor, config, h) {
			var items = [];
			for(var i=0;i<clusters.length;i+=1) {
				var cluster = clusters[i];
				items.push(h(
					'li',
					[
						h(
							'a',
							{
								props: {
									href: '#'+SCS.search.util.param({q: cluster.label})
								},
								on: {
									click: [this.trackClick, cluster, processor, config]
								}
							},
							[cluster.label]
						)
					]
				));
			}
			return h(
				'ul',
				items
			);
		},

		trackClick: function(cluster, processor, config) {
			Module.SearchResultContainer.trackClick(
				'cluster',
				config,
				{
					previousQuery: config.query,
					query: cluster.label,
					url: document.location.href
				},
				processor
			);
		},

		findElements: function() {
			this.minSearchResults = Math.max(1, this.$ctx.data('minSearchResults') || 0);
			this.maxSearchResults = this.$ctx.data('maxSearchResults') || 8;
			this.titleFormat = this.$ctx.attr('data-title');
			this.$title = this.$ctx.find('div.title h3');
			this.resultContainer = this.$ctx.find('.scs-sitesearch-cluster-suggestions-results')[0];
		},

		attachListeners: function() {
		}

	});

	Module.SearchClusterSuggestions = SearchClusterSuggestions;

})(window.Tc.Module, __webpack_provided_window_dot_Tc_dot_$, window.SCS = window.SCS || {});

}.call(window));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_Tc_dot_$) {/*** IMPORTS FROM imports-loader ***/
var loadTerrific = __webpack_require__(1);
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function(Module, $, SCS) {
	'use strict';

	var SearchPreviewLink = Module.extend({
		// The container module instance (for setting config changes and the like)
		searchContainer: null,
		// The search processor instance for retrieving the result count
		searchProcessor: null,
		// The search config that was previosly used, for sending the correct click event
		previousConfig: null,

		on: function(callback) {
			callback();
		},

		after: function() {
			var mod = this;
			mod.contentsContainer = mod.$ctx.find('> .contents')[0];
			mod.translations = {
				titleFormat: mod.$ctx.attr('data-translation-title-format')
			};
			mod.linkTitle = mod.$ctx.attr('data-sitesearch-linkTitle');

			// Set the href (except the query)
			var redirectTarget = mod.$ctx.attr('data-sitesearch-redirectTarget');
			var useGetParam = mod.$ctx.data('sitesearchUsegetparam');
			var pivot = useGetParam ? '?' : '#';
			var separator = redirectTarget.indexOf(pivot) > -1 ? '&' : pivot;
			mod.url = redirectTarget + separator;

			mod.$title = mod.$ctx.find('.title-container');
			mod.$container = mod.$ctx.closest('.scs-sitesearch-link-list');

			mod.$ctx.on('click', function() {
				if(!mod.previousConfig) {
					return;
				}
				Module.SearchResultContainer.trackClick('search_other', mod.previousConfig, {
					url: mod.$ctx.prop('href')
				}, mod.searchProcessor);
			});
		},

		initSearch: function(searchContainer) {
			var mod = this;
			mod.searchContainer = searchContainer;
			mod.searchProcessor = SCS.search.orchestration.forResultCount(
				mod.$ctx.attr('data-sitesearch-gsahostname'),
				mod.$ctx.attr('data-sitesearch-sites'),
				mod.$ctx.attr('data-sitesearch-client'),
				$('html').attr('lang') || 'de'
			);
			mod.searchProcessor.responder(SCS.search.util.respondTo({
				data: mod.countReceived
			}, mod));
			mod.searchProcessor.responder(SCS.search.util.respondTo({
				data: searchContainer.stopLoading,
				error: searchContainer.stopLoading,
				abort: searchContainer.stopLoading
			}, searchContainer));
		},

		searchConfigChanged: function(searchConfig) {
			// Hide the container (every item will do this)
			this.$container.hide().removeClass('');
			this.process({query: searchConfig.query});
		},

		process: function(config) {
			this.searchContainer.startLoading();
			this.searchProcessor.process(config);
		},

		countReceived: function(processor, data, config) {
			this.previousConfig = config;
			this.$ctx.prop('href', this.url + SCS.search.util.param({q: config.query}));
			this.$title.text(
				SCS.utils.formatString(
					this.translations.titleFormat,
					this.linkTitle,
					data.resultCount
				)
			);
			if(data.resultCount > 0) {
				this.$ctx.show();
				// Show the container if at least one item had results
				this.$container.show();
			} else {
				this.$ctx.hide();
			}
		}

	});

	Module.SearchPreviewLink = SearchPreviewLink;

})(window.Tc.Module, __webpack_provided_window_dot_Tc_dot_$, window.SCS = window.SCS || {});

}.call(window));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var loadTerrific = __webpack_require__(1);
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function(Module) {
	'use strict';

	var SearchPromoBox = Module.extend({
		on: function(callback) {
			callback();
		},

		after: function() {
			this.findElements();
		},

		// Mark us a search-dependent module
		initSearch: function() {},

		findElements: function() {
			this.data = this.$ctx.data();
			this.$content = this.$ctx.children('div:eq(0)');
			this.id = this.$content.attr('id');
		},

		getAdConfig: function() {
			// FIXME: Implement hiding when keymatches are present (if this.data.hideIfKeymatches)
			return {
				container: this.id,
				number: this.data.sitesearchNumberOfAds,
				width: 'auto',
				lines: this.data.sitesearchNumberOfLines,
				fontFamily: 'Trebuchet MS',
				fontSizeTitle: 15,
				fontSizeDescription: 13,
				fontSizeDomainLink: 13,
				colorTitleLink: '#' + this.data.sitesearchColorTitleLink,
				colorText: '#' + this.data.sitesearchColorLink,
				colorDomainLink: '#' + this.data.sitesearchColorDomainLink,
				colorBackground: '#' + this.data.sitesearchColorBackground,
				noTitleUnderline: true
			};
		}
	});

	Module.SearchPromoBox = SearchPromoBox;

})(window.Tc.Module);

}.call(window));

/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_Tc_dot_$) {/*** IMPORTS FROM imports-loader ***/
var loadTerrific = __webpack_require__(1);
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function(Module, $) {
	'use strict';

	var SearchPromoContainer = Module.extend({
		on: function(callback) {
			callback();
		},

		after: function() {
			this.data = this.$ctx.data();
		},

		// Mark us a search-dependent module
		initSearch: function() {},

		searchConfigChanged: function(searchConfig, searchContainer) {
			if(!window.google || !window.google.ads || !window.google.ads.search || !window.google.ads.search.Ads) {
				return;
			}
			var promoBoxes = searchContainer.internalModulesByName('SearchPromoBox');
			var configs = [];
			$.each(promoBoxes, function(i, promoBox) {
				var config = promoBox.getAdConfig();
				if(config) {
					configs.push(config);
				}
			});
			if(!configs.length) {
				return;
			}
			var pageConfig = this.getPageConfig(searchConfig.query);
			try {
				window.google.ads.search.Ads(pageConfig, configs);
			} catch(e) {}
		},

		getPageConfig: function(query) {
			return {
        pubId: this.data.sitesearchSwisscomAdsenseID,
        query: query,
        hl: $('html').attr('lang') || 'de',
        adtest: 'off',
        siteLinks: false,
        oe: 'UTF-8',
        ie: 'UTF-8',
        domainLinkAboveDescription: false
			};
		}
	});

	Module.SearchPromoContainer = SearchPromoContainer;

})(window.Tc.Module, __webpack_provided_window_dot_Tc_dot_$);

}.call(window));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_Tc_dot_$) {/*** IMPORTS FROM imports-loader ***/
var loadTerrific = __webpack_require__(1);
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function(Module, $, SCS) {
	'use strict';

	var deparam = __webpack_require__(8).default;

	// Handles:
	//  • getting/setting query and filters
	//  • notifying search-related internal modules (SearchResultDisplay, SearchResultFilter, SearchResultClusterSuggestions, SearchResultQueryBox) of changed config (query/filters).
	//      Note: all of these need a class “searchInternal”.
	//  • communication with outside (NPE header search field, URL-Hash)
	var SearchResultContainer = Module.extend({
		// The current query
		query: null,
		// The current filters in the following form:
		// {
		// 		Area: '1_residential1_residential'
		// }
		filter: {},
		// Force the session to change (or remain) on the next request
		sessionOptions: null,
		// Keep track of search queries that were triggered by changed filters (relevant for tracking)
		fromFilterChange: false,
		// Array of all internal search modules that need be notified if the config changes
		internals: null,
		// How many result displays are currently loading
		loading: 0,

		on: function(callback) {
			if(this.debug) {
				window.searchResultContainer = this;
			}
			// Create a long-lasting options object
			this.sessionOptions = {};
			callback();
		},

		after: function() {
			var mod = this;
			mod.findElements();
			// Use a timeout to guarantee that the dependent modules’ “after” initializers have run
			window.setTimeout(function() {
				mod.queryFromHash();
			}, 0);
		},

		findElements: function() {
			var mod = this;
			this.internals = [];

			// Find the element where the search params are configured. Prefer the main modSearchResultDisplay accordion
			mod.$config = mod.$ctx.find('.modSearchResultDisplay.search-configuration');
			if(mod.$config.length !== 1) {
				// Find the config that is first in the DOM (from the search field)
				mod.$config = mod.$ctx.find('.search-configuration:eq(0)');
			}

			this.$ctx.find('.mod.searchInternal').each(function() {
				var modules = mod.sandbox.getModuleInstances(this);
				$.each(modules, function(i, module) {
					if('initSearch' in module) {
						mod.internals.push(module);
					}
				});
			});
			
			$.each(this.internals, function(i, module) {
				module.initSearch(mod);
			});
			
			$(window).on('hashchange', function() {
				mod.queryFromHash();
			});
		},

		currentConfig: function() {
			return {
				query: this.query,
				filter: this.filter,
				sessionOptions: this.sessionOptions,
				fromFilterChange: this.fromFilterChange
			};
		},

		internalModulesByName: function(modName) {
			var result = [];
			$.each(this.internals, function(i, module) {
				if(module.modName === modName) {
					result.push(module);
				}
			});
			return result;
		},

		configChanged: function(fromFilterChange) {
			var mod = this;

			mod.configUpdated();

			// Keep track of search queries that were triggered by changed filters
			mod.fromFilterChange = !!fromFilterChange;

			$.each(this.internals, function(i, module) {
				if('searchConfigChanged' in module) {
					module.searchConfigChanged(mod.currentConfig(), mod);
				}
			});
			
		},

		// Called when the search logic has changed the configuration but a new search should not immediately be triggered.
		configUpdated: function() {
			var mod = this;

			// fire custom event so header search fields can update themselves
			$(document).trigger('scsSiteSearch-serp-query', [mod.query, mod.filter]);

			$.each(this.internals, function(i, module) {
				if('searchConfigUpdated' in module) {
					module.searchConfigUpdated(mod.currentConfig(), mod);
				}
			});

			mod.updateHash();
		},

		updateHash: function() {
			var param = SCS.search.util.param;

			var params = {};
			if(this.query) {
				params.q = this.query;
			}
			// Paramizing empty objects yields the empty string.
			// When leaving the filter as an object, there would be no way to distinguish
			// between the explicit and the implicit case for no filters set.
			params.filter = param(this.filter);
			
			// TODO: if the query or filter wasn’t previously represented in the hash, use location.replace so that arrow navigation is still correct
			window.location.hash = '#' + param(params);
		},

		queryFromHash: function() {
			var hash = window.location.href;
			var index = hash.indexOf('#');
			if(index > -1) {
				hash = hash.substring(index + 1);
			} else {
				hash = '';
			}
			hash = deparam(hash);
			var changed = false;
			if(hash.q && hash.q !== this.query) {
				changed = true;
				this.query = hash.q;
			}
			if('filter' in hash && hash.filter !== SCS.search.util.param(this.filter)) {
				changed = true;
				this.filter = deparam(hash.filter);
			}
			if(changed) {
				this.configChanged();
			}
		},

		startLoading: function() {
			this.loading += 1;
			this.updateLoading();
		},

		stopLoading: function() {
			this.loading -= 1;
			this.updateLoading();
		},

		updateLoading: function() {
			var mod = this;

			if(mod.loading < 0) {
				mod.log.warn('Loading indicator counter below 0', mod.loading);
			}
			mod.$ctx.toggleClass('loading', mod.loading > 0);

			if(mod.loading === 0) {
				$.each(mod.internals, function(i, module) {
					if('searchProcessingDone' in module) {
						module.searchProcessingDone(mod.currentConfig(), mod);
					}
				});
			}
		}

	});

	SearchResultContainer.ellipsis = function ellipsis(elements) {
		elements.each(function () {
			var element = $(this),
				previousMaxHeight = this.style.maxHeight || 'none',
				previousHeight = this.style.height || 'auto',
				targetHeight = element.height(),
				lineHeight = parseInt(element.css('line-height'), 10),
				maxLines = Math.max( (targetHeight / lineHeight), 1),
				maxCutCharacters = 400,
				text = element.text();

			if (targetHeight > 0) {
				element.css({
					'max-height': 'none',
					'height': 'auto'
				});
				var currentLines = Math.round(element.height() / lineHeight);
				// jshint plusplus: false
				while (text.length > 0 && currentLines > maxLines && maxCutCharacters-- > 0) {
					text = text.substr(0, text.length - 1);
					element.text(text + '\u2026');
					currentLines = Math.round(element.height() / lineHeight);
				}

				element.css({
					'max-height': previousMaxHeight,
					'height': previousHeight
				});
			}
		});
	};

	// Strips HTML (from safe sources like the GSA), flattens tags and unescapes entities
	SearchResultContainer.unsafelyStripHTML = function(html) {
		return $('<div/>').html(html).text();
	};

	// Make the hightlights in the snippets survive the HTML stripping (as snabbdom VDom elements)
	SearchResultContainer.snippetToVDomElements = function(html, h) {
		html = html.split(/<\/?b>/g);
		return $.map(html, function(text, i) {
			text = SearchResultContainer.unsafelyStripHTML(text);
			var plain = i%2 === 0;
			if(plain) {
				return text;
			}
			return h('em.highlight', [text]);
		});
	};

	// Prepares a data object for click tracking, sends it off to the processor
	SearchResultContainer.trackClick = function(cType, config, item, processor) {
		var data = SCS.search.util.extend({}, config, item, {
			ctype: cType || 'c',
			start: config.offset,
			href: item.url || item.link
		});
		processor.track('generalClick', data);
	};



	Module.SearchResultContainer = SearchResultContainer;

})(window.Tc.Module, __webpack_provided_window_dot_Tc_dot_$, window.SCS = window.SCS || {});

}.call(window));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_Tc_dot_$) {/*** IMPORTS FROM imports-loader ***/
var loadTerrific = __webpack_require__(1);
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function(Module, $, SCS) {
	'use strict';

	var MIME_SUFFIXES = {
		'application/pdf': 'PDF',
		'application/msword': 'DOC',
		'application/excel': 'XLS',
		'application/vnd.ms-excel': 'XLS',
		'application/x-excel': 'XLS',
		'application/x-msexcel': 'XLS',
		'application/mspowerpoint': 'PPT',
		'application/powerpoint': 'PPT',
		'application/vnd.ms-powerpoint': 'PPT',
		'application/x-mspowerpoint': 'PPT',
		'text/plain': 'TXT',
		'application/rtf': 'RTF',
		'application/x-rtf': 'RTF',
		'text/richtext': 'RTF',
		'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'DOCX',
		'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'XLSX',
		'application/vnd.openxmlformats-officedocument.presentationml.presentation': 'PPTX'
	};

	var STAR = '★';

	// Normalizes URLs from search results for the purposes of de-duplication:
	// • Remove selectors
	// • Remove query params and hash params
	// • Remove product specifiers for family pages
	function normalizeURL(url) {
		var index;

		index = url.indexOf('#');
		if(index > -1) {
			url = url.substring(0, index);
		}
		index = url.indexOf('?');
		if(index > -1) {
			url = url.substring(0, index);
		}
		url = url.split('/');

		var lastPart = url.pop();
		// Remove product family item specifier (e.g. `(N_NATEL RES 2.0 XL,24,000000000010247106)`)
		lastPart = lastPart.replace(/\([^()]+\)/, '');
		// Remove selectors
		lastPart = lastPart.split('.');
		var extension = lastPart.pop();
		lastPart = lastPart.slice(0, 1);
		lastPart.push(extension);
		url.push(lastPart.join('.'));

		return url.join('/');
	}

	var SearchResultDisplay = Module.extend({
		// The container module instance (for setting config changes and the like)
		searchContainer: null,
		// The search processor instance for this specific search result accordion with its GSA sites and client
		searchProcessor: null,
		// The current page we’re on
		pageNumber: 0,
		// The previous results
		prevResults: [],
		// Mapping from categoru names to iconfont characters
		iconMap: null,
		// If this is the only SearchResultDisplay in the current SearchResultContainer
		isSingle: false,
		// The SearchResultTitle component to display titles in (if isSingle is true)
		titleModule: null,
		// The last-recently loaded data
		currentData: {},
		// The last-recently loaded config
		currentConfig: {},
		// URLs of all last-recently loaded keymatches (for deduplication)
		currentDisplayedKeymatchURLs: {},
		// The element the search config is on
		$config: null,
		// Display the search results with images and ratings 
		enhancedResults: false,
		// True when findelements got called before
		foundElements : false,

		on: function(callback) {
			callback();
		},

		after: function() {
			this.findElements();
			this.attachListeners();

			var $accordionTitle = this.$ctx.find('.scs-sitesearch-accordion-title');
			if(!$accordionTitle.text().trim()) {
				$accordionTitle.hide();
			}			
		},

		initSearch: function(searchContainer) {
			var mod = this;
		
			this.findElements();
			mod.searchContainer = searchContainer;

			// Do communication
			var siblings = searchContainer.internalModulesByName('SearchResultDisplay');

			mod.isSingle = siblings.length === 1 && siblings[0] === mod;
			if(mod.isSingle) {
				mod.titleModule = searchContainer.internalModulesByName('SearchResultTitle')[0];
			}

			if(mod.isSingle && mod.enhancedResults) {
				searchContainer.$ctx.addClass('scs-sitesearch-enhanced-results');
			}

			mod.$config = mod.$ctx.closest('.search-configuration');
			if(!mod.$config.length) {
				// Configuration on search field could also be outside
				mod.$config = searchContainer.$config;
			}

			mod.initSearchProcessor();
		},

		searchConfigChanged: function(searchConfig) {
			this.pageNumber = 0;
			this.process(searchConfig);
		},

		process: function(config) {
			config.page = this.pageNumber;
			this.searchContainer.startLoading();
			this.searchProcessor.process(config);
		},

		findElements: function() {
			// only do that once
			if(this.foundElements) {
				return;
			}
			this.foundElements = true;
			this.resultContainer = this.$ctx.find('.scs-sitesearch-accordion-content-first-results')[0];
			this.additionalResultsContainer = this.$ctx.find('.scs-sitesearch-accordion-content-more-results')[0];
			this.$titleContainer = this.$ctx.find('.title-container');
			this.title = this.$titleContainer.text();
			this.titleFormat = this.$ctx.attr('data-sitesearch-title-format');
			this.enhancedResults = this.$ctx.data('sitesearch-enable-enhanced-results');

			this.iconMap = {};
			try {
				var icons = this.$ctx.attr('data-sitesearch-category-icons');
				if(icons) {
					this.iconMap = window.JSON.parse(icons);
				}
			} catch(e) {}

			var $textContainer = this.$ctx.closest('.scs-sitesearch-accordion-box');
			this.translations = $textContainer.data();
		},

		initSearchProcessor: function() {
			var mod = this;
			var defaults = {};
			var resultLimit = parseInt(mod.$ctx.attr('data-sitesearch-shownResults'), 10);
			if(!isNaN(resultLimit)) {
				defaults.resultLimit = resultLimit;
			}
			mod.searchProcessor = mod.createSearchProcessor(defaults);
			mod.searchProcessor.responder(SCS.search.util.respondTo({
				data: mod.searchData
			}, mod));
			mod.searchProcessor.responder(SCS.search.util.respondTo({
				data: mod.searchContainer.stopLoading,
				error: mod.searchContainer.stopLoading,
				abort: mod.searchContainer.stopLoading
			}, mod.searchContainer));
		},

		createSearchProcessor: function(defaults) {
			return SCS.search.orchestration.forSerp(
				this.$config.attr('data-sitesearch-gsahostname'),
				this.$config.attr('data-sitesearch-sites'),
				this.$config.attr('data-sitesearch-client'),
				$('html').attr('lang') || 'de',
				defaults
			);
		},

		// Got search data
		searchData: function(processor, data, config) {
			var mod = this;

			// Update the query and filter if they changed (when auto-unfiltering)
			mod.searchContainer.query = config.query;
			mod.searchContainer.filter = config.filter;
			mod.searchContainer.configUpdated();

			mod.currentConfig = config;

			// Update the title
			if(mod.titleModule) {
				mod.titleModule.searchDataAvailable(processor, data, config);
			}

			// Update resultDisplay
			mod.dataUpdated(data);
		},

		dataUpdated: function(data, displayedKeymatchURLs) {
			if(data) {
				this.currentData = data;
			}
			if(displayedKeymatchURLs) {
				this.currentDisplayedKeymatchURLs = displayedKeymatchURLs;
			}

			this.display();
		},

		attachListeners: function() {
			var mod = this;
			// Legacy accordion handling
			if(mod.$ctx.is('.scs-sitesearch-accordion-closed, .scs-sitesearch-accordion-opened')) {
				mod.$ctx.find('.scs-sitesearch-accordion-title').on('click', function() {
					mod.$ctx.toggleClass('scs-sitesearch-accordion-closed').toggleClass('scs-sitesearch-accordion-opened');
				});
			}
		},

		display: function() {
			var mod = this;

			var data = mod.currentData;
			var config = mod.currentConfig;

			var results = data.results || data.items || [];
			if(config.page > 0) {
				results = mod.prevResults.concat(results);
			}
			mod.prevResults = results;

			var snabbdom = window.snabbdom;
			var h = snabbdom.h;
			var SearchResultContainer = Module.SearchResultContainer;

			// Result container is initially hidden (before the first search was performed)
			mod.$ctx.removeClass('hidden');

			var resultCount = data.resultCount || 0;

			mod.$titleContainer.text(SCS.utils.formatString(
				mod.titleFormat,
				config.query,
				resultCount,
				mod.title
			));

			var content;
			var hasResults = resultCount > 0;
			mod.$ctx.toggleClass('scs-sitesearch-has-results', hasResults).toggleClass('has-results', hasResults).toggleClass('scs-sitesearch-no-results', !hasResults);

			if(hasResults) {
				content = mod.renderResults(results, config, h, SearchResultContainer);
			} else {
				content = mod.renderNoResultsMessage(config.query, h);
			}
			mod.resultContainer = snabbdom.patch(mod.resultContainer, h('div.scs-sitesearch-accordion-content-first-results', content));

			mod.renderPaging(data, config, resultCount, results, snabbdom, SearchResultContainer);
		},

		renderResults: function(results, config, h, SearchResultContainer) {
			var mod = this;

			// Start with spellcheck messages (if any)
			var result = mod.renderSpellcheckMessage(config, h, SearchResultContainer);

			for(var i=0;i<results.length;i+=1) {
				var item = mod.renderItem(results[i], config, h, SearchResultContainer);
				if(item) {
					result.push(item);
				}
			}
			return result;
		},

		renderSpellcheckMessage: function(config, h, SearchResultContainer) {
			var mod = this;

			var messages = [];

			if(mod.titleModule) {
				// Let the title module render these messages
				return messages;
			}

			if(config.autoCorrectedFrom) {
				messages.push(h('div.scs-sitesearch-misspelled-link', [SCS.utils.formatString(
					mod.translations.sitesearchNoresultsformisspelled,
					config.autoCorrectedFrom
				)]));
			}

			if(config.manualCorrectionSuggestion) {
				var newQuery = config.manualCorrectionSuggestion;
				messages.push(h(
					'a.scs-sitesearch-misspelled-link',
					{
						props: {
							href: window.location.pathname + '#q=' + encodeURIComponent(newQuery)
						},
						on: {
							click: function(event) {
								SearchResultContainer.trackClick('spell', config, {query: newQuery, previousQuery: config.query}, mod.searchProcessor);
								event.preventDefault();
								if(mod.isSingle) {
									// Update the whole container if we are the only module displaying search results
									mod.searchContainer.query = newQuery;
									mod.searchContainer.configChanged();
								} else {
									// Otherwise, only update this result display module
									mod.pageNumber = 0;
									mod.process(SCS.search.util.extend({}, config.inputConfig, {query: newQuery}));
								}
							}
						}
					},
					[SCS.utils.formatString(
						mod.translations.sitesearchDidyoumean,
						newQuery
					)]
				));
			}

			return messages;
		},

		renderItem: function(result, config, h, SearchResultContainer) {
			var mod = this;

			var displayedKeymatchURLs = mod.currentDisplayedKeymatchURLs;
			var url = result.url || result.link || '#';
			// Deduplicate search results that already appear as keymatches
			if(normalizeURL(url) in displayedKeymatchURLs) {
				return null;
			}

			var isEnhanced = mod.enhancedResults;
			var title = 'htmlTitle' in result ? result.title : SearchResultContainer.unsafelyStripHTML(result.title);
			var mime = String(result.mimeType || '').toLowerCase();
			if(mime in MIME_SUFFIXES) {
				title += ' ['+MIME_SUFFIXES[result.mimeType]+']';
			}
			var content = [
				h(
					'a.scs-sitesearch-accordion-searchlink',
					{
						props: {
							href: url
						},
						on: {
							click: function() {
								// Track click
								SearchResultContainer.trackClick('c', config, result, mod.searchProcessor);
							}
						}
					},
					title
				),
				h(
					'div',
					SearchResultContainer.snippetToVDomElements(result.htmlSnippet || result.snippet, h)
				)
			];
			if(isEnhanced) {
				var reviews = mod.renderReviews(result, h);
				if(reviews) {
					content.push(reviews);
				}

				// Wrap enhanced results in a group
				content = h('div.scs-result-item-content', content);
				var icon = mod.getIcon(result);
				if(icon && icon.src) {
					icon = h('img', {props: {src: icon.src}});
				} else if(icon && icon.icon && icon.icon in mod.iconMap) {
					icon = h('span.iconfont.glyph', [mod.iconMap[icon.icon]]);
				} else {
					icon = null;
				}
				if(icon) {
					// Prepend icon to group
					content = [h('div.scs-result-item-icon', [icon]), content];
				} else {
					content = [content];
				}
			}
			return h(
				'div.scs-result-item',
				content
			);
		},

		renderReviews: function(result, h) {
			if(!result.meta) {
				return;
			}
			// FIXME NEC: Is there a spec for this? Rating seems to be an integer [10..50]
			var rating = Math.max(0, Math.min(5, parseFloat(result.meta.ratingValue) / 10));
			var count = parseInt(result.meta.ratingCount, 10);
			if(!rating || !count) {
				return;
			}

			var fullStars = Math.floor(rating);
			var halfStar = rating - fullStars;
			var emptyStars = 5 - fullStars - Math.ceil(halfStar);

			var stars = [], i;

			for(i=0;i<fullStars;i+=1) {
				stars.push(h('div.star.iconfont.glyph', [STAR]));
			}
			if(halfStar) {
				stars.push(h(
					'div.star.gray.iconfont.glyph',
					[
						STAR,
						h(
							'div.star.halfFilled.iconfont.glyph',
							{
								style:
								{
									width: (18*halfStar)+'px'
									// FIXME: Test with em and get rid of magic 18px = 100%
									// width: halfStar+'em'
								}
							},
							[STAR]
						)
					]
				));
			}
			for(i=0;i<emptyStars;i+=1) {
				stars.push(h('div.star.gray.iconfont.glyph', [STAR]));
			}

			return h(
				'div.scs-result-item-review',
				[
					h(
						'div.scs-result-item-review-stars',
						stars
					),
					h(
						'div.starstext',
						[SCS.utils.formatString(
							this.translations.sitesearchRatingsTitle,
							count
						)]
					)
				]
			);
		},

		renderNoResultsMessage: function(query, h) {
			if(this.titleModule) {
				// Let the title module render these messages
				return [];
			}
			return [
				h('span.scs-noresults-icon'),
				h('span.scs-sitesearch-no-results-content', [SCS.utils.formatString(
					this.translations.sitesearchNoresultsglobal,
					query,
					this.title
				)])
			];
		},

		renderPaging: function(data, config, resultCount, results, snabbdom, SearchResultContainer) {
			var mod = this;
			var h = snabbdom.h;
			// Add more results button and info
			var remaining = resultCount - (config.offset + results.length);

			var pagingControls = [];

			if(remaining > 0) {
				var nextPageStart = config.offset + config.resultLimit + 1;
				var nextPageEnd = Math.min(nextPageStart + config.resultLimit - 1, resultCount);
				pagingControls = [
					h(
						'div.scs-sitesearch-moreresults.secondary-button.button-secondary',
						{
							on: {
								click: function() {
									// Track click
									SearchResultContainer.trackClick('nav.next', config, {url: document.location.href, page: config.page + 1, previousPage: config.page}, mod.searchProcessor);
									// Load next page
									mod.pageNumber = config.page + 1;
									mod.process(SCS.search.util.extend({}, config.inputConfig));
								}
							}
						},
						[mod.translations.sitesearchMorebuttontext]
					),
					h(
						'div.scs-sitesearch-moreresults-info',
						[
							SCS.utils.formatString(
								mod.translations.sitesearchMorebuttontextInfo,
								nextPageStart,
								nextPageEnd,
								resultCount
							)
						]
					),
					h('hr')
				];
			}

			mod.additionalResultsContainer = snabbdom.patch(mod.additionalResultsContainer, h('div.scs-sitesearch-accordion-content-more-results', pagingControls));
		},

		getIcon: function(result) {
			// jshint camelcase: false
			var meta = result.meta;
			if(!meta) {
				return;
			}
			if(meta.thumbnail) {
				return {src: result.meta.thumbnail};
			} else if(meta.gsaentity_GSA_Category) {
				return {icon: meta.gsaentity_GSA_Category};
			}
		}

	});

	SearchResultDisplay.normalizeURL = normalizeURL;

	Module.SearchResultDisplay = SearchResultDisplay;

})(window.Tc.Module, __webpack_provided_window_dot_Tc_dot_$, window.SCS = window.SCS || {});

}.call(window));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_Tc_dot_$) {/*** IMPORTS FROM imports-loader ***/
var loadTerrific = __webpack_require__(1);
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function(Module, $, SCS) {
	'use strict';

	// Skin for what used to be called a Web-Accordion
	Module.SearchResultDisplay.Web = function(parent) {

		this.createSearchProcessor = function(defaults) {
			return SCS.search.orchestration.forWebSearch(
				this.$ctx.attr('data-sitesearch-gsahostname'),
				$('html').attr('lang') || 'de',
				defaults
			);
		};

		this.getIcon = function(result) {
			// jshint camelcase: false
			if(result.pagemap && result.pagemap.cse_thumbnail && result.pagemap.cse_thumbnail[0]) {
				return {src: result.pagemap.cse_thumbnail[0].src};
			}
		};

	};

})(window.Tc.Module, __webpack_provided_window_dot_Tc_dot_$, window.SCS = window.SCS || {});

}.call(window));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_Tc_dot_$) {/*** IMPORTS FROM imports-loader ***/
var loadTerrific = __webpack_require__(1);
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function(Module, $, SCS) {
	'use strict';

	var FILTER_VALUE_UNSELECTED = '0_no_filter';

	var SearchResultFilter = Module.extend({
		// The container module instance (for setting config changes and the like)
		searchContainer: null,
		// The search processor instance (for counting results in filters)
		searchProcessors: null,
		// Available fitlers
		filters: null,

		on: function(callback) {
			callback();
		},

		after: function() {},

		initSearch: function(searchContainer) {
			this.searchContainer = searchContainer;

			this.findElements();
			this.attachListeners();

			// Don’t trigger a search, just set the initial filter
			searchContainer.filter = this.currentFilter();
		},

		searchConfigUpdated: function(searchConfig) {
			var mod = this;

			mod.$filterContainer.addClass('active');
			mod.$title.removeClass('hidden');

			// jshint forin: false
			var filter = searchConfig.filter || {};
			for(var filterName in mod.filters) {
				var filterConfig = mod.filters[filterName];
				var filterValueConfig = null;

				// Search the selected filter. If not found, assume no filter was to be used.
				if(filterName in filter && filter[filterName] in filterConfig) {
					filterValueConfig = filterConfig[filter[filterName]];
				} else {
					filterValueConfig = filterConfig[FILTER_VALUE_UNSELECTED] || filterConfig[''];
				}
				if(filterValueConfig) {
					// Update the filter DOM
					mod.activateFilter(null, filterValueConfig);
				}

				// Trigger queries for the result counts
				var filterExceptCurrent = SCS.search.util.extend({}, filter);
				if(filterName in filterExceptCurrent) {
					delete filterExceptCurrent[filterName];
				}
				var configForSubquery = SCS.search.util.extend({}, searchConfig, {filter: filterExceptCurrent});
				mod.searchProcessors[filterName].process(configForSubquery);
			}
		},

		findElements: function() {
			var mod = this;

			mod.$filterContainer = mod.$ctx.find('.scs-sitesearch-searchfilter');
			mod.$title = mod.$ctx.find('.scs-sitesearchfilter-title');

			var $config = mod.$ctx.closest('.search-configuration');
			if(!$config.length) {
				// Configuration on search field could also be outside
				$config = mod.searchContainer.$config;
			}

			var filters = mod.filters = {};
			var searchProcessors = mod.searchProcessors = {};

			var $filters = mod.$filterContainer.find('.scs-sitesearch-filter-menu');
			$filters.each(function() {
				var $filter = $(this);

				var filter = $filter.attr('data-gsa-filter');

				var filterConfig = filters[filter] = {};
				var $filterValues = $filter.find('.scs-sitesearch-filter-menu-item');

				// Initialize the search processor that count how many times the current search term appears in the filter values
				searchProcessors[filter] = mod.initSearchProcessor($config, filter);

				$filterValues.each(function() {
					var $filterValue = $(this);
					var filterValue = $filterValue.attr('data-gsa-filter-value');
					if(!filterValue || filterValue === FILTER_VALUE_UNSELECTED) {
						// Always show the “Show All” filter
						$filterValue.addClass('is-reset-button');
					}
					filterConfig[filterValue] = {
						$filter: $filter,
						$filterValue: $filterValue,
						$otherFilterValues: $filterValues.not($filterValue),
						filter: filter,
						filterValue: filterValue
					};
				});
			});

			// Add mobile-only toggle element
			var $toggler = mod.$ctx.find('.scs-sitesearch-searchfilter-mobile-button');
			if($toggler.length) {
				$toggler.click(function() {
					mod.$filterContainer.toggle();
					$toggler.toggleClass('active');
				});
				mod.$filterContainer.hide();
			}
		},

		// Initialize processors that count the unfiltered queries for us
		initSearchProcessor: function($config, filter) {
			var mod = this;

			var defaults = {
				requester: 'logic'
			};
			// Use the same config as for the search itself so the queries can be consolidated by deduplicatedBackend
			var resultLimit = parseInt($config.attr('data-sitesearch-shownResults'), 10);
			if(!isNaN(resultLimit)) {
				defaults.resultLimit = resultLimit;
			}
			var processor = SCS.search.orchestration.forSerp(
				$config.attr('data-sitesearch-gsahostname'),
				$config.attr('data-sitesearch-sites'),
				$config.attr('data-sitesearch-client'),
				$('html').attr('lang') || 'de',
				defaults
			);
			processor.responder(SCS.search.util.respondTo({
				data: $.proxy(mod.updateFilterCounts, mod, filter)
			}, mod));

			return processor;
		},

		updateFilterCounts: function(filter, processor, data, config) {
			var facets = config.facets || {};

			var facet = (facets[filter] || {}).values || {};
			var filterConfig = this.filters[filter];
			for(var filterValue in filterConfig) {
				// jshint forin: false
				var filterValueConfig = filterConfig[filterValue];
				if(filterValue in facet) {
					filterValueConfig.$filterValue.attr('data-result-count', facet[filterValue].count);
				} else {
					filterValueConfig.$filterValue.attr('data-result-count', 0);
				}
			}
		},

		attachListeners: function() {
			var mod = this;

			// jshint forin: false
			for(var filter in mod.filters) {
				var filterConfig = mod.filters[filter];
				for(var filterValue in filterConfig) {
					var filterValueConfig = filterConfig[filterValue];
					filterValueConfig.$filterValue.click(filterValueConfig, $.proxy(mod.activateFilter, mod));
				}
			}
		},

		activateFilter: function(event, filterValueConfig) {
			filterValueConfig = filterValueConfig || event.data;
			var $filterValue = filterValueConfig.$filterValue;
			if($filterValue.is('.active')) {
				// Filter already active, do nothing
				return;
			}
			if(event) {
				event.preventDefault();
			}

			filterValueConfig.$otherFilterValues.removeClass('active');
			filterValueConfig.$filterValue.addClass('active');

			if(event) {
				var previousFilter = this.searchContainer.currentConfig().filter;

				// Change came from a click event, not to just update filter display
				this.searchContainer.filter = this.currentFilter();
				this.searchContainer.configChanged(true);

				Module.SearchResultContainer.trackClick(
					'dynnav.'+filterValueConfig.filter+'.'+filterValueConfig.filterValue,
					this.searchContainer.currentConfig(),
					{
						previousFilter: previousFilter,
						filterName: filterValueConfig.filter,
						filterValue: filterValueConfig.filter,
						url: document.location.href
					},
					this.searchProcessors[filterValueConfig.filter]
				);
			}
		},

		// Calculates the current filter (as applicatble for Tc.Module.SearchResultContainer) from the current DOM state
		currentFilter: function() {
			var mod = this;

			var currentFilter = {};

			// jshint forin: false
			for(var filter in mod.filters) {
				var filterConfig = mod.filters[filter];
				for(var filterValue in filterConfig) {
					var filterValueConfig = filterConfig[filterValue];
					if(!filterValueConfig.$filterValue.is('.active')) {
						// Find next 
						continue;
					}
					if(filterValueConfig.filterValue && filterValueConfig.filterValue !== FILTER_VALUE_UNSELECTED) {
						// This sets the filter properties
						currentFilter[filter] = filterValueConfig.filterValue;
					}
					break;
				}
			}

			return currentFilter;
		},

		getFilterTitles: function() {
			var result = {};

			// jshint forin: false
			for(var filter in this.filters) {
				var filterConfig = this.filters[filter];
				result[filter] = {};
				for(var filterValue in filterConfig) {
					var filterValueConfig = filterConfig[filterValue];
					result[filter][filterValue] = $.trim(filterValueConfig.$filterValue.text());
				}
			}

			return result;
		}

	});

	Module.SearchResultFilter = SearchResultFilter;

})(window.Tc.Module, __webpack_provided_window_dot_Tc_dot_$, window.SCS = window.SCS || {});

}.call(window));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_Tc_dot_$) {/*** IMPORTS FROM imports-loader ***/
var loadTerrific = __webpack_require__(1);
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function(Module, $, SCS) {
	'use strict';

	var SearchResultQueryBox = Module.extend({
		// The container module instance (for setting config changes and the like)
		searchContainer: null,
		// The search processor instance for autosuggest and keymatches
		// FIXME: Implement (or remove)
		searchProcessor: null,

		on: function(callback) {
			callback();
		},

		after: function() {
			this.findElements();
			this.attachListeners();
		},

		initSearch: function(searchContainer) {
			this.searchContainer = searchContainer;
		},

		searchConfigUpdated: function(searchConfig) {
			this.$field.val(searchConfig.query);
		},

		findElements: function() {
			this.$field = this.$ctx.find('.scs-sitesearch-searchfield-input');
		},

		attachListeners: function() {
			var mod = this;
			mod.$ctx.on('submit', function(event) {
				event.preventDefault();
				var query = mod.$field.val();
				mod.searchContainer.query = query;
				mod.searchContainer.configChanged();
			});
		}

	});

	Module.SearchResultQueryBox = SearchResultQueryBox;

})(window.Tc.Module, __webpack_provided_window_dot_Tc_dot_$, window.SCS = window.SCS || {});

}.call(window));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_Tc_dot_$) {/*** IMPORTS FROM imports-loader ***/
var loadTerrific = __webpack_require__(1);
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function(Module, $, SCS) {
	'use strict';

	var SearchResultTitle = Module.extend({
		// The container module instance (for setting config changes and the like)
		searchContainer: null,
		// The human-readable names of the filter options
		filterTitles: {},

		on: function(callback) {
			callback();
		},

		after: function() {
			this.findElements();
		},

		initSearch: function(searchContainer) {
			this.searchContainer = searchContainer;

		},

		searchConfigChanged: function() {
			this.$ctx.removeClass('active');
		},

		searchDataAvailable: function(processor, data, config) {
			var mod = this;
			var SearchResultContainer = Module.SearchResultContainer;
			var snabbdom = window.snabbdom;
			var h = snabbdom.h;

			mod.$ctx.addClass('active');

			// Fill in title
			var title = [];
			var resultCount = data.resultCount || 0;
			if(resultCount < 1) {
				title = [
					h('span.scs-noresults-icon'),
					h('span.scs-sitesearch-no-results-content', [SCS.utils.formatString(mod.translations.resultTitleTextNoresults, config.query)])
				];
			} else {
				var translationKey = 'resultTitleText' + (resultCount === 1 ? 'S' : 'P');
				var filterTitles = [];
				for(var filterArea in config.filter) {
					var filterValue = config.filter[filterArea];
					// jshint forin: false
					var titles = mod.filterTitles[filterArea] || {};
					filterTitles.push(titles[filterValue] || filterValue);
				}
				if(!filterTitles.length) {
					translationKey = translationKey + 'NoFilter';
				}
				var suffix = '';
				if(config.previousFilter) {
					suffix = mod.translations.resultTitleTextWithoutFilter;
				}
				var text = mod.translations[translationKey];
				title.push(SCS.utils.formatString(
					text,
					resultCount,
					config.query,
					filterTitles.join(', '),
					suffix
				));
			}
			mod.title = snabbdom.patch(mod.title, h('div.scs-sitesearch-result-title-count.active', title));

			// Handle autocorrection
			var misspelled = [];
			if(config.autoCorrectedFrom) {
				misspelled.push(SCS.utils.formatString(
					mod.translations.resultTitleTextNoresultsForMisspelled,
					config.autoCorrectedFrom
				));
			}
			mod.misspelled = snabbdom.patch(mod.misspelled, h('div.scs-sitesearch-result-title-misspelled', {
				'class': {
					active: !!config.autoCorrectedFrom
				}
			}, misspelled));

			// Handle manual correction
			var suggestion = [];
			if(config.manualCorrectionSuggestion) {
				var newQuery = config.manualCorrectionSuggestion;
				// Don’t use format here because we want to replace the placeholder with a DOM element
				var contents = this.translations.resultTitleTextDidYouMean.split('{0}');
				contents.splice(1, 0, h(
					'span',
					[newQuery]
				));
				suggestion.push(h(
					'a.scs-sitesearch-misspelled-link',
					{
						props: {
							href: '#'+SCS.search.util.param({q: newQuery})
						},
						on: {
							click: function(event) {
								event.preventDefault();
								SearchResultContainer.trackClick('spell', config, {query: newQuery, previousQuery: config.query}, processor);
								mod.searchContainer.query = newQuery;
								mod.searchContainer.configChanged();
							}
						}
					},
					contents
				));
			}
			this.suggestion = snabbdom.patch(this.suggestion, h('div.scs-sitesearch-result-title-suggestion', {
				'class': {
					active: !!config.manualCorrectionSuggestion
				}
			}, suggestion));
		},

		findElements: function() {
			this.translations = this.$ctx.data();

			this.title = this.$ctx.find('.scs-sitesearch-result-title-count')[0];
			this.misspelled = this.$ctx.find('.scs-sitesearch-result-title-misspelled')[0];
			this.suggestion = this.$ctx.find('.scs-sitesearch-result-title-suggestion')[0];

			var filterModule = this.searchContainer.internalModulesByName('SearchResultFilter')[0];
			if(filterModule) {
				this.filterTitles = filterModule.getFilterTitles();
			}
		}

	});

	Module.SearchResultTitle = SearchResultTitle;

})(window.Tc.Module, __webpack_provided_window_dot_Tc_dot_$, window.SCS = window.SCS || {});

}.call(window));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_Tc_dot_$) {/*** IMPORTS FROM imports-loader ***/
var loadTerrific = __webpack_require__(1);
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function(Module, $, SCS) {
	'use strict';

	function trackKeymatchClick(mod, keymatch, config) {
		// Store URL so the referenced page knows where we came from
		if ('localStorage' in window) {
			window.localStorage.setItem('sitesearch-keymatch-origin-url', window.location.href);
		}
		// Tracking
		Module.SearchResultContainer.trackClick('keymatch', config, keymatch, mod.searchProcessor);
	}


	var SearchTopResults = Module.extend({
		// The container module instance (for setting config changes and the like)
		searchContainer: null,
		// The search processor instance for retrieving keymatches
		searchProcessor: null,
		// The DOM/vDOM element for displaying keymatches
		contentsContainer: null,
		// Search result display modules. These should filter out results if they point to the same URL as the keymatches we display
		searchDisplayModules: [],

		on: function(callback) {
			callback();
		},

		after: function() {
			this.contentsContainer = this.$ctx.find('> .contents')[0];
			this.translations = {
				detailsText: this.$ctx.attr('data-details-text'),
				ratingCount: this.$ctx.attr('data-sitesearch-numberOfReviews')
			};
		},

		initSearch: function(searchContainer) {
			var mod = this;
			var $config = mod.$ctx.closest('.search-configuration');
			if(!$config.length) {
				// Configuration on search field could also be outside
				$config = searchContainer.$config;
			}
			mod.searchDisplayModules = searchContainer.internalModulesByName('SearchResultDisplay');
			mod.searchContainer = searchContainer;
			mod.searchProcessor = SCS.search.orchestration.forKeymatches(
				mod.$ctx.attr('data-sitesearch-gsahostname'),
				$config.attr('data-sitesearch-sites'),
				$config.attr('data-sitesearch-client'),
				$config.attr('data-sitesearch-gsainstantsearchresults'),
				$('html').attr('lang') || 'de',
				mod.$ctx.attr('data-sitesearch-instantsearchcollectionsuffix')
			);
			mod.searchProcessor.responder(SCS.search.util.respondTo({
				data: mod.keymatchData
			}, mod));
			mod.searchProcessor.responder(SCS.search.util.respondTo({
				data: searchContainer.stopLoading,
				error: searchContainer.stopLoading,
				abort: searchContainer.stopLoading
			}, searchContainer));
		},

		searchConfigChanged: function(searchConfig) {
			this.process({query: searchConfig.query});
		},

		process: function(config) {
			this.searchContainer.startLoading();
			this.searchProcessor.process(config);
		},

		keymatchData: function(processor, data, config) {
			var mod = this;

			var snabbdom = window.snabbdom;
			var h = snabbdom.h;

			var keymatch, i;

			var keymatches = $.grep(config.keymatches || [], function(el) {
				return !el.error;
			});

			if(mod.searchDisplayModules.length) {
				var keymatchURLs = {};
				for(i=0;i<keymatches.length;i+=1) {
					keymatch = keymatches[i];
					keymatchURLs[Module.SearchResultDisplay.normalizeURL(keymatch.url)] = true;
				}
				for(i=0;i<mod.searchDisplayModules.length;i+=1) {
					mod.searchDisplayModules[i].dataUpdated(null, keymatchURLs);
				}
			}
			var hasKeymatches = keymatches.length > 0;
			mod.$ctx.toggleClass('active', hasKeymatches);

			var keymatchElements = [];
			for(i=0;i<keymatches.length;i+=1) {
				keymatch = keymatches[i];
				var display = keymatch.display;
				display = 'render' + display[0].toUpperCase()+display.substring(1).toLowerCase() + 'Keymatch';
				if(!(display in mod)) {
					display = 'renderGenericKeymatch';
				}
				var vnode = mod[display](keymatch, h, config);
				if(vnode) {
					keymatchElements.push(vnode);
				}
			}

			mod.contentsContainer = snabbdom.patch(mod.contentsContainer, h('div', keymatchElements));

		},

		renderGenericKeymatch: function(keymatch, h, config) {
			return h(
				'div.scs-sitesearch-keymatch.scs-sitesearch-selfcare.scs-sitesearch-'+keymatch.display,
				[
					h('div.scs-sitesearch-'+keymatch.display+'-tag'),
					h(
						'div.scs-sitesearch-selfcare-box',
						[h(
							'a',
							{
								props: {
									href: keymatch.url
								},
								on: {
									click: [trackKeymatchClick, this, keymatch, config]
								}
							},
							[
								h(
									'div.scs-sitesearch-selfcare-title',
									[keymatch.title]
								)
							]
						), h(
							'div.scs-sitesearch-selfcare-box-text',
							[keymatch.subtitle]
						)]
					)
				]
			);
		},

		// Don’t display webcodes
		renderWebcodeKeymatch: function() {
			return null;
		},

		renderProductKeymatch: function(keymatch, h, config) {
			var image = [];
			if(keymatch.image) {
				image = [h(
					'img',
					{
						props: {
							src: keymatch.image
						}
					}
				)];
			}
			var rating = h('div');
			if(typeof keymatch.rating === 'number' && keymatch.ratingCount > 0) {
				rating = h(
					'div.scs-sitesearch-product-teaser-rating',
					[
						h('div.scs-sitesearch-product-teaser-stars', {
							attrs: {
								'data-rating': keymatch.rating
							}
						}),
						h('div.scs-sitesearch-rating-txt', [
							SCS.utils.formatString(
								this.translations.ratingCount,
								keymatch.ratingCount
							)
						])
					]
				);
			}
			return h(
				'div.scs-sitesearch-product-teaser',
				[
					h(
						'div.scs-sitesearch-product-teaser-image',
						{
							'class': {
								'default-product': !keymatch.image
							}
						},
						image
					),
					h(
						'div.scs-sitesearch-product-teaser-content',
						[
							h(
								'a',
								{
									props: {
										href: keymatch.url
									},
									on: {
										click: [trackKeymatchClick, this, keymatch, config]
									}
								}, 
								[
									h('div.scs-sitesearch-product-teaser-title', 
										[keymatch.title]
									)
								]
							),
							h('div.scs-sitesearch-product-teaser-intro', [keymatch.subtitle]),
							rating,
							h('div.scs-sitesearch-clear'),
							h(
								'div.scs-sitesearch-product-teaser-details',
								[
									h('div.scs-sitesearch-details-txt', [this.translations.detailsText])
								]
							)
						]
					)
				]
				
			);
		}

	});

	Module.SearchTopResults = SearchTopResults;

})(window.Tc.Module, __webpack_provided_window_dot_Tc_dot_$, window.SCS = window.SCS || {});

}.call(window));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery) {/**
 * bxSlider v4.2.1d
 * Copyright 2013-2017 Steven Wanderski
 * Written while drinking Belgian ales and listening to jazz
 * Licensed under MIT (http://opensource.org/licenses/MIT)
 */

;(function($) {

  var defaults = {

    // GENERAL
    mode: 'horizontal',
    slideSelector: '',
    infiniteLoop: true,
    hideControlOnEnd: false,
    speed: 500,
    easing: null,
    slideMargin: 0,
    startSlide: 0,
    randomStart: false,
    captions: false,
    ticker: false,
    tickerHover: false,
    adaptiveHeight: false,
    adaptiveHeightSpeed: 500,
    video: false,
    useCSS: true,
    preloadImages: 'visible',
    responsive: true,
    slideZIndex: 50,
    wrapperClass: 'bx-wrapper',

    // TOUCH
    touchEnabled: true,
    swipeThreshold: 50,
    oneToOneTouch: true,
    preventDefaultSwipeX: true,
    preventDefaultSwipeY: false,

    // ACCESSIBILITY
    ariaLive: true,
    ariaHidden: true,

    // KEYBOARD
    keyboardEnabled: false,

    // PAGER
    pager: true,
    pagerType: 'full',
    pagerShortSeparator: ' / ',
    pagerSelector: null,
    buildPager: null,
    pagerCustom: null,

    // CONTROLS
    controls: true,
    nextText: 'Next',
    prevText: 'Prev',
    nextSelector: null,
    prevSelector: null,
    autoControls: false,
    startText: 'Start',
    stopText: 'Stop',
    autoControlsCombine: false,
    autoControlsSelector: null,

    // AUTO
    auto: false,
    pause: 4000,
    autoStart: true,
    autoDirection: 'next',
    stopAutoOnClick: false,
    autoHover: false,
    autoDelay: 0,
    autoSlideForOnePage: false,

    // CAROUSEL
    minSlides: 1,
    maxSlides: 1,
    moveSlides: 0,
    slideWidth: 0,
    shrinkItems: false,

    // CALLBACKS
    onSliderLoad: function() { return true; },
    onSlideBefore: function() { return true; },
    onSlideAfter: function() { return true; },
    onSlideNext: function() { return true; },
    onSlidePrev: function() { return true; },
    onSliderResize: function() { return true; },
	onAutoChange: function() { return true; } //calls when auto slides starts and stops
  };

  $.fn.bxSlider = function(options) {

    if (this.length === 0) {
      return this;
    }

    // support multiple elements
    if (this.length > 1) {
      this.each(function() {
        $(this).bxSlider(options);
      });
      return this;
    }

    // create a namespace to be used throughout the plugin
    var slider = {},
    // set a reference to our slider element
    el = this,
    // get the original window dimens (thanks a lot IE)
    windowWidth = $(window).width(),
    windowHeight = $(window).height();

    // Return if slider is already initialized
    if ($(el).data('bxSlider')) { return; }

    /**
     * ===================================================================================
     * = PRIVATE FUNCTIONS
     * ===================================================================================
     */

    /**
     * Initializes namespace settings to be used throughout plugin
     */
    var init = function() {
      // Return if slider is already initialized
      if ($(el).data('bxSlider')) { return; }
      // merge user-supplied options with the defaults
      slider.settings = $.extend({}, defaults, options);
      // parse slideWidth setting
      slider.settings.slideWidth = parseInt(slider.settings.slideWidth);
      // store the original children
      slider.children = el.children(slider.settings.slideSelector);
      // check if actual number of slides is less than minSlides / maxSlides
      if (slider.children.length < slider.settings.minSlides) { slider.settings.minSlides = slider.children.length; }
      if (slider.children.length < slider.settings.maxSlides) { slider.settings.maxSlides = slider.children.length; }
      // if random start, set the startSlide setting to random number
      if (slider.settings.randomStart) { slider.settings.startSlide = Math.floor(Math.random() * slider.children.length); }
      // store active slide information
      slider.active = { index: slider.settings.startSlide };
      // store if the slider is in carousel mode (displaying / moving multiple slides)
      slider.carousel = slider.settings.minSlides > 1 || slider.settings.maxSlides > 1;
      // if carousel, force preloadImages = 'all'
      if (slider.carousel) { slider.settings.preloadImages = 'all'; }
      // calculate the min / max width thresholds based on min / max number of slides
      // used to setup and update carousel slides dimensions
      slider.minThreshold = (slider.settings.minSlides * slider.settings.slideWidth) + ((slider.settings.minSlides - 1) * slider.settings.slideMargin);
      slider.maxThreshold = (slider.settings.maxSlides * slider.settings.slideWidth) + ((slider.settings.maxSlides - 1) * slider.settings.slideMargin);
      // store the current state of the slider (if currently animating, working is true)
      slider.working = false;
      // initialize the controls object
      slider.controls = {};
      // initialize an auto interval
      slider.interval = null;
      // determine which property to use for transitions
      slider.animProp = slider.settings.mode === 'vertical' ? 'top' : 'left';
      // determine if hardware acceleration can be used
      slider.usingCSS = slider.settings.useCSS && slider.settings.mode !== 'fade' && (function() {
        // create our test div element
        var div = document.createElement('div'),
        // css transition properties
        props = ['WebkitPerspective', 'MozPerspective', 'OPerspective', 'msPerspective'];
        // test for each property
        for (var i = 0; i < props.length; i++) {
          if (div.style[props[i]] !== undefined) {
            slider.cssPrefix = props[i].replace('Perspective', '').toLowerCase();
            slider.animProp = '-' + slider.cssPrefix + '-transform';
            return true;
          }
        }
        return false;
      }());
      // if vertical mode always make maxSlides and minSlides equal
      if (slider.settings.mode === 'vertical') { slider.settings.maxSlides = slider.settings.minSlides; }
      // save original style data
      el.data('origStyle', el.attr('style'));
      el.children(slider.settings.slideSelector).each(function() {
        $(this).data('origStyle', $(this).attr('style'));
      });

      // perform all DOM / CSS modifications
      setup();
    };

    /**
     * Performs all DOM and CSS modifications
     */
    var setup = function() {
      var preloadSelector = slider.children.eq(slider.settings.startSlide); // set the default preload selector (visible)

      // wrap el in a wrapper
      el.wrap('<div class="' + slider.settings.wrapperClass + '"><div class="bx-viewport"></div></div>');
      // store a namespace reference to .bx-viewport
      slider.viewport = el.parent();

      // add aria-live if the setting is enabled and ticker mode is disabled
      if (slider.settings.ariaLive && !slider.settings.ticker) {
        slider.viewport.attr('aria-live', 'polite');
      }
      // add a loading div to display while images are loading
      slider.loader = $('<div class="bx-loading" />');
      slider.viewport.prepend(slider.loader);
      // set el to a massive width, to hold any needed slides
      // also strip any margin and padding from el
      el.css({
        width: slider.settings.mode === 'horizontal' ? (slider.children.length * 1000 + 215) + '%' : 'auto',
        position: 'relative'
      });
      // if using CSS, add the easing property
      if (slider.usingCSS && slider.settings.easing) {
        el.css('-' + slider.cssPrefix + '-transition-timing-function', slider.settings.easing);
      // if not using CSS and no easing value was supplied, use the default JS animation easing (swing)
      } else if (!slider.settings.easing) {
        slider.settings.easing = 'swing';
      }
      // make modifications to the viewport (.bx-viewport)
      slider.viewport.css({
        width: '100%',
        overflow: 'hidden',
        position: 'relative'
      });
      slider.viewport.parent().css({
        maxWidth: getViewportMaxWidth()
      });
      // apply css to all slider children
      slider.children.css({
        // the float attribute is a reserved word in compressors like YUI compressor and need to be quoted #48
        'float': slider.settings.mode === 'horizontal' ? 'left' : 'none',
        listStyle: 'none',
        position: 'relative'
      });
      // apply the calculated width after the float is applied to prevent scrollbar interference
      slider.children.css('width', getSlideWidth());
      // if slideMargin is supplied, add the css
      if (slider.settings.mode === 'horizontal' && slider.settings.slideMargin > 0) { slider.children.css('marginRight', slider.settings.slideMargin); }
      if (slider.settings.mode === 'vertical' && slider.settings.slideMargin > 0) { slider.children.css('marginBottom', slider.settings.slideMargin); }
      // if "fade" mode, add positioning and z-index CSS
      if (slider.settings.mode === 'fade') {
        slider.children.css({
          position: 'absolute',
          zIndex: 0,
          display: 'none'
        });
        // prepare the z-index on the showing element
        slider.children.eq(slider.settings.startSlide).css({zIndex: slider.settings.slideZIndex, display: 'block'});
      }
      // create an element to contain all slider controls (pager, start / stop, etc)
      slider.controls.el = $('<div class="bx-controls" />');
      // if captions are requested, add them
      if (slider.settings.captions) { appendCaptions(); }
      // check if startSlide is last slide
      slider.active.last = slider.settings.startSlide === getPagerQty() - 1;
      // if video is true, set up the fitVids plugin
      if (slider.settings.video) { el.fitVids(); }
	  //preloadImages
	  if (slider.settings.preloadImages === 'none') { 
		  preloadSelector = null; 
	  }
      else if (slider.settings.preloadImages === 'all' || slider.settings.ticker) { 
		  preloadSelector = slider.children; 
	  }
      // only check for control addition if not in "ticker" mode
      if (!slider.settings.ticker) {
        // if controls are requested, add them
        if (slider.settings.controls) { appendControls(); }
        // if auto is true, and auto controls are requested, add them
        if (slider.settings.auto && slider.settings.autoControls) { appendControlsAuto(); }
        // if pager is requested, add it
        if (slider.settings.pager) { appendPager(); }
        // if any control option is requested, add the controls wrapper
        if (slider.settings.controls || slider.settings.autoControls || slider.settings.pager) { slider.viewport.after(slider.controls.el); }
      // if ticker mode, do not allow a pager
      } else {
        slider.settings.pager = false;
      }
	  if (preloadSelector === null) {
        start();
      } else {
        loadElements(preloadSelector, start);
      }
    };

    var loadElements = function(selector, callback) {
      var total = selector.find('img:not([src=""]), iframe').length,
      count = 0;
      if (total === 0) {
        callback();
        return;
      }
      selector.find('img:not([src=""]), iframe').each(function() {
        $(this).one('load error', function() {
          if (++count === total) { callback(); }
        }).each(function() {
          if (this.complete || this.src == '') { $(this).trigger('load'); }
        });
      });
    };

    /**
     * Start the slider
     */
    var start = function() {
      // if infinite loop, prepare additional slides
      if (slider.settings.infiniteLoop && slider.settings.mode !== 'fade' && !slider.settings.ticker) {
        var slice    = slider.settings.mode === 'vertical' ? slider.settings.minSlides : slider.settings.maxSlides,
        sliceAppend  = slider.children.slice(0, slice).clone(true).addClass('bx-clone'),
        slicePrepend = slider.children.slice(-slice).clone(true).addClass('bx-clone');
        if (slider.settings.ariaHidden) {
          sliceAppend.attr('aria-hidden', true);
          slicePrepend.attr('aria-hidden', true);
        }
        el.append(sliceAppend).prepend(slicePrepend);
      }
      // remove the loading DOM element
      slider.loader.remove();
      // set the left / top position of "el"
      setSlidePosition();
      // if "vertical" mode, always use adaptiveHeight to prevent odd behavior
      if (slider.settings.mode === 'vertical') { slider.settings.adaptiveHeight = true; }
      // set the viewport height
      slider.viewport.height(getViewportHeight());
      // make sure everything is positioned just right (same as a window resize)
      el.redrawSlider();
      // onSliderLoad callback
      slider.settings.onSliderLoad.call(el, slider.active.index);
      // slider has been fully initialized
      slider.initialized = true;
      // add the resize call to the window
      if (slider.settings.responsive) { $(window).on('resize', resizeWindow); }
      // if auto is true and has more than 1 page, start the show
      if (slider.settings.auto && slider.settings.autoStart && (getPagerQty() > 1 || slider.settings.autoSlideForOnePage)) { initAuto(); }
      // if ticker is true, start the ticker
      if (slider.settings.ticker) { initTicker(); }
      // if pager is requested, make the appropriate pager link active
      if (slider.settings.pager) { updatePagerActive(slider.settings.startSlide); }
      // check for any updates to the controls (like hideControlOnEnd updates)
      if (slider.settings.controls) { updateDirectionControls(); }
      // if touchEnabled is true, setup the touch events
      if (slider.settings.touchEnabled && !slider.settings.ticker) { initTouch(); }
      // if keyboardEnabled is true, setup the keyboard events
      if (slider.settings.keyboardEnabled && !slider.settings.ticker) {
        $(document).keydown(keyPress);
      }
    };

    /**
     * Returns the calculated height of the viewport, used to determine either adaptiveHeight or the maxHeight value
     */
    var getViewportHeight = function() {
      var height = 0;
      // first determine which children (slides) should be used in our height calculation
      var children = $();
      // if mode is not "vertical" and adaptiveHeight is false, include all children
      if (slider.settings.mode !== 'vertical' && !slider.settings.adaptiveHeight) {
        children = slider.children;
      } else {
        // if not carousel, return the single active child
        if (!slider.carousel) {
          children = slider.children.eq(slider.active.index);
        // if carousel, return a slice of children
        } else {
          // get the individual slide index
          var currentIndex = slider.settings.moveSlides === 1 ? slider.active.index : slider.active.index * getMoveBy();
          // add the current slide to the children
          children = slider.children.eq(currentIndex);
          // cycle through the remaining "showing" slides
          for (i = 1; i <= slider.settings.maxSlides - 1; i++) {
            // if looped back to the start
            if (currentIndex + i >= slider.children.length) {
              children = children.add(slider.children.eq(i - 1));
            } else {
              children = children.add(slider.children.eq(currentIndex + i));
            }
          }
        }
      }
      // if "vertical" mode, calculate the sum of the heights of the children
      if (slider.settings.mode === 'vertical') {
        children.each(function(index) {
          height += $(this).outerHeight();
        });
        // add user-supplied margins
        if (slider.settings.slideMargin > 0) {
          height += slider.settings.slideMargin * (slider.settings.minSlides - 1);
        }
      // if not "vertical" mode, calculate the max height of the children
      } else {
        height = Math.max.apply(Math, children.map(function() {
          return $(this).outerHeight(false);
        }).get());
      }

      if (slider.viewport.css('box-sizing') === 'border-box') {
        height += parseFloat(slider.viewport.css('padding-top')) + parseFloat(slider.viewport.css('padding-bottom')) +
              parseFloat(slider.viewport.css('border-top-width')) + parseFloat(slider.viewport.css('border-bottom-width'));
      } else if (slider.viewport.css('box-sizing') === 'padding-box') {
        height += parseFloat(slider.viewport.css('padding-top')) + parseFloat(slider.viewport.css('padding-bottom'));
      }

      return height;
    };

    /**
     * Returns the calculated width to be used for the outer wrapper / viewport
     */
    var getViewportMaxWidth = function() {
      var width = '100%';
      if (slider.settings.slideWidth > 0) {
        if (slider.settings.mode === 'horizontal') {
          width = (slider.settings.maxSlides * slider.settings.slideWidth) + ((slider.settings.maxSlides - 1) * slider.settings.slideMargin);
        } else {
          width = slider.settings.slideWidth;
        }
      }
      return width;
    };

    /**
     * Returns the calculated width to be applied to each slide
     */
    var getSlideWidth = function() {
      var newElWidth = slider.settings.slideWidth, // start with any user-supplied slide width
      wrapWidth      = slider.viewport.width();    // get the current viewport width
      // if slide width was not supplied, or is larger than the viewport use the viewport width
      if (slider.settings.slideWidth === 0 ||
        (slider.settings.slideWidth > wrapWidth && !slider.carousel) ||
        slider.settings.mode === 'vertical') {
        newElWidth = wrapWidth;
      // if carousel, use the thresholds to determine the width
      } else if (slider.settings.maxSlides > 1 && slider.settings.mode === 'horizontal') {
        if (wrapWidth > slider.maxThreshold) {
          return newElWidth;
        } else if (wrapWidth < slider.minThreshold) {
          newElWidth = (wrapWidth - (slider.settings.slideMargin * (slider.settings.minSlides - 1))) / slider.settings.minSlides;
        } else if (slider.settings.shrinkItems) {
          newElWidth = Math.floor((wrapWidth + slider.settings.slideMargin) / (Math.ceil((wrapWidth + slider.settings.slideMargin) / (newElWidth + slider.settings.slideMargin))) - slider.settings.slideMargin);
        }
      }
      return newElWidth;
    };

    /**
     * Returns the number of slides currently visible in the viewport (includes partially visible slides)
     */
    var getNumberSlidesShowing = function() {
      var slidesShowing = 1,
      childWidth = null;
      if (slider.settings.mode === 'horizontal' && slider.settings.slideWidth > 0) {
        // if viewport is smaller than minThreshold, return minSlides
        if (slider.viewport.width() < slider.minThreshold) {
          slidesShowing = slider.settings.minSlides;
        // if viewport is larger than maxThreshold, return maxSlides
        } else if (slider.viewport.width() > slider.maxThreshold) {
          slidesShowing = slider.settings.maxSlides;
        // if viewport is between min / max thresholds, divide viewport width by first child width
        } else {
          childWidth = slider.children.first().width() + slider.settings.slideMargin;
          slidesShowing = Math.floor((slider.viewport.width() +
            slider.settings.slideMargin) / childWidth) || 1;
        }
      // if "vertical" mode, slides showing will always be minSlides
      } else if (slider.settings.mode === 'vertical') {
        slidesShowing = slider.settings.minSlides;
      }
      return slidesShowing;
    };

    /**
     * Returns the number of pages (one full viewport of slides is one "page")
     */
    var getPagerQty = function() {
      var pagerQty = 0,
      breakPoint = 0,
      counter = 0;
      // if moveSlides is specified by the user
      if (slider.settings.moveSlides > 0) {
        if (slider.settings.infiniteLoop) {
          pagerQty = Math.ceil(slider.children.length / getMoveBy());
        } else {
          // when breakpoint goes above children length, counter is the number of pages
          while (breakPoint < slider.children.length) {
            ++pagerQty;
            breakPoint = counter + getNumberSlidesShowing();
            counter += slider.settings.moveSlides <= getNumberSlidesShowing() ? slider.settings.moveSlides : getNumberSlidesShowing();
          }
		  return counter;
        }
      // if moveSlides is 0 (auto) divide children length by sides showing, then round up
      } else {
        pagerQty = Math.ceil(slider.children.length / getNumberSlidesShowing());
      }
      return pagerQty;
    };

    /**
     * Returns the number of individual slides by which to shift the slider
     */
    var getMoveBy = function() {
      // if moveSlides was set by the user and moveSlides is less than number of slides showing
      if (slider.settings.moveSlides > 0 && slider.settings.moveSlides <= getNumberSlidesShowing()) {
        return slider.settings.moveSlides;
      }
      // if moveSlides is 0 (auto)
      return getNumberSlidesShowing();
    };

    /**
     * Sets the slider's (el) left or top position
     */
    var setSlidePosition = function() {
      var position, lastChild, lastShowingIndex;
      // if last slide, not infinite loop, and number of children is larger than specified maxSlides
      if (slider.children.length > slider.settings.maxSlides && slider.active.last && !slider.settings.infiniteLoop) {
        if (slider.settings.mode === 'horizontal') {
          // get the last child's position
          lastChild = slider.children.last();
          position = lastChild.position();
          // set the left position
          setPositionProperty(-(position.left - (slider.viewport.width() - lastChild.outerWidth())), 'reset', 0);
        } else if (slider.settings.mode === 'vertical') {
          // get the last showing index's position
          lastShowingIndex = slider.children.length - slider.settings.minSlides;
          position = slider.children.eq(lastShowingIndex).position();
          // set the top position
          setPositionProperty(-position.top, 'reset', 0);
        }
      // if not last slide
      } else {
        // get the position of the first showing slide
        position = slider.children.eq(slider.active.index * getMoveBy()).position();
        // check for last slide
        if (slider.active.index === getPagerQty() - 1) { slider.active.last = true; }
        // set the respective position
        if (position !== undefined) {
          if (slider.settings.mode === 'horizontal') { setPositionProperty(-position.left, 'reset', 0); }
          else if (slider.settings.mode === 'vertical') { setPositionProperty(-position.top, 'reset', 0); }
        }
      }
    };

    /**
     * Sets the el's animating property position (which in turn will sometimes animate el).
     * If using CSS, sets the transform property. If not using CSS, sets the top / left property.
     *
     * @param value (int)
     *  - the animating property's value
     *
     * @param type (string) 'slide', 'reset', 'ticker'
     *  - the type of instance for which the function is being
     *
     * @param duration (int)
     *  - the amount of time (in ms) the transition should occupy
     *
     * @param params (array) optional
     *  - an optional parameter containing any variables that need to be passed in
     */
    var setPositionProperty = function(value, type, duration, params) {
      var animateObj, propValue;
      // use CSS transform
      if (slider.usingCSS) {
        // determine the translate3d value
        propValue = slider.settings.mode === 'vertical' ? 'translate3d(0, ' + value + 'px, 0)' : 'translate3d(' + value + 'px, 0, 0)';
        // add the CSS transition-duration
        el.css('-' + slider.cssPrefix + '-transition-duration', duration / 1000 + 's');
        if (type === 'slide') {
          // set the property value
          el.css(slider.animProp, propValue);
          if (duration !== 0) {
            // add a callback method - executes when CSS transition completes
            el.on('transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd', function(e) {
              //make sure it's the correct one
              if (!$(e.target).is(el)) { return; }
              // remove the callback
              el.off('transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd');
              updateAfterSlideTransition();
            });
          } else { //duration = 0
            updateAfterSlideTransition();
          }
        } else if (type === 'reset') {
          el.css(slider.animProp, propValue);
        } else if (type === 'ticker') {
          // make the transition use 'linear'
          el.css('-' + slider.cssPrefix + '-transition-timing-function', 'linear');
          el.css(slider.animProp, propValue);
          if (duration !== 0) {
            el.on('transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd', function(e) {
              //make sure it's the correct one
              if (!$(e.target).is(el)) { return; }
              // remove the callback
              el.off('transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd');
              // reset the position
              setPositionProperty(params.resetValue, 'reset', 0);
              // start the loop again
              tickerLoop();
            });
          } else { //duration = 0
            setPositionProperty(params.resetValue, 'reset', 0);
            tickerLoop();
          }
        }
      // use JS animate
      } else {
        animateObj = {};
        animateObj[slider.animProp] = value;
        if (type === 'slide') {
          el.animate(animateObj, duration, slider.settings.easing, function() {
            updateAfterSlideTransition();
          });
        } else if (type === 'reset') {
          el.css(slider.animProp, value);
        } else if (type === 'ticker') {
          el.animate(animateObj, duration, 'linear', function() {
            setPositionProperty(params.resetValue, 'reset', 0);
            // run the recursive loop after animation
            tickerLoop();
          });
        }
      }
    };

    /**
     * Populates the pager with proper amount of pages
     */
    var populatePager = function() {
      var pagerHtml = '',
      linkContent = '',
      pagerQty = getPagerQty();
      // loop through each pager item
      for (var i = 0; i < pagerQty; i++) {
        linkContent = '';
        // if a buildPager function is supplied, use it to get pager link value, else use index + 1
        if (slider.settings.buildPager && $.isFunction(slider.settings.buildPager) || slider.settings.pagerCustom) {
          linkContent = slider.settings.buildPager(i);
          slider.pagerEl.addClass('bx-custom-pager');
        } else {
          linkContent = i + 1;
          slider.pagerEl.addClass('bx-default-pager');
        }
        // var linkContent = slider.settings.buildPager && $.isFunction(slider.settings.buildPager) ? slider.settings.buildPager(i) : i + 1;
        // add the markup to the string
        pagerHtml += '<div class="bx-pager-item"><a href="" data-slide-index="' + i + '" class="bx-pager-link">' + linkContent + '</a></div>';
      }
      // populate the pager element with pager links
      slider.pagerEl.html(pagerHtml);
    };

    /**
     * Appends the pager to the controls element
     */
    var appendPager = function() {
      if (!slider.settings.pagerCustom) {
        // create the pager DOM element
        slider.pagerEl = $('<div class="bx-pager" />');
        // if a pager selector was supplied, populate it with the pager
        if (slider.settings.pagerSelector) {
          $(slider.settings.pagerSelector).html(slider.pagerEl);
        // if no pager selector was supplied, add it after the wrapper
        } else {
          slider.controls.el.addClass('bx-has-pager').append(slider.pagerEl);
        }
        // populate the pager
        populatePager();
      } else {
        slider.pagerEl = $(slider.settings.pagerCustom);
      }
      // assign the pager click binding
      slider.pagerEl.on('click touchend', 'a', clickPagerBind);
    };

    /**
     * Appends prev / next controls to the controls element
     */
    var appendControls = function() {
      slider.controls.next = $('<a class="bx-next" href="">' + slider.settings.nextText + '</a>');
      slider.controls.prev = $('<a class="bx-prev" href="">' + slider.settings.prevText + '</a>');
      // add click actions to the controls
      slider.controls.next.on('click touchend', clickNextBind);
      slider.controls.prev.on('click touchend', clickPrevBind);
      // if nextSelector was supplied, populate it
      if (slider.settings.nextSelector) {
        $(slider.settings.nextSelector).append(slider.controls.next);
      }
      // if prevSelector was supplied, populate it
      if (slider.settings.prevSelector) {
        $(slider.settings.prevSelector).append(slider.controls.prev);
      }
      // if no custom selectors were supplied
      if (!slider.settings.nextSelector && !slider.settings.prevSelector) {
        // add the controls to the DOM
        slider.controls.directionEl = $('<div class="bx-controls-direction" />');
        // add the control elements to the directionEl
        slider.controls.directionEl.append(slider.controls.prev).append(slider.controls.next);
        // slider.viewport.append(slider.controls.directionEl);
        slider.controls.el.addClass('bx-has-controls-direction').append(slider.controls.directionEl);
      }
    };

    /**
     * Appends start / stop auto controls to the controls element
     */
    var appendControlsAuto = function() {
      slider.controls.start = $('<div class="bx-controls-auto-item"><a class="bx-start" href="">' + slider.settings.startText + '</a></div>');
      slider.controls.stop = $('<div class="bx-controls-auto-item"><a class="bx-stop" href="">' + slider.settings.stopText + '</a></div>');
      // add the controls to the DOM
      slider.controls.autoEl = $('<div class="bx-controls-auto" />');
      // on click actions to the controls
      slider.controls.autoEl.on('click', '.bx-start', clickStartBind);
      slider.controls.autoEl.on('click', '.bx-stop', clickStopBind);
      // if autoControlsCombine, insert only the "start" control
      if (slider.settings.autoControlsCombine) {
        slider.controls.autoEl.append(slider.controls.start);
      // if autoControlsCombine is false, insert both controls
      } else {
        slider.controls.autoEl.append(slider.controls.start).append(slider.controls.stop);
      }
      // if auto controls selector was supplied, populate it with the controls
      if (slider.settings.autoControlsSelector) {
        $(slider.settings.autoControlsSelector).html(slider.controls.autoEl);
      // if auto controls selector was not supplied, add it after the wrapper
      } else {
        slider.controls.el.addClass('bx-has-controls-auto').append(slider.controls.autoEl);
      }
      // update the auto controls
      updateAutoControls(slider.settings.autoStart ? 'stop' : 'start');
    };

    /**
     * Appends image captions to the DOM
     */
    var appendCaptions = function() {
      // cycle through each child
      slider.children.each(function(index) {
        // get the image title attribute
        var title = $(this).find('img:first').attr('title');
        // append the caption
        if (title !== undefined && ('' + title).length) {
          $(this).append('<div class="bx-caption"><span>' + title + '</span></div>');
        }
      });
    };

    /**
     * Click next binding
     *
     * @param e (event)
     *  - DOM event object
     */
    var clickNextBind = function(e) {
      e.preventDefault();
      if (slider.controls.el.hasClass('disabled')) { return; }
      // if auto show is running, stop it
      if (slider.settings.auto && slider.settings.stopAutoOnClick) { el.stopAuto(); }
      el.goToNextSlide();
    };

    /**
     * Click prev binding
     *
     * @param e (event)
     *  - DOM event object
     */
    var clickPrevBind = function(e) {
      e.preventDefault();
      if (slider.controls.el.hasClass('disabled')) { return; }
      // if auto show is running, stop it
      if (slider.settings.auto && slider.settings.stopAutoOnClick) { el.stopAuto(); }
      el.goToPrevSlide();
    };

    /**
     * Click start binding
     *
     * @param e (event)
     *  - DOM event object
     */
    var clickStartBind = function(e) {
      el.startAuto();
      e.preventDefault();
    };

    /**
     * Click stop binding
     *
     * @param e (event)
     *  - DOM event object
     */
    var clickStopBind = function(e) {
      el.stopAuto();
      e.preventDefault();
    };

    /**
     * Click pager binding
     *
     * @param e (event)
     *  - DOM event object
     */
    var clickPagerBind = function(e) {
      var pagerLink, pagerIndex;
      e.preventDefault();
      if (slider.controls.el.hasClass('disabled')) {
        return;
      }
      // if auto show is running, stop it
      if (slider.settings.auto  && slider.settings.stopAutoOnClick) { el.stopAuto(); }
      pagerLink = $(e.currentTarget);
      if (pagerLink.attr('data-slide-index') !== undefined) {
        pagerIndex = parseInt(pagerLink.attr('data-slide-index'));
        // if clicked pager link is not active, continue with the goToSlide call
        if (pagerIndex !== slider.active.index) { el.goToSlide(pagerIndex); }
      }
    };

    /**
     * Updates the pager links with an active class
     *
     * @param slideIndex (int)
     *  - index of slide to make active
     */
    var updatePagerActive = function(slideIndex) {
      // if "short" pager type
      var len = slider.children.length; // nb of children
      if (slider.settings.pagerType === 'short') {
        if (slider.settings.maxSlides > 1) {
          len = Math.ceil(slider.children.length / slider.settings.maxSlides);
        }
        slider.pagerEl.html((slideIndex + 1) + slider.settings.pagerShortSeparator + len);
        return;
      }
      // remove all pager active classes
      slider.pagerEl.find('a').removeClass('active');
      // apply the active class for all pagers
      slider.pagerEl.each(function(i, el) { $(el).find('a').eq(slideIndex).addClass('active'); });
    };

    /**
     * Performs needed actions after a slide transition
     */
    var updateAfterSlideTransition = function() {
      // if infinite loop is true
      if (slider.settings.infiniteLoop) {
        var position = '';
        // first slide
        if (slider.active.index === 0) {
          // set the new position
          position = slider.children.eq(0).position();
        // carousel, last slide
        } else if (slider.active.index === getPagerQty() - 1 && slider.carousel) {
          position = slider.children.eq((getPagerQty() - 1) * getMoveBy()).position();
        // last slide
        } else if (slider.active.index === slider.children.length - 1) {
          position = slider.children.eq(slider.children.length - 1).position();
        }
        if (position) {
          if (slider.settings.mode === 'horizontal') { setPositionProperty(-position.left, 'reset', 0); }
          else if (slider.settings.mode === 'vertical') { setPositionProperty(-position.top, 'reset', 0); }
        }
      }
      // declare that the transition is complete
      slider.working = false;
      // onSlideAfter callback
      slider.settings.onSlideAfter.call(el, slider.children.eq(slider.active.index), slider.oldIndex, slider.active.index);
    };

    /**
     * Updates the auto controls state (either active, or combined switch)
     *
     * @param state (string) "start", "stop"
     *  - the new state of the auto show
     */
    var updateAutoControls = function(state) {
      // if autoControlsCombine is true, replace the current control with the new state
      if (slider.settings.autoControlsCombine) {
        slider.controls.autoEl.html(slider.controls[state]);
      // if autoControlsCombine is false, apply the "active" class to the appropriate control
      } else {
        slider.controls.autoEl.find('a').removeClass('active');
        slider.controls.autoEl.find('a:not(.bx-' + state + ')').addClass('active');
      }
    };

    /**
     * Updates the direction controls (checks if either should be hidden)
     */
    var updateDirectionControls = function() {
      if (getPagerQty() === 1) {
        slider.controls.prev.addClass('disabled');
        slider.controls.next.addClass('disabled');
      } else if (!slider.settings.infiniteLoop && slider.settings.hideControlOnEnd) {
        // if first slide
        if (slider.active.index === 0) {
          slider.controls.prev.addClass('disabled');
          slider.controls.next.removeClass('disabled');
        // if last slide
        } else if (slider.active.index === getPagerQty() - 1) {
          slider.controls.next.addClass('disabled');
          slider.controls.prev.removeClass('disabled');
        // if any slide in the middle
        } else {
          slider.controls.prev.removeClass('disabled');
          slider.controls.next.removeClass('disabled');
        }
      }
    };
	/* auto start and stop functions */
	var windowFocusHandler = function() { el.startAuto(); };
	var windowBlurHandler = function() { el.stopAuto(); };
    /**
     * Initializes the auto process
     */
    var initAuto = function() {
      // if autoDelay was supplied, launch the auto show using a setTimeout() call
      if (slider.settings.autoDelay > 0) {
        setTimeout(el.startAuto, slider.settings.autoDelay);
      // if autoDelay was not supplied, start the auto show normally
      } else {
        el.startAuto();

        //add focus and blur events to ensure its running if timeout gets paused
        $(window).focus(windowFocusHandler).blur(windowBlurHandler);
      }
      // if autoHover is requested
      if (slider.settings.autoHover) {
        // on el hover
        el.hover(function() {
          // if the auto show is currently playing (has an active interval)
          if (slider.interval) {
            // stop the auto show and pass true argument which will prevent control update
            el.stopAuto(true);
            // create a new autoPaused value which will be used by the relative "mouseout" event
            slider.autoPaused = true;
          }
        }, function() {
          // if the autoPaused value was created be the prior "mouseover" event
          if (slider.autoPaused) {
            // start the auto show and pass true argument which will prevent control update
            el.startAuto(true);
            // reset the autoPaused value
            slider.autoPaused = null;
          }
        });
      }
    };

    /**
     * Initializes the ticker process
     */
    var initTicker = function() {
      var startPosition = 0,
      position, transform, value, idx, ratio, property, newSpeed, totalDimens;
      // if autoDirection is "next", append a clone of the entire slider
      if (slider.settings.autoDirection === 'next') {
        el.append(slider.children.clone().addClass('bx-clone'));
      // if autoDirection is "prev", prepend a clone of the entire slider, and set the left position
      } else {
        el.prepend(slider.children.clone().addClass('bx-clone'));
        position = slider.children.first().position();
        startPosition = slider.settings.mode === 'horizontal' ? -position.left : -position.top;
      }
      setPositionProperty(startPosition, 'reset', 0);
      // do not allow controls in ticker mode
      slider.settings.pager = false;
      slider.settings.controls = false;
      slider.settings.autoControls = false;
      // if autoHover is requested
      if (slider.settings.tickerHover) {
        if (slider.usingCSS) {
          idx = slider.settings.mode === 'horizontal' ? 4 : 5;
          slider.viewport.hover(function() {
            transform = el.css('-' + slider.cssPrefix + '-transform');
            value = parseFloat(transform.split(',')[idx]);
            setPositionProperty(value, 'reset', 0);
          }, function() {
            totalDimens = 0;
            slider.children.each(function(index) {
              totalDimens += slider.settings.mode === 'horizontal' ? $(this).outerWidth(true) : $(this).outerHeight(true);
            });
            // calculate the speed ratio (used to determine the new speed to finish the paused animation)
            ratio = slider.settings.speed / totalDimens;
            // determine which property to use
            property = slider.settings.mode === 'horizontal' ? 'left' : 'top';
            // calculate the new speed
            newSpeed = ratio * (totalDimens - (Math.abs(parseInt(value))));
            tickerLoop(newSpeed);
          });
        } else {
          // on el hover
          slider.viewport.hover(function() {
            el.stop();
          }, function() {
            // calculate the total width of children (used to calculate the speed ratio)
            totalDimens = 0;
            slider.children.each(function(index) {
              totalDimens += slider.settings.mode === 'horizontal' ? $(this).outerWidth(true) : $(this).outerHeight(true);
            });
            // calculate the speed ratio (used to determine the new speed to finish the paused animation)
            ratio = slider.settings.speed / totalDimens;
            // determine which property to use
            property = slider.settings.mode === 'horizontal' ? 'left' : 'top';
            // calculate the new speed
            newSpeed = ratio * (totalDimens - (Math.abs(parseInt(el.css(property)))));
            tickerLoop(newSpeed);
          });
        }
      }
      // start the ticker loop
      tickerLoop();
    };

    /**
     * Runs a continuous loop, news ticker-style
     */
    var tickerLoop = function(resumeSpeed) {
      var speed = resumeSpeed ? resumeSpeed : slider.settings.speed,
      position = {left: 0, top: 0},
      reset = {left: 0, top: 0},
      animateProperty, resetValue, params;

      // if "next" animate left position to last child, then reset left to 0
      if (slider.settings.autoDirection === 'next') {
        position = el.find('.bx-clone').first().position();
      // if "prev" animate left position to 0, then reset left to first non-clone child
      } else {
        reset = slider.children.first().position();
      }
      animateProperty = slider.settings.mode === 'horizontal' ? -position.left : -position.top;
      resetValue = slider.settings.mode === 'horizontal' ? -reset.left : -reset.top;
      params = {resetValue: resetValue};
      setPositionProperty(animateProperty, 'ticker', speed, params);
    };

    /**
     * Check if el is on screen
     */
    var isOnScreen = function(el) {
      var win = $(window),
      viewport = {
        top: win.scrollTop(),
        left: win.scrollLeft()
      },
      bounds = el.offset();

      viewport.right = viewport.left + win.width();
      viewport.bottom = viewport.top + win.height();
      bounds.right = bounds.left + el.outerWidth();
      bounds.bottom = bounds.top + el.outerHeight();

      return (!(viewport.right < bounds.left || viewport.left > bounds.right || viewport.bottom < bounds.top || viewport.top > bounds.bottom));
    };

    /**
     * Initializes keyboard events
     */
    var keyPress = function(e) {
      var activeElementTag = document.activeElement.tagName.toLowerCase(),
      tagFilters = 'input|textarea',
      p = new RegExp(activeElementTag,['i']),
      result = p.exec(tagFilters);

      if (result == null && isOnScreen(el)) {
        if (e.keyCode === 39) {
          clickNextBind(e);
          return false;
        } else if (e.keyCode === 37) {
          clickPrevBind(e);
          return false;
        }
      }
    };

    /**
     * Initializes touch events
     */
    var initTouch = function() {
      // initialize object to contain all touch values
      slider.touch = {
        start: {x: 0, y: 0},
        end: {x: 0, y: 0}
      };
      slider.viewport.on('touchstart MSPointerDown pointerdown', onTouchStart);

      //for browsers that have implemented pointer events and fire a click after
      //every pointerup regardless of whether pointerup is on same screen location as pointerdown or not
      slider.viewport.on('click', '.bxslider a', function(e) {
        if (slider.viewport.hasClass('click-disabled')) {
          e.preventDefault();
          slider.viewport.removeClass('click-disabled');
        }
      });
    };

    /**
     * Event handler for "touchstart"
     *
     * @param e (event)
     *  - DOM event object
     */
    var onTouchStart = function(e) {
      // watch only for left mouse, touch contact and pen contact
      // touchstart event object doesn`t have button property
      if (e.type !== 'touchstart' && e.button !== 0) {
        return;
      }
      //disable slider controls while user is interacting with slides to avoid slider freeze that happens on touch devices when a slide swipe happens immediately after interacting with slider controls
      slider.controls.el.addClass('disabled');

      if (slider.working) {
        slider.controls.el.removeClass('disabled');
      } else {
        // record the original position when touch starts
        slider.touch.originalPos = el.position();
        var orig = e.originalEvent,
        touchPoints = (typeof orig.changedTouches !== 'undefined') ? orig.changedTouches : [orig];
		var chromePointerEvents = typeof PointerEvent === 'function'; 
		if (chromePointerEvents) { 
			if (orig.pointerId === undefined) { 
				return;
			} 
		}
        // record the starting touch x, y coordinates
        slider.touch.start.x = touchPoints[0].pageX;
        slider.touch.start.y = touchPoints[0].pageY;

        if (slider.viewport.get(0).setPointerCapture) {
          slider.pointerId = orig.pointerId;
          slider.viewport.get(0).setPointerCapture(slider.pointerId);
        }
        // store original event data for click fixation
        slider.originalClickTarget = orig.originalTarget || orig.target;
        slider.originalClickButton = orig.button;
        slider.originalClickButtons = orig.buttons;
        slider.originalEventType = orig.type;
        // at this moment we don`t know what it is click or swipe
        slider.hasMove = false;
        // on a "touchmove" event to the viewport
        slider.viewport.on('touchmove MSPointerMove pointermove', onTouchMove);
        // on a "touchend" event to the viewport
        slider.viewport.on('touchend MSPointerUp pointerup', onTouchEnd);
        slider.viewport.on('MSPointerCancel pointercancel', onPointerCancel);
      }
    };

    /**
     * Cancel Pointer for Windows Phone
     *
     * @param e (event)
     *  - DOM event object
     */
    var onPointerCancel = function(e) {
      e.preventDefault();
      /* onPointerCancel handler is needed to deal with situations when a touchend
      doesn't fire after a touchstart (this happens on windows phones only) */
      setPositionProperty(slider.touch.originalPos.left, 'reset', 0);

      //remove handlers
      slider.controls.el.removeClass('disabled');
      slider.viewport.off('MSPointerCancel pointercancel', onPointerCancel);
      slider.viewport.off('touchmove MSPointerMove pointermove', onTouchMove);
      slider.viewport.off('touchend MSPointerUp pointerup', onTouchEnd);
      if (slider.viewport.get(0).releasePointerCapture) {
        slider.viewport.get(0).releasePointerCapture(slider.pointerId);
      }
    };

    /**
     * Event handler for "touchmove"
     *
     * @param e (event)
     *  - DOM event object
     */
    var onTouchMove = function(e) {
      var orig = e.originalEvent,
      touchPoints = (typeof orig.changedTouches !== 'undefined') ? orig.changedTouches : [orig],
      // if scrolling on y axis, do not prevent default
      xMovement = Math.abs(touchPoints[0].pageX - slider.touch.start.x),
      yMovement = Math.abs(touchPoints[0].pageY - slider.touch.start.y),
      value = 0,
      change = 0;
      // this is swipe
      slider.hasMove = true;

      // x axis swipe
      if ((xMovement * 3) > yMovement && slider.settings.preventDefaultSwipeX) {
        e.preventDefault();
      // y axis swipe
      } else if ((yMovement * 3) > xMovement && slider.settings.preventDefaultSwipeY) {
        e.preventDefault();
      }
      if (e.type !== 'touchmove') {
        e.preventDefault();
      }

      if (slider.settings.mode !== 'fade' && slider.settings.oneToOneTouch) {
        // if horizontal, drag along x axis
        if (slider.settings.mode === 'horizontal') {
          change = touchPoints[0].pageX - slider.touch.start.x;
          value = slider.touch.originalPos.left + change;
        // if vertical, drag along y axis
        } else {
          change = touchPoints[0].pageY - slider.touch.start.y;
          value = slider.touch.originalPos.top + change;
        }
        setPositionProperty(value, 'reset', 0);
      }
    };

    /**
     * Event handler for "touchend"
     *
     * @param e (event)
     *  - DOM event object
     */
    var onTouchEnd = function(e) {
      e.preventDefault();
      slider.viewport.off('touchmove MSPointerMove pointermove', onTouchMove);
      //enable slider controls as soon as user stops interacing with slides
      slider.controls.el.removeClass('disabled');
      var orig    = e.originalEvent,
      touchPoints = (typeof orig.changedTouches !== 'undefined') ? orig.changedTouches : [orig],
      value       = 0,
      distance    = 0;
      // record end x, y positions
      slider.touch.end.x = touchPoints[0].pageX;
      slider.touch.end.y = touchPoints[0].pageY;
      // if fade mode, check if absolute x distance clears the threshold
      if (slider.settings.mode === 'fade') {
        distance = Math.abs(slider.touch.start.x - slider.touch.end.x);
        if (distance >= slider.settings.swipeThreshold) {
          if (slider.touch.start.x > slider.touch.end.x) {
            el.goToNextSlide();
          } else {
            el.goToPrevSlide();
          }
          el.stopAuto();
        }
      // not fade mode
      } else {
        // calculate distance and el's animate property
        if (slider.settings.mode === 'horizontal') {
          distance = slider.touch.end.x - slider.touch.start.x;
          value = slider.touch.originalPos.left;
        } else {
          distance = slider.touch.end.y - slider.touch.start.y;
          value = slider.touch.originalPos.top;
        }
        // if not infinite loop and first / last slide, do not attempt a slide transition
        if (!slider.settings.infiniteLoop && ((slider.active.index === 0 && distance > 0) || (slider.active.last && distance < 0))) {
          setPositionProperty(value, 'reset', 200);
        } else {
          // check if distance clears threshold
          if (Math.abs(distance) >= slider.settings.swipeThreshold) {
            if (distance < 0) {
              el.goToNextSlide();
            } else {
              el.goToPrevSlide();
            }
            el.stopAuto();
          } else {
            // el.animate(property, 200);
            setPositionProperty(value, 'reset', 200);
          }
        }
      }
      slider.viewport.off('touchend MSPointerUp pointerup', onTouchEnd);

      if (slider.viewport.get(0).releasePointerCapture) {
        slider.viewport.get(0).releasePointerCapture(slider.pointerId);
      }
      // if slider had swipe with left mouse, touch contact and pen contact
      if (slider.hasMove === false && (slider.originalClickButton === 0 || slider.originalEventType === 'touchstart')) {
        // trigger click event (fix for Firefox59 and PointerEvent standard compatibility)
        $(slider.originalClickTarget).trigger({
          type: 'click',
          button: slider.originalClickButton,
          buttons: slider.originalClickButtons
        });
      }
    };

    /**
     * Window resize event callback
     */
    var resizeWindow = function(e) {
      // don't do anything if slider isn't initialized.
      if (!slider.initialized) { return; }
      // Delay if slider working.
      if (slider.working) {
        window.setTimeout(resizeWindow, 10);
      } else {
        // get the new window dimens (again, thank you IE)
        var windowWidthNew = $(window).width(),
        windowHeightNew = $(window).height();
        // make sure that it is a true window resize
        // *we must check this because our dinosaur friend IE fires a window resize event when certain DOM elements
        // are resized. Can you just die already?*
        if (windowWidth !== windowWidthNew || windowHeight !== windowHeightNew) {
          // set the new window dimens
          windowWidth = windowWidthNew;
          windowHeight = windowHeightNew;
          // update all dynamic elements
          el.redrawSlider();
          // Call user resize handler
          slider.settings.onSliderResize.call(el, slider.active.index);
        }
      }
    };

    /**
     * Adds an aria-hidden=true attribute to each element
     *
     * @param startVisibleIndex (int)
     *  - the first visible element's index
     */
    var applyAriaHiddenAttributes = function(startVisibleIndex) {
      var numberOfSlidesShowing = getNumberSlidesShowing();
      // only apply attributes if the setting is enabled and not in ticker mode
      if (slider.settings.ariaHidden && !slider.settings.ticker) {
        // add aria-hidden=true to all elements
        slider.children.attr('aria-hidden', 'true');
        // get the visible elements and change to aria-hidden=false
        slider.children.slice(startVisibleIndex, startVisibleIndex + numberOfSlidesShowing).attr('aria-hidden', 'false');
      }
    };

    /**
     * Returns index according to present page range
     *
     * @param slideOndex (int)
     *  - the desired slide index
     */
    var setSlideIndex = function(slideIndex) {
      if (slideIndex < 0) {
        if (slider.settings.infiniteLoop) {
          return getPagerQty() - 1;
        }else {
          //we don't go to undefined slides
          return slider.active.index;
        }
      // if slideIndex is greater than children length, set active index to 0 (this happens during infinite loop)
      } else if (slideIndex >= getPagerQty()) {
        if (slider.settings.infiniteLoop) {
          return 0;
        } else {
          //we don't move to undefined pages
          return slider.active.index;
        }
      // set active index to requested slide
      } else {
        return slideIndex;
      }
    };

    /**
     * ===================================================================================
     * = PUBLIC FUNCTIONS
     * ===================================================================================
     */

    /**
     * Performs slide transition to the specified slide
     *
     * @param slideIndex (int)
     *  - the destination slide's index (zero-based)
     *
     * @param direction (string)
     *  - INTERNAL USE ONLY - the direction of travel ("prev" / "next")
     */
    el.goToSlide = function(slideIndex, direction) {
      // onSlideBefore, onSlideNext, onSlidePrev callbacks
      // Allow transition canceling based on returned value
      var performTransition = true,
      moveBy = 0,
      position = {left: 0, top: 0},
      lastChild = null,
      lastShowingIndex, eq, value, requestEl;
      // store the old index
      slider.oldIndex = slider.active.index;
      //set new index
      slider.active.index = setSlideIndex(slideIndex);

      // if plugin is currently in motion, ignore request
      if (slider.working || slider.active.index === slider.oldIndex) { return; }
      // declare that plugin is in motion
      slider.working = true;

      performTransition = slider.settings.onSlideBefore.call(el, slider.children.eq(slider.active.index), slider.oldIndex, slider.active.index);

      // If transitions canceled, reset and return
      if (typeof (performTransition) !== 'undefined' && !performTransition) {
        slider.active.index = slider.oldIndex; // restore old index
        slider.working = false; // is not in motion
        return;
      }

      if (direction === 'next') {
        // Prevent canceling in future functions or lack there-of from negating previous commands to cancel
        if (!slider.settings.onSlideNext.call(el, slider.children.eq(slider.active.index), slider.oldIndex, slider.active.index)) {
          performTransition = false;
        }
      } else if (direction === 'prev') {
        // Prevent canceling in future functions or lack there-of from negating previous commands to cancel
        if (!slider.settings.onSlidePrev.call(el, slider.children.eq(slider.active.index), slider.oldIndex, slider.active.index)) {
          performTransition = false;
        }
      }

      // check if last slide
      slider.active.last = slider.active.index >= getPagerQty() - 1;
      // update the pager with active class
      if (slider.settings.pager || slider.settings.pagerCustom) { updatePagerActive(slider.active.index); }
      // // check for direction control update
      if (slider.settings.controls) { updateDirectionControls(); }
      // if slider is set to mode: "fade"
      if (slider.settings.mode === 'fade') {
        // if adaptiveHeight is true and next height is different from current height, animate to the new height
        if (slider.settings.adaptiveHeight && slider.viewport.height() !== getViewportHeight()) {
          slider.viewport.animate({height: getViewportHeight()}, slider.settings.adaptiveHeightSpeed);
        }
        // fade out the visible child and reset its z-index value
        slider.children.filter(':visible').fadeOut(slider.settings.speed).css({zIndex: 0});
        // fade in the newly requested slide
        slider.children.eq(slider.active.index).css('zIndex', slider.settings.slideZIndex + 1).fadeIn(slider.settings.speed, function() {
          $(this).css('zIndex', slider.settings.slideZIndex);
          updateAfterSlideTransition();
        });
      // slider mode is not "fade"
      } else {
        // if adaptiveHeight is true and next height is different from current height, animate to the new height
        if (slider.settings.adaptiveHeight && slider.viewport.height() !== getViewportHeight()) {
          slider.viewport.animate({height: getViewportHeight()}, slider.settings.adaptiveHeightSpeed);
        }
        // if carousel and not infinite loop
        if (!slider.settings.infiniteLoop && slider.carousel && slider.active.last) {
          if (slider.settings.mode === 'horizontal') {
            // get the last child position
            lastChild = slider.children.eq(slider.children.length - 1);
            position = lastChild.position();
            // calculate the position of the last slide
            moveBy = slider.viewport.width() - lastChild.outerWidth();
          } else {
            // get last showing index position
            lastShowingIndex = slider.children.length - slider.settings.minSlides;
            position = slider.children.eq(lastShowingIndex).position();
          }
          // horizontal carousel, going previous while on first slide (infiniteLoop mode)
        } else if (slider.carousel && slider.active.last && direction === 'prev') {
          // get the last child position
          eq = slider.settings.moveSlides === 1 ? slider.settings.maxSlides - getMoveBy() : ((getPagerQty() - 1) * getMoveBy()) - (slider.children.length - slider.settings.maxSlides);
          lastChild = el.children('.bx-clone').eq(eq);
          position = lastChild.position();
        // if infinite loop and "Next" is clicked on the last slide
        } else if (direction === 'next' && slider.active.index === 0) {
          // get the last clone position
          position = el.find('> .bx-clone').eq(slider.settings.maxSlides).position();
          slider.active.last = false;
        // normal non-zero requests
        } else if (slideIndex >= 0) {
          //parseInt is applied to allow floats for slides/page
          requestEl = slideIndex * parseInt(getMoveBy());
          position = slider.children.eq(requestEl).position();
        }

        /* If the position doesn't exist
         * (e.g. if you destroy the slider on a next click),
         * it doesn't throw an error.
         */
        if (typeof (position) !== 'undefined') {
          value = slider.settings.mode === 'horizontal' ? -(position.left - moveBy) : -position.top;
          // plugin values to be animated
          setPositionProperty(value, 'slide', slider.settings.speed);
        }
        slider.working = false;
      }
      if (slider.settings.ariaHidden) { applyAriaHiddenAttributes(slider.active.index * getMoveBy()); }
    };

    /**
     * Transitions to the next slide in the show
     */
    el.goToNextSlide = function() {
      // if infiniteLoop is false and last page is showing, disregard call
      if (!slider.settings.infiniteLoop && slider.active.last) { return; }
	  if (slider.working === true){ return ;}
      var pagerIndex = parseInt(slider.active.index) + 1;
      el.goToSlide(pagerIndex, 'next');
    };

    /**
     * Transitions to the prev slide in the show
     */
    el.goToPrevSlide = function() {
      // if infiniteLoop is false and last page is showing, disregard call
      if (!slider.settings.infiniteLoop && slider.active.index === 0) { return; }
	  if (slider.working === true){ return ;}
      var pagerIndex = parseInt(slider.active.index) - 1;
      el.goToSlide(pagerIndex, 'prev');
    };

    /**
     * Starts the auto show
     *
     * @param preventControlUpdate (boolean)
     *  - if true, auto controls state will not be updated
     */
    el.startAuto = function(preventControlUpdate) {
      // if an interval already exists, disregard call
      if (slider.interval) { return; }
      // create an interval
      slider.interval = setInterval(function() {
        if (slider.settings.autoDirection === 'next') {
          el.goToNextSlide();
        } else {
          el.goToPrevSlide();
        }
      }, slider.settings.pause);
	  //allback for when the auto rotate status changes
	  slider.settings.onAutoChange.call(el, true);
      // if auto controls are displayed and preventControlUpdate is not true
      if (slider.settings.autoControls && preventControlUpdate !== true) { updateAutoControls('stop'); }
    };

    /**
     * Stops the auto show
     *
     * @param preventControlUpdate (boolean)
     *  - if true, auto controls state will not be updated
     */
    el.stopAuto = function(preventControlUpdate) {
      // if slider is auto paused, just clear that state
      if (slider.autoPaused) slider.autoPaused = false;
      // if no interval exists, disregard call
      if (!slider.interval) { return; }
      // clear the interval
      clearInterval(slider.interval);
      slider.interval = null;
	  //allback for when the auto rotate status changes
	  slider.settings.onAutoChange.call(el, false);
      // if auto controls are displayed and preventControlUpdate is not true
      if (slider.settings.autoControls && preventControlUpdate !== true) { updateAutoControls('start'); }
    };

    /**
     * Returns current slide index (zero-based)
     */
    el.getCurrentSlide = function() {
      return slider.active.index;
    };

    /**
     * Returns current slide element
     */
    el.getCurrentSlideElement = function() {
      return slider.children.eq(slider.active.index);
    };

    /**
     * Returns a slide element
     * @param index (int)
     *  - The index (zero-based) of the element you want returned.
     */
    el.getSlideElement = function(index) {
      return slider.children.eq(index);
    };

    /**
     * Returns number of slides in show
     */
    el.getSlideCount = function() {
      return slider.children.length;
    };

    /**
     * Return slider.working variable
     */
    el.isWorking = function() {
      return slider.working;
    };

    /**
     * Update all dynamic slider elements
     */
    el.redrawSlider = function() {
      // resize all children in ratio to new screen size
      slider.children.add(el.find('.bx-clone')).outerWidth(getSlideWidth());
      // adjust the height
      slider.viewport.css('height', getViewportHeight());
      // update the slide position
      if (!slider.settings.ticker) { setSlidePosition(); }
      // if active.last was true before the screen resize, we want
      // to keep it last no matter what screen size we end on
      if (slider.active.last) { slider.active.index = getPagerQty() - 1; }
      // if the active index (page) no longer exists due to the resize, simply set the index as last
      if (slider.active.index >= getPagerQty()) { slider.active.last = true; }
      // if a pager is being displayed and a custom pager is not being used, update it
      if (slider.settings.pager && !slider.settings.pagerCustom) {
        populatePager();
        updatePagerActive(slider.active.index);
      }
      if (slider.settings.ariaHidden) { applyAriaHiddenAttributes(slider.active.index * getMoveBy()); }
    };

    /**
     * Destroy the current instance of the slider (revert everything back to original state)
     */
    el.destroySlider = function() {
      // don't do anything if slider has already been destroyed
      if (!slider.initialized) { return; }
      slider.initialized = false;
      $('.bx-clone', this).remove();
      slider.children.each(function() {
        if ($(this).data('origStyle') !== undefined) {
          $(this).attr('style', $(this).data('origStyle'));
        } else {
          $(this).removeAttr('style');
        }
      });
      if ($(this).data('origStyle') !== undefined) {
        this.attr('style', $(this).data('origStyle'));
      } else {
        $(this).removeAttr('style');
      }
      $(this).unwrap().unwrap();
      if (slider.controls.el) { slider.controls.el.remove(); }
      if (slider.controls.next) { slider.controls.next.remove(); }
      if (slider.controls.prev) { slider.controls.prev.remove(); }
      if (slider.pagerEl && slider.settings.controls && !slider.settings.pagerCustom) { slider.pagerEl.remove(); }
      $('.bx-caption', this).remove();
      if (slider.controls.autoEl) { slider.controls.autoEl.remove(); }
      clearInterval(slider.interval);
      if (slider.settings.responsive) { $(window).off('resize', resizeWindow); }
      if (slider.settings.keyboardEnabled) { $(document).off('keydown', keyPress); }
      //remove self reference in data
      $(this).removeData('bxSlider');
	  // remove global window handlers
	  $(window).off('blur', windowBlurHandler).off('focus', windowFocusHandler);
    };

    /**
     * Reload the slider (revert all DOM changes, and re-initialize)
     */
    el.reloadSlider = function(settings) {
      if (settings !== undefined) { options = settings; }
      el.destroySlider();
      init();
      //store reference to self in order to access public functions later
      $(el).data('bxSlider', this);
    };

    init();

    $(el).data('bxSlider', this);

    // returns the current jQuery object
    return this;
  };

})(jQuery);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 323 */
/***/ (function(module, exports) {

/*yepnope1.5.x|WTFPL*/
(function(a,b,c){function d(a){return"[object Function]"==o.call(a)}function e(a){return"string"==typeof a}function f(){}function g(a){return!a||"loaded"==a||"complete"==a||"uninitialized"==a}function h(){var a=p.shift();q=1,a?a.t?m(function(){("c"==a.t?B.injectCss:B.injectJs)(a.s,0,a.a,a.x,a.e,1)},0):(a(),h()):q=0}function i(a,c,d,e,f,i,j){function k(b){if(!o&&g(l.readyState)&&(u.r=o=1,!q&&h(),l.onload=l.onreadystatechange=null,b)){"img"!=a&&m(function(){t.removeChild(l)},50);for(var d in y[c])y[c].hasOwnProperty(d)&&y[c][d].onload()}}var j=j||B.errorTimeout,l=b.createElement(a),o=0,r=0,u={t:d,s:c,e:f,a:i,x:j};1===y[c]&&(r=1,y[c]=[]),"object"==a?l.data=c:(l.src=c,l.type=a),l.width=l.height="0",l.onerror=l.onload=l.onreadystatechange=function(){k.call(this,r)},p.splice(e,0,u),"img"!=a&&(r||2===y[c]?(t.insertBefore(l,s?null:n),m(k,j)):y[c].push(l))}function j(a,b,c,d,f){return q=0,b=b||"j",e(a)?i("c"==b?v:u,a,b,this.i++,c,d,f):(p.splice(this.i++,0,a),1==p.length&&h()),this}function k(){var a=B;return a.loader={load:j,i:0},a}var l=b.documentElement,m=a.setTimeout,n=b.getElementsByTagName("script")[0],o={}.toString,p=[],q=0,r="MozAppearance"in l.style,s=r&&!!b.createRange().compareNode,t=s?l:n.parentNode,l=a.opera&&"[object Opera]"==o.call(a.opera),l=!!b.attachEvent&&!l,u=r?"object":l?"script":"img",v=l?"script":u,w=Array.isArray||function(a){return"[object Array]"==o.call(a)},x=[],y={},z={timeout:function(a,b){return b.length&&(a.timeout=b[0]),a}},A,B;B=function(a){function b(a){var a=a.split("!"),b=x.length,c=a.pop(),d=a.length,c={url:c,origUrl:c,prefixes:a},e,f,g;for(f=0;f<d;f++)g=a[f].split("="),(e=z[g.shift()])&&(c=e(c,g));for(f=0;f<b;f++)c=x[f](c);return c}function g(a,e,f,g,h){var i=b(a),j=i.autoCallback;i.url.split(".").pop().split("?").shift(),i.bypass||(e&&(e=d(e)?e:e[a]||e[g]||e[a.split("/").pop().split("?")[0]]),i.instead?i.instead(a,e,f,g,h):(y[i.url]?i.noexec=!0:y[i.url]=1,f.load(i.url,i.forceCSS||!i.forceJS&&"css"==i.url.split(".").pop().split("?").shift()?"c":c,i.noexec,i.attrs,i.timeout),(d(e)||d(j))&&f.load(function(){k(),e&&e(i.origUrl,h,g),j&&j(i.origUrl,h,g),y[i.url]=2})))}function h(a,b){function c(a,c){if(a){if(e(a))c||(j=function(){var a=[].slice.call(arguments);k.apply(this,a),l()}),g(a,j,b,0,h);else if(Object(a)===a)for(n in m=function(){var b=0,c;for(c in a)a.hasOwnProperty(c)&&b++;return b}(),a)a.hasOwnProperty(n)&&(!c&&!--m&&(d(j)?j=function(){var a=[].slice.call(arguments);k.apply(this,a),l()}:j[n]=function(a){return function(){var b=[].slice.call(arguments);a&&a.apply(this,b),l()}}(k[n])),g(a[n],j,b,n,h))}else!c&&l()}var h=!!a.test,i=a.load||a.both,j=a.callback||f,k=j,l=a.complete||f,m,n;c(h?a.yep:a.nope,!!i),i&&c(i)}var i,j,l=this.yepnope.loader;if(e(a))g(a,0,l,0);else if(w(a))for(i=0;i<a.length;i++)j=a[i],e(j)?g(j,0,l,0):w(j)?B(j):Object(j)===j&&h(j,l);else Object(a)===a&&h(a,l)},B.addPrefix=function(a,b){z[a]=b},B.addFilter=function(a){x.push(a)},B.errorTimeout=1e4,null==b.readyState&&b.addEventListener&&(b.readyState="loading",b.addEventListener("DOMContentLoaded",A=function(){b.removeEventListener("DOMContentLoaded",A,0),b.readyState="complete"},0)),a.yepnope=k(),a.yepnope.executeStack=h,a.yepnope.injectJs=function(a,c,d,e,i,j){var k=b.createElement("script"),l,o,e=e||B.errorTimeout;k.src=a;for(o in d)k.setAttribute(o,d[o]);c=j?h:c||f,k.onreadystatechange=k.onload=function(){!l&&g(k.readyState)&&(l=1,c(),k.onload=k.onreadystatechange=null)},m(function(){l||(l=1,c(1))},e),i?k.onload():n.parentNode.insertBefore(k,n)},a.yepnope.injectCss=function(a,c,d,e,g,i){var e=b.createElement("link"),j,c=i?h:c||f;e.href=a,e.rel="stylesheet",e.type="text/css";for(j in d)e.setAttribute(j,d[j]);g||(n.parentNode.insertBefore(e,n),m(c,0))}})(this,document);

/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_$) {(function ($) {
	/**
	 * Swisscom Cookies
	 *
	 * Wrapper for $.cookies (jquery.cookies.2.2.0.min.js)
	 * See documentation on http://code.google.com/p/cookies/wiki/Documentation
	 *
	 * @author Juliane Huber, Thomas Junghans
	 * @namespace $
	 * @class setCookie, getCookie, removeCookie
	 */

	'use strict';

	/**
	 * setCookie
	 *
	 * @param {String} name
	 * @param {*} value
	 * @param {Number} days (optional)
	 * @param {String} path (optional)
	 * @param {String} domain (optional)
	 * @return {*}
	 */
	$.setCookie = function (name, value, days, path, domain) {
		var date;
		if (days && !isNaN(days)) {
			date = new Date();
			date.setTime(date.getTime() + (days*24*60*60*1000));
		}
		$.cookies.set(name, value, {
			secure: location.protocol.indexOf('https') >= 0,
			path: path || '/',
			expiresAt: date || '',
			domain: domain || null
		});
		return value;
	};

	/**
	 * getCookie
	 *
	 * @param {String} name
	 * @return {*}
	 */
	$.getCookie = function (name) {
		return $.cookies.get(name);
	};

	/**
	 * removeCookie
	 *
	 * @param {String} name
	 * @param {String} path
	 * @param {String} domain
	 */
	$.removeCookie = function (name, path, domain) {
		$.cookies.del(name, {
			secure: location.protocol.indexOf('https') >= 0,
			path: path || '/',
			domain: domain || null
		});
	};

})(__webpack_provided_window_dot_$);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

(function () {
	/**
	 * Global hash deeplinks
	 *
	 * @author Matthias Inauen
	 * @namespace SCS
	 * @class HashDeepLink
	 */

	'use strict';
	window.SCS = window.SCS || {};

	window.SCS.HashDeepLink = __webpack_require__(6).hashDeepLink;

}());


/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_Tc_dot_$) {/*** IMPORTS FROM imports-loader ***/
var loadTerrific = __webpack_require__(1);
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function (Module, $, w, SCS) {
	'use strict';
	/*jshint smarttabs:true */

	function uuid() {
		// jshint bitwise: false
		return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
			var r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
			return v.toString(16);
		});
	}

	// IE8 fix
	document.createElement('video');

	/**
	 * BrightcoveVideo module implementation.
	 *
	 * @author Thomas Junghans (refactored by Dave Talamona, Benjamin Berger)
	 * @namespace Tc.Module
	 * @class BrightcoveVideo
	 * @extends Tc.Module
	 */
	Module.BrightcoveVideo = Module.extend({

		/* Runtime properties */
		// The videojs player instance.
		player: null,

		// The current video metadata
		currentVideo: null,

		// The interval for the ugly hack that causes flash to throw an exception when it has died so we know when to reload the player.
		flashHideErrorTriggerInterval: null,

		// The interval that counts down the skip-ad timeout and activates the skip button.
		skipAdTimeoutInterval: null,

		// How many milliseconds of the ad timeout have elapsed.
		skipAdTimeoutElapsed: 0,

		// This video’s id attribute value (generated by the module).
		id: null,

		/* Config attributes */
		// Whether the video starts automatically.
		autostart: false,

		// Whether the video loops.
		loop: false,

		// How long one has to wait before being allowed to skip an ad, in milliseconds.
		skipAdTimeout: 8000,

		// The URL for the VAST tag. Null if not yet initialized or ads are disabled.
		adServerUrl: null,

		// Whether this video is in an overlay
		isInOverlay: false,

		// Whether the player was reloaded because of a technical problem.
		// If this is the case, ads should not be shown again because they might have caused the problem.
		wasReloaded: false,

		// Whether the player is currently showing an ad (playing or paused).
		currentlyShowingAds: false,

		/* Module elements */
		// The container for this video. This element is responsible for creating the correct aspect ratio.
		// If the player is in an overlay, this is the element that gets overlaid.
		$videoContainer: null,

		// The div that contains the video tag.
		$wrapper: null,

		// A div with the same attributes as the video tag, from which the video tag can be generated.
		$dummyVideoTag: null,

		// The actual video tag. Careful, this might not be what you expected (if you expected a <video> tag attached to the document):
		// * null if the video tag has not yet been initialized
		// * a <video> tag not attachted to the document (if it has been replaced by flash)
		$videoTag: null,

		// The button on which to click when skipping an ad.
		$skipAdsButton: null,

		/**
		 * Hook function to do all of your module stuff.
		 *
		 * @method after
		 * @param {Function} callback function
		 * @return void
		 */
		on: function (callback) {
			var mod = this;

			mod.$videoContainer = mod.$ctx.find('.video-container');
			mod.$dummyVideoTag = mod.$videoContainer.find('.dummyVideoTag');
			mod.$dummyVideoTag.remove();

			callback();
		},

		after: function () {
			var mod = this;

			// Store calls to the API that were made before the player was ready
			mod.apiCache = {};
			mod.setupAPI();

			// Get attributes
			mod.autostart = mod.$ctx.data('autostart');
			mod.loop = mod.$ctx.data('loop');
			mod.skipAdTimeout = parseInt(mod.$ctx.attr('data-skip-ad-timeout'), 10) * 1000 || mod.skipAdTimeout;
			mod.isInOverlay = mod.$ctx.data('is-in-overlay');

			if (mod.debug) {
				window.modBrightcoveVideo = mod;
			}

			mod.$wrapper = mod.$videoContainer.find('.video-player-wrapper');
			mod.$skipAdsButton = mod.$ctx.find('.skipAdsButton');

			mod.loadBrightcove($.proxy(mod, 'preparePlayer'));

			mod.initVideoPlaybutton();
		},

		setupAPI: function () {
			var mod = this;

			mod.$ctx.on('onPause', function () {
				mod.pause();
				mod.log('on pause API called');
			});

			mod.$ctx.on('onPlay', function () {
				mod.play();
				mod.log('on play API called');
			});

			mod.$ctx.closest('.modVisibilityControlContainer').on('visibilityControl-hide', function () {
				mod.pause();
			});

			mod.$ctx[0].brightcoveapi = {
				play: $.proxy(mod, 'play'),
				pause: $.proxy(mod, 'pause'),
				getPlayer: $.proxy(mod, 'getPlayer'),
				isPlaying: $.proxy(mod, 'isPlaying'),
				dispose: $.proxy(mod, 'dispose'),
				getModule: function getModule() {
					return mod;
				}
			};

			mod.$ctx.data('brightcove-api', mod.$ctx[0].brightcoveapi);
		},

		loadBrightcove: function loadBrightcove(callback) {
			var mod = this;

			if (window.bc && window.videojs) {
				callback();
			} else {
				if (loadBrightcove.loaders) {
					loadBrightcove.loaders.push(callback);
					return;
				}
				loadBrightcove.loaders = [callback];
				var url = mod.$ctx.data('playerScript');
				if (mod.debug) {
					url = url.replace(/\.min\.js$/, '.js');
				}
				mod.log('loading window.bc from ' + url);
				$.ajax({
					url: url,
					cache: true,
					dataType: 'script',
					success: function () {
						mod.log('loaded window.bc', typeof window.bc, typeof window.videojs, loadBrightcove.loaders.length);
						for (var i = 0; i < loadBrightcove.loaders.length; i += 1) {
							loadBrightcove.loaders[i]();
						}
						delete loadBrightcove.loaders;
					}
				});
			}
		},

		preparePlayer: function () {
			var mod = this;
			mod.initPlayer();
		},

		initPlayer: function () {
			var mod = this;

			if (mod.player) {
				mod.log('Player reloaded because of a technical problem');
				mod.wasReloaded = true;
			}

			mod.createVideo();

			var video = mod.$videoTag[0];
			try {
				// this call is very important so Brightcove can mess around with the video tag
				// before we init the real vjs component that we will use
				window.bc(video);
			} catch (e) {
				// If brightcove has already transformed the video tag, we get an error. That’s ok.
			}

			window.videojs(video).ready(function () {
				var player = this;
				mod.log('videojs ready', mod.id, video, player);
				if (player.techName === 'Flash') {
					mod.prepareFlashPlaybackHack(player);
				}
				mod.setupPlayer(player);
			});
		},

		prepareFlashPlaybackHack: function (player) {
			var techCall = player.techCall;
			player.techCall = function (method) {
				if (method === 'play') {
					// Call play twice to combat flash not starting the first time around
					techCall.apply(this, arguments);
				}
				techCall.apply(this, arguments);
			};
		},

		// Create the <video> element that is then used to initialize brightcove
		createVideo: function () {
			var mod = this;

			mod.id = uuid();
			var attrs = {
				poster: mod.$dummyVideoTag.attr('data-poster'),
				'class': mod.$dummyVideoTag.attr('data-class'),
				controls: true,
				id: mod.id
			};
			for (var name in mod.$dummyVideoTag.data()) {
				// jshint forin: false
				// de-camelize name
				name = 'data-' + name.replace(/([a-z\d])([A-Z])/g, '$1' + '-' + '$2').toLowerCase();
				var value = mod.$dummyVideoTag.attr(name);

				attrs[name] = value;
			}

			mod.$videoTag = $(document.createElement('video'));

			if(!mod.$ctx.closest('.stagearea').length) {
				attrs.preload = 'metadata';
			}
			mod.$videoTag.attr(attrs);

			mod.$wrapper.empty();
			mod.$wrapper.append(mod.$videoTag);
		},

		setupPlayer: function (player) {
			var mod = this;

			// Clean up the old player (if any)
			mod.cleanup();
			/* Initialize state */
			// get a reference to the player
			mod.player = player;
			mod.skipAdTimeoutElapsed = 0;

			mod.log('setupPlayer bc video');

			mod.$wrapper.find('.video-js').css('left', '0px');
			mod.$ctx.find('.video-js').css({width: '100%', height: '100%'});

			mod.player.loop(mod.loop);
			//mod.player.autoplay(mod.autostart);
			mod.log('setting autoplay: ' + mod.autostart + ', loop: ' + mod.loop);

			// TODO could be saved in a cookie for next use of player or at least sync with other players on same page
			mod.player.volume(0.5);

			mod.setupPlayerLoad();
			mod.setupPlayerEvents();

			if (mod.videoOnHold){
				mod.onBrightcovePlayVideo(mod.videoOnHold);
				delete mod.videoOnHold;
			}

			try {
				mod.setupPlayerAds();
			} catch (e) {
				mod.log('setting up ads crashed', e);
				mod.setNotShowingAds();
			}

			// Re-run the calls to the API that were made before the player was ready
			for (var api in mod.apiCache) {
				if (!mod.apiCache.hasOwnProperty(api)) {
					continue;
				}
				this[api]();
			}

			mod.$ctx.addClass('scs-setup-and-ready');
		},

		cleanup: function () {
			var mod = this;
			if (mod.skipAdTimeoutInterval) {
				window.clearInterval(mod.skipAdTimeoutInterval);
			}
			if (mod.flashHideErrorTriggerInterval) {
				window.clearInterval(mod.flashHideErrorTriggerInterval);
			}
			if (mod.player) {
				mod.player.dispose();
				mod.player = null;
			}
		},

		setupPlayerLoad: function () {
			var mod = this;

			mod.log('trigger handler for player-loaded');
			// Trigger event for parent modules to react to and re-calculate sizes and stuff.
			mod.$ctx.trigger('brightcove.playerloaded');
		},

		setupPlayerEvents: function () {
			var mod = this;

			var isFirst = true;

			mod.player.on('loadstart', function (event) {
				mod.log('got loadstart event', event);
				var video = mod.player.mediainfo;

				mod.videoChanged(mod, video, isFirst);
				if (isFirst) {
					mod.initialVideoChanged(mod, video);
					isFirst = false;
				}
			});
			mod.player.on('ended', function (event) {
				mod.log('got ended event', event);
				mod.videoFinished(mod.player.mediainfo, mod);
			});
			mod.player.on('error', function (event) {
				mod.log('got error event', event);
				if (mod.player.ads && mod.currentlyShowingAds) {
					// Error was caused by an ad. Re-init the player (no ads will be shown this time).
					mod.initPlayer();
				}
			});
			mod.player.on('bc-catalog-error', function (event) {
				mod.log('got bc-catalog-error event', event);
				// Wait a few seconds, then re-init the player
				window.setTimeout(function () {
					mod.initPlayer();
				}, 2000);
			});

			mod.player.on('pause', function(event) {
				mod.log('got pause event', event);
				mod.$ctx.addClass('is-paused').removeClass('is-playing');
			});
			mod.player.on('play', function(event) {
				mod.log('got play event', event);
				mod.$ctx.removeClass('is-paused').addClass('is-playing');
			});
			mod.player.on('firstplay', function(event) {
				mod.log('got firstplay event', event);
				mod.$ctx.removeClass('is-idle').addClass('has-started');
			});

			var hasLoaded = !!mod.player.mediainfo;
			if (hasLoaded) {
				mod.player.trigger('loadstart');
			}
		},

		getAdVars: function () {
			var mod = this,
				vars = '';

			// window.bwAdVars is set by persad.js
			for (var k in window.bwAdVars) {
				if (k.indexOf('kv') === 0) {
					vars += ';' + k + '=' + window.bwAdVars[k];
				}
			}
			mod.log('getAdVars > vars=' + vars);
			return vars;
		},

		setupPlayerAds: function () {
			var mod = this;
			mod.adServerUrl = null;

			mod.log('setupPlayerAds', mod.player.ima3, mod.wasReloaded);

			if (!mod.player.ima3 || !mod.player.ima3.adrequest) {
				mod.log('ima3 not present');
				return;
			}

			if (mod.wasReloaded) {
				// Do not show ads twice if player was reloaded because of a technical problem.
				mod.wasReloaded = false;
				return;
			}

			// Get the brightcove ad configuration
			mod.adServerUrl = mod.getAdServerUrl();

			// debug ad URL, leave this comment in
			//mod.adServerUrl = "https://cs1.brightcodes.net/gamati/AdServer/AdExampleForTest.xml";
			if (!mod.adServerUrl) {
				return;
			}

			mod.player.ima3.settings.requestMode = 'onplay';
			mod.player.ima3.settings.serverUrl = mod.adServerUrl + mod.getAdVars();

			// 20 vast request redirects: PORTAL-11593
			// see docu https://docs.brightcove.com/en/perform/brightcove-player/guides/ima-plugin.html#methods
			mod.player.ima3.settings.ima3SdkSettings = { numRedirects : 20};

			mod.$wrapper.find('.video-js').append(mod.$skipAdsButton);
			mod.$ctx.find('.skipAdForReal').click($.proxy(mod.skipAd, mod));
			mod.updateSkipAdsButtonState();

			// Register adstart and adend listeners to start skip countdown
			mod.player.on('adstart', function (event) {
				mod.log('got adstart event', event);
				mod.setShowingAds();
			});

			mod.player.on('adend', function (event) {
				mod.log('got adend event', event);
				mod.setNotShowingAds();
			});

			mod.player.on('ima3-ad-error', function (event) {
				mod.log('got ima3-ad-error event', event);
				mod.setNotShowingAds();
				mod.play();
			});

			// Log
			if(mod.debug) {
				[
					'ima3error',
					'ads-request',
					'ads-load',
					'adsready',
					'adtimeout',
					'ads-ad-started',
					'ads-ad-ended',
					'ads-pause',
					'ads-play',
					'ads-first-quartile',
					'ads-midpoint',
					'ads-third-quartile',
					'ads-click',
					'ads-volumechange',
					'ads-pod-started',
					'ads-pod-ended',
					'ads-allpods-completed'
				].forEach(function(type) {
					mod.player.on(type, function (event) {
						mod.log('got '+type+' event', event);
					});
				});
			}
		},

		/*triggerAdRequest: function() {
			var mod = this;
			if(!mod.adServerUrl) {
				// No ads configured on page
				return;
			}
			if(window.google && window.google.ima) {
				mod.log('requesting ads from', mod.adServerUrl);
				mod.player.ima3.adrequest(mod.adServerUrl);
			} else {
				mod.player.on('ima3-ready', function(event) {
					// initialize the ima3 plugin that was registered in ima3.min.js with custom options
					mod.log('got ima3-ready event', event, 'now requesting ads from', mod.adServerUrl);
					mod.player.ima3.adrequest(mod.adServerUrl);
				});
			}
		},*/

		getAdServerUrl: function () {
			var mod = this;

			if (!mod.player.ima3) {
				mod.log('don’t configure ads because they seem to be turned off', mod.player.ima3);
				return;
			}
			if(mod.$ctx.data('ad-pre') && mod.$ctx.data('ad-pre').length) {
				return mod.$ctx.data('ad-pre');
			}
			else if(mod.$ctx.data('ad-post') && mod.$ctx.data('ad-post').length) {
				return mod.$ctx.data('ad-post');
			}

			mod.log('!prerollAds && !postrollAds');
		},

		setShowingAds: function () {
			var mod = this;
			mod.log('setShowingAds', mod.skipAdTimeoutElapsed, mod.skipAdTimeout);

			mod.currentlyShowingAds = true;
			$('.disablePlaylist').css({zIndex: 1}).show();

			if (mod.skipAdTimeoutElapsed >= mod.skipAdTimeout) {
				// Something went wrong: ads were already shown
				return;
			}
			mod.$skipAdsButton.removeClass('hiddenSkip');
			mod.startAdSkipCountdown();
		},

		setNotShowingAds: function () {
			var mod = this;
			mod.log('setNotShowingAds');

			mod.currentlyShowingAds = false;
			$('.disablePlaylist').hide();

			mod.pauseAdSkipCountdown();
			mod.skipAdTimeoutElapsed = 0;
			mod.$skipAdsButton.addClass('hiddenSkip');
		},

		startAdSkipCountdown: function () {
			var mod = this;
			mod.log('startAdSkipCountdown');
			mod.$skipAdsButton.removeClass('hiddenSkip');

			if (mod.skipAdTimeoutInterval) {
				// Already an interval active… do nothing
				// FIXME: Why not clear the old interval and create a new one?
				return;
			}

			// Make sure the buttons have the correct initial state
			mod.updateSkipAdsButtonState();

			if (mod.skipAdTimeoutElapsed >= mod.skipAdTimeout) {
				return;
			}

			var startDate = + new Date();
			// Store the initial time (if it’s not 0)
			var elapsed = mod.skipAdTimeoutElapsed;
			mod.skipAdTimeoutInterval = setInterval(function () {
				mod.skipAdTimeoutElapsed = elapsed + (+new Date()) - startDate;
				mod.updateSkipAdsButtonState();
			}, 500);
		},

		updateSkipAdsButtonState: function () {
			var mod = this;
			var postSkip = mod.skipAdTimeoutElapsed >= mod.skipAdTimeout;
			mod.$skipAdsButton.toggleClass('preSkip', !postSkip);
			mod.$skipAdsButton.toggleClass('postSkip', postSkip);
			if(mod.player && mod.player.ima3 && mod.player.ima3.adsManager) {
				mod.$skipAdsButton.find('.skipAdRest .secTimer').text(Math.ceil(mod.player.ima3.adsManager.getRemainingTime()));
			}
			mod.$skipAdsButton.find('.skipAdCountdown .secTimer').text(Math.ceil((mod.skipAdTimeout - mod.skipAdTimeoutElapsed)/1000));
		},

		pauseAdSkipCountdown: function () {
			var mod = this;
			if (mod.skipAdTimeoutInterval) {
				clearInterval(mod.skipAdTimeoutInterval);
				mod.skipAdTimeoutInterval = null;
			}
		},

		skipAd: function () {
			var mod = this;
			if (mod.player.ads) {
				if (mod.player.ima3.adsManager) {
					mod.player.ads.endLinearAdMode();
					mod.player.ima3.adsManager.pause();
					mod.player.ima3.adsManager.skip();
					mod.log('skipped ad');
				} else {
					mod.log('can’t skip cause this is the ima3', mod.player.ima3);
				}
			}
		},

		detectAndroidPhone: function () {
			var ua = navigator.userAgent.toLowerCase(),
				isAndroid = ua.indexOf('android') > -1;

			return isAndroid ? true : false;
		},

		initVideoPlaybutton: function () {
			var mod = this,
				$ctx = mod.$ctx,
				$videoPlaybutton = $ctx.find('.video-playbutton-container');

			$videoPlaybutton.click(function () {
				mod.play();
			});

			// detect android phones
			if (mod.detectAndroidPhone()) {
				// show play button placeholder
				// set class to hide webkit default controls
				$ctx.addClass('is-android');
			}
		},

		// API
		getPlayer: function () {
			return this.player;
		},

		pause: function () {
			var mod = this;

			if (mod.player) {
				mod.player.pause();
			} else {
				mod.apiCache.pause = true;
			}
		},

		play: function () {
			var mod = this;
			if (mod.player) {
				mod.player.play();
			} else {
				mod.apiCache.play = true;
			}
		},

		isPlaying: function () {
			var mod = this;
			if (mod.player) {
				return !mod.player.paused();
			}
			return mod;
		},

		dispose: function () {
			var mod = this;
			mod.cleanup();
			for (var name in mod) {
				if (mod.hasOwnProperty(name)) {
					mod[name] = null;
				}
			}
		},

		initialVideoChanged: function (mod, video) {
			mod.log('fire brightcoveFirstVideoReady');
			mod.fire('brightcoveFirstVideoReady', {'currentVideoId': parseInt(video.id, 10), 'tags': video.tags, 'thumbnailURL': video.thumbnail, 'name': video.name});
			if (mod.isInOverlay) {
				mod.trackVideoPageCall(mod.createUrl(video.id, video.name));
			}
		},

		videoChanged: function (mod, video, isFirst) {
			mod.updateAspectRatio(video);
			mod.log('videoChanged', mod.$dummyVideoTag.attr('data-video-id'), video.id);
			// Update the video id in case we need to reload the player using initPlayer()
			mod.$dummyVideoTag.attr('data-video-id', video.id);

			// Only update to new video if it is a different video, because this can be called multiple times at startup because of ads, etc.
			if (!isFirst && mod.currentVideo && video.id !== mod.currentVideo.id) {
				var data = {'currentVideoId': video.id, 'name': video.name, 'description': video.description};
				mod.fire('brightcoveChangedVideoReady', data);
				window.setTimeout(function () {
					mod.updateToNewVideo(data);
				}, 10); // keep in separate “thread” so that any IE-errors with the player do not stop the action

				mod.log('fire brightcoveChangedVideo > currentVideoId = ' + video.id);
			}

			/*if(mod.player.paused()) {
				// Register listener for next play
				mod.player.one('play', function initialPlay() {
					mod.log('initial play after video change');
					// Trigger the ad request on first play after loadstart
					mod.triggerAdRequest();
				});
			} else {
				// Already playing: call ad request directly
				mod.triggerAdRequest();
			}*/

			var newUrl = mod.createUrl(video.id, video.name);

			mod.log('fire urlChanged', newUrl);
			mod.sendUrlChangeToModules({
				url: newUrl,
				title: video.name,
				description: video.description
			});

			// save current video for check next time
			mod.currentVideo = video;

			// reset initial timeout for skipping ads
			mod.skipAdTimeoutElapsed = 0;

			if(mod.autostart) {
				setTimeout(function() {mod.play();}, 10);
			}
		},

		videoFinished: function (video, mod) {
			if (video) {
				mod.fire('brightcoveFinishedVideo', {'currentVideoId': video.id});
				mod.log('fire brightcoveFinishedVideo > currentVideoId = ' + video.id);
			}
		},

		updateAspectRatio: function (video) {
			var mod = this;

			var largestSource = null,
				sourcesLength = video.sources ? video.sources.length : 0;
			for (var i = 0; i < sourcesLength; i += 1) {
				var source = video.sources[i];
				if (('width' in source && 'height' in source) && (largestSource === null || largestSource.width < source.width)) {
					largestSource = source;
				}
			}

			var aspectRatio = 4 / 3;
			if (largestSource) {
				aspectRatio = largestSource.width / largestSource.height;
			}

			mod.$wrapper.css({paddingBottom: '' + (100 / aspectRatio) + '%'});
		},

		onBrightcovePlayVideo: function (data) {
			var mod = this;

			if (mod.isPlaying()) {
				mod.pause();
			}

			if (!mod.player){
				mod.log('Player not initialized, storing id: ' + data.currentVideoId);
				mod.videoOnHold = data;
				return;
			}

			mod.player.catalog.getVideo(data.currentVideoId, function (error, video) {
				if (error) {
					mod.log('Loading video mediainfo failed for ' + data.currentVideoId);
					return;
				}
				// This will trigger a “loadstart” event
				try {
					mod.player.catalog.load(video);
				} catch (e) {
					mod.log('Loading video failed for id_' + data.currentVideoId);
					mod.log('Try again, to load video for id_' + data.currentVideoId);
					//try again
					mod.player.catalog.load(video);
				}
			});
		},

		updateToNewVideo: function (data) {
			// update title/url and fire urlupdated
			var mod = this,
				videoId = data.currentVideoId,
				videoTitle = data.name,
				videoDescription = data.description,
				url = mod.createUrl(videoId, videoTitle);

			mod.log('onBrightcoveChangedVideo > currentVideoId = ' + data.currentVideoId);

			if (!mod.isInOverlay && window.history && window.history.pushState) {
				window.history.pushState(null, videoTitle, url);
			}

			if (!mod.isInOverlay) {
				document.title = videoTitle;
				$('.modBrightcoveVideo h1.title').text(videoTitle);
			}
			else {
				$('.sc-overlay-container .modBrightcoveVideo h1.title').text(videoTitle);
			}

			if (videoDescription) {
				mod.$ctx.find('.lead p').text(videoDescription);
			}
			else {
				mod.$ctx.find('.lead p').text('');
			}

			// track video page call
			mod.trackVideoPageCall(url);


		},

		createUrl: function (id, title) {
			var mod = this,
				currentUrl = mod.$ctx.data('video-page-url') || document.location.href;
			if (currentUrl.indexOf('http') !== 0) {
				currentUrl = $('<a />').attr('href', currentUrl)[0].href; // make url absolute
			}

			currentUrl = currentUrl.replace(/\.galleryoverlay\./g, '.');

			var urlParts = currentUrl.split('.');

			var html = urlParts.pop();
			if (html !== 'html') {
				// Not an ordinary page => do nothing
				return currentUrl;
			}

			// Cut off the first “id-” (if found) and everything that follows (should mostly include the title)
			for (var i = 0; i < urlParts.length; i += 1) {
				if (urlParts[i].indexOf('id-') === 0) {
					urlParts = urlParts.slice(0, i);
					break;
				}
			}

			// Add the id to the url
			urlParts.push('id-' + id);

			// Add the (normalized) title to the url
			urlParts.push((!title || title.length < 2) ? 'notitle' : SCS.Url.getValidSelector(title).toLowerCase());

			// Add the html again
			urlParts.push(html);

			return urlParts.join('.')+(document.location.search||'');
		},

		trackVideoPageCall: function () {
			// Net-Metrix
			// jshint camelcase: false
			if (window.NETMX_track) {
				window.NETMX_track();
			}
		},

		sendUrlChangeToModules: function (data) {
			var mod = this;
			if (mod.isInOverlay) {
				$('.sc-overlay-container .mod[data-connectors*=urlchange]').each(function () {
					var tempMod = mod.sandbox.getModuleInstance(this);
					if (tempMod && tempMod.onUrlChanged) {
						tempMod.onUrlChanged(data);
					}
				});
			}
			else {
				mod.fire('urlChanged', data);
			}
		},

		onToggleVisibility: function(data) {
			var mod = this;
			// jshint unused: false
			if (this.$ctx.is(':visible')) {
				mod.log('toggleVisibility event called > player visible');
				if (!this.player) {
					this.initPlayer();
				}
			}
			else {
				mod.log('toggleVisibility event called > player hidden');
				if (this.player) {
					this.cleanup();
				}
			}
		}

	});

}(window.Tc.Module, __webpack_provided_window_dot_Tc_dot_$, window, window.SCS = window.SCS || {}));

}.call(window));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_Tc_dot_$) {/*** IMPORTS FROM imports-loader ***/
var loadTerrific = __webpack_require__(1);
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function ($) {
	'use strict';
	/*globals Tc, debug, google */

	/**
	 * @author Matthias Inauen
	 * @namespace Tc.Module
	 * @class Google Maps
	 * @extends Tc.Module
	 *
	 */
	Tc.Module.GoogleMaps = Tc.Module.extend({

		channelId: 'googleMaps',
		statusMapLoaded: 'googleMapLoaded',
		drawMapLocations: 'googleMapDrawLocations',
		statusShowMap: 'googleMapShowMap',
		markerPinImageHeight: 30,
		DEFAULT_LAT: 47.378388,
		DEFAULT_LNG: 8.539193,
		DEFAULT_ZOOM: 16,

		init: function($ctx, sandbox, modId) {
			this.$ctx = $ctx;
			this.mapCenterLat = (this.$ctx.data('centerlat')) ? parseFloat(this.$ctx.data('centerlat')) : this.DEFAULT_LAT;
			this.mapCenterLng = (this.$ctx.data('centerlng')) ? parseFloat(this.$ctx.data('centerlng')) : this.DEFAULT_LNG;
			this.mapZoom = (this.$ctx.data('mapzoom')) ? parseInt(this.$ctx.data('mapzoom')) : this.DEFAULT_ZOOM;
			this.markerPinImage = this.$ctx.data('pinurl');
			this.mapmarkers = [];
			this.locations = this.$ctx.data('locations');
			this.lazyLoad = this.$ctx.data('lazyload') ? true : false;
			if(this.markerPinImage){
				$('<img>').on('load', $.proxy(this.setPinImageHeight, this)).attr('src', this.markerPinImage);
			}

			this.initialiazed = false;
			this._super($ctx, sandbox, modId);
		},

		/**
		 * Hook function to do all of your module stuff.
		 *
		 * @method on
		 * @param {Function} callback function
		 * @return void
		 */
		on: function (callback) {

			if( !this.lazyLoad ) {
				this.initGoolgeMapModule();
			}
			callback();
		},

		setPinImageHeight: function(event){
			this.markerPinImageHeight = event.target.height;
		},

		loadMap: function() {
			Tc.Module.GoogleMaps.globalMapLoaded = $.proxy(this.mapLoaded, this);
			var script = document.createElement('script');
			script.type = 'text/javascript';
			script.src = 'https://maps.googleapis.com/maps/api/js?v=3.exp&' +
				'key=AIzaSyCZ7XcxAZ9vixukf6fm5EaUvAAfjzdw7Zw&' + // pragma: allowlist-secret
				'callback=Tc.Module.GoogleMaps.globalMapLoaded';
			document.body.appendChild(script);
		},

		mapLoaded: function(){
			var mod = this;

			mod.fire(mod.statusMapLoaded, {}, [mod.channelId]);

			mod.initializeMap();
		},

		initializeMap: function(){
			var mod = this;

			mod.mapOptions = {
				center: new google.maps.LatLng(mod.mapCenterLat, mod.mapCenterLng),
				zoom: mod.mapZoom
			};

			mod.map = new google.maps.Map(document.getElementById(mod.$ctx.attr('id')), mod.mapOptions);
			mod.geocoder = new google.maps.Geocoder();
			mod.mapInfoWindow = new google.maps.InfoWindow({pixelOffset: new google.maps.Size(0, -this.markerPinImageHeight) });
			this.drawMapMarkers();
		},

		drawMapMarkers: function() {
			var i,
				locationData,
				length,
				latlng,
				mod = this;
			this.createGoogleCnt = this.createGoogleCnt || 0;

			if( typeof google !== "undefined" ) {
				mod.clearMapMarkers();
				if(mod.locations){
					for(i = 0, length = mod.locations.length; i < length; i++){
						locationData = mod.locations[i];
						if( locationData.locationlat !== '' && locationData.locationlng !== '' ) {
							latlng = new google.maps.LatLng( parseFloat(locationData.locationlat), parseFloat(locationData.locationlng) );
							mod.drawLocation( latlng, locationData.title, locationData.description );
						}
						else if( locationData.address && locationData.address !== '' ) {
							mod.geolockup( locationData );
						}

					}
				}
			} else {
				if (this.createGoogleCnt < 10) {
					this.createGoogleCnt++;
					setTimeout($.proxy(this.drawMapMarkers, this), 500);
				}
			}
		},

		drawLocation: function( latlng, title, description ){

			var marker = new google.maps.Marker({
				position: latlng,
				title: title,
				icon: this.markerPinImage,
				map: this.map
			});

			this.mapBounds.extend(marker.position);
			google.maps.event.addListener(marker, 'click', $.proxy(this.handleMarkerClicked, this));
			this.mapmarkers.push({ marker: marker, infoWindowContent: description.replace(new RegExp('\r?\n','g'), '<br />') });
			// you have to do this everytime, cause geolockups are asynchronous
			this.map.fitBounds(this.mapBounds);
		},

		clearMapMarkers: function(){
			var markerItem;
			if( this.map && this.mapmarkers.length ){
				while(this.mapmarkers.length){
					markerItem = this.mapmarkers.pop();
					google.maps.event.clearInstanceListeners(markerItem.marker);
					markerItem.marker.setMap(null);
				}
			}

			this.mapBounds = new google.maps.LatLngBounds();
			this.mapmarkers = [];
		},

		geolockup: function( locationData ){
			var mod = this;
			mod.geocoder.geocode( { 'address': locationData.address }, function(results, status) {
				if (status == google.maps.GeocoderStatus.OK) {
					mod.drawLocation(results[0].geometry.location, locationData.title, locationData.description);
				}
			});
		},

		handleMarkerClicked: function(event){
			this.mapInfoWindow.close();
			this.mapInfoWindow.setOptions({
				content: this.getDescriptionFromLatLng(event.latLng),
				pixelOffset: new google.maps.Size(0, -(this.markerPinImageHeight + 5))
			});
			this.mapInfoWindow.setPosition(event.latLng);
			this.mapInfoWindow.open(this.map);
		},

		getDescriptionFromLatLng: function( latlng ){
			var i, length, markerItem, description = '';
			for( i = 0, length = this.mapmarkers.length; i < length; i++){
				markerItem = this.mapmarkers[i];
				if(latlng.equals(markerItem.marker.position)) {
					description = "<div class=\"googleMapsInfoWindowContentWrapper\">"+markerItem.infoWindowContent+"</div>";
					break;
				}
			}

			return description;
		},

		getMarkerFromLatLng: function( lat, lng ){
			var i, length,
				latlng = new google.maps.LatLng(lat, lng),
				markerItem = null;

			for( i = 0, length = this.mapmarkers.length; i < length; i++){
				markerItem = this.mapmarkers[i];
				if(latlng.equals(markerItem.marker.position)) {
					break;
				}
			}

			return markerItem;
		},

		onGoogleMapLoaded: function(){
			this.initializeMap();
		},

		/**
		 * Channel Call Handler.
		 * Expects an Array with location Objects in data.locations as follows:
		 *
		 * data.locations = [
		 *						{title: (String), locationlat: (Float), locationlng: (Float), description: (String), address: (String)},
		 *						...
		 * 					]
		 *
		 * @param data
		 */
		onGoogleMapDrawLocations: function(data){
			this.initGoolgeMapModule();
			this.locations = data.locations;
			this.drawMapMarkers();
		},

		/**
		 * Resizes the google map container to the parent container with potentially changed dimensions.
		 * The data attribute may have a new mapcenter position. (which should be an object of {lat: (float), lng: (float) }
		 * @param data
		 */
		onGoogleMapShowMap: function(data) {
			this.initGoolgeMapModule();
			google.maps.event.trigger(this.map, 'resize');
			this.map.fitBounds(this.mapBounds);

			if( data.mapcenter ) {
				this.map.setCenter(data.mapcenter);
				var marker = this.getMarkerFromLatLng( data.mapcenter.lat, data.mapcenter.lng );

				if( marker.marker ){
					google.maps.event.trigger(marker.marker, 'click', { latLng: marker.marker.position });
				}
			}
		},

		initGoolgeMapModule: function() {
			if ( this.initialiazed == false ) {
				if((typeof(window.google) === 'undefined' || typeof(window.google.maps) === 'undefined')) {
					if(!Tc.Module.GoogleMaps.globalMapsLibIsLoading){
						Tc.Module.GoogleMaps.globalMapsLibIsLoading = true;
						this.loadMap();
					}
					else {
						// do nothing and wait for a call on the channel.
					}
				}
				else {
					this.initializeMap();
				}
				this.initialiazed = true;
			}
		}
	});
}(__webpack_provided_window_dot_Tc_dot_$));

}.call(window));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_Tc_dot_$) {/*** IMPORTS FROM imports-loader ***/
var loadTerrific = __webpack_require__(1);
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

var imageLoaded = __webpack_require__(4).imageLoaded;

(function ($, Tc, SCS) {
	'use strict';

	var TRACKING_EVENT_ACTION = 'view';
	var TRACKING_EVENT_CATEGORY = 'slider';

	/**
	 * Wrapper for BxSlider2
	 *
	 * @author Matthias Inauen
	 * @namespace Tc.Module
	 * @class Slider
	 * @extends Tc.Module
	 */
	Tc.Module.Slider = Tc.Module.extend({
		/**
		 * Initialize Slider - only if more than one element is present
		 *
		 * @method on
		 * @param {Function} callback function
		 * @return void
		 */
		on: function (callback) {
			var mod = this;

			mod.animationInterval = mod.$ctx.data('animationInterval') ? mod.$ctx.data('animationInterval') : 0;
			mod.loopAround = mod.$ctx.data('loopAround') ? true : false;
			mod.startIndex = mod.$ctx.data('startIndex') ? (parseInt(mod.$ctx.data('startIndex'), 10) - 1) : 0;
			mod.deepLinking = mod.$ctx.data('deepLinking') ? true : false;
			mod.sliderId = mod.$ctx.data('sliderId');
			mod.isMobile = $(document.body).hasClass('is-mobile');
			mod.videoVolume = mod.$ctx.find('.video-volume');
			mod.slides = mod.$ctx.find('ul.bx-slider .modSlide');
			mod.disableTracking = mod.$ctx.data('disable-tracking');
			mod.trackingLocation = mod.$ctx.data('event-location');
			mod.trackingStarted = false;
			mod.noControlsFadeout = mod.$ctx.data('no-controls-fadeout');
			mod.controls = {};
			mod.componentInitialized = false;
			mod.redrawDebounceTimer = 0;

			if (mod.slides.length <= 1) {
				mod.$ctx.addClass('no-controls');
			}

			mod.controlsEnabled = !mod.$ctx.hasClass('no-controls');

			if (mod.deepLinking && mod.sliderId) {
				var deepLinkValue = parseInt(SCS.HashDeepLink.get(mod.sliderId), 10) - 1; // make base 0
				mod.startIndex = (deepLinkValue) ? parseInt(deepLinkValue, 10) : mod.startIndex;
				// make sure start index is not larger than amount of slides available
				mod.startIndex = (mod.startIndex >= mod.$ctx.find('.modSlide').length) ? 0 : mod.startIndex;
			}

			// subscribe to my own channel, so others can communicate back
			this.sandbox.subscribe('SLIDER', this);
			var uuid = Math.floor((Math.random() * 100000000000)) + '-' + Math.floor((Math.random() * 100000000000));
			this.$ctx.attr('data-id', uuid);
			if(this.$ctx.hasClass('sdx') && !this.$ctx.hasClass('fullbleed')) {
				var elemWidth = this.$ctx.parent().width();
				var $customStyle = $('<style>[data-id="' + uuid + '"] .bx-wrapper { width: ' + elemWidth + 'px; } </style>');
				this.$ctx.prepend($customStyle);
			}

			this.initSlider();
			// controls only exist after slider is initialized.
			mod.controls = mod.$ctx.find('.bx-controls');
			mod.addEventListeners();

			mod.$ctx.removeClass('not-initialized');

			callback();
		},

		initSlider: function () {
			var options = {
				pause: (this.animationInterval * 1000),
				speed: 300,
				startSlide: this.startIndex,
				infiniteLoop: this.loopAround,
				auto: (this.animationInterval > 0),
				preloadImages: 'visible',
				hideControlOnEnd: true,
				nextText: '',
				prevText: '',
				touchEnabled: this.controlsEnabled && this.isMobile,
				useCSS: false, // true will kill the loop around feature.
				responsive: true,
				adaptiveHeight: false,
				onSlideBefore: $.proxy(this.handleBeforeSlide, this),
				onSliderLoad: $.proxy(this.lazyLoadFirstItem, this)
			};

			if (this.deepLinking && this.sliderId) {
				options.onSlideAfter = $.proxy(this.setDeepLink, this);
			}

			this.slider = $('ul.bx-slider', this.$ctx).bxSlider(options);
		},

		lazyLoadFirstItem: function () {
			var index = this.startIndex,
				mod = this;
			// bx slider in infinite loop mode, will clone the first and last item
			if (mod.loopAround) {
				// let's preload the cloned elements to allow for smooth looping transition.
				mod.$ctx.find('.bx-clone').each(function () {
					mod.handleBeforeSlide($(this));
				});
			}

			mod.handleBeforeSlide(mod.slides.eq(index));
			// make sure the initialization ends first.
			this.componentInitialized = true;
			setTimeout(function () {
				mod.fire('sliderSlideInitialized', {index: mod.startIndex, sliderId: mod.sliderId, slideId: mod.slides.eq(index).data('id')}, ['SLIDER']);
				if (!mod.disableTracking && !mod.animationInterval && mod.slides.length > 1) {
					mod.trackingStarted = true;
					if (SCS && SCS.portal && SCS.portal.datalayer) {
						SCS.portal.datalayer.trackEvent(TRACKING_EVENT_ACTION, mod.slides.eq(index).data('event-label'), mod.trackingLocation, TRACKING_EVENT_CATEGORY);
					}
				}
			}, 0);
		},

		/**
		 * Lazy load all images just before switching to new slide.
		 * @param $slideElement
		 * @param oldIndex
		 * @param newIndex
		 */
		handleBeforeSlide: function ($slideElement, oldIndex, newIndex) {
			var image = $slideElement.find('img');

			if (image.length) {
				if (!this.isMobile) {
					this.stopAllVideos();
					this.loadVideo(image);
				}

				this.loadImage(image);
			}

			this.fireSliderSlideChanged($slideElement.data('id'), newIndex);
		},

		/**
		 * lazy load the image if the image does not have a src set yet.
		 * @param image
		 */
		loadImage: function (image) {
			var url;

			if (image.attr('src').length === 0) {
				if (this.isMobile) {
					url = image.data('m-image') ? image.data('m-image') : image.data('d-image');
				} else {
					url = image.data('d-image');
				}

				image.attr('src', url).one('load', $.proxy(this.handleResize, this));
			}
		},

		loadVideo: function (image) {
			var videoUrl = image.data('video'),
				mod = this,
				disableLoop = image.data('disable-loop'),
				showPoster = image.data('show-poster');

			if (image.parent().is('video')) {
				this.unPauseVideo(image.parent().get(0));
			}
			else if (videoUrl && videoUrl.length > 0) {
				var url;
				if (showPoster) {
					if (this.isMobile) {
						url = image.data('m-image') ? image.data('m-image') : image.data('d-image');
					} else {
						url = image.data('d-image');
					}
				}
				image.wrap('<video muted="muted" ' + (disableLoop ? '' : 'loop="true"') +
					(showPoster ? ' poster="' + url + '"' : '') +
					' src="' + videoUrl + '"></video>');
				// loop = true, for browser that support that attribute, like safari iPad
				// for browsers that don't support the loop attribute, wait for the ended event and restart.
				// loop = true will loop before calling the ended event, hence this will never be called in that case.
				if(!disableLoop) {
					image.parent('video').on('ended', function () {
						mod.playVideoFromStart(this);
					});
				}
				// update video list
				this.videos = this.$ctx.find('video');

				this.playVideoFromStart(image.parent().get(0));
			}
		},

		stopAllVideos: function () {
			if (this.videos) {
				this.videos.each(function () {
					this.pause();
				});
			}
		},

		playVideoFromStart: function (videoDomEl) {
			videoDomEl.load();
			videoDomEl.play();
		},

		unPauseVideo: function (videoDomEl) {
			videoDomEl.play();
		},

		handleResize: function () {
			this.redraw();
		},

		handleOrientationChange: function () {
			if (this.slider) {
				this.slider.parent().css('height', 'auto');
				this.redraw();
			}
		},

		handleMouseEnter: function () {
			this.showHideControl(0, 300, 1);
			this.startStopAutoPlay(false);
		},

		handleMouseLeave: function () {
			this.showHideControl(750, 500, 0);
			this.startStopAutoPlay(true);
		},

		handleTouchStart: function () {
			this.showHideControl(0, 100, 1, 150);
			this.startStopAutoPlay(false);
		},

		handleTouchEnd: function () {
			this.showHideControl(500, 350, 0, 150);
			this.startStopAutoPlay(true);
		},

		handleVideoVolume: function (event) {
			var button = $(event.currentTarget),
				slide = button.closest('.modSlide'),
				video = slide.find('video').eq(0).get(0);

			if (button.is('.video-volume-off') || button.is('.video-volume-on')) {
				video.muted = !video.muted;
				button.addClass('hidden');
				button.siblings('button').removeClass('hidden');
			}
		},

		startStopAutoPlay: function (startAuto) {
			if (!this.animationInterval || this.animationInterval <= 0) {
				return;
			}

			if (startAuto) {
				this.slider.startAuto();
			}
			else {
				this.slider.stopAuto();
			}
		},

		setDeepLink: function ($sliderItem, oldIndex, newIndex) {
			SCS.HashDeepLink.set(this.sliderId, (newIndex + 1));
		},

		/**
		 * Does the show hide animation of the controls ui.
		 * @param delay - in ms
		 * @param duration - in ms
		 * @param alpha - from 0 - 1
		 * @param startDelay - in ms
		 */
		showHideControl: function (delay, duration, alpha, startDelay) {
			var mod = this;
			startDelay = startDelay || 0;
			if (this.controlsEnabled) {
				setTimeout(function () {
					mod.controls.stop(true).delay(delay).fadeTo(duration, alpha);
				}, startDelay);
			}
		},

		addEventListeners: function () {
			if (!this.noControlsFadeout) {
				this.$ctx.on('mouseenter', $.proxy(this.handleMouseEnter, this));
				this.$ctx.on('mouseleave', $.proxy(this.handleMouseLeave, this));

				$(document.body).on('touchstart', $.proxy(this.handleTouchStart, this));
				$(document.body).on('touchend', $.proxy(this.handleTouchEnd, this));
			}

			if (!this.isMobile) {
				$(window).on('resize', $.proxy(this.handleResize, this));
			} else {
				$(window).on('orientationchanged', $.proxy(this.handleOrientationChange, this));
			}


			// Redraw slider after all slider images are (lazy)loaded
			Promise.all(this.$ctx.find('img').get().map(imageLoaded)).then(this.redraw.bind(this, true));

			this.videoVolume.on('click', '.video-volume-on, .video-volume-off', $.proxy(this.handleVideoVolume, this));
		},

		/**
		 * Find the slide with slideId and make it the active slide
		 * @param slideId
		 */
		gotoSlideWithId: function (slideId) {
			var mod = this;
			if (slideId) {
				mod.slides.each(function (index, slide) {
					if ($(slide).data('id') === slideId) {
						mod.slider.goToSlide(index);
						mod.fireSliderSlideChanged(slideId, index);
						return false;
					}
				});
			}
		},

		/**
		 * Fires Terrific event sliderSlideChanged
		 *
		 * @param slideId string
		 * @param newIndex number
		 */
		fireSliderSlideChanged: function (slideId, newIndex) {
			this.fire('sliderSlideChanged', {index: newIndex, sliderId: this.sliderId, slideId: slideId}, ['SLIDER']);
			if (this.trackingStarted) {
				if (SCS && SCS.portal && SCS.portal.datalayer) {
					SCS.portal.datalayer.trackEvent(TRACKING_EVENT_ACTION, this.slides.eq(newIndex).data('event-label'), this.trackingLocation, TRACKING_EVENT_CATEGORY);
				}
			}
		},

		/**
		 * Terrific message handler to auto scroll to slide
		 * @param data      requires a slideId attribute, that is either e single slideId or an array of slideIds
		 */
		onSliderGotoSlide: function (data) {
			var mod = this;
			var slideId = data.slideId;

			if (slideId) {
				if ($.isArray(slideId)) {
					for (var i = 0; i < slideId.length; i += 1) {
						mod.gotoSlideWithId(slideId[i]);
					}
				}
				else if ($.type(slideId) === 'string') {
					mod.gotoSlideWithId(slideId);
				}
			}
		},

		redraw: function(lazy) {
			var mod = this;
			if (this.slider) {
				var redraw = function() {
					mod.$ctx.addClass('redrawing');
					mod.$ctx.find('.bx-viewport').css('height', '');
					mod.slider.parent().css('height', 'auto');
					mod.slider.redrawSlider();
					mod.$ctx.removeClass('redrawing');
				}
				if (lazy) {
					// Clear pending timer
					if (this.redrawDebounceTimer) {
						clearTimeout(this.redrawDebounceTimer);
					}
					this.redrawDebounceTimer = setTimeout(redraw, 50);
				} else {
					redraw();
				}
			}
		}
	});
})(__webpack_provided_window_dot_Tc_dot_$, window.Tc, window.SCS = window.SCS || {});

}.call(window));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_Tc_dot_$) {/*** IMPORTS FROM imports-loader ***/
var loadTerrific = __webpack_require__(1);
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function ($, Tc) {
	'use strict';
	/**
	 * Skin for rotating teaser theme of the slider.
	 * Implemented as part of the new story project
	 *
	 * @author Matthias Inauen
	 * @namespace Tc.Module.Slider
	 * @class RotatingTeaser
	 * @extends Tc.Module
	 * @constructor
	 */
	Tc.Module.Slider.RotatingTeaser = function(parent) {

		this.on = function(callback) {
			parent.on.call(this, callback);
		};

		/**
		 * Find the closest sibling slide that is not disabled
		 * and activate that slide instead.
		 * @param $slide
		 */
		this.activateNextEnabledSibling = function($slide){
			var mod = this;
			var siblingVicinity;
			var $sibling;

			$slide.siblings(':not(.disabled)').each(function(index, sibling){
				var vicinity = Math.abs(mod.slides.index($(sibling)) - mod.slides.index($slide));
				if(!siblingVicinity || vicinity < siblingVicinity) {
					siblingVicinity = vicinity;
					$sibling = $(sibling);
				}
			});

			if($sibling && $sibling.length){
				mod.gotoSlideWithId($sibling.data('id'));
			}
			else {
				// disable whole slider
			}
		};

		this.after = function(){
			var delayTime = this.isMobile ? 1500 : 150;

			setTimeout($.proxy( this.setSliderHeight, this), delayTime);

			if(this.isMobile){
				$(window).on('load', $.proxy(this.setSliderHeight, this));
			}
		};

		this.initSlider = function () {
			this.controlsEnabled = this.isMobile;
			this.$ctx.toggleClass('no-controls', !this.controlsEnabled);

			var options = {
				pause: (this.animationInterval * 1000),
				speed: 240,
				startSlide: this.startIndex,
				infiniteLoop: this.loopAround,
				auto: (this.animationInterval > 0),
				preloadImages: 'visible',
				hideControlOnEnd: false,
				nextText: '',
				prevText: '',
				touchEnabled: this.isMobile,
				swipeThreshold: 50,
				useCSS: false, // has to be off, bx slider can not handle end-off animation in transitions, which will break the slider
				responsive: true,
				adaptiveHeight: false,
				onSlideBefore: $.proxy(this.handleBeforeSlide, this),
				onSlideAfter: this.handleAfterSlide.bind(this),
				onSliderLoad: $.proxy(this.cleanupSliderOnLoad, this),
				slideWidth: this.isMobile ? 280 : 300
			};

			if(this.deepLinking && this.sliderId) {
				options.onSlideAfter = $.proxy(this.setDeepLink, this);
			}

			this.slider = $('ul.bx-slider', this.$ctx).bxSlider(options);

			// Fix width 100% -> 100px problem
			if(this.slider.getCurrentSlideElement().width() < options.slideWidth){
				this.slider.children().css('width', options.slideWidth);

				// Fix slider position
				this.slider.css('left', -(options.startSlide*options.slideWidth));
			}
		};

		this.handleAfterSlide = function($slideElement) {
			if($slideElement.hasClass('disabled') && $slideElement.hasClass('active')) {
				this.activateNextEnabledSibling($slideElement);
			}
		}

		this.handleBeforeSlide = function($slideElement) {
			var activeSlideIndex = $slideElement.index();
			var $slideContent = $slideElement.find('.slideContent');
			var paddingTotal = parseInt($slideContent.css('padding-left'), 10) + parseInt($slideContent.css('padding-right'), 10);


			this.slides.removeClass('active leftOfActive');
			$slideElement.addClass('active');

			$.each(this.slides, function(index, slide){
				var $slide = $(slide);
				var slideIndex = $slide.index();
				var stepsAway = (activeSlideIndex >= slideIndex) ? (activeSlideIndex - slideIndex) : (activeSlideIndex + 1 - slideIndex);

				$slide.find('.slideContent').css('margin-left', stepsAway * paddingTotal);
			});

			parent.handleBeforeSlide.call(this, $slideElement);
		};

		this.handleSlideClicked = function(event){
			var $slide = $(event.currentTarget);

			if(!$slide.hasClass('disabled')) {
				var slideIndex = this.slides.index($slide);
				this.slider.goToSlide(slideIndex);
			}
		};

		this.showHideControl = $.noop;

		this.cleanupSliderOnLoad = function () {
			var mod = this;
			// enable transitions
			mod.$ctx.find('.bx-viewport').addClass('cf').prop('style', '');
			mod.lazyLoadFirstItem();
			mod.$ctx.removeClass('not-initialized');
			setTimeout(function(){
				mod.$ctx.addClass('transitionsEnabled');
			}, 0);
		};

		this.addEventListeners = function(){
			this.enable();
			parent.addEventListeners.call(this);
		};

		this.disable = function() {
			this.slides.off('click', $.proxy(this.handleSlideClicked, this));
			this.$ctx.addClass('disabled');
		};

		this.enable = function() {
			if(!this.isMobile){
				this.slides.on('click', $.proxy(this.handleSlideClicked, this));
			}
			this.$ctx.removeClass('disabled');
		};

		this.setSliderHeight = function(){
			var biggestSlideHeight = 0;

			this.slides.each(function(index, slide){
				var $slide = $(slide);
				var $slideContent = $slide.find('.slideContent');

				biggestSlideHeight = Math.max($slideContent.height(), biggestSlideHeight);
			});

			this.slides.find('.slideContent').css('min-height', biggestSlideHeight);

			// set the height of the viewport, so the controls wont move around when changing slides.
			this.$ctx.find('.bx-wrapper').css('height', biggestSlideHeight);
			this.$ctx.css('height', biggestSlideHeight);
		};

		// fired by Tc.Module.LegoContainer
		this.onSliderToggleEnable = function(data) {
			if (this.sliderId === data.sliderId) {
				if (data.enable) {
					this.enable();
				}
				else {
					this.disable();
				}
			}
		};

		/**
		 * Message handler to enable/disable individual slides.
		 * @param data
		 */
		this.onSetSlideState = function(data) {
			var $slide = this.slides.filter('[data-id='+data.slideId+']');

			if(!$slide.length || !this.componentInitialized || ($slide.hasClass('disabled') && data.disable === true)) {
				return;
			}

			$slide.toggleClass('disabled', data.disable);
			// if this is the currently active slide, that we are disabling
			// it can't stay active anymore.
			if($slide.hasClass('active') && data.disable === true) {
				this.activateNextEnabledSibling($slide);
			}
		};
	};
})(__webpack_provided_window_dot_Tc_dot_$, window.Tc);

}.call(window));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var loadTerrific = __webpack_require__(1);
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function($) {
	"use strict";
	/*globals Tc, SCS */

	/**
	 * Page module implementation.
	 *
	 * @author Bozo Jovicic
	 * @namespace Tc.Module
	 * @class Twitter
	 * @extends Tc.Module
	 */

	Tc.Module.Twitter = Tc.Module.extend({

		/**
		 * Hook function to do all of your module stuff.
		 *
		 * @method on
		 * @param {Function} callback function
		 * @return void
		 */
		on: function (callback) {
			var mod = this;

			callback();
		},

		after : function() {
			var mod = this;

			var tweetId = mod.$ctx.data('tweet-id');
			if(tweetId){
				var url = 'https://api.twitter.com/1/statuses/oembed.json?id=' + tweetId;
				var width = mod.$ctx.data('width');
				if(width){
					url += '&maxwidth=' + width;
				}

				$.getJSON(url + "&callback=?", null, function(res) {
					if(res && typeof(res.html) != "undefined") {
						mod.$ctx.find('.tweet').html(res.html);

						var tweetUrl = null;
						var resHtmlArray = res.html.split('\"');
						for (var i=0;i < resHtmlArray.length; i+=1) {
							if(resHtmlArray[i].indexOf('https://twitter.com/') > -1){
								tweetUrl = resHtmlArray[i];
							}
						}
						mod.$ctx.find('.tweet').closest('.image-post').data('url', tweetUrl);
					}
				});
			}
		}
	});

}(Tc.$));
}.call(window));

/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_Tc_dot_$) {/*** IMPORTS FROM imports-loader ***/
var loadTerrific = __webpack_require__(1);
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function ($, Tc) {
	'use strict';

	/**
	 * Add hash & querystring to link url
	 *
	 * @author Dimitri Sebeschuk
	 * @namespace Tc.Module
	 * @class LinkForwarder
	 * @extends Tc.Module
	 */
	Tc.Module.LinkForwarder = Tc.Module.extend({

		on: function (callback) {
			var mod = this;

			if (mod.$ctx.prop('tagName') === 'A') {
				mod.enhanceUrl(mod.$ctx);
			} else {
				mod.$ctx.find('a').each(function () {
					mod.enhanceUrl($(this));
				})
			}
			callback();
		},

		enhanceUrl: function (a) {
			var href = a ? a.attr('href') : '',
				url = href.split('?')[0],
				origSearch = a ? a.prop('search').substring(1) : '',
				origHash = a ? a.prop('hash') : '',
				query = window.location.search.length ? window.location.search : '';

			//add search
			query = query ? (origSearch ? query + '&' + origSearch : query) : (origSearch ? '?' + origSearch : '');
			//add hash
			query = query + (window.location.hash ? ( origHash ? window.location.hash + '&' + origHash : window.location.hash ) : ( origHash ? '#' + origHash : '' ));

			if (url && query) {
				a.attr('href', url + query);
			}
		}
	});

})(__webpack_provided_window_dot_Tc_dot_$, window.Tc);

}.call(window));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($, SnabbdomPragma) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bootstrap_load_snabbdom__ = __webpack_require__(9);

var TIMEOUT = 300;
var observer = new MutationObserver(mutationHandler);
var BROCKEN_NODES = ['body', 'blockquote', 'figure', 'td', 'details', 'dialog', 'fieldset', 'section', 'article', 'nav', 'aside'];
var warningTimeout;
var container;
var currentH1s;
var currentH1Count = -1;
function getContainer() {
    if (container) {
        return container;
    }
    container = document.createElement('div');
    container.setAttribute('class', 'sdx-container');
    $('body').prepend(container);
    return container;
}
function getH1() {
    var h1s = new Map();
    $('h1').each(function (_i, el) {
        var closest = getClosestBrockenNode(el);
        if (closest) {
            if (h1s.has(closest)) {
                h1s.get(closest).push(el);
            }
            else {
                h1s.set(closest, [el]);
            }
        }
    });
    return h1s;
}
function getClosestBrockenNode(el) {
    if (!el || !el.parentElement) {
        return null;
    }
    return BROCKEN_NODES.includes(el.parentElement.tagName.toLowerCase()) ? el.parentElement :
        getClosestBrockenNode(el.parentElement);
}
function getH1Count() {
    var count = 0;
    if (currentH1s.size === 0) {
        return count;
    }
    // Value is Array
    for (var _a = 0, _b = Array.from(currentH1s.values()); _a < _b.length; _a++) {
        var value = _b[_a];
        count = Array.isArray(value) && value.length > count ? value.length : count;
    }
    return count;
}
function getBody() {
    if (!getH1Count()) {
        return 'Attention, you forgot to define an H1 title.';
    }
    if (getH1Count() > 1) {
        return SnabbdomPragma.createElement("span", null,
            "Attention, you are not allowed to use more then one H1 title on this page, ",
            getH1Count(),
            " H1s were found",
            SnabbdomPragma.createElement("span", { className: "checkbox" },
                SnabbdomPragma.createElement("input", { type: "checkbox", name: "h1-highlight", id: "h1-highlight", value: "1", "data-role": "none" }),
                SnabbdomPragma.createElement("label", { for: "h1-highlight" }, "Highlight")));
    }
    return '';
}
function startObserve() {
    // Create an observer instance linked to the callback function
    observer.observe($('body')[0], { attributes: false, childList: true, subtree: true });
}
function closeWarning() {
    container = Object(__WEBPACK_IMPORTED_MODULE_0_bootstrap_load_snabbdom__["b" /* patch */])(getContainer(), SnabbdomPragma.createElement("div", null));
}
function toggleWarning() {
    currentH1s = getH1();
    if (currentH1Count === getH1Count()) {
        return;
    }
    currentH1Count = getH1Count();
    // Stop observer before update warning message
    observer.disconnect();
    if (currentH1Count !== 1) {
        $(document).trigger('h1-warning-show');
        container = Object(__WEBPACK_IMPORTED_MODULE_0_bootstrap_load_snabbdom__["b" /* patch */])(getContainer(), SnabbdomPragma.createElement("div", { className: "sdx-container h1-warning-container" },
            SnabbdomPragma.createElement("div", { className: "notification-header notification--alert notification--open" },
                SnabbdomPragma.createElement("div", { className: "notification__content" },
                    SnabbdomPragma.createElement("div", { className: "notification__body" }, getBody()),
                    SnabbdomPragma.createElement("button", { className: "notification__close notification-cancel", ariaLabel: "Close", "on-click": closeWarning },
                        SnabbdomPragma.createElement("i", { className: "icon icon-022-close", ariaHidden: "true" }))))));
        $('.h1-warning-container').on('click', '#h1-highlight', highlightHandler);
    }
    else {
        container = Object(__WEBPACK_IMPORTED_MODULE_0_bootstrap_load_snabbdom__["b" /* patch */])(getContainer(), SnabbdomPragma.createElement("div", { className: "sdx-container h1-warning-container" }));
        $(document).trigger('h1-warning-hide');
    }
    // Start observer after update warning message
    startObserve();
}
function highlightHandler(e) {
    var el = e.target;
    if (el.checked) {
        // Value is Array
        for (var _a = 0, _b = Array.from(currentH1s.values()); _a < _b.length; _a++) {
            var value = _b[_a];
            if (Array.isArray(value) && value.length > 1) {
                value.forEach(function (h1El) { return h1El.className += ' h1-warning-highlight'; });
            }
        }
    }
    else {
        $('h1').removeClass('h1-warning-highlight');
    }
}
function mutationHandler() {
    if (warningTimeout) {
        clearTimeout(warningTimeout);
    }
    warningTimeout = setTimeout(toggleWarning, TIMEOUT);
}
$(function () {
    if ($('body.h1Warning').length) {
        mutationHandler();
        startObserve();
    }
});

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0), __webpack_require__(10)))

/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_$) {(function ($, SCS, debug) {
	"use strict";
	// jshint camelcase: false

	var getPagePath = __webpack_require__(334).getPagePath;

	/**
	 * The page object according to the specifications
	 * @returns {Page}
	 * @constructor
	 */
	var Page = function () {
		$.extend(this, {
			init: function (path, language, cfu, viewtype, template) {
				SCS.portal.datalayer.originalPagePath = this.path = path || "";
				this.language = language || "";
				this.cfu = cfu || "";
				this.charset = "utf-8";
				this.viewtype = viewtype || "";
				this.template = template || "";
				this.pagetype = ""; // intentionally left empty
			}
		});
		//noinspection JSUnresolvedVariable
		this.init.apply(this, arguments);
		return this;
	};

	/**
	 * The platform object according to the specifications
	 * @returns {Platform}
	 * @constructor
	 */
	var Platform = function () {
		$.extend(this, {
			init: function (platform, environment) {
				this.platform = platform || "";
				this.environment = environment || "";
				this.context = "online";
			}
		});
		//noinspection JSUnresolvedVariable
		this.init.apply(this, arguments);
		return this;
	};

	/**
	 * The product object according to the specifications
	 * @returns {Product}
	 * @constructor
	 */
	var Product = function () {
		$.extend(this, {
			init: function (id, key, name) {
				this.id = id || "";
				this.key = key || "";
				this.name = name || "";
			}
		});
		//noinspection JSUnresolvedVariable
		this.init.apply(this, arguments);
		return this;
	};

	/**
	 * The product object according to the specifications
	 * @returns {Category}
	 * @constructor
	 */
	var Category = function () {
		$.extend(this, {
			init: function (name, value) {
				this.name = name || "";
				this.value = value || "";
			}
		});
		//noinspection JSUnresolvedVariable
		this.init.apply(this, arguments);
		return this;
	};

	/**
	 * Adds a product category to the currently(!) viewed product's Category list
	 */
	Product.prototype.withCategory = function (key, value) {
		if (key && value) {
			this.productCategory_list = this.productCategory_list || [];
			this.productCategory_list.push(new Category(key, value));
		}
		return this;
	};

	/**
	 * The Conversion object according to the specifications
	 * @see https://wiki.swisscom.com/pages/viewpage.action?spaceKey=TAG&title=Online+Data+Layer+Platform+Integration#OnlineDataLayerPlatformIntegration-Conversion
	 * @returns {Conversion}
	 * @constructor
	 */
	var Conversion = function () {
		$.extend(this, {
			init: function (category, detail, _class) {
				this.category = category || "";
				this.detail = detail || "";
				this['class'] = _class;
			}
		});
		//noinspection JSUnresolvedVariable
		this.init.apply(this, arguments);
		return this;
	};

	/**
	 * The link and conversion tracking event.
	 * @returns {Event}
	 * @constructor
	 */
	var Event = function () {
		$.extend(this, {
			init: function (action, label, location, category, linkName) {
				this.action = action || "";
				this.label = label || "";
				this.location = location || "";
				this.category = category || "";
				if (linkName) {
					this.linkName = linkName;
				}
			}
		});
		//noinspection JSUnresolvedVariable
		this.init.apply(this, arguments);
		return this;
	};

	/**
	 * The link and conversion tracking event.
	 * @returns {Interaction}
	 * @constructor
	 */
	var Interaction = function () {
		$.extend(this, {
			init: function () {
			}
		});
		//noinspection JSUnresolvedVariable
		this.init.apply(this, arguments);
		return this;
	};

	/**
	 * Set event information. Either conversion information OR event information can be set
	 * @param action
	 * @param label
	 * @param location
	 * @param category
	 * @param linkName
	 * @returns {Interaction}
	 */
	Interaction.prototype.withEvent = function (action, label, location, category, linkName) {
		this.event = new Event(action, label, location, category, linkName);
		return this;
	};

	/**
	 * Set conversion information. Either conversion information OR event information can be set
	 * @param conversionCategory
	 * @param conversionDetail
	 * @param conversionClass
	 * @returns {Interaction}
	 */
	Interaction.prototype.withConversion = function (conversionCategory, conversionDetail, conversionClass) {
		if (conversionCategory && conversionDetail) {
			this.conversion = new Conversion(conversionCategory, conversionDetail, conversionClass || "");
		} else {
			debug.log("SCS.portal.datalayer.js > withConversion > conversionCategory and Detail are mandatory in Conversion objects");
		}
		return this;
	};

	/**
	 *
	 * @param rawdata
	 * @returns {Interaction}
	 * Make sure event is set before calling this
	 */
	Interaction.prototype.withRawData = function (rawdata) {
		if (typeof this.event !== "undefined") {
			this.event.rawdata = rawdata;
		}
		return this;
	};

	Interaction.prototype.withProfile = function (profile) {
		this.profile = profile;
		return this;
	};

	Interaction.prototype.withProduct = function (product) {
		this.product = product;
		return this;
	};

	/**
	 * Fires the click Interaction. The action/label/location/category must always be set, even for the conversion tracking
	 */
	Interaction.prototype.track = function () {
		if (!SCS.datalayer || !SCS.datalayer.track) {
			debug.log("Cannot track event, SCS Datalayer not available at this time. Please check whether utag.sync.js has been loaded");
			return;
		}

		if (this.event && this.conversion) {
			debug.log("SCS.portal.datalayer.js > track > Warning: event and conversion set at the same time!");
		}

		// in order to not permanently add the event and avoid side effects on multiple
		// user interactions, we clone the existing trackObj to not modify it
		var dataObj = $.extend(true, {}, SCS.portal.datalayer.trackObj);

		// transfer all set props in data object
		for (var prop in this) {
			if (this.hasOwnProperty(prop) && typeof this[prop] !== "function") {
				dataObj[prop] = this[prop];
			}
		}

		// delegating tracking call to Tealium
		debug.log('SCS.portal.datalayer.js > Interaction > track', dataObj);
		SCS.datalayer.track(dataObj);
	};

	/**
	 * User information (currently only login status)
	 * @returns {Profile}
	 * @constructor
	 */
	var Profile = function (user) {
		$.extend(this, {
			init: function () {
				this.loggedIn = user ? "login" : "";
				if (user.getSegment()) {
					this.cfu = user.getSegment();
				}
			}
		});

		//noinspection JSUnresolvedVariable
		this.init.apply(this, arguments);
		return this;
	};

	/**
	 * The product object according to the specifications
	 * @returns {Cart}
	 * @constructor
	 */
	var Cart = function () {
		$.extend(this, {
			init: function (ordertotal) {
				this.ordertotal = new Number(parseFloat(ordertotal)).valueOf() || 0.0;
			}
		});
		//noinspection JSUnresolvedVariable
		this.init.apply(this, arguments);
		return this;
	};



	/**
	 * Namespace for Tealium related functionality
	 */
	SCS.portal = SCS.portal || {};
	SCS.portal.datalayer = {

		// This ist the basic data to be sent to Tealium. Will be enriched with various sub-objects, e.g. page and platform which are mandatory.
		// Whenever there is event tracking, e.g. click tracking using the Interaction.track function this data will be cloned as template
		trackObj: {},

		// flag indicating whether the page should track automatically or an explicit SCS.portal.datalayer.trackPageView has to be called.
		// e.g. true on product detail pages that first need to load product data from the ecommerce backend
		// may become obsolete with the new Hybris implementation
		isDeferred: false,

		//Set as soon as the initialize method has been called
		initialized: false,

		// stores the original trackObj.page.path value before it's extended e.g. used for click tracking tabs when the current tab
		// name shall be appended to page path
		originalPagePath: "",

		// used together with aforementioned originalPagePath for temporarily adding new page.path elements
		appendedPagePaths: [],

		/**
		 * Initialization function
		 *
		 * Depending on the 'deferred' parameter tracking data object is instantiated in the datalayer.
		 * If the page shall manage its own page view tracking, call the function with 'deferred' set to true
		 * but be aware that you will need to fire SCS.portal.datalayer.trackPageView when the page is ready loaded.
		 * A sample use case for this behavior are e.g. the product detail pages with the datahub where further product
		 * information needs assembled first before explicitly firing the tracking call
		 */
		initializeTrackingData: function (path, lang, cfu, viewtype, template, platform, environment, deferred) {
			var mod = this;
			debug.log("SCS.portal.datalayer.initializeTrackingData", arguments);
			this.isDeferred = deferred;
			this.initialized = true;

			// initialize mandatory page and platform data
			this.trackObj = {
				page: new Page(path, lang, cfu, viewtype, template),
				platform: new Platform(platform, environment)
			};

			__webpack_require__(5).getProfile().then(function(profile) {
				var user = profile.getUser();
				if(user) {
					mod.trackObj.profile = new Profile(user);
				}
			});
		},

		/**
		 * Check if the user is logged in
		 * @returns {string} "" or "login"
		 * @deprecated use lib/personalization/profile.ts
		 */
		isLoggedIn: function () {
			return (this.trackObj.profile && this.trackObj.profile.loggedIn) || "";
		},

		/**
		 * Set the optional page type
		 * @param pageType value from the pageType dropdown in page properties
		 */
		setPageType: function (pageType) {
			if (pageType) {
				this.trackObj.page.type = pageType;
			}
		},

		/**
		 * Sets the product in the tracking object. This contains the initially viewed product when opening the page
		 */
		setProduct: function (id, key, name, CategoryMaster, Category2, productBrand) {
			this.trackObj.product = this.createProduct(id, key, name, CategoryMaster, Category2, productBrand);
		},

		/**
		 * ODL Getter for the current product
		 * @return {SCS.}
		 */
		getProduct: function () {
			return this.trackObj.product || {};
		},

		/**
		 * ODL Getter for the template
		 * @returns {string|*}
		 */
		getTemplate: function () {
			return this.trackObj.page.template || '';
		},

		/**
		 * Sets the conversion information in the tracking object.
		 */
		setConversion: function (category, detail, _class) {
			this.trackObj.conversion = new Conversion(category, detail, _class);
		},

		/**
		 * ODL Getter for the template
		 * @returns {string|*}
		 */
		setCart: function (ordertotal) {
			this.trackObj.cart = new Cart(ordertotal);
		},

		/**
		 * Sets a custom UDO parameter in the datalayer
		 * @param name
		 * @param value
		 */
		addUdoProperty: function (name, value) {
			this.trackObj.udo = this.trackObj.udo || {};
			this.trackObj.udo[name] = value;
		},

		/**
		 * Creates a Product
		 */
		createProduct: function (id, key, name, CategoryMaster, Category2, productBrand) {
			return new Product(id, key, name)
				.withCategory("ProductCategoryMaster", CategoryMaster)
				.withCategory("ProductCategory2", Category2)
				.withCategory("Brand", productBrand);
		},

		/**
		 * Empties the current product_list
		 */
		resetProductList: function () {
			this.trackObj.product_list = [];
		},

		/**
		 * Adds an InOne product to the product_list.
		 * @param siebelName aka siebelId when it is actually the siebelName we're working with since the siebelId is environment dependent, like a primary database key
		 * @param {String} price the price
		 * @param {String} type can be either "bundle" or "flavour"
		 */
		addInOneProduct: function (siebelName, price, type) {
			if (!siebelName || !type || !/^(bundle|flavour)$/.test(type)) {
				debug.log("SCS.portal.datalayer.js > addInOneProduct > invalid type", type);
			} else {
				this.trackObj.product_list = this.trackObj.product_list || [];
				var product = new Product(siebelName, siebelName).withCategory("inOne", type);
				product.quantity = 1;
				product.priceRecurring = price || 0;
				this.trackObj.product_list.push(product);
			}
		},

		/**
		 * Queues a page view event to track a page view.
		 * Note that there will be an automatic implicit call on page load
		 */
		trackPageView: function () {
			var mod = this;
			// Wait until profile is available
			__webpack_require__(5).getProfile().then(function(profile) {
				if (window.SCS && window.SCS.datalayer && window.SCS.datalayer.page) {
					// delegate tracking call to Tealium
					SCS.datalayer.page(mod.trackObj, mod.isDeferred);
				} else {
					debug.log('SCS.datalayer.page not available, utag.sync.js not loaded?');
				}
			});
		},

		/**
		 * Fires a standard click Interaction with the default parameter set.
		 * If you wish to add more information like product or profile information,
		 * create a new Interaction and use the appropriate chaining methods, e.g.
		 * .withRawData(...) in combination with .track() to send the event manually.
		 * @param action the event action
		 * @param label the event label
		 * @param location the event location
		 * @param category the event category
		 * @param linkName the friendly name of the event/link (appears in SiteCatalyst link tracking reports)
		 */
		trackEvent: function (action, label, location, category, linkName) {
			if (action && label && location && category) {
				var interaction = new Interaction()
					.withEvent(action, label, location, category, linkName);
				interaction.track();
			}
		},

		/**
		 * Track a user conversion
		 * @param conversionCategory
		 * @param conversionDetail
		 * @param conversionClass
		 */
		trackConversion: function (conversionCategory, conversionDetail, conversionClass) {
			if (conversionCategory && conversionDetail) {
				var interaction = new Interaction()
					.withConversion(conversionCategory, conversionDetail, conversionClass);
				interaction.track();
			}
		},

		/**
		 * Appends an override to the current page page
		 * @param {string} value new path part to push on the stack
		 * @param {boolean} [popPreviousValue] whether to first remove the previous value on the stack. Defaults to false
		 * @param {boolean} [resetCompletely] whether to remove all items from the stack first. Defaults to false
		 * @param {string} [separator] optional separator when joining the path parts. Defaults to "/"
		 */
		pushPagePath: function (value, popPreviousValue, resetCompletely, separator) {

			// Check whether the previously added stack value is the same and if so abort. This may happen every once in a
			// while if components fire multiple times.
			if (this.appendedPagePaths.length > 0 && this.appendedPagePaths[this.appendedPagePaths.length - 1] === getPagePath(value)) {
				return false;
			}

			// Remove previous stack value
			if (popPreviousValue) {
				this.popPagePath();
			}

			// Remove all previous values from the stack
			if (resetCompletely) {
				this.appendedPagePaths = [];
			}

			this.appendedPagePaths.push(getPagePath(value));
			this.applyPagePath(separator);
			debug.log("SCS.portal.datalayer.js > pushPagePath > path is now ", this.trackObj.page.path);
			return true;
		},

		/**
		 * Removes an override from the current page path (last in, last out)
		 */
		popPagePath: function () {
			this.appendedPagePaths.pop();
			this.applyPagePath();
			debug.log("SCS.portal.datalayer.js > popPagePath > path is now ", this.trackObj.page.path);
		},

		/**
		 * Applys the page path overrides. This should not be called directly, but always using
		 * implicitly by calling pushPagePath and popPagePath
		 * @param {string} [separator] optional separator when joining the path parts. Defaults to "/"
		 */
		applyPagePath: function (separator) {
			separator = separator || '/';
			this.trackObj.page.path = this.originalPagePath;
			if (this.appendedPagePaths.length > 0) {
				this.trackObj.page.path += separator + this.appendedPagePaths.join(separator);
			}
		},

		/**
		 * Enable UX tracking (e.g. Clicktale) on Tealium side
		 * @param {boolean} value
		 */
		setUxTracking: function (value) {
			this.trackObj.apps = this.trackObj.apps || {};
			this.trackObj.apps.uxTracking = this.trackObj.apps.uxTracking || {};
			this.trackObj.apps.uxTracking.active = value;
		}

	};

	// export library classes
	SCS.portal.datalayer.Interaction = Interaction;

})(__webpack_provided_window_dot_$, window.SCS = window.SCS || {}, window.debug);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["getPagePath"] = getPagePath;
/**
 * Making sure path is always a string and never undefined.
 * SCS.datalayer handels sanitization internally by
 * implicitly calling SCS.tealium.sanitizeString.
 *
 * @returns string
 */
function getPagePath(path) {
    if (typeof path === 'string') {
        return path;
    }
    if (path === undefined) {
        return window.location.pathname;
    }
    // Ok now we do the best we can...
    return String(path);
}


/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {/**
 * (c) Copyright Swisscom (Schweiz) AG. All rights reserved.
 *
 * This product is the proprietary and sole property of Swisscom (Schweiz) AG
 * Use, duplication or dissemination is subject to prior written consent of
 * Swisscom (Schweiz) AG.
 *
 * $Id: faq.js
 */
$.namespace("SCS.faq");

SCS.faq.firstPageLoaded = false;
SCS.faq.gsaFirstPageLoaded = false;

/**
 * Initialize FAQ
 */
SCS.faq.init = function(resultPerPage, numResults) {

	$(window).on('hashchange', function() {
		SCS.faq.switchPage(location.hash, resultPerPage, numResults);
	});
	$(window).trigger('hashchange');
};

/**
 * Switch FAQ results page (Solution results)
 * @param hash Hash/Anchor (#)
 */
SCS.faq.switchPage = function(hash, resultPerPage, numResults) {
	var hashPrefix = "#p-";
	if (hash.startsWith(hashPrefix) || !this.firstPageLoaded) {
		var pageNumber = (hash && hash.startsWith(hashPrefix)) ? hash.substr(hashPrefix.length)
			: "1";

		// show/hide results page
		var resultsSelector = '.faqPage';
		var selectedResultId = 'faqPage-' + pageNumber;
		$(resultsSelector).each(function() {
			if (this.id == selectedResultId) {
				$(this).show();
			} else {
				$(this).hide();
			}
		});

		// switch page link
		this.switchPageLink('page', pageNumber, numResults, resultPerPage);

		// change start/end number text
		var startIndex = ((pageNumber - 1) * resultPerPage) + 1;
		$('#jcrFaqStartIndex').html(startIndex);

		var endIndex = 0;
		if (numResults > resultPerPage) {
			var endI = pageNumber * resultPerPage;
			if (endI > numResults) {
				endIndex = numResults;
			} else {
				endIndex = endI;
			}
		} else {
			endIndex = numResults;
		}
		$('#jcrFaqEndIndex').html(endIndex);

		this.firstPageLoaded = true;
	}
};

/**
 * Switch highlighting of page links
 * @param cssPrefix CSS prefix
 */
SCS.faq.switchPageLink = function(cssPrefix, pageNumber, numResults, resultPerPage) {
	var indexCounter = Math.ceil(parseInt(numResults) / parseInt(resultPerPage));

	if (indexCounter > 10) {
		for ( var i = 1; i <= indexCounter; i++) {
			$("#pageLink-" + i + "-counter").hide();
			$("#pageLink-" + i + "-counter").removeClass("active");
		}

		if (1 <= pageNumber && pageNumber < 7) {

			for ( var i = 0; i <= 7; i++) {
				$("#pageLink-" + i + "-counter").show();
			}

			$("#pageLink-" + parseInt(indexCounter - 1) + "-counter").show();
			$("#pageLink-" + indexCounter + "-counter").show();
			$("#pageLink-" + pageNumber + "-counter").addClass("active");
			$("#lastSpan").show();
			$("#firstSpan").hide();
		} else if (indexCounter - 7 < pageNumber && pageNumber <= indexCounter) {
			for ( var i = 0; i <= 7; i++) {
				$("#pageLink-" + parseInt(indexCounter - i) + "-counter").show();
			}
			$("#pageLink-" + 1 + "-counter").show();
			$("#pageLink-" + 2 + "-counter").show();
			$("#pageLink-" + pageNumber + "-counter").addClass("active");
			$("#firstSpan").show();
			$("#lastSpan").hide();
		} else {
			$("#pageLink-" + 1 + "-counter").show();
			$("#pageLink-" + 2 + "-counter").show();

			$("#pageLink-" + parseInt(pageNumber - 1) + "-counter").show();
			$("#pageLink-" + parseInt(pageNumber - 2) + "-counter").show();
			$("#pageLink-" + pageNumber + "-counter").addClass("active");
			$("#pageLink-" + pageNumber + "-counter").show();

			var next1 = parseInt(pageNumber) + 1;
			var next2 = parseInt(pageNumber) + 2;

			$("#pageLink-" + next1 + "-counter").show();
			$("#pageLink-" + next2 + "-counter").show();

			$("#pageLink-" + parseInt(indexCounter - 1) + "-counter").show();
			$("#pageLink-" + indexCounter + "-counter").show();

			$("#firstSpan").show();
			$("#lastSpan").show();
		}
	}

	else {

		var pageLinksSelector = '.' + cssPrefix + 'link';
		var selectedPageId = cssPrefix + 'Link-' + pageNumber + '-counter';
		$(pageLinksSelector).each(function() {
			if (this.id == selectedPageId) {
				$(this).addClass("active");
			} else {
				$(this).removeClass("active");
			}
		});
	}

	var startIndex = ((pageNumber - 1) * resultPerPage) + 1;
	if (numResults >= startIndex + resultPerPage) {
		var next = parseInt(pageNumber) + 1;
		$('#pageLinkNext').attr("href", "#p-" + next);
		$('#pageLinkNext').show();
	} else {
		$('#pageLinkNext').hide();
	}
	if (startIndex - resultPerPage > 0) {
		var prev = parseInt(pageNumber) - 1;
		$('#pageLinkPrevious').attr("href", "#p-" + prev);
		$('#pageLinkPrevious').show();
	} else {
		$('#pageLinkPrevious').hide();
	}
};

SCS.faq.sendRequest = function() {
	var searchBoxElement = $("#searchHidden");
	searchBoxElement.val(escape($("#search").val()));
};

SCS.faq.setText = function(query) {
	var searchBoxElement = $("#search");
	if ($("#searchHidden").val() != null) {
		searchBoxElement.val(unescape(query));
	}
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {$(function(){
	$("body").on("click", ".popupbutton .primary-button, .supportstrip .popup", function(evt) {
		evt.preventDefault();
		$this = $(this);
		window.open($this.attr('href'),'_blank','width='+$this.data('width')+',height='+$this.data('height')+',toolbar=no,location=no,directories=no,status=no,menubar=no,scrollbars=yes');
	});
});

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($, jQuery) {/**
 * (c) Copyright Swisscom (Schweiz) AG. All rights reserved.
 *
 * This product is the proprietary and sole property of Swisscom (Schweiz) AG
 * Use, duplication or dissemination is subject to prior written consent of
 * Swisscom (Schweiz) AG.
 *
 * $Id: searchform.js
 */
$.namespace("SCS.search");

SCS.search.isAjaxRequest = false;
SCS.search.searchKeywordDefaultText = "";
SCS.search.subCategoryDefaultText = "";
SCS.search.EMPTY_SEARCH_TERM = "_";

SCS.search.setI18nEntries = function(searchInstructionI18n,subCategoryI18n) {
	SCS.search.searchKeywordDefaultText = searchInstructionI18n;
	SCS.search.subCategoryDefaultText = subCategoryI18n;
};

SCS.search.initSearchBox = function() {
	var helpTextElement = $("#helpText");
	var helpTextVal = helpTextElement.val();

	var searchBoxElement = $("#search");
	var searchBoxVal = searchBoxElement.val();

	if(helpTextVal != searchBoxVal) {
		searchBoxElement.addClass('active');
	}
};

SCS.search.setSearchBox = function(isOnfocusEvent) {

	var helpTextElement = $("#helpText");
	var helpTextVal = helpTextElement.val();
	
	var searchBoxElement = $("#search");
	var searchBoxVal = searchBoxElement.val();
	
	if (isOnfocusEvent) {
	
		if (helpTextVal == searchBoxVal) {
			searchBoxElement.val('');
		}
		searchBoxElement.addClass('active');
	}

	//Handle EMPTY_VALUE placeholder '_'
	else {
		if (searchBoxVal == ''||searchBoxVal == SCS.search.EMPTY_SEARCH_TERM) {
			searchBoxElement.val(helpTextVal);
		}
		searchBoxElement.removeClass('active');
	}

};

SCS.search.populateSubTags = function () {
	var json = $("#scs-search-data").find("#tags").data("value");

	// category tag selected by user
	var categoryTagValue = $("#categoryTag").val();

	var subCategoryTag = json.tags[categoryTagValue];

	$('#subcategoryTags').empty();
	var subCategoryDropDown = '';
	var subCategoryTagInRequest = $("#subCat").val();
	subCategoryDropDown += '<select name="sc" id="subtagDropdown" class="customDropDown">';

	var labelCat = $("#categoryTag option:selected").text();

	if(categoryTagValue === "" ) {
		labelCat = "";
	}

	var textX = SCS.search.subCategoryDefaultText.replace("{0}",labelCat);

	subCategoryDropDown += '<option value="">'+textX+'</option>';
	var id = "";
	var title ="";

	if(categoryTagValue === "") {
		$('#subcategoryTags').addClass("disabledropdown");
	}
	else {
		$('#subcategoryTags').removeClass("disabledropdown");
	}
	for (var subCategoryTagKey in subCategoryTag) {
		if(subCategoryTag.hasOwnProperty(subCategoryTagKey)){
			id = subCategoryTag[subCategoryTagKey].id;
			title = subCategoryTag[subCategoryTagKey].title;
			if(subCategoryTagInRequest == id) {
				subCategoryDropDown += '<option value=\"'+id+'\" selected>'+title+'</option>';
			}
			else {
				subCategoryDropDown += '<option value=\"'+id+'\">'+title+'</option>';
			}
		}
	}
	subCategoryDropDown += '</select>';
	$('#subcategoryTags').html(subCategoryDropDown);
	$('#subtagDropdown').sSelect();
};

SCS.search.sendRequest = function() {

	var keyword = SCS.search.clean($("#search").val());
	if (this.isAjaxRequest) {
		return;
	}
	if(keyword == SCS.search.searchKeywordDefaultText ) {
		keyword = "";
	}

	window.location.href = SCS.search.buildUrl(keyword);
	SCS.supportstrip.loadStrips();
	return false;
};

SCS.search.sendRequestSuggestedKeyword = function() {
	var keyword = $("#suggestedKeyword").val();
	window.location.href = SCS.search.buildUrl(keyword);
};

SCS.search.filterEmptyTerms = function (term) {
	
	//empty suffixes are replaced by _ to work around Nevis configurations that can delete "//" under some circumstances.
	
	if (term == SCS.search.EMPTY_SEARCH_TERM) {
		return '';
	}
	return term;
}

SCS.search.encodeEmptyTerms = function (term) {
	
	//empty suffixes are replaced by _ to work around Nevis configurations that can delete "//" under some circumstances.
	
	if (term == '') {
		return SCS.search.EMPTY_SEARCH_TERM;
	}
	return term;
}

SCS.search.buildUrl = function(keyword) {

	var category = $("#categoryTag").val() || "";
	var subcategory = $("#subtagDropdown").val() || "";
	keyword = jQuery.trim(keyword);

	keyword = keyword.replace(/\./g, " ");
	subcategory = subcategory.replace(/\//g, ":");
	
	keyword = SCS.search.encodeEmptyTerms(keyword);
	category = SCS.search.encodeEmptyTerms(category);
	subcategory = SCS.search.encodeEmptyTerms(subcategory);

	var suffixes = "/" + keyword + "/" + category + "/" + subcategory;

	var url = $("#searchForm").attr('action');

	if (!!("ontouchend" in window)) {
		return url + ".mobile.html" + suffixes;
	}else {
		return url + ".html" + suffixes;
	}
};

SCS.search.init = function() {

	SCS.search.initSearchBox();

	$(document).on("searchEvent", function(event, pathname) {

		pathname = decodeURIComponent(pathname);
		
		//query parameters and the hash are not part of the pathname
		var pathnameSplit = pathname.split('.html');

		if (pathnameSplit.length>1) {
			suffixPart = pathnameSplit[1];
		} else {
			return;
		}

		suffixes = suffixPart.split('/');

		if (suffixes.length == 4) {

			//this is a proper selector structure for the help search

			var keyword = SCS.search.filterEmptyTerms(suffixes[1]);
			var category = SCS.search.filterEmptyTerms(suffixes[2]);
			var subCategory = SCS.search.filterEmptyTerms(suffixes[3]);

			$("#search").val(keyword);

			$("#categoryTag").val(category);
			$("#categoryTag").trigger("change.sSelect");

			SCS.search.populateSubTags();
			subCategory = subCategory.replace(category+":",category+"/");
			$("#subtagDropdown").val(subCategory);
			$("#subtagDropdown").trigger("change.sSelect");

		}

	});

	var pathname = SCS.search.clean(decodeURIComponent(escape(location.pathname)));
	$(document).trigger("searchEvent",[pathname]);
	if (!!SCS.header && typeof SCS.header.changeheaderurl == 'function'){
	SCS.header.changeheaderurl("de");
	SCS.header.changeheaderurl("en");
	SCS.header.changeheaderurl("fr");
	SCS.header.changeheaderurl("it");
	}
};

// strip the following characters: backslash
SCS.search.clean = function(s) {
	return s.replace(/\\/g,'');
};

$(document).ready(function(){
	var $data = $("#scs-search-data");
	if ($data.length === 0) return;
	
	$(".searchform #search").on('keypress', function(e) {
		if(e.keyCode == 13){
			SCS.search.sendRequest();
			return false;
		}
		return true;
	});

	$("#searchForm").submit(function(event) {
		SCS.search.sendRequest();
		event.preventDefault();
	});

	SCS.search.setI18nEntries(
		$data.find("#searchKeywordDefaultText").data("value"),
		$data.find("#subCategoryDefaultText").data("value")
	);
	SCS.search.init();
	SCS.search.setSearchBox(false);

	if (!!SCS.searchsuggestion) {
		if ($data.find("#showsuggestion").data("value")) {
				  SCS.searchsuggestion.init($data.find("#path").data("value"));
		}
	}



	SCS.search.populateSubTags();
});

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0), __webpack_require__(0)))

/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($, jQuery) {/**
 * (c) Copyright Swisscom (Schweiz) AG. All rights reserved.
 *
 * This product is the proprietary and sole property of Swisscom (Schweiz) AG
 * Use, duplication or dissemination is subject to prior written consent of
 * Swisscom (Schweiz) AG.
 *
 * $Id: downloadsearchform.js
 */
$.namespace("SCS.downloadsearchform");


SCS.downloadsearchform.defaultSelectorAppender = "$";

SCS.downloadsearchform.searchType = "";
SCS.downloadsearchform.searchFormName = "";

SCS.downloadsearchform.searchKeywordDefaultText = "";
SCS.downloadsearchform.isAjaxRequest = false;
SCS.downloadsearchform.manufacturerDefaultText = "";
SCS.downloadsearchform.productDefaultText = "";

SCS.downloadsearchform.setI18nEntries = function(searchInstructionI18n, manufacturerI18n, productI18n) {
	SCS.downloadsearchform.searchKeywordDefaultText = searchInstructionI18n;
	SCS.downloadsearchform.manufacturerDefaultText = manufacturerI18n;
	SCS.downloadsearchform.productDefaultText = productI18n;
};

SCS.downloadsearchform.populateManufacturerTags = function(json) {
	var productFamilyTagValue = $("#productFamilyTag_" + SCS.downloadsearchform.searchType).val();
	var manufacturerTagInRequest = $("#manufacturerTag_" + SCS.downloadsearchform.searchType).val();
	var dropdownDisabled = '';
	if (productFamilyTagValue == null || productFamilyTagValue == '') {
		dropdownDisabled = 'disabled';
	}

	var productTagsDefaultHtml = '';
	var labelManufacturer = $("#productFamilyTag_" + SCS.downloadsearchform.searchType
		+ " option:selected").text();
	if (productFamilyTagValue == "") {
		labelManufacturer = "";
	}
	else if (SCS.utils.isMobilePage() == true) {
		$("#productFamilyTag_" + SCS.downloadsearchform.searchType).siblings('span').html(labelManufacturer);
	}

	var textX = SCS.downloadsearchform.manufacturerDefaultText.replace("{0}", labelManufacturer);

	var labelProduct = '';
	var textY = SCS.downloadsearchform.productDefaultText.replace("{0}", labelProduct);
	
	if (SCS.utils.isMobilePage() == true) {
		productTagsDefaultHtml = '<select name="p" id="productTag_' + SCS.downloadsearchform.searchType
			+ '" data-theme="secondary-button">';
	}
	else {
		productTagsDefaultHtml = '<select name="p" id="productTag_' + SCS.downloadsearchform.searchType
		+ '" size="8" disabled>';
	}
	productTagsDefaultHtml += '<option title="' + textY + '" value="">' + textY + '</option>';
	productTagsDefaultHtml += '</select>';
	var productFamilyTag = json.tags[productFamilyTagValue];

	$('#manufacturerTags').empty();
	var manufacturerDropDown = '';

	if (SCS.utils.isMobilePage() == true) {
		manufacturerDropDown += '<select name="m" id="manufacturerTag_'
			+ SCS.downloadsearchform.searchType
			+ '" data-theme="secondary-button" onchange="SCS.downloadsearchform.populateProductTags(SCS.downloadsearchform.productTags); ">';
	}
	else {
		manufacturerDropDown += '<select name="m" id="manufacturerTag_'
			+ SCS.downloadsearchform.searchType
			+ '" size="8" onchange="SCS.downloadsearchform.populateProductTags(SCS.downloadsearchform.productTags); "'
			+ dropdownDisabled + '>';
	}
	manufacturerDropDown += '<option title="' + textX + '" value="">' + textX + '</option>';

	var id = "";
	var title = "";
	var lmfText = textX;
	for ( var manufacturerTagKey in productFamilyTag) {
		if (productFamilyTag.hasOwnProperty(manufacturerTagKey)) {
			id = productFamilyTag[manufacturerTagKey].id;
			title = productFamilyTag[manufacturerTagKey].title;
			count = productFamilyTag[manufacturerTagKey].results;
			if (manufacturerTagInRequest == id) {
				if (count != "" && count != "0") {
					manufacturerDropDown += '<option title="' + title + '" value=\"' + id
						+ '\" selected>' + title + ' (' + count + ')</option>';
				} else if (count != "" && count == "0") {
					manufacturerDropDown += '<option class="greytext" title="' + title
						+ '" value=\"' + id + '\" selected>' + title + ' (' + count + ')</option>';
				} else {
					manufacturerDropDown += '<option title="' + title + '" value=\"' + id
						+ '\" selected>' + title + '</option>';
				}
				lmfText = title;
			} else {
				if (count != "" && count != "0") {
					manufacturerDropDown += '<option title="' + title + '" value=\"' + id + '\">'
						+ title + ' (' + count + ')</option>';
				} else if (count != "" && count == "0") {
					manufacturerDropDown += '<option class="greytext" title="' + title
						+ '" value=\"' + id + '\">' + title + ' (' + count + ')</option>';
				} else {
					manufacturerDropDown += '<option title="' + title + '" value=\"' + id + '\">'
						+ title + '</option>';
				}

			}
		}
	}
	manufacturerDropDown += '</select>';
	
	$('#manufacturerTags').html(manufacturerDropDown);
	$('#productTags').html(productTagsDefaultHtml);
	if (SCS.utils.isMobilePage() == true) {
		$('#manufacturerTags').trigger("create");
		$('#productTags').trigger("create");
	}
}

SCS.downloadsearchform.populateProductTags = function(json) {
	var labelProduct = null;
	var manufacturerTagValue = $("#manufacturerTag_" + SCS.downloadsearchform.searchType).val();
	var valManuf = $("#manufacturerTag_" + SCS.downloadsearchform.searchType + " option:selected")
		.val();
	var valProdFamily = $("#productFamilyTag_" + SCS.downloadsearchform.searchType
		+ " option:selected").val();

	if (valProdFamily && valManuf) {
		labelProduct = SCS.downloadsearchform.manufacturerTags.tags[valProdFamily][valManuf].title;
	}

	if (labelProduct == null) {
		labelProduct = $("#manufacturerTag_" + SCS.downloadsearchform.searchType
			+ " option:selected").text();
	}

	if (manufacturerTagValue == "") {
		labelProduct = "";
	}
	else if (SCS.utils.isMobilePage() == true) {
		$("#manufacturerTag_" + SCS.downloadsearchform.searchType).siblings('span').html(labelProduct);
	}
	
	var textY = SCS.downloadsearchform.productDefaultText.replace("{0}", labelProduct);
	var dropdownDisabled = '';
	if (manufacturerTagValue == null || manufacturerTagValue == '') {
		dropdownDisabled = 'disabled';
	}
	var manufacturerTag = json.tags[manufacturerTagValue];

	$('#productTags').empty();
	var productDropDown = '';
	var productTagInRequest = $("#product").val();
	if (SCS.utils.isMobilePage() == true) {
		productDropDown += '<select name="p" id="productTag_' + SCS.downloadsearchform.searchType
		+ '"data-theme="secondary-button">';
	}
	else {
		productDropDown += '<select name="p" id="productTag_' + SCS.downloadsearchform.searchType
			+ '" size="8" ' + dropdownDisabled + '>';
	}
	productDropDown += '<option title="' + textY + '" value="">' + textY + '</option>';
	var id = "";
	var title = "";
	var lmfText = textY;
	for ( var productTagKey in manufacturerTag) {
		if (manufacturerTag.hasOwnProperty(productTagKey)) {
			id = manufacturerTag[productTagKey].id;
			title = manufacturerTag[productTagKey].title;
			count = manufacturerTag[productTagKey].results;
			if (productTagInRequest == id) {
				if (count != "" && count != "0") {
					productDropDown += '<option title="' + title + '" value=\"' + id
						+ '\" selected>' + title + ' (' + count + ')</option>';
				} else if (count != "" && count == "0") {
					productDropDown += '<option class="greytext" title="' + title + '" value=\"'
						+ id + '\" selected>' + title + ' (' + count + ')</option>';
				} else {
					productDropDown += '<option title="' + title + '" value=\"' + id
						+ '\" selected>' + title + '</option>';
				}
				lmfText = title;
			} else {
				if (count != "" && count != "0") {
					productDropDown += '<option title="' + title + '" value=\"' + id + '\">'
						+ title + ' (' + count + ')</option>';
				} else if (count != "" && count == "0") {
					productDropDown += '<option class="greytext" title="' + title + '" value=\"'
						+ id + '\">' + title + ' (' + count + ')</option>';
				} else {
					productDropDown += '<option title="' + title + '" value=\"' + id + '\">'
						+ title + '</option>';
				}
			}
		}
	}
	productDropDown += '</select>';
	
	$('#productTags').html(productDropDown);
	if (SCS.utils.isMobilePage() == true) {
		$('#productTags').trigger("create");
	}
	
	if (SCS.utils.isMobilePage() == true) {
		$('#productTags select').off('change').on('change', function() {
			$(this).siblings('span').html($('option:selected', $(this)).text());
		});
	}
	
}

var searchKeyword;

/**
 * Replace all function
 * WARNING: dangerous function - if find-text is contained in replacement-text,
 * it will re-replace within
 * @param text Text
 * @param find String to find
 * @param repl Replacement string
 */
SCS.downloadsearchform.replaceAll = function(text, find, repl) {
	var newText = text;
	if (newText) {
		var i = 0;
		while (newText.indexOf(find) != -1 && i < 20) {
			newText = newText.replace(find, repl);
			i++;
		}
	}
	return newText;
};

SCS.downloadsearchform.sendRequest = function(searchType) {
	SCS.downloadsearchresults.clientSideValidation = false;
	searchKeyword = $("#search").val();
	if (this.isAjaxRequest)
		return;

	if (searchKeyword == SCS.downloadsearchform.searchKeywordDefaultText) {
		searchKeyword = "";
	}
	window.location.href = SCS.downloadsearchform.buildUrl(searchType);
	return false;
};

SCS.downloadsearchform.sendRequestSuggestedKeyword = function(keyword) {
	SCS.downloadsearchresults.clientSideValidation = false;
	searchKeyword = $("#suggestedKeyword").val();
	window.location.href = SCS.downloadsearchform.buildUrl('searchForm');
	location.reload();
	return false;
};

SCS.downloadsearchform.buildUrl = function(searchType) {
	var productFamilyTagValue = $("#productFamilyTag_" + SCS.downloadsearchform.searchType).val();
	var manufacturerTagValue = $("#manufacturerTag_" + SCS.downloadsearchform.searchType).val();
	var productTagValue = $("#productTag_" + SCS.downloadsearchform.searchType).val();
	if (productFamilyTagValue == null) {
		productFamilyTagValue = '';
	}
	productFamilyTagValue = SCS.downloadsearchform.defaultSelectorAppender + productFamilyTagValue;

	if (manufacturerTagValue == null) {
		manufacturerTagValue = '';
	}
	manufacturerTagValue = SCS.downloadsearchform.defaultSelectorAppender + manufacturerTagValue;

	if (productTagValue == null) {
		productTagValue = '';
	}
	productTagValue = SCS.downloadsearchform.defaultSelectorAppender + productTagValue;

	searchKeyword = SCS.downloadsearchform.defaultSelectorAppender + jQuery.trim(searchKeyword);

	searchKeyword = SCS.downloadsearchform.replaceAll(searchKeyword, '.', ' ');

	manufacturerTagValue = SCS.downloadsearchform.replaceAll(manufacturerTagValue, '/', ':');

	productTagValue = SCS.downloadsearchform.replaceAll(productTagValue, '/', ':');

	/*
	 * Defect ID-8681 . Functioning of component as two different components .
	 * Selectors should be changed to achieve this based on searchType .
	 */
	var selectors = "";
	if (searchType == 'searchForm') {
		selectors = "#." + searchKeyword + "." + productFamilyTagValue + "." + manufacturerTagValue
			+ "." + productTagValue;

	} else if (searchType == 'both') {
		selectors = "#." + searchKeyword + "." + productFamilyTagValue + "." + manufacturerTagValue
			+ "." + productTagValue;

	} else {
		selectors = "#." + "$." + productFamilyTagValue + "." + manufacturerTagValue + "."
			+ productTagValue;
	}

	var url = $('#' + SCS.downloadsearchform.searchFormName).attr('action');

	return url + ".html" + selectors;
};

SCS.downloadsearchform.init = function() {
	$(window).on('hashchange', function() {
		if (!SCS.downloadsearchresults.clientSideValidation) {
			$(document).trigger("downloadSearchEvent", [ location.hash ]);
			$(document).trigger("downloadSearchFormEvent", [ location.hash ]);
		}
		// get data back from hash :)
//		SCS.header.changeheaderurl("de");
//		SCS.header.changeheaderurl("en");
//		SCS.header.changeheaderurl("fr");
//		SCS.header.changeheaderurl("it");

	});
	$(document).on("downloadSearchFormEvent", function(event, selector) {
		if (selector != undefined && selector != '') {
			selector = unescape(selector);
			var selector1 = selector.replace('#', '');
			var ss = selector1.split(".");
			if (ss[1] != undefined) {
				var keyword = ss[1].replace('$', '');
				if (keyword != '') {
					$("#search").val(keyword);
				}
			}
			if (ss[2] != undefined) {
				var productFamily = ss[2].replace('$', '');
				if (productFamily != '') {
					$("#productFamilyTag_" + SCS.downloadsearchform.searchType).val(productFamily);
				}
			}

			if (ss[3] != undefined) {
				SCS.downloadsearchform
					.populateManufacturerTags(SCS.downloadsearchform.manufacturerTags)
				var manufacturer = ss[3].replace('$', '');
				manufacturer = manufacturer.replace(productFamily + ":", productFamily + "/");
				if (manufacturer != '') {
					$("#manufacturerTag_" + SCS.downloadsearchform.searchType).val(manufacturer);
				}
			}

			if (ss[4] != undefined) {
				SCS.downloadsearchform.populateProductTags(SCS.downloadsearchform.productTags)
				var product = ss[4].replace('$', '');
				var manufacturer1 = ss[3].replace('$', '');
				product = product.replace(manufacturer1 + ":", manufacturer + "/");
				product = product.replace('+', ' ');
				if (product != '') {
					$("#productTag_" + SCS.downloadsearchform.searchType).val(product);
				}
			}

		}

	});

	$(document).ready(function() {

		if (location.hash.length > 0) {
			$(window).trigger('hashchange');
		}
	});

};

SCS.downloadsearchform.showAjaxLoader = function() {

	var windowWidth = $(window).width();
	var windowHeight = $(window).height();
	var barWidth = $("#processingBar").width();
	var barHeight = $("#processingBar").height();

	$("#processingBar").css({
		top : ((windowHeight / 2) - (barHeight / 2)),
		left : ((windowWidth / 2) - (barWidth / 2))
	});

	$("#processingBarPanel").css({
		width : windowWidth,
		height : windowHeight
	});

	$("#processingBarPanel").show();
	$("#processingBar").show();
};

SCS.downloadsearchform.hideAjaxLoader = function() {
	$("#processingBarPanel").hide();
	$("#processingBar").hide();
};

SCS.downloadsearchform.showCarousel = function() {
	$("#scs-devicecarousel").show();
	if ($("div.basic-carousel:visible") != undefined) {
		$("div.basic-carousel:visible").each(function() {
			SCS.devicecarousel.init(this.id);
		});
	}
};

SCS.downloadsearchform.hideCarousel = function() {
	$("#scs-devicecarousel").hide();
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0), __webpack_require__(0)))

/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {/**
 * (c) Copyright Swisscom (Schweiz) AG. All rights reserved.
 *
 * This product is the proprietary and sole property of Swisscom (Schweiz) AG
 * Use, duplication or dissemination is subject to prior written consent of
 * Swisscom (Schweiz) AG.
 *
 * $Id: articlesearch.js
 */
$.namespace("SCS.pagination");

SCS.pagination.firstPageLoaded = false;
SCS.pagination.gsaFirstPageLoaded = false;

/**
 * Switch Article results page (Solution results)
 * @param hash Hash/Anchor (#)
 */
SCS.pagination.switchPage = function(hash, resultPerPage, numResults, resultsSelector, selectedResultIdPrefix) {
	var hashPrefix = "#.";
	if (hash.startsWith(hashPrefix) || !this.firstPageLoaded) {
		var pageNumber = (hash && hash.startsWith(hashPrefix)) ? hash.substr(hash.lastIndexOf(".")+1) : "1";
		if(pageNumber.startsWith("$")) {
			pageNumber = 1;
			hash = hash+"."+pageNumber
		}
		// show/hide results page
		var selectedResultId = selectedResultIdPrefix + pageNumber;
		$(resultsSelector).each(function() {
			if (this.id == selectedResultId) {
				$(this).show();
			} else {
				$(this).hide();
			}
		});
		
		// switch page link
		this.switchPageLink('page', pageNumber, numResults, resultPerPage,hash);

		this.firstPageLoaded = true;
	}
};

/**
 * Switch highlighting of page links
 * @param cssPrefix CSS prefix
 */
SCS.pagination.switchPageLink = function(cssPrefix, pageNumber, numResults, resultPerPage, hash) {
	var indexCounter = Math.ceil(parseInt(numResults) / parseInt(resultPerPage));
	
	if(indexCounter > 10)
	{
		for(var i=1; i <= indexCounter; i++)
		{
			$("#pageLink-"+ i + "-counter").hide();
			$("#pageLink-"+ i + "-counter").removeClass("active");
		}

		if(1 <= pageNumber && pageNumber < 7)
		{
			
			for(var i=0; i <= 7; i++)
			{
				$("#pageLink-"+ i + "-counter").show();
			}
			
			$("#pageLink-"+ parseInt(indexCounter-1) + "-counter").show();
			$("#pageLink-"+ indexCounter + "-counter").show();
			$("#pageLink-"+ pageNumber + "-counter").addClass("active");
			$("#lastSpan").show();
			$("#firstSpan").hide();
		}
		else if(indexCounter-7 < pageNumber && pageNumber <= indexCounter)
		{
			for(var i=0; i <= 7; i++)
			{
				$("#pageLink-"+ parseInt(indexCounter-i) + "-counter").show();
			}
			$("#pageLink-"+ 1 + "-counter").show();
			$("#pageLink-"+ 2 + "-counter").show();
			$("#pageLink-"+ pageNumber + "-counter").addClass("active");
			$("#firstSpan").show();
			$("#lastSpan").hide();
		}
		else{
			$("#pageLink-"+ 1 + "-counter").show();
			$("#pageLink-"+ 2 + "-counter").show();
			
			$("#pageLink-"+ parseInt(pageNumber - 1) + "-counter").show();
			$("#pageLink-"+ parseInt(pageNumber - 2) + "-counter").show();
			$("#pageLink-"+ pageNumber + "-counter").addClass("active");
			$("#pageLink-"+ pageNumber+ "-counter").show();
			
			var next1 = parseInt(pageNumber) + 1;
			var next2 = parseInt(pageNumber) + 2;
			
			$("#pageLink-"+ next1 + "-counter").show();
			$("#pageLink-"+ next2 + "-counter").show();
			
			
			$("#pageLink-"+ parseInt(indexCounter-1)+ "-counter").show();
			$("#pageLink-"+ indexCounter + "-counter").show();
			
			$("#firstSpan").show();
			$("#lastSpan").show();
		}
	}
	
	else{
	
		var pageLinksSelector = '.' + cssPrefix + 'link';
		var selectedPageId = cssPrefix + 'Link-' + pageNumber + '-counter';
		$(pageLinksSelector).each(function() {
			if (this.id == selectedPageId) {
				$(this).addClass("active");
			} else {
				$(this).removeClass("active");
			}
		});
	}
	
	var startIndex = ((pageNumber - 1) * resultPerPage) + 1;
	if(numResults >= startIndex + resultPerPage) {
		var next = parseInt(pageNumber) + 1;
		hash = hash.substring(0,hash.lastIndexOf(".")+1) + next;
		$('#pageLinkNext').attr("href", hash);
		$('#pageLinkNext').show();
	} else {
		$('#pageLinkNext').hide();
	}
	if(startIndex - resultPerPage > 0) {	
		var prev = parseInt(pageNumber) - 1;
		hash = hash.substring(0,hash.lastIndexOf(".")+1) + prev;
		$('#pageLinkPrevious').attr("href",hash);
		$('#pageLinkPrevious').show();
	} else {
		$('#pageLinkPrevious').hide();
	}
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {/**
 * (c) Copyright Swisscom (Schweiz) AG. All rights reserved.
 * 
 * This product is the proprietary and sole property of Swisscom (Schweiz) AG
 * Use, duplication or dissemination is subject to prior written consent of
 * Swisscom (Schweiz) AG.
 * 
 * $Id: downloadsearchform.js
 */
$.namespace("SCS.downloadsearchresults");
SCS.downloadsearchresults.init = function(path) {
	$(document).on("downloadSearchEvent", function(event, selector) {
		selector = unescape(selector);
		var selector1 = encodeURIComponent(selector.replace('#', ''));
		if (SCS.downloadsearchform.isAjaxRequest == true) {
			   return;
		}
		$.ajax({
			beforeSend : function(jqXHR, settings) {
				SCS.downloadsearchform.isAjaxRequest = true;
				SCS.downloadsearchform.showAjaxLoader();
			},
			url : path + ".search" + selector1 + ".html",
			timeout : 50000,
			success : function(data) {
				$("#searchresult").html(data);
			},
			complete : function(jqXHR, textStatus) {
				SCS.downloadsearchform.hideAjaxLoader();
				SCS.downloadsearchform.isAjaxRequest = false;
			}
		});

	});
};

SCS.downloadsearchresults.openRequestedPopup = function(url) {
	var strWindowFeatures = "toolbar=no,menubar=no,location=no,resizable=yes,scrollbars=yes,status=no,width=700,height=500,top=200";
	window.open(url, "", strWindowFeatures);
}

SCS.downloadsearchresults.loadDownloadButton = function(containerId, buttonUrl) {
	$.ajax({
		url : buttonUrl,
		timeout : 10000,
		success : function(data) {
			$(containerId).html(data);
			if ($(containerId + " a") != undefined) {
				$(containerId + " a").attr("baynote_dlcontext", "search");
			}
		},
		complete : function(jqXHR, textStatus) {

		}
	});
};

SCS.downloadsearchresults.clientSideValidation = false;

/**
 * Initialize Article search
 */
SCS.downloadsearchresults.initPagination = function(resultPerPage, numResults) {
	this.clientSideValidation = true;

	$(window).on('hashchange', function() {
		SCS.pagination
			.switchPage(location.hash, resultPerPage, numResults, ".helpteaser", "dlcPage-");
	});
	$(window).trigger('hashchange');
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {$.namespace("SCS.downloadbutton");
SCS.downloadbutton.buttonClick = function(openInNewWindow, resourceURL, nodeId) {
	if (openInNewWindow != 'true') {
		$("#scs-help-downloadStartLink-" + nodeId).css("display", "block");
		window.open(resourceURL, "_self");
	} else {
		window.open(resourceURL, "_blank");
	}
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {/**
 * (c) Copyright Swisscom (Schweiz) AG. All rights reserved.
 *
 * This product is the proprietary and sole property of Swisscom (Schweiz) AG
 * Use, duplication or dissemination is subject to prior written consent of
 * Swisscom (Schweiz) AG.
 *
 * $Id: searchsuggestion.js
 */

$.namespace("SCS.searchsuggestion");

/**
 * Initialize
 */
SCS.searchsuggestion.init = function(resourcePath) {
	$(document).ready(function() {
		var url;
		var searchvalue;
		$("#search").keyup(function() {
			searchvalue = encodeURIComponent(this.value);
			var cat = $("#categoryTag option:selected").text();
			url = resourcePath + ".suggestion." + searchvalue + ".json";
		});
		$("#search").autocomplete({
			source : loadFromAjax,
			minLength : 3,
			appendTo : "#search_results_div"
		});
		function loadFromAjax(request, response) {
			$.ajax({
				url : url,
				timeout : 10000,
				dataType : 'json',
				success : function(data) {
					response(data);
				}
			});
		}
	});
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {/**
 * (c) Copyright Swisscom (Schweiz) AG. All rights reserved.
 *
 * This product is the proprietary and sole property of Swisscom (Schweiz) AG
 * Use, duplication or dissemination is subject to prior written consent of
 * Swisscom (Schweiz) AG.
 *
 * $Id: imageload.js
 */
$.namespace("SCS.imageload");


SCS.imageload.showAjaxLoader = function() {
	var windowWidth = $(".supportcommunitysec").width();
	var barWidth = 145;
	leftVal=(windowWidth-barWidth)/2+"px";
	topVal= 70;
		
	
	$("#processingBarPanel").css('width', windowWidth).show();
	$("#processingBar").css({
		//top: topVal,
		left: leftVal
	}).show();
	};

	SCS.imageload.hideAjaxLoader = function() {
		$("#processingBarPanel").hide();
		$("#processingBar").hide();
	};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {$.namespace("SCS.ajaxcalls");

SCS.ajaxcalls.init = function(scriptpath, id) {

	$(document).ready(function() {
		if (location.hash == '') {
			$.ajax({
				url : scriptpath + ".html",
				timeout : 10000,
				success : function(data) {
					$('#' + id).html(data);
				}
			}); // Defect ID : 11250 Quicklink in Accordion
		} else {
			$.ajax({
				url : scriptpath + ".html",
				timeout : 10000,
				success : function(data) {
					$('#' + id).html(data);
				}
			});
		}
	});
};

SCS.ajaxcalls.bind = function(scriptpath, id) {
	$(document).on("searchEvent", function(event, selector) {
		var selector1 = encodeURIComponent(selector.replace('#', ''));
		$.ajax({
			url : scriptpath + selector1 + ".html",
			timeout : 10000,
			success : function(data) {
				$('#' + id).html(data);
			}
		});
	});
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {$.namespace("SCS.devicelist");

SCS.devicelist.initialized = false;

SCS.devicelist.init = function() {
	
	if(SCS.devicelist.initialized){
		return;
	}
	
	$(document).ready(function() {
		lazy(".devicelisting img");
		load(1000);
		$('.devicelisting a span.img').each(function(){
			var spanWidth = 109;
			var deviceImage = $(this).children('img');
			
			if(deviceImage){
				var imgWidth = deviceImage.width();	
				leftVal=(spanWidth-imgWidth)/2+"px";
				deviceImage.css("left",leftVal);
			}
		});
		SCS.devicelist.initialized = true;
	});
	
	$(window).on('load', function() {
		var timeout = setTimeout(function() {
			$(".devicelisting img").trigger("sporty")
		}, 500);
	});
	
	function lazy(toload) {
		$(toload).lazyload( {
			placeholder : "/etc/designs/help/resources/images/grey.gif",
			event : "sporty"
		});
	}
	
	function load(timeValue) {
		$('li.ui-state-default a').on('click', function() {
		var timeout = setTimeout(function() {
			lazy(".devicelisting img[src$='grey.gif']");
			$(".devicelisting img[src$='grey.gif']").each(function(){
				$(this).trigger("sporty");
			});
			$('.devicelisting a span.img').each(function(){
				var spanWidth = 109;
				var deviceImage = $(this).children('img');
				if(deviceImage){
					var imgWidth = deviceImage.width();	
					leftVal=(spanWidth-imgWidth)/2+"px";
					deviceImage.css("left",leftVal);
				}
			});
		}, timeValue);
	});}
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {/**
 * (c) Copyright Swisscom (Schweiz) AG. All rights reserved.
 *
 * This product is the proprietary and sole property of Swisscom (Schweiz) AG
 * Use, duplication or dissemination is subject to prior written consent of
 * Swisscom (Schweiz) AG.
 *
 * $Id: searchform.js
 */
$.namespace("SCS.header");

SCS.header.changeheaderurl = function(lang)
{
	SCS.header.changeurl("osn_meta_overview_language_"+lang);
};

SCS.header.changeurl = function(id)
{
	if($("#"+id))
	{
		var hrefval = $("#"+id).attr("orighref");
		
		if(!hrefval)
		{
			hrefval = $("#"+id).attr("href");
			$("#"+id).attr("orighref", hrefval);
		}
		$("#"+id).attr("href", hrefval + location.hash);
	}
};

SCS.header.changeprinturl = function(id)
{
	if($("#"+id))
	{
		var hrefval = $("#"+id).attr("orighref");
		
		if(!hrefval)
		{
			hrefval = $("#"+id).attr("href");
			
			var start = hrefval
			
			$("#"+id).attr("orighref", hrefval);
		}
		var st1 = "javascript:SCS.openPrint('";
		var st2 = "','Portrait')";
		var st3 = "document.location.hash,'Portrait')";
		var len = hrefval.length - st3.length;
		var start = hrefval.substring(0,len) + "'";
		var newurl = start + location.hash + st2;
				
		$("#"+id).attr("href", newurl);
	}
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 347 */
/***/ (function(module, exports) {

/**
 * (c) Copyright Swisscom (Schweiz) AG. All rights reserved.
 * 
 * This product is the proprietary and sole property of Swisscom (Schweiz) AG
 * Use, duplication or dissemination is subject to prior written consent of
 * Swisscom (Schweiz) AG.
 * 
 * $Id: quicklinkteaser.js
 */
SCS.ensure(function(context, $) {
	context.find('.scs-quicklink-teaser-container').each(function() {
		var teaser = $(this);
		teaser.load(teaser.data('load-url'));
	});
}, 'body, .ui-tabs-panel, .displayRequest, .scs-accordion-tab-panel');


/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {/**
 * (c) Copyright Swisscom (Schweiz) AG. All rights reserved.
 *
 * This product is the proprietary and sole property of Swisscom (Schweiz) AG
 * Use, duplication or dissemination is subject to prior written consent of
 * Swisscom (Schweiz) AG.
 *
 * $Id: supportstrip.js (search)
 */
/**
 * Load support strip link lists
 */
//This javascript is obsolete. Please try to use Tc.Module.SupportStrip
$.namespace("SCS.supportstrip");

SCS.supportstrip.placeholder = '_keyword_';
SCS.supportstrip.NA = 'NA';//base64 url safe encoded

SCS.supportstrip.loadStrips = function() {	
	$(".scs-search-support-strip .links, .scs-support-strip-help .links").each(function() {
		var $this = $(this);
		var url = $this.data("url");
		var currentPagePath = $this.data("currentpagepath");
		var searchEnabled = $this.data("search-enabled");
		if (url.indexOf(SCS.supportstrip.placeholder)!==-1) {
			var keyword = escape($("#search").val());
			//$('#searchKeywordDefaultText') not exists in DOM !!!!
			var defaultKeyword = escape($("#searchKeywordDefaultText").data("value"));
			if (keyword == SCS.search.searchKeywordDefaultText || keyword == "" || keyword == defaultKeyword) {
				keyword = SCS.supportstrip.NA;//NA base64 url safe encoded
			}
			url = url.replace(SCS.supportstrip.placeholder, $.base64.encode(keyword).replace('=', '')); // URL Safe version of Base64
		}
		if (url != undefined) {
			$.get(url, {tagSrc:currentPagePath}, function(response, status, xhr) {
				$this.html(response);
				if (status != "success" && status != "notmodified") {
					$(this).hide();
				}
			});
		}
	});
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {/**
 * (c) Copyright Swisscom (Schweiz) AG. All rights reserved.
 *
 * This product is the proprietary and sole property of Swisscom (Schweiz) AG
 * Use, duplication or dissemination is subject to prior written consent of
 * Swisscom (Schweiz) AG.
 *
 * $Id: sitecatalyst.js
 */
$.namespace("SCS.sitecatalyst.downloadCenter");

SCS.sitecatalyst.downloadCenter = function(keyword, productTagTitle, productFamilyTagTitle, manufacturerTagTitle, totalMatches) {
	var siteCatalyst = window.s || window.s_one;
	if (siteCatalyst && siteCatalyst.t) {
		siteCatalyst.prop10 = keyword;
		siteCatalyst.prop11 = totalMatches;
		siteCatalyst.prop36 = 'Download:' + productFamilyTagTitle + '/' + manufacturerTagTitle + '/' + productTagTitle;
		siteCatalyst.linkTrackVars = 'prop10,prop11,prop36';
		siteCatalyst.t(this, 'o', siteCatalyst.prop10);
	}
};

/**
 * Initialize SiteCatalyst
 */
SCS.sitecatalyst.downloadCenter.init = function(keyword, catTag, subCatTag, totalMatches) {
	var siteCatalyst = window.s || window.s_one;
	if (siteCatalyst && siteCatalyst.t) {
		siteCatalyst.prop10 = keyword;
		siteCatalyst.prop11 = totalMatches;
		siteCatalyst.prop36 = catTag;

		siteCatalyst.linkTrackVars = 'prop10,prop11,prop36';
		siteCatalyst.linkTrackEvents = 'None';
		if (subCatTag != null)
			siteCatalyst.prop36 = subCatTag;
		siteCatalyst.t(this, 'o', siteCatalyst.prop10);
	}
};

SCS.sitecatalyst.downloadCenter.track = function(url, counter) {
	var siteCatalyst = window.s || window.s_one;
	if (siteCatalyst && siteCatalyst.t) {
		siteCatalyst.linkTrackVars += ",prop59";
		siteCatalyst.prop59 = counter;
		siteCatalyst.tl(this, 'o', siteCatalyst.prop59);
	}
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {$.namespace("SCS.backbutton");
SCS.backbutton.hide = function() {
	//if "browser" does not have browsing history then hide the button 
	if (window.history.length < 2) {
		$(document).ready(function() {
			$('.back').hide();
		});
	}
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_Tc_dot_$) {/*** IMPORTS FROM imports-loader ***/
var loadTerrific = __webpack_require__(1);
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

var createAnimation = __webpack_require__(24).createAnimation;

(function ($, Module, SCS, debug) {
	'use strict';

	// Helper functions

	// Object.create polyfill (without getter/setter support)
	var createObject = Object.create || function (proto) {
			// Inherit from “Item”
			function Creator() {
			}

			Creator.prototype = proto;
			return new Creator();
		};

	// Data structure to hold jQuery objects
	function NodeWrapper($ctx) {
		this.$ctx = $ctx;
	}

	function updateStepBackState(topic, active) {
		topic.$ctx.find('.step-back').toggleClass('is-hidden', !active);
		topic.$ctx.toggleClass('last', active);
	}

	// Set the current and active states.
	// An item that is current is, by definition, always active
	// What being current or being active means differs by type.
	// Steps:
	//		Steps are active if they are visible and current if a topic has been clicked
	//		Multiple Steps can be current at a time.
	//		If steps 1…n are current, steps 1…n+1 are active
	// Topics:
	//		A topic is current if it has been clicked upon.
	//		Active means a topic’s parent is current
	//		One topic per step can be current
	NodeWrapper.prototype.updateState = function (current, active) {
		if (current !== null) {
			this.$ctx.toggleClass('current', current);
			if (current) {
				active = true;
			}
		}
		if (active !== null) {
			this.$ctx.toggleClass('active', active);
		}

		var isMobilePage = SCS.utils.isMobilePage();
		if (isMobilePage) {
			if (!current) {
				updateStepBackState(this, false);
				if (this.parent && this.parent.$ctx.hasClass('current')) {
					updateStepBackState(this.parent, true);
				}
			} else {
				updateStepBackState(this, true);
				if (this.parent) {
					updateStepBackState(this.parent, false);
				}
			}
		}
	};
	NodeWrapper.prototype.getContext = function () {
		return this.$ctx;
	};

	// Represents a whole step
	function Step($ctx, previousStep, module) {
		NodeWrapper.call(this, $ctx);
		this.nextStep = null;
		this.number = $ctx.data('stepNumber');
		this.topics = [];
		this.results = [];
		this.topicsByName = {};
		this.selectedTopic = null;
		this.module = module;
		this.previousStep = previousStep;
		if (previousStep) {
			previousStep.nextStep = this;
		}
	}

	Step.prototype = createObject(NodeWrapper.prototype);

	Step.prototype.namedTopic = function (topicName) {
		return this.topicsByName[topicName];
	};

	Step.prototype.addTopic = function (topic) {
		this.topics.push(topic);
		this.topicsByName[topic.name] = topic;
		topic.setStep(this);
	};

	Step.prototype.addResult = function (result) {
		this.results.push(result);
		result.setStep(this);
	};

	Step.prototype.updateItems = function (current, active) {
		$.each(this.topics, function () {
			this.updateState(current, active);
		});
		$.each(this.results, function () {
			this.updateState(current, active);
		});
	};

	Step.prototype.deselect = function () {
		if (!this.selectedTopic) {
			return;
		}

		var newTopic = (this.previousStep && this.previousStep.selectedTopic) || null;

		this.selectTopic(newTopic);
	};

	// Select a new topic. Call this on the lowest step that must be updated.
	// Hash handling will call this on the first step,
	// click handlers on the step the click ocurred.
	Step.prototype.selectTopic = function (topic) {
		// Search parents of the newly-selected topic until we found one in our step (like jQuery.fn.closest)
		var stepTopic = topic;

		while (stepTopic && stepTopic.step !== this) {
			stepTopic = stepTopic.parent;
		}

		debug.log('Tc.Module.ContactWizard > Step > selecting step topic', stepTopic, stepTopic === topic, 'in step', this.number);

		// Mark the step topic as selected
		this.selectedTopic = stepTopic;

		// Set current if we have a “current” topic for this step
		this.updateState(!!stepTopic, null);

		// Remove “current” from all items
		this.updateItems(false, null);
		// Mark current item active (if any)
		if (stepTopic) {
			stepTopic.updateState(true, null);
		}

		// Propagate to the next step (if any)
		if (this.nextStep) {
			this.nextStep.markActive(stepTopic);
			this.nextStep.selectTopic(topic);
		} else {
			// Mark topic as selected in the module (for hash handling, scrolling and stuff)
			this.module.topicSelected(topic);
		}
	};

	Step.prototype.markActive = function (parentTopic) {
		var activeItems = [];
		if (parentTopic) {
			// Mark which subset of topics/results are active (the ones whose parent are from the previous step)
			activeItems = parentTopic.children;
		}

		debug.log('Tc.Module.ContactWizard > Step > activating children from', parentTopic, ':', activeItems, 'in step', this.number);

		// Deactivate all items
		this.updateItems(false, false);

		// Activate active items
		$.each(activeItems, function () {
			this.updateState(null, true);
		});

		// Set step active if we have topics to show in this step
		this.updateState(null, !!activeItems.length);
	};

	// Represents a topic or a result
	function Item($ctx) {
		NodeWrapper.call(this, $ctx);
		this.parentTopicName = $ctx.data('parentTopic');
		this.step = null;
		this.parent = null;
		this.children = [];
		this.init();
	}

	Item.prototype = createObject(NodeWrapper.prototype);

	Item.prototype.init = function () {
	};

	Item.prototype.setStep = function (step) {
		this.step = step;
		if (this.step.previousStep) {
			var parent = this.step.previousStep.namedTopic(this.parentTopicName);
			if (parent) {
				this.setParent(parent);
			}
		}
	};

	Item.prototype.setParent = function (parent) {
		this.parent = parent;
		parent.children.push(this);
	};

	// Represents a topic or subtopic that can be clicked on
	function Topic($ctx) {
		Item.call(this, $ctx);
		this.name = this.$ctx.data('name');
		this.mobileResultLink = this.$ctx.data('mobileResultLink');
	}

	Topic.prototype = createObject(Item.prototype);

	Topic.prototype.init = function () {
		this.$ctx.on('click tap', $.proxy(this.select, this));
		this.$ctx.find('.step-back > a').on('click tap', this.deselect.bind(this));
	};

	Topic.prototype.deselect = function (evt) {
		evt.preventDefault();
		evt.stopPropagation();
		updateStepBackState(this, false);
		this.step.deselect();
	};

	Topic.prototype.select = function () {
		this.step.selectTopic(this);
	};

	Topic.prototype.getTitle = function () {
		return this.$ctx.find('.title').text();
	};

	// Represents a result
	function Result($ctx) {
		Item.call(this, $ctx);

	}

	Result.prototype = createObject(Item.prototype);

	Result.prototype.updateState = function (current, active) {
		Item.prototype.updateState.apply(this, arguments);
		if (active) {
			SCS.utils.initNewModules(this.$ctx);
		}
	};

	/**
	 * Module for the Contact Wizard
	 *
	 * @author Benjamin Berger, Raphael Schweikert
	 * @namespace Tc.Module
	 * @class ContactWizard
	 * @extends Tc.Module
	 * @version 1.0
	 */
	Module.ContactWizard = Module.extend({
		// Whether we are curently editing page the component is on
		isEditMode: false,
		// Whether we are in mobile view
		isMobilePage: false,
		// All the steps in this contact wizard
		steps: null,
		// Whether debug mode is on
		debug: false,
		// The initial document title
		defaultTitle: null,
		// The animator for scrolls
		scrollAnimation: null,

		/**
		 * Main function.
		 *
		 * @method on
		 * @param {Function} callback function
		 * @return void
		 */
		on: function (callback) {
			// Module vars
			this.isEditMode = !!$('.cq_isEditMode').length;
			this.isMobilePage = SCS.utils.isMobilePage();
			this.steps = [];
			this.debug = !!(window.location.search + window.location.hash).match(/\bdevconsole\b/);
			if (this.debug) {
				window.modContactWizard = this;
			}

			callback();
		},

		/**
		 * Initialize contact wizard functionality.
		 */
		after: function () {
			// Find steps and topics
			this.initializeSteps();
			this.loadStateFromHash();
			this.initializeDom();
			// Load initial hash
			this.hashChanged();
		},

		initializeSteps: function () {
			var mod = this;
			var $steps = this.$ctx.find('> .steps > .step');
			var previousStep = null;
			$steps.each(function () {
				var $step = $(this);
				var step = new Step($step, previousStep, mod);
				mod.steps.push(step);

				// Handle topics
				var $topics = $step.find('.topics > .topic');
				$topics.each(function () {
					var $topic = $(this);
					var topic = new Topic($topic);
					step.addTopic(topic);
				});
				debug.log('Tc.Module.ContactWizard > found topics', $topics);

				// Handle results
				var $results = $step.find('.results > .result');
				$results.each(function () {
					var $result = $(this);
					var result = new Result($result);
					step.addResult(result);
				});
				debug.log('Tc.Module.ContactWizard > found results', $results);

				// Handle the reset button
				var $reset = $step.find('.show-all');
				if ($reset.length) {
					$reset.on('click tap', function (event) {
						event.preventDefault();
						step.deselect();
					});
				}
				previousStep = step;
			});
		},

		initializeDom: function () {
			var $window = $(window);
			// Bind hash change handlers
			$window.on('hashchange', $.proxy(this.hashChanged, this));
			// Store initial document title
			this.defaultTitle = Module.ContactWizard.titleGetter();
			// Create animator
			this.scrollAnimation = createAnimation({
				easing: $.easing.swing,
				animator: function (time, scrollTop) {
					$window.scrollTop(scrollTop);
				},
				startValueCalculator: function () {
					return $window.scrollTop();
				}
			});
		},

		// Scroll to the next step when we have selected a topic
		scrollToTopic: function (topic) {
			if (!topic) {
				return;
			}
			var step = topic.step;
			if (!step) {
				return;
			}
			// Only scroll to the current step on mobile since the items collapse anyway and we don’t know their height before they do, yielding an incorrect scroll position.
			// Also scrolling to the next step would hide the “show all” button that only just appeared…
			if (!this.isMobilePage) {
				step = step.nextStep;
			}
			if (!step) {
				return;
			}
			var pos = step.getContext().offset();
			if (!pos) {
				return;
			}

			var correctionElement = this.$ctx.parents('body').find('.modHeader .scsh-lvl2-container'),
				correction = 0;

			if (correctionElement.length) {
				correction = correctionElement.height() + 10;
			}

			debug.log('Tc.Module.ContactWizard > scrolling to', pos);
			this.scrollAnimation.start({
				endValue: pos.top - correction
			});
		},

		// Hash serialziation
		setHash: function (hash) {
			if (this.currentHash === hash) {
				return;
			}
			debug.log('Tc.Module.ContactWizard > setting hash to', hash);
			this.currentHash = hash;
			Module.ContactWizard.hashSetter(hash || '');
		},

		topicSelected: function (topic) {
			var hash = (topic && topic.name) || null;
			this.trackSelectionChange(topic);
			this.updateTitle(topic);
			this.setHash(hash);
			this.scrollToTopic(topic);
			if (topic && this.isMobilePage && topic.mobileResultLink) {
				document.location.replace(topic.mobileResultLink);
			}
			this.fire('topicSelected', topic);
		},

		// Hash deserialziation
		getHash: function () {
			var hash = Module.ContactWizard.hashGetter() || '';
			if (hash.charAt(0) === '#') {
				hash = hash.substring(1);
			}
			if (hash === this.currentHash) {
				// Same hash has already been set, do nothing
				return null;
			}
			debug.log('Tc.Module.ContactWizard > got changed hash', hash);
			return hash;
		},

		loadStateFromHash: function (hash) {
			if (hash === null) {
				return;
			}

			if (!this.steps || !this.steps.length) {
				return;
			}

			var topic = null;

			// Find topic by name
			for (var i = 0; i < this.steps.length && !topic; i += 1) {
				topic = this.steps[i].namedTopic(hash);
			}

			if (topic) {
				this.currentHash = hash;
				this.steps[0].selectTopic(topic);
			} else if (!hash) {
				this.steps[0].deselect();
			}
		},

		// @VisibleForTesting
		hashChanged: function () {
			var hash = this.getHash();
			this.loadStateFromHash(hash);
		},

		// Change the document title to match the topic
		updateTitle: function (topic) {
			var titles = [];

			while (topic) {
				titles.unshift(topic.getTitle());
				topic = topic.parent;
			}

			var newTitle = this.defaultTitle;
			if (titles.length) {
				newTitle = titles.join(': ') + ' – ' + newTitle;
			}
			debug.log('Tc.Module.ContactWizard > updating title to', newTitle);
			Module.ContactWizard.titleSetter(newTitle);
		},

		// perform click tracking on selection change
		trackSelectionChange: function (topic) {
			if (!topic) {
				return;
			}
			debug.log('Tc.Module.ContactWizard > trackSelectionChange >', topic);
			var label = topic.name || '', // currently selected button with top category prefix
				category = topic.parentTopicName || topic.name; // selected top category (or if already top category the topic itself)

			SCS.portal.datalayer.trackEvent('select', label, 'contactform', category, 'Contact Wizard');
		}
	});

	// All of these are mocked in testing
	$.extend(Module.ContactWizard, {
		hashSetter: function (hash) {
			window.location.hash = hash;
		},
		hashGetter: function () {
			return window.location.hash;
		},

		titleSetter: function (title) {
			document.title = title;
		},
		titleGetter: function () {
			return document.title;
		}
	});

})(__webpack_provided_window_dot_Tc_dot_$, window.Tc.Module, window.SCS, window.debug || window.console);

}.call(window));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_Tc_dot_$) {/*** IMPORTS FROM imports-loader ***/
var loadTerrific = __webpack_require__(1);
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function(Module, $, SCS) {
	'use strict';

	var HelpSearchResults = Module.extend({
		// The container module instance (for setting config changes and the like)
		searchContainer: null,

		on: function(callback) {
			callback();
		},

		after: function() {
			this.findElements();
		},

		initSearch: function(searchContainer) {
			this.searchContainer = searchContainer;
		},

		searchConfigChanged: function(config) {
			var query = config.query;
			this.loadResults(query);
			this.loadSpellchecker(query);
		},

		loadResults: function(query) {
			var mod = this;
			var path = this.path.replace('.html/', '.ajax.html/') + query;
			$.ajax({
				url : path,
				timeout : 10000,
				success : function(data) {
					mod.$searchresult.html(data);
					var nextButton = mod.$searchresult.find('.nextsearch');
					var items = mod.$searchresult.find('.articleresultitem');
					SCS.portal.initPaging(nextButton, items);
				}
			});
		},

		loadSpellchecker: function(query) {
			var mod = this;
			var path = this.path.replace('.html/', '.spellchecker.html/') + query;
			$.ajax({
				url : path,
				timeout : 10000,
				success : function(data) {
					mod.$spellchecker.html(data);
				}
			});
		},

		findElements: function() {
			var path = this.$ctx.attr('data-path');
			if(path.indexOf('.html') === -1) {
				path = path + '.html';
			}
			// Append slash after .html (the search term comes next)
			this.path = path.replace(/(\.html)\/?.*?$/, '$1/');
			this.$searchresult = this.$ctx.find('.searchresult');
			this.$spellchecker = this.$ctx.find('.spellchecker');
		}

	});

	Module.HelpSearchResults = HelpSearchResults;

})(window.Tc.Module, __webpack_provided_window_dot_Tc_dot_$, window.SCS = window.SCS || {});

}.call(window));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var loadTerrific = __webpack_require__(1);
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function($, w, SCS) {
	'use strict';
	/* globals Tc, debug */

	/**
	 * Module for Help Interactive Video component.
	 *
	 * @author Branislav Maksin
	 * @namespace Tc.Module
	 * @class InteractiveVideo
	 * @extends Tc.Module
	 * @version 1.2
	 */
	Tc.Module.InteractiveVideo = Tc.Module.extend({
		// jshint camelcase: false
		// FIXME: convert variables and properties to camelcase

		/**
		 * Default classes for this module
		 */
		SCS_INTERACTIVE_VIDEO_CLASS : 'scs-interactiveVideo',
		SCS_INTERACTIVE_VIDEO_BUTTON_CLASS : 'scs-interactiveVideo-button',
		SCS_INTERACTIVE_VIDEO_LOADER_CLASS : 'scs-interactiveVideo-loader',
		SCS_INTERACTIVE_VIDEO_CONTROL_CLASS : 'scs-interactiveVideo-controls',
		SCS_INTERACTIVE_VIDEO_REFERENT_WIDTH : 700,
		SCS_INTERACTIVE_VIDEO_REFERENT_HEIGHT : 394,

		/**
		 * Main function.
		 *
		 * @method on
		 * @param {Function} callback function
		 * @return void
		 */
		on : function(callback) {
			var mod = this,
				$ctx = mod.$ctx;

			// Module vars
			mod.isEditMode = $('.cq_isEditMode').length;
			mod.isMobilePage = SCS.utils.isMobilePage();
			mod.isEndless = w.location.search.indexOf('endless') !== -1;

			// Set special object for this module, iv = interactive_video
			mod.iv = {

				// Declare module array of processed videos
				videos_elements_byIDs: [],

				// Loader event
				loader_event: true,

				// Default video quality
				videoQuality: mod.isMobilePage ? 'default' : 'hd720',

				// Video buttons that are hidden
				hidden_buttons: [],

				// Create and store old and new URL when hash change
				// We are doing this because mighty IE doesn't support oldURL / newURL attributes on hash change
				old_url_onhashchange: '',

				// Store navigation buttons width for wrapper left animation
				control_buttons: {}
			};

			// Cache videos elements
			mod.iv.videos_elements = $('.' + mod.SCS_INTERACTIVE_VIDEO_CLASS + '-video', $ctx);
			mod.iv.videos_element = mod.iv.videos_elements.eq(0);

			// Get first video ID
			mod.iv.first_video_id = mod.iv.videos_elements.eq(0).data('videoid');

			// Get all buttons
			mod.iv.videos_buttons = mod.iv.videos_elements.find('.' + mod.SCS_INTERACTIVE_VIDEO_BUTTON_CLASS);

			// Cache navigation buttons element and buttons
			mod.iv.control_buttons_element = $('.' + mod.SCS_INTERACTIVE_VIDEO_CONTROL_CLASS, $ctx);
			mod.iv.control_buttons_elements = $('> span', mod.iv.control_buttons_element);

			if (mod.isMobilePage) {

				// Referent player size
				mod.iv.player = {};

				// Set mod.iv.player properties
				mod.setPlayerSizeForCompare(mod.iv.videos_element, true);

				// Start listening for window resize
				mod.onResizeChange();

			} else {

				// Since entire module is available in DOM we will now add qtip to every button images
				mod.iv.videos_buttons.find('> img').qtip();

				// Also add tooltip to navigation buttons
				$('.' + mod.SCS_INTERACTIVE_VIDEO_CONTROL_CLASS + ' > span', $ctx).qtip({
					position: {
						my: 'top center',
						at: 'bottom center'
					}
				});
			}

			// Start listening for hash tag
			mod.onHashChange();

			// Lets fire up the engine :)
			mod.getIDandStartProcessing();

			callback();
		},

		/**
		 * Helper function that count the occurrences of substring in a string
		 *
		 * @param string {String} Required. The string
		 * @param subString {String} Required. The string to search for
		 *
		 * @return n {Integer} Number of occurrences
		 */
		stringOccurrences : function (string, subString) {
			string += '';
			subString += '';

			var $n = 0,
				$pos = 0,
				$step = subString.length;

			if(subString.length <= 0) {
				return string.length + 1;
			}

			while(true) {
				$pos = string.indexOf(subString, $pos);
				if($pos >= 0) {
					$n += 1;
					$pos += $step;
				} else {
					break;
				}
			}

			return($n);
		},

		/**
		 * Helper function to calculate time format HH:MM:SS to seconds
		 *
		 * @params time {String} Time in format (HH:)MM:SS
		 */
		convertTimeToSeconds : function(time) {
			var timeArray = time.toString().split(':'),
				seconds = 0,
				minutes = 1;

			while (timeArray.length > 0) {
				seconds += minutes * parseInt(timeArray.pop(), 10);
				minutes *= 60;
			}

			return seconds;
		},

		/**
		 * We are monitoring hash change in URL for this module
		 * If hash changes, we then process video element with new ID from URL
		 */
		onHashChange : function() {
			var mod = this,
				newUrl, oldUrl;

			// Check if browser support hash change event
			if ('onhashchange' in w) {

				// Start hash change event
				w.onhashchange = function(event) {

					// Check if we are in IE
					if (typeof event !== 'undefined' && w.ActiveXObject === undefined) {
						newUrl = event.newURL;
						oldUrl = event.oldURL;
					} else {
						newUrl = location.href;
						oldUrl = mod.iv.old_url_onhashchange;
					}

					// Get ID from new URL and start processing it
					mod.processURLsForID(newUrl, oldUrl);
				};

			} else {

				// Browser doesn't support hash change event and we will mimic it
				setInterval(function() {

					// Get ID from new URL and start processing it
					mod.processURLsForID(location.href, mod.iv.old_url_onhashchange);
				}, 100);
			}
		},

		/**
		 * Process the video element with new ID from URL
		 *
		 * @param newUrl {String} Current URL
		 * @param oldUrl {String} URL before hash update
		 */
		processURLsForID : function(newUrl, oldUrl) {
			var mod = this,
				newUrlId,
				oldUrlId;

			// First check if we have interactive_video hash tag in new URL
			if (newUrl.indexOf('#interactive_video_' + mod.id + '=') !== -1) {
				newUrlId = mod.getVideoIDfromURL(newUrl);
				oldUrlId = mod.getVideoIDfromURL(oldUrl);

				// Then check if we have good ID from new URL if new video ID is different then old one (if present)
				if (mod.sanitizeVideoID(newUrlId) && newUrlId !== oldUrlId) {
					mod.getIDandStartProcessing(newUrlId);
				}
			} else {
				mod.getIDandStartProcessing(mod.iv.first_video_id);
			}
		},

		/**
		 * Get video ID from current or passed URL
		 *
		 * @param url {String} URL to get ID
		 *
		 * @return $video_id {String} YouTube video ID
		 */
		getVideoIDfromURL : function(url) {
			var mod = this,
				$video_id = '',
				$current_url = (typeof url !== 'undefined' ? url : location.href),
				$url_hashtag = $current_url.substr($current_url.indexOf('#') + 1);

			// Check hashtag for video ID
			if ($url_hashtag.indexOf('interactive_video_' + mod.id + '=') !== -1) {

				// Because URL can hold multiple hash tags we will split it by #
				$url_hashtag = $url_hashtag.split('#');
				$.each($url_hashtag, function(index, value) {
					if (value.indexOf('interactive_video_' + mod.id + '=') !== -1) {
						value = value.split('=');
						$video_id = value[1];
					}
				});
			}

			return $video_id;
		},

		/**
		 * Little sanitization of video ID
		 *
		 * @param video_id {String} YouTube video ID
		 *
		 * @return $video_id_test {Boolean} True if video is in good format, false otherwise
		 */
		sanitizeVideoID : function(video_id) {
			var $video_id_test = true,
				$id_regex_check = /^[\w-]+$/;

			// Lets perform a little sanity check of ID
			if (!$id_regex_check.test(video_id) || video_id.length < 11) {
				$video_id_test = false;
			}

			return $video_id_test;
		},

		/**
		 * Introduction function to get video ID and start processing corresponding video element
		 *
		 * @param video_id {String} YouTube video ID
		 */
		getIDandStartProcessing : function(video_id) {
			var mod = this;

			// Check if need to get video ID
			if (typeof video_id === 'undefined') {
				video_id = mod.getVideoID();
			}

			// Start processing ID
			if (video_id) {
				mod.processVideoID(video_id);
				mod.iv.currentVideo = video_id;
			} else {
				debug.log('Tc.Module.InteractiveVideo.js > Unable to get video ID for processing');
			}
		},

		/**
		 * Check URL for video ID or get from first video element
		 *
		 * @return $video_id {String} YouTube video ID
		 */
		getVideoID : function() {
			var mod = this,
				$video_id = mod.getVideoIDfromURL();

			// If video ID isn't found in current URL get ID from first video in component
			if (!$video_id) {
				$video_id = mod.iv.first_video_id;
			}

			// Check if ID is valid
			if(!mod.sanitizeVideoID($video_id)) {
				$video_id = '';
			}

			return $video_id;
		},

		/**
		 * Update current URL with videoID hash tag
		 *
		 * @param video_id {String} YouTube video ID
		 */
		updateURLHashTag : function(video_id) {
			var mod = this,
				$current_url = location.href,
				$url_hashtag = $current_url.substr($current_url.indexOf('#') + 1),
				$hashtag_count = mod.stringOccurrences($current_url, '#'),
				$new_hashtag;

			// Check if URL have hash tags
			switch ($hashtag_count) {

				// No hash tag
				case 0:
					$new_hashtag = 'interactive_video_' + mod.id + '=' + video_id;
					break;

				// Only one hash tag
				case 1:
					// mod.iv.first_video_id
					if ($url_hashtag.indexOf('interactive_video_' + mod.id + '=') !== -1) {
						$new_hashtag = 'interactive_video_' + mod.id + '=' + video_id;
					} else {
						$new_hashtag = $url_hashtag + '#interactive_video_' + mod.id + '=' + video_id;
					}
					break;

				// Two or more hash tags
				default:
					if ($current_url.indexOf('interactive_video_' + mod.id + '=') !== -1) {

						// This is a little tricky and we need to break it in order to replace video ID
						$url_hashtag = $url_hashtag.split('#');
						$.each($url_hashtag, function(index, value) {
							if (value.indexOf('interactive_video_' + mod.id + '=') !== -1) {
								value = value.split('=');
								$url_hashtag[index] = value[0] + '=' + video_id;
							}
						});

						// And now put it back together for update
						$new_hashtag = $url_hashtag.join('#');
					} else {
						$new_hashtag = $url_hashtag + '#interactive_video_' + mod.id + '=' + video_id;
					}

					break;
				}

				// Store old URL to
				mod.iv.old_url_onhashchange = $current_url;

				// Set video ID hash tag
				w.location.hash = $new_hashtag;
		},

		/**
		 * Main power plant for processing video ID
		 *
		 * @param video_id {String} YouTube video ID
		 */
		processVideoID : function(video_id) {
			var mod = this,
				foundVideoElement;

			// Check video ID
			if (typeof video_id === 'undefined') {
				debug.log('Tc.Module.InteractiveVideo.js > Please check video ID');
				return false;
			}

			// Now check if this element is already in mod.iv.videos_elements array
			if (typeof mod.iv.videos_elements_byIDs[video_id] === 'undefined') {
				foundVideoElement = mod.importVideoElement(video_id, true);
			} else {
				foundVideoElement = mod.importVideoElement(video_id);
			}

			// Check if we have video element by desired ID
			if (foundVideoElement) {

				// Process video buttons
				if (mod.isEditMode) {
					mod.prepareButtons(mod.iv.videos_elements);
				} else {
					mod.prepareButtons(mod.iv.videos_elements_byIDs[video_id]);
				}

				// Fire up YouTube API
				mod.youtubeAPI(mod.iv.videos_elements_byIDs[video_id]);

				// Player control buttons
				if (!mod.isEditMode) {
					mod.videoControls(mod.iv.videos_elements_byIDs[video_id]);
				}
			} else {
				debug.log('Tc.Module.InteractiveVideo.js > Couldn\'t find video element by data-videoid attribute equal to: ' + video_id);
			}
		},

		/**
		 * Import wanted video element into DOM
		 *
		 * @param video_id {String} YouTube video ID
		 * @param new_video_element {Boolean} Do we need to import new video element
		 *
		 * @return foundVideoElement {Boolean} Return true if element with video_id exist
		 */
		importVideoElement : function(video_id, new_video_element) {
			var mod = this,
				$video_element,
				foundVideoElement = false;

			// First hide all videos and then show needed one
			if (!mod.isEditMode) {
				mod.iv.videos_elements.hide();
			}

			// Now check if we need to assign new video element to mod.iv.videos_elements_byIDs object
			if (new_video_element === true) {
				$.each(mod.iv.videos_elements, function() {
					$video_element = $(this);

					if ($video_element.data('videoid') === video_id) {

						// Process and set video start and end time
						$video_element.start_seconds = mod.convertTimeToSeconds($video_element.data('startvideo'));
						$video_element.end_seconds = mod.convertTimeToSeconds($video_element.data('stopvideo'));

						// Show this video element
						$video_element.show();

						// Assign element
						mod.iv.videos_elements_byIDs[video_id] = $video_element;
						foundVideoElement = true;

						// Break from iteration
						return false;
					}
				});
			} else {
				mod.iv.videos_elements_byIDs[video_id].show();
				foundVideoElement = true;
			}

			return foundVideoElement;
		},

		/**
		 * Setup overlay buttons for video
		 *
		 * @param video_element {Object} Video element object
		 */
		prepareButtons : function(video_element) {
			var mod = this,
				$video_buttons = $('.' + mod.SCS_INTERACTIVE_VIDEO_BUTTON_CLASS, video_element),
				$button;

			// Reset hidden_buttons array if it's set
			if (mod.iv.hidden_buttons.length) {
				mod.iv.hidden_buttons = [];
			}

			// Check if we have buttons on this video
			if ($video_buttons.length) {

				// Iterate all buttons and setup necessary properties
				$.each($video_buttons, function() {
					$button = $(this);

					// On mobile we need to resize button to match video size
					if (mod.isMobilePage) {
						mod.resizeOverlayButtons($button);
					}

					// Set button position if needed
					mod.prepareButtonPosition(video_element, $button);

					// Now check if button has time table
					mod.checkButtonTimeTable(video_element.start_seconds, $button);

					// Finally check button URL and click event
					mod.addButtonEvent($button);
				});
			}
		},

		/**
		 * Set button position for middle column and center row
		 *
		 * @param video_element {Object} Video element object
		 * @param button {Object} Video button element
		 */
		prepareButtonPosition : function(video_element, button) {
			var mod = this,
				$button_image = button.find('> img');

			// Just in case check if we have button
			if (typeof button === 'undefined') {
				debug.log('Tc.Module.InteractiveVideo.js > Iterate function returned empty video button.');
			}

			// Check if the button is image
			if ($button_image.length) {
				if (mod.isLoaded(video_element)) {
					mod.overlayButtonsDimensions(button, button.width(), button.height());
				} else {
					$button_image.on('load', function(){
						mod.overlayButtonsDimensions(button, button.width(), button.height());
					});
				}
			} else {
				mod.overlayButtonsDimensions(button, button.width(), button.outerHeight(false));
			}
		},

		/**
		 * Button time table, if button has limited time window hide it and sent it to mod.iv.hidden_buttons array
		 *
		 * @param start_video_time {Integer} Video start time in seconds
		 * @param button {Object} Video button element
		 */
		checkButtonTimeTable : function(start_video_time, button) {
			var mod = this,
				$button_show_time = mod.convertTimeToSeconds(button.data('showtime'));

			// Check is this button should start with the video
			if ($button_show_time <= start_video_time) {
				button.css('visibility', 'visible');
			} else {
				button.show_time = $button_show_time;
				button.hide_time = mod.convertTimeToSeconds(button.data('hidetime'));
				mod.iv.hidden_buttons.push(button);
			}
		},

		/**
		 * Add button click event
		 *
		 * @param button {Object} Video button element
		 */
		addButtonEvent : function(button) {
			var mod = this,
				button_href = $.trim(button.attr('href')),
				buttonEvent = parseFloat(button.jquery) < 1.8 ? $.data(button[0], 'events') : $._data(button[0], 'events');

			// Check if button href contains video ID
			if (button_href.substring(0, 1) === '#' && button_href.length > 11 && !(buttonEvent || {}).hasOwnProperty('click')) {

				// Remove wcmmode and endless query parameters from href
				if (mod.isEndless && button_href.indexOf('&endless') !== -1) {
					button_href = button_href.replace('?wcmmode=disabled&endless', '');
					button.attr('href', button_href);
				}

				button.click(function(event) {
					event.preventDefault();

					// Update hash tag in URL
					if (!mod.isEditMode) {
						mod.iv.videos_buttons.css('visibility', '');
						mod.updateURLHashTag(button_href.substring(1));
					}
				});
			}
		},

		/**
		 * Start preparation for YouTube API
		 *
		 * @param video_element {Object} DOM video element object
		 */
		youtubeAPI : function(video_element) {
			var mod = this;

			// Declare onYouTubeIframeAPIReady function if needed
			if (typeof(w.onYouTubeIframeAPIReady) !== 'function') {
				w.onYouTubeIframeAPIReady = function() {

					// Set new YouTube API player
					mod.youtubePlayerStart(video_element);
				};
			} else {

				// We are just updating the player
				mod.youtubePlayerStart(video_element);
			}

			// Check if iframe API is loaded into document head
			if (w.YT === undefined) {
				mod.youtubeAPIScript('https://www.youtube.com/iframe_api');
			}
		},

		/**
		 * Helper function to add YouTube iframe API to document head
		 *
		 * @param url {String} Script URL to include into document head
		 * @param callback {Object} Callback when script was included and loaded
		 */
		youtubeAPIScript : function(url, callback) {
			var $document = document,
				$script = 'script',
				$iframeAPI = $document.createElement($script),
				$scripts = $document.getElementsByTagName($script)[0],
				$iframeApiState;

			// Set script object
			$iframeAPI.type = 'text/java' + $script;
			$iframeAPI.src = url;

			// Scripts that are dynamically created and added to the document are async by default
			$iframeAPI.async = false;

			// Check callback
			if (callback === 'function') {
				$iframeAPI.onreadystatechange = $iframeAPI.onload = function() {
					$iframeApiState = $iframeAPI.readyState;
					if (!callback.done && (!$iframeApiState || /loaded|complete/.test($iframeApiState))) {
						callback.done = true;
						callback();
					}
				};
			}

			// Insert it before first script in the head
			$scripts.parentNode.insertBefore($iframeAPI, $scripts);
		},

		/**
		 * Update YouTube player object or start creating new one
		 *
		 * @param video_element {Object} DOM video element object
		 */
		youtubePlayerStart : function(video_element) {
			var mod = this,
				$ctx = mod.$ctx;

			// Check if we already have declared YouTube player for this module
			if (typeof mod.iv.youtubePlayerObject !== 'undefined') {
				mod.iv.youtubePlayerObject.loadVideoById({
					'videoId': video_element.data('videoid'),
					'startSeconds': video_element.start_seconds,
					'endSeconds': video_element.end_seconds,
					'suggestedQuality': mod.iv.videoQuality
				});
			} else {

				// Preliminary check if we are in edit mode
				if (mod.isEditMode) {
					$('.' + mod.SCS_INTERACTIVE_VIDEO_CLASS + '-video', $ctx).each(function() {
						mod.youtubePlayer($(this));
					});
				} else {
					mod.youtubePlayer(video_element);
				}
			}
		},

		/**
		 * YouTube player object
		 *
		 * @param video_element {Object} DOM video element object
		 */
		youtubePlayer : function(video_element) {
			var mod = this,
				$ctx = mod.$ctx;

			// Create new Youtube player object
			mod.iv.youtubePlayerObject = new w.YT.Player(
				$('.' + mod.SCS_INTERACTIVE_VIDEO_CLASS + '-ytPlaceholder', (mod.isEditMode ? video_element : $ctx))[0], {

					// Player vars
					height: '100%',
					width: '100%',
					videoId: video_element.data('videoid'),
					playerVars: {
						autoplay: 0,
						controls: 1,
						enablejsapi: 1,
						modestbranding: 1,
						showinfo: 0,
						rel: 0,
						iv_load_policy: 3,
						vq: mod.iv.videoQuality,
						wmode: 'transparent',
						fs: 0,
						origin: encodeURIComponent(w.location.protocol + '//' + w.location.host),
						start: video_element.start_seconds,
						end: video_element.end_seconds
					},
					events: {
						'onReady': function() {

							// Hide loader when player is ready
							if (mod.iv.loader_event) {
								mod.loadingEvent();
							}
						},
						'onStateChange': function(event) {

							// Check if we have any buttons with time table
							if (mod.iv.hidden_buttons.length) {
								mod.monitorPlayerTime(event.data);
							}
						}
					}
			});
		},

		/**
		 * Check player status for playing, stop and paused event
		 *
		 * @param player_status {object} Player status retrieved from player event object
		 */
		monitorPlayerTime : function(player_status) {
			var mod = this;

			// Lets check player status
			switch (player_status) {

				// Playing
				case w.YT.PlayerState.PLAYING:

					// Hide
					if (mod.iv.youtubePlayerObject.getCurrentTime() <= 0.3) {
						mod.iv.videos_buttons.css('visibility', '');
					}

					// Set interval to check player time every 400 milliseconds
					mod.iv.play_time = setInterval(function() {
						mod.showHideVideoButtons(mod.iv.youtubePlayerObject.getCurrentTime());
					}, 400);

					break;

				// Ended or paused
				case w.YT.PlayerState.ENDED:
				case w.YT.PlayerState.PAUSED:
					clearInterval(mod.iv.play_time);
					break;
			}
		},

		/**
		 * Show and hide video buttons with time table
		 *
		 * @param time {Integer} Current player time in seconds point milliseconds
		 */
		showHideVideoButtons : function(time) {
			var mod = this;

			// Check hidden elements
			$.each(mod.iv.hidden_buttons, function() {

				// Check if we are ready to show this button
				if (this.show_time <= time) {
					this.css('visibility', 'visible');
				}

				// Check if we need to hide this button
				if (this.hide_time > 0 && (this.hide_time <= time || time < this.show_time)) {
					this.css('visibility', 'hidden');
				}
			});
		},

		/**
		 * Prepare control buttons for videos
		 *
		 * @param video_element {Object} DOM video element object
		 */
		videoControls : function(video_element) {
			var mod = this,
				$control_button,
				$previous_video_element = video_element.parent().prev().children('.' + mod.SCS_INTERACTIVE_VIDEO_CLASS + '-video'),
				$next_video_element = video_element.parent().next().children('.' + mod.SCS_INTERACTIVE_VIDEO_CLASS + '-video'),
				$video_id = video_element.data('videoid'),
				$control_buttons_width = 0;

			// Iterate transla each button and set it click action
			$.each(mod.iv.control_buttons_elements, function(index) {

				// Create jQuery object for this button
				$control_button = $(this);

				// Add buttons width to control buttons object
				if (mod.iv.control_buttons[index] === undefined) {
					mod.iv.control_buttons[index] = (parseInt($control_button.outerWidth(true), 10) / 2);
				}

				// Remove any previous attached clicks
				$control_button.off('click');

				// Start from beginning
				if ($control_button.hasClass(mod.SCS_INTERACTIVE_VIDEO_CONTROL_CLASS + '-beginning')) {
					if ($video_id !== mod.iv.first_video_id) {
						$control_button.show('slow').click(function() {
							mod.updateURLHashTag(mod.iv.first_video_id);
						});

						$control_buttons_width += mod.iv.control_buttons[index];

					} else {
						$control_button.hide('slow');
					}

				// Reload current video - always visible
				} else if ($control_button.hasClass(mod.SCS_INTERACTIVE_VIDEO_CONTROL_CLASS + '-reload')) {
					$control_button.show('slow').click(function() {
						if (mod.iv.youtubePlayerObject !== 'undefined') {
							mod.iv.youtubePlayerObject.loadVideoById({
								'videoId': $video_id,
								'startSeconds': video_element.start_seconds,
								'endSeconds': video_element.end_seconds,
								'suggestedQuality': mod.iv.videoQuality
							});
						} else {
							debug.log('Tc.Module.InteractiveVideo.js > YouTube player object "mod.iv.youtubePlayerObject" is undefined?');
						}
					});

					$control_buttons_width += mod.iv.control_buttons[index];

				// Previous video
				} else if ($control_button.hasClass(mod.SCS_INTERACTIVE_VIDEO_CONTROL_CLASS + '-previous')) {

					if ($previous_video_element.length) {

						$control_button.show('slow').click(function() {
							window.history.back();
						});
						$control_buttons_width += mod.iv.control_buttons[index];

					} else {
						$control_button.hide('slow');
					}

				// Next video
				} else if ($control_button.hasClass(mod.SCS_INTERACTIVE_VIDEO_CONTROL_CLASS + '-next')) {
					if ($next_video_element.length) {
						$control_button.show('slow').click(function() {
							mod.updateURLHashTag($next_video_element.data('videoid'));
						});
						$control_buttons_width += mod.iv.control_buttons[index];
					} else {
						$control_button.hide('slow');
					}
				}
			});

			// Set new left margin for navigation buttons
			mod.iv.control_buttons_element.animate({'margin-left': -$control_buttons_width});
		},

		/**
		 * Hide or show video loading overlay
		 * Currently we are only hiding it on first load
		 */
		loadingEvent : function() {
			var mod = this,
				$ctx = mod.$ctx,
				$loader_element = $('.' + mod.SCS_INTERACTIVE_VIDEO_CLASS + '-loader', $ctx);

			// Check loader status
			if ($loader_element.is(':visible')) {
				$loader_element
					.toggleClass(mod.SCS_INTERACTIVE_VIDEO_LOADER_CLASS + '-visible ' + mod.SCS_INTERACTIVE_VIDEO_LOADER_CLASS + '-hidden')
					.fadeOut('slow');

				mod.iv.loader_event = false;
			}
		},

		/**
		 * Set player size for comparison
		 *
		 * @param videos_element {Object} Main wrapper object for videos element
		 * @param referent {Boolean} Whether to get player referent size
		 */
		setPlayerSizeForCompare : function(videos_element, referent) {
			var mod = this;

			// Referent player size
			if (referent === true) {
				mod.iv.player.referent = mod.SCS_INTERACTIVE_VIDEO_REFERENT_WIDTH + mod.SCS_INTERACTIVE_VIDEO_REFERENT_HEIGHT;
			}

			// The player is different then referent dimensions, let's check how much
			mod.iv.player.resize_proportion = ((100 * (videos_element.width() + videos_element.outerHeight(true))) / mod.iv.player.referent).toFixed();
		},

		/**
		 * If window resize check the overlay buttons size
		 */
		onResizeChange : function() {
			var mod = this;

			// Start listening for resize event
			w.onresize = function() {
				mod.setPlayerSizeForCompare(mod.iv.videos_element);
				mod.prepareButtons(mod.iv.videos_elements_byIDs[mod.iv.currentVideo]);
			};
		},

		/**
		 * Because video is responsive on mobile devices,
		 * we will resize overlay buttons accordingly
		 *
		 * @param button {Object} Video button element
		 */
		resizeOverlayButtons : function(button) {
			var mod = this,
				$button_image = button.find('> img');

			// Just in case check if we have button
			if (typeof button === 'undefined') {
				debug.log('Tc.Module.InteractiveVideo.js > Iterate function returned empty video button.');
			}

			// Remove border from button
			button.css({
				'font-size': '',
				'line-height': ''
			});

			// Check referent dimensions
			if (mod.iv.player.resize_proportion !== 100) {

				// Check if button has image
				if ($button_image.length) {
					button.css('width', (($button_image.attr('width') * mod.iv.player.resize_proportion)) / 100 + 'px');

				// If not, try to resize font
				} else {
					if (mod.iv.player.resize_proportion > 100) {
						button.css({
							'font-size': mod.iv.player.resize_proportion + '%',
							'line-height': mod.iv.player.resize_proportion + '%'
						});
					}
				}
			}
		},

		/**
		 * Calculate and set negative margin for center and middle buttons
		 *
		 * @param button {Object} overlay button object
		 * @param button_width {Integer} button element width
		 * @param button_height {Integer} button element height
		 */
		overlayButtonsDimensions : function(button, button_width, button_height) {
			var mod = this;

			// Check for center column
			if(button.hasClass(mod.SCS_INTERACTIVE_VIDEO_BUTTON_CLASS + '-center') && button_width > 0) {
				button.css('margin-left', - (button_width / 2).toFixed() + 'px');
			}

			// Check for middle row
			if(button.hasClass(mod.SCS_INTERACTIVE_VIDEO_BUTTON_CLASS + '-middle') && button_height > 0) {
				button.css('margin-top', - (button_height / 2).toFixed() + 'px');
			}
		},

		/**
		 * Check if all images have been loaded
		 *
		 * @param video_element {Object} Video element object
		 *
		 * @return {Boolean} Whether or not has all images been loaded
		 */
		isLoaded: function($element) {
			return $element.find('img')
				.filter(function() {
					return this.complete;
				}).length > 0;
		}
	});
})(Tc.$, window, window.SCS = window.SCS || {});

}.call(window));

/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var loadTerrific = __webpack_require__(1);
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function ($, w) {
	'use strict';
	/* globals Tc, debug */

	/**
	 * Module for last visited help pages component.
	 *
	 * @author Branislav Maksin
	 * @namespace Tc.Module
	 * @class LastVisitedHelpPages
	 * @extends Tc.Module
	 */
	Tc.Module.LastVisitedHelpPages = Tc.Module.extend({

		/**
		 * Main function.
		 *
		 * @method on
		 * @param {Function} callback function
		 * @return void
		 */
		on: function (callback) {
			var mod = this;

			// First check if browser support localStorage
			if (typeof(w.localStorage) === "undefined") {
				return false;
			}

			//Do last visited pages
			mod.doLastVisitedPages();

			callback();
		},


		/**
		 * Check if last visited pages exist and display content
		 */
		doLastVisitedPages: function () {
			var mod = this,
				$ctx = mod.$ctx,
				$data;

			// Get the current page URL and make it available to everyone in this module
			mod.getCurrentURL();

			// Now check if we have a data
			$data = w.localStorage.getItem('scsLastVisitedPages');
			if ($data !== null) {
				$data = JSON.parse($data);
				$data = mod.updateComponentDiv($data);

				// Check do we need to store this url
				if ($ctx.closest('body').data('url-save')) {
					mod.checkLinksCount($data);
				}
			} else {
				// Check do we need to store this url
				if ($ctx.closest('body').data('url-save')) {
					mod.processURL({'scsLastVisitedLinks': []});
				}
			}
		},

		/**
		 * Get current page URL without tabs and other selectors in it
		 *
		 * @return $pageUrl {String} Current page URL
		 */
		getCurrentURL: function () {
			var mod = this,
				$pathname = w.location.pathname,
				$pathnameParts = $pathname.split('.');

			// Remove tabs and other selectors from pathname
			$pathname = $pathnameParts[0] + '.' + $pathnameParts[$pathnameParts.length - 1];
			mod.currentURL = w.location.protocol + '//' + w.location.hostname + $pathname;
		},

		/**
		 * Insert link list into component
		 *
		 * @param data {JSON} value from storage
		 *
		 * @return data {JSON} Processed data
		 */
		updateComponentDiv: function (data) {
			var mod = this,
				$ctx = mod.$ctx,
				dataItems = data.scsLastVisitedLinks,
				dataList = '<ul class="link-list">',
				i = 0;

			// Do we have proper data
			if (dataItems.length <= 4) {

				// Create list of data
				for (i; i < dataItems.length; i++) {
					if (dataItems[i].url === mod.currentURL) {
						dataItems.splice(i, 1);
						i--;
					} else {
						dataList += '<li class="item-' + i + '"><a href="' + dataItems[i].url + '">' + dataItems[i].title + '</a></li>';
					}
				}

				// Now check if we have any items to show after data iteration
				if (dataItems.length > 0) {

					// We are creating list elements this way because it's global fastest way
					// http://jsperf.com/jquery-element-creationyay/19
					$(dataList + '</ul>').appendTo($ctx);

					// Show module element
					$ctx.show();
				}

			} else {
				debug.log('Tc.Module.LastVisitedHelpPages.js > Storage returned more then 4 items');
			}

			// Return new data
			return data;
		},

		/**
		 * Check if for some strange reason we are having more than 3 items in data
		 * We are doing this because previous function should remove unnecessary URL from it
		 *
		 * @param data {JSON} value
		 */
		checkLinksCount: function (data) {
			var mod = this;

			// Trim it to first 3
			if (data.scsLastVisitedLinks.length > 3) {
				data.scsLastVisitedLinks.splice(3);
			}

			// Proceed to processing URL of the current page
			mod.processURL(data);
		},

		/**
		 * Insert current URL into data at first place
		 *
		 * @param data {JSON} value
		 */
		processURL: function (data) {
			var mod = this,
				$ctx = mod.$ctx,
				$pageTitle = document.title.split('|'),
				$pageData = {},

			// Set new link item
				$pageData = {
					url: mod.currentURL,
					title: $.trim($pageTitle[0])
				};

			// And add it to the data
			data.scsLastVisitedLinks.unshift($pageData);

			// Add URLs to localStorage
			w.localStorage.setItem('scsLastVisitedPages', JSON.stringify(data));
		}
	});
})(Tc.$, window);

}.call(window));

/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var loadTerrific = __webpack_require__(1);
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function($) {
	"use strict";
	/*globals Tc, doT, SCS */
	
	/**
	 * Module for Adobe Recommendations teaser component.
	 *
	 * @author Branislav Maksin
	 * @namespace Tc.Module
	 * @class RecommendationsTeaser
	 * @extends Tc.Module
	 */
	Tc.Module.RecommendationsTeaser = Tc.Module.extend({
		/**
		 * Hook function to do all of your module stuff.
		 *
		 * @method on
		 * @param {Function} callback function
		 * @return void
		 */
		on: function(callback) {
			var mod = this,
				$ctx = mod.$ctx,
				$h2 = $('h2', $ctx);
			
			// Check if Recommendations title is empty
			if ($h2.is(':empty')) {
				$h2.hide();
			}

			callback();
		}
	});
})(Tc.$);

}.call(window));

/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var loadTerrific = __webpack_require__(1);
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function($) {
	'use strict';

	/**
	 * Module for Help Tiles component.
	 *
	 * @author Walid Ghazzo, Sreten Ancic
	 * @namespace Tc.Module
	 * @class SupportCommunityBox
	 * @extends Tc.Module
	 */

	Tc.Module.SupportCommunityBox = Tc.Module.extend({

		// typeAhead config
		numOfItems: 3,
		minNumOfChars: 3,
		typeAheadTimeoutInMs: 300,

		// component config
		keywordPlaceholder: '_keyword_',
		supportstripNA: 'NA',
		classLinks: '.links',
		defaultSeachKeyword: SCS.search.searchKeywordDefaultText,
		cachedResults: {},
		selector: '.showform.',

		// session
		ssoSession: false,
		sscSession: false,
		sscProfile: false,
		ssoRedirect: false,

		// session initializer
		ssoSessionInit: false,
		sscSessionInit: false,
		sscProfileInit: false,

		// api handling
		sscApiURL: '//community.swisscom.ch/scs/restapi',
		sscApiPostSubject: "",
		sscApiPostContent: "",
		sscApiPostError: false,
		sscApiPostErrorMessage: false,
		sscApiUserID: "",
		sscApiFeedBack: {},
		sscBoardID: '',

		// error handling
		showForm: false,
		formError: false,
		formErrorPostSubject: false,
		formErrorPostContent: false,

		// i18n strings
		i18n: {},

		// other local variables
		jqXHR: {},
		typeAheadTimeoutId: null,

		/**
		 * hook function to do all of your module stuff.
		 *
		 * @method on
		 * @param {Function} callback function
		 * @return void
		 */

		on: function(callback) {
			var mod = this,
				$ctx = mod.$ctx,
				$link = $ctx.find(mod.classLinks),
				i18n = $ctx.find('.i18n');

			mod.sscApiFeedBack = $ctx.find('.apifeedback');
			mod.i18n = i18n.data();

			__webpack_require__(5).getProfile().then(function(profile) {
				mod.user = profile.getUser();
				mod.initClientSessions();
				mod.loadDefault($link);
				mod.makeItSearchable($link);
				mod.getRedirectSelector();
			});
			

			callback();
		},

		loadDefault: function($link) {
			//$('#searchKeywordDefaultText') not exists in DOM !!!!
			var keyword = encodeURI($('#search').val()),
				defaultKeyword = encodeURI($('#searchKeywordDefaultText').data('value'));

			this.loadSupportStrip($link, keyword, defaultKeyword);
		},

		loadSupportStrip: function($link, keyword, defaultKeyword, callback) {
			var url = $link.data('url'),
				currentPagePath = $link.data('currentpagepath'),
				parsedUrl = this.getUrl(url, keyword, defaultKeyword);

			if (parsedUrl != undefined) {
				this.loadFromUrl($link, parsedUrl, currentPagePath, callback);
			}
		},

		makeItSearchable: function($link) {
			var mod = this;
			if ($link.data('search-enabled')) {
				var url = $link.data('url'),
					$ctx = mod.$ctx,
					$input = $ctx.find('#questionsubject');
				mod.bindSearch($input, $link);
			}
		},

		bindSearch: function($input, $link) {
			var mod = this,
				oldValue = "";

			$input.on('change keyup input', function() {
				var value = $input.val();

				if (value != oldValue) {
					oldValue = value;

					clearTimeout(mod.typeAheadTimeoutId);

					if (value.length == 0) {
						mod.loadDefault($link);
					} else {
						mod.typeAheadTimeoutId = setTimeout(function () {
							if (value.length >= mod.minNumOfChars) {
								mod.loadSupportStrip($link, value, '');
							} else {
								$link.html(mod.i18n.minChars.replace('{i}', mod.minNumOfChars));
							}
						}, mod.typeAheadTimeoutInMs);
					}
				}
			});
		},

		getUrl: function(url, keyword, defaultKeyword) {
			var mod = this;

			if (url.indexOf(mod.keywordPlaceholder)!==-1) {
				if (keyword == mod.defaultSeachKeyword || keyword == '' || keyword == defaultKeyword) {
					keyword = mod.supportstripNA;
				}
				url = url.replace(mod.keywordPlaceholder, $.base64.encode(keyword).replace('=', ''));
			}
			return url;
		},

		loadFromUrl: function($link, url, currentPagePath, callback) {
			var mod = this;

			// kill the previous AJAX call
			if (mod.jqXHR && mod.jqXHR.abort) {
				mod.jqXHR.abort();
			}

			if (mod.cachedResults[url]) {
				$link.html(mod.cachedResults[url]);
				if (callback) {
					callback(mod.cachedResults[url]);
				}
			} else {
				$link.html(mod.i18n.searching);
				mod.jqXHR = $.get(url, {tagSrc:currentPagePath}, function(response, status) {
					$link.html(response);
					if (status != 'success' && status != 'notmodified') {
						$link.hide();
					} else {
						mod.cachedResults[url] = response;
						if (callback) {
							callback(response);
						}
					}
				});
			}
		},

		initClientSessions: function() {
			var mod = this;
			mod.ssoSessionCheck();
			mod.sscSessionCheck();
			mod.sscProfileCheck();
		},

// check session: swisscom sso portal ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

		ssoSessionCheck: function() {
			var mod = this;

			// check if user has active session in portal
			if (mod.user) {
				mod.ssoSession = true;
				debug.log('Tc.Module.SupportCommunityBox.js > ssoSessionCheck:SSO header logged in');
			}

			mod.ssoSessionInit = true;
			mod.sessionCallback();
		},

// check session: support community ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

		sscSessionCheck: function() {
			var mod = this;

			$.ajax({
				url: mod.sscApiURL + '/vc/authentication/sessions/login?restapi.response_format=json',
				dataType: 'json',
				success: function(data){
					mod.sscSessionInit = true;

					if (data.response.status == 'success'){
						mod.sscSession = true;
					}
					else if (data.response.status == 'error') {
						debug.log('Tc.Module.SupportCommunityBox.js > ' + data.response.error.code);
						debug.log('Tc.Module.SupportCommunityBox.js > ' + data.response.error.message);
					}
					else {
						debug.log('Tc.Module.SupportCommunityBox.js > API error');
					}

					debug.log('Tc.Module.SupportCommunityBox.js > sscSessionCheck:SC-API session status: ' + data.response.status);
					mod.sessionCallback();
				},
				error: function(data){
					mod.sscSessionInit = true;
					debug.log('Tc.Module.SupportCommunityBox.js > ' + data.response.status);
					mod.sessionCallback();
				}
			});
		},

// check profile: support community ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

		sscProfileCheck: function() {
			var mod = this;

			$.ajax({
				url: mod.sscApiURL + '/vc/authentication/sessions/current/user?restapi.response_format=json',
				dataType: 'json',
				success: function(data){
					mod.sscProfileInit = true;

					if(data.response.status == 'success' && data.response.user.email != undefined){
						if (data.response.user.email.$ != '') {
							mod.sscProfile = true;
							mod.sscApiUserID = data.response.user.id.$;
							debug.log('Tc.Module.SupportCommunityBox.js > sscProfileCheck:SC-API profile email: ' + data.response.user.email.$);
						}
					}
					else {
						mod.sessionCallback();
					}
					mod.sessionCallback();
				},
				error: function(){
					// api not accessible
					mod.injectMessage(mod.i18n.technicalError, 'formerror', true);
					mod.sscProfileInit = true;
					mod.sessionCallback();
				}
			});
		},

// session callback ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

		sessionCallback: function() {
			var mod = this;

			if (mod.ssoSessionInit && mod.sscSessionInit && mod.sscProfileInit) {
				if (mod.ssoSession && mod.sscSession && mod.sscProfile && mod.ssoRedirect) {
					mod.showForm = true;
					mod.gotoForm();
				} else if (mod.ssoSession && mod.sscSession && !mod.sscProfile) {
					// no profile
				}				
				else {
					// no session available - sso issues?
					// mod.injectMessage(mod.i18n.technicalError, 'formerror', true);
				}
			}

			debug.log('Tc.Module.SupportCommunityBox.js > sso portal session: ' + mod.ssoSession);
			debug.log('Tc.Module.SupportCommunityBox.js > sso portal redirect: ' + mod.ssoRedirect);
			debug.log('Tc.Module.SupportCommunityBox.js > sc community session: ' + mod.sscSession);
			debug.log('Tc.Module.SupportCommunityBox.js > sc community profile: ' + mod.sscProfile);
			debug.log('Tc.Module.SupportCommunityBox.js > sc show form: ' + mod.showForm);
		},

		gotoForm: function() {
			var mod = this,
				$ctx = mod.$ctx,
				step = $ctx.find('.scs-support-strip-help');

			if (mod.showForm) {
				step.removeClass('step1').addClass('step2');
				$('.noAnswerButton').click(function (e) {
					e.preventDefault();
					mod.validateQuestionForm();
				})
			}
			else {
				step.removeClass('step2').addClass('step1');
			}
		},

// check redirect selector ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

		getRedirectSelector: function() {
			var mod = this,
				currentURL = location.href;
				mod.ssoRedirect = currentURL.indexOf(mod.selector) != -1;

			debug.log('Tc.Module.SupportCommunityBox.js > getRedirectSelector: ' + mod.selector + ' : ' + mod.ssoRedirect);
			return mod.ssoRedirect;
		},

// validate form ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

		validateQuestionForm: function() {
			var mod = this;

			mod.sscApiPostSubject = $('#questionsubject').val();
			mod.sscApiPostContent = $('#questioncontent').val();

			mod.formErrorPostSubject = ($.trim(mod.sscApiPostSubject) == "");
			mod.formErrorPostContent = ($.trim(mod.sscApiPostContent) == "");

			debug.log('Tc.Module.SupportCommunityBox.js > validateQuestionForm: mod.sscApiPostSubject: ' + mod.sscApiPostSubject);
			debug.log('Tc.Module.SupportCommunityBox.js > validateQuestionForm: mod.sscApiPostContent: ' + mod.sscApiPostContent);

			if (mod.formErrorPostSubject || mod.formErrorPostContent) {
				mod.formError = true;
				mod.updateDisplayErrors();
			}
			else {
				mod.formError = false;
				mod.updateDisplayErrors();
				mod.submitQuestionForm();
			}
			debug.log('Tc.Module.SupportCommunityBox.js > validateQuestionForm: mod.formError: ' + mod.formError,'color: red');
			debug.log('Tc.Module.SupportCommunityBox.js > validateQuestionForm: mod.formErrorPostSubject: ' + mod.formErrorPostSubject);
			debug.log('Tc.Module.SupportCommunityBox.js > validateQuestionForm: mod.formErrorPostContent: ' + mod.formErrorPostContent);
		},

// show & hide errors based on validation ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

		updateDisplayErrors: function() {
			var mod = this,
				$ctx = mod.$ctx,
				feqs = $ctx.find('.formerror.questionsubject'),
				feqc = $ctx.find('.formerror.questioncontent');

			mod.formErrorPostSubject ? feqs.removeClass('hidden') : feqs.addClass('hidden');
			mod.formErrorPostContent ? feqc.removeClass('hidden') : feqc.addClass('hidden');
		},


// inject messages (non-form) ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

		injectMessage: function(message, cssclass, hideanswerbutton) {
			var mod = this,
				$ctx = mod.$ctx,
				button = $ctx.find('.noanswer');

			message					 = arguments[0] || "";
			cssclass					= arguments[1] || null;
			hideanswerbutton	= arguments[2] || false;

			mod.sscApiFeedBack.removeClass('hidden');

			if (hideanswerbutton) {
				button.hide();
			}

			if (cssclass !== null) {
				mod.sscApiFeedBack.removeClass();
				mod.sscApiFeedBack.addClass('apifeedback');
				mod.sscApiFeedBack.addClass(cssclass);
			}
			mod.sscApiFeedBack.html(message);
		},

// prepare api-request and submit ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

		submitQuestionForm: function() {
			var mod = this,
				$ctx = mod.$ctx;
				mod.sscBoardID = $ctx.find('.modScForm').data('sscboardid');

			$.ajax({
				url: mod.sscApiURL + '/vc/boards/id/' + mod.sscBoardID +'/messages/post/',
				dataType: 'json',
				data: {
					'message.subject': mod.sscApiPostSubject,
					'message.body': mod.sscApiPostContent,
					'message.author': '/users/id/' + mod.sscApiUserID,
					'restapi.response_format': 'json'
				},

				success: function(data){
					mod.sscProfileInit = true;
					if (data.response.status == 'success'){
						debug.log('Tc.Module.SupportCommunityBox.js > Success');
						debug.log('Tc.Module.SupportCommunityBox.js > ' + data.response);
						mod.confirmApiPost(data.response.message.id.$);
					}
					else {
						debug.log('Tc.Module.SupportCommunityBox.js > ' + data.response.error.message);
						mod.sscApiPostError = true;
						mod.sscApiPostErrorMessage = data.response.error.message;
						mod.sscApiFeedBack.addClass('formerror');
						mod.injectMessage('API error: ' + mod.sscApiPostErrorMessage);
					}
				},
				error: function(){
					mod.sscApiFeedBack.addClass('formerror');
					mod.injectMessage('API error');
				}
			});
		},

// prepare api-request and submit ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

		confirmApiPost: function(id) {
			var mod = this,
				$ctx = mod.$ctx,
				form = $ctx.find('.modScForm'),
				button = $ctx.find('.noanswer');

			$.ajax({
				url: mod.sscApiURL + '/vc/messages/id/' + id + '/web_page_url',
				dataType: 'json',
				data: {
					'restapi.response_format': 'json'
				},

				success: function(data){
					if (data.response.status == 'success'){
						debug.log('Tc.Module.SupportCommunityBox.js > Success');
						form.hide();
						button.hide();
						mod.sscApiFeedBack.addClass('success');
						mod.injectMessage(mod.i18n.postSuccessMessage, 'success', true);
						debug.log('Tc.Module.SupportCommunityBox.js > ' + data.response.string.$);

						setTimeout(function(){
							location.href = data.response.string.$;
						},3000);
					}
					else {
						debug.log('Tc.Module.SupportCommunityBox.js > Error' + data.response.error.message);
						// mod.sscApiPostError = true;
						// mod.sscApiPostErrorMessage = data.response.error.message;
					}
				},

				error: function(){
					debug.log('Tc.Module.SupportCommunityBox.js > API Error');
					debug.log('Tc.Module.SupportCommunityBox.js > ' + this.url);
				}
			});
		}
	});
})(Tc.$);

}.call(window));

/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {// userbox.js

/* globals $ */
$(function () {
	'use strict';

	var $userBox = $('#scs-pageheader-userbox');

	if (!$userBox.length) {
		return;
	}

	// Ensure expected data attributes are defined to avoid errors (DAC-15301)
	if ($userBox.data('login-url') === undefined) { $userBox.data('login-url', ''); }
	if ($userBox.data('logout-url') === undefined) { $userBox.data('logout-url', ''); }

	var currentPage = encodeURIComponent(location.href),
		loginUrl = $userBox.data('login-url').replace(/originUrl=[^&]*/, 'originUrl=' + currentPage),
		$logoutButton = $userBox.find('#scs-pageheader-userbox-logout-button'),
		logoutUrl,
		logoutButtonUrl;

	// update originUrl and RURL to point to current page (except for pex logout URL)
	// (otherwise they would point to the responsive-header config page, due to SSI cached header)
	$userBox.data('login-url', loginUrl);
	if (!$userBox.data('is-pex')) {
		logoutUrl = $userBox.data('logout-url').replace(/RURL=[^&]*/, 'RURL=' + currentPage);
		logoutButtonUrl =($logoutButton.attr('href') || '').replace(/RURL=[^&]*/, 'RURL=' + currentPage);

		$userBox.data('logout-url', logoutUrl);
		$logoutButton.attr('href', logoutButtonUrl);
	} else {
		//update domain for PEX

		var getRurl = function (url) {
			var result = /RURL=([^&]*)/.exec(url);
			if (result && result.length === 2) {
				return decodeURIComponent(result[1]);
			}
			return false;
		}

		var getHost = function (url) {
			var aTag = $('<a />', {href: url})[0];
			return aTag.protocol + '//' + aTag.host;
		}

		var logoutUrlRurl = getRurl($userBox.data('logout-url')),
			logoutButtonRurl = getRurl($logoutButton.attr('href')),
			currentHost = getHost(location.href);

		if (logoutUrlRurl && currentHost !== getHost(logoutUrlRurl)) {
			logoutUrlRurl = logoutUrlRurl.replace(getHost(logoutUrlRurl), currentHost);
			logoutUrl = $userBox.data('logout-url').replace(/RURL=[^&]*/, 'RURL=' + encodeURIComponent(logoutUrlRurl));
			$userBox.data('logout-url', logoutUrl);
		}

		if (logoutButtonRurl && currentHost !== getHost(logoutButtonRurl)) {
			logoutButtonRurl = logoutButtonRurl.replace(getHost(logoutButtonRurl), currentHost);
			logoutButtonUrl = $userBox.data('logout-url').replace(/RURL=[^&]*/, 'RURL=' + encodeURIComponent(logoutButtonRurl));
			$logoutButton.attr('href', logoutButtonUrl);
		}

	}


	// clear the mini basket's item count (cart-itemcount) on logout
	$logoutButton.click(function () {
		$.cookie('SCSMiniShoppingCart', '', {
			'path': '/'
		});
		$('#shoppingCartLink .cart-itemcount').remove();
		return true;
	});
});

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($, jQuery) {/* globals $, SCS, debug */


// ************************************************************************
// Tracking implementation and helpers
// ************************************************************************

// some trackings are called very early and there is a high chance
// tealium and the datalayer are not yet initialized. Queue these
// calls and execute them once datalayer/tealium is initialized.
// newer versions will support getAnalyticsPageName(callback)
var trackingQueue = [];
var scheduledCheck = false;

// return if tealium and datalayer are ready
function isTrackingReady() {
	return SCS.tealium && SCS.tealium.isReady()
		&& SCS.datalayer.getAnalyticsPageName
		&& SCS.datalayer.getAnalyticsPageName();
}

// check if tracking is ready and process queued events
// ToDo: datalayer should offer us a callback hook!
function checkTrackingState() {
	if (isTrackingReady()) {
		processTrackingQueue();
	} else if (!scheduledCheck) {
		scheduledCheck = true;
		setTimeout(function () {
			scheduledCheck = false;
			checkTrackingState();
		}, 80);
		debug.log('res-sme-cbu-popup: waiting for datalayer');
	}
}

// process all queued tracking events
function processTrackingQueue() {
	var location = SCS.datalayer.getAnalyticsPageName();
	while (trackingQueue.length > 0) {
		var data = trackingQueue.shift();
		debug.log('res-sme-cbu-popup: process queued tracking', location, data);
		SCS.portal.datalayer.trackEvent(data.action, data.label, location, data.category);
	}
}

// track as soon as tealium/datalayer is ready
function trackDefered(action, label, category) {
	trackingQueue.push({
		action: action,
		label: label,
		category: category
	});
	checkTrackingState();
}

// ************************************************************************
// Dialog implementation
// ************************************************************************
var modal = __webpack_require__(7).default;
var Segment = __webpack_require__(14).Segment;
// ************************************************************************

var user = undefined;
var userBox = undefined;
__webpack_require__(5).getProfile().then(function(profile) {
	// Wait for DOMContentLoaded to ensure UserBox is available
	$(function ready() {
		userBox = __webpack_require__(32).getGlobalUserBox();
		user = profile.getUser();
		var userSegment;
		var labelSegment;

		if(user) {
			// Get user segment from user profile
			userSegment = user.getSegment();
			if (typeof(userSegment) !== 'string') return;
			userSegment = userSegment.toLowerCase();
			labelSegment = userSegment !== 'res' ? 'biz' : 'res';
			handleLoginState(userSegment, true);

			// Set cookie so we have segment information (from previous login)
			// When user is not logged in (sometimes also known as SME Cookie)
			jQuery.cookie('SCSUserSegment', userSegment, {
				'expires' : 365 , 'path' : '/'
			});
		} else {
			// Get user segment from previously stored cookie
			userSegment = jQuery.cookie('SCSUserSegment');
			if (typeof(userSegment) !== 'string') return;
			userSegment = userSegment.toLowerCase();
			handleLoginState(userSegment, false);
		}
	});
});

function getStorageKey(userSegment) {
	return 'SCS_' +
		userSegment.toUpperCase() +
		'_CALLOUT_CLOSED';
}

/** Check if user already saw the popup */
function sawDialog(userSegment, isLoggedIn) {

	var storageKey = getStorageKey(userSegment === 'res' ? 'res' : 'biz');
	// SessionStorage is cleared after UA close or new Tab
	var storageValue = !!sessionStorage.getItem(storageKey);
	// Users can only persist setting if they are not logged in.
	storageValue |= !isLoggedIn && !!localStorage.getItem(storageKey);

	// Disabled since cookie seems to be never set anywhere?
	// if (!storageValue && jQuery.cookie(storageKey) == '1') {
	// 	sessionStorage.setItem(storageKey, true)
	// 	return true;
	// }

	return storageValue;

}

/** Show dialog to chose to switch segments */
function showDialog(userSegment, isLoggedIn) {

	var $dialogLabels = jQuery('DIV.res-sme-cbu-callout');
	var labels = $dialogLabels.data("labels");
	var labelSegment = userSegment !== 'res' ? 'biz' : 'res';
	var storageKey = getStorageKey(labelSegment);

	// Suppress popup without having useful labels
	if ($dialogLabels.length == 0 || !labels) {
		return;
	}

	function i18n(name) {
		if (!labels[name]) return name;
		return labels[name][labelSegment] ||
			labels[name]['res'] ||
			labels[name] ||
			name;
	}

	function persitCloseState(canceled) {
		// Checkbox will only be available if user is not logged in
		// So in case user is logged in we always use sessionStorage
		if($checkbox.prop('checked')) {
			localStorage.setItem(storageKey, true);
		}
		// Always remember choice for session
		sessionStorage.setItem(storageKey, true);
	}

	var $wrapper = jQuery('<div class="checkbox checkbox--inverted"></div>')
	var $checkbox = jQuery('<input type="checkbox" id="dontShowAgain"></input>')
	var $label = jQuery('<label for="dontShowAgain"> ' + i18n('dontShowAgain') + '</label>');
	var $html = jQuery('<form>').append($wrapper.append($checkbox, $label));

	// Show SDXModalDialog
	modal.show({
		class: 'col-xs col-md-10 col-lg-8 col-xl-6',
		title: i18n('title'), text: i18n('message'),
		html: isLoggedIn ? undefined : $html,
		buttons: [{
			title: i18n('change'),
			primary: true,
			type: 'close'
		}, {
			title: i18n('close'),
			primary: false,
			type: 'cancel'
		}],
		on: {
			close: function() {
				persitCloseState(false);
				// defer to allow tracking
				setTimeout(function() {
					var getShopUrl = userBox['get' +
						userSegment.substr(0,1).toUpperCase() +
						userSegment.substr(1).toLowerCase() +
					'ShopUrl'];
					if (getShopUrl) {
						var url = getShopUrl.call(userBox);
						if (url) { document.location = url; }
					}
				}, 85);
				// Closed via "change segment" button
				trackDefered('button', 'change-cfu', 'cfu-suggestion');
			},
			cancel: function() {
				persitCloseState(true);
				// Closed via "cancel" or any other mean
				trackDefered('close', 'close cfu-suggestion', 'cfu-suggestion');
			}
		}
	});

	// Track the open event immediately (but wait for datalayer)
	trackDefered('open', 'open cfu-suggestion', 'cfu-suggestion');

}

/** Check if user should see the popup */
function wantsDialog(userSegment, isLoggedIn) {

	var $body = $(document.body);
	// Do not show popup on ent and home pages.
	if($('[data-is-exclude-popup="true"]').length) { return false; }
	if($('[data-is-level-null-page="true"]').length) { return false; }

	// We need to wait a little to fetch this?
	// AEM does something weird with body tag?
	var pageSegment = $body.data('page-segment');

	// Help page doesn't have pageSegment
	if (pageSegment == undefined) { return false; }
	// Checks taken exactly from previous code
	if (userSegment == undefined) { return false; }
	if (userSegment === 'undefined') { return false; }
	// Don't show when user is in correct segment
	if (userSegment === pageSegment) { return false; }

	// Print out a debug message
	var msg = 'res-sme-callout: logged';
	var state = isLoggedIn ? '-in' : '-out';
	debug.log(msg + state, userSegment, 'user in', pageSegment);

	// Do not show for SME-customers in CBU or CBU-customers in SME
	if (userSegment === Segment.SME && pageSegment === Segment.CBU) { return false; }
	if (userSegment === Segment.CBU && pageSegment === Segment.SME) { return false; }
	// Only show dialog for not logged in SME users (copied from cbu.js)
	if (userSegment !== Segment.SME && isLoggedIn === false) { return false; }

	// Show otherwise
	return true;

}

/** Called once login state is determined */
function handleLoginState(userSegment, isLoggedIn) {
	if (wantsDialog(userSegment, isLoggedIn)) {
		if (!sawDialog(userSegment, isLoggedIn)) {
			showDialog(userSegment, isLoggedIn);
		}
	}
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0), __webpack_require__(0)))

/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_scsHeaderJQuery) {/*** IMPORTS FROM imports-loader ***/
var loadTerrific = __webpack_require__(1);
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function (Tc, $, doT) {
	'use strict';

	var deparam = __webpack_require__(8).default;

	function getNumberOfItemsInBasket() {
		// Read number of basket items from cookie and add it to shopping basket link
		var shoppingCartQuery = ($.cookie || $.noop)('SCSMiniShoppingCart') || '';
		// Use deparam if available
		shoppingCartQuery = deparam(shoppingCartQuery);
		// Get number of items in basket or 0 and display in indicator
		return (shoppingCartQuery && shoppingCartQuery.qty) || 0;
	}

	/**
	 * Basket module implementation.
	 *
	 * @author
	 * @namespace Tc.Module
	 * @class Basket
	 * @extends Tc.Module
	 */
	Tc.Module.Basket = Tc.Module.extend({

		on: function (callback) {
			var mod = this;
			mod.groupTpl = doT.template(mod.$ctx.find('.scsh-tmpl-basket-group').html());
			mod.itemTpl = doT.template(mod.$ctx.find('.scsh-tmpl-basket-item-group').html());

			mod.updateBasketNumberIndicator();
			mod.initShoppingCartMini();

			callback();
		},

		initShoppingCartMini: function () {
			var mod = this,
				$ctx = mod.$ctx;

			var url = $ctx.find('.scsh-basket-cartmini').data('url');

			$ctx.find('.scsh-header-icon').click(function () {

				// todo just get the closes with position : relative
				var rightDisp = ($('.scsh-icon-menu li:visible:last').offset().left + $('.scsh-icon-menu li:visible:last').width()) - $('.modBasket').offset().left - $ctx.width() / 2;
				$ctx.find('.scsh-flyout-panel').css('right', '-' + rightDisp + 'px');

				$ctx.trigger('scsh-flyout-open');

				// Write the resume shopping link cookie on Shopping cart link click (FR 14608)
				$.cookie('SCSResumeShoppingLink', window.location.href, {
					'path': '/'
				});

				mod.updateBasketNumberIndicator();
				$ctx.find('.scsh-basket-cartmini>div').hide();
				$ctx.find('.scs-loadingRotator').show();

				$.ajax({
					type: 'GET',
					url: url,
					dataType: 'json',
					success: function (json) {
						var i;

						if (json && json.BasketItems && json.BasketItems.length) {
							$('.scsh-basket-total .onetimecharge').html(json.OneTimeChargeFormatted);
							$('.scsh-basket-total .recurringcharge').html(json.RecurringChargeFormatted);
							$('.scsh-basket-cartmini-inner .scsh-basket-content').html('');

							// cart items
							for (i = 0; i < json.BasketItems.length; i += 1) {
								var groupItems = (json.BasketItems[i].ChildrenItems) ? json.BasketItems[i].ChildrenItems.length + 1 : 1;
								var itemHtml = '';
								for (var j = 0; j < groupItems; j += 1) {

									itemHtml += mod.itemTpl({
										basketItem: (j === 0) ? json.BasketItems[i] : json.BasketItems[i].ChildrenItems[j - 1],
										isFirst: j === 0
									});

								}
								$('.scsh-basket-cartmini-inner .scsh-basket-content').append(mod.groupTpl({
									inner: itemHtml
								}));
							}
							$ctx.find('.scsh-basket-cartmini-inner').show();
						} else {
							// empty cart
							$ctx.find('.scsh-basket-cartmini-empty').show();
							$ctx.find('.scsh-header-icon sup').remove();
						}
						$ctx.find('.scs-loadingRotator').hide();
					},
					error: function (error) {
						// If empty response (JSON parse error)
						if (error.status === 200) {
							$ctx.find('.scsh-basket-cartmini-empty').show();
							$ctx.find('.scsh-header-icon sup').remove();
							$ctx.find('.scs-loadingRotator').hide();
						}
					}
				});

			});

		},

		// Refactor warning: this may be called from the outside.
		updateBasketNumberIndicator: function () {
			var $ctx = this.$ctx;
			var basketItems = getNumberOfItemsInBasket();
			$ctx.find('.scsh-header-icon sup').attr('data-item-count', basketItems);
		}
	});

	// Export for others to use
	Tc.Module.Basket.getNumberOfItemsInBasket = getNumberOfItemsInBasket;

}(window.Tc, __webpack_provided_window_dot_scsHeaderJQuery, window.doT));

}.call(window));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_scsHeaderJQuery) {/*** IMPORTS FROM imports-loader ***/
var loadTerrific = __webpack_require__(1);
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function (Tc, $) {
	'use strict';

	/**
	 * Flyout module implementation.
	 *
	 * @author
	 * @namespace Tc.Module
	 * @class Flyout
	 * @extends Tc.Module
	 */
	Tc.Module.Flyout = Tc.Module.extend({
		on: function(callback) {
			var mod = this;

			mod.closeCallbacks = [];

			mod.createClickAwayHandler();

			mod.$ctx.on('scsh-flyout-open', function(event, closeCallback) {
				if(closeCallback) {
					mod.registerCloseCallback(closeCallback);
				}
				mod.openFlyout();
			});
			mod.$ctx.on('scsh-flyout-close', function() { mod.closeFlyout(); });

			mod.$panel = mod.$ctx.find('.scsh-flyout-panel');
			callback();
		},

		createClickAwayHandler : function () {
			var mod = this,
				$ctx = mod.$ctx;

			this.bodyClickAwayFlyout = function(e) {
				if (mod.$panel.is(e.target) ||
					$.contains(mod.$panel[0], e.target)) {
					return;
				}
				if($ctx.is('.scsh-flyout-open')) {
					mod.closeFlyout();
				}
			};
			this.bodyEscAwayFlyout = function(e) {
				if (e.which === 27 && $ctx.is('.scsh-flyout-open')) { // ECS key
					mod.closeFlyout();
				}
			};
		},

		registerCloseCallback : function(cb) {
			this.closeCallbacks.push(cb);
		},

		openFlyout : function() {
			var mod = this,
				$ctx = mod.$ctx;

			if (!$ctx.is('.scsh-flyout-open')) {

				$ctx.addClass('scsh-flyout-open');
				setTimeout(function() { $ctx.addClass('scsh-flyout-open-anim'); }, 1);
				setTimeout(function() {
					$('body').on('click', mod.bodyClickAwayFlyout);
					$('body').on('keydown', mod.bodyEscAwayFlyout);
				}, 0);
			}
		},

		closeFlyout : function() {
			var mod = this,
				$ctx = mod.$ctx;

			$('body').off('keydown', mod.bodyEscAwayFlyout);
			$('body').off('click', mod.bodyClickAwayFlyout);

			$ctx.removeClass('scsh-flyout-open-anim');
			$ctx.removeClass('scsh-flyout-open');

			for(var i = 0; i < mod.closeCallbacks.length; i+=1) {
				mod.closeCallbacks[i]();
			}
			mod.closeCallbacks = [];
		}
	});
}(window.Tc, __webpack_provided_window_dot_scsHeaderJQuery));

}.call(window));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_Tc_dot_$) {/*** IMPORTS FROM imports-loader ***/
var loadTerrific = __webpack_require__(1);
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function (Tc, $, SCS, debug) {
	'use strict';

	/**
	 * Responsive Footer
	 *
	 * @author Cesar Keller
	 * @namespace Tc.Module
	 * @class Footer
	 * @extends Tc.Module
	 */
	Tc.Module.Footer = Tc.Module.extend({

		on: function (callback) {
			var mod = this,
				$ctx = mod.$ctx;

			mod.lessVars = SCS.utils.getLessVars($ctx) || { mobile: { breakpoint: 768 } };

			if (!$('body.is-mobile').length) {
				// only init the responsive parts if we're not in NEVIS forced mobile mode -> there the desktop clientlib is missing and some of the new headers parts relies on it
				mod.initResponsiveness();
			} else {
				$ctx.addClass('scsh-mobile');
				debug.log('Tc.Module.Footer > forced mobile mode (non-responsive)');
			}

			mod.initLanguageSwitch();

			callback();
		},

		initLanguageSwitch: function () {
			var mod = this,
				$links = mod.$ctx.find('.scs-footer-lang-switch a');

			if (!$links.length) {
				return;
			}
			function updateLinks() {
				$links.each(function () {
					this.hash = location.hash;
					mod.log('updated hash', this.href);
				});
			}
			$(window).on('hashchange', updateLinks);
			updateLinks();
		},

		initResponsiveness: function () {
			var mod = this,
				$ctx = mod.$ctx,
				$window = $(window);

			function checkWidth() {
				if (!mod.lessVars.mobile) {
					debug.error('lessVars.mobile is missing!', mod.lessVars);
					mod.lessVars.mobile = { breakpoint: 768 };
				}
				var isMobile = $window.width() <= Number(mod.lessVars.mobile.breakpoint);

				$ctx.toggleClass('scsh-mobile', isMobile);
				$ctx.toggleClass('scsh-desktop', !isMobile);
				debug.log('Tc.Module.Footer > initResponsiveness', $ctx.attr('class'), isMobile ? 'isMobile' : 'isDesktop');
			}
			$window.on('load resize', checkWidth);
			checkWidth();
		}
	});
}(window.Tc, __webpack_provided_window_dot_Tc_dot_$, window.SCS, window.debug));

}.call(window));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_scsHeaderJQuery) {/*** IMPORTS FROM imports-loader ***/
var loadTerrific = __webpack_require__(1);
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function (Tc, $, SCS, debug) {
	'use strict';

	/**
	 * Header module implementation.
	 *
	 * @author Rami Attallah & Dave Talamona
	 * @namespace Tc.Module
	 * @class Header
	 * @extends Tc.Module
	 */
	Tc.Module.Header = Tc.Module.extend({

		$win: $(),
		$lvl2Container: $(),
		$maxAvailableWidthElement: $(),

		width: 0,
		lessVars: {},

		isMobile: false, // indicates whether the header is in its mobile view with a burger instead of visible navigation (not the "normal" backend mobile/desktop switch)
		isSemiMobile: false, // indicates whether the header is in its semi-mobile view with a burger instead of visible navigation because the navigation items take more space then available
		isDesktop: false,

		breakPoints: {
			smallerLogoSpacing: 0,
			smallerTextSpacing: 0,
			smallerText: 0,
			semiMobile: 0
		},

		on: function (callback) {
			var mod = this;

			// init module-globals
			mod.$win = $(window);
			mod.$lvl2Container = mod.$ctx.find('.scsh-dynamic');
			mod.$maxAvailableWidthElement = mod.$ctx.find('.scsh-lvl1-container');
			mod.width = mod.$maxAvailableWidthElement.width();
			mod.lessVars = SCS.utils.getLessVars(mod.$ctx) || { mobile: { breakpoint: 768 } };
			mod.breakPoints.semiMobile = Number(mod.lessVars.mobile.breakpoint);

			if (!$('body.is-mobile').length) {
				// only init the responsive parts if we're not in NEVIS forced mobile mode -> there the desktop clientlib is missing and some of the new headers parts relies on it
				mod.initResponsiveness();
			} else {
				mod.isMobile = true;
				mod.$ctx.addClass('scsh-mobile');
				debug.log('Tc.Module.Header > forced mobile mode (non-responsive)');
			}
			mod.$ctx.addClass('is-initialized');

			mod.initMddHeight();

			mod.$ctx.find('.scsh-icon-menu > li > a').on('click', function (event) {
				var $this = $(this),
					item = $this.parent(),
					isActivate,
					burgerNav;

				// deactivate other active items
				{
					// other LIs on the same level
					item.siblings('.active').removeClass('active');

					// other lists on the same level with active LIs (eg. for scsh-icon-menu vs. item-menu)
					item.parent().siblings().children('.active').removeClass('active');
				}

				item.toggleClass('active');

				// burger menu
				if (item.hasClass('burger')) {
					isActivate = item.hasClass('active');
					burgerNav = mod.$ctx.find('.menu-items');
					if (isActivate) {
						burgerNav.find('.scsh-search-hidden-menus').removeClass('scsh-search-hidden-menus');
						mod.$win.scrollTop(0);
						burgerNav.scrollTop(0);
					}
					burgerNav.toggleClass('active', isActivate);
					$this.blur();

					if (mod.isMobile) {
						mod.$ctx.toggleClass('is-sticky', isActivate);
						debug.log('Tc.Module.Header > is-sticky', isActivate);
						if (isActivate) {
							// Wait a bit until the menu slides in a bit and has enough place,
							// otherwise browser will scroll to focus the search box into view ...
							setTimeout(function() {
								mod.$ctx.find('.modSiteSearch.skinSiteSearchMobileMenu input[name=q]').trigger('click').trigger('focus');
								mod.$ctx.find('.skinFusionSearchMobileMenu input[data-name=query]').trigger('click').trigger('focus');
							}, 250);
						}
					}

					if (isActivate && mod.isSemiMobile) {
						// set the menu to fixed width, based on the first level of entries, because it should no change its width anymore, once its opened:
						// PORTAL-9064
						setTimeout(function () {
							burgerNav.css('width', burgerNav.width() + 2 + 'px'); // plus 2 because else its not enough
						}, 6);
					}
				}

				// This makes the MDD animate promptly and makes click tracking asynchronous.
				if (!item.data('dont-prevent-click')) {
					event.preventDefault();
				}
			});

			// close MDD and icon-tools (search, etc.) on click outside
			$(document).on('click', function (e) {
				if (!$(e.target).closest('.scsh-icon-menu, .menu-items').length && !($('.scs-sitesearchcontainer-plus').length || $('.scs-sitesearchcontainer').length)) {
					mod.$ctx.find('.scsh-icon-menu > li.active, .menu-items > li.scsh-has-subnav.active').not(':has(> .modFlyout)').find('> a, .lvl1-item a').trigger('click');
				}
			});

			mod.$ctx.find('.scsh-lvl2-container.scsh-has-child-pages h1').on('click', function () {
				if (mod.isMobile) {
					$(this).toggleClass('active').closest('.scsh-lvl2-container').find('.scsh-lvl2-navi').toggleClass('active');
				}
			});

			// make dev life easier
			if (location.search.match(/\bdebugmenu\b/)) {
				mod.$ctx.find('.scsh-icon-menu .burger > a').click();
				mod.$ctx.find('.menu-items .lvl1-item:eq(0) > a').click();
			}

			mod.initTrackingLinkName();

			mod.initLanguageSwitch();

			callback();
		},

		initLanguageSwitch: function () {
			var mod = this,
				$links = mod.$ctx.find('.scsh-language-switch-list a');

			if (!$links.length) {
				return;
			}
			function updateLinks() {
				$links.each(function () {
					this.hash = location.hash;
					mod.log('updated hash', this.href);
				});
			}
			$(window).on('hashchange', updateLinks);
			updateLinks();
		},

		setHeaderTitle: function(newTitle) {
			this.$ctx.find('.scsh-lvl2-container h1').text(newTitle);
		},

		initTrackingLinkName: function () {
			var mod = this;
			mod.findTrackingLinks().on('click', mod.handleTrackingLinkClick);
			mod.$ctx.find('.secondary-navigation .link .aTag').on('click', function(e) {
				var isSticky = !!$(this).parents('.scsh-dynamic.is-sticky').length;
				var $mddLvl1Link = $(this).closest('.scsh-has-subnav').find('h2 a'),
					mddLvl1 = $mddLvl1Link.data('tracking-link-name') || $mddLvl1Link.text() || 'mddLvl1',
					mddLvl2 = $.trim(mddLvl1) + '_' + ( $(this).data('track-linkname') || $.trim($(this).find('h4').text()));

				window.scsHeader.siteCatalyst.trackClick(this, e, mddLvl2, 'MDD' + (isSticky ? '-sticky' : ''));
			});
		},
		findTrackingLinks: function () {
			var mod = this;
			return mod.$ctx.find('.secondary-navigation li a.linklist');
		},
		handleTrackingLinkClick: function (e) {
			var isSticky = !!$(this).parents('.scsh-dynamic.is-sticky').length;
			var $mddLvl1Link = $(this).closest('.scsh-has-subnav').find('h2 a'),
				mddLvl1 = $mddLvl1Link.data('tracking-link-name') || $mddLvl1Link.text() || 'mddLvl1',
				mddLvl2 = $(this).parents('.column').find('a').data('track-linkname') || $(this).parents('.column').find('h4:first, .modPromoBadge').text() || 'mddLvl2',
				mddLvl3 = $.trim(mddLvl1) + '_' + $.trim(mddLvl2) + '_' + ($(this).data('tracking-link-name') || $(this).text());
			window.scsHeader.siteCatalyst.trackClick(this, e, mddLvl3, 'MDD' + (isSticky ? '-sticky' : ''));
		},

		initResponsiveness: function () {
			var mod = this;

			// pre-processor for following resize-listeners
			mod.$win.on('resize', function () {
				mod.width = mod.$maxAvailableWidthElement.width();

				if (!mod.isMobile && mod.width <= Number(mod.lessVars.mobile.breakpoint)) {
					mod.$win.trigger('scsh-responsive-switch').trigger('scsh-responsive-switch-mobile');

					mod.$ctx.removeClass('scsh-semi-mobile scsh-desktop').addClass('scsh-mobile');

					mod.isMobile = true;
					mod.isSemiMobile = false;
					mod.isDesktop = false;
				} else if (!mod.isSemiMobile && mod.width > Number(mod.lessVars.mobile.breakpoint) && mod.width < mod.breakPoints.semiMobile) {
					mod.$win.trigger('scsh-responsive-switch').trigger('scsh-responsive-switch-semiMobile');

					mod.$ctx.removeClass('scsh-mobile scsh-desktop').addClass('scsh-semi-mobile');

					// move semi mobile menu to the right edge of the icons
					mod.$ctx.find('.menu-items').css('right', 4 - 20 - mod.$ctx.find('.scsh-icon-menu').width());

					mod.isMobile = false;
					mod.isSemiMobile = true;
					mod.isDesktop = false;
				} else if (!mod.isDesktop && mod.width >= mod.breakPoints.semiMobile) {
					mod.$win.trigger('scsh-responsive-switch').trigger('scsh-responsive-switch-desktop');

					mod.$ctx.removeClass('scsh-mobile scsh-semi-mobile').addClass('scsh-desktop');

					mod.isMobile = false;
					mod.isSemiMobile = false;
					mod.isDesktop = true;
				}
				debug.log('Tc.Module.Header > initResponsiveness', mod.width, mod.isDesktop ? 'isDesktop' : mod.isSemiMobile ? 'isSemiMobile' : mod.isMobile ? 'isMobile' : '?');

				if (window.scsHeader && window.scsHeader.positionToolbarFiller) {
					// update legacy header toolbar
					window.scsHeader.positionToolbarFiller();
				}
			}).trigger('resize');

			// initialization that must be done when the header is NOT in mobile view
			{
				var doInitializationsWhenNotMobile = function () {
					mod.measureResponsiveBreakpoints();

					if (mod.$lvl2Container.length && mod.$lvl2Container.find('.scsh-lvl2-navi > li').length) {
						// lvl2 area is present and has nav-items -> init handling of item-overflow
						mod.initLvl2OverflowBreak();

						// listener for click on overflow-nav dropdown
						mod.$ctx.find('.scsh-lvl2-overflow-container > a').on('click', function () {
							var overflowContainer = mod.$ctx.find('.scsh-lvl2-overflow-container');

							overflowContainer.trigger('scsh-flyout-open', [function () {
								overflowContainer.removeClass('scsh-active');
							}]);

							overflowContainer.addClass('scsh-active');
						});
					}

					// init stickiness of lvl2 navigation
					if (mod.$lvl2Container.length) {
						mod.initStickiness();
					}

					mod.$win.trigger('resize').trigger('scroll');
					mod.afterMeasure();
				};

				// mobile view is active -> it's not possible to measure because the mediaquery prevents it -> wait till another view is active
				if (mod.isMobile) {
					mod.$win.on('scsh-responsive-switch', function measureOnSwitchFromMobileView() {
						// stop watching
						mod.$win.off('scsh-responsive-switch', measureOnSwitchFromMobileView);

						doInitializationsWhenNotMobile();
					});
				}

				// mobile view is not active -> measurements can be done now
				else {
					doInitializationsWhenNotMobile();
				}
			}
		},

		measureResponsiveBreakpoints: function () {
			var mod = this;

			// clone header for measurement without having flickering on the original one
			var clonedHeader = mod.$ctx.clone()
				.attr('data-ignore', true).attr('data-ignore-descendants', true) // prevent init of terrific modules
				.css('opacity', 0) // hide it from the user
				.css('position', 'absolute').css('width', '100%') // force full with like the original relative positioned one
				.removeClass('scsh-mobile scsh-semi-mobile').addClass('scsh-desktop') // set it to desktop view
				.insertAfter(mod.$ctx);

			var iconNavi = clonedHeader.find('ul.scsh-icon-menu'),
				textNavi = clonedHeader.find('ul.menu-items'),
				lastTextItem = textNavi.children(':visible:last'),
				spaceNeededNormal = 0,
				spaceNeededSmallerLogoDistance = 0,
				spaceNeededSmallerTextSpacing = 0,
				spaceNeededSmallerText = 0,
				unshrinkableSpace = (2 * Number(mod.lessVars.desktop.edgeSpacing)) + iconNavi.outerWidth(true),
				getTextSpace = function () {
					// do not measure the ULs (textNavi) with because it can be bigger then the space needed by the items
					if (!lastTextItem.length) {
						return 0;
					}
					return lastTextItem.offset().left + lastTextItem.width() - textNavi.offset().left;
				};

			// measure normal state
			spaceNeededNormal = unshrinkableSpace + Number(mod.lessVars.desktop.logoTotalWidth.big) + getTextSpace();
			if (spaceNeededNormal > Number(mod.lessVars.mobile.breakpoint)) {
				mod.breakPoints.smallerLogoSpacing = spaceNeededNormal;
			}

			// measure with shrinked logo distance (shrinking step 1)
			// adding 'lvl1-small-logo-spacing' class is not necessary since we have the value as less var
			spaceNeededSmallerLogoDistance = unshrinkableSpace + Number(mod.lessVars.desktop.logoTotalWidth.small) + getTextSpace();
			if (spaceNeededSmallerLogoDistance > Number(mod.lessVars.mobile.breakpoint)) {
				mod.breakPoints.smallerTextSpacing = spaceNeededSmallerLogoDistance;
			}

			// measure with also shrinked text spacing (shrinking step 2)
			clonedHeader.addClass('lvl1-small-text-spacing');
			spaceNeededSmallerTextSpacing = unshrinkableSpace + Number(mod.lessVars.desktop.logoTotalWidth.small) + getTextSpace();
			if (spaceNeededSmallerTextSpacing > Number(mod.lessVars.mobile.breakpoint)) {
				mod.breakPoints.smallerText = spaceNeededSmallerTextSpacing;
			}

			// measure with also shrinked text size (shrinking step 3)
			clonedHeader.addClass('lvl1-small-text');
			spaceNeededSmallerText = unshrinkableSpace + Number(mod.lessVars.desktop.logoTotalWidth.small) + getTextSpace();
			if (spaceNeededSmallerText > Number(mod.lessVars.mobile.breakpoint)) {
				mod.breakPoints.semiMobile = spaceNeededSmallerText;
			}

			clonedHeader.remove();

			mod.initLvl1OverflowBreak();
		},

		initLvl1OverflowBreak: function () {
			var mod = this;

			// switch from desktop to semiMobile
			mod.$win.on('scsh-responsive-switch-semiMobile', function () {
				if (mod.isDesktop) {
					mod.$ctx.removeClass('lvl1-animated-shrinking lvl1-small-text lvl1-small-text-spacing lvl1-small-logo-spacing');
				}
			});

			// switch from semiMobile to desktop
			mod.$win.on('scsh-responsive-switch-desktop', function () {
				if (mod.isSemiMobile) {
					mod.$ctx.addClass('lvl1-small-text lvl1-small-text-spacing lvl1-small-logo-spacing');

					// force re-rendering before appending the 'lvl1-animated-shrinking' class to prevent animations for this iteration
					mod.$ctx.width();
					mod.$ctx.addClass('lvl1-animated-shrinking');
				}
			});

			// breakpoints
			mod.$win.on('resize', function () {
				// handle desktop view with shrinked text size (shrinking step 3)
				if (mod.isDesktop && mod.breakPoints.smallerText && mod.width < mod.breakPoints.smallerText && !mod.$ctx.hasClass('lvl1-small-text')) {
					mod.$ctx.addClass('lvl1-animated-shrinking lvl1-small-text');
				} else if (mod.breakPoints.smallerText && mod.width >= mod.breakPoints.smallerText && mod.$ctx.hasClass('lvl1-small-text')) {
					mod.$ctx.removeClass('lvl1-small-text');
				}

				// handle desktop view with shrinked text spacing (shrinking step 2)
				if (mod.isDesktop && mod.breakPoints.smallerTextSpacing && mod.width < mod.breakPoints.smallerTextSpacing && !mod.$ctx.hasClass('lvl1-small-text lvl1-small-text-spacing')) {
					mod.$ctx.addClass('lvl1-animated-shrinking lvl1-small-text-spacing');
				} else if (mod.breakPoints.smallerTextSpacing && mod.width >= mod.breakPoints.smallerTextSpacing && mod.$ctx.hasClass('lvl1-small-text-spacing')) {
					mod.$ctx.removeClass('lvl1-small-text-spacing');
				}

				// handle desktop view with shrinked logo spacing (shrinking step 1)
				if (mod.isDesktop && mod.breakPoints.smallerLogoSpacing && mod.width < mod.breakPoints.smallerLogoSpacing && !mod.$ctx.hasClass('lvl1-small-text-spacing lvl1-small-logo-spacing')) {
					mod.$ctx.addClass('lvl1-animated-shrinking lvl1-small-logo-spacing');
				} else if (mod.breakPoints.smallerLogoSpacing && mod.width >= mod.breakPoints.smallerLogoSpacing && mod.$ctx.hasClass('lvl1-small-logo-spacing')) {
					mod.$ctx.removeClass('lvl1-small-logo-spacing');
				}
			});
		},

		initLvl2OverflowBreak: function () {
			var mod = this,
				nav = mod.$ctx.find('.scsh-lvl2-navi'),
				overflowNav = mod.$ctx.find('.scsh-lvl2-overflow-navi'),
				overflowContainer = mod.$ctx.find('.scsh-lvl2-overflow-container'),
				maxXPosElement = nav.closest('.scsh-lvl2-container'),
				firstNavItem = nav.children().first(),
				firstNavItemSpacingToTitle = firstNavItem.css('margin-left').replace('px', ''),
				lastHeaderWidth = 0,
				overflowNavVisible = false,
				mobilizedItems = $();

			// store each items outer-with inclusive margin
			nav.children().each(function () {
				var li = $(this);

				li.data('width', li.outerWidth(true));
			});

			mod.$win.on('resize', function () {
				var headerWidth = mod.width,
					navItems = nav.children();

				// do not do anything if (complete) mobile view is active
				if (mod.isMobile) {
					if (!mobilizedItems.length) {
						mobilizedItems = overflowNav.children().appendTo(nav);
					}
					return;
				} else if (mobilizedItems.length) {
					mobilizedItems.appendTo(overflowNav);
					mobilizedItems = $();
				}

				// screen got smaller -> check for moving items to overflow nav
				if ((headerWidth < lastHeaderWidth || !lastHeaderWidth) && navItems.length > 1) {
					var maxXPos = Math.round(maxXPosElement.offset().left + maxXPosElement.width()),
						lastElement = (overflowNavVisible ? overflowContainer : navItems.last());

					// move all but the first item into overflow navi (ignore forst one to prevent just having the overflow navi there)
					while (navItems.length > 1 && Math.floor(lastElement.offset().left + lastElement.outerWidth()) > maxXPos) {
						var lastNavItem = navItems.last();

						// move to overflow-list
						lastNavItem.prependTo(overflowNav);

						// remove the last item from the set
						navItems = navItems.not(lastNavItem);

						if (!overflowNavVisible) {
							overflowContainer.addClass('is-visible');
							overflowNavVisible = true;
							lastElement = overflowContainer;
						}
					}
				}

				// screen got bigger -> check for moving items back to normal nav
				else if (headerWidth > lastHeaderWidth && overflowNavVisible) {
					var availableSpace = Math.floor(firstNavItem.offset().left - firstNavItemSpacingToTitle - nav.offset().left),
						overflowItems = overflowNav.children(),
						firstOverflowElement = overflowItems.first();

					while (overflowItems.length && availableSpace >= firstOverflowElement.data('width')) {
						// move back to normal-list
						firstOverflowElement.appendTo(nav);

						// reduce available space by the moved elements width
						availableSpace -= firstOverflowElement.data('width');

						// get new first item in overflow-nav
						overflowItems = overflowItems.not(firstOverflowElement); // remove the first item from the set
						firstOverflowElement = overflowItems.first(); // get the new first item

						if (!overflowItems.length) {
							overflowContainer.removeClass('is-visible');
							overflowNavVisible = false;
						}
					}
				}

				lastHeaderWidth = headerWidth;
			});
		},

		initStickiness: function () {
			var mod = this,
				stickyElement = mod.$lvl2Container, // if you want to make LVL1 sticky again when LVL2 is not present then check GIT history - this was removed with story PORTAL-8984
				stickyPos = stickyElement.offset().top,
				isSticky = false,
				placeholderElement = (mod.$lvl2Container.hasClass('is-floating') ? $() /* none - is already absolute */ : mod.$ctx.find('.scsh-static')),
				makeNormal = function () {
					stickyElement.removeClass('is-sticky');
					stickyElement.find('.modImageAnimation').data('width', 39);

					if (placeholderElement.length) {
						placeholderElement.css('margin-bottom', '');
					}

					isSticky = false;
				};

			// check if stickiness must be changed
			mod.$win.on('scroll', function () {
				// do not do anything if mobile view or edit mode is active
				var isEditMode = __webpack_require__(4).isEditMode();
				if (mod.isMobile || mod.isSemiMobile || isEditMode) {
					return;
				}

				//noinspection JSValidateTypes
				var scrollPos = mod.$win.scrollTop();

				// make sticky
				if (!isSticky && scrollPos > stickyPos) {
					if (placeholderElement.length) {
						placeholderElement.css('margin-bottom', stickyElement.outerHeight(true) + 'px');
					}

					stickyElement.addClass('is-sticky');
					stickyElement.find('.modImageAnimation').data('width', 24);

					isSticky = true;
				}

				// make normal
				else if (isSticky && scrollPos <= stickyPos) {
					makeNormal();
				}
			}).trigger('scroll');

			// remove stickiness when switching to mobile
			mod.$win.on('scsh-responsive-switch-mobile scsh-responsive-switch-semiMobile', function () {
				if (isSticky) {
					makeNormal();
				}
			});

			// restore stickiness if needed when switching from mobile to another view
			mod.$win.on('scsh-responsive-switch-desktop', function () {
				if (mod.isMobile || mod.isSemiMobile) { // switching from mobile to another view
					window.setTimeout(function () {
						mod.$win.trigger('scroll');
					}, 10);
				}
			});
		},

		afterMeasure: function () {
			var mod = this;

			if (window.navigator.userAgent.indexOf('Safari') > -1) {
				mod.$ctx.find('.menu-items > li').each(function (i, item) {
					item.style.transform = 'scale(1)';
					item.style.webkitTransform = 'scale(1)';
					window.setTimeout(function () {
						item.style.transform = '';
						item.style.webkitTransform = '';
					}, 0);
				});
			}
		},

		initMddHeight: function () {
			var mod = this,
				items = mod.$ctx.find('.menu-items > .scsh-has-subnav'),
				sizedItems = $(),
				imagesLoaded = false,
				resizeTimeout = null,
				setItemMaxHeight = function () {
					if (this.length && !SCS.utils.isIE11()) {
						this.data(
							'maxHeightStyle',
							$('<style> .modHeader .scsh-has-subnav:nth-child(' + (this.index() + 1) + ').active .secondary-navigation { max-height: ' + this.find('.scsh-mdd-content').height() + 'px !important; } </style>')
								.appendTo(this)
						);
						sizedItems = sizedItems.add(this);
					}
				};

			items.children('.lvl1-item').on('click', function (event) {
				var item = $(this).parent();

				// deactivate other active items
				{
					// other LIs on the same level
					item.siblings('.active').removeClass('active');

					// other lists on the same level with active LIs (eg. for scsh-icon-menu vs. item-menu)
					if (!mod.isMobile && !mod.isSemiMobile) {
						item.parent().siblings().children('.active').removeClass('active');
					}
				}

				item.toggleClass('active');

				// measure and set MDDs proper height (for closing animation and further opening animations)
				{
					window.clearTimeout(item.data('measureHeightTimeoutId'));
					if (!item.data('maxHeightStyle') && item.hasClass('active')) {
						// use timeout time to wait until opening animation is done (animation time is 300ms)
						// store timeout ID to prevent measurement when MDD is closed again before properly opened
						item.data('measureHeightTimeoutId', window.setTimeout($.proxy(setItemMaxHeight, item), 500));
					}
				}

				// This makes the MDD animate promptly and makes click tracking asynchronous.
				event.preventDefault();

				// Tracking event should be called after openning or closing the MDD
				var isSticky = !!$(this).parents('.scsh-dynamic.is-sticky').length;
				window.scsHeader.siteCatalyst.trackClick(this, event, $(this).find('a').data('tracking-link-name') || $(this).text(), 'MDD' + (isSticky ? '-sticky' : ''));

				//lazy load images
				if(SCS.lazyLoadImages && !imagesLoaded){
					SCS.lazyLoadImages(mod.$ctx);
					imagesLoaded = true;
				}

			});

			mod.$win.on('resize', function () {
				// use timeout to throttle
				window.clearTimeout(resizeTimeout);
				resizeTimeout = window.setTimeout(function () {
					if (sizedItems.length) {
						// clear all set heights
						sizedItems.each(function () {
							($(this).data('maxHeightStyle') || $()).remove();
						});
						sizedItems.removeData('maxHeightStyle');
						sizedItems = $();

						// set height of the currently open MDD
						setItemMaxHeight.call(items.filter('.active'));
					}
				}, 10);
			});
		}
	});
}(window.Tc, __webpack_provided_window_dot_scsHeaderJQuery, window.SCS, window.debug));

}.call(window));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_scsHeaderJQuery) {/*** IMPORTS FROM imports-loader ***/
var loadTerrific = __webpack_require__(1);
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function (Tc, $, SCS) {
	'use strict';

	/**
	 * Product Comparator
	 *
	 * @author taaatra1
	 * @namespace Tc.Module
	 * @class ProductComparator
	 * @extends Tc.Module
	 */
	Tc.Module.ProductComparator = Tc.Module.extend({
		on: function(callback) {
			var mod = this,
				$ctx = mod.$ctx;

			mod.productComparisonCookie = 'SCSMiniComparedProductList';
			mod.productComparisonList = SCS.productComparisonList || [];
			mod.maxElementToCompare = 3;
			mod.addToComparisonURL = '/portalshop/de/Comparison/AddProduct/';
			mod.removeFromComparisonURL = '/portalshop/de/Comparison/RemoveProduct/';

			$ctx.find('.scsh-compare-info').on('click', function () {
				$ctx.trigger('scsh-flyout-open');
			});

			mod.updateProductComparator();

			mod.updateSCSNamespace();

			callback();
		},

		updateSCSNamespace : function() {
			var mod = this;
			SCS.comparisonProduct = function(a) { mod.comparisonProduct(a); };
			SCS.readProductComparisonCookie = function(a) { mod.readProductComparisonCookie(a); };
			SCS.addToProductComparisonList = function(productId, productName, miniImg, productType) { mod.comparisonProduct(productId, productName, miniImg, productType); };
			SCS.removeFromProductComparisonList = function(a) { mod.removeFromProductComparisonList(a); };
			SCS.getProductComparisonListIndex = function(a) { mod.getProductComparisonListIndex(a); };
			SCS.updateProductComparator = function(a) { mod.updateProductComparator(a); };
			SCS.compareDeviceDetailPage = function(a) { mod.compareDeviceDetailPage(a); };
			SCS.addToComparison = function(event, productId, productName, productImage, productType) { mod.addToComparison(event, productId, productName, productImage, productType); };
			SCS.removeFromComparison = function(event,productId) { mod.removeFromComparison(event,productId); };
			SCS.displayComparisonError = function(a) { mod.displayComparisonError(a); };
		},

		comparisonProduct : function (productId, productName, miniImg, productType) {
			if (!productType) {
				productType = 'mobile';
			}

			return {
				Id: productId,
				Name: productName,
				Image: miniImg,
				ProductType: productType
			};
		},

		readProductComparisonCookie : function() {
			var mod = this;
			if ($.cookie(mod.productComparisonCookie)) {
				try {
					mod.productComparisonList = $.parseJSON($.cookie(mod.productComparisonCookie));
				} catch(e) {
					mod.productComparisonList = [];
					window.debug.log('Tc.Module.ProductComparator > cannot read cookie ' + mod.productComparisonCookie, e);
				}
			} else {
				mod.productComparisonList = [];
			}
		},

		addToProductComparisonList : function(productId, productName, miniImg, productType) {
			var mod = this;
			var product = mod.comparisonProduct(productId, productName, miniImg, productType);
			mod.productComparisonList.push(product);
		},

		removeFromProductComparisonList : function(productId) {
			var mod = this,
				idx = mod.getProductComparisonListIndex(productId);

			if (idx > -1) {
				mod.productComparisonList.splice(idx, 1);
			}
		},

		getProductComparisonListIndex : function(productId) {
			var mod = this;
			for (var i = 0; i < mod.productComparisonList.length; i += 1) {
				if (mod.productComparisonList[i].Id === productId) {
					return i;
				}
			}
			return -1;
		},

		updateProductComparator : function() {
			var mod = this,
				$ctx = mod.$ctx;

			$ctx.hide();
			$ctx.find('ul').html('');
			mod.enableCompare(true);

			mod.readProductComparisonCookie();

			var list = mod.productComparisonList;

			var handler = function(event) {
				var $icon = $(this);
				var id = $icon.data('product-id');

				$ctx.trigger('scsh-flyout-close', {});
				mod.removeFromComparison(event, id);
				var n = list.length;
				$ctx.find('.scsh-compare-count').html(n);
				if (n === 0) {
					mod.enableCompare(false);
				}
				// uncheck Comparison checkbox on Product Detail page
				$('#chkCompare' + id).attr('checked', false).trigger('updateState');
			};

			for (var i = 0; i < list.length; i += 1) {
				var product = list[i];
				var img = $('<img/>').attr('src', product.Image);
				var div = $('<div/>').addClass('scsh-compare-name').append(product.Name);
				var icon = $('<div/>').addClass('scsh-compare-delete-icon').data('product-id', product.Id).click(handler);
				var li = $('<li/>').addClass('scsh-compare-product').append(img).append(icon).append(div);
				$ctx.find('ul').append(li);
			}

			$ctx.find('.scsh-compare-count').html(list.length); // mod.maxElementToCompare
			if (list.length === 0) {
				mod.enableCompare(false);
			}
			$ctx.show();
		},

		enableCompare : function(should) {
			var mod = this,
				$ctx = mod.$ctx;

			$ctx.toggleClass('scsh-empty', !should);
			$ctx.find('.modFlatButton a').toggleClass('disabled', !should);
		},

		compareDeviceDetailPage : function(event) {
			var mod = this;
			var productId = $(event.target).attr('data-product-id');
			var productName = $(event.target).attr('data-product-name');
			var productImage = $(event.target).attr('data-mini-image');
			var productType = $(event.target).attr('data-product-type');
			if (mod.getProductComparisonListIndex(productId) === -1) {
				mod.addToComparison(event, productId, productName, productImage, productType);
			} else {
				mod.removeFromComparison(event, productId);
			}
		},

		addToComparison : function(event, productId, productName, productImage, productType) {
			var mod = this;
			var $this = $(event.target);
			//if comparison is already full
			var wrongProductType = (mod.productComparisonList.length && mod.productComparisonList[0].ProductType !== productType);

			if (mod.productComparisonList.length >= mod.maxElementToCompare || wrongProductType) {
				var compareFull = (productType === 'mobile') ? mod.$ctx.data('productComparatorFull') : mod.$ctx.data('productComparatorFullTablets');
				var qtipText = (!wrongProductType) ? compareFull : mod.$ctx.data('productComparatorWrongType');
				$this.attr('checked', false).trigger('updateState');
				$this.qtip({
					content : '<div class="sc-richtext-failure">' + qtipText + '</div>',
					style : {
						classes : 'ui-tooltip-ecommerce',
						width : 240
					},
					show : {
						event : 'click',
						effect : function() {
							$(this).fadeIn(1000);
						}
					},
					hide : {
						event : false,
						inactive : 3500,
						effect : function() {
							$(this).fadeOut(1000);
						}
					},
					events : {
						hidden : function(event, api) {
							api.destroy();
						}
					}
				});

				$this.qtip('show');
				return;
			}

			mod.addToProductComparisonList(productId, productName, productImage, productType);
			$.cookie(mod.productComparisonCookie, window.JSON.stringify(mod.productComparisonList), { path: '/' });

			mod.updateProductComparator();
		},

		removeFromComparison : function(event,productId) {
			var mod = this;
			mod.removeFromProductComparisonList(productId);

			if (mod.productComparisonList.length) {
				$.cookie(mod.productComparisonCookie, window.JSON.stringify(mod.productComparisonList), { path: '/' });
			} else {
				$.cookie(mod.productComparisonCookie, null, { path: '/' });
			}
			mod.updateProductComparator();
		},

		displayComparisonError : function(xhr) {
			SCS.portal.showError('error', xhr.responseText);
		}
	});
}(window.Tc, __webpack_provided_window_dot_scsHeaderJQuery, window.SCS = window.SCS || {}));

}.call(window));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_Tc_dot_$) {/*** IMPORTS FROM imports-loader ***/
var loadTerrific = __webpack_require__(1);
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function (Module, $, SCS) {
	'use strict';
	// Note: For the Responsive Header
	//	- DON'T use:	.is-mobile		(server has detected a mobile device, mobile.jsp is rendered)
	//	- OK to use:	.scsh-mobile	(client has detected a small screen size)
	//		- but of course it's better to move mobile-only stuff into the MobileMenu skin

	var KEYS = {
		ESCAPE: 27,
		DOWN: 40,
		UP: 38,
		ENTER: 13
	};

	var LIVE_SEARCH_RESULTS = 3;

	function stop(event) {
		event.preventDefault();
	}

	function trackLiveSearchClick(mod, liveSearch) {
		Module.SearchResultContainer.trackClick('ac', mod.liveSearchConfig, liveSearch, mod.liveSearchProcessor);
	}

	var TEXT_SIZING_ATTEMPTS = 50;
	var CLEAR_ICON_DISTANCE_TO_TEXT = 8;
	var APPROX_LETTER_WIDTH = 16;
	var WANTED_FONT_DEFINITION = 'normal 32px TheSerifB3';
	var PROCESS_WAIT_TIMEOUT = 200;

	function calcTextWidth(field) {
		if(!field.length || !window.getComputedStyle) {
			return field.length ? field.val().length * APPROX_LETTER_WIDTH : 0;
		}
		var text = field.val();
		var font = window.getComputedStyle(field[0], null).getPropertyValue('font') || WANTED_FONT_DEFINITION;
		var $fakeEl = $($('<pre>').hide().appendTo(document.body));
		$fakeEl.text(text);
		$fakeEl.css('font', font);
		var wRet = $fakeEl.width();
		$fakeEl.detach();
		return wRet;
	}

	/**
	 * SiteSearch module implementation.
	 *
	 * @author Cesar Keller & Raphael Schweikert & Benjamin Berger
	 * @namespace Tc.Module
	 * @class SiteSearch
	 * @extends Tc.Module
	 */
	Module.SiteSearch = Module.extend({
		// The array of search suggestions
		suggestions: [],
		// The array of keymatches for the current suggestions
		keymatches: [],
		// URLs of all last-recently loaded keymatches (for deduplication)
		keymatchURLs: {},
		// The array of live search results
		liveSearches: [],
		// Concatenation of all results (suggestions and keymatches combined)
		// for the purpose of making selection tracking and arrow key handling simpler.
		results: [],
		// The result that is currently selected. May be a suggestion or a keymatch.
		selectedIndex: -1,

		// Value of the field at the time the last query was made
		// (to revert after selecting keymatches)
		prevFieldVal: '',

		on: function (callback) {
			var mod = this;

			// FIXME: Can’t we move most of these to “after”?
			mod.findElements();
			mod.addEventHandlers();

			mod.textCalculationLoopCounter = 0;

			callback();
		},

		after: function() {
			var mod = this;
			mod.initSearchProcessor();
			mod.initLiveSearchProcessor();
		},

		initSearchProcessor: function() {
			var mod = this;
			mod.searchProcessor = SCS.search.orchestration.forAutosuggest(
				mod.$container.data('gsahostname'),
				mod.$container.data('gsasites'),
				mod.$container.data('gsaclient'),
				mod.$container.data('gsanumberofresults'),
				mod.$container.data('gsainstantsearchresults'),
				$('html').attr('lang') || 'de',
				mod.$container.data('instantsearchcollectionsuffix')
			);
			mod.searchProcessor.responder(SCS.search.util.respondTo({
				'data': mod.suggestData,
				'keymatch-data': mod.keymatchData
			}, mod));
		},

		initLiveSearchProcessor: function() {
			var mod = this;
			mod.liveSearchProcessor = SCS.search.orchestration.forSerp(
				mod.$container.data('gsahostname'),
				mod.$container.data('gsasites'),
				mod.$container.data('gsaclient'),
				$('html').attr('lang') || 'de',
				{
					// Take deduplication into account and load more live search results than would be needed
					// in case all keymatches appear in the results
					resultLimit: LIVE_SEARCH_RESULTS + mod.$container.data('gsainstantsearchresults'),
					origin: 'header'
				}
			);
			mod.liveSearchProcessor.responder(SCS.search.util.respondTo({
				data: mod.liveSearchData
			}, mod));
		},

		findElements: function() {
			var mod = this,
				$ctx = mod.$ctx;

			var $container = mod.$container = $ctx.find('.scsh-sitesearch-container');
			mod.$field = mod.$container.find('input.scs-sitesearch-searchfield-input');
			mod.$instantResultContainer = $container.find('.scsh-instant-result-container');
			mod.$submitButton = $ctx.find('.scsh-sitesearch-submit-button');
			mod.$form = $ctx.find('.scsh-sitesearch-form');

			mod.suggestResultContent = $container.find('.scsh-autosuggest-content')[0];
			mod.keymatchResultContent = $container.find('.scsh-keymatch-content')[0];
			mod.liveSearchContent = $container.find('.scsh-livesearch-content')[0];

			mod.$whiteOut = $('.scsh-modSiteSearch-white-out');
			if(!mod.$whiteOut.length) {
				if(SCS.utils.isMobilePage()) {
					mod.$whiteOut = $('<div class="scsh-modSiteSearch-white-out"></div>').appendTo(mod.$ctx);
				} else {
					mod.$whiteOut = $('<div class="scsh-modSiteSearch-white-out"></div>').appendTo([
						document.body,
						mod.$ctx.closest('.modHeader').find('>.scsh-dynamic')
					]);
				}
			}
			mod.$delEl = mod.$ctx.find('.scsh-sitesearch-del-content');

			// make dev life easier
			if (location.search.match(/\bwcmmode=disabled\b/)) {
				if (mod.$form.prop('action') && !mod.$form.prop('action').match(/\bwcmmode=disabled\b/)) {
					mod.$form.prop('action', mod.$form.prop('action') + location.search);
				}
			}
		},

		// Called when the *displayed* query needs to be updated (without triggering anything)
		updateQuery: function(query) {
			var mod = this;
			var prevValue = mod.$field.val();
			if(prevValue === query) {
				return;
			}
			mod.$field.val(query);
			mod.activateDelContentButton();
			mod.checkForEmptyContent();
		},

		activateSearchField: function() {
			this.$field.focus();
		},

		// Overridden in MobileMenu skin
		checkAndCalcTextWidth: function(field) {
			var mod = this;
			if(mod.textCalculationLoopHandle) {
				window.clearTimeout(mod.textCalculationLoopHandle);
				mod.textCalculationLoopHandle = null;
			}
			function setCalculatedWidth() {
				var calcedWidth = calcTextWidth(field);
				if(calcedWidth) {
					// Fix Safari rendering this element too close
					if (navigator.userAgent.indexOf('Safari') !== -1 && navigator.userAgent.indexOf('Chrome') === -1) {
						calcedWidth += 10;
					}

					mod.$delEl.css('left', (calcedWidth + CLEAR_ICON_DISTANCE_TO_TEXT) + 'px').show();
				} else {
					mod.$delEl.hide();
				}
			}
			if(!document.fonts) {
				setTimeout(function() {
					setCalculatedWidth();
				}, 1);
			} else if(!document.fonts.check(WANTED_FONT_DEFINITION) && mod.textCalculationLoopCounter < TEXT_SIZING_ATTEMPTS) {
				mod.textCalculationLoopHandle = setTimeout(function() {
					mod.textCalculationLoopHandle = null;
					mod.textCalculationLoopCounter += 1;
					mod.checkAndCalcTextWidth(field);
				}, 100);
			} else {
				setCalculatedWidth();
			}
		},

		activateDelContentButton: function () {
			var mod = this;
			mod.$delEl.toggleClass('active', !!mod.$field.val());
			mod.checkAndCalcTextWidth(mod.$field);
		},

		checkForEmptyContent: function () {
			var mod = this;
			var fieldVal = mod.$field.val();
			if (fieldVal && fieldVal.length) {
				mod.$submitButton.addClass('active');
			} else {
				mod.$submitButton.removeClass('active');
			}
		},

		addEventHandlers: function () {
			// FIXME: Break this method up into smaller pieces, maybe create mobile skin and add overloads for mobile-only stuff there
			var mod = this,
				$ctx = mod.$ctx,
				$form = mod.$form,
				$field = mod.$field,
				$button = $ctx.find('.scsh-sitesearch-open-button'),
				isOpen = false;

			$field.on('focus', function () {
				$ctx.addClass('active');
				mod.$container.addClass('scsh-focus');
				mod.$whiteOut.show();
				isOpen = true;
				mod.checkForEmptyContent();
				mod.$delEl.removeClass('active');
			});

			// custom event fired by scsSiteSearch.Serp.init()
			$(document).on('scsSiteSearch-serp-query', function (event, q) {
				// we are on a search result page (SERP)
				isOpen = !!q;
				mod.updateQuery(q);
				$ctx.addClass('scsh-search-result-page active');
			});

			$field.on('blur', function () {
				mod.$whiteOut.hide();
				var fieldVal = $field.val();
				if (fieldVal && fieldVal.length) {
					mod.activateDelContentButton();
				}
				mod.$container.removeClass('scsh-focus');
			});

			function close() {
				$ctx.removeClass('active');
				isOpen = false;
			}
			$field.on('keydown', function (event) {
				mod.$delEl.removeClass('active');
				// Escape
				if (event.which === KEYS.ESCAPE) {
					$field.blur();
					close();
				}
			});

			$field.on('keyup', function() {
				mod.checkForEmptyContent();
			});

			$field.on('keydown', function(event) {
				var selectedKeymatch = mod.getSelectedKeymatch();
				if(event.keyCode === KEYS.UP) {
					mod.selectionChanged(-1);
				} else if(event.keyCode === KEYS.DOWN) {
					mod.selectionChanged(+1);
				} else if(event.keyCode === KEYS.ENTER && selectedKeymatch) {
					event.stopPropagation();
					event.preventDefault();
					mod.activateKeymatch(selectedKeymatch);
					// Open the keymatch. We could also synthesize a click on the element… Which is better?
					if (window.top && window.top !== window) {
						window.top.location = selectedKeymatch.url;
					} else {
						window.location = selectedKeymatch.url;
					}
				} else {
					return;
				}
				// Do not further process the key press:
				// * Do not trigger a new search
				// * Do not move the cursor the beginning or end when navigating suggestions or keymatches
				event.stopImmediatePropagation();
				return false;
			});
			var processKeyPressTimeout = null;
			$field.on('input keypress', function(event) {
				if(event.which === KEYS.ENTER) {
					// Selected suggestions already updated the field value with the suggestion
					// and normal searches can just trigger the regular form submit
					return;
				}
				var value = $field.val();
				if(value === mod.prevFieldVal) {
					return;
				}

				mod.prevFieldVal = value;

				clearTimeout(processKeyPressTimeout);
				processKeyPressTimeout = setTimeout(function() {
					processKeyPressTimeout = null;
					mod.searchProcessor.process({query: value});
				}, PROCESS_WAIT_TIMEOUT);
			});
			$button.on('click', function () {
				mod.log('open clicked', isOpen);
				if (!isOpen) {
					$field.focus();
				} else {
					close();
				}
			});
			$ctx.find('.scsh-sitesearch-close-button').on('click', close);
			mod.$submitButton.on('click', function () {
				if (mod.$submitButton.hasClass('active')) {
					$form.submit();
					mod.$submitButton.removeClass('active');
					mod.activateDelContentButton();
				}
			});
			$form.on('submit', function(event) {
				event.preventDefault();
				var target = $form.attr('action');
				var pivot = '#'; // RESOLVE: Do we need to use query params at one point or is the hash always ok?
				var separator = target.indexOf(pivot) > -1 ? '&' : pivot;
				var query = {q: $field.val()};
				target = target + separator + SCS.search.util.param(query);
				// FIXME: Should we also send an event so the SearchResultContainer module does not need to rely on the hashchange event if on a SERP?
				window.location.href = target;
				$field.blur();
			});

			var touched = false;
			mod.$delEl.on('click', function(event) {
				if(event.type === 'touchstart') {
					touched = true;
				} else if(touched) {
					// Don’t act on both “click” and “touchstart”
					touched = false;
					return;
				}
				mod.clearSearchField();
				mod.activateSearchField();
			});
		},

		clearSearchField : function() {
			this.$field.val('');
		},

		updateDom: function() {
			this.updateSuggestions();
			this.updateKeymatches();
			this.updateLiveSearch();
			this.updateSelection();
			this.triggerLiveSearch();
		},

		getSelectedSuggestion: function() {
			var mod = this;
			if(mod.selectedIndex in mod.suggestions) {
				return mod.suggestions[mod.selectedIndex];
			}
			return null;
		},

		selectSuggestion: function(index) {
			this.selectedIndex = index;
			this.updateDom();
		},

		getSelectedKeymatch: function() {
			var mod = this;
			// Relies on the ordering of mod.results to always put suggestions before keymatches.
			var selectedKeymatchIndex = mod.selectedIndex - mod.suggestions.length;
			if(selectedKeymatchIndex in mod.keymatches) {
				return mod.keymatches[selectedKeymatchIndex];
			}
			return null;
		},

		selectKeymatch: function(index) {
			// Relies on the ordering of mod.results to always put suggestions before keymatches.
			this.selectedIndex = this.suggestions.length + index;
			this.updateDom();
		},

		updateSuggestions: function() {
			var mod = this;

			var selectedSuggestion = mod.getSelectedSuggestion();
			var results = mod.suggestions;
			var snabbdom = window.snabbdom;
			var h = snabbdom.h;
			var contents = [];
			for(var i=0;i<results.length;i+=1) {
				var result = results[i];
				contents.push(h(
					'li.scs-sitesearch-autosuggest-li',
					{
						'class': {
							'scs-sitesearch-searchfield-hoveractive': result === selectedSuggestion
						},
						on: {
							click: [$.proxy(mod.activateSuggestion, mod), result],
							// Don’t let the mousedown trigger a blur of the input field (otherwise we don’t get a click)
							mousedown: stop
						}
					},
					result.name
				));
			}
			var suggestions = h('ul.suggestions', contents);
			mod.suggestResultContent = snabbdom.patch(mod.suggestResultContent, suggestions);
			mod.$instantResultContainer.toggleClass('has-suggestions', !!results.length);
			mod.calculateAndSetContainerHeight();
		},

		updateKeymatches: function() {
			var mod = this;

			var selectedKeymatch = mod.getSelectedKeymatch();
			var results = mod.keymatches;
			var snabbdom = window.snabbdom;
			var h = snabbdom.h;
			var contents = [];
			for(var i=0;i<results.length;i+=1) {
				var result = results[i];
				var image;
				if(result.image) {
					image = h('img', {props: {src: result.image}});
				} else if(result.display === 'product') {
					image = h('div');
				} else {
					image = h('div.icon');
				}
				contents.push(h(
					'li.scs-sitesearch-keymatch-li.type-'+(result.display),
					{
						'class': {
							'scs-sitesearch-searchfield-hoveractive': result === selectedKeymatch
						}
					},
					[h(
						'a',
						{
							on: {
								click: [$.proxy(mod.activateKeymatch, mod), result],
								// Don’t let the mousedown trigger a blur of the input field (otherwise we don’t get a click)
								mousedown: stop
							},
							attrs: {
								href: result.url
							}
						},
						[
							h('div.image', {
								'class': {
									'type-iconfont': !result.image,
									'type-bitmap': !!result.image
								}
							}, [image]),
							h('div.text.scs-font-regular', [h('h4', result.title), h('p', result.subtitle)])
						]
					)]
				));
			}
			var keymatches = h('ul.keymatches', {}, contents);
			mod.keymatchResultContent = snabbdom.patch(mod.keymatchResultContent, keymatches);
			mod.$instantResultContainer.toggleClass('has-keymatches', !!results.length);
			mod.calculateAndSetContainerHeight();
		},

		calculateAndSetContainerHeight : function() {
			var mod = this;
			// calculate height of children and set it fixed for animation
			// problem why this is needed: setting it to a very height fixed number --> too fast animation
			// setting to a low fixed value --> Content is cut. Solution: dynamic fixed heigt, based on content
			var totalHeight = 0;
			mod.$instantResultContainer.children().each(function(){
			    totalHeight = totalHeight + $(this).outerHeight(true);
			});
			mod.$instantResultContainer.css('max-height', totalHeight + 'px');
		},

		updateLiveSearch: function() {
			var mod = this;

			var results = mod.liveSearches;
			var snabbdom = window.snabbdom;
			var h = snabbdom.h;
			var contents = [];
			for(var i=0;i<results.length && contents.length < LIVE_SEARCH_RESULTS;i+=1) {
				var liveSearch = results[i];
				// Deduplicate search results that already appear as keymatches
				if(Module.SearchResultDisplay.normalizeURL(liveSearch.url) in mod.keymatchURLs) {
					continue;
				}
				var liContent = [
					h(
						'a',
						{
							props: {
								href: liveSearch.url
							},
							on : {
								click: [trackLiveSearchClick, mod, liveSearch],
								mousedown: stop
							}
						},
						[Module.SearchResultContainer.unsafelyStripHTML(liveSearch.title)]
					),
					h('small.snippet', Module.SearchResultContainer.snippetToVDomElements(liveSearch.snippet, h))
				];

				// jshint camelcase: false
				if(liveSearch.meta && liveSearch.meta.search_image_url) {
					liContent.push(h('div.livesearch-icon', {},
						[h('img', {props: {src: liveSearch.meta.search_image_url}})]
					));
				}
				contents.push(h(
					'li.scs-sitesearch-livesearch-li',
					{
						'class': {
							'has-snippet': !!liveSearch.snippet
						}
					},
					liContent
				));
			}
			var liveSearches = h('ul.livesearch', {}, contents);
			mod.liveSearchContent = snabbdom.patch(mod.liveSearchContent, liveSearches);
			mod.$instantResultContainer.toggleClass('has-livesearches', !!results.length);
			mod.calculateAndSetContainerHeight();
		},

		updateSelection: function() {
			var mod = this;
			// If a keymatch or nothing was selected, revert to the previous field value
			var fieldValue = mod.prevFieldVal;
			if(mod.selectedIndex !== -1) {
				var selection = mod.results[mod.selectedIndex];
				if('name' in selection) {
					// Display selected suggestion in search field
					fieldValue = selection.name;
				}
			}
			mod.updateQuery(fieldValue);
		},

		previousLiveSearchQuery: null,

		// Triggers a live search
		triggerLiveSearch: function() {
			var mod = this;

			var userQuery = (mod.suggestConfig && mod.suggestConfig.query) || mod.$field.val();
			// If no suggestions present, use the user’s input as query, otherwise use the selected suggestion (or the first, if no suggestion is selected)
			var query = userQuery;
			var suggestion = mod.getSelectedSuggestion() || mod.suggestions[0];
			if(suggestion) {
				query = suggestion.name;
			}

			if(mod.previousLiveSearchQuery === query) {
				// Query hasn’t changed, do nothing
				return;
			}

			mod.previousLiveSearchQuery = query;
			if(mod.liveSearchTimeoutHandle) {
				window.clearTimeout(mod.liveSearchTimeoutHandle);
			}
			// If the user has selected a new suggestion, wait 500ms before loading the results
			// so the user has time to select a different suggestion
			// FIXME: make timeout configurable
			var timeout = 500;
			mod.liveSearchTimeoutHandle = window.setTimeout(function() {
				mod.liveSearchTimeoutHandle = null;
				mod.liveSearchProcessor.process({query: query, userQuery: userQuery});
			}, timeout);

		},

		// Helper function for opening keymatch URLs
		activateKeymatch: function(keymatch) {
			// Store URL so the referenced page knows where we came from
			if ('localStorage' in window) {
				window.localStorage.setItem('sitesearch-keymatch-origin-url', window.location.href);
			}
			// Tracking
			Module.SearchResultContainer.trackClick('keymatch', this.keymatchConfig, keymatch, this.searchProcessor);
		},

		// Click handler for a suggest item
		activateSuggestion: function(suggestion) {
			// Tracking
			Module.SearchResultContainer.trackClick('suggestion', this.suggestConfig, suggestion, this.searchProcessor);
			// Set the form value and let the submit handle the rest
			this.updateQuery(suggestion.name);
			this.$form.submit();
		},

		suggestData: function(processor, data, config) {
			this.suggestConfig = config;
			this.dataChanged(data.results || []);
		},

		keymatchData: function(processor, data, config) {
			this.keymatchConfig = config;
			this.dataChanged(null, config.keymatches || []);
		},

		liveSearchData: function(processor, data, config) {
			this.liveSearchConfig = config;
			this.dataChanged(null, null, data.results||[]);
		},

		dataChanged: function(suggestions, keymatches, liveSearches) {
			var mod = this;
			if(suggestions) {
				this.suggestions = suggestions;
			}
			if(keymatches) {
				// Filter out failed eCommerce calls
				this.keymatches = $.grep(keymatches || [], function(el) {
					return !el.error;
				});
				this.keymatchURLs = {};
				for(var i=0;i<keymatches.length;i+=1) {
					this.keymatchURLs[Module.SearchResultDisplay.normalizeURL(keymatches[i].url)] = true;
				}
			}
			if(liveSearches) {
				this.liveSearches = liveSearches;
			}
			if(suggestions || keymatches) {
				// Reset the selection index.
				// If we don’t do this, the selected suggestion’s name is set in the search box
				// and will override the value just typed by the user.
				mod.selectedIndex = -1;
			}
			mod.results = mod.suggestions.concat(mod.keymatches);
			mod.updateDom();
		},

		selectionChanged: function(delta) {
			var mod = this;
			var newSelectedIndex = mod.selectedIndex + delta;
			if(newSelectedIndex < -1) {
				// On arrow-up, if nothing is selected, select the last item available
				newSelectedIndex = mod.results.length + newSelectedIndex + 1;
			}
			if(newSelectedIndex >= mod.results.length) {
				// On arrow-down at the last item, begin again with being unselected
				newSelectedIndex = -1;
			}
			mod.selectedIndex = newSelectedIndex;
			mod.updateDom();
		}
	});
})(window.Tc.Module, __webpack_provided_window_dot_Tc_dot_$, window.SCS = window.SCS || {});

}.call(window));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_Tc_dot_$) {/*** IMPORTS FROM imports-loader ***/
var loadTerrific = __webpack_require__(1);
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function (Module, $, debug) {
	'use strict';

	Module.SiteSearch.MobileMenu = function(parent) {
		var mod = this;

		mod.isProxy = mod.$ctx.is('.skinSiteSearchProxy');

		mod.on = function(callback) {
			mod.$titleContainer = mod.$ctx.find('.scsh-sitesearch-container-result-page-title');
			mod.$title = mod.$titleContainer.find('h1');
			mod.$header = mod.$ctx.closest('.modHeader');

			if(mod.isProxy) {
				// Use the real field, not the proxied one for focusing and stuff
				mod.$originalField = mod.$header.find('.top-navigation .modSiteSearch.skinSiteSearchMobileMenu .scsh-sitesearch-container input.scs-sitesearch-searchfield-input');
			}

			parent.on.call(this, callback);
		};

		// Do nothing on mobile
		mod.updateLiveSearch = mod.initLiveResultProcessor = mod.triggerLiveSearch = $.noop;

		// just show and do not calculate any width anymore
		mod.checkAndCalcTextWidth = function() {
			if(mod.isProxy && mod.$originalField.val()) {
				mod.$delEl.show();
			} else {
				mod.$delEl.hide();
			}
		};

		if(mod.isProxy) {
			mod.updateQuery = function(query) {
				mod.$title.text(query || '');
				parent.updateQuery.call(mod, query);
			};
			mod.clearSearchField = function() {
				mod.$originalField.val('');
			};
		}

		mod.activateSearchField = function() {
			// let the burger do whatever it does with a click event
			mod.$header.find('.burger > a').click();

			// header should not be sticky on search result page, because keyboard is open
			mod.$header.removeClass('is-sticky');
			debug.log('Tc.Module.SiteSearch.MobileMenu > is-sticky', false);

			// this class hides all menu items except the search field
			mod.$header.find('.top-navigation .menu-items > li:not(.modSiteSearch)').addClass('scsh-search-hidden-menus');

			$('.scsh-menu-wrapper > .menu-items').scrollTop(0);

			if(mod.isProxy) {
				mod.$originalField.focus();
			} else {
				mod.$field.focus();
			}

			mod.$delEl.removeClass('active');
		};

		mod.addEventHandlers = function() {
			// Call the shared version
			parent.addEventHandlers.call(mod);

			// Do mobile-specific stuff
			if(mod.isProxy) {
				mod.$titleContainer.click(function(event) {
					mod.activateSearchField();
					event.stopPropagation();
					event.preventDefault();
				});
			}
			mod.$form.on('submit', function () {
				$('.modHeader.scsh-mobile .burger.active > a').click(); // close mobile menu
			});
		};
	};
})(window.Tc.Module, __webpack_provided_window_dot_Tc_dot_$, window.debug);

}.call(window));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var loadTerrific = __webpack_require__(1);
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function ($) {
	'use strict';
	/*globals Tc */
	/*jshint smarttabs:true */

	/**
	 * Metanav module implementation.
	 *
	 * @author
	 * @namespace Tc.Module
	 * @class Metanav
	 * @extends Tc.Module
	 */
	Tc.Module.Metanav = Tc.Module.extend({

		/**
		 * Hook function to do all of your module stuff.
		 *
		 * @method on
		 * @param {Function} callback function
		 * @return void
		 */
		on: function (callback) {
			// language selector
			var mod = this,
				$ctx = mod.$ctx,
				$langSwitch = $ctx.find('.scsh-js-language-switch'),
				$businessAreaSwitch = $ctx.find('.scsh-js-business-area-switch');

			$langSwitch.click(function () {
				$langSwitch.trigger('scsh-flyout-open');
			});

			$businessAreaSwitch.click(function () {
				$businessAreaSwitch.trigger('scsh-flyout-open');
			});
			
			callback();
		}
	});
}(Tc.$));
}.call(window));

/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_scsHeaderJQuery) {/**
 * (c) Copyright Swisscom (Schweiz) AG. All rights reserved.
 *
 * This product is the proprietary and sole property of Swisscom (Schweiz) AG
 * Use, duplication or dissemination is subject to prior written consent of
 * Swisscom (Schweiz) AG.
 *
 * $Id: sitecatalyst.js
 */
(function ($, scsHeader, debug) {
	'use strict';

	$.namespace('scsHeader.siteCatalyst');

	// tzhkobj1: set timeout to 0 since Sitecatalyst already provides a 500ms delay
	scsHeader.siteCatalyst.PAGE_LOAD_DELAY = 0;

	/**
	 * Resolve referenced/shortened SiteCatalyst prop/eVar values, e.g. D=c1,
	 * where cXX stands for props and vXX for eVars
	 * @param value the concrete prop value to resolve
	 */
	scsHeader.siteCatalyst.resolveShortenedValue = function (value) {
		var regExpValue = /.*D=([c|v])(\d{1,3})$/,
			/* jshint camelcase: false */
			siteCatalyst = window.s || window.s_one;

		if (siteCatalyst && typeof value !== 'undefined' && regExpValue.test(value)) {
			var matches = regExpValue.exec(value),
				prefix = matches[1] === 'c' ? 'prop' : 'eVar',
				result = siteCatalyst[prefix + matches[2]];

			if (regExpValue.test(result)) {
				// multi-layer reference, recursion
				return scsHeader.siteCatalyst.resolveShortenedValue(result);
			} else {
				debug.log('>> resolve shortened value', value, result);
				return result;
			}
		} else {
			return value;
		}
	};

	scsHeader.siteCatalyst.trackClick = function track(me, e, link, area) {
		if(!SCS.portal || !SCS.portal.datalayer) {
			return
		}
		var $this = $(me);
		if ($this.is('.active')) {
			return;
		}

		SCS.portal.datalayer.trackEvent('link', scsHeader.siteCatalyst.resolveShortenedValue(link), 'header', area);

		// prevent double tracking of links in header
		e.stopPropagation();

		if (e.isDefaultPrevented()) {
			return;
		}

		e.preventDefault();
		var destination = $this.attr('href');
		var target = $this.attr('target') || '_self';
		var isNewTab = e.ctrlKey || e.metaKey;

		//maybe needs to be delayed by 100-200ms (google tracking experience)
		setTimeout(function () {
			if (isNewTab) {
				window.open(destination);
			}
			else {
				window.open(destination, target);
			}
		}, scsHeader.siteCatalyst.PAGE_LOAD_DELAY);
	};

	scsHeader.siteCatalyst.initHeaderTracking = function () {

		/**
		 * Legacy Header
		 */
		// TODO: Remove when old header isn’t used anymore
		$('#scs-pageheader-language-switch a').on('click', function (e) {
			scsHeader.siteCatalyst.trackClick(this, e, $(this).data('trackingLinkName'), 'Toolbar');
		});

		$('#scs-pageheader-topnav a').on('click', function (e) {
			scsHeader.siteCatalyst.trackClick(this, e, $(this).data('trackingTitle'), 'MDD');
		});

		/**
		 * Legacy L0
		 */
		// TODO: Change selector when L0 is new header
		$('#scs-pageheader-toolsnav a, #scs-pageheader-metanav a, #scs-pageheader-branchnav a').on('click', function (e) {
			scsHeader.siteCatalyst.trackClick(this, e, $(this).data('trackingLinkName'), 'Toolbar');
		});

		// Track burger click
		$('ul.scsh-icon-menu li.burger a').on('click', function (e) {
			scsHeader.siteCatalyst.trackClick(this, e, 'Burger', 'Burger-Menu');
		});
		// Track burger menu lvl-0 clicks
		$('.scsh-menu-wrapper ul.menu-items li.scsh-metanav-item a, .scsh-menu-wrapper ul.menu-items li.scsh-toolsnav-item a, .scsh-menu-wrapper ul.menu-items li.scsh-branchnav-item a').on('click', function (e) {
			scsHeader.siteCatalyst.trackClick(this, e, $(this).data('trackingLinkName') || $(this).text(), 'Burger-Menu');
		});

		/**
		 * New Header
		 */
		$('.scsh-js-language-switch a, .scsh-metanav-links a').on('click', function (e) {
			var isSticky = !!$(this).parents('.scsh-dynamic.is-sticky').length;
			scsHeader.siteCatalyst.trackClick(this, e, $(this).data('trackingLinkName') || $(this).text(), 'Toolbar' + (isSticky ? '-sticky' : ''));
		});

		// Level2
		$('.scsh-lvl2-navi li a').on('click', function (e) {
			scsHeader.siteCatalyst.trackClick(this, e, $(this).data('tracking-link-name') || $(this).find('h3').text(), 'Level2');
		});

		// search/basket icons
		$('.top-navigation li.modSiteSearch a, .top-navigation li.modFusionSearch a, .top-navigation div.modBasket a').on('click', function (e) {
			var isSticky = !!$(this).parents('.scsh-dynamic.is-sticky').length;
			scsHeader.siteCatalyst.trackClick(this, e, $(this).data('tracking-link-name'), 'MDD' + (isSticky ? '-sticky' : ''));
		});

		// logo
		$('.scsh-lvl1-container a.logo').on('click', function (e) {
			var isSticky = !!$(this).parents('.scsh-dynamic.is-sticky').length;
			scsHeader.siteCatalyst.trackClick(this, e, 'logo', 'MDD' + (isSticky ? '-sticky' : ''));
		});

	};

	// TODO remove is-mobile check when deleting old header
	$(function () {
		var $body = $(document.body);
		if ($body.hasClass('cq_isEditMode')) {
			return;
		}
		if (!$body.hasClass('is-mobile') || $body.hasClass('responsiveHeader')) {
			scsHeader.siteCatalyst.initHeaderTracking();
		}
	});
}(__webpack_provided_window_dot_scsHeaderJQuery, window.scsHeader = window.scsHeader || {}, window.debug));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_$) {/**
 * Created by Dimitri Sebeschuk on 04.05.17.
 *
 * Wrapper for CQ_Analytics.TestTarget
 * see: /etc/clientlibs/foundation/testandtarget/util/js.txt
 *
 * Fix "targetoffer" selector
 */
// jshint camelcase: false
(function (CQ_Analytics, CQ, SCS, $, debug) {
	'use strict';

	if (!CQ_Analytics || !CQ_Analytics.TestTarget || !CQ) {
		return;
	}

	var obj = CQ_Analytics.TestTarget;

	var origGet = CQ.shared.HTTP.get,
		origPull = obj.pull;

	SCS.TestTarget = SCS.TestTarget || {};

	SCS.TestTarget.transformProxyUrl = function (url) {
		var suffixIndex = url.indexOf('.html/'),
			baseUlr = suffixIndex > -1 ? url.substring(0, suffixIndex) : url,
			selectors = baseUlr.substring(baseUlr.indexOf('.'), baseUlr.lastIndexOf('.') + 1).split('.'),
			//support mobile selector in Browser
			mobile = $.inArray('mobile', selectors) !== -1 ? '.mobile' : '',
			basePath = baseUlr.indexOf('.') > -1 ? baseUlr.substring(0, baseUlr.indexOf('.')) : baseUlr,
			suffixUrl = suffixIndex > -1 ? url.substring(suffixIndex + 5) : '',
			suffixPath = suffixUrl.substring(0, suffixUrl.indexOf('.')),
			suffixSelectors = suffixUrl.substring(suffixUrl.indexOf('.'), suffixUrl.lastIndexOf('.') + 1).split('.'),
			query = window.location.search.indexOf('wcmmode=disabled') > 0 ? '?wcmmode=disabled' : '';

		if (suffixUrl.length === 0) {
			return basePath + mobile + '.scstargetoffer.html' + query;
		}

		selectors = selectors.filter(function (it) {
			return it !== 'mobile' && it !== 'targetoffer' && it.length > 0;
		});
		selectors = selectors.length > 0 ? '.' + selectors.join('.') : '';

		suffixSelectors = suffixSelectors.filter(function (it) {
			return it.length > 0;
		});
		//tandt selector or empty
		suffixSelectors = suffixSelectors.length > 0 ? '.' + suffixSelectors.join('.') : '';

		//sling on selectors to the suffix url
		return basePath + mobile + '.scstargetoffer.html' + suffixPath + suffixSelectors + selectors + '.html' + query;
	};

	/**
	 * Fetches the resource from provided path and writes the
	 * response to the document or the mbox Element if
	 *
	 * <ul>
	 * <li>response status code is 200</li>
	 * <li>response has a body with length > 0</li>
	 * </ul>
	 *
	 * Uses a synchronous call for requesting the resource. If a WCM mode is defined this
	 * call forces the resource to be rendered with WCM mode disabled.
	 *
	 * @static
	 * @param {String} path Path to document/node to request.
	 * @param {String} mboxName The name of the mbox that issued the request
	 */
	obj.pull = function (path, mboxName) {

		CQ.shared.HTTP.get = function (proxyUrl) {
			CQ.shared.HTTP.get = origGet;
			// pull in the content
			var output = origGet.call(this, SCS.TestTarget.transformProxyUrl(proxyUrl)),
				isOk = (output && output.status && output.status === 200),
				hasBody = (output && output.body && output.body.length > 0);

			if (isOk && !hasBody) {
				//try to get default content
				debug.warn('SCS Target -> pull(): The offer is not found, try to get default content.');
				if (typeof obj.defaults[mboxName] === 'undefined') {
					debug.error('SCS Target -> pull(): The default offer path was not found in the internal map for mbox ' + mboxName);
					return output;
				}
				var defaultContentPath = obj.defaults[mboxName],
					url = document.location.pathname,
					defaultProxyUrl = url + defaultContentPath;
				output = origGet.call(this, SCS.TestTarget.transformProxyUrl(defaultProxyUrl));
			}

			return output;
		};
		var result = origPull.apply(this, arguments);
		return result;
	};

	function onTargetDomLoaded(e) {
		if (!SCS || !SCS.utils || !SCS.utils.initNewModules) {
			return;
		}
		SCS.utils.initNewModules(e.target);
	}

	$('body').on('target-dom-loaded', onTargetDomLoaded);

})(window.CQ_Analytics, window.CQ, window.SCS = window.SCS || {}, __webpack_provided_window_dot_$, window.debug || window.console);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_Tc_dot_$) {/*** IMPORTS FROM imports-loader ***/
var loadTerrific = __webpack_require__(1);
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

var SdxAccordion = __webpack_require__(27).default;

(function (Module, $, SCS) {
	'use strict';

	/**
	 * SDXAccordion.
	 *
	 * @author TAABANI9
	 * @namespace Tc.Module
	 * @class SDXAccordion
	 * @extends Tc.Module
	 */

	Module.SDXAccordion = Module.extend({

		/**
		 * Does all the work.
		 *
		 * @method on
		 * @param {Function} callback function
		 * @return void
		 */
		on: function (callback) {
			new SdxAccordion(this.$ctx[0]);
			this.accordionId = this.$ctx.data('accordionId');
			this.$tabs = this.$ctx.find('.accordion__item');
			if (this.accordionId) {
				var openTabIndex = parseInt(SCS.HashDeepLink.get(this.accordionId), 10);
				if ((openTabIndex === 0 || openTabIndex) && openTabIndex < this.$tabs.length) {
					this.setDefaultOpenStates(this.$tabs, openTabIndex);
				}
				this.$tabs.on('click', this.handleTabClicked.bind(this));
			}
			this.$tabs.on('click', this.handleTracking.bind(this));

			callback();
		},

		/**
		 * Set hash on clicked tab.
		 *
		 * @method handleTabClicked
		 * @param event
		 * @return void
		 */
		handleTabClicked: function (event) {
			var target = $(event.currentTarget);
			var index = this.$tabs.index(target);

			if ($(target).hasClass('is-open')) {
				SCS.HashDeepLink.set(this.accordionId, index);
			} else {
				SCS.HashDeepLink.set(this.accordionId, '');
			}
		},

		/**
		 * Tab class toggle.
		 *
		 * @method setDefaultOpenStates
		 * @param $tabs
		 * @param openTabIndex
		 * @return void
		 */
		setDefaultOpenStates: function ($tabs, openTabIndex) {
			$tabs.each(function (index, tab) {
				var $tab = $(tab);
				$tab.toggleClass('is-open', (index === openTabIndex));
				$tab.find('.accordion__collapse').toggleClass('is-open', (index === openTabIndex));
			});
		},

		handleTracking: function (event) {
			var target = $(event.currentTarget);
			var trackLabel = target.data('track-label'),
				trackCategory = target.data('track-category');

			if ($(target).hasClass('is-open')) {
				//(action, label, location, category, linkName)
				SCS.portal.datalayer.trackEvent('open', trackLabel, SCS.datalayer.getAnalyticsPageName(), trackCategory);
			} else {
				SCS.portal.datalayer.trackEvent('close', trackLabel, SCS.datalayer.getAnalyticsPageName(), trackCategory);
			}
		}

	});
}(window.Tc.Module, __webpack_provided_window_dot_Tc_dot_$, window.SCS = window.SCS || {}));
}.call(window));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_Tc_dot_$) {/*** IMPORTS FROM imports-loader ***/
var loadTerrific = __webpack_require__(1);
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function (Module, $, SCS) {
	'use strict';

	function isTrackingReady() {
		return SCS.tealium && SCS.tealium.isReady() &&
			SCS.datalayer.getAnalyticsPageName &&
			SCS.datalayer.getAnalyticsPageName();
	}

	/**
	 * Yet Another Tab Component.
	 * Supports deeplinking via #<tabId>=<tabNo> or custom hash parameter per tab (useful for integrating Angular apps).
	 *
	 * @author Ces
	 * @namespace Tc.Module
	 * @class SDXTabs
	 * @extends Tc.Module
	 */
	Module.SDXTabs = Module.extend({

		init: function ($ctx) {
			var mod = this;

			mod.sdxTabs = $ctx[0];
			mod.tabId = $ctx.data('tab-id') || 'tab';
			mod.$tabs = $ctx.find('.tab-link');
			mod.itemSelector = 'sdx-tabs-item, sdx-select-option';
			mod.retryTimeout = 5000;

			// caching panels
			mod.$panels = mod.$tabs.map(function() {
				if (this.dataset.panel) {
					return $('.' + this.dataset.panel);
				}
				return $();
			});

			mod.log('init', mod.tabId, mod.$tabs.length);
		},

		on: function (callback) {
			var mod = this;

			mod.log('on', mod.tabId, mod.$tabs.length);
			mod.deepLinking();
			mod.addEvents();

			mod.executeInitialTracking(function () {
				mod.$tabs.each(function (idx, item) {
					var $tab = $(item);
					if ($tab.find(mod.itemSelector).prop('selected') || $tab.hasClass('active')) {
						var trackLabel = $tab.data('track-label'),
							trackCategory = $tab.data('track-category');
						SCS.portal.datalayer.trackEvent('view', trackLabel, SCS.datalayer.getAnalyticsPageName(), trackCategory);
						mod.log('executeInitialTracking', mod.tabId, trackLabel, trackCategory);
						return false;
					}
				});
			});

			callback();
		},

		/**
		 * Preselect a tab based on hash parameters.
		 */
		deepLinking: function () {
			var mod = this,
				hashValue = SCS.HashDeepLink.get(mod.tabId);

			var selectedTabIndex = mod.$tabs.get().findIndex(function(item) { return item.dataset.panel === hashValue; });
			if(selectedTabIndex === -1) {
				// Fallback to old functionality where tab index number is used as hash value
				selectedTabIndex = parseInt(hashValue, 10);
			}
			if (selectedTabIndex >= 0) {
				mod.log('deepLinking - found matching tabId hash', location.hash, mod.tabId, selectedTabIndex);

			} else if (location.hash) {
				mod.$tabs.each(function (index) {
					var hash = $(this).data('hash');
					if (hash === location.hash) {
						selectedTabIndex = index;
						mod.log('deepLinking - found matching custom hash', location.hash, mod.tabId, selectedTabIndex);
						return false;
					}
				});
			}
			mod.$tabs.eq(selectedTabIndex || 0).find(mod.itemSelector).prop('selected', true);
			mod.switchToPanel(selectedTabIndex);

			mod.log('deepLinking', mod.tabId, selectedTabIndex);
			return selectedTabIndex;
		},

		/**
		 * Attach change event on tabs, and handle hashchange event.
		 */
		addEvents: function () {
			var mod = this;

			mod.sdxTabs.changeCallback = mod.handleSdxTabsChange.bind(mod);
			mod.sdxTabs.selectCallback = mod.handleSdxTabsChange.bind(mod);
			window.addEventListener('hashchange', mod.deepLinking.bind(mod));
		},

		/**
		 * Handle tab switch
		 *
		 * @param {HTMLElement | String} tab - the now active sdx-tabs-item | the value (index) of the selected sdx-select-option
		 */
		handleSdxTabsChange: function (tab) {
			var mod = this,
				$tab;

			if (/sdx-tabs-item/i.test(tab.nodeName)) {
				$tab = $(tab).closest('.tab-link');
			} else {
				// sdx-select-option
				$tab = mod.$tabs.eq(tab);
			}

			var activePanel = $tab.data('panel'),
				selectedTabIndex = mod.$tabs.index($tab),
				hash = $tab.data('hash');

			if (hash) {
				location.hash = hash;
			} else {
				SCS.HashDeepLink.set(mod.tabId, activePanel || selectedTabIndex, '&');
			}

			mod.switchToPanel(selectedTabIndex);

			var trackLabel = $tab.data('track-label'),
				trackCategory = $tab.data('track-category');

			SCS.portal.datalayer.trackEvent('view', trackLabel, SCS.datalayer.getAnalyticsPageName(), trackCategory);

			mod.log('handleSdxTabsChange', mod.tabId, selectedTabIndex, activePanel, hash);
		},

		/**
		 * Show the panel of the selected tab, and hide the others.
		 *
		 * @param {number} selectedTabIndex - the tab of which the panel should be shown
		 */
		switchToPanel: function (selectedTabIndex) {
			var mod = this,
				i = selectedTabIndex < mod.$tabs.length ? selectedTabIndex : 0;

			if ($(document.body).hasClass('cq_isEditMode')) {
				return;
			}

			mod.$panels.each(function(index) {
				$(this).toggleClass('hideSDXTab', index !== i);
			});

			$(window).trigger('resize'); // force jQuery Lazy to re-check which images are now visible
		},

		// check if tracking is ready and process queued events
		executeInitialTracking: function (callback) {
			var mod = this;

			clearTimeout(this.timeout); // if undefined silently does nothing

			if (isTrackingReady()) {
				callback();
				return;
			}

			if (mod.retryTimeout > 0) {
				this.timeout = setTimeout(function () {
					mod.retryTimeout -= 80;
					mod.executeInitialTracking(callback);
				}, 80);
			}
		}
	});
}(window.Tc.Module, __webpack_provided_window_dot_Tc_dot_$, window.SCS = window.SCS || {}));

}.call(window));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_Tc_dot_$) {/*** IMPORTS FROM imports-loader ***/
var loadTerrific = __webpack_require__(1);
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function (Module, $, SCS) {
	'use strict';

	/**
	 * SDXTabs Image Skin.
	 * Not based on sdx-tabs Web Component because it doesn't support Images.
	 *
	 * @author Ces, Nikola Bajkic
	 * @namespace Tc.Module
	 * @class Image
	 * @extends Tc.Module
	 */
	Module.SDXTabs.Image = function(parent) {

		this.on = function (callback) {
			var mod = this;
			mod.log('on-Image', mod.tabId, mod.$tabs.length);

			mod.$tabContainer = mod.$ctx.find('.tabitems');
			mod.$tabContainer.on('scroll', function () {
				var offset = mod.getScrolledOffset();
				mod.setOverflowShadows(offset);
			});
			mod.setOverflowShadows();

			parent.on.call(this, callback);
		};

		/**
		 * Preselect a tab based on hash parameters.
		 */
		this.deepLinking = function () {
			var mod = this;

			var selectedTabIndex = parent.deepLinking.call(this);
			mod.setActiveState(selectedTabIndex);
			mod.switchToPanel(selectedTabIndex);
			mod.log('deepLinking-Image', mod.tabId, selectedTabIndex);
		};

		/**
		 * Attach click event on tabs, and handle hashchange event.
		 */
		this.addEvents = function () {
			var mod = this;

			mod.$tabs.on('click', mod.handleTabClicked.bind(mod));
			mod.$tabs.on('click', mod.handleTracking.bind(mod));
			window.addEventListener('hashchange', mod.deepLinking.bind(mod));
		};

		/**
		 * Scroll tab to position.
		 *
		 * @param {number} index - index of current tab
		 */
		this.scrollTab = function (index) {
			var mod = this,
				targetPosition;

			var $tab = mod.$tabs.eq(index).closest('div'),
				tabWidth = $tab.outerWidth(true);
			var leftPosition = $tab[0].offsetLeft,
				leftDistance = leftPosition - mod.getScrolledOffset();
			var rightPosition = leftDistance + tabWidth,
				rightDistance = mod.$tabContainer.width() - rightPosition;

			if (leftDistance < tabWidth || rightDistance < tabWidth) {
				targetPosition = leftPosition - (mod.$tabContainer.width() - tabWidth)/2;
				mod.$tabContainer.animate({ scrollLeft: targetPosition }, 400, 'linear');
			}
			mod.log('scrollTab', leftDistance, rightDistance, targetPosition);
		};

		this.getScrolledOffset = function () {
			var mod = this;

			return mod.$ctx[0].getBoundingClientRect().left - mod.$tabs[0].getBoundingClientRect().left;
		};

		this.setOverflowShadows = function (offset) {
			var mod = this,
				hasOverflow = mod.$tabContainer[0].scrollWidth > mod.$ctx.width();

			if (hasOverflow) {
				if (!offset || offset === 0) {
					mod.$ctx.removeClass('overflowLeft');
					mod.$ctx.addClass('overflowRight');
				} else if (offset > 0 && offset < mod.$tabContainer[0].scrollWidth - mod.$tabContainer.width()) {
					mod.$ctx.addClass('overflowLeft');
					mod.$ctx.addClass('overflowRight');
				} else {
					mod.$ctx.addClass('overflowLeft');
					mod.$ctx.removeClass('overflowRight');
				}
			}
		};

		/**
		 * Update hash parameters and active state.
		 *
		 * @param {Object} event - the click event
		 */
		this.handleTabClicked = function (event) {
			var mod = this,
				$tab = $(event.currentTarget),
				selectedTabIndex = mod.$tabs.index($tab),
				hash = $tab.data('hash');

			if ($tab.is('.disabled')) {
				return;
			}
			if (hash) {
				location.hash = hash;
			} else {
				SCS.HashDeepLink.set(mod.tabId, ($tab.data('panel') || selectedTabIndex), '&');
			}
			mod.setActiveState(selectedTabIndex);
			mod.switchToPanel(selectedTabIndex);
			mod.log('handleTabClicked', mod.tabId, selectedTabIndex, hash);
		};

		/**
		 * Activate a tab.
		 *
		 * @param {number} selectedTabIndex - the tab to select
		 */
		this.setActiveState = function (selectedTabIndex) {
			var mod = this,
				i = selectedTabIndex < mod.$tabs.length ? selectedTabIndex : 0;

			mod.$tabs.removeClass('active').blur().eq(i).addClass('active');
		};

		/**
		 * Show the panel of the selected tab, and hide the others.
		 * Scroll the selected image tab into view.
		 *
		 * @param {number} selectedTabIndex - the tab of which the panel should be shown
		 */
		this.switchToPanel = function (selectedTabIndex) {
			var mod = this;
			parent.switchToPanel.call(mod, selectedTabIndex);

			if (!isNaN(selectedTabIndex) && (selectedTabIndex < 10) && !SCS.utils.isMobilePage()) {
				mod.scrollTab(selectedTabIndex);
			}
		};

		this.handleTracking = function (event) {
			var $target = $(event.currentTarget);
			var trackLabel = $target.data('track-label'),
				trackCategory = $target.data('track-category');

			SCS.portal.datalayer.trackEvent('view', trackLabel, SCS.datalayer.getAnalyticsPageName(), trackCategory);
		};
	};
}(window.Tc.Module, __webpack_provided_window_dot_Tc_dot_$, window.SCS = window.SCS || {}));

}.call(window));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// portal/ui/build/clientlibs/js/jcr_root/etc/designs/portal/clientlibs/aggregated.min.js